var Jv = Object.defineProperty;
var eb = (Xn, zn, Un) => zn in Xn ? Jv(Xn, zn, { enumerable: !0, configurable: !0, writable: !0, value: Un }) : Xn[zn] = Un;
var Ca = (Xn, zn, Un) => eb(Xn, typeof zn != "symbol" ? zn + "" : zn, Un);
var EditorComponentType = /* @__PURE__ */ ((Xn) => (Xn.PICTURE = "COMPONENT_PICTURE", Xn.TABLE = "COMPONENT_TABLE", Xn.TEXT = "COMPONENT_TEXT", Xn.FIGURE = "COMPONENT_FIGURE", Xn.GROUP = "COMPONENT_GROUP", Xn.BOOK = "COMPONENT_BOOK", Xn.MODULE = "COMPONENT_MODULE", Xn.LINE = "COMPONENT_LINE", Xn))(EditorComponentType || {});
const Eh = class Eh extends Error {
  constructor(Un, ...Kn) {
    super(Un);
    Ca(this, "extend", null);
    Ca(this, "getBody", () => {
      if (Eh.context === null)
        throw "Manipulator error not initialize in editor";
      return {
        message: this.name,
        sketchID: Eh.context.getID(),
        stack: this.stack === void 0 ? null : this.stack,
        extend: this.extend !== null ? JSON.stringify(this.extend) : this.extend
      };
    });
    if (Eh.context === null) {
      console.error("failed to send an error to the server because the id sketch was not installed");
      return;
    }
    this.extend = Kn, Eh.errorsBuffer.push(this.getBody());
  }
};
Ca(Eh, "SEND_ERRORS_INTERVAL", 1e4), Ca(Eh, "context", null), Ca(Eh, "reporter", null), Ca(Eh, "errorsBuffer", []), Ca(Eh, "intervalID"), Ca(Eh, "setContext", (Un) => {
  Eh.context = Un, Eh.intervalID = setInterval(Eh.sendError, Eh.SEND_ERRORS_INTERVAL);
}), Ca(Eh, "setReporter", (Un) => {
  Eh.reporter = Un;
}), Ca(Eh, "resetContext", () => {
  Eh.context = null, clearInterval(Eh.intervalID);
}), Ca(Eh, "sendError", () => {
  if (Eh.errorsBuffer.length === 0 || !Eh.reporter)
    return;
  const Un = [...Eh.errorsBuffer];
  Eh.errorsBuffer = [], Eh.reporter(Un);
});
let EditorError = Eh;
class Dependent {
  constructor() {
    Ca(this, "postInjectDependenciesListeners");
    Ca(this, "privateDependencies", null);
    this.postInjectDependenciesListeners = [];
  }
  /**
   * Возвращает внедрённые зависимости.
   *
   * @throws {EditorError} Если зависимости не были внедрены.
   * @protected
   */
  get dependencies() {
    if (this.privateDependencies === null)
      throw new EditorError("Dependencies have not been injected.");
    return this.privateDependencies;
  }
  /**
   * Добавляет слушатель события внедрения зависимостей.
   *
   * @param listener Функция, вызываемая после внедрения зависимостей.
   * @protected
   */
  addPostInjectDependenciesListener(zn) {
    this.postInjectDependenciesListeners.push(zn);
  }
  /**
   * Подключает внешние зависимости.
   *
   * @param dependencies Объект с зависимостями.
   * @returns Текущий экземпляр класса.
   * @throws {EditorError} Если хотя бы одна из переданных зависимостей равна `undefined`.
   */
  connectDependencies(zn) {
    for (const Un in zn)
      if (zn[Un] === void 0)
        throw new EditorError(`Dependency "${Un}" is undefined.`);
    return this.privateDependencies = { ...zn }, this;
  }
  /**
   * Принудительно внедряет зависимости и активирует их.
   *
   * @param dependencies Объект с зависимостями.
   * @returns Текущий экземпляр класса.
   */
  forceInjectDependencies(zn) {
    return this.connectDependencies(zn).injectDependencies();
  }
  /**
   * Активирует внедрённые зависимости, вызывая зарегистрированные слушатели.
   *
   * @returns Текущий экземпляр класса.
   * @throws {EditorError} Если зависимости не были подключены.
   */
  injectDependencies() {
    if (this.privateDependencies === null)
      throw new EditorError("Dependencies have not been connected.");
    for (let zn = 0; zn < this.postInjectDependenciesListeners.length; zn++)
      this.postInjectDependenciesListeners[zn]({ ...this.privateDependencies });
    return this;
  }
}
class ComponentBuilder extends Dependent {
  constructor() {
    super();
    Ca(this, "component");
    // Порядок слоев только той графики, которая находится внутри ComponentBuilder в данный момент.
    Ca(this, "layerSequences");
    Ca(this, "structure");
    /**
     * Очищает память сборщика.
     */
    Ca(this, "clear", () => {
      this.structure = null, this.component = null, this.layerSequences = [];
    });
    /**
     * Сканирует компонент и сохраняет в памяти его структуру. Сохраняет исходный порядок слоев.
     * @param component Сканируемый компонент.
     * @param globalLayerSequences Последовательность слоев.
     */
    Ca(this, "scanComponent", async (Un, Kn) => {
      this.clear(), await this.initializeFromComponent(Un, Kn);
    });
    /**
     * Сканирует структуру и сохраняет её в памяти. Сохраняет исходный порядок слоев.
     * @param structure
     */
    Ca(this, "scanStructure", async (Un) => {
      this.clear(), await this.initializeFromStructure(Un);
    });
    /**
     * Возвращает порядок графики. Не содержит информацию о расположении графики, только лишь о порядке. Графика только
     * та, которая внутри ComponentBuilder в данный момент
     */
    Ca(this, "getLayerSequences", () => {
      if (this.structure === null)
        throw new EditorError("structure not found");
      if (this.component === null)
        throw new EditorError("component not found");
      return this.layerSequences.map((Un) => [...Un]);
    });
    /**
     * Перезаписывает внутренний компонент новым с той же структурой, но уникальными идентификаторами.
     */
    Ca(this, "regenerate", async () => {
      if (this.component === null || this.structure === null)
        throw new EditorError("component or structure not found");
      const Un = this.component.getUniqueStructure(), Kn = this.structure, qn = this.getUpdatedLayerSequences(Kn, this.layerSequences, Un);
      this.structure = Un, await this.build(), this.layerSequences = qn;
    });
    /**
     * Возвращает структуру сгенерированного компонента.
     */
    Ca(this, "getStructure", () => {
      if (this.structure === null)
        throw new EditorError("structure not load");
      if (this.component === null)
        throw new EditorError("component not load");
      return this.component.getStructure();
    });
    /**
     * Возвращает уникальную структуру сгенерированного компонента.
     */
    Ca(this, "getUniqueStructure", () => {
      if (this.structure === null)
        throw new EditorError("structure not load");
      if (this.component === null)
        throw new EditorError("component not load");
      return this.component.getUniqueStructure();
    });
    /**
     * Возвращает собранный компонент.
     */
    Ca(this, "getComponent", () => {
      if (this.component === null)
        throw new EditorError("component not found");
      return this.component;
    });
    /**
     * Возвращает коллекцию всех компонентов, включая корневой.
     */
    Ca(this, "getComponentAll", () => {
      if (this.component === null)
        throw new EditorError("component not found");
      return [this.component, ...this.component.getComponentAll()];
    });
    /**
     * Собирает компонент по сохраненной структуре.
     */
    Ca(this, "build", async () => {
      if (this.structure === null)
        throw new EditorError("structure not load");
      const Un = await this.generateComponent(this.structure);
      if (this.structure.components !== null)
        for (let Kn = 0; Kn < this.structure.components.length; Kn++) {
          const qn = this.structure.components[Kn];
          await this.recursiveGenerateComponent(Un, qn);
        }
      this.component = Un;
    });
    /**
     * Рекурсивно генерирует компонент по структуре.
     * @param parent Родительский компонент.
     * @param structure Структура для генерации компонента.
     */
    Ca(this, "recursiveGenerateComponent", async (Un, Kn) => {
      const qn = await this.generateComponent(Kn);
      if (Un.appendComponent(qn), Kn.components !== null)
        for (let Jo = 0; Jo < Kn.components.length; Jo++) {
          const pa = Kn.components[Jo];
          await this.recursiveGenerateComponent(qn, pa);
        }
    });
    /**
     * Генерирует дерево компонентов.
     * @param structure Структура для генерации компонентов.
     */
    Ca(this, "generateComponent", async (Un) => {
      const Kn = this.dependencies.componentFactory.getClearComponent(Un.type);
      if (Un.graphics === null)
        throw new EditorError("graphics is null");
      for (let qn = 0; qn < Un.graphics.length; qn++) {
        const Jo = Un.graphics[qn], pa = this.dependencies.graphicFactory.getClearGraphic(Jo.type);
        await pa.setStructure(() => Jo), Kn.appendGraphic(pa);
      }
      return await Kn.setStructure(() => Un), Kn;
    });
    /**
     * Инициализирует строителя на основе компонента. Сохраняет в памяти структуру и последовательность слоев
     * нового компонента. Хранит независимую копию компонента.
     * @param component Исходный компонент.
     * @param globalLayerSequences Глобальная последовательность слоев.
     */
    Ca(this, "initializeFromComponent", async (Un, Kn) => {
      const Jo = [Un, ...Un.getComponentAll()].flatMap((va) => va.getGraphics()).map((va) => va.getID());
      if (this.structure = Un.getUniqueStructure(), await this.build(), this.component === null)
        throw new EditorError("component not build");
      const pa = [this.component, ...this.component.getComponentAll()].flatMap((va) => va.getGraphics()).map((va) => va.getID()), ma = [];
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va];
        let _a = !1;
        for (let ya = 0; ya < Kn.length; ya++) {
          const wa = Kn[ya].indexOf(ba);
          wa !== -1 && (_a = !0), ma[ya] === void 0 && (ma[ya] = []), ma[ya][wa] = pa[va];
        }
        if (!_a)
          throw new EditorError("graphic in layer sequences not found");
      }
      return this.cleanupLayerSequence(ma), this.layerSequences = ma, ma;
    });
    /**
     * Устраняет пустоты в последовательностях и первые пустые элементы в коллекции последовательностей.
     * Пример:
     * [
     * 		[],
     * 		[],
     * 		[undefined, "xxxxx", undefined, undefined, "yyyyy", undefined, "zzzzz"],
     * 		[],
     * 		["xxxxx", undefined, "yyyyy", undefined, "zzzzz"],
     * 		[],
     * 		[undefined, "xxxxx", "yyyyy", undefined, "zzzzz", undefined, undefined],
     * ] => [
     * 		["xxxxx", "yyyyy", "zzzzz"],
     * 		[],
     * 		["xxxxx", "yyyyy", "zzzzz"],
     * 		[],
     * 		["xxxxx", "yyyyy", "zzzzz"],
     * ]
     * @param layerSequences Последовательность для обработки.
     */
    Ca(this, "cleanupLayerSequence", (Un) => {
      let Kn = !0;
      return Un.filter((qn) => Kn ? (Kn = !1, qn.length !== 0) : !0).forEach((qn, Jo) => {
        Un[Jo] !== void 0 && (Un[Jo] = Un[Jo].filter((pa) => pa !== void 0));
      });
    });
    /**
     * Инициализирует строителя на основе компонента.
     * Сохраняет в памяти структуру и последовательность слоев нового компонента.
     * @param structure Сканируемая структура.
     */
    Ca(this, "initializeFromStructure", async (Un) => {
      if (this.structure = Un, await this.build(), this.component === null)
        throw new EditorError("component is not build");
      const Kn = [];
      this.recursiveCalculateSequences(Kn, Un, 0), this.cleanupLayerSequence(Kn), this.layerSequences = Kn;
    });
    /**
     * Формирует последовательность слоев графики по структуре корневого компонента.
     * @param accum Аккумулирующая коллекция последовательностей слоев.
     * @param structure Структура корневого компонента.
     * @param sumComponentOffset Суммарный сдвиг компонента на текущую итерацию.
     */
    Ca(this, "recursiveCalculateSequences", (Un, Kn, qn) => {
      var Jo;
      Kn.graphics !== null && Kn.graphics.forEach((pa, ma) => {
        if (Un[qn + ma] === void 0 && (Un[qn + ma] = []), pa.frame === null)
          throw new EditorError("frame configuration is null");
        Un[qn + ma][pa.frame.layer] = pa.id;
      }), (Jo = Kn.components) == null || Jo.forEach((pa) => {
        if (pa.offset === null)
          throw new EditorError("structure offset is null");
        this.recursiveCalculateSequences(Un, pa, qn + pa.offset);
      });
    });
    this.component = null, this.structure = null, this.layerSequences = [];
  }
  /**
   * Возвращает обновленную последовательность слоев из структуры `source` на основании последовательности
   * из `prototype`. Структуры должны быть идентичны.
   * @param prototypeStructure Структура, по которой будет генерироваться новая последовательность.
   * @param prototypeLayers Последовательность слоев, на которой будет основываться новая последовательность.
   * @param sourceStructure Структура, идентификаторы который будут в новой последовательности.
   * @private
   */
  getUpdatedLayerSequences(Un, Kn, qn) {
    const Jo = [], pa = [], ma = [];
    if (this.recursiveAccumulationGraphicID(pa, Un), this.recursiveAccumulationGraphicID(ma, qn), pa.length !== ma.length)
      throw new EditorError("different structures");
    for (let va = 0; va < Kn.length; va++)
      if (Kn[va] !== void 0)
        for (let ba = 0; ba < Kn[va].length; ba++) {
          const _a = pa.indexOf(Kn[va][ba]);
          if (_a === -1)
            throw new EditorError("graphic id not found");
          if (Jo[va] === void 0 && (Jo[va] = []), ma[_a] === void 0)
            throw new EditorError("graphic id not found");
          Jo[va][ba] = ma[_a];
        }
    return Jo;
  }
  recursiveAccumulationGraphicID(Un, Kn) {
    var qn;
    Kn.graphics && Un.push(...Kn.graphics.map((Jo) => Jo.id)), (qn = Kn.components) == null || qn.forEach((Jo) => {
      this.recursiveAccumulationGraphicID(Un, Jo);
    });
  }
}
var GraphicType = /* @__PURE__ */ ((Xn) => (Xn.GROUP = "GRAPHIC_GROUP", Xn.PICTURE = "GRAPHIC_PICTURE", Xn.TABLE = "GRAPHIC_TABLE", Xn.TEXT = "GRAPHIC_TEXT", Xn.FIGURE = "GRAPHIC_FIGURE", Xn.PAGE = "GRAPHIC_PAGE", Xn.MODULE = "GRAPHIC_MODULE", Xn.LINE = "GRAPHIC_LINE", Xn))(GraphicType || {});
class Stack {
  constructor(zn = Number.POSITIVE_INFINITY) {
    Ca(this, "storage", []);
    Ca(this, "push", (zn) => {
      if (this.size() === this.capacity)
        throw Error("Stack has reached max capacity, you cannot add more items");
      this.storage.push(zn);
    });
    Ca(this, "pop", () => this.storage.pop());
    Ca(this, "peek", () => this.storage[this.size() - 1]);
    Ca(this, "size", () => this.storage.length);
    this.capacity = zn;
  }
}
class ComponentTree extends Dependent {
  constructor() {
    super();
    Ca(this, "rootComponent");
    /**
     * Загружает структуру корневого компонента и визуализирует её.
     * @param structure - структура корневого компонента.
     */
    Ca(this, "load", async (Un) => {
      if (this.rootComponent = this.dependencies.componentFactory.createComponent(Un), Un.graphics === null)
        throw new EditorError("root graphic structures not found");
      for (let Kn = 0; Kn < Un.graphics.length; Kn++) {
        const qn = Un.graphics[Kn];
        if (this.rootComponent === null)
          throw new EditorError("root component not found");
        const Jo = this.dependencies.graphicFactory.createGraphic(qn.type, this.rootComponent);
        await Jo.setStructure(() => qn), this.rootComponent.appendGraphic(Jo);
      }
      await this.rootComponent.setStructure(() => Un), Un.components !== null && await this.recursiveInitializeAppendComponent(this.rootComponent, Un.components), this.dependencies.layerRegistry.load(Un);
    });
    /**
     * Метод рекурсивного добавления компонентов в структуру при инициализации конструктора.
     * @param parentComponent - родительский компонент.
     * @param componentStructures - структуры добавляемых компонентов.
     */
    Ca(this, "recursiveInitializeAppendComponent", async (Un, Kn) => {
      const qn = Un.getGraphics();
      for (let Jo = 0; Jo < Kn.length; Jo++) {
        const pa = Kn[Jo], ma = this.dependencies.componentFactory.createComponent(pa);
        if (pa.graphics === null)
          throw new EditorError("component graphic structures not found");
        for (let va = 0; va < pa.graphics.length; va++) {
          const ba = pa.graphics[va], _a = this.dependencies.graphicFactory.createGraphic(ba.type, ma), { offset: ya } = ba;
          if (pa.offset === null)
            throw new EditorError("component offset is null");
          if (qn[ya + pa.offset] === void 0)
            throw new EditorError("parent graphic not found", {
              parentComponentStructure: Un.getStructure(),
              componentStructure: pa
            });
          await _a.setStructure(() => ba), ma.appendGraphic(_a);
        }
        await ma.setStructure(() => pa), Un.appendComponent(ma), pa.components !== null && await this.recursiveInitializeAppendComponent(ma, pa.components);
      }
    });
    Ca(this, "reset", () => {
    });
    Ca(this, "getGraphicSequences", () => {
      if (this.rootComponent === null)
        throw new EditorError("root component not initialized");
      const Un = [];
      this.rootComponent.getGraphics().forEach((Jo) => Un.push([Jo]));
      const qn = this.rootComponent.getComponents();
      return qn === null || qn.forEach((Jo) => {
        const pa = Jo.getOffset();
        if (pa === null)
          throw new EditorError("offset not found");
        this.recursiveFillGraphicSequences(Un, Jo, pa);
      }), Un;
    });
    /**
     * Снимает фокус (следовательно обводку и режим редактирования) со всех компонентов, кроме компонентов,
     * указанных в `targetComponents`.
     * @param targetComponents Компоненты, которые не подлежать сбросу фокуса.
     */
    Ca(this, "disableFocusExcept", (...Un) => {
      this.getComponents().forEach((qn) => {
        Un.includes(qn) || (qn.disableEditMode(), qn.disableFocus(), qn.disableHover());
      });
    });
    /**
     * Возвращает компоненты в фокусе.
     * @return IComponent[] При нахождении подобных.
     * @return null При отсутствии компонентов в фокусе.
     */
    Ca(this, "getFocusComponents", () => {
      const Un = this.getComponents().filter(
        (Kn) => Kn.isEnableFocus() && Kn.type !== EditorComponentType.BOOK
      );
      return Un.length === 0 ? null : Un;
    });
    /**
     * Возвращает коллекцию графики, находящейся в фокусе.
     * @return IGraphic[] - Коллекция графики.
     * @return null - В случае отсутствия графики в фокусе.
     */
    Ca(this, "getFocusGraphics", () => {
      const Un = this.getFocusComponents();
      return Un === null ? null : Un.flatMap((Kn) => Kn.getGraphics());
    });
    /**
     * Включает фокус только у одного элемента, в то же время отключая его у других.
     * @param component - Компонент, у которого необходимо включить фокус.
     */
    Ca(this, "enableFocusOnly", (Un) => {
      Un.enableFocus(), this.disableFocusExcept(Un);
    });
    /**
     * Возвращает все компоненты типа `UniformType`, в случае отсутствия таковых - null.
     * `UniformType` и `componentType` должны соответствовать друг другу.
     * @param componentType - тип компонентов для поиска.
     */
    Ca(this, "getUniformComponents", (Un) => {
      const qn = this.getComponents().filter((Jo) => Jo.type === Un);
      return qn.length === 0 ? null : qn;
    });
    /**
     * Возвращает все компоненты в фокусе типа `UniformType`, в случае отсутствия таковых - null.
     * `UniformType` и `componentType` должны соответствовать друг другу.
     * @param componentType - тип компонентов для поиска.
     */
    Ca(this, "getUniformFocusComponents", (Un) => {
      const Kn = this.getFocusComponents();
      if (Kn === null)
        return null;
      const qn = Kn.filter((Jo) => Jo.type === Un);
      return qn.length === 0 ? null : qn;
    });
    /**
     * Возвращает все существующие компоненты-объединители из дерева компонентов.
     */
    Ca(this, "getUniterComponents", () => {
      const Kn = this.getComponents().filter((qn) => qn.isUniter);
      return Kn.length === 0 ? null : Kn;
    });
    /**
     * Возвращает все компоненты в режиме редактирования, кроме корневого компонента.
     */
    Ca(this, "getEditableComponents", () => {
      const Un = this.getComponentsWithoutRoot();
      if (Un === null)
        return null;
      const Kn = Un.filter((qn) => qn.isEnableEditMode());
      return Kn.length === 0 ? null : Kn;
    });
    /**
     * Возвращает все компоненты в режиме редактирования типа `UniformType`, в случае отсутствия таковых - null.
     * `UniformType` и `componentType` должны соответствовать друг другу.
     * @param componentType Тип компонентов для поиска.
     */
    Ca(this, "getEditableUniformComponents", (Un) => {
      const Kn = this.getEditableComponents();
      if (Kn === null)
        return null;
      const qn = Kn.filter((Jo) => Jo.type === Un);
      return qn.length === 0 ? null : qn;
    });
    /**
     * Находится ли хотя бы один компонент в режиме фокуса или редактирования.
     * */
    Ca(this, "hasEditableOrFocusComponent", () => this.getComponents().filter((Kn) => Kn.type === EditorComponentType.BOOK ? Kn.isEnableEditMode() : Kn.isEnableEditMode() || Kn.isEnableFocus()).length !== 0);
    /** Содержит ли дерево хотя бы один компонент в режиме редактирования. */
    Ca(this, "hasEditableComponent", () => {
      if (this.rootComponent === null)
        throw new EditorError("root component is null");
      return this.rootComponent.hasEditableComponent();
    });
    /**
     * Возвращает структуру всех компонентов текущего скетча.
     */
    Ca(this, "getStructure", () => {
      if (this.rootComponent === null)
        throw new EditorError("root component is null");
      return this.rootComponent.getStructure();
    });
    /**
     * Возвращает абсолютно все компоненты дерева.
     */
    Ca(this, "getComponents", () => {
      if (this.rootComponent === null)
        throw new EditorError("root component is null");
      return [this.rootComponent, ...this.rootComponent.getComponentAll()];
    });
    Ca(this, "getRootComponent", () => {
      if (this.rootComponent === null)
        throw new EditorError("root component is null");
      return this.rootComponent;
    });
    Ca(this, "getRootGraphics", () => {
      if (this.rootComponent === null)
        throw new EditorError("root component is null");
      return this.rootComponent.getGraphics();
    });
    /**
     * Возвращает все компоненты кроме корневого.
     */
    Ca(this, "getComponentsWithoutRoot", () => {
      if (this.rootComponent === null)
        throw new EditorError("root component is null");
      const Un = this.rootComponent.getComponentAll();
      return Un.length === 0 ? null : Un;
    });
    /**
     * Отключает фокус у всех компонентов.
     */
    Ca(this, "disableComponentFocus", () => {
      this.getComponents().forEach((Kn) => Kn.disableFocus());
    });
    /**
     * Отключает режим редактирования у всех компонентов.
     */
    Ca(this, "disableComponentsEditMode", () => {
      this.getComponents().forEach((Kn) => Kn.disableEditMode());
    });
    /**
     * Возвращает всю графику на всей глубине, которую в себе содержит переданная графика.
     * @param targetGraphic Графика, в которой будет запущен поиск.
     */
    Ca(this, "getInternalGraphics", (Un) => {
      const Kn = Un.getParentComponent();
      if (Kn === null)
        throw new EditorError("target component not found");
      const qn = Kn.getComponentAll(), Jo = /* @__PURE__ */ new Set([...qn.flatMap((ba) => ba.getGraphics())]), pa = [];
      let ma = [Un];
      const va = [];
      for (; Jo.forEach((ba) => {
        const _a = ba.getParentGraphic();
        _a !== null && ma.includes(_a) && (va.push(ba), pa.push(ba));
      }), va.length !== 0; )
        ma = [...va], va.length = 0;
      return pa.length === 0 ? null : pa;
    });
    /**
     * Возвращает позицию графики относительно коллекции графики компонента,
     * дочерним компонентов которого является родительский компонент текущей графики.
     */
    Ca(this, "getIndexByParentGraphic", (Un) => {
      const Kn = Un.getParentGraphic();
      if (Kn === null)
        throw new EditorError("parent graphic not found");
      const qn = Kn.getParentComponent();
      if (qn === null)
        throw new EditorError("parent component not found");
      const pa = qn.getGraphics().indexOf(Kn);
      if (pa === -1)
        throw new EditorError("parent graphic index not found");
      return pa;
    });
    /**
     * Синхронизирует размеры контейнерных компонентов начиная от компонента,
     * отправленного в метод, вверх по дереву компонентов в сторону корня.
     */
    Ca(this, "syncUniterComponentsSizeFromComponent", (Un) => {
      this.recursiveSyncContainerComponent(Un);
    });
    /**
     * Синхронизирует размеры всех компонентов объединителей.
     */
    Ca(this, "syncUniterComponentsSize", () => {
      const Un = this.getUniterComponents();
      if (Un !== null)
        for (let Kn = 0; Kn < Un.length; Kn++)
          Un[Kn].syncSizeFrames();
    });
    /**
     * Рекурсивно запускает синхронизацию размеров у компонента и его родителя.
     * @param component Синхронизируемый компонент.
     */
    Ca(this, "recursiveSyncContainerComponent", (Un) => {
      this.syncSizeContainerComponent(Un);
      const Kn = Un.getParentComponent();
      Kn !== null && this.recursiveSyncContainerComponent(Kn);
    });
    /**
     * Запускает синхронизацию размеров только компонентов, которые объединяют другие компоненты.
     * @param component
     */
    Ca(this, "syncSizeContainerComponent", (Un) => {
      Un.isUniter && Un.syncSizeFrames();
    });
    /**
     * Возвращает верную последовательность id графики для каждой страницы
     * на основе структур компонентов в дереве.
     * @returns Массив с массивами верной последовательности id графики страницы.
     */
    Ca(this, "getIdPageGraphics", () => {
      const Un = [], Kn = this.getStructure(), { components: qn, graphics: Jo } = Kn;
      if (Jo === null)
        throw new EditorError("structure not found");
      if (qn === null)
        throw new EditorError("components not found");
      return Jo.forEach((pa) => {
        const ma = pa.offset;
        Un[ma] = [pa.id];
      }), Jo.forEach((pa) => {
        qn.forEach((ma) => {
          ma.offset === pa.offset && this.recursiveFillIdGraphic(Un, ma, ma.offset);
        });
      }), Un;
    });
    /**
     * Рекурсивная функция для заполнения массивов id графики.
     * @param idPageGraphics Массив массивов id графики страницы.
     * @param component Компонент структуры.
     * @param offset Отступ компонента.
     * @returns Массив массивов id графики страницы.
     */
    Ca(this, "recursiveFillIdGraphic", (Un, Kn, qn) => {
      if (Kn === null)
        throw new EditorError("component not found");
      const Jo = Kn.graphics;
      if (Jo === null)
        throw new EditorError("graphic of component not found");
      Jo.forEach((ma) => {
        Un[qn + ma.offset].push(ma.id);
      });
      const { components: pa } = Kn;
      if (pa === null)
        throw new EditorError("component of components not found");
      return pa.length > 0 && pa.forEach((ma) => {
        this.recursiveFillIdGraphic(Un, ma, qn);
      }), Un;
    });
    Ca(this, "recursiveFillGraphicSequences", (Un, Kn, qn) => {
      Kn.getGraphics().forEach((ma) => {
        const va = ma.getOffset();
        Un[qn + va].push(ma);
      });
      const pa = Kn.getComponents();
      pa !== null && pa.forEach((ma) => {
        const va = ma.getOffset();
        if (va === null)
          throw new EditorError("child offset not found");
        this.recursiveFillGraphicSequences(Un, ma, qn + va);
      });
    });
    this.rootComponent = null;
  }
}
class DynamicComponentTree extends ComponentTree {
  constructor() {
    super();
    Ca(this, "componentBuilder");
    /**
     * Выполняет набор мутаций и запускает побочные эффекты.
     *
     * Example:
     * mutations() {
     *     .mutateByAppendComponent(a1, a2);
     *     .mutateByAppendComponent(a2, a3);
     *     // actions
     *     .mutateByAppendComponent(a1, a4);
     * }
     * @param mutations - функция, содержащая последовательность мутаций.
     */
    Ca(this, "executeMutations", async (Un) => {
      await Un({
        mutator: this,
        componentBuilder: this.componentBuilder,
        layerRegistry: this.dependencies.layerRegistry,
        graphicFactory: this.dependencies.graphicFactory,
        componentFactory: this.dependencies.componentFactory
      }), this.dependencies.render.render();
    });
    /**
     * Добавляет компонент в другой компонент.
     * @param parentComponent - родительский компонент.
     * @param component - вкладываемый компонент.
     */
    Ca(this, "mutateByAppendComponent", (Un, Kn) => {
      const qn = Kn.getGraphics(), Jo = Kn.getStructure(), pa = Un.getGraphics();
      qn.forEach((ma) => {
        if (Jo.offset === null)
          throw new EditorError("component offset is null");
        const va = ma.getOffset(), ba = pa[Jo.offset + va];
        if (ba === void 0)
          throw new EditorError("parent graphic not found");
        this.dependencies.layerRegistry.appendGraphicAfterForChild(ba, ma);
      }), Kn.type === EditorComponentType.TABLE && (Kn.mutateSyncRealRowHeight(), Kn.applyMutations(), Kn.syncGraphicsHeight()), Un.appendComponent(Kn);
    });
    /**
     * Добавляет графику в компонент. Используется только при изменении уже внедренного компонента
     * в общее дерево.
     * @param component - компонент, с графикой который мы работаем.
     * @param graphic - добавляемая графика.
     */
    Ca(this, "mutateByAppendGraphic", (Un, Kn) => {
      if (Un.getOffset() === null)
        throw new EditorError("the component is not connected to component tree");
      if (Un.appendGraphic(Kn), Un.type === EditorComponentType.BOOK)
        return this.dependencies.layerRegistry.appendRootGraphic(Kn), Un.syncPagePanels(), Kn;
      const Jo = Kn.getParentGraphic();
      if (Jo === null) {
        const pa = Kn.getOffset();
        return this.dependencies.layerRegistry.appendGraphic(Kn, pa), Kn;
      }
      return this.dependencies.layerRegistry.appendGraphicAfterForChild(Jo, Kn), Kn;
    });
    /**
     * Добавляет графику в компонент после определенной графики. Используется только при изменении
     * уже внедренного компонента в общее дерево.
     * @param component Компонент, с графикой который мы работаем.
     * @param targetGraphic Графика, после которой будет вставлена передаваемая графика.
     * @param graphic Добавляемая графика.
     */
    Ca(this, "mutateByAppendGraphicAfter", (Un, Kn, qn) => (Un.appendGraphicAfter(Kn, qn), this.dependencies.layerRegistry.appendGraphicNextForHorizontal(Kn, qn), qn));
    /**
     * Добавляет графику в компонент перед определенной графикой.
     * Используется только при изменении уже внедренного компонента в общее дерево.
     * @param component Компонент, с графикой который мы работаем.
     * @param targetGraphic Графика, перед которой будет вставлена передаваемая графика.
     * @param graphic Добавляемая графика.
     */
    Ca(this, "mutateByAppendGraphicBefore", async (Un, Kn, qn) => {
      const Jo = Un.getOffset();
      if (Jo === null)
        throw new EditorError("component offset is null");
      const pa = Un.getGraphics();
      for (let va = 0; va < pa.length; va++) {
        const ba = pa[va].getOffset();
        pa[va].setOffset(ba + 1);
      }
      Un.appendGraphicBefore(Kn, qn), this.dependencies.layerRegistry.appendGraphicBefore(Kn, qn), await this.mutateByChangeOffset(Un, Jo - 1);
      const ma = Un.getComponents();
      if (ma !== null)
        for (let va = 0; va < ma.length; va++) {
          const ba = ma[va], _a = ba.getOffset();
          if (_a === null)
            throw new EditorError("current offset is null");
          await this.mutateByChangeOffset(ba, _a + 1);
        }
      return qn;
    });
    /**
     * Удаляет компонент.
     * @param component - удаляемый компонент.
     */
    Ca(this, "mutateByRemoveComponent", (Un) => {
      Un.getGraphics().forEach((Jo) => {
        const pa = this.dependencies.layerRegistry.getTree();
        Jo.removeFrame();
        const ma = pa.getLayerFromData(Jo);
        if (ma === null)
          throw new EditorError("graphic in tree not found");
        pa.removeLayers(ma);
      });
      const qn = Un.getParentComponent();
      if (qn === null)
        throw new EditorError("parent component not found");
      qn.removeComponent(Un);
    });
    /**
     * Обнаруживает графику компонентов-объединителей, которые не содержать дочернюю графику, и удаляет их.
     */
    Ca(this, "mutateByRemoveEmptyUniterGraphics", async () => {
      const Un = this.getUniterComponents();
      if (Un !== null)
        for (let Kn = 0; Kn < Un.length; Kn++) {
          const Jo = Un[Kn].getGraphics(), pa = [], ma = new Stack();
          let va = !0;
          Jo.forEach((_a) => {
            if (this.getInternalGraphics(_a) !== null) {
              if (va && (va = !1), ma.size() !== 0 && !va)
                throw new EditorError("the group has an empty graphic in the middle of the component");
              return;
            }
            va ? pa.push(_a) : ma.push(_a);
          });
          for (let _a = 0; _a < pa.length; _a++) {
            const ya = pa[_a];
            await this.mutateByRemoveGraphicWithCorrectOffsets(ya);
          }
          let ba = ma.pop();
          for (; ba; )
            await this.mutateByRemoveGraphicWithCorrectOffsets(ba), ba = ma.pop();
        }
    });
    /**
     * Удаляет графику, учитывая изменение последовательности слоев и офсета затронутых компонентов.
     * @param graphic Удаляемая графика.
     */
    Ca(this, "mutateByRemoveGraphicWithCorrectOffsets", async (Un) => {
      const Kn = Un.getParentComponent();
      if (Kn == null)
        throw new EditorError("parent component not found");
      const qn = Kn.getGraphics(), Jo = qn.indexOf(Un);
      if (Jo === void 0)
        throw new EditorError("graphic not found");
      const pa = qn.slice(Jo + 1), ma = [];
      pa.forEach((ba) => {
        const _a = this.getInternalGraphics(ba);
        _a !== null && ma.push(..._a);
      });
      const va = /* @__PURE__ */ new Set();
      if (ma.forEach((ba) => {
        const _a = ba.getParentComponent();
        if (_a === null)
          throw new EditorError("component is null");
        va.add(_a);
      }), this.mutateByRemoveGraphic(Un), Jo === 0) {
        const ba = [...va].sort((ya, xa) => {
          const wa = Math.min(...ya.getGraphics().map((Sa) => Sa.getFrameConfiguration().layer)), Ta = Math.min(...xa.getGraphics().map((Sa) => Sa.getFrameConfiguration().layer));
          return wa - Ta;
        });
        for (let ya = 0; ya < ba.length; ya++) {
          const xa = ba[ya], wa = xa.getOffset();
          if (wa == null || wa === 0)
            throw new EditorError("invalid current offset");
          await this.mutateByChangeOffset(xa, wa - 1);
        }
        const _a = Kn.getOffset();
        if (_a == null)
          throw new EditorError("parent component offset not found");
        await this.mutateByChangeOffset(Kn, _a + 1);
      }
    });
    /**
     * Удаляет графику компонента.
     * @param graphic Удаляемая графика.
     */
    Ca(this, "mutateByRemoveGraphic", (Un) => {
      const Kn = Un.getParentComponent();
      if (Kn === null)
        throw new EditorError("parent component not found");
      Kn.removeGraphic(Un), this.dependencies.layerRegistry.removeGraphic(Un);
    });
    /**
     * Устанавливает новый сдвиг компонента относительно родительского и перерисовывает компонент.
     * @param component обновляемый компонент.
     * @param updatedOffset новый сдвиг.
     */
    Ca(this, "mutateByChangeOffset", async (Un, Kn) => {
      if (Kn < 0)
        throw new EditorError("invalid offset");
      if (Un.getStructure().offset === Kn)
        return;
      const Jo = Un.getParentComponent();
      if (Jo === null)
        throw new EditorError("parent component is null");
      const pa = Un.getGraphics(), ma = Jo.getGraphics();
      if (ma.length < Kn + pa.length)
        throw new EditorError("insufficient parent graphics");
      let va = Kn, ba = ma[va];
      pa.forEach((_a) => {
        this.dependencies.layerRegistry.moveGraphicAfterForChild(ba, _a), va++, ba = ma[va];
      }), await Un.setStructure((_a) => ({
        ..._a,
        offset: Kn
      }));
    });
    /**
     * Добавляет компонент с вложенными компонентами в структуру. Возвращает созданный компонент.
     * @param parentComponent - родительский компонент.
     * @param componentStructure - структура добавляемого компонента.
     */
    Ca(this, "mutateByAppendMultiComponent", async (Un, Kn) => await this.recursiveAppendComponent(Un, Kn));
    Ca(this, "moveBackComponents", (...Un) => {
      Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          this.dependencies.layerRegistry.moveBackGraphic(qn);
        });
      });
    });
    Ca(this, "moveForwardComponents", (...Un) => {
      Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          this.dependencies.layerRegistry.moveForwardGraphic(qn);
        });
      });
    });
    Ca(this, "moveComponentToBackground", (...Un) => {
      Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          this.dependencies.layerRegistry.moveGraphicToBackground(qn);
        });
      });
    });
    Ca(this, "moveComponentToForeground", (...Un) => {
      Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          this.dependencies.layerRegistry.moveGraphicToForeground(qn);
        });
      });
    });
    Ca(this, "moveBackGraphics", (...Un) => {
      Un.forEach((Kn) => this.dependencies.layerRegistry.moveBackGraphic(Kn));
    });
    Ca(this, "moveForwardGraphics", (...Un) => {
      Un.forEach((Kn) => this.dependencies.layerRegistry.moveForwardGraphic(Kn));
    });
    Ca(this, "moveGraphicToBackground", (...Un) => {
      Un.forEach((Kn) => this.dependencies.layerRegistry.moveGraphicToBackground(Kn));
    });
    Ca(this, "moveGraphicToForeground", (...Un) => {
      Un.forEach((Kn) => this.dependencies.layerRegistry.moveGraphicToForeground(Kn));
    });
    Ca(this, "mutateByRemoveFocusComponents", async () => {
      const Un = this.getFocusComponents();
      if (Un === null)
        return;
      const Kn = /* @__PURE__ */ new Set();
      Un.forEach((qn) => {
        let Jo = qn.getParentComponent(), pa = qn;
        if (Jo !== null)
          for (; Jo !== null; )
            Un.includes(Jo) && (pa = Jo), Jo = Jo.getParentComponent();
        Kn.add(pa);
      }), await this.executeMutations(async (qn) => {
        Kn.forEach((Jo) => {
          qn.mutator.mutateByRemoveComponent(Jo);
        });
      });
    });
    /**
     * Расширяет компонент, добавляя в начало одну дополнительную графику и изменяя офсет на -1.
     * Добавляет +1 к офсету дочерних компонентов.
     * @exception EditorError В случае отсутствия родительской графики для смещения компонента на офсет -1.
     * @param component Расширяемый компонент.
     */
    Ca(this, "mutateByExtendComponentToStart", async (Un) => {
      let Kn = null;
      const qn = Un.getFirstGraphic();
      if (qn === null)
        throw new EditorError("first graphic is null of extended component");
      const Jo = qn.getUniqueTexture();
      return Kn = this.dependencies.graphicFactory.createGraphic(qn.type, Un), await Kn.setTexture(() => Jo), await this.mutateByAppendGraphicBefore(Un, qn, Kn), Kn;
    });
    Ca(this, "mutateByExtendComponentToEnd", async (Un) => {
      let Kn = null;
      const qn = Un.getLastGraphic();
      if (qn === null)
        throw new EditorError("last graphic is null of extended component");
      const Jo = qn.getUniqueTexture();
      return Kn = this.dependencies.graphicFactory.createGraphic(qn.type, Un), await Kn.setTexture(() => Jo), this.mutateByAppendGraphic(Un, Kn), Kn;
    });
    Ca(this, "setLayerSequences", (Un) => {
      const qn = this.getComponents().flatMap((Jo) => Jo.getGraphics());
      this.dependencies.layerRegistry.setSequences(qn, Un);
    });
    Ca(this, "getLayerSequences", () => this.dependencies.layerRegistry.getSequences());
    Ca(this, "getLastLayerFromRootGraphicNumber", (Un) => {
      const Kn = this.dependencies.layerRegistry.getLastLayerFromRootGraphic(Un);
      if (Kn === null)
        throw new EditorError("root graphic layer not found");
      const qn = Kn.getData();
      if (qn === null)
        throw new EditorError("graphic not found");
      return qn;
    });
    Ca(this, "getLayerFromRootGraphicNumber", (Un) => {
      const Kn = this.dependencies.layerRegistry.getLayerFromRootGraphic(Un);
      if (Kn === null)
        throw new EditorError("root graphic layer not found");
      const qn = Kn.getData();
      if (qn === null)
        throw new EditorError("graphic not found");
      return qn;
    });
    Ca(this, "mutateByChangeLayer", (Un, Kn) => {
      if (Un.isUniter || Un.type === GraphicType.PAGE) {
        this.dependencies.layerRegistry.moveGraphicAfterForChild(Un, Kn);
        return;
      }
      this.dependencies.layerRegistry.moveGraphicAfterForHorizontal(Un, Kn);
    });
    Ca(this, "getPrevLayerGraphic", (Un) => this.dependencies.layerRegistry.getPrevGraphic(Un));
    Ca(this, "syncUniterLayerSequence", () => {
      const Un = this.getUniterComponents();
      Un && Un.forEach((Kn) => {
        const { layerSequence: qn } = Kn.getTexture();
        if (!qn) return;
        const Jo = Kn.getComponents();
        if (Jo === null)
          throw new EditorError("components of uniter component is null");
        const pa = Jo.flatMap((ma) => ma.getGraphics());
        this.arraysIsEqual(qn, this.getUniterLayerSequence(pa)) || this.updateGraphicsLayers(Kn, qn);
      });
    });
    /**
     * Обновляет слои графических элементов, основываясь на заданной последовательности слоев.
     */
    Ca(this, "updateGraphicsLayers", (Un, Kn) => {
      const qn = Un.getGraphics(), Jo = Kn.map((va) => qn.find((ba) => ba.getID() === va)).filter(Boolean);
      if (Jo.length === 0) return;
      const [pa, ...ma] = Jo;
      this.applyLayerChanges(ma, pa);
    });
    Ca(this, "recursiveAppendComponent", async (Un, Kn) => {
      const qn = this.dependencies.componentFactory.createComponent(Kn);
      if (Kn.graphics)
        for (let Jo = 0; Jo < Kn.graphics.length; Jo++) {
          const pa = Kn.graphics[Jo], ma = this.dependencies.graphicFactory.createGraphic(pa.type, qn);
          await ma.setStructure(() => pa), qn.appendGraphic(ma);
        }
      if (await qn.setStructure(() => Kn), this.mutateByAppendComponent(Un, qn), Kn.components !== null)
        for (let Jo = 0; Jo < Kn.components.length; Jo++) {
          const pa = Kn.components[Jo];
          await this.recursiveAppendComponent(qn, pa);
        }
      return qn;
    });
    /**
     * Возвращает результат проверки, являются ли два массива строк полностью одинаковыми.
     * @param arr1 Первый массив строк для сравнения
     * @param arr2 Второй массив строк для сравнения
     */
    Ca(this, "arraysIsEqual", (Un, Kn) => Un.length !== Kn.length ? !1 : Un.every((qn, Jo) => qn === Kn[Jo]));
    /**
     * Возвращает массив строк с идентификаторами графики модуля в верной последовательности
     * для каждого слоя на каждой странице.
     * Учитывает только графику, переданную в `graphics`, и игнорирует отсутствующие в ней элементы.
     * @param graphics Графика компонентов.
     */
    Ca(this, "getUniterLayerSequence", (Un) => {
      const Kn = this.getLayerSequences(), qn = Un.map((pa) => pa.getID()), Jo = [];
      for (let pa = 0; pa < Kn.length; pa++) {
        let ma = 0;
        for (let va = 0; va < Kn[pa].length; va++) {
          const ba = qn.indexOf(Kn[pa][va]);
          ba !== -1 && (Jo[pa] === void 0 && (Jo[pa] = []), Jo[pa][ma] = Un[ba], ma++);
        }
      }
      for (let pa = 0; pa < Jo.length; pa++)
        Jo[pa] !== void 0 && (Jo[pa] = Jo[pa].filter((ma) => ma !== void 0));
      return Jo.flatMap((pa) => pa.map((ma) => ma.getID()));
    });
    this.componentBuilder = new ComponentBuilder(), this.addPostInjectDependenciesListener((Un) => {
      this.componentBuilder.connectDependencies({
        graphicFactory: Un.graphicFactory,
        componentFactory: Un.componentFactory
      });
    });
  }
  /**
   * Применяет изменения слоев для массива графических элементов, добавляя каждый следующий
   * элемент после предыдущего.
   */
  applyLayerChanges(Un, Kn) {
    let qn = Kn;
    Un.forEach((Jo) => {
      this.dependencies.layerRegistry.removeGraphic(Jo), this.dependencies.layerRegistry.appendGraphicNextForHorizontal(qn, Jo), qn = Jo;
    });
  }
}
class LayerItem {
  constructor(zn, Un) {
    Ca(this, "DEFAULT_NAME_LAYER", "Layer");
    Ca(this, "parentLayer");
    Ca(this, "relativePosition");
    Ca(this, "absolutePosition");
    Ca(this, "childrenLayers");
    Ca(this, "layerName");
    Ca(this, "data");
    /**
     * @inheritDoc
     */
    Ca(this, "clear", () => {
      this.childrenLayers = null;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "addLayers", (...zn) => {
      if (zn.includes(this))
        throw new Error("Can not add layer to itself");
      if (this.childrenLayers === null)
        this.childrenLayers = [];
      else if (zn.some((Kn) => {
        var qn;
        return (qn = this.childrenLayers) == null ? void 0 : qn.includes(Kn);
      }))
        throw new Error("Layers already exists");
      for (let Un = 0; Un < zn.length; Un++)
        zn[Un].setParent(this);
      return this.childrenLayers.push(...zn), this.syncRelativePosition(), zn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "addLayersPosition", (zn, ...Un) => {
      const Kn = this;
      if (Un.includes(Kn))
        throw new Error("Can not add layer to itself");
      if (this.childrenLayers === null)
        this.childrenLayers = [];
      else if (Un.some((Jo) => {
        var pa;
        return (pa = this.childrenLayers) == null ? void 0 : pa.includes(Jo);
      }))
        throw new Error("Layers already exists");
      if (zn > this.childrenLayers.length || zn < 0)
        throw new Error("Incorrect position");
      for (let qn = 0; qn < Un.length; qn++)
        Un[qn].setParent(this);
      return this.childrenLayers.splice(zn, 0, ...Un), this.syncRelativePosition(), Un;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "removeLayers", (...zn) => {
      if (this.childrenLayers === null || this.childrenLayers.length <= 0)
        throw new Error("Children layers is null");
      if (zn.some((Un) => {
        var Kn;
        return this.childrenLayers && !((Kn = this.childrenLayers) != null && Kn.includes(Un));
      }))
        throw new Error("Layer not found");
      return zn.forEach((Un) => {
        if (this.childrenLayers === null)
          throw new Error("Children layers is null");
        this.childrenLayers.splice(this.childrenLayers.indexOf(Un), 1);
      }), zn.forEach((Un) => Un.setParent(null)), this.syncRelativePosition(), zn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getLayers", () => this.childrenLayers === null ? null : [...this.childrenLayers].sort((Un, Kn) => Un.getRelativePosition() - Kn.getRelativePosition()));
    /**
     * @inheritDoc
     */
    Ca(this, "getAllLayers", () => this.childrenLayers === null ? null : this.collectLayers(this.childrenLayers).sort((Un, Kn) => Un.getAbsolutePosition() - Kn.getAbsolutePosition()));
    /**
     * @inheritDoc
     */
    Ca(this, "getParent", () => this.parentLayer);
    /**
     * @inheritDoc
     */
    Ca(this, "setParent", (zn) => {
      this.parentLayer = zn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getAbsolutePosition", () => this.absolutePosition);
    /**
     * @inheritDoc
     */
    Ca(this, "setAbsolutePosition", (zn) => {
      this.absolutePosition = zn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getRelativePosition", () => this.relativePosition);
    /**
     * @inheritDoc
     */
    Ca(this, "setRelativePosition", (zn) => {
      this.relativePosition = zn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getName", () => this.layerName);
    /**
     * @inheritDoc
     */
    Ca(this, "setName", (zn) => {
      if (!zn)
        throw new Error("Layer name is null");
      this.layerName = zn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getData", () => this.data);
    /**
     * @inheritDoc
     */
    Ca(this, "setData", (zn) => {
      this.data = zn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getLayerCount", () => this.childrenLayers === null ? 0 : this.childrenLayers.length);
    /**
     * Проверяет, является ли текущий слой последним среди дочерних слоёв родителя.
     */
    Ca(this, "isLastChild", () => {
      if (this.parentLayer === null)
        throw new EditorError("parent layer in null");
      return this.relativePosition === this.parentLayer.getLayerCount() - 1;
    });
    /**
     * Обновляет относительные позиции слоев.
     */
    Ca(this, "syncRelativePosition", () => {
      if (this.childrenLayers !== null)
        for (let zn = 0; zn < this.childrenLayers.length; zn++)
          this.childrenLayers[zn].setRelativePosition(zn);
    });
    Ca(this, "collectLayers", (zn) => {
      let Un = [...zn];
      for (let Kn = 0; Kn < zn.length; Kn++) {
        const qn = zn[Kn].getLayers();
        qn !== null && (Un = Un.concat(this.collectLayers(qn)));
      }
      return Un;
    });
    this.parentLayer = null, this.relativePosition = 0, this.absolutePosition = 0, this.childrenLayers = null, this.layerName = Un === void 0 ? this.DEFAULT_NAME_LAYER : Un, this.data = zn === void 0 ? null : zn;
  }
}
class LayerTree extends Dependent {
  constructor() {
    super();
    Ca(this, "rootLayer");
    /**
     * @inheritDoc
     */
    Ca(this, "clear", () => {
      this.rootLayer !== null && this.rootLayer.clear(), this.rootLayer = null;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getLayers", () => {
      if (this.rootLayer === null)
        return null;
      const Un = this.getAbsolutePositionLayers();
      return Un === null ? [this.rootLayer] : [this.rootLayer, ...Un];
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getLayerFromData", (Un) => {
      const Kn = this.getLayers();
      if (Kn === null)
        return null;
      const qn = Kn.find((Jo) => Jo.getData() === Un);
      return qn === void 0 ? null : qn;
    });
    Ca(this, "getLayerFromAbsolutePosition", (Un) => {
      const Kn = this.getAbsolutePositionLayers();
      if (Kn === null)
        throw new Error("layers not found");
      const qn = Kn[Un];
      if (Kn === void 0)
        throw new Error("layer not found");
      return qn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "setRootLayer", (Un) => {
      if (this.rootLayer !== null)
        throw new Error("Root layer already exists");
      return this.rootLayer = Un, Un;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getRootLayer", () => this.rootLayer);
    /**
     * @inheritDoc
     */
    Ca(this, "addLayers", (Un, ...Kn) => {
      const qn = this.getLayers();
      if (qn === null)
        throw new Error("Tree is empty");
      if (!Kn.every((pa) => !qn.includes(pa)))
        throw new Error("Layers is exist");
      if (!qn.includes(Un))
        throw new Error("Parent not found");
      return Un.addLayers(...Kn), this.syncLayersAbsolutePositions(), Kn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "addLayersPosition", (Un, Kn, ...qn) => {
      const Jo = this.getLayers();
      if (Jo === null)
        throw new Error("Tree is empty");
      if (!qn.every((ma) => !Jo.includes(ma)))
        throw new Error("Layers is exist");
      if (!Jo.includes(Un))
        throw new Error("Parent not found");
      return Un.addLayersPosition(Kn, ...qn), this.syncLayersAbsolutePositions(), qn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "removeLayers", (...Un) => {
      const Kn = this.getLayers();
      if (Kn === null)
        throw new Error("Tree is empty");
      if (Un.forEach((Jo) => {
        if (!Kn.includes(Jo))
          throw new Error("Layer not found");
      }), !Un)
        throw new Error("Layers not found");
      const qn = /* @__PURE__ */ new Map();
      for (let Jo = 0; Jo < Un.length; Jo++) {
        const pa = Un[Jo].getParent();
        if (pa === null)
          throw new Error("Layer not found");
        const ma = qn.get(pa);
        ma === void 0 ? qn.set(pa, [Un[Jo]]) : ma.push(Un[Jo]);
      }
      return qn.forEach((Jo, pa) => {
        pa.removeLayers(...Jo);
      }), this.syncLayersAbsolutePositions(), Un;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "moveLayers", (Un, ...Kn) => {
      const qn = this.getLayers();
      if (qn === null)
        throw new Error("Tree is empty");
      Kn.forEach((pa) => {
        if (!qn.includes(pa))
          throw new Error("Layer not found");
        if (!qn.includes(Un))
          throw new Error("New parent not found");
      });
      const Jo = /* @__PURE__ */ new Map();
      for (let pa = 0; pa < Kn.length; pa++) {
        const ma = Kn[pa].getParent();
        if (ma === null)
          throw new Error("Layer not found");
        const va = Jo.get(ma);
        va === void 0 ? Jo.set(ma, [Kn[pa]]) : va.push(Kn[pa]);
      }
      return Jo.forEach((pa, ma) => {
        ma.removeLayers(...pa), Un.addLayers(...pa);
      }), this.syncLayersAbsolutePositions(), Kn;
    });
    /**
     * @inheritDoc
     */
    Ca(this, "getAbsolutePositionLayers", () => {
      if (this.rootLayer === null)
        throw new Error("Tree is empty");
      const Un = [this.rootLayer], Kn = [];
      for (; Un.length > 0; ) {
        const qn = Un.pop();
        if (qn) {
          Kn.push(qn);
          const Jo = qn.getLayers();
          if (Jo)
            for (let pa = Jo.length - 1; pa >= 0; pa--)
              Un.push(Jo[pa]);
        }
      }
      return Kn;
    });
    /**
     * Обновляет абсолютные позиции слоев в дереве.
     */
    Ca(this, "syncLayersAbsolutePositions", () => {
      if (this.rootLayer === null)
        throw new Error("Tree is empty");
      let Un = 0;
      const Kn = [this.rootLayer];
      for (; Kn.length > 0; ) {
        const qn = Kn.pop();
        if (qn) {
          qn.setAbsolutePosition(Un), Un++;
          const Jo = qn.getLayers();
          if (Jo)
            for (let pa = Jo.length - 1; pa >= 0; pa--)
              Kn.push(Jo[pa]);
        }
      }
    });
    this.rootLayer = null;
  }
}
class BaseLayerRegistry extends Dependent {
  constructor() {
    super();
    Ca(this, "tree");
    Ca(this, "rootNode");
    /**
     * Рекурсивно обходит слои дерева и обновляет порядковые номера.
     *
     * @param layer - Текущий слой, который обрабатывается.
     * @param layerNumber - Текущий порядковый номер слоя.
     * @returns Следующий порядковый номер слоя после обработки текущего элемента.
     *
     * @throws {EditorError} Если для слоя отсутствует графический объект.
     *
     * Метод обновляет конфигурацию графики, добавляя к нему текущий номер слоя.
     * Затем выполняется рекурсивный вызов для всех дочерних слоёв, если они существуют.
     */
    Ca(this, "recursiveSync", (Un, Kn) => {
      const qn = Un.getData();
      if (qn === null)
        throw new EditorError("graphic not found");
      qn.setFrameConfiguration((ma) => ({
        ...ma,
        layer: Kn
      }));
      const Jo = Un.getLayers();
      if (Jo === null)
        return Kn + 1;
      let pa = Kn + 1;
      for (let ma = 0; ma < Jo.length; ma++)
        pa = this.recursiveSync(Jo[ma], pa);
      return pa;
    });
    Ca(this, "getSequences", () => {
      const Un = [], Kn = this.tree.getRootLayer();
      if (Kn === null)
        throw new EditorError("root layer not found");
      const qn = Kn.getLayers();
      if (qn === null)
        throw new EditorError("root layers not found");
      for (let Jo = 0; Jo < qn.length; Jo++) {
        Un[Jo] = [];
        const pa = qn[Jo].getData();
        if (pa === null)
          throw new EditorError("graphic not found");
        Un[Jo].push(pa.getID());
        const ma = qn[Jo].getAllLayers();
        if (ma !== null) {
          const va = ma.map((ba) => {
            const _a = ba.getData();
            if (_a === null)
              throw new EditorError("graphic not found");
            return _a.getID();
          });
          Un[Jo].push(...va);
        }
      }
      return Un;
    });
    Ca(this, "getSortedGraphics", () => {
      const Un = this.tree.getAbsolutePositionLayers(), Kn = [];
      return Un === null || Un.length === 1 ? null : (Un.splice(1).forEach((qn) => {
        const Jo = qn.getData();
        if (Jo === null)
          throw new EditorError("layer data is null");
        Kn.push(Jo);
      }), Kn);
    });
    Ca(this, "moveBackGraphic", (Un) => {
      const Kn = this.tree.getLayerFromData(Un);
      if (Kn === null)
        throw new EditorError("graphic not in tree");
      const qn = Kn.getRelativePosition();
      if (qn === 0)
        return;
      const Jo = Kn.getParent();
      if (Jo === null)
        throw new EditorError("parent not found");
      this.tree.removeLayers(Kn), this.tree.addLayersPosition(Jo, qn - 1, Kn), this.sync();
    });
    Ca(this, "moveForwardGraphic", (Un) => {
      const Kn = this.tree.getLayerFromData(Un);
      if (Kn === null)
        throw new EditorError("graphic not in tree");
      const qn = Kn.getRelativePosition();
      if (qn < 0 || Kn.isLastChild())
        return;
      const Jo = Kn.getParent();
      if (Jo === null)
        throw new EditorError("parent not found");
      this.tree.removeLayers(Kn), this.tree.addLayersPosition(Jo, qn + 1, Kn), this.sync();
    });
    /**
     * @param targetGraphic Графика, перед которой будет вставлена передаваемая графика.
     * @param graphic Добавляемая графика.
     */
    Ca(this, "appendGraphicBefore", (Un, Kn) => {
      const qn = this.tree.getLayerFromData(Un);
      if (qn === null)
        throw new EditorError("before graphic node not found");
      if (this.tree.getLayerFromData(Kn) !== null)
        throw new EditorError("graphic node exist in tree");
      const pa = qn.getParent();
      if (pa === null)
        throw new EditorError("parent node not found");
      const ma = qn.getRelativePosition(), va = new LayerItem(Kn, Kn.getShortID());
      this.tree.addLayersPosition(pa, ma, va), this.sync();
    });
    Ca(this, "appendGraphicNextForHorizontal", (Un, Kn) => {
      const qn = this.tree.getLayerFromData(Un);
      if (qn === null)
        throw new EditorError("prev graphic node not found");
      if (this.tree.getLayerFromData(Kn) !== null)
        throw new EditorError("graphic node exist in tree");
      const pa = qn.getParent();
      if (pa === null)
        throw new EditorError("parent node not found");
      const ma = qn.getRelativePosition(), va = new LayerItem(Kn, Kn.getShortID());
      this.tree.addLayersPosition(pa, ma + 1, va), this.sync();
    });
    Ca(this, "appendGraphicAfterForChild", (Un, Kn) => {
      const qn = this.tree.getLayerFromData(Un);
      if (qn === null)
        throw new EditorError("after graphic node not found");
      if (this.tree.getLayerFromData(Kn) !== null)
        throw new EditorError("graphic node exist in tree");
      const pa = new LayerItem(Kn, Kn.getShortID());
      this.tree.addLayers(qn, pa), this.sync();
    });
    Ca(this, "moveGraphicToBackground", (Un) => {
      const Kn = this.tree.getLayerFromData(Un);
      if (Kn === null)
        throw new EditorError("graphic node not found");
      const qn = Kn.getParent();
      if (qn === null)
        throw new EditorError("parent node not found");
      qn.removeLayers(Kn), this.tree.addLayersPosition(qn, 0, Kn), this.sync();
    });
    Ca(this, "moveGraphicToForeground", (Un) => {
      const Kn = this.tree.getLayerFromData(Un);
      if (Kn === null)
        throw new EditorError("graphic node not found");
      const qn = Kn.getParent();
      if (qn === null)
        throw new EditorError("parent node not found");
      qn.removeLayers(Kn), qn.addLayers(Kn), this.sync();
    });
    Ca(this, "removeGraphic", (Un) => {
      const Kn = this.tree.getLayerFromData(Un);
      if (Kn === null)
        throw new EditorError("graphic not in tree");
      return this.tree.removeLayers(Kn), Kn;
    });
    Ca(this, "moveGraphicAfterForHorizontal", (Un, Kn) => {
      const qn = this.tree.getLayerFromData(Kn);
      if (qn === null)
        throw new EditorError("graphic node not found");
      const Jo = this.tree.getLayerFromData(Un);
      if (Jo === null)
        throw new EditorError("prev graphic node not found");
      const pa = Jo.getParent();
      if (pa === null)
        throw new EditorError("parent node not found");
      this.tree.moveLayers(pa, qn), this.sync();
    });
    Ca(this, "moveGraphicAfterForChild", (Un, Kn) => {
      const qn = this.tree.getLayerFromData(Kn);
      if (qn === null)
        throw new EditorError("graphic node not found");
      const Jo = this.tree.getLayerFromData(Un);
      if (Jo === null)
        throw new EditorError("prev graphic node not found");
      this.tree.moveLayers(Jo, qn), this.sync();
    });
    Ca(this, "getLastLayerFromRootGraphic", (Un) => {
      const Kn = this.tree.getRootLayer();
      if (Kn === null)
        throw new EditorError("root layer not found");
      const qn = Kn.getLayers();
      if (qn === null)
        throw new EditorError("root children not found");
      const Jo = qn[Un];
      if (Jo === void 0)
        throw new EditorError("target child not found");
      const pa = Jo.getAllLayers(), ma = !pa || pa.length === 0 ? Jo : pa[pa.length - 1];
      if (ma === void 0)
        throw new EditorError("last layer not found");
      return ma;
    });
    Ca(this, "getLayerFromRootGraphic", (Un) => {
      const Kn = this.tree.getRootLayer();
      if (Kn === null)
        throw new EditorError("root layer not found");
      const qn = Kn.getLayers();
      if (qn === null)
        throw new EditorError("root children not found");
      const Jo = qn[Un];
      if (Jo === void 0)
        throw new EditorError("target child not found");
      return Jo;
    });
    Ca(this, "getTree", () => this.tree);
    this.rootNode = new LayerItem(), this.tree = new LayerTree();
  }
}
class BookLayerRegistry extends BaseLayerRegistry {
  constructor() {
    super();
    Ca(this, "load", (Un) => {
      const qn = this.dependencies.componentTree.getComponents().flatMap((va) => va.getGraphics()), Jo = /* @__PURE__ */ new Map(), pa = /* @__PURE__ */ new Map();
      qn.forEach((va) => {
        Jo.set(va.getID(), va), pa.set(va, va.getParentGraphic());
      });
      const ma = this.getFlatStructure(Un, Jo);
      if (!ma || ma.length === 0)
        throw new EditorError("Flat structure is empty or invalid");
      this.buildTree(ma, pa), this.sync();
    });
    /**
     * Запускает синхронизацию дерева слоёв.
     *
     * Метод получает корневой слой и выполняет рекурсивный обход всех дочерних слоёв,
     * обновляя их порядковые номера. Если корневого слоя или его дочерних слоёв нет,
     * метод завершает выполнение.
     *
     * Процесс начинается с вызова `recursiveSync` для каждого дочернего слоя корневого элемента,
     * то есть для каждой страницы.
     */
    Ca(this, "sync", () => {
      const Un = this.rootNode.getLayers();
      Un !== null && Un.forEach((Kn) => {
        this.recursiveSync(Kn, 0);
      });
    });
    Ca(this, "getPrevGraphic", (Un) => {
      const Kn = this.tree.getLayerFromData(Un);
      if (Kn === null)
        throw new EditorError("graphic not connected to tree");
      const qn = Kn.getAbsolutePosition(), Jo = this.getRootGraphicLayerNode(Kn);
      if (Jo === null)
        throw new EditorError("root graphic node not found");
      const pa = Jo.getAbsolutePosition();
      if (qn === pa)
        return null;
      const ma = this.tree.getLayerFromAbsolutePosition(qn - 1);
      if (ma === null)
        throw new EditorError("node not found");
      const va = ma.getData();
      if (Un === null)
        throw new EditorError("graphic not found");
      return va;
    });
    Ca(this, "setSequences", (Un, Kn) => {
      const qn = this.convertToFlatStructure(Un, Kn), Jo = this.tree.getRootLayer();
      if (Jo === null)
        throw new EditorError("root node not found");
      Jo.clear();
      const pa = /* @__PURE__ */ new Map();
      Un.forEach((ma) => {
        pa.set(ma, ma.getParentGraphic());
      }), this.buildTree(qn, pa);
    });
    Ca(this, "appendGraphic", (Un, Kn) => {
      const qn = this.getRootGraphicLayerFromNumber(Kn);
      if (this.tree.getLayerFromData(Un) !== null)
        throw new EditorError("the graphics are already in the tree");
      const pa = new LayerItem(Un, Un.getShortID());
      return this.tree.addLayers(qn, pa), this.sync(), pa;
    });
    Ca(this, "appendRootGraphic", (Un) => {
      const Kn = new LayerItem(Un, Un.getShortID()), qn = this.tree.getRootLayer();
      if (qn === null)
        throw new EditorError("root layer is null");
      const Jo = qn.getLayers();
      if (Jo === null)
        throw new EditorError("root layers of root layer is null");
      const pa = Jo[Jo.length - 1];
      return this.tree.addLayersPosition(qn, pa.getRelativePosition() + 1, Kn), this.sync(), Kn;
    });
    Ca(this, "getRootGraphicLayerNode", (Un) => {
      let Kn = Un;
      for (; Kn !== null; ) {
        const qn = Kn.getParent();
        if (qn === this.rootNode)
          return Kn;
        Kn = qn;
      }
      throw new EditorError("current node not found");
    });
    Ca(this, "getRootGraphicLayerFromNumber", (Un) => {
      const Kn = this.tree.getRootLayer();
      if (Kn === null)
        throw new EditorError("root layer not found");
      const qn = Kn.getLayers();
      if (qn === null)
        throw new EditorError("root children not found");
      const Jo = qn[Un];
      if (Jo === void 0)
        throw new EditorError("target child not found");
      return Jo;
    });
    Ca(this, "getFlatStructure", (Un, Kn) => {
      const qn = [];
      if (Un.graphics === null)
        throw new EditorError("root graphics not found");
      return this.recursiveFillFlatStructure(Un, 0, Kn, qn), qn.forEach((Jo) => {
        Jo.sort((pa, ma) => {
          const va = pa.getFrameConfiguration(), ba = ma.getFrameConfiguration();
          if (va === null || ba === null)
            throw new EditorError("frame configuration is missing in graphic structure");
          return va.layer - ba.layer;
        });
      }), qn;
    });
    Ca(this, "recursiveFillFlatStructure", (Un, Kn, qn, Jo) => {
      if (Un.graphics === null)
        throw new EditorError("graphic not found");
      for (let pa = 0; pa < Un.graphics.length; pa++) {
        const ma = qn.get(Un.graphics[pa].id);
        if (ma === void 0)
          throw new EditorError("graphic not found");
        Jo[Kn + pa] === void 0 && (Jo[Kn + pa] = []), Jo[Kn + pa].push(ma);
      }
      if (Un.components !== null)
        for (let pa = 0; pa < Un.components.length; pa++) {
          if (Un.components[pa].offset === null)
            throw new EditorError("component offset not found");
          this.recursiveFillFlatStructure(
            Un.components[pa],
            // biome-ignore lint/style/noNonNullAssertion: <explanation>
            Kn + Un.components[pa].offset,
            qn,
            Jo
          );
        }
    });
    Ca(this, "convertToFlatStructure", (Un, Kn) => Kn.map(
      (qn) => qn.map((Jo) => {
        const pa = Un.find((ma) => ma.getID() === Jo);
        if (pa === void 0)
          throw new EditorError("graphic not found");
        return pa;
      })
    ));
    /**
     * Строит дерево слоев на основе отсортированной структуры графики.
     *
     * Использует отображение `graphicToParent` для корректного связывания узлов.
     * - Если у графического элемента есть родитель, он привязывается к нему.
     * - Если родителя нет, он привязывается к `rootNode`.
     *
     * @param flatStructure Двумерный массив графических элементов, представляющий последовательности.
     * @param graphicToParent Словарь, связывающий каждый графический элемент с его родителем.
     *                        Графика без родителя привязывается к `rootNode`.
     * @throws {EditorError} Если отсутствует необходимая информация о графике или её родителе.
     */
    Ca(this, "buildTree", (Un, Kn) => {
      const qn = /* @__PURE__ */ new Map();
      Un.forEach((Jo) => {
        Jo.length !== 0 && Jo.forEach((pa) => {
          const ma = pa.getStructure().frame;
          if (!ma)
            throw new EditorError("Frame not found");
          const va = ma.layer;
          if (va < 0)
            throw new EditorError(`Invalid layer ${va} for graphic ${pa.getID()}`);
          const ba = new LayerItem(pa, pa.getShortID());
          qn.set(pa, ba);
          const _a = Kn.get(pa), ya = _a ? qn.get(_a) : this.rootNode;
          if (!ya)
            throw new EditorError(`Parent node not found for graphic ${pa.getID()}`);
          ya.addLayers(ba);
        });
      });
    });
    this.rootNode.setName("root"), this.tree.setRootLayer(this.rootNode);
  }
}
var BookMode = /* @__PURE__ */ ((Xn) => (Xn.VERTICAL = "VERTICAL", Xn.THUMBNAILS_VIEW = "THUMBNAILS_VIEW", Xn.VERTICAL_SHIFTED_RIGHT = "VERTICAL_SHIFTED_RIGHT", Xn))(BookMode || {});
class BookModeOrganizer extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "TOP_PADDING", 176);
    Ca(this, "INTER_PAGE_DISTANCE", 70);
    Ca(this, "sync", () => {
      const { width: Un } = this.dependencies.canvas, Kn = this.dependencies.book.getBookMode();
      switch (Kn) {
        case BookMode.VERTICAL:
          this.syncVerticalMode(Un);
          break;
        case BookMode.THUMBNAILS_VIEW:
          break;
        case BookMode.VERTICAL_SHIFTED_RIGHT:
          break;
        default:
          throw new EditorError(`book mode ${Kn} not found`);
      }
      this.dependencies.render.render();
    });
    Ca(this, "syncVerticalMode", (Un) => {
      const Kn = Un / 2, qn = this.dependencies.book.getGraphics();
      let Jo = 0, pa = this.TOP_PADDING;
      qn.forEach((ma) => {
        const { width: va, height: ba } = ma.getFrameConfiguration();
        Jo = Kn - va / 2, ma.setFrameConfiguration((_a) => ({
          ..._a,
          x: Jo,
          y: pa
        })), pa += ba + this.INTER_PAGE_DISTANCE;
      });
    });
  }
}
class DoublyLinkedListNode {
  constructor(zn, Un, Kn) {
    Ca(this, "next");
    Ca(this, "previous");
    Ca(this, "value");
    this.value = zn, Un ? this.next = Un : this.next = null, Kn ? this.previous = Kn : this.previous = null;
  }
  toString(zn) {
    return zn ? zn(this.value) : `${this.value}`;
  }
}
class DoublyLinkedList {
  constructor() {
    Ca(this, "head", null);
    Ca(this, "tail", null);
    Ca(this, "postDeleteListener");
    Ca(this, "postAppendListener");
    Ca(this, "getHead", () => this.head);
    // Добавляем узел в начало списка.
    Ca(this, "prepend", (zn) => {
      const Un = new DoublyLinkedListNode(zn, this.head);
      return this.head && (this.head.previous = Un), this.head = Un, this.tail || (this.tail = Un), Un;
    });
    Ca(this, "fromArray", (zn) => (zn.forEach((Un) => this.append(Un)), this));
    Ca(this, "reverse", () => {
      let zn = this.head, Un = null, Kn = null;
      for (; zn; )
        Kn = zn.next, Un = zn.previous, zn.next = Un, zn.previous = Kn, Un = zn, zn = Kn;
      return this.tail = this.head, this.head = Un, this;
    });
    Ca(this, "clear", () => {
      this.head = null, this.tail = null;
    });
    Ca(this, "addPostDeleteListener", (zn) => {
      this.postDeleteListener.push(zn);
    });
    Ca(this, "addPostAppendListener", (zn) => {
      this.postAppendListener.push(zn);
    });
    this.postDeleteListener = [], this.postAppendListener = [];
  }
  // Добавляем узел в конец списка.
  append(zn) {
    const Un = new DoublyLinkedListNode(zn);
    return this.tail && (this.tail.next = Un), Un.previous = this.tail, this.tail = Un, this.head || (this.head = Un), this.postAppendListener.forEach((Kn) => Kn(Un)), Un;
  }
  // Добавить node после элемента
  after(zn, Un) {
    const Kn = this.find(Un);
    if (!Kn) return this;
    if (Kn === this.tail)
      return this.append(zn), this;
    const qn = new DoublyLinkedListNode(zn), Jo = Kn.next;
    return Jo ? (Kn.next = qn, qn.previous = Kn, qn.next = Jo, Jo.previous = qn, this.postAppendListener.forEach((pa) => pa(qn)), this) : this;
  }
  // Добавить node после targetNode
  afterNode(zn, Un) {
    if (Un === this.tail)
      return this.append(zn), this;
    const Kn = new DoublyLinkedListNode(zn), qn = Un.next;
    if (!qn) return this;
    const Jo = Un;
    return Jo.next = Kn, Kn.previous = Un, Kn.next = qn, qn.previous = Kn, this.postAppendListener.forEach((pa) => pa(Kn)), this;
  }
  // Добавить node до элемента
  before(zn, Un) {
    const Kn = this.find(Un);
    if (!Kn) return this;
    if (Kn === this.head)
      return this.prepend(zn), this;
    const qn = new DoublyLinkedListNode(zn), Jo = Kn.previous;
    return Jo ? (Jo.next = qn, qn.previous = Jo, qn.next = Kn, Kn.previous = qn, this.postAppendListener.forEach((pa) => pa(qn)), this) : this;
  }
  // Добавить node до targetNode
  beforeNode(zn, Un) {
    if (Un === this.head)
      return this.prepend(zn), this;
    const Kn = new DoublyLinkedListNode(zn), qn = Un.previous;
    if (!qn) return this;
    const Jo = Un;
    return Jo.previous = Kn, Kn.next = Un, Kn.previous = qn, qn.next = Kn, this.postAppendListener.forEach((pa) => pa(Kn)), this;
  }
  // Заполнить список
  fill(zn, Un) {
    for (let Kn = 0; Kn < Un; Kn++)
      this.append(zn);
    return this;
  }
  delete(zn) {
    if (!this.head)
      return null;
    let Un = null, Kn = this.head;
    for (; Kn; ) {
      if (Kn.value === zn)
        if (Un = Kn, Un === this.head)
          this.head = Un.next, this.head && (this.head.previous = null), Un === this.tail && (this.tail = null);
        else if (Un === this.tail)
          this.tail = Un.previous, this.tail.next = null;
        else {
          const qn = Un.previous, Jo = Un.next;
          qn.next = Jo, Jo.previous = qn;
        }
      Kn = Kn.next;
    }
    return Un !== null && this.postDeleteListener.forEach((qn) => qn(Un)), Un;
  }
  // Удаление элемента по его индексу
  deleteByIndex(zn) {
    const Un = this.length();
    if (zn < 0 || zn > Un - 1)
      return console.error("DoublyLinkedList(deleteByIndex): index out of range"), this;
    if (zn === 0)
      return this.deleteHead(), this;
    if (zn === Un - 1)
      return this.deleteTail(), this;
    const qn = this.toArray()[zn], Jo = qn.previous, { next: pa } = qn;
    return Jo && pa ? (Jo.next = pa, pa.previous = Jo) : console.error("DoublyLinkedList(deleteByIndex): unknown error"), this.postDeleteListener.forEach((ma) => ma(qn)), this;
  }
  find(zn) {
    if (!this.head)
      return null;
    let Un = this.head;
    for (; Un; ) {
      if (zn !== void 0 && Un.value === zn)
        return Un;
      Un = Un.next;
    }
    return null;
  }
  deleteTail() {
    if (!this.tail)
      return null;
    const zn = this.tail;
    return this.tail.previous ? (this.tail = this.tail.previous, this.tail.next = null) : (this.head = null, this.tail = null), this.postDeleteListener.forEach((Un) => Un(zn)), zn;
  }
  deleteHead() {
    if (!this.head)
      return null;
    const zn = this.head;
    return this.head.next ? (this.head = this.head.next, this.head.previous = null) : (this.head = null, this.tail = null), this.postDeleteListener.forEach((Un) => Un(zn)), zn;
  }
  getElements() {
    const zn = [];
    let Un = this.head;
    for (; Un; )
      zn.push(Un.value), Un = Un.next;
    return zn;
  }
  toArray() {
    const zn = [];
    let Un = this.head;
    for (; Un; )
      zn.push(Un), Un = Un.next;
    return zn;
  }
  toString(zn) {
    return this.toArray().map((Un) => Un.toString(zn)).toString();
  }
  moveBack(zn) {
    const Un = this.find(zn);
    if (!Un) return;
    const Kn = Un.previous;
    Kn && (Un.value = Kn.value, Kn.value = zn);
  }
  moveForward(zn) {
    const Un = this.find(zn);
    if (!Un) return;
    const Kn = Un.next;
    Kn && (Un.value = Kn.value, Kn.value = zn);
  }
  moveHead(zn) {
    this.delete(zn), this.prepend(zn);
  }
  moveTail(zn) {
    this.delete(zn), this.append(zn);
  }
  length() {
    return this.getElements().length;
  }
  getIndex(zn) {
    return this.getElements().indexOf(zn);
  }
}
class GraphicList extends DoublyLinkedList {
  constructor() {
    super();
    /**
     * Возвращает результат проверки на содержание графики в коллекции.
     * @param graphic проверяемая графика.
     */
    Ca(this, "isOwnGraphic", (Un) => this.getIndex(Un) !== -1);
    Ca(this, "syncGraphicsOffset", () => {
      this.getElements().forEach((Kn, qn) => {
        Kn.setOffset(qn);
      });
    });
    this.addPostDeleteListener((Un) => {
      Un.value.removeFrame(), this.syncGraphicsOffset();
    }), this.addPostAppendListener(() => {
      this.syncGraphicsOffset();
    });
  }
}
const uu = class uu {
  constructor() {
    Ca(this, "userImagePrefix", "/api/file/user/");
    Ca(this, "systemImagePrefix", "/api/file/system/");
    /**
     * Возвращает URI для получения изображения с сервера.
     * @param source Идентификатор изображения.
     */
    Ca(this, "getUserImageURI", (zn) => `${this.userImagePrefix}${zn}`);
    Ca(this, "getSystemImageURI", (zn) => `${this.systemImagePrefix}${zn}`);
    /**
     * Возвращает URL для подключения к серверу по сокету.
     */
    Ca(this, "getSocketConnectionString", () => {
      const zn = process.env.REACT_APP_ENVIRONMENT_SERVER;
      if (zn === void 0)
        throw Error("react environment not initialized");
      let Un = "", Kn = "";
      switch (zn) {
        case uu.ENVIRONMENT_DEV: {
          Un = "ws", Kn = "localhost:25504";
          break;
        }
        case uu.ENVIRONMENT_TESTING: {
          Un = "wss", Kn = window.location.hostname;
          break;
        }
        case uu.ENVIRONMENT_RELEASE: {
          Un = "wss", Kn = window.location.hostname;
          break;
        }
        default:
          throw new Error("invalid react environment");
      }
      return `${Un}://${Kn}/api/ws`;
    });
  }
};
Ca(uu, "ENVIRONMENT_DEV", "dev"), Ca(uu, "ENVIRONMENT_TESTING", "testing"), Ca(uu, "ENVIRONMENT_RELEASE", "release"), Ca(uu, "getDomainString", () => {
  const zn = process.env.REACT_APP_ENVIRONMENT_SERVER;
  if (zn === void 0)
    throw Error("react environment not initialized");
  let Un = "";
  switch (zn) {
    case uu.ENVIRONMENT_DEV: {
      Un = "http://localhost:25504";
      break;
    }
    case uu.ENVIRONMENT_TESTING: {
      Un = `https://${window.location.hostname}`;
      break;
    }
    case uu.ENVIRONMENT_RELEASE: {
      Un = `https://${window.location.hostname}`;
      break;
    }
    default:
      throw new Error("invalid react environment");
  }
  return Un;
});
let Backend = uu;
var ColorexColor = /* @__PURE__ */ ((Xn) => (Xn.Black = "#000000", Xn.White = "#ffffff", Xn.Transparent = "transparent", Xn.Red50 = "#ffebee", Xn.Red100 = "#ffcdd2", Xn.Red200 = "#ef9a9a", Xn.Red300 = "#e57373", Xn.Red400 = "#ef5350", Xn.Red500 = "#f44336", Xn.Red600 = "#e53935", Xn.Red700 = "#d32f2f", Xn.Red800 = "#c62828", Xn.Red900 = "#b71c1c", Xn.RedA100 = "#ff8a80", Xn.RedA200 = "#ff5252", Xn.RedA400 = "#ff1744", Xn.RedA700 = "#d50000", Xn.Pink50 = "#FCE4EC", Xn.Pink100 = "#F8BBD0", Xn.Pink200 = "#F48FB1", Xn.Pink300 = "#F06292", Xn.Pink400 = "#EC407A", Xn.Pink500 = "#E91E63", Xn.Pink600 = "#D81B60", Xn.Pink700 = "#C2185B", Xn.Pink800 = "#AD1457", Xn.Pink900 = "#880E4F", Xn.PinkA100 = "#FF80AB", Xn.PinkA200 = "#FF4081", Xn.PinkA400 = "#F50057", Xn.PinkA700 = "#C51162", Xn.Purple50 = "#F3E5F5", Xn.Purple100 = "#E1BEE7", Xn.Purple200 = "#CE93D8", Xn.Purple300 = "#BA68C8", Xn.Purple400 = "#AB47BC", Xn.Purple500 = "#9C27B0", Xn.Purple600 = "#8E24AA", Xn.Purple700 = "#7B1FA2", Xn.Purple800 = "#6A1B9A", Xn.Purple900 = "#4A148C", Xn.PurpleA100 = "#EA80FC", Xn.PurpleA200 = "#E040FB", Xn.PurpleA400 = "#D500F9", Xn.PurpleA700 = "#AA00FF", Xn.DeepPurple50 = "#EDE7F6", Xn.DeepPurple100 = "#D1C4E9", Xn.DeepPurple200 = "#B39DDB", Xn.DeepPurple300 = "#9575CD", Xn.DeepPurple400 = "#7E57C2", Xn.DeepPurple500 = "#673AB7", Xn.DeepPurple600 = "#5E35B1", Xn.DeepPurple700 = "#512DA8", Xn.DeepPurple800 = "#4527A0", Xn.DeepPurple900 = "#311B92", Xn.DeepPurpleA100 = "#B388FF", Xn.DeepPurpleA200 = "#7C4DFF", Xn.DeepPurpleA400 = "#651FFF", Xn.DeepPurpleA700 = "#6200EA", Xn.Indigo50 = "#E8EAF6", Xn.Indigo100 = "#C5CAE9", Xn.Indigo200 = "#9FA8DA", Xn.Indigo300 = "#7986CB", Xn.Indigo400 = "#5C6BC0", Xn.Indigo500 = "#3F51B5", Xn.Indigo600 = "#3949AB", Xn.Indigo700 = "#303F9F", Xn.Indigo800 = "#283593", Xn.Indigo900 = "#1A237E", Xn.IndigoA100 = "#8C9EFF", Xn.IndigoA200 = "#536DFE", Xn.IndigoA400 = "#3D5AFE", Xn.IndigoA700 = "#304FFE", Xn.Blue50 = "#E3F2FD", Xn.Blue100 = "#BBDEFB", Xn.Blue200 = "#90CAF9", Xn.Blue300 = "#64B5F6", Xn.Blue400 = "#42A5F5", Xn.Blue500 = "#2196F3", Xn.Blue600 = "#1E88E5", Xn.Blue700 = "#1976D2", Xn.Blue800 = "#1565C0", Xn.Blue900 = "#0D47A1", Xn.BlueA100 = "#82B1FF", Xn.BlueA200 = "#448AFF", Xn.BlueA400 = "#2979FF", Xn.BlueA700 = "#2962FF", Xn.LightBlue50 = "#E1F5FE", Xn.LightBlue100 = "#B3E5FC", Xn.LightBlue200 = "#81D4FA", Xn.LightBlue300 = "#4FC3F7", Xn.LightBlue400 = "#29B6F6", Xn.LightBlue500 = "#03A9F4", Xn.LightBlue600 = "#039BE5", Xn.LightBlue700 = "#0288D1", Xn.LightBlue800 = "#0277BD", Xn.LightBlue900 = "#01579B", Xn.LightBlueA100 = "#80D8FF", Xn.LightBlueA200 = "#40C4FF", Xn.LightBlueA400 = "#00B0FF", Xn.LightBlueA700 = "#0091EA", Xn.Cyan50 = "#E0F7FA", Xn.Cyan100 = "#B2EBF2", Xn.Cyan200 = "#80DEEA", Xn.Cyan300 = "#4DD0E1", Xn.Cyan400 = "#26C6DA", Xn.Cyan500 = "#00BCD4", Xn.Cyan600 = "#00ACC1", Xn.Cyan700 = "#0097A7", Xn.Cyan800 = "#00838F", Xn.Cyan900 = "#006064", Xn.CyanA100 = "#84FFFF", Xn.CyanA200 = "#18FFFF", Xn.CyanA400 = "#00E5FF", Xn.CyanA700 = "#00B8D4", Xn.Teal50 = "#E0F2F1", Xn.Teal100 = "#B2DFDB", Xn.Teal200 = "#80CBC4", Xn.Teal300 = "#4DB6AC", Xn.Teal400 = "#26A69A", Xn.Teal500 = "#009688", Xn.Teal600 = "#00897B", Xn.Teal700 = "#00796B", Xn.Teal800 = "#00695C", Xn.Teal900 = "#004D40", Xn.TealA100 = "#A7FFEB", Xn.TealA200 = "#64FFDA", Xn.TealA400 = "#1DE9B6", Xn.TealA700 = "#00BFA5", Xn.Green50 = "#E8F5E9", Xn.Green100 = "#C8E6C9", Xn.Green200 = "#A5D6A7", Xn.Green300 = "#81C784", Xn.Green400 = "#66BB6A", Xn.Green500 = "#4CAF50", Xn.Green600 = "#43A047", Xn.Green700 = "#388E3C", Xn.Green800 = "#2E7D32", Xn.Green900 = "#1B5E20", Xn.GreenA100 = "#B9F6CA", Xn.GreenA200 = "#69F0AE", Xn.GreenA400 = "#00E676", Xn.GreenA700 = "#00C853", Xn.LightGreen50 = "#F1F8E9", Xn.LightGreen100 = "#DCEDC8", Xn.LightGreen200 = "#C5E1A5", Xn.LightGreen300 = "#AED581", Xn.LightGreen400 = "#9CCC65", Xn.LightGreen500 = "#8BC34A", Xn.LightGreen600 = "#7CB342", Xn.LightGreen700 = "#689F38", Xn.LightGreen800 = "#558B2F", Xn.LightGreen900 = "#33691E", Xn.LightGreenA100 = "#CCFF90", Xn.LightGreenA200 = "#B2FF59", Xn.LightGreenA400 = "#76FF03", Xn.LightGreenA700 = "#64DD17", Xn.Lime50 = "#F9FBE7", Xn.Lime100 = "#F0F4C3", Xn.Lime200 = "#E6EE9C", Xn.Lime300 = "#DCE775", Xn.Lime400 = "#D4E157", Xn.Lime500 = "#CDDC39", Xn.Lime600 = "#C0CA33", Xn.Lime700 = "#AFB42B", Xn.Lime800 = "#9E9D24", Xn.Lime900 = "#827717", Xn.LimeA100 = "#F4FF81", Xn.LimeA200 = "#EEFF41", Xn.LimeA400 = "#C6FF00", Xn.LimeA700 = "#AEEA00", Xn.Yellow50 = "#FFFDE7", Xn.Yellow100 = "#FFF9C4", Xn.Yellow200 = "#FFF59D", Xn.Yellow300 = "#FFF176", Xn.Yellow400 = "#FFEE58", Xn.Yellow500 = "#FFEB3B", Xn.Yellow600 = "#FDD835", Xn.Yellow700 = "#FBC02D", Xn.Yellow800 = "#F9A825", Xn.Yellow900 = "#F57F17", Xn.YellowA100 = "#FFFF8D", Xn.YellowA200 = "#FFFF00", Xn.YellowA400 = "#FFEA00", Xn.YellowA700 = "#FFD600", Xn.Amber50 = "#FFF8E1", Xn.Amber100 = "#FFECB3", Xn.Amber200 = "#FFE082", Xn.Amber300 = "#FFD54F", Xn.Amber400 = "#FFCA28", Xn.Amber500 = "#FFC107", Xn.Amber600 = "#FFB300", Xn.Amber700 = "#FFA000", Xn.Amber800 = "#FF8F00", Xn.Amber900 = "#FF6F00", Xn.AmberA100 = "#FFE57F", Xn.AmberA200 = "#FFD740", Xn.AmberA400 = "#FFC400", Xn.AmberA700 = "#FFAB00", Xn.Orange50 = "#FFF3E0", Xn.Orange100 = "#FFE0B2", Xn.Orange200 = "#FFCC80", Xn.Orange300 = "#FFB74D", Xn.Orange400 = "#FFA726", Xn.Orange500 = "#FF9800", Xn.Orange600 = "#FB8C00", Xn.Orange700 = "#F57C00", Xn.Orange800 = "#EF6C00", Xn.Orange900 = "#E65100", Xn.OrangeA100 = "#FFD180", Xn.OrangeA200 = "#FFAB40", Xn.OrangeA400 = "#FF9100", Xn.OrangeA700 = "#FF6D00", Xn.DeepOrange50 = "#FBE9E7", Xn.DeepOrange100 = "#FFCCBC", Xn.DeepOrange200 = "#FFAB91", Xn.DeepOrange300 = "#FF8A65", Xn.DeepOrange400 = "#FF7043", Xn.DeepOrange500 = "#FF5722", Xn.DeepOrange600 = "#F4511E", Xn.DeepOrange700 = "#E64A19", Xn.DeepOrange800 = "#D84315", Xn.DeepOrange900 = "#BF360C", Xn.DeepOrangeA100 = "#FF9E80", Xn.DeepOrangeA200 = "#FF6E40", Xn.DeepOrangeA400 = "#FF3D00", Xn.DeepOrangeA700 = "#DD2C00", Xn.Brown50 = "#EFEBE9", Xn.Brown100 = "#D7CCC8", Xn.Brown200 = "#BCAAA4", Xn.Brown300 = "#A1887F", Xn.Brown400 = "#8D6E63", Xn.Brown500 = "#795548", Xn.Brown600 = "#6D4C41", Xn.Brown700 = "#5D4037", Xn.Brown800 = "#4E342E", Xn.Brown900 = "#3E2723", Xn.Grey50 = "#FAFAFA", Xn.Grey100 = "#F5F5F5", Xn.Grey200 = "#EEEEEE", Xn.Grey300 = "#E0E0E0", Xn.Grey400 = "#BDBDBD", Xn.Grey500 = "#9E9E9E", Xn.Grey600 = "#757575", Xn.Grey700 = "#616161", Xn.Grey800 = "#424242", Xn.Grey900 = "#212121", Xn.BlueGrey50 = "#ECEFF1", Xn.BlueGrey100 = "#CFD8DC", Xn.BlueGrey200 = "#B0BEC5", Xn.BlueGrey300 = "#90A4AE", Xn.BlueGrey400 = "#78909C", Xn.BlueGrey500 = "#607D8B", Xn.BlueGrey600 = "#546E7A", Xn.BlueGrey700 = "#455A64", Xn.BlueGrey800 = "#37474F", Xn.BlueGrey900 = "#263238", Xn))(ColorexColor || {});
class Color {
  constructor() {
    /**
     * Возвращает цвет, который будет хорошо различим на фоне переданного цвета.
     * @param color Цвет фона в формате hex.
     */
    Ca(this, "getAccentColorFromHex", (zn) => {
      let Un = zn;
      if (Un.indexOf("#") === 0 && (Un = Un.slice(1)), Un.length === 3 && (Un = Un[0] + Un[0] + Un[1] + Un[1] + Un[2] + Un[2]), Un.length !== 6)
        throw new EditorError("invalid hex color");
      const Kn = Number.parseInt(Un.slice(0, 2), 16), qn = Number.parseInt(Un.slice(2, 4), 16), Jo = Number.parseInt(Un.slice(4, 6), 16);
      return Kn * 0.299 + qn * 0.587 + Jo * 0.114 > 186 ? "#000000" : "#FFFFFF";
    });
    Ca(this, "convertToColorexColor", (zn) => {
      const Un = zn.toLowerCase();
      return Object.values(ColorexColor).find((qn) => qn.toLowerCase() === Un) ?? null;
    });
  }
}
var FontFamily = /* @__PURE__ */ ((Xn) => (Xn.DEFAULT = "Inter", Xn.MERRI_WEATHER = "Merriweather", Xn.FIRA_SANS = "Fira Sans", Xn.ROBOTO = "Roboto", Xn.JOST = "Jost", Xn.ARIAL = "Arial", Xn.RUBIK = "Rubik", Xn.UBUNTU = "Ubuntu", Xn.OSWALD = "Oswald", Xn.RUSSO_ONE = "Russo One", Xn.KOSUGI_MARU = "Kosugi Maru", Xn.UNBOUNDED = "Unbounded", Xn.DELA_GOTHIC_ONE = "Dela Gothic One", Xn.MARTIN_MONO = "Martin Mono", Xn.KIWI_MARU = "Kiwi Maru", Xn.PROSTO_ONE = "Prosto One", Xn.TEKTUR = "Tektur", Xn.SEYMOUR_ONE = "Seymour One", Xn))(FontFamily || {}), FontSize = /* @__PURE__ */ ((Xn) => (Xn.Pt8 = "8pt", Xn.Pt9 = "9pt", Xn.Pt10 = "10pt", Xn.Pt11 = "11pt", Xn.Pt12 = "12pt", Xn.Pt14 = "14pt", Xn.Pt16 = "16pt", Xn.Pt18 = "18pt", Xn.Pt20 = "20pt", Xn.Pt22 = "22pt", Xn.Pt24 = "24pt", Xn.Pt26 = "26pt", Xn.Pt28 = "28pt", Xn.Pt36 = "36pt", Xn.Pt48 = "48pt", Xn.Pt56 = "56pt", Xn.Pt64 = "64pt", Xn.Pt72 = "72pt", Xn))(FontSize || {});
const DefaultFontSize = "14pt";
var LineHeight = /* @__PURE__ */ ((Xn) => (Xn[Xn.SMALL = 1] = "SMALL", Xn[Xn.SMALL_PLUS = 1.2] = "SMALL_PLUS", Xn[Xn.MEDIUM_MINUS = 1.5] = "MEDIUM_MINUS", Xn[Xn.MEDIUM_SMALL = 1.7] = "MEDIUM_SMALL", Xn[Xn.MEDIUM = 2] = "MEDIUM", Xn[Xn.MEDIUM_PLUS = 2.2] = "MEDIUM_PLUS", Xn[Xn.BIG_MINUS = 2.5] = "BIG_MINUS", Xn[Xn.BIG_SMALL = 2.7] = "BIG_SMALL", Xn[Xn.BIG = 3] = "BIG", Xn))(LineHeight || {}), TextAlign = /* @__PURE__ */ ((Xn) => (Xn.LEFT = "left", Xn.CENTER = "center", Xn.RIGHT = "right", Xn.JUSTIFY = "justify", Xn))(TextAlign || {}), TokenFormat = /* @__PURE__ */ ((Xn) => (Xn[Xn.None = 0] = "None", Xn[Xn.Bold = 1] = "Bold", Xn[Xn.Italic = 2] = "Italic", Xn[Xn.BoldItalic = 3] = "BoldItalic", Xn[Xn.Underline = 4] = "Underline", Xn[Xn.Strike = 8] = "Strike", Xn[Xn.Monospace = 16] = "Monospace", Xn[Xn.Heading = 32] = "Heading", Xn[Xn.Marked = 64] = "Marked", Xn[Xn.Highlight = 128] = "Highlight", Xn))(TokenFormat || {}), TokenType = /* @__PURE__ */ ((Xn) => (Xn.TEXT = "text", Xn.LINK = "link", Xn.NEW_LINE = "newline", Xn.PARAGRAPH = "paragraph", Xn.RED_LINE = "red_line", Xn))(TokenType || {});
class Component {
  constructor() {
    /**
     * Возвращает стандартную модель текста.
     */
    Ca(this, "getDefaultTextModel", () => ({
      id: Utils.generate.uuid4(),
      textAlign: TextAlign.LEFT,
      lineHeight: LineHeight.MEDIUM,
      splitGraphemePositions: [0],
      tokens: [
        {
          type: TokenType.TEXT,
          value: "",
          fontSize: DefaultFontSize,
          fontFamily: FontFamily.DEFAULT,
          color: "#000000",
          format: TokenFormat.None
        }
      ]
    }));
    /**
     * Возвращает стандартную модель текста с переданным содержимым.
     */
    Ca(this, "getDefaultTextModelWithValue", (zn) => ({
      id: Utils.generate.uuid4(),
      textAlign: TextAlign.LEFT,
      lineHeight: LineHeight.MEDIUM,
      splitGraphemePositions: [0],
      tokens: [
        {
          type: TokenType.TEXT,
          value: zn,
          fontSize: DefaultFontSize,
          fontFamily: FontFamily.DEFAULT,
          color: "#000000",
          format: TokenFormat.None
        }
      ]
    }));
    /**
     * Возвращает текстуру ячейки по умолчанию.
     * @param value Текст в ячейке.
     * @param rowIndex Позиция ячейки по оси Y.
     * @param columnIndex Позиция ячейки по оси X.
     */
    Ca(this, "getDefaultCellTexture", (zn, Un, Kn) => {
      const qn = this.getDefaultTextModelWithValue(zn);
      return {
        id: Utils.generate.uuid4(),
        content: qn,
        background: "#ffffff",
        row: Un,
        column: Kn,
        rowSpan: 1,
        columnSpan: 1
      };
    });
    Ca(this, "getSomeComponentType", (zn) => {
      const Un = zn[0].type;
      return zn.some((qn) => qn.type === Un) ? Un : null;
    });
  }
}
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var current_ansi = 1252, VALID_ANSI = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], CS2CP = {
  /*::[*/
  0: 1252,
  /* ANSI */
  /*::[*/
  1: 65001,
  /* DEFAULT */
  /*::[*/
  2: 65001,
  /* SYMBOL */
  /*::[*/
  77: 1e4,
  /* MAC */
  /*::[*/
  128: 932,
  /* SHIFTJIS */
  /*::[*/
  129: 949,
  /* HANGUL */
  /*::[*/
  130: 1361,
  /* JOHAB */
  /*::[*/
  134: 936,
  /* GB2312 */
  /*::[*/
  136: 950,
  /* CHINESEBIG5 */
  /*::[*/
  161: 1253,
  /* GREEK */
  /*::[*/
  162: 1254,
  /* TURKISH */
  /*::[*/
  163: 1258,
  /* VIETNAMESE */
  /*::[*/
  177: 1255,
  /* HEBREW */
  /*::[*/
  178: 1256,
  /* ARABIC */
  /*::[*/
  186: 1257,
  /* BALTIC */
  /*::[*/
  204: 1251,
  /* RUSSIAN */
  /*::[*/
  222: 874,
  /* THAI */
  /*::[*/
  238: 1250,
  /* EASTEUROPE */
  /*::[*/
  255: 1252,
  /* OEM */
  /*::[*/
  69: 6969
  /* MISC */
}, set_ansi = function(Xn) {
  VALID_ANSI.indexOf(Xn) != -1 && (current_ansi = CS2CP[0] = Xn);
};
function reset_ansi() {
  set_ansi(1252);
}
var set_cp = function(Xn) {
  set_ansi(Xn);
};
function reset_cp() {
  set_cp(1200), reset_ansi();
}
function char_codes(Xn) {
  for (var zn = [], Un = 0, Kn = Xn.length; Un < Kn; ++Un) zn[Un] = Xn.charCodeAt(Un);
  return zn;
}
function utf16leread(Xn) {
  for (var zn = [], Un = 0; Un < Xn.length >> 1; ++Un) zn[Un] = String.fromCharCode(Xn.charCodeAt(2 * Un) + (Xn.charCodeAt(2 * Un + 1) << 8));
  return zn.join("");
}
function utf16beread(Xn) {
  for (var zn = [], Un = 0; Un < Xn.length >> 1; ++Un) zn[Un] = String.fromCharCode(Xn.charCodeAt(2 * Un + 1) + (Xn.charCodeAt(2 * Un) << 8));
  return zn.join("");
}
var debom = function(Xn) {
  var zn = Xn.charCodeAt(0), Un = Xn.charCodeAt(1);
  return zn == 255 && Un == 254 ? utf16leread(Xn.slice(2)) : zn == 254 && Un == 255 ? utf16beread(Xn.slice(2)) : zn == 65279 ? Xn.slice(1) : Xn;
}, _getchar = function(zn) {
  return String.fromCharCode(zn);
}, _getansi = function(zn) {
  return String.fromCharCode(zn);
}, $cptable, Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Base64_encode(Xn) {
  for (var zn = "", Un = 0, Kn = 0, qn = 0, Jo = 0, pa = 0, ma = 0, va = 0, ba = 0; ba < Xn.length; )
    Un = Xn.charCodeAt(ba++), Jo = Un >> 2, Kn = Xn.charCodeAt(ba++), pa = (Un & 3) << 4 | Kn >> 4, qn = Xn.charCodeAt(ba++), ma = (Kn & 15) << 2 | qn >> 6, va = qn & 63, isNaN(Kn) ? ma = va = 64 : isNaN(qn) && (va = 64), zn += Base64_map.charAt(Jo) + Base64_map.charAt(pa) + Base64_map.charAt(ma) + Base64_map.charAt(va);
  return zn;
}
function Base64_decode(Xn) {
  var zn = "", Un = 0, Kn = 0, qn = 0, Jo = 0, pa = 0, ma = 0, va = 0;
  Xn = Xn.replace(/[^\w\+\/\=]/g, "");
  for (var ba = 0; ba < Xn.length; )
    Jo = Base64_map.indexOf(Xn.charAt(ba++)), pa = Base64_map.indexOf(Xn.charAt(ba++)), Un = Jo << 2 | pa >> 4, zn += String.fromCharCode(Un), ma = Base64_map.indexOf(Xn.charAt(ba++)), Kn = (pa & 15) << 4 | ma >> 2, ma !== 64 && (zn += String.fromCharCode(Kn)), va = Base64_map.indexOf(Xn.charAt(ba++)), qn = (ma & 3) << 6 | va, va !== 64 && (zn += String.fromCharCode(qn));
  return zn;
}
var has_buf = /* @__PURE__ */ function() {
  return typeof Buffer < "u" && typeof process < "u" && typeof process.versions < "u" && !!process.versions.node;
}(), Buffer_from = /* @__PURE__ */ function() {
  if (typeof Buffer < "u") {
    var Xn = !Buffer.from;
    if (!Xn) try {
      Buffer.from("foo", "utf8");
    } catch {
      Xn = !0;
    }
    return Xn ? function(zn, Un) {
      return Un ? new Buffer(zn, Un) : new Buffer(zn);
    } : Buffer.from.bind(Buffer);
  }
  return function() {
  };
}();
function new_raw_buf(Xn) {
  return has_buf ? Buffer.alloc ? Buffer.alloc(Xn) : new Buffer(Xn) : typeof Uint8Array < "u" ? new Uint8Array(Xn) : new Array(Xn);
}
function new_unsafe_buf(Xn) {
  return has_buf ? Buffer.allocUnsafe ? Buffer.allocUnsafe(Xn) : new Buffer(Xn) : typeof Uint8Array < "u" ? new Uint8Array(Xn) : new Array(Xn);
}
var s2a = function(zn) {
  return has_buf ? Buffer_from(zn, "binary") : zn.split("").map(function(Un) {
    return Un.charCodeAt(0) & 255;
  });
};
function a2s(Xn) {
  if (Array.isArray(Xn)) return Xn.map(function(Kn) {
    return String.fromCharCode(Kn);
  }).join("");
  for (var zn = [], Un = 0; Un < Xn.length; ++Un) zn[Un] = String.fromCharCode(Xn[Un]);
  return zn.join("");
}
function ab2a(Xn) {
  if (typeof ArrayBuffer > "u") throw new Error("Unsupported");
  if (Xn instanceof ArrayBuffer) return ab2a(new Uint8Array(Xn));
  for (var zn = new Array(Xn.length), Un = 0; Un < Xn.length; ++Un) zn[Un] = Xn[Un];
  return zn;
}
var bconcat = has_buf ? function(Xn) {
  return Buffer.concat(Xn.map(function(zn) {
    return Buffer.isBuffer(zn) ? zn : Buffer_from(zn);
  }));
} : function(Xn) {
  if (typeof Uint8Array < "u") {
    var zn = 0, Un = 0;
    for (zn = 0; zn < Xn.length; ++zn) Un += Xn[zn].length;
    var Kn = new Uint8Array(Un), qn = 0;
    for (zn = 0, Un = 0; zn < Xn.length; Un += qn, ++zn)
      if (qn = Xn[zn].length, Xn[zn] instanceof Uint8Array) Kn.set(Xn[zn], Un);
      else {
        if (typeof Xn[zn] == "string")
          throw "wtf";
        Kn.set(new Uint8Array(Xn[zn]), Un);
      }
    return Kn;
  }
  return [].concat.apply([], Xn.map(function(Jo) {
    return Array.isArray(Jo) ? Jo : [].slice.call(Jo);
  }));
};
function utf8decode(Xn) {
  for (var zn = [], Un = 0, Kn = Xn.length + 250, qn = new_raw_buf(Xn.length + 255), Jo = 0; Jo < Xn.length; ++Jo) {
    var pa = Xn.charCodeAt(Jo);
    if (pa < 128) qn[Un++] = pa;
    else if (pa < 2048)
      qn[Un++] = 192 | pa >> 6 & 31, qn[Un++] = 128 | pa & 63;
    else if (pa >= 55296 && pa < 57344) {
      pa = (pa & 1023) + 64;
      var ma = Xn.charCodeAt(++Jo) & 1023;
      qn[Un++] = 240 | pa >> 8 & 7, qn[Un++] = 128 | pa >> 2 & 63, qn[Un++] = 128 | ma >> 6 & 15 | (pa & 3) << 4, qn[Un++] = 128 | ma & 63;
    } else
      qn[Un++] = 224 | pa >> 12 & 15, qn[Un++] = 128 | pa >> 6 & 63, qn[Un++] = 128 | pa & 63;
    Un > Kn && (zn.push(qn.slice(0, Un)), Un = 0, qn = new_raw_buf(65535), Kn = 65530);
  }
  return zn.push(qn.slice(0, Un)), bconcat(zn);
}
var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
function _strrev(Xn) {
  for (var zn = "", Un = Xn.length - 1; Un >= 0; ) zn += Xn.charAt(Un--);
  return zn;
}
function pad0(Xn, zn) {
  var Un = "" + Xn;
  return Un.length >= zn ? Un : fill$1("0", zn - Un.length) + Un;
}
function pad_(Xn, zn) {
  var Un = "" + Xn;
  return Un.length >= zn ? Un : fill$1(" ", zn - Un.length) + Un;
}
function rpad_(Xn, zn) {
  var Un = "" + Xn;
  return Un.length >= zn ? Un : Un + fill$1(" ", zn - Un.length);
}
function pad0r1(Xn, zn) {
  var Un = "" + Math.round(Xn);
  return Un.length >= zn ? Un : fill$1("0", zn - Un.length) + Un;
}
function pad0r2(Xn, zn) {
  var Un = "" + Xn;
  return Un.length >= zn ? Un : fill$1("0", zn - Un.length) + Un;
}
var p2_32 = /* @__PURE__ */ Math.pow(2, 32);
function pad0r(Xn, zn) {
  if (Xn > p2_32 || Xn < -p2_32) return pad0r1(Xn, zn);
  var Un = Math.round(Xn);
  return pad0r2(Un, zn);
}
function SSF_isgeneral(Xn, zn) {
  return zn = zn || 0, Xn.length >= 7 + zn && (Xn.charCodeAt(zn) | 32) === 103 && (Xn.charCodeAt(zn + 1) | 32) === 101 && (Xn.charCodeAt(zn + 2) | 32) === 110 && (Xn.charCodeAt(zn + 3) | 32) === 101 && (Xn.charCodeAt(zn + 4) | 32) === 114 && (Xn.charCodeAt(zn + 5) | 32) === 97 && (Xn.charCodeAt(zn + 6) | 32) === 108;
}
var days = [
  ["Sun", "Sunday"],
  ["Mon", "Monday"],
  ["Tue", "Tuesday"],
  ["Wed", "Wednesday"],
  ["Thu", "Thursday"],
  ["Fri", "Friday"],
  ["Sat", "Saturday"]
], months = [
  ["J", "Jan", "January"],
  ["F", "Feb", "February"],
  ["M", "Mar", "March"],
  ["A", "Apr", "April"],
  ["M", "May", "May"],
  ["J", "Jun", "June"],
  ["J", "Jul", "July"],
  ["A", "Aug", "August"],
  ["S", "Sep", "September"],
  ["O", "Oct", "October"],
  ["N", "Nov", "November"],
  ["D", "Dec", "December"]
];
function SSF_init_table(Xn) {
  return Xn || (Xn = {}), Xn[0] = "General", Xn[1] = "0", Xn[2] = "0.00", Xn[3] = "#,##0", Xn[4] = "#,##0.00", Xn[9] = "0%", Xn[10] = "0.00%", Xn[11] = "0.00E+00", Xn[12] = "# ?/?", Xn[13] = "# ??/??", Xn[14] = "m/d/yy", Xn[15] = "d-mmm-yy", Xn[16] = "d-mmm", Xn[17] = "mmm-yy", Xn[18] = "h:mm AM/PM", Xn[19] = "h:mm:ss AM/PM", Xn[20] = "h:mm", Xn[21] = "h:mm:ss", Xn[22] = "m/d/yy h:mm", Xn[37] = "#,##0 ;(#,##0)", Xn[38] = "#,##0 ;[Red](#,##0)", Xn[39] = "#,##0.00;(#,##0.00)", Xn[40] = "#,##0.00;[Red](#,##0.00)", Xn[45] = "mm:ss", Xn[46] = "[h]:mm:ss", Xn[47] = "mmss.0", Xn[48] = "##0.0E+0", Xn[49] = "@", Xn[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', Xn;
}
var table_fmt = {
  0: "General",
  1: "0",
  2: "0.00",
  3: "#,##0",
  4: "#,##0.00",
  9: "0%",
  10: "0.00%",
  11: "0.00E+00",
  12: "# ?/?",
  13: "# ??/??",
  14: "m/d/yy",
  15: "d-mmm-yy",
  16: "d-mmm",
  17: "mmm-yy",
  18: "h:mm AM/PM",
  19: "h:mm:ss AM/PM",
  20: "h:mm",
  21: "h:mm:ss",
  22: "m/d/yy h:mm",
  37: "#,##0 ;(#,##0)",
  38: "#,##0 ;[Red](#,##0)",
  39: "#,##0.00;(#,##0.00)",
  40: "#,##0.00;[Red](#,##0.00)",
  45: "mm:ss",
  46: "[h]:mm:ss",
  47: "mmss.0",
  48: "##0.0E+0",
  49: "@",
  56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
}, SSF_default_map = {
  5: 37,
  6: 38,
  7: 39,
  8: 40,
  //  5 -> 37 ...  8 -> 40
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  // 23 ->  0 ... 26 ->  0
  27: 14,
  28: 14,
  29: 14,
  30: 14,
  31: 14,
  // 27 -> 14 ... 31 -> 14
  50: 14,
  51: 14,
  52: 14,
  53: 14,
  54: 14,
  // 50 -> 14 ... 58 -> 14
  55: 14,
  56: 14,
  57: 14,
  58: 14,
  59: 1,
  60: 2,
  61: 3,
  62: 4,
  // 59 ->  1 ... 62 ->  4
  67: 9,
  68: 10,
  // 67 ->  9 ... 68 -> 10
  69: 12,
  70: 13,
  71: 14,
  // 69 -> 12 ... 71 -> 14
  72: 14,
  73: 15,
  74: 16,
  75: 17,
  // 72 -> 14 ... 75 -> 17
  76: 20,
  77: 21,
  78: 22,
  // 76 -> 20 ... 78 -> 22
  79: 45,
  80: 46,
  81: 47,
  // 79 -> 45 ... 81 -> 47
  82: 0
  // 82 ->  0 ... 65536 -> 0 (omitted)
}, SSF_default_str = {
  //  5 -- Currency,   0 decimal, black negative
  5: '"$"#,##0_);\\("$"#,##0\\)',
  63: '"$"#,##0_);\\("$"#,##0\\)',
  //  6 -- Currency,   0 decimal, red   negative
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  //  7 -- Currency,   2 decimal, black negative
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  //  8 -- Currency,   2 decimal, red   negative
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  // 41 -- Accounting, 0 decimal, No Symbol
  41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
  // 42 -- Accounting, 0 decimal, $  Symbol
  42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
  // 43 -- Accounting, 2 decimal, No Symbol
  43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
  // 44 -- Accounting, 2 decimal, $  Symbol
  44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function SSF_frac(Xn, zn, Un) {
  for (var Kn = Xn < 0 ? -1 : 1, qn = Xn * Kn, Jo = 0, pa = 1, ma = 0, va = 1, ba = 0, _a = 0, ya = Math.floor(qn); ba < zn && (ya = Math.floor(qn), ma = ya * pa + Jo, _a = ya * ba + va, !(qn - ya < 5e-8)); )
    qn = 1 / (qn - ya), Jo = pa, pa = ma, va = ba, ba = _a;
  if (_a > zn && (ba > zn ? (_a = va, ma = Jo) : (_a = ba, ma = pa)), !Un) return [0, Kn * ma, _a];
  var xa = Math.floor(Kn * ma / _a);
  return [xa, Kn * ma - xa * _a, _a];
}
function SSF_parse_date_code(Xn, zn, Un) {
  if (Xn > 2958465 || Xn < 0) return null;
  var Kn = Xn | 0, qn = Math.floor(86400 * (Xn - Kn)), Jo = 0, pa = [], ma = { D: Kn, T: qn, u: 86400 * (Xn - Kn) - qn, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
  if (Math.abs(ma.u) < 1e-6 && (ma.u = 0), zn && zn.date1904 && (Kn += 1462), ma.u > 0.9999 && (ma.u = 0, ++qn == 86400 && (ma.T = qn = 0, ++Kn, ++ma.D)), Kn === 60)
    pa = Un ? [1317, 10, 29] : [1900, 2, 29], Jo = 3;
  else if (Kn === 0)
    pa = Un ? [1317, 8, 29] : [1900, 1, 0], Jo = 6;
  else {
    Kn > 60 && --Kn;
    var va = new Date(1900, 0, 1);
    va.setDate(va.getDate() + Kn - 1), pa = [va.getFullYear(), va.getMonth() + 1, va.getDate()], Jo = va.getDay(), Kn < 60 && (Jo = (Jo + 6) % 7), Un && (Jo = SSF_fix_hijri(va, pa));
  }
  return ma.y = pa[0], ma.m = pa[1], ma.d = pa[2], ma.S = qn % 60, qn = Math.floor(qn / 60), ma.M = qn % 60, qn = Math.floor(qn / 60), ma.H = qn, ma.q = Jo, ma;
}
var SSFbasedate = /* @__PURE__ */ new Date(1899, 11, 31, 0, 0, 0), SSFdnthresh = /* @__PURE__ */ SSFbasedate.getTime(), SSFbase1904 = /* @__PURE__ */ new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(Xn, zn) {
  var Un = /* @__PURE__ */ Xn.getTime();
  return zn ? Un -= 1461 * 24 * 60 * 60 * 1e3 : Xn >= SSFbase1904 && (Un += 24 * 60 * 60 * 1e3), (Un - (SSFdnthresh + (/* @__PURE__ */ Xn.getTimezoneOffset() - /* @__PURE__ */ SSFbasedate.getTimezoneOffset()) * 6e4)) / (24 * 60 * 60 * 1e3);
}
function SSF_strip_decimal(Xn) {
  return Xn.indexOf(".") == -1 ? Xn : Xn.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
function SSF_normalize_exp(Xn) {
  return Xn.indexOf("E") == -1 ? Xn : Xn.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
function SSF_small_exp(Xn) {
  var zn = Xn < 0 ? 12 : 11, Un = SSF_strip_decimal(Xn.toFixed(12));
  return Un.length <= zn || (Un = Xn.toPrecision(10), Un.length <= zn) ? Un : Xn.toExponential(5);
}
function SSF_large_exp(Xn) {
  var zn = SSF_strip_decimal(Xn.toFixed(11));
  return zn.length > (Xn < 0 ? 12 : 11) || zn === "0" || zn === "-0" ? Xn.toPrecision(6) : zn;
}
function SSF_general_num(Xn) {
  var zn = Math.floor(Math.log(Math.abs(Xn)) * Math.LOG10E), Un;
  return zn >= -4 && zn <= -1 ? Un = Xn.toPrecision(10 + zn) : Math.abs(zn) <= 9 ? Un = SSF_small_exp(Xn) : zn === 10 ? Un = Xn.toFixed(10).substr(0, 12) : Un = SSF_large_exp(Xn), SSF_strip_decimal(SSF_normalize_exp(Un.toUpperCase()));
}
function SSF_general(Xn, zn) {
  switch (typeof Xn) {
    case "string":
      return Xn;
    case "boolean":
      return Xn ? "TRUE" : "FALSE";
    case "number":
      return (Xn | 0) === Xn ? Xn.toString(10) : SSF_general_num(Xn);
    case "undefined":
      return "";
    case "object":
      if (Xn == null) return "";
      if (Xn instanceof Date) return SSF_format(14, datenum_local(Xn, zn && zn.date1904), zn);
  }
  throw new Error("unsupported value in General format: " + Xn);
}
function SSF_fix_hijri(Xn, zn) {
  zn[0] -= 581;
  var Un = Xn.getDay();
  return Xn < 60 && (Un = (Un + 6) % 7), Un;
}
function SSF_write_date(Xn, zn, Un, Kn) {
  var qn = "", Jo = 0, pa = 0, ma = Un.y, va, ba = 0;
  switch (Xn) {
    case 98:
      ma = Un.y + 543;
    /* falls through */
    case 121:
      switch (zn.length) {
        case 1:
        case 2:
          va = ma % 100, ba = 2;
          break;
        default:
          va = ma % 1e4, ba = 4;
          break;
      }
      break;
    case 109:
      switch (zn.length) {
        case 1:
        case 2:
          va = Un.m, ba = zn.length;
          break;
        case 3:
          return months[Un.m - 1][1];
        case 5:
          return months[Un.m - 1][0];
        default:
          return months[Un.m - 1][2];
      }
      break;
    case 100:
      switch (zn.length) {
        case 1:
        case 2:
          va = Un.d, ba = zn.length;
          break;
        case 3:
          return days[Un.q][0];
        default:
          return days[Un.q][1];
      }
      break;
    case 104:
      switch (zn.length) {
        case 1:
        case 2:
          va = 1 + (Un.H + 11) % 12, ba = zn.length;
          break;
        default:
          throw "bad hour format: " + zn;
      }
      break;
    case 72:
      switch (zn.length) {
        case 1:
        case 2:
          va = Un.H, ba = zn.length;
          break;
        default:
          throw "bad hour format: " + zn;
      }
      break;
    case 77:
      switch (zn.length) {
        case 1:
        case 2:
          va = Un.M, ba = zn.length;
          break;
        default:
          throw "bad minute format: " + zn;
      }
      break;
    case 115:
      if (zn != "s" && zn != "ss" && zn != ".0" && zn != ".00" && zn != ".000") throw "bad second format: " + zn;
      return Un.u === 0 && (zn == "s" || zn == "ss") ? pad0(Un.S, zn.length) : (Kn >= 2 ? pa = Kn === 3 ? 1e3 : 100 : pa = Kn === 1 ? 10 : 1, Jo = Math.round(pa * (Un.S + Un.u)), Jo >= 60 * pa && (Jo = 0), zn === "s" ? Jo === 0 ? "0" : "" + Jo / pa : (qn = pad0(Jo, 2 + Kn), zn === "ss" ? qn.substr(0, 2) : "." + qn.substr(2, zn.length - 1)));
    case 90:
      switch (zn) {
        case "[h]":
        case "[hh]":
          va = Un.D * 24 + Un.H;
          break;
        case "[m]":
        case "[mm]":
          va = (Un.D * 24 + Un.H) * 60 + Un.M;
          break;
        case "[s]":
        case "[ss]":
          va = ((Un.D * 24 + Un.H) * 60 + Un.M) * 60 + Math.round(Un.S + Un.u);
          break;
        default:
          throw "bad abstime format: " + zn;
      }
      ba = zn.length === 3 ? 1 : 2;
      break;
    case 101:
      va = ma, ba = 1;
      break;
  }
  var _a = ba > 0 ? pad0(va, ba) : "";
  return _a;
}
function commaify(Xn) {
  var zn = 3;
  if (Xn.length <= zn) return Xn;
  for (var Un = Xn.length % zn, Kn = Xn.substr(0, Un); Un != Xn.length; Un += zn) Kn += (Kn.length > 0 ? "," : "") + Xn.substr(Un, zn);
  return Kn;
}
var pct1 = /%/g;
function write_num_pct(Xn, zn, Un) {
  var Kn = zn.replace(pct1, ""), qn = zn.length - Kn.length;
  return write_num(Xn, Kn, Un * Math.pow(10, 2 * qn)) + fill$1("%", qn);
}
function write_num_cm(Xn, zn, Un) {
  for (var Kn = zn.length - 1; zn.charCodeAt(Kn - 1) === 44; ) --Kn;
  return write_num(Xn, zn.substr(0, Kn), Un / Math.pow(10, 3 * (zn.length - Kn)));
}
function write_num_exp(Xn, zn) {
  var Un, Kn = Xn.indexOf("E") - Xn.indexOf(".") - 1;
  if (Xn.match(/^#+0.0E\+0$/)) {
    if (zn == 0) return "0.0E+0";
    if (zn < 0) return "-" + write_num_exp(Xn, -zn);
    var qn = Xn.indexOf(".");
    qn === -1 && (qn = Xn.indexOf("E"));
    var Jo = Math.floor(Math.log(zn) * Math.LOG10E) % qn;
    if (Jo < 0 && (Jo += qn), Un = (zn / Math.pow(10, Jo)).toPrecision(Kn + 1 + (qn + Jo) % qn), Un.indexOf("e") === -1) {
      var pa = Math.floor(Math.log(zn) * Math.LOG10E);
      for (Un.indexOf(".") === -1 ? Un = Un.charAt(0) + "." + Un.substr(1) + "E+" + (pa - Un.length + Jo) : Un += "E+" + (pa - Jo); Un.substr(0, 2) === "0."; )
        Un = Un.charAt(0) + Un.substr(2, qn) + "." + Un.substr(2 + qn), Un = Un.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
      Un = Un.replace(/\+-/, "-");
    }
    Un = Un.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(ma, va, ba, _a) {
      return va + ba + _a.substr(0, (qn + Jo) % qn) + "." + _a.substr(Jo) + "E";
    });
  } else Un = zn.toExponential(Kn);
  return Xn.match(/E\+00$/) && Un.match(/e[+-]\d$/) && (Un = Un.substr(0, Un.length - 1) + "0" + Un.charAt(Un.length - 1)), Xn.match(/E\-/) && Un.match(/e\+/) && (Un = Un.replace(/e\+/, "e")), Un.replace("e", "E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(Xn, zn, Un) {
  var Kn = parseInt(Xn[4], 10), qn = Math.round(zn * Kn), Jo = Math.floor(qn / Kn), pa = qn - Jo * Kn, ma = Kn;
  return Un + (Jo === 0 ? "" : "" + Jo) + " " + (pa === 0 ? fill$1(" ", Xn[1].length + 1 + Xn[4].length) : pad_(pa, Xn[1].length) + Xn[2] + "/" + Xn[3] + pad0(ma, Xn[4].length));
}
function write_num_f2(Xn, zn, Un) {
  return Un + (zn === 0 ? "" : "" + zn) + fill$1(" ", Xn[1].length + 2 + Xn[4].length);
}
var dec1 = /^#*0*\.([0#]+)/, closeparen = /\).*[0#]/, phone = /\(###\) ###\\?-####/;
function hashq(Xn) {
  for (var zn = "", Un, Kn = 0; Kn != Xn.length; ++Kn) switch (Un = Xn.charCodeAt(Kn)) {
    case 35:
      break;
    case 63:
      zn += " ";
      break;
    case 48:
      zn += "0";
      break;
    default:
      zn += String.fromCharCode(Un);
  }
  return zn;
}
function rnd(Xn, zn) {
  var Un = Math.pow(10, zn);
  return "" + Math.round(Xn * Un) / Un;
}
function dec(Xn, zn) {
  var Un = Xn - Math.floor(Xn), Kn = Math.pow(10, zn);
  return zn < ("" + Math.round(Un * Kn)).length ? 0 : Math.round(Un * Kn);
}
function carry(Xn, zn) {
  return zn < ("" + Math.round((Xn - Math.floor(Xn)) * Math.pow(10, zn))).length ? 1 : 0;
}
function flr(Xn) {
  return Xn < 2147483647 && Xn > -2147483648 ? "" + (Xn >= 0 ? Xn | 0 : Xn - 1 | 0) : "" + Math.floor(Xn);
}
function write_num_flt(Xn, zn, Un) {
  if (Xn.charCodeAt(0) === 40 && !zn.match(closeparen)) {
    var Kn = zn.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return Un >= 0 ? write_num_flt("n", Kn, Un) : "(" + write_num_flt("n", Kn, -Un) + ")";
  }
  if (zn.charCodeAt(zn.length - 1) === 44) return write_num_cm(Xn, zn, Un);
  if (zn.indexOf("%") !== -1) return write_num_pct(Xn, zn, Un);
  if (zn.indexOf("E") !== -1) return write_num_exp(zn, Un);
  if (zn.charCodeAt(0) === 36) return "$" + write_num_flt(Xn, zn.substr(zn.charAt(1) == " " ? 2 : 1), Un);
  var qn, Jo, pa, ma, va = Math.abs(Un), ba = Un < 0 ? "-" : "";
  if (zn.match(/^00+$/)) return ba + pad0r(va, zn.length);
  if (zn.match(/^[#?]+$/))
    return qn = pad0r(Un, 0), qn === "0" && (qn = ""), qn.length > zn.length ? qn : hashq(zn.substr(0, zn.length - qn.length)) + qn;
  if (Jo = zn.match(frac1)) return write_num_f1(Jo, va, ba);
  if (zn.match(/^#+0+$/)) return ba + pad0r(va, zn.length - zn.indexOf("0"));
  if (Jo = zn.match(dec1))
    return qn = rnd(Un, Jo[1].length).replace(/^([^\.]+)$/, "$1." + hashq(Jo[1])).replace(/\.$/, "." + hashq(Jo[1])).replace(/\.(\d*)$/, function(Ta, Sa) {
      return "." + Sa + fill$1("0", hashq(
        /*::(*/
        Jo[1]
      ).length - Sa.length);
    }), zn.indexOf("0.") !== -1 ? qn : qn.replace(/^0\./, ".");
  if (zn = zn.replace(/^#+([0.])/, "$1"), Jo = zn.match(/^(0*)\.(#*)$/))
    return ba + rnd(va, Jo[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, Jo[1].length ? "0." : ".");
  if (Jo = zn.match(/^#{1,3},##0(\.?)$/)) return ba + commaify(pad0r(va, 0));
  if (Jo = zn.match(/^#,##0\.([#0]*0)$/))
    return Un < 0 ? "-" + write_num_flt(Xn, zn, -Un) : commaify("" + (Math.floor(Un) + carry(Un, Jo[1].length))) + "." + pad0(dec(Un, Jo[1].length), Jo[1].length);
  if (Jo = zn.match(/^#,#*,#0/)) return write_num_flt(Xn, zn.replace(/^#,#*,/, ""), Un);
  if (Jo = zn.match(/^([0#]+)(\\?-([0#]+))+$/))
    return qn = _strrev(write_num_flt(Xn, zn.replace(/[\\-]/g, ""), Un)), pa = 0, _strrev(_strrev(zn.replace(/\\/g, "")).replace(/[0#]/g, function(Ta) {
      return pa < qn.length ? qn.charAt(pa++) : Ta === "0" ? "0" : "";
    }));
  if (zn.match(phone))
    return qn = write_num_flt(Xn, "##########", Un), "(" + qn.substr(0, 3) + ") " + qn.substr(3, 3) + "-" + qn.substr(6);
  var _a = "";
  if (Jo = zn.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return pa = Math.min(
      /*::String(*/
      Jo[4].length,
      7
    ), ma = SSF_frac(va, Math.pow(10, pa) - 1, !1), qn = "" + ba, _a = write_num(
      "n",
      /*::String(*/
      Jo[1],
      ma[1]
    ), _a.charAt(_a.length - 1) == " " && (_a = _a.substr(0, _a.length - 1) + "0"), qn += _a + /*::String(*/
    Jo[2] + "/" + /*::String(*/
    Jo[3], _a = rpad_(ma[2], pa), _a.length < Jo[4].length && (_a = hashq(Jo[4].substr(Jo[4].length - _a.length)) + _a), qn += _a, qn;
  if (Jo = zn.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return pa = Math.min(Math.max(Jo[1].length, Jo[4].length), 7), ma = SSF_frac(va, Math.pow(10, pa) - 1, !0), ba + (ma[0] || (ma[1] ? "" : "0")) + " " + (ma[1] ? pad_(ma[1], pa) + Jo[2] + "/" + Jo[3] + rpad_(ma[2], pa) : fill$1(" ", 2 * pa + 1 + Jo[2].length + Jo[3].length));
  if (Jo = zn.match(/^[#0?]+$/))
    return qn = pad0r(Un, 0), zn.length <= qn.length ? qn : hashq(zn.substr(0, zn.length - qn.length)) + qn;
  if (Jo = zn.match(/^([#0?]+)\.([#0]+)$/)) {
    qn = "" + Un.toFixed(Math.min(Jo[2].length, 10)).replace(/([^0])0+$/, "$1"), pa = qn.indexOf(".");
    var ya = zn.indexOf(".") - pa, xa = zn.length - qn.length - ya;
    return hashq(zn.substr(0, ya) + qn + zn.substr(zn.length - xa));
  }
  if (Jo = zn.match(/^00,000\.([#0]*0)$/))
    return pa = dec(Un, Jo[1].length), Un < 0 ? "-" + write_num_flt(Xn, zn, -Un) : commaify(flr(Un)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(Ta) {
      return "00," + (Ta.length < 3 ? pad0(0, 3 - Ta.length) : "") + Ta;
    }) + "." + pad0(pa, Jo[1].length);
  switch (zn) {
    case "###,##0.00":
      return write_num_flt(Xn, "#,##0.00", Un);
    case "###,###":
    case "##,###":
    case "#,###":
      var wa = commaify(pad0r(va, 0));
      return wa !== "0" ? ba + wa : "";
    case "###,###.00":
      return write_num_flt(Xn, "###,##0.00", Un).replace(/^0\./, ".");
    case "#,###.00":
      return write_num_flt(Xn, "#,##0.00", Un).replace(/^0\./, ".");
  }
  throw new Error("unsupported format |" + zn + "|");
}
function write_num_cm2(Xn, zn, Un) {
  for (var Kn = zn.length - 1; zn.charCodeAt(Kn - 1) === 44; ) --Kn;
  return write_num(Xn, zn.substr(0, Kn), Un / Math.pow(10, 3 * (zn.length - Kn)));
}
function write_num_pct2(Xn, zn, Un) {
  var Kn = zn.replace(pct1, ""), qn = zn.length - Kn.length;
  return write_num(Xn, Kn, Un * Math.pow(10, 2 * qn)) + fill$1("%", qn);
}
function write_num_exp2(Xn, zn) {
  var Un, Kn = Xn.indexOf("E") - Xn.indexOf(".") - 1;
  if (Xn.match(/^#+0.0E\+0$/)) {
    if (zn == 0) return "0.0E+0";
    if (zn < 0) return "-" + write_num_exp2(Xn, -zn);
    var qn = Xn.indexOf(".");
    qn === -1 && (qn = Xn.indexOf("E"));
    var Jo = Math.floor(Math.log(zn) * Math.LOG10E) % qn;
    if (Jo < 0 && (Jo += qn), Un = (zn / Math.pow(10, Jo)).toPrecision(Kn + 1 + (qn + Jo) % qn), !Un.match(/[Ee]/)) {
      var pa = Math.floor(Math.log(zn) * Math.LOG10E);
      Un.indexOf(".") === -1 ? Un = Un.charAt(0) + "." + Un.substr(1) + "E+" + (pa - Un.length + Jo) : Un += "E+" + (pa - Jo), Un = Un.replace(/\+-/, "-");
    }
    Un = Un.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(ma, va, ba, _a) {
      return va + ba + _a.substr(0, (qn + Jo) % qn) + "." + _a.substr(Jo) + "E";
    });
  } else Un = zn.toExponential(Kn);
  return Xn.match(/E\+00$/) && Un.match(/e[+-]\d$/) && (Un = Un.substr(0, Un.length - 1) + "0" + Un.charAt(Un.length - 1)), Xn.match(/E\-/) && Un.match(/e\+/) && (Un = Un.replace(/e\+/, "e")), Un.replace("e", "E");
}
function write_num_int(Xn, zn, Un) {
  if (Xn.charCodeAt(0) === 40 && !zn.match(closeparen)) {
    var Kn = zn.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return Un >= 0 ? write_num_int("n", Kn, Un) : "(" + write_num_int("n", Kn, -Un) + ")";
  }
  if (zn.charCodeAt(zn.length - 1) === 44) return write_num_cm2(Xn, zn, Un);
  if (zn.indexOf("%") !== -1) return write_num_pct2(Xn, zn, Un);
  if (zn.indexOf("E") !== -1) return write_num_exp2(zn, Un);
  if (zn.charCodeAt(0) === 36) return "$" + write_num_int(Xn, zn.substr(zn.charAt(1) == " " ? 2 : 1), Un);
  var qn, Jo, pa, ma, va = Math.abs(Un), ba = Un < 0 ? "-" : "";
  if (zn.match(/^00+$/)) return ba + pad0(va, zn.length);
  if (zn.match(/^[#?]+$/))
    return qn = "" + Un, Un === 0 && (qn = ""), qn.length > zn.length ? qn : hashq(zn.substr(0, zn.length - qn.length)) + qn;
  if (Jo = zn.match(frac1)) return write_num_f2(Jo, va, ba);
  if (zn.match(/^#+0+$/)) return ba + pad0(va, zn.length - zn.indexOf("0"));
  if (Jo = zn.match(dec1))
    return qn = ("" + Un).replace(/^([^\.]+)$/, "$1." + hashq(Jo[1])).replace(/\.$/, "." + hashq(Jo[1])), qn = qn.replace(/\.(\d*)$/, function(Ta, Sa) {
      return "." + Sa + fill$1("0", hashq(Jo[1]).length - Sa.length);
    }), zn.indexOf("0.") !== -1 ? qn : qn.replace(/^0\./, ".");
  if (zn = zn.replace(/^#+([0.])/, "$1"), Jo = zn.match(/^(0*)\.(#*)$/))
    return ba + ("" + va).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, Jo[1].length ? "0." : ".");
  if (Jo = zn.match(/^#{1,3},##0(\.?)$/)) return ba + commaify("" + va);
  if (Jo = zn.match(/^#,##0\.([#0]*0)$/))
    return Un < 0 ? "-" + write_num_int(Xn, zn, -Un) : commaify("" + Un) + "." + fill$1("0", Jo[1].length);
  if (Jo = zn.match(/^#,#*,#0/)) return write_num_int(Xn, zn.replace(/^#,#*,/, ""), Un);
  if (Jo = zn.match(/^([0#]+)(\\?-([0#]+))+$/))
    return qn = _strrev(write_num_int(Xn, zn.replace(/[\\-]/g, ""), Un)), pa = 0, _strrev(_strrev(zn.replace(/\\/g, "")).replace(/[0#]/g, function(Ta) {
      return pa < qn.length ? qn.charAt(pa++) : Ta === "0" ? "0" : "";
    }));
  if (zn.match(phone))
    return qn = write_num_int(Xn, "##########", Un), "(" + qn.substr(0, 3) + ") " + qn.substr(3, 3) + "-" + qn.substr(6);
  var _a = "";
  if (Jo = zn.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return pa = Math.min(
      /*::String(*/
      Jo[4].length,
      7
    ), ma = SSF_frac(va, Math.pow(10, pa) - 1, !1), qn = "" + ba, _a = write_num(
      "n",
      /*::String(*/
      Jo[1],
      ma[1]
    ), _a.charAt(_a.length - 1) == " " && (_a = _a.substr(0, _a.length - 1) + "0"), qn += _a + /*::String(*/
    Jo[2] + "/" + /*::String(*/
    Jo[3], _a = rpad_(ma[2], pa), _a.length < Jo[4].length && (_a = hashq(Jo[4].substr(Jo[4].length - _a.length)) + _a), qn += _a, qn;
  if (Jo = zn.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return pa = Math.min(Math.max(Jo[1].length, Jo[4].length), 7), ma = SSF_frac(va, Math.pow(10, pa) - 1, !0), ba + (ma[0] || (ma[1] ? "" : "0")) + " " + (ma[1] ? pad_(ma[1], pa) + Jo[2] + "/" + Jo[3] + rpad_(ma[2], pa) : fill$1(" ", 2 * pa + 1 + Jo[2].length + Jo[3].length));
  if (Jo = zn.match(/^[#0?]+$/))
    return qn = "" + Un, zn.length <= qn.length ? qn : hashq(zn.substr(0, zn.length - qn.length)) + qn;
  if (Jo = zn.match(/^([#0]+)\.([#0]+)$/)) {
    qn = "" + Un.toFixed(Math.min(Jo[2].length, 10)).replace(/([^0])0+$/, "$1"), pa = qn.indexOf(".");
    var ya = zn.indexOf(".") - pa, xa = zn.length - qn.length - ya;
    return hashq(zn.substr(0, ya) + qn + zn.substr(zn.length - xa));
  }
  if (Jo = zn.match(/^00,000\.([#0]*0)$/))
    return Un < 0 ? "-" + write_num_int(Xn, zn, -Un) : commaify("" + Un).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(Ta) {
      return "00," + (Ta.length < 3 ? pad0(0, 3 - Ta.length) : "") + Ta;
    }) + "." + pad0(0, Jo[1].length);
  switch (zn) {
    case "###,###":
    case "##,###":
    case "#,###":
      var wa = commaify("" + va);
      return wa !== "0" ? ba + wa : "";
    default:
      if (zn.match(/\.[0#?]*$/)) return write_num_int(Xn, zn.slice(0, zn.lastIndexOf(".")), Un) + hashq(zn.slice(zn.lastIndexOf(".")));
  }
  throw new Error("unsupported format |" + zn + "|");
}
function write_num(Xn, zn, Un) {
  return (Un | 0) === Un ? write_num_int(Xn, zn, Un) : write_num_flt(Xn, zn, Un);
}
function SSF_split_fmt(Xn) {
  for (var zn = [], Un = !1, Kn = 0, qn = 0; Kn < Xn.length; ++Kn) switch (
    /*cc=*/
    Xn.charCodeAt(Kn)
  ) {
    case 34:
      Un = !Un;
      break;
    case 95:
    case 42:
    case 92:
      ++Kn;
      break;
    case 59:
      zn[zn.length] = Xn.substr(qn, Kn - qn), qn = Kn + 1;
  }
  if (zn[zn.length] = Xn.substr(qn), Un === !0) throw new Error("Format |" + Xn + "| unterminated string ");
  return zn;
}
var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function fmt_is_date(Xn) {
  for (var zn = 0, Un = "", Kn = ""; zn < Xn.length; )
    switch (Un = Xn.charAt(zn)) {
      case "G":
        SSF_isgeneral(Xn, zn) && (zn += 6), zn++;
        break;
      case '"':
        for (
          ;
          /*cc=*/
          Xn.charCodeAt(++zn) !== 34 && zn < Xn.length;
        )
          ;
        ++zn;
        break;
      case "\\":
        zn += 2;
        break;
      case "_":
        zn += 2;
        break;
      case "@":
        ++zn;
        break;
      case "B":
      case "b":
        if (Xn.charAt(zn + 1) === "1" || Xn.charAt(zn + 1) === "2") return !0;
      /* falls through */
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
      /* falls through */
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        return !0;
      case "A":
      case "a":
      case "上":
        if (Xn.substr(zn, 3).toUpperCase() === "A/P" || Xn.substr(zn, 5).toUpperCase() === "AM/PM" || Xn.substr(zn, 5).toUpperCase() === "上午/下午") return !0;
        ++zn;
        break;
      case "[":
        for (Kn = Un; Xn.charAt(zn++) !== "]" && zn < Xn.length; ) Kn += Xn.charAt(zn);
        if (Kn.match(SSF_abstime)) return !0;
        break;
      case ".":
      /* falls through */
      case "0":
      case "#":
        for (; zn < Xn.length && ("0#?.,E+-%".indexOf(Un = Xn.charAt(++zn)) > -1 || Un == "\\" && Xn.charAt(zn + 1) == "-" && "0#".indexOf(Xn.charAt(zn + 2)) > -1); )
          ;
        break;
      case "?":
        for (; Xn.charAt(++zn) === Un; )
          ;
        break;
      case "*":
        ++zn, (Xn.charAt(zn) == " " || Xn.charAt(zn) == "*") && ++zn;
        break;
      case "(":
      case ")":
        ++zn;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (; zn < Xn.length && "0123456789".indexOf(Xn.charAt(++zn)) > -1; )
          ;
        break;
      case " ":
        ++zn;
        break;
      default:
        ++zn;
        break;
    }
  return !1;
}
function eval_fmt(Xn, zn, Un, Kn) {
  for (var qn = [], Jo = "", pa = 0, ma = "", va = "t", ba, _a, ya, xa = "H"; pa < Xn.length; )
    switch (ma = Xn.charAt(pa)) {
      case "G":
        if (!SSF_isgeneral(Xn, pa)) throw new Error("unrecognized character " + ma + " in " + Xn);
        qn[qn.length] = { t: "G", v: "General" }, pa += 7;
        break;
      case '"':
        for (Jo = ""; (ya = Xn.charCodeAt(++pa)) !== 34 && pa < Xn.length; ) Jo += String.fromCharCode(ya);
        qn[qn.length] = { t: "t", v: Jo }, ++pa;
        break;
      case "\\":
        var wa = Xn.charAt(++pa), Ta = wa === "(" || wa === ")" ? wa : "t";
        qn[qn.length] = { t: Ta, v: wa }, ++pa;
        break;
      case "_":
        qn[qn.length] = { t: "t", v: " " }, pa += 2;
        break;
      case "@":
        qn[qn.length] = { t: "T", v: zn }, ++pa;
        break;
      case "B":
      case "b":
        if (Xn.charAt(pa + 1) === "1" || Xn.charAt(pa + 1) === "2") {
          if (ba == null && (ba = SSF_parse_date_code(zn, Un, Xn.charAt(pa + 1) === "2"), ba == null))
            return "";
          qn[qn.length] = { t: "X", v: Xn.substr(pa, 2) }, va = ma, pa += 2;
          break;
        }
      /* falls through */
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
        ma = ma.toLowerCase();
      /* falls through */
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        if (zn < 0 || ba == null && (ba = SSF_parse_date_code(zn, Un), ba == null))
          return "";
        for (Jo = ma; ++pa < Xn.length && Xn.charAt(pa).toLowerCase() === ma; ) Jo += ma;
        ma === "m" && va.toLowerCase() === "h" && (ma = "M"), ma === "h" && (ma = xa), qn[qn.length] = { t: ma, v: Jo }, va = ma;
        break;
      case "A":
      case "a":
      case "上":
        var Sa = { t: ma, v: ma };
        if (ba == null && (ba = SSF_parse_date_code(zn, Un)), Xn.substr(pa, 3).toUpperCase() === "A/P" ? (ba != null && (Sa.v = ba.H >= 12 ? "P" : "A"), Sa.t = "T", xa = "h", pa += 3) : Xn.substr(pa, 5).toUpperCase() === "AM/PM" ? (ba != null && (Sa.v = ba.H >= 12 ? "PM" : "AM"), Sa.t = "T", pa += 5, xa = "h") : Xn.substr(pa, 5).toUpperCase() === "上午/下午" ? (ba != null && (Sa.v = ba.H >= 12 ? "下午" : "上午"), Sa.t = "T", pa += 5, xa = "h") : (Sa.t = "t", ++pa), ba == null && Sa.t === "T") return "";
        qn[qn.length] = Sa, va = ma;
        break;
      case "[":
        for (Jo = ma; Xn.charAt(pa++) !== "]" && pa < Xn.length; ) Jo += Xn.charAt(pa);
        if (Jo.slice(-1) !== "]") throw 'unterminated "[" block: |' + Jo + "|";
        if (Jo.match(SSF_abstime)) {
          if (ba == null && (ba = SSF_parse_date_code(zn, Un), ba == null))
            return "";
          qn[qn.length] = { t: "Z", v: Jo.toLowerCase() }, va = Jo.charAt(1);
        } else Jo.indexOf("$") > -1 && (Jo = (Jo.match(/\$([^-\[\]]*)/) || [])[1] || "$", fmt_is_date(Xn) || (qn[qn.length] = { t: "t", v: Jo }));
        break;
      /* Numbers */
      case ".":
        if (ba != null) {
          for (Jo = ma; ++pa < Xn.length && (ma = Xn.charAt(pa)) === "0"; ) Jo += ma;
          qn[qn.length] = { t: "s", v: Jo };
          break;
        }
      /* falls through */
      case "0":
      case "#":
        for (Jo = ma; ++pa < Xn.length && "0#?.,E+-%".indexOf(ma = Xn.charAt(pa)) > -1; ) Jo += ma;
        qn[qn.length] = { t: "n", v: Jo };
        break;
      case "?":
        for (Jo = ma; Xn.charAt(++pa) === ma; ) Jo += ma;
        qn[qn.length] = { t: ma, v: Jo }, va = ma;
        break;
      case "*":
        ++pa, (Xn.charAt(pa) == " " || Xn.charAt(pa) == "*") && ++pa;
        break;
      // **
      case "(":
      case ")":
        qn[qn.length] = { t: Kn === 1 ? "t" : ma, v: ma }, ++pa;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (Jo = ma; pa < Xn.length && "0123456789".indexOf(Xn.charAt(++pa)) > -1; ) Jo += Xn.charAt(pa);
        qn[qn.length] = { t: "D", v: Jo };
        break;
      case " ":
        qn[qn.length] = { t: ma, v: ma }, ++pa;
        break;
      case "$":
        qn[qn.length] = { t: "t", v: "$" }, ++pa;
        break;
      default:
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(ma) === -1) throw new Error("unrecognized character " + ma + " in " + Xn);
        qn[qn.length] = { t: "t", v: ma }, ++pa;
        break;
    }
  var Ma = 0, ka = 0, Za;
  for (pa = qn.length - 1, va = "t"; pa >= 0; --pa)
    switch (qn[pa].t) {
      case "h":
      case "H":
        qn[pa].t = xa, va = "h", Ma < 1 && (Ma = 1);
        break;
      case "s":
        (Za = qn[pa].v.match(/\.0+$/)) && (ka = Math.max(ka, Za[0].length - 1)), Ma < 3 && (Ma = 3);
      /* falls through */
      case "d":
      case "y":
      case "M":
      case "e":
        va = qn[pa].t;
        break;
      case "m":
        va === "s" && (qn[pa].t = "M", Ma < 2 && (Ma = 2));
        break;
      case "X":
        break;
      case "Z":
        Ma < 1 && qn[pa].v.match(/[Hh]/) && (Ma = 1), Ma < 2 && qn[pa].v.match(/[Mm]/) && (Ma = 2), Ma < 3 && qn[pa].v.match(/[Ss]/) && (Ma = 3);
    }
  switch (Ma) {
    case 0:
      break;
    case 1:
      ba.u >= 0.5 && (ba.u = 0, ++ba.S), ba.S >= 60 && (ba.S = 0, ++ba.M), ba.M >= 60 && (ba.M = 0, ++ba.H);
      break;
    case 2:
      ba.u >= 0.5 && (ba.u = 0, ++ba.S), ba.S >= 60 && (ba.S = 0, ++ba.M);
      break;
  }
  var Na = "", Ka;
  for (pa = 0; pa < qn.length; ++pa)
    switch (qn[pa].t) {
      case "t":
      case "T":
      case " ":
      case "D":
        break;
      case "X":
        qn[pa].v = "", qn[pa].t = ";";
        break;
      case "d":
      case "m":
      case "y":
      case "h":
      case "H":
      case "M":
      case "s":
      case "e":
      case "b":
      case "Z":
        qn[pa].v = SSF_write_date(qn[pa].t.charCodeAt(0), qn[pa].v, ba, ka), qn[pa].t = "t";
        break;
      case "n":
      case "?":
        for (Ka = pa + 1; qn[Ka] != null && ((ma = qn[Ka].t) === "?" || ma === "D" || (ma === " " || ma === "t") && qn[Ka + 1] != null && (qn[Ka + 1].t === "?" || qn[Ka + 1].t === "t" && qn[Ka + 1].v === "/") || qn[pa].t === "(" && (ma === " " || ma === "n" || ma === ")") || ma === "t" && (qn[Ka].v === "/" || qn[Ka].v === " " && qn[Ka + 1] != null && qn[Ka + 1].t == "?")); )
          qn[pa].v += qn[Ka].v, qn[Ka] = { v: "", t: ";" }, ++Ka;
        Na += qn[pa].v, pa = Ka - 1;
        break;
      case "G":
        qn[pa].t = "t", qn[pa].v = SSF_general(zn, Un);
        break;
    }
  var Ja = "", el, qa;
  if (Na.length > 0) {
    Na.charCodeAt(0) == 40 ? (el = zn < 0 && Na.charCodeAt(0) === 45 ? -zn : zn, qa = write_num("n", Na, el)) : (el = zn < 0 && Kn > 1 ? -zn : zn, qa = write_num("n", Na, el), el < 0 && qn[0] && qn[0].t == "t" && (qa = qa.substr(1), qn[0].v = "-" + qn[0].v)), Ka = qa.length - 1;
    var tl = qn.length;
    for (pa = 0; pa < qn.length; ++pa) if (qn[pa] != null && qn[pa].t != "t" && qn[pa].v.indexOf(".") > -1) {
      tl = pa;
      break;
    }
    var Qa = qn.length;
    if (tl === qn.length && qa.indexOf("E") === -1) {
      for (pa = qn.length - 1; pa >= 0; --pa)
        qn[pa] == null || "n?".indexOf(qn[pa].t) === -1 || (Ka >= qn[pa].v.length - 1 ? (Ka -= qn[pa].v.length, qn[pa].v = qa.substr(Ka + 1, qn[pa].v.length)) : Ka < 0 ? qn[pa].v = "" : (qn[pa].v = qa.substr(0, Ka + 1), Ka = -1), qn[pa].t = "t", Qa = pa);
      Ka >= 0 && Qa < qn.length && (qn[Qa].v = qa.substr(0, Ka + 1) + qn[Qa].v);
    } else if (tl !== qn.length && qa.indexOf("E") === -1) {
      for (Ka = qa.indexOf(".") - 1, pa = tl; pa >= 0; --pa)
        if (!(qn[pa] == null || "n?".indexOf(qn[pa].t) === -1)) {
          for (_a = qn[pa].v.indexOf(".") > -1 && pa === tl ? qn[pa].v.indexOf(".") - 1 : qn[pa].v.length - 1, Ja = qn[pa].v.substr(_a + 1); _a >= 0; --_a)
            Ka >= 0 && (qn[pa].v.charAt(_a) === "0" || qn[pa].v.charAt(_a) === "#") && (Ja = qa.charAt(Ka--) + Ja);
          qn[pa].v = Ja, qn[pa].t = "t", Qa = pa;
        }
      for (Ka >= 0 && Qa < qn.length && (qn[Qa].v = qa.substr(0, Ka + 1) + qn[Qa].v), Ka = qa.indexOf(".") + 1, pa = tl; pa < qn.length; ++pa)
        if (!(qn[pa] == null || "n?(".indexOf(qn[pa].t) === -1 && pa !== tl)) {
          for (_a = qn[pa].v.indexOf(".") > -1 && pa === tl ? qn[pa].v.indexOf(".") + 1 : 0, Ja = qn[pa].v.substr(0, _a); _a < qn[pa].v.length; ++_a)
            Ka < qa.length && (Ja += qa.charAt(Ka++));
          qn[pa].v = Ja, qn[pa].t = "t", Qa = pa;
        }
    }
  }
  for (pa = 0; pa < qn.length; ++pa) qn[pa] != null && "n?".indexOf(qn[pa].t) > -1 && (el = Kn > 1 && zn < 0 && pa > 0 && qn[pa - 1].v === "-" ? -zn : zn, qn[pa].v = write_num(qn[pa].t, qn[pa].v, el), qn[pa].t = "t");
  var nl = "";
  for (pa = 0; pa !== qn.length; ++pa) qn[pa] != null && (nl += qn[pa].v);
  return nl;
}
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(Xn, zn) {
  if (zn == null) return !1;
  var Un = parseFloat(zn[2]);
  switch (zn[1]) {
    case "=":
      if (Xn == Un) return !0;
      break;
    case ">":
      if (Xn > Un) return !0;
      break;
    case "<":
      if (Xn < Un) return !0;
      break;
    case "<>":
      if (Xn != Un) return !0;
      break;
    case ">=":
      if (Xn >= Un) return !0;
      break;
    case "<=":
      if (Xn <= Un) return !0;
      break;
  }
  return !1;
}
function choose_fmt(Xn, zn) {
  var Un = SSF_split_fmt(Xn), Kn = Un.length, qn = Un[Kn - 1].indexOf("@");
  if (Kn < 4 && qn > -1 && --Kn, Un.length > 4) throw new Error("cannot find right format for |" + Un.join("|") + "|");
  if (typeof zn != "number") return [4, Un.length === 4 || qn > -1 ? Un[Un.length - 1] : "@"];
  switch (Un.length) {
    case 1:
      Un = qn > -1 ? ["General", "General", "General", Un[0]] : [Un[0], Un[0], Un[0], "@"];
      break;
    case 2:
      Un = qn > -1 ? [Un[0], Un[0], Un[0], Un[1]] : [Un[0], Un[1], Un[0], "@"];
      break;
    case 3:
      Un = qn > -1 ? [Un[0], Un[1], Un[0], Un[2]] : [Un[0], Un[1], Un[2], "@"];
      break;
  }
  var Jo = zn > 0 ? Un[0] : zn < 0 ? Un[1] : Un[2];
  if (Un[0].indexOf("[") === -1 && Un[1].indexOf("[") === -1) return [Kn, Jo];
  if (Un[0].match(/\[[=<>]/) != null || Un[1].match(/\[[=<>]/) != null) {
    var pa = Un[0].match(cfregex2), ma = Un[1].match(cfregex2);
    return chkcond(zn, pa) ? [Kn, Un[0]] : chkcond(zn, ma) ? [Kn, Un[1]] : [Kn, Un[pa != null && ma != null ? 2 : 1]];
  }
  return [Kn, Jo];
}
function SSF_format(Xn, zn, Un) {
  Un == null && (Un = {});
  var Kn = "";
  switch (typeof Xn) {
    case "string":
      Xn == "m/d/yy" && Un.dateNF ? Kn = Un.dateNF : Kn = Xn;
      break;
    case "number":
      Xn == 14 && Un.dateNF ? Kn = Un.dateNF : Kn = (Un.table != null ? Un.table : table_fmt)[Xn], Kn == null && (Kn = Un.table && Un.table[SSF_default_map[Xn]] || table_fmt[SSF_default_map[Xn]]), Kn == null && (Kn = SSF_default_str[Xn] || "General");
      break;
  }
  if (SSF_isgeneral(Kn, 0)) return SSF_general(zn, Un);
  zn instanceof Date && (zn = datenum_local(zn, Un.date1904));
  var qn = choose_fmt(Kn, zn);
  if (SSF_isgeneral(qn[1])) return SSF_general(zn, Un);
  if (zn === !0) zn = "TRUE";
  else if (zn === !1) zn = "FALSE";
  else if (zn === "" || zn == null) return "";
  return eval_fmt(qn[1], zn, Un, qn[0]);
}
function SSF_load(Xn, zn) {
  if (typeof zn != "number") {
    zn = +zn || -1;
    for (var Un = 0; Un < 392; ++Un) {
      if (table_fmt[Un] == null) {
        zn < 0 && (zn = Un);
        continue;
      }
      if (table_fmt[Un] == Xn) {
        zn = Un;
        break;
      }
    }
    zn < 0 && (zn = 391);
  }
  return table_fmt[zn] = Xn, zn;
}
function make_ssf() {
  table_fmt = SSF_init_table();
}
var SSFImplicit = {
  5: '"$"#,##0_);\\("$"#,##0\\)',
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  23: "General",
  24: "General",
  25: "General",
  26: "General",
  27: "m/d/yy",
  28: "m/d/yy",
  29: "m/d/yy",
  30: "m/d/yy",
  31: "m/d/yy",
  32: "h:mm:ss",
  33: "h:mm:ss",
  34: "h:mm:ss",
  35: "h:mm:ss",
  36: "m/d/yy",
  41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
  42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
  43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
  44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
  50: "m/d/yy",
  51: "m/d/yy",
  52: "m/d/yy",
  53: "m/d/yy",
  54: "m/d/yy",
  55: "m/d/yy",
  56: "m/d/yy",
  57: "m/d/yy",
  58: "m/d/yy",
  59: "0",
  60: "0.00",
  61: "#,##0",
  62: "#,##0.00",
  63: '"$"#,##0_);\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  67: "0%",
  68: "0.00%",
  69: "# ?/?",
  70: "# ??/??",
  71: "m/d/yy",
  72: "m/d/yy",
  73: "d-mmm-yy",
  74: "d-mmm",
  75: "mmm-yy",
  76: "h:mm",
  77: "h:mm:ss",
  78: "m/d/yy h:mm",
  79: "mm:ss",
  80: "[h]:mm:ss",
  81: "mmss.0"
}, dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(Xn) {
  var zn = typeof Xn == "number" ? table_fmt[Xn] : Xn;
  return zn = zn.replace(dateNFregex, "(\\d+)"), new RegExp("^" + zn + "$");
}
function dateNF_fix(Xn, zn, Un) {
  var Kn = -1, qn = -1, Jo = -1, pa = -1, ma = -1, va = -1;
  (zn.match(dateNFregex) || []).forEach(function(ya, xa) {
    var wa = parseInt(Un[xa + 1], 10);
    switch (ya.toLowerCase().charAt(0)) {
      case "y":
        Kn = wa;
        break;
      case "d":
        Jo = wa;
        break;
      case "h":
        pa = wa;
        break;
      case "s":
        va = wa;
        break;
      case "m":
        pa >= 0 ? ma = wa : qn = wa;
        break;
    }
  }), va >= 0 && ma == -1 && qn >= 0 && (ma = qn, qn = -1);
  var ba = ("" + (Kn >= 0 ? Kn : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (qn >= 1 ? qn : 1)).slice(-2) + "-" + ("00" + (Jo >= 1 ? Jo : 1)).slice(-2);
  ba.length == 7 && (ba = "0" + ba), ba.length == 8 && (ba = "20" + ba);
  var _a = ("00" + (pa >= 0 ? pa : 0)).slice(-2) + ":" + ("00" + (ma >= 0 ? ma : 0)).slice(-2) + ":" + ("00" + (va >= 0 ? va : 0)).slice(-2);
  return pa == -1 && ma == -1 && va == -1 ? ba : Kn == -1 && qn == -1 && Jo == -1 ? _a : ba + "T" + _a;
}
var CRC32 = /* @__PURE__ */ function() {
  var Xn = {};
  Xn.version = "1.2.0";
  function zn() {
    for (var qa = 0, tl = new Array(256), Qa = 0; Qa != 256; ++Qa)
      qa = Qa, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, qa = qa & 1 ? -306674912 ^ qa >>> 1 : qa >>> 1, tl[Qa] = qa;
    return typeof Int32Array < "u" ? new Int32Array(tl) : tl;
  }
  var Un = zn();
  function Kn(qa) {
    var tl = 0, Qa = 0, nl = 0, rl = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
    for (nl = 0; nl != 256; ++nl) rl[nl] = qa[nl];
    for (nl = 0; nl != 256; ++nl)
      for (Qa = qa[nl], tl = 256 + nl; tl < 4096; tl += 256) Qa = rl[tl] = Qa >>> 8 ^ qa[Qa & 255];
    var il = [];
    for (nl = 1; nl != 16; ++nl) il[nl - 1] = typeof Int32Array < "u" ? rl.subarray(nl * 256, nl * 256 + 256) : rl.slice(nl * 256, nl * 256 + 256);
    return il;
  }
  var qn = Kn(Un), Jo = qn[0], pa = qn[1], ma = qn[2], va = qn[3], ba = qn[4], _a = qn[5], ya = qn[6], xa = qn[7], wa = qn[8], Ta = qn[9], Sa = qn[10], Ma = qn[11], ka = qn[12], Za = qn[13], Na = qn[14];
  function Ka(qa, tl) {
    for (var Qa = tl ^ -1, nl = 0, rl = qa.length; nl < rl; ) Qa = Qa >>> 8 ^ Un[(Qa ^ qa.charCodeAt(nl++)) & 255];
    return ~Qa;
  }
  function Ja(qa, tl) {
    for (var Qa = tl ^ -1, nl = qa.length - 15, rl = 0; rl < nl; ) Qa = Na[qa[rl++] ^ Qa & 255] ^ Za[qa[rl++] ^ Qa >> 8 & 255] ^ ka[qa[rl++] ^ Qa >> 16 & 255] ^ Ma[qa[rl++] ^ Qa >>> 24] ^ Sa[qa[rl++]] ^ Ta[qa[rl++]] ^ wa[qa[rl++]] ^ xa[qa[rl++]] ^ ya[qa[rl++]] ^ _a[qa[rl++]] ^ ba[qa[rl++]] ^ va[qa[rl++]] ^ ma[qa[rl++]] ^ pa[qa[rl++]] ^ Jo[qa[rl++]] ^ Un[qa[rl++]];
    for (nl += 15; rl < nl; ) Qa = Qa >>> 8 ^ Un[(Qa ^ qa[rl++]) & 255];
    return ~Qa;
  }
  function el(qa, tl) {
    for (var Qa = tl ^ -1, nl = 0, rl = qa.length, il = 0, cl = 0; nl < rl; )
      il = qa.charCodeAt(nl++), il < 128 ? Qa = Qa >>> 8 ^ Un[(Qa ^ il) & 255] : il < 2048 ? (Qa = Qa >>> 8 ^ Un[(Qa ^ (192 | il >> 6 & 31)) & 255], Qa = Qa >>> 8 ^ Un[(Qa ^ (128 | il & 63)) & 255]) : il >= 55296 && il < 57344 ? (il = (il & 1023) + 64, cl = qa.charCodeAt(nl++) & 1023, Qa = Qa >>> 8 ^ Un[(Qa ^ (240 | il >> 8 & 7)) & 255], Qa = Qa >>> 8 ^ Un[(Qa ^ (128 | il >> 2 & 63)) & 255], Qa = Qa >>> 8 ^ Un[(Qa ^ (128 | cl >> 6 & 15 | (il & 3) << 4)) & 255], Qa = Qa >>> 8 ^ Un[(Qa ^ (128 | cl & 63)) & 255]) : (Qa = Qa >>> 8 ^ Un[(Qa ^ (224 | il >> 12 & 15)) & 255], Qa = Qa >>> 8 ^ Un[(Qa ^ (128 | il >> 6 & 63)) & 255], Qa = Qa >>> 8 ^ Un[(Qa ^ (128 | il & 63)) & 255]);
    return ~Qa;
  }
  return Xn.table = Un, Xn.bstr = Ka, Xn.buf = Ja, Xn.str = el, Xn;
}(), CFB = /* @__PURE__ */ function() {
  var zn = {};
  zn.version = "1.2.1";
  function Un(Wl, ic) {
    for (var Xl = Wl.split("/"), Ql = ic.split("/"), ec = 0, rc = 0, dc = Math.min(Xl.length, Ql.length); ec < dc; ++ec) {
      if (rc = Xl[ec].length - Ql[ec].length) return rc;
      if (Xl[ec] != Ql[ec]) return Xl[ec] < Ql[ec] ? -1 : 1;
    }
    return Xl.length - Ql.length;
  }
  function Kn(Wl) {
    if (Wl.charAt(Wl.length - 1) == "/") return Wl.slice(0, -1).indexOf("/") === -1 ? Wl : Kn(Wl.slice(0, -1));
    var ic = Wl.lastIndexOf("/");
    return ic === -1 ? Wl : Wl.slice(0, ic + 1);
  }
  function qn(Wl) {
    if (Wl.charAt(Wl.length - 1) == "/") return qn(Wl.slice(0, -1));
    var ic = Wl.lastIndexOf("/");
    return ic === -1 ? Wl : Wl.slice(ic + 1);
  }
  function Jo(Wl, ic) {
    typeof ic == "string" && (ic = new Date(ic));
    var Xl = ic.getHours();
    Xl = Xl << 6 | ic.getMinutes(), Xl = Xl << 5 | ic.getSeconds() >>> 1, Wl.write_shift(2, Xl);
    var Ql = ic.getFullYear() - 1980;
    Ql = Ql << 4 | ic.getMonth() + 1, Ql = Ql << 5 | ic.getDate(), Wl.write_shift(2, Ql);
  }
  function pa(Wl) {
    var ic = Wl.read_shift(2) & 65535, Xl = Wl.read_shift(2) & 65535, Ql = /* @__PURE__ */ new Date(), ec = Xl & 31;
    Xl >>>= 5;
    var rc = Xl & 15;
    Xl >>>= 4, Ql.setMilliseconds(0), Ql.setFullYear(Xl + 1980), Ql.setMonth(rc - 1), Ql.setDate(ec);
    var dc = ic & 31;
    ic >>>= 5;
    var wc = ic & 63;
    return ic >>>= 6, Ql.setHours(ic), Ql.setMinutes(wc), Ql.setSeconds(dc << 1), Ql;
  }
  function ma(Wl) {
    prep_blob(Wl, 0);
    for (var ic = (
      /*::(*/
      {}
    ), Xl = 0; Wl.l <= Wl.length - 4; ) {
      var Ql = Wl.read_shift(2), ec = Wl.read_shift(2), rc = Wl.l + ec, dc = {};
      switch (Ql) {
        /* UNIX-style Timestamps */
        case 21589:
          Xl = Wl.read_shift(1), Xl & 1 && (dc.mtime = Wl.read_shift(4)), ec > 5 && (Xl & 2 && (dc.atime = Wl.read_shift(4)), Xl & 4 && (dc.ctime = Wl.read_shift(4))), dc.mtime && (dc.mt = new Date(dc.mtime * 1e3));
          break;
      }
      Wl.l = rc, ic[Ql] = dc;
    }
    return ic;
  }
  var va;
  function ba() {
    return va || (va = {});
  }
  function _a(Wl, ic) {
    if (Wl[0] == 80 && Wl[1] == 75) return bl(Wl, ic);
    if ((Wl[0] | 32) == 109 && (Wl[1] | 32) == 105) return Pc(Wl, ic);
    if (Wl.length < 512) throw new Error("CFB file size " + Wl.length + " < 512");
    var Xl = 3, Ql = 512, ec = 0, rc = 0, dc = 0, wc = 0, bc = 0, Cc = [], yc = (
      /*::(*/
      Wl.slice(0, 512)
    );
    prep_blob(yc, 0);
    var Oc = ya(yc);
    switch (Xl = Oc[0], Xl) {
      case 3:
        Ql = 512;
        break;
      case 4:
        Ql = 4096;
        break;
      case 0:
        if (Oc[1] == 0) return bl(Wl, ic);
      /* falls through */
      default:
        throw new Error("Major Version: Expected 3 or 4 saw " + Xl);
    }
    Ql !== 512 && (yc = /*::(*/
    Wl.slice(0, Ql), prep_blob(
      yc,
      28
      /* blob.l */
    ));
    var Mc = Wl.slice(0, Ql);
    xa(yc, Xl);
    var Bc = yc.read_shift(4, "i");
    if (Xl === 3 && Bc !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + Bc);
    yc.l += 4, dc = yc.read_shift(4, "i"), yc.l += 4, yc.chk("00100000", "Mini Stream Cutoff Size: "), wc = yc.read_shift(4, "i"), ec = yc.read_shift(4, "i"), bc = yc.read_shift(4, "i"), rc = yc.read_shift(4, "i");
    for (var Rc = -1, kc = 0; kc < 109 && (Rc = yc.read_shift(4, "i"), !(Rc < 0)); ++kc)
      Cc[kc] = Rc;
    var Xc = wa(Wl, Ql);
    Ma(bc, rc, Xc, Ql, Cc);
    var Ah = Za(Xc, dc, Cc, Ql);
    Ah[dc].name = "!Directory", ec > 0 && wc !== cl && (Ah[wc].name = "!MiniFAT"), Ah[Cc[0]].name = "!FAT", Ah.fat_addrs = Cc, Ah.ssz = Ql;
    var Fh = {}, kh = [], Pu = [], Du = [];
    Na(dc, Ah, Xc, kh, ec, Fh, Pu, wc), Ta(Pu, Du, kh), kh.shift();
    var Gu = {
      FileIndex: Pu,
      FullPaths: Du
    };
    return ic && ic.raw && (Gu.raw = { header: Mc, sectors: Xc }), Gu;
  }
  function ya(Wl) {
    if (Wl[Wl.l] == 80 && Wl[Wl.l + 1] == 75) return [0, 0];
    Wl.chk(ll, "Header Signature: "), Wl.l += 16;
    var ic = Wl.read_shift(2, "u");
    return [Wl.read_shift(2, "u"), ic];
  }
  function xa(Wl, ic) {
    var Xl = 9;
    switch (Wl.l += 2, Xl = Wl.read_shift(2)) {
      case 9:
        if (ic != 3) throw new Error("Sector Shift: Expected 9 saw " + Xl);
        break;
      case 12:
        if (ic != 4) throw new Error("Sector Shift: Expected 12 saw " + Xl);
        break;
      default:
        throw new Error("Sector Shift: Expected 9 or 12 saw " + Xl);
    }
    Wl.chk("0600", "Mini Sector Shift: "), Wl.chk("000000000000", "Reserved: ");
  }
  function wa(Wl, ic) {
    for (var Xl = Math.ceil(Wl.length / ic) - 1, Ql = [], ec = 1; ec < Xl; ++ec) Ql[ec - 1] = Wl.slice(ec * ic, (ec + 1) * ic);
    return Ql[Xl - 1] = Wl.slice(Xl * ic), Ql;
  }
  function Ta(Wl, ic, Xl) {
    for (var Ql = 0, ec = 0, rc = 0, dc = 0, wc = 0, bc = Xl.length, Cc = [], yc = []; Ql < bc; ++Ql)
      Cc[Ql] = yc[Ql] = Ql, ic[Ql] = Xl[Ql];
    for (; wc < yc.length; ++wc)
      Ql = yc[wc], ec = Wl[Ql].L, rc = Wl[Ql].R, dc = Wl[Ql].C, Cc[Ql] === Ql && (ec !== -1 && Cc[ec] !== ec && (Cc[Ql] = Cc[ec]), rc !== -1 && Cc[rc] !== rc && (Cc[Ql] = Cc[rc])), dc !== -1 && (Cc[dc] = Ql), ec !== -1 && Ql != Cc[Ql] && (Cc[ec] = Cc[Ql], yc.lastIndexOf(ec) < wc && yc.push(ec)), rc !== -1 && Ql != Cc[Ql] && (Cc[rc] = Cc[Ql], yc.lastIndexOf(rc) < wc && yc.push(rc));
    for (Ql = 1; Ql < bc; ++Ql) Cc[Ql] === Ql && (rc !== -1 && Cc[rc] !== rc ? Cc[Ql] = Cc[rc] : ec !== -1 && Cc[ec] !== ec && (Cc[Ql] = Cc[ec]));
    for (Ql = 1; Ql < bc; ++Ql)
      if (Wl[Ql].type !== 0) {
        if (wc = Ql, wc != Cc[wc]) do
          wc = Cc[wc], ic[Ql] = ic[wc] + "/" + ic[Ql];
        while (wc !== 0 && Cc[wc] !== -1 && wc != Cc[wc]);
        Cc[Ql] = -1;
      }
    for (ic[0] += "/", Ql = 1; Ql < bc; ++Ql)
      Wl[Ql].type !== 2 && (ic[Ql] += "/");
  }
  function Sa(Wl, ic, Xl) {
    for (var Ql = Wl.start, ec = Wl.size, rc = [], dc = Ql; Xl && ec > 0 && dc >= 0; )
      rc.push(ic.slice(dc * il, dc * il + il)), ec -= il, dc = __readInt32LE(Xl, dc * 4);
    return rc.length === 0 ? new_buf(0) : bconcat(rc).slice(0, Wl.size);
  }
  function Ma(Wl, ic, Xl, Ql, ec) {
    var rc = cl;
    if (Wl === cl) {
      if (ic !== 0) throw new Error("DIFAT chain shorter than expected");
    } else if (Wl !== -1) {
      var dc = Xl[Wl], wc = (Ql >>> 2) - 1;
      if (!dc) return;
      for (var bc = 0; bc < wc && (rc = __readInt32LE(dc, bc * 4)) !== cl; ++bc)
        ec.push(rc);
      Ma(__readInt32LE(dc, Ql - 4), ic - 1, Xl, Ql, ec);
    }
  }
  function ka(Wl, ic, Xl, Ql, ec) {
    var rc = [], dc = [];
    ec || (ec = []);
    var wc = Ql - 1, bc = 0, Cc = 0;
    for (bc = ic; bc >= 0; ) {
      ec[bc] = !0, rc[rc.length] = bc, dc.push(Wl[bc]);
      var yc = Xl[Math.floor(bc * 4 / Ql)];
      if (Cc = bc * 4 & wc, Ql < 4 + Cc) throw new Error("FAT boundary crossed: " + bc + " 4 " + Ql);
      if (!Wl[yc]) break;
      bc = __readInt32LE(Wl[yc], Cc);
    }
    return { nodes: rc, data: __toBuffer([dc]) };
  }
  function Za(Wl, ic, Xl, Ql) {
    var ec = Wl.length, rc = [], dc = [], wc = [], bc = [], Cc = Ql - 1, yc = 0, Oc = 0, Mc = 0, Bc = 0;
    for (yc = 0; yc < ec; ++yc)
      if (wc = [], Mc = yc + ic, Mc >= ec && (Mc -= ec), !dc[Mc]) {
        bc = [];
        var Rc = [];
        for (Oc = Mc; Oc >= 0; ) {
          Rc[Oc] = !0, dc[Oc] = !0, wc[wc.length] = Oc, bc.push(Wl[Oc]);
          var kc = Xl[Math.floor(Oc * 4 / Ql)];
          if (Bc = Oc * 4 & Cc, Ql < 4 + Bc) throw new Error("FAT boundary crossed: " + Oc + " 4 " + Ql);
          if (!Wl[kc] || (Oc = __readInt32LE(Wl[kc], Bc), Rc[Oc])) break;
        }
        rc[Mc] = { nodes: wc, data: __toBuffer([bc]) };
      }
    return rc;
  }
  function Na(Wl, ic, Xl, Ql, ec, rc, dc, wc) {
    for (var bc = 0, Cc = Ql.length ? 2 : 0, yc = ic[Wl].data, Oc = 0, Mc = 0, Bc; Oc < yc.length; Oc += 128) {
      var Rc = (
        /*::(*/
        yc.slice(Oc, Oc + 128)
      );
      prep_blob(Rc, 64), Mc = Rc.read_shift(2), Bc = __utf16le(Rc, 0, Mc - Cc), Ql.push(Bc);
      var kc = {
        name: Bc,
        type: Rc.read_shift(1),
        color: Rc.read_shift(1),
        L: Rc.read_shift(4, "i"),
        R: Rc.read_shift(4, "i"),
        C: Rc.read_shift(4, "i"),
        clsid: Rc.read_shift(16),
        state: Rc.read_shift(4, "i"),
        start: 0,
        size: 0
      }, Xc = Rc.read_shift(2) + Rc.read_shift(2) + Rc.read_shift(2) + Rc.read_shift(2);
      Xc !== 0 && (kc.ct = Ka(Rc, Rc.l - 8));
      var Ah = Rc.read_shift(2) + Rc.read_shift(2) + Rc.read_shift(2) + Rc.read_shift(2);
      Ah !== 0 && (kc.mt = Ka(Rc, Rc.l - 8)), kc.start = Rc.read_shift(4, "i"), kc.size = Rc.read_shift(4, "i"), kc.size < 0 && kc.start < 0 && (kc.size = kc.type = 0, kc.start = cl, kc.name = ""), kc.type === 5 ? (bc = kc.start, ec > 0 && bc !== cl && (ic[bc].name = "!StreamData")) : kc.size >= 4096 ? (kc.storage = "fat", ic[kc.start] === void 0 && (ic[kc.start] = ka(Xl, kc.start, ic.fat_addrs, ic.ssz)), ic[kc.start].name = kc.name, kc.content = ic[kc.start].data.slice(0, kc.size)) : (kc.storage = "minifat", kc.size < 0 ? kc.size = 0 : bc !== cl && kc.start !== cl && ic[bc] && (kc.content = Sa(kc, ic[bc].data, (ic[wc] || {}).data))), kc.content && prep_blob(kc.content, 0), rc[Bc] = kc, dc.push(kc);
    }
  }
  function Ka(Wl, ic) {
    return new Date((__readUInt32LE(Wl, ic + 4) / 1e7 * Math.pow(2, 32) + __readUInt32LE(Wl, ic) / 1e7 - 11644473600) * 1e3);
  }
  function Ja(Wl, ic) {
    return ba(), _a(va.readFileSync(Wl), ic);
  }
  function el(Wl, ic) {
    var Xl = ic && ic.type;
    switch (Xl || has_buf && Buffer.isBuffer(Wl) && (Xl = "buffer"), Xl || "base64") {
      case "file":
        return Ja(Wl, ic);
      case "base64":
        return _a(s2a(Base64_decode(Wl)), ic);
      case "binary":
        return _a(s2a(Wl), ic);
    }
    return _a(
      /*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */
      Wl,
      ic
    );
  }
  function qa(Wl, ic) {
    var Xl = ic || {}, Ql = Xl.root || "Root Entry";
    if (Wl.FullPaths || (Wl.FullPaths = []), Wl.FileIndex || (Wl.FileIndex = []), Wl.FullPaths.length !== Wl.FileIndex.length) throw new Error("inconsistent CFB structure");
    Wl.FullPaths.length === 0 && (Wl.FullPaths[0] = Ql + "/", Wl.FileIndex[0] = { name: Ql, type: 5 }), Xl.CLSID && (Wl.FileIndex[0].clsid = Xl.CLSID), tl(Wl);
  }
  function tl(Wl) {
    var ic = "Sh33tJ5";
    if (!CFB.find(Wl, "/" + ic)) {
      var Xl = new_buf(4);
      Xl[0] = 55, Xl[1] = Xl[3] = 50, Xl[2] = 54, Wl.FileIndex.push({ name: ic, type: 2, content: Xl, size: 4, L: 69, R: 69, C: 69 }), Wl.FullPaths.push(Wl.FullPaths[0] + ic), Qa(Wl);
    }
  }
  function Qa(Wl, ic) {
    qa(Wl);
    for (var Xl = !1, Ql = !1, ec = Wl.FullPaths.length - 1; ec >= 0; --ec) {
      var rc = Wl.FileIndex[ec];
      switch (rc.type) {
        case 0:
          Ql ? Xl = !0 : (Wl.FileIndex.pop(), Wl.FullPaths.pop());
          break;
        case 1:
        case 2:
        case 5:
          Ql = !0, isNaN(rc.R * rc.L * rc.C) && (Xl = !0), rc.R > -1 && rc.L > -1 && rc.R == rc.L && (Xl = !0);
          break;
        default:
          Xl = !0;
          break;
      }
    }
    if (!(!Xl && !ic)) {
      var dc = new Date(1987, 1, 19), wc = 0, bc = Object.create ? /* @__PURE__ */ Object.create(null) : {}, Cc = [];
      for (ec = 0; ec < Wl.FullPaths.length; ++ec)
        bc[Wl.FullPaths[ec]] = !0, Wl.FileIndex[ec].type !== 0 && Cc.push([Wl.FullPaths[ec], Wl.FileIndex[ec]]);
      for (ec = 0; ec < Cc.length; ++ec) {
        var yc = Kn(Cc[ec][0]);
        Ql = bc[yc], Ql || (Cc.push([yc, {
          name: qn(yc).replace("/", ""),
          type: 1,
          clsid: sl,
          ct: dc,
          mt: dc,
          content: null
        }]), bc[yc] = !0);
      }
      for (Cc.sort(function(Bc, Rc) {
        return Un(Bc[0], Rc[0]);
      }), Wl.FullPaths = [], Wl.FileIndex = [], ec = 0; ec < Cc.length; ++ec)
        Wl.FullPaths[ec] = Cc[ec][0], Wl.FileIndex[ec] = Cc[ec][1];
      for (ec = 0; ec < Cc.length; ++ec) {
        var Oc = Wl.FileIndex[ec], Mc = Wl.FullPaths[ec];
        if (Oc.name = qn(Mc).replace("/", ""), Oc.L = Oc.R = Oc.C = -(Oc.color = 1), Oc.size = Oc.content ? Oc.content.length : 0, Oc.start = 0, Oc.clsid = Oc.clsid || sl, ec === 0)
          Oc.C = Cc.length > 1 ? 1 : -1, Oc.size = 0, Oc.type = 5;
        else if (Mc.slice(-1) == "/") {
          for (wc = ec + 1; wc < Cc.length && Kn(Wl.FullPaths[wc]) != Mc; ++wc) ;
          for (Oc.C = wc >= Cc.length ? -1 : wc, wc = ec + 1; wc < Cc.length && Kn(Wl.FullPaths[wc]) != Kn(Mc); ++wc) ;
          Oc.R = wc >= Cc.length ? -1 : wc, Oc.type = 1;
        } else
          Kn(Wl.FullPaths[ec + 1] || "") == Kn(Mc) && (Oc.R = ec + 1), Oc.type = 2;
      }
    }
  }
  function nl(Wl, ic) {
    var Xl = ic || {};
    if (Xl.fileType == "mad") return Hc(Wl, Xl);
    switch (Qa(Wl), Xl.fileType) {
      case "zip":
        return Jl(Wl, Xl);
    }
    var Ql = function(Bc) {
      for (var Rc = 0, kc = 0, Xc = 0; Xc < Bc.FileIndex.length; ++Xc) {
        var Ah = Bc.FileIndex[Xc];
        if (Ah.content) {
          var Fh = Ah.content.length;
          Fh > 0 && (Fh < 4096 ? Rc += Fh + 63 >> 6 : kc += Fh + 511 >> 9);
        }
      }
      for (var kh = Bc.FullPaths.length + 3 >> 2, Pu = Rc + 7 >> 3, Du = Rc + 127 >> 7, Gu = Pu + kc + kh + Du, _u = Gu + 127 >> 7, u0 = _u <= 109 ? 0 : Math.ceil((_u - 109) / 127); Gu + _u + u0 + 127 >> 7 > _u; ) u0 = ++_u <= 109 ? 0 : Math.ceil((_u - 109) / 127);
      var du = [1, u0, _u, Du, kh, kc, Rc, 0];
      return Bc.FileIndex[0].size = Rc << 6, du[7] = (Bc.FileIndex[0].start = du[0] + du[1] + du[2] + du[3] + du[4] + du[5]) + (du[6] + 7 >> 3), du;
    }(Wl), ec = new_buf(Ql[7] << 9), rc = 0, dc = 0;
    {
      for (rc = 0; rc < 8; ++rc) ec.write_shift(1, al[rc]);
      for (rc = 0; rc < 8; ++rc) ec.write_shift(2, 0);
      for (ec.write_shift(2, 62), ec.write_shift(2, 3), ec.write_shift(2, 65534), ec.write_shift(2, 9), ec.write_shift(2, 6), rc = 0; rc < 3; ++rc) ec.write_shift(2, 0);
      for (ec.write_shift(4, 0), ec.write_shift(4, Ql[2]), ec.write_shift(4, Ql[0] + Ql[1] + Ql[2] + Ql[3] - 1), ec.write_shift(4, 0), ec.write_shift(4, 4096), ec.write_shift(4, Ql[3] ? Ql[0] + Ql[1] + Ql[2] - 1 : cl), ec.write_shift(4, Ql[3]), ec.write_shift(-4, Ql[1] ? Ql[0] - 1 : cl), ec.write_shift(4, Ql[1]), rc = 0; rc < 109; ++rc) ec.write_shift(-4, rc < Ql[2] ? Ql[1] + rc : -1);
    }
    if (Ql[1])
      for (dc = 0; dc < Ql[1]; ++dc) {
        for (; rc < 236 + dc * 127; ++rc) ec.write_shift(-4, rc < Ql[2] ? Ql[1] + rc : -1);
        ec.write_shift(-4, dc === Ql[1] - 1 ? cl : dc + 1);
      }
    var wc = function(Bc) {
      for (dc += Bc; rc < dc - 1; ++rc) ec.write_shift(-4, rc + 1);
      Bc && (++rc, ec.write_shift(-4, cl));
    };
    for (dc = rc = 0, dc += Ql[1]; rc < dc; ++rc) ec.write_shift(-4, dl.DIFSECT);
    for (dc += Ql[2]; rc < dc; ++rc) ec.write_shift(-4, dl.FATSECT);
    wc(Ql[3]), wc(Ql[4]);
    for (var bc = 0, Cc = 0, yc = Wl.FileIndex[0]; bc < Wl.FileIndex.length; ++bc)
      yc = Wl.FileIndex[bc], yc.content && (Cc = yc.content.length, !(Cc < 4096) && (yc.start = dc, wc(Cc + 511 >> 9)));
    for (wc(Ql[6] + 7 >> 3); ec.l & 511; ) ec.write_shift(-4, dl.ENDOFCHAIN);
    for (dc = rc = 0, bc = 0; bc < Wl.FileIndex.length; ++bc)
      yc = Wl.FileIndex[bc], yc.content && (Cc = yc.content.length, !(!Cc || Cc >= 4096) && (yc.start = dc, wc(Cc + 63 >> 6)));
    for (; ec.l & 511; ) ec.write_shift(-4, dl.ENDOFCHAIN);
    for (rc = 0; rc < Ql[4] << 2; ++rc) {
      var Oc = Wl.FullPaths[rc];
      if (!Oc || Oc.length === 0) {
        for (bc = 0; bc < 17; ++bc) ec.write_shift(4, 0);
        for (bc = 0; bc < 3; ++bc) ec.write_shift(4, -1);
        for (bc = 0; bc < 12; ++bc) ec.write_shift(4, 0);
        continue;
      }
      yc = Wl.FileIndex[rc], rc === 0 && (yc.start = yc.size ? yc.start - 1 : cl);
      var Mc = rc === 0 && Xl.root || yc.name;
      if (Cc = 2 * (Mc.length + 1), ec.write_shift(64, Mc, "utf16le"), ec.write_shift(2, Cc), ec.write_shift(1, yc.type), ec.write_shift(1, yc.color), ec.write_shift(-4, yc.L), ec.write_shift(-4, yc.R), ec.write_shift(-4, yc.C), yc.clsid) ec.write_shift(16, yc.clsid, "hex");
      else for (bc = 0; bc < 4; ++bc) ec.write_shift(4, 0);
      ec.write_shift(4, yc.state || 0), ec.write_shift(4, 0), ec.write_shift(4, 0), ec.write_shift(4, 0), ec.write_shift(4, 0), ec.write_shift(4, yc.start), ec.write_shift(4, yc.size), ec.write_shift(4, 0);
    }
    for (rc = 1; rc < Wl.FileIndex.length; ++rc)
      if (yc = Wl.FileIndex[rc], yc.size >= 4096)
        if (ec.l = yc.start + 1 << 9, has_buf && Buffer.isBuffer(yc.content))
          yc.content.copy(ec, ec.l, 0, yc.size), ec.l += yc.size + 511 & -512;
        else {
          for (bc = 0; bc < yc.size; ++bc) ec.write_shift(1, yc.content[bc]);
          for (; bc & 511; ++bc) ec.write_shift(1, 0);
        }
    for (rc = 1; rc < Wl.FileIndex.length; ++rc)
      if (yc = Wl.FileIndex[rc], yc.size > 0 && yc.size < 4096)
        if (has_buf && Buffer.isBuffer(yc.content))
          yc.content.copy(ec, ec.l, 0, yc.size), ec.l += yc.size + 63 & -64;
        else {
          for (bc = 0; bc < yc.size; ++bc) ec.write_shift(1, yc.content[bc]);
          for (; bc & 63; ++bc) ec.write_shift(1, 0);
        }
    if (has_buf)
      ec.l = ec.length;
    else
      for (; ec.l < ec.length; ) ec.write_shift(1, 0);
    return ec;
  }
  function rl(Wl, ic) {
    var Xl = Wl.FullPaths.map(function(bc) {
      return bc.toUpperCase();
    }), Ql = Xl.map(function(bc) {
      var Cc = bc.split("/");
      return Cc[Cc.length - (bc.slice(-1) == "/" ? 2 : 1)];
    }), ec = !1;
    ic.charCodeAt(0) === 47 ? (ec = !0, ic = Xl[0].slice(0, -1) + ic) : ec = ic.indexOf("/") !== -1;
    var rc = ic.toUpperCase(), dc = ec === !0 ? Xl.indexOf(rc) : Ql.indexOf(rc);
    if (dc !== -1) return Wl.FileIndex[dc];
    var wc = !rc.match(chr1);
    for (rc = rc.replace(chr0, ""), wc && (rc = rc.replace(chr1, "!")), dc = 0; dc < Xl.length; ++dc)
      if ((wc ? Xl[dc].replace(chr1, "!") : Xl[dc]).replace(chr0, "") == rc || (wc ? Ql[dc].replace(chr1, "!") : Ql[dc]).replace(chr0, "") == rc) return Wl.FileIndex[dc];
    return null;
  }
  var il = 64, cl = -2, ll = "d0cf11e0a1b11ae1", al = [208, 207, 17, 224, 161, 177, 26, 225], sl = "00000000000000000000000000000000", dl = {
    /* 2.1 Compund File Sector Numbers and Types */
    MAXREGSECT: -6,
    DIFSECT: -4,
    FATSECT: -3,
    ENDOFCHAIN: cl,
    FREESECT: -1,
    /* 2.2 Compound File Header */
    HEADER_SIGNATURE: ll,
    HEADER_MINOR_VERSION: "3e00",
    MAXREGSID: -6,
    NOSTREAM: -1,
    HEADER_CLSID: sl,
    /* 2.6.1 Compound File Directory Entry */
    EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
  };
  function El(Wl, ic, Xl) {
    ba();
    var Ql = nl(Wl, Xl);
    va.writeFileSync(ic, Ql);
  }
  function fl(Wl) {
    for (var ic = new Array(Wl.length), Xl = 0; Xl < Wl.length; ++Xl) ic[Xl] = String.fromCharCode(Wl[Xl]);
    return ic.join("");
  }
  function Ml(Wl, ic) {
    var Xl = nl(Wl, ic);
    switch (ic && ic.type || "buffer") {
      case "file":
        return ba(), va.writeFileSync(ic.filename, Xl), Xl;
      case "binary":
        return typeof Xl == "string" ? Xl : fl(Xl);
      case "base64":
        return Base64_encode(typeof Xl == "string" ? Xl : fl(Xl));
      case "buffer":
        if (has_buf) return Buffer.isBuffer(Xl) ? Xl : Buffer_from(Xl);
      /* falls through */
      case "array":
        return typeof Xl == "string" ? s2a(Xl) : Xl;
    }
    return Xl;
  }
  var Sl;
  function ml(Wl) {
    try {
      var ic = Wl.InflateRaw, Xl = new ic();
      if (Xl._processChunk(new Uint8Array([3, 0]), Xl._finishFlushFlag), Xl.bytesRead) Sl = Wl;
      else throw new Error("zlib does not expose bytesRead");
    } catch (Ql) {
      console.error("cannot use native zlib: " + (Ql.message || Ql));
    }
  }
  function Dl(Wl, ic) {
    if (!Sl) return Ol(Wl, ic);
    var Xl = Sl.InflateRaw, Ql = new Xl(), ec = Ql._processChunk(Wl.slice(Wl.l), Ql._finishFlushFlag);
    return Wl.l += Ql.bytesRead, ec;
  }
  function _l(Wl) {
    return Sl ? Sl.deflateRawSync(Wl) : Ec(Wl);
  }
  var gl = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], Fl = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], Nl = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  function zl(Wl) {
    var ic = (Wl << 1 | Wl << 11) & 139536 | (Wl << 5 | Wl << 15) & 558144;
    return (ic >> 16 | ic >> 8 | ic) & 255;
  }
  for (var Zl = typeof Uint8Array < "u", kl = Zl ? new Uint8Array(256) : [], ul = 0; ul < 256; ++ul) kl[ul] = zl(ul);
  function vl(Wl, ic) {
    var Xl = kl[Wl & 255];
    return ic <= 8 ? Xl >>> 8 - ic : (Xl = Xl << 8 | kl[Wl >> 8 & 255], ic <= 16 ? Xl >>> 16 - ic : (Xl = Xl << 8 | kl[Wl >> 16 & 255], Xl >>> 24 - ic));
  }
  function Tl(Wl, ic) {
    var Xl = ic & 7, Ql = ic >>> 3;
    return (Wl[Ql] | (Xl <= 6 ? 0 : Wl[Ql + 1] << 8)) >>> Xl & 3;
  }
  function wl(Wl, ic) {
    var Xl = ic & 7, Ql = ic >>> 3;
    return (Wl[Ql] | (Xl <= 5 ? 0 : Wl[Ql + 1] << 8)) >>> Xl & 7;
  }
  function yl(Wl, ic) {
    var Xl = ic & 7, Ql = ic >>> 3;
    return (Wl[Ql] | (Xl <= 4 ? 0 : Wl[Ql + 1] << 8)) >>> Xl & 15;
  }
  function Rl(Wl, ic) {
    var Xl = ic & 7, Ql = ic >>> 3;
    return (Wl[Ql] | (Xl <= 3 ? 0 : Wl[Ql + 1] << 8)) >>> Xl & 31;
  }
  function Ul(Wl, ic) {
    var Xl = ic & 7, Ql = ic >>> 3;
    return (Wl[Ql] | (Xl <= 1 ? 0 : Wl[Ql + 1] << 8)) >>> Xl & 127;
  }
  function hl(Wl, ic, Xl) {
    var Ql = ic & 7, ec = ic >>> 3, rc = (1 << Xl) - 1, dc = Wl[ec] >>> Ql;
    return Xl < 8 - Ql || (dc |= Wl[ec + 1] << 8 - Ql, Xl < 16 - Ql) || (dc |= Wl[ec + 2] << 16 - Ql, Xl < 24 - Ql) || (dc |= Wl[ec + 3] << 24 - Ql), dc & rc;
  }
  function Cl(Wl, ic, Xl) {
    var Ql = ic & 7, ec = ic >>> 3;
    return Ql <= 5 ? Wl[ec] |= (Xl & 7) << Ql : (Wl[ec] |= Xl << Ql & 255, Wl[ec + 1] = (Xl & 7) >> 8 - Ql), ic + 3;
  }
  function Il(Wl, ic, Xl) {
    var Ql = ic & 7, ec = ic >>> 3;
    return Xl = (Xl & 1) << Ql, Wl[ec] |= Xl, ic + 1;
  }
  function Ll(Wl, ic, Xl) {
    var Ql = ic & 7, ec = ic >>> 3;
    return Xl <<= Ql, Wl[ec] |= Xl & 255, Xl >>>= 8, Wl[ec + 1] = Xl, ic + 8;
  }
  function tc(Wl, ic, Xl) {
    var Ql = ic & 7, ec = ic >>> 3;
    return Xl <<= Ql, Wl[ec] |= Xl & 255, Xl >>>= 8, Wl[ec + 1] = Xl & 255, Wl[ec + 2] = Xl >>> 8, ic + 16;
  }
  function nc(Wl, ic) {
    var Xl = Wl.length, Ql = 2 * Xl > ic ? 2 * Xl : ic + 5, ec = 0;
    if (Xl >= ic) return Wl;
    if (has_buf) {
      var rc = new_unsafe_buf(Ql);
      if (Wl.copy) Wl.copy(rc);
      else for (; ec < Wl.length; ++ec) rc[ec] = Wl[ec];
      return rc;
    } else if (Zl) {
      var dc = new Uint8Array(Ql);
      if (dc.set) dc.set(Wl);
      else for (; ec < Xl; ++ec) dc[ec] = Wl[ec];
      return dc;
    }
    return Wl.length = Ql, Wl;
  }
  function uc(Wl) {
    for (var ic = new Array(Wl), Xl = 0; Xl < Wl; ++Xl) ic[Xl] = 0;
    return ic;
  }
  function _c(Wl, ic, Xl) {
    var Ql = 1, ec = 0, rc = 0, dc = 0, wc = 0, bc = Wl.length, Cc = Zl ? new Uint16Array(32) : uc(32);
    for (rc = 0; rc < 32; ++rc) Cc[rc] = 0;
    for (rc = bc; rc < Xl; ++rc) Wl[rc] = 0;
    bc = Wl.length;
    var yc = Zl ? new Uint16Array(bc) : uc(bc);
    for (rc = 0; rc < bc; ++rc)
      Cc[ec = Wl[rc]]++, Ql < ec && (Ql = ec), yc[rc] = 0;
    for (Cc[0] = 0, rc = 1; rc <= Ql; ++rc) Cc[rc + 16] = wc = wc + Cc[rc - 1] << 1;
    for (rc = 0; rc < bc; ++rc)
      wc = Wl[rc], wc != 0 && (yc[rc] = Cc[wc + 16]++);
    var Oc = 0;
    for (rc = 0; rc < bc; ++rc)
      if (Oc = Wl[rc], Oc != 0)
        for (wc = vl(yc[rc], Ql) >> Ql - Oc, dc = (1 << Ql + 4 - Oc) - 1; dc >= 0; --dc)
          ic[wc | dc << Oc] = Oc & 15 | rc << 4;
    return Ql;
  }
  var mc = Zl ? new Uint16Array(512) : uc(512), Sc = Zl ? new Uint16Array(32) : uc(32);
  if (!Zl) {
    for (var hc = 0; hc < 512; ++hc) mc[hc] = 0;
    for (hc = 0; hc < 32; ++hc) Sc[hc] = 0;
  }
  (function() {
    for (var Wl = [], ic = 0; ic < 32; ic++) Wl.push(5);
    _c(Wl, Sc, 32);
    var Xl = [];
    for (ic = 0; ic <= 143; ic++) Xl.push(8);
    for (; ic <= 255; ic++) Xl.push(9);
    for (; ic <= 279; ic++) Xl.push(7);
    for (; ic <= 287; ic++) Xl.push(8);
    _c(Xl, mc, 288);
  })();
  var Lc = /* @__PURE__ */ function() {
    for (var ic = Zl ? new Uint8Array(32768) : [], Xl = 0, Ql = 0; Xl < Nl.length - 1; ++Xl)
      for (; Ql < Nl[Xl + 1]; ++Ql) ic[Ql] = Xl;
    for (; Ql < 32768; ++Ql) ic[Ql] = 29;
    var ec = Zl ? new Uint8Array(259) : [];
    for (Xl = 0, Ql = 0; Xl < Fl.length - 1; ++Xl)
      for (; Ql < Fl[Xl + 1]; ++Ql) ec[Ql] = Xl;
    function rc(wc, bc) {
      for (var Cc = 0; Cc < wc.length; ) {
        var yc = Math.min(65535, wc.length - Cc), Oc = Cc + yc == wc.length;
        for (bc.write_shift(1, +Oc), bc.write_shift(2, yc), bc.write_shift(2, ~yc & 65535); yc-- > 0; ) bc[bc.l++] = wc[Cc++];
      }
      return bc.l;
    }
    function dc(wc, bc) {
      for (var Cc = 0, yc = 0, Oc = Zl ? new Uint16Array(32768) : []; yc < wc.length; ) {
        var Mc = (
          /* data.length - boff; */
          Math.min(65535, wc.length - yc)
        );
        if (Mc < 10) {
          for (Cc = Cl(bc, Cc, +(yc + Mc == wc.length)), Cc & 7 && (Cc += 8 - (Cc & 7)), bc.l = Cc / 8 | 0, bc.write_shift(2, Mc), bc.write_shift(2, ~Mc & 65535); Mc-- > 0; ) bc[bc.l++] = wc[yc++];
          Cc = bc.l * 8;
          continue;
        }
        Cc = Cl(bc, Cc, +(yc + Mc == wc.length) + 2);
        for (var Bc = 0; Mc-- > 0; ) {
          var Rc = wc[yc];
          Bc = (Bc << 5 ^ Rc) & 32767;
          var kc = -1, Xc = 0;
          if ((kc = Oc[Bc]) && (kc |= yc & -32768, kc > yc && (kc -= 32768), kc < yc))
            for (; wc[kc + Xc] == wc[yc + Xc] && Xc < 250; ) ++Xc;
          if (Xc > 2) {
            Rc = ec[Xc], Rc <= 22 ? Cc = Ll(bc, Cc, kl[Rc + 1] >> 1) - 1 : (Ll(bc, Cc, 3), Cc += 5, Ll(bc, Cc, kl[Rc - 23] >> 5), Cc += 3);
            var Ah = Rc < 8 ? 0 : Rc - 4 >> 2;
            Ah > 0 && (tc(bc, Cc, Xc - Fl[Rc]), Cc += Ah), Rc = ic[yc - kc], Cc = Ll(bc, Cc, kl[Rc] >> 3), Cc -= 3;
            var Fh = Rc < 4 ? 0 : Rc - 2 >> 1;
            Fh > 0 && (tc(bc, Cc, yc - kc - Nl[Rc]), Cc += Fh);
            for (var kh = 0; kh < Xc; ++kh)
              Oc[Bc] = yc & 32767, Bc = (Bc << 5 ^ wc[yc]) & 32767, ++yc;
            Mc -= Xc - 1;
          } else
            Rc <= 143 ? Rc = Rc + 48 : Cc = Il(bc, Cc, 1), Cc = Ll(bc, Cc, kl[Rc]), Oc[Bc] = yc & 32767, ++yc;
        }
        Cc = Ll(bc, Cc, 0) - 1;
      }
      return bc.l = (Cc + 7) / 8 | 0, bc.l;
    }
    return function(bc, Cc) {
      return bc.length < 8 ? rc(bc, Cc) : dc(bc, Cc);
    };
  }();
  function Ec(Wl) {
    var ic = new_buf(50 + Math.floor(Wl.length * 1.1)), Xl = Lc(Wl, ic);
    return ic.slice(0, Xl);
  }
  var Hl = Zl ? new Uint16Array(32768) : uc(32768), fc = Zl ? new Uint16Array(32768) : uc(32768), lc = Zl ? new Uint16Array(128) : uc(128), Gl = 1, ql = 1;
  function Vl(Wl, ic) {
    var Xl = Rl(Wl, ic) + 257;
    ic += 5;
    var Ql = Rl(Wl, ic) + 1;
    ic += 5;
    var ec = yl(Wl, ic) + 4;
    ic += 4;
    for (var rc = 0, dc = Zl ? new Uint8Array(19) : uc(19), wc = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], bc = 1, Cc = Zl ? new Uint8Array(8) : uc(8), yc = Zl ? new Uint8Array(8) : uc(8), Oc = dc.length, Mc = 0; Mc < ec; ++Mc)
      dc[gl[Mc]] = rc = wl(Wl, ic), bc < rc && (bc = rc), Cc[rc]++, ic += 3;
    var Bc = 0;
    for (Cc[0] = 0, Mc = 1; Mc <= bc; ++Mc) yc[Mc] = Bc = Bc + Cc[Mc - 1] << 1;
    for (Mc = 0; Mc < Oc; ++Mc) (Bc = dc[Mc]) != 0 && (wc[Mc] = yc[Bc]++);
    var Rc = 0;
    for (Mc = 0; Mc < Oc; ++Mc)
      if (Rc = dc[Mc], Rc != 0) {
        Bc = kl[wc[Mc]] >> 8 - Rc;
        for (var kc = (1 << 7 - Rc) - 1; kc >= 0; --kc) lc[Bc | kc << Rc] = Rc & 7 | Mc << 3;
      }
    var Xc = [];
    for (bc = 1; Xc.length < Xl + Ql; )
      switch (Bc = lc[Ul(Wl, ic)], ic += Bc & 7, Bc >>>= 3) {
        case 16:
          for (rc = 3 + Tl(Wl, ic), ic += 2, Bc = Xc[Xc.length - 1]; rc-- > 0; ) Xc.push(Bc);
          break;
        case 17:
          for (rc = 3 + wl(Wl, ic), ic += 3; rc-- > 0; ) Xc.push(0);
          break;
        case 18:
          for (rc = 11 + Ul(Wl, ic), ic += 7; rc-- > 0; ) Xc.push(0);
          break;
        default:
          Xc.push(Bc), bc < Bc && (bc = Bc);
          break;
      }
    var Ah = Xc.slice(0, Xl), Fh = Xc.slice(Xl);
    for (Mc = Xl; Mc < 286; ++Mc) Ah[Mc] = 0;
    for (Mc = Ql; Mc < 30; ++Mc) Fh[Mc] = 0;
    return Gl = _c(Ah, Hl, 286), ql = _c(Fh, fc, 30), ic;
  }
  function Pl(Wl, ic) {
    if (Wl[0] == 3 && !(Wl[1] & 3))
      return [new_raw_buf(ic), 2];
    for (var Xl = 0, Ql = 0, ec = new_unsafe_buf(ic || 1 << 18), rc = 0, dc = ec.length >>> 0, wc = 0, bc = 0; (Ql & 1) == 0; ) {
      if (Ql = wl(Wl, Xl), Xl += 3, Ql >>> 1)
        Ql >> 1 == 1 ? (wc = 9, bc = 5) : (Xl = Vl(Wl, Xl), wc = Gl, bc = ql);
      else {
        Xl & 7 && (Xl += 8 - (Xl & 7));
        var Cc = Wl[Xl >>> 3] | Wl[(Xl >>> 3) + 1] << 8;
        if (Xl += 32, Cc > 0)
          for (!ic && dc < rc + Cc && (ec = nc(ec, rc + Cc), dc = ec.length); Cc-- > 0; )
            ec[rc++] = Wl[Xl >>> 3], Xl += 8;
        continue;
      }
      for (; ; ) {
        !ic && dc < rc + 32767 && (ec = nc(ec, rc + 32767), dc = ec.length);
        var yc = hl(Wl, Xl, wc), Oc = Ql >>> 1 == 1 ? mc[yc] : Hl[yc];
        if (Xl += Oc & 15, Oc >>>= 4, (Oc >>> 8 & 255) === 0) ec[rc++] = Oc;
        else {
          if (Oc == 256) break;
          Oc -= 257;
          var Mc = Oc < 8 ? 0 : Oc - 4 >> 2;
          Mc > 5 && (Mc = 0);
          var Bc = rc + Fl[Oc];
          Mc > 0 && (Bc += hl(Wl, Xl, Mc), Xl += Mc), yc = hl(Wl, Xl, bc), Oc = Ql >>> 1 == 1 ? Sc[yc] : fc[yc], Xl += Oc & 15, Oc >>>= 4;
          var Rc = Oc < 4 ? 0 : Oc - 2 >> 1, kc = Nl[Oc];
          for (Rc > 0 && (kc += hl(Wl, Xl, Rc), Xl += Rc), !ic && dc < Bc && (ec = nc(ec, Bc + 100), dc = ec.length); rc < Bc; )
            ec[rc] = ec[rc - kc], ++rc;
        }
      }
    }
    return ic ? [ec, Xl + 7 >>> 3] : [ec.slice(0, rc), Xl + 7 >>> 3];
  }
  function Ol(Wl, ic) {
    var Xl = Wl.slice(Wl.l || 0), Ql = Pl(Xl, ic);
    return Wl.l += Ql[1], Ql[0];
  }
  function cc(Wl, ic) {
    if (Wl)
      typeof console < "u" && console.error(ic);
    else throw new Error(ic);
  }
  function bl(Wl, ic) {
    var Xl = (
      /*::(*/
      Wl
    );
    prep_blob(Xl, 0);
    var Ql = [], ec = [], rc = {
      FileIndex: Ql,
      FullPaths: ec
    };
    qa(rc, { root: ic.root });
    for (var dc = Xl.length - 4; (Xl[dc] != 80 || Xl[dc + 1] != 75 || Xl[dc + 2] != 5 || Xl[dc + 3] != 6) && dc >= 0; ) --dc;
    Xl.l = dc + 4, Xl.l += 4;
    var wc = Xl.read_shift(2);
    Xl.l += 6;
    var bc = Xl.read_shift(4);
    for (Xl.l = bc, dc = 0; dc < wc; ++dc) {
      Xl.l += 20;
      var Cc = Xl.read_shift(4), yc = Xl.read_shift(4), Oc = Xl.read_shift(2), Mc = Xl.read_shift(2), Bc = Xl.read_shift(2);
      Xl.l += 8;
      var Rc = Xl.read_shift(4), kc = ma(
        /*::(*/
        Xl.slice(Xl.l + Oc, Xl.l + Oc + Mc)
        /*:: :any)*/
      );
      Xl.l += Oc + Mc + Bc;
      var Xc = Xl.l;
      Xl.l = Rc + 4, pl(Xl, Cc, yc, rc, kc), Xl.l = Xc;
    }
    return rc;
  }
  function pl(Wl, ic, Xl, Ql, ec) {
    Wl.l += 2;
    var rc = Wl.read_shift(2), dc = Wl.read_shift(2), wc = pa(Wl);
    if (rc & 8257) throw new Error("Unsupported ZIP encryption");
    for (var bc = Wl.read_shift(4), Cc = Wl.read_shift(4), yc = Wl.read_shift(4), Oc = Wl.read_shift(2), Mc = Wl.read_shift(2), Bc = "", Rc = 0; Rc < Oc; ++Rc) Bc += String.fromCharCode(Wl[Wl.l++]);
    if (Mc) {
      var kc = ma(
        /*::(*/
        Wl.slice(Wl.l, Wl.l + Mc)
        /*:: :any)*/
      );
      (kc[21589] || {}).mt && (wc = kc[21589].mt), ((ec || {})[21589] || {}).mt && (wc = ec[21589].mt);
    }
    Wl.l += Mc;
    var Xc = Wl.slice(Wl.l, Wl.l + Cc);
    switch (dc) {
      case 8:
        Xc = Dl(Wl, yc);
        break;
      case 0:
        break;
      // TODO: scan for magic number
      default:
        throw new Error("Unsupported ZIP Compression method " + dc);
    }
    var Ah = !1;
    rc & 8 && (bc = Wl.read_shift(4), bc == 134695760 && (bc = Wl.read_shift(4), Ah = !0), Cc = Wl.read_shift(4), yc = Wl.read_shift(4)), Cc != ic && cc(Ah, "Bad compressed size: " + ic + " != " + Cc), yc != Xl && cc(Ah, "Bad uncompressed size: " + Xl + " != " + yc), Nc(Ql, Bc, Xc, { unsafe: !0, mt: wc });
  }
  function Jl(Wl, ic) {
    var Xl = ic || {}, Ql = [], ec = [], rc = new_buf(1), dc = Xl.compression ? 8 : 0, wc = 0, bc = 0, Cc = 0, yc = 0, Oc = 0, Mc = Wl.FullPaths[0], Bc = Mc, Rc = Wl.FileIndex[0], kc = [], Xc = 0;
    for (bc = 1; bc < Wl.FullPaths.length; ++bc)
      if (Bc = Wl.FullPaths[bc].slice(Mc.length), Rc = Wl.FileIndex[bc], !(!Rc.size || !Rc.content || Bc == "Sh33tJ5")) {
        var Ah = yc, Fh = new_buf(Bc.length);
        for (Cc = 0; Cc < Bc.length; ++Cc) Fh.write_shift(1, Bc.charCodeAt(Cc) & 127);
        Fh = Fh.slice(0, Fh.l), kc[Oc] = CRC32.buf(
          /*::((*/
          Rc.content,
          0
        );
        var kh = Rc.content;
        dc == 8 && (kh = _l(kh)), rc = new_buf(30), rc.write_shift(4, 67324752), rc.write_shift(2, 20), rc.write_shift(2, wc), rc.write_shift(2, dc), Rc.mt ? Jo(rc, Rc.mt) : rc.write_shift(4, 0), rc.write_shift(-4, kc[Oc]), rc.write_shift(4, kh.length), rc.write_shift(
          4,
          /*::(*/
          Rc.content.length
        ), rc.write_shift(2, Fh.length), rc.write_shift(2, 0), yc += rc.length, Ql.push(rc), yc += Fh.length, Ql.push(Fh), yc += kh.length, Ql.push(kh), rc = new_buf(46), rc.write_shift(4, 33639248), rc.write_shift(2, 0), rc.write_shift(2, 20), rc.write_shift(2, wc), rc.write_shift(2, dc), rc.write_shift(4, 0), rc.write_shift(-4, kc[Oc]), rc.write_shift(4, kh.length), rc.write_shift(
          4,
          /*::(*/
          Rc.content.length
        ), rc.write_shift(2, Fh.length), rc.write_shift(2, 0), rc.write_shift(2, 0), rc.write_shift(2, 0), rc.write_shift(2, 0), rc.write_shift(4, 0), rc.write_shift(4, Ah), Xc += rc.l, ec.push(rc), Xc += Fh.length, ec.push(Fh), ++Oc;
      }
    return rc = new_buf(22), rc.write_shift(4, 101010256), rc.write_shift(2, 0), rc.write_shift(2, 0), rc.write_shift(2, Oc), rc.write_shift(2, Oc), rc.write_shift(4, Xc), rc.write_shift(4, yc), rc.write_shift(2, 0), bconcat([bconcat(Ql), bconcat(ec), rc]);
  }
  var Al = {
    htm: "text/html",
    xml: "text/xml",
    gif: "image/gif",
    jpg: "image/jpeg",
    png: "image/png",
    mso: "application/x-mso",
    thmx: "application/vnd.ms-officetheme",
    sh33tj5: "application/octet-stream"
  };
  function Bl(Wl, ic) {
    if (Wl.ctype) return Wl.ctype;
    var Xl = Wl.name || "", Ql = Xl.match(/\.([^\.]+)$/);
    return Ql && Al[Ql[1]] || ic && (Ql = (Xl = ic).match(/[\.\\]([^\.\\])+$/), Ql && Al[Ql[1]]) ? Al[Ql[1]] : "application/octet-stream";
  }
  function Kl(Wl) {
    for (var ic = Base64_encode(Wl), Xl = [], Ql = 0; Ql < ic.length; Ql += 76) Xl.push(ic.slice(Ql, Ql + 76));
    return Xl.join(`\r
`) + `\r
`;
  }
  function oc(Wl) {
    var ic = Wl.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(Cc) {
      var yc = Cc.charCodeAt(0).toString(16).toUpperCase();
      return "=" + (yc.length == 1 ? "0" + yc : yc);
    });
    ic = ic.replace(/ $/mg, "=20").replace(/\t$/mg, "=09"), ic.charAt(0) == `
` && (ic = "=0D" + ic.slice(1)), ic = ic.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, `
=0A`).replace(/([^\r\n])\n/mg, "$1=0A");
    for (var Xl = [], Ql = ic.split(`\r
`), ec = 0; ec < Ql.length; ++ec) {
      var rc = Ql[ec];
      if (rc.length == 0) {
        Xl.push("");
        continue;
      }
      for (var dc = 0; dc < rc.length; ) {
        var wc = 76, bc = rc.slice(dc, dc + wc);
        bc.charAt(wc - 1) == "=" ? wc-- : bc.charAt(wc - 2) == "=" ? wc -= 2 : bc.charAt(wc - 3) == "=" && (wc -= 3), bc = rc.slice(dc, dc + wc), dc += wc, dc < rc.length && (bc += "="), Xl.push(bc);
      }
    }
    return Xl.join(`\r
`);
  }
  function xc(Wl) {
    for (var ic = [], Xl = 0; Xl < Wl.length; ++Xl) {
      for (var Ql = Wl[Xl]; Xl <= Wl.length && Ql.charAt(Ql.length - 1) == "="; ) Ql = Ql.slice(0, Ql.length - 1) + Wl[++Xl];
      ic.push(Ql);
    }
    for (var ec = 0; ec < ic.length; ++ec) ic[ec] = ic[ec].replace(/[=][0-9A-Fa-f]{2}/g, function(rc) {
      return String.fromCharCode(parseInt(rc.slice(1), 16));
    });
    return s2a(ic.join(`\r
`));
  }
  function vc(Wl, ic, Xl) {
    for (var Ql = "", ec = "", rc = "", dc, wc = 0; wc < 10; ++wc) {
      var bc = ic[wc];
      if (!bc || bc.match(/^\s*$/)) break;
      var Cc = bc.match(/^(.*?):\s*([^\s].*)$/);
      if (Cc) switch (Cc[1].toLowerCase()) {
        case "content-location":
          Ql = Cc[2].trim();
          break;
        case "content-type":
          rc = Cc[2].trim();
          break;
        case "content-transfer-encoding":
          ec = Cc[2].trim();
          break;
      }
    }
    switch (++wc, ec.toLowerCase()) {
      case "base64":
        dc = s2a(Base64_decode(ic.slice(wc).join("")));
        break;
      case "quoted-printable":
        dc = xc(ic.slice(wc));
        break;
      default:
        throw new Error("Unsupported Content-Transfer-Encoding " + ec);
    }
    var yc = Nc(Wl, Ql.slice(Xl.length), dc, { unsafe: !0 });
    rc && (yc.ctype = rc);
  }
  function Pc(Wl, ic) {
    if (fl(Wl.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
    var Xl = ic && ic.root || "", Ql = (has_buf && Buffer.isBuffer(Wl) ? Wl.toString("binary") : fl(Wl)).split(`\r
`), ec = 0, rc = "";
    for (ec = 0; ec < Ql.length; ++ec)
      if (rc = Ql[ec], !!/^Content-Location:/i.test(rc) && (rc = rc.slice(rc.indexOf("file")), Xl || (Xl = rc.slice(0, rc.lastIndexOf("/") + 1)), rc.slice(0, Xl.length) != Xl))
        for (; Xl.length > 0 && (Xl = Xl.slice(0, Xl.length - 1), Xl = Xl.slice(0, Xl.lastIndexOf("/") + 1), rc.slice(0, Xl.length) != Xl); )
          ;
    var dc = (Ql[1] || "").match(/boundary="(.*?)"/);
    if (!dc) throw new Error("MAD cannot find boundary");
    var wc = "--" + (dc[1] || ""), bc = [], Cc = [], yc = {
      FileIndex: bc,
      FullPaths: Cc
    };
    qa(yc);
    var Oc, Mc = 0;
    for (ec = 0; ec < Ql.length; ++ec) {
      var Bc = Ql[ec];
      Bc !== wc && Bc !== wc + "--" || (Mc++ && vc(yc, Ql.slice(Oc, ec), Xl), Oc = ec);
    }
    return yc;
  }
  function Hc(Wl, ic) {
    var Xl = ic || {}, Ql = Xl.boundary || "SheetJS";
    Ql = "------=" + Ql;
    for (var ec = [
      "MIME-Version: 1.0",
      'Content-Type: multipart/related; boundary="' + Ql.slice(2) + '"',
      "",
      "",
      ""
    ], rc = Wl.FullPaths[0], dc = rc, wc = Wl.FileIndex[0], bc = 1; bc < Wl.FullPaths.length; ++bc)
      if (dc = Wl.FullPaths[bc].slice(rc.length), wc = Wl.FileIndex[bc], !(!wc.size || !wc.content || dc == "Sh33tJ5")) {
        dc = dc.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(Xc) {
          return "_x" + Xc.charCodeAt(0).toString(16) + "_";
        }).replace(/[\u0080-\uFFFF]/g, function(Xc) {
          return "_u" + Xc.charCodeAt(0).toString(16) + "_";
        });
        for (var Cc = wc.content, yc = has_buf && Buffer.isBuffer(Cc) ? Cc.toString("binary") : fl(Cc), Oc = 0, Mc = Math.min(1024, yc.length), Bc = 0, Rc = 0; Rc <= Mc; ++Rc) (Bc = yc.charCodeAt(Rc)) >= 32 && Bc < 128 && ++Oc;
        var kc = Oc >= Mc * 4 / 5;
        ec.push(Ql), ec.push("Content-Location: " + (Xl.root || "file:///C:/SheetJS/") + dc), ec.push("Content-Transfer-Encoding: " + (kc ? "quoted-printable" : "base64")), ec.push("Content-Type: " + Bl(wc, dc)), ec.push(""), ec.push(kc ? oc(yc) : Kl(yc));
      }
    return ec.push(Ql + `--\r
`), ec.join(`\r
`);
  }
  function $c(Wl) {
    var ic = {};
    return qa(ic, Wl), ic;
  }
  function Nc(Wl, ic, Xl, Ql) {
    var ec = Ql && Ql.unsafe;
    ec || qa(Wl);
    var rc = !ec && CFB.find(Wl, ic);
    if (!rc) {
      var dc = Wl.FullPaths[0];
      ic.slice(0, dc.length) == dc ? dc = ic : (dc.slice(-1) != "/" && (dc += "/"), dc = (dc + ic).replace("//", "/")), rc = { name: qn(ic), type: 2 }, Wl.FileIndex.push(rc), Wl.FullPaths.push(dc), ec || CFB.utils.cfb_gc(Wl);
    }
    return rc.content = Xl, rc.size = Xl ? Xl.length : 0, Ql && (Ql.CLSID && (rc.clsid = Ql.CLSID), Ql.mt && (rc.mt = Ql.mt), Ql.ct && (rc.ct = Ql.ct)), rc;
  }
  function Zc(Wl, ic) {
    qa(Wl);
    var Xl = CFB.find(Wl, ic);
    if (Xl) {
      for (var Ql = 0; Ql < Wl.FileIndex.length; ++Ql) if (Wl.FileIndex[Ql] == Xl)
        return Wl.FileIndex.splice(Ql, 1), Wl.FullPaths.splice(Ql, 1), !0;
    }
    return !1;
  }
  function Yc(Wl, ic, Xl) {
    qa(Wl);
    var Ql = CFB.find(Wl, ic);
    if (Ql) {
      for (var ec = 0; ec < Wl.FileIndex.length; ++ec) if (Wl.FileIndex[ec] == Ql)
        return Wl.FileIndex[ec].name = qn(Xl), Wl.FullPaths[ec] = Xl, !0;
    }
    return !1;
  }
  function mh(Wl) {
    Qa(Wl, !0);
  }
  return zn.find = rl, zn.read = el, zn.parse = _a, zn.write = Ml, zn.writeFile = El, zn.utils = {
    cfb_new: $c,
    cfb_add: Nc,
    cfb_del: Zc,
    cfb_mov: Yc,
    cfb_gc: mh,
    ReadShift,
    CheckField,
    prep_blob,
    bconcat,
    use_zlib: ml,
    _deflateRaw: Ec,
    _inflateRaw: Ol,
    consts: dl
  }, zn;
}();
function read_binary(Xn) {
  if (typeof Deno < "u") return Deno.readFileSync(Xn);
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u") try {
    var zn = File(Xn);
    zn.open("r"), zn.encoding = "binary";
    var Un = zn.read();
    return zn.close(), Un;
  } catch (Kn) {
    if (!Kn.message || !Kn.message.match(/onstruct/)) throw Kn;
  }
  throw new Error("Cannot access file " + Xn);
}
function keys(Xn) {
  for (var zn = Object.keys(Xn), Un = [], Kn = 0; Kn < zn.length; ++Kn) Object.prototype.hasOwnProperty.call(Xn, zn[Kn]) && Un.push(zn[Kn]);
  return Un;
}
function evert(Xn) {
  for (var zn = [], Un = keys(Xn), Kn = 0; Kn !== Un.length; ++Kn) zn[Xn[Un[Kn]]] = Un[Kn];
  return zn;
}
var basedate = /* @__PURE__ */ new Date(1899, 11, 30, 0, 0, 0);
function datenum(Xn, zn) {
  var Un = /* @__PURE__ */ Xn.getTime(), Kn = /* @__PURE__ */ basedate.getTime() + (/* @__PURE__ */ Xn.getTimezoneOffset() - /* @__PURE__ */ basedate.getTimezoneOffset()) * 6e4;
  return (Un - Kn) / (24 * 60 * 60 * 1e3);
}
var refdate = /* @__PURE__ */ new Date(), dnthresh = /* @__PURE__ */ basedate.getTime() + (/* @__PURE__ */ refdate.getTimezoneOffset() - /* @__PURE__ */ basedate.getTimezoneOffset()) * 6e4, refoffset = /* @__PURE__ */ refdate.getTimezoneOffset();
function numdate(Xn) {
  var zn = /* @__PURE__ */ new Date();
  return zn.setTime(Xn * 24 * 60 * 60 * 1e3 + dnthresh), zn.getTimezoneOffset() !== refoffset && zn.setTime(zn.getTime() + (zn.getTimezoneOffset() - refoffset) * 6e4), zn;
}
function parse_isodur(Xn) {
  var zn = 0, Un = 0, Kn = !1, qn = Xn.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  if (!qn) throw new Error("|" + Xn + "| is not an ISO8601 Duration");
  for (var Jo = 1; Jo != qn.length; ++Jo)
    if (qn[Jo]) {
      switch (Un = 1, Jo > 3 && (Kn = !0), qn[Jo].slice(qn[Jo].length - 1)) {
        case "Y":
          throw new Error("Unsupported ISO Duration Field: " + qn[Jo].slice(qn[Jo].length - 1));
        case "D":
          Un *= 24;
        /* falls through */
        case "H":
          Un *= 60;
        /* falls through */
        case "M":
          if (Kn) Un *= 60;
          else throw new Error("Unsupported ISO Duration Field: M");
      }
      zn += Un * parseInt(qn[Jo], 10);
    }
  return zn;
}
var good_pd_date_1 = /* @__PURE__ */ new Date("2017-02-19T19:06:09.000Z"), good_pd_date = /* @__PURE__ */ isNaN(/* @__PURE__ */ good_pd_date_1.getFullYear()) ? /* @__PURE__ */ new Date("2/19/17") : good_pd_date_1, good_pd = /* @__PURE__ */ good_pd_date.getFullYear() == 2017;
function parseDate$1(Xn, zn) {
  var Un = new Date(Xn);
  if (good_pd)
    return zn > 0 ? Un.setTime(Un.getTime() + Un.getTimezoneOffset() * 60 * 1e3) : zn < 0 && Un.setTime(Un.getTime() - Un.getTimezoneOffset() * 60 * 1e3), Un;
  if (Xn instanceof Date) return Xn;
  if (good_pd_date.getFullYear() == 1917 && !isNaN(Un.getFullYear())) {
    var Kn = Un.getFullYear();
    return Xn.indexOf("" + Kn) > -1 || Un.setFullYear(Un.getFullYear() + 100), Un;
  }
  var qn = Xn.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"], Jo = new Date(+qn[0], +qn[1] - 1, +qn[2], +qn[3] || 0, +qn[4] || 0, +qn[5] || 0);
  return Xn.indexOf("Z") > -1 && (Jo = new Date(Jo.getTime() - Jo.getTimezoneOffset() * 60 * 1e3)), Jo;
}
function cc2str(Xn, zn) {
  if (has_buf && Buffer.isBuffer(Xn)) {
    if (zn) {
      if (Xn[0] == 255 && Xn[1] == 254) return utf8write(Xn.slice(2).toString("utf16le"));
      if (Xn[1] == 254 && Xn[2] == 255) return utf8write(utf16beread(Xn.slice(2).toString("binary")));
    }
    return Xn.toString("binary");
  }
  if (typeof TextDecoder < "u") try {
    if (zn) {
      if (Xn[0] == 255 && Xn[1] == 254) return utf8write(new TextDecoder("utf-16le").decode(Xn.slice(2)));
      if (Xn[0] == 254 && Xn[1] == 255) return utf8write(new TextDecoder("utf-16be").decode(Xn.slice(2)));
    }
    var Un = {
      "€": "",
      "‚": "",
      ƒ: "",
      "„": "",
      "…": "",
      "†": "",
      "‡": "",
      "ˆ": "",
      "‰": "",
      Š: "",
      "‹": "",
      Œ: "",
      Ž: "",
      "‘": "",
      "’": "",
      "“": "",
      "”": "",
      "•": "",
      "–": "",
      "—": "",
      "˜": "",
      "™": "",
      š: "",
      "›": "",
      œ: "",
      ž: "",
      Ÿ: ""
    };
    return Array.isArray(Xn) && (Xn = new Uint8Array(Xn)), new TextDecoder("latin1").decode(Xn).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(Jo) {
      return Un[Jo] || Jo;
    });
  } catch {
  }
  for (var Kn = [], qn = 0; qn != Xn.length; ++qn) Kn.push(String.fromCharCode(Xn[qn]));
  return Kn.join("");
}
function dup(Xn) {
  if (typeof JSON < "u" && !Array.isArray(Xn)) return JSON.parse(JSON.stringify(Xn));
  if (typeof Xn != "object" || Xn == null) return Xn;
  if (Xn instanceof Date) return new Date(Xn.getTime());
  var zn = {};
  for (var Un in Xn) Object.prototype.hasOwnProperty.call(Xn, Un) && (zn[Un] = dup(Xn[Un]));
  return zn;
}
function fill$1(Xn, zn) {
  for (var Un = ""; Un.length < zn; ) Un += Xn;
  return Un;
}
function fuzzynum(Xn) {
  var zn = Number(Xn);
  if (!isNaN(zn)) return isFinite(zn) ? zn : NaN;
  if (!/\d/.test(Xn)) return zn;
  var Un = 1, Kn = Xn.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
    return Un *= 100, "";
  });
  return !isNaN(zn = Number(Kn)) || (Kn = Kn.replace(/[(](.*)[)]/, function(qn, Jo) {
    return Un = -Un, Jo;
  }), !isNaN(zn = Number(Kn))) ? zn / Un : zn;
}
var lower_months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function fuzzydate(Xn) {
  var zn = new Date(Xn), Un = /* @__PURE__ */ new Date(NaN), Kn = zn.getYear(), qn = zn.getMonth(), Jo = zn.getDate();
  if (isNaN(Jo)) return Un;
  var pa = Xn.toLowerCase();
  if (pa.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (pa = pa.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ""), pa.length > 3 && lower_months.indexOf(pa) == -1) return Un;
  } else if (pa.match(/[a-z]/)) return Un;
  return Kn < 0 || Kn > 8099 ? Un : (qn > 0 || Jo > 1) && Kn != 101 ? zn : Xn.match(/[^-0-9:,\/\\]/) ? Un : zn;
}
var split_regex = /* @__PURE__ */ function() {
  var Xn = "abacaba".split(/(:?b)/i).length == 5;
  return function(Un, Kn, qn) {
    if (Xn || typeof Kn == "string") return Un.split(Kn);
    for (var Jo = Un.split(Kn), pa = [Jo[0]], ma = 1; ma < Jo.length; ++ma)
      pa.push(qn), pa.push(Jo[ma]);
    return pa;
  };
}();
function getdatastr(Xn) {
  return Xn ? Xn.content && Xn.type ? cc2str(Xn.content, !0) : Xn.data ? debom(Xn.data) : Xn.asNodeBuffer && has_buf ? debom(Xn.asNodeBuffer().toString("binary")) : Xn.asBinary ? debom(Xn.asBinary()) : Xn._data && Xn._data.getContent ? debom(cc2str(Array.prototype.slice.call(Xn._data.getContent(), 0))) : null : null;
}
function getdatabin(Xn) {
  if (!Xn) return null;
  if (Xn.data) return char_codes(Xn.data);
  if (Xn.asNodeBuffer && has_buf) return Xn.asNodeBuffer();
  if (Xn._data && Xn._data.getContent) {
    var zn = Xn._data.getContent();
    return typeof zn == "string" ? char_codes(zn) : Array.prototype.slice.call(zn);
  }
  return Xn.content && Xn.type ? Xn.content : null;
}
function getdata(Xn) {
  return Xn && Xn.name.slice(-4) === ".bin" ? getdatabin(Xn) : getdatastr(Xn);
}
function safegetzipfile(Xn, zn) {
  for (var Un = Xn.FullPaths || keys(Xn.files), Kn = zn.toLowerCase().replace(/[\/]/g, "\\"), qn = Kn.replace(/\\/g, "/"), Jo = 0; Jo < Un.length; ++Jo) {
    var pa = Un[Jo].replace(/^Root Entry[\/]/, "").toLowerCase();
    if (Kn == pa || qn == pa) return Xn.files ? Xn.files[Un[Jo]] : Xn.FileIndex[Jo];
  }
  return null;
}
function getzipfile(Xn, zn) {
  var Un = safegetzipfile(Xn, zn);
  if (Un == null) throw new Error("Cannot find file " + zn + " in zip");
  return Un;
}
function getzipdata(Xn, zn, Un) {
  if (!Un) return getdata(getzipfile(Xn, zn));
  if (!zn) return null;
  try {
    return getzipdata(Xn, zn);
  } catch {
    return null;
  }
}
function getzipstr(Xn, zn, Un) {
  if (!Un) return getdatastr(getzipfile(Xn, zn));
  if (!zn) return null;
  try {
    return getzipstr(Xn, zn);
  } catch {
    return null;
  }
}
function getzipbin(Xn, zn, Un) {
  return getdatabin(getzipfile(Xn, zn));
}
function zipentries(Xn) {
  for (var zn = Xn.FullPaths || keys(Xn.files), Un = [], Kn = 0; Kn < zn.length; ++Kn) zn[Kn].slice(-1) != "/" && Un.push(zn[Kn].replace(/^Root Entry[\/]/, ""));
  return Un.sort();
}
function zip_add_file(Xn, zn, Un) {
  if (Xn.FullPaths) {
    if (typeof Un == "string") {
      var Kn;
      return has_buf ? Kn = Buffer_from(Un) : Kn = utf8decode(Un), CFB.utils.cfb_add(Xn, zn, Kn);
    }
    CFB.utils.cfb_add(Xn, zn, Un);
  } else Xn.file(zn, Un);
}
function zip_read(Xn, zn) {
  switch (zn.type) {
    case "base64":
      return CFB.read(Xn, { type: "base64" });
    case "binary":
      return CFB.read(Xn, { type: "binary" });
    case "buffer":
    case "array":
      return CFB.read(Xn, { type: "buffer" });
  }
  throw new Error("Unrecognized type " + zn.type);
}
function resolve_path(Xn, zn) {
  if (Xn.charAt(0) == "/") return Xn.slice(1);
  var Un = zn.split("/");
  zn.slice(-1) != "/" && Un.pop();
  for (var Kn = Xn.split("/"); Kn.length !== 0; ) {
    var qn = Kn.shift();
    qn === ".." ? Un.pop() : qn !== "." && Un.push(qn);
  }
  return Un.join("/");
}
var XML_HEADER = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g, tagregex = /* @__PURE__ */ XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2, nsregex = /<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(Xn, zn, Un) {
  for (var Kn = {}, qn = 0, Jo = 0; qn !== Xn.length && !((Jo = Xn.charCodeAt(qn)) === 32 || Jo === 10 || Jo === 13); ++qn) ;
  if (zn || (Kn[0] = Xn.slice(0, qn)), qn === Xn.length) return Kn;
  var pa = Xn.match(attregexg), ma = 0, va = "", ba = 0, _a = "", ya = "", xa = 1;
  if (pa) for (ba = 0; ba != pa.length; ++ba) {
    for (ya = pa[ba], Jo = 0; Jo != ya.length && ya.charCodeAt(Jo) !== 61; ++Jo) ;
    for (_a = ya.slice(0, Jo).trim(); ya.charCodeAt(Jo + 1) == 32; ) ++Jo;
    for (xa = (qn = ya.charCodeAt(Jo + 1)) == 34 || qn == 39 ? 1 : 0, va = ya.slice(Jo + 1 + xa, ya.length - xa), ma = 0; ma != _a.length && _a.charCodeAt(ma) !== 58; ++ma) ;
    if (ma === _a.length)
      _a.indexOf("_") > 0 && (_a = _a.slice(0, _a.indexOf("_"))), Kn[_a] = va, Kn[_a.toLowerCase()] = va;
    else {
      var wa = (ma === 5 && _a.slice(0, 5) === "xmlns" ? "xmlns" : "") + _a.slice(ma + 1);
      if (Kn[wa] && _a.slice(ma - 3, ma) == "ext") continue;
      Kn[wa] = va, Kn[wa.toLowerCase()] = va;
    }
  }
  return Kn;
}
function strip_ns(Xn) {
  return Xn.replace(nsregex2, "<$1");
}
var encodings = {
  "&quot;": '"',
  "&apos;": "'",
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&"
}, rencoding = /* @__PURE__ */ evert(encodings), unescapexml = /* @__PURE__ */ function() {
  var Xn = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, zn = /_x([\da-fA-F]{4})_/ig;
  return function Un(Kn) {
    var qn = Kn + "", Jo = qn.indexOf("<![CDATA[");
    if (Jo == -1) return qn.replace(Xn, function(ma, va) {
      return encodings[ma] || String.fromCharCode(parseInt(va, ma.indexOf("x") > -1 ? 16 : 10)) || ma;
    }).replace(zn, function(ma, va) {
      return String.fromCharCode(parseInt(va, 16));
    });
    var pa = qn.indexOf("]]>");
    return Un(qn.slice(0, Jo)) + qn.slice(Jo + 9, pa) + Un(qn.slice(pa + 3));
  };
}(), decregex = /[&<>'"]/g, htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(Xn) {
  var zn = Xn + "";
  return zn.replace(decregex, function(Un) {
    return rencoding[Un];
  }).replace(/\n/g, "<br/>").replace(htmlcharegex, function(Un) {
    return "&#x" + ("000" + Un.charCodeAt(0).toString(16)).slice(-4) + ";";
  });
}
var xlml_fixstr = /* @__PURE__ */ function() {
  var Xn = /&#(\d+);/g;
  function zn(Un, Kn) {
    return String.fromCharCode(parseInt(Kn, 10));
  }
  return function(Kn) {
    return Kn.replace(Xn, zn);
  };
}();
function parsexmlbool(Xn) {
  switch (Xn) {
    case 1:
    case !0:
    case "1":
    case "true":
    case "TRUE":
      return !0;
    /* case '0': case 'false': case 'FALSE':*/
    default:
      return !1;
  }
}
function utf8reada(Xn) {
  for (var zn = "", Un = 0, Kn = 0, qn = 0, Jo = 0, pa = 0, ma = 0; Un < Xn.length; ) {
    if (Kn = Xn.charCodeAt(Un++), Kn < 128) {
      zn += String.fromCharCode(Kn);
      continue;
    }
    if (qn = Xn.charCodeAt(Un++), Kn > 191 && Kn < 224) {
      pa = (Kn & 31) << 6, pa |= qn & 63, zn += String.fromCharCode(pa);
      continue;
    }
    if (Jo = Xn.charCodeAt(Un++), Kn < 240) {
      zn += String.fromCharCode((Kn & 15) << 12 | (qn & 63) << 6 | Jo & 63);
      continue;
    }
    pa = Xn.charCodeAt(Un++), ma = ((Kn & 7) << 18 | (qn & 63) << 12 | (Jo & 63) << 6 | pa & 63) - 65536, zn += String.fromCharCode(55296 + (ma >>> 10 & 1023)), zn += String.fromCharCode(56320 + (ma & 1023));
  }
  return zn;
}
function utf8readb(Xn) {
  var zn = new_raw_buf(2 * Xn.length), Un, Kn, qn = 1, Jo = 0, pa = 0, ma;
  for (Kn = 0; Kn < Xn.length; Kn += qn)
    qn = 1, (ma = Xn.charCodeAt(Kn)) < 128 ? Un = ma : ma < 224 ? (Un = (ma & 31) * 64 + (Xn.charCodeAt(Kn + 1) & 63), qn = 2) : ma < 240 ? (Un = (ma & 15) * 4096 + (Xn.charCodeAt(Kn + 1) & 63) * 64 + (Xn.charCodeAt(Kn + 2) & 63), qn = 3) : (qn = 4, Un = (ma & 7) * 262144 + (Xn.charCodeAt(Kn + 1) & 63) * 4096 + (Xn.charCodeAt(Kn + 2) & 63) * 64 + (Xn.charCodeAt(Kn + 3) & 63), Un -= 65536, pa = 55296 + (Un >>> 10 & 1023), Un = 56320 + (Un & 1023)), pa !== 0 && (zn[Jo++] = pa & 255, zn[Jo++] = pa >>> 8, pa = 0), zn[Jo++] = Un % 256, zn[Jo++] = Un >>> 8;
  return zn.slice(0, Jo).toString("ucs2");
}
function utf8readc(Xn) {
  return Buffer_from(Xn, "binary").toString("utf8");
}
var utf8corpus = "foo bar bazâð£", utf8read = has_buf && (/* @__PURE__ */ utf8readc(utf8corpus) == /* @__PURE__ */ utf8reada(utf8corpus) && utf8readc || /* @__PURE__ */ utf8readb(utf8corpus) == /* @__PURE__ */ utf8reada(utf8corpus) && utf8readb) || utf8reada, utf8write = has_buf ? function(Xn) {
  return Buffer_from(Xn, "utf8").toString("binary");
} : function(Xn) {
  for (var zn = [], Un = 0, Kn = 0, qn = 0; Un < Xn.length; )
    switch (Kn = Xn.charCodeAt(Un++), !0) {
      case Kn < 128:
        zn.push(String.fromCharCode(Kn));
        break;
      case Kn < 2048:
        zn.push(String.fromCharCode(192 + (Kn >> 6))), zn.push(String.fromCharCode(128 + (Kn & 63)));
        break;
      case (Kn >= 55296 && Kn < 57344):
        Kn -= 55296, qn = Xn.charCodeAt(Un++) - 56320 + (Kn << 10), zn.push(String.fromCharCode(240 + (qn >> 18 & 7))), zn.push(String.fromCharCode(144 + (qn >> 12 & 63))), zn.push(String.fromCharCode(128 + (qn >> 6 & 63))), zn.push(String.fromCharCode(128 + (qn & 63)));
        break;
      default:
        zn.push(String.fromCharCode(224 + (Kn >> 12))), zn.push(String.fromCharCode(128 + (Kn >> 6 & 63))), zn.push(String.fromCharCode(128 + (Kn & 63)));
    }
  return zn.join("");
}, matchtag = /* @__PURE__ */ function() {
  var Xn = {};
  return function(Un, Kn) {
    var qn = Un + "|" + (Kn || "");
    return Xn[qn] ? Xn[qn] : Xn[qn] = new RegExp("<(?:\\w+:)?" + Un + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + Un + ">", Kn || "");
  };
}(), htmldecode = /* @__PURE__ */ function() {
  var Xn = [
    ["nbsp", " "],
    ["middot", "·"],
    ["quot", '"'],
    ["apos", "'"],
    ["gt", ">"],
    ["lt", "<"],
    ["amp", "&"]
  ].map(function(zn) {
    return [new RegExp("&" + zn[0] + ";", "ig"), zn[1]];
  });
  return function(Un) {
    for (var Kn = Un.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), qn = 0; qn < Xn.length; ++qn) Kn = Kn.replace(Xn[qn][0], Xn[qn][1]);
    return Kn;
  };
}(), vtregex = /* @__PURE__ */ function() {
  var Xn = {};
  return function(Un) {
    return Xn[Un] !== void 0 ? Xn[Un] : Xn[Un] = new RegExp("<(?:vt:)?" + Un + ">([\\s\\S]*?)</(?:vt:)?" + Un + ">", "g");
  };
}(), vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(Xn, zn) {
  var Un = parsexmltag(Xn), Kn = Xn.match(vtregex(Un.baseType)) || [], qn = [];
  if (Kn.length != Un.size) {
    if (zn.WTF) throw new Error("unexpected vector length " + Kn.length + " != " + Un.size);
    return qn;
  }
  return Kn.forEach(function(Jo) {
    var pa = Jo.replace(vtvregex, "").match(vtmregex);
    pa && qn.push({ v: utf8read(pa[2]), t: pa[1] });
  }), qn;
}
var wtregex = /(^\s|\s$|\n)/;
function wxt_helper(Xn) {
  return keys(Xn).map(function(zn) {
    return " " + zn + '="' + Xn[zn] + '"';
  }).join("");
}
function writextag(Xn, zn, Un) {
  return "<" + Xn + (Un != null ? wxt_helper(Un) : "") + (zn != null ? (zn.match(wtregex) ? ' xml:space="preserve"' : "") + ">" + zn + "</" + Xn : "/") + ">";
}
function xlml_normalize(Xn) {
  if (has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/
  Buffer.isBuffer(Xn)) return Xn.toString("utf8");
  if (typeof Xn == "string") return Xn;
  if (typeof Uint8Array < "u" && Xn instanceof Uint8Array) return utf8read(a2s(ab2a(Xn)));
  throw new Error("Bad input format: expected Buffer or string");
}
var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg, XMLNS = {
  CT: "http://schemas.openxmlformats.org/package/2006/content-types"
}, XMLNS_main = [
  "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
  "http://purl.oclc.org/ooxml/spreadsheetml/main",
  "http://schemas.microsoft.com/office/excel/2006/main",
  "http://schemas.microsoft.com/office/excel/2006/2"
];
function read_double_le(Xn, zn) {
  for (var Un = 1 - 2 * (Xn[zn + 7] >>> 7), Kn = ((Xn[zn + 7] & 127) << 4) + (Xn[zn + 6] >>> 4 & 15), qn = Xn[zn + 6] & 15, Jo = 5; Jo >= 0; --Jo) qn = qn * 256 + Xn[zn + Jo];
  return Kn == 2047 ? qn == 0 ? Un * (1 / 0) : NaN : (Kn == 0 ? Kn = -1022 : (Kn -= 1023, qn += Math.pow(2, 52)), Un * Math.pow(2, Kn - 52) * qn);
}
function write_double_le(Xn, zn, Un) {
  var Kn = (zn < 0 || 1 / zn == -1 / 0 ? 1 : 0) << 7, qn = 0, Jo = 0, pa = Kn ? -zn : zn;
  isFinite(pa) ? pa == 0 ? qn = Jo = 0 : (qn = Math.floor(Math.log(pa) / Math.LN2), Jo = pa * Math.pow(2, 52 - qn), qn <= -1023 && (!isFinite(Jo) || Jo < Math.pow(2, 52)) ? qn = -1022 : (Jo -= Math.pow(2, 52), qn += 1023)) : (qn = 2047, Jo = isNaN(zn) ? 26985 : 0);
  for (var ma = 0; ma <= 5; ++ma, Jo /= 256) Xn[Un + ma] = Jo & 255;
  Xn[Un + 6] = (qn & 15) << 4 | Jo & 15, Xn[Un + 7] = qn >> 4 | Kn;
}
var ___toBuffer = function(Xn) {
  for (var zn = [], Un = 10240, Kn = 0; Kn < Xn[0].length; ++Kn) if (Xn[0][Kn]) for (var qn = 0, Jo = Xn[0][Kn].length; qn < Jo; qn += Un) zn.push.apply(zn, Xn[0][Kn].slice(qn, qn + Un));
  return zn;
}, __toBuffer = has_buf ? function(Xn) {
  return Xn[0].length > 0 && Buffer.isBuffer(Xn[0][0]) ? Buffer.concat(Xn[0].map(function(zn) {
    return Buffer.isBuffer(zn) ? zn : Buffer_from(zn);
  })) : ___toBuffer(Xn);
} : ___toBuffer, ___utf16le = function(Xn, zn, Un) {
  for (var Kn = [], qn = zn; qn < Un; qn += 2) Kn.push(String.fromCharCode(__readUInt16LE(Xn, qn)));
  return Kn.join("").replace(chr0, "");
}, __utf16le = has_buf ? function(Xn, zn, Un) {
  return Buffer.isBuffer(Xn) ? Xn.toString("utf16le", zn, Un).replace(chr0, "") : ___utf16le(Xn, zn, Un);
} : ___utf16le, ___hexlify = function(Xn, zn, Un) {
  for (var Kn = [], qn = zn; qn < zn + Un; ++qn) Kn.push(("0" + Xn[qn].toString(16)).slice(-2));
  return Kn.join("");
}, __hexlify = has_buf ? function(Xn, zn, Un) {
  return Buffer.isBuffer(Xn) ? Xn.toString("hex", zn, zn + Un) : ___hexlify(Xn, zn, Un);
} : ___hexlify, ___utf8 = function(Xn, zn, Un) {
  for (var Kn = [], qn = zn; qn < Un; qn++) Kn.push(String.fromCharCode(__readUInt8(Xn, qn)));
  return Kn.join("");
}, __utf8 = has_buf ? function(zn, Un, Kn) {
  return Buffer.isBuffer(zn) ? zn.toString("utf8", Un, Kn) : ___utf8(zn, Un, Kn);
} : ___utf8, ___lpstr = function(Xn, zn) {
  var Un = __readUInt32LE(Xn, zn);
  return Un > 0 ? __utf8(Xn, zn + 4, zn + 4 + Un - 1) : "";
}, __lpstr = ___lpstr, ___cpstr = function(Xn, zn) {
  var Un = __readUInt32LE(Xn, zn);
  return Un > 0 ? __utf8(Xn, zn + 4, zn + 4 + Un - 1) : "";
}, __cpstr = ___cpstr, ___lpwstr = function(Xn, zn) {
  var Un = 2 * __readUInt32LE(Xn, zn);
  return Un > 0 ? __utf8(Xn, zn + 4, zn + 4 + Un - 1) : "";
}, __lpwstr = ___lpwstr, ___lpp4 = function(zn, Un) {
  var Kn = __readUInt32LE(zn, Un);
  return Kn > 0 ? __utf16le(zn, Un + 4, Un + 4 + Kn) : "";
}, __lpp4 = ___lpp4, ___8lpp4 = function(Xn, zn) {
  var Un = __readUInt32LE(Xn, zn);
  return Un > 0 ? __utf8(Xn, zn + 4, zn + 4 + Un) : "";
}, __8lpp4 = ___8lpp4, ___double = function(Xn, zn) {
  return read_double_le(Xn, zn);
}, __double = ___double, is_buf = function(zn) {
  return Array.isArray(zn) || typeof Uint8Array < "u" && zn instanceof Uint8Array;
};
has_buf && (__lpstr = function(zn, Un) {
  if (!Buffer.isBuffer(zn)) return ___lpstr(zn, Un);
  var Kn = zn.readUInt32LE(Un);
  return Kn > 0 ? zn.toString("utf8", Un + 4, Un + 4 + Kn - 1) : "";
}, __cpstr = function(zn, Un) {
  if (!Buffer.isBuffer(zn)) return ___cpstr(zn, Un);
  var Kn = zn.readUInt32LE(Un);
  return Kn > 0 ? zn.toString("utf8", Un + 4, Un + 4 + Kn - 1) : "";
}, __lpwstr = function(zn, Un) {
  if (!Buffer.isBuffer(zn)) return ___lpwstr(zn, Un);
  var Kn = 2 * zn.readUInt32LE(Un);
  return zn.toString("utf16le", Un + 4, Un + 4 + Kn - 1);
}, __lpp4 = function(zn, Un) {
  if (!Buffer.isBuffer(zn)) return ___lpp4(zn, Un);
  var Kn = zn.readUInt32LE(Un);
  return zn.toString("utf16le", Un + 4, Un + 4 + Kn);
}, __8lpp4 = function(zn, Un) {
  if (!Buffer.isBuffer(zn)) return ___8lpp4(zn, Un);
  var Kn = zn.readUInt32LE(Un);
  return zn.toString("utf8", Un + 4, Un + 4 + Kn);
}, __double = function(zn, Un) {
  return Buffer.isBuffer(zn) ? zn.readDoubleLE(Un) : ___double(zn, Un);
}, is_buf = function(zn) {
  return Buffer.isBuffer(zn) || Array.isArray(zn) || typeof Uint8Array < "u" && zn instanceof Uint8Array;
});
var __readUInt8 = function(Xn, zn) {
  return Xn[zn];
}, __readUInt16LE = function(Xn, zn) {
  return Xn[zn + 1] * 256 + Xn[zn];
}, __readInt16LE = function(Xn, zn) {
  var Un = Xn[zn + 1] * 256 + Xn[zn];
  return Un < 32768 ? Un : (65535 - Un + 1) * -1;
}, __readUInt32LE = function(Xn, zn) {
  return Xn[zn + 3] * (1 << 24) + (Xn[zn + 2] << 16) + (Xn[zn + 1] << 8) + Xn[zn];
}, __readInt32LE = function(Xn, zn) {
  return Xn[zn + 3] << 24 | Xn[zn + 2] << 16 | Xn[zn + 1] << 8 | Xn[zn];
}, __readInt32BE = function(Xn, zn) {
  return Xn[zn] << 24 | Xn[zn + 1] << 16 | Xn[zn + 2] << 8 | Xn[zn + 3];
};
function ReadShift(Xn, zn) {
  var Un = "", Kn, qn, Jo = [], pa, ma, va, ba;
  switch (zn) {
    case "dbcs":
      if (ba = this.l, has_buf && Buffer.isBuffer(this)) Un = this.slice(this.l, this.l + 2 * Xn).toString("utf16le");
      else for (va = 0; va < Xn; ++va)
        Un += String.fromCharCode(__readUInt16LE(this, ba)), ba += 2;
      Xn *= 2;
      break;
    case "utf8":
      Un = __utf8(this, this.l, this.l + Xn);
      break;
    case "utf16le":
      Xn *= 2, Un = __utf16le(this, this.l, this.l + Xn);
      break;
    case "wstr":
      return ReadShift.call(this, Xn, "dbcs");
    /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
    case "lpstr-ansi":
      Un = __lpstr(this, this.l), Xn = 4 + __readUInt32LE(this, this.l);
      break;
    case "lpstr-cp":
      Un = __cpstr(this, this.l), Xn = 4 + __readUInt32LE(this, this.l);
      break;
    /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
    case "lpwstr":
      Un = __lpwstr(this, this.l), Xn = 4 + 2 * __readUInt32LE(this, this.l);
      break;
    /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
    case "lpp4":
      Xn = 4 + __readUInt32LE(this, this.l), Un = __lpp4(this, this.l), Xn & 2 && (Xn += 2);
      break;
    /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
    case "8lpp4":
      Xn = 4 + __readUInt32LE(this, this.l), Un = __8lpp4(this, this.l), Xn & 3 && (Xn += 4 - (Xn & 3));
      break;
    case "cstr":
      for (Xn = 0, Un = ""; (pa = __readUInt8(this, this.l + Xn++)) !== 0; ) Jo.push(_getchar(pa));
      Un = Jo.join("");
      break;
    case "_wstr":
      for (Xn = 0, Un = ""; (pa = __readUInt16LE(this, this.l + Xn)) !== 0; )
        Jo.push(_getchar(pa)), Xn += 2;
      Xn += 2, Un = Jo.join("");
      break;
    /* sbcs and dbcs support continue records in the SST way TODO codepages */
    case "dbcs-cont":
      for (Un = "", ba = this.l, va = 0; va < Xn; ++va) {
        if (this.lens && this.lens.indexOf(ba) !== -1)
          return pa = __readUInt8(this, ba), this.l = ba + 1, ma = ReadShift.call(this, Xn - va, pa ? "dbcs-cont" : "sbcs-cont"), Jo.join("") + ma;
        Jo.push(_getchar(__readUInt16LE(this, ba))), ba += 2;
      }
      Un = Jo.join(""), Xn *= 2;
      break;
    case "cpstr":
    /* falls through */
    case "sbcs-cont":
      for (Un = "", ba = this.l, va = 0; va != Xn; ++va) {
        if (this.lens && this.lens.indexOf(ba) !== -1)
          return pa = __readUInt8(this, ba), this.l = ba + 1, ma = ReadShift.call(this, Xn - va, pa ? "dbcs-cont" : "sbcs-cont"), Jo.join("") + ma;
        Jo.push(_getchar(__readUInt8(this, ba))), ba += 1;
      }
      Un = Jo.join("");
      break;
    default:
      switch (Xn) {
        case 1:
          return Kn = __readUInt8(this, this.l), this.l++, Kn;
        case 2:
          return Kn = (zn === "i" ? __readInt16LE : __readUInt16LE)(this, this.l), this.l += 2, Kn;
        case 4:
        case -4:
          return zn === "i" || (this[this.l + 3] & 128) === 0 ? (Kn = (Xn > 0 ? __readInt32LE : __readInt32BE)(this, this.l), this.l += 4, Kn) : (qn = __readUInt32LE(this, this.l), this.l += 4, qn);
        case 8:
        case -8:
          if (zn === "f")
            return Xn == 8 ? qn = __double(this, this.l) : qn = __double([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, qn;
          Xn = 8;
        /* falls through */
        case 16:
          Un = __hexlify(this, this.l, Xn);
          break;
      }
  }
  return this.l += Xn, Un;
}
var __writeUInt32LE = function(Xn, zn, Un) {
  Xn[Un] = zn & 255, Xn[Un + 1] = zn >>> 8 & 255, Xn[Un + 2] = zn >>> 16 & 255, Xn[Un + 3] = zn >>> 24 & 255;
}, __writeInt32LE = function(Xn, zn, Un) {
  Xn[Un] = zn & 255, Xn[Un + 1] = zn >> 8 & 255, Xn[Un + 2] = zn >> 16 & 255, Xn[Un + 3] = zn >> 24 & 255;
}, __writeUInt16LE = function(Xn, zn, Un) {
  Xn[Un] = zn & 255, Xn[Un + 1] = zn >>> 8 & 255;
};
function WriteShift(Xn, zn, Un) {
  var Kn = 0, qn = 0;
  if (Un === "dbcs") {
    for (qn = 0; qn != zn.length; ++qn) __writeUInt16LE(this, zn.charCodeAt(qn), this.l + 2 * qn);
    Kn = 2 * zn.length;
  } else if (Un === "sbcs") {
    for (zn = zn.replace(/[^\x00-\x7F]/g, "_"), qn = 0; qn != zn.length; ++qn) this[this.l + qn] = zn.charCodeAt(qn) & 255;
    Kn = zn.length;
  } else if (Un === "hex") {
    for (; qn < Xn; ++qn)
      this[this.l++] = parseInt(zn.slice(2 * qn, 2 * qn + 2), 16) || 0;
    return this;
  } else if (Un === "utf16le") {
    var Jo = Math.min(this.l + Xn, this.length);
    for (qn = 0; qn < Math.min(zn.length, Xn); ++qn) {
      var pa = zn.charCodeAt(qn);
      this[this.l++] = pa & 255, this[this.l++] = pa >> 8;
    }
    for (; this.l < Jo; ) this[this.l++] = 0;
    return this;
  } else switch (Xn) {
    case 1:
      Kn = 1, this[this.l] = zn & 255;
      break;
    case 2:
      Kn = 2, this[this.l] = zn & 255, zn >>>= 8, this[this.l + 1] = zn & 255;
      break;
    case 3:
      Kn = 3, this[this.l] = zn & 255, zn >>>= 8, this[this.l + 1] = zn & 255, zn >>>= 8, this[this.l + 2] = zn & 255;
      break;
    case 4:
      Kn = 4, __writeUInt32LE(this, zn, this.l);
      break;
    case 8:
      if (Kn = 8, Un === "f") {
        write_double_le(this, zn, this.l);
        break;
      }
    /* falls through */
    case 16:
      break;
    case -4:
      Kn = 4, __writeInt32LE(this, zn, this.l);
      break;
  }
  return this.l += Kn, this;
}
function CheckField(Xn, zn) {
  var Un = __hexlify(this, this.l, Xn.length >> 1);
  if (Un !== Xn) throw new Error(zn + "Expected " + Xn + " saw " + Un);
  this.l += Xn.length >> 1;
}
function prep_blob(Xn, zn) {
  Xn.l = zn, Xn.read_shift = /*::(*/
  ReadShift, Xn.chk = CheckField, Xn.write_shift = WriteShift;
}
function parsenoop(Xn, zn) {
  Xn.l += zn;
}
function new_buf(Xn) {
  var zn = new_raw_buf(Xn);
  return prep_blob(zn, 0), zn;
}
function recordhopper(Xn, zn, Un) {
  if (Xn) {
    var Kn, qn, Jo;
    prep_blob(Xn, Xn.l || 0);
    for (var pa = Xn.length, ma = 0, va = 0; Xn.l < pa; ) {
      ma = Xn.read_shift(1), ma & 128 && (ma = (ma & 127) + ((Xn.read_shift(1) & 127) << 7));
      var ba = XLSBRecordEnum[ma] || XLSBRecordEnum[65535];
      for (Kn = Xn.read_shift(1), Jo = Kn & 127, qn = 1; qn < 4 && Kn & 128; ++qn) Jo += ((Kn = Xn.read_shift(1)) & 127) << 7 * qn;
      va = Xn.l + Jo;
      var _a = ba.f && ba.f(Xn, Jo, Un);
      if (Xn.l = va, zn(_a, ba, ma)) return;
    }
  }
}
function buf_array() {
  var Xn = [], zn = has_buf ? 256 : 2048, Un = function(ba) {
    var _a = new_buf(ba);
    return prep_blob(_a, 0), _a;
  }, Kn = Un(zn), qn = function() {
    Kn && (Kn.length > Kn.l && (Kn = Kn.slice(0, Kn.l), Kn.l = Kn.length), Kn.length > 0 && Xn.push(Kn), Kn = null);
  }, Jo = function(ba) {
    return Kn && ba < Kn.length - Kn.l ? Kn : (qn(), Kn = Un(Math.max(ba + 1, zn)));
  }, pa = function() {
    return qn(), bconcat(Xn);
  }, ma = function(ba) {
    qn(), Kn = ba, Kn.l == null && (Kn.l = Kn.length), Jo(zn);
  };
  return { next: Jo, push: ma, end: pa, _bufs: Xn };
}
function shift_cell_xls(Xn, zn, Un) {
  var Kn = dup(Xn);
  if (zn.s ? (Kn.cRel && (Kn.c += zn.s.c), Kn.rRel && (Kn.r += zn.s.r)) : (Kn.cRel && (Kn.c += zn.c), Kn.rRel && (Kn.r += zn.r)), !Un || Un.biff < 12) {
    for (; Kn.c >= 256; ) Kn.c -= 256;
    for (; Kn.r >= 65536; ) Kn.r -= 65536;
  }
  return Kn;
}
function shift_range_xls(Xn, zn, Un) {
  var Kn = dup(Xn);
  return Kn.s = shift_cell_xls(Kn.s, zn.s, Un), Kn.e = shift_cell_xls(Kn.e, zn.s, Un), Kn;
}
function encode_cell_xls(Xn, zn) {
  if (Xn.cRel && Xn.c < 0)
    for (Xn = dup(Xn); Xn.c < 0; ) Xn.c += zn > 8 ? 16384 : 256;
  if (Xn.rRel && Xn.r < 0)
    for (Xn = dup(Xn); Xn.r < 0; ) Xn.r += zn > 8 ? 1048576 : zn > 5 ? 65536 : 16384;
  var Un = encode_cell(Xn);
  return !Xn.cRel && Xn.cRel != null && (Un = fix_col(Un)), !Xn.rRel && Xn.rRel != null && (Un = fix_row(Un)), Un;
}
function encode_range_xls(Xn, zn) {
  return Xn.s.r == 0 && !Xn.s.rRel && Xn.e.r == (zn.biff >= 12 ? 1048575 : zn.biff >= 8 ? 65536 : 16384) && !Xn.e.rRel ? (Xn.s.cRel ? "" : "$") + encode_col(Xn.s.c) + ":" + (Xn.e.cRel ? "" : "$") + encode_col(Xn.e.c) : Xn.s.c == 0 && !Xn.s.cRel && Xn.e.c == (zn.biff >= 12 ? 16383 : 255) && !Xn.e.cRel ? (Xn.s.rRel ? "" : "$") + encode_row(Xn.s.r) + ":" + (Xn.e.rRel ? "" : "$") + encode_row(Xn.e.r) : encode_cell_xls(Xn.s, zn.biff) + ":" + encode_cell_xls(Xn.e, zn.biff);
}
function decode_row(Xn) {
  return parseInt(unfix_row(Xn), 10) - 1;
}
function encode_row(Xn) {
  return "" + (Xn + 1);
}
function fix_row(Xn) {
  return Xn.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function unfix_row(Xn) {
  return Xn.replace(/\$(\d+)$/, "$1");
}
function decode_col(Xn) {
  for (var zn = unfix_col(Xn), Un = 0, Kn = 0; Kn !== zn.length; ++Kn) Un = 26 * Un + zn.charCodeAt(Kn) - 64;
  return Un - 1;
}
function encode_col(Xn) {
  if (Xn < 0) throw new Error("invalid column " + Xn);
  var zn = "";
  for (++Xn; Xn; Xn = Math.floor((Xn - 1) / 26)) zn = String.fromCharCode((Xn - 1) % 26 + 65) + zn;
  return zn;
}
function fix_col(Xn) {
  return Xn.replace(/^([A-Z])/, "$$$1");
}
function unfix_col(Xn) {
  return Xn.replace(/^\$([A-Z])/, "$1");
}
function split_cell(Xn) {
  return Xn.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function decode_cell(Xn) {
  for (var zn = 0, Un = 0, Kn = 0; Kn < Xn.length; ++Kn) {
    var qn = Xn.charCodeAt(Kn);
    qn >= 48 && qn <= 57 ? zn = 10 * zn + (qn - 48) : qn >= 65 && qn <= 90 && (Un = 26 * Un + (qn - 64));
  }
  return { c: Un - 1, r: zn - 1 };
}
function encode_cell(Xn) {
  for (var zn = Xn.c + 1, Un = ""; zn; zn = (zn - 1) / 26 | 0) Un = String.fromCharCode((zn - 1) % 26 + 65) + Un;
  return Un + (Xn.r + 1);
}
function decode_range(Xn) {
  var zn = Xn.indexOf(":");
  return zn == -1 ? { s: decode_cell(Xn), e: decode_cell(Xn) } : { s: decode_cell(Xn.slice(0, zn)), e: decode_cell(Xn.slice(zn + 1)) };
}
function encode_range(Xn, zn) {
  return typeof zn > "u" || typeof zn == "number" ? encode_range(Xn.s, Xn.e) : (typeof Xn != "string" && (Xn = encode_cell(Xn)), typeof zn != "string" && (zn = encode_cell(zn)), Xn == zn ? Xn : Xn + ":" + zn);
}
function safe_decode_range(Xn) {
  var zn = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, Un = 0, Kn = 0, qn = 0, Jo = Xn.length;
  for (Un = 0; Kn < Jo && !((qn = Xn.charCodeAt(Kn) - 64) < 1 || qn > 26); ++Kn)
    Un = 26 * Un + qn;
  for (zn.s.c = --Un, Un = 0; Kn < Jo && !((qn = Xn.charCodeAt(Kn) - 48) < 0 || qn > 9); ++Kn)
    Un = 10 * Un + qn;
  if (zn.s.r = --Un, Kn === Jo || qn != 10)
    return zn.e.c = zn.s.c, zn.e.r = zn.s.r, zn;
  for (++Kn, Un = 0; Kn != Jo && !((qn = Xn.charCodeAt(Kn) - 64) < 1 || qn > 26); ++Kn)
    Un = 26 * Un + qn;
  for (zn.e.c = --Un, Un = 0; Kn != Jo && !((qn = Xn.charCodeAt(Kn) - 48) < 0 || qn > 9); ++Kn)
    Un = 10 * Un + qn;
  return zn.e.r = --Un, zn;
}
function safe_format_cell(Xn, zn) {
  var Un = Xn.t == "d" && zn instanceof Date;
  if (Xn.z != null) try {
    return Xn.w = SSF_format(Xn.z, Un ? datenum(zn) : zn);
  } catch {
  }
  try {
    return Xn.w = SSF_format((Xn.XF || {}).numFmtId || (Un ? 14 : 0), Un ? datenum(zn) : zn);
  } catch {
    return "" + zn;
  }
}
function format_cell(Xn, zn, Un) {
  return Xn == null || Xn.t == null || Xn.t == "z" ? "" : Xn.w !== void 0 ? Xn.w : (Xn.t == "d" && !Xn.z && Un && Un.dateNF && (Xn.z = Un.dateNF), Xn.t == "e" ? BErr[Xn.v] || Xn.v : zn == null ? safe_format_cell(Xn, Xn.v) : safe_format_cell(Xn, zn));
}
function sheet_to_workbook(Xn, zn) {
  var Un = zn && zn.sheet ? zn.sheet : "Sheet1", Kn = {};
  return Kn[Un] = Xn, { SheetNames: [Un], Sheets: Kn };
}
function sheet_add_aoa(Xn, zn, Un) {
  var Kn = Un || {}, qn = Xn ? Array.isArray(Xn) : Kn.dense, Jo = Xn || (qn ? [] : {}), pa = 0, ma = 0;
  if (Jo && Kn.origin != null) {
    if (typeof Kn.origin == "number") pa = Kn.origin;
    else {
      var va = typeof Kn.origin == "string" ? decode_cell(Kn.origin) : Kn.origin;
      pa = va.r, ma = va.c;
    }
    Jo["!ref"] || (Jo["!ref"] = "A1:A1");
  }
  var ba = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
  if (Jo["!ref"]) {
    var _a = safe_decode_range(Jo["!ref"]);
    ba.s.c = _a.s.c, ba.s.r = _a.s.r, ba.e.c = Math.max(ba.e.c, _a.e.c), ba.e.r = Math.max(ba.e.r, _a.e.r), pa == -1 && (ba.e.r = pa = _a.e.r + 1);
  }
  for (var ya = 0; ya != zn.length; ++ya)
    if (zn[ya]) {
      if (!Array.isArray(zn[ya])) throw new Error("aoa_to_sheet expects an array of arrays");
      for (var xa = 0; xa != zn[ya].length; ++xa)
        if (!(typeof zn[ya][xa] > "u")) {
          var wa = { v: zn[ya][xa] }, Ta = pa + ya, Sa = ma + xa;
          if (ba.s.r > Ta && (ba.s.r = Ta), ba.s.c > Sa && (ba.s.c = Sa), ba.e.r < Ta && (ba.e.r = Ta), ba.e.c < Sa && (ba.e.c = Sa), zn[ya][xa] && typeof zn[ya][xa] == "object" && !Array.isArray(zn[ya][xa]) && !(zn[ya][xa] instanceof Date)) wa = zn[ya][xa];
          else if (Array.isArray(wa.v) && (wa.f = zn[ya][xa][1], wa.v = wa.v[0]), wa.v === null)
            if (wa.f) wa.t = "n";
            else if (Kn.nullError)
              wa.t = "e", wa.v = 0;
            else if (Kn.sheetStubs) wa.t = "z";
            else continue;
          else typeof wa.v == "number" ? wa.t = "n" : typeof wa.v == "boolean" ? wa.t = "b" : wa.v instanceof Date ? (wa.z = Kn.dateNF || table_fmt[14], Kn.cellDates ? (wa.t = "d", wa.w = SSF_format(wa.z, datenum(wa.v))) : (wa.t = "n", wa.v = datenum(wa.v), wa.w = SSF_format(wa.z, wa.v))) : wa.t = "s";
          if (qn)
            Jo[Ta] || (Jo[Ta] = []), Jo[Ta][Sa] && Jo[Ta][Sa].z && (wa.z = Jo[Ta][Sa].z), Jo[Ta][Sa] = wa;
          else {
            var Ma = encode_cell({ c: Sa, r: Ta });
            Jo[Ma] && Jo[Ma].z && (wa.z = Jo[Ma].z), Jo[Ma] = wa;
          }
        }
    }
  return ba.s.c < 1e7 && (Jo["!ref"] = encode_range(ba)), Jo;
}
function aoa_to_sheet(Xn, zn) {
  return sheet_add_aoa(null, Xn, zn);
}
function parse_Int32LE(Xn) {
  return Xn.read_shift(4, "i");
}
function parse_XLWideString(Xn) {
  var zn = Xn.read_shift(4);
  return zn === 0 ? "" : Xn.read_shift(zn, "dbcs");
}
function parse_StrRun(Xn) {
  return { ich: Xn.read_shift(2), ifnt: Xn.read_shift(2) };
}
function parse_RichStr(Xn, zn) {
  var Un = Xn.l, Kn = Xn.read_shift(1), qn = parse_XLWideString(Xn), Jo = [], pa = { t: qn, h: qn };
  if ((Kn & 1) !== 0) {
    for (var ma = Xn.read_shift(4), va = 0; va != ma; ++va) Jo.push(parse_StrRun(Xn));
    pa.r = Jo;
  } else pa.r = [{ ich: 0, ifnt: 0 }];
  return Xn.l = Un + zn, pa;
}
var parse_BrtCommentText = parse_RichStr;
function parse_XLSBCell(Xn) {
  var zn = Xn.read_shift(4), Un = Xn.read_shift(2);
  return Un += Xn.read_shift(1) << 16, Xn.l++, { c: zn, iStyleRef: Un };
}
function parse_XLSBShortCell(Xn) {
  var zn = Xn.read_shift(2);
  return zn += Xn.read_shift(1) << 16, Xn.l++, { c: -1, iStyleRef: zn };
}
var parse_XLSBCodeName = parse_XLWideString;
function parse_XLNullableWideString(Xn) {
  var zn = Xn.read_shift(4);
  return zn === 0 || zn === 4294967295 ? "" : Xn.read_shift(zn, "dbcs");
}
var parse_XLNameWideString = parse_XLWideString, parse_RelID = parse_XLNullableWideString;
function parse_RkNumber(Xn) {
  var zn = Xn.slice(Xn.l, Xn.l + 4), Un = zn[0] & 1, Kn = zn[0] & 2;
  Xn.l += 4;
  var qn = Kn === 0 ? __double([0, 0, 0, 0, zn[0] & 252, zn[1], zn[2], zn[3]], 0) : __readInt32LE(zn, 0) >> 2;
  return Un ? qn / 100 : qn;
}
function parse_RfX(Xn) {
  var zn = { s: {}, e: {} };
  return zn.s.r = Xn.read_shift(4), zn.e.r = Xn.read_shift(4), zn.s.c = Xn.read_shift(4), zn.e.c = Xn.read_shift(4), zn;
}
var parse_UncheckedRfX = parse_RfX;
function parse_Xnum(Xn) {
  if (Xn.length - Xn.l < 8) throw "XLS Xnum Buffer underflow";
  return Xn.read_shift(8, "f");
}
function parse_BrtColor(Xn) {
  var zn = {}, Un = Xn.read_shift(1), Kn = Un >>> 1, qn = Xn.read_shift(1), Jo = Xn.read_shift(2, "i"), pa = Xn.read_shift(1), ma = Xn.read_shift(1), va = Xn.read_shift(1);
  switch (Xn.l++, Kn) {
    case 0:
      zn.auto = 1;
      break;
    case 1:
      zn.index = qn;
      var ba = XLSIcv[qn];
      ba && (zn.rgb = rgb2Hex(ba));
      break;
    case 2:
      zn.rgb = rgb2Hex([pa, ma, va]);
      break;
    case 3:
      zn.theme = qn;
      break;
  }
  return Jo != 0 && (zn.tint = Jo > 0 ? Jo / 32767 : Jo / 32768), zn;
}
function parse_FontFlags(Xn) {
  var zn = Xn.read_shift(1);
  Xn.l++;
  var Un = {
    fBold: zn & 1,
    fItalic: zn & 2,
    fUnderline: zn & 4,
    fStrikeout: zn & 8,
    fOutline: zn & 16,
    fShadow: zn & 32,
    fCondense: zn & 64,
    fExtend: zn & 128
  };
  return Un;
}
function parse_ClipboardFormatOrString(Xn, zn) {
  var Un = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" }, Kn = Xn.read_shift(4);
  switch (Kn) {
    case 0:
      return "";
    case 4294967295:
    case 4294967294:
      return Un[Xn.read_shift(4)] || "";
  }
  if (Kn > 400) throw new Error("Unsupported Clipboard: " + Kn.toString(16));
  return Xn.l -= 4, Xn.read_shift(0, zn == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(Xn) {
  return parse_ClipboardFormatOrString(Xn, 1);
}
function parse_ClipboardFormatOrUnicodeString(Xn) {
  return parse_ClipboardFormatOrString(Xn, 2);
}
var VT_I2 = 2, VT_I4 = 3, VT_BOOL = 11, VT_VARIANT = 12, VT_UI4 = 19, VT_FILETIME = 64, VT_BLOB = 65, VT_CF = 71, VT_VECTOR_VARIANT = 4108, VT_VECTOR_LPSTR = 4126, VT_STRING = 80, VT_USTR = 81, VT_CUSTOM = [VT_STRING, VT_USTR], DocSummaryPIDDSI = {
  /*::[*/
  1: { n: "CodePage", t: VT_I2 },
  /*::[*/
  2: { n: "Category", t: VT_STRING },
  /*::[*/
  3: { n: "PresentationFormat", t: VT_STRING },
  /*::[*/
  4: { n: "ByteCount", t: VT_I4 },
  /*::[*/
  5: { n: "LineCount", t: VT_I4 },
  /*::[*/
  6: { n: "ParagraphCount", t: VT_I4 },
  /*::[*/
  7: { n: "SlideCount", t: VT_I4 },
  /*::[*/
  8: { n: "NoteCount", t: VT_I4 },
  /*::[*/
  9: { n: "HiddenCount", t: VT_I4 },
  /*::[*/
  10: { n: "MultimediaClipCount", t: VT_I4 },
  /*::[*/
  11: { n: "ScaleCrop", t: VT_BOOL },
  /*::[*/
  12: {
    n: "HeadingPairs",
    t: VT_VECTOR_VARIANT
    /* VT_VECTOR | VT_VARIANT */
  },
  /*::[*/
  13: {
    n: "TitlesOfParts",
    t: VT_VECTOR_LPSTR
    /* VT_VECTOR | VT_LPSTR */
  },
  /*::[*/
  14: { n: "Manager", t: VT_STRING },
  /*::[*/
  15: { n: "Company", t: VT_STRING },
  /*::[*/
  16: { n: "LinksUpToDate", t: VT_BOOL },
  /*::[*/
  17: { n: "CharacterCount", t: VT_I4 },
  /*::[*/
  19: { n: "SharedDoc", t: VT_BOOL },
  /*::[*/
  22: { n: "HyperlinksChanged", t: VT_BOOL },
  /*::[*/
  23: { n: "AppVersion", t: VT_I4, p: "version" },
  /*::[*/
  24: { n: "DigSig", t: VT_BLOB },
  /*::[*/
  26: { n: "ContentType", t: VT_STRING },
  /*::[*/
  27: { n: "ContentStatus", t: VT_STRING },
  /*::[*/
  28: { n: "Language", t: VT_STRING },
  /*::[*/
  29: { n: "Version", t: VT_STRING },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: VT_UI4 },
  /*::[*/
  2147483651: { n: "Behavior", t: VT_UI4 },
  /*::[*/
  1919054434: {}
}, SummaryPIDSI = {
  /*::[*/
  1: { n: "CodePage", t: VT_I2 },
  /*::[*/
  2: { n: "Title", t: VT_STRING },
  /*::[*/
  3: { n: "Subject", t: VT_STRING },
  /*::[*/
  4: { n: "Author", t: VT_STRING },
  /*::[*/
  5: { n: "Keywords", t: VT_STRING },
  /*::[*/
  6: { n: "Comments", t: VT_STRING },
  /*::[*/
  7: { n: "Template", t: VT_STRING },
  /*::[*/
  8: { n: "LastAuthor", t: VT_STRING },
  /*::[*/
  9: { n: "RevNumber", t: VT_STRING },
  /*::[*/
  10: { n: "EditTime", t: VT_FILETIME },
  /*::[*/
  11: { n: "LastPrinted", t: VT_FILETIME },
  /*::[*/
  12: { n: "CreatedDate", t: VT_FILETIME },
  /*::[*/
  13: { n: "ModifiedDate", t: VT_FILETIME },
  /*::[*/
  14: { n: "PageCount", t: VT_I4 },
  /*::[*/
  15: { n: "WordCount", t: VT_I4 },
  /*::[*/
  16: { n: "CharCount", t: VT_I4 },
  /*::[*/
  17: { n: "Thumbnail", t: VT_CF },
  /*::[*/
  18: { n: "Application", t: VT_STRING },
  /*::[*/
  19: { n: "DocSecurity", t: VT_I4 },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: VT_UI4 },
  /*::[*/
  2147483651: { n: "Behavior", t: VT_UI4 },
  /*::[*/
  1919054434: {}
}, CountryEnum = {
  /*::[*/
  1: "US",
  // United States
  /*::[*/
  2: "CA",
  // Canada
  /*::[*/
  3: "",
  // Latin America (except Brazil)
  /*::[*/
  7: "RU",
  // Russia
  /*::[*/
  20: "EG",
  // Egypt
  /*::[*/
  30: "GR",
  // Greece
  /*::[*/
  31: "NL",
  // Netherlands
  /*::[*/
  32: "BE",
  // Belgium
  /*::[*/
  33: "FR",
  // France
  /*::[*/
  34: "ES",
  // Spain
  /*::[*/
  36: "HU",
  // Hungary
  /*::[*/
  39: "IT",
  // Italy
  /*::[*/
  41: "CH",
  // Switzerland
  /*::[*/
  43: "AT",
  // Austria
  /*::[*/
  44: "GB",
  // United Kingdom
  /*::[*/
  45: "DK",
  // Denmark
  /*::[*/
  46: "SE",
  // Sweden
  /*::[*/
  47: "NO",
  // Norway
  /*::[*/
  48: "PL",
  // Poland
  /*::[*/
  49: "DE",
  // Germany
  /*::[*/
  52: "MX",
  // Mexico
  /*::[*/
  55: "BR",
  // Brazil
  /*::[*/
  61: "AU",
  // Australia
  /*::[*/
  64: "NZ",
  // New Zealand
  /*::[*/
  66: "TH",
  // Thailand
  /*::[*/
  81: "JP",
  // Japan
  /*::[*/
  82: "KR",
  // Korea
  /*::[*/
  84: "VN",
  // Viet Nam
  /*::[*/
  86: "CN",
  // China
  /*::[*/
  90: "TR",
  // Turkey
  /*::[*/
  105: "JS",
  // Ramastan
  /*::[*/
  213: "DZ",
  // Algeria
  /*::[*/
  216: "MA",
  // Morocco
  /*::[*/
  218: "LY",
  // Libya
  /*::[*/
  351: "PT",
  // Portugal
  /*::[*/
  354: "IS",
  // Iceland
  /*::[*/
  358: "FI",
  // Finland
  /*::[*/
  420: "CZ",
  // Czech Republic
  /*::[*/
  886: "TW",
  // Taiwan
  /*::[*/
  961: "LB",
  // Lebanon
  /*::[*/
  962: "JO",
  // Jordan
  /*::[*/
  963: "SY",
  // Syria
  /*::[*/
  964: "IQ",
  // Iraq
  /*::[*/
  965: "KW",
  // Kuwait
  /*::[*/
  966: "SA",
  // Saudi Arabia
  /*::[*/
  971: "AE",
  // United Arab Emirates
  /*::[*/
  972: "IL",
  // Israel
  /*::[*/
  974: "QA",
  // Qatar
  /*::[*/
  981: "IR",
  // Iran
  /*::[*/
  65535: "US"
  // United States
}, XLSFillPattern = [
  null,
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
];
function rgbify(Xn) {
  return Xn.map(function(zn) {
    return [zn >> 16 & 255, zn >> 8 & 255, zn & 255];
  });
}
var _XLSIcv = /* @__PURE__ */ rgbify([
  /* Color Constants */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  /* Overridable Defaults */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  8388608,
  32768,
  128,
  8421376,
  8388736,
  32896,
  12632256,
  8421504,
  10066431,
  10040166,
  16777164,
  13434879,
  6684774,
  16744576,
  26316,
  13421823,
  128,
  16711935,
  16776960,
  65535,
  8388736,
  8388608,
  32896,
  255,
  52479,
  13434879,
  13434828,
  16777113,
  10079487,
  16751052,
  13408767,
  16764057,
  3368703,
  3394764,
  10079232,
  16763904,
  16750848,
  16737792,
  6710937,
  9868950,
  13158,
  3381606,
  13056,
  3355392,
  10040064,
  10040166,
  3355545,
  3355443,
  /* Other entries to appease BIFF8/12 */
  16777215,
  /* 0x40 icvForeground ?? */
  0,
  /* 0x41 icvBackground ?? */
  0,
  /* 0x42 icvFrame ?? */
  0,
  /* 0x43 icv3D ?? */
  0,
  /* 0x44 icv3DText ?? */
  0,
  /* 0x45 icv3DHilite ?? */
  0,
  /* 0x46 icv3DShadow ?? */
  0,
  /* 0x47 icvHilite ?? */
  0,
  /* 0x48 icvCtlText ?? */
  0,
  /* 0x49 icvCtlScrl ?? */
  0,
  /* 0x4A icvCtlInv ?? */
  0,
  /* 0x4B icvCtlBody ?? */
  0,
  /* 0x4C icvCtlFrame ?? */
  0,
  /* 0x4D icvCtlFore ?? */
  0,
  /* 0x4E icvCtlBack ?? */
  0,
  /* 0x4F icvCtlNeutral */
  0,
  /* 0x50 icvInfoBk ?? */
  0
  /* 0x51 icvInfoText ?? */
]), XLSIcv = /* @__PURE__ */ dup(_XLSIcv), BErr = {
  /*::[*/
  0: "#NULL!",
  /*::[*/
  7: "#DIV/0!",
  /*::[*/
  15: "#VALUE!",
  /*::[*/
  23: "#REF!",
  /*::[*/
  29: "#NAME?",
  /*::[*/
  36: "#NUM!",
  /*::[*/
  42: "#N/A",
  /*::[*/
  43: "#GETTING_DATA",
  /*::[*/
  255: "#WTF?"
}, RBErr = {
  "#NULL!": 0,
  "#DIV/0!": 7,
  "#VALUE!": 15,
  "#REF!": 23,
  "#NAME?": 29,
  "#NUM!": 36,
  "#N/A": 42,
  "#GETTING_DATA": 43,
  "#WTF?": 255
}, ct2type = {
  /* Workbook */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
  /* Worksheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  "application/vnd.ms-excel.worksheet": "sheets",
  "application/vnd.ms-excel.binIndexWs": "TODO",
  /* Binary Index */
  /* Chartsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  "application/vnd.ms-excel.chartsheet": "charts",
  /* Macrosheet */
  "application/vnd.ms-excel.macrosheet+xml": "macros",
  "application/vnd.ms-excel.macrosheet": "macros",
  "application/vnd.ms-excel.intlmacrosheet": "TODO",
  "application/vnd.ms-excel.binIndexMs": "TODO",
  /* Binary Index */
  /* Dialogsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  "application/vnd.ms-excel.dialogsheet": "dialogs",
  /* Shared Strings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  "application/vnd.ms-excel.sharedStrings": "strs",
  /* Styles */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  "application/vnd.ms-excel.styles": "styles",
  /* File Properties */
  "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
  /* Custom Data Properties */
  "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
  /* Comments */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  "application/vnd.ms-excel.comments": "comments",
  "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  "application/vnd.ms-excel.person+xml": "people",
  /* Metadata (Stock/Geography and Dynamic Array) */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  "application/vnd.ms-excel.sheetMetadata": "metadata",
  /* PivotTable */
  "application/vnd.ms-excel.pivotTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
  /* Chart Objects */
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
  /* Chart Colors */
  "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
  /* Chart Style */
  "application/vnd.ms-office.chartstyle+xml": "TODO",
  /* Chart Advanced */
  "application/vnd.ms-office.chartex+xml": "TODO",
  /* Calculation Chain */
  "application/vnd.ms-excel.calcChain": "calcchains",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
  /* Printer Settings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
  /* ActiveX */
  "application/vnd.ms-office.activeX": "TODO",
  "application/vnd.ms-office.activeX+xml": "TODO",
  /* Custom Toolbars */
  "application/vnd.ms-excel.attachedToolbars": "TODO",
  /* External Data Connections */
  "application/vnd.ms-excel.connections": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
  /* External Links */
  "application/vnd.ms-excel.externalLink": "links",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
  /* PivotCache */
  "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  "application/vnd.ms-excel.pivotCacheRecords": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
  /* Query Table */
  "application/vnd.ms-excel.queryTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
  /* Shared Workbook */
  "application/vnd.ms-excel.userNames": "TODO",
  "application/vnd.ms-excel.revisionHeaders": "TODO",
  "application/vnd.ms-excel.revisionLog": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
  /* Single Cell Table */
  "application/vnd.ms-excel.tableSingleCells": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
  /* Slicer */
  "application/vnd.ms-excel.slicer": "TODO",
  "application/vnd.ms-excel.slicerCache": "TODO",
  "application/vnd.ms-excel.slicer+xml": "TODO",
  "application/vnd.ms-excel.slicerCache+xml": "TODO",
  /* Sort Map */
  "application/vnd.ms-excel.wsSortMap": "TODO",
  /* Table */
  "application/vnd.ms-excel.table": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
  /* Themes */
  "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
  /* Theme Override */
  "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
  /* Timeline */
  "application/vnd.ms-excel.Timeline+xml": "TODO",
  /* verify */
  "application/vnd.ms-excel.TimelineCache+xml": "TODO",
  /* verify */
  /* VBA */
  "application/vnd.ms-office.vbaProject": "vba",
  "application/vnd.ms-office.vbaProjectSignature": "TODO",
  /* Volatile Dependencies */
  "application/vnd.ms-office.volatileDependencies": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
  /* Control Properties */
  "application/vnd.ms-excel.controlproperties+xml": "TODO",
  /* Data Model */
  "application/vnd.openxmlformats-officedocument.model+data": "TODO",
  /* Survey */
  "application/vnd.ms-excel.Survey+xml": "TODO",
  /* Drawing */
  "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
  /* VML */
  "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
  "application/vnd.openxmlformats-package.relationships+xml": "rels",
  "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
  /* Image */
  "image/png": "TODO",
  sheet: "js"
};
function new_ct() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ""
  };
}
function parse_ct(Xn) {
  var zn = new_ct();
  if (!Xn || !Xn.match) return zn;
  var Un = {};
  if ((Xn.match(tagregex) || []).forEach(function(Kn) {
    var qn = parsexmltag(Kn);
    switch (qn[0].replace(nsregex, "<")) {
      case "<?xml":
        break;
      case "<Types":
        zn.xmlns = qn["xmlns" + (qn[0].match(/<(\w+):/) || ["", ""])[1]];
        break;
      case "<Default":
        Un[qn.Extension] = qn.ContentType;
        break;
      case "<Override":
        zn[ct2type[qn.ContentType]] !== void 0 && zn[ct2type[qn.ContentType]].push(qn.PartName);
        break;
    }
  }), zn.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + zn.xmlns);
  return zn.calcchain = zn.calcchains.length > 0 ? zn.calcchains[0] : "", zn.sst = zn.strs.length > 0 ? zn.strs[0] : "", zn.style = zn.styles.length > 0 ? zn.styles[0] : "", zn.defaults = Un, delete zn.calcchains, zn;
}
var RELS = {
  WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
  CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
  CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
  CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
  SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
  CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
  CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
  WS: [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  ],
  DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
  MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
  IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
  DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
};
function get_rels_path(Xn) {
  var zn = Xn.lastIndexOf("/");
  return Xn.slice(0, zn + 1) + "_rels/" + Xn.slice(zn + 1) + ".rels";
}
function parse_rels(Xn, zn) {
  var Un = { "!id": {} };
  if (!Xn) return Un;
  zn.charAt(0) !== "/" && (zn = "/" + zn);
  var Kn = {};
  return (Xn.match(tagregex) || []).forEach(function(qn) {
    var Jo = parsexmltag(qn);
    if (Jo[0] === "<Relationship") {
      var pa = {};
      pa.Type = Jo.Type, pa.Target = Jo.Target, pa.Id = Jo.Id, Jo.TargetMode && (pa.TargetMode = Jo.TargetMode);
      var ma = Jo.TargetMode === "External" ? Jo.Target : resolve_path(Jo.Target, zn);
      Un[ma] = pa, Kn[Jo.Id] = pa;
    }
  }), Un["!id"] = Kn, Un;
}
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(Xn, zn) {
  for (var Un = xlml_normalize(Xn), Kn, qn; Kn = xlmlregex.exec(Un); ) switch (Kn[3]) {
    case "manifest":
      break;
    // 4.2 <manifest:manifest>
    case "file-entry":
      if (qn = parsexmltag(Kn[0], !1), qn.path == "/" && qn.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
      break;
    case "encryption-data":
    // 4.4 <manifest:encryption-data>
    case "algorithm":
    // 4.5 <manifest:algorithm>
    case "start-key-generation":
    // 4.6 <manifest:start-key-generation>
    case "key-derivation":
      throw new Error("Unsupported ODS Encryption");
    default:
      if (zn && zn.WTF) throw Kn;
  }
}
var CORE_PROPS = [
  ["cp:category", "Category"],
  ["cp:contentStatus", "ContentStatus"],
  ["cp:keywords", "Keywords"],
  ["cp:lastModifiedBy", "LastAuthor"],
  ["cp:lastPrinted", "LastPrinted"],
  ["cp:revision", "RevNumber"],
  ["cp:version", "Version"],
  ["dc:creator", "Author"],
  ["dc:description", "Comments"],
  ["dc:identifier", "Identifier"],
  ["dc:language", "Language"],
  ["dc:subject", "Subject"],
  ["dc:title", "Title"],
  ["dcterms:created", "CreatedDate", "date"],
  ["dcterms:modified", "ModifiedDate", "date"]
], CORE_PROPS_REGEX = /* @__PURE__ */ function() {
  for (var Xn = new Array(CORE_PROPS.length), zn = 0; zn < CORE_PROPS.length; ++zn) {
    var Un = CORE_PROPS[zn], Kn = "(?:" + Un[0].slice(0, Un[0].indexOf(":")) + ":)" + Un[0].slice(Un[0].indexOf(":") + 1);
    Xn[zn] = new RegExp("<" + Kn + "[^>]*>([\\s\\S]*?)</" + Kn + ">");
  }
  return Xn;
}();
function parse_core_props(Xn) {
  var zn = {};
  Xn = utf8read(Xn);
  for (var Un = 0; Un < CORE_PROPS.length; ++Un) {
    var Kn = CORE_PROPS[Un], qn = Xn.match(CORE_PROPS_REGEX[Un]);
    qn != null && qn.length > 0 && (zn[Kn[1]] = unescapexml(qn[1])), Kn[2] === "date" && zn[Kn[1]] && (zn[Kn[1]] = parseDate$1(zn[Kn[1]]));
  }
  return zn;
}
var EXT_PROPS = [
  ["Application", "Application", "string"],
  ["AppVersion", "AppVersion", "string"],
  ["Company", "Company", "string"],
  ["DocSecurity", "DocSecurity", "string"],
  ["Manager", "Manager", "string"],
  ["HyperlinksChanged", "HyperlinksChanged", "bool"],
  ["SharedDoc", "SharedDoc", "bool"],
  ["LinksUpToDate", "LinksUpToDate", "bool"],
  ["ScaleCrop", "ScaleCrop", "bool"],
  ["HeadingPairs", "HeadingPairs", "raw"],
  ["TitlesOfParts", "TitlesOfParts", "raw"]
];
function load_props_pairs(Xn, zn, Un, Kn) {
  var qn = [];
  if (typeof Xn == "string") qn = parseVector(Xn, Kn);
  else for (var Jo = 0; Jo < Xn.length; ++Jo) qn = qn.concat(Xn[Jo].map(function(_a) {
    return { v: _a };
  }));
  var pa = typeof zn == "string" ? parseVector(zn, Kn).map(function(_a) {
    return _a.v;
  }) : zn, ma = 0, va = 0;
  if (pa.length > 0) for (var ba = 0; ba !== qn.length; ba += 2) {
    switch (va = +qn[ba + 1].v, qn[ba].v) {
      case "Worksheets":
      case "工作表":
      case "Листы":
      case "أوراق العمل":
      case "ワークシート":
      case "גליונות עבודה":
      case "Arbeitsblätter":
      case "Çalışma Sayfaları":
      case "Feuilles de calcul":
      case "Fogli di lavoro":
      case "Folhas de cálculo":
      case "Planilhas":
      case "Regneark":
      case "Hojas de cálculo":
      case "Werkbladen":
        Un.Worksheets = va, Un.SheetNames = pa.slice(ma, ma + va);
        break;
      case "Named Ranges":
      case "Rangos con nombre":
      case "名前付き一覧":
      case "Benannte Bereiche":
      case "Navngivne områder":
        Un.NamedRanges = va, Un.DefinedNames = pa.slice(ma, ma + va);
        break;
      case "Charts":
      case "Diagramme":
        Un.Chartsheets = va, Un.ChartNames = pa.slice(ma, ma + va);
        break;
    }
    ma += va;
  }
}
function parse_ext_props(Xn, zn, Un) {
  var Kn = {};
  return zn || (zn = {}), Xn = utf8read(Xn), EXT_PROPS.forEach(function(qn) {
    var Jo = (Xn.match(matchtag(qn[0])) || [])[1];
    switch (qn[2]) {
      case "string":
        Jo && (zn[qn[1]] = unescapexml(Jo));
        break;
      case "bool":
        zn[qn[1]] = Jo === "true";
        break;
      case "raw":
        var pa = Xn.match(new RegExp("<" + qn[0] + "[^>]*>([\\s\\S]*?)</" + qn[0] + ">"));
        pa && pa.length > 0 && (Kn[qn[1]] = pa[1]);
        break;
    }
  }), Kn.HeadingPairs && Kn.TitlesOfParts && load_props_pairs(Kn.HeadingPairs, Kn.TitlesOfParts, zn, Un), zn;
}
var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(Xn, zn) {
  var Un = {}, Kn = "", qn = Xn.match(custregex);
  if (qn) for (var Jo = 0; Jo != qn.length; ++Jo) {
    var pa = qn[Jo], ma = parsexmltag(pa);
    switch (ma[0]) {
      case "<?xml":
        break;
      case "<Properties":
        break;
      case "<property":
        Kn = unescapexml(ma.name);
        break;
      case "</property>":
        Kn = null;
        break;
      default:
        if (pa.indexOf("<vt:") === 0) {
          var va = pa.split(">"), ba = va[0].slice(4), _a = va[1];
          switch (ba) {
            case "lpstr":
            case "bstr":
            case "lpwstr":
              Un[Kn] = unescapexml(_a);
              break;
            case "bool":
              Un[Kn] = parsexmlbool(_a);
              break;
            case "i1":
            case "i2":
            case "i4":
            case "i8":
            case "int":
            case "uint":
              Un[Kn] = parseInt(_a, 10);
              break;
            case "r4":
            case "r8":
            case "decimal":
              Un[Kn] = parseFloat(_a);
              break;
            case "filetime":
            case "date":
              Un[Kn] = parseDate$1(_a);
              break;
            case "cy":
            case "error":
              Un[Kn] = unescapexml(_a);
              break;
            default:
              if (ba.slice(-1) == "/") break;
              zn.WTF && typeof console < "u" && console.warn("Unexpected", pa, ba, va);
          }
        } else if (pa.slice(0, 2) !== "</") {
          if (zn.WTF) throw new Error(pa);
        }
    }
  }
  return Un;
}
var XLMLDocPropsMap = {
  Title: "Title",
  Subject: "Subject",
  Author: "Author",
  Keywords: "Keywords",
  Comments: "Description",
  LastAuthor: "LastAuthor",
  RevNumber: "Revision",
  Application: "AppName",
  /* TotalTime: 'TotalTime', */
  LastPrinted: "LastPrinted",
  CreatedDate: "Created",
  ModifiedDate: "LastSaved",
  /* Pages */
  /* Words */
  /* Characters */
  Category: "Category",
  /* PresentationFormat */
  Manager: "Manager",
  Company: "Company",
  /* Guid */
  /* HyperlinkBase */
  /* Bytes */
  /* Lines */
  /* Paragraphs */
  /* CharactersWithSpaces */
  AppVersion: "Version",
  ContentStatus: "ContentStatus",
  /* NOTE: missing from schema */
  Identifier: "Identifier",
  /* NOTE: missing from schema */
  Language: "Language"
  /* NOTE: missing from schema */
}, evert_XLMLDPM;
function xlml_set_prop(Xn, zn, Un) {
  evert_XLMLDPM || (evert_XLMLDPM = evert(XLMLDocPropsMap)), zn = evert_XLMLDPM[zn] || zn, Xn[zn] = Un;
}
function parse_FILETIME(Xn) {
  var zn = Xn.read_shift(4), Un = Xn.read_shift(4);
  return new Date((Un / 1e7 * Math.pow(2, 32) + zn / 1e7 - 11644473600) * 1e3).toISOString().replace(/\.000/, "");
}
function parse_lpstr(Xn, zn, Un) {
  var Kn = Xn.l, qn = Xn.read_shift(0, "lpstr-cp");
  if (Un) for (; Xn.l - Kn & 3; ) ++Xn.l;
  return qn;
}
function parse_lpwstr(Xn, zn, Un) {
  var Kn = Xn.read_shift(0, "lpwstr");
  return Kn;
}
function parse_VtStringBase(Xn, zn, Un) {
  return zn === 31 ? parse_lpwstr(Xn) : parse_lpstr(Xn, zn, Un);
}
function parse_VtString(Xn, zn, Un) {
  return parse_VtStringBase(Xn, zn, Un === !1 ? 0 : 4);
}
function parse_VtUnalignedString(Xn, zn) {
  if (!zn) throw new Error("VtUnalignedString must have positive length");
  return parse_VtStringBase(Xn, zn, 0);
}
function parse_VtVecLpwstrValue(Xn) {
  for (var zn = Xn.read_shift(4), Un = [], Kn = 0; Kn != zn; ++Kn) {
    var qn = Xn.l;
    Un[Kn] = Xn.read_shift(0, "lpwstr").replace(chr0, ""), Xn.l - qn & 2 && (Xn.l += 2);
  }
  return Un;
}
function parse_VtVecUnalignedLpstrValue(Xn) {
  for (var zn = Xn.read_shift(4), Un = [], Kn = 0; Kn != zn; ++Kn) Un[Kn] = Xn.read_shift(0, "lpstr-cp").replace(chr0, "");
  return Un;
}
function parse_VtHeadingPair(Xn) {
  var zn = Xn.l, Un = parse_TypedPropertyValue(Xn, VT_USTR);
  Xn[Xn.l] == 0 && Xn[Xn.l + 1] == 0 && Xn.l - zn & 2 && (Xn.l += 2);
  var Kn = parse_TypedPropertyValue(Xn, VT_I4);
  return [Un, Kn];
}
function parse_VtVecHeadingPairValue(Xn) {
  for (var zn = Xn.read_shift(4), Un = [], Kn = 0; Kn < zn / 2; ++Kn) Un.push(parse_VtHeadingPair(Xn));
  return Un;
}
function parse_dictionary(Xn, zn) {
  for (var Un = Xn.read_shift(4), Kn = {}, qn = 0; qn != Un; ++qn) {
    var Jo = Xn.read_shift(4), pa = Xn.read_shift(4);
    Kn[Jo] = Xn.read_shift(pa, zn === 1200 ? "utf16le" : "utf8").replace(chr0, "").replace(chr1, "!"), zn === 1200 && pa % 2 && (Xn.l += 2);
  }
  return Xn.l & 3 && (Xn.l = Xn.l >> 3 << 2), Kn;
}
function parse_BLOB(Xn) {
  var zn = Xn.read_shift(4), Un = Xn.slice(Xn.l, Xn.l + zn);
  return Xn.l += zn, (zn & 3) > 0 && (Xn.l += 4 - (zn & 3) & 3), Un;
}
function parse_ClipboardData(Xn) {
  var zn = {};
  return zn.Size = Xn.read_shift(4), Xn.l += zn.Size + 3 - (zn.Size - 1) % 4, zn;
}
function parse_TypedPropertyValue(Xn, zn, Un) {
  var Kn = Xn.read_shift(2), qn, Jo = Un || {};
  if (Xn.l += 2, zn !== VT_VARIANT && Kn !== zn && VT_CUSTOM.indexOf(zn) === -1 && !((zn & 65534) == 4126 && (Kn & 65534) == 4126))
    throw new Error("Expected type " + zn + " saw " + Kn);
  switch (zn === VT_VARIANT ? Kn : zn) {
    case 2:
      return qn = Xn.read_shift(2, "i"), Jo.raw || (Xn.l += 2), qn;
    case 3:
      return qn = Xn.read_shift(4, "i"), qn;
    case 11:
      return Xn.read_shift(4) !== 0;
    case 19:
      return qn = Xn.read_shift(4), qn;
    case 30:
      return parse_lpstr(Xn, Kn, 4).replace(chr0, "");
    case 31:
      return parse_lpwstr(Xn);
    case 64:
      return parse_FILETIME(Xn);
    case 65:
      return parse_BLOB(Xn);
    case 71:
      return parse_ClipboardData(Xn);
    case 80:
      return parse_VtString(Xn, Kn, !Jo.raw).replace(chr0, "");
    case 81:
      return parse_VtUnalignedString(
        Xn,
        Kn
        /*, 4*/
      ).replace(chr0, "");
    case 4108:
      return parse_VtVecHeadingPairValue(Xn);
    case 4126:
    case 4127:
      return Kn == 4127 ? parse_VtVecLpwstrValue(Xn) : parse_VtVecUnalignedLpstrValue(Xn);
    default:
      throw new Error("TypedPropertyValue unrecognized type " + zn + " " + Kn);
  }
}
function parse_PropertySet(Xn, zn) {
  var Un = Xn.l, Kn = Xn.read_shift(4), qn = Xn.read_shift(4), Jo = [], pa = 0, ma = 0, va = -1, ba = {};
  for (pa = 0; pa != qn; ++pa) {
    var _a = Xn.read_shift(4), ya = Xn.read_shift(4);
    Jo[pa] = [_a, ya + Un];
  }
  Jo.sort(function(Za, Na) {
    return Za[1] - Na[1];
  });
  var xa = {};
  for (pa = 0; pa != qn; ++pa) {
    if (Xn.l !== Jo[pa][1]) {
      var wa = !0;
      if (pa > 0 && zn) switch (zn[Jo[pa - 1][0]].t) {
        case 2:
          Xn.l + 2 === Jo[pa][1] && (Xn.l += 2, wa = !1);
          break;
        case 80:
          Xn.l <= Jo[pa][1] && (Xn.l = Jo[pa][1], wa = !1);
          break;
        case 4108:
          Xn.l <= Jo[pa][1] && (Xn.l = Jo[pa][1], wa = !1);
          break;
      }
      if ((!zn || pa == 0) && Xn.l <= Jo[pa][1] && (wa = !1, Xn.l = Jo[pa][1]), wa) throw new Error("Read Error: Expected address " + Jo[pa][1] + " at " + Xn.l + " :" + pa);
    }
    if (zn) {
      var Ta = zn[Jo[pa][0]];
      if (xa[Ta.n] = parse_TypedPropertyValue(Xn, Ta.t, { raw: !0 }), Ta.p === "version" && (xa[Ta.n] = String(xa[Ta.n] >> 16) + "." + ("0000" + String(xa[Ta.n] & 65535)).slice(-4)), Ta.n == "CodePage") switch (xa[Ta.n]) {
        case 0:
          xa[Ta.n] = 1252;
        /* falls through */
        case 874:
        case 932:
        case 936:
        case 949:
        case 950:
        case 1250:
        case 1251:
        case 1253:
        case 1254:
        case 1255:
        case 1256:
        case 1257:
        case 1258:
        case 1e4:
        case 1200:
        case 1201:
        case 1252:
        case 65e3:
        case -536:
        case 65001:
        case -535:
          set_cp(ma = xa[Ta.n] >>> 0 & 65535);
          break;
        default:
          throw new Error("Unsupported CodePage: " + xa[Ta.n]);
      }
    } else if (Jo[pa][0] === 1) {
      if (ma = xa.CodePage = parse_TypedPropertyValue(Xn, VT_I2), set_cp(ma), va !== -1) {
        var Sa = Xn.l;
        Xn.l = Jo[va][1], ba = parse_dictionary(Xn, ma), Xn.l = Sa;
      }
    } else if (Jo[pa][0] === 0) {
      if (ma === 0) {
        va = pa, Xn.l = Jo[pa + 1][1];
        continue;
      }
      ba = parse_dictionary(Xn, ma);
    } else {
      var Ma = ba[Jo[pa][0]], ka;
      switch (Xn[Xn.l]) {
        case 65:
          Xn.l += 4, ka = parse_BLOB(Xn);
          break;
        case 30:
          Xn.l += 4, ka = parse_VtString(Xn, Xn[Xn.l - 4]).replace(/\u0000+$/, "");
          break;
        case 31:
          Xn.l += 4, ka = parse_VtString(Xn, Xn[Xn.l - 4]).replace(/\u0000+$/, "");
          break;
        case 3:
          Xn.l += 4, ka = Xn.read_shift(4, "i");
          break;
        case 19:
          Xn.l += 4, ka = Xn.read_shift(4);
          break;
        case 5:
          Xn.l += 4, ka = Xn.read_shift(8, "f");
          break;
        case 11:
          Xn.l += 4, ka = parsebool(Xn, 4);
          break;
        case 64:
          Xn.l += 4, ka = parseDate$1(parse_FILETIME(Xn));
          break;
        default:
          throw new Error("unparsed value: " + Xn[Xn.l]);
      }
      xa[Ma] = ka;
    }
  }
  return Xn.l = Un + Kn, xa;
}
function parse_PropertySetStream(Xn, zn, Un) {
  var Kn = Xn.content;
  if (!Kn) return {};
  prep_blob(Kn, 0);
  var qn, Jo, pa, ma, va = 0;
  Kn.chk("feff", "Byte Order: "), Kn.read_shift(2);
  var ba = Kn.read_shift(4), _a = Kn.read_shift(16);
  if (_a !== CFB.utils.consts.HEADER_CLSID && _a !== Un) throw new Error("Bad PropertySet CLSID " + _a);
  if (qn = Kn.read_shift(4), qn !== 1 && qn !== 2) throw new Error("Unrecognized #Sets: " + qn);
  if (Jo = Kn.read_shift(16), ma = Kn.read_shift(4), qn === 1 && ma !== Kn.l) throw new Error("Length mismatch: " + ma + " !== " + Kn.l);
  qn === 2 && (pa = Kn.read_shift(16), va = Kn.read_shift(4));
  var ya = parse_PropertySet(Kn, zn), xa = { SystemIdentifier: ba };
  for (var wa in ya) xa[wa] = ya[wa];
  if (xa.FMTID = Jo, qn === 1) return xa;
  if (va - Kn.l == 2 && (Kn.l += 2), Kn.l !== va) throw new Error("Length mismatch 2: " + Kn.l + " !== " + va);
  var Ta;
  try {
    Ta = parse_PropertySet(Kn, null);
  } catch {
  }
  for (wa in Ta) xa[wa] = Ta[wa];
  return xa.FMTID = [Jo, pa], xa;
}
function parsenoop2(Xn, zn) {
  return Xn.read_shift(zn), null;
}
function parslurp(Xn, zn, Un) {
  for (var Kn = [], qn = Xn.l + zn; Xn.l < qn; ) Kn.push(Un(Xn, qn - Xn.l));
  if (qn !== Xn.l) throw new Error("Slurp error");
  return Kn;
}
function parsebool(Xn, zn) {
  return Xn.read_shift(zn) === 1;
}
function parseuint16(Xn) {
  return Xn.read_shift(2, "u");
}
function parseuint16a(Xn, zn) {
  return parslurp(Xn, zn, parseuint16);
}
function parse_Bes(Xn) {
  var zn = Xn.read_shift(1), Un = Xn.read_shift(1);
  return Un === 1 ? zn : zn === 1;
}
function parse_ShortXLUnicodeString(Xn, zn, Un) {
  var Kn = Xn.read_shift(Un && Un.biff >= 12 ? 2 : 1), qn = "sbcs-cont";
  if (Un && Un.biff >= 8, !Un || Un.biff == 8) {
    var Jo = Xn.read_shift(1);
    Jo && (qn = "dbcs-cont");
  } else Un.biff == 12 && (qn = "wstr");
  Un.biff >= 2 && Un.biff <= 5 && (qn = "cpstr");
  var pa = Kn ? Xn.read_shift(Kn, qn) : "";
  return pa;
}
function parse_XLUnicodeRichExtendedString(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(1), Kn = Un & 4, qn = Un & 8, Jo = 1 + (Un & 1), pa = 0, ma, va = {};
  qn && (pa = Xn.read_shift(2)), Kn && (ma = Xn.read_shift(4));
  var ba = Jo == 2 ? "dbcs-cont" : "sbcs-cont", _a = zn === 0 ? "" : Xn.read_shift(zn, ba);
  return qn && (Xn.l += 4 * pa), Kn && (Xn.l += ma), va.t = _a, qn || (va.raw = "<t>" + va.t + "</t>", va.r = va.t), va;
}
function parse_XLUnicodeStringNoCch(Xn, zn, Un) {
  var Kn;
  if (Un) {
    if (Un.biff >= 2 && Un.biff <= 5) return Xn.read_shift(zn, "cpstr");
    if (Un.biff >= 12) return Xn.read_shift(zn, "dbcs-cont");
  }
  var qn = Xn.read_shift(1);
  return qn === 0 ? Kn = Xn.read_shift(zn, "sbcs-cont") : Kn = Xn.read_shift(zn, "dbcs-cont"), Kn;
}
function parse_XLUnicodeString(Xn, zn, Un) {
  var Kn = Xn.read_shift(Un && Un.biff == 2 ? 1 : 2);
  return Kn === 0 ? (Xn.l++, "") : parse_XLUnicodeStringNoCch(Xn, Kn, Un);
}
function parse_XLUnicodeString2(Xn, zn, Un) {
  if (Un.biff > 5) return parse_XLUnicodeString(Xn, zn, Un);
  var Kn = Xn.read_shift(1);
  return Kn === 0 ? (Xn.l++, "") : Xn.read_shift(Kn, Un.biff <= 4 || !Xn.lens ? "cpstr" : "sbcs-cont");
}
function parse_ControlInfo(Xn) {
  var zn = Xn.read_shift(1);
  Xn.l++;
  var Un = Xn.read_shift(2);
  return Xn.l += 2, [zn, Un];
}
function parse_URLMoniker(Xn) {
  var zn = Xn.read_shift(4), Un = Xn.l, Kn = !1;
  zn > 24 && (Xn.l += zn - 24, Xn.read_shift(16) === "795881f43b1d7f48af2c825dc4852763" && (Kn = !0), Xn.l = Un);
  var qn = Xn.read_shift((Kn ? zn - 24 : zn) >> 1, "utf16le").replace(chr0, "");
  return Kn && (Xn.l += 24), qn;
}
function parse_FileMoniker(Xn) {
  for (var zn = Xn.read_shift(2), Un = ""; zn-- > 0; ) Un += "../";
  var Kn = Xn.read_shift(0, "lpstr-ansi");
  if (Xn.l += 2, Xn.read_shift(2) != 57005) throw new Error("Bad FileMoniker");
  var qn = Xn.read_shift(4);
  if (qn === 0) return Un + Kn.replace(/\\/g, "/");
  var Jo = Xn.read_shift(4);
  if (Xn.read_shift(2) != 3) throw new Error("Bad FileMoniker");
  var pa = Xn.read_shift(Jo >> 1, "utf16le").replace(chr0, "");
  return Un + pa;
}
function parse_HyperlinkMoniker(Xn, zn) {
  var Un = Xn.read_shift(16);
  switch (Un) {
    case "e0c9ea79f9bace118c8200aa004ba90b":
      return parse_URLMoniker(Xn);
    case "0303000000000000c000000000000046":
      return parse_FileMoniker(Xn);
    default:
      throw new Error("Unsupported Moniker " + Un);
  }
}
function parse_HyperlinkString(Xn) {
  var zn = Xn.read_shift(4), Un = zn > 0 ? Xn.read_shift(zn, "utf16le").replace(chr0, "") : "";
  return Un;
}
function parse_Hyperlink(Xn, zn) {
  var Un = Xn.l + zn, Kn = Xn.read_shift(4);
  if (Kn !== 2) throw new Error("Unrecognized streamVersion: " + Kn);
  var qn = Xn.read_shift(2);
  Xn.l += 2;
  var Jo, pa, ma, va, ba = "", _a, ya;
  qn & 16 && (Jo = parse_HyperlinkString(Xn, Un - Xn.l)), qn & 128 && (pa = parse_HyperlinkString(Xn, Un - Xn.l)), (qn & 257) === 257 && (ma = parse_HyperlinkString(Xn, Un - Xn.l)), (qn & 257) === 1 && (va = parse_HyperlinkMoniker(Xn, Un - Xn.l)), qn & 8 && (ba = parse_HyperlinkString(Xn, Un - Xn.l)), qn & 32 && (_a = Xn.read_shift(16)), qn & 64 && (ya = parse_FILETIME(
    Xn
    /*, 8*/
  )), Xn.l = Un;
  var xa = pa || ma || va || "";
  xa && ba && (xa += "#" + ba), xa || (xa = "#" + ba), qn & 2 && xa.charAt(0) == "/" && xa.charAt(1) != "/" && (xa = "file://" + xa);
  var wa = { Target: xa };
  return _a && (wa.guid = _a), ya && (wa.time = ya), Jo && (wa.Tooltip = Jo), wa;
}
function parse_LongRGBA(Xn) {
  var zn = Xn.read_shift(1), Un = Xn.read_shift(1), Kn = Xn.read_shift(1), qn = Xn.read_shift(1);
  return [zn, Un, Kn, qn];
}
function parse_LongRGB(Xn, zn) {
  var Un = parse_LongRGBA(Xn);
  return Un[3] = 0, Un;
}
function parse_XLSCell(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = Xn.read_shift(2);
  return { r: zn, c: Un, ixfe: Kn };
}
function parse_frtHeader(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2);
  return Xn.l += 8, { type: zn, flags: Un };
}
function parse_OptXLUnicodeString(Xn, zn, Un) {
  return zn === 0 ? "" : parse_XLUnicodeString2(Xn, zn, Un);
}
function parse_XTI(Xn, zn, Un) {
  var Kn = Un.biff > 8 ? 4 : 2, qn = Xn.read_shift(Kn), Jo = Xn.read_shift(Kn, "i"), pa = Xn.read_shift(Kn, "i");
  return [qn, Jo, pa];
}
function parse_RkRec(Xn) {
  var zn = Xn.read_shift(2), Un = parse_RkNumber(Xn);
  return [zn, Un];
}
function parse_AddinUdf(Xn, zn, Un) {
  Xn.l += 4, zn -= 4;
  var Kn = Xn.l + zn, qn = parse_ShortXLUnicodeString(Xn, zn, Un), Jo = Xn.read_shift(2);
  if (Kn -= Xn.l, Jo !== Kn) throw new Error("Malformed AddinUdf: padding = " + Kn + " != " + Jo);
  return Xn.l += Jo, qn;
}
function parse_Ref8U(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = Xn.read_shift(2), qn = Xn.read_shift(2);
  return { s: { c: Kn, r: zn }, e: { c: qn, r: Un } };
}
function parse_RefU(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = Xn.read_shift(1), qn = Xn.read_shift(1);
  return { s: { c: Kn, r: zn }, e: { c: qn, r: Un } };
}
var parse_Ref = parse_RefU;
function parse_FtCmo(Xn) {
  Xn.l += 4;
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = Xn.read_shift(2);
  return Xn.l += 12, [Un, zn, Kn];
}
function parse_FtNts(Xn) {
  var zn = {};
  return Xn.l += 4, Xn.l += 16, zn.fSharedNote = Xn.read_shift(2), Xn.l += 4, zn;
}
function parse_FtCf(Xn) {
  var zn = {};
  return Xn.l += 4, Xn.cf = Xn.read_shift(2), zn;
}
function parse_FtSkip(Xn) {
  Xn.l += 2, Xn.l += Xn.read_shift(2);
}
var FtTab = {
  /*::[*/
  0: parse_FtSkip,
  /* FtEnd */
  /*::[*/
  4: parse_FtSkip,
  /* FtMacro */
  /*::[*/
  5: parse_FtSkip,
  /* FtButton */
  /*::[*/
  6: parse_FtSkip,
  /* FtGmo */
  /*::[*/
  7: parse_FtCf,
  /* FtCf */
  /*::[*/
  8: parse_FtSkip,
  /* FtPioGrbit */
  /*::[*/
  9: parse_FtSkip,
  /* FtPictFmla */
  /*::[*/
  10: parse_FtSkip,
  /* FtCbls */
  /*::[*/
  11: parse_FtSkip,
  /* FtRbo */
  /*::[*/
  12: parse_FtSkip,
  /* FtSbs */
  /*::[*/
  13: parse_FtNts,
  /* FtNts */
  /*::[*/
  14: parse_FtSkip,
  /* FtSbsFmla */
  /*::[*/
  15: parse_FtSkip,
  /* FtGboData */
  /*::[*/
  16: parse_FtSkip,
  /* FtEdoData */
  /*::[*/
  17: parse_FtSkip,
  /* FtRboData */
  /*::[*/
  18: parse_FtSkip,
  /* FtCblsData */
  /*::[*/
  19: parse_FtSkip,
  /* FtLbsData */
  /*::[*/
  20: parse_FtSkip,
  /* FtCblsFmla */
  /*::[*/
  21: parse_FtCmo
};
function parse_FtArray(Xn, zn) {
  for (var Un = Xn.l + zn, Kn = []; Xn.l < Un; ) {
    var qn = Xn.read_shift(2);
    Xn.l -= 2;
    try {
      Kn.push(FtTab[qn](Xn, Un - Xn.l));
    } catch {
      return Xn.l = Un, Kn;
    }
  }
  return Xn.l != Un && (Xn.l = Un), Kn;
}
function parse_BOF(Xn, zn) {
  var Un = { BIFFVer: 0, dt: 0 };
  switch (Un.BIFFVer = Xn.read_shift(2), zn -= 2, zn >= 2 && (Un.dt = Xn.read_shift(2), Xn.l -= 2), Un.BIFFVer) {
    case 1536:
    /* BIFF8 */
    case 1280:
    /* BIFF5 */
    case 1024:
    /* BIFF4 */
    case 768:
    /* BIFF3 */
    case 512:
    /* BIFF2 */
    case 2:
    case 7:
      break;
    default:
      if (zn > 6) throw new Error("Unexpected BIFF Ver " + Un.BIFFVer);
  }
  return Xn.read_shift(zn), Un;
}
function parse_InterfaceHdr(Xn, zn) {
  return zn === 0 || Xn.read_shift(2), 1200;
}
function parse_WriteAccess(Xn, zn, Un) {
  if (Un.enc)
    return Xn.l += zn, "";
  var Kn = Xn.l, qn = parse_XLUnicodeString2(Xn, 0, Un);
  return Xn.read_shift(zn + Kn - Xn.l), qn;
}
function parse_WsBool(Xn, zn, Un) {
  var Kn = Un && Un.biff == 8 || zn == 2 ? Xn.read_shift(2) : (Xn.l += zn, 0);
  return { fDialog: Kn & 16, fBelow: Kn & 64, fRight: Kn & 128 };
}
function parse_BoundSheet8(Xn, zn, Un) {
  var Kn = Xn.read_shift(4), qn = Xn.read_shift(1) & 3, Jo = Xn.read_shift(1);
  switch (Jo) {
    case 0:
      Jo = "Worksheet";
      break;
    case 1:
      Jo = "Macrosheet";
      break;
    case 2:
      Jo = "Chartsheet";
      break;
    case 6:
      Jo = "VBAModule";
      break;
  }
  var pa = parse_ShortXLUnicodeString(Xn, 0, Un);
  return pa.length === 0 && (pa = "Sheet1"), { pos: Kn, hs: qn, dt: Jo, name: pa };
}
function parse_SST(Xn, zn) {
  for (var Un = Xn.l + zn, Kn = Xn.read_shift(4), qn = Xn.read_shift(4), Jo = [], pa = 0; pa != qn && Xn.l < Un; ++pa)
    Jo.push(parse_XLUnicodeRichExtendedString(Xn));
  return Jo.Count = Kn, Jo.Unique = qn, Jo;
}
function parse_ExtSST(Xn, zn) {
  var Un = {};
  return Un.dsst = Xn.read_shift(2), Xn.l += zn - 2, Un;
}
function parse_Row(Xn) {
  var zn = {};
  zn.r = Xn.read_shift(2), zn.c = Xn.read_shift(2), zn.cnt = Xn.read_shift(2) - zn.c;
  var Un = Xn.read_shift(2);
  Xn.l += 4;
  var Kn = Xn.read_shift(1);
  return Xn.l += 3, Kn & 7 && (zn.level = Kn & 7), Kn & 32 && (zn.hidden = !0), Kn & 64 && (zn.hpt = Un / 20), zn;
}
function parse_ForceFullCalculation(Xn) {
  var zn = parse_frtHeader(Xn);
  if (zn.type != 2211) throw new Error("Invalid Future Record " + zn.type);
  var Un = Xn.read_shift(4);
  return Un !== 0;
}
function parse_RecalcId(Xn) {
  return Xn.read_shift(2), Xn.read_shift(4);
}
function parse_DefaultRowHeight(Xn, zn, Un) {
  var Kn = 0;
  Un && Un.biff == 2 || (Kn = Xn.read_shift(2));
  var qn = Xn.read_shift(2);
  Un && Un.biff == 2 && (Kn = 1 - (qn >> 15), qn &= 32767);
  var Jo = { Unsynced: Kn & 1, DyZero: (Kn & 2) >> 1, ExAsc: (Kn & 4) >> 2, ExDsc: (Kn & 8) >> 3 };
  return [Jo, qn];
}
function parse_Window1(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = Xn.read_shift(2), qn = Xn.read_shift(2), Jo = Xn.read_shift(2), pa = Xn.read_shift(2), ma = Xn.read_shift(2), va = Xn.read_shift(2), ba = Xn.read_shift(2);
  return {
    Pos: [zn, Un],
    Dim: [Kn, qn],
    Flags: Jo,
    CurTab: pa,
    FirstTab: ma,
    Selected: va,
    TabRatio: ba
  };
}
function parse_Window2(Xn, zn, Un) {
  if (Un && Un.biff >= 2 && Un.biff < 5) return {};
  var Kn = Xn.read_shift(2);
  return { RTL: Kn & 64 };
}
function parse_Pane() {
}
function parse_Font(Xn, zn, Un) {
  var Kn = {
    dyHeight: Xn.read_shift(2),
    fl: Xn.read_shift(2)
  };
  switch (Un && Un.biff || 8) {
    case 2:
      break;
    case 3:
    case 4:
      Xn.l += 2;
      break;
    default:
      Xn.l += 10;
      break;
  }
  return Kn.name = parse_ShortXLUnicodeString(Xn, 0, Un), Kn;
}
function parse_LabelSst(Xn) {
  var zn = parse_XLSCell(Xn);
  return zn.isst = Xn.read_shift(4), zn;
}
function parse_Label(Xn, zn, Un) {
  Un.biffguess && Un.biff == 2 && (Un.biff = 5);
  var Kn = Xn.l + zn, qn = parse_XLSCell(Xn);
  Un.biff == 2 && Xn.l++;
  var Jo = parse_XLUnicodeString(Xn, Kn - Xn.l, Un);
  return qn.val = Jo, qn;
}
function parse_Format(Xn, zn, Un) {
  var Kn = Xn.read_shift(2), qn = parse_XLUnicodeString2(Xn, 0, Un);
  return [Kn, qn];
}
var parse_BIFF2Format = parse_XLUnicodeString2;
function parse_Dimensions(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = Un.biff == 8 || !Un.biff ? 4 : 2, Jo = Xn.read_shift(qn), pa = Xn.read_shift(qn), ma = Xn.read_shift(2), va = Xn.read_shift(2);
  return Xn.l = Kn, { s: { r: Jo, c: ma }, e: { r: pa, c: va } };
}
function parse_RK(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = parse_RkRec(Xn);
  return { r: zn, c: Un, ixfe: Kn[0], rknum: Kn[1] };
}
function parse_MulRk(Xn, zn) {
  for (var Un = Xn.l + zn - 2, Kn = Xn.read_shift(2), qn = Xn.read_shift(2), Jo = []; Xn.l < Un; ) Jo.push(parse_RkRec(Xn));
  if (Xn.l !== Un) throw new Error("MulRK read error");
  var pa = Xn.read_shift(2);
  if (Jo.length != pa - qn + 1) throw new Error("MulRK length mismatch");
  return { r: Kn, c: qn, C: pa, rkrec: Jo };
}
function parse_MulBlank(Xn, zn) {
  for (var Un = Xn.l + zn - 2, Kn = Xn.read_shift(2), qn = Xn.read_shift(2), Jo = []; Xn.l < Un; ) Jo.push(Xn.read_shift(2));
  if (Xn.l !== Un) throw new Error("MulBlank read error");
  var pa = Xn.read_shift(2);
  if (Jo.length != pa - qn + 1) throw new Error("MulBlank length mismatch");
  return { r: Kn, c: qn, C: pa, ixfe: Jo };
}
function parse_CellStyleXF(Xn, zn, Un, Kn) {
  var qn = {}, Jo = Xn.read_shift(4), pa = Xn.read_shift(4), ma = Xn.read_shift(4), va = Xn.read_shift(2);
  return qn.patternType = XLSFillPattern[ma >> 26], Kn.cellStyles && (qn.alc = Jo & 7, qn.fWrap = Jo >> 3 & 1, qn.alcV = Jo >> 4 & 7, qn.fJustLast = Jo >> 7 & 1, qn.trot = Jo >> 8 & 255, qn.cIndent = Jo >> 16 & 15, qn.fShrinkToFit = Jo >> 20 & 1, qn.iReadOrder = Jo >> 22 & 2, qn.fAtrNum = Jo >> 26 & 1, qn.fAtrFnt = Jo >> 27 & 1, qn.fAtrAlc = Jo >> 28 & 1, qn.fAtrBdr = Jo >> 29 & 1, qn.fAtrPat = Jo >> 30 & 1, qn.fAtrProt = Jo >> 31 & 1, qn.dgLeft = pa & 15, qn.dgRight = pa >> 4 & 15, qn.dgTop = pa >> 8 & 15, qn.dgBottom = pa >> 12 & 15, qn.icvLeft = pa >> 16 & 127, qn.icvRight = pa >> 23 & 127, qn.grbitDiag = pa >> 30 & 3, qn.icvTop = ma & 127, qn.icvBottom = ma >> 7 & 127, qn.icvDiag = ma >> 14 & 127, qn.dgDiag = ma >> 21 & 15, qn.icvFore = va & 127, qn.icvBack = va >> 7 & 127, qn.fsxButton = va >> 14 & 1), qn;
}
function parse_XF(Xn, zn, Un) {
  var Kn = {};
  return Kn.ifnt = Xn.read_shift(2), Kn.numFmtId = Xn.read_shift(2), Kn.flags = Xn.read_shift(2), Kn.fStyle = Kn.flags >> 2 & 1, zn -= 6, Kn.data = parse_CellStyleXF(Xn, zn, Kn.fStyle, Un), Kn;
}
function parse_Guts(Xn) {
  Xn.l += 4;
  var zn = [Xn.read_shift(2), Xn.read_shift(2)];
  if (zn[0] !== 0 && zn[0]--, zn[1] !== 0 && zn[1]--, zn[0] > 7 || zn[1] > 7) throw new Error("Bad Gutters: " + zn.join("|"));
  return zn;
}
function parse_BoolErr(Xn, zn, Un) {
  var Kn = parse_XLSCell(Xn);
  (Un.biff == 2 || zn == 9) && ++Xn.l;
  var qn = parse_Bes(Xn);
  return Kn.val = qn, Kn.t = qn === !0 || qn === !1 ? "b" : "e", Kn;
}
function parse_Number(Xn, zn, Un) {
  Un.biffguess && Un.biff == 2 && (Un.biff = 5);
  var Kn = parse_XLSCell(Xn), qn = parse_Xnum(Xn);
  return Kn.val = qn, Kn;
}
var parse_XLHeaderFooter = parse_OptXLUnicodeString;
function parse_SupBook(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = Xn.read_shift(2), Jo = Xn.read_shift(2);
  if (Un.sbcch = Jo, Jo == 1025 || Jo == 14849) return [Jo, qn];
  if (Jo < 1 || Jo > 255) throw new Error("Unexpected SupBook type: " + Jo);
  for (var pa = parse_XLUnicodeStringNoCch(Xn, Jo), ma = []; Kn > Xn.l; ) ma.push(parse_XLUnicodeString(Xn));
  return [Jo, qn, pa, ma];
}
function parse_ExternName(Xn, zn, Un) {
  var Kn = Xn.read_shift(2), qn, Jo = {
    fBuiltIn: Kn & 1,
    fWantAdvise: Kn >>> 1 & 1,
    fWantPict: Kn >>> 2 & 1,
    fOle: Kn >>> 3 & 1,
    fOleLink: Kn >>> 4 & 1,
    cf: Kn >>> 5 & 1023,
    fIcon: Kn >>> 15 & 1
  };
  return Un.sbcch === 14849 && (qn = parse_AddinUdf(Xn, zn - 2, Un)), Jo.body = qn || Xn.read_shift(zn - 2), typeof qn == "string" && (Jo.Name = qn), Jo;
}
var XLSLblBuiltIn = [
  "_xlnm.Consolidate_Area",
  "_xlnm.Auto_Open",
  "_xlnm.Auto_Close",
  "_xlnm.Extract",
  "_xlnm.Database",
  "_xlnm.Criteria",
  "_xlnm.Print_Area",
  "_xlnm.Print_Titles",
  "_xlnm.Recorder",
  "_xlnm.Data_Form",
  "_xlnm.Auto_Activate",
  "_xlnm.Auto_Deactivate",
  "_xlnm.Sheet_Title",
  "_xlnm._FilterDatabase"
];
function parse_Lbl(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = Xn.read_shift(2), Jo = Xn.read_shift(1), pa = Xn.read_shift(1), ma = Xn.read_shift(Un && Un.biff == 2 ? 1 : 2), va = 0;
  (!Un || Un.biff >= 5) && (Un.biff != 5 && (Xn.l += 2), va = Xn.read_shift(2), Un.biff == 5 && (Xn.l += 2), Xn.l += 4);
  var ba = parse_XLUnicodeStringNoCch(Xn, pa, Un);
  qn & 32 && (ba = XLSLblBuiltIn[ba.charCodeAt(0)]);
  var _a = Kn - Xn.l;
  Un && Un.biff == 2 && --_a;
  var ya = Kn == Xn.l || ma === 0 || !(_a > 0) ? [] : parse_NameParsedFormula(Xn, _a, Un, ma);
  return {
    chKey: Jo,
    Name: ba,
    itab: va,
    rgce: ya
  };
}
function parse_ExternSheet(Xn, zn, Un) {
  if (Un.biff < 8) return parse_BIFF5ExternSheet(Xn, zn, Un);
  for (var Kn = [], qn = Xn.l + zn, Jo = Xn.read_shift(Un.biff > 8 ? 4 : 2); Jo-- !== 0; ) Kn.push(parse_XTI(Xn, Un.biff > 8 ? 12 : 6, Un));
  if (Xn.l != qn) throw new Error("Bad ExternSheet: " + Xn.l + " != " + qn);
  return Kn;
}
function parse_BIFF5ExternSheet(Xn, zn, Un) {
  Xn[Xn.l + 1] == 3 && Xn[Xn.l]++;
  var Kn = parse_ShortXLUnicodeString(Xn, zn, Un);
  return Kn.charCodeAt(0) == 3 ? Kn.slice(1) : Kn;
}
function parse_NameCmt(Xn, zn, Un) {
  if (Un.biff < 8) {
    Xn.l += zn;
    return;
  }
  var Kn = Xn.read_shift(2), qn = Xn.read_shift(2), Jo = parse_XLUnicodeStringNoCch(Xn, Kn, Un), pa = parse_XLUnicodeStringNoCch(Xn, qn, Un);
  return [Jo, pa];
}
function parse_ShrFmla(Xn, zn, Un) {
  var Kn = parse_RefU(Xn);
  Xn.l++;
  var qn = Xn.read_shift(1);
  return zn -= 8, [parse_SharedParsedFormula(Xn, zn, Un), qn, Kn];
}
function parse_Array(Xn, zn, Un) {
  var Kn = parse_Ref(Xn);
  switch (Un.biff) {
    case 2:
      Xn.l++, zn -= 7;
      break;
    case 3:
    case 4:
      Xn.l += 2, zn -= 8;
      break;
    default:
      Xn.l += 6, zn -= 12;
  }
  return [Kn, parse_ArrayParsedFormula(Xn, zn, Un)];
}
function parse_MTRSettings(Xn) {
  var zn = Xn.read_shift(4) !== 0, Un = Xn.read_shift(4) !== 0, Kn = Xn.read_shift(4);
  return [zn, Un, Kn];
}
function parse_NoteSh(Xn, zn, Un) {
  if (!(Un.biff < 8)) {
    var Kn = Xn.read_shift(2), qn = Xn.read_shift(2), Jo = Xn.read_shift(2), pa = Xn.read_shift(2), ma = parse_XLUnicodeString2(Xn, 0, Un);
    return Un.biff < 8 && Xn.read_shift(1), [{ r: Kn, c: qn }, ma, pa, Jo];
  }
}
function parse_Note(Xn, zn, Un) {
  return parse_NoteSh(Xn, zn, Un);
}
function parse_MergeCells(Xn, zn) {
  for (var Un = [], Kn = Xn.read_shift(2); Kn--; ) Un.push(parse_Ref8U(Xn));
  return Un;
}
function parse_Obj(Xn, zn, Un) {
  if (Un && Un.biff < 8) return parse_BIFF5Obj(Xn, zn, Un);
  var Kn = parse_FtCmo(Xn), qn = parse_FtArray(Xn, zn - 22, Kn[1]);
  return { cmo: Kn, ft: qn };
}
var parse_BIFF5OT = {
  8: function(Xn, zn) {
    var Un = Xn.l + zn;
    Xn.l += 10;
    var Kn = Xn.read_shift(2);
    Xn.l += 4, Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 4;
    var qn = Xn.read_shift(1);
    return Xn.l += qn, Xn.l = Un, { fmt: Kn };
  }
};
function parse_BIFF5Obj(Xn, zn, Un) {
  Xn.l += 4;
  var Kn = Xn.read_shift(2), qn = Xn.read_shift(2), Jo = Xn.read_shift(2);
  Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 2, Xn.l += 6, zn -= 36;
  var pa = [];
  return pa.push((parse_BIFF5OT[Kn] || parsenoop)(Xn, zn, Un)), { cmo: [qn, Kn, Jo], ft: pa };
}
function parse_TxO(Xn, zn, Un) {
  var Kn = Xn.l, qn = "";
  try {
    Xn.l += 4;
    var Jo = (Un.lastobj || { cmo: [0, 0] }).cmo[1], pa;
    [0, 5, 7, 11, 12, 14].indexOf(Jo) == -1 ? Xn.l += 6 : pa = parse_ControlInfo(Xn, 6, Un);
    var ma = Xn.read_shift(2);
    Xn.read_shift(2), parseuint16(Xn, 2);
    var va = Xn.read_shift(2);
    Xn.l += va;
    for (var ba = 1; ba < Xn.lens.length - 1; ++ba) {
      if (Xn.l - Kn != Xn.lens[ba]) throw new Error("TxO: bad continue record");
      var _a = Xn[Xn.l], ya = parse_XLUnicodeStringNoCch(Xn, Xn.lens[ba + 1] - Xn.lens[ba] - 1);
      if (qn += ya, qn.length >= (_a ? ma : 2 * ma)) break;
    }
    if (qn.length !== ma && qn.length !== ma * 2)
      throw new Error("cchText: " + ma + " != " + qn.length);
    return Xn.l = Kn + zn, { t: qn };
  } catch {
    return Xn.l = Kn + zn, { t: qn };
  }
}
function parse_HLink(Xn, zn) {
  var Un = parse_Ref8U(Xn);
  Xn.l += 16;
  var Kn = parse_Hyperlink(Xn, zn - 24);
  return [Un, Kn];
}
function parse_HLinkTooltip(Xn, zn) {
  Xn.read_shift(2);
  var Un = parse_Ref8U(Xn), Kn = Xn.read_shift((zn - 10) / 2, "dbcs-cont");
  return Kn = Kn.replace(chr0, ""), [Un, Kn];
}
function parse_Country(Xn) {
  var zn = [0, 0], Un;
  return Un = Xn.read_shift(2), zn[0] = CountryEnum[Un] || Un, Un = Xn.read_shift(2), zn[1] = CountryEnum[Un] || Un, zn;
}
function parse_ClrtClient(Xn) {
  for (var zn = Xn.read_shift(2), Un = []; zn-- > 0; ) Un.push(parse_LongRGB(Xn));
  return Un;
}
function parse_Palette(Xn) {
  for (var zn = Xn.read_shift(2), Un = []; zn-- > 0; ) Un.push(parse_LongRGB(Xn));
  return Un;
}
function parse_XFCRC(Xn) {
  Xn.l += 2;
  var zn = { cxfs: 0, crc: 0 };
  return zn.cxfs = Xn.read_shift(2), zn.crc = Xn.read_shift(4), zn;
}
function parse_ColInfo(Xn, zn, Un) {
  if (!Un.cellStyles) return parsenoop(Xn, zn);
  var Kn = Un && Un.biff >= 12 ? 4 : 2, qn = Xn.read_shift(Kn), Jo = Xn.read_shift(Kn), pa = Xn.read_shift(Kn), ma = Xn.read_shift(Kn), va = Xn.read_shift(2);
  Kn == 2 && (Xn.l += 2);
  var ba = { s: qn, e: Jo, w: pa, ixfe: ma, flags: va };
  return (Un.biff >= 5 || !Un.biff) && (ba.level = va >> 8 & 7), ba;
}
function parse_Setup(Xn, zn) {
  var Un = {};
  return zn < 32 || (Xn.l += 16, Un.header = parse_Xnum(Xn), Un.footer = parse_Xnum(Xn), Xn.l += 2), Un;
}
function parse_ShtProps(Xn, zn, Un) {
  var Kn = { area: !1 };
  if (Un.biff != 5)
    return Xn.l += zn, Kn;
  var qn = Xn.read_shift(1);
  return Xn.l += 3, qn & 16 && (Kn.area = !0), Kn;
}
var parse_Blank = parse_XLSCell, parse_Scl = parseuint16a, parse_String = parse_XLUnicodeString;
function parse_ImData(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = Xn.read_shift(4), qn = { fmt: zn, env: Un, len: Kn, data: Xn.slice(Xn.l, Xn.l + Kn) };
  return Xn.l += Kn, qn;
}
function parse_BIFF2STR(Xn, zn, Un) {
  Un.biffguess && Un.biff == 5 && (Un.biff = 2);
  var Kn = parse_XLSCell(Xn);
  ++Xn.l;
  var qn = parse_XLUnicodeString2(Xn, zn - 7, Un);
  return Kn.t = "str", Kn.val = qn, Kn;
}
function parse_BIFF2NUM(Xn) {
  var zn = parse_XLSCell(Xn);
  ++Xn.l;
  var Un = parse_Xnum(Xn);
  return zn.t = "n", zn.val = Un, zn;
}
function parse_BIFF2INT(Xn) {
  var zn = parse_XLSCell(Xn);
  ++Xn.l;
  var Un = Xn.read_shift(2);
  return zn.t = "n", zn.val = Un, zn;
}
function parse_BIFF2STRING(Xn) {
  var zn = Xn.read_shift(1);
  return zn === 0 ? (Xn.l++, "") : Xn.read_shift(zn, "sbcs-cont");
}
function parse_BIFF2FONTXTRA(Xn, zn) {
  Xn.l += 6, Xn.l += 2, Xn.l += 1, Xn.l += 3, Xn.l += 1, Xn.l += zn - 13;
}
function parse_RString(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_XLSCell(Xn), Jo = Xn.read_shift(2), pa = parse_XLUnicodeStringNoCch(Xn, Jo, Un);
  return Xn.l = Kn, qn.t = "str", qn.val = pa, qn;
}
var DBF_SUPPORTED_VERSIONS = [2, 3, 48, 49, 131, 139, 140, 245], DBF = /* @__PURE__ */ function() {
  var Xn = {
    /* Code Pages Supported by Visual FoxPro */
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /* shapefile DBF extension */
    /*::[*/
    0: 20127,
    /*::[*/
    8: 865,
    /*::[*/
    9: 437,
    /*::[*/
    10: 850,
    /*::[*/
    11: 437,
    /*::[*/
    13: 437,
    /*::[*/
    14: 850,
    /*::[*/
    15: 437,
    /*::[*/
    16: 850,
    /*::[*/
    17: 437,
    /*::[*/
    18: 850,
    /*::[*/
    19: 932,
    /*::[*/
    20: 850,
    /*::[*/
    21: 437,
    /*::[*/
    22: 850,
    /*::[*/
    23: 865,
    /*::[*/
    24: 437,
    /*::[*/
    25: 437,
    /*::[*/
    26: 850,
    /*::[*/
    27: 437,
    /*::[*/
    28: 863,
    /*::[*/
    29: 850,
    /*::[*/
    31: 852,
    /*::[*/
    34: 852,
    /*::[*/
    35: 852,
    /*::[*/
    36: 860,
    /*::[*/
    37: 850,
    /*::[*/
    38: 866,
    /*::[*/
    55: 850,
    /*::[*/
    64: 852,
    /*::[*/
    77: 936,
    /*::[*/
    78: 949,
    /*::[*/
    79: 950,
    /*::[*/
    80: 874,
    /*::[*/
    87: 1252,
    /*::[*/
    88: 1252,
    /*::[*/
    89: 1252,
    /*::[*/
    108: 863,
    /*::[*/
    134: 737,
    /*::[*/
    135: 852,
    /*::[*/
    136: 857,
    /*::[*/
    204: 1257,
    /*::[*/
    255: 16969
  }, zn = evert({
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /*::[*/
    0: 20127
  });
  function Un(ma, va) {
    var ba = [], _a = new_raw_buf(1);
    switch (va.type) {
      case "base64":
        _a = s2a(Base64_decode(ma));
        break;
      case "binary":
        _a = s2a(ma);
        break;
      case "buffer":
      case "array":
        _a = ma;
        break;
    }
    prep_blob(_a, 0);
    var ya = _a.read_shift(1), xa = !!(ya & 136), wa = !1, Ta = !1;
    switch (ya) {
      case 2:
        break;
      // dBASE II
      case 3:
        break;
      // dBASE III
      case 48:
        wa = !0, xa = !0;
        break;
      // VFP
      case 49:
        wa = !0, xa = !0;
        break;
      // VFP with autoincrement
      // 0x43 dBASE IV SQL table files
      // 0x63 dBASE IV SQL system files
      case 131:
        break;
      // dBASE III with memo
      case 139:
        break;
      // dBASE IV with memo
      case 140:
        Ta = !0;
        break;
      // dBASE Level 7 with memo
      // case 0xCB dBASE IV SQL table files with memo
      case 245:
        break;
      // FoxPro 2.x with memo
      // case 0xFB FoxBASE
      default:
        throw new Error("DBF Unsupported Version: " + ya.toString(16));
    }
    var Sa = 0, Ma = 521;
    ya == 2 && (Sa = _a.read_shift(2)), _a.l += 3, ya != 2 && (Sa = _a.read_shift(4)), Sa > 1048576 && (Sa = 1e6), ya != 2 && (Ma = _a.read_shift(2));
    var ka = _a.read_shift(2), Za = va.codepage || 1252;
    ya != 2 && (_a.l += 16, _a.read_shift(1), _a[_a.l] !== 0 && (Za = Xn[_a[_a.l]]), _a.l += 1, _a.l += 2), Ta && (_a.l += 36);
    for (var Na = [], Ka = {}, Ja = Math.min(_a.length, ya == 2 ? 521 : Ma - 10 - (wa ? 264 : 0)), el = Ta ? 32 : 11; _a.l < Ja && _a[_a.l] != 13; )
      switch (Ka = {}, Ka.name = $cptable.utils.decode(Za, _a.slice(_a.l, _a.l + el)).replace(/[\u0000\r\n].*$/g, ""), _a.l += el, Ka.type = String.fromCharCode(_a.read_shift(1)), ya != 2 && !Ta && (Ka.offset = _a.read_shift(4)), Ka.len = _a.read_shift(1), ya == 2 && (Ka.offset = _a.read_shift(2)), Ka.dec = _a.read_shift(1), Ka.name.length && Na.push(Ka), ya != 2 && (_a.l += Ta ? 13 : 14), Ka.type) {
        case "B":
          (!wa || Ka.len != 8) && va.WTF && console.log("Skipping " + Ka.name + ":" + Ka.type);
          break;
        case "G":
        // General (FoxPro and dBASE L7)
        case "P":
          va.WTF && console.log("Skipping " + Ka.name + ":" + Ka.type);
          break;
        case "+":
        // Autoincrement (dBASE L7 only)
        case "0":
        // _NullFlags (VFP only)
        case "@":
        // Timestamp (dBASE L7 only)
        case "C":
        // Character (dBASE II)
        case "D":
        // Date (dBASE III)
        case "F":
        // Float (dBASE IV)
        case "I":
        // Long (VFP and dBASE L7)
        case "L":
        // Logical (dBASE II)
        case "M":
        // Memo (dBASE III)
        case "N":
        // Number (dBASE II)
        case "O":
        // Double (dBASE L7 only)
        case "T":
        // Datetime (VFP only)
        case "Y":
          break;
        default:
          throw new Error("Unknown Field Type: " + Ka.type);
      }
    if (_a[_a.l] !== 13 && (_a.l = Ma - 1), _a.read_shift(1) !== 13) throw new Error("DBF Terminator not found " + _a.l + " " + _a[_a.l]);
    _a.l = Ma;
    var qa = 0, tl = 0;
    for (ba[0] = [], tl = 0; tl != Na.length; ++tl) ba[0][tl] = Na[tl].name;
    for (; Sa-- > 0; ) {
      if (_a[_a.l] === 42) {
        _a.l += ka;
        continue;
      }
      for (++_a.l, ba[++qa] = [], tl = 0, tl = 0; tl != Na.length; ++tl) {
        var Qa = _a.slice(_a.l, _a.l + Na[tl].len);
        _a.l += Na[tl].len, prep_blob(Qa, 0);
        var nl = $cptable.utils.decode(Za, Qa);
        switch (Na[tl].type) {
          case "C":
            nl.trim().length && (ba[qa][tl] = nl.replace(/\s+$/, ""));
            break;
          case "D":
            nl.length === 8 ? ba[qa][tl] = new Date(+nl.slice(0, 4), +nl.slice(4, 6) - 1, +nl.slice(6, 8)) : ba[qa][tl] = nl;
            break;
          case "F":
            ba[qa][tl] = parseFloat(nl.trim());
            break;
          case "+":
          case "I":
            ba[qa][tl] = Ta ? Qa.read_shift(-4, "i") ^ 2147483648 : Qa.read_shift(4, "i");
            break;
          case "L":
            switch (nl.trim().toUpperCase()) {
              case "Y":
              case "T":
                ba[qa][tl] = !0;
                break;
              case "N":
              case "F":
                ba[qa][tl] = !1;
                break;
              case "":
              case "?":
                break;
              default:
                throw new Error("DBF Unrecognized L:|" + nl + "|");
            }
            break;
          case "M":
            if (!xa) throw new Error("DBF Unexpected MEMO for type " + ya.toString(16));
            ba[qa][tl] = "##MEMO##" + (Ta ? parseInt(nl.trim(), 10) : Qa.read_shift(4));
            break;
          case "N":
            nl = nl.replace(/\u0000/g, "").trim(), nl && nl != "." && (ba[qa][tl] = +nl || 0);
            break;
          case "@":
            ba[qa][tl] = new Date(Qa.read_shift(-8, "f") - 621356832e5);
            break;
          case "T":
            ba[qa][tl] = new Date((Qa.read_shift(4) - 2440588) * 864e5 + Qa.read_shift(4));
            break;
          case "Y":
            ba[qa][tl] = Qa.read_shift(4, "i") / 1e4 + Qa.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
            break;
          case "O":
            ba[qa][tl] = -Qa.read_shift(-8, "f");
            break;
          case "B":
            if (wa && Na[tl].len == 8) {
              ba[qa][tl] = Qa.read_shift(8, "f");
              break;
            }
          /* falls through */
          case "G":
          case "P":
            Qa.l += Na[tl].len;
            break;
          case "0":
            if (Na[tl].name === "_NullFlags") break;
          /* falls through */
          default:
            throw new Error("DBF Unsupported data type " + Na[tl].type);
        }
      }
    }
    if (ya != 2 && _a.l < _a.length && _a[_a.l++] != 26) throw new Error("DBF EOF Marker missing " + (_a.l - 1) + " of " + _a.length + " " + _a[_a.l - 1].toString(16));
    return va && va.sheetRows && (ba = ba.slice(0, va.sheetRows)), va.DBF = Na, ba;
  }
  function Kn(ma, va) {
    var ba = va || {};
    ba.dateNF || (ba.dateNF = "yyyymmdd");
    var _a = aoa_to_sheet(Un(ma, ba), ba);
    return _a["!cols"] = ba.DBF.map(function(ya) {
      return {
        wch: ya.len,
        DBF: ya
      };
    }), delete ba.DBF, _a;
  }
  function qn(ma, va) {
    try {
      return sheet_to_workbook(Kn(ma, va), va);
    } catch (ba) {
      if (va && va.WTF) throw ba;
    }
    return { SheetNames: [], Sheets: {} };
  }
  var Jo = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 };
  function pa(ma, va) {
    var ba = va || {};
    if (+ba.codepage >= 0 && set_cp(+ba.codepage), ba.type == "string") throw new Error("Cannot write DBF to JS string");
    var _a = buf_array(), ya = sheet_to_json(ma, { header: 1, raw: !0, cellDates: !0 }), xa = ya[0], wa = ya.slice(1), Ta = ma["!cols"] || [], Sa = 0, Ma = 0, ka = 0, Za = 1;
    for (Sa = 0; Sa < xa.length; ++Sa) {
      if (((Ta[Sa] || {}).DBF || {}).name) {
        xa[Sa] = Ta[Sa].DBF.name, ++ka;
        continue;
      }
      if (xa[Sa] != null) {
        if (++ka, typeof xa[Sa] == "number" && (xa[Sa] = xa[Sa].toString(10)), typeof xa[Sa] != "string") throw new Error("DBF Invalid column name " + xa[Sa] + " |" + typeof xa[Sa] + "|");
        if (xa.indexOf(xa[Sa]) !== Sa) {
          for (Ma = 0; Ma < 1024; ++Ma)
            if (xa.indexOf(xa[Sa] + "_" + Ma) == -1) {
              xa[Sa] += "_" + Ma;
              break;
            }
        }
      }
    }
    var Na = safe_decode_range(ma["!ref"]), Ka = [], Ja = [], el = [];
    for (Sa = 0; Sa <= Na.e.c - Na.s.c; ++Sa) {
      var qa = "", tl = "", Qa = 0, nl = [];
      for (Ma = 0; Ma < wa.length; ++Ma)
        wa[Ma][Sa] != null && nl.push(wa[Ma][Sa]);
      if (nl.length == 0 || xa[Sa] == null) {
        Ka[Sa] = "?";
        continue;
      }
      for (Ma = 0; Ma < nl.length; ++Ma) {
        switch (typeof nl[Ma]) {
          /* TODO: check if L2 compat is desired */
          case "number":
            tl = "B";
            break;
          case "string":
            tl = "C";
            break;
          case "boolean":
            tl = "L";
            break;
          case "object":
            tl = nl[Ma] instanceof Date ? "D" : "C";
            break;
          default:
            tl = "C";
        }
        Qa = Math.max(Qa, String(nl[Ma]).length), qa = qa && qa != tl ? "C" : tl;
      }
      Qa > 250 && (Qa = 250), tl = ((Ta[Sa] || {}).DBF || {}).type, tl == "C" && Ta[Sa].DBF.len > Qa && (Qa = Ta[Sa].DBF.len), qa == "B" && tl == "N" && (qa = "N", el[Sa] = Ta[Sa].DBF.dec, Qa = Ta[Sa].DBF.len), Ja[Sa] = qa == "C" || tl == "N" ? Qa : Jo[qa] || 0, Za += Ja[Sa], Ka[Sa] = qa;
    }
    var rl = _a.next(32);
    for (rl.write_shift(4, 318902576), rl.write_shift(4, wa.length), rl.write_shift(2, 296 + 32 * ka), rl.write_shift(2, Za), Sa = 0; Sa < 4; ++Sa) rl.write_shift(4, 0);
    for (rl.write_shift(4, 0 | (+zn[
      /*::String(*/
      current_ansi
      /*::)*/
    ] || 3) << 8), Sa = 0, Ma = 0; Sa < xa.length; ++Sa)
      if (xa[Sa] != null) {
        var il = _a.next(32), cl = (xa[Sa].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
        il.write_shift(1, cl, "sbcs"), il.write_shift(1, Ka[Sa] == "?" ? "C" : Ka[Sa], "sbcs"), il.write_shift(4, Ma), il.write_shift(1, Ja[Sa] || Jo[Ka[Sa]] || 0), il.write_shift(1, el[Sa] || 0), il.write_shift(1, 2), il.write_shift(4, 0), il.write_shift(1, 0), il.write_shift(4, 0), il.write_shift(4, 0), Ma += Ja[Sa] || Jo[Ka[Sa]] || 0;
      }
    var ll = _a.next(264);
    for (ll.write_shift(4, 13), Sa = 0; Sa < 65; ++Sa) ll.write_shift(4, 0);
    for (Sa = 0; Sa < wa.length; ++Sa) {
      var al = _a.next(Za);
      for (al.write_shift(1, 0), Ma = 0; Ma < xa.length; ++Ma)
        if (xa[Ma] != null)
          switch (Ka[Ma]) {
            case "L":
              al.write_shift(1, wa[Sa][Ma] == null ? 63 : wa[Sa][Ma] ? 84 : 70);
              break;
            case "B":
              al.write_shift(8, wa[Sa][Ma] || 0, "f");
              break;
            case "N":
              var sl = "0";
              for (typeof wa[Sa][Ma] == "number" && (sl = wa[Sa][Ma].toFixed(el[Ma] || 0)), ka = 0; ka < Ja[Ma] - sl.length; ++ka) al.write_shift(1, 32);
              al.write_shift(1, sl, "sbcs");
              break;
            case "D":
              wa[Sa][Ma] ? (al.write_shift(4, ("0000" + wa[Sa][Ma].getFullYear()).slice(-4), "sbcs"), al.write_shift(2, ("00" + (wa[Sa][Ma].getMonth() + 1)).slice(-2), "sbcs"), al.write_shift(2, ("00" + wa[Sa][Ma].getDate()).slice(-2), "sbcs")) : al.write_shift(8, "00000000", "sbcs");
              break;
            case "C":
              var dl = String(wa[Sa][Ma] != null ? wa[Sa][Ma] : "").slice(0, Ja[Ma]);
              for (al.write_shift(1, dl, "sbcs"), ka = 0; ka < Ja[Ma] - dl.length; ++ka) al.write_shift(1, 32);
              break;
          }
    }
    return _a.next(1).write_shift(1, 26), _a.end();
  }
  return {
    to_workbook: qn,
    to_sheet: Kn,
    from_sheet: pa
  };
}(), SYLK = /* @__PURE__ */ function() {
  var Xn = {
    AA: "À",
    BA: "Á",
    CA: "Â",
    DA: 195,
    HA: "Ä",
    JA: 197,
    AE: "È",
    BE: "É",
    CE: "Ê",
    HE: "Ë",
    AI: "Ì",
    BI: "Í",
    CI: "Î",
    HI: "Ï",
    AO: "Ò",
    BO: "Ó",
    CO: "Ô",
    DO: 213,
    HO: "Ö",
    AU: "Ù",
    BU: "Ú",
    CU: "Û",
    HU: "Ü",
    Aa: "à",
    Ba: "á",
    Ca: "â",
    Da: 227,
    Ha: "ä",
    Ja: 229,
    Ae: "è",
    Be: "é",
    Ce: "ê",
    He: "ë",
    Ai: "ì",
    Bi: "í",
    Ci: "î",
    Hi: "ï",
    Ao: "ò",
    Bo: "ó",
    Co: "ô",
    Do: 245,
    Ho: "ö",
    Au: "ù",
    Bu: "ú",
    Cu: "û",
    Hu: "ü",
    KC: "Ç",
    Kc: "ç",
    q: "æ",
    z: "œ",
    a: "Æ",
    j: "Œ",
    DN: 209,
    Dn: 241,
    Hy: 255,
    S: 169,
    c: 170,
    R: 174,
    "B ": 180,
    /*::[*/
    0: 176,
    /*::[*/
    1: 177,
    /*::[*/
    2: 178,
    /*::[*/
    3: 179,
    /*::[*/
    5: 181,
    /*::[*/
    6: 182,
    /*::[*/
    7: 183,
    Q: 185,
    k: 186,
    b: 208,
    i: 216,
    l: 222,
    s: 240,
    y: 248,
    "!": 161,
    '"': 162,
    "#": 163,
    "(": 164,
    "%": 165,
    "'": 167,
    "H ": 168,
    "+": 171,
    ";": 187,
    "<": 188,
    "=": 189,
    ">": 190,
    "?": 191,
    "{": 223
  }, zn = new RegExp("\x1BN(" + keys(Xn).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), Un = function(xa, wa) {
    var Ta = Xn[wa];
    return typeof Ta == "number" ? _getansi(Ta) : Ta;
  }, Kn = function(xa, wa, Ta) {
    var Sa = wa.charCodeAt(0) - 32 << 4 | Ta.charCodeAt(0) - 48;
    return Sa == 59 ? xa : _getansi(Sa);
  };
  Xn["|"] = 254;
  function qn(xa, wa) {
    switch (wa.type) {
      case "base64":
        return Jo(Base64_decode(xa), wa);
      case "binary":
        return Jo(xa, wa);
      case "buffer":
        return Jo(has_buf && Buffer.isBuffer(xa) ? xa.toString("binary") : a2s(xa), wa);
      case "array":
        return Jo(cc2str(xa), wa);
    }
    throw new Error("Unrecognized type " + wa.type);
  }
  function Jo(xa, wa) {
    var Ta = xa.split(/[\n\r]+/), Sa = -1, Ma = -1, ka = 0, Za = 0, Na = [], Ka = [], Ja = null, el = {}, qa = [], tl = [], Qa = [], nl = 0, rl;
    for (+wa.codepage >= 0 && set_cp(+wa.codepage); ka !== Ta.length; ++ka) {
      nl = 0;
      var il = Ta[ka].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, Kn).replace(zn, Un), cl = il.replace(/;;/g, "\0").split(";").map(function(gl) {
        return gl.replace(/\u0000/g, ";");
      }), ll = cl[0], al;
      if (il.length > 0) switch (ll) {
        case "ID":
          break;
        /* header */
        case "E":
          break;
        /* EOF */
        case "B":
          break;
        /* dimensions */
        case "O":
          break;
        /* options? */
        case "W":
          break;
        /* window? */
        case "P":
          cl[1].charAt(0) == "P" && Ka.push(il.slice(3).replace(/;;/g, ";"));
          break;
        case "C":
          var sl = !1, dl = !1, El = !1, fl = !1, Ml = -1, Sl = -1;
          for (Za = 1; Za < cl.length; ++Za) switch (cl[Za].charAt(0)) {
            case "A":
              break;
            // TODO: comment
            case "X":
              Ma = parseInt(cl[Za].slice(1)) - 1, dl = !0;
              break;
            case "Y":
              for (Sa = parseInt(cl[Za].slice(1)) - 1, dl || (Ma = 0), rl = Na.length; rl <= Sa; ++rl) Na[rl] = [];
              break;
            case "K":
              al = cl[Za].slice(1), al.charAt(0) === '"' ? al = al.slice(1, al.length - 1) : al === "TRUE" ? al = !0 : al === "FALSE" ? al = !1 : isNaN(fuzzynum(al)) ? isNaN(fuzzydate(al).getDate()) || (al = parseDate$1(al)) : (al = fuzzynum(al), Ja !== null && fmt_is_date(Ja) && (al = numdate(al))), sl = !0;
              break;
            case "E":
              fl = !0;
              var ml = rc_to_a1(cl[Za].slice(1), { r: Sa, c: Ma });
              Na[Sa][Ma] = [Na[Sa][Ma], ml];
              break;
            case "S":
              El = !0, Na[Sa][Ma] = [Na[Sa][Ma], "S5S"];
              break;
            case "G":
              break;
            // unknown
            case "R":
              Ml = parseInt(cl[Za].slice(1)) - 1;
              break;
            case "C":
              Sl = parseInt(cl[Za].slice(1)) - 1;
              break;
            default:
              if (wa && wa.WTF) throw new Error("SYLK bad record " + il);
          }
          if (sl && (Na[Sa][Ma] && Na[Sa][Ma].length == 2 ? Na[Sa][Ma][0] = al : Na[Sa][Ma] = al, Ja = null), El) {
            if (fl) throw new Error("SYLK shared formula cannot have own formula");
            var Dl = Ml > -1 && Na[Ml][Sl];
            if (!Dl || !Dl[1]) throw new Error("SYLK shared formula cannot find base");
            Na[Sa][Ma][1] = shift_formula_str(Dl[1], { r: Sa - Ml, c: Ma - Sl });
          }
          break;
        case "F":
          var _l = 0;
          for (Za = 1; Za < cl.length; ++Za) switch (cl[Za].charAt(0)) {
            case "X":
              Ma = parseInt(cl[Za].slice(1)) - 1, ++_l;
              break;
            case "Y":
              for (Sa = parseInt(cl[Za].slice(1)) - 1, rl = Na.length; rl <= Sa; ++rl) Na[rl] = [];
              break;
            case "M":
              nl = parseInt(cl[Za].slice(1)) / 20;
              break;
            case "F":
              break;
            /* ??? */
            case "G":
              break;
            /* hide grid */
            case "P":
              Ja = Ka[parseInt(cl[Za].slice(1))];
              break;
            case "S":
              break;
            /* cell style */
            case "D":
              break;
            /* column */
            case "N":
              break;
            /* font */
            case "W":
              for (Qa = cl[Za].slice(1).split(" "), rl = parseInt(Qa[0], 10); rl <= parseInt(Qa[1], 10); ++rl)
                nl = parseInt(Qa[2], 10), tl[rl - 1] = nl === 0 ? { hidden: !0 } : { wch: nl }, process_col(tl[rl - 1]);
              break;
            case "C":
              Ma = parseInt(cl[Za].slice(1)) - 1, tl[Ma] || (tl[Ma] = {});
              break;
            case "R":
              Sa = parseInt(cl[Za].slice(1)) - 1, qa[Sa] || (qa[Sa] = {}), nl > 0 ? (qa[Sa].hpt = nl, qa[Sa].hpx = pt2px(nl)) : nl === 0 && (qa[Sa].hidden = !0);
              break;
            default:
              if (wa && wa.WTF) throw new Error("SYLK bad record " + il);
          }
          _l < 1 && (Ja = null);
          break;
        default:
          if (wa && wa.WTF) throw new Error("SYLK bad record " + il);
      }
    }
    return qa.length > 0 && (el["!rows"] = qa), tl.length > 0 && (el["!cols"] = tl), wa && wa.sheetRows && (Na = Na.slice(0, wa.sheetRows)), [Na, el];
  }
  function pa(xa, wa) {
    var Ta = qn(xa, wa), Sa = Ta[0], Ma = Ta[1], ka = aoa_to_sheet(Sa, wa);
    return keys(Ma).forEach(function(Za) {
      ka[Za] = Ma[Za];
    }), ka;
  }
  function ma(xa, wa) {
    return sheet_to_workbook(pa(xa, wa), wa);
  }
  function va(xa, wa, Ta, Sa) {
    var Ma = "C;Y" + (Ta + 1) + ";X" + (Sa + 1) + ";K";
    switch (xa.t) {
      case "n":
        Ma += xa.v || 0, xa.f && !xa.F && (Ma += ";E" + a1_to_rc(xa.f, { r: Ta, c: Sa }));
        break;
      case "b":
        Ma += xa.v ? "TRUE" : "FALSE";
        break;
      case "e":
        Ma += xa.w || xa.v;
        break;
      case "d":
        Ma += '"' + (xa.w || xa.v) + '"';
        break;
      case "s":
        Ma += '"' + xa.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
        break;
    }
    return Ma;
  }
  function ba(xa, wa) {
    wa.forEach(function(Ta, Sa) {
      var Ma = "F;W" + (Sa + 1) + " " + (Sa + 1) + " ";
      Ta.hidden ? Ma += "0" : (typeof Ta.width == "number" && !Ta.wpx && (Ta.wpx = width2px(Ta.width)), typeof Ta.wpx == "number" && !Ta.wch && (Ta.wch = px2char(Ta.wpx)), typeof Ta.wch == "number" && (Ma += Math.round(Ta.wch))), Ma.charAt(Ma.length - 1) != " " && xa.push(Ma);
    });
  }
  function _a(xa, wa) {
    wa.forEach(function(Ta, Sa) {
      var Ma = "F;";
      Ta.hidden ? Ma += "M0;" : Ta.hpt ? Ma += "M" + 20 * Ta.hpt + ";" : Ta.hpx && (Ma += "M" + 20 * px2pt(Ta.hpx) + ";"), Ma.length > 2 && xa.push(Ma + "R" + (Sa + 1));
    });
  }
  function ya(xa, wa) {
    var Ta = ["ID;PWXL;N;E"], Sa = [], Ma = safe_decode_range(xa["!ref"]), ka, Za = Array.isArray(xa), Na = `\r
`;
    Ta.push("P;PGeneral"), Ta.push("F;P0;DG0G8;M255"), xa["!cols"] && ba(Ta, xa["!cols"]), xa["!rows"] && _a(Ta, xa["!rows"]), Ta.push("B;Y" + (Ma.e.r - Ma.s.r + 1) + ";X" + (Ma.e.c - Ma.s.c + 1) + ";D" + [Ma.s.c, Ma.s.r, Ma.e.c, Ma.e.r].join(" "));
    for (var Ka = Ma.s.r; Ka <= Ma.e.r; ++Ka)
      for (var Ja = Ma.s.c; Ja <= Ma.e.c; ++Ja) {
        var el = encode_cell({ r: Ka, c: Ja });
        ka = Za ? (xa[Ka] || [])[Ja] : xa[el], !(!ka || ka.v == null && (!ka.f || ka.F)) && Sa.push(va(ka, xa, Ka, Ja));
      }
    return Ta.join(Na) + Na + Sa.join(Na) + Na + "E" + Na;
  }
  return {
    to_workbook: ma,
    to_sheet: pa,
    from_sheet: ya
  };
}(), DIF = /* @__PURE__ */ function() {
  function Xn(Jo, pa) {
    switch (pa.type) {
      case "base64":
        return zn(Base64_decode(Jo), pa);
      case "binary":
        return zn(Jo, pa);
      case "buffer":
        return zn(has_buf && Buffer.isBuffer(Jo) ? Jo.toString("binary") : a2s(Jo), pa);
      case "array":
        return zn(cc2str(Jo), pa);
    }
    throw new Error("Unrecognized type " + pa.type);
  }
  function zn(Jo, pa) {
    for (var ma = Jo.split(`
`), va = -1, ba = -1, _a = 0, ya = []; _a !== ma.length; ++_a) {
      if (ma[_a].trim() === "BOT") {
        ya[++va] = [], ba = 0;
        continue;
      }
      if (!(va < 0)) {
        var xa = ma[_a].trim().split(","), wa = xa[0], Ta = xa[1];
        ++_a;
        for (var Sa = ma[_a] || ""; (Sa.match(/["]/g) || []).length & 1 && _a < ma.length - 1; ) Sa += `
` + ma[++_a];
        switch (Sa = Sa.trim(), +wa) {
          case -1:
            if (Sa === "BOT") {
              ya[++va] = [], ba = 0;
              continue;
            } else if (Sa !== "EOD") throw new Error("Unrecognized DIF special command " + Sa);
            break;
          case 0:
            Sa === "TRUE" ? ya[va][ba] = !0 : Sa === "FALSE" ? ya[va][ba] = !1 : isNaN(fuzzynum(Ta)) ? isNaN(fuzzydate(Ta).getDate()) ? ya[va][ba] = Ta : ya[va][ba] = parseDate$1(Ta) : ya[va][ba] = fuzzynum(Ta), ++ba;
            break;
          case 1:
            Sa = Sa.slice(1, Sa.length - 1), Sa = Sa.replace(/""/g, '"'), Sa && Sa.match(/^=".*"$/) && (Sa = Sa.slice(2, -1)), ya[va][ba++] = Sa !== "" ? Sa : null;
            break;
        }
        if (Sa === "EOD") break;
      }
    }
    return pa && pa.sheetRows && (ya = ya.slice(0, pa.sheetRows)), ya;
  }
  function Un(Jo, pa) {
    return aoa_to_sheet(Xn(Jo, pa), pa);
  }
  function Kn(Jo, pa) {
    return sheet_to_workbook(Un(Jo, pa), pa);
  }
  var qn = /* @__PURE__ */ function() {
    var Jo = function(va, ba, _a, ya, xa) {
      va.push(ba), va.push(_a + "," + ya), va.push('"' + xa.replace(/"/g, '""') + '"');
    }, pa = function(va, ba, _a, ya) {
      va.push(ba + "," + _a), va.push(ba == 1 ? '"' + ya.replace(/"/g, '""') + '"' : ya);
    };
    return function(va) {
      var ba = [], _a = safe_decode_range(va["!ref"]), ya, xa = Array.isArray(va);
      Jo(ba, "TABLE", 0, 1, "sheetjs"), Jo(ba, "VECTORS", 0, _a.e.r - _a.s.r + 1, ""), Jo(ba, "TUPLES", 0, _a.e.c - _a.s.c + 1, ""), Jo(ba, "DATA", 0, 0, "");
      for (var wa = _a.s.r; wa <= _a.e.r; ++wa) {
        pa(ba, -1, 0, "BOT");
        for (var Ta = _a.s.c; Ta <= _a.e.c; ++Ta) {
          var Sa = encode_cell({ r: wa, c: Ta });
          if (ya = xa ? (va[wa] || [])[Ta] : va[Sa], !ya) {
            pa(ba, 1, 0, "");
            continue;
          }
          switch (ya.t) {
            case "n":
              var Ma = ya.w;
              !Ma && ya.v != null && (Ma = ya.v), Ma == null ? ya.f && !ya.F ? pa(ba, 1, 0, "=" + ya.f) : pa(ba, 1, 0, "") : pa(ba, 0, Ma, "V");
              break;
            case "b":
              pa(ba, 0, ya.v ? 1 : 0, ya.v ? "TRUE" : "FALSE");
              break;
            case "s":
              pa(ba, 1, 0, isNaN(ya.v) ? ya.v : '="' + ya.v + '"');
              break;
            case "d":
              ya.w || (ya.w = SSF_format(ya.z || table_fmt[14], datenum(parseDate$1(ya.v)))), pa(ba, 0, ya.w, "V");
              break;
            default:
              pa(ba, 1, 0, "");
          }
        }
      }
      pa(ba, -1, 0, "EOD");
      var ka = `\r
`, Za = ba.join(ka);
      return Za;
    };
  }();
  return {
    to_workbook: Kn,
    to_sheet: Un,
    from_sheet: qn
  };
}(), ETH = /* @__PURE__ */ function() {
  function Xn(ya) {
    return ya.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
  }
  function zn(ya) {
    return ya.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
  }
  function Un(ya, xa) {
    for (var wa = ya.split(`
`), Ta = -1, Sa = -1, Ma = 0, ka = []; Ma !== wa.length; ++Ma) {
      var Za = wa[Ma].trim().split(":");
      if (Za[0] === "cell") {
        var Na = decode_cell(Za[1]);
        if (ka.length <= Na.r) for (Ta = ka.length; Ta <= Na.r; ++Ta) ka[Ta] || (ka[Ta] = []);
        switch (Ta = Na.r, Sa = Na.c, Za[2]) {
          case "t":
            ka[Ta][Sa] = Xn(Za[3]);
            break;
          case "v":
            ka[Ta][Sa] = +Za[3];
            break;
          case "vtf":
            var Ka = Za[Za.length - 1];
          /* falls through */
          case "vtc":
            switch (Za[3]) {
              case "nl":
                ka[Ta][Sa] = !!+Za[4];
                break;
              default:
                ka[Ta][Sa] = +Za[4];
                break;
            }
            Za[2] == "vtf" && (ka[Ta][Sa] = [ka[Ta][Sa], Ka]);
        }
      }
    }
    return xa && xa.sheetRows && (ka = ka.slice(0, xa.sheetRows)), ka;
  }
  function Kn(ya, xa) {
    return aoa_to_sheet(Un(ya, xa), xa);
  }
  function qn(ya, xa) {
    return sheet_to_workbook(Kn(ya, xa), xa);
  }
  var Jo = [
    "socialcalc:version:1.5",
    "MIME-Version: 1.0",
    "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  ].join(`
`), pa = [
    "--SocialCalcSpreadsheetControlSave",
    "Content-type: text/plain; charset=UTF-8"
  ].join(`
`) + `
`, ma = [
    "# SocialCalc Spreadsheet Control Save",
    "part:sheet"
  ].join(`
`), va = "--SocialCalcSpreadsheetControlSave--";
  function ba(ya) {
    if (!ya || !ya["!ref"]) return "";
    for (var xa = [], wa = [], Ta, Sa = "", Ma = decode_range(ya["!ref"]), ka = Array.isArray(ya), Za = Ma.s.r; Za <= Ma.e.r; ++Za)
      for (var Na = Ma.s.c; Na <= Ma.e.c; ++Na)
        if (Sa = encode_cell({ r: Za, c: Na }), Ta = ka ? (ya[Za] || [])[Na] : ya[Sa], !(!Ta || Ta.v == null || Ta.t === "z")) {
          switch (wa = ["cell", Sa, "t"], Ta.t) {
            case "s":
            case "str":
              wa.push(zn(Ta.v));
              break;
            case "n":
              Ta.f ? (wa[2] = "vtf", wa[3] = "n", wa[4] = Ta.v, wa[5] = zn(Ta.f)) : (wa[2] = "v", wa[3] = Ta.v);
              break;
            case "b":
              wa[2] = "vt" + (Ta.f ? "f" : "c"), wa[3] = "nl", wa[4] = Ta.v ? "1" : "0", wa[5] = zn(Ta.f || (Ta.v ? "TRUE" : "FALSE"));
              break;
            case "d":
              var Ka = datenum(parseDate$1(Ta.v));
              wa[2] = "vtc", wa[3] = "nd", wa[4] = "" + Ka, wa[5] = Ta.w || SSF_format(Ta.z || table_fmt[14], Ka);
              break;
            case "e":
              continue;
          }
          xa.push(wa.join(":"));
        }
    return xa.push("sheet:c:" + (Ma.e.c - Ma.s.c + 1) + ":r:" + (Ma.e.r - Ma.s.r + 1) + ":tvf:1"), xa.push("valueformat:1:text-wiki"), xa.join(`
`);
  }
  function _a(ya) {
    return [Jo, pa, ma, pa, ba(ya), va].join(`
`);
  }
  return {
    to_workbook: qn,
    to_sheet: Kn,
    from_sheet: _a
  };
}(), PRN = /* @__PURE__ */ function() {
  function Xn(_a, ya, xa, wa, Ta) {
    Ta.raw ? ya[xa][wa] = _a : _a === "" || (_a === "TRUE" ? ya[xa][wa] = !0 : _a === "FALSE" ? ya[xa][wa] = !1 : isNaN(fuzzynum(_a)) ? isNaN(fuzzydate(_a).getDate()) ? ya[xa][wa] = _a : ya[xa][wa] = parseDate$1(_a) : ya[xa][wa] = fuzzynum(_a));
  }
  function zn(_a, ya) {
    var xa = ya || {}, wa = [];
    if (!_a || _a.length === 0) return wa;
    for (var Ta = _a.split(/[\r\n]/), Sa = Ta.length - 1; Sa >= 0 && Ta[Sa].length === 0; ) --Sa;
    for (var Ma = 10, ka = 0, Za = 0; Za <= Sa; ++Za)
      ka = Ta[Za].indexOf(" "), ka == -1 ? ka = Ta[Za].length : ka++, Ma = Math.max(Ma, ka);
    for (Za = 0; Za <= Sa; ++Za) {
      wa[Za] = [];
      var Na = 0;
      for (Xn(Ta[Za].slice(0, Ma).trim(), wa, Za, Na, xa), Na = 1; Na <= (Ta[Za].length - Ma) / 10 + 1; ++Na)
        Xn(Ta[Za].slice(Ma + (Na - 1) * 10, Ma + Na * 10).trim(), wa, Za, Na, xa);
    }
    return xa.sheetRows && (wa = wa.slice(0, xa.sheetRows)), wa;
  }
  var Un = {
    /*::[*/
    44: ",",
    /*::[*/
    9: "	",
    /*::[*/
    59: ";",
    /*::[*/
    124: "|"
  }, Kn = {
    /*::[*/
    44: 3,
    /*::[*/
    9: 2,
    /*::[*/
    59: 1,
    /*::[*/
    124: 0
  };
  function qn(_a) {
    for (var ya = {}, xa = !1, wa = 0, Ta = 0; wa < _a.length; ++wa)
      (Ta = _a.charCodeAt(wa)) == 34 ? xa = !xa : !xa && Ta in Un && (ya[Ta] = (ya[Ta] || 0) + 1);
    Ta = [];
    for (wa in ya) Object.prototype.hasOwnProperty.call(ya, wa) && Ta.push([ya[wa], wa]);
    if (!Ta.length) {
      ya = Kn;
      for (wa in ya) Object.prototype.hasOwnProperty.call(ya, wa) && Ta.push([ya[wa], wa]);
    }
    return Ta.sort(function(Sa, Ma) {
      return Sa[0] - Ma[0] || Kn[Sa[1]] - Kn[Ma[1]];
    }), Un[Ta.pop()[1]] || 44;
  }
  function Jo(_a, ya) {
    var xa = ya || {}, wa = "", Ta = xa.dense ? [] : {}, Sa = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    _a.slice(0, 4) == "sep=" ? _a.charCodeAt(5) == 13 && _a.charCodeAt(6) == 10 ? (wa = _a.charAt(4), _a = _a.slice(7)) : _a.charCodeAt(5) == 13 || _a.charCodeAt(5) == 10 ? (wa = _a.charAt(4), _a = _a.slice(6)) : wa = qn(_a.slice(0, 1024)) : xa && xa.FS ? wa = xa.FS : wa = qn(_a.slice(0, 1024));
    var Ma = 0, ka = 0, Za = 0, Na = 0, Ka = 0, Ja = wa.charCodeAt(0), el = !1, qa = 0, tl = _a.charCodeAt(0);
    _a = _a.replace(/\r\n/mg, `
`);
    var Qa = xa.dateNF != null ? dateNF_regex(xa.dateNF) : null;
    function nl() {
      var rl = _a.slice(Na, Ka), il = {};
      if (rl.charAt(0) == '"' && rl.charAt(rl.length - 1) == '"' && (rl = rl.slice(1, -1).replace(/""/g, '"')), rl.length === 0) il.t = "z";
      else if (xa.raw)
        il.t = "s", il.v = rl;
      else if (rl.trim().length === 0)
        il.t = "s", il.v = rl;
      else if (rl.charCodeAt(0) == 61)
        rl.charCodeAt(1) == 34 && rl.charCodeAt(rl.length - 1) == 34 ? (il.t = "s", il.v = rl.slice(2, -1).replace(/""/g, '"')) : fuzzyfmla(rl) ? (il.t = "n", il.f = rl.slice(1)) : (il.t = "s", il.v = rl);
      else if (rl == "TRUE")
        il.t = "b", il.v = !0;
      else if (rl == "FALSE")
        il.t = "b", il.v = !1;
      else if (!isNaN(Za = fuzzynum(rl)))
        il.t = "n", xa.cellText !== !1 && (il.w = rl), il.v = Za;
      else if (!isNaN(fuzzydate(rl).getDate()) || Qa && rl.match(Qa)) {
        il.z = xa.dateNF || table_fmt[14];
        var cl = 0;
        Qa && rl.match(Qa) && (rl = dateNF_fix(rl, xa.dateNF, rl.match(Qa) || []), cl = 1), xa.cellDates ? (il.t = "d", il.v = parseDate$1(rl, cl)) : (il.t = "n", il.v = datenum(parseDate$1(rl, cl))), xa.cellText !== !1 && (il.w = SSF_format(il.z, il.v instanceof Date ? datenum(il.v) : il.v)), xa.cellNF || delete il.z;
      } else
        il.t = "s", il.v = rl;
      if (il.t == "z" || (xa.dense ? (Ta[Ma] || (Ta[Ma] = []), Ta[Ma][ka] = il) : Ta[encode_cell({ c: ka, r: Ma })] = il), Na = Ka + 1, tl = _a.charCodeAt(Na), Sa.e.c < ka && (Sa.e.c = ka), Sa.e.r < Ma && (Sa.e.r = Ma), qa == Ja) ++ka;
      else if (ka = 0, ++Ma, xa.sheetRows && xa.sheetRows <= Ma) return !0;
    }
    e: for (; Ka < _a.length; ++Ka) switch (qa = _a.charCodeAt(Ka)) {
      case 34:
        tl === 34 && (el = !el);
        break;
      case Ja:
      case 10:
      case 13:
        if (!el && nl()) break e;
        break;
    }
    return Ka - Na > 0 && nl(), Ta["!ref"] = encode_range(Sa), Ta;
  }
  function pa(_a, ya) {
    return !(ya && ya.PRN) || ya.FS || _a.slice(0, 4) == "sep=" || _a.indexOf("	") >= 0 || _a.indexOf(",") >= 0 || _a.indexOf(";") >= 0 ? Jo(_a, ya) : aoa_to_sheet(zn(_a, ya), ya);
  }
  function ma(_a, ya) {
    var xa = "", wa = ya.type == "string" ? [0, 0, 0, 0] : firstbyte(_a, ya);
    switch (ya.type) {
      case "base64":
        xa = Base64_decode(_a);
        break;
      case "binary":
        xa = _a;
        break;
      case "buffer":
        ya.codepage == 65001 ? xa = _a.toString("utf8") : (ya.codepage, xa = has_buf && Buffer.isBuffer(_a) ? _a.toString("binary") : a2s(_a));
        break;
      case "array":
        xa = cc2str(_a);
        break;
      case "string":
        xa = _a;
        break;
      default:
        throw new Error("Unrecognized type " + ya.type);
    }
    return wa[0] == 239 && wa[1] == 187 && wa[2] == 191 ? xa = utf8read(xa.slice(3)) : ya.type != "string" && ya.type != "buffer" && ya.codepage == 65001 ? xa = utf8read(xa) : ya.type == "binary", xa.slice(0, 19) == "socialcalc:version:" ? ETH.to_sheet(ya.type == "string" ? xa : utf8read(xa), ya) : pa(xa, ya);
  }
  function va(_a, ya) {
    return sheet_to_workbook(ma(_a, ya), ya);
  }
  function ba(_a) {
    for (var ya = [], xa = safe_decode_range(_a["!ref"]), wa, Ta = Array.isArray(_a), Sa = xa.s.r; Sa <= xa.e.r; ++Sa) {
      for (var Ma = [], ka = xa.s.c; ka <= xa.e.c; ++ka) {
        var Za = encode_cell({ r: Sa, c: ka });
        if (wa = Ta ? (_a[Sa] || [])[ka] : _a[Za], !wa || wa.v == null) {
          Ma.push("          ");
          continue;
        }
        for (var Na = (wa.w || (format_cell(wa), wa.w) || "").slice(0, 10); Na.length < 10; ) Na += " ";
        Ma.push(Na + (ka === 0 ? " " : ""));
      }
      ya.push(Ma.join(""));
    }
    return ya.join(`
`);
  }
  return {
    to_workbook: va,
    to_sheet: ma,
    from_sheet: ba
  };
}();
function read_wb_ID(Xn, zn) {
  var Un = zn || {}, Kn = !!Un.WTF;
  Un.WTF = !0;
  try {
    var qn = SYLK.to_workbook(Xn, Un);
    return Un.WTF = Kn, qn;
  } catch (Jo) {
    if (Un.WTF = Kn, !Jo.message.match(/SYLK bad record ID/) && Kn) throw Jo;
    return PRN.to_workbook(Xn, zn);
  }
}
var WK_ = /* @__PURE__ */ function() {
  function Xn(ml, Dl, _l) {
    if (ml) {
      prep_blob(ml, ml.l || 0);
      for (var gl = _l.Enum || Ml; ml.l < ml.length; ) {
        var Fl = ml.read_shift(2), Nl = gl[Fl] || gl[65535], zl = ml.read_shift(2), Zl = ml.l + zl, kl = Nl.f && Nl.f(ml, zl, _l);
        if (ml.l = Zl, Dl(kl, Nl, Fl)) return;
      }
    }
  }
  function zn(ml, Dl) {
    switch (Dl.type) {
      case "base64":
        return Un(s2a(Base64_decode(ml)), Dl);
      case "binary":
        return Un(s2a(ml), Dl);
      case "buffer":
      case "array":
        return Un(ml, Dl);
    }
    throw "Unsupported type " + Dl.type;
  }
  function Un(ml, Dl) {
    if (!ml) return ml;
    var _l = Dl || {}, gl = _l.dense ? [] : {}, Fl = "Sheet1", Nl = "", zl = 0, Zl = {}, kl = [], ul = [], vl = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, Tl = _l.sheetRows || 0;
    if (ml[2] == 0 && (ml[3] == 8 || ml[3] == 9) && ml.length >= 16 && ml[14] == 5 && ml[15] === 108)
      throw new Error("Unsupported Works 3 for Mac file");
    if (ml[2] == 2)
      _l.Enum = Ml, Xn(ml, function(Ul, hl, Cl) {
        switch (Cl) {
          case 0:
            _l.vers = Ul, Ul >= 4096 && (_l.qpro = !0);
            break;
          case 6:
            vl = Ul;
            break;
          /* RANGE */
          case 204:
            Ul && (Nl = Ul);
            break;
          /* SHEETNAMECS */
          case 222:
            Nl = Ul;
            break;
          /* SHEETNAMELP */
          case 15:
          /* LABEL */
          case 51:
            _l.qpro || (Ul[1].v = Ul[1].v.slice(1));
          /* falls through */
          case 13:
          /* INTEGER */
          case 14:
          /* NUMBER */
          case 16:
            Cl == 14 && (Ul[2] & 112) == 112 && (Ul[2] & 15) > 1 && (Ul[2] & 15) < 15 && (Ul[1].z = _l.dateNF || table_fmt[14], _l.cellDates && (Ul[1].t = "d", Ul[1].v = numdate(Ul[1].v))), _l.qpro && Ul[3] > zl && (gl["!ref"] = encode_range(vl), Zl[Fl] = gl, kl.push(Fl), gl = _l.dense ? [] : {}, vl = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, zl = Ul[3], Fl = Nl || "Sheet" + (zl + 1), Nl = "");
            var Il = _l.dense ? (gl[Ul[0].r] || [])[Ul[0].c] : gl[encode_cell(Ul[0])];
            if (Il) {
              Il.t = Ul[1].t, Il.v = Ul[1].v, Ul[1].z != null && (Il.z = Ul[1].z), Ul[1].f != null && (Il.f = Ul[1].f);
              break;
            }
            _l.dense ? (gl[Ul[0].r] || (gl[Ul[0].r] = []), gl[Ul[0].r][Ul[0].c] = Ul[1]) : gl[encode_cell(Ul[0])] = Ul[1];
            break;
        }
      }, _l);
    else if (ml[2] == 26 || ml[2] == 14)
      _l.Enum = Sl, ml[2] == 14 && (_l.qpro = !0, ml.l = 0), Xn(ml, function(Ul, hl, Cl) {
        switch (Cl) {
          case 204:
            Fl = Ul;
            break;
          /* SHEETNAMECS */
          case 22:
            Ul[1].v = Ul[1].v.slice(1);
          /* falls through */
          case 23:
          /* NUMBER17 */
          case 24:
          /* NUMBER18 */
          case 25:
          /* FORMULA19 */
          case 37:
          /* NUMBER25 */
          case 39:
          /* NUMBER27 */
          case 40:
            if (Ul[3] > zl && (gl["!ref"] = encode_range(vl), Zl[Fl] = gl, kl.push(Fl), gl = _l.dense ? [] : {}, vl = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, zl = Ul[3], Fl = "Sheet" + (zl + 1)), Tl > 0 && Ul[0].r >= Tl) break;
            _l.dense ? (gl[Ul[0].r] || (gl[Ul[0].r] = []), gl[Ul[0].r][Ul[0].c] = Ul[1]) : gl[encode_cell(Ul[0])] = Ul[1], vl.e.c < Ul[0].c && (vl.e.c = Ul[0].c), vl.e.r < Ul[0].r && (vl.e.r = Ul[0].r);
            break;
          case 27:
            Ul[14e3] && (ul[Ul[14e3][0]] = Ul[14e3][1]);
            break;
          case 1537:
            ul[Ul[0]] = Ul[1], Ul[0] == zl && (Fl = Ul[1]);
            break;
        }
      }, _l);
    else throw new Error("Unrecognized LOTUS BOF " + ml[2]);
    if (gl["!ref"] = encode_range(vl), Zl[Nl || Fl] = gl, kl.push(Nl || Fl), !ul.length) return { SheetNames: kl, Sheets: Zl };
    for (var wl = {}, yl = [], Rl = 0; Rl < ul.length; ++Rl) Zl[kl[Rl]] ? (yl.push(ul[Rl] || kl[Rl]), wl[ul[Rl]] = Zl[ul[Rl]] || Zl[kl[Rl]]) : (yl.push(ul[Rl]), wl[ul[Rl]] = { "!ref": "A1" });
    return { SheetNames: yl, Sheets: wl };
  }
  function Kn(ml, Dl) {
    var _l = Dl || {};
    if (+_l.codepage >= 0 && set_cp(+_l.codepage), _l.type == "string") throw new Error("Cannot write WK1 to JS string");
    var gl = buf_array(), Fl = safe_decode_range(ml["!ref"]), Nl = Array.isArray(ml), zl = [];
    write_biff_rec(gl, 0, Jo(1030)), write_biff_rec(gl, 6, va(Fl));
    for (var Zl = Math.min(Fl.e.r, 8191), kl = Fl.s.r; kl <= Zl; ++kl)
      for (var ul = encode_row(kl), vl = Fl.s.c; vl <= Fl.e.c; ++vl) {
        kl === Fl.s.r && (zl[vl] = encode_col(vl));
        var Tl = zl[vl] + ul, wl = Nl ? (ml[kl] || [])[vl] : ml[Tl];
        if (!(!wl || wl.t == "z"))
          if (wl.t == "n")
            (wl.v | 0) == wl.v && wl.v >= -32768 && wl.v <= 32767 ? write_biff_rec(gl, 13, wa(kl, vl, wl.v)) : write_biff_rec(gl, 14, Sa(kl, vl, wl.v));
          else {
            var yl = format_cell(wl);
            write_biff_rec(gl, 15, ya(kl, vl, yl.slice(0, 239)));
          }
      }
    return write_biff_rec(gl, 1), gl.end();
  }
  function qn(ml, Dl) {
    var _l = Dl || {};
    if (+_l.codepage >= 0 && set_cp(+_l.codepage), _l.type == "string") throw new Error("Cannot write WK3 to JS string");
    var gl = buf_array();
    write_biff_rec(gl, 0, pa(ml));
    for (var Fl = 0, Nl = 0; Fl < ml.SheetNames.length; ++Fl) (ml.Sheets[ml.SheetNames[Fl]] || {})["!ref"] && write_biff_rec(gl, 27, fl(ml.SheetNames[Fl], Nl++));
    var zl = 0;
    for (Fl = 0; Fl < ml.SheetNames.length; ++Fl) {
      var Zl = ml.Sheets[ml.SheetNames[Fl]];
      if (!(!Zl || !Zl["!ref"])) {
        for (var kl = safe_decode_range(Zl["!ref"]), ul = Array.isArray(Zl), vl = [], Tl = Math.min(kl.e.r, 8191), wl = kl.s.r; wl <= Tl; ++wl)
          for (var yl = encode_row(wl), Rl = kl.s.c; Rl <= kl.e.c; ++Rl) {
            wl === kl.s.r && (vl[Rl] = encode_col(Rl));
            var Ul = vl[Rl] + yl, hl = ul ? (Zl[wl] || [])[Rl] : Zl[Ul];
            if (!(!hl || hl.t == "z"))
              if (hl.t == "n")
                write_biff_rec(gl, 23, nl(wl, Rl, zl, hl.v));
              else {
                var Cl = format_cell(hl);
                write_biff_rec(gl, 22, qa(wl, Rl, zl, Cl.slice(0, 239)));
              }
          }
        ++zl;
      }
    }
    return write_biff_rec(gl, 1), gl.end();
  }
  function Jo(ml) {
    var Dl = new_buf(2);
    return Dl.write_shift(2, ml), Dl;
  }
  function pa(ml) {
    var Dl = new_buf(26);
    Dl.write_shift(2, 4096), Dl.write_shift(2, 4), Dl.write_shift(4, 0);
    for (var _l = 0, gl = 0, Fl = 0, Nl = 0; Nl < ml.SheetNames.length; ++Nl) {
      var zl = ml.SheetNames[Nl], Zl = ml.Sheets[zl];
      if (!(!Zl || !Zl["!ref"])) {
        ++Fl;
        var kl = decode_range(Zl["!ref"]);
        _l < kl.e.r && (_l = kl.e.r), gl < kl.e.c && (gl = kl.e.c);
      }
    }
    return _l > 8191 && (_l = 8191), Dl.write_shift(2, _l), Dl.write_shift(1, Fl), Dl.write_shift(1, gl), Dl.write_shift(2, 0), Dl.write_shift(2, 0), Dl.write_shift(1, 1), Dl.write_shift(1, 2), Dl.write_shift(4, 0), Dl.write_shift(4, 0), Dl;
  }
  function ma(ml, Dl, _l) {
    var gl = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    return Dl == 8 && _l.qpro ? (gl.s.c = ml.read_shift(1), ml.l++, gl.s.r = ml.read_shift(2), gl.e.c = ml.read_shift(1), ml.l++, gl.e.r = ml.read_shift(2), gl) : (gl.s.c = ml.read_shift(2), gl.s.r = ml.read_shift(2), Dl == 12 && _l.qpro && (ml.l += 2), gl.e.c = ml.read_shift(2), gl.e.r = ml.read_shift(2), Dl == 12 && _l.qpro && (ml.l += 2), gl.s.c == 65535 && (gl.s.c = gl.e.c = gl.s.r = gl.e.r = 0), gl);
  }
  function va(ml) {
    var Dl = new_buf(8);
    return Dl.write_shift(2, ml.s.c), Dl.write_shift(2, ml.s.r), Dl.write_shift(2, ml.e.c), Dl.write_shift(2, ml.e.r), Dl;
  }
  function ba(ml, Dl, _l) {
    var gl = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
    return _l.qpro && _l.vers != 20768 ? (gl[0].c = ml.read_shift(1), gl[3] = ml.read_shift(1), gl[0].r = ml.read_shift(2), ml.l += 2) : (gl[2] = ml.read_shift(1), gl[0].c = ml.read_shift(2), gl[0].r = ml.read_shift(2)), gl;
  }
  function _a(ml, Dl, _l) {
    var gl = ml.l + Dl, Fl = ba(ml, Dl, _l);
    if (Fl[1].t = "s", _l.vers == 20768) {
      ml.l++;
      var Nl = ml.read_shift(1);
      return Fl[1].v = ml.read_shift(Nl, "utf8"), Fl;
    }
    return _l.qpro && ml.l++, Fl[1].v = ml.read_shift(gl - ml.l, "cstr"), Fl;
  }
  function ya(ml, Dl, _l) {
    var gl = new_buf(7 + _l.length);
    gl.write_shift(1, 255), gl.write_shift(2, Dl), gl.write_shift(2, ml), gl.write_shift(1, 39);
    for (var Fl = 0; Fl < gl.length; ++Fl) {
      var Nl = _l.charCodeAt(Fl);
      gl.write_shift(1, Nl >= 128 ? 95 : Nl);
    }
    return gl.write_shift(1, 0), gl;
  }
  function xa(ml, Dl, _l) {
    var gl = ba(ml, Dl, _l);
    return gl[1].v = ml.read_shift(2, "i"), gl;
  }
  function wa(ml, Dl, _l) {
    var gl = new_buf(7);
    return gl.write_shift(1, 255), gl.write_shift(2, Dl), gl.write_shift(2, ml), gl.write_shift(2, _l, "i"), gl;
  }
  function Ta(ml, Dl, _l) {
    var gl = ba(ml, Dl, _l);
    return gl[1].v = ml.read_shift(8, "f"), gl;
  }
  function Sa(ml, Dl, _l) {
    var gl = new_buf(13);
    return gl.write_shift(1, 255), gl.write_shift(2, Dl), gl.write_shift(2, ml), gl.write_shift(8, _l, "f"), gl;
  }
  function Ma(ml, Dl, _l) {
    var gl = ml.l + Dl, Fl = ba(ml, Dl, _l);
    if (Fl[1].v = ml.read_shift(8, "f"), _l.qpro) ml.l = gl;
    else {
      var Nl = ml.read_shift(2);
      Ka(ml.slice(ml.l, ml.l + Nl), Fl), ml.l += Nl;
    }
    return Fl;
  }
  function ka(ml, Dl, _l) {
    var gl = Dl & 32768;
    return Dl &= -32769, Dl = (gl ? ml : 0) + (Dl >= 8192 ? Dl - 16384 : Dl), (gl ? "" : "$") + (_l ? encode_col(Dl) : encode_row(Dl));
  }
  var Za = {
    51: ["FALSE", 0],
    52: ["TRUE", 0],
    70: ["LEN", 1],
    80: ["SUM", 69],
    81: ["AVERAGEA", 69],
    82: ["COUNTA", 69],
    83: ["MINA", 69],
    84: ["MAXA", 69],
    111: ["T", 1]
  }, Na = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "",
    "+",
    "-",
    "*",
    "/",
    "^",
    "=",
    "<>",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "<=",
    ">=",
    "<",
    ">",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "&",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
    // eslint-disable-line no-mixed-spaces-and-tabs
  ];
  function Ka(ml, Dl) {
    prep_blob(ml, 0);
    for (var _l = [], gl = 0, Fl = "", Nl = "", zl = "", Zl = ""; ml.l < ml.length; ) {
      var kl = ml[ml.l++];
      switch (kl) {
        case 0:
          _l.push(ml.read_shift(8, "f"));
          break;
        case 1:
          Nl = ka(Dl[0].c, ml.read_shift(2), !0), Fl = ka(Dl[0].r, ml.read_shift(2), !1), _l.push(Nl + Fl);
          break;
        case 2:
          {
            var ul = ka(Dl[0].c, ml.read_shift(2), !0), vl = ka(Dl[0].r, ml.read_shift(2), !1);
            Nl = ka(Dl[0].c, ml.read_shift(2), !0), Fl = ka(Dl[0].r, ml.read_shift(2), !1), _l.push(ul + vl + ":" + Nl + Fl);
          }
          break;
        case 3:
          if (ml.l < ml.length) {
            console.error("WK1 premature formula end");
            return;
          }
          break;
        case 4:
          _l.push("(" + _l.pop() + ")");
          break;
        case 5:
          _l.push(ml.read_shift(2));
          break;
        case 6:
          {
            for (var Tl = ""; kl = ml[ml.l++]; ) Tl += String.fromCharCode(kl);
            _l.push('"' + Tl.replace(/"/g, '""') + '"');
          }
          break;
        case 8:
          _l.push("-" + _l.pop());
          break;
        case 23:
          _l.push("+" + _l.pop());
          break;
        case 22:
          _l.push("NOT(" + _l.pop() + ")");
          break;
        case 20:
        case 21:
          Zl = _l.pop(), zl = _l.pop(), _l.push(["AND", "OR"][kl - 20] + "(" + zl + "," + Zl + ")");
          break;
        default:
          if (kl < 32 && Na[kl])
            Zl = _l.pop(), zl = _l.pop(), _l.push(zl + Na[kl] + Zl);
          else if (Za[kl]) {
            if (gl = Za[kl][1], gl == 69 && (gl = ml[ml.l++]), gl > _l.length) {
              console.error("WK1 bad formula parse 0x" + kl.toString(16) + ":|" + _l.join("|") + "|");
              return;
            }
            var wl = _l.slice(-gl);
            _l.length -= gl, _l.push(Za[kl][0] + "(" + wl.join(",") + ")");
          } else return kl <= 7 ? console.error("WK1 invalid opcode " + kl.toString(16)) : kl <= 24 ? console.error("WK1 unsupported op " + kl.toString(16)) : kl <= 30 ? console.error("WK1 invalid opcode " + kl.toString(16)) : kl <= 115 ? console.error("WK1 unsupported function opcode " + kl.toString(16)) : console.error("WK1 unrecognized opcode " + kl.toString(16));
      }
    }
    _l.length == 1 ? Dl[1].f = "" + _l[0] : console.error("WK1 bad formula parse |" + _l.join("|") + "|");
  }
  function Ja(ml) {
    var Dl = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
    return Dl[0].r = ml.read_shift(2), Dl[3] = ml[ml.l++], Dl[0].c = ml[ml.l++], Dl;
  }
  function el(ml, Dl) {
    var _l = Ja(ml);
    return _l[1].t = "s", _l[1].v = ml.read_shift(Dl - 4, "cstr"), _l;
  }
  function qa(ml, Dl, _l, gl) {
    var Fl = new_buf(6 + gl.length);
    Fl.write_shift(2, ml), Fl.write_shift(1, _l), Fl.write_shift(1, Dl), Fl.write_shift(1, 39);
    for (var Nl = 0; Nl < gl.length; ++Nl) {
      var zl = gl.charCodeAt(Nl);
      Fl.write_shift(1, zl >= 128 ? 95 : zl);
    }
    return Fl.write_shift(1, 0), Fl;
  }
  function tl(ml, Dl) {
    var _l = Ja(ml);
    _l[1].v = ml.read_shift(2);
    var gl = _l[1].v >> 1;
    if (_l[1].v & 1)
      switch (gl & 7) {
        case 0:
          gl = (gl >> 3) * 5e3;
          break;
        case 1:
          gl = (gl >> 3) * 500;
          break;
        case 2:
          gl = (gl >> 3) / 20;
          break;
        case 3:
          gl = (gl >> 3) / 200;
          break;
        case 4:
          gl = (gl >> 3) / 2e3;
          break;
        case 5:
          gl = (gl >> 3) / 2e4;
          break;
        case 6:
          gl = (gl >> 3) / 16;
          break;
        case 7:
          gl = (gl >> 3) / 64;
          break;
      }
    return _l[1].v = gl, _l;
  }
  function Qa(ml, Dl) {
    var _l = Ja(ml), gl = ml.read_shift(4), Fl = ml.read_shift(4), Nl = ml.read_shift(2);
    if (Nl == 65535)
      return gl === 0 && Fl === 3221225472 ? (_l[1].t = "e", _l[1].v = 15) : gl === 0 && Fl === 3489660928 ? (_l[1].t = "e", _l[1].v = 42) : _l[1].v = 0, _l;
    var zl = Nl & 32768;
    return Nl = (Nl & 32767) - 16446, _l[1].v = (1 - zl * 2) * (Fl * Math.pow(2, Nl + 32) + gl * Math.pow(2, Nl)), _l;
  }
  function nl(ml, Dl, _l, gl) {
    var Fl = new_buf(14);
    if (Fl.write_shift(2, ml), Fl.write_shift(1, _l), Fl.write_shift(1, Dl), gl == 0)
      return Fl.write_shift(4, 0), Fl.write_shift(4, 0), Fl.write_shift(2, 65535), Fl;
    var Nl = 0, zl = 0, Zl = 0, kl = 0;
    return gl < 0 && (Nl = 1, gl = -gl), zl = Math.log2(gl) | 0, gl /= Math.pow(2, zl - 31), kl = gl >>> 0, (kl & 2147483648) == 0 && (gl /= 2, ++zl, kl = gl >>> 0), gl -= kl, kl |= 2147483648, kl >>>= 0, gl *= Math.pow(2, 32), Zl = gl >>> 0, Fl.write_shift(4, Zl), Fl.write_shift(4, kl), zl += 16383 + (Nl ? 32768 : 0), Fl.write_shift(2, zl), Fl;
  }
  function rl(ml, Dl) {
    var _l = Qa(ml);
    return ml.l += Dl - 14, _l;
  }
  function il(ml, Dl) {
    var _l = Ja(ml), gl = ml.read_shift(4);
    return _l[1].v = gl >> 6, _l;
  }
  function cl(ml, Dl) {
    var _l = Ja(ml), gl = ml.read_shift(8, "f");
    return _l[1].v = gl, _l;
  }
  function ll(ml, Dl) {
    var _l = cl(ml);
    return ml.l += Dl - 10, _l;
  }
  function al(ml, Dl) {
    return ml[ml.l + Dl - 1] == 0 ? ml.read_shift(Dl, "cstr") : "";
  }
  function sl(ml, Dl) {
    var _l = ml[ml.l++];
    _l > Dl - 1 && (_l = Dl - 1);
    for (var gl = ""; gl.length < _l; ) gl += String.fromCharCode(ml[ml.l++]);
    return gl;
  }
  function dl(ml, Dl, _l) {
    if (!(!_l.qpro || Dl < 21)) {
      var gl = ml.read_shift(1);
      ml.l += 17, ml.l += 1, ml.l += 2;
      var Fl = ml.read_shift(Dl - 21, "cstr");
      return [gl, Fl];
    }
  }
  function El(ml, Dl) {
    for (var _l = {}, gl = ml.l + Dl; ml.l < gl; ) {
      var Fl = ml.read_shift(2);
      if (Fl == 14e3) {
        for (_l[Fl] = [0, ""], _l[Fl][0] = ml.read_shift(2); ml[ml.l]; )
          _l[Fl][1] += String.fromCharCode(ml[ml.l]), ml.l++;
        ml.l++;
      }
    }
    return _l;
  }
  function fl(ml, Dl) {
    var _l = new_buf(5 + ml.length);
    _l.write_shift(2, 14e3), _l.write_shift(2, Dl);
    for (var gl = 0; gl < ml.length; ++gl) {
      var Fl = ml.charCodeAt(gl);
      _l[_l.l++] = Fl > 127 ? 95 : Fl;
    }
    return _l[_l.l++] = 0, _l;
  }
  var Ml = {
    /*::[*/
    0: { n: "BOF", f: parseuint16 },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "CALCMODE" },
    /*::[*/
    3: { n: "CALCORDER" },
    /*::[*/
    4: { n: "SPLIT" },
    /*::[*/
    5: { n: "SYNC" },
    /*::[*/
    6: { n: "RANGE", f: ma },
    /*::[*/
    7: { n: "WINDOW1" },
    /*::[*/
    8: { n: "COLW1" },
    /*::[*/
    9: { n: "WINTWO" },
    /*::[*/
    10: { n: "COLW2" },
    /*::[*/
    11: { n: "NAME" },
    /*::[*/
    12: { n: "BLANK" },
    /*::[*/
    13: { n: "INTEGER", f: xa },
    /*::[*/
    14: { n: "NUMBER", f: Ta },
    /*::[*/
    15: { n: "LABEL", f: _a },
    /*::[*/
    16: { n: "FORMULA", f: Ma },
    /*::[*/
    24: { n: "TABLE" },
    /*::[*/
    25: { n: "ORANGE" },
    /*::[*/
    26: { n: "PRANGE" },
    /*::[*/
    27: { n: "SRANGE" },
    /*::[*/
    28: { n: "FRANGE" },
    /*::[*/
    29: { n: "KRANGE1" },
    /*::[*/
    32: { n: "HRANGE" },
    /*::[*/
    35: { n: "KRANGE2" },
    /*::[*/
    36: { n: "PROTEC" },
    /*::[*/
    37: { n: "FOOTER" },
    /*::[*/
    38: { n: "HEADER" },
    /*::[*/
    39: { n: "SETUP" },
    /*::[*/
    40: { n: "MARGINS" },
    /*::[*/
    41: { n: "LABELFMT" },
    /*::[*/
    42: { n: "TITLES" },
    /*::[*/
    43: { n: "SHEETJS" },
    /*::[*/
    45: { n: "GRAPH" },
    /*::[*/
    46: { n: "NGRAPH" },
    /*::[*/
    47: { n: "CALCCOUNT" },
    /*::[*/
    48: { n: "UNFORMATTED" },
    /*::[*/
    49: { n: "CURSORW12" },
    /*::[*/
    50: { n: "WINDOW" },
    /*::[*/
    51: { n: "STRING", f: _a },
    /*::[*/
    55: { n: "PASSWORD" },
    /*::[*/
    56: { n: "LOCKED" },
    /*::[*/
    60: { n: "QUERY" },
    /*::[*/
    61: { n: "QUERYNAME" },
    /*::[*/
    62: { n: "PRINT" },
    /*::[*/
    63: { n: "PRINTNAME" },
    /*::[*/
    64: { n: "GRAPH2" },
    /*::[*/
    65: { n: "GRAPHNAME" },
    /*::[*/
    66: { n: "ZOOM" },
    /*::[*/
    67: { n: "SYMSPLIT" },
    /*::[*/
    68: { n: "NSROWS" },
    /*::[*/
    69: { n: "NSCOLS" },
    /*::[*/
    70: { n: "RULER" },
    /*::[*/
    71: { n: "NNAME" },
    /*::[*/
    72: { n: "ACOMM" },
    /*::[*/
    73: { n: "AMACRO" },
    /*::[*/
    74: { n: "PARSE" },
    /*::[*/
    102: { n: "PRANGES??" },
    /*::[*/
    103: { n: "RRANGES??" },
    /*::[*/
    104: { n: "FNAME??" },
    /*::[*/
    105: { n: "MRANGES??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: al },
    /*::[*/
    222: { n: "SHEETNAMELP", f: sl },
    /*::[*/
    65535: { n: "" }
  }, Sl = {
    /*::[*/
    0: { n: "BOF" },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "PASSWORD" },
    /*::[*/
    3: { n: "CALCSET" },
    /*::[*/
    4: { n: "WINDOWSET" },
    /*::[*/
    5: { n: "SHEETCELLPTR" },
    /*::[*/
    6: { n: "SHEETLAYOUT" },
    /*::[*/
    7: { n: "COLUMNWIDTH" },
    /*::[*/
    8: { n: "HIDDENCOLUMN" },
    /*::[*/
    9: { n: "USERRANGE" },
    /*::[*/
    10: { n: "SYSTEMRANGE" },
    /*::[*/
    11: { n: "ZEROFORCE" },
    /*::[*/
    12: { n: "SORTKEYDIR" },
    /*::[*/
    13: { n: "FILESEAL" },
    /*::[*/
    14: { n: "DATAFILLNUMS" },
    /*::[*/
    15: { n: "PRINTMAIN" },
    /*::[*/
    16: { n: "PRINTSTRING" },
    /*::[*/
    17: { n: "GRAPHMAIN" },
    /*::[*/
    18: { n: "GRAPHSTRING" },
    /*::[*/
    19: { n: "??" },
    /*::[*/
    20: { n: "ERRCELL" },
    /*::[*/
    21: { n: "NACELL" },
    /*::[*/
    22: { n: "LABEL16", f: el },
    /*::[*/
    23: { n: "NUMBER17", f: Qa },
    /*::[*/
    24: { n: "NUMBER18", f: tl },
    /*::[*/
    25: { n: "FORMULA19", f: rl },
    /*::[*/
    26: { n: "FORMULA1A" },
    /*::[*/
    27: { n: "XFORMAT", f: El },
    /*::[*/
    28: { n: "DTLABELMISC" },
    /*::[*/
    29: { n: "DTLABELCELL" },
    /*::[*/
    30: { n: "GRAPHWINDOW" },
    /*::[*/
    31: { n: "CPA" },
    /*::[*/
    32: { n: "LPLAUTO" },
    /*::[*/
    33: { n: "QUERY" },
    /*::[*/
    34: { n: "HIDDENSHEET" },
    /*::[*/
    35: { n: "??" },
    /*::[*/
    37: { n: "NUMBER25", f: il },
    /*::[*/
    38: { n: "??" },
    /*::[*/
    39: { n: "NUMBER27", f: cl },
    /*::[*/
    40: { n: "FORMULA28", f: ll },
    /*::[*/
    142: { n: "??" },
    /*::[*/
    147: { n: "??" },
    /*::[*/
    150: { n: "??" },
    /*::[*/
    151: { n: "??" },
    /*::[*/
    152: { n: "??" },
    /*::[*/
    153: { n: "??" },
    /*::[*/
    154: { n: "??" },
    /*::[*/
    155: { n: "??" },
    /*::[*/
    156: { n: "??" },
    /*::[*/
    163: { n: "??" },
    /*::[*/
    174: { n: "??" },
    /*::[*/
    175: { n: "??" },
    /*::[*/
    176: { n: "??" },
    /*::[*/
    177: { n: "??" },
    /*::[*/
    184: { n: "??" },
    /*::[*/
    185: { n: "??" },
    /*::[*/
    186: { n: "??" },
    /*::[*/
    187: { n: "??" },
    /*::[*/
    188: { n: "??" },
    /*::[*/
    195: { n: "??" },
    /*::[*/
    201: { n: "??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: al },
    /*::[*/
    205: { n: "??" },
    /*::[*/
    206: { n: "??" },
    /*::[*/
    207: { n: "??" },
    /*::[*/
    208: { n: "??" },
    /*::[*/
    256: { n: "??" },
    /*::[*/
    259: { n: "??" },
    /*::[*/
    260: { n: "??" },
    /*::[*/
    261: { n: "??" },
    /*::[*/
    262: { n: "??" },
    /*::[*/
    263: { n: "??" },
    /*::[*/
    265: { n: "??" },
    /*::[*/
    266: { n: "??" },
    /*::[*/
    267: { n: "??" },
    /*::[*/
    268: { n: "??" },
    /*::[*/
    270: { n: "??" },
    /*::[*/
    271: { n: "??" },
    /*::[*/
    384: { n: "??" },
    /*::[*/
    389: { n: "??" },
    /*::[*/
    390: { n: "??" },
    /*::[*/
    393: { n: "??" },
    /*::[*/
    396: { n: "??" },
    /*::[*/
    512: { n: "??" },
    /*::[*/
    514: { n: "??" },
    /*::[*/
    513: { n: "??" },
    /*::[*/
    516: { n: "??" },
    /*::[*/
    517: { n: "??" },
    /*::[*/
    640: { n: "??" },
    /*::[*/
    641: { n: "??" },
    /*::[*/
    642: { n: "??" },
    /*::[*/
    643: { n: "??" },
    /*::[*/
    644: { n: "??" },
    /*::[*/
    645: { n: "??" },
    /*::[*/
    646: { n: "??" },
    /*::[*/
    647: { n: "??" },
    /*::[*/
    648: { n: "??" },
    /*::[*/
    658: { n: "??" },
    /*::[*/
    659: { n: "??" },
    /*::[*/
    660: { n: "??" },
    /*::[*/
    661: { n: "??" },
    /*::[*/
    662: { n: "??" },
    /*::[*/
    665: { n: "??" },
    /*::[*/
    666: { n: "??" },
    /*::[*/
    768: { n: "??" },
    /*::[*/
    772: { n: "??" },
    /*::[*/
    1537: { n: "SHEETINFOQP", f: dl },
    /*::[*/
    1600: { n: "??" },
    /*::[*/
    1602: { n: "??" },
    /*::[*/
    1793: { n: "??" },
    /*::[*/
    1794: { n: "??" },
    /*::[*/
    1795: { n: "??" },
    /*::[*/
    1796: { n: "??" },
    /*::[*/
    1920: { n: "??" },
    /*::[*/
    2048: { n: "??" },
    /*::[*/
    2049: { n: "??" },
    /*::[*/
    2052: { n: "??" },
    /*::[*/
    2688: { n: "??" },
    /*::[*/
    10998: { n: "??" },
    /*::[*/
    12849: { n: "??" },
    /*::[*/
    28233: { n: "??" },
    /*::[*/
    28484: { n: "??" },
    /*::[*/
    65535: { n: "" }
  };
  return {
    sheet_to_wk1: Kn,
    book_to_wk3: qn,
    to_workbook: zn
  };
}();
function parse_rpr(Xn) {
  var zn = {}, Un = Xn.match(tagregex), Kn = 0, qn = !1;
  if (Un) for (; Kn != Un.length; ++Kn) {
    var Jo = parsexmltag(Un[Kn]);
    switch (Jo[0].replace(/\w*:/g, "")) {
      /* 18.8.12 condense CT_BooleanProperty */
      /* ** not required . */
      case "<condense":
        break;
      /* 18.8.17 extend CT_BooleanProperty */
      /* ** not required . */
      case "<extend":
        break;
      /* 18.8.36 shadow CT_BooleanProperty */
      /* ** not required . */
      case "<shadow":
        if (!Jo.val) break;
      /* falls through */
      case "<shadow>":
      case "<shadow/>":
        zn.shadow = 1;
        break;
      case "</shadow>":
        break;
      /* 18.4.1 charset CT_IntProperty TODO */
      case "<charset":
        if (Jo.val == "1") break;
        zn.cp = CS2CP[parseInt(Jo.val, 10)];
        break;
      /* 18.4.2 outline CT_BooleanProperty TODO */
      case "<outline":
        if (!Jo.val) break;
      /* falls through */
      case "<outline>":
      case "<outline/>":
        zn.outline = 1;
        break;
      case "</outline>":
        break;
      /* 18.4.5 rFont CT_FontName */
      case "<rFont":
        zn.name = Jo.val;
        break;
      /* 18.4.11 sz CT_FontSize */
      case "<sz":
        zn.sz = Jo.val;
        break;
      /* 18.4.10 strike CT_BooleanProperty */
      case "<strike":
        if (!Jo.val) break;
      /* falls through */
      case "<strike>":
      case "<strike/>":
        zn.strike = 1;
        break;
      case "</strike>":
        break;
      /* 18.4.13 u CT_UnderlineProperty */
      case "<u":
        if (!Jo.val) break;
        switch (Jo.val) {
          case "double":
            zn.uval = "double";
            break;
          case "singleAccounting":
            zn.uval = "single-accounting";
            break;
          case "doubleAccounting":
            zn.uval = "double-accounting";
            break;
        }
      /* falls through */
      case "<u>":
      case "<u/>":
        zn.u = 1;
        break;
      case "</u>":
        break;
      /* 18.8.2 b */
      case "<b":
        if (Jo.val == "0") break;
      /* falls through */
      case "<b>":
      case "<b/>":
        zn.b = 1;
        break;
      case "</b>":
        break;
      /* 18.8.26 i */
      case "<i":
        if (Jo.val == "0") break;
      /* falls through */
      case "<i>":
      case "<i/>":
        zn.i = 1;
        break;
      case "</i>":
        break;
      /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
      case "<color":
        Jo.rgb && (zn.color = Jo.rgb.slice(2, 8));
        break;
      case "<color>":
      case "<color/>":
      case "</color>":
        break;
      /* 18.8.18 family ST_FontFamily */
      case "<family":
        zn.family = Jo.val;
        break;
      case "<family>":
      case "<family/>":
      case "</family>":
        break;
      /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
      case "<vertAlign":
        zn.valign = Jo.val;
        break;
      case "<vertAlign>":
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      /* 18.8.35 scheme CT_FontScheme TODO */
      case "<scheme":
        break;
      case "<scheme>":
      case "<scheme/>":
      case "</scheme>":
        break;
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        qn = !0;
        break;
      case "</ext>":
        qn = !1;
        break;
      default:
        if (Jo[0].charCodeAt(1) !== 47 && !qn) throw new Error("Unrecognized rich format " + Jo[0]);
    }
  }
  return zn;
}
var parse_rs = /* @__PURE__ */ function() {
  var Xn = matchtag("t"), zn = matchtag("rPr");
  function Un(Jo) {
    var pa = Jo.match(Xn);
    if (!pa) return { t: "s", v: "" };
    var ma = { t: "s", v: unescapexml(pa[1]) }, va = Jo.match(zn);
    return va && (ma.s = parse_rpr(va[1])), ma;
  }
  var Kn = /<(?:\w+:)?r>/g, qn = /<\/(?:\w+:)?r>/;
  return function(pa) {
    return pa.replace(Kn, "").split(qn).map(Un).filter(function(ma) {
      return ma.v;
    });
  };
}(), rs_to_html = /* @__PURE__ */ function() {
  var zn = /(\r\n|\n)/g;
  function Un(qn, Jo, pa) {
    var ma = [];
    qn.u && ma.push("text-decoration: underline;"), qn.uval && ma.push("text-underline-style:" + qn.uval + ";"), qn.sz && ma.push("font-size:" + qn.sz + "pt;"), qn.outline && ma.push("text-effect: outline;"), qn.shadow && ma.push("text-shadow: auto;"), Jo.push('<span style="' + ma.join("") + '">'), qn.b && (Jo.push("<b>"), pa.push("</b>")), qn.i && (Jo.push("<i>"), pa.push("</i>")), qn.strike && (Jo.push("<s>"), pa.push("</s>"));
    var va = qn.valign || "";
    return va == "superscript" || va == "super" ? va = "sup" : va == "subscript" && (va = "sub"), va != "" && (Jo.push("<" + va + ">"), pa.push("</" + va + ">")), pa.push("</span>"), qn;
  }
  function Kn(qn) {
    var Jo = [[], qn.v, []];
    return qn.v ? (qn.s && Un(qn.s, Jo[0], Jo[2]), Jo[0].join("") + Jo[1].replace(zn, "<br/>") + Jo[2].join("")) : "";
  }
  return function(Jo) {
    return Jo.map(Kn).join("");
  };
}(), sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/, sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(Xn, zn) {
  var Un = zn ? zn.cellHTML : !0, Kn = {};
  return Xn ? (Xn.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (Kn.t = unescapexml(utf8read(Xn.slice(Xn.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || "")), Kn.r = utf8read(Xn), Un && (Kn.h = escapehtml(Kn.t))) : (
    /*y = */
    Xn.match(sirregex) && (Kn.r = utf8read(Xn), Kn.t = unescapexml(utf8read((Xn.replace(sirphregex, "").match(sitregex) || []).join("").replace(tagregex, ""))), Un && (Kn.h = rs_to_html(parse_rs(Kn.r))))
  ), Kn) : { t: "" };
}
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g, sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(Xn, zn) {
  var Un = [], Kn = "";
  if (!Xn) return Un;
  var qn = Xn.match(sstr0);
  if (qn) {
    Kn = qn[2].replace(sstr1, "").split(sstr2);
    for (var Jo = 0; Jo != Kn.length; ++Jo) {
      var pa = parse_si(Kn[Jo].trim(), zn);
      pa != null && (Un[Un.length] = pa);
    }
    qn = parsexmltag(qn[1]), Un.Count = qn.count, Un.Unique = qn.uniqueCount;
  }
  return Un;
}
function parse_BrtBeginSst(Xn) {
  return [Xn.read_shift(4), Xn.read_shift(4)];
}
function parse_sst_bin(Xn, zn) {
  var Un = [], Kn = !1;
  return recordhopper(Xn, function(Jo, pa, ma) {
    switch (ma) {
      case 159:
        Un.Count = Jo[0], Un.Unique = Jo[1];
        break;
      case 19:
        Un.push(Jo);
        break;
      case 160:
        return !0;
      case 35:
        Kn = !0;
        break;
      case 36:
        Kn = !1;
        break;
      default:
        if (pa.T, !Kn || zn.WTF) throw new Error("Unexpected record 0x" + ma.toString(16));
    }
  }), Un;
}
function _JS2ANSI(Xn) {
  for (var zn = [], Un = Xn.split(""), Kn = 0; Kn < Un.length; ++Kn) zn[Kn] = Un[Kn].charCodeAt(0);
  return zn;
}
function parse_CRYPTOVersion(Xn, zn) {
  var Un = {};
  return Un.Major = Xn.read_shift(2), Un.Minor = Xn.read_shift(2), zn >= 4 && (Xn.l += zn - 4), Un;
}
function parse_DataSpaceVersionInfo(Xn) {
  var zn = {};
  return zn.id = Xn.read_shift(0, "lpp4"), zn.R = parse_CRYPTOVersion(Xn, 4), zn.U = parse_CRYPTOVersion(Xn, 4), zn.W = parse_CRYPTOVersion(Xn, 4), zn;
}
function parse_DataSpaceMapEntry(Xn) {
  for (var zn = Xn.read_shift(4), Un = Xn.l + zn - 4, Kn = {}, qn = Xn.read_shift(4), Jo = []; qn-- > 0; ) Jo.push({ t: Xn.read_shift(4), v: Xn.read_shift(0, "lpp4") });
  if (Kn.name = Xn.read_shift(0, "lpp4"), Kn.comps = Jo, Xn.l != Un) throw new Error("Bad DataSpaceMapEntry: " + Xn.l + " != " + Un);
  return Kn;
}
function parse_DataSpaceMap(Xn) {
  var zn = [];
  Xn.l += 4;
  for (var Un = Xn.read_shift(4); Un-- > 0; ) zn.push(parse_DataSpaceMapEntry(Xn));
  return zn;
}
function parse_DataSpaceDefinition(Xn) {
  var zn = [];
  Xn.l += 4;
  for (var Un = Xn.read_shift(4); Un-- > 0; ) zn.push(Xn.read_shift(0, "lpp4"));
  return zn;
}
function parse_TransformInfoHeader(Xn) {
  var zn = {};
  return Xn.read_shift(4), Xn.l += 4, zn.id = Xn.read_shift(0, "lpp4"), zn.name = Xn.read_shift(0, "lpp4"), zn.R = parse_CRYPTOVersion(Xn, 4), zn.U = parse_CRYPTOVersion(Xn, 4), zn.W = parse_CRYPTOVersion(Xn, 4), zn;
}
function parse_Primary(Xn) {
  var zn = parse_TransformInfoHeader(Xn);
  if (zn.ename = Xn.read_shift(0, "8lpp4"), zn.blksz = Xn.read_shift(4), zn.cmode = Xn.read_shift(4), Xn.read_shift(4) != 4) throw new Error("Bad !Primary record");
  return zn;
}
function parse_EncryptionHeader(Xn, zn) {
  var Un = Xn.l + zn, Kn = {};
  Kn.Flags = Xn.read_shift(4) & 63, Xn.l += 4, Kn.AlgID = Xn.read_shift(4);
  var qn = !1;
  switch (Kn.AlgID) {
    case 26126:
    case 26127:
    case 26128:
      qn = Kn.Flags == 36;
      break;
    case 26625:
      qn = Kn.Flags == 4;
      break;
    case 0:
      qn = Kn.Flags == 16 || Kn.Flags == 4 || Kn.Flags == 36;
      break;
    default:
      throw "Unrecognized encryption algorithm: " + Kn.AlgID;
  }
  if (!qn) throw new Error("Encryption Flags/AlgID mismatch");
  return Kn.AlgIDHash = Xn.read_shift(4), Kn.KeySize = Xn.read_shift(4), Kn.ProviderType = Xn.read_shift(4), Xn.l += 8, Kn.CSPName = Xn.read_shift(Un - Xn.l >> 1, "utf16le"), Xn.l = Un, Kn;
}
function parse_EncryptionVerifier(Xn, zn) {
  var Un = {}, Kn = Xn.l + zn;
  return Xn.l += 4, Un.Salt = Xn.slice(Xn.l, Xn.l + 16), Xn.l += 16, Un.Verifier = Xn.slice(Xn.l, Xn.l + 16), Xn.l += 16, Xn.read_shift(4), Un.VerifierHash = Xn.slice(Xn.l, Kn), Xn.l = Kn, Un;
}
function parse_EncryptionInfo(Xn) {
  var zn = parse_CRYPTOVersion(Xn);
  switch (zn.Minor) {
    case 2:
      return [zn.Minor, parse_EncInfoStd(Xn)];
    case 3:
      return [zn.Minor, parse_EncInfoExt()];
    case 4:
      return [zn.Minor, parse_EncInfoAgl(Xn)];
  }
  throw new Error("ECMA-376 Encrypted file unrecognized Version: " + zn.Minor);
}
function parse_EncInfoStd(Xn) {
  var zn = Xn.read_shift(4);
  if ((zn & 63) != 36) throw new Error("EncryptionInfo mismatch");
  var Un = Xn.read_shift(4), Kn = parse_EncryptionHeader(Xn, Un), qn = parse_EncryptionVerifier(Xn, Xn.length - Xn.l);
  return { t: "Std", h: Kn, v: qn };
}
function parse_EncInfoExt() {
  throw new Error("File is password-protected: ECMA-376 Extensible");
}
function parse_EncInfoAgl(Xn) {
  var zn = ["saltSize", "blockSize", "keyBits", "hashSize", "cipherAlgorithm", "cipherChaining", "hashAlgorithm", "saltValue"];
  Xn.l += 4;
  var Un = Xn.read_shift(Xn.length - Xn.l, "utf8"), Kn = {};
  return Un.replace(tagregex, function(Jo) {
    var pa = parsexmltag(Jo);
    switch (strip_ns(pa[0])) {
      case "<?xml":
        break;
      case "<encryption":
      case "</encryption>":
        break;
      case "<keyData":
        zn.forEach(function(ma) {
          Kn[ma] = pa[ma];
        });
        break;
      case "<dataIntegrity":
        Kn.encryptedHmacKey = pa.encryptedHmacKey, Kn.encryptedHmacValue = pa.encryptedHmacValue;
        break;
      case "<keyEncryptors>":
      case "<keyEncryptors":
        Kn.encs = [];
        break;
      case "</keyEncryptors>":
        break;
      case "<keyEncryptor":
        Kn.uri = pa.uri;
        break;
      case "</keyEncryptor>":
        break;
      case "<encryptedKey":
        Kn.encs.push(pa);
        break;
      default:
        throw pa[0];
    }
  }), Kn;
}
function parse_RC4CryptoHeader(Xn, zn) {
  var Un = {}, Kn = Un.EncryptionVersionInfo = parse_CRYPTOVersion(Xn, 4);
  if (zn -= 4, Kn.Minor != 2) throw new Error("unrecognized minor version code: " + Kn.Minor);
  if (Kn.Major > 4 || Kn.Major < 2) throw new Error("unrecognized major version code: " + Kn.Major);
  Un.Flags = Xn.read_shift(4), zn -= 4;
  var qn = Xn.read_shift(4);
  return zn -= 4, Un.EncryptionHeader = parse_EncryptionHeader(Xn, qn), zn -= qn, Un.EncryptionVerifier = parse_EncryptionVerifier(Xn, zn), Un;
}
function parse_RC4Header(Xn) {
  var zn = {}, Un = zn.EncryptionVersionInfo = parse_CRYPTOVersion(Xn, 4);
  if (Un.Major != 1 || Un.Minor != 1) throw "unrecognized version code " + Un.Major + " : " + Un.Minor;
  return zn.Salt = Xn.read_shift(16), zn.EncryptedVerifier = Xn.read_shift(16), zn.EncryptedVerifierHash = Xn.read_shift(16), zn;
}
function crypto_CreatePasswordVerifier_Method1(Xn) {
  var zn = 0, Un, Kn = _JS2ANSI(Xn), qn = Kn.length + 1, Jo, pa, ma, va, ba;
  for (Un = new_raw_buf(qn), Un[0] = Kn.length, Jo = 1; Jo != qn; ++Jo) Un[Jo] = Kn[Jo - 1];
  for (Jo = qn - 1; Jo >= 0; --Jo)
    pa = Un[Jo], ma = (zn & 16384) === 0 ? 0 : 1, va = zn << 1 & 32767, ba = ma | va, zn = ba ^ pa;
  return zn ^ 52811;
}
var crypto_CreateXorArray_Method1 = /* @__PURE__ */ function() {
  var Xn = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0], zn = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163], Un = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628], Kn = function(pa) {
    return (pa / 2 | pa * 128) & 255;
  }, qn = function(pa, ma) {
    return Kn(pa ^ ma);
  }, Jo = function(pa) {
    for (var ma = zn[pa.length - 1], va = 104, ba = pa.length - 1; ba >= 0; --ba)
      for (var _a = pa[ba], ya = 0; ya != 7; ++ya)
        _a & 64 && (ma ^= Un[va]), _a *= 2, --va;
    return ma;
  };
  return function(pa) {
    for (var ma = _JS2ANSI(pa), va = Jo(ma), ba = ma.length, _a = new_raw_buf(16), ya = 0; ya != 16; ++ya) _a[ya] = 0;
    var xa, wa, Ta;
    for ((ba & 1) === 1 && (xa = va >> 8, _a[ba] = qn(Xn[0], xa), --ba, xa = va & 255, wa = ma[ma.length - 1], _a[ba] = qn(wa, xa)); ba > 0; )
      --ba, xa = va >> 8, _a[ba] = qn(ma[ba], xa), --ba, xa = va & 255, _a[ba] = qn(ma[ba], xa);
    for (ba = 15, Ta = 15 - ma.length; Ta > 0; )
      xa = va >> 8, _a[ba] = qn(Xn[Ta], xa), --ba, --Ta, xa = va & 255, _a[ba] = qn(ma[ba], xa), --ba, --Ta;
    return _a;
  };
}(), crypto_DecryptData_Method1 = function(Xn, zn, Un, Kn, qn) {
  qn || (qn = zn), Kn || (Kn = crypto_CreateXorArray_Method1(Xn));
  var Jo, pa;
  for (Jo = 0; Jo != zn.length; ++Jo)
    pa = zn[Jo], pa ^= Kn[Un], pa = (pa >> 5 | pa << 3) & 255, qn[Jo] = pa, ++Un;
  return [qn, Un, Kn];
}, crypto_MakeXorDecryptor = function(Xn) {
  var zn = 0, Un = crypto_CreateXorArray_Method1(Xn);
  return function(Kn) {
    var qn = crypto_DecryptData_Method1("", Kn, zn, Un);
    return zn = qn[1], qn[0];
  };
};
function parse_XORObfuscation(Xn, zn, Un, Kn) {
  var qn = { key: parseuint16(Xn), verificationBytes: parseuint16(Xn) };
  return Un.password && (qn.verifier = crypto_CreatePasswordVerifier_Method1(Un.password)), Kn.valid = qn.verificationBytes === qn.verifier, Kn.valid && (Kn.insitu = crypto_MakeXorDecryptor(Un.password)), qn;
}
function parse_FilePassHeader(Xn, zn, Un) {
  var Kn = Un || {};
  return Kn.Info = Xn.read_shift(2), Xn.l -= 2, Kn.Info === 1 ? Kn.Data = parse_RC4Header(Xn) : Kn.Data = parse_RC4CryptoHeader(Xn, zn), Kn;
}
function parse_FilePass(Xn, zn, Un) {
  var Kn = { Type: Un.biff >= 8 ? Xn.read_shift(2) : 0 };
  return Kn.Type ? parse_FilePassHeader(Xn, zn - 2, Kn) : parse_XORObfuscation(Xn, Un.biff >= 8 ? zn : zn - 2, Un, Kn), Kn;
}
var RTF = /* @__PURE__ */ function() {
  function Xn(qn, Jo) {
    switch (Jo.type) {
      case "base64":
        return zn(Base64_decode(qn), Jo);
      case "binary":
        return zn(qn, Jo);
      case "buffer":
        return zn(has_buf && Buffer.isBuffer(qn) ? qn.toString("binary") : a2s(qn), Jo);
      case "array":
        return zn(cc2str(qn), Jo);
    }
    throw new Error("Unrecognized type " + Jo.type);
  }
  function zn(qn, Jo) {
    var pa = Jo || {}, ma = pa.dense ? [] : {}, va = qn.match(/\\trowd.*?\\row\b/g);
    if (!va.length) throw new Error("RTF missing table");
    var ba = { s: { c: 0, r: 0 }, e: { c: 0, r: va.length - 1 } };
    return va.forEach(function(_a, ya) {
      Array.isArray(ma) && (ma[ya] = []);
      for (var xa = /\\\w+\b/g, wa = 0, Ta, Sa = -1; Ta = xa.exec(_a); ) {
        switch (Ta[0]) {
          case "\\cell":
            var Ma = _a.slice(wa, xa.lastIndex - Ta[0].length);
            if (Ma[0] == " " && (Ma = Ma.slice(1)), ++Sa, Ma.length) {
              var ka = { v: Ma, t: "s" };
              Array.isArray(ma) ? ma[ya][Sa] = ka : ma[encode_cell({ r: ya, c: Sa })] = ka;
            }
            break;
        }
        wa = xa.lastIndex;
      }
      Sa > ba.e.c && (ba.e.c = Sa);
    }), ma["!ref"] = encode_range(ba), ma;
  }
  function Un(qn, Jo) {
    return sheet_to_workbook(Xn(qn, Jo), Jo);
  }
  function Kn(qn) {
    for (var Jo = ["{\\rtf1\\ansi"], pa = safe_decode_range(qn["!ref"]), ma, va = Array.isArray(qn), ba = pa.s.r; ba <= pa.e.r; ++ba) {
      Jo.push("\\trowd\\trautofit1");
      for (var _a = pa.s.c; _a <= pa.e.c; ++_a) Jo.push("\\cellx" + (_a + 1));
      for (Jo.push("\\pard\\intbl"), _a = pa.s.c; _a <= pa.e.c; ++_a) {
        var ya = encode_cell({ r: ba, c: _a });
        ma = va ? (qn[ba] || [])[_a] : qn[ya], !(!ma || ma.v == null && (!ma.f || ma.F)) && (Jo.push(" " + (ma.w || (format_cell(ma), ma.w))), Jo.push("\\cell"));
      }
      Jo.push("\\pard\\intbl\\row");
    }
    return Jo.join("") + "}";
  }
  return {
    to_workbook: Un,
    to_sheet: Xn,
    from_sheet: Kn
  };
}();
function hex2RGB(Xn) {
  var zn = Xn.slice(Xn[0] === "#" ? 1 : 0).slice(0, 6);
  return [parseInt(zn.slice(0, 2), 16), parseInt(zn.slice(2, 4), 16), parseInt(zn.slice(4, 6), 16)];
}
function rgb2Hex(Xn) {
  for (var zn = 0, Un = 1; zn != 3; ++zn) Un = Un * 256 + (Xn[zn] > 255 ? 255 : Xn[zn] < 0 ? 0 : Xn[zn]);
  return Un.toString(16).toUpperCase().slice(1);
}
function rgb2HSL(Xn) {
  var zn = Xn[0] / 255, Un = Xn[1] / 255, Kn = Xn[2] / 255, qn = Math.max(zn, Un, Kn), Jo = Math.min(zn, Un, Kn), pa = qn - Jo;
  if (pa === 0) return [0, 0, zn];
  var ma = 0, va = 0, ba = qn + Jo;
  switch (va = pa / (ba > 1 ? 2 - ba : ba), qn) {
    case zn:
      ma = ((Un - Kn) / pa + 6) % 6;
      break;
    case Un:
      ma = (Kn - zn) / pa + 2;
      break;
    case Kn:
      ma = (zn - Un) / pa + 4;
      break;
  }
  return [ma / 6, va, ba / 2];
}
function hsl2RGB(Xn) {
  var zn = Xn[0], Un = Xn[1], Kn = Xn[2], qn = Un * 2 * (Kn < 0.5 ? Kn : 1 - Kn), Jo = Kn - qn / 2, pa = [Jo, Jo, Jo], ma = 6 * zn, va;
  if (Un !== 0) switch (ma | 0) {
    case 0:
    case 6:
      va = qn * ma, pa[0] += qn, pa[1] += va;
      break;
    case 1:
      va = qn * (2 - ma), pa[0] += va, pa[1] += qn;
      break;
    case 2:
      va = qn * (ma - 2), pa[1] += qn, pa[2] += va;
      break;
    case 3:
      va = qn * (4 - ma), pa[1] += va, pa[2] += qn;
      break;
    case 4:
      va = qn * (ma - 4), pa[2] += qn, pa[0] += va;
      break;
    case 5:
      va = qn * (6 - ma), pa[2] += va, pa[0] += qn;
      break;
  }
  for (var ba = 0; ba != 3; ++ba) pa[ba] = Math.round(pa[ba] * 255);
  return pa;
}
function rgb_tint(Xn, zn) {
  if (zn === 0) return Xn;
  var Un = rgb2HSL(hex2RGB(Xn));
  return zn < 0 ? Un[2] = Un[2] * (1 + zn) : Un[2] = 1 - (1 - Un[2]) * (1 - zn), rgb2Hex(hsl2RGB(Un));
}
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(Xn) {
  return Math.floor((Xn + Math.round(128 / MDW) / 256) * MDW);
}
function px2char(Xn) {
  return Math.floor((Xn - 5) / MDW * 100 + 0.5) / 100;
}
function char2width(Xn) {
  return Math.round((Xn * MDW + 5) / MDW * 256) / 256;
}
function cycle_width(Xn) {
  return char2width(px2char(width2px(Xn)));
}
function find_mdw_colw(Xn) {
  var zn = Math.abs(Xn - cycle_width(Xn)), Un = MDW;
  if (zn > 5e-3) for (MDW = MIN_MDW; MDW < MAX_MDW; ++MDW) Math.abs(Xn - cycle_width(Xn)) <= zn && (zn = Math.abs(Xn - cycle_width(Xn)), Un = MDW);
  MDW = Un;
}
function process_col(Xn) {
  Xn.width ? (Xn.wpx = width2px(Xn.width), Xn.wch = px2char(Xn.wpx), Xn.MDW = MDW) : Xn.wpx ? (Xn.wch = px2char(Xn.wpx), Xn.width = char2width(Xn.wch), Xn.MDW = MDW) : typeof Xn.wch == "number" && (Xn.width = char2width(Xn.wch), Xn.wpx = width2px(Xn.width), Xn.MDW = MDW), Xn.customWidth && delete Xn.customWidth;
}
var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(Xn) {
  return Xn * 96 / PPI;
}
function pt2px(Xn) {
  return Xn * PPI / 96;
}
var XLMLPatternTypeMap = {
  None: "none",
  Solid: "solid",
  Gray50: "mediumGray",
  Gray75: "darkGray",
  Gray25: "lightGray",
  HorzStripe: "darkHorizontal",
  VertStripe: "darkVertical",
  ReverseDiagStripe: "darkDown",
  DiagStripe: "darkUp",
  DiagCross: "darkGrid",
  ThickDiagCross: "darkTrellis",
  ThinHorzStripe: "lightHorizontal",
  ThinVertStripe: "lightVertical",
  ThinReverseDiagStripe: "lightDown",
  ThinHorzCross: "lightGrid"
};
function parse_borders(Xn, zn, Un, Kn) {
  zn.Borders = [];
  var qn = {}, Jo = !1;
  (Xn[0].match(tagregex) || []).forEach(function(pa) {
    var ma = parsexmltag(pa);
    switch (strip_ns(ma[0])) {
      case "<borders":
      case "<borders>":
      case "</borders>":
        break;
      /* 18.8.4 border CT_Border */
      case "<border":
      case "<border>":
      case "<border/>":
        qn = /*::(*/
        {}, ma.diagonalUp && (qn.diagonalUp = parsexmlbool(ma.diagonalUp)), ma.diagonalDown && (qn.diagonalDown = parsexmlbool(ma.diagonalDown)), zn.Borders.push(qn);
        break;
      case "</border>":
        break;
      /* note: not in spec, appears to be CT_BorderPr */
      case "<left/>":
        break;
      case "<left":
      case "<left>":
        break;
      case "</left>":
        break;
      /* note: not in spec, appears to be CT_BorderPr */
      case "<right/>":
        break;
      case "<right":
      case "<right>":
        break;
      case "</right>":
        break;
      /* 18.8.43 top CT_BorderPr */
      case "<top/>":
        break;
      case "<top":
      case "<top>":
        break;
      case "</top>":
        break;
      /* 18.8.6 bottom CT_BorderPr */
      case "<bottom/>":
        break;
      case "<bottom":
      case "<bottom>":
        break;
      case "</bottom>":
        break;
      /* 18.8.13 diagonal CT_BorderPr */
      case "<diagonal":
      case "<diagonal>":
      case "<diagonal/>":
        break;
      case "</diagonal>":
        break;
      /* 18.8.25 horizontal CT_BorderPr */
      case "<horizontal":
      case "<horizontal>":
      case "<horizontal/>":
        break;
      case "</horizontal>":
        break;
      /* 18.8.44 vertical CT_BorderPr */
      case "<vertical":
      case "<vertical>":
      case "<vertical/>":
        break;
      case "</vertical>":
        break;
      /* 18.8.37 start CT_BorderPr */
      case "<start":
      case "<start>":
      case "<start/>":
        break;
      case "</start>":
        break;
      /* 18.8.16 end CT_BorderPr */
      case "<end":
      case "<end>":
      case "<end/>":
        break;
      case "</end>":
        break;
      /* 18.8.? color CT_Color */
      case "<color":
      case "<color>":
        break;
      case "<color/>":
      case "</color>":
        break;
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        Jo = !0;
        break;
      case "</ext>":
        Jo = !1;
        break;
      default:
        if (Kn && Kn.WTF && !Jo)
          throw new Error("unrecognized " + ma[0] + " in borders");
    }
  });
}
function parse_fills(Xn, zn, Un, Kn) {
  zn.Fills = [];
  var qn = {}, Jo = !1;
  (Xn[0].match(tagregex) || []).forEach(function(pa) {
    var ma = parsexmltag(pa);
    switch (strip_ns(ma[0])) {
      case "<fills":
      case "<fills>":
      case "</fills>":
        break;
      /* 18.8.20 fill CT_Fill */
      case "<fill>":
      case "<fill":
      case "<fill/>":
        qn = {}, zn.Fills.push(qn);
        break;
      case "</fill>":
        break;
      /* 18.8.24 gradientFill CT_GradientFill */
      case "<gradientFill>":
        break;
      case "<gradientFill":
      case "</gradientFill>":
        zn.Fills.push(qn), qn = {};
        break;
      /* 18.8.32 patternFill CT_PatternFill */
      case "<patternFill":
      case "<patternFill>":
        ma.patternType && (qn.patternType = ma.patternType);
        break;
      case "<patternFill/>":
      case "</patternFill>":
        break;
      /* 18.8.3 bgColor CT_Color */
      case "<bgColor":
        qn.bgColor || (qn.bgColor = {}), ma.indexed && (qn.bgColor.indexed = parseInt(ma.indexed, 10)), ma.theme && (qn.bgColor.theme = parseInt(ma.theme, 10)), ma.tint && (qn.bgColor.tint = parseFloat(ma.tint)), ma.rgb && (qn.bgColor.rgb = ma.rgb.slice(-6));
        break;
      case "<bgColor/>":
      case "</bgColor>":
        break;
      /* 18.8.19 fgColor CT_Color */
      case "<fgColor":
        qn.fgColor || (qn.fgColor = {}), ma.theme && (qn.fgColor.theme = parseInt(ma.theme, 10)), ma.tint && (qn.fgColor.tint = parseFloat(ma.tint)), ma.rgb != null && (qn.fgColor.rgb = ma.rgb.slice(-6));
        break;
      case "<fgColor/>":
      case "</fgColor>":
        break;
      /* 18.8.38 stop CT_GradientStop */
      case "<stop":
      case "<stop/>":
        break;
      case "</stop>":
        break;
      /* 18.8.? color CT_Color */
      case "<color":
      case "<color/>":
        break;
      case "</color>":
        break;
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        Jo = !0;
        break;
      case "</ext>":
        Jo = !1;
        break;
      default:
        if (Kn && Kn.WTF && !Jo)
          throw new Error("unrecognized " + ma[0] + " in fills");
    }
  });
}
function parse_fonts(Xn, zn, Un, Kn) {
  zn.Fonts = [];
  var qn = {}, Jo = !1;
  (Xn[0].match(tagregex) || []).forEach(function(pa) {
    var ma = parsexmltag(pa);
    switch (strip_ns(ma[0])) {
      case "<fonts":
      case "<fonts>":
      case "</fonts>":
        break;
      /* 18.8.22 font CT_Font */
      case "<font":
      case "<font>":
        break;
      case "</font>":
      case "<font/>":
        zn.Fonts.push(qn), qn = {};
        break;
      /* 18.8.29 name CT_FontName */
      case "<name":
        ma.val && (qn.name = utf8read(ma.val));
        break;
      case "<name/>":
      case "</name>":
        break;
      /* 18.8.2  b CT_BooleanProperty */
      case "<b":
        qn.bold = ma.val ? parsexmlbool(ma.val) : 1;
        break;
      case "<b/>":
        qn.bold = 1;
        break;
      /* 18.8.26 i CT_BooleanProperty */
      case "<i":
        qn.italic = ma.val ? parsexmlbool(ma.val) : 1;
        break;
      case "<i/>":
        qn.italic = 1;
        break;
      /* 18.4.13 u CT_UnderlineProperty */
      case "<u":
        switch (ma.val) {
          case "none":
            qn.underline = 0;
            break;
          case "single":
            qn.underline = 1;
            break;
          case "double":
            qn.underline = 2;
            break;
          case "singleAccounting":
            qn.underline = 33;
            break;
          case "doubleAccounting":
            qn.underline = 34;
            break;
        }
        break;
      case "<u/>":
        qn.underline = 1;
        break;
      /* 18.4.10 strike CT_BooleanProperty */
      case "<strike":
        qn.strike = ma.val ? parsexmlbool(ma.val) : 1;
        break;
      case "<strike/>":
        qn.strike = 1;
        break;
      /* 18.4.2  outline CT_BooleanProperty */
      case "<outline":
        qn.outline = ma.val ? parsexmlbool(ma.val) : 1;
        break;
      case "<outline/>":
        qn.outline = 1;
        break;
      /* 18.8.36 shadow CT_BooleanProperty */
      case "<shadow":
        qn.shadow = ma.val ? parsexmlbool(ma.val) : 1;
        break;
      case "<shadow/>":
        qn.shadow = 1;
        break;
      /* 18.8.12 condense CT_BooleanProperty */
      case "<condense":
        qn.condense = ma.val ? parsexmlbool(ma.val) : 1;
        break;
      case "<condense/>":
        qn.condense = 1;
        break;
      /* 18.8.17 extend CT_BooleanProperty */
      case "<extend":
        qn.extend = ma.val ? parsexmlbool(ma.val) : 1;
        break;
      case "<extend/>":
        qn.extend = 1;
        break;
      /* 18.4.11 sz CT_FontSize */
      case "<sz":
        ma.val && (qn.sz = +ma.val);
        break;
      case "<sz/>":
      case "</sz>":
        break;
      /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
      case "<vertAlign":
        ma.val && (qn.vertAlign = ma.val);
        break;
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      /* 18.8.18 family CT_FontFamily */
      case "<family":
        ma.val && (qn.family = parseInt(ma.val, 10));
        break;
      case "<family/>":
      case "</family>":
        break;
      /* 18.8.35 scheme CT_FontScheme */
      case "<scheme":
        ma.val && (qn.scheme = ma.val);
        break;
      case "<scheme/>":
      case "</scheme>":
        break;
      /* 18.4.1 charset CT_IntProperty */
      case "<charset":
        if (ma.val == "1") break;
        ma.codepage = CS2CP[parseInt(ma.val, 10)];
        break;
      /* 18.?.? color CT_Color */
      case "<color":
        if (qn.color || (qn.color = {}), ma.auto && (qn.color.auto = parsexmlbool(ma.auto)), ma.rgb) qn.color.rgb = ma.rgb.slice(-6);
        else if (ma.indexed) {
          qn.color.index = parseInt(ma.indexed, 10);
          var va = XLSIcv[qn.color.index];
          qn.color.index == 81 && (va = XLSIcv[1]), va || (va = XLSIcv[1]), qn.color.rgb = va[0].toString(16) + va[1].toString(16) + va[2].toString(16);
        } else ma.theme && (qn.color.theme = parseInt(ma.theme, 10), ma.tint && (qn.color.tint = parseFloat(ma.tint)), ma.theme && Un.themeElements && Un.themeElements.clrScheme && (qn.color.rgb = rgb_tint(Un.themeElements.clrScheme[qn.color.theme].rgb, qn.color.tint || 0)));
        break;
      case "<color/>":
      case "</color>":
        break;
      /* note: sometimes mc:AlternateContent appears bare */
      case "<AlternateContent":
        Jo = !0;
        break;
      case "</AlternateContent>":
        Jo = !1;
        break;
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        Jo = !0;
        break;
      case "</ext>":
        Jo = !1;
        break;
      default:
        if (Kn && Kn.WTF && !Jo)
          throw new Error("unrecognized " + ma[0] + " in fonts");
    }
  });
}
function parse_numFmts(Xn, zn, Un) {
  zn.NumberFmt = [];
  for (var Kn = keys(table_fmt), qn = 0; qn < Kn.length; ++qn) zn.NumberFmt[Kn[qn]] = table_fmt[Kn[qn]];
  var Jo = Xn[0].match(tagregex);
  if (Jo)
    for (qn = 0; qn < Jo.length; ++qn) {
      var pa = parsexmltag(Jo[qn]);
      switch (strip_ns(pa[0])) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var ma = unescapexml(utf8read(pa.formatCode)), va = parseInt(pa.numFmtId, 10);
            if (zn.NumberFmt[va] = ma, va > 0) {
              if (va > 392) {
                for (va = 392; va > 60 && zn.NumberFmt[va] != null; --va) ;
                zn.NumberFmt[va] = ma;
              }
              SSF_load(ma, va);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (Un.WTF) throw new Error("unrecognized " + pa[0] + " in numFmts");
      }
    }
}
var cellXF_uint = ["numFmtId", "fillId", "fontId", "borderId", "xfId"], cellXF_bool = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"];
function parse_cellXfs(Xn, zn, Un) {
  zn.CellXf = [];
  var Kn, qn = !1;
  (Xn[0].match(tagregex) || []).forEach(function(Jo) {
    var pa = parsexmltag(Jo), ma = 0;
    switch (strip_ns(pa[0])) {
      case "<cellXfs":
      case "<cellXfs>":
      case "<cellXfs/>":
      case "</cellXfs>":
        break;
      /* 18.8.45 xf CT_Xf */
      case "<xf":
      case "<xf/>":
        for (Kn = pa, delete Kn[0], ma = 0; ma < cellXF_uint.length; ++ma) Kn[cellXF_uint[ma]] && (Kn[cellXF_uint[ma]] = parseInt(Kn[cellXF_uint[ma]], 10));
        for (ma = 0; ma < cellXF_bool.length; ++ma) Kn[cellXF_bool[ma]] && (Kn[cellXF_bool[ma]] = parsexmlbool(Kn[cellXF_bool[ma]]));
        if (zn.NumberFmt && Kn.numFmtId > 392) {
          for (ma = 392; ma > 60; --ma) if (zn.NumberFmt[Kn.numFmtId] == zn.NumberFmt[ma]) {
            Kn.numFmtId = ma;
            break;
          }
        }
        zn.CellXf.push(Kn);
        break;
      case "</xf>":
        break;
      /* 18.8.1 alignment CT_CellAlignment */
      case "<alignment":
      case "<alignment/>":
        var va = {};
        pa.vertical && (va.vertical = pa.vertical), pa.horizontal && (va.horizontal = pa.horizontal), pa.textRotation != null && (va.textRotation = pa.textRotation), pa.indent && (va.indent = pa.indent), pa.wrapText && (va.wrapText = parsexmlbool(pa.wrapText)), Kn.alignment = va;
        break;
      case "</alignment>":
        break;
      /* 18.8.33 protection CT_CellProtection */
      case "<protection":
        break;
      case "</protection>":
      case "<protection/>":
        break;
      /* note: sometimes mc:AlternateContent appears bare */
      case "<AlternateContent":
        qn = !0;
        break;
      case "</AlternateContent>":
        qn = !1;
        break;
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        qn = !0;
        break;
      case "</ext>":
        qn = !1;
        break;
      default:
        if (Un && Un.WTF && !qn)
          throw new Error("unrecognized " + pa[0] + " in cellXfs");
    }
  });
}
var parse_sty_xml = /* @__PURE__ */ function() {
  var zn = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, Un = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, Kn = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, qn = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, Jo = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
  return function(ma, va, ba) {
    var _a = {};
    if (!ma) return _a;
    ma = ma.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var ya;
    return (ya = ma.match(zn)) && parse_numFmts(ya, _a, ba), (ya = ma.match(qn)) && parse_fonts(ya, _a, va, ba), (ya = ma.match(Kn)) && parse_fills(ya, _a, va, ba), (ya = ma.match(Jo)) && parse_borders(ya, _a, va, ba), (ya = ma.match(Un)) && parse_cellXfs(ya, _a, ba), _a;
  };
}();
function parse_BrtFmt(Xn, zn) {
  var Un = Xn.read_shift(2), Kn = parse_XLWideString(Xn);
  return [Un, Kn];
}
function parse_BrtFont(Xn, zn, Un) {
  var Kn = {};
  Kn.sz = Xn.read_shift(2) / 20;
  var qn = parse_FontFlags(Xn);
  qn.fItalic && (Kn.italic = 1), qn.fCondense && (Kn.condense = 1), qn.fExtend && (Kn.extend = 1), qn.fShadow && (Kn.shadow = 1), qn.fOutline && (Kn.outline = 1), qn.fStrikeout && (Kn.strike = 1);
  var Jo = Xn.read_shift(2);
  switch (Jo === 700 && (Kn.bold = 1), Xn.read_shift(2)) {
    /* case 0: out.vertAlign = "baseline"; break; */
    case 1:
      Kn.vertAlign = "superscript";
      break;
    case 2:
      Kn.vertAlign = "subscript";
      break;
  }
  var pa = Xn.read_shift(1);
  pa != 0 && (Kn.underline = pa);
  var ma = Xn.read_shift(1);
  ma > 0 && (Kn.family = ma);
  var va = Xn.read_shift(1);
  switch (va > 0 && (Kn.charset = va), Xn.l++, Kn.color = parse_BrtColor(Xn), Xn.read_shift(1)) {
    /* case 0: out.scheme = "none": break; */
    case 1:
      Kn.scheme = "major";
      break;
    case 2:
      Kn.scheme = "minor";
      break;
  }
  return Kn.name = parse_XLWideString(Xn), Kn;
}
var parse_BrtFill = parsenoop;
function parse_BrtXF(Xn, zn) {
  var Un = Xn.l + zn, Kn = Xn.read_shift(2), qn = Xn.read_shift(2);
  return Xn.l = Un, { ixfe: Kn, numFmtId: qn };
}
var parse_BrtBorder = parsenoop;
function parse_sty_bin(Xn, zn, Un) {
  var Kn = {};
  Kn.NumberFmt = [];
  for (var qn in table_fmt) Kn.NumberFmt[qn] = table_fmt[qn];
  Kn.CellXf = [], Kn.Fonts = [];
  var Jo = [], pa = !1;
  return recordhopper(Xn, function(va, ba, _a) {
    switch (_a) {
      case 44:
        Kn.NumberFmt[va[0]] = va[1], SSF_load(va[1], va[0]);
        break;
      case 43:
        Kn.Fonts.push(va), va.color.theme != null && zn && zn.themeElements && zn.themeElements.clrScheme && (va.color.rgb = rgb_tint(zn.themeElements.clrScheme[va.color.theme].rgb, va.color.tint || 0));
        break;
      case 1025:
        break;
      case 45:
        break;
      case 46:
        break;
      case 47:
        Jo[Jo.length - 1] == 617 && Kn.CellXf.push(va);
        break;
      case 48:
      /* BrtStyle */
      case 507:
      /* BrtDXF */
      case 572:
      /* BrtMRUColor */
      case 475:
        break;
      case 1171:
      /* BrtDXF14 */
      case 2102:
      /* BrtDXF15 */
      case 1130:
      /* BrtSlicerStyleElement */
      case 512:
      /* BrtTableStyleElement */
      case 2095:
      /* BrtTimelineStyleElement */
      case 3072:
        break;
      case 35:
        pa = !0;
        break;
      case 36:
        pa = !1;
        break;
      case 37:
        Jo.push(_a), pa = !0;
        break;
      case 38:
        Jo.pop(), pa = !1;
        break;
      default:
        if (ba.T > 0) Jo.push(_a);
        else if (ba.T < 0) Jo.pop();
        else if (!pa || Un.WTF && Jo[Jo.length - 1] != 37) throw new Error("Unexpected record 0x" + _a.toString(16));
    }
  }), Kn;
}
var XLSXThemeClrScheme = [
  "</a:lt1>",
  "</a:dk1>",
  "</a:lt2>",
  "</a:dk2>",
  "</a:accent1>",
  "</a:accent2>",
  "</a:accent3>",
  "</a:accent4>",
  "</a:accent5>",
  "</a:accent6>",
  "</a:hlink>",
  "</a:folHlink>"
];
function parse_clrScheme(Xn, zn, Un) {
  zn.themeElements.clrScheme = [];
  var Kn = {};
  (Xn[0].match(tagregex) || []).forEach(function(qn) {
    var Jo = parsexmltag(qn);
    switch (Jo[0]) {
      /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
      case "<a:clrScheme":
      case "</a:clrScheme>":
        break;
      /* 20.1.2.3.32 srgbClr CT_SRgbColor */
      case "<a:srgbClr":
        Kn.rgb = Jo.val;
        break;
      /* 20.1.2.3.33 sysClr CT_SystemColor */
      case "<a:sysClr":
        Kn.rgb = Jo.lastClr;
        break;
      /* 20.1.4.1.1 accent1 (Accent 1) */
      /* 20.1.4.1.2 accent2 (Accent 2) */
      /* 20.1.4.1.3 accent3 (Accent 3) */
      /* 20.1.4.1.4 accent4 (Accent 4) */
      /* 20.1.4.1.5 accent5 (Accent 5) */
      /* 20.1.4.1.6 accent6 (Accent 6) */
      /* 20.1.4.1.9 dk1 (Dark 1) */
      /* 20.1.4.1.10 dk2 (Dark 2) */
      /* 20.1.4.1.15 folHlink (Followed Hyperlink) */
      /* 20.1.4.1.19 hlink (Hyperlink) */
      /* 20.1.4.1.22 lt1 (Light 1) */
      /* 20.1.4.1.23 lt2 (Light 2) */
      case "<a:dk1>":
      case "</a:dk1>":
      case "<a:lt1>":
      case "</a:lt1>":
      case "<a:dk2>":
      case "</a:dk2>":
      case "<a:lt2>":
      case "</a:lt2>":
      case "<a:accent1>":
      case "</a:accent1>":
      case "<a:accent2>":
      case "</a:accent2>":
      case "<a:accent3>":
      case "</a:accent3>":
      case "<a:accent4>":
      case "</a:accent4>":
      case "<a:accent5>":
      case "</a:accent5>":
      case "<a:accent6>":
      case "</a:accent6>":
      case "<a:hlink>":
      case "</a:hlink>":
      case "<a:folHlink>":
      case "</a:folHlink>":
        Jo[0].charAt(1) === "/" ? (zn.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(Jo[0])] = Kn, Kn = {}) : Kn.name = Jo[0].slice(3, Jo[0].length - 1);
        break;
      default:
        if (Un && Un.WTF) throw new Error("Unrecognized " + Jo[0] + " in clrScheme");
    }
  });
}
function parse_fontScheme() {
}
function parse_fmtScheme() {
}
var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
function parse_themeElements(Xn, zn, Un) {
  zn.themeElements = {};
  var Kn;
  [
    /* clrScheme CT_ColorScheme */
    ["clrScheme", clrsregex, parse_clrScheme],
    /* fontScheme CT_FontScheme */
    ["fontScheme", fntsregex, parse_fontScheme],
    /* fmtScheme CT_StyleMatrix */
    ["fmtScheme", fmtsregex, parse_fmtScheme]
  ].forEach(function(qn) {
    if (!(Kn = Xn.match(qn[1]))) throw new Error(qn[0] + " not found in themeElements");
    qn[2](Kn, zn, Un);
  });
}
var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
function parse_theme_xml(Xn, zn) {
  (!Xn || Xn.length === 0) && (Xn = write_theme());
  var Un, Kn = {};
  if (!(Un = Xn.match(themeltregex))) throw new Error("themeElements not found in theme");
  return parse_themeElements(Un[0], Kn, zn), Kn.raw = Xn, Kn;
}
function write_theme(Xn, zn) {
  var Un = [XML_HEADER];
  return Un[Un.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', Un[Un.length] = "<a:themeElements>", Un[Un.length] = '<a:clrScheme name="Office">', Un[Un.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', Un[Un.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', Un[Un.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', Un[Un.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', Un[Un.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', Un[Un.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', Un[Un.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', Un[Un.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', Un[Un.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', Un[Un.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', Un[Un.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', Un[Un.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', Un[Un.length] = "</a:clrScheme>", Un[Un.length] = '<a:fontScheme name="Office">', Un[Un.length] = "<a:majorFont>", Un[Un.length] = '<a:latin typeface="Cambria"/>', Un[Un.length] = '<a:ea typeface=""/>', Un[Un.length] = '<a:cs typeface=""/>', Un[Un.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', Un[Un.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', Un[Un.length] = '<a:font script="Hans" typeface="宋体"/>', Un[Un.length] = '<a:font script="Hant" typeface="新細明體"/>', Un[Un.length] = '<a:font script="Arab" typeface="Times New Roman"/>', Un[Un.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', Un[Un.length] = '<a:font script="Thai" typeface="Tahoma"/>', Un[Un.length] = '<a:font script="Ethi" typeface="Nyala"/>', Un[Un.length] = '<a:font script="Beng" typeface="Vrinda"/>', Un[Un.length] = '<a:font script="Gujr" typeface="Shruti"/>', Un[Un.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', Un[Un.length] = '<a:font script="Knda" typeface="Tunga"/>', Un[Un.length] = '<a:font script="Guru" typeface="Raavi"/>', Un[Un.length] = '<a:font script="Cans" typeface="Euphemia"/>', Un[Un.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', Un[Un.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', Un[Un.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', Un[Un.length] = '<a:font script="Thaa" typeface="MV Boli"/>', Un[Un.length] = '<a:font script="Deva" typeface="Mangal"/>', Un[Un.length] = '<a:font script="Telu" typeface="Gautami"/>', Un[Un.length] = '<a:font script="Taml" typeface="Latha"/>', Un[Un.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', Un[Un.length] = '<a:font script="Orya" typeface="Kalinga"/>', Un[Un.length] = '<a:font script="Mlym" typeface="Kartika"/>', Un[Un.length] = '<a:font script="Laoo" typeface="DokChampa"/>', Un[Un.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', Un[Un.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', Un[Un.length] = '<a:font script="Viet" typeface="Times New Roman"/>', Un[Un.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', Un[Un.length] = '<a:font script="Geor" typeface="Sylfaen"/>', Un[Un.length] = "</a:majorFont>", Un[Un.length] = "<a:minorFont>", Un[Un.length] = '<a:latin typeface="Calibri"/>', Un[Un.length] = '<a:ea typeface=""/>', Un[Un.length] = '<a:cs typeface=""/>', Un[Un.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', Un[Un.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', Un[Un.length] = '<a:font script="Hans" typeface="宋体"/>', Un[Un.length] = '<a:font script="Hant" typeface="新細明體"/>', Un[Un.length] = '<a:font script="Arab" typeface="Arial"/>', Un[Un.length] = '<a:font script="Hebr" typeface="Arial"/>', Un[Un.length] = '<a:font script="Thai" typeface="Tahoma"/>', Un[Un.length] = '<a:font script="Ethi" typeface="Nyala"/>', Un[Un.length] = '<a:font script="Beng" typeface="Vrinda"/>', Un[Un.length] = '<a:font script="Gujr" typeface="Shruti"/>', Un[Un.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', Un[Un.length] = '<a:font script="Knda" typeface="Tunga"/>', Un[Un.length] = '<a:font script="Guru" typeface="Raavi"/>', Un[Un.length] = '<a:font script="Cans" typeface="Euphemia"/>', Un[Un.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', Un[Un.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', Un[Un.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', Un[Un.length] = '<a:font script="Thaa" typeface="MV Boli"/>', Un[Un.length] = '<a:font script="Deva" typeface="Mangal"/>', Un[Un.length] = '<a:font script="Telu" typeface="Gautami"/>', Un[Un.length] = '<a:font script="Taml" typeface="Latha"/>', Un[Un.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', Un[Un.length] = '<a:font script="Orya" typeface="Kalinga"/>', Un[Un.length] = '<a:font script="Mlym" typeface="Kartika"/>', Un[Un.length] = '<a:font script="Laoo" typeface="DokChampa"/>', Un[Un.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', Un[Un.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', Un[Un.length] = '<a:font script="Viet" typeface="Arial"/>', Un[Un.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', Un[Un.length] = '<a:font script="Geor" typeface="Sylfaen"/>', Un[Un.length] = "</a:minorFont>", Un[Un.length] = "</a:fontScheme>", Un[Un.length] = '<a:fmtScheme name="Office">', Un[Un.length] = "<a:fillStyleLst>", Un[Un.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', Un[Un.length] = '<a:gradFill rotWithShape="1">', Un[Un.length] = "<a:gsLst>", Un[Un.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', Un[Un.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', Un[Un.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', Un[Un.length] = "</a:gsLst>", Un[Un.length] = '<a:lin ang="16200000" scaled="1"/>', Un[Un.length] = "</a:gradFill>", Un[Un.length] = '<a:gradFill rotWithShape="1">', Un[Un.length] = "<a:gsLst>", Un[Un.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', Un[Un.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', Un[Un.length] = "</a:gsLst>", Un[Un.length] = '<a:lin ang="16200000" scaled="0"/>', Un[Un.length] = "</a:gradFill>", Un[Un.length] = "</a:fillStyleLst>", Un[Un.length] = "<a:lnStyleLst>", Un[Un.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', Un[Un.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', Un[Un.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', Un[Un.length] = "</a:lnStyleLst>", Un[Un.length] = "<a:effectStyleLst>", Un[Un.length] = "<a:effectStyle>", Un[Un.length] = "<a:effectLst>", Un[Un.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', Un[Un.length] = "</a:effectLst>", Un[Un.length] = "</a:effectStyle>", Un[Un.length] = "<a:effectStyle>", Un[Un.length] = "<a:effectLst>", Un[Un.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', Un[Un.length] = "</a:effectLst>", Un[Un.length] = "</a:effectStyle>", Un[Un.length] = "<a:effectStyle>", Un[Un.length] = "<a:effectLst>", Un[Un.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', Un[Un.length] = "</a:effectLst>", Un[Un.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', Un[Un.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', Un[Un.length] = "</a:effectStyle>", Un[Un.length] = "</a:effectStyleLst>", Un[Un.length] = "<a:bgFillStyleLst>", Un[Un.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', Un[Un.length] = '<a:gradFill rotWithShape="1">', Un[Un.length] = "<a:gsLst>", Un[Un.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', Un[Un.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', Un[Un.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', Un[Un.length] = "</a:gsLst>", Un[Un.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', Un[Un.length] = "</a:gradFill>", Un[Un.length] = '<a:gradFill rotWithShape="1">', Un[Un.length] = "<a:gsLst>", Un[Un.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', Un[Un.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', Un[Un.length] = "</a:gsLst>", Un[Un.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', Un[Un.length] = "</a:gradFill>", Un[Un.length] = "</a:bgFillStyleLst>", Un[Un.length] = "</a:fmtScheme>", Un[Un.length] = "</a:themeElements>", Un[Un.length] = "<a:objectDefaults>", Un[Un.length] = "<a:spDef>", Un[Un.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', Un[Un.length] = "</a:spDef>", Un[Un.length] = "<a:lnDef>", Un[Un.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', Un[Un.length] = "</a:lnDef>", Un[Un.length] = "</a:objectDefaults>", Un[Un.length] = "<a:extraClrSchemeLst/>", Un[Un.length] = "</a:theme>", Un.join("");
}
function parse_Theme(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = Xn.read_shift(4);
  if (qn !== 124226) {
    if (!Un.cellStyles) {
      Xn.l = Kn;
      return;
    }
    var Jo = Xn.slice(Xn.l);
    Xn.l = Kn;
    var pa;
    try {
      pa = zip_read(Jo, { type: "array" });
    } catch {
      return;
    }
    var ma = getzipstr(pa, "theme/theme/theme1.xml", !0);
    if (ma)
      return parse_theme_xml(ma, Un);
  }
}
function parse_ColorTheme(Xn) {
  return Xn.read_shift(4);
}
function parse_FullColorExt(Xn) {
  var zn = {};
  switch (zn.xclrType = Xn.read_shift(2), zn.nTintShade = Xn.read_shift(2), zn.xclrType) {
    case 0:
      Xn.l += 4;
      break;
    case 1:
      zn.xclrValue = parse_IcvXF(Xn, 4);
      break;
    case 2:
      zn.xclrValue = parse_LongRGBA(Xn);
      break;
    case 3:
      zn.xclrValue = parse_ColorTheme(Xn);
      break;
    case 4:
      Xn.l += 4;
      break;
  }
  return Xn.l += 8, zn;
}
function parse_IcvXF(Xn, zn) {
  return parsenoop(Xn, zn);
}
function parse_XFExtGradient(Xn, zn) {
  return parsenoop(Xn, zn);
}
function parse_ExtProp(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2) - 4, Kn = [zn];
  switch (zn) {
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
      Kn[1] = parse_FullColorExt(Xn);
      break;
    case 6:
      Kn[1] = parse_XFExtGradient(Xn, Un);
      break;
    case 14:
    case 15:
      Kn[1] = Xn.read_shift(Un === 1 ? 1 : 2);
      break;
    default:
      throw new Error("Unrecognized ExtProp type: " + zn + " " + Un);
  }
  return Kn;
}
function parse_XFExt(Xn, zn) {
  var Un = Xn.l + zn;
  Xn.l += 2;
  var Kn = Xn.read_shift(2);
  Xn.l += 2;
  for (var qn = Xn.read_shift(2), Jo = []; qn-- > 0; ) Jo.push(parse_ExtProp(Xn, Un - Xn.l));
  return { ixfe: Kn, ext: Jo };
}
function update_xfext(Xn, zn) {
  zn.forEach(function(Un) {
    Un[0];
  });
}
function parse_BrtMdtinfo(Xn, zn) {
  return {
    flags: Xn.read_shift(4),
    version: Xn.read_shift(4),
    name: parse_XLWideString(Xn)
  };
}
function parse_BrtMdb(Xn) {
  for (var zn = [], Un = Xn.read_shift(4); Un-- > 0; )
    zn.push([Xn.read_shift(4), Xn.read_shift(4)]);
  return zn;
}
function parse_BrtBeginEsmdb(Xn) {
  return Xn.l += 4, Xn.read_shift(4) != 0;
}
function parse_xlmeta_bin(Xn, zn, Un) {
  var Kn = { Types: [], Cell: [], Value: [] }, qn = Un || {}, Jo = [], pa = !1, ma = 2;
  return recordhopper(Xn, function(va, ba, _a) {
    switch (_a) {
      case 335:
        Kn.Types.push({ name: va.name });
        break;
      case 51:
        va.forEach(function(ya) {
          ma == 1 ? Kn.Cell.push({ type: Kn.Types[ya[0] - 1].name, index: ya[1] }) : ma == 0 && Kn.Value.push({ type: Kn.Types[ya[0] - 1].name, index: ya[1] });
        });
        break;
      case 337:
        ma = va ? 1 : 0;
        break;
      case 338:
        ma = 2;
        break;
      case 35:
        Jo.push(_a), pa = !0;
        break;
      case 36:
        Jo.pop(), pa = !1;
        break;
      default:
        if (!ba.T) {
          if (!pa || qn.WTF && Jo[Jo.length - 1] != 35)
            throw new Error("Unexpected record 0x" + _a.toString(16));
        }
    }
  }), Kn;
}
function parse_xlmeta_xml(Xn, zn, Un) {
  var Kn = { Types: [], Cell: [], Value: [] };
  if (!Xn)
    return Kn;
  var qn = !1, Jo = 2, pa;
  return Xn.replace(tagregex, function(ma) {
    var va = parsexmltag(ma);
    switch (strip_ns(va[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        Kn.Types.push({ name: va.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var ba = 0; ba < Kn.Types.length; ++ba)
          Kn.Types[ba].name == va.name && (pa = Kn.Types[ba]);
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        Jo == 1 ? Kn.Cell.push({ type: Kn.Types[va.t - 1].name, index: +va.v }) : Jo == 0 && Kn.Value.push({ type: Kn.Types[va.t - 1].name, index: +va.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        Jo = 1;
        break;
      case "</cellMetadata>":
        Jo = 2;
        break;
      case "<valueMetadata":
        Jo = 0;
        break;
      case "</valueMetadata>":
        Jo = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        qn = !0;
        break;
      case "</ext>":
        qn = !1;
        break;
      case "<rvb":
        if (!pa)
          break;
        pa.offsets || (pa.offsets = []), pa.offsets.push(+va.i);
        break;
      default:
        if (!qn && Un.WTF)
          throw new Error("unrecognized " + va[0] + " in metadata");
    }
    return ma;
  }), Kn;
}
function parse_cc_xml(Xn) {
  var zn = [];
  if (!Xn) return zn;
  var Un = 1;
  return (Xn.match(tagregex) || []).forEach(function(Kn) {
    var qn = parsexmltag(Kn);
    switch (qn[0]) {
      case "<?xml":
        break;
      /* 18.6.2  calcChain CT_CalcChain 1 */
      case "<calcChain":
      case "<calcChain>":
      case "</calcChain>":
        break;
      /* 18.6.1  c CT_CalcCell 1 */
      case "<c":
        delete qn[0], qn.i ? Un = qn.i : qn.i = Un, zn.push(qn);
        break;
    }
  }), zn;
}
function parse_BrtCalcChainItem$(Xn) {
  var zn = {};
  zn.i = Xn.read_shift(4);
  var Un = {};
  Un.r = Xn.read_shift(4), Un.c = Xn.read_shift(4), zn.r = encode_cell(Un);
  var Kn = Xn.read_shift(1);
  return Kn & 2 && (zn.l = "1"), Kn & 8 && (zn.a = "1"), zn;
}
function parse_cc_bin(Xn, zn, Un) {
  var Kn = [];
  return recordhopper(Xn, function(Jo, pa, ma) {
    switch (ma) {
      case 63:
        Kn.push(Jo);
        break;
      default:
        if (!pa.T) throw new Error("Unexpected record 0x" + ma.toString(16));
    }
  }), Kn;
}
function parse_xlink_xml() {
}
function parse_xlink_bin(Xn, zn, Un, Kn) {
  if (!Xn) return Xn;
  var qn = Kn || {}, Jo = !1;
  recordhopper(Xn, function(ma, va, ba) {
    switch (ba) {
      case 359:
      /* 'BrtSupTabs' */
      case 363:
      /* 'BrtExternTableStart' */
      case 364:
      /* 'BrtExternTableEnd' */
      case 366:
      /* 'BrtExternRowHdr' */
      case 367:
      /* 'BrtExternCellBlank' */
      case 368:
      /* 'BrtExternCellReal' */
      case 369:
      /* 'BrtExternCellBool' */
      case 370:
      /* 'BrtExternCellError' */
      case 371:
      /* 'BrtExternCellString' */
      case 472:
      /* 'BrtExternValueMeta' */
      case 577:
      /* 'BrtSupNameStart' */
      case 578:
      /* 'BrtSupNameValueStart' */
      case 579:
      /* 'BrtSupNameValueEnd' */
      case 580:
      /* 'BrtSupNameNum' */
      case 581:
      /* 'BrtSupNameErr' */
      case 582:
      /* 'BrtSupNameSt' */
      case 583:
      /* 'BrtSupNameNil' */
      case 584:
      /* 'BrtSupNameBool' */
      case 585:
      /* 'BrtSupNameFmla' */
      case 586:
      /* 'BrtSupNameBits' */
      case 587:
        break;
      case 35:
        Jo = !0;
        break;
      case 36:
        Jo = !1;
        break;
      default:
        if (!va.T) {
          if (!Jo || qn.WTF) throw new Error("Unexpected record 0x" + ba.toString(16));
        }
    }
  }, qn);
}
function parse_drawing(Xn, zn) {
  if (!Xn) return "??";
  var Un = (Xn.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
  return zn["!id"][Un].Target;
}
function sheet_insert_comments(Xn, zn, Un, Kn) {
  var qn = Array.isArray(Xn), Jo;
  zn.forEach(function(pa) {
    var ma = decode_cell(pa.ref);
    if (qn ? (Xn[ma.r] || (Xn[ma.r] = []), Jo = Xn[ma.r][ma.c]) : Jo = Xn[pa.ref], !Jo) {
      Jo = { t: "z" }, qn ? Xn[ma.r][ma.c] = Jo : Xn[pa.ref] = Jo;
      var va = safe_decode_range(Xn["!ref"] || "BDWGO1000001:A1");
      va.s.r > ma.r && (va.s.r = ma.r), va.e.r < ma.r && (va.e.r = ma.r), va.s.c > ma.c && (va.s.c = ma.c), va.e.c < ma.c && (va.e.c = ma.c);
      var ba = encode_range(va);
      ba !== Xn["!ref"] && (Xn["!ref"] = ba);
    }
    Jo.c || (Jo.c = []);
    var _a = { a: pa.author, t: pa.t, r: pa.r, T: Un };
    pa.h && (_a.h = pa.h);
    for (var ya = Jo.c.length - 1; ya >= 0; --ya) {
      if (!Un && Jo.c[ya].T) return;
      Un && !Jo.c[ya].T && Jo.c.splice(ya, 1);
    }
    if (Un && Kn) {
      for (ya = 0; ya < Kn.length; ++ya)
        if (_a.a == Kn[ya].id) {
          _a.a = Kn[ya].name || _a.a;
          break;
        }
    }
    Jo.c.push(_a);
  });
}
function parse_comments_xml(Xn, zn) {
  if (Xn.match(/<(?:\w+:)?comments *\/>/)) return [];
  var Un = [], Kn = [], qn = Xn.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  qn && qn[1] && qn[1].split(/<\/\w*:?author>/).forEach(function(pa) {
    if (!(pa === "" || pa.trim() === "")) {
      var ma = pa.match(/<(?:\w+:)?author[^>]*>(.*)/);
      ma && Un.push(ma[1]);
    }
  });
  var Jo = Xn.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  return Jo && Jo[1] && Jo[1].split(/<\/\w*:?comment>/).forEach(function(pa) {
    if (!(pa === "" || pa.trim() === "")) {
      var ma = pa.match(/<(?:\w+:)?comment[^>]*>/);
      if (ma) {
        var va = parsexmltag(ma[0]), ba = { author: va.authorId && Un[va.authorId] || "sheetjsghost", ref: va.ref, guid: va.guid }, _a = decode_cell(va.ref);
        if (!(zn.sheetRows && zn.sheetRows <= _a.r)) {
          var ya = pa.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/), xa = !!ya && !!ya[1] && parse_si(ya[1]) || { r: "", t: "", h: "" };
          ba.r = xa.r, xa.r == "<t></t>" && (xa.t = xa.h = ""), ba.t = (xa.t || "").replace(/\r\n/g, `
`).replace(/\r/g, `
`), zn.cellHTML && (ba.h = xa.h), Kn.push(ba);
        }
      }
    }
  }), Kn;
}
function parse_tcmnt_xml(Xn, zn) {
  var Un = [], Kn = !1, qn = {}, Jo = 0;
  return Xn.replace(tagregex, function(ma, va) {
    var ba = parsexmltag(ma);
    switch (strip_ns(ba[0])) {
      case "<?xml":
        break;
      /* 2.6.207 ThreadedComments CT_ThreadedComments */
      case "<ThreadedComments":
        break;
      case "</ThreadedComments>":
        break;
      /* 2.6.205 threadedComment CT_ThreadedComment */
      case "<threadedComment":
        qn = { author: ba.personId, guid: ba.id, ref: ba.ref, T: 1 };
        break;
      case "</threadedComment>":
        qn.t != null && Un.push(qn);
        break;
      case "<text>":
      case "<text":
        Jo = va + ma.length;
        break;
      case "</text>":
        qn.t = Xn.slice(Jo, va).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
        break;
      /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
      case "<mentions":
      case "<mentions>":
        Kn = !0;
        break;
      case "</mentions>":
        Kn = !1;
        break;
      /* 2.6.202 mention CT_Mention TODO */
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      /* 18.2.7  ext CT_Extension + */
      case "<ext":
        Kn = !0;
        break;
      case "</ext>":
        Kn = !1;
        break;
      default:
        if (!Kn && zn.WTF) throw new Error("unrecognized " + ba[0] + " in threaded comments");
    }
    return ma;
  }), Un;
}
function parse_people_xml(Xn, zn) {
  var Un = [], Kn = !1;
  return Xn.replace(tagregex, function(Jo) {
    var pa = parsexmltag(Jo);
    switch (strip_ns(pa[0])) {
      case "<?xml":
        break;
      /* 2.4.85 personList CT_PersonList */
      case "<personList":
        break;
      case "</personList>":
        break;
      /* 2.6.203 person CT_Person TODO: providers */
      case "<person":
        Un.push({ name: pa.displayname, id: pa.id });
        break;
      case "</person>":
        break;
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      /* 18.2.7  ext CT_Extension + */
      case "<ext":
        Kn = !0;
        break;
      case "</ext>":
        Kn = !1;
        break;
      default:
        if (!Kn && zn.WTF) throw new Error("unrecognized " + pa[0] + " in threaded comments");
    }
    return Jo;
  }), Un;
}
function parse_BrtBeginComment(Xn) {
  var zn = {};
  zn.iauthor = Xn.read_shift(4);
  var Un = parse_UncheckedRfX(Xn);
  return zn.rfx = Un.s, zn.ref = encode_cell(Un.s), Xn.l += 16, zn;
}
var parse_BrtCommentAuthor = parse_XLWideString;
function parse_comments_bin(Xn, zn) {
  var Un = [], Kn = [], qn = {}, Jo = !1;
  return recordhopper(Xn, function(ma, va, ba) {
    switch (ba) {
      case 632:
        Kn.push(ma);
        break;
      case 635:
        qn = ma;
        break;
      case 637:
        qn.t = ma.t, qn.h = ma.h, qn.r = ma.r;
        break;
      case 636:
        if (qn.author = Kn[qn.iauthor], delete qn.iauthor, zn.sheetRows && qn.rfx && zn.sheetRows <= qn.rfx.r) break;
        qn.t || (qn.t = ""), delete qn.rfx, Un.push(qn);
        break;
      case 3072:
        break;
      case 35:
        Jo = !0;
        break;
      case 36:
        Jo = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!va.T) {
          if (!Jo || zn.WTF) throw new Error("Unexpected record 0x" + ba.toString(16));
        }
    }
  }), Un;
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(Xn) {
  var zn = CFB.utils.cfb_new({ root: "R" });
  return Xn.FullPaths.forEach(function(Un, Kn) {
    if (!(Un.slice(-1) === "/" || !Un.match(/_VBA_PROJECT_CUR/))) {
      var qn = Un.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
      CFB.utils.cfb_add(zn, qn, Xn.FileIndex[Kn].content);
    }
  }), CFB.write(zn);
}
function parse_ds_bin() {
  return { "!type": "dialog" };
}
function parse_ds_xml() {
  return { "!type": "dialog" };
}
function parse_ms_bin() {
  return { "!type": "macro" };
}
function parse_ms_xml() {
  return { "!type": "macro" };
}
var rc_to_a1 = /* @__PURE__ */ function() {
  var Xn = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, zn = { r: 0, c: 0 };
  function Un(Kn, qn, Jo, pa) {
    var ma = !1, va = !1;
    Jo.length == 0 ? va = !0 : Jo.charAt(0) == "[" && (va = !0, Jo = Jo.slice(1, -1)), pa.length == 0 ? ma = !0 : pa.charAt(0) == "[" && (ma = !0, pa = pa.slice(1, -1));
    var ba = Jo.length > 0 ? parseInt(Jo, 10) | 0 : 0, _a = pa.length > 0 ? parseInt(pa, 10) | 0 : 0;
    return ma ? _a += zn.c : --_a, va ? ba += zn.r : --ba, qn + (ma ? "" : "$") + encode_col(_a) + (va ? "" : "$") + encode_row(ba);
  }
  return function(qn, Jo) {
    return zn = Jo, qn.replace(Xn, Un);
  };
}(), crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, a1_to_rc = /* @__PURE__ */ function() {
  return function(zn, Un) {
    return zn.replace(crefregex, function(Kn, qn, Jo, pa, ma, va) {
      var ba = decode_col(pa) - (Jo ? 0 : Un.c), _a = decode_row(va) - (ma ? 0 : Un.r), ya = _a == 0 ? "" : ma ? _a + 1 : "[" + _a + "]", xa = ba == 0 ? "" : Jo ? ba + 1 : "[" + ba + "]";
      return qn + "R" + ya + "C" + xa;
    });
  };
}();
function shift_formula_str(Xn, zn) {
  return Xn.replace(crefregex, function(Un, Kn, qn, Jo, pa, ma) {
    return Kn + (qn == "$" ? qn + Jo : encode_col(decode_col(Jo) + zn.c)) + (pa == "$" ? pa + ma : encode_row(decode_row(ma) + zn.r));
  });
}
function shift_formula_xlsx(Xn, zn, Un) {
  var Kn = decode_range(zn), qn = Kn.s, Jo = decode_cell(Un), pa = { r: Jo.r - qn.r, c: Jo.c - qn.c };
  return shift_formula_str(Xn, pa);
}
function fuzzyfmla(Xn) {
  return Xn.length != 1;
}
function _xlfn(Xn) {
  return Xn.replace(/_xlfn\./g, "");
}
function parseread1(Xn) {
  Xn.l += 1;
}
function parse_ColRelU(Xn, zn) {
  var Un = Xn.read_shift(2);
  return [Un & 16383, Un >> 14 & 1, Un >> 15 & 1];
}
function parse_RgceArea(Xn, zn, Un) {
  var Kn = 2;
  if (Un) {
    if (Un.biff >= 2 && Un.biff <= 5) return parse_RgceArea_BIFF2(Xn);
    Un.biff == 12 && (Kn = 4);
  }
  var qn = Xn.read_shift(Kn), Jo = Xn.read_shift(Kn), pa = parse_ColRelU(Xn), ma = parse_ColRelU(Xn);
  return { s: { r: qn, c: pa[0], cRel: pa[1], rRel: pa[2] }, e: { r: Jo, c: ma[0], cRel: ma[1], rRel: ma[2] } };
}
function parse_RgceArea_BIFF2(Xn) {
  var zn = parse_ColRelU(Xn), Un = parse_ColRelU(Xn), Kn = Xn.read_shift(1), qn = Xn.read_shift(1);
  return { s: { r: zn[0], c: Kn, cRel: zn[1], rRel: zn[2] }, e: { r: Un[0], c: qn, cRel: Un[1], rRel: Un[2] } };
}
function parse_RgceAreaRel(Xn, zn, Un) {
  if (Un.biff < 8) return parse_RgceArea_BIFF2(Xn);
  var Kn = Xn.read_shift(Un.biff == 12 ? 4 : 2), qn = Xn.read_shift(Un.biff == 12 ? 4 : 2), Jo = parse_ColRelU(Xn), pa = parse_ColRelU(Xn);
  return { s: { r: Kn, c: Jo[0], cRel: Jo[1], rRel: Jo[2] }, e: { r: qn, c: pa[0], cRel: pa[1], rRel: pa[2] } };
}
function parse_RgceLoc(Xn, zn, Un) {
  if (Un && Un.biff >= 2 && Un.biff <= 5) return parse_RgceLoc_BIFF2(Xn);
  var Kn = Xn.read_shift(Un && Un.biff == 12 ? 4 : 2), qn = parse_ColRelU(Xn);
  return { r: Kn, c: qn[0], cRel: qn[1], rRel: qn[2] };
}
function parse_RgceLoc_BIFF2(Xn) {
  var zn = parse_ColRelU(Xn), Un = Xn.read_shift(1);
  return { r: zn[0], c: Un, cRel: zn[1], rRel: zn[2] };
}
function parse_RgceElfLoc(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2);
  return { r: zn, c: Un & 255, fQuoted: !!(Un & 16384), cRel: Un >> 15, rRel: Un >> 15 };
}
function parse_RgceLocRel(Xn, zn, Un) {
  var Kn = Un && Un.biff ? Un.biff : 8;
  if (Kn >= 2 && Kn <= 5) return parse_RgceLocRel_BIFF2(Xn);
  var qn = Xn.read_shift(Kn >= 12 ? 4 : 2), Jo = Xn.read_shift(2), pa = (Jo & 16384) >> 14, ma = (Jo & 32768) >> 15;
  if (Jo &= 16383, ma == 1) for (; qn > 524287; ) qn -= 1048576;
  if (pa == 1) for (; Jo > 8191; ) Jo = Jo - 16384;
  return { r: qn, c: Jo, cRel: pa, rRel: ma };
}
function parse_RgceLocRel_BIFF2(Xn) {
  var zn = Xn.read_shift(2), Un = Xn.read_shift(1), Kn = (zn & 32768) >> 15, qn = (zn & 16384) >> 14;
  return zn &= 16383, Kn == 1 && zn >= 8192 && (zn = zn - 16384), qn == 1 && Un >= 128 && (Un = Un - 256), { r: zn, c: Un, cRel: qn, rRel: Kn };
}
function parse_PtgArea(Xn, zn, Un) {
  var Kn = (Xn[Xn.l++] & 96) >> 5, qn = parse_RgceArea(Xn, Un.biff >= 2 && Un.biff <= 5 ? 6 : 8, Un);
  return [Kn, qn];
}
function parse_PtgArea3d(Xn, zn, Un) {
  var Kn = (Xn[Xn.l++] & 96) >> 5, qn = Xn.read_shift(2, "i"), Jo = 8;
  if (Un) switch (Un.biff) {
    case 5:
      Xn.l += 12, Jo = 6;
      break;
    case 12:
      Jo = 12;
      break;
  }
  var pa = parse_RgceArea(Xn, Jo, Un);
  return [Kn, qn, pa];
}
function parse_PtgAreaErr(Xn, zn, Un) {
  var Kn = (Xn[Xn.l++] & 96) >> 5;
  return Xn.l += Un && Un.biff > 8 ? 12 : Un.biff < 8 ? 6 : 8, [Kn];
}
function parse_PtgAreaErr3d(Xn, zn, Un) {
  var Kn = (Xn[Xn.l++] & 96) >> 5, qn = Xn.read_shift(2), Jo = 8;
  if (Un) switch (Un.biff) {
    case 5:
      Xn.l += 12, Jo = 6;
      break;
    case 12:
      Jo = 12;
      break;
  }
  return Xn.l += Jo, [Kn, qn];
}
function parse_PtgAreaN(Xn, zn, Un) {
  var Kn = (Xn[Xn.l++] & 96) >> 5, qn = parse_RgceAreaRel(Xn, zn - 1, Un);
  return [Kn, qn];
}
function parse_PtgArray(Xn, zn, Un) {
  var Kn = (Xn[Xn.l++] & 96) >> 5;
  return Xn.l += Un.biff == 2 ? 6 : Un.biff == 12 ? 14 : 7, [Kn];
}
function parse_PtgAttrBaxcel(Xn) {
  var zn = Xn[Xn.l + 1] & 1, Un = 1;
  return Xn.l += 4, [zn, Un];
}
function parse_PtgAttrChoose(Xn, zn, Un) {
  Xn.l += 2;
  for (var Kn = Xn.read_shift(Un && Un.biff == 2 ? 1 : 2), qn = [], Jo = 0; Jo <= Kn; ++Jo) qn.push(Xn.read_shift(Un && Un.biff == 2 ? 1 : 2));
  return qn;
}
function parse_PtgAttrGoto(Xn, zn, Un) {
  var Kn = Xn[Xn.l + 1] & 255 ? 1 : 0;
  return Xn.l += 2, [Kn, Xn.read_shift(Un && Un.biff == 2 ? 1 : 2)];
}
function parse_PtgAttrIf(Xn, zn, Un) {
  var Kn = Xn[Xn.l + 1] & 255 ? 1 : 0;
  return Xn.l += 2, [Kn, Xn.read_shift(Un && Un.biff == 2 ? 1 : 2)];
}
function parse_PtgAttrIfError(Xn) {
  var zn = Xn[Xn.l + 1] & 255 ? 1 : 0;
  return Xn.l += 2, [zn, Xn.read_shift(2)];
}
function parse_PtgAttrSemi(Xn, zn, Un) {
  var Kn = Xn[Xn.l + 1] & 255 ? 1 : 0;
  return Xn.l += Un && Un.biff == 2 ? 3 : 4, [Kn];
}
function parse_PtgAttrSpaceType(Xn) {
  var zn = Xn.read_shift(1), Un = Xn.read_shift(1);
  return [zn, Un];
}
function parse_PtgAttrSpace(Xn) {
  return Xn.read_shift(2), parse_PtgAttrSpaceType(Xn);
}
function parse_PtgAttrSpaceSemi(Xn) {
  return Xn.read_shift(2), parse_PtgAttrSpaceType(Xn);
}
function parse_PtgRef(Xn, zn, Un) {
  var Kn = (Xn[Xn.l] & 96) >> 5;
  Xn.l += 1;
  var qn = parse_RgceLoc(Xn, 0, Un);
  return [Kn, qn];
}
function parse_PtgRefN(Xn, zn, Un) {
  var Kn = (Xn[Xn.l] & 96) >> 5;
  Xn.l += 1;
  var qn = parse_RgceLocRel(Xn, 0, Un);
  return [Kn, qn];
}
function parse_PtgRef3d(Xn, zn, Un) {
  var Kn = (Xn[Xn.l] & 96) >> 5;
  Xn.l += 1;
  var qn = Xn.read_shift(2);
  Un && Un.biff == 5 && (Xn.l += 12);
  var Jo = parse_RgceLoc(Xn, 0, Un);
  return [Kn, qn, Jo];
}
function parse_PtgFunc(Xn, zn, Un) {
  var Kn = (Xn[Xn.l] & 96) >> 5;
  Xn.l += 1;
  var qn = Xn.read_shift(Un && Un.biff <= 3 ? 1 : 2);
  return [FtabArgc[qn], Ftab[qn], Kn];
}
function parse_PtgFuncVar(Xn, zn, Un) {
  var Kn = Xn[Xn.l++], qn = Xn.read_shift(1), Jo = Un && Un.biff <= 3 ? [Kn == 88 ? -1 : 0, Xn.read_shift(1)] : parsetab(Xn);
  return [qn, (Jo[0] === 0 ? Ftab : Cetab)[Jo[1]]];
}
function parsetab(Xn) {
  return [Xn[Xn.l + 1] >> 7, Xn.read_shift(2) & 32767];
}
function parse_PtgAttrSum(Xn, zn, Un) {
  Xn.l += Un && Un.biff == 2 ? 3 : 4;
}
function parse_PtgExp(Xn, zn, Un) {
  if (Xn.l++, Un && Un.biff == 12) return [Xn.read_shift(4, "i"), 0];
  var Kn = Xn.read_shift(2), qn = Xn.read_shift(Un && Un.biff == 2 ? 1 : 2);
  return [Kn, qn];
}
function parse_PtgErr(Xn) {
  return Xn.l++, BErr[Xn.read_shift(1)];
}
function parse_PtgInt(Xn) {
  return Xn.l++, Xn.read_shift(2);
}
function parse_PtgBool(Xn) {
  return Xn.l++, Xn.read_shift(1) !== 0;
}
function parse_PtgNum(Xn) {
  return Xn.l++, parse_Xnum(Xn);
}
function parse_PtgStr(Xn, zn, Un) {
  return Xn.l++, parse_ShortXLUnicodeString(Xn, zn - 1, Un);
}
function parse_SerAr(Xn, zn) {
  var Un = [Xn.read_shift(1)];
  if (zn == 12) switch (Un[0]) {
    case 2:
      Un[0] = 4;
      break;
    /* SerBool */
    case 4:
      Un[0] = 16;
      break;
    /* SerErr */
    case 0:
      Un[0] = 1;
      break;
    /* SerNum */
    case 1:
      Un[0] = 2;
      break;
  }
  switch (Un[0]) {
    case 4:
      Un[1] = parsebool(Xn, 1) ? "TRUE" : "FALSE", zn != 12 && (Xn.l += 7);
      break;
    case 37:
    /* appears to be an alias */
    case 16:
      Un[1] = BErr[Xn[Xn.l]], Xn.l += zn == 12 ? 4 : 8;
      break;
    case 0:
      Xn.l += 8;
      break;
    case 1:
      Un[1] = parse_Xnum(Xn);
      break;
    case 2:
      Un[1] = parse_XLUnicodeString2(Xn, 0, { biff: zn > 0 && zn < 8 ? 2 : zn });
      break;
    default:
      throw new Error("Bad SerAr: " + Un[0]);
  }
  return Un;
}
function parse_PtgExtraMem(Xn, zn, Un) {
  for (var Kn = Xn.read_shift(Un.biff == 12 ? 4 : 2), qn = [], Jo = 0; Jo != Kn; ++Jo) qn.push((Un.biff == 12 ? parse_UncheckedRfX : parse_Ref8U)(Xn));
  return qn;
}
function parse_PtgExtraArray(Xn, zn, Un) {
  var Kn = 0, qn = 0;
  Un.biff == 12 ? (Kn = Xn.read_shift(4), qn = Xn.read_shift(4)) : (qn = 1 + Xn.read_shift(1), Kn = 1 + Xn.read_shift(2)), Un.biff >= 2 && Un.biff < 8 && (--Kn, --qn == 0 && (qn = 256));
  for (var Jo = 0, pa = []; Jo != Kn && (pa[Jo] = []); ++Jo)
    for (var ma = 0; ma != qn; ++ma) pa[Jo][ma] = parse_SerAr(Xn, Un.biff);
  return pa;
}
function parse_PtgName(Xn, zn, Un) {
  var Kn = Xn.read_shift(1) >>> 5 & 3, qn = !Un || Un.biff >= 8 ? 4 : 2, Jo = Xn.read_shift(qn);
  switch (Un.biff) {
    case 2:
      Xn.l += 5;
      break;
    case 3:
    case 4:
      Xn.l += 8;
      break;
    case 5:
      Xn.l += 12;
      break;
  }
  return [Kn, 0, Jo];
}
function parse_PtgNameX(Xn, zn, Un) {
  if (Un.biff == 5) return parse_PtgNameX_BIFF5(Xn);
  var Kn = Xn.read_shift(1) >>> 5 & 3, qn = Xn.read_shift(2), Jo = Xn.read_shift(4);
  return [Kn, qn, Jo];
}
function parse_PtgNameX_BIFF5(Xn) {
  var zn = Xn.read_shift(1) >>> 5 & 3, Un = Xn.read_shift(2, "i");
  Xn.l += 8;
  var Kn = Xn.read_shift(2);
  return Xn.l += 12, [zn, Un, Kn];
}
function parse_PtgMemArea(Xn, zn, Un) {
  var Kn = Xn.read_shift(1) >>> 5 & 3;
  Xn.l += Un && Un.biff == 2 ? 3 : 4;
  var qn = Xn.read_shift(Un && Un.biff == 2 ? 1 : 2);
  return [Kn, qn];
}
function parse_PtgMemFunc(Xn, zn, Un) {
  var Kn = Xn.read_shift(1) >>> 5 & 3, qn = Xn.read_shift(Un && Un.biff == 2 ? 1 : 2);
  return [Kn, qn];
}
function parse_PtgRefErr(Xn, zn, Un) {
  var Kn = Xn.read_shift(1) >>> 5 & 3;
  return Xn.l += 4, Un.biff < 8 && Xn.l--, Un.biff == 12 && (Xn.l += 2), [Kn];
}
function parse_PtgRefErr3d(Xn, zn, Un) {
  var Kn = (Xn[Xn.l++] & 96) >> 5, qn = Xn.read_shift(2), Jo = 4;
  if (Un) switch (Un.biff) {
    case 5:
      Jo = 15;
      break;
    case 12:
      Jo = 6;
      break;
  }
  return Xn.l += Jo, [Kn, qn];
}
var parse_PtgMemErr = parsenoop, parse_PtgMemNoMem = parsenoop, parse_PtgTbl = parsenoop;
function parse_PtgElfLoc(Xn, zn, Un) {
  return Xn.l += 2, [parse_RgceElfLoc(Xn)];
}
function parse_PtgElfNoop(Xn) {
  return Xn.l += 6, [];
}
var parse_PtgElfCol = parse_PtgElfLoc, parse_PtgElfColS = parse_PtgElfNoop, parse_PtgElfColSV = parse_PtgElfNoop, parse_PtgElfColV = parse_PtgElfLoc;
function parse_PtgElfLel(Xn) {
  return Xn.l += 2, [parseuint16(Xn), Xn.read_shift(2) & 1];
}
var parse_PtgElfRadical = parse_PtgElfLoc, parse_PtgElfRadicalLel = parse_PtgElfLel, parse_PtgElfRadicalS = parse_PtgElfNoop, parse_PtgElfRw = parse_PtgElfLoc, parse_PtgElfRwV = parse_PtgElfLoc, PtgListRT = [
  "Data",
  "All",
  "Headers",
  "??",
  "?Data2",
  "??",
  "?DataHeaders",
  "??",
  "Totals",
  "??",
  "??",
  "??",
  "?DataTotals",
  "??",
  "??",
  "??",
  "?Current"
];
function parse_PtgList(Xn) {
  Xn.l += 2;
  var zn = Xn.read_shift(2), Un = Xn.read_shift(2), Kn = Xn.read_shift(4), qn = Xn.read_shift(2), Jo = Xn.read_shift(2), pa = PtgListRT[Un >> 2 & 31];
  return { ixti: zn, coltype: Un & 3, rt: pa, idx: Kn, c: qn, C: Jo };
}
function parse_PtgSxName(Xn) {
  return Xn.l += 2, [Xn.read_shift(4)];
}
function parse_PtgSheet(Xn, zn, Un) {
  return Xn.l += 5, Xn.l += 2, Xn.l += Un.biff == 2 ? 1 : 4, ["PTGSHEET"];
}
function parse_PtgEndSheet(Xn, zn, Un) {
  return Xn.l += Un.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(Xn) {
  var zn = Xn.read_shift(1) >>> 5 & 3, Un = Xn.read_shift(2);
  return [zn, Un];
}
function parse_PtgMemNoMemN(Xn) {
  var zn = Xn.read_shift(1) >>> 5 & 3, Un = Xn.read_shift(2);
  return [zn, Un];
}
function parse_PtgAttrNoop(Xn) {
  return Xn.l += 4, [0, 0];
}
var PtgTypes = {
  /*::[*/
  1: { n: "PtgExp", f: parse_PtgExp },
  /*::[*/
  2: { n: "PtgTbl", f: parse_PtgTbl },
  /*::[*/
  3: { n: "PtgAdd", f: parseread1 },
  /*::[*/
  4: { n: "PtgSub", f: parseread1 },
  /*::[*/
  5: { n: "PtgMul", f: parseread1 },
  /*::[*/
  6: { n: "PtgDiv", f: parseread1 },
  /*::[*/
  7: { n: "PtgPower", f: parseread1 },
  /*::[*/
  8: { n: "PtgConcat", f: parseread1 },
  /*::[*/
  9: { n: "PtgLt", f: parseread1 },
  /*::[*/
  10: { n: "PtgLe", f: parseread1 },
  /*::[*/
  11: { n: "PtgEq", f: parseread1 },
  /*::[*/
  12: { n: "PtgGe", f: parseread1 },
  /*::[*/
  13: { n: "PtgGt", f: parseread1 },
  /*::[*/
  14: { n: "PtgNe", f: parseread1 },
  /*::[*/
  15: { n: "PtgIsect", f: parseread1 },
  /*::[*/
  16: { n: "PtgUnion", f: parseread1 },
  /*::[*/
  17: { n: "PtgRange", f: parseread1 },
  /*::[*/
  18: { n: "PtgUplus", f: parseread1 },
  /*::[*/
  19: { n: "PtgUminus", f: parseread1 },
  /*::[*/
  20: { n: "PtgPercent", f: parseread1 },
  /*::[*/
  21: { n: "PtgParen", f: parseread1 },
  /*::[*/
  22: { n: "PtgMissArg", f: parseread1 },
  /*::[*/
  23: { n: "PtgStr", f: parse_PtgStr },
  /*::[*/
  26: { n: "PtgSheet", f: parse_PtgSheet },
  /*::[*/
  27: { n: "PtgEndSheet", f: parse_PtgEndSheet },
  /*::[*/
  28: { n: "PtgErr", f: parse_PtgErr },
  /*::[*/
  29: { n: "PtgBool", f: parse_PtgBool },
  /*::[*/
  30: { n: "PtgInt", f: parse_PtgInt },
  /*::[*/
  31: { n: "PtgNum", f: parse_PtgNum },
  /*::[*/
  32: { n: "PtgArray", f: parse_PtgArray },
  /*::[*/
  33: { n: "PtgFunc", f: parse_PtgFunc },
  /*::[*/
  34: { n: "PtgFuncVar", f: parse_PtgFuncVar },
  /*::[*/
  35: { n: "PtgName", f: parse_PtgName },
  /*::[*/
  36: { n: "PtgRef", f: parse_PtgRef },
  /*::[*/
  37: { n: "PtgArea", f: parse_PtgArea },
  /*::[*/
  38: { n: "PtgMemArea", f: parse_PtgMemArea },
  /*::[*/
  39: { n: "PtgMemErr", f: parse_PtgMemErr },
  /*::[*/
  40: { n: "PtgMemNoMem", f: parse_PtgMemNoMem },
  /*::[*/
  41: { n: "PtgMemFunc", f: parse_PtgMemFunc },
  /*::[*/
  42: { n: "PtgRefErr", f: parse_PtgRefErr },
  /*::[*/
  43: { n: "PtgAreaErr", f: parse_PtgAreaErr },
  /*::[*/
  44: { n: "PtgRefN", f: parse_PtgRefN },
  /*::[*/
  45: { n: "PtgAreaN", f: parse_PtgAreaN },
  /*::[*/
  46: { n: "PtgMemAreaN", f: parse_PtgMemAreaN },
  /*::[*/
  47: { n: "PtgMemNoMemN", f: parse_PtgMemNoMemN },
  /*::[*/
  57: { n: "PtgNameX", f: parse_PtgNameX },
  /*::[*/
  58: { n: "PtgRef3d", f: parse_PtgRef3d },
  /*::[*/
  59: { n: "PtgArea3d", f: parse_PtgArea3d },
  /*::[*/
  60: { n: "PtgRefErr3d", f: parse_PtgRefErr3d },
  /*::[*/
  61: { n: "PtgAreaErr3d", f: parse_PtgAreaErr3d },
  /*::[*/
  255: {}
}, PtgDupes = {
  /*::[*/
  64: 32,
  /*::[*/
  96: 32,
  /*::[*/
  65: 33,
  /*::[*/
  97: 33,
  /*::[*/
  66: 34,
  /*::[*/
  98: 34,
  /*::[*/
  67: 35,
  /*::[*/
  99: 35,
  /*::[*/
  68: 36,
  /*::[*/
  100: 36,
  /*::[*/
  69: 37,
  /*::[*/
  101: 37,
  /*::[*/
  70: 38,
  /*::[*/
  102: 38,
  /*::[*/
  71: 39,
  /*::[*/
  103: 39,
  /*::[*/
  72: 40,
  /*::[*/
  104: 40,
  /*::[*/
  73: 41,
  /*::[*/
  105: 41,
  /*::[*/
  74: 42,
  /*::[*/
  106: 42,
  /*::[*/
  75: 43,
  /*::[*/
  107: 43,
  /*::[*/
  76: 44,
  /*::[*/
  108: 44,
  /*::[*/
  77: 45,
  /*::[*/
  109: 45,
  /*::[*/
  78: 46,
  /*::[*/
  110: 46,
  /*::[*/
  79: 47,
  /*::[*/
  111: 47,
  /*::[*/
  88: 34,
  /*::[*/
  120: 34,
  /*::[*/
  89: 57,
  /*::[*/
  121: 57,
  /*::[*/
  90: 58,
  /*::[*/
  122: 58,
  /*::[*/
  91: 59,
  /*::[*/
  123: 59,
  /*::[*/
  92: 60,
  /*::[*/
  124: 60,
  /*::[*/
  93: 61,
  /*::[*/
  125: 61
}, Ptg18 = {
  /*::[*/
  1: { n: "PtgElfLel", f: parse_PtgElfLel },
  /*::[*/
  2: { n: "PtgElfRw", f: parse_PtgElfRw },
  /*::[*/
  3: { n: "PtgElfCol", f: parse_PtgElfCol },
  /*::[*/
  6: { n: "PtgElfRwV", f: parse_PtgElfRwV },
  /*::[*/
  7: { n: "PtgElfColV", f: parse_PtgElfColV },
  /*::[*/
  10: { n: "PtgElfRadical", f: parse_PtgElfRadical },
  /*::[*/
  11: { n: "PtgElfRadicalS", f: parse_PtgElfRadicalS },
  /*::[*/
  13: { n: "PtgElfColS", f: parse_PtgElfColS },
  /*::[*/
  15: { n: "PtgElfColSV", f: parse_PtgElfColSV },
  /*::[*/
  16: { n: "PtgElfRadicalLel", f: parse_PtgElfRadicalLel },
  /*::[*/
  25: { n: "PtgList", f: parse_PtgList },
  /*::[*/
  29: { n: "PtgSxName", f: parse_PtgSxName },
  /*::[*/
  255: {}
}, Ptg19 = {
  /*::[*/
  0: { n: "PtgAttrNoop", f: parse_PtgAttrNoop },
  /*::[*/
  1: { n: "PtgAttrSemi", f: parse_PtgAttrSemi },
  /*::[*/
  2: { n: "PtgAttrIf", f: parse_PtgAttrIf },
  /*::[*/
  4: { n: "PtgAttrChoose", f: parse_PtgAttrChoose },
  /*::[*/
  8: { n: "PtgAttrGoto", f: parse_PtgAttrGoto },
  /*::[*/
  16: { n: "PtgAttrSum", f: parse_PtgAttrSum },
  /*::[*/
  32: { n: "PtgAttrBaxcel", f: parse_PtgAttrBaxcel },
  /*::[*/
  33: { n: "PtgAttrBaxcel", f: parse_PtgAttrBaxcel },
  /*::[*/
  64: { n: "PtgAttrSpace", f: parse_PtgAttrSpace },
  /*::[*/
  65: { n: "PtgAttrSpaceSemi", f: parse_PtgAttrSpaceSemi },
  /*::[*/
  128: { n: "PtgAttrIfError", f: parse_PtgAttrIfError },
  /*::[*/
  255: {}
};
function parse_RgbExtra(Xn, zn, Un, Kn) {
  if (Kn.biff < 8) return parsenoop(Xn, zn);
  for (var qn = Xn.l + zn, Jo = [], pa = 0; pa !== Un.length; ++pa)
    switch (Un[pa][0]) {
      case "PtgArray":
        Un[pa][1] = parse_PtgExtraArray(Xn, 0, Kn), Jo.push(Un[pa][1]);
        break;
      case "PtgMemArea":
        Un[pa][2] = parse_PtgExtraMem(Xn, Un[pa][1], Kn), Jo.push(Un[pa][2]);
        break;
      case "PtgExp":
        Kn && Kn.biff == 12 && (Un[pa][1][1] = Xn.read_shift(4), Jo.push(Un[pa][1]));
        break;
      case "PtgList":
      /* TODO: PtgList -> PtgExtraList */
      case "PtgElfRadicalS":
      /* TODO: PtgElfRadicalS -> PtgExtraElf */
      case "PtgElfColS":
      /* TODO: PtgElfColS -> PtgExtraElf */
      case "PtgElfColSV":
        throw "Unsupported " + Un[pa][0];
    }
  return zn = qn - Xn.l, zn !== 0 && Jo.push(parsenoop(Xn, zn)), Jo;
}
function parse_Rgce(Xn, zn, Un) {
  for (var Kn = Xn.l + zn, qn, Jo, pa = []; Kn != Xn.l; )
    zn = Kn - Xn.l, Jo = Xn[Xn.l], qn = PtgTypes[Jo] || PtgTypes[PtgDupes[Jo]], (Jo === 24 || Jo === 25) && (qn = (Jo === 24 ? Ptg18 : Ptg19)[Xn[Xn.l + 1]]), !qn || !qn.f ? parsenoop(Xn, zn) : pa.push([qn.n, qn.f(Xn, zn, Un)]);
  return pa;
}
function stringify_array(Xn) {
  for (var zn = [], Un = 0; Un < Xn.length; ++Un) {
    for (var Kn = Xn[Un], qn = [], Jo = 0; Jo < Kn.length; ++Jo) {
      var pa = Kn[Jo];
      if (pa) switch (pa[0]) {
        // TODO: handle embedded quotes
        case 2:
          qn.push('"' + pa[1].replace(/"/g, '""') + '"');
          break;
        default:
          qn.push(pa[1]);
      }
      else qn.push("");
    }
    zn.push(qn.join(","));
  }
  return zn.join(";");
}
var PtgBinOp = {
  PtgAdd: "+",
  PtgConcat: "&",
  PtgDiv: "/",
  PtgEq: "=",
  PtgGe: ">=",
  PtgGt: ">",
  PtgLe: "<=",
  PtgLt: "<",
  PtgMul: "*",
  PtgNe: "<>",
  PtgPower: "^",
  PtgSub: "-"
};
function formula_quote_sheet_name(Xn, zn) {
  if (!Xn && !(zn && zn.biff <= 5 && zn.biff >= 2)) throw new Error("empty sheet name");
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(Xn) ? "'" + Xn + "'" : Xn;
}
function get_ixti_raw(Xn, zn, Un) {
  if (!Xn) return "SH33TJSERR0";
  if (Un.biff > 8 && (!Xn.XTI || !Xn.XTI[zn])) return Xn.SheetNames[zn];
  if (!Xn.XTI) return "SH33TJSERR6";
  var Kn = Xn.XTI[zn];
  if (Un.biff < 8)
    return zn > 1e4 && (zn -= 65536), zn < 0 && (zn = -zn), zn == 0 ? "" : Xn.XTI[zn - 1];
  if (!Kn) return "SH33TJSERR1";
  var qn = "";
  if (Un.biff > 8) switch (Xn[Kn[0]][0]) {
    case 357:
      return qn = Kn[1] == -1 ? "#REF" : Xn.SheetNames[Kn[1]], Kn[1] == Kn[2] ? qn : qn + ":" + Xn.SheetNames[Kn[2]];
    case 358:
      return Un.SID != null ? Xn.SheetNames[Un.SID] : "SH33TJSSAME" + Xn[Kn[0]][0];
    case 355:
    /* 'BrtSupBookSrc' */
    /* falls through */
    default:
      return "SH33TJSSRC" + Xn[Kn[0]][0];
  }
  switch (Xn[Kn[0]][0][0]) {
    case 1025:
      return qn = Kn[1] == -1 ? "#REF" : Xn.SheetNames[Kn[1]] || "SH33TJSERR3", Kn[1] == Kn[2] ? qn : qn + ":" + Xn.SheetNames[Kn[2]];
    case 14849:
      return Xn[Kn[0]].slice(1).map(function(Jo) {
        return Jo.Name;
      }).join(";;");
    //return "SH33TJSERR8";
    default:
      return Xn[Kn[0]][0][3] ? (qn = Kn[1] == -1 ? "#REF" : Xn[Kn[0]][0][3][Kn[1]] || "SH33TJSERR4", Kn[1] == Kn[2] ? qn : qn + ":" + Xn[Kn[0]][0][3][Kn[2]]) : "SH33TJSERR2";
  }
}
function get_ixti(Xn, zn, Un) {
  var Kn = get_ixti_raw(Xn, zn, Un);
  return Kn == "#REF" ? Kn : formula_quote_sheet_name(Kn, Un);
}
function stringify_formula(Xn, zn, Un, Kn, qn) {
  var Jo = qn && qn.biff || 8, pa = (
    /*range != null ? range :*/
    { s: { c: 0, r: 0 } }
  ), ma = [], va, ba, _a, ya = 0, xa = 0, wa, Ta = "";
  if (!Xn[0] || !Xn[0][0]) return "";
  for (var Sa = -1, Ma = "", ka = 0, Za = Xn[0].length; ka < Za; ++ka) {
    var Na = Xn[0][ka];
    switch (Na[0]) {
      case "PtgUminus":
        ma.push("-" + ma.pop());
        break;
      case "PtgUplus":
        ma.push("+" + ma.pop());
        break;
      case "PtgPercent":
        ma.push(ma.pop() + "%");
        break;
      case "PtgAdd":
      /* [MS-XLS] 2.5.198.26 */
      case "PtgConcat":
      /* [MS-XLS] 2.5.198.43 */
      case "PtgDiv":
      /* [MS-XLS] 2.5.198.45 */
      case "PtgEq":
      /* [MS-XLS] 2.5.198.56 */
      case "PtgGe":
      /* [MS-XLS] 2.5.198.64 */
      case "PtgGt":
      /* [MS-XLS] 2.5.198.65 */
      case "PtgLe":
      /* [MS-XLS] 2.5.198.68 */
      case "PtgLt":
      /* [MS-XLS] 2.5.198.69 */
      case "PtgMul":
      /* [MS-XLS] 2.5.198.75 */
      case "PtgNe":
      /* [MS-XLS] 2.5.198.78 */
      case "PtgPower":
      /* [MS-XLS] 2.5.198.82 */
      case "PtgSub":
        if (va = ma.pop(), ba = ma.pop(), Sa >= 0) {
          switch (Xn[0][Sa][1][0]) {
            case 0:
              Ma = fill$1(" ", Xn[0][Sa][1][1]);
              break;
            case 1:
              Ma = fill$1("\r", Xn[0][Sa][1][1]);
              break;
            default:
              if (Ma = "", qn.WTF) throw new Error("Unexpected PtgAttrSpaceType " + Xn[0][Sa][1][0]);
          }
          ba = ba + Ma, Sa = -1;
        }
        ma.push(ba + PtgBinOp[Na[0]] + va);
        break;
      case "PtgIsect":
        va = ma.pop(), ba = ma.pop(), ma.push(ba + " " + va);
        break;
      case "PtgUnion":
        va = ma.pop(), ba = ma.pop(), ma.push(ba + "," + va);
        break;
      case "PtgRange":
        va = ma.pop(), ba = ma.pop(), ma.push(ba + ":" + va);
        break;
      case "PtgAttrChoose":
        break;
      case "PtgAttrGoto":
        break;
      case "PtgAttrIf":
        break;
      case "PtgAttrIfError":
        break;
      case "PtgRef":
        _a = shift_cell_xls(Na[1][1], pa, qn), ma.push(encode_cell_xls(_a, Jo));
        break;
      case "PtgRefN":
        _a = Un ? shift_cell_xls(Na[1][1], Un, qn) : Na[1][1], ma.push(encode_cell_xls(_a, Jo));
        break;
      case "PtgRef3d":
        ya = /*::Number(*/
        Na[1][1], _a = shift_cell_xls(Na[1][2], pa, qn), Ta = get_ixti(Kn, ya, qn), ma.push(Ta + "!" + encode_cell_xls(_a, Jo));
        break;
      case "PtgFunc":
      /* [MS-XLS] 2.5.198.62 */
      case "PtgFuncVar":
        var Ka = Na[1][0], Ja = Na[1][1];
        Ka || (Ka = 0), Ka &= 127;
        var el = Ka == 0 ? [] : ma.slice(-Ka);
        ma.length -= Ka, Ja === "User" && (Ja = el.shift()), ma.push(Ja + "(" + el.join(",") + ")");
        break;
      case "PtgBool":
        ma.push(Na[1] ? "TRUE" : "FALSE");
        break;
      case "PtgInt":
        ma.push(
          /*::String(*/
          Na[1]
          /*::)*/
        );
        break;
      case "PtgNum":
        ma.push(String(Na[1]));
        break;
      case "PtgStr":
        ma.push('"' + Na[1].replace(/"/g, '""') + '"');
        break;
      case "PtgErr":
        ma.push(
          /*::String(*/
          Na[1]
          /*::)*/
        );
        break;
      case "PtgAreaN":
        wa = shift_range_xls(Na[1][1], Un ? { s: Un } : pa, qn), ma.push(encode_range_xls(wa, qn));
        break;
      case "PtgArea":
        wa = shift_range_xls(Na[1][1], pa, qn), ma.push(encode_range_xls(wa, qn));
        break;
      case "PtgArea3d":
        ya = /*::Number(*/
        Na[1][1], wa = Na[1][2], Ta = get_ixti(Kn, ya, qn), ma.push(Ta + "!" + encode_range_xls(wa, qn));
        break;
      case "PtgAttrSum":
        ma.push("SUM(" + ma.pop() + ")");
        break;
      case "PtgAttrBaxcel":
      /* [MS-XLS] 2.5.198.33 */
      case "PtgAttrSemi":
        break;
      case "PtgName":
        xa = Na[1][2];
        var qa = (Kn.names || [])[xa - 1] || (Kn[0] || [])[xa], tl = qa ? qa.Name : "SH33TJSNAME" + String(xa);
        tl && tl.slice(0, 6) == "_xlfn." && !qn.xlfn && (tl = tl.slice(6)), ma.push(tl);
        break;
      case "PtgNameX":
        var Qa = Na[1][1];
        xa = Na[1][2];
        var nl;
        if (qn.biff <= 5)
          Qa < 0 && (Qa = -Qa), Kn[Qa] && (nl = Kn[Qa][xa]);
        else {
          var rl = "";
          if (((Kn[Qa] || [])[0] || [])[0] == 14849 || (((Kn[Qa] || [])[0] || [])[0] == 1025 ? Kn[Qa][xa] && Kn[Qa][xa].itab > 0 && (rl = Kn.SheetNames[Kn[Qa][xa].itab - 1] + "!") : rl = Kn.SheetNames[xa - 1] + "!"), Kn[Qa] && Kn[Qa][xa]) rl += Kn[Qa][xa].Name;
          else if (Kn[0] && Kn[0][xa]) rl += Kn[0][xa].Name;
          else {
            var il = (get_ixti_raw(Kn, Qa, qn) || "").split(";;");
            il[xa - 1] ? rl = il[xa - 1] : rl += "SH33TJSERRX";
          }
          ma.push(rl);
          break;
        }
        nl || (nl = { Name: "SH33TJSERRY" }), ma.push(nl.Name);
        break;
      case "PtgParen":
        var cl = "(", ll = ")";
        if (Sa >= 0) {
          switch (Ma = "", Xn[0][Sa][1][0]) {
            // $FlowIgnore
            case 2:
              cl = fill$1(" ", Xn[0][Sa][1][1]) + cl;
              break;
            // $FlowIgnore
            case 3:
              cl = fill$1("\r", Xn[0][Sa][1][1]) + cl;
              break;
            // $FlowIgnore
            case 4:
              ll = fill$1(" ", Xn[0][Sa][1][1]) + ll;
              break;
            // $FlowIgnore
            case 5:
              ll = fill$1("\r", Xn[0][Sa][1][1]) + ll;
              break;
            default:
              if (qn.WTF) throw new Error("Unexpected PtgAttrSpaceType " + Xn[0][Sa][1][0]);
          }
          Sa = -1;
        }
        ma.push(cl + ma.pop() + ll);
        break;
      case "PtgRefErr":
        ma.push("#REF!");
        break;
      case "PtgRefErr3d":
        ma.push("#REF!");
        break;
      case "PtgExp":
        _a = { c: Na[1][1], r: Na[1][0] };
        var al = { c: Un.c, r: Un.r };
        if (Kn.sharedf[encode_cell(_a)]) {
          var sl = Kn.sharedf[encode_cell(_a)];
          ma.push(stringify_formula(sl, pa, al, Kn, qn));
        } else {
          var dl = !1;
          for (va = 0; va != Kn.arrayf.length; ++va)
            if (ba = Kn.arrayf[va], !(_a.c < ba[0].s.c || _a.c > ba[0].e.c) && !(_a.r < ba[0].s.r || _a.r > ba[0].e.r)) {
              ma.push(stringify_formula(ba[1], pa, al, Kn, qn)), dl = !0;
              break;
            }
          dl || ma.push(
            /*::String(*/
            Na[1]
            /*::)*/
          );
        }
        break;
      case "PtgArray":
        ma.push("{" + stringify_array(
          /*::(*/
          Na[1]
          /*:: :any)*/
        ) + "}");
        break;
      case "PtgMemArea":
        break;
      case "PtgAttrSpace":
      /* [MS-XLS] 2.5.198.38 */
      case "PtgAttrSpaceSemi":
        Sa = ka;
        break;
      case "PtgTbl":
        break;
      case "PtgMemErr":
        break;
      case "PtgMissArg":
        ma.push("");
        break;
      case "PtgAreaErr":
        ma.push("#REF!");
        break;
      case "PtgAreaErr3d":
        ma.push("#REF!");
        break;
      case "PtgList":
        ma.push("Table" + Na[1].idx + "[#" + Na[1].rt + "]");
        break;
      case "PtgMemAreaN":
      case "PtgMemNoMemN":
      case "PtgAttrNoop":
      case "PtgSheet":
      case "PtgEndSheet":
        break;
      case "PtgMemFunc":
        break;
      case "PtgMemNoMem":
        break;
      case "PtgElfCol":
      /* [MS-XLS] 2.5.198.46 */
      case "PtgElfColS":
      /* [MS-XLS] 2.5.198.47 */
      case "PtgElfColSV":
      /* [MS-XLS] 2.5.198.48 */
      case "PtgElfColV":
      /* [MS-XLS] 2.5.198.49 */
      case "PtgElfLel":
      /* [MS-XLS] 2.5.198.50 */
      case "PtgElfRadical":
      /* [MS-XLS] 2.5.198.51 */
      case "PtgElfRadicalLel":
      /* [MS-XLS] 2.5.198.52 */
      case "PtgElfRadicalS":
      /* [MS-XLS] 2.5.198.53 */
      case "PtgElfRw":
      /* [MS-XLS] 2.5.198.54 */
      case "PtgElfRwV":
        throw new Error("Unsupported ELFs");
      case "PtgSxName":
        throw new Error("Unrecognized Formula Token: " + String(Na));
      default:
        throw new Error("Unrecognized Formula Token: " + String(Na));
    }
    var El = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
    if (qn.biff != 3 && Sa >= 0 && El.indexOf(Xn[0][ka][0]) == -1) {
      Na = Xn[0][Sa];
      var fl = !0;
      switch (Na[1][0]) {
        /* note: some bad XLSB files omit the PtgParen */
        case 4:
          fl = !1;
        /* falls through */
        case 0:
          Ma = fill$1(" ", Na[1][1]);
          break;
        case 5:
          fl = !1;
        /* falls through */
        case 1:
          Ma = fill$1("\r", Na[1][1]);
          break;
        default:
          if (Ma = "", qn.WTF) throw new Error("Unexpected PtgAttrSpaceType " + Na[1][0]);
      }
      ma.push((fl ? Ma : "") + ma.pop() + (fl ? "" : Ma)), Sa = -1;
    }
  }
  if (ma.length > 1 && qn.WTF) throw new Error("bad formula stack");
  return ma[0];
}
function parse_ArrayParsedFormula(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = Un.biff == 2 ? 1 : 2, Jo, pa = Xn.read_shift(qn);
  if (pa == 65535) return [[], parsenoop(Xn, zn - 2)];
  var ma = parse_Rgce(Xn, pa, Un);
  return zn !== pa + qn && (Jo = parse_RgbExtra(Xn, zn - pa - qn, ma, Un)), Xn.l = Kn, [ma, Jo];
}
function parse_XLSCellParsedFormula(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = Un.biff == 2 ? 1 : 2, Jo, pa = Xn.read_shift(qn);
  if (pa == 65535) return [[], parsenoop(Xn, zn - 2)];
  var ma = parse_Rgce(Xn, pa, Un);
  return zn !== pa + qn && (Jo = parse_RgbExtra(Xn, zn - pa - qn, ma, Un)), Xn.l = Kn, [ma, Jo];
}
function parse_NameParsedFormula(Xn, zn, Un, Kn) {
  var qn = Xn.l + zn, Jo = parse_Rgce(Xn, Kn, Un), pa;
  return qn !== Xn.l && (pa = parse_RgbExtra(Xn, qn - Xn.l, Jo, Un)), [Jo, pa];
}
function parse_SharedParsedFormula(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn, Jo = Xn.read_shift(2), pa = parse_Rgce(Xn, Jo, Un);
  return Jo == 65535 ? [[], parsenoop(Xn, zn - 2)] : (zn !== Jo + 2 && (qn = parse_RgbExtra(Xn, Kn - Jo - 2, pa, Un)), [pa, qn]);
}
function parse_FormulaValue(Xn) {
  var zn;
  if (__readUInt16LE(Xn, Xn.l + 6) !== 65535) return [parse_Xnum(Xn), "n"];
  switch (Xn[Xn.l]) {
    case 0:
      return Xn.l += 8, ["String", "s"];
    case 1:
      return zn = Xn[Xn.l + 2] === 1, Xn.l += 8, [zn, "b"];
    case 2:
      return zn = Xn[Xn.l + 2], Xn.l += 8, [zn, "e"];
    case 3:
      return Xn.l += 8, ["", "s"];
  }
  return [];
}
function parse_Formula(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_XLSCell(Xn);
  Un.biff == 2 && ++Xn.l;
  var Jo = parse_FormulaValue(Xn), pa = Xn.read_shift(1);
  Un.biff != 2 && (Xn.read_shift(1), Un.biff >= 5 && Xn.read_shift(4));
  var ma = parse_XLSCellParsedFormula(Xn, Kn - Xn.l, Un);
  return { cell: qn, val: Jo[0], formula: ma, shared: pa >> 3 & 1, tt: Jo[1] };
}
function parse_XLSBParsedFormula(Xn, zn, Un) {
  var Kn = Xn.read_shift(4), qn = parse_Rgce(Xn, Kn, Un), Jo = Xn.read_shift(4), pa = Jo > 0 ? parse_RgbExtra(Xn, Jo, qn, Un) : null;
  return [qn, pa];
}
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula, parse_XLSBCellParsedFormula = parse_XLSBParsedFormula, parse_XLSBNameParsedFormula = parse_XLSBParsedFormula, parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula, Cetab = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
}, Ftab = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
}, FtabArgc = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
function ods_to_csf_formula(Xn) {
  return Xn.slice(0, 3) == "of:" && (Xn = Xn.slice(3)), Xn.charCodeAt(0) == 61 && (Xn = Xn.slice(1), Xn.charCodeAt(0) == 61 && (Xn = Xn.slice(1))), Xn = Xn.replace(/COM\.MICROSOFT\./g, ""), Xn = Xn.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(zn, Un) {
    return Un.replace(/\./g, "");
  }), Xn = Xn.replace(/\[.(#[A-Z]*[?!])\]/g, "$1"), Xn.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function ods_to_csf_3D(Xn) {
  var zn = Xn.split(":"), Un = zn[0].split(".")[0];
  return [Un, zn[0].split(".")[1] + (zn.length > 1 ? ":" + (zn[1].split(".")[1] || zn[1].split(".")[0]) : "")];
}
var strs = {}, _ssfopts = {};
function default_margins(Xn, zn) {
  if (Xn) {
    var Un = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    zn == "xlml" && (Un = [1, 1, 1, 1, 0.5, 0.5]), Xn.left == null && (Xn.left = Un[0]), Xn.right == null && (Xn.right = Un[1]), Xn.top == null && (Xn.top = Un[2]), Xn.bottom == null && (Xn.bottom = Un[3]), Xn.header == null && (Xn.header = Un[4]), Xn.footer == null && (Xn.footer = Un[5]);
  }
}
function safe_format(Xn, zn, Un, Kn, qn, Jo) {
  try {
    Kn.cellNF && (Xn.z = table_fmt[zn]);
  } catch (ma) {
    if (Kn.WTF) throw ma;
  }
  if (!(Xn.t === "z" && !Kn.cellStyles)) {
    if (Xn.t === "d" && typeof Xn.v == "string" && (Xn.v = parseDate$1(Xn.v)), (!Kn || Kn.cellText !== !1) && Xn.t !== "z") try {
      if (table_fmt[zn] == null && SSF_load(SSFImplicit[zn] || "General", zn), Xn.t === "e") Xn.w = Xn.w || BErr[Xn.v];
      else if (zn === 0)
        if (Xn.t === "n")
          (Xn.v | 0) === Xn.v ? Xn.w = Xn.v.toString(10) : Xn.w = SSF_general_num(Xn.v);
        else if (Xn.t === "d") {
          var pa = datenum(Xn.v);
          (pa | 0) === pa ? Xn.w = pa.toString(10) : Xn.w = SSF_general_num(pa);
        } else {
          if (Xn.v === void 0) return "";
          Xn.w = SSF_general(Xn.v, _ssfopts);
        }
      else Xn.t === "d" ? Xn.w = SSF_format(zn, datenum(Xn.v), _ssfopts) : Xn.w = SSF_format(zn, Xn.v, _ssfopts);
    } catch (ma) {
      if (Kn.WTF) throw ma;
    }
    if (Kn.cellStyles && Un != null)
      try {
        Xn.s = Jo.Fills[Un], Xn.s.fgColor && Xn.s.fgColor.theme && !Xn.s.fgColor.rgb && (Xn.s.fgColor.rgb = rgb_tint(qn.themeElements.clrScheme[Xn.s.fgColor.theme].rgb, Xn.s.fgColor.tint || 0), Kn.WTF && (Xn.s.fgColor.raw_rgb = qn.themeElements.clrScheme[Xn.s.fgColor.theme].rgb)), Xn.s.bgColor && Xn.s.bgColor.theme && (Xn.s.bgColor.rgb = rgb_tint(qn.themeElements.clrScheme[Xn.s.bgColor.theme].rgb, Xn.s.bgColor.tint || 0), Kn.WTF && (Xn.s.bgColor.raw_rgb = qn.themeElements.clrScheme[Xn.s.bgColor.theme].rgb));
      } catch (ma) {
        if (Kn.WTF && Jo.Fills) throw ma;
      }
  }
}
function parse_ws_xml_dim(Xn, zn) {
  var Un = safe_decode_range(zn);
  Un.s.r <= Un.e.r && Un.s.c <= Un.e.c && Un.s.r >= 0 && Un.s.c >= 0 && (Xn["!ref"] = encode_range(Un));
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g, sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg, dimregex = /"(\w*:\w*)"/, colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g, afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g, sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
function parse_ws_xml(Xn, zn, Un, Kn, qn, Jo, pa) {
  if (!Xn) return Xn;
  Kn || (Kn = { "!id": {} });
  var ma = zn.dense ? [] : {}, va = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, ba = "", _a = "", ya = Xn.match(sheetdataregex);
  ya ? (ba = Xn.slice(0, ya.index), _a = Xn.slice(ya.index + ya[0].length)) : ba = _a = Xn;
  var xa = ba.match(sheetprregex);
  xa ? parse_ws_xml_sheetpr(xa[0], ma, qn, Un) : (xa = ba.match(sheetprregex2)) && parse_ws_xml_sheetpr2(xa[0], xa[1] || "", ma, qn, Un);
  var wa = (ba.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
  if (wa > 0) {
    var Ta = ba.slice(wa, wa + 50).match(dimregex);
    Ta && parse_ws_xml_dim(ma, Ta[1]);
  }
  var Sa = ba.match(svsregex);
  Sa && Sa[1] && parse_ws_xml_sheetviews(Sa[1], qn);
  var Ma = [];
  if (zn.cellStyles) {
    var ka = ba.match(colregex);
    ka && parse_ws_xml_cols(Ma, ka);
  }
  ya && parse_ws_xml_data(ya[1], ma, zn, va, Jo, pa);
  var Za = _a.match(afregex);
  Za && (ma["!autofilter"] = parse_ws_xml_autofilter(Za[0]));
  var Na = [], Ka = _a.match(mergecregex);
  if (Ka) for (wa = 0; wa != Ka.length; ++wa)
    Na[wa] = safe_decode_range(Ka[wa].slice(Ka[wa].indexOf('"') + 1));
  var Ja = _a.match(hlinkregex);
  Ja && parse_ws_xml_hlinks(ma, Ja, Kn);
  var el = _a.match(marginregex);
  if (el && (ma["!margins"] = parse_ws_xml_margins(parsexmltag(el[0]))), !ma["!ref"] && va.e.c >= va.s.c && va.e.r >= va.s.r && (ma["!ref"] = encode_range(va)), zn.sheetRows > 0 && ma["!ref"]) {
    var qa = safe_decode_range(ma["!ref"]);
    zn.sheetRows <= +qa.e.r && (qa.e.r = zn.sheetRows - 1, qa.e.r > va.e.r && (qa.e.r = va.e.r), qa.e.r < qa.s.r && (qa.s.r = qa.e.r), qa.e.c > va.e.c && (qa.e.c = va.e.c), qa.e.c < qa.s.c && (qa.s.c = qa.e.c), ma["!fullref"] = ma["!ref"], ma["!ref"] = encode_range(qa));
  }
  return Ma.length > 0 && (ma["!cols"] = Ma), Na.length > 0 && (ma["!merges"] = Na), ma;
}
function parse_ws_xml_sheetpr(Xn, zn, Un, Kn) {
  var qn = parsexmltag(Xn);
  Un.Sheets[Kn] || (Un.Sheets[Kn] = {}), qn.codeName && (Un.Sheets[Kn].CodeName = unescapexml(utf8read(qn.codeName)));
}
function parse_ws_xml_sheetpr2(Xn, zn, Un, Kn, qn) {
  parse_ws_xml_sheetpr(Xn.slice(0, Xn.indexOf(">")), Un, Kn, qn);
}
function parse_ws_xml_hlinks(Xn, zn, Un) {
  for (var Kn = Array.isArray(Xn), qn = 0; qn != zn.length; ++qn) {
    var Jo = parsexmltag(utf8read(zn[qn]), !0);
    if (!Jo.ref) return;
    var pa = ((Un || {})["!id"] || [])[Jo.id];
    pa ? (Jo.Target = pa.Target, Jo.location && (Jo.Target += "#" + unescapexml(Jo.location))) : (Jo.Target = "#" + unescapexml(Jo.location), pa = { Target: Jo.Target, TargetMode: "Internal" }), Jo.Rel = pa, Jo.tooltip && (Jo.Tooltip = Jo.tooltip, delete Jo.tooltip);
    for (var ma = safe_decode_range(Jo.ref), va = ma.s.r; va <= ma.e.r; ++va) for (var ba = ma.s.c; ba <= ma.e.c; ++ba) {
      var _a = encode_cell({ c: ba, r: va });
      Kn ? (Xn[va] || (Xn[va] = []), Xn[va][ba] || (Xn[va][ba] = { t: "z", v: void 0 }), Xn[va][ba].l = Jo) : (Xn[_a] || (Xn[_a] = { t: "z", v: void 0 }), Xn[_a].l = Jo);
    }
  }
}
function parse_ws_xml_margins(Xn) {
  var zn = {};
  return ["left", "right", "top", "bottom", "header", "footer"].forEach(function(Un) {
    Xn[Un] && (zn[Un] = parseFloat(Xn[Un]));
  }), zn;
}
function parse_ws_xml_cols(Xn, zn) {
  for (var Un = !1, Kn = 0; Kn != zn.length; ++Kn) {
    var qn = parsexmltag(zn[Kn], !0);
    qn.hidden && (qn.hidden = parsexmlbool(qn.hidden));
    var Jo = parseInt(qn.min, 10) - 1, pa = parseInt(qn.max, 10) - 1;
    for (qn.outlineLevel && (qn.level = +qn.outlineLevel || 0), delete qn.min, delete qn.max, qn.width = +qn.width, !Un && qn.width && (Un = !0, find_mdw_colw(qn.width)), process_col(qn); Jo <= pa; ) Xn[Jo++] = dup(qn);
  }
}
function parse_ws_xml_autofilter(Xn) {
  var zn = { ref: (Xn.match(/ref="([^"]*)"/) || [])[1] };
  return zn;
}
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function parse_ws_xml_sheetviews(Xn, zn) {
  zn.Views || (zn.Views = [{}]), (Xn.match(sviewregex) || []).forEach(function(Un, Kn) {
    var qn = parsexmltag(Un);
    zn.Views[Kn] || (zn.Views[Kn] = {}), +qn.zoomScale && (zn.Views[Kn].zoom = +qn.zoomScale), parsexmlbool(qn.rightToLeft) && (zn.Views[Kn].RTL = !0);
  });
}
var parse_ws_xml_data = /* @__PURE__ */ function() {
  var Xn = /<(?:\w+:)?c[ \/>]/, zn = /<\/(?:\w+:)?row>/, Un = /r=["']([^"']*)["']/, Kn = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, qn = /ref=["']([^"']*)["']/, Jo = matchtag("v"), pa = matchtag("f");
  return function(va, ba, _a, ya, xa, wa) {
    for (var Ta = 0, Sa = "", Ma = [], ka = [], Za = 0, Na = 0, Ka = 0, Ja = "", el, qa, tl = 0, Qa = 0, nl, rl, il = 0, cl = 0, ll = Array.isArray(wa.CellXf), al, sl = [], dl = [], El = Array.isArray(ba), fl = [], Ml = {}, Sl = !1, ml = !!_a.sheetStubs, Dl = va.split(zn), _l = 0, gl = Dl.length; _l != gl; ++_l) {
      Sa = Dl[_l].trim();
      var Fl = Sa.length;
      if (Fl !== 0) {
        var Nl = 0;
        e: for (Ta = 0; Ta < Fl; ++Ta) switch (
          /*x.charCodeAt(ri)*/
          Sa[Ta]
        ) {
          case ">":
            if (
              /*x.charCodeAt(ri-1) != 47*/
              Sa[Ta - 1] != "/"
            ) {
              ++Ta;
              break e;
            }
            if (_a && _a.cellStyles) {
              if (qa = parsexmltag(Sa.slice(Nl, Ta), !0), tl = qa.r != null ? parseInt(qa.r, 10) : tl + 1, Qa = -1, _a.sheetRows && _a.sheetRows < tl) continue;
              Ml = {}, Sl = !1, qa.ht && (Sl = !0, Ml.hpt = parseFloat(qa.ht), Ml.hpx = pt2px(Ml.hpt)), qa.hidden == "1" && (Sl = !0, Ml.hidden = !0), qa.outlineLevel != null && (Sl = !0, Ml.level = +qa.outlineLevel), Sl && (fl[tl - 1] = Ml);
            }
            break;
          case "<":
            Nl = Ta;
            break;
        }
        if (Nl >= Ta) break;
        if (qa = parsexmltag(Sa.slice(Nl, Ta), !0), tl = qa.r != null ? parseInt(qa.r, 10) : tl + 1, Qa = -1, !(_a.sheetRows && _a.sheetRows < tl)) {
          ya.s.r > tl - 1 && (ya.s.r = tl - 1), ya.e.r < tl - 1 && (ya.e.r = tl - 1), _a && _a.cellStyles && (Ml = {}, Sl = !1, qa.ht && (Sl = !0, Ml.hpt = parseFloat(qa.ht), Ml.hpx = pt2px(Ml.hpt)), qa.hidden == "1" && (Sl = !0, Ml.hidden = !0), qa.outlineLevel != null && (Sl = !0, Ml.level = +qa.outlineLevel), Sl && (fl[tl - 1] = Ml)), Ma = Sa.slice(Ta).split(Xn);
          for (var zl = 0; zl != Ma.length && Ma[zl].trim().charAt(0) == "<"; ++zl) ;
          for (Ma = Ma.slice(zl), Ta = 0; Ta != Ma.length; ++Ta)
            if (Sa = Ma[Ta].trim(), Sa.length !== 0) {
              if (ka = Sa.match(Un), Za = Ta, Na = 0, Ka = 0, Sa = "<c " + (Sa.slice(0, 1) == "<" ? ">" : "") + Sa, ka != null && ka.length === 2) {
                for (Za = 0, Ja = ka[1], Na = 0; Na != Ja.length && !((Ka = Ja.charCodeAt(Na) - 64) < 1 || Ka > 26); ++Na)
                  Za = 26 * Za + Ka;
                --Za, Qa = Za;
              } else ++Qa;
              for (Na = 0; Na != Sa.length && Sa.charCodeAt(Na) !== 62; ++Na) ;
              if (++Na, qa = parsexmltag(Sa.slice(0, Na), !0), qa.r || (qa.r = encode_cell({ r: tl - 1, c: Qa })), Ja = Sa.slice(Na), el = { t: "" }, (ka = Ja.match(Jo)) != null && /*::cref != null && */
              ka[1] !== "" && (el.v = unescapexml(ka[1])), _a.cellFormula) {
                if ((ka = Ja.match(pa)) != null && /*::cref != null && */
                ka[1] !== "") {
                  if (el.f = unescapexml(utf8read(ka[1])).replace(/\r\n/g, `
`), _a.xlfn || (el.f = _xlfn(el.f)), /*::cref != null && cref[0] != null && */
                  ka[0].indexOf('t="array"') > -1)
                    el.F = (Ja.match(qn) || [])[1], el.F.indexOf(":") > -1 && sl.push([safe_decode_range(el.F), el.F]);
                  else if (
                    /*::cref != null && cref[0] != null && */
                    ka[0].indexOf('t="shared"') > -1
                  ) {
                    rl = parsexmltag(ka[0]);
                    var Zl = unescapexml(utf8read(ka[1]));
                    _a.xlfn || (Zl = _xlfn(Zl)), dl[parseInt(rl.si, 10)] = [rl, Zl, qa.r];
                  }
                } else (ka = Ja.match(/<f[^>]*\/>/)) && (rl = parsexmltag(ka[0]), dl[rl.si] && (el.f = shift_formula_xlsx(dl[rl.si][1], dl[rl.si][2], qa.r)));
                var kl = decode_cell(qa.r);
                for (Na = 0; Na < sl.length; ++Na)
                  kl.r >= sl[Na][0].s.r && kl.r <= sl[Na][0].e.r && kl.c >= sl[Na][0].s.c && kl.c <= sl[Na][0].e.c && (el.F = sl[Na][1]);
              }
              if (qa.t == null && el.v === void 0)
                if (el.f || el.F)
                  el.v = 0, el.t = "n";
                else if (ml) el.t = "z";
                else continue;
              else el.t = qa.t || "n";
              switch (ya.s.c > Qa && (ya.s.c = Qa), ya.e.c < Qa && (ya.e.c = Qa), el.t) {
                case "n":
                  if (el.v == "" || el.v == null) {
                    if (!ml) continue;
                    el.t = "z";
                  } else el.v = parseFloat(el.v);
                  break;
                case "s":
                  if (typeof el.v > "u") {
                    if (!ml) continue;
                    el.t = "z";
                  } else
                    nl = strs[parseInt(el.v, 10)], el.v = nl.t, el.r = nl.r, _a.cellHTML && (el.h = nl.h);
                  break;
                case "str":
                  el.t = "s", el.v = el.v != null ? utf8read(el.v) : "", _a.cellHTML && (el.h = escapehtml(el.v));
                  break;
                case "inlineStr":
                  ka = Ja.match(Kn), el.t = "s", ka != null && (nl = parse_si(ka[1])) ? (el.v = nl.t, _a.cellHTML && (el.h = nl.h)) : el.v = "";
                  break;
                case "b":
                  el.v = parsexmlbool(el.v);
                  break;
                case "d":
                  _a.cellDates ? el.v = parseDate$1(el.v, 1) : (el.v = datenum(parseDate$1(el.v, 1)), el.t = "n");
                  break;
                /* error string in .w, number in .v */
                case "e":
                  (!_a || _a.cellText !== !1) && (el.w = el.v), el.v = RBErr[el.v];
                  break;
              }
              if (il = cl = 0, al = null, ll && qa.s !== void 0 && (al = wa.CellXf[qa.s], al != null && (al.numFmtId != null && (il = al.numFmtId), _a.cellStyles && al.fillId != null && (cl = al.fillId))), safe_format(el, il, cl, _a, xa, wa), _a.cellDates && ll && el.t == "n" && fmt_is_date(table_fmt[il]) && (el.t = "d", el.v = numdate(el.v)), qa.cm && _a.xlmeta) {
                var ul = (_a.xlmeta.Cell || [])[+qa.cm - 1];
                ul && ul.type == "XLDAPR" && (el.D = !0);
              }
              if (El) {
                var vl = decode_cell(qa.r);
                ba[vl.r] || (ba[vl.r] = []), ba[vl.r][vl.c] = el;
              } else ba[qa.r] = el;
            }
        }
      }
    }
    fl.length > 0 && (ba["!rows"] = fl);
  };
}();
function parse_BrtRowHdr(Xn, zn) {
  var Un = {}, Kn = Xn.l + zn;
  Un.r = Xn.read_shift(4), Xn.l += 4;
  var qn = Xn.read_shift(2);
  Xn.l += 1;
  var Jo = Xn.read_shift(1);
  return Xn.l = Kn, Jo & 7 && (Un.level = Jo & 7), Jo & 16 && (Un.hidden = !0), Jo & 32 && (Un.hpt = qn / 20), Un;
}
var parse_BrtWsDim = parse_UncheckedRfX;
function parse_BrtWsFmtInfo() {
}
function parse_BrtWsProp(Xn, zn) {
  var Un = {}, Kn = Xn[Xn.l];
  return ++Xn.l, Un.above = !(Kn & 64), Un.left = !(Kn & 128), Xn.l += 18, Un.name = parse_XLSBCodeName(Xn), Un;
}
function parse_BrtCellBlank(Xn) {
  var zn = parse_XLSBCell(Xn);
  return [zn];
}
function parse_BrtShortBlank(Xn) {
  var zn = parse_XLSBShortCell(Xn);
  return [zn];
}
function parse_BrtCellBool(Xn) {
  var zn = parse_XLSBCell(Xn), Un = Xn.read_shift(1);
  return [zn, Un, "b"];
}
function parse_BrtShortBool(Xn) {
  var zn = parse_XLSBShortCell(Xn), Un = Xn.read_shift(1);
  return [zn, Un, "b"];
}
function parse_BrtCellError(Xn) {
  var zn = parse_XLSBCell(Xn), Un = Xn.read_shift(1);
  return [zn, Un, "e"];
}
function parse_BrtShortError(Xn) {
  var zn = parse_XLSBShortCell(Xn), Un = Xn.read_shift(1);
  return [zn, Un, "e"];
}
function parse_BrtCellIsst(Xn) {
  var zn = parse_XLSBCell(Xn), Un = Xn.read_shift(4);
  return [zn, Un, "s"];
}
function parse_BrtShortIsst(Xn) {
  var zn = parse_XLSBShortCell(Xn), Un = Xn.read_shift(4);
  return [zn, Un, "s"];
}
function parse_BrtCellReal(Xn) {
  var zn = parse_XLSBCell(Xn), Un = parse_Xnum(Xn);
  return [zn, Un, "n"];
}
function parse_BrtShortReal(Xn) {
  var zn = parse_XLSBShortCell(Xn), Un = parse_Xnum(Xn);
  return [zn, Un, "n"];
}
function parse_BrtCellRk(Xn) {
  var zn = parse_XLSBCell(Xn), Un = parse_RkNumber(Xn);
  return [zn, Un, "n"];
}
function parse_BrtShortRk(Xn) {
  var zn = parse_XLSBShortCell(Xn), Un = parse_RkNumber(Xn);
  return [zn, Un, "n"];
}
function parse_BrtCellRString(Xn) {
  var zn = parse_XLSBCell(Xn), Un = parse_RichStr(Xn);
  return [zn, Un, "is"];
}
function parse_BrtCellSt(Xn) {
  var zn = parse_XLSBCell(Xn), Un = parse_XLWideString(Xn);
  return [zn, Un, "str"];
}
function parse_BrtShortSt(Xn) {
  var zn = parse_XLSBShortCell(Xn), Un = parse_XLWideString(Xn);
  return [zn, Un, "str"];
}
function parse_BrtFmlaBool(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_XLSBCell(Xn);
  qn.r = Un["!row"];
  var Jo = Xn.read_shift(1), pa = [qn, Jo, "b"];
  if (Un.cellFormula) {
    Xn.l += 2;
    var ma = parse_XLSBCellParsedFormula(Xn, Kn - Xn.l, Un);
    pa[3] = stringify_formula(ma, null, qn, Un.supbooks, Un);
  } else Xn.l = Kn;
  return pa;
}
function parse_BrtFmlaError(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_XLSBCell(Xn);
  qn.r = Un["!row"];
  var Jo = Xn.read_shift(1), pa = [qn, Jo, "e"];
  if (Un.cellFormula) {
    Xn.l += 2;
    var ma = parse_XLSBCellParsedFormula(Xn, Kn - Xn.l, Un);
    pa[3] = stringify_formula(ma, null, qn, Un.supbooks, Un);
  } else Xn.l = Kn;
  return pa;
}
function parse_BrtFmlaNum(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_XLSBCell(Xn);
  qn.r = Un["!row"];
  var Jo = parse_Xnum(Xn), pa = [qn, Jo, "n"];
  if (Un.cellFormula) {
    Xn.l += 2;
    var ma = parse_XLSBCellParsedFormula(Xn, Kn - Xn.l, Un);
    pa[3] = stringify_formula(ma, null, qn, Un.supbooks, Un);
  } else Xn.l = Kn;
  return pa;
}
function parse_BrtFmlaString(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_XLSBCell(Xn);
  qn.r = Un["!row"];
  var Jo = parse_XLWideString(Xn), pa = [qn, Jo, "str"];
  if (Un.cellFormula) {
    Xn.l += 2;
    var ma = parse_XLSBCellParsedFormula(Xn, Kn - Xn.l, Un);
    pa[3] = stringify_formula(ma, null, qn, Un.supbooks, Un);
  } else Xn.l = Kn;
  return pa;
}
var parse_BrtMergeCell = parse_UncheckedRfX;
function parse_BrtHLink(Xn, zn) {
  var Un = Xn.l + zn, Kn = parse_UncheckedRfX(Xn), qn = parse_XLNullableWideString(Xn), Jo = parse_XLWideString(Xn), pa = parse_XLWideString(Xn), ma = parse_XLWideString(Xn);
  Xn.l = Un;
  var va = { rfx: Kn, relId: qn, loc: Jo, display: ma };
  return pa && (va.Tooltip = pa), va;
}
function parse_BrtPane() {
}
function parse_BrtArrFmla(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_RfX(Xn), Jo = Xn.read_shift(1), pa = [qn];
  if (pa[2] = Jo, Un.cellFormula) {
    var ma = parse_XLSBArrayParsedFormula(Xn, Kn - Xn.l, Un);
    pa[1] = ma;
  } else Xn.l = Kn;
  return pa;
}
function parse_BrtShrFmla(Xn, zn, Un) {
  var Kn = Xn.l + zn, qn = parse_UncheckedRfX(Xn), Jo = [qn];
  if (Un.cellFormula) {
    var pa = parse_XLSBSharedParsedFormula(Xn, Kn - Xn.l, Un);
    Jo[1] = pa, Xn.l = Kn;
  } else Xn.l = Kn;
  return Jo;
}
var BrtMarginKeys = ["left", "right", "top", "bottom", "header", "footer"];
function parse_BrtMargins(Xn) {
  var zn = {};
  return BrtMarginKeys.forEach(function(Un) {
    zn[Un] = parse_Xnum(Xn);
  }), zn;
}
function parse_BrtBeginWsView(Xn) {
  var zn = Xn.read_shift(2);
  return Xn.l += 28, { RTL: zn & 32 };
}
function parse_BrtDVal() {
}
function parse_BrtDVal14() {
}
function parse_ws_bin(Xn, zn, Un, Kn, qn, Jo, pa) {
  if (!Xn) return Xn;
  var ma = zn || {};
  Kn || (Kn = { "!id": {} });
  var va = ma.dense ? [] : {}, ba, _a = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, ya = !1, xa = !1, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el = [];
  ma.biff = 12, ma["!row"] = 0;
  var qa = 0, tl = !1, Qa = [], nl = {}, rl = ma.supbooks || /*::(*/
  qn.supbooks || [[]];
  if (rl.sharedf = nl, rl.arrayf = Qa, rl.SheetNames = qn.SheetNames || qn.Sheets.map(function(El) {
    return El.name;
  }), !ma.supbooks && (ma.supbooks = rl, qn.Names))
    for (var il = 0; il < qn.Names.length; ++il) rl[0][il + 1] = qn.Names[il];
  var cl = [], ll = [], al = !1;
  XLSBRecordEnum[16] = { n: "BrtShortReal", f: parse_BrtShortReal };
  var sl;
  if (recordhopper(Xn, function(fl, Ml, Sl) {
    if (!xa)
      switch (Sl) {
        case 148:
          ba = fl;
          break;
        case 0:
          wa = fl, ma.sheetRows && ma.sheetRows <= wa.r && (xa = !0), Ka = encode_row(Ma = wa.r), ma["!row"] = wa.r, (fl.hidden || fl.hpt || fl.level != null) && (fl.hpt && (fl.hpx = pt2px(fl.hpt)), ll[fl.r] = fl);
          break;
        case 2:
        /* 'BrtCellRk' */
        case 3:
        /* 'BrtCellError' */
        case 4:
        /* 'BrtCellBool' */
        case 5:
        /* 'BrtCellReal' */
        case 6:
        /* 'BrtCellSt' */
        case 7:
        /* 'BrtCellIsst' */
        case 8:
        /* 'BrtFmlaString' */
        case 9:
        /* 'BrtFmlaNum' */
        case 10:
        /* 'BrtFmlaBool' */
        case 11:
        /* 'BrtFmlaError' */
        case 13:
        /* 'BrtShortRk' */
        case 14:
        /* 'BrtShortError' */
        case 15:
        /* 'BrtShortBool' */
        case 16:
        /* 'BrtShortReal' */
        case 17:
        /* 'BrtShortSt' */
        case 18:
        /* 'BrtShortIsst' */
        case 62:
          switch (Ta = { t: fl[2] }, fl[2]) {
            case "n":
              Ta.v = fl[1];
              break;
            case "s":
              Na = strs[fl[1]], Ta.v = Na.t, Ta.r = Na.r;
              break;
            case "b":
              Ta.v = !!fl[1];
              break;
            case "e":
              Ta.v = fl[1], ma.cellText !== !1 && (Ta.w = BErr[Ta.v]);
              break;
            case "str":
              Ta.t = "s", Ta.v = fl[1];
              break;
            case "is":
              Ta.t = "s", Ta.v = fl[1].t;
              break;
          }
          if ((Sa = pa.CellXf[fl[0].iStyleRef]) && safe_format(Ta, Sa.numFmtId, null, ma, Jo, pa), ka = fl[0].c == -1 ? ka + 1 : fl[0].c, ma.dense ? (va[Ma] || (va[Ma] = []), va[Ma][ka] = Ta) : va[encode_col(ka) + Ka] = Ta, ma.cellFormula) {
            for (tl = !1, qa = 0; qa < Qa.length; ++qa) {
              var ml = Qa[qa];
              wa.r >= ml[0].s.r && wa.r <= ml[0].e.r && ka >= ml[0].s.c && ka <= ml[0].e.c && (Ta.F = encode_range(ml[0]), tl = !0);
            }
            !tl && fl.length > 3 && (Ta.f = fl[3]);
          }
          if (_a.s.r > wa.r && (_a.s.r = wa.r), _a.s.c > ka && (_a.s.c = ka), _a.e.r < wa.r && (_a.e.r = wa.r), _a.e.c < ka && (_a.e.c = ka), ma.cellDates && Sa && Ta.t == "n" && fmt_is_date(table_fmt[Sa.numFmtId])) {
            var Dl = SSF_parse_date_code(Ta.v);
            Dl && (Ta.t = "d", Ta.v = new Date(Dl.y, Dl.m - 1, Dl.d, Dl.H, Dl.M, Dl.S, Dl.u));
          }
          sl && (sl.type == "XLDAPR" && (Ta.D = !0), sl = void 0);
          break;
        case 1:
        /* 'BrtCellBlank' */
        case 12:
          if (!ma.sheetStubs || ya) break;
          Ta = { t: "z", v: void 0 }, ka = fl[0].c == -1 ? ka + 1 : fl[0].c, ma.dense ? (va[Ma] || (va[Ma] = []), va[Ma][ka] = Ta) : va[encode_col(ka) + Ka] = Ta, _a.s.r > wa.r && (_a.s.r = wa.r), _a.s.c > ka && (_a.s.c = ka), _a.e.r < wa.r && (_a.e.r = wa.r), _a.e.c < ka && (_a.e.c = ka), sl && (sl.type == "XLDAPR" && (Ta.D = !0), sl = void 0);
          break;
        case 176:
          el.push(fl);
          break;
        case 49:
          sl = ((ma.xlmeta || {}).Cell || [])[fl - 1];
          break;
        case 494:
          var _l = Kn["!id"][fl.relId];
          for (_l ? (fl.Target = _l.Target, fl.loc && (fl.Target += "#" + fl.loc), fl.Rel = _l) : fl.relId == "" && (fl.Target = "#" + fl.loc), Ma = fl.rfx.s.r; Ma <= fl.rfx.e.r; ++Ma) for (ka = fl.rfx.s.c; ka <= fl.rfx.e.c; ++ka)
            ma.dense ? (va[Ma] || (va[Ma] = []), va[Ma][ka] || (va[Ma][ka] = { t: "z", v: void 0 }), va[Ma][ka].l = fl) : (Za = encode_cell({ c: ka, r: Ma }), va[Za] || (va[Za] = { t: "z", v: void 0 }), va[Za].l = fl);
          break;
        case 426:
          if (!ma.cellFormula) break;
          Qa.push(fl), Ja = ma.dense ? va[Ma][ka] : va[encode_col(ka) + Ka], Ja.f = stringify_formula(fl[1], _a, { r: wa.r, c: ka }, rl, ma), Ja.F = encode_range(fl[0]);
          break;
        case 427:
          if (!ma.cellFormula) break;
          nl[encode_cell(fl[0].s)] = fl[1], Ja = ma.dense ? va[Ma][ka] : va[encode_col(ka) + Ka], Ja.f = stringify_formula(fl[1], _a, { r: wa.r, c: ka }, rl, ma);
          break;
        /* identical to 'ColInfo' in XLS */
        case 60:
          if (!ma.cellStyles) break;
          for (; fl.e >= fl.s; )
            cl[fl.e--] = { width: fl.w / 256, hidden: !!(fl.flags & 1), level: fl.level }, al || (al = !0, find_mdw_colw(fl.w / 256)), process_col(cl[fl.e + 1]);
          break;
        case 161:
          va["!autofilter"] = { ref: encode_range(fl) };
          break;
        case 476:
          va["!margins"] = fl;
          break;
        case 147:
          qn.Sheets[Un] || (qn.Sheets[Un] = {}), fl.name && (qn.Sheets[Un].CodeName = fl.name), (fl.above || fl.left) && (va["!outline"] = { above: fl.above, left: fl.left });
          break;
        case 137:
          qn.Views || (qn.Views = [{}]), qn.Views[0] || (qn.Views[0] = {}), fl.RTL && (qn.Views[0].RTL = !0);
          break;
        case 485:
          break;
        case 64:
        /* 'BrtDVal' */
        case 1053:
          break;
        case 151:
          break;
        case 152:
        /* 'BrtSel' */
        case 175:
        /* 'BrtAFilterDateGroupItem' */
        case 644:
        /* 'BrtActiveX' */
        case 625:
        /* 'BrtBigName' */
        case 562:
        /* 'BrtBkHim' */
        case 396:
        /* 'BrtBrk' */
        case 1112:
        /* 'BrtCFIcon' */
        case 1146:
        /* 'BrtCFRuleExt' */
        case 471:
        /* 'BrtCFVO' */
        case 1050:
        /* 'BrtCFVO14' */
        case 649:
        /* 'BrtCellIgnoreEC' */
        case 1105:
        /* 'BrtCellIgnoreEC14' */
        case 589:
        /* 'BrtCellSmartTagProperty' */
        case 607:
        /* 'BrtCellWatch' */
        case 564:
        /* 'BrtColor' */
        case 1055:
        /* 'BrtColor14' */
        case 168:
        /* 'BrtColorFilter' */
        case 174:
        /* 'BrtCustomFilter' */
        case 1180:
        /* 'BrtCustomFilter14' */
        case 499:
        /* 'BrtDRef' */
        case 507:
        /* 'BrtDXF' */
        case 550:
        /* 'BrtDrawing' */
        case 171:
        /* 'BrtDynamicFilter' */
        case 167:
        /* 'BrtFilter' */
        case 1177:
        /* 'BrtFilter14' */
        case 169:
        /* 'BrtIconFilter' */
        case 1181:
        /* 'BrtIconFilter14' */
        case 551:
        /* 'BrtLegacyDrawing' */
        case 552:
        /* 'BrtLegacyDrawingHF' */
        case 661:
        /* 'BrtListPart' */
        case 639:
        /* 'BrtOleObject' */
        case 478:
        /* 'BrtPageSetup' */
        case 537:
        /* 'BrtPhoneticInfo' */
        case 477:
        /* 'BrtPrintOptions' */
        case 536:
        /* 'BrtRangeProtection' */
        case 1103:
        /* 'BrtRangeProtection14' */
        case 680:
        /* 'BrtRangeProtectionIso' */
        case 1104:
        /* 'BrtRangeProtectionIso14' */
        case 1024:
        /* 'BrtRwDescent' */
        case 663:
        /* 'BrtSheetCalcProp' */
        case 535:
        /* 'BrtSheetProtection' */
        case 678:
        /* 'BrtSheetProtectionIso' */
        case 504:
        /* 'BrtSlc' */
        case 1043:
        /* 'BrtSparkline' */
        case 428:
        /* 'BrtTable' */
        case 170:
        /* 'BrtTop10Filter' */
        case 3072:
        /* 'BrtUid' */
        case 50:
        /* 'BrtValueMeta' */
        case 2070:
        /* 'BrtWebExtension' */
        case 1045:
          break;
        case 35:
          ya = !0;
          break;
        case 36:
          ya = !1;
          break;
        case 37:
          ya = !0;
          break;
        case 38:
          ya = !1;
          break;
        default:
          if (!Ml.T) {
            if (!ya || ma.WTF) throw new Error("Unexpected record 0x" + Sl.toString(16));
          }
      }
  }, ma), delete ma.supbooks, delete ma["!row"], !va["!ref"] && (_a.s.r < 2e6 || ba && (ba.e.r > 0 || ba.e.c > 0 || ba.s.r > 0 || ba.s.c > 0)) && (va["!ref"] = encode_range(ba || _a)), ma.sheetRows && va["!ref"]) {
    var dl = safe_decode_range(va["!ref"]);
    ma.sheetRows <= +dl.e.r && (dl.e.r = ma.sheetRows - 1, dl.e.r > _a.e.r && (dl.e.r = _a.e.r), dl.e.r < dl.s.r && (dl.s.r = dl.e.r), dl.e.c > _a.e.c && (dl.e.c = _a.e.c), dl.e.c < dl.s.c && (dl.s.c = dl.e.c), va["!fullref"] = va["!ref"], va["!ref"] = encode_range(dl));
  }
  return el.length > 0 && (va["!merges"] = el), cl.length > 0 && (va["!cols"] = cl), ll.length > 0 && (va["!rows"] = ll), va;
}
function parse_Cache(Xn) {
  var zn = [], Un = Xn.match(/^<c:numCache>/), Kn;
  (Xn.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(Jo) {
    var pa = Jo.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
    pa && (zn[+pa[1]] = Un ? +pa[2] : pa[2]);
  });
  var qn = unescapexml((Xn.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
  return (Xn.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(Jo) {
    Kn = Jo.replace(/<.*?>/g, "");
  }), [zn, qn, Kn];
}
function parse_chart(Xn, zn, Un, Kn, qn, Jo) {
  var pa = Jo || { "!type": "chart" };
  if (!Xn) return Jo;
  var ma = 0, va = 0, ba = "A", _a = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
  return (Xn.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(ya) {
    var xa = parse_Cache(ya);
    _a.s.r = _a.s.c = 0, _a.e.c = ma, ba = encode_col(ma), xa[0].forEach(function(wa, Ta) {
      pa[ba + encode_row(Ta)] = { t: "n", v: wa, z: xa[1] }, va = Ta;
    }), _a.e.r < va && (_a.e.r = va), ++ma;
  }), ma > 0 && (pa["!ref"] = encode_range(_a)), pa;
}
function parse_cs_xml(Xn, zn, Un, Kn, qn) {
  if (!Xn) return Xn;
  Kn || (Kn = { "!id": {} });
  var Jo = { "!type": "chart", "!drawel": null, "!rel": "" }, pa, ma = Xn.match(sheetprregex);
  return ma && parse_ws_xml_sheetpr(ma[0], Jo, qn, Un), (pa = Xn.match(/drawing r:id="(.*?)"/)) && (Jo["!rel"] = pa[1]), Kn["!id"][Jo["!rel"]] && (Jo["!drawel"] = Kn["!id"][Jo["!rel"]]), Jo;
}
function parse_BrtCsProp(Xn, zn) {
  Xn.l += 10;
  var Un = parse_XLWideString(Xn);
  return { name: Un };
}
function parse_cs_bin(Xn, zn, Un, Kn, qn) {
  if (!Xn) return Xn;
  Kn || (Kn = { "!id": {} });
  var Jo = { "!type": "chart", "!drawel": null, "!rel": "" }, pa = !1;
  return recordhopper(Xn, function(va, ba, _a) {
    switch (_a) {
      case 550:
        Jo["!rel"] = va;
        break;
      case 651:
        qn.Sheets[Un] || (qn.Sheets[Un] = {}), va.name && (qn.Sheets[Un].CodeName = va.name);
        break;
      case 562:
      /* 'BrtBkHim' */
      case 652:
      /* 'BrtCsPageSetup' */
      case 669:
      /* 'BrtCsProtection' */
      case 679:
      /* 'BrtCsProtectionIso' */
      case 551:
      /* 'BrtLegacyDrawing' */
      case 552:
      /* 'BrtLegacyDrawingHF' */
      case 476:
      /* 'BrtMargins' */
      case 3072:
        break;
      case 35:
        pa = !0;
        break;
      case 36:
        pa = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!(ba.T > 0)) {
          if (!(ba.T < 0)) {
            if (!pa || zn.WTF) throw new Error("Unexpected record 0x" + _a.toString(16));
          }
        }
    }
  }, zn), Kn["!id"][Jo["!rel"]] && (Jo["!drawel"] = Kn["!id"][Jo["!rel"]]), Jo;
}
var WBPropsDef = [
  ["allowRefreshQuery", !1, "bool"],
  ["autoCompressPictures", !0, "bool"],
  ["backupFile", !1, "bool"],
  ["checkCompatibility", !1, "bool"],
  ["CodeName", ""],
  ["date1904", !1, "bool"],
  ["defaultThemeVersion", 0, "int"],
  ["filterPrivacy", !1, "bool"],
  ["hidePivotFieldList", !1, "bool"],
  ["promptedSolutions", !1, "bool"],
  ["publishItems", !1, "bool"],
  ["refreshAllConnections", !1, "bool"],
  ["saveExternalLinkValues", !0, "bool"],
  ["showBorderUnselectedTables", !0, "bool"],
  ["showInkAnnotation", !0, "bool"],
  ["showObjects", "all"],
  ["showPivotChartFilter", !1, "bool"],
  ["updateLinks", "userSet"]
], WBViewDef = [
  ["activeTab", 0, "int"],
  ["autoFilterDateGrouping", !0, "bool"],
  ["firstSheet", 0, "int"],
  ["minimized", !1, "bool"],
  ["showHorizontalScroll", !0, "bool"],
  ["showSheetTabs", !0, "bool"],
  ["showVerticalScroll", !0, "bool"],
  ["tabRatio", 600, "int"],
  ["visibility", "visible"]
  //window{Height,Width}, {x,y}Window
], SheetDef = [
  //['state', 'visible']
], CalcPrDef = [
  ["calcCompleted", "true"],
  ["calcMode", "auto"],
  ["calcOnSave", "true"],
  ["concurrentCalc", "true"],
  ["fullCalcOnLoad", "false"],
  ["fullPrecision", "true"],
  ["iterate", "false"],
  ["iterateCount", "100"],
  ["iterateDelta", "0.001"],
  ["refMode", "A1"]
];
function push_defaults_array(Xn, zn) {
  for (var Un = 0; Un != Xn.length; ++Un)
    for (var Kn = Xn[Un], qn = 0; qn != zn.length; ++qn) {
      var Jo = zn[qn];
      if (Kn[Jo[0]] == null) Kn[Jo[0]] = Jo[1];
      else switch (Jo[2]) {
        case "bool":
          typeof Kn[Jo[0]] == "string" && (Kn[Jo[0]] = parsexmlbool(Kn[Jo[0]]));
          break;
        case "int":
          typeof Kn[Jo[0]] == "string" && (Kn[Jo[0]] = parseInt(Kn[Jo[0]], 10));
          break;
      }
    }
}
function push_defaults(Xn, zn) {
  for (var Un = 0; Un != zn.length; ++Un) {
    var Kn = zn[Un];
    if (Xn[Kn[0]] == null) Xn[Kn[0]] = Kn[1];
    else switch (Kn[2]) {
      case "bool":
        typeof Xn[Kn[0]] == "string" && (Xn[Kn[0]] = parsexmlbool(Xn[Kn[0]]));
        break;
      case "int":
        typeof Xn[Kn[0]] == "string" && (Xn[Kn[0]] = parseInt(Xn[Kn[0]], 10));
        break;
    }
  }
}
function parse_wb_defaults(Xn) {
  push_defaults(Xn.WBProps, WBPropsDef), push_defaults(Xn.CalcPr, CalcPrDef), push_defaults_array(Xn.WBView, WBViewDef), push_defaults_array(Xn.Sheets, SheetDef), _ssfopts.date1904 = parsexmlbool(Xn.WBProps.date1904);
}
var badchars = /* @__PURE__ */ "][*?/\\".split("");
function check_ws_name(Xn, zn) {
  if (Xn.length > 31)
    throw new Error("Sheet names cannot exceed 31 chars");
  var Un = !0;
  return badchars.forEach(function(Kn) {
    if (Xn.indexOf(Kn) != -1)
      throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
  }), Un;
}
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(Xn, zn) {
  if (!Xn) throw new Error("Could not find file");
  var Un = (
    /*::(*/
    { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, Names: [], xmlns: "" }
  ), Kn = !1, qn = "xmlns", Jo = {}, pa = 0;
  if (Xn.replace(tagregex, function(va, ba) {
    var _a = parsexmltag(va);
    switch (strip_ns(_a[0])) {
      case "<?xml":
        break;
      /* 18.2.27 workbook CT_Workbook 1 */
      case "<workbook":
        va.match(wbnsregex) && (qn = "xmlns" + va.match(/<(\w+):/)[1]), Un.xmlns = _a[qn];
        break;
      case "</workbook>":
        break;
      /* 18.2.13 fileVersion CT_FileVersion ? */
      case "<fileVersion":
        delete _a[0], Un.AppVersion = _a;
        break;
      case "<fileVersion/>":
      case "</fileVersion>":
        break;
      /* 18.2.12 fileSharing CT_FileSharing ? */
      case "<fileSharing":
        break;
      case "<fileSharing/>":
        break;
      /* 18.2.28 workbookPr CT_WorkbookPr ? */
      case "<workbookPr":
      case "<workbookPr/>":
        WBPropsDef.forEach(function(ya) {
          if (_a[ya[0]] != null)
            switch (ya[2]) {
              case "bool":
                Un.WBProps[ya[0]] = parsexmlbool(_a[ya[0]]);
                break;
              case "int":
                Un.WBProps[ya[0]] = parseInt(_a[ya[0]], 10);
                break;
              default:
                Un.WBProps[ya[0]] = _a[ya[0]];
            }
        }), _a.codeName && (Un.WBProps.CodeName = utf8read(_a.codeName));
        break;
      case "</workbookPr>":
        break;
      /* 18.2.29 workbookProtection CT_WorkbookProtection ? */
      case "<workbookProtection":
        break;
      case "<workbookProtection/>":
        break;
      /* 18.2.1  bookViews CT_BookViews ? */
      case "<bookViews":
      case "<bookViews>":
      case "</bookViews>":
        break;
      /* 18.2.30   workbookView CT_BookView + */
      case "<workbookView":
      case "<workbookView/>":
        delete _a[0], Un.WBView.push(_a);
        break;
      case "</workbookView>":
        break;
      /* 18.2.20 sheets CT_Sheets 1 */
      case "<sheets":
      case "<sheets>":
      case "</sheets>":
        break;
      // aggregate sheet
      /* 18.2.19   sheet CT_Sheet + */
      case "<sheet":
        switch (_a.state) {
          case "hidden":
            _a.Hidden = 1;
            break;
          case "veryHidden":
            _a.Hidden = 2;
            break;
          default:
            _a.Hidden = 0;
        }
        delete _a.state, _a.name = unescapexml(utf8read(_a.name)), delete _a[0], Un.Sheets.push(_a);
        break;
      case "</sheet>":
        break;
      /* 18.2.15 functionGroups CT_FunctionGroups ? */
      case "<functionGroups":
      case "<functionGroups/>":
        break;
      /* 18.2.14   functionGroup CT_FunctionGroup + */
      case "<functionGroup":
        break;
      /* 18.2.9  externalReferences CT_ExternalReferences ? */
      case "<externalReferences":
      case "</externalReferences>":
      case "<externalReferences>":
        break;
      /* 18.2.8    externalReference CT_ExternalReference + */
      case "<externalReference":
        break;
      /* 18.2.6  definedNames CT_DefinedNames ? */
      case "<definedNames/>":
        break;
      case "<definedNames>":
      case "<definedNames":
        Kn = !0;
        break;
      case "</definedNames>":
        Kn = !1;
        break;
      /* 18.2.5    definedName CT_DefinedName + */
      case "<definedName":
        Jo = {}, Jo.Name = utf8read(_a.name), _a.comment && (Jo.Comment = _a.comment), _a.localSheetId && (Jo.Sheet = +_a.localSheetId), parsexmlbool(_a.hidden || "0") && (Jo.Hidden = !0), pa = ba + va.length;
        break;
      case "</definedName>":
        Jo.Ref = unescapexml(utf8read(Xn.slice(pa, ba))), Un.Names.push(Jo);
        break;
      case "<definedName/>":
        break;
      /* 18.2.2  calcPr CT_CalcPr ? */
      case "<calcPr":
        delete _a[0], Un.CalcPr = _a;
        break;
      case "<calcPr/>":
        delete _a[0], Un.CalcPr = _a;
        break;
      case "</calcPr>":
        break;
      /* 18.2.16 oleSize CT_OleSize ? (ref required) */
      case "<oleSize":
        break;
      /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
      case "<customWorkbookViews>":
      case "</customWorkbookViews>":
      case "<customWorkbookViews":
        break;
      /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
      case "<customWorkbookView":
      case "</customWorkbookView>":
        break;
      /* 18.2.18 pivotCaches CT_PivotCaches ? */
      case "<pivotCaches>":
      case "</pivotCaches>":
      case "<pivotCaches":
        break;
      /* 18.2.17 pivotCache CT_PivotCache ? */
      case "<pivotCache":
        break;
      /* 18.2.21 smartTagPr CT_SmartTagPr ? */
      case "<smartTagPr":
      case "<smartTagPr/>":
        break;
      /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
      case "<smartTagTypes":
      case "<smartTagTypes>":
      case "</smartTagTypes>":
        break;
      /* 18.2.22 smartTagType CT_SmartTagType ? */
      case "<smartTagType":
        break;
      /* 18.2.24 webPublishing CT_WebPublishing ? */
      case "<webPublishing":
      case "<webPublishing/>":
        break;
      /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
      case "<fileRecoveryPr":
      case "<fileRecoveryPr/>":
        break;
      /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
      case "<webPublishObjects>":
      case "<webPublishObjects":
      case "</webPublishObjects>":
        break;
      /* 18.2.25 webPublishObject CT_WebPublishObject ? */
      case "<webPublishObject":
        break;
      /* 18.2.10 extLst CT_ExtensionList ? */
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      /* 18.2.7  ext CT_Extension + */
      case "<ext":
        Kn = !0;
        break;
      //TODO: check with versions of excel
      case "</ext>":
        Kn = !1;
        break;
      /* Others */
      case "<ArchID":
        break;
      case "<AlternateContent":
      case "<AlternateContent>":
        Kn = !0;
        break;
      case "</AlternateContent>":
        Kn = !1;
        break;
      /* TODO */
      case "<revisionPtr":
        break;
      default:
        if (!Kn && zn.WTF) throw new Error("unrecognized " + _a[0] + " in workbook");
    }
    return va;
  }), XMLNS_main.indexOf(Un.xmlns) === -1) throw new Error("Unknown Namespace: " + Un.xmlns);
  return parse_wb_defaults(Un), Un;
}
function parse_BrtBundleSh(Xn, zn) {
  var Un = {};
  return Un.Hidden = Xn.read_shift(4), Un.iTabID = Xn.read_shift(4), Un.strRelID = parse_RelID(Xn), Un.name = parse_XLWideString(Xn), Un;
}
function parse_BrtWbProp(Xn, zn) {
  var Un = {}, Kn = Xn.read_shift(4);
  Un.defaultThemeVersion = Xn.read_shift(4);
  var qn = zn > 8 ? parse_XLWideString(Xn) : "";
  return qn.length > 0 && (Un.CodeName = qn), Un.autoCompressPictures = !!(Kn & 65536), Un.backupFile = !!(Kn & 64), Un.checkCompatibility = !!(Kn & 4096), Un.date1904 = !!(Kn & 1), Un.filterPrivacy = !!(Kn & 8), Un.hidePivotFieldList = !!(Kn & 1024), Un.promptedSolutions = !!(Kn & 16), Un.publishItems = !!(Kn & 2048), Un.refreshAllConnections = !!(Kn & 262144), Un.saveExternalLinkValues = !!(Kn & 128), Un.showBorderUnselectedTables = !!(Kn & 4), Un.showInkAnnotation = !!(Kn & 32), Un.showObjects = ["all", "placeholders", "none"][Kn >> 13 & 3], Un.showPivotChartFilter = !!(Kn & 32768), Un.updateLinks = ["userSet", "never", "always"][Kn >> 8 & 3], Un;
}
function parse_BrtFRTArchID$(Xn, zn) {
  var Un = {};
  return Xn.read_shift(4), Un.ArchID = Xn.read_shift(4), Xn.l += zn - 8, Un;
}
function parse_BrtName(Xn, zn, Un) {
  var Kn = Xn.l + zn;
  Xn.l += 4, Xn.l += 1;
  var qn = Xn.read_shift(4), Jo = parse_XLNameWideString(Xn), pa = parse_XLSBNameParsedFormula(Xn, 0, Un), ma = parse_XLNullableWideString(Xn);
  Xn.l = Kn;
  var va = { Name: Jo, Ptg: pa };
  return qn < 268435455 && (va.Sheet = qn), ma && (va.Comment = ma), va;
}
function parse_wb_bin(Xn, zn) {
  var Un = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }, Kn = [], qn = !1;
  zn || (zn = {}), zn.biff = 12;
  var Jo = [], pa = [[]];
  return pa.SheetNames = [], pa.XTI = [], XLSBRecordEnum[16] = { n: "BrtFRTArchID$", f: parse_BrtFRTArchID$ }, recordhopper(Xn, function(va, ba, _a) {
    switch (_a) {
      case 156:
        pa.SheetNames.push(va.name), Un.Sheets.push(va);
        break;
      case 153:
        Un.WBProps = va;
        break;
      case 39:
        va.Sheet != null && (zn.SID = va.Sheet), va.Ref = stringify_formula(va.Ptg, null, null, pa, zn), delete zn.SID, delete va.Ptg, Jo.push(va);
        break;
      case 1036:
        break;
      case 357:
      /* 'BrtSupSelf' */
      case 358:
      /* 'BrtSupSame' */
      case 355:
      /* 'BrtSupBookSrc' */
      case 667:
        pa[0].length ? pa.push([_a, va]) : pa[0] = [_a, va], pa[pa.length - 1].XTI = [];
        break;
      case 362:
        pa.length === 0 && (pa[0] = [], pa[0].XTI = []), pa[pa.length - 1].XTI = pa[pa.length - 1].XTI.concat(va), pa.XTI = pa.XTI.concat(va);
        break;
      case 361:
        break;
      case 2071:
      /* 'BrtAbsPath15' */
      case 158:
      /* 'BrtBookView' */
      case 143:
      /* 'BrtBeginBundleShs' */
      case 664:
      /* 'BrtBeginFnGroup' */
      case 353:
        break;
      /* case 'BrtModelTimeGroupingCalcCol' */
      case 3072:
      /* 'BrtUid' */
      case 3073:
      /* 'BrtRevisionPtr' */
      case 534:
      /* 'BrtBookProtection' */
      case 677:
      /* 'BrtBookProtectionIso' */
      case 157:
      /* 'BrtCalcProp' */
      case 610:
      /* 'BrtCrashRecErr' */
      case 2050:
      /* 'BrtDecoupledPivotCacheID' */
      case 155:
      /* 'BrtFileRecover' */
      case 548:
      /* 'BrtFileSharing' */
      case 676:
      /* 'BrtFileSharingIso' */
      case 128:
      /* 'BrtFileVersion' */
      case 665:
      /* 'BrtFnGroup' */
      case 2128:
      /* 'BrtModelRelationship' */
      case 2125:
      /* 'BrtModelTable' */
      case 549:
      /* 'BrtOleSize' */
      case 2053:
      /* 'BrtPivotTableRef' */
      case 596:
      /* 'BrtSmartTagType' */
      case 2076:
      /* 'BrtTableSlicerCacheID' */
      case 2075:
      /* 'BrtTableSlicerCacheIDs' */
      case 2082:
      /* 'BrtTimelineCachePivotCacheID' */
      case 397:
      /* 'BrtUserBookView' */
      case 154:
      /* 'BrtWbFactoid' */
      case 1117:
      /* 'BrtWbProp14' */
      case 553:
      /* 'BrtWebOpt' */
      case 2091:
        break;
      case 35:
        Kn.push(_a), qn = !0;
        break;
      case 36:
        Kn.pop(), qn = !1;
        break;
      case 37:
        Kn.push(_a), qn = !0;
        break;
      case 38:
        Kn.pop(), qn = !1;
        break;
      case 16:
        break;
      default:
        if (!ba.T) {
          if (!qn || zn.WTF && Kn[Kn.length - 1] != 37 && Kn[Kn.length - 1] != 35) throw new Error("Unexpected record 0x" + _a.toString(16));
        }
    }
  }, zn), parse_wb_defaults(Un), Un.Names = Jo, Un.supbooks = pa, Un;
}
function parse_wb(Xn, zn, Un) {
  return zn.slice(-4) === ".bin" ? parse_wb_bin(Xn, Un) : parse_wb_xml(Xn, Un);
}
function parse_ws(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  return zn.slice(-4) === ".bin" ? parse_ws_bin(Xn, Kn, Un, qn, Jo, pa, ma) : parse_ws_xml(Xn, Kn, Un, qn, Jo, pa, ma);
}
function parse_cs(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  return zn.slice(-4) === ".bin" ? parse_cs_bin(Xn, Kn, Un, qn, Jo) : parse_cs_xml(Xn, Kn, Un, qn, Jo);
}
function parse_ms(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  return zn.slice(-4) === ".bin" ? parse_ms_bin() : parse_ms_xml();
}
function parse_ds(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  return zn.slice(-4) === ".bin" ? parse_ds_bin() : parse_ds_xml();
}
function parse_sty(Xn, zn, Un, Kn) {
  return zn.slice(-4) === ".bin" ? parse_sty_bin(Xn, Un, Kn) : parse_sty_xml(Xn, Un, Kn);
}
function parse_theme(Xn, zn, Un) {
  return parse_theme_xml(Xn, Un);
}
function parse_sst(Xn, zn, Un) {
  return zn.slice(-4) === ".bin" ? parse_sst_bin(Xn, Un) : parse_sst_xml(Xn, Un);
}
function parse_cmnt(Xn, zn, Un) {
  return zn.slice(-4) === ".bin" ? parse_comments_bin(Xn, Un) : parse_comments_xml(Xn, Un);
}
function parse_cc(Xn, zn, Un) {
  return zn.slice(-4) === ".bin" ? parse_cc_bin(Xn) : parse_cc_xml(Xn);
}
function parse_xlink(Xn, zn, Un, Kn) {
  return Un.slice(-4) === ".bin" ? parse_xlink_bin(Xn, zn, Un, Kn) : void 0;
}
function parse_xlmeta(Xn, zn, Un) {
  return zn.slice(-4) === ".bin" ? parse_xlmeta_bin(Xn, zn, Un) : parse_xlmeta_xml(Xn, zn, Un);
}
var attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function xlml_parsexmltag(Xn, zn) {
  var Un = Xn.split(/\s+/), Kn = [];
  if (Kn[0] = Un[0], Un.length === 1) return Kn;
  var qn = Xn.match(attregexg2), Jo, pa, ma, va;
  if (qn) for (va = 0; va != qn.length; ++va)
    Jo = qn[va].match(attregex2), (pa = Jo[1].indexOf(":")) === -1 ? Kn[Jo[1]] = Jo[2].slice(1, Jo[2].length - 1) : (Jo[1].slice(0, 6) === "xmlns:" ? ma = "xmlns" + Jo[1].slice(6) : ma = Jo[1].slice(pa + 1), Kn[ma] = Jo[2].slice(1, Jo[2].length - 1));
  return Kn;
}
function xlml_parsexmltagobj(Xn) {
  var zn = Xn.split(/\s+/), Un = {};
  if (zn.length === 1) return Un;
  var Kn = Xn.match(attregexg2), qn, Jo, pa, ma;
  if (Kn) for (ma = 0; ma != Kn.length; ++ma)
    qn = Kn[ma].match(attregex2), (Jo = qn[1].indexOf(":")) === -1 ? Un[qn[1]] = qn[2].slice(1, qn[2].length - 1) : (qn[1].slice(0, 6) === "xmlns:" ? pa = "xmlns" + qn[1].slice(6) : pa = qn[1].slice(Jo + 1), Un[pa] = qn[2].slice(1, qn[2].length - 1));
  return Un;
}
var XLMLFormatMap;
function xlml_format(Xn, zn) {
  var Un = XLMLFormatMap[Xn] || unescapexml(Xn);
  return Un === "General" ? SSF_general(zn) : SSF_format(Un, zn);
}
function xlml_set_custprop(Xn, zn, Un, Kn) {
  var qn = Kn;
  switch ((Un[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
    case "boolean":
      qn = parsexmlbool(Kn);
      break;
    case "i2":
    case "int":
      qn = parseInt(Kn, 10);
      break;
    case "r4":
    case "float":
      qn = parseFloat(Kn);
      break;
    case "date":
    case "dateTime.tz":
      qn = parseDate$1(Kn);
      break;
    case "i8":
    case "string":
    case "fixed":
    case "uuid":
    case "bin.base64":
      break;
    default:
      throw new Error("bad custprop:" + Un[0]);
  }
  Xn[unescapexml(zn)] = qn;
}
function safe_format_xlml(Xn, zn, Un) {
  if (Xn.t !== "z") {
    if (!Un || Un.cellText !== !1) try {
      Xn.t === "e" ? Xn.w = Xn.w || BErr[Xn.v] : zn === "General" ? Xn.t === "n" ? (Xn.v | 0) === Xn.v ? Xn.w = Xn.v.toString(10) : Xn.w = SSF_general_num(Xn.v) : Xn.w = SSF_general(Xn.v) : Xn.w = xlml_format(zn || "General", Xn.v);
    } catch (Jo) {
      if (Un.WTF) throw Jo;
    }
    try {
      var Kn = XLMLFormatMap[zn] || zn || "General";
      if (Un.cellNF && (Xn.z = Kn), Un.cellDates && Xn.t == "n" && fmt_is_date(Kn)) {
        var qn = SSF_parse_date_code(Xn.v);
        qn && (Xn.t = "d", Xn.v = new Date(qn.y, qn.m - 1, qn.d, qn.H, qn.M, qn.S, qn.u));
      }
    } catch (Jo) {
      if (Un.WTF) throw Jo;
    }
  }
}
function process_style_xlml(Xn, zn, Un) {
  if (Un.cellStyles && zn.Interior) {
    var Kn = zn.Interior;
    Kn.Pattern && (Kn.patternType = XLMLPatternTypeMap[Kn.Pattern] || Kn.Pattern);
  }
  Xn[zn.ID] = zn;
}
function parse_xlml_data(Xn, zn, Un, Kn, qn, Jo, pa, ma, va, ba) {
  var _a = "General", ya = Kn.StyleID, xa = {};
  ba = ba || {};
  var wa = [], Ta = 0;
  for (ya === void 0 && ma && (ya = ma.StyleID), ya === void 0 && pa && (ya = pa.StyleID); Jo[ya] !== void 0 && (Jo[ya].nf && (_a = Jo[ya].nf), Jo[ya].Interior && wa.push(Jo[ya].Interior), !!Jo[ya].Parent); )
    ya = Jo[ya].Parent;
  switch (Un.Type) {
    case "Boolean":
      Kn.t = "b", Kn.v = parsexmlbool(Xn);
      break;
    case "String":
      Kn.t = "s", Kn.r = xlml_fixstr(unescapexml(Xn)), Kn.v = Xn.indexOf("<") > -1 ? unescapexml(zn || Xn).replace(/<.*?>/g, "") : Kn.r;
      break;
    case "DateTime":
      Xn.slice(-1) != "Z" && (Xn += "Z"), Kn.v = (parseDate$1(Xn) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1e3), Kn.v !== Kn.v ? Kn.v = unescapexml(Xn) : Kn.v < 60 && (Kn.v = Kn.v - 1), (!_a || _a == "General") && (_a = "yyyy-mm-dd");
    /* falls through */
    case "Number":
      Kn.v === void 0 && (Kn.v = +Xn), Kn.t || (Kn.t = "n");
      break;
    case "Error":
      Kn.t = "e", Kn.v = RBErr[Xn], ba.cellText !== !1 && (Kn.w = Xn);
      break;
    default:
      Xn == "" && zn == "" ? Kn.t = "z" : (Kn.t = "s", Kn.v = xlml_fixstr(zn || Xn));
      break;
  }
  if (safe_format_xlml(Kn, _a, ba), ba.cellFormula !== !1)
    if (Kn.Formula) {
      var Sa = unescapexml(Kn.Formula);
      Sa.charCodeAt(0) == 61 && (Sa = Sa.slice(1)), Kn.f = rc_to_a1(Sa, qn), delete Kn.Formula, Kn.ArrayRange == "RC" ? Kn.F = rc_to_a1("RC:RC", qn) : Kn.ArrayRange && (Kn.F = rc_to_a1(Kn.ArrayRange, qn), va.push([safe_decode_range(Kn.F), Kn.F]));
    } else
      for (Ta = 0; Ta < va.length; ++Ta)
        qn.r >= va[Ta][0].s.r && qn.r <= va[Ta][0].e.r && qn.c >= va[Ta][0].s.c && qn.c <= va[Ta][0].e.c && (Kn.F = va[Ta][1]);
  ba.cellStyles && (wa.forEach(function(Ma) {
    !xa.patternType && Ma.patternType && (xa.patternType = Ma.patternType);
  }), Kn.s = xa), Kn.StyleID !== void 0 && (Kn.ixfe = Kn.StyleID);
}
function xlml_clean_comment(Xn) {
  Xn.t = Xn.v || "", Xn.t = Xn.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), Xn.v = Xn.w = Xn.ixfe = void 0;
}
function parse_xlml_xml(Xn, zn) {
  var Un = zn || {};
  make_ssf();
  var Kn = debom(xlml_normalize(Xn));
  (Un.type == "binary" || Un.type == "array" || Un.type == "base64") && (Kn = utf8read(Kn));
  var qn = Kn.slice(0, 1024).toLowerCase(), Jo = !1;
  if (qn = qn.replace(/".*?"/g, ""), (qn.indexOf(">") & 1023) > Math.min(qn.indexOf(",") & 1023, qn.indexOf(";") & 1023)) {
    var pa = dup(Un);
    return pa.type = "string", PRN.to_workbook(Kn, pa);
  }
  if (qn.indexOf("<?xml") == -1 && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(hl) {
    qn.indexOf("<" + hl) >= 0 && (Jo = !0);
  }), Jo) return html_to_workbook(Kn, Un);
  XLMLFormatMap = {
    "General Number": "General",
    "General Date": table_fmt[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": table_fmt[15],
    "Short Date": table_fmt[14],
    "Long Time": table_fmt[19],
    "Medium Time": table_fmt[18],
    "Short Time": table_fmt[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: table_fmt[2],
    Standard: table_fmt[4],
    Percent: table_fmt[10],
    Scientific: table_fmt[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@'
  };
  var ma, va = [], ba, _a = {}, ya = [], xa = Un.dense ? [] : {}, wa = "", Ta = {}, Sa = {}, Ma = xlml_parsexmltag('<Data ss:Type="String">'), ka = 0, Za = 0, Na = 0, Ka = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, Ja = {}, el = {}, qa = "", tl = 0, Qa = [], nl = {}, rl = {}, il = 0, cl = [], ll = [], al = {}, sl = [], dl, El = !1, fl = [], Ml = [], Sl = {}, ml = 0, Dl = 0, _l = { Sheets: [], WBProps: { date1904: !1 } }, gl = {};
  xlmlregex.lastIndex = 0, Kn = Kn.replace(/<!--([\s\S]*?)-->/mg, "");
  for (var Fl = ""; ma = xlmlregex.exec(Kn); ) switch (ma[3] = (Fl = ma[3]).toLowerCase()) {
    case "data":
      if (Fl == "data") {
        if (ma[1] === "/") {
          if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
        } else ma[0].charAt(ma[0].length - 2) !== "/" && va.push([ma[3], !0]);
        break;
      }
      if (va[va.length - 1][1]) break;
      ma[1] === "/" ? parse_xlml_data(Kn.slice(ka, ma.index), qa, Ma, va[va.length - 1][0] == /*"Comment"*/
      "comment" ? al : Ta, { c: Za, r: Na }, Ja, sl[Za], Sa, fl, Un) : (qa = "", Ma = xlml_parsexmltag(ma[0]), ka = ma.index + ma[0].length);
      break;
    case "cell":
      if (ma[1] === "/")
        if (ll.length > 0 && (Ta.c = ll), (!Un.sheetRows || Un.sheetRows > Na) && Ta.v !== void 0 && (Un.dense ? (xa[Na] || (xa[Na] = []), xa[Na][Za] = Ta) : xa[encode_col(Za) + encode_row(Na)] = Ta), Ta.HRef && (Ta.l = { Target: unescapexml(Ta.HRef) }, Ta.HRefScreenTip && (Ta.l.Tooltip = Ta.HRefScreenTip), delete Ta.HRef, delete Ta.HRefScreenTip), (Ta.MergeAcross || Ta.MergeDown) && (ml = Za + (parseInt(Ta.MergeAcross, 10) | 0), Dl = Na + (parseInt(Ta.MergeDown, 10) | 0), Qa.push({ s: { c: Za, r: Na }, e: { c: ml, r: Dl } })), !Un.sheetStubs)
          Ta.MergeAcross ? Za = ml + 1 : ++Za;
        else if (Ta.MergeAcross || Ta.MergeDown) {
          for (var Nl = Za; Nl <= ml; ++Nl)
            for (var zl = Na; zl <= Dl; ++zl)
              (Nl > Za || zl > Na) && (Un.dense ? (xa[zl] || (xa[zl] = []), xa[zl][Nl] = { t: "z" }) : xa[encode_col(Nl) + encode_row(zl)] = { t: "z" });
          Za = ml + 1;
        } else ++Za;
      else
        Ta = xlml_parsexmltagobj(ma[0]), Ta.Index && (Za = +Ta.Index - 1), Za < Ka.s.c && (Ka.s.c = Za), Za > Ka.e.c && (Ka.e.c = Za), ma[0].slice(-2) === "/>" && ++Za, ll = [];
      break;
    case "row":
      ma[1] === "/" || ma[0].slice(-2) === "/>" ? (Na < Ka.s.r && (Ka.s.r = Na), Na > Ka.e.r && (Ka.e.r = Na), ma[0].slice(-2) === "/>" && (Sa = xlml_parsexmltag(ma[0]), Sa.Index && (Na = +Sa.Index - 1)), Za = 0, ++Na) : (Sa = xlml_parsexmltag(ma[0]), Sa.Index && (Na = +Sa.Index - 1), Sl = {}, (Sa.AutoFitHeight == "0" || Sa.Height) && (Sl.hpx = parseInt(Sa.Height, 10), Sl.hpt = px2pt(Sl.hpx), Ml[Na] = Sl), Sa.Hidden == "1" && (Sl.hidden = !0, Ml[Na] = Sl));
      break;
    case "worksheet":
      if (ma[1] === "/") {
        if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
        ya.push(wa), Ka.s.r <= Ka.e.r && Ka.s.c <= Ka.e.c && (xa["!ref"] = encode_range(Ka), Un.sheetRows && Un.sheetRows <= Ka.e.r && (xa["!fullref"] = xa["!ref"], Ka.e.r = Un.sheetRows - 1, xa["!ref"] = encode_range(Ka))), Qa.length && (xa["!merges"] = Qa), sl.length > 0 && (xa["!cols"] = sl), Ml.length > 0 && (xa["!rows"] = Ml), _a[wa] = xa;
      } else
        Ka = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, Na = Za = 0, va.push([ma[3], !1]), ba = xlml_parsexmltag(ma[0]), wa = unescapexml(ba.Name), xa = Un.dense ? [] : {}, Qa = [], fl = [], Ml = [], gl = { name: wa, Hidden: 0 }, _l.Sheets.push(gl);
      break;
    case "table":
      if (ma[1] === "/") {
        if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
      } else {
        if (ma[0].slice(-2) == "/>") break;
        va.push([ma[3], !1]), sl = [], El = !1;
      }
      break;
    case "style":
      ma[1] === "/" ? process_style_xlml(Ja, el, Un) : el = xlml_parsexmltag(ma[0]);
      break;
    case "numberformat":
      el.nf = unescapexml(xlml_parsexmltag(ma[0]).Format || "General"), XLMLFormatMap[el.nf] && (el.nf = XLMLFormatMap[el.nf]);
      for (var Zl = 0; Zl != 392 && table_fmt[Zl] != el.nf; ++Zl) ;
      if (Zl == 392) {
        for (Zl = 57; Zl != 392; ++Zl) if (table_fmt[Zl] == null) {
          SSF_load(el.nf, Zl);
          break;
        }
      }
      break;
    case "column":
      if (va[va.length - 1][0] !== /*'Table'*/
      "table") break;
      if (dl = xlml_parsexmltag(ma[0]), dl.Hidden && (dl.hidden = !0, delete dl.Hidden), dl.Width && (dl.wpx = parseInt(dl.Width, 10)), !El && dl.wpx > 10) {
        El = !0, MDW = DEF_MDW;
        for (var kl = 0; kl < sl.length; ++kl) sl[kl] && process_col(sl[kl]);
      }
      El && process_col(dl), sl[dl.Index - 1 || sl.length] = dl;
      for (var ul = 0; ul < +dl.Span; ++ul) sl[sl.length] = dup(dl);
      break;
    case "namedrange":
      if (ma[1] === "/") break;
      _l.Names || (_l.Names = []);
      var vl = parsexmltag(ma[0]), Tl = {
        Name: vl.Name,
        Ref: rc_to_a1(vl.RefersTo.slice(1), { r: 0, c: 0 })
      };
      _l.Sheets.length > 0 && (Tl.Sheet = _l.Sheets.length - 1), _l.Names.push(Tl);
      break;
    case "namedcell":
      break;
    case "b":
      break;
    case "i":
      break;
    case "u":
      break;
    case "s":
      break;
    case "em":
      break;
    case "h2":
      break;
    case "h3":
      break;
    case "sub":
      break;
    case "sup":
      break;
    case "span":
      break;
    case "alignment":
      break;
    case "borders":
      break;
    case "border":
      break;
    case "font":
      if (ma[0].slice(-2) === "/>") break;
      ma[1] === "/" ? qa += Kn.slice(tl, ma.index) : tl = ma.index + ma[0].length;
      break;
    case "interior":
      if (!Un.cellStyles) break;
      el.Interior = xlml_parsexmltag(ma[0]);
      break;
    case "protection":
      break;
    case "author":
    case "title":
    case "description":
    case "created":
    case "keywords":
    case "subject":
    case "category":
    case "company":
    case "lastauthor":
    case "lastsaved":
    case "lastprinted":
    case "version":
    case "revision":
    case "totaltime":
    case "hyperlinkbase":
    case "manager":
    case "contentstatus":
    case "identifier":
    case "language":
    case "appname":
      if (ma[0].slice(-2) === "/>") break;
      ma[1] === "/" ? xlml_set_prop(nl, Fl, Kn.slice(il, ma.index)) : il = ma.index + ma[0].length;
      break;
    case "paragraphs":
      break;
    case "styles":
    case "workbook":
      if (ma[1] === "/") {
        if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
      } else va.push([ma[3], !1]);
      break;
    case "comment":
      if (ma[1] === "/") {
        if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
        xlml_clean_comment(al), ll.push(al);
      } else
        va.push([ma[3], !1]), ba = xlml_parsexmltag(ma[0]), al = { a: ba.Author };
      break;
    case "autofilter":
      if (ma[1] === "/") {
        if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
      } else if (ma[0].charAt(ma[0].length - 2) !== "/") {
        var wl = xlml_parsexmltag(ma[0]);
        xa["!autofilter"] = { ref: rc_to_a1(wl.Range).replace(/\$/g, "") }, va.push([ma[3], !0]);
      }
      break;
    case "name":
      break;
    case "datavalidation":
      if (ma[1] === "/") {
        if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
      } else
        ma[0].charAt(ma[0].length - 2) !== "/" && va.push([ma[3], !0]);
      break;
    case "pixelsperinch":
      break;
    case "componentoptions":
    case "documentproperties":
    case "customdocumentproperties":
    case "officedocumentsettings":
    case "pivottable":
    case "pivotcache":
    case "names":
    case "mapinfo":
    case "pagebreaks":
    case "querytable":
    case "sorting":
    case "schema":
    //case 'data' /*case 'data'*/:
    case "conditionalformatting":
    case "smarttagtype":
    case "smarttags":
    case "excelworkbook":
    case "workbookoptions":
    case "worksheetoptions":
      if (ma[1] === "/") {
        if ((ba = va.pop())[0] !== ma[3]) throw new Error("Bad state: " + ba.join("|"));
      } else ma[0].charAt(ma[0].length - 2) !== "/" && va.push([ma[3], !0]);
      break;
    case "null":
      break;
    default:
      if (va.length == 0 && ma[3] == "document" || va.length == 0 && ma[3] == "uof") return parse_fods(Kn, Un);
      var yl = !0;
      switch (va[va.length - 1][0]) {
        /* OfficeDocumentSettings */
        case "officedocumentsettings":
          switch (ma[3]) {
            case "allowpng":
              break;
            case "removepersonalinformation":
              break;
            case "downloadcomponents":
              break;
            case "locationofcomponents":
              break;
            case "colors":
              break;
            case "color":
              break;
            case "index":
              break;
            case "rgb":
              break;
            case "targetscreensize":
              break;
            case "readonlyrecommended":
              break;
            default:
              yl = !1;
          }
          break;
        /* ComponentOptions */
        case "componentoptions":
          switch (ma[3]) {
            case "toolbar":
              break;
            case "hideofficelogo":
              break;
            case "spreadsheetautofit":
              break;
            case "label":
              break;
            case "caption":
              break;
            case "maxheight":
              break;
            case "maxwidth":
              break;
            case "nextsheetnumber":
              break;
            default:
              yl = !1;
          }
          break;
        /* ExcelWorkbook */
        case "excelworkbook":
          switch (ma[3]) {
            case "date1904":
              _l.WBProps.date1904 = !0;
              break;
            case "windowheight":
              break;
            case "windowwidth":
              break;
            case "windowtopx":
              break;
            case "windowtopy":
              break;
            case "tabratio":
              break;
            case "protectstructure":
              break;
            case "protectwindow":
              break;
            case "protectwindows":
              break;
            case "activesheet":
              break;
            case "displayinknotes":
              break;
            case "firstvisiblesheet":
              break;
            case "supbook":
              break;
            case "sheetname":
              break;
            case "sheetindex":
              break;
            case "sheetindexfirst":
              break;
            case "sheetindexlast":
              break;
            case "dll":
              break;
            case "acceptlabelsinformulas":
              break;
            case "donotsavelinkvalues":
              break;
            case "iteration":
              break;
            case "maxiterations":
              break;
            case "maxchange":
              break;
            case "path":
              break;
            case "xct":
              break;
            case "count":
              break;
            case "selectedsheets":
              break;
            case "calculation":
              break;
            case "uncalced":
              break;
            case "startupprompt":
              break;
            case "crn":
              break;
            case "externname":
              break;
            case "formula":
              break;
            case "colfirst":
              break;
            case "collast":
              break;
            case "wantadvise":
              break;
            case "boolean":
              break;
            case "error":
              break;
            case "text":
              break;
            case "ole":
              break;
            case "noautorecover":
              break;
            case "publishobjects":
              break;
            case "donotcalculatebeforesave":
              break;
            case "number":
              break;
            case "refmoder1c1":
              break;
            case "embedsavesmarttags":
              break;
            default:
              yl = !1;
          }
          break;
        /* WorkbookOptions */
        case "workbookoptions":
          switch (ma[3]) {
            case "owcversion":
              break;
            case "height":
              break;
            case "width":
              break;
            default:
              yl = !1;
          }
          break;
        /* WorksheetOptions */
        case "worksheetoptions":
          switch (ma[3]) {
            case "visible":
              if (ma[0].slice(-2) !== "/>") if (ma[1] === "/") switch (Kn.slice(il, ma.index)) {
                case "SheetHidden":
                  gl.Hidden = 1;
                  break;
                case "SheetVeryHidden":
                  gl.Hidden = 2;
                  break;
              }
              else il = ma.index + ma[0].length;
              break;
            case "header":
              xa["!margins"] || default_margins(xa["!margins"] = {}, "xlml"), isNaN(+parsexmltag(ma[0]).Margin) || (xa["!margins"].header = +parsexmltag(ma[0]).Margin);
              break;
            case "footer":
              xa["!margins"] || default_margins(xa["!margins"] = {}, "xlml"), isNaN(+parsexmltag(ma[0]).Margin) || (xa["!margins"].footer = +parsexmltag(ma[0]).Margin);
              break;
            case "pagemargins":
              var Rl = parsexmltag(ma[0]);
              xa["!margins"] || default_margins(xa["!margins"] = {}, "xlml"), isNaN(+Rl.Top) || (xa["!margins"].top = +Rl.Top), isNaN(+Rl.Left) || (xa["!margins"].left = +Rl.Left), isNaN(+Rl.Right) || (xa["!margins"].right = +Rl.Right), isNaN(+Rl.Bottom) || (xa["!margins"].bottom = +Rl.Bottom);
              break;
            case "displayrighttoleft":
              _l.Views || (_l.Views = []), _l.Views[0] || (_l.Views[0] = {}), _l.Views[0].RTL = !0;
              break;
            case "freezepanes":
              break;
            case "frozennosplit":
              break;
            case "splithorizontal":
            case "splitvertical":
              break;
            case "donotdisplaygridlines":
              break;
            case "activerow":
              break;
            case "activecol":
              break;
            case "toprowbottompane":
              break;
            case "leftcolumnrightpane":
              break;
            case "unsynced":
              break;
            case "print":
              break;
            case "printerrors":
              break;
            case "panes":
              break;
            case "scale":
              break;
            case "pane":
              break;
            case "number":
              break;
            case "layout":
              break;
            case "pagesetup":
              break;
            case "selected":
              break;
            case "protectobjects":
              break;
            case "enableselection":
              break;
            case "protectscenarios":
              break;
            case "validprinterinfo":
              break;
            case "horizontalresolution":
              break;
            case "verticalresolution":
              break;
            case "numberofcopies":
              break;
            case "activepane":
              break;
            case "toprowvisible":
              break;
            case "leftcolumnvisible":
              break;
            case "fittopage":
              break;
            case "rangeselection":
              break;
            case "papersizeindex":
              break;
            case "pagelayoutzoom":
              break;
            case "pagebreakzoom":
              break;
            case "filteron":
              break;
            case "fitwidth":
              break;
            case "fitheight":
              break;
            case "commentslayout":
              break;
            case "zoom":
              break;
            case "lefttoright":
              break;
            case "gridlines":
              break;
            case "allowsort":
              break;
            case "allowfilter":
              break;
            case "allowinsertrows":
              break;
            case "allowdeleterows":
              break;
            case "allowinsertcols":
              break;
            case "allowdeletecols":
              break;
            case "allowinserthyperlinks":
              break;
            case "allowformatcells":
              break;
            case "allowsizecols":
              break;
            case "allowsizerows":
              break;
            case "nosummaryrowsbelowdetail":
              xa["!outline"] || (xa["!outline"] = {}), xa["!outline"].above = !0;
              break;
            case "tabcolorindex":
              break;
            case "donotdisplayheadings":
              break;
            case "showpagelayoutzoom":
              break;
            case "nosummarycolumnsrightdetail":
              xa["!outline"] || (xa["!outline"] = {}), xa["!outline"].left = !0;
              break;
            case "blackandwhite":
              break;
            case "donotdisplayzeros":
              break;
            case "displaypagebreak":
              break;
            case "rowcolheadings":
              break;
            case "donotdisplayoutline":
              break;
            case "noorientation":
              break;
            case "allowusepivottables":
              break;
            case "zeroheight":
              break;
            case "viewablerange":
              break;
            case "selection":
              break;
            case "protectcontents":
              break;
            default:
              yl = !1;
          }
          break;
        /* PivotTable */
        case "pivottable":
        case "pivotcache":
          switch (ma[3]) {
            case "immediateitemsondrop":
              break;
            case "showpagemultipleitemlabel":
              break;
            case "compactrowindent":
              break;
            case "location":
              break;
            case "pivotfield":
              break;
            case "orientation":
              break;
            case "layoutform":
              break;
            case "layoutsubtotallocation":
              break;
            case "layoutcompactrow":
              break;
            case "position":
              break;
            case "pivotitem":
              break;
            case "datatype":
              break;
            case "datafield":
              break;
            case "sourcename":
              break;
            case "parentfield":
              break;
            case "ptlineitems":
              break;
            case "ptlineitem":
              break;
            case "countofsameitems":
              break;
            case "item":
              break;
            case "itemtype":
              break;
            case "ptsource":
              break;
            case "cacheindex":
              break;
            case "consolidationreference":
              break;
            case "filename":
              break;
            case "reference":
              break;
            case "nocolumngrand":
              break;
            case "norowgrand":
              break;
            case "blanklineafteritems":
              break;
            case "hidden":
              break;
            case "subtotal":
              break;
            case "basefield":
              break;
            case "mapchilditems":
              break;
            case "function":
              break;
            case "refreshonfileopen":
              break;
            case "printsettitles":
              break;
            case "mergelabels":
              break;
            case "defaultversion":
              break;
            case "refreshname":
              break;
            case "refreshdate":
              break;
            case "refreshdatecopy":
              break;
            case "versionlastrefresh":
              break;
            case "versionlastupdate":
              break;
            case "versionupdateablemin":
              break;
            case "versionrefreshablemin":
              break;
            case "calculation":
              break;
            default:
              yl = !1;
          }
          break;
        /* PageBreaks */
        case "pagebreaks":
          switch (ma[3]) {
            case "colbreaks":
              break;
            case "colbreak":
              break;
            case "rowbreaks":
              break;
            case "rowbreak":
              break;
            case "colstart":
              break;
            case "colend":
              break;
            case "rowend":
              break;
            default:
              yl = !1;
          }
          break;
        /* AutoFilter */
        case "autofilter":
          switch (ma[3]) {
            case "autofiltercolumn":
              break;
            case "autofiltercondition":
              break;
            case "autofilterand":
              break;
            case "autofilteror":
              break;
            default:
              yl = !1;
          }
          break;
        /* QueryTable */
        case "querytable":
          switch (ma[3]) {
            case "id":
              break;
            case "autoformatfont":
              break;
            case "autoformatpattern":
              break;
            case "querysource":
              break;
            case "querytype":
              break;
            case "enableredirections":
              break;
            case "refreshedinxl9":
              break;
            case "urlstring":
              break;
            case "htmltables":
              break;
            case "connection":
              break;
            case "commandtext":
              break;
            case "refreshinfo":
              break;
            case "notitles":
              break;
            case "nextid":
              break;
            case "columninfo":
              break;
            case "overwritecells":
              break;
            case "donotpromptforfile":
              break;
            case "textwizardsettings":
              break;
            case "source":
              break;
            case "number":
              break;
            case "decimal":
              break;
            case "thousandseparator":
              break;
            case "trailingminusnumbers":
              break;
            case "formatsettings":
              break;
            case "fieldtype":
              break;
            case "delimiters":
              break;
            case "tab":
              break;
            case "comma":
              break;
            case "autoformatname":
              break;
            case "versionlastedit":
              break;
            case "versionlastrefresh":
              break;
            default:
              yl = !1;
          }
          break;
        case "datavalidation":
          switch (ma[3]) {
            case "range":
              break;
            case "type":
              break;
            case "min":
              break;
            case "max":
              break;
            case "sort":
              break;
            case "descending":
              break;
            case "order":
              break;
            case "casesensitive":
              break;
            case "value":
              break;
            case "errorstyle":
              break;
            case "errormessage":
              break;
            case "errortitle":
              break;
            case "inputmessage":
              break;
            case "inputtitle":
              break;
            case "combohide":
              break;
            case "inputhide":
              break;
            case "condition":
              break;
            case "qualifier":
              break;
            case "useblank":
              break;
            case "value1":
              break;
            case "value2":
              break;
            case "format":
              break;
            case "cellrangelist":
              break;
            default:
              yl = !1;
          }
          break;
        case "sorting":
        case "conditionalformatting":
          switch (ma[3]) {
            case "range":
              break;
            case "type":
              break;
            case "min":
              break;
            case "max":
              break;
            case "sort":
              break;
            case "descending":
              break;
            case "order":
              break;
            case "casesensitive":
              break;
            case "value":
              break;
            case "errorstyle":
              break;
            case "errormessage":
              break;
            case "errortitle":
              break;
            case "cellrangelist":
              break;
            case "inputmessage":
              break;
            case "inputtitle":
              break;
            case "combohide":
              break;
            case "inputhide":
              break;
            case "condition":
              break;
            case "qualifier":
              break;
            case "useblank":
              break;
            case "value1":
              break;
            case "value2":
              break;
            case "format":
              break;
            default:
              yl = !1;
          }
          break;
        /* MapInfo (schema) */
        case "mapinfo":
        case "schema":
        case "data":
          switch (ma[3]) {
            case "map":
              break;
            case "entry":
              break;
            case "range":
              break;
            case "xpath":
              break;
            case "field":
              break;
            case "xsdtype":
              break;
            case "filteron":
              break;
            case "aggregate":
              break;
            case "elementtype":
              break;
            case "attributetype":
              break;
            /* These are from xsd (XML Schema Definition) */
            case "schema":
            case "element":
            case "complextype":
            case "datatype":
            case "all":
            case "attribute":
            case "extends":
              break;
            case "row":
              break;
            default:
              yl = !1;
          }
          break;
        /* SmartTags (can be anything) */
        case "smarttags":
          break;
        default:
          yl = !1;
          break;
      }
      if (yl || ma[3].match(/!\[CDATA/)) break;
      if (!va[va.length - 1][1]) throw "Unrecognized tag: " + ma[3] + "|" + va.join("|");
      if (va[va.length - 1][0] === /*'CustomDocumentProperties'*/
      "customdocumentproperties") {
        if (ma[0].slice(-2) === "/>") break;
        ma[1] === "/" ? xlml_set_custprop(rl, Fl, cl, Kn.slice(il, ma.index)) : (cl = ma, il = ma.index + ma[0].length);
        break;
      }
      if (Un.WTF) throw "Unrecognized tag: " + ma[3] + "|" + va.join("|");
  }
  var Ul = {};
  return !Un.bookSheets && !Un.bookProps && (Ul.Sheets = _a), Ul.SheetNames = ya, Ul.Workbook = _l, Ul.SSF = dup(table_fmt), Ul.Props = nl, Ul.Custprops = rl, Ul;
}
function parse_xlml(Xn, zn) {
  switch (fix_read_opts(zn = zn || {}), zn.type || "base64") {
    case "base64":
      return parse_xlml_xml(Base64_decode(Xn), zn);
    case "binary":
    case "buffer":
    case "file":
      return parse_xlml_xml(Xn, zn);
    case "array":
      return parse_xlml_xml(a2s(Xn), zn);
  }
}
function parse_compobj(Xn) {
  var zn = {}, Un = Xn.content;
  if (Un.l = 28, zn.AnsiUserType = Un.read_shift(0, "lpstr-ansi"), zn.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(Un), Un.length - Un.l <= 4) return zn;
  var Kn = Un.read_shift(4);
  if (Kn == 0 || Kn > 40 || (Un.l -= 4, zn.Reserved1 = Un.read_shift(0, "lpstr-ansi"), Un.length - Un.l <= 4) || (Kn = Un.read_shift(4), Kn !== 1907505652) || (zn.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(Un), Kn = Un.read_shift(4), Kn == 0 || Kn > 40)) return zn;
  Un.l -= 4, zn.Reserved2 = Un.read_shift(0, "lpwstr");
}
var CONTINUE_RT = [60, 1084, 2066, 2165, 2175];
function slurp(Xn, zn, Un, Kn, qn) {
  var Jo = Kn, pa = [], ma = Un.slice(Un.l, Un.l + Jo);
  if (qn && qn.enc && qn.enc.insitu && ma.length > 0) switch (Xn) {
    case 9:
    case 521:
    case 1033:
    case 2057:
    case 47:
    case 405:
    case 225:
    case 406:
    case 312:
    case 404:
    case 10:
      break;
    case 133:
      break;
    default:
      qn.enc.insitu(ma);
  }
  pa.push(ma), Un.l += Jo;
  for (var va = __readUInt16LE(Un, Un.l), ba = XLSRecordEnum[va], _a = 0; ba != null && CONTINUE_RT.indexOf(va) > -1; )
    Jo = __readUInt16LE(Un, Un.l + 2), _a = Un.l + 4, va == 2066 ? _a += 4 : (va == 2165 || va == 2175) && (_a += 12), ma = Un.slice(_a, Un.l + 4 + Jo), pa.push(ma), Un.l += 4 + Jo, ba = XLSRecordEnum[va = __readUInt16LE(Un, Un.l)];
  var ya = bconcat(pa);
  prep_blob(ya, 0);
  var xa = 0;
  ya.lens = [];
  for (var wa = 0; wa < pa.length; ++wa)
    ya.lens.push(xa), xa += pa[wa].length;
  if (ya.length < Kn) throw "XLS Record 0x" + Xn.toString(16) + " Truncated: " + ya.length + " < " + Kn;
  return zn.f(ya, ya.length, qn);
}
function safe_format_xf(Xn, zn, Un) {
  if (Xn.t !== "z" && Xn.XF) {
    var Kn = 0;
    try {
      Kn = Xn.z || Xn.XF.numFmtId || 0, zn.cellNF && (Xn.z = table_fmt[Kn]);
    } catch (Jo) {
      if (zn.WTF) throw Jo;
    }
    if (!zn || zn.cellText !== !1) try {
      Xn.t === "e" ? Xn.w = Xn.w || BErr[Xn.v] : Kn === 0 || Kn == "General" ? Xn.t === "n" ? (Xn.v | 0) === Xn.v ? Xn.w = Xn.v.toString(10) : Xn.w = SSF_general_num(Xn.v) : Xn.w = SSF_general(Xn.v) : Xn.w = SSF_format(Kn, Xn.v, { date1904: !!Un, dateNF: zn && zn.dateNF });
    } catch (Jo) {
      if (zn.WTF) throw Jo;
    }
    if (zn.cellDates && Kn && Xn.t == "n" && fmt_is_date(table_fmt[Kn] || String(Kn))) {
      var qn = SSF_parse_date_code(Xn.v);
      qn && (Xn.t = "d", Xn.v = new Date(qn.y, qn.m - 1, qn.d, qn.H, qn.M, qn.S, qn.u));
    }
  }
}
function make_cell(Xn, zn, Un) {
  return { v: Xn, ixfe: zn, t: Un };
}
function parse_workbook(Xn, zn) {
  var Un = { opts: {} }, Kn = {}, qn = zn.dense ? [] : {}, Jo = {}, pa = {}, ma = null, va = [], ba = "", _a = {}, ya, xa = "", wa, Ta, Sa, Ma, ka = {}, Za = [], Na, Ka, Ja = [], el = [], qa = { Sheets: [], WBProps: { date1904: !1 }, Views: [{}] }, tl = {}, Qa = function(Ec) {
    return Ec < 8 ? XLSIcv[Ec] : Ec < 64 && el[Ec - 8] || XLSIcv[Ec];
  }, nl = function(Ec, Hl, fc) {
    var lc = Hl.XF.data;
    if (!(!lc || !lc.patternType || !fc || !fc.cellStyles)) {
      Hl.s = {}, Hl.s.patternType = lc.patternType;
      var Gl;
      (Gl = rgb2Hex(Qa(lc.icvFore))) && (Hl.s.fgColor = { rgb: Gl }), (Gl = rgb2Hex(Qa(lc.icvBack))) && (Hl.s.bgColor = { rgb: Gl });
    }
  }, rl = function(Ec, Hl, fc) {
    if (!(Sl > 1) && !(fc.sheetRows && Ec.r >= fc.sheetRows)) {
      if (fc.cellStyles && Hl.XF && Hl.XF.data && nl(Ec, Hl, fc), delete Hl.ixfe, delete Hl.XF, ya = Ec, xa = encode_cell(Ec), (!pa || !pa.s || !pa.e) && (pa = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }), Ec.r < pa.s.r && (pa.s.r = Ec.r), Ec.c < pa.s.c && (pa.s.c = Ec.c), Ec.r + 1 > pa.e.r && (pa.e.r = Ec.r + 1), Ec.c + 1 > pa.e.c && (pa.e.c = Ec.c + 1), fc.cellFormula && Hl.f) {
        for (var lc = 0; lc < Za.length; ++lc)
          if (!(Za[lc][0].s.c > Ec.c || Za[lc][0].s.r > Ec.r) && !(Za[lc][0].e.c < Ec.c || Za[lc][0].e.r < Ec.r)) {
            Hl.F = encode_range(Za[lc][0]), (Za[lc][0].s.c != Ec.c || Za[lc][0].s.r != Ec.r) && delete Hl.f, Hl.f && (Hl.f = "" + stringify_formula(Za[lc][1], pa, Ec, fl, il));
            break;
          }
      }
      fc.dense ? (qn[Ec.r] || (qn[Ec.r] = []), qn[Ec.r][Ec.c] = Hl) : qn[xa] = Hl;
    }
  }, il = {
    enc: !1,
    // encrypted
    sbcch: 0,
    // cch in the preceding SupBook
    snames: [],
    // sheetnames
    sharedf: ka,
    // shared formulae by address
    arrayf: Za,
    // array formulae array
    rrtabid: [],
    // RRTabId
    lastuser: "",
    // Last User from WriteAccess
    biff: 8,
    // BIFF version
    codepage: 0,
    // CP from CodePage record
    winlocked: 0,
    // fLockWn from WinProtect
    cellStyles: !!zn && !!zn.cellStyles,
    WTF: !!zn && !!zn.wtf
  };
  zn.password && (il.password = zn.password);
  var cl, ll = [], al = [], sl = [], dl = [], El = !1, fl = [];
  fl.SheetNames = il.snames, fl.sharedf = il.sharedf, fl.arrayf = il.arrayf, fl.names = [], fl.XTI = [];
  var Ml = 0, Sl = 0, ml = 0, Dl = [], _l = [], gl;
  il.codepage = 1200, set_cp(1200);
  for (var Fl = !1; Xn.l < Xn.length - 1; ) {
    var Nl = Xn.l, zl = Xn.read_shift(2);
    if (zl === 0 && Ml === 10) break;
    var Zl = Xn.l === Xn.length ? 0 : Xn.read_shift(2), kl = XLSRecordEnum[zl];
    if (kl && kl.f) {
      if (zn.bookSheets && Ml === 133 && zl !== 133)
        break;
      if (Ml = zl, kl.r === 2 || kl.r == 12) {
        var ul = Xn.read_shift(2);
        if (Zl -= 2, !il.enc && ul !== zl && ((ul & 255) << 8 | ul >> 8) !== zl) throw new Error("rt mismatch: " + ul + "!=" + zl);
        kl.r == 12 && (Xn.l += 10, Zl -= 10);
      }
      var vl = {};
      if (zl === 10 ? vl = /*::(*/
      kl.f(Xn, Zl, il) : vl = /*::(*/
      slurp(zl, kl, Xn, Zl, il), Sl == 0 && [9, 521, 1033, 2057].indexOf(Ml) === -1) continue;
      switch (zl) {
        case 34:
          Un.opts.Date1904 = qa.WBProps.date1904 = vl;
          break;
        case 134:
          Un.opts.WriteProtect = !0;
          break;
        case 47:
          if (il.enc || (Xn.l = 0), il.enc = vl, !zn.password) throw new Error("File is password-protected");
          if (vl.valid == null) throw new Error("Encryption scheme unsupported");
          if (!vl.valid) throw new Error("Password is incorrect");
          break;
        case 92:
          il.lastuser = vl;
          break;
        case 66:
          var Tl = Number(vl);
          switch (Tl) {
            case 21010:
              Tl = 1200;
              break;
            case 32768:
              Tl = 1e4;
              break;
            case 32769:
              Tl = 1252;
              break;
          }
          set_cp(il.codepage = Tl), Fl = !0;
          break;
        case 317:
          il.rrtabid = vl;
          break;
        case 25:
          il.winlocked = vl;
          break;
        case 439:
          Un.opts.RefreshAll = vl;
          break;
        case 12:
          Un.opts.CalcCount = vl;
          break;
        case 16:
          Un.opts.CalcDelta = vl;
          break;
        case 17:
          Un.opts.CalcIter = vl;
          break;
        case 13:
          Un.opts.CalcMode = vl;
          break;
        case 14:
          Un.opts.CalcPrecision = vl;
          break;
        case 95:
          Un.opts.CalcSaveRecalc = vl;
          break;
        case 15:
          il.CalcRefMode = vl;
          break;
        // TODO: implement R1C1
        case 2211:
          Un.opts.FullCalc = vl;
          break;
        case 129:
          vl.fDialog && (qn["!type"] = "dialog"), vl.fBelow || ((qn["!outline"] || (qn["!outline"] = {})).above = !0), vl.fRight || ((qn["!outline"] || (qn["!outline"] = {})).left = !0);
          break;
        // TODO
        case 224:
          Ja.push(vl);
          break;
        case 430:
          fl.push([vl]), fl[fl.length - 1].XTI = [];
          break;
        case 35:
        case 547:
          fl[fl.length - 1].push(vl);
          break;
        case 24:
        case 536:
          gl = {
            Name: vl.Name,
            Ref: stringify_formula(vl.rgce, pa, null, fl, il)
          }, vl.itab > 0 && (gl.Sheet = vl.itab - 1), fl.names.push(gl), fl[0] || (fl[0] = [], fl[0].XTI = []), fl[fl.length - 1].push(vl), vl.Name == "_xlnm._FilterDatabase" && vl.itab > 0 && vl.rgce && vl.rgce[0] && vl.rgce[0][0] && vl.rgce[0][0][0] == "PtgArea3d" && (_l[vl.itab - 1] = { ref: encode_range(vl.rgce[0][0][1][2]) });
          break;
        case 22:
          il.ExternCount = vl;
          break;
        case 23:
          fl.length == 0 && (fl[0] = [], fl[0].XTI = []), fl[fl.length - 1].XTI = fl[fl.length - 1].XTI.concat(vl), fl.XTI = fl.XTI.concat(vl);
          break;
        case 2196:
          if (il.biff < 8) break;
          gl != null && (gl.Comment = vl[1]);
          break;
        case 18:
          qn["!protect"] = vl;
          break;
        /* for sheet or book */
        case 19:
          vl !== 0 && il.WTF && console.error("Password verifier: " + vl);
          break;
        case 133:
          Jo[vl.pos] = vl, il.snames.push(vl.name);
          break;
        case 10:
          {
            if (--Sl) break;
            if (pa.e) {
              if (pa.e.r > 0 && pa.e.c > 0) {
                if (pa.e.r--, pa.e.c--, qn["!ref"] = encode_range(pa), zn.sheetRows && zn.sheetRows <= pa.e.r) {
                  var wl = pa.e.r;
                  pa.e.r = zn.sheetRows - 1, qn["!fullref"] = qn["!ref"], qn["!ref"] = encode_range(pa), pa.e.r = wl;
                }
                pa.e.r++, pa.e.c++;
              }
              ll.length > 0 && (qn["!merges"] = ll), al.length > 0 && (qn["!objects"] = al), sl.length > 0 && (qn["!cols"] = sl), dl.length > 0 && (qn["!rows"] = dl), qa.Sheets.push(tl);
            }
            ba === "" ? _a = qn : Kn[ba] = qn, qn = zn.dense ? [] : {};
          }
          break;
        case 9:
        case 521:
        case 1033:
        case 2057:
          {
            if (il.biff === 8 && (il.biff = {
              /*::[*/
              9: 2,
              /*::[*/
              521: 3,
              /*::[*/
              1033: 4
            }[zl] || {
              /*::[*/
              512: 2,
              /*::[*/
              768: 3,
              /*::[*/
              1024: 4,
              /*::[*/
              1280: 5,
              /*::[*/
              1536: 8,
              /*::[*/
              2: 2,
              /*::[*/
              7: 2
            }[vl.BIFFVer] || 8), il.biffguess = vl.BIFFVer == 0, vl.BIFFVer == 0 && vl.dt == 4096 && (il.biff = 5, Fl = !0, set_cp(il.codepage = 28591)), il.biff == 8 && vl.BIFFVer == 0 && vl.dt == 16 && (il.biff = 2), Sl++) break;
            if (qn = zn.dense ? [] : {}, il.biff < 8 && !Fl && (Fl = !0, set_cp(il.codepage = zn.codepage || 1252)), il.biff < 5 || vl.BIFFVer == 0 && vl.dt == 4096) {
              ba === "" && (ba = "Sheet1"), pa = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
              var yl = { pos: Xn.l - Zl, name: ba };
              Jo[yl.pos] = yl, il.snames.push(ba);
            } else ba = (Jo[Nl] || { name: "" }).name;
            vl.dt == 32 && (qn["!type"] = "chart"), vl.dt == 64 && (qn["!type"] = "macro"), ll = [], al = [], il.arrayf = Za = [], sl = [], dl = [], El = !1, tl = { Hidden: (Jo[Nl] || { hs: 0 }).hs, name: ba };
          }
          break;
        case 515:
        case 3:
        case 2:
          qn["!type"] == "chart" && (zn.dense ? (qn[vl.r] || [])[vl.c] : qn[encode_cell({ c: vl.c, r: vl.r })]) && ++vl.c, Na = { ixfe: vl.ixfe, XF: Ja[vl.ixfe] || {}, v: vl.val, t: "n" }, ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: vl.c, r: vl.r }, Na, zn);
          break;
        case 5:
        case 517:
          Na = { ixfe: vl.ixfe, XF: Ja[vl.ixfe], v: vl.val, t: vl.t }, ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: vl.c, r: vl.r }, Na, zn);
          break;
        case 638:
          Na = { ixfe: vl.ixfe, XF: Ja[vl.ixfe], v: vl.rknum, t: "n" }, ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: vl.c, r: vl.r }, Na, zn);
          break;
        case 189:
          for (var Rl = vl.c; Rl <= vl.C; ++Rl) {
            var Ul = vl.rkrec[Rl - vl.c][0];
            Na = { ixfe: Ul, XF: Ja[Ul], v: vl.rkrec[Rl - vl.c][1], t: "n" }, ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: Rl, r: vl.r }, Na, zn);
          }
          break;
        case 6:
        case 518:
        case 1030:
          {
            if (vl.val == "String") {
              ma = vl;
              break;
            }
            if (Na = make_cell(vl.val, vl.cell.ixfe, vl.tt), Na.XF = Ja[Na.ixfe], zn.cellFormula) {
              var hl = vl.formula;
              if (hl && hl[0] && hl[0][0] && hl[0][0][0] == "PtgExp") {
                var Cl = hl[0][0][1][0], Il = hl[0][0][1][1], Ll = encode_cell({ r: Cl, c: Il });
                ka[Ll] ? Na.f = "" + stringify_formula(vl.formula, pa, vl.cell, fl, il) : Na.F = ((zn.dense ? (qn[Cl] || [])[Il] : qn[Ll]) || {}).F;
              } else Na.f = "" + stringify_formula(vl.formula, pa, vl.cell, fl, il);
            }
            ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl(vl.cell, Na, zn), ma = vl;
          }
          break;
        case 7:
        case 519:
          if (ma)
            ma.val = vl, Na = make_cell(vl, ma.cell.ixfe, "s"), Na.XF = Ja[Na.ixfe], zn.cellFormula && (Na.f = "" + stringify_formula(ma.formula, pa, ma.cell, fl, il)), ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl(ma.cell, Na, zn), ma = null;
          else throw new Error("String record expects Formula");
          break;
        case 33:
        case 545:
          {
            Za.push(vl);
            var tc = encode_cell(vl[0].s);
            if (wa = zn.dense ? (qn[vl[0].s.r] || [])[vl[0].s.c] : qn[tc], zn.cellFormula && wa) {
              if (!ma || !tc || !wa) break;
              wa.f = "" + stringify_formula(vl[1], pa, vl[0], fl, il), wa.F = encode_range(vl[0]);
            }
          }
          break;
        case 1212:
          {
            if (!zn.cellFormula) break;
            if (xa) {
              if (!ma) break;
              ka[encode_cell(ma.cell)] = vl[0], wa = zn.dense ? (qn[ma.cell.r] || [])[ma.cell.c] : qn[encode_cell(ma.cell)], (wa || {}).f = "" + stringify_formula(vl[0], pa, ya, fl, il);
            }
          }
          break;
        case 253:
          Na = make_cell(va[vl.isst].t, vl.ixfe, "s"), va[vl.isst].h && (Na.h = va[vl.isst].h), Na.XF = Ja[Na.ixfe], ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: vl.c, r: vl.r }, Na, zn);
          break;
        case 513:
          zn.sheetStubs && (Na = { ixfe: vl.ixfe, XF: Ja[vl.ixfe], t: "z" }, ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: vl.c, r: vl.r }, Na, zn));
          break;
        case 190:
          if (zn.sheetStubs)
            for (var nc = vl.c; nc <= vl.C; ++nc) {
              var uc = vl.ixfe[nc - vl.c];
              Na = { ixfe: uc, XF: Ja[uc], t: "z" }, ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: nc, r: vl.r }, Na, zn);
            }
          break;
        case 214:
        case 516:
        case 4:
          Na = make_cell(vl.val, vl.ixfe, "s"), Na.XF = Ja[Na.ixfe], ml > 0 && (Na.z = Dl[Na.ixfe >> 8 & 63]), safe_format_xf(Na, zn, Un.opts.Date1904), rl({ c: vl.c, r: vl.r }, Na, zn);
          break;
        case 0:
        case 512:
          Sl === 1 && (pa = vl);
          break;
        case 252:
          va = vl;
          break;
        case 1054:
          if (il.biff == 4) {
            Dl[ml++] = vl[1];
            for (var _c = 0; _c < ml + 163 && table_fmt[_c] != vl[1]; ++_c) ;
            _c >= 163 && SSF_load(vl[1], ml + 163);
          } else SSF_load(vl[1], vl[0]);
          break;
        case 30:
          {
            Dl[ml++] = vl;
            for (var mc = 0; mc < ml + 163 && table_fmt[mc] != vl; ++mc) ;
            mc >= 163 && SSF_load(vl, ml + 163);
          }
          break;
        case 229:
          ll = ll.concat(vl);
          break;
        case 93:
          al[vl.cmo[0]] = il.lastobj = vl;
          break;
        case 438:
          il.lastobj.TxO = vl;
          break;
        case 127:
          il.lastobj.ImData = vl;
          break;
        case 440:
          for (Ma = vl[0].s.r; Ma <= vl[0].e.r; ++Ma)
            for (Sa = vl[0].s.c; Sa <= vl[0].e.c; ++Sa)
              wa = zn.dense ? (qn[Ma] || [])[Sa] : qn[encode_cell({ c: Sa, r: Ma })], wa && (wa.l = vl[1]);
          break;
        case 2048:
          for (Ma = vl[0].s.r; Ma <= vl[0].e.r; ++Ma)
            for (Sa = vl[0].s.c; Sa <= vl[0].e.c; ++Sa)
              wa = zn.dense ? (qn[Ma] || [])[Sa] : qn[encode_cell({ c: Sa, r: Ma })], wa && wa.l && (wa.l.Tooltip = vl[1]);
          break;
        case 28:
          {
            if (il.biff <= 5 && il.biff >= 2) break;
            wa = zn.dense ? (qn[vl[0].r] || [])[vl[0].c] : qn[encode_cell(vl[0])];
            var Sc = al[vl[2]];
            wa || (zn.dense ? (qn[vl[0].r] || (qn[vl[0].r] = []), wa = qn[vl[0].r][vl[0].c] = { t: "z" }) : wa = qn[encode_cell(vl[0])] = { t: "z" }, pa.e.r = Math.max(pa.e.r, vl[0].r), pa.s.r = Math.min(pa.s.r, vl[0].r), pa.e.c = Math.max(pa.e.c, vl[0].c), pa.s.c = Math.min(pa.s.c, vl[0].c)), wa.c || (wa.c = []), Ta = { a: vl[1], t: Sc.TxO.t }, wa.c.push(Ta);
          }
          break;
        case 2173:
          update_xfext(Ja[vl.ixfe], vl.ext);
          break;
        case 125:
          {
            if (!il.cellStyles) break;
            for (; vl.e >= vl.s; )
              sl[vl.e--] = { width: vl.w / 256, level: vl.level || 0, hidden: !!(vl.flags & 1) }, El || (El = !0, find_mdw_colw(vl.w / 256)), process_col(sl[vl.e + 1]);
          }
          break;
        case 520:
          {
            var hc = {};
            vl.level != null && (dl[vl.r] = hc, hc.level = vl.level), vl.hidden && (dl[vl.r] = hc, hc.hidden = !0), vl.hpt && (dl[vl.r] = hc, hc.hpt = vl.hpt, hc.hpx = pt2px(vl.hpt));
          }
          break;
        case 38:
        case 39:
        case 40:
        case 41:
          qn["!margins"] || default_margins(qn["!margins"] = {}), qn["!margins"][{ 38: "left", 39: "right", 40: "top", 41: "bottom" }[zl]] = vl;
          break;
        case 161:
          qn["!margins"] || default_margins(qn["!margins"] = {}), qn["!margins"].header = vl.header, qn["!margins"].footer = vl.footer;
          break;
        case 574:
          vl.RTL && (qa.Views[0].RTL = !0);
          break;
        case 146:
          el = vl;
          break;
        case 2198:
          cl = vl;
          break;
        case 140:
          Ka = vl;
          break;
        case 442:
          ba ? tl.CodeName = vl || tl.name : qa.WBProps.CodeName = vl || "ThisWorkbook";
          break;
      }
    } else
      kl || console.error("Missing Info for XLS Record 0x" + zl.toString(16)), Xn.l += Zl;
  }
  return Un.SheetNames = keys(Jo).sort(function(Lc, Ec) {
    return Number(Lc) - Number(Ec);
  }).map(function(Lc) {
    return Jo[Lc].name;
  }), zn.bookSheets || (Un.Sheets = Kn), !Un.SheetNames.length && _a["!ref"] ? (Un.SheetNames.push("Sheet1"), Un.Sheets && (Un.Sheets.Sheet1 = _a)) : Un.Preamble = _a, Un.Sheets && _l.forEach(function(Lc, Ec) {
    Un.Sheets[Un.SheetNames[Ec]]["!autofilter"] = Lc;
  }), Un.Strings = va, Un.SSF = dup(table_fmt), il.enc && (Un.Encryption = il.enc), cl && (Un.Themes = cl), Un.Metadata = {}, Ka !== void 0 && (Un.Metadata.Country = Ka), fl.names.length > 0 && (qa.Names = fl.names), Un.Workbook = qa, Un;
}
var PSCLSID = {
  SI: "e0859ff2f94f6810ab9108002b27b3d9",
  DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(Xn, zn, Un) {
  var Kn = CFB.find(Xn, "/!DocumentSummaryInformation");
  if (Kn && Kn.size > 0) try {
    var qn = parse_PropertySetStream(Kn, DocSummaryPIDDSI, PSCLSID.DSI);
    for (var Jo in qn) zn[Jo] = qn[Jo];
  } catch (ba) {
    if (Un.WTF) throw ba;
  }
  var pa = CFB.find(Xn, "/!SummaryInformation");
  if (pa && pa.size > 0) try {
    var ma = parse_PropertySetStream(pa, SummaryPIDSI, PSCLSID.SI);
    for (var va in ma) zn[va] == null && (zn[va] = ma[va]);
  } catch (ba) {
    if (Un.WTF) throw ba;
  }
  zn.HeadingPairs && zn.TitlesOfParts && (load_props_pairs(zn.HeadingPairs, zn.TitlesOfParts, zn, Un), delete zn.HeadingPairs, delete zn.TitlesOfParts);
}
function parse_xlscfb(Xn, zn) {
  zn || (zn = {}), fix_read_opts(zn), reset_cp(), zn.codepage && set_ansi(zn.codepage);
  var Un, Kn;
  if (Xn.FullPaths) {
    if (CFB.find(Xn, "/encryption")) throw new Error("File is password-protected");
    Un = CFB.find(Xn, "!CompObj"), Kn = CFB.find(Xn, "/Workbook") || CFB.find(Xn, "/Book");
  } else {
    switch (zn.type) {
      case "base64":
        Xn = s2a(Base64_decode(Xn));
        break;
      case "binary":
        Xn = s2a(Xn);
        break;
      case "buffer":
        break;
      case "array":
        Array.isArray(Xn) || (Xn = Array.prototype.slice.call(Xn));
        break;
    }
    prep_blob(Xn, 0), Kn = { content: Xn };
  }
  var qn, Jo;
  if (Un && parse_compobj(Un), zn.bookProps && !zn.bookSheets) qn = {};
  else {
    var pa = has_buf ? "buffer" : "array";
    if (Kn && Kn.content) qn = parse_workbook(Kn.content, zn);
    else if ((Jo = CFB.find(Xn, "PerfectOffice_MAIN")) && Jo.content) qn = WK_.to_workbook(Jo.content, (zn.type = pa, zn));
    else if ((Jo = CFB.find(Xn, "NativeContent_MAIN")) && Jo.content) qn = WK_.to_workbook(Jo.content, (zn.type = pa, zn));
    else throw (Jo = CFB.find(Xn, "MN0")) && Jo.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
    zn.bookVBA && Xn.FullPaths && CFB.find(Xn, "/_VBA_PROJECT_CUR/VBA/dir") && (qn.vbaraw = make_vba_xls(Xn));
  }
  var ma = {};
  return Xn.FullPaths && parse_xls_props(
    /*::((*/
    Xn,
    ma,
    zn
  ), qn.Props = qn.Custprops = ma, zn.bookFiles && (qn.cfb = Xn), qn;
}
var XLSBRecordEnum = {
  /*::[*/
  0: {
    /* n:"BrtRowHdr", */
    f: parse_BrtRowHdr
  },
  /*::[*/
  1: {
    /* n:"BrtCellBlank", */
    f: parse_BrtCellBlank
  },
  /*::[*/
  2: {
    /* n:"BrtCellRk", */
    f: parse_BrtCellRk
  },
  /*::[*/
  3: {
    /* n:"BrtCellError", */
    f: parse_BrtCellError
  },
  /*::[*/
  4: {
    /* n:"BrtCellBool", */
    f: parse_BrtCellBool
  },
  /*::[*/
  5: {
    /* n:"BrtCellReal", */
    f: parse_BrtCellReal
  },
  /*::[*/
  6: {
    /* n:"BrtCellSt", */
    f: parse_BrtCellSt
  },
  /*::[*/
  7: {
    /* n:"BrtCellIsst", */
    f: parse_BrtCellIsst
  },
  /*::[*/
  8: {
    /* n:"BrtFmlaString", */
    f: parse_BrtFmlaString
  },
  /*::[*/
  9: {
    /* n:"BrtFmlaNum", */
    f: parse_BrtFmlaNum
  },
  /*::[*/
  10: {
    /* n:"BrtFmlaBool", */
    f: parse_BrtFmlaBool
  },
  /*::[*/
  11: {
    /* n:"BrtFmlaError", */
    f: parse_BrtFmlaError
  },
  /*::[*/
  12: {
    /* n:"BrtShortBlank", */
    f: parse_BrtShortBlank
  },
  /*::[*/
  13: {
    /* n:"BrtShortRk", */
    f: parse_BrtShortRk
  },
  /*::[*/
  14: {
    /* n:"BrtShortError", */
    f: parse_BrtShortError
  },
  /*::[*/
  15: {
    /* n:"BrtShortBool", */
    f: parse_BrtShortBool
  },
  /*::[*/
  16: {
    /* n:"BrtShortReal", */
    f: parse_BrtShortReal
  },
  /*::[*/
  17: {
    /* n:"BrtShortSt", */
    f: parse_BrtShortSt
  },
  /*::[*/
  18: {
    /* n:"BrtShortIsst", */
    f: parse_BrtShortIsst
  },
  /*::[*/
  19: {
    /* n:"BrtSSTItem", */
    f: parse_RichStr
  },
  /*::[*/
  20: {
    /* n:"BrtPCDIMissing" */
  },
  /*::[*/
  21: {
    /* n:"BrtPCDINumber" */
  },
  /*::[*/
  22: {
    /* n:"BrtPCDIBoolean" */
  },
  /*::[*/
  23: {
    /* n:"BrtPCDIError" */
  },
  /*::[*/
  24: {
    /* n:"BrtPCDIString" */
  },
  /*::[*/
  25: {
    /* n:"BrtPCDIDatetime" */
  },
  /*::[*/
  26: {
    /* n:"BrtPCDIIndex" */
  },
  /*::[*/
  27: {
    /* n:"BrtPCDIAMissing" */
  },
  /*::[*/
  28: {
    /* n:"BrtPCDIANumber" */
  },
  /*::[*/
  29: {
    /* n:"BrtPCDIABoolean" */
  },
  /*::[*/
  30: {
    /* n:"BrtPCDIAError" */
  },
  /*::[*/
  31: {
    /* n:"BrtPCDIAString" */
  },
  /*::[*/
  32: {
    /* n:"BrtPCDIADatetime" */
  },
  /*::[*/
  33: {
    /* n:"BrtPCRRecord" */
  },
  /*::[*/
  34: {
    /* n:"BrtPCRRecordDt" */
  },
  /*::[*/
  35: {
    /* n:"BrtFRTBegin", */
    T: 1
  },
  /*::[*/
  36: {
    /* n:"BrtFRTEnd", */
    T: -1
  },
  /*::[*/
  37: {
    /* n:"BrtACBegin", */
    T: 1
  },
  /*::[*/
  38: {
    /* n:"BrtACEnd", */
    T: -1
  },
  /*::[*/
  39: {
    /* n:"BrtName", */
    f: parse_BrtName
  },
  /*::[*/
  40: {
    /* n:"BrtIndexRowBlock" */
  },
  /*::[*/
  42: {
    /* n:"BrtIndexBlock" */
  },
  /*::[*/
  43: {
    /* n:"BrtFont", */
    f: parse_BrtFont
  },
  /*::[*/
  44: {
    /* n:"BrtFmt", */
    f: parse_BrtFmt
  },
  /*::[*/
  45: {
    /* n:"BrtFill", */
    f: parse_BrtFill
  },
  /*::[*/
  46: {
    /* n:"BrtBorder", */
    f: parse_BrtBorder
  },
  /*::[*/
  47: {
    /* n:"BrtXF", */
    f: parse_BrtXF
  },
  /*::[*/
  48: {
    /* n:"BrtStyle" */
  },
  /*::[*/
  49: {
    /* n:"BrtCellMeta", */
    f: parse_Int32LE
  },
  /*::[*/
  50: {
    /* n:"BrtValueMeta" */
  },
  /*::[*/
  51: {
    /* n:"BrtMdb" */
    f: parse_BrtMdb
  },
  /*::[*/
  52: {
    /* n:"BrtBeginFmd", */
    T: 1
  },
  /*::[*/
  53: {
    /* n:"BrtEndFmd", */
    T: -1
  },
  /*::[*/
  54: {
    /* n:"BrtBeginMdx", */
    T: 1
  },
  /*::[*/
  55: {
    /* n:"BrtEndMdx", */
    T: -1
  },
  /*::[*/
  56: {
    /* n:"BrtBeginMdxTuple", */
    T: 1
  },
  /*::[*/
  57: {
    /* n:"BrtEndMdxTuple", */
    T: -1
  },
  /*::[*/
  58: {
    /* n:"BrtMdxMbrIstr" */
  },
  /*::[*/
  59: {
    /* n:"BrtStr" */
  },
  /*::[*/
  60: {
    /* n:"BrtColInfo", */
    f: parse_ColInfo
  },
  /*::[*/
  62: {
    /* n:"BrtCellRString", */
    f: parse_BrtCellRString
  },
  /*::[*/
  63: {
    /* n:"BrtCalcChainItem$", */
    f: parse_BrtCalcChainItem$
  },
  /*::[*/
  64: {
    /* n:"BrtDVal", */
    f: parse_BrtDVal
  },
  /*::[*/
  65: {
    /* n:"BrtSxvcellNum" */
  },
  /*::[*/
  66: {
    /* n:"BrtSxvcellStr" */
  },
  /*::[*/
  67: {
    /* n:"BrtSxvcellBool" */
  },
  /*::[*/
  68: {
    /* n:"BrtSxvcellErr" */
  },
  /*::[*/
  69: {
    /* n:"BrtSxvcellDate" */
  },
  /*::[*/
  70: {
    /* n:"BrtSxvcellNil" */
  },
  /*::[*/
  128: {
    /* n:"BrtFileVersion" */
  },
  /*::[*/
  129: {
    /* n:"BrtBeginSheet", */
    T: 1
  },
  /*::[*/
  130: {
    /* n:"BrtEndSheet", */
    T: -1
  },
  /*::[*/
  131: {
    /* n:"BrtBeginBook", */
    T: 1,
    f: parsenoop,
    p: 0
  },
  /*::[*/
  132: {
    /* n:"BrtEndBook", */
    T: -1
  },
  /*::[*/
  133: {
    /* n:"BrtBeginWsViews", */
    T: 1
  },
  /*::[*/
  134: {
    /* n:"BrtEndWsViews", */
    T: -1
  },
  /*::[*/
  135: {
    /* n:"BrtBeginBookViews", */
    T: 1
  },
  /*::[*/
  136: {
    /* n:"BrtEndBookViews", */
    T: -1
  },
  /*::[*/
  137: {
    /* n:"BrtBeginWsView", */
    T: 1,
    f: parse_BrtBeginWsView
  },
  /*::[*/
  138: {
    /* n:"BrtEndWsView", */
    T: -1
  },
  /*::[*/
  139: {
    /* n:"BrtBeginCsViews", */
    T: 1
  },
  /*::[*/
  140: {
    /* n:"BrtEndCsViews", */
    T: -1
  },
  /*::[*/
  141: {
    /* n:"BrtBeginCsView", */
    T: 1
  },
  /*::[*/
  142: {
    /* n:"BrtEndCsView", */
    T: -1
  },
  /*::[*/
  143: {
    /* n:"BrtBeginBundleShs", */
    T: 1
  },
  /*::[*/
  144: {
    /* n:"BrtEndBundleShs", */
    T: -1
  },
  /*::[*/
  145: {
    /* n:"BrtBeginSheetData", */
    T: 1
  },
  /*::[*/
  146: {
    /* n:"BrtEndSheetData", */
    T: -1
  },
  /*::[*/
  147: {
    /* n:"BrtWsProp", */
    f: parse_BrtWsProp
  },
  /*::[*/
  148: {
    /* n:"BrtWsDim", */
    f: parse_BrtWsDim,
    p: 16
  },
  /*::[*/
  151: {
    /* n:"BrtPane", */
    f: parse_BrtPane
  },
  /*::[*/
  152: {
    /* n:"BrtSel" */
  },
  /*::[*/
  153: {
    /* n:"BrtWbProp", */
    f: parse_BrtWbProp
  },
  /*::[*/
  154: {
    /* n:"BrtWbFactoid" */
  },
  /*::[*/
  155: {
    /* n:"BrtFileRecover" */
  },
  /*::[*/
  156: {
    /* n:"BrtBundleSh", */
    f: parse_BrtBundleSh
  },
  /*::[*/
  157: {
    /* n:"BrtCalcProp" */
  },
  /*::[*/
  158: {
    /* n:"BrtBookView" */
  },
  /*::[*/
  159: {
    /* n:"BrtBeginSst", */
    T: 1,
    f: parse_BrtBeginSst
  },
  /*::[*/
  160: {
    /* n:"BrtEndSst", */
    T: -1
  },
  /*::[*/
  161: {
    /* n:"BrtBeginAFilter", */
    T: 1,
    f: parse_UncheckedRfX
  },
  /*::[*/
  162: {
    /* n:"BrtEndAFilter", */
    T: -1
  },
  /*::[*/
  163: {
    /* n:"BrtBeginFilterColumn", */
    T: 1
  },
  /*::[*/
  164: {
    /* n:"BrtEndFilterColumn", */
    T: -1
  },
  /*::[*/
  165: {
    /* n:"BrtBeginFilters", */
    T: 1
  },
  /*::[*/
  166: {
    /* n:"BrtEndFilters", */
    T: -1
  },
  /*::[*/
  167: {
    /* n:"BrtFilter" */
  },
  /*::[*/
  168: {
    /* n:"BrtColorFilter" */
  },
  /*::[*/
  169: {
    /* n:"BrtIconFilter" */
  },
  /*::[*/
  170: {
    /* n:"BrtTop10Filter" */
  },
  /*::[*/
  171: {
    /* n:"BrtDynamicFilter" */
  },
  /*::[*/
  172: {
    /* n:"BrtBeginCustomFilters", */
    T: 1
  },
  /*::[*/
  173: {
    /* n:"BrtEndCustomFilters", */
    T: -1
  },
  /*::[*/
  174: {
    /* n:"BrtCustomFilter" */
  },
  /*::[*/
  175: {
    /* n:"BrtAFilterDateGroupItem" */
  },
  /*::[*/
  176: {
    /* n:"BrtMergeCell", */
    f: parse_BrtMergeCell
  },
  /*::[*/
  177: {
    /* n:"BrtBeginMergeCells", */
    T: 1
  },
  /*::[*/
  178: {
    /* n:"BrtEndMergeCells", */
    T: -1
  },
  /*::[*/
  179: {
    /* n:"BrtBeginPivotCacheDef", */
    T: 1
  },
  /*::[*/
  180: {
    /* n:"BrtEndPivotCacheDef", */
    T: -1
  },
  /*::[*/
  181: {
    /* n:"BrtBeginPCDFields", */
    T: 1
  },
  /*::[*/
  182: {
    /* n:"BrtEndPCDFields", */
    T: -1
  },
  /*::[*/
  183: {
    /* n:"BrtBeginPCDField", */
    T: 1
  },
  /*::[*/
  184: {
    /* n:"BrtEndPCDField", */
    T: -1
  },
  /*::[*/
  185: {
    /* n:"BrtBeginPCDSource", */
    T: 1
  },
  /*::[*/
  186: {
    /* n:"BrtEndPCDSource", */
    T: -1
  },
  /*::[*/
  187: {
    /* n:"BrtBeginPCDSRange", */
    T: 1
  },
  /*::[*/
  188: {
    /* n:"BrtEndPCDSRange", */
    T: -1
  },
  /*::[*/
  189: {
    /* n:"BrtBeginPCDFAtbl", */
    T: 1
  },
  /*::[*/
  190: {
    /* n:"BrtEndPCDFAtbl", */
    T: -1
  },
  /*::[*/
  191: {
    /* n:"BrtBeginPCDIRun", */
    T: 1
  },
  /*::[*/
  192: {
    /* n:"BrtEndPCDIRun", */
    T: -1
  },
  /*::[*/
  193: {
    /* n:"BrtBeginPivotCacheRecords", */
    T: 1
  },
  /*::[*/
  194: {
    /* n:"BrtEndPivotCacheRecords", */
    T: -1
  },
  /*::[*/
  195: {
    /* n:"BrtBeginPCDHierarchies", */
    T: 1
  },
  /*::[*/
  196: {
    /* n:"BrtEndPCDHierarchies", */
    T: -1
  },
  /*::[*/
  197: {
    /* n:"BrtBeginPCDHierarchy", */
    T: 1
  },
  /*::[*/
  198: {
    /* n:"BrtEndPCDHierarchy", */
    T: -1
  },
  /*::[*/
  199: {
    /* n:"BrtBeginPCDHFieldsUsage", */
    T: 1
  },
  /*::[*/
  200: {
    /* n:"BrtEndPCDHFieldsUsage", */
    T: -1
  },
  /*::[*/
  201: {
    /* n:"BrtBeginExtConnection", */
    T: 1
  },
  /*::[*/
  202: {
    /* n:"BrtEndExtConnection", */
    T: -1
  },
  /*::[*/
  203: {
    /* n:"BrtBeginECDbProps", */
    T: 1
  },
  /*::[*/
  204: {
    /* n:"BrtEndECDbProps", */
    T: -1
  },
  /*::[*/
  205: {
    /* n:"BrtBeginECOlapProps", */
    T: 1
  },
  /*::[*/
  206: {
    /* n:"BrtEndECOlapProps", */
    T: -1
  },
  /*::[*/
  207: {
    /* n:"BrtBeginPCDSConsol", */
    T: 1
  },
  /*::[*/
  208: {
    /* n:"BrtEndPCDSConsol", */
    T: -1
  },
  /*::[*/
  209: {
    /* n:"BrtBeginPCDSCPages", */
    T: 1
  },
  /*::[*/
  210: {
    /* n:"BrtEndPCDSCPages", */
    T: -1
  },
  /*::[*/
  211: {
    /* n:"BrtBeginPCDSCPage", */
    T: 1
  },
  /*::[*/
  212: {
    /* n:"BrtEndPCDSCPage", */
    T: -1
  },
  /*::[*/
  213: {
    /* n:"BrtBeginPCDSCPItem", */
    T: 1
  },
  /*::[*/
  214: {
    /* n:"BrtEndPCDSCPItem", */
    T: -1
  },
  /*::[*/
  215: {
    /* n:"BrtBeginPCDSCSets", */
    T: 1
  },
  /*::[*/
  216: {
    /* n:"BrtEndPCDSCSets", */
    T: -1
  },
  /*::[*/
  217: {
    /* n:"BrtBeginPCDSCSet", */
    T: 1
  },
  /*::[*/
  218: {
    /* n:"BrtEndPCDSCSet", */
    T: -1
  },
  /*::[*/
  219: {
    /* n:"BrtBeginPCDFGroup", */
    T: 1
  },
  /*::[*/
  220: {
    /* n:"BrtEndPCDFGroup", */
    T: -1
  },
  /*::[*/
  221: {
    /* n:"BrtBeginPCDFGItems", */
    T: 1
  },
  /*::[*/
  222: {
    /* n:"BrtEndPCDFGItems", */
    T: -1
  },
  /*::[*/
  223: {
    /* n:"BrtBeginPCDFGRange", */
    T: 1
  },
  /*::[*/
  224: {
    /* n:"BrtEndPCDFGRange", */
    T: -1
  },
  /*::[*/
  225: {
    /* n:"BrtBeginPCDFGDiscrete", */
    T: 1
  },
  /*::[*/
  226: {
    /* n:"BrtEndPCDFGDiscrete", */
    T: -1
  },
  /*::[*/
  227: {
    /* n:"BrtBeginPCDSDTupleCache", */
    T: 1
  },
  /*::[*/
  228: {
    /* n:"BrtEndPCDSDTupleCache", */
    T: -1
  },
  /*::[*/
  229: {
    /* n:"BrtBeginPCDSDTCEntries", */
    T: 1
  },
  /*::[*/
  230: {
    /* n:"BrtEndPCDSDTCEntries", */
    T: -1
  },
  /*::[*/
  231: {
    /* n:"BrtBeginPCDSDTCEMembers", */
    T: 1
  },
  /*::[*/
  232: {
    /* n:"BrtEndPCDSDTCEMembers", */
    T: -1
  },
  /*::[*/
  233: {
    /* n:"BrtBeginPCDSDTCEMember", */
    T: 1
  },
  /*::[*/
  234: {
    /* n:"BrtEndPCDSDTCEMember", */
    T: -1
  },
  /*::[*/
  235: {
    /* n:"BrtBeginPCDSDTCQueries", */
    T: 1
  },
  /*::[*/
  236: {
    /* n:"BrtEndPCDSDTCQueries", */
    T: -1
  },
  /*::[*/
  237: {
    /* n:"BrtBeginPCDSDTCQuery", */
    T: 1
  },
  /*::[*/
  238: {
    /* n:"BrtEndPCDSDTCQuery", */
    T: -1
  },
  /*::[*/
  239: {
    /* n:"BrtBeginPCDSDTCSets", */
    T: 1
  },
  /*::[*/
  240: {
    /* n:"BrtEndPCDSDTCSets", */
    T: -1
  },
  /*::[*/
  241: {
    /* n:"BrtBeginPCDSDTCSet", */
    T: 1
  },
  /*::[*/
  242: {
    /* n:"BrtEndPCDSDTCSet", */
    T: -1
  },
  /*::[*/
  243: {
    /* n:"BrtBeginPCDCalcItems", */
    T: 1
  },
  /*::[*/
  244: {
    /* n:"BrtEndPCDCalcItems", */
    T: -1
  },
  /*::[*/
  245: {
    /* n:"BrtBeginPCDCalcItem", */
    T: 1
  },
  /*::[*/
  246: {
    /* n:"BrtEndPCDCalcItem", */
    T: -1
  },
  /*::[*/
  247: {
    /* n:"BrtBeginPRule", */
    T: 1
  },
  /*::[*/
  248: {
    /* n:"BrtEndPRule", */
    T: -1
  },
  /*::[*/
  249: {
    /* n:"BrtBeginPRFilters", */
    T: 1
  },
  /*::[*/
  250: {
    /* n:"BrtEndPRFilters", */
    T: -1
  },
  /*::[*/
  251: {
    /* n:"BrtBeginPRFilter", */
    T: 1
  },
  /*::[*/
  252: {
    /* n:"BrtEndPRFilter", */
    T: -1
  },
  /*::[*/
  253: {
    /* n:"BrtBeginPNames", */
    T: 1
  },
  /*::[*/
  254: {
    /* n:"BrtEndPNames", */
    T: -1
  },
  /*::[*/
  255: {
    /* n:"BrtBeginPName", */
    T: 1
  },
  /*::[*/
  256: {
    /* n:"BrtEndPName", */
    T: -1
  },
  /*::[*/
  257: {
    /* n:"BrtBeginPNPairs", */
    T: 1
  },
  /*::[*/
  258: {
    /* n:"BrtEndPNPairs", */
    T: -1
  },
  /*::[*/
  259: {
    /* n:"BrtBeginPNPair", */
    T: 1
  },
  /*::[*/
  260: {
    /* n:"BrtEndPNPair", */
    T: -1
  },
  /*::[*/
  261: {
    /* n:"BrtBeginECWebProps", */
    T: 1
  },
  /*::[*/
  262: {
    /* n:"BrtEndECWebProps", */
    T: -1
  },
  /*::[*/
  263: {
    /* n:"BrtBeginEcWpTables", */
    T: 1
  },
  /*::[*/
  264: {
    /* n:"BrtEndECWPTables", */
    T: -1
  },
  /*::[*/
  265: {
    /* n:"BrtBeginECParams", */
    T: 1
  },
  /*::[*/
  266: {
    /* n:"BrtEndECParams", */
    T: -1
  },
  /*::[*/
  267: {
    /* n:"BrtBeginECParam", */
    T: 1
  },
  /*::[*/
  268: {
    /* n:"BrtEndECParam", */
    T: -1
  },
  /*::[*/
  269: {
    /* n:"BrtBeginPCDKPIs", */
    T: 1
  },
  /*::[*/
  270: {
    /* n:"BrtEndPCDKPIs", */
    T: -1
  },
  /*::[*/
  271: {
    /* n:"BrtBeginPCDKPI", */
    T: 1
  },
  /*::[*/
  272: {
    /* n:"BrtEndPCDKPI", */
    T: -1
  },
  /*::[*/
  273: {
    /* n:"BrtBeginDims", */
    T: 1
  },
  /*::[*/
  274: {
    /* n:"BrtEndDims", */
    T: -1
  },
  /*::[*/
  275: {
    /* n:"BrtBeginDim", */
    T: 1
  },
  /*::[*/
  276: {
    /* n:"BrtEndDim", */
    T: -1
  },
  /*::[*/
  277: {
    /* n:"BrtIndexPartEnd" */
  },
  /*::[*/
  278: {
    /* n:"BrtBeginStyleSheet", */
    T: 1
  },
  /*::[*/
  279: {
    /* n:"BrtEndStyleSheet", */
    T: -1
  },
  /*::[*/
  280: {
    /* n:"BrtBeginSXView", */
    T: 1
  },
  /*::[*/
  281: {
    /* n:"BrtEndSXVI", */
    T: -1
  },
  /*::[*/
  282: {
    /* n:"BrtBeginSXVI", */
    T: 1
  },
  /*::[*/
  283: {
    /* n:"BrtBeginSXVIs", */
    T: 1
  },
  /*::[*/
  284: {
    /* n:"BrtEndSXVIs", */
    T: -1
  },
  /*::[*/
  285: {
    /* n:"BrtBeginSXVD", */
    T: 1
  },
  /*::[*/
  286: {
    /* n:"BrtEndSXVD", */
    T: -1
  },
  /*::[*/
  287: {
    /* n:"BrtBeginSXVDs", */
    T: 1
  },
  /*::[*/
  288: {
    /* n:"BrtEndSXVDs", */
    T: -1
  },
  /*::[*/
  289: {
    /* n:"BrtBeginSXPI", */
    T: 1
  },
  /*::[*/
  290: {
    /* n:"BrtEndSXPI", */
    T: -1
  },
  /*::[*/
  291: {
    /* n:"BrtBeginSXPIs", */
    T: 1
  },
  /*::[*/
  292: {
    /* n:"BrtEndSXPIs", */
    T: -1
  },
  /*::[*/
  293: {
    /* n:"BrtBeginSXDI", */
    T: 1
  },
  /*::[*/
  294: {
    /* n:"BrtEndSXDI", */
    T: -1
  },
  /*::[*/
  295: {
    /* n:"BrtBeginSXDIs", */
    T: 1
  },
  /*::[*/
  296: {
    /* n:"BrtEndSXDIs", */
    T: -1
  },
  /*::[*/
  297: {
    /* n:"BrtBeginSXLI", */
    T: 1
  },
  /*::[*/
  298: {
    /* n:"BrtEndSXLI", */
    T: -1
  },
  /*::[*/
  299: {
    /* n:"BrtBeginSXLIRws", */
    T: 1
  },
  /*::[*/
  300: {
    /* n:"BrtEndSXLIRws", */
    T: -1
  },
  /*::[*/
  301: {
    /* n:"BrtBeginSXLICols", */
    T: 1
  },
  /*::[*/
  302: {
    /* n:"BrtEndSXLICols", */
    T: -1
  },
  /*::[*/
  303: {
    /* n:"BrtBeginSXFormat", */
    T: 1
  },
  /*::[*/
  304: {
    /* n:"BrtEndSXFormat", */
    T: -1
  },
  /*::[*/
  305: {
    /* n:"BrtBeginSXFormats", */
    T: 1
  },
  /*::[*/
  306: {
    /* n:"BrtEndSxFormats", */
    T: -1
  },
  /*::[*/
  307: {
    /* n:"BrtBeginSxSelect", */
    T: 1
  },
  /*::[*/
  308: {
    /* n:"BrtEndSxSelect", */
    T: -1
  },
  /*::[*/
  309: {
    /* n:"BrtBeginISXVDRws", */
    T: 1
  },
  /*::[*/
  310: {
    /* n:"BrtEndISXVDRws", */
    T: -1
  },
  /*::[*/
  311: {
    /* n:"BrtBeginISXVDCols", */
    T: 1
  },
  /*::[*/
  312: {
    /* n:"BrtEndISXVDCols", */
    T: -1
  },
  /*::[*/
  313: {
    /* n:"BrtEndSXLocation", */
    T: -1
  },
  /*::[*/
  314: {
    /* n:"BrtBeginSXLocation", */
    T: 1
  },
  /*::[*/
  315: {
    /* n:"BrtEndSXView", */
    T: -1
  },
  /*::[*/
  316: {
    /* n:"BrtBeginSXTHs", */
    T: 1
  },
  /*::[*/
  317: {
    /* n:"BrtEndSXTHs", */
    T: -1
  },
  /*::[*/
  318: {
    /* n:"BrtBeginSXTH", */
    T: 1
  },
  /*::[*/
  319: {
    /* n:"BrtEndSXTH", */
    T: -1
  },
  /*::[*/
  320: {
    /* n:"BrtBeginISXTHRws", */
    T: 1
  },
  /*::[*/
  321: {
    /* n:"BrtEndISXTHRws", */
    T: -1
  },
  /*::[*/
  322: {
    /* n:"BrtBeginISXTHCols", */
    T: 1
  },
  /*::[*/
  323: {
    /* n:"BrtEndISXTHCols", */
    T: -1
  },
  /*::[*/
  324: {
    /* n:"BrtBeginSXTDMPS", */
    T: 1
  },
  /*::[*/
  325: {
    /* n:"BrtEndSXTDMPs", */
    T: -1
  },
  /*::[*/
  326: {
    /* n:"BrtBeginSXTDMP", */
    T: 1
  },
  /*::[*/
  327: {
    /* n:"BrtEndSXTDMP", */
    T: -1
  },
  /*::[*/
  328: {
    /* n:"BrtBeginSXTHItems", */
    T: 1
  },
  /*::[*/
  329: {
    /* n:"BrtEndSXTHItems", */
    T: -1
  },
  /*::[*/
  330: {
    /* n:"BrtBeginSXTHItem", */
    T: 1
  },
  /*::[*/
  331: {
    /* n:"BrtEndSXTHItem", */
    T: -1
  },
  /*::[*/
  332: {
    /* n:"BrtBeginMetadata", */
    T: 1
  },
  /*::[*/
  333: {
    /* n:"BrtEndMetadata", */
    T: -1
  },
  /*::[*/
  334: {
    /* n:"BrtBeginEsmdtinfo", */
    T: 1
  },
  /*::[*/
  335: {
    /* n:"BrtMdtinfo", */
    f: parse_BrtMdtinfo
  },
  /*::[*/
  336: {
    /* n:"BrtEndEsmdtinfo", */
    T: -1
  },
  /*::[*/
  337: {
    /* n:"BrtBeginEsmdb", */
    f: parse_BrtBeginEsmdb,
    T: 1
  },
  /*::[*/
  338: {
    /* n:"BrtEndEsmdb", */
    T: -1
  },
  /*::[*/
  339: {
    /* n:"BrtBeginEsfmd", */
    T: 1
  },
  /*::[*/
  340: {
    /* n:"BrtEndEsfmd", */
    T: -1
  },
  /*::[*/
  341: {
    /* n:"BrtBeginSingleCells", */
    T: 1
  },
  /*::[*/
  342: {
    /* n:"BrtEndSingleCells", */
    T: -1
  },
  /*::[*/
  343: {
    /* n:"BrtBeginList", */
    T: 1
  },
  /*::[*/
  344: {
    /* n:"BrtEndList", */
    T: -1
  },
  /*::[*/
  345: {
    /* n:"BrtBeginListCols", */
    T: 1
  },
  /*::[*/
  346: {
    /* n:"BrtEndListCols", */
    T: -1
  },
  /*::[*/
  347: {
    /* n:"BrtBeginListCol", */
    T: 1
  },
  /*::[*/
  348: {
    /* n:"BrtEndListCol", */
    T: -1
  },
  /*::[*/
  349: {
    /* n:"BrtBeginListXmlCPr", */
    T: 1
  },
  /*::[*/
  350: {
    /* n:"BrtEndListXmlCPr", */
    T: -1
  },
  /*::[*/
  351: {
    /* n:"BrtListCCFmla" */
  },
  /*::[*/
  352: {
    /* n:"BrtListTrFmla" */
  },
  /*::[*/
  353: {
    /* n:"BrtBeginExternals", */
    T: 1
  },
  /*::[*/
  354: {
    /* n:"BrtEndExternals", */
    T: -1
  },
  /*::[*/
  355: {
    /* n:"BrtSupBookSrc", */
    f: parse_RelID
  },
  /*::[*/
  357: {
    /* n:"BrtSupSelf" */
  },
  /*::[*/
  358: {
    /* n:"BrtSupSame" */
  },
  /*::[*/
  359: {
    /* n:"BrtSupTabs" */
  },
  /*::[*/
  360: {
    /* n:"BrtBeginSupBook", */
    T: 1
  },
  /*::[*/
  361: {
    /* n:"BrtPlaceholderName" */
  },
  /*::[*/
  362: {
    /* n:"BrtExternSheet", */
    f: parse_ExternSheet
  },
  /*::[*/
  363: {
    /* n:"BrtExternTableStart" */
  },
  /*::[*/
  364: {
    /* n:"BrtExternTableEnd" */
  },
  /*::[*/
  366: {
    /* n:"BrtExternRowHdr" */
  },
  /*::[*/
  367: {
    /* n:"BrtExternCellBlank" */
  },
  /*::[*/
  368: {
    /* n:"BrtExternCellReal" */
  },
  /*::[*/
  369: {
    /* n:"BrtExternCellBool" */
  },
  /*::[*/
  370: {
    /* n:"BrtExternCellError" */
  },
  /*::[*/
  371: {
    /* n:"BrtExternCellString" */
  },
  /*::[*/
  372: {
    /* n:"BrtBeginEsmdx", */
    T: 1
  },
  /*::[*/
  373: {
    /* n:"BrtEndEsmdx", */
    T: -1
  },
  /*::[*/
  374: {
    /* n:"BrtBeginMdxSet", */
    T: 1
  },
  /*::[*/
  375: {
    /* n:"BrtEndMdxSet", */
    T: -1
  },
  /*::[*/
  376: {
    /* n:"BrtBeginMdxMbrProp", */
    T: 1
  },
  /*::[*/
  377: {
    /* n:"BrtEndMdxMbrProp", */
    T: -1
  },
  /*::[*/
  378: {
    /* n:"BrtBeginMdxKPI", */
    T: 1
  },
  /*::[*/
  379: {
    /* n:"BrtEndMdxKPI", */
    T: -1
  },
  /*::[*/
  380: {
    /* n:"BrtBeginEsstr", */
    T: 1
  },
  /*::[*/
  381: {
    /* n:"BrtEndEsstr", */
    T: -1
  },
  /*::[*/
  382: {
    /* n:"BrtBeginPRFItem", */
    T: 1
  },
  /*::[*/
  383: {
    /* n:"BrtEndPRFItem", */
    T: -1
  },
  /*::[*/
  384: {
    /* n:"BrtBeginPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  385: {
    /* n:"BrtEndPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  386: {
    /* n:"BrtBeginPivotCacheID", */
    T: 1
  },
  /*::[*/
  387: {
    /* n:"BrtEndPivotCacheID", */
    T: -1
  },
  /*::[*/
  388: {
    /* n:"BrtBeginISXVIs", */
    T: 1
  },
  /*::[*/
  389: {
    /* n:"BrtEndISXVIs", */
    T: -1
  },
  /*::[*/
  390: {
    /* n:"BrtBeginColInfos", */
    T: 1
  },
  /*::[*/
  391: {
    /* n:"BrtEndColInfos", */
    T: -1
  },
  /*::[*/
  392: {
    /* n:"BrtBeginRwBrk", */
    T: 1
  },
  /*::[*/
  393: {
    /* n:"BrtEndRwBrk", */
    T: -1
  },
  /*::[*/
  394: {
    /* n:"BrtBeginColBrk", */
    T: 1
  },
  /*::[*/
  395: {
    /* n:"BrtEndColBrk", */
    T: -1
  },
  /*::[*/
  396: {
    /* n:"BrtBrk" */
  },
  /*::[*/
  397: {
    /* n:"BrtUserBookView" */
  },
  /*::[*/
  398: {
    /* n:"BrtInfo" */
  },
  /*::[*/
  399: {
    /* n:"BrtCUsr" */
  },
  /*::[*/
  400: {
    /* n:"BrtUsr" */
  },
  /*::[*/
  401: {
    /* n:"BrtBeginUsers", */
    T: 1
  },
  /*::[*/
  403: {
    /* n:"BrtEOF" */
  },
  /*::[*/
  404: {
    /* n:"BrtUCR" */
  },
  /*::[*/
  405: {
    /* n:"BrtRRInsDel" */
  },
  /*::[*/
  406: {
    /* n:"BrtRREndInsDel" */
  },
  /*::[*/
  407: {
    /* n:"BrtRRMove" */
  },
  /*::[*/
  408: {
    /* n:"BrtRREndMove" */
  },
  /*::[*/
  409: {
    /* n:"BrtRRChgCell" */
  },
  /*::[*/
  410: {
    /* n:"BrtRREndChgCell" */
  },
  /*::[*/
  411: {
    /* n:"BrtRRHeader" */
  },
  /*::[*/
  412: {
    /* n:"BrtRRUserView" */
  },
  /*::[*/
  413: {
    /* n:"BrtRRRenSheet" */
  },
  /*::[*/
  414: {
    /* n:"BrtRRInsertSh" */
  },
  /*::[*/
  415: {
    /* n:"BrtRRDefName" */
  },
  /*::[*/
  416: {
    /* n:"BrtRRNote" */
  },
  /*::[*/
  417: {
    /* n:"BrtRRConflict" */
  },
  /*::[*/
  418: {
    /* n:"BrtRRTQSIF" */
  },
  /*::[*/
  419: {
    /* n:"BrtRRFormat" */
  },
  /*::[*/
  420: {
    /* n:"BrtRREndFormat" */
  },
  /*::[*/
  421: {
    /* n:"BrtRRAutoFmt" */
  },
  /*::[*/
  422: {
    /* n:"BrtBeginUserShViews", */
    T: 1
  },
  /*::[*/
  423: {
    /* n:"BrtBeginUserShView", */
    T: 1
  },
  /*::[*/
  424: {
    /* n:"BrtEndUserShView", */
    T: -1
  },
  /*::[*/
  425: {
    /* n:"BrtEndUserShViews", */
    T: -1
  },
  /*::[*/
  426: {
    /* n:"BrtArrFmla", */
    f: parse_BrtArrFmla
  },
  /*::[*/
  427: {
    /* n:"BrtShrFmla", */
    f: parse_BrtShrFmla
  },
  /*::[*/
  428: {
    /* n:"BrtTable" */
  },
  /*::[*/
  429: {
    /* n:"BrtBeginExtConnections", */
    T: 1
  },
  /*::[*/
  430: {
    /* n:"BrtEndExtConnections", */
    T: -1
  },
  /*::[*/
  431: {
    /* n:"BrtBeginPCDCalcMems", */
    T: 1
  },
  /*::[*/
  432: {
    /* n:"BrtEndPCDCalcMems", */
    T: -1
  },
  /*::[*/
  433: {
    /* n:"BrtBeginPCDCalcMem", */
    T: 1
  },
  /*::[*/
  434: {
    /* n:"BrtEndPCDCalcMem", */
    T: -1
  },
  /*::[*/
  435: {
    /* n:"BrtBeginPCDHGLevels", */
    T: 1
  },
  /*::[*/
  436: {
    /* n:"BrtEndPCDHGLevels", */
    T: -1
  },
  /*::[*/
  437: {
    /* n:"BrtBeginPCDHGLevel", */
    T: 1
  },
  /*::[*/
  438: {
    /* n:"BrtEndPCDHGLevel", */
    T: -1
  },
  /*::[*/
  439: {
    /* n:"BrtBeginPCDHGLGroups", */
    T: 1
  },
  /*::[*/
  440: {
    /* n:"BrtEndPCDHGLGroups", */
    T: -1
  },
  /*::[*/
  441: {
    /* n:"BrtBeginPCDHGLGroup", */
    T: 1
  },
  /*::[*/
  442: {
    /* n:"BrtEndPCDHGLGroup", */
    T: -1
  },
  /*::[*/
  443: {
    /* n:"BrtBeginPCDHGLGMembers", */
    T: 1
  },
  /*::[*/
  444: {
    /* n:"BrtEndPCDHGLGMembers", */
    T: -1
  },
  /*::[*/
  445: {
    /* n:"BrtBeginPCDHGLGMember", */
    T: 1
  },
  /*::[*/
  446: {
    /* n:"BrtEndPCDHGLGMember", */
    T: -1
  },
  /*::[*/
  447: {
    /* n:"BrtBeginQSI", */
    T: 1
  },
  /*::[*/
  448: {
    /* n:"BrtEndQSI", */
    T: -1
  },
  /*::[*/
  449: {
    /* n:"BrtBeginQSIR", */
    T: 1
  },
  /*::[*/
  450: {
    /* n:"BrtEndQSIR", */
    T: -1
  },
  /*::[*/
  451: {
    /* n:"BrtBeginDeletedNames", */
    T: 1
  },
  /*::[*/
  452: {
    /* n:"BrtEndDeletedNames", */
    T: -1
  },
  /*::[*/
  453: {
    /* n:"BrtBeginDeletedName", */
    T: 1
  },
  /*::[*/
  454: {
    /* n:"BrtEndDeletedName", */
    T: -1
  },
  /*::[*/
  455: {
    /* n:"BrtBeginQSIFs", */
    T: 1
  },
  /*::[*/
  456: {
    /* n:"BrtEndQSIFs", */
    T: -1
  },
  /*::[*/
  457: {
    /* n:"BrtBeginQSIF", */
    T: 1
  },
  /*::[*/
  458: {
    /* n:"BrtEndQSIF", */
    T: -1
  },
  /*::[*/
  459: {
    /* n:"BrtBeginAutoSortScope", */
    T: 1
  },
  /*::[*/
  460: {
    /* n:"BrtEndAutoSortScope", */
    T: -1
  },
  /*::[*/
  461: {
    /* n:"BrtBeginConditionalFormatting", */
    T: 1
  },
  /*::[*/
  462: {
    /* n:"BrtEndConditionalFormatting", */
    T: -1
  },
  /*::[*/
  463: {
    /* n:"BrtBeginCFRule", */
    T: 1
  },
  /*::[*/
  464: {
    /* n:"BrtEndCFRule", */
    T: -1
  },
  /*::[*/
  465: {
    /* n:"BrtBeginIconSet", */
    T: 1
  },
  /*::[*/
  466: {
    /* n:"BrtEndIconSet", */
    T: -1
  },
  /*::[*/
  467: {
    /* n:"BrtBeginDatabar", */
    T: 1
  },
  /*::[*/
  468: {
    /* n:"BrtEndDatabar", */
    T: -1
  },
  /*::[*/
  469: {
    /* n:"BrtBeginColorScale", */
    T: 1
  },
  /*::[*/
  470: {
    /* n:"BrtEndColorScale", */
    T: -1
  },
  /*::[*/
  471: {
    /* n:"BrtCFVO" */
  },
  /*::[*/
  472: {
    /* n:"BrtExternValueMeta" */
  },
  /*::[*/
  473: {
    /* n:"BrtBeginColorPalette", */
    T: 1
  },
  /*::[*/
  474: {
    /* n:"BrtEndColorPalette", */
    T: -1
  },
  /*::[*/
  475: {
    /* n:"BrtIndexedColor" */
  },
  /*::[*/
  476: {
    /* n:"BrtMargins", */
    f: parse_BrtMargins
  },
  /*::[*/
  477: {
    /* n:"BrtPrintOptions" */
  },
  /*::[*/
  478: {
    /* n:"BrtPageSetup" */
  },
  /*::[*/
  479: {
    /* n:"BrtBeginHeaderFooter", */
    T: 1
  },
  /*::[*/
  480: {
    /* n:"BrtEndHeaderFooter", */
    T: -1
  },
  /*::[*/
  481: {
    /* n:"BrtBeginSXCrtFormat", */
    T: 1
  },
  /*::[*/
  482: {
    /* n:"BrtEndSXCrtFormat", */
    T: -1
  },
  /*::[*/
  483: {
    /* n:"BrtBeginSXCrtFormats", */
    T: 1
  },
  /*::[*/
  484: {
    /* n:"BrtEndSXCrtFormats", */
    T: -1
  },
  /*::[*/
  485: {
    /* n:"BrtWsFmtInfo", */
    f: parse_BrtWsFmtInfo
  },
  /*::[*/
  486: {
    /* n:"BrtBeginMgs", */
    T: 1
  },
  /*::[*/
  487: {
    /* n:"BrtEndMGs", */
    T: -1
  },
  /*::[*/
  488: {
    /* n:"BrtBeginMGMaps", */
    T: 1
  },
  /*::[*/
  489: {
    /* n:"BrtEndMGMaps", */
    T: -1
  },
  /*::[*/
  490: {
    /* n:"BrtBeginMG", */
    T: 1
  },
  /*::[*/
  491: {
    /* n:"BrtEndMG", */
    T: -1
  },
  /*::[*/
  492: {
    /* n:"BrtBeginMap", */
    T: 1
  },
  /*::[*/
  493: {
    /* n:"BrtEndMap", */
    T: -1
  },
  /*::[*/
  494: {
    /* n:"BrtHLink", */
    f: parse_BrtHLink
  },
  /*::[*/
  495: {
    /* n:"BrtBeginDCon", */
    T: 1
  },
  /*::[*/
  496: {
    /* n:"BrtEndDCon", */
    T: -1
  },
  /*::[*/
  497: {
    /* n:"BrtBeginDRefs", */
    T: 1
  },
  /*::[*/
  498: {
    /* n:"BrtEndDRefs", */
    T: -1
  },
  /*::[*/
  499: {
    /* n:"BrtDRef" */
  },
  /*::[*/
  500: {
    /* n:"BrtBeginScenMan", */
    T: 1
  },
  /*::[*/
  501: {
    /* n:"BrtEndScenMan", */
    T: -1
  },
  /*::[*/
  502: {
    /* n:"BrtBeginSct", */
    T: 1
  },
  /*::[*/
  503: {
    /* n:"BrtEndSct", */
    T: -1
  },
  /*::[*/
  504: {
    /* n:"BrtSlc" */
  },
  /*::[*/
  505: {
    /* n:"BrtBeginDXFs", */
    T: 1
  },
  /*::[*/
  506: {
    /* n:"BrtEndDXFs", */
    T: -1
  },
  /*::[*/
  507: {
    /* n:"BrtDXF" */
  },
  /*::[*/
  508: {
    /* n:"BrtBeginTableStyles", */
    T: 1
  },
  /*::[*/
  509: {
    /* n:"BrtEndTableStyles", */
    T: -1
  },
  /*::[*/
  510: {
    /* n:"BrtBeginTableStyle", */
    T: 1
  },
  /*::[*/
  511: {
    /* n:"BrtEndTableStyle", */
    T: -1
  },
  /*::[*/
  512: {
    /* n:"BrtTableStyleElement" */
  },
  /*::[*/
  513: {
    /* n:"BrtTableStyleClient" */
  },
  /*::[*/
  514: {
    /* n:"BrtBeginVolDeps", */
    T: 1
  },
  /*::[*/
  515: {
    /* n:"BrtEndVolDeps", */
    T: -1
  },
  /*::[*/
  516: {
    /* n:"BrtBeginVolType", */
    T: 1
  },
  /*::[*/
  517: {
    /* n:"BrtEndVolType", */
    T: -1
  },
  /*::[*/
  518: {
    /* n:"BrtBeginVolMain", */
    T: 1
  },
  /*::[*/
  519: {
    /* n:"BrtEndVolMain", */
    T: -1
  },
  /*::[*/
  520: {
    /* n:"BrtBeginVolTopic", */
    T: 1
  },
  /*::[*/
  521: {
    /* n:"BrtEndVolTopic", */
    T: -1
  },
  /*::[*/
  522: {
    /* n:"BrtVolSubtopic" */
  },
  /*::[*/
  523: {
    /* n:"BrtVolRef" */
  },
  /*::[*/
  524: {
    /* n:"BrtVolNum" */
  },
  /*::[*/
  525: {
    /* n:"BrtVolErr" */
  },
  /*::[*/
  526: {
    /* n:"BrtVolStr" */
  },
  /*::[*/
  527: {
    /* n:"BrtVolBool" */
  },
  /*::[*/
  528: {
    /* n:"BrtBeginCalcChain$", */
    T: 1
  },
  /*::[*/
  529: {
    /* n:"BrtEndCalcChain$", */
    T: -1
  },
  /*::[*/
  530: {
    /* n:"BrtBeginSortState", */
    T: 1
  },
  /*::[*/
  531: {
    /* n:"BrtEndSortState", */
    T: -1
  },
  /*::[*/
  532: {
    /* n:"BrtBeginSortCond", */
    T: 1
  },
  /*::[*/
  533: {
    /* n:"BrtEndSortCond", */
    T: -1
  },
  /*::[*/
  534: {
    /* n:"BrtBookProtection" */
  },
  /*::[*/
  535: {
    /* n:"BrtSheetProtection" */
  },
  /*::[*/
  536: {
    /* n:"BrtRangeProtection" */
  },
  /*::[*/
  537: {
    /* n:"BrtPhoneticInfo" */
  },
  /*::[*/
  538: {
    /* n:"BrtBeginECTxtWiz", */
    T: 1
  },
  /*::[*/
  539: {
    /* n:"BrtEndECTxtWiz", */
    T: -1
  },
  /*::[*/
  540: {
    /* n:"BrtBeginECTWFldInfoLst", */
    T: 1
  },
  /*::[*/
  541: {
    /* n:"BrtEndECTWFldInfoLst", */
    T: -1
  },
  /*::[*/
  542: {
    /* n:"BrtBeginECTwFldInfo", */
    T: 1
  },
  /*::[*/
  548: {
    /* n:"BrtFileSharing" */
  },
  /*::[*/
  549: {
    /* n:"BrtOleSize" */
  },
  /*::[*/
  550: {
    /* n:"BrtDrawing", */
    f: parse_RelID
  },
  /*::[*/
  551: {
    /* n:"BrtLegacyDrawing" */
  },
  /*::[*/
  552: {
    /* n:"BrtLegacyDrawingHF" */
  },
  /*::[*/
  553: {
    /* n:"BrtWebOpt" */
  },
  /*::[*/
  554: {
    /* n:"BrtBeginWebPubItems", */
    T: 1
  },
  /*::[*/
  555: {
    /* n:"BrtEndWebPubItems", */
    T: -1
  },
  /*::[*/
  556: {
    /* n:"BrtBeginWebPubItem", */
    T: 1
  },
  /*::[*/
  557: {
    /* n:"BrtEndWebPubItem", */
    T: -1
  },
  /*::[*/
  558: {
    /* n:"BrtBeginSXCondFmt", */
    T: 1
  },
  /*::[*/
  559: {
    /* n:"BrtEndSXCondFmt", */
    T: -1
  },
  /*::[*/
  560: {
    /* n:"BrtBeginSXCondFmts", */
    T: 1
  },
  /*::[*/
  561: {
    /* n:"BrtEndSXCondFmts", */
    T: -1
  },
  /*::[*/
  562: {
    /* n:"BrtBkHim" */
  },
  /*::[*/
  564: {
    /* n:"BrtColor" */
  },
  /*::[*/
  565: {
    /* n:"BrtBeginIndexedColors", */
    T: 1
  },
  /*::[*/
  566: {
    /* n:"BrtEndIndexedColors", */
    T: -1
  },
  /*::[*/
  569: {
    /* n:"BrtBeginMRUColors", */
    T: 1
  },
  /*::[*/
  570: {
    /* n:"BrtEndMRUColors", */
    T: -1
  },
  /*::[*/
  572: {
    /* n:"BrtMRUColor" */
  },
  /*::[*/
  573: {
    /* n:"BrtBeginDVals", */
    T: 1
  },
  /*::[*/
  574: {
    /* n:"BrtEndDVals", */
    T: -1
  },
  /*::[*/
  577: {
    /* n:"BrtSupNameStart" */
  },
  /*::[*/
  578: {
    /* n:"BrtSupNameValueStart" */
  },
  /*::[*/
  579: {
    /* n:"BrtSupNameValueEnd" */
  },
  /*::[*/
  580: {
    /* n:"BrtSupNameNum" */
  },
  /*::[*/
  581: {
    /* n:"BrtSupNameErr" */
  },
  /*::[*/
  582: {
    /* n:"BrtSupNameSt" */
  },
  /*::[*/
  583: {
    /* n:"BrtSupNameNil" */
  },
  /*::[*/
  584: {
    /* n:"BrtSupNameBool" */
  },
  /*::[*/
  585: {
    /* n:"BrtSupNameFmla" */
  },
  /*::[*/
  586: {
    /* n:"BrtSupNameBits" */
  },
  /*::[*/
  587: {
    /* n:"BrtSupNameEnd" */
  },
  /*::[*/
  588: {
    /* n:"BrtEndSupBook", */
    T: -1
  },
  /*::[*/
  589: {
    /* n:"BrtCellSmartTagProperty" */
  },
  /*::[*/
  590: {
    /* n:"BrtBeginCellSmartTag", */
    T: 1
  },
  /*::[*/
  591: {
    /* n:"BrtEndCellSmartTag", */
    T: -1
  },
  /*::[*/
  592: {
    /* n:"BrtBeginCellSmartTags", */
    T: 1
  },
  /*::[*/
  593: {
    /* n:"BrtEndCellSmartTags", */
    T: -1
  },
  /*::[*/
  594: {
    /* n:"BrtBeginSmartTags", */
    T: 1
  },
  /*::[*/
  595: {
    /* n:"BrtEndSmartTags", */
    T: -1
  },
  /*::[*/
  596: {
    /* n:"BrtSmartTagType" */
  },
  /*::[*/
  597: {
    /* n:"BrtBeginSmartTagTypes", */
    T: 1
  },
  /*::[*/
  598: {
    /* n:"BrtEndSmartTagTypes", */
    T: -1
  },
  /*::[*/
  599: {
    /* n:"BrtBeginSXFilters", */
    T: 1
  },
  /*::[*/
  600: {
    /* n:"BrtEndSXFilters", */
    T: -1
  },
  /*::[*/
  601: {
    /* n:"BrtBeginSXFILTER", */
    T: 1
  },
  /*::[*/
  602: {
    /* n:"BrtEndSXFilter", */
    T: -1
  },
  /*::[*/
  603: {
    /* n:"BrtBeginFills", */
    T: 1
  },
  /*::[*/
  604: {
    /* n:"BrtEndFills", */
    T: -1
  },
  /*::[*/
  605: {
    /* n:"BrtBeginCellWatches", */
    T: 1
  },
  /*::[*/
  606: {
    /* n:"BrtEndCellWatches", */
    T: -1
  },
  /*::[*/
  607: {
    /* n:"BrtCellWatch" */
  },
  /*::[*/
  608: {
    /* n:"BrtBeginCRErrs", */
    T: 1
  },
  /*::[*/
  609: {
    /* n:"BrtEndCRErrs", */
    T: -1
  },
  /*::[*/
  610: {
    /* n:"BrtCrashRecErr" */
  },
  /*::[*/
  611: {
    /* n:"BrtBeginFonts", */
    T: 1
  },
  /*::[*/
  612: {
    /* n:"BrtEndFonts", */
    T: -1
  },
  /*::[*/
  613: {
    /* n:"BrtBeginBorders", */
    T: 1
  },
  /*::[*/
  614: {
    /* n:"BrtEndBorders", */
    T: -1
  },
  /*::[*/
  615: {
    /* n:"BrtBeginFmts", */
    T: 1
  },
  /*::[*/
  616: {
    /* n:"BrtEndFmts", */
    T: -1
  },
  /*::[*/
  617: {
    /* n:"BrtBeginCellXFs", */
    T: 1
  },
  /*::[*/
  618: {
    /* n:"BrtEndCellXFs", */
    T: -1
  },
  /*::[*/
  619: {
    /* n:"BrtBeginStyles", */
    T: 1
  },
  /*::[*/
  620: {
    /* n:"BrtEndStyles", */
    T: -1
  },
  /*::[*/
  625: {
    /* n:"BrtBigName" */
  },
  /*::[*/
  626: {
    /* n:"BrtBeginCellStyleXFs", */
    T: 1
  },
  /*::[*/
  627: {
    /* n:"BrtEndCellStyleXFs", */
    T: -1
  },
  /*::[*/
  628: {
    /* n:"BrtBeginComments", */
    T: 1
  },
  /*::[*/
  629: {
    /* n:"BrtEndComments", */
    T: -1
  },
  /*::[*/
  630: {
    /* n:"BrtBeginCommentAuthors", */
    T: 1
  },
  /*::[*/
  631: {
    /* n:"BrtEndCommentAuthors", */
    T: -1
  },
  /*::[*/
  632: {
    /* n:"BrtCommentAuthor", */
    f: parse_BrtCommentAuthor
  },
  /*::[*/
  633: {
    /* n:"BrtBeginCommentList", */
    T: 1
  },
  /*::[*/
  634: {
    /* n:"BrtEndCommentList", */
    T: -1
  },
  /*::[*/
  635: {
    /* n:"BrtBeginComment", */
    T: 1,
    f: parse_BrtBeginComment
  },
  /*::[*/
  636: {
    /* n:"BrtEndComment", */
    T: -1
  },
  /*::[*/
  637: {
    /* n:"BrtCommentText", */
    f: parse_BrtCommentText
  },
  /*::[*/
  638: {
    /* n:"BrtBeginOleObjects", */
    T: 1
  },
  /*::[*/
  639: {
    /* n:"BrtOleObject" */
  },
  /*::[*/
  640: {
    /* n:"BrtEndOleObjects", */
    T: -1
  },
  /*::[*/
  641: {
    /* n:"BrtBeginSxrules", */
    T: 1
  },
  /*::[*/
  642: {
    /* n:"BrtEndSxRules", */
    T: -1
  },
  /*::[*/
  643: {
    /* n:"BrtBeginActiveXControls", */
    T: 1
  },
  /*::[*/
  644: {
    /* n:"BrtActiveX" */
  },
  /*::[*/
  645: {
    /* n:"BrtEndActiveXControls", */
    T: -1
  },
  /*::[*/
  646: {
    /* n:"BrtBeginPCDSDTCEMembersSortBy", */
    T: 1
  },
  /*::[*/
  648: {
    /* n:"BrtBeginCellIgnoreECs", */
    T: 1
  },
  /*::[*/
  649: {
    /* n:"BrtCellIgnoreEC" */
  },
  /*::[*/
  650: {
    /* n:"BrtEndCellIgnoreECs", */
    T: -1
  },
  /*::[*/
  651: {
    /* n:"BrtCsProp", */
    f: parse_BrtCsProp
  },
  /*::[*/
  652: {
    /* n:"BrtCsPageSetup" */
  },
  /*::[*/
  653: {
    /* n:"BrtBeginUserCsViews", */
    T: 1
  },
  /*::[*/
  654: {
    /* n:"BrtEndUserCsViews", */
    T: -1
  },
  /*::[*/
  655: {
    /* n:"BrtBeginUserCsView", */
    T: 1
  },
  /*::[*/
  656: {
    /* n:"BrtEndUserCsView", */
    T: -1
  },
  /*::[*/
  657: {
    /* n:"BrtBeginPcdSFCIEntries", */
    T: 1
  },
  /*::[*/
  658: {
    /* n:"BrtEndPCDSFCIEntries", */
    T: -1
  },
  /*::[*/
  659: {
    /* n:"BrtPCDSFCIEntry" */
  },
  /*::[*/
  660: {
    /* n:"BrtBeginListParts", */
    T: 1
  },
  /*::[*/
  661: {
    /* n:"BrtListPart" */
  },
  /*::[*/
  662: {
    /* n:"BrtEndListParts", */
    T: -1
  },
  /*::[*/
  663: {
    /* n:"BrtSheetCalcProp" */
  },
  /*::[*/
  664: {
    /* n:"BrtBeginFnGroup", */
    T: 1
  },
  /*::[*/
  665: {
    /* n:"BrtFnGroup" */
  },
  /*::[*/
  666: {
    /* n:"BrtEndFnGroup", */
    T: -1
  },
  /*::[*/
  667: {
    /* n:"BrtSupAddin" */
  },
  /*::[*/
  668: {
    /* n:"BrtSXTDMPOrder" */
  },
  /*::[*/
  669: {
    /* n:"BrtCsProtection" */
  },
  /*::[*/
  671: {
    /* n:"BrtBeginWsSortMap", */
    T: 1
  },
  /*::[*/
  672: {
    /* n:"BrtEndWsSortMap", */
    T: -1
  },
  /*::[*/
  673: {
    /* n:"BrtBeginRRSort", */
    T: 1
  },
  /*::[*/
  674: {
    /* n:"BrtEndRRSort", */
    T: -1
  },
  /*::[*/
  675: {
    /* n:"BrtRRSortItem" */
  },
  /*::[*/
  676: {
    /* n:"BrtFileSharingIso" */
  },
  /*::[*/
  677: {
    /* n:"BrtBookProtectionIso" */
  },
  /*::[*/
  678: {
    /* n:"BrtSheetProtectionIso" */
  },
  /*::[*/
  679: {
    /* n:"BrtCsProtectionIso" */
  },
  /*::[*/
  680: {
    /* n:"BrtRangeProtectionIso" */
  },
  /*::[*/
  681: {
    /* n:"BrtDValList" */
  },
  /*::[*/
  1024: {
    /* n:"BrtRwDescent" */
  },
  /*::[*/
  1025: {
    /* n:"BrtKnownFonts" */
  },
  /*::[*/
  1026: {
    /* n:"BrtBeginSXTupleSet", */
    T: 1
  },
  /*::[*/
  1027: {
    /* n:"BrtEndSXTupleSet", */
    T: -1
  },
  /*::[*/
  1028: {
    /* n:"BrtBeginSXTupleSetHeader", */
    T: 1
  },
  /*::[*/
  1029: {
    /* n:"BrtEndSXTupleSetHeader", */
    T: -1
  },
  /*::[*/
  1030: {
    /* n:"BrtSXTupleSetHeaderItem" */
  },
  /*::[*/
  1031: {
    /* n:"BrtBeginSXTupleSetData", */
    T: 1
  },
  /*::[*/
  1032: {
    /* n:"BrtEndSXTupleSetData", */
    T: -1
  },
  /*::[*/
  1033: {
    /* n:"BrtBeginSXTupleSetRow", */
    T: 1
  },
  /*::[*/
  1034: {
    /* n:"BrtEndSXTupleSetRow", */
    T: -1
  },
  /*::[*/
  1035: {
    /* n:"BrtSXTupleSetRowItem" */
  },
  /*::[*/
  1036: {
    /* n:"BrtNameExt" */
  },
  /*::[*/
  1037: {
    /* n:"BrtPCDH14" */
  },
  /*::[*/
  1038: {
    /* n:"BrtBeginPCDCalcMem14", */
    T: 1
  },
  /*::[*/
  1039: {
    /* n:"BrtEndPCDCalcMem14", */
    T: -1
  },
  /*::[*/
  1040: {
    /* n:"BrtSXTH14" */
  },
  /*::[*/
  1041: {
    /* n:"BrtBeginSparklineGroup", */
    T: 1
  },
  /*::[*/
  1042: {
    /* n:"BrtEndSparklineGroup", */
    T: -1
  },
  /*::[*/
  1043: {
    /* n:"BrtSparkline" */
  },
  /*::[*/
  1044: {
    /* n:"BrtSXDI14" */
  },
  /*::[*/
  1045: {
    /* n:"BrtWsFmtInfoEx14" */
  },
  /*::[*/
  1046: {
    /* n:"BrtBeginConditionalFormatting14", */
    T: 1
  },
  /*::[*/
  1047: {
    /* n:"BrtEndConditionalFormatting14", */
    T: -1
  },
  /*::[*/
  1048: {
    /* n:"BrtBeginCFRule14", */
    T: 1
  },
  /*::[*/
  1049: {
    /* n:"BrtEndCFRule14", */
    T: -1
  },
  /*::[*/
  1050: {
    /* n:"BrtCFVO14" */
  },
  /*::[*/
  1051: {
    /* n:"BrtBeginDatabar14", */
    T: 1
  },
  /*::[*/
  1052: {
    /* n:"BrtBeginIconSet14", */
    T: 1
  },
  /*::[*/
  1053: {
    /* n:"BrtDVal14", */
    f: parse_BrtDVal14
  },
  /*::[*/
  1054: {
    /* n:"BrtBeginDVals14", */
    T: 1
  },
  /*::[*/
  1055: {
    /* n:"BrtColor14" */
  },
  /*::[*/
  1056: {
    /* n:"BrtBeginSparklines", */
    T: 1
  },
  /*::[*/
  1057: {
    /* n:"BrtEndSparklines", */
    T: -1
  },
  /*::[*/
  1058: {
    /* n:"BrtBeginSparklineGroups", */
    T: 1
  },
  /*::[*/
  1059: {
    /* n:"BrtEndSparklineGroups", */
    T: -1
  },
  /*::[*/
  1061: {
    /* n:"BrtSXVD14" */
  },
  /*::[*/
  1062: {
    /* n:"BrtBeginSXView14", */
    T: 1
  },
  /*::[*/
  1063: {
    /* n:"BrtEndSXView14", */
    T: -1
  },
  /*::[*/
  1064: {
    /* n:"BrtBeginSXView16", */
    T: 1
  },
  /*::[*/
  1065: {
    /* n:"BrtEndSXView16", */
    T: -1
  },
  /*::[*/
  1066: {
    /* n:"BrtBeginPCD14", */
    T: 1
  },
  /*::[*/
  1067: {
    /* n:"BrtEndPCD14", */
    T: -1
  },
  /*::[*/
  1068: {
    /* n:"BrtBeginExtConn14", */
    T: 1
  },
  /*::[*/
  1069: {
    /* n:"BrtEndExtConn14", */
    T: -1
  },
  /*::[*/
  1070: {
    /* n:"BrtBeginSlicerCacheIDs", */
    T: 1
  },
  /*::[*/
  1071: {
    /* n:"BrtEndSlicerCacheIDs", */
    T: -1
  },
  /*::[*/
  1072: {
    /* n:"BrtBeginSlicerCacheID", */
    T: 1
  },
  /*::[*/
  1073: {
    /* n:"BrtEndSlicerCacheID", */
    T: -1
  },
  /*::[*/
  1075: {
    /* n:"BrtBeginSlicerCache", */
    T: 1
  },
  /*::[*/
  1076: {
    /* n:"BrtEndSlicerCache", */
    T: -1
  },
  /*::[*/
  1077: {
    /* n:"BrtBeginSlicerCacheDef", */
    T: 1
  },
  /*::[*/
  1078: {
    /* n:"BrtEndSlicerCacheDef", */
    T: -1
  },
  /*::[*/
  1079: {
    /* n:"BrtBeginSlicersEx", */
    T: 1
  },
  /*::[*/
  1080: {
    /* n:"BrtEndSlicersEx", */
    T: -1
  },
  /*::[*/
  1081: {
    /* n:"BrtBeginSlicerEx", */
    T: 1
  },
  /*::[*/
  1082: {
    /* n:"BrtEndSlicerEx", */
    T: -1
  },
  /*::[*/
  1083: {
    /* n:"BrtBeginSlicer", */
    T: 1
  },
  /*::[*/
  1084: {
    /* n:"BrtEndSlicer", */
    T: -1
  },
  /*::[*/
  1085: {
    /* n:"BrtSlicerCachePivotTables" */
  },
  /*::[*/
  1086: {
    /* n:"BrtBeginSlicerCacheOlapImpl", */
    T: 1
  },
  /*::[*/
  1087: {
    /* n:"BrtEndSlicerCacheOlapImpl", */
    T: -1
  },
  /*::[*/
  1088: {
    /* n:"BrtBeginSlicerCacheLevelsData", */
    T: 1
  },
  /*::[*/
  1089: {
    /* n:"BrtEndSlicerCacheLevelsData", */
    T: -1
  },
  /*::[*/
  1090: {
    /* n:"BrtBeginSlicerCacheLevelData", */
    T: 1
  },
  /*::[*/
  1091: {
    /* n:"BrtEndSlicerCacheLevelData", */
    T: -1
  },
  /*::[*/
  1092: {
    /* n:"BrtBeginSlicerCacheSiRanges", */
    T: 1
  },
  /*::[*/
  1093: {
    /* n:"BrtEndSlicerCacheSiRanges", */
    T: -1
  },
  /*::[*/
  1094: {
    /* n:"BrtBeginSlicerCacheSiRange", */
    T: 1
  },
  /*::[*/
  1095: {
    /* n:"BrtEndSlicerCacheSiRange", */
    T: -1
  },
  /*::[*/
  1096: {
    /* n:"BrtSlicerCacheOlapItem" */
  },
  /*::[*/
  1097: {
    /* n:"BrtBeginSlicerCacheSelections", */
    T: 1
  },
  /*::[*/
  1098: {
    /* n:"BrtSlicerCacheSelection" */
  },
  /*::[*/
  1099: {
    /* n:"BrtEndSlicerCacheSelections", */
    T: -1
  },
  /*::[*/
  1100: {
    /* n:"BrtBeginSlicerCacheNative", */
    T: 1
  },
  /*::[*/
  1101: {
    /* n:"BrtEndSlicerCacheNative", */
    T: -1
  },
  /*::[*/
  1102: {
    /* n:"BrtSlicerCacheNativeItem" */
  },
  /*::[*/
  1103: {
    /* n:"BrtRangeProtection14" */
  },
  /*::[*/
  1104: {
    /* n:"BrtRangeProtectionIso14" */
  },
  /*::[*/
  1105: {
    /* n:"BrtCellIgnoreEC14" */
  },
  /*::[*/
  1111: {
    /* n:"BrtList14" */
  },
  /*::[*/
  1112: {
    /* n:"BrtCFIcon" */
  },
  /*::[*/
  1113: {
    /* n:"BrtBeginSlicerCachesPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  1114: {
    /* n:"BrtEndSlicerCachesPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  1115: {
    /* n:"BrtBeginSlicers", */
    T: 1
  },
  /*::[*/
  1116: {
    /* n:"BrtEndSlicers", */
    T: -1
  },
  /*::[*/
  1117: {
    /* n:"BrtWbProp14" */
  },
  /*::[*/
  1118: {
    /* n:"BrtBeginSXEdit", */
    T: 1
  },
  /*::[*/
  1119: {
    /* n:"BrtEndSXEdit", */
    T: -1
  },
  /*::[*/
  1120: {
    /* n:"BrtBeginSXEdits", */
    T: 1
  },
  /*::[*/
  1121: {
    /* n:"BrtEndSXEdits", */
    T: -1
  },
  /*::[*/
  1122: {
    /* n:"BrtBeginSXChange", */
    T: 1
  },
  /*::[*/
  1123: {
    /* n:"BrtEndSXChange", */
    T: -1
  },
  /*::[*/
  1124: {
    /* n:"BrtBeginSXChanges", */
    T: 1
  },
  /*::[*/
  1125: {
    /* n:"BrtEndSXChanges", */
    T: -1
  },
  /*::[*/
  1126: {
    /* n:"BrtSXTupleItems" */
  },
  /*::[*/
  1128: {
    /* n:"BrtBeginSlicerStyle", */
    T: 1
  },
  /*::[*/
  1129: {
    /* n:"BrtEndSlicerStyle", */
    T: -1
  },
  /*::[*/
  1130: {
    /* n:"BrtSlicerStyleElement" */
  },
  /*::[*/
  1131: {
    /* n:"BrtBeginStyleSheetExt14", */
    T: 1
  },
  /*::[*/
  1132: {
    /* n:"BrtEndStyleSheetExt14", */
    T: -1
  },
  /*::[*/
  1133: {
    /* n:"BrtBeginSlicerCachesPivotCacheID", */
    T: 1
  },
  /*::[*/
  1134: {
    /* n:"BrtEndSlicerCachesPivotCacheID", */
    T: -1
  },
  /*::[*/
  1135: {
    /* n:"BrtBeginConditionalFormattings", */
    T: 1
  },
  /*::[*/
  1136: {
    /* n:"BrtEndConditionalFormattings", */
    T: -1
  },
  /*::[*/
  1137: {
    /* n:"BrtBeginPCDCalcMemExt", */
    T: 1
  },
  /*::[*/
  1138: {
    /* n:"BrtEndPCDCalcMemExt", */
    T: -1
  },
  /*::[*/
  1139: {
    /* n:"BrtBeginPCDCalcMemsExt", */
    T: 1
  },
  /*::[*/
  1140: {
    /* n:"BrtEndPCDCalcMemsExt", */
    T: -1
  },
  /*::[*/
  1141: {
    /* n:"BrtPCDField14" */
  },
  /*::[*/
  1142: {
    /* n:"BrtBeginSlicerStyles", */
    T: 1
  },
  /*::[*/
  1143: {
    /* n:"BrtEndSlicerStyles", */
    T: -1
  },
  /*::[*/
  1144: {
    /* n:"BrtBeginSlicerStyleElements", */
    T: 1
  },
  /*::[*/
  1145: {
    /* n:"BrtEndSlicerStyleElements", */
    T: -1
  },
  /*::[*/
  1146: {
    /* n:"BrtCFRuleExt" */
  },
  /*::[*/
  1147: {
    /* n:"BrtBeginSXCondFmt14", */
    T: 1
  },
  /*::[*/
  1148: {
    /* n:"BrtEndSXCondFmt14", */
    T: -1
  },
  /*::[*/
  1149: {
    /* n:"BrtBeginSXCondFmts14", */
    T: 1
  },
  /*::[*/
  1150: {
    /* n:"BrtEndSXCondFmts14", */
    T: -1
  },
  /*::[*/
  1152: {
    /* n:"BrtBeginSortCond14", */
    T: 1
  },
  /*::[*/
  1153: {
    /* n:"BrtEndSortCond14", */
    T: -1
  },
  /*::[*/
  1154: {
    /* n:"BrtEndDVals14", */
    T: -1
  },
  /*::[*/
  1155: {
    /* n:"BrtEndIconSet14", */
    T: -1
  },
  /*::[*/
  1156: {
    /* n:"BrtEndDatabar14", */
    T: -1
  },
  /*::[*/
  1157: {
    /* n:"BrtBeginColorScale14", */
    T: 1
  },
  /*::[*/
  1158: {
    /* n:"BrtEndColorScale14", */
    T: -1
  },
  /*::[*/
  1159: {
    /* n:"BrtBeginSxrules14", */
    T: 1
  },
  /*::[*/
  1160: {
    /* n:"BrtEndSxrules14", */
    T: -1
  },
  /*::[*/
  1161: {
    /* n:"BrtBeginPRule14", */
    T: 1
  },
  /*::[*/
  1162: {
    /* n:"BrtEndPRule14", */
    T: -1
  },
  /*::[*/
  1163: {
    /* n:"BrtBeginPRFilters14", */
    T: 1
  },
  /*::[*/
  1164: {
    /* n:"BrtEndPRFilters14", */
    T: -1
  },
  /*::[*/
  1165: {
    /* n:"BrtBeginPRFilter14", */
    T: 1
  },
  /*::[*/
  1166: {
    /* n:"BrtEndPRFilter14", */
    T: -1
  },
  /*::[*/
  1167: {
    /* n:"BrtBeginPRFItem14", */
    T: 1
  },
  /*::[*/
  1168: {
    /* n:"BrtEndPRFItem14", */
    T: -1
  },
  /*::[*/
  1169: {
    /* n:"BrtBeginCellIgnoreECs14", */
    T: 1
  },
  /*::[*/
  1170: {
    /* n:"BrtEndCellIgnoreECs14", */
    T: -1
  },
  /*::[*/
  1171: {
    /* n:"BrtDxf14" */
  },
  /*::[*/
  1172: {
    /* n:"BrtBeginDxF14s", */
    T: 1
  },
  /*::[*/
  1173: {
    /* n:"BrtEndDxf14s", */
    T: -1
  },
  /*::[*/
  1177: {
    /* n:"BrtFilter14" */
  },
  /*::[*/
  1178: {
    /* n:"BrtBeginCustomFilters14", */
    T: 1
  },
  /*::[*/
  1180: {
    /* n:"BrtCustomFilter14" */
  },
  /*::[*/
  1181: {
    /* n:"BrtIconFilter14" */
  },
  /*::[*/
  1182: {
    /* n:"BrtPivotCacheConnectionName" */
  },
  /*::[*/
  2048: {
    /* n:"BrtBeginDecoupledPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2049: {
    /* n:"BrtEndDecoupledPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2050: {
    /* n:"BrtDecoupledPivotCacheID" */
  },
  /*::[*/
  2051: {
    /* n:"BrtBeginPivotTableRefs", */
    T: 1
  },
  /*::[*/
  2052: {
    /* n:"BrtEndPivotTableRefs", */
    T: -1
  },
  /*::[*/
  2053: {
    /* n:"BrtPivotTableRef" */
  },
  /*::[*/
  2054: {
    /* n:"BrtSlicerCacheBookPivotTables" */
  },
  /*::[*/
  2055: {
    /* n:"BrtBeginSxvcells", */
    T: 1
  },
  /*::[*/
  2056: {
    /* n:"BrtEndSxvcells", */
    T: -1
  },
  /*::[*/
  2057: {
    /* n:"BrtBeginSxRow", */
    T: 1
  },
  /*::[*/
  2058: {
    /* n:"BrtEndSxRow", */
    T: -1
  },
  /*::[*/
  2060: {
    /* n:"BrtPcdCalcMem15" */
  },
  /*::[*/
  2067: {
    /* n:"BrtQsi15" */
  },
  /*::[*/
  2068: {
    /* n:"BrtBeginWebExtensions", */
    T: 1
  },
  /*::[*/
  2069: {
    /* n:"BrtEndWebExtensions", */
    T: -1
  },
  /*::[*/
  2070: {
    /* n:"BrtWebExtension" */
  },
  /*::[*/
  2071: {
    /* n:"BrtAbsPath15" */
  },
  /*::[*/
  2072: {
    /* n:"BrtBeginPivotTableUISettings", */
    T: 1
  },
  /*::[*/
  2073: {
    /* n:"BrtEndPivotTableUISettings", */
    T: -1
  },
  /*::[*/
  2075: {
    /* n:"BrtTableSlicerCacheIDs" */
  },
  /*::[*/
  2076: {
    /* n:"BrtTableSlicerCacheID" */
  },
  /*::[*/
  2077: {
    /* n:"BrtBeginTableSlicerCache", */
    T: 1
  },
  /*::[*/
  2078: {
    /* n:"BrtEndTableSlicerCache", */
    T: -1
  },
  /*::[*/
  2079: {
    /* n:"BrtSxFilter15" */
  },
  /*::[*/
  2080: {
    /* n:"BrtBeginTimelineCachePivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2081: {
    /* n:"BrtEndTimelineCachePivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2082: {
    /* n:"BrtTimelineCachePivotCacheID" */
  },
  /*::[*/
  2083: {
    /* n:"BrtBeginTimelineCacheIDs", */
    T: 1
  },
  /*::[*/
  2084: {
    /* n:"BrtEndTimelineCacheIDs", */
    T: -1
  },
  /*::[*/
  2085: {
    /* n:"BrtBeginTimelineCacheID", */
    T: 1
  },
  /*::[*/
  2086: {
    /* n:"BrtEndTimelineCacheID", */
    T: -1
  },
  /*::[*/
  2087: {
    /* n:"BrtBeginTimelinesEx", */
    T: 1
  },
  /*::[*/
  2088: {
    /* n:"BrtEndTimelinesEx", */
    T: -1
  },
  /*::[*/
  2089: {
    /* n:"BrtBeginTimelineEx", */
    T: 1
  },
  /*::[*/
  2090: {
    /* n:"BrtEndTimelineEx", */
    T: -1
  },
  /*::[*/
  2091: {
    /* n:"BrtWorkBookPr15" */
  },
  /*::[*/
  2092: {
    /* n:"BrtPCDH15" */
  },
  /*::[*/
  2093: {
    /* n:"BrtBeginTimelineStyle", */
    T: 1
  },
  /*::[*/
  2094: {
    /* n:"BrtEndTimelineStyle", */
    T: -1
  },
  /*::[*/
  2095: {
    /* n:"BrtTimelineStyleElement" */
  },
  /*::[*/
  2096: {
    /* n:"BrtBeginTimelineStylesheetExt15", */
    T: 1
  },
  /*::[*/
  2097: {
    /* n:"BrtEndTimelineStylesheetExt15", */
    T: -1
  },
  /*::[*/
  2098: {
    /* n:"BrtBeginTimelineStyles", */
    T: 1
  },
  /*::[*/
  2099: {
    /* n:"BrtEndTimelineStyles", */
    T: -1
  },
  /*::[*/
  2100: {
    /* n:"BrtBeginTimelineStyleElements", */
    T: 1
  },
  /*::[*/
  2101: {
    /* n:"BrtEndTimelineStyleElements", */
    T: -1
  },
  /*::[*/
  2102: {
    /* n:"BrtDxf15" */
  },
  /*::[*/
  2103: {
    /* n:"BrtBeginDxfs15", */
    T: 1
  },
  /*::[*/
  2104: {
    /* n:"BrtEndDxfs15", */
    T: -1
  },
  /*::[*/
  2105: {
    /* n:"BrtSlicerCacheHideItemsWithNoData" */
  },
  /*::[*/
  2106: {
    /* n:"BrtBeginItemUniqueNames", */
    T: 1
  },
  /*::[*/
  2107: {
    /* n:"BrtEndItemUniqueNames", */
    T: -1
  },
  /*::[*/
  2108: {
    /* n:"BrtItemUniqueName" */
  },
  /*::[*/
  2109: {
    /* n:"BrtBeginExtConn15", */
    T: 1
  },
  /*::[*/
  2110: {
    /* n:"BrtEndExtConn15", */
    T: -1
  },
  /*::[*/
  2111: {
    /* n:"BrtBeginOledbPr15", */
    T: 1
  },
  /*::[*/
  2112: {
    /* n:"BrtEndOledbPr15", */
    T: -1
  },
  /*::[*/
  2113: {
    /* n:"BrtBeginDataFeedPr15", */
    T: 1
  },
  /*::[*/
  2114: {
    /* n:"BrtEndDataFeedPr15", */
    T: -1
  },
  /*::[*/
  2115: {
    /* n:"BrtTextPr15" */
  },
  /*::[*/
  2116: {
    /* n:"BrtRangePr15" */
  },
  /*::[*/
  2117: {
    /* n:"BrtDbCommand15" */
  },
  /*::[*/
  2118: {
    /* n:"BrtBeginDbTables15", */
    T: 1
  },
  /*::[*/
  2119: {
    /* n:"BrtEndDbTables15", */
    T: -1
  },
  /*::[*/
  2120: {
    /* n:"BrtDbTable15" */
  },
  /*::[*/
  2121: {
    /* n:"BrtBeginDataModel", */
    T: 1
  },
  /*::[*/
  2122: {
    /* n:"BrtEndDataModel", */
    T: -1
  },
  /*::[*/
  2123: {
    /* n:"BrtBeginModelTables", */
    T: 1
  },
  /*::[*/
  2124: {
    /* n:"BrtEndModelTables", */
    T: -1
  },
  /*::[*/
  2125: {
    /* n:"BrtModelTable" */
  },
  /*::[*/
  2126: {
    /* n:"BrtBeginModelRelationships", */
    T: 1
  },
  /*::[*/
  2127: {
    /* n:"BrtEndModelRelationships", */
    T: -1
  },
  /*::[*/
  2128: {
    /* n:"BrtModelRelationship" */
  },
  /*::[*/
  2129: {
    /* n:"BrtBeginECTxtWiz15", */
    T: 1
  },
  /*::[*/
  2130: {
    /* n:"BrtEndECTxtWiz15", */
    T: -1
  },
  /*::[*/
  2131: {
    /* n:"BrtBeginECTWFldInfoLst15", */
    T: 1
  },
  /*::[*/
  2132: {
    /* n:"BrtEndECTWFldInfoLst15", */
    T: -1
  },
  /*::[*/
  2133: {
    /* n:"BrtBeginECTWFldInfo15", */
    T: 1
  },
  /*::[*/
  2134: {
    /* n:"BrtFieldListActiveItem" */
  },
  /*::[*/
  2135: {
    /* n:"BrtPivotCacheIdVersion" */
  },
  /*::[*/
  2136: {
    /* n:"BrtSXDI15" */
  },
  /*::[*/
  2137: {
    /* n:"BrtBeginModelTimeGroupings", */
    T: 1
  },
  /*::[*/
  2138: {
    /* n:"BrtEndModelTimeGroupings", */
    T: -1
  },
  /*::[*/
  2139: {
    /* n:"BrtBeginModelTimeGrouping", */
    T: 1
  },
  /*::[*/
  2140: {
    /* n:"BrtEndModelTimeGrouping", */
    T: -1
  },
  /*::[*/
  2141: {
    /* n:"BrtModelTimeGroupingCalcCol" */
  },
  /*::[*/
  3072: {
    /* n:"BrtUid" */
  },
  /*::[*/
  3073: {
    /* n:"BrtRevisionPtr" */
  },
  /*::[*/
  4096: {
    /* n:"BrtBeginDynamicArrayPr", */
    T: 1
  },
  /*::[*/
  4097: {
    /* n:"BrtEndDynamicArrayPr", */
    T: -1
  },
  /*::[*/
  5002: {
    /* n:"BrtBeginRichValueBlock", */
    T: 1
  },
  /*::[*/
  5003: {
    /* n:"BrtEndRichValueBlock", */
    T: -1
  },
  /*::[*/
  5081: {
    /* n:"BrtBeginRichFilters", */
    T: 1
  },
  /*::[*/
  5082: {
    /* n:"BrtEndRichFilters", */
    T: -1
  },
  /*::[*/
  5083: {
    /* n:"BrtRichFilter" */
  },
  /*::[*/
  5084: {
    /* n:"BrtBeginRichFilterColumn", */
    T: 1
  },
  /*::[*/
  5085: {
    /* n:"BrtEndRichFilterColumn", */
    T: -1
  },
  /*::[*/
  5086: {
    /* n:"BrtBeginCustomRichFilters", */
    T: 1
  },
  /*::[*/
  5087: {
    /* n:"BrtEndCustomRichFilters", */
    T: -1
  },
  /*::[*/
  5088: {
    /* n:"BrtCustomRichFilter" */
  },
  /*::[*/
  5089: {
    /* n:"BrtTop10RichFilter" */
  },
  /*::[*/
  5090: {
    /* n:"BrtDynamicRichFilter" */
  },
  /*::[*/
  5092: {
    /* n:"BrtBeginRichSortCondition", */
    T: 1
  },
  /*::[*/
  5093: {
    /* n:"BrtEndRichSortCondition", */
    T: -1
  },
  /*::[*/
  5094: {
    /* n:"BrtRichFilterDateGroupItem" */
  },
  /*::[*/
  5095: {
    /* n:"BrtBeginCalcFeatures", */
    T: 1
  },
  /*::[*/
  5096: {
    /* n:"BrtEndCalcFeatures", */
    T: -1
  },
  /*::[*/
  5097: {
    /* n:"BrtCalcFeature" */
  },
  /*::[*/
  5099: {
    /* n:"BrtExternalLinksPr" */
  },
  /*::[*/
  65535: { n: "" }
}, XLSRecordEnum = {
  /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
  /*::[*/
  6: {
    /* n:"Formula", */
    f: parse_Formula
  },
  /*::[*/
  10: {
    /* n:"EOF", */
    f: parsenoop2
  },
  /*::[*/
  12: {
    /* n:"CalcCount", */
    f: parseuint16
  },
  //
  /*::[*/
  13: {
    /* n:"CalcMode", */
    f: parseuint16
  },
  //
  /*::[*/
  14: {
    /* n:"CalcPrecision", */
    f: parsebool
  },
  //
  /*::[*/
  15: {
    /* n:"CalcRefMode", */
    f: parsebool
  },
  //
  /*::[*/
  16: {
    /* n:"CalcDelta", */
    f: parse_Xnum
  },
  //
  /*::[*/
  17: {
    /* n:"CalcIter", */
    f: parsebool
  },
  //
  /*::[*/
  18: {
    /* n:"Protect", */
    f: parsebool
  },
  /*::[*/
  19: {
    /* n:"Password", */
    f: parseuint16
  },
  /*::[*/
  20: {
    /* n:"Header", */
    f: parse_XLHeaderFooter
  },
  /*::[*/
  21: {
    /* n:"Footer", */
    f: parse_XLHeaderFooter
  },
  /*::[*/
  23: {
    /* n:"ExternSheet", */
    f: parse_ExternSheet
  },
  /*::[*/
  24: {
    /* n:"Lbl", */
    f: parse_Lbl
  },
  /*::[*/
  25: {
    /* n:"WinProtect", */
    f: parsebool
  },
  /*::[*/
  26: {
    /* n:"VerticalPageBreaks", */
  },
  /*::[*/
  27: {
    /* n:"HorizontalPageBreaks", */
  },
  /*::[*/
  28: {
    /* n:"Note", */
    f: parse_Note
  },
  /*::[*/
  29: {
    /* n:"Selection", */
  },
  /*::[*/
  34: {
    /* n:"Date1904", */
    f: parsebool
  },
  /*::[*/
  35: {
    /* n:"ExternName", */
    f: parse_ExternName
  },
  /*::[*/
  38: {
    /* n:"LeftMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  39: {
    /* n:"RightMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  40: {
    /* n:"TopMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  41: {
    /* n:"BottomMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  42: {
    /* n:"PrintRowCol", */
    f: parsebool
  },
  /*::[*/
  43: {
    /* n:"PrintGrid", */
    f: parsebool
  },
  /*::[*/
  47: {
    /* n:"FilePass", */
    f: parse_FilePass
  },
  /*::[*/
  49: {
    /* n:"Font", */
    f: parse_Font
  },
  /*::[*/
  51: {
    /* n:"PrintSize", */
    f: parseuint16
  },
  /*::[*/
  60: {
    /* n:"Continue", */
  },
  /*::[*/
  61: {
    /* n:"Window1", */
    f: parse_Window1
  },
  /*::[*/
  64: {
    /* n:"Backup", */
    f: parsebool
  },
  /*::[*/
  65: {
    /* n:"Pane", */
    f: parse_Pane
  },
  /*::[*/
  66: {
    /* n:"CodePage", */
    f: parseuint16
  },
  /*::[*/
  77: {
    /* n:"Pls", */
  },
  /*::[*/
  80: {
    /* n:"DCon", */
  },
  /*::[*/
  81: {
    /* n:"DConRef", */
  },
  /*::[*/
  82: {
    /* n:"DConName", */
  },
  /*::[*/
  85: {
    /* n:"DefColWidth", */
    f: parseuint16
  },
  /*::[*/
  89: {
    /* n:"XCT", */
  },
  /*::[*/
  90: {
    /* n:"CRN", */
  },
  /*::[*/
  91: {
    /* n:"FileSharing", */
  },
  /*::[*/
  92: {
    /* n:"WriteAccess", */
    f: parse_WriteAccess
  },
  /*::[*/
  93: {
    /* n:"Obj", */
    f: parse_Obj
  },
  /*::[*/
  94: {
    /* n:"Uncalced", */
  },
  /*::[*/
  95: {
    /* n:"CalcSaveRecalc", */
    f: parsebool
  },
  //
  /*::[*/
  96: {
    /* n:"Template", */
  },
  /*::[*/
  97: {
    /* n:"Intl", */
  },
  /*::[*/
  99: {
    /* n:"ObjProtect", */
    f: parsebool
  },
  /*::[*/
  125: {
    /* n:"ColInfo", */
    f: parse_ColInfo
  },
  /*::[*/
  128: {
    /* n:"Guts", */
    f: parse_Guts
  },
  /*::[*/
  129: {
    /* n:"WsBool", */
    f: parse_WsBool
  },
  /*::[*/
  130: {
    /* n:"GridSet", */
    f: parseuint16
  },
  /*::[*/
  131: {
    /* n:"HCenter", */
    f: parsebool
  },
  /*::[*/
  132: {
    /* n:"VCenter", */
    f: parsebool
  },
  /*::[*/
  133: {
    /* n:"BoundSheet8", */
    f: parse_BoundSheet8
  },
  /*::[*/
  134: {
    /* n:"WriteProtect", */
  },
  /*::[*/
  140: {
    /* n:"Country", */
    f: parse_Country
  },
  /*::[*/
  141: {
    /* n:"HideObj", */
    f: parseuint16
  },
  /*::[*/
  144: {
    /* n:"Sort", */
  },
  /*::[*/
  146: {
    /* n:"Palette", */
    f: parse_Palette
  },
  /*::[*/
  151: {
    /* n:"Sync", */
  },
  /*::[*/
  152: {
    /* n:"LPr", */
  },
  /*::[*/
  153: {
    /* n:"DxGCol", */
  },
  /*::[*/
  154: {
    /* n:"FnGroupName", */
  },
  /*::[*/
  155: {
    /* n:"FilterMode", */
  },
  /*::[*/
  156: {
    /* n:"BuiltInFnGroupCount", */
    f: parseuint16
  },
  /*::[*/
  157: {
    /* n:"AutoFilterInfo", */
  },
  /*::[*/
  158: {
    /* n:"AutoFilter", */
  },
  /*::[*/
  160: {
    /* n:"Scl", */
    f: parse_Scl
  },
  /*::[*/
  161: {
    /* n:"Setup", */
    f: parse_Setup
  },
  /*::[*/
  174: {
    /* n:"ScenMan", */
  },
  /*::[*/
  175: {
    /* n:"SCENARIO", */
  },
  /*::[*/
  176: {
    /* n:"SxView", */
  },
  /*::[*/
  177: {
    /* n:"Sxvd", */
  },
  /*::[*/
  178: {
    /* n:"SXVI", */
  },
  /*::[*/
  180: {
    /* n:"SxIvd", */
  },
  /*::[*/
  181: {
    /* n:"SXLI", */
  },
  /*::[*/
  182: {
    /* n:"SXPI", */
  },
  /*::[*/
  184: {
    /* n:"DocRoute", */
  },
  /*::[*/
  185: {
    /* n:"RecipName", */
  },
  /*::[*/
  189: {
    /* n:"MulRk", */
    f: parse_MulRk
  },
  /*::[*/
  190: {
    /* n:"MulBlank", */
    f: parse_MulBlank
  },
  /*::[*/
  193: {
    /* n:"Mms", */
    f: parsenoop2
  },
  /*::[*/
  197: {
    /* n:"SXDI", */
  },
  /*::[*/
  198: {
    /* n:"SXDB", */
  },
  /*::[*/
  199: {
    /* n:"SXFDB", */
  },
  /*::[*/
  200: {
    /* n:"SXDBB", */
  },
  /*::[*/
  201: {
    /* n:"SXNum", */
  },
  /*::[*/
  202: {
    /* n:"SxBool", */
    f: parsebool
  },
  /*::[*/
  203: {
    /* n:"SxErr", */
  },
  /*::[*/
  204: {
    /* n:"SXInt", */
  },
  /*::[*/
  205: {
    /* n:"SXString", */
  },
  /*::[*/
  206: {
    /* n:"SXDtr", */
  },
  /*::[*/
  207: {
    /* n:"SxNil", */
  },
  /*::[*/
  208: {
    /* n:"SXTbl", */
  },
  /*::[*/
  209: {
    /* n:"SXTBRGIITM", */
  },
  /*::[*/
  210: {
    /* n:"SxTbpg", */
  },
  /*::[*/
  211: {
    /* n:"ObProj", */
  },
  /*::[*/
  213: {
    /* n:"SXStreamID", */
  },
  /*::[*/
  215: {
    /* n:"DBCell", */
  },
  /*::[*/
  216: {
    /* n:"SXRng", */
  },
  /*::[*/
  217: {
    /* n:"SxIsxoper", */
  },
  /*::[*/
  218: {
    /* n:"BookBool", */
    f: parseuint16
  },
  /*::[*/
  220: {
    /* n:"DbOrParamQry", */
  },
  /*::[*/
  221: {
    /* n:"ScenarioProtect", */
    f: parsebool
  },
  /*::[*/
  222: {
    /* n:"OleObjectSize", */
  },
  /*::[*/
  224: {
    /* n:"XF", */
    f: parse_XF
  },
  /*::[*/
  225: {
    /* n:"InterfaceHdr", */
    f: parse_InterfaceHdr
  },
  /*::[*/
  226: {
    /* n:"InterfaceEnd", */
    f: parsenoop2
  },
  /*::[*/
  227: {
    /* n:"SXVS", */
  },
  /*::[*/
  229: {
    /* n:"MergeCells", */
    f: parse_MergeCells
  },
  /*::[*/
  233: {
    /* n:"BkHim", */
  },
  /*::[*/
  235: {
    /* n:"MsoDrawingGroup", */
  },
  /*::[*/
  236: {
    /* n:"MsoDrawing", */
  },
  /*::[*/
  237: {
    /* n:"MsoDrawingSelection", */
  },
  /*::[*/
  239: {
    /* n:"PhoneticInfo", */
  },
  /*::[*/
  240: {
    /* n:"SxRule", */
  },
  /*::[*/
  241: {
    /* n:"SXEx", */
  },
  /*::[*/
  242: {
    /* n:"SxFilt", */
  },
  /*::[*/
  244: {
    /* n:"SxDXF", */
  },
  /*::[*/
  245: {
    /* n:"SxItm", */
  },
  /*::[*/
  246: {
    /* n:"SxName", */
  },
  /*::[*/
  247: {
    /* n:"SxSelect", */
  },
  /*::[*/
  248: {
    /* n:"SXPair", */
  },
  /*::[*/
  249: {
    /* n:"SxFmla", */
  },
  /*::[*/
  251: {
    /* n:"SxFormat", */
  },
  /*::[*/
  252: {
    /* n:"SST", */
    f: parse_SST
  },
  /*::[*/
  253: {
    /* n:"LabelSst", */
    f: parse_LabelSst
  },
  /*::[*/
  255: {
    /* n:"ExtSST", */
    f: parse_ExtSST
  },
  /*::[*/
  256: {
    /* n:"SXVDEx", */
  },
  /*::[*/
  259: {
    /* n:"SXFormula", */
  },
  /*::[*/
  290: {
    /* n:"SXDBEx", */
  },
  /*::[*/
  311: {
    /* n:"RRDInsDel", */
  },
  /*::[*/
  312: {
    /* n:"RRDHead", */
  },
  /*::[*/
  315: {
    /* n:"RRDChgCell", */
  },
  /*::[*/
  317: {
    /* n:"RRTabId", */
    f: parseuint16a
  },
  /*::[*/
  318: {
    /* n:"RRDRenSheet", */
  },
  /*::[*/
  319: {
    /* n:"RRSort", */
  },
  /*::[*/
  320: {
    /* n:"RRDMove", */
  },
  /*::[*/
  330: {
    /* n:"RRFormat", */
  },
  /*::[*/
  331: {
    /* n:"RRAutoFmt", */
  },
  /*::[*/
  333: {
    /* n:"RRInsertSh", */
  },
  /*::[*/
  334: {
    /* n:"RRDMoveBegin", */
  },
  /*::[*/
  335: {
    /* n:"RRDMoveEnd", */
  },
  /*::[*/
  336: {
    /* n:"RRDInsDelBegin", */
  },
  /*::[*/
  337: {
    /* n:"RRDInsDelEnd", */
  },
  /*::[*/
  338: {
    /* n:"RRDConflict", */
  },
  /*::[*/
  339: {
    /* n:"RRDDefName", */
  },
  /*::[*/
  340: {
    /* n:"RRDRstEtxp", */
  },
  /*::[*/
  351: {
    /* n:"LRng", */
  },
  /*::[*/
  352: {
    /* n:"UsesELFs", */
    f: parsebool
  },
  /*::[*/
  353: {
    /* n:"DSF", */
    f: parsenoop2
  },
  /*::[*/
  401: {
    /* n:"CUsr", */
  },
  /*::[*/
  402: {
    /* n:"CbUsr", */
  },
  /*::[*/
  403: {
    /* n:"UsrInfo", */
  },
  /*::[*/
  404: {
    /* n:"UsrExcl", */
  },
  /*::[*/
  405: {
    /* n:"FileLock", */
  },
  /*::[*/
  406: {
    /* n:"RRDInfo", */
  },
  /*::[*/
  407: {
    /* n:"BCUsrs", */
  },
  /*::[*/
  408: {
    /* n:"UsrChk", */
  },
  /*::[*/
  425: {
    /* n:"UserBView", */
  },
  /*::[*/
  426: {
    /* n:"UserSViewBegin", */
  },
  /*::[*/
  427: {
    /* n:"UserSViewEnd", */
  },
  /*::[*/
  428: {
    /* n:"RRDUserView", */
  },
  /*::[*/
  429: {
    /* n:"Qsi", */
  },
  /*::[*/
  430: {
    /* n:"SupBook", */
    f: parse_SupBook
  },
  /*::[*/
  431: {
    /* n:"Prot4Rev", */
    f: parsebool
  },
  /*::[*/
  432: {
    /* n:"CondFmt", */
  },
  /*::[*/
  433: {
    /* n:"CF", */
  },
  /*::[*/
  434: {
    /* n:"DVal", */
  },
  /*::[*/
  437: {
    /* n:"DConBin", */
  },
  /*::[*/
  438: {
    /* n:"TxO", */
    f: parse_TxO
  },
  /*::[*/
  439: {
    /* n:"RefreshAll", */
    f: parsebool
  },
  //
  /*::[*/
  440: {
    /* n:"HLink", */
    f: parse_HLink
  },
  /*::[*/
  441: {
    /* n:"Lel", */
  },
  /*::[*/
  442: {
    /* n:"CodeName", */
    f: parse_XLUnicodeString
  },
  /*::[*/
  443: {
    /* n:"SXFDBType", */
  },
  /*::[*/
  444: {
    /* n:"Prot4RevPass", */
    f: parseuint16
  },
  /*::[*/
  445: {
    /* n:"ObNoMacros", */
  },
  /*::[*/
  446: {
    /* n:"Dv", */
  },
  /*::[*/
  448: {
    /* n:"Excel9File", */
    f: parsenoop2
  },
  /*::[*/
  449: {
    /* n:"RecalcId", */
    f: parse_RecalcId,
    r: 2
  },
  /*::[*/
  450: {
    /* n:"EntExU2", */
    f: parsenoop2
  },
  /*::[*/
  512: {
    /* n:"Dimensions", */
    f: parse_Dimensions
  },
  /*::[*/
  513: {
    /* n:"Blank", */
    f: parse_Blank
  },
  /*::[*/
  515: {
    /* n:"Number", */
    f: parse_Number
  },
  /*::[*/
  516: {
    /* n:"Label", */
    f: parse_Label
  },
  /*::[*/
  517: {
    /* n:"BoolErr", */
    f: parse_BoolErr
  },
  /*::[*/
  519: {
    /* n:"String", */
    f: parse_String
  },
  /*::[*/
  520: {
    /* n:"Row", */
    f: parse_Row
  },
  /*::[*/
  523: {
    /* n:"Index", */
  },
  /*::[*/
  545: {
    /* n:"Array", */
    f: parse_Array
  },
  /*::[*/
  549: {
    /* n:"DefaultRowHeight", */
    f: parse_DefaultRowHeight
  },
  /*::[*/
  566: {
    /* n:"Table", */
  },
  /*::[*/
  574: {
    /* n:"Window2", */
    f: parse_Window2
  },
  /*::[*/
  638: {
    /* n:"RK", */
    f: parse_RK
  },
  /*::[*/
  659: {
    /* n:"Style", */
  },
  /*::[*/
  1048: {
    /* n:"BigName", */
  },
  /*::[*/
  1054: {
    /* n:"Format", */
    f: parse_Format
  },
  /*::[*/
  1084: {
    /* n:"ContinueBigName", */
  },
  /*::[*/
  1212: {
    /* n:"ShrFmla", */
    f: parse_ShrFmla
  },
  /*::[*/
  2048: {
    /* n:"HLinkTooltip", */
    f: parse_HLinkTooltip
  },
  /*::[*/
  2049: {
    /* n:"WebPub", */
  },
  /*::[*/
  2050: {
    /* n:"QsiSXTag", */
  },
  /*::[*/
  2051: {
    /* n:"DBQueryExt", */
  },
  /*::[*/
  2052: {
    /* n:"ExtString", */
  },
  /*::[*/
  2053: {
    /* n:"TxtQry", */
  },
  /*::[*/
  2054: {
    /* n:"Qsir", */
  },
  /*::[*/
  2055: {
    /* n:"Qsif", */
  },
  /*::[*/
  2056: {
    /* n:"RRDTQSIF", */
  },
  /*::[*/
  2057: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  2058: {
    /* n:"OleDbConn", */
  },
  /*::[*/
  2059: {
    /* n:"WOpt", */
  },
  /*::[*/
  2060: {
    /* n:"SXViewEx", */
  },
  /*::[*/
  2061: {
    /* n:"SXTH", */
  },
  /*::[*/
  2062: {
    /* n:"SXPIEx", */
  },
  /*::[*/
  2063: {
    /* n:"SXVDTEx", */
  },
  /*::[*/
  2064: {
    /* n:"SXViewEx9", */
  },
  /*::[*/
  2066: {
    /* n:"ContinueFrt", */
  },
  /*::[*/
  2067: {
    /* n:"RealTimeData", */
  },
  /*::[*/
  2128: {
    /* n:"ChartFrtInfo", */
  },
  /*::[*/
  2129: {
    /* n:"FrtWrapper", */
  },
  /*::[*/
  2130: {
    /* n:"StartBlock", */
  },
  /*::[*/
  2131: {
    /* n:"EndBlock", */
  },
  /*::[*/
  2132: {
    /* n:"StartObject", */
  },
  /*::[*/
  2133: {
    /* n:"EndObject", */
  },
  /*::[*/
  2134: {
    /* n:"CatLab", */
  },
  /*::[*/
  2135: {
    /* n:"YMult", */
  },
  /*::[*/
  2136: {
    /* n:"SXViewLink", */
  },
  /*::[*/
  2137: {
    /* n:"PivotChartBits", */
  },
  /*::[*/
  2138: {
    /* n:"FrtFontList", */
  },
  /*::[*/
  2146: {
    /* n:"SheetExt", */
  },
  /*::[*/
  2147: {
    /* n:"BookExt", */
    r: 12
  },
  /*::[*/
  2148: {
    /* n:"SXAddl", */
  },
  /*::[*/
  2149: {
    /* n:"CrErr", */
  },
  /*::[*/
  2150: {
    /* n:"HFPicture", */
  },
  /*::[*/
  2151: {
    /* n:"FeatHdr", */
    f: parsenoop2
  },
  /*::[*/
  2152: {
    /* n:"Feat", */
  },
  /*::[*/
  2154: {
    /* n:"DataLabExt", */
  },
  /*::[*/
  2155: {
    /* n:"DataLabExtContents", */
  },
  /*::[*/
  2156: {
    /* n:"CellWatch", */
  },
  /*::[*/
  2161: {
    /* n:"FeatHdr11", */
  },
  /*::[*/
  2162: {
    /* n:"Feature11", */
  },
  /*::[*/
  2164: {
    /* n:"DropDownObjIds", */
  },
  /*::[*/
  2165: {
    /* n:"ContinueFrt11", */
  },
  /*::[*/
  2166: {
    /* n:"DConn", */
  },
  /*::[*/
  2167: {
    /* n:"List12", */
  },
  /*::[*/
  2168: {
    /* n:"Feature12", */
  },
  /*::[*/
  2169: {
    /* n:"CondFmt12", */
  },
  /*::[*/
  2170: {
    /* n:"CF12", */
  },
  /*::[*/
  2171: {
    /* n:"CFEx", */
  },
  /*::[*/
  2172: {
    /* n:"XFCRC", */
    f: parse_XFCRC,
    r: 12
  },
  /*::[*/
  2173: {
    /* n:"XFExt", */
    f: parse_XFExt,
    r: 12
  },
  /*::[*/
  2174: {
    /* n:"AutoFilter12", */
  },
  /*::[*/
  2175: {
    /* n:"ContinueFrt12", */
  },
  /*::[*/
  2180: {
    /* n:"MDTInfo", */
  },
  /*::[*/
  2181: {
    /* n:"MDXStr", */
  },
  /*::[*/
  2182: {
    /* n:"MDXTuple", */
  },
  /*::[*/
  2183: {
    /* n:"MDXSet", */
  },
  /*::[*/
  2184: {
    /* n:"MDXProp", */
  },
  /*::[*/
  2185: {
    /* n:"MDXKPI", */
  },
  /*::[*/
  2186: {
    /* n:"MDB", */
  },
  /*::[*/
  2187: {
    /* n:"PLV", */
  },
  /*::[*/
  2188: {
    /* n:"Compat12", */
    f: parsebool,
    r: 12
  },
  /*::[*/
  2189: {
    /* n:"DXF", */
  },
  /*::[*/
  2190: {
    /* n:"TableStyles", */
    r: 12
  },
  /*::[*/
  2191: {
    /* n:"TableStyle", */
  },
  /*::[*/
  2192: {
    /* n:"TableStyleElement", */
  },
  /*::[*/
  2194: {
    /* n:"StyleExt", */
  },
  /*::[*/
  2195: {
    /* n:"NamePublish", */
  },
  /*::[*/
  2196: {
    /* n:"NameCmt", */
    f: parse_NameCmt,
    r: 12
  },
  /*::[*/
  2197: {
    /* n:"SortData", */
  },
  /*::[*/
  2198: {
    /* n:"Theme", */
    f: parse_Theme,
    r: 12
  },
  /*::[*/
  2199: {
    /* n:"GUIDTypeLib", */
  },
  /*::[*/
  2200: {
    /* n:"FnGrp12", */
  },
  /*::[*/
  2201: {
    /* n:"NameFnGrp12", */
  },
  /*::[*/
  2202: {
    /* n:"MTRSettings", */
    f: parse_MTRSettings,
    r: 12
  },
  /*::[*/
  2203: {
    /* n:"CompressPictures", */
    f: parsenoop2
  },
  /*::[*/
  2204: {
    /* n:"HeaderFooter", */
  },
  /*::[*/
  2205: {
    /* n:"CrtLayout12", */
  },
  /*::[*/
  2206: {
    /* n:"CrtMlFrt", */
  },
  /*::[*/
  2207: {
    /* n:"CrtMlFrtContinue", */
  },
  /*::[*/
  2211: {
    /* n:"ForceFullCalculation", */
    f: parse_ForceFullCalculation
  },
  /*::[*/
  2212: {
    /* n:"ShapePropsStream", */
  },
  /*::[*/
  2213: {
    /* n:"TextPropsStream", */
  },
  /*::[*/
  2214: {
    /* n:"RichTextStream", */
  },
  /*::[*/
  2215: {
    /* n:"CrtLayout12A", */
  },
  /*::[*/
  4097: {
    /* n:"Units", */
  },
  /*::[*/
  4098: {
    /* n:"Chart", */
  },
  /*::[*/
  4099: {
    /* n:"Series", */
  },
  /*::[*/
  4102: {
    /* n:"DataFormat", */
  },
  /*::[*/
  4103: {
    /* n:"LineFormat", */
  },
  /*::[*/
  4105: {
    /* n:"MarkerFormat", */
  },
  /*::[*/
  4106: {
    /* n:"AreaFormat", */
  },
  /*::[*/
  4107: {
    /* n:"PieFormat", */
  },
  /*::[*/
  4108: {
    /* n:"AttachedLabel", */
  },
  /*::[*/
  4109: {
    /* n:"SeriesText", */
  },
  /*::[*/
  4116: {
    /* n:"ChartFormat", */
  },
  /*::[*/
  4117: {
    /* n:"Legend", */
  },
  /*::[*/
  4118: {
    /* n:"SeriesList", */
  },
  /*::[*/
  4119: {
    /* n:"Bar", */
  },
  /*::[*/
  4120: {
    /* n:"Line", */
  },
  /*::[*/
  4121: {
    /* n:"Pie", */
  },
  /*::[*/
  4122: {
    /* n:"Area", */
  },
  /*::[*/
  4123: {
    /* n:"Scatter", */
  },
  /*::[*/
  4124: {
    /* n:"CrtLine", */
  },
  /*::[*/
  4125: {
    /* n:"Axis", */
  },
  /*::[*/
  4126: {
    /* n:"Tick", */
  },
  /*::[*/
  4127: {
    /* n:"ValueRange", */
  },
  /*::[*/
  4128: {
    /* n:"CatSerRange", */
  },
  /*::[*/
  4129: {
    /* n:"AxisLine", */
  },
  /*::[*/
  4130: {
    /* n:"CrtLink", */
  },
  /*::[*/
  4132: {
    /* n:"DefaultText", */
  },
  /*::[*/
  4133: {
    /* n:"Text", */
  },
  /*::[*/
  4134: {
    /* n:"FontX", */
    f: parseuint16
  },
  /*::[*/
  4135: {
    /* n:"ObjectLink", */
  },
  /*::[*/
  4146: {
    /* n:"Frame", */
  },
  /*::[*/
  4147: {
    /* n:"Begin", */
  },
  /*::[*/
  4148: {
    /* n:"End", */
  },
  /*::[*/
  4149: {
    /* n:"PlotArea", */
  },
  /*::[*/
  4154: {
    /* n:"Chart3d", */
  },
  /*::[*/
  4156: {
    /* n:"PicF", */
  },
  /*::[*/
  4157: {
    /* n:"DropBar", */
  },
  /*::[*/
  4158: {
    /* n:"Radar", */
  },
  /*::[*/
  4159: {
    /* n:"Surf", */
  },
  /*::[*/
  4160: {
    /* n:"RadarArea", */
  },
  /*::[*/
  4161: {
    /* n:"AxisParent", */
  },
  /*::[*/
  4163: {
    /* n:"LegendException", */
  },
  /*::[*/
  4164: {
    /* n:"ShtProps", */
    f: parse_ShtProps
  },
  /*::[*/
  4165: {
    /* n:"SerToCrt", */
  },
  /*::[*/
  4166: {
    /* n:"AxesUsed", */
  },
  /*::[*/
  4168: {
    /* n:"SBaseRef", */
  },
  /*::[*/
  4170: {
    /* n:"SerParent", */
  },
  /*::[*/
  4171: {
    /* n:"SerAuxTrend", */
  },
  /*::[*/
  4174: {
    /* n:"IFmtRecord", */
  },
  /*::[*/
  4175: {
    /* n:"Pos", */
  },
  /*::[*/
  4176: {
    /* n:"AlRuns", */
  },
  /*::[*/
  4177: {
    /* n:"BRAI", */
  },
  /*::[*/
  4187: {
    /* n:"SerAuxErrBar", */
  },
  /*::[*/
  4188: {
    /* n:"ClrtClient", */
    f: parse_ClrtClient
  },
  /*::[*/
  4189: {
    /* n:"SerFmt", */
  },
  /*::[*/
  4191: {
    /* n:"Chart3DBarShape", */
  },
  /*::[*/
  4192: {
    /* n:"Fbi", */
  },
  /*::[*/
  4193: {
    /* n:"BopPop", */
  },
  /*::[*/
  4194: {
    /* n:"AxcExt", */
  },
  /*::[*/
  4195: {
    /* n:"Dat", */
  },
  /*::[*/
  4196: {
    /* n:"PlotGrowth", */
  },
  /*::[*/
  4197: {
    /* n:"SIIndex", */
  },
  /*::[*/
  4198: {
    /* n:"GelFrame", */
  },
  /*::[*/
  4199: {
    /* n:"BopPopCustom", */
  },
  /*::[*/
  4200: {
    /* n:"Fbi2", */
  },
  /*::[*/
  0: {
    /* n:"Dimensions", */
    f: parse_Dimensions
  },
  /*::[*/
  1: {
    /* n:"BIFF2BLANK", */
  },
  /*::[*/
  2: {
    /* n:"BIFF2INT", */
    f: parse_BIFF2INT
  },
  /*::[*/
  3: {
    /* n:"BIFF2NUM", */
    f: parse_BIFF2NUM
  },
  /*::[*/
  4: {
    /* n:"BIFF2STR", */
    f: parse_BIFF2STR
  },
  /*::[*/
  5: {
    /* n:"BoolErr", */
    f: parse_BoolErr
  },
  /*::[*/
  7: {
    /* n:"String", */
    f: parse_BIFF2STRING
  },
  /*::[*/
  8: {
    /* n:"BIFF2ROW", */
  },
  /*::[*/
  9: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  11: {
    /* n:"Index", */
  },
  /*::[*/
  22: {
    /* n:"ExternCount", */
    f: parseuint16
  },
  /*::[*/
  30: {
    /* n:"BIFF2FORMAT", */
    f: parse_BIFF2Format
  },
  /*::[*/
  31: {
    /* n:"BIFF2FMTCNT", */
  },
  /* 16-bit cnt of BIFF2FORMAT records */
  /*::[*/
  32: {
    /* n:"BIFF2COLINFO", */
  },
  /*::[*/
  33: {
    /* n:"Array", */
    f: parse_Array
  },
  /*::[*/
  36: {
    /* n:"COLWIDTH", */
  },
  /*::[*/
  37: {
    /* n:"DefaultRowHeight", */
    f: parse_DefaultRowHeight
  },
  // 0x2c ??
  // 0x2d ??
  // 0x2e ??
  // 0x30 FONTCOUNT: number of fonts
  /*::[*/
  50: {
    /* n:"BIFF2FONTXTRA", */
    f: parse_BIFF2FONTXTRA
  },
  // 0x35: INFOOPTS
  // 0x36: TABLE (BIFF2 only)
  // 0x37: TABLE2 (BIFF2 only)
  // 0x38: WNDESK
  // 0x39 ??
  // 0x3a: BEGINPREF
  // 0x3b: ENDPREF
  /*::[*/
  62: {
    /* n:"BIFF2WINDOW2", */
  },
  // 0x3f ??
  // 0x46: SHOWSCROLL
  // 0x47: SHOWFORMULA
  // 0x48: STATUSBAR
  // 0x49: SHORTMENUS
  // 0x4A:
  // 0x4B:
  // 0x4C:
  // 0x4E:
  // 0x4F:
  // 0x58: TOOLBAR (BIFF3)
  /* - - - */
  /*::[*/
  52: {
    /* n:"DDEObjName", */
  },
  /*::[*/
  67: {
    /* n:"BIFF2XF", */
  },
  /*::[*/
  68: {
    /* n:"BIFF2XFINDEX", */
    f: parseuint16
  },
  /*::[*/
  69: {
    /* n:"BIFF2FONTCLR", */
  },
  /*::[*/
  86: {
    /* n:"BIFF4FMTCNT", */
  },
  /* 16-bit cnt, similar to BIFF2 */
  /*::[*/
  126: {
    /* n:"RK", */
  },
  /* Not necessarily same as 0x027e */
  /*::[*/
  127: {
    /* n:"ImData", */
    f: parse_ImData
  },
  /*::[*/
  135: {
    /* n:"Addin", */
  },
  /*::[*/
  136: {
    /* n:"Edg", */
  },
  /*::[*/
  137: {
    /* n:"Pub", */
  },
  // 0x8A
  // 0x8B LH: alternate menu key flag (BIFF3/4)
  // 0x8E
  // 0x8F
  /*::[*/
  145: {
    /* n:"Sub", */
  },
  // 0x93 STYLE
  /*::[*/
  148: {
    /* n:"LHRecord", */
  },
  /*::[*/
  149: {
    /* n:"LHNGraph", */
  },
  /*::[*/
  150: {
    /* n:"Sound", */
  },
  // 0xA2 FNPROTO: function prototypes (BIFF4)
  // 0xA3
  // 0xA8
  /*::[*/
  169: {
    /* n:"CoordList", */
  },
  /*::[*/
  171: {
    /* n:"GCW", */
  },
  /*::[*/
  188: {
    /* n:"ShrFmla", */
  },
  /* Not necessarily same as 0x04bc */
  /*::[*/
  191: {
    /* n:"ToolbarHdr", */
  },
  /*::[*/
  192: {
    /* n:"ToolbarEnd", */
  },
  /*::[*/
  194: {
    /* n:"AddMenu", */
  },
  /*::[*/
  195: {
    /* n:"DelMenu", */
  },
  /*::[*/
  214: {
    /* n:"RString", */
    f: parse_RString
  },
  /*::[*/
  223: {
    /* n:"UDDesc", */
  },
  /*::[*/
  234: {
    /* n:"TabIdConf", */
  },
  /*::[*/
  354: {
    /* n:"XL5Modify", */
  },
  /*::[*/
  421: {
    /* n:"FileSharing2", */
  },
  /*::[*/
  518: {
    /* n:"Formula", */
    f: parse_Formula
  },
  /*::[*/
  521: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  536: {
    /* n:"Lbl", */
    f: parse_Lbl
  },
  /*::[*/
  547: {
    /* n:"ExternName", */
    f: parse_ExternName
  },
  /*::[*/
  561: {
    /* n:"Font", */
  },
  /*::[*/
  579: {
    /* n:"BIFF3XF", */
  },
  /*::[*/
  1030: {
    /* n:"Formula", */
    f: parse_Formula
  },
  /*::[*/
  1033: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  1091: {
    /* n:"BIFF4XF", */
  },
  /*::[*/
  2157: {
    /* n:"FeatInfo", */
  },
  /*::[*/
  2163: {
    /* n:"FeatInfo11", */
  },
  /*::[*/
  2177: {
    /* n:"SXAddl12", */
  },
  /*::[*/
  2240: {
    /* n:"AutoWebPub", */
  },
  /*::[*/
  2241: {
    /* n:"ListObj", */
  },
  /*::[*/
  2242: {
    /* n:"ListField", */
  },
  /*::[*/
  2243: {
    /* n:"ListDV", */
  },
  /*::[*/
  2244: {
    /* n:"ListCondFmt", */
  },
  /*::[*/
  2245: {
    /* n:"ListCF", */
  },
  /*::[*/
  2246: {
    /* n:"FMQry", */
  },
  /*::[*/
  2247: {
    /* n:"FMSQry", */
  },
  /*::[*/
  2248: {
    /* n:"PLV", */
  },
  /*::[*/
  2249: {
    /* n:"LnExt", */
  },
  /*::[*/
  2250: {
    /* n:"MkrExt", */
  },
  /*::[*/
  2251: {
    /* n:"CrtCoopt", */
  },
  /*::[*/
  2262: {
    /* n:"FRTArchId$", */
    r: 12
  },
  /*::[*/
  29282: {}
};
function write_biff_rec(Xn, zn, Un, Kn) {
  var qn = zn;
  if (!isNaN(qn)) {
    var Jo = (Un || []).length || 0, pa = Xn.next(4);
    pa.write_shift(2, qn), pa.write_shift(2, Jo), /*:: len != null &&*/
    Jo > 0 && is_buf(Un) && Xn.push(Un);
  }
}
function html_to_sheet(Xn, zn) {
  var Un = zn || {}, Kn = Un.dense ? [] : {};
  Xn = Xn.replace(/<!--.*?-->/g, "");
  var qn = Xn.match(/<table/i);
  if (!qn) throw new Error("Invalid HTML: could not find <table>");
  var Jo = Xn.match(/<\/table/i), pa = qn.index, ma = Jo && Jo.index || Xn.length, va = split_regex(Xn.slice(pa, ma), /(:?<tr[^>]*>)/i, "<tr>"), ba = -1, _a = 0, ya = 0, xa = 0, wa = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } }, Ta = [];
  for (pa = 0; pa < va.length; ++pa) {
    var Sa = va[pa].trim(), Ma = Sa.slice(0, 3).toLowerCase();
    if (Ma == "<tr") {
      if (++ba, Un.sheetRows && Un.sheetRows <= ba) {
        --ba;
        break;
      }
      _a = 0;
      continue;
    }
    if (!(Ma != "<td" && Ma != "<th")) {
      var ka = Sa.split(/<\/t[dh]>/i);
      for (ma = 0; ma < ka.length; ++ma) {
        var Za = ka[ma].trim();
        if (Za.match(/<t[dh]/i)) {
          for (var Na = Za, Ka = 0; Na.charAt(0) == "<" && (Ka = Na.indexOf(">")) > -1; ) Na = Na.slice(Ka + 1);
          for (var Ja = 0; Ja < Ta.length; ++Ja) {
            var el = Ta[Ja];
            el.s.c == _a && el.s.r < ba && ba <= el.e.r && (_a = el.e.c + 1, Ja = -1);
          }
          var qa = parsexmltag(Za.slice(0, Za.indexOf(">")));
          xa = qa.colspan ? +qa.colspan : 1, ((ya = +qa.rowspan) > 1 || xa > 1) && Ta.push({ s: { r: ba, c: _a }, e: { r: ba + (ya || 1) - 1, c: _a + xa - 1 } });
          var tl = qa.t || qa["data-t"] || "";
          if (!Na.length) {
            _a += xa;
            continue;
          }
          if (Na = htmldecode(Na), wa.s.r > ba && (wa.s.r = ba), wa.e.r < ba && (wa.e.r = ba), wa.s.c > _a && (wa.s.c = _a), wa.e.c < _a && (wa.e.c = _a), !Na.length) {
            _a += xa;
            continue;
          }
          var Qa = { t: "s", v: Na };
          Un.raw || !Na.trim().length || tl == "s" || (Na === "TRUE" ? Qa = { t: "b", v: !0 } : Na === "FALSE" ? Qa = { t: "b", v: !1 } : isNaN(fuzzynum(Na)) ? isNaN(fuzzydate(Na).getDate()) || (Qa = { t: "d", v: parseDate$1(Na) }, Un.cellDates || (Qa = { t: "n", v: datenum(Qa.v) }), Qa.z = Un.dateNF || table_fmt[14]) : Qa = { t: "n", v: fuzzynum(Na) }), Un.dense ? (Kn[ba] || (Kn[ba] = []), Kn[ba][_a] = Qa) : Kn[encode_cell({ r: ba, c: _a })] = Qa, _a += xa;
        }
      }
    }
  }
  return Kn["!ref"] = encode_range(wa), Ta.length && (Kn["!merges"] = Ta), Kn;
}
function make_html_row(Xn, zn, Un, Kn) {
  for (var qn = Xn["!merges"] || [], Jo = [], pa = zn.s.c; pa <= zn.e.c; ++pa) {
    for (var ma = 0, va = 0, ba = 0; ba < qn.length; ++ba)
      if (!(qn[ba].s.r > Un || qn[ba].s.c > pa) && !(qn[ba].e.r < Un || qn[ba].e.c < pa)) {
        if (qn[ba].s.r < Un || qn[ba].s.c < pa) {
          ma = -1;
          break;
        }
        ma = qn[ba].e.r - qn[ba].s.r + 1, va = qn[ba].e.c - qn[ba].s.c + 1;
        break;
      }
    if (!(ma < 0)) {
      var _a = encode_cell({ r: Un, c: pa }), ya = Kn.dense ? (Xn[Un] || [])[pa] : Xn[_a], xa = ya && ya.v != null && (ya.h || escapehtml(ya.w || (format_cell(ya), ya.w) || "")) || "", wa = {};
      ma > 1 && (wa.rowspan = ma), va > 1 && (wa.colspan = va), Kn.editable ? xa = '<span contenteditable="true">' + xa + "</span>" : ya && (wa["data-t"] = ya && ya.t || "z", ya.v != null && (wa["data-v"] = ya.v), ya.z != null && (wa["data-z"] = ya.z), ya.l && (ya.l.Target || "#").charAt(0) != "#" && (xa = '<a href="' + ya.l.Target + '">' + xa + "</a>")), wa.id = (Kn.id || "sjs") + "-" + _a, Jo.push(writextag("td", xa, wa));
    }
  }
  var Ta = "<tr>";
  return Ta + Jo.join("") + "</tr>";
}
var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', HTML_END = "</body></html>";
function html_to_workbook(Xn, zn) {
  var Un = Xn.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  if (!Un || Un.length == 0) throw new Error("Invalid HTML: could not find <table>");
  if (Un.length == 1) return sheet_to_workbook(html_to_sheet(Un[0], zn), zn);
  var Kn = book_new();
  return Un.forEach(function(qn, Jo) {
    book_append_sheet(Kn, html_to_sheet(qn, zn), "Sheet" + (Jo + 1));
  }), Kn;
}
function make_html_preamble(Xn, zn, Un) {
  var Kn = [];
  return Kn.join("") + "<table" + (Un && Un.id ? ' id="' + Un.id + '"' : "") + ">";
}
function sheet_to_html(Xn, zn) {
  var Un = zn || {}, Kn = Un.header != null ? Un.header : HTML_BEGIN, qn = Un.footer != null ? Un.footer : HTML_END, Jo = [Kn], pa = decode_range(Xn["!ref"]);
  Un.dense = Array.isArray(Xn), Jo.push(make_html_preamble(Xn, pa, Un));
  for (var ma = pa.s.r; ma <= pa.e.r; ++ma) Jo.push(make_html_row(Xn, pa, ma, Un));
  return Jo.push("</table>" + qn), Jo.join("");
}
function sheet_add_dom(Xn, zn, Un) {
  var Kn = Un || {}, qn = 0, Jo = 0;
  if (Kn.origin != null)
    if (typeof Kn.origin == "number") qn = Kn.origin;
    else {
      var pa = typeof Kn.origin == "string" ? decode_cell(Kn.origin) : Kn.origin;
      qn = pa.r, Jo = pa.c;
    }
  var ma = zn.getElementsByTagName("tr"), va = Math.min(Kn.sheetRows || 1e7, ma.length), ba = { s: { r: 0, c: 0 }, e: { r: qn, c: Jo } };
  if (Xn["!ref"]) {
    var _a = decode_range(Xn["!ref"]);
    ba.s.r = Math.min(ba.s.r, _a.s.r), ba.s.c = Math.min(ba.s.c, _a.s.c), ba.e.r = Math.max(ba.e.r, _a.e.r), ba.e.c = Math.max(ba.e.c, _a.e.c), qn == -1 && (ba.e.r = qn = _a.e.r + 1);
  }
  var ya = [], xa = 0, wa = Xn["!rows"] || (Xn["!rows"] = []), Ta = 0, Sa = 0, Ma = 0, ka = 0, Za = 0, Na = 0;
  for (Xn["!cols"] || (Xn["!cols"] = []); Ta < ma.length && Sa < va; ++Ta) {
    var Ka = ma[Ta];
    if (is_dom_element_hidden(Ka)) {
      if (Kn.display) continue;
      wa[Sa] = { hidden: !0 };
    }
    var Ja = Ka.children;
    for (Ma = ka = 0; Ma < Ja.length; ++Ma) {
      var el = Ja[Ma];
      if (!(Kn.display && is_dom_element_hidden(el))) {
        var qa = el.hasAttribute("data-v") ? el.getAttribute("data-v") : el.hasAttribute("v") ? el.getAttribute("v") : htmldecode(el.innerHTML), tl = el.getAttribute("data-z") || el.getAttribute("z");
        for (xa = 0; xa < ya.length; ++xa) {
          var Qa = ya[xa];
          Qa.s.c == ka + Jo && Qa.s.r < Sa + qn && Sa + qn <= Qa.e.r && (ka = Qa.e.c + 1 - Jo, xa = -1);
        }
        Na = +el.getAttribute("colspan") || 1, ((Za = +el.getAttribute("rowspan") || 1) > 1 || Na > 1) && ya.push({ s: { r: Sa + qn, c: ka + Jo }, e: { r: Sa + qn + (Za || 1) - 1, c: ka + Jo + (Na || 1) - 1 } });
        var nl = { t: "s", v: qa }, rl = el.getAttribute("data-t") || el.getAttribute("t") || "";
        qa != null && (qa.length == 0 ? nl.t = rl || "z" : Kn.raw || qa.trim().length == 0 || rl == "s" || (qa === "TRUE" ? nl = { t: "b", v: !0 } : qa === "FALSE" ? nl = { t: "b", v: !1 } : isNaN(fuzzynum(qa)) ? isNaN(fuzzydate(qa).getDate()) || (nl = { t: "d", v: parseDate$1(qa) }, Kn.cellDates || (nl = { t: "n", v: datenum(nl.v) }), nl.z = Kn.dateNF || table_fmt[14]) : nl = { t: "n", v: fuzzynum(qa) })), nl.z === void 0 && tl != null && (nl.z = tl);
        var il = "", cl = el.getElementsByTagName("A");
        if (cl && cl.length) for (var ll = 0; ll < cl.length && !(cl[ll].hasAttribute("href") && (il = cl[ll].getAttribute("href"), il.charAt(0) != "#")); ++ll) ;
        il && il.charAt(0) != "#" && (nl.l = { Target: il }), Kn.dense ? (Xn[Sa + qn] || (Xn[Sa + qn] = []), Xn[Sa + qn][ka + Jo] = nl) : Xn[encode_cell({ c: ka + Jo, r: Sa + qn })] = nl, ba.e.c < ka + Jo && (ba.e.c = ka + Jo), ka += Na;
      }
    }
    ++Sa;
  }
  return ya.length && (Xn["!merges"] = (Xn["!merges"] || []).concat(ya)), ba.e.r = Math.max(ba.e.r, Sa - 1 + qn), Xn["!ref"] = encode_range(ba), Sa >= va && (Xn["!fullref"] = encode_range((ba.e.r = ma.length - Ta + Sa - 1 + qn, ba))), Xn;
}
function parse_dom_table(Xn, zn) {
  var Un = zn || {}, Kn = Un.dense ? [] : {};
  return sheet_add_dom(Kn, Xn, zn);
}
function table_to_book(Xn, zn) {
  return sheet_to_workbook(parse_dom_table(Xn, zn), zn);
}
function is_dom_element_hidden(Xn) {
  var zn = "", Un = get_get_computed_style_function(Xn);
  return Un && (zn = Un(Xn).getPropertyValue("display")), zn || (zn = Xn.style && Xn.style.display), zn === "none";
}
function get_get_computed_style_function(Xn) {
  return Xn.ownerDocument.defaultView && typeof Xn.ownerDocument.defaultView.getComputedStyle == "function" ? Xn.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == "function" ? getComputedStyle : null;
}
function parse_text_p(Xn) {
  var zn = Xn.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(Kn, qn) {
    return Array(parseInt(qn, 10) + 1).join(" ");
  }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, `
`), Un = unescapexml(zn.replace(/<[^>]*>/g, ""));
  return [Un];
}
var number_formats_ods = {
  /* ods name: [short ssf fmt, long ssf fmt] */
  day: ["d", "dd"],
  month: ["m", "mm"],
  year: ["y", "yy"],
  hours: ["h", "hh"],
  minutes: ["m", "mm"],
  seconds: ["s", "ss"],
  "am-pm": ["A/P", "AM/PM"],
  "day-of-week": ["ddd", "dddd"],
  era: ["e", "ee"],
  /* there is no native representation of LO "Q" format */
  quarter: ["\\Qm", 'm\\"th quarter"']
};
function parse_content_xml(Xn, zn) {
  var Un = zn || {}, Kn = xlml_normalize(Xn), qn = [], Jo, pa, ma = { name: "" }, va = "", ba = 0, _a, ya, xa = {}, wa = [], Ta = Un.dense ? [] : {}, Sa, Ma, ka = { value: "" }, Za = "", Na = 0, Ka = [], Ja = -1, el = -1, qa = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } }, tl = 0, Qa = {}, nl = [], rl = {}, il = 0, cl = 0, ll = [], al = 1, sl = 1, dl = [], El = { Names: [] }, fl = {}, Ml = ["", ""], Sl = [], ml = {}, Dl = "", _l = 0, gl = !1, Fl = !1, Nl = 0;
  for (xlmlregex.lastIndex = 0, Kn = Kn.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); Sa = xlmlregex.exec(Kn); ) switch (Sa[3] = Sa[3].replace(/_.*$/, "")) {
    case "table":
    case "工作表":
      Sa[1] === "/" ? (qa.e.c >= qa.s.c && qa.e.r >= qa.s.r ? Ta["!ref"] = encode_range(qa) : Ta["!ref"] = "A1:A1", Un.sheetRows > 0 && Un.sheetRows <= qa.e.r && (Ta["!fullref"] = Ta["!ref"], qa.e.r = Un.sheetRows - 1, Ta["!ref"] = encode_range(qa)), nl.length && (Ta["!merges"] = nl), ll.length && (Ta["!rows"] = ll), _a.name = _a.名称 || _a.name, typeof JSON < "u" && JSON.stringify(_a), wa.push(_a.name), xa[_a.name] = Ta, Fl = !1) : Sa[0].charAt(Sa[0].length - 2) !== "/" && (_a = parsexmltag(Sa[0], !1), Ja = el = -1, qa.s.r = qa.s.c = 1e7, qa.e.r = qa.e.c = 0, Ta = Un.dense ? [] : {}, nl = [], ll = [], Fl = !0);
      break;
    case "table-row-group":
      Sa[1] === "/" ? --tl : ++tl;
      break;
    case "table-row":
    case "行":
      if (Sa[1] === "/") {
        Ja += al, al = 1;
        break;
      }
      if (ya = parsexmltag(Sa[0], !1), ya.行号 ? Ja = ya.行号 - 1 : Ja == -1 && (Ja = 0), al = +ya["number-rows-repeated"] || 1, al < 10) for (Nl = 0; Nl < al; ++Nl) tl > 0 && (ll[Ja + Nl] = { level: tl });
      el = -1;
      break;
    case "covered-table-cell":
      Sa[1] !== "/" && ++el, Un.sheetStubs && (Un.dense ? (Ta[Ja] || (Ta[Ja] = []), Ta[Ja][el] = { t: "z" }) : Ta[encode_cell({ r: Ja, c: el })] = { t: "z" }), Za = "", Ka = [];
      break;
    /* stub */
    case "table-cell":
    case "数据":
      if (Sa[0].charAt(Sa[0].length - 2) === "/")
        ++el, ka = parsexmltag(Sa[0], !1), sl = parseInt(ka["number-columns-repeated"] || "1", 10), Ma = {
          t: "z",
          v: null
          /*:: , z:null, w:"",c:[]*/
        }, ka.formula && Un.cellFormula != !1 && (Ma.f = ods_to_csf_formula(unescapexml(ka.formula))), (ka.数据类型 || ka["value-type"]) == "string" && (Ma.t = "s", Ma.v = unescapexml(ka["string-value"] || ""), Un.dense ? (Ta[Ja] || (Ta[Ja] = []), Ta[Ja][el] = Ma) : Ta[encode_cell({ r: Ja, c: el })] = Ma), el += sl - 1;
      else if (Sa[1] !== "/") {
        ++el, Za = "", Na = 0, Ka = [], sl = 1;
        var zl = al ? Ja + al - 1 : Ja;
        if (el > qa.e.c && (qa.e.c = el), el < qa.s.c && (qa.s.c = el), Ja < qa.s.r && (qa.s.r = Ja), zl > qa.e.r && (qa.e.r = zl), ka = parsexmltag(Sa[0], !1), Sl = [], ml = {}, Ma = {
          t: ka.数据类型 || ka["value-type"],
          v: null
          /*:: , z:null, w:"",c:[]*/
        }, Un.cellFormula)
          if (ka.formula && (ka.formula = unescapexml(ka.formula)), ka["number-matrix-columns-spanned"] && ka["number-matrix-rows-spanned"] && (il = parseInt(ka["number-matrix-rows-spanned"], 10) || 0, cl = parseInt(ka["number-matrix-columns-spanned"], 10) || 0, rl = { s: { r: Ja, c: el }, e: { r: Ja + il - 1, c: el + cl - 1 } }, Ma.F = encode_range(rl), dl.push([rl, Ma.F])), ka.formula) Ma.f = ods_to_csf_formula(ka.formula);
          else for (Nl = 0; Nl < dl.length; ++Nl)
            Ja >= dl[Nl][0].s.r && Ja <= dl[Nl][0].e.r && el >= dl[Nl][0].s.c && el <= dl[Nl][0].e.c && (Ma.F = dl[Nl][1]);
        switch ((ka["number-columns-spanned"] || ka["number-rows-spanned"]) && (il = parseInt(ka["number-rows-spanned"], 10) || 0, cl = parseInt(ka["number-columns-spanned"], 10) || 0, rl = { s: { r: Ja, c: el }, e: { r: Ja + il - 1, c: el + cl - 1 } }, nl.push(rl)), ka["number-columns-repeated"] && (sl = parseInt(ka["number-columns-repeated"], 10)), Ma.t) {
          case "boolean":
            Ma.t = "b", Ma.v = parsexmlbool(ka["boolean-value"]);
            break;
          case "float":
            Ma.t = "n", Ma.v = parseFloat(ka.value);
            break;
          case "percentage":
            Ma.t = "n", Ma.v = parseFloat(ka.value);
            break;
          case "currency":
            Ma.t = "n", Ma.v = parseFloat(ka.value);
            break;
          case "date":
            Ma.t = "d", Ma.v = parseDate$1(ka["date-value"]), Un.cellDates || (Ma.t = "n", Ma.v = datenum(Ma.v)), Ma.z = "m/d/yy";
            break;
          case "time":
            Ma.t = "n", Ma.v = parse_isodur(ka["time-value"]) / 86400, Un.cellDates && (Ma.t = "d", Ma.v = numdate(Ma.v)), Ma.z = "HH:MM:SS";
            break;
          case "number":
            Ma.t = "n", Ma.v = parseFloat(ka.数据数值);
            break;
          default:
            if (Ma.t === "string" || Ma.t === "text" || !Ma.t)
              Ma.t = "s", ka["string-value"] != null && (Za = unescapexml(ka["string-value"]), Ka = []);
            else throw new Error("Unsupported value type " + Ma.t);
        }
      } else {
        if (gl = !1, Ma.t === "s" && (Ma.v = Za || "", Ka.length && (Ma.R = Ka), gl = Na == 0), fl.Target && (Ma.l = fl), Sl.length > 0 && (Ma.c = Sl, Sl = []), Za && Un.cellText !== !1 && (Ma.w = Za), gl && (Ma.t = "z", delete Ma.v), (!gl || Un.sheetStubs) && !(Un.sheetRows && Un.sheetRows <= Ja))
          for (var Zl = 0; Zl < al; ++Zl) {
            if (sl = parseInt(ka["number-columns-repeated"] || "1", 10), Un.dense)
              for (Ta[Ja + Zl] || (Ta[Ja + Zl] = []), Ta[Ja + Zl][el] = Zl == 0 ? Ma : dup(Ma); --sl > 0; ) Ta[Ja + Zl][el + sl] = dup(Ma);
            else
              for (Ta[encode_cell({ r: Ja + Zl, c: el })] = Ma; --sl > 0; ) Ta[encode_cell({ r: Ja + Zl, c: el + sl })] = dup(Ma);
            qa.e.c <= el && (qa.e.c = el);
          }
        sl = parseInt(ka["number-columns-repeated"] || "1", 10), el += sl - 1, sl = 0, Ma = {
          /*:: t:"", v:null, z:null, w:"",c:[]*/
        }, Za = "", Ka = [];
      }
      fl = {};
      break;
    // 9.1.4 <table:table-cell>
    /* pure state */
    case "document":
    // TODO: <office:document> is the root for FODS
    case "document-content":
    case "电子表格文档":
    // 3.1.3.2 <office:document-content>
    case "spreadsheet":
    case "主体":
    // 3.7 <office:spreadsheet>
    case "scripts":
    // 3.12 <office:scripts>
    case "styles":
    // TODO <office:styles>
    case "font-face-decls":
    // 3.14 <office:font-face-decls>
    case "master-styles":
      if (Sa[1] === "/") {
        if ((Jo = qn.pop())[0] !== Sa[3]) throw "Bad state: " + Jo;
      } else Sa[0].charAt(Sa[0].length - 2) !== "/" && qn.push([Sa[3], !0]);
      break;
    case "annotation":
      if (Sa[1] === "/") {
        if ((Jo = qn.pop())[0] !== Sa[3]) throw "Bad state: " + Jo;
        ml.t = Za, Ka.length && (ml.R = Ka), ml.a = Dl, Sl.push(ml);
      } else Sa[0].charAt(Sa[0].length - 2) !== "/" && qn.push([Sa[3], !1]);
      Dl = "", _l = 0, Za = "", Na = 0, Ka = [];
      break;
    case "creator":
      Sa[1] === "/" ? Dl = Kn.slice(_l, Sa.index) : _l = Sa.index + Sa[0].length;
      break;
    /* ignore state */
    case "meta":
    case "元数据":
    // TODO: <office:meta> <uof:元数据> FODS/UOF
    case "settings":
    // TODO: <office:settings>
    case "config-item-set":
    // TODO: <office:config-item-set>
    case "config-item-map-indexed":
    // TODO: <office:config-item-map-indexed>
    case "config-item-map-entry":
    // TODO: <office:config-item-map-entry>
    case "config-item-map-named":
    // TODO: <office:config-item-map-entry>
    case "shapes":
    // 9.2.8 <table:shapes>
    case "frame":
    // 10.4.2 <draw:frame>
    case "text-box":
    // 10.4.3 <draw:text-box>
    case "image":
    // 10.4.4 <draw:image>
    case "data-pilot-tables":
    // 9.6.2 <table:data-pilot-tables>
    case "list-style":
    // 16.30 <text:list-style>
    case "form":
    // 13.13 <form:form>
    case "dde-links":
    // 9.8 <table:dde-links>
    case "event-listeners":
    // TODO
    case "chart":
      if (Sa[1] === "/") {
        if ((Jo = qn.pop())[0] !== Sa[3]) throw "Bad state: " + Jo;
      } else Sa[0].charAt(Sa[0].length - 2) !== "/" && qn.push([Sa[3], !1]);
      Za = "", Na = 0, Ka = [];
      break;
    case "scientific-number":
      break;
    case "currency-symbol":
      break;
    case "currency-style":
      break;
    case "number-style":
    // 16.27.2 <number:number-style>
    case "percentage-style":
    // 16.27.9 <number:percentage-style>
    case "date-style":
    // 16.27.10 <number:date-style>
    case "time-style":
      if (Sa[1] === "/") {
        if (Qa[ma.name] = va, (Jo = qn.pop())[0] !== Sa[3]) throw "Bad state: " + Jo;
      } else Sa[0].charAt(Sa[0].length - 2) !== "/" && (va = "", ma = parsexmltag(Sa[0], !1), qn.push([Sa[3], !0]));
      break;
    case "script":
      break;
    // 3.13 <office:script>
    case "libraries":
      break;
    // TODO: <ooo:libraries>
    case "automatic-styles":
      break;
    // 3.15.3 <office:automatic-styles>
    case "default-style":
    // TODO: <style:default-style>
    case "page-layout":
      break;
    // TODO: <style:page-layout>
    case "style":
      break;
    case "map":
      break;
    // 16.3 <style:map>
    case "font-face":
      break;
    // 16.21 <style:font-face>
    case "paragraph-properties":
      break;
    // 17.6 <style:paragraph-properties>
    case "table-properties":
      break;
    // 17.15 <style:table-properties>
    case "table-column-properties":
      break;
    // 17.16 <style:table-column-properties>
    case "table-row-properties":
      break;
    // 17.17 <style:table-row-properties>
    case "table-cell-properties":
      break;
    // 17.18 <style:table-cell-properties>
    case "number":
      switch (qn[qn.length - 1][0]) {
        case "time-style":
        case "date-style":
          pa = parsexmltag(Sa[0], !1), va += number_formats_ods[Sa[3]][pa.style === "long" ? 1 : 0];
          break;
      }
      break;
    case "fraction":
      break;
    // TODO 16.27.6 <number:fraction>
    case "day":
    // 16.27.11 <number:day>
    case "month":
    // 16.27.12 <number:month>
    case "year":
    // 16.27.13 <number:year>
    case "era":
    // 16.27.14 <number:era>
    case "day-of-week":
    // 16.27.15 <number:day-of-week>
    case "week-of-year":
    // 16.27.16 <number:week-of-year>
    case "quarter":
    // 16.27.17 <number:quarter>
    case "hours":
    // 16.27.19 <number:hours>
    case "minutes":
    // 16.27.20 <number:minutes>
    case "seconds":
    // 16.27.21 <number:seconds>
    case "am-pm":
      switch (qn[qn.length - 1][0]) {
        case "time-style":
        case "date-style":
          pa = parsexmltag(Sa[0], !1), va += number_formats_ods[Sa[3]][pa.style === "long" ? 1 : 0];
          break;
      }
      break;
    case "boolean-style":
      break;
    // 16.27.23 <number:boolean-style>
    case "boolean":
      break;
    // 16.27.24 <number:boolean>
    case "text-style":
      break;
    // 16.27.25 <number:text-style>
    case "text":
      if (Sa[0].slice(-2) === "/>") break;
      if (Sa[1] === "/") switch (qn[qn.length - 1][0]) {
        case "number-style":
        case "date-style":
        case "time-style":
          va += Kn.slice(ba, Sa.index);
          break;
      }
      else ba = Sa.index + Sa[0].length;
      break;
    case "named-range":
      pa = parsexmltag(Sa[0], !1), Ml = ods_to_csf_3D(pa["cell-range-address"]);
      var kl = { Name: pa.name, Ref: Ml[0] + "!" + Ml[1] };
      Fl && (kl.Sheet = wa.length), El.Names.push(kl);
      break;
    case "text-content":
      break;
    // 16.27.27 <number:text-content>
    case "text-properties":
      break;
    // 16.27.27 <style:text-properties>
    case "embedded-text":
      break;
    // 16.27.4 <number:embedded-text>
    case "body":
    case "电子表格":
      break;
    // 3.3 16.9.6 19.726.3
    case "forms":
      break;
    // 12.25.2 13.2
    case "table-column":
      break;
    // 9.1.6 <table:table-column>
    case "table-header-rows":
      break;
    // 9.1.7 <table:table-header-rows>
    case "table-rows":
      break;
    // 9.1.12 <table:table-rows>
    /* TODO: outline levels */
    case "table-column-group":
      break;
    // 9.1.10 <table:table-column-group>
    case "table-header-columns":
      break;
    // 9.1.11 <table:table-header-columns>
    case "table-columns":
      break;
    // 9.1.12 <table:table-columns>
    case "null-date":
      break;
    // 9.4.2 <table:null-date> TODO: date1904
    case "graphic-properties":
      break;
    // 17.21 <style:graphic-properties>
    case "calculation-settings":
      break;
    // 9.4.1 <table:calculation-settings>
    case "named-expressions":
      break;
    // 9.4.11 <table:named-expressions>
    case "label-range":
      break;
    // 9.4.9 <table:label-range>
    case "label-ranges":
      break;
    // 9.4.10 <table:label-ranges>
    case "named-expression":
      break;
    // 9.4.13 <table:named-expression>
    case "sort":
      break;
    // 9.4.19 <table:sort>
    case "sort-by":
      break;
    // 9.4.20 <table:sort-by>
    case "sort-groups":
      break;
    // 9.4.22 <table:sort-groups>
    case "tab":
      break;
    // 6.1.4 <text:tab>
    case "line-break":
      break;
    // 6.1.5 <text:line-break>
    case "span":
      break;
    // 6.1.7 <text:span>
    case "p":
    case "文本串":
      if (["master-styles"].indexOf(qn[qn.length - 1][0]) > -1) break;
      if (Sa[1] === "/" && (!ka || !ka["string-value"])) {
        var ul = parse_text_p(Kn.slice(Na, Sa.index));
        Za = (Za.length > 0 ? Za + `
` : "") + ul[0];
      } else
        parsexmltag(Sa[0], !1), Na = Sa.index + Sa[0].length;
      break;
    // <text:p>
    case "s":
      break;
    // <text:s>
    case "database-range":
      if (Sa[1] === "/") break;
      try {
        Ml = ods_to_csf_3D(parsexmltag(Sa[0])["target-range-address"]), xa[Ml[0]]["!autofilter"] = { ref: Ml[1] };
      } catch {
      }
      break;
    case "date":
      break;
    // <*:date>
    case "object":
      break;
    // 10.4.6.2 <draw:object>
    case "title":
    case "标题":
      break;
    // <*:title> OR <uof:标题>
    case "desc":
      break;
    // <*:desc>
    case "binary-data":
      break;
    // 10.4.5 TODO: b64 blob
    /* 9.2 Advanced Tables */
    case "table-source":
      break;
    // 9.2.6
    case "scenario":
      break;
    // 9.2.6
    case "iteration":
      break;
    // 9.4.3 <table:iteration>
    case "content-validations":
      break;
    // 9.4.4 <table:
    case "content-validation":
      break;
    // 9.4.5 <table:
    case "help-message":
      break;
    // 9.4.6 <table:
    case "error-message":
      break;
    // 9.4.7 <table:
    case "database-ranges":
      break;
    // 9.4.14 <table:database-ranges>
    case "filter":
      break;
    // 9.5.2 <table:filter>
    case "filter-and":
      break;
    // 9.5.3 <table:filter-and>
    case "filter-or":
      break;
    // 9.5.4 <table:filter-or>
    case "filter-condition":
      break;
    // 9.5.5 <table:filter-condition>
    case "list-level-style-bullet":
      break;
    // 16.31 <text:
    case "list-level-style-number":
      break;
    // 16.32 <text:
    case "list-level-properties":
      break;
    // 17.19 <style:
    /* 7.3 Document Fields */
    case "sender-firstname":
    // 7.3.6.2
    case "sender-lastname":
    // 7.3.6.3
    case "sender-initials":
    // 7.3.6.4
    case "sender-title":
    // 7.3.6.5
    case "sender-position":
    // 7.3.6.6
    case "sender-email":
    // 7.3.6.7
    case "sender-phone-private":
    // 7.3.6.8
    case "sender-fax":
    // 7.3.6.9
    case "sender-company":
    // 7.3.6.10
    case "sender-phone-work":
    // 7.3.6.11
    case "sender-street":
    // 7.3.6.12
    case "sender-city":
    // 7.3.6.13
    case "sender-postal-code":
    // 7.3.6.14
    case "sender-country":
    // 7.3.6.15
    case "sender-state-or-province":
    // 7.3.6.16
    case "author-name":
    // 7.3.7.1
    case "author-initials":
    // 7.3.7.2
    case "chapter":
    // 7.3.8
    case "file-name":
    // 7.3.9
    case "template-name":
    // 7.3.9
    case "sheet-name":
      break;
    case "event-listener":
      break;
    /* TODO: FODS Properties */
    case "initial-creator":
    case "creation-date":
    case "print-date":
    case "generator":
    case "document-statistic":
    case "user-defined":
    case "editing-duration":
    case "editing-cycles":
      break;
    /* TODO: FODS Config */
    case "config-item":
      break;
    /* TODO: style tokens */
    case "page-number":
      break;
    // TODO <text:page-number>
    case "page-count":
      break;
    // TODO <text:page-count>
    case "time":
      break;
    // TODO <text:time>
    /* 9.3 Advanced Table Cells */
    case "cell-range-source":
      break;
    // 9.3.1 <table:
    case "detective":
      break;
    // 9.3.2 <table:
    case "operation":
      break;
    // 9.3.3 <table:
    case "highlighted-range":
      break;
    // 9.3.4 <table:
    /* 9.6 Data Pilot Tables <table: */
    case "data-pilot-table":
    // 9.6.3
    case "source-cell-range":
    // 9.6.5
    case "source-service":
    // 9.6.6
    case "data-pilot-field":
    // 9.6.7
    case "data-pilot-level":
    // 9.6.8
    case "data-pilot-subtotals":
    // 9.6.9
    case "data-pilot-subtotal":
    // 9.6.10
    case "data-pilot-members":
    // 9.6.11
    case "data-pilot-member":
    // 9.6.12
    case "data-pilot-display-info":
    // 9.6.13
    case "data-pilot-sort-info":
    // 9.6.14
    case "data-pilot-layout-info":
    // 9.6.15
    case "data-pilot-field-reference":
    // 9.6.16
    case "data-pilot-groups":
    // 9.6.17
    case "data-pilot-group":
    // 9.6.18
    case "data-pilot-group-member":
      break;
    /* 10.3 Drawing Shapes */
    case "rect":
      break;
    /* 14.6 DDE Connections */
    case "dde-connection-decls":
    // 14.6.2 <text:
    case "dde-connection-decl":
    // 14.6.3 <text:
    case "dde-link":
    // 14.6.4 <table:
    case "dde-source":
      break;
    case "properties":
      break;
    // 13.7 <form:properties>
    case "property":
      break;
    // 13.8 <form:property>
    case "a":
      if (Sa[1] !== "/") {
        if (fl = parsexmltag(Sa[0], !1), !fl.href) break;
        fl.Target = unescapexml(fl.href), delete fl.href, fl.Target.charAt(0) == "#" && fl.Target.indexOf(".") > -1 ? (Ml = ods_to_csf_3D(fl.Target.slice(1)), fl.Target = "#" + Ml[0] + "!" + Ml[1]) : fl.Target.match(/^\.\.[\\\/]/) && (fl.Target = fl.Target.slice(3));
      }
      break;
    /* non-standard */
    case "table-protection":
      break;
    case "data-pilot-grand-total":
      break;
    // <table:
    case "office-document-common-attrs":
      break;
    // bare
    default:
      switch (Sa[2]) {
        case "dc:":
        // TODO: properties
        case "calcext:":
        // ignore undocumented extensions
        case "loext:":
        // ignore undocumented extensions
        case "ooo:":
        // ignore undocumented extensions
        case "chartooo:":
        // ignore undocumented extensions
        case "draw:":
        // TODO: drawing
        case "style:":
        // TODO: styles
        case "chart:":
        // TODO: charts
        case "form:":
        // TODO: forms
        case "uof:":
        // TODO: uof
        case "表:":
        // TODO: uof
        case "字:":
          break;
        default:
          if (Un.WTF) throw new Error(Sa);
      }
  }
  var vl = {
    Sheets: xa,
    SheetNames: wa,
    Workbook: El
  };
  return Un.bookSheets && delete /*::(*/
  vl.Sheets, vl;
}
function parse_ods(Xn, zn) {
  zn = zn || {}, safegetzipfile(Xn, "META-INF/manifest.xml") && parse_manifest(getzipdata(Xn, "META-INF/manifest.xml"), zn);
  var Un = getzipstr(Xn, "content.xml");
  if (!Un) throw new Error("Missing content.xml in ODS / UOF file");
  var Kn = parse_content_xml(utf8read(Un), zn);
  return safegetzipfile(Xn, "meta.xml") && (Kn.Props = parse_core_props(getzipdata(Xn, "meta.xml"))), Kn;
}
function parse_fods(Xn, zn) {
  return parse_content_xml(Xn, zn);
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function u8_to_dataview(Xn) {
  return new DataView(Xn.buffer, Xn.byteOffset, Xn.byteLength);
}
function u8str(Xn) {
  return typeof TextDecoder < "u" ? new TextDecoder().decode(Xn) : utf8read(a2s(Xn));
}
function u8concat(Xn) {
  var zn = Xn.reduce(function(qn, Jo) {
    return qn + Jo.length;
  }, 0), Un = new Uint8Array(zn), Kn = 0;
  return Xn.forEach(function(qn) {
    Un.set(qn, Kn), Kn += qn.length;
  }), Un;
}
function popcnt(Xn) {
  return Xn -= Xn >> 1 & 1431655765, Xn = (Xn & 858993459) + (Xn >> 2 & 858993459), (Xn + (Xn >> 4) & 252645135) * 16843009 >>> 24;
}
function readDecimal128LE(Xn, zn) {
  for (var Un = (Xn[zn + 15] & 127) << 7 | Xn[zn + 14] >> 1, Kn = Xn[zn + 14] & 1, qn = zn + 13; qn >= zn; --qn)
    Kn = Kn * 256 + Xn[qn];
  return (Xn[zn + 15] & 128 ? -Kn : Kn) * Math.pow(10, Un - 6176);
}
function parse_varint49(Xn, zn) {
  var Un = zn ? zn[0] : 0, Kn = Xn[Un] & 127;
  e:
    if (Xn[Un++] >= 128 && (Kn |= (Xn[Un] & 127) << 7, Xn[Un++] < 128 || (Kn |= (Xn[Un] & 127) << 14, Xn[Un++] < 128) || (Kn |= (Xn[Un] & 127) << 21, Xn[Un++] < 128) || (Kn += (Xn[Un] & 127) * Math.pow(2, 28), ++Un, Xn[Un++] < 128) || (Kn += (Xn[Un] & 127) * Math.pow(2, 35), ++Un, Xn[Un++] < 128) || (Kn += (Xn[Un] & 127) * Math.pow(2, 42), ++Un, Xn[Un++] < 128)))
      break e;
  return zn && (zn[0] = Un), Kn;
}
function varint_to_i32(Xn) {
  var zn = 0, Un = Xn[zn] & 127;
  e:
    if (Xn[zn++] >= 128) {
      if (Un |= (Xn[zn] & 127) << 7, Xn[zn++] < 128 || (Un |= (Xn[zn] & 127) << 14, Xn[zn++] < 128) || (Un |= (Xn[zn] & 127) << 21, Xn[zn++] < 128))
        break e;
      Un |= (Xn[zn] & 127) << 28;
    }
  return Un;
}
function parse_shallow(Xn) {
  for (var zn = [], Un = [0]; Un[0] < Xn.length; ) {
    var Kn = Un[0], qn = parse_varint49(Xn, Un), Jo = qn & 7;
    qn = Math.floor(qn / 8);
    var pa = 0, ma;
    if (qn == 0)
      break;
    switch (Jo) {
      case 0:
        {
          for (var va = Un[0]; Xn[Un[0]++] >= 128; )
            ;
          ma = Xn.slice(va, Un[0]);
        }
        break;
      case 5:
        pa = 4, ma = Xn.slice(Un[0], Un[0] + pa), Un[0] += pa;
        break;
      case 1:
        pa = 8, ma = Xn.slice(Un[0], Un[0] + pa), Un[0] += pa;
        break;
      case 2:
        pa = parse_varint49(Xn, Un), ma = Xn.slice(Un[0], Un[0] + pa), Un[0] += pa;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(Jo, " for Field ").concat(qn, " at offset ").concat(Kn));
    }
    var ba = { data: ma, type: Jo };
    zn[qn] == null ? zn[qn] = [ba] : zn[qn].push(ba);
  }
  return zn;
}
function mappa(Xn, zn) {
  return (Xn == null ? void 0 : Xn.map(function(Un) {
    return zn(Un.data);
  })) || [];
}
function parse_iwa_file(Xn) {
  for (var zn, Un = [], Kn = [0]; Kn[0] < Xn.length; ) {
    var qn = parse_varint49(Xn, Kn), Jo = parse_shallow(Xn.slice(Kn[0], Kn[0] + qn));
    Kn[0] += qn;
    var pa = {
      id: varint_to_i32(Jo[1][0].data),
      messages: []
    };
    Jo[2].forEach(function(ma) {
      var va = parse_shallow(ma.data), ba = varint_to_i32(va[3][0].data);
      pa.messages.push({
        meta: va,
        data: Xn.slice(Kn[0], Kn[0] + ba)
      }), Kn[0] += ba;
    }), (zn = Jo[3]) != null && zn[0] && (pa.merge = varint_to_i32(Jo[3][0].data) >>> 0 > 0), Un.push(pa);
  }
  return Un;
}
function parse_snappy_chunk(Xn, zn) {
  if (Xn != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(Xn));
  for (var Un = [0], Kn = parse_varint49(zn, Un), qn = []; Un[0] < zn.length; ) {
    var Jo = zn[Un[0]] & 3;
    if (Jo == 0) {
      var pa = zn[Un[0]++] >> 2;
      if (pa < 60)
        ++pa;
      else {
        var ma = pa - 59;
        pa = zn[Un[0]], ma > 1 && (pa |= zn[Un[0] + 1] << 8), ma > 2 && (pa |= zn[Un[0] + 2] << 16), ma > 3 && (pa |= zn[Un[0] + 3] << 24), pa >>>= 0, pa++, Un[0] += ma;
      }
      qn.push(zn.slice(Un[0], Un[0] + pa)), Un[0] += pa;
      continue;
    } else {
      var va = 0, ba = 0;
      if (Jo == 1 ? (ba = (zn[Un[0]] >> 2 & 7) + 4, va = (zn[Un[0]++] & 224) << 3, va |= zn[Un[0]++]) : (ba = (zn[Un[0]++] >> 2) + 1, Jo == 2 ? (va = zn[Un[0]] | zn[Un[0] + 1] << 8, Un[0] += 2) : (va = (zn[Un[0]] | zn[Un[0] + 1] << 8 | zn[Un[0] + 2] << 16 | zn[Un[0] + 3] << 24) >>> 0, Un[0] += 4)), qn = [u8concat(qn)], va == 0)
        throw new Error("Invalid offset 0");
      if (va > qn[0].length)
        throw new Error("Invalid offset beyond length");
      if (ba >= va)
        for (qn.push(qn[0].slice(-va)), ba -= va; ba >= qn[qn.length - 1].length; )
          qn.push(qn[qn.length - 1]), ba -= qn[qn.length - 1].length;
      qn.push(qn[0].slice(-va, -va + ba));
    }
  }
  var _a = u8concat(qn);
  if (_a.length != Kn)
    throw new Error("Unexpected length: ".concat(_a.length, " != ").concat(Kn));
  return _a;
}
function decompress_iwa_file(Xn) {
  for (var zn = [], Un = 0; Un < Xn.length; ) {
    var Kn = Xn[Un++], qn = Xn[Un] | Xn[Un + 1] << 8 | Xn[Un + 2] << 16;
    Un += 3, zn.push(parse_snappy_chunk(Kn, Xn.slice(Un, Un + qn))), Un += qn;
  }
  if (Un !== Xn.length)
    throw new Error("data is not a valid framed stream!");
  return u8concat(zn);
}
function parse_old_storage(Xn, zn, Un, Kn) {
  var qn = u8_to_dataview(Xn), Jo = qn.getUint32(4, !0), pa = (Kn > 1 ? 12 : 8) + popcnt(Jo & (Kn > 1 ? 3470 : 398)) * 4, ma = -1, va = -1, ba = NaN, _a = new Date(2001, 0, 1);
  Jo & 512 && (ma = qn.getUint32(pa, !0), pa += 4), pa += popcnt(Jo & (Kn > 1 ? 12288 : 4096)) * 4, Jo & 16 && (va = qn.getUint32(pa, !0), pa += 4), Jo & 32 && (ba = qn.getFloat64(pa, !0), pa += 8), Jo & 64 && (_a.setTime(_a.getTime() + qn.getFloat64(pa, !0) * 1e3), pa += 8);
  var ya;
  switch (Xn[2]) {
    case 0:
      break;
    case 2:
      ya = { t: "n", v: ba };
      break;
    case 3:
      ya = { t: "s", v: zn[va] };
      break;
    case 5:
      ya = { t: "d", v: _a };
      break;
    case 6:
      ya = { t: "b", v: ba > 0 };
      break;
    case 7:
      ya = { t: "n", v: ba / 86400 };
      break;
    case 8:
      ya = { t: "e", v: 0 };
      break;
    case 9:
      if (ma > -1)
        ya = { t: "s", v: Un[ma] };
      else if (va > -1)
        ya = { t: "s", v: zn[va] };
      else if (!isNaN(ba))
        ya = { t: "n", v: ba };
      else
        throw new Error("Unsupported cell type ".concat(Xn.slice(0, 4)));
      break;
    default:
      throw new Error("Unsupported cell type ".concat(Xn.slice(0, 4)));
  }
  return ya;
}
function parse_new_storage(Xn, zn, Un) {
  var Kn = u8_to_dataview(Xn), qn = Kn.getUint32(8, !0), Jo = 12, pa = -1, ma = -1, va = NaN, ba = NaN, _a = new Date(2001, 0, 1);
  qn & 1 && (va = readDecimal128LE(Xn, Jo), Jo += 16), qn & 2 && (ba = Kn.getFloat64(Jo, !0), Jo += 8), qn & 4 && (_a.setTime(_a.getTime() + Kn.getFloat64(Jo, !0) * 1e3), Jo += 8), qn & 8 && (ma = Kn.getUint32(Jo, !0), Jo += 4), qn & 16 && (pa = Kn.getUint32(Jo, !0), Jo += 4);
  var ya;
  switch (Xn[1]) {
    case 0:
      break;
    case 2:
      ya = { t: "n", v: va };
      break;
    case 3:
      ya = { t: "s", v: zn[ma] };
      break;
    case 5:
      ya = { t: "d", v: _a };
      break;
    case 6:
      ya = { t: "b", v: ba > 0 };
      break;
    case 7:
      ya = { t: "n", v: ba / 86400 };
      break;
    case 8:
      ya = { t: "e", v: 0 };
      break;
    case 9:
      if (pa > -1)
        ya = { t: "s", v: Un[pa] };
      else
        throw new Error("Unsupported cell type ".concat(Xn[1], " : ").concat(qn & 31, " : ").concat(Xn.slice(0, 4)));
      break;
    case 10:
      ya = { t: "n", v: va };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(Xn[1], " : ").concat(qn & 31, " : ").concat(Xn.slice(0, 4)));
  }
  return ya;
}
function parse_cell_storage(Xn, zn, Un) {
  switch (Xn[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
      return parse_old_storage(Xn, zn, Un, Xn[0]);
    case 5:
      return parse_new_storage(Xn, zn, Un);
    default:
      throw new Error("Unsupported payload version ".concat(Xn[0]));
  }
}
function parse_TSP_Reference(Xn) {
  var zn = parse_shallow(Xn);
  return parse_varint49(zn[1][0].data);
}
function parse_TST_TableDataList(Xn, zn) {
  var Un = parse_shallow(zn.data), Kn = varint_to_i32(Un[1][0].data), qn = Un[3], Jo = [];
  return (qn || []).forEach(function(pa) {
    var ma = parse_shallow(pa.data), va = varint_to_i32(ma[1][0].data) >>> 0;
    switch (Kn) {
      case 1:
        Jo[va] = u8str(ma[3][0].data);
        break;
      case 8:
        {
          var ba = Xn[parse_TSP_Reference(ma[9][0].data)][0], _a = parse_shallow(ba.data), ya = Xn[parse_TSP_Reference(_a[1][0].data)][0], xa = varint_to_i32(ya.meta[1][0].data);
          if (xa != 2001)
            throw new Error("2000 unexpected reference to ".concat(xa));
          var wa = parse_shallow(ya.data);
          Jo[va] = wa[3].map(function(Ta) {
            return u8str(Ta.data);
          }).join("");
        }
        break;
    }
  }), Jo;
}
function parse_TST_TileRowInfo(Xn, zn) {
  var Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma = parse_shallow(Xn), ka = varint_to_i32(Ma[1][0].data) >>> 0, Za = varint_to_i32(Ma[2][0].data) >>> 0, Na = ((Kn = (Un = Ma[8]) == null ? void 0 : Un[0]) == null ? void 0 : Kn.data) && varint_to_i32(Ma[8][0].data) > 0 || !1, Ka, Ja;
  if ((Jo = (qn = Ma[7]) == null ? void 0 : qn[0]) != null && Jo.data && zn != 0)
    Ka = (ma = (pa = Ma[7]) == null ? void 0 : pa[0]) == null ? void 0 : ma.data, Ja = (ba = (va = Ma[6]) == null ? void 0 : va[0]) == null ? void 0 : ba.data;
  else if ((ya = (_a = Ma[4]) == null ? void 0 : _a[0]) != null && ya.data && zn != 1)
    Ka = (wa = (xa = Ma[4]) == null ? void 0 : xa[0]) == null ? void 0 : wa.data, Ja = (Sa = (Ta = Ma[3]) == null ? void 0 : Ta[0]) == null ? void 0 : Sa.data;
  else
    throw "NUMBERS Tile missing ".concat(zn, " cell storage");
  for (var el = Na ? 4 : 1, qa = u8_to_dataview(Ka), tl = [], Qa = 0; Qa < Ka.length / 2; ++Qa) {
    var nl = qa.getUint16(Qa * 2, !0);
    nl < 65535 && tl.push([Qa, nl]);
  }
  if (tl.length != Za)
    throw "Expected ".concat(Za, " cells, found ").concat(tl.length);
  var rl = [];
  for (Qa = 0; Qa < tl.length - 1; ++Qa)
    rl[tl[Qa][0]] = Ja.subarray(tl[Qa][1] * el, tl[Qa + 1][1] * el);
  return tl.length >= 1 && (rl[tl[tl.length - 1][0]] = Ja.subarray(tl[tl.length - 1][1] * el)), { R: ka, cells: rl };
}
function parse_TST_Tile(Xn, zn) {
  var Un, Kn = parse_shallow(zn.data), qn = (Un = Kn == null ? void 0 : Kn[7]) != null && Un[0] ? varint_to_i32(Kn[7][0].data) >>> 0 > 0 ? 1 : 0 : -1, Jo = mappa(Kn[5], function(pa) {
    return parse_TST_TileRowInfo(pa, qn);
  });
  return {
    nrows: varint_to_i32(Kn[4][0].data) >>> 0,
    data: Jo.reduce(function(pa, ma) {
      return pa[ma.R] || (pa[ma.R] = []), ma.cells.forEach(function(va, ba) {
        if (pa[ma.R][ba])
          throw new Error("Duplicate cell r=".concat(ma.R, " c=").concat(ba));
        pa[ma.R][ba] = va;
      }), pa;
    }, [])
  };
}
function parse_TST_TableModelArchive(Xn, zn, Un) {
  var Kn, qn = parse_shallow(zn.data), Jo = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  if (Jo.e.r = (varint_to_i32(qn[6][0].data) >>> 0) - 1, Jo.e.r < 0)
    throw new Error("Invalid row varint ".concat(qn[6][0].data));
  if (Jo.e.c = (varint_to_i32(qn[7][0].data) >>> 0) - 1, Jo.e.c < 0)
    throw new Error("Invalid col varint ".concat(qn[7][0].data));
  Un["!ref"] = encode_range(Jo);
  var pa = parse_shallow(qn[4][0].data), ma = parse_TST_TableDataList(Xn, Xn[parse_TSP_Reference(pa[4][0].data)][0]), va = (Kn = pa[17]) != null && Kn[0] ? parse_TST_TableDataList(Xn, Xn[parse_TSP_Reference(pa[17][0].data)][0]) : [], ba = parse_shallow(pa[3][0].data), _a = 0;
  ba[1].forEach(function(ya) {
    var xa = parse_shallow(ya.data), wa = Xn[parse_TSP_Reference(xa[2][0].data)][0], Ta = varint_to_i32(wa.meta[1][0].data);
    if (Ta != 6002)
      throw new Error("6001 unexpected reference to ".concat(Ta));
    var Sa = parse_TST_Tile(Xn, wa);
    Sa.data.forEach(function(Ma, ka) {
      Ma.forEach(function(Za, Na) {
        var Ka = encode_cell({ r: _a + ka, c: Na }), Ja = parse_cell_storage(Za, ma, va);
        Ja && (Un[Ka] = Ja);
      });
    }), _a += Sa.nrows;
  });
}
function parse_TST_TableInfoArchive(Xn, zn) {
  var Un = parse_shallow(zn.data), Kn = { "!ref": "A1" }, qn = Xn[parse_TSP_Reference(Un[2][0].data)], Jo = varint_to_i32(qn[0].meta[1][0].data);
  if (Jo != 6001)
    throw new Error("6000 unexpected reference to ".concat(Jo));
  return parse_TST_TableModelArchive(Xn, qn[0], Kn), Kn;
}
function parse_TN_SheetArchive(Xn, zn) {
  var Un, Kn = parse_shallow(zn.data), qn = {
    name: (Un = Kn[1]) != null && Un[0] ? u8str(Kn[1][0].data) : "",
    sheets: []
  }, Jo = mappa(Kn[2], parse_TSP_Reference);
  return Jo.forEach(function(pa) {
    Xn[pa].forEach(function(ma) {
      var va = varint_to_i32(ma.meta[1][0].data);
      va == 6e3 && qn.sheets.push(parse_TST_TableInfoArchive(Xn, ma));
    });
  }), qn;
}
function parse_TN_DocumentArchive(Xn, zn) {
  var Un = book_new(), Kn = parse_shallow(zn.data), qn = mappa(Kn[1], parse_TSP_Reference);
  if (qn.forEach(function(Jo) {
    Xn[Jo].forEach(function(pa) {
      var ma = varint_to_i32(pa.meta[1][0].data);
      if (ma == 2) {
        var va = parse_TN_SheetArchive(Xn, pa);
        va.sheets.forEach(function(ba, _a) {
          book_append_sheet(Un, ba, _a == 0 ? va.name : va.name + "_" + _a, !0);
        });
      }
    });
  }), Un.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  return Un;
}
function parse_numbers_iwa(Xn) {
  var zn, Un, Kn, qn, Jo = {}, pa = [];
  if (Xn.FullPaths.forEach(function(va) {
    if (va.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  }), Xn.FileIndex.forEach(function(va) {
    if (va.name.match(/\.iwa$/)) {
      var ba;
      try {
        ba = decompress_iwa_file(va.content);
      } catch (ya) {
        return console.log("?? " + va.content.length + " " + (ya.message || ya));
      }
      var _a;
      try {
        _a = parse_iwa_file(ba);
      } catch (ya) {
        return console.log("## " + (ya.message || ya));
      }
      _a.forEach(function(ya) {
        Jo[ya.id] = ya.messages, pa.push(ya.id);
      });
    }
  }), !pa.length)
    throw new Error("File has no messages");
  var ma = ((qn = (Kn = (Un = (zn = Jo == null ? void 0 : Jo[1]) == null ? void 0 : zn[0]) == null ? void 0 : Un.meta) == null ? void 0 : Kn[1]) == null ? void 0 : qn[0].data) && varint_to_i32(Jo[1][0].meta[1][0].data) == 1 && Jo[1][0];
  if (ma || pa.forEach(function(va) {
    Jo[va].forEach(function(ba) {
      var _a = varint_to_i32(ba.meta[1][0].data) >>> 0;
      if (_a == 1)
        if (!ma)
          ma = ba;
        else
          throw new Error("Document has multiple roots");
    });
  }), !ma)
    throw new Error("Cannot find Document root");
  return parse_TN_DocumentArchive(Jo, ma);
}
function fix_opts_func(Xn) {
  return function(Un) {
    for (var Kn = 0; Kn != Xn.length; ++Kn) {
      var qn = Xn[Kn];
      Un[qn[0]] === void 0 && (Un[qn[0]] = qn[1]), qn[2] === "n" && (Un[qn[0]] = Number(Un[qn[0]]));
    }
  };
}
function fix_read_opts(Xn) {
  fix_opts_func([
    ["cellNF", !1],
    /* emit cell number format string as .z */
    ["cellHTML", !0],
    /* emit html string as .h */
    ["cellFormula", !0],
    /* emit formulae as .f */
    ["cellStyles", !1],
    /* emits style/theme as .s */
    ["cellText", !0],
    /* emit formatted text as .w */
    ["cellDates", !1],
    /* emit date cells with type `d` */
    ["sheetStubs", !1],
    /* emit empty cells */
    ["sheetRows", 0, "n"],
    /* read n rows (0 = read all rows) */
    ["bookDeps", !1],
    /* parse calculation chains */
    ["bookSheets", !1],
    /* only try to get sheet names (no Sheets) */
    ["bookProps", !1],
    /* only try to get properties (no Sheets) */
    ["bookFiles", !1],
    /* include raw file structure (keys, files, cfb) */
    ["bookVBA", !1],
    /* include vba raw data (vbaraw) */
    ["password", ""],
    /* password */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(Xn);
}
function get_sheet_type(Xn) {
  return RELS.WS.indexOf(Xn) > -1 ? "sheet" : Xn == RELS.CS ? "chart" : Xn == RELS.DS ? "dialog" : Xn == RELS.MS ? "macro" : Xn && Xn.length ? Xn : "sheet";
}
function safe_parse_wbrels(Xn, zn) {
  if (!Xn) return 0;
  try {
    Xn = zn.map(function(Kn) {
      return Kn.id || (Kn.id = Kn.strRelID), [Kn.name, Xn["!id"][Kn.id].Target, get_sheet_type(Xn["!id"][Kn.id].Type)];
    });
  } catch {
    return null;
  }
  return !Xn || Xn.length === 0 ? null : Xn;
}
function safe_parse_sheet(Xn, zn, Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya) {
  try {
    Jo[Kn] = parse_rels(getzipstr(Xn, Un, !0), zn);
    var xa = getzipdata(Xn, zn), wa;
    switch (ma) {
      case "sheet":
        wa = parse_ws(xa, zn, qn, va, Jo[Kn], ba, _a, ya);
        break;
      case "chart":
        if (wa = parse_cs(xa, zn, qn, va, Jo[Kn], ba, _a, ya), !wa || !wa["!drawel"]) break;
        var Ta = resolve_path(wa["!drawel"].Target, zn), Sa = get_rels_path(Ta), Ma = parse_drawing(getzipstr(Xn, Ta, !0), parse_rels(getzipstr(Xn, Sa, !0), Ta)), ka = resolve_path(Ma, Ta), Za = get_rels_path(ka);
        wa = parse_chart(getzipstr(Xn, ka, !0), ka, va, parse_rels(getzipstr(Xn, Za, !0), ka), ba, wa);
        break;
      case "macro":
        wa = parse_ms(xa, zn, qn, va, Jo[Kn], ba, _a, ya);
        break;
      case "dialog":
        wa = parse_ds(xa, zn, qn, va, Jo[Kn], ba, _a, ya);
        break;
      default:
        throw new Error("Unrecognized sheet type " + ma);
    }
    pa[Kn] = wa;
    var Na = [];
    Jo && Jo[Kn] && keys(Jo[Kn]).forEach(function(Ka) {
      var Ja = "";
      if (Jo[Kn][Ka].Type == RELS.CMNT) {
        Ja = resolve_path(Jo[Kn][Ka].Target, zn);
        var el = parse_cmnt(getzipdata(Xn, Ja, !0), Ja, va);
        if (!el || !el.length) return;
        sheet_insert_comments(wa, el, !1);
      }
      Jo[Kn][Ka].Type == RELS.TCMNT && (Ja = resolve_path(Jo[Kn][Ka].Target, zn), Na = Na.concat(parse_tcmnt_xml(getzipdata(Xn, Ja, !0), va)));
    }), Na && Na.length && sheet_insert_comments(wa, Na, !0, va.people || []);
  } catch (Ka) {
    if (va.WTF) throw Ka;
  }
}
function strip_front_slash(Xn) {
  return Xn.charAt(0) == "/" ? Xn.slice(1) : Xn;
}
function parse_zip(Xn, zn) {
  if (make_ssf(), zn = zn || {}, fix_read_opts(zn), safegetzipfile(Xn, "META-INF/manifest.xml") || safegetzipfile(Xn, "objectdata.xml")) return parse_ods(Xn, zn);
  if (safegetzipfile(Xn, "Index/Document.iwa")) {
    if (typeof Uint8Array > "u") throw new Error("NUMBERS file parsing requires Uint8Array support");
    if (typeof parse_numbers_iwa < "u") {
      if (Xn.FileIndex) return parse_numbers_iwa(Xn);
      var Un = CFB.utils.cfb_new();
      return zipentries(Xn).forEach(function(ll) {
        zip_add_file(Un, ll, getzipbin(Xn, ll));
      }), parse_numbers_iwa(Un);
    }
    throw new Error("Unsupported NUMBERS file");
  }
  if (!safegetzipfile(Xn, "[Content_Types].xml"))
    throw safegetzipfile(Xn, "index.xml.gz") ? new Error("Unsupported NUMBERS 08 file") : safegetzipfile(Xn, "index.xml") ? new Error("Unsupported NUMBERS 09 file") : new Error("Unsupported ZIP file");
  var Kn = zipentries(Xn), qn = parse_ct(getzipstr(Xn, "[Content_Types].xml")), Jo = !1, pa, ma;
  if (qn.workbooks.length === 0 && (ma = "xl/workbook.xml", getzipdata(Xn, ma, !0) && qn.workbooks.push(ma)), qn.workbooks.length === 0) {
    if (ma = "xl/workbook.bin", !getzipdata(Xn, ma, !0)) throw new Error("Could not find workbook");
    qn.workbooks.push(ma), Jo = !0;
  }
  qn.workbooks[0].slice(-3) == "bin" && (Jo = !0);
  var va = {}, ba = {};
  if (!zn.bookSheets && !zn.bookProps) {
    if (strs = [], qn.sst) try {
      strs = parse_sst(getzipdata(Xn, strip_front_slash(qn.sst)), qn.sst, zn);
    } catch (ll) {
      if (zn.WTF) throw ll;
    }
    zn.cellStyles && qn.themes.length && (va = parse_theme(getzipstr(Xn, qn.themes[0].replace(/^\//, ""), !0) || "", qn.themes[0], zn)), qn.style && (ba = parse_sty(getzipdata(Xn, strip_front_slash(qn.style)), qn.style, va, zn));
  }
  qn.links.map(function(ll) {
    try {
      var al = parse_rels(getzipstr(Xn, get_rels_path(strip_front_slash(ll))), ll);
      return parse_xlink(getzipdata(Xn, strip_front_slash(ll)), al, ll, zn);
    } catch {
    }
  });
  var _a = parse_wb(getzipdata(Xn, strip_front_slash(qn.workbooks[0])), qn.workbooks[0], zn), ya = {}, xa = "";
  qn.coreprops.length && (xa = getzipdata(Xn, strip_front_slash(qn.coreprops[0]), !0), xa && (ya = parse_core_props(xa)), qn.extprops.length !== 0 && (xa = getzipdata(Xn, strip_front_slash(qn.extprops[0]), !0), xa && parse_ext_props(xa, ya, zn)));
  var wa = {};
  (!zn.bookSheets || zn.bookProps) && qn.custprops.length !== 0 && (xa = getzipstr(Xn, strip_front_slash(qn.custprops[0]), !0), xa && (wa = parse_cust_props(xa, zn)));
  var Ta = {};
  if ((zn.bookSheets || zn.bookProps) && (_a.Sheets ? pa = _a.Sheets.map(function(al) {
    return al.name;
  }) : ya.Worksheets && ya.SheetNames.length > 0 && (pa = ya.SheetNames), zn.bookProps && (Ta.Props = ya, Ta.Custprops = wa), zn.bookSheets && typeof pa < "u" && (Ta.SheetNames = pa), zn.bookSheets ? Ta.SheetNames : zn.bookProps))
    return Ta;
  pa = {};
  var Sa = {};
  zn.bookDeps && qn.calcchain && (Sa = parse_cc(getzipdata(Xn, strip_front_slash(qn.calcchain)), qn.calcchain));
  var Ma = 0, ka = {}, Za, Na;
  {
    var Ka = _a.Sheets;
    ya.Worksheets = Ka.length, ya.SheetNames = [];
    for (var Ja = 0; Ja != Ka.length; ++Ja)
      ya.SheetNames[Ja] = Ka[Ja].name;
  }
  var el = Jo ? "bin" : "xml", qa = qn.workbooks[0].lastIndexOf("/"), tl = (qn.workbooks[0].slice(0, qa + 1) + "_rels/" + qn.workbooks[0].slice(qa + 1) + ".rels").replace(/^\//, "");
  safegetzipfile(Xn, tl) || (tl = "xl/_rels/workbook." + el + ".rels");
  var Qa = parse_rels(getzipstr(Xn, tl, !0), tl.replace(/_rels.*/, "s5s"));
  (qn.metadata || []).length >= 1 && (zn.xlmeta = parse_xlmeta(getzipdata(Xn, strip_front_slash(qn.metadata[0])), qn.metadata[0], zn)), (qn.people || []).length >= 1 && (zn.people = parse_people_xml(getzipdata(Xn, strip_front_slash(qn.people[0])), zn)), Qa && (Qa = safe_parse_wbrels(Qa, _a.Sheets));
  var nl = getzipdata(Xn, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
  e: for (Ma = 0; Ma != ya.Worksheets; ++Ma) {
    var rl = "sheet";
    if (Qa && Qa[Ma] ? (Za = "xl/" + Qa[Ma][1].replace(/[\/]?xl\//, ""), safegetzipfile(Xn, Za) || (Za = Qa[Ma][1]), safegetzipfile(Xn, Za) || (Za = tl.replace(/_rels\/.*$/, "") + Qa[Ma][1]), rl = Qa[Ma][2]) : (Za = "xl/worksheets/sheet" + (Ma + 1 - nl) + "." + el, Za = Za.replace(/sheet0\./, "sheet.")), Na = Za.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), zn && zn.sheets != null) switch (typeof zn.sheets) {
      case "number":
        if (Ma != zn.sheets) continue e;
        break;
      case "string":
        if (ya.SheetNames[Ma].toLowerCase() != zn.sheets.toLowerCase()) continue e;
        break;
      default:
        if (Array.isArray && Array.isArray(zn.sheets)) {
          for (var il = !1, cl = 0; cl != zn.sheets.length; ++cl)
            typeof zn.sheets[cl] == "number" && zn.sheets[cl] == Ma && (il = 1), typeof zn.sheets[cl] == "string" && zn.sheets[cl].toLowerCase() == ya.SheetNames[Ma].toLowerCase() && (il = 1);
          if (!il) continue e;
        }
    }
    safe_parse_sheet(Xn, Za, Na, ya.SheetNames[Ma], Ma, ka, pa, rl, zn, _a, va, ba);
  }
  return Ta = {
    Directory: qn,
    Workbook: _a,
    Props: ya,
    Custprops: wa,
    Deps: Sa,
    Sheets: pa,
    SheetNames: ya.SheetNames,
    Strings: strs,
    Styles: ba,
    Themes: va,
    SSF: dup(table_fmt)
  }, zn && zn.bookFiles && (Xn.files ? (Ta.keys = Kn, Ta.files = Xn.files) : (Ta.keys = [], Ta.files = {}, Xn.FullPaths.forEach(function(ll, al) {
    ll = ll.replace(/^Root Entry[\/]/, ""), Ta.keys.push(ll), Ta.files[ll] = Xn.FileIndex[al];
  }))), zn && zn.bookVBA && (qn.vba.length > 0 ? Ta.vbaraw = getzipdata(Xn, strip_front_slash(qn.vba[0]), !0) : qn.defaults && qn.defaults.bin === CT_VBA && (Ta.vbaraw = getzipdata(Xn, "xl/vbaProject.bin", !0))), Ta;
}
function parse_xlsxcfb(Xn, zn) {
  var Un = zn || {}, Kn = "Workbook", qn = CFB.find(Xn, Kn);
  try {
    if (Kn = "/!DataSpaces/Version", qn = CFB.find(Xn, Kn), !qn || !qn.content) throw new Error("ECMA-376 Encrypted file missing " + Kn);
    if (parse_DataSpaceVersionInfo(qn.content), Kn = "/!DataSpaces/DataSpaceMap", qn = CFB.find(Xn, Kn), !qn || !qn.content) throw new Error("ECMA-376 Encrypted file missing " + Kn);
    var Jo = parse_DataSpaceMap(qn.content);
    if (Jo.length !== 1 || Jo[0].comps.length !== 1 || Jo[0].comps[0].t !== 0 || Jo[0].name !== "StrongEncryptionDataSpace" || Jo[0].comps[0].v !== "EncryptedPackage")
      throw new Error("ECMA-376 Encrypted file bad " + Kn);
    if (Kn = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", qn = CFB.find(Xn, Kn), !qn || !qn.content) throw new Error("ECMA-376 Encrypted file missing " + Kn);
    var pa = parse_DataSpaceDefinition(qn.content);
    if (pa.length != 1 || pa[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + Kn);
    if (Kn = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", qn = CFB.find(Xn, Kn), !qn || !qn.content) throw new Error("ECMA-376 Encrypted file missing " + Kn);
    parse_Primary(qn.content);
  } catch {
  }
  if (Kn = "/EncryptionInfo", qn = CFB.find(Xn, Kn), !qn || !qn.content) throw new Error("ECMA-376 Encrypted file missing " + Kn);
  var ma = parse_EncryptionInfo(qn.content);
  if (Kn = "/EncryptedPackage", qn = CFB.find(Xn, Kn), !qn || !qn.content) throw new Error("ECMA-376 Encrypted file missing " + Kn);
  if (ma[0] == 4 && typeof decrypt_agile < "u") return decrypt_agile(ma[1], qn.content, Un.password || "", Un);
  if (ma[0] == 2 && typeof decrypt_std76 < "u") return decrypt_std76(ma[1], qn.content, Un.password || "", Un);
  throw new Error("File is password-protected");
}
function firstbyte(Xn, zn) {
  var Un = "";
  switch ((zn || {}).type || "base64") {
    case "buffer":
      return [Xn[0], Xn[1], Xn[2], Xn[3], Xn[4], Xn[5], Xn[6], Xn[7]];
    case "base64":
      Un = Base64_decode(Xn.slice(0, 12));
      break;
    case "binary":
      Un = Xn;
      break;
    case "array":
      return [Xn[0], Xn[1], Xn[2], Xn[3], Xn[4], Xn[5], Xn[6], Xn[7]];
    default:
      throw new Error("Unrecognized type " + (zn && zn.type || "undefined"));
  }
  return [Un.charCodeAt(0), Un.charCodeAt(1), Un.charCodeAt(2), Un.charCodeAt(3), Un.charCodeAt(4), Un.charCodeAt(5), Un.charCodeAt(6), Un.charCodeAt(7)];
}
function read_cfb(Xn, zn) {
  return CFB.find(Xn, "EncryptedPackage") ? parse_xlsxcfb(Xn, zn) : parse_xlscfb(Xn, zn);
}
function read_zip(Xn, zn) {
  var Un, Kn = Xn, qn = zn || {};
  return qn.type || (qn.type = has_buf && Buffer.isBuffer(Xn) ? "buffer" : "base64"), Un = zip_read(Kn, qn), parse_zip(Un, qn);
}
function read_plaintext(Xn, zn) {
  var Un = 0;
  e: for (; Un < Xn.length; ) switch (Xn.charCodeAt(Un)) {
    case 10:
    case 13:
    case 32:
      ++Un;
      break;
    case 60:
      return parse_xlml(Xn.slice(Un), zn);
    default:
      break e;
  }
  return PRN.to_workbook(Xn, zn);
}
function read_plaintext_raw(Xn, zn) {
  var Un = "", Kn = firstbyte(Xn, zn);
  switch (zn.type) {
    case "base64":
      Un = Base64_decode(Xn);
      break;
    case "binary":
      Un = Xn;
      break;
    case "buffer":
      Un = Xn.toString("binary");
      break;
    case "array":
      Un = cc2str(Xn);
      break;
    default:
      throw new Error("Unrecognized type " + zn.type);
  }
  return Kn[0] == 239 && Kn[1] == 187 && Kn[2] == 191 && (Un = utf8read(Un)), zn.type = "binary", read_plaintext(Un, zn);
}
function read_utf16(Xn, zn) {
  var Un = Xn;
  return zn.type == "base64" && (Un = Base64_decode(Un)), Un = $cptable.utils.decode(1200, Un.slice(2), "str"), zn.type = "binary", read_plaintext(Un, zn);
}
function bstrify(Xn) {
  return Xn.match(/[^\x00-\x7F]/) ? utf8write(Xn) : Xn;
}
function read_prn(Xn, zn, Un, Kn) {
  return Kn ? (Un.type = "string", PRN.to_workbook(Xn, Un)) : PRN.to_workbook(zn, Un);
}
function readSync(Xn, zn) {
  reset_cp();
  var Un = zn || {};
  if (typeof ArrayBuffer < "u" && Xn instanceof ArrayBuffer) return readSync(new Uint8Array(Xn), (Un = dup(Un), Un.type = "array", Un));
  typeof Uint8Array < "u" && Xn instanceof Uint8Array && !Un.type && (Un.type = typeof Deno < "u" ? "buffer" : "array");
  var Kn = Xn, qn = [0, 0, 0, 0], Jo = !1;
  if (Un.cellStyles && (Un.cellNF = !0, Un.sheetStubs = !0), _ssfopts = {}, Un.dateNF && (_ssfopts.dateNF = Un.dateNF), Un.type || (Un.type = has_buf && Buffer.isBuffer(Xn) ? "buffer" : "base64"), Un.type == "file" && (Un.type = has_buf ? "buffer" : "binary", Kn = read_binary(Xn), typeof Uint8Array < "u" && !has_buf && (Un.type = "array")), Un.type == "string" && (Jo = !0, Un.type = "binary", Un.codepage = 65001, Kn = bstrify(Xn)), Un.type == "array" && typeof Uint8Array < "u" && Xn instanceof Uint8Array && typeof ArrayBuffer < "u") {
    var pa = new ArrayBuffer(3), ma = new Uint8Array(pa);
    if (ma.foo = "bar", !ma.foo)
      return Un = dup(Un), Un.type = "array", readSync(ab2a(Kn), Un);
  }
  switch ((qn = firstbyte(Kn, Un))[0]) {
    case 208:
      if (qn[1] === 207 && qn[2] === 17 && qn[3] === 224 && qn[4] === 161 && qn[5] === 177 && qn[6] === 26 && qn[7] === 225) return read_cfb(CFB.read(Kn, Un), Un);
      break;
    case 9:
      if (qn[1] <= 8) return parse_xlscfb(Kn, Un);
      break;
    case 60:
      return parse_xlml(Kn, Un);
    case 73:
      if (qn[1] === 73 && qn[2] === 42 && qn[3] === 0) throw new Error("TIFF Image File is not a spreadsheet");
      if (qn[1] === 68) return read_wb_ID(Kn, Un);
      break;
    case 84:
      if (qn[1] === 65 && qn[2] === 66 && qn[3] === 76) return DIF.to_workbook(Kn, Un);
      break;
    case 80:
      return qn[1] === 75 && qn[2] < 9 && qn[3] < 9 ? read_zip(Kn, Un) : read_prn(Xn, Kn, Un, Jo);
    case 239:
      return qn[3] === 60 ? parse_xlml(Kn, Un) : read_prn(Xn, Kn, Un, Jo);
    case 255:
      if (qn[1] === 254)
        return read_utf16(Kn, Un);
      if (qn[1] === 0 && qn[2] === 2 && qn[3] === 0) return WK_.to_workbook(Kn, Un);
      break;
    case 0:
      if (qn[1] === 0 && (qn[2] >= 2 && qn[3] === 0 || qn[2] === 0 && (qn[3] === 8 || qn[3] === 9)))
        return WK_.to_workbook(Kn, Un);
      break;
    case 3:
    case 131:
    case 139:
    case 140:
      return DBF.to_workbook(Kn, Un);
    case 123:
      if (qn[1] === 92 && qn[2] === 114 && qn[3] === 116) return RTF.to_workbook(Kn, Un);
      break;
    case 10:
    case 13:
    case 32:
      return read_plaintext_raw(Kn, Un);
    case 137:
      if (qn[1] === 80 && qn[2] === 78 && qn[3] === 71) throw new Error("PNG Image File is not a spreadsheet");
      break;
  }
  return DBF_SUPPORTED_VERSIONS.indexOf(qn[0]) > -1 && qn[2] <= 12 && qn[3] <= 31 ? DBF.to_workbook(Kn, Un) : read_prn(Xn, Kn, Un, Jo);
}
function make_json_row(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  var va = encode_row(Un), ba = ma.defval, _a = ma.raw || !Object.prototype.hasOwnProperty.call(ma, "raw"), ya = !0, xa = qn === 1 ? [] : {};
  if (qn !== 1)
    if (Object.defineProperty) try {
      Object.defineProperty(xa, "__rowNum__", { value: Un, enumerable: !1 });
    } catch {
      xa.__rowNum__ = Un;
    }
    else xa.__rowNum__ = Un;
  if (!pa || Xn[Un]) for (var wa = zn.s.c; wa <= zn.e.c; ++wa) {
    var Ta = pa ? Xn[Un][wa] : Xn[Kn[wa] + va];
    if (Ta === void 0 || Ta.t === void 0) {
      if (ba === void 0) continue;
      Jo[wa] != null && (xa[Jo[wa]] = ba);
      continue;
    }
    var Sa = Ta.v;
    switch (Ta.t) {
      case "z":
        if (Sa == null) break;
        continue;
      case "e":
        Sa = Sa == 0 ? null : void 0;
        break;
      case "s":
      case "d":
      case "b":
      case "n":
        break;
      default:
        throw new Error("unrecognized type " + Ta.t);
    }
    if (Jo[wa] != null) {
      if (Sa == null)
        if (Ta.t == "e" && Sa === null) xa[Jo[wa]] = null;
        else if (ba !== void 0) xa[Jo[wa]] = ba;
        else if (_a && Sa === null) xa[Jo[wa]] = null;
        else continue;
      else
        xa[Jo[wa]] = _a && (Ta.t !== "n" || Ta.t === "n" && ma.rawNumbers !== !1) ? Sa : format_cell(Ta, Sa, ma);
      Sa != null && (ya = !1);
    }
  }
  return { row: xa, isempty: ya };
}
function sheet_to_json(Xn, zn) {
  if (Xn == null || Xn["!ref"] == null) return [];
  var Un = { t: "n", v: 0 }, Kn = 0, qn = 1, Jo = [], pa = 0, ma = "", va = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, ba = zn || {}, _a = ba.range != null ? ba.range : Xn["!ref"];
  switch (ba.header === 1 ? Kn = 1 : ba.header === "A" ? Kn = 2 : Array.isArray(ba.header) ? Kn = 3 : ba.header == null && (Kn = 0), typeof _a) {
    case "string":
      va = safe_decode_range(_a);
      break;
    case "number":
      va = safe_decode_range(Xn["!ref"]), va.s.r = _a;
      break;
    default:
      va = _a;
  }
  Kn > 0 && (qn = 0);
  var ya = encode_row(va.s.r), xa = [], wa = [], Ta = 0, Sa = 0, Ma = Array.isArray(Xn), ka = va.s.r, Za = 0, Na = {};
  Ma && !Xn[ka] && (Xn[ka] = []);
  var Ka = ba.skipHidden && Xn["!cols"] || [], Ja = ba.skipHidden && Xn["!rows"] || [];
  for (Za = va.s.c; Za <= va.e.c; ++Za)
    if (!(Ka[Za] || {}).hidden)
      switch (xa[Za] = encode_col(Za), Un = Ma ? Xn[ka][Za] : Xn[xa[Za] + ya], Kn) {
        case 1:
          Jo[Za] = Za - va.s.c;
          break;
        case 2:
          Jo[Za] = xa[Za];
          break;
        case 3:
          Jo[Za] = ba.header[Za - va.s.c];
          break;
        default:
          if (Un == null && (Un = { w: "__EMPTY", t: "s" }), ma = pa = format_cell(Un, null, ba), Sa = Na[pa] || 0, !Sa) Na[pa] = 1;
          else {
            do
              ma = pa + "_" + Sa++;
            while (Na[ma]);
            Na[pa] = Sa, Na[ma] = 1;
          }
          Jo[Za] = ma;
      }
  for (ka = va.s.r + qn; ka <= va.e.r; ++ka)
    if (!(Ja[ka] || {}).hidden) {
      var el = make_json_row(Xn, va, ka, xa, Kn, Jo, Ma, ba);
      (el.isempty === !1 || (Kn === 1 ? ba.blankrows !== !1 : ba.blankrows)) && (wa[Ta++] = el.row);
    }
  return wa.length = Ta, wa;
}
var qreg = /"/g;
function make_csv_row(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  for (var va = !0, ba = [], _a = "", ya = encode_row(Un), xa = zn.s.c; xa <= zn.e.c; ++xa)
    if (Kn[xa]) {
      var wa = ma.dense ? (Xn[Un] || [])[xa] : Xn[Kn[xa] + ya];
      if (wa == null) _a = "";
      else if (wa.v != null) {
        va = !1, _a = "" + (ma.rawNumbers && wa.t == "n" ? wa.v : format_cell(wa, null, ma));
        for (var Ta = 0, Sa = 0; Ta !== _a.length; ++Ta) if ((Sa = _a.charCodeAt(Ta)) === qn || Sa === Jo || Sa === 34 || ma.forceQuotes) {
          _a = '"' + _a.replace(qreg, '""') + '"';
          break;
        }
        _a == "ID" && (_a = '"ID"');
      } else wa.f != null && !wa.F ? (va = !1, _a = "=" + wa.f, _a.indexOf(",") >= 0 && (_a = '"' + _a.replace(qreg, '""') + '"')) : _a = "";
      ba.push(_a);
    }
  return ma.blankrows === !1 && va ? null : ba.join(pa);
}
function sheet_to_csv(Xn, zn) {
  var Un = [], Kn = zn ?? {};
  if (Xn == null || Xn["!ref"] == null) return "";
  var qn = safe_decode_range(Xn["!ref"]), Jo = Kn.FS !== void 0 ? Kn.FS : ",", pa = Jo.charCodeAt(0), ma = Kn.RS !== void 0 ? Kn.RS : `
`, va = ma.charCodeAt(0), ba = new RegExp((Jo == "|" ? "\\|" : Jo) + "+$"), _a = "", ya = [];
  Kn.dense = Array.isArray(Xn);
  for (var xa = Kn.skipHidden && Xn["!cols"] || [], wa = Kn.skipHidden && Xn["!rows"] || [], Ta = qn.s.c; Ta <= qn.e.c; ++Ta) (xa[Ta] || {}).hidden || (ya[Ta] = encode_col(Ta));
  for (var Sa = 0, Ma = qn.s.r; Ma <= qn.e.r; ++Ma)
    (wa[Ma] || {}).hidden || (_a = make_csv_row(Xn, qn, Ma, ya, pa, va, Jo, Kn), _a != null && (Kn.strip && (_a = _a.replace(ba, "")), (_a || Kn.blankrows !== !1) && Un.push((Sa++ ? ma : "") + _a)));
  return delete Kn.dense, Un.join("");
}
function sheet_to_txt(Xn, zn) {
  zn || (zn = {}), zn.FS = "	", zn.RS = `
`;
  var Un = sheet_to_csv(Xn, zn);
  return Un;
}
function sheet_to_formulae(Xn) {
  var zn = "", Un, Kn = "";
  if (Xn == null || Xn["!ref"] == null) return [];
  var qn = safe_decode_range(Xn["!ref"]), Jo = "", pa = [], ma, va = [], ba = Array.isArray(Xn);
  for (ma = qn.s.c; ma <= qn.e.c; ++ma) pa[ma] = encode_col(ma);
  for (var _a = qn.s.r; _a <= qn.e.r; ++_a)
    for (Jo = encode_row(_a), ma = qn.s.c; ma <= qn.e.c; ++ma)
      if (zn = pa[ma] + Jo, Un = ba ? (Xn[_a] || [])[ma] : Xn[zn], Kn = "", Un !== void 0) {
        if (Un.F != null) {
          if (zn = Un.F, !Un.f) continue;
          Kn = Un.f, zn.indexOf(":") == -1 && (zn = zn + ":" + zn);
        }
        if (Un.f != null) Kn = Un.f;
        else {
          if (Un.t == "z") continue;
          if (Un.t == "n" && Un.v != null) Kn = "" + Un.v;
          else if (Un.t == "b") Kn = Un.v ? "TRUE" : "FALSE";
          else if (Un.w !== void 0) Kn = "'" + Un.w;
          else {
            if (Un.v === void 0) continue;
            Un.t == "s" ? Kn = "'" + Un.v : Kn = "" + Un.v;
          }
        }
        va[va.length] = zn + "=" + Kn;
      }
  return va;
}
function sheet_add_json(Xn, zn, Un) {
  var Kn = Un || {}, qn = +!Kn.skipHeader, Jo = Xn || {}, pa = 0, ma = 0;
  if (Jo && Kn.origin != null)
    if (typeof Kn.origin == "number") pa = Kn.origin;
    else {
      var va = typeof Kn.origin == "string" ? decode_cell(Kn.origin) : Kn.origin;
      pa = va.r, ma = va.c;
    }
  var ba, _a = { s: { c: 0, r: 0 }, e: { c: ma, r: pa + zn.length - 1 + qn } };
  if (Jo["!ref"]) {
    var ya = safe_decode_range(Jo["!ref"]);
    _a.e.c = Math.max(_a.e.c, ya.e.c), _a.e.r = Math.max(_a.e.r, ya.e.r), pa == -1 && (pa = ya.e.r + 1, _a.e.r = pa + zn.length - 1 + qn);
  } else
    pa == -1 && (pa = 0, _a.e.r = zn.length - 1 + qn);
  var xa = Kn.header || [], wa = 0;
  zn.forEach(function(Sa, Ma) {
    keys(Sa).forEach(function(ka) {
      (wa = xa.indexOf(ka)) == -1 && (xa[wa = xa.length] = ka);
      var Za = Sa[ka], Na = "z", Ka = "", Ja = encode_cell({ c: ma + wa, r: pa + Ma + qn });
      ba = ws_get_cell_stub(Jo, Ja), Za && typeof Za == "object" && !(Za instanceof Date) ? Jo[Ja] = Za : (typeof Za == "number" ? Na = "n" : typeof Za == "boolean" ? Na = "b" : typeof Za == "string" ? Na = "s" : Za instanceof Date ? (Na = "d", Kn.cellDates || (Na = "n", Za = datenum(Za)), Ka = Kn.dateNF || table_fmt[14]) : Za === null && Kn.nullError && (Na = "e", Za = 0), ba ? (ba.t = Na, ba.v = Za, delete ba.w, delete ba.R, Ka && (ba.z = Ka)) : Jo[Ja] = ba = { t: Na, v: Za }, Ka && (ba.z = Ka));
    });
  }), _a.e.c = Math.max(_a.e.c, ma + xa.length - 1);
  var Ta = encode_row(pa);
  if (qn) for (wa = 0; wa < xa.length; ++wa) Jo[encode_col(wa + ma) + Ta] = { t: "s", v: xa[wa] };
  return Jo["!ref"] = encode_range(_a), Jo;
}
function json_to_sheet(Xn, zn) {
  return sheet_add_json(null, Xn, zn);
}
function ws_get_cell_stub(Xn, zn, Un) {
  if (typeof zn == "string") {
    if (Array.isArray(Xn)) {
      var Kn = decode_cell(zn);
      return Xn[Kn.r] || (Xn[Kn.r] = []), Xn[Kn.r][Kn.c] || (Xn[Kn.r][Kn.c] = { t: "z" });
    }
    return Xn[zn] || (Xn[zn] = { t: "z" });
  }
  return typeof zn != "number" ? ws_get_cell_stub(Xn, encode_cell(zn)) : ws_get_cell_stub(Xn, encode_cell({ r: zn, c: Un || 0 }));
}
function wb_sheet_idx(Xn, zn) {
  if (typeof zn == "number") {
    if (zn >= 0 && Xn.SheetNames.length > zn) return zn;
    throw new Error("Cannot find sheet # " + zn);
  } else if (typeof zn == "string") {
    var Un = Xn.SheetNames.indexOf(zn);
    if (Un > -1) return Un;
    throw new Error("Cannot find sheet name |" + zn + "|");
  } else throw new Error("Cannot find sheet |" + zn + "|");
}
function book_new() {
  return { SheetNames: [], Sheets: {} };
}
function book_append_sheet(Xn, zn, Un, Kn) {
  var qn = 1;
  if (!Un) for (; qn <= 65535 && Xn.SheetNames.indexOf(Un = "Sheet" + qn) != -1; ++qn, Un = void 0) ;
  if (!Un || Xn.SheetNames.length >= 65535) throw new Error("Too many worksheets");
  if (Kn && Xn.SheetNames.indexOf(Un) >= 0) {
    var Jo = Un.match(/(^.*?)(\d+)$/);
    qn = Jo && +Jo[2] || 0;
    var pa = Jo && Jo[1] || Un;
    for (++qn; qn <= 65535 && Xn.SheetNames.indexOf(Un = pa + qn) != -1; ++qn) ;
  }
  if (check_ws_name(Un), Xn.SheetNames.indexOf(Un) >= 0) throw new Error("Worksheet with name |" + Un + "| already exists!");
  return Xn.SheetNames.push(Un), Xn.Sheets[Un] = zn, Un;
}
function book_set_sheet_visibility(Xn, zn, Un) {
  Xn.Workbook || (Xn.Workbook = {}), Xn.Workbook.Sheets || (Xn.Workbook.Sheets = []);
  var Kn = wb_sheet_idx(Xn, zn);
  switch (Xn.Workbook.Sheets[Kn] || (Xn.Workbook.Sheets[Kn] = {}), Un) {
    case 0:
    case 1:
    case 2:
      break;
    default:
      throw new Error("Bad sheet visibility setting " + Un);
  }
  Xn.Workbook.Sheets[Kn].Hidden = Un;
}
function cell_set_number_format(Xn, zn) {
  return Xn.z = zn, Xn;
}
function cell_set_hyperlink(Xn, zn, Un) {
  return zn ? (Xn.l = { Target: zn }, Un && (Xn.l.Tooltip = Un)) : delete Xn.l, Xn;
}
function cell_set_internal_link(Xn, zn, Un) {
  return cell_set_hyperlink(Xn, "#" + zn, Un);
}
function cell_add_comment(Xn, zn, Un) {
  Xn.c || (Xn.c = []), Xn.c.push({ t: zn, a: Un || "SheetJS" });
}
function sheet_set_array_formula(Xn, zn, Un, Kn) {
  for (var qn = typeof zn != "string" ? zn : safe_decode_range(zn), Jo = typeof zn == "string" ? zn : encode_range(zn), pa = qn.s.r; pa <= qn.e.r; ++pa) for (var ma = qn.s.c; ma <= qn.e.c; ++ma) {
    var va = ws_get_cell_stub(Xn, pa, ma);
    va.t = "n", va.F = Jo, delete va.v, pa == qn.s.r && ma == qn.s.c && (va.f = Un, Kn && (va.D = !0));
  }
  return Xn;
}
var utils = {
  encode_col,
  encode_row,
  encode_cell,
  encode_range,
  decode_col,
  decode_row,
  split_cell,
  decode_cell,
  decode_range,
  format_cell,
  sheet_add_aoa,
  sheet_add_json,
  sheet_add_dom,
  aoa_to_sheet,
  json_to_sheet,
  table_to_sheet: parse_dom_table,
  table_to_book,
  sheet_to_csv,
  sheet_to_txt,
  sheet_to_json,
  sheet_to_html,
  sheet_to_formulae,
  sheet_to_row_object_array: sheet_to_json,
  sheet_get_cell: ws_get_cell_stub,
  book_new,
  book_append_sheet,
  book_set_sheet_visibility,
  cell_set_number_format,
  cell_set_hyperlink,
  cell_set_internal_link,
  cell_add_comment,
  sheet_set_array_formula,
  consts: {
    SHEET_VISIBLE: 0,
    SHEET_HIDDEN: 1,
    SHEET_VERY_HIDDEN: 2
  }
};
function _mergeNamespaces(Xn, zn) {
  return zn.forEach(function(Un) {
    Un && typeof Un != "string" && !Array.isArray(Un) && Object.keys(Un).forEach(function(Kn) {
      if (Kn !== "default" && !(Kn in Xn)) {
        var qn = Object.getOwnPropertyDescriptor(Un, Kn);
        Object.defineProperty(Xn, Kn, qn.get ? qn : { enumerable: !0, get: function() {
          return Un[Kn];
        } });
      }
    });
  }), Object.freeze(Xn);
}
function copyExifWithoutOrientation(Xn, zn) {
  return new Promise(function(Un, Kn) {
    let qn;
    return getApp1Segment(Xn).then(function(Jo) {
      try {
        return qn = Jo, Un(new Blob([zn.slice(0, 2), qn, zn.slice(2)], { type: "image/jpeg" }));
      } catch (pa) {
        return Kn(pa);
      }
    }, Kn);
  });
}
const getApp1Segment = (Xn) => new Promise((zn, Un) => {
  const Kn = new FileReader();
  Kn.addEventListener("load", ({ target: { result: qn } }) => {
    const Jo = new DataView(qn);
    let pa = 0;
    if (Jo.getUint16(pa) !== 65496) return Un("not a valid JPEG");
    for (pa += 2; ; ) {
      const ma = Jo.getUint16(pa);
      if (ma === 65498) break;
      const va = Jo.getUint16(pa + 2);
      if (ma === 65505 && Jo.getUint32(pa + 4) === 1165519206) {
        const ba = pa + 10;
        let _a;
        switch (Jo.getUint16(ba)) {
          case 18761:
            _a = !0;
            break;
          case 19789:
            _a = !1;
            break;
          default:
            return Un("TIFF header contains invalid endian");
        }
        if (Jo.getUint16(ba + 2, _a) !== 42) return Un("TIFF header contains invalid version");
        const ya = Jo.getUint32(ba + 4, _a), xa = ba + ya + 2 + 12 * Jo.getUint16(ba + ya, _a);
        for (let wa = ba + ya + 2; wa < xa; wa += 12)
          if (Jo.getUint16(wa, _a) == 274) {
            if (Jo.getUint16(wa + 2, _a) !== 3) return Un("Orientation data type is invalid");
            if (Jo.getUint32(wa + 4, _a) !== 1) return Un("Orientation data count is invalid");
            Jo.setUint16(wa + 8, 1, _a);
            break;
          }
        return zn(qn.slice(pa, pa + 2 + va));
      }
      pa += 2 + va;
    }
    return zn(new Blob());
  }), Kn.readAsArrayBuffer(Xn);
});
var e$2 = {}, t$2 = { get exports() {
  return e$2;
}, set exports(Xn) {
  e$2 = Xn;
} };
(function(Xn) {
  var zn, Un, Kn = {};
  t$2.exports = Kn, Kn.parse = function(qn, Jo) {
    for (var pa = Kn.bin.readUshort, ma = Kn.bin.readUint, va = 0, ba = {}, _a = new Uint8Array(qn), ya = _a.length - 4; ma(_a, ya) != 101010256; ) ya--;
    va = ya, va += 4;
    var xa = pa(_a, va += 4);
    pa(_a, va += 2);
    var wa = ma(_a, va += 2), Ta = ma(_a, va += 4);
    va += 4, va = Ta;
    for (var Sa = 0; Sa < xa; Sa++) {
      ma(_a, va), va += 4, va += 4, va += 4, ma(_a, va += 4), wa = ma(_a, va += 4);
      var Ma = ma(_a, va += 4), ka = pa(_a, va += 4), Za = pa(_a, va + 2), Na = pa(_a, va + 4);
      va += 6;
      var Ka = ma(_a, va += 8);
      va += 4, va += ka + Za + Na, Kn._readLocal(_a, Ka, ba, wa, Ma, Jo);
    }
    return ba;
  }, Kn._readLocal = function(qn, Jo, pa, ma, va, ba) {
    var _a = Kn.bin.readUshort, ya = Kn.bin.readUint;
    ya(qn, Jo), _a(qn, Jo += 4), _a(qn, Jo += 2);
    var xa = _a(qn, Jo += 2);
    ya(qn, Jo += 2), ya(qn, Jo += 4), Jo += 4;
    var wa = _a(qn, Jo += 8), Ta = _a(qn, Jo += 2);
    Jo += 2;
    var Sa = Kn.bin.readUTF8(qn, Jo, wa);
    if (Jo += wa, Jo += Ta, ba) pa[Sa] = { size: va, csize: ma };
    else {
      var Ma = new Uint8Array(qn.buffer, Jo);
      if (xa == 0) pa[Sa] = new Uint8Array(Ma.buffer.slice(Jo, Jo + ma));
      else {
        if (xa != 8) throw "unknown compression method: " + xa;
        var ka = new Uint8Array(va);
        Kn.inflateRaw(Ma, ka), pa[Sa] = ka;
      }
    }
  }, Kn.inflateRaw = function(qn, Jo) {
    return Kn.F.inflate(qn, Jo);
  }, Kn.inflate = function(qn, Jo) {
    return qn[0], qn[1], Kn.inflateRaw(new Uint8Array(qn.buffer, qn.byteOffset + 2, qn.length - 6), Jo);
  }, Kn.deflate = function(qn, Jo) {
    Jo == null && (Jo = { level: 6 });
    var pa = 0, ma = new Uint8Array(50 + Math.floor(1.1 * qn.length));
    ma[pa] = 120, ma[pa + 1] = 156, pa += 2, pa = Kn.F.deflateRaw(qn, ma, pa, Jo.level);
    var va = Kn.adler(qn, 0, qn.length);
    return ma[pa + 0] = va >>> 24 & 255, ma[pa + 1] = va >>> 16 & 255, ma[pa + 2] = va >>> 8 & 255, ma[pa + 3] = va >>> 0 & 255, new Uint8Array(ma.buffer, 0, pa + 4);
  }, Kn.deflateRaw = function(qn, Jo) {
    Jo == null && (Jo = { level: 6 });
    var pa = new Uint8Array(50 + Math.floor(1.1 * qn.length)), ma = Kn.F.deflateRaw(qn, pa, ma, Jo.level);
    return new Uint8Array(pa.buffer, 0, ma);
  }, Kn.encode = function(qn, Jo) {
    Jo == null && (Jo = !1);
    var pa = 0, ma = Kn.bin.writeUint, va = Kn.bin.writeUshort, ba = {};
    for (var _a in qn) {
      var ya = !Kn._noNeed(_a) && !Jo, xa = qn[_a], wa = Kn.crc.crc(xa, 0, xa.length);
      ba[_a] = { cpr: ya, usize: xa.length, crc: wa, file: ya ? Kn.deflateRaw(xa) : xa };
    }
    for (var _a in ba) pa += ba[_a].file.length + 30 + 46 + 2 * Kn.bin.sizeUTF8(_a);
    pa += 22;
    var Ta = new Uint8Array(pa), Sa = 0, Ma = [];
    for (var _a in ba) {
      var ka = ba[_a];
      Ma.push(Sa), Sa = Kn._writeHeader(Ta, Sa, _a, ka, 0);
    }
    var Za = 0, Na = Sa;
    for (var _a in ba)
      ka = ba[_a], Ma.push(Sa), Sa = Kn._writeHeader(Ta, Sa, _a, ka, 1, Ma[Za++]);
    var Ka = Sa - Na;
    return ma(Ta, Sa, 101010256), Sa += 4, va(Ta, Sa += 4, Za), va(Ta, Sa += 2, Za), ma(Ta, Sa += 2, Ka), ma(Ta, Sa += 4, Na), Sa += 4, Sa += 2, Ta.buffer;
  }, Kn._noNeed = function(qn) {
    var Jo = qn.split(".").pop().toLowerCase();
    return "png,jpg,jpeg,zip".indexOf(Jo) != -1;
  }, Kn._writeHeader = function(qn, Jo, pa, ma, va, ba) {
    var _a = Kn.bin.writeUint, ya = Kn.bin.writeUshort, xa = ma.file;
    return _a(qn, Jo, va == 0 ? 67324752 : 33639248), Jo += 4, va == 1 && (Jo += 2), ya(qn, Jo, 20), ya(qn, Jo += 2, 0), ya(qn, Jo += 2, ma.cpr ? 8 : 0), _a(qn, Jo += 2, 0), _a(qn, Jo += 4, ma.crc), _a(qn, Jo += 4, xa.length), _a(qn, Jo += 4, ma.usize), ya(qn, Jo += 4, Kn.bin.sizeUTF8(pa)), ya(qn, Jo += 2, 0), Jo += 2, va == 1 && (Jo += 2, Jo += 2, _a(qn, Jo += 6, ba), Jo += 4), Jo += Kn.bin.writeUTF8(qn, Jo, pa), va == 0 && (qn.set(xa, Jo), Jo += xa.length), Jo;
  }, Kn.crc = { table: function() {
    for (var qn = new Uint32Array(256), Jo = 0; Jo < 256; Jo++) {
      for (var pa = Jo, ma = 0; ma < 8; ma++) 1 & pa ? pa = 3988292384 ^ pa >>> 1 : pa >>>= 1;
      qn[Jo] = pa;
    }
    return qn;
  }(), update: function(qn, Jo, pa, ma) {
    for (var va = 0; va < ma; va++) qn = Kn.crc.table[255 & (qn ^ Jo[pa + va])] ^ qn >>> 8;
    return qn;
  }, crc: function(qn, Jo, pa) {
    return 4294967295 ^ Kn.crc.update(4294967295, qn, Jo, pa);
  } }, Kn.adler = function(qn, Jo, pa) {
    for (var ma = 1, va = 0, ba = Jo, _a = Jo + pa; ba < _a; ) {
      for (var ya = Math.min(ba + 5552, _a); ba < ya; ) va += ma += qn[ba++];
      ma %= 65521, va %= 65521;
    }
    return va << 16 | ma;
  }, Kn.bin = { readUshort: function(qn, Jo) {
    return qn[Jo] | qn[Jo + 1] << 8;
  }, writeUshort: function(qn, Jo, pa) {
    qn[Jo] = 255 & pa, qn[Jo + 1] = pa >> 8 & 255;
  }, readUint: function(qn, Jo) {
    return 16777216 * qn[Jo + 3] + (qn[Jo + 2] << 16 | qn[Jo + 1] << 8 | qn[Jo]);
  }, writeUint: function(qn, Jo, pa) {
    qn[Jo] = 255 & pa, qn[Jo + 1] = pa >> 8 & 255, qn[Jo + 2] = pa >> 16 & 255, qn[Jo + 3] = pa >> 24 & 255;
  }, readASCII: function(qn, Jo, pa) {
    for (var ma = "", va = 0; va < pa; va++) ma += String.fromCharCode(qn[Jo + va]);
    return ma;
  }, writeASCII: function(qn, Jo, pa) {
    for (var ma = 0; ma < pa.length; ma++) qn[Jo + ma] = pa.charCodeAt(ma);
  }, pad: function(qn) {
    return qn.length < 2 ? "0" + qn : qn;
  }, readUTF8: function(qn, Jo, pa) {
    for (var ma, va = "", ba = 0; ba < pa; ba++) va += "%" + Kn.bin.pad(qn[Jo + ba].toString(16));
    try {
      ma = decodeURIComponent(va);
    } catch {
      return Kn.bin.readASCII(qn, Jo, pa);
    }
    return ma;
  }, writeUTF8: function(qn, Jo, pa) {
    for (var ma = pa.length, va = 0, ba = 0; ba < ma; ba++) {
      var _a = pa.charCodeAt(ba);
      if ((4294967168 & _a) == 0) qn[Jo + va] = _a, va++;
      else if ((4294965248 & _a) == 0) qn[Jo + va] = 192 | _a >> 6, qn[Jo + va + 1] = 128 | _a >> 0 & 63, va += 2;
      else if ((4294901760 & _a) == 0) qn[Jo + va] = 224 | _a >> 12, qn[Jo + va + 1] = 128 | _a >> 6 & 63, qn[Jo + va + 2] = 128 | _a >> 0 & 63, va += 3;
      else {
        if ((4292870144 & _a) != 0) throw "e";
        qn[Jo + va] = 240 | _a >> 18, qn[Jo + va + 1] = 128 | _a >> 12 & 63, qn[Jo + va + 2] = 128 | _a >> 6 & 63, qn[Jo + va + 3] = 128 | _a >> 0 & 63, va += 4;
      }
    }
    return va;
  }, sizeUTF8: function(qn) {
    for (var Jo = qn.length, pa = 0, ma = 0; ma < Jo; ma++) {
      var va = qn.charCodeAt(ma);
      if ((4294967168 & va) == 0) pa++;
      else if ((4294965248 & va) == 0) pa += 2;
      else if ((4294901760 & va) == 0) pa += 3;
      else {
        if ((4292870144 & va) != 0) throw "e";
        pa += 4;
      }
    }
    return pa;
  } }, Kn.F = {}, Kn.F.deflateRaw = function(qn, Jo, pa, ma) {
    var va = [[0, 0, 0, 0, 0], [4, 4, 8, 4, 0], [4, 5, 16, 8, 0], [4, 6, 16, 16, 0], [4, 10, 16, 32, 0], [8, 16, 32, 32, 0], [8, 16, 128, 128, 0], [8, 32, 128, 256, 0], [32, 128, 258, 1024, 1], [32, 258, 258, 4096, 1]][ma], ba = Kn.F.U, _a = Kn.F._goodIndex;
    Kn.F._hash;
    var ya = Kn.F._putsE, xa = 0, wa = pa << 3, Ta = 0, Sa = qn.length;
    if (ma == 0) {
      for (; xa < Sa; )
        ya(Jo, wa, xa + (rl = Math.min(65535, Sa - xa)) == Sa ? 1 : 0), wa = Kn.F._copyExact(qn, xa, rl, Jo, wa + 8), xa += rl;
      return wa >>> 3;
    }
    var Ma = ba.lits, ka = ba.strt, Za = ba.prev, Na = 0, Ka = 0, Ja = 0, el = 0, qa = 0, tl = 0;
    for (Sa > 2 && (ka[tl = Kn.F._hash(qn, 0)] = 0), xa = 0; xa < Sa; xa++) {
      if (qa = tl, xa + 1 < Sa - 2) {
        tl = Kn.F._hash(qn, xa + 1);
        var Qa = xa + 1 & 32767;
        Za[Qa] = ka[tl], ka[tl] = Qa;
      }
      if (Ta <= xa) {
        (Na > 14e3 || Ka > 26697) && Sa - xa > 100 && (Ta < xa && (Ma[Na] = xa - Ta, Na += 2, Ta = xa), wa = Kn.F._writeBlock(xa == Sa - 1 || Ta == Sa ? 1 : 0, Ma, Na, el, qn, Ja, xa - Ja, Jo, wa), Na = Ka = el = 0, Ja = xa);
        var nl = 0;
        xa < Sa - 2 && (nl = Kn.F._bestMatch(qn, xa, Za, qa, Math.min(va[2], Sa - xa), va[3]));
        var rl = nl >>> 16, il = 65535 & nl;
        if (nl != 0) {
          il = 65535 & nl;
          var cl = _a(rl = nl >>> 16, ba.of0);
          ba.lhst[257 + cl]++;
          var ll = _a(il, ba.df0);
          ba.dhst[ll]++, el += ba.exb[cl] + ba.dxb[ll], Ma[Na] = rl << 23 | xa - Ta, Ma[Na + 1] = il << 16 | cl << 8 | ll, Na += 2, Ta = xa + rl;
        } else ba.lhst[qn[xa]]++;
        Ka++;
      }
    }
    for (Ja == xa && qn.length != 0 || (Ta < xa && (Ma[Na] = xa - Ta, Na += 2, Ta = xa), wa = Kn.F._writeBlock(1, Ma, Na, el, qn, Ja, xa - Ja, Jo, wa), Na = 0, Ka = 0, Na = Ka = el = 0, Ja = xa); (7 & wa) != 0; ) wa++;
    return wa >>> 3;
  }, Kn.F._bestMatch = function(qn, Jo, pa, ma, va, ba) {
    var _a = 32767 & Jo, ya = pa[_a], xa = _a - ya + 32768 & 32767;
    if (ya == _a || ma != Kn.F._hash(qn, Jo - xa)) return 0;
    for (var wa = 0, Ta = 0, Sa = Math.min(32767, Jo); xa <= Sa && --ba != 0 && ya != _a; ) {
      if (wa == 0 || qn[Jo + wa] == qn[Jo + wa - xa]) {
        var Ma = Kn.F._howLong(qn, Jo, xa);
        if (Ma > wa) {
          if (Ta = xa, (wa = Ma) >= va) break;
          xa + 2 < Ma && (Ma = xa + 2);
          for (var ka = 0, Za = 0; Za < Ma - 2; Za++) {
            var Na = Jo - xa + Za + 32768 & 32767, Ka = Na - pa[Na] + 32768 & 32767;
            Ka > ka && (ka = Ka, ya = Na);
          }
        }
      }
      xa += (_a = ya) - (ya = pa[_a]) + 32768 & 32767;
    }
    return wa << 16 | Ta;
  }, Kn.F._howLong = function(qn, Jo, pa) {
    if (qn[Jo] != qn[Jo - pa] || qn[Jo + 1] != qn[Jo + 1 - pa] || qn[Jo + 2] != qn[Jo + 2 - pa]) return 0;
    var ma = Jo, va = Math.min(qn.length, Jo + 258);
    for (Jo += 3; Jo < va && qn[Jo] == qn[Jo - pa]; ) Jo++;
    return Jo - ma;
  }, Kn.F._hash = function(qn, Jo) {
    return (qn[Jo] << 8 | qn[Jo + 1]) + (qn[Jo + 2] << 4) & 65535;
  }, Kn.saved = 0, Kn.F._writeBlock = function(qn, Jo, pa, ma, va, ba, _a, ya, xa) {
    var wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el = Kn.F.U, qa = Kn.F._putsF, tl = Kn.F._putsE;
    el.lhst[256]++, Ta = (wa = Kn.F.getTrees())[0], Sa = wa[1], Ma = wa[2], ka = wa[3], Za = wa[4], Na = wa[5], Ka = wa[6], Ja = wa[7];
    var Qa = 32 + ((xa + 3 & 7) == 0 ? 0 : 8 - (xa + 3 & 7)) + (_a << 3), nl = ma + Kn.F.contSize(el.fltree, el.lhst) + Kn.F.contSize(el.fdtree, el.dhst), rl = ma + Kn.F.contSize(el.ltree, el.lhst) + Kn.F.contSize(el.dtree, el.dhst);
    rl += 14 + 3 * Na + Kn.F.contSize(el.itree, el.ihst) + (2 * el.ihst[16] + 3 * el.ihst[17] + 7 * el.ihst[18]);
    for (var il = 0; il < 286; il++) el.lhst[il] = 0;
    for (il = 0; il < 30; il++) el.dhst[il] = 0;
    for (il = 0; il < 19; il++) el.ihst[il] = 0;
    var cl = Qa < nl && Qa < rl ? 0 : nl < rl ? 1 : 2;
    if (qa(ya, xa, qn), qa(ya, xa + 1, cl), xa += 3, cl == 0) {
      for (; (7 & xa) != 0; ) xa++;
      xa = Kn.F._copyExact(va, ba, _a, ya, xa);
    } else {
      var ll, al;
      if (cl == 1 && (ll = el.fltree, al = el.fdtree), cl == 2) {
        Kn.F.makeCodes(el.ltree, Ta), Kn.F.revCodes(el.ltree, Ta), Kn.F.makeCodes(el.dtree, Sa), Kn.F.revCodes(el.dtree, Sa), Kn.F.makeCodes(el.itree, Ma), Kn.F.revCodes(el.itree, Ma), ll = el.ltree, al = el.dtree, tl(ya, xa, ka - 257), tl(ya, xa += 5, Za - 1), tl(ya, xa += 5, Na - 4), xa += 4;
        for (var sl = 0; sl < Na; sl++) tl(ya, xa + 3 * sl, el.itree[1 + (el.ordr[sl] << 1)]);
        xa += 3 * Na, xa = Kn.F._codeTiny(Ka, el.itree, ya, xa), xa = Kn.F._codeTiny(Ja, el.itree, ya, xa);
      }
      for (var dl = ba, El = 0; El < pa; El += 2) {
        for (var fl = Jo[El], Ml = fl >>> 23, Sl = dl + (8388607 & fl); dl < Sl; ) xa = Kn.F._writeLit(va[dl++], ll, ya, xa);
        if (Ml != 0) {
          var ml = Jo[El + 1], Dl = ml >> 16, _l = ml >> 8 & 255, gl = 255 & ml;
          tl(ya, xa = Kn.F._writeLit(257 + _l, ll, ya, xa), Ml - el.of0[_l]), xa += el.exb[_l], qa(ya, xa = Kn.F._writeLit(gl, al, ya, xa), Dl - el.df0[gl]), xa += el.dxb[gl], dl += Ml;
        }
      }
      xa = Kn.F._writeLit(256, ll, ya, xa);
    }
    return xa;
  }, Kn.F._copyExact = function(qn, Jo, pa, ma, va) {
    var ba = va >>> 3;
    return ma[ba] = pa, ma[ba + 1] = pa >>> 8, ma[ba + 2] = 255 - ma[ba], ma[ba + 3] = 255 - ma[ba + 1], ba += 4, ma.set(new Uint8Array(qn.buffer, Jo, pa), ba), va + (pa + 4 << 3);
  }, Kn.F.getTrees = function() {
    for (var qn = Kn.F.U, Jo = Kn.F._hufTree(qn.lhst, qn.ltree, 15), pa = Kn.F._hufTree(qn.dhst, qn.dtree, 15), ma = [], va = Kn.F._lenCodes(qn.ltree, ma), ba = [], _a = Kn.F._lenCodes(qn.dtree, ba), ya = 0; ya < ma.length; ya += 2) qn.ihst[ma[ya]]++;
    for (ya = 0; ya < ba.length; ya += 2) qn.ihst[ba[ya]]++;
    for (var xa = Kn.F._hufTree(qn.ihst, qn.itree, 7), wa = 19; wa > 4 && qn.itree[1 + (qn.ordr[wa - 1] << 1)] == 0; ) wa--;
    return [Jo, pa, xa, va, _a, wa, ma, ba];
  }, Kn.F.getSecond = function(qn) {
    for (var Jo = [], pa = 0; pa < qn.length; pa += 2) Jo.push(qn[pa + 1]);
    return Jo;
  }, Kn.F.nonZero = function(qn) {
    for (var Jo = "", pa = 0; pa < qn.length; pa += 2) qn[pa + 1] != 0 && (Jo += (pa >> 1) + ",");
    return Jo;
  }, Kn.F.contSize = function(qn, Jo) {
    for (var pa = 0, ma = 0; ma < Jo.length; ma++) pa += Jo[ma] * qn[1 + (ma << 1)];
    return pa;
  }, Kn.F._codeTiny = function(qn, Jo, pa, ma) {
    for (var va = 0; va < qn.length; va += 2) {
      var ba = qn[va], _a = qn[va + 1];
      ma = Kn.F._writeLit(ba, Jo, pa, ma);
      var ya = ba == 16 ? 2 : ba == 17 ? 3 : 7;
      ba > 15 && (Kn.F._putsE(pa, ma, _a, ya), ma += ya);
    }
    return ma;
  }, Kn.F._lenCodes = function(qn, Jo) {
    for (var pa = qn.length; pa != 2 && qn[pa - 1] == 0; ) pa -= 2;
    for (var ma = 0; ma < pa; ma += 2) {
      var va = qn[ma + 1], ba = ma + 3 < pa ? qn[ma + 3] : -1, _a = ma + 5 < pa ? qn[ma + 5] : -1, ya = ma == 0 ? -1 : qn[ma - 1];
      if (va == 0 && ba == va && _a == va) {
        for (var xa = ma + 5; xa + 2 < pa && qn[xa + 2] == va; ) xa += 2;
        (wa = Math.min(xa + 1 - ma >>> 1, 138)) < 11 ? Jo.push(17, wa - 3) : Jo.push(18, wa - 11), ma += 2 * wa - 2;
      } else if (va == ya && ba == va && _a == va) {
        for (xa = ma + 5; xa + 2 < pa && qn[xa + 2] == va; ) xa += 2;
        var wa = Math.min(xa + 1 - ma >>> 1, 6);
        Jo.push(16, wa - 3), ma += 2 * wa - 2;
      } else Jo.push(va, 0);
    }
    return pa >>> 1;
  }, Kn.F._hufTree = function(qn, Jo, pa) {
    var ma = [], va = qn.length, ba = Jo.length, _a = 0;
    for (_a = 0; _a < ba; _a += 2) Jo[_a] = 0, Jo[_a + 1] = 0;
    for (_a = 0; _a < va; _a++) qn[_a] != 0 && ma.push({ lit: _a, f: qn[_a] });
    var ya = ma.length, xa = ma.slice(0);
    if (ya == 0) return 0;
    if (ya == 1) {
      var wa = ma[0].lit;
      return xa = wa == 0 ? 1 : 0, Jo[1 + (wa << 1)] = 1, Jo[1 + (xa << 1)] = 1, 1;
    }
    ma.sort(function(Ka, Ja) {
      return Ka.f - Ja.f;
    });
    var Ta = ma[0], Sa = ma[1], Ma = 0, ka = 1, Za = 2;
    for (ma[0] = { lit: -1, f: Ta.f + Sa.f, l: Ta, r: Sa, d: 0 }; ka != ya - 1; ) Ta = Ma != ka && (Za == ya || ma[Ma].f < ma[Za].f) ? ma[Ma++] : ma[Za++], Sa = Ma != ka && (Za == ya || ma[Ma].f < ma[Za].f) ? ma[Ma++] : ma[Za++], ma[ka++] = { lit: -1, f: Ta.f + Sa.f, l: Ta, r: Sa };
    var Na = Kn.F.setDepth(ma[ka - 1], 0);
    for (Na > pa && (Kn.F.restrictDepth(xa, pa, Na), Na = pa), _a = 0; _a < ya; _a++) Jo[1 + (xa[_a].lit << 1)] = xa[_a].d;
    return Na;
  }, Kn.F.setDepth = function(qn, Jo) {
    return qn.lit != -1 ? (qn.d = Jo, Jo) : Math.max(Kn.F.setDepth(qn.l, Jo + 1), Kn.F.setDepth(qn.r, Jo + 1));
  }, Kn.F.restrictDepth = function(qn, Jo, pa) {
    var ma = 0, va = 1 << pa - Jo, ba = 0;
    for (qn.sort(function(ya, xa) {
      return xa.d == ya.d ? ya.f - xa.f : xa.d - ya.d;
    }), ma = 0; ma < qn.length && qn[ma].d > Jo; ma++) {
      var _a = qn[ma].d;
      qn[ma].d = Jo, ba += va - (1 << pa - _a);
    }
    for (ba >>>= pa - Jo; ba > 0; )
      (_a = qn[ma].d) < Jo ? (qn[ma].d++, ba -= 1 << Jo - _a - 1) : ma++;
    for (; ma >= 0; ma--) qn[ma].d == Jo && ba < 0 && (qn[ma].d--, ba++);
    ba != 0 && console.log("debt left");
  }, Kn.F._goodIndex = function(qn, Jo) {
    var pa = 0;
    return Jo[16 | pa] <= qn && (pa |= 16), Jo[8 | pa] <= qn && (pa |= 8), Jo[4 | pa] <= qn && (pa |= 4), Jo[2 | pa] <= qn && (pa |= 2), Jo[1 | pa] <= qn && (pa |= 1), pa;
  }, Kn.F._writeLit = function(qn, Jo, pa, ma) {
    return Kn.F._putsF(pa, ma, Jo[qn << 1]), ma + Jo[1 + (qn << 1)];
  }, Kn.F.inflate = function(qn, Jo) {
    var pa = Uint8Array;
    if (qn[0] == 3 && qn[1] == 0) return Jo || new pa(0);
    var ma = Kn.F, va = ma._bitsF, ba = ma._bitsE, _a = ma._decodeTiny, ya = ma.makeCodes, xa = ma.codes2map, wa = ma._get17, Ta = ma.U, Sa = Jo == null;
    Sa && (Jo = new pa(qn.length >>> 2 << 3));
    for (var Ma, ka, Za = 0, Na = 0, Ka = 0, Ja = 0, el = 0, qa = 0, tl = 0, Qa = 0, nl = 0; Za == 0; ) if (Za = va(qn, nl, 1), Na = va(qn, nl + 1, 2), nl += 3, Na != 0) {
      if (Sa && (Jo = Kn.F._check(Jo, Qa + (1 << 17))), Na == 1 && (Ma = Ta.flmap, ka = Ta.fdmap, qa = 511, tl = 31), Na == 2) {
        Ka = ba(qn, nl, 5) + 257, Ja = ba(qn, nl + 5, 5) + 1, el = ba(qn, nl + 10, 4) + 4, nl += 14;
        for (var rl = 0; rl < 38; rl += 2) Ta.itree[rl] = 0, Ta.itree[rl + 1] = 0;
        var il = 1;
        for (rl = 0; rl < el; rl++) {
          var cl = ba(qn, nl + 3 * rl, 3);
          Ta.itree[1 + (Ta.ordr[rl] << 1)] = cl, cl > il && (il = cl);
        }
        nl += 3 * el, ya(Ta.itree, il), xa(Ta.itree, il, Ta.imap), Ma = Ta.lmap, ka = Ta.dmap, nl = _a(Ta.imap, (1 << il) - 1, Ka + Ja, qn, nl, Ta.ttree);
        var ll = ma._copyOut(Ta.ttree, 0, Ka, Ta.ltree);
        qa = (1 << ll) - 1;
        var al = ma._copyOut(Ta.ttree, Ka, Ja, Ta.dtree);
        tl = (1 << al) - 1, ya(Ta.ltree, ll), xa(Ta.ltree, ll, Ma), ya(Ta.dtree, al), xa(Ta.dtree, al, ka);
      }
      for (; ; ) {
        var sl = Ma[wa(qn, nl) & qa];
        nl += 15 & sl;
        var dl = sl >>> 4;
        if (!(dl >>> 8)) Jo[Qa++] = dl;
        else {
          if (dl == 256) break;
          var El = Qa + dl - 254;
          if (dl > 264) {
            var fl = Ta.ldef[dl - 257];
            El = Qa + (fl >>> 3) + ba(qn, nl, 7 & fl), nl += 7 & fl;
          }
          var Ml = ka[wa(qn, nl) & tl];
          nl += 15 & Ml;
          var Sl = Ml >>> 4, ml = Ta.ddef[Sl], Dl = (ml >>> 4) + va(qn, nl, 15 & ml);
          for (nl += 15 & ml, Sa && (Jo = Kn.F._check(Jo, Qa + (1 << 17))); Qa < El; ) Jo[Qa] = Jo[Qa++ - Dl], Jo[Qa] = Jo[Qa++ - Dl], Jo[Qa] = Jo[Qa++ - Dl], Jo[Qa] = Jo[Qa++ - Dl];
          Qa = El;
        }
      }
    } else {
      (7 & nl) != 0 && (nl += 8 - (7 & nl));
      var _l = 4 + (nl >>> 3), gl = qn[_l - 4] | qn[_l - 3] << 8;
      Sa && (Jo = Kn.F._check(Jo, Qa + gl)), Jo.set(new pa(qn.buffer, qn.byteOffset + _l, gl), Qa), nl = _l + gl << 3, Qa += gl;
    }
    return Jo.length == Qa ? Jo : Jo.slice(0, Qa);
  }, Kn.F._check = function(qn, Jo) {
    var pa = qn.length;
    if (Jo <= pa) return qn;
    var ma = new Uint8Array(Math.max(pa << 1, Jo));
    return ma.set(qn, 0), ma;
  }, Kn.F._decodeTiny = function(qn, Jo, pa, ma, va, ba) {
    for (var _a = Kn.F._bitsE, ya = Kn.F._get17, xa = 0; xa < pa; ) {
      var wa = qn[ya(ma, va) & Jo];
      va += 15 & wa;
      var Ta = wa >>> 4;
      if (Ta <= 15) ba[xa] = Ta, xa++;
      else {
        var Sa = 0, Ma = 0;
        Ta == 16 ? (Ma = 3 + _a(ma, va, 2), va += 2, Sa = ba[xa - 1]) : Ta == 17 ? (Ma = 3 + _a(ma, va, 3), va += 3) : Ta == 18 && (Ma = 11 + _a(ma, va, 7), va += 7);
        for (var ka = xa + Ma; xa < ka; ) ba[xa] = Sa, xa++;
      }
    }
    return va;
  }, Kn.F._copyOut = function(qn, Jo, pa, ma) {
    for (var va = 0, ba = 0, _a = ma.length >>> 1; ba < pa; ) {
      var ya = qn[ba + Jo];
      ma[ba << 1] = 0, ma[1 + (ba << 1)] = ya, ya > va && (va = ya), ba++;
    }
    for (; ba < _a; ) ma[ba << 1] = 0, ma[1 + (ba << 1)] = 0, ba++;
    return va;
  }, Kn.F.makeCodes = function(qn, Jo) {
    for (var pa, ma, va, ba, _a = Kn.F.U, ya = qn.length, xa = _a.bl_count, wa = 0; wa <= Jo; wa++) xa[wa] = 0;
    for (wa = 1; wa < ya; wa += 2) xa[qn[wa]]++;
    var Ta = _a.next_code;
    for (pa = 0, xa[0] = 0, ma = 1; ma <= Jo; ma++) pa = pa + xa[ma - 1] << 1, Ta[ma] = pa;
    for (va = 0; va < ya; va += 2) (ba = qn[va + 1]) != 0 && (qn[va] = Ta[ba], Ta[ba]++);
  }, Kn.F.codes2map = function(qn, Jo, pa) {
    for (var ma = qn.length, va = Kn.F.U.rev15, ba = 0; ba < ma; ba += 2) if (qn[ba + 1] != 0) for (var _a = ba >> 1, ya = qn[ba + 1], xa = _a << 4 | ya, wa = Jo - ya, Ta = qn[ba] << wa, Sa = Ta + (1 << wa); Ta != Sa; )
      pa[va[Ta] >>> 15 - Jo] = xa, Ta++;
  }, Kn.F.revCodes = function(qn, Jo) {
    for (var pa = Kn.F.U.rev15, ma = 15 - Jo, va = 0; va < qn.length; va += 2) {
      var ba = qn[va] << Jo - qn[va + 1];
      qn[va] = pa[ba] >>> ma;
    }
  }, Kn.F._putsE = function(qn, Jo, pa) {
    pa <<= 7 & Jo;
    var ma = Jo >>> 3;
    qn[ma] |= pa, qn[ma + 1] |= pa >>> 8;
  }, Kn.F._putsF = function(qn, Jo, pa) {
    pa <<= 7 & Jo;
    var ma = Jo >>> 3;
    qn[ma] |= pa, qn[ma + 1] |= pa >>> 8, qn[ma + 2] |= pa >>> 16;
  }, Kn.F._bitsE = function(qn, Jo, pa) {
    return (qn[Jo >>> 3] | qn[1 + (Jo >>> 3)] << 8) >>> (7 & Jo) & (1 << pa) - 1;
  }, Kn.F._bitsF = function(qn, Jo, pa) {
    return (qn[Jo >>> 3] | qn[1 + (Jo >>> 3)] << 8 | qn[2 + (Jo >>> 3)] << 16) >>> (7 & Jo) & (1 << pa) - 1;
  }, Kn.F._get17 = function(qn, Jo) {
    return (qn[Jo >>> 3] | qn[1 + (Jo >>> 3)] << 8 | qn[2 + (Jo >>> 3)] << 16) >>> (7 & Jo);
  }, Kn.F._get25 = function(qn, Jo) {
    return (qn[Jo >>> 3] | qn[1 + (Jo >>> 3)] << 8 | qn[2 + (Jo >>> 3)] << 16 | qn[3 + (Jo >>> 3)] << 24) >>> (7 & Jo);
  }, Kn.F.U = (zn = Uint16Array, Un = Uint32Array, { next_code: new zn(16), bl_count: new zn(16), ordr: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], of0: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], exb: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], ldef: new zn(32), df0: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], dxb: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], ddef: new Un(32), flmap: new zn(512), fltree: [], fdmap: new zn(32), fdtree: [], lmap: new zn(32768), ltree: [], ttree: [], dmap: new zn(32768), dtree: [], imap: new zn(512), itree: [], rev15: new zn(32768), lhst: new Un(286), dhst: new Un(30), ihst: new Un(19), lits: new Un(15e3), strt: new zn(65536), prev: new zn(32768) }), function() {
    for (var qn = Kn.F.U, Jo = 0; Jo < 32768; Jo++) {
      var pa = Jo;
      pa = (4278255360 & (pa = (4042322160 & (pa = (3435973836 & (pa = (2863311530 & pa) >>> 1 | (1431655765 & pa) << 1)) >>> 2 | (858993459 & pa) << 2)) >>> 4 | (252645135 & pa) << 4)) >>> 8 | (16711935 & pa) << 8, qn.rev15[Jo] = (pa >>> 16 | pa << 16) >>> 17;
    }
    function ma(va, ba, _a) {
      for (; ba-- != 0; ) va.push(0, _a);
    }
    for (Jo = 0; Jo < 32; Jo++) qn.ldef[Jo] = qn.of0[Jo] << 3 | qn.exb[Jo], qn.ddef[Jo] = qn.df0[Jo] << 4 | qn.dxb[Jo];
    ma(qn.fltree, 144, 8), ma(qn.fltree, 112, 9), ma(qn.fltree, 24, 7), ma(qn.fltree, 8, 8), Kn.F.makeCodes(qn.fltree, 9), Kn.F.codes2map(qn.fltree, 9, qn.flmap), Kn.F.revCodes(qn.fltree, 9), ma(qn.fdtree, 32, 5), Kn.F.makeCodes(qn.fdtree, 5), Kn.F.codes2map(qn.fdtree, 5, qn.fdmap), Kn.F.revCodes(qn.fdtree, 5), ma(qn.itree, 19, 0), ma(qn.ltree, 286, 0), ma(qn.dtree, 30, 0), ma(qn.ttree, 320, 0);
  }();
})();
var UZIP$1 = _mergeNamespaces({ __proto__: null, default: e$2 }, [e$2]);
const UPNG$1 = function() {
  var Xn = { nextZero(_a, ya) {
    for (; _a[ya] != 0; ) ya++;
    return ya;
  }, readUshort: (_a, ya) => _a[ya] << 8 | _a[ya + 1], writeUshort(_a, ya, xa) {
    _a[ya] = xa >> 8 & 255, _a[ya + 1] = 255 & xa;
  }, readUint: (_a, ya) => 16777216 * _a[ya] + (_a[ya + 1] << 16 | _a[ya + 2] << 8 | _a[ya + 3]), writeUint(_a, ya, xa) {
    _a[ya] = xa >> 24 & 255, _a[ya + 1] = xa >> 16 & 255, _a[ya + 2] = xa >> 8 & 255, _a[ya + 3] = 255 & xa;
  }, readASCII(_a, ya, xa) {
    let wa = "";
    for (let Ta = 0; Ta < xa; Ta++) wa += String.fromCharCode(_a[ya + Ta]);
    return wa;
  }, writeASCII(_a, ya, xa) {
    for (let wa = 0; wa < xa.length; wa++) _a[ya + wa] = xa.charCodeAt(wa);
  }, readBytes(_a, ya, xa) {
    const wa = [];
    for (let Ta = 0; Ta < xa; Ta++) wa.push(_a[ya + Ta]);
    return wa;
  }, pad: (_a) => _a.length < 2 ? `0${_a}` : _a, readUTF8(_a, ya, xa) {
    let wa, Ta = "";
    for (let Sa = 0; Sa < xa; Sa++) Ta += `%${Xn.pad(_a[ya + Sa].toString(16))}`;
    try {
      wa = decodeURIComponent(Ta);
    } catch {
      return Xn.readASCII(_a, ya, xa);
    }
    return wa;
  } };
  function zn(_a, ya, xa, wa) {
    const Ta = ya * xa, Sa = Jo(wa), Ma = Math.ceil(ya * Sa / 8), ka = new Uint8Array(4 * Ta), Za = new Uint32Array(ka.buffer), { ctype: Na } = wa, { depth: Ka } = wa, Ja = Xn.readUshort;
    if (Na == 6) {
      const fl = Ta << 2;
      if (Ka == 8) for (var el = 0; el < fl; el += 4) ka[el] = _a[el], ka[el + 1] = _a[el + 1], ka[el + 2] = _a[el + 2], ka[el + 3] = _a[el + 3];
      if (Ka == 16) for (el = 0; el < fl; el++) ka[el] = _a[el << 1];
    } else if (Na == 2) {
      const fl = wa.tabs.tRNS;
      if (fl == null) {
        if (Ka == 8) for (el = 0; el < Ta; el++) {
          var qa = 3 * el;
          Za[el] = 255 << 24 | _a[qa + 2] << 16 | _a[qa + 1] << 8 | _a[qa];
        }
        if (Ka == 16) for (el = 0; el < Ta; el++)
          qa = 6 * el, Za[el] = 255 << 24 | _a[qa + 4] << 16 | _a[qa + 2] << 8 | _a[qa];
      } else {
        var tl = fl[0];
        const Ml = fl[1], Sl = fl[2];
        if (Ka == 8) for (el = 0; el < Ta; el++) {
          var Qa = el << 2;
          qa = 3 * el, Za[el] = 255 << 24 | _a[qa + 2] << 16 | _a[qa + 1] << 8 | _a[qa], _a[qa] == tl && _a[qa + 1] == Ml && _a[qa + 2] == Sl && (ka[Qa + 3] = 0);
        }
        if (Ka == 16) for (el = 0; el < Ta; el++)
          Qa = el << 2, qa = 6 * el, Za[el] = 255 << 24 | _a[qa + 4] << 16 | _a[qa + 2] << 8 | _a[qa], Ja(_a, qa) == tl && Ja(_a, qa + 2) == Ml && Ja(_a, qa + 4) == Sl && (ka[Qa + 3] = 0);
      }
    } else if (Na == 3) {
      const fl = wa.tabs.PLTE, Ml = wa.tabs.tRNS, Sl = Ml ? Ml.length : 0;
      if (Ka == 1) for (var nl = 0; nl < xa; nl++) {
        var rl = nl * Ma, il = nl * ya;
        for (el = 0; el < ya; el++) {
          Qa = il + el << 2;
          var cl = 3 * (ll = _a[rl + (el >> 3)] >> 7 - ((7 & el) << 0) & 1);
          ka[Qa] = fl[cl], ka[Qa + 1] = fl[cl + 1], ka[Qa + 2] = fl[cl + 2], ka[Qa + 3] = ll < Sl ? Ml[ll] : 255;
        }
      }
      if (Ka == 2) for (nl = 0; nl < xa; nl++) for (rl = nl * Ma, il = nl * ya, el = 0; el < ya; el++)
        Qa = il + el << 2, cl = 3 * (ll = _a[rl + (el >> 2)] >> 6 - ((3 & el) << 1) & 3), ka[Qa] = fl[cl], ka[Qa + 1] = fl[cl + 1], ka[Qa + 2] = fl[cl + 2], ka[Qa + 3] = ll < Sl ? Ml[ll] : 255;
      if (Ka == 4) for (nl = 0; nl < xa; nl++) for (rl = nl * Ma, il = nl * ya, el = 0; el < ya; el++)
        Qa = il + el << 2, cl = 3 * (ll = _a[rl + (el >> 1)] >> 4 - ((1 & el) << 2) & 15), ka[Qa] = fl[cl], ka[Qa + 1] = fl[cl + 1], ka[Qa + 2] = fl[cl + 2], ka[Qa + 3] = ll < Sl ? Ml[ll] : 255;
      if (Ka == 8) for (el = 0; el < Ta; el++) {
        var ll;
        Qa = el << 2, cl = 3 * (ll = _a[el]), ka[Qa] = fl[cl], ka[Qa + 1] = fl[cl + 1], ka[Qa + 2] = fl[cl + 2], ka[Qa + 3] = ll < Sl ? Ml[ll] : 255;
      }
    } else if (Na == 4) {
      if (Ka == 8) for (el = 0; el < Ta; el++) {
        Qa = el << 2;
        var al = _a[sl = el << 1];
        ka[Qa] = al, ka[Qa + 1] = al, ka[Qa + 2] = al, ka[Qa + 3] = _a[sl + 1];
      }
      if (Ka == 16) for (el = 0; el < Ta; el++) {
        var sl;
        Qa = el << 2, al = _a[sl = el << 2], ka[Qa] = al, ka[Qa + 1] = al, ka[Qa + 2] = al, ka[Qa + 3] = _a[sl + 2];
      }
    } else if (Na == 0) for (tl = wa.tabs.tRNS ? wa.tabs.tRNS : -1, nl = 0; nl < xa; nl++) {
      const fl = nl * Ma, Ml = nl * ya;
      if (Ka == 1) for (var dl = 0; dl < ya; dl++) {
        var El = (al = 255 * (_a[fl + (dl >>> 3)] >>> 7 - (7 & dl) & 1)) == 255 * tl ? 0 : 255;
        Za[Ml + dl] = El << 24 | al << 16 | al << 8 | al;
      }
      else if (Ka == 2) for (dl = 0; dl < ya; dl++)
        El = (al = 85 * (_a[fl + (dl >>> 2)] >>> 6 - ((3 & dl) << 1) & 3)) == 85 * tl ? 0 : 255, Za[Ml + dl] = El << 24 | al << 16 | al << 8 | al;
      else if (Ka == 4) for (dl = 0; dl < ya; dl++)
        El = (al = 17 * (_a[fl + (dl >>> 1)] >>> 4 - ((1 & dl) << 2) & 15)) == 17 * tl ? 0 : 255, Za[Ml + dl] = El << 24 | al << 16 | al << 8 | al;
      else if (Ka == 8) for (dl = 0; dl < ya; dl++)
        El = (al = _a[fl + dl]) == tl ? 0 : 255, Za[Ml + dl] = El << 24 | al << 16 | al << 8 | al;
      else if (Ka == 16) for (dl = 0; dl < ya; dl++)
        al = _a[fl + (dl << 1)], El = Ja(_a, fl + (dl << 1)) == tl ? 0 : 255, Za[Ml + dl] = El << 24 | al << 16 | al << 8 | al;
    }
    return ka;
  }
  function Un(_a, ya, xa, wa) {
    const Ta = Jo(_a), Sa = Math.ceil(xa * Ta / 8), Ma = new Uint8Array((Sa + 1 + _a.interlace) * wa);
    return ya = _a.tabs.CgBI ? qn(ya, Ma) : Kn(ya, Ma), _a.interlace == 0 ? ya = pa(ya, _a, 0, xa, wa) : _a.interlace == 1 && (ya = function(Za, Na) {
      const Ka = Na.width, Ja = Na.height, el = Jo(Na), qa = el >> 3, tl = Math.ceil(Ka * el / 8), Qa = new Uint8Array(Ja * tl);
      let nl = 0;
      const rl = [0, 0, 4, 0, 2, 0, 1], il = [0, 4, 0, 2, 0, 1, 0], cl = [8, 8, 8, 4, 4, 2, 2], ll = [8, 8, 4, 4, 2, 2, 1];
      let al = 0;
      for (; al < 7; ) {
        const dl = cl[al], El = ll[al];
        let fl = 0, Ml = 0, Sl = rl[al];
        for (; Sl < Ja; ) Sl += dl, Ml++;
        let ml = il[al];
        for (; ml < Ka; ) ml += El, fl++;
        const Dl = Math.ceil(fl * el / 8);
        pa(Za, Na, nl, fl, Ml);
        let _l = 0, gl = rl[al];
        for (; gl < Ja; ) {
          let Fl = il[al], Nl = nl + _l * Dl << 3;
          for (; Fl < Ka; ) {
            var sl;
            if (el == 1 && (sl = (sl = Za[Nl >> 3]) >> 7 - (7 & Nl) & 1, Qa[gl * tl + (Fl >> 3)] |= sl << 7 - ((7 & Fl) << 0)), el == 2 && (sl = (sl = Za[Nl >> 3]) >> 6 - (7 & Nl) & 3, Qa[gl * tl + (Fl >> 2)] |= sl << 6 - ((3 & Fl) << 1)), el == 4 && (sl = (sl = Za[Nl >> 3]) >> 4 - (7 & Nl) & 15, Qa[gl * tl + (Fl >> 1)] |= sl << 4 - ((1 & Fl) << 2)), el >= 8) {
              const zl = gl * tl + Fl * qa;
              for (let Zl = 0; Zl < qa; Zl++) Qa[zl + Zl] = Za[(Nl >> 3) + Zl];
            }
            Nl += el, Fl += El;
          }
          _l++, gl += dl;
        }
        fl * Ml != 0 && (nl += Ml * (1 + Dl)), al += 1;
      }
      return Qa;
    }(ya, _a)), ya;
  }
  function Kn(_a, ya) {
    return qn(new Uint8Array(_a.buffer, 2, _a.length - 6), ya);
  }
  var qn = function() {
    const _a = { H: {} };
    return _a.H.N = function(ya, xa) {
      const wa = Uint8Array;
      let Ta, Sa, Ma = 0, ka = 0, Za = 0, Na = 0, Ka = 0, Ja = 0, el = 0, qa = 0, tl = 0;
      if (ya[0] == 3 && ya[1] == 0) return xa || new wa(0);
      const Qa = _a.H, nl = Qa.b, rl = Qa.e, il = Qa.R, cl = Qa.n, ll = Qa.A, al = Qa.Z, sl = Qa.m, dl = xa == null;
      for (dl && (xa = new wa(ya.length >>> 2 << 5)); Ma == 0; ) if (Ma = nl(ya, tl, 1), ka = nl(ya, tl + 1, 2), tl += 3, ka != 0) {
        if (dl && (xa = _a.H.W(xa, qa + (1 << 17))), ka == 1 && (Ta = sl.J, Sa = sl.h, Ja = 511, el = 31), ka == 2) {
          Za = rl(ya, tl, 5) + 257, Na = rl(ya, tl + 5, 5) + 1, Ka = rl(ya, tl + 10, 4) + 4, tl += 14;
          let fl = 1;
          for (var El = 0; El < 38; El += 2) sl.Q[El] = 0, sl.Q[El + 1] = 0;
          for (El = 0; El < Ka; El++) {
            const ml = rl(ya, tl + 3 * El, 3);
            sl.Q[1 + (sl.X[El] << 1)] = ml, ml > fl && (fl = ml);
          }
          tl += 3 * Ka, cl(sl.Q, fl), ll(sl.Q, fl, sl.u), Ta = sl.w, Sa = sl.d, tl = il(sl.u, (1 << fl) - 1, Za + Na, ya, tl, sl.v);
          const Ml = Qa.V(sl.v, 0, Za, sl.C);
          Ja = (1 << Ml) - 1;
          const Sl = Qa.V(sl.v, Za, Na, sl.D);
          el = (1 << Sl) - 1, cl(sl.C, Ml), ll(sl.C, Ml, Ta), cl(sl.D, Sl), ll(sl.D, Sl, Sa);
        }
        for (; ; ) {
          const fl = Ta[al(ya, tl) & Ja];
          tl += 15 & fl;
          const Ml = fl >>> 4;
          if (!(Ml >>> 8)) xa[qa++] = Ml;
          else {
            if (Ml == 256) break;
            {
              let Sl = qa + Ml - 254;
              if (Ml > 264) {
                const Fl = sl.q[Ml - 257];
                Sl = qa + (Fl >>> 3) + rl(ya, tl, 7 & Fl), tl += 7 & Fl;
              }
              const ml = Sa[al(ya, tl) & el];
              tl += 15 & ml;
              const Dl = ml >>> 4, _l = sl.c[Dl], gl = (_l >>> 4) + nl(ya, tl, 15 & _l);
              for (tl += 15 & _l; qa < Sl; ) xa[qa] = xa[qa++ - gl], xa[qa] = xa[qa++ - gl], xa[qa] = xa[qa++ - gl], xa[qa] = xa[qa++ - gl];
              qa = Sl;
            }
          }
        }
      } else {
        (7 & tl) != 0 && (tl += 8 - (7 & tl));
        const fl = 4 + (tl >>> 3), Ml = ya[fl - 4] | ya[fl - 3] << 8;
        dl && (xa = _a.H.W(xa, qa + Ml)), xa.set(new wa(ya.buffer, ya.byteOffset + fl, Ml), qa), tl = fl + Ml << 3, qa += Ml;
      }
      return xa.length == qa ? xa : xa.slice(0, qa);
    }, _a.H.W = function(ya, xa) {
      const wa = ya.length;
      if (xa <= wa) return ya;
      const Ta = new Uint8Array(wa << 1);
      return Ta.set(ya, 0), Ta;
    }, _a.H.R = function(ya, xa, wa, Ta, Sa, Ma) {
      const ka = _a.H.e, Za = _a.H.Z;
      let Na = 0;
      for (; Na < wa; ) {
        const Ka = ya[Za(Ta, Sa) & xa];
        Sa += 15 & Ka;
        const Ja = Ka >>> 4;
        if (Ja <= 15) Ma[Na] = Ja, Na++;
        else {
          let el = 0, qa = 0;
          Ja == 16 ? (qa = 3 + ka(Ta, Sa, 2), Sa += 2, el = Ma[Na - 1]) : Ja == 17 ? (qa = 3 + ka(Ta, Sa, 3), Sa += 3) : Ja == 18 && (qa = 11 + ka(Ta, Sa, 7), Sa += 7);
          const tl = Na + qa;
          for (; Na < tl; ) Ma[Na] = el, Na++;
        }
      }
      return Sa;
    }, _a.H.V = function(ya, xa, wa, Ta) {
      let Sa = 0, Ma = 0;
      const ka = Ta.length >>> 1;
      for (; Ma < wa; ) {
        const Za = ya[Ma + xa];
        Ta[Ma << 1] = 0, Ta[1 + (Ma << 1)] = Za, Za > Sa && (Sa = Za), Ma++;
      }
      for (; Ma < ka; ) Ta[Ma << 1] = 0, Ta[1 + (Ma << 1)] = 0, Ma++;
      return Sa;
    }, _a.H.n = function(ya, xa) {
      const wa = _a.H.m, Ta = ya.length;
      let Sa, Ma, ka, Za;
      const Na = wa.j;
      for (var Ka = 0; Ka <= xa; Ka++) Na[Ka] = 0;
      for (Ka = 1; Ka < Ta; Ka += 2) Na[ya[Ka]]++;
      const Ja = wa.K;
      for (Sa = 0, Na[0] = 0, Ma = 1; Ma <= xa; Ma++) Sa = Sa + Na[Ma - 1] << 1, Ja[Ma] = Sa;
      for (ka = 0; ka < Ta; ka += 2) Za = ya[ka + 1], Za != 0 && (ya[ka] = Ja[Za], Ja[Za]++);
    }, _a.H.A = function(ya, xa, wa) {
      const Ta = ya.length, Sa = _a.H.m.r;
      for (let Ma = 0; Ma < Ta; Ma += 2) if (ya[Ma + 1] != 0) {
        const ka = Ma >> 1, Za = ya[Ma + 1], Na = ka << 4 | Za, Ka = xa - Za;
        let Ja = ya[Ma] << Ka;
        const el = Ja + (1 << Ka);
        for (; Ja != el; )
          wa[Sa[Ja] >>> 15 - xa] = Na, Ja++;
      }
    }, _a.H.l = function(ya, xa) {
      const wa = _a.H.m.r, Ta = 15 - xa;
      for (let Sa = 0; Sa < ya.length; Sa += 2) {
        const Ma = ya[Sa] << xa - ya[Sa + 1];
        ya[Sa] = wa[Ma] >>> Ta;
      }
    }, _a.H.M = function(ya, xa, wa) {
      wa <<= 7 & xa;
      const Ta = xa >>> 3;
      ya[Ta] |= wa, ya[Ta + 1] |= wa >>> 8;
    }, _a.H.I = function(ya, xa, wa) {
      wa <<= 7 & xa;
      const Ta = xa >>> 3;
      ya[Ta] |= wa, ya[Ta + 1] |= wa >>> 8, ya[Ta + 2] |= wa >>> 16;
    }, _a.H.e = function(ya, xa, wa) {
      return (ya[xa >>> 3] | ya[1 + (xa >>> 3)] << 8) >>> (7 & xa) & (1 << wa) - 1;
    }, _a.H.b = function(ya, xa, wa) {
      return (ya[xa >>> 3] | ya[1 + (xa >>> 3)] << 8 | ya[2 + (xa >>> 3)] << 16) >>> (7 & xa) & (1 << wa) - 1;
    }, _a.H.Z = function(ya, xa) {
      return (ya[xa >>> 3] | ya[1 + (xa >>> 3)] << 8 | ya[2 + (xa >>> 3)] << 16) >>> (7 & xa);
    }, _a.H.i = function(ya, xa) {
      return (ya[xa >>> 3] | ya[1 + (xa >>> 3)] << 8 | ya[2 + (xa >>> 3)] << 16 | ya[3 + (xa >>> 3)] << 24) >>> (7 & xa);
    }, _a.H.m = function() {
      const ya = Uint16Array, xa = Uint32Array;
      return { K: new ya(16), j: new ya(16), X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], S: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], T: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], q: new ya(32), p: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], z: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], c: new xa(32), J: new ya(512), _: [], h: new ya(32), $: [], w: new ya(32768), C: [], v: [], d: new ya(32768), D: [], u: new ya(512), Q: [], r: new ya(32768), s: new xa(286), Y: new xa(30), a: new xa(19), t: new xa(15e3), k: new ya(65536), g: new ya(32768) };
    }(), function() {
      const ya = _a.H.m;
      for (var xa = 0; xa < 32768; xa++) {
        let Ta = xa;
        Ta = (2863311530 & Ta) >>> 1 | (1431655765 & Ta) << 1, Ta = (3435973836 & Ta) >>> 2 | (858993459 & Ta) << 2, Ta = (4042322160 & Ta) >>> 4 | (252645135 & Ta) << 4, Ta = (4278255360 & Ta) >>> 8 | (16711935 & Ta) << 8, ya.r[xa] = (Ta >>> 16 | Ta << 16) >>> 17;
      }
      function wa(Ta, Sa, Ma) {
        for (; Sa-- != 0; ) Ta.push(0, Ma);
      }
      for (xa = 0; xa < 32; xa++) ya.q[xa] = ya.S[xa] << 3 | ya.T[xa], ya.c[xa] = ya.p[xa] << 4 | ya.z[xa];
      wa(ya._, 144, 8), wa(ya._, 112, 9), wa(ya._, 24, 7), wa(ya._, 8, 8), _a.H.n(ya._, 9), _a.H.A(ya._, 9, ya.J), _a.H.l(ya._, 9), wa(ya.$, 32, 5), _a.H.n(ya.$, 5), _a.H.A(ya.$, 5, ya.h), _a.H.l(ya.$, 5), wa(ya.Q, 19, 0), wa(ya.C, 286, 0), wa(ya.D, 30, 0), wa(ya.v, 320, 0);
    }(), _a.H.N;
  }();
  function Jo(_a) {
    return [1, null, 3, 1, 2, null, 4][_a.ctype] * _a.depth;
  }
  function pa(_a, ya, xa, wa, Ta) {
    let Sa = Jo(ya);
    const Ma = Math.ceil(wa * Sa / 8);
    let ka, Za;
    Sa = Math.ceil(Sa / 8);
    let Na = _a[xa], Ka = 0;
    if (Na > 1 && (_a[xa] = [0, 0, 1][Na - 2]), Na == 3) for (Ka = Sa; Ka < Ma; Ka++) _a[Ka + 1] = _a[Ka + 1] + (_a[Ka + 1 - Sa] >>> 1) & 255;
    for (let Ja = 0; Ja < Ta; Ja++) if (ka = xa + Ja * Ma, Za = ka + Ja + 1, Na = _a[Za - 1], Ka = 0, Na == 0) for (; Ka < Ma; Ka++) _a[ka + Ka] = _a[Za + Ka];
    else if (Na == 1) {
      for (; Ka < Sa; Ka++) _a[ka + Ka] = _a[Za + Ka];
      for (; Ka < Ma; Ka++) _a[ka + Ka] = _a[Za + Ka] + _a[ka + Ka - Sa];
    } else if (Na == 2) for (; Ka < Ma; Ka++) _a[ka + Ka] = _a[Za + Ka] + _a[ka + Ka - Ma];
    else if (Na == 3) {
      for (; Ka < Sa; Ka++) _a[ka + Ka] = _a[Za + Ka] + (_a[ka + Ka - Ma] >>> 1);
      for (; Ka < Ma; Ka++) _a[ka + Ka] = _a[Za + Ka] + (_a[ka + Ka - Ma] + _a[ka + Ka - Sa] >>> 1);
    } else {
      for (; Ka < Sa; Ka++) _a[ka + Ka] = _a[Za + Ka] + ma(0, _a[ka + Ka - Ma], 0);
      for (; Ka < Ma; Ka++) _a[ka + Ka] = _a[Za + Ka] + ma(_a[ka + Ka - Sa], _a[ka + Ka - Ma], _a[ka + Ka - Sa - Ma]);
    }
    return _a;
  }
  function ma(_a, ya, xa) {
    const wa = _a + ya - xa, Ta = wa - _a, Sa = wa - ya, Ma = wa - xa;
    return Ta * Ta <= Sa * Sa && Ta * Ta <= Ma * Ma ? _a : Sa * Sa <= Ma * Ma ? ya : xa;
  }
  function va(_a, ya, xa) {
    xa.width = Xn.readUint(_a, ya), ya += 4, xa.height = Xn.readUint(_a, ya), ya += 4, xa.depth = _a[ya], ya++, xa.ctype = _a[ya], ya++, xa.compress = _a[ya], ya++, xa.filter = _a[ya], ya++, xa.interlace = _a[ya], ya++;
  }
  function ba(_a, ya, xa, wa, Ta, Sa, Ma, ka, Za) {
    const Na = Math.min(ya, Ta), Ka = Math.min(xa, Sa);
    let Ja = 0, el = 0;
    for (let al = 0; al < Ka; al++) for (let sl = 0; sl < Na; sl++) if (Ma >= 0 && ka >= 0 ? (Ja = al * ya + sl << 2, el = (ka + al) * Ta + Ma + sl << 2) : (Ja = (-ka + al) * ya - Ma + sl << 2, el = al * Ta + sl << 2), Za == 0) wa[el] = _a[Ja], wa[el + 1] = _a[Ja + 1], wa[el + 2] = _a[Ja + 2], wa[el + 3] = _a[Ja + 3];
    else if (Za == 1) {
      var qa = _a[Ja + 3] * 0.00392156862745098, tl = _a[Ja] * qa, Qa = _a[Ja + 1] * qa, nl = _a[Ja + 2] * qa, rl = wa[el + 3] * (1 / 255), il = wa[el] * rl, cl = wa[el + 1] * rl, ll = wa[el + 2] * rl;
      const dl = 1 - qa, El = qa + rl * dl, fl = El == 0 ? 0 : 1 / El;
      wa[el + 3] = 255 * El, wa[el + 0] = (tl + il * dl) * fl, wa[el + 1] = (Qa + cl * dl) * fl, wa[el + 2] = (nl + ll * dl) * fl;
    } else if (Za == 2)
      qa = _a[Ja + 3], tl = _a[Ja], Qa = _a[Ja + 1], nl = _a[Ja + 2], rl = wa[el + 3], il = wa[el], cl = wa[el + 1], ll = wa[el + 2], qa == rl && tl == il && Qa == cl && nl == ll ? (wa[el] = 0, wa[el + 1] = 0, wa[el + 2] = 0, wa[el + 3] = 0) : (wa[el] = tl, wa[el + 1] = Qa, wa[el + 2] = nl, wa[el + 3] = qa);
    else if (Za == 3) {
      if (qa = _a[Ja + 3], tl = _a[Ja], Qa = _a[Ja + 1], nl = _a[Ja + 2], rl = wa[el + 3], il = wa[el], cl = wa[el + 1], ll = wa[el + 2], qa == rl && tl == il && Qa == cl && nl == ll) continue;
      if (qa < 220 && rl > 20) return !1;
    }
    return !0;
  }
  return { decode: function(ya) {
    const xa = new Uint8Array(ya);
    let wa = 8;
    const Ta = Xn, Sa = Ta.readUshort, Ma = Ta.readUint, ka = { tabs: {}, frames: [] }, Za = new Uint8Array(xa.length);
    let Na, Ka = 0, Ja = 0;
    const el = [137, 80, 78, 71, 13, 10, 26, 10];
    for (var qa = 0; qa < 8; qa++) if (xa[qa] != el[qa]) throw "The input is not a PNG file!";
    for (; wa < xa.length; ) {
      const al = Ta.readUint(xa, wa);
      wa += 4;
      const sl = Ta.readASCII(xa, wa, 4);
      if (wa += 4, sl == "IHDR") va(xa, wa, ka);
      else if (sl == "iCCP") {
        for (var tl = wa; xa[tl] != 0; ) tl++;
        Ta.readASCII(xa, wa, tl - wa), xa[tl + 1];
        const dl = xa.slice(tl + 2, wa + al);
        let El = null;
        try {
          El = Kn(dl);
        } catch {
          El = qn(dl);
        }
        ka.tabs[sl] = El;
      } else if (sl == "CgBI") ka.tabs[sl] = xa.slice(wa, wa + 4);
      else if (sl == "IDAT") {
        for (qa = 0; qa < al; qa++) Za[Ka + qa] = xa[wa + qa];
        Ka += al;
      } else if (sl == "acTL") ka.tabs[sl] = { num_frames: Ma(xa, wa), num_plays: Ma(xa, wa + 4) }, Na = new Uint8Array(xa.length);
      else if (sl == "fcTL") {
        Ja != 0 && ((ll = ka.frames[ka.frames.length - 1]).data = Un(ka, Na.slice(0, Ja), ll.rect.width, ll.rect.height), Ja = 0);
        const dl = { x: Ma(xa, wa + 12), y: Ma(xa, wa + 16), width: Ma(xa, wa + 4), height: Ma(xa, wa + 8) };
        let El = Sa(xa, wa + 22);
        El = Sa(xa, wa + 20) / (El == 0 ? 100 : El);
        const fl = { rect: dl, delay: Math.round(1e3 * El), dispose: xa[wa + 24], blend: xa[wa + 25] };
        ka.frames.push(fl);
      } else if (sl == "fdAT") {
        for (qa = 0; qa < al - 4; qa++) Na[Ja + qa] = xa[wa + qa + 4];
        Ja += al - 4;
      } else if (sl == "pHYs") ka.tabs[sl] = [Ta.readUint(xa, wa), Ta.readUint(xa, wa + 4), xa[wa + 8]];
      else if (sl == "cHRM")
        for (ka.tabs[sl] = [], qa = 0; qa < 8; qa++) ka.tabs[sl].push(Ta.readUint(xa, wa + 4 * qa));
      else if (sl == "tEXt" || sl == "zTXt") {
        ka.tabs[sl] == null && (ka.tabs[sl] = {});
        var Qa = Ta.nextZero(xa, wa), nl = Ta.readASCII(xa, wa, Qa - wa), rl = wa + al - Qa - 1;
        if (sl == "tEXt") cl = Ta.readASCII(xa, Qa + 1, rl);
        else {
          var il = Kn(xa.slice(Qa + 2, Qa + 2 + rl));
          cl = Ta.readUTF8(il, 0, il.length);
        }
        ka.tabs[sl][nl] = cl;
      } else if (sl == "iTXt") {
        ka.tabs[sl] == null && (ka.tabs[sl] = {}), Qa = 0, tl = wa, Qa = Ta.nextZero(xa, tl), nl = Ta.readASCII(xa, tl, Qa - tl);
        const dl = xa[tl = Qa + 1];
        var cl;
        xa[tl + 1], tl += 2, Qa = Ta.nextZero(xa, tl), Ta.readASCII(xa, tl, Qa - tl), tl = Qa + 1, Qa = Ta.nextZero(xa, tl), Ta.readUTF8(xa, tl, Qa - tl), rl = al - ((tl = Qa + 1) - wa), dl == 0 ? cl = Ta.readUTF8(xa, tl, rl) : (il = Kn(xa.slice(tl, tl + rl)), cl = Ta.readUTF8(il, 0, il.length)), ka.tabs[sl][nl] = cl;
      } else if (sl == "PLTE") ka.tabs[sl] = Ta.readBytes(xa, wa, al);
      else if (sl == "hIST") {
        const dl = ka.tabs.PLTE.length / 3;
        for (ka.tabs[sl] = [], qa = 0; qa < dl; qa++) ka.tabs[sl].push(Sa(xa, wa + 2 * qa));
      } else if (sl == "tRNS") ka.ctype == 3 ? ka.tabs[sl] = Ta.readBytes(xa, wa, al) : ka.ctype == 0 ? ka.tabs[sl] = Sa(xa, wa) : ka.ctype == 2 && (ka.tabs[sl] = [Sa(xa, wa), Sa(xa, wa + 2), Sa(xa, wa + 4)]);
      else if (sl == "gAMA") ka.tabs[sl] = Ta.readUint(xa, wa) / 1e5;
      else if (sl == "sRGB") ka.tabs[sl] = xa[wa];
      else if (sl == "bKGD") ka.ctype == 0 || ka.ctype == 4 ? ka.tabs[sl] = [Sa(xa, wa)] : ka.ctype == 2 || ka.ctype == 6 ? ka.tabs[sl] = [Sa(xa, wa), Sa(xa, wa + 2), Sa(xa, wa + 4)] : ka.ctype == 3 && (ka.tabs[sl] = xa[wa]);
      else if (sl == "IEND") break;
      wa += al, Ta.readUint(xa, wa), wa += 4;
    }
    var ll;
    return Ja != 0 && ((ll = ka.frames[ka.frames.length - 1]).data = Un(ka, Na.slice(0, Ja), ll.rect.width, ll.rect.height)), ka.data = Un(ka, Za, ka.width, ka.height), delete ka.compress, delete ka.interlace, delete ka.filter, ka;
  }, toRGBA8: function(ya) {
    const xa = ya.width, wa = ya.height;
    if (ya.tabs.acTL == null) return [zn(ya.data, xa, wa, ya).buffer];
    const Ta = [];
    ya.frames[0].data == null && (ya.frames[0].data = ya.data);
    const Sa = xa * wa * 4, Ma = new Uint8Array(Sa), ka = new Uint8Array(Sa), Za = new Uint8Array(Sa);
    for (let Ka = 0; Ka < ya.frames.length; Ka++) {
      const Ja = ya.frames[Ka], el = Ja.rect.x, qa = Ja.rect.y, tl = Ja.rect.width, Qa = Ja.rect.height, nl = zn(Ja.data, tl, Qa, ya);
      if (Ka != 0) for (var Na = 0; Na < Sa; Na++) Za[Na] = Ma[Na];
      if (Ja.blend == 0 ? ba(nl, tl, Qa, Ma, xa, wa, el, qa, 0) : Ja.blend == 1 && ba(nl, tl, Qa, Ma, xa, wa, el, qa, 1), Ta.push(Ma.buffer.slice(0)), Ja.dispose != 0) {
        if (Ja.dispose == 1) ba(ka, tl, Qa, Ma, xa, wa, el, qa, 0);
        else if (Ja.dispose == 2) for (Na = 0; Na < Sa; Na++) Ma[Na] = Za[Na];
      }
    }
    return Ta;
  }, _paeth: ma, _copyTile: ba, _bin: Xn };
}();
(function() {
  const { _copyTile: Xn } = UPNG$1, { _bin: zn } = UPNG$1, Un = UPNG$1._paeth;
  var Kn = { table: function() {
    const tl = new Uint32Array(256);
    for (let Qa = 0; Qa < 256; Qa++) {
      let nl = Qa;
      for (let rl = 0; rl < 8; rl++) 1 & nl ? nl = 3988292384 ^ nl >>> 1 : nl >>>= 1;
      tl[Qa] = nl;
    }
    return tl;
  }(), update(tl, Qa, nl, rl) {
    for (let il = 0; il < rl; il++) tl = Kn.table[255 & (tl ^ Qa[nl + il])] ^ tl >>> 8;
    return tl;
  }, crc: (tl, Qa, nl) => 4294967295 ^ Kn.update(4294967295, tl, Qa, nl) };
  function qn(tl, Qa, nl, rl) {
    Qa[nl] += tl[0] * rl >> 4, Qa[nl + 1] += tl[1] * rl >> 4, Qa[nl + 2] += tl[2] * rl >> 4, Qa[nl + 3] += tl[3] * rl >> 4;
  }
  function Jo(tl) {
    return Math.max(0, Math.min(255, tl));
  }
  function pa(tl, Qa) {
    const nl = tl[0] - Qa[0], rl = tl[1] - Qa[1], il = tl[2] - Qa[2], cl = tl[3] - Qa[3];
    return nl * nl + rl * rl + il * il + cl * cl;
  }
  function ma(tl, Qa, nl, rl, il, cl, ll) {
    ll == null && (ll = 1);
    const al = rl.length, sl = [];
    for (var dl = 0; dl < al; dl++) {
      const gl = rl[dl];
      sl.push([gl >>> 0 & 255, gl >>> 8 & 255, gl >>> 16 & 255, gl >>> 24 & 255]);
    }
    for (dl = 0; dl < al; dl++) {
      let gl = 4294967295;
      for (var El = 0, fl = 0; fl < al; fl++) {
        var Ml = pa(sl[dl], sl[fl]);
        fl != dl && Ml < gl && (gl = Ml, El = fl);
      }
    }
    const Sl = new Uint32Array(il.buffer), ml = new Int16Array(Qa * nl * 4), Dl = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
    for (dl = 0; dl < Dl.length; dl++) Dl[dl] = 255 * ((Dl[dl] + 0.5) / 16 - 0.5);
    for (let gl = 0; gl < nl; gl++) for (let Fl = 0; Fl < Qa; Fl++) {
      var _l;
      dl = 4 * (gl * Qa + Fl), ll != 2 ? _l = [Jo(tl[dl] + ml[dl]), Jo(tl[dl + 1] + ml[dl + 1]), Jo(tl[dl + 2] + ml[dl + 2]), Jo(tl[dl + 3] + ml[dl + 3])] : (Ml = Dl[4 * (3 & gl) + (3 & Fl)], _l = [Jo(tl[dl] + Ml), Jo(tl[dl + 1] + Ml), Jo(tl[dl + 2] + Ml), Jo(tl[dl + 3] + Ml)]), El = 0;
      let Nl = 16777215;
      for (fl = 0; fl < al; fl++) {
        const kl = pa(_l, sl[fl]);
        kl < Nl && (Nl = kl, El = fl);
      }
      const zl = sl[El], Zl = [_l[0] - zl[0], _l[1] - zl[1], _l[2] - zl[2], _l[3] - zl[3]];
      ll == 1 && (Fl != Qa - 1 && qn(Zl, ml, dl + 4, 7), gl != nl - 1 && (Fl != 0 && qn(Zl, ml, dl + 4 * Qa - 4, 3), qn(Zl, ml, dl + 4 * Qa, 5), Fl != Qa - 1 && qn(Zl, ml, dl + 4 * Qa + 4, 1))), cl[dl >> 2] = El, Sl[dl >> 2] = rl[El];
    }
  }
  function va(tl, Qa, nl, rl, il) {
    il == null && (il = {});
    const { crc: cl } = Kn, ll = zn.writeUint, al = zn.writeUshort, sl = zn.writeASCII;
    let dl = 8;
    const El = tl.frames.length > 1;
    let fl, Ml = !1, Sl = 33 + (El ? 20 : 0);
    if (il.sRGB != null && (Sl += 13), il.pHYs != null && (Sl += 21), il.iCCP != null && (fl = pako.deflate(il.iCCP), Sl += 21 + fl.length + 4), tl.ctype == 3) {
      for (var ml = tl.plte.length, Dl = 0; Dl < ml; Dl++) tl.plte[Dl] >>> 24 != 255 && (Ml = !0);
      Sl += 8 + 3 * ml + 4 + (Ml ? 8 + 1 * ml + 4 : 0);
    }
    for (var _l = 0; _l < tl.frames.length; _l++)
      El && (Sl += 38), Sl += (zl = tl.frames[_l]).cimg.length + 12, _l != 0 && (Sl += 4);
    Sl += 12;
    const gl = new Uint8Array(Sl), Fl = [137, 80, 78, 71, 13, 10, 26, 10];
    for (Dl = 0; Dl < 8; Dl++) gl[Dl] = Fl[Dl];
    if (ll(gl, dl, 13), dl += 4, sl(gl, dl, "IHDR"), dl += 4, ll(gl, dl, Qa), dl += 4, ll(gl, dl, nl), dl += 4, gl[dl] = tl.depth, dl++, gl[dl] = tl.ctype, dl++, gl[dl] = 0, dl++, gl[dl] = 0, dl++, gl[dl] = 0, dl++, ll(gl, dl, cl(gl, dl - 17, 17)), dl += 4, il.sRGB != null && (ll(gl, dl, 1), dl += 4, sl(gl, dl, "sRGB"), dl += 4, gl[dl] = il.sRGB, dl++, ll(gl, dl, cl(gl, dl - 5, 5)), dl += 4), il.iCCP != null) {
      const Zl = 13 + fl.length;
      ll(gl, dl, Zl), dl += 4, sl(gl, dl, "iCCP"), dl += 4, sl(gl, dl, "ICC profile"), dl += 11, dl += 2, gl.set(fl, dl), dl += fl.length, ll(gl, dl, cl(gl, dl - (Zl + 4), Zl + 4)), dl += 4;
    }
    if (il.pHYs != null && (ll(gl, dl, 9), dl += 4, sl(gl, dl, "pHYs"), dl += 4, ll(gl, dl, il.pHYs[0]), dl += 4, ll(gl, dl, il.pHYs[1]), dl += 4, gl[dl] = il.pHYs[2], dl++, ll(gl, dl, cl(gl, dl - 13, 13)), dl += 4), El && (ll(gl, dl, 8), dl += 4, sl(gl, dl, "acTL"), dl += 4, ll(gl, dl, tl.frames.length), dl += 4, ll(gl, dl, il.loop != null ? il.loop : 0), dl += 4, ll(gl, dl, cl(gl, dl - 12, 12)), dl += 4), tl.ctype == 3) {
      for (ll(gl, dl, 3 * (ml = tl.plte.length)), dl += 4, sl(gl, dl, "PLTE"), dl += 4, Dl = 0; Dl < ml; Dl++) {
        const Zl = 3 * Dl, kl = tl.plte[Dl], ul = 255 & kl, vl = kl >>> 8 & 255, Tl = kl >>> 16 & 255;
        gl[dl + Zl + 0] = ul, gl[dl + Zl + 1] = vl, gl[dl + Zl + 2] = Tl;
      }
      if (dl += 3 * ml, ll(gl, dl, cl(gl, dl - 3 * ml - 4, 3 * ml + 4)), dl += 4, Ml) {
        for (ll(gl, dl, ml), dl += 4, sl(gl, dl, "tRNS"), dl += 4, Dl = 0; Dl < ml; Dl++) gl[dl + Dl] = tl.plte[Dl] >>> 24 & 255;
        dl += ml, ll(gl, dl, cl(gl, dl - ml - 4, ml + 4)), dl += 4;
      }
    }
    let Nl = 0;
    for (_l = 0; _l < tl.frames.length; _l++) {
      var zl = tl.frames[_l];
      El && (ll(gl, dl, 26), dl += 4, sl(gl, dl, "fcTL"), dl += 4, ll(gl, dl, Nl++), dl += 4, ll(gl, dl, zl.rect.width), dl += 4, ll(gl, dl, zl.rect.height), dl += 4, ll(gl, dl, zl.rect.x), dl += 4, ll(gl, dl, zl.rect.y), dl += 4, al(gl, dl, rl[_l]), dl += 2, al(gl, dl, 1e3), dl += 2, gl[dl] = zl.dispose, dl++, gl[dl] = zl.blend, dl++, ll(gl, dl, cl(gl, dl - 30, 30)), dl += 4);
      const Zl = zl.cimg;
      ll(gl, dl, (ml = Zl.length) + (_l == 0 ? 0 : 4)), dl += 4;
      const kl = dl;
      sl(gl, dl, _l == 0 ? "IDAT" : "fdAT"), dl += 4, _l != 0 && (ll(gl, dl, Nl++), dl += 4), gl.set(Zl, dl), dl += ml, ll(gl, dl, cl(gl, kl, dl - kl)), dl += 4;
    }
    return ll(gl, dl, 0), dl += 4, sl(gl, dl, "IEND"), dl += 4, ll(gl, dl, cl(gl, dl - 4, 4)), dl += 4, gl.buffer;
  }
  function ba(tl, Qa, nl) {
    for (let rl = 0; rl < tl.frames.length; rl++) {
      const il = tl.frames[rl];
      il.rect.width;
      const cl = il.rect.height, ll = new Uint8Array(cl * il.bpl + cl);
      il.cimg = wa(il.img, cl, il.bpp, il.bpl, ll, Qa, nl);
    }
  }
  function _a(tl, Qa, nl, rl, il) {
    const cl = il[0], ll = il[1], al = il[2], sl = il[3], dl = il[4], El = il[5];
    let fl = 6, Ml = 8, Sl = 255;
    for (var ml = 0; ml < tl.length; ml++) {
      const Rl = new Uint8Array(tl[ml]);
      for (var Dl = Rl.length, _l = 0; _l < Dl; _l += 4) Sl &= Rl[_l + 3];
    }
    const gl = Sl != 255, Fl = function(Ul, hl, Cl, Il, Ll, tc) {
      const nc = [];
      for (var uc = 0; uc < Ul.length; uc++) {
        const Ec = new Uint8Array(Ul[uc]), Hl = new Uint32Array(Ec.buffer);
        var _c;
        let fc = 0, lc = 0, Gl = hl, ql = Cl, Vl = Il ? 1 : 0;
        if (uc != 0) {
          const Pl = tc || Il || uc == 1 || nc[uc - 2].dispose != 0 ? 1 : 2;
          let Ol = 0, cc = 1e9;
          for (let bl = 0; bl < Pl; bl++) {
            var mc = new Uint8Array(Ul[uc - 1 - bl]);
            const pl = new Uint32Array(Ul[uc - 1 - bl]);
            let Jl = hl, Al = Cl, Bl = -1, Kl = -1;
            for (let xc = 0; xc < Cl; xc++) for (let vc = 0; vc < hl; vc++)
              Hl[hc = xc * hl + vc] != pl[hc] && (vc < Jl && (Jl = vc), vc > Bl && (Bl = vc), xc < Al && (Al = xc), xc > Kl && (Kl = xc));
            Bl == -1 && (Jl = Al = Bl = Kl = 0), Ll && ((1 & Jl) == 1 && Jl--, (1 & Al) == 1 && Al--);
            const oc = (Bl - Jl + 1) * (Kl - Al + 1);
            oc < cc && (cc = oc, Ol = bl, fc = Jl, lc = Al, Gl = Bl - Jl + 1, ql = Kl - Al + 1);
          }
          mc = new Uint8Array(Ul[uc - 1 - Ol]), Ol == 1 && (nc[uc - 1].dispose = 2), _c = new Uint8Array(Gl * ql * 4), Xn(mc, hl, Cl, _c, Gl, ql, -fc, -lc, 0), Vl = Xn(Ec, hl, Cl, _c, Gl, ql, -fc, -lc, 3) ? 1 : 0, Vl == 1 ? xa(Ec, hl, Cl, _c, { x: fc, y: lc, width: Gl, height: ql }) : Xn(Ec, hl, Cl, _c, Gl, ql, -fc, -lc, 0);
        } else _c = Ec.slice(0);
        nc.push({ rect: { x: fc, y: lc, width: Gl, height: ql }, img: _c, blend: Vl, dispose: 0 });
      }
      if (Il) for (uc = 0; uc < nc.length; uc++) {
        if ((Lc = nc[uc]).blend == 1) continue;
        const Ec = Lc.rect, Hl = nc[uc - 1].rect, fc = Math.min(Ec.x, Hl.x), lc = Math.min(Ec.y, Hl.y), Gl = { x: fc, y: lc, width: Math.max(Ec.x + Ec.width, Hl.x + Hl.width) - fc, height: Math.max(Ec.y + Ec.height, Hl.y + Hl.height) - lc };
        nc[uc - 1].dispose = 1, uc - 1 != 0 && ya(Ul, hl, Cl, nc, uc - 1, Gl, Ll), ya(Ul, hl, Cl, nc, uc, Gl, Ll);
      }
      let Sc = 0;
      if (Ul.length != 1) for (var hc = 0; hc < nc.length; hc++) {
        var Lc;
        Sc += (Lc = nc[hc]).rect.width * Lc.rect.height;
      }
      return nc;
    }(tl, Qa, nl, cl, ll, al), Nl = {}, zl = [], Zl = [];
    if (rl != 0) {
      const Rl = [];
      for (_l = 0; _l < Fl.length; _l++) Rl.push(Fl[_l].img.buffer);
      const Ul = function(Ll) {
        let tc = 0;
        for (var nc = 0; nc < Ll.length; nc++) tc += Ll[nc].byteLength;
        const uc = new Uint8Array(tc);
        let _c = 0;
        for (nc = 0; nc < Ll.length; nc++) {
          const mc = new Uint8Array(Ll[nc]), Sc = mc.length;
          for (let hc = 0; hc < Sc; hc += 4) {
            let Lc = mc[hc], Ec = mc[hc + 1], Hl = mc[hc + 2];
            const fc = mc[hc + 3];
            fc == 0 && (Lc = Ec = Hl = 0), uc[_c + hc] = Lc, uc[_c + hc + 1] = Ec, uc[_c + hc + 2] = Hl, uc[_c + hc + 3] = fc;
          }
          _c += Sc;
        }
        return uc.buffer;
      }(Rl), hl = Sa(Ul, rl);
      for (_l = 0; _l < hl.plte.length; _l++) zl.push(hl.plte[_l].est.rgba);
      let Cl = 0;
      for (_l = 0; _l < Fl.length; _l++) {
        const Il = (ul = Fl[_l]).img.length;
        var kl = new Uint8Array(hl.inds.buffer, Cl >> 2, Il >> 2);
        Zl.push(kl);
        const Ll = new Uint8Array(hl.abuf, Cl, Il);
        El && ma(ul.img, ul.rect.width, ul.rect.height, zl, Ll, kl), ul.img.set(Ll), Cl += Il;
      }
    } else for (ml = 0; ml < Fl.length; ml++) {
      var ul = Fl[ml];
      const Rl = new Uint32Array(ul.img.buffer);
      var vl = ul.rect.width;
      for (Dl = Rl.length, kl = new Uint8Array(Dl), Zl.push(kl), _l = 0; _l < Dl; _l++) {
        const Ul = Rl[_l];
        if (_l != 0 && Ul == Rl[_l - 1]) kl[_l] = kl[_l - 1];
        else if (_l > vl && Ul == Rl[_l - vl]) kl[_l] = kl[_l - vl];
        else {
          let hl = Nl[Ul];
          if (hl == null && (Nl[Ul] = hl = zl.length, zl.push(Ul), zl.length >= 300)) break;
          kl[_l] = hl;
        }
      }
    }
    const Tl = zl.length;
    for (Tl <= 256 && dl == 0 && (Ml = Tl <= 2 ? 1 : Tl <= 4 ? 2 : Tl <= 16 ? 4 : 8, Ml = Math.max(Ml, sl)), ml = 0; ml < Fl.length; ml++) {
      (ul = Fl[ml]).rect.x, ul.rect.y, vl = ul.rect.width;
      const Rl = ul.rect.height;
      let Ul = ul.img;
      new Uint32Array(Ul.buffer);
      let hl = 4 * vl, Cl = 4;
      if (Tl <= 256 && dl == 0) {
        hl = Math.ceil(Ml * vl / 8);
        var wl = new Uint8Array(hl * Rl);
        const Il = Zl[ml];
        for (let Ll = 0; Ll < Rl; Ll++) {
          _l = Ll * hl;
          const tc = Ll * vl;
          if (Ml == 8) for (var yl = 0; yl < vl; yl++) wl[_l + yl] = Il[tc + yl];
          else if (Ml == 4) for (yl = 0; yl < vl; yl++) wl[_l + (yl >> 1)] |= Il[tc + yl] << 4 - 4 * (1 & yl);
          else if (Ml == 2) for (yl = 0; yl < vl; yl++) wl[_l + (yl >> 2)] |= Il[tc + yl] << 6 - 2 * (3 & yl);
          else if (Ml == 1) for (yl = 0; yl < vl; yl++) wl[_l + (yl >> 3)] |= Il[tc + yl] << 7 - 1 * (7 & yl);
        }
        Ul = wl, fl = 3, Cl = 1;
      } else if (gl == 0 && Fl.length == 1) {
        wl = new Uint8Array(vl * Rl * 3);
        const Il = vl * Rl;
        for (_l = 0; _l < Il; _l++) {
          const Ll = 3 * _l, tc = 4 * _l;
          wl[Ll] = Ul[tc], wl[Ll + 1] = Ul[tc + 1], wl[Ll + 2] = Ul[tc + 2];
        }
        Ul = wl, fl = 2, Cl = 3, hl = 3 * vl;
      }
      ul.img = Ul, ul.bpl = hl, ul.bpp = Cl;
    }
    return { ctype: fl, depth: Ml, plte: zl, frames: Fl };
  }
  function ya(tl, Qa, nl, rl, il, cl, ll) {
    const al = Uint8Array, sl = Uint32Array, dl = new al(tl[il - 1]), El = new sl(tl[il - 1]), fl = il + 1 < tl.length ? new al(tl[il + 1]) : null, Ml = new al(tl[il]), Sl = new sl(Ml.buffer);
    let ml = Qa, Dl = nl, _l = -1, gl = -1;
    for (let Nl = 0; Nl < cl.height; Nl++) for (let zl = 0; zl < cl.width; zl++) {
      const Zl = cl.x + zl, kl = cl.y + Nl, ul = kl * Qa + Zl, vl = Sl[ul];
      vl == 0 || rl[il - 1].dispose == 0 && El[ul] == vl && (fl == null || fl[4 * ul + 3] != 0) || (Zl < ml && (ml = Zl), Zl > _l && (_l = Zl), kl < Dl && (Dl = kl), kl > gl && (gl = kl));
    }
    _l == -1 && (ml = Dl = _l = gl = 0), ll && ((1 & ml) == 1 && ml--, (1 & Dl) == 1 && Dl--), cl = { x: ml, y: Dl, width: _l - ml + 1, height: gl - Dl + 1 };
    const Fl = rl[il];
    Fl.rect = cl, Fl.blend = 1, Fl.img = new Uint8Array(cl.width * cl.height * 4), rl[il - 1].dispose == 0 ? (Xn(dl, Qa, nl, Fl.img, cl.width, cl.height, -cl.x, -cl.y, 0), xa(Ml, Qa, nl, Fl.img, cl)) : Xn(Ml, Qa, nl, Fl.img, cl.width, cl.height, -cl.x, -cl.y, 0);
  }
  function xa(tl, Qa, nl, rl, il) {
    Xn(tl, Qa, nl, rl, il.width, il.height, -il.x, -il.y, 2);
  }
  function wa(tl, Qa, nl, rl, il, cl, ll) {
    const al = [];
    let sl, dl = [0, 1, 2, 3, 4];
    cl != -1 ? dl = [cl] : (Qa * rl > 5e5 || nl == 1) && (dl = [0]), ll && (sl = { level: 0 });
    const El = UZIP$1;
    for (var fl = 0; fl < dl.length; fl++) {
      for (let ml = 0; ml < Qa; ml++) Ta(il, tl, ml, rl, nl, dl[fl]);
      al.push(El.deflate(il, sl));
    }
    let Ml, Sl = 1e9;
    for (fl = 0; fl < al.length; fl++) al[fl].length < Sl && (Ml = fl, Sl = al[fl].length);
    return al[Ml];
  }
  function Ta(tl, Qa, nl, rl, il, cl) {
    const ll = nl * rl;
    let al = ll + nl;
    if (tl[al] = cl, al++, cl == 0) if (rl < 500) for (var sl = 0; sl < rl; sl++) tl[al + sl] = Qa[ll + sl];
    else tl.set(new Uint8Array(Qa.buffer, ll, rl), al);
    else if (cl == 1) {
      for (sl = 0; sl < il; sl++) tl[al + sl] = Qa[ll + sl];
      for (sl = il; sl < rl; sl++) tl[al + sl] = Qa[ll + sl] - Qa[ll + sl - il] + 256 & 255;
    } else if (nl == 0) {
      for (sl = 0; sl < il; sl++) tl[al + sl] = Qa[ll + sl];
      if (cl == 2) for (sl = il; sl < rl; sl++) tl[al + sl] = Qa[ll + sl];
      if (cl == 3) for (sl = il; sl < rl; sl++) tl[al + sl] = Qa[ll + sl] - (Qa[ll + sl - il] >> 1) + 256 & 255;
      if (cl == 4) for (sl = il; sl < rl; sl++) tl[al + sl] = Qa[ll + sl] - Un(Qa[ll + sl - il], 0, 0) + 256 & 255;
    } else {
      if (cl == 2) for (sl = 0; sl < rl; sl++) tl[al + sl] = Qa[ll + sl] + 256 - Qa[ll + sl - rl] & 255;
      if (cl == 3) {
        for (sl = 0; sl < il; sl++) tl[al + sl] = Qa[ll + sl] + 256 - (Qa[ll + sl - rl] >> 1) & 255;
        for (sl = il; sl < rl; sl++) tl[al + sl] = Qa[ll + sl] + 256 - (Qa[ll + sl - rl] + Qa[ll + sl - il] >> 1) & 255;
      }
      if (cl == 4) {
        for (sl = 0; sl < il; sl++) tl[al + sl] = Qa[ll + sl] + 256 - Un(0, Qa[ll + sl - rl], 0) & 255;
        for (sl = il; sl < rl; sl++) tl[al + sl] = Qa[ll + sl] + 256 - Un(Qa[ll + sl - il], Qa[ll + sl - rl], Qa[ll + sl - il - rl]) & 255;
      }
    }
  }
  function Sa(tl, Qa) {
    const nl = new Uint8Array(tl), rl = nl.slice(0), il = new Uint32Array(rl.buffer), cl = Ma(rl, Qa), ll = cl[0], al = cl[1], sl = nl.length, dl = new Uint8Array(sl >> 2);
    let El;
    if (nl.length < 2e7) for (var fl = 0; fl < sl; fl += 4)
      El = ka(ll, Ml = nl[fl] * (1 / 255), Sl = nl[fl + 1] * (1 / 255), ml = nl[fl + 2] * (1 / 255), Dl = nl[fl + 3] * (1 / 255)), dl[fl >> 2] = El.ind, il[fl >> 2] = El.est.rgba;
    else for (fl = 0; fl < sl; fl += 4) {
      var Ml = nl[fl] * 0.00392156862745098, Sl = nl[fl + 1] * (1 / 255), ml = nl[fl + 2] * (1 / 255), Dl = nl[fl + 3] * (1 / 255);
      for (El = ll; El.left; ) El = Za(El.est, Ml, Sl, ml, Dl) <= 0 ? El.left : El.right;
      dl[fl >> 2] = El.ind, il[fl >> 2] = El.est.rgba;
    }
    return { abuf: rl.buffer, inds: dl, plte: al };
  }
  function Ma(tl, Qa, nl) {
    nl == null && (nl = 1e-4);
    const rl = new Uint32Array(tl.buffer), il = { i0: 0, i1: tl.length, bst: null, est: null, tdst: 0, left: null, right: null };
    il.bst = Ja(tl, il.i0, il.i1), il.est = el(il.bst);
    const cl = [il];
    for (; cl.length < Qa; ) {
      let al = 0, sl = 0;
      for (var ll = 0; ll < cl.length; ll++) cl[ll].est.L > al && (al = cl[ll].est.L, sl = ll);
      if (al < nl) break;
      const dl = cl[sl], El = Na(tl, rl, dl.i0, dl.i1, dl.est.e, dl.est.eMq255);
      if (dl.i0 >= El || dl.i1 <= El) {
        dl.est.L = 0;
        continue;
      }
      const fl = { i0: dl.i0, i1: El, bst: null, est: null, tdst: 0, left: null, right: null };
      fl.bst = Ja(tl, fl.i0, fl.i1), fl.est = el(fl.bst);
      const Ml = { i0: El, i1: dl.i1, bst: null, est: null, tdst: 0, left: null, right: null };
      for (Ml.bst = { R: [], m: [], N: dl.bst.N - fl.bst.N }, ll = 0; ll < 16; ll++) Ml.bst.R[ll] = dl.bst.R[ll] - fl.bst.R[ll];
      for (ll = 0; ll < 4; ll++) Ml.bst.m[ll] = dl.bst.m[ll] - fl.bst.m[ll];
      Ml.est = el(Ml.bst), dl.left = fl, dl.right = Ml, cl[sl] = fl, cl.push(Ml);
    }
    for (cl.sort((al, sl) => sl.bst.N - al.bst.N), ll = 0; ll < cl.length; ll++) cl[ll].ind = ll;
    return [il, cl];
  }
  function ka(tl, Qa, nl, rl, il) {
    if (tl.left == null) return tl.tdst = function(fl, Ml, Sl, ml, Dl) {
      const _l = Ml - fl[0], gl = Sl - fl[1], Fl = ml - fl[2], Nl = Dl - fl[3];
      return _l * _l + gl * gl + Fl * Fl + Nl * Nl;
    }(tl.est.q, Qa, nl, rl, il), tl;
    const cl = Za(tl.est, Qa, nl, rl, il);
    let ll = tl.left, al = tl.right;
    cl > 0 && (ll = tl.right, al = tl.left);
    const sl = ka(ll, Qa, nl, rl, il);
    if (sl.tdst <= cl * cl) return sl;
    const dl = ka(al, Qa, nl, rl, il);
    return dl.tdst < sl.tdst ? dl : sl;
  }
  function Za(tl, Qa, nl, rl, il) {
    const { e: cl } = tl;
    return cl[0] * Qa + cl[1] * nl + cl[2] * rl + cl[3] * il - tl.eMq;
  }
  function Na(tl, Qa, nl, rl, il, cl) {
    for (rl -= 4; nl < rl; ) {
      for (; Ka(tl, nl, il) <= cl; ) nl += 4;
      for (; Ka(tl, rl, il) > cl; ) rl -= 4;
      if (nl >= rl) break;
      const ll = Qa[nl >> 2];
      Qa[nl >> 2] = Qa[rl >> 2], Qa[rl >> 2] = ll, nl += 4, rl -= 4;
    }
    for (; Ka(tl, nl, il) > cl; ) nl -= 4;
    return nl + 4;
  }
  function Ka(tl, Qa, nl) {
    return tl[Qa] * nl[0] + tl[Qa + 1] * nl[1] + tl[Qa + 2] * nl[2] + tl[Qa + 3] * nl[3];
  }
  function Ja(tl, Qa, nl) {
    const rl = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], il = [0, 0, 0, 0], cl = nl - Qa >> 2;
    for (let ll = Qa; ll < nl; ll += 4) {
      const al = tl[ll] * 0.00392156862745098, sl = tl[ll + 1] * (1 / 255), dl = tl[ll + 2] * (1 / 255), El = tl[ll + 3] * (1 / 255);
      il[0] += al, il[1] += sl, il[2] += dl, il[3] += El, rl[0] += al * al, rl[1] += al * sl, rl[2] += al * dl, rl[3] += al * El, rl[5] += sl * sl, rl[6] += sl * dl, rl[7] += sl * El, rl[10] += dl * dl, rl[11] += dl * El, rl[15] += El * El;
    }
    return rl[4] = rl[1], rl[8] = rl[2], rl[9] = rl[6], rl[12] = rl[3], rl[13] = rl[7], rl[14] = rl[11], { R: rl, m: il, N: cl };
  }
  function el(tl) {
    const { R: Qa } = tl, { m: nl } = tl, { N: rl } = tl, il = nl[0], cl = nl[1], ll = nl[2], al = nl[3], sl = rl == 0 ? 0 : 1 / rl, dl = [Qa[0] - il * il * sl, Qa[1] - il * cl * sl, Qa[2] - il * ll * sl, Qa[3] - il * al * sl, Qa[4] - cl * il * sl, Qa[5] - cl * cl * sl, Qa[6] - cl * ll * sl, Qa[7] - cl * al * sl, Qa[8] - ll * il * sl, Qa[9] - ll * cl * sl, Qa[10] - ll * ll * sl, Qa[11] - ll * al * sl, Qa[12] - al * il * sl, Qa[13] - al * cl * sl, Qa[14] - al * ll * sl, Qa[15] - al * al * sl], El = dl, fl = qa;
    let Ml = [Math.random(), Math.random(), Math.random(), Math.random()], Sl = 0, ml = 0;
    if (rl != 0) for (let _l = 0; _l < 16 && (Ml = fl.multVec(El, Ml), ml = Math.sqrt(fl.dot(Ml, Ml)), Ml = fl.sml(1 / ml, Ml), !(_l != 0 && Math.abs(ml - Sl) < 1e-9)); _l++) Sl = ml;
    const Dl = [il * sl, cl * sl, ll * sl, al * sl];
    return { Cov: dl, q: Dl, e: Ml, L: Sl, eMq255: fl.dot(fl.sml(255, Dl), Ml), eMq: fl.dot(Ml, Dl), rgba: (Math.round(255 * Dl[3]) << 24 | Math.round(255 * Dl[2]) << 16 | Math.round(255 * Dl[1]) << 8 | Math.round(255 * Dl[0]) << 0) >>> 0 };
  }
  var qa = { multVec: (tl, Qa) => [tl[0] * Qa[0] + tl[1] * Qa[1] + tl[2] * Qa[2] + tl[3] * Qa[3], tl[4] * Qa[0] + tl[5] * Qa[1] + tl[6] * Qa[2] + tl[7] * Qa[3], tl[8] * Qa[0] + tl[9] * Qa[1] + tl[10] * Qa[2] + tl[11] * Qa[3], tl[12] * Qa[0] + tl[13] * Qa[1] + tl[14] * Qa[2] + tl[15] * Qa[3]], dot: (tl, Qa) => tl[0] * Qa[0] + tl[1] * Qa[1] + tl[2] * Qa[2] + tl[3] * Qa[3], sml: (tl, Qa) => [tl * Qa[0], tl * Qa[1], tl * Qa[2], tl * Qa[3]] };
  UPNG$1.encode = function(Qa, nl, rl, il, cl, ll, al) {
    il == null && (il = 0), al == null && (al = !1);
    const sl = _a(Qa, nl, rl, il, [!1, !1, !1, 0, al, !1]);
    return ba(sl, -1), va(sl, nl, rl, cl, ll);
  }, UPNG$1.encodeLL = function(Qa, nl, rl, il, cl, ll, al, sl) {
    const dl = { ctype: 0 + (il == 1 ? 0 : 2) + (cl == 0 ? 0 : 4), depth: ll, frames: [] }, El = (il + cl) * ll, fl = El * nl;
    for (let Ml = 0; Ml < Qa.length; Ml++) dl.frames.push({ rect: { x: 0, y: 0, width: nl, height: rl }, img: new Uint8Array(Qa[Ml]), blend: 0, dispose: 1, bpp: Math.ceil(El / 8), bpl: Math.ceil(fl / 8) });
    return ba(dl, 0, !0), va(dl, nl, rl, al, sl);
  }, UPNG$1.encode.compress = _a, UPNG$1.encode.dither = ma, UPNG$1.quantize = Sa, UPNG$1.quantize.getKDtree = Ma, UPNG$1.quantize.getNearest = ka;
})();
const r$2 = { toArrayBuffer(Xn, zn) {
  const Un = Xn.width, Kn = Xn.height, qn = Un << 2, Jo = Xn.getContext("2d").getImageData(0, 0, Un, Kn), pa = new Uint32Array(Jo.data.buffer), ma = (32 * Un + 31) / 32 << 2, va = ma * Kn, ba = 122 + va, _a = new ArrayBuffer(ba), ya = new DataView(_a), xa = 1 << 20;
  let wa, Ta, Sa, Ma, ka = xa, Za = 0, Na = 0, Ka = 0;
  function Ja(tl) {
    ya.setUint16(Na, tl, !0), Na += 2;
  }
  function el(tl) {
    ya.setUint32(Na, tl, !0), Na += 4;
  }
  function qa(tl) {
    Na += tl;
  }
  Ja(19778), el(ba), qa(4), el(122), el(108), el(Un), el(-Kn >>> 0), Ja(1), Ja(32), el(3), el(va), el(2835), el(2835), qa(8), el(16711680), el(65280), el(255), el(4278190080), el(1466527264), function tl() {
    for (; Za < Kn && ka > 0; ) {
      for (Ma = 122 + Za * ma, wa = 0; wa < qn; ) ka--, Ta = pa[Ka++], Sa = Ta >>> 24, ya.setUint32(Ma + wa, Ta << 8 | Sa), wa += 4;
      Za++;
    }
    Ka < pa.length ? (ka = xa, setTimeout(tl, r$2._dly)) : zn(_a);
  }();
}, toBlob(Xn, zn) {
  this.toArrayBuffer(Xn, (Un) => {
    zn(new Blob([Un], { type: "image/bmp" }));
  });
}, _dly: 9 };
var i$4 = { CHROME: "CHROME", FIREFOX: "FIREFOX", DESKTOP_SAFARI: "DESKTOP_SAFARI", IE: "IE", IOS: "IOS", ETC: "ETC" }, o$2 = { [i$4.CHROME]: 16384, [i$4.FIREFOX]: 11180, [i$4.DESKTOP_SAFARI]: 16384, [i$4.IE]: 8192, [i$4.IOS]: 4096, [i$4.ETC]: 8192 };
const a$2 = typeof window < "u", s$2 = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, f$1 = a$2 && window.cordova && window.cordova.require && window.cordova.require("cordova/modulemapper"), CustomFile = (a$2 || s$2) && (f$1 && f$1.getOriginalSymbol(window, "File") || typeof File < "u" && File), CustomFileReader = (a$2 || s$2) && (f$1 && f$1.getOriginalSymbol(window, "FileReader") || typeof FileReader < "u" && FileReader);
function getFilefromDataUrl(Xn, zn, Un = Date.now()) {
  return new Promise((Kn) => {
    const qn = Xn.split(","), Jo = qn[0].match(/:(.*?);/)[1], pa = globalThis.atob(qn[1]);
    let ma = pa.length;
    const va = new Uint8Array(ma);
    for (; ma--; ) va[ma] = pa.charCodeAt(ma);
    const ba = new Blob([va], { type: Jo });
    ba.name = zn, ba.lastModified = Un, Kn(ba);
  });
}
function getDataUrlFromFile(Xn) {
  return new Promise((zn, Un) => {
    const Kn = new CustomFileReader();
    Kn.onload = () => zn(Kn.result), Kn.onerror = (qn) => Un(qn), Kn.readAsDataURL(Xn);
  });
}
function loadImage(Xn) {
  return new Promise((zn, Un) => {
    const Kn = new Image();
    Kn.onload = () => zn(Kn), Kn.onerror = (qn) => Un(qn), Kn.src = Xn;
  });
}
function getBrowserName() {
  if (getBrowserName.cachedResult !== void 0) return getBrowserName.cachedResult;
  let Xn = i$4.ETC;
  const { userAgent: zn } = navigator;
  return /Chrom(e|ium)/i.test(zn) ? Xn = i$4.CHROME : /iP(ad|od|hone)/i.test(zn) && /WebKit/i.test(zn) ? Xn = i$4.IOS : /Safari/i.test(zn) ? Xn = i$4.DESKTOP_SAFARI : /Firefox/i.test(zn) ? Xn = i$4.FIREFOX : (/MSIE/i.test(zn) || document.documentMode) && (Xn = i$4.IE), getBrowserName.cachedResult = Xn, getBrowserName.cachedResult;
}
function approximateBelowMaximumCanvasSizeOfBrowser(Xn, zn) {
  const Un = getBrowserName(), Kn = o$2[Un];
  let qn = Xn, Jo = zn, pa = qn * Jo;
  const ma = qn > Jo ? Jo / qn : qn / Jo;
  for (; pa > Kn * Kn; ) {
    const va = (Kn + qn) / 2, ba = (Kn + Jo) / 2;
    va < ba ? (Jo = ba, qn = ba * ma) : (Jo = va * ma, qn = va), pa = qn * Jo;
  }
  return { width: qn, height: Jo };
}
function getNewCanvasAndCtx(Xn, zn) {
  let Un, Kn;
  try {
    if (Un = new OffscreenCanvas(Xn, zn), Kn = Un.getContext("2d"), Kn === null) throw new Error("getContext of OffscreenCanvas returns null");
  } catch {
    Un = document.createElement("canvas"), Kn = Un.getContext("2d");
  }
  return Un.width = Xn, Un.height = zn, [Un, Kn];
}
function drawImageInCanvas(Xn, zn) {
  const { width: Un, height: Kn } = approximateBelowMaximumCanvasSizeOfBrowser(Xn.width, Xn.height), [qn, Jo] = getNewCanvasAndCtx(Un, Kn);
  return zn && /jpe?g/.test(zn) && (Jo.fillStyle = "white", Jo.fillRect(0, 0, qn.width, qn.height)), Jo.drawImage(Xn, 0, 0, qn.width, qn.height), qn;
}
function isIOS() {
  return isIOS.cachedResult !== void 0 || (isIOS.cachedResult = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || navigator.userAgent.includes("Mac") && typeof document < "u" && "ontouchend" in document), isIOS.cachedResult;
}
function drawFileInCanvas(Xn, zn = {}) {
  return new Promise(function(Un, Kn) {
    let qn, Jo;
    var pa = function() {
      try {
        return Jo = drawImageInCanvas(qn, zn.fileType || Xn.type), Un([qn, Jo]);
      } catch (va) {
        return Kn(va);
      }
    }, ma = function(va) {
      try {
        var ba = function(_a) {
          try {
            throw _a;
          } catch (ya) {
            return Kn(ya);
          }
        };
        try {
          let _a;
          return getDataUrlFromFile(Xn).then(function(ya) {
            try {
              return _a = ya, loadImage(_a).then(function(xa) {
                try {
                  return qn = xa, function() {
                    try {
                      return pa();
                    } catch (wa) {
                      return Kn(wa);
                    }
                  }();
                } catch (wa) {
                  return ba(wa);
                }
              }, ba);
            } catch (xa) {
              return ba(xa);
            }
          }, ba);
        } catch (_a) {
          ba(_a);
        }
      } catch (_a) {
        return Kn(_a);
      }
    };
    try {
      if (isIOS() || [i$4.DESKTOP_SAFARI, i$4.MOBILE_SAFARI].includes(getBrowserName())) throw new Error("Skip createImageBitmap on IOS and Safari");
      return createImageBitmap(Xn).then(function(va) {
        try {
          return qn = va, pa();
        } catch {
          return ma();
        }
      }, ma);
    } catch {
      ma();
    }
  });
}
function canvasToFile(Xn, zn, Un, Kn, qn = 1) {
  return new Promise(function(Jo, pa) {
    let ma;
    if (zn === "image/png") {
      let ba, _a, ya;
      return ba = Xn.getContext("2d"), { data: _a } = ba.getImageData(0, 0, Xn.width, Xn.height), ya = UPNG$1.encode([_a.buffer], Xn.width, Xn.height, 4096 * qn), ma = new Blob([ya], { type: zn }), ma.name = Un, ma.lastModified = Kn, va.call(this);
    }
    {
      let ba = function() {
        return va.call(this);
      };
      if (zn === "image/bmp") return new Promise((_a) => r$2.toBlob(Xn, _a)).then((function(_a) {
        try {
          return ma = _a, ma.name = Un, ma.lastModified = Kn, ba.call(this);
        } catch (ya) {
          return pa(ya);
        }
      }).bind(this), pa);
      {
        let _a = function() {
          return ba.call(this);
        };
        if (typeof OffscreenCanvas == "function" && Xn instanceof OffscreenCanvas) return Xn.convertToBlob({ type: zn, quality: qn }).then((function(ya) {
          try {
            return ma = ya, ma.name = Un, ma.lastModified = Kn, _a.call(this);
          } catch (xa) {
            return pa(xa);
          }
        }).bind(this), pa);
        {
          let ya;
          return ya = Xn.toDataURL(zn, qn), getFilefromDataUrl(ya, Un, Kn).then((function(xa) {
            try {
              return ma = xa, _a.call(this);
            } catch (wa) {
              return pa(wa);
            }
          }).bind(this), pa);
        }
      }
    }
    function va() {
      return Jo(ma);
    }
  });
}
function cleanupCanvasMemory(Xn) {
  Xn.width = 0, Xn.height = 0;
}
function isAutoOrientationInBrowser() {
  return new Promise(function(Xn, zn) {
    let Un, Kn, qn, Jo;
    return isAutoOrientationInBrowser.cachedResult !== void 0 ? Xn(isAutoOrientationInBrowser.cachedResult) : getFilefromDataUrl("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", "test.jpg", Date.now()).then(function(pa) {
      try {
        return Un = pa, drawFileInCanvas(Un).then(function(ma) {
          try {
            return Kn = ma[1], canvasToFile(Kn, Un.type, Un.name, Un.lastModified).then(function(va) {
              try {
                return qn = va, cleanupCanvasMemory(Kn), drawFileInCanvas(qn).then(function(ba) {
                  try {
                    return Jo = ba[0], isAutoOrientationInBrowser.cachedResult = Jo.width === 1 && Jo.height === 2, Xn(isAutoOrientationInBrowser.cachedResult);
                  } catch (_a) {
                    return zn(_a);
                  }
                }, zn);
              } catch (ba) {
                return zn(ba);
              }
            }, zn);
          } catch (va) {
            return zn(va);
          }
        }, zn);
      } catch (ma) {
        return zn(ma);
      }
    }, zn);
  });
}
function getExifOrientation$1(Xn) {
  return new Promise((zn, Un) => {
    const Kn = new CustomFileReader();
    Kn.onload = (qn) => {
      const Jo = new DataView(qn.target.result);
      if (Jo.getUint16(0, !1) != 65496) return zn(-2);
      const pa = Jo.byteLength;
      let ma = 2;
      for (; ma < pa; ) {
        if (Jo.getUint16(ma + 2, !1) <= 8) return zn(-1);
        const va = Jo.getUint16(ma, !1);
        if (ma += 2, va == 65505) {
          if (Jo.getUint32(ma += 2, !1) != 1165519206) return zn(-1);
          const ba = Jo.getUint16(ma += 6, !1) == 18761;
          ma += Jo.getUint32(ma + 4, ba);
          const _a = Jo.getUint16(ma, ba);
          ma += 2;
          for (let ya = 0; ya < _a; ya++) if (Jo.getUint16(ma + 12 * ya, ba) == 274) return zn(Jo.getUint16(ma + 12 * ya + 8, ba));
        } else {
          if ((65280 & va) != 65280) break;
          ma += Jo.getUint16(ma, !1);
        }
      }
      return zn(-1);
    }, Kn.onerror = (qn) => Un(qn), Kn.readAsArrayBuffer(Xn);
  });
}
function handleMaxWidthOrHeight(Xn, zn) {
  const { width: Un } = Xn, { height: Kn } = Xn, { maxWidthOrHeight: qn } = zn;
  let Jo, pa = Xn;
  return isFinite(qn) && (Un > qn || Kn > qn) && ([pa, Jo] = getNewCanvasAndCtx(Un, Kn), Un > Kn ? (pa.width = qn, pa.height = Kn / Un * qn) : (pa.width = Un / Kn * qn, pa.height = qn), Jo.drawImage(Xn, 0, 0, pa.width, pa.height), cleanupCanvasMemory(Xn)), pa;
}
function followExifOrientation(Xn, zn) {
  const { width: Un } = Xn, { height: Kn } = Xn, [qn, Jo] = getNewCanvasAndCtx(Un, Kn);
  switch (zn > 4 && zn < 9 ? (qn.width = Kn, qn.height = Un) : (qn.width = Un, qn.height = Kn), zn) {
    case 2:
      Jo.transform(-1, 0, 0, 1, Un, 0);
      break;
    case 3:
      Jo.transform(-1, 0, 0, -1, Un, Kn);
      break;
    case 4:
      Jo.transform(1, 0, 0, -1, 0, Kn);
      break;
    case 5:
      Jo.transform(0, 1, 1, 0, 0, 0);
      break;
    case 6:
      Jo.transform(0, 1, -1, 0, Kn, 0);
      break;
    case 7:
      Jo.transform(0, -1, -1, 0, Kn, Un);
      break;
    case 8:
      Jo.transform(0, -1, 1, 0, 0, Un);
  }
  return Jo.drawImage(Xn, 0, 0, Un, Kn), cleanupCanvasMemory(Xn), qn;
}
function compress(Xn, zn, Un = 0) {
  return new Promise(function(Kn, qn) {
    let Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el, qa, tl;
    function Qa(rl = 5) {
      if (zn.signal && zn.signal.aborted) throw zn.signal.reason;
      Jo += rl, zn.onProgress(Math.min(Jo, 100));
    }
    function nl(rl) {
      if (zn.signal && zn.signal.aborted) throw zn.signal.reason;
      Jo = Math.min(Math.max(rl, Jo), 100), zn.onProgress(Jo);
    }
    return Jo = Un, pa = zn.maxIteration || 10, ma = 1024 * zn.maxSizeMB * 1024, Qa(), drawFileInCanvas(Xn, zn).then((function(rl) {
      try {
        return [, va] = rl, Qa(), ba = handleMaxWidthOrHeight(va, zn), Qa(), new Promise(function(il, cl) {
          var ll;
          if (!(ll = zn.exifOrientation)) return getExifOrientation$1(Xn).then((function(sl) {
            try {
              return ll = sl, al.call(this);
            } catch (dl) {
              return cl(dl);
            }
          }).bind(this), cl);
          function al() {
            return il(ll);
          }
          return al.call(this);
        }).then((function(il) {
          try {
            return _a = il, Qa(), isAutoOrientationInBrowser().then((function(cl) {
              try {
                return ya = cl ? ba : followExifOrientation(ba, _a), Qa(), xa = zn.initialQuality || 1, wa = zn.fileType || Xn.type, canvasToFile(ya, wa, Xn.name, Xn.lastModified, xa).then((function(ll) {
                  try {
                    {
                      let sl = function() {
                        if (pa-- && (Na > ma || Na > ka)) {
                          let El, fl;
                          return El = tl ? 0.95 * qa.width : qa.width, fl = tl ? 0.95 * qa.height : qa.height, [Ja, el] = getNewCanvasAndCtx(El, fl), el.drawImage(qa, 0, 0, El, fl), xa *= wa === "image/png" ? 0.85 : 0.95, canvasToFile(Ja, wa, Xn.name, Xn.lastModified, xa).then(function(Ml) {
                            try {
                              return Ka = Ml, cleanupCanvasMemory(qa), qa = Ja, Na = Ka.size, nl(Math.min(99, Math.floor((Za - Na) / (Za - ma) * 100))), sl;
                            } catch (Sl) {
                              return qn(Sl);
                            }
                          }, qn);
                        }
                        return [1];
                      }, dl = function() {
                        return cleanupCanvasMemory(qa), cleanupCanvasMemory(Ja), cleanupCanvasMemory(ba), cleanupCanvasMemory(ya), cleanupCanvasMemory(va), nl(100), Kn(Ka);
                      };
                      if (Ta = ll, Qa(), Sa = Ta.size > ma, Ma = Ta.size > Xn.size, !Sa && !Ma) return nl(100), Kn(Ta);
                      var al;
                      return ka = Xn.size, Za = Ta.size, Na = Za, qa = ya, tl = !zn.alwaysKeepResolution && Sa, (al = (function(El) {
                        for (; El; ) {
                          if (El.then) return void El.then(al, qn);
                          try {
                            if (El.pop) {
                              if (El.length) return El.pop() ? dl.call(this) : El;
                              El = sl;
                            } else El = El.call(this);
                          } catch (fl) {
                            return qn(fl);
                          }
                        }
                      }).bind(this))(sl);
                    }
                  } catch (sl) {
                    return qn(sl);
                  }
                }).bind(this), qn);
              } catch (ll) {
                return qn(ll);
              }
            }).bind(this), qn);
          } catch (cl) {
            return qn(cl);
          }
        }).bind(this), qn);
      } catch (il) {
        return qn(il);
      }
    }).bind(this), qn);
  });
}
const l$2 = `
let scriptImported = false
self.addEventListener('message', async (e) => {
  const { file, id, imageCompressionLibUrl, options } = e.data
  options.onProgress = (progress) => self.postMessage({ progress, id })
  try {
    if (!scriptImported) {
      // console.log('[worker] importScripts', imageCompressionLibUrl)
      self.importScripts(imageCompressionLibUrl)
      scriptImported = true
    }
    // console.log('[worker] self', self)
    const compressedFile = await imageCompression(file, options)
    self.postMessage({ file: compressedFile, id })
  } catch (e) {
    // console.error('[worker] error', e)
    self.postMessage({ error: e.message + '\\n' + e.stack, id })
  }
})
`;
let c$3;
function compressOnWebWorker(Xn, zn) {
  return new Promise((Un, Kn) => {
    c$3 || (c$3 = function(pa) {
      const ma = [];
      return ma.push(pa), URL.createObjectURL(new Blob(ma));
    }(l$2));
    const qn = new Worker(c$3);
    qn.addEventListener("message", function(pa) {
      if (zn.signal && zn.signal.aborted) qn.terminate();
      else if (pa.data.progress === void 0) {
        if (pa.data.error) return Kn(new Error(pa.data.error)), void qn.terminate();
        Un(pa.data.file), qn.terminate();
      } else zn.onProgress(pa.data.progress);
    }), qn.addEventListener("error", Kn), zn.signal && zn.signal.addEventListener("abort", () => {
      Kn(zn.signal.reason), qn.terminate();
    }), qn.postMessage({ file: Xn, imageCompressionLibUrl: zn.libURL, options: { ...zn, onProgress: void 0, signal: void 0 } });
  });
}
function imageCompression(Xn, zn) {
  return new Promise(function(Un, Kn) {
    let qn, Jo, pa, ma, va, ba;
    if (qn = { ...zn }, pa = 0, { onProgress: ma } = qn, qn.maxSizeMB = qn.maxSizeMB || Number.POSITIVE_INFINITY, va = typeof qn.useWebWorker != "boolean" || qn.useWebWorker, delete qn.useWebWorker, qn.onProgress = (wa) => {
      pa = wa, typeof ma == "function" && ma(pa);
    }, !(Xn instanceof Blob || Xn instanceof CustomFile)) return Kn(new Error("The file given is not an instance of Blob or File"));
    if (!/^image/.test(Xn.type)) return Kn(new Error("The file given is not an image"));
    if (ba = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, !va || typeof Worker != "function" || ba) return compress(Xn, qn).then((function(wa) {
      try {
        return Jo = wa, xa.call(this);
      } catch (Ta) {
        return Kn(Ta);
      }
    }).bind(this), Kn);
    var _a = (function() {
      try {
        return xa.call(this);
      } catch (wa) {
        return Kn(wa);
      }
    }).bind(this), ya = function(wa) {
      try {
        return compress(Xn, qn).then(function(Ta) {
          try {
            return Jo = Ta, _a();
          } catch (Sa) {
            return Kn(Sa);
          }
        }, Kn);
      } catch (Ta) {
        return Kn(Ta);
      }
    };
    try {
      return qn.libURL = qn.libURL || "https://cdn.jsdelivr.net/npm/browser-image-compression@2.0.2/dist/browser-image-compression.js", compressOnWebWorker(Xn, qn).then(function(wa) {
        try {
          return Jo = wa, _a();
        } catch {
          return ya();
        }
      }, ya);
    } catch {
      ya();
    }
    function xa() {
      try {
        Jo.name = Xn.name, Jo.lastModified = Xn.lastModified;
      } catch {
      }
      try {
        qn.preserveExif && Xn.type === "image/jpeg" && (!qn.fileType || qn.fileType && qn.fileType === Xn.type) && (Jo = copyExifWithoutOrientation(Xn, Jo));
      } catch {
      }
      return Un(Jo);
    }
  });
}
imageCompression.getDataUrlFromFile = getDataUrlFromFile, imageCompression.getFilefromDataUrl = getFilefromDataUrl, imageCompression.loadImage = loadImage, imageCompression.drawImageInCanvas = drawImageInCanvas, imageCompression.drawFileInCanvas = drawFileInCanvas, imageCompression.canvasToFile = canvasToFile, imageCompression.getExifOrientation = getExifOrientation$1, imageCompression.handleMaxWidthOrHeight = handleMaxWidthOrHeight, imageCompression.followExifOrientation = followExifOrientation, imageCompression.cleanupCanvasMemory = cleanupCanvasMemory, imageCompression.isAutoOrientationInBrowser = isAutoOrientationInBrowser, imageCompression.approximateBelowMaximumCanvasSizeOfBrowser = approximateBelowMaximumCanvasSizeOfBrowser, imageCompression.copyExifWithoutOrientation = copyExifWithoutOrientation, imageCompression.getBrowserName = getBrowserName, imageCompression.version = "2.0.2";
const MAX_SIZE_COMPRESS_IMAGE_MB = 4, MAX_WIDTH_OR_HEIGHT_COMPRESS_IMAGE = Number.MAX_VALUE, compressImage = async (Xn) => {
  const zn = {
    maxSizeMB: MAX_SIZE_COMPRESS_IMAGE_MB,
    maxWidthOrHeight: MAX_WIDTH_OR_HEIGHT_COMPRESS_IMAGE,
    useWebWorker: !0
  };
  try {
    const Un = Xn.split(",")[1], Kn = decodeBase64(Un), qn = Xn.split(",")[0].split(":")[1].split(";")[0], Jo = new Blob([Kn], { type: qn }), pa = new File([Jo], "image.png", { type: Jo.type, lastModified: Date.now() }), ma = await imageCompression(pa, zn);
    return new Promise((va, ba) => {
      const _a = new FileReader();
      _a.onloadend = () => va(_a.result), _a.onerror = ba, _a.readAsDataURL(ma);
    });
  } catch (Un) {
    throw console.error("Ошибка при сжатии изображения:", Un), Un;
  }
};
function decodeBase64(Xn) {
  const zn = window.atob(Xn), Un = new Uint8Array(zn.length);
  for (let Kn = 0; Kn < zn.length; Kn++)
    Un[Kn] = zn.charCodeAt(Kn);
  return Un;
}
let File$1 = class {
  constructor() {
    /**
     * Возвращает структуру XLSX файла в callback.
     * @param callback
     */
    Ca(this, "getXLSXData", (zn) => {
      const Un = document.createElement("input");
      Un.type = "file", Un.accept = ".xlsx, .ods", Un.click(), Un.onchange = () => {
        if (!Un.files) return;
        const Kn = Un.files[0], qn = new FileReader();
        qn.onloadend = () => {
          if (!qn.result) return;
          const Jo = readSync(qn.result, {
            type: "buffer",
            cellStyles: !0
            // raw: true,
            // bookDeps: true,
            // dense: true,
            // bookVBA: true,
            // bookProps: true,
            // cellFormula: true,
            // cellHTML: true,
            // cellNF: true,
            // cellText: true,
            // cellDates: true,
            // sheetStubs: true,
            // bookFiles: true,
            // bookVBA: true,
            // WTF: true,
          });
          zn(Jo);
        }, qn.readAsArrayBuffer(Kn);
      };
    });
    /**
     * Вовзращает в callback имя, изображение в формате base64 и его размер в байтах.
     * @param callback
     */
    Ca(this, "getPictureBase64FromFile", (zn) => {
      const Un = document.createElement("input");
      let Kn = Un.value.split(/(\\|\/)/g).pop();
      Kn = Kn === void 0 ? Utils.generate.uuid4() : Kn, Un.type = "file", Un.accept = "image/*", Un.onchange = () => {
        if (!Un.files)
          throw new Error("files not found");
        const qn = Un.files[0];
        if (qn === void 0)
          throw new Error("file is undefined");
        const Jo = new FileReader();
        Jo.onloadend = async () => {
          if (!Jo.result)
            throw new Error("error result");
          const pa = await compressImage(Jo.result.toString());
          zn(Kn, pa, qn.size);
        }, Jo.readAsDataURL(qn);
      }, Un.click();
    });
  }
};
const byteToHex = [];
for (let Xn = 0; Xn < 256; ++Xn)
  byteToHex.push((Xn + 256).toString(16).slice(1));
function unsafeStringify(Xn, zn = 0) {
  return (byteToHex[Xn[zn + 0]] + byteToHex[Xn[zn + 1]] + byteToHex[Xn[zn + 2]] + byteToHex[Xn[zn + 3]] + "-" + byteToHex[Xn[zn + 4]] + byteToHex[Xn[zn + 5]] + "-" + byteToHex[Xn[zn + 6]] + byteToHex[Xn[zn + 7]] + "-" + byteToHex[Xn[zn + 8]] + byteToHex[Xn[zn + 9]] + "-" + byteToHex[Xn[zn + 10]] + byteToHex[Xn[zn + 11]] + byteToHex[Xn[zn + 12]] + byteToHex[Xn[zn + 13]] + byteToHex[Xn[zn + 14]] + byteToHex[Xn[zn + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function v4(Xn, zn, Un) {
  var qn;
  if (native.randomUUID && !Xn)
    return native.randomUUID();
  Xn = Xn || {};
  const Kn = Xn.random ?? ((qn = Xn.rng) == null ? void 0 : qn.call(Xn)) ?? rng();
  if (Kn.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return Kn[6] = Kn[6] & 15 | 64, Kn[8] = Kn[8] & 63 | 128, unsafeStringify(Kn);
}
class Generate {
  constructor() {
    Ca(this, "uuid4", () => v4());
  }
}
class Geometry {
  constructor() {
    /**
     * Возвращает пересекаемую площадь двух прямоугольников.
     */
    Ca(this, "intersectArea", (zn, Un) => {
      const Kn = Math.max(0, Math.min(zn.x + zn.width, Un.x + Un.width) - Math.max(zn.x, Un.x)), qn = Math.max(0, Math.min(zn.y + zn.height, Un.y + Un.height) - Math.max(zn.y, Un.y));
      return Kn * qn;
    });
  }
  isCrossedAreas(zn, Un) {
    const Kn = zn.x + zn.width, qn = zn.y + zn.height, Jo = Un.x + Un.width, pa = Un.y + Un.height;
    return !(zn.x > Jo || // area1 находится правее area2
    Kn < Un.x || // area1 находится левее area2
    zn.y > pa || // area1 находится ниже area2
    qn < Un.y);
  }
}
class NumberUtils {
  constructor() {
    /**
     * Проверяет четное ли число, если нечетное то возвращает ближайшее наибольшее четное число.
     * @param num
     */
    Ca(this, "toEvenOver", (zn) => zn % 2 === 0 ? zn : zn + 1);
    /**
     * Проверяет четное ли число, если нечетное то возвращает ближайшее наименьшее четное число.
     * @param num
     */
    Ca(this, "toEvenLess", (zn) => zn % 2 === 0 ? zn : zn - 1);
  }
  /**
      * Проверяет, является ли число четным.
      * @param num - Число для проверки.
      * @returns true, если число четное, иначе false.
      */
  isEven(zn) {
    return zn % 2 === 0;
  }
  /**
      * Проверяет, является ли число нечетным.
      * @param num - Число для проверки.
      * @returns true, если число нечетное, иначе false.
      */
  isOdd(zn) {
    return zn % 2 !== 0;
  }
  /**
      * Преобразует четное число в нечетное, увеличив его на 1.
      * Если число нечетное, возвращает его без изменений.
      * @param num - Число для преобразования.
      * @returns Преобразованное число.
      */
  makeOdd(zn) {
    return this.isEven(zn) ? zn + 1 : zn;
  }
  /**
      * Преобразует нечетное число в четное, увеличив его на 1.
      * Если число четное, возвращает его без изменений.
      * @param num - Число для преобразования.
      * @returns Преобразованное число.
      */
  makeEven(zn) {
    return this.isOdd(zn) ? zn + 1 : zn;
  }
  /**
      * Проверяет, является ли число положительным.
      * @param num - Число для проверки.
      * @returns true, если число положительное, иначе false.
      */
  isPositive(zn) {
    return zn > 0;
  }
  /**
      * Проверяет, является ли число отрицательным.
      * @param num - Число для проверки.
      * @returns true, если число отрицательное, иначе false.
      */
  isNegative(zn) {
    return zn < 0;
  }
  /**
      * Преобразует число в его абсолютное значение.
      * @param num - Число для преобразования.
      * @returns Абсолютное значение числа.
      */
  toAbsolute(zn) {
    return Math.abs(zn);
  }
  /**
      * Проверяет, является ли число целым.
      * @param num - Число для проверки.
      * @returns true, если число целое, иначе false.
      */
  isInteger(zn) {
    return this.isInteger(zn);
  }
  /**
   * Округляет заданное число вверх до ближайшей степени двойки, начиная с минимальной степени.
   * @param num Число для округления.
   */
  roundUp(zn) {
    return zn <= 1 ? 1 : 2 ** Math.ceil(Math.log2(zn));
  }
}
class ObjectUtils {
  constructor() {
    /**
     * Сравнивает объекты по значению, возвращает true в случае совпадения, в ином false.
     */
    Ca(this, "deepEqual", (zn, Un) => {
      if (zn === Un)
        return !0;
      if (zn === null || Un === null || typeof zn > "u" || typeof Un > "u")
        return !1;
      if (Array.isArray(zn) && Array.isArray(Un)) {
        if (zn.length !== Un.length)
          return !1;
        for (const Kn in zn)
          if (!this.deepEqual(zn[Kn], Un[Kn]))
            return !1;
        return !0;
      }
      if (typeof zn == "object" && typeof Un == "object" && !Array.isArray(zn) && !Array.isArray(Un)) {
        if (Object.keys(zn).length !== Object.keys(Un).length)
          return !1;
        for (const Kn in zn)
          if (typeof zn[Kn] != "object" && typeof Un[Kn] != "object" && zn[Kn] !== Un[Kn] || !this.deepEqual(zn[Kn], Un[Kn]))
            return !1;
        return !0;
      }
      return !1;
    });
    /**
     * Возвращает результат совпадений значений полей объектов. Если все значения одного поля одинаковы,
     * то в значении этого поля с этим именем будет `true`.
     * @param objects - объекты для сравнения.
     */
    Ca(this, "checkFieldsEquality", (...zn) => {
      let Un = 0, Kn = null;
      for (; Un < zn.length; ) {
        if (zn[Un] !== null) {
          Kn = zn[Un];
          break;
        }
        Un++;
      }
      if (!Kn)
        throw new Error("Array is empty");
      const qn = {};
      for (const Jo in Kn)
        if (Object.prototype.hasOwnProperty.call(Kn, Jo)) {
          const pa = Kn[Jo];
          let ma = !0;
          for (let va = 1; va < zn.length; va++)
            if (!this.deepEqual(zn[va][Jo], pa)) {
              ma = !1;
              break;
            }
          qn[Jo] = ma ? pa : null;
        }
      return qn;
    });
    /**
     * Возвращает отсортированный массив объектов на основании переданных функций.
     * @param objects Сортируемые объекты.
     * @param lambdaFunctions Функция сортировки.
     */
    Ca(this, "sortByLambdaFunctions", (zn, ...Un) => zn.sort((Kn, qn) => {
      for (let Jo = 0; Jo < Un.length; Jo++) {
        const pa = Un[Jo], ma = pa(Kn), va = pa(qn);
        if (ma && !va)
          return -1;
        if (!ma && va)
          return 1;
      }
      return 0;
    }));
  }
}
class PlatformUtils {
  isMacOs() {
    return this.getOS() === "macos";
  }
  isWindows() {
    return this.getOS() === "windows";
  }
  isLinux() {
    return this.getOS() === "linux";
  }
  isAndroid() {
    return this.getOS() === "android";
  }
  isIos() {
    return this.getOS() === "ios";
  }
  getOS() {
    const zn = navigator.userAgent.toLowerCase(), Un = navigator.platform.toLowerCase(), Kn = navigator.userAgentData;
    let qn = "unknown";
    return Kn != null && Kn.platform ? qn = Kn.platform.toLowerCase() : zn.includes("win") || Un.includes("win") ? qn = "windows" : zn.includes("mac") || Un.includes("mac") ? qn = "macos" : zn.includes("linux") || Un.includes("linux") ? qn = "linux" : zn.includes("android") ? qn = "android" : (zn.includes("iphone") || zn.includes("ipad") || Un.includes("iphone") || Un.includes("ipad")) && (qn = "ios"), qn;
  }
}
class Text {
  constructor() {
    Ca(this, "PT_TO_PX_MULTIPLIER", 1.3);
    /**
     * Преобразует размер шрифта из формата 'pt' в пиксели.
     *
     * @param {FontSize} fontSize - Размер шрифта в пунктах, например '72pt'.
     * @returns {number} Размер шрифта в пикселях.
     * @throws {Error} Если формат fontSize не соответствует 'pt' или не удаётся разобрать число.
     */
    Ca(this, "parseFontSize", (zn) => {
      if (!zn.endsWith("pt"))
        throw new Error(`Invalid font size format: ${zn}. Expected format like '72pt'.`);
      const Un = Number.parseInt(zn.slice(0, -2), 10);
      if (Number.isNaN(Un))
        throw new Error(`Unable to parse font size: ${zn}`);
      return Math.round(Un * this.PT_TO_PX_MULTIPLIER);
    });
    Ca(this, "getDefaultTextToken", (zn) => ({
      type: TokenType.TEXT,
      value: zn,
      fontSize: DefaultFontSize,
      fontFamily: FontFamily.DEFAULT,
      color: "#000000",
      format: TokenFormat.None
    }));
    Ca(this, "splitByNewline", (zn, Un) => {
      const Kn = [...zn].reduce((pa, ma, va) => (ma === `
` && pa.push(va), pa), []), qn = [];
      let Jo = 0;
      return Kn.forEach((pa) => {
        qn.push(Un.slice(Jo, pa)), Jo = pa;
      }), qn.push(Un.slice(Jo)), qn;
    });
    Ca(this, "getStylesMap", (zn, Un) => this.splitByNewline(zn, Un).reduce((qn, Jo, pa) => (qn[pa] = Jo, qn), {}));
    /**
     * Преобразует значение `TextAlign` в соответствующее строковое представление для FabricJS.
     *
     * @param {TextAlign} textAlign - Выравнивание текста.
     * @returns {string} Строковое представление выравнивания ('left', 'center', 'right', 'justify').
     */
    Ca(this, "parseTextAlign", (zn) => {
      switch (zn) {
        case TextAlign.LEFT:
          return "left";
        case TextAlign.CENTER:
          return "center";
        case TextAlign.RIGHT:
          return "right";
        case TextAlign.JUSTIFY:
          return "justify";
        default:
          return console.warn(`TextAlign value "${zn}" не поддерживается. Используется значение по умолчанию "left".`), "left";
      }
    });
  }
}
const Utils = {
  text: new Text(),
  file: new File$1(),
  color: new Color(),
  backend: new Backend(),
  generate: new Generate(),
  geometry: new Geometry(),
  component: new Component(),
  platform: new PlatformUtils(),
  numberUtils: new NumberUtils(),
  objectUtils: new ObjectUtils()
};
class ComponentList extends DoublyLinkedList {
}
class GraphicComponent {
  constructor() {
    Ca(this, "isUniter", !1);
    Ca(this, "postDisableEditMode");
    Ca(this, "postEnableEditModeListeners");
    Ca(this, "graphicsState");
    // Отображает, включена ли механика режима редактирования.
    Ca(this, "isEnableEditModeMechanic");
    Ca(this, "isFocus");
    Ca(this, "isEditMode");
    Ca(this, "componentList");
    Ca(this, "graphicList");
    Ca(this, "id");
    Ca(this, "offset");
    Ca(this, "parentComponent");
    Ca(this, "addPostEnableEditModeListener", (zn) => {
      this.postEnableEditModeListeners.push(zn);
    });
    Ca(this, "getStructure", () => {
      const zn = [];
      this.getGraphics().forEach((qn) => {
        const Jo = qn.getStructure();
        zn.push(Jo);
      });
      const Kn = this.componentList.getElements().map((qn) => qn.getStructure());
      return {
        id: this.id,
        type: this.type,
        offset: this.offset,
        texture: this.getTexture(),
        graphics: zn,
        components: Kn
      };
    });
    Ca(this, "getUniqueStructure", () => {
      const zn = [];
      this.getGraphics().forEach((qn) => {
        const Jo = qn.getUniqueStructure();
        zn.push(Jo);
      });
      const Kn = this.componentList.getElements().map((qn) => qn.getUniqueStructure());
      return {
        type: this.type,
        offset: this.offset,
        id: Utils.generate.uuid4(),
        graphics: zn,
        components: Kn,
        texture: this.getUniqueTexture()
      };
    });
    Ca(this, "setParentComponent", (zn) => {
      this.parentComponent = zn;
    });
    Ca(this, "setStructure", async (zn) => {
      const Un = this.getStructure(), Kn = zn(Un);
      this.id = Kn.id, this.offset = Kn.offset, await this.setTexture(() => Kn.texture);
    });
    Ca(this, "disableHover", () => {
      this.getGraphics().forEach((Un) => {
        Un.disableHover();
      });
    });
    Ca(this, "enableHover", () => {
      this.getGraphics().forEach((Un) => {
        Un.enableHover();
      });
    });
    Ca(this, "enableFocus", () => {
      this.isFocus = !0, this.getGraphics().forEach((zn) => zn.enableFocus());
    });
    Ca(this, "disableFocus", () => {
      this.isFocus = !1, this.getGraphics().forEach((zn) => zn.disableFocus());
    });
    Ca(this, "isEnableFocus", () => this.isFocus);
    /**
     * Отключает реагирование на включение режима редактирования.
     */
    Ca(this, "disableEditModeMechanic", () => {
      this.isEnableEditModeMechanic = !1;
    });
    /**
     * Включает реагирование на включение режима редактирования.
     */
    Ca(this, "enableEditModeMechanic", () => {
      this.isEnableEditModeMechanic = !0;
    });
    Ca(this, "enableEditMode", () => {
      this.isEditMode || !this.isEnableEditModeMechanic || (this.isEditMode = !0, this.getGraphics().forEach((zn) => {
        zn.enableEditMode();
      }), this.runPostEnableEditModeListeners());
    });
    Ca(this, "disableEditMode", () => {
      this.isEditMode && (this.isEditMode = !1, this.getGraphics().forEach((zn) => {
        zn.disableEditMode();
      }), this.runPostDisableEditModeListeners());
    });
    Ca(this, "appendComponent", (zn) => {
      zn.setParentComponent(this), this.componentList.append(zn);
    });
    Ca(this, "removeComponent", (zn) => {
      this.componentList.delete(zn);
    });
    Ca(this, "appendGraphic", (zn) => {
      zn.setParentComponent(this), this.graphicList.append(zn);
    });
    Ca(this, "appendGraphicAfter", (zn, Un) => {
      this.graphicList.after(Un, zn);
    });
    Ca(this, "appendGraphicBefore", (zn, Un) => {
      this.graphicList.before(Un, zn);
    });
    Ca(this, "removeGraphic", (zn) => {
      if (!this.graphicList.isOwnGraphic(zn))
        throw new EditorError("is not own graphic");
      zn.removeFrame(), this.graphicList.delete(zn);
    });
    Ca(this, "hasEditableComponent", () => {
      const zn = this.getComponents();
      return zn === null ? !1 : zn.filter((Un) => Un.isEnableEditMode()).length !== 0;
    });
    Ca(this, "getSpatialAreas", () => this.getGraphics().flatMap((Un) => Un.getSpatialAreas()));
    Ca(this, "addPostDisableEditModeListener", (zn) => {
      this.postDisableEditMode.push(zn);
    });
    /**
     * Сохраняет внутри компонента текущее состояние для последующего извлечения или восстановления.
     */
    Ca(this, "fixGraphicState", () => {
      const zn = this.getGraphics();
      if (zn.length === 0)
        throw new EditorError("graphics nor found");
      this.graphicsState.push(...zn.map((Un) => Un.getStructure()));
    });
    Ca(this, "clearGraphicState", () => {
      this.graphicsState.length = 0;
    });
    Ca(this, "getFirstGraphic", () => this.getGraphicFromNumber(0));
    Ca(this, "getGraphicFromNumber", (zn) => {
      const Kn = this.getGraphics()[zn];
      return Kn === void 0 ? null : Kn;
    });
    Ca(this, "getLastGraphic", () => {
      const zn = this.getGraphics(), Un = zn[zn.length - 1];
      return Un === void 0 ? null : Un;
    });
    Ca(this, "getNumberFromGraphic", (zn) => {
      const Kn = this.getGraphics().indexOf(zn);
      return Kn === -1 ? null : Kn;
    });
    Ca(this, "recursiveSyncGraphicsOffset", () => {
      this.syncGraphicsOffset();
      const zn = this.getComponents();
      zn == null || zn.forEach((Un) => Un.recursiveSyncGraphicsOffset());
    });
    Ca(this, "getComponents", () => {
      const zn = this.componentList.getElements();
      return zn.length === 0 ? null : zn;
    });
    Ca(this, "getID", () => this.id);
    Ca(this, "getOffset", () => this.offset);
    Ca(this, "isEnableEditMode", () => this.isEditMode);
    /**
     * Включает ли в себя передаваемый компонент.
     * @param component - передаваемый компонент для проверки
     */
    Ca(this, "isIncludeComponent", (zn) => {
      const Un = this.getComponents();
      if (Un === null) return !1;
      for (let Kn = 0; Kn < Un.length; Kn++)
        if (zn === Un[Kn]) return !0;
      return !1;
    });
    /**
     * Проверяет, является ли графика последней.
     * @param graphic - графика компонента, для которой происходит проверка.
     * */
    Ca(this, "isLastGraphic", (zn) => {
      const Un = this.getGraphics();
      return Un.indexOf(zn) === Un.length - 1;
    });
    Ca(this, "syncGraphicsHeight", () => {
      this.getGraphics().forEach((Un) => {
        const { object: Kn } = Un.getFrameObject();
        Un.setFrameConfiguration((qn) => ({
          ...qn,
          height: Kn.height
        }));
      });
    });
    Ca(this, "getNearestGraphic", (zn) => {
      let Un = null, Kn = Number.MAX_SAFE_INTEGER;
      const qn = this.getGraphics();
      if (qn.forEach((pa) => {
        const { x: ma, y: va, width: ba, height: _a } = pa.getFrameConfiguration(), ya = ma + ba / 2, xa = va + _a / 2, wa = Math.sqrt((zn.x - ya) ** 2 + (zn.y - xa) ** 2);
        wa < Kn && (Kn = wa, Un = pa.getOffset());
      }), Un === null)
        throw new EditorError("page not found", {
          graphicCount: { value: qn.length },
          graphicIndex: { value: Un }
        });
      const Jo = qn[Un];
      if (Jo === void 0)
        throw new EditorError("page not found", { graphicCount: { value: qn.length }, graphicIndex: Un });
      return Jo;
    });
    Ca(this, "syncGraphicsOffset", () => this.graphicList.syncGraphicsOffset());
    Ca(this, "getGraphics", () => this.graphicList.getElements());
    Ca(this, "getParentComponent", () => this.parentComponent);
    Ca(this, "getGraphicState", () => [...this.graphicsState]);
    Ca(this, "getComponentAll", () => this.getRecursiveComponents(this));
    Ca(this, "getRecursiveComponents", (zn) => {
      const Un = [], Kn = zn.getComponents();
      return Kn === null || (Un.push(...Kn), Kn.forEach((qn) => {
        Un.push(...this.getRecursiveComponents(qn));
      })), Un;
    });
    Ca(this, "runPostDisableEditModeListeners", () => {
      this.postDisableEditMode.forEach((zn) => zn());
    });
    Ca(this, "runPostEnableEditModeListeners", () => {
      this.postEnableEditModeListeners.forEach((zn) => zn());
    });
    this.offset = null, this.isFocus = !1, this.isEditMode = !1, this.graphicsState = [], this.parentComponent = null, this.id = "not initializing", this.postDisableEditMode = [], this.isEnableEditModeMechanic = !0, this.postEnableEditModeListeners = [], this.componentList = new ComponentList(), this.graphicList = new GraphicList();
  }
}
class BookComponent extends GraphicComponent {
  constructor() {
    super();
    Ca(this, "BOOK_MODE_DEFAULT", BookMode.VERTICAL);
    /** Тип компонента (Книга). */
    Ca(this, "type", EditorComponentType.BOOK);
    Ca(this, "currentBookMode");
    /**
     * Синхронизирует панели всех страниц.
     */
    Ca(this, "syncPagePanels", () => {
      const Un = this.getGraphics(), Kn = [];
      for (let qn = 0; qn < Un.length - 1; qn++)
        Un[qn].syncTopPageHeader(), Un[qn].hideBottomPageHeader(), Kn.push(...Un[qn].getSpatialAreas());
      Un[Un.length - 1].syncTopPageHeader(), Un[Un.length - 1].syncBottomPageHeader(), Un[Un.length - 1].showBottomPageHeader(), Kn.push(...Un[Un.length - 1].getSpatialAreas());
      for (let qn = 0; qn < Kn.length; qn++)
        Kn[qn].markDirty();
    });
    Ca(this, "setBookMode", (Un) => {
      this.currentBookMode !== Un && (this.currentBookMode = Un);
    });
    /**
     * Возвращает графические объекты, встроенные в указанную страницу.
     * @param pageNumber Номер страницы.
     * @returns {IGraphic[] | null} Список графических объектов или null, если их нет.
     */
    Ca(this, "getPageEmbeddedGraphics", (Un) => {
      const Kn = this.getComponentAll();
      if (Kn === null)
        return null;
      const Jo = Kn.flatMap((pa) => pa.getGraphics()).filter((pa) => pa.getRootGraphicNumber() === Un);
      return Jo.length === 0 ? null : Jo;
    });
    /**
     * Возвращает конфигурацию с позицией, относительно текущей страницы.
     * @param graphic - Графика, от которой будут производиться расчеты.
     */
    Ca(this, "getConfigurationFromPage", (Un) => {
      const Kn = Un.getFrameConfiguration();
      let { x: qn, y: Jo } = Kn;
      const { width: pa, height: ma, rotate: va, layer: ba } = Kn;
      let _a = Un.getParentGraphic();
      if (_a === null)
        return {
          x: qn,
          y: Jo,
          width: pa,
          height: ma,
          rotate: va,
          layer: ba
        };
      for (; _a !== null && _a.type !== GraphicType.PAGE; ) {
        const ya = _a.getFrameConfiguration();
        qn += ya.x, Jo += ya.y, _a = _a.getParentGraphic();
      }
      return {
        x: qn,
        y: Jo,
        width: pa,
        height: ma,
        rotate: va,
        layer: ba
      };
    });
    /**
     * Возвращает страницу, к которой относится указанный графический объект.
     * @param graphic Графический объект.
     * @throws {EditorError} Если страница не найдена.
     * @returns {PageGraphic} Страница.
     */
    Ca(this, "getPageFromGraphic", (Un) => {
      const Kn = Un.getRootGraphicNumber();
      if (Kn === null)
        throw new EditorError("page number not found");
      const qn = this.getGraphicFromNumber(Kn);
      if (qn === null)
        throw new EditorError("page not found from index");
      return qn;
    });
    /**
     * Возвращает позицию графики относительно страницы.
     * @param graphic Графика.
     * @throws {EditorError} Если страница не найдена.
     * @returns {IDescartesPosition} Позиция.
     */
    Ca(this, "getRelativePagePosition", (Un) => {
      const Kn = { x: 0, y: 0 };
      let qn = Un, Jo = qn.getFrameConfiguration();
      for (; qn.type !== GraphicType.PAGE; ) {
        if (Kn.x += Jo.x, Kn.y += Jo.y, qn = qn.getParentGraphic(), qn === null)
          throw new EditorError("page not found");
        Jo = qn.getFrameConfiguration();
      }
      return Kn;
    });
    /**
     * Возвращает позицию графики относительно заданной страницы.
     * @param graphic Графика.
     * @param pageGraphic Страница.
     * @returns {IDescartesPosition} Позиция.
     */
    Ca(this, "getRelativePositionFromPage", (Un, Kn) => {
      const qn = Un.getGlobalPosition(), Jo = Kn.getGlobalPosition();
      return {
        x: qn.x - Jo.x,
        y: qn.y - Jo.y
      };
    });
    /**
     * Сбрасывает все графические объекты и компоненты.
     */
    Ca(this, "reset", () => {
      this.getGraphics().forEach((Kn) => Kn.removeFrame()), this.graphicList.clear(), this.componentList.clear();
    });
    Ca(this, "getBookMode", () => this.currentBookMode);
    /**
     * Включает режим магнитного выравнивания справа.
     */
    Ca(this, "enableRightMagneticMode", () => {
    });
    /**
     * Выключает режим магнитного выравнивания справа.
     */
    Ca(this, "disableRightMagneticMode", () => {
    });
    /**
     * Возвращает текстуру компонента.
     * @returns {null} Текстура.
     */
    Ca(this, "getTexture", () => null);
    /**
     * Возвращает уникальную текстуру компонента.
     * @returns {null} Уникальная текстура.
     */
    Ca(this, "getUniqueTexture", () => null);
    /**
     * Устанавливает текстуру компонента.
     * @param fn Функция для установки текстуры.
     */
    Ca(this, "setTexture", async (Un) => {
    });
    this.offset = 0, this.currentBookMode = this.BOOK_MODE_DEFAULT;
  }
}
class FigureComponent extends GraphicComponent {
  constructor() {
    super();
    Ca(this, "type", EditorComponentType.FIGURE);
    Ca(this, "getTexture", () => null);
    Ca(this, "getUniqueTexture", () => null);
    Ca(this, "setTexture", async (Un) => {
    });
    this.disableEditModeMechanic();
  }
}
class UniterComponent extends GraphicComponent {
  constructor() {
    super();
    Ca(this, "isUniter", !0);
    /**
     * Синхронизирует размеры графики на основе положения дочерних компонентов.
     * Графика группы изменяется под расположение и размеры дочерней графики.
     */
    Ca(this, "syncSizeFrames", () => {
      const Un = this.getComponents();
      if (Un === null)
        return;
      const Kn = this.getGraphics(), qn = this.getOffsetGraphics(Un);
      this.syncUniterGraphics(qn, Kn);
    });
    Ca(this, "syncSingleComponentsEditMode", () => {
      const Un = this.getComponents();
      Un && Un.forEach((Kn) => {
        this.isEnableEditMode() || Kn.disableEditMode();
      });
    });
    /**
     * Абсолютный offset вложенной графики относительно групповой графики
     * @param components
     */
    Ca(this, "getOffsetGraphics", (Un) => {
      const Kn = /* @__PURE__ */ new Map(), qn = [];
      return Un.forEach((Jo) => {
        const pa = Jo.getGraphics();
        if (pa === null)
          throw new EditorError("graphics is null");
        qn.push(...pa);
      }), qn.forEach((Jo) => {
        const pa = Jo.getParentComponent();
        if (pa === null) return;
        const ma = pa.getGraphics(), va = pa.getOffset();
        if (va === null) return;
        let ba = 0;
        if (va === 0)
          ba = Jo.getOffset();
        else
          for (let ya = 0; ya < ma.length; ya++)
            if (ma[ya] === Jo) {
              ba = ya + va;
              break;
            }
        let _a = Kn.get(ba);
        _a === void 0 && (_a = [], Kn.set(ba, _a)), Kn.set(ba, [..._a, Jo]);
      }), Kn;
    });
    Ca(this, "syncUniterGraphics", (Un, Kn) => {
      Un.forEach((qn, Jo) => {
        const pa = Kn[Jo];
        if (pa === void 0)
          throw new EditorError("uniter graphic is undefined");
        this.syncUniterGraphic(pa, qn);
      });
    });
    Ca(this, "syncUniterGraphic", (Un, Kn) => {
      const [qn, Jo, pa, ma] = this.getExtremeGraphics(Kn);
      this.syncLeftExtreme(qn, Un, Kn), this.syncTopExtreme(Jo, Un, Kn), this.syncRightExtreme(pa, Un), this.syncBottomExtreme(ma, Un);
    });
    Ca(this, "getExtremeGraphics", (Un) => {
      let Kn = Un[0], qn = Un[0], Jo = Un[0], pa = Un[0], ma = Un[0].getFrameConfiguration().x, va = Un[0].getFrameConfiguration().y, ba = Un[0].getFrameConfiguration().x + Un[0].getFrameConfiguration().width, _a = Un[0].getFrameConfiguration().y + Un[0].getFrameConfiguration().height;
      return Un.forEach((ya) => {
        const {
          x: xa,
          y: wa,
          width: Ta,
          height: Sa
        } = ya.getFrameConfiguration();
        xa < ma && (Kn = ya, ma = xa), wa < va && (qn = ya, va = wa), xa + Ta > ba && (Jo = ya, ba = xa + Ta), wa + Sa > _a && (pa = ya, _a = wa + Sa);
      }), [Kn, qn, Jo, pa];
    });
    Ca(this, "syncLeftExtreme", (Un, Kn, qn) => {
      const Jo = Un.getFrameConfiguration();
      if (Jo.x === 0)
        return;
      const pa = Jo.x;
      Kn.setFrameConfiguration((ma) => ({
        ...ma,
        x: ma.x + pa,
        width: ma.width - pa
      })), Un.setFrameConfiguration((ma) => ({
        ...ma,
        x: 0
      })), qn.forEach((ma) => {
        ma !== Un && ma.setFrameConfiguration((va) => ({
          ...va,
          x: va.x - pa
        }));
      });
    });
    Ca(this, "syncTopExtreme", (Un, Kn, qn) => {
      const Jo = Un.getFrameConfiguration();
      if (Jo.y === 0)
        return;
      const pa = Jo.y;
      Kn.setFrameConfiguration((ma) => ({
        ...ma,
        y: ma.y + pa,
        height: ma.height - pa
      })), Un.setFrameConfiguration((ma) => ({
        ...ma,
        y: 0
      })), qn.forEach((ma) => {
        ma !== Un && ma.setFrameConfiguration((va) => ({
          ...va,
          y: va.y - pa
        }));
      });
    });
    Ca(this, "syncRightExtreme", (Un, Kn) => {
      const qn = Un.getFrameConfiguration(), Jo = Kn.getFrameConfiguration();
      if (qn.x + qn.width === Jo.width)
        return;
      const pa = qn.x + qn.width - Jo.width;
      Kn.setFrameConfiguration((ma) => ({
        ...ma,
        width: ma.width + pa
      }));
    });
    Ca(this, "syncBottomExtreme", (Un, Kn) => {
      const qn = Un.getFrameConfiguration(), Jo = Kn.getFrameConfiguration();
      if (qn.y + qn.height === Jo.height)
        return;
      const pa = qn.y + qn.height - Jo.height;
      Kn.setFrameConfiguration((ma) => ({
        ...ma,
        height: ma.height + pa
      }));
    });
  }
}
class GroupComponent extends UniterComponent {
  constructor() {
    super();
    Ca(this, "type", EditorComponentType.GROUP);
    Ca(this, "layerSequence");
    Ca(this, "getTexture", () => ({
      layerSequence: this.layerSequence
    }));
    Ca(this, "getUniqueTexture", () => this.getTexture());
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture(), qn = Un(Kn);
      qn !== null && (this.layerSequence = qn.layerSequence);
    });
    this.layerSequence = [];
  }
}
class LineComponent extends GraphicComponent {
  constructor() {
    super();
    Ca(this, "type", EditorComponentType.LINE);
    Ca(this, "getTexture", () => null);
    Ca(this, "getUniqueTexture", () => null);
    Ca(this, "setTexture", async (Un) => {
    });
    this.disableEditModeMechanic();
  }
}
class ModuleComponent extends UniterComponent {
  constructor() {
    super();
    Ca(this, "type", EditorComponentType.MODULE);
    Ca(this, "baseModuleID");
    Ca(this, "layerSequence");
    Ca(this, "getTexture", () => ({
      baseModule: this.baseModuleID,
      layerSequence: this.layerSequence
    }));
    Ca(this, "getUniqueTexture", () => this.getTexture());
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture(), qn = Un(Kn);
      qn !== null && (this.baseModuleID = qn.baseModule, this.layerSequence = qn.layerSequence);
    });
    this.baseModuleID = null, this.layerSequence = [];
  }
}
class PictureComponent extends GraphicComponent {
  constructor() {
    super();
    Ca(this, "type", EditorComponentType.PICTURE);
    Ca(this, "isAdaptPictureAfterSetup");
    /**
     * Отменяет все изменения в режиме редактирования и возвращает в состояния до различных
     * мутаций в режиме редактирования.
     */
    Ca(this, "cancelChanges", async () => {
      if (!this.isEnableEditMode())
        return;
      const Un = this.getStructure();
      Un.graphics = this.getGraphicState(), await this.setStructure((Kn) => Un), this.disableEditMode(), this.clearGraphicState();
    });
    /**
     * Сбрасывает положение изображения относительно фрейма, максимально заполняет и центрирует.
     */
    Ca(this, "resetPictureSize", async () => {
      const Un = this.getGraphics();
      await Promise.all(Un.map((Kn) => Kn.resetPictureSize()));
    });
    Ca(this, "enableAdaptPictureAfterSetup", () => {
      this.isAdaptPictureAfterSetup = !0;
    });
    Ca(this, "disableAdaptPictureAfterSetup", () => {
      this.isAdaptPictureAfterSetup = !1;
    });
    Ca(this, "hasAdaptPictureAfterSetup", () => this.isAdaptPictureAfterSetup);
    Ca(this, "setNewPicture", async (Un) => {
      const Kn = this.getGraphics();
      await Promise.all(
        Kn.map((qn) => qn.setNewPicture(Un))
      );
    });
    Ca(this, "setPicture", async (Un) => {
      const Kn = this.getGraphics();
      await Promise.all(
        Kn.map((qn) => qn.setPicture(Un))
      );
    });
    Ca(this, "enableLoadingMode", async () => {
      const Un = this.getGraphics();
      await Promise.all(
        Un.map((Kn) => Kn.enableLoadingMode())
      );
    });
    Ca(this, "getPictureArea", () => {
      const Kn = this.getGraphics()[0];
      if (Kn === void 0)
        throw new EditorError("picture graphic nor found");
      return Kn.getPictureArea();
    });
    Ca(this, "getTexture", () => null);
    Ca(this, "getUniqueTexture", () => null);
    Ca(this, "setTexture", async (Un) => {
    });
    this.isAdaptPictureAfterSetup = !0;
  }
}
class CellPositioner {
  constructor(zn) {
    Ca(this, "sync", () => {
      const Un = this.component.getCellContexts().flatMap((va) => va.getTableCells()), Kn = this.component.getStartRows(), { rowHeights: qn, columnWidths: Jo } = this.component.getTexture(), pa = [];
      for (let va = 0; va < Kn.length; va++) {
        const ba = Kn[va], _a = Kn[va + 1] ?? Un.length, ya = Un.filter((xa) => xa.row >= ba && xa.row < _a);
        pa.push(ya);
      }
      let ma = 0;
      for (let va = 0; va < pa.length; va++) {
        const ba = Kn[va] || 0;
        va > 0 && (ma = 0);
        for (let _a = 0; _a < pa[va].length; _a++) {
          const ya = pa[va][_a], xa = { x: 0, y: 0 }, wa = Jo.slice(ya.column, ya.column + ya.columnSpan).reduce((Sa, Ma) => Sa + Ma, 0), Ta = qn.slice(ya.row, ya.row + ya.rowSpan).reduce((Sa, Ma) => Sa + Ma, 0);
          xa.y = ma + qn.slice(ba, ya.row).reduce((Sa, Ma) => Sa + Ma, 0), xa.x = Jo.slice(0, ya.column).reduce((Sa, Ma) => Sa + Ma, 0), ya.setSize(wa, Ta), ya.setPosition(xa);
        }
      }
    });
    this.component = zn;
  }
}
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs$1(Xn) {
  return Xn && Xn.__esModule && Object.prototype.hasOwnProperty.call(Xn, "default") ? Xn.default : Xn;
}
var lodash$1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var lodash = lodash$1.exports, hasRequiredLodash;
function requireLodash() {
  return hasRequiredLodash || (hasRequiredLodash = 1, function(Xn, zn) {
    (function() {
      var Un, Kn = "4.17.21", qn = 200, Jo = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", pa = "Expected a function", ma = "Invalid `variable` option passed into `_.template`", va = "__lodash_hash_undefined__", ba = 500, _a = "__lodash_placeholder__", ya = 1, xa = 2, wa = 4, Ta = 1, Sa = 2, Ma = 1, ka = 2, Za = 4, Na = 8, Ka = 16, Ja = 32, el = 64, qa = 128, tl = 256, Qa = 512, nl = 30, rl = "...", il = 800, cl = 16, ll = 1, al = 2, sl = 3, dl = 1 / 0, El = 9007199254740991, fl = 17976931348623157e292, Ml = NaN, Sl = 4294967295, ml = Sl - 1, Dl = Sl >>> 1, _l = [
        ["ary", qa],
        ["bind", Ma],
        ["bindKey", ka],
        ["curry", Na],
        ["curryRight", Ka],
        ["flip", Qa],
        ["partial", Ja],
        ["partialRight", el],
        ["rearg", tl]
      ], gl = "[object Arguments]", Fl = "[object Array]", Nl = "[object AsyncFunction]", zl = "[object Boolean]", Zl = "[object Date]", kl = "[object DOMException]", ul = "[object Error]", vl = "[object Function]", Tl = "[object GeneratorFunction]", wl = "[object Map]", yl = "[object Number]", Rl = "[object Null]", Ul = "[object Object]", hl = "[object Promise]", Cl = "[object Proxy]", Il = "[object RegExp]", Ll = "[object Set]", tc = "[object String]", nc = "[object Symbol]", uc = "[object Undefined]", _c = "[object WeakMap]", mc = "[object WeakSet]", Sc = "[object ArrayBuffer]", hc = "[object DataView]", Lc = "[object Float32Array]", Ec = "[object Float64Array]", Hl = "[object Int8Array]", fc = "[object Int16Array]", lc = "[object Int32Array]", Gl = "[object Uint8Array]", ql = "[object Uint8ClampedArray]", Vl = "[object Uint16Array]", Pl = "[object Uint32Array]", Ol = /\b__p \+= '';/g, cc = /\b(__p \+=) '' \+/g, bl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, pl = /&(?:amp|lt|gt|quot|#39);/g, Jl = /[&<>"']/g, Al = RegExp(pl.source), Bl = RegExp(Jl.source), Kl = /<%-([\s\S]+?)%>/g, oc = /<%([\s\S]+?)%>/g, xc = /<%=([\s\S]+?)%>/g, vc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Pc = /^\w*$/, Hc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $c = /[\\^$.*+?()[\]{}|]/g, Nc = RegExp($c.source), Zc = /^\s+/, Yc = /\s/, mh = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Wl = /\{\n\/\* \[wrapped with (.+)\] \*/, ic = /,? & /, Xl = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ql = /[()=,{}\[\]\/\s]/, ec = /\\(\\)?/g, rc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, dc = /\w*$/, wc = /^[-+]0x[0-9a-f]+$/i, bc = /^0b[01]+$/i, Cc = /^\[object .+?Constructor\]$/, yc = /^0o[0-7]+$/i, Oc = /^(?:0|[1-9]\d*)$/, Mc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Bc = /($^)/, Rc = /['\n\r\u2028\u2029\\]/g, kc = "\\ud800-\\udfff", Xc = "\\u0300-\\u036f", Ah = "\\ufe20-\\ufe2f", Fh = "\\u20d0-\\u20ff", kh = Xc + Ah + Fh, Pu = "\\u2700-\\u27bf", Du = "a-z\\xdf-\\xf6\\xf8-\\xff", Gu = "\\xac\\xb1\\xd7\\xf7", _u = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", u0 = "\\u2000-\\u206f", du = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", A1 = "A-Z\\xc0-\\xd6\\xd8-\\xde", F1 = "\\ufe0e\\ufe0f", I1 = Gu + _u + u0 + du, gd = "['’]", Yp = "[" + kc + "]", P1 = "[" + I1 + "]", A0 = "[" + kh + "]", D1 = "\\d+", Qp = "[" + Pu + "]", L1 = "[" + Du + "]", O1 = "[^" + kc + I1 + D1 + Pu + Du + A1 + "]", md = "\\ud83c[\\udffb-\\udfff]", Jp = "(?:" + A0 + "|" + md + ")", R1 = "[^" + kc + "]", vd = "(?:\\ud83c[\\udde6-\\uddff]){2}", bd = "[\\ud800-\\udbff][\\udc00-\\udfff]", Yu = "[" + A1 + "]", M1 = "\\u200d", k1 = "(?:" + L1 + "|" + O1 + ")", eg = "(?:" + Yu + "|" + O1 + ")", B1 = "(?:" + gd + "(?:d|ll|m|re|s|t|ve))?", U1 = "(?:" + gd + "(?:D|LL|M|RE|S|T|VE))?", N1 = Jp + "?", j1 = "[" + F1 + "]?", tg = "(?:" + M1 + "(?:" + [R1, vd, bd].join("|") + ")" + j1 + N1 + ")*", rg = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ig = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", G1 = j1 + N1 + tg, ng = "(?:" + [Qp, vd, bd].join("|") + ")" + G1, sg = "(?:" + [R1 + A0 + "?", A0, vd, bd, Yp].join("|") + ")", og = RegExp(gd, "g"), ag = RegExp(A0, "g"), Cd = RegExp(md + "(?=" + md + ")|" + sg + G1, "g"), lg = RegExp([
        Yu + "?" + L1 + "+" + B1 + "(?=" + [P1, Yu, "$"].join("|") + ")",
        eg + "+" + U1 + "(?=" + [P1, Yu + k1, "$"].join("|") + ")",
        Yu + "?" + k1 + "+" + B1,
        Yu + "+" + U1,
        ig,
        rg,
        D1,
        ng
      ].join("|"), "g"), cg = RegExp("[" + M1 + kc + kh + F1 + "]"), hg = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ug = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], dg = -1, Ih = {};
      Ih[Lc] = Ih[Ec] = Ih[Hl] = Ih[fc] = Ih[lc] = Ih[Gl] = Ih[ql] = Ih[Vl] = Ih[Pl] = !0, Ih[gl] = Ih[Fl] = Ih[Sc] = Ih[zl] = Ih[hc] = Ih[Zl] = Ih[ul] = Ih[vl] = Ih[wl] = Ih[yl] = Ih[Ul] = Ih[Il] = Ih[Ll] = Ih[tc] = Ih[_c] = !1;
      var Sh = {};
      Sh[gl] = Sh[Fl] = Sh[Sc] = Sh[hc] = Sh[zl] = Sh[Zl] = Sh[Lc] = Sh[Ec] = Sh[Hl] = Sh[fc] = Sh[lc] = Sh[wl] = Sh[yl] = Sh[Ul] = Sh[Il] = Sh[Ll] = Sh[tc] = Sh[nc] = Sh[Gl] = Sh[ql] = Sh[Vl] = Sh[Pl] = !0, Sh[ul] = Sh[vl] = Sh[_c] = !1;
      var fg = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, pg = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, gg = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, mg = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, vg = parseFloat, bg = parseInt, H1 = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1, Cg = typeof self == "object" && self && self.Object === Object && self, jh = H1 || Cg || Function("return this")(), _d = zn && !zn.nodeType && zn, Hu = _d && !0 && Xn && !Xn.nodeType && Xn, z1 = Hu && Hu.exports === _d, yd = z1 && H1.process, iu = function() {
        try {
          var pc = Hu && Hu.require && Hu.require("util").types;
          return pc || yd && yd.binding && yd.binding("util");
        } catch {
        }
      }(), V1 = iu && iu.isArrayBuffer, W1 = iu && iu.isDate, Z1 = iu && iu.isMap, X1 = iu && iu.isRegExp, $1 = iu && iu.isSet, q1 = iu && iu.isTypedArray;
      function Yh(pc, Ac, Tc) {
        switch (Tc.length) {
          case 0:
            return pc.call(Ac);
          case 1:
            return pc.call(Ac, Tc[0]);
          case 2:
            return pc.call(Ac, Tc[0], Tc[1]);
          case 3:
            return pc.call(Ac, Tc[0], Tc[1], Tc[2]);
        }
        return pc.apply(Ac, Tc);
      }
      function _g(pc, Ac, Tc, jc) {
        for (var Kc = -1, yh = pc == null ? 0 : pc.length; ++Kc < yh; ) {
          var Bh = pc[Kc];
          Ac(jc, Bh, Tc(Bh), pc);
        }
        return jc;
      }
      function nu(pc, Ac) {
        for (var Tc = -1, jc = pc == null ? 0 : pc.length; ++Tc < jc && Ac(pc[Tc], Tc, pc) !== !1; )
          ;
        return pc;
      }
      function yg(pc, Ac) {
        for (var Tc = pc == null ? 0 : pc.length; Tc-- && Ac(pc[Tc], Tc, pc) !== !1; )
          ;
        return pc;
      }
      function Y1(pc, Ac) {
        for (var Tc = -1, jc = pc == null ? 0 : pc.length; ++Tc < jc; )
          if (!Ac(pc[Tc], Tc, pc))
            return !1;
        return !0;
      }
      function Lu(pc, Ac) {
        for (var Tc = -1, jc = pc == null ? 0 : pc.length, Kc = 0, yh = []; ++Tc < jc; ) {
          var Bh = pc[Tc];
          Ac(Bh, Tc, pc) && (yh[Kc++] = Bh);
        }
        return yh;
      }
      function F0(pc, Ac) {
        var Tc = pc == null ? 0 : pc.length;
        return !!Tc && Qu(pc, Ac, 0) > -1;
      }
      function xd(pc, Ac, Tc) {
        for (var jc = -1, Kc = pc == null ? 0 : pc.length; ++jc < Kc; )
          if (Tc(Ac, pc[jc]))
            return !0;
        return !1;
      }
      function Ph(pc, Ac) {
        for (var Tc = -1, jc = pc == null ? 0 : pc.length, Kc = Array(jc); ++Tc < jc; )
          Kc[Tc] = Ac(pc[Tc], Tc, pc);
        return Kc;
      }
      function Ou(pc, Ac) {
        for (var Tc = -1, jc = Ac.length, Kc = pc.length; ++Tc < jc; )
          pc[Kc + Tc] = Ac[Tc];
        return pc;
      }
      function wd(pc, Ac, Tc, jc) {
        var Kc = -1, yh = pc == null ? 0 : pc.length;
        for (jc && yh && (Tc = pc[++Kc]); ++Kc < yh; )
          Tc = Ac(Tc, pc[Kc], Kc, pc);
        return Tc;
      }
      function xg(pc, Ac, Tc, jc) {
        var Kc = pc == null ? 0 : pc.length;
        for (jc && Kc && (Tc = pc[--Kc]); Kc--; )
          Tc = Ac(Tc, pc[Kc], Kc, pc);
        return Tc;
      }
      function Td(pc, Ac) {
        for (var Tc = -1, jc = pc == null ? 0 : pc.length; ++Tc < jc; )
          if (Ac(pc[Tc], Tc, pc))
            return !0;
        return !1;
      }
      var wg = Ed("length");
      function Tg(pc) {
        return pc.split("");
      }
      function Eg(pc) {
        return pc.match(Xl) || [];
      }
      function Q1(pc, Ac, Tc) {
        var jc;
        return Tc(pc, function(Kc, yh, Bh) {
          if (Ac(Kc, yh, Bh))
            return jc = yh, !1;
        }), jc;
      }
      function I0(pc, Ac, Tc, jc) {
        for (var Kc = pc.length, yh = Tc + (jc ? 1 : -1); jc ? yh-- : ++yh < Kc; )
          if (Ac(pc[yh], yh, pc))
            return yh;
        return -1;
      }
      function Qu(pc, Ac, Tc) {
        return Ac === Ac ? Bg(pc, Ac, Tc) : I0(pc, J1, Tc);
      }
      function Sg(pc, Ac, Tc, jc) {
        for (var Kc = Tc - 1, yh = pc.length; ++Kc < yh; )
          if (jc(pc[Kc], Ac))
            return Kc;
        return -1;
      }
      function J1(pc) {
        return pc !== pc;
      }
      function ef(pc, Ac) {
        var Tc = pc == null ? 0 : pc.length;
        return Tc ? Ad(pc, Ac) / Tc : Ml;
      }
      function Ed(pc) {
        return function(Ac) {
          return Ac == null ? Un : Ac[pc];
        };
      }
      function Sd(pc) {
        return function(Ac) {
          return pc == null ? Un : pc[Ac];
        };
      }
      function tf(pc, Ac, Tc, jc, Kc) {
        return Kc(pc, function(yh, Bh, Th) {
          Tc = jc ? (jc = !1, yh) : Ac(Tc, yh, Bh, Th);
        }), Tc;
      }
      function Ag(pc, Ac) {
        var Tc = pc.length;
        for (pc.sort(Ac); Tc--; )
          pc[Tc] = pc[Tc].value;
        return pc;
      }
      function Ad(pc, Ac) {
        for (var Tc, jc = -1, Kc = pc.length; ++jc < Kc; ) {
          var yh = Ac(pc[jc]);
          yh !== Un && (Tc = Tc === Un ? yh : Tc + yh);
        }
        return Tc;
      }
      function Fd(pc, Ac) {
        for (var Tc = -1, jc = Array(pc); ++Tc < pc; )
          jc[Tc] = Ac(Tc);
        return jc;
      }
      function Fg(pc, Ac) {
        return Ph(Ac, function(Tc) {
          return [Tc, pc[Tc]];
        });
      }
      function rf(pc) {
        return pc && pc.slice(0, af(pc) + 1).replace(Zc, "");
      }
      function Qh(pc) {
        return function(Ac) {
          return pc(Ac);
        };
      }
      function Id(pc, Ac) {
        return Ph(Ac, function(Tc) {
          return pc[Tc];
        });
      }
      function d0(pc, Ac) {
        return pc.has(Ac);
      }
      function nf(pc, Ac) {
        for (var Tc = -1, jc = pc.length; ++Tc < jc && Qu(Ac, pc[Tc], 0) > -1; )
          ;
        return Tc;
      }
      function sf(pc, Ac) {
        for (var Tc = pc.length; Tc-- && Qu(Ac, pc[Tc], 0) > -1; )
          ;
        return Tc;
      }
      function Ig(pc, Ac) {
        for (var Tc = pc.length, jc = 0; Tc--; )
          pc[Tc] === Ac && ++jc;
        return jc;
      }
      var Pg = Sd(fg), Dg = Sd(pg);
      function Lg(pc) {
        return "\\" + mg[pc];
      }
      function Og(pc, Ac) {
        return pc == null ? Un : pc[Ac];
      }
      function Ju(pc) {
        return cg.test(pc);
      }
      function Rg(pc) {
        return hg.test(pc);
      }
      function Mg(pc) {
        for (var Ac, Tc = []; !(Ac = pc.next()).done; )
          Tc.push(Ac.value);
        return Tc;
      }
      function Pd(pc) {
        var Ac = -1, Tc = Array(pc.size);
        return pc.forEach(function(jc, Kc) {
          Tc[++Ac] = [Kc, jc];
        }), Tc;
      }
      function of(pc, Ac) {
        return function(Tc) {
          return pc(Ac(Tc));
        };
      }
      function Ru(pc, Ac) {
        for (var Tc = -1, jc = pc.length, Kc = 0, yh = []; ++Tc < jc; ) {
          var Bh = pc[Tc];
          (Bh === Ac || Bh === _a) && (pc[Tc] = _a, yh[Kc++] = Tc);
        }
        return yh;
      }
      function P0(pc) {
        var Ac = -1, Tc = Array(pc.size);
        return pc.forEach(function(jc) {
          Tc[++Ac] = jc;
        }), Tc;
      }
      function kg(pc) {
        var Ac = -1, Tc = Array(pc.size);
        return pc.forEach(function(jc) {
          Tc[++Ac] = [jc, jc];
        }), Tc;
      }
      function Bg(pc, Ac, Tc) {
        for (var jc = Tc - 1, Kc = pc.length; ++jc < Kc; )
          if (pc[jc] === Ac)
            return jc;
        return -1;
      }
      function Ug(pc, Ac, Tc) {
        for (var jc = Tc + 1; jc--; )
          if (pc[jc] === Ac)
            return jc;
        return jc;
      }
      function e0(pc) {
        return Ju(pc) ? jg(pc) : wg(pc);
      }
      function fu(pc) {
        return Ju(pc) ? Gg(pc) : Tg(pc);
      }
      function af(pc) {
        for (var Ac = pc.length; Ac-- && Yc.test(pc.charAt(Ac)); )
          ;
        return Ac;
      }
      var Ng = Sd(gg);
      function jg(pc) {
        for (var Ac = Cd.lastIndex = 0; Cd.test(pc); )
          ++Ac;
        return Ac;
      }
      function Gg(pc) {
        return pc.match(Cd) || [];
      }
      function Hg(pc) {
        return pc.match(lg) || [];
      }
      var zg = function pc(Ac) {
        Ac = Ac == null ? jh : t0.defaults(jh.Object(), Ac, t0.pick(jh, ug));
        var Tc = Ac.Array, jc = Ac.Date, Kc = Ac.Error, yh = Ac.Function, Bh = Ac.Math, Th = Ac.Object, Dd = Ac.RegExp, Vg = Ac.String, su = Ac.TypeError, D0 = Tc.prototype, Wg = yh.prototype, r0 = Th.prototype, L0 = Ac["__core-js_shared__"], O0 = Wg.toString, wh = r0.hasOwnProperty, Zg = 0, lf = function() {
          var Oa = /[^.]+$/.exec(L0 && L0.keys && L0.keys.IE_PROTO || "");
          return Oa ? "Symbol(src)_1." + Oa : "";
        }(), R0 = r0.toString, Xg = O0.call(Th), Kg = jh._, $g = Dd(
          "^" + O0.call(wh).replace($c, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), M0 = z1 ? Ac.Buffer : Un, Mu = Ac.Symbol, k0 = Ac.Uint8Array, cf = M0 ? M0.allocUnsafe : Un, B0 = of(Th.getPrototypeOf, Th), hf = Th.create, uf = r0.propertyIsEnumerable, U0 = D0.splice, df = Mu ? Mu.isConcatSpreadable : Un, f0 = Mu ? Mu.iterator : Un, zu = Mu ? Mu.toStringTag : Un, N0 = function() {
          try {
            var Oa = Ku(Th, "defineProperty");
            return Oa({}, "", {}), Oa;
          } catch {
          }
        }(), qg = Ac.clearTimeout !== jh.clearTimeout && Ac.clearTimeout, Yg = jc && jc.now !== jh.Date.now && jc.now, Qg = Ac.setTimeout !== jh.setTimeout && Ac.setTimeout, j0 = Bh.ceil, G0 = Bh.floor, Ld = Th.getOwnPropertySymbols, Jg = M0 ? M0.isBuffer : Un, ff = Ac.isFinite, e2 = D0.join, t2 = of(Th.keys, Th), Uh = Bh.max, Hh = Bh.min, r2 = jc.now, i2 = Ac.parseInt, pf = Bh.random, n2 = D0.reverse, Od = Ku(Ac, "DataView"), p0 = Ku(Ac, "Map"), Rd = Ku(Ac, "Promise"), i0 = Ku(Ac, "Set"), g0 = Ku(Ac, "WeakMap"), m0 = Ku(Th, "create"), H0 = g0 && new g0(), n0 = {}, s2 = $u(Od), o2 = $u(p0), a2 = $u(Rd), l2 = $u(i0), c2 = $u(g0), z0 = Mu ? Mu.prototype : Un, v0 = z0 ? z0.valueOf : Un, gf = z0 ? z0.toString : Un;
        function $l(Oa) {
          if (Lh(Oa) && !qc(Oa) && !(Oa instanceof Ch)) {
            if (Oa instanceof ou)
              return Oa;
            if (wh.call(Oa, "__wrapped__"))
              return mp(Oa);
          }
          return new ou(Oa);
        }
        var s0 = /* @__PURE__ */ function() {
          function Oa() {
          }
          return function(Ua) {
            if (!Dh(Ua))
              return {};
            if (hf)
              return hf(Ua);
            Oa.prototype = Ua;
            var ol = new Oa();
            return Oa.prototype = Un, ol;
          };
        }();
        function V0() {
        }
        function ou(Oa, Ua) {
          this.__wrapped__ = Oa, this.__actions__ = [], this.__chain__ = !!Ua, this.__index__ = 0, this.__values__ = Un;
        }
        $l.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Kl,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: oc,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: xc,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: $l
          }
        }, $l.prototype = V0.prototype, $l.prototype.constructor = $l, ou.prototype = s0(V0.prototype), ou.prototype.constructor = ou;
        function Ch(Oa) {
          this.__wrapped__ = Oa, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Sl, this.__views__ = [];
        }
        function h2() {
          var Oa = new Ch(this.__wrapped__);
          return Oa.__actions__ = Xh(this.__actions__), Oa.__dir__ = this.__dir__, Oa.__filtered__ = this.__filtered__, Oa.__iteratees__ = Xh(this.__iteratees__), Oa.__takeCount__ = this.__takeCount__, Oa.__views__ = Xh(this.__views__), Oa;
        }
        function u2() {
          if (this.__filtered__) {
            var Oa = new Ch(this);
            Oa.__dir__ = -1, Oa.__filtered__ = !0;
          } else
            Oa = this.clone(), Oa.__dir__ *= -1;
          return Oa;
        }
        function d2() {
          var Oa = this.__wrapped__.value(), Ua = this.__dir__, ol = qc(Oa), xl = Ua < 0, jl = ol ? Oa.length : 0, Yl = Em(0, jl, this.__views__), sc = Yl.start, ac = Yl.end, gc = ac - sc, Fc = xl ? ac : sc - 1, Ic = this.__iteratees__, Dc = Ic.length, Uc = 0, Gc = Hh(gc, this.__takeCount__);
          if (!ol || !xl && jl == gc && Gc == gc)
            return Nf(Oa, this.__actions__);
          var Vc = [];
          e:
            for (; gc-- && Uc < Gc; ) {
              Fc += Ua;
              for (var Jc = -1, Wc = Oa[Fc]; ++Jc < Dc; ) {
                var bh = Ic[Jc], _h = bh.iteratee, tu = bh.type, Zh = _h(Wc);
                if (tu == al)
                  Wc = Zh;
                else if (!Zh) {
                  if (tu == ll)
                    continue e;
                  break e;
                }
              }
              Vc[Uc++] = Wc;
            }
          return Vc;
        }
        Ch.prototype = s0(V0.prototype), Ch.prototype.constructor = Ch;
        function Vu(Oa) {
          var Ua = -1, ol = Oa == null ? 0 : Oa.length;
          for (this.clear(); ++Ua < ol; ) {
            var xl = Oa[Ua];
            this.set(xl[0], xl[1]);
          }
        }
        function f2() {
          this.__data__ = m0 ? m0(null) : {}, this.size = 0;
        }
        function p2(Oa) {
          var Ua = this.has(Oa) && delete this.__data__[Oa];
          return this.size -= Ua ? 1 : 0, Ua;
        }
        function g2(Oa) {
          var Ua = this.__data__;
          if (m0) {
            var ol = Ua[Oa];
            return ol === va ? Un : ol;
          }
          return wh.call(Ua, Oa) ? Ua[Oa] : Un;
        }
        function m2(Oa) {
          var Ua = this.__data__;
          return m0 ? Ua[Oa] !== Un : wh.call(Ua, Oa);
        }
        function v2(Oa, Ua) {
          var ol = this.__data__;
          return this.size += this.has(Oa) ? 0 : 1, ol[Oa] = m0 && Ua === Un ? va : Ua, this;
        }
        Vu.prototype.clear = f2, Vu.prototype.delete = p2, Vu.prototype.get = g2, Vu.prototype.has = m2, Vu.prototype.set = v2;
        function yu(Oa) {
          var Ua = -1, ol = Oa == null ? 0 : Oa.length;
          for (this.clear(); ++Ua < ol; ) {
            var xl = Oa[Ua];
            this.set(xl[0], xl[1]);
          }
        }
        function b2() {
          this.__data__ = [], this.size = 0;
        }
        function C2(Oa) {
          var Ua = this.__data__, ol = W0(Ua, Oa);
          if (ol < 0)
            return !1;
          var xl = Ua.length - 1;
          return ol == xl ? Ua.pop() : U0.call(Ua, ol, 1), --this.size, !0;
        }
        function _2(Oa) {
          var Ua = this.__data__, ol = W0(Ua, Oa);
          return ol < 0 ? Un : Ua[ol][1];
        }
        function y2(Oa) {
          return W0(this.__data__, Oa) > -1;
        }
        function x2(Oa, Ua) {
          var ol = this.__data__, xl = W0(ol, Oa);
          return xl < 0 ? (++this.size, ol.push([Oa, Ua])) : ol[xl][1] = Ua, this;
        }
        yu.prototype.clear = b2, yu.prototype.delete = C2, yu.prototype.get = _2, yu.prototype.has = y2, yu.prototype.set = x2;
        function xu(Oa) {
          var Ua = -1, ol = Oa == null ? 0 : Oa.length;
          for (this.clear(); ++Ua < ol; ) {
            var xl = Oa[Ua];
            this.set(xl[0], xl[1]);
          }
        }
        function w2() {
          this.size = 0, this.__data__ = {
            hash: new Vu(),
            map: new (p0 || yu)(),
            string: new Vu()
          };
        }
        function T2(Oa) {
          var Ua = id(this, Oa).delete(Oa);
          return this.size -= Ua ? 1 : 0, Ua;
        }
        function E2(Oa) {
          return id(this, Oa).get(Oa);
        }
        function S2(Oa) {
          return id(this, Oa).has(Oa);
        }
        function A2(Oa, Ua) {
          var ol = id(this, Oa), xl = ol.size;
          return ol.set(Oa, Ua), this.size += ol.size == xl ? 0 : 1, this;
        }
        xu.prototype.clear = w2, xu.prototype.delete = T2, xu.prototype.get = E2, xu.prototype.has = S2, xu.prototype.set = A2;
        function Wu(Oa) {
          var Ua = -1, ol = Oa == null ? 0 : Oa.length;
          for (this.__data__ = new xu(); ++Ua < ol; )
            this.add(Oa[Ua]);
        }
        function F2(Oa) {
          return this.__data__.set(Oa, va), this;
        }
        function I2(Oa) {
          return this.__data__.has(Oa);
        }
        Wu.prototype.add = Wu.prototype.push = F2, Wu.prototype.has = I2;
        function pu(Oa) {
          var Ua = this.__data__ = new yu(Oa);
          this.size = Ua.size;
        }
        function P2() {
          this.__data__ = new yu(), this.size = 0;
        }
        function D2(Oa) {
          var Ua = this.__data__, ol = Ua.delete(Oa);
          return this.size = Ua.size, ol;
        }
        function L2(Oa) {
          return this.__data__.get(Oa);
        }
        function O2(Oa) {
          return this.__data__.has(Oa);
        }
        function R2(Oa, Ua) {
          var ol = this.__data__;
          if (ol instanceof yu) {
            var xl = ol.__data__;
            if (!p0 || xl.length < qn - 1)
              return xl.push([Oa, Ua]), this.size = ++ol.size, this;
            ol = this.__data__ = new xu(xl);
          }
          return ol.set(Oa, Ua), this.size = ol.size, this;
        }
        pu.prototype.clear = P2, pu.prototype.delete = D2, pu.prototype.get = L2, pu.prototype.has = O2, pu.prototype.set = R2;
        function mf(Oa, Ua) {
          var ol = qc(Oa), xl = !ol && qu(Oa), jl = !ol && !xl && ju(Oa), Yl = !ol && !xl && !jl && c0(Oa), sc = ol || xl || jl || Yl, ac = sc ? Fd(Oa.length, Vg) : [], gc = ac.length;
          for (var Fc in Oa)
            (Ua || wh.call(Oa, Fc)) && !(sc && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Fc == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            jl && (Fc == "offset" || Fc == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            Yl && (Fc == "buffer" || Fc == "byteLength" || Fc == "byteOffset") || // Skip index properties.
            Su(Fc, gc))) && ac.push(Fc);
          return ac;
        }
        function vf(Oa) {
          var Ua = Oa.length;
          return Ua ? Oa[Wd(0, Ua - 1)] : Un;
        }
        function M2(Oa, Ua) {
          return nd(Xh(Oa), Zu(Ua, 0, Oa.length));
        }
        function k2(Oa) {
          return nd(Xh(Oa));
        }
        function Md(Oa, Ua, ol) {
          (ol !== Un && !gu(Oa[Ua], ol) || ol === Un && !(Ua in Oa)) && wu(Oa, Ua, ol);
        }
        function b0(Oa, Ua, ol) {
          var xl = Oa[Ua];
          (!(wh.call(Oa, Ua) && gu(xl, ol)) || ol === Un && !(Ua in Oa)) && wu(Oa, Ua, ol);
        }
        function W0(Oa, Ua) {
          for (var ol = Oa.length; ol--; )
            if (gu(Oa[ol][0], Ua))
              return ol;
          return -1;
        }
        function B2(Oa, Ua, ol, xl) {
          return ku(Oa, function(jl, Yl, sc) {
            Ua(xl, jl, ol(jl), sc);
          }), xl;
        }
        function bf(Oa, Ua) {
          return Oa && bu(Ua, Nh(Ua), Oa);
        }
        function U2(Oa, Ua) {
          return Oa && bu(Ua, $h(Ua), Oa);
        }
        function wu(Oa, Ua, ol) {
          Ua == "__proto__" && N0 ? N0(Oa, Ua, {
            configurable: !0,
            enumerable: !0,
            value: ol,
            writable: !0
          }) : Oa[Ua] = ol;
        }
        function kd(Oa, Ua) {
          for (var ol = -1, xl = Ua.length, jl = Tc(xl), Yl = Oa == null; ++ol < xl; )
            jl[ol] = Yl ? Un : m1(Oa, Ua[ol]);
          return jl;
        }
        function Zu(Oa, Ua, ol) {
          return Oa === Oa && (ol !== Un && (Oa = Oa <= ol ? Oa : ol), Ua !== Un && (Oa = Oa >= Ua ? Oa : Ua)), Oa;
        }
        function au(Oa, Ua, ol, xl, jl, Yl) {
          var sc, ac = Ua & ya, gc = Ua & xa, Fc = Ua & wa;
          if (ol && (sc = jl ? ol(Oa, xl, jl, Yl) : ol(Oa)), sc !== Un)
            return sc;
          if (!Dh(Oa))
            return Oa;
          var Ic = qc(Oa);
          if (Ic) {
            if (sc = Am(Oa), !ac)
              return Xh(Oa, sc);
          } else {
            var Dc = zh(Oa), Uc = Dc == vl || Dc == Tl;
            if (ju(Oa))
              return Hf(Oa, ac);
            if (Dc == Ul || Dc == gl || Uc && !jl) {
              if (sc = gc || Uc ? {} : ap(Oa), !ac)
                return gc ? mm(Oa, U2(sc, Oa)) : gm(Oa, bf(sc, Oa));
            } else {
              if (!Sh[Dc])
                return jl ? Oa : {};
              sc = Fm(Oa, Dc, ac);
            }
          }
          Yl || (Yl = new pu());
          var Gc = Yl.get(Oa);
          if (Gc)
            return Gc;
          Yl.set(Oa, sc), kp(Oa) ? Oa.forEach(function(Wc) {
            sc.add(au(Wc, Ua, ol, Wc, Oa, Yl));
          }) : Rp(Oa) && Oa.forEach(function(Wc, bh) {
            sc.set(bh, au(Wc, Ua, ol, bh, Oa, Yl));
          });
          var Vc = Fc ? gc ? r1 : t1 : gc ? $h : Nh, Jc = Ic ? Un : Vc(Oa);
          return nu(Jc || Oa, function(Wc, bh) {
            Jc && (bh = Wc, Wc = Oa[bh]), b0(sc, bh, au(Wc, Ua, ol, bh, Oa, Yl));
          }), sc;
        }
        function N2(Oa) {
          var Ua = Nh(Oa);
          return function(ol) {
            return Cf(ol, Oa, Ua);
          };
        }
        function Cf(Oa, Ua, ol) {
          var xl = ol.length;
          if (Oa == null)
            return !xl;
          for (Oa = Th(Oa); xl--; ) {
            var jl = ol[xl], Yl = Ua[jl], sc = Oa[jl];
            if (sc === Un && !(jl in Oa) || !Yl(sc))
              return !1;
          }
          return !0;
        }
        function _f(Oa, Ua, ol) {
          if (typeof Oa != "function")
            throw new su(pa);
          return E0(function() {
            Oa.apply(Un, ol);
          }, Ua);
        }
        function C0(Oa, Ua, ol, xl) {
          var jl = -1, Yl = F0, sc = !0, ac = Oa.length, gc = [], Fc = Ua.length;
          if (!ac)
            return gc;
          ol && (Ua = Ph(Ua, Qh(ol))), xl ? (Yl = xd, sc = !1) : Ua.length >= qn && (Yl = d0, sc = !1, Ua = new Wu(Ua));
          e:
            for (; ++jl < ac; ) {
              var Ic = Oa[jl], Dc = ol == null ? Ic : ol(Ic);
              if (Ic = xl || Ic !== 0 ? Ic : 0, sc && Dc === Dc) {
                for (var Uc = Fc; Uc--; )
                  if (Ua[Uc] === Dc)
                    continue e;
                gc.push(Ic);
              } else Yl(Ua, Dc, xl) || gc.push(Ic);
            }
          return gc;
        }
        var ku = Xf(vu), yf = Xf(Ud, !0);
        function j2(Oa, Ua) {
          var ol = !0;
          return ku(Oa, function(xl, jl, Yl) {
            return ol = !!Ua(xl, jl, Yl), ol;
          }), ol;
        }
        function Z0(Oa, Ua, ol) {
          for (var xl = -1, jl = Oa.length; ++xl < jl; ) {
            var Yl = Oa[xl], sc = Ua(Yl);
            if (sc != null && (ac === Un ? sc === sc && !eu(sc) : ol(sc, ac)))
              var ac = sc, gc = Yl;
          }
          return gc;
        }
        function G2(Oa, Ua, ol, xl) {
          var jl = Oa.length;
          for (ol = Qc(ol), ol < 0 && (ol = -ol > jl ? 0 : jl + ol), xl = xl === Un || xl > jl ? jl : Qc(xl), xl < 0 && (xl += jl), xl = ol > xl ? 0 : Up(xl); ol < xl; )
            Oa[ol++] = Ua;
          return Oa;
        }
        function xf(Oa, Ua) {
          var ol = [];
          return ku(Oa, function(xl, jl, Yl) {
            Ua(xl, jl, Yl) && ol.push(xl);
          }), ol;
        }
        function Gh(Oa, Ua, ol, xl, jl) {
          var Yl = -1, sc = Oa.length;
          for (ol || (ol = Pm), jl || (jl = []); ++Yl < sc; ) {
            var ac = Oa[Yl];
            Ua > 0 && ol(ac) ? Ua > 1 ? Gh(ac, Ua - 1, ol, xl, jl) : Ou(jl, ac) : xl || (jl[jl.length] = ac);
          }
          return jl;
        }
        var Bd = Kf(), wf = Kf(!0);
        function vu(Oa, Ua) {
          return Oa && Bd(Oa, Ua, Nh);
        }
        function Ud(Oa, Ua) {
          return Oa && wf(Oa, Ua, Nh);
        }
        function X0(Oa, Ua) {
          return Lu(Ua, function(ol) {
            return Au(Oa[ol]);
          });
        }
        function Xu(Oa, Ua) {
          Ua = Uu(Ua, Oa);
          for (var ol = 0, xl = Ua.length; Oa != null && ol < xl; )
            Oa = Oa[Cu(Ua[ol++])];
          return ol && ol == xl ? Oa : Un;
        }
        function Tf(Oa, Ua, ol) {
          var xl = Ua(Oa);
          return qc(Oa) ? xl : Ou(xl, ol(Oa));
        }
        function Vh(Oa) {
          return Oa == null ? Oa === Un ? uc : Rl : zu && zu in Th(Oa) ? Tm(Oa) : Bm(Oa);
        }
        function Nd(Oa, Ua) {
          return Oa > Ua;
        }
        function H2(Oa, Ua) {
          return Oa != null && wh.call(Oa, Ua);
        }
        function z2(Oa, Ua) {
          return Oa != null && Ua in Th(Oa);
        }
        function V2(Oa, Ua, ol) {
          return Oa >= Hh(Ua, ol) && Oa < Uh(Ua, ol);
        }
        function jd(Oa, Ua, ol) {
          for (var xl = ol ? xd : F0, jl = Oa[0].length, Yl = Oa.length, sc = Yl, ac = Tc(Yl), gc = 1 / 0, Fc = []; sc--; ) {
            var Ic = Oa[sc];
            sc && Ua && (Ic = Ph(Ic, Qh(Ua))), gc = Hh(Ic.length, gc), ac[sc] = !ol && (Ua || jl >= 120 && Ic.length >= 120) ? new Wu(sc && Ic) : Un;
          }
          Ic = Oa[0];
          var Dc = -1, Uc = ac[0];
          e:
            for (; ++Dc < jl && Fc.length < gc; ) {
              var Gc = Ic[Dc], Vc = Ua ? Ua(Gc) : Gc;
              if (Gc = ol || Gc !== 0 ? Gc : 0, !(Uc ? d0(Uc, Vc) : xl(Fc, Vc, ol))) {
                for (sc = Yl; --sc; ) {
                  var Jc = ac[sc];
                  if (!(Jc ? d0(Jc, Vc) : xl(Oa[sc], Vc, ol)))
                    continue e;
                }
                Uc && Uc.push(Vc), Fc.push(Gc);
              }
            }
          return Fc;
        }
        function W2(Oa, Ua, ol, xl) {
          return vu(Oa, function(jl, Yl, sc) {
            Ua(xl, ol(jl), Yl, sc);
          }), xl;
        }
        function _0(Oa, Ua, ol) {
          Ua = Uu(Ua, Oa), Oa = up(Oa, Ua);
          var xl = Oa == null ? Oa : Oa[Cu(cu(Ua))];
          return xl == null ? Un : Yh(xl, Oa, ol);
        }
        function Ef(Oa) {
          return Lh(Oa) && Vh(Oa) == gl;
        }
        function Z2(Oa) {
          return Lh(Oa) && Vh(Oa) == Sc;
        }
        function X2(Oa) {
          return Lh(Oa) && Vh(Oa) == Zl;
        }
        function y0(Oa, Ua, ol, xl, jl) {
          return Oa === Ua ? !0 : Oa == null || Ua == null || !Lh(Oa) && !Lh(Ua) ? Oa !== Oa && Ua !== Ua : $2(Oa, Ua, ol, xl, y0, jl);
        }
        function $2(Oa, Ua, ol, xl, jl, Yl) {
          var sc = qc(Oa), ac = qc(Ua), gc = sc ? Fl : zh(Oa), Fc = ac ? Fl : zh(Ua);
          gc = gc == gl ? Ul : gc, Fc = Fc == gl ? Ul : Fc;
          var Ic = gc == Ul, Dc = Fc == Ul, Uc = gc == Fc;
          if (Uc && ju(Oa)) {
            if (!ju(Ua))
              return !1;
            sc = !0, Ic = !1;
          }
          if (Uc && !Ic)
            return Yl || (Yl = new pu()), sc || c0(Oa) ? np(Oa, Ua, ol, xl, jl, Yl) : xm(Oa, Ua, gc, ol, xl, jl, Yl);
          if (!(ol & Ta)) {
            var Gc = Ic && wh.call(Oa, "__wrapped__"), Vc = Dc && wh.call(Ua, "__wrapped__");
            if (Gc || Vc) {
              var Jc = Gc ? Oa.value() : Oa, Wc = Vc ? Ua.value() : Ua;
              return Yl || (Yl = new pu()), jl(Jc, Wc, ol, xl, Yl);
            }
          }
          return Uc ? (Yl || (Yl = new pu()), wm(Oa, Ua, ol, xl, jl, Yl)) : !1;
        }
        function q2(Oa) {
          return Lh(Oa) && zh(Oa) == wl;
        }
        function Gd(Oa, Ua, ol, xl) {
          var jl = ol.length, Yl = jl, sc = !xl;
          if (Oa == null)
            return !Yl;
          for (Oa = Th(Oa); jl--; ) {
            var ac = ol[jl];
            if (sc && ac[2] ? ac[1] !== Oa[ac[0]] : !(ac[0] in Oa))
              return !1;
          }
          for (; ++jl < Yl; ) {
            ac = ol[jl];
            var gc = ac[0], Fc = Oa[gc], Ic = ac[1];
            if (sc && ac[2]) {
              if (Fc === Un && !(gc in Oa))
                return !1;
            } else {
              var Dc = new pu();
              if (xl)
                var Uc = xl(Fc, Ic, gc, Oa, Ua, Dc);
              if (!(Uc === Un ? y0(Ic, Fc, Ta | Sa, xl, Dc) : Uc))
                return !1;
            }
          }
          return !0;
        }
        function Sf(Oa) {
          if (!Dh(Oa) || Lm(Oa))
            return !1;
          var Ua = Au(Oa) ? $g : Cc;
          return Ua.test($u(Oa));
        }
        function Y2(Oa) {
          return Lh(Oa) && Vh(Oa) == Il;
        }
        function Q2(Oa) {
          return Lh(Oa) && zh(Oa) == Ll;
        }
        function J2(Oa) {
          return Lh(Oa) && hd(Oa.length) && !!Ih[Vh(Oa)];
        }
        function Af(Oa) {
          return typeof Oa == "function" ? Oa : Oa == null ? qh : typeof Oa == "object" ? qc(Oa) ? Pf(Oa[0], Oa[1]) : If(Oa) : $p(Oa);
        }
        function Hd(Oa) {
          if (!T0(Oa))
            return t2(Oa);
          var Ua = [];
          for (var ol in Th(Oa))
            wh.call(Oa, ol) && ol != "constructor" && Ua.push(ol);
          return Ua;
        }
        function em(Oa) {
          if (!Dh(Oa))
            return km(Oa);
          var Ua = T0(Oa), ol = [];
          for (var xl in Oa)
            xl == "constructor" && (Ua || !wh.call(Oa, xl)) || ol.push(xl);
          return ol;
        }
        function zd(Oa, Ua) {
          return Oa < Ua;
        }
        function Ff(Oa, Ua) {
          var ol = -1, xl = Kh(Oa) ? Tc(Oa.length) : [];
          return ku(Oa, function(jl, Yl, sc) {
            xl[++ol] = Ua(jl, Yl, sc);
          }), xl;
        }
        function If(Oa) {
          var Ua = n1(Oa);
          return Ua.length == 1 && Ua[0][2] ? cp(Ua[0][0], Ua[0][1]) : function(ol) {
            return ol === Oa || Gd(ol, Oa, Ua);
          };
        }
        function Pf(Oa, Ua) {
          return o1(Oa) && lp(Ua) ? cp(Cu(Oa), Ua) : function(ol) {
            var xl = m1(ol, Oa);
            return xl === Un && xl === Ua ? v1(ol, Oa) : y0(Ua, xl, Ta | Sa);
          };
        }
        function K0(Oa, Ua, ol, xl, jl) {
          Oa !== Ua && Bd(Ua, function(Yl, sc) {
            if (jl || (jl = new pu()), Dh(Yl))
              tm(Oa, Ua, sc, ol, K0, xl, jl);
            else {
              var ac = xl ? xl(l1(Oa, sc), Yl, sc + "", Oa, Ua, jl) : Un;
              ac === Un && (ac = Yl), Md(Oa, sc, ac);
            }
          }, $h);
        }
        function tm(Oa, Ua, ol, xl, jl, Yl, sc) {
          var ac = l1(Oa, ol), gc = l1(Ua, ol), Fc = sc.get(gc);
          if (Fc) {
            Md(Oa, ol, Fc);
            return;
          }
          var Ic = Yl ? Yl(ac, gc, ol + "", Oa, Ua, sc) : Un, Dc = Ic === Un;
          if (Dc) {
            var Uc = qc(gc), Gc = !Uc && ju(gc), Vc = !Uc && !Gc && c0(gc);
            Ic = gc, Uc || Gc || Vc ? qc(ac) ? Ic = ac : Oh(ac) ? Ic = Xh(ac) : Gc ? (Dc = !1, Ic = Hf(gc, !0)) : Vc ? (Dc = !1, Ic = zf(gc, !0)) : Ic = [] : S0(gc) || qu(gc) ? (Ic = ac, qu(ac) ? Ic = Np(ac) : (!Dh(ac) || Au(ac)) && (Ic = ap(gc))) : Dc = !1;
          }
          Dc && (sc.set(gc, Ic), jl(Ic, gc, xl, Yl, sc), sc.delete(gc)), Md(Oa, ol, Ic);
        }
        function Df(Oa, Ua) {
          var ol = Oa.length;
          if (ol)
            return Ua += Ua < 0 ? ol : 0, Su(Ua, ol) ? Oa[Ua] : Un;
        }
        function Lf(Oa, Ua, ol) {
          Ua.length ? Ua = Ph(Ua, function(Yl) {
            return qc(Yl) ? function(sc) {
              return Xu(sc, Yl.length === 1 ? Yl[0] : Yl);
            } : Yl;
          }) : Ua = [qh];
          var xl = -1;
          Ua = Ph(Ua, Qh(zc()));
          var jl = Ff(Oa, function(Yl, sc, ac) {
            var gc = Ph(Ua, function(Fc) {
              return Fc(Yl);
            });
            return { criteria: gc, index: ++xl, value: Yl };
          });
          return Ag(jl, function(Yl, sc) {
            return pm(Yl, sc, ol);
          });
        }
        function rm(Oa, Ua) {
          return Of(Oa, Ua, function(ol, xl) {
            return v1(Oa, xl);
          });
        }
        function Of(Oa, Ua, ol) {
          for (var xl = -1, jl = Ua.length, Yl = {}; ++xl < jl; ) {
            var sc = Ua[xl], ac = Xu(Oa, sc);
            ol(ac, sc) && x0(Yl, Uu(sc, Oa), ac);
          }
          return Yl;
        }
        function im(Oa) {
          return function(Ua) {
            return Xu(Ua, Oa);
          };
        }
        function Vd(Oa, Ua, ol, xl) {
          var jl = xl ? Sg : Qu, Yl = -1, sc = Ua.length, ac = Oa;
          for (Oa === Ua && (Ua = Xh(Ua)), ol && (ac = Ph(Oa, Qh(ol))); ++Yl < sc; )
            for (var gc = 0, Fc = Ua[Yl], Ic = ol ? ol(Fc) : Fc; (gc = jl(ac, Ic, gc, xl)) > -1; )
              ac !== Oa && U0.call(ac, gc, 1), U0.call(Oa, gc, 1);
          return Oa;
        }
        function Rf(Oa, Ua) {
          for (var ol = Oa ? Ua.length : 0, xl = ol - 1; ol--; ) {
            var jl = Ua[ol];
            if (ol == xl || jl !== Yl) {
              var Yl = jl;
              Su(jl) ? U0.call(Oa, jl, 1) : Kd(Oa, jl);
            }
          }
          return Oa;
        }
        function Wd(Oa, Ua) {
          return Oa + G0(pf() * (Ua - Oa + 1));
        }
        function nm(Oa, Ua, ol, xl) {
          for (var jl = -1, Yl = Uh(j0((Ua - Oa) / (ol || 1)), 0), sc = Tc(Yl); Yl--; )
            sc[xl ? Yl : ++jl] = Oa, Oa += ol;
          return sc;
        }
        function Zd(Oa, Ua) {
          var ol = "";
          if (!Oa || Ua < 1 || Ua > El)
            return ol;
          do
            Ua % 2 && (ol += Oa), Ua = G0(Ua / 2), Ua && (Oa += Oa);
          while (Ua);
          return ol;
        }
        function vh(Oa, Ua) {
          return c1(hp(Oa, Ua, qh), Oa + "");
        }
        function sm(Oa) {
          return vf(h0(Oa));
        }
        function om(Oa, Ua) {
          var ol = h0(Oa);
          return nd(ol, Zu(Ua, 0, ol.length));
        }
        function x0(Oa, Ua, ol, xl) {
          if (!Dh(Oa))
            return Oa;
          Ua = Uu(Ua, Oa);
          for (var jl = -1, Yl = Ua.length, sc = Yl - 1, ac = Oa; ac != null && ++jl < Yl; ) {
            var gc = Cu(Ua[jl]), Fc = ol;
            if (gc === "__proto__" || gc === "constructor" || gc === "prototype")
              return Oa;
            if (jl != sc) {
              var Ic = ac[gc];
              Fc = xl ? xl(Ic, gc, ac) : Un, Fc === Un && (Fc = Dh(Ic) ? Ic : Su(Ua[jl + 1]) ? [] : {});
            }
            b0(ac, gc, Fc), ac = ac[gc];
          }
          return Oa;
        }
        var Mf = H0 ? function(Oa, Ua) {
          return H0.set(Oa, Ua), Oa;
        } : qh, am = N0 ? function(Oa, Ua) {
          return N0(Oa, "toString", {
            configurable: !0,
            enumerable: !1,
            value: C1(Ua),
            writable: !0
          });
        } : qh;
        function lm(Oa) {
          return nd(h0(Oa));
        }
        function lu(Oa, Ua, ol) {
          var xl = -1, jl = Oa.length;
          Ua < 0 && (Ua = -Ua > jl ? 0 : jl + Ua), ol = ol > jl ? jl : ol, ol < 0 && (ol += jl), jl = Ua > ol ? 0 : ol - Ua >>> 0, Ua >>>= 0;
          for (var Yl = Tc(jl); ++xl < jl; )
            Yl[xl] = Oa[xl + Ua];
          return Yl;
        }
        function cm(Oa, Ua) {
          var ol;
          return ku(Oa, function(xl, jl, Yl) {
            return ol = Ua(xl, jl, Yl), !ol;
          }), !!ol;
        }
        function $0(Oa, Ua, ol) {
          var xl = 0, jl = Oa == null ? xl : Oa.length;
          if (typeof Ua == "number" && Ua === Ua && jl <= Dl) {
            for (; xl < jl; ) {
              var Yl = xl + jl >>> 1, sc = Oa[Yl];
              sc !== null && !eu(sc) && (ol ? sc <= Ua : sc < Ua) ? xl = Yl + 1 : jl = Yl;
            }
            return jl;
          }
          return Xd(Oa, Ua, qh, ol);
        }
        function Xd(Oa, Ua, ol, xl) {
          var jl = 0, Yl = Oa == null ? 0 : Oa.length;
          if (Yl === 0)
            return 0;
          Ua = ol(Ua);
          for (var sc = Ua !== Ua, ac = Ua === null, gc = eu(Ua), Fc = Ua === Un; jl < Yl; ) {
            var Ic = G0((jl + Yl) / 2), Dc = ol(Oa[Ic]), Uc = Dc !== Un, Gc = Dc === null, Vc = Dc === Dc, Jc = eu(Dc);
            if (sc)
              var Wc = xl || Vc;
            else Fc ? Wc = Vc && (xl || Uc) : ac ? Wc = Vc && Uc && (xl || !Gc) : gc ? Wc = Vc && Uc && !Gc && (xl || !Jc) : Gc || Jc ? Wc = !1 : Wc = xl ? Dc <= Ua : Dc < Ua;
            Wc ? jl = Ic + 1 : Yl = Ic;
          }
          return Hh(Yl, ml);
        }
        function kf(Oa, Ua) {
          for (var ol = -1, xl = Oa.length, jl = 0, Yl = []; ++ol < xl; ) {
            var sc = Oa[ol], ac = Ua ? Ua(sc) : sc;
            if (!ol || !gu(ac, gc)) {
              var gc = ac;
              Yl[jl++] = sc === 0 ? 0 : sc;
            }
          }
          return Yl;
        }
        function Bf(Oa) {
          return typeof Oa == "number" ? Oa : eu(Oa) ? Ml : +Oa;
        }
        function Jh(Oa) {
          if (typeof Oa == "string")
            return Oa;
          if (qc(Oa))
            return Ph(Oa, Jh) + "";
          if (eu(Oa))
            return gf ? gf.call(Oa) : "";
          var Ua = Oa + "";
          return Ua == "0" && 1 / Oa == -1 / 0 ? "-0" : Ua;
        }
        function Bu(Oa, Ua, ol) {
          var xl = -1, jl = F0, Yl = Oa.length, sc = !0, ac = [], gc = ac;
          if (ol)
            sc = !1, jl = xd;
          else if (Yl >= qn) {
            var Fc = Ua ? null : _m(Oa);
            if (Fc)
              return P0(Fc);
            sc = !1, jl = d0, gc = new Wu();
          } else
            gc = Ua ? [] : ac;
          e:
            for (; ++xl < Yl; ) {
              var Ic = Oa[xl], Dc = Ua ? Ua(Ic) : Ic;
              if (Ic = ol || Ic !== 0 ? Ic : 0, sc && Dc === Dc) {
                for (var Uc = gc.length; Uc--; )
                  if (gc[Uc] === Dc)
                    continue e;
                Ua && gc.push(Dc), ac.push(Ic);
              } else jl(gc, Dc, ol) || (gc !== ac && gc.push(Dc), ac.push(Ic));
            }
          return ac;
        }
        function Kd(Oa, Ua) {
          return Ua = Uu(Ua, Oa), Oa = up(Oa, Ua), Oa == null || delete Oa[Cu(cu(Ua))];
        }
        function Uf(Oa, Ua, ol, xl) {
          return x0(Oa, Ua, ol(Xu(Oa, Ua)), xl);
        }
        function q0(Oa, Ua, ol, xl) {
          for (var jl = Oa.length, Yl = xl ? jl : -1; (xl ? Yl-- : ++Yl < jl) && Ua(Oa[Yl], Yl, Oa); )
            ;
          return ol ? lu(Oa, xl ? 0 : Yl, xl ? Yl + 1 : jl) : lu(Oa, xl ? Yl + 1 : 0, xl ? jl : Yl);
        }
        function Nf(Oa, Ua) {
          var ol = Oa;
          return ol instanceof Ch && (ol = ol.value()), wd(Ua, function(xl, jl) {
            return jl.func.apply(jl.thisArg, Ou([xl], jl.args));
          }, ol);
        }
        function $d(Oa, Ua, ol) {
          var xl = Oa.length;
          if (xl < 2)
            return xl ? Bu(Oa[0]) : [];
          for (var jl = -1, Yl = Tc(xl); ++jl < xl; )
            for (var sc = Oa[jl], ac = -1; ++ac < xl; )
              ac != jl && (Yl[jl] = C0(Yl[jl] || sc, Oa[ac], Ua, ol));
          return Bu(Gh(Yl, 1), Ua, ol);
        }
        function jf(Oa, Ua, ol) {
          for (var xl = -1, jl = Oa.length, Yl = Ua.length, sc = {}; ++xl < jl; ) {
            var ac = xl < Yl ? Ua[xl] : Un;
            ol(sc, Oa[xl], ac);
          }
          return sc;
        }
        function qd(Oa) {
          return Oh(Oa) ? Oa : [];
        }
        function Yd(Oa) {
          return typeof Oa == "function" ? Oa : qh;
        }
        function Uu(Oa, Ua) {
          return qc(Oa) ? Oa : o1(Oa, Ua) ? [Oa] : gp(xh(Oa));
        }
        var hm = vh;
        function Nu(Oa, Ua, ol) {
          var xl = Oa.length;
          return ol = ol === Un ? xl : ol, !Ua && ol >= xl ? Oa : lu(Oa, Ua, ol);
        }
        var Gf = qg || function(Oa) {
          return jh.clearTimeout(Oa);
        };
        function Hf(Oa, Ua) {
          if (Ua)
            return Oa.slice();
          var ol = Oa.length, xl = cf ? cf(ol) : new Oa.constructor(ol);
          return Oa.copy(xl), xl;
        }
        function Qd(Oa) {
          var Ua = new Oa.constructor(Oa.byteLength);
          return new k0(Ua).set(new k0(Oa)), Ua;
        }
        function um(Oa, Ua) {
          var ol = Ua ? Qd(Oa.buffer) : Oa.buffer;
          return new Oa.constructor(ol, Oa.byteOffset, Oa.byteLength);
        }
        function dm(Oa) {
          var Ua = new Oa.constructor(Oa.source, dc.exec(Oa));
          return Ua.lastIndex = Oa.lastIndex, Ua;
        }
        function fm(Oa) {
          return v0 ? Th(v0.call(Oa)) : {};
        }
        function zf(Oa, Ua) {
          var ol = Ua ? Qd(Oa.buffer) : Oa.buffer;
          return new Oa.constructor(ol, Oa.byteOffset, Oa.length);
        }
        function Vf(Oa, Ua) {
          if (Oa !== Ua) {
            var ol = Oa !== Un, xl = Oa === null, jl = Oa === Oa, Yl = eu(Oa), sc = Ua !== Un, ac = Ua === null, gc = Ua === Ua, Fc = eu(Ua);
            if (!ac && !Fc && !Yl && Oa > Ua || Yl && sc && gc && !ac && !Fc || xl && sc && gc || !ol && gc || !jl)
              return 1;
            if (!xl && !Yl && !Fc && Oa < Ua || Fc && ol && jl && !xl && !Yl || ac && ol && jl || !sc && jl || !gc)
              return -1;
          }
          return 0;
        }
        function pm(Oa, Ua, ol) {
          for (var xl = -1, jl = Oa.criteria, Yl = Ua.criteria, sc = jl.length, ac = ol.length; ++xl < sc; ) {
            var gc = Vf(jl[xl], Yl[xl]);
            if (gc) {
              if (xl >= ac)
                return gc;
              var Fc = ol[xl];
              return gc * (Fc == "desc" ? -1 : 1);
            }
          }
          return Oa.index - Ua.index;
        }
        function Wf(Oa, Ua, ol, xl) {
          for (var jl = -1, Yl = Oa.length, sc = ol.length, ac = -1, gc = Ua.length, Fc = Uh(Yl - sc, 0), Ic = Tc(gc + Fc), Dc = !xl; ++ac < gc; )
            Ic[ac] = Ua[ac];
          for (; ++jl < sc; )
            (Dc || jl < Yl) && (Ic[ol[jl]] = Oa[jl]);
          for (; Fc--; )
            Ic[ac++] = Oa[jl++];
          return Ic;
        }
        function Zf(Oa, Ua, ol, xl) {
          for (var jl = -1, Yl = Oa.length, sc = -1, ac = ol.length, gc = -1, Fc = Ua.length, Ic = Uh(Yl - ac, 0), Dc = Tc(Ic + Fc), Uc = !xl; ++jl < Ic; )
            Dc[jl] = Oa[jl];
          for (var Gc = jl; ++gc < Fc; )
            Dc[Gc + gc] = Ua[gc];
          for (; ++sc < ac; )
            (Uc || jl < Yl) && (Dc[Gc + ol[sc]] = Oa[jl++]);
          return Dc;
        }
        function Xh(Oa, Ua) {
          var ol = -1, xl = Oa.length;
          for (Ua || (Ua = Tc(xl)); ++ol < xl; )
            Ua[ol] = Oa[ol];
          return Ua;
        }
        function bu(Oa, Ua, ol, xl) {
          var jl = !ol;
          ol || (ol = {});
          for (var Yl = -1, sc = Ua.length; ++Yl < sc; ) {
            var ac = Ua[Yl], gc = xl ? xl(ol[ac], Oa[ac], ac, ol, Oa) : Un;
            gc === Un && (gc = Oa[ac]), jl ? wu(ol, ac, gc) : b0(ol, ac, gc);
          }
          return ol;
        }
        function gm(Oa, Ua) {
          return bu(Oa, s1(Oa), Ua);
        }
        function mm(Oa, Ua) {
          return bu(Oa, sp(Oa), Ua);
        }
        function Y0(Oa, Ua) {
          return function(ol, xl) {
            var jl = qc(ol) ? _g : B2, Yl = Ua ? Ua() : {};
            return jl(ol, Oa, zc(xl, 2), Yl);
          };
        }
        function o0(Oa) {
          return vh(function(Ua, ol) {
            var xl = -1, jl = ol.length, Yl = jl > 1 ? ol[jl - 1] : Un, sc = jl > 2 ? ol[2] : Un;
            for (Yl = Oa.length > 3 && typeof Yl == "function" ? (jl--, Yl) : Un, sc && Wh(ol[0], ol[1], sc) && (Yl = jl < 3 ? Un : Yl, jl = 1), Ua = Th(Ua); ++xl < jl; ) {
              var ac = ol[xl];
              ac && Oa(Ua, ac, xl, Yl);
            }
            return Ua;
          });
        }
        function Xf(Oa, Ua) {
          return function(ol, xl) {
            if (ol == null)
              return ol;
            if (!Kh(ol))
              return Oa(ol, xl);
            for (var jl = ol.length, Yl = Ua ? jl : -1, sc = Th(ol); (Ua ? Yl-- : ++Yl < jl) && xl(sc[Yl], Yl, sc) !== !1; )
              ;
            return ol;
          };
        }
        function Kf(Oa) {
          return function(Ua, ol, xl) {
            for (var jl = -1, Yl = Th(Ua), sc = xl(Ua), ac = sc.length; ac--; ) {
              var gc = sc[Oa ? ac : ++jl];
              if (ol(Yl[gc], gc, Yl) === !1)
                break;
            }
            return Ua;
          };
        }
        function vm(Oa, Ua, ol) {
          var xl = Ua & Ma, jl = w0(Oa);
          function Yl() {
            var sc = this && this !== jh && this instanceof Yl ? jl : Oa;
            return sc.apply(xl ? ol : this, arguments);
          }
          return Yl;
        }
        function $f(Oa) {
          return function(Ua) {
            Ua = xh(Ua);
            var ol = Ju(Ua) ? fu(Ua) : Un, xl = ol ? ol[0] : Ua.charAt(0), jl = ol ? Nu(ol, 1).join("") : Ua.slice(1);
            return xl[Oa]() + jl;
          };
        }
        function a0(Oa) {
          return function(Ua) {
            return wd(Xp(Zp(Ua).replace(og, "")), Oa, "");
          };
        }
        function w0(Oa) {
          return function() {
            var Ua = arguments;
            switch (Ua.length) {
              case 0:
                return new Oa();
              case 1:
                return new Oa(Ua[0]);
              case 2:
                return new Oa(Ua[0], Ua[1]);
              case 3:
                return new Oa(Ua[0], Ua[1], Ua[2]);
              case 4:
                return new Oa(Ua[0], Ua[1], Ua[2], Ua[3]);
              case 5:
                return new Oa(Ua[0], Ua[1], Ua[2], Ua[3], Ua[4]);
              case 6:
                return new Oa(Ua[0], Ua[1], Ua[2], Ua[3], Ua[4], Ua[5]);
              case 7:
                return new Oa(Ua[0], Ua[1], Ua[2], Ua[3], Ua[4], Ua[5], Ua[6]);
            }
            var ol = s0(Oa.prototype), xl = Oa.apply(ol, Ua);
            return Dh(xl) ? xl : ol;
          };
        }
        function bm(Oa, Ua, ol) {
          var xl = w0(Oa);
          function jl() {
            for (var Yl = arguments.length, sc = Tc(Yl), ac = Yl, gc = l0(jl); ac--; )
              sc[ac] = arguments[ac];
            var Fc = Yl < 3 && sc[0] !== gc && sc[Yl - 1] !== gc ? [] : Ru(sc, gc);
            if (Yl -= Fc.length, Yl < ol)
              return ep(
                Oa,
                Ua,
                Q0,
                jl.placeholder,
                Un,
                sc,
                Fc,
                Un,
                Un,
                ol - Yl
              );
            var Ic = this && this !== jh && this instanceof jl ? xl : Oa;
            return Yh(Ic, this, sc);
          }
          return jl;
        }
        function qf(Oa) {
          return function(Ua, ol, xl) {
            var jl = Th(Ua);
            if (!Kh(Ua)) {
              var Yl = zc(ol, 3);
              Ua = Nh(Ua), ol = function(ac) {
                return Yl(jl[ac], ac, jl);
              };
            }
            var sc = Oa(Ua, ol, xl);
            return sc > -1 ? jl[Yl ? Ua[sc] : sc] : Un;
          };
        }
        function Yf(Oa) {
          return Eu(function(Ua) {
            var ol = Ua.length, xl = ol, jl = ou.prototype.thru;
            for (Oa && Ua.reverse(); xl--; ) {
              var Yl = Ua[xl];
              if (typeof Yl != "function")
                throw new su(pa);
              if (jl && !sc && rd(Yl) == "wrapper")
                var sc = new ou([], !0);
            }
            for (xl = sc ? xl : ol; ++xl < ol; ) {
              Yl = Ua[xl];
              var ac = rd(Yl), gc = ac == "wrapper" ? i1(Yl) : Un;
              gc && a1(gc[0]) && gc[1] == (qa | Na | Ja | tl) && !gc[4].length && gc[9] == 1 ? sc = sc[rd(gc[0])].apply(sc, gc[3]) : sc = Yl.length == 1 && a1(Yl) ? sc[ac]() : sc.thru(Yl);
            }
            return function() {
              var Fc = arguments, Ic = Fc[0];
              if (sc && Fc.length == 1 && qc(Ic))
                return sc.plant(Ic).value();
              for (var Dc = 0, Uc = ol ? Ua[Dc].apply(this, Fc) : Ic; ++Dc < ol; )
                Uc = Ua[Dc].call(this, Uc);
              return Uc;
            };
          });
        }
        function Q0(Oa, Ua, ol, xl, jl, Yl, sc, ac, gc, Fc) {
          var Ic = Ua & qa, Dc = Ua & Ma, Uc = Ua & ka, Gc = Ua & (Na | Ka), Vc = Ua & Qa, Jc = Uc ? Un : w0(Oa);
          function Wc() {
            for (var bh = arguments.length, _h = Tc(bh), tu = bh; tu--; )
              _h[tu] = arguments[tu];
            if (Gc)
              var Zh = l0(Wc), ru = Ig(_h, Zh);
            if (xl && (_h = Wf(_h, xl, jl, Gc)), Yl && (_h = Zf(_h, Yl, sc, Gc)), bh -= ru, Gc && bh < Fc) {
              var Rh = Ru(_h, Zh);
              return ep(
                Oa,
                Ua,
                Q0,
                Wc.placeholder,
                ol,
                _h,
                Rh,
                ac,
                gc,
                Fc - bh
              );
            }
            var mu = Dc ? ol : this, Iu = Uc ? mu[Oa] : Oa;
            return bh = _h.length, ac ? _h = Um(_h, ac) : Vc && bh > 1 && _h.reverse(), Ic && gc < bh && (_h.length = gc), this && this !== jh && this instanceof Wc && (Iu = Jc || w0(Iu)), Iu.apply(mu, _h);
          }
          return Wc;
        }
        function Qf(Oa, Ua) {
          return function(ol, xl) {
            return W2(ol, Oa, Ua(xl), {});
          };
        }
        function J0(Oa, Ua) {
          return function(ol, xl) {
            var jl;
            if (ol === Un && xl === Un)
              return Ua;
            if (ol !== Un && (jl = ol), xl !== Un) {
              if (jl === Un)
                return xl;
              typeof ol == "string" || typeof xl == "string" ? (ol = Jh(ol), xl = Jh(xl)) : (ol = Bf(ol), xl = Bf(xl)), jl = Oa(ol, xl);
            }
            return jl;
          };
        }
        function Jd(Oa) {
          return Eu(function(Ua) {
            return Ua = Ph(Ua, Qh(zc())), vh(function(ol) {
              var xl = this;
              return Oa(Ua, function(jl) {
                return Yh(jl, xl, ol);
              });
            });
          });
        }
        function ed(Oa, Ua) {
          Ua = Ua === Un ? " " : Jh(Ua);
          var ol = Ua.length;
          if (ol < 2)
            return ol ? Zd(Ua, Oa) : Ua;
          var xl = Zd(Ua, j0(Oa / e0(Ua)));
          return Ju(Ua) ? Nu(fu(xl), 0, Oa).join("") : xl.slice(0, Oa);
        }
        function Cm(Oa, Ua, ol, xl) {
          var jl = Ua & Ma, Yl = w0(Oa);
          function sc() {
            for (var ac = -1, gc = arguments.length, Fc = -1, Ic = xl.length, Dc = Tc(Ic + gc), Uc = this && this !== jh && this instanceof sc ? Yl : Oa; ++Fc < Ic; )
              Dc[Fc] = xl[Fc];
            for (; gc--; )
              Dc[Fc++] = arguments[++ac];
            return Yh(Uc, jl ? ol : this, Dc);
          }
          return sc;
        }
        function Jf(Oa) {
          return function(Ua, ol, xl) {
            return xl && typeof xl != "number" && Wh(Ua, ol, xl) && (ol = xl = Un), Ua = Fu(Ua), ol === Un ? (ol = Ua, Ua = 0) : ol = Fu(ol), xl = xl === Un ? Ua < ol ? 1 : -1 : Fu(xl), nm(Ua, ol, xl, Oa);
          };
        }
        function td(Oa) {
          return function(Ua, ol) {
            return typeof Ua == "string" && typeof ol == "string" || (Ua = hu(Ua), ol = hu(ol)), Oa(Ua, ol);
          };
        }
        function ep(Oa, Ua, ol, xl, jl, Yl, sc, ac, gc, Fc) {
          var Ic = Ua & Na, Dc = Ic ? sc : Un, Uc = Ic ? Un : sc, Gc = Ic ? Yl : Un, Vc = Ic ? Un : Yl;
          Ua |= Ic ? Ja : el, Ua &= ~(Ic ? el : Ja), Ua & Za || (Ua &= -4);
          var Jc = [
            Oa,
            Ua,
            jl,
            Gc,
            Dc,
            Vc,
            Uc,
            ac,
            gc,
            Fc
          ], Wc = ol.apply(Un, Jc);
          return a1(Oa) && dp(Wc, Jc), Wc.placeholder = xl, fp(Wc, Oa, Ua);
        }
        function e1(Oa) {
          var Ua = Bh[Oa];
          return function(ol, xl) {
            if (ol = hu(ol), xl = xl == null ? 0 : Hh(Qc(xl), 292), xl && ff(ol)) {
              var jl = (xh(ol) + "e").split("e"), Yl = Ua(jl[0] + "e" + (+jl[1] + xl));
              return jl = (xh(Yl) + "e").split("e"), +(jl[0] + "e" + (+jl[1] - xl));
            }
            return Ua(ol);
          };
        }
        var _m = i0 && 1 / P0(new i0([, -0]))[1] == dl ? function(Oa) {
          return new i0(Oa);
        } : x1;
        function tp(Oa) {
          return function(Ua) {
            var ol = zh(Ua);
            return ol == wl ? Pd(Ua) : ol == Ll ? kg(Ua) : Fg(Ua, Oa(Ua));
          };
        }
        function Tu(Oa, Ua, ol, xl, jl, Yl, sc, ac) {
          var gc = Ua & ka;
          if (!gc && typeof Oa != "function")
            throw new su(pa);
          var Fc = xl ? xl.length : 0;
          if (Fc || (Ua &= -97, xl = jl = Un), sc = sc === Un ? sc : Uh(Qc(sc), 0), ac = ac === Un ? ac : Qc(ac), Fc -= jl ? jl.length : 0, Ua & el) {
            var Ic = xl, Dc = jl;
            xl = jl = Un;
          }
          var Uc = gc ? Un : i1(Oa), Gc = [
            Oa,
            Ua,
            ol,
            xl,
            jl,
            Ic,
            Dc,
            Yl,
            sc,
            ac
          ];
          if (Uc && Mm(Gc, Uc), Oa = Gc[0], Ua = Gc[1], ol = Gc[2], xl = Gc[3], jl = Gc[4], ac = Gc[9] = Gc[9] === Un ? gc ? 0 : Oa.length : Uh(Gc[9] - Fc, 0), !ac && Ua & (Na | Ka) && (Ua &= -25), !Ua || Ua == Ma)
            var Vc = vm(Oa, Ua, ol);
          else Ua == Na || Ua == Ka ? Vc = bm(Oa, Ua, ac) : (Ua == Ja || Ua == (Ma | Ja)) && !jl.length ? Vc = Cm(Oa, Ua, ol, xl) : Vc = Q0.apply(Un, Gc);
          var Jc = Uc ? Mf : dp;
          return fp(Jc(Vc, Gc), Oa, Ua);
        }
        function rp(Oa, Ua, ol, xl) {
          return Oa === Un || gu(Oa, r0[ol]) && !wh.call(xl, ol) ? Ua : Oa;
        }
        function ip(Oa, Ua, ol, xl, jl, Yl) {
          return Dh(Oa) && Dh(Ua) && (Yl.set(Ua, Oa), K0(Oa, Ua, Un, ip, Yl), Yl.delete(Ua)), Oa;
        }
        function ym(Oa) {
          return S0(Oa) ? Un : Oa;
        }
        function np(Oa, Ua, ol, xl, jl, Yl) {
          var sc = ol & Ta, ac = Oa.length, gc = Ua.length;
          if (ac != gc && !(sc && gc > ac))
            return !1;
          var Fc = Yl.get(Oa), Ic = Yl.get(Ua);
          if (Fc && Ic)
            return Fc == Ua && Ic == Oa;
          var Dc = -1, Uc = !0, Gc = ol & Sa ? new Wu() : Un;
          for (Yl.set(Oa, Ua), Yl.set(Ua, Oa); ++Dc < ac; ) {
            var Vc = Oa[Dc], Jc = Ua[Dc];
            if (xl)
              var Wc = sc ? xl(Jc, Vc, Dc, Ua, Oa, Yl) : xl(Vc, Jc, Dc, Oa, Ua, Yl);
            if (Wc !== Un) {
              if (Wc)
                continue;
              Uc = !1;
              break;
            }
            if (Gc) {
              if (!Td(Ua, function(bh, _h) {
                if (!d0(Gc, _h) && (Vc === bh || jl(Vc, bh, ol, xl, Yl)))
                  return Gc.push(_h);
              })) {
                Uc = !1;
                break;
              }
            } else if (!(Vc === Jc || jl(Vc, Jc, ol, xl, Yl))) {
              Uc = !1;
              break;
            }
          }
          return Yl.delete(Oa), Yl.delete(Ua), Uc;
        }
        function xm(Oa, Ua, ol, xl, jl, Yl, sc) {
          switch (ol) {
            case hc:
              if (Oa.byteLength != Ua.byteLength || Oa.byteOffset != Ua.byteOffset)
                return !1;
              Oa = Oa.buffer, Ua = Ua.buffer;
            case Sc:
              return !(Oa.byteLength != Ua.byteLength || !Yl(new k0(Oa), new k0(Ua)));
            case zl:
            case Zl:
            case yl:
              return gu(+Oa, +Ua);
            case ul:
              return Oa.name == Ua.name && Oa.message == Ua.message;
            case Il:
            case tc:
              return Oa == Ua + "";
            case wl:
              var ac = Pd;
            case Ll:
              var gc = xl & Ta;
              if (ac || (ac = P0), Oa.size != Ua.size && !gc)
                return !1;
              var Fc = sc.get(Oa);
              if (Fc)
                return Fc == Ua;
              xl |= Sa, sc.set(Oa, Ua);
              var Ic = np(ac(Oa), ac(Ua), xl, jl, Yl, sc);
              return sc.delete(Oa), Ic;
            case nc:
              if (v0)
                return v0.call(Oa) == v0.call(Ua);
          }
          return !1;
        }
        function wm(Oa, Ua, ol, xl, jl, Yl) {
          var sc = ol & Ta, ac = t1(Oa), gc = ac.length, Fc = t1(Ua), Ic = Fc.length;
          if (gc != Ic && !sc)
            return !1;
          for (var Dc = gc; Dc--; ) {
            var Uc = ac[Dc];
            if (!(sc ? Uc in Ua : wh.call(Ua, Uc)))
              return !1;
          }
          var Gc = Yl.get(Oa), Vc = Yl.get(Ua);
          if (Gc && Vc)
            return Gc == Ua && Vc == Oa;
          var Jc = !0;
          Yl.set(Oa, Ua), Yl.set(Ua, Oa);
          for (var Wc = sc; ++Dc < gc; ) {
            Uc = ac[Dc];
            var bh = Oa[Uc], _h = Ua[Uc];
            if (xl)
              var tu = sc ? xl(_h, bh, Uc, Ua, Oa, Yl) : xl(bh, _h, Uc, Oa, Ua, Yl);
            if (!(tu === Un ? bh === _h || jl(bh, _h, ol, xl, Yl) : tu)) {
              Jc = !1;
              break;
            }
            Wc || (Wc = Uc == "constructor");
          }
          if (Jc && !Wc) {
            var Zh = Oa.constructor, ru = Ua.constructor;
            Zh != ru && "constructor" in Oa && "constructor" in Ua && !(typeof Zh == "function" && Zh instanceof Zh && typeof ru == "function" && ru instanceof ru) && (Jc = !1);
          }
          return Yl.delete(Oa), Yl.delete(Ua), Jc;
        }
        function Eu(Oa) {
          return c1(hp(Oa, Un, Cp), Oa + "");
        }
        function t1(Oa) {
          return Tf(Oa, Nh, s1);
        }
        function r1(Oa) {
          return Tf(Oa, $h, sp);
        }
        var i1 = H0 ? function(Oa) {
          return H0.get(Oa);
        } : x1;
        function rd(Oa) {
          for (var Ua = Oa.name + "", ol = n0[Ua], xl = wh.call(n0, Ua) ? ol.length : 0; xl--; ) {
            var jl = ol[xl], Yl = jl.func;
            if (Yl == null || Yl == Oa)
              return jl.name;
          }
          return Ua;
        }
        function l0(Oa) {
          var Ua = wh.call($l, "placeholder") ? $l : Oa;
          return Ua.placeholder;
        }
        function zc() {
          var Oa = $l.iteratee || _1;
          return Oa = Oa === _1 ? Af : Oa, arguments.length ? Oa(arguments[0], arguments[1]) : Oa;
        }
        function id(Oa, Ua) {
          var ol = Oa.__data__;
          return Dm(Ua) ? ol[typeof Ua == "string" ? "string" : "hash"] : ol.map;
        }
        function n1(Oa) {
          for (var Ua = Nh(Oa), ol = Ua.length; ol--; ) {
            var xl = Ua[ol], jl = Oa[xl];
            Ua[ol] = [xl, jl, lp(jl)];
          }
          return Ua;
        }
        function Ku(Oa, Ua) {
          var ol = Og(Oa, Ua);
          return Sf(ol) ? ol : Un;
        }
        function Tm(Oa) {
          var Ua = wh.call(Oa, zu), ol = Oa[zu];
          try {
            Oa[zu] = Un;
            var xl = !0;
          } catch {
          }
          var jl = R0.call(Oa);
          return xl && (Ua ? Oa[zu] = ol : delete Oa[zu]), jl;
        }
        var s1 = Ld ? function(Oa) {
          return Oa == null ? [] : (Oa = Th(Oa), Lu(Ld(Oa), function(Ua) {
            return uf.call(Oa, Ua);
          }));
        } : w1, sp = Ld ? function(Oa) {
          for (var Ua = []; Oa; )
            Ou(Ua, s1(Oa)), Oa = B0(Oa);
          return Ua;
        } : w1, zh = Vh;
        (Od && zh(new Od(new ArrayBuffer(1))) != hc || p0 && zh(new p0()) != wl || Rd && zh(Rd.resolve()) != hl || i0 && zh(new i0()) != Ll || g0 && zh(new g0()) != _c) && (zh = function(Oa) {
          var Ua = Vh(Oa), ol = Ua == Ul ? Oa.constructor : Un, xl = ol ? $u(ol) : "";
          if (xl)
            switch (xl) {
              case s2:
                return hc;
              case o2:
                return wl;
              case a2:
                return hl;
              case l2:
                return Ll;
              case c2:
                return _c;
            }
          return Ua;
        });
        function Em(Oa, Ua, ol) {
          for (var xl = -1, jl = ol.length; ++xl < jl; ) {
            var Yl = ol[xl], sc = Yl.size;
            switch (Yl.type) {
              case "drop":
                Oa += sc;
                break;
              case "dropRight":
                Ua -= sc;
                break;
              case "take":
                Ua = Hh(Ua, Oa + sc);
                break;
              case "takeRight":
                Oa = Uh(Oa, Ua - sc);
                break;
            }
          }
          return { start: Oa, end: Ua };
        }
        function Sm(Oa) {
          var Ua = Oa.match(Wl);
          return Ua ? Ua[1].split(ic) : [];
        }
        function op(Oa, Ua, ol) {
          Ua = Uu(Ua, Oa);
          for (var xl = -1, jl = Ua.length, Yl = !1; ++xl < jl; ) {
            var sc = Cu(Ua[xl]);
            if (!(Yl = Oa != null && ol(Oa, sc)))
              break;
            Oa = Oa[sc];
          }
          return Yl || ++xl != jl ? Yl : (jl = Oa == null ? 0 : Oa.length, !!jl && hd(jl) && Su(sc, jl) && (qc(Oa) || qu(Oa)));
        }
        function Am(Oa) {
          var Ua = Oa.length, ol = new Oa.constructor(Ua);
          return Ua && typeof Oa[0] == "string" && wh.call(Oa, "index") && (ol.index = Oa.index, ol.input = Oa.input), ol;
        }
        function ap(Oa) {
          return typeof Oa.constructor == "function" && !T0(Oa) ? s0(B0(Oa)) : {};
        }
        function Fm(Oa, Ua, ol) {
          var xl = Oa.constructor;
          switch (Ua) {
            case Sc:
              return Qd(Oa);
            case zl:
            case Zl:
              return new xl(+Oa);
            case hc:
              return um(Oa, ol);
            case Lc:
            case Ec:
            case Hl:
            case fc:
            case lc:
            case Gl:
            case ql:
            case Vl:
            case Pl:
              return zf(Oa, ol);
            case wl:
              return new xl();
            case yl:
            case tc:
              return new xl(Oa);
            case Il:
              return dm(Oa);
            case Ll:
              return new xl();
            case nc:
              return fm(Oa);
          }
        }
        function Im(Oa, Ua) {
          var ol = Ua.length;
          if (!ol)
            return Oa;
          var xl = ol - 1;
          return Ua[xl] = (ol > 1 ? "& " : "") + Ua[xl], Ua = Ua.join(ol > 2 ? ", " : " "), Oa.replace(mh, `{
/* [wrapped with ` + Ua + `] */
`);
        }
        function Pm(Oa) {
          return qc(Oa) || qu(Oa) || !!(df && Oa && Oa[df]);
        }
        function Su(Oa, Ua) {
          var ol = typeof Oa;
          return Ua = Ua ?? El, !!Ua && (ol == "number" || ol != "symbol" && Oc.test(Oa)) && Oa > -1 && Oa % 1 == 0 && Oa < Ua;
        }
        function Wh(Oa, Ua, ol) {
          if (!Dh(ol))
            return !1;
          var xl = typeof Ua;
          return (xl == "number" ? Kh(ol) && Su(Ua, ol.length) : xl == "string" && Ua in ol) ? gu(ol[Ua], Oa) : !1;
        }
        function o1(Oa, Ua) {
          if (qc(Oa))
            return !1;
          var ol = typeof Oa;
          return ol == "number" || ol == "symbol" || ol == "boolean" || Oa == null || eu(Oa) ? !0 : Pc.test(Oa) || !vc.test(Oa) || Ua != null && Oa in Th(Ua);
        }
        function Dm(Oa) {
          var Ua = typeof Oa;
          return Ua == "string" || Ua == "number" || Ua == "symbol" || Ua == "boolean" ? Oa !== "__proto__" : Oa === null;
        }
        function a1(Oa) {
          var Ua = rd(Oa), ol = $l[Ua];
          if (typeof ol != "function" || !(Ua in Ch.prototype))
            return !1;
          if (Oa === ol)
            return !0;
          var xl = i1(ol);
          return !!xl && Oa === xl[0];
        }
        function Lm(Oa) {
          return !!lf && lf in Oa;
        }
        var Om = L0 ? Au : T1;
        function T0(Oa) {
          var Ua = Oa && Oa.constructor, ol = typeof Ua == "function" && Ua.prototype || r0;
          return Oa === ol;
        }
        function lp(Oa) {
          return Oa === Oa && !Dh(Oa);
        }
        function cp(Oa, Ua) {
          return function(ol) {
            return ol == null ? !1 : ol[Oa] === Ua && (Ua !== Un || Oa in Th(ol));
          };
        }
        function Rm(Oa) {
          var Ua = ld(Oa, function(xl) {
            return ol.size === ba && ol.clear(), xl;
          }), ol = Ua.cache;
          return Ua;
        }
        function Mm(Oa, Ua) {
          var ol = Oa[1], xl = Ua[1], jl = ol | xl, Yl = jl < (Ma | ka | qa), sc = xl == qa && ol == Na || xl == qa && ol == tl && Oa[7].length <= Ua[8] || xl == (qa | tl) && Ua[7].length <= Ua[8] && ol == Na;
          if (!(Yl || sc))
            return Oa;
          xl & Ma && (Oa[2] = Ua[2], jl |= ol & Ma ? 0 : Za);
          var ac = Ua[3];
          if (ac) {
            var gc = Oa[3];
            Oa[3] = gc ? Wf(gc, ac, Ua[4]) : ac, Oa[4] = gc ? Ru(Oa[3], _a) : Ua[4];
          }
          return ac = Ua[5], ac && (gc = Oa[5], Oa[5] = gc ? Zf(gc, ac, Ua[6]) : ac, Oa[6] = gc ? Ru(Oa[5], _a) : Ua[6]), ac = Ua[7], ac && (Oa[7] = ac), xl & qa && (Oa[8] = Oa[8] == null ? Ua[8] : Hh(Oa[8], Ua[8])), Oa[9] == null && (Oa[9] = Ua[9]), Oa[0] = Ua[0], Oa[1] = jl, Oa;
        }
        function km(Oa) {
          var Ua = [];
          if (Oa != null)
            for (var ol in Th(Oa))
              Ua.push(ol);
          return Ua;
        }
        function Bm(Oa) {
          return R0.call(Oa);
        }
        function hp(Oa, Ua, ol) {
          return Ua = Uh(Ua === Un ? Oa.length - 1 : Ua, 0), function() {
            for (var xl = arguments, jl = -1, Yl = Uh(xl.length - Ua, 0), sc = Tc(Yl); ++jl < Yl; )
              sc[jl] = xl[Ua + jl];
            jl = -1;
            for (var ac = Tc(Ua + 1); ++jl < Ua; )
              ac[jl] = xl[jl];
            return ac[Ua] = ol(sc), Yh(Oa, this, ac);
          };
        }
        function up(Oa, Ua) {
          return Ua.length < 2 ? Oa : Xu(Oa, lu(Ua, 0, -1));
        }
        function Um(Oa, Ua) {
          for (var ol = Oa.length, xl = Hh(Ua.length, ol), jl = Xh(Oa); xl--; ) {
            var Yl = Ua[xl];
            Oa[xl] = Su(Yl, ol) ? jl[Yl] : Un;
          }
          return Oa;
        }
        function l1(Oa, Ua) {
          if (!(Ua === "constructor" && typeof Oa[Ua] == "function") && Ua != "__proto__")
            return Oa[Ua];
        }
        var dp = pp(Mf), E0 = Qg || function(Oa, Ua) {
          return jh.setTimeout(Oa, Ua);
        }, c1 = pp(am);
        function fp(Oa, Ua, ol) {
          var xl = Ua + "";
          return c1(Oa, Im(xl, Nm(Sm(xl), ol)));
        }
        function pp(Oa) {
          var Ua = 0, ol = 0;
          return function() {
            var xl = r2(), jl = cl - (xl - ol);
            if (ol = xl, jl > 0) {
              if (++Ua >= il)
                return arguments[0];
            } else
              Ua = 0;
            return Oa.apply(Un, arguments);
          };
        }
        function nd(Oa, Ua) {
          var ol = -1, xl = Oa.length, jl = xl - 1;
          for (Ua = Ua === Un ? xl : Ua; ++ol < Ua; ) {
            var Yl = Wd(ol, jl), sc = Oa[Yl];
            Oa[Yl] = Oa[ol], Oa[ol] = sc;
          }
          return Oa.length = Ua, Oa;
        }
        var gp = Rm(function(Oa) {
          var Ua = [];
          return Oa.charCodeAt(0) === 46 && Ua.push(""), Oa.replace(Hc, function(ol, xl, jl, Yl) {
            Ua.push(jl ? Yl.replace(ec, "$1") : xl || ol);
          }), Ua;
        });
        function Cu(Oa) {
          if (typeof Oa == "string" || eu(Oa))
            return Oa;
          var Ua = Oa + "";
          return Ua == "0" && 1 / Oa == -1 / 0 ? "-0" : Ua;
        }
        function $u(Oa) {
          if (Oa != null) {
            try {
              return O0.call(Oa);
            } catch {
            }
            try {
              return Oa + "";
            } catch {
            }
          }
          return "";
        }
        function Nm(Oa, Ua) {
          return nu(_l, function(ol) {
            var xl = "_." + ol[0];
            Ua & ol[1] && !F0(Oa, xl) && Oa.push(xl);
          }), Oa.sort();
        }
        function mp(Oa) {
          if (Oa instanceof Ch)
            return Oa.clone();
          var Ua = new ou(Oa.__wrapped__, Oa.__chain__);
          return Ua.__actions__ = Xh(Oa.__actions__), Ua.__index__ = Oa.__index__, Ua.__values__ = Oa.__values__, Ua;
        }
        function jm(Oa, Ua, ol) {
          (ol ? Wh(Oa, Ua, ol) : Ua === Un) ? Ua = 1 : Ua = Uh(Qc(Ua), 0);
          var xl = Oa == null ? 0 : Oa.length;
          if (!xl || Ua < 1)
            return [];
          for (var jl = 0, Yl = 0, sc = Tc(j0(xl / Ua)); jl < xl; )
            sc[Yl++] = lu(Oa, jl, jl += Ua);
          return sc;
        }
        function Gm(Oa) {
          for (var Ua = -1, ol = Oa == null ? 0 : Oa.length, xl = 0, jl = []; ++Ua < ol; ) {
            var Yl = Oa[Ua];
            Yl && (jl[xl++] = Yl);
          }
          return jl;
        }
        function Hm() {
          var Oa = arguments.length;
          if (!Oa)
            return [];
          for (var Ua = Tc(Oa - 1), ol = arguments[0], xl = Oa; xl--; )
            Ua[xl - 1] = arguments[xl];
          return Ou(qc(ol) ? Xh(ol) : [ol], Gh(Ua, 1));
        }
        var zm = vh(function(Oa, Ua) {
          return Oh(Oa) ? C0(Oa, Gh(Ua, 1, Oh, !0)) : [];
        }), Vm = vh(function(Oa, Ua) {
          var ol = cu(Ua);
          return Oh(ol) && (ol = Un), Oh(Oa) ? C0(Oa, Gh(Ua, 1, Oh, !0), zc(ol, 2)) : [];
        }), Wm = vh(function(Oa, Ua) {
          var ol = cu(Ua);
          return Oh(ol) && (ol = Un), Oh(Oa) ? C0(Oa, Gh(Ua, 1, Oh, !0), Un, ol) : [];
        });
        function Zm(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          return xl ? (Ua = ol || Ua === Un ? 1 : Qc(Ua), lu(Oa, Ua < 0 ? 0 : Ua, xl)) : [];
        }
        function Xm(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          return xl ? (Ua = ol || Ua === Un ? 1 : Qc(Ua), Ua = xl - Ua, lu(Oa, 0, Ua < 0 ? 0 : Ua)) : [];
        }
        function Km(Oa, Ua) {
          return Oa && Oa.length ? q0(Oa, zc(Ua, 3), !0, !0) : [];
        }
        function $m(Oa, Ua) {
          return Oa && Oa.length ? q0(Oa, zc(Ua, 3), !0) : [];
        }
        function qm(Oa, Ua, ol, xl) {
          var jl = Oa == null ? 0 : Oa.length;
          return jl ? (ol && typeof ol != "number" && Wh(Oa, Ua, ol) && (ol = 0, xl = jl), G2(Oa, Ua, ol, xl)) : [];
        }
        function vp(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          if (!xl)
            return -1;
          var jl = ol == null ? 0 : Qc(ol);
          return jl < 0 && (jl = Uh(xl + jl, 0)), I0(Oa, zc(Ua, 3), jl);
        }
        function bp(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          if (!xl)
            return -1;
          var jl = xl - 1;
          return ol !== Un && (jl = Qc(ol), jl = ol < 0 ? Uh(xl + jl, 0) : Hh(jl, xl - 1)), I0(Oa, zc(Ua, 3), jl, !0);
        }
        function Cp(Oa) {
          var Ua = Oa == null ? 0 : Oa.length;
          return Ua ? Gh(Oa, 1) : [];
        }
        function Ym(Oa) {
          var Ua = Oa == null ? 0 : Oa.length;
          return Ua ? Gh(Oa, dl) : [];
        }
        function Qm(Oa, Ua) {
          var ol = Oa == null ? 0 : Oa.length;
          return ol ? (Ua = Ua === Un ? 1 : Qc(Ua), Gh(Oa, Ua)) : [];
        }
        function Jm(Oa) {
          for (var Ua = -1, ol = Oa == null ? 0 : Oa.length, xl = {}; ++Ua < ol; ) {
            var jl = Oa[Ua];
            xl[jl[0]] = jl[1];
          }
          return xl;
        }
        function _p(Oa) {
          return Oa && Oa.length ? Oa[0] : Un;
        }
        function e3(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          if (!xl)
            return -1;
          var jl = ol == null ? 0 : Qc(ol);
          return jl < 0 && (jl = Uh(xl + jl, 0)), Qu(Oa, Ua, jl);
        }
        function t3(Oa) {
          var Ua = Oa == null ? 0 : Oa.length;
          return Ua ? lu(Oa, 0, -1) : [];
        }
        var r3 = vh(function(Oa) {
          var Ua = Ph(Oa, qd);
          return Ua.length && Ua[0] === Oa[0] ? jd(Ua) : [];
        }), i3 = vh(function(Oa) {
          var Ua = cu(Oa), ol = Ph(Oa, qd);
          return Ua === cu(ol) ? Ua = Un : ol.pop(), ol.length && ol[0] === Oa[0] ? jd(ol, zc(Ua, 2)) : [];
        }), n3 = vh(function(Oa) {
          var Ua = cu(Oa), ol = Ph(Oa, qd);
          return Ua = typeof Ua == "function" ? Ua : Un, Ua && ol.pop(), ol.length && ol[0] === Oa[0] ? jd(ol, Un, Ua) : [];
        });
        function s3(Oa, Ua) {
          return Oa == null ? "" : e2.call(Oa, Ua);
        }
        function cu(Oa) {
          var Ua = Oa == null ? 0 : Oa.length;
          return Ua ? Oa[Ua - 1] : Un;
        }
        function o3(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          if (!xl)
            return -1;
          var jl = xl;
          return ol !== Un && (jl = Qc(ol), jl = jl < 0 ? Uh(xl + jl, 0) : Hh(jl, xl - 1)), Ua === Ua ? Ug(Oa, Ua, jl) : I0(Oa, J1, jl, !0);
        }
        function a3(Oa, Ua) {
          return Oa && Oa.length ? Df(Oa, Qc(Ua)) : Un;
        }
        var l3 = vh(yp);
        function yp(Oa, Ua) {
          return Oa && Oa.length && Ua && Ua.length ? Vd(Oa, Ua) : Oa;
        }
        function c3(Oa, Ua, ol) {
          return Oa && Oa.length && Ua && Ua.length ? Vd(Oa, Ua, zc(ol, 2)) : Oa;
        }
        function h3(Oa, Ua, ol) {
          return Oa && Oa.length && Ua && Ua.length ? Vd(Oa, Ua, Un, ol) : Oa;
        }
        var u3 = Eu(function(Oa, Ua) {
          var ol = Oa == null ? 0 : Oa.length, xl = kd(Oa, Ua);
          return Rf(Oa, Ph(Ua, function(jl) {
            return Su(jl, ol) ? +jl : jl;
          }).sort(Vf)), xl;
        });
        function d3(Oa, Ua) {
          var ol = [];
          if (!(Oa && Oa.length))
            return ol;
          var xl = -1, jl = [], Yl = Oa.length;
          for (Ua = zc(Ua, 3); ++xl < Yl; ) {
            var sc = Oa[xl];
            Ua(sc, xl, Oa) && (ol.push(sc), jl.push(xl));
          }
          return Rf(Oa, jl), ol;
        }
        function h1(Oa) {
          return Oa == null ? Oa : n2.call(Oa);
        }
        function f3(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          return xl ? (ol && typeof ol != "number" && Wh(Oa, Ua, ol) ? (Ua = 0, ol = xl) : (Ua = Ua == null ? 0 : Qc(Ua), ol = ol === Un ? xl : Qc(ol)), lu(Oa, Ua, ol)) : [];
        }
        function p3(Oa, Ua) {
          return $0(Oa, Ua);
        }
        function g3(Oa, Ua, ol) {
          return Xd(Oa, Ua, zc(ol, 2));
        }
        function m3(Oa, Ua) {
          var ol = Oa == null ? 0 : Oa.length;
          if (ol) {
            var xl = $0(Oa, Ua);
            if (xl < ol && gu(Oa[xl], Ua))
              return xl;
          }
          return -1;
        }
        function v3(Oa, Ua) {
          return $0(Oa, Ua, !0);
        }
        function b3(Oa, Ua, ol) {
          return Xd(Oa, Ua, zc(ol, 2), !0);
        }
        function C3(Oa, Ua) {
          var ol = Oa == null ? 0 : Oa.length;
          if (ol) {
            var xl = $0(Oa, Ua, !0) - 1;
            if (gu(Oa[xl], Ua))
              return xl;
          }
          return -1;
        }
        function _3(Oa) {
          return Oa && Oa.length ? kf(Oa) : [];
        }
        function y3(Oa, Ua) {
          return Oa && Oa.length ? kf(Oa, zc(Ua, 2)) : [];
        }
        function x3(Oa) {
          var Ua = Oa == null ? 0 : Oa.length;
          return Ua ? lu(Oa, 1, Ua) : [];
        }
        function w3(Oa, Ua, ol) {
          return Oa && Oa.length ? (Ua = ol || Ua === Un ? 1 : Qc(Ua), lu(Oa, 0, Ua < 0 ? 0 : Ua)) : [];
        }
        function T3(Oa, Ua, ol) {
          var xl = Oa == null ? 0 : Oa.length;
          return xl ? (Ua = ol || Ua === Un ? 1 : Qc(Ua), Ua = xl - Ua, lu(Oa, Ua < 0 ? 0 : Ua, xl)) : [];
        }
        function E3(Oa, Ua) {
          return Oa && Oa.length ? q0(Oa, zc(Ua, 3), !1, !0) : [];
        }
        function S3(Oa, Ua) {
          return Oa && Oa.length ? q0(Oa, zc(Ua, 3)) : [];
        }
        var A3 = vh(function(Oa) {
          return Bu(Gh(Oa, 1, Oh, !0));
        }), F3 = vh(function(Oa) {
          var Ua = cu(Oa);
          return Oh(Ua) && (Ua = Un), Bu(Gh(Oa, 1, Oh, !0), zc(Ua, 2));
        }), I3 = vh(function(Oa) {
          var Ua = cu(Oa);
          return Ua = typeof Ua == "function" ? Ua : Un, Bu(Gh(Oa, 1, Oh, !0), Un, Ua);
        });
        function P3(Oa) {
          return Oa && Oa.length ? Bu(Oa) : [];
        }
        function D3(Oa, Ua) {
          return Oa && Oa.length ? Bu(Oa, zc(Ua, 2)) : [];
        }
        function L3(Oa, Ua) {
          return Ua = typeof Ua == "function" ? Ua : Un, Oa && Oa.length ? Bu(Oa, Un, Ua) : [];
        }
        function u1(Oa) {
          if (!(Oa && Oa.length))
            return [];
          var Ua = 0;
          return Oa = Lu(Oa, function(ol) {
            if (Oh(ol))
              return Ua = Uh(ol.length, Ua), !0;
          }), Fd(Ua, function(ol) {
            return Ph(Oa, Ed(ol));
          });
        }
        function xp(Oa, Ua) {
          if (!(Oa && Oa.length))
            return [];
          var ol = u1(Oa);
          return Ua == null ? ol : Ph(ol, function(xl) {
            return Yh(Ua, Un, xl);
          });
        }
        var O3 = vh(function(Oa, Ua) {
          return Oh(Oa) ? C0(Oa, Ua) : [];
        }), R3 = vh(function(Oa) {
          return $d(Lu(Oa, Oh));
        }), M3 = vh(function(Oa) {
          var Ua = cu(Oa);
          return Oh(Ua) && (Ua = Un), $d(Lu(Oa, Oh), zc(Ua, 2));
        }), k3 = vh(function(Oa) {
          var Ua = cu(Oa);
          return Ua = typeof Ua == "function" ? Ua : Un, $d(Lu(Oa, Oh), Un, Ua);
        }), B3 = vh(u1);
        function U3(Oa, Ua) {
          return jf(Oa || [], Ua || [], b0);
        }
        function N3(Oa, Ua) {
          return jf(Oa || [], Ua || [], x0);
        }
        var j3 = vh(function(Oa) {
          var Ua = Oa.length, ol = Ua > 1 ? Oa[Ua - 1] : Un;
          return ol = typeof ol == "function" ? (Oa.pop(), ol) : Un, xp(Oa, ol);
        });
        function wp(Oa) {
          var Ua = $l(Oa);
          return Ua.__chain__ = !0, Ua;
        }
        function G3(Oa, Ua) {
          return Ua(Oa), Oa;
        }
        function sd(Oa, Ua) {
          return Ua(Oa);
        }
        var H3 = Eu(function(Oa) {
          var Ua = Oa.length, ol = Ua ? Oa[0] : 0, xl = this.__wrapped__, jl = function(Yl) {
            return kd(Yl, Oa);
          };
          return Ua > 1 || this.__actions__.length || !(xl instanceof Ch) || !Su(ol) ? this.thru(jl) : (xl = xl.slice(ol, +ol + (Ua ? 1 : 0)), xl.__actions__.push({
            func: sd,
            args: [jl],
            thisArg: Un
          }), new ou(xl, this.__chain__).thru(function(Yl) {
            return Ua && !Yl.length && Yl.push(Un), Yl;
          }));
        });
        function z3() {
          return wp(this);
        }
        function V3() {
          return new ou(this.value(), this.__chain__);
        }
        function W3() {
          this.__values__ === Un && (this.__values__ = Bp(this.value()));
          var Oa = this.__index__ >= this.__values__.length, Ua = Oa ? Un : this.__values__[this.__index__++];
          return { done: Oa, value: Ua };
        }
        function Z3() {
          return this;
        }
        function X3(Oa) {
          for (var Ua, ol = this; ol instanceof V0; ) {
            var xl = mp(ol);
            xl.__index__ = 0, xl.__values__ = Un, Ua ? jl.__wrapped__ = xl : Ua = xl;
            var jl = xl;
            ol = ol.__wrapped__;
          }
          return jl.__wrapped__ = Oa, Ua;
        }
        function K3() {
          var Oa = this.__wrapped__;
          if (Oa instanceof Ch) {
            var Ua = Oa;
            return this.__actions__.length && (Ua = new Ch(this)), Ua = Ua.reverse(), Ua.__actions__.push({
              func: sd,
              args: [h1],
              thisArg: Un
            }), new ou(Ua, this.__chain__);
          }
          return this.thru(h1);
        }
        function $3() {
          return Nf(this.__wrapped__, this.__actions__);
        }
        var q3 = Y0(function(Oa, Ua, ol) {
          wh.call(Oa, ol) ? ++Oa[ol] : wu(Oa, ol, 1);
        });
        function Y3(Oa, Ua, ol) {
          var xl = qc(Oa) ? Y1 : j2;
          return ol && Wh(Oa, Ua, ol) && (Ua = Un), xl(Oa, zc(Ua, 3));
        }
        function Q3(Oa, Ua) {
          var ol = qc(Oa) ? Lu : xf;
          return ol(Oa, zc(Ua, 3));
        }
        var J3 = qf(vp), e5 = qf(bp);
        function t5(Oa, Ua) {
          return Gh(od(Oa, Ua), 1);
        }
        function r5(Oa, Ua) {
          return Gh(od(Oa, Ua), dl);
        }
        function i5(Oa, Ua, ol) {
          return ol = ol === Un ? 1 : Qc(ol), Gh(od(Oa, Ua), ol);
        }
        function Tp(Oa, Ua) {
          var ol = qc(Oa) ? nu : ku;
          return ol(Oa, zc(Ua, 3));
        }
        function Ep(Oa, Ua) {
          var ol = qc(Oa) ? yg : yf;
          return ol(Oa, zc(Ua, 3));
        }
        var n5 = Y0(function(Oa, Ua, ol) {
          wh.call(Oa, ol) ? Oa[ol].push(Ua) : wu(Oa, ol, [Ua]);
        });
        function s5(Oa, Ua, ol, xl) {
          Oa = Kh(Oa) ? Oa : h0(Oa), ol = ol && !xl ? Qc(ol) : 0;
          var jl = Oa.length;
          return ol < 0 && (ol = Uh(jl + ol, 0)), ud(Oa) ? ol <= jl && Oa.indexOf(Ua, ol) > -1 : !!jl && Qu(Oa, Ua, ol) > -1;
        }
        var o5 = vh(function(Oa, Ua, ol) {
          var xl = -1, jl = typeof Ua == "function", Yl = Kh(Oa) ? Tc(Oa.length) : [];
          return ku(Oa, function(sc) {
            Yl[++xl] = jl ? Yh(Ua, sc, ol) : _0(sc, Ua, ol);
          }), Yl;
        }), a5 = Y0(function(Oa, Ua, ol) {
          wu(Oa, ol, Ua);
        });
        function od(Oa, Ua) {
          var ol = qc(Oa) ? Ph : Ff;
          return ol(Oa, zc(Ua, 3));
        }
        function l5(Oa, Ua, ol, xl) {
          return Oa == null ? [] : (qc(Ua) || (Ua = Ua == null ? [] : [Ua]), ol = xl ? Un : ol, qc(ol) || (ol = ol == null ? [] : [ol]), Lf(Oa, Ua, ol));
        }
        var c5 = Y0(function(Oa, Ua, ol) {
          Oa[ol ? 0 : 1].push(Ua);
        }, function() {
          return [[], []];
        });
        function h5(Oa, Ua, ol) {
          var xl = qc(Oa) ? wd : tf, jl = arguments.length < 3;
          return xl(Oa, zc(Ua, 4), ol, jl, ku);
        }
        function u5(Oa, Ua, ol) {
          var xl = qc(Oa) ? xg : tf, jl = arguments.length < 3;
          return xl(Oa, zc(Ua, 4), ol, jl, yf);
        }
        function d5(Oa, Ua) {
          var ol = qc(Oa) ? Lu : xf;
          return ol(Oa, cd(zc(Ua, 3)));
        }
        function f5(Oa) {
          var Ua = qc(Oa) ? vf : sm;
          return Ua(Oa);
        }
        function p5(Oa, Ua, ol) {
          (ol ? Wh(Oa, Ua, ol) : Ua === Un) ? Ua = 1 : Ua = Qc(Ua);
          var xl = qc(Oa) ? M2 : om;
          return xl(Oa, Ua);
        }
        function g5(Oa) {
          var Ua = qc(Oa) ? k2 : lm;
          return Ua(Oa);
        }
        function m5(Oa) {
          if (Oa == null)
            return 0;
          if (Kh(Oa))
            return ud(Oa) ? e0(Oa) : Oa.length;
          var Ua = zh(Oa);
          return Ua == wl || Ua == Ll ? Oa.size : Hd(Oa).length;
        }
        function v5(Oa, Ua, ol) {
          var xl = qc(Oa) ? Td : cm;
          return ol && Wh(Oa, Ua, ol) && (Ua = Un), xl(Oa, zc(Ua, 3));
        }
        var b5 = vh(function(Oa, Ua) {
          if (Oa == null)
            return [];
          var ol = Ua.length;
          return ol > 1 && Wh(Oa, Ua[0], Ua[1]) ? Ua = [] : ol > 2 && Wh(Ua[0], Ua[1], Ua[2]) && (Ua = [Ua[0]]), Lf(Oa, Gh(Ua, 1), []);
        }), ad = Yg || function() {
          return jh.Date.now();
        };
        function C5(Oa, Ua) {
          if (typeof Ua != "function")
            throw new su(pa);
          return Oa = Qc(Oa), function() {
            if (--Oa < 1)
              return Ua.apply(this, arguments);
          };
        }
        function Sp(Oa, Ua, ol) {
          return Ua = ol ? Un : Ua, Ua = Oa && Ua == null ? Oa.length : Ua, Tu(Oa, qa, Un, Un, Un, Un, Ua);
        }
        function Ap(Oa, Ua) {
          var ol;
          if (typeof Ua != "function")
            throw new su(pa);
          return Oa = Qc(Oa), function() {
            return --Oa > 0 && (ol = Ua.apply(this, arguments)), Oa <= 1 && (Ua = Un), ol;
          };
        }
        var d1 = vh(function(Oa, Ua, ol) {
          var xl = Ma;
          if (ol.length) {
            var jl = Ru(ol, l0(d1));
            xl |= Ja;
          }
          return Tu(Oa, xl, Ua, ol, jl);
        }), Fp = vh(function(Oa, Ua, ol) {
          var xl = Ma | ka;
          if (ol.length) {
            var jl = Ru(ol, l0(Fp));
            xl |= Ja;
          }
          return Tu(Ua, xl, Oa, ol, jl);
        });
        function Ip(Oa, Ua, ol) {
          Ua = ol ? Un : Ua;
          var xl = Tu(Oa, Na, Un, Un, Un, Un, Un, Ua);
          return xl.placeholder = Ip.placeholder, xl;
        }
        function Pp(Oa, Ua, ol) {
          Ua = ol ? Un : Ua;
          var xl = Tu(Oa, Ka, Un, Un, Un, Un, Un, Ua);
          return xl.placeholder = Pp.placeholder, xl;
        }
        function Dp(Oa, Ua, ol) {
          var xl, jl, Yl, sc, ac, gc, Fc = 0, Ic = !1, Dc = !1, Uc = !0;
          if (typeof Oa != "function")
            throw new su(pa);
          Ua = hu(Ua) || 0, Dh(ol) && (Ic = !!ol.leading, Dc = "maxWait" in ol, Yl = Dc ? Uh(hu(ol.maxWait) || 0, Ua) : Yl, Uc = "trailing" in ol ? !!ol.trailing : Uc);
          function Gc(Rh) {
            var mu = xl, Iu = jl;
            return xl = jl = Un, Fc = Rh, sc = Oa.apply(Iu, mu), sc;
          }
          function Vc(Rh) {
            return Fc = Rh, ac = E0(bh, Ua), Ic ? Gc(Rh) : sc;
          }
          function Jc(Rh) {
            var mu = Rh - gc, Iu = Rh - Fc, qp = Ua - mu;
            return Dc ? Hh(qp, Yl - Iu) : qp;
          }
          function Wc(Rh) {
            var mu = Rh - gc, Iu = Rh - Fc;
            return gc === Un || mu >= Ua || mu < 0 || Dc && Iu >= Yl;
          }
          function bh() {
            var Rh = ad();
            if (Wc(Rh))
              return _h(Rh);
            ac = E0(bh, Jc(Rh));
          }
          function _h(Rh) {
            return ac = Un, Uc && xl ? Gc(Rh) : (xl = jl = Un, sc);
          }
          function tu() {
            ac !== Un && Gf(ac), Fc = 0, xl = gc = jl = ac = Un;
          }
          function Zh() {
            return ac === Un ? sc : _h(ad());
          }
          function ru() {
            var Rh = ad(), mu = Wc(Rh);
            if (xl = arguments, jl = this, gc = Rh, mu) {
              if (ac === Un)
                return Vc(gc);
              if (Dc)
                return Gf(ac), ac = E0(bh, Ua), Gc(gc);
            }
            return ac === Un && (ac = E0(bh, Ua)), sc;
          }
          return ru.cancel = tu, ru.flush = Zh, ru;
        }
        var _5 = vh(function(Oa, Ua) {
          return _f(Oa, 1, Ua);
        }), y5 = vh(function(Oa, Ua, ol) {
          return _f(Oa, hu(Ua) || 0, ol);
        });
        function x5(Oa) {
          return Tu(Oa, Qa);
        }
        function ld(Oa, Ua) {
          if (typeof Oa != "function" || Ua != null && typeof Ua != "function")
            throw new su(pa);
          var ol = function() {
            var xl = arguments, jl = Ua ? Ua.apply(this, xl) : xl[0], Yl = ol.cache;
            if (Yl.has(jl))
              return Yl.get(jl);
            var sc = Oa.apply(this, xl);
            return ol.cache = Yl.set(jl, sc) || Yl, sc;
          };
          return ol.cache = new (ld.Cache || xu)(), ol;
        }
        ld.Cache = xu;
        function cd(Oa) {
          if (typeof Oa != "function")
            throw new su(pa);
          return function() {
            var Ua = arguments;
            switch (Ua.length) {
              case 0:
                return !Oa.call(this);
              case 1:
                return !Oa.call(this, Ua[0]);
              case 2:
                return !Oa.call(this, Ua[0], Ua[1]);
              case 3:
                return !Oa.call(this, Ua[0], Ua[1], Ua[2]);
            }
            return !Oa.apply(this, Ua);
          };
        }
        function w5(Oa) {
          return Ap(2, Oa);
        }
        var T5 = hm(function(Oa, Ua) {
          Ua = Ua.length == 1 && qc(Ua[0]) ? Ph(Ua[0], Qh(zc())) : Ph(Gh(Ua, 1), Qh(zc()));
          var ol = Ua.length;
          return vh(function(xl) {
            for (var jl = -1, Yl = Hh(xl.length, ol); ++jl < Yl; )
              xl[jl] = Ua[jl].call(this, xl[jl]);
            return Yh(Oa, this, xl);
          });
        }), f1 = vh(function(Oa, Ua) {
          var ol = Ru(Ua, l0(f1));
          return Tu(Oa, Ja, Un, Ua, ol);
        }), Lp = vh(function(Oa, Ua) {
          var ol = Ru(Ua, l0(Lp));
          return Tu(Oa, el, Un, Ua, ol);
        }), E5 = Eu(function(Oa, Ua) {
          return Tu(Oa, tl, Un, Un, Un, Ua);
        });
        function S5(Oa, Ua) {
          if (typeof Oa != "function")
            throw new su(pa);
          return Ua = Ua === Un ? Ua : Qc(Ua), vh(Oa, Ua);
        }
        function A5(Oa, Ua) {
          if (typeof Oa != "function")
            throw new su(pa);
          return Ua = Ua == null ? 0 : Uh(Qc(Ua), 0), vh(function(ol) {
            var xl = ol[Ua], jl = Nu(ol, 0, Ua);
            return xl && Ou(jl, xl), Yh(Oa, this, jl);
          });
        }
        function F5(Oa, Ua, ol) {
          var xl = !0, jl = !0;
          if (typeof Oa != "function")
            throw new su(pa);
          return Dh(ol) && (xl = "leading" in ol ? !!ol.leading : xl, jl = "trailing" in ol ? !!ol.trailing : jl), Dp(Oa, Ua, {
            leading: xl,
            maxWait: Ua,
            trailing: jl
          });
        }
        function I5(Oa) {
          return Sp(Oa, 1);
        }
        function P5(Oa, Ua) {
          return f1(Yd(Ua), Oa);
        }
        function D5() {
          if (!arguments.length)
            return [];
          var Oa = arguments[0];
          return qc(Oa) ? Oa : [Oa];
        }
        function L5(Oa) {
          return au(Oa, wa);
        }
        function O5(Oa, Ua) {
          return Ua = typeof Ua == "function" ? Ua : Un, au(Oa, wa, Ua);
        }
        function R5(Oa) {
          return au(Oa, ya | wa);
        }
        function M5(Oa, Ua) {
          return Ua = typeof Ua == "function" ? Ua : Un, au(Oa, ya | wa, Ua);
        }
        function k5(Oa, Ua) {
          return Ua == null || Cf(Oa, Ua, Nh(Ua));
        }
        function gu(Oa, Ua) {
          return Oa === Ua || Oa !== Oa && Ua !== Ua;
        }
        var B5 = td(Nd), U5 = td(function(Oa, Ua) {
          return Oa >= Ua;
        }), qu = Ef(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Ef : function(Oa) {
          return Lh(Oa) && wh.call(Oa, "callee") && !uf.call(Oa, "callee");
        }, qc = Tc.isArray, N5 = V1 ? Qh(V1) : Z2;
        function Kh(Oa) {
          return Oa != null && hd(Oa.length) && !Au(Oa);
        }
        function Oh(Oa) {
          return Lh(Oa) && Kh(Oa);
        }
        function j5(Oa) {
          return Oa === !0 || Oa === !1 || Lh(Oa) && Vh(Oa) == zl;
        }
        var ju = Jg || T1, G5 = W1 ? Qh(W1) : X2;
        function H5(Oa) {
          return Lh(Oa) && Oa.nodeType === 1 && !S0(Oa);
        }
        function z5(Oa) {
          if (Oa == null)
            return !0;
          if (Kh(Oa) && (qc(Oa) || typeof Oa == "string" || typeof Oa.splice == "function" || ju(Oa) || c0(Oa) || qu(Oa)))
            return !Oa.length;
          var Ua = zh(Oa);
          if (Ua == wl || Ua == Ll)
            return !Oa.size;
          if (T0(Oa))
            return !Hd(Oa).length;
          for (var ol in Oa)
            if (wh.call(Oa, ol))
              return !1;
          return !0;
        }
        function V5(Oa, Ua) {
          return y0(Oa, Ua);
        }
        function W5(Oa, Ua, ol) {
          ol = typeof ol == "function" ? ol : Un;
          var xl = ol ? ol(Oa, Ua) : Un;
          return xl === Un ? y0(Oa, Ua, Un, ol) : !!xl;
        }
        function p1(Oa) {
          if (!Lh(Oa))
            return !1;
          var Ua = Vh(Oa);
          return Ua == ul || Ua == kl || typeof Oa.message == "string" && typeof Oa.name == "string" && !S0(Oa);
        }
        function Z5(Oa) {
          return typeof Oa == "number" && ff(Oa);
        }
        function Au(Oa) {
          if (!Dh(Oa))
            return !1;
          var Ua = Vh(Oa);
          return Ua == vl || Ua == Tl || Ua == Nl || Ua == Cl;
        }
        function Op(Oa) {
          return typeof Oa == "number" && Oa == Qc(Oa);
        }
        function hd(Oa) {
          return typeof Oa == "number" && Oa > -1 && Oa % 1 == 0 && Oa <= El;
        }
        function Dh(Oa) {
          var Ua = typeof Oa;
          return Oa != null && (Ua == "object" || Ua == "function");
        }
        function Lh(Oa) {
          return Oa != null && typeof Oa == "object";
        }
        var Rp = Z1 ? Qh(Z1) : q2;
        function X5(Oa, Ua) {
          return Oa === Ua || Gd(Oa, Ua, n1(Ua));
        }
        function K5(Oa, Ua, ol) {
          return ol = typeof ol == "function" ? ol : Un, Gd(Oa, Ua, n1(Ua), ol);
        }
        function $5(Oa) {
          return Mp(Oa) && Oa != +Oa;
        }
        function q5(Oa) {
          if (Om(Oa))
            throw new Kc(Jo);
          return Sf(Oa);
        }
        function Y5(Oa) {
          return Oa === null;
        }
        function Q5(Oa) {
          return Oa == null;
        }
        function Mp(Oa) {
          return typeof Oa == "number" || Lh(Oa) && Vh(Oa) == yl;
        }
        function S0(Oa) {
          if (!Lh(Oa) || Vh(Oa) != Ul)
            return !1;
          var Ua = B0(Oa);
          if (Ua === null)
            return !0;
          var ol = wh.call(Ua, "constructor") && Ua.constructor;
          return typeof ol == "function" && ol instanceof ol && O0.call(ol) == Xg;
        }
        var g1 = X1 ? Qh(X1) : Y2;
        function J5(Oa) {
          return Op(Oa) && Oa >= -9007199254740991 && Oa <= El;
        }
        var kp = $1 ? Qh($1) : Q2;
        function ud(Oa) {
          return typeof Oa == "string" || !qc(Oa) && Lh(Oa) && Vh(Oa) == tc;
        }
        function eu(Oa) {
          return typeof Oa == "symbol" || Lh(Oa) && Vh(Oa) == nc;
        }
        var c0 = q1 ? Qh(q1) : J2;
        function e4(Oa) {
          return Oa === Un;
        }
        function t4(Oa) {
          return Lh(Oa) && zh(Oa) == _c;
        }
        function r4(Oa) {
          return Lh(Oa) && Vh(Oa) == mc;
        }
        var i4 = td(zd), n4 = td(function(Oa, Ua) {
          return Oa <= Ua;
        });
        function Bp(Oa) {
          if (!Oa)
            return [];
          if (Kh(Oa))
            return ud(Oa) ? fu(Oa) : Xh(Oa);
          if (f0 && Oa[f0])
            return Mg(Oa[f0]());
          var Ua = zh(Oa), ol = Ua == wl ? Pd : Ua == Ll ? P0 : h0;
          return ol(Oa);
        }
        function Fu(Oa) {
          if (!Oa)
            return Oa === 0 ? Oa : 0;
          if (Oa = hu(Oa), Oa === dl || Oa === -1 / 0) {
            var Ua = Oa < 0 ? -1 : 1;
            return Ua * fl;
          }
          return Oa === Oa ? Oa : 0;
        }
        function Qc(Oa) {
          var Ua = Fu(Oa), ol = Ua % 1;
          return Ua === Ua ? ol ? Ua - ol : Ua : 0;
        }
        function Up(Oa) {
          return Oa ? Zu(Qc(Oa), 0, Sl) : 0;
        }
        function hu(Oa) {
          if (typeof Oa == "number")
            return Oa;
          if (eu(Oa))
            return Ml;
          if (Dh(Oa)) {
            var Ua = typeof Oa.valueOf == "function" ? Oa.valueOf() : Oa;
            Oa = Dh(Ua) ? Ua + "" : Ua;
          }
          if (typeof Oa != "string")
            return Oa === 0 ? Oa : +Oa;
          Oa = rf(Oa);
          var ol = bc.test(Oa);
          return ol || yc.test(Oa) ? bg(Oa.slice(2), ol ? 2 : 8) : wc.test(Oa) ? Ml : +Oa;
        }
        function Np(Oa) {
          return bu(Oa, $h(Oa));
        }
        function s4(Oa) {
          return Oa ? Zu(Qc(Oa), -9007199254740991, El) : Oa === 0 ? Oa : 0;
        }
        function xh(Oa) {
          return Oa == null ? "" : Jh(Oa);
        }
        var o4 = o0(function(Oa, Ua) {
          if (T0(Ua) || Kh(Ua)) {
            bu(Ua, Nh(Ua), Oa);
            return;
          }
          for (var ol in Ua)
            wh.call(Ua, ol) && b0(Oa, ol, Ua[ol]);
        }), jp = o0(function(Oa, Ua) {
          bu(Ua, $h(Ua), Oa);
        }), dd = o0(function(Oa, Ua, ol, xl) {
          bu(Ua, $h(Ua), Oa, xl);
        }), a4 = o0(function(Oa, Ua, ol, xl) {
          bu(Ua, Nh(Ua), Oa, xl);
        }), l4 = Eu(kd);
        function c4(Oa, Ua) {
          var ol = s0(Oa);
          return Ua == null ? ol : bf(ol, Ua);
        }
        var h4 = vh(function(Oa, Ua) {
          Oa = Th(Oa);
          var ol = -1, xl = Ua.length, jl = xl > 2 ? Ua[2] : Un;
          for (jl && Wh(Ua[0], Ua[1], jl) && (xl = 1); ++ol < xl; )
            for (var Yl = Ua[ol], sc = $h(Yl), ac = -1, gc = sc.length; ++ac < gc; ) {
              var Fc = sc[ac], Ic = Oa[Fc];
              (Ic === Un || gu(Ic, r0[Fc]) && !wh.call(Oa, Fc)) && (Oa[Fc] = Yl[Fc]);
            }
          return Oa;
        }), u4 = vh(function(Oa) {
          return Oa.push(Un, ip), Yh(Gp, Un, Oa);
        });
        function d4(Oa, Ua) {
          return Q1(Oa, zc(Ua, 3), vu);
        }
        function f4(Oa, Ua) {
          return Q1(Oa, zc(Ua, 3), Ud);
        }
        function p4(Oa, Ua) {
          return Oa == null ? Oa : Bd(Oa, zc(Ua, 3), $h);
        }
        function g4(Oa, Ua) {
          return Oa == null ? Oa : wf(Oa, zc(Ua, 3), $h);
        }
        function m4(Oa, Ua) {
          return Oa && vu(Oa, zc(Ua, 3));
        }
        function b4(Oa, Ua) {
          return Oa && Ud(Oa, zc(Ua, 3));
        }
        function C4(Oa) {
          return Oa == null ? [] : X0(Oa, Nh(Oa));
        }
        function _4(Oa) {
          return Oa == null ? [] : X0(Oa, $h(Oa));
        }
        function m1(Oa, Ua, ol) {
          var xl = Oa == null ? Un : Xu(Oa, Ua);
          return xl === Un ? ol : xl;
        }
        function y4(Oa, Ua) {
          return Oa != null && op(Oa, Ua, H2);
        }
        function v1(Oa, Ua) {
          return Oa != null && op(Oa, Ua, z2);
        }
        var x4 = Qf(function(Oa, Ua, ol) {
          Ua != null && typeof Ua.toString != "function" && (Ua = R0.call(Ua)), Oa[Ua] = ol;
        }, C1(qh)), w4 = Qf(function(Oa, Ua, ol) {
          Ua != null && typeof Ua.toString != "function" && (Ua = R0.call(Ua)), wh.call(Oa, Ua) ? Oa[Ua].push(ol) : Oa[Ua] = [ol];
        }, zc), T4 = vh(_0);
        function Nh(Oa) {
          return Kh(Oa) ? mf(Oa) : Hd(Oa);
        }
        function $h(Oa) {
          return Kh(Oa) ? mf(Oa, !0) : em(Oa);
        }
        function E4(Oa, Ua) {
          var ol = {};
          return Ua = zc(Ua, 3), vu(Oa, function(xl, jl, Yl) {
            wu(ol, Ua(xl, jl, Yl), xl);
          }), ol;
        }
        function S4(Oa, Ua) {
          var ol = {};
          return Ua = zc(Ua, 3), vu(Oa, function(xl, jl, Yl) {
            wu(ol, jl, Ua(xl, jl, Yl));
          }), ol;
        }
        var A4 = o0(function(Oa, Ua, ol) {
          K0(Oa, Ua, ol);
        }), Gp = o0(function(Oa, Ua, ol, xl) {
          K0(Oa, Ua, ol, xl);
        }), F4 = Eu(function(Oa, Ua) {
          var ol = {};
          if (Oa == null)
            return ol;
          var xl = !1;
          Ua = Ph(Ua, function(Yl) {
            return Yl = Uu(Yl, Oa), xl || (xl = Yl.length > 1), Yl;
          }), bu(Oa, r1(Oa), ol), xl && (ol = au(ol, ya | xa | wa, ym));
          for (var jl = Ua.length; jl--; )
            Kd(ol, Ua[jl]);
          return ol;
        });
        function I4(Oa, Ua) {
          return Hp(Oa, cd(zc(Ua)));
        }
        var P4 = Eu(function(Oa, Ua) {
          return Oa == null ? {} : rm(Oa, Ua);
        });
        function Hp(Oa, Ua) {
          if (Oa == null)
            return {};
          var ol = Ph(r1(Oa), function(xl) {
            return [xl];
          });
          return Ua = zc(Ua), Of(Oa, ol, function(xl, jl) {
            return Ua(xl, jl[0]);
          });
        }
        function D4(Oa, Ua, ol) {
          Ua = Uu(Ua, Oa);
          var xl = -1, jl = Ua.length;
          for (jl || (jl = 1, Oa = Un); ++xl < jl; ) {
            var Yl = Oa == null ? Un : Oa[Cu(Ua[xl])];
            Yl === Un && (xl = jl, Yl = ol), Oa = Au(Yl) ? Yl.call(Oa) : Yl;
          }
          return Oa;
        }
        function L4(Oa, Ua, ol) {
          return Oa == null ? Oa : x0(Oa, Ua, ol);
        }
        function O4(Oa, Ua, ol, xl) {
          return xl = typeof xl == "function" ? xl : Un, Oa == null ? Oa : x0(Oa, Ua, ol, xl);
        }
        var zp = tp(Nh), Vp = tp($h);
        function R4(Oa, Ua, ol) {
          var xl = qc(Oa), jl = xl || ju(Oa) || c0(Oa);
          if (Ua = zc(Ua, 4), ol == null) {
            var Yl = Oa && Oa.constructor;
            jl ? ol = xl ? new Yl() : [] : Dh(Oa) ? ol = Au(Yl) ? s0(B0(Oa)) : {} : ol = {};
          }
          return (jl ? nu : vu)(Oa, function(sc, ac, gc) {
            return Ua(ol, sc, ac, gc);
          }), ol;
        }
        function M4(Oa, Ua) {
          return Oa == null ? !0 : Kd(Oa, Ua);
        }
        function k4(Oa, Ua, ol) {
          return Oa == null ? Oa : Uf(Oa, Ua, Yd(ol));
        }
        function B4(Oa, Ua, ol, xl) {
          return xl = typeof xl == "function" ? xl : Un, Oa == null ? Oa : Uf(Oa, Ua, Yd(ol), xl);
        }
        function h0(Oa) {
          return Oa == null ? [] : Id(Oa, Nh(Oa));
        }
        function U4(Oa) {
          return Oa == null ? [] : Id(Oa, $h(Oa));
        }
        function N4(Oa, Ua, ol) {
          return ol === Un && (ol = Ua, Ua = Un), ol !== Un && (ol = hu(ol), ol = ol === ol ? ol : 0), Ua !== Un && (Ua = hu(Ua), Ua = Ua === Ua ? Ua : 0), Zu(hu(Oa), Ua, ol);
        }
        function j4(Oa, Ua, ol) {
          return Ua = Fu(Ua), ol === Un ? (ol = Ua, Ua = 0) : ol = Fu(ol), Oa = hu(Oa), V2(Oa, Ua, ol);
        }
        function G4(Oa, Ua, ol) {
          if (ol && typeof ol != "boolean" && Wh(Oa, Ua, ol) && (Ua = ol = Un), ol === Un && (typeof Ua == "boolean" ? (ol = Ua, Ua = Un) : typeof Oa == "boolean" && (ol = Oa, Oa = Un)), Oa === Un && Ua === Un ? (Oa = 0, Ua = 1) : (Oa = Fu(Oa), Ua === Un ? (Ua = Oa, Oa = 0) : Ua = Fu(Ua)), Oa > Ua) {
            var xl = Oa;
            Oa = Ua, Ua = xl;
          }
          if (ol || Oa % 1 || Ua % 1) {
            var jl = pf();
            return Hh(Oa + jl * (Ua - Oa + vg("1e-" + ((jl + "").length - 1))), Ua);
          }
          return Wd(Oa, Ua);
        }
        var H4 = a0(function(Oa, Ua, ol) {
          return Ua = Ua.toLowerCase(), Oa + (ol ? Wp(Ua) : Ua);
        });
        function Wp(Oa) {
          return b1(xh(Oa).toLowerCase());
        }
        function Zp(Oa) {
          return Oa = xh(Oa), Oa && Oa.replace(Mc, Pg).replace(ag, "");
        }
        function z4(Oa, Ua, ol) {
          Oa = xh(Oa), Ua = Jh(Ua);
          var xl = Oa.length;
          ol = ol === Un ? xl : Zu(Qc(ol), 0, xl);
          var jl = ol;
          return ol -= Ua.length, ol >= 0 && Oa.slice(ol, jl) == Ua;
        }
        function V4(Oa) {
          return Oa = xh(Oa), Oa && Bl.test(Oa) ? Oa.replace(Jl, Dg) : Oa;
        }
        function W4(Oa) {
          return Oa = xh(Oa), Oa && Nc.test(Oa) ? Oa.replace($c, "\\$&") : Oa;
        }
        var Z4 = a0(function(Oa, Ua, ol) {
          return Oa + (ol ? "-" : "") + Ua.toLowerCase();
        }), X4 = a0(function(Oa, Ua, ol) {
          return Oa + (ol ? " " : "") + Ua.toLowerCase();
        }), K4 = $f("toLowerCase");
        function $4(Oa, Ua, ol) {
          Oa = xh(Oa), Ua = Qc(Ua);
          var xl = Ua ? e0(Oa) : 0;
          if (!Ua || xl >= Ua)
            return Oa;
          var jl = (Ua - xl) / 2;
          return ed(G0(jl), ol) + Oa + ed(j0(jl), ol);
        }
        function q4(Oa, Ua, ol) {
          Oa = xh(Oa), Ua = Qc(Ua);
          var xl = Ua ? e0(Oa) : 0;
          return Ua && xl < Ua ? Oa + ed(Ua - xl, ol) : Oa;
        }
        function Y4(Oa, Ua, ol) {
          Oa = xh(Oa), Ua = Qc(Ua);
          var xl = Ua ? e0(Oa) : 0;
          return Ua && xl < Ua ? ed(Ua - xl, ol) + Oa : Oa;
        }
        function Q4(Oa, Ua, ol) {
          return ol || Ua == null ? Ua = 0 : Ua && (Ua = +Ua), i2(xh(Oa).replace(Zc, ""), Ua || 0);
        }
        function J4(Oa, Ua, ol) {
          return (ol ? Wh(Oa, Ua, ol) : Ua === Un) ? Ua = 1 : Ua = Qc(Ua), Zd(xh(Oa), Ua);
        }
        function ev() {
          var Oa = arguments, Ua = xh(Oa[0]);
          return Oa.length < 3 ? Ua : Ua.replace(Oa[1], Oa[2]);
        }
        var tv = a0(function(Oa, Ua, ol) {
          return Oa + (ol ? "_" : "") + Ua.toLowerCase();
        });
        function rv(Oa, Ua, ol) {
          return ol && typeof ol != "number" && Wh(Oa, Ua, ol) && (Ua = ol = Un), ol = ol === Un ? Sl : ol >>> 0, ol ? (Oa = xh(Oa), Oa && (typeof Ua == "string" || Ua != null && !g1(Ua)) && (Ua = Jh(Ua), !Ua && Ju(Oa)) ? Nu(fu(Oa), 0, ol) : Oa.split(Ua, ol)) : [];
        }
        var iv = a0(function(Oa, Ua, ol) {
          return Oa + (ol ? " " : "") + b1(Ua);
        });
        function nv(Oa, Ua, ol) {
          return Oa = xh(Oa), ol = ol == null ? 0 : Zu(Qc(ol), 0, Oa.length), Ua = Jh(Ua), Oa.slice(ol, ol + Ua.length) == Ua;
        }
        function sv(Oa, Ua, ol) {
          var xl = $l.templateSettings;
          ol && Wh(Oa, Ua, ol) && (Ua = Un), Oa = xh(Oa), Ua = dd({}, Ua, xl, rp);
          var jl = dd({}, Ua.imports, xl.imports, rp), Yl = Nh(jl), sc = Id(jl, Yl), ac, gc, Fc = 0, Ic = Ua.interpolate || Bc, Dc = "__p += '", Uc = Dd(
            (Ua.escape || Bc).source + "|" + Ic.source + "|" + (Ic === xc ? rc : Bc).source + "|" + (Ua.evaluate || Bc).source + "|$",
            "g"
          ), Gc = "//# sourceURL=" + (wh.call(Ua, "sourceURL") ? (Ua.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++dg + "]") + `
`;
          Oa.replace(Uc, function(Wc, bh, _h, tu, Zh, ru) {
            return _h || (_h = tu), Dc += Oa.slice(Fc, ru).replace(Rc, Lg), bh && (ac = !0, Dc += `' +
__e(` + bh + `) +
'`), Zh && (gc = !0, Dc += `';
` + Zh + `;
__p += '`), _h && (Dc += `' +
((__t = (` + _h + `)) == null ? '' : __t) +
'`), Fc = ru + Wc.length, Wc;
          }), Dc += `';
`;
          var Vc = wh.call(Ua, "variable") && Ua.variable;
          if (!Vc)
            Dc = `with (obj) {
` + Dc + `
}
`;
          else if (Ql.test(Vc))
            throw new Kc(ma);
          Dc = (gc ? Dc.replace(Ol, "") : Dc).replace(cc, "$1").replace(bl, "$1;"), Dc = "function(" + (Vc || "obj") + `) {
` + (Vc ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ac ? ", __e = _.escape" : "") + (gc ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Dc + `return __p
}`;
          var Jc = Kp(function() {
            return yh(Yl, Gc + "return " + Dc).apply(Un, sc);
          });
          if (Jc.source = Dc, p1(Jc))
            throw Jc;
          return Jc;
        }
        function ov(Oa) {
          return xh(Oa).toLowerCase();
        }
        function av(Oa) {
          return xh(Oa).toUpperCase();
        }
        function lv(Oa, Ua, ol) {
          if (Oa = xh(Oa), Oa && (ol || Ua === Un))
            return rf(Oa);
          if (!Oa || !(Ua = Jh(Ua)))
            return Oa;
          var xl = fu(Oa), jl = fu(Ua), Yl = nf(xl, jl), sc = sf(xl, jl) + 1;
          return Nu(xl, Yl, sc).join("");
        }
        function cv(Oa, Ua, ol) {
          if (Oa = xh(Oa), Oa && (ol || Ua === Un))
            return Oa.slice(0, af(Oa) + 1);
          if (!Oa || !(Ua = Jh(Ua)))
            return Oa;
          var xl = fu(Oa), jl = sf(xl, fu(Ua)) + 1;
          return Nu(xl, 0, jl).join("");
        }
        function hv(Oa, Ua, ol) {
          if (Oa = xh(Oa), Oa && (ol || Ua === Un))
            return Oa.replace(Zc, "");
          if (!Oa || !(Ua = Jh(Ua)))
            return Oa;
          var xl = fu(Oa), jl = nf(xl, fu(Ua));
          return Nu(xl, jl).join("");
        }
        function uv(Oa, Ua) {
          var ol = nl, xl = rl;
          if (Dh(Ua)) {
            var jl = "separator" in Ua ? Ua.separator : jl;
            ol = "length" in Ua ? Qc(Ua.length) : ol, xl = "omission" in Ua ? Jh(Ua.omission) : xl;
          }
          Oa = xh(Oa);
          var Yl = Oa.length;
          if (Ju(Oa)) {
            var sc = fu(Oa);
            Yl = sc.length;
          }
          if (ol >= Yl)
            return Oa;
          var ac = ol - e0(xl);
          if (ac < 1)
            return xl;
          var gc = sc ? Nu(sc, 0, ac).join("") : Oa.slice(0, ac);
          if (jl === Un)
            return gc + xl;
          if (sc && (ac += gc.length - ac), g1(jl)) {
            if (Oa.slice(ac).search(jl)) {
              var Fc, Ic = gc;
              for (jl.global || (jl = Dd(jl.source, xh(dc.exec(jl)) + "g")), jl.lastIndex = 0; Fc = jl.exec(Ic); )
                var Dc = Fc.index;
              gc = gc.slice(0, Dc === Un ? ac : Dc);
            }
          } else if (Oa.indexOf(Jh(jl), ac) != ac) {
            var Uc = gc.lastIndexOf(jl);
            Uc > -1 && (gc = gc.slice(0, Uc));
          }
          return gc + xl;
        }
        function dv(Oa) {
          return Oa = xh(Oa), Oa && Al.test(Oa) ? Oa.replace(pl, Ng) : Oa;
        }
        var fv = a0(function(Oa, Ua, ol) {
          return Oa + (ol ? " " : "") + Ua.toUpperCase();
        }), b1 = $f("toUpperCase");
        function Xp(Oa, Ua, ol) {
          return Oa = xh(Oa), Ua = ol ? Un : Ua, Ua === Un ? Rg(Oa) ? Hg(Oa) : Eg(Oa) : Oa.match(Ua) || [];
        }
        var Kp = vh(function(Oa, Ua) {
          try {
            return Yh(Oa, Un, Ua);
          } catch (ol) {
            return p1(ol) ? ol : new Kc(ol);
          }
        }), pv = Eu(function(Oa, Ua) {
          return nu(Ua, function(ol) {
            ol = Cu(ol), wu(Oa, ol, d1(Oa[ol], Oa));
          }), Oa;
        });
        function gv(Oa) {
          var Ua = Oa == null ? 0 : Oa.length, ol = zc();
          return Oa = Ua ? Ph(Oa, function(xl) {
            if (typeof xl[1] != "function")
              throw new su(pa);
            return [ol(xl[0]), xl[1]];
          }) : [], vh(function(xl) {
            for (var jl = -1; ++jl < Ua; ) {
              var Yl = Oa[jl];
              if (Yh(Yl[0], this, xl))
                return Yh(Yl[1], this, xl);
            }
          });
        }
        function mv(Oa) {
          return N2(au(Oa, ya));
        }
        function C1(Oa) {
          return function() {
            return Oa;
          };
        }
        function vv(Oa, Ua) {
          return Oa == null || Oa !== Oa ? Ua : Oa;
        }
        var bv = Yf(), Cv = Yf(!0);
        function qh(Oa) {
          return Oa;
        }
        function _1(Oa) {
          return Af(typeof Oa == "function" ? Oa : au(Oa, ya));
        }
        function _v(Oa) {
          return If(au(Oa, ya));
        }
        function yv(Oa, Ua) {
          return Pf(Oa, au(Ua, ya));
        }
        var xv = vh(function(Oa, Ua) {
          return function(ol) {
            return _0(ol, Oa, Ua);
          };
        }), wv = vh(function(Oa, Ua) {
          return function(ol) {
            return _0(Oa, ol, Ua);
          };
        });
        function y1(Oa, Ua, ol) {
          var xl = Nh(Ua), jl = X0(Ua, xl);
          ol == null && !(Dh(Ua) && (jl.length || !xl.length)) && (ol = Ua, Ua = Oa, Oa = this, jl = X0(Ua, Nh(Ua)));
          var Yl = !(Dh(ol) && "chain" in ol) || !!ol.chain, sc = Au(Oa);
          return nu(jl, function(ac) {
            var gc = Ua[ac];
            Oa[ac] = gc, sc && (Oa.prototype[ac] = function() {
              var Fc = this.__chain__;
              if (Yl || Fc) {
                var Ic = Oa(this.__wrapped__), Dc = Ic.__actions__ = Xh(this.__actions__);
                return Dc.push({ func: gc, args: arguments, thisArg: Oa }), Ic.__chain__ = Fc, Ic;
              }
              return gc.apply(Oa, Ou([this.value()], arguments));
            });
          }), Oa;
        }
        function Tv() {
          return jh._ === this && (jh._ = Kg), this;
        }
        function x1() {
        }
        function Ev(Oa) {
          return Oa = Qc(Oa), vh(function(Ua) {
            return Df(Ua, Oa);
          });
        }
        var Sv = Jd(Ph), Av = Jd(Y1), Fv = Jd(Td);
        function $p(Oa) {
          return o1(Oa) ? Ed(Cu(Oa)) : im(Oa);
        }
        function Iv(Oa) {
          return function(Ua) {
            return Oa == null ? Un : Xu(Oa, Ua);
          };
        }
        var Pv = Jf(), Dv = Jf(!0);
        function w1() {
          return [];
        }
        function T1() {
          return !1;
        }
        function Lv() {
          return {};
        }
        function Ov() {
          return "";
        }
        function Rv() {
          return !0;
        }
        function Mv(Oa, Ua) {
          if (Oa = Qc(Oa), Oa < 1 || Oa > El)
            return [];
          var ol = Sl, xl = Hh(Oa, Sl);
          Ua = zc(Ua), Oa -= Sl;
          for (var jl = Fd(xl, Ua); ++ol < Oa; )
            Ua(ol);
          return jl;
        }
        function kv(Oa) {
          return qc(Oa) ? Ph(Oa, Cu) : eu(Oa) ? [Oa] : Xh(gp(xh(Oa)));
        }
        function Bv(Oa) {
          var Ua = ++Zg;
          return xh(Oa) + Ua;
        }
        var Uv = J0(function(Oa, Ua) {
          return Oa + Ua;
        }, 0), Nv = e1("ceil"), jv = J0(function(Oa, Ua) {
          return Oa / Ua;
        }, 1), Gv = e1("floor");
        function Hv(Oa) {
          return Oa && Oa.length ? Z0(Oa, qh, Nd) : Un;
        }
        function zv(Oa, Ua) {
          return Oa && Oa.length ? Z0(Oa, zc(Ua, 2), Nd) : Un;
        }
        function Vv(Oa) {
          return ef(Oa, qh);
        }
        function Wv(Oa, Ua) {
          return ef(Oa, zc(Ua, 2));
        }
        function Zv(Oa) {
          return Oa && Oa.length ? Z0(Oa, qh, zd) : Un;
        }
        function Xv(Oa, Ua) {
          return Oa && Oa.length ? Z0(Oa, zc(Ua, 2), zd) : Un;
        }
        var Kv = J0(function(Oa, Ua) {
          return Oa * Ua;
        }, 1), $v = e1("round"), qv = J0(function(Oa, Ua) {
          return Oa - Ua;
        }, 0);
        function Yv(Oa) {
          return Oa && Oa.length ? Ad(Oa, qh) : 0;
        }
        function Qv(Oa, Ua) {
          return Oa && Oa.length ? Ad(Oa, zc(Ua, 2)) : 0;
        }
        return $l.after = C5, $l.ary = Sp, $l.assign = o4, $l.assignIn = jp, $l.assignInWith = dd, $l.assignWith = a4, $l.at = l4, $l.before = Ap, $l.bind = d1, $l.bindAll = pv, $l.bindKey = Fp, $l.castArray = D5, $l.chain = wp, $l.chunk = jm, $l.compact = Gm, $l.concat = Hm, $l.cond = gv, $l.conforms = mv, $l.constant = C1, $l.countBy = q3, $l.create = c4, $l.curry = Ip, $l.curryRight = Pp, $l.debounce = Dp, $l.defaults = h4, $l.defaultsDeep = u4, $l.defer = _5, $l.delay = y5, $l.difference = zm, $l.differenceBy = Vm, $l.differenceWith = Wm, $l.drop = Zm, $l.dropRight = Xm, $l.dropRightWhile = Km, $l.dropWhile = $m, $l.fill = qm, $l.filter = Q3, $l.flatMap = t5, $l.flatMapDeep = r5, $l.flatMapDepth = i5, $l.flatten = Cp, $l.flattenDeep = Ym, $l.flattenDepth = Qm, $l.flip = x5, $l.flow = bv, $l.flowRight = Cv, $l.fromPairs = Jm, $l.functions = C4, $l.functionsIn = _4, $l.groupBy = n5, $l.initial = t3, $l.intersection = r3, $l.intersectionBy = i3, $l.intersectionWith = n3, $l.invert = x4, $l.invertBy = w4, $l.invokeMap = o5, $l.iteratee = _1, $l.keyBy = a5, $l.keys = Nh, $l.keysIn = $h, $l.map = od, $l.mapKeys = E4, $l.mapValues = S4, $l.matches = _v, $l.matchesProperty = yv, $l.memoize = ld, $l.merge = A4, $l.mergeWith = Gp, $l.method = xv, $l.methodOf = wv, $l.mixin = y1, $l.negate = cd, $l.nthArg = Ev, $l.omit = F4, $l.omitBy = I4, $l.once = w5, $l.orderBy = l5, $l.over = Sv, $l.overArgs = T5, $l.overEvery = Av, $l.overSome = Fv, $l.partial = f1, $l.partialRight = Lp, $l.partition = c5, $l.pick = P4, $l.pickBy = Hp, $l.property = $p, $l.propertyOf = Iv, $l.pull = l3, $l.pullAll = yp, $l.pullAllBy = c3, $l.pullAllWith = h3, $l.pullAt = u3, $l.range = Pv, $l.rangeRight = Dv, $l.rearg = E5, $l.reject = d5, $l.remove = d3, $l.rest = S5, $l.reverse = h1, $l.sampleSize = p5, $l.set = L4, $l.setWith = O4, $l.shuffle = g5, $l.slice = f3, $l.sortBy = b5, $l.sortedUniq = _3, $l.sortedUniqBy = y3, $l.split = rv, $l.spread = A5, $l.tail = x3, $l.take = w3, $l.takeRight = T3, $l.takeRightWhile = E3, $l.takeWhile = S3, $l.tap = G3, $l.throttle = F5, $l.thru = sd, $l.toArray = Bp, $l.toPairs = zp, $l.toPairsIn = Vp, $l.toPath = kv, $l.toPlainObject = Np, $l.transform = R4, $l.unary = I5, $l.union = A3, $l.unionBy = F3, $l.unionWith = I3, $l.uniq = P3, $l.uniqBy = D3, $l.uniqWith = L3, $l.unset = M4, $l.unzip = u1, $l.unzipWith = xp, $l.update = k4, $l.updateWith = B4, $l.values = h0, $l.valuesIn = U4, $l.without = O3, $l.words = Xp, $l.wrap = P5, $l.xor = R3, $l.xorBy = M3, $l.xorWith = k3, $l.zip = B3, $l.zipObject = U3, $l.zipObjectDeep = N3, $l.zipWith = j3, $l.entries = zp, $l.entriesIn = Vp, $l.extend = jp, $l.extendWith = dd, y1($l, $l), $l.add = Uv, $l.attempt = Kp, $l.camelCase = H4, $l.capitalize = Wp, $l.ceil = Nv, $l.clamp = N4, $l.clone = L5, $l.cloneDeep = R5, $l.cloneDeepWith = M5, $l.cloneWith = O5, $l.conformsTo = k5, $l.deburr = Zp, $l.defaultTo = vv, $l.divide = jv, $l.endsWith = z4, $l.eq = gu, $l.escape = V4, $l.escapeRegExp = W4, $l.every = Y3, $l.find = J3, $l.findIndex = vp, $l.findKey = d4, $l.findLast = e5, $l.findLastIndex = bp, $l.findLastKey = f4, $l.floor = Gv, $l.forEach = Tp, $l.forEachRight = Ep, $l.forIn = p4, $l.forInRight = g4, $l.forOwn = m4, $l.forOwnRight = b4, $l.get = m1, $l.gt = B5, $l.gte = U5, $l.has = y4, $l.hasIn = v1, $l.head = _p, $l.identity = qh, $l.includes = s5, $l.indexOf = e3, $l.inRange = j4, $l.invoke = T4, $l.isArguments = qu, $l.isArray = qc, $l.isArrayBuffer = N5, $l.isArrayLike = Kh, $l.isArrayLikeObject = Oh, $l.isBoolean = j5, $l.isBuffer = ju, $l.isDate = G5, $l.isElement = H5, $l.isEmpty = z5, $l.isEqual = V5, $l.isEqualWith = W5, $l.isError = p1, $l.isFinite = Z5, $l.isFunction = Au, $l.isInteger = Op, $l.isLength = hd, $l.isMap = Rp, $l.isMatch = X5, $l.isMatchWith = K5, $l.isNaN = $5, $l.isNative = q5, $l.isNil = Q5, $l.isNull = Y5, $l.isNumber = Mp, $l.isObject = Dh, $l.isObjectLike = Lh, $l.isPlainObject = S0, $l.isRegExp = g1, $l.isSafeInteger = J5, $l.isSet = kp, $l.isString = ud, $l.isSymbol = eu, $l.isTypedArray = c0, $l.isUndefined = e4, $l.isWeakMap = t4, $l.isWeakSet = r4, $l.join = s3, $l.kebabCase = Z4, $l.last = cu, $l.lastIndexOf = o3, $l.lowerCase = X4, $l.lowerFirst = K4, $l.lt = i4, $l.lte = n4, $l.max = Hv, $l.maxBy = zv, $l.mean = Vv, $l.meanBy = Wv, $l.min = Zv, $l.minBy = Xv, $l.stubArray = w1, $l.stubFalse = T1, $l.stubObject = Lv, $l.stubString = Ov, $l.stubTrue = Rv, $l.multiply = Kv, $l.nth = a3, $l.noConflict = Tv, $l.noop = x1, $l.now = ad, $l.pad = $4, $l.padEnd = q4, $l.padStart = Y4, $l.parseInt = Q4, $l.random = G4, $l.reduce = h5, $l.reduceRight = u5, $l.repeat = J4, $l.replace = ev, $l.result = D4, $l.round = $v, $l.runInContext = pc, $l.sample = f5, $l.size = m5, $l.snakeCase = tv, $l.some = v5, $l.sortedIndex = p3, $l.sortedIndexBy = g3, $l.sortedIndexOf = m3, $l.sortedLastIndex = v3, $l.sortedLastIndexBy = b3, $l.sortedLastIndexOf = C3, $l.startCase = iv, $l.startsWith = nv, $l.subtract = qv, $l.sum = Yv, $l.sumBy = Qv, $l.template = sv, $l.times = Mv, $l.toFinite = Fu, $l.toInteger = Qc, $l.toLength = Up, $l.toLower = ov, $l.toNumber = hu, $l.toSafeInteger = s4, $l.toString = xh, $l.toUpper = av, $l.trim = lv, $l.trimEnd = cv, $l.trimStart = hv, $l.truncate = uv, $l.unescape = dv, $l.uniqueId = Bv, $l.upperCase = fv, $l.upperFirst = b1, $l.each = Tp, $l.eachRight = Ep, $l.first = _p, y1($l, function() {
          var Oa = {};
          return vu($l, function(Ua, ol) {
            wh.call($l.prototype, ol) || (Oa[ol] = Ua);
          }), Oa;
        }(), { chain: !1 }), $l.VERSION = Kn, nu(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(Oa) {
          $l[Oa].placeholder = $l;
        }), nu(["drop", "take"], function(Oa, Ua) {
          Ch.prototype[Oa] = function(ol) {
            ol = ol === Un ? 1 : Uh(Qc(ol), 0);
            var xl = this.__filtered__ && !Ua ? new Ch(this) : this.clone();
            return xl.__filtered__ ? xl.__takeCount__ = Hh(ol, xl.__takeCount__) : xl.__views__.push({
              size: Hh(ol, Sl),
              type: Oa + (xl.__dir__ < 0 ? "Right" : "")
            }), xl;
          }, Ch.prototype[Oa + "Right"] = function(ol) {
            return this.reverse()[Oa](ol).reverse();
          };
        }), nu(["filter", "map", "takeWhile"], function(Oa, Ua) {
          var ol = Ua + 1, xl = ol == ll || ol == sl;
          Ch.prototype[Oa] = function(jl) {
            var Yl = this.clone();
            return Yl.__iteratees__.push({
              iteratee: zc(jl, 3),
              type: ol
            }), Yl.__filtered__ = Yl.__filtered__ || xl, Yl;
          };
        }), nu(["head", "last"], function(Oa, Ua) {
          var ol = "take" + (Ua ? "Right" : "");
          Ch.prototype[Oa] = function() {
            return this[ol](1).value()[0];
          };
        }), nu(["initial", "tail"], function(Oa, Ua) {
          var ol = "drop" + (Ua ? "" : "Right");
          Ch.prototype[Oa] = function() {
            return this.__filtered__ ? new Ch(this) : this[ol](1);
          };
        }), Ch.prototype.compact = function() {
          return this.filter(qh);
        }, Ch.prototype.find = function(Oa) {
          return this.filter(Oa).head();
        }, Ch.prototype.findLast = function(Oa) {
          return this.reverse().find(Oa);
        }, Ch.prototype.invokeMap = vh(function(Oa, Ua) {
          return typeof Oa == "function" ? new Ch(this) : this.map(function(ol) {
            return _0(ol, Oa, Ua);
          });
        }), Ch.prototype.reject = function(Oa) {
          return this.filter(cd(zc(Oa)));
        }, Ch.prototype.slice = function(Oa, Ua) {
          Oa = Qc(Oa);
          var ol = this;
          return ol.__filtered__ && (Oa > 0 || Ua < 0) ? new Ch(ol) : (Oa < 0 ? ol = ol.takeRight(-Oa) : Oa && (ol = ol.drop(Oa)), Ua !== Un && (Ua = Qc(Ua), ol = Ua < 0 ? ol.dropRight(-Ua) : ol.take(Ua - Oa)), ol);
        }, Ch.prototype.takeRightWhile = function(Oa) {
          return this.reverse().takeWhile(Oa).reverse();
        }, Ch.prototype.toArray = function() {
          return this.take(Sl);
        }, vu(Ch.prototype, function(Oa, Ua) {
          var ol = /^(?:filter|find|map|reject)|While$/.test(Ua), xl = /^(?:head|last)$/.test(Ua), jl = $l[xl ? "take" + (Ua == "last" ? "Right" : "") : Ua], Yl = xl || /^find/.test(Ua);
          jl && ($l.prototype[Ua] = function() {
            var sc = this.__wrapped__, ac = xl ? [1] : arguments, gc = sc instanceof Ch, Fc = ac[0], Ic = gc || qc(sc), Dc = function(bh) {
              var _h = jl.apply($l, Ou([bh], ac));
              return xl && Uc ? _h[0] : _h;
            };
            Ic && ol && typeof Fc == "function" && Fc.length != 1 && (gc = Ic = !1);
            var Uc = this.__chain__, Gc = !!this.__actions__.length, Vc = Yl && !Uc, Jc = gc && !Gc;
            if (!Yl && Ic) {
              sc = Jc ? sc : new Ch(this);
              var Wc = Oa.apply(sc, ac);
              return Wc.__actions__.push({ func: sd, args: [Dc], thisArg: Un }), new ou(Wc, Uc);
            }
            return Vc && Jc ? Oa.apply(this, ac) : (Wc = this.thru(Dc), Vc ? xl ? Wc.value()[0] : Wc.value() : Wc);
          });
        }), nu(["pop", "push", "shift", "sort", "splice", "unshift"], function(Oa) {
          var Ua = D0[Oa], ol = /^(?:push|sort|unshift)$/.test(Oa) ? "tap" : "thru", xl = /^(?:pop|shift)$/.test(Oa);
          $l.prototype[Oa] = function() {
            var jl = arguments;
            if (xl && !this.__chain__) {
              var Yl = this.value();
              return Ua.apply(qc(Yl) ? Yl : [], jl);
            }
            return this[ol](function(sc) {
              return Ua.apply(qc(sc) ? sc : [], jl);
            });
          };
        }), vu(Ch.prototype, function(Oa, Ua) {
          var ol = $l[Ua];
          if (ol) {
            var xl = ol.name + "";
            wh.call(n0, xl) || (n0[xl] = []), n0[xl].push({ name: Ua, func: ol });
          }
        }), n0[Q0(Un, ka).name] = [{
          name: "wrapper",
          func: Un
        }], Ch.prototype.clone = h2, Ch.prototype.reverse = u2, Ch.prototype.value = d2, $l.prototype.at = H3, $l.prototype.chain = z3, $l.prototype.commit = V3, $l.prototype.next = W3, $l.prototype.plant = X3, $l.prototype.reverse = K3, $l.prototype.toJSON = $l.prototype.valueOf = $l.prototype.value = $3, $l.prototype.first = $l.prototype.head, f0 && ($l.prototype[f0] = Z3), $l;
      }, t0 = zg();
      Hu ? ((Hu.exports = t0)._ = t0, _d._ = t0) : jh._ = t0;
    }).call(lodash);
  }(lodash$1, lodash$1.exports)), lodash$1.exports;
}
var lodashExports = requireLodash();
const _$2 = /* @__PURE__ */ getDefaultExportFromCjs$1(lodashExports);
function t$1(Xn, zn, Un) {
  return (zn = function(Kn) {
    var qn = function(Jo, pa) {
      if (typeof Jo != "object" || !Jo) return Jo;
      var ma = Jo[Symbol.toPrimitive];
      if (ma !== void 0) {
        var va = ma.call(Jo, pa);
        if (typeof va != "object") return va;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (pa === "string" ? String : Number)(Jo);
    }(Kn, "string");
    return typeof qn == "symbol" ? qn : qn + "";
  }(zn)) in Xn ? Object.defineProperty(Xn, zn, { value: Un, enumerable: !0, configurable: !0, writable: !0 }) : Xn[zn] = Un, Xn;
}
function e$1(Xn, zn) {
  var Un = Object.keys(Xn);
  if (Object.getOwnPropertySymbols) {
    var Kn = Object.getOwnPropertySymbols(Xn);
    zn && (Kn = Kn.filter(function(qn) {
      return Object.getOwnPropertyDescriptor(Xn, qn).enumerable;
    })), Un.push.apply(Un, Kn);
  }
  return Un;
}
function s$1(Xn) {
  for (var zn = 1; zn < arguments.length; zn++) {
    var Un = arguments[zn] != null ? arguments[zn] : {};
    zn % 2 ? e$1(Object(Un), !0).forEach(function(Kn) {
      t$1(Xn, Kn, Un[Kn]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Xn, Object.getOwnPropertyDescriptors(Un)) : e$1(Object(Un)).forEach(function(Kn) {
      Object.defineProperty(Xn, Kn, Object.getOwnPropertyDescriptor(Un, Kn));
    });
  }
  return Xn;
}
function i$3(Xn, zn) {
  if (Xn == null) return {};
  var Un, Kn, qn = function(pa, ma) {
    if (pa == null) return {};
    var va = {};
    for (var ba in pa) if ({}.hasOwnProperty.call(pa, ba)) {
      if (ma.indexOf(ba) >= 0) continue;
      va[ba] = pa[ba];
    }
    return va;
  }(Xn, zn);
  if (Object.getOwnPropertySymbols) {
    var Jo = Object.getOwnPropertySymbols(Xn);
    for (Kn = 0; Kn < Jo.length; Kn++) Un = Jo[Kn], zn.indexOf(Un) >= 0 || {}.propertyIsEnumerable.call(Xn, Un) && (qn[Un] = Xn[Un]);
  }
  return qn;
}
function r$1(Xn, zn) {
  return zn || (zn = Xn.slice(0)), Object.freeze(Object.defineProperties(Xn, { raw: { value: Object.freeze(zn) } }));
}
let n$1 = class {
  constructor() {
    t$1(this, "browserShadowBlurConstant", 1), t$1(this, "DPI", 96), t$1(this, "devicePixelRatio", typeof window < "u" ? window.devicePixelRatio : 1), t$1(this, "perfLimitSizeTotal", 2097152), t$1(this, "maxCacheSideLimit", 4096), t$1(this, "minCacheSideLimit", 256), t$1(this, "disableStyleCopyPaste", !1), t$1(this, "enableGLFiltering", !0), t$1(this, "textureSize", 4096), t$1(this, "forceGLPutImageData", !1), t$1(this, "cachesBoundsOfCurve", !1), t$1(this, "fontPaths", {}), t$1(this, "NUM_FRACTION_DIGITS", 4);
  }
};
const o$1 = new class extends n$1 {
  constructor(Xn) {
    super(), this.configure(Xn);
  }
  configure() {
    let Xn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Object.assign(this, Xn);
  }
  addFonts() {
    let Xn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.fontPaths = s$1(s$1({}, this.fontPaths), Xn);
  }
  removeFonts() {
    (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).forEach((Xn) => {
      delete this.fontPaths[Xn];
    });
  }
  clearFonts() {
    this.fontPaths = {};
  }
  restoreDefaults(Xn) {
    const zn = new n$1(), Un = (Xn == null ? void 0 : Xn.reduce((Kn, qn) => (Kn[qn] = zn[qn], Kn), {})) || zn;
    this.configure(Un);
  }
}(), a$1 = function(Xn) {
  for (var zn = arguments.length, Un = new Array(zn > 1 ? zn - 1 : 0), Kn = 1; Kn < zn; Kn++) Un[Kn - 1] = arguments[Kn];
  return console[Xn]("fabric", ...Un);
};
let h$1 = class extends Error {
  constructor(zn, Un) {
    super("fabric: ".concat(zn), Un);
  }
}, c$2 = class extends h$1 {
  constructor(zn) {
    super("".concat(zn, " 'options.signal' is in 'aborted' state"));
  }
}, l$1 = class {
}, u$1 = class extends l$1 {
  testPrecision(zn, Un) {
    const Kn = "precision ".concat(Un, ` float;
void main(){}`), qn = zn.createShader(zn.FRAGMENT_SHADER);
    return !!qn && (zn.shaderSource(qn, Kn), zn.compileShader(qn), !!zn.getShaderParameter(qn, zn.COMPILE_STATUS));
  }
  queryWebGL(zn) {
    const Un = zn.getContext("webgl");
    Un && (this.maxTextureSize = Un.getParameter(Un.MAX_TEXTURE_SIZE), this.GLPrecision = ["highp", "mediump", "lowp"].find((Kn) => this.testPrecision(Un, Kn)), Un.getExtension("WEBGL_lose_context").loseContext(), a$1("log", "WebGL: max texture size ".concat(this.maxTextureSize)));
  }
  isSupported(zn) {
    return !!this.maxTextureSize && this.maxTextureSize >= zn;
  }
};
const d = {};
let g;
const p$1 = () => g || (g = { document, window, isTouchSupported: "ontouchstart" in window || "ontouchstart" in document || window && window.navigator && window.navigator.maxTouchPoints > 0, WebGLProbe: new u$1(), dispose() {
}, copyPasteData: d }), m = () => p$1().document, v$1 = () => p$1().window, y$3 = () => {
  var Xn;
  return Math.max((Xn = o$1.devicePixelRatio) !== null && Xn !== void 0 ? Xn : v$1().devicePixelRatio, 1);
}, _$1 = new class {
  constructor() {
    t$1(this, "charWidthsCache", {}), t$1(this, "boundsOfCurveCache", {});
  }
  getFontCache(Xn) {
    let { fontFamily: zn, fontStyle: Un, fontWeight: Kn } = Xn;
    zn = zn.toLowerCase(), this.charWidthsCache[zn] || (this.charWidthsCache[zn] = {});
    const qn = this.charWidthsCache[zn], Jo = "".concat(Un.toLowerCase(), "_").concat((Kn + "").toLowerCase());
    return qn[Jo] || (qn[Jo] = {}), qn[Jo];
  }
  clearFontCache(Xn) {
    (Xn = (Xn || "").toLowerCase()) ? this.charWidthsCache[Xn] && delete this.charWidthsCache[Xn] : this.charWidthsCache = {};
  }
  limitDimsByArea(Xn) {
    const { perfLimitSizeTotal: zn } = o$1, Un = Math.sqrt(zn * Xn);
    return [Math.floor(Un), Math.floor(zn / Un)];
  }
}(), x$3 = "6.6.4";
function C$1() {
}
const b$1 = Math.PI / 2, w = 2 * Math.PI, S$1 = Math.PI / 180, T$1 = Object.freeze([1, 0, 0, 1, 0, 0]), O$1 = 16, k$1 = 0.4477152502, D = "center", M$1 = "left", P = "top", E$1 = "bottom", A$1 = "right", j = "none", F = /\r?\n/, L$1 = "moving", R$1 = "scaling", I = "rotating", B$1 = "rotate", X = "skewing", Y$2 = "resizing", W = "modifyPoly", V = "modifyPath", z$1 = "changed", G = "scale", H = "scaleX", N$1 = "scaleY", U = "skewX", q = "skewY", K = "fill", J = "stroke", Q = "modified", Z = "json", $$1 = "svg", tt = new class {
  constructor() {
    this[Z] = /* @__PURE__ */ new Map(), this[$$1] = /* @__PURE__ */ new Map();
  }
  has(Xn) {
    return this[Z].has(Xn);
  }
  getClass(Xn) {
    const zn = this[Z].get(Xn);
    if (!zn) throw new h$1("No class registered for ".concat(Xn));
    return zn;
  }
  setClass(Xn, zn) {
    zn ? this[Z].set(zn, Xn) : (this[Z].set(Xn.type, Xn), this[Z].set(Xn.type.toLowerCase(), Xn));
  }
  getSVGClass(Xn) {
    return this[$$1].get(Xn);
  }
  setSVGClass(Xn, zn) {
    this[$$1].set(zn ?? Xn.type.toLowerCase(), Xn);
  }
}(), et = new class extends Array {
  remove(Xn) {
    const zn = this.indexOf(Xn);
    zn > -1 && this.splice(zn, 1);
  }
  cancelAll() {
    const Xn = this.splice(0);
    return Xn.forEach((zn) => zn.abort()), Xn;
  }
  cancelByCanvas(Xn) {
    if (!Xn) return [];
    const zn = this.filter((Un) => {
      var Kn;
      return Un.target === Xn || typeof Un.target == "object" && ((Kn = Un.target) === null || Kn === void 0 ? void 0 : Kn.canvas) === Xn;
    });
    return zn.forEach((Un) => Un.abort()), zn;
  }
  cancelByTarget(Xn) {
    if (!Xn) return [];
    const zn = this.filter((Un) => Un.target === Xn);
    return zn.forEach((Un) => Un.abort()), zn;
  }
}();
class st {
  constructor() {
    t$1(this, "__eventListeners", {});
  }
  on(zn, Un) {
    if (this.__eventListeners || (this.__eventListeners = {}), typeof zn == "object") return Object.entries(zn).forEach((Kn) => {
      let [qn, Jo] = Kn;
      this.on(qn, Jo);
    }), () => this.off(zn);
    if (Un) {
      const Kn = zn;
      return this.__eventListeners[Kn] || (this.__eventListeners[Kn] = []), this.__eventListeners[Kn].push(Un), () => this.off(Kn, Un);
    }
    return () => !1;
  }
  once(zn, Un) {
    if (typeof zn == "object") {
      const Kn = [];
      return Object.entries(zn).forEach((qn) => {
        let [Jo, pa] = qn;
        Kn.push(this.once(Jo, pa));
      }), () => Kn.forEach((qn) => qn());
    }
    if (Un) {
      const Kn = this.on(zn, function() {
        for (var qn = arguments.length, Jo = new Array(qn), pa = 0; pa < qn; pa++) Jo[pa] = arguments[pa];
        Un.call(this, ...Jo), Kn();
      });
      return Kn;
    }
    return () => !1;
  }
  _removeEventListener(zn, Un) {
    if (this.__eventListeners[zn]) if (Un) {
      const Kn = this.__eventListeners[zn], qn = Kn.indexOf(Un);
      qn > -1 && Kn.splice(qn, 1);
    } else this.__eventListeners[zn] = [];
  }
  off(zn, Un) {
    if (this.__eventListeners) if (zn === void 0) for (const Kn in this.__eventListeners) this._removeEventListener(Kn);
    else typeof zn == "object" ? Object.entries(zn).forEach((Kn) => {
      let [qn, Jo] = Kn;
      this._removeEventListener(qn, Jo);
    }) : this._removeEventListener(zn, Un);
  }
  fire(zn, Un) {
    var Kn;
    if (!this.__eventListeners) return;
    const qn = (Kn = this.__eventListeners[zn]) === null || Kn === void 0 ? void 0 : Kn.concat();
    if (qn) for (let Jo = 0; Jo < qn.length; Jo++) qn[Jo].call(this, Un || {});
  }
}
const it = (Xn, zn) => {
  const Un = Xn.indexOf(zn);
  return Un !== -1 && Xn.splice(Un, 1), Xn;
}, rt = (Xn) => {
  if (Xn === 0) return 1;
  switch (Math.abs(Xn) / b$1) {
    case 1:
    case 3:
      return 0;
    case 2:
      return -1;
  }
  return Math.cos(Xn);
}, nt = (Xn) => {
  if (Xn === 0) return 0;
  const zn = Xn / b$1, Un = Math.sign(Xn);
  switch (zn) {
    case 1:
      return Un;
    case 2:
      return 0;
    case 3:
      return -Un;
  }
  return Math.sin(Xn);
};
class ot {
  constructor() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    typeof zn == "object" ? (this.x = zn.x, this.y = zn.y) : (this.x = zn, this.y = Un);
  }
  add(zn) {
    return new ot(this.x + zn.x, this.y + zn.y);
  }
  addEquals(zn) {
    return this.x += zn.x, this.y += zn.y, this;
  }
  scalarAdd(zn) {
    return new ot(this.x + zn, this.y + zn);
  }
  scalarAddEquals(zn) {
    return this.x += zn, this.y += zn, this;
  }
  subtract(zn) {
    return new ot(this.x - zn.x, this.y - zn.y);
  }
  subtractEquals(zn) {
    return this.x -= zn.x, this.y -= zn.y, this;
  }
  scalarSubtract(zn) {
    return new ot(this.x - zn, this.y - zn);
  }
  scalarSubtractEquals(zn) {
    return this.x -= zn, this.y -= zn, this;
  }
  multiply(zn) {
    return new ot(this.x * zn.x, this.y * zn.y);
  }
  scalarMultiply(zn) {
    return new ot(this.x * zn, this.y * zn);
  }
  scalarMultiplyEquals(zn) {
    return this.x *= zn, this.y *= zn, this;
  }
  divide(zn) {
    return new ot(this.x / zn.x, this.y / zn.y);
  }
  scalarDivide(zn) {
    return new ot(this.x / zn, this.y / zn);
  }
  scalarDivideEquals(zn) {
    return this.x /= zn, this.y /= zn, this;
  }
  eq(zn) {
    return this.x === zn.x && this.y === zn.y;
  }
  lt(zn) {
    return this.x < zn.x && this.y < zn.y;
  }
  lte(zn) {
    return this.x <= zn.x && this.y <= zn.y;
  }
  gt(zn) {
    return this.x > zn.x && this.y > zn.y;
  }
  gte(zn) {
    return this.x >= zn.x && this.y >= zn.y;
  }
  lerp(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.5;
    return Un = Math.max(Math.min(1, Un), 0), new ot(this.x + (zn.x - this.x) * Un, this.y + (zn.y - this.y) * Un);
  }
  distanceFrom(zn) {
    const Un = this.x - zn.x, Kn = this.y - zn.y;
    return Math.sqrt(Un * Un + Kn * Kn);
  }
  midPointFrom(zn) {
    return this.lerp(zn);
  }
  min(zn) {
    return new ot(Math.min(this.x, zn.x), Math.min(this.y, zn.y));
  }
  max(zn) {
    return new ot(Math.max(this.x, zn.x), Math.max(this.y, zn.y));
  }
  toString() {
    return "".concat(this.x, ",").concat(this.y);
  }
  setXY(zn, Un) {
    return this.x = zn, this.y = Un, this;
  }
  setX(zn) {
    return this.x = zn, this;
  }
  setY(zn) {
    return this.y = zn, this;
  }
  setFromPoint(zn) {
    return this.x = zn.x, this.y = zn.y, this;
  }
  swap(zn) {
    const Un = this.x, Kn = this.y;
    this.x = zn.x, this.y = zn.y, zn.x = Un, zn.y = Kn;
  }
  clone() {
    return new ot(this.x, this.y);
  }
  rotate(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : at;
    const Kn = nt(zn), qn = rt(zn), Jo = this.subtract(Un);
    return new ot(Jo.x * qn - Jo.y * Kn, Jo.x * Kn + Jo.y * qn).add(Un);
  }
  transform(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return new ot(zn[0] * this.x + zn[2] * this.y + (Un ? 0 : zn[4]), zn[1] * this.x + zn[3] * this.y + (Un ? 0 : zn[5]));
  }
}
const at = new ot(0, 0), ht = (Xn) => !!Xn && Array.isArray(Xn._objects);
function ct(Xn) {
  class zn extends Xn {
    constructor() {
      super(...arguments), t$1(this, "_objects", []);
    }
    _onObjectAdded(Kn) {
    }
    _onObjectRemoved(Kn) {
    }
    _onStackOrderChanged(Kn) {
    }
    add() {
      for (var Kn = arguments.length, qn = new Array(Kn), Jo = 0; Jo < Kn; Jo++) qn[Jo] = arguments[Jo];
      const pa = this._objects.push(...qn);
      return qn.forEach((ma) => this._onObjectAdded(ma)), pa;
    }
    insertAt(Kn) {
      for (var qn = arguments.length, Jo = new Array(qn > 1 ? qn - 1 : 0), pa = 1; pa < qn; pa++) Jo[pa - 1] = arguments[pa];
      return this._objects.splice(Kn, 0, ...Jo), Jo.forEach((ma) => this._onObjectAdded(ma)), this._objects.length;
    }
    remove() {
      const Kn = this._objects, qn = [];
      for (var Jo = arguments.length, pa = new Array(Jo), ma = 0; ma < Jo; ma++) pa[ma] = arguments[ma];
      return pa.forEach((va) => {
        const ba = Kn.indexOf(va);
        ba !== -1 && (Kn.splice(ba, 1), qn.push(va), this._onObjectRemoved(va));
      }), qn;
    }
    forEachObject(Kn) {
      this.getObjects().forEach((qn, Jo, pa) => Kn(qn, Jo, pa));
    }
    getObjects() {
      for (var Kn = arguments.length, qn = new Array(Kn), Jo = 0; Jo < Kn; Jo++) qn[Jo] = arguments[Jo];
      return qn.length === 0 ? [...this._objects] : this._objects.filter((pa) => pa.isType(...qn));
    }
    item(Kn) {
      return this._objects[Kn];
    }
    isEmpty() {
      return this._objects.length === 0;
    }
    size() {
      return this._objects.length;
    }
    contains(Kn, qn) {
      return !!this._objects.includes(Kn) || !!qn && this._objects.some((Jo) => Jo instanceof zn && Jo.contains(Kn, !0));
    }
    complexity() {
      return this._objects.reduce((Kn, qn) => Kn += qn.complexity ? qn.complexity() : 0, 0);
    }
    sendObjectToBack(Kn) {
      return !(!Kn || Kn === this._objects[0]) && (it(this._objects, Kn), this._objects.unshift(Kn), this._onStackOrderChanged(Kn), !0);
    }
    bringObjectToFront(Kn) {
      return !(!Kn || Kn === this._objects[this._objects.length - 1]) && (it(this._objects, Kn), this._objects.push(Kn), this._onStackOrderChanged(Kn), !0);
    }
    sendObjectBackwards(Kn, qn) {
      if (!Kn) return !1;
      const Jo = this._objects.indexOf(Kn);
      if (Jo !== 0) {
        const pa = this.findNewLowerIndex(Kn, Jo, qn);
        return it(this._objects, Kn), this._objects.splice(pa, 0, Kn), this._onStackOrderChanged(Kn), !0;
      }
      return !1;
    }
    bringObjectForward(Kn, qn) {
      if (!Kn) return !1;
      const Jo = this._objects.indexOf(Kn);
      if (Jo !== this._objects.length - 1) {
        const pa = this.findNewUpperIndex(Kn, Jo, qn);
        return it(this._objects, Kn), this._objects.splice(pa, 0, Kn), this._onStackOrderChanged(Kn), !0;
      }
      return !1;
    }
    moveObjectTo(Kn, qn) {
      return Kn !== this._objects[qn] && (it(this._objects, Kn), this._objects.splice(qn, 0, Kn), this._onStackOrderChanged(Kn), !0);
    }
    findNewLowerIndex(Kn, qn, Jo) {
      let pa;
      if (Jo) {
        pa = qn;
        for (let ma = qn - 1; ma >= 0; --ma) if (Kn.isOverlapping(this._objects[ma])) {
          pa = ma;
          break;
        }
      } else pa = qn - 1;
      return pa;
    }
    findNewUpperIndex(Kn, qn, Jo) {
      let pa;
      if (Jo) {
        pa = qn;
        for (let ma = qn + 1; ma < this._objects.length; ++ma) if (Kn.isOverlapping(this._objects[ma])) {
          pa = ma;
          break;
        }
      } else pa = qn + 1;
      return pa;
    }
    collectObjects(Kn) {
      let { left: qn, top: Jo, width: pa, height: ma } = Kn, { includeIntersecting: va = !0 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const ba = [], _a = new ot(qn, Jo), ya = _a.add(new ot(pa, ma));
      for (let xa = this._objects.length - 1; xa >= 0; xa--) {
        const wa = this._objects[xa];
        wa.selectable && wa.visible && (va && wa.intersectsWithRect(_a, ya) || wa.isContainedWithinRect(_a, ya) || va && wa.containsPoint(_a) || va && wa.containsPoint(ya)) && ba.push(wa);
      }
      return ba;
    }
  }
  return zn;
}
class lt extends st {
  _setOptions() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    for (const Un in zn) this.set(Un, zn[Un]);
  }
  _setObject(zn) {
    for (const Un in zn) this._set(Un, zn[Un]);
  }
  set(zn, Un) {
    return typeof zn == "object" ? this._setObject(zn) : this._set(zn, Un), this;
  }
  _set(zn, Un) {
    this[zn] = Un;
  }
  toggle(zn) {
    const Un = this.get(zn);
    return typeof Un == "boolean" && this.set(zn, !Un), this;
  }
  get(zn) {
    return this[zn];
  }
}
function ut(Xn) {
  return v$1().requestAnimationFrame(Xn);
}
function dt(Xn) {
  return v$1().cancelAnimationFrame(Xn);
}
let gt = 0;
const ft = () => gt++, pt = () => {
  const Xn = m().createElement("canvas");
  if (!Xn || Xn.getContext === void 0) throw new h$1("Failed to create `canvas` element");
  return Xn;
}, mt = () => m().createElement("img"), vt = (Xn) => {
  const zn = pt();
  return zn.width = Xn.width, zn.height = Xn.height, zn;
}, yt = (Xn, zn, Un) => Xn.toDataURL("image/".concat(zn), Un), _t = (Xn, zn, Un) => new Promise((Kn, qn) => {
  Xn.toBlob(Kn, "image/".concat(zn), Un);
}), xt = (Xn) => Xn * S$1, Ct = (Xn) => Xn / S$1, bt = (Xn) => Xn.every((zn, Un) => zn === T$1[Un]), wt = (Xn, zn, Un) => new ot(Xn).transform(zn, Un), St = (Xn) => {
  const zn = 1 / (Xn[0] * Xn[3] - Xn[1] * Xn[2]), Un = [zn * Xn[3], -zn * Xn[1], -zn * Xn[2], zn * Xn[0], 0, 0], { x: Kn, y: qn } = new ot(Xn[4], Xn[5]).transform(Un, !0);
  return Un[4] = -Kn, Un[5] = -qn, Un;
}, Tt = (Xn, zn, Un) => [Xn[0] * zn[0] + Xn[2] * zn[1], Xn[1] * zn[0] + Xn[3] * zn[1], Xn[0] * zn[2] + Xn[2] * zn[3], Xn[1] * zn[2] + Xn[3] * zn[3], Un ? 0 : Xn[0] * zn[4] + Xn[2] * zn[5] + Xn[4], Un ? 0 : Xn[1] * zn[4] + Xn[3] * zn[5] + Xn[5]], Ot = (Xn, zn) => Xn.reduceRight((Un, Kn) => Kn && Un ? Tt(Kn, Un, zn) : Kn || Un, void 0) || T$1.concat(), kt = (Xn) => {
  let [zn, Un] = Xn;
  return Math.atan2(Un, zn);
}, Dt = (Xn) => {
  const zn = kt(Xn), Un = Math.pow(Xn[0], 2) + Math.pow(Xn[1], 2), Kn = Math.sqrt(Un), qn = (Xn[0] * Xn[3] - Xn[2] * Xn[1]) / Kn, Jo = Math.atan2(Xn[0] * Xn[2] + Xn[1] * Xn[3], Un);
  return { angle: Ct(zn), scaleX: Kn, scaleY: qn, skewX: Ct(Jo), skewY: 0, translateX: Xn[4] || 0, translateY: Xn[5] || 0 };
}, Mt = function(Xn) {
  return [1, 0, 0, 1, Xn, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0];
};
function Pt() {
  let { angle: Xn = 0 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { x: zn = 0, y: Un = 0 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const Kn = xt(Xn), qn = rt(Kn), Jo = nt(Kn);
  return [qn, Jo, -Jo, qn, zn ? zn - (qn * zn - Jo * Un) : 0, Un ? Un - (Jo * zn + qn * Un) : 0];
}
const Et = function(Xn) {
  return [Xn, 0, 0, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn, 0, 0];
}, At = (Xn) => Math.tan(xt(Xn)), jt = (Xn) => [1, 0, At(Xn), 1, 0, 0], Ft = (Xn) => [1, At(Xn), 0, 1, 0, 0], Lt = (Xn) => {
  let { scaleX: zn = 1, scaleY: Un = 1, flipX: Kn = !1, flipY: qn = !1, skewX: Jo = 0, skewY: pa = 0 } = Xn, ma = Et(Kn ? -zn : zn, qn ? -Un : Un);
  return Jo && (ma = Tt(ma, jt(Jo), !0)), pa && (ma = Tt(ma, Ft(pa), !0)), ma;
}, Rt = (Xn) => {
  const { translateX: zn = 0, translateY: Un = 0, angle: Kn = 0 } = Xn;
  let qn = Mt(zn, Un);
  Kn && (qn = Tt(qn, Pt({ angle: Kn })));
  const Jo = Lt(Xn);
  return bt(Jo) || (qn = Tt(qn, Jo)), qn;
}, It = function(Xn) {
  let { signal: zn, crossOrigin: Un = null } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(Kn, qn) {
    if (zn && zn.aborted) return qn(new c$2("loadImage"));
    const Jo = mt();
    let pa;
    zn && (pa = function(va) {
      Jo.src = "", qn(va);
    }, zn.addEventListener("abort", pa, { once: !0 }));
    const ma = function() {
      Jo.onload = Jo.onerror = null, pa && (zn == null || zn.removeEventListener("abort", pa)), Kn(Jo);
    };
    Xn ? (Jo.onload = ma, Jo.onerror = function() {
      pa && (zn == null || zn.removeEventListener("abort", pa)), qn(new h$1("Error loading ".concat(Jo.src)));
    }, Un && (Jo.crossOrigin = Un), Jo.src = Xn) : ma();
  });
}, Bt = function(Xn) {
  let { signal: zn, reviver: Un = C$1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise((Kn, qn) => {
    const Jo = [];
    zn && zn.addEventListener("abort", qn, { once: !0 }), Promise.all(Xn.map((pa) => tt.getClass(pa.type).fromObject(pa, { signal: zn }).then((ma) => (Un(pa, ma), Jo.push(ma), ma)))).then(Kn).catch((pa) => {
      Jo.forEach((ma) => {
        ma.dispose && ma.dispose();
      }), qn(pa);
    }).finally(() => {
      zn && zn.removeEventListener("abort", qn);
    });
  });
}, Xt = function(Xn) {
  let { signal: zn } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise((Un, Kn) => {
    const qn = [];
    zn && zn.addEventListener("abort", Kn, { once: !0 });
    const Jo = Object.values(Xn).map((ma) => ma && ma.type && tt.has(ma.type) ? Bt([ma], { signal: zn }).then((va) => {
      let [ba] = va;
      return qn.push(ba), ba;
    }) : ma), pa = Object.keys(Xn);
    Promise.all(Jo).then((ma) => ma.reduce((va, ba, _a) => (va[pa[_a]] = ba, va), {})).then(Un).catch((ma) => {
      qn.forEach((va) => {
        va.dispose && va.dispose();
      }), Kn(ma);
    }).finally(() => {
      zn && zn.removeEventListener("abort", Kn);
    });
  });
}, Yt = function(Xn) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : []).reduce((zn, Un) => (Un in Xn && (zn[Un] = Xn[Un]), zn), {});
}, Wt = (Xn, zn) => Object.keys(Xn).reduce((Un, Kn) => (zn(Xn[Kn], Kn, Xn) && (Un[Kn] = Xn[Kn]), Un), {}), Vt = (Xn, zn) => parseFloat(Number(Xn).toFixed(zn)), zt = (Xn) => "matrix(" + Xn.map((zn) => Vt(zn, o$1.NUM_FRACTION_DIGITS)).join(" ") + ")", Gt = (Xn) => !!Xn && Xn.toLive !== void 0, Ht = (Xn) => !!Xn && typeof Xn.toObject == "function", Nt = (Xn) => !!Xn && Xn.offsetX !== void 0 && "source" in Xn, Ut = (Xn) => !!Xn && "multiSelectionStacking" in Xn;
function qt(Xn) {
  const zn = Xn && Kt(Xn);
  let Un = 0, Kn = 0;
  if (!Xn || !zn) return { left: Un, top: Kn };
  let qn = Xn;
  const Jo = zn.documentElement, pa = zn.body || { scrollLeft: 0, scrollTop: 0 };
  for (; qn && (qn.parentNode || qn.host) && (qn = qn.parentNode || qn.host, qn === zn ? (Un = pa.scrollLeft || Jo.scrollLeft || 0, Kn = pa.scrollTop || Jo.scrollTop || 0) : (Un += qn.scrollLeft || 0, Kn += qn.scrollTop || 0), qn.nodeType !== 1 || qn.style.position !== "fixed"); ) ;
  return { left: Un, top: Kn };
}
const Kt = (Xn) => Xn.ownerDocument || null, Jt = (Xn) => {
  var zn;
  return ((zn = Xn.ownerDocument) === null || zn === void 0 ? void 0 : zn.defaultView) || null;
}, Qt = function(Xn, zn, Un) {
  let { width: Kn, height: qn } = Un, Jo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  Xn.width = Kn, Xn.height = qn, Jo > 1 && (Xn.setAttribute("width", (Kn * Jo).toString()), Xn.setAttribute("height", (qn * Jo).toString()), zn.scale(Jo, Jo));
}, Zt = (Xn, zn) => {
  let { width: Un, height: Kn } = zn;
  Un && (Xn.style.width = typeof Un == "number" ? "".concat(Un, "px") : Un), Kn && (Xn.style.height = typeof Kn == "number" ? "".concat(Kn, "px") : Kn);
};
function $t(Xn) {
  return Xn.onselectstart !== void 0 && (Xn.onselectstart = () => !1), Xn.style.userSelect = j, Xn;
}
class te {
  constructor(zn) {
    t$1(this, "_originalCanvasStyle", void 0), t$1(this, "lower", void 0);
    const Un = this.createLowerCanvas(zn);
    this.lower = { el: Un, ctx: Un.getContext("2d") };
  }
  createLowerCanvas(zn) {
    const Un = (Kn = zn) && Kn.getContext !== void 0 ? zn : zn && m().getElementById(zn) || pt();
    var Kn;
    if (Un.hasAttribute("data-fabric")) throw new h$1("Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?");
    return this._originalCanvasStyle = Un.style.cssText, Un.setAttribute("data-fabric", "main"), Un.classList.add("lower-canvas"), Un;
  }
  cleanupDOM(zn) {
    let { width: Un, height: Kn } = zn;
    const { el: qn } = this.lower;
    qn.classList.remove("lower-canvas"), qn.removeAttribute("data-fabric"), qn.setAttribute("width", "".concat(Un)), qn.setAttribute("height", "".concat(Kn)), qn.style.cssText = this._originalCanvasStyle || "", this._originalCanvasStyle = void 0;
  }
  setDimensions(zn, Un) {
    const { el: Kn, ctx: qn } = this.lower;
    Qt(Kn, qn, zn, Un);
  }
  setCSSDimensions(zn) {
    Zt(this.lower.el, zn);
  }
  calcOffset() {
    return function(zn) {
      var Un;
      const Kn = zn && Kt(zn), qn = { left: 0, top: 0 };
      if (!Kn) return qn;
      const Jo = ((Un = Jt(zn)) === null || Un === void 0 ? void 0 : Un.getComputedStyle(zn, null)) || {};
      qn.left += parseInt(Jo.borderLeftWidth, 10) || 0, qn.top += parseInt(Jo.borderTopWidth, 10) || 0, qn.left += parseInt(Jo.paddingLeft, 10) || 0, qn.top += parseInt(Jo.paddingTop, 10) || 0;
      let pa = { left: 0, top: 0 };
      const ma = Kn.documentElement;
      zn.getBoundingClientRect !== void 0 && (pa = zn.getBoundingClientRect());
      const va = qt(zn);
      return { left: pa.left + va.left - (ma.clientLeft || 0) + qn.left, top: pa.top + va.top - (ma.clientTop || 0) + qn.top };
    }(this.lower.el);
  }
  dispose() {
    p$1().dispose(this.lower.el), delete this.lower;
  }
}
const ee = { backgroundVpt: !0, backgroundColor: "", overlayVpt: !0, overlayColor: "", includeDefaultValues: !0, svgViewportTransformation: !0, renderOnAddRemove: !0, skipOffscreen: !0, enableRetinaScaling: !0, imageSmoothingEnabled: !0, controlsAboveOverlay: !1, allowTouchScrolling: !1, viewportTransform: [...T$1] };
class se extends ct(lt) {
  get lowerCanvasEl() {
    var zn;
    return (zn = this.elements.lower) === null || zn === void 0 ? void 0 : zn.el;
  }
  get contextContainer() {
    var zn;
    return (zn = this.elements.lower) === null || zn === void 0 ? void 0 : zn.ctx;
  }
  static getDefaults() {
    return se.ownDefaults;
  }
  constructor(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Object.assign(this, this.constructor.getDefaults()), this.set(Un), this.initElements(zn), this._setDimensionsImpl({ width: this.width || this.elements.lower.el.width || 0, height: this.height || this.elements.lower.el.height || 0 }), this.skipControlsDrawing = !1, this.viewportTransform = [...this.viewportTransform], this.calcViewportBoundaries();
  }
  initElements(zn) {
    this.elements = new te(zn);
  }
  add() {
    const zn = super.add(...arguments);
    return arguments.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), zn;
  }
  insertAt(zn) {
    for (var Un = arguments.length, Kn = new Array(Un > 1 ? Un - 1 : 0), qn = 1; qn < Un; qn++) Kn[qn - 1] = arguments[qn];
    const Jo = super.insertAt(zn, ...Kn);
    return Kn.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), Jo;
  }
  remove() {
    const zn = super.remove(...arguments);
    return zn.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), zn;
  }
  _onObjectAdded(zn) {
    zn.canvas && zn.canvas !== this && (a$1("warn", `Canvas is trying to add an object that belongs to a different canvas.
Resulting to default behavior: removing object from previous canvas and adding to new canvas`), zn.canvas.remove(zn)), zn._set("canvas", this), zn.setCoords(), this.fire("object:added", { target: zn }), zn.fire("added", { target: this });
  }
  _onObjectRemoved(zn) {
    zn._set("canvas", void 0), this.fire("object:removed", { target: zn }), zn.fire("removed", { target: this });
  }
  _onStackOrderChanged() {
    this.renderOnAddRemove && this.requestRenderAll();
  }
  getRetinaScaling() {
    return this.enableRetinaScaling ? y$3() : 1;
  }
  calcOffset() {
    return this._offset = this.elements.calcOffset();
  }
  getWidth() {
    return this.width;
  }
  getHeight() {
    return this.height;
  }
  setWidth(zn, Un) {
    return this.setDimensions({ width: zn }, Un);
  }
  setHeight(zn, Un) {
    return this.setDimensions({ height: zn }, Un);
  }
  _setDimensionsImpl(zn) {
    let { cssOnly: Un = !1, backstoreOnly: Kn = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!Un) {
      const qn = s$1({ width: this.width, height: this.height }, zn);
      this.elements.setDimensions(qn, this.getRetinaScaling()), this.hasLostContext = !0, this.width = qn.width, this.height = qn.height;
    }
    Kn || this.elements.setCSSDimensions(zn), this.calcOffset();
  }
  setDimensions(zn, Un) {
    this._setDimensionsImpl(zn, Un), Un && Un.cssOnly || this.requestRenderAll();
  }
  getZoom() {
    return this.viewportTransform[0];
  }
  setViewportTransform(zn) {
    this.viewportTransform = zn, this.calcViewportBoundaries(), this.renderOnAddRemove && this.requestRenderAll();
  }
  zoomToPoint(zn, Un) {
    const Kn = zn, qn = [...this.viewportTransform], Jo = wt(zn, St(qn));
    qn[0] = Un, qn[3] = Un;
    const pa = wt(Jo, qn);
    qn[4] += Kn.x - pa.x, qn[5] += Kn.y - pa.y, this.setViewportTransform(qn);
  }
  setZoom(zn) {
    this.zoomToPoint(new ot(0, 0), zn);
  }
  absolutePan(zn) {
    const Un = [...this.viewportTransform];
    return Un[4] = -zn.x, Un[5] = -zn.y, this.setViewportTransform(Un);
  }
  relativePan(zn) {
    return this.absolutePan(new ot(-zn.x - this.viewportTransform[4], -zn.y - this.viewportTransform[5]));
  }
  getElement() {
    return this.elements.lower.el;
  }
  clearContext(zn) {
    zn.clearRect(0, 0, this.width, this.height);
  }
  getContext() {
    return this.elements.lower.ctx;
  }
  clear() {
    this.remove(...this.getObjects()), this.backgroundImage = void 0, this.overlayImage = void 0, this.backgroundColor = "", this.overlayColor = "", this.clearContext(this.getContext()), this.fire("canvas:cleared"), this.renderOnAddRemove && this.requestRenderAll();
  }
  renderAll() {
    this.cancelRequestedRender(), this.destroyed || this.renderCanvas(this.getContext(), this._objects);
  }
  renderAndReset() {
    this.nextRenderHandle = 0, this.renderAll();
  }
  requestRenderAll() {
    this.nextRenderHandle || this.disposed || this.destroyed || (this.nextRenderHandle = ut(() => this.renderAndReset()));
  }
  calcViewportBoundaries() {
    const zn = this.width, Un = this.height, Kn = St(this.viewportTransform), qn = wt({ x: 0, y: 0 }, Kn), Jo = wt({ x: zn, y: Un }, Kn), pa = qn.min(Jo), ma = qn.max(Jo);
    return this.vptCoords = { tl: pa, tr: new ot(ma.x, pa.y), bl: new ot(pa.x, ma.y), br: ma };
  }
  cancelRequestedRender() {
    this.nextRenderHandle && (dt(this.nextRenderHandle), this.nextRenderHandle = 0);
  }
  drawControls(zn) {
  }
  renderCanvas(zn, Un) {
    if (this.destroyed) return;
    const Kn = this.viewportTransform, qn = this.clipPath;
    this.calcViewportBoundaries(), this.clearContext(zn), zn.imageSmoothingEnabled = this.imageSmoothingEnabled, zn.patternQuality = "best", this.fire("before:render", { ctx: zn }), this._renderBackground(zn), zn.save(), zn.transform(Kn[0], Kn[1], Kn[2], Kn[3], Kn[4], Kn[5]), this._renderObjects(zn, Un), zn.restore(), this.controlsAboveOverlay || this.skipControlsDrawing || this.drawControls(zn), qn && (qn._set("canvas", this), qn.shouldCache(), qn._transformDone = !0, qn.renderCache({ forClipping: !0 }), this.drawClipPathOnCanvas(zn, qn)), this._renderOverlay(zn), this.controlsAboveOverlay && !this.skipControlsDrawing && this.drawControls(zn), this.fire("after:render", { ctx: zn }), this.__cleanupTask && (this.__cleanupTask(), this.__cleanupTask = void 0);
  }
  drawClipPathOnCanvas(zn, Un) {
    const Kn = this.viewportTransform;
    zn.save(), zn.transform(...Kn), zn.globalCompositeOperation = "destination-in", Un.transform(zn), zn.scale(1 / Un.zoomX, 1 / Un.zoomY), zn.drawImage(Un._cacheCanvas, -Un.cacheTranslationX, -Un.cacheTranslationY), zn.restore();
  }
  _renderObjects(zn, Un) {
    for (let Kn = 0, qn = Un.length; Kn < qn; ++Kn) Un[Kn] && Un[Kn].render(zn);
  }
  _renderBackgroundOrOverlay(zn, Un) {
    const Kn = this["".concat(Un, "Color")], qn = this["".concat(Un, "Image")], Jo = this.viewportTransform, pa = this["".concat(Un, "Vpt")];
    if (!Kn && !qn) return;
    const ma = Gt(Kn);
    if (Kn) {
      if (zn.save(), zn.beginPath(), zn.moveTo(0, 0), zn.lineTo(this.width, 0), zn.lineTo(this.width, this.height), zn.lineTo(0, this.height), zn.closePath(), zn.fillStyle = ma ? Kn.toLive(zn) : Kn, pa && zn.transform(...Jo), ma) {
        zn.transform(1, 0, 0, 1, Kn.offsetX || 0, Kn.offsetY || 0);
        const va = Kn.gradientTransform || Kn.patternTransform;
        va && zn.transform(...va);
      }
      zn.fill(), zn.restore();
    }
    if (qn) {
      zn.save();
      const { skipOffscreen: va } = this;
      this.skipOffscreen = pa, pa && zn.transform(...Jo), qn.render(zn), this.skipOffscreen = va, zn.restore();
    }
  }
  _renderBackground(zn) {
    this._renderBackgroundOrOverlay(zn, "background");
  }
  _renderOverlay(zn) {
    this._renderBackgroundOrOverlay(zn, "overlay");
  }
  getCenter() {
    return { top: this.height / 2, left: this.width / 2 };
  }
  getCenterPoint() {
    return new ot(this.width / 2, this.height / 2);
  }
  centerObjectH(zn) {
    return this._centerObject(zn, new ot(this.getCenterPoint().x, zn.getCenterPoint().y));
  }
  centerObjectV(zn) {
    return this._centerObject(zn, new ot(zn.getCenterPoint().x, this.getCenterPoint().y));
  }
  centerObject(zn) {
    return this._centerObject(zn, this.getCenterPoint());
  }
  viewportCenterObject(zn) {
    return this._centerObject(zn, this.getVpCenter());
  }
  viewportCenterObjectH(zn) {
    return this._centerObject(zn, new ot(this.getVpCenter().x, zn.getCenterPoint().y));
  }
  viewportCenterObjectV(zn) {
    return this._centerObject(zn, new ot(zn.getCenterPoint().x, this.getVpCenter().y));
  }
  getVpCenter() {
    return wt(this.getCenterPoint(), St(this.viewportTransform));
  }
  _centerObject(zn, Un) {
    zn.setXY(Un, D, D), zn.setCoords(), this.renderOnAddRemove && this.requestRenderAll();
  }
  toDatalessJSON(zn) {
    return this.toDatalessObject(zn);
  }
  toObject(zn) {
    return this._toObjectMethod("toObject", zn);
  }
  toJSON() {
    return this.toObject();
  }
  toDatalessObject(zn) {
    return this._toObjectMethod("toDatalessObject", zn);
  }
  _toObjectMethod(zn, Un) {
    const Kn = this.clipPath, qn = Kn && !Kn.excludeFromExport ? this._toObject(Kn, zn, Un) : null;
    return s$1(s$1(s$1({ version: x$3 }, Yt(this, Un)), {}, { objects: this._objects.filter((Jo) => !Jo.excludeFromExport).map((Jo) => this._toObject(Jo, zn, Un)) }, this.__serializeBgOverlay(zn, Un)), qn ? { clipPath: qn } : null);
  }
  _toObject(zn, Un, Kn) {
    let qn;
    this.includeDefaultValues || (qn = zn.includeDefaultValues, zn.includeDefaultValues = !1);
    const Jo = zn[Un](Kn);
    return this.includeDefaultValues || (zn.includeDefaultValues = !!qn), Jo;
  }
  __serializeBgOverlay(zn, Un) {
    const Kn = {}, qn = this.backgroundImage, Jo = this.overlayImage, pa = this.backgroundColor, ma = this.overlayColor;
    return Gt(pa) ? pa.excludeFromExport || (Kn.background = pa.toObject(Un)) : pa && (Kn.background = pa), Gt(ma) ? ma.excludeFromExport || (Kn.overlay = ma.toObject(Un)) : ma && (Kn.overlay = ma), qn && !qn.excludeFromExport && (Kn.backgroundImage = this._toObject(qn, zn, Un)), Jo && !Jo.excludeFromExport && (Kn.overlayImage = this._toObject(Jo, zn, Un)), Kn;
  }
  toSVG() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Un = arguments.length > 1 ? arguments[1] : void 0;
    zn.reviver = Un;
    const Kn = [];
    return this._setSVGPreamble(Kn, zn), this._setSVGHeader(Kn, zn), this.clipPath && Kn.push('<g clip-path="url(#'.concat(this.clipPath.clipPathId, `)" >
`)), this._setSVGBgOverlayColor(Kn, "background"), this._setSVGBgOverlayImage(Kn, "backgroundImage", Un), this._setSVGObjects(Kn, Un), this.clipPath && Kn.push(`</g>
`), this._setSVGBgOverlayColor(Kn, "overlay"), this._setSVGBgOverlayImage(Kn, "overlayImage", Un), Kn.push("</svg>"), Kn.join("");
  }
  _setSVGPreamble(zn, Un) {
    Un.suppressPreamble || zn.push('<?xml version="1.0" encoding="', Un.encoding || "UTF-8", `" standalone="no" ?>
`, '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', `"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
`);
  }
  _setSVGHeader(zn, Un) {
    const Kn = Un.width || "".concat(this.width), qn = Un.height || "".concat(this.height), Jo = o$1.NUM_FRACTION_DIGITS, pa = Un.viewBox;
    let ma;
    if (pa) ma = 'viewBox="'.concat(pa.x, " ").concat(pa.y, " ").concat(pa.width, " ").concat(pa.height, '" ');
    else if (this.svgViewportTransformation) {
      const va = this.viewportTransform;
      ma = 'viewBox="'.concat(Vt(-va[4] / va[0], Jo), " ").concat(Vt(-va[5] / va[3], Jo), " ").concat(Vt(this.width / va[0], Jo), " ").concat(Vt(this.height / va[3], Jo), '" ');
    } else ma = 'viewBox="0 0 '.concat(this.width, " ").concat(this.height, '" ');
    zn.push("<svg ", 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', Kn, '" ', 'height="', qn, '" ', ma, `xml:space="preserve">
`, "<desc>Created with Fabric.js ", x$3, `</desc>
`, `<defs>
`, this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(Un), `</defs>
`);
  }
  createSVGClipPathMarkup(zn) {
    const Un = this.clipPath;
    return Un ? (Un.clipPathId = "CLIPPATH_".concat(ft()), '<clipPath id="'.concat(Un.clipPathId, `" >
`).concat(Un.toClipPathSVG(zn.reviver), `</clipPath>
`)) : "";
  }
  createSVGRefElementsMarkup() {
    return ["background", "overlay"].map((zn) => {
      const Un = this["".concat(zn, "Color")];
      if (Gt(Un)) {
        const Kn = this["".concat(zn, "Vpt")], qn = this.viewportTransform, Jo = { isType: () => !1, width: this.width / (Kn ? qn[0] : 1), height: this.height / (Kn ? qn[3] : 1) };
        return Un.toSVG(Jo, { additionalTransform: Kn ? zt(qn) : "" });
      }
    }).join("");
  }
  createSVGFontFacesMarkup() {
    const zn = [], Un = {}, Kn = o$1.fontPaths;
    this._objects.forEach(function Jo(pa) {
      zn.push(pa), ht(pa) && pa._objects.forEach(Jo);
    }), zn.forEach((Jo) => {
      if (!(pa = Jo) || typeof pa._renderText != "function") return;
      var pa;
      const { styles: ma, fontFamily: va } = Jo;
      !Un[va] && Kn[va] && (Un[va] = !0, ma && Object.values(ma).forEach((ba) => {
        Object.values(ba).forEach((_a) => {
          let { fontFamily: ya = "" } = _a;
          !Un[ya] && Kn[ya] && (Un[ya] = !0);
        });
      }));
    });
    const qn = Object.keys(Un).map((Jo) => `		@font-face {
			font-family: '`.concat(Jo, `';
			src: url('`).concat(Kn[Jo], `');
		}
`)).join("");
    return qn ? `	<style type="text/css"><![CDATA[
`.concat(qn, `]]></style>
`) : "";
  }
  _setSVGObjects(zn, Un) {
    this.forEachObject((Kn) => {
      Kn.excludeFromExport || this._setSVGObject(zn, Kn, Un);
    });
  }
  _setSVGObject(zn, Un, Kn) {
    zn.push(Un.toSVG(Kn));
  }
  _setSVGBgOverlayImage(zn, Un, Kn) {
    const qn = this[Un];
    qn && !qn.excludeFromExport && qn.toSVG && zn.push(qn.toSVG(Kn));
  }
  _setSVGBgOverlayColor(zn, Un) {
    const Kn = this["".concat(Un, "Color")];
    if (Kn) if (Gt(Kn)) {
      const qn = Kn.repeat || "", Jo = this.width, pa = this.height, ma = this["".concat(Un, "Vpt")] ? zt(St(this.viewportTransform)) : "";
      zn.push('<rect transform="'.concat(ma, " translate(").concat(Jo / 2, ",").concat(pa / 2, ')" x="').concat(Kn.offsetX - Jo / 2, '" y="').concat(Kn.offsetY - pa / 2, '" width="').concat(qn !== "repeat-y" && qn !== "no-repeat" || !Nt(Kn) ? Jo : Kn.source.width, '" height="').concat(qn !== "repeat-x" && qn !== "no-repeat" || !Nt(Kn) ? pa : Kn.source.height, '" fill="url(#SVGID_').concat(Kn.id, `)"></rect>
`));
    } else zn.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', Kn, '"', `></rect>
`);
  }
  loadFromJSON(zn, Un) {
    let { signal: Kn } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!zn) return Promise.reject(new h$1("`json` is undefined"));
    const qn = typeof zn == "string" ? JSON.parse(zn) : zn, { objects: Jo = [], backgroundImage: pa, background: ma, overlayImage: va, overlay: ba, clipPath: _a } = qn, ya = this.renderOnAddRemove;
    return this.renderOnAddRemove = !1, Promise.all([Bt(Jo, { reviver: Un, signal: Kn }), Xt({ backgroundImage: pa, backgroundColor: ma, overlayImage: va, overlayColor: ba, clipPath: _a }, { signal: Kn })]).then((xa) => {
      let [wa, Ta] = xa;
      return this.clear(), this.add(...wa), this.set(qn), this.set(Ta), this.renderOnAddRemove = ya, this;
    });
  }
  clone(zn) {
    const Un = this.toObject(zn);
    return this.cloneWithoutData().loadFromJSON(Un);
  }
  cloneWithoutData() {
    const zn = vt(this);
    return new this.constructor(zn);
  }
  toDataURL() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { format: Un = "png", quality: Kn = 1, multiplier: qn = 1, enableRetinaScaling: Jo = !1 } = zn, pa = qn * (Jo ? this.getRetinaScaling() : 1);
    return yt(this.toCanvasElement(pa, zn), Un, Kn);
  }
  toBlob() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { format: Un = "png", quality: Kn = 1, multiplier: qn = 1, enableRetinaScaling: Jo = !1 } = zn, pa = qn * (Jo ? this.getRetinaScaling() : 1);
    return _t(this.toCanvasElement(pa, zn), Un, Kn);
  }
  toCanvasElement() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, { width: Un, height: Kn, left: qn, top: Jo, filter: pa } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const ma = (Un || this.width) * zn, va = (Kn || this.height) * zn, ba = this.getZoom(), _a = this.width, ya = this.height, xa = this.skipControlsDrawing, wa = ba * zn, Ta = this.viewportTransform, Sa = [wa, 0, 0, wa, (Ta[4] - (qn || 0)) * zn, (Ta[5] - (Jo || 0)) * zn], Ma = this.enableRetinaScaling, ka = vt({ width: ma, height: va }), Za = pa ? this._objects.filter((Na) => pa(Na)) : this._objects;
    return this.enableRetinaScaling = !1, this.viewportTransform = Sa, this.width = ma, this.height = va, this.skipControlsDrawing = !0, this.calcViewportBoundaries(), this.renderCanvas(ka.getContext("2d"), Za), this.viewportTransform = Ta, this.width = _a, this.height = ya, this.calcViewportBoundaries(), this.enableRetinaScaling = Ma, this.skipControlsDrawing = xa, ka;
  }
  dispose() {
    return !this.disposed && this.elements.cleanupDOM({ width: this.width, height: this.height }), et.cancelByCanvas(this), this.disposed = !0, new Promise((zn, Un) => {
      const Kn = () => {
        this.destroy(), zn(!0);
      };
      Kn.kill = Un, this.__cleanupTask && this.__cleanupTask.kill("aborted"), this.destroyed ? zn(!1) : this.nextRenderHandle ? this.__cleanupTask = Kn : Kn();
    });
  }
  destroy() {
    this.destroyed = !0, this.cancelRequestedRender(), this.forEachObject((zn) => zn.dispose()), this._objects = [], this.backgroundImage && this.backgroundImage.dispose(), this.backgroundImage = void 0, this.overlayImage && this.overlayImage.dispose(), this.overlayImage = void 0, this.elements.dispose();
  }
  toString() {
    return "#<Canvas (".concat(this.complexity(), "): { objects: ").concat(this._objects.length, " }>");
  }
}
t$1(se, "ownDefaults", ee);
const ie = ["touchstart", "touchmove", "touchend"], re = (Xn) => {
  const zn = qt(Xn.target), Un = function(Kn) {
    const qn = Kn.changedTouches;
    return qn && qn[0] ? qn[0] : Kn;
  }(Xn);
  return new ot(Un.clientX + zn.left, Un.clientY + zn.top);
}, ne = (Xn) => ie.includes(Xn.type) || Xn.pointerType === "touch", oe = (Xn) => {
  Xn.preventDefault(), Xn.stopPropagation();
}, ae = (Xn) => {
  let zn = 0, Un = 0, Kn = 0, qn = 0;
  for (let Jo = 0, pa = Xn.length; Jo < pa; Jo++) {
    const { x: ma, y: va } = Xn[Jo];
    (ma > Kn || !Jo) && (Kn = ma), (ma < zn || !Jo) && (zn = ma), (va > qn || !Jo) && (qn = va), (va < Un || !Jo) && (Un = va);
  }
  return { left: zn, top: Un, width: Kn - zn, height: qn - Un };
}, he = ["translateX", "translateY", "scaleX", "scaleY"], ce = (Xn, zn) => le(Xn, Tt(zn, Xn.calcOwnMatrix())), le = (Xn, zn) => {
  const Un = Dt(zn), { translateX: Kn, translateY: qn, scaleX: Jo, scaleY: pa } = Un, ma = i$3(Un, he), va = new ot(Kn, qn);
  Xn.flipX = !1, Xn.flipY = !1, Object.assign(Xn, ma), Xn.set({ scaleX: Jo, scaleY: pa }), Xn.setPositionByOrigin(va, D, D);
}, ue = (Xn) => {
  Xn.scaleX = 1, Xn.scaleY = 1, Xn.skewX = 0, Xn.skewY = 0, Xn.flipX = !1, Xn.flipY = !1, Xn.rotate(0);
}, de = (Xn) => ({ scaleX: Xn.scaleX, scaleY: Xn.scaleY, skewX: Xn.skewX, skewY: Xn.skewY, angle: Xn.angle, left: Xn.left, flipX: Xn.flipX, flipY: Xn.flipY, top: Xn.top }), ge = (Xn, zn, Un) => {
  const Kn = Xn / 2, qn = zn / 2, Jo = [new ot(-Kn, -qn), new ot(Kn, -qn), new ot(-Kn, qn), new ot(Kn, qn)].map((ma) => ma.transform(Un)), pa = ae(Jo);
  return new ot(pa.width, pa.height);
}, fe = function() {
  let Xn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : T$1;
  return Tt(St(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : T$1), Xn);
}, pe = function(Xn) {
  let zn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : T$1, Un = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : T$1;
  return Xn.transform(fe(zn, Un));
}, me = function(Xn) {
  let zn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : T$1, Un = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : T$1;
  return Xn.transform(fe(zn, Un), !0);
}, ve = (Xn, zn, Un) => {
  const Kn = fe(zn, Un);
  return le(Xn, Tt(Kn, Xn.calcOwnMatrix())), Kn;
}, ye = (Xn, zn) => {
  var Un;
  const { transform: { target: Kn } } = zn;
  (Un = Kn.canvas) === null || Un === void 0 || Un.fire("object:".concat(Xn), s$1(s$1({}, zn), {}, { target: Kn })), Kn.fire(Xn, zn);
}, _e = { left: -0.5, top: -0.5, center: 0, bottom: 0.5, right: 0.5 }, xe = (Xn) => typeof Xn == "string" ? _e[Xn] : Xn - 0.5, Ce = "not-allowed";
function be(Xn) {
  return xe(Xn.originX) === xe(D) && xe(Xn.originY) === xe(D);
}
function we(Xn) {
  return 0.5 - xe(Xn);
}
const Se = (Xn, zn) => Xn[zn], Te = (Xn, zn, Un, Kn) => ({ e: Xn, transform: zn, pointer: new ot(Un, Kn) });
function Oe(Xn, zn) {
  const Un = Xn.getTotalAngle() + Ct(Math.atan2(zn.y, zn.x)) + 360;
  return Math.round(Un % 360 / 45);
}
function ke(Xn, zn, Un, Kn, qn) {
  var Jo;
  let { target: pa, corner: ma } = Xn;
  const va = pa.controls[ma], ba = ((Jo = pa.canvas) === null || Jo === void 0 ? void 0 : Jo.getZoom()) || 1, _a = pa.padding / ba, ya = function(xa, wa, Ta, Sa) {
    const Ma = xa.getRelativeCenterPoint(), ka = Ta !== void 0 && Sa !== void 0 ? xa.translateToGivenOrigin(Ma, D, D, Ta, Sa) : new ot(xa.left, xa.top);
    return (xa.angle ? wa.rotate(-xt(xa.angle), Ma) : wa).subtract(ka);
  }(pa, new ot(Kn, qn), zn, Un);
  return ya.x >= _a && (ya.x -= _a), ya.x <= -_a && (ya.x += _a), ya.y >= _a && (ya.y -= _a), ya.y <= _a && (ya.y += _a), ya.x -= va.offsetX, ya.y -= va.offsetY, ya;
}
const De = (Xn, zn, Un, Kn) => {
  const { target: qn, offsetX: Jo, offsetY: pa } = zn, ma = Un - Jo, va = Kn - pa, ba = !Se(qn, "lockMovementX") && qn.left !== ma, _a = !Se(qn, "lockMovementY") && qn.top !== va;
  return ba && qn.set(M$1, ma), _a && qn.set(P, va), (ba || _a) && ye(L$1, Te(Xn, zn, Un, Kn)), ba || _a;
}, Me = { aliceblue: "#F0F8FF", antiquewhite: "#FAEBD7", aqua: "#0FF", aquamarine: "#7FFFD4", azure: "#F0FFFF", beige: "#F5F5DC", bisque: "#FFE4C4", black: "#000", blanchedalmond: "#FFEBCD", blue: "#00F", blueviolet: "#8A2BE2", brown: "#A52A2A", burlywood: "#DEB887", cadetblue: "#5F9EA0", chartreuse: "#7FFF00", chocolate: "#D2691E", coral: "#FF7F50", cornflowerblue: "#6495ED", cornsilk: "#FFF8DC", crimson: "#DC143C", cyan: "#0FF", darkblue: "#00008B", darkcyan: "#008B8B", darkgoldenrod: "#B8860B", darkgray: "#A9A9A9", darkgrey: "#A9A9A9", darkgreen: "#006400", darkkhaki: "#BDB76B", darkmagenta: "#8B008B", darkolivegreen: "#556B2F", darkorange: "#FF8C00", darkorchid: "#9932CC", darkred: "#8B0000", darksalmon: "#E9967A", darkseagreen: "#8FBC8F", darkslateblue: "#483D8B", darkslategray: "#2F4F4F", darkslategrey: "#2F4F4F", darkturquoise: "#00CED1", darkviolet: "#9400D3", deeppink: "#FF1493", deepskyblue: "#00BFFF", dimgray: "#696969", dimgrey: "#696969", dodgerblue: "#1E90FF", firebrick: "#B22222", floralwhite: "#FFFAF0", forestgreen: "#228B22", fuchsia: "#F0F", gainsboro: "#DCDCDC", ghostwhite: "#F8F8FF", gold: "#FFD700", goldenrod: "#DAA520", gray: "#808080", grey: "#808080", green: "#008000", greenyellow: "#ADFF2F", honeydew: "#F0FFF0", hotpink: "#FF69B4", indianred: "#CD5C5C", indigo: "#4B0082", ivory: "#FFFFF0", khaki: "#F0E68C", lavender: "#E6E6FA", lavenderblush: "#FFF0F5", lawngreen: "#7CFC00", lemonchiffon: "#FFFACD", lightblue: "#ADD8E6", lightcoral: "#F08080", lightcyan: "#E0FFFF", lightgoldenrodyellow: "#FAFAD2", lightgray: "#D3D3D3", lightgrey: "#D3D3D3", lightgreen: "#90EE90", lightpink: "#FFB6C1", lightsalmon: "#FFA07A", lightseagreen: "#20B2AA", lightskyblue: "#87CEFA", lightslategray: "#789", lightslategrey: "#789", lightsteelblue: "#B0C4DE", lightyellow: "#FFFFE0", lime: "#0F0", limegreen: "#32CD32", linen: "#FAF0E6", magenta: "#F0F", maroon: "#800000", mediumaquamarine: "#66CDAA", mediumblue: "#0000CD", mediumorchid: "#BA55D3", mediumpurple: "#9370DB", mediumseagreen: "#3CB371", mediumslateblue: "#7B68EE", mediumspringgreen: "#00FA9A", mediumturquoise: "#48D1CC", mediumvioletred: "#C71585", midnightblue: "#191970", mintcream: "#F5FFFA", mistyrose: "#FFE4E1", moccasin: "#FFE4B5", navajowhite: "#FFDEAD", navy: "#000080", oldlace: "#FDF5E6", olive: "#808000", olivedrab: "#6B8E23", orange: "#FFA500", orangered: "#FF4500", orchid: "#DA70D6", palegoldenrod: "#EEE8AA", palegreen: "#98FB98", paleturquoise: "#AFEEEE", palevioletred: "#DB7093", papayawhip: "#FFEFD5", peachpuff: "#FFDAB9", peru: "#CD853F", pink: "#FFC0CB", plum: "#DDA0DD", powderblue: "#B0E0E6", purple: "#800080", rebeccapurple: "#639", red: "#F00", rosybrown: "#BC8F8F", royalblue: "#4169E1", saddlebrown: "#8B4513", salmon: "#FA8072", sandybrown: "#F4A460", seagreen: "#2E8B57", seashell: "#FFF5EE", sienna: "#A0522D", silver: "#C0C0C0", skyblue: "#87CEEB", slateblue: "#6A5ACD", slategray: "#708090", slategrey: "#708090", snow: "#FFFAFA", springgreen: "#00FF7F", steelblue: "#4682B4", tan: "#D2B48C", teal: "#008080", thistle: "#D8BFD8", tomato: "#FF6347", turquoise: "#40E0D0", violet: "#EE82EE", wheat: "#F5DEB3", white: "#FFF", whitesmoke: "#F5F5F5", yellow: "#FF0", yellowgreen: "#9ACD32" }, Pe = (Xn, zn, Un) => (Un < 0 && (Un += 1), Un > 1 && (Un -= 1), Un < 1 / 6 ? Xn + 6 * (zn - Xn) * Un : Un < 0.5 ? zn : Un < 2 / 3 ? Xn + (zn - Xn) * (2 / 3 - Un) * 6 : Xn), Ee = (Xn, zn, Un, Kn) => {
  Xn /= 255, zn /= 255, Un /= 255;
  const qn = Math.max(Xn, zn, Un), Jo = Math.min(Xn, zn, Un);
  let pa, ma;
  const va = (qn + Jo) / 2;
  if (qn === Jo) pa = ma = 0;
  else {
    const ba = qn - Jo;
    switch (ma = va > 0.5 ? ba / (2 - qn - Jo) : ba / (qn + Jo), qn) {
      case Xn:
        pa = (zn - Un) / ba + (zn < Un ? 6 : 0);
        break;
      case zn:
        pa = (Un - Xn) / ba + 2;
        break;
      case Un:
        pa = (Xn - zn) / ba + 4;
    }
    pa /= 6;
  }
  return [Math.round(360 * pa), Math.round(100 * ma), Math.round(100 * va), Kn];
}, Ae = function() {
  let Xn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1";
  return parseFloat(Xn) / (Xn.endsWith("%") ? 100 : 1);
}, je = (Xn) => Math.min(Math.round(Xn), 255).toString(16).toUpperCase().padStart(2, "0"), Fe = (Xn) => {
  let [zn, Un, Kn, qn = 1] = Xn;
  const Jo = Math.round(0.3 * zn + 0.59 * Un + 0.11 * Kn);
  return [Jo, Jo, Jo, qn];
};
class Le {
  constructor(zn) {
    if (t$1(this, "isUnrecognised", !1), zn) if (zn instanceof Le) this.setSource([...zn._source]);
    else if (Array.isArray(zn)) {
      const [Un, Kn, qn, Jo = 1] = zn;
      this.setSource([Un, Kn, qn, Jo]);
    } else this.setSource(this._tryParsingColor(zn));
    else this.setSource([0, 0, 0, 1]);
  }
  _tryParsingColor(zn) {
    return (zn = zn.toLowerCase()) in Me && (zn = Me[zn]), zn === "transparent" ? [255, 255, 255, 0] : Le.sourceFromHex(zn) || Le.sourceFromRgb(zn) || Le.sourceFromHsl(zn) || (this.isUnrecognised = !0) && [0, 0, 0, 1];
  }
  getSource() {
    return this._source;
  }
  setSource(zn) {
    this._source = zn;
  }
  toRgb() {
    const [zn, Un, Kn] = this.getSource();
    return "rgb(".concat(zn, ",").concat(Un, ",").concat(Kn, ")");
  }
  toRgba() {
    return "rgba(".concat(this.getSource().join(","), ")");
  }
  toHsl() {
    const [zn, Un, Kn] = Ee(...this.getSource());
    return "hsl(".concat(zn, ",").concat(Un, "%,").concat(Kn, "%)");
  }
  toHsla() {
    const [zn, Un, Kn, qn] = Ee(...this.getSource());
    return "hsla(".concat(zn, ",").concat(Un, "%,").concat(Kn, "%,").concat(qn, ")");
  }
  toHex() {
    return this.toHexa().slice(0, 6);
  }
  toHexa() {
    const [zn, Un, Kn, qn] = this.getSource();
    return "".concat(je(zn)).concat(je(Un)).concat(je(Kn)).concat(je(Math.round(255 * qn)));
  }
  getAlpha() {
    return this.getSource()[3];
  }
  setAlpha(zn) {
    return this._source[3] = zn, this;
  }
  toGrayscale() {
    return this.setSource(Fe(this.getSource())), this;
  }
  toBlackWhite(zn) {
    const [Un, , , Kn] = Fe(this.getSource()), qn = Un < (zn || 127) ? 0 : 255;
    return this.setSource([qn, qn, qn, Kn]), this;
  }
  overlayWith(zn) {
    zn instanceof Le || (zn = new Le(zn));
    const Un = this.getSource(), Kn = zn.getSource(), [qn, Jo, pa] = Un.map((ma, va) => Math.round(0.5 * ma + 0.5 * Kn[va]));
    return this.setSource([qn, Jo, pa, Un[3]]), this;
  }
  static fromRgb(zn) {
    return Le.fromRgba(zn);
  }
  static fromRgba(zn) {
    return new Le(Le.sourceFromRgb(zn));
  }
  static sourceFromRgb(zn) {
    const Un = zn.match(/^rgba?\(\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d{0,3}(?:\.\d+)?%?)\s*)?\)$/i);
    if (Un) {
      const [Kn, qn, Jo] = Un.slice(1, 4).map((pa) => {
        const ma = parseFloat(pa);
        return pa.endsWith("%") ? Math.round(2.55 * ma) : ma;
      });
      return [Kn, qn, Jo, Ae(Un[4])];
    }
  }
  static fromHsl(zn) {
    return Le.fromHsla(zn);
  }
  static fromHsla(zn) {
    return new Le(Le.sourceFromHsl(zn));
  }
  static sourceFromHsl(zn) {
    const Un = zn.match(/^hsla?\(\s*([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d*(?:\.\d+)?%?)\s*)?\)$/i);
    if (!Un) return;
    const Kn = (Le.parseAngletoDegrees(Un[1]) % 360 + 360) % 360 / 360, qn = parseFloat(Un[2]) / 100, Jo = parseFloat(Un[3]) / 100;
    let pa, ma, va;
    if (qn === 0) pa = ma = va = Jo;
    else {
      const ba = Jo <= 0.5 ? Jo * (qn + 1) : Jo + qn - Jo * qn, _a = 2 * Jo - ba;
      pa = Pe(_a, ba, Kn + 1 / 3), ma = Pe(_a, ba, Kn), va = Pe(_a, ba, Kn - 1 / 3);
    }
    return [Math.round(255 * pa), Math.round(255 * ma), Math.round(255 * va), Ae(Un[4])];
  }
  static fromHex(zn) {
    return new Le(Le.sourceFromHex(zn));
  }
  static sourceFromHex(zn) {
    if (zn.match(/^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i)) {
      const Un = zn.slice(zn.indexOf("#") + 1);
      let Kn;
      Kn = Un.length <= 4 ? Un.split("").map((va) => va + va) : Un.match(/.{2}/g);
      const [qn, Jo, pa, ma = 255] = Kn.map((va) => parseInt(va, 16));
      return [qn, Jo, pa, ma / 255];
    }
  }
  static parseAngletoDegrees(zn) {
    const Un = zn.toLowerCase(), Kn = parseFloat(Un);
    return Un.includes("rad") ? Ct(Kn) : Un.includes("turn") ? 360 * Kn : Kn;
  }
}
const Re = function(Xn) {
  let zn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : O$1;
  const Un = /\D{0,2}$/.exec(Xn), Kn = parseFloat(Xn), qn = o$1.DPI;
  switch (Un == null ? void 0 : Un[0]) {
    case "mm":
      return Kn * qn / 25.4;
    case "cm":
      return Kn * qn / 2.54;
    case "in":
      return Kn * qn;
    case "pt":
      return Kn * qn / 72;
    case "pc":
      return Kn * qn / 72 * 12;
    case "em":
      return Kn * zn;
    default:
      return Kn;
  }
}, Ie = (Xn) => {
  const [zn, Un] = Xn.trim().split(" "), [Kn, qn] = (Jo = zn) && Jo !== j ? [Jo.slice(1, 4), Jo.slice(5, 8)] : Jo === j ? [Jo, Jo] : ["Mid", "Mid"];
  var Jo;
  return { meetOrSlice: Un || "meet", alignX: Kn, alignY: qn };
}, Be = function(Xn, zn) {
  let Un, Kn, qn = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
  if (zn) if (zn.toLive) Un = "url(#SVGID_".concat(zn.id, ")");
  else {
    const Jo = new Le(zn), pa = Jo.getAlpha();
    Un = Jo.toRgb(), pa !== 1 && (Kn = pa.toString());
  }
  else Un = "none";
  return qn ? "".concat(Xn, ": ").concat(Un, "; ").concat(Kn ? "".concat(Xn, "-opacity: ").concat(Kn, "; ") : "") : "".concat(Xn, '="').concat(Un, '" ').concat(Kn ? "".concat(Xn, '-opacity="').concat(Kn, '" ') : "");
};
class Xe {
  getSvgStyles(zn) {
    const Un = this.fillRule ? this.fillRule : "nonzero", Kn = this.strokeWidth ? this.strokeWidth : "0", qn = this.strokeDashArray ? this.strokeDashArray.join(" ") : j, Jo = this.strokeDashOffset ? this.strokeDashOffset : "0", pa = this.strokeLineCap ? this.strokeLineCap : "butt", ma = this.strokeLineJoin ? this.strokeLineJoin : "miter", va = this.strokeMiterLimit ? this.strokeMiterLimit : "4", ba = this.opacity !== void 0 ? this.opacity : "1", _a = this.visible ? "" : " visibility: hidden;", ya = zn ? "" : this.getSvgFilter(), xa = Be(K, this.fill);
    return [Be(J, this.stroke), "stroke-width: ", Kn, "; ", "stroke-dasharray: ", qn, "; ", "stroke-linecap: ", pa, "; ", "stroke-dashoffset: ", Jo, "; ", "stroke-linejoin: ", ma, "; ", "stroke-miterlimit: ", va, "; ", xa, "fill-rule: ", Un, "; ", "opacity: ", ba, ";", ya, _a].join("");
  }
  getSvgFilter() {
    return this.shadow ? "filter: url(#SVGID_".concat(this.shadow.id, ");") : "";
  }
  getSvgCommons() {
    return [this.id ? 'id="'.concat(this.id, '" ') : "", this.clipPath ? 'clip-path="url(#'.concat(this.clipPath.clipPathId, ')" ') : ""].join("");
  }
  getSvgTransform(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const Kn = zn ? this.calcTransformMatrix() : this.calcOwnMatrix(), qn = 'transform="'.concat(zt(Kn));
    return "".concat(qn).concat(Un, '" ');
  }
  _toSVG(zn) {
    return [""];
  }
  toSVG(zn) {
    return this._createBaseSVGMarkup(this._toSVG(zn), { reviver: zn });
  }
  toClipPathSVG(zn) {
    return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(zn), { reviver: zn });
  }
  _createBaseClipPathSVGMarkup(zn) {
    let { reviver: Un, additionalTransform: Kn = "" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const qn = [this.getSvgTransform(!0, Kn), this.getSvgCommons()].join(""), Jo = zn.indexOf("COMMON_PARTS");
    return zn[Jo] = qn, Un ? Un(zn.join("")) : zn.join("");
  }
  _createBaseSVGMarkup(zn) {
    let { noStyle: Un, reviver: Kn, withShadow: qn, additionalTransform: Jo } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const pa = Un ? "" : 'style="'.concat(this.getSvgStyles(), '" '), ma = qn ? 'style="'.concat(this.getSvgFilter(), '" ') : "", va = this.clipPath, ba = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : "", _a = va && va.absolutePositioned, ya = this.stroke, xa = this.fill, wa = this.shadow, Ta = [], Sa = zn.indexOf("COMMON_PARTS");
    let Ma;
    va && (va.clipPathId = "CLIPPATH_".concat(ft()), Ma = '<clipPath id="'.concat(va.clipPathId, `" >
`).concat(va.toClipPathSVG(Kn), `</clipPath>
`)), _a && Ta.push("<g ", ma, this.getSvgCommons(), ` >
`), Ta.push("<g ", this.getSvgTransform(!1), _a ? "" : ma + this.getSvgCommons(), ` >
`);
    const ka = [pa, ba, Un ? "" : this.addPaintOrder(), " ", Jo ? 'transform="'.concat(Jo, '" ') : ""].join("");
    return zn[Sa] = ka, Gt(xa) && Ta.push(xa.toSVG(this)), Gt(ya) && Ta.push(ya.toSVG(this)), wa && Ta.push(wa.toSVG(this)), va && Ta.push(Ma), Ta.push(zn.join("")), Ta.push(`</g>
`), _a && Ta.push(`</g>
`), Kn ? Kn(Ta.join("")) : Ta.join("");
  }
  addPaintOrder() {
    return this.paintFirst !== K ? ' paint-order="'.concat(this.paintFirst, '" ') : "";
  }
}
function Ye(Xn) {
  return new RegExp("^(" + Xn.join("|") + ")\\b", "i");
}
var We;
const Ve = String.raw(We || (We = r$1(["(?:[-+]?(?:d*.d+|d+.?)(?:[eE][-+]?d+)?)"], ["(?:[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?)"]))), ze = "http://www.w3.org/2000/svg", Ge = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + Ve + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + Ve + "))?\\s+(.*)"), He = { cx: M$1, x: M$1, r: "radius", cy: P, y: P, display: "visible", visibility: "visible", transform: "transformMatrix", "fill-opacity": "fillOpacity", "fill-rule": "fillRule", "font-family": "fontFamily", "font-size": "fontSize", "font-style": "fontStyle", "font-weight": "fontWeight", "letter-spacing": "charSpacing", "paint-order": "paintFirst", "stroke-dasharray": "strokeDashArray", "stroke-dashoffset": "strokeDashOffset", "stroke-linecap": "strokeLineCap", "stroke-linejoin": "strokeLineJoin", "stroke-miterlimit": "strokeMiterLimit", "stroke-opacity": "strokeOpacity", "stroke-width": "strokeWidth", "text-decoration": "textDecoration", "text-anchor": "textAnchor", opacity: "opacity", "clip-path": "clipPath", "clip-rule": "clipRule", "vector-effect": "strokeUniform", "image-rendering": "imageSmoothing" }, Ne = "font-size", Ue = "clip-path", qe = Ye(["path", "circle", "polygon", "polyline", "ellipse", "rect", "line", "image", "text"]), Ke = Ye(["symbol", "image", "marker", "pattern", "view", "svg"]), Je = Ye(["symbol", "g", "a", "svg", "clipPath", "defs"]), Qe = new RegExp("^\\s*(" + Ve + "+)\\s*,?\\s*(" + Ve + "+)\\s*,?\\s*(" + Ve + "+)\\s*,?\\s*(" + Ve + "+)\\s*$"), Ze = new ot(1, 0), $e = new ot(), ts = (Xn, zn) => Xn.rotate(zn), es = (Xn, zn) => new ot(zn).subtract(Xn), ss = (Xn) => Xn.distanceFrom($e), is = (Xn, zn) => Math.atan2(as(Xn, zn), hs(Xn, zn)), rs = (Xn) => is(Ze, Xn), ns = (Xn) => Xn.eq($e) ? Xn : Xn.scalarDivide(ss(Xn)), os = function(Xn) {
  let zn = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
  return ns(new ot(-Xn.y, Xn.x).scalarMultiply(zn ? 1 : -1));
}, as = (Xn, zn) => Xn.x * zn.y - Xn.y * zn.x, hs = (Xn, zn) => Xn.x * zn.x + Xn.y * zn.y, cs = (Xn, zn, Un) => {
  if (Xn.eq(zn) || Xn.eq(Un)) return !0;
  const Kn = as(zn, Un), qn = as(zn, Xn), Jo = as(Un, Xn);
  return Kn >= 0 ? qn >= 0 && Jo <= 0 : !(qn <= 0 && Jo >= 0);
}, ls = "(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?", us = new RegExp("(?:\\s|^)" + ls + ls + "(" + Ve + "?(?:px)?)?(?:\\s?|$)(?:$|\\s)");
class ds {
  constructor(zn) {
    const Un = typeof zn == "string" ? ds.parseShadow(zn) : zn;
    Object.assign(this, ds.ownDefaults, Un), this.id = ft();
  }
  static parseShadow(zn) {
    const Un = zn.trim(), [, Kn = 0, qn = 0, Jo = 0] = (us.exec(Un) || []).map((pa) => parseFloat(pa) || 0);
    return { color: (Un.replace(us, "") || "rgb(0,0,0)").trim(), offsetX: Kn, offsetY: qn, blur: Jo };
  }
  toString() {
    return [this.offsetX, this.offsetY, this.blur, this.color].join("px ");
  }
  toSVG(zn) {
    const Un = ts(new ot(this.offsetX, this.offsetY), xt(-zn.angle)), Kn = new Le(this.color);
    let qn = 40, Jo = 40;
    return zn.width && zn.height && (qn = 100 * Vt((Math.abs(Un.x) + this.blur) / zn.width, o$1.NUM_FRACTION_DIGITS) + 20, Jo = 100 * Vt((Math.abs(Un.y) + this.blur) / zn.height, o$1.NUM_FRACTION_DIGITS) + 20), zn.flipX && (Un.x *= -1), zn.flipY && (Un.y *= -1), '<filter id="SVGID_'.concat(this.id, '" y="-').concat(Jo, '%" height="').concat(100 + 2 * Jo, '%" x="-').concat(qn, '%" width="').concat(100 + 2 * qn, `%" >
	<feGaussianBlur in="SourceAlpha" stdDeviation="`).concat(Vt(this.blur ? this.blur / 2 : 0, o$1.NUM_FRACTION_DIGITS), `"></feGaussianBlur>
	<feOffset dx="`).concat(Vt(Un.x, o$1.NUM_FRACTION_DIGITS), '" dy="').concat(Vt(Un.y, o$1.NUM_FRACTION_DIGITS), `" result="oBlur" ></feOffset>
	<feFlood flood-color="`).concat(Kn.toRgb(), '" flood-opacity="').concat(Kn.getAlpha(), `"/>
	<feComposite in2="oBlur" operator="in" />
	<feMerge>
		<feMergeNode></feMergeNode>
		<feMergeNode in="SourceGraphic"></feMergeNode>
	</feMerge>
</filter>
`);
  }
  toObject() {
    const zn = { color: this.color, blur: this.blur, offsetX: this.offsetX, offsetY: this.offsetY, affectStroke: this.affectStroke, nonScaling: this.nonScaling, type: this.constructor.type }, Un = ds.ownDefaults;
    return this.includeDefaultValues ? zn : Wt(zn, (Kn, qn) => Kn !== Un[qn]);
  }
  static async fromObject(zn) {
    return new this(zn);
  }
}
t$1(ds, "ownDefaults", { color: "rgb(0,0,0)", blur: 0, offsetX: 0, offsetY: 0, affectStroke: !1, includeDefaultValues: !0, nonScaling: !1 }), t$1(ds, "type", "shadow"), tt.setClass(ds, "shadow");
const gs = (Xn, zn, Un) => Math.max(Xn, Math.min(zn, Un)), fs = [P, M$1, H, N$1, "flipX", "flipY", "originX", "originY", "angle", "opacity", "globalCompositeOperation", "shadow", "visible", U, q], ps = [K, J, "strokeWidth", "strokeDashArray", "width", "height", "paintFirst", "strokeUniform", "strokeLineCap", "strokeDashOffset", "strokeLineJoin", "strokeMiterLimit", "backgroundColor", "clipPath"], ms = { top: 0, left: 0, width: 0, height: 0, angle: 0, flipX: !1, flipY: !1, scaleX: 1, scaleY: 1, minScaleLimit: 0, skewX: 0, skewY: 0, originX: M$1, originY: P, strokeWidth: 1, strokeUniform: !1, padding: 0, opacity: 1, paintFirst: K, fill: "rgb(0,0,0)", fillRule: "nonzero", stroke: null, strokeDashArray: null, strokeDashOffset: 0, strokeLineCap: "butt", strokeLineJoin: "miter", strokeMiterLimit: 4, globalCompositeOperation: "source-over", backgroundColor: "", shadow: null, visible: !0, includeDefaultValues: !0, excludeFromExport: !1, objectCaching: !0, clipPath: void 0, inverted: !1, absolutePositioned: !1, centeredRotation: !0, centeredScaling: !1, dirty: !0 }, vs = (Xn, zn, Un, Kn) => (Xn < Math.abs(zn) ? (Xn = zn, Kn = Un / 4) : Kn = zn === 0 && Xn === 0 ? Un / w * Math.asin(1) : Un / w * Math.asin(zn / Xn), { a: Xn, c: zn, p: Un, s: Kn }), ys = (Xn, zn, Un, Kn, qn) => Xn * Math.pow(2, 10 * (Kn -= 1)) * Math.sin((Kn * qn - zn) * w / Un), _s = (Xn, zn, Un, Kn) => -Un * Math.cos(Xn / Kn * b$1) + Un + zn, xs = (Xn, zn, Un, Kn) => (Xn /= Kn) < 1 / 2.75 ? Un * (7.5625 * Xn * Xn) + zn : Xn < 2 / 2.75 ? Un * (7.5625 * (Xn -= 1.5 / 2.75) * Xn + 0.75) + zn : Xn < 2.5 / 2.75 ? Un * (7.5625 * (Xn -= 2.25 / 2.75) * Xn + 0.9375) + zn : Un * (7.5625 * (Xn -= 2.625 / 2.75) * Xn + 0.984375) + zn, Cs = (Xn, zn, Un, Kn) => Un - xs(Kn - Xn, 0, Un, Kn) + zn;
var bs = Object.freeze({ __proto__: null, defaultEasing: _s, easeInBack: function(Xn, zn, Un, Kn) {
  let qn = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1.70158;
  return Un * (Xn /= Kn) * Xn * ((qn + 1) * Xn - qn) + zn;
}, easeInBounce: Cs, easeInCirc: (Xn, zn, Un, Kn) => -Un * (Math.sqrt(1 - (Xn /= Kn) * Xn) - 1) + zn, easeInCubic: (Xn, zn, Un, Kn) => Un * (Xn / Kn) ** 3 + zn, easeInElastic: (Xn, zn, Un, Kn) => {
  const qn = Un;
  let Jo = 0;
  if (Xn === 0) return zn;
  if ((Xn /= Kn) === 1) return zn + Un;
  Jo || (Jo = 0.3 * Kn);
  const { a: pa, s: ma, p: va } = vs(qn, Un, Jo, 1.70158);
  return -ys(pa, ma, va, Xn, Kn) + zn;
}, easeInExpo: (Xn, zn, Un, Kn) => Xn === 0 ? zn : Un * 2 ** (10 * (Xn / Kn - 1)) + zn, easeInOutBack: function(Xn, zn, Un, Kn) {
  let qn = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1.70158;
  return (Xn /= Kn / 2) < 1 ? Un / 2 * (Xn * Xn * ((1 + (qn *= 1.525)) * Xn - qn)) + zn : Un / 2 * ((Xn -= 2) * Xn * ((1 + (qn *= 1.525)) * Xn + qn) + 2) + zn;
}, easeInOutBounce: (Xn, zn, Un, Kn) => Xn < Kn / 2 ? 0.5 * Cs(2 * Xn, 0, Un, Kn) + zn : 0.5 * xs(2 * Xn - Kn, 0, Un, Kn) + 0.5 * Un + zn, easeInOutCirc: (Xn, zn, Un, Kn) => (Xn /= Kn / 2) < 1 ? -Un / 2 * (Math.sqrt(1 - Xn ** 2) - 1) + zn : Un / 2 * (Math.sqrt(1 - (Xn -= 2) * Xn) + 1) + zn, easeInOutCubic: (Xn, zn, Un, Kn) => (Xn /= Kn / 2) < 1 ? Un / 2 * Xn ** 3 + zn : Un / 2 * ((Xn - 2) ** 3 + 2) + zn, easeInOutElastic: (Xn, zn, Un, Kn) => {
  const qn = Un;
  let Jo = 0;
  if (Xn === 0) return zn;
  if ((Xn /= Kn / 2) === 2) return zn + Un;
  Jo || (Jo = Kn * (0.3 * 1.5));
  const { a: pa, s: ma, p: va, c: ba } = vs(qn, Un, Jo, 1.70158);
  return Xn < 1 ? -0.5 * ys(pa, ma, va, Xn, Kn) + zn : pa * Math.pow(2, -10 * (Xn -= 1)) * Math.sin((Xn * Kn - ma) * w / va) * 0.5 + ba + zn;
}, easeInOutExpo: (Xn, zn, Un, Kn) => Xn === 0 ? zn : Xn === Kn ? zn + Un : (Xn /= Kn / 2) < 1 ? Un / 2 * 2 ** (10 * (Xn - 1)) + zn : Un / 2 * -(2 ** (-10 * --Xn) + 2) + zn, easeInOutQuad: (Xn, zn, Un, Kn) => (Xn /= Kn / 2) < 1 ? Un / 2 * Xn ** 2 + zn : -Un / 2 * (--Xn * (Xn - 2) - 1) + zn, easeInOutQuart: (Xn, zn, Un, Kn) => (Xn /= Kn / 2) < 1 ? Un / 2 * Xn ** 4 + zn : -Un / 2 * ((Xn -= 2) * Xn ** 3 - 2) + zn, easeInOutQuint: (Xn, zn, Un, Kn) => (Xn /= Kn / 2) < 1 ? Un / 2 * Xn ** 5 + zn : Un / 2 * ((Xn - 2) ** 5 + 2) + zn, easeInOutSine: (Xn, zn, Un, Kn) => -Un / 2 * (Math.cos(Math.PI * Xn / Kn) - 1) + zn, easeInQuad: (Xn, zn, Un, Kn) => Un * (Xn /= Kn) * Xn + zn, easeInQuart: (Xn, zn, Un, Kn) => Un * (Xn /= Kn) * Xn ** 3 + zn, easeInQuint: (Xn, zn, Un, Kn) => Un * (Xn / Kn) ** 5 + zn, easeInSine: (Xn, zn, Un, Kn) => -Un * Math.cos(Xn / Kn * b$1) + Un + zn, easeOutBack: function(Xn, zn, Un, Kn) {
  let qn = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1.70158;
  return Un * ((Xn = Xn / Kn - 1) * Xn * ((qn + 1) * Xn + qn) + 1) + zn;
}, easeOutBounce: xs, easeOutCirc: (Xn, zn, Un, Kn) => Un * Math.sqrt(1 - (Xn = Xn / Kn - 1) * Xn) + zn, easeOutCubic: (Xn, zn, Un, Kn) => Un * ((Xn / Kn - 1) ** 3 + 1) + zn, easeOutElastic: (Xn, zn, Un, Kn) => {
  const qn = Un;
  let Jo = 0;
  if (Xn === 0) return zn;
  if ((Xn /= Kn) === 1) return zn + Un;
  Jo || (Jo = 0.3 * Kn);
  const { a: pa, s: ma, p: va, c: ba } = vs(qn, Un, Jo, 1.70158);
  return pa * 2 ** (-10 * Xn) * Math.sin((Xn * Kn - ma) * w / va) + ba + zn;
}, easeOutExpo: (Xn, zn, Un, Kn) => Xn === Kn ? zn + Un : Un * -(2 ** (-10 * Xn / Kn) + 1) + zn, easeOutQuad: (Xn, zn, Un, Kn) => -Un * (Xn /= Kn) * (Xn - 2) + zn, easeOutQuart: (Xn, zn, Un, Kn) => -Un * ((Xn = Xn / Kn - 1) * Xn ** 3 - 1) + zn, easeOutQuint: (Xn, zn, Un, Kn) => Un * ((Xn / Kn - 1) ** 5 + 1) + zn, easeOutSine: (Xn, zn, Un, Kn) => Un * Math.sin(Xn / Kn * b$1) + zn });
const ws = () => !1;
class Ss {
  constructor(zn) {
    let { startValue: Un, byValue: Kn, duration: qn = 500, delay: Jo = 0, easing: pa = _s, onStart: ma = C$1, onChange: va = C$1, onComplete: ba = C$1, abort: _a = ws, target: ya } = zn;
    t$1(this, "_state", "pending"), t$1(this, "durationProgress", 0), t$1(this, "valueProgress", 0), this.tick = this.tick.bind(this), this.duration = qn, this.delay = Jo, this.easing = pa, this._onStart = ma, this._onChange = va, this._onComplete = ba, this._abort = _a, this.target = ya, this.startValue = Un, this.byValue = Kn, this.value = this.startValue, this.endValue = Object.freeze(this.calculate(this.duration).value);
  }
  get state() {
    return this._state;
  }
  isDone() {
    return this._state === "aborted" || this._state === "completed";
  }
  start() {
    const zn = (Un) => {
      this._state === "pending" && (this.startTime = Un || +/* @__PURE__ */ new Date(), this._state = "running", this._onStart(), this.tick(this.startTime));
    };
    this.register(), this.delay > 0 ? setTimeout(() => ut(zn), this.delay) : ut(zn);
  }
  tick(zn) {
    const Un = (zn || +/* @__PURE__ */ new Date()) - this.startTime, Kn = Math.min(Un, this.duration);
    this.durationProgress = Kn / this.duration;
    const { value: qn, valueProgress: Jo } = this.calculate(Kn);
    this.value = Object.freeze(qn), this.valueProgress = Jo, this._state !== "aborted" && (this._abort(this.value, this.valueProgress, this.durationProgress) ? (this._state = "aborted", this.unregister()) : Un >= this.duration ? (this.durationProgress = this.valueProgress = 1, this._onChange(this.endValue, this.valueProgress, this.durationProgress), this._state = "completed", this._onComplete(this.endValue, this.valueProgress, this.durationProgress), this.unregister()) : (this._onChange(this.value, this.valueProgress, this.durationProgress), ut(this.tick)));
  }
  register() {
    et.push(this);
  }
  unregister() {
    et.remove(this);
  }
  abort() {
    this._state = "aborted", this.unregister();
  }
}
const Ts = ["startValue", "endValue"];
class Os extends Ss {
  constructor(zn) {
    let { startValue: Un = 0, endValue: Kn = 100 } = zn;
    super(s$1(s$1({}, i$3(zn, Ts)), {}, { startValue: Un, byValue: Kn - Un }));
  }
  calculate(zn) {
    const Un = this.easing(zn, this.startValue, this.byValue, this.duration);
    return { value: Un, valueProgress: Math.abs((Un - this.startValue) / this.byValue) };
  }
}
const ks = ["startValue", "endValue"];
class Ds extends Ss {
  constructor(zn) {
    let { startValue: Un = [0], endValue: Kn = [100] } = zn;
    super(s$1(s$1({}, i$3(zn, ks)), {}, { startValue: Un, byValue: Kn.map((qn, Jo) => qn - Un[Jo]) }));
  }
  calculate(zn) {
    const Un = this.startValue.map((Kn, qn) => this.easing(zn, Kn, this.byValue[qn], this.duration, qn));
    return { value: Un, valueProgress: Math.abs((Un[0] - this.startValue[0]) / this.byValue[0]) };
  }
}
const Ms = ["startValue", "endValue", "easing", "onChange", "onComplete", "abort"], Ps = (Xn, zn, Un, Kn) => zn + Un * (1 - Math.cos(Xn / Kn * b$1)), Es = (Xn) => Xn && ((zn, Un, Kn) => Xn(new Le(zn).toRgba(), Un, Kn));
class As extends Ss {
  constructor(zn) {
    let { startValue: Un, endValue: Kn, easing: qn = Ps, onChange: Jo, onComplete: pa, abort: ma } = zn, va = i$3(zn, Ms);
    const ba = new Le(Un).getSource(), _a = new Le(Kn).getSource();
    super(s$1(s$1({}, va), {}, { startValue: ba, byValue: _a.map((ya, xa) => ya - ba[xa]), easing: qn, onChange: Es(Jo), onComplete: Es(pa), abort: Es(ma) }));
  }
  calculate(zn) {
    const [Un, Kn, qn, Jo] = this.startValue.map((ma, va) => this.easing(zn, ma, this.byValue[va], this.duration, va)), pa = [...[Un, Kn, qn].map(Math.round), gs(0, Jo, 1)];
    return { value: pa, valueProgress: pa.map((ma, va) => this.byValue[va] !== 0 ? Math.abs((ma - this.startValue[va]) / this.byValue[va]) : 0).find((ma) => ma !== 0) || 0 };
  }
}
function js(Xn) {
  const zn = ((Un) => Array.isArray(Un.startValue) || Array.isArray(Un.endValue))(Xn) ? new Ds(Xn) : new Os(Xn);
  return zn.start(), zn;
}
function Fs(Xn) {
  const zn = new As(Xn);
  return zn.start(), zn;
}
class Ls {
  constructor(zn) {
    this.status = zn, this.points = [];
  }
  includes(zn) {
    return this.points.some((Un) => Un.eq(zn));
  }
  append() {
    for (var zn = arguments.length, Un = new Array(zn), Kn = 0; Kn < zn; Kn++) Un[Kn] = arguments[Kn];
    return this.points = this.points.concat(Un.filter((qn) => !this.includes(qn))), this;
  }
  static isPointContained(zn, Un, Kn) {
    let qn = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    if (Un.eq(Kn)) return zn.eq(Un);
    if (Un.x === Kn.x) return zn.x === Un.x && (qn || zn.y >= Math.min(Un.y, Kn.y) && zn.y <= Math.max(Un.y, Kn.y));
    if (Un.y === Kn.y) return zn.y === Un.y && (qn || zn.x >= Math.min(Un.x, Kn.x) && zn.x <= Math.max(Un.x, Kn.x));
    {
      const Jo = es(Un, Kn), pa = es(Un, zn).divide(Jo);
      return qn ? Math.abs(pa.x) === Math.abs(pa.y) : pa.x === pa.y && pa.x >= 0 && pa.x <= 1;
    }
  }
  static isPointInPolygon(zn, Un) {
    const Kn = new ot(zn).setX(Math.min(zn.x - 1, ...Un.map((Jo) => Jo.x)));
    let qn = 0;
    for (let Jo = 0; Jo < Un.length; Jo++) {
      const pa = this.intersectSegmentSegment(Un[Jo], Un[(Jo + 1) % Un.length], zn, Kn);
      if (pa.includes(zn)) return !0;
      qn += +(pa.status === "Intersection");
    }
    return qn % 2 == 1;
  }
  static intersectLineLine(zn, Un, Kn, qn) {
    let Jo = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], pa = !(arguments.length > 5 && arguments[5] !== void 0) || arguments[5];
    const ma = Un.x - zn.x, va = Un.y - zn.y, ba = qn.x - Kn.x, _a = qn.y - Kn.y, ya = zn.x - Kn.x, xa = zn.y - Kn.y, wa = ba * xa - _a * ya, Ta = ma * xa - va * ya, Sa = _a * ma - ba * va;
    if (Sa !== 0) {
      const Ma = wa / Sa, ka = Ta / Sa;
      return (Jo || 0 <= Ma && Ma <= 1) && (pa || 0 <= ka && ka <= 1) ? new Ls("Intersection").append(new ot(zn.x + Ma * ma, zn.y + Ma * va)) : new Ls();
    }
    if (wa === 0 || Ta === 0) {
      const Ma = Jo || pa || Ls.isPointContained(zn, Kn, qn) || Ls.isPointContained(Un, Kn, qn) || Ls.isPointContained(Kn, zn, Un) || Ls.isPointContained(qn, zn, Un);
      return new Ls(Ma ? "Coincident" : void 0);
    }
    return new Ls("Parallel");
  }
  static intersectSegmentLine(zn, Un, Kn, qn) {
    return Ls.intersectLineLine(zn, Un, Kn, qn, !1, !0);
  }
  static intersectSegmentSegment(zn, Un, Kn, qn) {
    return Ls.intersectLineLine(zn, Un, Kn, qn, !1, !1);
  }
  static intersectLinePolygon(zn, Un, Kn) {
    let qn = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
    const Jo = new Ls(), pa = Kn.length;
    for (let ma, va, ba, _a = 0; _a < pa; _a++) {
      if (ma = Kn[_a], va = Kn[(_a + 1) % pa], ba = Ls.intersectLineLine(zn, Un, ma, va, qn, !1), ba.status === "Coincident") return ba;
      Jo.append(...ba.points);
    }
    return Jo.points.length > 0 && (Jo.status = "Intersection"), Jo;
  }
  static intersectSegmentPolygon(zn, Un, Kn) {
    return Ls.intersectLinePolygon(zn, Un, Kn, !1);
  }
  static intersectPolygonPolygon(zn, Un) {
    const Kn = new Ls(), qn = zn.length, Jo = [];
    for (let pa = 0; pa < qn; pa++) {
      const ma = zn[pa], va = zn[(pa + 1) % qn], ba = Ls.intersectSegmentPolygon(ma, va, Un);
      ba.status === "Coincident" ? (Jo.push(ba), Kn.append(ma, va)) : Kn.append(...ba.points);
    }
    return Jo.length > 0 && Jo.length === zn.length ? new Ls("Coincident") : (Kn.points.length > 0 && (Kn.status = "Intersection"), Kn);
  }
  static intersectPolygonRectangle(zn, Un, Kn) {
    const qn = Un.min(Kn), Jo = Un.max(Kn), pa = new ot(Jo.x, qn.y), ma = new ot(qn.x, Jo.y);
    return Ls.intersectPolygonPolygon(zn, [qn, pa, Jo, ma]);
  }
}
class Rs extends lt {
  getX() {
    return this.getXY().x;
  }
  setX(zn) {
    this.setXY(this.getXY().setX(zn));
  }
  getY() {
    return this.getXY().y;
  }
  setY(zn) {
    this.setXY(this.getXY().setY(zn));
  }
  getRelativeX() {
    return this.left;
  }
  setRelativeX(zn) {
    this.left = zn;
  }
  getRelativeY() {
    return this.top;
  }
  setRelativeY(zn) {
    this.top = zn;
  }
  getXY() {
    const zn = this.getRelativeXY();
    return this.group ? wt(zn, this.group.calcTransformMatrix()) : zn;
  }
  setXY(zn, Un, Kn) {
    this.group && (zn = wt(zn, St(this.group.calcTransformMatrix()))), this.setRelativeXY(zn, Un, Kn);
  }
  getRelativeXY() {
    return new ot(this.left, this.top);
  }
  setRelativeXY(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.originX, Kn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.originY;
    this.setPositionByOrigin(zn, Un, Kn);
  }
  isStrokeAccountedForInDimensions() {
    return !1;
  }
  getCoords() {
    const { tl: zn, tr: Un, br: Kn, bl: qn } = this.aCoords || (this.aCoords = this.calcACoords()), Jo = [zn, Un, Kn, qn];
    if (this.group) {
      const pa = this.group.calcTransformMatrix();
      return Jo.map((ma) => wt(ma, pa));
    }
    return Jo;
  }
  intersectsWithRect(zn, Un) {
    return Ls.intersectPolygonRectangle(this.getCoords(), zn, Un).status === "Intersection";
  }
  intersectsWithObject(zn) {
    const Un = Ls.intersectPolygonPolygon(this.getCoords(), zn.getCoords());
    return Un.status === "Intersection" || Un.status === "Coincident" || zn.isContainedWithinObject(this) || this.isContainedWithinObject(zn);
  }
  isContainedWithinObject(zn) {
    return this.getCoords().every((Un) => zn.containsPoint(Un));
  }
  isContainedWithinRect(zn, Un) {
    const { left: Kn, top: qn, width: Jo, height: pa } = this.getBoundingRect();
    return Kn >= zn.x && Kn + Jo <= Un.x && qn >= zn.y && qn + pa <= Un.y;
  }
  isOverlapping(zn) {
    return this.intersectsWithObject(zn) || this.isContainedWithinObject(zn) || zn.isContainedWithinObject(this);
  }
  containsPoint(zn) {
    return Ls.isPointInPolygon(zn, this.getCoords());
  }
  isOnScreen() {
    if (!this.canvas) return !1;
    const { tl: zn, br: Un } = this.canvas.vptCoords;
    return !!this.getCoords().some((Kn) => Kn.x <= Un.x && Kn.x >= zn.x && Kn.y <= Un.y && Kn.y >= zn.y) || !!this.intersectsWithRect(zn, Un) || this.containsPoint(zn.midPointFrom(Un));
  }
  isPartiallyOnScreen() {
    if (!this.canvas) return !1;
    const { tl: zn, br: Un } = this.canvas.vptCoords;
    return this.intersectsWithRect(zn, Un) ? !0 : this.getCoords().every((Kn) => (Kn.x >= Un.x || Kn.x <= zn.x) && (Kn.y >= Un.y || Kn.y <= zn.y)) && this.containsPoint(zn.midPointFrom(Un));
  }
  getBoundingRect() {
    return ae(this.getCoords());
  }
  getScaledWidth() {
    return this._getTransformedDimensions().x;
  }
  getScaledHeight() {
    return this._getTransformedDimensions().y;
  }
  scale(zn) {
    this._set(H, zn), this._set(N$1, zn), this.setCoords();
  }
  scaleToWidth(zn) {
    const Un = this.getBoundingRect().width / this.getScaledWidth();
    return this.scale(zn / this.width / Un);
  }
  scaleToHeight(zn) {
    const Un = this.getBoundingRect().height / this.getScaledHeight();
    return this.scale(zn / this.height / Un);
  }
  getCanvasRetinaScaling() {
    var zn;
    return ((zn = this.canvas) === null || zn === void 0 ? void 0 : zn.getRetinaScaling()) || 1;
  }
  getTotalAngle() {
    return this.group ? Ct(kt(this.calcTransformMatrix())) : this.angle;
  }
  getViewportTransform() {
    var zn;
    return ((zn = this.canvas) === null || zn === void 0 ? void 0 : zn.viewportTransform) || T$1.concat();
  }
  calcACoords() {
    const zn = Pt({ angle: this.angle }), { x: Un, y: Kn } = this.getRelativeCenterPoint(), qn = Mt(Un, Kn), Jo = Tt(qn, zn), pa = this._getTransformedDimensions(), ma = pa.x / 2, va = pa.y / 2;
    return { tl: wt({ x: -ma, y: -va }, Jo), tr: wt({ x: ma, y: -va }, Jo), bl: wt({ x: -ma, y: va }, Jo), br: wt({ x: ma, y: va }, Jo) };
  }
  setCoords() {
    this.aCoords = this.calcACoords();
  }
  transformMatrixKey() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], Un = [];
    return !zn && this.group && (Un = this.group.transformMatrixKey(zn)), Un.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, xe(this.originX), xe(this.originY)), Un;
  }
  calcTransformMatrix() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], Un = this.calcOwnMatrix();
    if (zn || !this.group) return Un;
    const Kn = this.transformMatrixKey(zn), qn = this.matrixCache;
    return qn && qn.key.every((Jo, pa) => Jo === Kn[pa]) ? qn.value : (this.group && (Un = Tt(this.group.calcTransformMatrix(!1), Un)), this.matrixCache = { key: Kn, value: Un }, Un);
  }
  calcOwnMatrix() {
    const zn = this.transformMatrixKey(!0), Un = this.ownMatrixCache;
    if (Un && Un.key === zn) return Un.value;
    const Kn = this.getRelativeCenterPoint(), qn = { angle: this.angle, translateX: Kn.x, translateY: Kn.y, scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, flipX: this.flipX, flipY: this.flipY }, Jo = Rt(qn);
    return this.ownMatrixCache = { key: zn, value: Jo }, Jo;
  }
  _getNonTransformedDimensions() {
    return new ot(this.width, this.height).scalarAdd(this.strokeWidth);
  }
  _calculateCurrentDimensions(zn) {
    return this._getTransformedDimensions(zn).transform(this.getViewportTransform(), !0).scalarAdd(2 * this.padding);
  }
  _getTransformedDimensions() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const Un = s$1({ scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, width: this.width, height: this.height, strokeWidth: this.strokeWidth }, zn), Kn = Un.strokeWidth;
    let qn = Kn, Jo = 0;
    this.strokeUniform && (qn = 0, Jo = Kn);
    const pa = Un.width + qn, ma = Un.height + qn;
    let va;
    return va = Un.skewX === 0 && Un.skewY === 0 ? new ot(pa * Un.scaleX, ma * Un.scaleY) : ge(pa, ma, Lt(Un)), va.scalarAdd(Jo);
  }
  translateToGivenOrigin(zn, Un, Kn, qn, Jo) {
    let pa = zn.x, ma = zn.y;
    const va = xe(qn) - xe(Un), ba = xe(Jo) - xe(Kn);
    if (va || ba) {
      const _a = this._getTransformedDimensions();
      pa += va * _a.x, ma += ba * _a.y;
    }
    return new ot(pa, ma);
  }
  translateToCenterPoint(zn, Un, Kn) {
    if (Un === D && Kn === D) return zn;
    const qn = this.translateToGivenOrigin(zn, Un, Kn, D, D);
    return this.angle ? qn.rotate(xt(this.angle), zn) : qn;
  }
  translateToOriginPoint(zn, Un, Kn) {
    const qn = this.translateToGivenOrigin(zn, D, D, Un, Kn);
    return this.angle ? qn.rotate(xt(this.angle), zn) : qn;
  }
  getCenterPoint() {
    const zn = this.getRelativeCenterPoint();
    return this.group ? wt(zn, this.group.calcTransformMatrix()) : zn;
  }
  getRelativeCenterPoint() {
    return this.translateToCenterPoint(new ot(this.left, this.top), this.originX, this.originY);
  }
  getPointByOrigin(zn, Un) {
    return this.translateToOriginPoint(this.getRelativeCenterPoint(), zn, Un);
  }
  setPositionByOrigin(zn, Un, Kn) {
    const qn = this.translateToCenterPoint(zn, Un, Kn), Jo = this.translateToOriginPoint(qn, this.originX, this.originY);
    this.set({ left: Jo.x, top: Jo.y });
  }
  _getLeftTopCoords() {
    return this.translateToOriginPoint(this.getRelativeCenterPoint(), M$1, P);
  }
}
const Is = ["type"], Bs = ["extraParam"];
let Xs = class fd extends Rs {
  static getDefaults() {
    return fd.ownDefaults;
  }
  get type() {
    const zn = this.constructor.type;
    return zn === "FabricObject" ? "object" : zn.toLowerCase();
  }
  set type(zn) {
    a$1("warn", "Setting type has no effect", zn);
  }
  constructor(zn) {
    super(), t$1(this, "_cacheContext", null), Object.assign(this, fd.ownDefaults), this.setOptions(zn);
  }
  _createCacheCanvas() {
    this._cacheCanvas = pt(), this._cacheContext = this._cacheCanvas.getContext("2d"), this._updateCacheCanvas(), this.dirty = !0;
  }
  _limitCacheSize(zn) {
    const Un = zn.width, Kn = zn.height, qn = o$1.maxCacheSideLimit, Jo = o$1.minCacheSideLimit;
    if (Un <= qn && Kn <= qn && Un * Kn <= o$1.perfLimitSizeTotal) return Un < Jo && (zn.width = Jo), Kn < Jo && (zn.height = Jo), zn;
    const pa = Un / Kn, [ma, va] = _$1.limitDimsByArea(pa), ba = gs(Jo, ma, qn), _a = gs(Jo, va, qn);
    return Un > ba && (zn.zoomX /= Un / ba, zn.width = ba, zn.capped = !0), Kn > _a && (zn.zoomY /= Kn / _a, zn.height = _a, zn.capped = !0), zn;
  }
  _getCacheCanvasDimensions() {
    const zn = this.getTotalObjectScaling(), Un = this._getTransformedDimensions({ skewX: 0, skewY: 0 }), Kn = Un.x * zn.x / this.scaleX, qn = Un.y * zn.y / this.scaleY;
    return { width: Math.ceil(Kn + 2), height: Math.ceil(qn + 2), zoomX: zn.x, zoomY: zn.y, x: Kn, y: qn };
  }
  _updateCacheCanvas() {
    const zn = this._cacheCanvas, Un = this._cacheContext, { width: Kn, height: qn, zoomX: Jo, zoomY: pa, x: ma, y: va } = this._limitCacheSize(this._getCacheCanvasDimensions()), ba = Kn !== zn.width || qn !== zn.height, _a = this.zoomX !== Jo || this.zoomY !== pa;
    if (!zn || !Un) return !1;
    if (ba || _a) {
      Kn !== zn.width || qn !== zn.height ? (zn.width = Kn, zn.height = qn) : (Un.setTransform(1, 0, 0, 1, 0, 0), Un.clearRect(0, 0, zn.width, zn.height));
      const ya = ma / 2, xa = va / 2;
      return this.cacheTranslationX = Math.round(zn.width / 2 - ya) + ya, this.cacheTranslationY = Math.round(zn.height / 2 - xa) + xa, Un.translate(this.cacheTranslationX, this.cacheTranslationY), Un.scale(Jo, pa), this.zoomX = Jo, this.zoomY = pa, !0;
    }
    return !1;
  }
  setOptions() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this._setOptions(zn);
  }
  transform(zn) {
    const Un = this.group && !this.group._transformDone || this.group && this.canvas && zn === this.canvas.contextTop, Kn = this.calcTransformMatrix(!Un);
    zn.transform(Kn[0], Kn[1], Kn[2], Kn[3], Kn[4], Kn[5]);
  }
  getObjectScaling() {
    if (!this.group) return new ot(Math.abs(this.scaleX), Math.abs(this.scaleY));
    const zn = Dt(this.calcTransformMatrix());
    return new ot(Math.abs(zn.scaleX), Math.abs(zn.scaleY));
  }
  getTotalObjectScaling() {
    const zn = this.getObjectScaling();
    if (this.canvas) {
      const Un = this.canvas.getZoom(), Kn = this.getCanvasRetinaScaling();
      return zn.scalarMultiply(Un * Kn);
    }
    return zn;
  }
  getObjectOpacity() {
    let zn = this.opacity;
    return this.group && (zn *= this.group.getObjectOpacity()), zn;
  }
  _constrainScale(zn) {
    return Math.abs(zn) < this.minScaleLimit ? zn < 0 ? -this.minScaleLimit : this.minScaleLimit : zn === 0 ? 1e-4 : zn;
  }
  _set(zn, Un) {
    zn !== H && zn !== N$1 || (Un = this._constrainScale(Un)), zn === H && Un < 0 ? (this.flipX = !this.flipX, Un *= -1) : zn === "scaleY" && Un < 0 ? (this.flipY = !this.flipY, Un *= -1) : zn !== "shadow" || !Un || Un instanceof ds || (Un = new ds(Un));
    const Kn = this[zn] !== Un;
    return this[zn] = Un, Kn && this.constructor.cacheProperties.includes(zn) && (this.dirty = !0), this.parent && (this.dirty || Kn && this.constructor.stateProperties.includes(zn)) && this.parent._set("dirty", !0), this;
  }
  isNotVisible() {
    return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
  }
  render(zn) {
    this.isNotVisible() || this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (zn.save(), this._setupCompositeOperation(zn), this.drawSelectionBackground(zn), this.transform(zn), this._setOpacity(zn), this._setShadow(zn), this.shouldCache() ? (this.renderCache(), this.drawCacheOnCanvas(zn)) : (this._removeCacheCanvas(), this.drawObject(zn, !1, {}), this.dirty = !1), zn.restore());
  }
  drawSelectionBackground(zn) {
  }
  renderCache(zn) {
    if (zn = zn || {}, this._cacheCanvas && this._cacheContext || this._createCacheCanvas(), this.isCacheDirty() && this._cacheContext) {
      const { zoomX: Un, zoomY: Kn, cacheTranslationX: qn, cacheTranslationY: Jo } = this, { width: pa, height: ma } = this._cacheCanvas;
      this.drawObject(this._cacheContext, zn.forClipping, { zoomX: Un, zoomY: Kn, cacheTranslationX: qn, cacheTranslationY: Jo, width: pa, height: ma, parentClipPaths: [] }), this.dirty = !1;
    }
  }
  _removeCacheCanvas() {
    this._cacheCanvas = void 0, this._cacheContext = null;
  }
  hasStroke() {
    return this.stroke && this.stroke !== "transparent" && this.strokeWidth !== 0;
  }
  hasFill() {
    return this.fill && this.fill !== "transparent";
  }
  needsItsOwnCache() {
    return !!(this.paintFirst === J && this.hasFill() && this.hasStroke() && this.shadow) || !!this.clipPath;
  }
  shouldCache() {
    return this.ownCaching = this.objectCaching && (!this.parent || !this.parent.isOnACache()) || this.needsItsOwnCache(), this.ownCaching;
  }
  willDrawShadow() {
    return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
  }
  drawClipPathOnCache(zn, Un, Kn) {
    zn.save(), Un.inverted ? zn.globalCompositeOperation = "destination-out" : zn.globalCompositeOperation = "destination-in", zn.setTransform(1, 0, 0, 1, 0, 0), zn.drawImage(Kn, 0, 0), zn.restore();
  }
  drawObject(zn, Un, Kn) {
    const qn = this.fill, Jo = this.stroke;
    Un ? (this.fill = "black", this.stroke = "", this._setClippingProperties(zn)) : this._renderBackground(zn), this._render(zn), this._drawClipPath(zn, this.clipPath, Kn), this.fill = qn, this.stroke = Jo;
  }
  createClipPathLayer(zn, Un) {
    const Kn = vt(Un), qn = Kn.getContext("2d");
    if (qn.translate(Un.cacheTranslationX, Un.cacheTranslationY), qn.scale(Un.zoomX, Un.zoomY), zn._cacheCanvas = Kn, Un.parentClipPaths.forEach((Jo) => {
      Jo.transform(qn);
    }), Un.parentClipPaths.push(zn), zn.absolutePositioned) {
      const Jo = St(this.calcTransformMatrix());
      qn.transform(Jo[0], Jo[1], Jo[2], Jo[3], Jo[4], Jo[5]);
    }
    return zn.transform(qn), zn.drawObject(qn, !0, Un), Kn;
  }
  _drawClipPath(zn, Un, Kn) {
    if (!Un) return;
    Un._transformDone = !0;
    const qn = this.createClipPathLayer(Un, Kn);
    this.drawClipPathOnCache(zn, Un, qn);
  }
  drawCacheOnCanvas(zn) {
    zn.scale(1 / this.zoomX, 1 / this.zoomY), zn.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
  }
  isCacheDirty() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    if (this.isNotVisible()) return !1;
    const Un = this._cacheCanvas, Kn = this._cacheContext;
    return !(!Un || !Kn || zn || !this._updateCacheCanvas()) || !!(this.dirty || this.clipPath && this.clipPath.absolutePositioned) && (Un && Kn && !zn && (Kn.save(), Kn.setTransform(1, 0, 0, 1, 0, 0), Kn.clearRect(0, 0, Un.width, Un.height), Kn.restore()), !0);
  }
  _renderBackground(zn) {
    if (!this.backgroundColor) return;
    const Un = this._getNonTransformedDimensions();
    zn.fillStyle = this.backgroundColor, zn.fillRect(-Un.x / 2, -Un.y / 2, Un.x, Un.y), this._removeShadow(zn);
  }
  _setOpacity(zn) {
    this.group && !this.group._transformDone ? zn.globalAlpha = this.getObjectOpacity() : zn.globalAlpha *= this.opacity;
  }
  _setStrokeStyles(zn, Un) {
    const Kn = Un.stroke;
    Kn && (zn.lineWidth = Un.strokeWidth, zn.lineCap = Un.strokeLineCap, zn.lineDashOffset = Un.strokeDashOffset, zn.lineJoin = Un.strokeLineJoin, zn.miterLimit = Un.strokeMiterLimit, Gt(Kn) ? Kn.gradientUnits === "percentage" || Kn.gradientTransform || Kn.patternTransform ? this._applyPatternForTransformedGradient(zn, Kn) : (zn.strokeStyle = Kn.toLive(zn), this._applyPatternGradientTransform(zn, Kn)) : zn.strokeStyle = Un.stroke);
  }
  _setFillStyles(zn, Un) {
    let { fill: Kn } = Un;
    Kn && (Gt(Kn) ? (zn.fillStyle = Kn.toLive(zn), this._applyPatternGradientTransform(zn, Kn)) : zn.fillStyle = Kn);
  }
  _setClippingProperties(zn) {
    zn.globalAlpha = 1, zn.strokeStyle = "transparent", zn.fillStyle = "#000000";
  }
  _setLineDash(zn, Un) {
    Un && Un.length !== 0 && zn.setLineDash(Un);
  }
  _setShadow(zn) {
    if (!this.shadow) return;
    const Un = this.shadow, Kn = this.canvas, qn = this.getCanvasRetinaScaling(), [Jo, , , pa] = (Kn == null ? void 0 : Kn.viewportTransform) || T$1, ma = Jo * qn, va = pa * qn, ba = Un.nonScaling ? new ot(1, 1) : this.getObjectScaling();
    zn.shadowColor = Un.color, zn.shadowBlur = Un.blur * o$1.browserShadowBlurConstant * (ma + va) * (ba.x + ba.y) / 4, zn.shadowOffsetX = Un.offsetX * ma * ba.x, zn.shadowOffsetY = Un.offsetY * va * ba.y;
  }
  _removeShadow(zn) {
    this.shadow && (zn.shadowColor = "", zn.shadowBlur = zn.shadowOffsetX = zn.shadowOffsetY = 0);
  }
  _applyPatternGradientTransform(zn, Un) {
    if (!Gt(Un)) return { offsetX: 0, offsetY: 0 };
    const Kn = Un.gradientTransform || Un.patternTransform, qn = -this.width / 2 + Un.offsetX || 0, Jo = -this.height / 2 + Un.offsetY || 0;
    return Un.gradientUnits === "percentage" ? zn.transform(this.width, 0, 0, this.height, qn, Jo) : zn.transform(1, 0, 0, 1, qn, Jo), Kn && zn.transform(Kn[0], Kn[1], Kn[2], Kn[3], Kn[4], Kn[5]), { offsetX: qn, offsetY: Jo };
  }
  _renderPaintInOrder(zn) {
    this.paintFirst === J ? (this._renderStroke(zn), this._renderFill(zn)) : (this._renderFill(zn), this._renderStroke(zn));
  }
  _render(zn) {
  }
  _renderFill(zn) {
    this.fill && (zn.save(), this._setFillStyles(zn, this), this.fillRule === "evenodd" ? zn.fill("evenodd") : zn.fill(), zn.restore());
  }
  _renderStroke(zn) {
    if (this.stroke && this.strokeWidth !== 0) {
      if (this.shadow && !this.shadow.affectStroke && this._removeShadow(zn), zn.save(), this.strokeUniform) {
        const Un = this.getObjectScaling();
        zn.scale(1 / Un.x, 1 / Un.y);
      }
      this._setLineDash(zn, this.strokeDashArray), this._setStrokeStyles(zn, this), zn.stroke(), zn.restore();
    }
  }
  _applyPatternForTransformedGradient(zn, Un) {
    var Kn;
    const qn = this._limitCacheSize(this._getCacheCanvasDimensions()), Jo = this.getCanvasRetinaScaling(), pa = qn.x / this.scaleX / Jo, ma = qn.y / this.scaleY / Jo, va = vt({ width: Math.ceil(pa), height: Math.ceil(ma) }), ba = va.getContext("2d");
    ba && (ba.beginPath(), ba.moveTo(0, 0), ba.lineTo(pa, 0), ba.lineTo(pa, ma), ba.lineTo(0, ma), ba.closePath(), ba.translate(pa / 2, ma / 2), ba.scale(qn.zoomX / this.scaleX / Jo, qn.zoomY / this.scaleY / Jo), this._applyPatternGradientTransform(ba, Un), ba.fillStyle = Un.toLive(zn), ba.fill(), zn.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2), zn.scale(Jo * this.scaleX / qn.zoomX, Jo * this.scaleY / qn.zoomY), zn.strokeStyle = (Kn = ba.createPattern(va, "no-repeat")) !== null && Kn !== void 0 ? Kn : "");
  }
  _findCenterFromElement() {
    return new ot(this.left + this.width / 2, this.top + this.height / 2);
  }
  clone(zn) {
    const Un = this.toObject(zn);
    return this.constructor.fromObject(Un);
  }
  cloneAsImage(zn) {
    const Un = this.toCanvasElement(zn);
    return new (tt.getClass("image"))(Un);
  }
  toCanvasElement() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const Un = de(this), Kn = this.group, qn = this.shadow, Jo = Math.abs, pa = zn.enableRetinaScaling ? y$3() : 1, ma = (zn.multiplier || 1) * pa, va = zn.canvasProvider || ((Za) => new se(Za, { enableRetinaScaling: !1, renderOnAddRemove: !1, skipOffscreen: !1 }));
    delete this.group, zn.withoutTransform && ue(this), zn.withoutShadow && (this.shadow = null), zn.viewportTransform && ve(this, this.getViewportTransform()), this.setCoords();
    const ba = pt(), _a = this.getBoundingRect(), ya = this.shadow, xa = new ot();
    if (ya) {
      const Za = ya.blur, Na = ya.nonScaling ? new ot(1, 1) : this.getObjectScaling();
      xa.x = 2 * Math.round(Jo(ya.offsetX) + Za) * Jo(Na.x), xa.y = 2 * Math.round(Jo(ya.offsetY) + Za) * Jo(Na.y);
    }
    const wa = _a.width + xa.x, Ta = _a.height + xa.y;
    ba.width = Math.ceil(wa), ba.height = Math.ceil(Ta);
    const Sa = va(ba);
    zn.format === "jpeg" && (Sa.backgroundColor = "#fff"), this.setPositionByOrigin(new ot(Sa.width / 2, Sa.height / 2), D, D);
    const Ma = this.canvas;
    Sa._objects = [this], this.set("canvas", Sa), this.setCoords();
    const ka = Sa.toCanvasElement(ma || 1, zn);
    return this.set("canvas", Ma), this.shadow = qn, Kn && (this.group = Kn), this.set(Un), this.setCoords(), Sa._objects = [], Sa.destroy(), ka;
  }
  toDataURL() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return yt(this.toCanvasElement(zn), zn.format || "png", zn.quality || 1);
  }
  toBlob() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return _t(this.toCanvasElement(zn), zn.format || "png", zn.quality || 1);
  }
  isType() {
    for (var zn = arguments.length, Un = new Array(zn), Kn = 0; Kn < zn; Kn++) Un[Kn] = arguments[Kn];
    return Un.includes(this.constructor.type) || Un.includes(this.type);
  }
  complexity() {
    return 1;
  }
  toJSON() {
    return this.toObject();
  }
  rotate(zn) {
    const { centeredRotation: Un, originX: Kn, originY: qn } = this;
    if (Un) {
      const { x: Jo, y: pa } = this.getRelativeCenterPoint();
      this.originX = D, this.originY = D, this.left = Jo, this.top = pa;
    }
    if (this.set("angle", zn), Un) {
      const { x: Jo, y: pa } = this.translateToOriginPoint(this.getRelativeCenterPoint(), Kn, qn);
      this.left = Jo, this.top = pa, this.originX = Kn, this.originY = qn;
    }
  }
  setOnGroup() {
  }
  _setupCompositeOperation(zn) {
    this.globalCompositeOperation && (zn.globalCompositeOperation = this.globalCompositeOperation);
  }
  dispose() {
    et.cancelByTarget(this), this.off(), this._set("canvas", void 0), this._cacheCanvas && p$1().dispose(this._cacheCanvas), this._cacheCanvas = void 0, this._cacheContext = null;
  }
  animate(zn, Un) {
    return Object.entries(zn).reduce((Kn, qn) => {
      let [Jo, pa] = qn;
      return Kn[Jo] = this._animate(Jo, pa, Un), Kn;
    }, {});
  }
  _animate(zn, Un) {
    let Kn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const qn = zn.split("."), Jo = this.constructor.colorProperties.includes(qn[qn.length - 1]), { abort: pa, startValue: ma, onChange: va, onComplete: ba } = Kn, _a = s$1(s$1({}, Kn), {}, { target: this, startValue: ma ?? qn.reduce((ya, xa) => ya[xa], this), endValue: Un, abort: pa == null ? void 0 : pa.bind(this), onChange: (ya, xa, wa) => {
      qn.reduce((Ta, Sa, Ma) => (Ma === qn.length - 1 && (Ta[Sa] = ya), Ta[Sa]), this), va && va(ya, xa, wa);
    }, onComplete: (ya, xa, wa) => {
      this.setCoords(), ba && ba(ya, xa, wa);
    } });
    return Jo ? Fs(_a) : js(_a);
  }
  isDescendantOf(zn) {
    const { parent: Un, group: Kn } = this;
    return Un === zn || Kn === zn || !!Un && Un.isDescendantOf(zn) || !!Kn && Kn !== Un && Kn.isDescendantOf(zn);
  }
  getAncestors() {
    const zn = [];
    let Un = this;
    do
      Un = Un.parent, Un && zn.push(Un);
    while (Un);
    return zn;
  }
  findCommonAncestors(zn) {
    if (this === zn) return { fork: [], otherFork: [], common: [this, ...this.getAncestors()] };
    const Un = this.getAncestors(), Kn = zn.getAncestors();
    if (Un.length === 0 && Kn.length > 0 && this === Kn[Kn.length - 1]) return { fork: [], otherFork: [zn, ...Kn.slice(0, Kn.length - 1)], common: [this] };
    for (let qn, Jo = 0; Jo < Un.length; Jo++) {
      if (qn = Un[Jo], qn === zn) return { fork: [this, ...Un.slice(0, Jo)], otherFork: [], common: Un.slice(Jo) };
      for (let pa = 0; pa < Kn.length; pa++) {
        if (this === Kn[pa]) return { fork: [], otherFork: [zn, ...Kn.slice(0, pa)], common: [this, ...Un] };
        if (qn === Kn[pa]) return { fork: [this, ...Un.slice(0, Jo)], otherFork: [zn, ...Kn.slice(0, pa)], common: Un.slice(Jo) };
      }
    }
    return { fork: [this, ...Un], otherFork: [zn, ...Kn], common: [] };
  }
  hasCommonAncestors(zn) {
    const Un = this.findCommonAncestors(zn);
    return Un && !!Un.common.length;
  }
  isInFrontOf(zn) {
    if (this === zn) return;
    const Un = this.findCommonAncestors(zn);
    if (Un.fork.includes(zn)) return !0;
    if (Un.otherFork.includes(this)) return !1;
    const Kn = Un.common[0] || this.canvas;
    if (!Kn) return;
    const qn = Un.fork.pop(), Jo = Un.otherFork.pop(), pa = Kn._objects.indexOf(qn), ma = Kn._objects.indexOf(Jo);
    return pa > -1 && pa > ma;
  }
  toObject() {
    const zn = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).concat(fd.customProperties, this.constructor.customProperties || []);
    let Un;
    const Kn = o$1.NUM_FRACTION_DIGITS, { clipPath: qn, fill: Jo, stroke: pa, shadow: ma, strokeDashArray: va, left: ba, top: _a, originX: ya, originY: xa, width: wa, height: Ta, strokeWidth: Sa, strokeLineCap: Ma, strokeDashOffset: ka, strokeLineJoin: Za, strokeUniform: Na, strokeMiterLimit: Ka, scaleX: Ja, scaleY: el, angle: qa, flipX: tl, flipY: Qa, opacity: nl, visible: rl, backgroundColor: il, fillRule: cl, paintFirst: ll, globalCompositeOperation: al, skewX: sl, skewY: dl } = this;
    qn && !qn.excludeFromExport && (Un = qn.toObject(zn.concat("inverted", "absolutePositioned")));
    const El = (Ml) => Vt(Ml, Kn), fl = s$1(s$1({}, Yt(this, zn)), {}, { type: this.constructor.type, version: x$3, originX: ya, originY: xa, left: El(ba), top: El(_a), width: El(wa), height: El(Ta), fill: Ht(Jo) ? Jo.toObject() : Jo, stroke: Ht(pa) ? pa.toObject() : pa, strokeWidth: El(Sa), strokeDashArray: va && va.concat(), strokeLineCap: Ma, strokeDashOffset: ka, strokeLineJoin: Za, strokeUniform: Na, strokeMiterLimit: El(Ka), scaleX: El(Ja), scaleY: El(el), angle: El(qa), flipX: tl, flipY: Qa, opacity: El(nl), shadow: ma && ma.toObject(), visible: rl, backgroundColor: il, fillRule: cl, paintFirst: ll, globalCompositeOperation: al, skewX: El(sl), skewY: El(dl) }, Un ? { clipPath: Un } : null);
    return this.includeDefaultValues ? fl : this._removeDefaultValues(fl);
  }
  toDatalessObject(zn) {
    return this.toObject(zn);
  }
  _removeDefaultValues(zn) {
    const Un = this.constructor.getDefaults(), Kn = Object.keys(Un).length > 0 ? Un : Object.getPrototypeOf(this);
    return Wt(zn, (qn, Jo) => {
      if (Jo === M$1 || Jo === P || Jo === "type") return !0;
      const pa = Kn[Jo];
      return qn !== pa && !(Array.isArray(qn) && Array.isArray(pa) && qn.length === 0 && pa.length === 0);
    });
  }
  toString() {
    return "#<".concat(this.constructor.type, ">");
  }
  static _fromObject(zn) {
    let Un = i$3(zn, Is), Kn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { extraParam: qn } = Kn, Jo = i$3(Kn, Bs);
    return Xt(Un, Jo).then((pa) => qn ? (delete pa[qn], new this(Un[qn], pa)) : new this(pa));
  }
  static fromObject(zn, Un) {
    return this._fromObject(zn, Un);
  }
};
t$1(Xs, "stateProperties", fs), t$1(Xs, "cacheProperties", ps), t$1(Xs, "ownDefaults", ms), t$1(Xs, "type", "FabricObject"), t$1(Xs, "colorProperties", [K, J, "backgroundColor"]), t$1(Xs, "customProperties", []), tt.setClass(Xs), tt.setClass(Xs, "object");
const Ys = (Xn, zn, Un) => (Kn, qn, Jo, pa) => {
  const ma = zn(Kn, qn, Jo, pa);
  return ma && ye(Xn, s$1(s$1({}, Te(Kn, qn, Jo, pa)), Un)), ma;
};
function Ws(Xn) {
  return (zn, Un, Kn, qn) => {
    const { target: Jo, originX: pa, originY: ma } = Un, va = Jo.getRelativeCenterPoint(), ba = Jo.translateToOriginPoint(va, pa, ma), _a = Xn(zn, Un, Kn, qn);
    return Jo.setPositionByOrigin(ba, Un.originX, Un.originY), _a;
  };
}
const Vs = Ys(Y$2, Ws((Xn, zn, Un, Kn) => {
  const qn = ke(zn, zn.originX, zn.originY, Un, Kn);
  if (xe(zn.originX) === xe(D) || xe(zn.originX) === xe(A$1) && qn.x < 0 || xe(zn.originX) === xe(M$1) && qn.x > 0) {
    const { target: Jo } = zn, pa = Jo.strokeWidth / (Jo.strokeUniform ? Jo.scaleX : 1), ma = be(zn) ? 2 : 1, va = Jo.width, ba = Math.abs(qn.x * ma / Jo.scaleX) - pa;
    return Jo.set("width", Math.max(ba, 1)), va !== Jo.width;
  }
  return !1;
}));
function zs(Xn, zn, Un, Kn, qn) {
  Kn = Kn || {};
  const Jo = this.sizeX || Kn.cornerSize || qn.cornerSize, pa = this.sizeY || Kn.cornerSize || qn.cornerSize, ma = Kn.transparentCorners !== void 0 ? Kn.transparentCorners : qn.transparentCorners, va = ma ? J : K, ba = !ma && (Kn.cornerStrokeColor || qn.cornerStrokeColor);
  let _a, ya = zn, xa = Un;
  Xn.save(), Xn.fillStyle = Kn.cornerColor || qn.cornerColor || "", Xn.strokeStyle = Kn.cornerStrokeColor || qn.cornerStrokeColor || "", Jo > pa ? (_a = Jo, Xn.scale(1, pa / Jo), xa = Un * Jo / pa) : pa > Jo ? (_a = pa, Xn.scale(Jo / pa, 1), ya = zn * pa / Jo) : _a = Jo, Xn.beginPath(), Xn.arc(ya, xa, _a / 2, 0, w, !1), Xn[va](), ba && Xn.stroke(), Xn.restore();
}
function Gs(Xn, zn, Un, Kn, qn) {
  Kn = Kn || {};
  const Jo = this.sizeX || Kn.cornerSize || qn.cornerSize, pa = this.sizeY || Kn.cornerSize || qn.cornerSize, ma = Kn.transparentCorners !== void 0 ? Kn.transparentCorners : qn.transparentCorners, va = ma ? J : K, ba = !ma && (Kn.cornerStrokeColor || qn.cornerStrokeColor), _a = Jo / 2, ya = pa / 2;
  Xn.save(), Xn.fillStyle = Kn.cornerColor || qn.cornerColor || "", Xn.strokeStyle = Kn.cornerStrokeColor || qn.cornerStrokeColor || "", Xn.translate(zn, Un);
  const xa = qn.getTotalAngle();
  Xn.rotate(xt(xa)), Xn["".concat(va, "Rect")](-_a, -ya, Jo, pa), ba && Xn.strokeRect(-_a, -ya, Jo, pa), Xn.restore();
}
class Hs {
  constructor(zn) {
    t$1(this, "visible", !0), t$1(this, "actionName", G), t$1(this, "angle", 0), t$1(this, "x", 0), t$1(this, "y", 0), t$1(this, "offsetX", 0), t$1(this, "offsetY", 0), t$1(this, "sizeX", 0), t$1(this, "sizeY", 0), t$1(this, "touchSizeX", 0), t$1(this, "touchSizeY", 0), t$1(this, "cursorStyle", "crosshair"), t$1(this, "withConnection", !1), Object.assign(this, zn);
  }
  shouldActivate(zn, Un, Kn, qn) {
    var Jo;
    let { tl: pa, tr: ma, br: va, bl: ba } = qn;
    return ((Jo = Un.canvas) === null || Jo === void 0 ? void 0 : Jo.getActiveObject()) === Un && Un.isControlVisible(zn) && Ls.isPointInPolygon(Kn, [pa, ma, va, ba]);
  }
  getActionHandler(zn, Un, Kn) {
    return this.actionHandler;
  }
  getMouseDownHandler(zn, Un, Kn) {
    return this.mouseDownHandler;
  }
  getMouseUpHandler(zn, Un, Kn) {
    return this.mouseUpHandler;
  }
  cursorStyleHandler(zn, Un, Kn) {
    return Un.cursorStyle;
  }
  getActionName(zn, Un, Kn) {
    return Un.actionName;
  }
  getVisibility(zn, Un) {
    var Kn, qn;
    return (Kn = (qn = zn._controlsVisibility) === null || qn === void 0 ? void 0 : qn[Un]) !== null && Kn !== void 0 ? Kn : this.visible;
  }
  setVisibility(zn, Un, Kn) {
    this.visible = zn;
  }
  positionHandler(zn, Un, Kn, qn) {
    return new ot(this.x * zn.x + this.offsetX, this.y * zn.y + this.offsetY).transform(Un);
  }
  calcCornerCoords(zn, Un, Kn, qn, Jo, pa) {
    const ma = Ot([Mt(Kn, qn), Pt({ angle: zn }), Et((Jo ? this.touchSizeX : this.sizeX) || Un, (Jo ? this.touchSizeY : this.sizeY) || Un)]);
    return { tl: new ot(-0.5, -0.5).transform(ma), tr: new ot(0.5, -0.5).transform(ma), br: new ot(0.5, 0.5).transform(ma), bl: new ot(-0.5, 0.5).transform(ma) };
  }
  render(zn, Un, Kn, qn, Jo) {
    ((qn = qn || {}).cornerStyle || Jo.cornerStyle) === "circle" ? zs.call(this, zn, Un, Kn, qn, Jo) : Gs.call(this, zn, Un, Kn, qn, Jo);
  }
}
const Ns = (Xn, zn, Un) => Un.lockRotation ? Ce : zn.cursorStyle, Us = Ys(I, Ws((Xn, zn, Un, Kn) => {
  let { target: qn, ex: Jo, ey: pa, theta: ma, originX: va, originY: ba } = zn;
  const _a = qn.translateToOriginPoint(qn.getRelativeCenterPoint(), va, ba);
  if (Se(qn, "lockRotation")) return !1;
  const ya = Math.atan2(pa - _a.y, Jo - _a.x), xa = Math.atan2(Kn - _a.y, Un - _a.x);
  let wa = Ct(xa - ya + ma);
  if (qn.snapAngle && qn.snapAngle > 0) {
    const Sa = qn.snapAngle, Ma = qn.snapThreshold || Sa, ka = Math.ceil(wa / Sa) * Sa, Za = Math.floor(wa / Sa) * Sa;
    Math.abs(wa - Za) < Ma ? wa = Za : Math.abs(wa - ka) < Ma && (wa = ka);
  }
  wa < 0 && (wa = 360 + wa), wa %= 360;
  const Ta = qn.angle !== wa;
  return qn.angle = wa, Ta;
}));
function qs(Xn, zn) {
  const Un = zn.canvas, Kn = Xn[Un.uniScaleKey];
  return Un.uniformScaling && !Kn || !Un.uniformScaling && Kn;
}
function Ks(Xn, zn, Un) {
  const Kn = Se(Xn, "lockScalingX"), qn = Se(Xn, "lockScalingY");
  if (Kn && qn || !zn && (Kn || qn) && Un || Kn && zn === "x" || qn && zn === "y") return !0;
  const { width: Jo, height: pa, strokeWidth: ma } = Xn;
  return Jo === 0 && ma === 0 && zn !== "y" || pa === 0 && ma === 0 && zn !== "x";
}
const Js = ["e", "se", "s", "sw", "w", "nw", "n", "ne", "e"], Qs = (Xn, zn, Un) => {
  const Kn = qs(Xn, Un);
  if (Ks(Un, zn.x !== 0 && zn.y === 0 ? "x" : zn.x === 0 && zn.y !== 0 ? "y" : "", Kn)) return Ce;
  const qn = Oe(Un, zn);
  return "".concat(Js[qn], "-resize");
};
function Zs(Xn, zn, Un, Kn) {
  let qn = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
  const Jo = zn.target, pa = qn.by, ma = qs(Xn, Jo);
  let va, ba, _a, ya, xa, wa;
  if (Ks(Jo, pa, ma)) return !1;
  if (zn.gestureScale) ba = zn.scaleX * zn.gestureScale, _a = zn.scaleY * zn.gestureScale;
  else {
    if (va = ke(zn, zn.originX, zn.originY, Un, Kn), xa = pa !== "y" ? Math.sign(va.x || zn.signX || 1) : 1, wa = pa !== "x" ? Math.sign(va.y || zn.signY || 1) : 1, zn.signX || (zn.signX = xa), zn.signY || (zn.signY = wa), Se(Jo, "lockScalingFlip") && (zn.signX !== xa || zn.signY !== wa)) return !1;
    if (ya = Jo._getTransformedDimensions(), ma && !pa) {
      const Ma = Math.abs(va.x) + Math.abs(va.y), { original: ka } = zn, Za = Ma / (Math.abs(ya.x * ka.scaleX / Jo.scaleX) + Math.abs(ya.y * ka.scaleY / Jo.scaleY));
      ba = ka.scaleX * Za, _a = ka.scaleY * Za;
    } else ba = Math.abs(va.x * Jo.scaleX / ya.x), _a = Math.abs(va.y * Jo.scaleY / ya.y);
    be(zn) && (ba *= 2, _a *= 2), zn.signX !== xa && pa !== "y" && (zn.originX = we(zn.originX), ba *= -1, zn.signX = xa), zn.signY !== wa && pa !== "x" && (zn.originY = we(zn.originY), _a *= -1, zn.signY = wa);
  }
  const Ta = Jo.scaleX, Sa = Jo.scaleY;
  return pa ? (pa === "x" && Jo.set(H, ba), pa === "y" && Jo.set(N$1, _a)) : (!Se(Jo, "lockScalingX") && Jo.set(H, ba), !Se(Jo, "lockScalingY") && Jo.set(N$1, _a)), Ta !== Jo.scaleX || Sa !== Jo.scaleY;
}
const $s = Ys(R$1, Ws((Xn, zn, Un, Kn) => Zs(Xn, zn, Un, Kn))), ti = Ys(R$1, Ws((Xn, zn, Un, Kn) => Zs(Xn, zn, Un, Kn, { by: "x" }))), ei = Ys(R$1, Ws((Xn, zn, Un, Kn) => Zs(Xn, zn, Un, Kn, { by: "y" }))), si = ["target", "ex", "ey", "skewingSide"], ii = { x: { counterAxis: "y", scale: H, skew: U, lockSkewing: "lockSkewingX", origin: "originX", flip: "flipX" }, y: { counterAxis: "x", scale: N$1, skew: q, lockSkewing: "lockSkewingY", origin: "originY", flip: "flipY" } }, ri = ["ns", "nesw", "ew", "nwse"], ni = (Xn, zn, Un) => {
  if (zn.x !== 0 && Se(Un, "lockSkewingY") || zn.y !== 0 && Se(Un, "lockSkewingX")) return Ce;
  const Kn = Oe(Un, zn) % 4;
  return "".concat(ri[Kn], "-resize");
};
function oi(Xn, zn, Un, Kn, qn) {
  const { target: Jo } = Un, { counterAxis: pa, origin: ma, lockSkewing: va, skew: ba, flip: _a } = ii[Xn];
  if (Se(Jo, va)) return !1;
  const { origin: ya, flip: xa } = ii[pa], wa = xe(Un[ya]) * (Jo[xa] ? -1 : 1), Ta = -Math.sign(wa) * (Jo[_a] ? -1 : 1), Sa = 0.5 * -((Jo[ba] === 0 && ke(Un, D, D, Kn, qn)[Xn] > 0 || Jo[ba] > 0 ? 1 : -1) * Ta) + 0.5;
  return Ys(X, Ws((ka, Za, Na, Ka) => function(Ja, el, qa) {
    let { target: tl, ex: Qa, ey: nl, skewingSide: rl } = el, il = i$3(el, si);
    const { skew: cl } = ii[Ja], ll = qa.subtract(new ot(Qa, nl)).divide(new ot(tl.scaleX, tl.scaleY))[Ja], al = tl[cl], sl = il[cl], dl = Math.tan(xt(sl)), El = Ja === "y" ? tl._getTransformedDimensions({ scaleX: 1, scaleY: 1, skewX: 0 }).x : tl._getTransformedDimensions({ scaleX: 1, scaleY: 1 }).y, fl = 2 * ll * rl / Math.max(El, 1) + dl, Ml = Ct(Math.atan(fl));
    tl.set(cl, Ml);
    const Sl = al !== tl[cl];
    if (Sl && Ja === "y") {
      const { skewX: ml, scaleX: Dl } = tl, _l = tl._getTransformedDimensions({ skewY: al }), gl = tl._getTransformedDimensions(), Fl = ml !== 0 ? _l.x / gl.x : 1;
      Fl !== 1 && tl.set(H, Fl * Dl);
    }
    return Sl;
  }(Xn, Za, new ot(Na, Ka))))(zn, s$1(s$1({}, Un), {}, { [ma]: Sa, skewingSide: Ta }), Kn, qn);
}
const ai = (Xn, zn, Un, Kn) => oi("x", Xn, zn, Un, Kn), hi = (Xn, zn, Un, Kn) => oi("y", Xn, zn, Un, Kn);
function ci(Xn, zn) {
  return Xn[zn.canvas.altActionKey];
}
const li = (Xn, zn, Un) => {
  const Kn = ci(Xn, Un);
  return zn.x === 0 ? Kn ? U : N$1 : zn.y === 0 ? Kn ? q : H : "";
}, ui = (Xn, zn, Un) => ci(Xn, Un) ? ni(0, zn, Un) : Qs(Xn, zn, Un), di = (Xn, zn, Un, Kn) => ci(Xn, zn.target) ? hi(Xn, zn, Un, Kn) : ti(Xn, zn, Un, Kn), gi = (Xn, zn, Un, Kn) => ci(Xn, zn.target) ? ai(Xn, zn, Un, Kn) : ei(Xn, zn, Un, Kn), fi = () => ({ ml: new Hs({ x: -0.5, y: 0, cursorStyleHandler: ui, actionHandler: di, getActionName: li }), mr: new Hs({ x: 0.5, y: 0, cursorStyleHandler: ui, actionHandler: di, getActionName: li }), mb: new Hs({ x: 0, y: 0.5, cursorStyleHandler: ui, actionHandler: gi, getActionName: li }), mt: new Hs({ x: 0, y: -0.5, cursorStyleHandler: ui, actionHandler: gi, getActionName: li }), tl: new Hs({ x: -0.5, y: -0.5, cursorStyleHandler: Qs, actionHandler: $s }), tr: new Hs({ x: 0.5, y: -0.5, cursorStyleHandler: Qs, actionHandler: $s }), bl: new Hs({ x: -0.5, y: 0.5, cursorStyleHandler: Qs, actionHandler: $s }), br: new Hs({ x: 0.5, y: 0.5, cursorStyleHandler: Qs, actionHandler: $s }), mtr: new Hs({ x: 0, y: -0.5, actionHandler: Us, cursorStyleHandler: Ns, offsetY: -40, withConnection: !0, actionName: B$1 }) }), pi = () => ({ mr: new Hs({ x: 0.5, y: 0, actionHandler: Vs, cursorStyleHandler: ui, actionName: Y$2 }), ml: new Hs({ x: -0.5, y: 0, actionHandler: Vs, cursorStyleHandler: ui, actionName: Y$2 }) }), mi = () => s$1(s$1({}, fi()), pi());
class vi extends Xs {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), vi.ownDefaults);
  }
  constructor(zn) {
    super(), Object.assign(this, this.constructor.createControls(), vi.ownDefaults), this.setOptions(zn);
  }
  static createControls() {
    return { controls: fi() };
  }
  _updateCacheCanvas() {
    const zn = this.canvas;
    if (this.noScaleCache && zn && zn._currentTransform) {
      const Un = zn._currentTransform, Kn = Un.target, qn = Un.action;
      if (this === Kn && qn && qn.startsWith(G)) return !1;
    }
    return super._updateCacheCanvas();
  }
  getActiveControl() {
    const zn = this.__corner;
    return zn ? { key: zn, control: this.controls[zn], coord: this.oCoords[zn] } : void 0;
  }
  findControl(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    if (!this.hasControls || !this.canvas) return;
    this.__corner = void 0;
    const Kn = Object.entries(this.oCoords);
    for (let qn = Kn.length - 1; qn >= 0; qn--) {
      const [Jo, pa] = Kn[qn], ma = this.controls[Jo];
      if (ma.shouldActivate(Jo, this, zn, Un ? pa.touchCorner : pa.corner)) return this.__corner = Jo, { key: Jo, control: ma, coord: this.oCoords[Jo] };
    }
  }
  calcOCoords() {
    const zn = this.getViewportTransform(), Un = this.getCenterPoint(), Kn = Mt(Un.x, Un.y), qn = Pt({ angle: this.getTotalAngle() - (this.group && this.flipX ? 180 : 0) }), Jo = Tt(Kn, qn), pa = Tt(zn, Jo), ma = Tt(pa, [1 / zn[0], 0, 0, 1 / zn[3], 0, 0]), va = this.group ? Dt(this.calcTransformMatrix()) : void 0;
    va && (va.scaleX = Math.abs(va.scaleX), va.scaleY = Math.abs(va.scaleY));
    const ba = this._calculateCurrentDimensions(va), _a = {};
    return this.forEachControl((ya, xa) => {
      const wa = ya.positionHandler(ba, ma, this, ya);
      _a[xa] = Object.assign(wa, this._calcCornerCoords(ya, wa));
    }), _a;
  }
  _calcCornerCoords(zn, Un) {
    const Kn = this.getTotalAngle();
    return { corner: zn.calcCornerCoords(Kn, this.cornerSize, Un.x, Un.y, !1, this), touchCorner: zn.calcCornerCoords(Kn, this.touchCornerSize, Un.x, Un.y, !0, this) };
  }
  setCoords() {
    super.setCoords(), this.canvas && (this.oCoords = this.calcOCoords());
  }
  forEachControl(zn) {
    for (const Un in this.controls) zn(this.controls[Un], Un, this);
  }
  drawSelectionBackground(zn) {
    if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) return;
    zn.save();
    const Un = this.getRelativeCenterPoint(), Kn = this._calculateCurrentDimensions(), qn = this.getViewportTransform();
    zn.translate(Un.x, Un.y), zn.scale(1 / qn[0], 1 / qn[3]), zn.rotate(xt(this.angle)), zn.fillStyle = this.selectionBackgroundColor, zn.fillRect(-Kn.x / 2, -Kn.y / 2, Kn.x, Kn.y), zn.restore();
  }
  strokeBorders(zn, Un) {
    zn.strokeRect(-Un.x / 2, -Un.y / 2, Un.x, Un.y);
  }
  _drawBorders(zn, Un) {
    let Kn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const qn = s$1({ hasControls: this.hasControls, borderColor: this.borderColor, borderDashArray: this.borderDashArray }, Kn);
    zn.save(), zn.strokeStyle = qn.borderColor, this._setLineDash(zn, qn.borderDashArray), this.strokeBorders(zn, Un), qn.hasControls && this.drawControlsConnectingLines(zn, Un), zn.restore();
  }
  _renderControls(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { hasBorders: Kn, hasControls: qn } = this, Jo = s$1({ hasBorders: Kn, hasControls: qn }, Un), pa = this.getViewportTransform(), ma = Jo.hasBorders, va = Jo.hasControls, ba = Tt(pa, this.calcTransformMatrix()), _a = Dt(ba);
    zn.save(), zn.translate(_a.translateX, _a.translateY), zn.lineWidth = this.borderScaleFactor, this.group === this.parent && (zn.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1), this.flipX && (_a.angle -= 180), zn.rotate(xt(this.group ? _a.angle : this.angle)), ma && this.drawBorders(zn, _a, Un), va && this.drawControls(zn, Un), zn.restore();
  }
  drawBorders(zn, Un, Kn) {
    let qn;
    if (Kn && Kn.forActiveSelection || this.group) {
      const Jo = ge(this.width, this.height, Lt(Un)), pa = this.isStrokeAccountedForInDimensions() ? at : (this.strokeUniform ? new ot().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) : new ot(Un.scaleX, Un.scaleY)).scalarMultiply(this.strokeWidth);
      qn = Jo.add(pa).scalarAdd(this.borderScaleFactor).scalarAdd(2 * this.padding);
    } else qn = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
    this._drawBorders(zn, qn, Kn);
  }
  drawControlsConnectingLines(zn, Un) {
    let Kn = !1;
    zn.beginPath(), this.forEachControl((qn, Jo) => {
      qn.withConnection && qn.getVisibility(this, Jo) && (Kn = !0, zn.moveTo(qn.x * Un.x, qn.y * Un.y), zn.lineTo(qn.x * Un.x + qn.offsetX, qn.y * Un.y + qn.offsetY));
    }), Kn && zn.stroke();
  }
  drawControls(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    zn.save();
    const Kn = this.getCanvasRetinaScaling(), { cornerStrokeColor: qn, cornerDashArray: Jo, cornerColor: pa } = this, ma = s$1({ cornerStrokeColor: qn, cornerDashArray: Jo, cornerColor: pa }, Un);
    zn.setTransform(Kn, 0, 0, Kn, 0, 0), zn.strokeStyle = zn.fillStyle = ma.cornerColor, this.transparentCorners || (zn.strokeStyle = ma.cornerStrokeColor), this._setLineDash(zn, ma.cornerDashArray), this.forEachControl((va, ba) => {
      if (va.getVisibility(this, ba)) {
        const _a = this.oCoords[ba];
        va.render(zn, _a.x, _a.y, ma, this);
      }
    }), zn.restore();
  }
  isControlVisible(zn) {
    return this.controls[zn] && this.controls[zn].getVisibility(this, zn);
  }
  setControlVisible(zn, Un) {
    this._controlsVisibility || (this._controlsVisibility = {}), this._controlsVisibility[zn] = Un;
  }
  setControlsVisibility() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Object.entries(zn).forEach((Un) => {
      let [Kn, qn] = Un;
      return this.setControlVisible(Kn, qn);
    });
  }
  clearContextTop(zn) {
    if (!this.canvas) return;
    const Un = this.canvas.contextTop;
    if (!Un) return;
    const Kn = this.canvas.viewportTransform;
    Un.save(), Un.transform(Kn[0], Kn[1], Kn[2], Kn[3], Kn[4], Kn[5]), this.transform(Un);
    const qn = this.width + 4, Jo = this.height + 4;
    return Un.clearRect(-qn / 2, -Jo / 2, qn, Jo), zn || Un.restore(), Un;
  }
  onDeselect(zn) {
    return !1;
  }
  onSelect(zn) {
    return !1;
  }
  shouldStartDragging(zn) {
    return !1;
  }
  onDragStart(zn) {
    return !1;
  }
  canDrop(zn) {
    return !1;
  }
  renderDragSourceEffect(zn) {
  }
  renderDropTargetEffect(zn) {
  }
}
function yi(Xn, zn) {
  return zn.forEach((Un) => {
    Object.getOwnPropertyNames(Un.prototype).forEach((Kn) => {
      Kn !== "constructor" && Object.defineProperty(Xn.prototype, Kn, Object.getOwnPropertyDescriptor(Un.prototype, Kn) || /* @__PURE__ */ Object.create(null));
    });
  }), Xn;
}
t$1(vi, "ownDefaults", { noScaleCache: !0, lockMovementX: !1, lockMovementY: !1, lockRotation: !1, lockScalingX: !1, lockScalingY: !1, lockSkewingX: !1, lockSkewingY: !1, lockScalingFlip: !1, cornerSize: 13, touchCornerSize: 24, transparentCorners: !0, cornerColor: "rgb(178,204,255)", cornerStrokeColor: "", cornerStyle: "rect", cornerDashArray: null, hasControls: !0, borderColor: "rgb(178,204,255)", borderDashArray: null, borderOpacityWhenMoving: 0.4, borderScaleFactor: 1, hasBorders: !0, selectionBackgroundColor: "", selectable: !0, evented: !0, perPixelTargetFind: !1, activeOn: "down", hoverCursor: null, moveCursor: null });
class _i extends vi {
}
yi(_i, [Xe]), tt.setClass(_i), tt.setClass(_i, "object");
const xi = (Xn, zn, Un, Kn) => {
  const qn = 2 * (Kn = Math.round(Kn)) + 1, { data: Jo } = Xn.getImageData(zn - Kn, Un - Kn, qn, qn);
  for (let pa = 3; pa < Jo.length; pa += 4)
    if (Jo[pa] > 0) return !1;
  return !0;
};
class Ci {
  constructor(zn) {
    this.options = zn, this.strokeProjectionMagnitude = this.options.strokeWidth / 2, this.scale = new ot(this.options.scaleX, this.options.scaleY), this.strokeUniformScalar = this.options.strokeUniform ? new ot(1 / this.options.scaleX, 1 / this.options.scaleY) : new ot(1, 1);
  }
  createSideVector(zn, Un) {
    const Kn = es(zn, Un);
    return this.options.strokeUniform ? Kn.multiply(this.scale) : Kn;
  }
  projectOrthogonally(zn, Un, Kn) {
    return this.applySkew(zn.add(this.calcOrthogonalProjection(zn, Un, Kn)));
  }
  isSkewed() {
    return this.options.skewX !== 0 || this.options.skewY !== 0;
  }
  applySkew(zn) {
    const Un = new ot(zn);
    return Un.y += Un.x * Math.tan(xt(this.options.skewY)), Un.x += Un.y * Math.tan(xt(this.options.skewX)), Un;
  }
  scaleUnitVector(zn, Un) {
    return zn.multiply(this.strokeUniformScalar).scalarMultiply(Un);
  }
}
const bi = new ot();
class wi extends Ci {
  static getOrthogonalRotationFactor(zn, Un) {
    const Kn = Un ? is(zn, Un) : rs(zn);
    return Math.abs(Kn) < b$1 ? -1 : 1;
  }
  constructor(zn, Un, Kn, qn) {
    super(qn), t$1(this, "AB", void 0), t$1(this, "AC", void 0), t$1(this, "alpha", void 0), t$1(this, "bisector", void 0), this.A = new ot(zn), this.B = new ot(Un), this.C = new ot(Kn), this.AB = this.createSideVector(this.A, this.B), this.AC = this.createSideVector(this.A, this.C), this.alpha = is(this.AB, this.AC), this.bisector = ns(ts(this.AB.eq(bi) ? this.AC : this.AB, this.alpha / 2));
  }
  calcOrthogonalProjection(zn, Un) {
    let Kn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.strokeProjectionMagnitude;
    const qn = this.createSideVector(zn, Un), Jo = os(qn), pa = wi.getOrthogonalRotationFactor(Jo, this.bisector);
    return this.scaleUnitVector(Jo, Kn * pa);
  }
  projectBevel() {
    const zn = [];
    return (this.alpha % w == 0 ? [this.B] : [this.B, this.C]).forEach((Un) => {
      zn.push(this.projectOrthogonally(this.A, Un)), zn.push(this.projectOrthogonally(this.A, Un, -this.strokeProjectionMagnitude));
    }), zn;
  }
  projectMiter() {
    const zn = [], Un = Math.abs(this.alpha), Kn = 1 / Math.sin(Un / 2), qn = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * Kn), Jo = this.options.strokeUniform ? ss(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
    return ss(qn) / this.strokeProjectionMagnitude <= Jo && zn.push(this.applySkew(this.A.add(qn))), zn.push(...this.projectBevel()), zn;
  }
  projectRoundNoSkew(zn, Un) {
    const Kn = [], qn = new ot(wi.getOrthogonalRotationFactor(this.bisector), wi.getOrthogonalRotationFactor(new ot(this.bisector.y, this.bisector.x)));
    return [new ot(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(qn), new ot(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(qn)].forEach((Jo) => {
      cs(Jo, zn, Un) && Kn.push(this.A.add(Jo));
    }), Kn;
  }
  projectRoundWithSkew(zn, Un) {
    const Kn = [], { skewX: qn, skewY: Jo, scaleX: pa, scaleY: ma, strokeUniform: va } = this.options, ba = new ot(Math.tan(xt(qn)), Math.tan(xt(Jo))), _a = this.strokeProjectionMagnitude, ya = va ? _a / ma / Math.sqrt(1 / ma ** 2 + 1 / pa ** 2 * ba.y ** 2) : _a / Math.sqrt(1 + ba.y ** 2), xa = new ot(Math.sqrt(Math.max(_a ** 2 - ya ** 2, 0)), ya), wa = va ? _a / Math.sqrt(1 + ba.x ** 2 * (1 / ma) ** 2 / (1 / pa + 1 / pa * ba.x * ba.y) ** 2) : _a / Math.sqrt(1 + ba.x ** 2 / (1 + ba.x * ba.y) ** 2), Ta = new ot(wa, Math.sqrt(Math.max(_a ** 2 - wa ** 2, 0)));
    return [Ta, Ta.scalarMultiply(-1), xa, xa.scalarMultiply(-1)].map((Sa) => this.applySkew(va ? Sa.multiply(this.strokeUniformScalar) : Sa)).forEach((Sa) => {
      cs(Sa, zn, Un) && Kn.push(this.applySkew(this.A).add(Sa));
    }), Kn;
  }
  projectRound() {
    const zn = [];
    zn.push(...this.projectBevel());
    const Un = this.alpha % w == 0, Kn = this.applySkew(this.A), qn = zn[Un ? 0 : 2].subtract(Kn), Jo = zn[Un ? 1 : 0].subtract(Kn), pa = Un ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1)), ma = as(qn, pa) > 0, va = ma ? qn : Jo, ba = ma ? Jo : qn;
    return this.isSkewed() ? zn.push(...this.projectRoundWithSkew(va, ba)) : zn.push(...this.projectRoundNoSkew(va, ba)), zn;
  }
  projectPoints() {
    switch (this.options.strokeLineJoin) {
      case "miter":
        return this.projectMiter();
      case "round":
        return this.projectRound();
      default:
        return this.projectBevel();
    }
  }
  project() {
    return this.projectPoints().map((zn) => ({ originPoint: this.A, projectedPoint: zn, angle: this.alpha, bisector: this.bisector }));
  }
}
class Si extends Ci {
  constructor(zn, Un, Kn) {
    super(Kn), this.A = new ot(zn), this.T = new ot(Un);
  }
  calcOrthogonalProjection(zn, Un) {
    let Kn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.strokeProjectionMagnitude;
    const qn = this.createSideVector(zn, Un);
    return this.scaleUnitVector(os(qn), Kn);
  }
  projectButt() {
    return [this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude), this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)];
  }
  projectRound() {
    const zn = [];
    if (!this.isSkewed() && this.A.eq(this.T)) {
      const Un = new ot(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
      zn.push(this.applySkew(this.A.add(Un)), this.applySkew(this.A.subtract(Un)));
    } else zn.push(...new wi(this.A, this.T, this.T, this.options).projectRound());
    return zn;
  }
  projectSquare() {
    const zn = [];
    if (this.A.eq(this.T)) {
      const Un = new ot(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
      zn.push(this.A.add(Un), this.A.subtract(Un));
    } else {
      const Un = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude), Kn = this.scaleUnitVector(ns(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude), qn = this.A.add(Kn);
      zn.push(qn.add(Un), qn.subtract(Un));
    }
    return zn.map((Un) => this.applySkew(Un));
  }
  projectPoints() {
    switch (this.options.strokeLineCap) {
      case "round":
        return this.projectRound();
      case "square":
        return this.projectSquare();
      default:
        return this.projectButt();
    }
  }
  project() {
    return this.projectPoints().map((zn) => ({ originPoint: this.A, projectedPoint: zn }));
  }
}
const Ti = function(Xn, zn) {
  let Un = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
  const Kn = [];
  if (Xn.length === 0) return Kn;
  const qn = Xn.reduce((Jo, pa) => (Jo[Jo.length - 1].eq(pa) || Jo.push(new ot(pa)), Jo), [new ot(Xn[0])]);
  if (qn.length === 1) Un = !0;
  else if (!Un) {
    const Jo = qn[0], pa = ((ma, va) => {
      for (let ba = ma.length - 1; ba >= 0; ba--) if (va(ma[ba], ba, ma)) return ba;
      return -1;
    })(qn, (ma) => !ma.eq(Jo));
    qn.splice(pa + 1);
  }
  return qn.forEach((Jo, pa, ma) => {
    let va, ba;
    pa === 0 ? (ba = ma[1], va = Un ? Jo : ma[ma.length - 1]) : pa === ma.length - 1 ? (va = ma[pa - 1], ba = Un ? Jo : ma[0]) : (va = ma[pa - 1], ba = ma[pa + 1]), Un && ma.length === 1 ? Kn.push(...new Si(Jo, Jo, zn).project()) : !Un || pa !== 0 && pa !== ma.length - 1 ? Kn.push(...new wi(Jo, va, ba, zn).project()) : Kn.push(...new Si(Jo, pa === 0 ? ba : va, zn).project());
  }), Kn;
}, Oi = (Xn) => {
  const zn = {};
  return Object.keys(Xn).forEach((Un) => {
    zn[Un] = {}, Object.keys(Xn[Un]).forEach((Kn) => {
      zn[Un][Kn] = s$1({}, Xn[Un][Kn]);
    });
  }), zn;
}, ki = (Xn) => Xn.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Di = (Xn) => {
  const zn = [];
  for (let Un, Kn = 0; Kn < Xn.length; Kn++) (Un = Mi(Xn, Kn)) !== !1 && zn.push(Un);
  return zn;
}, Mi = (Xn, zn) => {
  const Un = Xn.charCodeAt(zn);
  if (isNaN(Un)) return "";
  if (Un < 55296 || Un > 57343) return Xn.charAt(zn);
  if (55296 <= Un && Un <= 56319) {
    if (Xn.length <= zn + 1) throw "High surrogate without following low surrogate";
    const qn = Xn.charCodeAt(zn + 1);
    if (56320 > qn || qn > 57343) throw "High surrogate without following low surrogate";
    return Xn.charAt(zn) + Xn.charAt(zn + 1);
  }
  if (zn === 0) throw "Low surrogate without preceding high surrogate";
  const Kn = Xn.charCodeAt(zn - 1);
  if (55296 > Kn || Kn > 56319) throw "Low surrogate without preceding high surrogate";
  return !1;
};
var Pi = Object.freeze({ __proto__: null, capitalize: function(Xn) {
  let zn = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
  return "".concat(Xn.charAt(0).toUpperCase()).concat(zn ? Xn.slice(1) : Xn.slice(1).toLowerCase());
}, escapeXml: ki, graphemeSplit: Di });
const Ei = function(Xn, zn) {
  let Un = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
  return Xn.fill !== zn.fill || Xn.stroke !== zn.stroke || Xn.strokeWidth !== zn.strokeWidth || Xn.fontSize !== zn.fontSize || Xn.fontFamily !== zn.fontFamily || Xn.fontWeight !== zn.fontWeight || Xn.fontStyle !== zn.fontStyle || Xn.textBackgroundColor !== zn.textBackgroundColor || Xn.deltaY !== zn.deltaY || Un && (Xn.overline !== zn.overline || Xn.underline !== zn.underline || Xn.linethrough !== zn.linethrough);
}, Ai = (Xn, zn) => {
  const Un = zn.split(`
`), Kn = [];
  let qn = -1, Jo = {};
  Xn = Oi(Xn);
  for (let pa = 0; pa < Un.length; pa++) {
    const ma = Di(Un[pa]);
    if (Xn[pa]) for (let va = 0; va < ma.length; va++) {
      qn++;
      const ba = Xn[pa][va];
      ba && Object.keys(ba).length > 0 && (Ei(Jo, ba, !0) ? Kn.push({ start: qn, end: qn + 1, style: ba }) : Kn[Kn.length - 1].end++), Jo = ba || {};
    }
    else qn += ma.length, Jo = {};
  }
  return Kn;
}, ji = (Xn, zn) => {
  if (!Array.isArray(Xn)) return Oi(Xn);
  const Un = zn.split(F), Kn = {};
  let qn = -1, Jo = 0;
  for (let pa = 0; pa < Un.length; pa++) {
    const ma = Di(Un[pa]);
    for (let va = 0; va < ma.length; va++) qn++, Xn[Jo] && Xn[Jo].start <= qn && qn < Xn[Jo].end && (Kn[pa] = Kn[pa] || {}, Kn[pa][va] = s$1({}, Xn[Jo].style), qn === Xn[Jo].end - 1 && Jo++);
  }
  return Kn;
}, Fi = ["display", "transform", K, "fill-opacity", "fill-rule", "opacity", J, "stroke-dasharray", "stroke-linecap", "stroke-dashoffset", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "id", "paint-order", "vector-effect", "instantiated_by_use", "clip-path"];
function Li(Xn, zn) {
  const Un = Xn.nodeName, Kn = Xn.getAttribute("class"), qn = Xn.getAttribute("id"), Jo = "(?![a-zA-Z\\-]+)";
  let pa;
  if (pa = new RegExp("^" + Un, "i"), zn = zn.replace(pa, ""), qn && zn.length && (pa = new RegExp("#" + qn + Jo, "i"), zn = zn.replace(pa, "")), Kn && zn.length) {
    const ma = Kn.split(" ");
    for (let va = ma.length; va--; ) pa = new RegExp("\\." + ma[va] + Jo, "i"), zn = zn.replace(pa, "");
  }
  return zn.length === 0;
}
function Ri(Xn, zn) {
  let Un = !0;
  const Kn = Li(Xn, zn.pop());
  return Kn && zn.length && (Un = function(qn, Jo) {
    let pa, ma = !0;
    for (; qn.parentElement && qn.parentElement.nodeType === 1 && Jo.length; ) ma && (pa = Jo.pop()), ma = Li(qn = qn.parentElement, pa);
    return Jo.length === 0;
  }(Xn, zn)), Kn && Un && zn.length === 0;
}
const Ii = (Xn) => {
  var zn;
  return (zn = He[Xn]) !== null && zn !== void 0 ? zn : Xn;
}, Bi = new RegExp("(".concat(Ve, ")"), "gi"), Xi = (Xn) => Xn.replace(Bi, " $1 ").replace(/,/gi, " ").replace(/\s+/gi, " ");
var Yi, Wi, Vi, zi, Gi, Hi, Ni;
const Ui = "(".concat(Ve, ")"), qi = String.raw(Yi || (Yi = r$1(["(skewX)(", ")"], ["(skewX)\\(", "\\)"])), Ui), Ki = String.raw(Wi || (Wi = r$1(["(skewY)(", ")"], ["(skewY)\\(", "\\)"])), Ui), Ji = String.raw(Vi || (Vi = r$1(["(rotate)(", "(?: ", " ", ")?)"], ["(rotate)\\(", "(?: ", " ", ")?\\)"])), Ui, Ui, Ui), Qi = String.raw(zi || (zi = r$1(["(scale)(", "(?: ", ")?)"], ["(scale)\\(", "(?: ", ")?\\)"])), Ui, Ui), Zi = String.raw(Gi || (Gi = r$1(["(translate)(", "(?: ", ")?)"], ["(translate)\\(", "(?: ", ")?\\)"])), Ui, Ui), $i = String.raw(Hi || (Hi = r$1(["(matrix)(", " ", " ", " ", " ", " ", ")"], ["(matrix)\\(", " ", " ", " ", " ", " ", "\\)"])), Ui, Ui, Ui, Ui, Ui, Ui), tr = "(?:".concat($i, "|").concat(Zi, "|").concat(Ji, "|").concat(Qi, "|").concat(qi, "|").concat(Ki, ")"), er = "(?:".concat(tr, "*)"), sr = String.raw(Ni || (Ni = r$1(["^s*(?:", "?)s*$"], ["^\\s*(?:", "?)\\s*$"])), er), ir = new RegExp(sr), rr = new RegExp(tr), nr = new RegExp(tr, "g");
function or(Xn) {
  const zn = [];
  if (!(Xn = Xi(Xn).replace(/\s*([()])\s*/gi, "$1")) || Xn && !ir.test(Xn)) return [...T$1];
  for (const Un of Xn.matchAll(nr)) {
    const Kn = rr.exec(Un[0]);
    if (!Kn) continue;
    let qn = T$1;
    const Jo = Kn.filter((Ta) => !!Ta), [, pa, ...ma] = Jo, [va, ba, _a, ya, xa, wa] = ma.map((Ta) => parseFloat(Ta));
    switch (pa) {
      case "translate":
        qn = Mt(va, ba);
        break;
      case B$1:
        qn = Pt({ angle: va }, { x: ba, y: _a });
        break;
      case G:
        qn = Et(va, ba);
        break;
      case U:
        qn = jt(va);
        break;
      case q:
        qn = Ft(va);
        break;
      case "matrix":
        qn = [va, ba, _a, ya, xa, wa];
    }
    zn.push(qn);
  }
  return Ot(zn);
}
function ar(Xn, zn, Un, Kn) {
  const qn = Array.isArray(zn);
  let Jo, pa = zn;
  if (Xn !== K && Xn !== J || zn !== j) {
    if (Xn === "strokeUniform") return zn === "non-scaling-stroke";
    if (Xn === "strokeDashArray") pa = zn === j ? null : zn.replace(/,/g, " ").split(/\s+/).map(parseFloat);
    else if (Xn === "transformMatrix") pa = Un && Un.transformMatrix ? Tt(Un.transformMatrix, or(zn)) : or(zn);
    else if (Xn === "visible") pa = zn !== j && zn !== "hidden", Un && Un.visible === !1 && (pa = !1);
    else if (Xn === "opacity") pa = parseFloat(zn), Un && Un.opacity !== void 0 && (pa *= Un.opacity);
    else if (Xn === "textAnchor") pa = zn === "start" ? M$1 : zn === "end" ? A$1 : D;
    else if (Xn === "charSpacing") Jo = Re(zn, Kn) / Kn * 1e3;
    else if (Xn === "paintFirst") {
      const ma = zn.indexOf(K), va = zn.indexOf(J);
      pa = K, (ma > -1 && va > -1 && va < ma || ma === -1 && va > -1) && (pa = J);
    } else {
      if (Xn === "href" || Xn === "xlink:href" || Xn === "font" || Xn === "id") return zn;
      if (Xn === "imageSmoothing") return zn === "optimizeQuality";
      Jo = qn ? zn.map(Re) : Re(zn, Kn);
    }
  } else pa = "";
  return !qn && isNaN(Jo) ? pa : Jo;
}
function hr(Xn, zn) {
  const Un = Xn.match(Ge);
  if (!Un) return;
  const Kn = Un[1], qn = Un[3], Jo = Un[4], pa = Un[5], ma = Un[6];
  Kn && (zn.fontStyle = Kn), qn && (zn.fontWeight = isNaN(parseFloat(qn)) ? qn : parseFloat(qn)), Jo && (zn.fontSize = Re(Jo)), ma && (zn.fontFamily = ma), pa && (zn.lineHeight = pa === "normal" ? 1 : pa);
}
function cr(Xn, zn) {
  Xn.replace(/;\s*$/, "").split(";").forEach((Un) => {
    if (!Un) return;
    const [Kn, qn] = Un.split(":");
    zn[Kn.trim().toLowerCase()] = qn.trim();
  });
}
function lr(Xn) {
  const zn = {}, Un = Xn.getAttribute("style");
  return Un && (typeof Un == "string" ? cr(Un, zn) : function(Kn, qn) {
    Object.entries(Kn).forEach((Jo) => {
      let [pa, ma] = Jo;
      ma !== void 0 && (qn[pa.toLowerCase()] = ma);
    });
  }(Un, zn)), zn;
}
const ur = { stroke: "strokeOpacity", fill: "fillOpacity" };
function dr(Xn, zn, Un) {
  if (!Xn) return {};
  let Kn, qn = {}, Jo = O$1;
  Xn.parentNode && Je.test(Xn.parentNode.nodeName) && (qn = dr(Xn.parentElement, zn, Un), qn.fontSize && (Kn = Jo = Re(qn.fontSize)));
  const pa = s$1(s$1(s$1({}, zn.reduce((ba, _a) => {
    const ya = Xn.getAttribute(_a);
    return ya && (ba[_a] = ya), ba;
  }, {})), function(ba) {
    let _a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ya = {};
    for (const xa in _a) Ri(ba, xa.split(" ")) && (ya = s$1(s$1({}, ya), _a[xa]));
    return ya;
  }(Xn, Un)), lr(Xn));
  pa[Ue] && Xn.setAttribute(Ue, pa[Ue]), pa[Ne] && (Kn = Re(pa[Ne], Jo), pa[Ne] = "".concat(Kn));
  const ma = {};
  for (const ba in pa) {
    const _a = Ii(ba), ya = ar(_a, pa[ba], qn, Kn);
    ma[_a] = ya;
  }
  ma && ma.font && hr(ma.font, ma);
  const va = s$1(s$1({}, qn), ma);
  return Je.test(Xn.nodeName) ? va : function(ba) {
    const _a = _i.getDefaults();
    return Object.entries(ur).forEach((ya) => {
      let [xa, wa] = ya;
      if (ba[wa] === void 0 || ba[xa] === "") return;
      if (ba[xa] === void 0) {
        if (!_a[xa]) return;
        ba[xa] = _a[xa];
      }
      if (ba[xa].indexOf("url(") === 0) return;
      const Ta = new Le(ba[xa]);
      ba[xa] = Ta.setAlpha(Vt(Ta.getAlpha() * ba[wa], 2)).toRgba();
    }), ba;
  }(va);
}
const gr = ["left", "top", "width", "height", "visible"], fr = ["rx", "ry"];
class pr extends _i {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), pr.ownDefaults);
  }
  constructor(zn) {
    super(), Object.assign(this, pr.ownDefaults), this.setOptions(zn), this._initRxRy();
  }
  _initRxRy() {
    const { rx: zn, ry: Un } = this;
    zn && !Un ? this.ry = zn : Un && !zn && (this.rx = Un);
  }
  _render(zn) {
    const { width: Un, height: Kn } = this, qn = -Un / 2, Jo = -Kn / 2, pa = this.rx ? Math.min(this.rx, Un / 2) : 0, ma = this.ry ? Math.min(this.ry, Kn / 2) : 0, va = pa !== 0 || ma !== 0;
    zn.beginPath(), zn.moveTo(qn + pa, Jo), zn.lineTo(qn + Un - pa, Jo), va && zn.bezierCurveTo(qn + Un - k$1 * pa, Jo, qn + Un, Jo + k$1 * ma, qn + Un, Jo + ma), zn.lineTo(qn + Un, Jo + Kn - ma), va && zn.bezierCurveTo(qn + Un, Jo + Kn - k$1 * ma, qn + Un - k$1 * pa, Jo + Kn, qn + Un - pa, Jo + Kn), zn.lineTo(qn + pa, Jo + Kn), va && zn.bezierCurveTo(qn + k$1 * pa, Jo + Kn, qn, Jo + Kn - k$1 * ma, qn, Jo + Kn - ma), zn.lineTo(qn, Jo + ma), va && zn.bezierCurveTo(qn, Jo + k$1 * ma, qn + k$1 * pa, Jo, qn + pa, Jo), zn.closePath(), this._renderPaintInOrder(zn);
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject([...fr, ...zn]);
  }
  _toSVG() {
    const { width: zn, height: Un, rx: Kn, ry: qn } = this;
    return ["<rect ", "COMMON_PARTS", 'x="'.concat(-zn / 2, '" y="').concat(-Un / 2, '" rx="').concat(Kn, '" ry="').concat(qn, '" width="').concat(zn, '" height="').concat(Un, `" />
`)];
  }
  static async fromElement(zn, Un, Kn) {
    const qn = dr(zn, this.ATTRIBUTE_NAMES, Kn), { left: Jo = 0, top: pa = 0, width: ma = 0, height: va = 0, visible: ba = !0 } = qn, _a = i$3(qn, gr);
    return new this(s$1(s$1(s$1({}, Un), _a), {}, { left: Jo, top: pa, width: ma, height: va, visible: !!(ba && ma && va) }));
  }
}
t$1(pr, "type", "Rect"), t$1(pr, "cacheProperties", [...ps, ...fr]), t$1(pr, "ownDefaults", { rx: 0, ry: 0 }), t$1(pr, "ATTRIBUTE_NAMES", [...Fi, "x", "y", "rx", "ry", "width", "height"]), tt.setClass(pr), tt.setSVGClass(pr);
const mr = "initialization", vr = "added", yr = "removed", _r = "imperative", xr = (Xn, zn) => {
  const { strokeUniform: Un, strokeWidth: Kn, width: qn, height: Jo, group: pa } = zn, ma = pa && pa !== Xn ? fe(pa.calcTransformMatrix(), Xn.calcTransformMatrix()) : null, va = ma ? zn.getRelativeCenterPoint().transform(ma) : zn.getRelativeCenterPoint(), ba = !zn.isStrokeAccountedForInDimensions(), _a = Un && ba ? me(new ot(Kn, Kn), void 0, Xn.calcTransformMatrix()) : at, ya = !Un && ba ? Kn : 0, xa = ge(qn + ya, Jo + ya, Ot([ma, zn.calcOwnMatrix()], !0)).add(_a).scalarDivide(2);
  return [va.subtract(xa), va.add(xa)];
};
class Cr {
  calcLayoutResult(zn, Un) {
    if (this.shouldPerformLayout(zn)) return this.calcBoundingBox(Un, zn);
  }
  shouldPerformLayout(zn) {
    let { type: Un, prevStrategy: Kn, strategy: qn } = zn;
    return Un === mr || Un === _r || !!Kn && qn !== Kn;
  }
  shouldLayoutClipPath(zn) {
    let { type: Un, target: { clipPath: Kn } } = zn;
    return Un !== mr && Kn && !Kn.absolutePositioned;
  }
  getInitialSize(zn, Un) {
    return Un.size;
  }
  calcBoundingBox(zn, Un) {
    const { type: Kn, target: qn } = Un;
    if (Kn === _r && Un.overrides) return Un.overrides;
    if (zn.length === 0) return;
    const { left: Jo, top: pa, width: ma, height: va } = ae(zn.map((ya) => xr(qn, ya)).reduce((ya, xa) => ya.concat(xa), [])), ba = new ot(ma, va), _a = new ot(Jo, pa).add(ba.scalarDivide(2));
    if (Kn === mr) {
      const ya = this.getInitialSize(Un, { size: ba, center: _a });
      return { center: _a, relativeCorrection: new ot(0, 0), size: ya };
    }
    return { center: _a.transform(qn.calcOwnMatrix()), size: ba };
  }
}
t$1(Cr, "type", "strategy");
class br extends Cr {
  shouldPerformLayout(zn) {
    return !0;
  }
}
t$1(br, "type", "fit-content"), tt.setClass(br);
const wr = ["strategy"], Sr = ["target", "strategy", "bubbles", "prevStrategy"], Tr = "layoutManager";
class Or {
  constructor() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new br();
    t$1(this, "strategy", void 0), this.strategy = zn, this._subscriptions = /* @__PURE__ */ new Map();
  }
  performLayout(zn) {
    const Un = s$1(s$1({ bubbles: !0, strategy: this.strategy }, zn), {}, { prevStrategy: this._prevLayoutStrategy, stopPropagation() {
      this.bubbles = !1;
    } });
    this.onBeforeLayout(Un);
    const Kn = this.getLayoutResult(Un);
    Kn && this.commitLayout(Un, Kn), this.onAfterLayout(Un, Kn), this._prevLayoutStrategy = Un.strategy;
  }
  attachHandlers(zn, Un) {
    const { target: Kn } = Un;
    return [Q, L$1, Y$2, I, R$1, X, z$1, W, V].map((qn) => zn.on(qn, (Jo) => this.performLayout(qn === Q ? { type: "object_modified", trigger: qn, e: Jo, target: Kn } : { type: "object_modifying", trigger: qn, e: Jo, target: Kn })));
  }
  subscribe(zn, Un) {
    this.unsubscribe(zn, Un);
    const Kn = this.attachHandlers(zn, Un);
    this._subscriptions.set(zn, Kn);
  }
  unsubscribe(zn, Un) {
    (this._subscriptions.get(zn) || []).forEach((Kn) => Kn()), this._subscriptions.delete(zn);
  }
  unsubscribeTargets(zn) {
    zn.targets.forEach((Un) => this.unsubscribe(Un, zn));
  }
  subscribeTargets(zn) {
    zn.targets.forEach((Un) => this.subscribe(Un, zn));
  }
  onBeforeLayout(zn) {
    const { target: Un, type: Kn } = zn, { canvas: qn } = Un;
    if (Kn === mr || Kn === vr ? this.subscribeTargets(zn) : Kn === yr && this.unsubscribeTargets(zn), Un.fire("layout:before", { context: zn }), qn && qn.fire("object:layout:before", { target: Un, context: zn }), Kn === _r && zn.deep) {
      const Jo = i$3(zn, wr);
      Un.forEachObject((pa) => pa.layoutManager && pa.layoutManager.performLayout(s$1(s$1({}, Jo), {}, { bubbles: !1, target: pa })));
    }
  }
  getLayoutResult(zn) {
    const { target: Un, strategy: Kn, type: qn } = zn, Jo = Kn.calcLayoutResult(zn, Un.getObjects());
    if (!Jo) return;
    const pa = qn === mr ? new ot() : Un.getRelativeCenterPoint(), { center: ma, correction: va = new ot(), relativeCorrection: ba = new ot() } = Jo, _a = pa.subtract(ma).add(va).transform(qn === mr ? T$1 : St(Un.calcOwnMatrix()), !0).add(ba);
    return { result: Jo, prevCenter: pa, nextCenter: ma, offset: _a };
  }
  commitLayout(zn, Un) {
    const { target: Kn } = zn, { result: { size: qn }, nextCenter: Jo } = Un;
    var pa, ma;
    Kn.set({ width: qn.x, height: qn.y }), this.layoutObjects(zn, Un), zn.type === mr ? Kn.set({ left: (pa = zn.x) !== null && pa !== void 0 ? pa : Jo.x + qn.x * xe(Kn.originX), top: (ma = zn.y) !== null && ma !== void 0 ? ma : Jo.y + qn.y * xe(Kn.originY) }) : (Kn.setPositionByOrigin(Jo, D, D), Kn.setCoords(), Kn.set("dirty", !0));
  }
  layoutObjects(zn, Un) {
    const { target: Kn } = zn;
    Kn.forEachObject((qn) => {
      qn.group === Kn && this.layoutObject(zn, Un, qn);
    }), zn.strategy.shouldLayoutClipPath(zn) && this.layoutObject(zn, Un, Kn.clipPath);
  }
  layoutObject(zn, Un, Kn) {
    let { offset: qn } = Un;
    Kn.set({ left: Kn.left + qn.x, top: Kn.top + qn.y });
  }
  onAfterLayout(zn, Un) {
    const { target: Kn, strategy: qn, bubbles: Jo, prevStrategy: pa } = zn, ma = i$3(zn, Sr), { canvas: va } = Kn;
    Kn.fire("layout:after", { context: zn, result: Un }), va && va.fire("object:layout:after", { context: zn, result: Un, target: Kn });
    const ba = Kn.parent;
    Jo && ba != null && ba.layoutManager && ((ma.path || (ma.path = [])).push(Kn), ba.layoutManager.performLayout(s$1(s$1({}, ma), {}, { target: ba }))), Kn.set("dirty", !0);
  }
  dispose() {
    const { _subscriptions: zn } = this;
    zn.forEach((Un) => Un.forEach((Kn) => Kn())), zn.clear();
  }
  toObject() {
    return { type: Tr, strategy: this.strategy.constructor.type };
  }
  toJSON() {
    return this.toObject();
  }
}
tt.setClass(Or, Tr);
const kr = ["type", "objects", "layoutManager"];
class Dr extends Or {
  performLayout() {
  }
}
class Mr extends ct(_i) {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), Mr.ownDefaults);
  }
  constructor() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), t$1(this, "_activeObjects", []), t$1(this, "__objectSelectionTracker", void 0), t$1(this, "__objectSelectionDisposer", void 0), Object.assign(this, Mr.ownDefaults), this.setOptions(Un), this.groupInit(zn, Un);
  }
  groupInit(zn, Un) {
    var Kn;
    this._objects = [...zn], this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, !0), this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, !1), this.forEachObject((qn) => {
      this.enterGroup(qn, !1);
    }), this.layoutManager = (Kn = Un.layoutManager) !== null && Kn !== void 0 ? Kn : new Or(), this.layoutManager.performLayout({ type: mr, target: this, targets: [...zn], x: Un.left, y: Un.top });
  }
  canEnterGroup(zn) {
    return zn === this || this.isDescendantOf(zn) ? (a$1("error", "Group: circular object trees are not supported, this call has no effect"), !1) : this._objects.indexOf(zn) === -1 || (a$1("error", "Group: duplicate objects are not supported inside group, this call has no effect"), !1);
  }
  _filterObjectsBeforeEnteringGroup(zn) {
    return zn.filter((Un, Kn, qn) => this.canEnterGroup(Un) && qn.indexOf(Un) === Kn);
  }
  add() {
    for (var zn = arguments.length, Un = new Array(zn), Kn = 0; Kn < zn; Kn++) Un[Kn] = arguments[Kn];
    const qn = this._filterObjectsBeforeEnteringGroup(Un), Jo = super.add(...qn);
    return this._onAfterObjectsChange(vr, qn), Jo;
  }
  insertAt(zn) {
    for (var Un = arguments.length, Kn = new Array(Un > 1 ? Un - 1 : 0), qn = 1; qn < Un; qn++) Kn[qn - 1] = arguments[qn];
    const Jo = this._filterObjectsBeforeEnteringGroup(Kn), pa = super.insertAt(zn, ...Jo);
    return this._onAfterObjectsChange(vr, Jo), pa;
  }
  remove() {
    const zn = super.remove(...arguments);
    return this._onAfterObjectsChange(yr, zn), zn;
  }
  _onObjectAdded(zn) {
    this.enterGroup(zn, !0), this.fire("object:added", { target: zn }), zn.fire("added", { target: this });
  }
  _onObjectRemoved(zn, Un) {
    this.exitGroup(zn, Un), this.fire("object:removed", { target: zn }), zn.fire("removed", { target: this });
  }
  _onAfterObjectsChange(zn, Un) {
    this.layoutManager.performLayout({ type: zn, targets: Un, target: this });
  }
  _onStackOrderChanged() {
    this._set("dirty", !0);
  }
  _set(zn, Un) {
    const Kn = this[zn];
    return super._set(zn, Un), zn === "canvas" && Kn !== Un && (this._objects || []).forEach((qn) => {
      qn._set(zn, Un);
    }), this;
  }
  _shouldSetNestedCoords() {
    return this.subTargetCheck;
  }
  removeAll() {
    return this._activeObjects = [], this.remove(...this._objects);
  }
  __objectSelectionMonitor(zn, Un) {
    let { target: Kn } = Un;
    const qn = this._activeObjects;
    if (zn) qn.push(Kn), this._set("dirty", !0);
    else if (qn.length > 0) {
      const Jo = qn.indexOf(Kn);
      Jo > -1 && (qn.splice(Jo, 1), this._set("dirty", !0));
    }
  }
  _watchObject(zn, Un) {
    zn && this._watchObject(!1, Un), zn ? (Un.on("selected", this.__objectSelectionTracker), Un.on("deselected", this.__objectSelectionDisposer)) : (Un.off("selected", this.__objectSelectionTracker), Un.off("deselected", this.__objectSelectionDisposer));
  }
  enterGroup(zn, Un) {
    zn.group && zn.group.remove(zn), zn._set("parent", this), this._enterGroup(zn, Un);
  }
  _enterGroup(zn, Un) {
    Un && le(zn, Tt(St(this.calcTransformMatrix()), zn.calcTransformMatrix())), this._shouldSetNestedCoords() && zn.setCoords(), zn._set("group", this), zn._set("canvas", this.canvas), this._watchObject(!0, zn);
    const Kn = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
    Kn && (Kn === zn || zn.isDescendantOf(Kn)) && this._activeObjects.push(zn);
  }
  exitGroup(zn, Un) {
    this._exitGroup(zn, Un), zn._set("parent", void 0), zn._set("canvas", void 0);
  }
  _exitGroup(zn, Un) {
    zn._set("group", void 0), Un || (le(zn, Tt(this.calcTransformMatrix(), zn.calcTransformMatrix())), zn.setCoords()), this._watchObject(!1, zn);
    const Kn = this._activeObjects.length > 0 ? this._activeObjects.indexOf(zn) : -1;
    Kn > -1 && this._activeObjects.splice(Kn, 1);
  }
  shouldCache() {
    const zn = _i.prototype.shouldCache.call(this);
    if (zn) {
      for (let Un = 0; Un < this._objects.length; Un++) if (this._objects[Un].willDrawShadow()) return this.ownCaching = !1, !1;
    }
    return zn;
  }
  willDrawShadow() {
    if (super.willDrawShadow()) return !0;
    for (let zn = 0; zn < this._objects.length; zn++) if (this._objects[zn].willDrawShadow()) return !0;
    return !1;
  }
  isOnACache() {
    return this.ownCaching || !!this.parent && this.parent.isOnACache();
  }
  drawObject(zn, Un, Kn) {
    this._renderBackground(zn);
    for (let Jo = 0; Jo < this._objects.length; Jo++) {
      var qn;
      const pa = this._objects[Jo];
      (qn = this.canvas) !== null && qn !== void 0 && qn.preserveObjectStacking && pa.group !== this ? (zn.save(), zn.transform(...St(this.calcTransformMatrix())), pa.render(zn), zn.restore()) : pa.group === this && pa.render(zn);
    }
    this._drawClipPath(zn, this.clipPath, Kn);
  }
  setCoords() {
    super.setCoords(), this._shouldSetNestedCoords() && this.forEachObject((zn) => zn.setCoords());
  }
  triggerLayout() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.layoutManager.performLayout(s$1({ target: this, type: _r }, zn));
  }
  render(zn) {
    this._transformDone = !0, super.render(zn), this._transformDone = !1;
  }
  __serializeObjects(zn, Un) {
    const Kn = this.includeDefaultValues;
    return this._objects.filter(function(qn) {
      return !qn.excludeFromExport;
    }).map(function(qn) {
      const Jo = qn.includeDefaultValues;
      qn.includeDefaultValues = Kn;
      const pa = qn[zn || "toObject"](Un);
      return qn.includeDefaultValues = Jo, pa;
    });
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const Un = this.layoutManager.toObject();
    return s$1(s$1(s$1({}, super.toObject(["subTargetCheck", "interactive", ...zn])), Un.strategy !== "fit-content" || this.includeDefaultValues ? { layoutManager: Un } : {}), {}, { objects: this.__serializeObjects("toObject", zn) });
  }
  toString() {
    return "#<Group: (".concat(this.complexity(), ")>");
  }
  dispose() {
    this.layoutManager.unsubscribeTargets({ targets: this.getObjects(), target: this }), this._activeObjects = [], this.forEachObject((zn) => {
      this._watchObject(!1, zn), zn.dispose();
    }), super.dispose();
  }
  _createSVGBgRect(zn) {
    if (!this.backgroundColor) return "";
    const Un = pr.prototype._toSVG.call(this), Kn = Un.indexOf("COMMON_PARTS");
    Un[Kn] = 'for="group" ';
    const qn = Un.join("");
    return zn ? zn(qn) : qn;
  }
  _toSVG(zn) {
    const Un = ["<g ", "COMMON_PARTS", ` >
`], Kn = this._createSVGBgRect(zn);
    Kn && Un.push("		", Kn);
    for (let qn = 0; qn < this._objects.length; qn++) Un.push("		", this._objects[qn].toSVG(zn));
    return Un.push(`</g>
`), Un;
  }
  getSvgStyles() {
    const zn = this.opacity !== void 0 && this.opacity !== 1 ? "opacity: ".concat(this.opacity, ";") : "", Un = this.visible ? "" : " visibility: hidden;";
    return [zn, this.getSvgFilter(), Un].join("");
  }
  toClipPathSVG(zn) {
    const Un = [], Kn = this._createSVGBgRect(zn);
    Kn && Un.push("	", Kn);
    for (let qn = 0; qn < this._objects.length; qn++) Un.push("	", this._objects[qn].toClipPathSVG(zn));
    return this._createBaseClipPathSVGMarkup(Un, { reviver: zn });
  }
  static fromObject(zn, Un) {
    let { type: Kn, objects: qn = [], layoutManager: Jo } = zn, pa = i$3(zn, kr);
    return Promise.all([Bt(qn, Un), Xt(pa, Un)]).then((ma) => {
      let [va, ba] = ma;
      const _a = new this(va, s$1(s$1(s$1({}, pa), ba), {}, { layoutManager: new Dr() }));
      if (Jo) {
        const ya = tt.getClass(Jo.type), xa = tt.getClass(Jo.strategy);
        _a.layoutManager = new ya(new xa());
      } else _a.layoutManager = new Or();
      return _a.layoutManager.subscribeTargets({ type: mr, target: _a, targets: _a.getObjects() }), _a.setCoords(), _a;
    });
  }
}
t$1(Mr, "type", "Group"), t$1(Mr, "ownDefaults", { strokeWidth: 0, subTargetCheck: !1, interactive: !1 }), tt.setClass(Mr);
const Pr = (Xn, zn) => Math.min(zn.width / Xn.width, zn.height / Xn.height), Er = (Xn, zn) => Math.max(zn.width / Xn.width, zn.height / Xn.height), Ar = "\\s*,?\\s*", jr = "".concat(Ar, "(").concat(Ve, ")"), Fr = "".concat(jr).concat(jr).concat(jr).concat(Ar, "([01])").concat(Ar, "([01])").concat(jr).concat(jr), Lr = { m: "l", M: "L" }, Rr = (Xn, zn, Un, Kn, qn, Jo, pa, ma, va, ba, _a) => {
  const ya = rt(Xn), xa = nt(Xn), wa = rt(zn), Ta = nt(zn), Sa = Un * qn * wa - Kn * Jo * Ta + pa, Ma = Kn * qn * wa + Un * Jo * Ta + ma;
  return ["C", ba + va * (-Un * qn * xa - Kn * Jo * ya), _a + va * (-Kn * qn * xa + Un * Jo * ya), Sa + va * (Un * qn * Ta + Kn * Jo * wa), Ma + va * (Kn * qn * Ta - Un * Jo * wa), Sa, Ma];
}, Ir = (Xn, zn, Un, Kn) => {
  const qn = Math.atan2(zn, Xn), Jo = Math.atan2(Kn, Un);
  return Jo >= qn ? Jo - qn : 2 * Math.PI - (qn - Jo);
};
function Br(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  let va;
  if (o$1.cachesBoundsOfCurve && (va = [...arguments].join(), _$1.boundsOfCurveCache[va])) return _$1.boundsOfCurveCache[va];
  const ba = Math.sqrt, _a = Math.abs, ya = [], xa = [[0, 0], [0, 0]];
  let wa = 6 * Xn - 12 * Un + 6 * qn, Ta = -3 * Xn + 9 * Un - 9 * qn + 3 * pa, Sa = 3 * Un - 3 * Xn;
  for (let Ka = 0; Ka < 2; ++Ka) {
    if (Ka > 0 && (wa = 6 * zn - 12 * Kn + 6 * Jo, Ta = -3 * zn + 9 * Kn - 9 * Jo + 3 * ma, Sa = 3 * Kn - 3 * zn), _a(Ta) < 1e-12) {
      if (_a(wa) < 1e-12) continue;
      const Qa = -Sa / wa;
      0 < Qa && Qa < 1 && ya.push(Qa);
      continue;
    }
    const Ja = wa * wa - 4 * Sa * Ta;
    if (Ja < 0) continue;
    const el = ba(Ja), qa = (-wa + el) / (2 * Ta);
    0 < qa && qa < 1 && ya.push(qa);
    const tl = (-wa - el) / (2 * Ta);
    0 < tl && tl < 1 && ya.push(tl);
  }
  let Ma = ya.length;
  const ka = Ma, Za = Vr(Xn, zn, Un, Kn, qn, Jo, pa, ma);
  for (; Ma--; ) {
    const { x: Ka, y: Ja } = Za(ya[Ma]);
    xa[0][Ma] = Ka, xa[1][Ma] = Ja;
  }
  xa[0][ka] = Xn, xa[1][ka] = zn, xa[0][ka + 1] = pa, xa[1][ka + 1] = ma;
  const Na = [new ot(Math.min(...xa[0]), Math.min(...xa[1])), new ot(Math.max(...xa[0]), Math.max(...xa[1]))];
  return o$1.cachesBoundsOfCurve && (_$1.boundsOfCurveCache[va] = Na), Na;
}
const Xr = (Xn, zn, Un) => {
  let [Kn, qn, Jo, pa, ma, va, ba, _a] = Un;
  const ya = ((xa, wa, Ta, Sa, Ma, ka, Za) => {
    if (Ta === 0 || Sa === 0) return [];
    let Na = 0, Ka = 0, Ja = 0;
    const el = Math.PI, qa = Za * S$1, tl = nt(qa), Qa = rt(qa), nl = 0.5 * (-Qa * xa - tl * wa), rl = 0.5 * (-Qa * wa + tl * xa), il = Ta ** 2, cl = Sa ** 2, ll = rl ** 2, al = nl ** 2, sl = il * cl - il * ll - cl * al;
    let dl = Math.abs(Ta), El = Math.abs(Sa);
    if (sl < 0) {
      const kl = Math.sqrt(1 - sl / (il * cl));
      dl *= kl, El *= kl;
    } else Ja = (Ma === ka ? -1 : 1) * Math.sqrt(sl / (il * ll + cl * al));
    const fl = Ja * dl * rl / El, Ml = -Ja * El * nl / dl, Sl = Qa * fl - tl * Ml + 0.5 * xa, ml = tl * fl + Qa * Ml + 0.5 * wa;
    let Dl = Ir(1, 0, (nl - fl) / dl, (rl - Ml) / El), _l = Ir((nl - fl) / dl, (rl - Ml) / El, (-nl - fl) / dl, (-rl - Ml) / El);
    ka === 0 && _l > 0 ? _l -= 2 * el : ka === 1 && _l < 0 && (_l += 2 * el);
    const gl = Math.ceil(Math.abs(_l / el * 2)), Fl = [], Nl = _l / gl, zl = 8 / 3 * Math.sin(Nl / 4) * Math.sin(Nl / 4) / Math.sin(Nl / 2);
    let Zl = Dl + Nl;
    for (let kl = 0; kl < gl; kl++) Fl[kl] = Rr(Dl, Zl, Qa, tl, dl, El, Sl, ml, zl, Na, Ka), Na = Fl[kl][5], Ka = Fl[kl][6], Dl = Zl, Zl += Nl;
    return Fl;
  })(ba - Xn, _a - zn, qn, Jo, ma, va, pa);
  for (let xa = 0, wa = ya.length; xa < wa; xa++) ya[xa][1] += Xn, ya[xa][2] += zn, ya[xa][3] += Xn, ya[xa][4] += zn, ya[xa][5] += Xn, ya[xa][6] += zn;
  return ya;
}, Yr = (Xn) => {
  let zn = 0, Un = 0, Kn = 0, qn = 0;
  const Jo = [];
  let pa, ma = 0, va = 0;
  for (const ba of Xn) {
    const _a = [...ba];
    let ya;
    switch (_a[0]) {
      case "l":
        _a[1] += zn, _a[2] += Un;
      case "L":
        zn = _a[1], Un = _a[2], ya = ["L", zn, Un];
        break;
      case "h":
        _a[1] += zn;
      case "H":
        zn = _a[1], ya = ["L", zn, Un];
        break;
      case "v":
        _a[1] += Un;
      case "V":
        Un = _a[1], ya = ["L", zn, Un];
        break;
      case "m":
        _a[1] += zn, _a[2] += Un;
      case "M":
        zn = _a[1], Un = _a[2], Kn = _a[1], qn = _a[2], ya = ["M", zn, Un];
        break;
      case "c":
        _a[1] += zn, _a[2] += Un, _a[3] += zn, _a[4] += Un, _a[5] += zn, _a[6] += Un;
      case "C":
        ma = _a[3], va = _a[4], zn = _a[5], Un = _a[6], ya = ["C", _a[1], _a[2], ma, va, zn, Un];
        break;
      case "s":
        _a[1] += zn, _a[2] += Un, _a[3] += zn, _a[4] += Un;
      case "S":
        pa === "C" ? (ma = 2 * zn - ma, va = 2 * Un - va) : (ma = zn, va = Un), zn = _a[3], Un = _a[4], ya = ["C", ma, va, _a[1], _a[2], zn, Un], ma = ya[3], va = ya[4];
        break;
      case "q":
        _a[1] += zn, _a[2] += Un, _a[3] += zn, _a[4] += Un;
      case "Q":
        ma = _a[1], va = _a[2], zn = _a[3], Un = _a[4], ya = ["Q", ma, va, zn, Un];
        break;
      case "t":
        _a[1] += zn, _a[2] += Un;
      case "T":
        pa === "Q" ? (ma = 2 * zn - ma, va = 2 * Un - va) : (ma = zn, va = Un), zn = _a[1], Un = _a[2], ya = ["Q", ma, va, zn, Un];
        break;
      case "a":
        _a[6] += zn, _a[7] += Un;
      case "A":
        Xr(zn, Un, _a).forEach((xa) => Jo.push(xa)), zn = _a[6], Un = _a[7];
        break;
      case "z":
      case "Z":
        zn = Kn, Un = qn, ya = ["Z"];
    }
    ya ? (Jo.push(ya), pa = ya[0]) : pa = "";
  }
  return Jo;
}, Wr = (Xn, zn, Un, Kn) => Math.sqrt((Un - Xn) ** 2 + (Kn - zn) ** 2), Vr = (Xn, zn, Un, Kn, qn, Jo, pa, ma) => (va) => {
  const ba = va ** 3, _a = ((wa) => 3 * wa ** 2 * (1 - wa))(va), ya = ((wa) => 3 * wa * (1 - wa) ** 2)(va), xa = ((wa) => (1 - wa) ** 3)(va);
  return new ot(pa * ba + qn * _a + Un * ya + Xn * xa, ma * ba + Jo * _a + Kn * ya + zn * xa);
}, zr = (Xn) => Xn ** 2, Gr = (Xn) => 2 * Xn * (1 - Xn), Hr = (Xn) => (1 - Xn) ** 2, Nr = (Xn, zn, Un, Kn, qn, Jo, pa, ma) => (va) => {
  const ba = zr(va), _a = Gr(va), ya = Hr(va), xa = 3 * (ya * (Un - Xn) + _a * (qn - Un) + ba * (pa - qn)), wa = 3 * (ya * (Kn - zn) + _a * (Jo - Kn) + ba * (ma - Jo));
  return Math.atan2(wa, xa);
}, Ur = (Xn, zn, Un, Kn, qn, Jo) => (pa) => {
  const ma = zr(pa), va = Gr(pa), ba = Hr(pa);
  return new ot(qn * ma + Un * va + Xn * ba, Jo * ma + Kn * va + zn * ba);
}, qr = (Xn, zn, Un, Kn, qn, Jo) => (pa) => {
  const ma = 1 - pa, va = 2 * (ma * (Un - Xn) + pa * (qn - Un)), ba = 2 * (ma * (Kn - zn) + pa * (Jo - Kn));
  return Math.atan2(ba, va);
}, Kr = (Xn, zn, Un) => {
  let Kn = new ot(zn, Un), qn = 0;
  for (let Jo = 1; Jo <= 100; Jo += 1) {
    const pa = Xn(Jo / 100);
    qn += Wr(Kn.x, Kn.y, pa.x, pa.y), Kn = pa;
  }
  return qn;
}, Jr = (Xn, zn) => {
  let Un, Kn = 0, qn = 0, Jo = { x: Xn.x, y: Xn.y }, pa = s$1({}, Jo), ma = 0.01, va = 0;
  const ba = Xn.iterator, _a = Xn.angleFinder;
  for (; qn < zn && ma > 1e-4; ) pa = ba(Kn), va = Kn, Un = Wr(Jo.x, Jo.y, pa.x, pa.y), Un + qn > zn ? (Kn -= ma, ma /= 2) : (Jo = pa, Kn += ma, qn += Un);
  return s$1(s$1({}, pa), {}, { angle: _a(va) });
}, Qr = (Xn) => {
  let zn, Un, Kn = 0, qn = 0, Jo = 0, pa = 0, ma = 0;
  const va = [];
  for (const ba of Xn) {
    const _a = { x: qn, y: Jo, command: ba[0], length: 0 };
    switch (ba[0]) {
      case "M":
        Un = _a, Un.x = pa = qn = ba[1], Un.y = ma = Jo = ba[2];
        break;
      case "L":
        Un = _a, Un.length = Wr(qn, Jo, ba[1], ba[2]), qn = ba[1], Jo = ba[2];
        break;
      case "C":
        zn = Vr(qn, Jo, ba[1], ba[2], ba[3], ba[4], ba[5], ba[6]), Un = _a, Un.iterator = zn, Un.angleFinder = Nr(qn, Jo, ba[1], ba[2], ba[3], ba[4], ba[5], ba[6]), Un.length = Kr(zn, qn, Jo), qn = ba[5], Jo = ba[6];
        break;
      case "Q":
        zn = Ur(qn, Jo, ba[1], ba[2], ba[3], ba[4]), Un = _a, Un.iterator = zn, Un.angleFinder = qr(qn, Jo, ba[1], ba[2], ba[3], ba[4]), Un.length = Kr(zn, qn, Jo), qn = ba[3], Jo = ba[4];
        break;
      case "Z":
        Un = _a, Un.destX = pa, Un.destY = ma, Un.length = Wr(qn, Jo, pa, ma), qn = pa, Jo = ma;
    }
    Kn += Un.length, va.push(Un);
  }
  return va.push({ length: Kn, x: qn, y: Jo }), va;
}, Zr = function(Xn, zn) {
  let Un = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Qr(Xn), Kn = 0;
  for (; zn - Un[Kn].length > 0 && Kn < Un.length - 2; ) zn -= Un[Kn].length, Kn++;
  const qn = Un[Kn], Jo = zn / qn.length, pa = Xn[Kn];
  switch (qn.command) {
    case "M":
      return { x: qn.x, y: qn.y, angle: 0 };
    case "Z":
      return s$1(s$1({}, new ot(qn.x, qn.y).lerp(new ot(qn.destX, qn.destY), Jo)), {}, { angle: Math.atan2(qn.destY - qn.y, qn.destX - qn.x) });
    case "L":
      return s$1(s$1({}, new ot(qn.x, qn.y).lerp(new ot(pa[1], pa[2]), Jo)), {}, { angle: Math.atan2(pa[2] - qn.y, pa[1] - qn.x) });
    case "C":
    case "Q":
      return Jr(qn, zn);
  }
}, $r = new RegExp("[mzlhvcsqta][^mzlhvcsqta]*", "gi"), tn = new RegExp(Fr, "g"), en = new RegExp(Ve, "gi"), sn = { m: 2, l: 2, h: 1, v: 1, c: 6, s: 4, q: 4, t: 2, a: 7 }, rn = (Xn) => {
  var zn;
  const Un = [], Kn = (zn = Xn.match($r)) !== null && zn !== void 0 ? zn : [];
  for (const qn of Kn) {
    const Jo = qn[0];
    if (Jo === "z" || Jo === "Z") {
      Un.push([Jo]);
      continue;
    }
    const pa = sn[Jo.toLowerCase()];
    let ma = [];
    if (Jo === "a" || Jo === "A") {
      tn.lastIndex = 0;
      for (let va = null; va = tn.exec(qn); ) ma.push(...va.slice(1));
    } else ma = qn.match(en) || [];
    for (let va = 0; va < ma.length; va += pa) {
      const ba = new Array(pa), _a = Lr[Jo];
      ba[0] = va > 0 && _a ? _a : Jo;
      for (let ya = 0; ya < pa; ya++) ba[ya + 1] = parseFloat(ma[va + ya]);
      Un.push(ba);
    }
  }
  return Un;
}, nn = function(Xn) {
  let zn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Un = new ot(Xn[0]), Kn = new ot(Xn[1]), qn = 1, Jo = 0;
  const pa = [], ma = Xn.length, va = ma > 2;
  let ba;
  for (va && (qn = Xn[2].x < Kn.x ? -1 : Xn[2].x === Kn.x ? 0 : 1, Jo = Xn[2].y < Kn.y ? -1 : Xn[2].y === Kn.y ? 0 : 1), pa.push(["M", Un.x - qn * zn, Un.y - Jo * zn]), ba = 1; ba < ma; ba++) {
    if (!Un.eq(Kn)) {
      const _a = Un.midPointFrom(Kn);
      pa.push(["Q", Un.x, Un.y, _a.x, _a.y]);
    }
    Un = Xn[ba], ba + 1 < Xn.length && (Kn = Xn[ba + 1]);
  }
  return va && (qn = Un.x > Xn[ba - 2].x ? 1 : Un.x === Xn[ba - 2].x ? 0 : -1, Jo = Un.y > Xn[ba - 2].y ? 1 : Un.y === Xn[ba - 2].y ? 0 : -1), pa.push(["L", Un.x + qn * zn, Un.y + Jo * zn]), pa;
}, on = (Xn, zn) => Xn.map((Un) => Un.map((Kn, qn) => qn === 0 || zn === void 0 ? Kn : Vt(Kn, zn)).join(" ")).join(" ");
function an(Xn, zn) {
  const Un = Xn.style;
  Un && zn && (typeof zn == "string" ? Un.cssText += ";" + zn : Object.entries(zn).forEach((Kn) => {
    let [qn, Jo] = Kn;
    return Un.setProperty(qn, Jo);
  }));
}
const hn = (Xn, zn) => Math.floor(Math.random() * (zn - Xn + 1)) + Xn;
function cn(Xn) {
  let zn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const Un = zn.onComplete || C$1, Kn = new (v$1()).XMLHttpRequest(), qn = zn.signal, Jo = function() {
    Kn.abort();
  }, pa = function() {
    qn && qn.removeEventListener("abort", Jo), Kn.onerror = Kn.ontimeout = C$1;
  };
  if (qn && qn.aborted) throw new c$2("request");
  return qn && qn.addEventListener("abort", Jo, { once: !0 }), Kn.onreadystatechange = function() {
    Kn.readyState === 4 && (pa(), Un(Kn), Kn.onreadystatechange = C$1);
  }, Kn.onerror = Kn.ontimeout = pa, Kn.open("get", Xn, !0), Kn.send(), Kn;
}
const ln = (Xn, zn) => {
  let Un = Xn._findCenterFromElement();
  Xn.transformMatrix && (((Kn) => {
    if (Kn.transformMatrix) {
      const { scaleX: qn, scaleY: Jo, angle: pa, skewX: ma } = Dt(Kn.transformMatrix);
      Kn.flipX = !1, Kn.flipY = !1, Kn.set(H, qn), Kn.set(N$1, Jo), Kn.angle = pa, Kn.skewX = ma, Kn.skewY = 0;
    }
  })(Xn), Un = Un.transform(Xn.transformMatrix)), delete Xn.transformMatrix, zn && (Xn.scaleX *= zn.scaleX, Xn.scaleY *= zn.scaleY, Xn.cropX = zn.cropX, Xn.cropY = zn.cropY, Un.x += zn.offsetLeft, Un.y += zn.offsetTop, Xn.width = zn.width, Xn.height = zn.height), Xn.setPositionByOrigin(Un, D, D);
};
var un = Object.freeze({ __proto__: null, addTransformToObject: ce, animate: js, animateColor: Fs, applyTransformToObject: le, calcAngleBetweenVectors: is, calcDimensionsMatrix: Lt, calcPlaneChangeMatrix: fe, calcVectorRotation: rs, cancelAnimFrame: dt, capValue: gs, composeMatrix: Rt, copyCanvasElement: (Xn) => {
  var zn;
  const Un = vt(Xn);
  return (zn = Un.getContext("2d")) === null || zn === void 0 || zn.drawImage(Xn, 0, 0), Un;
}, cos: rt, createCanvasElement: pt, createImage: mt, createRotateMatrix: Pt, createScaleMatrix: Et, createSkewXMatrix: jt, createSkewYMatrix: Ft, createTranslateMatrix: Mt, createVector: es, crossProduct: as, degreesToRadians: xt, dotProduct: hs, ease: bs, enlivenObjectEnlivables: Xt, enlivenObjects: Bt, findScaleToCover: Er, findScaleToFit: Pr, getBoundsOfCurve: Br, getOrthonormalVector: os, getPathSegmentsInfo: Qr, getPointOnPath: Zr, getPointer: re, getRandomInt: hn, getRegularPolygonPath: (Xn, zn) => {
  const Un = 2 * Math.PI / Xn;
  let Kn = -b$1;
  Xn % 2 == 0 && (Kn += Un / 2);
  const qn = new Array(Xn + 1);
  for (let Jo = 0; Jo < Xn; Jo++) {
    const pa = Jo * Un + Kn, { x: ma, y: va } = new ot(rt(pa), nt(pa)).scalarMultiply(zn);
    qn[Jo] = [Jo === 0 ? "M" : "L", ma, va];
  }
  return qn[Xn] = ["Z"], qn;
}, getSmoothPathFromPoints: nn, getSvgAttributes: (Xn) => {
  const zn = ["instantiated_by_use", "style", "id", "class"];
  switch (Xn) {
    case "linearGradient":
      return zn.concat(["x1", "y1", "x2", "y2", "gradientUnits", "gradientTransform"]);
    case "radialGradient":
      return zn.concat(["gradientUnits", "gradientTransform", "cx", "cy", "r", "fx", "fy", "fr"]);
    case "stop":
      return zn.concat(["offset", "stop-color", "stop-opacity"]);
  }
  return zn;
}, getUnitVector: ns, groupSVGElements: (Xn, zn) => Xn && Xn.length === 1 ? Xn[0] : new Mr(Xn, zn), hasStyleChanged: Ei, invertTransform: St, isBetweenVectors: cs, isIdentityMatrix: bt, isTouchEvent: ne, isTransparent: xi, joinPath: on, loadImage: It, magnitude: ss, makeBoundingBoxFromPoints: ae, makePathSimpler: Yr, matrixToSVG: zt, mergeClipPaths: (Xn, zn) => {
  var Un;
  let Kn = Xn, qn = zn;
  Kn.inverted && !qn.inverted && (Kn = zn, qn = Xn), ve(qn, (Un = qn.group) === null || Un === void 0 ? void 0 : Un.calcTransformMatrix(), Kn.calcTransformMatrix());
  const Jo = Kn.inverted && qn.inverted;
  return Jo && (Kn.inverted = qn.inverted = !1), new Mr([Kn], { clipPath: qn, inverted: Jo });
}, multiplyTransformMatrices: Tt, multiplyTransformMatrixArray: Ot, parsePath: rn, parsePreserveAspectRatioAttribute: Ie, parseUnit: Re, pick: Yt, projectStrokeOnPoints: Ti, qrDecompose: Dt, radiansToDegrees: Ct, removeFromArray: it, removeTransformFromObject: (Xn, zn) => {
  const Un = St(zn), Kn = Tt(Un, Xn.calcOwnMatrix());
  le(Xn, Kn);
}, removeTransformMatrixForSvgParsing: ln, request: cn, requestAnimFrame: ut, resetObjectTransform: ue, rotatePoint: (Xn, zn, Un) => Xn.rotate(Un, zn), rotateVector: ts, saveObjectTransform: de, sendObjectToPlane: ve, sendPointToPlane: pe, sendVectorToPlane: me, setStyle: an, sin: nt, sizeAfterTransform: ge, string: Pi, stylesFromArray: ji, stylesToArray: Ai, toBlob: _t, toDataURL: yt, toFixed: Vt, transformPath: (Xn, zn, Un) => (Un && (zn = Tt(zn, [1, 0, 0, 1, -Un.x, -Un.y])), Xn.map((Kn) => {
  const qn = [...Kn];
  for (let Jo = 1; Jo < Kn.length - 1; Jo += 2) {
    const { x: pa, y: ma } = wt({ x: Kn[Jo], y: Kn[Jo + 1] }, zn);
    qn[Jo] = pa, qn[Jo + 1] = ma;
  }
  return qn;
})), transformPoint: wt });
class dn extends te {
  constructor(zn) {
    let { allowTouchScrolling: Un = !1, containerClass: Kn = "" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(zn), t$1(this, "upper", void 0), t$1(this, "container", void 0);
    const { el: qn } = this.lower, Jo = this.createUpperCanvas();
    this.upper = { el: Jo, ctx: Jo.getContext("2d") }, this.applyCanvasStyle(qn, { allowTouchScrolling: Un }), this.applyCanvasStyle(Jo, { allowTouchScrolling: Un, styles: { position: "absolute", left: "0", top: "0" } });
    const pa = this.createContainerElement();
    pa.classList.add(Kn), qn.parentNode && qn.parentNode.replaceChild(pa, qn), pa.append(qn, Jo), this.container = pa;
  }
  createUpperCanvas() {
    const { el: zn } = this.lower, Un = pt();
    return Un.className = zn.className, Un.classList.remove("lower-canvas"), Un.classList.add("upper-canvas"), Un.setAttribute("data-fabric", "top"), Un.style.cssText = zn.style.cssText, Un.setAttribute("draggable", "true"), Un;
  }
  createContainerElement() {
    const zn = m().createElement("div");
    return zn.setAttribute("data-fabric", "wrapper"), an(zn, { position: "relative" }), $t(zn), zn;
  }
  applyCanvasStyle(zn, Un) {
    const { styles: Kn, allowTouchScrolling: qn } = Un;
    an(zn, s$1(s$1({}, Kn), {}, { "touch-action": qn ? "manipulation" : j })), $t(zn);
  }
  setDimensions(zn, Un) {
    super.setDimensions(zn, Un);
    const { el: Kn, ctx: qn } = this.upper;
    Qt(Kn, qn, zn, Un);
  }
  setCSSDimensions(zn) {
    super.setCSSDimensions(zn), Zt(this.upper.el, zn), Zt(this.container, zn);
  }
  cleanupDOM(zn) {
    const Un = this.container, { el: Kn } = this.lower, { el: qn } = this.upper;
    super.cleanupDOM(zn), Un.removeChild(qn), Un.removeChild(Kn), Un.parentNode && Un.parentNode.replaceChild(Kn, Un);
  }
  dispose() {
    super.dispose(), p$1().dispose(this.upper.el), delete this.upper, delete this.container;
  }
}
class gn extends se {
  constructor() {
    super(...arguments), t$1(this, "targets", []), t$1(this, "_hoveredTargets", []), t$1(this, "_objectsToRender", void 0), t$1(this, "_currentTransform", null), t$1(this, "_groupSelector", null), t$1(this, "contextTopDirty", !1);
  }
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), gn.ownDefaults);
  }
  get upperCanvasEl() {
    var zn;
    return (zn = this.elements.upper) === null || zn === void 0 ? void 0 : zn.el;
  }
  get contextTop() {
    var zn;
    return (zn = this.elements.upper) === null || zn === void 0 ? void 0 : zn.ctx;
  }
  get wrapperEl() {
    return this.elements.container;
  }
  initElements(zn) {
    this.elements = new dn(zn, { allowTouchScrolling: this.allowTouchScrolling, containerClass: this.containerClass }), this._createCacheCanvas();
  }
  _onObjectAdded(zn) {
    this._objectsToRender = void 0, super._onObjectAdded(zn);
  }
  _onObjectRemoved(zn) {
    this._objectsToRender = void 0, zn === this._activeObject && (this.fire("before:selection:cleared", { deselected: [zn] }), this._discardActiveObject(), this.fire("selection:cleared", { deselected: [zn] }), zn.fire("deselected", { target: zn })), zn === this._hoveredTarget && (this._hoveredTarget = void 0, this._hoveredTargets = []), super._onObjectRemoved(zn);
  }
  _onStackOrderChanged() {
    this._objectsToRender = void 0, super._onStackOrderChanged();
  }
  _chooseObjectsToRender() {
    const zn = this._activeObject;
    return !this.preserveObjectStacking && zn ? this._objects.filter((Un) => !Un.group && Un !== zn).concat(zn) : this._objects;
  }
  renderAll() {
    this.cancelRequestedRender(), this.destroyed || (!this.contextTopDirty || this._groupSelector || this.isDrawingMode || (this.clearContext(this.contextTop), this.contextTopDirty = !1), this.hasLostContext && (this.renderTopLayer(this.contextTop), this.hasLostContext = !1), !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender()), this.renderCanvas(this.getContext(), this._objectsToRender));
  }
  renderTopLayer(zn) {
    zn.save(), this.isDrawingMode && this._isCurrentlyDrawing && (this.freeDrawingBrush && this.freeDrawingBrush._render(), this.contextTopDirty = !0), this.selection && this._groupSelector && (this._drawSelection(zn), this.contextTopDirty = !0), zn.restore();
  }
  renderTop() {
    const zn = this.contextTop;
    this.clearContext(zn), this.renderTopLayer(zn), this.fire("after:render", { ctx: zn });
  }
  setTargetFindTolerance(zn) {
    zn = Math.round(zn), this.targetFindTolerance = zn;
    const Un = this.getRetinaScaling(), Kn = Math.ceil((2 * zn + 1) * Un);
    this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = Kn, this.pixelFindContext.scale(Un, Un);
  }
  isTargetTransparent(zn, Un, Kn) {
    const qn = this.targetFindTolerance, Jo = this.pixelFindContext;
    this.clearContext(Jo), Jo.save(), Jo.translate(-Un + qn, -Kn + qn), Jo.transform(...this.viewportTransform);
    const pa = zn.selectionBackgroundColor;
    zn.selectionBackgroundColor = "", zn.render(Jo), zn.selectionBackgroundColor = pa, Jo.restore();
    const ma = Math.round(qn * this.getRetinaScaling());
    return xi(Jo, ma, ma, ma);
  }
  _isSelectionKeyPressed(zn) {
    const Un = this.selectionKey;
    return !!Un && (Array.isArray(Un) ? !!Un.find((Kn) => !!Kn && zn[Kn] === !0) : zn[Un]);
  }
  _shouldClearSelection(zn, Un) {
    const Kn = this.getActiveObjects(), qn = this._activeObject;
    return !!(!Un || Un && qn && Kn.length > 1 && Kn.indexOf(Un) === -1 && qn !== Un && !this._isSelectionKeyPressed(zn) || Un && !Un.evented || Un && !Un.selectable && qn && qn !== Un);
  }
  _shouldCenterTransform(zn, Un, Kn) {
    if (!zn) return;
    let qn;
    return Un === G || Un === H || Un === N$1 || Un === Y$2 ? qn = this.centeredScaling || zn.centeredScaling : Un === B$1 && (qn = this.centeredRotation || zn.centeredRotation), qn ? !Kn : Kn;
  }
  _getOriginFromCorner(zn, Un) {
    const Kn = { x: zn.originX, y: zn.originY };
    return Un && (["ml", "tl", "bl"].includes(Un) ? Kn.x = A$1 : ["mr", "tr", "br"].includes(Un) && (Kn.x = M$1), ["tl", "mt", "tr"].includes(Un) ? Kn.y = E$1 : ["bl", "mb", "br"].includes(Un) && (Kn.y = P)), Kn;
  }
  _setupCurrentTransform(zn, Un, Kn) {
    var qn;
    const Jo = Un.group ? pe(this.getScenePoint(zn), void 0, Un.group.calcTransformMatrix()) : this.getScenePoint(zn), { key: pa = "", control: ma } = Un.getActiveControl() || {}, va = Kn && ma ? (qn = ma.getActionHandler(zn, Un, ma)) === null || qn === void 0 ? void 0 : qn.bind(ma) : De, ba = ((wa, Ta, Sa, Ma) => {
      if (!Ta || !wa) return "drag";
      const ka = Ma.controls[Ta];
      return ka.getActionName(Sa, ka, Ma);
    })(Kn, pa, zn, Un), _a = zn[this.centeredKey], ya = this._shouldCenterTransform(Un, ba, _a) ? { x: D, y: D } : this._getOriginFromCorner(Un, pa), xa = { target: Un, action: ba, actionHandler: va, actionPerformed: !1, corner: pa, scaleX: Un.scaleX, scaleY: Un.scaleY, skewX: Un.skewX, skewY: Un.skewY, offsetX: Jo.x - Un.left, offsetY: Jo.y - Un.top, originX: ya.x, originY: ya.y, ex: Jo.x, ey: Jo.y, lastX: Jo.x, lastY: Jo.y, theta: xt(Un.angle), width: Un.width, height: Un.height, shiftKey: zn.shiftKey, altKey: _a, original: s$1(s$1({}, de(Un)), {}, { originX: ya.x, originY: ya.y }) };
    this._currentTransform = xa, this.fire("before:transform", { e: zn, transform: xa });
  }
  setCursor(zn) {
    this.upperCanvasEl.style.cursor = zn;
  }
  _drawSelection(zn) {
    const { x: Un, y: Kn, deltaX: qn, deltaY: Jo } = this._groupSelector, pa = new ot(Un, Kn).transform(this.viewportTransform), ma = new ot(Un + qn, Kn + Jo).transform(this.viewportTransform), va = this.selectionLineWidth / 2;
    let ba = Math.min(pa.x, ma.x), _a = Math.min(pa.y, ma.y), ya = Math.max(pa.x, ma.x), xa = Math.max(pa.y, ma.y);
    this.selectionColor && (zn.fillStyle = this.selectionColor, zn.fillRect(ba, _a, ya - ba, xa - _a)), this.selectionLineWidth && this.selectionBorderColor && (zn.lineWidth = this.selectionLineWidth, zn.strokeStyle = this.selectionBorderColor, ba += va, _a += va, ya -= va, xa -= va, _i.prototype._setLineDash.call(this, zn, this.selectionDashArray), zn.strokeRect(ba, _a, ya - ba, xa - _a));
  }
  findTarget(zn) {
    if (this.skipTargetFind) return;
    const Un = this.getViewportPoint(zn), Kn = this._activeObject, qn = this.getActiveObjects();
    if (this.targets = [], Kn && qn.length >= 1) {
      if (Kn.findControl(Un, ne(zn)) || qn.length > 1 && this.searchPossibleTargets([Kn], Un)) return Kn;
      if (Kn === this.searchPossibleTargets([Kn], Un)) {
        if (this.preserveObjectStacking) {
          const Jo = this.targets;
          this.targets = [];
          const pa = this.searchPossibleTargets(this._objects, Un);
          return zn[this.altSelectionKey] && pa && pa !== Kn ? (this.targets = Jo, Kn) : pa;
        }
        return Kn;
      }
    }
    return this.searchPossibleTargets(this._objects, Un);
  }
  _pointIsInObjectSelectionArea(zn, Un) {
    let Kn = zn.getCoords();
    const qn = this.getZoom(), Jo = zn.padding / qn;
    if (Jo) {
      const [pa, ma, va, ba] = Kn, _a = Math.atan2(ma.y - pa.y, ma.x - pa.x), ya = rt(_a) * Jo, xa = nt(_a) * Jo, wa = ya + xa, Ta = ya - xa;
      Kn = [new ot(pa.x - Ta, pa.y - wa), new ot(ma.x + wa, ma.y - Ta), new ot(va.x + Ta, va.y + wa), new ot(ba.x - wa, ba.y + Ta)];
    }
    return Ls.isPointInPolygon(Un, Kn);
  }
  _checkTarget(zn, Un) {
    return !!(zn && zn.visible && zn.evented && this._pointIsInObjectSelectionArea(zn, pe(Un, void 0, this.viewportTransform)) && (!this.perPixelTargetFind && !zn.perPixelTargetFind || zn.isEditing || !this.isTargetTransparent(zn, Un.x, Un.y)));
  }
  _searchPossibleTargets(zn, Un) {
    let Kn = zn.length;
    for (; Kn--; ) {
      const qn = zn[Kn];
      if (this._checkTarget(qn, Un)) {
        if (ht(qn) && qn.subTargetCheck) {
          const Jo = this._searchPossibleTargets(qn._objects, Un);
          Jo && this.targets.push(Jo);
        }
        return qn;
      }
    }
  }
  searchPossibleTargets(zn, Un) {
    const Kn = this._searchPossibleTargets(zn, Un);
    if (Kn && ht(Kn) && Kn.interactive && this.targets[0]) {
      const qn = this.targets;
      for (let Jo = qn.length - 1; Jo > 0; Jo--) {
        const pa = qn[Jo];
        if (!ht(pa) || !pa.interactive) return pa;
      }
      return qn[0];
    }
    return Kn;
  }
  getViewportPoint(zn) {
    return this._pointer ? this._pointer : this.getPointer(zn, !0);
  }
  getScenePoint(zn) {
    return this._absolutePointer ? this._absolutePointer : this.getPointer(zn);
  }
  getPointer(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    const Kn = this.upperCanvasEl, qn = Kn.getBoundingClientRect();
    let Jo = re(zn), pa = qn.width || 0, ma = qn.height || 0;
    pa && ma || (P in qn && E$1 in qn && (ma = Math.abs(qn.top - qn.bottom)), A$1 in qn && M$1 in qn && (pa = Math.abs(qn.right - qn.left))), this.calcOffset(), Jo.x = Jo.x - this._offset.left, Jo.y = Jo.y - this._offset.top, Un || (Jo = pe(Jo, void 0, this.viewportTransform));
    const va = this.getRetinaScaling();
    va !== 1 && (Jo.x /= va, Jo.y /= va);
    const ba = pa === 0 || ma === 0 ? new ot(1, 1) : new ot(Kn.width / pa, Kn.height / ma);
    return Jo.multiply(ba);
  }
  _setDimensionsImpl(zn, Un) {
    this._resetTransformEventData(), super._setDimensionsImpl(zn, Un), this._isCurrentlyDrawing && this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
  }
  _createCacheCanvas() {
    this.pixelFindCanvasEl = pt(), this.pixelFindContext = this.pixelFindCanvasEl.getContext("2d", { willReadFrequently: !0 }), this.setTargetFindTolerance(this.targetFindTolerance);
  }
  getTopContext() {
    return this.elements.upper.ctx;
  }
  getSelectionContext() {
    return this.elements.upper.ctx;
  }
  getSelectionElement() {
    return this.elements.upper.el;
  }
  getActiveObject() {
    return this._activeObject;
  }
  getActiveObjects() {
    const zn = this._activeObject;
    return Ut(zn) ? zn.getObjects() : zn ? [zn] : [];
  }
  _fireSelectionEvents(zn, Un) {
    let Kn = !1, qn = !1;
    const Jo = this.getActiveObjects(), pa = [], ma = [];
    zn.forEach((va) => {
      Jo.includes(va) || (Kn = !0, va.fire("deselected", { e: Un, target: va }), ma.push(va));
    }), Jo.forEach((va) => {
      zn.includes(va) || (Kn = !0, va.fire("selected", { e: Un, target: va }), pa.push(va));
    }), zn.length > 0 && Jo.length > 0 ? (qn = !0, Kn && this.fire("selection:updated", { e: Un, selected: pa, deselected: ma })) : Jo.length > 0 ? (qn = !0, this.fire("selection:created", { e: Un, selected: pa })) : zn.length > 0 && (qn = !0, this.fire("selection:cleared", { e: Un, deselected: ma })), qn && (this._objectsToRender = void 0);
  }
  setActiveObject(zn, Un) {
    const Kn = this.getActiveObjects(), qn = this._setActiveObject(zn, Un);
    return this._fireSelectionEvents(Kn, Un), qn;
  }
  _setActiveObject(zn, Un) {
    const Kn = this._activeObject;
    return Kn !== zn && !(!this._discardActiveObject(Un, zn) && this._activeObject) && !zn.onSelect({ e: Un }) && (this._activeObject = zn, Ut(zn) && Kn !== zn && zn.set("canvas", this), zn.setCoords(), !0);
  }
  _discardActiveObject(zn, Un) {
    const Kn = this._activeObject;
    return !!Kn && !Kn.onDeselect({ e: zn, object: Un }) && (this._currentTransform && this._currentTransform.target === Kn && this.endCurrentTransform(zn), Ut(Kn) && Kn === this._hoveredTarget && (this._hoveredTarget = void 0), this._activeObject = void 0, !0);
  }
  discardActiveObject(zn) {
    const Un = this.getActiveObjects(), Kn = this.getActiveObject();
    Un.length && this.fire("before:selection:cleared", { e: zn, deselected: [Kn] });
    const qn = this._discardActiveObject(zn);
    return this._fireSelectionEvents(Un, zn), qn;
  }
  endCurrentTransform(zn) {
    const Un = this._currentTransform;
    this._finalizeCurrentTransform(zn), Un && Un.target && (Un.target.isMoving = !1), this._currentTransform = null;
  }
  _finalizeCurrentTransform(zn) {
    const Un = this._currentTransform, Kn = Un.target, qn = { e: zn, target: Kn, transform: Un, action: Un.action };
    Kn._scaling && (Kn._scaling = !1), Kn.setCoords(), Un.actionPerformed && (this.fire("object:modified", qn), Kn.fire(Q, qn));
  }
  setViewportTransform(zn) {
    super.setViewportTransform(zn);
    const Un = this._activeObject;
    Un && Un.setCoords();
  }
  destroy() {
    const zn = this._activeObject;
    Ut(zn) && (zn.removeAll(), zn.dispose()), delete this._activeObject, super.destroy(), this.pixelFindContext = null, this.pixelFindCanvasEl = void 0;
  }
  clear() {
    this.discardActiveObject(), this._activeObject = void 0, this.clearContext(this.contextTop), super.clear();
  }
  drawControls(zn) {
    const Un = this._activeObject;
    Un && Un._renderControls(zn);
  }
  _toObject(zn, Un, Kn) {
    const qn = this._realizeGroupTransformOnObject(zn), Jo = super._toObject(zn, Un, Kn);
    return zn.set(qn), Jo;
  }
  _realizeGroupTransformOnObject(zn) {
    const { group: Un } = zn;
    if (Un && Ut(Un) && this._activeObject === Un) {
      const Kn = Yt(zn, ["angle", "flipX", "flipY", M$1, H, N$1, U, q, P]);
      return ce(zn, Un.calcOwnMatrix()), Kn;
    }
    return {};
  }
  _setSVGObject(zn, Un, Kn) {
    const qn = this._realizeGroupTransformOnObject(Un);
    super._setSVGObject(zn, Un, Kn), Un.set(qn);
  }
}
t$1(gn, "ownDefaults", { uniformScaling: !0, uniScaleKey: "shiftKey", centeredScaling: !1, centeredRotation: !1, centeredKey: "altKey", altActionKey: "shiftKey", selection: !0, selectionKey: "shiftKey", selectionColor: "rgba(100, 100, 255, 0.3)", selectionDashArray: [], selectionBorderColor: "rgba(255, 255, 255, 0.3)", selectionLineWidth: 1, selectionFullyContained: !1, hoverCursor: "move", moveCursor: "move", defaultCursor: "default", freeDrawingCursor: "crosshair", notAllowedCursor: "not-allowed", perPixelTargetFind: !1, targetFindTolerance: 0, skipTargetFind: !1, stopContextMenu: !1, fireRightClick: !1, fireMiddleClick: !1, enablePointerEvents: !1, containerClass: "canvas-container", preserveObjectStacking: !1 });
class fn {
  constructor(zn) {
    t$1(this, "targets", []), t$1(this, "__disposer", void 0);
    const Un = () => {
      const { hiddenTextarea: qn } = zn.getActiveObject() || {};
      qn && qn.focus();
    }, Kn = zn.upperCanvasEl;
    Kn.addEventListener("click", Un), this.__disposer = () => Kn.removeEventListener("click", Un);
  }
  exitTextEditing() {
    this.target = void 0, this.targets.forEach((zn) => {
      zn.isEditing && zn.exitEditing();
    });
  }
  add(zn) {
    this.targets.push(zn);
  }
  remove(zn) {
    this.unregister(zn), it(this.targets, zn);
  }
  register(zn) {
    this.target = zn;
  }
  unregister(zn) {
    zn === this.target && (this.target = void 0);
  }
  onMouseMove(zn) {
    var Un;
    !((Un = this.target) === null || Un === void 0) && Un.isEditing && this.target.updateSelectionOnMouseMove(zn);
  }
  clear() {
    this.targets = [], this.target = void 0;
  }
  dispose() {
    this.clear(), this.__disposer(), delete this.__disposer;
  }
}
const pn = ["target", "oldTarget", "fireCanvas", "e"], mn = { passive: !1 }, vn = (Xn, zn) => {
  const Un = Xn.getViewportPoint(zn), Kn = Xn.getScenePoint(zn);
  return { viewportPoint: Un, scenePoint: Kn, pointer: Un, absolutePointer: Kn };
}, yn = function(Xn) {
  for (var zn = arguments.length, Un = new Array(zn > 1 ? zn - 1 : 0), Kn = 1; Kn < zn; Kn++) Un[Kn - 1] = arguments[Kn];
  return Xn.addEventListener(...Un);
}, _n = function(Xn) {
  for (var zn = arguments.length, Un = new Array(zn > 1 ? zn - 1 : 0), Kn = 1; Kn < zn; Kn++) Un[Kn - 1] = arguments[Kn];
  return Xn.removeEventListener(...Un);
}, xn = { mouse: { in: "over", out: "out", targetIn: "mouseover", targetOut: "mouseout", canvasIn: "mouse:over", canvasOut: "mouse:out" }, drag: { in: "enter", out: "leave", targetIn: "dragenter", targetOut: "dragleave", canvasIn: "drag:enter", canvasOut: "drag:leave" } };
class Cn extends gn {
  constructor(zn) {
    super(zn, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}), t$1(this, "_isClick", void 0), t$1(this, "textEditingManager", new fn(this)), ["_onMouseDown", "_onTouchStart", "_onMouseMove", "_onMouseUp", "_onTouchEnd", "_onResize", "_onMouseWheel", "_onMouseOut", "_onMouseEnter", "_onContextMenu", "_onClick", "_onDragStart", "_onDragEnd", "_onDragProgress", "_onDragOver", "_onDragEnter", "_onDragLeave", "_onDrop"].forEach((Un) => {
      this[Un] = this[Un].bind(this);
    }), this.addOrRemove(yn, "add");
  }
  _getEventPrefix() {
    return this.enablePointerEvents ? "pointer" : "mouse";
  }
  addOrRemove(zn, Un) {
    const Kn = this.upperCanvasEl, qn = this._getEventPrefix();
    zn(Jt(Kn), "resize", this._onResize), zn(Kn, qn + "down", this._onMouseDown), zn(Kn, "".concat(qn, "move"), this._onMouseMove, mn), zn(Kn, "".concat(qn, "out"), this._onMouseOut), zn(Kn, "".concat(qn, "enter"), this._onMouseEnter), zn(Kn, "wheel", this._onMouseWheel), zn(Kn, "contextmenu", this._onContextMenu), zn(Kn, "click", this._onClick), zn(Kn, "dblclick", this._onClick), zn(Kn, "dragstart", this._onDragStart), zn(Kn, "dragend", this._onDragEnd), zn(Kn, "dragover", this._onDragOver), zn(Kn, "dragenter", this._onDragEnter), zn(Kn, "dragleave", this._onDragLeave), zn(Kn, "drop", this._onDrop), this.enablePointerEvents || zn(Kn, "touchstart", this._onTouchStart, mn);
  }
  removeListeners() {
    this.addOrRemove(_n, "remove");
    const zn = this._getEventPrefix(), Un = Kt(this.upperCanvasEl);
    _n(Un, "".concat(zn, "up"), this._onMouseUp), _n(Un, "touchend", this._onTouchEnd, mn), _n(Un, "".concat(zn, "move"), this._onMouseMove, mn), _n(Un, "touchmove", this._onMouseMove, mn), clearTimeout(this._willAddMouseDown);
  }
  _onMouseWheel(zn) {
    this.__onMouseWheel(zn);
  }
  _onMouseOut(zn) {
    const Un = this._hoveredTarget, Kn = s$1({ e: zn }, vn(this, zn));
    this.fire("mouse:out", s$1(s$1({}, Kn), {}, { target: Un })), this._hoveredTarget = void 0, Un && Un.fire("mouseout", s$1({}, Kn)), this._hoveredTargets.forEach((qn) => {
      this.fire("mouse:out", s$1(s$1({}, Kn), {}, { target: qn })), qn && qn.fire("mouseout", s$1({}, Kn));
    }), this._hoveredTargets = [];
  }
  _onMouseEnter(zn) {
    this._currentTransform || this.findTarget(zn) || (this.fire("mouse:over", s$1({ e: zn }, vn(this, zn))), this._hoveredTarget = void 0, this._hoveredTargets = []);
  }
  _onDragStart(zn) {
    this._isClick = !1;
    const Un = this.getActiveObject();
    if (Un && Un.onDragStart(zn)) {
      this._dragSource = Un;
      const Kn = { e: zn, target: Un };
      return this.fire("dragstart", Kn), Un.fire("dragstart", Kn), void yn(this.upperCanvasEl, "drag", this._onDragProgress);
    }
    oe(zn);
  }
  _renderDragEffects(zn, Un, Kn) {
    let qn = !1;
    const Jo = this._dropTarget;
    Jo && Jo !== Un && Jo !== Kn && (Jo.clearContextTop(), qn = !0), Un == null || Un.clearContextTop(), Kn !== Un && (Kn == null || Kn.clearContextTop());
    const pa = this.contextTop;
    pa.save(), pa.transform(...this.viewportTransform), Un && (pa.save(), Un.transform(pa), Un.renderDragSourceEffect(zn), pa.restore(), qn = !0), Kn && (pa.save(), Kn.transform(pa), Kn.renderDropTargetEffect(zn), pa.restore(), qn = !0), pa.restore(), qn && (this.contextTopDirty = !0);
  }
  _onDragEnd(zn) {
    const Un = !!zn.dataTransfer && zn.dataTransfer.dropEffect !== j, Kn = Un ? this._activeObject : void 0, qn = { e: zn, target: this._dragSource, subTargets: this.targets, dragSource: this._dragSource, didDrop: Un, dropTarget: Kn };
    _n(this.upperCanvasEl, "drag", this._onDragProgress), this.fire("dragend", qn), this._dragSource && this._dragSource.fire("dragend", qn), delete this._dragSource, this._onMouseUp(zn);
  }
  _onDragProgress(zn) {
    const Un = { e: zn, target: this._dragSource, dragSource: this._dragSource, dropTarget: this._draggedoverTarget };
    this.fire("drag", Un), this._dragSource && this._dragSource.fire("drag", Un);
  }
  findDragTargets(zn) {
    return this.targets = [], { target: this._searchPossibleTargets(this._objects, this.getViewportPoint(zn)), targets: [...this.targets] };
  }
  _onDragOver(zn) {
    const Un = "dragover", { target: Kn, targets: qn } = this.findDragTargets(zn), Jo = this._dragSource, pa = { e: zn, target: Kn, subTargets: qn, dragSource: Jo, canDrop: !1, dropTarget: void 0 };
    let ma;
    this.fire(Un, pa), this._fireEnterLeaveEvents(Kn, pa), Kn && (Kn.canDrop(zn) && (ma = Kn), Kn.fire(Un, pa));
    for (let va = 0; va < qn.length; va++) {
      const ba = qn[va];
      ba.canDrop(zn) && (ma = ba), ba.fire(Un, pa);
    }
    this._renderDragEffects(zn, Jo, ma), this._dropTarget = ma;
  }
  _onDragEnter(zn) {
    const { target: Un, targets: Kn } = this.findDragTargets(zn), qn = { e: zn, target: Un, subTargets: Kn, dragSource: this._dragSource };
    this.fire("dragenter", qn), this._fireEnterLeaveEvents(Un, qn);
  }
  _onDragLeave(zn) {
    const Un = { e: zn, target: this._draggedoverTarget, subTargets: this.targets, dragSource: this._dragSource };
    this.fire("dragleave", Un), this._fireEnterLeaveEvents(void 0, Un), this._renderDragEffects(zn, this._dragSource), this._dropTarget = void 0, this.targets = [], this._hoveredTargets = [];
  }
  _onDrop(zn) {
    const { target: Un, targets: Kn } = this.findDragTargets(zn), qn = this._basicEventHandler("drop:before", s$1({ e: zn, target: Un, subTargets: Kn, dragSource: this._dragSource }, vn(this, zn)));
    qn.didDrop = !1, qn.dropTarget = void 0, this._basicEventHandler("drop", qn), this.fire("drop:after", qn);
  }
  _onContextMenu(zn) {
    const Un = this.findTarget(zn), Kn = this.targets || [], qn = this._basicEventHandler("contextmenu:before", { e: zn, target: Un, subTargets: Kn });
    return this.stopContextMenu && oe(zn), this._basicEventHandler("contextmenu", qn), !1;
  }
  _onClick(zn) {
    const Un = zn.detail;
    Un > 3 || Un < 2 || (this._cacheTransformEventData(zn), Un == 2 && zn.type === "dblclick" && this._handleEvent(zn, "dblclick"), Un == 3 && this._handleEvent(zn, "tripleclick"), this._resetTransformEventData());
  }
  getPointerId(zn) {
    const Un = zn.changedTouches;
    return Un ? Un[0] && Un[0].identifier : this.enablePointerEvents ? zn.pointerId : -1;
  }
  _isMainEvent(zn) {
    return zn.isPrimary === !0 || zn.isPrimary !== !1 && (zn.type === "touchend" && zn.touches.length === 0 || !zn.changedTouches || zn.changedTouches[0].identifier === this.mainTouchId);
  }
  _onTouchStart(zn) {
    let Un = !this.allowTouchScrolling;
    const Kn = this._activeObject;
    this.mainTouchId === void 0 && (this.mainTouchId = this.getPointerId(zn)), this.__onMouseDown(zn), (this.isDrawingMode || Kn && this._target === Kn) && (Un = !0), Un && zn.preventDefault(), this._resetTransformEventData();
    const qn = this.upperCanvasEl, Jo = this._getEventPrefix(), pa = Kt(qn);
    yn(pa, "touchend", this._onTouchEnd, mn), Un && yn(pa, "touchmove", this._onMouseMove, mn), _n(qn, "".concat(Jo, "down"), this._onMouseDown);
  }
  _onMouseDown(zn) {
    this.__onMouseDown(zn), this._resetTransformEventData();
    const Un = this.upperCanvasEl, Kn = this._getEventPrefix();
    _n(Un, "".concat(Kn, "move"), this._onMouseMove, mn);
    const qn = Kt(Un);
    yn(qn, "".concat(Kn, "up"), this._onMouseUp), yn(qn, "".concat(Kn, "move"), this._onMouseMove, mn);
  }
  _onTouchEnd(zn) {
    if (zn.touches.length > 0) return;
    this.__onMouseUp(zn), this._resetTransformEventData(), delete this.mainTouchId;
    const Un = this._getEventPrefix(), Kn = Kt(this.upperCanvasEl);
    _n(Kn, "touchend", this._onTouchEnd, mn), _n(Kn, "touchmove", this._onMouseMove, mn), this._willAddMouseDown && clearTimeout(this._willAddMouseDown), this._willAddMouseDown = setTimeout(() => {
      yn(this.upperCanvasEl, "".concat(Un, "down"), this._onMouseDown), this._willAddMouseDown = 0;
    }, 400);
  }
  _onMouseUp(zn) {
    this.__onMouseUp(zn), this._resetTransformEventData();
    const Un = this.upperCanvasEl, Kn = this._getEventPrefix();
    if (this._isMainEvent(zn)) {
      const qn = Kt(this.upperCanvasEl);
      _n(qn, "".concat(Kn, "up"), this._onMouseUp), _n(qn, "".concat(Kn, "move"), this._onMouseMove, mn), yn(Un, "".concat(Kn, "move"), this._onMouseMove, mn);
    }
  }
  _onMouseMove(zn) {
    const Un = this.getActiveObject();
    !this.allowTouchScrolling && (!Un || !Un.shouldStartDragging(zn)) && zn.preventDefault && zn.preventDefault(), this.__onMouseMove(zn);
  }
  _onResize() {
    this.calcOffset(), this._resetTransformEventData();
  }
  _shouldRender(zn) {
    const Un = this.getActiveObject();
    return !!Un != !!zn || Un && zn && Un !== zn;
  }
  __onMouseUp(zn) {
    var Un;
    this._cacheTransformEventData(zn), this._handleEvent(zn, "up:before");
    const Kn = this._currentTransform, qn = this._isClick, Jo = this._target, { button: pa } = zn;
    if (pa) return (this.fireMiddleClick && pa === 1 || this.fireRightClick && pa === 2) && this._handleEvent(zn, "up"), void this._resetTransformEventData();
    if (this.isDrawingMode && this._isCurrentlyDrawing) return void this._onMouseUpInDrawingMode(zn);
    if (!this._isMainEvent(zn)) return;
    let ma, va, ba = !1;
    if (Kn && (this._finalizeCurrentTransform(zn), ba = Kn.actionPerformed), !qn) {
      const _a = Jo === this._activeObject;
      this.handleSelection(zn), ba || (ba = this._shouldRender(Jo) || !_a && Jo === this._activeObject);
    }
    if (Jo) {
      const _a = Jo.findControl(this.getViewportPoint(zn), ne(zn)), { key: ya, control: xa } = _a || {};
      if (va = ya, Jo.selectable && Jo !== this._activeObject && Jo.activeOn === "up") this.setActiveObject(Jo, zn), ba = !0;
      else if (xa) {
        const wa = xa.getMouseUpHandler(zn, Jo, xa);
        wa && (ma = this.getScenePoint(zn), wa.call(xa, zn, Kn, ma.x, ma.y));
      }
      Jo.isMoving = !1;
    }
    if (Kn && (Kn.target !== Jo || Kn.corner !== va)) {
      const _a = Kn.target && Kn.target.controls[Kn.corner], ya = _a && _a.getMouseUpHandler(zn, Kn.target, _a);
      ma = ma || this.getScenePoint(zn), ya && ya.call(_a, zn, Kn, ma.x, ma.y);
    }
    this._setCursorFromEvent(zn, Jo), this._handleEvent(zn, "up"), this._groupSelector = null, this._currentTransform = null, Jo && (Jo.__corner = void 0), ba ? this.requestRenderAll() : qn || (Un = this._activeObject) !== null && Un !== void 0 && Un.isEditing || this.renderTop();
  }
  _basicEventHandler(zn, Un) {
    const { target: Kn, subTargets: qn = [] } = Un;
    this.fire(zn, Un), Kn && Kn.fire(zn, Un);
    for (let Jo = 0; Jo < qn.length; Jo++) qn[Jo] !== Kn && qn[Jo].fire(zn, Un);
    return Un;
  }
  _handleEvent(zn, Un, Kn) {
    const qn = this._target, Jo = this.targets || [], pa = s$1(s$1(s$1({ e: zn, target: qn, subTargets: Jo }, vn(this, zn)), {}, { transform: this._currentTransform }, Un === "up:before" || Un === "up" ? { isClick: this._isClick, currentTarget: this.findTarget(zn), currentSubTargets: this.targets } : {}), Un === "down:before" || Un === "down" ? Kn : {});
    this.fire("mouse:".concat(Un), pa), qn && qn.fire("mouse".concat(Un), pa);
    for (let ma = 0; ma < Jo.length; ma++) Jo[ma] !== qn && Jo[ma].fire("mouse".concat(Un), pa);
  }
  _onMouseDownInDrawingMode(zn) {
    this._isCurrentlyDrawing = !0, this.getActiveObject() && (this.discardActiveObject(zn), this.requestRenderAll());
    const Un = this.getScenePoint(zn);
    this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(Un, { e: zn, pointer: Un }), this._handleEvent(zn, "down", { alreadySelected: !1 });
  }
  _onMouseMoveInDrawingMode(zn) {
    if (this._isCurrentlyDrawing) {
      const Un = this.getScenePoint(zn);
      this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(Un, { e: zn, pointer: Un });
    }
    this.setCursor(this.freeDrawingCursor), this._handleEvent(zn, "move");
  }
  _onMouseUpInDrawingMode(zn) {
    const Un = this.getScenePoint(zn);
    this.freeDrawingBrush ? this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({ e: zn, pointer: Un }) : this._isCurrentlyDrawing = !1, this._handleEvent(zn, "up");
  }
  __onMouseDown(zn) {
    this._isClick = !0, this._cacheTransformEventData(zn), this._handleEvent(zn, "down:before");
    let Un = this._target, Kn = !!Un && Un === this._activeObject;
    const { button: qn } = zn;
    if (qn) return (this.fireMiddleClick && qn === 1 || this.fireRightClick && qn === 2) && this._handleEvent(zn, "down", { alreadySelected: Kn }), void this._resetTransformEventData();
    if (this.isDrawingMode) return void this._onMouseDownInDrawingMode(zn);
    if (!this._isMainEvent(zn) || this._currentTransform) return;
    let Jo = this._shouldRender(Un), pa = !1;
    if (this.handleMultiSelection(zn, Un) ? (Un = this._activeObject, pa = !0, Jo = !0) : this._shouldClearSelection(zn, Un) && this.discardActiveObject(zn), this.selection && (!Un || !Un.selectable && !Un.isEditing && Un !== this._activeObject)) {
      const ma = this.getScenePoint(zn);
      this._groupSelector = { x: ma.x, y: ma.y, deltaY: 0, deltaX: 0 };
    }
    if (Kn = !!Un && Un === this._activeObject, Un) {
      Un.selectable && Un.activeOn === "down" && this.setActiveObject(Un, zn);
      const ma = Un.findControl(this.getViewportPoint(zn), ne(zn));
      if (Un === this._activeObject && (ma || !pa)) {
        this._setupCurrentTransform(zn, Un, Kn);
        const va = ma ? ma.control : void 0, ba = this.getScenePoint(zn), _a = va && va.getMouseDownHandler(zn, Un, va);
        _a && _a.call(va, zn, this._currentTransform, ba.x, ba.y);
      }
    }
    Jo && (this._objectsToRender = void 0), this._handleEvent(zn, "down", { alreadySelected: Kn }), Jo && this.requestRenderAll();
  }
  _resetTransformEventData() {
    this._target = this._pointer = this._absolutePointer = void 0;
  }
  _cacheTransformEventData(zn) {
    this._resetTransformEventData(), this._pointer = this.getViewportPoint(zn), this._absolutePointer = pe(this._pointer, void 0, this.viewportTransform), this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(zn);
  }
  __onMouseMove(zn) {
    if (this._isClick = !1, this._cacheTransformEventData(zn), this._handleEvent(zn, "move:before"), this.isDrawingMode) return void this._onMouseMoveInDrawingMode(zn);
    if (!this._isMainEvent(zn)) return;
    const Un = this._groupSelector;
    if (Un) {
      const Kn = this.getScenePoint(zn);
      Un.deltaX = Kn.x - Un.x, Un.deltaY = Kn.y - Un.y, this.renderTop();
    } else if (this._currentTransform) this._transformObject(zn);
    else {
      const Kn = this.findTarget(zn);
      this._setCursorFromEvent(zn, Kn), this._fireOverOutEvents(zn, Kn);
    }
    this.textEditingManager.onMouseMove(zn), this._handleEvent(zn, "move"), this._resetTransformEventData();
  }
  _fireOverOutEvents(zn, Un) {
    const Kn = this._hoveredTarget, qn = this._hoveredTargets, Jo = this.targets, pa = Math.max(qn.length, Jo.length);
    this.fireSyntheticInOutEvents("mouse", { e: zn, target: Un, oldTarget: Kn, fireCanvas: !0 });
    for (let ma = 0; ma < pa; ma++) this.fireSyntheticInOutEvents("mouse", { e: zn, target: Jo[ma], oldTarget: qn[ma] });
    this._hoveredTarget = Un, this._hoveredTargets = this.targets.concat();
  }
  _fireEnterLeaveEvents(zn, Un) {
    const Kn = this._draggedoverTarget, qn = this._hoveredTargets, Jo = this.targets, pa = Math.max(qn.length, Jo.length);
    this.fireSyntheticInOutEvents("drag", s$1(s$1({}, Un), {}, { target: zn, oldTarget: Kn, fireCanvas: !0 }));
    for (let ma = 0; ma < pa; ma++) this.fireSyntheticInOutEvents("drag", s$1(s$1({}, Un), {}, { target: Jo[ma], oldTarget: qn[ma] }));
    this._draggedoverTarget = zn;
  }
  fireSyntheticInOutEvents(zn, Un) {
    let { target: Kn, oldTarget: qn, fireCanvas: Jo, e: pa } = Un, ma = i$3(Un, pn);
    const { targetIn: va, targetOut: ba, canvasIn: _a, canvasOut: ya } = xn[zn], xa = qn !== Kn;
    if (qn && xa) {
      const wa = s$1(s$1({}, ma), {}, { e: pa, target: qn, nextTarget: Kn }, vn(this, pa));
      Jo && this.fire(ya, wa), qn.fire(ba, wa);
    }
    if (Kn && xa) {
      const wa = s$1(s$1({}, ma), {}, { e: pa, target: Kn, previousTarget: qn }, vn(this, pa));
      Jo && this.fire(_a, wa), Kn.fire(va, wa);
    }
  }
  __onMouseWheel(zn) {
    this._cacheTransformEventData(zn), this._handleEvent(zn, "wheel"), this._resetTransformEventData();
  }
  _transformObject(zn) {
    const Un = this.getScenePoint(zn), Kn = this._currentTransform, qn = Kn.target, Jo = qn.group ? pe(Un, void 0, qn.group.calcTransformMatrix()) : Un;
    Kn.shiftKey = zn.shiftKey, Kn.altKey = !!this.centeredKey && zn[this.centeredKey], this._performTransformAction(zn, Kn, Jo), Kn.actionPerformed && this.requestRenderAll();
  }
  _performTransformAction(zn, Un, Kn) {
    const { action: qn, actionHandler: Jo, target: pa } = Un, ma = !!Jo && Jo(zn, Un, Kn.x, Kn.y);
    ma && pa.setCoords(), qn === "drag" && ma && (Un.target.isMoving = !0, this.setCursor(Un.target.moveCursor || this.moveCursor)), Un.actionPerformed = Un.actionPerformed || ma;
  }
  _setCursorFromEvent(zn, Un) {
    if (!Un) return void this.setCursor(this.defaultCursor);
    let Kn = Un.hoverCursor || this.hoverCursor;
    const qn = Ut(this._activeObject) ? this._activeObject : null, Jo = (!qn || Un.group !== qn) && Un.findControl(this.getViewportPoint(zn));
    if (Jo) {
      const pa = Jo.control;
      this.setCursor(pa.cursorStyleHandler(zn, pa, Un));
    } else Un.subTargetCheck && this.targets.concat().reverse().map((pa) => {
      Kn = pa.hoverCursor || Kn;
    }), this.setCursor(Kn);
  }
  handleMultiSelection(zn, Un) {
    const Kn = this._activeObject, qn = Ut(Kn);
    if (Kn && this._isSelectionKeyPressed(zn) && this.selection && Un && Un.selectable && (Kn !== Un || qn) && (qn || !Un.isDescendantOf(Kn) && !Kn.isDescendantOf(Un)) && !Un.onSelect({ e: zn }) && !Kn.getActiveControl()) {
      if (qn) {
        const Jo = Kn.getObjects();
        if (Un === Kn) {
          const pa = this.getViewportPoint(zn);
          if (!(Un = this.searchPossibleTargets(Jo, pa) || this.searchPossibleTargets(this._objects, pa)) || !Un.selectable) return !1;
        }
        Un.group === Kn ? (Kn.remove(Un), this._hoveredTarget = Un, this._hoveredTargets = [...this.targets], Kn.size() === 1 && this._setActiveObject(Kn.item(0), zn)) : (Kn.multiSelectAdd(Un), this._hoveredTarget = Kn, this._hoveredTargets = [...this.targets]), this._fireSelectionEvents(Jo, zn);
      } else {
        Kn.isEditing && Kn.exitEditing();
        const Jo = new (tt.getClass("ActiveSelection"))([], { canvas: this });
        Jo.multiSelectAdd(Kn, Un), this._hoveredTarget = Jo, this._setActiveObject(Jo, zn), this._fireSelectionEvents([Kn], zn);
      }
      return !0;
    }
    return !1;
  }
  handleSelection(zn) {
    if (!this.selection || !this._groupSelector) return !1;
    const { x: Un, y: Kn, deltaX: qn, deltaY: Jo } = this._groupSelector, pa = new ot(Un, Kn), ma = pa.add(new ot(qn, Jo)), va = pa.min(ma), ba = pa.max(ma).subtract(va), _a = this.collectObjects({ left: va.x, top: va.y, width: ba.x, height: ba.y }, { includeIntersecting: !this.selectionFullyContained }), ya = pa.eq(ma) ? _a[0] ? [_a[0]] : [] : _a.length > 1 ? _a.filter((xa) => !xa.onSelect({ e: zn })).reverse() : _a;
    if (ya.length === 1) this.setActiveObject(ya[0], zn);
    else if (ya.length > 1) {
      const xa = tt.getClass("ActiveSelection");
      this.setActiveObject(new xa(ya, { canvas: this }), zn);
    }
    return this._groupSelector = null, !0;
  }
  clear() {
    this.textEditingManager.clear(), super.clear();
  }
  destroy() {
    this.removeListeners(), this.textEditingManager.dispose(), super.destroy();
  }
}
const bn = { x1: 0, y1: 0, x2: 0, y2: 0 }, wn = s$1(s$1({}, bn), {}, { r1: 0, r2: 0 }), Sn = (Xn, zn) => isNaN(Xn) && typeof zn == "number" ? zn : Xn, Tn = /^(\d+\.\d+)%|(\d+)%$/;
function On(Xn) {
  return Xn && Tn.test(Xn);
}
function kn(Xn, zn) {
  const Un = typeof Xn == "number" ? Xn : typeof Xn == "string" ? parseFloat(Xn) / (On(Xn) ? 100 : 1) : NaN;
  return gs(0, Sn(Un, zn), 1);
}
const Dn = /\s*;\s*/, Mn = /\s*:\s*/;
function Pn(Xn, zn) {
  let Un, Kn;
  const qn = Xn.getAttribute("style");
  if (qn) {
    const pa = qn.split(Dn);
    pa[pa.length - 1] === "" && pa.pop();
    for (let ma = pa.length; ma--; ) {
      const [va, ba] = pa[ma].split(Mn).map((_a) => _a.trim());
      va === "stop-color" ? Un = ba : va === "stop-opacity" && (Kn = ba);
    }
  }
  const Jo = new Le(Un || Xn.getAttribute("stop-color") || "rgb(0,0,0)");
  return { offset: kn(Xn.getAttribute("offset"), 0), color: Jo.toRgb(), opacity: Sn(parseFloat(Kn || Xn.getAttribute("stop-opacity") || ""), 1) * Jo.getAlpha() * zn };
}
function En(Xn, zn) {
  const Un = [], Kn = Xn.getElementsByTagName("stop"), qn = kn(zn, 1);
  for (let Jo = Kn.length; Jo--; ) Un.push(Pn(Kn[Jo], qn));
  return Un;
}
function An(Xn) {
  return Xn.nodeName === "linearGradient" || Xn.nodeName === "LINEARGRADIENT" ? "linear" : "radial";
}
function jn(Xn) {
  return Xn.getAttribute("gradientUnits") === "userSpaceOnUse" ? "pixels" : "percentage";
}
function Fn(Xn, zn) {
  return Xn.getAttribute(zn);
}
function Ln(Xn, zn) {
  return function(Un, Kn) {
    let qn, { width: Jo, height: pa, gradientUnits: ma } = Kn;
    return Object.keys(Un).reduce((va, ba) => {
      const _a = Un[ba];
      return _a === "Infinity" ? qn = 1 : _a === "-Infinity" ? qn = 0 : (qn = typeof _a == "string" ? parseFloat(_a) : _a, typeof _a == "string" && On(_a) && (qn *= 0.01, ma === "pixels" && (ba !== "x1" && ba !== "x2" && ba !== "r2" || (qn *= Jo), ba !== "y1" && ba !== "y2" || (qn *= pa)))), va[ba] = qn, va;
    }, {});
  }(An(Xn) === "linear" ? function(Un) {
    return { x1: Fn(Un, "x1") || 0, y1: Fn(Un, "y1") || 0, x2: Fn(Un, "x2") || "100%", y2: Fn(Un, "y2") || 0 };
  }(Xn) : function(Un) {
    return { x1: Fn(Un, "fx") || Fn(Un, "cx") || "50%", y1: Fn(Un, "fy") || Fn(Un, "cy") || "50%", r1: 0, x2: Fn(Un, "cx") || "50%", y2: Fn(Un, "cy") || "50%", r2: Fn(Un, "r") || "50%" };
  }(Xn), s$1(s$1({}, zn), {}, { gradientUnits: jn(Xn) }));
}
class Rn {
  constructor(zn) {
    const { type: Un = "linear", gradientUnits: Kn = "pixels", coords: qn = {}, colorStops: Jo = [], offsetX: pa = 0, offsetY: ma = 0, gradientTransform: va, id: ba } = zn || {};
    Object.assign(this, { type: Un, gradientUnits: Kn, coords: s$1(s$1({}, Un === "radial" ? wn : bn), qn), colorStops: Jo, offsetX: pa, offsetY: ma, gradientTransform: va, id: ba ? "".concat(ba, "_").concat(ft()) : ft() });
  }
  addColorStop(zn) {
    for (const Un in zn) {
      const Kn = new Le(zn[Un]);
      this.colorStops.push({ offset: parseFloat(Un), color: Kn.toRgb(), opacity: Kn.getAlpha() });
    }
    return this;
  }
  toObject(zn) {
    return s$1(s$1({}, Yt(this, zn)), {}, { type: this.type, coords: s$1({}, this.coords), colorStops: this.colorStops.map((Un) => s$1({}, Un)), offsetX: this.offsetX, offsetY: this.offsetY, gradientUnits: this.gradientUnits, gradientTransform: this.gradientTransform ? [...this.gradientTransform] : void 0 });
  }
  toSVG(zn) {
    let { additionalTransform: Un } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const Kn = [], qn = this.gradientTransform ? this.gradientTransform.concat() : T$1.concat(), Jo = this.gradientUnits === "pixels" ? "userSpaceOnUse" : "objectBoundingBox", pa = this.colorStops.map((ya) => s$1({}, ya)).sort((ya, xa) => ya.offset - xa.offset);
    let ma = -this.offsetX, va = -this.offsetY;
    var ba;
    Jo === "objectBoundingBox" ? (ma /= zn.width, va /= zn.height) : (ma += zn.width / 2, va += zn.height / 2), (ba = zn) && typeof ba._renderPathCommands == "function" && this.gradientUnits !== "percentage" && (ma -= zn.pathOffset.x, va -= zn.pathOffset.y), qn[4] -= ma, qn[5] -= va;
    const _a = ['id="SVGID_'.concat(this.id, '"'), 'gradientUnits="'.concat(Jo, '"'), 'gradientTransform="'.concat(Un ? Un + " " : "").concat(zt(qn), '"'), ""].join(" ");
    if (this.type === "linear") {
      const { x1: ya, y1: xa, x2: wa, y2: Ta } = this.coords;
      Kn.push("<linearGradient ", _a, ' x1="', ya, '" y1="', xa, '" x2="', wa, '" y2="', Ta, `">
`);
    } else if (this.type === "radial") {
      const { x1: ya, y1: xa, x2: wa, y2: Ta, r1: Sa, r2: Ma } = this.coords, ka = Sa > Ma;
      Kn.push("<radialGradient ", _a, ' cx="', ka ? ya : wa, '" cy="', ka ? xa : Ta, '" r="', ka ? Sa : Ma, '" fx="', ka ? wa : ya, '" fy="', ka ? Ta : xa, `">
`), ka && (pa.reverse(), pa.forEach((Na) => {
        Na.offset = 1 - Na.offset;
      }));
      const Za = Math.min(Sa, Ma);
      if (Za > 0) {
        const Na = Za / Math.max(Sa, Ma);
        pa.forEach((Ka) => {
          Ka.offset += Na * (1 - Ka.offset);
        });
      }
    }
    return pa.forEach((ya) => {
      let { color: xa, offset: wa, opacity: Ta } = ya;
      Kn.push("<stop ", 'offset="', 100 * wa + "%", '" style="stop-color:', xa, Ta !== void 0 ? ";stop-opacity: " + Ta : ";", `"/>
`);
    }), Kn.push(this.type === "linear" ? "</linearGradient>" : "</radialGradient>", `
`), Kn.join("");
  }
  toLive(zn) {
    const { x1: Un, y1: Kn, x2: qn, y2: Jo, r1: pa, r2: ma } = this.coords, va = this.type === "linear" ? zn.createLinearGradient(Un, Kn, qn, Jo) : zn.createRadialGradient(Un, Kn, pa, qn, Jo, ma);
    return this.colorStops.forEach((ba) => {
      let { color: _a, opacity: ya, offset: xa } = ba;
      va.addColorStop(xa, ya !== void 0 ? new Le(_a).setAlpha(ya).toRgba() : _a);
    }), va;
  }
  static async fromObject(zn) {
    const { colorStops: Un, gradientTransform: Kn } = zn;
    return new this(s$1(s$1({}, zn), {}, { colorStops: Un ? Un.map((qn) => s$1({}, qn)) : void 0, gradientTransform: Kn ? [...Kn] : void 0 }));
  }
  static fromElement(zn, Un, Kn) {
    const qn = jn(zn), Jo = Un._findCenterFromElement();
    return new this(s$1({ id: zn.getAttribute("id") || void 0, type: An(zn), coords: Ln(zn, { width: Kn.viewBoxWidth || Kn.width, height: Kn.viewBoxHeight || Kn.height }), colorStops: En(zn, Kn.opacity), gradientUnits: qn, gradientTransform: or(zn.getAttribute("gradientTransform") || "") }, qn === "pixels" ? { offsetX: Un.width / 2 - Jo.x, offsetY: Un.height / 2 - Jo.y } : { offsetX: 0, offsetY: 0 }));
  }
}
t$1(Rn, "type", "Gradient"), tt.setClass(Rn, "gradient"), tt.setClass(Rn, "linear"), tt.setClass(Rn, "radial");
const In = ["type", "source", "patternTransform"];
class Bn {
  get type() {
    return "pattern";
  }
  set type(zn) {
    a$1("warn", "Setting type has no effect", zn);
  }
  constructor(zn) {
    t$1(this, "repeat", "repeat"), t$1(this, "offsetX", 0), t$1(this, "offsetY", 0), t$1(this, "crossOrigin", ""), this.id = ft(), Object.assign(this, zn);
  }
  isImageSource() {
    return !!this.source && typeof this.source.src == "string";
  }
  isCanvasSource() {
    return !!this.source && !!this.source.toDataURL;
  }
  sourceToString() {
    return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : "";
  }
  toLive(zn) {
    return this.source && (!this.isImageSource() || this.source.complete && this.source.naturalWidth !== 0 && this.source.naturalHeight !== 0) ? zn.createPattern(this.source, this.repeat) : null;
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const { repeat: Un, crossOrigin: Kn } = this;
    return s$1(s$1({}, Yt(this, zn)), {}, { type: "pattern", source: this.sourceToString(), repeat: Un, crossOrigin: Kn, offsetX: Vt(this.offsetX, o$1.NUM_FRACTION_DIGITS), offsetY: Vt(this.offsetY, o$1.NUM_FRACTION_DIGITS), patternTransform: this.patternTransform ? [...this.patternTransform] : null });
  }
  toSVG(zn) {
    let { width: Un, height: Kn } = zn;
    const { source: qn, repeat: Jo, id: pa } = this, ma = Sn(this.offsetX / Un, 0), va = Sn(this.offsetY / Kn, 0), ba = Jo === "repeat-y" || Jo === "no-repeat" ? 1 + Math.abs(ma || 0) : Sn(qn.width / Un, 0), _a = Jo === "repeat-x" || Jo === "no-repeat" ? 1 + Math.abs(va || 0) : Sn(qn.height / Kn, 0);
    return ['<pattern id="SVGID_'.concat(pa, '" x="').concat(ma, '" y="').concat(va, '" width="').concat(ba, '" height="').concat(_a, '">'), '<image x="0" y="0" width="'.concat(qn.width, '" height="').concat(qn.height, '" xlink:href="').concat(this.sourceToString(), '"></image>'), "</pattern>", ""].join(`
`);
  }
  static async fromObject(zn, Un) {
    let { type: Kn, source: qn, patternTransform: Jo } = zn, pa = i$3(zn, In);
    const ma = await It(qn, s$1(s$1({}, Un), {}, { crossOrigin: pa.crossOrigin }));
    return new this(s$1(s$1({}, pa), {}, { patternTransform: Jo && Jo.slice(0), source: ma }));
  }
}
t$1(Bn, "type", "Pattern"), tt.setClass(Bn), tt.setClass(Bn, "pattern");
const Yn = ["path", "left", "top"], Wn = ["d"];
class Vn extends _i {
  constructor(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { path: Kn, left: qn, top: Jo } = Un, pa = i$3(Un, Yn);
    super(), Object.assign(this, Vn.ownDefaults), this.setOptions(pa), this._setPath(zn || [], !0), typeof qn == "number" && this.set(M$1, qn), typeof Jo == "number" && this.set(P, Jo);
  }
  _setPath(zn, Un) {
    this.path = Yr(Array.isArray(zn) ? zn : rn(zn)), this.setBoundingBox(Un);
  }
  _findCenterFromElement() {
    const zn = this._calcBoundsFromPath();
    return new ot(zn.left + zn.width / 2, zn.top + zn.height / 2);
  }
  _renderPathCommands(zn) {
    const Un = -this.pathOffset.x, Kn = -this.pathOffset.y;
    zn.beginPath();
    for (const qn of this.path) switch (qn[0]) {
      case "L":
        zn.lineTo(qn[1] + Un, qn[2] + Kn);
        break;
      case "M":
        zn.moveTo(qn[1] + Un, qn[2] + Kn);
        break;
      case "C":
        zn.bezierCurveTo(qn[1] + Un, qn[2] + Kn, qn[3] + Un, qn[4] + Kn, qn[5] + Un, qn[6] + Kn);
        break;
      case "Q":
        zn.quadraticCurveTo(qn[1] + Un, qn[2] + Kn, qn[3] + Un, qn[4] + Kn);
        break;
      case "Z":
        zn.closePath();
    }
  }
  _render(zn) {
    this._renderPathCommands(zn), this._renderPaintInOrder(zn);
  }
  toString() {
    return "#<Path (".concat(this.complexity(), '): { "top": ').concat(this.top, ', "left": ').concat(this.left, " }>");
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return s$1(s$1({}, super.toObject(zn)), {}, { path: this.path.map((Un) => Un.slice()) });
  }
  toDatalessObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const Un = this.toObject(zn);
    return this.sourcePath && (delete Un.path, Un.sourcePath = this.sourcePath), Un;
  }
  _toSVG() {
    const zn = on(this.path, o$1.NUM_FRACTION_DIGITS);
    return ["<path ", "COMMON_PARTS", 'd="'.concat(zn, `" stroke-linecap="round" />
`)];
  }
  _getOffsetTransform() {
    const zn = o$1.NUM_FRACTION_DIGITS;
    return " translate(".concat(Vt(-this.pathOffset.x, zn), ", ").concat(Vt(-this.pathOffset.y, zn), ")");
  }
  toClipPathSVG(zn) {
    const Un = this._getOffsetTransform();
    return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(), { reviver: zn, additionalTransform: Un });
  }
  toSVG(zn) {
    const Un = this._getOffsetTransform();
    return this._createBaseSVGMarkup(this._toSVG(), { reviver: zn, additionalTransform: Un });
  }
  complexity() {
    return this.path.length;
  }
  setDimensions() {
    this.setBoundingBox();
  }
  setBoundingBox(zn) {
    const { width: Un, height: Kn, pathOffset: qn } = this._calcDimensions();
    this.set({ width: Un, height: Kn, pathOffset: qn }), zn && this.setPositionByOrigin(qn, D, D);
  }
  _calcBoundsFromPath() {
    const zn = [];
    let Un = 0, Kn = 0, qn = 0, Jo = 0;
    for (const pa of this.path) switch (pa[0]) {
      case "L":
        qn = pa[1], Jo = pa[2], zn.push({ x: Un, y: Kn }, { x: qn, y: Jo });
        break;
      case "M":
        qn = pa[1], Jo = pa[2], Un = qn, Kn = Jo;
        break;
      case "C":
        zn.push(...Br(qn, Jo, pa[1], pa[2], pa[3], pa[4], pa[5], pa[6])), qn = pa[5], Jo = pa[6];
        break;
      case "Q":
        zn.push(...Br(qn, Jo, pa[1], pa[2], pa[1], pa[2], pa[3], pa[4])), qn = pa[3], Jo = pa[4];
        break;
      case "Z":
        qn = Un, Jo = Kn;
    }
    return ae(zn);
  }
  _calcDimensions() {
    const zn = this._calcBoundsFromPath();
    return s$1(s$1({}, zn), {}, { pathOffset: new ot(zn.left + zn.width / 2, zn.top + zn.height / 2) });
  }
  static fromObject(zn) {
    return this._fromObject(zn, { extraParam: "path" });
  }
  static async fromElement(zn, Un, Kn) {
    const qn = dr(zn, this.ATTRIBUTE_NAMES, Kn), { d: Jo } = qn;
    return new this(Jo, s$1(s$1(s$1({}, i$3(qn, Wn)), Un), {}, { left: void 0, top: void 0 }));
  }
}
t$1(Vn, "type", "Path"), t$1(Vn, "cacheProperties", [...ps, "path", "fillRule"]), t$1(Vn, "ATTRIBUTE_NAMES", [...Fi, "d"]), tt.setClass(Vn), tt.setSVGClass(Vn);
const Gn = ["left", "top", "radius"], Hn = ["radius", "startAngle", "endAngle", "counterClockwise"];
class Nn extends _i {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), Nn.ownDefaults);
  }
  constructor(zn) {
    super(), Object.assign(this, Nn.ownDefaults), this.setOptions(zn);
  }
  _set(zn, Un) {
    return super._set(zn, Un), zn === "radius" && this.setRadius(Un), this;
  }
  _render(zn) {
    zn.beginPath(), zn.arc(0, 0, this.radius, xt(this.startAngle), xt(this.endAngle), this.counterClockwise), this._renderPaintInOrder(zn);
  }
  getRadiusX() {
    return this.get("radius") * this.get(H);
  }
  getRadiusY() {
    return this.get("radius") * this.get(N$1);
  }
  setRadius(zn) {
    this.radius = zn, this.set({ width: 2 * zn, height: 2 * zn });
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject([...Hn, ...zn]);
  }
  _toSVG() {
    const zn = (this.endAngle - this.startAngle) % 360;
    if (zn === 0) return ["<circle ", "COMMON_PARTS", 'cx="0" cy="0" ', 'r="', "".concat(this.radius), `" />
`];
    {
      const { radius: Un } = this, Kn = xt(this.startAngle), qn = xt(this.endAngle), Jo = rt(Kn) * Un, pa = nt(Kn) * Un, ma = rt(qn) * Un, va = nt(qn) * Un, ba = zn > 180 ? 1 : 0, _a = this.counterClockwise ? 0 : 1;
      return ['<path d="M '.concat(Jo, " ").concat(pa, " A ").concat(Un, " ").concat(Un, " 0 ").concat(ba, " ").concat(_a, " ").concat(ma, " ").concat(va, '" '), "COMMON_PARTS", ` />
`];
    }
  }
  static async fromElement(zn, Un, Kn) {
    const qn = dr(zn, this.ATTRIBUTE_NAMES, Kn), { left: Jo = 0, top: pa = 0, radius: ma = 0 } = qn;
    return new this(s$1(s$1({}, i$3(qn, Gn)), {}, { radius: ma, left: Jo - ma, top: pa - ma }));
  }
  static fromObject(zn) {
    return super._fromObject(zn);
  }
}
t$1(Nn, "type", "Circle"), t$1(Nn, "cacheProperties", [...ps, ...Hn]), t$1(Nn, "ownDefaults", { radius: 0, startAngle: 0, endAngle: 360, counterClockwise: !1 }), t$1(Nn, "ATTRIBUTE_NAMES", ["cx", "cy", "r", ...Fi]), tt.setClass(Nn), tt.setSVGClass(Nn);
const Jn = ["x1", "y1", "x2", "y2"], Qn = ["x1", "y1", "x2", "y2"], Zn = ["x1", "x2", "y1", "y2"];
class $n extends _i {
  constructor() {
    let [zn, Un, Kn, qn] = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [0, 0, 0, 0], Jo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Object.assign(this, $n.ownDefaults), this.setOptions(Jo), this.x1 = zn, this.x2 = Kn, this.y1 = Un, this.y2 = qn, this._setWidthHeight();
    const { left: pa, top: ma } = Jo;
    typeof pa == "number" && this.set(M$1, pa), typeof ma == "number" && this.set(P, ma);
  }
  _setWidthHeight() {
    const { x1: zn, y1: Un, x2: Kn, y2: qn } = this;
    this.width = Math.abs(Kn - zn), this.height = Math.abs(qn - Un);
    const { left: Jo, top: pa, width: ma, height: va } = ae([{ x: zn, y: Un }, { x: Kn, y: qn }]), ba = new ot(Jo + ma / 2, pa + va / 2);
    this.setPositionByOrigin(ba, D, D);
  }
  _set(zn, Un) {
    return super._set(zn, Un), Zn.includes(zn) && this._setWidthHeight(), this;
  }
  _render(zn) {
    zn.beginPath();
    const Un = this.calcLinePoints();
    zn.moveTo(Un.x1, Un.y1), zn.lineTo(Un.x2, Un.y2), zn.lineWidth = this.strokeWidth;
    const Kn = zn.strokeStyle;
    var qn;
    Gt(this.stroke) ? zn.strokeStyle = this.stroke.toLive(zn) : zn.strokeStyle = (qn = this.stroke) !== null && qn !== void 0 ? qn : zn.fillStyle, this.stroke && this._renderStroke(zn), zn.strokeStyle = Kn;
  }
  _findCenterFromElement() {
    return new ot((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return s$1(s$1({}, super.toObject(zn)), this.calcLinePoints());
  }
  _getNonTransformedDimensions() {
    const zn = super._getNonTransformedDimensions();
    return this.strokeLineCap === "butt" && (this.width === 0 && (zn.y -= this.strokeWidth), this.height === 0 && (zn.x -= this.strokeWidth)), zn;
  }
  calcLinePoints() {
    const { x1: zn, x2: Un, y1: Kn, y2: qn, width: Jo, height: pa } = this, ma = zn <= Un ? -1 : 1, va = Kn <= qn ? -1 : 1;
    return { x1: ma * Jo / 2, x2: ma * -Jo / 2, y1: va * pa / 2, y2: va * -pa / 2 };
  }
  _toSVG() {
    const { x1: zn, x2: Un, y1: Kn, y2: qn } = this.calcLinePoints();
    return ["<line ", "COMMON_PARTS", 'x1="'.concat(zn, '" y1="').concat(Kn, '" x2="').concat(Un, '" y2="').concat(qn, `" />
`)];
  }
  static async fromElement(zn, Un, Kn) {
    const qn = dr(zn, this.ATTRIBUTE_NAMES, Kn), { x1: Jo = 0, y1: pa = 0, x2: ma = 0, y2: va = 0 } = qn;
    return new this([Jo, pa, ma, va], i$3(qn, Jn));
  }
  static fromObject(zn) {
    let { x1: Un, y1: Kn, x2: qn, y2: Jo } = zn, pa = i$3(zn, Qn);
    return this._fromObject(s$1(s$1({}, pa), {}, { points: [Un, Kn, qn, Jo] }), { extraParam: "points" });
  }
}
t$1($n, "type", "Line"), t$1($n, "cacheProperties", [...ps, ...Zn]), t$1($n, "ATTRIBUTE_NAMES", Fi.concat(Zn)), tt.setClass($n), tt.setSVGClass($n);
let to$1 = class E1 extends _i {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), E1.ownDefaults);
  }
  constructor(zn) {
    super(), Object.assign(this, E1.ownDefaults), this.setOptions(zn);
  }
  _render(zn) {
    const Un = this.width / 2, Kn = this.height / 2;
    zn.beginPath(), zn.moveTo(-Un, Kn), zn.lineTo(0, -Kn), zn.lineTo(Un, Kn), zn.closePath(), this._renderPaintInOrder(zn);
  }
  _toSVG() {
    const zn = this.width / 2, Un = this.height / 2;
    return ["<polygon ", "COMMON_PARTS", 'points="', "".concat(-zn, " ").concat(Un, ",0 ").concat(-Un, ",").concat(zn, " ").concat(Un), '" />'];
  }
};
t$1(to$1, "type", "Triangle"), t$1(to$1, "ownDefaults", { width: 100, height: 100 }), tt.setClass(to$1), tt.setSVGClass(to$1);
const eo = ["rx", "ry"];
class so extends _i {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), so.ownDefaults);
  }
  constructor(zn) {
    super(), Object.assign(this, so.ownDefaults), this.setOptions(zn);
  }
  _set(zn, Un) {
    switch (super._set(zn, Un), zn) {
      case "rx":
        this.rx = Un, this.set("width", 2 * Un);
        break;
      case "ry":
        this.ry = Un, this.set("height", 2 * Un);
    }
    return this;
  }
  getRx() {
    return this.get("rx") * this.get(H);
  }
  getRy() {
    return this.get("ry") * this.get(N$1);
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject([...eo, ...zn]);
  }
  _toSVG() {
    return ["<ellipse ", "COMMON_PARTS", 'cx="0" cy="0" rx="'.concat(this.rx, '" ry="').concat(this.ry, `" />
`)];
  }
  _render(zn) {
    zn.beginPath(), zn.save(), zn.transform(1, 0, 0, this.ry / this.rx, 0, 0), zn.arc(0, 0, this.rx, 0, w, !1), zn.restore(), this._renderPaintInOrder(zn);
  }
  static async fromElement(zn, Un, Kn) {
    const qn = dr(zn, this.ATTRIBUTE_NAMES, Kn);
    return qn.left = (qn.left || 0) - qn.rx, qn.top = (qn.top || 0) - qn.ry, new this(qn);
  }
}
function io(Xn) {
  if (!Xn) return [];
  const zn = Xn.replace(/,/g, " ").trim().split(/\s+/), Un = [];
  for (let Kn = 0; Kn < zn.length; Kn += 2) Un.push({ x: parseFloat(zn[Kn]), y: parseFloat(zn[Kn + 1]) });
  return Un;
}
t$1(so, "type", "Ellipse"), t$1(so, "cacheProperties", [...ps, ...eo]), t$1(so, "ownDefaults", { rx: 0, ry: 0 }), t$1(so, "ATTRIBUTE_NAMES", [...Fi, "cx", "cy", "rx", "ry"]), tt.setClass(so), tt.setSVGClass(so);
const ro = ["left", "top"], no = { exactBoundingBox: !1 };
class oo extends _i {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), oo.ownDefaults);
  }
  constructor() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), t$1(this, "strokeDiff", void 0), Object.assign(this, oo.ownDefaults), this.setOptions(Un), this.points = zn;
    const { left: Kn, top: qn } = Un;
    this.initialized = !0, this.setBoundingBox(!0), typeof Kn == "number" && this.set(M$1, Kn), typeof qn == "number" && this.set(P, qn);
  }
  isOpen() {
    return !0;
  }
  _projectStrokeOnPoints(zn) {
    return Ti(this.points, zn, this.isOpen());
  }
  _calcDimensions(zn) {
    zn = s$1({ scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, strokeLineCap: this.strokeLineCap, strokeLineJoin: this.strokeLineJoin, strokeMiterLimit: this.strokeMiterLimit, strokeUniform: this.strokeUniform, strokeWidth: this.strokeWidth }, zn || {});
    const Un = this.exactBoundingBox ? this._projectStrokeOnPoints(zn).map((ba) => ba.projectedPoint) : this.points;
    if (Un.length === 0) return { left: 0, top: 0, width: 0, height: 0, pathOffset: new ot(), strokeOffset: new ot(), strokeDiff: new ot() };
    const Kn = ae(Un), qn = Lt(s$1(s$1({}, zn), {}, { scaleX: 1, scaleY: 1 })), Jo = ae(this.points.map((ba) => wt(ba, qn, !0))), pa = new ot(this.scaleX, this.scaleY);
    let ma = Kn.left + Kn.width / 2, va = Kn.top + Kn.height / 2;
    return this.exactBoundingBox && (ma -= va * Math.tan(xt(this.skewX)), va -= ma * Math.tan(xt(this.skewY))), s$1(s$1({}, Kn), {}, { pathOffset: new ot(ma, va), strokeOffset: new ot(Jo.left, Jo.top).subtract(new ot(Kn.left, Kn.top)).multiply(pa), strokeDiff: new ot(Kn.width, Kn.height).subtract(new ot(Jo.width, Jo.height)).multiply(pa) });
  }
  _findCenterFromElement() {
    const zn = ae(this.points);
    return new ot(zn.left + zn.width / 2, zn.top + zn.height / 2);
  }
  setDimensions() {
    this.setBoundingBox();
  }
  setBoundingBox(zn) {
    const { left: Un, top: Kn, width: qn, height: Jo, pathOffset: pa, strokeOffset: ma, strokeDiff: va } = this._calcDimensions();
    this.set({ width: qn, height: Jo, pathOffset: pa, strokeOffset: ma, strokeDiff: va }), zn && this.setPositionByOrigin(new ot(Un + qn / 2, Kn + Jo / 2), D, D);
  }
  isStrokeAccountedForInDimensions() {
    return this.exactBoundingBox;
  }
  _getNonTransformedDimensions() {
    return this.exactBoundingBox ? new ot(this.width, this.height) : super._getNonTransformedDimensions();
  }
  _getTransformedDimensions() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (this.exactBoundingBox) {
      let pa;
      if (Object.keys(zn).some((ma) => this.strokeUniform || this.constructor.layoutProperties.includes(ma))) {
        var Un, Kn;
        const { width: ma, height: va } = this._calcDimensions(zn);
        pa = new ot((Un = zn.width) !== null && Un !== void 0 ? Un : ma, (Kn = zn.height) !== null && Kn !== void 0 ? Kn : va);
      } else {
        var qn, Jo;
        pa = new ot((qn = zn.width) !== null && qn !== void 0 ? qn : this.width, (Jo = zn.height) !== null && Jo !== void 0 ? Jo : this.height);
      }
      return pa.multiply(new ot(zn.scaleX || this.scaleX, zn.scaleY || this.scaleY));
    }
    return super._getTransformedDimensions(zn);
  }
  _set(zn, Un) {
    const Kn = this.initialized && this[zn] !== Un, qn = super._set(zn, Un);
    return this.exactBoundingBox && Kn && ((zn === H || zn === N$1) && this.strokeUniform && this.constructor.layoutProperties.includes("strokeUniform") || this.constructor.layoutProperties.includes(zn)) && this.setDimensions(), qn;
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return s$1(s$1({}, super.toObject(zn)), {}, { points: this.points.map((Un) => {
      let { x: Kn, y: qn } = Un;
      return { x: Kn, y: qn };
    }) });
  }
  _toSVG() {
    const zn = [], Un = this.pathOffset.x, Kn = this.pathOffset.y, qn = o$1.NUM_FRACTION_DIGITS;
    for (let Jo = 0, pa = this.points.length; Jo < pa; Jo++) zn.push(Vt(this.points[Jo].x - Un, qn), ",", Vt(this.points[Jo].y - Kn, qn), " ");
    return ["<".concat(this.constructor.type.toLowerCase(), " "), "COMMON_PARTS", 'points="'.concat(zn.join(""), `" />
`)];
  }
  _render(zn) {
    const Un = this.points.length, Kn = this.pathOffset.x, qn = this.pathOffset.y;
    if (Un && !isNaN(this.points[Un - 1].y)) {
      zn.beginPath(), zn.moveTo(this.points[0].x - Kn, this.points[0].y - qn);
      for (let Jo = 0; Jo < Un; Jo++) {
        const pa = this.points[Jo];
        zn.lineTo(pa.x - Kn, pa.y - qn);
      }
      !this.isOpen() && zn.closePath(), this._renderPaintInOrder(zn);
    }
  }
  complexity() {
    return this.points.length;
  }
  static async fromElement(zn, Un, Kn) {
    return new this(io(zn.getAttribute("points")), s$1(s$1({}, i$3(dr(zn, this.ATTRIBUTE_NAMES, Kn), ro)), Un));
  }
  static fromObject(zn) {
    return this._fromObject(zn, { extraParam: "points" });
  }
}
t$1(oo, "ownDefaults", no), t$1(oo, "type", "Polyline"), t$1(oo, "layoutProperties", [U, q, "strokeLineCap", "strokeLineJoin", "strokeMiterLimit", "strokeWidth", "strokeUniform", "points"]), t$1(oo, "cacheProperties", [...ps, "points"]), t$1(oo, "ATTRIBUTE_NAMES", [...Fi]), tt.setClass(oo), tt.setSVGClass(oo);
class ao extends oo {
  isOpen() {
    return !1;
  }
}
t$1(ao, "ownDefaults", no), t$1(ao, "type", "Polygon"), tt.setClass(ao), tt.setSVGClass(ao);
const ho = ["fontSize", "fontWeight", "fontFamily", "fontStyle"], co = ["underline", "overline", "linethrough"], lo = [...ho, "lineHeight", "text", "charSpacing", "textAlign", "styles", "path", "pathStartOffset", "pathSide", "pathAlign"], uo = [...lo, ...co, "textBackgroundColor", "direction"], go = [...ho, ...co, J, "strokeWidth", K, "deltaY", "textBackgroundColor"], fo = { _reNewline: F, _reSpacesAndTabs: /[ \t\r]/g, _reSpaceAndTab: /[ \t\r]/, _reWords: /\S+/g, fontSize: 40, fontWeight: "normal", fontFamily: "Times New Roman", underline: !1, overline: !1, linethrough: !1, textAlign: M$1, fontStyle: "normal", lineHeight: 1.16, superscript: { size: 0.6, baseline: -0.35 }, subscript: { size: 0.6, baseline: 0.11 }, textBackgroundColor: "", stroke: null, shadow: null, path: void 0, pathStartOffset: 0, pathSide: M$1, pathAlign: "baseline", _fontSizeFraction: 0.222, offsets: { underline: 0.1, linethrough: -0.315, overline: -0.88 }, _fontSizeMult: 1.13, charSpacing: 0, deltaY: 0, direction: "ltr", CACHE_FONT_SIZE: 400, MIN_TEXT_WIDTH: 2 }, po = "justify", mo = "justify-left", vo = "justify-right", yo = "justify-center";
class _o extends _i {
  isEmptyStyles(zn) {
    if (!this.styles || zn !== void 0 && !this.styles[zn]) return !0;
    const Un = zn === void 0 ? this.styles : { line: this.styles[zn] };
    for (const Kn in Un) for (const qn in Un[Kn]) for (const Jo in Un[Kn][qn]) return !1;
    return !0;
  }
  styleHas(zn, Un) {
    if (!this.styles || Un !== void 0 && !this.styles[Un]) return !1;
    const Kn = Un === void 0 ? this.styles : { 0: this.styles[Un] };
    for (const qn in Kn) for (const Jo in Kn[qn]) if (Kn[qn][Jo][zn] !== void 0) return !0;
    return !1;
  }
  cleanStyle(zn) {
    if (!this.styles) return !1;
    const Un = this.styles;
    let Kn, qn, Jo = 0, pa = !0, ma = 0;
    for (const va in Un) {
      Kn = 0;
      for (const ba in Un[va]) {
        const _a = Un[va][ba] || {};
        Jo++, _a[zn] !== void 0 ? (qn ? _a[zn] !== qn && (pa = !1) : qn = _a[zn], _a[zn] === this[zn] && delete _a[zn]) : pa = !1, Object.keys(_a).length !== 0 ? Kn++ : delete Un[va][ba];
      }
      Kn === 0 && delete Un[va];
    }
    for (let va = 0; va < this._textLines.length; va++) ma += this._textLines[va].length;
    pa && Jo === ma && (this[zn] = qn, this.removeStyle(zn));
  }
  removeStyle(zn) {
    if (!this.styles) return;
    const Un = this.styles;
    let Kn, qn, Jo;
    for (qn in Un) {
      for (Jo in Kn = Un[qn], Kn) delete Kn[Jo][zn], Object.keys(Kn[Jo]).length === 0 && delete Kn[Jo];
      Object.keys(Kn).length === 0 && delete Un[qn];
    }
  }
  _extendStyles(zn, Un) {
    const { lineIndex: Kn, charIndex: qn } = this.get2DCursorLocation(zn);
    this._getLineStyle(Kn) || this._setLineStyle(Kn);
    const Jo = Wt(s$1(s$1({}, this._getStyleDeclaration(Kn, qn)), Un), (pa) => pa !== void 0);
    this._setStyleDeclaration(Kn, qn, Jo);
  }
  getSelectionStyles(zn, Un, Kn) {
    const qn = [];
    for (let Jo = zn; Jo < (Un || zn); Jo++) qn.push(this.getStyleAtPosition(Jo, Kn));
    return qn;
  }
  getStyleAtPosition(zn, Un) {
    const { lineIndex: Kn, charIndex: qn } = this.get2DCursorLocation(zn);
    return Un ? this.getCompleteStyleDeclaration(Kn, qn) : this._getStyleDeclaration(Kn, qn);
  }
  setSelectionStyles(zn, Un, Kn) {
    for (let qn = Un; qn < (Kn || Un); qn++) this._extendStyles(qn, zn);
    this._forceClearCache = !0;
  }
  _getStyleDeclaration(zn, Un) {
    var Kn;
    const qn = this.styles && this.styles[zn];
    return qn && (Kn = qn[Un]) !== null && Kn !== void 0 ? Kn : {};
  }
  getCompleteStyleDeclaration(zn, Un) {
    return s$1(s$1({}, Yt(this, this.constructor._styleProperties)), this._getStyleDeclaration(zn, Un));
  }
  _setStyleDeclaration(zn, Un, Kn) {
    this.styles[zn][Un] = Kn;
  }
  _deleteStyleDeclaration(zn, Un) {
    delete this.styles[zn][Un];
  }
  _getLineStyle(zn) {
    return !!this.styles[zn];
  }
  _setLineStyle(zn) {
    this.styles[zn] = {};
  }
  _deleteLineStyle(zn) {
    delete this.styles[zn];
  }
}
t$1(_o, "_styleProperties", go);
const xo = /  +/g, Co = /"/g;
function bo(Xn, zn, Un, Kn, qn) {
  return "		".concat(function(Jo, pa) {
    let { left: ma, top: va, width: ba, height: _a } = pa, ya = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : o$1.NUM_FRACTION_DIGITS;
    const xa = Be(K, Jo, !1), [wa, Ta, Sa, Ma] = [ma, va, ba, _a].map((ka) => Vt(ka, ya));
    return "<rect ".concat(xa, ' x="').concat(wa, '" y="').concat(Ta, '" width="').concat(Sa, '" height="').concat(Ma, '"></rect>');
  }(Xn, { left: zn, top: Un, width: Kn, height: qn }), `
`);
}
const wo = ["textAnchor", "textDecoration", "dx", "dy", "top", "left", "fontSize", "strokeWidth"];
let So;
class To extends _o {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), To.ownDefaults);
  }
  constructor(zn, Un) {
    super(), t$1(this, "__charBounds", []), Object.assign(this, To.ownDefaults), this.setOptions(Un), this.styles || (this.styles = {}), this.text = zn, this.initialized = !0, this.path && this.setPathInfo(), this.initDimensions(), this.setCoords();
  }
  setPathInfo() {
    const zn = this.path;
    zn && (zn.segmentsInfo = Qr(zn.path));
  }
  _splitText() {
    const zn = this._splitTextIntoLines(this.text);
    return this.textLines = zn.lines, this._textLines = zn.graphemeLines, this._unwrappedTextLines = zn._unwrappedLines, this._text = zn.graphemeText, zn;
  }
  initDimensions() {
    this._splitText(), this._clearCache(), this.dirty = !0, this.path ? (this.width = this.path.width, this.height = this.path.height) : (this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH, this.height = this.calcTextHeight()), this.textAlign.includes(po) && this.enlargeSpaces();
  }
  enlargeSpaces() {
    let zn, Un, Kn, qn, Jo, pa, ma;
    for (let va = 0, ba = this._textLines.length; va < ba; va++) if ((this.textAlign === po || va !== ba - 1 && !this.isEndOfWrapping(va)) && (qn = 0, Jo = this._textLines[va], Un = this.getLineWidth(va), Un < this.width && (ma = this.textLines[va].match(this._reSpacesAndTabs)))) {
      Kn = ma.length, zn = (this.width - Un) / Kn;
      for (let _a = 0; _a <= Jo.length; _a++) pa = this.__charBounds[va][_a], this._reSpaceAndTab.test(Jo[_a]) ? (pa.width += zn, pa.kernedWidth += zn, pa.left += qn, qn += zn) : pa.left += qn;
    }
  }
  isEndOfWrapping(zn) {
    return zn === this._textLines.length - 1;
  }
  missingNewlineOffset(zn) {
    return 1;
  }
  get2DCursorLocation(zn, Un) {
    const Kn = Un ? this._unwrappedTextLines : this._textLines;
    let qn;
    for (qn = 0; qn < Kn.length; qn++) {
      if (zn <= Kn[qn].length) return { lineIndex: qn, charIndex: zn };
      zn -= Kn[qn].length + this.missingNewlineOffset(qn, Un);
    }
    return { lineIndex: qn - 1, charIndex: Kn[qn - 1].length < zn ? Kn[qn - 1].length : zn };
  }
  toString() {
    return "#<Text (".concat(this.complexity(), '): { "text": "').concat(this.text, '", "fontFamily": "').concat(this.fontFamily, '" }>');
  }
  _getCacheCanvasDimensions() {
    const zn = super._getCacheCanvasDimensions(), Un = this.fontSize;
    return zn.width += Un * zn.zoomX, zn.height += Un * zn.zoomY, zn;
  }
  _render(zn) {
    const Un = this.path;
    Un && !Un.isNotVisible() && Un._render(zn), this._setTextStyles(zn), this._renderTextLinesBackground(zn), this._renderTextDecoration(zn, "underline"), this._renderText(zn), this._renderTextDecoration(zn, "overline"), this._renderTextDecoration(zn, "linethrough");
  }
  _renderText(zn) {
    this.paintFirst === J ? (this._renderTextStroke(zn), this._renderTextFill(zn)) : (this._renderTextFill(zn), this._renderTextStroke(zn));
  }
  _setTextStyles(zn, Un, Kn) {
    if (zn.textBaseline = "alphabetic", this.path) switch (this.pathAlign) {
      case D:
        zn.textBaseline = "middle";
        break;
      case "ascender":
        zn.textBaseline = P;
        break;
      case "descender":
        zn.textBaseline = E$1;
    }
    zn.font = this._getFontDeclaration(Un, Kn);
  }
  calcTextWidth() {
    let zn = this.getLineWidth(0);
    for (let Un = 1, Kn = this._textLines.length; Un < Kn; Un++) {
      const qn = this.getLineWidth(Un);
      qn > zn && (zn = qn);
    }
    return zn;
  }
  _renderTextLine(zn, Un, Kn, qn, Jo, pa) {
    this._renderChars(zn, Un, Kn, qn, Jo, pa);
  }
  _renderTextLinesBackground(zn) {
    if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor")) return;
    const Un = zn.fillStyle, Kn = this._getLeftOffset();
    let qn = this._getTopOffset();
    for (let Jo = 0, pa = this._textLines.length; Jo < pa; Jo++) {
      const ma = this.getHeightOfLine(Jo);
      if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor", Jo)) {
        qn += ma;
        continue;
      }
      const va = this._textLines[Jo].length, ba = this._getLineLeftOffset(Jo);
      let _a, ya, xa = 0, wa = 0, Ta = this.getValueOfPropertyAt(Jo, 0, "textBackgroundColor");
      for (let Sa = 0; Sa < va; Sa++) {
        const Ma = this.__charBounds[Jo][Sa];
        ya = this.getValueOfPropertyAt(Jo, Sa, "textBackgroundColor"), this.path ? (zn.save(), zn.translate(Ma.renderLeft, Ma.renderTop), zn.rotate(Ma.angle), zn.fillStyle = ya, ya && zn.fillRect(-Ma.width / 2, -ma / this.lineHeight * (1 - this._fontSizeFraction), Ma.width, ma / this.lineHeight), zn.restore()) : ya !== Ta ? (_a = Kn + ba + wa, this.direction === "rtl" && (_a = this.width - _a - xa), zn.fillStyle = Ta, Ta && zn.fillRect(_a, qn, xa, ma / this.lineHeight), wa = Ma.left, xa = Ma.width, Ta = ya) : xa += Ma.kernedWidth;
      }
      ya && !this.path && (_a = Kn + ba + wa, this.direction === "rtl" && (_a = this.width - _a - xa), zn.fillStyle = ya, zn.fillRect(_a, qn, xa, ma / this.lineHeight)), qn += ma;
    }
    zn.fillStyle = Un, this._removeShadow(zn);
  }
  _measureChar(zn, Un, Kn, qn) {
    const Jo = _$1.getFontCache(Un), pa = this._getFontDeclaration(Un), ma = Kn + zn, va = Kn && pa === this._getFontDeclaration(qn), ba = Un.fontSize / this.CACHE_FONT_SIZE;
    let _a, ya, xa, wa;
    if (Kn && Jo[Kn] !== void 0 && (xa = Jo[Kn]), Jo[zn] !== void 0 && (wa = _a = Jo[zn]), va && Jo[ma] !== void 0 && (ya = Jo[ma], wa = ya - xa), _a === void 0 || xa === void 0 || ya === void 0) {
      const Ta = function() {
        return So || (So = vt({ width: 0, height: 0 }).getContext("2d")), So;
      }();
      this._setTextStyles(Ta, Un, !0), _a === void 0 && (wa = _a = Ta.measureText(zn).width, Jo[zn] = _a), xa === void 0 && va && Kn && (xa = Ta.measureText(Kn).width, Jo[Kn] = xa), va && ya === void 0 && (ya = Ta.measureText(ma).width, Jo[ma] = ya, wa = ya - xa);
    }
    return { width: _a * ba, kernedWidth: wa * ba };
  }
  getHeightOfChar(zn, Un) {
    return this.getValueOfPropertyAt(zn, Un, "fontSize");
  }
  measureLine(zn) {
    const Un = this._measureLine(zn);
    return this.charSpacing !== 0 && (Un.width -= this._getWidthOfCharSpacing()), Un.width < 0 && (Un.width = 0), Un;
  }
  _measureLine(zn) {
    let Un, Kn, qn = 0;
    const Jo = this.pathSide === A$1, pa = this.path, ma = this._textLines[zn], va = ma.length, ba = new Array(va);
    this.__charBounds[zn] = ba;
    for (let _a = 0; _a < va; _a++) {
      const ya = ma[_a];
      Kn = this._getGraphemeBox(ya, zn, _a, Un), ba[_a] = Kn, qn += Kn.kernedWidth, Un = ya;
    }
    if (ba[va] = { left: Kn ? Kn.left + Kn.width : 0, width: 0, kernedWidth: 0, height: this.fontSize, deltaY: 0 }, pa && pa.segmentsInfo) {
      let _a = 0;
      const ya = pa.segmentsInfo[pa.segmentsInfo.length - 1].length;
      switch (this.textAlign) {
        case M$1:
          _a = Jo ? ya - qn : 0;
          break;
        case D:
          _a = (ya - qn) / 2;
          break;
        case A$1:
          _a = Jo ? 0 : ya - qn;
      }
      _a += this.pathStartOffset * (Jo ? -1 : 1);
      for (let xa = Jo ? va - 1 : 0; Jo ? xa >= 0 : xa < va; Jo ? xa-- : xa++) Kn = ba[xa], _a > ya ? _a %= ya : _a < 0 && (_a += ya), this._setGraphemeOnPath(_a, Kn), _a += Kn.kernedWidth;
    }
    return { width: qn, numOfSpaces: 0 };
  }
  _setGraphemeOnPath(zn, Un) {
    const Kn = zn + Un.kernedWidth / 2, qn = this.path, Jo = Zr(qn.path, Kn, qn.segmentsInfo);
    Un.renderLeft = Jo.x - qn.pathOffset.x, Un.renderTop = Jo.y - qn.pathOffset.y, Un.angle = Jo.angle + (this.pathSide === A$1 ? Math.PI : 0);
  }
  _getGraphemeBox(zn, Un, Kn, qn, Jo) {
    const pa = this.getCompleteStyleDeclaration(Un, Kn), ma = qn ? this.getCompleteStyleDeclaration(Un, Kn - 1) : {}, va = this._measureChar(zn, pa, qn, ma);
    let ba, _a = va.kernedWidth, ya = va.width;
    this.charSpacing !== 0 && (ba = this._getWidthOfCharSpacing(), ya += ba, _a += ba);
    const xa = { width: ya, left: 0, height: pa.fontSize, kernedWidth: _a, deltaY: pa.deltaY };
    if (Kn > 0 && !Jo) {
      const wa = this.__charBounds[Un][Kn - 1];
      xa.left = wa.left + wa.width + va.kernedWidth - va.width;
    }
    return xa;
  }
  getHeightOfLine(zn) {
    if (this.__lineHeights[zn]) return this.__lineHeights[zn];
    let Un = this.getHeightOfChar(zn, 0);
    for (let Kn = 1, qn = this._textLines[zn].length; Kn < qn; Kn++) Un = Math.max(this.getHeightOfChar(zn, Kn), Un);
    return this.__lineHeights[zn] = Un * this.lineHeight * this._fontSizeMult;
  }
  calcTextHeight() {
    let zn, Un = 0;
    for (let Kn = 0, qn = this._textLines.length; Kn < qn; Kn++) zn = this.getHeightOfLine(Kn), Un += Kn === qn - 1 ? zn / this.lineHeight : zn;
    return Un;
  }
  _getLeftOffset() {
    return this.direction === "ltr" ? -this.width / 2 : this.width / 2;
  }
  _getTopOffset() {
    return -this.height / 2;
  }
  _renderTextCommon(zn, Un) {
    zn.save();
    let Kn = 0;
    const qn = this._getLeftOffset(), Jo = this._getTopOffset();
    for (let pa = 0, ma = this._textLines.length; pa < ma; pa++) {
      const va = this.getHeightOfLine(pa), ba = va / this.lineHeight, _a = this._getLineLeftOffset(pa);
      this._renderTextLine(Un, zn, this._textLines[pa], qn + _a, Jo + Kn + ba, pa), Kn += va;
    }
    zn.restore();
  }
  _renderTextFill(zn) {
    (this.fill || this.styleHas(K)) && this._renderTextCommon(zn, "fillText");
  }
  _renderTextStroke(zn) {
    (this.stroke && this.strokeWidth !== 0 || !this.isEmptyStyles()) && (this.shadow && !this.shadow.affectStroke && this._removeShadow(zn), zn.save(), this._setLineDash(zn, this.strokeDashArray), zn.beginPath(), this._renderTextCommon(zn, "strokeText"), zn.closePath(), zn.restore());
  }
  _renderChars(zn, Un, Kn, qn, Jo, pa) {
    const ma = this.getHeightOfLine(pa), va = this.textAlign.includes(po), ba = this.path, _a = !va && this.charSpacing === 0 && this.isEmptyStyles(pa) && !ba, ya = this.direction === "ltr", xa = this.direction === "ltr" ? 1 : -1, wa = Un.direction;
    let Ta, Sa, Ma, ka, Za, Na = "", Ka = 0;
    if (Un.save(), wa !== this.direction && (Un.canvas.setAttribute("dir", ya ? "ltr" : "rtl"), Un.direction = ya ? "ltr" : "rtl", Un.textAlign = ya ? M$1 : A$1), Jo -= ma * this._fontSizeFraction / this.lineHeight, _a) return this._renderChar(zn, Un, pa, 0, Kn.join(""), qn, Jo), void Un.restore();
    for (let Ja = 0, el = Kn.length - 1; Ja <= el; Ja++) ka = Ja === el || this.charSpacing || ba, Na += Kn[Ja], Ma = this.__charBounds[pa][Ja], Ka === 0 ? (qn += xa * (Ma.kernedWidth - Ma.width), Ka += Ma.width) : Ka += Ma.kernedWidth, va && !ka && this._reSpaceAndTab.test(Kn[Ja]) && (ka = !0), ka || (Ta = Ta || this.getCompleteStyleDeclaration(pa, Ja), Sa = this.getCompleteStyleDeclaration(pa, Ja + 1), ka = Ei(Ta, Sa, !1)), ka && (ba ? (Un.save(), Un.translate(Ma.renderLeft, Ma.renderTop), Un.rotate(Ma.angle), this._renderChar(zn, Un, pa, Ja, Na, -Ka / 2, 0), Un.restore()) : (Za = qn, this._renderChar(zn, Un, pa, Ja, Na, Za, Jo)), Na = "", Ta = Sa, qn += xa * Ka, Ka = 0);
    Un.restore();
  }
  _applyPatternGradientTransformText(zn) {
    const Un = this.width + this.strokeWidth, Kn = this.height + this.strokeWidth, qn = vt({ width: Un, height: Kn }), Jo = qn.getContext("2d");
    return qn.width = Un, qn.height = Kn, Jo.beginPath(), Jo.moveTo(0, 0), Jo.lineTo(Un, 0), Jo.lineTo(Un, Kn), Jo.lineTo(0, Kn), Jo.closePath(), Jo.translate(Un / 2, Kn / 2), Jo.fillStyle = zn.toLive(Jo), this._applyPatternGradientTransform(Jo, zn), Jo.fill(), Jo.createPattern(qn, "no-repeat");
  }
  handleFiller(zn, Un, Kn) {
    let qn, Jo;
    return Gt(Kn) ? Kn.gradientUnits === "percentage" || Kn.gradientTransform || Kn.patternTransform ? (qn = -this.width / 2, Jo = -this.height / 2, zn.translate(qn, Jo), zn[Un] = this._applyPatternGradientTransformText(Kn), { offsetX: qn, offsetY: Jo }) : (zn[Un] = Kn.toLive(zn), this._applyPatternGradientTransform(zn, Kn)) : (zn[Un] = Kn, { offsetX: 0, offsetY: 0 });
  }
  _setStrokeStyles(zn, Un) {
    let { stroke: Kn, strokeWidth: qn } = Un;
    return zn.lineWidth = qn, zn.lineCap = this.strokeLineCap, zn.lineDashOffset = this.strokeDashOffset, zn.lineJoin = this.strokeLineJoin, zn.miterLimit = this.strokeMiterLimit, this.handleFiller(zn, "strokeStyle", Kn);
  }
  _setFillStyles(zn, Un) {
    let { fill: Kn } = Un;
    return this.handleFiller(zn, "fillStyle", Kn);
  }
  _renderChar(zn, Un, Kn, qn, Jo, pa, ma) {
    const va = this._getStyleDeclaration(Kn, qn), ba = this.getCompleteStyleDeclaration(Kn, qn), _a = zn === "fillText" && ba.fill, ya = zn === "strokeText" && ba.stroke && ba.strokeWidth;
    if (ya || _a) {
      if (Un.save(), Un.font = this._getFontDeclaration(ba), va.textBackgroundColor && this._removeShadow(Un), va.deltaY && (ma += va.deltaY), _a) {
        const xa = this._setFillStyles(Un, ba);
        Un.fillText(Jo, pa - xa.offsetX, ma - xa.offsetY);
      }
      if (ya) {
        const xa = this._setStrokeStyles(Un, ba);
        Un.strokeText(Jo, pa - xa.offsetX, ma - xa.offsetY);
      }
      Un.restore();
    }
  }
  setSuperscript(zn, Un) {
    this._setScript(zn, Un, this.superscript);
  }
  setSubscript(zn, Un) {
    this._setScript(zn, Un, this.subscript);
  }
  _setScript(zn, Un, Kn) {
    const qn = this.get2DCursorLocation(zn, !0), Jo = this.getValueOfPropertyAt(qn.lineIndex, qn.charIndex, "fontSize"), pa = this.getValueOfPropertyAt(qn.lineIndex, qn.charIndex, "deltaY"), ma = { fontSize: Jo * Kn.size, deltaY: pa + Jo * Kn.baseline };
    this.setSelectionStyles(ma, zn, Un);
  }
  _getLineLeftOffset(zn) {
    const Un = this.getLineWidth(zn), Kn = this.width - Un, qn = this.textAlign, Jo = this.direction, pa = this.isEndOfWrapping(zn);
    let ma = 0;
    return qn === po || qn === yo && !pa || qn === vo && !pa || qn === mo && !pa ? 0 : (qn === D && (ma = Kn / 2), qn === A$1 && (ma = Kn), qn === yo && (ma = Kn / 2), qn === vo && (ma = Kn), Jo === "rtl" && (qn === A$1 || qn === po || qn === vo ? ma = 0 : qn === M$1 || qn === mo ? ma = -Kn : qn !== D && qn !== yo || (ma = -Kn / 2)), ma);
  }
  _clearCache() {
    this._forceClearCache = !1, this.__lineWidths = [], this.__lineHeights = [], this.__charBounds = [];
  }
  getLineWidth(zn) {
    if (this.__lineWidths[zn] !== void 0) return this.__lineWidths[zn];
    const { width: Un } = this.measureLine(zn);
    return this.__lineWidths[zn] = Un, Un;
  }
  _getWidthOfCharSpacing() {
    return this.charSpacing !== 0 ? this.fontSize * this.charSpacing / 1e3 : 0;
  }
  getValueOfPropertyAt(zn, Un, Kn) {
    var qn;
    return (qn = this._getStyleDeclaration(zn, Un)[Kn]) !== null && qn !== void 0 ? qn : this[Kn];
  }
  _renderTextDecoration(zn, Un) {
    if (!this[Un] && !this.styleHas(Un)) return;
    let Kn = this._getTopOffset();
    const qn = this._getLeftOffset(), Jo = this.path, pa = this._getWidthOfCharSpacing(), ma = this.offsets[Un];
    for (let va = 0, ba = this._textLines.length; va < ba; va++) {
      const _a = this.getHeightOfLine(va);
      if (!this[Un] && !this.styleHas(Un, va)) {
        Kn += _a;
        continue;
      }
      const ya = this._textLines[va], xa = _a / this.lineHeight, wa = this._getLineLeftOffset(va);
      let Ta, Sa, Ma = 0, ka = 0, Za = this.getValueOfPropertyAt(va, 0, Un), Na = this.getValueOfPropertyAt(va, 0, K);
      const Ka = Kn + xa * (1 - this._fontSizeFraction);
      let Ja = this.getHeightOfChar(va, 0), el = this.getValueOfPropertyAt(va, 0, "deltaY");
      for (let tl = 0, Qa = ya.length; tl < Qa; tl++) {
        const nl = this.__charBounds[va][tl];
        Ta = this.getValueOfPropertyAt(va, tl, Un), Sa = this.getValueOfPropertyAt(va, tl, K);
        const rl = this.getHeightOfChar(va, tl), il = this.getValueOfPropertyAt(va, tl, "deltaY");
        if (Jo && Ta && Sa) zn.save(), zn.fillStyle = Na, zn.translate(nl.renderLeft, nl.renderTop), zn.rotate(nl.angle), zn.fillRect(-nl.kernedWidth / 2, ma * rl + il, nl.kernedWidth, this.fontSize / 15), zn.restore();
        else if ((Ta !== Za || Sa !== Na || rl !== Ja || il !== el) && ka > 0) {
          let cl = qn + wa + Ma;
          this.direction === "rtl" && (cl = this.width - cl - ka), Za && Na && (zn.fillStyle = Na, zn.fillRect(cl, Ka + ma * Ja + el, ka, this.fontSize / 15)), Ma = nl.left, ka = nl.width, Za = Ta, Na = Sa, Ja = rl, el = il;
        } else ka += nl.kernedWidth;
      }
      let qa = qn + wa + Ma;
      this.direction === "rtl" && (qa = this.width - qa - ka), zn.fillStyle = Sa, Ta && Sa && zn.fillRect(qa, Ka + ma * Ja + el, ka - pa, this.fontSize / 15), Kn += _a;
    }
    this._removeShadow(zn);
  }
  _getFontDeclaration() {
    let { fontFamily: zn = this.fontFamily, fontStyle: Un = this.fontStyle, fontWeight: Kn = this.fontWeight, fontSize: qn = this.fontSize } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Jo = arguments.length > 1 ? arguments[1] : void 0;
    const pa = zn.includes("'") || zn.includes('"') || zn.includes(",") || To.genericFonts.includes(zn.toLowerCase()) ? zn : '"'.concat(zn, '"');
    return [Un, Kn, "".concat(Jo ? this.CACHE_FONT_SIZE : qn, "px"), pa].join(" ");
  }
  render(zn) {
    this.visible && (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (this._forceClearCache && this.initDimensions(), super.render(zn)));
  }
  graphemeSplit(zn) {
    return Di(zn);
  }
  _splitTextIntoLines(zn) {
    const Un = zn.split(this._reNewline), Kn = new Array(Un.length), qn = [`
`];
    let Jo = [];
    for (let pa = 0; pa < Un.length; pa++) Kn[pa] = this.graphemeSplit(Un[pa]), Jo = Jo.concat(Kn[pa], qn);
    return Jo.pop(), { _unwrappedLines: Kn, lines: Un, graphemeText: Jo, graphemeLines: Kn };
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return s$1(s$1({}, super.toObject([...uo, ...zn])), {}, { styles: Ai(this.styles, this.text) }, this.path ? { path: this.path.toObject() } : {});
  }
  set(zn, Un) {
    const { textLayoutProperties: Kn } = this.constructor;
    super.set(zn, Un);
    let qn = !1, Jo = !1;
    if (typeof zn == "object") for (const pa in zn) pa === "path" && this.setPathInfo(), qn = qn || Kn.includes(pa), Jo = Jo || pa === "path";
    else qn = Kn.includes(zn), Jo = zn === "path";
    return Jo && this.setPathInfo(), qn && this.initialized && (this.initDimensions(), this.setCoords()), this;
  }
  complexity() {
    return 1;
  }
  static async fromElement(zn, Un, Kn) {
    const qn = dr(zn, To.ATTRIBUTE_NAMES, Kn), Jo = s$1(s$1({}, Un), qn), { textAnchor: pa = M$1, textDecoration: ma = "", dx: va = 0, dy: ba = 0, top: _a = 0, left: ya = 0, fontSize: xa = O$1, strokeWidth: wa = 1 } = Jo, Ta = i$3(Jo, wo), Sa = new this((zn.textContent || "").replace(/^\s+|\s+$|\n+/g, "").replace(/\s+/g, " "), s$1({ left: ya + va, top: _a + ba, underline: ma.includes("underline"), overline: ma.includes("overline"), linethrough: ma.includes("line-through"), strokeWidth: 0, fontSize: xa }, Ta)), Ma = Sa.getScaledHeight() / Sa.height, ka = ((Sa.height + Sa.strokeWidth) * Sa.lineHeight - Sa.height) * Ma, Za = Sa.getScaledHeight() + ka;
    let Na = 0;
    return pa === D && (Na = Sa.getScaledWidth() / 2), pa === A$1 && (Na = Sa.getScaledWidth()), Sa.set({ left: Sa.left - Na, top: Sa.top - (Za - Sa.fontSize * (0.07 + Sa._fontSizeFraction)) / Sa.lineHeight, strokeWidth: wa }), Sa;
  }
  static fromObject(zn) {
    return this._fromObject(s$1(s$1({}, zn), {}, { styles: ji(zn.styles || {}, zn.text) }), { extraParam: "text" });
  }
}
t$1(To, "textLayoutProperties", lo), t$1(To, "cacheProperties", [...ps, ...uo]), t$1(To, "ownDefaults", fo), t$1(To, "type", "Text"), t$1(To, "genericFonts", ["serif", "sans-serif", "monospace", "cursive", "fantasy", "system-ui", "ui-serif", "ui-sans-serif", "ui-monospace", "ui-rounded", "math", "emoji", "fangsong"]), t$1(To, "ATTRIBUTE_NAMES", Fi.concat("x", "y", "dx", "dy", "font-family", "font-style", "font-weight", "font-size", "letter-spacing", "text-decoration", "text-anchor")), yi(To, [class extends Xe {
  _toSVG() {
    const Xn = this._getSVGLeftTopOffsets(), zn = this._getSVGTextAndBg(Xn.textTop, Xn.textLeft);
    return this._wrapSVGTextAndBg(zn);
  }
  toSVG(Xn) {
    const zn = this._createBaseSVGMarkup(this._toSVG(), { reviver: Xn, noStyle: !0, withShadow: !0 }), Un = this.path;
    return Un ? zn + Un._createBaseSVGMarkup(Un._toSVG(), { reviver: Xn, withShadow: !0, additionalTransform: zt(this.calcOwnMatrix()) }) : zn;
  }
  _getSVGLeftTopOffsets() {
    return { textLeft: -this.width / 2, textTop: -this.height / 2, lineTop: this.getHeightOfLine(0) };
  }
  _wrapSVGTextAndBg(Xn) {
    let { textBgRects: zn, textSpans: Un } = Xn;
    const Kn = this.getSvgTextDecoration(this);
    return [zn.join(""), '		<text xml:space="preserve" ', this.fontFamily ? 'font-family="'.concat(this.fontFamily.replace(Co, "'"), '" ') : "", this.fontSize ? 'font-size="'.concat(this.fontSize, '" ') : "", this.fontStyle ? 'font-style="'.concat(this.fontStyle, '" ') : "", this.fontWeight ? 'font-weight="'.concat(this.fontWeight, '" ') : "", Kn ? 'text-decoration="'.concat(Kn, '" ') : "", this.direction === "rtl" ? 'direction="'.concat(this.direction, '" ') : "", 'style="', this.getSvgStyles(!0), '"', this.addPaintOrder(), " >", Un.join(""), `</text>
`];
  }
  _getSVGTextAndBg(Xn, zn) {
    const Un = [], Kn = [];
    let qn, Jo = Xn;
    this.backgroundColor && Kn.push(...bo(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));
    for (let pa = 0, ma = this._textLines.length; pa < ma; pa++) qn = this._getLineLeftOffset(pa), this.direction === "rtl" && (qn += this.width), (this.textBackgroundColor || this.styleHas("textBackgroundColor", pa)) && this._setSVGTextLineBg(Kn, pa, zn + qn, Jo), this._setSVGTextLineText(Un, pa, zn + qn, Jo), Jo += this.getHeightOfLine(pa);
    return { textSpans: Un, textBgRects: Kn };
  }
  _createTextCharSpan(Xn, zn, Un, Kn, qn) {
    const Jo = o$1.NUM_FRACTION_DIGITS, pa = this.getSvgSpanStyles(zn, Xn !== Xn.trim() || !!Xn.match(xo)), ma = pa ? 'style="'.concat(pa, '"') : "", va = zn.deltaY, ba = va ? ' dy="'.concat(Vt(va, Jo), '" ') : "", { angle: _a, renderLeft: ya, renderTop: xa, width: wa } = qn;
    let Ta = "";
    if (ya !== void 0) {
      const Sa = wa / 2;
      _a && (Ta = ' rotate="'.concat(Vt(Ct(_a), Jo), '"'));
      const Ma = Pt({ angle: Ct(_a) });
      Ma[4] = ya, Ma[5] = xa;
      const ka = new ot(-Sa, 0).transform(Ma);
      Un = ka.x, Kn = ka.y;
    }
    return '<tspan x="'.concat(Vt(Un, Jo), '" y="').concat(Vt(Kn, Jo), '" ').concat(ba).concat(Ta).concat(ma, ">").concat(ki(Xn), "</tspan>");
  }
  _setSVGTextLineText(Xn, zn, Un, Kn) {
    const qn = this.getHeightOfLine(zn), Jo = this.textAlign.includes(po), pa = this._textLines[zn];
    let ma, va, ba, _a, ya, xa = "", wa = 0;
    Kn += qn * (1 - this._fontSizeFraction) / this.lineHeight;
    for (let Ta = 0, Sa = pa.length - 1; Ta <= Sa; Ta++) ya = Ta === Sa || this.charSpacing || this.path, xa += pa[Ta], ba = this.__charBounds[zn][Ta], wa === 0 ? (Un += ba.kernedWidth - ba.width, wa += ba.width) : wa += ba.kernedWidth, Jo && !ya && this._reSpaceAndTab.test(pa[Ta]) && (ya = !0), ya || (ma = ma || this.getCompleteStyleDeclaration(zn, Ta), va = this.getCompleteStyleDeclaration(zn, Ta + 1), ya = Ei(ma, va, !0)), ya && (_a = this._getStyleDeclaration(zn, Ta), Xn.push(this._createTextCharSpan(xa, _a, Un, Kn, ba)), xa = "", ma = va, this.direction === "rtl" ? Un -= wa : Un += wa, wa = 0);
  }
  _setSVGTextLineBg(Xn, zn, Un, Kn) {
    const qn = this._textLines[zn], Jo = this.getHeightOfLine(zn) / this.lineHeight;
    let pa, ma = 0, va = 0, ba = this.getValueOfPropertyAt(zn, 0, "textBackgroundColor");
    for (let _a = 0; _a < qn.length; _a++) {
      const { left: ya, width: xa, kernedWidth: wa } = this.__charBounds[zn][_a];
      pa = this.getValueOfPropertyAt(zn, _a, "textBackgroundColor"), pa !== ba ? (ba && Xn.push(...bo(ba, Un + va, Kn, ma, Jo)), va = ya, ma = xa, ba = pa) : ma += wa;
    }
    pa && Xn.push(...bo(ba, Un + va, Kn, ma, Jo));
  }
  _getSVGLineTopOffset(Xn) {
    let zn, Un = 0;
    for (zn = 0; zn < Xn; zn++) Un += this.getHeightOfLine(zn);
    const Kn = this.getHeightOfLine(zn);
    return { lineTop: Un, offset: (this._fontSizeMult - this._fontSizeFraction) * Kn / (this.lineHeight * this._fontSizeMult) };
  }
  getSvgStyles(Xn) {
    return "".concat(super.getSvgStyles(Xn), " white-space: pre;");
  }
  getSvgSpanStyles(Xn, zn) {
    const { fontFamily: Un, strokeWidth: Kn, stroke: qn, fill: Jo, fontSize: pa, fontStyle: ma, fontWeight: va, deltaY: ba } = Xn, _a = this.getSvgTextDecoration(Xn);
    return [qn ? Be(J, qn) : "", Kn ? "stroke-width: ".concat(Kn, "; ") : "", Un ? "font-family: ".concat(Un.includes("'") || Un.includes('"') ? Un : "'".concat(Un, "'"), "; ") : "", pa ? "font-size: ".concat(pa, "px; ") : "", ma ? "font-style: ".concat(ma, "; ") : "", va ? "font-weight: ".concat(va, "; ") : "", _a && "text-decoration: ".concat(_a, "; "), Jo ? Be(K, Jo) : "", ba ? "baseline-shift: ".concat(-ba, "; ") : "", zn ? "white-space: pre; " : ""].join("");
  }
  getSvgTextDecoration(Xn) {
    return ["overline", "underline", "line-through"].filter((zn) => Xn[zn.replace("-", "")]).join(" ");
  }
}]), tt.setClass(To), tt.setSVGClass(To);
class Oo {
  constructor(zn) {
    t$1(this, "target", void 0), t$1(this, "__mouseDownInPlace", !1), t$1(this, "__dragStartFired", !1), t$1(this, "__isDraggingOver", !1), t$1(this, "__dragStartSelection", void 0), t$1(this, "__dragImageDisposer", void 0), t$1(this, "_dispose", void 0), this.target = zn;
    const Un = [this.target.on("dragenter", this.dragEnterHandler.bind(this)), this.target.on("dragover", this.dragOverHandler.bind(this)), this.target.on("dragleave", this.dragLeaveHandler.bind(this)), this.target.on("dragend", this.dragEndHandler.bind(this)), this.target.on("drop", this.dropHandler.bind(this))];
    this._dispose = () => {
      Un.forEach((Kn) => Kn()), this._dispose = void 0;
    };
  }
  isPointerOverSelection(zn) {
    const Un = this.target, Kn = Un.getSelectionStartFromPointer(zn);
    return Un.isEditing && Kn >= Un.selectionStart && Kn <= Un.selectionEnd && Un.selectionStart < Un.selectionEnd;
  }
  start(zn) {
    return this.__mouseDownInPlace = this.isPointerOverSelection(zn);
  }
  isActive() {
    return this.__mouseDownInPlace;
  }
  end(zn) {
    const Un = this.isActive();
    return Un && !this.__dragStartFired && (this.target.setCursorByClick(zn), this.target.initDelayedCursor(!0)), this.__mouseDownInPlace = !1, this.__dragStartFired = !1, this.__isDraggingOver = !1, Un;
  }
  getDragStartSelection() {
    return this.__dragStartSelection;
  }
  setDragImage(zn, Un) {
    var Kn;
    let { selectionStart: qn, selectionEnd: Jo } = Un;
    const pa = this.target, ma = pa.canvas, va = new ot(pa.flipX ? -1 : 1, pa.flipY ? -1 : 1), ba = pa._getCursorBoundaries(qn), _a = new ot(ba.left + ba.leftOffset, ba.top + ba.topOffset).multiply(va).transform(pa.calcTransformMatrix()), ya = ma.getScenePoint(zn).subtract(_a), xa = pa.getCanvasRetinaScaling(), wa = pa.getBoundingRect(), Ta = _a.subtract(new ot(wa.left, wa.top)), Sa = ma.viewportTransform, Ma = Ta.add(ya).transform(Sa, !0), ka = pa.backgroundColor, Za = Oi(pa.styles);
    pa.backgroundColor = "";
    const Na = { stroke: "transparent", fill: "transparent", textBackgroundColor: "transparent" };
    pa.setSelectionStyles(Na, 0, qn), pa.setSelectionStyles(Na, Jo, pa.text.length), pa.dirty = !0;
    const Ka = pa.toCanvasElement({ enableRetinaScaling: ma.enableRetinaScaling, viewportTransform: !0 });
    pa.backgroundColor = ka, pa.styles = Za, pa.dirty = !0, an(Ka, { position: "fixed", left: "".concat(-Ka.width, "px"), border: j, width: "".concat(Ka.width / xa, "px"), height: "".concat(Ka.height / xa, "px") }), this.__dragImageDisposer && this.__dragImageDisposer(), this.__dragImageDisposer = () => {
      Ka.remove();
    }, Kt(zn.target || this.target.hiddenTextarea).body.appendChild(Ka), (Kn = zn.dataTransfer) === null || Kn === void 0 || Kn.setDragImage(Ka, Ma.x, Ma.y);
  }
  onDragStart(zn) {
    this.__dragStartFired = !0;
    const Un = this.target, Kn = this.isActive();
    if (Kn && zn.dataTransfer) {
      const qn = this.__dragStartSelection = { selectionStart: Un.selectionStart, selectionEnd: Un.selectionEnd }, Jo = Un._text.slice(qn.selectionStart, qn.selectionEnd).join(""), pa = s$1({ text: Un.text, value: Jo }, qn);
      zn.dataTransfer.setData("text/plain", Jo), zn.dataTransfer.setData("application/fabric", JSON.stringify({ value: Jo, styles: Un.getSelectionStyles(qn.selectionStart, qn.selectionEnd, !0) })), zn.dataTransfer.effectAllowed = "copyMove", this.setDragImage(zn, pa);
    }
    return Un.abortCursorAnimation(), Kn;
  }
  canDrop(zn) {
    if (this.target.editable && !this.target.getActiveControl() && !zn.defaultPrevented) {
      if (this.isActive() && this.__dragStartSelection) {
        const Un = this.target.getSelectionStartFromPointer(zn), Kn = this.__dragStartSelection;
        return Un < Kn.selectionStart || Un > Kn.selectionEnd;
      }
      return !0;
    }
    return !1;
  }
  targetCanDrop(zn) {
    return this.target.canDrop(zn);
  }
  dragEnterHandler(zn) {
    let { e: Un } = zn;
    const Kn = this.targetCanDrop(Un);
    !this.__isDraggingOver && Kn && (this.__isDraggingOver = !0);
  }
  dragOverHandler(zn) {
    const { e: Un } = zn, Kn = this.targetCanDrop(Un);
    !this.__isDraggingOver && Kn ? this.__isDraggingOver = !0 : this.__isDraggingOver && !Kn && (this.__isDraggingOver = !1), this.__isDraggingOver && (Un.preventDefault(), zn.canDrop = !0, zn.dropTarget = this.target);
  }
  dragLeaveHandler() {
    (this.__isDraggingOver || this.isActive()) && (this.__isDraggingOver = !1);
  }
  dropHandler(zn) {
    var Un;
    const { e: Kn } = zn, qn = Kn.defaultPrevented;
    this.__isDraggingOver = !1, Kn.preventDefault();
    let Jo = (Un = Kn.dataTransfer) === null || Un === void 0 ? void 0 : Un.getData("text/plain");
    if (Jo && !qn) {
      const pa = this.target, ma = pa.canvas;
      let va = pa.getSelectionStartFromPointer(Kn);
      const { styles: ba } = Kn.dataTransfer.types.includes("application/fabric") ? JSON.parse(Kn.dataTransfer.getData("application/fabric")) : {}, _a = Jo[Math.max(0, Jo.length - 1)], ya = 0;
      if (this.__dragStartSelection) {
        const xa = this.__dragStartSelection.selectionStart, wa = this.__dragStartSelection.selectionEnd;
        va > xa && va <= wa ? va = xa : va > wa && (va -= wa - xa), pa.removeChars(xa, wa), delete this.__dragStartSelection;
      }
      pa._reNewline.test(_a) && (pa._reNewline.test(pa._text[va]) || va === pa._text.length) && (Jo = Jo.trimEnd()), zn.didDrop = !0, zn.dropTarget = pa, pa.insertChars(Jo, ba, va), ma.setActiveObject(pa), pa.enterEditing(Kn), pa.selectionStart = Math.min(va + ya, pa._text.length), pa.selectionEnd = Math.min(pa.selectionStart + Jo.length, pa._text.length), pa.hiddenTextarea.value = pa.text, pa._updateTextarea(), pa.hiddenTextarea.focus(), pa.fire(z$1, { index: va + ya, action: "drop" }), ma.fire("text:changed", { target: pa }), ma.contextTopDirty = !0, ma.requestRenderAll();
    }
  }
  dragEndHandler(zn) {
    let { e: Un } = zn;
    if (this.isActive() && this.__dragStartFired && this.__dragStartSelection) {
      var Kn;
      const qn = this.target, Jo = this.target.canvas, { selectionStart: pa, selectionEnd: ma } = this.__dragStartSelection, va = ((Kn = Un.dataTransfer) === null || Kn === void 0 ? void 0 : Kn.dropEffect) || j;
      va === j ? (qn.selectionStart = pa, qn.selectionEnd = ma, qn._updateTextarea(), qn.hiddenTextarea.focus()) : (qn.clearContextTop(), va === "move" && (qn.removeChars(pa, ma), qn.selectionStart = qn.selectionEnd = pa, qn.hiddenTextarea && (qn.hiddenTextarea.value = qn.text), qn._updateTextarea(), qn.fire(z$1, { index: pa, action: "dragend" }), Jo.fire("text:changed", { target: qn }), Jo.requestRenderAll()), qn.exitEditing());
    }
    this.__dragImageDisposer && this.__dragImageDisposer(), delete this.__dragImageDisposer, delete this.__dragStartSelection, this.__isDraggingOver = !1;
  }
  dispose() {
    this._dispose && this._dispose();
  }
}
const ko = /[ \n\.,;!\?\-]/;
class Do extends To {
  constructor() {
    super(...arguments), t$1(this, "_currentCursorOpacity", 1);
  }
  initBehavior() {
    this._tick = this._tick.bind(this), this._onTickComplete = this._onTickComplete.bind(this), this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
  }
  onDeselect(zn) {
    return this.isEditing && this.exitEditing(), this.selected = !1, super.onDeselect(zn);
  }
  _animateCursor(zn) {
    let { toValue: Un, duration: Kn, delay: qn, onComplete: Jo } = zn;
    return js({ startValue: this._currentCursorOpacity, endValue: Un, duration: Kn, delay: qn, onComplete: Jo, abort: () => !this.canvas || this.selectionStart !== this.selectionEnd, onChange: (pa) => {
      this._currentCursorOpacity = pa, this.renderCursorOrSelection();
    } });
  }
  _tick(zn) {
    this._currentTickState = this._animateCursor({ toValue: 0, duration: this.cursorDuration / 2, delay: Math.max(zn || 0, 100), onComplete: this._onTickComplete });
  }
  _onTickComplete() {
    var zn;
    (zn = this._currentTickCompleteState) === null || zn === void 0 || zn.abort(), this._currentTickCompleteState = this._animateCursor({ toValue: 1, duration: this.cursorDuration, onComplete: this._tick });
  }
  initDelayedCursor(zn) {
    this.abortCursorAnimation(), this._tick(zn ? 0 : this.cursorDelay);
  }
  abortCursorAnimation() {
    let zn = !1;
    [this._currentTickState, this._currentTickCompleteState].forEach((Un) => {
      Un && !Un.isDone() && (zn = !0, Un.abort());
    }), this._currentCursorOpacity = 1, zn && this.clearContextTop();
  }
  restartCursorIfNeeded() {
    [this._currentTickState, this._currentTickCompleteState].some((zn) => !zn || zn.isDone()) && this.initDelayedCursor();
  }
  selectAll() {
    return this.selectionStart = 0, this.selectionEnd = this._text.length, this._fireSelectionChanged(), this._updateTextarea(), this;
  }
  cmdAll() {
    this.selectAll(), this.renderCursorOrSelection();
  }
  getSelectedText() {
    return this._text.slice(this.selectionStart, this.selectionEnd).join("");
  }
  findWordBoundaryLeft(zn) {
    let Un = 0, Kn = zn - 1;
    if (this._reSpace.test(this._text[Kn])) for (; this._reSpace.test(this._text[Kn]); ) Un++, Kn--;
    for (; /\S/.test(this._text[Kn]) && Kn > -1; ) Un++, Kn--;
    return zn - Un;
  }
  findWordBoundaryRight(zn) {
    let Un = 0, Kn = zn;
    if (this._reSpace.test(this._text[Kn])) for (; this._reSpace.test(this._text[Kn]); ) Un++, Kn++;
    for (; /\S/.test(this._text[Kn]) && Kn < this._text.length; ) Un++, Kn++;
    return zn + Un;
  }
  findLineBoundaryLeft(zn) {
    let Un = 0, Kn = zn - 1;
    for (; !/\n/.test(this._text[Kn]) && Kn > -1; ) Un++, Kn--;
    return zn - Un;
  }
  findLineBoundaryRight(zn) {
    let Un = 0, Kn = zn;
    for (; !/\n/.test(this._text[Kn]) && Kn < this._text.length; ) Un++, Kn++;
    return zn + Un;
  }
  searchWordBoundary(zn, Un) {
    const Kn = this._text;
    let qn = zn > 0 && this._reSpace.test(Kn[zn]) && (Un === -1 || !F.test(Kn[zn - 1])) ? zn - 1 : zn, Jo = Kn[qn];
    for (; qn > 0 && qn < Kn.length && !ko.test(Jo); ) qn += Un, Jo = Kn[qn];
    return Un === -1 && ko.test(Jo) && qn++, qn;
  }
  selectWord(zn) {
    var Un;
    zn = (Un = zn) !== null && Un !== void 0 ? Un : this.selectionStart;
    const Kn = this.searchWordBoundary(zn, -1), qn = Math.max(Kn, this.searchWordBoundary(zn, 1));
    this.selectionStart = Kn, this.selectionEnd = qn, this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection();
  }
  selectLine(zn) {
    var Un;
    zn = (Un = zn) !== null && Un !== void 0 ? Un : this.selectionStart;
    const Kn = this.findLineBoundaryLeft(zn), qn = this.findLineBoundaryRight(zn);
    this.selectionStart = Kn, this.selectionEnd = qn, this._fireSelectionChanged(), this._updateTextarea();
  }
  enterEditing(zn) {
    !this.isEditing && this.editable && (this.enterEditingImpl(), this.fire("editing:entered", zn ? { e: zn } : void 0), this._fireSelectionChanged(), this.canvas && (this.canvas.fire("text:editing:entered", { target: this, e: zn }), this.canvas.requestRenderAll()));
  }
  enterEditingImpl() {
    this.canvas && (this.canvas.calcOffset(), this.canvas.textEditingManager.exitTextEditing()), this.isEditing = !0, this.initHiddenTextarea(), this.hiddenTextarea.focus(), this.hiddenTextarea.value = this.text, this._updateTextarea(), this._saveEditingProps(), this._setEditingProps(), this._textBeforeEdit = this.text, this._tick();
  }
  updateSelectionOnMouseMove(zn) {
    if (this.getActiveControl()) return;
    const Un = this.hiddenTextarea;
    Kt(Un).activeElement !== Un && Un.focus();
    const Kn = this.getSelectionStartFromPointer(zn), qn = this.selectionStart, Jo = this.selectionEnd;
    (Kn === this.__selectionStartOnMouseDown && qn !== Jo || qn !== Kn && Jo !== Kn) && (Kn > this.__selectionStartOnMouseDown ? (this.selectionStart = this.__selectionStartOnMouseDown, this.selectionEnd = Kn) : (this.selectionStart = Kn, this.selectionEnd = this.__selectionStartOnMouseDown), this.selectionStart === qn && this.selectionEnd === Jo || (this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection()));
  }
  _setEditingProps() {
    this.hoverCursor = "text", this.canvas && (this.canvas.defaultCursor = this.canvas.moveCursor = "text"), this.borderColor = this.editingBorderColor, this.hasControls = this.selectable = !1, this.lockMovementX = this.lockMovementY = !0;
  }
  fromStringToGraphemeSelection(zn, Un, Kn) {
    const qn = Kn.slice(0, zn), Jo = this.graphemeSplit(qn).length;
    if (zn === Un) return { selectionStart: Jo, selectionEnd: Jo };
    const pa = Kn.slice(zn, Un);
    return { selectionStart: Jo, selectionEnd: Jo + this.graphemeSplit(pa).length };
  }
  fromGraphemeToStringSelection(zn, Un, Kn) {
    const qn = Kn.slice(0, zn).join("").length;
    return zn === Un ? { selectionStart: qn, selectionEnd: qn } : { selectionStart: qn, selectionEnd: qn + Kn.slice(zn, Un).join("").length };
  }
  _updateTextarea() {
    if (this.cursorOffsetCache = {}, this.hiddenTextarea) {
      if (!this.inCompositionMode) {
        const zn = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
        this.hiddenTextarea.selectionStart = zn.selectionStart, this.hiddenTextarea.selectionEnd = zn.selectionEnd;
      }
      this.updateTextareaPosition();
    }
  }
  updateFromTextArea() {
    if (!this.hiddenTextarea) return;
    this.cursorOffsetCache = {};
    const zn = this.hiddenTextarea;
    this.text = zn.value, this.set("dirty", !0), this.initDimensions(), this.setCoords();
    const Un = this.fromStringToGraphemeSelection(zn.selectionStart, zn.selectionEnd, zn.value);
    this.selectionEnd = this.selectionStart = Un.selectionEnd, this.inCompositionMode || (this.selectionStart = Un.selectionStart), this.updateTextareaPosition();
  }
  updateTextareaPosition() {
    if (this.selectionStart === this.selectionEnd) {
      const zn = this._calcTextareaPosition();
      this.hiddenTextarea.style.left = zn.left, this.hiddenTextarea.style.top = zn.top;
    }
  }
  _calcTextareaPosition() {
    if (!this.canvas) return { left: "1px", top: "1px" };
    const zn = this.inCompositionMode ? this.compositionStart : this.selectionStart, Un = this._getCursorBoundaries(zn), Kn = this.get2DCursorLocation(zn), qn = Kn.lineIndex, Jo = Kn.charIndex, pa = this.getValueOfPropertyAt(qn, Jo, "fontSize") * this.lineHeight, ma = Un.leftOffset, va = this.getCanvasRetinaScaling(), ba = this.canvas.upperCanvasEl, _a = ba.width / va, ya = ba.height / va, xa = _a - pa, wa = ya - pa, Ta = new ot(Un.left + ma, Un.top + Un.topOffset + pa).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new ot(ba.clientWidth / _a, ba.clientHeight / ya));
    return Ta.x < 0 && (Ta.x = 0), Ta.x > xa && (Ta.x = xa), Ta.y < 0 && (Ta.y = 0), Ta.y > wa && (Ta.y = wa), Ta.x += this.canvas._offset.left, Ta.y += this.canvas._offset.top, { left: "".concat(Ta.x, "px"), top: "".concat(Ta.y, "px"), fontSize: "".concat(pa, "px"), charHeight: pa };
  }
  _saveEditingProps() {
    this._savedProps = { hasControls: this.hasControls, borderColor: this.borderColor, lockMovementX: this.lockMovementX, lockMovementY: this.lockMovementY, hoverCursor: this.hoverCursor, selectable: this.selectable, defaultCursor: this.canvas && this.canvas.defaultCursor, moveCursor: this.canvas && this.canvas.moveCursor };
  }
  _restoreEditingProps() {
    this._savedProps && (this.hoverCursor = this._savedProps.hoverCursor, this.hasControls = this._savedProps.hasControls, this.borderColor = this._savedProps.borderColor, this.selectable = this._savedProps.selectable, this.lockMovementX = this._savedProps.lockMovementX, this.lockMovementY = this._savedProps.lockMovementY, this.canvas && (this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor, this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor), delete this._savedProps);
  }
  _exitEditing() {
    const zn = this.hiddenTextarea;
    this.selected = !1, this.isEditing = !1, zn && (zn.blur && zn.blur(), zn.parentNode && zn.parentNode.removeChild(zn)), this.hiddenTextarea = null, this.abortCursorAnimation(), this.selectionStart !== this.selectionEnd && this.clearContextTop();
  }
  exitEditingImpl() {
    this._exitEditing(), this.selectionEnd = this.selectionStart, this._restoreEditingProps(), this._forceClearCache && (this.initDimensions(), this.setCoords());
  }
  exitEditing() {
    const zn = this._textBeforeEdit !== this.text;
    return this.exitEditingImpl(), this.fire("editing:exited"), zn && this.fire(Q), this.canvas && (this.canvas.fire("text:editing:exited", { target: this }), zn && this.canvas.fire("object:modified", { target: this })), this;
  }
  _removeExtraneousStyles() {
    for (const zn in this.styles) this._textLines[zn] || delete this.styles[zn];
  }
  removeStyleFromTo(zn, Un) {
    const { lineIndex: Kn, charIndex: qn } = this.get2DCursorLocation(zn, !0), { lineIndex: Jo, charIndex: pa } = this.get2DCursorLocation(Un, !0);
    if (Kn !== Jo) {
      if (this.styles[Kn]) for (let ma = qn; ma < this._unwrappedTextLines[Kn].length; ma++) delete this.styles[Kn][ma];
      if (this.styles[Jo]) for (let ma = pa; ma < this._unwrappedTextLines[Jo].length; ma++) {
        const va = this.styles[Jo][ma];
        va && (this.styles[Kn] || (this.styles[Kn] = {}), this.styles[Kn][qn + ma - pa] = va);
      }
      for (let ma = Kn + 1; ma <= Jo; ma++) delete this.styles[ma];
      this.shiftLineStyles(Jo, Kn - Jo);
    } else if (this.styles[Kn]) {
      const ma = this.styles[Kn], va = pa - qn;
      for (let ba = qn; ba < pa; ba++) delete ma[ba];
      for (const ba in this.styles[Kn]) {
        const _a = parseInt(ba, 10);
        _a >= pa && (ma[_a - va] = ma[ba], delete ma[ba]);
      }
    }
  }
  shiftLineStyles(zn, Un) {
    const Kn = Object.assign({}, this.styles);
    for (const qn in this.styles) {
      const Jo = parseInt(qn, 10);
      Jo > zn && (this.styles[Jo + Un] = Kn[Jo], Kn[Jo - Un] || delete this.styles[Jo]);
    }
  }
  insertNewlineStyleObject(zn, Un, Kn, qn) {
    const Jo = {}, pa = this._unwrappedTextLines[zn].length, ma = pa === Un;
    let va = !1;
    Kn || (Kn = 1), this.shiftLineStyles(zn, Kn);
    const ba = this.styles[zn] ? this.styles[zn][Un === 0 ? Un : Un - 1] : void 0;
    for (const ya in this.styles[zn]) {
      const xa = parseInt(ya, 10);
      xa >= Un && (va = !0, Jo[xa - Un] = this.styles[zn][ya], ma && Un === 0 || delete this.styles[zn][ya]);
    }
    let _a = !1;
    for (va && !ma && (this.styles[zn + Kn] = Jo, _a = !0), (_a || pa > Un) && Kn--; Kn > 0; ) qn && qn[Kn - 1] ? this.styles[zn + Kn] = { 0: s$1({}, qn[Kn - 1]) } : ba ? this.styles[zn + Kn] = { 0: s$1({}, ba) } : delete this.styles[zn + Kn], Kn--;
    this._forceClearCache = !0;
  }
  insertCharStyleObject(zn, Un, Kn, qn) {
    this.styles || (this.styles = {});
    const Jo = this.styles[zn], pa = Jo ? s$1({}, Jo) : {};
    Kn || (Kn = 1);
    for (const va in pa) {
      const ba = parseInt(va, 10);
      ba >= Un && (Jo[ba + Kn] = pa[ba], pa[ba - Kn] || delete Jo[ba]);
    }
    if (this._forceClearCache = !0, qn) {
      for (; Kn--; ) Object.keys(qn[Kn]).length && (this.styles[zn] || (this.styles[zn] = {}), this.styles[zn][Un + Kn] = s$1({}, qn[Kn]));
      return;
    }
    if (!Jo) return;
    const ma = Jo[Un ? Un - 1 : 1];
    for (; ma && Kn--; ) this.styles[zn][Un + Kn] = s$1({}, ma);
  }
  insertNewStyleBlock(zn, Un, Kn) {
    const qn = this.get2DCursorLocation(Un, !0), Jo = [0];
    let pa, ma = 0;
    for (let va = 0; va < zn.length; va++) zn[va] === `
` ? (ma++, Jo[ma] = 0) : Jo[ma]++;
    for (Jo[0] > 0 && (this.insertCharStyleObject(qn.lineIndex, qn.charIndex, Jo[0], Kn), Kn = Kn && Kn.slice(Jo[0] + 1)), ma && this.insertNewlineStyleObject(qn.lineIndex, qn.charIndex + Jo[0], ma), pa = 1; pa < ma; pa++) Jo[pa] > 0 ? this.insertCharStyleObject(qn.lineIndex + pa, 0, Jo[pa], Kn) : Kn && this.styles[qn.lineIndex + pa] && Kn[0] && (this.styles[qn.lineIndex + pa][0] = Kn[0]), Kn = Kn && Kn.slice(Jo[pa] + 1);
    Jo[pa] > 0 && this.insertCharStyleObject(qn.lineIndex + pa, 0, Jo[pa], Kn);
  }
  removeChars(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zn + 1;
    this.removeStyleFromTo(zn, Un), this._text.splice(zn, Un - zn), this.text = this._text.join(""), this.set("dirty", !0), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
  }
  insertChars(zn, Un, Kn) {
    let qn = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Kn;
    qn > Kn && this.removeStyleFromTo(Kn, qn);
    const Jo = this.graphemeSplit(zn);
    this.insertNewStyleBlock(Jo, Kn, Un), this._text = [...this._text.slice(0, Kn), ...Jo, ...this._text.slice(qn)], this.text = this._text.join(""), this.set("dirty", !0), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
  }
  setSelectionStartEndWithShift(zn, Un, Kn) {
    Kn <= zn ? (Un === zn ? this._selectionDirection = M$1 : this._selectionDirection === A$1 && (this._selectionDirection = M$1, this.selectionEnd = zn), this.selectionStart = Kn) : Kn > zn && Kn < Un ? this._selectionDirection === A$1 ? this.selectionEnd = Kn : this.selectionStart = Kn : (Un === zn ? this._selectionDirection = A$1 : this._selectionDirection === M$1 && (this._selectionDirection = A$1, this.selectionStart = Un), this.selectionEnd = Kn);
  }
}
class Mo extends Do {
  initHiddenTextarea() {
    const zn = this.canvas && Kt(this.canvas.getElement()) || m(), Un = zn.createElement("textarea");
    Object.entries({ autocapitalize: "off", autocorrect: "off", autocomplete: "off", spellcheck: "false", "data-fabric": "textarea", wrap: "off" }).map((pa) => {
      let [ma, va] = pa;
      return Un.setAttribute(ma, va);
    });
    const { top: Kn, left: qn, fontSize: Jo } = this._calcTextareaPosition();
    Un.style.cssText = "position: absolute; top: ".concat(Kn, "; left: ").concat(qn, "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ").concat(Jo, ";"), (this.hiddenTextareaContainer || zn.body).appendChild(Un), Object.entries({ blur: "blur", keydown: "onKeyDown", keyup: "onKeyUp", input: "onInput", copy: "copy", cut: "copy", paste: "paste", compositionstart: "onCompositionStart", compositionupdate: "onCompositionUpdate", compositionend: "onCompositionEnd" }).map((pa) => {
      let [ma, va] = pa;
      return Un.addEventListener(ma, this[va].bind(this));
    }), this.hiddenTextarea = Un;
  }
  blur() {
    this.abortCursorAnimation();
  }
  onKeyDown(zn) {
    if (!this.isEditing) return;
    const Un = this.direction === "rtl" ? this.keysMapRtl : this.keysMap;
    if (zn.keyCode in Un) this[Un[zn.keyCode]](zn);
    else {
      if (!(zn.keyCode in this.ctrlKeysMapDown) || !zn.ctrlKey && !zn.metaKey) return;
      this[this.ctrlKeysMapDown[zn.keyCode]](zn);
    }
    zn.stopImmediatePropagation(), zn.preventDefault(), zn.keyCode >= 33 && zn.keyCode <= 40 ? (this.inCompositionMode = !1, this.clearContextTop(), this.renderCursorOrSelection()) : this.canvas && this.canvas.requestRenderAll();
  }
  onKeyUp(zn) {
    !this.isEditing || this._copyDone || this.inCompositionMode ? this._copyDone = !1 : zn.keyCode in this.ctrlKeysMapUp && (zn.ctrlKey || zn.metaKey) && (this[this.ctrlKeysMapUp[zn.keyCode]](zn), zn.stopImmediatePropagation(), zn.preventDefault(), this.canvas && this.canvas.requestRenderAll());
  }
  onInput(zn) {
    const Un = this.fromPaste, { value: Kn, selectionStart: qn, selectionEnd: Jo } = this.hiddenTextarea;
    if (this.fromPaste = !1, zn && zn.stopPropagation(), !this.isEditing) return;
    const pa = () => {
      this.updateFromTextArea(), this.fire(z$1), this.canvas && (this.canvas.fire("text:changed", { target: this }), this.canvas.requestRenderAll());
    };
    if (this.hiddenTextarea.value === "") return this.styles = {}, void pa();
    const ma = this._splitTextIntoLines(Kn).graphemeText, va = this._text.length, ba = ma.length, _a = this.selectionStart, ya = this.selectionEnd, xa = _a !== ya;
    let wa, Ta, Sa, Ma, ka = ba - va;
    const Za = this.fromStringToGraphemeSelection(qn, Jo, Kn), Na = _a > Za.selectionStart;
    xa ? (Ta = this._text.slice(_a, ya), ka += ya - _a) : ba < va && (Ta = Na ? this._text.slice(ya + ka, ya) : this._text.slice(_a, _a - ka));
    const Ka = ma.slice(Za.selectionEnd - ka, Za.selectionEnd);
    if (Ta && Ta.length && (Ka.length && (wa = this.getSelectionStyles(_a, _a + 1, !1), wa = Ka.map(() => wa[0])), xa ? (Sa = _a, Ma = ya) : Na ? (Sa = ya - Ta.length, Ma = ya) : (Sa = ya, Ma = ya + Ta.length), this.removeStyleFromTo(Sa, Ma)), Ka.length) {
      const { copyPasteData: Ja } = p$1();
      Un && Ka.join("") === Ja.copiedText && !o$1.disableStyleCopyPaste && (wa = Ja.copiedTextStyle), this.insertNewStyleBlock(Ka, _a, wa);
    }
    pa();
  }
  onCompositionStart() {
    this.inCompositionMode = !0;
  }
  onCompositionEnd() {
    this.inCompositionMode = !1;
  }
  onCompositionUpdate(zn) {
    let { target: Un } = zn;
    const { selectionStart: Kn, selectionEnd: qn } = Un;
    this.compositionStart = Kn, this.compositionEnd = qn, this.updateTextareaPosition();
  }
  copy() {
    if (this.selectionStart === this.selectionEnd) return;
    const { copyPasteData: zn } = p$1();
    zn.copiedText = this.getSelectedText(), o$1.disableStyleCopyPaste ? zn.copiedTextStyle = void 0 : zn.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, !0), this._copyDone = !0;
  }
  paste() {
    this.fromPaste = !0;
  }
  _getWidthBeforeCursor(zn, Un) {
    let Kn, qn = this._getLineLeftOffset(zn);
    return Un > 0 && (Kn = this.__charBounds[zn][Un - 1], qn += Kn.left + Kn.width), qn;
  }
  getDownCursorOffset(zn, Un) {
    const Kn = this._getSelectionForOffset(zn, Un), qn = this.get2DCursorLocation(Kn), Jo = qn.lineIndex;
    if (Jo === this._textLines.length - 1 || zn.metaKey || zn.keyCode === 34) return this._text.length - Kn;
    const pa = qn.charIndex, ma = this._getWidthBeforeCursor(Jo, pa), va = this._getIndexOnLine(Jo + 1, ma);
    return this._textLines[Jo].slice(pa).length + va + 1 + this.missingNewlineOffset(Jo);
  }
  _getSelectionForOffset(zn, Un) {
    return zn.shiftKey && this.selectionStart !== this.selectionEnd && Un ? this.selectionEnd : this.selectionStart;
  }
  getUpCursorOffset(zn, Un) {
    const Kn = this._getSelectionForOffset(zn, Un), qn = this.get2DCursorLocation(Kn), Jo = qn.lineIndex;
    if (Jo === 0 || zn.metaKey || zn.keyCode === 33) return -Kn;
    const pa = qn.charIndex, ma = this._getWidthBeforeCursor(Jo, pa), va = this._getIndexOnLine(Jo - 1, ma), ba = this._textLines[Jo].slice(0, pa), _a = this.missingNewlineOffset(Jo - 1);
    return -this._textLines[Jo - 1].length + va - ba.length + (1 - _a);
  }
  _getIndexOnLine(zn, Un) {
    const Kn = this._textLines[zn];
    let qn, Jo, pa = this._getLineLeftOffset(zn), ma = 0;
    for (let va = 0, ba = Kn.length; va < ba; va++) if (qn = this.__charBounds[zn][va].width, pa += qn, pa > Un) {
      Jo = !0;
      const _a = pa - qn, ya = pa, xa = Math.abs(_a - Un);
      ma = Math.abs(ya - Un) < xa ? va : va - 1;
      break;
    }
    return Jo || (ma = Kn.length - 1), ma;
  }
  moveCursorDown(zn) {
    this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorUpOrDown("Down", zn);
  }
  moveCursorUp(zn) {
    this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorUpOrDown("Up", zn);
  }
  _moveCursorUpOrDown(zn, Un) {
    const Kn = this["get".concat(zn, "CursorOffset")](Un, this._selectionDirection === A$1);
    if (Un.shiftKey ? this.moveCursorWithShift(Kn) : this.moveCursorWithoutShift(Kn), Kn !== 0) {
      const qn = this.text.length;
      this.selectionStart = gs(0, this.selectionStart, qn), this.selectionEnd = gs(0, this.selectionEnd, qn), this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea();
    }
  }
  moveCursorWithShift(zn) {
    const Un = this._selectionDirection === M$1 ? this.selectionStart + zn : this.selectionEnd + zn;
    return this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, Un), zn !== 0;
  }
  moveCursorWithoutShift(zn) {
    return zn < 0 ? (this.selectionStart += zn, this.selectionEnd = this.selectionStart) : (this.selectionEnd += zn, this.selectionStart = this.selectionEnd), zn !== 0;
  }
  moveCursorLeft(zn) {
    this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorLeftOrRight("Left", zn);
  }
  _move(zn, Un, Kn) {
    let qn;
    if (zn.altKey) qn = this["findWordBoundary".concat(Kn)](this[Un]);
    else {
      if (!zn.metaKey && zn.keyCode !== 35 && zn.keyCode !== 36) return this[Un] += Kn === "Left" ? -1 : 1, !0;
      qn = this["findLineBoundary".concat(Kn)](this[Un]);
    }
    return qn !== void 0 && this[Un] !== qn && (this[Un] = qn, !0);
  }
  _moveLeft(zn, Un) {
    return this._move(zn, Un, "Left");
  }
  _moveRight(zn, Un) {
    return this._move(zn, Un, "Right");
  }
  moveCursorLeftWithoutShift(zn) {
    let Un = !0;
    return this._selectionDirection = M$1, this.selectionEnd === this.selectionStart && this.selectionStart !== 0 && (Un = this._moveLeft(zn, "selectionStart")), this.selectionEnd = this.selectionStart, Un;
  }
  moveCursorLeftWithShift(zn) {
    return this._selectionDirection === A$1 && this.selectionStart !== this.selectionEnd ? this._moveLeft(zn, "selectionEnd") : this.selectionStart !== 0 ? (this._selectionDirection = M$1, this._moveLeft(zn, "selectionStart")) : void 0;
  }
  moveCursorRight(zn) {
    this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorLeftOrRight("Right", zn);
  }
  _moveCursorLeftOrRight(zn, Un) {
    const Kn = "moveCursor".concat(zn).concat(Un.shiftKey ? "WithShift" : "WithoutShift");
    this._currentCursorOpacity = 1, this[Kn](Un) && (this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea());
  }
  moveCursorRightWithShift(zn) {
    return this._selectionDirection === M$1 && this.selectionStart !== this.selectionEnd ? this._moveRight(zn, "selectionStart") : this.selectionEnd !== this._text.length ? (this._selectionDirection = A$1, this._moveRight(zn, "selectionEnd")) : void 0;
  }
  moveCursorRightWithoutShift(zn) {
    let Un = !0;
    return this._selectionDirection = A$1, this.selectionStart === this.selectionEnd ? (Un = this._moveRight(zn, "selectionStart"), this.selectionEnd = this.selectionStart) : this.selectionStart = this.selectionEnd, Un;
  }
}
const Po = (Xn) => !!Xn.button;
class Eo extends Mo {
  constructor() {
    super(...arguments), t$1(this, "draggableTextDelegate", void 0);
  }
  initBehavior() {
    this.on("mousedown", this._mouseDownHandler), this.on("mouseup", this.mouseUpHandler), this.on("mousedblclick", this.doubleClickHandler), this.on("mousetripleclick", this.tripleClickHandler), this.draggableTextDelegate = new Oo(this), super.initBehavior();
  }
  shouldStartDragging() {
    return this.draggableTextDelegate.isActive();
  }
  onDragStart(zn) {
    return this.draggableTextDelegate.onDragStart(zn);
  }
  canDrop(zn) {
    return this.draggableTextDelegate.canDrop(zn);
  }
  doubleClickHandler(zn) {
    this.isEditing && (this.selectWord(this.getSelectionStartFromPointer(zn.e)), this.renderCursorOrSelection());
  }
  tripleClickHandler(zn) {
    this.isEditing && (this.selectLine(this.getSelectionStartFromPointer(zn.e)), this.renderCursorOrSelection());
  }
  _mouseDownHandler(zn) {
    let { e: Un, alreadySelected: Kn } = zn;
    this.canvas && this.editable && !Po(Un) && !this.getActiveControl() && (this.draggableTextDelegate.start(Un) || (this.canvas.textEditingManager.register(this), Kn && (this.inCompositionMode = !1, this.setCursorByClick(Un)), this.isEditing && (this.__selectionStartOnMouseDown = this.selectionStart, this.selectionStart === this.selectionEnd && this.abortCursorAnimation(), this.renderCursorOrSelection()), this.selected || (this.selected = Kn || this.isEditing)));
  }
  mouseUpHandler(zn) {
    let { e: Un, transform: Kn } = zn;
    const qn = this.draggableTextDelegate.end(Un);
    if (this.canvas) {
      this.canvas.textEditingManager.unregister(this);
      const Jo = this.canvas._activeObject;
      if (Jo && Jo !== this) return;
    }
    !this.editable || this.group && !this.group.interactive || Kn && Kn.actionPerformed || Po(Un) || qn || this.selected && !this.getActiveControl() && (this.enterEditing(Un), this.selectionStart === this.selectionEnd ? this.initDelayedCursor(!0) : this.renderCursorOrSelection());
  }
  setCursorByClick(zn) {
    const Un = this.getSelectionStartFromPointer(zn), Kn = this.selectionStart, qn = this.selectionEnd;
    zn.shiftKey ? this.setSelectionStartEndWithShift(Kn, qn, Un) : (this.selectionStart = Un, this.selectionEnd = Un), this.isEditing && (this._fireSelectionChanged(), this._updateTextarea());
  }
  getSelectionStartFromPointer(zn) {
    const Un = this.canvas.getScenePoint(zn).transform(St(this.calcTransformMatrix())).add(new ot(-this._getLeftOffset(), -this._getTopOffset()));
    let Kn = 0, qn = 0, Jo = 0;
    for (let ba = 0; ba < this._textLines.length && Kn <= Un.y; ba++) Kn += this.getHeightOfLine(ba), Jo = ba, ba > 0 && (qn += this._textLines[ba - 1].length + this.missingNewlineOffset(ba - 1));
    let pa = Math.abs(this._getLineLeftOffset(Jo));
    const ma = this._textLines[Jo].length, va = this.__charBounds[Jo];
    for (let ba = 0; ba < ma; ba++) {
      const _a = pa + va[ba].kernedWidth;
      if (Un.x <= _a) {
        Math.abs(Un.x - _a) <= Math.abs(Un.x - pa) && qn++;
        break;
      }
      pa = _a, qn++;
    }
    return Math.min(this.flipX ? ma - qn : qn, this._text.length);
  }
}
const Ao = "moveCursorUp", jo = "moveCursorDown", Fo = "moveCursorLeft", Lo = "moveCursorRight", Ro = "exitEditing", Io = (Xn, zn) => {
  const Un = zn.getRetinaScaling();
  Xn.setTransform(Un, 0, 0, Un, 0, 0);
  const Kn = zn.viewportTransform;
  Xn.transform(Kn[0], Kn[1], Kn[2], Kn[3], Kn[4], Kn[5]);
}, Bo = s$1({ selectionStart: 0, selectionEnd: 0, selectionColor: "rgba(17,119,255,0.3)", isEditing: !1, editable: !0, editingBorderColor: "rgba(102,153,255,0.25)", cursorWidth: 2, cursorColor: "", cursorDelay: 1e3, cursorDuration: 600, caching: !0, hiddenTextareaContainer: null, keysMap: { 9: Ro, 27: Ro, 33: Ao, 34: jo, 35: Lo, 36: Fo, 37: Fo, 38: Ao, 39: Lo, 40: jo }, keysMapRtl: { 9: Ro, 27: Ro, 33: Ao, 34: jo, 35: Fo, 36: Lo, 37: Lo, 38: Ao, 39: Fo, 40: jo }, ctrlKeysMapDown: { 65: "cmdAll" }, ctrlKeysMapUp: { 67: "copy", 88: "cut" } }, { _selectionDirection: null, _reSpace: /\s|\r?\n/, inCompositionMode: !1 });
class Xo extends Eo {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), Xo.ownDefaults);
  }
  get type() {
    const zn = super.type;
    return zn === "itext" ? "i-text" : zn;
  }
  constructor(zn, Un) {
    super(zn, s$1(s$1({}, Xo.ownDefaults), Un)), this.initBehavior();
  }
  _set(zn, Un) {
    return this.isEditing && this._savedProps && zn in this._savedProps ? (this._savedProps[zn] = Un, this) : (zn === "canvas" && (this.canvas instanceof Cn && this.canvas.textEditingManager.remove(this), Un instanceof Cn && Un.textEditingManager.add(this)), super._set(zn, Un));
  }
  setSelectionStart(zn) {
    zn = Math.max(zn, 0), this._updateAndFire("selectionStart", zn);
  }
  setSelectionEnd(zn) {
    zn = Math.min(zn, this.text.length), this._updateAndFire("selectionEnd", zn);
  }
  _updateAndFire(zn, Un) {
    this[zn] !== Un && (this._fireSelectionChanged(), this[zn] = Un), this._updateTextarea();
  }
  _fireSelectionChanged() {
    this.fire("selection:changed"), this.canvas && this.canvas.fire("text:selection:changed", { target: this });
  }
  initDimensions() {
    this.isEditing && this.initDelayedCursor(), super.initDimensions();
  }
  getSelectionStyles() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart || 0, Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.selectionEnd, Kn = arguments.length > 2 ? arguments[2] : void 0;
    return super.getSelectionStyles(zn, Un, Kn);
  }
  setSelectionStyles(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.selectionStart || 0, Kn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.selectionEnd;
    return super.setSelectionStyles(zn, Un, Kn);
  }
  get2DCursorLocation() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart, Un = arguments.length > 1 ? arguments[1] : void 0;
    return super.get2DCursorLocation(zn, Un);
  }
  render(zn) {
    super.render(zn), this.cursorOffsetCache = {}, this.renderCursorOrSelection();
  }
  toCanvasElement(zn) {
    const Un = this.isEditing;
    this.isEditing = !1;
    const Kn = super.toCanvasElement(zn);
    return this.isEditing = Un, Kn;
  }
  renderCursorOrSelection() {
    if (!this.isEditing || !this.canvas) return;
    const zn = this.clearContextTop(!0);
    if (!zn) return;
    const Un = this._getCursorBoundaries(), Kn = this.findAncestorsWithClipPath(), qn = Kn.length > 0;
    let Jo, pa = zn;
    if (qn) {
      Jo = vt(zn.canvas), pa = Jo.getContext("2d"), Io(pa, this.canvas);
      const ma = this.calcTransformMatrix();
      pa.transform(ma[0], ma[1], ma[2], ma[3], ma[4], ma[5]);
    }
    if (this.selectionStart !== this.selectionEnd || this.inCompositionMode ? this.renderSelection(pa, Un) : this.renderCursor(pa, Un), qn) for (const ma of Kn) {
      const va = ma.clipPath, ba = vt(zn.canvas), _a = ba.getContext("2d");
      if (Io(_a, this.canvas), !va.absolutePositioned) {
        const ya = ma.calcTransformMatrix();
        _a.transform(ya[0], ya[1], ya[2], ya[3], ya[4], ya[5]);
      }
      va.transform(_a), va.drawObject(_a, !0, {}), this.drawClipPathOnCache(pa, va, ba);
    }
    qn && (zn.setTransform(1, 0, 0, 1, 0, 0), zn.drawImage(Jo, 0, 0)), this.canvas.contextTopDirty = !0, zn.restore();
  }
  findAncestorsWithClipPath() {
    const zn = [];
    let Un = this;
    for (; Un; ) Un.clipPath && zn.push(Un), Un = Un.parent;
    return zn;
  }
  _getCursorBoundaries() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart, Un = arguments.length > 1 ? arguments[1] : void 0;
    const Kn = this._getLeftOffset(), qn = this._getTopOffset(), Jo = this._getCursorBoundariesOffsets(zn, Un);
    return { left: Kn, top: qn, leftOffset: Jo.left, topOffset: Jo.top };
  }
  _getCursorBoundariesOffsets(zn, Un) {
    return Un ? this.__getCursorBoundariesOffsets(zn) : this.cursorOffsetCache && "top" in this.cursorOffsetCache ? this.cursorOffsetCache : this.cursorOffsetCache = this.__getCursorBoundariesOffsets(zn);
  }
  __getCursorBoundariesOffsets(zn) {
    let Un = 0, Kn = 0;
    const { charIndex: qn, lineIndex: Jo } = this.get2DCursorLocation(zn);
    for (let ba = 0; ba < Jo; ba++) Un += this.getHeightOfLine(ba);
    const pa = this._getLineLeftOffset(Jo), ma = this.__charBounds[Jo][qn];
    ma && (Kn = ma.left), this.charSpacing !== 0 && qn === this._textLines[Jo].length && (Kn -= this._getWidthOfCharSpacing());
    const va = { top: Un, left: pa + (Kn > 0 ? Kn : 0) };
    return this.direction === "rtl" && (this.textAlign === A$1 || this.textAlign === po || this.textAlign === vo ? va.left *= -1 : this.textAlign === M$1 || this.textAlign === mo ? va.left = pa - (Kn > 0 ? Kn : 0) : this.textAlign !== D && this.textAlign !== yo || (va.left = pa - (Kn > 0 ? Kn : 0))), va;
  }
  renderCursorAt(zn) {
    this._renderCursor(this.canvas.contextTop, this._getCursorBoundaries(zn, !0), zn);
  }
  renderCursor(zn, Un) {
    this._renderCursor(zn, Un, this.selectionStart);
  }
  getCursorRenderingData() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectionStart, Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._getCursorBoundaries(zn);
    const Kn = this.get2DCursorLocation(zn), qn = Kn.lineIndex, Jo = Kn.charIndex > 0 ? Kn.charIndex - 1 : 0, pa = this.getValueOfPropertyAt(qn, Jo, "fontSize"), ma = this.getObjectScaling().x * this.canvas.getZoom(), va = this.cursorWidth / ma, ba = this.getValueOfPropertyAt(qn, Jo, "deltaY"), _a = Un.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(qn) / this.lineHeight - pa * (1 - this._fontSizeFraction);
    return { color: this.cursorColor || this.getValueOfPropertyAt(qn, Jo, "fill"), opacity: this._currentCursorOpacity, left: Un.left + Un.leftOffset - va / 2, top: _a + Un.top + ba, width: va, height: pa };
  }
  _renderCursor(zn, Un, Kn) {
    const { color: qn, opacity: Jo, left: pa, top: ma, width: va, height: ba } = this.getCursorRenderingData(Kn, Un);
    zn.fillStyle = qn, zn.globalAlpha = Jo, zn.fillRect(pa, ma, va, ba);
  }
  renderSelection(zn, Un) {
    const Kn = { selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd };
    this._renderSelection(zn, Kn, Un);
  }
  renderDragSourceEffect() {
    const zn = this.draggableTextDelegate.getDragStartSelection();
    this._renderSelection(this.canvas.contextTop, zn, this._getCursorBoundaries(zn.selectionStart, !0));
  }
  renderDropTargetEffect(zn) {
    const Un = this.getSelectionStartFromPointer(zn);
    this.renderCursorAt(Un);
  }
  _renderSelection(zn, Un, Kn) {
    const qn = Un.selectionStart, Jo = Un.selectionEnd, pa = this.textAlign.includes(po), ma = this.get2DCursorLocation(qn), va = this.get2DCursorLocation(Jo), ba = ma.lineIndex, _a = va.lineIndex, ya = ma.charIndex < 0 ? 0 : ma.charIndex, xa = va.charIndex < 0 ? 0 : va.charIndex;
    for (let wa = ba; wa <= _a; wa++) {
      const Ta = this._getLineLeftOffset(wa) || 0;
      let Sa = this.getHeightOfLine(wa), Ma = 0, ka = 0, Za = 0;
      if (wa === ba && (ka = this.__charBounds[ba][ya].left), wa >= ba && wa < _a) Za = pa && !this.isEndOfWrapping(wa) ? this.width : this.getLineWidth(wa) || 5;
      else if (wa === _a) if (xa === 0) Za = this.__charBounds[_a][xa].left;
      else {
        const qa = this._getWidthOfCharSpacing();
        Za = this.__charBounds[_a][xa - 1].left + this.__charBounds[_a][xa - 1].width - qa;
      }
      Ma = Sa, (this.lineHeight < 1 || wa === _a && this.lineHeight > 1) && (Sa /= this.lineHeight);
      let Na = Kn.left + Ta + ka, Ka = Sa, Ja = 0;
      const el = Za - ka;
      this.inCompositionMode ? (zn.fillStyle = this.compositionColor || "black", Ka = 1, Ja = Sa) : zn.fillStyle = this.selectionColor, this.direction === "rtl" && (this.textAlign === A$1 || this.textAlign === po || this.textAlign === vo ? Na = this.width - Na - el : this.textAlign === M$1 || this.textAlign === mo ? Na = Kn.left + Ta - Za : this.textAlign !== D && this.textAlign !== yo || (Na = Kn.left + Ta - Za)), zn.fillRect(Na, Kn.top + Kn.topOffset + Ja, el, Ka), Kn.topOffset += Ma;
    }
  }
  getCurrentCharFontSize() {
    const zn = this._getCurrentCharIndex();
    return this.getValueOfPropertyAt(zn.l, zn.c, "fontSize");
  }
  getCurrentCharColor() {
    const zn = this._getCurrentCharIndex();
    return this.getValueOfPropertyAt(zn.l, zn.c, K);
  }
  _getCurrentCharIndex() {
    const zn = this.get2DCursorLocation(this.selectionStart, !0), Un = zn.charIndex > 0 ? zn.charIndex - 1 : 0;
    return { l: zn.lineIndex, c: Un };
  }
  dispose() {
    this.exitEditingImpl(), this.draggableTextDelegate.dispose(), super.dispose();
  }
}
t$1(Xo, "ownDefaults", Bo), t$1(Xo, "type", "IText"), tt.setClass(Xo), tt.setClass(Xo, "i-text");
class Yo extends Xo {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), Yo.ownDefaults);
  }
  constructor(zn, Un) {
    super(zn, s$1(s$1({}, Yo.ownDefaults), Un));
  }
  static createControls() {
    return { controls: mi() };
  }
  initDimensions() {
    this.initialized && (this.isEditing && this.initDelayedCursor(), this._clearCache(), this.dynamicMinWidth = 0, this._styleMap = this._generateStyleMap(this._splitText()), this.dynamicMinWidth > this.width && this._set("width", this.dynamicMinWidth), this.textAlign.includes(po) && this.enlargeSpaces(), this.height = this.calcTextHeight());
  }
  _generateStyleMap(zn) {
    let Un = 0, Kn = 0, qn = 0;
    const Jo = {};
    for (let pa = 0; pa < zn.graphemeLines.length; pa++) zn.graphemeText[qn] === `
` && pa > 0 ? (Kn = 0, qn++, Un++) : !this.splitByGrapheme && this._reSpaceAndTab.test(zn.graphemeText[qn]) && pa > 0 && (Kn++, qn++), Jo[pa] = { line: Un, offset: Kn }, qn += zn.graphemeLines[pa].length, Kn += zn.graphemeLines[pa].length;
    return Jo;
  }
  styleHas(zn, Un) {
    if (this._styleMap && !this.isWrapping) {
      const Kn = this._styleMap[Un];
      Kn && (Un = Kn.line);
    }
    return super.styleHas(zn, Un);
  }
  isEmptyStyles(zn) {
    if (!this.styles) return !0;
    let Un, Kn = 0, qn = zn + 1, Jo = !1;
    const pa = this._styleMap[zn], ma = this._styleMap[zn + 1];
    pa && (zn = pa.line, Kn = pa.offset), ma && (qn = ma.line, Jo = qn === zn, Un = ma.offset);
    const va = zn === void 0 ? this.styles : { line: this.styles[zn] };
    for (const ba in va) for (const _a in va[ba]) {
      const ya = parseInt(_a, 10);
      if (ya >= Kn && (!Jo || ya < Un)) for (const xa in va[ba][_a]) return !1;
    }
    return !0;
  }
  _getStyleDeclaration(zn, Un) {
    if (this._styleMap && !this.isWrapping) {
      const Kn = this._styleMap[zn];
      if (!Kn) return {};
      zn = Kn.line, Un = Kn.offset + Un;
    }
    return super._getStyleDeclaration(zn, Un);
  }
  _setStyleDeclaration(zn, Un, Kn) {
    const qn = this._styleMap[zn];
    super._setStyleDeclaration(qn.line, qn.offset + Un, Kn);
  }
  _deleteStyleDeclaration(zn, Un) {
    const Kn = this._styleMap[zn];
    super._deleteStyleDeclaration(Kn.line, Kn.offset + Un);
  }
  _getLineStyle(zn) {
    const Un = this._styleMap[zn];
    return !!this.styles[Un.line];
  }
  _setLineStyle(zn) {
    const Un = this._styleMap[zn];
    super._setLineStyle(Un.line);
  }
  _wrapText(zn, Un) {
    this.isWrapping = !0;
    const Kn = this.getGraphemeDataForRender(zn), qn = [];
    for (let Jo = 0; Jo < Kn.wordsData.length; Jo++) qn.push(...this._wrapLine(Jo, Un, Kn));
    return this.isWrapping = !1, qn;
  }
  getGraphemeDataForRender(zn) {
    const Un = this.splitByGrapheme, Kn = Un ? "" : " ";
    let qn = 0;
    return { wordsData: zn.map((Jo, pa) => {
      let ma = 0;
      const va = Un ? this.graphemeSplit(Jo) : this.wordSplit(Jo);
      return va.length === 0 ? [{ word: [], width: 0 }] : va.map((ba) => {
        const _a = Un ? [ba] : this.graphemeSplit(ba), ya = this._measureWord(_a, pa, ma);
        return qn = Math.max(ya, qn), ma += _a.length + Kn.length, { word: _a, width: ya };
      });
    }), largestWordWidth: qn };
  }
  _measureWord(zn, Un) {
    let Kn, qn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, Jo = 0;
    for (let pa = 0, ma = zn.length; pa < ma; pa++)
      Jo += this._getGraphemeBox(zn[pa], Un, pa + qn, Kn, !0).kernedWidth, Kn = zn[pa];
    return Jo;
  }
  wordSplit(zn) {
    return zn.split(this._wordJoiners);
  }
  _wrapLine(zn, Un, Kn) {
    let { largestWordWidth: qn, wordsData: Jo } = Kn, pa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    const ma = this._getWidthOfCharSpacing(), va = this.splitByGrapheme, ba = [], _a = va ? "" : " ";
    let ya = 0, xa = [], wa = 0, Ta = 0, Sa = !0;
    Un -= pa;
    const Ma = Math.max(Un, qn, this.dynamicMinWidth), ka = Jo[zn];
    let Za;
    for (wa = 0, Za = 0; Za < ka.length; Za++) {
      const { word: Na, width: Ka } = ka[Za];
      wa += Na.length, ya += Ta + Ka - ma, ya > Ma && !Sa ? (ba.push(xa), xa = [], ya = Ka, Sa = !0) : ya += ma, Sa || va || xa.push(_a), xa = xa.concat(Na), Ta = va ? 0 : this._measureWord([_a], zn, wa), wa++, Sa = !1;
    }
    return Za && ba.push(xa), qn + pa > this.dynamicMinWidth && (this.dynamicMinWidth = qn - ma + pa), ba;
  }
  isEndOfWrapping(zn) {
    return !this._styleMap[zn + 1] || this._styleMap[zn + 1].line !== this._styleMap[zn].line;
  }
  missingNewlineOffset(zn, Un) {
    return this.splitByGrapheme && !Un ? this.isEndOfWrapping(zn) ? 1 : 0 : 1;
  }
  _splitTextIntoLines(zn) {
    const Un = super._splitTextIntoLines(zn), Kn = this._wrapText(Un.lines, this.width), qn = new Array(Kn.length);
    for (let Jo = 0; Jo < Kn.length; Jo++) qn[Jo] = Kn[Jo].join("");
    return Un.lines = qn, Un.graphemeLines = Kn, Un;
  }
  getMinWidth() {
    return Math.max(this.minWidth, this.dynamicMinWidth);
  }
  _removeExtraneousStyles() {
    const zn = /* @__PURE__ */ new Map();
    for (const Un in this._styleMap) {
      const Kn = parseInt(Un, 10);
      if (this._textLines[Kn]) {
        const qn = this._styleMap[Un].line;
        zn.set("".concat(qn), !0);
      }
    }
    for (const Un in this.styles) zn.has(Un) || delete this.styles[Un];
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return super.toObject(["minWidth", "splitByGrapheme", ...zn]);
  }
}
t$1(Yo, "type", "Textbox"), t$1(Yo, "textLayoutProperties", [...Xo.textLayoutProperties, "width"]), t$1(Yo, "ownDefaults", { minWidth: 20, dynamicMinWidth: 2, lockScalingFlip: !0, noScaleCache: !1, _wordJoiners: /[ \t\r]/, splitByGrapheme: !1 }), tt.setClass(Yo);
class Wo extends Cr {
  shouldPerformLayout(zn) {
    return !!zn.target.clipPath && super.shouldPerformLayout(zn);
  }
  shouldLayoutClipPath() {
    return !1;
  }
  calcLayoutResult(zn, Un) {
    const { target: Kn } = zn, { clipPath: qn, group: Jo } = Kn;
    if (!qn || !this.shouldPerformLayout(zn)) return;
    const { width: pa, height: ma } = ae(xr(Kn, qn)), va = new ot(pa, ma);
    if (qn.absolutePositioned)
      return { center: pe(qn.getRelativeCenterPoint(), void 0, Jo ? Jo.calcTransformMatrix() : void 0), size: va };
    {
      const ba = qn.getRelativeCenterPoint().transform(Kn.calcOwnMatrix(), !0);
      if (this.shouldPerformLayout(zn)) {
        const { center: _a = new ot(), correction: ya = new ot() } = this.calcBoundingBox(Un, zn) || {};
        return { center: _a.add(ba), correction: ya.subtract(ba), size: va };
      }
      return { center: Kn.getRelativeCenterPoint().add(ba), size: va };
    }
  }
}
t$1(Wo, "type", "clip-path"), tt.setClass(Wo);
class Vo extends Cr {
  getInitialSize(zn, Un) {
    let { target: Kn } = zn, { size: qn } = Un;
    return new ot(Kn.width || qn.x, Kn.height || qn.y);
  }
}
t$1(Vo, "type", "fixed"), tt.setClass(Vo);
class zo extends Or {
  subscribeTargets(zn) {
    const Un = zn.target;
    zn.targets.reduce((Kn, qn) => (qn.parent && Kn.add(qn.parent), Kn), /* @__PURE__ */ new Set()).forEach((Kn) => {
      Kn.layoutManager.subscribeTargets({ target: Kn, targets: [Un] });
    });
  }
  unsubscribeTargets(zn) {
    const Un = zn.target, Kn = Un.getObjects();
    zn.targets.reduce((qn, Jo) => (Jo.parent && qn.add(Jo.parent), qn), /* @__PURE__ */ new Set()).forEach((qn) => {
      !Kn.some((Jo) => Jo.parent === qn) && qn.layoutManager.unsubscribeTargets({ target: qn, targets: [Un] });
    });
  }
}
class Go extends Mr {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), Go.ownDefaults);
  }
  constructor() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Object.assign(this, Go.ownDefaults), this.setOptions(Un);
    const { left: Kn, top: qn, layoutManager: Jo } = Un;
    this.groupInit(zn, { left: Kn, top: qn, layoutManager: Jo ?? new zo() });
  }
  _shouldSetNestedCoords() {
    return !0;
  }
  __objectSelectionMonitor() {
  }
  multiSelectAdd() {
    for (var zn = arguments.length, Un = new Array(zn), Kn = 0; Kn < zn; Kn++) Un[Kn] = arguments[Kn];
    this.multiSelectionStacking === "selection-order" ? this.add(...Un) : Un.forEach((qn) => {
      const Jo = this._objects.findIndex((ma) => ma.isInFrontOf(qn)), pa = Jo === -1 ? this.size() : Jo;
      this.insertAt(pa, qn);
    });
  }
  canEnterGroup(zn) {
    return this.getObjects().some((Un) => Un.isDescendantOf(zn) || zn.isDescendantOf(Un)) ? (a$1("error", "ActiveSelection: circular object trees are not supported, this call has no effect"), !1) : super.canEnterGroup(zn);
  }
  enterGroup(zn, Un) {
    zn.parent && zn.parent === zn.group ? zn.parent._exitGroup(zn) : zn.group && zn.parent !== zn.group && zn.group.remove(zn), this._enterGroup(zn, Un);
  }
  exitGroup(zn, Un) {
    this._exitGroup(zn, Un), zn.parent && zn.parent._enterGroup(zn, !0);
  }
  _onAfterObjectsChange(zn, Un) {
    super._onAfterObjectsChange(zn, Un);
    const Kn = /* @__PURE__ */ new Set();
    Un.forEach((qn) => {
      const { parent: Jo } = qn;
      Jo && Kn.add(Jo);
    }), zn === yr ? Kn.forEach((qn) => {
      qn._onAfterObjectsChange(vr, Un);
    }) : Kn.forEach((qn) => {
      qn._set("dirty", !0);
    });
  }
  onDeselect() {
    return this.removeAll(), !1;
  }
  toString() {
    return "#<ActiveSelection: (".concat(this.complexity(), ")>");
  }
  shouldCache() {
    return !1;
  }
  isOnACache() {
    return !1;
  }
  _renderControls(zn, Un, Kn) {
    zn.save(), zn.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
    const qn = s$1(s$1({ hasControls: !1 }, Kn), {}, { forActiveSelection: !0 });
    for (let Jo = 0; Jo < this._objects.length; Jo++) this._objects[Jo]._renderControls(zn, qn);
    super._renderControls(zn, Un), zn.restore();
  }
}
t$1(Go, "type", "ActiveSelection"), t$1(Go, "ownDefaults", { multiSelectionStacking: "canvas-stacking" }), tt.setClass(Go), tt.setClass(Go, "activeSelection");
class Ho {
  constructor() {
    t$1(this, "resources", {});
  }
  applyFilters(zn, Un, Kn, qn, Jo) {
    const pa = Jo.getContext("2d");
    if (!pa) return;
    pa.drawImage(Un, 0, 0, Kn, qn);
    const ma = { sourceWidth: Kn, sourceHeight: qn, imageData: pa.getImageData(0, 0, Kn, qn), originalEl: Un, originalImageData: pa.getImageData(0, 0, Kn, qn), canvasEl: Jo, ctx: pa, filterBackend: this };
    zn.forEach((ba) => {
      ba.applyTo(ma);
    });
    const { imageData: va } = ma;
    return va.width === Kn && va.height === qn || (Jo.width = va.width, Jo.height = va.height), pa.putImageData(va, 0, 0), ma;
  }
}
class No {
  constructor() {
    let { tileSize: zn = o$1.textureSize } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t$1(this, "aPosition", new Float32Array([0, 0, 0, 1, 1, 0, 1, 1])), t$1(this, "resources", {}), this.tileSize = zn, this.setupGLContext(zn, zn), this.captureGPUInfo();
  }
  setupGLContext(zn, Un) {
    this.dispose(), this.createWebGLCanvas(zn, Un);
  }
  createWebGLCanvas(zn, Un) {
    const Kn = vt({ width: zn, height: Un }), qn = Kn.getContext("webgl", { alpha: !0, premultipliedAlpha: !1, depth: !1, stencil: !1, antialias: !1 });
    qn && (qn.clearColor(0, 0, 0, 0), this.canvas = Kn, this.gl = qn);
  }
  applyFilters(zn, Un, Kn, qn, Jo, pa) {
    const ma = this.gl, va = Jo.getContext("2d");
    if (!ma || !va) return;
    let ba;
    pa && (ba = this.getCachedTexture(pa, Un));
    const _a = { originalWidth: Un.width || Un.naturalWidth || 0, originalHeight: Un.height || Un.naturalHeight || 0, sourceWidth: Kn, sourceHeight: qn, destinationWidth: Kn, destinationHeight: qn, context: ma, sourceTexture: this.createTexture(ma, Kn, qn, ba ? void 0 : Un), targetTexture: this.createTexture(ma, Kn, qn), originalTexture: ba || this.createTexture(ma, Kn, qn, ba ? void 0 : Un), passes: zn.length, webgl: !0, aPosition: this.aPosition, programCache: this.programCache, pass: 0, filterBackend: this, targetCanvas: Jo }, ya = ma.createFramebuffer();
    return ma.bindFramebuffer(ma.FRAMEBUFFER, ya), zn.forEach((xa) => {
      xa && xa.applyTo(_a);
    }), function(xa) {
      const wa = xa.targetCanvas, Ta = wa.width, Sa = wa.height, Ma = xa.destinationWidth, ka = xa.destinationHeight;
      Ta === Ma && Sa === ka || (wa.width = Ma, wa.height = ka);
    }(_a), this.copyGLTo2D(ma, _a), ma.bindTexture(ma.TEXTURE_2D, null), ma.deleteTexture(_a.sourceTexture), ma.deleteTexture(_a.targetTexture), ma.deleteFramebuffer(ya), va.setTransform(1, 0, 0, 1, 0, 0), _a;
  }
  dispose() {
    this.canvas && (this.canvas = null, this.gl = null), this.clearWebGLCaches();
  }
  clearWebGLCaches() {
    this.programCache = {}, this.textureCache = {};
  }
  createTexture(zn, Un, Kn, qn, Jo) {
    const { NEAREST: pa, TEXTURE_2D: ma, RGBA: va, UNSIGNED_BYTE: ba, CLAMP_TO_EDGE: _a, TEXTURE_MAG_FILTER: ya, TEXTURE_MIN_FILTER: xa, TEXTURE_WRAP_S: wa, TEXTURE_WRAP_T: Ta } = zn, Sa = zn.createTexture();
    return zn.bindTexture(ma, Sa), zn.texParameteri(ma, ya, Jo || pa), zn.texParameteri(ma, xa, Jo || pa), zn.texParameteri(ma, wa, _a), zn.texParameteri(ma, Ta, _a), qn ? zn.texImage2D(ma, 0, va, va, ba, qn) : zn.texImage2D(ma, 0, va, Un, Kn, 0, va, ba, null), Sa;
  }
  getCachedTexture(zn, Un, Kn) {
    const { textureCache: qn } = this;
    if (qn[zn]) return qn[zn];
    {
      const Jo = this.createTexture(this.gl, Un.width, Un.height, Un, Kn);
      return Jo && (qn[zn] = Jo), Jo;
    }
  }
  evictCachesForKey(zn) {
    this.textureCache[zn] && (this.gl.deleteTexture(this.textureCache[zn]), delete this.textureCache[zn]);
  }
  copyGLTo2D(zn, Un) {
    const Kn = zn.canvas, qn = Un.targetCanvas, Jo = qn.getContext("2d");
    if (!Jo) return;
    Jo.translate(0, qn.height), Jo.scale(1, -1);
    const pa = Kn.height - qn.height;
    Jo.drawImage(Kn, 0, pa, qn.width, qn.height, 0, 0, qn.width, qn.height);
  }
  copyGLTo2DPutImageData(zn, Un) {
    const Kn = Un.targetCanvas.getContext("2d"), qn = Un.destinationWidth, Jo = Un.destinationHeight, pa = qn * Jo * 4;
    if (!Kn) return;
    const ma = new Uint8Array(this.imageBuffer, 0, pa), va = new Uint8ClampedArray(this.imageBuffer, 0, pa);
    zn.readPixels(0, 0, qn, Jo, zn.RGBA, zn.UNSIGNED_BYTE, ma);
    const ba = new ImageData(va, qn, Jo);
    Kn.putImageData(ba, 0, 0);
  }
  captureGPUInfo() {
    if (this.gpuInfo) return this.gpuInfo;
    const zn = this.gl, Un = { renderer: "", vendor: "" };
    if (!zn) return Un;
    const Kn = zn.getExtension("WEBGL_debug_renderer_info");
    if (Kn) {
      const qn = zn.getParameter(Kn.UNMASKED_RENDERER_WEBGL), Jo = zn.getParameter(Kn.UNMASKED_VENDOR_WEBGL);
      qn && (Un.renderer = qn.toLowerCase()), Jo && (Un.vendor = Jo.toLowerCase());
    }
    return this.gpuInfo = Un, Un;
  }
}
let Uo;
function qo() {
  const { WebGLProbe: Xn } = p$1();
  return Xn.queryWebGL(pt()), o$1.enableGLFiltering && Xn.isSupported(o$1.textureSize) ? new No({ tileSize: o$1.textureSize }) : new Ho();
}
function Ko() {
  return !Uo && (!(arguments.length > 0 && arguments[0] !== void 0) || arguments[0]) && (Uo = qo()), Uo;
}
const Qo = ["filters", "resizeFilter", "src", "crossOrigin", "type"], Zo = ["cropX", "cropY"];
class $o extends _i {
  static getDefaults() {
    return s$1(s$1({}, super.getDefaults()), $o.ownDefaults);
  }
  constructor(zn, Un) {
    super(), t$1(this, "_lastScaleX", 1), t$1(this, "_lastScaleY", 1), t$1(this, "_filterScalingX", 1), t$1(this, "_filterScalingY", 1), this.filters = [], Object.assign(this, $o.ownDefaults), this.setOptions(Un), this.cacheKey = "texture".concat(ft()), this.setElement(typeof zn == "string" ? (this.canvas && Kt(this.canvas.getElement()) || m()).getElementById(zn) : zn, Un);
  }
  getElement() {
    return this._element;
  }
  setElement(zn) {
    var Un;
    let Kn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.removeTexture(this.cacheKey), this.removeTexture("".concat(this.cacheKey, "_filtered")), this._element = zn, this._originalElement = zn, this._setWidthHeight(Kn), (Un = zn.classList) === null || Un === void 0 || Un.add($o.CSS_CANVAS), this.filters.length !== 0 && this.applyFilters(), this.resizeFilter && this.applyResizeFilters();
  }
  removeTexture(zn) {
    const Un = Ko(!1);
    Un instanceof No && Un.evictCachesForKey(zn);
  }
  dispose() {
    super.dispose(), this.removeTexture(this.cacheKey), this.removeTexture("".concat(this.cacheKey, "_filtered")), this._cacheContext = null, ["_originalElement", "_element", "_filteredEl", "_cacheCanvas"].forEach((zn) => {
      const Un = this[zn];
      Un && p$1().dispose(Un), this[zn] = void 0;
    });
  }
  getCrossOrigin() {
    return this._originalElement && (this._originalElement.crossOrigin || null);
  }
  getOriginalSize() {
    const zn = this.getElement();
    return zn ? { width: zn.naturalWidth || zn.width, height: zn.naturalHeight || zn.height } : { width: 0, height: 0 };
  }
  _stroke(zn) {
    if (!this.stroke || this.strokeWidth === 0) return;
    const Un = this.width / 2, Kn = this.height / 2;
    zn.beginPath(), zn.moveTo(-Un, -Kn), zn.lineTo(Un, -Kn), zn.lineTo(Un, Kn), zn.lineTo(-Un, Kn), zn.lineTo(-Un, -Kn), zn.closePath();
  }
  toObject() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const Un = [];
    return this.filters.forEach((Kn) => {
      Kn && Un.push(Kn.toObject());
    }), s$1(s$1({}, super.toObject([...Zo, ...zn])), {}, { src: this.getSrc(), crossOrigin: this.getCrossOrigin(), filters: Un }, this.resizeFilter ? { resizeFilter: this.resizeFilter.toObject() } : {});
  }
  hasCrop() {
    return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
  }
  _toSVG() {
    const zn = [], Un = this._element, Kn = -this.width / 2, qn = -this.height / 2;
    let Jo = [], pa = [], ma = "", va = "";
    if (!Un) return [];
    if (this.hasCrop()) {
      const ba = ft();
      Jo.push('<clipPath id="imageCrop_' + ba + `">
`, '	<rect x="' + Kn + '" y="' + qn + '" width="' + this.width + '" height="' + this.height + `" />
`, `</clipPath>
`), ma = ' clip-path="url(#imageCrop_' + ba + ')" ';
    }
    if (this.imageSmoothing || (va = ' image-rendering="optimizeSpeed"'), zn.push("	<image ", "COMMON_PARTS", 'xlink:href="'.concat(this.getSvgSrc(!0), '" x="').concat(Kn - this.cropX, '" y="').concat(qn - this.cropY, '" width="').concat(Un.width || Un.naturalWidth, '" height="').concat(Un.height || Un.naturalHeight, '"').concat(va).concat(ma, `></image>
`)), this.stroke || this.strokeDashArray) {
      const ba = this.fill;
      this.fill = null, pa = ['	<rect x="'.concat(Kn, '" y="').concat(qn, '" width="').concat(this.width, '" height="').concat(this.height, '" style="').concat(this.getSvgStyles(), `" />
`)], this.fill = ba;
    }
    return Jo = this.paintFirst !== K ? Jo.concat(pa, zn) : Jo.concat(zn, pa), Jo;
  }
  getSrc(zn) {
    const Un = zn ? this._element : this._originalElement;
    return Un ? Un.toDataURL ? Un.toDataURL() : this.srcFromAttribute ? Un.getAttribute("src") || "" : Un.src : this.src || "";
  }
  getSvgSrc(zn) {
    return this.getSrc(zn);
  }
  setSrc(zn) {
    let { crossOrigin: Un, signal: Kn } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return It(zn, { crossOrigin: Un, signal: Kn }).then((qn) => {
      Un !== void 0 && this.set({ crossOrigin: Un }), this.setElement(qn);
    });
  }
  toString() {
    return '#<Image: { src: "'.concat(this.getSrc(), '" }>');
  }
  applyResizeFilters() {
    const zn = this.resizeFilter, Un = this.minimumScaleTrigger, Kn = this.getTotalObjectScaling(), qn = Kn.x, Jo = Kn.y, pa = this._filteredEl || this._originalElement;
    if (this.group && this.set("dirty", !0), !zn || qn > Un && Jo > Un) return this._element = pa, this._filterScalingX = 1, this._filterScalingY = 1, this._lastScaleX = qn, void (this._lastScaleY = Jo);
    const ma = vt(pa), { width: va, height: ba } = pa;
    this._element = ma, this._lastScaleX = zn.scaleX = qn, this._lastScaleY = zn.scaleY = Jo, Ko().applyFilters([zn], pa, va, ba, this._element), this._filterScalingX = ma.width / this._originalElement.width, this._filterScalingY = ma.height / this._originalElement.height;
  }
  applyFilters() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.filters || [];
    if (zn = zn.filter((Jo) => Jo && !Jo.isNeutralState()), this.set("dirty", !0), this.removeTexture("".concat(this.cacheKey, "_filtered")), zn.length === 0) return this._element = this._originalElement, this._filteredEl = void 0, this._filterScalingX = 1, void (this._filterScalingY = 1);
    const Un = this._originalElement, Kn = Un.naturalWidth || Un.width, qn = Un.naturalHeight || Un.height;
    if (this._element === this._originalElement) {
      const Jo = vt({ width: Kn, height: qn });
      this._element = Jo, this._filteredEl = Jo;
    } else this._filteredEl && (this._element = this._filteredEl, this._filteredEl.getContext("2d").clearRect(0, 0, Kn, qn), this._lastScaleX = 1, this._lastScaleY = 1);
    Ko().applyFilters(zn, this._originalElement, Kn, qn, this._element, this.cacheKey), this._originalElement.width === this._element.width && this._originalElement.height === this._element.height || (this._filterScalingX = this._element.width / this._originalElement.width, this._filterScalingY = this._element.height / this._originalElement.height);
  }
  _render(zn) {
    zn.imageSmoothingEnabled = this.imageSmoothing, this.isMoving !== !0 && this.resizeFilter && this._needsResize() && this.applyResizeFilters(), this._stroke(zn), this._renderPaintInOrder(zn);
  }
  drawCacheOnCanvas(zn) {
    zn.imageSmoothingEnabled = this.imageSmoothing, super.drawCacheOnCanvas(zn);
  }
  shouldCache() {
    return this.needsItsOwnCache();
  }
  _renderFill(zn) {
    const Un = this._element;
    if (!Un) return;
    const Kn = this._filterScalingX, qn = this._filterScalingY, Jo = this.width, pa = this.height, ma = Math.max(this.cropX, 0), va = Math.max(this.cropY, 0), ba = Un.naturalWidth || Un.width, _a = Un.naturalHeight || Un.height, ya = ma * Kn, xa = va * qn, wa = Math.min(Jo * Kn, ba - ya), Ta = Math.min(pa * qn, _a - xa), Sa = -Jo / 2, Ma = -pa / 2, ka = Math.min(Jo, ba / Kn - ma), Za = Math.min(pa, _a / qn - va);
    Un && zn.drawImage(Un, ya, xa, wa, Ta, Sa, Ma, ka, Za);
  }
  _needsResize() {
    const zn = this.getTotalObjectScaling();
    return zn.x !== this._lastScaleX || zn.y !== this._lastScaleY;
  }
  _resetWidthHeight() {
    this.set(this.getOriginalSize());
  }
  _setWidthHeight() {
    let { width: zn, height: Un } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const Kn = this.getOriginalSize();
    this.width = zn || Kn.width, this.height = Un || Kn.height;
  }
  parsePreserveAspectRatioAttribute() {
    const zn = Ie(this.preserveAspectRatio || ""), Un = this.width, Kn = this.height, qn = { width: Un, height: Kn };
    let Jo, pa = this._element.width, ma = this._element.height, va = 1, ba = 1, _a = 0, ya = 0, xa = 0, wa = 0;
    return !zn || zn.alignX === j && zn.alignY === j ? (va = Un / pa, ba = Kn / ma) : (zn.meetOrSlice === "meet" && (va = ba = Pr(this._element, qn), Jo = (Un - pa * va) / 2, zn.alignX === "Min" && (_a = -Jo), zn.alignX === "Max" && (_a = Jo), Jo = (Kn - ma * ba) / 2, zn.alignY === "Min" && (ya = -Jo), zn.alignY === "Max" && (ya = Jo)), zn.meetOrSlice === "slice" && (va = ba = Er(this._element, qn), Jo = pa - Un / va, zn.alignX === "Mid" && (xa = Jo / 2), zn.alignX === "Max" && (xa = Jo), Jo = ma - Kn / ba, zn.alignY === "Mid" && (wa = Jo / 2), zn.alignY === "Max" && (wa = Jo), pa = Un / va, ma = Kn / ba)), { width: pa, height: ma, scaleX: va, scaleY: ba, offsetLeft: _a, offsetTop: ya, cropX: xa, cropY: wa };
  }
  static fromObject(zn, Un) {
    let { filters: Kn, resizeFilter: qn, src: Jo, crossOrigin: pa, type: ma } = zn, va = i$3(zn, Qo);
    return Promise.all([It(Jo, s$1(s$1({}, Un), {}, { crossOrigin: pa })), Kn && Bt(Kn, Un), qn && Bt([qn], Un), Xt(va, Un)]).then((ba) => {
      let [_a, ya = [], [xa] = [], wa = {}] = ba;
      return new this(_a, s$1(s$1({}, va), {}, { src: Jo, filters: ya, resizeFilter: xa }, wa));
    });
  }
  static fromURL(zn) {
    let { crossOrigin: Un = null, signal: Kn } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, qn = arguments.length > 2 ? arguments[2] : void 0;
    return It(zn, { crossOrigin: Un, signal: Kn }).then((Jo) => new this(Jo, qn));
  }
  static async fromElement(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Kn = arguments.length > 2 ? arguments[2] : void 0;
    const qn = dr(zn, this.ATTRIBUTE_NAMES, Kn);
    return this.fromURL(qn["xlink:href"] || qn.href, Un, qn).catch((Jo) => (a$1("log", "Unable to parse Image", Jo), null));
  }
}
function ta(Xn) {
  if (!Ke.test(Xn.nodeName)) return {};
  const zn = Xn.getAttribute("viewBox");
  let Un, Kn, qn = 1, Jo = 1, pa = 0, ma = 0;
  const va = Xn.getAttribute("width"), ba = Xn.getAttribute("height"), _a = Xn.getAttribute("x") || 0, ya = Xn.getAttribute("y") || 0, xa = !(zn && Qe.test(zn)), wa = !va || !ba || va === "100%" || ba === "100%";
  let Ta = "", Sa = 0, Ma = 0;
  if (xa && (_a || ya) && Xn.parentNode && Xn.parentNode.nodeName !== "#document" && (Ta = " translate(" + Re(_a || "0") + " " + Re(ya || "0") + ") ", Un = (Xn.getAttribute("transform") || "") + Ta, Xn.setAttribute("transform", Un), Xn.removeAttribute("x"), Xn.removeAttribute("y")), xa && wa) return { width: 0, height: 0 };
  const ka = { width: 0, height: 0 };
  if (xa) return ka.width = Re(va), ka.height = Re(ba), ka;
  const Za = zn.match(Qe);
  pa = -parseFloat(Za[1]), ma = -parseFloat(Za[2]);
  const Na = parseFloat(Za[3]), Ka = parseFloat(Za[4]);
  ka.minX = pa, ka.minY = ma, ka.viewBoxWidth = Na, ka.viewBoxHeight = Ka, wa ? (ka.width = Na, ka.height = Ka) : (ka.width = Re(va), ka.height = Re(ba), qn = ka.width / Na, Jo = ka.height / Ka);
  const Ja = Ie(Xn.getAttribute("preserveAspectRatio") || "");
  if (Ja.alignX !== j && (Ja.meetOrSlice === "meet" && (Jo = qn = qn > Jo ? Jo : qn), Ja.meetOrSlice === "slice" && (Jo = qn = qn > Jo ? qn : Jo), Sa = ka.width - Na * qn, Ma = ka.height - Ka * qn, Ja.alignX === "Mid" && (Sa /= 2), Ja.alignY === "Mid" && (Ma /= 2), Ja.alignX === "Min" && (Sa = 0), Ja.alignY === "Min" && (Ma = 0)), qn === 1 && Jo === 1 && pa === 0 && ma === 0 && _a === 0 && ya === 0) return ka;
  if ((_a || ya) && Xn.parentNode.nodeName !== "#document" && (Ta = " translate(" + Re(_a || "0") + " " + Re(ya || "0") + ") "), Un = Ta + " matrix(" + qn + " 0 0 " + Jo + " " + (pa * qn + Sa) + " " + (ma * Jo + Ma) + ") ", Xn.nodeName === "svg") {
    for (Kn = Xn.ownerDocument.createElementNS(ze, "g"); Xn.firstChild; ) Kn.appendChild(Xn.firstChild);
    Xn.appendChild(Kn);
  } else Kn = Xn, Kn.removeAttribute("x"), Kn.removeAttribute("y"), Un = Kn.getAttribute("transform") + Un;
  return Kn.setAttribute("transform", Un), ka;
}
t$1($o, "type", "Image"), t$1($o, "cacheProperties", [...ps, ...Zo]), t$1($o, "ownDefaults", { strokeWidth: 0, srcFromAttribute: !1, minimumScaleTrigger: 0.5, cropX: 0, cropY: 0, imageSmoothing: !0 }), t$1($o, "CSS_CANVAS", "canvas-img"), t$1($o, "ATTRIBUTE_NAMES", [...Fi, "x", "y", "width", "height", "preserveAspectRatio", "xlink:href", "href", "crossOrigin", "image-rendering"]), tt.setClass($o), tt.setSVGClass($o);
const ea = (Xn) => Xn.tagName.replace("svg:", ""), sa = Ye(["pattern", "defs", "symbol", "metadata", "clipPath", "mask", "desc"]);
function ia(Xn, zn) {
  let Un, Kn, qn, Jo, pa = [];
  for (qn = 0, Jo = zn.length; qn < Jo; qn++) Un = zn[qn], Kn = Xn.getElementsByTagNameNS("http://www.w3.org/2000/svg", Un), pa = pa.concat(Array.from(Kn));
  return pa;
}
const ra = ["gradientTransform", "x1", "x2", "y1", "y2", "gradientUnits", "cx", "cy", "r", "fx", "fy"], na = "xlink:href";
function oa(Xn, zn) {
  var Un;
  const Kn = ((Un = zn.getAttribute(na)) === null || Un === void 0 ? void 0 : Un.slice(1)) || "", qn = Xn.getElementById(Kn);
  if (qn && qn.getAttribute(na) && oa(Xn, qn), qn && (ra.forEach((Jo) => {
    const pa = qn.getAttribute(Jo);
    !zn.hasAttribute(Jo) && pa && zn.setAttribute(Jo, pa);
  }), !zn.children.length)) {
    const Jo = qn.cloneNode(!0);
    for (; Jo.firstChild; ) zn.appendChild(Jo.firstChild);
  }
  zn.removeAttribute(na);
}
const aa = ["linearGradient", "radialGradient", "svg:linearGradient", "svg:radialGradient"];
function ha(Xn) {
  const zn = Xn.getElementsByTagName("style");
  let Un, Kn;
  const qn = {};
  for (Un = 0, Kn = zn.length; Un < Kn; Un++) {
    const Jo = (zn[Un].textContent || "").replace(/\/\*[\s\S]*?\*\//g, "");
    Jo.trim() !== "" && Jo.split("}").filter((pa, ma, va) => va.length > 1 && pa.trim()).forEach((pa) => {
      if ((pa.match(/{/g) || []).length > 1 && pa.trim().startsWith("@")) return;
      const ma = pa.split("{"), va = {}, ba = ma[1].trim().split(";").filter(function(_a) {
        return _a.trim();
      });
      for (Un = 0, Kn = ba.length; Un < Kn; Un++) {
        const _a = ba[Un].split(":"), ya = _a[0].trim(), xa = _a[1].trim();
        va[ya] = xa;
      }
      (pa = ma[0].trim()).split(",").forEach((_a) => {
        (_a = _a.replace(/^svg/i, "").trim()) !== "" && (qn[_a] = s$1(s$1({}, qn[_a] || {}), va));
      });
    });
  }
  return qn;
}
const ca = (Xn) => tt.getSVGClass(ea(Xn).toLowerCase());
class la {
  constructor(zn, Un, Kn, qn, Jo) {
    this.elements = zn, this.options = Un, this.reviver = Kn, this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g, this.doc = qn, this.clipPaths = Jo, this.gradientDefs = function(pa) {
      const ma = ia(pa, aa), va = {};
      let ba = ma.length;
      for (; ba--; ) {
        const _a = ma[ba];
        _a.getAttribute("xlink:href") && oa(pa, _a);
        const ya = _a.getAttribute("id");
        ya && (va[ya] = _a);
      }
      return va;
    }(qn), this.cssRules = ha(qn);
  }
  parse() {
    return Promise.all(this.elements.map((zn) => this.createObject(zn)));
  }
  async createObject(zn) {
    const Un = ca(zn);
    if (Un) {
      const Kn = await Un.fromElement(zn, this.options, this.cssRules);
      return this.resolveGradient(Kn, zn, K), this.resolveGradient(Kn, zn, J), Kn instanceof $o && Kn._originalElement ? ln(Kn, Kn.parsePreserveAspectRatioAttribute()) : ln(Kn), await this.resolveClipPath(Kn, zn), this.reviver && this.reviver(zn, Kn), Kn;
    }
    return null;
  }
  extractPropertyDefinition(zn, Un, Kn) {
    const qn = zn[Un], Jo = this.regexUrl;
    if (!Jo.test(qn)) return;
    Jo.lastIndex = 0;
    const pa = Jo.exec(qn)[1];
    return Jo.lastIndex = 0, Kn[pa];
  }
  resolveGradient(zn, Un, Kn) {
    const qn = this.extractPropertyDefinition(zn, Kn, this.gradientDefs);
    if (qn) {
      const Jo = Un.getAttribute(Kn + "-opacity"), pa = Rn.fromElement(qn, zn, s$1(s$1({}, this.options), {}, { opacity: Jo }));
      zn.set(Kn, pa);
    }
  }
  async resolveClipPath(zn, Un, Kn) {
    const qn = this.extractPropertyDefinition(zn, "clipPath", this.clipPaths);
    if (qn) {
      const Jo = St(zn.calcTransformMatrix()), pa = qn[0].parentElement;
      let ma = Un;
      for (; !Kn && ma.parentElement && ma.getAttribute("clip-path") !== zn.clipPath; ) ma = ma.parentElement;
      ma.parentElement.appendChild(pa);
      const va = or("".concat(ma.getAttribute("transform") || "", " ").concat(pa.getAttribute("originalTransform") || ""));
      pa.setAttribute("transform", "matrix(".concat(va.join(","), ")"));
      const ba = await Promise.all(qn.map((Za) => ca(Za).fromElement(Za, this.options, this.cssRules).then((Na) => (ln(Na), Na.fillRule = Na.clipRule, delete Na.clipRule, Na)))), _a = ba.length === 1 ? ba[0] : new Mr(ba), ya = Tt(Jo, _a.calcTransformMatrix());
      _a.clipPath && await this.resolveClipPath(_a, ma, pa.getAttribute("clip-path") ? ma : void 0);
      const { scaleX: xa, scaleY: wa, angle: Ta, skewX: Sa, translateX: Ma, translateY: ka } = Dt(ya);
      _a.set({ flipX: !1, flipY: !1 }), _a.set({ scaleX: xa, scaleY: wa, angle: Ta, skewX: Sa, skewY: 0 }), _a.setPositionByOrigin(new ot(Ma, ka), D, D), zn.clipPath = _a;
    } else delete zn.clipPath;
  }
}
const ua = (Xn) => qe.test(ea(Xn)), da = () => ({ objects: [], elements: [], options: {}, allElements: [] });
async function ga(Xn, zn) {
  let { crossOrigin: Un, signal: Kn } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Kn && Kn.aborted) return a$1("log", new c$2("parseSVGDocument")), da();
  const qn = Xn.documentElement;
  (function(_a) {
    const ya = ia(_a, ["use", "svg:use"]), xa = ["x", "y", "xlink:href", "href", "transform"];
    for (const wa of ya) {
      const Ta = wa.attributes, Sa = {};
      for (const Qa of Ta) Qa.value && (Sa[Qa.name] = Qa.value);
      const Ma = (Sa["xlink:href"] || Sa.href || "").slice(1);
      if (Ma === "") return;
      const ka = _a.getElementById(Ma);
      if (ka === null) return;
      let Za = ka.cloneNode(!0);
      const Na = Za.attributes, Ka = {};
      for (const Qa of Na) Qa.value && (Ka[Qa.name] = Qa.value);
      const { x: Ja = 0, y: el = 0, transform: qa = "" } = Sa, tl = "".concat(qa, " ").concat(Ka.transform || "", " translate(").concat(Ja, ", ").concat(el, ")");
      if (ta(Za), /^svg$/i.test(Za.nodeName)) {
        const Qa = Za.ownerDocument.createElementNS(ze, "g");
        Object.entries(Ka).forEach((nl) => {
          let [rl, il] = nl;
          return Qa.setAttributeNS(ze, rl, il);
        }), Qa.append(...Za.childNodes), Za = Qa;
      }
      for (const Qa of Ta) {
        if (!Qa) continue;
        const { name: nl, value: rl } = Qa;
        if (!xa.includes(nl)) if (nl === "style") {
          const il = {};
          cr(rl, il), Object.entries(Ka).forEach((ll) => {
            let [al, sl] = ll;
            il[al] = sl;
          }), cr(Ka.style || "", il);
          const cl = Object.entries(il).map((ll) => ll.join(":")).join(";");
          Za.setAttribute(nl, cl);
        } else !Ka[nl] && Za.setAttribute(nl, rl);
      }
      Za.setAttribute("transform", tl), Za.setAttribute("instantiated_by_use", "1"), Za.removeAttribute("id"), wa.parentNode.replaceChild(Za, wa);
    }
  })(Xn);
  const Jo = Array.from(qn.getElementsByTagName("*")), pa = s$1(s$1({}, ta(qn)), {}, { crossOrigin: Un, signal: Kn }), ma = Jo.filter((_a) => (ta(_a), ua(_a) && !function(ya) {
    let xa = ya;
    for (; xa && (xa = xa.parentElement); ) if (xa && xa.nodeName && sa.test(ea(xa)) && !xa.getAttribute("instantiated_by_use")) return !0;
    return !1;
  }(_a)));
  if (!ma || ma && !ma.length) return s$1(s$1({}, da()), {}, { options: pa, allElements: Jo });
  const va = {};
  return Jo.filter((_a) => ea(_a) === "clipPath").forEach((_a) => {
    _a.setAttribute("originalTransform", _a.getAttribute("transform") || "");
    const ya = _a.getAttribute("id");
    va[ya] = Array.from(_a.getElementsByTagName("*")).filter((xa) => ua(xa));
  }), { objects: await new la(ma, pa, zn, Xn, va).parse(), elements: ma, options: pa, allElements: Jo };
}
function fa(Xn, zn, Un) {
  return ga(new (v$1()).DOMParser().parseFromString(Xn.trim(), "text/xml"), zn, Un);
}
const Da = (Xn) => Xn.webgl !== void 0, Pa = "precision highp float", Ea = `
    `.concat(Pa, `;
    varying vec2 vTexCoord;
    uniform sampler2D uTexture;
    void main() {
      gl_FragColor = texture2D(uTexture, vTexCoord);
    }`), Aa = ["type"], ja = ["type"], Fa = new RegExp(Pa, "g");
class La {
  get type() {
    return this.constructor.type;
  }
  constructor() {
    let zn = i$3(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Aa);
    Object.assign(this, this.constructor.defaults, zn);
  }
  getFragmentSource() {
    return Ea;
  }
  getVertexSource() {
    return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    void main() {
      vTexCoord = aPosition;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }`;
  }
  createProgram(zn) {
    let Un = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getFragmentSource(), Kn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.getVertexSource();
    const { WebGLProbe: { GLPrecision: qn = "highp" } } = p$1();
    qn !== "highp" && (Un = Un.replace(Fa, Pa.replace("highp", qn)));
    const Jo = zn.createShader(zn.VERTEX_SHADER), pa = zn.createShader(zn.FRAGMENT_SHADER), ma = zn.createProgram();
    if (!Jo || !pa || !ma) throw new h$1("Vertex, fragment shader or program creation error");
    if (zn.shaderSource(Jo, Kn), zn.compileShader(Jo), !zn.getShaderParameter(Jo, zn.COMPILE_STATUS)) throw new h$1("Vertex shader compile error for ".concat(this.type, ": ").concat(zn.getShaderInfoLog(Jo)));
    if (zn.shaderSource(pa, Un), zn.compileShader(pa), !zn.getShaderParameter(pa, zn.COMPILE_STATUS)) throw new h$1("Fragment shader compile error for ".concat(this.type, ": ").concat(zn.getShaderInfoLog(pa)));
    if (zn.attachShader(ma, Jo), zn.attachShader(ma, pa), zn.linkProgram(ma), !zn.getProgramParameter(ma, zn.LINK_STATUS)) throw new h$1('Shader link error for "'.concat(this.type, '" ').concat(zn.getProgramInfoLog(ma)));
    const va = this.getUniformLocations(zn, ma) || {};
    return va.uStepW = zn.getUniformLocation(ma, "uStepW"), va.uStepH = zn.getUniformLocation(ma, "uStepH"), { program: ma, attributeLocations: this.getAttributeLocations(zn, ma), uniformLocations: va };
  }
  getAttributeLocations(zn, Un) {
    return { aPosition: zn.getAttribLocation(Un, "aPosition") };
  }
  getUniformLocations(zn, Un) {
    const Kn = this.constructor.uniformLocations, qn = {};
    for (let Jo = 0; Jo < Kn.length; Jo++) qn[Kn[Jo]] = zn.getUniformLocation(Un, Kn[Jo]);
    return qn;
  }
  sendAttributeData(zn, Un, Kn) {
    const qn = Un.aPosition, Jo = zn.createBuffer();
    zn.bindBuffer(zn.ARRAY_BUFFER, Jo), zn.enableVertexAttribArray(qn), zn.vertexAttribPointer(qn, 2, zn.FLOAT, !1, 0, 0), zn.bufferData(zn.ARRAY_BUFFER, Kn, zn.STATIC_DRAW);
  }
  _setupFrameBuffer(zn) {
    const Un = zn.context;
    if (zn.passes > 1) {
      const Kn = zn.destinationWidth, qn = zn.destinationHeight;
      zn.sourceWidth === Kn && zn.sourceHeight === qn || (Un.deleteTexture(zn.targetTexture), zn.targetTexture = zn.filterBackend.createTexture(Un, Kn, qn)), Un.framebufferTexture2D(Un.FRAMEBUFFER, Un.COLOR_ATTACHMENT0, Un.TEXTURE_2D, zn.targetTexture, 0);
    } else Un.bindFramebuffer(Un.FRAMEBUFFER, null), Un.finish();
  }
  _swapTextures(zn) {
    zn.passes--, zn.pass++;
    const Un = zn.targetTexture;
    zn.targetTexture = zn.sourceTexture, zn.sourceTexture = Un;
  }
  isNeutralState(zn) {
    return !1;
  }
  applyTo(zn) {
    Da(zn) ? (this._setupFrameBuffer(zn), this.applyToWebGL(zn), this._swapTextures(zn)) : this.applyTo2d(zn);
  }
  applyTo2d(zn) {
  }
  getCacheKey() {
    return this.type;
  }
  retrieveShader(zn) {
    const Un = this.getCacheKey();
    return zn.programCache[Un] || (zn.programCache[Un] = this.createProgram(zn.context)), zn.programCache[Un];
  }
  applyToWebGL(zn) {
    const Un = zn.context, Kn = this.retrieveShader(zn);
    zn.pass === 0 && zn.originalTexture ? Un.bindTexture(Un.TEXTURE_2D, zn.originalTexture) : Un.bindTexture(Un.TEXTURE_2D, zn.sourceTexture), Un.useProgram(Kn.program), this.sendAttributeData(Un, Kn.attributeLocations, zn.aPosition), Un.uniform1f(Kn.uniformLocations.uStepW, 1 / zn.sourceWidth), Un.uniform1f(Kn.uniformLocations.uStepH, 1 / zn.sourceHeight), this.sendUniformData(Un, Kn.uniformLocations), Un.viewport(0, 0, zn.destinationWidth, zn.destinationHeight), Un.drawArrays(Un.TRIANGLE_STRIP, 0, 4);
  }
  bindAdditionalTexture(zn, Un, Kn) {
    zn.activeTexture(Kn), zn.bindTexture(zn.TEXTURE_2D, Un), zn.activeTexture(zn.TEXTURE0);
  }
  unbindAdditionalTexture(zn, Un) {
    zn.activeTexture(Un), zn.bindTexture(zn.TEXTURE_2D, null), zn.activeTexture(zn.TEXTURE0);
  }
  sendUniformData(zn, Un) {
  }
  createHelpLayer(zn) {
    if (!zn.helpLayer) {
      const { sourceWidth: Un, sourceHeight: Kn } = zn, qn = vt({ width: Un, height: Kn });
      zn.helpLayer = qn;
    }
  }
  toObject() {
    const zn = Object.keys(this.constructor.defaults || {});
    return s$1({ type: this.type }, zn.reduce((Un, Kn) => (Un[Kn] = this[Kn], Un), {}));
  }
  toJSON() {
    return this.toObject();
  }
  static async fromObject(zn, Un) {
    return new this(i$3(zn, ja));
  }
}
t$1(La, "type", "BaseFilter"), t$1(La, "uniformLocations", []);
const Ra = { multiply: `gl_FragColor.rgb *= uColor.rgb;
`, screen: `gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);
`, add: `gl_FragColor.rgb += uColor.rgb;
`, difference: `gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);
`, subtract: `gl_FragColor.rgb -= uColor.rgb;
`, lighten: `gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);
`, darken: `gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);
`, exclusion: `gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);
`, overlay: `
    if (uColor.r < 0.5) {
      gl_FragColor.r *= 2.0 * uColor.r;
    } else {
      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);
    }
    if (uColor.g < 0.5) {
      gl_FragColor.g *= 2.0 * uColor.g;
    } else {
      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);
    }
    if (uColor.b < 0.5) {
      gl_FragColor.b *= 2.0 * uColor.b;
    } else {
      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);
    }
    `, tint: `
    gl_FragColor.rgb *= (1.0 - uColor.a);
    gl_FragColor.rgb += uColor.rgb;
    ` };
class Ia extends La {
  getCacheKey() {
    return "".concat(this.type, "_").concat(this.mode);
  }
  getFragmentSource() {
    return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec4 uColor;
      varying vec2 vTexCoord;
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        gl_FragColor = color;
        if (color.a > 0.0) {
          `.concat(Ra[this.mode], `
        }
      }
      `);
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = new Le(this.color).getSource(), qn = this.alpha, Jo = Kn[0] * qn, pa = Kn[1] * qn, ma = Kn[2] * qn, va = 1 - qn;
    for (let ba = 0; ba < Un.length; ba += 4) {
      const _a = Un[ba], ya = Un[ba + 1], xa = Un[ba + 2];
      let wa, Ta, Sa;
      switch (this.mode) {
        case "multiply":
          wa = _a * Jo / 255, Ta = ya * pa / 255, Sa = xa * ma / 255;
          break;
        case "screen":
          wa = 255 - (255 - _a) * (255 - Jo) / 255, Ta = 255 - (255 - ya) * (255 - pa) / 255, Sa = 255 - (255 - xa) * (255 - ma) / 255;
          break;
        case "add":
          wa = _a + Jo, Ta = ya + pa, Sa = xa + ma;
          break;
        case "difference":
          wa = Math.abs(_a - Jo), Ta = Math.abs(ya - pa), Sa = Math.abs(xa - ma);
          break;
        case "subtract":
          wa = _a - Jo, Ta = ya - pa, Sa = xa - ma;
          break;
        case "darken":
          wa = Math.min(_a, Jo), Ta = Math.min(ya, pa), Sa = Math.min(xa, ma);
          break;
        case "lighten":
          wa = Math.max(_a, Jo), Ta = Math.max(ya, pa), Sa = Math.max(xa, ma);
          break;
        case "overlay":
          wa = Jo < 128 ? 2 * _a * Jo / 255 : 255 - 2 * (255 - _a) * (255 - Jo) / 255, Ta = pa < 128 ? 2 * ya * pa / 255 : 255 - 2 * (255 - ya) * (255 - pa) / 255, Sa = ma < 128 ? 2 * xa * ma / 255 : 255 - 2 * (255 - xa) * (255 - ma) / 255;
          break;
        case "exclusion":
          wa = Jo + _a - 2 * Jo * _a / 255, Ta = pa + ya - 2 * pa * ya / 255, Sa = ma + xa - 2 * ma * xa / 255;
          break;
        case "tint":
          wa = Jo + _a * va, Ta = pa + ya * va, Sa = ma + xa * va;
      }
      Un[ba] = wa, Un[ba + 1] = Ta, Un[ba + 2] = Sa;
    }
  }
  sendUniformData(zn, Un) {
    const Kn = new Le(this.color).getSource();
    Kn[0] = this.alpha * Kn[0] / 255, Kn[1] = this.alpha * Kn[1] / 255, Kn[2] = this.alpha * Kn[2] / 255, Kn[3] = this.alpha, zn.uniform4fv(Un.uColor, Kn);
  }
}
t$1(Ia, "defaults", { color: "#F95C63", mode: "multiply", alpha: 1 }), t$1(Ia, "type", "BlendColor"), t$1(Ia, "uniformLocations", ["uColor"]), tt.setClass(Ia);
const Ba = { multiply: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.rgba *= color2.rgba;
      gl_FragColor = color;
    }
    `, mask: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.a = color2.a;
      gl_FragColor = color;
    }
    ` }, Xa = ["type", "image"];
class Ya extends La {
  getCacheKey() {
    return "".concat(this.type, "_").concat(this.mode);
  }
  getFragmentSource() {
    return Ba[this.mode];
  }
  getVertexSource() {
    return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    uniform mat3 uTransformMatrix;
    void main() {
      vTexCoord = aPosition;
      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }
    `;
  }
  applyToWebGL(zn) {
    const Un = zn.context, Kn = this.createTexture(zn.filterBackend, this.image);
    this.bindAdditionalTexture(Un, Kn, Un.TEXTURE1), super.applyToWebGL(zn), this.unbindAdditionalTexture(Un, Un.TEXTURE1);
  }
  createTexture(zn, Un) {
    return zn.getCachedTexture(Un.cacheKey, Un.getElement());
  }
  calculateMatrix() {
    const zn = this.image, { width: Un, height: Kn } = zn.getElement();
    return [1 / zn.scaleX, 0, 0, 0, 1 / zn.scaleY, 0, -zn.left / Un, -zn.top / Kn, 1];
  }
  applyTo2d(zn) {
    let { imageData: { data: Un, width: Kn, height: qn }, filterBackend: { resources: Jo } } = zn;
    const pa = this.image;
    Jo.blendImage || (Jo.blendImage = pt());
    const ma = Jo.blendImage, va = ma.getContext("2d");
    ma.width !== Kn || ma.height !== qn ? (ma.width = Kn, ma.height = qn) : va.clearRect(0, 0, Kn, qn), va.setTransform(pa.scaleX, 0, 0, pa.scaleY, pa.left, pa.top), va.drawImage(pa.getElement(), 0, 0, Kn, qn);
    const ba = va.getImageData(0, 0, Kn, qn).data;
    for (let _a = 0; _a < Un.length; _a += 4) {
      const ya = Un[_a], xa = Un[_a + 1], wa = Un[_a + 2], Ta = Un[_a + 3], Sa = ba[_a], Ma = ba[_a + 1], ka = ba[_a + 2], Za = ba[_a + 3];
      switch (this.mode) {
        case "multiply":
          Un[_a] = ya * Sa / 255, Un[_a + 1] = xa * Ma / 255, Un[_a + 2] = wa * ka / 255, Un[_a + 3] = Ta * Za / 255;
          break;
        case "mask":
          Un[_a + 3] = Za;
      }
    }
  }
  sendUniformData(zn, Un) {
    const Kn = this.calculateMatrix();
    zn.uniform1i(Un.uImage, 1), zn.uniformMatrix3fv(Un.uTransformMatrix, !1, Kn);
  }
  toObject() {
    return s$1(s$1({}, super.toObject()), {}, { image: this.image && this.image.toObject() });
  }
  static async fromObject(zn, Un) {
    let { type: Kn, image: qn } = zn, Jo = i$3(zn, Xa);
    return $o.fromObject(qn, Un).then((pa) => new this(s$1(s$1({}, Jo), {}, { image: pa })));
  }
}
t$1(Ya, "type", "BlendImage"), t$1(Ya, "defaults", { mode: "multiply", alpha: 1 }), t$1(Ya, "uniformLocations", ["uTransformMatrix", "uImage"]), tt.setClass(Ya);
class Wa extends La {
  getFragmentSource() {
    return `
    precision highp float;
    uniform sampler2D uTexture;
    uniform vec2 uDelta;
    varying vec2 vTexCoord;
    const float nSamples = 15.0;
    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);
    float random(vec3 scale) {
      /* use the fragment position for a different seed per-pixel */
      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);
    }
    void main() {
      vec4 color = vec4(0.0);
      float total = 0.0;
      float offset = random(v3offset);
      for (float t = -nSamples; t <= nSamples; t++) {
        float percent = (t + offset - 0.5) / nSamples;
        float weight = 1.0 - abs(percent);
        color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;
        total += weight;
      }
      gl_FragColor = color / total;
    }
  `;
  }
  applyTo(zn) {
    Da(zn) ? (this.aspectRatio = zn.sourceWidth / zn.sourceHeight, zn.passes++, this._setupFrameBuffer(zn), this.horizontal = !0, this.applyToWebGL(zn), this._swapTextures(zn), this._setupFrameBuffer(zn), this.horizontal = !1, this.applyToWebGL(zn), this._swapTextures(zn)) : this.applyTo2d(zn);
  }
  applyTo2d(zn) {
    zn.imageData = this.simpleBlur(zn);
  }
  simpleBlur(zn) {
    let { ctx: Un, imageData: Kn, filterBackend: { resources: qn } } = zn;
    const { width: Jo, height: pa } = Kn;
    qn.blurLayer1 || (qn.blurLayer1 = pt(), qn.blurLayer2 = pt());
    const ma = qn.blurLayer1, va = qn.blurLayer2;
    ma.width === Jo && ma.height === pa || (va.width = ma.width = Jo, va.height = ma.height = pa);
    const ba = ma.getContext("2d"), _a = va.getContext("2d"), ya = 15, xa = 0.06 * this.blur * 0.5;
    let wa, Ta, Sa, Ma;
    for (ba.putImageData(Kn, 0, 0), _a.clearRect(0, 0, Jo, pa), Ma = -15; Ma <= ya; Ma++) wa = (Math.random() - 0.5) / 4, Ta = Ma / ya, Sa = xa * Ta * Jo + wa, _a.globalAlpha = 1 - Math.abs(Ta), _a.drawImage(ma, Sa, wa), ba.drawImage(va, 0, 0), _a.globalAlpha = 1, _a.clearRect(0, 0, va.width, va.height);
    for (Ma = -15; Ma <= ya; Ma++) wa = (Math.random() - 0.5) / 4, Ta = Ma / ya, Sa = xa * Ta * pa + wa, _a.globalAlpha = 1 - Math.abs(Ta), _a.drawImage(ma, wa, Sa), ba.drawImage(va, 0, 0), _a.globalAlpha = 1, _a.clearRect(0, 0, va.width, va.height);
    Un.drawImage(ma, 0, 0);
    const ka = Un.getImageData(0, 0, ma.width, ma.height);
    return ba.globalAlpha = 1, ba.clearRect(0, 0, ma.width, ma.height), ka;
  }
  sendUniformData(zn, Un) {
    const Kn = this.chooseRightDelta();
    zn.uniform2fv(Un.uDelta, Kn);
  }
  isNeutralState() {
    return this.blur === 0;
  }
  chooseRightDelta() {
    let zn = 1;
    const Un = [0, 0];
    this.horizontal ? this.aspectRatio > 1 && (zn = 1 / this.aspectRatio) : this.aspectRatio < 1 && (zn = this.aspectRatio);
    const Kn = zn * this.blur * 0.12;
    return this.horizontal ? Un[0] = Kn : Un[1] = Kn, Un;
  }
}
t$1(Wa, "type", "Blur"), t$1(Wa, "defaults", { blur: 0 }), t$1(Wa, "uniformLocations", ["uDelta"]), tt.setClass(Wa);
class Va extends La {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBrightness;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += uBrightness;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = Math.round(255 * this.brightness);
    for (let qn = 0; qn < Un.length; qn += 4) Un[qn] += Kn, Un[qn + 1] += Kn, Un[qn + 2] += Kn;
  }
  isNeutralState() {
    return this.brightness === 0;
  }
  sendUniformData(zn, Un) {
    zn.uniform1f(Un.uBrightness, this.brightness);
  }
}
t$1(Va, "type", "Brightness"), t$1(Va, "defaults", { brightness: 0 }), t$1(Va, "uniformLocations", ["uBrightness"]), tt.setClass(Va);
const za = { matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], colorsOnly: !0 };
class Ga extends La {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  varying vec2 vTexCoord;
  uniform mat4 uColorMatrix;
  uniform vec4 uConstants;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color *= uColorMatrix;
    color += uConstants;
    gl_FragColor = color;
  }`;
  }
  applyTo2d(zn) {
    const Un = zn.imageData.data, Kn = this.matrix, qn = this.colorsOnly;
    for (let Jo = 0; Jo < Un.length; Jo += 4) {
      const pa = Un[Jo], ma = Un[Jo + 1], va = Un[Jo + 2];
      if (Un[Jo] = pa * Kn[0] + ma * Kn[1] + va * Kn[2] + 255 * Kn[4], Un[Jo + 1] = pa * Kn[5] + ma * Kn[6] + va * Kn[7] + 255 * Kn[9], Un[Jo + 2] = pa * Kn[10] + ma * Kn[11] + va * Kn[12] + 255 * Kn[14], !qn) {
        const ba = Un[Jo + 3];
        Un[Jo] += ba * Kn[3], Un[Jo + 1] += ba * Kn[8], Un[Jo + 2] += ba * Kn[13], Un[Jo + 3] = pa * Kn[15] + ma * Kn[16] + va * Kn[17] + ba * Kn[18] + 255 * Kn[19];
      }
    }
  }
  sendUniformData(zn, Un) {
    const Kn = this.matrix, qn = [Kn[0], Kn[1], Kn[2], Kn[3], Kn[5], Kn[6], Kn[7], Kn[8], Kn[10], Kn[11], Kn[12], Kn[13], Kn[15], Kn[16], Kn[17], Kn[18]], Jo = [Kn[4], Kn[9], Kn[14], Kn[19]];
    zn.uniformMatrix4fv(Un.uColorMatrix, !1, qn), zn.uniform4fv(Un.uConstants, Jo);
  }
  toObject() {
    return s$1(s$1({}, super.toObject()), {}, { matrix: [...this.matrix] });
  }
}
function Ha(Xn, zn) {
  var Un;
  const Kn = (t$1(Un = class extends Ga {
    toObject() {
      return { type: this.type, colorsOnly: this.colorsOnly };
    }
  }, "type", Xn), t$1(Un, "defaults", { colorsOnly: !1, matrix: zn }), Un);
  return tt.setClass(Kn, Xn), Kn;
}
t$1(Ga, "type", "ColorMatrix"), t$1(Ga, "defaults", za), t$1(Ga, "uniformLocations", ["uColorMatrix", "uConstants"]), tt.setClass(Ga);
Ha("Brownie", [0.5997, 0.34553, -0.27082, 0, 0.186, -0.0377, 0.86095, 0.15059, 0, -0.1449, 0.24113, -0.07441, 0.44972, 0, -0.02965, 0, 0, 0, 1, 0]);
Ha("Vintage", [0.62793, 0.32021, -0.03965, 0, 0.03784, 0.02578, 0.64411, 0.03259, 0, 0.02926, 0.0466, -0.08512, 0.52416, 0, 0.02023, 0, 0, 0, 1, 0]);
Ha("Kodachrome", [1.12855, -0.39673, -0.03992, 0, 0.24991, -0.16404, 1.08352, -0.05498, 0, 0.09698, -0.16786, -0.56034, 1.60148, 0, 0.13972, 0, 0, 0, 1, 0]);
Ha("Technicolor", [1.91252, -0.85453, -0.09155, 0, 0.04624, -0.30878, 1.76589, -0.10601, 0, -0.27589, -0.2311, -0.75018, 1.84759, 0, 0.12137, 0, 0, 0, 1, 0]);
Ha("Polaroid", [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0]);
Ha("Sepia", [0.393, 0.769, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0, 0, 0, 0, 0, 1, 0]);
Ha("BlackWhite", [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]);
class $a extends La {
  constructor() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(zn), this.subFilters = zn.subFilters || [];
  }
  applyTo(zn) {
    Da(zn) && (zn.passes += this.subFilters.length - 1), this.subFilters.forEach((Un) => {
      Un.applyTo(zn);
    });
  }
  toObject() {
    return { type: this.type, subFilters: this.subFilters.map((zn) => zn.toObject()) };
  }
  isNeutralState() {
    return !this.subFilters.some((zn) => !zn.isNeutralState());
  }
  static fromObject(zn, Un) {
    return Promise.all((zn.subFilters || []).map((Kn) => tt.getClass(Kn.type).fromObject(Kn, Un))).then((Kn) => new this({ subFilters: Kn }));
  }
}
t$1($a, "type", "Composed"), tt.setClass($a);
class th extends La {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uContrast;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));
    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;
    gl_FragColor = color;
  }`;
  }
  isNeutralState() {
    return this.contrast === 0;
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = Math.floor(255 * this.contrast), qn = 259 * (Kn + 255) / (255 * (259 - Kn));
    for (let Jo = 0; Jo < Un.length; Jo += 4) Un[Jo] = qn * (Un[Jo] - 128) + 128, Un[Jo + 1] = qn * (Un[Jo + 1] - 128) + 128, Un[Jo + 2] = qn * (Un[Jo + 2] - 128) + 128;
  }
  sendUniformData(zn, Un) {
    zn.uniform1f(Un.uContrast, this.contrast);
  }
}
t$1(th, "type", "Contrast"), t$1(th, "defaults", { contrast: 0 }), t$1(th, "uniformLocations", ["uContrast"]), tt.setClass(th);
const eh = { Convolute_3_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_3_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_5_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_5_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_7_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_7_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_9_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_9_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    ` };
class sh extends La {
  getCacheKey() {
    return "".concat(this.type, "_").concat(Math.sqrt(this.matrix.length), "_").concat(this.opaque ? 1 : 0);
  }
  getFragmentSource() {
    return eh[this.getCacheKey()];
  }
  applyTo2d(zn) {
    const Un = zn.imageData, Kn = Un.data, qn = this.matrix, Jo = Math.round(Math.sqrt(qn.length)), pa = Math.floor(Jo / 2), ma = Un.width, va = Un.height, ba = zn.ctx.createImageData(ma, va), _a = ba.data, ya = this.opaque ? 1 : 0;
    let xa, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el, qa, tl;
    for (el = 0; el < va; el++) for (Ja = 0; Ja < ma; Ja++) {
      for (Ma = 4 * (el * ma + Ja), xa = 0, wa = 0, Ta = 0, Sa = 0, tl = 0; tl < Jo; tl++) for (qa = 0; qa < Jo; qa++) Za = el + tl - pa, ka = Ja + qa - pa, Za < 0 || Za >= va || ka < 0 || ka >= ma || (Na = 4 * (Za * ma + ka), Ka = qn[tl * Jo + qa], xa += Kn[Na] * Ka, wa += Kn[Na + 1] * Ka, Ta += Kn[Na + 2] * Ka, ya || (Sa += Kn[Na + 3] * Ka));
      _a[Ma] = xa, _a[Ma + 1] = wa, _a[Ma + 2] = Ta, _a[Ma + 3] = ya ? Kn[Ma + 3] : Sa;
    }
    zn.imageData = ba;
  }
  sendUniformData(zn, Un) {
    zn.uniform1fv(Un.uMatrix, this.matrix);
  }
  toObject() {
    return s$1(s$1({}, super.toObject()), {}, { opaque: this.opaque, matrix: [...this.matrix] });
  }
}
t$1(sh, "type", "Convolute"), t$1(sh, "defaults", { opaque: !1, matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0] }), t$1(sh, "uniformLocations", ["uMatrix", "uOpaque", "uHalfSize", "uSize"]), tt.setClass(sh);
const ih = "Gamma";
class rh extends La {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform vec3 uGamma;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    vec3 correction = (1.0 / uGamma);
    color.r = pow(color.r, correction.r);
    color.g = pow(color.g, correction.g);
    color.b = pow(color.b, correction.b);
    gl_FragColor = color;
    gl_FragColor.rgb *= color.a;
  }
`;
  }
  constructor() {
    let zn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(zn), this.gamma = zn.gamma || this.constructor.defaults.gamma.concat();
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = this.gamma, qn = 1 / Kn[0], Jo = 1 / Kn[1], pa = 1 / Kn[2];
    this.rgbValues || (this.rgbValues = { r: new Uint8Array(256), g: new Uint8Array(256), b: new Uint8Array(256) });
    const ma = this.rgbValues;
    for (let va = 0; va < 256; va++) ma.r[va] = 255 * Math.pow(va / 255, qn), ma.g[va] = 255 * Math.pow(va / 255, Jo), ma.b[va] = 255 * Math.pow(va / 255, pa);
    for (let va = 0; va < Un.length; va += 4) Un[va] = ma.r[Un[va]], Un[va + 1] = ma.g[Un[va + 1]], Un[va + 2] = ma.b[Un[va + 2]];
  }
  sendUniformData(zn, Un) {
    zn.uniform3fv(Un.uGamma, this.gamma);
  }
  isNeutralState() {
    const { gamma: zn } = this;
    return zn[0] === 1 && zn[1] === 1 && zn[2] === 1;
  }
  toObject() {
    return { type: ih, gamma: this.gamma.concat() };
  }
}
t$1(rh, "type", ih), t$1(rh, "defaults", { gamma: [1, 1, 1] }), t$1(rh, "uniformLocations", ["uGamma"]), tt.setClass(rh);
const nh = { average: `
    precision highp float;
    uniform sampler2D uTexture;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      float average = (color.r + color.b + color.g) / 3.0;
      gl_FragColor = vec4(average, average, average, color.a);
    }
    `, lightness: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    `, luminosity: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    ` };
class oh extends La {
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    for (let Kn, qn = 0; qn < Un.length; qn += 4) {
      const Jo = Un[qn], pa = Un[qn + 1], ma = Un[qn + 2];
      switch (this.mode) {
        case "average":
          Kn = (Jo + pa + ma) / 3;
          break;
        case "lightness":
          Kn = (Math.min(Jo, pa, ma) + Math.max(Jo, pa, ma)) / 2;
          break;
        case "luminosity":
          Kn = 0.21 * Jo + 0.72 * pa + 0.07 * ma;
      }
      Un[qn + 2] = Un[qn + 1] = Un[qn] = Kn;
    }
  }
  getCacheKey() {
    return "".concat(this.type, "_").concat(this.mode);
  }
  getFragmentSource() {
    return nh[this.mode];
  }
  sendUniformData(zn, Un) {
    zn.uniform1i(Un.uMode, 1);
  }
  isNeutralState() {
    return !1;
  }
}
t$1(oh, "type", "Grayscale"), t$1(oh, "defaults", { mode: "average" }), t$1(oh, "uniformLocations", ["uMode"]), tt.setClass(oh);
const ah = s$1(s$1({}, za), {}, { rotation: 0 });
class hh extends Ga {
  calculateMatrix() {
    const zn = this.rotation * Math.PI, Un = rt(zn), Kn = nt(zn), qn = 1 / 3, Jo = Math.sqrt(qn) * Kn, pa = 1 - Un;
    this.matrix = [Un + pa / 3, qn * pa - Jo, qn * pa + Jo, 0, 0, qn * pa + Jo, Un + qn * pa, qn * pa - Jo, 0, 0, qn * pa - Jo, qn * pa + Jo, Un + qn * pa, 0, 0, 0, 0, 0, 1, 0];
  }
  isNeutralState() {
    return this.rotation === 0;
  }
  applyTo(zn) {
    this.calculateMatrix(), super.applyTo(zn);
  }
  toObject() {
    return { type: this.type, rotation: this.rotation };
  }
}
t$1(hh, "type", "HueRotation"), t$1(hh, "defaults", ah), tt.setClass(hh);
class ch extends La {
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    for (let Kn = 0; Kn < Un.length; Kn += 4) Un[Kn] = 255 - Un[Kn], Un[Kn + 1] = 255 - Un[Kn + 1], Un[Kn + 2] = 255 - Un[Kn + 2], this.alpha && (Un[Kn + 3] = 255 - Un[Kn + 3]);
  }
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform int uInvert;
  uniform int uAlpha;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    if (uInvert == 1) {
      if (uAlpha == 1) {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);
      } else {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);
      }
    } else {
      gl_FragColor = color;
    }
  }
`;
  }
  isNeutralState() {
    return !this.invert;
  }
  sendUniformData(zn, Un) {
    zn.uniform1i(Un.uInvert, Number(this.invert)), zn.uniform1i(Un.uAlpha, Number(this.alpha));
  }
}
t$1(ch, "type", "Invert"), t$1(ch, "defaults", { alpha: !1, invert: !0 }), t$1(ch, "uniformLocations", ["uInvert", "uAlpha"]), tt.setClass(ch);
class lh extends La {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uStepH;
  uniform float uNoise;
  uniform float uSeed;
  varying vec2 vTexCoord;
  float rand(vec2 co, float seed, float vScale) {
    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);
  }
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = this.noise;
    for (let qn = 0; qn < Un.length; qn += 4) {
      const Jo = (0.5 - Math.random()) * Kn;
      Un[qn] += Jo, Un[qn + 1] += Jo, Un[qn + 2] += Jo;
    }
  }
  sendUniformData(zn, Un) {
    zn.uniform1f(Un.uNoise, this.noise / 255), zn.uniform1f(Un.uSeed, Math.random());
  }
  isNeutralState() {
    return this.noise === 0;
  }
}
t$1(lh, "type", "Noise"), t$1(lh, "defaults", { noise: 0 }), t$1(lh, "uniformLocations", ["uNoise", "uSeed"]), tt.setClass(lh);
class uh extends La {
  applyTo2d(zn) {
    let { imageData: { data: Un, width: Kn, height: qn } } = zn;
    for (let Jo = 0; Jo < qn; Jo += this.blocksize) for (let pa = 0; pa < Kn; pa += this.blocksize) {
      const ma = 4 * Jo * Kn + 4 * pa, va = Un[ma], ba = Un[ma + 1], _a = Un[ma + 2], ya = Un[ma + 3];
      for (let xa = Jo; xa < Math.min(Jo + this.blocksize, qn); xa++) for (let wa = pa; wa < Math.min(pa + this.blocksize, Kn); wa++) {
        const Ta = 4 * xa * Kn + 4 * wa;
        Un[Ta] = va, Un[Ta + 1] = ba, Un[Ta + 2] = _a, Un[Ta + 3] = ya;
      }
    }
  }
  isNeutralState() {
    return this.blocksize === 1;
  }
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBlocksize;
  uniform float uStepW;
  uniform float uStepH;
  varying vec2 vTexCoord;
  void main() {
    float blockW = uBlocksize * uStepW;
    float blockH = uBlocksize * uStepH;
    int posX = int(vTexCoord.x / blockW);
    int posY = int(vTexCoord.y / blockH);
    float fposX = float(posX);
    float fposY = float(posY);
    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);
    vec4 color = texture2D(uTexture, squareCoords);
    gl_FragColor = color;
  }
`;
  }
  sendUniformData(zn, Un) {
    zn.uniform1f(Un.uBlocksize, this.blocksize);
  }
}
t$1(uh, "type", "Pixelate"), t$1(uh, "defaults", { blocksize: 4 }), t$1(uh, "uniformLocations", ["uBlocksize"]), tt.setClass(uh);
class dh extends La {
  getFragmentSource() {
    return `
precision highp float;
uniform sampler2D uTexture;
uniform vec4 uLow;
uniform vec4 uHigh;
varying vec2 vTexCoord;
void main() {
  gl_FragColor = texture2D(uTexture, vTexCoord);
  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {
    gl_FragColor.a = 0.0;
  }
}
`;
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = 255 * this.distance, qn = new Le(this.color).getSource(), Jo = [qn[0] - Kn, qn[1] - Kn, qn[2] - Kn], pa = [qn[0] + Kn, qn[1] + Kn, qn[2] + Kn];
    for (let ma = 0; ma < Un.length; ma += 4) {
      const va = Un[ma], ba = Un[ma + 1], _a = Un[ma + 2];
      va > Jo[0] && ba > Jo[1] && _a > Jo[2] && va < pa[0] && ba < pa[1] && _a < pa[2] && (Un[ma + 3] = 0);
    }
  }
  sendUniformData(zn, Un) {
    const Kn = new Le(this.color).getSource(), qn = this.distance, Jo = [0 + Kn[0] / 255 - qn, 0 + Kn[1] / 255 - qn, 0 + Kn[2] / 255 - qn, 1], pa = [Kn[0] / 255 + qn, Kn[1] / 255 + qn, Kn[2] / 255 + qn, 1];
    zn.uniform4fv(Un.uLow, Jo), zn.uniform4fv(Un.uHigh, pa);
  }
}
t$1(dh, "type", "RemoveColor"), t$1(dh, "defaults", { color: "#FFFFFF", distance: 0.02, useAlpha: !1 }), t$1(dh, "uniformLocations", ["uLow", "uHigh"]), tt.setClass(dh);
class gh extends La {
  sendUniformData(zn, Un) {
    zn.uniform2fv(Un.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]), zn.uniform1fv(Un.uTaps, this.taps);
  }
  getFilterWindow() {
    const zn = this.tempScale;
    return Math.ceil(this.lanczosLobes / zn);
  }
  getCacheKey() {
    const zn = this.getFilterWindow();
    return "".concat(this.type, "_").concat(zn);
  }
  getFragmentSource() {
    const zn = this.getFilterWindow();
    return this.generateShader(zn);
  }
  getTaps() {
    const zn = this.lanczosCreate(this.lanczosLobes), Un = this.tempScale, Kn = this.getFilterWindow(), qn = new Array(Kn);
    for (let Jo = 1; Jo <= Kn; Jo++) qn[Jo - 1] = zn(Jo * Un);
    return qn;
  }
  generateShader(zn) {
    const Un = new Array(zn);
    for (let Kn = 1; Kn <= zn; Kn++) Un[Kn - 1] = "".concat(Kn, ".0 * uDelta");
    return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec2 uDelta;
      varying vec2 vTexCoord;
      uniform float uTaps[`.concat(zn, `];
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        float sum = 1.0;
        `).concat(Un.map((Kn, qn) => `
              color += texture2D(uTexture, vTexCoord + `.concat(Kn, ") * uTaps[").concat(qn, "] + texture2D(uTexture, vTexCoord - ").concat(Kn, ") * uTaps[").concat(qn, `];
              sum += 2.0 * uTaps[`).concat(qn, `];
            `)).join(`
`), `
        gl_FragColor = color / sum;
      }
    `);
  }
  applyToForWebgl(zn) {
    zn.passes++, this.width = zn.sourceWidth, this.horizontal = !0, this.dW = Math.round(this.width * this.scaleX), this.dH = zn.sourceHeight, this.tempScale = this.dW / this.width, this.taps = this.getTaps(), zn.destinationWidth = this.dW, super.applyTo(zn), zn.sourceWidth = zn.destinationWidth, this.height = zn.sourceHeight, this.horizontal = !1, this.dH = Math.round(this.height * this.scaleY), this.tempScale = this.dH / this.height, this.taps = this.getTaps(), zn.destinationHeight = this.dH, super.applyTo(zn), zn.sourceHeight = zn.destinationHeight;
  }
  applyTo(zn) {
    Da(zn) ? this.applyToForWebgl(zn) : this.applyTo2d(zn);
  }
  isNeutralState() {
    return this.scaleX === 1 && this.scaleY === 1;
  }
  lanczosCreate(zn) {
    return (Un) => {
      if (Un >= zn || Un <= -zn) return 0;
      if (Un < 11920929e-14 && Un > -11920929e-14) return 1;
      const Kn = (Un *= Math.PI) / zn;
      return Math.sin(Un) / Un * Math.sin(Kn) / Kn;
    };
  }
  applyTo2d(zn) {
    const Un = zn.imageData, Kn = this.scaleX, qn = this.scaleY;
    this.rcpScaleX = 1 / Kn, this.rcpScaleY = 1 / qn;
    const Jo = Un.width, pa = Un.height, ma = Math.round(Jo * Kn), va = Math.round(pa * qn);
    let ba;
    ba = this.resizeType === "sliceHack" ? this.sliceByTwo(zn, Jo, pa, ma, va) : this.resizeType === "hermite" ? this.hermiteFastResize(zn, Jo, pa, ma, va) : this.resizeType === "bilinear" ? this.bilinearFiltering(zn, Jo, pa, ma, va) : this.resizeType === "lanczos" ? this.lanczosResize(zn, Jo, pa, ma, va) : new ImageData(ma, va), zn.imageData = ba;
  }
  sliceByTwo(zn, Un, Kn, qn, Jo) {
    const pa = zn.imageData, ma = 0.5;
    let va = !1, ba = !1, _a = Un * ma, ya = Kn * ma;
    const xa = zn.filterBackend.resources;
    let wa = 0, Ta = 0;
    const Sa = Un;
    let Ma = 0;
    xa.sliceByTwo || (xa.sliceByTwo = pt());
    const ka = xa.sliceByTwo;
    (ka.width < 1.5 * Un || ka.height < Kn) && (ka.width = 1.5 * Un, ka.height = Kn);
    const Za = ka.getContext("2d");
    for (Za.clearRect(0, 0, 1.5 * Un, Kn), Za.putImageData(pa, 0, 0), qn = Math.floor(qn), Jo = Math.floor(Jo); !va || !ba; ) Un = _a, Kn = ya, qn < Math.floor(_a * ma) ? _a = Math.floor(_a * ma) : (_a = qn, va = !0), Jo < Math.floor(ya * ma) ? ya = Math.floor(ya * ma) : (ya = Jo, ba = !0), Za.drawImage(ka, wa, Ta, Un, Kn, Sa, Ma, _a, ya), wa = Sa, Ta = Ma, Ma += ya;
    return Za.getImageData(wa, Ta, qn, Jo);
  }
  lanczosResize(zn, Un, Kn, qn, Jo) {
    const pa = zn.imageData.data, ma = zn.ctx.createImageData(qn, Jo), va = ma.data, ba = this.lanczosCreate(this.lanczosLobes), _a = this.rcpScaleX, ya = this.rcpScaleY, xa = 2 / this.rcpScaleX, wa = 2 / this.rcpScaleY, Ta = Math.ceil(_a * this.lanczosLobes / 2), Sa = Math.ceil(ya * this.lanczosLobes / 2), Ma = {}, ka = { x: 0, y: 0 }, Za = { x: 0, y: 0 };
    return function Na(Ka) {
      let Ja, el, qa, tl, Qa, nl, rl, il, cl, ll, al;
      for (ka.x = (Ka + 0.5) * _a, Za.x = Math.floor(ka.x), Ja = 0; Ja < Jo; Ja++) {
        for (ka.y = (Ja + 0.5) * ya, Za.y = Math.floor(ka.y), Qa = 0, nl = 0, rl = 0, il = 0, cl = 0, el = Za.x - Ta; el <= Za.x + Ta; el++) if (!(el < 0 || el >= Un)) {
          ll = Math.floor(1e3 * Math.abs(el - ka.x)), Ma[ll] || (Ma[ll] = {});
          for (let sl = Za.y - Sa; sl <= Za.y + Sa; sl++) sl < 0 || sl >= Kn || (al = Math.floor(1e3 * Math.abs(sl - ka.y)), Ma[ll][al] || (Ma[ll][al] = ba(Math.sqrt(Math.pow(ll * xa, 2) + Math.pow(al * wa, 2)) / 1e3)), qa = Ma[ll][al], qa > 0 && (tl = 4 * (sl * Un + el), Qa += qa, nl += qa * pa[tl], rl += qa * pa[tl + 1], il += qa * pa[tl + 2], cl += qa * pa[tl + 3]));
        }
        tl = 4 * (Ja * qn + Ka), va[tl] = nl / Qa, va[tl + 1] = rl / Qa, va[tl + 2] = il / Qa, va[tl + 3] = cl / Qa;
      }
      return ++Ka < qn ? Na(Ka) : ma;
    }(0);
  }
  bilinearFiltering(zn, Un, Kn, qn, Jo) {
    let pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma, ka, Za, Na = 0;
    const Ka = this.rcpScaleX, Ja = this.rcpScaleY, el = 4 * (Un - 1), qa = zn.imageData.data, tl = zn.ctx.createImageData(qn, Jo), Qa = tl.data;
    for (xa = 0; xa < Jo; xa++) for (wa = 0; wa < qn; wa++) for (_a = Math.floor(Ka * wa), ya = Math.floor(Ja * xa), Ta = Ka * wa - _a, Sa = Ja * xa - ya, Za = 4 * (ya * Un + _a), Ma = 0; Ma < 4; Ma++) pa = qa[Za + Ma], ma = qa[Za + 4 + Ma], va = qa[Za + el + Ma], ba = qa[Za + el + 4 + Ma], ka = pa * (1 - Ta) * (1 - Sa) + ma * Ta * (1 - Sa) + va * Sa * (1 - Ta) + ba * Ta * Sa, Qa[Na++] = ka;
    return tl;
  }
  hermiteFastResize(zn, Un, Kn, qn, Jo) {
    const pa = this.rcpScaleX, ma = this.rcpScaleY, va = Math.ceil(pa / 2), ba = Math.ceil(ma / 2), _a = zn.imageData.data, ya = zn.ctx.createImageData(qn, Jo), xa = ya.data;
    for (let wa = 0; wa < Jo; wa++) for (let Ta = 0; Ta < qn; Ta++) {
      const Sa = 4 * (Ta + wa * qn);
      let Ma = 0, ka = 0, Za = 0, Na = 0, Ka = 0, Ja = 0, el = 0;
      const qa = (wa + 0.5) * ma;
      for (let tl = Math.floor(wa * ma); tl < (wa + 1) * ma; tl++) {
        const Qa = Math.abs(qa - (tl + 0.5)) / ba, nl = (Ta + 0.5) * pa, rl = Qa * Qa;
        for (let il = Math.floor(Ta * pa); il < (Ta + 1) * pa; il++) {
          let cl = Math.abs(nl - (il + 0.5)) / va;
          const ll = Math.sqrt(rl + cl * cl);
          ll > 1 && ll < -1 || (Ma = 2 * ll * ll * ll - 3 * ll * ll + 1, Ma > 0 && (cl = 4 * (il + tl * Un), el += Ma * _a[cl + 3], Za += Ma, _a[cl + 3] < 255 && (Ma = Ma * _a[cl + 3] / 250), Na += Ma * _a[cl], Ka += Ma * _a[cl + 1], Ja += Ma * _a[cl + 2], ka += Ma));
        }
      }
      xa[Sa] = Na / ka, xa[Sa + 1] = Ka / ka, xa[Sa + 2] = Ja / ka, xa[Sa + 3] = el / Za;
    }
    return ya;
  }
}
t$1(gh, "type", "Resize"), t$1(gh, "defaults", { resizeType: "hermite", scaleX: 1, scaleY: 1, lanczosLobes: 3 }), t$1(gh, "uniformLocations", ["uDelta", "uTaps"]), tt.setClass(gh);
class fh extends La {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uSaturation;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float rgMax = max(color.r, color.g);
    float rgbMax = max(rgMax, color.b);
    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;
    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;
    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = -this.saturation;
    for (let qn = 0; qn < Un.length; qn += 4) {
      const Jo = Un[qn], pa = Un[qn + 1], ma = Un[qn + 2], va = Math.max(Jo, pa, ma);
      Un[qn] += va !== Jo ? (va - Jo) * Kn : 0, Un[qn + 1] += va !== pa ? (va - pa) * Kn : 0, Un[qn + 2] += va !== ma ? (va - ma) * Kn : 0;
    }
  }
  sendUniformData(zn, Un) {
    zn.uniform1f(Un.uSaturation, -this.saturation);
  }
  isNeutralState() {
    return this.saturation === 0;
  }
}
t$1(fh, "type", "Saturation"), t$1(fh, "defaults", { saturation: 0 }), t$1(fh, "uniformLocations", ["uSaturation"]), tt.setClass(fh);
class ph extends La {
  getFragmentSource() {
    return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uVibrance;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float max = max(color.r, max(color.g, color.b));
    float avg = (color.r + color.g + color.b) / 3.0;
    float amt = (abs(max - avg) * 2.0) * uVibrance;
    color.r += max != color.r ? (max - color.r) * amt : 0.00;
    color.g += max != color.g ? (max - color.g) * amt : 0.00;
    color.b += max != color.b ? (max - color.b) * amt : 0.00;
    gl_FragColor = color;
  }
`;
  }
  applyTo2d(zn) {
    let { imageData: { data: Un } } = zn;
    const Kn = -this.vibrance;
    for (let qn = 0; qn < Un.length; qn += 4) {
      const Jo = Un[qn], pa = Un[qn + 1], ma = Un[qn + 2], va = Math.max(Jo, pa, ma), ba = (Jo + pa + ma) / 3, _a = 2 * Math.abs(va - ba) / 255 * Kn;
      Un[qn] += va !== Jo ? (va - Jo) * _a : 0, Un[qn + 1] += va !== pa ? (va - pa) * _a : 0, Un[qn + 2] += va !== ma ? (va - ma) * _a : 0;
    }
  }
  sendUniformData(zn, Un) {
    zn.uniform1f(Un.uVibrance, -this.vibrance);
  }
  isNeutralState() {
    return this.vibrance === 0;
  }
}
t$1(ph, "type", "Vibrance"), t$1(ph, "defaults", { vibrance: 0 }), t$1(ph, "uniformLocations", ["uVibrance"]), tt.setClass(ph);
class TextCarriage {
  constructor() {
    Ca(this, "object");
    Ca(this, "localPosition");
    Ca(this, "positionOffset");
    Ca(this, "enable", () => {
      this.object.object.visible = !0;
    });
    Ca(this, "disable", () => {
      this.object.object.visible = !1;
    });
    Ca(this, "setHeight", (zn) => {
      this.object.object.set("height", zn);
    });
    Ca(this, "setWidth", () => {
    });
    Ca(this, "setColor", () => {
    });
    Ca(this, "getObject", () => this.object);
    Ca(this, "setPositionOffset", (zn) => {
      this.positionOffset.x = zn.x, this.positionOffset.y = zn.y;
    });
    Ca(this, "setPosition", (zn) => {
      this.localPosition.x = zn.x, this.localPosition.y = zn.y, this.object.relativePosition = {
        y: zn.y + this.positionOffset.y,
        x: zn.x + this.positionOffset.x
      };
    });
    Ca(this, "getPosition", () => ({ ...this.localPosition }));
    this.object = {
      object: new pr({
        width: 1,
        fill: "black"
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.localPosition = { x: 0, y: 0 }, this.positionOffset = { x: 0, y: 0 };
  }
}
class TextLineSelection {
  constructor() {
    Ca(this, "object");
    Ca(this, "offset");
    Ca(this, "setOffset", (zn) => {
      this.offset = zn;
    });
    Ca(this, "setPosition", (zn) => {
      this.object.relativePosition.x = zn.x + this.offset.x, this.object.relativePosition.y = zn.y + this.offset.y;
    });
    Ca(this, "setSize", (zn, Un) => {
      this.object.object.set({
        width: zn,
        height: Un
      });
    });
    Ca(this, "getObjects", () => [this.object]);
    Ca(this, "disable", () => {
      this.object.object.visible = !1;
    });
    Ca(this, "enable", () => {
      this.object.object.visible = !0;
    });
    this.object = {
      object: new pr({
        fill: "rgba(0,140,255,0.3)"
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.offset = {
      x: 0,
      y: 0
    };
  }
}
class TextViewSelection {
  constructor() {
    Ca(this, "lineSelections");
    Ca(this, "positionOffset");
    Ca(this, "setPositionOffset", (zn) => {
      this.positionOffset = zn;
    });
    Ca(this, "setLinesSelection", (zn, Un) => {
      this.lineSelections.splice(Un.lines.length);
      for (let Kn = 0; Kn < Un.lines.length; Kn++) {
        const qn = zn.graphemePositions[Un.lines[Kn].number], Jo = zn.lineHeights[Un.lines[Kn].number], pa = qn[Un.lines[Kn].range.start].left, ma = qn[Un.lines[Kn].range.end].left + qn[Un.lines[Kn].range.end].width, va = this.getLinePosition(zn.lineHeights, Un.lines[Kn].number);
        this.lineSelections[Kn] === void 0 && (this.lineSelections[Kn] = new TextLineSelection()), this.lineSelections[Kn].setOffset(this.positionOffset), this.lineSelections[Kn].setPosition({
          x: pa,
          y: va
        }), this.lineSelections[Kn].setSize(ma - pa, Jo), this.lineSelections[Kn].enable();
      }
    });
    Ca(this, "getObjects", () => this.lineSelections.flatMap((zn) => zn.getObjects()));
    Ca(this, "disable", () => {
      for (let zn = 0; zn < this.lineSelections.length; zn++)
        this.lineSelections[zn].disable();
    });
    Ca(this, "getLinePosition", (zn, Un) => {
      let Kn = 0;
      for (let qn = 0; qn < zn.length; qn++) {
        if (Un === qn)
          return Kn;
        Kn += zn[qn];
      }
      return Kn;
    });
    this.lineSelections = [], this.positionOffset = { x: 0, y: 0 };
  }
}
class TableCell {
  constructor(zn) {
    Ca(this, "TEXT_VIEW_PADDING", { x: 6, y: 4 });
    Ca(this, "id");
    Ca(this, "row");
    Ca(this, "column");
    Ca(this, "rowSpan");
    Ca(this, "columnSpan");
    Ca(this, "width");
    Ca(this, "height");
    Ca(this, "textCarriage");
    Ca(this, "textSelection");
    Ca(this, "textObject");
    Ca(this, "backgroundObject");
    Ca(this, "focusBorderObject");
    Ca(this, "textViewPadding");
    Ca(this, "getWidthView", () => this.getLocalFrameArea().width);
    Ca(this, "getGraphemePositions", () => {
      if (this.textObject === null)
        throw new EditorError("graphic object not initialized");
      return this.textObject.object.__charBounds;
    });
    Ca(this, "getRealLineHeights", () => {
      if (this.textObject === null)
        throw new EditorError("graphic object not initialized");
      return this.textObject.object.__lineHeights;
    });
    Ca(this, "setBorderColor", (zn) => (this.backgroundObject.object.set("stroke", zn), this));
    Ca(this, "setBackground", (zn) => {
      this.backgroundObject.object.set("fill", zn);
      const Un = this.getContrastColor(zn);
      return this.focusBorderObject.object.set("fill", Un), this;
    });
    /**
     * Установка позиции относительно родительской графики.
     * @param position Позиция.
     */
    Ca(this, "setPosition", (zn) => {
      this.backgroundObject.relativePosition = zn, this.focusBorderObject.relativePosition = zn;
      const Un = {
        x: zn.x + this.TEXT_VIEW_PADDING.x,
        y: zn.y + this.TEXT_VIEW_PADDING.y
      };
      this.textViewPadding = Un, this.textObject.relativePosition = Un, this.textCarriage.setPositionOffset(Un), this.textSelection.setPositionOffset(Un);
    });
    Ca(this, "setSize", (zn, Un) => {
      zn === this.width && this.height === Un || (this.width = zn, this.height = Un, this.backgroundObject.object.set("width", zn), this.backgroundObject.object.set("height", Un), this.focusBorderObject.object.set("width", zn - 1), this.focusBorderObject.object.set("height", Un - 1), this.textObject.object.set("height", Un), this.textObject.object.set("width", zn - this.TEXT_VIEW_PADDING.x * 2));
    });
    Ca(this, "setText", (zn, Un) => {
      if (this.textObject === null)
        throw new EditorError("graphic object not initialized");
      this.textObject.object.set({
        text: zn,
        styles: Utils.text.getStylesMap(zn, Un)
      });
    });
    Ca(this, "getHeight", () => this.backgroundObject.object.height);
    Ca(this, "getTextHeight", () => this.textObject.object.height + this.TEXT_VIEW_PADDING.y * 2);
    Ca(this, "enableFocus", () => {
      this.focusBorderObject.object.visible = !0;
    });
    Ca(this, "disableFocus", () => {
      this.focusBorderObject.object.visible = !1;
    });
    Ca(this, "enableCarriage", () => {
      this.textCarriage.enable();
    });
    Ca(this, "disableCarriage", () => {
      this.textCarriage.disable();
    });
    Ca(this, "getObjects", () => [
      this.backgroundObject,
      this.focusBorderObject,
      this.textObject,
      this.textCarriage.getObject(),
      ...this.textSelection.getObjects()
    ]);
    Ca(this, "getLocalFrameArea", () => ({
      rotate: 0,
      y: this.backgroundObject.relativePosition.y,
      x: this.backgroundObject.relativePosition.x,
      height: this.backgroundObject.object.height,
      width: this.backgroundObject.object.width
    }));
    Ca(this, "getTextPadding", () => this.textViewPadding);
    Ca(this, "setLineHeight", (zn) => {
      if (this.textObject === null)
        throw new EditorError("graphic object not initialized");
      this.textObject.object.set("lineHeight", zn);
    });
    Ca(this, "setTextAlign", (zn) => {
      if (this.textObject === null)
        throw new EditorError("graphic object not initialized");
      this.textObject.object.set({ textAlign: zn });
    });
    Ca(this, "getContext", () => this.context);
    Ca(this, "getTextCarriage", () => this.textCarriage);
    Ca(this, "getTextSelection", () => this.textSelection);
    Ca(this, "getContrastColor", (zn) => {
      const Un = zn.replace(/^#/, ""), Kn = Number.parseInt(Un.substring(0, 2), 16), qn = Number.parseInt(Un.substring(2, 4), 16), Jo = Number.parseInt(Un.substring(4, 6), 16);
      return (Kn * 299 + qn * 587 + Jo * 114) / 1e3 > 128 ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)";
    });
    this.context = zn, this.id = "not initialized", this.textViewPadding = { x: 0, y: 0 }, this.textCarriage = new TextCarriage(), this.textSelection = new TextViewSelection(), this.focusBorderObject = {
      object: new pr({
        visible: !1,
        fill: "transparent"
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.backgroundObject = {
      object: new pr({
        strokeWidth: 1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.textObject = {
      object: new Yo("", {
        fontSize: Utils.text.parseFontSize(DefaultFontSize)
      }),
      relativePosition: this.TEXT_VIEW_PADDING
    }, this.width = 0, this.height = 0, this.row = 1, this.column = 1, this.rowSpan = 1, this.columnSpan = 1;
  }
}
var UIDefaultColor = /* @__PURE__ */ ((Xn) => (Xn.GRAY_900 = "#272727", Xn.GRAY_700 = "#939393", Xn.GRAY_600 = "#7f8184", Xn.GRAY_550 = "#5a5a5a", Xn.GRAY_580 = "#868686", Xn.GRAY_500 = "#c2c2c2", Xn.GRAY_400 = "#cccccc", Xn.GRAY_350 = "#eee7e7", Xn.GRAY_300 = "#eeeeee", Xn.GRAY_200 = "#d9d9d9", Xn.GRAY_100 = "#ededed", Xn.GRAY_50 = "#e0dede", Xn.BLUE_900 = "#0075ff", Xn.BLUE_700 = "#4696ff", Xn.BLUE_300 = "#d6e9ff", Xn.GREEN_900 = "#1e7049", Xn.GREEN_700 = "#00ad59", Xn.GREEN_500 = "#249C5C", Xn.WHITE = "#ffffff", Xn.BLACK = "#000000", Xn.SHADOW = "rgba(185,185,185,0.5)", Xn))(UIDefaultColor || {}), TextEventType = /* @__PURE__ */ ((Xn) => (Xn.INSERT = "insert", Xn.INSERT_TOKENS = "insert_tokens", Xn.REMOVE_LEFT = "remove_left", Xn.REMOVE_RIGHT = "remove_right", Xn.REMOVE_WORD_RIGHT = "remove_word_right", Xn.REMOVE_WORD_LEFT = "remove_word_left", Xn.LINE_BREAK = "line_break", Xn))(TextEventType || {}), RemoveMode = /* @__PURE__ */ ((Xn) => (Xn[Xn.LETTER = 0] = "LETTER", Xn[Xn.WORD = 1] = "WORD", Xn[Xn.LINE = 2] = "LINE", Xn))(RemoveMode || {});
class TextModel {
  constructor(zn) {
    Ca(this, "tokens");
    Ca(this, "moveCarriageListeners");
    Ca(this, "changeTextListeners");
    Ca(this, "changeTextActionListeners");
    Ca(this, "prevEventListeners");
    Ca(this, "splitGraphemePositions");
    Ca(this, "id");
    Ca(this, "textAlign");
    /**
     * Текущий диапазон выделения текста. Именно текста на основе токенов, а не на основе графем.
     * При расчете последняя графема строки пропущена.
     * @private
     */
    Ca(this, "selectionRange");
    /**
     * Перед какой графемой будет отображаться курсор. В конце каждой строки есть пустая графема
     * для отображения последней позиции курсора.
     * @private
     */
    Ca(this, "carriagePosition");
    Ca(this, "lineHeight");
    Ca(this, "maxTextLength");
    Ca(this, "isEnableEnter");
    Ca(this, "disableEnter", () => {
      this.isEnableEnter = !1;
    });
    /**
     * Рассчитывает покрытие каретки (курсорного положения) по представлениям текста.
     *
     * Этот метод вычисляет, какие части текста охватываются различными представлениями (views),
     * и возвращает массив объектов, содержащих информацию о положении каретки, диапазоне покрытия,
     * позициях графем и высотах строк.
     *
     * @param views - Массив представлений модели текста.
     * @returns Массив объектов, описывающих покрытие каретки для каждого представления.
     * @throws {EditorError} Если количество представлений не соответствует количеству разделенных позиций графем.
     */
    Ca(this, "getCoverages", (zn) => {
      const Un = this.getSplitGraphemePositions(), Kn = this.getText();
      if (zn.length === 1) {
        const Jo = zn[0], pa = Jo.getGraphemePositions(), ma = [];
        for (let va = 0; va < pa.length; va++) {
          ma[va] = [];
          let ba = 0;
          if (this.textAlign === TextAlign.CENTER)
            if (Jo instanceof TableCell) {
              const ya = Jo.getLocalFrameArea(), xa = Jo.getTextPadding(), wa = {
                x: xa.x - ya.x,
                y: xa.y - ya.y
              };
              ba = Jo.getWidthView() / 2 - pa[va].reduce((Ta, Sa) => Ta + Sa.width, 0) / 2 - wa.x;
            } else
              ba = Jo.getWidthView() / 2 - pa[va].reduce((_a, ya) => _a + ya.width, 0) / 2 - Jo.getTextPadding().x;
          else if (this.textAlign === TextAlign.RIGHT)
            if (Jo instanceof TableCell) {
              const ya = Jo.getLocalFrameArea(), xa = Jo.getTextPadding(), wa = {
                x: xa.x - ya.x,
                y: xa.y - ya.y
              };
              ba = Jo.getWidthView() - pa[va].reduce((Ta, Sa) => Ta + Sa.width, 0) - wa.x * 2;
            } else
              ba = Jo.getWidthView() - pa[va].reduce((_a, ya) => _a + ya.width, 0) - Jo.getTextPadding().x * 2;
          for (let _a = 0; _a < pa[va].length; _a++) {
            const ya = pa[va][_a], xa = {
              ...ya,
              left: ya.left + ba
            };
            ma[va].push(xa);
          }
        }
        return [
          {
            carriage: Jo.getTextCarriage(),
            coverage: { start: 0, end: Kn.length },
            graphemePositions: ma,
            lineHeights: Jo.getRealLineHeights(),
            view: Jo
          }
        ];
      }
      if (zn.length !== Un.length + 1)
        throw new EditorError("invalid split grapheme positions");
      const qn = [];
      for (let Jo = 0; Jo < zn.length; Jo++) {
        const pa = zn[Jo], ma = pa.getGraphemePositions(), va = [];
        for (let ba = 0; ba < ma.length; ba++) {
          va[ba] = [];
          let _a = 0;
          this.textAlign === TextAlign.CENTER ? _a = pa.getWidthView() / 2 - ma[ba].reduce((ya, xa) => ya + xa.width, 0) / 2 - pa.getTextPadding().x : this.textAlign === TextAlign.RIGHT && (_a = pa.getWidthView() - ma[ba].reduce((ya, xa) => ya + xa.width, 0) - pa.getTextPadding().x * 2);
          for (let ya = 0; ya < ma[ba].length; ya++) {
            const xa = ma[ba][ya], wa = {
              ...xa,
              left: xa.left + _a
            };
            va[ba].push(wa);
          }
        }
        qn.push({
          carriage: pa.getTextCarriage(),
          coverage: { start: 0, end: Kn.length },
          graphemePositions: va,
          lineHeights: pa.getRealLineHeights(),
          view: pa
        }), Un[Jo];
      }
      return qn;
    });
    Ca(this, "enableSelection", () => {
      const zn = this.calculateLineBreaksBeforePositionWithHyphenation(this.carriagePosition);
      this.getWordSeparatorsRight().includes(this.carriagePosition) || (this.selectionRange = {
        start: this.carriagePosition - zn,
        end: this.carriagePosition - zn
      });
    });
    Ca(this, "disableSelection", () => {
      this.selectionRange = null;
    });
    Ca(this, "isEnableSelection", () => this.selectionRange !== null);
    Ca(this, "getSplitGraphemePositions", () => this.splitGraphemePositions);
    Ca(this, "getTokensGrapheme", () => {
      let zn = "";
      const Un = [];
      for (let Kn = 0; Kn < this.tokens.length; Kn++) {
        const qn = this.tokens[Kn];
        for (let Jo = 0; Jo < qn.value.length; Jo++) {
          const pa = qn.value[Jo], ma = (() => {
            switch (qn.format) {
              case TokenFormat.Bold:
                return "bold";
              case TokenFormat.Italic:
                return "italic";
              case TokenFormat.BoldItalic:
                return "italic bold";
              default:
                return "normal";
            }
          })();
          Un.push({
            fontSize: Number.parseInt(qn.fontSize, 10),
            fontFamily: qn.fontFamily,
            fill: qn.color,
            fontStyle: ma
          }), zn += pa;
        }
      }
      return { text: zn, styles: Un };
    });
    Ca(this, "getTexture", () => ({
      id: this.id,
      textAlign: this.textAlign,
      lineHeight: this.lineHeight,
      tokens: _$2.cloneDeep(this.tokens),
      splitGraphemePositions: this.splitGraphemePositions
    }));
    /**
     * Возвращает все цвета токенов текста.
     */
    Ca(this, "getColorsTokens", () => {
      const zn = [];
      for (const Un of this.tokens)
        zn.includes(Un.color) || zn.push(Un.color);
      return zn;
    });
    /**
     * Возвращает все размеры символов токенов текста.
     */
    Ca(this, "getFontSizeTokens", () => {
      const zn = [];
      for (const Un of this.tokens)
        zn.includes(Un.fontSize) || zn.push(Un.fontSize);
      return [...new Set(zn)];
    });
    /**
     * Возвращает все шрифты символов токенов текста.
     */
    Ca(this, "getFontFamilyTokens", () => {
      const zn = [];
      for (const Un of this.tokens)
        zn.includes(Un.fontFamily) || zn.push(Un.fontFamily);
      return [...new Set(zn)];
    });
    /**
     * Возвращает все шрифты символов токенов текста.
     */
    Ca(this, "getFontFormatTokens", () => {
      const zn = [];
      for (const Un of this.tokens)
        zn.includes(Un.format) || zn.push(Un.format);
      return [...new Set(zn)];
    });
    /**
     * Возвращает цвет токена на котором находится курсор (каретка).
     */
    Ca(this, "getColorToCarriagePosition", () => {
      var zn;
      if (this.selectionRange) {
        let { start: Un, end: Kn } = this.selectionRange;
        Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
        let qn = null, Jo = 0;
        for (const pa of this.tokens) {
          const ma = Jo + pa.value.length - 1;
          if (Un <= ma && Kn >= Jo) {
            if (!qn)
              qn = pa.color;
            else if (qn !== pa.color)
              return UIDefaultColor.BLACK;
          }
          Jo += pa.value.length;
        }
        return qn ?? UIDefaultColor.BLACK;
      }
      return ((zn = this.getTokenToPosition(this.carriagePosition)) == null ? void 0 : zn.color) ?? UIDefaultColor.BLACK;
    });
    /**
     * Возвращает размер токена на котором находится курсор (каретка).
     */
    Ca(this, "getFontSizeToCarriagePosition", () => {
      var zn;
      if (this.selectionRange) {
        let { start: Un, end: Kn } = this.selectionRange;
        Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
        let qn = null, Jo = 0;
        for (const pa of this.tokens) {
          const ma = Jo + pa.value.length - 1;
          if (Un <= ma && Kn >= Jo) {
            if (!qn)
              qn = pa.fontSize;
            else if (qn !== pa.fontSize)
              return DefaultFontSize;
          }
          Jo += pa.value.length;
        }
        return qn ?? DefaultFontSize;
      }
      return ((zn = this.getTokenToPosition(this.carriagePosition)) == null ? void 0 : zn.fontSize) ?? DefaultFontSize;
    });
    /**
     * Возвращает шрифт токена на котором находится курсор (каретка).
     */
    Ca(this, "getFontFamilyToCarriagePosition", () => {
      var zn;
      if (this.selectionRange) {
        let { start: Un, end: Kn } = this.selectionRange;
        Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
        let qn = null, Jo = 0;
        for (const pa of this.tokens) {
          const ma = Jo + pa.value.length - 1;
          if (Un <= ma && Kn >= Jo) {
            if (!qn)
              qn = pa.fontFamily;
            else if (qn !== pa.fontFamily)
              return FontFamily.DEFAULT;
          }
          Jo += pa.value.length;
        }
        return qn ?? FontFamily.DEFAULT;
      }
      return ((zn = this.getTokenToPosition(this.carriagePosition)) == null ? void 0 : zn.fontFamily) ?? FontFamily.DEFAULT;
    });
    /**
     * Возвращает формат токена на котором находится курсор (каретка).
     */
    Ca(this, "getFontFormatToCarriagePosition", () => {
      var zn;
      if (this.selectionRange) {
        let { start: Un, end: Kn } = this.selectionRange;
        Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
        let qn = null, Jo = 0;
        for (const pa of this.tokens) {
          const ma = Jo + pa.value.length - 1;
          if (Un <= ma && Kn >= Jo) {
            if (!qn)
              qn = pa.format;
            else if (qn !== pa.format)
              return TokenFormat.None;
          }
          Jo += pa.value.length;
        }
        return qn ?? TokenFormat.None;
      }
      return ((zn = this.getTokenToPosition(this.carriagePosition)) == null ? void 0 : zn.format) ?? TokenFormat.None;
    });
    Ca(this, "setTexture", (zn) => {
      const { id: Un, tokens: Kn, textAlign: qn, lineHeight: Jo } = zn;
      this.id = Un, this.tokens.length = 0, this.textAlign = qn, this.lineHeight = Jo, this.tokens.push(..._$2.cloneDeep(Kn));
      const pa = this.parent.getTextViews();
      for (const ma of pa)
        ma.setTextAlign(qn);
    });
    Ca(this, "getSelectionRange", () => this.selectionRange === null ? null : {
      ...this.selectionRange
    });
    Ca(this, "moveCarriageLeft", () => {
      this.carriagePosition !== 0 && (this.selectionRange === null ? this.carriagePosition -= 1 : (this.carriagePosition = this.selectionRange.start, this.selectionRange = null, this.disableSelection()), this.callCarriageMoveListeners());
    });
    Ca(this, "moveCarriageRight", () => {
      const { text: zn } = this.getTokensGrapheme();
      this.carriagePosition !== zn.length && (this.selectionRange === null ? this.carriagePosition++ : (this.carriagePosition = this.selectionRange.end + 1, this.disableSelection()), this.callCarriageMoveListeners());
    });
    Ca(this, "selectWord", () => {
      const zn = this.getWordSeparatorsRight(), Un = this.getLineBreaks(), Kn = this.getText();
      if (this.carriagePosition <= 0 || Kn[this.carriagePosition] === " " || Kn[this.carriagePosition] === `
`)
        return;
      const qn = this.findPreviousSpaceIndex(zn, this.carriagePosition), Jo = this.findNextSpaceIndex(zn, Kn, this.carriagePosition), pa = Kn[qn] === " " && !Un.includes(qn) ? 1 : 0;
      this.selectionRange = {
        start: qn - this.calculateLineBreaksBeforePositionWithHyphenation(qn) + pa,
        end: Jo - this.calculateLineBreaksBeforePositionWithHyphenation(Jo) - 1
      }, this.carriagePosition = Jo, this.callPostChangeListeners();
    });
    /**
     * Перемещает каретку влево на одно слово, пропуская пробелы и символы до границы слова или начала строки.
     * Корректирует позицию с учётом смещения графем, отключает выделение и уведомляет слушателей.
     */
    Ca(this, "moveCarriageWordLeft", () => {
      const zn = this.getWordSeparatorsLeft();
      this.carriagePosition <= 0 || (this.carriagePosition = this.findPreviousSpaceIndex(zn, this.carriagePosition), this.disableSelection(), this.callCarriageMoveListeners());
    });
    /**
     * Перемещает каретку (курсор) и изменяет выделение вправо.
     * Если выделения нет, включает его. Если выделение есть, корректирует границы.
     *
     * @throws {EditorError} Если положение каретки некорректно.
     */
    Ca(this, "moveCarriageSelectionRight", () => {
      if (!(this.carriagePosition >= this.getText().length)) {
        if (this.selectionRange === null)
          this.enableSelection(), this.carriagePosition++;
        else {
          const zn = this.calculateLineBreaksBeforePositionWithHyphenation(this.carriagePosition), Un = this.getLineBreaks().includes(this.carriagePosition);
          this.carriagePosition === this.selectionRange.end + zn + 1 && (this.carriagePosition++, Un || (this.selectionRange.end += 1)), this.carriagePosition === this.selectionRange.start + zn && (this.carriagePosition++, Un || (this.selectionRange.start += 1));
        }
        this.callCarriageMoveListeners();
      }
    });
    /**
     * Перемещает каретку (курсор) и изменяет выделение вправо на одно слово.
     * Если выделения нет, включает его. Если выделение есть, корректирует границы.
     */
    Ca(this, "moveCarriageSelectionWordRight", () => {
      if (this.carriagePosition >= this.getText().length)
        return;
      const zn = this.getText(), Un = this.getWordSeparatorsRight(), Kn = this.calculateLineBreaksBeforePositionWithHyphenation(this.carriagePosition);
      if (this.selectionRange) {
        const qn = this.carriagePosition === this.selectionRange.end + Kn + 1, Jo = this.carriagePosition === this.selectionRange.start + Kn;
        if (qn || Jo) {
          const pa = this.findNextSpaceIndex(Un, zn, this.carriagePosition);
          if (this.carriagePosition = pa, qn ? this.selectionRange.end = pa - this.calculateLineBreaksBeforePositionWithHyphenation(pa) - 1 : this.selectionRange.start = pa - this.calculateLineBreaksBeforePositionWithHyphenation(pa), this.selectionRange.start > this.selectionRange.end) {
            const ma = this.selectionRange.start;
            this.selectionRange = {
              start: this.selectionRange.end + 1,
              end: ma - 1
            };
          }
        }
      } else {
        const qn = this.findNextSpaceIndex(Un, zn, this.carriagePosition);
        this.selectionRange = {
          start: this.carriagePosition - Kn,
          end: qn - this.calculateLineBreaksBeforePositionWithHyphenation(qn) - 1
        }, this.carriagePosition = qn;
      }
      this.callCarriageMoveListeners();
    });
    /**
     * Перемещает каретку (курсор) и изменяет выделение влево на одно слово.
     * Если выделения нет, включает его. Если выделение есть, корректирует границы.
     */
    Ca(this, "moveCarriageSelectionWordLeft", () => {
      if (this.carriagePosition <= 0)
        return;
      const zn = this.getWordSeparatorsLeft(), Un = this.calculateLineBreaksBeforePositionWithHyphenation(this.carriagePosition);
      if (this.selectionRange) {
        const Kn = this.carriagePosition === this.selectionRange.end + Un + 1, qn = this.carriagePosition === this.selectionRange.start + Un;
        if (Kn || qn) {
          const Jo = this.findPreviousSpaceIndex(zn, this.carriagePosition);
          if (this.carriagePosition = Jo, Kn ? this.selectionRange.end = Jo - this.calculateLineBreaksBeforePositionWithHyphenation(Jo) - 1 : this.selectionRange.start = Jo - this.calculateLineBreaksBeforePositionWithHyphenation(Jo), this.selectionRange.start > this.selectionRange.end) {
            const pa = this.selectionRange.start;
            this.selectionRange = {
              start: this.selectionRange.end + 1,
              end: pa - 1
            };
          }
        }
      } else {
        const Kn = this.findPreviousSpaceIndex(zn, this.carriagePosition);
        this.selectionRange = {
          start: Kn - this.calculateLineBreaksBeforePositionWithHyphenation(Kn),
          end: this.carriagePosition - Un - 1
        }, this.carriagePosition = Kn;
      }
      this.callCarriageMoveListeners();
    });
    Ca(this, "removeWordLeft", () => {
      if (this.carriagePosition <= 0)
        return;
      const zn = this.getWordSeparatorsLeft(), Un = this.findPreviousSpaceIndex(zn, this.carriagePosition);
      this.selectionRange ? (this.removeSelectionText(), this.disableSelection()) : (this.removeTextInTokens(Un, this.carriagePosition - Un), this.carriagePosition = Un), this.callCarriageMoveListeners();
    });
    /**
     * Перемещает каретку (курсор) и изменяет выделение влево.
     * Если выделения нет, включает его. Если выделение есть, корректирует границы.
     *
     * @throws {EditorError} Если положение каретки некорректно.
     */
    Ca(this, "moveCarriageSelectionLeft", () => {
      if (!(this.carriagePosition <= 0)) {
        if (this.selectionRange === null)
          this.carriagePosition--, this.enableSelection();
        else {
          const zn = this.calculateLineBreaksBeforePositionWithHyphenation(this.carriagePosition), Un = this.getLineBreaks().includes(this.carriagePosition - 1);
          this.carriagePosition === this.selectionRange.end + zn + 1 && (this.carriagePosition--, Un || (this.selectionRange.end -= 1)), this.carriagePosition === this.selectionRange.start + zn && (this.carriagePosition--, Un || (this.selectionRange.start -= 1));
        }
        this.callCarriageMoveListeners();
      }
    });
    Ca(this, "selectAllText", () => {
      const zn = this.getText().length - 1, Un = this.calculateLineBreaksBeforePositionWithHyphenation(zn);
      this.selectionRange = {
        start: 0,
        end: zn - Un
      }, this.carriagePosition = zn + 1, this.callCarriageMoveListeners();
    });
    Ca(this, "setCarriagePosition", (zn) => {
      this.carriagePosition = zn, this.disableSelection(), this.callCarriageMoveListeners();
    });
    Ca(this, "setSelection", (zn, Un) => {
      this.selectionRange = { start: zn, end: Un }, this.callCarriageMoveListeners();
    });
    Ca(this, "getCarriagePosition", () => this.carriagePosition);
    Ca(this, "getText", () => this.tokens.map((zn) => zn.value).join(""));
    Ca(this, "addPostChangeTextListener", (zn) => {
      this.changeTextListeners.push(zn);
    });
    Ca(this, "removePostChangeTextListener", (zn) => {
      const Un = this.changeTextListeners.indexOf(zn);
      if (Un === -1)
        throw new EditorError("listener not found");
      this.changeTextListeners.splice(Un, 1);
    });
    Ca(this, "addPostChangeTextActionListener", (zn) => {
      this.changeTextActionListeners.push(zn);
    });
    Ca(this, "removePostChangeTextActionListener", (zn) => {
      const Un = this.changeTextActionListeners.indexOf(zn);
      if (Un === -1)
        throw new EditorError("listener not found");
      this.changeTextActionListeners.splice(Un, 1);
    });
    Ca(this, "addPostMoveCarriageListener", (zn) => {
      this.moveCarriageListeners.push(zn);
    });
    Ca(this, "removePostMoveCarriageListener", (zn) => {
      const Un = this.moveCarriageListeners.indexOf(zn);
      if (Un === -1)
        throw new EditorError("listener not found");
      this.moveCarriageListeners.splice(Un, 1);
    });
    Ca(this, "addPrevEventListener", (zn) => {
      this.prevEventListeners.push(zn);
    });
    Ca(this, "enableOnlyNumbersMode", () => {
      this.addPrevEventListener((zn) => {
        if (zn.type === TextEventType.INSERT) {
          const Un = zn;
          if (!/^\d+$/.test(Un.data.letter))
            return !1;
        }
        return !0;
      });
    });
    Ca(this, "setMaxTextLength", (zn) => {
      this.maxTextLength = zn;
    });
    Ca(this, "action", (zn) => {
      if (!this.prevEventListeners.some((Un) => !Un(zn))) {
        if (this.maxTextLength !== null && zn.type === TextEventType.INSERT) {
          const Un = zn;
          if ((this.getText() + Un.data.letter).length > this.maxTextLength)
            return;
        }
        switch (zn.type) {
          case TextEventType.INSERT: {
            const Un = zn;
            if (this.selectionRange === null)
              this.insertText(this.carriagePosition, Un.data.letter), this.carriagePosition += 1;
            else {
              const Kn = this.calculateLinesGraphemeOffset(this.selectionRange.start);
              this.removeSelectionText(), this.insertText(this.selectionRange.start + Kn, Un.data.letter), this.carriagePosition = this.selectionRange.start + Kn + 1, this.selectionRange = null;
            }
            break;
          }
          case TextEventType.INSERT_TOKENS: {
            const Un = zn;
            if (this.selectionRange === null) {
              this.insertTokens(this.carriagePosition, ...Un.data.tokens);
              const Kn = Un.data.tokens.map((qn) => qn.value).map((qn) => qn.length).reduce((qn, Jo) => qn + Jo, 0);
              this.carriagePosition += Kn;
            } else {
              const Kn = this.calculateLinesGraphemeOffset(this.selectionRange.start);
              this.removeSelectionText(), this.insertTokens(this.selectionRange.start + Kn, ...Un.data.tokens);
              const qn = Un.data.tokens.map((Jo) => Jo.value).map((Jo) => Jo.length).reduce((Jo, pa) => Jo + pa, 0);
              this.carriagePosition = this.selectionRange.start + Kn + qn, this.selectionRange = null;
            }
            break;
          }
          case TextEventType.REMOVE_LEFT: {
            const Un = zn;
            if (this.selectionRange === null) {
              if (Un.data.mode === RemoveMode.LETTER) {
                if (this.carriagePosition === 0)
                  return;
                this.carriagePosition -= 1, this.removeTextInTokens(this.carriagePosition, 1);
              }
            } else
              this.removeSelectionText(), this.disableSelection();
            break;
          }
          case TextEventType.REMOVE_RIGHT:
            break;
          case TextEventType.REMOVE_WORD_RIGHT:
            break;
          case TextEventType.REMOVE_WORD_LEFT:
            break;
          case TextEventType.LINE_BREAK: {
            if (!this.isEnableEnter)
              return;
            if (this.selectionRange === null)
              this.insertText(this.carriagePosition, `
`), this.carriagePosition += 1;
            else {
              const Un = this.calculateLinesGraphemeOffset(this.selectionRange.start);
              this.removeSelectionText(), this.insertText(this.selectionRange.start + Un, `
`), this.carriagePosition = this.selectionRange.start + Un + 1, this.selectionRange = null;
            }
            break;
          }
        }
        this.callPostChangeListeners();
      }
    });
    Ca(this, "setColor", (zn) => {
      if (this.selectionRange === null) {
        for (const Jo of this.tokens)
          Jo.color = zn;
        this.callPostChangeListeners();
        return;
      }
      let { start: Un, end: Kn } = this.selectionRange;
      Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
      let qn = 0;
      for (let Jo = 0; Jo < this.tokens.length; Jo++) {
        const pa = this.tokens[Jo], ma = pa.value.length, va = qn, ba = qn + ma - 1;
        if (Un <= ba && Kn >= va) {
          const _a = Math.max(Un, va), ya = Math.min(Kn, ba), xa = pa.value.slice(0, _a - va), wa = pa.value.slice(_a - va, ya - va + 1), Ta = pa.value.slice(ya - va + 1);
          if (!(wa.trim() === "" && (xa.trim() !== "" || Ta.trim() !== ""))) if (Un <= va && Kn >= ba)
            pa.color = zn;
          else if (xa === " " && Ta === " " || xa.trim() === "" && Ta.trim() === "")
            pa.color = zn;
          else {
            const Ma = [];
            xa.length > 0 && Ma.push({
              ...pa,
              value: xa
            }), Ma.push({
              ...pa,
              value: wa,
              color: zn
            }), Ta.length > 0 && Ma.push({
              ...pa,
              value: Ta
            }), this.tokens.splice(Jo, 1, ...Ma), Jo += Ma.length - 1;
          }
        }
        qn += ma;
      }
      this.callPostChangeListeners();
    });
    Ca(this, "setLineHeights", (zn) => {
      this.lineHeight = zn;
      const Un = this.parent.getTextViews();
      for (const Kn of Un)
        Kn.setLineHeight(zn);
      this.callPostChangeListeners();
    });
    Ca(this, "setAlign", (zn) => {
      this.textAlign = zn;
      const Un = this.parent.getTextViews();
      for (const Kn of Un)
        Kn.setTextAlign(zn);
      this.callPostChangeListeners();
    });
    /**
     * Получает список токенов, которые находятся в текущем выделении.
     * Если выделения нет, возвращает пустой массив.
     *
     * @returns {ITokenBaseTexture[]} Массив токенов в пределах выделенного текста.
     */
    Ca(this, "getFocusTextTokens", () => {
      if (this.selectionRange === null)
        return null;
      const zn = this.calculateLinesGraphemeOffset(this.selectionRange.start), Un = this.calculateLinesGraphemeOffset(this.selectionRange.end), Kn = this.selectionRange.start + zn, qn = this.selectionRange.end + Un + 1, Jo = [];
      let pa = 0;
      for (const ma of this.tokens) {
        const va = ma.value.length;
        if (pa + va > Kn && pa < qn) {
          const ba = Math.max(0, Kn - pa), _a = Math.min(va, qn - pa);
          ba === 0 && _a === va ? Jo.push(ma) : Jo.push({
            ...ma,
            value: ma.value.slice(ba, _a)
          });
        }
        pa += va;
      }
      return Jo;
    });
    Ca(this, "setFontFamily", (zn) => {
      if (this.selectionRange === null)
        for (const Un of this.tokens)
          Un.fontFamily = zn;
      else {
        let { start: Un, end: Kn } = this.selectionRange;
        Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
        let qn = 0;
        for (let Jo = 0; Jo < this.tokens.length; Jo++) {
          const pa = this.tokens[Jo], ma = pa.value.length, va = qn, ba = qn + ma - 1;
          if (Un <= ba && Kn >= va) {
            const _a = Math.max(Un, va), ya = Math.min(Kn, ba), xa = pa.value.slice(0, _a - va), wa = pa.value.slice(_a - va, ya - va + 1), Ta = pa.value.slice(ya - va + 1);
            if (!(wa.trim() === "" && (xa.trim() !== "" || Ta.trim() !== ""))) if (Un <= va && Kn >= ba)
              pa.fontFamily = zn;
            else if (xa === " " && Ta === " " || xa.trim() === "" && Ta.trim() === "")
              pa.fontFamily = zn;
            else {
              const Ma = [];
              xa.length > 0 && Ma.push({
                ...pa,
                value: xa
              }), Ma.push({
                ...pa,
                value: wa,
                fontFamily: zn
              }), Ta.length > 0 && Ma.push({
                ...pa,
                value: Ta
              }), this.tokens.splice(Jo, 1, ...Ma), Jo += Ma.length - 1;
            }
          }
          qn += ma;
        }
      }
      this.callPostChangeListeners();
    });
    Ca(this, "setFormat", (zn) => {
      if (this.selectionRange === null)
        for (const Un of this.tokens)
          Un.format = zn;
      else {
        let { start: Un, end: Kn } = this.selectionRange;
        Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
        let qn = 0;
        for (let Jo = 0; Jo < this.tokens.length; Jo++) {
          const pa = this.tokens[Jo], ma = pa.value.length, va = qn, ba = qn + ma - 1;
          if (Un <= ba && Kn >= va) {
            const _a = Math.max(Un, va), ya = Math.min(Kn, ba), xa = pa.value.slice(0, _a - va), wa = pa.value.slice(_a - va, ya - va + 1), Ta = pa.value.slice(ya - va + 1);
            if (!(wa.trim() === "" && (xa.trim() !== "" || Ta.trim() !== ""))) if (Un <= va && Kn >= ba)
              pa.format = zn;
            else if (xa === " " && Ta === " " || xa.trim() === "" && Ta.trim() === "")
              pa.format = zn;
            else {
              const Ma = [];
              xa.length > 0 && Ma.push({
                ...pa,
                value: xa
              }), Ma.push({
                ...pa,
                value: wa,
                format: zn
              }), Ta.length > 0 && Ma.push({
                ...pa,
                value: Ta
              }), this.tokens.splice(Jo, 1, ...Ma), Jo += Ma.length - 1;
            }
          }
          qn += ma;
        }
      }
      this.callPostChangeListeners();
    });
    Ca(this, "setFontSize", (zn) => {
      if (this.selectionRange === null)
        for (const Un of this.tokens)
          Un.fontSize = zn;
      else {
        let { start: Un, end: Kn } = this.selectionRange;
        Un += this.calculateLineBreaksBeforePositionNoHyphenation(Un), Kn += this.calculateLineBreaksBeforePositionNoHyphenation(Kn);
        let qn = 0;
        for (let Jo = 0; Jo < this.tokens.length; Jo++) {
          const pa = this.tokens[Jo], ma = pa.value.length, va = qn, ba = qn + ma - 1;
          if (Un <= ba && Kn >= va) {
            const _a = Math.max(Un, va), ya = Math.min(Kn, ba), xa = pa.value.slice(0, _a - va), wa = pa.value.slice(_a - va, ya - va + 1), Ta = pa.value.slice(ya - va + 1);
            if (!(wa.trim() === "" && (xa.trim() !== "" || Ta.trim() !== ""))) if (Un <= va && Kn >= ba)
              pa.fontSize = zn;
            else if (xa === " " && Ta === " " || xa.trim() === "" && Ta.trim() === "")
              pa.fontSize = zn;
            else {
              const Ma = [];
              xa.length > 0 && Ma.push({
                ...pa,
                value: xa
              }), Ma.push({
                ...pa,
                value: wa,
                fontSize: zn
              }), Ta.length > 0 && Ma.push({
                ...pa,
                value: Ta
              }), this.tokens.splice(Jo, 1, ...Ma), Jo += Ma.length - 1;
            }
          }
          qn += ma;
        }
      }
      this.callPostChangeListeners();
    });
    Ca(this, "syncModelWithViews", () => {
      const zn = this.getTokensGrapheme(), Un = this.getTexture();
      this.getParent().getTextViews().forEach((Jo, pa) => {
        const ma = Un.splitGraphemePositions[pa];
        if (ma === void 0)
          throw new EditorError("start positions not found");
        let va = Un.splitGraphemePositions[pa + 1];
        va === void 0 && (va = zn.text.length);
        const ba = zn.text.slice(ma, va), _a = zn.styles.slice(ma, va);
        _a.map((ya) => {
          ya.fontSize !== void 0 && (ya.fontSize = ya.fontSize * 1.3);
        }), Jo.setText(ba, _a);
      });
    });
    /**
     * Синхронизация при изменении ширины текста, отключает выделение текста и синхронизирует каретку.
     */
    Ca(this, "syncWhenResizing", () => {
      this.callCarriageMoveListeners(), this.selectionRange !== null && (this.selectionRange = null, this.callPostChangeListeners());
    });
    Ca(this, "getParent", () => this.parent);
    Ca(this, "getTokens", () => [...this.tokens]);
    Ca(this, "insertTokens", (zn, ...Un) => {
      if (Un.length === 0)
        return;
      let Kn = 0;
      for (let qn = 0; qn < this.tokens.length; qn++) {
        const Jo = this.tokens[qn], pa = Jo.value.length;
        if (Kn <= zn && zn < Kn + pa) {
          const ma = zn - Kn, va = Jo.value.slice(0, ma), ba = Jo.value.slice(ma), _a = [];
          _a.push({
            ...Jo,
            value: va
          }), _a.push(...Un), _a.push({
            ...Jo,
            value: ba
          }), this.tokens.splice(qn, 1, ..._a);
          return;
        }
        Kn += pa;
      }
      zn >= Kn && (this.tokens.length > 0 ? this.tokens.push(...Un) : this.tokens.push(...Un));
    });
    Ca(this, "insertText", (zn, Un) => {
      if (Un.length === 0) {
        console.warn("Вставляемый текст пуст. Действие пропущено.");
        return;
      }
      let Kn = 0;
      for (let qn = 0; qn < this.tokens.length; qn++) {
        const Jo = this.tokens[qn], pa = Jo.value.length;
        if (Kn <= zn && zn < Kn + pa) {
          const ma = zn - Kn;
          Jo.value = Jo.value.slice(0, ma) + // Текст до позиции вставки
          Un + // Вставляемый текст
          Jo.value.slice(ma);
          return;
        }
        Kn += pa;
      }
      if (zn >= Kn)
        if (this.tokens.length > 0) {
          const qn = this.tokens[this.tokens.length - 1];
          qn.value += Un;
        } else
          this.tokens.push({
            type: TokenType.TEXT,
            value: Un,
            fontSize: FontSize.Pt14,
            // Значение по умолчанию
            fontFamily: FontFamily.DEFAULT,
            // Значение по умолчанию
            color: "#000000",
            // Черный цвет по умолчанию
            format: TokenFormat.None
          });
    });
    Ca(this, "removeSelectionText", () => {
      if (this.selectionRange === null)
        throw new EditorError("selection range not found");
      const zn = this.selectionRange.end - this.selectionRange.start + 1, Un = this.calculateLinesGraphemeOffset(this.selectionRange.start), qn = this.calculateLinesGraphemeOffset(this.selectionRange.end) - Un, Jo = this.selectionRange.start + Un;
      this.removeTextInTokens(Jo, zn + qn), this.carriagePosition = Jo;
    });
    /**
     * Удаляет указанное количество символов, начиная с заданной позиции, из токенизированного текста.
     * Индексы определяются относительно последовательности токенов, а не графемных позиций.
     * Если указано число символов для удаления, превышающее доступное количество,
     * удаляются только существующие символы.
     *
     * @param position - Начальная позиция удаления в последовательности токенов.
     * @param count - Количество символов для удаления. Должно быть больше нуля.
     * @throws {EditorError} Если `count` меньше или равен нулю.
     */
    Ca(this, "removeTextInTokens", (zn, Un) => {
      if (Un <= 0)
        throw new EditorError("Removal length is less than or equal to zero. Action skipped.");
      let Kn = 0, qn = Un;
      for (let Jo = 0; Jo < this.tokens.length; Jo++) {
        const pa = this.tokens[Jo], ma = pa.value.length;
        if (Kn + ma > zn && qn > 0) {
          const va = Math.max(0, zn - Kn), ba = Math.min(ma, va + qn);
          if (pa.value = pa.value.slice(0, va) + // Текст до удаления
          pa.value.slice(ba), qn -= ba - va, pa.value.length === 0 && this.tokens.length > 1 && (this.tokens.splice(Jo, 1), Jo--), qn <= 0)
            break;
        }
        Kn += ma;
      }
      qn > 0 && console.warn("Удаление вышло за пределы текста. Удалено только доступное количество символов.");
    });
    Ca(this, "callPostChangeListeners", () => {
      for (let zn = 0; zn < this.changeTextListeners.length; zn++)
        this.changeTextListeners[zn](this);
    });
    Ca(this, "callPostChangeActionListeners", () => {
      for (let zn = 0; zn < this.changeTextActionListeners.length; zn++)
        this.changeTextActionListeners[zn](this);
    });
    Ca(this, "callCarriageMoveListeners", () => {
      for (let zn = 0; zn < this.moveCarriageListeners.length; zn++)
        this.moveCarriageListeners[zn](this);
    });
    /**
     * Вычисляет необходимое смещение для корректного позиционирования каретки в тексте,
     * основываясь на количестве графем в предыдущих строках.
     *
     * Метод суммирует количество графем в строках, предшествующих `graphemePosition`,
     * и возвращает итоговое значение сдвига, которое необходимо прибавить к позиции.
     * Это позволяет корректно учитывать разбиение на строки при навигации по тексту.
     *
     * @param graphemePosition - Позиция буквы в последовательности графем.
     * @returns Число, определяющее, насколько нужно скорректировать позицию.
     * @throws {EditorError} Если переданная позиция выходит за границы текста.
     */
    Ca(this, "calculateLinesGraphemeOffset", (zn) => {
      const Kn = this.parent.getTextViews().flatMap((Jo) => Jo.getGraphemePositions());
      let qn = 0;
      for (let Jo = 0; Jo < Kn.length; Jo++)
        if (qn += Kn[Jo].length, qn > zn)
          return Jo;
      throw new EditorError("invalid position");
    });
    /**
     * Рассчитывает количество переносов строки до указанной позиции символа без учета переноса строк.
     * @param latterPosition - Позиция символа без учета переносов строк.
     */
    Ca(this, "calculateLineBreaksBeforePositionNoHyphenation", (zn) => {
      const Kn = this.parent.getTextViews().flatMap((Jo) => Jo.getGraphemePositions());
      if (Kn.length <= 0)
        return 0;
      let qn = 0;
      for (let Jo = 0; Jo < Kn.length; Jo++)
        if (qn += Kn[Jo].length - 1, zn <= qn - 1)
          return Jo;
      throw new EditorError("Invalid position: out of range");
    });
    /**
     * Рассчитывает количество переносов строки до указанной позиции символа с учетом переносов строк.
     * @param latterPosition - Позиция символа с учетом переносов строк.
     */
    Ca(this, "calculateLineBreaksBeforePositionWithHyphenation", (zn) => {
      const Kn = this.parent.getTextViews().flatMap((Jo) => Jo.getGraphemePositions());
      let qn = 0;
      for (let Jo = 0; Jo < Kn.length; Jo++)
        if (qn += Kn[Jo].length, zn <= qn - 1)
          return Jo;
      throw new EditorError("Invalid position: out of range");
    });
    /**
     * Возвращает все индексы переносов строк в тексте.
     */
    Ca(this, "getLineBreaks", () => {
      const zn = [], Kn = this.parent.getTextViews().flatMap((Jo) => Jo.getGraphemePositions());
      let qn = 0;
      for (let Jo = 0; Jo < Kn.length; Jo++) {
        const ma = Kn[Jo].filter((va) => va.width > 0).length;
        zn.push(qn + ma), qn += ma + 1;
      }
      return zn;
    });
    /**
     * Возвращает токен по индексу символа в тексте.
     * @param latterIndex - индекс символа с учетом переносов строк.
     */
    Ca(this, "getTokenToPosition", (zn) => {
      if (zn >= this.getText().length)
        return this.tokens[this.tokens.length - 1];
      let Un = 0;
      for (const Kn of this.tokens) {
        const qn = Kn.value.length;
        if (zn >= Un && zn < Un + qn)
          return Kn;
        Un += qn;
      }
      return null;
    });
    this.parent = zn, this.tokens = [], this.selectionRange = null, this.carriagePosition = 0, this.maxTextLength = null, this.lineHeight = LineHeight.SMALL, this.textAlign = TextAlign.LEFT, this.splitGraphemePositions = [0], this.changeTextListeners = [], this.changeTextActionListeners = [], this.moveCarriageListeners = [], this.prevEventListeners = [], this.id = "not initialized", this.isEnableEnter = !0, this.addPostChangeTextListener(this.syncModelWithViews);
  }
  /**
   * Перемещает каретку вправо на одно слово, пропуская пробелы и символы до границы слова или конца строки.
   * Корректирует позицию с учётом смещения графем, отключает выделение и уведомляет слушателей.
   */
  moveCarriageWordRight() {
    const zn = this.getText(), Un = this.getWordSeparatorsRight();
    this.carriagePosition >= zn.length || (this.carriagePosition = this.findNextSpaceIndex(Un, zn, this.carriagePosition), this.disableSelection(), this.callCarriageMoveListeners());
  }
  /**
   * Функция для получения индексов всех разделителей слов в тексте.
   * Если несколько пробелов то берется индекс крайнего ЛЕВОГО пробела.
   * Разделителем слова считается пробел или перенос строки
   */
  getWordSeparatorsRight() {
    return [...`${this.getText()} `].reduce((Un, Kn, qn, Jo) => ((Kn === " " || Kn === `
`) && (qn === 0 || Jo[qn - 1] !== " ") && Un.push(qn), Un), []);
  }
  /**
   * Функция для получения индексов всех разделителей слов в тексте.
   * Если несколько пробелов рядом, то берется индекс крайнего ПРАВОГО пробела.
   * Разделителем слова считается пробел или перенос строки
   */
  getWordSeparatorsLeft() {
    const zn = this.getText(), Un = [];
    let Kn = "";
    for (let qn = 0; qn < zn.length; qn++) {
      const Jo = zn[qn];
      (Jo === " " || Jo === `
`) && Kn !== " " && Un.push(qn + 1), Kn = Jo;
    }
    return Un;
  }
  /**
   * Функция для нахождения ближайшего пробела справа от индекса буквы в тексте.
   */
  findNextSpaceIndex(zn, Un, Kn) {
    const qn = zn.filter((Jo) => Jo > Kn);
    return qn.length > 0 ? qn[0] : Un.length;
  }
  /**
   * Функция для нахождения ближайшего пробела слева от индекса буквы в тексте.
   */
  findPreviousSpaceIndex(zn, Un) {
    const Kn = zn.filter((qn) => qn < Un);
    return Kn.length > 0 ? Kn[Kn.length - 1] : 0;
  }
}
class ControlTableCell extends TableCell {
  constructor(Un) {
    super(Un);
    Ca(this, "isContextExtend", !1);
  }
}
class ExtendTableCell extends TableCell {
  constructor(Un) {
    super(Un);
    Ca(this, "isContextExtend", !0);
  }
}
class TableCellContext {
  constructor(zn) {
    // Функциональная ячейка, в которую будет происходить ввод текста.
    Ca(this, "controlCell");
    // Ячейки расширения, не несут никакой логической нагрузки, только для визуализации.
    Ca(this, "extendCells");
    Ca(this, "texture");
    Ca(this, "textModel");
    Ca(this, "isFocus");
    Ca(this, "currentTableStartRows");
    /**
     * Ставит курсор текста внутрь ячейки.
     */
    Ca(this, "enableCarriage", () => {
      this.controlCell.enableCarriage();
    });
    Ca(this, "disableCarriage", () => {
      this.controlCell.disableCarriage();
    });
    Ca(this, "enableMutationMode", () => {
    });
    Ca(this, "disableMutationMode", () => {
    });
    Ca(this, "setTableStartRows", (zn) => {
      const Un = zn.filter((Kn) => Kn !== 0);
      this.currentTableStartRows.toString() !== Un.toString() && (this.currentTableStartRows = Un, this.rebuildCells());
    });
    Ca(this, "addPostChangeModelListener", (zn) => {
      this.textModel.addPostChangeTextListener(zn);
    });
    Ca(this, "rebuildCells", () => {
      const zn = [];
      for (let qn = 0; qn < this.currentTableStartRows.length; qn++)
        this.currentTableStartRows[qn] > this.texture.row && this.currentTableStartRows[qn] < this.texture.row + this.texture.rowSpan && zn.push(this.currentTableStartRows[qn] - this.texture.row);
      const Un = [];
      let Kn = this.texture.row;
      for (let qn = 0; qn < zn.length; qn++) {
        const Jo = Kn, pa = this.texture.row + zn[qn] - Kn, ma = {
          id: this.texture.id,
          row: Jo,
          rowSpan: pa,
          column: this.texture.column,
          columnSpan: this.texture.columnSpan
        };
        Un.push(ma), Kn += pa;
      }
      Un.push({
        id: this.texture.id,
        row: Kn,
        rowSpan: this.texture.row + this.texture.rowSpan - Kn,
        column: this.texture.column,
        columnSpan: this.texture.columnSpan
      }), this.applyCellProperties(Un);
    });
    Ca(this, "getTexture", () => ({
      ...this.texture,
      content: this.textModel.getTexture()
    }));
    Ca(this, "enableFocus", () => {
      this.isFocus || (this.controlCell.enableFocus(), this.extendCells.forEach((zn) => zn.enableFocus()), this.isFocus = !0);
    });
    Ca(this, "disableFocus", () => {
      this.isFocus && (this.controlCell.disableFocus(), this.extendCells.forEach((zn) => zn.disableFocus()), this.isFocus = !1);
    });
    Ca(this, "setBackground", (zn) => {
      this.texture.background = zn, this.controlCell.setBackground(zn), this.extendCells.forEach((Un) => Un.setBackground(zn));
    });
    Ca(this, "setTextAlign", (zn) => {
      this.texture.content.textAlign = zn, this.textModel.setAlign(zn), this.textModel.syncModelWithViews(), this.controlCell.setTextAlign(zn), this.extendCells.forEach((Un) => Un.setTextAlign(zn));
    });
    Ca(this, "syncTextModelWhenResizing", () => {
      this.textModel.syncWhenResizing();
    });
    Ca(this, "setBorderColor", (zn) => {
      this.controlCell.setBorderColor(zn), this.extendCells.forEach((Un) => {
        Un.setBorderColor(zn);
      });
    });
    Ca(this, "getTextViews", () => [this.controlCell, ...this.extendCells]);
    Ca(this, "getCarriageCoverages", () => this.textModel.getCoverages([this.controlCell, ...this.extendCells]));
    Ca(this, "getID", () => this.texture.id);
    Ca(this, "hasFocus", () => this.isFocus);
    Ca(this, "getTextModel", () => this.textModel);
    Ca(this, "getTableCells", () => [this.controlCell, ...this.extendCells]);
    Ca(this, "buildControlTableCell", (zn) => {
      const Un = new ControlTableCell(this);
      return this.setupBaseTableCell(Un, zn), Un;
    });
    Ca(this, "buildExtendTableCell", (zn) => {
      const Un = new ExtendTableCell(this);
      return this.setupBaseTableCell(Un, zn), Un;
    });
    Ca(this, "setupBaseTableCell", (zn, Un) => {
      const { id: Kn, row: qn, rowSpan: Jo, column: pa, columnSpan: ma } = Un;
      zn.id = Kn, zn.row = qn, zn.rowSpan = Jo, zn.column = pa, zn.columnSpan = ma, zn.setBackground(this.texture.background);
    });
    Ca(this, "applyCellProperties", (zn) => {
      if (zn[0] === null)
        throw new EditorError("functional cell property not found");
      this.applyCellPropertiesToCell(this.controlCell, zn[0]), this.extendCells.length = zn.length - 1;
      for (let Un = 1; Un < zn.length; Un++)
        this.extendCells[Un - 1] === void 0 ? this.extendCells[Un - 1] = this.buildExtendTableCell(zn[Un]) : this.applyCellPropertiesToCell(this.extendCells[Un - 1], zn[Un]);
    });
    Ca(this, "applyCellPropertiesToCell", (zn, Un) => {
      zn.row = Un.row, zn.column = Un.column, zn.rowSpan = Un.rowSpan, zn.columnSpan = Un.columnSpan;
    });
    this.texture = _$2.cloneDeep(zn), this.textModel = new TextModel(this), this.controlCell = this.buildControlTableCell(zn), this.isFocus = !1, this.extendCells = [], this.currentTableStartRows = [], this.textModel.setTexture(zn.content);
  }
}
class TableGridAreas {
  constructor(zn) {
    Ca(this, "map");
    Ca(this, "sync", () => {
      const zn = this.tableComponent.getCellContexts(), Un = this.tableComponent.getRowHeights(), Kn = this.tableComponent.getColumnWidths(), qn = zn.flatMap((ba) => ba.getTableCells());
      this.map = [];
      const Jo = [0], pa = [0];
      for (let ba = 0; ba < Un.length; ba++)
        Jo[ba + 1] = Jo[ba] + Un[ba];
      for (let ba = 0; ba < Kn.length; ba++)
        pa[ba + 1] = pa[ba] + Kn[ba];
      for (let ba = 0; ba < qn.length; ba++)
        for (let _a = qn[ba].row; _a < qn[ba].row + qn[ba].rowSpan; _a++)
          for (let ya = qn[ba].column; ya < qn[ba].column + qn[ba].columnSpan; ya++)
            if (this.map[_a] === void 0 && (this.map[_a] = []), this.map[_a][ya])
              ya + 1 >= qn[ba].column || (this.map[_a][ya + 1] = this.map[_a][ya], qn[ba].columnSpan = qn[ba].columnSpan + 1);
            else {
              const xa = pa[ya], wa = Jo[_a], Ta = pa[ya + qn[ba].columnSpan] - pa[ya], Sa = Jo[_a + qn[ba].rowSpan] - Jo[_a];
              this.map[_a][ya] = {
                cell: qn[ba],
                absoluteRow: _a,
                absoluteColumn: ya,
                frame: {
                  x: xa,
                  y: wa,
                  width: Ta,
                  height: Sa,
                  rotate: 0
                }
              };
            }
      const ma = this.tableComponent.getColumnCount();
      if (!this.validateMap(ma))
        throw new EditorError("table map not valid");
    });
    Ca(this, "getMap", () => {
      if (this.map === null)
        throw new EditorError("map not initialized");
      return this.map.map((zn) => [...zn]);
    });
    Ca(this, "validateMap", (zn) => {
      if (this.map === null)
        throw new EditorError("map not initialized");
      for (let Un = 0; Un < this.map.length; Un++)
        for (let Kn = 0; Kn < zn; Kn++)
          if (this.map[Un][Kn] === void 0)
            return console.log(`position: row(${Un}) column(${Kn})`), console.log(this.map), !1;
      return !0;
    });
    this.tableComponent = zn, this.map = null;
  }
}
class SpatialArea {
  constructor() {
    Ca(this, "isDirty");
    /** Проверить, требует ли область перерисовки */
    Ca(this, "isDirtyArea", () => this.isDirty);
    /**
     * Предназначена ли область для изменения размеров элемента.
     */
    Ca(this, "isResizeType", () => !1);
    /**
     * Является ли область активным покрытием текста.
     */
    Ca(this, "isTextPlace", () => !1);
    this.isDirty = !1;
  }
  /** Пометить область как изменённую */
  markDirty() {
    this.isDirty = !0;
  }
  /** Сбросить флаг изменения после перерисовки */
  clearDirty() {
    this.isDirty = !1;
  }
}
var SpatialCanvasAreaType = /* @__PURE__ */ ((Xn) => (Xn.GRAPHIC = "GRAPHIC", Xn.GRAPHIC_RESIZE = "GRAPHIC_RESIZE", Xn.GRAPHIC_ANGULAR_RESIZE = "GRAPHIC_ANGULAR_RESIZE", Xn.PICTURE = "PICTURE", Xn.PICTURE_RESIZE = "PICTURE_RESIZE", Xn.PICTURE_ANGULAR_RESIZE = "PICTURE_ANGULAR_RESIZE", Xn.TABLE_COLUMN_RESIZE = "TABLE_COLUMN_RESIZE", Xn.TABLE_ROW_RESIZE = "TABLE_ROW_RESIZE", Xn.TABLE_CELL = "TABLE_CELL", Xn.BUTTON = "CANVAS_BUTTON", Xn))(SpatialCanvasAreaType || {});
class SpatialTableCellArea extends SpatialArea {
  constructor(Un, Kn, qn, Jo) {
    super();
    Ca(this, "type", SpatialCanvasAreaType.TABLE_CELL);
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.cell.getLocalFrameArea(), Kn = this.graphic.getGlobalPosition();
      return {
        ...Un,
        x: Kn.x + Un.x,
        y: Kn.y + Un.y
      };
    });
    Ca(this, "getRelatedFrames", () => []);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "isTextPlace", () => !0);
    Ca(this, "getData", () => ({
      graphic: this.graphic,
      areaCell: this.cell,
      component: this.component,
      areaCellContext: this.cellContext
    }));
    this.component = Un, this.graphic = Kn, this.cellContext = qn, this.cell = Jo;
  }
}
var SearchPositionTableCell = /* @__PURE__ */ ((Xn) => (Xn[Xn.CELL_ABOVE = 0] = "CELL_ABOVE", Xn[Xn.CELL_BELOW = 1] = "CELL_BELOW", Xn[Xn.CELL_LEFT = 2] = "CELL_LEFT", Xn[Xn.CELL_RIGHT = 3] = "CELL_RIGHT", Xn))(SearchPositionTableCell || {});
class TableComponent extends GraphicComponent {
  constructor() {
    super();
    Ca(this, "type", EditorComponentType.TABLE);
    Ca(this, "DEFAULT_ROW_HEIGHT", 32);
    Ca(this, "DEFAULT_ROW_MARGIN", 20);
    Ca(this, "DEFAULT_COLUMN_WIDTH", 100);
    // Слушатели события автоматического изменения высоты ячеек.
    Ca(this, "postCellInputExternalListeners");
    Ca(this, "cellPositioner");
    Ca(this, "gridAreas");
    Ca(this, "cellTextures");
    Ca(this, "cellContexts");
    Ca(this, "cellSpatialAreas");
    Ca(this, "activeEditCellContext");
    // Коллекция номеров абсолютных строк, с которых начинает отображать строки каждая графика.
    Ca(this, "startRows");
    Ca(this, "borderColor");
    Ca(this, "rowHeights");
    Ca(this, "columnWidths");
    Ca(this, "currentRow");
    Ca(this, "currentColumn");
    Ca(this, "getColorsContextTable", () => {
      const Un = this.getFocusCellContexts();
      return Un !== null ? Un.map((qn) => qn.getTexture().background) : this.getCellContexts().map((qn) => qn.getTexture().background);
    });
    Ca(this, "syncCellPositions", () => {
      this.cellPositioner.sync();
    });
    Ca(this, "setActiveEditCellContext", (Un) => {
      this.activeEditCellContext = Un;
    });
    Ca(this, "getActiveEditCellContext", () => this.activeEditCellContext);
    Ca(this, "mutateCellTextures", async (Un) => {
      if (_$2.isEqual(this.cellTextures, Un))
        return;
      this.cellTextures = Un;
      const Kn = Un.map((qn) => {
        const Jo = new TableCellContext(qn);
        return Jo.getTextModel().setAlign(qn.content.textAlign), Jo.getTextModel().syncModelWithViews(), Jo.addPostChangeModelListener(this.postCellInputListener), Jo;
      });
      this.cellContexts = [...Kn], this.gridAreas.sync();
    });
    Ca(this, "setFocusCellTextAlign", (Un) => {
      const Kn = this.getFocusCellContexts();
      if (Kn === null) {
        const qn = this.getCellContexts();
        for (const Jo of qn)
          Jo.setTextAlign(Un);
        return;
      }
      for (const qn of Kn)
        qn.setTextAlign(Un);
    });
    Ca(this, "mutateColumnWidths", (Un) => {
      this.columnWidths = Un, this.syncTextModelContexts();
    });
    Ca(this, "mutateRowHeights", (Un) => {
      this.rowHeights = Un;
    });
    Ca(this, "mutateBorderColor", (Un) => {
      this.borderColor = Un;
    });
    Ca(this, "mutateStartRows", async (Un) => {
      if (this.cellContexts === null)
        throw new EditorError("cell context not found");
      this.startRows = Un;
      const Kn = this.getRowCount(), qn = this.getGraphics();
      for (let Jo = 0; Jo < qn.length; Jo++) {
        const pa = Jo < Un.length - 1 ? Un[Jo + 1] - Un[Jo] : Kn - Un[Jo];
        await qn[Jo].setTexture((ma) => ({
          ...ma,
          rowCount: pa
        }));
      }
    });
    /**
     * Инициализирует множители высоты строк, если изначально таблица была сохранена без них,
     * например в старых версиях шаблонов, в которых ещё не был предусмотрен функционал высоты строк.
     */
    Ca(this, "mutateInitRowMultipliers", () => {
      const Un = this.getDefaultRowHeight(), Kn = this.getRowProperties(), qn = [];
      Kn.forEach((Jo) => qn.push(Jo.height / Un)), this.rowHeights = qn;
    });
    /**
     * Синхронизирует реальную высоту строки с высотой в памяти по минимальной высоте контента внутри строки.
     */
    Ca(this, "mutateSyncRealRowHeight", () => {
      if (this.rowHeights === null)
        throw new EditorError("rows multipliers not initialized");
      const Un = this.getRowCount();
      if (this.rowHeights.length !== Un)
        throw new EditorError("invalid row heights count");
      const Kn = [...this.rowHeights], qn = this.getCellsFromRow();
      for (let Jo = 0; Jo < Un; Jo++)
        if (qn[Jo] !== void 0) {
          const pa = this.calculateRealRowHeight(qn, Jo);
          Kn[Jo] !== pa && (pa < this.DEFAULT_ROW_HEIGHT ? Kn[Jo] = this.DEFAULT_ROW_HEIGHT : Kn[Jo] = pa);
        }
      this.rowHeights = Kn;
    });
    Ca(this, "calculateRealRowHeight", (Un, Kn) => Math.max(...Un[Kn].map((qn) => qn.getTextHeight())));
    Ca(this, "applyMutations", () => {
      const Un = this.getGraphics();
      if (Un.length === 0 || this.cellContexts === null)
        throw new EditorError("graphics not found");
      this.cellContexts.forEach((qn) => {
        qn.setTableStartRows(this.startRows), qn.setBorderColor(this.borderColor);
      }), this.gridAreas.sync();
      const Kn = this.gridAreas.getMap();
      Un.forEach((qn, Jo) => {
        const pa = this.calculateRowHeightsForGraphic(qn), ma = this.startRows[Jo], va = this.startRows[Jo + 1], ya = Kn.slice(ma, va).flat().map((xa) => xa.cell);
        qn.setRowHeights(pa), qn.setColumnWidths(this.columnWidths), qn.setCurrentRenderCells(ya);
      }), this.cellPositioner.sync();
    });
    /**
     * Возвращает все пространственные области таблицы.
     * Перегрузка вызвана добавлением областей ячеек.
     */
    Ca(this, "getSpatialAreas", () => {
      const Un = [], Kn = this.getGraphics(), qn = this.getCellAreas();
      qn.length !== this.cellSpatialAreas.length && (this.cellSpatialAreas = qn), this.isEnableEditMode() && Un.push(...this.cellSpatialAreas), Un.push(...Kn.flatMap((ma) => ma.getSpatialAreas()));
      const Jo = this.getFirstGraphic();
      if (Jo === null)
        throw new EditorError("first graphic of table is null");
      if (Jo.getSpatialGraphicArea().isDirtyArea())
        for (let ma = 0; ma < this.cellSpatialAreas.length; ma++)
          this.cellSpatialAreas[ma].markDirty();
      return Un;
    });
    /**
     * Возвращает базовую высоту строки таблицы.
     * Используется для вычисления фактической высоты строки по множителю.
     */
    Ca(this, "getDefaultColumnWidth", () => this.DEFAULT_COLUMN_WIDTH);
    Ca(this, "getDefaultRowHeight", () => this.DEFAULT_ROW_HEIGHT);
    Ca(this, "getStartRows", () => this.startRows);
    Ca(this, "getColumnCount", () => this.columnWidths.length);
    Ca(this, "getRowCount", () => this.rowHeights.length);
    Ca(this, "getBorderColor", () => this.borderColor);
    Ca(this, "getColumnWidths", () => this.columnWidths);
    Ca(this, "getRowHeights", () => this.rowHeights);
    /**
     * Возвращает словарь, в котором key - идентификатор ячейки, а value - сам объект ячейки.
     * @param cells - структуры ячеек, по которым будет генерироваться словарь.
     */
    Ca(this, "getIDCellToTableCell", (Un) => {
      const Kn = /* @__PURE__ */ new Map();
      return Un.forEach((qn) => Kn.set(qn.id, qn)), Kn;
    });
    Ca(this, "getFocusCellContexts", () => {
      if (this.cellContexts === null)
        return null;
      if (!this.isEnableEditMode())
        return this.cellContexts;
      const Un = this.cellContexts.filter((Kn) => Kn.hasFocus());
      return Un.length === 0 ? null : Un;
    });
    Ca(this, "moveFocusTableCell", (Un) => {
      if (this.activeEditCellContext !== null) {
        const Kn = this.getMapTableCells(), qn = this.getCellToTargetTableCell(Kn, this.activeEditCellContext, Un);
        qn !== null && (this.activeEditCellContext.disableFocus(), qn.enableFocus(), this.activeEditCellContext = qn);
      }
    });
    Ca(this, "syncWidths", async () => {
      const Un = this.getColumnWidths(), qn = Un.reduce((_a, ya) => _a + ya, 0) / Un.length, Jo = Un.map((_a) => _a / qn), pa = this.getFirstGraphic();
      if (pa === null)
        throw new EditorError("first graphic not found");
      const va = pa.getFrameConfiguration().width / Un.length, ba = Jo.map((_a) => va * _a);
      this.mutateColumnWidths(ba), this.applyMutations();
    });
    /**
     * Возвращает карту всех ячеек таблицы учитывая объединенные ячейки.
     */
    Ca(this, "getMapTableCells", () => {
      const Un = this.getRowCount(), Kn = this.getColumnCount(), qn = this.getCells(), Jo = Array.from({ length: Un }, () => Array(Kn).fill(null));
      for (let pa = 0; pa < qn.length; pa++) {
        const ma = qn[pa].rowSpan || 1, va = qn[pa].columnSpan || 1;
        for (let ba = 0; ba < ma; ba++)
          for (let _a = 0; _a < va; _a++)
            Jo[qn[ba].row + ba][qn[ba].column + _a] = qn[ba];
      }
      return Jo;
    });
    /**
     * Возвращает контекст ячейки по позиции относительно полученной ячейкой.
     * Возвращает null если ячейки по позиции относительно полученной ячейкой нет.
     * @param tableCells Карта ячеек таблицы.
     * @param targetCell Ячейка для поиска.
     * @param positionTableCell Позиция разыскиваемой ячейки от полученной.
     */
    Ca(this, "getCellToTargetTableCell", (Un, Kn, qn) => {
      for (let Jo = 0; Jo < Un.length; Jo++)
        for (let pa = 0; pa < Un[Jo].length; pa++)
          if (Un[Jo][pa].context === Kn) {
            if (qn === SearchPositionTableCell.CELL_ABOVE)
              for (let ma = Jo - 1; ma >= 0; ma--) {
                const va = Un[ma][pa];
                if (va.context !== Kn) {
                  if (this.currentRow = null, va.columnSpan > 1 && this.currentColumn === null)
                    this.currentColumn = Kn.controlCell.column;
                  else if (va.columnSpan === 1 && this.currentColumn !== null) {
                    const ba = Un[ma][this.currentColumn].context;
                    return this.currentColumn = null, ba;
                  } else if (va.columnSpan > 1 && this.currentColumn !== null)
                    return Un[ma][this.currentColumn].context;
                  return va.context;
                }
              }
            if (qn === SearchPositionTableCell.CELL_BELOW)
              for (let ma = Jo + 1; ma < Un.length; ma++) {
                const va = Un[ma][pa];
                if (va.context !== Kn) {
                  if (this.currentRow = null, va.columnSpan > 1 && this.currentColumn === null)
                    this.currentColumn = Kn.controlCell.row;
                  else if (va.columnSpan === 1 && this.currentColumn !== null) {
                    const ba = Un[ma][this.currentColumn].context;
                    return this.currentColumn = null, ba;
                  } else if (va.columnSpan > 1 && this.currentColumn !== null)
                    return Un[ma][this.currentColumn].context;
                  return va.context;
                }
              }
            if (qn === SearchPositionTableCell.CELL_LEFT)
              for (let ma = pa - 1; ma >= 0; ma--) {
                const va = Un[Jo][ma];
                if (va.context !== Kn) {
                  if (this.currentColumn = null, va.rowSpan > 1 && this.currentRow === null)
                    this.currentRow = Kn.controlCell.row;
                  else if (va.rowSpan === 1 && this.currentRow !== null) {
                    const ba = Un[this.currentRow][ma].context;
                    return this.currentRow = null, ba;
                  } else if (va.rowSpan > 1 && this.currentRow !== null)
                    return Un[this.currentRow][ma].context;
                  return va.context;
                }
              }
            if (qn === SearchPositionTableCell.CELL_RIGHT)
              for (let ma = pa + 1; ma < Un[Jo].length; ma++) {
                const va = Un[Jo][ma];
                if (va.context !== Kn) {
                  if (this.currentColumn = null, va.rowSpan > 1 && this.currentRow === null)
                    this.currentRow = Kn.controlCell.row;
                  else if (va.rowSpan === 1 && this.currentRow !== null) {
                    const ba = Un[this.currentRow][ma].context;
                    return this.currentRow = null, ba;
                  } else if (va.rowSpan > 1 && this.currentRow !== null)
                    return Un[this.currentRow][ma].context;
                  return va.context;
                }
              }
            return null;
          }
      return null;
    });
    /**
     * Находит наибольший индекс колонки (индекс самой правой колонки) и возвращает все ячейки с этим индексом либо
     * null если ячеек в фокусе нет.
     */
    Ca(this, "getRightmostColumnIndex", () => {
      const Un = this.getFocusCellContexts();
      if (Un === null)
        return null;
      let Kn = 0;
      return Un.forEach((qn) => {
        const { column: Jo, columnSpan: pa } = qn.getTexture(), ma = Jo + pa - 1;
        Kn = ma > Kn ? ma : Kn;
      }), Kn;
    });
    /**
     * Находит наименьший индекс колонки (индекс самой левой колонки) и возвращает все ячейки с этим индексом либо
     * null если ячеек в фокусе нет.
     */
    Ca(this, "getLeftmostColumnIndex", () => {
      const Un = this.getFocusCellContexts();
      if (Un === null)
        return null;
      let Kn = Number.MAX_SAFE_INTEGER;
      return Un.forEach((qn) => {
        const { column: Jo } = qn.getTexture();
        Kn = Jo < Kn ? Jo : Kn;
      }), Kn;
    });
    /**
     * Находит наибольший индекс строки (индекс самой нижней строки) и возвращает все ячейки с этим индексом либо
     * null если ячеек в фокусе нет.
     */
    Ca(this, "getLowestIndex", () => {
      let Un = 0;
      const Kn = this.getFocusCellContexts();
      return Kn === null ? null : (Kn.forEach((qn) => {
        const Jo = qn.getTexture().rowSpan, pa = qn.getTexture().row + Jo - 1;
        Un = pa > Un ? pa : Un;
      }), Un);
    });
    Ca(this, "getHighestIndex", () => {
      let Un = Number.MAX_SAFE_INTEGER;
      const Kn = this.getFocusCellContexts();
      return Kn === null ? null : (Kn.forEach((qn) => {
        const Jo = qn.getTexture().row;
        Un = Jo < Un ? Jo : Un;
      }), Un);
    });
    /**
     * Возвращает коллекцию высот каждой абсолютной строки таблицы в пикселях.
     */
    Ca(this, "getRowProperties", () => this.getRowMinCells().map((Kn) => ({
      height: Kn.getHeight(),
      rowSpan: Kn.rowSpan
    })));
    Ca(this, "getCells", () => {
      if (this.cellContexts === null)
        throw new EditorError("the table cells not initialized");
      return this.cellContexts.flatMap((Un) => Un.getTableCells());
    });
    Ca(this, "getCellContexts", () => {
      if (this.cellContexts === null)
        throw new EditorError("the table cell contexts not initialized");
      return [...this.cellContexts];
    });
    Ca(this, "getGridAreas", () => this.gridAreas.getMap());
    Ca(this, "getTexture", () => ({
      startRows: this.startRows,
      borderColor: this.borderColor,
      columnWidths: this.columnWidths,
      rowHeights: this.rowHeights,
      cells: this.cellContexts === null ? [] : this.cellContexts.map((Un) => Un.getTexture())
    }));
    Ca(this, "getUniqueTexture", () => {
      if (this.cellContexts === null || this.columnWidths === null || this.borderColor === null)
        throw new EditorError("table not initialized");
      return {
        startRows: this.startRows,
        borderColor: this.borderColor,
        columnWidths: this.columnWidths,
        rowHeights: this.rowHeights,
        cells: this.cellContexts.map((Un) => Un.getTexture()).map((Un) => ({
          ...Un,
          id: Utils.generate.uuid4(),
          content: {
            ...Un.content,
            id: Utils.generate.uuid4()
          }
        }))
      };
    });
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture(), { cells: qn, columnWidths: Jo, borderColor: pa, startRows: ma, rowHeights: va } = Un(Kn);
      this.startRows = ma, this.rowHeights = va, this.borderColor = pa, this.columnWidths = Jo, await this.mutateCellTextures(qn), this.applyMutations();
    });
    /**
     * Включает фокус у ячейки по её идентификатору и снимает его со всех остальных.
     * В случае отсутствия ячейки метод возвращает `false`.
     * @param cellID Идентификатор ячейки.
     */
    Ca(this, "focusOnlyCellContextByID", (Un) => {
      if (this.cellContexts === null)
        return !1;
      const Kn = this.cellContexts.find((qn) => qn.getID() === Un);
      return Kn === void 0 ? !1 : (this.cellContexts.forEach((qn) => {
        if (qn === Kn) {
          qn.enableFocus(), qn.enableMutationMode();
          return;
        }
        qn.disableFocus();
      }), !0);
    });
    Ca(this, "addPostCellInputListener", (Un) => {
      this.postCellInputExternalListeners.push(Un);
    });
    /**
     * Вычисляет и возвращает массив множителей строк для переданной графики таблицы.
     * @param graphic графика таблицы, для которой необходимо вычислить множитель строк
     * @return number[] - возвращает массив высот строк для графики таблицы
     */
    Ca(this, "calculateRowHeightsForGraphic", (Un) => {
      const { rowCount: Kn } = Un.getTexture(), Jo = this.getGraphics().indexOf(Un);
      if (Jo === -1)
        throw new EditorError("graphic not found");
      const pa = this.startRows[Jo];
      if (pa === void 0)
        throw new EditorError("start row not found");
      return this.rowHeights.slice(pa, pa + Kn);
    });
    Ca(this, "disableAllContextFocus", () => {
      this.cellContexts !== null && this.cellContexts.forEach((Un) => Un.disableFocus());
    });
    Ca(this, "getCellSpatialAreas", () => this.cellSpatialAreas);
    Ca(this, "getCellAreas", () => {
      if (this.cellContexts === null)
        throw new EditorError("table cell not initialized");
      const Un = [];
      return this.getCellContextToGraphic().forEach((qn, Jo) => {
        const pa = Jo.getTableCells();
        for (let ma = 0; ma < pa.length; ma++)
          Un.push(new SpatialTableCellArea(this, qn, Jo, pa[ma]));
      }), Un;
    });
    /**
     * Возвращает карту графики с ячейки, где ключ - ячейка, а значение - графика, где она визуализируется.
     */
    Ca(this, "getCellContextToGraphic", () => {
      const Un = /* @__PURE__ */ new Map();
      return this.getGraphics().forEach((qn) => {
        const Jo = qn.getCurrentRenderCells();
        new Set(Jo.map((ma) => ma.context)).forEach((ma) => {
          Un.set(ma, qn);
        });
      }), Un;
    });
    /**
     * Снимает фокус со всех ячеек.
     */
    Ca(this, "disableCellFocus", () => {
      const Un = this.getFocusCellContexts();
      Un !== null && Un.forEach((Kn) => Kn.disableFocus());
    });
    Ca(this, "postCellInputListener", () => {
      this.syncGraphicsHeight(), this.mutateSyncRealRowHeight(), this.applyMutations(), this.callPostCellInputExternalListeners();
    });
    Ca(this, "callPostCellInputExternalListeners", () => {
      this.postCellInputExternalListeners.forEach((Un) => Un());
    });
    /**
     * Вычисляет и возвращает массив ячеек по строкам.
     * @return TableCell[][] Возвращает массив ячеек для каждой строки
     */
    Ca(this, "getCellsFromRow", () => {
      const Un = this.getCells(), Kn = [];
      return Un.forEach((qn) => {
        if (qn.isContextExtend)
          return;
        const Jo = qn.row + qn.rowSpan - 1;
        Kn[Jo] === void 0 && (Kn[Jo] = []), Kn[Jo].push(qn);
      }), Kn;
    });
    /**
     * Синхронизирует модели текста при изменении ширины колонок.
     */
    Ca(this, "syncTextModelContexts", () => {
      this.cellContexts !== null && this.cellContexts.forEach((Un) => {
        Un.syncTextModelWhenResizing();
      });
    });
    /**
     * Возвращает минимальную по объединению строк ячейку в каждой логической строке.
     */
    Ca(this, "getRowMinCells", () => {
      const Un = [], Kn = this.getCells(), qn = this.gridAreas.getMap(), Jo = this.getIDCellToTableCell(Kn);
      for (let pa = 0; pa < qn.length; pa++) {
        let ma = Number.MAX_SAFE_INTEGER, va = null;
        for (let ba = 0; ba < qn[pa].length; ba++) {
          const _a = Jo.get(qn[pa][ba].cell.id);
          if (_a === void 0)
            throw new EditorError("cell not found");
          (va === null || _a.rowSpan < ma) && (ma = _a.rowSpan, va = _a);
        }
        if (va === null)
          throw new EditorError("min cell not found");
        Un.push(va), pa += ma - 1;
      }
      return Un;
    });
    this.startRows = [0], this.borderColor = "", this.cellContexts = null, this.cellTextures = null, this.rowHeights = [], this.columnWidths = [], this.cellPositioner = new CellPositioner(this), this.gridAreas = new TableGridAreas(this), this.postCellInputExternalListeners = [], this.activeEditCellContext = null, this.currentRow = null, this.currentColumn = null, this.cellSpatialAreas = [];
  }
}
class TextComponent extends GraphicComponent {
  constructor() {
    super();
    Ca(this, "type", EditorComponentType.TEXT);
    Ca(this, "model");
    Ca(this, "isAutoWidth");
    /**
     * Синхронизирует размер фрейма с фактическим размером содержимого текста.
     */
    Ca(this, "syncFrameSize", async () => {
      this.syncWidth(), this.syncHeight();
    });
    /**
     * Включает режим автоматической ширины, когда ширина фрейма автоматически
     * принимает ширину текста.
     */
    Ca(this, "enableAutoWidth", () => {
      const Un = this.getGraphics();
      for (const Kn of Un)
        Kn.enableAutoWidth();
      this.isAutoWidth = !0, this.model.syncModelWithViews();
    });
    /**
     * Отключает режим автоматической ширины, когда ширина фрейма автоматически
     * принимает ширину текста.
     */
    Ca(this, "disableAutoWidth", () => {
      const Un = this.getGraphics();
      for (const Kn of Un)
        Kn.disableAutoWidth();
      this.isAutoWidth = !1, this.model.syncModelWithViews();
    });
    Ca(this, "requestGraphicsUpdateArea", () => {
      const Un = this.getSpatialAreas();
      for (let Kn = 0; Kn < Un.length; Kn++)
        Un[Kn].markDirty();
    });
    Ca(this, "syncWidth", () => {
      const Un = this.getGraphics();
      for (const Kn of Un) {
        if (!this.isAutoWidth)
          return;
        const qn = Kn.getGraphicObject(), Jo = Kn.getTextPadding();
        Kn.setFrameConfiguration((pa) => ({
          ...pa,
          width: qn.object.width + Jo.x * 2
        }));
      }
    });
    Ca(this, "syncHeight", () => {
      const Un = this.getGraphics();
      for (const Kn of Un) {
        const qn = Kn.getTextPadding(), Jo = Kn.getGraphicObject();
        Kn.setFrameConfiguration((pa) => ({
          ...pa,
          height: Jo.object.height + qn.y * 2
        }));
      }
    });
    Ca(this, "getTexture", () => ({
      model: this.model.getTexture()
    }));
    Ca(this, "getUniqueTexture", () => {
      const Un = this.getTexture();
      return Un.model.id = Utils.generate.uuid4(), Un;
    });
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture(), qn = Un(Kn);
      this.model.setTexture(qn.model), this.model.syncModelWithViews();
      for (const Jo of this.getGraphics())
        Jo.setTextAlign(qn.model.textAlign);
    });
    Ca(this, "getTextModel", () => this.model);
    Ca(this, "getTextViews", () => this.getGraphics());
    Ca(this, "getCarriageCoverages", () => this.model.getCoverages(this.getGraphics()));
    this.isAutoWidth = !1, this.model = new TextModel(this), this.model.addPostChangeTextListener(this.requestGraphicsUpdateArea);
  }
}
class ComponentFactory extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "getClearComponent", (Un) => {
      switch (Un) {
        case EditorComponentType.BOOK:
          return new BookComponent();
        case EditorComponentType.MODULE:
          return new ModuleComponent();
        case EditorComponentType.GROUP:
          return new GroupComponent();
        case EditorComponentType.PICTURE:
          return new PictureComponent();
        case EditorComponentType.TABLE:
          return new TableComponent();
        case EditorComponentType.TEXT:
          return new TextComponent();
        case EditorComponentType.FIGURE:
          return new FigureComponent();
        case EditorComponentType.LINE:
          return new LineComponent();
        default:
          throw new EditorError(`constructor component "${Un}" not found`);
      }
    });
  }
}
class StaticComponentFactory extends ComponentFactory {
  constructor() {
    super();
    Ca(this, "createComponent", (Un) => this.getClearComponent(Un.type));
  }
}
class SpatialGraphicArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialCanvasAreaType.GRAPHIC);
    Ca(this, "graphic");
    Ca(this, "getData", () => ({
      graphic: this.graphic
    }));
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.graphic.getGlobalPosition(), Kn = this.graphic.getFrameConfiguration();
      return {
        ...Un,
        width: Kn.width,
        height: Kn.height,
        rotate: Kn.rotate
      };
    });
    Ca(this, "getRelatedFrames", () => {
      const Un = this.graphic.getParentComponent();
      if (Un === null)
        throw new EditorError("component not found");
      return Un.getGraphics();
    });
    Ca(this, "isTextPlace", () => this.graphic.type === GraphicType.TEXT && this.graphic.isEnableEditMode());
    Ca(this, "isAllowMutatePosition", () => !this.graphic.isEnableEditMode());
    this.graphic = Un;
  }
}
class Frame {
  /**
   * Создает экземпляр `Frame`.
   */
  constructor() {
    /** Значение ширины обводки фрейма при включении какой-либо обводки. */
    Ca(this, "STROKE_WIDTH_DEFAULT", 1);
    /** Значение по умолчанию для минимальной ширины. */
    Ca(this, "DEFAULT_MIN_WIDTH", 1);
    /** Значение по умолчанию для минимальной высоты. */
    Ca(this, "DEFAULT_MIN_HEIGHT", 1);
    /** Нижний предел минимальной ширины. */
    Ca(this, "LOWER_LIMIT_WIDTH", 6);
    /** Нижний предел минимальной высоты. */
    Ca(this, "LOWER_LIMIT_HEIGHT", 6);
    /** Объект `fabric.Group`, представляющий фрейм. */
    Ca(this, "frameObject");
    /** Конфигурация фрейма. */
    Ca(this, "frameConfiguration");
    /** Минимальная ширина фрейма. */
    Ca(this, "minWidth");
    /** Минимальная высота фрейма. */
    Ca(this, "minHeight");
    /** Слушатели событий изменения конфигурации фрейма. */
    Ca(this, "postChangeListeners");
    /**
     * Возвращает объект `fabric.Rect`, представляющий фрейм.
     * @returns {fabric.Rect} Объект фрейма.
     */
    Ca(this, "getFrameObject", () => this.frameObject);
    /**
     * Возвращает текущую конфигурацию фрейма.
     * @returns {IFrameConfiguration} Конфигурация фрейма.
     */
    Ca(this, "getFrameConfiguration", () => ({
      ...this.frameConfiguration
    }));
    /**
     * Обновляет конфигурацию фрейма.
     * После вызова необходимо вызвать `renderAll()` для отображения изменений.
     * Метод `setCoords()` вызывается автоматически.
     * @param fn Функция, изменяющая параметры конфигурации.
     */
    Ca(this, "setFrameConfiguration", (zn) => {
      const Un = this.getFrameConfiguration();
      let Kn = zn(Un);
      Kn = {
        y: Math.round(Kn.y),
        x: Math.round(Kn.x),
        width: Math.round(Kn.width),
        height: Math.round(Kn.height),
        rotate: Math.round(Kn.rotate),
        layer: Kn.layer
      };
      let qn = !1;
      Un.x !== Kn.x && (this.frameConfiguration.x = Kn.x, qn = !0), Un.layer !== Kn.layer && (this.frameConfiguration.layer = Kn.layer, qn = !0), Un.height !== Kn.height && Kn.height >= this.minHeight && (this.frameObject.object.height = Kn.height, this.frameConfiguration.height = Kn.height, qn = !0), Un.width !== Kn.width && Kn.width >= this.minWidth && (this.frameObject.object.width = Kn.width, this.frameConfiguration.width = Kn.width, qn = !0), Un.y !== Kn.y && (this.frameConfiguration.y = Kn.y, qn = !0), Un.rotate !== Kn.rotate && (this.frameObject.object.angle = Kn.rotate, this.frameConfiguration.rotate = Kn.rotate, qn = !0), qn && this.callFrameConfigurationChangeListeners(Un, Kn);
    });
    /**
     * Удаляет фрейм из холста.
     */
    Ca(this, "removeFrame", () => {
    });
    /**
     * Добавляет слушателя изменений конфигурации фрейма.
     * @param listener Функция, вызываемая при изменении конфигурации.
     */
    Ca(this, "addFrameConfigurationChangeListener", (zn) => {
      this.postChangeListeners === null && (this.postChangeListeners = []), this.postChangeListeners.push(zn);
    });
    /**
     * Удаляет слушателя изменений конфигурации фрейма.
     * @param listener Функция, вызываемая при изменении конфигурации.
     */
    Ca(this, "removeFrameConfigurationChangeListener", (zn) => {
      if (this.postChangeListeners === null)
        throw new EditorError("listeners not found");
      this.postChangeListeners.splice(this.postChangeListeners.indexOf(zn), 1);
    });
    /**
     * Уведомляет всех слушателей о произошедших изменениях конфигурации фрейма.
     */
    Ca(this, "callFrameConfigurationChangeListeners", (zn, Un) => {
      this.postChangeListeners !== null && this.postChangeListeners.forEach((Kn) => Kn(zn, Un));
    });
    /**
     * Устанавливает минимальную ширину фрейма.
     * @param value Новое значение минимальной ширины.
     * @throws {EditorError} Если значение меньше нижнего предела.
     */
    Ca(this, "setMinWidth", (zn) => {
      if (zn < this.LOWER_LIMIT_WIDTH)
        throw new EditorError(`the minimum width cannot be less than ${this.LOWER_LIMIT_WIDTH}`);
      this.minWidth = zn;
    });
    /**
     * Устанавливает минимальную высоту фрейма.
     * @param value Новое значение минимальной высоты.
     * @throws {EditorError} Если значение меньше нижнего предела.
     */
    Ca(this, "setMinHeight", (zn) => {
      if (zn < this.LOWER_LIMIT_HEIGHT)
        throw new EditorError(`the minimum height cannot be less than ${this.LOWER_LIMIT_HEIGHT}`);
      this.minHeight = zn;
    });
    /**
     * Возвращает соотношение сторон фрейма.
     * @returns {number} Соотношение ширины к высоте.
     */
    Ca(this, "getFrameAspectRatio", () => this.frameConfiguration.width / this.frameConfiguration.height);
    /**
     * Возвращает минимальную ширину фрейма.
     * @returns {number} Минимальная ширина.
     */
    Ca(this, "getMinWidth", () => this.minWidth);
    /**
     * Возвращает минимальную высоту фрейма.
     * @returns {number} Минимальная высота.
     */
    Ca(this, "getMinHeight", () => this.minHeight);
    this.frameConfiguration = {
      x: 0,
      y: 0,
      layer: -1,
      height: 0,
      width: 0,
      rotate: 0
    }, this.postChangeListeners = null, this.minWidth = this.DEFAULT_MIN_WIDTH, this.minHeight = this.DEFAULT_MIN_HEIGHT, this.frameObject = {
      object: new pr({
        fill: null,
        strokeWidth: this.STROKE_WIDTH_DEFAULT
      }),
      relativePosition: { x: 0, y: 0 }
    };
  }
}
class HoveringFrame extends Frame {
  /**
   * Создает экземпляр `HoveringFrame`.
   */
  constructor() {
    super();
    /** Слушатели, вызываемые после включения подсветки. */
    Ca(this, "postEnableHoverListeners");
    /** Слушатели, вызываемые после отключения подсветки. */
    Ca(this, "postDisableHoverListeners");
    /** Состояние подсветки фрейма. */
    Ca(this, "isHover");
    /**
     * Включает подсветку фрейма.
     */
    Ca(this, "enableHover", () => {
      this.isHover = !0, this.runPostEnableHoverListeners();
    });
    /**
     * Отключает подсветку фрейма.
     */
    Ca(this, "disableHover", () => {
      this.isHover = !1, this.runPostDisableHoverListeners();
    });
    /**
     * Добавляет слушатель, вызываемый после включения подсветки.
     * @param listener Функция-слушатель.
     */
    Ca(this, "addPostEnableHoverListener", (Un) => {
      this.postEnableHoverListeners.push(Un);
    });
    /**
     * Добавляет слушатель, вызываемый после отключения подсветки.
     * @param listener Функция-слушатель.
     */
    Ca(this, "addPostDisableHoverListener", (Un) => {
      this.postDisableHoverListeners.push(Un);
    });
    /**
     * Выполняет все слушатели, связанные с включением подсветки.
     * @private
     */
    Ca(this, "runPostEnableHoverListeners", () => {
      this.postEnableHoverListeners.forEach((Un) => Un());
    });
    /**
     * Выполняет все слушатели, связанные с отключением подсветки.
     * @private
     */
    Ca(this, "runPostDisableHoverListeners", () => {
      this.postDisableHoverListeners.forEach((Un) => Un());
    });
    /**
     * Проверяет, включена ли подсветка.
     * @returns {boolean} `true`, если подсветка включена; иначе `false`.
     */
    Ca(this, "isEnableHover", () => this.isHover);
    this.isHover = !1, this.postEnableHoverListeners = [], this.postDisableHoverListeners = [];
  }
}
class FocusableFrame extends HoveringFrame {
  constructor() {
    super();
    Ca(this, "postEnableFocusListeners");
    Ca(this, "postDisableFocusListeners");
    Ca(this, "mutationPermissions");
    Ca(this, "isFocus");
    Ca(this, "enableFocus", () => {
      this.isFocus || (this.isFocus = !0, this.runPostEnableFocusModeListeners());
    });
    Ca(this, "disableFocus", () => {
      this.isFocus && (this.isFocus = !1, this.runPostDisableFocusModeListeners());
    });
    Ca(this, "addPostEnableFocusListener", (Un) => {
      this.postEnableFocusListeners.push(Un);
    });
    Ca(this, "addPostDisableFocusListener", (Un) => {
      this.postDisableFocusListeners.push(Un);
    });
    Ca(this, "runPostDisableFocusModeListeners", () => {
      this.postDisableFocusListeners.forEach((Un) => Un());
    });
    Ca(this, "runPostEnableFocusModeListeners", () => {
      this.postEnableFocusListeners.forEach((Un) => Un());
    });
    Ca(this, "setMutationPermissions", (Un) => {
      this.mutationPermissions = { ...Un };
    });
    Ca(this, "isEnableFocus", () => this.isFocus);
    Ca(this, "getMutationPermission", () => ({ ...this.mutationPermissions }));
    this.isFocus = !1, this.mutationPermissions = {
      top: !0,
      left: !0,
      right: !0,
      bottom: !0,
      leftTop: !0,
      rightTop: !0,
      leftBottom: !0,
      rightBottom: !0
    }, this.postEnableFocusListeners = [], this.postDisableFocusListeners = [];
  }
}
class EditableFrame extends FocusableFrame {
  constructor() {
    super();
    Ca(this, "enableEditModeListeners");
    Ca(this, "disableEditModeListeners");
    Ca(this, "isEditMode");
    Ca(this, "enableEditMode", () => {
      this.isEditMode || (this.isEditMode = !0, this.startMutation(), this.callPostEnableEditModeListeners());
    });
    Ca(this, "disableEditMode", () => {
      this.isEditMode && (this.isEditMode = !1, this.finishMutation(), this.callPostDisableEditModeListeners());
    });
    Ca(this, "addPostEnableEditModeListener", (Un) => {
      this.enableEditModeListeners.push(Un);
    });
    Ca(this, "addPostDisableEditModeListener", (Un) => {
      this.disableEditModeListeners.push(Un);
    });
    Ca(this, "isEnableEditMode", () => this.isEditMode);
    Ca(this, "callPostEnableEditModeListeners", () => {
      this.enableEditModeListeners.forEach((Un) => Un());
    });
    Ca(this, "callPostDisableEditModeListeners", () => {
      this.disableEditModeListeners.forEach((Un) => Un());
    });
    this.isEditMode = !1, this.enableEditModeListeners = [], this.disableEditModeListeners = [];
  }
}
class SizePanel {
  constructor(zn) {
    Ca(this, "BORDER_COLOR_DEFAULT", "#0075FF");
    Ca(this, "STROKE_WIDTH_DEFAULT", 1);
    Ca(this, "CORNER_SIZE_DEFAULT", 7);
    Ca(this, "DEFAULT_PADDING", 4);
    Ca(this, "TOOLTIP_COLOR_DEFAULT", "#0075FF");
    Ca(this, "borderObject");
    Ca(this, "tooltipObject");
    Ca(this, "crossObject");
    Ca(this, "textWidthObject");
    Ca(this, "textHeightObject");
    Ca(this, "isDisable");
    Ca(this, "show", () => {
      this.borderObject.object.visible = !0, this.tooltipObject.object.visible = !0, this.crossObject.object.visible = !0, this.textWidthObject.object.visible = !0, this.textHeightObject.object.visible = !0;
    });
    Ca(this, "hide", () => {
      this.borderObject.object.visible = !1, this.tooltipObject.object.visible = !1, this.crossObject.object.visible = !1, this.textWidthObject.object.visible = !1, this.textHeightObject.object.visible = !1;
    });
    Ca(this, "disable", () => {
      this.isDisable = !0, this.graphic.removeFrameConfigurationChangeListener(this.syncWithFrame);
    });
    Ca(this, "getObjects", () => this.isDisable ? [] : [this.borderObject, this.tooltipObject, this.crossObject, this.textWidthObject, this.textHeightObject]);
    Ca(this, "syncWithFrame", (zn, Un) => {
      const { width: Kn, height: qn } = Un;
      this.updateBorderSize(Kn, qn, this.CORNER_SIZE_DEFAULT), this.updateTooltipShape(Kn, qn), this.updateText(Kn, qn);
    });
    Ca(this, "updateBorderSize", (zn, Un, Kn) => {
      const qn = Kn / 2, Jo = this.STROKE_WIDTH_DEFAULT / 2;
      this.borderObject.object.path = [
        // Основная рамка (внешний прямоугольник, обводящий переданный квадрат)
        ["M", -Jo, -Jo],
        ["L", zn + Jo, -Jo],
        ["L", zn + Jo, Un + Jo],
        ["L", -Jo, Un + Jo],
        ["Z"],
        // Вырезаем внутренний прямоугольник (чтобы линия не перекрывала внутреннюю область)
        ["M", 0, 0],
        ["L", zn, 0],
        ["L", zn, Un],
        ["L", 0, Un],
        ["Z"],
        // Верхний левый квадрат (угол)
        ["M", -qn - Jo, -qn - Jo],
        ["L", qn - Jo, -qn - Jo],
        ["L", qn - Jo, qn - Jo],
        ["L", -qn - Jo, qn - Jo],
        ["Z"],
        // Верхний правый квадрат (угол)
        ["M", zn - qn + Jo, -qn - Jo],
        ["L", zn + qn + Jo, -qn - Jo],
        ["L", zn + qn + Jo, qn - Jo],
        ["L", zn - qn + Jo, qn - Jo],
        ["Z"],
        // Нижний правый квадрат (угол)
        ["M", zn - qn + Jo, Un - qn + Jo],
        ["L", zn + qn + Jo, Un - qn + Jo],
        ["L", zn + qn + Jo, Un + qn + Jo],
        ["L", zn - qn + Jo, Un + qn + Jo],
        ["Z"],
        // Нижний левый квадрат (угол)
        ["M", -qn - Jo, Un - qn + Jo],
        ["L", qn - Jo, Un - qn + Jo],
        ["L", qn - Jo, Un + qn + Jo],
        ["L", -qn - Jo, Un + qn + Jo],
        ["Z"]
      ];
    });
    Ca(this, "updateTooltipShape", (zn, Un) => {
      const pa = Math.round(this.textWidthObject.object.width + this.textHeightObject.object.width), ma = Math.round(this.textHeightObject.object.height), va = pa + this.DEFAULT_PADDING * 4 + 10, ba = Math.max(14, ma + this.DEFAULT_PADDING);
      this.tooltipObject.object.set({
        path: [
          // Верхний левый угол (скругление)
          ["M", 4, 0],
          ["L", va / 2 - 4, 0],
          ["L", va / 2, -4],
          ["L", va / 2 + 4, 0],
          ["L", va - 4, 0],
          // Правый верхний угол
          ["Q", va, 0, va, 4],
          ["L", va, ba - 4],
          // Правый нижний угол
          ["Q", va, ba, va - 4, ba],
          ["L", 4, ba],
          // Левый нижний угол
          ["Q", 0, ba, 0, ba - 4],
          ["L", 0, 4],
          // Верхний левый угол
          ["Q", 0, 0, 4, 0],
          ["Z"]
        ]
      }), this.tooltipObject.relativePosition.x = zn / 2 - va / 2, this.tooltipObject.relativePosition.y = Un + 10;
      const _a = va / 2, ya = ba / 2;
      this.crossObject.object.set({
        path: [
          // Левая часть горизонтальной линии
          ["M", _a - 7 * 0.35, ya - 7 * 0.35],
          // Поворот верхней части влево
          ["L", _a + 7 * 0.35, ya + 7 * 0.35],
          // Поворот нижней части вправо
          // Правая часть горизонтальной линии
          ["M", _a + 7 * 0.35, ya - 7 * 0.35],
          // Поворот верхней части вправо
          ["L", _a - 7 * 0.35, ya + 7 * 0.35]
          // Поворот нижней части влево
        ]
      }), this.crossObject.relativePosition.x = this.tooltipObject.relativePosition.x, this.crossObject.relativePosition.y = this.tooltipObject.relativePosition.y;
    });
    Ca(this, "updateText", (zn, Un) => {
      this.textWidthObject.object.set("text", zn.toString()), this.textHeightObject.object.set("text", Un.toString());
      const Kn = Math.round(this.textWidthObject.object.width || 0), qn = Math.round(this.textHeightObject.object.width || 0), Jo = Math.round(this.textHeightObject.object.height || 0), pa = Math.max(60, Kn + qn + 20), ma = Math.max(14, Jo + 4);
      this.tooltipObject.relativePosition.x + pa / 2;
      const va = this.tooltipObject.relativePosition.y + ma / 2, _a = Math.round(this.textWidthObject.object.width + this.textHeightObject.object.width) + this.DEFAULT_PADDING * 4 + 10;
      this.textWidthObject.relativePosition.x = this.tooltipObject.relativePosition.x + this.DEFAULT_PADDING, this.textWidthObject.relativePosition.y = va - Jo / 2, this.textHeightObject.relativePosition.x = this.tooltipObject.relativePosition.x + _a - this.textHeightObject.object.width - this.DEFAULT_PADDING, this.textHeightObject.relativePosition.y = va - Jo / 2;
    });
    this.graphic = zn, this.borderObject = {
      object: new Vn("", {
        visible: !1,
        fillRule: "evenodd",
        objectCaching: !1,
        fill: this.BORDER_COLOR_DEFAULT,
        // Заливка для углов
        stroke: this.BORDER_COLOR_DEFAULT,
        // Цвет обводки рамки
        strokeWidth: this.STROKE_WIDTH_DEFAULT
        // Толщина линии рамки
      }),
      relativePosition: {
        x: 0,
        y: 0
      }
    }, this.tooltipObject = {
      object: new Vn("", {
        visible: !1,
        fillRule: "evenodd",
        objectCaching: !1,
        fill: this.TOOLTIP_COLOR_DEFAULT
      }),
      relativePosition: {
        x: 0,
        y: 0
      }
    }, this.crossObject = {
      object: new Vn("", {
        visible: !1,
        fillRule: "evenodd",
        objectCaching: !1,
        stroke: "white",
        // Цвет крестика
        strokeWidth: 1,
        // Толщина линий
        fill: this.TOOLTIP_COLOR_DEFAULT
      }),
      relativePosition: {
        x: 0,
        y: 0
      }
    }, this.textWidthObject = {
      object: new Xo("0", {
        visible: !1,
        fill: "white",
        fontSize: 11,
        objectCaching: !1,
        fontFamily: FontFamily.DEFAULT
      }),
      relativePosition: {
        x: 0,
        y: 0
      }
    }, this.textHeightObject = {
      object: new Xo("0", {
        visible: !1,
        fill: "white",
        objectCaching: !1,
        fontSize: 11,
        fontFamily: FontFamily.DEFAULT
      }),
      relativePosition: {
        x: 0,
        y: 0
      }
    }, this.isDisable = !1, this.graphic.addFrameConfigurationChangeListener(this.syncWithFrame);
  }
}
class AreaHighlighter {
  constructor() {
    Ca(this, "BORDER_COLOR_DEFAULT", "#FFB82E");
    Ca(this, "BORDER_WIDTH_DEFAULT", 1);
    Ca(this, "areaObject");
    Ca(this, "setConfiguration", (zn) => {
      let { width: Un, height: Kn } = zn;
      const qn = this.BORDER_WIDTH_DEFAULT / 2;
      Un += this.BORDER_WIDTH_DEFAULT * 2, Kn += this.BORDER_WIDTH_DEFAULT * 2, this.areaObject.path = [
        // Основная рамка (внешний прямоугольник, обводящий переданный квадрат)
        ["M", -qn, -qn],
        ["L", Un + qn, -qn],
        ["L", Un + qn, Kn + qn],
        ["L", -qn, Kn + qn],
        ["Z"],
        // Вырезаем внутренний прямоугольник (чтобы линия не перекрывала внутреннюю область)
        ["M", 0, 0],
        ["L", Un, 0],
        ["L", Un, Kn],
        ["L", 0, Kn],
        ["Z"]
      ];
    });
    Ca(this, "enable", () => {
      this.areaObject.visible = !0;
    });
    Ca(this, "disable", () => {
      this.areaObject.visible = !1;
    });
    Ca(this, "setStrokeColor", (zn) => this.areaObject.set("stroke", zn));
    Ca(this, "setStrokeWidth", (zn) => this.areaObject.set("strokeWidth", zn));
    Ca(this, "getAreaObject", () => this.areaObject);
    this.areaObject = new Vn("", {
      top: 0,
      left: 0,
      fill: null,
      // Убираем заливку
      stroke: this.BORDER_COLOR_DEFAULT,
      // Устанавливаем цвет обводки
      strokeWidth: this.BORDER_WIDTH_DEFAULT,
      // Устанавливаем ширину обводки
      visible: !1,
      objectCaching: !1
    });
  }
}
class EditModeGraphicHighlighter extends AreaHighlighter {
  constructor(Un) {
    super();
    Ca(this, "positionedObject");
    Ca(this, "getObjects", () => [this.positionedObject]);
    this.positionedObject = {
      object: this.areaObject,
      relativePosition: { x: 0, y: 0 }
    }, Un.addFrameConfigurationChangeListener((Kn, qn) => {
      this.setConfiguration({
        ...qn
      });
    });
  }
}
class HoverGraphicHighlighter extends AreaHighlighter {
  constructor(Un) {
    super();
    Ca(this, "STROKE_COLOR", "#BEBEBE");
    Ca(this, "positionedObject");
    Ca(this, "getObjects", () => [this.positionedObject]);
    this.positionedObject = {
      object: this.areaObject,
      relativePosition: { x: 0, y: 0 }
    }, this.setStrokeColor(this.STROKE_COLOR), Un.addFrameConfigurationChangeListener((Kn, qn) => {
      this.setConfiguration({
        ...qn
      });
    });
  }
}
var AreaResizeTrigger = /* @__PURE__ */ ((Xn) => (Xn[Xn.LEFT = 0] = "LEFT", Xn[Xn.TOP = 1] = "TOP", Xn[Xn.RIGHT = 2] = "RIGHT", Xn[Xn.BOTTOM = 3] = "BOTTOM", Xn[Xn.LEFT_TOP = 4] = "LEFT_TOP", Xn[Xn.RIGHT_TOP = 5] = "RIGHT_TOP", Xn[Xn.RIGHT_BOTTOM = 6] = "RIGHT_BOTTOM", Xn[Xn.LEFT_BOTTOM = 7] = "LEFT_BOTTOM", Xn))(AreaResizeTrigger || {});
class SpatialResizeArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "TRIGGER_RADIUS", 6);
    Ca(this, "trigger");
    Ca(this, "getTrigger", () => this.trigger);
    Ca(this, "getTriggerArea", (Un, Kn, qn, Jo) => {
      switch (this.trigger) {
        case AreaResizeTrigger.LEFT:
          return {
            x: Un - this.TRIGGER_RADIUS,
            y: Kn - this.TRIGGER_RADIUS,
            width: this.TRIGGER_RADIUS * 2,
            height: Jo + this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        case AreaResizeTrigger.TOP:
          return {
            x: Un - this.TRIGGER_RADIUS,
            y: Kn - this.TRIGGER_RADIUS,
            width: qn + this.TRIGGER_RADIUS * 2,
            height: this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        case AreaResizeTrigger.RIGHT:
          return {
            x: Un + qn - this.TRIGGER_RADIUS,
            y: Kn - this.TRIGGER_RADIUS,
            width: this.TRIGGER_RADIUS * 2,
            height: Jo + this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        case AreaResizeTrigger.BOTTOM:
          return {
            x: Un - this.TRIGGER_RADIUS,
            y: Kn + Jo - this.TRIGGER_RADIUS,
            width: qn + this.TRIGGER_RADIUS * 2,
            height: this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        case AreaResizeTrigger.LEFT_TOP:
          return {
            x: Un - this.TRIGGER_RADIUS,
            y: Kn - this.TRIGGER_RADIUS,
            width: this.TRIGGER_RADIUS * 2,
            height: this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        case AreaResizeTrigger.RIGHT_TOP:
          return {
            x: Un + qn - this.TRIGGER_RADIUS,
            y: Kn - this.TRIGGER_RADIUS,
            width: this.TRIGGER_RADIUS * 2,
            height: this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        case AreaResizeTrigger.RIGHT_BOTTOM:
          return {
            x: Un + qn - this.TRIGGER_RADIUS,
            y: Kn + Jo - this.TRIGGER_RADIUS,
            width: this.TRIGGER_RADIUS * 2,
            height: this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        case AreaResizeTrigger.LEFT_BOTTOM:
          return {
            x: Un - this.TRIGGER_RADIUS,
            y: Kn + Jo - this.TRIGGER_RADIUS,
            width: this.TRIGGER_RADIUS * 2,
            height: this.TRIGGER_RADIUS * 2,
            rotate: 0
          };
        default:
          throw new EditorError("trigger not found");
      }
    });
    Ca(this, "isResizeType", () => !0);
    this.trigger = Un;
  }
}
class SpatialGraphicResizeAngularArea extends SpatialResizeArea {
  constructor(Un, Kn) {
    super(Kn);
    Ca(this, "type", SpatialCanvasAreaType.GRAPHIC_ANGULAR_RESIZE);
    Ca(this, "graphic");
    Ca(this, "getData", () => ({
      graphic: this.graphic
    }));
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.graphic.getGlobalPosition(), Kn = this.graphic.getFrameConfiguration();
      return this.getTriggerArea(Un.x, Un.y, Kn.width, Kn.height);
    });
    /** Возвращает всю графику компонента, которая подвержена мутации. */
    Ca(this, "getRelatedFrames", () => {
      const Un = this.graphic.getParentComponent();
      if (Un === null)
        throw new EditorError("component not found");
      return Un.getGraphics();
    });
    Ca(this, "isAllowMutatePosition", () => !0);
    this.graphic = Un;
  }
}
class SpatialGraphicResizeArea extends SpatialResizeArea {
  constructor(Un, Kn) {
    super(Kn);
    Ca(this, "type", SpatialCanvasAreaType.GRAPHIC_RESIZE);
    Ca(this, "graphic");
    Ca(this, "getData", () => ({
      graphic: this.graphic
    }));
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.graphic.getGlobalPosition(), Kn = this.graphic.getFrameConfiguration();
      return this.getTriggerArea(Un.x, Un.y, Kn.width, Kn.height);
    });
    /** Возвращает всю графику компонента, которая подвержена мутации. */
    Ca(this, "getRelatedFrames", () => {
      const Un = this.graphic.getParentComponent();
      if (Un === null)
        throw new EditorError("component not found");
      return Un.getGraphics();
    });
    Ca(this, "isAllowMutatePosition", () => !0);
    this.graphic = Un;
  }
}
class Graphic extends EditableFrame {
  constructor() {
    super();
    Ca(this, "postMutationListeners");
    Ca(this, "maintainAspectRatio", !1);
    Ca(this, "graphicArea");
    Ca(this, "resizeAreas");
    Ca(this, "sizePanel");
    Ca(this, "hoverHighlighter");
    Ca(this, "editModeHighlighter");
    Ca(this, "graphicObject");
    Ca(this, "id");
    Ca(this, "offset");
    Ca(this, "parentComponent");
    Ca(this, "isUniter", !1);
    /**
     * Рекурсивно поднимается от переданной графики наверх и возвращает родительскую групповую графику. Если графика
     * находится не в группе, то вернет null.
     */
    Ca(this, "getParentUniterGraphic", () => {
      let Un = this.getParentGraphic();
      if (Un === null) throw new EditorError("parentGraphic is null");
      for (; Un.type !== GraphicType.PAGE; ) {
        if (Un.isUniter)
          return Un;
        if (Un = Un.getParentGraphic(), Un === null)
          throw new EditorError("parentGraphic is null");
      }
      return null;
    });
    Ca(this, "setParentComponent", (Un) => {
      this.parentComponent = Un;
    });
    Ca(this, "getGlobalPosition", () => {
      const Un = this.getFrameConfiguration();
      let Kn = this.getParentGraphic();
      for (; Kn !== null; ) {
        const { x: qn, y: Jo } = Kn.getFrameConfiguration();
        Un.x += qn, Un.y += Jo, Kn = Kn.getParentGraphic();
      }
      return Un;
    });
    Ca(this, "getStructure", () => ({
      id: this.id,
      type: this.type,
      offset: this.offset,
      frame: this.getFrameConfiguration(),
      texture: this.getTexture()
    }));
    Ca(this, "getParentGraphic", () => {
      if (this.parentComponent === null)
        throw new EditorError("parent component is null");
      const Un = this.parentComponent.getParentComponent();
      if (Un === null)
        return null;
      const Kn = Un.getGraphics(), qn = this.parentComponent.getStructure();
      if (qn.offset === null)
        throw new EditorError("component structure offset is null");
      const Jo = this.offset + qn.offset, pa = Kn[Jo];
      if (pa === void 0)
        throw new EditorError("find graphic not found");
      return pa;
    });
    Ca(this, "getUniqueStructure", () => ({
      id: Utils.generate.uuid4(),
      type: this.type,
      offset: this.offset,
      frame: this.getFrameConfiguration(),
      texture: this.getUniqueTexture()
    }));
    Ca(this, "mutateFrameArea", async (Un) => {
      const Kn = this.getFrameConfiguration(), qn = Un(Kn);
      if (this.setFrameConfiguration((Jo) => ({
        ...Jo,
        ...qn
      })), this.graphicArea !== null) {
        const Jo = [...this.resizeAreas, this.graphicArea];
        if (Jo.length > 0)
          for (let pa = 0; pa < Jo.length; pa++)
            Jo[pa].markDirty();
      }
    });
    Ca(this, "addMutationListener", (Un) => {
      this.postMutationListeners.push(Un);
    });
    Ca(this, "getResizeAreas", () => {
      const Un = [], Kn = this.getMutationPermission();
      return Kn.left && Un.push(new SpatialGraphicResizeArea(this, AreaResizeTrigger.LEFT)), Kn.top && Un.push(new SpatialGraphicResizeArea(this, AreaResizeTrigger.TOP)), Kn.right && Un.push(new SpatialGraphicResizeArea(this, AreaResizeTrigger.RIGHT)), Kn.bottom && Un.push(new SpatialGraphicResizeArea(this, AreaResizeTrigger.BOTTOM)), Kn.leftBottom && Un.push(new SpatialGraphicResizeAngularArea(this, AreaResizeTrigger.LEFT_BOTTOM)), Kn.leftTop && Un.push(new SpatialGraphicResizeAngularArea(this, AreaResizeTrigger.LEFT_TOP)), Kn.rightTop && Un.push(new SpatialGraphicResizeAngularArea(this, AreaResizeTrigger.RIGHT_TOP)), Kn.rightBottom && Un.push(new SpatialGraphicResizeAngularArea(this, AreaResizeTrigger.RIGHT_BOTTOM)), Un;
    });
    /**
     * Возвращает номер корневой графики (графика root component), на которой расположена текущая графика.
     */
    Ca(this, "getRootGraphicNumber", () => {
      const Un = this.getOffset();
      let Kn = 0, qn = this.getParentComponent();
      if (qn === null)
        return null;
      for (; qn !== null; ) {
        const { offset: Jo } = qn.getStructure();
        if (Jo === null)
          break;
        Kn += Jo, qn = qn.getParentComponent();
      }
      return Kn + Un;
    });
    Ca(this, "setOffset", (Un) => {
      this.offset = Un;
    });
    Ca(this, "getGraphicObject", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object is null");
      return this.graphicObject;
    });
    Ca(this, "getID", () => this.id);
    Ca(this, "getOffset", () => this.offset);
    Ca(this, "getShortID", () => this.id.slice(0, 4));
    Ca(this, "getSizePanel", () => this.sizePanel);
    Ca(this, "getFrameArea", () => this.getFrameConfiguration());
    Ca(this, "getParentComponent", () => this.parentComponent);
    Ca(this, "getPostMutationEvents", () => this.postMutationListeners);
    Ca(this, "isMaintainAspectRatio", () => this.maintainAspectRatio);
    Ca(this, "getHoverHighlighter", () => this.hoverHighlighter);
    Ca(this, "getEditModeHighlighter", () => this.editModeHighlighter);
    Ca(this, "enableMaintainAspectRatio", () => {
      this.maintainAspectRatio = !0;
    });
    Ca(this, "disableMaintainAspectRatio", () => {
      this.maintainAspectRatio = !1;
    });
    Ca(this, "correctEnableEditModeVisual", () => {
      this.sizePanel.hide(), this.editModeHighlighter.enable();
    });
    Ca(this, "correctDisableEditModeVisual", () => {
      this.editModeHighlighter.disable(), this.isEnableFocus() && this.sizePanel.show();
    });
    this.offset = 0, this.graphicObject = null, this.parentComponent = null, this.graphicArea = null, this.resizeAreas = [], this.postMutationListeners = [], this.id = Utils.generate.uuid4(), this.sizePanel = new SizePanel(this), this.hoverHighlighter = new HoverGraphicHighlighter(this), this.editModeHighlighter = new EditModeGraphicHighlighter(this), this.addPostEnableFocusListener(this.sizePanel.show), this.addPostDisableFocusListener(this.sizePanel.hide), this.addPostEnableHoverListener(this.hoverHighlighter.enable), this.addPostDisableHoverListener(this.hoverHighlighter.disable), this.addPostEnableEditModeListener(this.correctEnableEditModeVisual), this.addPostDisableEditModeListener(this.correctDisableEditModeVisual);
  }
}
var BorderStyle$1 = /* @__PURE__ */ ((Xn) => (Xn.SOLID = "solid", Xn.DASHED = "dashed", Xn.DOTTED = "dotted", Xn))(BorderStyle$1 || {});
class FigureGraphic extends Graphic {
  constructor() {
    super();
    Ca(this, "type", GraphicType.FIGURE);
    Ca(this, "texture");
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { texture: Jo, frame: pa, id: ma, offset: va } = qn;
      if (Jo === null)
        throw new EditorError("figure graphic texture cannot be null");
      if (pa === null)
        throw new EditorError("figure graphic frame cannot be null");
      this.id = ma, this.offset = va, this.setFrameConfiguration(() => pa), await this.setTexture(() => Jo);
    });
    Ca(this, "getTexture", () => ({ ...this.texture }));
    Ca(this, "setTexture", async (Un) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      const Kn = this.getTexture(), qn = Un(Kn), Jo = this.getFrameConfiguration();
      this.texture = qn, this.graphicObject.object.set({
        fill: qn.background,
        stroke: qn.borderColor,
        strokeWidth: qn.borderWidth,
        path: this.getPath(Jo, qn)
      });
    });
    Ca(this, "getSpatialAreas", () => (this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), this.resizeAreas.length === 0 && (this.resizeAreas = this.getResizeAreas()), [this.graphicArea, ...this.resizeAreas]));
    Ca(this, "getObjects", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      return [this.frameObject, this.graphicObject];
    });
    Ca(this, "getUniqueTexture", () => this.getTexture());
    Ca(this, "startMutation", () => {
    });
    Ca(this, "finishMutation", () => {
    });
    Ca(this, "getPath", (Un, Kn) => {
      let { width: qn, height: Jo } = Un;
      const { topLeft: pa, topRight: ma, bottomRight: va, bottomLeft: ba } = Kn.radius, _a = Kn.borderWidth - 1;
      qn -= _a, Jo -= _a;
      const ya = Math.min(pa, qn / 2, Jo / 2), xa = Math.min(ma, qn / 2, Jo / 2), wa = Math.min(va, qn / 2, Jo / 2), Ta = Math.min(ba, qn / 2, Jo / 2), Sa = 0.5522847498;
      return [
        ["M", ya, 0],
        // Начало пути (верхний левый радиус)
        ["L", qn - xa, 0],
        // Линия до верхнего правого угла
        [
          "C",
          qn - xa * (1 - Sa),
          0,
          // Контрольная точка 1
          qn,
          xa * (1 - Sa),
          // Контрольная точка 2
          qn,
          xa
          // Конечная точка
        ],
        ["L", qn, Jo - wa],
        [
          "C",
          qn,
          Jo - wa * (1 - Sa),
          qn - wa * (1 - Sa),
          Jo,
          qn - wa,
          Jo
        ],
        ["L", Ta, Jo],
        [
          "C",
          Ta * (1 - Sa),
          Jo,
          0,
          Jo - Ta * (1 - Sa),
          0,
          Jo - Ta
        ],
        ["L", 0, ya],
        ["C", 0, ya * (1 - Sa), ya * (1 - Sa), 0, ya, 0],
        ["Z"]
        // Замыкание пути
      ];
    });
    this.graphicObject = {
      object: new Vn("", {
        objectCaching: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.texture = {
      background: "",
      borderColor: "",
      borderWidth: 1,
      borderStyle: BorderStyle$1.SOLID,
      radius: {
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    }, this.addFrameConfigurationChangeListener((Un, Kn) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.path = this.getPath(Kn, this.texture);
    });
  }
}
class UniterGraphic extends Graphic {
  constructor() {
    super();
    Ca(this, "getSpatialAreas", () => (this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), [this.graphicArea]));
    Ca(this, "isUniter", !0);
  }
}
class GroupGraphic extends UniterGraphic {
  constructor() {
    super();
    Ca(this, "type", GraphicType.GROUP);
    Ca(this, "getTexture", () => null);
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { frame: Jo, id: pa, offset: ma } = qn;
      if (Jo === null)
        throw new EditorError("group graphic frame cannot be null");
      this.id = pa, this.offset = ma, this.setFrameConfiguration(() => Jo);
    });
    Ca(this, "setTexture", async (Un) => {
    });
    Ca(this, "getObjects", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      return [this.graphicObject];
    });
    Ca(this, "getUniqueTexture", () => null);
    Ca(this, "startMutation", () => {
    });
    Ca(this, "finishMutation", () => {
    });
    this.graphicObject = {
      object: new pr(),
      relativePosition: { x: 0, y: 0 }
    };
  }
}
var LineStyle = /* @__PURE__ */ ((Xn) => (Xn.SOLID = "solid", Xn.DASHED = "dashed", Xn.DOTTED = "dotted", Xn))(LineStyle || {});
class LineGraphic extends Graphic {
  constructor() {
    super();
    Ca(this, "type", GraphicType.LINE);
    Ca(this, "texture");
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { texture: Jo, frame: pa, id: ma, offset: va } = qn;
      if (Jo === null)
        throw new EditorError("line graphic texture cannot be null");
      if (pa === null)
        throw new EditorError("line graphic frame cannot be null");
      this.id = ma, this.offset = va, this.setFrameConfiguration(() => pa), await this.setTexture(() => Jo);
    });
    Ca(this, "getTexture", () => ({ ...this.texture }));
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture(), qn = Un(Kn), { thickness: Jo, background: pa } = qn;
      if (this.graphicObject === null)
        throw new EditorError("graphic object not found");
      this.texture = qn, this.graphicObject.object.set({
        fill: pa,
        height: Jo
      });
    });
    Ca(this, "getSpatialAreas", () => (this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), this.resizeAreas.length === 0 && (this.resizeAreas = this.getResizeAreas()), [this.graphicArea, ...this.resizeAreas]));
    Ca(this, "getObjects", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      return [this.graphicObject];
    });
    Ca(this, "getUniqueTexture", () => this.getTexture());
    Ca(this, "startMutation", () => {
    });
    Ca(this, "finishMutation", () => {
    });
    this.graphicObject = {
      object: new pr({
        objectCaching: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.texture = {
      background: "",
      thickness: 1,
      style: LineStyle.SOLID
    }, this.setMutationPermissions({
      top: !1,
      right: !0,
      bottom: !1,
      left: !0,
      leftTop: !1,
      rightTop: !1,
      rightBottom: !1,
      leftBottom: !1
    }), this.addFrameConfigurationChangeListener((Un, Kn) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.set("width", Kn.width);
    });
  }
}
class ModuleGraphic extends UniterGraphic {
  constructor() {
    super();
    Ca(this, "type", GraphicType.MODULE);
    Ca(this, "getTexture", () => null);
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { frame: Jo, id: pa, offset: ma } = qn;
      if (Jo === null)
        throw new EditorError("group graphic frame cannot be null");
      this.id = pa, this.offset = ma, this.setFrameConfiguration((va) => Jo);
    });
    Ca(this, "setTexture", async (Un) => {
    });
    Ca(this, "getObjects", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      return [this.graphicObject];
    });
    Ca(this, "getUniqueTexture", () => null);
    Ca(this, "startMutation", () => {
    });
    Ca(this, "finishMutation", () => {
    });
    this.graphicObject = {
      object: new pr(),
      relativePosition: { x: 0, y: 0 }
    };
  }
}
var Orientation = /* @__PURE__ */ ((Xn) => (Xn.PORTRAIT = "PORTRAIT", Xn.LANDSCAPE = "LANDSCAPE", Xn))(Orientation || {});
class ComponentAlignment {
  constructor() {
    Ca(this, "alignToWidth", (...zn) => {
      zn.forEach(this.componentToWidthAlign);
    });
    Ca(this, "alignWithIndentation", (...zn) => {
      zn.forEach(this.componentAlignWithIndentation);
    });
    Ca(this, "alignHorizontalCenter", (...zn) => {
    });
    Ca(this, "alignVerticalCenter", (...zn) => {
    });
    Ca(this, "alignLeft", (...zn) => {
      zn.forEach(this.componentLeftAlign);
    });
    Ca(this, "alignExtremeLeft", (...zn) => {
      zn.forEach(this.componentExtremeLeftAlign);
    });
    Ca(this, "alignTop", (...zn) => {
      zn.forEach(this.componentTopAlign);
    });
    Ca(this, "alignRight", (...zn) => {
      zn.forEach(this.componentRightAlign);
    });
    Ca(this, "alignBottom", (...zn) => {
      zn.forEach(this.componentBottomAlign);
    });
    Ca(this, "componentToWidthAlign", (zn) => {
      const Un = zn.getGraphics();
      if (Un.length === 0)
        throw new EditorError("graphics not found");
      Un.forEach((Kn) => {
        const qn = Kn.getParentGraphic();
        if (qn === null)
          throw new EditorError("parent graphic not found");
        if (!(qn.type === GraphicType.PAGE)) {
          Kn.setFrameConfiguration((ma) => ({
            ...ma,
            x: qn.getFrameConfiguration().x,
            width: qn.getFrameConfiguration().width
          }));
          return;
        }
        const { width: pa } = qn.getFrameConfiguration();
        Kn.setFrameConfiguration((ma) => ({
          ...ma,
          x: 0,
          width: pa
        }));
      });
    });
    Ca(this, "componentAlignWithIndentation", (zn) => {
      const Un = zn.getGraphics();
      if (Un.length === 0)
        throw new EditorError("graphics not found");
      Un.forEach((Kn) => {
        const qn = Kn.getParentGraphic();
        if (qn === null)
          throw new EditorError("parent graphic not found");
        if (!(qn.type === GraphicType.PAGE)) {
          Kn.setFrameConfiguration((ba) => ({
            ...ba,
            x: qn.getFrameConfiguration().x,
            width: qn.getFrameConfiguration().width
          }));
          return;
        }
        const { width: pa } = qn.getFrameConfiguration(), { paddingLeft: ma, paddingRight: va } = qn.getTexture();
        Kn.setFrameConfiguration((ba) => ({
          ...ba,
          x: 0 + ma,
          width: pa - va * 2
        }));
      });
    });
    Ca(this, "componentLeftAlign", (zn) => {
      const Un = zn.getGraphics();
      if (Un.length === 0)
        throw new EditorError("graphics not found");
      Un.forEach((Kn) => {
        const qn = Kn.getParentGraphic();
        if (qn === null)
          throw new EditorError("parent graphic not found");
        if (!(qn.type === GraphicType.PAGE)) {
          Kn.setFrameConfiguration((ma) => ({
            ...ma,
            x: 0
          }));
          return;
        }
        const { paddingLeft: pa } = qn.getTexture();
        Kn.setFrameConfiguration((ma) => ({
          ...ma,
          x: pa
        }));
      });
    });
    Ca(this, "componentExtremeLeftAlign", (zn) => {
      const Un = zn.getGraphics();
      if (Un.length === 0)
        throw new EditorError("graphics not found");
      Un.forEach((Kn) => {
        Kn.setFrameConfiguration((qn) => ({
          ...qn,
          x: 0
        }));
      });
    });
    Ca(this, "componentTopAlign", (zn) => {
      const Un = zn.getGraphics();
      if (Un.length === 0)
        throw new EditorError("graphics not found");
      Un.forEach((Kn) => {
        const qn = Kn.getParentGraphic();
        if (qn === null)
          throw new EditorError("parent graphic not found");
        if (!(qn.type === GraphicType.PAGE)) {
          Kn.setFrameConfiguration((ma) => ({
            ...ma,
            y: 0
          }));
          return;
        }
        const { paddingTop: pa } = qn.getTexture();
        Kn.setFrameConfiguration((ma) => ({
          ...ma,
          y: pa
        }));
      });
    });
    Ca(this, "componentRightAlign", (zn) => {
      const Un = zn.getGraphics();
      if (Un.length === 0)
        throw new EditorError("graphics not found");
      Un.forEach((Kn) => {
        const qn = Kn.getParentGraphic();
        if (qn === null)
          throw new EditorError("parent graphic not found");
        if (!(qn.type === GraphicType.PAGE)) {
          const va = Kn.getParentGraphic();
          if (va === null)
            throw new EditorError("parent graphic is null");
          const ba = va.getFrameConfiguration();
          Kn.setFrameConfiguration((_a) => ({
            ..._a,
            x: ba.width - _a.width
          }));
          return;
        }
        const { paddingRight: pa } = qn.getTexture(), { width: ma } = qn.getFrameConfiguration();
        Kn.setFrameConfiguration((va) => ({
          ...va,
          x: ma - pa - va.width
        }));
      });
    });
    Ca(this, "componentBottomAlign", (zn) => {
      const Un = zn.getGraphics();
      if (Un.length === 0)
        throw new EditorError("graphics not found");
      Un.forEach((Kn) => {
        const qn = Kn.getParentGraphic();
        if (qn === null)
          throw new EditorError("parent graphic not found");
        if (!(qn.type === GraphicType.PAGE)) {
          const va = Kn.getParentGraphic();
          if (va === null)
            throw new EditorError("parent graphic is null");
          const ba = va.getFrameConfiguration();
          Kn.setFrameConfiguration((_a) => ({
            ..._a,
            y: ba.height - _a.height
          }));
          return;
        }
        const { paddingBottom: pa } = qn.getTexture(), { height: ma } = qn.getFrameConfiguration();
        Kn.setFrameConfiguration((va) => ({
          ...va,
          y: ma - pa - va.height
        }));
      });
    });
  }
}
class SpatialImageResizeAngularArea extends SpatialResizeArea {
  constructor(Un, Kn, qn) {
    super(qn);
    Ca(this, "type", SpatialCanvasAreaType.PICTURE_ANGULAR_RESIZE);
    Ca(this, "graphic");
    Ca(this, "imageState");
    Ca(this, "getData", () => ({
      graphic: this.graphic,
      pictureState: this.imageState
    }));
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.graphic.getGlobalPosition(), Kn = this.imageState.getTexture();
      return this.getTriggerArea(
        Un.x + Kn.x,
        Un.y + Kn.y,
        Kn.width,
        Kn.height
      );
    });
    Ca(this, "getRelatedFrames", () => [this.imageState]);
    Ca(this, "isAllowMutatePosition", () => !0);
    this.graphic = Un, this.imageState = Kn;
  }
}
class SpatialImageResizeArea extends SpatialResizeArea {
  constructor(Un, Kn, qn) {
    super(qn);
    Ca(this, "type", SpatialCanvasAreaType.PICTURE_RESIZE);
    Ca(this, "graphic");
    Ca(this, "imageState");
    Ca(this, "getData", () => ({
      graphic: this.graphic,
      pictureState: this.imageState
    }));
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.graphic.getGlobalPosition(), Kn = this.imageState.getTexture();
      return this.getTriggerArea(
        Un.x + Kn.x,
        Un.y + Kn.y,
        Kn.width,
        Kn.height
      );
    });
    Ca(this, "getRelatedFrames", () => [this.imageState]);
    Ca(this, "isAllowMutatePosition", () => !0);
    this.graphic = Un, this.imageState = Kn;
  }
}
class ImageGraphicBlock extends Dependent {
  constructor() {
    super();
    Ca(this, "isEnabled");
    Ca(this, "isBlockEnabled", () => this.isEnabled);
    Ca(this, "getTexture", () => ({
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      rotate: 0,
      source: null,
      radius: {
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    }));
    this.isEnabled = !1;
  }
}
class LoadingPictureBlock extends ImageGraphicBlock {
  constructor() {
    super();
    Ca(this, "loadingRect");
    Ca(this, "animationRunning");
    Ca(this, "postLoadingAnimationListeners");
    Ca(this, "INITIAL_FILL", "hsl(200, 20%, 85%)");
    Ca(this, "ANIMATION_START_VALUE", 85);
    Ca(this, "ANIMATION_END_VALUE", 95);
    Ca(this, "ANIMATION_DURATION", 500);
    Ca(this, "getObject", () => this.loadingRect);
    Ca(this, "startAnimation", () => {
      this.animationRunning || (this.animationRunning = !0, this.recursiveAnimateFill(this.ANIMATION_START_VALUE, this.ANIMATION_END_VALUE));
    });
    Ca(this, "addPostLoadingAnimationListener", (Un) => {
      this.postLoadingAnimationListeners.push(Un);
    });
    Ca(this, "show", () => {
      this.loadingRect.object.visible = !0;
    });
    Ca(this, "hide", () => {
      this.loadingRect.object.visible = !1;
    });
    Ca(this, "configureRect", (Un) => {
      const { width: Kn, height: qn } = Un;
      this.loadingRect.object.set({ width: Kn, height: qn });
    });
    Ca(this, "recursiveAnimateFill", (Un, Kn) => {
      if (!this.isBlockEnabled()) {
        this.animationRunning = !1;
        return;
      }
      un.animate({
        startValue: Un,
        endValue: Kn,
        duration: this.ANIMATION_DURATION,
        onChange: (qn) => {
          this.loadingRect.object.set("fill", `hsl(200, 20%, ${qn}%)`), this.callPostLoadingAnimationListeners();
        },
        onComplete: () => {
          this.recursiveAnimateFill(Kn, Un);
        }
      });
    });
    Ca(this, "callPostLoadingAnimationListeners", () => {
      this.postLoadingAnimationListeners.forEach((Un) => Un());
    });
    this.animationRunning = !1, this.loadingRect = {
      object: new pr({
        visible: !1,
        fill: this.INITIAL_FILL
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.postLoadingAnimationListeners = [], this.addPostInjectDependenciesListener((Un) => {
      Un.graphic.addFrameConfigurationChangeListener((Kn, qn) => {
        this.configureRect(qn);
      });
    });
  }
  enable() {
    this.isEnabled = !0, this.startAnimation(), this.show();
  }
  disable() {
    this.isEnabled = !1, this.hide();
  }
}
const __vite_glob_0_0 = `<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_390)">
<path d="M4.99072 10.4284C4.99072 10.4937 5.04462 10.5466 5.1111 10.5466H5.82747C5.89396 10.5466 5.94785 10.4937 5.94785 10.4284V9.38014C5.94785 9.31486 6.00175 9.26194 6.06824 9.26194H6.59755C7.50441 9.26194 8.07095 8.7004 8.07095 7.84192C8.07095 6.99153 7.51601 6.40979 6.62655 6.40979H5.1111C5.04462 6.40979 4.99072 6.4627 4.99072 6.52798V10.4284ZM6.06824 8.47416C6.00175 8.47416 5.94785 8.42125 5.94785 8.35597V7.33394C5.94785 7.26866 6.00175 7.21574 6.06824 7.21574H6.41965C6.84891 7.21574 7.07901 7.45814 7.07901 7.84192C7.07901 8.22369 6.84891 8.47416 6.41965 8.47416H6.06824Z" fill="#272727"/>
<path d="M10.0067 10.5466C11.2132 10.5466 11.9615 9.76895 11.9615 8.47619C11.9615 7.18544 11.2132 6.40979 10.0047 6.40979H8.66336C8.59687 6.40979 8.54297 6.4627 8.54297 6.52798V10.4284C8.54297 10.4937 8.59687 10.5466 8.66336 10.5466H10.0067ZM9.62049 9.69421C9.55401 9.69421 9.50011 9.64129 9.50011 9.57601V7.3804C9.50011 7.31512 9.55401 7.2622 9.62049 7.2622H9.95644C10.637 7.2622 11.0025 7.58539 11.0025 8.47619C11.0025 9.37102 10.637 9.69421 9.96998 9.69421H9.62049Z" fill="#272727"/>
<path d="M12.5205 10.4284C12.5205 10.4937 12.5744 10.5466 12.6408 10.5466H13.3572C13.4237 10.5466 13.4776 10.4937 13.4776 10.4284V9.00241C13.4776 8.93713 13.5315 8.88421 13.598 8.88421H14.9312C14.9976 8.88421 15.0515 8.83129 15.0515 8.76602V8.18837C15.0515 8.1231 14.9976 8.07018 14.9312 8.07018H13.598C13.5315 8.07018 13.4776 8.01726 13.4776 7.95198V7.34C13.4776 7.27472 13.5315 7.2218 13.598 7.2218H15.1033C15.1697 7.2218 15.2236 7.16888 15.2236 7.10361V6.52798C15.2236 6.4627 15.1697 6.40979 15.1033 6.40979H12.6408C12.5744 6.40979 12.5205 6.4627 12.5205 6.52798V10.4284Z" fill="#272727"/>
<path d="M6.66422 1.54032C6.8061 1.54032 6.8846 1.54066 6.94327 1.54517C6.97462 1.54757 6.98883 1.55053 6.99362 1.5518C6.99787 1.55432 7.00985 1.56232 7.03337 1.58272C7.07785 1.62131 7.13347 1.67701 7.23384 1.7784L9.75217 4.32242C9.85255 4.42383 9.90767 4.47999 9.94584 4.5249C9.96489 4.54731 9.9729 4.55923 9.9757 4.56386C9.97695 4.56912 9.97957 4.58312 9.98176 4.61214C9.98619 4.67096 9.98653 4.74984 9.98653 4.89331V5.22781H11.0098V4.89331L11.0099 4.83949C11.0105 4.62409 11.0113 4.38552 10.9203 4.1637C10.8295 3.94222 10.6624 3.7745 10.5112 3.62269L10.4735 3.58469L7.95513 1.04066L7.91767 1.00266C7.76711 0.849645 7.60148 0.681307 7.38317 0.589956C7.16518 0.49874 6.93085 0.499458 6.71733 0.500112L6.66422 0.500221L3.88507 0.50022C3.29482 0.500199 2.80111 0.500182 2.40884 0.553459C1.99442 0.609744 1.61734 0.733875 1.31365 1.04066C1.00952 1.34789 0.88605 1.73013 0.830131 2.1503C0.777307 2.5472 0.777324 3.0465 0.777345 3.6423V10.3594C0.777324 10.9552 0.777307 11.4545 0.830131 11.8514C0.88605 12.2716 1.00952 12.6538 1.31365 12.961C1.61734 13.2678 1.99442 13.392 2.40884 13.4482C2.80111 13.5015 3.29482 13.5015 3.88507 13.5015H7.90204C8.4923 13.5015 8.98601 13.5015 9.37828 13.4482C9.79269 13.392 10.1698 13.2678 10.4735 12.961C10.7776 12.6538 10.9011 12.2716 10.957 11.8514C10.9623 11.8115 10.9671 11.7705 10.9714 11.7286H9.94072C9.90002 12.0202 9.83188 12.1428 9.75217 12.2233C9.67053 12.3058 9.54486 12.3763 9.24276 12.4173C8.92627 12.4603 8.50151 12.4614 7.86695 12.4614H3.92016C3.28561 12.4614 2.86085 12.4603 2.54435 12.4173C2.24226 12.3763 2.11659 12.3058 2.03495 12.2233C1.95374 12.1413 1.88455 12.0156 1.84414 11.712C1.80169 11.393 1.80059 10.9647 1.80059 10.3234V3.67831C1.80059 3.03701 1.80169 2.60868 1.84414 2.28973C1.88455 1.98608 1.95374 1.86043 2.03495 1.7784C2.11659 1.69593 2.24226 1.62543 2.54435 1.5844C2.86085 1.54141 3.28561 1.54032 3.92016 1.54032H6.66422Z" fill="#272727"/>
</g>
<defs>
<clipPath id="clip0_109_390">
<rect width="16" height="14" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_1 = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.1263 0.300049C11.4577 0.300049 11.7263 0.568678 11.7263 0.900049V2.27373H13.1C13.4314 2.27373 13.7 2.54236 13.7 2.87373C13.7 3.2051 13.4314 3.47373 13.1 3.47373H11.7263V4.84742C11.7263 5.17879 11.4577 5.44742 11.1263 5.44742C10.7949 5.44742 10.5263 5.17879 10.5263 4.84742V3.47373H9.15263C8.82126 3.47373 8.55263 3.2051 8.55263 2.87373C8.55263 2.54236 8.82126 2.27373 9.15263 2.27373H10.5263V0.900049C10.5263 0.568678 10.7949 0.300049 11.1263 0.300049ZM3.7328 0.957943L6.85 0.957944C7.18137 0.957944 7.45 1.22657 7.45 1.55794C7.45 1.88931 7.18137 2.15794 6.85 2.15794H3.75789C3.19531 2.15794 2.80946 2.15841 2.51044 2.18284C2.21843 2.2067 2.06246 2.25039 1.95005 2.30767C1.69157 2.43937 1.48142 2.64951 1.34972 2.90799C1.29244 3.0204 1.24876 3.17637 1.2249 3.46839C1.20047 3.7674 1.2 4.15325 1.2 4.71584V10.2422C1.2 10.8047 1.20047 11.1906 1.2249 11.4896C1.24876 11.7816 1.29244 11.9376 1.34972 12.05C1.48134 12.3083 1.69131 12.5184 1.94957 12.6501C2.01005 12.5434 2.0819 12.4631 2.12861 12.4126C2.22665 12.3065 2.36071 12.1847 2.50215 12.0561L8.09768 6.96927C8.20429 6.87233 8.30751 6.77847 8.40158 6.70516C8.50543 6.62421 8.63147 6.54098 8.79132 6.48906C9.01816 6.41538 9.26127 6.40771 9.49229 6.46695C9.6551 6.50869 9.78613 6.58381 9.89488 6.65805C9.99339 6.72529 10.1023 6.81246 10.2148 6.90249L12.0689 8.38578C12.0827 8.39679 12.0963 8.40768 12.1098 8.41846C12.3185 8.58512 12.4952 8.72627 12.6333 8.90222C12.8055 9.12154 12.9277 9.3758 12.9914 9.64723C13.0425 9.865 13.0423 10.0912 13.0421 10.3582C13.0421 10.3755 13.0421 10.3929 13.0421 10.4106V10.432C13.0421 10.5425 13.0421 10.6482 13.0418 10.7492C13.042 10.7556 13.0421 10.762 13.0421 10.7685C13.0421 10.7975 13.0421 10.8261 13.0421 10.8543C13.0424 11.3825 13.0426 11.7635 12.9544 12.0925C12.8503 12.4811 12.6589 12.8324 12.4022 13.1247C12.3197 13.2187 12.2303 13.3066 12.135 13.3876C11.8491 13.6305 11.5091 13.812 11.1345 13.9124C10.8056 14.0005 10.4246 14.0003 9.89639 14.0001C9.86819 14.0001 9.83958 14 9.81053 14H9.51234C9.49963 14 9.48685 14 9.47401 14H3.73282C3.71792 14 3.70309 14 3.68834 14L3.25369 14.0001C3.08366 14.0001 2.92153 14.0001 2.7865 13.9913C2.65285 13.987 2.52843 13.9806 2.41272 13.9712C2.0465 13.9412 1.71503 13.8774 1.40526 13.7195C0.920987 13.4728 0.527263 13.0791 0.280515 12.5948C0.122675 12.285 0.0588043 11.9535 0.028883 11.5873C-1.26529e-05 11.2337 -6.87168e-06 10.7986 2.21277e-07 10.2672V4.69075C-6.87168e-06 4.15938 -1.26529e-05 3.72433 0.028883 3.37067C0.0588044 3.00445 0.122676 2.67298 0.280515 2.3632C0.527263 1.87893 0.920987 1.48521 1.40526 1.23846C1.71503 1.08062 2.0465 1.01675 2.41272 0.986826C2.76639 0.95793 3.20144 0.957936 3.7328 0.957943ZM11.5411 12.2845C11.618 12.1884 11.6822 12.0817 11.7314 11.9666C11.7736 11.8681 11.806 11.7319 11.8237 11.4802C11.8418 11.2229 11.8421 10.8924 11.8421 10.4106C11.8421 10.0635 11.8384 9.98633 11.8232 9.92149C11.7993 9.82007 11.7537 9.72508 11.6894 9.64313C11.6483 9.59074 11.5903 9.53961 11.3193 9.32282L9.47902 7.85058C9.34746 7.74534 9.27455 7.68752 9.21832 7.64914C9.2022 7.63814 9.19131 7.63148 9.1848 7.62774C9.18032 7.62736 9.17582 7.62751 9.17138 7.62817C9.16512 7.63231 9.15466 7.63964 9.13927 7.65163C9.08557 7.69349 9.01645 7.75578 8.89179 7.86911L3.46796 12.7999C3.55912 12.8 3.65559 12.8 3.75789 12.8H9.45262C9.93448 12.8 10.2649 12.7997 10.5222 12.7816C10.7739 12.764 10.9102 12.7315 11.0087 12.6893C11.1434 12.6317 11.2667 12.5535 11.3749 12.4585C11.4352 12.4055 11.4909 12.3473 11.5411 12.2845ZM4.21842 4.46058C3.8231 4.46058 3.50263 4.78104 3.50263 5.17636C3.50263 5.57168 3.8231 5.89215 4.21842 5.89215C4.61374 5.89215 4.93421 5.57168 4.93421 5.17636C4.93421 4.78104 4.61374 4.46058 4.21842 4.46058ZM2.30263 5.17636C2.30263 4.1183 3.16036 3.26058 4.21842 3.26058C5.27648 3.26058 6.13421 4.1183 6.13421 5.17636C6.13421 6.23443 5.27648 7.09215 4.21842 7.09215C3.16036 7.09215 2.30263 6.23443 2.30263 5.17636Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_2 = `<svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_97_76)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4571 1.97637C12.8086 1.6249 13.3785 1.6249 13.7299 1.97637C13.9568 2.2032 14.1337 2.53157 14.2676 2.81061C14.4158 3.11931 14.5681 3.49274 14.7204 3.89639C15.0185 4.68637 15.3407 5.65702 15.6567 6.60869L15.6777 6.67211C16.004 7.65511 16.3232 8.61407 16.6158 9.38312C16.7622 9.76778 16.8957 10.0883 17.0138 10.3316C17.1337 10.5784 17.2033 10.6719 17.2127 10.6846L17.2138 10.6861L17.2153 10.6871C17.2279 10.6965 17.3213 10.7661 17.5682 10.886C17.8116 11.0042 18.132 11.1377 18.5167 11.284C19.2857 11.5766 20.2447 11.8958 21.2277 12.2221L21.2911 12.2432C22.2428 12.5591 23.2134 12.8813 24.0034 13.1794C24.4071 13.3318 24.7805 13.484 25.0892 13.6322C25.3683 13.7661 25.6966 13.9431 25.9235 14.1699C26.2749 14.5214 26.2749 15.0912 25.9235 15.4427C25.6966 15.6696 25.3683 15.8465 25.0892 15.9804C24.7805 16.1286 24.4071 16.2809 24.0034 16.4332C23.2135 16.7313 22.2428 17.0535 21.2912 17.3694L21.2277 17.3905C20.2447 17.7168 19.2857 18.036 18.5167 18.3286C18.132 18.475 17.8116 18.6085 17.5682 18.7266C17.3213 18.8465 17.2279 18.9161 17.2153 18.9255L17.2138 18.9266L17.2128 18.928C17.2034 18.9407 17.1337 19.0341 17.0138 19.281C16.8957 19.5244 16.7622 19.8448 16.6158 20.2295C16.3232 20.9985 16.004 21.9575 15.6777 22.9405L15.6567 23.0039C15.3407 23.9556 15.0185 24.9262 14.7204 25.7162C14.5681 26.1199 14.4158 26.4933 14.2676 26.802C14.1337 27.081 13.9568 27.4094 13.7299 27.6362C13.3785 27.9877 12.8086 27.9877 12.4571 27.6362C12.2303 27.4094 12.0533 27.081 11.9194 26.802C11.7712 26.4933 11.619 26.1199 11.4666 25.7162C11.1685 24.9262 10.8463 23.9556 10.5304 23.0039L10.5094 22.9405C10.183 21.9575 9.86383 20.9985 9.57122 20.2295C9.42486 19.8448 9.29138 19.5244 9.17321 19.281C9.05334 19.0341 8.98374 18.9407 8.9743 18.9281L8.97328 18.9266L8.9718 18.9255C8.95908 18.9161 8.86564 18.8465 8.61886 18.7266C8.37549 18.6085 8.05502 18.475 7.67036 18.3286C6.90131 18.036 5.94235 17.7168 4.95935 17.3905L4.89593 17.3694C3.94427 17.0535 2.97359 16.7313 2.18363 16.4332C1.77997 16.2809 1.40655 16.1286 1.09785 15.9804C0.818804 15.8465 0.490439 15.6696 0.263604 15.4427C-0.087868 15.0912 -0.087868 14.5214 0.263604 14.1699C0.490439 13.9431 0.818804 13.7661 1.09785 13.6322C1.40655 13.484 1.77997 13.3318 2.18363 13.1794C2.97361 12.8813 3.94426 12.5591 4.89595 12.2432L4.95935 12.2221C5.94235 11.8958 6.90131 11.5766 7.67036 11.284C8.05502 11.1377 8.37549 11.0042 8.61886 10.886C8.86576 10.7661 8.95915 10.6965 8.9718 10.6871L8.97327 10.6861L8.9743 10.6846C8.98373 10.6719 9.05334 10.5786 9.17321 10.3316C9.29138 10.0883 9.42486 9.76778 9.57122 9.38312C9.86383 8.61407 10.183 7.65511 10.5094 6.67211L10.5304 6.60871C10.8463 5.65703 11.1685 4.68637 11.4666 3.89639C11.619 3.49274 11.7712 3.11931 11.9194 2.81061C12.0533 2.53157 12.2303 2.2032 12.4571 1.97637ZM10.7924 11.1178C10.6543 11.4024 10.4744 11.7305 10.2461 11.9589C10.0177 12.1872 9.6896 12.3671 9.40505 12.5052C9.09292 12.6568 8.7166 12.8118 8.31046 12.9664C7.4979 13.2755 6.49918 13.6076 5.52647 13.9305L5.4857 13.944C4.5807 14.2444 3.69989 14.5368 2.97217 14.8063C3.69993 15.0758 4.58064 15.3682 5.4857 15.6686L5.52647 15.6822C6.49918 16.0051 7.4979 16.3371 8.31046 16.6463C8.7166 16.8008 9.09292 16.9559 9.40505 17.1074C9.6896 17.2456 10.0177 17.4255 10.2461 17.6538C10.4744 17.8821 10.6543 18.2103 10.7924 18.4948C10.944 18.8069 11.099 19.1833 11.2536 19.5894C11.5627 20.402 11.8948 21.4007 12.2177 22.3734L12.2312 22.4141C12.5316 23.3191 12.824 24.1999 13.0935 24.9277C13.363 24.1999 13.6554 23.3192 13.9559 22.4141L13.9694 22.3734C14.2923 21.4007 14.6243 20.402 14.9335 19.5894C15.088 19.1833 15.2431 18.8069 15.3946 18.4948C15.5328 18.2103 15.7127 17.8821 15.941 17.6538C16.1693 17.4255 16.4975 17.2456 16.782 17.1074C17.0941 16.9559 17.4705 16.8008 17.8766 16.6463C18.6892 16.3371 19.6879 16.0051 20.6606 15.6822L20.7013 15.6687C21.6064 15.3682 22.4871 15.0758 23.2149 14.8063C22.4871 14.5368 21.6064 14.2445 20.7014 13.944L20.6606 13.9305C19.6879 13.6076 18.6892 13.2755 17.8766 12.9664C17.4705 12.8118 17.0941 12.6568 16.782 12.5052C16.4975 12.3671 16.1693 12.1872 15.941 11.9589C15.7127 11.7305 15.5328 11.4024 15.3946 11.1178C15.2431 10.8057 15.088 10.4294 14.9335 10.0233C14.6243 9.21066 14.2923 8.21194 13.9694 7.23924L13.9558 7.19846C13.6554 6.29341 13.363 5.41269 13.0935 4.68494C12.8241 5.4126 12.5317 6.29318 12.2313 7.19811L12.2177 7.23924C11.8948 8.21194 11.5627 9.21066 11.2536 10.0233C11.099 10.4294 10.944 10.8057 10.7924 11.1178Z" fill="#7F8184"/>
<path d="M23.5439 19.8656C24.041 19.8656 24.4439 20.2686 24.4439 20.7656V24.2205H27.8987C28.3958 24.2205 28.7987 24.6234 28.7987 25.1205C28.7987 25.6175 28.3958 26.0205 27.8987 26.0205H24.4439V29.4753C24.4439 29.9723 24.041 30.3753 23.5439 30.3753C23.0468 30.3753 22.6439 29.9723 22.6439 29.4753V26.0205H19.1891C18.692 26.0205 18.2891 25.6175 18.2891 25.1205C18.2891 24.6234 18.692 24.2205 19.1891 24.2205H22.6439V20.7656C22.6439 20.2686 23.0468 19.8656 23.5439 19.8656Z" fill="#7F8184"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 3C22.8954 3 22 3.89543 22 5C22 6.10458 22.8954 7 24 7C25.1046 7 26 6.10458 26 5C26 3.89543 25.1046 3 24 3ZM21 5C21 3.34315 22.3431 2 24 2C25.6569 2 27 3.34315 27 5C27 6.65686 25.6569 8 24 8C22.3431 8 21 6.65687 21 5Z" fill="#7F8184"/>
</g>
<defs>
<clipPath id="clip0_97_76">
<rect width="29" height="31" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_3 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C12.5523 2 13 2.44772 13 3V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V3C11 2.44772 11.4477 2 12 2Z" fill="black"/>
<path d="M15 6C15 5.44772 15.4477 5 16 5H20C20.5523 5 21 5.44772 21 6V10C21 10.5523 20.5523 11 20 11H16C15.4477 11 15 10.5523 15 10C15 9.44772 15.4477 9 16 9H19V7H16C15.4477 7 15 6.55228 15 6Z" fill="black"/>
<path d="M4 5C3.44772 5 3 5.44772 3 6V10C3 10.5523 3.44772 11 4 11H8C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9H5V7H8C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5H4Z" fill="black"/>
<path d="M15 14C15 13.4477 15.4477 13 16 13H18C18.5523 13 19 13.4477 19 14V18C19 18.5523 18.5523 19 18 19H16C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17H17V15H16C15.4477 15 15 14.5523 15 14Z" fill="black"/>
<path d="M6 13C5.44772 13 5 13.4477 5 14V18C5 18.5523 5.44772 19 6 19H8C8.55228 19 9 18.5523 9 18C9 17.4477 8.55228 17 8 17H7V15H8C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13H6Z" fill="black"/>
</svg>
`, __vite_glob_0_4 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 12C2 11.4477 2.44772 11 3 11L21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L3 13C2.44772 13 2 12.5523 2 12Z" fill="black"/>
<path d="M6 9C5.44772 9 5 8.55229 5 8V4C5 3.44772 5.44772 3 6 3H10C10.5523 3 11 3.44772 11 4V8C11 8.55229 10.5523 9 10 9C9.44772 9 9 8.55229 9 8V5H7V8C7 8.55229 6.55228 9 6 9Z" fill="black"/>
<path d="M5 20C5 20.5523 5.44772 21 6 21H10C10.5523 21 11 20.5523 11 20V16C11 15.4477 10.5523 15 10 15C9.44772 15 9 15.4477 9 16V19H7L7 16C7 15.4477 6.55228 15 6 15C5.44772 15 5 15.4477 5 16V20Z" fill="black"/>
<path d="M14 9C13.4477 9 13 8.55229 13 8V6C13 5.44772 13.4477 5 14 5H18C18.5523 5 19 5.44772 19 6L19 8C19 8.55229 18.5523 9 18 9C17.4477 9 17 8.55229 17 8V7H15V8C15 8.55229 14.5523 9 14 9Z" fill="black"/>
<path d="M13 18C13 18.5523 13.4477 19 14 19L18 19C18.5523 19 19 18.5523 19 18V16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16V17H15V16C15 15.4477 14.5523 15 14 15C13.4477 15 13 15.4477 13 16V18Z" fill="black"/>
</svg>
`, __vite_glob_0_5 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2C2.55228 2 3 2.44772 3 3V21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21V3C1 2.44772 1.44772 2 2 2Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 6C5 5.44772 5.44772 5 6 5H22C22.5523 5 23 5.44772 23 6V10C23 10.5523 22.5523 11 22 11H6C5.44772 11 5 10.5523 5 10V6ZM7 7V9H21V7H7Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 13C5.44772 13 5 13.4477 5 14V18C5 18.5523 5.44772 19 6 19H16C16.5523 19 17 18.5523 17 18V14C17 13.4477 16.5523 13 16 13H6ZM7 17V15H15V17H7Z" fill="black"/>
</svg>
`, __vite_glob_0_6 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 2C22.5523 2 23 2.44772 23 3V21C23 21.5523 22.5523 22 22 22C21.4477 22 21 21.5523 21 21V3C21 2.44772 21.4477 2 22 2Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 6C1 5.44772 1.44772 5 2 5H18C18.5523 5 19 5.44772 19 6V10C19 10.5523 18.5523 11 18 11H2C1.44772 11 1 10.5523 1 10V6ZM3 7V9H17V7H3Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 13C7.44772 13 7 13.4477 7 14V18C7 18.5523 7.44772 19 8 19H18C18.5523 19 19 18.5523 19 18V14C19 13.4477 18.5523 13 18 13H8ZM9 17V15H17V17H9Z" fill="black"/>
</svg>
`, __vite_glob_0_7 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2C2 1.44772 2.44772 1 3 1H21C21.5523 1 22 1.44772 22 2C22 2.55228 21.5523 3 21 3H3C2.44772 3 2 2.55228 2 2Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 6C5 5.44772 5.44772 5 6 5H10C10.5523 5 11 5.44772 11 6V22C11 22.5523 10.5523 23 10 23H6C5.44772 23 5 22.5523 5 22V6ZM7 7V21H9V7H7Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 5C13.4477 5 13 5.44772 13 6V16C13 16.5523 13.4477 17 14 17H18C18.5523 17 19 16.5523 19 16V6C19 5.44772 18.5523 5 18 5H14ZM15 15V7H17V15H15Z" fill="black"/>
</svg>
`, __vite_glob_0_8 = `<svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.705 0.808841C19.0983 1.22063 19.0983 1.88827 18.705 2.30005L10.2122 11.1912C9.81886 11.6029 9.18113 11.6029 8.7878 11.1912L0.295006 2.30005C-0.0983353 1.88827 -0.0983353 1.22063 0.295006 0.80884C0.688345 0.397052 1.32607 0.397053 1.71941 0.80884L9.5 8.95434L17.2806 0.80884C17.6739 0.397053 18.3117 0.397053 18.705 0.808841Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_9 = `<svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.705 11.1912C19.0983 10.7794 19.0983 10.1117 18.705 9.69995L10.2122 0.808841C9.81886 0.397053 9.18114 0.397053 8.7878 0.808841L0.295006 9.69995C-0.0983352 10.1117 -0.0983353 10.7794 0.295006 11.1912C0.688345 11.6029 1.32607 11.6029 1.71941 11.1912L9.5 3.04566L17.2806 11.1912C17.6739 11.6029 18.3117 11.6029 18.705 11.1912Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_10 = `<svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_107_74)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.6897 0.275864C12.0896 0.65675 12.105 1.28973 11.7241 1.68966L2.38095 11.5L11.7241 21.3103C12.105 21.7103 12.0896 22.3432 11.6897 22.7241C11.2897 23.105 10.6567 23.0896 10.2759 22.6896L0.275862 12.1896C-0.0919539 11.8034 -0.0919539 11.1965 0.275862 10.8103L10.2759 0.310347C10.6567 -0.0895834 11.2897 -0.105022 11.6897 0.275864Z" fill="#87909A"/>
</g>
<defs>
<clipPath id="clip0_107_74">
<rect width="12" height="23" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_11 = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_30)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.584961 1.25002C0.584961 0.882753 0.882692 0.585022 1.24996 0.585022H5.74996C6.11723 0.585022 6.41496 0.882753 6.41496 1.25002C6.41496 1.61729 6.11723 1.91502 5.74996 1.91502H2.85541L6.22019 5.2798C6.47989 5.53949 6.47989 5.96055 6.22019 6.22025C5.96049 6.47995 5.53943 6.47995 5.27974 6.22025L1.91496 2.85547V5.75002C1.91496 6.11729 1.61723 6.41502 1.24996 6.41502C0.882692 6.41502 0.584961 6.11729 0.584961 5.75002V1.25002ZM10.25 0.585022H14.75C15.1172 0.585022 15.415 0.882753 15.415 1.25002V5.75002C15.415 6.11729 15.1172 6.41502 14.75 6.41502C14.3827 6.41502 14.085 6.11729 14.085 5.75002V2.85547L10.7202 6.22025C10.4605 6.47995 10.0394 6.47995 9.77973 6.22025C9.52004 5.96055 9.52004 5.53949 9.77973 5.2798L13.1445 1.91502H10.25C9.88269 1.91502 9.58496 1.61729 9.58496 1.25002C9.58496 0.882753 9.88269 0.585022 10.25 0.585022ZM1.91496 13.1446L5.27974 9.7798C5.53943 9.5201 5.96049 9.5201 6.22019 9.7798C6.47989 10.0395 6.47989 10.4605 6.22019 10.7202L2.85541 14.085H5.74996C6.11723 14.085 6.41496 14.3828 6.41496 14.75C6.41496 15.1173 6.11723 15.415 5.74996 15.415H1.24996C0.882692 15.415 0.584961 15.1173 0.584961 14.75V10.25C0.584961 9.88275 0.882692 9.58502 1.24996 9.58502C1.61723 9.58502 1.91496 9.88275 1.91496 10.25V13.1446ZM9.77973 9.7798C10.0394 9.5201 10.4605 9.5201 10.7202 9.7798L14.085 13.1446V10.25C14.085 9.88275 14.3827 9.58502 14.75 9.58502C15.1172 9.58502 15.415 9.88275 15.415 10.25V14.75C15.415 15.1173 15.1172 15.415 14.75 15.415H10.25C9.88269 15.415 9.58496 15.1173 9.58496 14.75C9.58496 14.3828 9.88269 14.085 10.25 14.085H13.1445L9.77973 10.7202C9.52004 10.4605 9.52004 10.0395 9.77973 9.7798Z" fill="#7F8184"/>
</g>
<defs>
<clipPath id="clip0_108_30">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_12 = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_429)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.33325C0 0.780967 0.447715 0.333252 1 0.333252H11C11.5523 0.333252 12 0.780967 12 1.33325C12 1.88554 11.5523 2.33325 11 2.33325H1C0.447715 2.33325 0 1.88554 0 1.33325Z" fill="#C2C2C2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.33327C0 4.59689 0.596954 3.99994 1.33333 3.99994H10.6667C11.403 3.99994 12 4.59689 12 5.33327C12 6.06965 11.403 6.6666 10.6667 6.6666H1.33333C0.596954 6.6666 0 6.06965 0 5.33327Z" fill="#C2C2C2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.99992C0 9.07944 0.746192 8.33325 1.66667 8.33325H10.3333C11.2538 8.33325 12 9.07944 12 9.99992C12 10.9204 11.2538 11.6666 10.3333 11.6666H1.66667C0.746192 11.6666 0 10.9204 0 9.99992Z" fill="#C2C2C2"/>
</g>
<defs>
<clipPath id="clip0_109_429">
<rect width="12" height="12" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_13 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02943 3 3 7.02943 3 12C3 16.9705 7.02944 21 12 21C16.9705 21 21 16.9705 21 12C21 7.02944 16.9705 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92486 23 12C23 18.0751 18.0751 23 12 23C5.92486 23 1 18.0751 1 12ZM8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L12 10.5858L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L13.4142 12L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L12 13.4142L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L10.5858 12L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289Z" fill="#FF3636"/>
</svg>
`, __vite_glob_0_14 = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_120)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#EDEDED"/>
</g>
<defs>
<clipPath id="clip0_108_120">
<rect width="12" height="12" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_15 = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 5C0 2.23858 2.23858 0 5 0H25C27.7614 0 30 2.23858 30 5V25C30 27.7614 27.7614 30 25 30H5C2.23858 30 0 27.7614 0 25V5Z" fill="#D9D9D9"/>
</svg>
`, __vite_glob_0_16 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_313)">
<mask id="mask0_109_313" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<path d="M24 0H0V24H24V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_109_313)">
<path d="M3.12466 10.6637C3.12466 10.4309 2.87092 10.2868 2.67095 10.4061L0.43144 11.7424C0.236395 11.8587 0.236395 12.1412 0.431439 12.2576L2.67095 13.5938C2.87092 13.7132 3.12466 13.5691 3.12466 13.3362V10.6637Z" fill="#565656"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00195 5C4.00195 3.34315 5.3451 2 7.00195 2H15.0062V13H4.00195V5ZM7.00195 4C6.44967 4 6.00195 4.44772 6.00195 5V11H13.0062V4H7.00195Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.0038 22H6.99951C5.34266 22 3.99951 20.6569 3.99951 19V11H15.0038V22ZM13.0038 20V13H5.99951V19C5.99951 19.5523 6.44723 20 6.99951 20H13.0038Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.0059 2H21.0101C22.667 2 24.0101 3.34315 24.0101 5V13H13.0059V2ZM15.0059 4V11H22.0101V5C22.0101 4.44772 21.5624 4 21.0101 4H15.0059Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M24.0115 19C24.0115 20.6569 22.6684 22 21.0115 22H13.0073V11H24.0115V19ZM21.0115 20C21.5638 20 22.0115 19.5523 22.0115 19V13H15.0073V20H21.0115Z" fill="black"/>
</g>
</g>
<defs>
<clipPath id="clip0_109_313">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_17 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_296)">
<mask id="mask0_109_296" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<path d="M24 0H0V24H24V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_109_296)">
<path d="M20.8872 10.6637C20.8872 10.4309 21.1409 10.2868 21.3409 10.4061L23.5804 11.7424C23.7754 11.8587 23.7754 12.1412 23.5804 12.2576L21.3409 13.5938C21.1409 13.7132 20.8872 13.5691 20.8872 13.3362V10.6637Z" fill="#565656"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.0097 5C20.0097 3.34315 18.6665 2 17.0097 2H9.00537V13H20.0097V5ZM17.0097 4C17.562 4 18.0097 4.44772 18.0097 5V11H11.0054V4H17.0097Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.00781 22H17.0121C18.6689 22 20.0121 20.6569 20.0121 19V11H9.00781V22ZM11.0078 20V13H18.0121V19C18.0121 19.5523 17.5644 20 17.0121 20H11.0078Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0058 2H3.00147C1.34461 2 0.00146484 3.34315 0.00146484 5V13H11.0058V2ZM9.00573 4V11H2.00147V5C2.00147 4.44772 2.44918 4 3.00147 4H9.00573Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.99382e-07 19C8.44228e-07 20.6569 1.34315 22 3 22H11.0043V11H0L6.99382e-07 19ZM3 20C2.44772 20 2 19.5523 2 19V13H9.00426V20H3Z" fill="black"/>
</g>
</g>
<defs>
<clipPath id="clip0_109_296">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_18 = `<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_27)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24.9994 2.69073C12.6783 2.69073 2.68994 12.679 2.68994 25.0002C2.68994 37.3215 12.6783 47.3098 24.9994 47.3098C37.3206 47.3098 47.309 37.3215 47.309 25.0002C47.309 12.679 37.3206 2.69073 24.9994 2.69073ZM-0.310059 25.0002C-0.310059 11.0222 11.0214 -0.309265 24.9994 -0.309265C38.9775 -0.309265 50.309 11.0222 50.309 25.0002C50.309 38.9783 38.9775 50.3098 24.9994 50.3098C11.0214 50.3098 -0.310059 38.9783 -0.310059 25.0002ZM24.9994 13.9765C25.8279 13.9765 26.4994 14.648 26.4994 15.4765V23.5002H34.5233C35.3517 23.5002 36.0233 24.1718 36.0233 25.0002C36.0233 25.8287 35.3517 26.5002 34.5233 26.5002H26.4994V34.5241C26.4994 35.3525 25.8279 36.0241 24.9994 36.0241C24.171 36.0241 23.4994 35.3525 23.4994 34.5241V26.5002H15.4756C14.6472 26.5002 13.9756 25.8287 13.9756 25.0002C13.9756 24.1718 14.6472 23.5002 15.4756 23.5002H23.4994V15.4765C23.4994 14.648 24.171 13.9765 24.9994 13.9765Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_106_27">
<rect width="50" height="50" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_19 = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_425)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 1C2.34314 1 1 2.34314 1 4V9.5C1 9.77614 0.776142 10 0.5 10C0.223858 10 0 9.77614 0 9.5V4C0 1.79086 1.79086 0 4 0H9.5C9.77614 0 10 0.223858 10 0.5C10 0.776142 9.77614 1 9.5 1H4Z" fill="#C2C2C2"/>
</g>
<defs>
<clipPath id="clip0_109_425">
<rect width="10" height="10" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_20 = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_33)">
<path d="M6.3 3.2487e-07H5.18283C4.45839 -9.868e-06 3.86043 -1.82837e-05 3.37336 0.0397764C2.86747 0.0811089 2.40244 0.169816 1.96563 0.392379C1.28825 0.737523 0.737523 1.28825 0.392379 1.96563C0.169816 2.40244 0.0811089 2.86747 0.0397764 3.37336C-1.82837e-05 3.86043 -9.868e-06 4.45833 3.2487e-07 5.18277V6.3H1.8V5.22C1.8 4.44908 1.8007 3.92501 1.8338 3.51993C1.86604 3.12536 1.92447 2.92358 1.99619 2.78282C2.16876 2.44413 2.44413 2.16876 2.78282 1.99619C2.92358 1.92447 3.12536 1.86604 3.51993 1.8338C3.92501 1.8007 4.44908 1.8 5.22 1.8H6.3V3.2487e-07Z" fill="#C2C2C2"/>
<path d="M16.2002 6.3V5.22C16.2002 4.44908 16.1995 3.92501 16.1664 3.51993C16.1342 3.12536 16.0758 2.92358 16.004 2.78282C15.8314 2.44413 15.556 2.16876 15.2174 1.99619C15.0767 1.92447 14.8748 1.86604 14.4803 1.8338C14.0752 1.8007 13.5512 1.8 12.7802 1.8H11.7002V3.2487e-07H12.8173C13.5418 -9.868e-06 14.1398 -1.82837e-05 14.6269 0.0397764C15.1327 0.081109 15.5978 0.169816 16.0346 0.392379C16.712 0.737523 17.2626 1.28825 17.6078 1.96563C17.8304 2.40244 17.9191 2.86747 17.9604 3.37336C18.0002 3.86044 18.0002 4.45835 18.0002 5.18283V6.3H16.2002Z" fill="#C2C2C2"/>
<path d="M11.7002 16.2H12.7802C13.5512 16.2 14.0752 16.1993 14.4803 16.1663C14.8748 16.134 15.0767 16.0756 15.2174 16.0038C15.556 15.8312 15.8314 15.5558 16.004 15.2172C16.0758 15.0765 16.1342 14.8746 16.1664 14.4801C16.1995 14.075 16.2002 13.551 16.2002 12.78V11.7H18.0002V12.8171C18.0002 13.5416 18.0002 14.1396 17.9604 14.6267C17.9191 15.1325 17.8304 15.5976 17.6078 16.0344C17.2626 16.7118 16.712 17.2625 16.0346 17.6076C15.5978 17.8303 15.1327 17.9189 14.6269 17.9602C14.1398 18 13.5418 18 12.8173 18H11.7002V16.2Z" fill="#C2C2C2"/>
<path d="M1.8 11.7V12.78C1.8 13.551 1.8007 14.075 1.8338 14.4801C1.86604 14.8746 1.92447 15.0765 1.99619 15.2172C2.16876 15.5558 2.44413 15.8312 2.78282 16.0038C2.92358 16.0756 3.12536 16.134 3.51993 16.1663C3.92501 16.1993 4.44908 16.2 5.22 16.2H6.3V18H5.18283C4.45835 18 3.86044 18 3.37336 17.9602C2.86747 17.9189 2.40244 17.8303 1.96563 17.6076C1.28825 17.2625 0.737523 16.7118 0.392379 16.0344C0.169816 15.5976 0.0811089 15.1325 0.0397764 14.6267C-1.82837e-05 14.1396 -9.868e-06 13.5416 3.2487e-07 12.8172V11.7H1.8Z" fill="#C2C2C2"/>
</g>
<defs>
<clipPath id="clip0_108_33">
<rect width="18" height="18" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_21 = `<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0642 6.09435C12.3211 6.36576 12.667 6.52556 13.0428 6.52556C13.7854 6.52556 14.4424 5.88029 14.4424 5.01462C14.4424 4.14894 13.7854 3.50368 13.0428 3.50368C12.3904 3.50368 12.0652 3.8538 11.9383 4.07309C11.771 4.36196 11.4013 4.46055 11.1124 4.29331C10.8235 4.12606 10.7249 3.75631 10.8922 3.46744C11.1853 2.96108 11.868 2.29492 13.0428 2.29492C14.5137 2.29492 15.6512 3.54378 15.6512 5.01462C15.6512 6.48546 14.5137 7.73432 13.0428 7.73432C12.4075 7.73432 11.8288 7.49738 11.3808 7.11096C11.2938 7.33804 11.0738 7.49928 10.8162 7.49928C10.4824 7.49928 10.2118 7.22869 10.2118 6.8949V5.48469C10.2118 5.1509 10.4824 4.88031 10.8162 4.88031H12.1521C12.4859 4.88031 12.7565 5.1509 12.7565 5.48469C12.7565 5.81848 12.4859 6.08907 12.1521 6.08907H12.0592L12.0642 6.09435Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.82593 2.95493L5.72162 2.95493C5.19457 2.95492 4.75959 2.95491 4.40525 2.98386C4.03722 3.01393 3.69891 3.07846 3.38115 3.24038C2.88836 3.49146 2.48771 3.89211 2.23662 4.3849C2.07471 4.70267 2.01018 5.04097 1.98011 5.409C1.95116 5.76334 1.95116 6.19832 1.95117 6.72536V12.2793C1.95116 12.8063 1.95116 13.2413 1.98011 13.5956C2.01018 13.9637 2.07471 14.302 2.23662 14.6197C2.48771 15.1125 2.88836 15.5132 3.38115 15.7642C3.69891 15.9262 4.03722 15.9907 4.40525 16.0208C4.5211 16.0302 4.64556 16.0366 4.77905 16.0409C4.91538 16.0497 5.07792 16.0497 5.24542 16.0497L11.8623 16.0497C12.3831 16.05 12.7698 16.0502 13.1048 15.9605C13.4716 15.8622 13.8057 15.6876 14.0896 15.4543C14.1992 15.3642 14.3013 15.2654 14.3948 15.1589C14.656 14.8615 14.8508 14.504 14.9567 14.1086C15.0465 13.7736 15.0463 13.3869 15.046 12.8661L15.0459 12.776L15.0456 12.7561C15.0459 12.6562 15.0459 12.5519 15.0459 12.4429L15.046 12.3655C15.0462 12.1022 15.0464 11.8705 14.994 11.647C14.9286 11.3687 14.8033 11.108 14.6268 10.8831C14.4851 10.7025 14.304 10.5579 14.0983 10.3937L12.2098 8.88291C12.0986 8.79392 11.9886 8.70591 11.8887 8.63772C11.7776 8.56191 11.6409 8.48317 11.4699 8.43931C11.2294 8.37765 10.9763 8.38563 10.7401 8.46233C10.5722 8.51688 10.4407 8.60409 10.3346 8.68674C10.2392 8.7611 10.135 8.85586 10.0297 8.95168L4.45909 14.0158C4.31933 14.1429 4.18419 14.2657 4.08487 14.3731C4.04503 14.4162 3.98451 14.4833 3.92794 14.5719C3.70339 14.4456 3.52072 14.2555 3.40337 14.0252C3.3512 13.9228 3.30869 13.776 3.28524 13.489C3.26116 13.1943 3.26065 12.8131 3.26065 12.2522V6.75241C3.26065 6.19157 3.26116 5.81033 3.28524 5.51563C3.30869 5.22859 3.3512 5.08179 3.40337 4.97939C3.52892 4.733 3.72924 4.53267 3.97564 4.40713C4.07804 4.35495 4.22483 4.31244 4.51188 4.28899C4.80657 4.26491 5.18782 4.2644 5.74866 4.2644H8.82593C9.18753 4.2644 9.48067 3.97127 9.48067 3.60967C9.48067 3.24806 9.18753 2.95493 8.82593 2.95493ZM13.6309 13.9458C13.588 14.0462 13.533 14.1399 13.4678 14.2253C13.3981 14.3167 13.3166 14.3985 13.2255 14.4686C13.1391 14.5351 13.044 14.5911 12.942 14.6347C12.8523 14.6731 12.724 14.7047 12.4765 14.722C12.2229 14.7398 11.8964 14.7402 11.4161 14.7402L5.60897 14.7402L10.8967 9.93319C11.0214 9.81982 11.0883 9.75956 11.1396 9.71957L11.1449 9.7155L11.1504 9.71923C11.2041 9.75591 11.2747 9.81182 11.4063 9.91711L13.2378 11.3823C13.5096 11.5997 13.5609 11.646 13.5968 11.6916C13.6556 11.7666 13.6974 11.8535 13.7191 11.9463C13.7324 12.0028 13.7365 12.0717 13.7365 12.4198C13.7365 12.9002 13.7361 13.2267 13.7183 13.4803C13.7009 13.7277 13.6693 13.8561 13.6309 13.9458Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.20697 5.24651C5.12217 5.24651 4.24276 6.12592 4.24276 7.21073C4.24276 8.29553 5.12217 9.17494 6.20697 9.17494C7.29178 9.17494 8.17119 8.29553 8.17119 7.21073C8.17119 6.12592 7.29178 5.24651 6.20697 5.24651ZM5.55223 7.21073C5.55223 6.84913 5.84537 6.55599 6.20697 6.55599C6.56858 6.55599 6.86171 6.84913 6.86171 7.21073C6.86171 7.57233 6.56858 7.86547 6.20697 7.86547C5.84537 7.86547 5.55223 7.57233 5.55223 7.21073Z" fill="white"/>
</svg>
`, __vite_glob_0_22 = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.454 11.109C20.4046 11.0838 20.3039 11.0461 20.0322 11.0239C19.7488 11.0008 19.3765 11 18.8 11H11V18.8C11 19.3765 11.0008 19.7488 11.0239 20.0322C11.0461 20.3039 11.0838 20.4046 11.109 20.454C11.2048 20.6421 11.3578 20.7951 11.5459 20.891C11.5953 20.9161 11.6961 20.9539 11.9678 20.9761C12.2512 20.9992 12.6234 21 13.2 21H21V13.2C21 12.6234 20.9992 12.2512 20.9761 11.9678C20.9539 11.6961 20.9162 11.5954 20.891 11.546C20.7952 11.3579 20.6421 11.2048 20.454 11.109ZM18 22H13.2C12.0799 22 11.5198 22 11.092 21.782C10.7157 21.5903 10.4097 21.2843 10.218 20.908C10 20.4802 10 19.9201 10 18.8V14L9 13V11H7L6 10H10V6L11 7V9H13L14 10H18.8C19.9201 10 20.4802 10 20.908 10.218C21.2843 10.4097 21.5903 10.7157 21.782 11.092C22 11.5198 22 12.0799 22 13.2V18L23 19V21H25L26 22H22V26L21 25V23H19L18 22Z" fill="black"/>
</svg>
`, __vite_glob_0_23 = `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_133)">
<path d="M6.42534 7.20452L0.817383 1.59656L1.57306 0.840881L7.18102 6.44883L6.42534 7.20452ZM1.57306 7.20452L0.817383 6.44883L6.42534 0.840881L7.18102 1.59656L1.57306 7.20452Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_108_133">
<rect width="8" height="8" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_24 = `<svg width="44" height="2" viewBox="0 0 44 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_81)">
<path d="M4.9106 0.0880737V1.18183H0.456055V0.0880737H4.9106ZM11.35 0.0880737V1.18183H6.89551V0.0880737H11.35ZM17.7895 0.0880737V1.18183H13.3349V0.0880737H17.7895ZM24.2289 0.0880737V1.18183H19.7744V0.0880737H24.2289ZM30.6684 0.0880737V1.18183H26.2138V0.0880737H30.6684ZM37.1078 0.0880737V1.18183H32.6533V0.0880737H37.1078ZM43.5473 0.0880737V1.18183H39.0928V0.0880737H43.5473Z" fill="#272727"/>
</g>
<defs>
<clipPath id="clip0_108_81">
<rect width="44" height="2" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_25 = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.44065 0.666749H8.5587C8.91014 0.666737 9.21331 0.666726 9.46303 0.687129C9.72659 0.708663 9.98874 0.756207 10.241 0.884736C10.6173 1.07648 10.9233 1.38244 11.115 1.75877C11.2436 2.01102 11.2911 2.27317 11.3126 2.53673C11.3309 2.76058 11.3328 3.02739 11.333 3.33342H13.9997C14.3679 3.33342 14.6663 3.63189 14.6663 4.00008C14.6663 4.36827 14.3679 4.66675 13.9997 4.66675H13.333V11.4943C13.333 12.0309 13.333 12.4738 13.3035 12.8346C13.2729 13.2094 13.2072 13.5538 13.0424 13.8774C12.7867 14.3792 12.3787 14.7871 11.877 15.0428C11.5534 15.2076 11.209 15.2733 10.8342 15.304C10.4734 15.3334 10.0305 15.3334 9.49389 15.3334H6.50546C5.96882 15.3334 5.52592 15.3334 5.16512 15.304C4.79039 15.2733 4.44592 15.2076 4.12237 15.0428C3.6206 14.7871 3.21265 14.3792 2.95699 13.8774C2.79213 13.5538 2.72642 13.2094 2.6958 12.8346C2.66633 12.4738 2.66633 12.0309 2.66634 11.4943L2.66634 4.66675H1.99967C1.63148 4.66675 1.33301 4.36827 1.33301 4.00008C1.33301 3.63189 1.63148 3.33342 1.99967 3.33342H4.66636C4.66655 3.02739 4.66843 2.76058 4.68672 2.53673C4.70825 2.27317 4.7558 2.01102 4.88433 1.75877C5.07608 1.38244 5.38204 1.07648 5.75836 0.884736C6.01061 0.756207 6.27276 0.708663 6.53632 0.687129C6.78604 0.666726 7.08921 0.666737 7.44065 0.666749ZM3.99967 4.66675V11.4667C3.99967 12.0378 4.00019 12.426 4.02471 12.7261C4.04859 13.0183 4.09187 13.1678 4.145 13.2721C4.27283 13.523 4.4768 13.7269 4.72769 13.8548C4.83195 13.9079 4.98142 13.9512 5.2737 13.975C5.57376 13.9996 5.96196 14.0001 6.53301 14.0001H9.46634C10.0374 14.0001 10.4256 13.9996 10.7256 13.975C11.0179 13.9512 11.1674 13.9079 11.2717 13.8548C11.5225 13.7269 11.7265 13.523 11.8544 13.2721C11.9075 13.1678 11.9508 13.0183 11.9746 12.7261C11.9992 12.426 11.9997 12.0378 11.9997 11.4667V4.66675H3.99967ZM9.99963 3.33342H5.99972C6.00002 3.02335 6.00206 2.8114 6.01563 2.64531C6.03042 2.4642 6.05554 2.39705 6.07234 2.36409C6.13625 2.23865 6.23824 2.13666 6.36368 2.07275C6.39664 2.05595 6.46379 2.03083 6.6449 2.01603C6.83379 2.0006 7.08197 2.00008 7.46634 2.00008H8.53301C8.91738 2.00008 9.16556 2.0006 9.35445 2.01603C9.53556 2.03083 9.60271 2.05595 9.63567 2.07275C9.76111 2.13666 9.8631 2.23865 9.92701 2.36409C9.94381 2.39705 9.96893 2.4642 9.98372 2.64531C9.99729 2.8114 9.99933 3.02335 9.99963 3.33342ZM6.66634 7.00008C7.03453 7.00008 7.33301 7.29856 7.33301 7.66675V11.0001C7.33301 11.3683 7.03453 11.6667 6.66634 11.6667C6.29815 11.6667 5.99967 11.3683 5.99967 11.0001V7.66675C5.99967 7.29856 6.29815 7.00008 6.66634 7.00008ZM9.33301 7.00008C9.7012 7.00008 9.99967 7.29856 9.99967 7.66675V11.0001C9.99967 11.3683 9.7012 11.6667 9.33301 11.6667C8.96482 11.6667 8.66634 11.3683 8.66634 11.0001V7.66675C8.66634 7.29856 8.96482 7.00008 9.33301 7.00008Z" fill="#FF3636"/>
</svg>
`, __vite_glob_0_26 = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.49991 12.0005V16.0005H0V18.0006H6.50003V12.0005H4.49991Z" fill="black"/>
<path d="M4.49991 2.00012V6H6.50003V0H0V2.00012H4.49991Z" fill="black"/>
<path d="M0 12.0004H6.49964V6H0V12.0004Z" fill="#0075FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.79282 5.29335C9.40239 5.68377 9.40239 6.31685 9.79282 6.70727L12.0859 9.00031L9.79282 11.2933C9.40239 11.6838 9.40239 12.3168 9.79282 12.7073C10.1832 13.0981 10.8167 13.0981 11.2071 12.7073L13.4998 10.4146L15.7928 12.7073C16.1832 13.0981 16.8167 13.0981 17.2071 12.7073C17.5975 12.3168 17.5975 11.6838 17.2071 11.2933L14.9141 9.00031L17.2071 6.70727C17.5975 6.31685 17.5975 5.68377 17.2071 5.29335C16.8167 4.90254 16.1832 4.90254 15.7928 5.29335L13.4998 7.58601L11.2071 5.29335C10.8167 4.90254 10.1832 4.90254 9.79282 5.29335Z" fill="#FF0000"/>
</svg>
`, __vite_glob_0_27 = `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.418 7.00014H18.4178V0.500488H16.4177V5.0004H12.418V7.00014Z" fill="black"/>
<path d="M6.41797 7.00014H0.417969V0.500488H2.41809V5.0004H6.41797V7.00014Z" fill="black"/>
<path d="M6.41797 0.500488V7.00014H12.4183V0.500488H6.41797Z" fill="#0075FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.71107 10.2933C6.1015 9.90288 6.73457 9.90288 7.125 10.2933L9.41803 12.5863L11.7111 10.2933C12.1015 9.90288 12.7346 9.90288 13.125 10.2933C13.5158 10.6837 13.5158 11.3172 13.125 11.7076L10.8323 14.0003L13.125 16.2933C13.5158 16.6837 13.5158 17.3172 13.125 17.7076C12.7346 18.098 12.1015 18.098 11.7111 17.7076L9.41803 15.4146L7.125 17.7076C6.73457 18.098 6.1015 18.098 5.71107 17.7076C5.32027 17.3172 5.32027 16.6837 5.71107 16.2933L8.00374 14.0003L5.71107 11.7076C5.32027 11.3172 5.32027 10.6837 5.71107 10.2933Z" fill="#FF0000"/>
</svg>
`, __vite_glob_0_28 = `<svg width="44" height="6" viewBox="0 0 44 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_86)">
<path d="M2.3125 5.13067C1.91146 5.13067 1.54522 5.0329 1.21378 4.83735C0.882339 4.63848 0.617188 4.37333 0.418324 4.04189C0.222775 3.71045 0.125 3.34421 0.125 2.94317C0.125 2.53882 0.222775 2.17258 0.418324 1.84445C0.617188 1.51301 0.882339 1.24952 1.21378 1.05397C1.54522 0.855107 1.91146 0.755676 2.3125 0.755676C2.71686 0.755676 3.0831 0.855107 3.41122 1.05397C3.74266 1.24952 4.00616 1.51301 4.2017 1.84445C4.40057 2.17258 4.5 2.53882 4.5 2.94317C4.5 3.34421 4.40057 3.71045 4.2017 4.04189C4.00616 4.37333 3.74266 4.63848 3.41122 4.83735C3.0831 5.0329 2.71686 5.13067 2.3125 5.13067ZM10.1875 5.13067C9.78646 5.13067 9.42022 5.0329 9.08878 4.83735C8.75734 4.63848 8.49219 4.37333 8.29332 4.04189C8.09777 3.71045 8 3.34421 8 2.94317C8 2.53882 8.09777 2.17258 8.29332 1.84445C8.49219 1.51301 8.75734 1.24952 9.08878 1.05397C9.42022 0.855107 9.78646 0.755676 10.1875 0.755676C10.5919 0.755676 10.9581 0.855107 11.2862 1.05397C11.6177 1.24952 11.8812 1.51301 12.0767 1.84445C12.2756 2.17258 12.375 2.53882 12.375 2.94317C12.375 3.34421 12.2756 3.71045 12.0767 4.04189C11.8812 4.37333 11.6177 4.63848 11.2862 4.83735C10.9581 5.0329 10.5919 5.13067 10.1875 5.13067ZM18.0625 5.13067C17.6615 5.13067 17.2952 5.0329 16.9638 4.83735C16.6323 4.63848 16.3672 4.37333 16.1683 4.04189C15.9728 3.71045 15.875 3.34421 15.875 2.94317C15.875 2.53882 15.9728 2.17258 16.1683 1.84445C16.3672 1.51301 16.6323 1.24952 16.9638 1.05397C17.2952 0.855107 17.6615 0.755676 18.0625 0.755676C18.4669 0.755676 18.8331 0.855107 19.1612 1.05397C19.4927 1.24952 19.7562 1.51301 19.9517 1.84445C20.1506 2.17258 20.25 2.53882 20.25 2.94317C20.25 3.34421 20.1506 3.71045 19.9517 4.04189C19.7562 4.37333 19.4927 4.63848 19.1612 4.83735C18.8331 5.0329 18.4669 5.13067 18.0625 5.13067ZM25.9375 5.13067C25.5365 5.13067 25.1702 5.0329 24.8388 4.83735C24.5073 4.63848 24.2422 4.37333 24.0433 4.04189C23.8478 3.71045 23.75 3.34421 23.75 2.94317C23.75 2.53882 23.8478 2.17258 24.0433 1.84445C24.2422 1.51301 24.5073 1.24952 24.8388 1.05397C25.1702 0.855107 25.5365 0.755676 25.9375 0.755676C26.3419 0.755676 26.7081 0.855107 27.0362 1.05397C27.3677 1.24952 27.6312 1.51301 27.8267 1.84445C28.0256 2.17258 28.125 2.53882 28.125 2.94317C28.125 3.34421 28.0256 3.71045 27.8267 4.04189C27.6312 4.37333 27.3677 4.63848 27.0362 4.83735C26.7081 5.0329 26.3419 5.13067 25.9375 5.13067ZM33.8125 5.13067C33.4115 5.13067 33.0452 5.0329 32.7138 4.83735C32.3823 4.63848 32.1172 4.37333 31.9183 4.04189C31.7228 3.71045 31.625 3.34421 31.625 2.94317C31.625 2.53882 31.7228 2.17258 31.9183 1.84445C32.1172 1.51301 32.3823 1.24952 32.7138 1.05397C33.0452 0.855107 33.4115 0.755676 33.8125 0.755676C34.2169 0.755676 34.5831 0.855107 34.9112 1.05397C35.2427 1.24952 35.5062 1.51301 35.7017 1.84445C35.9006 2.17258 36 2.53882 36 2.94317C36 3.34421 35.9006 3.71045 35.7017 4.04189C35.5062 4.37333 35.2427 4.63848 34.9112 4.83735C34.5831 5.0329 34.2169 5.13067 33.8125 5.13067ZM41.6875 5.13067C41.2865 5.13067 40.9202 5.0329 40.5888 4.83735C40.2573 4.63848 39.9922 4.37333 39.7933 4.04189C39.5978 3.71045 39.5 3.34421 39.5 2.94317C39.5 2.53882 39.5978 2.17258 39.7933 1.84445C39.9922 1.51301 40.2573 1.24952 40.5888 1.05397C40.9202 0.855107 41.2865 0.755676 41.6875 0.755676C42.0919 0.755676 42.4581 0.855107 42.7862 1.05397C43.1177 1.24952 43.3812 1.51301 43.5767 1.84445C43.7756 2.17258 43.875 2.53882 43.875 2.94317C43.875 3.34421 43.7756 3.71045 43.5767 4.04189C43.3812 4.37333 43.1177 4.63848 42.7862 4.83735C42.4581 5.0329 42.0919 5.13067 41.6875 5.13067Z" fill="#272727"/>
</g>
<defs>
<clipPath id="clip0_108_86">
<rect width="44" height="6" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_29 = `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3573_4727)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.6342 1.38658C13.4807 0.540083 14.8532 0.540085 15.6997 1.38659C16.5462 2.23309 16.5462 3.60554 15.6997 4.45204L8.92607 11.2256C8.91242 11.2393 8.89891 11.2528 8.88552 11.2662C8.68061 11.4715 8.50466 11.6477 8.29282 11.7776C8.10657 11.8917 7.90351 11.9758 7.69111 12.0268C7.44951 12.0848 7.20048 12.0846 6.91044 12.0843C6.89149 12.0843 6.87237 12.0843 6.85307 12.0843H5.66693C5.29967 12.0843 5.00193 11.7866 5.00193 11.4193V10.2332C5.00193 10.2139 5.00192 10.1948 5.0019 10.1758C5.00166 9.88578 5.00145 9.63675 5.05945 9.39516C5.11045 9.18275 5.19455 8.9797 5.30869 8.79345C5.43851 8.5816 5.61475 8.40566 5.82001 8.20074C5.83342 8.18736 5.84695 8.17385 5.8606 8.16019L12.6342 1.38658ZM14.7592 2.32704C14.4321 1.99993 13.9018 1.99993 13.5747 2.32704L6.80105 9.10065C6.53365 9.36804 6.47962 9.42812 6.4427 9.48837C6.40149 9.55562 6.37112 9.62894 6.3527 9.70564C6.33621 9.77435 6.33193 9.85504 6.33193 10.2332V10.7543H6.85307C7.23123 10.7543 7.31192 10.75 7.38062 10.7335C7.45732 10.7151 7.53064 10.6848 7.5979 10.6435C7.65814 10.6066 7.71822 10.5526 7.98562 10.2852L14.7592 3.51159C15.0863 3.18448 15.0863 2.65414 14.7592 2.32704ZM4.78925 2.25431L7.79195 2.25431C8.15922 2.25431 8.45695 2.55204 8.45695 2.91931C8.45695 3.28658 8.15922 3.58431 7.79195 3.58431H4.81695C4.21092 3.58431 3.7964 3.58483 3.47541 3.61105C3.16219 3.63665 2.99704 3.68336 2.87913 3.74344C2.60441 3.88342 2.38106 4.10677 2.24108 4.38149C2.18101 4.4994 2.13429 4.66454 2.1087 4.97777C2.08247 5.29876 2.08195 5.71328 2.08195 6.31931V12.2693C2.08195 12.8753 2.08247 13.2899 2.1087 13.6109C2.13429 13.9241 2.18101 14.0892 2.24108 14.2071C2.38106 14.4819 2.60441 14.7052 2.87913 14.8452C2.99704 14.9053 3.16219 14.952 3.47541 14.9776C3.7964 15.0038 4.21092 15.0043 4.81695 15.0043H10.767C11.373 15.0043 11.7875 15.0038 12.1085 14.9776C12.4217 14.952 12.5869 14.9053 12.7048 14.8452C12.9795 14.7052 13.2028 14.4819 13.3428 14.2071C13.4029 14.0892 13.4496 13.9241 13.4752 13.6109C13.5014 13.2899 13.502 12.8753 13.502 12.2693V9.29431C13.502 8.92704 13.7997 8.62931 14.167 8.62931C14.5342 8.62931 14.832 8.92704 14.832 9.29431V12.297C14.832 12.8685 14.832 13.3376 14.8008 13.7192C14.7685 14.1146 14.6994 14.4743 14.5279 14.8109C14.2604 15.3359 13.8336 15.7627 13.3086 16.0302C12.9719 16.2018 12.6123 16.2708 12.2168 16.3032C11.8352 16.3343 11.3662 16.3343 10.7946 16.3343H4.78926C4.21774 16.3343 3.74867 16.3343 3.36711 16.3032C2.97163 16.2708 2.61197 16.2018 2.27532 16.0302C1.75035 15.7627 1.32353 15.3359 1.05605 14.8109C0.884513 14.4743 0.815425 14.1146 0.783114 13.7192C0.751939 13.3376 0.751945 12.8685 0.751953 12.297V6.29161C0.751945 5.72009 0.751939 5.25103 0.783114 4.86946C0.815425 4.47399 0.884512 4.11433 1.05605 3.77768C1.32353 3.25271 1.75035 2.82589 2.27532 2.5584C2.61197 2.38687 2.97163 2.31778 3.36711 2.28547C3.74867 2.2543 4.21773 2.2543 4.78925 2.25431Z" fill="#7F8184"/>
</g>
<defs>
<clipPath id="clip0_3573_4727">
<rect width="17" height="17" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_30 = `<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_108)">
<path d="M9.25638 1.53352C9.18062 1.52801 9.07886 1.52758 8.89307 1.52758H4.92932C4.09913 1.52758 3.5454 1.52897 3.13335 1.58198C2.73711 1.63295 2.58543 1.72002 2.49531 1.80625C2.41325 1.88477 2.33324 2.00707 2.28374 2.3593C2.23027 2.73989 2.22844 3.25632 2.22844 4.05538L2.22815 13.9449C2.22815 14.7439 2.22998 15.2604 2.28346 15.641C2.33295 15.9932 2.41297 16.1155 2.49502 16.194C2.58514 16.2803 2.73682 16.3673 3.13306 16.4183C3.54511 16.4713 4.09884 16.4727 4.92903 16.4727H10.4652C11.2954 16.4727 11.8491 16.4713 12.2612 16.4183C12.6574 16.3673 12.8091 16.2803 12.8992 16.194C12.9813 16.1155 13.0613 15.9932 13.1108 15.641C13.1404 15.4305 13.1541 15.1784 13.1605 14.86H14.6391C14.6319 15.2326 14.6147 15.5677 14.5736 15.8604C14.4971 16.4045 14.3253 16.9111 13.9036 17.3146C13.4899 17.7104 12.9843 17.8644 12.4438 17.9339C11.9296 18 11.2829 18 10.5123 18H4.88192C4.11129 18 3.46468 18 2.95044 17.9339C2.40993 17.8644 1.90432 17.7104 1.49068 17.3146C1.06896 16.9111 0.897091 16.4045 0.820643 15.8604C0.749923 15.3571 0.749959 14.7285 0.750002 13.999L0.750291 4.00126C0.750248 3.27178 0.750211 2.64317 0.820932 2.13986C0.897382 1.59579 1.06925 1.08917 1.49097 0.685667C1.90461 0.289881 2.41022 0.135936 2.95073 0.0664042C3.46498 0.000249989 4.11158 0.000272657 4.88222 0.000299675L8.89307 0.00030084L8.96356 0.000152785C9.24117 -0.000717052 9.55221 -0.00169162 9.84308 0.113591C10.1393 0.230973 10.3658 0.449139 10.562 0.638178L10.6114 0.685667L13.9038 3.83593C13.9207 3.85203 13.938 3.86844 13.9556 3.88519C14.1488 4.06847 14.3848 4.29236 14.5146 4.59239C14.6474 4.89896 14.6459 5.22966 14.6447 5.49088C14.6446 5.51442 14.6445 5.53758 14.6445 5.55993V6.47554H13.1663L13.1664 5.55993C13.1664 5.3797 13.1658 5.28975 13.1607 5.22512L13.1599 5.21599C13.1565 5.21197 13.1524 5.20729 13.1476 5.20192C13.1008 5.14979 13.0318 5.08314 12.8995 4.95652L9.60711 1.80625C9.47503 1.67988 9.40504 1.61358 9.34989 1.56827C9.33091 1.55268 9.31905 1.54415 9.31271 1.53991C9.30432 1.53833 9.28703 1.53575 9.25638 1.53352Z" fill="#1E7049"/>
<path d="M16.4145 9.36833C16.4282 9.4303 16.4782 9.47953 16.5397 9.47953H17.6725C17.738 9.47953 17.7914 9.42422 17.7871 9.35665C17.7235 8.3635 16.9439 7.71454 15.7251 7.71454C14.4797 7.71454 13.6 8.40679 13.6077 9.43726C13.6051 10.2828 14.1728 10.7531 15.1011 10.9592L15.6228 11.0754C16.2058 11.2075 16.4053 11.3581 16.4104 11.6039C16.4053 11.8707 16.17 12.0583 15.7148 12.0583C15.2142 12.0583 14.9015 11.8351 14.8363 11.4133C14.8264 11.3489 14.7753 11.2974 14.7122 11.2974H13.5934C13.5279 11.2974 13.4746 11.3524 13.4777 11.42C13.5348 12.6921 14.4116 13.2632 15.7353 13.2632C17.0625 13.2632 17.8578 12.6713 17.8629 11.6039C17.8578 10.7795 17.3821 10.2009 16.2263 9.94456L15.7967 9.84944C15.3006 9.74111 15.0781 9.59051 15.0909 9.33157C15.0934 9.09377 15.2852 8.91938 15.7251 8.91938C16.1345 8.91938 16.3517 9.08453 16.4145 9.36833Z" fill="#1E7049"/>
<path d="M5.45664 7.78851C5.49932 7.78851 5.53869 7.81227 5.55965 7.85069L6.37487 9.3448C6.3811 9.35621 6.39279 9.36327 6.40546 9.36327C6.41808 9.36327 6.42972 9.35628 6.43597 9.34496L7.26129 7.85015C7.28233 7.81204 7.32153 7.78851 7.364 7.78851H8.67236C8.76418 7.78851 8.82097 7.89193 8.77386 7.97337L7.35274 10.4302C7.33004 10.4695 7.33044 10.5185 7.35379 10.5574L8.82997 13.0131C8.8789 13.0945 8.82225 13.1998 8.72952 13.1998H7.38434C7.34194 13.1998 7.30278 13.1763 7.28171 13.1383L6.43602 11.6116C6.42974 11.6003 6.41806 11.5933 6.4054 11.5933C6.39275 11.5933 6.38107 11.6003 6.37478 11.6116L5.5291 13.1383C5.50803 13.1763 5.46887 13.1998 5.42647 13.1998H4.09011C3.99768 13.1998 3.94099 13.0951 3.98931 13.0137L5.4475 10.557C5.47044 10.5183 5.47078 10.4697 5.44837 10.4307L4.03607 7.97307C3.98927 7.89162 4.04608 7.78851 4.13775 7.78851H5.45664Z" fill="#1E7049"/>
<path d="M9.6119 13.1998C9.54659 13.1998 9.49365 13.1451 9.49365 13.0776V7.91069C9.49365 7.84321 9.54659 7.78851 9.6119 7.78851H10.7972C10.8625 7.78851 10.9155 7.84321 10.9155 7.91069V11.8939C10.9155 11.9614 10.9684 12.0161 11.0337 12.0161H12.9146C12.9799 12.0161 13.0329 12.0708 13.0329 12.1382V13.0776C13.0329 13.1451 12.9799 13.1998 12.9146 13.1998H9.6119Z" fill="#1E7049"/>
<path d="M19.8586 7.78851C19.9013 7.78851 19.9406 7.81227 19.9616 7.85069L20.7768 9.3448C20.783 9.35621 20.7947 9.36327 20.8074 9.36327C20.82 9.36327 20.8317 9.35628 20.8379 9.34496L21.6632 7.85015C21.6843 7.81204 21.7235 7.78851 21.7659 7.78851H23.0743C23.1661 7.78851 23.2229 7.89193 23.1758 7.97337L21.7547 10.4302C21.732 10.4695 21.7324 10.5185 21.7557 10.5574L23.2319 13.0131C23.2808 13.0945 23.2242 13.1998 23.1315 13.1998H21.7863C21.7439 13.1998 21.7047 13.1763 21.6837 13.1383L20.838 11.6116C20.8317 11.6003 20.82 11.5933 20.8073 11.5933C20.7947 11.5933 20.783 11.6003 20.7767 11.6116L19.931 13.1383C19.91 13.1763 19.8708 13.1998 19.8284 13.1998H18.4921C18.3996 13.1998 18.3429 13.0951 18.3912 13.0137L19.8494 10.557C19.8724 10.5183 19.8727 10.4697 19.8503 10.4307L18.438 7.97307C18.3912 7.89162 18.448 7.78851 18.5397 7.78851H19.8586Z" fill="#1E7049"/>
</g>
<defs>
<clipPath id="clip0_108_108">
<rect width="24" height="18" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_31 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.25638 4.53352C9.18062 4.52801 9.07886 4.52758 8.89307 4.52758H4.92932C4.09913 4.52758 3.5454 4.52897 3.13335 4.58198C2.73711 4.63295 2.58543 4.72002 2.49531 4.80625C2.41325 4.88477 2.33324 5.00707 2.28374 5.3593C2.23027 5.73989 2.22844 6.25632 2.22844 7.05538L2.22815 16.9449C2.22815 17.7439 2.22998 18.2604 2.28346 18.641C2.33295 18.9932 2.41297 19.1155 2.49502 19.194C2.58514 19.2803 2.73682 19.3673 3.13306 19.4183C3.54511 19.4713 4.09884 19.4727 4.92903 19.4727H10.4652C11.2954 19.4727 11.8491 19.4713 12.2612 19.4183C12.6574 19.3673 12.8091 19.2803 12.8992 19.194C12.9813 19.1155 13.0613 18.9932 13.1108 18.641C13.1404 18.4305 13.1541 18.1784 13.1605 17.86H14.6391C14.6319 18.2326 14.6147 18.5677 14.5736 18.8604C14.4971 19.4045 14.3253 19.9111 13.9036 20.3146C13.4899 20.7104 12.9843 20.8644 12.4438 20.9339C11.9296 21 11.2829 21 10.5123 21H4.88192C4.11129 21 3.46468 21 2.95044 20.9339C2.40993 20.8644 1.90432 20.7104 1.49068 20.3146C1.06896 19.9111 0.897091 19.4045 0.820643 18.8604C0.749923 18.3571 0.749959 17.7285 0.750002 16.999L0.750291 7.00126C0.750248 6.27178 0.750211 5.64317 0.820932 5.13986C0.897382 4.59579 1.06925 4.08917 1.49097 3.68567C1.90461 3.28988 2.41022 3.13594 2.95073 3.0664C3.46498 3.00025 4.11158 3.00027 4.88222 3.0003H8.89307L8.96356 3.00015C9.24117 2.99928 9.55221 2.99831 9.84308 3.11359C10.1393 3.23097 10.3658 3.44914 10.562 3.63818L10.6114 3.68567L13.9038 6.83593C13.9207 6.85203 13.938 6.86844 13.9556 6.88519C14.1488 7.06847 14.3848 7.29236 14.5146 7.59239C14.6474 7.89896 14.6459 8.22966 14.6447 8.49088C14.6446 8.51442 14.6445 8.53758 14.6445 8.55993V9.47554H13.1663L13.1664 8.55993C13.1664 8.3797 13.1658 8.28975 13.1607 8.22512L13.1599 8.21599C13.1565 8.21197 13.1524 8.20729 13.1476 8.20192C13.1008 8.14979 13.0318 8.08314 12.8995 7.95652L9.60711 4.80625C9.47503 4.67988 9.40504 4.61358 9.34989 4.56827C9.33091 4.55268 9.31905 4.54415 9.31271 4.53991C9.30432 4.53833 9.28703 4.53575 9.25638 4.53352Z" fill="#7F8184"/>
<path d="M16.4145 12.3683C16.4282 12.4303 16.4782 12.4795 16.5397 12.4795H17.6725C17.738 12.4795 17.7914 12.4242 17.7871 12.3567C17.7235 11.3635 16.9439 10.7145 15.7251 10.7145C14.4797 10.7145 13.6 11.4068 13.6077 12.4373C13.6051 13.2828 14.1728 13.7531 15.1011 13.9592L15.6228 14.0754C16.2058 14.2075 16.4053 14.3581 16.4104 14.6039C16.4053 14.8707 16.17 15.0583 15.7148 15.0583C15.2142 15.0583 14.9015 14.8351 14.8363 14.4133C14.8264 14.3489 14.7753 14.2974 14.7122 14.2974H13.5934C13.5279 14.2974 13.4746 14.3524 13.4777 14.42C13.5348 15.6921 14.4116 16.2632 15.7353 16.2632C17.0625 16.2632 17.8578 15.6713 17.8629 14.6039C17.8578 13.7795 17.3821 13.2009 16.2263 12.9446L15.7967 12.8494C15.3006 12.7411 15.0781 12.5905 15.0909 12.3316C15.0934 12.0938 15.2852 11.9194 15.7251 11.9194C16.1345 11.9194 16.3517 12.0845 16.4145 12.3683Z" fill="#7F8184"/>
<path d="M5.45664 10.7885C5.49932 10.7885 5.53869 10.8123 5.55965 10.8507L6.37487 12.3448C6.3811 12.3562 6.39279 12.3633 6.40546 12.3633C6.41808 12.3633 6.42972 12.3563 6.43597 12.345L7.26129 10.8502C7.28233 10.812 7.32153 10.7885 7.364 10.7885H8.67236C8.76418 10.7885 8.82097 10.8919 8.77386 10.9734L7.35274 13.4302C7.33004 13.4695 7.33044 13.5185 7.35379 13.5574L8.82997 16.0131C8.8789 16.0945 8.82225 16.1998 8.72952 16.1998H7.38434C7.34194 16.1998 7.30278 16.1763 7.28171 16.1383L6.43602 14.6116C6.42974 14.6003 6.41806 14.5933 6.4054 14.5933C6.39275 14.5933 6.38107 14.6003 6.37478 14.6116L5.5291 16.1383C5.50803 16.1763 5.46887 16.1998 5.42647 16.1998H4.09011C3.99768 16.1998 3.94099 16.0951 3.98931 16.0137L5.4475 13.557C5.47044 13.5183 5.47078 13.4697 5.44837 13.4307L4.03607 10.9731C3.98927 10.8916 4.04608 10.7885 4.13775 10.7885H5.45664Z" fill="#7F8184"/>
<path d="M9.6119 16.1998C9.54659 16.1998 9.49365 16.1451 9.49365 16.0776V10.9107C9.49365 10.8432 9.54659 10.7885 9.6119 10.7885H10.7972C10.8625 10.7885 10.9155 10.8432 10.9155 10.9107V14.8939C10.9155 14.9614 10.9684 15.0161 11.0337 15.0161H12.9146C12.9799 15.0161 13.0329 15.0708 13.0329 15.1382V16.0776C13.0329 16.1451 12.9799 16.1998 12.9146 16.1998H9.6119Z" fill="#7F8184"/>
<path d="M19.8586 10.7885C19.9013 10.7885 19.9406 10.8123 19.9616 10.8507L20.7768 12.3448C20.783 12.3562 20.7947 12.3633 20.8074 12.3633C20.82 12.3633 20.8317 12.3563 20.8379 12.345L21.6632 10.8502C21.6843 10.812 21.7235 10.7885 21.7659 10.7885H23.0743C23.1661 10.7885 23.2229 10.8919 23.1758 10.9734L21.7547 13.4302C21.732 13.4695 21.7324 13.5185 21.7557 13.5574L23.2319 16.0131C23.2808 16.0945 23.2242 16.1998 23.1315 16.1998H21.7863C21.7439 16.1998 21.7047 16.1763 21.6837 16.1383L20.838 14.6116C20.8317 14.6003 20.82 14.5933 20.8073 14.5933C20.7947 14.5933 20.783 14.6003 20.7767 14.6116L19.931 16.1383C19.91 16.1763 19.8708 16.1998 19.8284 16.1998H18.4921C18.3996 16.1998 18.3429 16.0951 18.3912 16.0137L19.8494 13.557C19.8724 13.5183 19.8727 13.4697 19.8503 13.4307L18.438 10.9731C18.3912 10.8916 18.448 10.7885 18.5397 10.7885H19.8586Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_32 = `<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_270)">
<path d="M9.16102 0H6.83898V4.93945H5.63925L3.09606 0H0.149274L3.54941 5.67188L0 12H2.83621L5.29095 7.2832H6.83898V12H9.16102V7.2832H10.7478L13.1417 12H16L12.5169 5.6543L15.8341 0H12.8984L10.4216 4.93945H9.16102V0Z" fill="#7F8184"/>
</g>
<defs>
<clipPath id="clip0_109_270">
<rect width="16" height="12" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_33 = `<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_274)">
<path d="M0 12H2.31663L2.84095 8.60156L4.2213 7.06641L6.45768 12H9.22909L6.13667 5.37305L11 0H8.22325L3.48298 5.29102H3.33852L4.1357 0H1.81907L0 12Z" fill="#D9D9D9"/>
</g>
<defs>
<clipPath id="clip0_109_274">
<rect width="11" height="12" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_34 = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_107_78)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.36207 0.5C9.74261 0.5 10.0468 0.504926 10.0579 0.511084C10.0702 0.517241 10.1663 0.525862 10.2709 0.529557C10.3756 0.534483 10.5 0.543103 10.548 0.549261C10.5948 0.55665 10.7057 0.567734 10.7943 0.573892C10.8818 0.581281 11.0209 0.594828 11.1022 0.60468C11.1835 0.614532 11.303 0.630542 11.367 0.640394C11.431 0.650246 11.5369 0.667488 11.601 0.67734C11.665 0.688424 11.7599 0.704433 11.8103 0.714286C11.8608 0.724138 11.947 0.740148 12.0012 0.752463C12.0554 0.763547 12.1268 0.778325 12.1613 0.784483C12.1946 0.79064 12.2389 0.800493 12.2599 0.80665C12.2796 0.814039 12.335 0.827586 12.383 0.83867C12.4298 0.850985 12.4963 0.866995 12.5308 0.875616C12.564 0.885468 12.6281 0.901478 12.6724 0.913793C12.7167 0.924877 12.8522 0.966749 12.9741 1.00739C13.0961 1.0468 13.2057 1.08498 13.2167 1.09236C13.2291 1.09852 13.2463 1.10345 13.2537 1.10345C13.2623 1.10468 13.2919 1.11453 13.319 1.12808C13.3461 1.14163 13.3768 1.15148 13.3867 1.15148C13.3966 1.15271 13.4113 1.15764 13.4175 1.16256C13.4236 1.16872 13.4766 1.19335 13.5345 1.21798C13.5924 1.24138 13.6921 1.28818 13.7562 1.32143C13.8202 1.35468 13.9397 1.42118 14.0209 1.47044C14.1022 1.51847 14.181 1.56897 14.1958 1.58374C14.2118 1.59729 14.2266 1.60837 14.2303 1.60837C14.234 1.60837 14.2549 1.62069 14.2759 1.6367C14.298 1.65148 14.319 1.66626 14.3227 1.66995C14.3264 1.67365 14.351 1.69335 14.3781 1.71305C14.4052 1.73399 14.4384 1.76108 14.4532 1.77463C14.468 1.78818 14.4938 1.81034 14.5086 1.82512C14.5246 1.83867 14.5579 1.87192 14.5813 1.89901C14.6059 1.92488 14.6466 1.97537 14.6736 2.00862C14.7007 2.0431 14.7254 2.07266 14.7291 2.07635C14.7328 2.08005 14.7475 2.10099 14.7623 2.12315C14.7783 2.14409 14.7906 2.16749 14.7906 2.17488C14.7906 2.18227 14.7968 2.18719 14.803 2.18719C14.8091 2.18719 14.8153 2.19581 14.8153 2.20566C14.8153 2.21552 14.8227 2.23153 14.83 2.24015C14.8387 2.24877 14.8547 2.27463 14.8658 2.29803C14.8756 2.32143 14.8929 2.36084 14.9039 2.38424C14.9138 2.40764 14.931 2.45813 14.9421 2.49507C14.9532 2.53202 14.9704 2.60837 14.9815 2.66502C14.9975 2.75493 15 3.28202 15 7.55296C15 12.1379 14.9988 12.3461 14.9766 12.4458C14.9643 12.5037 14.9483 12.5653 14.9409 12.585C14.9323 12.6034 14.9261 12.6244 14.9261 12.6305C14.9261 12.6367 14.9212 12.6527 14.915 12.665C14.9089 12.6761 14.8904 12.7143 14.8756 12.7475C14.8596 12.782 14.8288 12.8399 14.8067 12.8768C14.7857 12.9138 14.7562 12.9569 14.7414 12.9729C14.7278 12.9877 14.7167 13.0025 14.7167 13.0062C14.7167 13.0099 14.6933 13.0406 14.6638 13.0751C14.6355 13.1096 14.5924 13.1576 14.569 13.1823C14.5443 13.2069 14.4975 13.25 14.4643 13.2771C14.4298 13.303 14.4002 13.3288 14.3966 13.3325C14.3929 13.3374 14.3374 13.3793 14.2734 13.4273C14.2094 13.4754 14.1318 13.5283 14.101 13.5468C14.0702 13.5653 14.0369 13.585 14.0271 13.5911C14.0172 13.5973 13.9729 13.6244 13.9286 13.649C13.8842 13.6749 13.7783 13.7315 13.6909 13.7734C13.6047 13.8153 13.5308 13.8498 13.5246 13.8498C13.5197 13.8498 13.4865 13.8645 13.4507 13.8805C13.4163 13.8978 13.3695 13.915 13.3498 13.9212C13.3288 13.9261 13.3128 13.9335 13.3128 13.9397C13.3128 13.9446 13.2919 13.9532 13.266 13.9594C13.2414 13.9655 13.1207 14.0049 12.9988 14.0468C12.8768 14.0887 12.7463 14.1318 12.7094 14.1416C12.6724 14.1515 12.617 14.1638 12.5862 14.1712C12.5554 14.1773 12.5135 14.1884 12.4938 14.1946C12.4729 14.2007 12.4224 14.2143 12.3793 14.2241C12.3374 14.2352 12.2709 14.2512 12.2315 14.2611C12.1933 14.2709 12.1145 14.2882 12.0567 14.2993C11.9988 14.3103 11.9298 14.3251 11.9027 14.3313C11.8756 14.3374 11.8227 14.3473 11.7857 14.3547C11.7488 14.3621 11.665 14.3768 11.601 14.3867C11.5369 14.3966 11.431 14.4126 11.367 14.4224C11.303 14.4323 11.1773 14.4495 11.0899 14.4594C11.0012 14.4692 10.8387 14.4865 10.7266 14.4963C10.6145 14.5074 10.3953 14.5234 10.2401 14.5345C10.0837 14.5443 9.76847 14.5554 9.53818 14.5591C9.2266 14.5653 9.02709 14.5616 8.75616 14.5468C8.55665 14.5357 8.34729 14.5197 8.29064 14.5111C8.22291 14.5012 8.18596 14.5 8.1798 14.5086C8.17488 14.5148 8.16256 14.5271 8.15148 14.5333C8.13916 14.5394 8.07512 14.5825 8.00616 14.6293C7.93719 14.6749 7.87562 14.7118 7.86946 14.7118C7.86207 14.7118 7.85591 14.7167 7.85345 14.7217C7.85222 14.7278 7.80419 14.7599 7.7463 14.7931C7.68842 14.8276 7.61946 14.8658 7.59236 14.8793C7.56527 14.8916 7.54064 14.9052 7.53695 14.9089C7.53325 14.9126 7.47537 14.9421 7.40764 14.9754C7.3399 15.0074 7.26601 15.0419 7.24384 15.0517C7.22291 15.0616 7.18596 15.0764 7.16379 15.0862C7.14286 15.0961 7.09975 15.1133 7.06897 15.1244C7.03818 15.1367 6.99877 15.1527 6.97906 15.1626C6.96059 15.1724 6.93596 15.1798 6.92365 15.1798C6.91133 15.1798 6.89655 15.1847 6.89039 15.1909C6.883 15.197 6.82759 15.218 6.76724 15.2389C6.70566 15.2586 6.62808 15.2845 6.59483 15.2943C6.56034 15.3042 6.51355 15.3165 6.49015 15.3214C6.46675 15.3251 6.43596 15.3337 6.42241 15.3399C6.40887 15.3448 6.36453 15.3571 6.32389 15.3645C6.28325 15.3732 6.21059 15.3867 6.16379 15.3966C6.11576 15.4064 6.02709 15.4224 5.96675 15.4323C5.90517 15.4421 5.79433 15.4569 5.72044 15.4643C5.64532 15.4717 5.58005 15.4828 5.57389 15.4889C5.5665 15.4951 5.38793 15.5 5.15148 15.5C4.92611 15.5 4.74015 15.4951 4.73768 15.4889C4.73645 15.4828 4.67118 15.4717 4.5936 15.4643C4.51601 15.4569 4.39901 15.4421 4.33498 15.4323C4.27094 15.4224 4.17611 15.4064 4.12562 15.3953C4.07512 15.3855 4.00246 15.3695 3.96552 15.3608C3.92857 15.351 3.88916 15.3411 3.87931 15.3374C3.86946 15.3325 3.83621 15.3239 3.80542 15.3153C3.77463 15.3079 3.72537 15.2956 3.69458 15.2882C3.66379 15.282 3.633 15.2709 3.62685 15.2648C3.61946 15.2586 3.60345 15.2537 3.5899 15.2537C3.57635 15.2537 3.54803 15.2451 3.52833 15.2352C3.50739 15.2241 3.48276 15.2155 3.47291 15.2167C3.46305 15.2167 3.43719 15.2081 3.41749 15.1983C3.39655 15.1872 3.37685 15.1798 3.37069 15.1798C3.36576 15.1798 3.3436 15.1724 3.32143 15.1626C3.30049 15.1539 3.23153 15.1244 3.17118 15.0998C3.10961 15.0739 3.03079 15.0406 2.99507 15.0246C2.96059 15.0086 2.92488 14.9951 2.91872 14.9951C2.91133 14.9951 2.9064 14.9889 2.9064 14.9828C2.9064 14.9766 2.89163 14.9667 2.87192 14.9631C2.85345 14.9594 2.83621 14.952 2.83251 14.9483C2.82882 14.9433 2.78202 14.9175 2.72783 14.8904C2.67365 14.8633 2.62808 14.8374 2.62562 14.8325C2.62438 14.8264 2.617 14.8227 2.61084 14.8227C2.60345 14.8227 2.56404 14.8017 2.52094 14.7771C2.47906 14.7525 2.44212 14.7291 2.43842 14.7241C2.43473 14.7192 2.42365 14.7118 2.41379 14.7081C2.40394 14.7032 2.37808 14.6884 2.35837 14.6749C2.33744 14.6613 2.30911 14.6441 2.2931 14.6355C2.27832 14.6268 2.26601 14.6158 2.26601 14.6108C2.26601 14.6047 2.25739 14.601 2.24754 14.601C2.23768 14.601 2.22783 14.5973 2.22537 14.5924C2.22414 14.5862 2.20074 14.5677 2.17365 14.5493C2.14655 14.5308 2.11207 14.5049 2.09606 14.4901C2.08128 14.4766 2.06527 14.4655 2.05911 14.4655C2.05419 14.4655 2.03325 14.4495 2.01355 14.431C1.99261 14.4126 1.95197 14.3781 1.92118 14.3547C1.89039 14.3313 1.85961 14.3066 1.85222 14.2993C1.84483 14.2931 1.80911 14.2623 1.77217 14.2315C1.73645 14.2007 1.62069 14.0899 1.51478 13.984C1.4101 13.8793 1.29926 13.7635 1.26847 13.7278C1.23768 13.6909 1.2032 13.6502 1.19089 13.6355C1.17857 13.6219 1.1564 13.5936 1.14163 13.5751C1.12685 13.5554 1.10837 13.5332 1.10099 13.5259C1.0936 13.5172 1.05049 13.4618 1.00616 13.4002C0.960591 13.3387 0.919951 13.2833 0.913793 13.2771C0.907635 13.2709 0.887931 13.2401 0.868227 13.2094C0.848522 13.1786 0.825123 13.1429 0.816502 13.1293C0.807882 13.1158 0.79803 13.0961 0.793103 13.0862C0.788177 13.0764 0.780788 13.0653 0.775862 13.0616C0.772167 13.0579 0.748768 13.0209 0.722906 12.9791C0.698276 12.936 0.67734 12.8953 0.67734 12.8892C0.67734 12.883 0.673645 12.8756 0.667488 12.8744C0.662562 12.8719 0.636699 12.8264 0.609606 12.7722C0.582512 12.718 0.55665 12.6712 0.551724 12.6675C0.54803 12.6638 0.54064 12.6466 0.536946 12.6281C0.533251 12.6084 0.523399 12.5936 0.517241 12.5936C0.509852 12.5936 0.504926 12.5874 0.504926 12.5813C0.504926 12.5751 0.490148 12.5369 0.472906 12.4988C0.455665 12.4594 0.431034 12.4052 0.418719 12.3781C0.406404 12.351 0.386699 12.3042 0.375616 12.2734C0.364532 12.2426 0.349754 12.2081 0.343596 12.197C0.337438 12.1847 0.312808 12.1158 0.288177 12.0431C0.264778 11.9692 0.240148 11.899 0.23399 11.8855C0.229064 11.8719 0.21798 11.8362 0.20936 11.8054C0.20197 11.7746 0.189655 11.7278 0.183498 11.7007C0.176108 11.6736 0.166256 11.6404 0.160099 11.6268C0.155172 11.6133 0.144089 11.569 0.135468 11.5283C0.128079 11.4877 0.1133 11.4163 0.103448 11.3682C0.093596 11.3202 0.0775862 11.2328 0.067734 11.1712C0.0578818 11.1096 0.0431034 10.9963 0.0357143 10.9187C0.0283251 10.8411 0.0172414 10.7709 0.0110837 10.7648C0.00492611 10.7574 0 10.5616 0 10.3153C0 10.0554 0.00492611 9.87315 0.0110837 9.86576C0.0172414 9.85961 0.0295567 9.79803 0.0357143 9.7303C0.0431034 9.66256 0.0566502 9.56034 0.0665025 9.50246C0.0763547 9.44458 0.0923645 9.35345 0.103448 9.29926C0.114532 9.24507 0.130542 9.16995 0.139163 9.133C0.147783 9.09606 0.157635 9.05911 0.16133 9.05296C0.166256 9.0468 0.173645 9.02094 0.178571 8.99754C0.183498 8.97414 0.195813 8.92734 0.205665 8.89286C0.216749 8.85961 0.235222 8.80049 0.247537 8.76355C0.259852 8.7266 0.284483 8.65394 0.301724 8.60345C0.318966 8.55296 0.339901 8.49754 0.347291 8.4803C0.35468 8.46305 0.368227 8.43473 0.376847 8.41626C0.386699 8.39655 0.394089 8.37562 0.394089 8.36946C0.394089 8.3633 0.416256 8.30911 0.444581 8.25C0.471675 8.18965 0.512315 8.10591 0.534483 8.06158C0.557882 8.01724 0.594828 7.94581 0.616995 7.90148C0.640394 7.85714 0.662562 7.8202 0.667488 7.81896C0.673645 7.8165 0.67734 7.80788 0.67734 7.80049C0.678571 7.79187 0.698276 7.75123 0.722906 7.71059C0.747537 7.66995 0.772167 7.63424 0.775862 7.63054C0.780788 7.62685 0.788177 7.61576 0.791872 7.60591C0.796798 7.59606 0.810345 7.57266 0.82266 7.55419C0.833744 7.53695 0.873153 7.47783 0.910098 7.42488C0.945813 7.37192 0.981527 7.32759 0.986453 7.32635C0.992611 7.32389 0.997537 7.31527 0.997537 7.30788C0.996305 7.29926 1.00862 7.28079 1.02217 7.26724C1.03571 7.25369 1.04803 7.23645 1.04803 7.2303C1.04803 7.22414 1.06034 7.2069 1.07512 7.19335C1.0899 7.1798 1.12808 7.13547 1.15887 7.09483C1.18966 7.05419 1.24015 6.99384 1.2697 6.95936C1.29926 6.92611 1.40148 6.82143 1.49631 6.72537C1.59113 6.63054 1.69951 6.52586 1.73645 6.49138C1.77463 6.45813 1.83251 6.40764 1.86576 6.38054C1.90025 6.35345 1.92857 6.32759 1.9298 6.32266C1.93227 6.3165 1.94212 6.31281 1.95197 6.31281C1.96182 6.31281 1.97044 6.30911 1.97044 6.30419C1.97044 6.29803 2.01355 6.26355 2.06527 6.22414C2.11823 6.18596 2.19704 6.13054 2.24138 6.10222C2.28571 6.07266 2.32389 6.04557 2.32759 6.04187C2.33128 6.03818 2.34483 6.02956 2.35837 6.02094C2.37192 6.01231 2.44335 5.96921 2.51847 5.92488C2.59236 5.87931 2.66256 5.83744 2.67241 5.83251C2.68227 5.82635 2.78202 5.77586 2.89409 5.72044C3.00616 5.66626 3.10837 5.61576 3.12192 5.60961C3.13547 5.60345 3.17734 5.58744 3.21429 5.57389C3.25123 5.56034 3.2931 5.54433 3.30665 5.53818C3.3202 5.53202 3.35345 5.5197 3.38054 5.50985C3.40764 5.49877 3.44951 5.48399 3.47291 5.47537C3.49631 5.46798 3.52956 5.45813 3.5468 5.45443C3.56404 5.45074 3.58251 5.44335 3.5899 5.43842C3.59606 5.4335 3.63177 5.42365 3.66626 5.41502C3.70197 5.40764 3.73522 5.39409 3.74015 5.3867C3.74631 5.37808 3.75246 4.74384 3.75616 3.97906C3.76232 2.64778 3.76355 2.58498 3.78571 2.52586C3.79926 2.49261 3.8165 2.44581 3.82635 2.42488C3.83498 2.40271 3.84236 2.37931 3.84236 2.37192C3.84236 2.36453 3.84729 2.34975 3.85345 2.33867C3.85961 2.32635 3.89409 2.26601 3.9298 2.20566C3.96552 2.14532 4.00123 2.08867 4.00862 2.08005C4.01478 2.07266 4.03448 2.04803 4.05049 2.02463C4.06773 2.00246 4.13424 1.93103 4.19828 1.86699C4.26355 1.80296 4.33498 1.73522 4.35591 1.71675C4.37808 1.69704 4.40148 1.68227 4.40887 1.68227C4.41502 1.68227 4.42118 1.67857 4.42118 1.67365C4.42118 1.66749 4.44335 1.65025 4.47044 1.633C4.49754 1.61576 4.5197 1.59852 4.5197 1.5936C4.5197 1.58744 4.52463 1.58374 4.53202 1.58374C4.53818 1.58374 4.56281 1.57143 4.58374 1.55665C4.60591 1.54064 4.62562 1.52463 4.62685 1.5197C4.62931 1.51355 4.63547 1.50985 4.64286 1.50985C4.64901 1.50985 4.71182 1.4766 4.78079 1.43596C4.85099 1.39532 4.91626 1.35591 4.92611 1.34975C4.93596 1.3436 4.96675 1.32759 4.99384 1.31527C5.02094 1.30172 5.07389 1.27709 5.11084 1.25985C5.14778 1.24384 5.2032 1.21798 5.23399 1.20443C5.26478 1.19212 5.3165 1.17118 5.35099 1.15887C5.38424 1.14655 5.41749 1.13177 5.42488 1.12562C5.43103 1.12069 5.44335 1.11576 5.45197 1.11576C5.46059 1.11576 5.48645 1.10837 5.50739 1.09852C5.52956 1.08867 5.58621 1.06773 5.63424 1.05296C5.68103 1.03818 5.72537 1.02094 5.73276 1.01478C5.73892 1.00985 5.75369 1.00493 5.76601 1.00493C5.77833 1.00493 5.80665 0.997537 5.82759 0.987685C5.84975 0.979064 5.89901 0.961823 5.93596 0.95197C5.97291 0.940887 6.03079 0.923645 6.06527 0.913793C6.09852 0.905172 6.1601 0.887931 6.20074 0.878079C6.24138 0.866995 6.33251 0.843596 6.40394 0.826355C6.47537 0.807882 6.56034 0.788177 6.59483 0.78202C6.62808 0.775862 6.69458 0.762315 6.74261 0.752463C6.78941 0.741379 6.87315 0.725369 6.92734 0.714286C6.98153 0.704433 7.07512 0.687192 7.1367 0.67734C7.19704 0.667488 7.28571 0.653941 7.33374 0.647783C7.38054 0.641626 7.44704 0.631773 7.48153 0.624384C7.51478 0.618227 7.60098 0.605911 7.67241 0.598522C7.74384 0.591133 7.87069 0.580049 7.95566 0.573892C8.04064 0.567734 8.14778 0.55665 8.19581 0.550493C8.24261 0.543103 8.36823 0.534483 8.47291 0.530788C8.57759 0.525862 8.66872 0.517241 8.67488 0.511084C8.68227 0.504926 8.96429 0.5 9.36207 0.5ZM8.44828 1.47291C8.32266 1.47906 8.14039 1.49384 8.04187 1.50246C7.94335 1.51232 7.79926 1.52956 7.72167 1.53941C7.64409 1.54926 7.52463 1.5665 7.4569 1.57759C7.38916 1.58744 7.30049 1.60099 7.25985 1.60837C7.21921 1.61453 7.16133 1.62562 7.13054 1.63177C7.09975 1.63916 7.03079 1.65394 6.9766 1.66502C6.92241 1.67488 6.83867 1.69212 6.79187 1.70197C6.74384 1.71182 6.67365 1.72783 6.63424 1.73768C6.59606 1.74754 6.52956 1.76478 6.48645 1.77586C6.44458 1.78571 6.38547 1.80172 6.35468 1.81158C6.32389 1.8202 6.26601 1.83744 6.22537 1.84852C6.18473 1.86084 6.12069 1.88054 6.08374 1.89286C6.0468 1.90517 5.97414 1.9298 5.92365 1.94704C5.87315 1.96429 5.8202 1.98399 5.80665 1.98892C5.7931 1.99507 5.75123 2.01232 5.71429 2.02709C5.67734 2.04064 5.63547 2.05788 5.62192 2.06281C5.60837 2.06897 5.50616 2.11823 5.39409 2.17365C5.28202 2.22906 5.1798 2.28079 5.16626 2.28941C5.15271 2.29803 5.12069 2.31897 5.09606 2.33867C5.0702 2.35714 5.0431 2.37192 5.03695 2.37192C5.02956 2.37192 5.0234 2.37562 5.02094 2.38177C5.0197 2.3867 4.99015 2.41256 4.9569 2.43842C4.92241 2.46552 4.87069 2.51232 4.84113 2.5431C4.81035 2.57389 4.76601 2.63054 4.74261 2.66749C4.70074 2.73153 4.69828 2.74015 4.69828 2.8399C4.69951 2.90887 4.70567 2.95567 4.71798 2.97537C4.72783 2.99261 4.7463 3.0234 4.75862 3.0431C4.77217 3.06404 4.82512 3.12192 4.87562 3.17241C4.92734 3.22414 5.01601 3.2968 5.07389 3.33374C5.13177 3.37192 5.18719 3.4064 5.19704 3.4101C5.2069 3.41502 5.23522 3.43103 5.25862 3.44458C5.28202 3.45936 5.32143 3.48153 5.34483 3.49384C5.36823 3.50739 5.39532 3.51724 5.40271 3.51724C5.41133 3.51724 5.41872 3.5234 5.41872 3.52956C5.41872 3.53695 5.43473 3.54433 5.45566 3.54803C5.47537 3.55172 5.49261 3.56034 5.49261 3.5665C5.49261 3.57389 5.49754 3.57882 5.50493 3.57882C5.51108 3.57882 5.5431 3.5899 5.57512 3.60468C5.60837 3.61823 5.65271 3.63793 5.67365 3.64778C5.69581 3.65764 5.72291 3.66502 5.73276 3.66502C5.74261 3.66502 5.75369 3.67118 5.75739 3.67734C5.76108 3.68473 5.7734 3.68966 5.78448 3.68966C5.7968 3.68966 5.82266 3.69828 5.8436 3.70813C5.8633 3.71921 5.88547 3.72783 5.89286 3.7266C5.89901 3.7266 5.91872 3.73399 5.93596 3.74261C5.9532 3.75123 6 3.76847 6.04064 3.78079C6.08128 3.7931 6.13424 3.81034 6.15764 3.81897C6.18103 3.82759 6.23645 3.84483 6.28079 3.85591C6.32512 3.867 6.37192 3.88177 6.38547 3.88793C6.39901 3.89286 6.4298 3.90148 6.4532 3.90517C6.4766 3.9101 6.51231 3.91872 6.53325 3.92488C6.55296 3.93103 6.60591 3.94458 6.65025 3.95566C6.69458 3.96552 6.75739 3.9803 6.79187 3.98645C6.82512 3.99384 6.89163 4.00616 6.93965 4.01601C6.98645 4.02586 7.0702 4.0431 7.12438 4.05296C7.17857 4.06404 7.27217 4.08005 7.33374 4.09113C7.39409 4.10099 7.5 4.11699 7.56773 4.12808C7.63547 4.13793 7.74015 4.15148 7.80172 4.15764C7.86207 4.16379 7.95936 4.17488 8.01724 4.18227C8.07512 4.18842 8.19335 4.20074 8.28202 4.20813C8.36946 4.21552 8.55788 4.2266 8.70074 4.23276C8.84236 4.23892 9.1367 4.24384 9.35345 4.24384C9.5702 4.24384 9.88054 4.23892 10.0431 4.23153C10.2057 4.22537 10.3547 4.21675 10.3756 4.21305C10.3953 4.20936 10.4815 4.20074 10.5665 4.19458C10.6515 4.18842 10.7759 4.17734 10.8436 4.16995C10.9113 4.16256 11 4.15148 11.0406 4.14409C11.0813 4.13793 11.1564 4.12685 11.2069 4.12069C11.2574 4.11453 11.3485 4.10099 11.4101 4.09113C11.4704 4.08128 11.5653 4.06404 11.6195 4.05296C11.6736 4.04187 11.7562 4.02463 11.8042 4.01601C11.851 4.00616 11.9064 3.99507 11.9273 3.99138C11.947 3.98645 12.0443 3.96429 12.1429 3.93965C12.2414 3.91626 12.3411 3.89163 12.3645 3.88424C12.3879 3.87685 12.4298 3.86453 12.4569 3.85591C12.484 3.84852 12.5369 3.83251 12.5739 3.82143C12.6108 3.81034 12.6749 3.79064 12.7155 3.77709C12.7562 3.76355 12.8054 3.74631 12.8264 3.73768C12.8473 3.7303 12.8818 3.71552 12.9027 3.7069C12.9249 3.69704 12.952 3.68966 12.9618 3.68966C12.9717 3.68966 12.9828 3.68473 12.9865 3.67734C12.9901 3.67118 13.0111 3.66133 13.032 3.65764C13.0542 3.65271 13.0813 3.64532 13.0911 3.63916C13.101 3.63424 13.17 3.60099 13.2451 3.56527C13.319 3.53079 13.3966 3.49384 13.4175 3.48399C13.4384 3.47537 13.4704 3.4569 13.4914 3.44335C13.5123 3.4298 13.5419 3.41256 13.5591 3.40517C13.5764 3.39778 13.6232 3.36946 13.6638 3.34113C13.7044 3.31404 13.7451 3.28325 13.7537 3.27463C13.7623 3.26601 13.7734 3.25862 13.7783 3.25862C13.7833 3.25862 13.8227 3.22291 13.867 3.18103C13.9113 3.13793 13.9643 3.07882 13.9852 3.04803C14.0062 3.01847 14.032 2.96921 14.0431 2.93842C14.0542 2.90764 14.064 2.86946 14.064 2.85222C14.064 2.83498 14.0554 2.79433 14.0443 2.75985C14.032 2.7266 14.0062 2.67365 13.9865 2.64286C13.9655 2.61207 13.9138 2.55419 13.8719 2.51355C13.83 2.47291 13.7562 2.41256 13.7081 2.37808C13.6589 2.34483 13.6047 2.30665 13.5862 2.29557C13.5677 2.28325 13.5369 2.26601 13.516 2.25616C13.4951 2.24631 13.4594 2.2266 13.436 2.21429C13.4126 2.20074 13.3374 2.16379 13.2697 2.13054C13.202 2.09852 13.1305 2.06527 13.1096 2.05665C13.0887 2.04803 13.0517 2.03202 13.0259 2.02217C13.0012 2.01108 12.9766 2.00246 12.9704 2.00246C12.9655 2.00246 12.915 1.98522 12.8571 1.96429C12.7993 1.94335 12.7414 1.92118 12.7278 1.91626C12.7143 1.91133 12.6786 1.89778 12.6478 1.88793C12.617 1.87808 12.564 1.86084 12.5308 1.85099C12.4963 1.84113 12.4495 1.82882 12.4261 1.82389C12.4027 1.81897 12.3768 1.81034 12.3707 1.80542C12.3645 1.80049 12.3411 1.7931 12.3214 1.79064C12.3005 1.78695 12.2266 1.7697 12.1552 1.75123C12.0837 1.73399 12.0012 1.71305 11.9704 1.70566C11.9397 1.69704 11.8904 1.68719 11.8596 1.68227C11.8288 1.67734 11.7599 1.66379 11.7057 1.65394C11.6515 1.64286 11.5985 1.63177 11.5887 1.62808C11.5788 1.62315 11.5345 1.61453 11.4901 1.60837C11.4458 1.60222 11.3547 1.58867 11.2869 1.57759C11.2192 1.5665 11.1022 1.54926 11.0283 1.54064C10.9544 1.53079 10.8067 1.51355 10.702 1.50369C10.5973 1.49261 10.3805 1.4766 10.2217 1.46552C10.0628 1.45566 9.70813 1.44458 9.4335 1.44212C9.15887 1.43966 8.87685 1.44335 8.80542 1.44951C8.73399 1.45443 8.57389 1.46552 8.44828 1.47291ZM4.69212 5.20443C5.23768 5.19212 5.4298 5.19458 5.54187 5.2032C5.64039 5.21182 5.7734 5.22537 5.83744 5.23399C5.90148 5.24384 6.00739 5.25985 6.07143 5.27094C6.13547 5.28079 6.22167 5.29803 6.26232 5.30788C6.30296 5.31773 6.36946 5.33498 6.4101 5.34606C6.45074 5.35714 6.50862 5.37069 6.53941 5.37808C6.5702 5.38424 6.66626 5.41502 6.75493 5.44458C6.84236 5.47414 6.94581 5.51108 6.98276 5.52463C7.0197 5.53941 7.06158 5.55419 7.07512 5.55788C7.08867 5.56281 7.10222 5.56897 7.10591 5.57266C7.10961 5.57759 7.14532 5.5936 7.18596 5.60961C7.2266 5.62562 7.31281 5.66379 7.37685 5.69581C7.44089 5.7266 7.4963 5.75493 7.5 5.75862C7.50369 5.76231 7.53695 5.78079 7.57389 5.79926C7.61084 5.81773 7.66872 5.84852 7.7032 5.86946C7.73645 5.88916 7.77586 5.91133 7.78941 5.91872C7.80296 5.92611 7.83005 5.94212 7.85099 5.95566C7.87069 5.96921 7.89655 5.98399 7.9064 5.98892C7.91626 5.99261 7.92734 6 7.93103 6.00369C7.93473 6.00739 7.95566 6.0234 7.9766 6.03941C7.99877 6.05419 8.0197 6.0665 8.0234 6.0665C8.02709 6.0665 8.03695 6.07266 8.04433 6.07882C8.05295 6.08621 8.11823 6.13424 8.18966 6.18596C8.26108 6.23768 8.32143 6.28325 8.32512 6.28695C8.32882 6.29064 8.35837 6.3165 8.39286 6.3436C8.42611 6.36946 8.46798 6.40394 8.48522 6.41872C8.50246 6.43473 8.54557 6.47291 8.58005 6.50616L8.64532 6.56527C8.95813 6.5936 9.12931 6.59729 9.44581 6.59236C9.68596 6.58867 10.0246 6.57759 10.197 6.5665C10.3695 6.55542 10.5936 6.53818 10.6958 6.52833C10.7968 6.5197 10.9273 6.50493 10.9852 6.49877C11.0431 6.49138 11.1145 6.4803 11.1453 6.47414C11.1761 6.46798 11.234 6.45936 11.2746 6.45567C11.3153 6.45074 11.3732 6.44335 11.4039 6.43596C11.4347 6.4298 11.4926 6.41872 11.5333 6.41256C11.5739 6.40517 11.6626 6.38916 11.7303 6.37438C11.798 6.36084 11.8953 6.34113 11.9458 6.33005C11.9963 6.3202 12.0714 6.30296 12.1121 6.29187C12.1527 6.28202 12.2131 6.26601 12.2475 6.25739C12.2808 6.24877 12.3424 6.23276 12.383 6.22044C12.4236 6.20936 12.5123 6.1835 12.58 6.16256C12.6478 6.14286 12.7143 6.12069 12.7278 6.11576C12.7414 6.11084 12.8017 6.08867 12.8633 6.0665C12.9249 6.04557 12.9963 6.0197 13.0234 6.00862C13.0505 5.99877 13.0887 5.98276 13.1096 5.97414C13.1305 5.96552 13.218 5.92365 13.3067 5.88054C13.3953 5.83867 13.516 5.7734 13.5776 5.73645C13.6392 5.69951 13.7131 5.65148 13.7426 5.63054C13.7709 5.60961 13.8325 5.55665 13.8781 5.51232C13.9236 5.46798 13.9741 5.4101 13.9914 5.383C14.0086 5.35591 14.032 5.30911 14.0431 5.27833C14.0616 5.22906 14.064 5.16133 14.064 4.71552C14.064 4.3165 14.0603 4.2069 14.048 4.20813C14.0406 4.20813 14.0172 4.21921 13.9963 4.23153C13.9754 4.24384 13.8732 4.29803 13.7685 4.35099C13.6638 4.40394 13.5579 4.45443 13.5345 4.46429C13.5111 4.47414 13.4667 4.49261 13.436 4.50493C13.4052 4.51847 13.3645 4.53571 13.3436 4.54557C13.3227 4.55419 13.2808 4.5702 13.2475 4.58128C13.2155 4.59236 13.1798 4.60591 13.1675 4.61207C13.1564 4.61699 13.1268 4.62931 13.1034 4.63793C13.08 4.64532 13.0394 4.65764 13.0135 4.66379C12.9889 4.66995 12.9581 4.6798 12.9458 4.68596C12.9347 4.69212 12.8966 4.70443 12.8633 4.71552C12.8288 4.72537 12.7697 4.74261 12.7303 4.75369C12.6921 4.76478 12.6281 4.78202 12.5887 4.79187C12.5505 4.80296 12.5012 4.8165 12.4815 4.82266C12.4606 4.82882 12.42 4.8399 12.3892 4.84606C12.3584 4.85345 12.2943 4.86823 12.2475 4.87808C12.1995 4.88916 12.1219 4.9064 12.0751 4.91626C12.0271 4.92611 11.9495 4.94212 11.9027 4.95197C11.8547 4.96182 11.7833 4.97537 11.7426 4.98276C11.702 4.98892 11.6404 5 11.6071 5.00616C11.5727 5.01231 11.4926 5.02709 11.4286 5.03695C11.3645 5.0468 11.2451 5.06404 11.1638 5.07389C11.0825 5.08497 10.952 5.09975 10.8744 5.10714C10.7968 5.11576 10.6773 5.12562 10.6096 5.13054C10.5419 5.13547 10.4089 5.14655 10.314 5.15271C10.2192 5.1601 10 5.17241 9.82759 5.1798C9.65517 5.18596 9.44458 5.19212 9.35961 5.19212C9.27463 5.19212 9.08374 5.18596 8.93473 5.1798C8.78571 5.17241 8.57266 5.1601 8.46059 5.15394C8.34852 5.14655 8.22414 5.13793 8.1835 5.13547C8.14286 5.133 8.0234 5.12192 7.91872 5.11207C7.81404 5.10099 7.66133 5.08374 7.58005 5.07389C7.49877 5.06404 7.37931 5.0468 7.31527 5.03695C7.25123 5.02709 7.14901 5.00985 7.08744 5C7.02586 4.98892 6.94335 4.97291 6.90271 4.96305C6.86207 4.9532 6.81404 4.94581 6.79433 4.94581C6.77586 4.94581 6.75123 4.94089 6.73892 4.9335C6.72783 4.92734 6.68719 4.91626 6.65025 4.9101C6.6133 4.90394 6.5468 4.88916 6.50246 4.87931C6.45813 4.86946 6.38916 4.85345 6.34852 4.84236C6.30788 4.83251 6.25 4.81773 6.21921 4.81034C6.18842 4.80296 6.15025 4.7931 6.133 4.78695C6.11576 4.78079 6.0665 4.76601 6.02217 4.75493C5.97783 4.74261 5.86207 4.7069 5.76355 4.67488C5.66502 4.64163 5.56773 4.60837 5.54803 4.60099C5.52709 4.59236 5.49261 4.57759 5.47044 4.56897C5.44951 4.55911 5.42488 4.55172 5.41872 4.55172C5.41133 4.55172 5.39655 4.5468 5.38424 4.53941C5.37315 4.53325 5.3436 4.5197 5.3202 4.50985C5.2968 4.5 5.24877 4.4803 5.21552 4.46552C5.18103 4.45074 5.09606 4.4101 5.02463 4.37438C4.9532 4.33867 4.85345 4.28695 4.80296 4.25862C4.75246 4.2303 4.7069 4.2069 4.70074 4.2069C4.69581 4.2069 4.69212 4.43103 4.69212 4.70566V5.20443ZM4.58744 6.16256C4.52586 6.16995 4.45197 6.18227 4.42118 6.18842C4.39039 6.19581 4.33498 6.2069 4.29803 6.21429C4.26108 6.22167 4.20197 6.23276 4.16872 6.23892C4.13424 6.2463 4.06773 6.26478 4.02094 6.27956C3.97291 6.29557 3.90148 6.31897 3.86084 6.33128C3.8202 6.3436 3.76478 6.36084 3.73768 6.37192C3.71059 6.38177 3.67734 6.39409 3.66379 6.40025C3.65025 6.4064 3.60837 6.42241 3.57143 6.43596C3.53448 6.45074 3.46798 6.47906 3.42365 6.5C3.37931 6.5197 3.2968 6.56034 3.23892 6.5899C3.18103 6.61946 3.11453 6.65271 3.09113 6.66626C3.06773 6.67857 3.0468 6.69212 3.04433 6.69828C3.0431 6.7032 3.03448 6.7069 3.02586 6.7069C3.01847 6.7069 2.94704 6.74877 2.86946 6.80049C2.79187 6.85222 2.67365 6.93473 2.60714 6.98522C2.54187 7.03571 2.47291 7.08867 2.45443 7.10468C2.43719 7.11946 2.39163 7.15887 2.35345 7.19335C2.31527 7.2266 2.22291 7.31527 2.14901 7.39039C2.07389 7.46552 1.99507 7.54803 1.97291 7.57266C1.95197 7.59729 1.9335 7.62069 1.9335 7.62438C1.9335 7.62808 1.92118 7.64286 1.90517 7.65887C1.88916 7.67364 1.83374 7.74261 1.78202 7.81281C1.7303 7.88177 1.68719 7.94458 1.68719 7.95074C1.68719 7.9569 1.6835 7.96429 1.67734 7.96675C1.67241 7.96798 1.6564 7.98768 1.64039 8.00985C1.62562 8.03079 1.6133 8.05542 1.6133 8.06158C1.6133 8.06773 1.60837 8.07512 1.60345 8.07759C1.59729 8.07882 1.56527 8.12685 1.52956 8.18473C1.49507 8.24261 1.46675 8.2968 1.46552 8.30542C1.46552 8.31281 1.46182 8.32143 1.45566 8.32389C1.45074 8.32512 1.41749 8.38424 1.383 8.45566C1.34729 8.52709 1.31773 8.59236 1.31773 8.60098C1.31773 8.60837 1.31158 8.61576 1.30542 8.61576C1.29803 8.61576 1.2931 8.62562 1.2931 8.63793C1.2931 8.64901 1.28941 8.66502 1.28325 8.67118C1.27833 8.67734 1.26108 8.71675 1.24507 8.75739C1.2303 8.79803 1.21182 8.84236 1.20566 8.85591C1.20074 8.86946 1.1835 8.91625 1.16995 8.96059C1.15517 9.00493 1.13916 9.04926 1.13424 9.05911C1.12808 9.06896 1.12069 9.09729 1.11576 9.12069C1.11084 9.14409 1.10222 9.17488 1.09606 9.18842C1.09113 9.20197 1.08005 9.23768 1.07143 9.26847C1.06404 9.29926 1.04926 9.3633 1.03818 9.4101C1.02833 9.45813 1.01232 9.54064 1.00246 9.59483C0.992611 9.64901 0.975369 9.76231 0.964286 9.84729C0.949507 9.9569 0.94335 10.0924 0.94335 10.3214C0.94335 10.5443 0.949507 10.6946 0.964286 10.814C0.975369 10.9089 0.990148 11.0197 0.997537 11.0603C1.00493 11.101 1.01847 11.1736 1.02956 11.2204C1.04064 11.2685 1.05665 11.3424 1.06773 11.3867C1.07759 11.431 1.09113 11.4778 1.09606 11.4914C1.10099 11.5049 1.117 11.5579 1.133 11.6084C1.14778 11.6589 1.16379 11.7118 1.16995 11.7254C1.17488 11.7389 1.19704 11.7968 1.21798 11.8547C1.24015 11.9126 1.26478 11.9766 1.27463 11.9963C1.28325 12.0172 1.30542 12.0665 1.32389 12.1071C1.34236 12.1478 1.3633 12.1946 1.37192 12.2118C1.38054 12.2291 1.41133 12.2869 1.44089 12.3411C1.46921 12.3953 1.50739 12.4594 1.5234 12.4828C1.53818 12.5062 1.55172 12.5333 1.55172 12.5419C1.55172 12.5493 1.55665 12.5567 1.56404 12.5567C1.5702 12.5567 1.57635 12.5628 1.57635 12.569C1.57635 12.5751 1.58867 12.5998 1.60345 12.6219C1.61946 12.6429 1.63424 12.6638 1.63793 12.6675C1.64163 12.6712 1.65148 12.6847 1.6601 12.6983C1.66872 12.7118 1.67857 12.7328 1.68103 12.7451C1.68473 12.7562 1.69212 12.766 1.69951 12.766C1.70566 12.766 1.7303 12.7943 1.75123 12.83C1.7734 12.8658 1.79803 12.9002 1.80542 12.9064C1.81281 12.9138 1.83867 12.9458 1.8633 12.9791C1.88916 13.0111 1.92118 13.0517 1.93596 13.0702C1.95197 13.0874 1.98892 13.1305 2.0197 13.1638C2.05049 13.1983 2.11084 13.2623 2.15517 13.3067C2.19951 13.351 2.27217 13.4212 2.3165 13.4618C2.36084 13.5025 2.41256 13.548 2.4298 13.564C2.44828 13.5788 2.48892 13.6108 2.52094 13.6367C2.55419 13.6613 2.58867 13.6897 2.59852 13.6995C2.60837 13.7106 2.64286 13.734 2.67488 13.7537C2.70813 13.7722 2.73399 13.7943 2.73399 13.8005C2.73399 13.8067 2.74384 13.8153 2.75493 13.819C2.76724 13.8214 2.78818 13.8313 2.80172 13.8399C2.81527 13.8485 2.82882 13.8596 2.83251 13.8658C2.83621 13.8707 2.85222 13.883 2.86946 13.8929C2.8867 13.9027 2.9101 13.9138 2.92118 13.9175C2.9335 13.9212 2.94335 13.9298 2.94335 13.936C2.94335 13.9421 2.95566 13.952 2.97044 13.9569C2.98645 13.9606 3.01478 13.9766 3.03571 13.9901C3.05542 14.0049 3.16133 14.0603 3.2697 14.1133C3.37808 14.1663 3.48276 14.218 3.50369 14.2266C3.5234 14.234 3.56527 14.2512 3.59606 14.2623C3.62685 14.2734 3.66749 14.2894 3.68842 14.298C3.70813 14.3066 3.78325 14.3313 3.85468 14.3534C3.92611 14.3768 3.99507 14.4002 4.00862 14.4052C4.02217 14.4113 4.05788 14.4212 4.08867 14.4286C4.11946 14.436 4.1798 14.4507 4.22414 14.4606C4.26847 14.4704 4.35099 14.4877 4.40887 14.4975C4.46675 14.5074 4.59606 14.5246 4.69828 14.5369C4.81773 14.5505 4.97783 14.5579 5.15394 14.5579C5.32759 14.5567 5.49138 14.5493 5.60961 14.5357C5.71059 14.5246 5.84113 14.5074 5.89901 14.4975C5.9569 14.4877 6.01478 14.4766 6.02833 14.4729C6.04187 14.4692 6.09113 14.4569 6.13916 14.4458C6.18596 14.436 6.25862 14.4163 6.29926 14.4027C6.3399 14.3904 6.42241 14.3633 6.48399 14.3436C6.54557 14.3239 6.60837 14.303 6.62562 14.2956C6.64286 14.2894 6.68103 14.2734 6.71182 14.2623C6.74261 14.25 6.79187 14.2291 6.82266 14.2155C6.85345 14.202 6.94458 14.1589 7.02586 14.1195C7.10714 14.08 7.20074 14.0308 7.23522 14.0099C7.26847 13.9901 7.31158 13.968 7.33005 13.9606C7.34975 13.9544 7.36453 13.9446 7.36453 13.9397C7.36453 13.9335 7.38547 13.9187 7.4101 13.9052C7.43596 13.8916 7.46305 13.8756 7.46921 13.8707C7.47537 13.8658 7.51847 13.835 7.56281 13.803C7.60837 13.7709 7.65764 13.7365 7.67241 13.7266C7.68719 13.7167 7.7069 13.702 7.71429 13.6958C7.72167 13.6884 7.75493 13.6613 7.78941 13.6342C7.82266 13.6071 7.8633 13.5739 7.88054 13.5603C7.89655 13.5468 7.95443 13.4938 8.00862 13.4433C8.06281 13.3929 8.15025 13.3079 8.20074 13.2537C8.25246 13.2007 8.30788 13.1404 8.32512 13.1207C8.34236 13.0998 8.37438 13.0628 8.39778 13.0382C8.41995 13.0135 8.44828 12.9791 8.45936 12.9594C8.47044 12.9409 8.48153 12.9261 8.48522 12.9261C8.48892 12.9261 8.51355 12.8953 8.54064 12.8559C8.56773 12.8165 8.59483 12.7783 8.60222 12.7697C8.60837 12.7611 8.62069 12.7475 8.62808 12.7389C8.63424 12.7303 8.65148 12.7032 8.66502 12.6798C8.67734 12.6564 8.69089 12.6342 8.69458 12.6305C8.69828 12.6268 8.71305 12.6059 8.72783 12.585C8.74384 12.5628 8.75616 12.5419 8.75616 12.5382C8.75616 12.5345 8.77709 12.4975 8.80296 12.4557C8.82882 12.4126 8.87562 12.3288 8.90763 12.2672C8.93842 12.2057 8.9803 12.1207 9.00123 12.0764C9.02094 12.032 9.04926 11.9655 9.06404 11.9286C9.07759 11.8916 9.0936 11.8498 9.09975 11.8362C9.10591 11.8227 9.11823 11.7894 9.12808 11.7623C9.13916 11.7352 9.15394 11.6933 9.16256 11.67C9.16995 11.6466 9.18227 11.6071 9.18842 11.5837C9.19335 11.5603 9.20566 11.516 9.21552 11.4852C9.22414 11.4544 9.23645 11.4212 9.24015 11.4113C9.24507 11.4015 9.25369 11.3621 9.25985 11.3251C9.26724 11.2882 9.27833 11.2303 9.28571 11.1958C9.2931 11.1626 9.30419 11.1096 9.31034 11.0788C9.31773 11.048 9.32882 10.9766 9.33621 10.9187C9.34236 10.8608 9.35345 10.7586 9.35961 10.6909C9.36576 10.6232 9.37069 10.4877 9.37069 10.3892C9.37069 10.2906 9.36576 10.1416 9.35961 10.0567C9.35345 9.97167 9.34236 9.85591 9.33498 9.79803C9.32882 9.74015 9.31773 9.66872 9.31034 9.63793C9.30419 9.60714 9.2931 9.54926 9.28448 9.50862C9.27709 9.46798 9.26601 9.40764 9.25862 9.37315C9.25246 9.3399 9.23276 9.26724 9.21675 9.21305C9.20074 9.15887 9.18103 9.09852 9.17365 9.07759C9.16626 9.05788 9.1564 9.02463 9.15025 9.00369C9.14409 8.98399 9.133 8.94704 9.12438 8.92365C9.11576 8.90025 9.10222 8.86453 9.0936 8.8436C9.08498 8.82389 9.06896 8.78202 9.05665 8.75123C9.04557 8.72044 9.0197 8.6601 8.99877 8.61576C8.97906 8.57143 8.94828 8.50493 8.93103 8.46798C8.91256 8.43103 8.86699 8.34729 8.83005 8.28325C8.79187 8.21921 8.75739 8.15764 8.75246 8.14778C8.74754 8.13793 8.73645 8.11823 8.72783 8.10468C8.71921 8.09113 8.69581 8.05542 8.67611 8.02463C8.65517 7.99384 8.63547 7.96305 8.62931 7.9569C8.62438 7.95074 8.58374 7.89532 8.53941 7.83374C8.49507 7.77217 8.4532 7.72167 8.44704 7.72044C8.44089 7.71798 8.43596 7.70813 8.43596 7.69828C8.43596 7.68842 8.43227 7.6798 8.42611 7.6798C8.42118 7.6798 8.38916 7.64532 8.35591 7.60345C8.32143 7.56034 8.22537 7.4569 8.14039 7.37192C8.05542 7.28695 7.9532 7.19089 7.91256 7.1564C7.87192 7.12315 7.83497 7.08867 7.82882 7.08005C7.82389 7.07143 7.81158 7.06404 7.80172 7.06404C7.79187 7.06404 7.78202 7.05911 7.77956 7.05296C7.77833 7.0468 7.72783 7.00493 7.66626 6.96059C7.60468 6.91626 7.54926 6.87438 7.5431 6.86946C7.53695 6.8633 7.48399 6.82759 7.42611 6.79064C7.36823 6.75246 7.29064 6.70443 7.25369 6.68473C7.21675 6.66379 7.10222 6.60468 7.00123 6.55419C6.89901 6.50369 6.80049 6.45813 6.78079 6.45197C6.76108 6.44704 6.74384 6.43842 6.74138 6.4335C6.73892 6.42734 6.72783 6.42365 6.71798 6.42365C6.70813 6.42365 6.68103 6.41626 6.65887 6.4064C6.63793 6.39655 6.57759 6.37315 6.52709 6.35591C6.4766 6.33744 6.41502 6.31897 6.39163 6.31404C6.36823 6.30788 6.33498 6.29803 6.31773 6.29064C6.30049 6.28448 6.25616 6.2697 6.21921 6.25985C6.18227 6.25 6.10714 6.23276 6.05296 6.22167C5.99877 6.21059 5.9298 6.19581 5.89901 6.18842C5.86823 6.18227 5.7931 6.17118 5.73276 6.16379C5.67118 6.15764 5.5665 6.14655 5.49877 6.14039C5.43103 6.13424 5.26724 6.13054 5.13547 6.13054C5.00369 6.13177 4.85099 6.1367 4.7968 6.14039C4.74261 6.14532 4.64778 6.15517 4.58744 6.16256ZM13.8485 6.65764C13.814 6.67488 13.7857 6.69212 13.7832 6.69828C13.782 6.7032 13.7722 6.7069 13.7623 6.7069C13.7525 6.7069 13.7118 6.72291 13.6724 6.74261C13.6342 6.76231 13.5714 6.7931 13.5345 6.80911C13.4975 6.82635 13.436 6.85222 13.399 6.86576C13.3621 6.88054 13.3202 6.89778 13.3067 6.90394C13.2931 6.9101 13.2377 6.93227 13.1835 6.9532C13.1293 6.97291 13.0665 6.99384 13.0431 7C13.0209 7.00493 13 7.01232 12.9975 7.01847C12.9951 7.0234 12.9803 7.02709 12.9643 7.02709C12.9495 7.02709 12.9212 7.03571 12.9002 7.04557C12.8793 7.05665 12.8559 7.06404 12.8473 7.06404C12.8399 7.06404 12.7808 7.08005 12.718 7.09975C12.6564 7.11946 12.5714 7.14409 12.5308 7.15394C12.4901 7.16502 12.4323 7.1798 12.4015 7.18842C12.3707 7.19704 12.3239 7.20813 12.2968 7.21305C12.2697 7.21921 12.2081 7.23153 12.1613 7.24261C12.1133 7.25246 12.0357 7.2697 11.9889 7.27833C11.9409 7.28818 11.8608 7.30542 11.8103 7.3165C11.7599 7.32635 11.665 7.3436 11.601 7.35345C11.5369 7.3633 11.4224 7.38054 11.3485 7.39039C11.2746 7.40148 11.149 7.41749 11.0714 7.42734C10.9938 7.43842 10.8411 7.45443 10.7328 7.46552C10.6244 7.47537 10.4138 7.49138 10.2648 7.50123C10.1158 7.51108 9.87931 7.5234 9.73768 7.52833C9.59729 7.53448 9.48276 7.53818 9.48276 7.53818C9.48276 7.53818 9.48892 7.55172 9.49754 7.56897C9.50616 7.58621 9.52709 7.61946 9.54433 7.64286C9.56158 7.66626 9.58744 7.70813 9.60345 7.73522C9.61823 7.76231 9.63793 7.79803 9.64655 7.81527C9.65394 7.83251 9.66379 7.84852 9.66749 7.85222C9.67118 7.85591 9.71182 7.9335 9.75739 8.02463C9.80296 8.11576 9.8399 8.19828 9.8399 8.2069C9.8399 8.21429 9.84483 8.22167 9.85222 8.22167C9.85837 8.22167 9.86453 8.22906 9.86453 8.23768C9.86453 8.24507 9.87562 8.28079 9.89039 8.31404C9.90394 8.34852 9.92365 8.39286 9.93227 8.41256C9.94212 8.4335 9.96921 8.50493 9.99384 8.57266C10.0185 8.64039 10.0431 8.71305 10.0493 8.73276C10.0542 8.75369 10.0702 8.80049 10.0825 8.83744L10.1047 8.90517C10.3621 8.89901 10.4975 8.88916 10.5727 8.87931C10.6466 8.86946 10.7303 8.86207 10.7574 8.86207C10.7845 8.86207 10.8645 8.85345 10.936 8.8436C11.0074 8.83251 11.1256 8.8165 11.2007 8.80542C11.2746 8.79557 11.3608 8.78202 11.3916 8.77586C11.4224 8.76847 11.4803 8.75862 11.5209 8.75246C11.5616 8.74507 11.6416 8.73153 11.6995 8.72167C11.7574 8.71182 11.8399 8.69458 11.8842 8.68473C11.9286 8.67488 11.9988 8.65763 12.0406 8.64655C12.0837 8.6367 12.1502 8.62069 12.1884 8.61084C12.2278 8.60098 12.2931 8.58374 12.3337 8.57266C12.3744 8.56158 12.4273 8.54803 12.4507 8.5431C12.4741 8.53818 12.5135 8.52709 12.5369 8.5197C12.5603 8.51231 12.6158 8.49384 12.6601 8.47906C12.7044 8.46429 12.7894 8.4335 12.851 8.41256C12.9113 8.39039 12.9729 8.36823 12.9865 8.3633C13 8.35837 13.0271 8.34729 13.048 8.33867C13.069 8.33005 13.0985 8.3165 13.1158 8.31034C13.133 8.30296 13.1786 8.28325 13.2167 8.26601C13.2562 8.24877 13.3202 8.21921 13.3584 8.20074C13.3978 8.1835 13.4692 8.14409 13.516 8.11576C13.5628 8.08621 13.6096 8.06281 13.617 8.06158C13.6256 8.06158 13.633 8.05542 13.633 8.04926C13.633 8.0431 13.6379 8.03695 13.6453 8.03695C13.6515 8.03695 13.6921 8.01108 13.734 7.97906C13.7771 7.94704 13.8436 7.89039 13.883 7.85345C13.9212 7.81527 13.9655 7.76478 13.9803 7.74138C13.9951 7.71798 14.0111 7.69581 14.0148 7.69212C14.0185 7.68842 14.032 7.66133 14.0431 7.63054C14.0616 7.58128 14.064 7.51355 14.064 7.06158C14.064 6.77832 14.0603 6.5468 14.0542 6.5468C14.0493 6.5468 14.0148 6.56527 13.9778 6.58744C13.9397 6.60837 13.8818 6.64039 13.8485 6.65764ZM13.8941 8.97291C13.8867 8.97291 13.8781 8.97783 13.8756 8.98276C13.8744 8.98768 13.8042 9.02709 13.7192 9.06896C13.6342 9.11084 13.5616 9.14532 13.5554 9.14532C13.5505 9.14532 13.5111 9.16256 13.4667 9.18227C13.4224 9.2032 13.3793 9.21921 13.3707 9.21921C13.3621 9.21921 13.3498 9.22414 13.3424 9.2303C13.3362 9.23645 13.2894 9.25616 13.2389 9.27463C13.1884 9.2931 13.0665 9.33374 12.968 9.36699C12.8695 9.40025 12.7672 9.43227 12.7401 9.43966C12.7131 9.44704 12.6601 9.46059 12.6232 9.47044C12.5862 9.4803 12.4754 9.50862 12.3768 9.53202C12.2783 9.55665 12.165 9.58498 12.1244 9.5936C12.0837 9.60345 12.0062 9.61946 11.952 9.63054C11.8978 9.64039 11.8091 9.65764 11.7549 9.66749C11.7007 9.67734 11.5985 9.69458 11.5271 9.70566C11.4557 9.71675 11.367 9.7303 11.33 9.73645C11.2931 9.74261 11.2229 9.75123 11.1761 9.75493C11.1281 9.75862 11.0567 9.76724 11.016 9.77463C10.9754 9.78079 10.8805 9.79187 10.8067 9.79926C10.7328 9.80665 10.5874 9.81896 10.4865 9.82635L10.3017 9.84113C10.3079 10.3855 10.3042 10.6158 10.2968 10.7032C10.2894 10.7919 10.2759 10.9249 10.2648 10.9988C10.2537 11.0727 10.2414 11.1613 10.2365 11.1933L10.2278 11.2537C10.3707 11.2414 10.4791 11.2328 10.5603 11.2254C10.6416 11.2192 10.7796 11.2057 10.8682 11.1958C10.9557 11.186 11.0837 11.17 11.1515 11.1601C11.2192 11.1502 11.3276 11.133 11.3916 11.1219C11.4557 11.1108 11.553 11.0936 11.6071 11.0837C11.6613 11.0739 11.7414 11.0603 11.7857 11.053C11.83 11.0456 11.8756 11.0345 11.8867 11.0283C11.899 11.0222 11.9212 11.0172 11.936 11.0172C11.952 11.0172 11.9914 11.0099 12.0259 11C12.0591 10.9901 12.1232 10.9729 12.1675 10.9618C12.2118 10.9507 12.2746 10.9335 12.3091 10.9249C12.3424 10.915 12.4064 10.899 12.4507 10.8867C12.4951 10.8756 12.5419 10.8621 12.5554 10.8571C12.569 10.8522 12.6441 10.8276 12.7217 10.8017C12.7993 10.7771 12.8818 10.7488 12.9027 10.7389C12.9249 10.7291 12.9507 10.7217 12.9594 10.7217C12.968 10.7217 12.9803 10.7167 12.9865 10.7118C12.9938 10.7057 13.0259 10.6909 13.0603 10.6786C13.0936 10.6675 13.1663 10.6367 13.2204 10.6108C13.2746 10.585 13.3498 10.5493 13.3867 10.532C13.4236 10.5135 13.4704 10.4877 13.4914 10.4754C13.5123 10.4618 13.5394 10.4458 13.553 10.4384C13.5665 10.4323 13.5887 10.4187 13.6022 10.4113C13.6158 10.4027 13.6515 10.3793 13.6823 10.3596C13.7131 10.3399 13.7401 10.319 13.7438 10.3153C13.7475 10.3103 13.7586 10.3017 13.7709 10.2956C13.782 10.2894 13.8264 10.2512 13.8695 10.2094C13.9113 10.1687 13.9643 10.1108 13.9852 10.08C14.0062 10.0505 14.032 10.0025 14.0431 9.97414C14.0616 9.92734 14.064 9.85591 14.0653 9.41133C14.0665 9.09606 14.0616 8.89778 14.0542 8.89409C14.048 8.89162 14.0135 8.90763 13.9766 8.93103C13.9397 8.9532 13.9027 8.97291 13.8941 8.97291ZM13.9544 11.2882C13.9507 11.2919 13.936 11.3005 13.9224 11.3091C13.9089 11.3177 13.8485 11.3485 13.7869 11.3793C13.7254 11.4089 13.6478 11.4458 13.6145 11.4606C13.58 11.4754 13.5234 11.5012 13.4877 11.5172C13.4532 11.5333 13.4199 11.5468 13.4138 11.5468C13.4089 11.5468 13.3916 11.5542 13.3744 11.5628C13.3571 11.5727 13.3079 11.5924 13.2635 11.6084C13.2192 11.6232 13.1613 11.6441 13.1342 11.6539C13.1071 11.6626 13.0739 11.6749 13.0603 11.681C13.0468 11.686 13.016 11.697 12.9926 11.7057C12.9692 11.7143 12.9212 11.7291 12.8879 11.7389C12.8534 11.7488 12.8103 11.7623 12.7894 11.7672C12.7685 11.7734 12.7192 11.7869 12.6786 11.7993C12.6379 11.8103 12.5628 11.8313 12.5123 11.8448C12.4618 11.8584 12.4002 11.8744 12.3768 11.8805C12.3534 11.8855 12.2943 11.899 12.2475 11.9101C12.1995 11.9212 12.1195 11.9384 12.069 11.9483C12.0185 11.9594 11.9372 11.9754 11.8904 11.9852C11.8424 11.9951 11.7574 12.0123 11.6995 12.0222C11.6416 12.032 11.5394 12.048 11.4717 12.0591C11.4039 12.069 11.3066 12.0825 11.2562 12.0887C11.2057 12.0948 11.1281 12.1059 11.0837 12.1121C11.0394 12.1195 10.915 12.133 10.8067 12.1429C10.6983 12.1527 10.5148 12.17 10.4002 12.181C10.2845 12.1909 10.1441 12.1995 10.0862 12.1995C10.0012 12.1983 9.97783 12.2032 9.96182 12.2204C9.95074 12.2328 9.93103 12.2709 9.91872 12.3042C9.9064 12.3387 9.88916 12.3793 9.88054 12.3966C9.87192 12.4138 9.86453 12.4347 9.86453 12.4433C9.86453 12.4507 9.85837 12.4581 9.85222 12.4581C9.84606 12.4581 9.8399 12.4655 9.8399 12.4741C9.8399 12.4815 9.81896 12.5333 9.79433 12.5874C9.76847 12.6416 9.74507 12.6884 9.74138 12.6921C9.73768 12.6958 9.71428 12.7401 9.68842 12.7906C9.66256 12.8411 9.62438 12.9138 9.60345 12.9507C9.58251 12.9877 9.56034 13.0197 9.55419 13.0222C9.54926 13.0234 9.54433 13.0308 9.54433 13.0369C9.54433 13.0431 9.51847 13.0899 9.48522 13.1392C9.4532 13.1872 9.42365 13.2291 9.41749 13.2315C9.41256 13.2328 9.40887 13.2401 9.40887 13.2463C9.40887 13.2525 9.39655 13.2771 9.38054 13.298C9.36576 13.3202 9.34606 13.3461 9.33621 13.3571C9.32635 13.367 9.30542 13.3978 9.28818 13.4249C9.27094 13.452 9.24261 13.4889 9.22537 13.5074C9.20813 13.5246 9.18473 13.5542 9.17488 13.5714C9.16502 13.5887 9.16133 13.6071 9.16626 13.6121C9.17241 13.6182 9.30296 13.6219 9.45566 13.6219C9.60961 13.6219 9.88424 13.6145 10.0677 13.6059C10.25 13.5973 10.4421 13.5862 10.4926 13.5788C10.5431 13.5727 10.649 13.5616 10.7266 13.5554C10.8042 13.548 10.9175 13.5369 10.9791 13.5308C11.0394 13.5234 11.117 13.5123 11.1515 13.5062C11.1847 13.4988 11.2574 13.4877 11.3116 13.4803C11.3658 13.4729 11.4409 13.4618 11.4778 13.4557C11.5148 13.4495 11.6121 13.431 11.6933 13.4138C11.7746 13.3966 11.8547 13.3818 11.8719 13.3818C11.8904 13.3818 11.9089 13.3768 11.915 13.3707C11.9224 13.3645 11.9606 13.3534 12.0012 13.3473C12.0419 13.3399 12.1084 13.3251 12.149 13.3153C12.1897 13.3054 12.2537 13.2882 12.2906 13.2783C12.3276 13.2685 12.383 13.2537 12.4138 13.2463C12.4446 13.2377 12.4803 13.2278 12.4938 13.2217C12.5074 13.2167 12.5603 13.2007 12.6108 13.1847C12.6613 13.17 12.7143 13.1539 12.7278 13.1478C12.7414 13.1429 12.8017 13.1207 12.8633 13.0985C12.9236 13.0776 12.9963 13.0517 13.0234 13.0406C13.0505 13.0296 13.0887 13.0148 13.1096 13.0062C13.1305 12.9975 13.1995 12.9643 13.2635 12.9335C13.3276 12.9027 13.3842 12.8768 13.3892 12.8768C13.3953 12.8768 13.4643 12.8374 13.5431 12.7894C13.6232 12.7414 13.7217 12.6761 13.7623 12.6453C13.803 12.6145 13.8658 12.5579 13.9027 12.5209C13.9397 12.4828 13.9815 12.4323 13.9963 12.4089C14.0111 12.3855 14.032 12.3411 14.0431 12.3103C14.0616 12.2611 14.064 12.1933 14.064 11.7475C14.064 11.3485 14.0603 11.2389 14.048 11.2401C14.0406 11.2414 14.0172 11.25 13.9975 11.2611C13.9766 11.2722 13.9581 11.2845 13.9544 11.2882Z" fill="white"/>
<path d="M7.57208 8.31749C7.59873 8.28967 7.6461 8.25513 7.67571 8.24073L7.73 8.21387L8.35378 8.21962L8.39227 8.24457C8.41398 8.25896 8.44261 8.28967 8.45741 8.31653C8.47419 8.34532 8.48702 8.38562 8.48998 8.42112C8.49492 8.46526 8.49196 8.49213 8.47715 8.53626C8.4663 8.56793 8.4278 8.65428 8.39326 8.72816C8.35871 8.80205 8.30541 8.91239 8.2758 8.97284C8.24619 9.03329 8.21264 9.10237 8.20079 9.12636C8.19082 9.14839 8.15337 9.22466 8.11521 9.30237L8.10505 9.32306C8.06261 9.4075 7.99747 9.54087 7.95997 9.62051C7.92246 9.69919 7.86521 9.81817 7.83363 9.88437C7.80205 9.95058 7.72704 10.106 7.66782 10.2298C7.60761 10.3536 7.52964 10.5148 7.4941 10.5867C7.45857 10.6597 7.42896 10.7211 7.42896 10.7211C7.42896 10.7211 7.4033 10.7777 7.37073 10.8439C7.33915 10.9101 7.274 11.0435 7.22663 11.1413C7.17925 11.2392 7.1299 11.3399 7.11806 11.3668C7.10523 11.3927 7.06575 11.4752 7.03022 11.5491C6.9937 11.623 6.96507 11.6854 6.96507 11.6854C6.96507 11.6854 6.92362 11.7688 6.87328 11.8677C6.82196 11.9675 6.74892 12.1152 6.70944 12.1968C6.66996 12.2783 6.62555 12.358 6.61074 12.3724C6.59693 12.3877 6.57324 12.406 6.55843 12.4136C6.54264 12.4213 6.51501 12.4271 6.49625 12.4271C6.4775 12.4271 6.44394 12.4184 6.42223 12.4079C6.39755 12.3954 6.37189 12.3714 6.35314 12.3426C6.33636 12.3177 6.32353 12.2947 6.32353 12.2899C6.32353 12.286 6.29194 12.2198 6.25345 12.1411C6.21496 12.0634 6.14883 11.9262 6.10639 11.837C6.06605 11.7512 6.00253 11.6187 5.96159 11.5333L5.80832 11.2133C5.76785 11.1289 5.71554 11.0204 5.69185 10.9734C5.66915 10.9254 5.6425 10.8698 5.63263 10.8487C5.62276 10.8276 5.60302 10.7844 5.58822 10.7527C5.57341 10.7211 5.53887 10.6501 5.51123 10.5944C5.48458 10.5388 5.42931 10.4227 5.38884 10.3353C5.34936 10.248 5.30594 10.1674 5.29409 10.155C5.28225 10.1434 5.25856 10.131 5.24277 10.1281C5.225 10.1242 5.20033 10.1281 5.18157 10.1377C5.16381 10.1463 5.14012 10.1674 5.13025 10.1837C5.11939 10.201 5.08189 10.2759 5.04734 10.3497C5.01181 10.4236 4.92693 10.5963 4.85784 10.7335C4.78875 10.8707 4.70288 11.0435 4.66538 11.1173C4.62886 11.1912 4.52522 11.3985 4.43541 11.5779C4.34658 11.7573 4.23406 11.9838 4.18668 12.0816C4.13931 12.1795 4.07417 12.311 4.04357 12.3743C4.01199 12.4376 3.91723 12.6295 3.83137 12.8013C3.74648 12.973 3.66456 13.1275 3.64976 13.1457C3.63594 13.164 3.60633 13.187 3.58462 13.1966C3.5629 13.2062 3.52836 13.2139 3.50862 13.2139C3.48789 13.2139 3.45335 13.2052 3.43163 13.1947C3.40992 13.1841 3.38426 13.164 3.3734 13.1486C3.36353 13.1342 3.3428 13.0968 3.328 13.0651C3.31319 13.0335 3.27865 12.9625 3.25101 12.9068C3.22436 12.8512 3.17798 12.7562 3.14837 12.6957C3.11876 12.6353 3.08125 12.5595 3.06644 12.5278C3.05164 12.4962 3.02104 12.4338 2.99933 12.3887C2.9786 12.3436 2.94307 12.2707 2.92037 12.2256C2.89866 12.1805 2.85819 12.096 2.83154 12.0385C2.8039 11.9799 2.76146 11.8897 2.7358 11.837C2.71014 11.7842 2.6677 11.6959 2.64105 11.6403C2.61539 11.5846 2.49497 11.3342 2.37456 11.0838C2.25415 10.8333 2.1209 10.5541 2.07748 10.4649C2.03405 10.3747 1.9847 10.2711 1.96693 10.2346C1.94818 10.1972 1.89587 10.0897 1.84948 9.99472C1.80309 9.89972 1.72512 9.73757 1.67478 9.6349C1.62444 9.53223 1.56325 9.40462 1.53858 9.35184C1.49416 9.25973 1.49219 9.25301 1.49219 9.16954C1.49317 9.0947 1.49614 9.07743 1.51884 9.04C1.53265 9.01602 1.5593 8.98435 1.57707 8.969C1.59582 8.95365 1.63037 8.93158 1.65504 8.92103C1.69847 8.90184 1.71327 8.90088 2.61736 8.90183L2.70126 8.94117C2.75357 8.96612 2.80292 8.99779 2.83253 9.02753C2.85918 9.05248 2.90458 9.11389 2.93419 9.16186C2.9638 9.2108 2.98748 9.25302 2.98748 9.25589C2.98748 9.25877 3.02795 9.34609 3.0773 9.44971C3.12665 9.5543 3.22634 9.7606 3.29839 9.90836C3.37044 10.0561 3.44841 10.2154 3.47111 10.2634C3.49381 10.3104 3.55106 10.4294 3.59646 10.5272C3.64285 10.6251 3.68825 10.7239 3.69812 10.7479C3.70799 10.7719 3.73168 10.8247 3.75142 10.865C3.77807 10.9206 3.79485 10.9437 3.81656 10.9542C3.83235 10.9619 3.86394 10.9686 3.88565 10.9686C3.90736 10.9686 3.93994 10.9619 3.9577 10.9523C3.97448 10.9437 3.99521 10.9302 4.00212 10.9216C4.00903 10.913 4.02876 10.8784 4.04554 10.8439C4.06134 10.8093 4.09983 10.7297 4.12944 10.6664C4.16004 10.603 4.22024 10.4802 4.26466 10.3929C4.30907 10.3056 4.36632 10.1914 4.39099 10.1386C4.41665 10.0859 4.51535 9.88437 4.6101 9.68959C4.70584 9.49577 4.78382 9.33553 4.78382 9.33265C4.78382 9.32978 4.85389 9.18681 4.94075 9.01314L4.95298 8.98854C5.03454 8.8245 5.11239 8.6679 5.13025 8.63317C5.15197 8.59 5.1796 8.55257 5.20822 8.52955C5.23389 8.50748 5.27337 8.48637 5.30199 8.47773C5.33555 8.4691 5.36713 8.46718 5.40069 8.47197C5.42832 8.47581 5.47076 8.49117 5.49741 8.50556C5.52308 8.51995 5.55663 8.5497 5.57242 8.57176C5.58723 8.59479 5.61487 8.64565 5.63263 8.68499C5.64941 8.72433 5.7106 8.85386 5.76785 8.97284C5.8251 9.09182 5.89715 9.24246 5.92873 9.30867C5.96031 9.37487 6.03236 9.52743 6.08961 9.64929C6.14587 9.77019 6.22384 9.93715 6.26135 10.0187C6.29984 10.1003 6.35018 10.2106 6.37386 10.2634C6.39755 10.3162 6.42519 10.3689 6.43506 10.3804C6.4469 10.3967 6.46269 10.4025 6.48934 10.4025C6.51204 10.4035 6.53277 10.3967 6.54264 10.3862C6.55251 10.3766 6.58706 10.3085 6.61963 10.2346C6.65318 10.1607 6.72129 10.0158 6.77162 9.91316C6.82295 9.81049 6.87822 9.69535 6.89599 9.65889C6.91375 9.62147 6.95817 9.52935 6.99468 9.45259C7.0312 9.37583 7.11609 9.20312 7.18221 9.06879C7.24834 8.93446 7.34013 8.74448 7.38553 8.64661C7.43192 8.54874 7.48127 8.44607 7.49608 8.41824C7.51088 8.39042 7.54444 8.34532 7.57208 8.31749Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_107_78">
<rect width="15" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_35 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02943 3 3 7.02943 3 12C3 16.9705 7.02944 21 12 21C16.9705 21 21 16.9705 21 12C21 7.02944 16.9705 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92486 23 12C23 18.0751 18.0751 23 12 23C5.92486 23 1 18.0751 1 12ZM17.2071 8.29289C17.5976 8.68342 17.5976 9.31658 17.2071 9.70711L11.2071 15.7071C10.8166 16.0976 10.1834 16.0976 9.79289 15.7071L6.79289 12.7071C6.40237 12.3166 6.40237 11.6834 6.79289 11.2929C7.18342 10.9024 7.81658 10.9024 8.20711 11.2929L10.5 13.5858L15.7929 8.29289C16.1834 7.90237 16.8166 7.90237 17.2071 8.29289Z" fill="#249C5C"/>
</svg>
`, __vite_glob_0_36 = `<svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.23295 5.62784H6.66193V10.1818H7.89489V0H6.66193V4.53409H1.23295V0H0V10.1818H1.23295V5.62784Z" fill="black"/>
</svg>
`, __vite_glob_0_37 = `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9357 4.75946C10.6949 5.00022 10.3034 5.00022 10.0626 4.75946C9.82187 4.51871 9.82187 4.12715 10.0626 3.8864L10.8616 3.0874H8.64644C8.30553 3.0874 8.02888 2.81074 8.02888 2.46983C8.02888 2.12892 8.30553 1.85225 8.64644 1.85225H10.8612L10.0626 1.05364C9.82187 0.812886 9.82187 0.421323 10.0626 0.180567C10.3034 -0.060189 10.6949 -0.060189 10.9357 0.180567L12.7809 2.02536C12.8973 2.13761 12.9698 2.29521 12.9698 2.46983C12.9698 2.64444 12.8973 2.80205 12.7809 2.9143L10.9357 4.75946ZM6.48492 0.617104C6.82583 0.617104 7.10249 0.89376 7.10249 1.23467C7.10249 1.57559 6.82583 1.85225 6.48492 1.85225H3.58225C2.64266 1.85225 2.17209 1.85225 1.90866 1.98643C1.79414 2.04463 1.68832 2.12211 1.59648 2.21395C1.50539 2.30504 1.42755 2.41162 1.36934 2.52614C1.23517 2.7892 1.23517 3.25975 1.23517 4.19934V9.38712C1.23517 10.3271 1.23555 10.7976 1.36934 11.0607C1.42755 11.1752 1.50539 11.2814 1.59648 11.3725C1.67585 11.4519 1.7658 11.5207 1.86293 11.5755C1.96914 11.4137 2.13923 11.2587 2.38036 11.0392L7.60744 6.28677C7.73179 6.17339 7.82592 6.08835 7.90907 6.02372C8.0217 5.93641 8.12789 5.87291 8.25111 5.82793L8.29078 5.81358C8.39964 5.77805 8.51565 5.75839 8.63319 5.75461C8.74771 5.75121 8.86563 5.76331 8.97977 5.79279C9.11924 5.82869 9.23982 5.88765 9.37286 5.97874C9.45979 6.03921 9.55842 6.11821 9.68843 6.22215L11.4161 7.60431C11.6652 7.80349 11.8012 7.91234 11.9222 8.05672L11.9558 8.09603C12.0276 8.18749 12.093 8.29068 12.1489 8.4018L12.1675 8.43694C12.2264 8.55902 12.2725 8.68791 12.3028 8.81754C12.3523 9.0292 12.3523 9.20154 12.3523 9.54548V9.88148C12.3523 10.1551 12.3519 10.3615 12.3421 10.5833C12.333 10.7893 12.3129 10.9522 12.2755 11.1049L12.2676 11.1378C12.2086 11.3585 12.1198 11.5672 12.0053 11.7592C11.8995 11.9383 11.7725 12.1016 11.6285 12.2456C11.4796 12.3945 11.3102 12.5249 11.1243 12.6326C10.9372 12.7418 10.7343 12.8272 10.5203 12.8847C10.2051 12.969 9.89104 12.9694 9.26401 12.9694H3.13095C2.9416 12.9694 2.79421 12.9694 2.66759 12.961C2.09537 12.9429 1.71289 12.8847 1.3493 12.6999C1.1161 12.5812 0.904843 12.427 0.723425 12.2456C0.542386 12.0645 0.388153 11.8533 0.269476 11.6201C0.000373513 11.0909 0 10.5229 0 9.38712V4.19934C0 3.06397 -4.44055e-06 2.49553 0.269476 1.96677C0.388153 1.73395 0.542386 1.52192 0.723425 1.34088C0.904843 1.15946 1.1161 1.00526 1.3493 0.88658C1.87843 0.617478 2.44688 0.617104 3.58225 0.617104H6.48492ZM3.44882 11.7342H8.96542C9.70734 11.7342 10.1008 11.7323 10.3325 11.6499C10.388 11.6284 10.4413 11.6027 10.4927 11.574C10.5884 11.5191 10.6768 11.4511 10.7554 11.3725C10.8371 11.2909 10.907 11.1994 10.9625 11.1004L11.0298 10.9579C11.0668 10.8574 11.088 10.7258 11.1008 10.5455L11.1016 10.5361C11.1167 10.3044 11.1171 9.97786 11.1171 9.54548C11.1171 9.29112 11.1167 9.16337 11.1016 9.09723C11.0914 9.05338 11.0763 9.0103 11.0578 8.97213C11.0381 8.92942 10.9996 8.87651 10.9709 8.83758C10.9202 8.78126 10.8234 8.70378 10.6488 8.56432L8.9212 7.18214C8.81802 7.09975 8.74015 7.03739 8.68044 6.99695L8.66685 6.9875C8.66534 6.98939 8.67858 6.98863 8.66649 6.99808C8.60715 7.04419 8.53418 7.11033 8.43743 7.19839L3.44882 11.7342ZM5.86735 4.63172C5.86735 5.1412 5.65946 5.60382 5.32459 5.93944C4.9867 6.27657 4.52412 6.48444 4.01464 6.48444C3.50478 6.48444 3.04215 6.27656 2.70653 5.9417C2.3694 5.60683 2.16153 5.14309 2.16153 4.63172C2.16153 4.12035 2.36942 3.6566 2.70428 3.32174L2.7447 3.2847C3.07654 2.97175 3.52368 2.77899 4.01464 2.77899C4.52412 2.77899 4.98672 2.98687 5.32234 3.32174C5.65948 3.6566 5.86735 4.12035 5.86735 4.63172ZM4.45268 5.06977C4.56304 4.95827 4.63221 4.80293 4.63221 4.63172C4.63221 4.46088 4.56266 4.30592 4.45154 4.1948C4.34118 4.08331 4.18585 4.01414 4.01464 4.01414C3.85363 4.01414 3.70735 4.07461 3.59812 4.17326L3.57734 4.1948C3.46622 4.30592 3.39667 4.46088 3.39667 4.63172C3.39667 4.80255 3.46622 4.95751 3.57734 5.06863C3.6877 5.18013 3.84305 5.2493 4.01464 5.2493C4.18585 5.2493 4.34119 5.18013 4.45268 5.06977Z" fill="white"/>
</svg>
`, __vite_glob_0_38 = `<svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_108_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="1" width="20" height="16">
<path d="M20.7305 11H16.6C16.0399 11 15.7599 11 15.546 11.109C15.3578 11.2049 15.2049 11.3578 15.109 11.546C15 11.7599 15 12.0399 15 12.6V16.7305M13.0118 17H5.8C4.11984 17 3.27976 17 2.63803 16.673C2.07354 16.3854 1.6146 15.9265 1.32698 15.362C1 14.7202 0.999999 13.8802 1 12.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H16.2C17.8802 1 18.7202 1 19.362 1.32698C19.9265 1.6146 20.3854 2.07354 20.673 2.63803C21 3.27976 21 4.11984 21 5.8V9.01178C21 9.74555 21 10.1124 20.9171 10.4577C20.8436 10.7638 20.7224 11.0564 20.5579 11.3249C20.3724 11.6276 20.113 11.887 19.5941 12.4059L16.4059 15.5941C15.887 16.113 15.6276 16.3724 15.3249 16.5579C15.0564 16.7224 14.7638 16.8436 14.4577 16.9171C14.1124 17 13.7455 17 13.0118 17Z" fill="white"/>
</mask>
<g mask="url(#mask0_108_2)">
<path d="M20.7305 10H16.6V12H20.7305V10ZM16.6 10C16.3365 10 16.0787 9.99922 15.8617 10.0169C15.6331 10.0356 15.3634 10.0797 15.092 10.218L16 12C15.9425 12.0293 15.9197 12.0189 16.0246 12.0103C16.1412 12.0008 16.3034 12 16.6 12V10ZM15.092 10.218C14.7156 10.4098 14.4098 10.7156 14.218 11.092L16 12L15.092 10.218ZM14.218 11.092C14.0797 11.3634 14.0356 11.6331 14.0169 11.8617C13.9992 12.0787 14 12.3365 14 12.6H16C16 12.3034 16.0008 12.1412 16.0103 12.0246C16.0189 11.9197 16.0293 11.9425 16 12L14.218 11.092ZM14 12.6V16.7305H16V12.6H14ZM13.0118 16H5.8V18H13.0118V16ZM5.8 16C4.94342 16 4.36113 15.9992 3.91104 15.9624C3.47263 15.9266 3.24844 15.8617 3.09205 15.782L2.18402 17.564C2.66935 17.8113 3.18607 17.9099 3.74817 17.9558C4.29859 18.0008 4.97642 18 5.8 18V16ZM3.09205 15.782C2.71572 15.5902 2.40972 15.2843 2.21799 14.908L0.435956 15.816C0.819463 16.5687 1.43137 17.1806 2.18402 17.564L3.09205 15.782ZM2.21799 14.908C2.13827 14.7516 2.07337 14.5274 2.03755 14.089C2.00078 13.6389 2 13.0566 2 12.2H9.17086e-07C4.26907e-07 13.0236 -0.000777338 13.7014 0.0441942 14.2518C0.0901207 14.8139 0.188687 15.3306 0.435956 15.816L2.21799 14.908ZM2 12.2V5.8H9.17086e-07L9.17086e-07 12.2H2ZM2 5.8C2 4.94342 2.00078 4.36113 2.03755 3.91104C2.07337 3.47262 2.1383 3.24842 2.21799 3.09202L0.435976 2.18404C0.188684 2.66937 0.0901195 3.18608 0.0441945 3.74817C-0.00077679 4.2986 9.17086e-07 4.97642 9.17086e-07 5.8H2ZM2.21799 3.09202C2.40973 2.71569 2.71569 2.40974 3.09202 2.21799L2.18404 0.435974C1.43139 0.819468 0.81947 1.43139 0.435976 2.18404L2.21799 3.09202ZM3.09202 2.21799C3.24842 2.1383 3.47262 2.07337 3.91104 2.03755C4.36113 2.00078 4.94342 2 5.8 2V8.69177e-07C4.97642 8.69177e-07 4.2986 -0.000776842 3.74817 0.0441946C3.18607 0.0901198 2.66937 0.188681 2.18404 0.435974L3.09202 2.21799ZM5.8 2H16.2V1.88246e-06L5.8 8.69177e-07V2ZM16.2 2C17.0566 2 17.6389 2.00078 18.089 2.03755C18.5274 2.07337 18.7516 2.13829 18.908 2.21801L19.816 0.435971C19.3306 0.188702 18.8139 0.0901219 18.2518 0.0441956C17.7014 -0.000775851 17.0236 1.88246e-06 16.2 1.88246e-06V2ZM18.908 2.21801C19.2843 2.40975 19.5902 2.71566 19.782 3.09199L21.564 2.18407C21.1806 1.43142 20.5687 0.819478 19.816 0.435971L18.908 2.21801ZM19.782 3.09199C19.8617 3.24838 19.9266 3.47263 19.9624 3.91104C19.9992 4.36113 20 4.94342 20 5.8H22C22 4.97642 22.0008 4.29859 21.9558 3.74817C21.9099 3.18607 21.8113 2.66941 21.564 2.18407L19.782 3.09199ZM20 5.8V9.01178H22V5.8H20ZM20 9.01178C20 9.79314 19.9936 10.0208 19.9447 10.2243L21.8895 10.6912C22.0064 10.2041 22 9.69796 22 9.01178H20ZM19.9447 10.2243C19.8957 10.4284 19.8149 10.6234 19.7052 10.8025L21.4105 11.8474C21.6298 11.4895 21.7915 11.0993 21.8895 10.6912L19.9447 10.2243ZM19.7052 10.8025C19.5959 10.9808 19.4396 11.1462 18.887 11.6988L20.3012 13.113C20.7864 12.6278 21.1488 12.2745 21.4105 11.8474L19.7052 10.8025ZM18.887 11.6988L15.6988 14.887L17.113 16.3012L20.3012 13.113L18.887 11.6988ZM15.6988 14.887C15.1462 15.4396 14.9807 15.596 14.8024 15.7053L15.8473 17.4106C16.2744 17.1489 16.6278 16.7864 17.113 16.3012L15.6988 14.887ZM14.8024 15.7053C14.6233 15.815 14.4283 15.8957 14.2242 15.9447L14.6911 17.8895C15.0992 17.7915 15.4894 17.6299 15.8473 17.4106L14.8024 15.7053ZM14.2242 15.9447C14.0207 15.9936 13.7931 16 13.0118 16V18C13.6979 18 14.204 18.0064 14.6911 17.8895L14.2242 15.9447Z" fill="black"/>
</g>
</svg>
`, __vite_glob_0_39 = `<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M26.2929 0.292893C26.6834 0.683417 26.6834 1.31658 26.2929 1.70711L1.70711 26.2929C1.31658 26.6834 0.683417 26.6834 0.292893 26.2929C-0.097631 25.9024 -0.097631 25.2692 0.292893 24.8787L24.8787 0.292893C25.2692 -0.097631 25.9024 -0.097631 26.2929 0.292893Z" fill="black"/>
</svg>
`, __vite_glob_0_40 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3579_4896)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6466 2.29223C11.5896 1.38144 12.8526 0.877469 14.1636 0.888861C15.4746 0.900253 16.7286 1.4261 17.6557 2.35314C18.5827 3.28018 19.1085 4.53424 19.1199 5.84522C19.1313 7.15621 18.6274 8.41922 17.7166 9.36223L17.7064 9.37256L15.2065 11.8725C14.6997 12.3795 14.0896 12.7717 13.4179 13.0222C12.7461 13.2728 12.0283 13.376 11.3132 13.3248C10.598 13.2736 9.90226 13.0691 9.27307 12.7254C8.64388 12.3816 8.09597 11.9066 7.66652 11.3325C7.39085 10.9639 7.46613 10.4417 7.83468 10.166C8.20322 9.89033 8.72546 9.96561 9.00113 10.3342C9.28743 10.7169 9.6527 11.0336 10.0722 11.2628C10.4916 11.492 10.9555 11.6282 11.4322 11.6624C11.909 11.6965 12.3875 11.6277 12.8354 11.4607C13.2832 11.2936 13.6899 11.0322 14.0278 10.6942L16.5225 8.19944C17.1267 7.5713 17.4609 6.73141 17.4533 5.85971C17.4457 4.98572 17.0952 4.14968 16.4771 3.53165C15.8591 2.91362 15.0231 2.56306 14.1491 2.55546C13.277 2.54789 12.4368 2.88239 11.8085 3.48709L10.3797 4.90761C10.0533 5.2321 9.52567 5.23056 9.20119 4.90417C8.8767 4.57779 8.87824 4.05015 9.20462 3.72567L10.6466 2.29223ZM6.58312 6.97771C7.25488 6.72712 7.97267 6.62394 8.68781 6.67516C9.40296 6.72637 10.0987 6.93079 10.7279 7.27455C11.3571 7.61831 11.905 8.09336 12.3345 8.66749C12.6101 9.03603 12.5348 9.55827 12.1663 9.83394C11.7978 10.1096 11.2755 10.0343 10.9999 9.66578C10.7136 9.28303 10.3483 8.96633 9.92882 8.73716C9.50936 8.50799 9.04552 8.37171 8.56875 8.33756C8.09199 8.30342 7.61346 8.37221 7.16562 8.53927C6.71778 8.70632 6.31111 8.96774 5.97319 9.30579L3.4785 11.8005C2.87429 12.4286 2.54008 13.2685 2.54765 14.1402C2.55525 15.0142 2.90581 15.8503 3.52384 16.4683C4.14186 17.0863 4.97791 17.4369 5.85189 17.4445C6.72359 17.4521 7.56348 17.1178 8.19162 16.5137L9.61124 15.094C9.93667 14.7686 10.4643 14.7686 10.7897 15.094C11.1152 15.4195 11.1152 15.9471 10.7897 16.2726L9.36475 17.6976L9.35442 17.7077C8.41141 18.6185 7.1484 19.1225 5.83741 19.1111C4.52643 19.0997 3.27237 18.5738 2.34533 17.6468C1.41829 16.7198 0.892441 15.4657 0.881048 14.1547C0.869656 12.8437 1.37363 11.5807 2.28442 10.6377L2.29457 10.6274L4.79446 8.12749C5.30133 7.62047 5.91141 7.22827 6.58312 6.97771Z" fill="#7F8184"/>
</g>
<defs>
<clipPath id="clip0_3579_4896">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_41 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.99975 3C4.55232 3 4.99982 3.44787 4.99982 4.00006V7.1794C4.99982 7.63257 4.63244 8.00032 4.17889 8.00032C3.72573 8.00032 3.35799 7.63257 3.35799 7.1794V4.25027H3.32283L2.74721 4.53487C2.46035 4.6766 2.13266 4.52655 2.03137 4.25027C2.01096 4.19509 2 4.13462 2 4.07074C2 3.87534 2.10998 3.69657 2.28422 3.60851L3.27522 3.10772C3.2911 3.09978 3.30658 3.09222 3.32283 3.08542C3.33436 3.08021 3.34588 3.07538 3.3574 3.07055C3.42241 3.04523 3.48989 3.02608 3.5583 3.01437C3.61348 3.00492 3.6698 3 3.72649 3H3.99975Z" fill="black"/>
<path d="M8.99969 5.00024C8.4475 5.00024 8 5.44813 8 6.00031C8 6.5525 8.4475 7.00038 8.99969 7.00038H20.9997C21.5519 7.00038 21.9994 6.5525 21.9994 6.00031C21.9994 5.44813 21.5519 5.00024 20.9997 5.00024H8.99969Z" fill="black"/>
<path d="M8.99969 11.0002C8.4475 11.0002 8 11.4481 8 12.0003C8 12.5525 8.4475 13.0004 8.99969 13.0004H20.9997C21.5519 13.0004 21.9994 12.5525 21.9994 12.0003C21.9994 11.4481 21.5519 11.0002 20.9997 11.0002H8.99969Z" fill="black"/>
<path d="M8.99969 16.9999C8.4475 16.9999 8 17.4477 8 17.9999C8 18.5521 8.4475 19 8.99969 19H20.9997C21.5519 19 21.9994 18.5521 21.9994 17.9999C21.9994 17.4477 21.5519 16.9999 20.9997 16.9999H8.99969Z" fill="black"/>
<path d="M3.86768 21.0001C3.48444 21.0001 3.1439 20.9343 2.84645 20.8028C2.55014 20.6697 2.31732 20.4864 2.14799 20.2536C2.11133 20.203 2.07844 20.1508 2.04934 20.0971C1.87434 19.7702 2.19297 19.4505 2.56374 19.4505H2.95114C3.10119 19.4505 3.2176 19.582 3.30717 19.7026C3.36424 19.7751 3.44173 19.8322 3.54 19.8734C3.63789 19.9146 3.75051 19.9354 3.87713 19.9354C3.99921 19.9354 4.10692 19.9138 4.20027 19.8711C4.29362 19.8265 4.36658 19.7657 4.41874 19.6882C4.47089 19.6103 4.49621 19.5219 4.4947 19.4221C4.49621 19.3239 4.46635 19.2365 4.40436 19.1606C4.34427 19.0846 4.25962 19.0253 4.15039 18.9822C4.04116 18.9395 3.91529 18.9183 3.7728 18.9183H3.73501C3.48291 18.9183 3.27844 18.7138 3.27844 18.4617C3.27844 18.21 3.48291 18.0056 3.73501 18.0056H3.7728C3.90395 18.0056 4.0196 17.984 4.11938 17.9413C4.22067 17.8986 4.2993 17.8393 4.35448 17.7633C4.41155 17.6873 4.43915 17.6 4.43763 17.5017C4.43915 17.4065 4.41646 17.323 4.36884 17.25C4.32121 17.1771 4.2547 17.12 4.16928 17.0788C4.08538 17.0376 3.98787 17.0168 3.87713 17.0168C3.75694 17.0168 3.64921 17.0384 3.55397 17.0811C3.46061 17.1238 3.38692 17.1835 3.33325 17.2595C3.24405 17.3857 3.12614 17.5206 2.97155 17.5206H2.62496C2.27308 17.5206 1.96998 17.2187 2.12758 16.9038C2.15744 16.8445 2.19183 16.787 2.23113 16.7319C2.39403 16.5036 2.61741 16.3248 2.90087 16.1948C3.18434 16.0648 3.50976 15.9998 3.87713 15.9998C4.23656 15.9998 4.55403 16.061 4.82956 16.1831C5.1066 16.3048 5.32279 16.473 5.47813 16.6865C5.63498 16.8989 5.71247 17.1423 5.71096 17.4163C5.71398 17.6888 5.62063 17.9122 5.43052 18.0864C5.2423 18.2607 5.00304 18.3639 4.71315 18.3952V18.4334C5.10584 18.4761 5.40141 18.5967 5.59908 18.7947C5.79713 18.9909 5.89464 19.2381 5.89124 19.5359C5.89313 19.8212 5.80732 20.0737 5.63498 20.2941C5.46376 20.5144 5.22566 20.6871 4.91989 20.8122C4.61602 20.9373 4.26529 21.0001 3.86768 21.0001Z" fill="black"/>
<path d="M5.89425 13.8045C5.82584 13.5876 5.62364 13.4303 5.38402 13.4303H4.01962L4.41005 13.0161C4.47468 12.9643 4.53704 12.9133 4.59676 12.8634C4.71959 12.7606 4.83221 12.6631 4.93426 12.5705C4.95673 12.5502 4.97853 12.5302 4.99998 12.5105L5.00381 12.507L5.01099 12.5002C5.12362 12.3955 5.22188 12.298 5.30579 12.2073C5.333 12.1782 5.35907 12.1491 5.38402 12.1207C5.39611 12.1067 5.40783 12.0931 5.41917 12.0795C5.4426 12.0523 5.46454 12.0255 5.4857 11.9986L5.49591 11.9858C5.60665 11.8444 5.68903 11.7118 5.7427 11.5882C5.76084 11.5466 5.77672 11.505 5.7907 11.4631C5.82699 11.355 5.84966 11.2465 5.85911 11.1381C5.86251 11.0995 5.86441 11.0609 5.86441 11.0224C5.86441 10.7155 5.78239 10.4483 5.61874 10.2204C5.59758 10.1909 5.57564 10.1622 5.55221 10.1346L5.54088 10.121C5.38554 9.94032 5.18068 9.79669 4.92632 9.69049C4.85791 9.66139 4.78686 9.63568 4.71278 9.61301L4.69879 9.60886C4.4535 9.53629 4.17685 9.5 3.8692 9.5C3.73464 9.5 3.60575 9.50794 3.48292 9.52382C3.32267 9.5446 3.17224 9.57862 3.03202 9.62586L3.02484 9.62851C2.97003 9.64741 2.91637 9.66819 2.86459 9.69125L2.83927 9.70259C2.74403 9.74643 2.65559 9.7967 2.57395 9.85301C2.42731 9.9543 2.30333 10.0756 2.20242 10.217C2.18768 10.2378 2.17332 10.2589 2.15972 10.2805C2.10831 10.3602 2.06521 10.4453 2.03044 10.5348C1.9745 10.6785 1.99945 10.816 2.07429 10.9268C2.16613 11.0632 2.33357 11.1585 2.5199 11.1743C2.53766 11.1758 2.55581 11.1766 2.57395 11.1766H2.86459C2.92204 11.1766 2.97458 11.1622 3.02295 11.1381C3.06529 11.1165 3.10459 11.0874 3.14049 11.053L3.14125 11.0523C3.16166 11.0326 3.18094 11.0114 3.19946 10.9891C3.20701 10.9797 3.2142 10.9706 3.22138 10.9608C3.24443 10.9306 3.26561 10.8984 3.28488 10.8659L3.29394 10.8504C3.29886 10.8421 3.30377 10.8334 3.3083 10.8247C3.31038 10.8213 3.31237 10.8178 3.31436 10.8143C3.31634 10.8108 3.31833 10.8073 3.32041 10.8039C3.32532 10.7956 3.3306 10.7877 3.33589 10.7801C3.38616 10.7053 3.45117 10.6475 3.53168 10.6055C3.62919 10.556 3.74183 10.5311 3.8692 10.5311C3.91228 10.5311 3.95385 10.5337 3.99391 10.5394C4.07139 10.5507 4.14207 10.5726 4.2067 10.6055C4.30421 10.6539 4.38056 10.7227 4.43498 10.8126L4.44292 10.8255L4.44784 10.8346C4.47695 10.8867 4.49735 10.9453 4.50869 11.0095L4.50981 11.0167L4.51096 11.0224C4.51247 11.0326 4.51398 11.0432 4.51511 11.0541L4.51548 11.0587C4.51813 11.0844 4.51926 11.1108 4.51926 11.1381C4.51926 11.2412 4.49961 11.3357 4.4603 11.4223C4.42062 11.5088 2.26175 13.3408 2.26175 13.3408C2.23492 13.3623 2.20998 13.3857 2.18731 13.4111C2.07921 13.5297 2.01798 13.6855 2.01798 13.8487C2.01798 14.2082 2.30976 14.4999 2.6692 14.4999H5.38402C5.45318 14.4999 5.51934 14.4867 5.58019 14.4625C5.60551 14.4527 5.6297 14.441 5.65275 14.4274C5.81187 14.3348 5.91883 14.1624 5.91883 13.9651C5.91883 13.9092 5.91013 13.8552 5.89425 13.8045Z" fill="black"/>
</svg>
`, __vite_glob_0_42 = `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.06592 13.75C5.03242 13.75 5.81592 12.9665 5.81592 12C5.81592 11.0335 5.03242 10.25 4.06592 10.25C3.09942 10.25 2.31592 11.0335 2.31592 12C2.31592 12.9665 3.09942 13.75 4.06592 13.75Z" fill="#2D2D2D"/>
<path d="M21.5659 13.75C22.5324 13.75 23.3159 12.9665 23.3159 12C23.3159 11.0335 22.5324 10.25 21.5659 10.25C20.5994 10.25 19.8159 11.0335 19.8159 12C19.8159 12.9665 20.5994 13.75 21.5659 13.75Z" fill="#D9D9D9"/>
<path d="M12.8159 5C13.7824 5 14.5659 4.2165 14.5659 3.25C14.5659 2.2835 13.7824 1.5 12.8159 1.5C11.8494 1.5 11.0659 2.2835 11.0659 3.25C11.0659 4.2165 11.8494 5 12.8159 5Z" fill="#D9D9D9"/>
<path d="M12.8159 22.5C13.7824 22.5 14.5659 21.7165 14.5659 20.75C14.5659 19.7835 13.7824 19 12.8159 19C11.8494 19 11.0659 19.7835 11.0659 20.75C11.0659 21.7165 11.8494 22.5 12.8159 22.5Z" fill="#D9D9D9"/>
<path d="M17.7655 7.0502C18.4489 7.73362 19.5569 7.73362 20.2404 7.0502C20.9238 6.36678 20.9238 5.25875 20.2404 4.57533C19.5569 3.89191 18.4489 3.89191 17.7655 4.57533C17.0821 5.25875 17.0821 6.36678 17.7655 7.0502Z" fill="#D9D9D9"/>
<path d="M5.39147 19.4247C6.07489 20.1081 7.18293 20.1081 7.86634 19.4247C8.54976 18.7413 8.54976 17.6333 7.86634 16.9498C7.18293 16.2664 6.07489 16.2664 5.39147 16.9498C4.70805 17.6333 4.70805 18.7413 5.39147 19.4247Z" fill="#D9D9D9"/>
<path d="M17.7657 16.9499C17.0823 17.6333 17.0823 18.7413 17.7657 19.4248C18.4491 20.1082 19.5572 20.1082 20.2406 19.4248C20.924 18.7413 20.924 17.6333 20.2406 16.9499C19.5572 16.2665 18.4491 16.2665 17.7657 16.9499Z" fill="#D9D9D9"/>
<path d="M5.39121 4.57531C4.70779 5.25872 4.70779 6.36676 5.39121 7.05018C6.07462 7.7336 7.18266 7.7336 7.86608 7.05018C8.5495 6.36676 8.5495 5.25872 7.86608 4.57531C7.18266 3.89189 6.07462 3.89189 5.39121 4.57531Z" fill="#D9D9D9"/>
</svg>
`, __vite_glob_0_43 = `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.05948 2L16.5421 2C17.3471 1.99999 18.0114 1.99998 18.5526 2.0442C19.1147 2.09012 19.6314 2.18868 20.1167 2.43598C20.8694 2.81947 21.4813 3.43139 21.8648 4.18404C22.1121 4.66937 22.2107 5.18608 22.2566 5.74818C22.3008 6.28937 22.3008 6.95372 22.3008 7.75868V16.2413C22.3008 17.0463 22.3008 17.7106 22.2566 18.2518C22.2107 18.8139 22.1121 19.3306 21.8648 19.816C21.4813 20.5686 20.8694 21.1805 20.1167 21.564C19.6314 21.8113 19.1147 21.9099 18.5526 21.9558C18.0114 22 17.3471 22 16.5421 22H8.05946C7.2545 22 6.59015 22 6.04896 21.9558C5.48686 21.9099 4.97016 21.8113 4.48482 21.564C3.73217 21.1805 3.12025 20.5686 2.73676 19.816C2.48947 19.3306 2.3909 18.8139 2.34498 18.2518C2.30076 17.7106 2.30077 17.0463 2.30078 16.2413L2.30078 7.7587C2.30077 6.95373 2.30076 6.28937 2.34498 5.74817C2.3909 5.18608 2.48947 4.66937 2.73676 4.18404C3.12025 3.43139 3.73217 2.81947 4.48482 2.43597C4.97016 2.18868 5.48686 2.09012 6.04896 2.04419C6.59015 1.99998 7.25451 1.99999 8.05948 2ZM20.3008 11V7.8C20.3008 6.94342 20.3 6.36113 20.2632 5.91104C20.2274 5.47262 20.1625 5.24842 20.0828 5.09202C19.891 4.7157 19.5851 4.40973 19.2088 4.21799C19.0524 4.1383 18.8282 4.07337 18.3897 4.03755C17.9397 4.00078 17.3574 4 16.5008 4L8.10078 4C7.2442 4 6.66191 4.00078 6.21182 4.03755C5.77341 4.07337 5.5492 4.1383 5.3928 4.21799C5.01648 4.40973 4.71052 4.7157 4.51877 5.09202C4.43908 5.24842 4.37415 5.47262 4.33833 5.91104C4.30156 6.36113 4.30078 6.94342 4.30078 7.8V11H20.3008ZM20.3008 13H13.3008L13.3008 20H16.5008C17.3574 20 17.9397 19.9992 18.3897 19.9624C18.8282 19.9266 19.0524 19.8617 19.2088 19.782C19.5851 19.5903 19.891 19.2843 20.0828 18.908C20.1625 18.7516 20.2274 18.5274 20.2632 18.089C20.3 17.6389 20.3008 17.0566 20.3008 16.2V13ZM11.3008 20L11.3008 13H4.30078V16.2C4.30078 17.0566 4.30156 17.6389 4.33833 18.089C4.37415 18.5274 4.43908 18.7516 4.51877 18.908C4.71052 19.2843 5.01648 19.5903 5.3928 19.782C5.5492 19.8617 5.7734 19.9266 6.21182 19.9624C6.66191 19.9992 7.2442 20 8.10078 20H11.3008Z" fill="black"/>
</svg>
`, __vite_glob_0_44 = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.0001 1.75C13.0336 1.75 12.2501 2.53349 12.2501 3.5C12.2501 4.4665 13.0336 5.24999 14.0001 5.24999C14.9666 5.24999 15.7501 4.46648 15.7501 3.5C15.7501 2.53351 14.9666 1.75 14.0001 1.75ZM10.5001 3.5C10.5001 1.56701 12.067 0 14.0001 0C15.933 0 17.5001 1.56699 17.5001 3.5C17.5001 5.433 15.933 6.99999 14.0001 6.99999C12.067 6.99999 10.5001 5.43298 10.5001 3.5ZM24.4999 1.75C23.5334 1.75 22.7499 2.53351 22.7499 3.5C22.7499 4.46648 23.5334 5.24999 24.4999 5.24999C25.4664 5.24999 26.2499 4.4665 26.2499 3.5C26.2499 2.53349 25.4664 1.75 24.4999 1.75ZM20.9999 3.5C20.9999 1.56699 22.567 0 24.4999 0C26.433 0 27.9999 1.56701 27.9999 3.5C27.9999 5.43298 26.433 6.99999 24.4999 6.99999C22.567 6.99999 20.9999 5.433 20.9999 3.5ZM3.50003 1.75001C2.53354 1.75001 1.75004 2.53351 1.75004 3.5C1.75004 4.4665 2.53354 5.25 3.50003 5.25C4.46653 5.25 5.25003 4.4665 5.25003 3.5C5.25003 2.53351 4.46653 1.75001 3.50003 1.75001ZM3.60012e-05 3.5C3.60012e-05 1.56701 1.56704 6.02007e-06 3.50003 6.02007e-06C5.43303 6.02007e-06 7.00003 1.56701 7.00003 3.5C7.00003 5.433 5.43303 7 3.50003 7C1.56704 7 3.60012e-05 5.433 3.60012e-05 3.5ZM3.5 12.25C2.53349 12.25 1.75 13.0335 1.75 14C1.75 14.9665 2.53351 15.75 3.5 15.75C4.46648 15.75 5.24999 14.9665 5.24999 14C5.24999 13.0335 4.4665 12.25 3.5 12.25ZM0 14C0 12.0669 1.56701 10.5 3.5 10.5C5.43298 10.5 6.99999 12.0669 6.99999 14C6.99999 15.9329 5.433 17.5 3.5 17.5C1.56699 17.5 0 15.9329 0 14ZM14.0001 12.25C13.0335 12.25 12.2501 13.0335 12.2501 13.9999C12.2501 14.9665 13.0336 15.7499 14.0001 15.7499C14.9666 15.7499 15.7501 14.9664 15.7501 13.9999C15.7501 13.0335 14.9666 12.25 14.0001 12.25ZM10.5001 13.9999C10.5001 12.0669 12.0671 10.5 14.0001 10.5C15.933 10.5 17.5001 12.0669 17.5001 13.9999C17.5001 15.933 15.933 17.4999 14.0001 17.4999C12.0671 17.4999 10.5001 15.933 10.5001 13.9999ZM24.4999 12.25C23.5333 12.25 22.7499 13.0335 22.7499 13.9999C22.7499 14.9665 23.5334 15.7499 24.4999 15.7499C25.4664 15.7499 26.2499 14.9664 26.2499 13.9999C26.2499 13.0335 25.4664 12.25 24.4999 12.25ZM20.9999 13.9999C20.9999 12.0669 22.5669 10.5 24.4999 10.5C26.4328 10.5 27.9999 12.0669 27.9999 13.9999C27.9999 15.933 26.4328 17.4999 24.4999 17.4999C22.5669 17.4999 20.9999 15.933 20.9999 13.9999ZM14.0001 22.7499C13.0336 22.7499 12.2501 23.5334 12.2501 24.4999C12.2501 25.4665 13.0336 26.2499 14.0001 26.2499C14.9666 26.2499 15.7501 25.4664 15.7501 24.4999C15.7501 23.5335 14.9666 22.7499 14.0001 22.7499ZM10.5001 24.4999C10.5001 22.567 12.067 20.9999 14.0001 20.9999C15.9331 20.9999 17.5001 22.567 17.5001 24.4999C17.5001 26.433 15.933 27.9999 14.0001 27.9999C12.0671 27.9999 10.5001 26.433 10.5001 24.4999ZM24.4999 22.7499C23.5334 22.7499 22.7499 23.5334 22.7499 24.4999C22.7499 25.4665 23.5334 26.2499 24.4999 26.2499C25.4664 26.2499 26.2499 25.4664 26.2499 24.4999C26.2499 23.5335 25.4664 22.7499 24.4999 22.7499ZM20.9999 24.4999C20.9999 22.567 22.5668 20.9999 24.4999 20.9999C26.4329 20.9999 27.9999 22.567 27.9999 24.4999C27.9999 26.433 26.4328 27.9999 24.4999 27.9999C22.5669 27.9999 20.9999 26.433 20.9999 24.4999ZM3.5 22.75C2.53349 22.75 1.75 23.5335 1.75 24.5C1.75 25.4665 2.53351 26.25 3.5 26.25C4.46648 26.25 5.24999 25.4665 5.24999 24.5C5.24999 23.5335 4.4665 22.75 3.5 22.75ZM0 24.5C0 22.5669 1.56701 21 3.5 21C5.43298 21 6.99999 22.5669 6.99999 24.5C6.99999 26.4329 5.433 28 3.5 28C1.56699 28 0 26.4329 0 24.5Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_45 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8029 3.02004L11.8029 3.02005L11.8029 3.02004ZM12.0002 3.11759L4.23628 6.99958L12.0002 10.8816L19.7642 6.99958L12.0002 3.11759ZM11.8029 10.9791C11.8027 10.9792 11.8027 10.9792 11.8029 10.9791L11.8029 10.9791ZM12.1976 10.9791C12.1978 10.9792 12.1978 10.9792 12.1976 10.9791L12.1976 10.9791ZM12.1975 3.02005L12.1975 3.02004L12.1975 3.02005ZM12.2768 1.08432C12.0941 1.05002 11.9064 1.05002 11.7236 1.08432H12.2768ZM12.2769 1.08433C12.4933 1.12494 12.6863 1.22341 12.7796 1.27103C12.7892 1.27593 12.7978 1.2803 12.8052 1.284L12.8052 1.28403L22.4474 6.10515C22.7862 6.27454 23.0002 6.6208 23.0002 6.99958C23.0002 7.37835 22.7862 7.72461 22.4474 7.894L12.8052 12.7151C12.7978 12.7188 12.7893 12.7232 12.7797 12.7281C12.6864 12.7757 12.4932 12.8743 12.2767 12.9149L12.2764 12.9149C12.0939 12.9491 11.9065 12.9491 11.724 12.9149L11.7237 12.9149C11.5072 12.8743 11.3141 12.7757 11.2208 12.7281C11.2112 12.7232 11.2026 12.7188 11.1952 12.7151L1.553 7.894C1.21422 7.72461 1.00022 7.37835 1.00022 6.99958C1.00022 6.6208 1.21422 6.27454 1.553 6.10515L11.1952 1.28403L11.1953 1.284C11.2027 1.2803 11.2112 1.27593 11.2208 1.27103C11.3142 1.22341 11.5072 1.12494 11.7236 1.08433M1.10579 11.5524C1.35278 11.0584 1.95345 10.8582 2.44743 11.1052L12.0002 15.8816L21.553 11.1052C22.047 10.8582 22.6477 11.0584 22.8946 11.5524C23.1416 12.0464 22.9414 12.647 22.4474 12.894L12.8052 17.7151C12.7978 17.7188 12.7893 17.7232 12.7797 17.7281C12.6864 17.7757 12.4932 17.8743 12.2767 17.9149L12.2764 17.9149C12.0939 17.9491 11.9065 17.9491 11.724 17.9149L11.7237 17.9149C11.5072 17.8743 11.3141 17.7757 11.2208 17.7281C11.2112 17.7232 11.2026 17.7188 11.1952 17.7151L1.55301 12.894C1.05903 12.647 0.858803 12.0464 1.10579 11.5524ZM11.8029 15.9791C11.8027 15.9792 11.8027 15.9792 11.8029 15.9791L11.8029 15.9791ZM12.1976 15.9791C12.1978 15.9792 12.1978 15.9792 12.1976 15.9791L12.1976 15.9791ZM1.10579 16.5524C1.35278 16.0584 1.95345 15.8582 2.44743 16.1052L12.0002 20.8816L21.553 16.1052C22.047 15.8582 22.6477 16.0584 22.8946 16.5524C23.1416 17.0464 22.9414 17.647 22.4474 17.894L12.8052 22.7151C12.7978 22.7188 12.7893 22.7232 12.7797 22.7281C12.6864 22.7757 12.4932 22.8743 12.2767 22.9149L12.2764 22.9149C12.0939 22.9491 11.9065 22.9491 11.724 22.9149L11.7237 22.9149C11.5072 22.8743 11.3141 22.7757 11.2208 22.7281C11.2112 22.7232 11.2026 22.7188 11.1952 22.7151L1.55301 17.894C1.05903 17.647 0.858803 17.0464 1.10579 16.5524ZM11.8029 20.9791C11.8027 20.9792 11.8027 20.9792 11.8029 20.9791L11.8029 20.9791ZM12.1975 20.9791C12.1978 20.9792 12.1978 20.9792 12.1976 20.9791L12.1975 20.9791Z" fill="#0075FF"/>
<path d="M11.6422 2.17846L2 6.99958L11.6422 11.8207C11.7734 11.8863 11.839 11.9191 11.9078 11.932C11.9687 11.9434 12.0313 11.9434 12.0922 11.932C12.161 11.9191 12.2266 11.8863 12.3578 11.8207L22 6.99958L12.3578 2.17846C12.2266 2.11287 12.161 2.08008 12.0922 2.06717C12.0313 2.05574 11.9687 2.05574 11.9078 2.06717C11.839 2.08008 11.7734 2.11287 11.6422 2.17846Z" fill="#272727"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8029 3.02004L11.8029 3.02005L11.8029 3.02004ZM12.0002 3.11759L4.23628 6.99958L12.0002 10.8816L19.7642 6.99958L12.0002 3.11759ZM11.8029 10.9791C11.8027 10.9792 11.8027 10.9792 11.8029 10.9791L11.8029 10.9791ZM12.1976 10.9791C12.1978 10.9792 12.1978 10.9792 12.1976 10.9791L12.1976 10.9791ZM12.1975 3.02005L12.1975 3.02004L12.1975 3.02005ZM12.2768 1.08432C12.0941 1.05002 11.9064 1.05002 11.7236 1.08432H12.2768ZM12.2769 1.08433C12.4933 1.12494 12.6863 1.22341 12.7796 1.27103C12.7892 1.27593 12.7978 1.2803 12.8052 1.284L12.8052 1.28403L22.4474 6.10515C22.7862 6.27454 23.0002 6.6208 23.0002 6.99958C23.0002 7.37835 22.7862 7.72461 22.4474 7.894L12.8052 12.7151C12.7978 12.7188 12.7893 12.7232 12.7797 12.7281C12.6864 12.7757 12.4932 12.8743 12.2767 12.9149L12.2764 12.9149C12.0939 12.9491 11.9065 12.9491 11.724 12.9149L11.7237 12.9149C11.5072 12.8743 11.3141 12.7757 11.2208 12.7281C11.2112 12.7232 11.2026 12.7188 11.1952 12.7151L1.553 7.894C1.21422 7.72461 1.00022 7.37835 1.00022 6.99958C1.00022 6.6208 1.21422 6.27454 1.553 6.10515L11.1952 1.28403L11.1953 1.284C11.2027 1.2803 11.2112 1.27593 11.2208 1.27103C11.3142 1.22341 11.5072 1.12494 11.7236 1.08433M1.10579 11.5524C1.35278 11.0584 1.95345 10.8582 2.44743 11.1052L12.0002 15.8816L21.553 11.1052C22.047 10.8582 22.6477 11.0584 22.8946 11.5524C23.1416 12.0464 22.9414 12.647 22.4474 12.894L12.8052 17.7151C12.7978 17.7188 12.7893 17.7232 12.7797 17.7281C12.6864 17.7757 12.4932 17.8743 12.2767 17.9149L12.2764 17.9149C12.0939 17.9491 11.9065 17.9491 11.724 17.9149L11.7237 17.9149C11.5072 17.8743 11.3141 17.7757 11.2208 17.7281C11.2112 17.7232 11.2026 17.7188 11.1952 17.7151L1.55301 12.894C1.05903 12.647 0.858803 12.0464 1.10579 11.5524ZM11.8029 15.9791C11.8027 15.9792 11.8027 15.9792 11.8029 15.9791L11.8029 15.9791ZM12.1976 15.9791C12.1978 15.9792 12.1978 15.9792 12.1976 15.9791L12.1976 15.9791Z" fill="#272727"/>
</svg>
`, __vite_glob_0_46 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8029 3.02004L11.8029 3.02005L11.8029 3.02004ZM12.0002 3.11759L4.23628 6.99958L12.0002 10.8816L19.7642 6.99958L12.0002 3.11759ZM11.8029 10.9791C11.8027 10.9792 11.8027 10.9792 11.8029 10.9791L11.8029 10.9791ZM12.1976 10.9791C12.1978 10.9792 12.1978 10.9792 12.1976 10.9791L12.1976 10.9791ZM12.1975 3.02005L12.1975 3.02004L12.1975 3.02005ZM12.2768 1.08432C12.0941 1.05002 11.9064 1.05002 11.7236 1.08432H12.2768ZM12.2769 1.08433C12.4933 1.12494 12.6863 1.22341 12.7796 1.27103C12.7892 1.27593 12.7978 1.2803 12.8052 1.284L12.8052 1.28403L22.4474 6.10515C22.7862 6.27454 23.0002 6.6208 23.0002 6.99958C23.0002 7.37835 22.7862 7.72461 22.4474 7.894L12.8052 12.7151C12.7978 12.7188 12.7893 12.7232 12.7797 12.7281C12.6864 12.7757 12.4932 12.8743 12.2767 12.9149L12.2764 12.9149C12.0939 12.9491 11.9065 12.9491 11.724 12.9149L11.7237 12.9149C11.5072 12.8743 11.3141 12.7757 11.2208 12.7281C11.2112 12.7232 11.2026 12.7188 11.1952 12.7151L1.553 7.894C1.21422 7.72461 1.00022 7.37835 1.00022 6.99958C1.00022 6.6208 1.21422 6.27454 1.553 6.10515L11.1952 1.28403L11.1953 1.284C11.2027 1.2803 11.2112 1.27593 11.2208 1.27103C11.3142 1.22341 11.5072 1.12494 11.7236 1.08433M1.10579 11.5524C1.35278 11.0584 1.95345 10.8582 2.44743 11.1052L12.0002 15.8816L21.553 11.1052C22.047 10.8582 22.6477 11.0584 22.8946 11.5524C23.1416 12.0464 22.9414 12.647 22.4474 12.894L12.8052 17.7151C12.7978 17.7188 12.7893 17.7232 12.7797 17.7281C12.6864 17.7757 12.4932 17.8743 12.2767 17.9149L12.2764 17.9149C12.0939 17.9491 11.9065 17.9491 11.724 17.9149L11.7237 17.9149C11.5072 17.8743 11.3141 17.7757 11.2208 17.7281C11.2112 17.7232 11.2026 17.7188 11.1952 17.7151L1.55301 12.894C1.05903 12.647 0.858803 12.0464 1.10579 11.5524ZM11.8029 15.9791C11.8027 15.9792 11.8027 15.9792 11.8029 15.9791L11.8029 15.9791ZM12.1976 15.9791C12.1978 15.9792 12.1978 15.9792 12.1976 15.9791L12.1976 15.9791ZM1.10579 16.5524C1.35278 16.0584 1.95345 15.8582 2.44743 16.1052L12.0002 20.8816L21.553 16.1052C22.047 15.8582 22.6477 16.0584 22.8946 16.5524C23.1416 17.0464 22.9414 17.647 22.4474 17.894L12.8052 22.7151C12.7978 22.7188 12.7893 22.7232 12.7797 22.7281C12.6864 22.7757 12.4932 22.8743 12.2767 22.9149L12.2764 22.9149C12.0939 22.9491 11.9065 22.9491 11.724 22.9149L11.7237 22.9149C11.5072 22.8743 11.3141 22.7757 11.2208 22.7281C11.2112 22.7232 11.2026 22.7188 11.1952 22.7151L1.55301 17.894C1.05903 17.647 0.858803 17.0464 1.10579 16.5524ZM11.8029 20.9791C11.8027 20.9792 11.8027 20.9792 11.8029 20.9791L11.8029 20.9791ZM12.1975 20.9791C12.1978 20.9792 12.1978 20.9792 12.1976 20.9791L12.1975 20.9791Z" fill="black"/>
<path d="M12.3578 2.17846C12.2266 2.11287 12.161 2.08008 12.0922 2.06717C12.0313 2.05574 11.9687 2.05574 11.9078 2.06717C11.839 2.08008 11.7734 2.11287 11.6422 2.17846L2 6.99958L11.6422 11.8207C11.7734 11.8863 11.839 11.9191 11.9078 11.932C11.9687 11.9434 12.0313 11.9434 12.0922 11.932C12.161 11.9191 12.2266 11.8863 12.3578 11.8207L22 6.99958L12.3578 2.17846Z" fill="#0075FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.2766 1.08432C12.0938 1.05002 11.9062 1.05002 11.7234 1.08432H12.2766ZM11.7233 1.08433C11.507 1.12494 11.3139 1.22341 11.2206 1.27103C11.211 1.27593 11.2025 1.2803 11.195 1.284L11.195 1.28403L1.55278 6.10515C1.214 6.27454 1 6.6208 1 6.99958C1 7.37835 1.214 7.72461 1.55278 7.894L11.195 12.7151C11.2024 12.7188 11.2109 12.7232 11.2206 12.7281C11.3139 12.7757 11.507 12.8743 11.7235 12.9149L11.7238 12.9149C11.9063 12.9491 12.0937 12.9491 12.2762 12.9149L12.2765 12.9149C12.493 12.8743 12.6861 12.7757 12.7794 12.7281C12.7891 12.7232 12.7976 12.7188 12.805 12.7151L22.4472 7.894C22.786 7.72461 23 7.37835 23 6.99958C23 6.6208 22.786 6.27454 22.4472 6.10515L12.805 1.28403L12.805 1.284C12.7975 1.2803 12.789 1.27593 12.7794 1.27103C12.6861 1.22341 12.493 1.12494 12.2767 1.08433M11.8027 3.02004L11.8027 3.02005L11.8027 3.02004ZM12 3.11759L4.23606 6.99958L12 10.8816L19.7639 6.99958L12 3.11759ZM11.8026 10.9791C11.8024 10.9792 11.8024 10.9792 11.8027 10.9791L11.8026 10.9791ZM12.1973 10.9791C12.1976 10.9792 12.1976 10.9792 12.1974 10.9791L12.1973 10.9791ZM12.1973 3.02005L12.1973 3.02004L12.1973 3.02005Z" fill="#0075FF"/>
</svg>
`, __vite_glob_0_47 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8029 5.52004L11.8029 5.52005L11.8029 5.52004ZM12.0002 5.61759L4.23628 9.49958L12.0002 13.3816L19.7642 9.49958L12.0002 5.61759ZM11.8029 13.4791C11.8027 13.4792 11.8027 13.4792 11.8029 13.4791L11.8029 13.4791ZM12.1976 13.4791C12.1978 13.4792 12.1978 13.4792 12.1976 13.4791L12.1976 13.4791ZM12.1975 5.52005L12.1975 5.52004L12.1975 5.52005ZM12.2768 3.58432C12.0941 3.55002 11.9064 3.55002 11.7236 3.58432H12.2768ZM12.2769 3.58433C12.4933 3.62494 12.6863 3.72341 12.7796 3.77103C12.7892 3.77593 12.7978 3.7803 12.8052 3.784L12.8052 3.78403L22.4474 8.60515C22.7862 8.77454 23.0002 9.12081 23.0002 9.49958C23.0002 9.87835 22.7862 10.2246 22.4474 10.394L12.8052 15.2151C12.7978 15.2188 12.7893 15.2232 12.7797 15.2281C12.6864 15.2757 12.4932 15.3743 12.2767 15.4149L12.2764 15.4149C12.0939 15.4491 11.9065 15.4491 11.724 15.4149L11.7237 15.4149C11.5072 15.3743 11.3141 15.2757 11.2208 15.2281C11.2112 15.2232 11.2026 15.2188 11.1952 15.2151L1.553 10.394C1.21422 10.2246 1.00022 9.87835 1.00022 9.49958C1.00022 9.12081 1.21422 8.77454 1.553 8.60515L11.1952 3.78403L11.1953 3.784C11.2027 3.7803 11.2112 3.77593 11.2208 3.77103C11.3142 3.72341 11.5072 3.62494 11.7236 3.58433M1.10579 14.0524C1.35278 13.5584 1.95345 13.3582 2.44743 13.6052L12.0002 18.3816L21.553 13.6052C22.047 13.3582 22.6477 13.5584 22.8946 14.0524C23.1416 14.5464 22.9414 15.147 22.4474 15.394L12.8052 20.2151C12.7978 20.2188 12.7893 20.2232 12.7797 20.2281C12.6864 20.2757 12.4932 20.3743 12.2767 20.4149L12.2764 20.4149C12.0939 20.4491 11.9065 20.4491 11.724 20.4149L11.7237 20.4149C11.5072 20.3743 11.3141 20.2757 11.2208 20.2281C11.2112 20.2232 11.2026 20.2188 11.1952 20.2151L1.55301 15.394C1.05903 15.147 0.858803 14.5464 1.10579 14.0524ZM11.8029 18.4791C11.8027 18.4792 11.8027 18.4792 11.8029 18.4791L11.8029 18.4791ZM12.1976 18.4791C12.1978 18.4792 12.1978 18.4792 12.1976 18.4791L12.1976 18.4791Z" fill="#272727"/>
<path d="M12.3578 4.67846C12.2266 4.61287 12.161 4.58008 12.0922 4.56717C12.0313 4.55574 11.9687 4.55574 11.9078 4.56717C11.839 4.58008 11.7734 4.61287 11.6422 4.67846L2 9.49958L11.6422 14.3207C11.7734 14.3863 11.839 14.4191 11.9078 14.432C11.9687 14.4434 12.0313 14.4434 12.0922 14.432C12.161 14.4191 12.2266 14.3863 12.3578 14.3207L22 9.49958L12.3578 4.67846Z" fill="#0075FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.2766 3.58432C12.0938 3.55002 11.9062 3.55002 11.7234 3.58432H12.2766ZM11.7233 3.58433C11.507 3.62494 11.3139 3.72341 11.2206 3.77103C11.211 3.77593 11.2025 3.7803 11.195 3.784L11.195 3.78403L1.55278 8.60515C1.214 8.77454 1 9.12081 1 9.49958C1 9.87835 1.214 10.2246 1.55278 10.394L11.195 15.2151C11.2024 15.2188 11.2109 15.2232 11.2206 15.2281C11.3139 15.2757 11.507 15.3743 11.7235 15.4149L11.7238 15.4149C11.9063 15.4491 12.0937 15.4491 12.2762 15.4149L12.2765 15.4149C12.493 15.3743 12.6861 15.2757 12.7794 15.2281C12.7891 15.2232 12.7976 15.2188 12.805 15.2151L22.4472 10.394C22.786 10.2246 23 9.87835 23 9.49958C23 9.12081 22.786 8.77454 22.4472 8.60515L12.805 3.78403L12.805 3.784C12.7975 3.7803 12.789 3.77593 12.7794 3.77103C12.6861 3.72341 12.493 3.62494 12.2767 3.58433M11.8027 5.52004L11.8027 5.52005L11.8027 5.52004ZM12 5.61759L4.23606 9.49958L12 13.3816L19.7639 9.49958L12 5.61759ZM11.8026 13.4791C11.8024 13.4792 11.8024 13.4792 11.8027 13.4791L11.8026 13.4791ZM12.1973 13.4791C12.1976 13.4792 12.1976 13.4792 12.1974 13.4791L12.1973 13.4791ZM12.1973 5.52005L12.1973 5.52004L12.1973 5.52005Z" fill="#0075FF"/>
</svg>
`, __vite_glob_0_48 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 6C8 5.44772 8.44772 5 9 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H9C8.44772 7 8 6.55228 8 6ZM8 12C8 11.4477 8.44772 11 9 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9C8.44772 13 8 12.5523 8 12ZM8 18C8 17.4477 8.44772 17 9 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H9C8.44772 19 8 18.5523 8 18Z" fill="#7F8184"/>
<mask id="mask0_109_232" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="3" width="3" height="5">
<path d="M4 3C4.55228 3 5 3.44772 5 4V7.17913C5 7.63249 4.63249 8 4.17913 8C3.72578 8 3.35827 7.63249 3.35827 7.17913V4.25H3.32283L2.74739 4.53462C2.40323 4.70485 2 4.45444 2 4.07048C2 3.87513 2.10994 3.6964 2.28429 3.60831L3.2755 3.10747C3.41534 3.03681 3.56981 3 3.72648 3H4Z" fill="white"/>
</mask>
<g mask="url(#mask0_109_232)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.3584 6.30554V7.17913C1.3584 8.73704 2.62132 10 4.17926 10C5.73719 10 7.00013 8.73706 7.00013 7.17913V4C7.00013 2.34315 5.65698 1 4.00013 1H3.72661C3.25659 1 2.79317 1.11044 2.37367 1.3224C2.37366 1.32241 2.37366 1.32241 2.37365 1.32241L1.3825 1.82322C1.38249 1.82323 1.38247 1.82323 1.38246 1.82324" fill="#7F8184"/>
</g>
<mask id="mask1_109_232" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="9" width="4" height="6">
<path d="M2.75023 14.5C2.39061 14.5 2.09909 14.2085 2.09909 13.8489C2.09909 13.6515 2.18864 13.4647 2.34256 13.3411L3.99487 12.0145C4.12059 11.9133 4.22812 11.8186 4.31745 11.7303C4.40843 11.6403 4.47791 11.548 4.52588 11.4533C4.57551 11.3585 4.60033 11.2534 4.60033 11.1378C4.60033 11.0109 4.5722 10.9025 4.51596 10.8126C4.46137 10.7227 4.38527 10.6537 4.28767 10.6055C4.19007 10.5557 4.07758 10.5308 3.9502 10.5308C3.82282 10.5308 3.71033 10.5557 3.61273 10.6055C3.51679 10.6553 3.44234 10.7283 3.38941 10.8247C3.29251 11.001 3.14689 11.1763 2.94567 11.1763H2.65492C2.29312 11.1763 1.98043 10.8718 2.11151 10.5346C2.14636 10.445 2.18937 10.3602 2.24052 10.2803C2.40099 10.0299 2.62762 9.83719 2.92043 9.70231C3.21323 9.56744 3.55649 9.5 3.9502 9.5C4.35715 9.5 4.70951 9.56342 5.00727 9.69027C5.3067 9.81551 5.53746 9.99213 5.69958 10.2201C5.86335 10.4481 5.94524 10.7155 5.94524 11.0222C5.94524 11.2116 5.90471 11.4003 5.82365 11.5882C5.74259 11.7744 5.59702 11.9807 5.38693 12.2071C5.17684 12.4335 4.87824 12.7033 4.49114 13.0164L4.02198 13.3959C4.01739 13.3996 4.01472 13.4052 4.01472 13.4111C4.01472 13.4219 4.02348 13.4306 4.03428 13.4306H5.46515C5.76044 13.4306 5.99983 13.67 5.99983 13.9653C5.99983 14.2606 5.76044 14.5 5.46515 14.5H2.75023Z" fill="white"/>
</mask>
<g mask="url(#mask1_109_232)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.642855 12.24C0.14387 11.6351 -0.110951 10.7314 0.247247 9.80996L0.247386 9.80961C0.329528 9.59842 0.432346 9.39507 0.555957 9.20198L0.556477 9.20117C0.940261 8.60231 1.47377 8.16664 2.08351 7.88577L2.08353 7.88576C2.69016 7.60633 3.33002 7.5 3.95005 7.5C4.55738 7.5 5.18615 7.5938 5.78489 7.84769C6.36916 8.09317 6.9171 8.48302 7.32666 9.0573C7.75544 9.65609 7.94509 10.3392 7.94509 11.0222C7.94509 11.5053 7.84014 11.9626 7.6599 12.3804L7.65727 12.3865L7.65726 12.3865C7.63146 12.4458 7.60404 12.5039 7.57523 12.5607C7.84338 12.9628 7.99968 13.4458 7.99968 13.9653C7.99968 15.3651 6.86493 16.5 5.465 16.5H2.75008C1.28601 16.5 0.0989364 15.3132 0.0989364 13.8489C0.0989364 13.2617 0.29353 12.6976 0.642855 12.24ZM1.63705 9.86046C1.63763 9.85939 1.6384 9.85798 1.63937 9.85625Z" fill="#7F8184"/>
</g>
<mask id="mask2_109_232" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="16" width="4" height="5">
<path d="M3.97599 21C3.59278 21 3.25233 20.9343 2.95463 20.8028C2.65852 20.6697 2.42574 20.4867 2.25631 20.2538C2.21953 20.2032 2.1867 20.1511 2.15783 20.0972C1.9826 19.7704 2.30141 19.4506 2.67222 19.4506H3.05938C3.20953 19.4506 3.32578 19.582 3.41543 19.7025C3.47244 19.7753 3.55003 19.8324 3.6482 19.8736C3.74638 19.9148 3.85881 19.9354 3.98549 19.9354C4.10742 19.9354 4.2151 19.914 4.30853 19.8712C4.40195 19.8268 4.47479 19.7658 4.52705 19.6882C4.5793 19.6106 4.60464 19.5219 4.60306 19.4221C4.60464 19.3238 4.57455 19.2367 4.5128 19.1606C4.45262 19.0846 4.36791 19.0252 4.25864 18.9824C4.14938 18.9396 4.02349 18.9183 3.88098 18.9183H3.8432C3.59121 18.9183 3.38693 18.714 3.38693 18.462C3.38693 18.21 3.59121 18.0057 3.8432 18.0057H3.88098C4.01241 18.0057 4.12801 17.9843 4.22777 17.9415C4.32911 17.8988 4.40749 17.8394 4.46292 17.7633C4.51992 17.6873 4.54763 17.6001 4.54605 17.5019C4.54763 17.4068 4.52467 17.3229 4.47717 17.25C4.42966 17.1771 4.36316 17.1201 4.27765 17.0789C4.19372 17.0377 4.09634 17.0171 3.98549 17.0171C3.86514 17.0171 3.75747 17.0385 3.66246 17.0813C3.56903 17.124 3.4954 17.1835 3.44156 17.2595C3.35223 17.3857 3.23441 17.5209 3.07981 17.5209H2.73338C2.38125 17.5209 2.07836 17.2188 2.23608 16.904C2.26583 16.8446 2.30029 16.7872 2.33944 16.7319C2.50254 16.5038 2.72582 16.3248 3.00926 16.1949C3.29271 16.065 3.61812 16 3.98549 16C4.34495 16 4.66244 16.061 4.93797 16.183C5.21508 16.305 5.43123 16.4729 5.58641 16.6868C5.74318 16.8991 5.82077 17.1423 5.81919 17.4163C5.82235 17.6888 5.72893 17.9122 5.53891 18.0865C5.35047 18.2608 5.11136 18.3638 4.82158 18.3954V18.4335C5.21429 18.4762 5.50961 18.5966 5.70755 18.7947C5.90549 18.9911 6.00287 19.2383 5.99971 19.5361C6.00129 19.8213 5.91578 20.074 5.74318 20.2942C5.57216 20.5144 5.33384 20.6871 5.02823 20.8123C4.72419 20.9374 4.37345 21 3.97599 21Z" fill="white"/>
</mask>
<g mask="url(#mask2_109_232)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.4479 16.0081C0.523678 15.8568 0.610439 15.7127 0.707048 15.5763L0.71248 15.5686L0.712498 15.5686C1.10056 15.0259 1.61173 14.6353 2.17595 14.3767L2.17597 14.3767C2.76318 14.1076 3.38098 14 3.98544 14C4.57022 14 5.17144 14.0995 5.74572 14.3534C6.29592 14.596 6.80927 14.9693 7.2004 15.5057C7.617 16.0731 7.81973 16.732 7.81916 17.4111C7.82076 17.6856 7.78601 17.9571 7.71406 18.2188C7.9094 18.6338 8.00224 19.0844 7.99968 19.541C8.00028 20.2605 7.77151 20.9468 7.32002 21.5244C6.89828 22.066 6.35439 22.4303 5.78636 22.663C5.19715 22.9049 4.58048 23 3.97594 23C3.36341 23 2.74002 22.8945 2.14646 22.6323L2.1346 22.627L2.13461 22.627C1.56208 22.3696 1.03828 21.9793 0.638944 21.4304L0.638481 21.4297C0.550556 21.3088 0.468841 21.1798 0.395173 21.0423M1.81075 20.8963L1.81514 20.9022C1.80598 20.8907 1.80436 20.8877 1.81075 20.8963ZM0.447775 16.0084C0.00844586 16.8855 0.179143 17.7934 0.622432 18.4344C0.104838 19.0973 -0.111885 20.0959 0.394749 21.0415" fill="#7F8184"/>
</g>
</svg>
`, __vite_glob_0_49 = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.64648 11.6464L11.6465 3.64642L12.3536 4.35353L4.35359 12.3535L3.64648 11.6464Z" fill="#249C5C"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.5026 4.5H5.33594V3.5H12.5026V10.6667H11.5026V4.5Z" fill="#249C5C"/>
</svg>
`, __vite_glob_0_50 = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.8027 14.2496C11.7165 14.2496 12.2007 14.2473 12.4959 14.1407L12.6448 14.0735L12.7427 14.0187C12.8122 13.9763 12.8753 13.9313 12.9294 13.8864C12.9997 13.8217 13.0466 13.7775 13.1093 13.7068C13.1664 13.6415 13.2163 13.5757 13.2567 13.5114C13.2986 13.4453 13.338 13.3693 13.3731 13.2873L13.3833 13.265C13.499 12.9672 13.4993 12.4709 13.4993 11.5068V10.794C13.4993 10.4266 13.7972 10.1288 14.1646 10.1288C14.5319 10.1288 14.8297 10.4266 14.8297 10.794C14.8297 11.1662 14.8233 11.5434 14.8297 11.915C14.8297 12.6675 14.8294 13.0454 14.73 13.4188L14.7202 13.4525C14.6933 13.547 14.6615 13.6403 14.6253 13.7318L14.5939 13.8119C14.5353 13.9487 14.4631 14.0856 14.3792 14.2182L14.2772 14.3701C14.2254 14.4427 14.1706 14.5119 14.1139 14.5773C14.0629 14.637 13.9994 14.6978 13.9438 14.7553L13.776 14.9046L13.6029 15.0384L13.4336 15.151C13.3187 15.2217 13.1962 15.2855 13.07 15.3396C12.94 15.3963 12.8058 15.4432 12.6686 15.4798C12.2956 15.5796 11.918 15.58 11.1647 15.58C8.69142 15.58 6.13949 15.6491 3.67751 15.5788C2.68992 15.5724 2.12031 15.5305 1.59231 15.2621L1.53676 15.2304C1.28051 15.0932 1.05032 14.9227 0.853789 14.7262C0.63949 14.5119 0.458076 14.2624 0.318233 13.9877C0.000375032 13.3637 0 12.6803 0 11.3148V5.01543C0 3.64989 -2.95043e-06 2.96655 0.318233 2.34255C0.458076 2.06778 0.63949 1.81834 0.853789 1.60404C1.06431 1.39352 1.31414 1.21285 1.59231 1.07074C2.21707 0.750617 2.90005 0.75024 4.26522 0.75024H7.78963C8.157 0.75024 8.45481 1.04806 8.45481 1.41543C8.45481 1.7828 8.157 2.08063 7.78963 2.08063H4.26522C3.11057 2.08063 2.53267 2.08063 2.19478 2.2526C2.05003 2.32366 1.91474 2.42381 1.79417 2.54438C1.677 2.66155 1.57798 2.79723 1.50277 2.94501C1.33042 3.2829 1.3304 3.86079 1.3304 5.01543V11.3148C1.3304 12.4694 1.3308 13.0473 1.50277 13.3852C1.57798 13.533 1.677 13.6687 1.79417 13.7858C1.9034 13.8951 2.02509 13.9877 2.15359 14.0583L2.19478 14.0776C2.52738 14.2469 3.09243 14.2496 4.21155 14.2496H10.8027ZM13.33 5.16511C13.33 5.53248 13.0322 5.8303 12.6648 5.8303C12.2974 5.8303 11.9996 5.53248 11.9996 5.16511V3.58035H10.4149C10.0475 3.58035 9.74967 3.28252 9.74967 2.91515C9.74967 2.54778 10.0475 2.24995 10.4149 2.24995H11.9996V0.665201C11.9996 0.29783 12.2974 0 12.6648 0C13.0322 0 13.33 0.29783 13.33 0.665201V2.24995H14.9148C15.2821 2.24995 15.58 2.54778 15.58 2.91515C15.58 3.28252 15.2821 3.58035 14.9148 3.58035H13.33V5.16511ZM6.95547 5.54041C6.95547 6.13569 6.71245 6.67692 6.31938 7.06961C5.92933 7.46268 5.38735 7.70533 4.79018 7.70533C4.19302 7.70533 3.65103 7.46268 3.25947 7.07112L3.21902 7.0269C2.85052 6.63799 2.62489 6.11452 2.62489 5.54041C2.62489 4.94476 2.86755 4.40429 3.2591 4.01197C3.65406 3.61777 4.19453 3.37512 4.79018 3.37512C5.38735 3.37512 5.92933 3.61777 6.32089 4.00933C6.71283 4.40126 6.95547 4.94325 6.95547 5.54041ZM5.38206 6.13077C5.53249 5.98186 5.62507 5.77248 5.62507 5.54041C5.62507 5.30986 5.53135 5.10047 5.38055 4.94967C5.23012 4.79924 5.02073 4.70551 4.79018 4.70551C4.5585 4.70551 4.34873 4.79887 4.1983 4.94854C4.04863 5.09897 3.95529 5.30873 3.95529 5.54041C3.95529 5.75925 4.03769 5.95805 4.17224 6.10469L4.19982 6.13077C4.35024 6.2812 4.55963 6.37494 4.79018 6.37494C5.02073 6.37494 5.23012 6.2812 5.38206 6.13077ZM6.95547 10.7932C6.95547 11.3904 6.71282 11.9323 6.32126 12.3239L6.27704 12.3644C5.88851 12.7321 5.36505 12.9581 4.79018 12.9581C4.19453 12.9581 3.65408 12.7155 3.26176 12.3239C2.86756 11.9323 2.62489 11.3904 2.62489 10.7932C2.62489 10.1975 2.86755 9.65708 3.2591 9.26476C3.65406 8.87056 4.19453 8.62791 4.79018 8.62791C5.38735 8.62791 5.92933 8.87055 6.32089 9.26211C6.71283 9.65405 6.95547 10.196 6.95547 10.7932ZM5.38092 11.3836C5.53134 11.2331 5.62507 11.0238 5.62507 10.7932C5.62507 10.5626 5.53135 10.3533 5.38055 10.2025C5.23012 10.052 5.02073 9.9583 4.79018 9.9583C4.5585 9.9583 4.34873 10.0517 4.1983 10.2013C4.04863 10.3518 3.95529 10.5615 3.95529 10.7932C3.95529 11.0238 4.04902 11.2331 4.19945 11.3836C4.34874 11.5344 4.5585 11.6277 4.79018 11.6277C5.00939 11.6277 5.20784 11.5446 5.35637 11.4096L5.38092 11.3836ZM12.2086 10.6651C12.2086 11.2804 11.9588 11.8382 11.5555 12.2415C11.1523 12.6448 10.5944 12.8946 9.9791 12.8946C9.36379 12.8946 8.80593 12.6448 8.40266 12.2415C7.99938 11.8382 7.74954 11.2804 7.74954 10.6651C7.74954 10.0517 7.99938 9.49493 8.40266 9.0909C8.80593 8.68498 9.36379 8.43516 9.9791 8.43516C10.5944 8.43516 11.1523 8.68497 11.5555 9.08825L11.5956 9.1321C11.9755 9.53235 12.2086 10.0724 12.2086 10.6651ZM10.6152 11.3012C10.7773 11.139 10.8782 10.9134 10.8782 10.6651C10.8782 10.4289 10.7883 10.2138 10.6417 10.0535L10.6152 10.0286C10.4531 9.86646 10.2274 9.76555 9.9791 9.76555C9.73078 9.76555 9.50514 9.86646 9.343 10.0286C9.18048 10.1896 9.07995 10.4156 9.07995 10.6651C9.07995 10.9134 9.18086 11.139 9.343 11.3012C9.50514 11.4633 9.73078 11.5642 9.9791 11.5642C10.2274 11.5642 10.4531 11.4633 10.6152 11.3012Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_51 = `<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_107_45)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9 1.73913C8.60024 1.73913 8.2258 1.77496 7.93821 1.83422C7.7944 1.86385 7.69166 1.89541 7.62646 1.92161C7.60982 1.9283 7.59773 1.9338 7.58961 1.93775C7.26009 2.22796 6.77064 2.1998 6.47289 1.86422C6.16288 1.51482 6.17807 0.964479 6.50682 0.634998C6.67815 0.463286 6.88545 0.360103 7.04766 0.294909C7.22381 0.224114 7.42127 0.169224 7.62674 0.126884C8.03773 0.0421962 8.51922 5.18301e-08 9 0C9.48077 0 9.96227 0.0421961 10.3733 0.126884C10.5787 0.169224 10.7762 0.224114 10.9523 0.294908C11.1145 0.360102 11.3218 0.463286 11.4932 0.634997C11.8219 0.964478 11.8371 1.51482 11.5271 1.86422C11.2294 2.1998 10.7399 2.22796 10.4104 1.93775C10.4023 1.9338 10.3902 1.9283 10.3735 1.92161C10.3083 1.89541 10.2056 1.86385 10.0618 1.83422C9.7742 1.77496 9.39976 1.73913 9 1.73913ZM1.03802 6.05419C0.793784 6.03629 0.477255 6.0358 0 6.0358V4.29667H0.0273966C0.0456813 4.29667 0.0638478 4.29667 0.0818962 4.29667H17.9181C17.9362 4.29667 17.9543 4.29667 17.9726 4.29667H18V6.0358C17.5227 6.0358 17.2062 6.03629 16.962 6.05419C16.7253 6.07154 16.6172 6.10224 16.5506 6.13188C16.2624 6.26012 16.0307 6.50737 15.9093 6.8222C15.8805 6.89687 15.8516 7.01595 15.8354 7.27184C15.8186 7.53536 15.8182 7.87647 15.8182 8.38875V14.8928C15.8182 15.8552 15.8182 16.6631 15.7378 17.3057C15.6527 17.9855 15.4645 18.6093 14.9958 19.1128C14.5259 19.6175 13.9417 19.8214 13.3047 19.9134C12.7048 20.0001 11.9511 20 11.0564 20H6.9436C6.04892 20 5.29524 20.0001 4.69529 19.9134C4.05834 19.8214 3.47407 19.6175 3.00418 19.1128C2.53548 18.6093 2.34727 17.9855 2.26219 17.3057C2.18176 16.6631 2.18178 15.8552 2.18182 14.8928V8.38875C2.18182 7.87647 2.18138 7.53536 2.16465 7.27184C2.14839 7.01595 2.11948 6.89687 2.09069 6.8222C1.96929 6.50737 1.73762 6.26012 1.44941 6.13188C1.38278 6.10224 1.27474 6.07154 1.03802 6.05419ZM14.4473 6.0358H3.55269C3.57093 6.07758 3.58832 6.11988 3.60483 6.16269C3.72827 6.48282 3.77549 6.81139 3.79729 7.1547C3.8182 7.4838 3.81819 7.88398 3.81818 8.36008V14.8338C3.81818 15.8708 3.81988 16.5621 3.88426 17.0764C3.94562 17.5667 4.05031 17.7638 4.1674 17.8896C4.28329 18.0141 4.46332 18.1248 4.91562 18.1901C5.39236 18.259 6.03382 18.2609 7 18.2609H11C11.9662 18.2609 12.6076 18.259 13.0844 18.1901C13.5367 18.1248 13.7167 18.0141 13.8326 17.8896C13.9497 17.7638 14.0544 17.5667 14.1157 17.0764C14.1801 16.5621 14.1818 15.8708 14.1818 14.8338V8.36008C14.1818 7.88398 14.1818 7.4838 14.2027 7.1547C14.2245 6.81139 14.2717 6.48282 14.3952 6.16269C14.4117 6.11988 14.4291 6.07758 14.4473 6.0358ZM7 9.66752C7.45187 9.66752 7.81818 10.0568 7.81818 10.5371V13.7596C7.81818 14.2398 7.45187 14.6292 7 14.6292C6.54813 14.6292 6.18182 14.2398 6.18182 13.7596V10.5371C6.18182 10.0568 6.54813 9.66752 7 9.66752ZM11 9.66752C11.4519 9.66752 11.8182 10.0568 11.8182 10.5371V13.7596C11.8182 14.2398 11.4519 14.6292 11 14.6292C10.5481 14.6292 10.1818 14.2398 10.1818 13.7596V10.5371C10.1818 10.0568 10.5481 9.66752 11 9.66752Z" fill="#7F8184"/>
</g>
<defs>
<clipPath id="clip0_107_45">
<rect width="18" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_52 = `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 2C6.92487 2 2 6.92487 2 13C2 19.0752 6.92487 24 13 24C19.0752 24 24 19.0752 24 13C24 6.92487 19.0752 2 13 2ZM0 13C0 5.8203 5.8203 0 13 0C20.1798 0 26 5.8203 26 13C26 20.1798 20.1798 26 13 26C5.8203 26 0 20.1798 0 13ZM13 6.66667C13.5523 6.66667 14 7.11438 14 7.66667V12H18.3333C18.8856 12 19.3333 12.4477 19.3333 13C19.3333 13.5523 18.8856 14 18.3333 14H14V18.3333C14 18.8856 13.5523 19.3333 13 19.3333C12.4477 19.3333 12 18.8856 12 18.3333V14H7.66667C7.11438 14 6.66667 13.5523 6.66667 13C6.66667 12.4477 7.11438 12 7.66667 12H12V7.66667C12 7.11438 12.4477 6.66667 13 6.66667Z" fill="white"/>
</svg>
`, __vite_glob_0_53 = `<svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.7587 4.31291e-07H12.2413C13.0463 -1.23241e-05 13.7106 -2.28137e-05 14.2518 0.0441945C14.8139 0.0901197 15.3306 0.188684 15.816 0.435975C16.5686 0.819468 17.1805 1.43139 17.564 2.18404C17.8113 2.66937 17.9099 3.18608 17.9558 3.74817C18 4.28936 18 4.95372 18 5.75868V9.5C18 10.0523 17.5523 10.5 17 10.5C16.4477 10.5 16 10.0523 16 9.5V5.8C16 4.94342 15.9992 4.36113 15.9624 3.91104C15.9266 3.47262 15.8617 3.24842 15.782 3.09202C15.5903 2.7157 15.2843 2.40973 14.908 2.21799C14.7516 2.1383 14.5274 2.07337 14.089 2.03755C13.6389 2.00078 13.0566 2 12.2 2H5.8C4.94342 2 4.36113 2.00078 3.91104 2.03755C3.47262 2.07337 3.24842 2.1383 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.1383 3.24842 2.07337 3.47262 2.03755 3.91104C2.00078 4.36113 2 4.94342 2 5.8V16.2C2 17.0566 2.00078 17.6389 2.03755 18.089C2.07337 18.5274 2.1383 18.7516 2.21799 18.908C2.40973 19.2843 2.7157 19.5903 3.09202 19.782C3.24842 19.8617 3.47262 19.9266 3.91104 19.9624C4.36113 19.9992 4.94342 20 5.8 20H8.5C9.05229 20 9.5 20.4477 9.5 21C9.5 21.5523 9.05229 22 8.5 22H5.75868C4.95372 22 4.28936 22 3.74817 21.9558C3.18608 21.9099 2.66937 21.8113 2.18404 21.564C1.43139 21.1805 0.819468 20.5686 0.435975 19.816C0.188684 19.3306 0.0901197 18.8139 0.0441945 18.2518C-2.28137e-05 17.7106 -1.23241e-05 17.0463 4.31291e-07 16.2413V5.7587C-1.23241e-05 4.95373 -2.28137e-05 4.28937 0.0441945 3.74817C0.0901197 3.18608 0.188684 2.66937 0.435975 2.18404C0.819468 1.43139 1.43139 0.819468 2.18404 0.435975C2.66937 0.188684 3.18608 0.0901197 3.74817 0.0441945C4.28937 -2.28137e-05 4.95373 -1.23241e-05 5.7587 4.31291e-07ZM15 14.5C13.6193 14.5 12.5 15.6193 12.5 17C12.5 18.3807 13.6193 19.5 15 19.5C16.3807 19.5 17.5 18.3807 17.5 17C17.5 15.6193 16.3807 14.5 15 14.5ZM10.5 17C10.5 14.5147 12.5147 12.5 15 12.5C17.4853 12.5 19.5 14.5147 19.5 17C19.5 17.8805 19.2471 18.702 18.81 19.3957L19.7071 20.2929C20.0976 20.6834 20.0976 21.3166 19.7071 21.7071C19.3166 22.0976 18.6834 22.0976 18.2929 21.7071L17.3957 20.81C16.702 21.2471 15.8805 21.5 15 21.5C12.5147 21.5 10.5 19.4853 10.5 17Z" fill="black"/>
</svg>
`, __vite_glob_0_54 = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4774 3.11069e-07H15.5226C18.1976 -1.72055e-05 20.3014 -3.10093e-05 21.9445 0.220879C23.6294 0.447401 24.9702 0.92162 26.0243 1.97572C27.0784 3.02981 27.5526 4.37063 27.7791 6.05548C28 7.69858 28 9.80234 28 12.4774V15.5226C28 18.1977 28 20.3014 27.7791 21.9445C27.5526 23.6294 27.0784 24.9702 26.0243 26.0243C24.9702 27.0784 23.6294 27.5526 21.9445 27.7791C20.3014 28 18.1977 28 15.5226 28H12.4774C9.80234 28 7.69858 28 6.05548 27.7791C4.37063 27.5526 3.02981 27.0784 1.97572 26.0243C0.92162 24.9702 0.447401 23.6294 0.220879 21.9445C-3.10093e-05 20.3014 -1.72055e-05 18.1976 3.11069e-07 15.5226V12.4774C-1.72055e-05 9.80236 -3.10093e-05 7.69859 0.220879 6.05548C0.447401 4.37063 0.92162 3.02981 1.97572 1.97572C3.02981 0.92162 4.37063 0.447401 6.05548 0.220879C7.69859 -3.10093e-05 9.80236 -1.72055e-05 12.4774 3.11069e-07ZM6.3065 2.08793C4.83055 2.28636 3.95353 2.66206 3.3078 3.3078C2.66206 3.95353 2.28636 4.83055 2.08793 6.3065C1.88585 7.80954 1.88385 9.78664 1.88385 12.5491V15.4509C1.88385 15.6839 1.88386 15.9113 1.88401 16.1333C2.30095 15.6611 2.80973 15.1525 3.4281 14.5344C3.46852 14.494 3.5094 14.4531 3.55075 14.4118L3.8121 14.1504C4.75456 13.208 5.51639 12.4461 6.17646 11.9148C6.85007 11.3727 7.53825 10.9679 8.34528 10.8998C9.05047 10.8403 9.7584 10.9766 10.3911 11.2938C11.1172 11.6578 11.6078 12.2963 12.0344 13.0568C12.4536 13.8041 12.8838 14.8078 13.4169 16.0519L13.4389 16.1032C13.7063 16.7272 13.8798 17.1292 14.0355 17.4107C14.1648 17.6444 14.2328 17.7004 14.2432 17.7078C14.3376 17.7599 14.4461 17.7808 14.5531 17.7673C14.539 17.7691 14.6098 17.7701 14.8514 17.5731C15.0964 17.3735 15.401 17.0705 15.8742 16.5973L15.9044 16.5671C16.4971 15.9744 16.986 15.4854 17.4196 15.1234C17.8711 14.7464 18.3284 14.449 18.8761 14.2962C19.4857 14.1262 20.1277 14.1093 20.7453 14.247C21.3004 14.3708 21.7727 14.6438 22.2433 14.9965C22.6953 15.3353 23.2093 15.7979 23.8323 16.3586L24.1754 16.6674C24.2209 16.7083 24.2658 16.7488 24.3103 16.7888C25.0361 17.4418 25.6248 17.9713 26.1016 18.4703C26.1158 17.5813 26.1162 16.5819 26.1162 15.4509V12.5491C26.1162 9.78664 26.1142 7.80954 25.9121 6.3065C25.7136 4.83055 25.3379 3.95353 24.6922 3.3078C24.0465 2.66206 23.1695 2.28636 21.6935 2.08793C20.1905 1.88585 18.2134 1.88385 15.4509 1.88385H12.5491C9.78664 1.88385 7.80954 1.88585 6.3065 2.08793ZM25.9213 21.6235C25.905 21.5881 25.8883 21.5518 25.8713 21.515C25.7299 21.2086 25.5914 20.9143 25.5421 20.822C25.1585 20.1043 24.5309 19.5218 22.9151 18.0676L22.6038 17.7875C21.9411 17.191 21.4897 16.7859 21.1135 16.504C20.7482 16.2302 20.5237 16.1277 20.3353 16.0857C20.0204 16.0155 19.693 16.0241 19.3822 16.1108C19.1963 16.1626 18.9775 16.2767 18.6271 16.5693C18.2662 16.8707 17.8368 17.2989 17.2063 17.9294L17.1729 17.9627C16.7427 18.393 16.37 18.7657 16.0415 19.0335C15.7012 19.3108 15.2961 19.5723 14.789 19.6363C14.285 19.6999 13.7739 19.6015 13.3296 19.3552C12.8805 19.1064 12.6005 18.7085 12.387 18.3224C12.1798 17.9478 11.9695 17.457 11.7259 16.8885L11.7074 16.8453C11.1471 15.5379 10.7555 14.6275 10.3914 13.9785C10.029 13.3325 9.76935 13.0894 9.54681 12.9778C9.22423 12.8161 8.86326 12.7466 8.50369 12.777C8.25326 12.7981 7.9246 12.926 7.35765 13.3824C6.78639 13.8422 6.09605 14.5306 5.10447 15.5222L4.88283 15.7439C3.41425 17.2125 2.84393 17.7997 2.50336 18.4983C2.37941 18.7525 2.27787 19.0171 2.19992 19.289C2.08073 19.7048 2.05102 19.8872 2.04832 20.1807C2.04603 20.4299 2.0634 20.7304 2.09211 21.2273C2.10491 21.4487 2.11995 21.7091 2.13652 22.0212C2.3453 23.302 2.71136 24.0958 3.3078 24.6922C3.95353 25.3379 4.83055 25.7136 6.3065 25.9121C7.80954 26.1142 9.78664 26.1162 12.5491 26.1162H15.4509C18.2134 26.1162 20.1905 26.1142 21.6935 25.9121C23.1695 25.7136 24.0465 25.3379 24.6922 24.6922C25.3379 24.0465 25.7136 23.1695 25.9121 21.6935C25.9152 21.6703 25.9183 21.6469 25.9213 21.6235ZM14.2446 17.7087C14.2446 17.7087 14.2441 17.7084 14.2432 17.7078L14.2446 17.7087ZM20.529 6.23654C19.8473 6.23654 19.2946 6.78921 19.2946 7.47096C19.2946 8.15272 19.8473 8.70539 20.529 8.70539C21.2108 8.70539 21.7635 8.15272 21.7635 7.47096C21.7635 6.78921 21.2108 6.23654 20.529 6.23654ZM17.4108 7.47096C17.4108 5.74879 18.8069 4.35269 20.529 4.35269C22.2512 4.35269 23.6473 5.74879 23.6473 7.47096C23.6473 9.19314 22.2512 10.5892 20.529 10.5892C18.8069 10.5892 17.4108 9.19314 17.4108 7.47096Z" fill="black"/>
</svg>
`, __vite_glob_0_55 = `<svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_108_7" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="1" width="16" height="20">
<path d="M11 1.26946V5.4C11 5.96005 11 6.24008 11.109 6.45399C11.2049 6.64215 11.3578 6.79513 11.546 6.89101C11.7599 7 12.0399 7 12.6 7H16.7305M17 8.98822V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H5.8C4.11984 21 3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1 16.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H9.01178C9.74555 1 10.1124 1 10.4577 1.08289C10.7638 1.15638 11.0564 1.27759 11.3249 1.44208C11.6276 1.6276 11.887 1.88703 12.4059 2.40589L15.5941 5.59411C16.113 6.11297 16.3724 6.3724 16.5579 6.67515C16.7224 6.94356 16.8436 7.2362 16.9171 7.5423C17 7.88757 17 8.25445 17 8.98822Z" fill="white"/>
</mask>
<g mask="url(#mask0_108_7)">
<path d="M10 1.26952V5.40006H12V1.26952H10ZM10 5.40006C10 5.66358 9.99922 5.92137 10.0169 6.13829C10.0356 6.36689 10.0797 6.63663 10.218 6.90806L12 6.00007C12.0293 6.0576 12.0189 6.08033 12.0103 5.97542C12.0008 5.85884 12 5.69659 12 5.40006H10ZM10.218 6.90806C10.4097 7.28414 10.7155 7.59026 11.0921 7.7821L12 6.00007L10.218 6.90806ZM11.0921 7.7821C11.3635 7.9204 11.6331 7.96444 11.8617 7.98312C12.0787 8.00084 12.3365 8.00006 12.6 8.00006V6.00006C12.3034 6.00006 12.1412 5.99928 12.0246 5.98976C11.9197 5.98119 11.9425 5.97076 12 6.00007L11.0921 7.7821ZM12.6 8.00006H16.7305V6.00006H12.6V8.00006ZM16 8.98828V16.2001H18V8.98828H16ZM16 16.2001C16 17.0567 15.9992 17.639 15.9624 18.0891C15.9266 18.5275 15.8617 18.7517 15.782 18.9081L17.564 19.8161C17.8113 19.3307 17.9099 18.814 17.9558 18.2519C18.0008 17.7015 18 17.0237 18 16.2001H16ZM15.782 18.9081C15.5903 19.2845 15.2844 19.5904 14.908 19.7821L15.816 21.5641C16.5686 21.1806 17.1805 20.5687 17.564 19.8161L15.782 18.9081ZM14.908 19.7821C14.7516 19.8618 14.5274 19.9267 14.089 19.9625C13.6389 19.9993 13.0566 20.0001 12.2 20.0001V22.0001C13.0236 22.0001 13.7014 22.0009 14.2518 21.9559C14.8139 21.91 15.3306 21.8114 15.816 21.5641L14.908 19.7821ZM12.2 20.0001H5.8V22.0001H12.2V20.0001ZM5.8 20.0001C4.94342 20.0001 4.36113 19.9993 3.91104 19.9625C3.47263 19.9267 3.24844 19.8618 3.09205 19.7821L2.18402 21.5641C2.66936 21.8114 3.18607 21.91 3.74817 21.9559C4.29859 22.0009 4.97642 22.0001 5.8 22.0001V20.0001ZM3.09205 19.7821C2.71572 19.5903 2.40972 19.2844 2.21799 18.9081L0.435956 19.8161C0.819463 20.5688 1.43137 21.1807 2.18402 21.5641L3.09205 19.7821ZM2.21799 18.9081C2.13827 18.7517 2.07337 18.5275 2.03755 18.0891C2.00078 17.639 2 17.0567 2 16.2001H8.6925e-07C8.6925e-07 17.0237 -0.000776865 17.7015 0.0441946 18.2519C0.0901209 18.814 0.188687 19.3307 0.435956 19.8161L2.21799 18.9081ZM2 16.2001V5.80006H8.6925e-07V16.2001H2ZM2 5.80006C2 4.94348 2.00078 4.36119 2.03755 3.9111C2.07337 3.47268 2.1383 3.24848 2.21799 3.09208L0.435976 2.1841C0.188684 2.66943 0.0901195 3.18614 0.0441945 3.74823C-0.000776839 4.29866 8.6925e-07 4.97648 8.6925e-07 5.80006H2ZM2.21799 3.09208C2.40973 2.71575 2.71569 2.40979 3.09202 2.21805L2.18404 0.436035C1.43139 0.819529 0.81947 1.43145 0.435976 2.1841L2.21799 3.09208ZM3.09202 2.21805C3.24842 2.13836 3.47262 2.07343 3.91104 2.03761C4.36113 2.00084 4.94342 2.00006 5.8 2.00006V6.27777e-05C4.97642 6.27777e-05 4.2986 -0.000714932 3.74817 0.0442564C3.18608 0.0901814 2.66937 0.188743 2.18404 0.436035L3.09202 2.21805ZM5.8 2.00006H9.01178V6.27777e-05H5.8V2.00006ZM9.01178 2.00006C9.79313 2.00006 10.0208 2.00648 10.2243 2.05533L10.6912 0.110584C10.2041 -0.00635483 9.69797 6.27777e-05 9.01178 6.27777e-05V2.00006ZM10.2243 2.05533C10.4284 2.10431 10.6234 2.18511 10.8025 2.29485L11.8474 0.589534C11.4895 0.370291 11.0993 0.208579 10.6912 0.110584L10.2243 2.05533ZM10.8025 2.29485C10.9809 2.40416 11.1462 2.56052 11.6988 3.11308L13.113 1.69885C12.6278 1.21369 12.2745 0.851268 11.8474 0.589534L10.8025 2.29485ZM11.6988 3.11308L14.887 6.30127L16.3012 4.88707L13.113 1.69885L11.6988 3.11308ZM14.887 6.30127C15.4395 6.85375 15.596 7.01934 15.7052 7.19766L17.4106 6.15276C17.1488 5.72558 16.7865 5.37231 16.3012 4.88707L14.887 6.30127ZM15.7052 7.19766C15.8148 7.37655 15.8957 7.57173 15.9447 7.77584L17.8895 7.30889C17.7915 6.9008 17.63 6.51069 17.4106 6.15276L15.7052 7.19766ZM15.9447 7.77584C15.9936 7.97924 16 8.20691 16 8.98828H18C18 8.30211 18.0064 7.79603 17.8895 7.30889L15.9447 7.77584Z" fill="black"/>
</g>
</svg>
`, __vite_glob_0_56 = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_95_24)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 2.93828C0 1.31552 1.31551 0 2.93828 0H25.0617C26.6845 0 28 1.31551 28 2.93828V25.0617C28 26.6845 26.6845 28 25.0617 28H2.93828C1.31552 28 0 26.6845 0 25.0617V2.93828ZM2.93828 1.95885C2.39736 1.95885 1.95885 2.39736 1.95885 2.93828V25.0617C1.95885 25.6026 2.39736 26.0411 2.93828 26.0411H25.0617C25.6026 26.0411 26.0411 25.6026 26.0411 25.0617V2.93828C26.0411 2.39736 25.6026 1.95885 25.0617 1.95885H2.93828Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_95_24">
<rect width="28" height="28" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_57 = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_116_27)">
<mask id="mask0_116_27" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
<path d="M28 0H0V28H28V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_116_27)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.3517 0.286436C20.7514 -0.108762 21.3844 -0.0930782 21.7655 0.321468L27.7238 6.80295C28.0921 7.20356 28.0921 7.83348 27.7238 8.23409L21.7655 14.7156C21.3844 15.1302 20.7514 15.1458 20.3517 14.7506C19.9519 14.3554 19.9368 13.6989 20.3179 13.2844L24.6651 8.55556L9.9375 8.55555C5.59823 8.55555 2 12.3967 2 17.2407C2 22.0847 5.59823 25.9259 9.9375 25.9259H14.5417C15.094 25.9259 15.5417 26.3902 15.5417 26.963C15.5417 27.5357 15.094 28 14.5417 28H9.9375C4.40467 28 0 23.1357 0 17.2407C0 11.3458 4.40467 6.48147 9.9375 6.48147L24.6651 6.48148L20.3179 1.75261C19.9368 1.33807 19.9519 0.681635 20.3517 0.286436Z" fill="#C2C2C2"/>
</g>
</g>
<defs>
<clipPath id="clip0_116_27">
<rect width="28" height="28" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_58 = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9 8.41656L8.75731 18.5102C10.374 17.0169 13.1374 17.6804 13.9 19.7448V8.41656ZM13.9 22.0181C13.5767 22.8866 12.8867 23.5766 12.0182 23.9H13.9V22.0181ZM9.77816 23.9C8.41497 23.3919 7.5552 21.9888 7.72133 20.5435L6.0112 23.9H9.77816ZM13.0199 7.50063C13.2508 7.04735 13.7625 6.8117 14.2569 6.9304C14.7514 7.04912 15.1 7.49138 15.1 8.00001V24C15.1 24.6076 14.6076 25.1 14 25.1H5.84803C5.46534 25.1 5.11012 24.9012 4.91014 24.5748C4.71025 24.2486 4.69414 23.8417 4.86791 23.5006L13.0199 7.50063ZM12.9 20.9025C12.9 18.8029 10.0759 18.1249 9.12277 19.9957C8.44565 21.3247 9.41105 22.9 10.9025 22.9C12.0058 22.9 12.9 22.0057 12.9 20.9025Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.2 8.48616L23.3427 18.5798C21.726 17.0865 18.9626 17.75 18.2 19.8144V8.48616ZM18.2 22.0877C18.5234 22.9562 19.2133 23.6462 20.0819 23.9696H18.2V22.0877ZM22.3219 23.9696C23.6851 23.4615 24.5448 22.0584 24.3787 20.6131L26.0888 23.9696H22.3219ZM19.0801 7.57023C18.8492 7.11695 18.3375 6.8813 17.8431 7C17.3487 7.11872 17 7.56098 17 8.06961V24.0696C17 24.6772 17.4924 25.1696 18.1 25.1696H26.252C26.6347 25.1696 26.9899 24.9708 27.1899 24.6444C27.3898 24.3182 27.4059 23.9113 27.2321 23.5702L19.0801 7.57023ZM19.2 20.9721C19.2 18.8725 22.0241 18.1945 22.9773 20.0653C23.6544 21.3943 22.689 22.9696 21.1975 22.9696C20.0942 22.9696 19.2 22.0753 19.2 20.9721Z" fill="black"/>
</svg>
`, __vite_glob_0_59 = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.6689 13.8849L13.5752 8.74218C15.0685 10.3588 14.4051 13.1223 12.3406 13.8849L23.6689 13.8849ZM10.0673 13.8849C9.19885 13.5615 8.50881 12.8716 8.18544 12.003V13.8849H10.0673ZM8.18544 9.76302C8.69356 8.39984 10.0966 7.54006 11.5419 7.70619L8.18544 5.99606V9.76302ZM24.5848 13.0048C25.0381 13.2357 25.2737 13.7473 25.1551 14.2418C25.0363 14.7362 24.5941 15.0849 24.0854 15.0849L8.08544 15.0849C7.47787 15.0849 6.98544 14.5925 6.98544 13.9849L6.98544 5.83289C6.98544 5.4502 7.1843 5.09498 7.51066 4.895C7.8368 4.69511 8.24378 4.679 8.58482 4.85277L24.5848 13.0048ZM11.1829 12.8849C13.2826 12.8849 13.9605 10.0608 12.0898 9.10763C10.7607 8.43052 9.18544 9.39592 9.18544 10.8874C9.18544 11.9907 10.0798 12.8849 11.1829 12.8849Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.5993 18.1849L13.5056 23.3276C14.9989 21.7109 14.3355 18.9474 12.271 18.1849L23.5993 18.1849ZM9.99773 18.1849C9.12925 18.5082 8.43921 19.1982 8.11584 20.0667V18.1849H9.99773ZM8.11584 22.3067C8.62396 23.6699 10.027 24.5297 11.4723 24.3636L8.11584 26.0737L8.11584 22.3067ZM24.5152 19.065C24.9685 18.8341 25.2041 18.3224 25.0854 17.828C24.9667 17.3335 24.5245 16.9849 24.0158 16.9849L8.01584 16.9849C7.40827 16.9849 6.91584 17.4773 6.91584 18.0849L6.91584 26.2369C6.91584 26.6196 7.11469 26.9748 7.44106 27.1748C7.7672 27.3746 8.17418 27.3908 8.51522 27.217L24.5152 19.065ZM11.1133 19.1849C13.213 19.1849 13.8909 22.009 12.0202 22.9621C10.6911 23.6392 9.11584 22.6738 9.11584 21.1824C9.11584 20.0791 10.0102 19.1849 11.1133 19.1849Z" fill="black"/>
</svg>
`, __vite_glob_0_60 = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 7.99992C3 6.61831 3.55905 5.36917 4.46569 4.46316C4.80916 4.11993 5.24107 3.74132 5.66667 3.38772V5.33325C5.66667 5.88554 6.11438 6.33325 6.66667 6.33325C7.21895 6.33325 7.66667 5.88554 7.66667 5.33325V1.33325C7.66667 0.780967 7.21895 0.333252 6.66667 0.333252H2.66667C2.11438 0.333252 1.66667 0.780967 1.66667 1.33325C1.66667 1.88554 2.11438 2.33325 2.66667 2.33325H3.82122C3.55084 2.57068 3.28699 2.81359 3.05197 3.04846C1.78531 4.31425 1 6.06632 1 7.99992C1 11.8659 4.13401 14.9999 8 14.9999C11.866 14.9999 15 11.8659 15 7.99992C15 4.80717 12.8633 2.11606 9.94392 1.27363C9.41328 1.12051 8.85899 1.42655 8.70587 1.95718C8.55275 2.48781 8.85878 3.04211 9.38942 3.19523C11.4757 3.79726 13 5.72188 13 7.99992C13 10.7613 10.7614 12.9999 8 12.9999C5.23858 12.9999 3 10.7613 3 7.99992Z" fill="black"/>
</svg>
`, __vite_glob_0_61 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 6.47715 17.5228 2 12 2C9.23761 2 6.73522 3.12139 4.92649 4.93138C4.28685 5.57146 3.60188 6.36248 3 7.09444V4C3 3.44772 2.55228 3 2 3C1.44772 3 1 3.44772 1 4V10C1 10.5523 1.44772 11 2 11H8C8.55229 11 9 10.5523 9 10C9 9.44772 8.55229 9 8 9H4.03079C4.72302 8.13128 5.58346 7.10335 6.34118 6.34511C7.79015 4.89514 9.78959 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C8.35426 20 5.27571 17.5605 4.31256 14.2227C4.15944 13.6921 3.60515 13.3861 3.07452 13.5392C2.54388 13.6923 2.23785 14.2466 2.39097 14.7773C3.59451 18.9481 7.43955 22 12 22C17.5228 22 22 17.5228 22 12Z" fill="black"/>
</svg>
`, __vite_glob_0_62 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 6.47715 5.47715 2 11 2C13.7624 2 16.2648 3.12139 18.0735 4.93138C18.7132 5.57146 19.3981 6.36248 20 7.09444V4C20 3.44772 20.4477 3 21 3C21.5523 3 22 3.44772 22 4V10C22 10.5523 21.5523 11 21 11H15C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9H18.9692C18.277 8.13128 17.4165 7.10335 16.6588 6.34511C15.2098 4.89514 13.2104 4 11 4C6.58172 4 3 7.58172 3 12C3 16.4183 6.58172 20 11 20C14.6457 20 17.7243 17.5605 18.6874 14.2227C18.8406 13.6921 19.3948 13.3861 19.9255 13.5392C20.4561 13.6923 20.7622 14.2466 20.609 14.7773C19.4055 18.9481 15.5605 22 11 22C5.47715 22 1 17.5228 1 12Z" fill="black"/>
</svg>
`, __vite_glob_0_63 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3372 2.98209C13.5701 2.98209 13.7142 2.72834 13.5949 2.52837L12.2586 0.288861C12.1422 0.0938173 11.8597 0.0938169 11.7434 0.288861L10.4071 2.52837C10.2878 2.72834 10.4319 2.98209 10.6648 2.98209H13.3372Z" fill="#565656"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 3.84668C20.6569 3.84668 22 5.18983 22 6.84668V14.8509H11V3.84668H19ZM20 6.84668C20 6.29439 19.5523 5.84668 19 5.84668H13V12.8509H20V6.84668Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 14.8486V6.84436C2 5.18751 3.34315 3.84436 5 3.84436H13V14.8486H2ZM4 12.8486H11V5.84436H5C4.44772 5.84436 4 6.29208 4 6.84436V12.8486Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 12.8506V20.8548C22 22.5117 20.6569 23.8548 19 23.8548H11V12.8506H22ZM20 14.8506H13V21.8548H19C19.5523 21.8548 20 21.4071 20 20.8548V14.8506Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 23.8574C3.34315 23.8574 2 22.5143 2 20.8574V12.8532H13V23.8574H5ZM4 20.8574C4 21.4097 4.44772 21.8574 5 21.8574H11V14.8532H4V20.8574Z" fill="black"/>
</svg>
`, __vite_glob_0_64 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_109_330)">
<mask id="mask0_109_330" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<path d="M24 0H0V24H24V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_109_330)">
<path d="M10.6628 20.8871C10.4299 20.8871 10.2858 21.1408 10.4051 21.3408L11.7414 23.5803C11.8578 23.7753 12.1403 23.7753 12.2566 23.5803L13.5929 21.3408C13.7122 21.1408 13.5681 20.8871 13.3352 20.8871H10.6628Z" fill="#565656"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 20.0098C3.34315 20.0098 2 18.6666 2 17.0098V9.00549H13V20.0098H5ZM4 17.0098C4 17.5621 4.44772 18.0098 5 18.0098H11V11.0055H4V17.0098Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 9.00781V17.0121C22 18.6689 20.6569 20.0121 19 20.0121H11V9.00781H22ZM20 11.0078H13V18.0121H19C19.5523 18.0121 20 17.5644 20 17.0121V11.0078Z" fill="#A4A4A4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 11.0059V3.00159C2 1.34473 3.34315 0.00158733 5 0.00158726L13 0.00158691V11.0059H2ZM4 9.00585H11V2.00159H5C4.44771 2.00159 4 2.4493 4 3.00159V9.00585Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 3.49691e-07C20.6569 4.22114e-07 22 1.34315 22 3V11.0043H11V0L19 3.49691e-07ZM20 3C20 2.44772 19.5523 2 19 2H13V9.00426H20V3Z" fill="black"/>
</g>
</g>
<defs>
<clipPath id="clip0_109_330">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_65 = `<svg width="42" height="2" viewBox="0 0 42 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_78)">
<path d="M14 0.0880737V1.18183H0V0.0880737H14ZM28 0.0880737V1.18183H14V0.0880737H28ZM42 0.0880737V1.18183H28V0.0880737H42Z" fill="#272727"/>
</g>
<defs>
<clipPath id="clip0_108_78">
<rect width="42" height="3" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_66 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 7.22197V11C22 11.5523 21.5523 12 21 12H3C2.73478 12 2.48043 11.8946 2.29289 11.7071C2.10536 11.5196 2 11.2652 2 11L2 7.22198C1.99998 6.51332 1.99996 5.91442 2.04507 5.42368C2.09256 4.907 2.19607 4.41813 2.45941 3.95872C2.85912 3.2614 3.4841 2.71549 4.22546 2.37972C4.69992 2.16483 5.20362 2.07916 5.75717 2.03896C6.29383 1.99998 6.95429 1.99999 7.76266 2L16.2373 2C17.0457 1.99999 17.7062 1.99998 18.2428 2.03896C18.7964 2.07916 19.3001 2.16483 19.7745 2.37972C20.5159 2.71549 21.1409 3.2614 21.5406 3.95872C21.8039 4.41813 21.9074 4.907 21.9549 5.42368C22 5.91442 22 6.51332 22 7.22197ZM19.9633 5.60674C19.9291 5.23407 19.8691 5.06435 19.8054 4.95333C19.6299 4.64712 19.337 4.37713 18.9494 4.20158C18.7821 4.12582 18.5449 4.06617 18.098 4.03371C17.6423 4.00062 17.0548 4 16.2 4L7.8 4C6.94524 4 6.35765 4.00062 5.90204 4.0337C5.45508 4.06617 5.21787 4.12582 5.0506 4.20158C4.66299 4.37713 4.37008 4.64712 4.19456 4.95333C4.13092 5.06435 4.07093 5.23407 4.03668 5.60674C4.00098 5.99505 4 6.50139 4 7.26667L4 10H20V7.26667C20 6.50139 19.999 5.99505 19.9633 5.60674Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7071 13.2929C10.8946 13.4805 11 13.7348 11 14L11 21C11 21.5523 10.5523 22 10 22H6.69368C6.07409 22 5.54949 22 5.11938 21.9649C4.66845 21.9281 4.23407 21.8477 3.82004 21.6367C3.19283 21.3171 2.6829 20.8072 2.36332 20.18C2.15236 19.766 2.07196 19.3316 2.03512 18.8806C1.99998 18.4505 1.99999 17.926 2.00001 17.3064L2.00001 14C2.00001 13.4478 2.44772 13 3.00001 13L10 13C10.2652 13 10.5196 13.1054 10.7071 13.2929ZM9.00001 15L4.00001 15V17.2667C4.00001 17.9366 4.00078 18.3789 4.02847 18.7178C4.05521 19.045 4.10197 19.1869 4.14533 19.272C4.27316 19.5229 4.47713 19.7269 4.72802 19.8547C4.81311 19.898 4.95499 19.9448 5.28224 19.9715C5.62116 19.9992 6.06344 20 6.73334 20H9.00001L9.00001 15Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.2929 13.2929C13.1054 13.4805 13 13.7348 13 14L13 21C13 21.5523 13.4477 22 14 22H17.3063C17.9259 22 18.4505 22 18.8806 21.9649C19.3316 21.9281 19.7659 21.8477 20.18 21.6367C20.8072 21.3171 21.3171 20.8072 21.6367 20.18C21.8476 19.766 21.928 19.3316 21.9649 18.8806C22 18.4505 22 17.926 22 17.3064V14C22 13.4478 21.5523 13 21 13L14 13C13.7348 13 13.4804 13.1054 13.2929 13.2929ZM15 15L20 15V17.2667C20 17.9366 19.9992 18.3789 19.9715 18.7178C19.9448 19.045 19.898 19.1869 19.8547 19.272C19.7268 19.5229 19.5229 19.7269 19.272 19.8547C19.1869 19.898 19.045 19.9448 18.7178 19.9715C18.3788 19.9992 17.9366 20 17.2667 20H15L15 15Z" fill="black"/>
</svg>
`, __vite_glob_0_67 = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 12.1287C0 11.5762 0.447485 11.1287 0.999674 11.1287H19.0001C19.5522 11.1287 19.9997 11.5762 19.9997 12.1287V15.6751C19.9997 16.3353 19.9997 16.9019 19.9544 17.3683C19.9056 17.8634 19.7991 18.3389 19.5262 18.7852C19.1176 19.4534 18.4864 19.9648 17.7528 20.2766C17.2845 20.4754 16.7875 20.5548 16.2383 20.5922C15.7039 20.6285 15.0455 20.6285 14.2352 20.6285H5.76454C4.95458 20.6285 4.29581 20.6285 3.76139 20.5922C3.21222 20.5548 2.7152 20.4754 2.24692 20.2766C1.51331 19.9648 0.882134 19.4534 0.473567 18.7852C0.201063 18.3389 0.0940992 17.8634 0.0453433 17.3683C-1.10753e-05 16.9019 0 16.3353 0 15.6751V12.1287ZM1.99974 15.6286C1.99974 16.3482 2.00087 16.8161 2.03602 17.1729C2.06928 17.5115 2.12597 17.6533 2.18002 17.7417C2.3467 18.0146 2.63356 18.2678 3.0289 18.4356C3.20238 18.5093 3.44654 18.566 3.89743 18.5966C4.35589 18.628 4.94588 18.6284 5.79967 18.6284H8.9998V13.1284H1.99974V15.6286ZM10.9999 13.1284V18.6284H14.2001C15.0539 18.6284 15.6438 18.628 16.1023 18.5966C16.5532 18.566 16.7973 18.5093 16.9712 18.4356C17.3662 18.2678 17.653 18.0146 17.8197 17.7421C17.8738 17.6533 17.9305 17.5115 17.9637 17.1729C17.9989 16.8161 18 16.3482 18 15.6286V13.1284H10.9999Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.12869C0 9.68125 0.447485 10.1287 0.999674 10.1287H19.0001C19.5522 10.1287 19.9997 9.68125 19.9997 9.12869V5.58236C19.9997 4.92207 19.9997 4.35552 19.9544 3.88913C19.9056 3.39401 19.7991 2.91854 19.5262 2.47218C19.1176 1.80396 18.4864 1.29259 17.7528 0.980782C17.2845 0.781979 16.7875 0.70261 16.2383 0.665193C15.7039 0.628909 15.0455 0.628906 14.2352 0.628906H5.76454C4.95458 0.628906 4.29581 0.628909 3.76139 0.665193C3.21222 0.70261 2.7152 0.781979 2.24692 0.980782C1.51331 1.29259 0.882134 1.80396 0.473567 2.47218C0.201063 2.91854 0.0940992 3.39401 0.0453433 3.88913C-1.10753e-05 4.35552 0 4.92207 0 5.58236V9.12869ZM1.99974 5.62884C1.99974 4.90922 2.00087 4.44132 2.03602 4.08453C2.06928 3.74588 2.12597 3.60415 2.18002 3.51571C2.3467 3.24283 2.63356 2.9896 3.0289 2.82179C3.20238 2.74809 3.44654 2.69139 3.89743 2.66078C4.35589 2.62941 4.94588 2.62903 5.79967 2.62903H8.9998V8.129H1.99974V5.62884ZM10.9999 8.129V2.62903H14.2001C15.0539 2.62903 15.6438 2.62941 16.1023 2.66078C16.5532 2.69139 16.7973 2.74809 16.9712 2.82179C17.3662 2.9896 17.653 3.24283 17.8197 3.51533C17.8738 3.60415 17.9305 3.74588 17.9637 4.08453C17.9989 4.44132 18 4.90922 18 5.62884V8.129H10.9999Z" fill="black"/>
</svg>
`, __vite_glob_0_68 = `<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_108_94)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.1569 14.7271C17.7679 15.4813 16.9526 16 16.0119 16H2.4015C1.07699 16 0 14.9776 0 13.7143V2.28571C0 1.02335 1.07452 0 2.4 0H16C17.3255 0 18.4 1.02335 18.4 2.28571V6.09821H16.8V2.28571C16.8 1.86493 16.4418 1.52381 16 1.52381H2.4C1.95817 1.52381 1.6 1.86493 1.6 2.28571V13.7143C1.6 14.1341 1.95869 14.4762 2.4015 14.4762H16.0119C16.4473 14.4762 16.8 14.1398 16.8 13.7271H18.4C18.4 14.086 18.3126 14.4254 18.1569 14.7271Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.8001 6.09522V4.57141H1.6001V6.09522H16.8001Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.2001 5.33331H5.6001V14.4762H7.2001V5.33331Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8002 5.33331H11.2002V14.4762H12.8002V5.33331Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.3998 7.61908H16.7998V12.1905H18.3998V7.61908Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.0002 10.6667V9.14288H15.2002V10.6667H20.0002Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_108_94">
<rect width="20" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_69 = `<svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.72093 3.93204e-05H24.186C24.8372 3.93204e-05 25.3953 3.96967e-05 25.8605 0.100039C26.3256 0.200039 26.7907 0.30004 27.2558 0.70004C27.6279 1.10004 27.814 1.60004 27.907 2.10004C28 2.60004 28 3.20004 28 3.80004V22.1C28 22.8 28 23.4 27.907 23.8C27.814 24.3 27.7209 24.8 27.2558 25.2C26.8837 25.6 26.3256 25.8 25.8605 25.8C25.3953 26 24.8372 26 24.186 26H3.72093C3.06977 26 2.51163 26 2.04651 25.9C1.5814 25.8 1.11628 25.7 0.651163 25.3C0.27907 24.9 0.0930233 24.4 0 23.9C0 23.4 0 22.8 0 22.1V3.90004C0 3.90004 0 3.90004 0 3.80004C0 3.10004 3.53469e-07 2.50004 0.0930233 2.10004C0.186047 1.60004 0.27907 1.10004 0.744186 0.70004C1.11628 0.30004 1.86047 0 2.32558 0C2.96512 0 3.06977 3.93204e-05 3.72093 3.93204e-05ZM2.13953 1.90004C1.95452 1.90004 1.86047 2.00004 1.86047 2.00004C1.86047 2.00004 1.76744 2.10004 1.76744 2.40004C1.76744 2.70004 1.76744 3.20004 1.76744 3.90004V7.50004H26.2326V3.90004C26.2326 3.20004 26.2326 2.70004 26.2326 2.40004C26.2326 2.10004 26.1395 2.00004 26.1395 2.00004C26.1395 2.00004 26.0465 1.90004 25.7674 1.90004C25.3953 1.90004 25.0233 1.90004 24.2791 1.90004H3.72093C2.55384 1.90004 2.51163 1.90004 2.13953 1.90004ZM26.2326 9.40004H19.1628V15.8945V17.7017V24.2H24.186C24.9302 24.2 25.3023 24.2 25.6744 24.2C25.9535 24.2 26.0465 24.1 26.0465 24.1C26.0465 24.1 26.1395 24 26.1395 23.7C26.1395 23.4 26.1395 22.9 26.1395 22.2V17.7017V15.8945V9.40004H26.2326ZM17.4884 24.2V17.7017V15.8945V9.40004H10.4186V15.8945V17.7017V24.2H17.4884ZM8.74419 24.2V17.7017V16.8V15.8945V9.40004H1.67442V15.8945V16.8V17.7017V22.1C1.67442 22.8 1.67442 23.3 1.67442 23.6C1.67442 23.9 1.76744 24 1.76744 24C1.76744 24 1.86046 24.1 2.13953 24.1C2.51163 24.1 2.88372 24.1 3.62791 24.1H8.74419V24.2Z" fill="black"/>
<path d="M19 18H27V16H19V18Z" fill="black"/>
<path d="M10 18H18V16H10V18Z" fill="black"/>
<path d="M1 18H9V16H1V18Z" fill="black"/>
</svg>
`, __vite_glob_0_70 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6ZM5 10C5 9.44772 5.44772 9 6 9H18C18.5523 9 19 9.44772 19 10C19 10.5523 18.5523 11 18 11H6C5.44772 11 5 10.5523 5 10ZM2 14C2 13.4477 2.44772 13 3 13H21C21.5523 13 22 13.4477 22 14C22 14.5523 21.5523 15 21 15H3C2.44772 15 2 14.5523 2 14ZM5 18C5 17.4477 5.44772 17 6 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z" fill="black"/>
</svg>
`, __vite_glob_0_71 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 3C6.26522 3 6.51957 3.10536 6.70711 3.29289L9.70711 6.29289C10.0976 6.68342 10.0976 7.31658 9.70711 7.70711C9.31658 8.09763 8.68342 8.09763 8.29289 7.70711L7 6.41421L7 17.5858L8.29289 16.2929C8.68342 15.9024 9.31658 15.9024 9.70711 16.2929C10.0976 16.6834 10.0976 17.3166 9.70711 17.7071L6.70711 20.7071C6.51957 20.8946 6.26522 21 6 21C5.73478 21 5.48043 20.8946 5.29289 20.7071L2.29289 17.7071C1.90237 17.3166 1.90237 16.6834 2.29289 16.2929C2.68342 15.9024 3.31658 15.9024 3.70711 16.2929L5 17.5858L5 6.41421L3.70711 7.70711C3.31658 8.09763 2.68342 8.09763 2.29289 7.70711C1.90237 7.31658 1.90237 6.68342 2.29289 6.29289L5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3ZM12 6C12 5.44772 12.4477 5 13 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H13C12.4477 7 12 6.55228 12 6ZM12 10C12 9.44772 12.4477 9 13 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H13C12.4477 11 12 10.5523 12 10ZM12 14C12 13.4477 12.4477 13 13 13H21C21.5523 13 22 13.4477 22 14C22 14.5523 21.5523 15 21 15H13C12.4477 15 12 14.5523 12 14ZM12 18C12 17.4477 12.4477 17 13 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H13C12.4477 19 12 18.5523 12 18Z" fill="black"/>
</svg>
`, __vite_glob_0_72 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6ZM2 10C2 9.44772 2.44772 9 3 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10ZM2 14C2 13.4477 2.44772 13 3 13H21C21.5523 13 22 13.4477 22 14C22 14.5523 21.5523 15 21 15H3C2.44772 15 2 14.5523 2 14ZM2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18Z" fill="black"/>
</svg>
`, __vite_glob_0_73 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 6C2 5.44772 2.44772 5 3 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H3C2.44772 7 2 6.55228 2 6ZM2 10C2 9.44772 2.44772 9 3 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H3C2.44772 11 2 10.5523 2 10ZM2 14C2 13.4477 2.44772 13 3 13H20C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15H3C2.44772 15 2 14.5523 2 14ZM2 18C2 17.4477 2.44772 17 3 17H16C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19H3C2.44772 19 2 18.5523 2 18Z" fill="black"/>
</svg>
`, __vite_glob_0_74 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 6C22 5.44772 21.5523 5 21 5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H21C21.5523 7 22 6.55228 22 6ZM22 10C22 9.44772 21.5523 9 21 9H8C7.44771 9 7 9.44772 7 10C7 10.5523 7.44771 11 8 11H21C21.5523 11 22 10.5523 22 10ZM22 14C22 13.4477 21.5523 13 21 13H4C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15H21C21.5523 15 22 14.5523 22 14ZM22 18C22 17.4477 21.5523 17 21 17H8C7.44771 17 7 17.4477 7 18C7 18.5523 7.44771 19 8 19H21C21.5523 19 22 18.5523 22 18Z" fill="black"/>
</svg>
`, __vite_glob_0_75 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 6C6 7.10456 5.10456 8 4 8C2.89544 8 2 7.10456 2 6C2 4.89544 2.89544 4 4 4C5.10456 4 6 4.89544 6 6Z" fill="black"/>
<path d="M6 12C6 13.1046 5.10455 14 4 14C2.89545 14 2 13.1046 2 12C2 10.8954 2.89545 10 4 10C5.10455 10 6 10.8954 6 12Z" fill="black"/>
<path d="M4 20C5.10455 20 6 19.1046 6 18C6 16.8954 5.10455 16 4 16C2.89545 16 2 16.8954 2 18C2 19.1046 2.89545 20 4 20Z" fill="black"/>
<path d="M8.99969 5.00024C8.4475 5.00024 8 5.44813 8 6.00031C8 6.5525 8.4475 7.00038 8.99969 7.00038H20.9997C21.5519 7.00038 21.9994 6.5525 21.9994 6.00031C21.9994 5.44813 21.5519 5.00024 20.9997 5.00024H8.99969Z" fill="black"/>
<path d="M8.99969 11.0002C8.4475 11.0002 8 11.4481 8 12.0003C8 12.5525 8.4475 13.0004 8.99969 13.0004H20.9997C21.5519 13.0004 21.9994 12.5525 21.9994 12.0003C21.9994 11.4481 21.5519 11.0002 20.9997 11.0002H8.99969Z" fill="black"/>
<path d="M8 17.9999C8 17.4477 8.4475 16.9999 8.99969 16.9999H20.9997C21.5519 16.9999 21.9994 17.4477 21.9994 17.9999C21.9994 18.5521 21.5519 19 20.9997 19H8.99969C8.4475 19 8 18.5521 8 17.9999Z" fill="black"/>
</svg>
`, __vite_glob_0_76 = `<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
    <path stroke="black" clip-rule="evenodd" d="M27 0C27.5523 -2.41411e-08 28 0.466027 28 1.0409V4.9591C28 5.53397 27.5523 6 27 6C26.4477 6 26 5.53397 26 4.9591V1.0409C26 0.466027 26.4477 2.41411e-08 27 0ZM1 0C1.55228 -2.41411e-08 2 0.466027 2 1.0409V4.9591C2 5.53397 1.55228 6 1 6C0.447716 6 1.96398e-07 5.53397 1.71269e-07 4.9591L0 1.0409C-2.51285e-08 0.466027 0.447715 2.41411e-08 1 0ZM0 1C-2.41411e-08 0.447716 0.456746 1.15936e-06 1.02017 1.13473e-06L26.9798 0C27.5433 -2.46282e-08 28 0.447715 28 0.999999C28 1.55228 27.5433 2 26.9798 2H1.02017C0.456746 2 2.41411e-08 1.55229 0 1ZM13 26.9791V1H15V26.9791C15 27.5429 14.5523 28 14 28C13.4477 28 13 27.5429 13 26.9791ZM18 27.0001C18 27.5523 17.5837 28.0001 17.0702 28.0001H10.9297C10.4162 28.0001 10 27.5523 10 27.0001C10 26.4478 10.4162 26.0001 10.9297 26.0001H17.0702C17.5837 26.0001 18 26.4478 18 27.0001Z" fill="black"/>
</svg>

`, __vite_glob_0_77 = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="18" height="18" fill="#D9D9D9"/>
<path d="M14 9C14 7.89543 14.8954 7 16 7V7C17.1046 7 18 7.89543 18 9V9C18 10.1046 17.1046 11 16 11V11C14.8954 11 14 10.1046 14 9V9Z" fill="#7F8184"/>
<path d="M7 9C7 7.89543 7.89543 7 9 7V7C10.1046 7 11 7.89543 11 9V9C11 10.1046 10.1046 11 9 11V11C7.89543 11 7 10.1046 7 9V9Z" fill="#7F8184"/>
<path d="M0 9C0 7.89543 0.895431 7 2 7V7C3.10457 7 4 7.89543 4 9V9C4 10.1046 3.10457 11 2 11V11C0.895431 11 0 10.1046 0 9V9Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_78 = `<svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 6H0L6 0L12 6Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_79 = `<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 0L5.59808 6.75H0.401924L3 0Z" fill="#D9D9D9"/>
</svg>
`, __vite_glob_0_80 = `<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 -3.57628e-07L6 12L0 6L6 -3.57628e-07Z" fill="#7F8184"/>
</svg>
`, __vite_glob_0_81 = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_116_34)">
<mask id="mask0_116_34" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
<path d="M28 0H0V28H28V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_116_34)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.64835 0.286438C8.04809 0.681638 8.06321 1.33807 7.68212 1.75261L3.33494 6.48148L18.0625 6.48147C23.5953 6.48147 28 11.3458 28 17.2407C28 23.1357 23.5953 28 18.0625 28H13.4583C12.906 28 12.4583 27.5357 12.4583 26.963C12.4583 26.3902 12.906 25.9259 13.4583 25.9259H18.0625C22.4017 25.9259 26 22.0847 26 17.2407C26 12.3967 22.4017 8.55555 18.0625 8.55555L3.33494 8.55556L7.68212 13.2844C8.06321 13.6989 8.04809 14.3554 7.64835 14.7506C7.24861 15.1458 6.61562 15.1302 6.23454 14.7156L0.276206 8.23409C-0.0920687 7.83349 -0.0920687 7.20356 0.276206 6.80295L6.23454 0.321466C6.61562 -0.0930792 7.24861 -0.108761 7.64835 0.286438Z" fill="#C2C2C2"/>
</g>
</g>
<defs>
<clipPath id="clip0_116_34">
<rect width="28" height="28" fill="white"/>
</clipPath>
</defs>
</svg>
`, __vite_glob_0_82 = `<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.25284 0H0L2.78409 10.1818H4.05682L6.30398 2.06818H6.38352L8.63068 10.1818H9.90341L12.6875 0H11.4347L9.30682 8.29261H9.20739L7.03977 0H5.64773L3.48011 8.29261H3.38068L1.25284 0Z" fill="black"/>
</svg>
`, __vite_glob_0_83 = `<svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.4517 0H0L3.28125 5.09091L0 10.1818H1.4517L4.0767 6.02557H4.15625L6.78125 10.1818H8.23295L5.03125 5.09091L8.23295 0H6.78125L4.15625 4.2358H4.0767L1.4517 0Z" fill="black"/>
</svg>
`, __vite_glob_0_84 = `<svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.41193 0H0L3.67898 5.9858V10.1818H4.91193V5.9858L8.59091 0H7.17898L4.35511 4.75284H4.2358L1.41193 0Z" fill="black"/>
</svg>
`, Mh = class Mh {
};
Ca(Mh, "svgCollection", /* @__PURE__ */ new Map()), Ca(Mh, "svgCollectionPath", /* @__PURE__ */ new Map()), Ca(Mh, "svgCollectionGroup", /* @__PURE__ */ new Map()), /**
 * Генерирует мапу из файлов `svg` в папке по указанному пути,
 * где ключ это название файла и значение svg в виде строки.
 * @param path Путь до папки с svg
 */
Ca(Mh, "generateSVG", () => {
  const zn = /* @__PURE__ */ Object.assign({ "./svg/PDF.svg": __vite_glob_0_0, "./svg/addImage.svg": __vite_glob_0_1, "./svg/aiTool.svg": __vite_glob_0_2, "./svg/alignCenter.svg": __vite_glob_0_3, "./svg/alignCenterVertical.svg": __vite_glob_0_4, "./svg/alignLeft.svg": __vite_glob_0_5, "./svg/alignRight.svg": __vite_glob_0_6, "./svg/alignTop.svg": __vite_glob_0_7, "./svg/arrowDown.svg": __vite_glob_0_8, "./svg/arrowUp.svg": __vite_glob_0_9, "./svg/backButton.svg": __vite_glob_0_10, "./svg/boom.svg": __vite_glob_0_11, "./svg/borderWidth.svg": __vite_glob_0_12, "./svg/canceled.svg": __vite_glob_0_13, "./svg/close.svg": __vite_glob_0_14, "./svg/colorInput.svg": __vite_glob_0_15, "./svg/columnLeft.svg": __vite_glob_0_16, "./svg/columnRight.svg": __vite_glob_0_17, "./svg/componentPicturePlus.svg": __vite_glob_0_18, "./svg/cornerRadius.svg": __vite_glob_0_19, "./svg/cornerRadiusAll.svg": __vite_glob_0_20, "./svg/cropImage.svg": __vite_glob_0_21, "./svg/cropImg.svg": __vite_glob_0_22, "./svg/cross.svg": __vite_glob_0_23, "./svg/dashed.svg": __vite_glob_0_24, "./svg/delete.svg": __vite_glob_0_25, "./svg/deleteColumn.svg": __vite_glob_0_26, "./svg/deleteRow.svg": __vite_glob_0_27, "./svg/doted.svg": __vite_glob_0_28, "./svg/edit.svg": __vite_glob_0_29, "./svg/excelLoader.svg": __vite_glob_0_30, "./svg/excelReplace.svg": __vite_glob_0_31, "./svg/fontBold.svg": __vite_glob_0_32, "./svg/fontItalic.svg": __vite_glob_0_33, "./svg/generationCounter.svg": __vite_glob_0_34, "./svg/greenSavedCircle.svg": __vite_glob_0_35, "./svg/height.svg": __vite_glob_0_36, "./svg/imgLoad.svg": __vite_glob_0_37, "./svg/landscapeOrientationBtn.svg": __vite_glob_0_38, "./svg/lineTool.svg": __vite_glob_0_39, "./svg/link.svg": __vite_glob_0_40, "./svg/listNumber.svg": __vite_glob_0_41, "./svg/loader.svg": __vite_glob_0_42, "./svg/mergeCells.svg": __vite_glob_0_43, "./svg/modalTool.svg": __vite_glob_0_44, "./svg/moveBackground.svg": __vite_glob_0_45, "./svg/moveForeground.svg": __vite_glob_0_46, "./svg/moveForward.svg": __vite_glob_0_47, "./svg/olTable.svg": __vite_glob_0_48, "./svg/outlineKP.svg": __vite_glob_0_49, "./svg/pageCollage.svg": __vite_glob_0_50, "./svg/pagePanelCart.svg": __vite_glob_0_51, "./svg/pagePanelPlus.svg": __vite_glob_0_52, "./svg/pagesTool.svg": __vite_glob_0_53, "./svg/pictureTool.svg": __vite_glob_0_54, "./svg/portraitOrientationBtn.svg": __vite_glob_0_55, "./svg/rectangleTool.svg": __vite_glob_0_56, "./svg/redoArrowTool.svg": __vite_glob_0_57, "./svg/reflectHorizontal.svg": __vite_glob_0_58, "./svg/reflectVertical.svg": __vite_glob_0_59, "./svg/rotate.svg": __vite_glob_0_60, "./svg/rotateLeft.svg": __vite_glob_0_61, "./svg/rotateRight.svg": __vite_glob_0_62, "./svg/rowOver.svg": __vite_glob_0_63, "./svg/rowUnder.svg": __vite_glob_0_64, "./svg/solid.svg": __vite_glob_0_65, "./svg/splitCells.svg": __vite_glob_0_66, "./svg/splitTable.svg": __vite_glob_0_67, "./svg/tableCustomValues.svg": __vite_glob_0_68, "./svg/tableTool.svg": __vite_glob_0_69, "./svg/textAlignCenter.svg": __vite_glob_0_70, "./svg/textAlignHeight.svg": __vite_glob_0_71, "./svg/textAlignJustify.svg": __vite_glob_0_72, "./svg/textAlignLeft.svg": __vite_glob_0_73, "./svg/textAlignRight.svg": __vite_glob_0_74, "./svg/textPanelUl.svg": __vite_glob_0_75, "./svg/textTool.svg": __vite_glob_0_76, "./svg/topPanelModules.svg": __vite_glob_0_77, "./svg/triangleBottom.svg": __vite_glob_0_78, "./svg/triangleGenerated.svg": __vite_glob_0_79, "./svg/triangleLeft.svg": __vite_glob_0_80, "./svg/undoArrowTool.svg": __vite_glob_0_81, "./svg/width.svg": __vite_glob_0_82, "./svg/x.svg": __vite_glob_0_83, "./svg/y.svg": __vite_glob_0_84 });
  for (const Un in zn) {
    const Kn = Un.replace("./svg/", "").replace(".svg", ""), qn = zn[Un];
    Mh.svgCollection.set(Kn, qn);
  }
}), /**
 * Возвращает мапу сгенерированных svg, где ключ это название файла и значение svg в виде строки.
 */
Ca(Mh, "getSVGCollection", () => new Map(Mh.svgCollection)), /**
 * Возвращает объект `Path` из коллекции svg.
 * @param name Имя svg из коллекции.
 */
Ca(Mh, "getSvg", (zn) => {
  const Un = Mh.svgCollectionPath.get(zn);
  if (!Un)
    throw new Error(`Path ${zn} not found`);
  return new Vn(Un.path, {
    fill: Un.fill,
    stroke: Un.stroke,
    strokeWidth: 0
  });
}), /**
 * Возвращает объект `Group` из коллекции svg (для цветных svg).
 * @param name Имя svg из коллекции.
 */
Ca(Mh, "getSvgGroup", (zn) => {
  const Un = Mh.svgCollectionGroup.get(zn);
  if (!Un || !(Un instanceof Mr))
    throw new Error(`Group '${zn}' not found or is not a valid Group object`);
  const Kn = new Mr(
    Un.getObjects().map((qn) => {
      if (qn instanceof Vn)
        return new Vn(qn.path, {
          fill: qn.fill,
          // Сохраняем цвет
          stroke: qn.stroke,
          strokeWidth: 0
        });
      throw new Error(`Path '${zn}' not found or is not a valid Group object`);
    })
  );
  return Kn.set({
    left: 400,
    top: 200
  }), Kn;
}), Ca(Mh, "generateGroupSVGAsync", async () => {
  for (const [zn, Un] of Mh.getSVGCollection())
    try {
      const { objects: Kn } = await fa(Un);
      if (Kn && Kn.length > 0) {
        const qn = [];
        if (Kn.forEach((Jo) => {
          if (Jo === null)
            throw new Error("svg does not contain any content");
          if (Jo instanceof Vn) {
            const pa = Jo;
            qn.push(
              new Vn(pa.path, {
                fill: pa.fill,
                // Сохраняем оригинальный цвет
                stroke: pa.stroke,
                strokeWidth: pa.strokeWidth
              })
            );
          }
        }), qn.length > 0) {
          const Jo = new Mr(qn);
          Mh.svgCollectionGroup.set(zn, Jo);
        } else
          console.error(`SVG '${zn}' не содержит объектов Path.`);
      } else
        console.error(`SVG '${zn}' не содержит объектов.`);
    } catch (Kn) {
      console.error(`Ошибка при обработке SVG '${zn}':`, Kn);
    }
}), Ca(Mh, "generatePathSVGAsync", async () => {
  for (const [zn, Un] of Mh.getSVGCollection())
    try {
      const { objects: Kn, options: qn } = await fa(Un);
      if (Kn && Kn.length > 0) {
        const Jo = un.groupSVGElements(Kn);
        if (Jo instanceof Mr) {
          const pa = Jo;
          let ma = [];
          pa.getObjects().forEach((_a) => {
            _a.type === "path" && (ma = ma.concat(_a.path));
          });
          const ba = new Vn(ma);
          ba.stroke = null, Mh.svgCollectionPath.set(zn, ba);
        } else
          Mh.svgCollectionPath.set(zn, Jo);
      } else
        console.error(`SVG '${zn}' не содержит объектов.`);
    } catch (Kn) {
      console.error(`Ошибка при обработке SVG '${zn}':`, Kn);
    }
});
let SVGCanvasStore = Mh;
var SVGCollection = /* @__PURE__ */ ((Xn) => (Xn.PICTURE_TOOL = "pictureTool", Xn.TEXT_TOOL = "textTool", Xn.RECTANGLE_TOOL = "rectangleTool", Xn.TABLE_TOOL = "tableTool", Xn.LINE_TOOL = "lineTool", Xn.AI_TOOL = "aiTool", Xn.UNDO_ARROW_TOOL = "undoArrowTool", Xn.REDO_ARROW_TOOL = "redoArrowTool", Xn.MODAL_TOOL = "modalTool", Xn.ARROW_DOWN = "arrowDown", Xn.ARROW_UP = "arrowUp", Xn.BACK_BUTTON = "backButton", Xn.BOOM = "boom", Xn.BORDER_WIDTH = "borderWidth", Xn.CANCELED = "canceled", Xn.CLOSE = "close", Xn.COLUMN_LEFT = "columnLeft", Xn.COLUMN_RIGHT = "columnRight", Xn.COMPONENT_PICTURE_PLUS = "componentPicturePlus", Xn.CORNER_RADIUS = "cornerRadius", Xn.CORNER_RADIUS_ALL = "cornerRadiusAll", Xn.CROP_IMG = "cropImg", Xn.CROSS = "cross", Xn.DASHED = "dashed", Xn.DOTED = "doted", Xn.EXCEL_LOADER = "excelLoader", Xn.EXCEL_REPLACE = "excelReplace", Xn.FONT_BOLD = "fontBold", Xn.FONT_ITALIC = "fontItalic", Xn.GENERATION_COUNTER = "generationCounter", Xn.GREEN_SAVED_CIRCLE = "greenSavedCircle", Xn.HEIGHT = "height", Xn.LANDSCAPE_ORIENTATION_BTN = "landscapeOrientationBtn", Xn.LOADER = "loader", Xn.MOVE_BACKGROUND = "moveBackground", Xn.MOVE_FOREGROUND = "moveForeground", Xn.MOVE_FORWARD = "moveForward", Xn.OL_TABLE = "olTable", Xn.OUTLINE_KP = "outlineKP", Xn.PAGE_PANEL_CART = "pagePanelCart", Xn.PAGE_PANEL_PLUS = "pagePanelPlus", Xn.PDF = "PDF", Xn.PORTRAIT_ORIENTATION_BTN = "portraitOrientationBtn", Xn.ROW_OVER = "rowOver", Xn.ROW_UNDER = "rowUnder", Xn.SOLID = "solid", Xn.TABLE_CUSTOM_VALUES = "tableCustomValues", Xn.TOP_PANEL_MODULES = "topPanelModules", Xn.WIDTH = "width", Xn.X = "x", Xn.Y = "y", Xn.COLOR_INPUT = "colorInput", Xn.ADD_IMAGE = "addImage", Xn.EDIT = "edit", Xn.PAGE_COLLAGE = "pageCollage", Xn.ALIGN_CENTER = "alignCenter", Xn.ALIGN_CENTER_VERTICAL = "alignCenterVertical", Xn.ALIGN_LEFT = "alignLeft", Xn.ALIGN_RIGHT = "alignRight", Xn.ALIGN_TOP = "alignTop", Xn.CROP_IMAGE = "cropImage", Xn.DELETE = "delete", Xn.IMG_LOAD = "imgLoad", Xn.LINK = "link", Xn.LIST_NUMBER = "listNumber", Xn.MERGE_CELLS = "mergeCells", Xn.PAGES_TOOL = "pagesTool", Xn.REFLECT_HORIZONTAL = "reflectHorizontal", Xn.REFLECT_VERTICAL = "reflectVertical", Xn.ROTATE = "rotate", Xn.ROTATE_LEFT = "rotateLeft", Xn.ROTATE_RIGHT = "rotateRight", Xn.SPLIT_CELLS = "splitCells", Xn.SPLIT_TABLE = "splitTable", Xn.TEXT_ALIGN_CENTER = "textAlignCenter", Xn.TEXT_ALIGN_HEIGHT = "textAlignHeight", Xn.TEXT_ALIGN_JUSTIFY = "textAlignJustify", Xn.TEXT_ALIGN_LEFT = "textAlignLeft", Xn.TEXT_ALIGN_RIGHT = "textAlignRight", Xn.TEXT_PANEL_UI = "textPanelUI", Xn.TRIANGLE_LEFT = "triangleLeft", Xn.TRIANGLE_BOTTOM = "triangleBottom", Xn.TRIANGLE_GENERATED = "triangleGenerated", Xn.DELETE_COLUMN = "deleteColumn", Xn.DELETE_ROW = "deleteRow", Xn))(SVGCollection || {});
class PendingImageBlock extends ImageGraphicBlock {
  constructor() {
    super();
    Ca(this, "DEFAULT_MIN_SIDE", 40);
    Ca(this, "BORDER_MARGIN", 5);
    Ca(this, "picturePath");
    Ca(this, "isPicture");
    Ca(this, "enable", () => {
      this.isEnabled = !0, this.picturePath.object.visible = !0;
    });
    Ca(this, "disable", () => {
      this.isEnabled = !1, this.picturePath.object.visible = !1;
    });
    Ca(this, "getObjects", () => [this.picturePath]);
    Ca(this, "configurePath", (Un) => {
      const { width: Kn, height: qn } = Un, Jo = Utils.numberUtils.toEvenOver(
        Math.max(this.DEFAULT_MIN_SIDE, Math.min(Kn - this.BORDER_MARGIN * 2, qn - this.BORDER_MARGIN * 2))
      );
      this.picturePath.object.scaleToWidth(Jo), this.picturePath.object.scaleToHeight(Jo);
      const pa = this.picturePath.object.getScaledWidth(), ma = this.picturePath.object.getScaledHeight();
      this.picturePath.relativePosition = {
        x: (Kn - pa) / 2,
        y: (qn - ma) / 2
      };
    });
    this.picturePath = {
      object: SVGCanvasStore.getSvg(SVGCollection.PICTURE_TOOL),
      relativePosition: { x: 0, y: 0 }
    }, this.isPicture = !0, this.addPostInjectDependenciesListener((Un) => {
      Un.graphic.addFrameConfigurationChangeListener((Kn, qn) => {
        this.configurePath(qn);
      });
    });
  }
}
class ImageTextureBlock extends ImageGraphicBlock {
  constructor() {
    super();
    Ca(this, "BORDER_THINKERS", 0.1);
    Ca(this, "DEFAULT_PICTURE_SCALE", 1);
    Ca(this, "DEFAULT_PICTURE_SIZE", 0);
    Ca(this, "picture");
    Ca(this, "pictureClipPath");
    Ca(this, "pictureTrimArea");
    Ca(this, "highlightPictureArea");
    Ca(this, "fileSourcePrefix");
    Ca(this, "postPictureUpdateListeners");
    Ca(this, "texture");
    Ca(this, "getTexture", () => ({ ...this.texture }));
    Ca(this, "enable", () => {
      this.isEnabled = !0, this.show();
    });
    Ca(this, "disable", () => {
      this.isEnabled = !1, this.hide();
    });
    Ca(this, "setFileSourcePrefix", (Un) => {
      this.fileSourcePrefix = Un;
    });
    Ca(this, "getObjects", () => [this.picture, this.pictureClipPath, this.pictureTrimArea, this.highlightPictureArea]);
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture();
      if (Kn === null)
        throw new EditorError("texture is null");
      const qn = Un(Kn);
      Kn.x !== qn.x && (this.texture.x = qn.x), Kn.y !== qn.y && (this.texture.y = qn.y), Kn.width !== qn.width && (this.texture.width = qn.width), Kn.height !== qn.height && (this.texture.height = qn.height), Kn.source !== qn.source && (this.texture.source = qn.source), qn.radius && !Utils.objectUtils.deepEqual(Kn.radius, qn.radius) && (this.texture.radius = qn.radius), Kn.source !== qn.source && (this.texture.source = qn.source, qn.source !== null && await this.loadImage(qn.source)), this.sync();
    });
    Ca(this, "getNaturalPictureSize", () => {
      const Un = this.picture.object.width, Kn = this.picture.object.height;
      if (Un === 0 || Kn === 0)
        throw new EditorError("not setup picture");
      return {
        width: Un,
        height: Kn
      };
    });
    Ca(this, "enableEditMode", () => {
      this.showHighlightArea(), this.showTrimArea(), this.hideClipPath();
    });
    Ca(this, "disableEditMode", () => {
      this.hideHighlightArea(), this.hideTrimArea(), this.showClipPath();
    });
    Ca(this, "addPostPictureUpdateListener", (Un) => {
      this.postPictureUpdateListeners.push(Un);
    });
    Ca(this, "getPictureNaturalAspectRatio", () => {
      const Un = this.getNaturalPictureSize();
      return Un.width / Un.height;
    });
    Ca(this, "show", () => {
      this.picture.object.visible = !0;
    });
    Ca(this, "hide", () => {
      this.picture.object.visible = !1;
    });
    Ca(this, "updateClipPath", (Un) => {
      const { width: Kn, height: qn } = Un, { topLeft: Jo, topRight: pa, bottomRight: ma, bottomLeft: va } = this.texture.radius, ba = Math.min(Jo, Kn / 2, qn / 2), _a = Math.min(pa, Kn / 2, qn / 2), ya = Math.min(ma, Kn / 2, qn / 2), xa = Math.min(va, Kn / 2, qn / 2), wa = 0.5522847498;
      this.pictureClipPath.object.set({
        path: [
          ["M", ba, 0],
          // Начало пути (верхний левый радиус)
          ["L", Kn - _a, 0],
          // Линия до верхнего правого угла
          [
            "C",
            Kn - _a * (1 - wa),
            0,
            // Контрольная точка 1
            Kn,
            _a * (1 - wa),
            // Контрольная точка 2
            Kn,
            _a
            // Конечная точка
          ],
          ["L", Kn, qn - ya],
          [
            "C",
            Kn,
            qn - ya * (1 - wa),
            Kn - ya * (1 - wa),
            qn,
            Kn - ya,
            qn
          ],
          ["L", xa, qn],
          [
            "C",
            xa * (1 - wa),
            qn,
            0,
            qn - xa * (1 - wa),
            0,
            qn - xa
          ],
          ["L", 0, ba],
          ["C", 0, ba * (1 - wa), ba * (1 - wa), 0, ba, 0],
          ["Z"]
          // Замыкание пути
        ]
      });
    });
    Ca(this, "updateHighlightArea", (Un, Kn) => {
      const { x: qn, y: Jo, width: pa, height: ma } = Kn, { width: va, height: ba } = Un, _a = qn, ya = Jo, xa = _a + pa, wa = ya + ma;
      this.highlightPictureArea.object.set({
        path: [
          // Рамка картинки
          ["M", _a, ya],
          ["L", xa, ya],
          ["L", xa, wa],
          ["L", _a, wa],
          ["Z"],
          // Рамка фрейма (прозрачная область внутри)
          ["M", 0, 0],
          ["L", va, 0],
          ["L", va, ba],
          ["L", 0, ba],
          ["Z"]
        ]
      });
    });
    Ca(this, "updatePicture", (Un) => {
      this.picture.object.set({
        scaleX: Un.width / this.picture.object.width || this.DEFAULT_PICTURE_SCALE,
        scaleY: Un.height / this.picture.object.height || this.DEFAULT_PICTURE_SCALE
      }), this.picture.relativePosition = { x: Un.x, y: Un.y }, this.callPostPictureUpdateListeners();
    });
    Ca(this, "updatePictureTrimArea", (Un) => {
      const { x: Kn, y: qn, width: Jo, height: pa } = Un, ma = Kn, va = qn, ba = ma + Jo, _a = va + pa;
      this.pictureTrimArea.object.set({
        path: [
          ["M", ma, va],
          ["L", ba, va],
          ["L", ba, _a],
          ["L", ma, _a],
          ["Z"],
          ["M", ma + this.BORDER_THINKERS, va + this.BORDER_THINKERS],
          ["L", ba - this.BORDER_THINKERS, va + this.BORDER_THINKERS],
          ["L", ba - this.BORDER_THINKERS, _a - this.BORDER_THINKERS],
          ["L", ma + this.BORDER_THINKERS, _a - this.BORDER_THINKERS],
          ["Z"]
        ]
      });
    });
    Ca(this, "sync", () => {
      const Un = this.dependencies.graphic.getFrameConfiguration();
      this.updatePicture(this.texture), this.updateClipPath(Un), this.updatePictureTrimArea(this.texture), this.updateHighlightArea(Un, this.texture);
    });
    Ca(this, "showTrimArea", () => {
      this.pictureTrimArea.object.visible = !0;
    });
    Ca(this, "hideTrimArea", () => {
      this.pictureTrimArea.object.visible = !1;
    });
    Ca(this, "showHighlightArea", () => {
      this.highlightPictureArea.object.visible = !0;
    });
    Ca(this, "hideHighlightArea", () => {
      this.highlightPictureArea.object.visible = !1;
    });
    Ca(this, "showClipPath", () => {
      this.picture.object.set({ clipPath: this.pictureClipPath.object });
    });
    Ca(this, "hideClipPath", () => {
      this.picture.object.set({ clipPath: "" });
    });
    Ca(this, "callPostPictureUpdateListeners", () => {
      this.postPictureUpdateListeners.forEach((Un) => Un());
    });
    const Un = new Image(this.DEFAULT_PICTURE_SIZE, this.DEFAULT_PICTURE_SIZE);
    this.picture = {
      object: new $o(Un),
      relativePosition: { x: 0, y: 0 }
    }, this.highlightPictureArea = {
      object: new Vn("", {
        objectCaching: !1,
        fill: "rgba(255,255,255,0.75)",
        fillRule: "evenodd",
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.pictureTrimArea = {
      object: new Vn("", {
        objectCaching: !1,
        strokeWidth: 1,
        stroke: "rgb(152,152,152)",
        fillRule: "evenodd",
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.pictureClipPath = {
      object: new Vn("", {
        objectCaching: !1,
        visible: !1,
        absolutePositioned: !0
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.showClipPath(), this.postPictureUpdateListeners = [], this.texture = {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      rotate: 0,
      source: null,
      radius: {
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    }, this.fileSourcePrefix = null, this.addPostInjectDependenciesListener((Kn) => {
      Kn.graphic.addFrameConfigurationChangeListener((qn, Jo) => {
        this.updateClipPath(Jo);
      });
    });
  }
  async loadImage(Un) {
    if (!this.fileSourcePrefix)
      throw new EditorError("File source prefix not found");
    const Kn = `${this.fileSourcePrefix}/${Un}`;
    await this.picture.object.setSrc(Kn);
    const { width: qn, height: Jo } = this.picture.object;
    !this.texture.width && !this.texture.height && await this.setTexture((pa) => ({
      ...pa,
      width: qn,
      height: Jo
    })), this.sync();
  }
}
class SpatialPictureArea extends SpatialArea {
  constructor(Un, Kn) {
    super();
    Ca(this, "type", SpatialCanvasAreaType.PICTURE);
    Ca(this, "graphic");
    Ca(this, "pictureState");
    Ca(this, "getData", () => ({
      graphic: this.graphic,
      pictureState: this.pictureState
    }));
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.graphic.getGlobalPosition(), Kn = this.pictureState.getTexture();
      return {
        x: Un.x + Kn.x,
        y: Un.y + Kn.y,
        width: Kn.width,
        height: Kn.height,
        rotate: Kn.rotate
      };
    });
    Ca(this, "getRelatedFrames", () => [this.pictureState]);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !0);
    this.graphic = Un, this.pictureState = Kn;
  }
}
class ImageState extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MIN_WIDTH", 40);
    Ca(this, "DEFAULT_MIN_HEIGHT", 40);
    Ca(this, "componentAlignment");
    Ca(this, "postMutationEvents");
    Ca(this, "minWidth");
    Ca(this, "minHeight");
    Ca(this, "blocks");
    Ca(this, "pictureArea");
    Ca(this, "pictureResizeAreas");
    Ca(this, "pendingBlock");
    Ca(this, "textureBlock");
    Ca(this, "loadingBlock");
    Ca(this, "getSpatialAreas", () => (this.pictureArea === null && (this.pictureArea = new SpatialPictureArea(this.dependencies.graphic, this)), this.pictureResizeAreas.length === 0 && (this.pictureResizeAreas = this.getResizeAreas()), [this.pictureArea, ...this.pictureResizeAreas]));
    Ca(this, "enablePendingPicture", () => {
      this.disableBlocks(), this.pendingBlock.enable();
    });
    Ca(this, "enableTextureBlock", async (Un) => {
      this.disableBlocks(), await this.textureBlock.setTexture(() => Un), this.textureBlock.enable();
    });
    Ca(this, "enableLoadingBlock", () => {
      this.disableBlocks(), this.loadingBlock.enable();
    });
    Ca(this, "setFileSourcePrefix", (Un) => {
      this.textureBlock.setFileSourcePrefix(Un);
    });
    Ca(this, "getTexture", () => {
      const Un = this.textureBlock.getTexture();
      return {
        ...Un,
        y: Math.round(Un.y),
        x: Math.round(Un.x),
        height: Math.round(Un.height),
        width: Math.round(Un.width)
      };
    });
    Ca(this, "enableEditMode", () => {
      if (!this.pendingBlock.isBlockEnabled()) {
        this.textureBlock.enableEditMode();
        return;
      }
    });
    Ca(this, "disableEditMode", () => {
      if (!this.pendingBlock.isBlockEnabled()) {
        this.textureBlock.disableEditMode();
        return;
      }
      this.textureBlock.disableEditMode();
    });
    Ca(this, "getFrameArea", () => {
      const Un = this.textureBlock.getTexture();
      return Un === null ? {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        rotate: 0
      } : Un;
    });
    /**
     * Очищает состояние от изображения.
     */
    Ca(this, "clear", async () => {
      await this.textureBlock.setTexture(() => ({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        rotate: 0,
        source: null,
        radius: {
          topLeft: 0,
          topRight: 0,
          bottomLeft: 0,
          bottomRight: 0
        }
      }));
    });
    Ca(this, "addMutationListener", (Un) => {
      this.postMutationEvents.push(Un);
    });
    Ca(this, "getPostMutationEvents", () => [...this.postMutationEvents]);
    Ca(this, "mutateFrameArea", async (Un) => {
      const Kn = this.getTexture();
      if (Kn === null) {
        const Jo = Un({
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          rotate: 0
        });
        await this.textureBlock.setTexture(() => ({
          ...Jo,
          source: "",
          radius: {
            topLeft: 0,
            topRight: 0,
            bottomLeft: 0,
            bottomRight: 0
          }
        }));
        return;
      }
      const qn = Un(Kn);
      await this.textureBlock.setTexture((Jo) => ({
        ...Jo,
        ...qn
      }));
    });
    Ca(this, "getResizeAreas", () => [
      new SpatialImageResizeArea(this.dependencies.graphic, this, AreaResizeTrigger.LEFT),
      new SpatialImageResizeArea(this.dependencies.graphic, this, AreaResizeTrigger.TOP),
      new SpatialImageResizeArea(this.dependencies.graphic, this, AreaResizeTrigger.RIGHT),
      new SpatialImageResizeArea(this.dependencies.graphic, this, AreaResizeTrigger.BOTTOM),
      new SpatialImageResizeAngularArea(this.dependencies.graphic, this, AreaResizeTrigger.LEFT_TOP),
      new SpatialImageResizeAngularArea(this.dependencies.graphic, this, AreaResizeTrigger.RIGHT_TOP),
      new SpatialImageResizeAngularArea(this.dependencies.graphic, this, AreaResizeTrigger.RIGHT_BOTTOM),
      new SpatialImageResizeAngularArea(this.dependencies.graphic, this, AreaResizeTrigger.LEFT_BOTTOM)
    ]);
    /**
     * Адаптирует изображение под размеры фрейма.
     * @param frameConfiguration - конфигурация фрейма
     * @param frameAspectRatio - соотношение сторон фрейма
     */
    Ca(this, "adaptPicture", async (Un, Kn) => {
      const qn = this.textureBlock.getPictureNaturalAspectRatio(), Jo = this.textureBlock.getNaturalPictureSize();
      let pa = this.textureBlock.getTexture();
      Kn < qn ? (pa = this.placePictureAtHeight(pa, Jo, Un), pa = this.placePictureHorizontalCenter(pa, Un)) : (pa = this.placePictureAtWidth(pa, Jo, Un), pa = this.placePictureVerticalCenter(pa, Un)), await this.textureBlock.setTexture(() => pa);
    });
    /**
     * Адаптирует размер фрейма под изображение, при этом, при необходимости, занимая
     * все свободное (учитывая отступы страницы, если графика первая на странице) пространство.
     * @param pictureGraphic - графика изображения
     * @param pictureComponent - компонент изображения
     */
    Ca(this, "adaptFrame", async (Un, Kn) => {
      const qn = this.textureBlock.getTexture();
      if (qn === null)
        throw new EditorError("texture is null");
      let Jo = {
        ...qn,
        y: 0,
        x: 0
      };
      const pa = Un.getParentGraphic();
      if (pa === null)
        throw new EditorError("parent graphic is null");
      let ma = 0, va = 0;
      const ba = this.textureBlock.getNaturalPictureSize();
      if (pa.type === GraphicType.PAGE) {
        const _a = pa, ya = _a.getTexture(), { width: xa } = _a.getFrameObject().object, wa = Un.getFrameConfiguration();
        va = _a.getAvailableSpaceX(), ma = xa - wa.x - ya.paddingRight;
      } else {
        const { width: _a } = pa.getFrameConfiguration();
        va = _a, ma = _a;
      }
      if (ba.width > ma && (this.componentAlignment.alignLeft(Kn), ba.width > va)) {
        Jo = this.alignAndFillAvailableSpace(Jo, va, Un), await this.textureBlock.setTexture(() => Jo);
        return;
      }
      Jo = this.adaptFromNaturalSize(Jo, Un, ba), await this.textureBlock.setTexture(() => Jo);
    });
    Ca(this, "addPostPictureUpdateListener", (Un) => {
      this.textureBlock.addPostPictureUpdateListener(Un);
    });
    Ca(this, "addPostLoadingAnimationListener", (Un) => {
      this.loadingBlock.addPostLoadingAnimationListener(Un);
    });
    Ca(this, "hasPicture", () => this.textureBlock.getTexture().source !== null);
    Ca(this, "getPictureAspectRatio", () => this.textureBlock.isBlockEnabled() ? this.textureBlock.getPictureNaturalAspectRatio() : null);
    Ca(this, "disableBlocks", () => {
      this.blocks.forEach((Un) => Un.disable());
    });
    Ca(this, "getMinWidth", () => this.minWidth);
    Ca(this, "getMinHeight", () => this.minHeight);
    Ca(this, "isMaintainAspectRatio", () => !0);
    Ca(this, "placePictureAtHeight", (Un, Kn, qn) => {
      const Jo = qn.height / Kn.height, pa = Kn.height * Jo, ma = Kn.width * Jo;
      return {
        ...Un,
        width: ma,
        height: pa
      };
    });
    Ca(this, "placePictureHorizontalCenter", (Un, Kn) => {
      const qn = (Kn.width - Un.width) / 2;
      return {
        ...Un,
        x: qn,
        y: 0
      };
    });
    Ca(this, "placePictureAtWidth", (Un, Kn, qn) => {
      const Jo = qn.width / Kn.width, pa = Kn.height * Jo, ma = Kn.width * Jo;
      return {
        ...Un,
        width: ma,
        height: pa
      };
    });
    Ca(this, "placePictureVerticalCenter", (Un, Kn) => {
      const qn = (Kn.height - Un.height) / 2;
      return {
        ...Un,
        y: qn,
        x: 0
      };
    });
    Ca(this, "alignAndFillAvailableSpace", (Un, Kn, qn) => {
      const Jo = this.textureBlock.getPictureNaturalAspectRatio(), pa = Kn, ma = Kn / Jo;
      return qn.setFrameConfiguration((va) => ({
        ...va,
        width: pa,
        height: ma
      })), {
        ...Un,
        width: pa,
        height: ma
      };
    });
    Ca(this, "adaptFromNaturalSize", (Un, Kn, qn) => (Kn.setFrameConfiguration((Jo) => ({
      ...Jo,
      width: qn.width,
      height: qn.height
    })), {
      ...Un,
      width: qn.width,
      height: qn.height
    }));
    this.blocks = [], this.postMutationEvents = [], this.minWidth = this.DEFAULT_MIN_WIDTH, this.minHeight = this.DEFAULT_MIN_HEIGHT, this.componentAlignment = new ComponentAlignment(), this.pendingBlock = new PendingImageBlock(), this.textureBlock = new ImageTextureBlock(), this.loadingBlock = new LoadingPictureBlock(), this.pictureArea = null, this.pictureResizeAreas = [], this.addPostInjectDependenciesListener((Un) => {
      const { graphic: Kn } = Un;
      this.pendingBlock.forceInjectDependencies({ graphic: Kn }), this.textureBlock.forceInjectDependencies({ graphic: Kn }), this.loadingBlock.forceInjectDependencies({ graphic: Kn }), this.blocks.push(this.pendingBlock, this.textureBlock, this.loadingBlock);
    });
  }
}
class PageBackgroundImageState extends ImageState {
  constructor() {
    super();
    Ca(this, "getObjects", () => [this.loadingBlock.getObject(), ...this.textureBlock.getObjects()]);
  }
}
class PageGraphic extends Graphic {
  constructor() {
    super();
    // Константы размеров A4
    Ca(this, "A4_LONG_SIDE", 1123);
    // Длинная сторона A4 (в пикселях при DPI 96)
    Ca(this, "A4_SHORT_SIDE", 794);
    // Короткая сторона A4 (в пикселях при DPI 96)
    Ca(this, "type", GraphicType.PAGE);
    Ca(this, "backgroundImageState");
    Ca(this, "topPageHeader");
    Ca(this, "bottomPageHeader");
    Ca(this, "backgroundColor");
    Ca(this, "paddingBottom");
    Ca(this, "paddingTop");
    Ca(this, "paddingLeft");
    Ca(this, "paddingRight");
    Ca(this, "orientation");
    Ca(this, "fileSourcePrefix");
    Ca(this, "repeatingImageTexture");
    Ca(this, "setFileSourcePrefix", (Un) => {
      this.fileSourcePrefix = Un, this.backgroundImageState.setFileSourcePrefix(Un);
    });
    Ca(this, "setBackgroundColor", async (Un) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      await this.backgroundImageState.clear(), this.clearRepeatingImage(), this.backgroundColor = Un, this.graphicObject.object.fill = Un;
    });
    Ca(this, "connectTopPageHeader", (Un) => {
      this.topPageHeader = Un;
    });
    Ca(this, "connectBottomPageHeader", (Un) => {
      this.bottomPageHeader = Un;
    });
    Ca(this, "syncBottomPageHeader", () => {
      if (this.bottomPageHeader === null)
        throw new EditorError("page header doesnt connected");
      this.bottomPageHeader.sync();
    });
    Ca(this, "syncTopPageHeader", () => {
      if (this.topPageHeader === null)
        throw new EditorError("page header doesnt connected");
      this.topPageHeader.sync();
    });
    Ca(this, "showBottomPageHeader", () => {
      if (this.bottomPageHeader === null)
        throw new EditorError("page header doesnt connected");
      this.bottomPageHeader.show();
    });
    Ca(this, "hideBottomPageHeader", () => {
      if (this.bottomPageHeader === null)
        throw new EditorError("page header doesnt connected");
      this.bottomPageHeader.hide();
    });
    Ca(this, "pageHeaderDisableHover", () => {
      this.topPageHeader && this.topPageHeader.disableHover(), this.bottomPageHeader && this.bottomPageHeader.disableHover();
    });
    Ca(this, "enableBackgroundPictureLoadingMode", () => {
      this.backgroundImageState.enableLoadingBlock();
    });
    Ca(this, "disableBackgroundPictureLoadingMode", () => {
      this.backgroundImageState.disableBlocks();
    });
    Ca(this, "setOrientation", (Un) => {
      switch (Un) {
        case Orientation.PORTRAIT: {
          this.setFrameConfiguration((Kn) => ({
            ...Kn,
            width: this.A4_SHORT_SIDE,
            height: this.A4_LONG_SIDE
          }));
          break;
        }
        case Orientation.LANDSCAPE: {
          this.setFrameConfiguration((Kn) => ({
            ...Kn,
            width: this.A4_LONG_SIDE,
            height: this.A4_SHORT_SIDE
          }));
          break;
        }
        default:
          throw new EditorError(`orientation "${Un}" not found`);
      }
      this.orientation = Un;
    });
    /**
     * Возвращает доступное пространство для компонентов по оси y (высота страницы минус верхний и нижний отступ).
     */
    Ca(this, "getAvailableSpaceY", () => {
      const Un = this.getTexture(), { height: Kn } = this.getFrameConfiguration(), qn = Kn - Un.paddingTop - Un.paddingBottom;
      if (qn < 0)
        throw new EditorError("available y space < 0");
      return qn;
    });
    /**
     * Возвращает доступное пространство для компонентов по оси x (ширина страницы минус левый и правый отступ).
     */
    Ca(this, "getAvailableSpaceX", () => {
      const Un = this.getTexture(), { width: Kn } = this.getFrameConfiguration(), qn = Kn - Un.paddingLeft - Un.paddingRight;
      if (qn < 0)
        throw new EditorError("available y space < 0");
      return qn;
    });
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { texture: Jo, id: pa, offset: ma, frame: va } = qn;
      if (Jo === null)
        throw new EditorError("page graphic texture cannot be null");
      if (va === null)
        throw new EditorError("page graphic frame cannot be null");
      this.id = pa, this.offset = ma, await this.setTexture(() => Jo), this.setFrameConfiguration(() => va);
    });
    Ca(this, "getTexture", () => ({
      backgroundColor: this.backgroundColor,
      orientation: this.orientation,
      paddingLeft: this.paddingLeft,
      paddingRight: this.paddingRight,
      paddingTop: this.paddingTop,
      paddingBottom: this.paddingBottom,
      backgroundImage: this.backgroundImageState.hasPicture() ? this.backgroundImageState.getTexture() : null,
      repeatingImage: this.repeatingImageTexture !== null ? { ...this.repeatingImageTexture } : null
    }));
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture(), qn = Un(Kn), {
        backgroundColor: Jo,
        orientation: pa,
        paddingBottom: ma,
        paddingTop: va,
        paddingRight: ba,
        paddingLeft: _a,
        backgroundImage: ya,
        repeatingImage: xa
      } = qn;
      if (Jo !== null && Jo !== "")
        this.clearRepeatingImage(), await this.backgroundImageState.clear(), await this.setBackgroundColor(Jo);
      else if (ya !== null)
        this.backgroundColor = null, this.clearRepeatingImage(), await this.backgroundImageState.enableTextureBlock(ya);
      else if (xa !== null)
        this.backgroundColor = null, await this.backgroundImageState.clear(), await this.setRepeatingImage(xa);
      else
        throw new EditorError("invalid page texture");
      this.setOrientation(pa), this.paddingBottom = ma, this.paddingTop = va, this.paddingRight = ba, this.paddingLeft = _a;
    });
    /**
     * Устанавливает изображение в качестве повторяющегося фона.
     * @param repeatingImage сигнатура изображения.
     */
    Ca(this, "setRepeatingImage", async (Un) => new Promise((Kn) => {
      this.repeatingImageTexture = {
        source: Un.source,
        size: Un.size
      }, this.backgroundImageState.clear(), this.backgroundImageState.disableBlocks(), this.backgroundColor = null;
      const qn = new Image();
      qn.onload = () => {
        if (this.graphicObject === null)
          throw new EditorError("graphic object not initialized");
        if (this.repeatingImageTexture === null)
          throw new EditorError("repeating texture not found");
        const Jo = new Bn({
          source: qn,
          repeat: "repeat",
          patternTransform: [
            this.repeatingImageTexture.size / qn.width,
            0,
            0,
            this.repeatingImageTexture.size / qn.height,
            0,
            0
          ]
        });
        this.graphicObject.object.set({
          fill: Jo
        }), Kn();
      }, qn.src = `${this.fileSourcePrefix}/${this.repeatingImageTexture.source}`;
    }));
    /**
     * Устанавливает изображение в качестве фона, используется только при первой установке пользователем.
     * @param pictureSource - идентификатор изображения
     */
    Ca(this, "setBackgroundImage", async (Un) => {
      const qn = {
        ...this.backgroundImageState.getTexture(),
        source: Un
      }, Jo = this.getFrameAspectRatio(), pa = this.getFrameConfiguration();
      await this.backgroundImageState.enableTextureBlock(qn), await this.backgroundImageState.adaptPicture(pa, Jo), this.backgroundColor = null, this.clearRepeatingImage(), this.backgroundImageState.enableEditMode();
    });
    Ca(this, "clearRepeatingImage", () => {
      if (this.repeatingImageTexture = null, this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.set({
        fill: "transparent"
      });
    });
    Ca(this, "getSpatialAreas", () => {
      this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this));
      const Un = [this.graphicArea];
      return this.backgroundImageState.hasPicture() && Un.push(...this.backgroundImageState.getSpatialAreas()), this.topPageHeader !== null && Un.push(...this.topPageHeader.getSpatialAreas()), this.bottomPageHeader !== null && Un.push(...this.bottomPageHeader.getSpatialAreas()), Un;
    });
    Ca(this, "removeBackgroundImage", () => {
      this.backgroundImageState.disableBlocks();
    });
    Ca(this, "addPostPictureUpdateListener", (Un) => {
      this.backgroundImageState.addPostPictureUpdateListener(Un);
    });
    Ca(this, "hasBackgroundImage", () => this.getTexture().backgroundImage !== null);
    /**
     * Растягивает фоновое изображение по высоте.
     */
    Ca(this, "stretchBackgroundImageToHeight", async () => {
      const Un = this.getFrameAspectRatio(), Kn = this.getFrameConfiguration();
      await this.backgroundImageState.adaptPicture(Kn, Un);
    });
    Ca(this, "getA4LongSide", () => this.A4_LONG_SIDE);
    Ca(this, "getA4ShortSide", () => this.A4_SHORT_SIDE);
    Ca(this, "getBackgroundImageState", () => this.backgroundImageState);
    Ca(this, "getUniqueTexture", () => this.getTexture());
    Ca(this, "getObjects", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      const Un = [
        this.frameObject,
        this.graphicObject,
        ...this.backgroundImageState.getObjects()
      ];
      return this.topPageHeader && Un.push(...this.topPageHeader.getObjects()), this.bottomPageHeader && Un.push(...this.bottomPageHeader.getObjects()), Un;
    });
    Ca(this, "getFrameAspectRatio", () => {
      const Un = this.getFrameConfiguration();
      return Un.width / Un.height;
    });
    Ca(this, "startMutation", () => {
      this.backgroundImageState.enableEditMode();
    });
    Ca(this, "finishMutation", () => {
      this.backgroundImageState.disableEditMode();
    });
    this.topPageHeader = null, this.bottomPageHeader = null, this.graphicObject = {
      object: new pr(),
      relativePosition: { x: 0, y: 0 }
    }, this.repeatingImageTexture = null, this.backgroundImageState = new PageBackgroundImageState(), this.backgroundImageState.connectDependencies({
      graphic: this
    }), this.backgroundImageState.injectDependencies(), this.backgroundColor = "null", this.paddingBottom = 0, this.paddingTop = 0, this.paddingLeft = 0, this.paddingRight = 0, this.fileSourcePrefix = null, this.orientation = Orientation.PORTRAIT, this.addFrameConfigurationChangeListener((Un, Kn) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.set({
        width: Kn.width,
        height: Kn.height
      });
    }), this.sizePanel.disable();
  }
}
var AreaMutationEventStage = /* @__PURE__ */ ((Xn) => (Xn[Xn.START = 0] = "START", Xn[Xn.PROCESS = 1] = "PROCESS", Xn[Xn.STOP = 2] = "STOP", Xn))(AreaMutationEventStage || {}), AreaMutationEventType = /* @__PURE__ */ ((Xn) => (Xn[Xn.POSITION = 0] = "POSITION", Xn[Xn.SIZE = 1] = "SIZE", Xn[Xn.COLUMN = 2] = "COLUMN", Xn[Xn.ROW = 3] = "ROW", Xn))(AreaMutationEventType || {});
class PictureTextureState extends ImageState {
  constructor(zn) {
    super(), this.forceInjectDependencies({ graphic: zn });
  }
  getObjects() {
    return [this.loadingBlock.getObject(), ...this.pendingBlock.getObjects(), ...this.textureBlock.getObjects()];
  }
}
class PictureGraphic extends Graphic {
  constructor() {
    super();
    Ca(this, "type", GraphicType.PICTURE);
    Ca(this, "DIFF_RANGE_BIND_PICTURE_FRAME_SIZE", 20);
    Ca(this, "UPPER_POSITION_RANGE_LIMIT", this.DIFF_RANGE_BIND_PICTURE_FRAME_SIZE / 2);
    Ca(this, "LOWER_POSITION_RANGE_LIMIT", -this.DIFF_RANGE_BIND_PICTURE_FRAME_SIZE / 2);
    Ca(this, "PICTURE_MIN_WIDTH", 55);
    Ca(this, "PICTURE_MIN_HEIGHT", 55);
    Ca(this, "textureState");
    Ca(this, "pictureActionLayer");
    Ca(this, "startMutatePicturePosition");
    Ca(this, "isInitialPictureState");
    Ca(this, "isBindChangeSize");
    Ca(this, "connectPictureActionLayer", (Un) => {
      this.pictureActionLayer = Un;
    });
    Ca(this, "enablePictureActionLayer", () => {
      this.pictureActionLayer !== null && this.pictureActionLayer.enable();
    });
    Ca(this, "disablePictureActionLayer", () => {
      this.pictureActionLayer !== null && this.pictureActionLayer.disable();
    });
    Ca(this, "getObjects", () => {
      const Un = [this.frameObject, ...this.textureState.getObjects()];
      return this.pictureActionLayer && Un.push(...this.pictureActionLayer.getObjects()), Un;
    });
    // public getPictureAction = (): PictureActionLayer | null => this.pictureActionLayer;
    Ca(this, "getTexture", () => this.textureState.getTexture());
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { texture: Jo, frame: pa, id: ma, offset: va } = qn;
      if (Jo === null)
        throw new EditorError("picture graphic texture cannot be null");
      if (pa === null)
        throw new EditorError("picture graphic frame cannot be null");
      this.id = ma, this.offset = va, this.setFrameConfiguration(() => pa), await this.setTexture(() => Jo);
    });
    Ca(this, "setTexture", async (Un) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      const Kn = this.getTexture(), qn = Un(Kn);
      if (qn.source === null) {
        this.textureState.enablePendingPicture();
        return;
      }
      await this.textureState.enableTextureBlock({
        ...qn,
        source: qn.source
      });
    });
    /**
     * Возвращает размеры изображения в исходное состояние.
     */
    Ca(this, "resetPictureSize", async () => {
      const Un = this.getFrameAspectRatio(), Kn = this.getFrameConfiguration();
      await this.textureState.adaptPicture(Kn, Un);
    });
    /**
     * Возвращает глобальную область, которую занимает изображение.
     */
    Ca(this, "getPictureArea", () => {
      const Un = this.getGlobalPosition(), Kn = this.getTexture();
      return {
        x: Un.x + Kn.x,
        y: Un.y + Kn.y,
        width: Kn.width,
        height: Kn.height,
        rotate: 0
      };
    });
    Ca(this, "getSpatialAreas", () => {
      this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), this.resizeAreas.length === 0 && (this.resizeAreas = this.getResizeAreas());
      const Un = [this.graphicArea, ...this.resizeAreas];
      return this.pictureActionLayer !== null && Un.push(...this.pictureActionLayer.getSpatialAreas()), this.textureState.hasPicture() && Un.push(...this.textureState.getSpatialAreas()), Un;
    });
    Ca(this, "resetInitialPictureState", () => {
      this.isInitialPictureState = !1;
    });
    /**
     * Адаптирует изображение под размеры фрейма
     */
    Ca(this, "adaptPictureToFrame", async () => {
      const Un = this.getFrameAspectRatio(), Kn = this.getFrameConfiguration();
      await this.textureState.adaptPicture(Kn, Un);
    });
    /**
     * Устанавливает новое изображение.
     * @param pictureID - id нового изображения.
     */
    Ca(this, "setNewPicture", async (Un) => {
      await this.setTextureWithAdaptPicture(Un);
    });
    Ca(this, "enableCompactActionLayerMode", () => {
      this.pictureActionLayer && this.pictureActionLayer.enableCompactMode();
    });
    Ca(this, "disableCompactActionLayerMode", () => {
      this.pictureActionLayer && this.pictureActionLayer.disableCompactMode();
    });
    Ca(this, "getUniqueTexture", () => this.getTexture());
    Ca(this, "addPostPictureUpdateListener", (Un) => {
      this.textureState.addPostPictureUpdateListener(Un);
    });
    Ca(this, "addPostLoadingAnimationListener", (Un) => {
      this.textureState.addPostLoadingAnimationListener(Un);
    });
    Ca(this, "setPicture", async (Un) => {
      if (this.parentComponent === null)
        return;
      !this.parentComponent.hasAdaptPictureAfterSetup() && !this.textureState.hasPicture() ? await this.setTextureWithAdaptFrame(Un) : await this.setTextureWithAdaptPicture(Un), this.parentComponent.enableEditMode();
    });
    Ca(this, "startMutation", () => {
      this.textureState.enableEditMode();
    });
    Ca(this, "finishMutation", () => {
      this.textureState.disableEditMode();
    });
    Ca(this, "setMinSize", () => {
      this.setMinWidth(this.PICTURE_MIN_WIDTH), this.setMinHeight(this.PICTURE_MIN_HEIGHT);
    });
    Ca(this, "onPostMutationListener", async (Un, Kn) => {
      if (Un.type !== AreaMutationEventType.SIZE)
        return;
      const qn = this.isEnableEditMode();
      if (Un.stage === AreaMutationEventStage.START) {
        const Jo = this.getFrameConfiguration(), pa = this.textureState.getTexture(), ma = Math.abs(Jo.width - pa.width), va = Math.abs(Jo.height - pa.height), ba = ma < this.DIFF_RANGE_BIND_PICTURE_FRAME_SIZE, _a = va < this.DIFF_RANGE_BIND_PICTURE_FRAME_SIZE, ya = this.isInRange(
          pa.x,
          this.LOWER_POSITION_RANGE_LIMIT,
          this.UPPER_POSITION_RANGE_LIMIT
        ), xa = this.isInRange(
          pa.y,
          this.LOWER_POSITION_RANGE_LIMIT,
          this.UPPER_POSITION_RANGE_LIMIT
        );
        if (this.startMutatePicturePosition = pa, (ba || _a) && (ya || xa)) {
          if (qn)
            return;
          this.isBindChangeSize = !0;
        }
      } else if (Un.stage === AreaMutationEventStage.PROCESS) {
        if (qn) {
          await this.correctPictureWithEditMode(Kn);
          return;
        }
        await this.correctPictureWithoutEditMode(Kn);
      } else if (Un.stage === AreaMutationEventStage.STOP)
        this.isBindChangeSize = !1;
      else
        throw new EditorError("area mutation event not found");
    });
    /**
     * Устанавливает изображение, подгоняя его под размеры фрейма
     * @param pictureSource - имя файла с изображением без URI
     */
    Ca(this, "setTextureWithAdaptPicture", async (Un) => {
      const qn = {
        ...this.textureState.getTexture(),
        source: Un
      }, Jo = this.getFrameAspectRatio(), pa = this.getFrameConfiguration();
      await this.textureState.enableTextureBlock(qn), await this.textureState.adaptPicture(pa, Jo), this.textureState.enableEditMode();
    });
    /**
     * Устанавливает изображение, подгоняя под него размеры фрейма.
     * @param pictureSource - имя файла с изображением без URI
     */
    Ca(this, "setTextureWithAdaptFrame", async (Un) => {
      if (this.parentComponent === null)
        throw new EditorError("parent component is null");
      const qn = {
        ...this.textureState.getTexture(),
        source: Un
      };
      await this.textureState.enableTextureBlock(qn), await this.textureState.adaptFrame(this, this.parentComponent), this.textureState.enableEditMode();
    });
    /**
     * Корректирует характеристику изображения при изменении размеров фрейма в режиме редактирования.
     * @param frameChanges - изменения фрейма
     */
    Ca(this, "correctPictureWithEditMode", async (Un) => {
      await this.textureState.mutateFrameArea((Kn) => ({
        ...Kn,
        x: this.startMutatePicturePosition.x - Un.x,
        y: this.startMutatePicturePosition.y - Un.y
      }));
    });
    /**
     * Корректирует характеристику изображения при изменении размеров фрейма без режима редактирования.
     */
    Ca(this, "correctPictureWithoutEditMode", async (Un) => {
      if (!this.isInitialPictureState || !this.isBindChangeSize) {
        await this.textureState.mutateFrameArea((Jo) => ({
          ...Jo,
          x: this.startMutatePicturePosition.x - Un.x,
          y: this.startMutatePicturePosition.y - Un.y
        }));
        return;
      }
      const Kn = this.getFrameConfiguration(), qn = this.getFrameAspectRatio();
      await this.textureState.adaptPicture(Kn, qn);
    });
    Ca(this, "isInRange", (Un, Kn, qn) => Un > Kn && Un < qn);
    this.graphicObject = {
      object: new Vn(""),
      relativePosition: { x: 0, y: 0 }
    }, this.textureState = new PictureTextureState(this), this.textureState.enablePendingPicture(), this.pictureActionLayer = null, this.addMutationListener(this.onPostMutationListener), this.isBindChangeSize = !1, this.isInitialPictureState = !0, this.startMutatePicturePosition = { x: 0, y: 0 }, this.setMinSize();
  }
  setFileSourcePrefix(Un) {
    this.textureState.setFileSourcePrefix(Un);
  }
  enableLoadingMode() {
    this.textureState.enableLoadingBlock();
  }
}
class TableMutator {
  constructor(zn) {
    Ca(this, "mutationListeners");
    Ca(this, "component");
    Ca(this, "addMutationListener", (zn) => {
      this.mutationListeners.push(zn);
    });
    Ca(this, "getFrameArea", () => ({
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      rotate: 0
    }));
    Ca(this, "getMinWidth", () => 0);
    Ca(this, "getMinHeight", () => 0);
    Ca(this, "isMaintainAspectRatio", () => !1);
    Ca(this, "getPostMutationEvents", () => this.mutationListeners);
    const { component: Un } = zn.getData();
    if (Un === void 0)
      throw new EditorError("component not found");
    this.mutationListeners = [], this.component = Un;
  }
}
class TableColumnMutator extends TableMutator {
  constructor(Un) {
    super(Un);
    Ca(this, "MIN_COLUMN_WIDTH", 10);
    Ca(this, "initialLeftColumnWidth");
    Ca(this, "initialRightColumnWidth");
    Ca(this, "columnWidths");
    Ca(this, "targetTriggerIndex");
    Ca(this, "mutateFrameArea", async (Un) => {
      const Kn = this.getFrameArea(), qn = Un(Kn);
      if (this.targetTriggerIndex === null || this.columnWidths === null || this.component === null)
        throw new EditorError("not initializer table column components");
      const Jo = this.initialLeftColumnWidth + qn.x, pa = this.initialRightColumnWidth - qn.x;
      Jo < this.MIN_COLUMN_WIDTH || pa < this.MIN_COLUMN_WIDTH || (this.columnWidths[this.targetTriggerIndex] = Jo, this.columnWidths[this.targetTriggerIndex + 1] = pa, this.component.mutateColumnWidths(this.columnWidths), this.component.applyMutations());
    });
    const { columnIndex: Kn } = Un.getData();
    this.columnWidths = this.component.getColumnWidths(), this.targetTriggerIndex = Kn;
    const qn = this.columnWidths[this.targetTriggerIndex], Jo = this.columnWidths[this.targetTriggerIndex + 1];
    if (Jo === void 0)
      throw new EditorError("right multiplier not found");
    if (qn === void 0)
      throw new EditorError("left multiplier not found");
    this.initialLeftColumnWidth = qn, this.initialRightColumnWidth = Jo;
  }
}
class SpatialTableColumnResizeArea extends SpatialArea {
  constructor(Un, Kn, qn) {
    super();
    Ca(this, "type", SpatialCanvasAreaType.TABLE_COLUMN_RESIZE);
    Ca(this, "COLUMN_WIDTH", 10);
    Ca(this, "getGlobalFrameArea", () => {
      const Un = this.graphic.getGlobalPosition(), Kn = this.graphic.getFrameConfiguration(), qn = this.component.getColumnWidths();
      let { x: Jo } = Un;
      for (let pa = 0; pa < this.columnIndex + 1; pa++)
        Jo += qn[pa];
      return {
        x: Jo - this.COLUMN_WIDTH / 2,
        y: Un.y,
        width: this.COLUMN_WIDTH,
        height: Kn.height,
        rotate: 0
      };
    });
    Ca(this, "getData", () => ({
      graphic: this.graphic,
      component: this.component,
      columnIndex: this.columnIndex
    }));
    Ca(this, "isResizeType", () => !1);
    Ca(this, "getRelatedFrames", () => [new TableColumnMutator(this)]);
    Ca(this, "isAllowMutatePosition", () => !0);
    this.component = Un, this.graphic = Kn, this.columnIndex = qn;
  }
}
class TableGraphic extends Graphic {
  constructor() {
    super();
    Ca(this, "type", GraphicType.TABLE);
    Ca(this, "rowCount");
    Ca(this, "currentRenderCells");
    Ca(this, "columnAreas");
    Ca(this, "setCurrentRenderCells", (Un) => {
      this.currentRenderCells = Un;
    });
    Ca(this, "setColumnWidths", (Un) => {
      this.setFrameConfiguration((Kn) => ({
        ...Kn,
        width: Un.reduce((qn, Jo) => qn + Jo, 0)
      }));
    });
    Ca(this, "setRowHeights", (Un) => {
      const Kn = Un.reduce((qn, Jo) => qn + Jo, 0);
      this.setFrameConfiguration((qn) => ({
        ...qn,
        height: Kn
      }));
    });
    Ca(this, "getCurrentRenderCells", () => [...this.currentRenderCells]);
    Ca(this, "getTexture", () => ({
      rowCount: this.rowCount
    }));
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { texture: Jo, frame: pa, id: ma, offset: va } = qn;
      if (this.id = ma, this.offset = va, Jo === null)
        throw new EditorError("table graphic texture cannot be null");
      if (pa === null)
        throw new EditorError("table graphic frame cannot be null");
      this.setFrameConfiguration(() => pa), await this.setTexture(() => Jo);
    });
    Ca(this, "setTexture", async (Un) => {
      const Kn = this.getTexture(), qn = Un(Kn), { rowCount: Jo } = qn;
      this.rowCount = Jo;
    });
    Ca(this, "mutateFrameArea", async (Un) => {
      const Kn = this.getFrameConfiguration(), qn = Un(Kn);
      if (this.setFrameConfiguration((Jo) => ({
        ...Jo,
        ...qn
      })), this.parentComponent === null)
        throw new EditorError("the parent component of table is null");
      if ((Kn.width !== qn.width || Kn.height !== qn.height) && await this.parentComponent.syncWidths(), this.graphicArea !== null) {
        const Jo = [...this.resizeAreas, this.graphicArea, ...this.columnAreas];
        if (Jo.length > 0)
          for (let pa = 0; pa < Jo.length; pa++)
            Jo[pa].markDirty();
      }
    });
    /**
     * Возвращает все пространственные области, связанные с графикой таблицы.
     * которые отвечают за изменение размеров столбцов и строк
     */
    Ca(this, "getSpatialAreas", () => {
      this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), this.resizeAreas.length === 0 && (this.resizeAreas = this.getResizeAreas());
      const Un = [this.graphicArea, ...this.resizeAreas];
      if (this.isEnableEditMode()) {
        const Kn = this.getColumnAreas();
        this.columnAreas.length !== Kn.length && (this.columnAreas = Kn), Un.push(...this.columnAreas);
      }
      return Un;
    });
    Ca(this, "getSpatialGraphicArea", () => (this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), this.graphicArea));
    Ca(this, "getUniqueTexture", () => this.getTexture());
    Ca(this, "getObjects", () => this.currentRenderCells.flatMap((Un) => Un.getObjects()));
    Ca(this, "startMutation", () => {
    });
    Ca(this, "finishMutation", () => {
    });
    Ca(this, "getColumnAreas", () => {
      if (this.parentComponent === null)
        throw new EditorError("parent component not found");
      const { columnWidths: Un } = this.parentComponent.getTexture(), Kn = [];
      for (let qn = 0; qn < Un.length - 1; qn++)
        Kn.push(new SpatialTableColumnResizeArea(this.parentComponent, this, qn));
      return Kn;
    });
    this.rowCount = -1, this.currentRenderCells = [], this.columnAreas = [];
  }
}
class TextGraphic extends Graphic {
  constructor() {
    super();
    Ca(this, "type", GraphicType.TEXT);
    Ca(this, "TEXT_VIEW_PADDING", { x: 6, y: 4 });
    Ca(this, "carriage");
    Ca(this, "textSelection");
    Ca(this, "getWidthView", () => this.getFrameArea().width);
    Ca(this, "getGraphemePositions", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      return this.graphicObject.object.__charBounds;
    });
    Ca(this, "getRealLineHeights", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      return this.graphicObject.object.__lineHeights;
    });
    Ca(this, "setLineHeight", (Un) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.set("lineHeight", Un);
    });
    Ca(this, "getTextSelection", () => this.textSelection);
    Ca(this, "getTextPadding", () => this.TEXT_VIEW_PADDING);
    Ca(this, "setStructure", async (Un) => {
      const Kn = this.getStructure(), qn = Un(Kn), { frame: Jo, id: pa, offset: ma } = qn;
      if (Jo === null)
        throw new EditorError("text graphic frame cannot be null");
      this.id = pa, this.offset = ma, this.setFrameConfiguration(() => Jo);
    });
    Ca(this, "enableAutoWidth", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      const Un = new Xo("", {
        fontSize: Utils.text.parseFontSize(DefaultFontSize),
        textAlign: this.graphicObject.object.textAlign
      }), Kn = this.getFrameConfiguration();
      Un.set("width", Kn.width - this.TEXT_VIEW_PADDING.x * 2), this.graphicObject.object = Un;
    });
    Ca(this, "disableAutoWidth", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      const Un = new Yo("", {
        fontSize: Utils.text.parseFontSize(DefaultFontSize),
        textAlign: this.graphicObject.object.textAlign
      }), Kn = this.getFrameConfiguration();
      Un.set("width", Kn.width - this.TEXT_VIEW_PADDING.x * 2), this.graphicObject.object = Un;
    });
    Ca(this, "getSpatialAreas", () => (this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), this.resizeAreas.length === 0 && (this.resizeAreas = this.getResizeAreas()), [this.graphicArea, ...this.resizeAreas]));
    Ca(this, "getSpatialGraphicArea", () => (this.graphicArea === null && (this.graphicArea = new SpatialGraphicArea(this)), this.graphicArea));
    Ca(this, "setText", (Un, Kn) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.set({
        text: Un,
        styles: Utils.text.getStylesMap(Un, Kn)
      });
    });
    Ca(this, "setTextAlign", (Un) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.set({ textAlign: Un });
    });
    Ca(this, "getObjects", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      return [this.graphicObject, this.carriage.getObject(), ...this.textSelection.getObjects()];
    });
    Ca(this, "getTextCarriage", () => this.carriage);
    Ca(this, "getTexture", () => null);
    Ca(this, "getUniqueTexture", () => null);
    Ca(this, "setTexture", async () => {
    });
    Ca(this, "startMutation", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
    });
    Ca(this, "finishMutation", () => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
    });
    this.graphicObject = {
      object: new Yo("", {
        fontSize: Utils.text.parseFontSize(DefaultFontSize)
      }),
      relativePosition: { x: this.TEXT_VIEW_PADDING.x, y: this.TEXT_VIEW_PADDING.y }
    }, this.carriage = new TextCarriage(), this.textSelection = new TextViewSelection(), this.textSelection.setPositionOffset(this.TEXT_VIEW_PADDING), this.carriage.setPositionOffset(this.TEXT_VIEW_PADDING), this.addFrameConfigurationChangeListener((Un, Kn) => {
      if (this.graphicObject === null)
        throw new EditorError("graphic object not initialized");
      this.graphicObject.object.set("width", Kn.width - this.TEXT_VIEW_PADDING.x * 2);
    }), this.addPostEnableEditModeListener(this.carriage.enable), this.addPostDisableEditModeListener(this.carriage.disable);
  }
}
var ScaleSvg = /* @__PURE__ */ ((Xn) => (Xn.WIDTH = "width", Xn.HEIGHT = "height", Xn))(ScaleSvg || {}), IPlaceholderPosition = /* @__PURE__ */ ((Xn) => (Xn.LEFT = "left", Xn.RIGHT = "right", Xn))(IPlaceholderPosition || {}), TypeColorAnimated = /* @__PURE__ */ ((Xn) => (Xn.FILL = "fill", Xn.STROKE = "stroke", Xn))(TypeColorAnimated || {});
class BaseCanvasButtonView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_FILL", "#FFFFFF");
    Ca(this, "DEFAULT_SVG_COLOR", "#7f8184");
    Ca(this, "DEFAULT_BORDER_COLOR", "#000000");
    Ca(this, "DEFAULT_BORDER_RADIUS", 0);
    Ca(this, "DEFAULT_BORDER_THICKNESS", 1);
    Ca(this, "DEFAULT_TEXT_FONT_SIZE", 16);
    Ca(this, "DEFAULT_INSIDE_TEXT_TO_SVG", 5);
    Ca(this, "DEFAULT_TEXT_FONT", FontFamily.DEFAULT);
    Ca(this, "DEFAULT_PADDING", {
      leftRight: 10,
      topBottom: 5
    });
    Ca(this, "DEFAULT_FILL_HOVER", "#d6e9ff");
    Ca(this, "DEFAULT_COLOR_HOVER_SVG", "#1560e0");
    Ca(this, "DEFAULT_BORDER_COLOR_HOVER", "#000000");
    Ca(this, "DEFAULT_DURATION_HOVER", 100);
    Ca(this, "buttonObject");
    Ca(this, "configuration");
    Ca(this, "isVisible");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "showButton", () => {
      this.buttonObject.container.visible = !0, this.buttonObject.text.visible = !0, this.configuration.svg && (this.configuration.svg.visible = !0);
    });
    Ca(this, "hideButton", () => {
      this.buttonObject.container.visible = !1, this.buttonObject.text.visible = !1, this.configuration.svg && (this.configuration.svg.visible = !1);
    });
    Ca(this, "showText", () => {
      this.setConfiguration((Un) => ({
        ...Un,
        isEnableText: !0
      })), this.buttonObject.text.visible = !0;
    });
    Ca(this, "hideText", () => {
      this.setConfiguration((Un) => ({
        ...Un,
        isEnableText: !1
      })), this.buttonObject.text.visible = !1;
    });
    Ca(this, "showSvg", () => {
      this.configuration.svg && (this.configuration.svg.visible = !0);
    });
    Ca(this, "hideSvg", () => {
      this.configuration.svg && (this.configuration.svg.visible = !1);
    });
    Ca(this, "enableHover", () => {
      if (!this.isHover) {
        this.isHover = !0;
        const {
          fill: Un,
          fillHover: Kn,
          fillFocus: qn,
          borderColor: Jo,
          borderColorHover: pa,
          borderColorFocus: ma,
          textColor: va,
          textColorHover: ba,
          textColorFocus: _a,
          svgColor: ya,
          svgColorHover: xa,
          svgColorFocus: wa,
          svg: Ta,
          text: Sa
        } = this.configuration, Ma = [];
        this.isFocus ? (Kn !== null && qn === null && Ma.push({
          object: this.buttonObject.container,
          startColor: Un,
          endColor: Kn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), pa !== null && ma === null && Ma.push({
          object: this.buttonObject.container,
          startColor: Jo,
          endColor: pa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), Sa && ba !== null && _a === null && Ma.push({
          object: this.buttonObject.text,
          startColor: va,
          endColor: ba,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Ta && xa && wa === null && Ma.push({
          object: Ta,
          startColor: ya,
          endColor: xa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), this.dependencies.render.animateColor(...Ma)) : (Kn !== null && Ma.push({
          object: this.buttonObject.container,
          startColor: Un,
          endColor: Kn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), pa !== null && Ma.push({
          object: this.buttonObject.container,
          startColor: Jo,
          endColor: pa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), Sa && ba !== null && Ma.push({
          object: this.buttonObject.text,
          startColor: va,
          endColor: ba,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Ta && xa && Ma.push({
          object: Ta,
          startColor: ya,
          endColor: xa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), this.dependencies.render.animateColor(...Ma));
      }
    });
    Ca(this, "disableHover", () => {
      if (this.isHover) {
        this.isHover = !1;
        const {
          fill: Un,
          fillHover: Kn,
          borderColor: qn,
          borderColorHover: Jo,
          textColor: pa,
          textColorHover: ma,
          svgColor: va,
          svgColorHover: ba,
          svg: _a,
          text: ya
        } = this.configuration, xa = [];
        this.isFocus ? (Kn !== null && xa.push({
          object: this.buttonObject.container,
          startColor: Kn,
          endColor: Un,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Jo !== null && xa.push({
          object: this.buttonObject.container,
          startColor: Jo,
          endColor: qn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), ya && ma !== null && xa.push({
          object: this.buttonObject.text,
          startColor: ma,
          endColor: pa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), _a && ba !== null && xa.push({
          object: _a,
          startColor: ba,
          endColor: va,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        })) : (Kn !== null && xa.push({
          object: this.buttonObject.container,
          startColor: Kn,
          endColor: Un,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Jo !== null && xa.push({
          object: this.buttonObject.container,
          startColor: Jo,
          endColor: qn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), ya && ma !== null && xa.push({
          object: this.buttonObject.text,
          startColor: ma,
          endColor: pa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), _a && ba !== null && xa.push({
          object: _a,
          startColor: ba,
          endColor: va,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        })), this.dependencies.render.animateColor(...xa);
      }
    });
    Ca(this, "getFrameArea", () => {
      const Un = this.getGlobalPosition();
      return {
        width: this.getWidth(),
        height: this.getHeight(),
        x: Un.x,
        y: Un.y,
        rotate: 0
      };
    });
    Ca(this, "getGlobalPosition", () => {
      const Un = this.dependencies.parentGraphic.getGlobalPosition();
      return {
        x: this.configuration.x + Un.x,
        y: this.configuration.y + Un.y
      };
    });
    Ca(this, "getWidth", () => {
      const { isEnableText: Un, svg: Kn, padding: qn, insideTextToSvg: Jo, textFontSize: pa } = this.configuration, ma = this.buttonObject.text.width, va = qn.leftRight * 2;
      if (Un && Kn)
        return Math.round(ma + pa + Jo + va);
      if (Un)
        return Math.round(ma + va);
      if (Kn)
        return Math.round(pa + va);
      throw new EditorError("invalid configuration: unable to determine width");
    });
    Ca(this, "getHeight", () => {
      const { padding: Un, textFontSize: Kn, size: qn, svgSize: Jo } = this.configuration;
      return qn !== null ? qn.height : Jo !== null ? Jo + Un.topBottom * 2 : Kn + Un.topBottom * 2;
    });
    Ca(this, "isEnableVisible", () => this.isVisible);
    Ca(this, "getObjects", () => [
      {
        object: this.buttonObject.container,
        relativePosition: {
          x: this.configuration.x,
          y: this.configuration.y
        }
      },
      {
        object: this.buttonObject.text,
        relativePosition: {
          x: this.configuration.x + this.configuration.padding.leftRight + (this.configuration.svg ? this.configuration.svg.width + this.configuration.insideTextToSvg : 0),
          y: this.configuration.y + this.configuration.padding.topBottom
        }
      },
      {
        object: this.configuration.svg,
        relativePosition: {
          x: this.configuration.x + this.configuration.padding.leftRight,
          y: this.configuration.y + this.configuration.padding.topBottom
        }
      }
    ]);
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      if (this.configuration = qn, this.buttonObject.container.rx = qn.borderRadius, this.buttonObject.container.ry = qn.borderRadius, this.buttonObject.container.set({
        fill: qn.fill,
        stroke: qn.borderColor,
        strokeWidth: qn.borderThickness,
        width: this.getWidth(),
        height: this.getHeight()
      }), this.buttonObject.text.fill = qn.textColor, this.buttonObject.text.set({
        text: qn.text,
        fontSize: qn.textFontSize,
        fontFamily: qn.textFontFamily,
        fill: qn.textColor
      }), qn.svg) {
        const Jo = qn.svgSize ?? qn.textFontSize;
        qn.svgScale === ScaleSvg.WIDTH ? qn.svg.scaleToWidth(Jo) : qn.svgScale === ScaleSvg.HEIGHT && qn.svg.scaleToHeight(Jo), qn.svg.set({
          fill: qn.svgColor
        });
      }
    });
    /**
     * Метод первичного создание кнопки
     */
    Ca(this, "createButton", () => {
      const {
        fill: Un,
        borderColor: Kn,
        borderThickness: qn,
        x: Jo,
        y: pa,
        borderRadius: ma,
        padding: va,
        text: ba,
        textColor: _a,
        textFontSize: ya,
        textFontFamily: xa
      } = this.configuration, wa = new Xo(ba, {
        left: this.configuration.x + this.configuration.padding.leftRight,
        top: this.configuration.y + this.configuration.padding.topBottom,
        fill: _a,
        fontSize: ya,
        fontFamily: xa
      });
      return {
        container: new pr({
          left: Jo,
          top: pa,
          width: wa.width + va.leftRight,
          height: wa.height + va.topBottom,
          fill: Un,
          stroke: Kn,
          strokeWidth: qn,
          rx: ma,
          ry: ma
        }),
        text: wa
      };
    });
    this.configuration = {
      isEnableText: !0,
      borderRadius: this.DEFAULT_BORDER_RADIUS,
      fill: this.DEFAULT_FILL,
      fillHover: this.DEFAULT_FILL_HOVER,
      fillFocus: null,
      borderColor: this.DEFAULT_BORDER_COLOR,
      borderColorHover: this.DEFAULT_BORDER_COLOR_HOVER,
      borderColorFocus: null,
      borderThickness: this.DEFAULT_BORDER_THICKNESS,
      x: 0,
      y: 0,
      padding: this.DEFAULT_PADDING,
      text: "",
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE,
      textFontFamily: this.DEFAULT_TEXT_FONT,
      textColor: this.DEFAULT_SVG_COLOR,
      textColorHover: this.DEFAULT_COLOR_HOVER_SVG,
      textColorFocus: null,
      durationFocus: this.DEFAULT_DURATION_HOVER,
      durationHover: this.DEFAULT_DURATION_HOVER,
      svg: new Vn(""),
      svgScale: ScaleSvg.WIDTH,
      svgColor: UIDefaultColor.GRAY_600,
      svgColorHover: null,
      svgColorFocus: null,
      insideTextToSvg: this.DEFAULT_INSIDE_TEXT_TO_SVG,
      svgSize: null,
      size: null
    }, this.buttonObject = this.createButton(), this.isVisible = !1, this.isHover = !1, this.isFocus = !1;
  }
}
class SpatialCanvasButtonTextArea extends SpatialArea {
  constructor(Un, Kn) {
    super();
    Ca(this, "type", SpatialCanvasAreaType.BUTTON);
    Ca(this, "graphic");
    Ca(this, "button");
    Ca(this, "getGlobalFrameArea", () => this.button.getFrameArea());
    Ca(this, "getData", () => ({
      graphic: this.graphic
    }));
    Ca(this, "getButton", () => this.button);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.graphic = Un, this.button = Kn;
  }
}
class BaseCanvasButton extends BaseCanvasButtonView {
  constructor() {
    super();
    Ca(this, "areas");
    Ca(this, "postMouseDownListeners");
    Ca(this, "getSpatialAreas", () => this.areas);
    Ca(this, "addPostMouseDownListeners", (...Un) => {
      this.postMouseDownListeners.push(...Un);
    });
    Ca(this, "callClick", () => {
      this.postMouseDownListeners.forEach((Un) => Un());
    });
    Ca(this, "getUIElements", () => [this]);
    this.areas = [], this.postMouseDownListeners = [], this.addPostInjectDependenciesListener((Un) => {
      this.areas.push(new SpatialCanvasButtonTextArea(Un.parentGraphic, this));
    });
  }
}
let PageAppendButton$1 = class extends BaseCanvasButton {
  constructor() {
    super();
    Ca(this, "FILL", "transparent");
    Ca(this, "SVG_SIZE", 20);
    Ca(this, "HOVER_FILL", "#0075FF");
    Ca(this, "BORDER_RADIUS", 0);
    Ca(this, "BORDER_THICKNESS", 0);
    Ca(this, "INSIDE_TEXT_TO_SVG", 0);
    Ca(this, "DEFAULT_COLOR", "#7F8184");
    Ca(this, "PADDING", { topBottom: 0, leftRight: 0 });
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableText: !1,
      fill: this.FILL,
      svgColor: this.DEFAULT_COLOR,
      textColor: this.DEFAULT_COLOR,
      borderRadius: this.BORDER_RADIUS,
      borderThickness: this.BORDER_THICKNESS,
      svg: SVGCanvasStore.getSvg(SVGCollection.PAGE_PANEL_PLUS),
      padding: this.PADDING,
      svgSize: this.SVG_SIZE,
      insideTextToSvg: this.INSIDE_TEXT_TO_SVG,
      fillHover: this.FILL,
      borderColorHover: this.FILL,
      textColorHover: this.FILL,
      svgColorHover: this.HOVER_FILL
    }));
  }
};
class PageAppendButton extends BaseCanvasButton {
  constructor() {
    super();
    Ca(this, "FILL", "transparent");
    Ca(this, "HOVER_FILL", "#0075FF");
    Ca(this, "SVG_SIZE", 20);
    Ca(this, "BORDER_RADIUS", 0);
    Ca(this, "BORDER_THICKNESS", 0);
    Ca(this, "INSIDE_TEXT_TO_SVG", 0);
    Ca(this, "DEFAULT_COLOR", "#7F8184");
    Ca(this, "PADDING", { topBottom: 0, leftRight: 0 });
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableText: !1,
      fill: this.FILL,
      svgColor: this.DEFAULT_COLOR,
      textColor: this.DEFAULT_COLOR,
      borderRadius: this.BORDER_RADIUS,
      borderThickness: this.BORDER_THICKNESS,
      svg: SVGCanvasStore.getSvg(SVGCollection.PAGE_PANEL_CART),
      padding: this.PADDING,
      svgSize: this.SVG_SIZE,
      insideTextToSvg: this.INSIDE_TEXT_TO_SVG,
      svgScale: ScaleSvg.HEIGHT,
      fillHover: this.FILL,
      borderColorHover: this.FILL,
      textColorHover: this.FILL,
      svgColorHover: this.HOVER_FILL
    }));
  }
}
class PageScrollDownButton extends BaseCanvasButton {
  constructor() {
    super();
    Ca(this, "FILL", "transparent");
    Ca(this, "HOVER_FILL", "#0075FF");
    Ca(this, "SVG_SIZE", 19);
    Ca(this, "BORDER_RADIUS", 0);
    Ca(this, "BORDER_THICKNESS", 0);
    Ca(this, "INSIDE_TEXT_TO_SVG", 0);
    Ca(this, "DEFAULT_COLOR", "#7F8184");
    Ca(this, "PADDING", { topBottom: 0, leftRight: 0 });
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableText: !1,
      fill: this.FILL,
      svgColor: this.DEFAULT_COLOR,
      textColor: this.DEFAULT_COLOR,
      borderRadius: this.BORDER_RADIUS,
      borderThickness: this.BORDER_THICKNESS,
      svg: SVGCanvasStore.getSvg(SVGCollection.ARROW_DOWN),
      padding: this.PADDING,
      svgSize: this.SVG_SIZE,
      insideTextToSvg: this.INSIDE_TEXT_TO_SVG,
      svgScale: ScaleSvg.WIDTH,
      fillHover: this.FILL,
      borderColorHover: this.FILL,
      textColorHover: this.FILL,
      svgColorHover: this.HOVER_FILL
    }));
  }
}
class PageScrollUpButton extends BaseCanvasButton {
  constructor() {
    super();
    Ca(this, "FILL", "transparent");
    Ca(this, "HOVER_FILL", "#0075FF");
    Ca(this, "SVG_SIZE", 19);
    Ca(this, "BORDER_RADIUS", 0);
    Ca(this, "BORDER_THICKNESS", 0);
    Ca(this, "INSIDE_TEXT_TO_SVG", 0);
    Ca(this, "DEFAULT_COLOR", "#7F8184");
    Ca(this, "PADDING", { topBottom: 0, leftRight: 0 });
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableText: !1,
      fill: this.FILL,
      svgColor: this.DEFAULT_COLOR,
      textColor: this.DEFAULT_COLOR,
      borderRadius: this.BORDER_RADIUS,
      borderThickness: this.BORDER_THICKNESS,
      svg: SVGCanvasStore.getSvg(SVGCollection.ARROW_UP),
      padding: this.PADDING,
      svgSize: this.SVG_SIZE,
      insideTextToSvg: this.INSIDE_TEXT_TO_SVG,
      svgScale: ScaleSvg.WIDTH,
      fillHover: this.FILL,
      borderColorHover: this.FILL,
      textColorHover: this.FILL,
      svgColorHover: this.HOVER_FILL
    }));
  }
}
class PageHeaderPanel extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_TEXT_FONT_SIZE", 16);
    Ca(this, "DEFAULT_COLOR", "#7F8184");
    Ca(this, "DEFAULT_TEXT_FONT", FontFamily.DEFAULT);
    Ca(this, "PAGE_NUMBER_DEFAULT", 1);
    Ca(this, "CURRENT_PAGE_NUMBER_COLOR", "#272727");
    Ca(this, "STARTUP_RELATIVE_POSITION", { x: 0, y: 0 });
    Ca(this, "PANEL_PADDING", 24);
    Ca(this, "deletePageButton");
    Ca(this, "appendPageButton");
    Ca(this, "scrollUpButton");
    Ca(this, "scrollDownButton");
    Ca(this, "TEXT_PADDING", 4);
    Ca(this, "SCROLL_BUTTON_PADDING", 0);
    Ca(this, "MODIFY_BUTTON_PADDING", 0);
    Ca(this, "pageInfoText");
    Ca(this, "isShowed");
    Ca(this, "isBottomLocation");
    Ca(this, "updatePosition", (Un) => {
      const { width: Kn } = Un;
      this.scrollUpButton.setConfiguration((qn) => ({
        ...qn,
        x: 0,
        y: this.calculateYPosition(
          Un,
          this.scrollUpButton.getHeight(),
          this.SCROLL_BUTTON_PADDING,
          this.isBottomLocation
        )
      })), this.pageInfoText.relativePosition = {
        x: this.scrollUpButton.getWidth() + 16,
        y: this.calculateYPosition(Un, this.pageInfoText.object.height, this.TEXT_PADDING, this.isBottomLocation)
      }, this.scrollDownButton.setConfiguration((qn) => ({
        ...qn,
        x: this.pageInfoText.relativePosition.x + this.pageInfoText.object.getScaledWidth() + 16,
        y: this.calculateYPosition(
          Un,
          this.scrollDownButton.getHeight(),
          this.SCROLL_BUTTON_PADDING,
          this.isBottomLocation
        )
      })), this.deletePageButton.setConfiguration((qn) => ({
        ...qn,
        x: Kn - this.deletePageButton.getWidth() * 2 - 18,
        y: this.calculateYPosition(
          Un,
          this.deletePageButton.getHeight(),
          this.MODIFY_BUTTON_PADDING,
          this.isBottomLocation
        )
      })), this.appendPageButton.setConfiguration((qn) => ({
        ...qn,
        x: Kn - this.appendPageButton.getWidth(),
        y: this.calculateYPosition(
          Un,
          this.appendPageButton.getHeight(),
          this.MODIFY_BUTTON_PADDING,
          this.isBottomLocation
        )
      }));
    });
    Ca(this, "getObjects", () => [
      this.pageInfoText,
      ...this.scrollUpButton.getObjects(),
      ...this.scrollDownButton.getObjects(),
      ...this.appendPageButton.getObjects(),
      ...this.deletePageButton.getObjects()
    ]);
    Ca(this, "getSpatialAreas", () => this.isShowed ? [
      ...this.scrollUpButton.getSpatialAreas(),
      ...this.scrollDownButton.getSpatialAreas(),
      ...this.appendPageButton.getSpatialAreas(),
      ...this.deletePageButton.getSpatialAreas()
    ] : []);
    Ca(this, "show", () => {
      this.scrollUpButton.showButton(), this.scrollDownButton.showButton(), this.appendPageButton.showButton(), this.deletePageButton.showButton(), this.pageInfoText.object.visible = !0, this.isShowed = !0;
    });
    Ca(this, "hide", () => {
      this.scrollUpButton.hideButton(), this.scrollDownButton.hideButton(), this.appendPageButton.hideButton(), this.deletePageButton.hideButton(), this.pageInfoText.object.visible = !1, this.isShowed = !1;
    });
    Ca(this, "enableLocationBottom", () => {
      this.isBottomLocation = !0;
    });
    Ca(this, "disableLocationBottom", () => {
      this.isBottomLocation = !1;
    });
    Ca(this, "disableHover", () => {
      this.appendPageButton.disableHover(), this.deletePageButton.disableHover(), this.scrollUpButton.disableHover(), this.scrollDownButton.disableHover();
    });
    Ca(this, "addPostClickAppendPageListener", (Un) => {
      this.appendPageButton.addPostMouseDownListeners(Un);
    });
    Ca(this, "addPostClickDeletePageListener", (Un) => {
      this.deletePageButton.addPostMouseDownListeners(Un);
    });
    Ca(this, "addPostClickScrollUpListener", (Un) => {
      this.scrollUpButton.addPostMouseDownListeners(Un);
    });
    Ca(this, "addPostClickScrollDownListener", (Un) => {
      this.scrollDownButton.addPostMouseDownListeners(Un);
    });
    Ca(this, "setPageInfo", (Un, Kn) => {
      this.pageInfoText.object.set({
        text: this.getPageInfoText(Un, Kn)
      }), this.pageInfoText.object.setSelectionStyles(
        { fill: this.CURRENT_PAGE_NUMBER_COLOR },
        0,
        String(Un).length
      );
    });
    Ca(this, "getPageInfoText", (Un, Kn) => `${Un} / ${Kn}`);
    Ca(this, "calculateYPosition", (Un, Kn, qn, Jo) => Jo ? Un.height + this.PANEL_PADDING - qn : -Kn - this.PANEL_PADDING - qn);
    this.isShowed = !1, this.isBottomLocation = !1, this.appendPageButton = new PageAppendButton$1(), this.deletePageButton = new PageAppendButton(), this.scrollUpButton = new PageScrollUpButton(), this.scrollDownButton = new PageScrollDownButton(), this.pageInfoText = {
      object: new Xo(this.getPageInfoText(this.PAGE_NUMBER_DEFAULT, this.PAGE_NUMBER_DEFAULT), {
        fill: this.DEFAULT_COLOR,
        fontSize: this.DEFAULT_TEXT_FONT_SIZE,
        fontFamily: this.DEFAULT_TEXT_FONT
      }),
      relativePosition: this.STARTUP_RELATIVE_POSITION
    }, this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, parentGraphic: qn } = Un;
      this.appendPageButton.forceInjectDependencies({ render: Kn, parentGraphic: qn }), this.deletePageButton.forceInjectDependencies({ render: Kn, parentGraphic: qn }), this.scrollUpButton.forceInjectDependencies({ render: Kn, parentGraphic: qn }), this.scrollDownButton.forceInjectDependencies({ render: Kn, parentGraphic: qn }), qn.addFrameConfigurationChangeListener((Jo, pa) => {
        this.updatePosition(pa);
      });
    });
  }
}
class PageHeader extends Dependent {
  constructor() {
    super();
    Ca(this, "SCROLL_PADDING", 160);
    Ca(this, "DEFAULT_CURRENT_PAGE_NUMBER", 1);
    Ca(this, "panel");
    Ca(this, "currentPageNumber");
    Ca(this, "getObjects", () => this.panel.getObjects());
    Ca(this, "getSpatialAreas", () => this.panel.getSpatialAreas());
    Ca(this, "sync", () => {
      const Un = this.dependencies.parentGraphic.getParentComponent();
      if (Un === null)
        return;
      const Kn = Un.getGraphics();
      this.syncPageInfo(Kn, this.dependencies.parentGraphic), this.panel.updatePosition(this.dependencies.parentGraphic.getFrameConfiguration());
    });
    Ca(this, "show", () => {
      this.panel.show();
    });
    Ca(this, "hide", () => {
      this.panel.hide();
    });
    Ca(this, "enableLocationBottom", () => {
      this.panel.enableLocationBottom();
    });
    Ca(this, "disableLocationBottom", () => {
      this.panel.disableLocationBottom();
    });
    Ca(this, "disableHover", () => {
      this.panel.disableHover();
    });
    Ca(this, "syncPageInfo", (Un, Kn) => {
      const qn = this.getGraphicIndex(Un, Kn) + 1;
      this.currentPageNumber = qn, this.panel.setPageInfo(qn, Un.length);
    });
    Ca(this, "onAppendPage", () => {
      this.dependencies.useCases.appendPageAfter(this.dependencies.parentGraphic);
    });
    Ca(this, "onDeletePage", () => {
      this.dependencies.useCases.deletePage(this.dependencies.parentGraphic);
    });
    Ca(this, "scrollUp", async () => {
      if (this.currentPageNumber === 1)
        return;
      const Un = this.dependencies.parentGraphic.getParentComponent();
      if (Un === null)
        return;
      const qn = Un.getGraphics()[this.currentPageNumber - 2];
      this.scrollToGraphic(qn), this.dependencies.areaController.updateActiveArea();
    });
    Ca(this, "scrollDown", async () => {
      const Un = this.dependencies.parentGraphic.getParentComponent();
      if (Un === null)
        return;
      const Kn = Un.getGraphics();
      if (this.currentPageNumber === Kn.length)
        return;
      const qn = Kn[this.currentPageNumber];
      this.scrollToGraphic(qn), this.dependencies.areaController.updateActiveArea();
    });
    Ca(this, "getGraphicIndex", (Un, Kn) => {
      const qn = Un.indexOf(Kn);
      if (qn === -1)
        throw new EditorError("current page graphic not found in graphic list");
      return qn;
    });
    Ca(this, "scrollToGraphic", (Un) => {
      const { y: Kn } = this.dependencies.camera.getConfiguration(), { y: qn } = Un.getGlobalPosition();
      this.dependencies.camera.move(-(Math.abs(Kn) - qn + this.SCROLL_PADDING));
    });
    this.currentPageNumber = this.DEFAULT_CURRENT_PAGE_NUMBER, this.panel = new PageHeaderPanel(), this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, parentGraphic: qn } = Un;
      this.panel.addPostClickScrollUpListener(this.scrollUp), this.panel.addPostClickScrollDownListener(this.scrollDown), this.panel.addPostClickAppendPageListener(this.onAppendPage), this.panel.addPostClickDeletePageListener(this.onDeletePage), this.panel.forceInjectDependencies({ render: Kn, parentGraphic: qn });
    });
  }
}
class PictureReplaceButton extends BaseCanvasButton {
  constructor() {
    super();
    Ca(this, "FILL", "rgba(0,0,0,0.45)");
    Ca(this, "FILL_HOVER", null);
    Ca(this, "TEXT", "Заменить");
    Ca(this, "COLOR", "white");
    Ca(this, "BORDER_RADIUS", 16);
    Ca(this, "BORDER_THICKNESS", 0);
    this.setConfiguration((Un) => ({
      ...Un,
      text: this.TEXT,
      isEnableText: !0,
      fill: this.FILL,
      svgColor: this.COLOR,
      textColor: this.COLOR,
      borderRadius: this.BORDER_RADIUS,
      borderThickness: this.BORDER_THICKNESS,
      svg: SVGCanvasStore.getSvg(SVGCollection.IMG_LOAD),
      fillHover: this.FILL_HOVER,
      svgColorHover: this.FILL_HOVER,
      textColorHover: this.FILL_HOVER,
      borderColorHover: this.FILL_HOVER
    }));
  }
}
class PictureActionLayer extends Dependent {
  constructor() {
    super();
    Ca(this, "BUTTON_MARGIN", 10);
    Ca(this, "replaceButton");
    Ca(this, "getObjects", () => this.replaceButton.getObjects());
    Ca(this, "getSpatialAreas", () => this.replaceButton.getSpatialAreas());
    Ca(this, "enableCompactMode", () => {
      this.replaceButton.hideText();
    });
    Ca(this, "disableCompactMode", () => {
      this.replaceButton.showText();
    });
    Ca(this, "enable", () => {
      this.replaceButton.showButton();
    });
    Ca(this, "disable", () => {
      this.replaceButton.hideButton();
    });
    Ca(this, "updatePosition", (Un) => {
      const { width: Kn } = Un, qn = this.replaceButton.getWidth();
      this.replaceButton.setConfiguration((Jo) => ({
        ...Jo,
        x: Kn - qn - this.BUTTON_MARGIN,
        y: this.BUTTON_MARGIN
      }));
    });
    this.replaceButton = new PictureReplaceButton(), this.addPostInjectDependenciesListener((Un) => {
      const { useCases: Kn, render: qn, parentGraphic: Jo } = Un;
      this.replaceButton.forceInjectDependencies({ render: qn, parentGraphic: Jo }), this.replaceButton.addPostMouseDownListeners(() => {
        const pa = Jo.getParentComponent();
        if (pa === null)
          throw new EditorError("component not found");
        Kn.loadPictureComponentWithAdaptFrame(pa);
      }), Jo.addFrameConfigurationChangeListener((pa, ma) => {
        this.updatePosition(ma);
      });
    });
  }
}
class GraphicFactory extends Dependent {
  constructor() {
    super();
    Ca(this, "getClearGraphic", (Un) => {
      switch (Un) {
        case GraphicType.GROUP:
          return new GroupGraphic();
        case GraphicType.PICTURE: {
          const Kn = new PictureGraphic();
          return Kn.setFileSourcePrefix(this.dependencies.imageFileSourcePrefix), Kn;
        }
        case GraphicType.TABLE:
          return new TableGraphic();
        case GraphicType.TEXT:
          return new TextGraphic();
        case GraphicType.FIGURE:
          return new FigureGraphic();
        case GraphicType.LINE:
          return new LineGraphic();
        case GraphicType.MODULE:
          return new ModuleGraphic();
        case GraphicType.PAGE: {
          const Kn = new PageGraphic();
          return Kn.setFileSourcePrefix(this.dependencies.imageFileSourcePrefix), Kn;
        }
        default:
          throw new EditorError("error type graphic");
      }
    });
    Ca(this, "injectPictureActionLayer", (Un, Kn, qn) => {
      const Jo = new PictureActionLayer();
      Jo.connectDependencies({
        useCases: Kn,
        render: qn,
        parentGraphic: Un
      }), Jo.injectDependencies(), Un.connectPictureActionLayer(Jo);
    });
    Ca(this, "injectTopPageHeader", (Un, Kn, qn, Jo, pa) => {
      const ma = new PageHeader();
      ma.connectDependencies({
        render: Kn,
        camera: Un,
        useCases: qn,
        parentGraphic: Jo,
        areaController: pa
      }), ma.injectDependencies(), ma.show(), Jo.connectTopPageHeader(ma);
    });
    Ca(this, "injectBottomPageHeader", (Un, Kn, qn, Jo, pa) => {
      const ma = new PageHeader();
      ma.connectDependencies({
        render: Kn,
        camera: Un,
        useCases: qn,
        parentGraphic: Jo,
        areaController: pa
      }), ma.injectDependencies(), ma.enableLocationBottom(), ma.hide(), Jo.connectBottomPageHeader(ma);
    });
  }
  getPrefix() {
    return this.dependencies.imageFileSourcePrefix;
  }
}
class StaticGraphicFactory extends GraphicFactory {
  constructor() {
    super();
    Ca(this, "createGraphic", (Un, Kn) => {
      let qn;
      switch (Un) {
        case GraphicType.PAGE: {
          const Jo = new PageGraphic();
          Jo.setFileSourcePrefix(this.dependencies.imageFileSourcePrefix), qn = Jo;
          break;
        }
        case GraphicType.GROUP: {
          qn = new GroupGraphic();
          break;
        }
        case GraphicType.PICTURE: {
          const Jo = new PictureGraphic();
          Jo.setFileSourcePrefix(this.dependencies.imageFileSourcePrefix), qn = Jo;
          break;
        }
        case GraphicType.TABLE: {
          qn = new TableGraphic();
          break;
        }
        case GraphicType.TEXT: {
          qn = new TextGraphic();
          break;
        }
        case GraphicType.FIGURE: {
          qn = new FigureGraphic();
          break;
        }
        case GraphicType.LINE: {
          qn = new LineGraphic();
          break;
        }
        case GraphicType.MODULE: {
          qn = new ModuleGraphic();
          break;
        }
        default:
          throw new EditorError(`graphic type "${Un}" not found`);
      }
      return qn.setParentComponent(Kn), qn;
    });
  }
}
class BaseObjectOrganizer extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "getComponentTreeObjects", () => {
      const Un = this.dependencies.layerRegistry.getSortedGraphics();
      if (Un === null)
        return [];
      const Kn = [];
      let qn = [];
      for (let Jo = 0; Jo < Un.length; Jo++) {
        qn = Un[Jo].getObjects();
        for (let pa = 0; pa < qn.length; pa++)
          Kn.push(qn[pa].object);
      }
      return Kn;
    });
  }
}
class StaticCanvasObjectOrganizer extends BaseObjectOrganizer {
  getSortedObjects() {
    return [...this.getComponentTreeObjects()];
  }
}
/**
 * lil-gui
 * https://lil-gui.georgealways.com
 * @version 0.20.0
 * @author George Michael Brower
 * @license MIT
 */
class Controller {
  constructor(zn, Un, Kn, qn, Jo = "div") {
    this.parent = zn, this.object = Un, this.property = Kn, this._disabled = !1, this._hidden = !1, this.initialValue = this.getValue(), this.domElement = document.createElement(Jo), this.domElement.classList.add("controller"), this.domElement.classList.add(qn), this.$name = document.createElement("div"), this.$name.classList.add("name"), Controller.nextNameID = Controller.nextNameID || 0, this.$name.id = `lil-gui-name-${++Controller.nextNameID}`, this.$widget = document.createElement("div"), this.$widget.classList.add("widget"), this.$disable = this.$widget, this.domElement.appendChild(this.$name), this.domElement.appendChild(this.$widget), this.domElement.addEventListener("keydown", (pa) => pa.stopPropagation()), this.domElement.addEventListener("keyup", (pa) => pa.stopPropagation()), this.parent.children.push(this), this.parent.controllers.push(this), this.parent.$children.appendChild(this.domElement), this._listenCallback = this._listenCallback.bind(this), this.name(Kn);
  }
  /**
   * Sets the name of the controller and its label in the GUI.
   * @param {string} name
   * @returns {this}
   */
  name(zn) {
    return this._name = zn, this.$name.textContent = zn, this;
  }
  /**
   * Pass a function to be called whenever the value is modified by this controller.
   * The function receives the new value as its first parameter. The value of `this` will be the
   * controller.
   *
   * For function controllers, the `onChange` callback will be fired on click, after the function
   * executes.
   * @param {Function} callback
   * @returns {this}
   * @example
   * const controller = gui.add( object, 'property' );
   *
   * controller.onChange( function( v ) {
   * 	console.log( 'The value is now ' + v );
   * 	console.assert( this === controller );
   * } );
   */
  onChange(zn) {
    return this._onChange = zn, this;
  }
  /**
   * Calls the onChange methods of this controller and its parent GUI.
   * @protected
   */
  _callOnChange() {
    this.parent._callOnChange(this), this._onChange !== void 0 && this._onChange.call(this, this.getValue()), this._changed = !0;
  }
  /**
   * Pass a function to be called after this controller has been modified and loses focus.
   * @param {Function} callback
   * @returns {this}
   * @example
   * const controller = gui.add( object, 'property' );
   *
   * controller.onFinishChange( function( v ) {
   * 	console.log( 'Changes complete: ' + v );
   * 	console.assert( this === controller );
   * } );
   */
  onFinishChange(zn) {
    return this._onFinishChange = zn, this;
  }
  /**
   * Should be called by Controller when its widgets lose focus.
   * @protected
   */
  _callOnFinishChange() {
    this._changed && (this.parent._callOnFinishChange(this), this._onFinishChange !== void 0 && this._onFinishChange.call(this, this.getValue())), this._changed = !1;
  }
  /**
   * Sets the controller back to its initial value.
   * @returns {this}
   */
  reset() {
    return this.setValue(this.initialValue), this._callOnFinishChange(), this;
  }
  /**
   * Enables this controller.
   * @param {boolean} enabled
   * @returns {this}
   * @example
   * controller.enable();
   * controller.enable( false ); // disable
   * controller.enable( controller._disabled ); // toggle
   */
  enable(zn = !0) {
    return this.disable(!zn);
  }
  /**
   * Disables this controller.
   * @param {boolean} disabled
   * @returns {this}
   * @example
   * controller.disable();
   * controller.disable( false ); // enable
   * controller.disable( !controller._disabled ); // toggle
   */
  disable(zn = !0) {
    return zn === this._disabled ? this : (this._disabled = zn, this.domElement.classList.toggle("disabled", zn), this.$disable.toggleAttribute("disabled", zn), this);
  }
  /**
   * Shows the Controller after it's been hidden.
   * @param {boolean} show
   * @returns {this}
   * @example
   * controller.show();
   * controller.show( false ); // hide
   * controller.show( controller._hidden ); // toggle
   */
  show(zn = !0) {
    return this._hidden = !zn, this.domElement.style.display = this._hidden ? "none" : "", this;
  }
  /**
   * Hides the Controller.
   * @returns {this}
   */
  hide() {
    return this.show(!1);
  }
  /**
   * Changes this controller into a dropdown of options.
   *
   * Calling this method on an option controller will simply update the options. However, if this
   * controller was not already an option controller, old references to this controller are
   * destroyed, and a new controller is added to the end of the GUI.
   * @example
   * // safe usage
   *
   * gui.add( obj, 'prop1' ).options( [ 'a', 'b', 'c' ] );
   * gui.add( obj, 'prop2' ).options( { Big: 10, Small: 1 } );
   * gui.add( obj, 'prop3' );
   *
   * // danger
   *
   * const ctrl1 = gui.add( obj, 'prop1' );
   * gui.add( obj, 'prop2' );
   *
   * // calling options out of order adds a new controller to the end...
   * const ctrl2 = ctrl1.options( [ 'a', 'b', 'c' ] );
   *
   * // ...and ctrl1 now references a controller that doesn't exist
   * assert( ctrl2 !== ctrl1 )
   * @param {object|Array} options
   * @returns {Controller}
   */
  options(zn) {
    const Un = this.parent.add(this.object, this.property, zn);
    return Un.name(this._name), this.destroy(), Un;
  }
  /**
   * Sets the minimum value. Only works on number controllers.
   * @param {number} min
   * @returns {this}
   */
  min(zn) {
    return this;
  }
  /**
   * Sets the maximum value. Only works on number controllers.
   * @param {number} max
   * @returns {this}
   */
  max(zn) {
    return this;
  }
  /**
   * Values set by this controller will be rounded to multiples of `step`. Only works on number
   * controllers.
   * @param {number} step
   * @returns {this}
   */
  step(zn) {
    return this;
  }
  /**
   * Rounds the displayed value to a fixed number of decimals, without affecting the actual value
   * like `step()`. Only works on number controllers.
   * @example
   * gui.add( object, 'property' ).listen().decimals( 4 );
   * @param {number} decimals
   * @returns {this}
   */
  decimals(zn) {
    return this;
  }
  /**
   * Calls `updateDisplay()` every animation frame. Pass `false` to stop listening.
   * @param {boolean} listen
   * @returns {this}
   */
  listen(zn = !0) {
    return this._listening = zn, this._listenCallbackID !== void 0 && (cancelAnimationFrame(this._listenCallbackID), this._listenCallbackID = void 0), this._listening && this._listenCallback(), this;
  }
  _listenCallback() {
    this._listenCallbackID = requestAnimationFrame(this._listenCallback);
    const zn = this.save();
    zn !== this._listenPrevValue && this.updateDisplay(), this._listenPrevValue = zn;
  }
  /**
   * Returns `object[ property ]`.
   * @returns {any}
   */
  getValue() {
    return this.object[this.property];
  }
  /**
   * Sets the value of `object[ property ]`, invokes any `onChange` handlers and updates the display.
   * @param {any} value
   * @returns {this}
   */
  setValue(zn) {
    return this.getValue() !== zn && (this.object[this.property] = zn, this._callOnChange(), this.updateDisplay()), this;
  }
  /**
   * Updates the display to keep it in sync with the current value. Useful for updating your
   * controllers when their values have been modified outside of the GUI.
   * @returns {this}
   */
  updateDisplay() {
    return this;
  }
  load(zn) {
    return this.setValue(zn), this._callOnFinishChange(), this;
  }
  save() {
    return this.getValue();
  }
  /**
   * Destroys this controller and removes it from the parent GUI.
   */
  destroy() {
    this.listen(!1), this.parent.children.splice(this.parent.children.indexOf(this), 1), this.parent.controllers.splice(this.parent.controllers.indexOf(this), 1), this.parent.$children.removeChild(this.domElement);
  }
}
class BooleanController extends Controller {
  constructor(zn, Un, Kn) {
    super(zn, Un, Kn, "boolean", "label"), this.$input = document.createElement("input"), this.$input.setAttribute("type", "checkbox"), this.$input.setAttribute("aria-labelledby", this.$name.id), this.$widget.appendChild(this.$input), this.$input.addEventListener("change", () => {
      this.setValue(this.$input.checked), this._callOnFinishChange();
    }), this.$disable = this.$input, this.updateDisplay();
  }
  updateDisplay() {
    return this.$input.checked = this.getValue(), this;
  }
}
function normalizeColorString(Xn) {
  let zn, Un;
  return (zn = Xn.match(/(#|0x)?([a-f0-9]{6})/i)) ? Un = zn[2] : (zn = Xn.match(/rgb\(\s*(\d*)\s*,\s*(\d*)\s*,\s*(\d*)\s*\)/)) ? Un = parseInt(zn[1]).toString(16).padStart(2, 0) + parseInt(zn[2]).toString(16).padStart(2, 0) + parseInt(zn[3]).toString(16).padStart(2, 0) : (zn = Xn.match(/^#?([a-f0-9])([a-f0-9])([a-f0-9])$/i)) && (Un = zn[1] + zn[1] + zn[2] + zn[2] + zn[3] + zn[3]), Un ? "#" + Un : !1;
}
const STRING = {
  isPrimitive: !0,
  match: (Xn) => typeof Xn == "string",
  fromHexString: normalizeColorString,
  toHexString: normalizeColorString
}, INT = {
  isPrimitive: !0,
  match: (Xn) => typeof Xn == "number",
  fromHexString: (Xn) => parseInt(Xn.substring(1), 16),
  toHexString: (Xn) => "#" + Xn.toString(16).padStart(6, 0)
}, ARRAY = {
  isPrimitive: !1,
  // The arrow function is here to appease tree shakers like esbuild or webpack.
  // See https://esbuild.github.io/api/#tree-shaking
  match: (Xn) => Array.isArray(Xn),
  fromHexString(Xn, zn, Un = 1) {
    const Kn = INT.fromHexString(Xn);
    zn[0] = (Kn >> 16 & 255) / 255 * Un, zn[1] = (Kn >> 8 & 255) / 255 * Un, zn[2] = (Kn & 255) / 255 * Un;
  },
  toHexString([Xn, zn, Un], Kn = 1) {
    Kn = 255 / Kn;
    const qn = Xn * Kn << 16 ^ zn * Kn << 8 ^ Un * Kn << 0;
    return INT.toHexString(qn);
  }
}, OBJECT = {
  isPrimitive: !1,
  match: (Xn) => Object(Xn) === Xn,
  fromHexString(Xn, zn, Un = 1) {
    const Kn = INT.fromHexString(Xn);
    zn.r = (Kn >> 16 & 255) / 255 * Un, zn.g = (Kn >> 8 & 255) / 255 * Un, zn.b = (Kn & 255) / 255 * Un;
  },
  toHexString({ r: Xn, g: zn, b: Un }, Kn = 1) {
    Kn = 255 / Kn;
    const qn = Xn * Kn << 16 ^ zn * Kn << 8 ^ Un * Kn << 0;
    return INT.toHexString(qn);
  }
}, FORMATS = [STRING, INT, ARRAY, OBJECT];
function getColorFormat(Xn) {
  return FORMATS.find((zn) => zn.match(Xn));
}
class ColorController extends Controller {
  constructor(zn, Un, Kn, qn) {
    super(zn, Un, Kn, "color"), this.$input = document.createElement("input"), this.$input.setAttribute("type", "color"), this.$input.setAttribute("tabindex", -1), this.$input.setAttribute("aria-labelledby", this.$name.id), this.$text = document.createElement("input"), this.$text.setAttribute("type", "text"), this.$text.setAttribute("spellcheck", "false"), this.$text.setAttribute("aria-labelledby", this.$name.id), this.$display = document.createElement("div"), this.$display.classList.add("display"), this.$display.appendChild(this.$input), this.$widget.appendChild(this.$display), this.$widget.appendChild(this.$text), this._format = getColorFormat(this.initialValue), this._rgbScale = qn, this._initialValueHexString = this.save(), this._textFocused = !1, this.$input.addEventListener("input", () => {
      this._setValueFromHexString(this.$input.value);
    }), this.$input.addEventListener("blur", () => {
      this._callOnFinishChange();
    }), this.$text.addEventListener("input", () => {
      const Jo = normalizeColorString(this.$text.value);
      Jo && this._setValueFromHexString(Jo);
    }), this.$text.addEventListener("focus", () => {
      this._textFocused = !0, this.$text.select();
    }), this.$text.addEventListener("blur", () => {
      this._textFocused = !1, this.updateDisplay(), this._callOnFinishChange();
    }), this.$disable = this.$text, this.updateDisplay();
  }
  reset() {
    return this._setValueFromHexString(this._initialValueHexString), this;
  }
  _setValueFromHexString(zn) {
    if (this._format.isPrimitive) {
      const Un = this._format.fromHexString(zn);
      this.setValue(Un);
    } else
      this._format.fromHexString(zn, this.getValue(), this._rgbScale), this._callOnChange(), this.updateDisplay();
  }
  save() {
    return this._format.toHexString(this.getValue(), this._rgbScale);
  }
  load(zn) {
    return this._setValueFromHexString(zn), this._callOnFinishChange(), this;
  }
  updateDisplay() {
    return this.$input.value = this._format.toHexString(this.getValue(), this._rgbScale), this._textFocused || (this.$text.value = this.$input.value.substring(1)), this.$display.style.backgroundColor = this.$input.value, this;
  }
}
class FunctionController extends Controller {
  constructor(zn, Un, Kn) {
    super(zn, Un, Kn, "function"), this.$button = document.createElement("button"), this.$button.appendChild(this.$name), this.$widget.appendChild(this.$button), this.$button.addEventListener("click", (qn) => {
      qn.preventDefault(), this.getValue().call(this.object), this._callOnChange();
    }), this.$button.addEventListener("touchstart", () => {
    }, { passive: !0 }), this.$disable = this.$button;
  }
}
class NumberController extends Controller {
  constructor(zn, Un, Kn, qn, Jo, pa) {
    super(zn, Un, Kn, "number"), this._initInput(), this.min(qn), this.max(Jo);
    const ma = pa !== void 0;
    this.step(ma ? pa : this._getImplicitStep(), ma), this.updateDisplay();
  }
  decimals(zn) {
    return this._decimals = zn, this.updateDisplay(), this;
  }
  min(zn) {
    return this._min = zn, this._onUpdateMinMax(), this;
  }
  max(zn) {
    return this._max = zn, this._onUpdateMinMax(), this;
  }
  step(zn, Un = !0) {
    return this._step = zn, this._stepExplicit = Un, this;
  }
  updateDisplay() {
    const zn = this.getValue();
    if (this._hasSlider) {
      let Un = (zn - this._min) / (this._max - this._min);
      Un = Math.max(0, Math.min(Un, 1)), this.$fill.style.width = Un * 100 + "%";
    }
    return this._inputFocused || (this.$input.value = this._decimals === void 0 ? zn : zn.toFixed(this._decimals)), this;
  }
  _initInput() {
    this.$input = document.createElement("input"), this.$input.setAttribute("type", "text"), this.$input.setAttribute("aria-labelledby", this.$name.id), window.matchMedia("(pointer: coarse)").matches && (this.$input.setAttribute("type", "number"), this.$input.setAttribute("step", "any")), this.$widget.appendChild(this.$input), this.$disable = this.$input;
    const Un = () => {
      let Za = parseFloat(this.$input.value);
      isNaN(Za) || (this._stepExplicit && (Za = this._snap(Za)), this.setValue(this._clamp(Za)));
    }, Kn = (Za) => {
      const Na = parseFloat(this.$input.value);
      isNaN(Na) || (this._snapClampSetValue(Na + Za), this.$input.value = this.getValue());
    }, qn = (Za) => {
      Za.key === "Enter" && this.$input.blur(), Za.code === "ArrowUp" && (Za.preventDefault(), Kn(this._step * this._arrowKeyMultiplier(Za))), Za.code === "ArrowDown" && (Za.preventDefault(), Kn(this._step * this._arrowKeyMultiplier(Za) * -1));
    }, Jo = (Za) => {
      this._inputFocused && (Za.preventDefault(), Kn(this._step * this._normalizeMouseWheel(Za)));
    };
    let pa = !1, ma, va, ba, _a, ya;
    const xa = 5, wa = (Za) => {
      ma = Za.clientX, va = ba = Za.clientY, pa = !0, _a = this.getValue(), ya = 0, window.addEventListener("mousemove", Ta), window.addEventListener("mouseup", Sa);
    }, Ta = (Za) => {
      if (pa) {
        const Na = Za.clientX - ma, Ka = Za.clientY - va;
        Math.abs(Ka) > xa ? (Za.preventDefault(), this.$input.blur(), pa = !1, this._setDraggingStyle(!0, "vertical")) : Math.abs(Na) > xa && Sa();
      }
      if (!pa) {
        const Na = Za.clientY - ba;
        ya -= Na * this._step * this._arrowKeyMultiplier(Za), _a + ya > this._max ? ya = this._max - _a : _a + ya < this._min && (ya = this._min - _a), this._snapClampSetValue(_a + ya);
      }
      ba = Za.clientY;
    }, Sa = () => {
      this._setDraggingStyle(!1, "vertical"), this._callOnFinishChange(), window.removeEventListener("mousemove", Ta), window.removeEventListener("mouseup", Sa);
    }, Ma = () => {
      this._inputFocused = !0;
    }, ka = () => {
      this._inputFocused = !1, this.updateDisplay(), this._callOnFinishChange();
    };
    this.$input.addEventListener("input", Un), this.$input.addEventListener("keydown", qn), this.$input.addEventListener("wheel", Jo, { passive: !1 }), this.$input.addEventListener("mousedown", wa), this.$input.addEventListener("focus", Ma), this.$input.addEventListener("blur", ka);
  }
  _initSlider() {
    this._hasSlider = !0, this.$slider = document.createElement("div"), this.$slider.classList.add("slider"), this.$fill = document.createElement("div"), this.$fill.classList.add("fill"), this.$slider.appendChild(this.$fill), this.$widget.insertBefore(this.$slider, this.$input), this.domElement.classList.add("hasSlider");
    const zn = (ka, Za, Na, Ka, Ja) => (ka - Za) / (Na - Za) * (Ja - Ka) + Ka, Un = (ka) => {
      const Za = this.$slider.getBoundingClientRect();
      let Na = zn(ka, Za.left, Za.right, this._min, this._max);
      this._snapClampSetValue(Na);
    }, Kn = (ka) => {
      this._setDraggingStyle(!0), Un(ka.clientX), window.addEventListener("mousemove", qn), window.addEventListener("mouseup", Jo);
    }, qn = (ka) => {
      Un(ka.clientX);
    }, Jo = () => {
      this._callOnFinishChange(), this._setDraggingStyle(!1), window.removeEventListener("mousemove", qn), window.removeEventListener("mouseup", Jo);
    };
    let pa = !1, ma, va;
    const ba = (ka) => {
      ka.preventDefault(), this._setDraggingStyle(!0), Un(ka.touches[0].clientX), pa = !1;
    }, _a = (ka) => {
      ka.touches.length > 1 || (this._hasScrollBar ? (ma = ka.touches[0].clientX, va = ka.touches[0].clientY, pa = !0) : ba(ka), window.addEventListener("touchmove", ya, { passive: !1 }), window.addEventListener("touchend", xa));
    }, ya = (ka) => {
      if (pa) {
        const Za = ka.touches[0].clientX - ma, Na = ka.touches[0].clientY - va;
        Math.abs(Za) > Math.abs(Na) ? ba(ka) : (window.removeEventListener("touchmove", ya), window.removeEventListener("touchend", xa));
      } else
        ka.preventDefault(), Un(ka.touches[0].clientX);
    }, xa = () => {
      this._callOnFinishChange(), this._setDraggingStyle(!1), window.removeEventListener("touchmove", ya), window.removeEventListener("touchend", xa);
    }, wa = this._callOnFinishChange.bind(this), Ta = 400;
    let Sa;
    const Ma = (ka) => {
      if (Math.abs(ka.deltaX) < Math.abs(ka.deltaY) && this._hasScrollBar) return;
      ka.preventDefault();
      const Na = this._normalizeMouseWheel(ka) * this._step;
      this._snapClampSetValue(this.getValue() + Na), this.$input.value = this.getValue(), clearTimeout(Sa), Sa = setTimeout(wa, Ta);
    };
    this.$slider.addEventListener("mousedown", Kn), this.$slider.addEventListener("touchstart", _a, { passive: !1 }), this.$slider.addEventListener("wheel", Ma, { passive: !1 });
  }
  _setDraggingStyle(zn, Un = "horizontal") {
    this.$slider && this.$slider.classList.toggle("active", zn), document.body.classList.toggle("lil-gui-dragging", zn), document.body.classList.toggle(`lil-gui-${Un}`, zn);
  }
  _getImplicitStep() {
    return this._hasMin && this._hasMax ? (this._max - this._min) / 1e3 : 0.1;
  }
  _onUpdateMinMax() {
    !this._hasSlider && this._hasMin && this._hasMax && (this._stepExplicit || this.step(this._getImplicitStep(), !1), this._initSlider(), this.updateDisplay());
  }
  _normalizeMouseWheel(zn) {
    let { deltaX: Un, deltaY: Kn } = zn;
    return Math.floor(zn.deltaY) !== zn.deltaY && zn.wheelDelta && (Un = 0, Kn = -zn.wheelDelta / 120, Kn *= this._stepExplicit ? 1 : 10), Un + -Kn;
  }
  _arrowKeyMultiplier(zn) {
    let Un = this._stepExplicit ? 1 : 10;
    return zn.shiftKey ? Un *= 10 : zn.altKey && (Un /= 10), Un;
  }
  _snap(zn) {
    let Un = 0;
    return this._hasMin ? Un = this._min : this._hasMax && (Un = this._max), zn -= Un, zn = Math.round(zn / this._step) * this._step, zn += Un, zn = parseFloat(zn.toPrecision(15)), zn;
  }
  _clamp(zn) {
    return zn < this._min && (zn = this._min), zn > this._max && (zn = this._max), zn;
  }
  _snapClampSetValue(zn) {
    this.setValue(this._clamp(this._snap(zn)));
  }
  get _hasScrollBar() {
    const zn = this.parent.root.$children;
    return zn.scrollHeight > zn.clientHeight;
  }
  get _hasMin() {
    return this._min !== void 0;
  }
  get _hasMax() {
    return this._max !== void 0;
  }
}
class OptionController extends Controller {
  constructor(zn, Un, Kn, qn) {
    super(zn, Un, Kn, "option"), this.$select = document.createElement("select"), this.$select.setAttribute("aria-labelledby", this.$name.id), this.$display = document.createElement("div"), this.$display.classList.add("display"), this.$select.addEventListener("change", () => {
      this.setValue(this._values[this.$select.selectedIndex]), this._callOnFinishChange();
    }), this.$select.addEventListener("focus", () => {
      this.$display.classList.add("focus");
    }), this.$select.addEventListener("blur", () => {
      this.$display.classList.remove("focus");
    }), this.$widget.appendChild(this.$select), this.$widget.appendChild(this.$display), this.$disable = this.$select, this.options(qn);
  }
  options(zn) {
    return this._values = Array.isArray(zn) ? zn : Object.values(zn), this._names = Array.isArray(zn) ? zn : Object.keys(zn), this.$select.replaceChildren(), this._names.forEach((Un) => {
      const Kn = document.createElement("option");
      Kn.textContent = Un, this.$select.appendChild(Kn);
    }), this.updateDisplay(), this;
  }
  updateDisplay() {
    const zn = this.getValue(), Un = this._values.indexOf(zn);
    return this.$select.selectedIndex = Un, this.$display.textContent = Un === -1 ? zn : this._names[Un], this;
  }
}
class StringController extends Controller {
  constructor(zn, Un, Kn) {
    super(zn, Un, Kn, "string"), this.$input = document.createElement("input"), this.$input.setAttribute("type", "text"), this.$input.setAttribute("spellcheck", "false"), this.$input.setAttribute("aria-labelledby", this.$name.id), this.$input.addEventListener("input", () => {
      this.setValue(this.$input.value);
    }), this.$input.addEventListener("keydown", (qn) => {
      qn.code === "Enter" && this.$input.blur();
    }), this.$input.addEventListener("blur", () => {
      this._callOnFinishChange();
    }), this.$widget.appendChild(this.$input), this.$disable = this.$input, this.updateDisplay();
  }
  updateDisplay() {
    return this.$input.value = this.getValue(), this;
  }
}
var stylesheet = `.lil-gui {
  font-family: var(--font-family);
  font-size: var(--font-size);
  line-height: 1;
  font-weight: normal;
  font-style: normal;
  text-align: left;
  color: var(--text-color);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  --background-color: #1f1f1f;
  --text-color: #ebebeb;
  --title-background-color: #111111;
  --title-text-color: #ebebeb;
  --widget-color: #424242;
  --hover-color: #4f4f4f;
  --focus-color: #595959;
  --number-color: #2cc9ff;
  --string-color: #a2db3c;
  --font-size: 11px;
  --input-font-size: 11px;
  --font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  --font-family-mono: Menlo, Monaco, Consolas, "Droid Sans Mono", monospace;
  --padding: 4px;
  --spacing: 4px;
  --widget-height: 20px;
  --title-height: calc(var(--widget-height) + var(--spacing) * 1.25);
  --name-width: 45%;
  --slider-knob-width: 2px;
  --slider-input-width: 27%;
  --color-input-width: 27%;
  --slider-input-min-width: 45px;
  --color-input-min-width: 45px;
  --folder-indent: 7px;
  --widget-padding: 0 0 0 3px;
  --widget-border-radius: 2px;
  --checkbox-size: calc(0.75 * var(--widget-height));
  --scrollbar-width: 5px;
}
.lil-gui, .lil-gui * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.lil-gui.root {
  width: var(--width, 245px);
  display: flex;
  flex-direction: column;
  background: var(--background-color);
}
.lil-gui.root > .title {
  background: var(--title-background-color);
  color: var(--title-text-color);
}
.lil-gui.root > .children {
  overflow-x: hidden;
  overflow-y: auto;
}
.lil-gui.root > .children::-webkit-scrollbar {
  width: var(--scrollbar-width);
  height: var(--scrollbar-width);
  background: var(--background-color);
}
.lil-gui.root > .children::-webkit-scrollbar-thumb {
  border-radius: var(--scrollbar-width);
  background: var(--focus-color);
}
@media (pointer: coarse) {
  .lil-gui.allow-touch-styles, .lil-gui.allow-touch-styles .lil-gui {
    --widget-height: 28px;
    --padding: 6px;
    --spacing: 6px;
    --font-size: 13px;
    --input-font-size: 16px;
    --folder-indent: 10px;
    --scrollbar-width: 7px;
    --slider-input-min-width: 50px;
    --color-input-min-width: 65px;
  }
}
.lil-gui.force-touch-styles, .lil-gui.force-touch-styles .lil-gui {
  --widget-height: 28px;
  --padding: 6px;
  --spacing: 6px;
  --font-size: 13px;
  --input-font-size: 16px;
  --folder-indent: 10px;
  --scrollbar-width: 7px;
  --slider-input-min-width: 50px;
  --color-input-min-width: 65px;
}
.lil-gui.autoPlace {
  max-height: 100%;
  position: fixed;
  top: 0;
  right: 15px;
  z-index: 1001;
}

.lil-gui .controller {
  display: flex;
  align-items: center;
  padding: 0 var(--padding);
  margin: var(--spacing) 0;
}
.lil-gui .controller.disabled {
  opacity: 0.5;
}
.lil-gui .controller.disabled, .lil-gui .controller.disabled * {
  pointer-events: none !important;
}
.lil-gui .controller > .name {
  min-width: var(--name-width);
  flex-shrink: 0;
  white-space: pre;
  padding-right: var(--spacing);
  line-height: var(--widget-height);
}
.lil-gui .controller .widget {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: var(--widget-height);
}
.lil-gui .controller.string input {
  color: var(--string-color);
}
.lil-gui .controller.boolean {
  cursor: pointer;
}
.lil-gui .controller.color .display {
  width: 100%;
  height: var(--widget-height);
  border-radius: var(--widget-border-radius);
  position: relative;
}
@media (hover: hover) {
  .lil-gui .controller.color .display:hover:before {
    content: " ";
    display: block;
    position: absolute;
    border-radius: var(--widget-border-radius);
    border: 1px solid #fff9;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
.lil-gui .controller.color input[type=color] {
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.lil-gui .controller.color input[type=text] {
  margin-left: var(--spacing);
  font-family: var(--font-family-mono);
  min-width: var(--color-input-min-width);
  width: var(--color-input-width);
  flex-shrink: 0;
}
.lil-gui .controller.option select {
  opacity: 0;
  position: absolute;
  width: 100%;
  max-width: 100%;
}
.lil-gui .controller.option .display {
  position: relative;
  pointer-events: none;
  border-radius: var(--widget-border-radius);
  height: var(--widget-height);
  line-height: var(--widget-height);
  max-width: 100%;
  overflow: hidden;
  word-break: break-all;
  padding-left: 0.55em;
  padding-right: 1.75em;
  background: var(--widget-color);
}
@media (hover: hover) {
  .lil-gui .controller.option .display.focus {
    background: var(--focus-color);
  }
}
.lil-gui .controller.option .display.active {
  background: var(--focus-color);
}
.lil-gui .controller.option .display:after {
  font-family: "lil-gui";
  content: "↕";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding-right: 0.375em;
}
.lil-gui .controller.option .widget,
.lil-gui .controller.option select {
  cursor: pointer;
}
@media (hover: hover) {
  .lil-gui .controller.option .widget:hover .display {
    background: var(--hover-color);
  }
}
.lil-gui .controller.number input {
  color: var(--number-color);
}
.lil-gui .controller.number.hasSlider input {
  margin-left: var(--spacing);
  width: var(--slider-input-width);
  min-width: var(--slider-input-min-width);
  flex-shrink: 0;
}
.lil-gui .controller.number .slider {
  width: 100%;
  height: var(--widget-height);
  background: var(--widget-color);
  border-radius: var(--widget-border-radius);
  padding-right: var(--slider-knob-width);
  overflow: hidden;
  cursor: ew-resize;
  touch-action: pan-y;
}
@media (hover: hover) {
  .lil-gui .controller.number .slider:hover {
    background: var(--hover-color);
  }
}
.lil-gui .controller.number .slider.active {
  background: var(--focus-color);
}
.lil-gui .controller.number .slider.active .fill {
  opacity: 0.95;
}
.lil-gui .controller.number .fill {
  height: 100%;
  border-right: var(--slider-knob-width) solid var(--number-color);
  box-sizing: content-box;
}

.lil-gui-dragging .lil-gui {
  --hover-color: var(--widget-color);
}
.lil-gui-dragging * {
  cursor: ew-resize !important;
}

.lil-gui-dragging.lil-gui-vertical * {
  cursor: ns-resize !important;
}

.lil-gui .title {
  height: var(--title-height);
  font-weight: 600;
  padding: 0 var(--padding);
  width: 100%;
  text-align: left;
  background: none;
  text-decoration-skip: objects;
}
.lil-gui .title:before {
  font-family: "lil-gui";
  content: "▾";
  padding-right: 2px;
  display: inline-block;
}
.lil-gui .title:active {
  background: var(--title-background-color);
  opacity: 0.75;
}
@media (hover: hover) {
  body:not(.lil-gui-dragging) .lil-gui .title:hover {
    background: var(--title-background-color);
    opacity: 0.85;
  }
  .lil-gui .title:focus {
    text-decoration: underline var(--focus-color);
  }
}
.lil-gui.root > .title:focus {
  text-decoration: none !important;
}
.lil-gui.closed > .title:before {
  content: "▸";
}
.lil-gui.closed > .children {
  transform: translateY(-7px);
  opacity: 0;
}
.lil-gui.closed:not(.transition) > .children {
  display: none;
}
.lil-gui.transition > .children {
  transition-duration: 300ms;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.2, 0.6, 0.35, 1);
  overflow: hidden;
  pointer-events: none;
}
.lil-gui .children:empty:before {
  content: "Empty";
  padding: 0 var(--padding);
  margin: var(--spacing) 0;
  display: block;
  height: var(--widget-height);
  font-style: italic;
  line-height: var(--widget-height);
  opacity: 0.5;
}
.lil-gui.root > .children > .lil-gui > .title {
  border: 0 solid var(--widget-color);
  border-width: 1px 0;
  transition: border-color 300ms;
}
.lil-gui.root > .children > .lil-gui.closed > .title {
  border-bottom-color: transparent;
}
.lil-gui + .controller {
  border-top: 1px solid var(--widget-color);
  margin-top: 0;
  padding-top: var(--spacing);
}
.lil-gui .lil-gui .lil-gui > .title {
  border: none;
}
.lil-gui .lil-gui .lil-gui > .children {
  border: none;
  margin-left: var(--folder-indent);
  border-left: 2px solid var(--widget-color);
}
.lil-gui .lil-gui .controller {
  border: none;
}

.lil-gui label, .lil-gui input, .lil-gui button {
  -webkit-tap-highlight-color: transparent;
}
.lil-gui input {
  border: 0;
  outline: none;
  font-family: var(--font-family);
  font-size: var(--input-font-size);
  border-radius: var(--widget-border-radius);
  height: var(--widget-height);
  background: var(--widget-color);
  color: var(--text-color);
  width: 100%;
}
@media (hover: hover) {
  .lil-gui input:hover {
    background: var(--hover-color);
  }
  .lil-gui input:active {
    background: var(--focus-color);
  }
}
.lil-gui input:disabled {
  opacity: 1;
}
.lil-gui input[type=text],
.lil-gui input[type=number] {
  padding: var(--widget-padding);
  -moz-appearance: textfield;
}
.lil-gui input[type=text]:focus,
.lil-gui input[type=number]:focus {
  background: var(--focus-color);
}
.lil-gui input[type=checkbox] {
  appearance: none;
  width: var(--checkbox-size);
  height: var(--checkbox-size);
  border-radius: var(--widget-border-radius);
  text-align: center;
  cursor: pointer;
}
.lil-gui input[type=checkbox]:checked:before {
  font-family: "lil-gui";
  content: "✓";
  font-size: var(--checkbox-size);
  line-height: var(--checkbox-size);
}
@media (hover: hover) {
  .lil-gui input[type=checkbox]:focus {
    box-shadow: inset 0 0 0 1px var(--focus-color);
  }
}
.lil-gui button {
  outline: none;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: var(--font-size);
  color: var(--text-color);
  width: 100%;
  border: none;
}
.lil-gui .controller button {
  height: var(--widget-height);
  text-transform: none;
  background: var(--widget-color);
  border-radius: var(--widget-border-radius);
}
@media (hover: hover) {
  .lil-gui .controller button:hover {
    background: var(--hover-color);
  }
  .lil-gui .controller button:focus {
    box-shadow: inset 0 0 0 1px var(--focus-color);
  }
}
.lil-gui .controller button:active {
  background: var(--focus-color);
}

@font-face {
  font-family: "lil-gui";
  src: url("data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAUsAAsAAAAACJwAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABCAAAAH4AAADAImwmYE9TLzIAAAGIAAAAPwAAAGBKqH5SY21hcAAAAcgAAAD0AAACrukyyJBnbHlmAAACvAAAAF8AAACEIZpWH2hlYWQAAAMcAAAAJwAAADZfcj2zaGhlYQAAA0QAAAAYAAAAJAC5AHhobXR4AAADXAAAABAAAABMAZAAAGxvY2EAAANsAAAAFAAAACgCEgIybWF4cAAAA4AAAAAeAAAAIAEfABJuYW1lAAADoAAAASIAAAIK9SUU/XBvc3QAAATEAAAAZgAAAJCTcMc2eJxVjbEOgjAURU+hFRBK1dGRL+ALnAiToyMLEzFpnPz/eAshwSa97517c/MwwJmeB9kwPl+0cf5+uGPZXsqPu4nvZabcSZldZ6kfyWnomFY/eScKqZNWupKJO6kXN3K9uCVoL7iInPr1X5baXs3tjuMqCtzEuagm/AAlzQgPAAB4nGNgYRBlnMDAysDAYM/gBiT5oLQBAwuDJAMDEwMrMwNWEJDmmsJwgCFeXZghBcjlZMgFCzOiKOIFAB71Bb8AeJy1kjFuwkAQRZ+DwRAwBtNQRUGKQ8OdKCAWUhAgKLhIuAsVSpWz5Bbkj3dEgYiUIszqWdpZe+Z7/wB1oCYmIoboiwiLT2WjKl/jscrHfGg/pKdMkyklC5Zs2LEfHYpjcRoPzme9MWWmk3dWbK9ObkWkikOetJ554fWyoEsmdSlt+uR0pCJR34b6t/TVg1SY3sYvdf8vuiKrpyaDXDISiegp17p7579Gp3p++y7HPAiY9pmTibljrr85qSidtlg4+l25GLCaS8e6rRxNBmsnERunKbaOObRz7N72ju5vdAjYpBXHgJylOAVsMseDAPEP8LYoUHicY2BiAAEfhiAGJgZWBgZ7RnFRdnVJELCQlBSRlATJMoLV2DK4glSYs6ubq5vbKrJLSbGrgEmovDuDJVhe3VzcXFwNLCOILB/C4IuQ1xTn5FPilBTj5FPmBAB4WwoqAHicY2BkYGAA4sk1sR/j+W2+MnAzpDBgAyEMQUCSg4EJxAEAwUgFHgB4nGNgZGBgSGFggJMhDIwMqEAYAByHATJ4nGNgAIIUNEwmAABl3AGReJxjYAACIQYlBiMGJ3wQAEcQBEV4nGNgZGBgEGZgY2BiAAEQyQWEDAz/wXwGAAsPATIAAHicXdBNSsNAHAXwl35iA0UQXYnMShfS9GPZA7T7LgIu03SSpkwzYTIt1BN4Ak/gKTyAeCxfw39jZkjymzcvAwmAW/wgwHUEGDb36+jQQ3GXGot79L24jxCP4gHzF/EIr4jEIe7wxhOC3g2TMYy4Q7+Lu/SHuEd/ivt4wJd4wPxbPEKMX3GI5+DJFGaSn4qNzk8mcbKSR6xdXdhSzaOZJGtdapd4vVPbi6rP+cL7TGXOHtXKll4bY1Xl7EGnPtp7Xy2n00zyKLVHfkHBa4IcJ2oD3cgggWvt/V/FbDrUlEUJhTn/0azVWbNTNr0Ens8de1tceK9xZmfB1CPjOmPH4kitmvOubcNpmVTN3oFJyjzCvnmrwhJTzqzVj9jiSX911FjeAAB4nG3HMRKCMBBA0f0giiKi4DU8k0V2GWbIZDOh4PoWWvq6J5V8If9NVNQcaDhyouXMhY4rPTcG7jwYmXhKq8Wz+p762aNaeYXom2n3m2dLTVgsrCgFJ7OTmIkYbwIbC6vIB7WmFfAAAA==") format("woff");
}`;
function _injectStyles(Xn) {
  const zn = document.createElement("style");
  zn.innerHTML = Xn;
  const Un = document.querySelector("head link[rel=stylesheet], head style");
  Un ? document.head.insertBefore(zn, Un) : document.head.appendChild(zn);
}
let stylesInjected = !1;
class GUI {
  /**
   * Creates a panel that holds controllers.
   * @example
   * new GUI();
   * new GUI( { container: document.getElementById( 'custom' ) } );
   *
   * @param {object} [options]
   * @param {boolean} [options.autoPlace=true]
   * Adds the GUI to `document.body` and fixes it to the top right of the page.
   *
   * @param {HTMLElement} [options.container]
   * Adds the GUI to this DOM element. Overrides `autoPlace`.
   *
   * @param {number} [options.width=245]
   * Width of the GUI in pixels, usually set when name labels become too long. Note that you can make
   * name labels wider in CSS with `.lil‑gui { ‑‑name‑width: 55% }`.
   *
   * @param {string} [options.title=Controls]
   * Name to display in the title bar.
   *
   * @param {boolean} [options.closeFolders=false]
   * Pass `true` to close all folders in this GUI by default.
   *
   * @param {boolean} [options.injectStyles=true]
   * Injects the default stylesheet into the page if this is the first GUI.
   * Pass `false` to use your own stylesheet.
   *
   * @param {number} [options.touchStyles=true]
   * Makes controllers larger on touch devices. Pass `false` to disable touch styles.
   *
   * @param {GUI} [options.parent]
   * Adds this GUI as a child in another GUI. Usually this is done for you by `addFolder()`.
   */
  constructor({
    parent: zn,
    autoPlace: Un = zn === void 0,
    container: Kn,
    width: qn,
    title: Jo = "Controls",
    closeFolders: pa = !1,
    injectStyles: ma = !0,
    touchStyles: va = !0
  } = {}) {
    if (this.parent = zn, this.root = zn ? zn.root : this, this.children = [], this.controllers = [], this.folders = [], this._closed = !1, this._hidden = !1, this.domElement = document.createElement("div"), this.domElement.classList.add("lil-gui"), this.$title = document.createElement("button"), this.$title.classList.add("title"), this.$title.setAttribute("aria-expanded", !0), this.$title.addEventListener("click", () => this.openAnimated(this._closed)), this.$title.addEventListener("touchstart", () => {
    }, { passive: !0 }), this.$children = document.createElement("div"), this.$children.classList.add("children"), this.domElement.appendChild(this.$title), this.domElement.appendChild(this.$children), this.title(Jo), this.parent) {
      this.parent.children.push(this), this.parent.folders.push(this), this.parent.$children.appendChild(this.domElement);
      return;
    }
    this.domElement.classList.add("root"), va && this.domElement.classList.add("allow-touch-styles"), !stylesInjected && ma && (_injectStyles(stylesheet), stylesInjected = !0), Kn ? Kn.appendChild(this.domElement) : Un && (this.domElement.classList.add("autoPlace"), document.body.appendChild(this.domElement)), qn && this.domElement.style.setProperty("--width", qn + "px"), this._closeFolders = pa;
  }
  /**
   * Adds a controller to the GUI, inferring controller type using the `typeof` operator.
   * @example
   * gui.add( object, 'property' );
   * gui.add( object, 'number', 0, 100, 1 );
   * gui.add( object, 'options', [ 1, 2, 3 ] );
   *
   * @param {object} object The object the controller will modify.
   * @param {string} property Name of the property to control.
   * @param {number|object|Array} [$1] Minimum value for number controllers, or the set of
   * selectable values for a dropdown.
   * @param {number} [max] Maximum value for number controllers.
   * @param {number} [step] Step value for number controllers.
   * @returns {Controller}
   */
  add(zn, Un, Kn, qn, Jo) {
    if (Object(Kn) === Kn)
      return new OptionController(this, zn, Un, Kn);
    const pa = zn[Un];
    switch (typeof pa) {
      case "number":
        return new NumberController(this, zn, Un, Kn, qn, Jo);
      case "boolean":
        return new BooleanController(this, zn, Un);
      case "string":
        return new StringController(this, zn, Un);
      case "function":
        return new FunctionController(this, zn, Un);
    }
    console.error(`gui.add failed
	property:`, Un, `
	object:`, zn, `
	value:`, pa);
  }
  /**
   * Adds a color controller to the GUI.
   * @example
   * params = {
   * 	cssColor: '#ff00ff',
   * 	rgbColor: { r: 0, g: 0.2, b: 0.4 },
   * 	customRange: [ 0, 127, 255 ],
   * };
   *
   * gui.addColor( params, 'cssColor' );
   * gui.addColor( params, 'rgbColor' );
   * gui.addColor( params, 'customRange', 255 );
   *
   * @param {object} object The object the controller will modify.
   * @param {string} property Name of the property to control.
   * @param {number} rgbScale Maximum value for a color channel when using an RGB color. You may
   * need to set this to 255 if your colors are too bright.
   * @returns {Controller}
   */
  addColor(zn, Un, Kn = 1) {
    return new ColorController(this, zn, Un, Kn);
  }
  /**
   * Adds a folder to the GUI, which is just another GUI. This method returns
   * the nested GUI so you can add controllers to it.
   * @example
   * const folder = gui.addFolder( 'Position' );
   * folder.add( position, 'x' );
   * folder.add( position, 'y' );
   * folder.add( position, 'z' );
   *
   * @param {string} title Name to display in the folder's title bar.
   * @returns {GUI}
   */
  addFolder(zn) {
    const Un = new GUI({ parent: this, title: zn });
    return this.root._closeFolders && Un.close(), Un;
  }
  /**
   * Recalls values that were saved with `gui.save()`.
   * @param {object} obj
   * @param {boolean} recursive Pass false to exclude folders descending from this GUI.
   * @returns {this}
   */
  load(zn, Un = !0) {
    return zn.controllers && this.controllers.forEach((Kn) => {
      Kn instanceof FunctionController || Kn._name in zn.controllers && Kn.load(zn.controllers[Kn._name]);
    }), Un && zn.folders && this.folders.forEach((Kn) => {
      Kn._title in zn.folders && Kn.load(zn.folders[Kn._title]);
    }), this;
  }
  /**
   * Returns an object mapping controller names to values. The object can be passed to `gui.load()` to
   * recall these values.
   * @example
   * {
   * 	controllers: {
   * 		prop1: 1,
   * 		prop2: 'value',
   * 		...
   * 	},
   * 	folders: {
   * 		folderName1: { controllers, folders },
   * 		folderName2: { controllers, folders }
   * 		...
   * 	}
   * }
   *
   * @param {boolean} recursive Pass false to exclude folders descending from this GUI.
   * @returns {object}
   */
  save(zn = !0) {
    const Un = {
      controllers: {},
      folders: {}
    };
    return this.controllers.forEach((Kn) => {
      if (!(Kn instanceof FunctionController)) {
        if (Kn._name in Un.controllers)
          throw new Error(`Cannot save GUI with duplicate property "${Kn._name}"`);
        Un.controllers[Kn._name] = Kn.save();
      }
    }), zn && this.folders.forEach((Kn) => {
      if (Kn._title in Un.folders)
        throw new Error(`Cannot save GUI with duplicate folder "${Kn._title}"`);
      Un.folders[Kn._title] = Kn.save();
    }), Un;
  }
  /**
   * Opens a GUI or folder. GUI and folders are open by default.
   * @param {boolean} open Pass false to close.
   * @returns {this}
   * @example
   * gui.open(); // open
   * gui.open( false ); // close
   * gui.open( gui._closed ); // toggle
   */
  open(zn = !0) {
    return this._setClosed(!zn), this.$title.setAttribute("aria-expanded", !this._closed), this.domElement.classList.toggle("closed", this._closed), this;
  }
  /**
   * Closes the GUI.
   * @returns {this}
   */
  close() {
    return this.open(!1);
  }
  _setClosed(zn) {
    this._closed !== zn && (this._closed = zn, this._callOnOpenClose(this));
  }
  /**
   * Shows the GUI after it's been hidden.
   * @param {boolean} show
   * @returns {this}
   * @example
   * gui.show();
   * gui.show( false ); // hide
   * gui.show( gui._hidden ); // toggle
   */
  show(zn = !0) {
    return this._hidden = !zn, this.domElement.style.display = this._hidden ? "none" : "", this;
  }
  /**
   * Hides the GUI.
   * @returns {this}
   */
  hide() {
    return this.show(!1);
  }
  openAnimated(zn = !0) {
    return this._setClosed(!zn), this.$title.setAttribute("aria-expanded", !this._closed), requestAnimationFrame(() => {
      const Un = this.$children.clientHeight;
      this.$children.style.height = Un + "px", this.domElement.classList.add("transition");
      const Kn = (Jo) => {
        Jo.target === this.$children && (this.$children.style.height = "", this.domElement.classList.remove("transition"), this.$children.removeEventListener("transitionend", Kn));
      };
      this.$children.addEventListener("transitionend", Kn);
      const qn = zn ? this.$children.scrollHeight : 0;
      this.domElement.classList.toggle("closed", !zn), requestAnimationFrame(() => {
        this.$children.style.height = qn + "px";
      });
    }), this;
  }
  /**
   * Change the title of this GUI.
   * @param {string} title
   * @returns {this}
   */
  title(zn) {
    return this._title = zn, this.$title.textContent = zn, this;
  }
  /**
   * Resets all controllers to their initial values.
   * @param {boolean} recursive Pass false to exclude folders descending from this GUI.
   * @returns {this}
   */
  reset(zn = !0) {
    return (zn ? this.controllersRecursive() : this.controllers).forEach((Kn) => Kn.reset()), this;
  }
  /**
   * Pass a function to be called whenever a controller in this GUI changes.
   * @param {function({object:object, property:string, value:any, controller:Controller})} callback
   * @returns {this}
   * @example
   * gui.onChange( event => {
   * 	event.object     // object that was modified
   * 	event.property   // string, name of property
   * 	event.value      // new value of controller
   * 	event.controller // controller that was modified
   * } );
   */
  onChange(zn) {
    return this._onChange = zn, this;
  }
  _callOnChange(zn) {
    this.parent && this.parent._callOnChange(zn), this._onChange !== void 0 && this._onChange.call(this, {
      object: zn.object,
      property: zn.property,
      value: zn.getValue(),
      controller: zn
    });
  }
  /**
   * Pass a function to be called whenever a controller in this GUI has finished changing.
   * @param {function({object:object, property:string, value:any, controller:Controller})} callback
   * @returns {this}
   * @example
   * gui.onFinishChange( event => {
   * 	event.object     // object that was modified
   * 	event.property   // string, name of property
   * 	event.value      // new value of controller
   * 	event.controller // controller that was modified
   * } );
   */
  onFinishChange(zn) {
    return this._onFinishChange = zn, this;
  }
  _callOnFinishChange(zn) {
    this.parent && this.parent._callOnFinishChange(zn), this._onFinishChange !== void 0 && this._onFinishChange.call(this, {
      object: zn.object,
      property: zn.property,
      value: zn.getValue(),
      controller: zn
    });
  }
  /**
   * Pass a function to be called when this GUI or its descendants are opened or closed.
   * @param {function(GUI)} callback
   * @returns {this}
   * @example
   * gui.onOpenClose( changedGUI => {
   * 	console.log( changedGUI._closed );
   * } );
   */
  onOpenClose(zn) {
    return this._onOpenClose = zn, this;
  }
  _callOnOpenClose(zn) {
    this.parent && this.parent._callOnOpenClose(zn), this._onOpenClose !== void 0 && this._onOpenClose.call(this, zn);
  }
  /**
   * Destroys all DOM elements and event listeners associated with this GUI.
   */
  destroy() {
    this.parent && (this.parent.children.splice(this.parent.children.indexOf(this), 1), this.parent.folders.splice(this.parent.folders.indexOf(this), 1)), this.domElement.parentElement && this.domElement.parentElement.removeChild(this.domElement), Array.from(this.children).forEach((zn) => zn.destroy());
  }
  /**
   * Returns an array of controllers contained by this GUI and its descendents.
   * @returns {Controller[]}
   */
  controllersRecursive() {
    let zn = Array.from(this.controllers);
    return this.folders.forEach((Un) => {
      zn = zn.concat(Un.controllersRecursive());
    }), zn;
  }
  /**
   * Returns an array of folders contained by this GUI and its descendents.
   * @returns {GUI[]}
   */
  foldersRecursive() {
    let zn = Array.from(this.folders);
    return this.folders.forEach((Un) => {
      zn = zn.concat(Un.foldersRecursive());
    }), zn;
  }
}
class Camera extends Dependent {
  constructor(Un) {
    super();
    Ca(this, "START_CAMERA_ZOOM", 1);
    Ca(this, "START_CAMERA_POSITION_X", 0);
    Ca(this, "START_CAMERA_POSITION_Y", 0);
    Ca(this, "END_CAMERA_POSITION_MARGIN", 110);
    Ca(this, "isAnimating", !1);
    Ca(this, "accumulatedOffset", 0);
    Ca(this, "cameraConfiguration");
    Ca(this, "canvas");
    Ca(this, "postUpdateViewListeners");
    /**
     * Смещает камеру по canvas на передаваемый сдвиг.
     * @param offset Сдвиг на который произойдет смещение.
     */
    Ca(this, "move", (Un) => {
      this.accumulatedOffset += Un, this.isAnimating || this.startMovement();
    });
    /**
     * Устанавливает новую конфигурацию.
     * @param fn
     */
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.cameraConfiguration, qn = Un(Kn);
      Kn.x !== qn.x && (this.cameraConfiguration.x = qn.x), Kn.y !== qn.y && (this.cameraConfiguration.y = qn.y), Kn.zoom !== qn.zoom && (this.cameraConfiguration.zoom = qn.zoom), Kn.width !== qn.width && (this.cameraConfiguration.width = qn.width), Kn.height !== qn.height && (this.cameraConfiguration.height = qn.height), Kn.startX !== qn.startX && (this.cameraConfiguration.startX = qn.startX), Kn.startY !== qn.startY && (this.cameraConfiguration.startY = qn.startY), Kn.endMarginY !== qn.endMarginY && (this.cameraConfiguration.endMarginY = qn.endMarginY);
    });
    Ca(this, "getConfiguration", () => ({
      ...this.cameraConfiguration
    }));
    Ca(this, "updateDimension", () => {
      this.setConfiguration((Un) => ({
        ...Un,
        width: this.canvas.getWidth(),
        height: this.canvas.getHeight()
      }));
    });
    /**
     * Добавляет слушателей изменения конфигурации камеры.
     * @param listener Слушатель события.
     */
    Ca(this, "addPostUpdateViewListeners", (Un) => {
      this.postUpdateViewListeners.push(Un);
    });
    /**
     * Вызывает всех слушателей, зарегистрированных для обработки изменений конфигурации камеры.
     */
    Ca(this, "callPostUpdateViewListeners", () => {
      this.postUpdateViewListeners.forEach((Un) => Un());
    });
    /**
     * Запускает перемещения камеры.
     */
    Ca(this, "startMovement", () => {
      if (this.accumulatedOffset === 0) {
        this.isAnimating = !1;
        return;
      }
      const Kn = this.dependencies.componentTree.getRootComponent().getLastGraphic();
      if (!Kn)
        throw new EditorError("Root component has no last graphic.");
      const qn = Kn.getFrameConfiguration(), { startY: Jo, endMarginY: pa, zoom: ma, y: va, height: ba } = this.cameraConfiguration, { y: _a, height: ya } = qn, xa = _a + ya + pa;
      if (xa <= ba / ma) return;
      const wa = -(xa - ba / ma), Ta = Math.max(wa, Math.min(Jo, va - this.accumulatedOffset));
      this.accumulatedOffset = 0, this.applyAnimation({ startPosition: va, targetPosition: Ta });
    });
    /**
     * Применяет анимацию для перемещения камеры.
     */
    Ca(this, "applyAnimation", (Un) => {
      this.isAnimating = !0, un.animate({
        startValue: Un.startPosition,
        endValue: Un.targetPosition,
        easing: un.ease.easeInSine,
        duration: 50,
        onChange: (Kn) => {
          this.setConfiguration((qn) => ({
            ...qn,
            y: Kn
          })), this.updateView();
        },
        onComplete: () => {
          this.isAnimating = !1, this.accumulatedOffset !== 0 && this.startMovement();
        }
      });
    });
    this.canvas = Un, this.cameraConfiguration = {
      x: this.START_CAMERA_POSITION_X,
      y: this.START_CAMERA_POSITION_Y,
      width: this.canvas.getWidth(),
      height: this.canvas.getHeight(),
      zoom: this.START_CAMERA_ZOOM,
      startX: this.START_CAMERA_POSITION_X,
      startY: this.START_CAMERA_POSITION_Y,
      endMarginY: this.END_CAMERA_POSITION_MARGIN
    }, this.postUpdateViewListeners = [], this.updateView();
  }
  /**
   * Обновление канваса в соответствии с текущим состоянием камеры
   */
  updateView() {
    this.canvas.setZoom(this.cameraConfiguration.zoom), this.canvas.setViewportTransform([
      this.cameraConfiguration.zoom,
      0,
      0,
      this.cameraConfiguration.zoom,
      this.cameraConfiguration.x * this.cameraConfiguration.zoom,
      this.cameraConfiguration.y * this.cameraConfiguration.zoom
    ]), this.callPostUpdateViewListeners();
  }
}
class LayerVisualizer extends Dependent {
  constructor(Un = 35, Kn = 80, qn = 60) {
    super();
    Ca(this, "GUI_FOLDER_NAME", "Layer Tree");
    Ca(this, "guiParameters");
    Ca(this, "nodeSize");
    // Размер круга (диаметр)
    Ca(this, "horizontalSpacing");
    // Горизонтальное расстояние между узлами
    Ca(this, "verticalSpacing");
    // Вертикальное расстояние между уровнями дерева
    Ca(this, "canvasWidth");
    // Ширина холста
    Ca(this, "canvasHeight");
    // Высота холста
    Ca(this, "rootX");
    // Координата X корневого узла
    Ca(this, "rootY");
    // Координата Y корневого узла
    // Цветовая палитра для типов графики
    Ca(this, "colorMapping", {
      [GraphicType.GROUP]: "#F9B5D0",
      // Пастельный розовый
      [GraphicType.PICTURE]: "#FDD9A5",
      // Пастельный персиковый
      [GraphicType.TABLE]: "#A9E2A0",
      // Пастельный зеленый
      [GraphicType.TEXT]: "#A7D8F0",
      // Пастельный голубой
      [GraphicType.FIGURE]: "#E6B3E2",
      // Пастельный сиреневый
      [GraphicType.PAGE]: "#DDDDDD",
      // Пастельный серый
      [GraphicType.MODULE]: "#D6CDEA",
      // Пастельный лавандовый
      [GraphicType.LINE]: "#FFF4A3"
      // Пастельный желтый
    });
    Ca(this, "sync", () => {
      const { width: Un, height: Kn } = this.dependencies.canvas;
      this.updateCanvasSize(Un, Kn), this.dependencies.render.render();
    });
    Ca(this, "addGUIBlock", (Un) => {
      Un.addFolder(this.GUI_FOLDER_NAME).add(this.guiParameters, "isEnable").name("Show").onChange((qn) => {
        qn ? this.enable() : this.disable(), this.sync();
      });
    });
    Ca(this, "enable", () => {
      this.guiParameters.isEnable = !0;
    });
    Ca(this, "disable", () => {
      this.guiParameters.isEnable = !1;
    });
    this.nodeSize = Un, this.horizontalSpacing = Kn, this.verticalSpacing = qn, this.canvasWidth = 800, this.canvasHeight = 600, this.rootX = this.canvasWidth / 2, this.rootY = 50, this.guiParameters = {
      isEnable: !1
    };
  }
  /**
   * Генерирует Fabric объекты для визуализации дерева.
   */
  getObjects() {
    if (!this.guiParameters.isEnable)
      return [];
    const Un = this.dependencies.tree.getRootLayer();
    if (!Un)
      throw new Error("Tree is empty. No root layer found.");
    const Kn = [], qn = /* @__PURE__ */ new Map(), Jo = this.nodeSize * 0.2, pa = (va) => {
      const ba = va.getLayers();
      return !ba || ba.length === 0 ? this.nodeSize + Jo : Math.max(
        ba.reduce((_a, ya) => _a + pa(ya), 0),
        Jo * ba.length
      );
    }, ma = (va, ba, _a) => {
      var Sa;
      qn.set(va, { x: ba, y: _a });
      const ya = this.getCircle(((Sa = va.getData()) == null ? void 0 : Sa.type) || GraphicType.GROUP), xa = this.getText(va.getName()), wa = new Mr([ya, xa], {
        left: Math.round(ba),
        top: Math.round(_a),
        originX: "center",
        originY: "center"
      });
      Kn.push(wa);
      const Ta = va.getLayers();
      if (Ta) {
        let Ma = ba - pa(va) / 2;
        Ta.forEach((ka) => {
          const Za = pa(ka), Na = Ma + Za / 2, Ka = _a + this.verticalSpacing;
          Ma += Za + Jo / 2;
          const [Ja, el, qa, tl] = this.getLinePoints(ba, _a, Na, Ka, this.nodeSize / 2);
          Kn.push(new $n([Ja, el, qa, tl], { stroke: "black", strokeWidth: 2 })), ma(ka, Na, Ka);
        });
      }
    };
    return ma(Un, this.rootX, this.rootY), Kn.push(...this.createLegend()), Kn;
  }
  /**
   * Создает круг для узла.
   */
  getCircle(Un) {
    return new Nn({
      radius: Math.round(this.nodeSize / 2),
      fill: this.colorMapping[Un] || "#FFFFFF",
      // Цвет узла
      stroke: "black",
      strokeWidth: 2,
      originX: "center",
      originY: "center"
    });
  }
  /**
   * Создает текст внутри круга для узла.
   */
  getText(Un) {
    return new To(Un, {
      fontSize: 12,
      originX: "center",
      originY: "center",
      fill: "black"
    });
  }
  /**
   * Вычисляет точки соединения линии с краями кругов.
   */
  getLinePoints(Un, Kn, qn, Jo, pa) {
    const ma = qn - Un, va = Jo - Kn, ba = Math.sqrt(ma * ma + va * va), _a = ma / ba * pa, ya = va / ba * pa, xa = ma / ba * pa, wa = va / ba * pa;
    return [
      Math.round(Un + _a),
      Math.round(Kn + ya),
      // Точка на крае родительского круга
      Math.round(qn - xa),
      Math.round(Jo - wa)
      // Точка на крае дочернего круга
    ];
  }
  /**
   * Создает легенду цветов.
   */
  createLegend() {
    const Un = [];
    return Object.entries(this.colorMapping).forEach(([Jo, pa], ma) => {
      const va = new pr({
        left: 20,
        top: 20 + ma * 25,
        width: 20,
        height: 20,
        fill: pa,
        stroke: "black",
        strokeWidth: 1
      }), ba = new To(Jo, {
        left: 50,
        top: 20 + ma * 25,
        fontSize: 14,
        originX: "left",
        originY: "top",
        fill: "black"
      });
      Un.push(va, ba);
    }), Un;
  }
  /**
   * Обновляет размеры холста и пересчитывает координаты центра дерева.
   */
  updateCanvasSize(Un, Kn) {
    this.canvasWidth = Un, this.canvasHeight = Kn, this.rootX = this.canvasWidth / 2, this.rootY = 50;
  }
}
class CanvasObjectPositionCorrector extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "sync", () => {
      const Kn = this.dependencies.layerRegistry.getTree().getRootLayer();
      if (Kn === null)
        return;
      const qn = Kn.getLayers();
      if (qn !== null)
        for (let Jo = 0; Jo < qn.length; Jo++)
          this.recursiveCorrect(qn[Jo], 0, 0);
    });
    Ca(this, "recursiveCorrect", (Un, Kn, qn) => {
      const Jo = Un.getData();
      if (Jo === null)
        throw new EditorError("graphic not found");
      const { x: pa, y: ma } = Jo.getFrameConfiguration(), va = Jo.getObjects();
      for (let Ma = 0; Ma < va.length; Ma++)
        va[Ma].object.set({
          top: qn + ma + va[Ma].relativePosition.y,
          left: Kn + pa + va[Ma].relativePosition.x
        });
      const _a = Jo.getSizePanel().getObjects();
      for (let Ma = 0; Ma < _a.length; Ma++)
        _a[Ma].object.set({
          top: qn + ma + _a[Ma].relativePosition.y,
          left: Kn + pa + _a[Ma].relativePosition.x
        });
      const xa = Jo.getHoverHighlighter().getObjects();
      for (let Ma = 0; Ma < xa.length; Ma++)
        xa[Ma].object.set({
          top: qn + ma + xa[Ma].relativePosition.y - xa[Ma].object.strokeWidth,
          left: Kn + pa + xa[Ma].relativePosition.x - xa[Ma].object.strokeWidth
        });
      const Ta = Jo.getEditModeHighlighter().getObjects();
      for (let Ma = 0; Ma < Ta.length; Ma++)
        Ta[Ma].object.set({
          top: qn + ma + Ta[Ma].relativePosition.y,
          left: Kn + pa + Ta[Ma].relativePosition.x
        });
      const Sa = Un.getLayers();
      if (Sa !== null)
        for (let Ma = 0; Ma < Sa.length; Ma++)
          this.recursiveCorrect(Sa[Ma], Kn + pa, qn + ma);
    });
  }
}
class BaseRender extends Dependent {
  constructor() {
    super(...arguments);
    /**
     * Выполняет анимацию изменения цвета объекта.
     * @param animateColor - Массив объектов, для которых будет выполнена анимация.
     */
    Ca(this, "animateColor", (...Un) => {
      Un.forEach((Kn) => {
        un.animateColor({
          startValue: Kn.startColor,
          endValue: Kn.endColor,
          duration: Kn.duration,
          onChange: (qn) => {
            Kn.object.set(Kn.type, qn), this.dependencies.canvas.requestRenderAll();
          },
          onComplete: () => {
          }
        });
      });
    });
    /**
     * Выполняет анимацию для группы объектов.
     * @param animateObjects - Массив объектов, для которых будет выполнена анимация.
     */
    Ca(this, "animateObjects", (...Un) => new Promise((Kn) => {
      let qn = 0;
      Un.forEach((Jo) => {
        un.animate({
          startValue: Jo.start,
          endValue: Jo.end,
          duration: Jo.duration,
          easing: Jo.ease,
          onChange: (pa) => {
            Jo.object.set(Jo.type, pa), this.dependencies.canvas.requestRenderAll();
          },
          onComplete: () => {
            qn++, qn === Un.length && Kn(null);
          }
        });
      }), Un.length === 0 && Kn(null);
    }));
    Ca(this, "getWidth", () => this.dependencies.canvas.width);
    Ca(this, "getHeight", () => this.dependencies.canvas.height);
    Ca(this, "syncObjects", (Un) => {
      const Kn = this.dependencies.canvas.getObjects(), qn = new Set(Kn);
      Un.forEach((Jo) => {
        qn.has(Jo) || this.dependencies.canvas.add(Jo);
      }), Kn.forEach((Jo) => {
        Un.includes(Jo) || this.dependencies.canvas.remove(Jo);
      }), this.dependencies.canvas._objects = [...Un];
    });
  }
}
class CanvasRender extends BaseRender {
  /**
   * Конструктор класса Render.
   * Инициализирует корректировщик позиций и регистрирует слушатель для внедрения зависимостей.
   */
  constructor() {
    super();
    /** Корректировщик позиций объектов. */
    Ca(this, "positionCorrector");
    /**
     * Выполняет синхронизацию объектов и их порядка на холсте.
     */
    Ca(this, "render", () => {
      const Un = this.dependencies.canvasObjectOrganizer.getSortedObjects();
      this.positionCorrector.sync(), this.syncObjects(Un), this.dependencies.canvas.requestRenderAll();
    });
    /**
     * Выполняет обновление основного холста без учета структуры объектов.
     */
    Ca(this, "renderUnstructured", () => {
      this.dependencies.canvas.requestRenderAll();
    });
    /**
     * Синхронизирует позиции объектов и обновляет основной холст.
     */
    Ca(this, "renderRelativePositions", async () => {
      this.positionCorrector.sync(), this.renderUnstructured();
    });
    /**
     * Принудительно обновляет основной холст, игнорируя структуру объектов.
     */
    Ca(this, "forceRenderUnstructured", () => {
      this.dependencies.canvas.renderAll();
    });
    this.positionCorrector = new CanvasObjectPositionCorrector(), this.addPostInjectDependenciesListener((Un) => {
      this.positionCorrector.connectDependencies({
        layerRegistry: Un.layerRegistry
      }), this.positionCorrector.injectDependencies();
    });
  }
}
class AreaController {
  constructor() {
    Ca(this, "controllers");
    Ca(this, "activeArea");
    Ca(this, "appendController", (zn) => {
      this.controllers.push(zn);
    });
    Ca(this, "sync", async () => {
      for (let zn = 0; zn < this.controllers.length; zn++)
        await this.controllers[zn].sync();
      this.updateArea();
    });
    Ca(this, "updateActiveArea", () => {
      for (let zn = this.controllers.length - 1; zn >= 0; zn--)
        if (this.controllers[zn].updateActiveArea(), this.activeArea = this.controllers[zn].getActiveArea(), this.activeArea !== null)
          return;
    });
    Ca(this, "updateArea", () => {
      for (let zn = this.controllers.length - 1; zn >= 0; zn--)
        if (this.activeArea = this.controllers[zn].getActiveArea(), this.activeArea !== null)
          return;
    });
    Ca(this, "updateAreaPosition", () => {
      for (let zn = 0; zn < this.controllers.length; zn++)
        this.controllers[zn].updateAreaPosition();
    });
    Ca(this, "getActiveArea", () => this.activeArea);
    Ca(this, "getAreaStack", () => this.controllers.flatMap((zn) => zn.getAreaStack()));
    this.controllers = [], this.activeArea = null;
  }
}
class CanvasAreaDetector {
  constructor() {
    /**
     * Определяет область на которую наведена мышь с учетом бизнес логики.
     * При определении области, если областью является SpatialAreaType.GRAPHIC, важно учитывать состояние родительских
     * и вложенных компонентов. Возможные варианты target-области (target-область - область графики под курсором мыши)
     * и того, что должна вернуть на выходе:
     *	1 пустое (от вложенного компонента) место в uniter-графике в режиме редактирования: uniter-графика,
     *	2 пустое (от вложенного компонента) место в uniter-графике не в режиме редактирования: uniter-графика,
     *	3 графика дочернего компонента у Uniter-компонента в режиме редактирования: графика дочернего компонента,
     *	4 графика дочернего компонента у Uniter-компонента не в режиме редактирования: uniter-графика,
     * @param areas Все пересеченные области в порядке от пользователя по оси Z в текущей позиции курсора.
     */
    Ca(this, "detect", (zn) => {
      for (let Un = 0; Un < zn.length; ++Un) {
        const Kn = zn[Un], { graphic: qn } = Kn.getData();
        switch (Kn.type) {
          case SpatialCanvasAreaType.BUTTON:
            return Kn;
          case SpatialCanvasAreaType.GRAPHIC_ANGULAR_RESIZE:
            return Kn;
          case SpatialCanvasAreaType.GRAPHIC_RESIZE:
            return Kn;
          case SpatialCanvasAreaType.GRAPHIC: {
            if (qn.isEnableEditMode() && qn.isUniter) {
              if (Un === zn.length - 1)
                return zn[Un];
              const Jo = zn[Un + 1], pa = Jo.getData().graphic;
              if (pa.type === SpatialCanvasAreaType.GRAPHIC && pa.getStructure().type === GraphicType.PAGE)
                return Jo;
              break;
            }
            if (qn.isEnableEditMode() && !qn.isUniter || !qn.isEnableEditMode() && qn.getStructure().type !== GraphicType.PAGE)
              return Kn;
            break;
          }
          case SpatialCanvasAreaType.PICTURE_ANGULAR_RESIZE: {
            if (qn.isEnableEditMode())
              return Kn;
            break;
          }
          case SpatialCanvasAreaType.PICTURE_RESIZE: {
            if (qn.isEnableEditMode())
              return Kn;
            break;
          }
          case SpatialCanvasAreaType.PICTURE: {
            if (qn.isEnableEditMode())
              return Kn;
            break;
          }
          case SpatialCanvasAreaType.TABLE_COLUMN_RESIZE: {
            if (qn.isEnableEditMode())
              return Kn;
            break;
          }
          case SpatialCanvasAreaType.TABLE_ROW_RESIZE: {
            if (qn.isEnableEditMode())
              return Kn;
            break;
          }
          case SpatialCanvasAreaType.TABLE_CELL: {
            if (qn.isEnableEditMode())
              return Kn;
            break;
          }
          default:
            throw new EditorError("not implemented all spatial area type");
        }
      }
      return null;
    });
  }
}
class SpatialAreaSorter {
  constructor() {
    Ca(this, "sortForType", (zn) => {
      if (!this.sortSequence || this.sortSequence.length === 0)
        throw new EditorError("Sort sequence is not defined or empty");
      return zn.sort((Un, Kn) => {
        const qn = this.sortSequence.indexOf(Un.type), Jo = this.sortSequence.indexOf(Kn.type);
        return (qn === -1 ? 1 / 0 : qn) - (Jo === -1 ? 1 / 0 : Jo);
      });
    });
  }
}
class CanvasAreaSorter extends SpatialAreaSorter {
  constructor() {
    super(...arguments);
    Ca(this, "sortSequence", [
      SpatialCanvasAreaType.TABLE_COLUMN_RESIZE,
      SpatialCanvasAreaType.TABLE_ROW_RESIZE,
      SpatialCanvasAreaType.TABLE_CELL,
      SpatialCanvasAreaType.PICTURE_ANGULAR_RESIZE,
      SpatialCanvasAreaType.PICTURE_RESIZE,
      SpatialCanvasAreaType.PICTURE,
      SpatialCanvasAreaType.GRAPHIC_ANGULAR_RESIZE,
      SpatialCanvasAreaType.GRAPHIC_RESIZE,
      SpatialCanvasAreaType.GRAPHIC
    ]);
    Ca(this, "sort", (Un) => {
      const qn = Un.filter(
        (_a) => Object.values(SpatialCanvasAreaType).includes(_a.type)
      ).sort((_a, ya) => {
        const xa = _a.getData().graphic.getFrameConfiguration(), wa = ya.getData().graphic.getFrameConfiguration();
        return xa.layer < wa.layer ? 1 : xa.layer > wa.layer ? -1 : 0;
      }), Jo = [], pa = [], ma = [], va = [], ba = [];
      for (let _a = 0; _a < qn.length; _a++) {
        const ya = qn[_a], xa = ya.getData().graphic;
        if (ya.type === SpatialCanvasAreaType.BUTTON) {
          Jo.push(ya);
          continue;
        }
        if (xa.isEnableEditMode()) {
          if (ya.type === SpatialCanvasAreaType.PICTURE_RESIZE || ya.type === SpatialCanvasAreaType.GRAPHIC_RESIZE || ya.type === SpatialCanvasAreaType.PICTURE_ANGULAR_RESIZE || ya.type === SpatialCanvasAreaType.GRAPHIC_ANGULAR_RESIZE) {
            pa.push(ya);
            continue;
          }
          ma.push(ya);
        } else xa.isEnableFocus() ? ya.getData().graphic.type !== "GRAPHIC_PAGE" && va.push(ya) : ba.push(ya);
      }
      return [
        ...this.groupAreasFromGraphic(Jo),
        ...this.groupAreasFromGraphic(pa),
        ...this.groupAreasFromGraphic(ma),
        ...this.groupAreasFromGraphic(va),
        ...this.groupAreasFromGraphic(ba)
      ];
    });
    Ca(this, "groupAreasFromGraphic", (Un) => {
      const Kn = /* @__PURE__ */ new Map();
      return Un.forEach((qn) => {
        const { graphic: Jo } = qn.getData();
        Kn.has(Jo) || Kn.set(Jo, []);
        const pa = Kn.get(Jo);
        if (pa === void 0)
          throw new EditorError("the graphic areas not found");
        pa.push(qn);
      }), Kn.forEach((qn, Jo) => {
        qn.length !== 1 && this.sortForType(qn);
      }), Array.from(Kn.values()).flat();
    });
  }
}
class BaseAreaController extends Dependent {
  constructor() {
    super();
    Ca(this, "areaStack");
    // Область, с которой взаимодействует пользователь в данный момент
    Ca(this, "activeArea");
    Ca(this, "getAreaStack", () => [...this.areaStack]);
    Ca(this, "getActiveArea", () => this.activeArea);
    this.areaStack = [], this.activeArea = null;
  }
}
class CanvasAreaController extends BaseAreaController {
  constructor() {
    super();
    Ca(this, "canvasAreaSorter");
    Ca(this, "activeAreaDetector");
    Ca(this, "componentFilterFunctions");
    Ca(this, "sync", async () => {
      const Un = this.dependencies.componentTree.getComponents(), qn = this.filterComponents(Un).flatMap((Jo) => Jo.getSpatialAreas());
      this.dependencies.tree.syncAreas(qn), this.updateActiveArea();
    });
    Ca(this, "updateActiveArea", () => {
      this.areaStack.length = 0, this.activeArea = null;
      const Un = this.dependencies.canvasMouseObserver.getCurrentPosition(), Kn = this.dependencies.tree.getAreasAtPosition(Un);
      Kn !== null && this.areaStack.push(...this.canvasAreaSorter.sort(Kn)), this.activeArea = this.activeAreaDetector.detect(this.areaStack);
    });
    Ca(this, "updateAreaPosition", () => {
      const Un = this.dependencies.componentTree.getComponents(), qn = this.filterComponents(Un).flatMap((Jo) => Jo.getSpatialAreas());
      for (let Jo = 0; Jo < qn.length; Jo++)
        qn[Jo].markDirty();
      this.dependencies.tree.syncAreas(qn), this.updateActiveArea();
    });
    Ca(this, "addFilterComponentFunction", (Un) => {
      this.componentFilterFunctions.push(Un);
    });
    Ca(this, "getAreas", () => this.dependencies.tree.getAreas());
    /**
     * Фильтрует компоненты по заранее сохраненным функциям фильтрации.
     * @param components Компоненты для сортировки.
     */
    Ca(this, "filterComponents", (Un) => {
      let Kn = [...Un];
      for (let qn = 0; qn < this.componentFilterFunctions.length; qn++)
        Kn = Kn.filter(this.componentFilterFunctions[qn]);
      return Kn;
    });
    Ca(this, "filterUniterComponents", (Un) => {
      const Kn = Un.getParentComponent();
      return Kn != null && Kn.isUniter ? Kn.isEnableEditMode() : !0;
    });
    this.componentFilterFunctions = [], this.canvasAreaSorter = new CanvasAreaSorter(), this.activeAreaDetector = new CanvasAreaDetector(), this.addFilterComponentFunction(this.filterUniterComponents);
  }
}
var SpatialUIAreaType = /* @__PURE__ */ ((Xn) => (Xn.BUTTON = "BUTTON", Xn.PANEL = "PANEL", Xn.COLOR_INPUT = "COLOR_INPUT", Xn.PALETTE = "PALETTE", Xn.MODAL = "MODAL", Xn.EDIT_CORNER = "EDIT_CORNER", Xn.COLOREX_COLOR = "COLOREX_COLOR", Xn.BORDER_SELECT_ITEM = "BORDER_SELECT_ITEM", Xn.GRID_TABLE_CELL = "GRID_TABLE_CELL", Xn.INPUT = "INPUT", Xn.COMBO_BOX = "COMBO_BOX", Xn.COMBO_BOX_ITEM = "COMBO_BOX_ITEM", Xn.CONTEXT_MENU = "CONTEXT_MENU", Xn.TEMPLATE_MENU = "TEMPLATE_MENU", Xn.SOCKET_INDICATOR = "SOCKET_INDICATOR", Xn))(SpatialUIAreaType || {});
class UIAreaSorter extends SpatialAreaSorter {
  constructor() {
    super(...arguments);
    Ca(this, "sortSequence", [
      SpatialUIAreaType.MODAL,
      SpatialUIAreaType.COLOREX_COLOR,
      SpatialUIAreaType.PALETTE,
      SpatialUIAreaType.COMBO_BOX_ITEM,
      SpatialUIAreaType.BUTTON,
      SpatialUIAreaType.INPUT,
      SpatialUIAreaType.CONTEXT_MENU,
      SpatialUIAreaType.GRID_TABLE_CELL,
      SpatialUIAreaType.BORDER_SELECT_ITEM,
      SpatialUIAreaType.COLOR_INPUT,
      SpatialUIAreaType.COMBO_BOX,
      SpatialUIAreaType.EDIT_CORNER,
      SpatialUIAreaType.PANEL
    ]);
    Ca(this, "sort", (Un) => Un.filter(
      (qn) => Object.values(SpatialUIAreaType).includes(qn.type)
    ).sort((qn, Jo) => {
      const pa = this.sortSequence.indexOf(qn.type), ma = this.sortSequence.indexOf(Jo.type);
      return (pa === -1 ? Number.MAX_SAFE_INTEGER : pa) - (ma === -1 ? Number.MAX_SAFE_INTEGER : ma);
    }));
  }
}
class UIAreaController extends BaseAreaController {
  constructor() {
    super();
    Ca(this, "uiAreaSorter");
    Ca(this, "sync", async () => {
      const Un = this.dependencies.ui.getSpatialAreas();
      this.dependencies.tree.syncAreas(Un), this.updateActiveArea();
    });
    Ca(this, "updateActiveArea", () => {
      this.areaStack.length = 0, this.activeArea = null;
      const Un = this.dependencies.uiMouseObserver.getCurrentPosition(), Kn = this.dependencies.tree.getAreasAtPosition(Un);
      Kn.length < 1 || (this.areaStack.push(...this.uiAreaSorter.sort(Kn)), this.activeArea = this.areaStack[0]);
    });
    Ca(this, "updateAreaPosition", () => {
      const Un = this.dependencies.ui.getSpatialAreas();
      for (let Kn = 0; Kn < Un.length; Kn++)
        Un[Kn].markDirty();
      this.dependencies.tree.syncAreas(Un), this.updateActiveArea();
    });
    Ca(this, "getAreas", () => this.dependencies.tree.getAreas());
    this.uiAreaSorter = new UIAreaSorter();
  }
}
class AreaWheelObserver extends Dependent {
  constructor() {
    super();
    Ca(this, "subscribersGlobal", []);
    Ca(this, "subscribeGlobalWheel", (Un) => {
      const Kn = {
        action: Un
      };
      this.subscribersGlobal.push(Kn);
    });
    Ca(this, "onMouseWheel", async (Un) => {
      this.dependencies.areaController.updateActiveArea();
      const Kn = this.dependencies.areaController.getActiveArea();
      if (!Kn) {
        this.reportSubscribersGlobalWheel(Un);
        return;
      }
      if (Kn.type === SpatialUIAreaType.COMBO_BOX_ITEM) {
        Kn.getData().getParentComboBox().syncScroll(Un);
        return;
      }
      this.reportSubscribersGlobalWheel(Un);
    });
    Ca(this, "reportSubscribersGlobalWheel", (Un) => {
      this.subscribersGlobal.forEach((Kn) => {
        Kn.action(Un);
      });
    });
  }
}
class PageStructureObserver extends Dependent {
  constructor() {
    super();
    Ca(this, "subscribers");
    Ca(this, "snapshot");
    Ca(this, "subscribe", (Un) => {
      this.subscribers.push(Un);
    });
    Ca(this, "sync", async () => {
      if (this.dependencies.componentTree.getRootComponent().getFirstGraphic() === null)
        throw new EditorError("first graphic not found");
      const Jo = this.dependencies.componentTree.getGraphicSequences()[0];
      if (Jo === void 0)
        throw new EditorError("embedded graphics not found");
      const pa = Jo.map((ma) => ma.getStructure());
      if (this.snapshot === null) {
        this.snapshot = pa;
        return;
      }
      Utils.objectUtils.deepEqual(this.snapshot, pa) || this.callSubscribes(), this.snapshot = pa;
    });
    Ca(this, "callSubscribes", () => {
      for (let Un = 0; Un < this.subscribers.length; Un++)
        this.subscribers[Un]();
    });
    this.snapshot = null, this.subscribers = [];
  }
}
class PageTextOverflowObserver extends Dependent {
  constructor() {
    super();
    Ca(this, "overflowGraphics");
    Ca(this, "overflowListeners");
    Ca(this, "notOverflowListeners");
    Ca(this, "sync", async () => {
    });
    Ca(this, "getOverflowGraphics", () => this.overflowGraphics.length === 0 ? null : [...this.overflowGraphics]);
    Ca(this, "addOverflowListeners", (Un) => {
      this.overflowListeners.push(Un);
    });
    Ca(this, "addNotOverflowListeners", (Un) => {
      this.notOverflowListeners.push(Un);
    });
    Ca(this, "callOverflowListeners", () => {
      for (let Un = 0; Un < this.overflowListeners.length; Un++)
        this.overflowListeners[Un]();
    });
    Ca(this, "callNotOverflowListeners", () => {
      for (let Un = 0; Un < this.notOverflowListeners.length; Un++)
        this.notOverflowListeners[Un]();
    });
    this.overflowGraphics = [], this.overflowListeners = [], this.notOverflowListeners = [];
  }
}
class TouchObserver {
  constructor() {
    Ca(this, "subscribers", []);
    Ca(this, "lastTouchY");
    Ca(this, "subscribe", (zn) => {
      const Un = {
        action: zn
      };
      this.subscribers.push(Un);
    });
    Ca(this, "destruct", () => {
      document.body.removeEventListener("touchstart", this.onTouchStart), document.body.removeEventListener("touchmove", this.onTouchMove), document.body.removeEventListener("touchend", this.onTouchEnd);
    });
    /**
        * Обработчик начала касания.
        */
    Ca(this, "onTouchStart", (zn) => {
      zn.touches.length > 0 && (this.lastTouchY = zn.touches[0].clientY);
    });
    /**
        * Обработчик движения касания.
        */
    Ca(this, "onTouchMove", (zn) => {
      if (this.lastTouchY === null || zn.touches.length === 0)
        return;
      const Un = zn.touches[0].clientY, Kn = this.lastTouchY - Un;
      this.lastTouchY = Un, console.log(Kn), this.reportSubscribers(Kn);
    });
    /**
        * Обработчик окончания касания.
        */
    Ca(this, "onTouchEnd", () => {
      this.lastTouchY = null;
    });
    Ca(this, "reportSubscribers", (zn) => {
      this.subscribers.forEach((Un) => {
        Un.action(zn);
      });
    });
    this.lastTouchY = null, document.body.addEventListener("touchstart", this.onTouchStart), document.body.addEventListener("touchmove", this.onTouchMove), document.body.addEventListener("touchend", this.onTouchEnd);
  }
}
class WheelObserver {
  constructor() {
    Ca(this, "subscribers", []);
    Ca(this, "subscribe", (zn) => {
      const Un = {
        action: zn
      };
      this.subscribers.push(Un);
    });
    Ca(this, "construct", () => {
      document.body.addEventListener("wheel", this.onWheel);
    });
    Ca(this, "destruct", () => {
      document.body.removeEventListener("wheel", this.onWheel);
    });
    Ca(this, "onWheel", (zn) => {
      const Un = zn.deltaY;
      this.reportSubscribers(Un);
    });
    Ca(this, "reportSubscribers", (zn) => {
      this.subscribers.forEach((Un) => {
        Un.action(zn);
      });
    });
    this.construct();
  }
}
class MouseObserver {
  /**
   * Создаёт экземпляр `MouseObserver`.
   * @param editorContainer HTML-элемент для отслеживания событий мыши.
   * @param canvas Экземпляр `fabric.StaticCanvas` для преобразования координат.
   */
  constructor(zn, Un) {
    /** Подписчики обновлений позиции мыши. */
    Ca(this, "positionSubscribers", []);
    /** Подписчики обновлений смещения мыши. */
    Ca(this, "offsetSubscribers", []);
    /** Текущая позиция мыши. */
    Ca(this, "currentPosition", { x: 0, y: 0 });
    /** Последние зарегистрированные координаты мыши для расчёта смещения. */
    Ca(this, "lastX", null);
    Ca(this, "lastY", null);
    Ca(this, "lastOffsetX", null);
    Ca(this, "lastOffsetY", null);
    /** HTML-элемент и холст для отслеживания событий мыши. */
    Ca(this, "editorContainer");
    Ca(this, "canvas");
    Ca(this, "forceUpdatePosition", () => {
      const zn = this.transformPoint(this.lastOffsetX || 0, this.lastOffsetY || 0);
      this.updatePosition(zn), this.updateOffset(zn);
    });
    /**
     * Обработчик события движения мыши для обновления текущей позиции.
     * @param event Событие мыши.
     */
    Ca(this, "onMouseMove", (zn) => {
      this.lastOffsetX = zn.offsetX, this.lastOffsetY = zn.offsetY;
      const Un = this.transformPoint(zn.offsetX, zn.offsetY);
      this.updatePosition(Un), this.updateOffset(Un);
    });
    this.editorContainer = zn, this.canvas = Un, this.editorContainer.addEventListener("mousemove", this.onMouseMove);
  }
  /**
   * Подписывает на обновления позиции мыши.
   * @param subscriber Функция для вызова при изменении позиции мыши.
   */
  subscribeToPosition(zn) {
    this.positionSubscribers.push(zn);
  }
  /**
   * Подписывает на обновления смещения мыши.
   * @param subscriber Функция для вызова при изменении смещения мыши.
   */
  subscribeToOffset(zn) {
    this.offsetSubscribers.push(zn);
  }
  /**
   * Возвращает текущую позицию мыши в координатах холста.
   * @returns {IDescartesPosition} Текущая позиция мыши.
   */
  getCurrentPosition() {
    return { ...this.currentPosition };
  }
  /** Уничтожает экземпляр `MouseObserver`, удаляя обработчики событий. */
  destructor() {
    this.editorContainer.removeEventListener("mousemove", this.onMouseMove);
  }
  /**
   * Преобразует координаты события в координаты холста с учётом трансформации.
   * @param x Координата X в системе координат окна.
   * @param y Координата Y в системе координат окна.
   * @returns Координаты на холсте.
   */
  transformPoint(zn, Un) {
    const Kn = this.canvas.viewportTransform;
    if (Kn) {
      const qn = un.invertTransform(Kn), Jo = zn * qn[0] + Un * qn[2] + qn[4], pa = zn * qn[1] + Un * qn[3] + qn[5];
      return { x: Jo, y: pa };
    }
    return { x: zn, y: Un };
  }
  /**
   * Обновляет текущую позицию мыши и уведомляет подписчиков.
   * @param pointer Новая позиция мыши.
   */
  updatePosition(zn) {
    this.currentPosition = zn, this.positionSubscribers.forEach((Un) => {
      Un(zn);
    });
  }
  /**
   * Вычисляет смещение мыши и уведомляет подписчиков.
   * @param pointer Текущая позиция мыши.
   */
  updateOffset(zn) {
    if (this.lastX === null || this.lastY === null) {
      this.lastX = zn.x, this.lastY = zn.y;
      return;
    }
    const Un = zn.x - this.lastX, Kn = zn.y - this.lastY;
    this.offsetSubscribers.forEach((qn) => {
      qn(Un, Kn);
    }), this.lastX = zn.x, this.lastY = zn.y;
  }
}
class SpatialGridVisualizer extends Dependent {
  constructor() {
    super();
    Ca(this, "parameters");
    Ca(this, "postUpdateVisibilityListeners");
    Ca(this, "GUI_FOLDER_NAME", "Spatial Grid");
    Ca(this, "folder");
    /**
     * Adds a GUI block for debugging.
     * @param gui The GUI instance passed from the main app.
     */
    Ca(this, "addGUIBlock", (Un) => {
      this.folder = Un.addFolder(this.GUI_FOLDER_NAME), this.folder.add(this.parameters, "showAreas").name("Show spatial areas").onChange(this.sync), this.folder.add(this.parameters, "showCells").name("Show grid cells").onChange(this.sync), this.folder.add(this.parameters, "areaCount").name("Number of areas").listen().disable(), this.folder.add(this.parameters, "cellCount").name("Number of cells").listen().disable(), this.updateCounts();
    });
    /**
     * Returns objects to be rendered based on the current parameters.
     */
    Ca(this, "getObjects", () => {
      const Un = [];
      return this.parameters.showAreas && this.getAllAreas().forEach((qn) => {
        Un.push(this.getAreaPath(qn)), qn.type === SpatialCanvasAreaType.GRAPHIC && Un.push(this.getAreaLabel(qn));
      }), this.parameters.showCells && this.getAllCells().forEach((qn) => Un.push(this.getCellPath(qn))), Un;
    });
    /**
     * Updates the visualizer when GUI parameters change.
     */
    Ca(this, "sync", () => {
      (this.parameters.showAreas || this.parameters.showCells) && (this.updateCounts(), this.callPostUpdateVisibilityListeners());
    });
    Ca(this, "addPostUpdateVisibilityListener", (Un) => {
      this.postUpdateVisibilityListeners.push(Un);
    });
    Ca(this, "callPostUpdateVisibilityListeners", () => {
      this.postUpdateVisibilityListeners.forEach((Un) => Un());
    });
    /**
     * Returns all areas in the spatial grid.
     */
    Ca(this, "getAllAreas", () => this.dependencies.spatialGrid.getAreas());
    /**
     * Returns a Path object to visualize a given area.
     * @param area The area to visualize.
     */
    Ca(this, "getAreaPath", (Un) => {
      const Kn = Un.getGlobalFrameArea(), Jo = [
        new ot(Kn.x, Kn.y),
        new ot(Kn.x + Kn.width, Kn.y),
        new ot(Kn.x + Kn.width, Kn.y + Kn.height),
        new ot(Kn.x, Kn.y + Kn.height),
        new ot(Kn.x, Kn.y)
      ].map((pa) => `${pa.x} ${pa.y}`).join(" L ");
      return new Vn(`M ${Jo} Z`, {
        fill: "rgba(255, 0, 0, 0.1)",
        stroke: this.parameters.areaColor,
        strokeWidth: 2
      });
    });
    Ca(this, "getAreaLabel", (Un) => {
      const Kn = Un.getGlobalFrameArea(), qn = `(${Kn.x}, ${Kn.y})`, Jo = new Xo(qn, {
        left: Kn.x + 20,
        top: Kn.y + 20,
        fontSize: 12,
        fill: this.parameters.labelColor
      }), pa = new pr({
        left: Kn.x + 15,
        top: Kn.y + 15,
        width: Jo.width + 10,
        height: Jo.height + 10,
        fill: this.parameters.labelFill,
        stroke: this.parameters.labelColor,
        strokeWidth: 1
      });
      return new Mr([pa, Jo]);
    });
    /**
     * Returns all the grid cells.
     */
    Ca(this, "getAllCells", () => this.dependencies.spatialGrid.getCells());
    /**
     * Returns a Path object to visualize a grid cell.
     * @param cell The cell to visualize.
     */
    Ca(this, "getCellPath", (Un) => {
      const [Kn, qn] = Un.split(",").map(Number), Jo = this.dependencies.spatialGrid.getCellSize(), pa = Kn * Jo, ma = qn * Jo, va = Jo, ba = Jo, ya = [
        new ot(pa, ma),
        new ot(pa + va, ma),
        new ot(pa + va, ma + ba),
        new ot(pa, ma + ba),
        new ot(pa, ma)
      ].map((xa) => `${xa.x} ${xa.y}`).join(" L ");
      return new Vn(`M ${ya} Z`, {
        fill: "rgba(0, 0, 255, 0.1)",
        stroke: this.parameters.cellColor,
        strokeWidth: 2
      });
    });
    /**
     * Updates the counts of areas and cells.
     */
    Ca(this, "updateCounts", () => {
      this.parameters.areaCount = this.getAllAreas().length, this.parameters.cellCount = this.getAllCells().length;
    });
    this.parameters = {
      areaColor: "#ff0000",
      cellColor: "#0000ff",
      labelColor: "black",
      labelFill: "rgba(255, 255, 255, 0.8)",
      showAreas: !1,
      showCells: !1,
      cellCount: 0,
      areaCount: 0
    }, this.postUpdateVisibilityListeners = [], this.folder = null;
  }
}
class BaseEditor {
  constructor(zn) {
    Ca(this, "CANVAS_FILL_DEFAULT", "#EAEDF1");
    Ca(this, "destructListeners");
    Ca(this, "resizeWindowListeners");
    Ca(this, "postChangeNameListeners");
    Ca(this, "prevChangeNameListeners");
    Ca(this, "postSetStructureListeners");
    Ca(this, "enableInteractiveListeners");
    Ca(this, "disableInteractiveListeners");
    Ca(this, "id");
    Ca(this, "name");
    Ca(this, "gui");
    Ca(this, "wheelObserver");
    Ca(this, "areaWheelObserver");
    Ca(this, "touchObserver");
    Ca(this, "debugEntities");
    // Холст для отрисовки содержимого конструктора
    Ca(this, "camera");
    Ca(this, "canvas");
    Ca(this, "canvasRender");
    Ca(this, "pageTextOverflowObserver");
    Ca(this, "areaController");
    Ca(this, "canvasMouseObserver");
    Ca(this, "canvasAreaController");
    Ca(this, "uiAreaController");
    Ca(this, "pageStructureObserver");
    Ca(this, "layerVisualizer");
    Ca(this, "canvasSpatialGridVisualizer");
    Ca(this, "uiSpatialGridVisualizer");
    Ca(this, "enableGUI", () => {
      this.gui = new GUI();
      for (let zn = 0; zn < this.debugEntities.length; zn++)
        this.debugEntities[zn].addGUIBlock(this.gui);
      this.gui.close();
    });
    Ca(this, "setName", (zn) => {
      this.prevChangeNameListeners.forEach((Un) => Un()), this.name = zn, this.postChangeNameListeners.forEach((Un) => Un());
    });
    Ca(this, "getID", () => this.id);
    Ca(this, "getName", () => this.name);
    Ca(this, "getStructure", () => ({
      id: this.getID(),
      name: this.getName(),
      root: this.componentTree.getStructure()
    }));
    Ca(this, "addPostChangeNameListener", (zn) => {
      this.postChangeNameListeners.push(zn);
    });
    Ca(this, "addPrevChangeNameListener", (zn) => {
      this.prevChangeNameListeners.push(zn);
    });
    Ca(this, "addDestructListener", (zn) => {
      this.destructListeners.push(zn);
    });
    Ca(this, "addPostResizeWindowListener", (zn) => {
      this.resizeWindowListeners.push(zn);
    });
    Ca(this, "addPostSetStructureListener", (zn) => {
      this.postSetStructureListeners.push(zn);
    });
    Ca(this, "addEnableInteractiveListener", (zn) => {
      this.enableInteractiveListeners.push(zn);
    });
    Ca(this, "addDisableInteractiveListener", (zn) => {
      this.disableInteractiveListeners.push(zn);
    });
    Ca(this, "destruct", () => {
      this.destructListeners.forEach((zn) => zn());
    });
    Ca(this, "enableInteractive", () => {
      this.callEnableInteractiveListeners();
    });
    Ca(this, "disableInteractive", () => {
      this.callDisableInteractiveListeners();
    });
    Ca(this, "setID", (zn) => {
      this.id = zn;
    });
    Ca(this, "adaptCanvas", () => {
      this.canvas.setDimensions({
        width: this.editorContainer.offsetWidth,
        height: this.editorContainer.offsetHeight
      }), this.canvas.requestRenderAll();
    });
    Ca(this, "getStaticCanvas", (zn, Un, Kn) => {
      const qn = document.createElement("canvas");
      return qn.style.position = "absolute", qn.style.left = "0", qn.style.top = "0", qn.style.pointerEvents = "none", new se(qn, {
        backgroundColor: Kn,
        width: zn,
        // Ширина Canvas
        height: Un,
        // Высота Canvas
        skipOffscreen: !1,
        // Пропускает рендеринг объектов, которые находятся за
        enableRetinaScaling: !0,
        // Включает масштабирование Canvas для экранов Retina,
        // чтобы объекты выглядели четче.
        renderOnAddRemove: !1
        // Отключает автоматический рендеринг при добавлении или удалении объектов.
      });
    });
    Ca(this, "callPostSetStructureListeners", () => {
      this.postSetStructureListeners.forEach((zn) => zn());
    });
    Ca(this, "callResizeWindowListeners", () => {
      this.resizeWindowListeners.forEach((zn) => zn());
    });
    Ca(this, "callEnableInteractiveListeners", () => {
      this.enableInteractiveListeners.forEach((zn) => zn());
    });
    Ca(this, "callDisableInteractiveListeners", () => {
      this.disableInteractiveListeners.forEach((zn) => zn());
    });
    Ca(this, "runResizeObserver", () => {
      new ResizeObserver(this.callResizeWindowListeners).observe(this.editorContainer);
    });
    this.editorContainer = zn, this.id = "not initialized", this.name = "not initialized", zn.style.position = "relative", this.gui = null, this.destructListeners = [], this.resizeWindowListeners = [], this.postChangeNameListeners = [], this.prevChangeNameListeners = [], this.postSetStructureListeners = [], this.enableInteractiveListeners = [], this.disableInteractiveListeners = [], this.canvas = this.getStaticCanvas(
      zn.offsetWidth,
      zn.offsetHeight,
      this.CANVAS_FILL_DEFAULT
    ), this.canvasAreaController = new CanvasAreaController(), this.uiAreaController = new UIAreaController(), this.layerVisualizer = new LayerVisualizer(), this.canvasSpatialGridVisualizer = new SpatialGridVisualizer(), this.uiSpatialGridVisualizer = new SpatialGridVisualizer(), this.debugEntities = [this.layerVisualizer, this.canvasSpatialGridVisualizer, this.uiSpatialGridVisualizer], this.wheelObserver = new WheelObserver(), this.areaWheelObserver = new AreaWheelObserver(), this.touchObserver = new TouchObserver(), this.canvasRender = new CanvasRender(), this.camera = new Camera(this.canvas), this.areaController = new AreaController(), this.pageStructureObserver = new PageStructureObserver(), this.pageTextOverflowObserver = new PageTextOverflowObserver(), this.canvasMouseObserver = new MouseObserver(zn, this.canvas), zn.append(this.canvas.getElement()), this.addEnableInteractiveListener(this.wheelObserver.construct), this.addDisableInteractiveListener(this.wheelObserver.destruct), this.areaController.appendController(this.canvasAreaController), this.areaController.appendController(this.uiAreaController), EditorError.setContext(this), this.addPostSetStructureListener(this.runResizeObserver), this.addDestructListener(EditorError.resetContext);
  }
}
class StaticEditor extends BaseEditor {
  constructor(Un) {
    super(Un);
    Ca(this, "objectOrganizer");
    Ca(this, "graphicFactory");
    Ca(this, "componentFactory");
    this.graphicFactory = new StaticGraphicFactory(), this.componentFactory = new StaticComponentFactory(), this.objectOrganizer = new StaticCanvasObjectOrganizer();
  }
}
class VisualizerEditor extends StaticEditor {
  constructor(Un) {
    super(Un.editorContainer);
    Ca(this, "useCases");
    Ca(this, "layerRegistry");
    Ca(this, "componentTree");
    Ca(this, "bookOrganizer");
    /**
     * Устанавливает структуру шаблона редактора.
     *
     * Этот метод загружает структуру редактора, обновляет его идентификатор и имя,
     * а также инициализирует корневой компонент.
     *
     * @param {IEditorStructure} structure - Новая структура редактора, содержащая ID, имя и корневой компонент.
     * @returns {Promise<void>} Промис, который выполняется после завершения установки структуры.
     */
    Ca(this, "setStructure", async (Un) => {
      this.setID(Un.id), this.setName(Un.name), await this.componentTree.load(Un.root);
      const Kn = this.componentTree.getRootComponent();
      this.bookOrganizer.forceInjectDependencies({
        book: Kn,
        canvas: this.canvas,
        render: this.canvasRender
      }), this.bookOrganizer.sync(), this.camera.addPostUpdateViewListeners(this.canvasRender.renderUnstructured), this.canvasRender.render(), this.callPostSetStructureListeners();
    });
    Ca(this, "adaptCanvasHeight", () => {
      const Un = this.getRequireCanvasHeight();
      this.editorContainer.style.height = `${Un}px`, this.adaptCanvas(), this.camera.updateDimension();
    });
    Ca(this, "getRequireCanvasHeight", () => {
      const Kn = this.componentTree.getRootComponent().getLastGraphic();
      if (Kn === null)
        throw new EditorError("last graphic not found");
      const { endMarginY: qn } = this.camera.getConfiguration(), Jo = Kn.getGraphicObject();
      return Jo.object.top + Jo.object.height + qn;
    });
    this.useCases = null, this.bookOrganizer = new BookModeOrganizer(), this.componentTree = new DynamicComponentTree(), this.layerRegistry = new BookLayerRegistry(), this.componentTree.connectDependencies({
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory,
      layerRegistry: this.layerRegistry,
      render: this.canvasRender
    }), this.objectOrganizer.connectDependencies({
      layerRegistry: this.layerRegistry
    }), this.layerRegistry.connectDependencies({
      componentTree: this.componentTree
    }), this.graphicFactory.connectDependencies({
      componentTree: this.componentTree,
      imageFileSourcePrefix: Un.imageFileSourcePrefix
    }), this.canvasRender.connectDependencies({
      canvas: this.canvas,
      layerRegistry: this.layerRegistry,
      canvasObjectOrganizer: this.objectOrganizer
    }), this.camera.connectDependencies({
      componentTree: this.componentTree
    }), this.componentFactory.connectDependencies(null), Un.isEnableMouseWheel && this.wheelObserver.subscribe(this.camera.move), Un.isCanvasHeightAdaptive && this.addPostSetStructureListener(this.adaptCanvasHeight), this.layerRegistry.injectDependencies(), this.componentTree.injectDependencies(), this.graphicFactory.injectDependencies(), this.objectOrganizer.injectDependencies(), this.canvasRender.injectDependencies(), this.camera.injectDependencies(), this.componentFactory.injectDependencies();
  }
}
class AdaptVisualizerEditor extends VisualizerEditor {
  constructor(Un) {
    super(Un);
    Ca(this, "cameraPadding");
    /**
     * Адаптирует конфигурацию камеры под содержимое контейнера по ширине с отступами
     */
    Ca(this, "adaptCameraFromContent", () => {
      const { offsetWidth: Un, offsetHeight: Kn } = this.editorContainer, Jo = this.componentTree.getRootComponent().getFirstGraphic();
      if (Jo === null)
        throw new EditorError("first root graphic is null");
      const { width: pa } = Jo.getFrameConfiguration(), { leftRight: ma, topBottom: va } = this.cameraPadding, ba = this.getAdaptZoom(Un, pa);
      this.camera.setConfiguration((_a) => ({
        ..._a,
        zoom: ba,
        width: Un,
        height: Kn,
        x: -Jo.getGlobalPosition().x + ma,
        y: -va,
        startY: -va,
        endMarginY: va
      })), this.camera.updateView();
    });
    /**
     * Рассчитывает коэффициент зума, необходимый для полного отображения содержимого по ширине.
     * @param containerWidth Ширина контейнера редактора.
     * @param pageWidth Ширина страницы.
     */
    Ca(this, "getAdaptZoom", (Un, Kn) => Un / (Kn + this.cameraPadding.leftRight * 2));
    this.cameraPadding = Un.cameraPadding, this.addPostSetStructureListener(this.adaptCameraFromContent);
  }
}
class ComponentInjector extends Dependent {
  constructor() {
    super();
    Ca(this, "injectors");
    Ca(this, "disableInjectorListeners");
    Ca(this, "prevInjectListeners");
    Ca(this, "postInjectListeners");
    Ca(this, "textInjector");
    Ca(this, "pictureInjector");
    Ca(this, "tableInjector");
    Ca(this, "figureInjector");
    Ca(this, "lineInjector");
    Ca(this, "moduleInjector");
    Ca(this, "runningInjector");
    /**
     * Проверяет, активен ли в данный момент хотя бы один инжектор.
     *
     * @returns {boolean} `true`, если хотя бы один инжектор активен, иначе `false`.
     */
    Ca(this, "isInjecting", () => this.injectors.some((Un) => Un.isInjecting()));
    /**
     * Запускает режим вставки текста.
     */
    Ca(this, "runInjectText", () => {
      if (this.textInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.textInjector.run(), this.runningInjector = this.textInjector;
    });
    /**
     * Запускает режим вставки текста с заданными параметрами.
     * @param token - токен текста.
     */
    Ca(this, "runInjectTextWithContent", (Un) => {
      if (this.textInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.textInjector.loadToken(Un), this.textInjector.run(), this.runningInjector = this.textInjector;
    });
    /**
     * Запускает режим вставки изображения.
     */
    Ca(this, "runInjectPicture", () => {
      if (this.pictureInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.pictureInjector.run(), this.runningInjector = this.pictureInjector;
    });
    /**
     * Вставляет таблицу с заданными параметрами.
     *
     * @param rowCount - количество строк.
     * @param columnCount - количество столбцов.
     * @param cells - массив текстур ячеек.
     */
    Ca(this, "injectTable", (Un, Kn, qn) => {
      if (this.tableInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.tableInjector.loadSize(Un, Kn), this.tableInjector.run(), this.tableInjector.loadCellTextures(qn), this.runningInjector = this.tableInjector;
    });
    /**
     * Вставляет пустую таблицу с заданными размерами.
     *
     * @param row - количество строк.
     * @param columns - количество столбцов.
     */
    Ca(this, "injectEmptyTable", (Un, Kn) => {
      if (this.tableInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.tableInjector.loadSize(Un, Kn), this.tableInjector.run(), this.runningInjector = this.tableInjector;
    });
    /**
     * Запускает режим вставки фигуры.
     */
    Ca(this, "runInjectFigure", () => {
      if (this.figureInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.figureInjector.run(), this.runningInjector = this.figureInjector;
    });
    /**
     * Запускает режим вставки фигуры.
     */
    Ca(this, "runInjectLine", () => {
      if (this.lineInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.lineInjector.run(), this.runningInjector = this.lineInjector;
    });
    /**
     * Запускает режим вставки модуля.
     * @param structure Структура модуля.
     * @param preview Превью модуля.
     */
    Ca(this, "injectModule", (Un) => {
      if (this.moduleInjector === null)
        throw new EditorError("injector not initialized");
      this.stopInjectors(), this.moduleInjector.loadStructure(Un), this.moduleInjector.run(), this.runningInjector = this.moduleInjector;
    });
    /**
     * Останавливает процесс вставки.
     */
    Ca(this, "stopInjecting", () => {
      if (this.runningInjector === null)
        throw new EditorError("a running injector cannot be null");
      this.runningInjector.stop(), this.runningInjector.clearSingleUseInjectListeners(), this.runningInjector = null;
    });
    /**
     * Выполняет вставку созданного компонента.
     */
    Ca(this, "inject", async () => {
      if (this.runningInjector === null)
        throw new EditorError("a running injector cannot be null");
      this.callPrevInjectListeners(), await this.runningInjector.inject(), this.callPostInjectListeners();
    });
    /**
     * Проверяет, готов ли текущий инжектор к вставке компонента.
     *
     * @returns {boolean} `true`, если инжектор готов, иначе `false`.
     */
    Ca(this, "isReadyInject", () => {
      if (this.runningInjector === null)
        throw new EditorError("a running injector cannot be null");
      return this.runningInjector.isReadyInject();
    });
    /**
     * Обработчик события нажатия кнопки мыши.
     */
    Ca(this, "onMouseDown", () => {
      this.runningInjector && this.runningInjector.onMouseDown();
    });
    /**
     * Обработчик события отпускания кнопки мыши.
     */
    Ca(this, "onMouseUp", async () => {
      if (!this.runningInjector)
        return;
      await this.runningInjector.onMouseUp() && this.callPostInjectListeners();
    });
    Ca(this, "addSingleUseInjectListener", (Un) => {
      if (this.runningInjector === null)
        throw new EditorError("running injector not found");
      this.runningInjector.addSingleUseInjectListener(Un);
    });
    /**
     * Добавляет обработчик события отключения всех инжекторов.
     * @param listener - Обработчик события.
     */
    Ca(this, "addDisableInjectorsListener", (Un) => {
      this.disableInjectorListeners.push(Un);
    });
    /**
     * Останавливает все инжекторы.
     */
    Ca(this, "stopInjectors", () => {
      this.injectors.forEach((Un) => Un.stop()), this.callDisableInjectorsListeners();
    });
    Ca(this, "addPrevInjectListener", (Un) => {
      this.prevInjectListeners.push(Un);
    });
    Ca(this, "addPostInjectListener", (Un) => {
      this.postInjectListeners.push(Un);
    });
    Ca(this, "addPostUpdateAreaListener", (Un) => {
      if (this.figureInjector === null || this.textInjector === null)
        throw new EditorError("injector not initialized");
      this.figureInjector.addPostUpdateAreaListener(Un), this.textInjector.addPostUpdateAreaListener(Un);
    });
    Ca(this, "getObjects", () => {
      if (this.figureInjector === null || this.textInjector === null || this.pictureInjector === null || this.lineInjector === null)
        throw new EditorError("injector not initialized");
      return [
        ...this.textInjector.getObjects(),
        ...this.lineInjector.getObjects(),
        ...this.figureInjector.getObjects(),
        ...this.pictureInjector.getObjects()
      ];
    });
    Ca(this, "callDisableInjectorsListeners", () => {
      this.disableInjectorListeners.forEach((Un) => Un());
    });
    Ca(this, "callPrevInjectListeners", () => {
      this.prevInjectListeners.forEach((Un) => Un());
    });
    Ca(this, "callPostInjectListeners", () => {
      this.postInjectListeners.forEach((Un) => Un());
    });
    this.injectors = [], this.runningInjector = null, this.prevInjectListeners = [], this.postInjectListeners = [], this.disableInjectorListeners = [], this.textInjector = null, this.pictureInjector = null, this.tableInjector = null, this.figureInjector = null, this.lineInjector = null, this.moduleInjector = null, this.addPostInjectDependenciesListener((Un) => {
      this.textInjector = Un.injectorFactory.getTextInjector(), this.pictureInjector = Un.injectorFactory.getPictureInjector(), this.tableInjector = Un.injectorFactory.getTableInjector(), this.figureInjector = Un.injectorFactory.getFigureInjector(), this.lineInjector = Un.injectorFactory.getLineInjector(), this.moduleInjector = Un.injectorFactory.getModuleInjector(), this.injectors.push(
        this.textInjector,
        this.pictureInjector,
        this.tableInjector,
        this.figureInjector,
        this.lineInjector,
        this.moduleInjector
      );
    });
  }
}
var CSSCursor = /* @__PURE__ */ ((Xn) => (Xn.AUTO = "auto", Xn.DEFAULT = "default", Xn.TOP = "n-resize", Xn.RIGHT = "e-resize", Xn.BOTTOM = "s-resize", Xn.LEFT = "w-resize", Xn.LEFT_TOP = "nw-resize", Xn.RIGHT_TOP = "ne-resize", Xn.RIGHT_BOTTOM = "se-resize", Xn.LEFT_BOTTOM = "sw-resize", Xn.TEXT = "text", Xn.CROSSHAIR = "crosshair", Xn.COLUMN_RESIZE = "col-resize", Xn.ROW_RESIZE = "row-resize", Xn.GRAB = "grab", Xn.GRABBING = "grabbing", Xn.POINTER = "pointer", Xn))(CSSCursor || {});
class CursorView {
  constructor(zn) {
    /** Флаги для фиксации вида курсора. */
    Ca(this, "isComponentMutateMode");
    Ca(this, "isComponentInjectMode");
    Ca(this, "isColumnMutatorMode");
    Ca(this, "isPictureMutatorMode");
    Ca(this, "enableComponentMutateMode", (zn) => {
      this.isComponentMutateMode = !0, this.setCursor(zn);
    });
    Ca(this, "disableComponentMutateMode", () => {
      this.isComponentInjectMode || this.isColumnMutatorMode || this.isPictureMutatorMode || this.setCursor(CSSCursor.AUTO);
    });
    Ca(this, "enableComponentInjectMode", () => {
      this.isComponentInjectMode = !0;
    });
    Ca(this, "disableComponentInjectMode", () => {
      this.isComponentInjectMode = !1, this.setCursor(CSSCursor.AUTO);
    });
    Ca(this, "enableColumnMutatorMode", () => {
      this.setCursor(CSSCursor.COLUMN_RESIZE), this.isColumnMutatorMode = !0;
    });
    Ca(this, "disableColumnMutatorMode", () => {
      this.setCursor(CSSCursor.AUTO), this.isColumnMutatorMode = !1;
    });
    Ca(this, "enablePictureMutateMode", () => {
      this.isPictureMutatorMode = !0;
    });
    Ca(this, "disablePictureMutatorMode", () => {
      this.setCursor(CSSCursor.AUTO), this.isPictureMutatorMode = !1;
    });
    Ca(this, "setCursor", (zn) => {
      this.editorContainer.style.cursor = zn;
    });
    Ca(this, "setActiveArea", (zn) => {
      if (this.isEnableAnyMode())
        return;
      if (zn === null) {
        this.setCursor(CSSCursor.AUTO);
        return;
      }
      if (zn.type === SpatialCanvasAreaType.BUTTON) {
        this.setCursor(CSSCursor.POINTER);
        return;
      }
      if (zn.type === SpatialCanvasAreaType.TABLE_COLUMN_RESIZE) {
        this.setCursor(CSSCursor.COLUMN_RESIZE);
        return;
      }
      if (zn.type === SpatialCanvasAreaType.TABLE_ROW_RESIZE) {
        this.setCursor(CSSCursor.ROW_RESIZE);
        return;
      }
      if (zn.isTextPlace()) {
        this.setCursor(CSSCursor.TEXT);
        return;
      }
      if (Object.values(SpatialUIAreaType).includes(zn.type)) {
        zn.type === SpatialUIAreaType.PANEL ? this.setCursor(CSSCursor.AUTO) : zn.type === SpatialUIAreaType.BUTTON || zn.type === SpatialUIAreaType.COLOR_INPUT || zn.type === SpatialUIAreaType.COMBO_BOX || zn.type === SpatialUIAreaType.COMBO_BOX_ITEM ? this.setCursor(CSSCursor.POINTER) : zn.type === SpatialUIAreaType.INPUT ? this.setCursor(CSSCursor.TEXT) : this.setCursor(CSSCursor.AUTO);
        return;
      }
      if (!zn.isResizeType()) {
        this.setCursor(CSSCursor.AUTO);
        return;
      }
      const Un = zn;
      switch (Un.getTrigger()) {
        case AreaResizeTrigger.LEFT: {
          this.setCursor(CSSCursor.LEFT);
          break;
        }
        case AreaResizeTrigger.TOP: {
          this.setCursor(CSSCursor.TOP);
          break;
        }
        case AreaResizeTrigger.RIGHT: {
          this.setCursor(CSSCursor.RIGHT);
          break;
        }
        case AreaResizeTrigger.BOTTOM: {
          this.setCursor(CSSCursor.BOTTOM);
          break;
        }
        case AreaResizeTrigger.LEFT_TOP: {
          this.setCursor(CSSCursor.LEFT_TOP);
          break;
        }
        case AreaResizeTrigger.RIGHT_TOP: {
          this.setCursor(CSSCursor.RIGHT_TOP);
          break;
        }
        case AreaResizeTrigger.RIGHT_BOTTOM: {
          this.setCursor(CSSCursor.RIGHT_BOTTOM);
          break;
        }
        case AreaResizeTrigger.LEFT_BOTTOM: {
          this.setCursor(CSSCursor.LEFT_BOTTOM);
          break;
        }
        default:
          throw new EditorError(`resize trigger "${Un.getTrigger()} not found"`);
      }
    });
    Ca(this, "isEnableAnyMode", () => this.isColumnMutatorMode || this.isComponentMutateMode || this.isComponentInjectMode || this.isPictureMutatorMode);
    this.editorContainer = zn, this.isComponentMutateMode = !1, this.isComponentInjectMode = !1, this.isColumnMutatorMode = !1, this.isPictureMutatorMode = !1;
  }
}
var DirectionVector = /* @__PURE__ */ ((Xn) => (Xn.LEFT = "LEFT", Xn.RIGHT = "RIGHT", Xn.TOP = "TOP", Xn.BOTTOM = "BOTTOM", Xn.MIDDLE_X = "MIDDLE_X", Xn.MIDDLE_Y = "MIDDLE_Y", Xn))(DirectionVector || {});
class MagneticCorrector extends Dependent {
  constructor() {
    super();
    Ca(this, "linesState");
    Ca(this, "initiatorGraphic");
    Ca(this, "startConfiguration");
    /**
     * Обрабатывает движение объектов графики и их притяжение к магнитным линиям во время изменения положения.
     */
    Ca(this, "move", async () => {
      const Un = this.dependencies.magneticLines.getMagneticLines();
      if (this.startConfiguration = this.dependencies.magneticLines.getStartConfiguration(), this.initiatorGraphic = this.dependencies.magneticLines.getInitiatorGraphic(), Un.length === 0)
        return;
      if (this.startConfiguration === null)
        throw new EditorError("required entities not found");
      const Kn = this.dependencies.mutator.getDryConfiguration(this.startConfiguration), qn = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        rotate: 0
      };
      this.linesState.disabledLines.length = 0, this.calculateCorrectValues(Un, Kn, qn), this.linesState.enabledLineX !== null && this.linesState.enabledLineX.show(), this.linesState.enabledLineY !== null && this.linesState.enabledLineY.show();
      for (let Jo = 0; Jo < this.linesState.disabledLines.length; Jo++)
        this.linesState.disabledLines[Jo].hide();
    });
    this.linesState = {
      enabledLineX: null,
      enabledLineY: null,
      disabledLines: []
    }, this.initiatorGraphic = null, this.startConfiguration = null;
  }
}
class MagneticPositionCorrector extends MagneticCorrector {
  constructor() {
    super();
    Ca(this, "calculateCorrectValues", (Un, Kn, qn) => {
      for (let Jo = 0; Jo < Un.length; Jo++) {
        const pa = Un[Jo], ma = pa.isMagnetizationZone(Kn);
        if (ma !== null) {
          switch (ma) {
            case DirectionVector.LEFT:
              qn.x = -(Kn.x - pa.linePosition.x), this.linesState.enabledLineX = pa.line;
              break;
            case DirectionVector.RIGHT:
              qn.x = -(Kn.x + Kn.width - pa.linePosition.x), this.linesState.enabledLineX = pa.line;
              break;
            case DirectionVector.TOP:
              qn.y = -(Kn.y - pa.linePosition.y), this.linesState.enabledLineY = pa.line;
              break;
            case DirectionVector.BOTTOM:
              qn.y = -(Kn.y + Kn.height - pa.linePosition.y), this.linesState.enabledLineY = pa.line;
              break;
            case DirectionVector.MIDDLE_X:
              qn.x = -(Kn.x + Kn.width / 2 - pa.linePosition.x), this.linesState.enabledLineX = pa.line;
              break;
            case DirectionVector.MIDDLE_Y:
              qn.y = -(Kn.y + Kn.height / 2 - pa.linePosition.y), this.linesState.enabledLineY = pa.line;
              break;
            default:
              throw new EditorError("direction not found");
          }
          this.dependencies.magneticLines.setIsMagnet(!0);
        } else
          this.linesState.disabledLines.push(pa.line);
      }
      this.dependencies.mutator.setCorrectValues(qn), this.dependencies.magneticLines.getIsMagnet() || this.dependencies.mutator.clearCorrectValues();
    });
  }
}
class MagneticSizeCorrector extends MagneticCorrector {
  constructor() {
    super();
    Ca(this, "calculateCorrectValues", (Un, Kn, qn) => {
      if (this.initiatorGraphic === null || this.startConfiguration === null)
        throw new EditorError("required entities not found");
      for (let Jo = 0; Jo < Un.length; Jo++) {
        const pa = Un[Jo], ma = this.initiatorGraphic.getFrameArea();
        if (ma === void 0)
          return;
        const va = pa.isVisualizeZone(ma), ba = pa.isMagnetizationZone(Kn);
        switch (pa.linePosition.x === Kn.width / 2 + Kn.x && pa.line.hide(), this.dependencies.mutator.getActiveTrigger()) {
          case AreaResizeTrigger.LEFT:
            this.leftTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeLeft(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          case AreaResizeTrigger.RIGHT:
            this.rightTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeRight(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          case AreaResizeTrigger.TOP:
            this.topTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeTop(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          case AreaResizeTrigger.BOTTOM:
            this.bottomTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeBottom(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          case AreaResizeTrigger.LEFT_TOP:
            this.leftTopTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeLeftTop(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          case AreaResizeTrigger.RIGHT_TOP:
            this.rightTopTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeRightTop(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          case AreaResizeTrigger.LEFT_BOTTOM:
            this.leftBottomTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeLeftBottom(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          case AreaResizeTrigger.RIGHT_BOTTOM:
            this.rightBottomTriggerReadyToVisualize(va, Kn, pa) ? (pa.line.show(), this.magnetizeRightBottom(ba, qn, Kn, pa)) : this.linesState.disabledLines.push(pa.line);
            break;
          default:
            throw new EditorError("direction not found");
        }
        this.dependencies.magneticLines.setIsMagnet(!0);
      }
      this.dependencies.mutator.setCorrectValues(qn), this.dependencies.magneticLines.getIsMagnet() || this.dependencies.mutator.clearCorrectValues();
    });
    /**
     * Вычисляет корректирующие значения для области намагничивания с левой стороны.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeLeft", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.LEFT && (Kn.x = -(qn.x - Jo.linePosition.x), Kn.width = qn.x - Jo.linePosition.x);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии с левой стороны графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param frameConfiguration Конфигурация графики.
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "leftTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.x <= Kn.x && qn.line.getDirection() !== DirectionVector.MIDDLE_X && qn.line.getDirection() !== DirectionVector.TOP && qn.line.getDirection() !== DirectionVector.BOTTOM);
    /**
     * Вычисляет корректирующие значения для области намагничивания с правой стороны.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeRight", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.RIGHT && (Kn.width = Jo.linePosition.x - qn.x - qn.width);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии с правой стороны графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param frameConfiguration Конфигурация графики.
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "rightTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.x > Kn.x + Kn.width && qn.line.getDirection() !== DirectionVector.MIDDLE_X);
    /**
     * Вычисляет корректирующие значения для области намагничивания сверху.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeTop", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.TOP && (Kn.y = -(qn.y - Jo.linePosition.y), Kn.height = qn.y - Jo.linePosition.y);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии сверху графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param frameConfiguration Конфигурация графики.
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "topTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.y < Kn.y && qn.line.getDirection() !== DirectionVector.MIDDLE_Y && qn.line.getDirection() !== DirectionVector.MIDDLE_X && qn.line.getDirection() !== DirectionVector.LEFT && qn.line.getDirection() !== DirectionVector.RIGHT);
    /**
     * Вычисляет корректирующие значения для области намагничивания снизу.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeBottom", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.BOTTOM && (Kn.height = Jo.linePosition.y - qn.y - qn.height);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии снизу графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param frameConfiguration Конфигурация графики.
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "bottomTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.y > Kn.y + Kn.height && qn.line.getDirection() !== DirectionVector.LEFT && qn.line.getDirection() !== DirectionVector.RIGHT);
    /**
     * Вычисляет корректирующие значения для области намагничивания левого верхнего угла.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeLeftTop", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.TOP && (Kn.y = -(qn.y - Jo.linePosition.y), Kn.height = qn.y - Jo.linePosition.y), Un !== null && Un === DirectionVector.LEFT && (Kn.x = -(qn.x - Jo.linePosition.x), Kn.width = qn.x - Jo.linePosition.x);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии рядом с левым верхним углом графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param dryConfiguration
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "leftTopTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.y <= Kn.y && qn.linePosition.x <= Kn.x);
    /**
     * Вычисляет корректирующие значения для области намагничивания правого верхнего угла.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeRightTop", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.TOP && (Kn.y = -(qn.y - Jo.linePosition.y), Kn.height = qn.y - Jo.linePosition.y), Un !== null && Un === DirectionVector.RIGHT && (Kn.width = Jo.linePosition.x - qn.x - qn.width);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии рядом с правым верхним углом графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param frameConfiguration Конфигурация графики.
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "rightTopTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.x > Kn.x + Kn.width ? !0 : Un !== null && qn.linePosition.y < Kn.y && qn.line.getDirection() === DirectionVector.TOP);
    /**
     * Вычисляет корректирующие значения для области намагничивания левого нижнего угла.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeLeftBottom", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.LEFT && (Kn.x = -(qn.x - Jo.linePosition.x), Kn.width = qn.x - Jo.linePosition.x), Un !== null && Un === DirectionVector.BOTTOM && (Kn.height = Jo.linePosition.y - qn.y - qn.height);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии рядом с левым нижним углом графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param frameConfiguration Конфигурация графики.
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "leftBottomTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.x <= Kn.x);
    /**
     * Вычисляет корректирующие значения для области намагничивания правого нижнего угла.
     * @param isMagnetizationZone Находится ли полученная область в зоне притягивания графики к линии.
     * @param correctValues Корректирующие значения для намагничивания.
     * @param dryConfiguration Конфигурация графики, без учета примагничивания к линии.
     * @param lineEntity Магнитная линия.
     */
    Ca(this, "magnetizeRightBottom", (Un, Kn, qn, Jo) => {
      Un !== null && Un === DirectionVector.BOTTOM && (Kn.height = Jo.linePosition.y - qn.y - qn.height), Un !== null && Un === DirectionVector.RIGHT && (Kn.width = Jo.linePosition.x - qn.x - qn.width);
    });
    /**
     * Вычисляет готовность к визуализации магнитной линии рядом с правым нижним углом графики.
     * @param isVisualizePosition Находится ли полученная область в зоне появления линии.
     * @param frameConfiguration Конфигурация графики.
     * @param lineEntity Магнитная линия.
     * @returns Готовность к визуализации магнитной линии.
     */
    Ca(this, "rightBottomTriggerReadyToVisualize", (Un, Kn, qn) => Un !== null && qn.linePosition.y >= Kn.y + Kn.height && qn.line.getDirection() !== DirectionVector.MIDDLE_Y ? !0 : Un !== null && qn.linePosition.x >= Kn.x + Kn.width && qn.line.getDirection() !== DirectionVector.MIDDLE_X);
  }
}
var KeyCode = /* @__PURE__ */ ((Xn) => (Xn.F1 = "F1", Xn.F2 = "F2", Xn.F3 = "F3", Xn.F4 = "F4", Xn.F5 = "F5", Xn.F6 = "F6", Xn.F7 = "F7", Xn.F8 = "F8", Xn.F9 = "F9", Xn.F10 = "F10", Xn.F11 = "F11", Xn.F12 = "F12", Xn.ESCAPE = "Escape", Xn.CONTROL_LEFT = "ControlLeft", Xn.CONTROL_RIGHT = "ControlRight", Xn.ALT_LEFT = "AltLeft", Xn.ALT_RIGHT = "AltRight", Xn.SHIFT_LEFT = "ShiftLeft", Xn.SHIFT_RIGHT = "ShiftRight", Xn.META_LEFT = "MetaLeft", Xn.META_RIGHT = "MetaRight", Xn.CAPS_LOCK = "CapsLock", Xn.TAB = "Tab", Xn.ENTER = "Enter", Xn.BACKSPACE = "Backspace", Xn.DELETE = "Delete", Xn.INSERT = "Insert", Xn.PAUSE = "Pause", Xn.PRINT_SCREEN = "PrintScreen", Xn.SCROLL_LOCK = "ScrollLock", Xn.ARROW_UP = "ArrowUp", Xn.ARROW_DOWN = "ArrowDown", Xn.ARROW_LEFT = "ArrowLeft", Xn.ARROW_RIGHT = "ArrowRight", Xn.HOME = "Home", Xn.END = "End", Xn.PAGE_UP = "PageUp", Xn.PAGE_DOWN = "PageDown", Xn.SPACE = "Space", Xn.BACKQUOTE = "Backquote", Xn.MINUS = "Minus", Xn.EQUAL = "Equal", Xn.BRACKET_LEFT = "BracketLeft", Xn.BRACKET_RIGHT = "BracketRight", Xn.BACKSLASH = "Backslash", Xn.SEMICOLON = "Semicolon", Xn.QUOTE = "Quote", Xn.COMMA = "Comma", Xn.PERIOD = "Period", Xn.SLASH = "Slash", Xn.NUM_LOCK = "NumLock", Xn.NUMPAD_0 = "Numpad0", Xn.NUMPAD_1 = "Numpad1", Xn.NUMPAD_2 = "Numpad2", Xn.NUMPAD_3 = "Numpad3", Xn.NUMPAD_4 = "Numpad4", Xn.NUMPAD_5 = "Numpad5", Xn.NUMPAD_6 = "Numpad6", Xn.NUMPAD_7 = "Numpad7", Xn.NUMPAD_8 = "Numpad8", Xn.NUMPAD_9 = "Numpad9", Xn.NUMPAD_DIVIDE = "NumpadDivide", Xn.NUMPAD_MULTIPLY = "NumpadMultiply", Xn.NUMPAD_SUBTRACT = "NumpadSubtract", Xn.NUMPAD_ADD = "NumpadAdd", Xn.NUMPAD_DECIMAL = "NumpadDecimal", Xn.NUMPAD_ENTER = "NumpadEnter", Xn.KEY_A = "KeyA", Xn.KEY_B = "KeyB", Xn.KEY_C = "KeyC", Xn.KEY_D = "KeyD", Xn.KEY_E = "KeyE", Xn.KEY_F = "KeyF", Xn.KEY_G = "KeyG", Xn.KEY_H = "KeyH", Xn.KEY_I = "KeyI", Xn.KEY_J = "KeyJ", Xn.KEY_K = "KeyK", Xn.KEY_L = "KeyL", Xn.KEY_M = "KeyM", Xn.KEY_N = "KeyN", Xn.KEY_O = "KeyO", Xn.KEY_P = "KeyP", Xn.KEY_Q = "KeyQ", Xn.KEY_R = "KeyR", Xn.KEY_S = "KeyS", Xn.KEY_T = "KeyT", Xn.KEY_U = "KeyU", Xn.KEY_V = "KeyV", Xn.KEY_W = "KeyW", Xn.KEY_X = "KeyX", Xn.KEY_Y = "KeyY", Xn.KEY_Z = "KeyZ", Xn.DIGIT_0 = "Digit0", Xn.DIGIT_1 = "Digit1", Xn.DIGIT_2 = "Digit2", Xn.DIGIT_3 = "Digit3", Xn.DIGIT_4 = "Digit4", Xn.DIGIT_5 = "Digit5", Xn.DIGIT_6 = "Digit6", Xn.DIGIT_7 = "Digit7", Xn.DIGIT_8 = "Digit8", Xn.DIGIT_9 = "Digit9", Xn.AUDIO_VOLUME_MUTE = "AudioVolumeMute", Xn.AUDIO_VOLUME_DOWN = "AudioVolumeDown", Xn.AUDIO_VOLUME_UP = "AudioVolumeUp", Xn.MEDIA_PLAY_PAUSE = "MediaPlayPause", Xn.MEDIA_STOP = "MediaStop", Xn.MEDIA_TRACK_NEXT = "MediaTrackNext", Xn.MEDIA_TRACK_PREVIOUS = "MediaTrackPrevious", Xn.CONTEXT_MENU = "ContextMenu", Xn.UNKNOWN = "Unidentified", Xn))(KeyCode || {});
class BlindZoneDetector {
  constructor() {
    Ca(this, "DEFAULT_BLIND_SIZE", 4);
    Ca(this, "blindZoneSize");
    // Находится ли текущая позиция за пределами слепой зоны
    Ca(this, "isOverstepping");
    /* Включен ли механизм слепой зоны, если нет, то детектор будет всегда уведомлять,
    что позиция за пределами слепой зоны */
    Ca(this, "isDetectorEnable");
    Ca(this, "isMoveRun");
    Ca(this, "currentOffset");
    Ca(this, "start", () => {
      this.isMoveRun = !0;
    });
    /**
     * Добавляет сдвиг к текущим значениям.
     * @param offsets - сдвиг.
     */
    Ca(this, "appendOffsets", (zn) => {
      this.isMoveRun && (this.currentOffset.x += zn.x, this.currentOffset.y += zn.y, this.checkOverstepping());
    });
    /**
     * Устанавливает сдвиг как текущий.
     * @param offsets - сдвиг.
     */
    Ca(this, "setOffsets", (zn) => {
      this.isMoveRun && (this.currentOffset.x = zn.x, this.currentOffset.y = zn.y, this.checkOverstepping());
    });
    Ca(this, "stop", () => {
      this.currentOffset.x = 0, this.currentOffset.y = 0, this.isOverstepping = !1;
    });
    Ca(this, "setBlindZoneSize", (zn) => {
      this.blindZoneSize = zn;
    });
    /**
     * Выключает работу детектора. Статус выхода за пределы зоны всегда будет положительным.
     */
    Ca(this, "disableDetector", () => {
      this.isDetectorEnable = !1;
    });
    Ca(this, "isBlindZoneOverstepping", () => this.isDetectorEnable ? this.isOverstepping : !0);
    Ca(this, "checkOverstepping", () => {
      this.isOverstepping || (Math.abs(this.currentOffset.x) > this.blindZoneSize || Math.abs(this.currentOffset.y) > this.blindZoneSize) && (this.isOverstepping = !0);
    });
    this.blindZoneSize = this.DEFAULT_BLIND_SIZE, this.isMoveRun = !1, this.isDetectorEnable = !0, this.isOverstepping = !1, this.currentOffset = { x: 0, y: 0 };
  }
}
class AreaMutator extends Dependent {
  constructor(Un) {
    super();
    Ca(this, "type");
    Ca(this, "startMutationListeners");
    Ca(this, "postMutationListeners");
    Ca(this, "prevMutationListeners");
    Ca(this, "stopMutationListeners");
    Ca(this, "blindZoneDetector");
    Ca(this, "mutableEntities");
    Ca(this, "activeTrigger");
    Ca(this, "isMutate");
    Ca(this, "maintainAspectRatio");
    Ca(this, "isDisableAspectRatio");
    Ca(this, "correctValues");
    Ca(this, "initiatorArea");
    // Изменения относительно начальной конфигурации (абсолютные изменения)
    Ca(this, "absoluteAreaOffsets");
    /**
     * Начинает мутацию областей.
     * @param initiatorArea - область, которая спровоцировала мутацию.
     * @param areas - связанные для мутации области.
     */
    Ca(this, "start", (Un, ...Kn) => {
      const qn = [Un, ...Kn].filter((Jo) => Jo.isAllowMutatePosition()).flatMap((Jo) => Jo.getRelatedFrames());
      qn.forEach((Jo) => {
        const pa = Jo.getMinWidth(), ma = Jo.getMinHeight(), va = Jo.getFrameArea(), ba = Jo.getPostMutationEvents(), _a = va.width / va.height;
        this.mutableEntities.push({
          initialFrameArea: va,
          postMutationEvents: ba,
          frame: Jo,
          aspectRatio: _a,
          minWidth: pa,
          minHeight: ma
        });
      }), this.maintainAspectRatio = this.getMaintainAspectRatio(qn), this.absoluteAreaOffsets = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        rotate: 0
      }, this.isMutate = !0, this.initiatorArea = Un, this.blindZoneDetector.start(), this.postStartEvent([Un, ...Kn]), this.runStartMutationsEvents({ x: 0, y: 0 }), this.runStartMutationListeners(Un, Kn);
    });
    /** Закончить мутацию областей. */
    Ca(this, "stop", () => {
      if (this.isMutate) {
        if (this.absoluteAreaOffsets === null)
          throw new EditorError("frame area offsets not found");
        this.runStopMutationsListeners({ x: this.absoluteAreaOffsets.x, y: this.absoluteAreaOffsets.y }), this.runStopMutationsLocalListeners({ x: this.absoluteAreaOffsets.x, y: this.absoluteAreaOffsets.y }), this.blindZoneDetector.stop(), this.isMutate = !1, this.initiatorArea = null, this.absoluteAreaOffsets = null, this.mutableEntities.length = 0, this.maintainAspectRatio = !1, this.postStopEvent();
      }
    });
    /** Сообщить об изменениях в пространстве, тем самым инициировав мутацию области. */
    Ca(this, "mutate", async (Un, Kn) => {
      if (!this.isMutate)
        return;
      if (this.updateOffsets(Un, Kn), this.absoluteAreaOffsets === null)
        throw new EditorError("offsets is null");
      if (this.blindZoneDetector.setOffsets(this.absoluteAreaOffsets), !this.blindZoneDetector.isBlindZoneOverstepping())
        return;
      const qn = this.getMutationEvent(Un, Kn);
      this.runPrevMutationListeners(qn), await this.mutateFrames(), this.runPostMutationListeners(qn), this.callEntitiesMutationEvents(qn);
    });
    /**
     * Возвращает результат выхода за пределы слепой зоны.
     */
    Ca(this, "isBlindZoneOverstepping", () => this.blindZoneDetector.isBlindZoneOverstepping());
    /** Добавить слушателя мутации области. */
    Ca(this, "addPostMutationListener", (Un) => {
      this.postMutationListeners.push(Un);
    });
    /**
     * Добавляет слушателя, который оповещается перед началом движения мутатора.
     * @param listener - слушатель.
     */
    Ca(this, "addPrevMutationListener", (Un) => {
      this.prevMutationListeners.push(Un);
    });
    /** Добавить слушателя начала мутации. */
    Ca(this, "addStartMutationListener", (Un) => {
      this.startMutationListeners.push(Un);
    });
    /** Отключает возможность применить механику с сохранением соотношения сторон. */
    Ca(this, "disableMaintainAspectRatio", () => {
      this.isDisableAspectRatio = !0;
    });
    /** Отключает задержку при начале движения. */
    Ca(this, "disableBlindMode", () => {
      this.blindZoneDetector.disableDetector();
    });
    /** Добавляет слушатель на остановку процесса мутации. */
    Ca(this, "addStopMutationListener", (Un) => {
      this.stopMutationListeners.push(Un);
    });
    /**
     * Устанавливает корректирующие значения, которые применяются к сдвигам для передачи их областям.
     * @param values - корректирующие значения.
     */
    Ca(this, "setCorrectValues", (Un) => {
      this.correctValues = Un;
    });
    /**
     * Сбрасывает корректирующие значения.
     */
    Ca(this, "clearCorrectValues", () => {
      this.correctValues = null;
    });
    /**
     * Возвращает сухую конфигурацию области без учета дополнительных сдвигов.
     * @param area - начальные значения области в момент начала мутации.
     */
    Ca(this, "getDryConfiguration", (Un) => {
      if (this.absoluteAreaOffsets === null)
        throw new EditorError("frame area offset is null");
      return {
        x: Un.x + this.absoluteAreaOffsets.x,
        y: Un.y + this.absoluteAreaOffsets.y,
        width: Un.width + this.absoluteAreaOffsets.width,
        height: Un.height + this.absoluteAreaOffsets.height,
        rotate: Un.rotate + this.absoluteAreaOffsets.rotate
      };
    });
    /**
     * Возвращает корректирующие сдвиг значения.
     */
    Ca(this, "getCurrentCorrectOffsets", () => this.correctValues);
    Ca(this, "isRunningMutate", () => this.isMutate);
    Ca(this, "getInitiatorArea", () => this.initiatorArea);
    /**
     * На основании сущностей для мутации определяет, нужно ли сохранить соотношение сторон при мутации.
     */
    Ca(this, "getMaintainAspectRatio", (Un) => this.mutableEntities.length === 0 ? !1 : Un.find((Kn) => Kn.isMaintainAspectRatio()) !== void 0);
    /** Физическое изменение фреймов. */
    Ca(this, "mutateFrames", async () => {
      if (this.absoluteAreaOffsets !== null)
        for (let Un = 0; Un < this.mutableEntities.length; Un++) {
          const Kn = this.mutableEntities[Un];
          let qn = this.getAbsoluteValues(Kn);
          !this.correctMinMaxValues(qn, Kn) && Kn.minWidth !== 0 || (this.maintainAspectRatio && (qn = this.correctAspectRatioValues(qn, Kn)), qn = this.applyCorrectValues(qn), await Kn.frame.mutateFrameArea(() => qn));
        }
    });
    Ca(this, "correctMinMaxValues", (Un, Kn) => !(Un.width < Kn.minWidth || Un.height < Kn.minHeight));
    /**
     * Пересчитывает сдвиги с учетом корректирующих значений (Магнитные линии например).
     */
    Ca(this, "applyCorrectValues", (Un) => this.correctValues === null ? Un : {
      x: Un.x + this.correctValues.x,
      y: Un.y + this.correctValues.y,
      width: Un.width + this.correctValues.width,
      height: Un.height + this.correctValues.height,
      rotate: Un.rotate + this.correctValues.rotate
    });
    /**
     * Запустить события начала мутации.
     * @param offsets - текущие сдвиги координат.
     */
    Ca(this, "runStartMutationsEvents", (Un) => {
      const Kn = {
        type: this.type,
        stage: AreaMutationEventStage.START,
        body: this.getMutationEventBody(),
        offsets: Un
      };
      this.callEntitiesMutationEvents(Kn);
    });
    /**
     * Запускает события окончания мутации.
     * @param offsets - текущие сдвиги координат.
     */
    Ca(this, "runStopMutationsListeners", (Un) => {
      const Kn = {
        type: this.type,
        stage: AreaMutationEventStage.STOP,
        body: this.getMutationEventBody(),
        offsets: Un
      };
      this.callEntitiesMutationEvents(Kn);
    });
    /**
     * Запускает события после мутации, загруженные в сам мутатор.
     */
    Ca(this, "runPostMutationListeners", (Un) => {
      if (this.absoluteAreaOffsets === null)
        throw new EditorError("frame area offsets not found");
      for (let Kn = 0; Kn < this.postMutationListeners.length; Kn++)
        this.postMutationListeners[Kn](Un, this.absoluteAreaOffsets);
    });
    Ca(this, "runPrevMutationListeners", (Un) => {
      if (this.absoluteAreaOffsets === null)
        throw new EditorError("frame area offsets not found");
      for (let Kn = 0; Kn < this.prevMutationListeners.length; Kn++)
        this.prevMutationListeners[Kn](Un, this.absoluteAreaOffsets);
    });
    /**
     * Оповещает слушателей начала мутации, загруженных в сам мутатор.
     */
    Ca(this, "runStartMutationListeners", (Un, Kn) => {
      if (this.absoluteAreaOffsets === null)
        throw new EditorError("frame area offsets not found");
      this.startMutationListeners.forEach((qn) => {
        qn({
          areas: Kn,
          initiator: Un,
          mutator: this
        });
      });
    });
    /**
     * Уведомляет о событиях все подписанные сущности.
     */
    Ca(this, "callEntitiesMutationEvents", (Un) => {
      if (this.absoluteAreaOffsets === null)
        throw new EditorError("frame area offsets not found");
      for (let Kn = 0; Kn < this.mutableEntities.length; Kn++)
        for (let qn = 0; qn < this.mutableEntities[Kn].postMutationEvents.length; qn++)
          this.mutableEntities[Kn].postMutationEvents[qn](Un, this.absoluteAreaOffsets);
    });
    /**
     * Получить объект события процесса мутации.
     * @param offsetX - сдвиг по оси x.
     * @param offsetY - сдвиг по оси y.
     */
    Ca(this, "getMutationEvent", (Un, Kn) => ({
      type: this.type,
      stage: AreaMutationEventStage.PROCESS,
      offsets: {
        x: Un,
        y: Kn
      },
      body: this.getMutationEventBody()
    }));
    this.type = Un, this.isMutate = !1, this.mutableEntities = [], this.initiatorArea = null, this.activeTrigger = null, this.isDisableAspectRatio = !1, this.postMutationListeners = [], this.prevMutationListeners = [], this.stopMutationListeners = [], this.startMutationListeners = [], this.absoluteAreaOffsets = null, this.maintainAspectRatio = !1, this.blindZoneDetector = new BlindZoneDetector(), this.correctValues = {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      rotate: 0
    };
  }
  /**
   * Запускает обработчики окончания мутации, загруженные в сам мутатор.
   * @param offsets - текущие сдвиги координат.
   */
  runStopMutationsLocalListeners(Un) {
    if (this.absoluteAreaOffsets === null)
      throw new EditorError("frame area offsets not found");
    const Kn = {
      type: this.type,
      stage: AreaMutationEventStage.STOP,
      body: this.getMutationEventBody(),
      offsets: Un
    };
    for (let qn = 0; qn < this.stopMutationListeners.length; qn++)
      this.stopMutationListeners[qn](Kn, this.absoluteAreaOffsets);
  }
  getAbsoluteValues(Un) {
    if (this.absoluteAreaOffsets === null)
      throw new EditorError("absolute area offsets not found");
    const Kn = Un.initialFrameArea.x + this.absoluteAreaOffsets.x, qn = Un.initialFrameArea.y + this.absoluteAreaOffsets.y, Jo = Un.initialFrameArea.rotate + this.absoluteAreaOffsets.rotate, pa = Un.initialFrameArea.width + this.absoluteAreaOffsets.width;
    return {
      height: Un.initialFrameArea.height + this.absoluteAreaOffsets.height,
      width: pa,
      x: Kn,
      y: qn,
      rotate: Jo
    };
  }
}
class AreaPositionMutator extends AreaMutator {
  constructor() {
    super(AreaMutationEventType.POSITION);
    Ca(this, "postStartEvent", (Un) => {
    });
    Ca(this, "postStopEvent", () => {
    });
    Ca(this, "startMoveComponents", (Un, Kn) => {
      const qn = [];
      Kn.forEach((Jo) => {
        Jo.getGraphics().forEach((ma) => {
          const va = new SpatialGraphicArea(ma);
          qn.push(va);
        });
      }), this.start(Un, ...qn);
    });
    Ca(this, "updateOffsets", (Un, Kn) => {
      if (this.absoluteAreaOffsets === null)
        throw new EditorError("offsets not initialize");
      this.absoluteAreaOffsets.x += Un, this.absoluteAreaOffsets.y += Kn;
    });
    Ca(this, "getMutationEventBody", () => ({}));
    Ca(this, "correctAspectRatioValues", (Un, Kn) => Un);
    this.disableMaintainAspectRatio();
  }
}
class AreaPositionWithCloneMutator extends AreaPositionMutator {
  constructor() {
    super();
    /* Флаг указывает можно ли копировать в мутации (от startMoveComponents() до this.stop() ) чтобы не
    копировать на каждый mouseMove */
    Ca(this, "isCanCopy");
    Ca(this, "mutateNew", (Un, Kn) => {
    });
    Ca(this, "onClone", async () => {
      this.isCanCopy && this.isBlindZoneOverstepping() && this.dependencies.keyboardObserver.isPressed(KeyCode.ALT_LEFT) && (this.dependencies.fnClone(), this.isCanCopy = !1);
    });
    Ca(this, "onStopMutation", async () => {
      this.isCanCopy = !0;
    });
    this.isCanCopy = !0, this.addPrevMutationListener(this.onClone), this.addStopMutationListener(this.onStopMutation);
  }
}
class SpatialInputArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.INPUT);
    Ca(this, "getGlobalFrameArea", () => this.input.getFrameArea());
    Ca(this, "getData", () => this.input);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.input = Un;
  }
}
class BaseInput extends Dependent {
  constructor() {
    super();
    Ca(this, "TEXT_PADDING", {
      x: 0,
      y: 0
    });
    Ca(this, "DEFAULT_DURATION", 100);
    Ca(this, "DEFAULT_MIN_WIDTH", 30);
    Ca(this, "textModel");
    Ca(this, "textSelection");
    Ca(this, "textCarriage");
    Ca(this, "text");
    Ca(this, "container");
    Ca(this, "postMouseDownListeners");
    Ca(this, "configuration");
    Ca(this, "enableFocusListeners");
    Ca(this, "disableFocusListeners");
    Ca(this, "area");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isShow");
    Ca(this, "isFixedWidth");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.text.object.left,
      y: this.text.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "addEnableFocusListeners", (...Un) => {
      this.enableFocusListeners.push(...Un);
    });
    Ca(this, "addDisableFocusListeners", (...Un) => {
      this.disableFocusListeners.push(...Un);
    });
    Ca(this, "enableFixedWidth", () => {
      this.isFixedWidth || (this.isFixedWidth = !0);
    });
    Ca(this, "disableFixedWidth", () => {
      this.isFixedWidth && (this.isFixedWidth = !1);
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn), {
        textColor: Jo,
        textColorFocus: pa,
        borderColor: ma,
        borderColorFocus: va,
        borderRadius: ba,
        placeholderColor: _a,
        placeholder: ya,
        fill: xa,
        fillFocus: wa,
        width: Ta,
        height: Sa,
        paddingHorizontal: Ma,
        svg: ka,
        svgColor: Za,
        textFontSize: Na
      } = qn;
      this.text.object.set({
        fill: this.isFocus ? pa === null ? Jo : pa : Jo,
        fontSize: Number.parseInt(String(Na).replace("pt", ""), 10)
      }), this.isFixedWidth ? this.container.object.set({
        fill: this.isFocus ? wa === null ? xa : wa : xa,
        stroke: this.isFocus ? va === null ? ma : va : ma,
        rx: ba,
        ry: ba,
        width: Ta,
        height: Sa
      }) : this.container.object.set({
        fill: this.isFocus ? wa : xa,
        stroke: this.isFocus ? va === null ? ma : va : ma,
        rx: ba,
        ry: ba,
        width: this.getWidthContainer(),
        height: Sa
      }), ka && (ka.object.set({
        fill: Za
      }), this.isShow || ka.object.set({
        visible: !1
      }));
      let Ka = qn.x + Ma;
      ka !== null && (ka.relativePosition = {
        x: Ka,
        y: Math.round(qn.y + (Sa / 2 - ka.object.height / 2))
      }, Ka += ka.object.width + Ma), this.text.relativePosition = {
        x: Ka,
        y: Math.round(qn.y + (Sa / 2 - this.text.object.height / 2))
      }, this.textCarriage.setPositionOffset({
        x: Ka,
        y: Math.round(qn.y + (Sa / 2 - this.text.object.height / 2))
      }), this.textSelection.setPositionOffset({
        x: Ka,
        y: Math.round(qn.y + (Sa / 2 - this.text.object.height / 2))
      }), this.container.relativePosition = {
        x: qn.x,
        y: qn.y
      }, this.configuration = qn;
    });
    Ca(this, "addPostChangeTextListener", (Un) => {
      this.textModel.addPostChangeTextListener(Un);
    });
    Ca(this, "syncPosition", () => {
      let Un = this.configuration.x + this.configuration.paddingHorizontal;
      this.configuration.svg !== null && (this.configuration.svg.relativePosition = {
        x: Un,
        y: Math.round(
          this.configuration.y + (this.configuration.height / 2 - this.configuration.svg.object.height / 2)
        )
      }, Un += this.configuration.svg.object.width + this.configuration.paddingHorizontal), this.text.object.set({
        fill: this.configuration.textColor,
        fontSize: Number.parseInt(String(this.configuration.textFontSize).slice(0, -2), 10)
      }), this.text.relativePosition = {
        x: Un,
        y: Math.round(this.configuration.y + (this.configuration.height / 2 - this.text.object.height / 2))
      }, this.container.relativePosition = {
        x: this.configuration.x,
        y: this.configuration.y
      }, this.dependencies.render.renderRelativePositions();
    });
    Ca(this, "getRelativePosition", () => ({
      x: this.container.relativePosition.x,
      y: this.container.relativePosition.y
    }));
    Ca(this, "callClick", () => {
      this.isFocus || (this.enableFocus(), this.textCarriage.enable());
    });
    Ca(this, "getTextPadding", () => this.TEXT_PADDING);
    Ca(this, "setText", (Un, Kn) => {
      this.text.object.set({
        text: Un,
        styles: {
          0: Kn
        }
      });
    });
    Ca(this, "setLineHeight", (Un) => {
      if (this.text === null)
        throw new EditorError("graphic object not initialized");
      this.text.object.set("lineHeight", Un);
    });
    Ca(this, "setTextAlign", (Un) => {
      if (this.text === null)
        throw new EditorError("graphic object not initialized");
      this.text.object.set({ textAlign: Un });
    });
    Ca(this, "getTextSelection", () => this.textSelection);
    Ca(this, "getObjects", () => {
      const Un = [
        this.container,
        this.text,
        ...this.textSelection.getObjects(),
        this.textCarriage.getObject()
      ];
      return this.configuration.svg !== null && Un.push(this.configuration.svg), Un;
    });
    Ca(this, "getFabricObjects", () => {
      const Un = [
        this.container.object,
        this.text.object,
        this.textCarriage.getObject().object,
        ...this.textSelection.getObjects().map((Kn) => Kn.object)
      ];
      return this.configuration.svg !== null && Un.push(this.configuration.svg.object), Un;
    });
    Ca(this, "getTextViews", () => [this]);
    Ca(this, "getTextCarriage", () => this.textCarriage);
    Ca(this, "getRealLineHeights", () => this.text.object.__lineHeights);
    Ca(this, "getGraphemePositions", () => this.text.object.__charBounds);
    Ca(this, "getTextModel", () => this.textModel);
    Ca(this, "getCarriageCoverages", () => this.textModel.getCoverages([this]));
    Ca(this, "addPostMouseDownListeners", (...Un) => {
      this.postMouseDownListeners.push(...Un);
    });
    Ca(this, "disableFocus", () => {
      if (!this.isFocus)
        return;
      this.isFocus = !1, this.dependencies.textEngine.disableModeEditMode(this.textModel.getParent());
      const { fill: Un, fillFocus: Kn, borderColor: qn, borderColorFocus: Jo, textColor: pa, textColorFocus: ma, svgColor: va } = this.configuration, ba = [];
      Kn !== null && ba.push({
        object: this.container.object,
        startColor: Kn,
        endColor: Un,
        duration: this.DEFAULT_DURATION,
        type: TypeColorAnimated.FILL
      }), Jo !== null && ba.push({
        object: this.container.object,
        startColor: Jo,
        endColor: qn,
        duration: this.DEFAULT_DURATION,
        type: TypeColorAnimated.STROKE
      }), ma !== null && ba.push({
        object: this.text.object,
        startColor: ma,
        endColor: pa,
        duration: this.DEFAULT_DURATION,
        type: TypeColorAnimated.FILL
      }), this.dependencies.render.animateColor(...ba);
      for (const _a of this.disableFocusListeners)
        _a();
    });
    Ca(this, "enableFocus", () => {
      if (this.isFocus)
        return;
      this.isFocus = !0, this.dependencies.textEngine.enableModelEditMode(this.textModel.getParent());
      const { fill: Un, fillFocus: Kn, borderColor: qn, borderColorFocus: Jo, textColor: pa, textColorFocus: ma, svgColor: va } = this.configuration, ba = [];
      Kn !== null && ba.push({
        object: this.container.object,
        startColor: Un,
        endColor: Kn,
        duration: this.DEFAULT_DURATION,
        type: TypeColorAnimated.FILL
      }), Jo !== null && ba.push({
        object: this.container.object,
        startColor: qn,
        endColor: Jo,
        duration: this.DEFAULT_DURATION,
        type: TypeColorAnimated.STROKE
      }), ma !== null && ba.push({
        object: this.text.object,
        startColor: pa,
        endColor: ma,
        duration: this.DEFAULT_DURATION,
        type: TypeColorAnimated.FILL
      }), this.dependencies.render.animateColor(...ba);
      for (const _a of this.enableFocusListeners)
        _a();
    });
    Ca(this, "disableHover", () => {
    });
    Ca(this, "enableHover", () => {
    });
    Ca(this, "show", () => {
      var Un;
      this.isShow || (this.isShow = !0, this.text.object.set({
        visible: !0
      }), this.container.object.set({
        visible: !0
      }), (Un = this.configuration.svg) == null || Un.object.set({
        visible: !0
      }));
    });
    Ca(this, "hide", () => {
      var Un;
      this.isShow && (this.isShow = !1, this.text.object.set({
        visible: !1
      }), this.container.object.set({
        visible: !1
      }), (Un = this.configuration.svg) == null || Un.object.set({
        visible: !1
      }));
    });
    Ca(this, "getFrameArea", () => ({
      width: this.container.object.width,
      height: this.container.object.height,
      x: this.text.object.left,
      y: this.text.object.top,
      rotate: 0
    }));
    Ca(this, "getSpatialArea", () => (this.area === null && (this.area = new SpatialInputArea(this), this.area.markDirty()), this.area));
    Ca(this, "getUIElements", () => []);
    Ca(this, "isEnableFocus", () => this.isFocus);
    Ca(this, "isEnableHover", () => this.isHover);
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getHeight", () => this.container.object.height);
    Ca(this, "getWidth", () => this.container.object.width);
    Ca(this, "getWidthView", () => this.container.object.width);
    Ca(this, "onPostChangeText", (Un) => {
      this.syncPosition(), !this.isFixedWidth && this.container.object.set({
        width: this.getWidthContainer()
      });
    });
    Ca(this, "getWidthContainer", () => {
      const { paddingHorizontal: Un, svg: Kn } = this.configuration, qn = this.text.object.width + Un * 2 + (Kn !== null ? Un : 0);
      return qn < this.DEFAULT_MIN_WIDTH ? this.DEFAULT_MIN_WIDTH : qn;
    });
    this.area = null, this.isHover = !1, this.isFocus = !1, this.isShow = !1, this.isFixedWidth = !0, this.isResetFocus = !0, this.postMouseDownListeners = [], this.enableFocusListeners = [], this.disableFocusListeners = [], this.configuration = {
      fill: UIDefaultColor.WHITE,
      fillFocus: null,
      borderColor: UIDefaultColor.GRAY_900,
      borderColorFocus: null,
      borderRadius: 5,
      textFontSize: FontSize.Pt14,
      textColor: UIDefaultColor.BLACK,
      textColorFocus: null,
      placeholder: null,
      placeholderColor: UIDefaultColor.GRAY_300,
      width: 200,
      height: 30,
      paddingHorizontal: 5,
      svg: null,
      svgColor: UIDefaultColor.GRAY_700,
      x: 0,
      y: 0
    }, this.textModel = new TextModel(this), this.textCarriage = new TextCarriage(), this.text = {
      object: new Xo("", { visible: !1 }),
      relativePosition: {
        x: 0,
        y: 0
      }
    }, this.container = {
      object: new pr({
        strokeWidth: 1,
        visible: !1
      }),
      relativePosition: {
        x: 0,
        y: 0
      }
    }, this.textSelection = new TextViewSelection(), this.textModel.setFontSize(FontSize.Pt8), this.textModel.disableEnter(), this.addPostInjectDependenciesListener(() => {
      this.addPostChangeTextListener(this.onPostChangeText);
    });
  }
}
class NumberInput extends BaseInput {
  constructor() {
    super();
    Ca(this, "DEFAULT_MAX_TEXT_LENGTH", 5);
    Ca(this, "setMaxLength", (Un) => {
      this.textModel.setMaxTextLength(Un);
    });
    Ca(this, "getValue", () => {
      const Un = Number.parseInt(this.textModel.getText(), 10);
      return Number.isNaN(Un) ? 0 : Un;
    });
    Ca(this, "setValue", (Un) => {
      this.textModel.setTexture({
        textAlign: TextAlign.LEFT,
        lineHeight: LineHeight.MEDIUM,
        splitGraphemePositions: [0],
        tokens: [
          {
            type: TokenType.PARAGRAPH,
            fontFamily: FontFamily.DEFAULT,
            color: UIDefaultColor.BLACK,
            fontSize: this.configuration.textFontSize,
            format: TokenFormat.None,
            value: Un
          }
        ],
        id: Utils.generate.uuid4()
      }), this.textModel.syncModelWithViews();
    });
    this.textModel.enableOnlyNumbersMode(), this.textModel.setMaxTextLength(this.DEFAULT_MAX_TEXT_LENGTH), this.textModel.syncModelWithViews();
  }
}
class LeftBottomInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 8,
      textFontSize: FontSize.Pt12
    })), this.hide();
  }
}
class LeftTopInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 8,
      textFontSize: FontSize.Pt12
    })), this.hide();
  }
}
class RightBottomInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 8,
      textFontSize: FontSize.Pt12
    })), this.hide();
  }
}
class RightTopInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 8,
      textFontSize: FontSize.Pt12
    })), this.hide();
  }
}
var TooltipType = /* @__PURE__ */ ((Xn) => (Xn.LEFT = "LEFT", Xn.RIGHT = "RIGHT", Xn.TOP = "TOP", Xn.BOTTOM = "BOTTOM", Xn))(TooltipType || {});
class SpatialUIButtonArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.BUTTON);
    Ca(this, "getGlobalFrameArea", () => this.button.getFrameArea());
    Ca(this, "getData", () => this.button);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.button = Un;
  }
}
class ToolTipBottom {
  constructor() {
    Ca(this, "DEFAULT_TEXT", "Изображение / shift + K");
    Ca(this, "container");
    Ca(this, "triangle");
    Ca(this, "text");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "setText", (zn) => {
      this.text.object.set({
        text: zn
      }), this.setPosition(
        {
          x: this.configuration.x,
          y: this.configuration.y
        },
        this.configuration.buttonWidth
      );
    });
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.triangle.object.visible = !0, this.text.object.visible = !0);
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.triangle.object.visible = !1, this.text.object.visible = !1);
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (zn) => {
      const Un = this.configuration, Kn = zn(Un);
      if (this.container.object.fill = Kn.fill, this.text.object.text = Kn.text, this.text.object.fontSize = Kn.fontSize, this.configuration.marginIsStart !== Kn.marginIsStart || this.configuration.padding !== Kn.padding || this.configuration.x !== Kn.x || this.configuration.y !== Kn.y) {
        this.configuration = Kn, this.setPosition(
          {
            x: Kn.x,
            y: Kn.y
          },
          this.configuration.buttonWidth
        );
        return;
      }
      this.configuration = Kn;
    });
    Ca(this, "getFabricObjects", () => [this.container.object, this.triangle.object, this.text.object]);
    Ca(this, "getObjects", () => [this.container, this.triangle, this.text]);
    Ca(this, "setPosition", (zn, Un) => {
      const { marginIsStart: Kn, padding: qn } = this.configuration;
      this.configuration.buttonWidth = Un, this.text.relativePosition = {
        x: Math.round(zn.x - qn.leftRight),
        y: Math.round(zn.y + Kn + qn.topBottom + this.text.object.height / 2)
      }, this.triangle.relativePosition = {
        x: Math.round(zn.x - Un / 2),
        y: Math.round(zn.y + (Kn - this.triangle.object.height))
      }, this.container.object.set({
        height: Math.round(this.text.object.height + qn.topBottom * 2),
        width: Math.round(qn.leftRight * 2 + this.text.object.width)
      }), this.container.relativePosition = {
        x: zn.x,
        y: Math.round(zn.y + Kn)
      }, this.configuration.x = zn.x, this.configuration.y = zn.y;
    });
    this.configuration = {
      padding: {
        leftRight: 10,
        topBottom: 10
      },
      text: this.DEFAULT_TEXT,
      marginIsStart: 14,
      x: 0,
      y: 0,
      fontSize: 15,
      fill: UIDefaultColor.GRAY_550,
      buttonWidth: 0
    }, this.container = {
      object: new pr({
        fill: this.configuration.fill,
        rx: 4,
        ry: 4,
        strokeWidth: 0,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.container.object.set({
      originX: "right"
    }), this.triangle = {
      object: SVGCanvasStore.getSvg(SVGCollection.TRIANGLE_BOTTOM),
      relativePosition: { x: 0, y: 0 }
    }, this.triangle.object.set({
      originX: "center",
      originY: "top",
      fill: this.configuration.fill,
      visible: !1
    }), this.triangle.object.scaleToWidth(11), this.triangle.object.scaleToHeight(11), this.text = {
      object: new Xo(this.DEFAULT_TEXT, {
        fill: UIDefaultColor.WHITE,
        fontSize: this.configuration.fontSize,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.text.object.set({
      originY: "center",
      originX: "right"
    }), this.isShow = !1;
  }
}
class ToolTipRight {
  constructor() {
    Ca(this, "DEFAULT_TEXT", "ToolTipRight");
    Ca(this, "container");
    Ca(this, "triangle");
    Ca(this, "text");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "setText", (zn) => {
      this.text.object.set({
        text: zn
      }), this.setPosition({
        x: this.configuration.x,
        y: this.configuration.y
      });
    });
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.triangle.object.visible = !0, this.text.object.visible = !0);
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.triangle.object.visible = !1, this.text.object.visible = !1);
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (zn) => {
      const Un = this.configuration, Kn = zn(Un);
      if (this.container.object.fill = Kn.fill, this.text.object.text = Kn.text, this.text.object.fontSize = Kn.fontSize, this.configuration.marginIsStart !== Kn.marginIsStart || this.configuration.padding !== Kn.padding || this.configuration.x !== Kn.x || this.configuration.y !== Kn.y) {
        this.configuration = Kn, this.setPosition({
          x: Kn.x,
          y: Kn.y
        });
        return;
      }
      this.configuration = Kn;
    });
    Ca(this, "getFabricObjects", () => [this.container.object, this.triangle.object, this.text.object]);
    Ca(this, "getObjects", () => [this.container, this.triangle, this.text]);
    Ca(this, "setPosition", (zn) => {
      const { marginIsStart: Un, padding: Kn } = this.configuration;
      this.text.relativePosition = {
        x: zn.x + Un + Kn.leftRight,
        y: zn.y
      }, this.triangle.relativePosition = {
        x: zn.x + (Un - this.triangle.object.width),
        y: zn.y
      }, this.container.object.set({
        height: this.text.object.height + Kn.topBottom * 2,
        width: Kn.leftRight * 2 + Math.round(this.text.object.width)
      }), this.container.relativePosition = {
        x: zn.x + Un,
        y: Math.round(zn.y - (this.text.object.height + Kn.topBottom * 2) / 2)
      }, this.configuration.x = zn.x, this.configuration.y = zn.y;
    });
    this.configuration = {
      padding: {
        leftRight: 10,
        topBottom: 10
      },
      text: this.DEFAULT_TEXT,
      marginIsStart: 14,
      x: 0,
      y: 0,
      fontSize: 15,
      fill: UIDefaultColor.GRAY_550
    }, this.container = {
      object: new pr({
        fill: this.configuration.fill,
        rx: 4,
        ry: 4,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.triangle = {
      object: SVGCanvasStore.getSvg(SVGCollection.TRIANGLE_LEFT),
      relativePosition: { x: 0, y: 0 }
    }, this.triangle.object.set({
      originX: "left",
      originY: "center",
      fill: this.configuration.fill,
      visible: !1
    }), this.triangle.object.scaleToWidth(10), this.triangle.object.scaleToHeight(20), this.text = {
      object: new Xo(this.DEFAULT_TEXT, {
        fill: UIDefaultColor.WHITE,
        fontSize: this.configuration.fontSize,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.text.object.set({
      originY: "center"
    }), this.isShow = !1;
  }
}
class BaseUIButtonView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_BORDER_RADIUS", 0);
    Ca(this, "DEFAULT_FILL", "#FFFFFF");
    Ca(this, "DEFAULT_BORDER_COLOR", "#000000");
    Ca(this, "DEFAULT_BORDER_THICKNESS", 1);
    Ca(this, "DEFAULT_FILL_HOVER", "#d6e9ff");
    Ca(this, "DEFAULT_BORDER_COLOR_HOVER", "#000000");
    Ca(this, "DEFAULT_SVG_COLOR", "#7f8184");
    Ca(this, "DEFAULT_COLOR_HOVER_SVG", "#1560e0");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE", 16);
    Ca(this, "DEFAULT_TEXT_FONT", FontFamily.DEFAULT);
    Ca(this, "DEFAULT_DURATION_FOCUS", 100);
    Ca(this, "DEFAULT_DURATION_HOVER", 100);
    Ca(this, "DEFAULT_INSIDE_TEXT_TO_SVG", 5);
    Ca(this, "DEFAULT_PADDING", {
      leftRight: 10,
      topBottom: 5
    });
    Ca(this, "DEFAULT_TOOLTIP_TEXT", "ToolTipRight UIButton");
    Ca(this, "DEFAULT_TOOLTIP_ENABLE", !1);
    Ca(this, "DEFAULT_TOOLTIP_TYPE", TooltipType.RIGHT);
    Ca(this, "tooltipRight");
    Ca(this, "tooltipBottom");
    Ca(this, "configuration");
    Ca(this, "buttonObject");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isVisible");
    Ca(this, "isResetFocus");
    Ca(this, "enableHover", () => {
      if (!this.isHover) {
        if (this.isHover = !0, !this.configuration.isEnableClick)
          return;
        const {
          fill: Un,
          fillHover: Kn,
          fillFocus: qn,
          borderColor: Jo,
          borderColorHover: pa,
          borderColorFocus: ma,
          textColor: va,
          textColorHover: ba,
          textColorFocus: _a,
          svgColor: ya,
          svgColorHover: xa,
          svgColorFocus: wa,
          svg: Ta,
          text: Sa,
          tooltipType: Ma,
          isEnableTooltip: ka
        } = this.configuration, Za = [];
        if (this.isFocus ? (Kn !== null && qn === null && Za.push({
          object: this.buttonObject.container.object,
          startColor: Un,
          endColor: Kn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), pa !== null && ma === null && Za.push({
          object: this.buttonObject.container.object,
          startColor: Jo,
          endColor: pa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), Sa && ba !== null && _a === null && Za.push({
          object: this.buttonObject.text.object,
          startColor: va,
          endColor: ba,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Ta && xa && wa === null && Za.push({
          object: Ta.object,
          startColor: ya,
          endColor: xa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), this.dependencies.render.animateColor(...Za)) : (Kn !== null && Za.push({
          object: this.buttonObject.container.object,
          startColor: Un,
          endColor: Kn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), pa !== null && Za.push({
          object: this.buttonObject.container.object,
          startColor: Jo,
          endColor: pa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), Sa && ba !== null && Za.push({
          object: this.buttonObject.text.object,
          startColor: va,
          endColor: ba,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Ta && xa && Za.push({
          object: Ta.object,
          startColor: ya,
          endColor: xa,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), this.dependencies.render.animateColor(...Za)), ka)
          switch (Ma) {
            case TooltipType.BOTTOM: {
              this.tooltipBottom.show();
              break;
            }
            case TooltipType.RIGHT: {
              this.tooltipRight.show();
              break;
            }
          }
      }
    });
    Ca(this, "disableHover", () => {
      if (this.isHover) {
        if (this.isHover = !1, !this.configuration.isEnableClick)
          return;
        const {
          fill: Un,
          fillHover: Kn,
          fillFocus: qn,
          borderColor: Jo,
          borderColorHover: pa,
          borderColorFocus: ma,
          textColor: va,
          textColorHover: ba,
          textColorFocus: _a,
          svgColor: ya,
          svgColorHover: xa,
          svgColorFocus: wa,
          svg: Ta,
          text: Sa,
          tooltipType: Ma,
          isEnableTooltip: ka
        } = this.configuration, Za = [];
        if (this.isFocus ? (Kn !== null && qn === null && Za.push({
          object: this.buttonObject.container.object,
          startColor: Kn,
          endColor: Un,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), pa !== null && ma === null && Za.push({
          object: this.buttonObject.container.object,
          startColor: pa,
          endColor: Jo,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), Sa && ba !== null && _a === null && Za.push({
          object: this.buttonObject.text.object,
          startColor: ba,
          endColor: va,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Ta && xa !== null && wa === null && Za.push({
          object: Ta.object,
          startColor: xa,
          endColor: ya,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        })) : (Kn !== null && Za.push({
          object: this.buttonObject.container.object,
          startColor: Kn,
          endColor: Un,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), pa !== null && Za.push({
          object: this.buttonObject.container.object,
          startColor: pa,
          endColor: Jo,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }), Sa && ba !== null && Za.push({
          object: this.buttonObject.text.object,
          startColor: ba,
          endColor: va,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        }), Ta && xa !== null && Za.push({
          object: Ta.object,
          startColor: xa,
          endColor: ya,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        })), this.dependencies.render.animateColor(...Za), ka)
          switch (Ma) {
            case TooltipType.BOTTOM: {
              this.tooltipBottom.hide();
              break;
            }
            case TooltipType.RIGHT: {
              this.tooltipRight.hide();
              break;
            }
          }
      }
    });
    Ca(this, "isEnableHover", () => this.isHover);
    Ca(this, "isEnableFocus", () => this.isFocus);
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.buttonObject.container.object.visible = !0, this.configuration.placeholder && (this.buttonObject.placeholder.object.visible = !0), this.configuration.text && (this.buttonObject.text.object.visible = !0), this.configuration.svg && (this.configuration.svg.object.visible = !0));
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.buttonObject.container.object.visible = !1, this.buttonObject.text.object.visible = !1, this.buttonObject.placeholder.object.visible = !1, this.configuration.svg && (this.configuration.svg.object.visible = !1));
    });
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getFrameArea", () => ({
      width: this.getWidth(),
      height: this.getHeight(),
      x: this.buttonObject.container.object.left,
      y: this.buttonObject.container.object.top,
      rotate: 0
    }));
    Ca(this, "getGlobalPosition", () => ({
      x: this.buttonObject.container.object.left,
      y: this.buttonObject.container.object.top
    }));
    Ca(this, "getWidth", () => {
      const { text: Un, svg: Kn, padding: qn, insideTextToSvg: Jo, textFontSize: pa, size: ma, svgSize: va, placeholder: ba, placeholderInside: _a } = this.configuration;
      if (ma !== null)
        return ma.width;
      let ya = 0;
      return qn !== "center" && (ya += qn.leftRight * 2), Kn !== null && (va !== null ? ya += va + Jo : ya += pa + Jo), Un !== null && (ya += this.buttonObject.text.object.width), ba !== null && (ya += this.buttonObject.placeholder.object.width + _a), ya;
    });
    Ca(this, "getHeight", () => {
      const { padding: Un, textFontSize: Kn, size: qn, svgSize: Jo, text: pa } = this.configuration;
      return qn ? qn.height : Jo && !pa ? Jo : Un !== "center" ? (Jo || Kn) + Un.topBottom * 2 : Kn;
    });
    Ca(this, "isShowed", () => this.isVisible);
    Ca(this, "getFabricObjects", () => {
      const Un = [
        this.buttonObject.container.object,
        ...this.tooltipRight.getFabricObjects(),
        ...this.tooltipBottom.getFabricObjects()
      ];
      return this.configuration.text && Un.push(this.buttonObject.text.object), this.configuration.placeholder && Un.push(this.buttonObject.placeholder.object), this.configuration.svg && Un.push(this.configuration.svg.object), Un;
    });
    Ca(this, "getObjects", () => {
      const Un = [
        this.buttonObject.container,
        ...this.tooltipRight.getObjects(),
        ...this.tooltipBottom.getObjects()
      ];
      return this.configuration.text && Un.push(this.buttonObject.text), this.configuration.placeholder && Un.push(this.buttonObject.placeholder), this.configuration.svg && Un.push(this.configuration.svg), Un;
    });
    Ca(this, "setIsEnableClick", (Un) => {
      this.setConfiguration((Kn) => ({
        ...Kn,
        isEnableClick: Un
      }));
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      if (qn.placeholder && this.buttonObject.placeholder.object.set({
        fill: qn.placeholderColor,
        text: qn.placeholder,
        fontSize: qn.textFontSize
      }), qn.text && (this.configuration.text !== qn.text || this.configuration.textFontSize !== qn.textFontSize || this.configuration.textFontFamily !== qn.textFontFamily || this.configuration.textColor !== qn.textColor) && this.buttonObject.text.object.set({
        text: qn.text,
        fontSize: qn.textFontSize,
        fontFamily: qn.textFontFamily,
        fill: qn.textColor
      }), qn.svg) {
        if (qn.svgSize !== null) {
          if (qn.svg instanceof Mr)
            switch (qn.svgScale) {
              case ScaleSvg.WIDTH: {
                const Jo = qn.svgSize / qn.svg.width;
                qn.svg.set({
                  scaleX: Jo,
                  scaleY: Jo
                });
                break;
              }
              case ScaleSvg.HEIGHT: {
                const Jo = qn.svgSize / qn.svg.height;
                qn.svg.set({
                  scaleX: Jo,
                  scaleY: Jo
                });
                break;
              }
            }
          qn.svgScale === ScaleSvg.WIDTH ? qn.svg.object.scaleToWidth(qn.svgSize) : qn.svgScale === ScaleSvg.HEIGHT && qn.svg.object.scaleToHeight(qn.svgSize);
        } else
          qn.svgScale === ScaleSvg.WIDTH ? qn.svg.object.scaleToWidth(qn.textFontSize) : qn.svgScale === ScaleSvg.HEIGHT && qn.svg.object.scaleToHeight(qn.textFontSize);
        qn.isEnableClick ? qn.svg.object.set({
          fill: this.isFocus && qn.svgColorFocus !== null ? qn.svgColorFocus : this.isHover && qn.svgColorHover !== null ? qn.svgColorHover : qn.svgColor
        }) : qn.svg.object.set({
          fill: qn.svgColorDisableClick
        });
      }
      if (this.buttonObject.container.relativePosition = {
        x: qn.x,
        y: qn.y
      }, this.buttonObject.container.object.rx = qn.borderRadius, this.buttonObject.container.object.ry = qn.borderRadius, qn.isEnableTooltip)
        switch (this.configuration.tooltipType) {
          case TooltipType.RIGHT: {
            this.tooltipRight.setPosition({
              x: Math.round(qn.x + this.getWidth()),
              y: Math.round(qn.y + this.getHeight() / 2)
            }), this.tooltipRight.setText(qn.tooltipText);
            break;
          }
          case TooltipType.BOTTOM: {
            this.tooltipBottom.setPosition(
              {
                x: Math.round(qn.x + this.getWidth()),
                y: Math.round(qn.y + this.getHeight())
              },
              this.getWidth()
            ), this.tooltipBottom.setText(qn.tooltipText);
            break;
          }
        }
      if (qn.x = Math.round(qn.x), qn.y = Math.round(qn.y), qn.text || qn.svg || qn.placeholder)
        if (qn.size === null)
          switch (qn.placeholderPosition) {
            case IPlaceholderPosition.RIGHT: {
              if (qn.padding !== "center") {
                let Jo = qn.x + qn.padding.leftRight;
                qn.svg && (qn.svg.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(this.getHeight() / 2 - qn.svg.object.getScaledHeight() / 2)
                }, Jo += qn.svg.object.width + qn.insideTextToSvg), qn.text && (this.buttonObject.text.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(this.getHeight() / 2 - this.buttonObject.text.object.height / 2)
                }, Jo += this.buttonObject.text.object.width + qn.placeholderInside), qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: qn.x + this.getWidth() - qn.padding.leftRight - this.buttonObject.placeholder.object.width,
                  y: Math.round(this.getHeight() / 2 - this.buttonObject.placeholder.object.height / 2)
                });
              } else {
                const Jo = (qn.svg ? (qn.svgScale === ScaleSvg.WIDTH ? qn.svg.object.getScaledWidth() : qn.svg.object.width) + qn.insideTextToSvg : 0) + (qn.text ? this.buttonObject.text.object.width + qn.placeholderInside : 0) + (qn.placeholder ? this.buttonObject.placeholder.object.width : 0);
                let pa = qn.x + (this.getWidth() / 2 - Jo / 2);
                qn.svg && (qn.svg.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(this.getHeight() / 2 - qn.svg.object.getScaledHeight() / 2)
                }, pa += qn.svg.object.width + qn.insideTextToSvg), qn.text && (this.buttonObject.text.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(this.getHeight() / 2 - this.buttonObject.text.object.height / 2)
                }, pa += this.buttonObject.text.object.width + qn.placeholderInside), qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(this.getHeight() / 2 - this.buttonObject.placeholder.object.height / 2)
                });
              }
              break;
            }
            case IPlaceholderPosition.LEFT: {
              if (qn.padding !== "center") {
                let Jo = qn.x + qn.padding.leftRight;
                qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(this.getHeight() / 2 - this.buttonObject.placeholder.object.height / 2)
                }, Jo += this.buttonObject.placeholder.object.width + qn.placeholderInside), qn.svg && (qn.svg.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(this.getHeight() / 2 - qn.svg.object.height / 2)
                }, Jo += qn.svg.object.width + qn.insideTextToSvg), qn.text && this.buttonObject.text.object.set({
                  left: Jo,
                  top: qn.y + Math.round(this.getHeight() / 2 - this.buttonObject.text.object.height / 2)
                });
              } else {
                const Jo = (qn.placeholder ? this.buttonObject.placeholder.object.width + qn.placeholderInside : 0) + (qn.svg ? (qn.svgScale === ScaleSvg.WIDTH ? qn.svg.object.getScaledWidth() : qn.svg.object.width) + qn.insideTextToSvg : 0) + (qn.text ? this.buttonObject.text.object.width : 0);
                let pa = qn.x + (this.getWidth() / 2 - Jo / 2);
                qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(this.getHeight() / 2 - this.buttonObject.placeholder.object.height / 2)
                }, pa += this.buttonObject.placeholder.object.width + qn.placeholderInside), qn.svg && (qn.svg.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(this.getHeight() / 2 - qn.svg.object.height / 2)
                }, pa += qn.svg.object.width + qn.insideTextToSvg), qn.text && this.buttonObject.text.object.set({
                  left: pa,
                  top: qn.y + Math.round(this.getHeight() / 2 - this.buttonObject.text.object.height / 2)
                });
              }
              break;
            }
          }
        else
          switch (qn.placeholderPosition) {
            case IPlaceholderPosition.RIGHT: {
              if (qn.padding !== "center") {
                let Jo = qn.x + qn.padding.leftRight;
                qn.svg && (qn.svg.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(
                    qn.size.height / 2 - qn.svg.object.getScaledHeight() / 2
                  )
                }, Jo += qn.svg.object.getScaledWidth() + qn.insideTextToSvg), qn.text && (this.buttonObject.text.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.text.object.height / 2)
                }, Jo += this.buttonObject.text.object.width + qn.placeholderInside), qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: qn.x + qn.size.width - qn.padding.leftRight - this.buttonObject.placeholder.object.width,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.placeholder.object.height / 2)
                });
              } else {
                const Jo = (qn.svg ? (qn.svgScale === ScaleSvg.WIDTH ? qn.svg.object.getScaledWidth() : qn.svg.object.width) + qn.insideTextToSvg : 0) + (qn.text ? this.buttonObject.text.object.width + qn.placeholderInside : 0) + (qn.placeholder ? this.buttonObject.placeholder.object.width : 0);
                let pa = qn.x + (qn.size.width / 2 - Jo / 2);
                qn.svg && (qn.svg.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(
                    qn.size.height / 2 - qn.svg.object.getScaledHeight() / 2
                  )
                }, pa += qn.svg.object.getScaledWidth() + qn.insideTextToSvg), qn.text && (this.buttonObject.text.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.text.object.height / 2)
                }, pa += this.buttonObject.text.object.width + qn.placeholderInside), qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.placeholder.object.height / 2)
                });
              }
              break;
            }
            case IPlaceholderPosition.LEFT: {
              if (qn.padding !== "center") {
                let Jo = qn.x + qn.padding.leftRight;
                qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.placeholder.object.height / 2)
                }, Jo += this.buttonObject.placeholder.object.width + qn.placeholderInside), qn.svg && (qn.svg.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(qn.size.height / 2 - qn.svg.object.height / 2)
                }, Jo += qn.svg.object.width + qn.insideTextToSvg), qn.text && (this.buttonObject.text.relativePosition = {
                  x: Jo,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.text.object.height / 2)
                });
              } else {
                const Jo = (qn.placeholder ? this.buttonObject.placeholder.object.width + qn.placeholderInside : 0) + (qn.svg ? (qn.svgScale === ScaleSvg.WIDTH ? qn.svg.object.getScaledWidth() : qn.svg.object.width) + qn.insideTextToSvg : 0) + (qn.text ? this.buttonObject.text.object.width : 0);
                let pa = qn.x + (this.getWidth() / 2 - Jo / 2);
                qn.placeholder && (this.buttonObject.placeholder.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.placeholder.object.height / 2)
                }, pa += this.buttonObject.placeholder.object.width + qn.placeholderInside), qn.svg && (qn.svg.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(qn.size.height / 2 - qn.svg.object.height / 2)
                }, pa += qn.svg.object.width + qn.insideTextToSvg), qn.text && (this.buttonObject.text.relativePosition = {
                  x: pa,
                  y: qn.y + Math.round(qn.size.height / 2 - this.buttonObject.text.object.height / 2)
                });
              }
              break;
            }
          }
      (this.configuration.fill !== qn.fill || this.configuration.borderColor !== qn.borderColor || this.configuration.borderThickness !== qn.borderThickness) && this.buttonObject.container.object.set({
        fill: qn.isEnableClick ? this.isFocus && qn.fillFocus !== null ? qn.fillFocus : this.isHover && qn.fillHover !== null ? qn.fillHover : qn.fill : qn.fill,
        stroke: qn.isEnableClick ? this.isFocus && qn.borderColorFocus !== null ? qn.borderColorFocus : this.isHover && qn.borderColorHover !== null ? qn.borderColorHover : qn.borderColor : qn.borderColor,
        strokeWidth: qn.borderThickness
      }), qn.isEnableClick || this.buttonObject.container.object.set({
        fill: qn.fill,
        stroke: qn.borderColor,
        strokeWidth: qn.borderThickness
      }), this.buttonObject.container.object.set({
        width: this.getWidth(),
        height: this.getHeight()
      }), qn.isEnableClick || (this.tooltipRight.hide(), this.tooltipBottom.hide()), this.configuration = qn;
    });
    Ca(this, "enableClickFocus", () => {
      this.configuration.isEnableFocusClick = !0;
    });
    Ca(this, "disableClickFocus", () => {
      this.configuration.isEnableFocusClick = !1;
    });
    /**
     * Метод первичного создание кнопки
     */
    Ca(this, "createButton", () => {
      const { fill: Un, borderColor: Kn, borderThickness: qn, x: Jo, y: pa, text: ma, textColor: va, borderRadius: ba, textFontSize: _a, textFontFamily: ya } = this.configuration, xa = new Xo(ma || "", {
        fill: va,
        fontSize: _a,
        fontFamily: ya
      }), wa = new pr({
        left: Jo,
        top: pa,
        fill: Un,
        stroke: Kn,
        strokeWidth: qn,
        rx: ba,
        ry: ba
      }), Ta = new Xo("", {});
      return {
        container: {
          object: wa,
          relativePosition: { x: 0, y: 0 }
        },
        text: {
          object: xa,
          relativePosition: { x: 0, y: 0 }
        },
        placeholder: {
          object: Ta,
          relativePosition: { x: 0, y: 0 }
        }
      };
    });
    this.configuration = {
      borderRadius: this.DEFAULT_BORDER_RADIUS,
      fill: this.DEFAULT_FILL,
      fillHover: this.DEFAULT_FILL_HOVER,
      fillFocus: null,
      borderColor: this.DEFAULT_BORDER_COLOR,
      borderColorHover: this.DEFAULT_BORDER_COLOR_HOVER,
      borderColorFocus: null,
      borderThickness: this.DEFAULT_BORDER_THICKNESS,
      x: 0,
      y: 0,
      padding: this.DEFAULT_PADDING,
      text: null,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE,
      textFontFamily: this.DEFAULT_TEXT_FONT,
      textColor: this.DEFAULT_SVG_COLOR,
      textColorHover: this.DEFAULT_COLOR_HOVER_SVG,
      textColorFocus: null,
      durationHover: this.DEFAULT_DURATION_HOVER,
      durationFocus: this.DEFAULT_DURATION_FOCUS,
      tooltipText: this.DEFAULT_TOOLTIP_TEXT,
      isEnableTooltip: this.DEFAULT_TOOLTIP_ENABLE,
      tooltipType: this.DEFAULT_TOOLTIP_TYPE,
      svg: null,
      svgScale: ScaleSvg.WIDTH,
      svgColor: UIDefaultColor.GRAY_600,
      svgColorHover: null,
      svgColorFocus: null,
      insideTextToSvg: this.DEFAULT_INSIDE_TEXT_TO_SVG,
      svgSize: null,
      size: null,
      placeholder: null,
      placeholderInside: 10,
      placeholderColor: UIDefaultColor.GRAY_600,
      placeholderPosition: IPlaceholderPosition.RIGHT,
      isEnableClick: !0,
      svgColorDisableClick: UIDefaultColor.GRAY_50,
      isEnableFocusClick: !1,
      isDisableFocusClick: !0
    }, this.buttonObject = this.createButton(), this.tooltipRight = new ToolTipRight(), this.tooltipBottom = new ToolTipBottom(), this.tooltipRight.setText(this.configuration.tooltipText), this.tooltipBottom.setText(this.configuration.tooltipText), this.isVisible = !0, this.isHover = !1, this.isFocus = !1, this.isResetFocus = !0;
  }
}
class BaseUIButton extends BaseUIButtonView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "postMouseDownListeners");
    Ca(this, "postMouseUpListeners");
    Ca(this, "prevMouseDownListeners");
    Ca(this, "prevMouseUpListeners");
    Ca(this, "enableFocusListeners");
    Ca(this, "disableFocusListeners");
    Ca(this, "getSpatialArea", () => (this.area === null && (this.area = new SpatialUIButtonArea(this), this.area.markDirty()), this.area));
    Ca(this, "enableFocus", () => {
      if (this.isFocus || (this.isFocus = !0, !this.configuration.isEnableClick))
        return;
      const {
        fill: Un,
        fillHover: Kn,
        fillFocus: qn,
        borderColor: Jo,
        borderColorHover: pa,
        borderColorFocus: ma,
        textColor: va,
        textColorHover: ba,
        textColorFocus: _a,
        svgColor: ya,
        svgColorHover: xa,
        svgColorFocus: wa
      } = this.configuration, Ta = [];
      this.isHover ? (qn !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: Kn ?? Un,
        endColor: qn,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), ma !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: pa ?? Jo,
        endColor: ma,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.STROKE
      }), _a !== null && Ta.push({
        object: this.buttonObject.text.object,
        startColor: ba ?? va,
        endColor: _a,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), this.configuration.svg && wa !== null && Ta.push({
        object: this.configuration.svg.object,
        startColor: xa ?? ya,
        endColor: wa,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      })) : (qn !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: Un,
        endColor: qn,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), ma !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: Jo,
        endColor: ma,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.STROKE
      }), _a !== null && Ta.push({
        object: this.buttonObject.text.object,
        startColor: va,
        endColor: _a,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), this.configuration.svg && wa !== null && Ta.push({
        object: this.configuration.svg.object,
        startColor: ya,
        endColor: wa,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      })), this.dependencies.render.animateColor(...Ta), this.callEnableFocusListeners();
    });
    Ca(this, "disableFocus", () => {
      if (!this.isFocus || (this.isFocus = !1, !this.configuration.isEnableClick))
        return;
      const {
        fill: Un,
        fillHover: Kn,
        fillFocus: qn,
        borderColor: Jo,
        borderColorHover: pa,
        borderColorFocus: ma,
        textColor: va,
        textColorHover: ba,
        textColorFocus: _a,
        svgColor: ya,
        svgColorHover: xa,
        svgColorFocus: wa
      } = this.configuration, Ta = [];
      this.isHover ? (Kn !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: qn ?? Un,
        endColor: Kn,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), pa !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: ma ?? Jo,
        endColor: pa,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.STROKE
      }), ba !== null && Ta.push({
        object: this.buttonObject.text.object,
        startColor: _a ?? va,
        endColor: ba,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), this.configuration.svg && xa && Ta.push({
        object: this.configuration.svg.object,
        startColor: wa ?? ya,
        endColor: xa,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      })) : (qn !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: qn,
        endColor: Un,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), ma !== null && Ta.push({
        object: this.buttonObject.container.object,
        startColor: ma,
        endColor: Jo,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.STROKE
      }), _a !== null && Ta.push({
        object: this.buttonObject.text.object,
        startColor: _a,
        endColor: va,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      }), this.configuration.svg && wa && Ta.push({
        object: this.configuration.svg.object,
        startColor: wa,
        endColor: ya,
        duration: this.DEFAULT_DURATION_HOVER,
        type: TypeColorAnimated.FILL
      })), this.dependencies.render.animateColor(...Ta), this.callDisableFocusListeners();
    });
    Ca(this, "addEnableFocusListeners", (...Un) => {
      this.enableFocusListeners.push(...Un);
    });
    Ca(this, "addDisableFocusListeners", (...Un) => {
      this.disableFocusListeners.push(...Un);
    });
    Ca(this, "addPostMouseDownListeners", (...Un) => {
      this.postMouseDownListeners.push(...Un);
    });
    Ca(this, "addPrevMouseDownListeners", (...Un) => {
      this.prevMouseDownListeners.push(...Un);
    });
    Ca(this, "callClick", () => {
      this.configuration.isEnableClick && (this.prevMouseDownListeners.forEach((Un) => Un()), this.onClick(), this.postMouseDownListeners.forEach((Un) => Un()));
    });
    Ca(this, "getUIElements", () => []);
    Ca(this, "onClick", () => {
      if (this.isFocus && this.configuration.isDisableFocusClick) {
        this.disableFocus();
        return;
      }
      this.configuration.isEnableFocusClick && this.enableFocus();
    });
    Ca(this, "callEnableFocusListeners", () => {
      this.enableFocusListeners.forEach((Un) => Un());
    });
    Ca(this, "callDisableFocusListeners", () => {
      this.disableFocusListeners.forEach((Un) => Un());
    });
    this.area = null, this.postMouseDownListeners = [], this.postMouseUpListeners = [], this.prevMouseDownListeners = [], this.prevMouseUpListeners = [], this.enableFocusListeners = [], this.disableFocusListeners = [];
  }
}
class ObjectCornerRadiusButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Изменить радиус углов");
    this.setConfiguration((Un) => ({
      ...Un,
      tooltipType: TooltipType.BOTTOM,
      tooltipText: this.TOOLTIP_TEXT,
      isEnableTooltip: !0,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.CORNER_RADIUS_ALL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 18,
      text: null,
      borderColor: UIDefaultColor.WHITE,
      svgColor: UIDefaultColor.GRAY_600,
      fillHover: null,
      borderColorHover: UIDefaultColor.GRAY_600,
      svgColorHover: UIDefaultColor.GRAY_600,
      size: {
        width: 32,
        height: 32
      },
      padding: "center",
      borderRadius: 2,
      insideTextToSvg: 0
    })), this.hide(), this.enableClickFocus(), this.addPostInjectDependenciesListener((Un) => {
      this.addDisableFocusListeners(() => {
        Un.editCornerObject.hide();
      }), this.addEnableFocusListeners(() => {
        Un.editCornerObject.setConfiguration((Kn) => ({
          ...Kn,
          x: this.getGlobalPosition().x,
          y: this.getGlobalPosition().y + this.getHeight()
        })), Un.render.render(), Un.editCornerObject.show();
      });
    });
  }
}
class TopRenameButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: null,
      borderColorFocus: null,
      fillHover: null,
      fillFocus: null,
      svgColor: UIDefaultColor.GRAY_600,
      svgColorHover: null,
      svgColorFocus: UIDefaultColor.BLUE_900,
      text: null,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.EDIT),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 24,
      padding: {
        topBottom: 5,
        leftRight: 0
      }
    })), this.enableClickFocus(), this.addPostInjectDependenciesListener((zn) => {
      this.addEnableFocusListeners(() => {
        zn.textInput.enableFocus();
      }), this.addDisableFocusListeners(() => {
        zn.textInput.disableFocus();
      });
    });
  }
}
class TextInput extends BaseInput {
  constructor() {
    super();
    Ca(this, "DEFAULT_MAX_TEXT_LENGTH", 60);
    Ca(this, "setMaxLength", (Un) => {
      this.textModel.setMaxTextLength(Un);
    });
    Ca(this, "getValue", () => this.textModel.getText());
    Ca(this, "setValue", (Un) => {
      this.textModel.setTexture({
        textAlign: TextAlign.LEFT,
        lineHeight: LineHeight.MEDIUM,
        splitGraphemePositions: [0],
        tokens: [
          {
            type: TokenType.PARAGRAPH,
            fontFamily: FontFamily.DEFAULT,
            color: UIDefaultColor.BLACK,
            fontSize: this.configuration.textFontSize,
            format: TokenFormat.None,
            value: Un
          }
        ],
        id: Utils.generate.uuid4()
      }), this.textModel.syncModelWithViews();
    });
    this.textModel.setMaxTextLength(this.DEFAULT_MAX_TEXT_LENGTH), this.textModel.syncModelWithViews();
  }
}
class TopTitleInput extends TextInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.WHITE,
      fillFocus: UIDefaultColor.BLUE_300,
      textFontSize: FontSize.Pt12
    })), this.hide(), this.disableFixedWidth(), this.setTextAlign(TextAlign.CENTER), this.addPostInjectDependenciesListener((zn) => {
      this.addEnableFocusListeners(() => {
        zn.topRenameButton.enableFocus();
      }), this.addDisableFocusListeners(() => {
        zn.topRenameButton.disableFocus();
      }), this.addPostChangeTextListener(async () => {
        await zn.actionController.executeUserAction(async () => {
          zn.onSetNameTemplate(this.getValue());
        });
      });
    });
  }
}
class CellSelectionObserver extends Dependent {
  constructor() {
    super();
    // Дополнительный сдвиг области для захвата инициирующей ячейки в фокус
    Ca(this, "AREA_EXTEND_OFFSET", 1);
    Ca(this, "blindZoneDetector");
    Ca(this, "isMoveRun");
    Ca(this, "initiatorCellFrame");
    Ca(this, "startFocusCell");
    Ca(this, "initiatorArea");
    Ca(this, "start", (Un) => {
      this.isMoveRun = !0, this.initiatorArea = Un, this.blindZoneDetector.start(), this.initiatorCellFrame = Un.getGlobalFrameArea();
    });
    Ca(this, "move", (Un, Kn, qn) => {
      if (!this.isMoveRun || !this.initiatorArea || qn === null || qn.type !== SpatialCanvasAreaType.TABLE_CELL || this.initiatorCellFrame === null)
        return;
      const Jo = this.initiatorArea.getData();
      if (Jo.areaCellContext === qn.getData().areaCellContext) {
        Jo.component.getCellContexts().forEach((wa) => {
          wa !== Jo.areaCellContext && wa.disableFocus();
        });
        return;
      }
      if (this.blindZoneDetector.appendOffsets({
        x: Un,
        y: Kn
      }), !this.blindZoneDetector.isBlindZoneOverstepping())
        return;
      this.startFocusCell === null && (this.startFocusCell = Jo.areaCellContext), Jo.component.setActiveEditCellContext(Jo.areaCellContext);
      const pa = {
        height: 0,
        width: 0,
        x: 0,
        y: 0,
        rotate: 0
      }, ma = this.dependencies.mousePositionObserver.getCurrentPosition();
      pa.x = Math.min(ma.x, this.initiatorCellFrame.x), pa.y = Math.min(ma.y, this.initiatorCellFrame.y), pa.width = Math.abs(ma.x - this.initiatorCellFrame.x) + this.AREA_EXTEND_OFFSET, pa.height = Math.abs(ma.y - this.initiatorCellFrame.y) + this.AREA_EXTEND_OFFSET;
      const ba = Jo.component.getCellSpatialAreas().filter((xa) => Utils.geometry.intersectArea(xa.getGlobalFrameArea(), pa) !== 0), _a = new Set(ba.map((xa) => xa.getData().areaCellContext));
      Jo.component.getCellContexts().forEach((xa) => {
        if (_a.has(xa)) {
          xa.enableFocus();
          return;
        }
        xa.disableFocus();
      });
    });
    Ca(this, "stop", async () => {
      if (this.isMoveRun) {
        if (this.isMoveRun = !1, this.initiatorArea === null)
          throw new EditorError("initiator area is null");
        if (this.blindZoneDetector.isBlindZoneOverstepping())
          await this.dependencies.textEngine.disableAllModels();
        else {
          const Un = this.initiatorArea.getData(), Kn = Un.component.getCellContexts();
          this.startFocusCell === null ? await this.enableCellFocusOnly(Kn, Un.areaCellContext) : await this.enableCellFocusOnly(Kn, this.startFocusCell);
        }
        this.startFocusCell = null, this.initiatorArea = null, this.blindZoneDetector.stop();
      }
    });
    Ca(this, "enableCellFocusOnly", (Un, Kn) => {
      Un.forEach((qn) => {
        if (qn === Kn) {
          qn.enableFocus();
          return;
        }
        qn.hasFocus() && qn.disableFocus();
      }), this.dependencies.textEngine.disableModelsExcept(Kn), this.dependencies.textEngine.isModelInEditMode(Kn) || this.dependencies.textEngine.enableModelEditMode(Kn), this.initiatorArea !== null && (this.initiatorArea.getData().component.setActiveEditCellContext(Kn), Kn.enableCarriage());
    });
    this.isMoveRun = !1, this.initiatorArea = null, this.startFocusCell = null, this.initiatorCellFrame = null, this.blindZoneDetector = new BlindZoneDetector();
  }
}
class AreaSizeMutator extends AreaMutator {
  constructor() {
    super(AreaMutationEventType.SIZE);
    Ca(this, "postStartEvent", (Un) => {
      const Kn = Un[0];
      if (Kn === void 0)
        throw new EditorError("the area not found");
      this.activeTrigger = Kn.getTrigger();
    });
    Ca(this, "postStopEvent", () => {
      this.activeTrigger = null;
    });
    Ca(this, "getActiveTrigger", () => this.activeTrigger);
    /** Определить область, которая изменяется и установить соответствующие значения, сохраняя
     * соотношения сторон фрейма.
     *
     * @param currentValues
     * @param entity
     */
    Ca(this, "correctAspectRatioValues", (Un, Kn) => {
      const qn = { ...Un }, Jo = this.getActiveTrigger();
      if (qn.height !== 0 && (Jo === AreaResizeTrigger.TOP || Jo === AreaResizeTrigger.BOTTOM) && (qn.width = qn.height * Kn.aspectRatio, qn.x -= (qn.width - Kn.initialFrameArea.width) / 2), qn.width !== 0) {
        if ((Jo === AreaResizeTrigger.LEFT || Jo === AreaResizeTrigger.RIGHT) && (qn.height = qn.width / Kn.aspectRatio, qn.y -= (qn.height - Kn.initialFrameArea.height) / 2), Jo === AreaResizeTrigger.RIGHT_TOP || Jo === AreaResizeTrigger.LEFT_TOP) {
          const pa = qn.height;
          qn.height = qn.width / Kn.aspectRatio, qn.y += pa - qn.height;
        }
        (Jo === AreaResizeTrigger.RIGHT_BOTTOM || Jo === AreaResizeTrigger.LEFT_BOTTOM) && (qn.height = qn.width / Kn.aspectRatio);
      }
      return qn;
    });
    Ca(this, "updateOffsets", (Un, Kn) => {
      if (this.activeTrigger !== null) {
        if (this.absoluteAreaOffsets === null)
          throw new EditorError("offsets not initialize");
        switch (this.activeTrigger) {
          case AreaResizeTrigger.LEFT: {
            this.absoluteAreaOffsets.x += Un, this.absoluteAreaOffsets.width -= Un;
            break;
          }
          case AreaResizeTrigger.TOP: {
            this.absoluteAreaOffsets.y += Kn, this.absoluteAreaOffsets.height -= Kn;
            break;
          }
          case AreaResizeTrigger.RIGHT: {
            this.absoluteAreaOffsets.width += Un;
            break;
          }
          case AreaResizeTrigger.BOTTOM: {
            this.absoluteAreaOffsets.height += Kn;
            break;
          }
          case AreaResizeTrigger.RIGHT_TOP: {
            this.absoluteAreaOffsets.y += Kn, this.absoluteAreaOffsets.width += Un, this.absoluteAreaOffsets.height -= Kn;
            break;
          }
          case AreaResizeTrigger.RIGHT_BOTTOM: {
            this.absoluteAreaOffsets.width += Un, this.absoluteAreaOffsets.height += Kn;
            break;
          }
          case AreaResizeTrigger.LEFT_TOP: {
            this.absoluteAreaOffsets.x += Un, this.absoluteAreaOffsets.width -= Un, this.absoluteAreaOffsets.y += Kn, this.absoluteAreaOffsets.height -= Kn;
            break;
          }
          case AreaResizeTrigger.LEFT_BOTTOM: {
            this.absoluteAreaOffsets.x += Un, this.absoluteAreaOffsets.width -= Un, this.absoluteAreaOffsets.height += Kn;
            break;
          }
          default:
            throw new EditorError(`mutate trigger "${this.activeTrigger}" not found, mutate impossible`);
        }
      }
    });
    Ca(this, "getMutationEventBody", () => ({
      trigger: this.activeTrigger
    }));
    this.activeTrigger = null, this.disableBlindMode();
  }
}
class AreaTableColumnMutator extends AreaMutator {
  constructor() {
    super(AreaMutationEventType.COLUMN);
    Ca(this, "updateOffsets", (Un, Kn) => {
      this.absoluteAreaOffsets !== null && (this.absoluteAreaOffsets.x += Un);
    });
    Ca(this, "postStartEvent", (Un) => {
    });
    Ca(this, "postStopEvent", () => {
    });
    Ca(this, "getMutationEventBody", () => ({}));
    Ca(this, "correctAspectRatioValues", (Un, Kn) => Un);
    this.disableBlindMode();
  }
}
class SpatialAreaTypeAnalyzer {
  constructor() {
    Ca(this, "spatialUIAreaTypes", new Set(Object.values(SpatialUIAreaType)));
    Ca(this, "spatialCanvasAreaTypes", new Set(Object.values(SpatialCanvasAreaType)));
  }
  isSpatialUIAreaType(zn) {
    return this.spatialUIAreaTypes.has(zn);
  }
  isSpatialCanvasAreaType(zn) {
    return this.spatialCanvasAreaTypes.has(zn);
  }
}
class Cursor extends Dependent {
  constructor() {
    super();
    Ca(this, "areaSizeMutator");
    Ca(this, "areaTypeAnalyzer");
    Ca(this, "tableColumnMutator");
    Ca(this, "cellSelectionObserver");
    Ca(this, "destruct", () => {
      this.dependencies.editorContainer.removeEventListener("mousedown", this.coordinateMouseDown), this.dependencies.editorContainer.removeEventListener("mouseup", this.coordinateMouseUp), this.dependencies.editorContainer.removeEventListener("dblclick", this.coordinateDoubleCLick);
    });
    Ca(this, "coordinateMouseDown", (Un) => {
      switch (Un.button) {
        case 0:
          this.onMouseLeftDown(Un);
          break;
        case 1:
          this.onMouseCenterDown(Un);
          break;
        case 2:
          this.onMouseRightDown(Un);
          break;
        default:
          console.warn(`Неизвестная кнопка мыши: ${Un.button}`);
      }
    });
    Ca(this, "coordinateDoubleCLick", (Un) => {
      this.onDoubleClick(Un);
    });
    Ca(this, "coordinateMouseUp", async (Un) => {
      switch (Un.button) {
        case 0:
          await this.onMouseLeftUp(Un);
          break;
        case 1:
          this.onMouseCenterUp(Un);
          break;
        case 2:
          this.onMouseRightUp(Un);
          break;
        default:
          console.warn(`Неизвестная кнопка мыши при отпускании: ${Un.button}`);
      }
    });
    this.areaSizeMutator = new AreaSizeMutator(), this.areaTypeAnalyzer = new SpatialAreaTypeAnalyzer(), this.cellSelectionObserver = new CellSelectionObserver(), this.tableColumnMutator = new AreaTableColumnMutator(), this.addPostInjectDependenciesListener((Un) => {
      Un.editorContainer.addEventListener(
        "contextmenu",
        (Kn) => {
          Kn.preventDefault();
        },
        !0
      ), Un.editorContainer.addEventListener("mousedown", this.coordinateMouseDown), Un.editorContainer.addEventListener("mouseup", this.coordinateMouseUp), Un.editorContainer.addEventListener("dblclick", this.coordinateDoubleCLick), this.cellSelectionObserver.connectDependencies({
        mousePositionObserver: Un.canvasMouseObserver,
        textEngine: Un.textEngine
      }), Un.canvasMouseObserver.subscribeToOffset(this.onMouseMove), this.cellSelectionObserver.injectDependencies();
    });
  }
}
var MouseEventType = /* @__PURE__ */ ((Xn) => (Xn.CLICK = "click", Xn.DOUBLE_CLICK = "dblclick", Xn.MOUSE_DOWN = "mousedown", Xn))(MouseEventType || {});
class PrivateTemplateCursor extends Cursor {
  constructor() {
    super();
    Ca(this, "magneticPositionCorrector");
    Ca(this, "areaPositionMutator");
    Ca(this, "magneticSizeCorrector");
    Ca(this, "onMouseMove", async (Un, Kn) => {
      const qn = this.dependencies.componentTree.getComponents();
      await this.dependencies.areaController.sync();
      const Jo = this.dependencies.areaController.getActiveArea();
      this.syncHover(Jo, qn), this.isRunningMutationComponent() ? this.dependencies.cursorView.setActiveArea(null) : this.dependencies.cursorView.setActiveArea(Jo), await this.areaSizeMutator.mutate(Un, Kn), await this.tableColumnMutator.mutate(Un, Kn), await this.areaPositionMutator.mutate(Un, Kn), this.cellSelectionObserver.move(Un, Kn, Jo), this.dependencies.textSelectionObserver.move(Un, Kn), this.dependencies.render.renderUnstructured();
    });
    Ca(this, "onMouseLeftDown", async (Un) => {
      if (this.dependencies.componentInjector.isInjecting()) {
        if (!this.dependencies.componentInjector.isReadyInject()) {
          this.dependencies.componentInjector.onMouseDown(), this.dependencies.contextMenu.hide();
          return;
        }
        await this.dependencies.componentInjector.inject(), this.dependencies.contextMenu.hide();
        return;
      }
      const qn = this.dependencies.componentTree.getComponents(), Jo = this.dependencies.canvasMouseObserver.getCurrentPosition();
      await this.dependencies.areaController.sync();
      const pa = this.dependencies.areaController.getActiveArea();
      if (this.syncFocusMouseDown(pa, Un), this.syncEditMode(pa, qn, Un), await this.dependencies.ui.sync(), pa === null) {
        this.dependencies.componentTree.hasEditableOrFocusComponent() || this.dependencies.selectionArea.start(Jo), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.isResizeType()) {
        this.areaSizeMutator.start(pa), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.type === SpatialCanvasAreaType.TABLE_COLUMN_RESIZE) {
        this.tableColumnMutator.start(pa), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.type === SpatialCanvasAreaType.TABLE_CELL && this.cellSelectionObserver.start(pa), this.areaTypeAnalyzer.isSpatialUIAreaType(pa.type)) {
        const ma = pa.getData();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
        if (pa.type === SpatialUIAreaType.COLOREX_COLOR)
          pa.callClick();
        else if (pa.type === SpatialUIAreaType.INPUT) {
          ma.callClick();
          const va = this.dependencies.uiMouseObserver.getCurrentPosition(), ba = ma.getGlobalPosition();
          this.dependencies.carriageCoordinator.pounceToMouse(ma, ma, ba, va), this.dependencies.textSelectionObserver.start([pa], ma.getTextModel(), va);
        } else
          ma.callClick();
        this.dependencies.contextMenu.hide();
      } else if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(pa.type)) {
        const ma = pa.getData();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
        const va = ma.graphic.type;
        if (pa.type === SpatialCanvasAreaType.BUTTON && pa.getButton().callClick(), va === GraphicType.PAGE && pa.type !== SpatialCanvasAreaType.BUTTON && this.areaPositionMutator.startMoveComponents(pa, [this.dependencies.componentTree.getRootComponent()]), va === GraphicType.TEXT && ma.graphic.isEnableEditMode()) {
          const _a = ma.graphic.getGlobalPosition();
          this.dependencies.carriageCoordinator.pounceToMouse(
            ma.graphic.getParentComponent(),
            ma.graphic,
            _a,
            Jo
          );
          const ya = ma.graphic.getParentComponent();
          if (ya === null)
            throw this.dependencies.contextMenu.hide(), new EditorError("component is null");
          const wa = ya.getGraphics().map((Ta) => new SpatialGraphicArea(Ta));
          this.dependencies.textSelectionObserver.start(wa, ya.getTextModel(), Jo);
        }
        if (pa.type === SpatialCanvasAreaType.TABLE_CELL && ma.graphic.isEnableEditMode()) {
          const _a = ma.graphic.getGlobalPosition(), xa = pa.getData();
          this.dependencies.carriageCoordinator.pounceToMouse(
            ma.areaCellContext,
            ma.areaCell,
            _a,
            Jo
          );
          const wa = xa.component.getSpatialAreas().filter(
            (Sa) => Sa.type === SpatialCanvasAreaType.TABLE_CELL && Sa.getData().areaCellContext === ma.areaCellContext
          ), Ta = xa.areaCellContext.getTextModel();
          wa.length !== 0 && this.dependencies.textSelectionObserver.start(wa, Ta, Jo);
        }
        const ba = this.dependencies.componentTree.getFocusComponents();
        if (ba === null) {
          this.dependencies.contextMenu.hide();
          return;
        }
        pa.type !== SpatialCanvasAreaType.BUTTON && (!ma.graphic.isEnableEditMode() || pa.type === SpatialCanvasAreaType.PICTURE) && this.areaPositionMutator.startMoveComponents(pa, ba), this.dependencies.contextMenu.hide();
      }
    });
    Ca(this, "onMouseLeftUp", async (Un) => {
      const Kn = this.dependencies.areaController.getActiveArea();
      await this.dependencies.componentInjector.onMouseUp(), this.dependencies.textSelectionObserver.stop(), this.syncFocusMouseUp(Kn, Un), this.areaSizeMutator.stop(), this.tableColumnMutator.stop(), this.areaPositionMutator.stop(), await this.cellSelectionObserver.stop(), this.dependencies.selectionArea.stop(), await this.dependencies.componentOrganizer.sync(), await this.dependencies.areaController.sync(), await this.dependencies.ui.sync();
    });
    Ca(this, "onMouseRightDown", (Un) => {
      Un.preventDefault(), this.dependencies.contextMenu.show();
    });
    // TODO Доделать
    /**
     * Обновляет эффекты наведения на компоненты в зависимости от положения курсора.
     */
    Ca(this, "syncHover", (Un, Kn) => {
      if (Un === null) {
        this.dependencies.ui.getUIElementsAll().forEach((Jo) => {
          Jo.disableHover();
        }), Kn == null || Kn.forEach((Jo) => {
          Jo.disableHover(), Jo.type === EditorComponentType.BOOK && Jo.getGraphics().forEach((ma) => {
            ma.pageHeaderDisableHover();
          });
        });
        return;
      }
      if (this.isRunningMutationComponent()) {
        Kn == null || Kn.forEach((qn) => {
          qn.disableHover();
        });
        return;
      }
      if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
        const qn = Un;
        if (qn.type === SpatialCanvasAreaType.BUTTON) {
          Un.getButton().enableHover();
          return;
        }
        const pa = qn.getData().graphic.getParentComponent();
        if (pa === null)
          throw new EditorError("crossed component not found");
        if (Kn === null)
          throw new EditorError("components is null");
        if (pa.type !== EditorComponentType.BOOK) {
          const ma = pa.getParentComponent();
          if (ma === null)
            throw new EditorError("parent component not found");
          if (ma.isUniter && this.dependencies.keyboardObserver.isPressed(KeyCode.CONTROL_LEFT)) {
            Kn.forEach((va) => {
              if (va === ma) {
                va.enableHover();
                return;
              }
              va.disableHover();
            });
            return;
          }
        }
        Kn.forEach((ma) => {
          if (ma === pa) {
            ma.enableHover();
            return;
          }
          ma.disableHover();
        });
      } else if (this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) {
        Kn == null || Kn.forEach((ma) => {
          ma.disableHover(), ma.type === EditorComponentType.BOOK && ma.getGraphics().forEach((ba) => {
            ba.pageHeaderDisableHover();
          });
        });
        const Jo = Un.getData();
        this.dependencies.ui.getUIElementsAll().forEach((ma) => {
          if (ma === Jo) {
            ma.enableHover();
            return;
          }
          ma.disableHover();
        });
      } else
        throw new EditorError("spatial area type not identity");
    });
    /**
     * Отключает фокус у компонентов в фокусе.
     * @param ev Событие мыши.
     */
    Ca(this, "disableFocusComponents", (Un) => {
      const Kn = this.dependencies.componentTree.getFocusComponents();
      Kn == null || Kn.forEach((qn) => {
        Un.altKey || Un.metaKey || qn.disableFocus();
      });
    });
    /**
     * Отключает фокус у компонентов в фокусе и оставляет фокус у компонентов у которых должен остатьтся фокус.
     * @param activeArea
     */
    Ca(this, "disableFocusUIElements", (Un) => {
      this.dependencies.ui.getFocusUIElements().forEach((qn) => {
        this.shouldKeepFocus(qn, Un) || qn.disableFocus();
      });
    });
    /**
     * Проверяет должен ли отключится фокус у элемента.
     * @param element
     * @param activeArea
     */
    Ca(this, "shouldKeepFocus", (Un, Kn) => {
      if (!Un.isEnableResetFocus())
        return !0;
      if (Kn === null)
        return !Un.isEnableResetFocus();
      const qn = Kn.getData(), { type: Jo } = Kn;
      return qn instanceof TopTitleInput && (Un instanceof TopTitleInput || Un instanceof TopRenameButton) || qn instanceof TopRenameButton && (Un instanceof TopTitleInput || Un instanceof TopRenameButton) || (qn instanceof LeftBottomInput || qn instanceof LeftTopInput || qn instanceof RightBottomInput || qn instanceof RightTopInput) && Un instanceof ObjectCornerRadiusButton || qn === Un || Jo === SpatialUIAreaType.EDIT_CORNER ? !0 : Jo === SpatialUIAreaType.PALETTE || Jo === SpatialUIAreaType.COLOREX_COLOR;
    });
    /**
     * Синхронизирует фокус компонентов при отжатии кнопки мыши.
     * @param activeArea
     * @param ev
     */
    Ca(this, "syncFocusMouseUp", (Un, Kn) => {
      if (Un !== null) {
        if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
          const pa = Un.getData().graphic.getParentComponent();
          if (pa === null)
            return;
          if (this.areaPositionMutator.isRunningMutate() && !this.areaPositionMutator.isBlindZoneOverstepping()) {
            const ma = this.dependencies.componentTree.getFocusComponents();
            ma !== null && ma.forEach((va) => {
              Kn.altKey || Kn.metaKey || va !== pa && va.disableFocus();
            });
          }
        } else if (!this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) throw new EditorError("spatial area type not identity");
      }
    });
    /**
     * Обновляет состояния режима редактирования у компонентов.
     */
    Ca(this, "syncEditMode", (Un, Kn, qn) => {
      if (Un === null) {
        Kn.forEach((Jo) => Jo.disableEditMode());
        return;
      }
      if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
        const Jo = Un, ma = Jo.getData().graphic.getParentComponent();
        if (ma === null || Jo.type === SpatialCanvasAreaType.BUTTON)
          return;
        if (ma && qn.type === MouseEventType.DOUBLE_CLICK) {
          ma.enableEditMode(), ma.isUniter && this.dependencies.editModeContext.setCurrentEditContext(ma);
          return;
        }
        if (qn.type === MouseEventType.MOUSE_DOWN) {
          let va = this.dependencies.editModeContext.getCurrentEditContext();
          va && (!ma || !va.isIncludeComponent(ma)) && (this.dependencies.editModeContext.setCurrentEditContext(null), va = null), Kn.forEach((ba) => {
            ba !== va && ba !== ma && ba.disableEditMode();
          });
        }
      } else if (!this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) throw new EditorError("spatial area type not identity");
    });
    /**
     * Обработчик события двойного нажатия мыши.
     * @param ev Событие мыши.
     */
    Ca(this, "onDoubleClick", (Un) => {
      const Kn = this.dependencies.componentTree.getComponents(), qn = this.dependencies.areaController.getActiveArea();
      if (this.syncEditMode(qn, Kn, Un), qn === null)
        return;
      const Jo = qn.getData();
      if (Jo === null)
        throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
      if (Jo.graphic.type === GraphicType.TEXT && Jo.graphic.isEnableEditMode()) {
        const ma = Jo.graphic.getParentComponent();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("component is null");
        this.dependencies.textSelectionObserver.selectWordToCarriagePosition(ma.getTextModel());
      }
    });
    /**
     * Обработчик события начала отрисовки магнитных линий.
     * @param props
     */
    Ca(this, "onStartMagneticLines", (Un) => {
      this.dependencies.componentTree.hasEditableComponent() || (this.dependencies.magneticLines.start(Un), this.dependencies.render.render());
    });
    /**
     * Возвращает происходит ли в данные момент мутация какого либо компонента.
     */
    Ca(this, "isRunningMutationComponent", () => !!(this.areaPositionMutator.isRunningMutate() || this.areaSizeMutator.isRunningMutate() || this.tableColumnMutator.isRunningMutate()));
    this.magneticPositionCorrector = new MagneticPositionCorrector(), this.areaPositionMutator = new AreaPositionWithCloneMutator(), this.magneticSizeCorrector = new MagneticSizeCorrector(), this.addPostInjectDependenciesListener((Un) => {
      this.tableColumnMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.tableColumnMutator.addStopMutationListener(this.dependencies.componentOrganizer.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.areaController.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.tableColumnMutator.addPostMutationListener(this.dependencies.render.renderRelativePositions), this.areaPositionMutator.addStartMutationListener(this.onStartMagneticLines), this.areaPositionMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.areaPositionMutator.addPrevMutationListener(this.magneticPositionCorrector.move), this.areaPositionMutator.addPostMutationListener(Un.render.renderRelativePositions), this.areaPositionMutator.addStopMutationListener(Un.magneticLines.stop), this.areaPositionMutator.addStopMutationListener(this.dependencies.pageTextOverflowObserver.sync), this.areaPositionMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.areaPositionMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.areaSizeMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.areaSizeMutator.addStartMutationListener(this.onStartMagneticLines), this.areaSizeMutator.addPrevMutationListener(this.magneticSizeCorrector.move), this.areaSizeMutator.addStopMutationListener(Un.magneticLines.stop), this.areaSizeMutator.addPostMutationListener(Un.ui.sync), this.areaSizeMutator.addPostMutationListener(Un.render.renderRelativePositions), this.areaSizeMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.areaSizeMutator.addStopMutationListener(this.dependencies.pageTextOverflowObserver.sync), this.areaSizeMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.areaPositionMutator.forceInjectDependencies({
        fnClone: Un.useCases.cloneWithAlt,
        keyboardObserver: Un.keyboardObserver
      }), this.magneticPositionCorrector.forceInjectDependencies({
        mutator: this.areaPositionMutator,
        magneticLines: Un.magneticLines
      }), this.magneticSizeCorrector.forceInjectDependencies({
        mutator: this.areaSizeMutator,
        magneticLines: Un.magneticLines
      });
    });
  }
  onMouseCenterDown(Un) {
  }
  onMouseCenterUp(Un) {
  }
  onMouseRightUp(Un) {
  }
  /**
   * Обновляет эффекты фокуса на компонентах.
   */
  syncFocusMouseDown(Un, Kn) {
    if (Un === null) {
      this.disableFocusComponents(Kn), this.disableFocusUIElements(Un);
      return;
    }
    if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
      this.disableFocusUIElements(null);
      const pa = Un.getData().graphic.getParentComponent();
      if (pa === null || pa.type === EditorComponentType.BOOK) {
        this.disableFocusComponents(Kn);
        return;
      }
      !pa.isEnableFocus() && this.disableFocusComponents(Kn);
      const va = pa.getParentComponent();
      if (va != null && va.isUniter && va.isEnableEditMode()) {
        const ba = va.getComponents();
        if (!ba)
          return;
        ba.forEach((_a) => {
          var ya;
          _a.type === EditorComponentType.TABLE && ((ya = _a.getFocusCellContexts()) == null || ya.forEach((xa) => {
            xa.disableFocus();
          })), _a.disableFocus();
        }), pa.enableFocus();
        return;
      }
      if (pa.isUniter && pa.isEnableEditMode()) {
        const ba = pa.getComponents();
        if (!ba) return;
        ba.forEach((_a) => {
          var ya;
          _a.type === EditorComponentType.TABLE && ((ya = _a.getFocusCellContexts()) == null || ya.forEach((xa) => {
            xa.disableFocus();
          })), _a.disableFocus();
        }), pa.enableFocus();
        return;
      }
      pa.enableFocus();
    } else if (this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type))
      this.disableFocusUIElements(Un);
    else
      throw new EditorError("spatial area type not identity");
  }
}
class ConstructorInjector extends Dependent {
  constructor() {
    super();
    Ca(this, "postInjectListeners");
    Ca(this, "singleUseInjectListeners");
    Ca(this, "isReady");
    Ca(this, "isProcess");
    /**
     * Добавляет слушателя события успешной инжекции компонента.
     */
    Ca(this, "addPostInjectListener", (Un) => {
      this.postInjectListeners.push(Un);
    });
    /**
     * Возвращает `true`, если процесс инжекции запущен, иначе `false`.
     */
    Ca(this, "isInjecting", () => this.isProcess);
    /**
     * Проверяет, готов ли инжектор к вставке. Например, в случае изображения или фигуры на `onMouseDown` не
     * нужно сразу вставлять компонент (как в случае с текстом, когда по клику сразу добавляется стандартный текст),
     * а необходимо выделить область для вставки.
     */
    Ca(this, "isReadyInject", () => this.isReady);
    /**
     * Устанавливает инжектор в состояние готовности к вставке.
     */
    Ca(this, "setReadyInject", () => {
      this.isReady = !0;
    });
    /**
     * Устанавливает инжектор в состояние неготовности к вставке.
     */
    Ca(this, "setNotReadyInject", () => {
      this.isReady = !1;
    });
    /**
     * Добавить одноразового слушателя на инжекцию компонента.
     * @param listener слушатель.
     */
    Ca(this, "addSingleUseInjectListener", (Un) => {
      this.singleUseInjectListeners.push(Un);
    });
    Ca(this, "clearSingleUseInjectListeners", () => {
      this.singleUseInjectListeners.length = 0;
    });
    /**
     * Запускает слушателей успешной инжекции компонента.
     */
    Ca(this, "callPostInjectListeners", (Un) => {
      this.postInjectListeners.forEach((Kn) => Kn(Un));
    });
    Ca(this, "callSingleUseInjectListeners", (Un) => {
      this.singleUseInjectListeners.length !== 0 && (this.singleUseInjectListeners.forEach((Kn) => Kn(Un)), this.singleUseInjectListeners.length = 0);
    });
    /**
     * Вычисляет параметры инжекции для компонента с областью на основе ближайшей графики для вставки.
     * @param area Область компонента.
     */
    Ca(this, "calculateAreaComponentInjectionParams", (Un) => {
      let Kn = null, qn = Number.MAX_SAFE_INTEGER;
      const Jo = this.dependencies.componentTree.getRootGraphics();
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va], { x: _a, y: ya, width: xa, height: wa } = ba.getFrameConfiguration(), Ta = _a + xa / 2, Sa = ya + wa / 2, Ma = Math.sqrt((Un.x - Ta) ** 2 + (Un.y - Sa) ** 2);
        Ma < qn && (qn = Ma, Kn = ba);
      }
      if (Kn === null)
        throw new EditorError("nearest page not found");
      const pa = Kn.getGlobalPosition(), ma = Kn.getOffset();
      return {
        x: pa.x,
        y: pa.y,
        componentOffset: ma
      };
    });
    /**
     * Вычисляет параметры инжекции для компонента по позиции мыши.
     * @param mousePosition - Текущая позиция мыши.
     * @returns Объект с параметрами: graphicPositionX, graphicPositionY, componentOffset.
     */
    Ca(this, "calculateComponentInjectionParams", (Un) => {
      let Kn = null, qn = Number.MAX_SAFE_INTEGER;
      const Jo = this.dependencies.componentTree.getRootGraphics();
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va], { y: _a, height: ya } = ba.getFrameConfiguration(), xa = _a + ya / 2, wa = Math.abs(Un.y - xa);
        wa < qn && (qn = wa, Kn = ba);
      }
      if (Kn === null)
        throw new EditorError("nearest page not found");
      const pa = Kn.getGlobalPosition(), ma = Kn.getOffset();
      return {
        x: pa.x,
        y: pa.y,
        componentOffset: ma
      };
    });
    this.isReady = !1, this.isProcess = !1, this.postInjectListeners = [], this.singleUseInjectListeners = [];
  }
}
class SelectionArea extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_DELAY_CREATE_AREA_PX", 0);
    Ca(this, "OBJECT_FILL_DEFAULT", "rgba(0, 117, 255, 0.2)");
    Ca(this, "OBJECT_STROKE_COLOR_DEFAULT", "#0075ff");
    Ca(this, "OBJECT_STROKE_WIDTH_DEFAULT", 1);
    Ca(this, "areaObject");
    Ca(this, "postUpdateAreaListeners");
    Ca(this, "isActivated");
    Ca(this, "currentArea");
    Ca(this, "isDelayCrossed");
    Ca(this, "delayCreateAreaPX");
    Ca(this, "initializePosition");
    Ca(this, "start", (Un) => {
      this.initializePosition = Un, this.currentArea.x = Un.x, this.currentArea.y = Un.y, this.isActivated = !0, this.showObject();
    });
    Ca(this, "stop", () => {
      this.initializePosition = null, this.isDelayCrossed = !1, this.isActivated = !1, this.hideObject();
    });
    Ca(this, "addPostUpdateAreaListener", (Un) => {
      this.postUpdateAreaListeners.push(Un);
    });
    Ca(this, "setDelayCreateAreaPx", (Un) => {
      this.delayCreateAreaPX = Un;
    });
    Ca(this, "forceUpdate", () => {
      const Un = this.dependencies.canvasMouseObserver.getCurrentPosition();
      this.update(Un);
    });
    Ca(this, "onScroll", (Un) => {
      if (this.initializePosition === null)
        return;
      const Kn = this.dependencies.canvasMouseObserver.getCurrentPosition();
      this.initializePosition.y -= Un, this.update(Kn);
    });
    Ca(this, "isAreaActivated", () => this.isActivated);
    Ca(this, "getArea", () => ({ ...this.currentArea }));
    Ca(this, "clearArea", () => {
      this.currentArea.width = 0, this.currentArea.height = 0, this.currentArea.rotate = 0, this.currentArea.x = 0, this.currentArea.y = 0;
    });
    Ca(this, "getObject", () => this.areaObject);
    Ca(this, "update", (Un) => {
      if (this.initializePosition === null)
        return;
      if (!this.isDelayCrossed) {
        const qn = Math.abs(this.initializePosition.x - Un.x), Jo = Math.abs(this.initializePosition.y - Un.y);
        if (qn > this.delayCreateAreaPX || Jo > this.delayCreateAreaPX)
          this.isDelayCrossed = !0, this.showObject();
        else {
          this.isDelayCrossed = !1;
          return;
        }
      }
      const Kn = {
        x: Un.x > this.initializePosition.x ? this.initializePosition.x : Un.x,
        y: Un.y > this.initializePosition.y ? this.initializePosition.y : Un.y,
        width: Math.abs(Un.x - this.initializePosition.x),
        height: Math.abs(Un.y - this.initializePosition.y),
        rotate: 0
      };
      this.currentArea = Kn, this.updateElementSize(Kn), this.callUpdateListeners();
    });
    Ca(this, "updateElementSize", (Un) => {
      this.areaObject.object.set({
        left: Math.round(Un.x),
        top: Math.round(Un.y),
        width: Math.round(Un.width),
        height: Math.round(Un.height)
      });
    });
    Ca(this, "callUpdateListeners", () => {
      this.postUpdateAreaListeners.forEach((Un) => Un());
    });
    Ca(this, "showObject", () => {
      this.areaObject.object.visible = !0;
    });
    Ca(this, "hideObject", () => {
      this.areaObject.object.set({
        width: 0,
        height: 0,
        visible: 0
      });
    });
    this.isActivated = !1, this.delayCreateAreaPX = this.DEFAULT_DELAY_CREATE_AREA_PX, this.postUpdateAreaListeners = [], this.initializePosition = null, this.isDelayCrossed = !1, this.currentArea = {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      rotate: 0
    }, this.areaObject = {
      object: new pr({
        fill: this.OBJECT_FILL_DEFAULT,
        stroke: this.OBJECT_STROKE_COLOR_DEFAULT,
        strokeWidth: this.OBJECT_STROKE_WIDTH_DEFAULT
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.addPostInjectDependenciesListener((Un) => {
      Un.canvasMouseObserver.subscribeToPosition(this.update);
    });
  }
}
class FigureInjectArea extends SelectionArea {
  constructor() {
    super();
  }
}
class FigureInjector extends ConstructorInjector {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 200);
    Ca(this, "DEFAULT_HEIGHT", 200);
    Ca(this, "MIN_CUSTOM_WIDTH", 21);
    Ca(this, "MIN_CUSTOM_HEIGHT", 21);
    Ca(this, "figureInjectArea");
    /**
     * Запускает инжекцию фигуры.
     */
    Ca(this, "run", () => {
      this.dependencies.cursorView.enableComponentInjectMode(), this.dependencies.cursorView.setCursor(CSSCursor.CROSSHAIR), this.isProcess = !0, this.setNotReadyInject();
    });
    /**
     * Инжектирует фигуру в структуру.
     */
    Ca(this, "inject", async () => {
      if (!this.isReadyInject())
        throw new EditorError("injector not ready inject component");
      const Kn = this.dependencies.componentTree.getRootComponent(), qn = this.figureInjectArea.getArea(), Jo = this.calculateAreaComponentInjectionParams(qn), pa = qn.height === 0 || qn.width === 0;
      let ma, va;
      if (pa)
        ma = this.DEFAULT_WIDTH, va = this.DEFAULT_HEIGHT;
      else {
        const wa = qn.height < this.MIN_CUSTOM_HEIGHT, Ta = qn.width < this.MIN_CUSTOM_WIDTH;
        wa && Ta ? (va = this.MIN_CUSTOM_HEIGHT, ma = this.MIN_CUSTOM_WIDTH) : Ta ? (va = qn.height, ma = this.MIN_CUSTOM_WIDTH) : wa ? (va = this.MIN_CUSTOM_HEIGHT, ma = qn.width) : (va = qn.height, ma = qn.width);
      }
      const ba = qn.x - Jo.x, _a = qn.y - Jo.y, ya = this.getDefaultStructure({
        x: ba,
        y: _a,
        width: ma,
        height: va,
        componentOffset: Jo.componentOffset
      });
      let xa;
      await this.dependencies.componentTree.executeMutations(async (wa) => {
        if (xa = wa.componentFactory.createComponent(ya), await xa.setStructure(() => ya), ya.graphics === null)
          throw new EditorError("graphic structures not found");
        for (let Ta = 0; Ta < ya.graphics.length; Ta++) {
          const Sa = ya.graphics[Ta], Ma = wa.graphicFactory.createGraphic(GraphicType.FIGURE, xa);
          await Ma.setStructure(() => Sa), xa.appendGraphic(Ma);
        }
        await xa.setStructure(() => ya), wa.mutator.mutateByAppendComponent(Kn, xa), this.stop(), this.callPostInjectListeners(xa), this.callSingleUseInjectListeners(xa);
      });
    });
    /**
     * Останавливает инжекцию фигуры.
     */
    Ca(this, "stop", () => {
      this.dependencies.cursorView.disableComponentInjectMode(), this.isProcess = !1, this.figureInjectArea.clearArea();
    });
    /**
     * Обработчик события нажатия кнопки мыши.
     */
    Ca(this, "onMouseDown", () => {
      const Un = this.dependencies.canvasMouseObserver.getCurrentPosition();
      return this.figureInjectArea.start(Un), this.setReadyInject(), !1;
    });
    /**
     * Обработчик события отпускания кнопки мыши.
     */
    Ca(this, "onMouseUp", async () => this.isReadyInject() ? (await this.inject(), this.figureInjectArea.stop(), this.setNotReadyInject(), !0) : !1);
    Ca(this, "addPostUpdateAreaListener", (Un) => {
      this.figureInjectArea.addPostUpdateAreaListener(Un);
    });
    Ca(this, "getObjects", () => [this.figureInjectArea.getObject()]);
    /**
     * Возвращает структуру фигуры по умолчанию.
     */
    Ca(this, "getDefaultStructure", (Un) => {
      const Kn = Utils.generate.uuid4(), qn = Utils.generate.uuid4();
      return {
        id: Kn,
        type: EditorComponentType.FIGURE,
        offset: Un.componentOffset,
        graphics: [
          {
            id: qn,
            type: GraphicType.FIGURE,
            frame: {
              x: Un.x,
              y: Un.y,
              width: Un.width,
              height: Un.height,
              rotate: 0,
              layer: 100
            },
            offset: 0,
            texture: {
              background: "#ffffff",
              borderColor: "#000",
              borderWidth: 1,
              borderStyle: BorderStyle$1.SOLID,
              radius: {
                topLeft: 0,
                topRight: 0,
                bottomLeft: 0,
                bottomRight: 0
              }
            }
          }
        ],
        texture: null,
        components: null
      };
    });
    this.figureInjectArea = new FigureInjectArea(), this.addPostInjectDependenciesListener((Un) => {
      this.figureInjectArea.connectDependencies({
        canvasMouseObserver: Un.canvasMouseObserver
      }), this.figureInjectArea.injectDependencies();
    });
  }
}
class LineInjectArea extends SelectionArea {
  constructor() {
    super();
  }
}
class LineInjector extends ConstructorInjector {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 200);
    Ca(this, "DEFAULT_HEIGHT", 3);
    Ca(this, "MIN_CUSTOM_WIDTH", 1);
    Ca(this, "MIN_CUSTOM_HEIGHT", 1);
    Ca(this, "lineInjectArea");
    /**
     * Запускает инжекцию линии.
     */
    Ca(this, "run", () => {
      this.dependencies.cursorView.enableComponentInjectMode(), this.dependencies.cursorView.setCursor(CSSCursor.CROSSHAIR), this.isProcess = !0, this.setNotReadyInject();
    });
    /**
     * Инжектирует фигуру в структуру.
     */
    Ca(this, "inject", async () => {
      if (!this.isReadyInject())
        throw new EditorError("injector not ready inject component");
      const Kn = this.dependencies.componentTree.getRootComponent(), qn = this.lineInjectArea.getArea(), Jo = this.calculateAreaComponentInjectionParams(qn), pa = qn.height === 0 || qn.width === 0;
      let ma, va;
      if (pa)
        ma = this.DEFAULT_WIDTH, va = this.DEFAULT_HEIGHT;
      else {
        const wa = qn.height < this.MIN_CUSTOM_HEIGHT, Ta = qn.width < this.MIN_CUSTOM_WIDTH;
        wa && Ta ? (va = this.MIN_CUSTOM_HEIGHT, ma = this.MIN_CUSTOM_WIDTH) : Ta ? (va = qn.height, ma = this.MIN_CUSTOM_WIDTH) : wa ? (va = this.MIN_CUSTOM_HEIGHT, ma = qn.width) : (va = qn.height, ma = qn.width);
      }
      const ba = qn.x - Jo.x, _a = qn.y - Jo.y, ya = this.getDefaultStructure({
        x: ba,
        y: _a,
        width: ma,
        height: va,
        componentOffset: Jo.componentOffset
      });
      let xa;
      await this.dependencies.componentTree.executeMutations(async (wa) => {
        if (xa = wa.componentFactory.createComponent(ya), ya.graphics === null)
          throw new EditorError("graphic structures not found");
        for (let Ta = 0; Ta < ya.graphics.length; Ta++) {
          const Sa = ya.graphics[Ta], Ma = wa.graphicFactory.createGraphic(GraphicType.LINE, xa);
          await Ma.setStructure(() => Sa), xa.appendGraphic(Ma);
        }
        await xa.setStructure(() => ya), wa.mutator.mutateByAppendComponent(Kn, xa), this.stop(), this.callPostInjectListeners(xa), this.callSingleUseInjectListeners(xa);
      });
    });
    /**
     * Останавливает инжекцию фигуры.
     */
    Ca(this, "stop", () => {
      this.dependencies.cursorView.disableComponentInjectMode(), this.isProcess = !1, this.lineInjectArea.clearArea();
    });
    /**
     * Обработчик события нажатия кнопки мыши.
     */
    Ca(this, "onMouseDown", () => {
      const Un = this.dependencies.canvasMouseObserver.getCurrentPosition();
      return this.lineInjectArea.start(Un), this.setReadyInject(), !1;
    });
    /**
     * Обработчик события отпускания кнопки мыши.
     */
    Ca(this, "onMouseUp", async () => this.isReadyInject() ? (await this.inject(), this.lineInjectArea.stop(), this.setNotReadyInject(), !0) : !1);
    Ca(this, "getObjects", () => [this.lineInjectArea.getObject()]);
    /**
     * Возвращает структуру линии по умолчанию.
     */
    Ca(this, "getDefaultStructure", (Un) => {
      const Kn = Utils.generate.uuid4(), qn = Utils.generate.uuid4();
      return {
        id: Kn,
        type: EditorComponentType.LINE,
        offset: Un.componentOffset,
        graphics: [
          {
            id: qn,
            type: GraphicType.LINE,
            frame: {
              x: Un.x,
              y: Un.y + Un.height / 2,
              width: Un.width,
              height: this.DEFAULT_HEIGHT,
              rotate: 0,
              layer: 100
            },
            offset: 0,
            texture: {
              background: "#000000",
              thickness: this.DEFAULT_HEIGHT,
              style: LineStyle.SOLID
            }
          }
        ],
        texture: null,
        components: null
      };
    });
    this.lineInjectArea = new LineInjectArea(), this.addPostInjectDependenciesListener((Un) => {
      this.lineInjectArea.connectDependencies({
        canvasMouseObserver: Un.canvasMouseObserver
      }), this.lineInjectArea.injectDependencies();
    });
  }
}
class ModuleInjector extends ConstructorInjector {
  constructor() {
    super();
    /* Оригинальная структура модуля, которая приходит с сервера. Её мы не меняем. */
    Ca(this, "moduleStructure");
    /**
     * Вставляет компонент модуля на страницу.
     */
    Ca(this, "inject", async () => {
      if (!this.isReadyInject())
        throw new EditorError("injector not ready inject component");
      await this.dependencies.componentTree.executeMutations(async (Kn) => {
        if (this.moduleStructure === null)
          throw new EditorError("module structure not load");
        const qn = this.dependencies.canvasMouseObserver.getCurrentPosition(), Jo = this.calculateComponentInjectionParams(qn), pa = await this.injectModuleStructure(Kn, this.moduleStructure, Jo), va = pa.getGraphics()[0], ba = va.getFrameConfiguration(), _a = this.getModuleAlignmentSection(qn, ba.width);
        va.setFrameConfiguration((ya) => ({
          ...ya,
          x: _a - Jo.x,
          y: qn.y - Jo.y
        })), this.stop(), this.callSingleUseInjectListeners(pa), this.callPostInjectListeners(pa);
      });
    });
    Ca(this, "stop", () => {
      this.dependencies.cursorView.disableComponentInjectMode(), this.dependencies.modulePlaceHolder.stop(), this.isProcess = !1;
    });
    Ca(this, "injectToPoint", async (Un, Kn, qn, Jo) => {
      await this.injectModuleStructure(Un, Kn, {
        x: 0,
        y: Jo,
        componentOffset: qn
      });
    });
    Ca(this, "onMouseDown", () => !1);
    Ca(this, "onMouseUp", async () => !1);
    Ca(this, "loadStructure", (Un) => {
      this.moduleStructure = Un;
    });
    Ca(this, "getDefaultStructure", (Un) => ({
      id: "",
      type: EditorComponentType.MODULE,
      texture: {},
      offset: null,
      graphics: null,
      components: null
    }));
    /**
     * Рассчитывает позицию модуля в одной из трёх горизонтальных секций страницы
     * (лево, центр или право) на основе текущей позиции мыши.
     * @param position Позиция мыши.
     * @param moduleWidth Ширина модуля.
     */
    Ca(this, "getModuleAlignmentSection", (Un, Kn) => {
      const qn = this.dependencies.componentTree.getRootGraphics(), { x: Jo, width: pa } = qn[0].getFrameConfiguration(), ma = pa / 3;
      return Un.x <= ma + Jo ? Jo : Un.x > ma + Jo && Un.x <= ma * 2 + Jo ? pa / 2 - Kn / 2 + Jo : pa - Kn + Jo;
    });
    /**
     * Возвращает массив строк с идентификаторами графики модуля в верной последовательности
     * для каждого слоя на каждой странице.
     * Учитывает только графику, переданную в `graphics`, и игнорирует отсутствующие в ней элементы.
     * @param graphics Графика компонентов.
     */
    Ca(this, "getModuleLayerSequence", (Un) => {
      const Kn = this.dependencies.componentTree.getLayerSequences(), qn = Un.map((pa) => pa.getID()), Jo = [];
      for (let pa = 0; pa < Kn.length; pa++) {
        let ma = 0;
        for (let va = 0; va < Kn[pa].length; va++) {
          const ba = qn.indexOf(Kn[pa][va]);
          ba !== -1 && (Jo[pa] === void 0 && (Jo[pa] = []), Jo[pa][ma] = Un[ba], ma++);
        }
      }
      for (let pa = 0; pa < Jo.length; pa++)
        Jo[pa] !== void 0 && (Jo[pa] = Jo[pa].filter((ma) => ma !== void 0));
      return Jo.flatMap((pa) => pa.map((ma) => ma.getID()));
    });
    Ca(this, "injectModuleStructure", async (Un, Kn, qn) => {
      const Jo = this.dependencies.componentTree.getRootComponent();
      await Un.componentBuilder.scanStructure(Kn), await Un.componentBuilder.regenerate();
      const pa = Un.componentBuilder.getLayerSequences(), ma = Un.componentBuilder.getStructure();
      if (!ma.graphics)
        throw new EditorError("not have module graphic");
      ma.offset = qn.componentOffset;
      const va = qn.componentOffset, ba = {
        pages: []
      };
      for (let Sa = 0; Sa < ma.graphics.length; Sa++) {
        const Ma = this.dependencies.componentTree.getLayerFromRootGraphicNumber(va + Sa);
        ba.pages.push({
          baseGraphic: Ma,
          moduleGraphics: []
        });
      }
      const _a = await Un.mutator.mutateByAppendMultiComponent(Jo, ma), xa = [_a, ..._a.getComponentAll()].flatMap((Sa) => Sa.getGraphics());
      for (let Sa = 0; Sa < ba.pages.length; Sa++)
        ba.pages[Sa].moduleGraphics = pa[Sa].map((Ma) => {
          const ka = xa.find((Za) => Za.getID() === Ma);
          if (ka === void 0)
            throw new EditorError("graphic not found", {
              layerSequences: pa[Sa],
              graphics: xa.map((Za) => Za.getID())
            });
          return ka;
        });
      ba.pages.forEach((Sa) => {
        Un.mutator.mutateByChangeLayer(Sa.baseGraphic, Sa.moduleGraphics[0]);
        for (let Ma = 0; Ma < Sa.moduleGraphics.length - 1; Ma++)
          Un.mutator.mutateByChangeLayer(Sa.moduleGraphics[Ma], Sa.moduleGraphics[Ma + 1]);
      });
      const wa = _a.getComponentAll(), Ta = this.getModuleLayerSequence(
        wa.flatMap((Sa) => Sa.getGraphics())
      );
      return await _a.setTexture((Sa) => ({
        ...Sa,
        layerSequence: Ta
      })), _a;
    });
    this.moduleStructure = null;
  }
  run() {
    this.dependencies.cursorView.enableComponentInjectMode();
    const Un = this.dependencies.canvasMouseObserver.getCurrentPosition();
    this.dependencies.modulePlaceHolder.start(Un), this.dependencies.cursorView.setCursor(CSSCursor.CROSSHAIR), this.isProcess = !0, this.setReadyInject();
  }
}
class PictureInjectArea extends SelectionArea {
  constructor() {
    super();
  }
}
class PictureInjector extends ConstructorInjector {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 200);
    Ca(this, "DEFAULT_HEIGHT", 200);
    Ca(this, "MIN_CUSTOM_WIDTH", 6);
    Ca(this, "MIN_CUSTOM_HEIGHT", 6);
    Ca(this, "pictureInjectArea");
    /**
     * Запускает инжекцию изображения.
     */
    Ca(this, "run", () => {
      this.dependencies.cursorView.enableComponentInjectMode(), this.dependencies.cursorView.setCursor(CSSCursor.CROSSHAIR), this.isProcess = !0, this.setNotReadyInject();
    });
    /**
     * Инжектирует изображение в структуру.
     */
    Ca(this, "inject", async () => {
      if (!this.isReadyInject())
        throw new EditorError("injector not ready inject component");
      const Kn = this.dependencies.componentTree.getRootComponent(), qn = this.pictureInjectArea.getArea(), Jo = this.calculateAreaComponentInjectionParams(qn), pa = qn.width < this.MIN_CUSTOM_WIDTH || qn.height < this.MIN_CUSTOM_HEIGHT;
      let ma, va;
      pa ? (ma = this.DEFAULT_WIDTH, va = this.DEFAULT_HEIGHT) : (ma = qn.width, va = qn.height);
      const ba = qn.x - Jo.x, _a = qn.y - Jo.y, ya = this.getDefaultStructure({
        x: ba,
        y: _a,
        width: ma,
        height: va,
        componentOffset: Jo.componentOffset
      });
      let xa = null;
      if (await this.dependencies.componentTree.executeMutations(async (wa) => {
        if (xa = wa.componentFactory.createComponent(ya), await xa.setStructure(() => ya), ya.graphics === null)
          throw new EditorError("graphic structures not found");
        for (let Ta = 0; Ta < ya.graphics.length; Ta++) {
          const Sa = ya.graphics[Ta], Ma = wa.graphicFactory.createGraphic(GraphicType.PICTURE, xa);
          await Ma.setStructure(() => Sa), xa.appendGraphic(Ma);
        }
        pa ? xa.disableAdaptPictureAfterSetup() : xa.enableAdaptPictureAfterSetup(), wa.mutator.mutateByAppendComponent(Kn, xa), this.callPostInjectListeners(xa);
      }), this.stop(), xa === null)
        throw new EditorError("component not found");
      this.callSingleUseInjectListeners(xa);
    });
    /**
     * Останавливает инжекцию изображения.
     */
    Ca(this, "stop", () => {
      this.dependencies.cursorView.disableComponentInjectMode(), this.isProcess = !1, this.pictureInjectArea.clearArea();
    });
    /**
     * Обработчик события нажатия кнопки мыши.
     */
    Ca(this, "onMouseDown", () => {
      const Un = this.dependencies.canvasMouseObserver.getCurrentPosition();
      return this.pictureInjectArea.start(Un), this.setReadyInject(), !1;
    });
    /**
     * Обработчик события отпускания кнопки мыши.
     */
    Ca(this, "onMouseUp", async () => this.isReadyInject() ? (this.pictureInjectArea.stop(), await this.inject(), this.setNotReadyInject(), !0) : !1);
    Ca(this, "getObjects", () => [this.pictureInjectArea.getObject()]);
    /**
     * Возвращает структуру изображения по умолчанию.
     */
    Ca(this, "getDefaultStructure", (Un) => {
      const Kn = Utils.generate.uuid4(), qn = Utils.generate.uuid4();
      return {
        id: Kn,
        type: EditorComponentType.PICTURE,
        offset: Un.componentOffset,
        graphics: [
          {
            id: qn,
            type: GraphicType.PICTURE,
            frame: {
              x: Un.x,
              y: Un.y,
              width: Un.width,
              height: Un.height,
              rotate: 0,
              layer: 100
            },
            offset: 0,
            texture: {
              x: 0,
              y: 0,
              width: 0,
              height: 0,
              source: null
            }
          }
        ],
        texture: null,
        components: null
      };
    });
    this.pictureInjectArea = new PictureInjectArea(), this.addPostInjectDependenciesListener((Un) => {
      this.pictureInjectArea.connectDependencies({
        canvasMouseObserver: Un.canvasMouseObserver
      }), this.pictureInjectArea.injectDependencies();
    });
  }
}
class TableInjector extends ConstructorInjector {
  constructor() {
    super();
    Ca(this, "MAX_TABLE_COLUMNS", 12);
    Ca(this, "loadedRowCount");
    Ca(this, "loadedColumnCount");
    Ca(this, "loadedCellTextures");
    /**
     * Загружает размер таблицы.
     */
    Ca(this, "loadSize", (Un, Kn) => {
      Kn > this.MAX_TABLE_COLUMNS || (this.loadedRowCount = Un, this.loadedColumnCount = Kn);
    });
    /**
     * Загружает текстуры ячеек таблицы.
     */
    Ca(this, "loadCellTextures", (Un) => {
      this.loadedCellTextures = Un;
    });
    /**
     * Инжектирует таблицу в структуру.
     */
    Ca(this, "inject", async () => {
      const Un = this.dependencies.componentTree.getRootComponent(), Kn = this.dependencies.canvasMouseObserver.getCurrentPosition(), qn = this.calculateComponentInjectionParams(Kn), Jo = Un.getGraphics()[qn.componentOffset], pa = Jo.getGlobalPosition();
      let ma = null;
      if (await this.dependencies.componentTree.executeMutations(async (va) => {
        const ba = this.createTableStructure(va, Jo, qn);
        if (ba.graphics === null)
          throw new EditorError("graphic structures not found");
        ma = va.componentFactory.createComponent(ba);
        for (let _a = 0; _a < ba.graphics.length; _a++) {
          const ya = ba.graphics[_a], xa = va.graphicFactory.createGraphic(GraphicType.TABLE, ma);
          if (await xa.setStructure(() => ya), ma.appendGraphic(xa), ba.offset === null)
            throw new EditorError("the table structure not have offset");
          const { paddingLeft: wa } = Jo.getTexture();
          xa.setFrameConfiguration((Ta) => ({
            ...Ta,
            x: wa,
            y: Kn.y - pa.y
          }));
        }
        await ma.setStructure(() => ba), va.mutator.mutateByAppendComponent(Un, ma), this.stop(), this.dependencies.componentTree.enableFocusOnly(ma), this.callPostInjectListeners(ma);
      }), ma === null)
        throw new EditorError("component is null");
      this.callSingleUseInjectListeners(ma), this.loadedRowCount = null, this.loadedColumnCount = null, this.loadedCellTextures = null;
    });
    Ca(this, "run", () => {
      this.dependencies.cursorView.enableComponentInjectMode(), this.dependencies.cursorView.setCursor(CSSCursor.CROSSHAIR), this.isProcess = !0, this.setReadyInject();
    });
    Ca(this, "stop", () => {
      this.dependencies.cursorView.disableComponentInjectMode(), this.isProcess = !1;
    });
    Ca(this, "onMouseUp", async () => !1);
    Ca(this, "onMouseDown", () => !1);
    /**
     * Возвращает структуру таблицы по умолчанию.
     */
    Ca(this, "getDefaultStructure", (Un) => {
      if (Un.columns === 0 || Un.rows === 0)
        throw new EditorError("size can not 0 or size not setup");
      const Kn = Utils.generate.uuid4(), qn = Utils.generate.uuid4(), Jo = [];
      for (let ma = 0; ma < Un.rows; ma++)
        for (let va = 0; va < Un.columns; va++) {
          const ba = this.getDefaultCell(ma, va);
          Jo.push(ba);
        }
      const pa = {
        id: qn,
        type: GraphicType.TABLE,
        frame: {
          width: 601,
          height: 156,
          layer: 100,
          x: 60,
          y: 90,
          rotate: 0
        },
        offset: 0,
        texture: {
          rowCount: Un.rows
        }
      };
      return {
        id: Kn,
        type: EditorComponentType.TABLE,
        offset: Un.componentOffset,
        graphics: [pa],
        components: null,
        texture: {
          startRows: [0],
          borderColor: "black",
          rowHeights: new Array(Un.rows).fill(Un.rowHeight),
          columnWidths: new Array(Un.columns).fill(100),
          cells: Jo
        }
      };
    });
    /**
     * Возвращает структуру таблицы с загруженными данными (методами `loadSize` и `loadCellTextures`).
     */
    Ca(this, "getLoadedStructure", (Un) => {
      if (Un.columns === 0 || Un.rows === 0)
        throw new EditorError("size can not 0 or size not setup");
      const Kn = Utils.generate.uuid4(), Jo = {
        id: Utils.generate.uuid4(),
        type: GraphicType.TABLE,
        frame: {
          width: 601,
          height: 156,
          layer: 0,
          x: 60,
          y: 90,
          rotate: 0
        },
        offset: 0,
        texture: {
          rowCount: Un.rows
        }
      };
      return {
        id: Kn,
        type: EditorComponentType.TABLE,
        offset: Un.componentOffset,
        graphics: [Jo],
        texture: {
          cells: Un.cells,
          startRows: [0],
          borderColor: "black",
          columnWidths: new Array(Un.columns).fill(100),
          rowHeights: new Array(Un.rows).fill(Un.rowHeight)
        },
        components: null
      };
    });
    /**
     * Возвращает текстуру ячейки по умолчанию.
     */
    Ca(this, "getDefaultCell", (Un, Kn) => ({
      id: Utils.generate.uuid4(),
      content: Utils.component.getDefaultTextModel(),
      row: Un,
      column: Kn,
      rowSpan: 1,
      columnSpan: 1,
      background: "#ffffff"
    }));
    this.loadedRowCount = null, this.loadedColumnCount = null, this.loadedCellTextures = null;
  }
  /**
   * Возвращает созданную структуру таблицы в зависимости от загруженных данных.
   * @param tools Инструменты для мутации.
   * @param injectionPageGraphic Графика страницы, на которую вставляется таблица.
   * @param injectionParams Параметры вставки.
   */
  createTableStructure(Un, Kn, qn) {
    if (this.loadedColumnCount === null || this.loadedRowCount === null)
      throw new EditorError("table size not loaded");
    const pa = Un.componentFactory.getClearComponent(EditorComponentType.TABLE).getDefaultRowHeight(), ma = this.loadedCellTextures === null ? this.getDefaultStructure({
      rowHeight: pa,
      rows: this.loadedRowCount,
      columns: this.loadedColumnCount,
      componentOffset: qn.componentOffset
    }) : this.getLoadedStructure({
      rowHeight: pa,
      rows: this.loadedRowCount,
      columns: this.loadedColumnCount,
      cells: this.loadedCellTextures,
      componentOffset: qn.componentOffset
    });
    return ma.texture.columnWidths = this.calculateColumnWidths(Kn, this.loadedColumnCount), ma;
  }
  /**
   * Вычисляет массив ширин колонок для таблицы на основе доступного пространства.
   * @param injectionPageGraphic Страница на которой будет размещена таблица.
   * @param columnCount Количество колонок в таблице.
   */
  calculateColumnWidths(Un, Kn) {
    const { paddingLeft: qn, paddingRight: Jo } = Un.getTexture(), pa = Un.getFrameConfiguration().width - qn - Jo;
    return new Array(Kn).fill(pa / Kn);
  }
}
class TextInjectArea extends SelectionArea {
  constructor() {
    super();
  }
}
class TextInjector extends ConstructorInjector {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 50);
    Ca(this, "DEFAULT_HEIGHT", 28);
    Ca(this, "loadedToken");
    Ca(this, "textInjectArea");
    /**
     * Запускает процесс инжекции текстового компонента.
     */
    Ca(this, "run", () => {
      this.dependencies.cursorView.enableComponentInjectMode(), this.dependencies.cursorView.setCursor(CSSCursor.CROSSHAIR), this.isProcess = !0, this.setNotReadyInject();
    });
    /**
     * Загружает токен текста.
     * @param token - токен текста.
     */
    Ca(this, "loadToken", (Un) => {
      this.loadedToken = Un;
    });
    /**
     * Инжектирует текстовый компонент.
     */
    Ca(this, "inject", async () => {
      if (!this.isReadyInject())
        throw new EditorError("injector not ready inject component");
      const Kn = this.dependencies.componentTree.getRootComponent(), qn = this.textInjectArea.getArea(), Jo = this.calculateAreaComponentInjectionParams(qn), pa = qn.height === 0 || qn.width === 0;
      let ma, va, ba = !1;
      if (pa)
        ma = this.DEFAULT_WIDTH, va = this.DEFAULT_HEIGHT, ba = !0;
      else {
        const Ta = qn.height < this.DEFAULT_HEIGHT, Sa = qn.width < this.DEFAULT_WIDTH;
        Ta && Sa ? (va = this.DEFAULT_HEIGHT, ma = this.DEFAULT_WIDTH, ba = !0) : Sa ? (va = qn.height, ma = this.DEFAULT_WIDTH, ba = !0) : Ta ? (va = this.DEFAULT_HEIGHT, ma = qn.width) : (va = qn.height, ma = qn.width);
      }
      const _a = qn.x - Jo.x, ya = qn.y - Jo.y;
      this.loadedToken = [
        {
          type: TokenType.TEXT,
          value: "",
          format: TokenFormat.None,
          color: UIDefaultColor.BLACK,
          fontFamily: FontFamily.DEFAULT,
          fontSize: DefaultFontSize
        }
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'Hello ',
        // 	format: TokenFormat.None,
        // 	color: '#000000', // Черный
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: DefaultFontSize,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'world',
        // 	format: TokenFormat.None,
        // 	color: '#f35151', // Красный
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt28,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'This ',
        // 	format: TokenFormat.None,
        // 	color: '#3b82f6', // Синий
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt20,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'is ',
        // 	format: TokenFormat.None,
        // 	color: '#22c55e', // Зеленый
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt18,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'a ',
        // 	format: TokenFormat.None,
        // 	color: '#eab308', // Желтый
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt24,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'dynamic ',
        // 	format: TokenFormat.None,
        // 	color: '#6b7280', // Серый
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt16,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'text ',
        // 	format: TokenFormat.None,
        // 	color: '#8b5cf6', // Фиолетовый
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt22,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'renderer ',
        // 	format: TokenFormat.None,
        // 	color: '#ec4899', // Розовый
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt20,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'with ',
        // 	format: TokenFormat.None,
        // 	color: '#0ea5e9', // Голубой
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt18,
        // },
        // {
        // 	type: TokenType.TEXT,
        // 	value: 'Fabric.js!',
        // 	format: TokenFormat.None,
        // 	color: '#ef4444', // Темно-красный
        // 	fontFamily: FontFamily.RUSSO_ONE,
        // 	fontSize: FontSize.Pt26,
        // },
      ];
      const xa = this.getLoadedStructure(
        {
          x: _a,
          y: ya,
          height: va,
          width: ma,
          componentOffset: Jo.componentOffset
        },
        {
          loadedToken: this.loadedToken
        }
      );
      let wa = null;
      if (await this.dependencies.componentTree.executeMutations(async (Ta) => {
        if (wa = Ta.componentFactory.createComponent(xa), xa.graphics === null)
          throw new EditorError("graphic structures not found");
        for (let Sa = 0; Sa < xa.graphics.length; Sa++) {
          const Ma = xa.graphics[Sa], ka = Ta.graphicFactory.createGraphic(Ma.type, wa);
          await ka.setStructure(() => Ma), wa.appendGraphic(ka);
        }
        await wa.setStructure(() => xa), Ta.mutator.mutateByAppendComponent(Kn, wa), wa.enableFocus(), ba && wa.enableAutoWidth(), this.callPostInjectListeners(wa);
      }), this.stop(), wa === null)
        throw new EditorError("text component not initialized");
      this.callSingleUseInjectListeners(wa), wa.enableEditMode(), this.loadedToken = null;
    });
    /**
     * Останавливает процесс инжекции текстового компонента.
     */
    Ca(this, "stop", () => {
      this.dependencies.cursorView.disableComponentInjectMode(), this.isProcess = !1, this.textInjectArea.clearArea();
    });
    /**
     * Обработчик события нажатия кнопки мыши.
     */
    Ca(this, "onMouseDown", () => {
      const Un = this.dependencies.canvasMouseObserver.getCurrentPosition();
      return this.textInjectArea.start(Un), this.setReadyInject(), !1;
    });
    /**
     * Обработчик события отпускания кнопки мыши.
     */
    Ca(this, "onMouseUp", async () => this.isReadyInject() ? (await this.inject(), this.textInjectArea.stop(), this.setNotReadyInject(), !0) : !1);
    Ca(this, "addPostUpdateAreaListener", (Un) => {
      this.textInjectArea.addPostUpdateAreaListener(Un);
    });
    Ca(this, "getObjects", () => [this.textInjectArea.getObject()]);
    /**
     * Возвращает структуру текстового компонента по умолчанию.
     */
    Ca(this, "getDefaultStructure", (Un) => {
      const Kn = Utils.generate.uuid4(), qn = Utils.generate.uuid4();
      return {
        id: Kn,
        type: EditorComponentType.TEXT,
        offset: Un.componentOffset,
        graphics: [
          {
            id: qn,
            type: GraphicType.TEXT,
            offset: 0,
            frame: {
              x: Un.x,
              y: Un.y,
              width: Un.width,
              height: Un.height,
              rotate: 0,
              layer: 100
            },
            texture: null
          }
        ],
        texture: null,
        components: null
      };
    });
    /**
     * Возвращает структуру текстового компонента с загруженными данными.
     */
    Ca(this, "getLoadedStructure", (Un, Kn) => {
      const qn = Utils.generate.uuid4(), Jo = Utils.generate.uuid4();
      return {
        id: qn,
        type: EditorComponentType.TEXT,
        offset: Un.componentOffset,
        graphics: [
          {
            id: Jo,
            type: GraphicType.TEXT,
            offset: 0,
            frame: {
              x: Un.x,
              y: Un.y,
              width: Un.width,
              height: Un.height,
              rotate: 0,
              layer: 100
            }
          }
        ],
        texture: {
          model: this.getLoadedTextModel(Kn.loadedToken)
        },
        components: null
      };
    });
    Ca(this, "getLoadedTextModel", (Un) => ({
      id: Utils.generate.uuid4(),
      tokens: Un,
      textAlign: TextAlign.LEFT,
      lineHeight: LineHeight.SMALL,
      splitGraphemePositions: []
    }));
    this.loadedToken = null, this.textInjectArea = new TextInjectArea(), this.addPostInjectDependenciesListener((Un) => {
      this.textInjectArea.connectDependencies({
        canvasMouseObserver: Un.canvasMouseObserver
      }), this.textInjectArea.injectDependencies();
    });
  }
}
class InjectorFactory extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "getTextInjector", () => {
      const Un = new TextInjector();
      return this.configureInjector(Un), Un.connectDependencies(this.dependencies), Un.injectDependencies(), Un;
    });
    Ca(this, "getPictureInjector", () => {
      const Un = new PictureInjector();
      return this.configureInjector(Un), Un.connectDependencies(this.dependencies), Un.injectDependencies(), Un;
    });
    Ca(this, "getTableInjector", () => {
      const Un = new TableInjector();
      return this.configureInjector(Un), Un.connectDependencies(this.dependencies), Un.injectDependencies(), Un;
    });
    Ca(this, "getFigureInjector", () => {
      const Un = new FigureInjector();
      return this.configureInjector(Un), Un.connectDependencies(this.dependencies), Un.injectDependencies(), Un;
    });
    Ca(this, "getLineInjector", () => {
      const Un = new LineInjector();
      return this.configureInjector(Un), Un.connectDependencies(this.dependencies), Un.injectDependencies(), Un;
    });
    Ca(this, "getModuleInjector", () => {
      const Un = new ModuleInjector();
      return this.configureInjector(Un), Un.connectDependencies(this.dependencies), Un.injectDependencies(), Un;
    });
    Ca(this, "configureInjector", (Un) => {
      Un.addPostInjectListener(this.dependencies.componentTree.moveComponentToForeground), Un.addPostInjectListener(this.dependencies.componentTree.disableFocusExcept);
    });
  }
}
class ModuleBuilder extends Dependent {
  constructor() {
    super(...arguments);
    /**
     * Возвращает собранный модуль, содержащий переданные компоненты.
     * @param components Компоненты для объединения.
     */
    Ca(this, "build", async (...Un) => {
      if (Un.length === 0)
        throw new EditorError("components not found");
      const Kn = await this.getCopiedComponents(Un), qn = this.getDefaultModuleStructure();
      if (Un.length === 1 && Un[0].isUniter) {
        const ma = Kn[0].getComponents();
        if (ma === null) throw new EditorError("components not found");
        this.fillComponentsModule(ma, qn);
        const va = await this.buildModuleComponent(qn);
        return va.syncSizeFrames(), va;
      }
      this.fillComponentsModule(Kn, qn), this.removeEmptyModuleGraphics(qn);
      const Jo = await this.buildModuleComponent(qn);
      Jo.syncSizeFrames();
      const pa = Jo.getFirstGraphic();
      if (pa === null)
        throw new EditorError("first graphic not found");
      return pa.setFrameConfiguration((ma) => ({
        ...ma,
        x: 0,
        y: 0
      })), Jo;
    });
    /**
     * Уменьшает компоненты таблиц за счет удаления дополнительных график. Количество строк и ячейки сохраняются.
     * @param components Компоненты таблиц.
     */
    Ca(this, "compressTableComponents", (Un) => {
      Un.forEach((Kn) => {
        const qn = Kn.getGraphics();
        if (Kn.type === EditorComponentType.TABLE && qn.length > 1) {
          const Jo = Kn, pa = Jo.getStructure();
          if (pa.graphics === null)
            return;
          const ma = pa.graphics.reduce(
            (_a, ya) => ya.texture.rowCount + _a,
            0
          ), va = Jo.getFirstGraphic();
          if (va === null)
            throw new EditorError("first graphic not found");
          const ba = Jo.getGraphics();
          for (let _a = 1; _a < ba.length; _a++)
            Kn.removeGraphic(ba[_a]);
          va.setTexture((_a) => ({
            ..._a,
            startRow: 0,
            rowCount: ma
          }));
        }
      });
    });
    Ca(this, "getCompresedStucture", (Un) => {
      const Kn = Un.getStructure();
      if (Kn.offset = 0, Kn.graphics === null)
        return Kn;
      const qn = Un.getGraphics();
      if (Kn.graphics.forEach((Jo, pa) => {
        const ma = qn[pa];
        Jo.frame && (Jo.offset = 0, Jo.frame.y = ma.getGlobalPosition().y);
      }), Kn.graphics.splice(1), Un.type === EditorComponentType.TABLE && qn.length > 1)
        return Kn.graphics[0].texture = {
          startRow: 0,
          rowCount: Un.getRowCount()
        }, Kn;
      if (Un.isUniter && qn.length > 1) {
        const Jo = Un.getComponents();
        if (Jo === null || Kn.components === null)
          throw new EditorError("component uniter has no components");
        for (let pa = 0; pa < Jo.length; pa++) {
          const ma = Kn.components[pa];
          ma.offset = 0;
          const va = Jo[pa].getGraphics(), ba = ma.graphics;
          if (ba === null)
            throw new EditorError("component has no graphics");
          for (let _a = 0; _a < va.length; _a++) {
            const ya = va[_a], xa = ba[_a];
            xa.frame && (xa.offset = 0, xa.frame.y = ya.getGlobalPosition().y - qn[0].getGlobalPosition().y);
          }
        }
        return Kn;
      }
      return Kn;
    });
    Ca(this, "recursiveUpdate", (Un, Kn, qn) => {
      const Jo = Un.getComponents();
      if (Jo !== null) {
        if (Kn.components === null)
          throw new EditorError("component uniter has no components");
        for (let pa = 0; pa < Jo.length; pa++) {
          const ma = Kn.components[pa];
          ma.offset = 0;
          const va = Jo[pa].getGraphics(), ba = ma.graphics;
          if (ba === null)
            throw new EditorError("component has no graphics");
          for (let _a = 0; _a < va.length; _a++) {
            const ya = va[_a], xa = ba[_a];
            xa.frame && (xa.offset = 0, xa.frame.y = ya.getGlobalPosition().y - qn);
          }
          this.recursiveUpdate(Jo[pa], Kn, qn);
        }
      }
    });
    /**
     * Возвращает коллекцию скопированных компонентов.
     * @param components Компоненты для копирования.
     */
    Ca(this, "getCopiedComponents", async (Un) => {
      const Kn = [];
      for (let qn = 0; qn < Un.length; qn++) {
        const Jo = Un[qn];
        if (Un.length === 1 && Jo.isUniter && Jo.type !== EditorComponentType.MODULE) {
          const ma = this.getCompresedStucture(Jo);
          let va = this.getDefaultModuleStructure();
          if (ma.graphics === null)
            throw new EditorError("graphics is null");
          va = {
            ...va,
            components: ma.components,
            graphics: ma.graphics.map((ba) => {
              const _a = this.getDefaultModuleGraphicStructure();
              return _a.frame = ba.frame, _a;
            })
          }, await this.dependencies.componentBuilder.scanStructure(va), await this.dependencies.componentBuilder.regenerate(), Kn.push(this.dependencies.componentBuilder.getComponent());
          continue;
        }
        const pa = this.getCompresedStucture(Jo);
        await this.dependencies.componentBuilder.scanStructure(pa), await this.dependencies.componentBuilder.regenerate(), Kn.push(this.dependencies.componentBuilder.getComponent());
      }
      return Kn;
    });
    /**
     * Возвращает стандартную структуру модуля.
     */
    Ca(this, "getDefaultModuleStructure", () => ({
      graphics: [this.getDefaultModuleGraphicStructure()],
      texture: {
        baseModule: null,
        layerSequence: []
      },
      components: [],
      id: Utils.generate.uuid4(),
      offset: 0,
      type: EditorComponentType.MODULE
    }));
    /**
     * Заполняет структуру модуля нужным количеством её графики.
     * @param components Дочерние компоненты, на основании которых будет высчитано количество графики модуля.
     * @param moduleStructure Структура модуля.
     */
    Ca(this, "fillGraphicsModuleStructure", (Un, Kn) => {
      const qn = Un.flatMap((va) => va.getGraphics()), Jo = /* @__PURE__ */ new Set();
      qn.forEach((va) => {
        const ba = va.getRootGraphicNumber();
        if (ba === null)
          throw new EditorError("page number not found");
        Jo.add(ba);
      });
      const pa = Jo.size, ma = [];
      for (let va = 0; va < pa; va++) {
        const ba = this.getDefaultModuleGraphicStructure();
        ba.offset = va, ma.push(ba);
      }
      ma.forEach((va) => {
        if (Kn.graphics === null)
          throw new EditorError("graphics is null");
        Kn.graphics.push(va);
      });
    });
    Ca(this, "getDefaultModuleGraphicStructure", () => ({
      id: Utils.generate.uuid4(),
      type: GraphicType.MODULE,
      texture: null,
      offset: 0,
      frame: {
        y: 0,
        x: 0,
        height: 0,
        width: 0,
        rotate: 0,
        layer: 0
      }
    }));
    /**
     * Актуализирует офсеты новых компонентов относительно их новой позиции внутри модуля.
     * @param components Компоненты для обновления офсетов.
     */
    Ca(this, "updateOffsets", async (Un) => {
      for (let Kn = 0; Kn < Un.length; Kn++)
        await Un[Kn].setStructure((Jo) => ({
          ...Jo,
          offset: 0
        }));
    });
    /**
     * Заполняет переданную структуру дочерними компонентами.
     * @param components Дочерние компоненты.
     * @param moduleStructure Структура модуля.
     */
    Ca(this, "fillComponentsModule", (Un, Kn) => {
      Un.forEach((qn) => {
        if (Kn.components === null)
          throw new EditorError("components is null");
        qn.type === EditorComponentType.TABLE && qn.applyMutations(), Kn.components.push(qn.getStructure());
      });
    });
    /**
     * Собирает компонент модуля из настроенной структуры.
     * @param structure Структура модуля.
     */
    Ca(this, "buildModuleComponent", async (Un) => (await this.dependencies.componentBuilder.scanStructure(Un), this.dependencies.componentBuilder.getComponent()));
    Ca(this, "recursiveFillAbsoluteGraphicOffsets", (Un, Kn, qn) => {
      if (Kn.graphics === null || Kn.offset === null)
        throw new EditorError("graphics or structure offset not found");
      for (let Jo = 0; Jo < Kn.graphics.length; ++Jo)
        Un[qn + Kn.offset + Jo] === void 0 && (Un[qn + Kn.offset + Jo] = []), Un[qn + Kn.offset + Jo].push(Kn.graphics[Jo]);
      Kn.components !== null && Kn.components.forEach((Jo) => {
        if (Kn.offset === null)
          throw new EditorError("structure offset not found");
        this.recursiveFillAbsoluteGraphicOffsets(
          Un,
          Jo,
          qn + Kn.offset
        );
      });
    });
  }
  /**
   * Удаляет графику модуля, на которой не располагает никакая другая графика.
   * @param moduleStructure Структура модуля.
   * @private
   */
  removeEmptyModuleGraphics(Un) {
    const Kn = [];
    if (Un.graphics === null)
      throw new EditorError("graphics not found");
    if (Un.components === null)
      throw new EditorError("components not found");
    Un.components.forEach((qn) => {
      this.recursiveFillAbsoluteGraphicOffsets(Kn, qn, 0);
    }), Kn.length !== Un.graphics.length && Un.graphics.splice(Kn.length);
  }
}
class DynamicGraphicFactory extends GraphicFactory {
  constructor() {
    super();
    Ca(this, "MIN_TEXT_WIDTH", 80);
    Ca(this, "DEFAULT_TEXT_WIDTH", 300);
    Ca(this, "MIN_WIDTH_FOR_PICTURE_ACTION_LAYER_DISPLAY", 150);
    Ca(this, "MIN_HEIGHT_FOR_PICTURE_ACTION_LAYER_DISPLAY", 50);
    Ca(this, "createGraphic", (Un, Kn) => {
      let qn;
      switch (Un) {
        case GraphicType.PAGE: {
          const Jo = new PageGraphic();
          this.configurePageGraphic(Jo), qn = Jo, qn.setParentComponent(Kn);
          break;
        }
        case GraphicType.MODULE:
          qn = new ModuleGraphic(), qn.setParentComponent(Kn);
          break;
        case GraphicType.GROUP: {
          qn = new GroupGraphic(), qn.setParentComponent(Kn);
          break;
        }
        case GraphicType.PICTURE: {
          const Jo = new PictureGraphic();
          this.configurePictureGraphic(Jo), qn = Jo, qn.setParentComponent(Kn), this.injectPictureActionLayer(Jo, this.dependencies.useCases, this.dependencies.render);
          break;
        }
        case GraphicType.TABLE: {
          qn = new TableGraphic();
          const Jo = {
            top: !1,
            left: !0,
            right: !0,
            bottom: !1,
            leftTop: !1,
            rightTop: !1,
            leftBottom: !1,
            rightBottom: !1
          };
          qn.setMutationPermissions(Jo), qn.setMinWidth(80), qn.setParentComponent(Kn);
          break;
        }
        case GraphicType.TEXT: {
          const Jo = new TextGraphic();
          if (Kn.type !== EditorComponentType.TEXT)
            throw new EditorError("parent component is not text");
          const pa = Kn;
          pa.addPostDisableEditModeListener(pa.disableAutoWidth);
          const ma = pa.getTextModel(), va = {
            top: !1,
            left: !0,
            right: !0,
            bottom: !1,
            leftTop: !1,
            rightTop: !1,
            leftBottom: !1,
            rightBottom: !1
          };
          ma.addPostChangeTextListener(
            this.dependencies.componentTree.syncUniterComponentsSizeFromComponent.bind(this, pa)
          ), ma.addPostChangeTextListener(this.checkTextComponentMaxWidth.bind(this, pa)), ma.addPostChangeTextListener(pa.syncFrameSize), Jo.setParentComponent(Kn), Jo.setMutationPermissions(va), Jo.addMutationListener(pa.syncFrameSize), qn = Jo;
          break;
        }
        case GraphicType.FIGURE: {
          qn = new FigureGraphic(), qn.setParentComponent(Kn);
          break;
        }
        case GraphicType.LINE: {
          qn = new LineGraphic(), qn.setParentComponent(Kn);
          break;
        }
        default:
          throw new EditorError(`graphic type "${Un}" not found`);
      }
      return qn;
    });
    Ca(this, "configurePageGraphic", (Un) => {
      this.injectTopPageHeader(
        this.dependencies.camera,
        this.dependencies.render,
        this.dependencies.useCases,
        Un,
        this.dependencies.areaController
      ), this.injectBottomPageHeader(
        this.dependencies.camera,
        this.dependencies.render,
        this.dependencies.useCases,
        Un,
        this.dependencies.areaController
      ), Un.setFileSourcePrefix(this.dependencies.imageFileSourcePrefix), Un.getBackgroundImageState().addMutationListener(this.applyAllPagesChanges.bind(this, Un)), Un.addPostPictureUpdateListener(this.dependencies.render.renderRelativePositions);
    });
    Ca(this, "configurePictureGraphic", (Un) => {
      Un.addMutationListener(this.enablePictureActionLayer.bind(this, Un)), Un.addPostEnableHoverListener(this.enablePictureActionLayer.bind(this, Un)), Un.addPostEnableFocusListener(this.enablePictureActionLayer.bind(this, Un)), Un.addPostDisableHoverListener(this.disablePictureActionLayer.bind(this, Un)), Un.addPostDisableFocusListener(this.disablePictureActionLayer.bind(this, Un)), Un.addPostPictureUpdateListener(this.dependencies.render.renderRelativePositions), Un.addPostLoadingAnimationListener(this.dependencies.render.render), Un.setFileSourcePrefix(this.dependencies.imageFileSourcePrefix);
    });
    Ca(this, "enablePictureActionLayer", async (Un) => {
      Un.enablePictureActionLayer();
      const { width: Kn, height: qn } = Un.getFrameConfiguration();
      if (Kn > this.MIN_WIDTH_FOR_PICTURE_ACTION_LAYER_DISPLAY && qn > this.MIN_HEIGHT_FOR_PICTURE_ACTION_LAYER_DISPLAY) {
        Un.disableCompactActionLayerMode();
        return;
      }
      Un.enableCompactActionLayerMode();
    });
    Ca(this, "disablePictureActionLayer", (Un) => {
      Un.isEnableFocus() || Un.disablePictureActionLayer();
    });
    /**
     * Проверяет ширину графики и если ширина больше ширины страницы - отключит autoWidth.
     */
    Ca(this, "checkTextComponentMaxWidth", async (Un) => {
      const Kn = Un.getGraphics();
      if (Kn.length === 0)
        throw new EditorError("graphics not found");
      const qn = this.dependencies.componentTree.getRootComponent();
      for (let Jo = 0; Jo < Kn.length; Jo++) {
        const pa = Kn[Jo], ma = pa.getRootGraphicNumber();
        if (ma === null)
          throw new EditorError("not connected to page");
        const va = qn.getGraphicFromNumber(ma);
        if (va === null)
          throw new EditorError("page not found");
        const ba = pa.getParentGraphic();
        if (ba === null)
          throw new EditorError("parent graphic is null");
        ba === va && await this.resizeGraphicsForTextOverflow(pa, ba);
      }
    });
    /**
     * Обеспечивает корректное отображение текста на странице,
     * предотвращая его выход за границы доступного пространства
     * и обеспечивая правильное визуальное отображение контента.
     * @param graphic
     * @param parentGraphic
     */
    Ca(this, "resizeGraphicsForTextOverflow", async (Un, Kn) => {
      const qn = this.dependencies.componentTree.getRootComponent(), Jo = Kn.getFrameConfiguration().width, { paddingRight: pa } = Kn.getTexture(), ma = Un.getParentComponent(), va = qn.getRelativePagePosition(Un), _a = Un.getGraphicObject().object.width, ya = Jo - pa;
      if (va.x + _a > ya) {
        const wa = ma.getTextModel();
        ma.disableAutoWidth(), Un.disableAutoWidth();
        let Ta = ya - va.x;
        Ta < this.MIN_TEXT_WIDTH && (Ta = this.DEFAULT_TEXT_WIDTH), Un.setFrameConfiguration((Sa) => ({
          ...Sa,
          width: Ta
        })), await ma.syncFrameSize(), this.dependencies.render.render(), wa.syncModelWithViews();
      }
    });
    // TODO перенести в PasteCoordinator
    /**
     * Устанавливает стандартную ширину текста после вставки,
     * если ширина меньше минимальной допустимой для вставки.
     * @param graphic
     */
    Ca(this, "resizeGraphicsAfterOverflow", async (Un) => {
      const Kn = Un.getParentComponent();
      Un.getFrameConfiguration().width < this.MIN_TEXT_WIDTH && (Un.setFrameConfiguration((Jo) => ({
        ...Jo,
        width: this.DEFAULT_TEXT_WIDTH
      })), await Kn.syncFrameSize());
    });
    Ca(this, "applyAllPagesChanges", async (Un) => {
      const Kn = Un.getTexture(), Jo = this.dependencies.componentTree.getRootComponent().getGraphics();
      await Promise.all(
        Jo.map(async (pa) => {
          pa !== Un && await pa.setTexture(() => Kn);
        })
      );
    });
  }
}
class TableGridMutator {
  constructor() {
    Ca(this, "postMutationListeners");
    /**
     * Объединяет ячейки в фокусе.
     * @param component компонент таблицы, в которой будет происходить объединение.
     */
    Ca(this, "mergeFocusCell", async (zn) => {
      const Un = zn.getCellContexts(), Kn = zn.getFocusCellContexts();
      if (Kn === null || Kn.length < 2 || !this.validateMerge(Kn))
        return;
      let Jo = Number.MAX_SAFE_INTEGER, pa = Number.MAX_SAFE_INTEGER;
      const ma = [];
      for (let xa = 0; xa < Kn.length; xa++) {
        const { row: wa, column: Ta, content: Sa } = Kn[xa].getTexture();
        Jo > wa && (Jo = wa), pa > Ta && (pa = Ta), ma.push(Sa.tokens);
      }
      const va = Un.filter((xa) => {
        const { row: wa, column: Ta } = xa.getTexture();
        return Jo === wa && Ta === pa;
      })[0];
      if (va === void 0)
        throw new EditorError("target cell not found");
      let ba = 0, _a = 0;
      for (let xa = 0; xa < Kn.length; xa++) {
        const {
          row: wa,
          column: Ta,
          rowSpan: Sa,
          columnSpan: Ma
        } = Kn[xa].getTexture();
        wa === Jo && (_a += Ma), Ta === pa && (ba += Sa);
      }
      const ya = [];
      if (Un.forEach((xa) => {
        const wa = xa.getTexture();
        xa === va && (wa.rowSpan = ba, wa.columnSpan = _a, wa.content.tokens = ma.flat(), ya.push(wa)), Kn.includes(xa) || ya.push(wa);
      }), await this.applyChanges(zn, ya), !zn.focusOnlyCellContextByID(va.getID()))
        throw new EditorError("error focus only cell");
    });
    /**
     * Разбивает объединенные ячейки.
     * @param component компонент таблицы, в которой будет происходить разбивка.
     */
    Ca(this, "splitFocusCells", async (zn) => {
      const Un = zn.getCellContexts(), Kn = zn.getFocusCellContexts();
      if (Kn === null || !this.validateSplit(Kn))
        return;
      const Jo = [], pa = [];
      Kn.forEach((va) => {
        const ba = va.getTexture();
        if (ba.columnSpan === 1 && ba.rowSpan === 1) {
          pa.push(ba);
          return;
        }
        for (let _a = ba.row; _a < ba.row + ba.rowSpan; _a++)
          for (let ya = ba.column; ya < ba.column + ba.columnSpan; ya++) {
            const xa = this.getSingleCellTexture(_a, ya, ba.background);
            Jo.push(xa), pa.push(xa);
          }
        Jo[0].content.tokens = ba.content.tokens;
      }), Un.forEach((va) => {
        if (Kn.includes(va))
          return;
        const _a = va.getTexture();
        pa.push(_a);
      }), await this.applyChanges(zn, pa);
      const ma = Jo[0];
      zn.focusOnlyCellContextByID(ma.id);
    });
    /**
     * Удаляет колонки, которые пересекают ячейки в фокусе.
     * @param component компонент, в котором будет происходить удаление колонок.
     */
    Ca(this, "deleteFocusColumns", async (zn) => {
      const Un = zn.getFocusCellContexts();
      if (Un === null)
        return;
      const Kn = this.getColumnIndexes(Un);
      if (Kn.length !== zn.getColumnCount())
        for (let qn = 0; qn < Kn.length; qn++)
          await this.deleteColumn(zn, Kn[qn] - qn);
    });
    /**
     * Удаляет строки, которые пересекают ячейки в фокусе.
     * @param component компонент таблицы, в котором будет происходить удаление строк.
     */
    Ca(this, "deleteFocusRows", async (zn) => {
      const Un = zn.getFocusCellContexts();
      if (Un === null)
        return;
      const Kn = this.getRowIndexes(Un);
      if (Kn.length !== zn.getRowCount())
        for (let qn = 0; qn < Kn.length; qn++)
          await this.deleteRow(zn, Kn[qn] - qn);
    });
    /**
     * Добавляет новую колонку таблицы перед самой крайней слева ячейкой в фокусе.
     * @param component - компонент таблицы, в котором происходит добавление колонок.
     */
    Ca(this, "addColumnBefore", async (zn) => {
      const Un = zn.getLeftmostColumnIndex();
      if (Un === null) return;
      const Kn = zn.getTexture().cells, qn = _$2.cloneDeep(Kn);
      for (let va = 0; va < qn.length; va++) {
        const ba = qn[va];
        ba.columnSpan > 1 && Un > ba.column && Un <= ba.column + ba.columnSpan - 1 && (ba.columnSpan += 1), ba.column >= Un && (ba.column += 1);
      }
      const Jo = Kn.filter((va) => va.column === Un);
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va], _a = this.getSingleCellTexture(ba.row, Un, ba.background);
        _a.content.tokens = this.getStylesFromPattern(_a, ba), _a.rowSpan = ba.rowSpan, qn.push(_a);
      }
      const pa = zn.getDefaultColumnWidth(), ma = zn.getColumnWidths();
      ma.splice(Un, 0, pa), zn.mutateColumnWidths(ma), await this.applyChanges(zn, qn);
    });
    /**
     * Добавляет новые колонки таблицы после самой крайней справа ячейки в фокусе.
     * @param component - компонент таблицы в которой происходит добавление колонок.
     */
    Ca(this, "addColumnAfter", async (zn) => {
      const Un = zn.getRightmostColumnIndex();
      if (Un === null) return;
      const Kn = zn.getTexture().cells, qn = _$2.cloneDeep(Kn);
      for (let va = 0; va < qn.length; va++) {
        const ba = qn[va];
        ba.columnSpan > 1 && Un >= ba.column && Un < ba.column + ba.columnSpan - 1 && (ba.columnSpan += 1), ba.column > Un && (ba.column += 1);
      }
      const Jo = Kn.filter(
        (va) => va.column === Un && va.columnSpan === 1 || Un === va.column + va.columnSpan - 1
      );
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va], _a = this.getSingleCellTexture(ba.row, Un + 1, ba.background);
        _a.content.tokens = this.getStylesFromPattern(_a, ba), _a.rowSpan = ba.rowSpan, qn.push(_a);
      }
      const pa = zn.getDefaultColumnWidth(), ma = zn.getColumnWidths();
      ma.splice(Un + 1, 0, pa), zn.mutateColumnWidths(ma), await this.applyChanges(zn, qn);
    });
    /**
     * Добавляет новую строку ПОД выделенными ячейками (новая строка будет находиться над самой верхней ячейкой в
     * выделении).
     * @param component - Компонент таблицы.
     */
    Ca(this, "addRowUnder", async (zn) => {
      const Un = zn.getLowestIndex();
      if (Un === null) return;
      const Kn = zn.getTexture().cells, qn = _$2.cloneDeep(Kn);
      for (let va = 0; va < qn.length; va++) {
        const ba = qn[va];
        ba.rowSpan > 1 && Un >= ba.row && Un < ba.row + ba.rowSpan - 1 && (ba.rowSpan += 1), ba.row > Un && (ba.row += 1);
      }
      const Jo = Kn.filter(
        (va) => va.row === Un && va.rowSpan === 1 || Un === va.row + va.rowSpan - 1
      );
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va], _a = this.getSingleCellTexture(Un + 1, ba.column, ba.background);
        _a.content.tokens = this.getStylesFromPattern(_a, ba), _a.columnSpan = ba.columnSpan, qn.push(_a);
      }
      const pa = zn.getDefaultRowHeight(), ma = zn.getRowHeights();
      ma.splice(Un + 1, 0, pa), zn.mutateRowHeights(ma), await this.applyChanges(zn, qn);
    });
    /**
     * Добавляет новую строку НАД выделенными ячейками новая строка будет находиться над самой верхней ячейков в
     * выделении.
     * @param component - Компонент таблицы.
     */
    Ca(this, "addRowOver", async (zn) => {
      const Un = zn.getHighestIndex();
      if (Un === null) return;
      const Kn = zn.getTexture().cells, qn = _$2.cloneDeep(Kn);
      for (let va = 0; va < qn.length; va++) {
        const ba = qn[va];
        ba.rowSpan > 1 && Un > ba.row && Un <= ba.row + ba.rowSpan - 1 && (ba.rowSpan += 1), ba.row >= Un && (ba.row += 1);
      }
      const Jo = Kn.filter((va) => va.row === Un);
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va], _a = this.getSingleCellTexture(Un, ba.column, ba.background);
        _a.content.tokens = this.getStylesFromPattern(_a, ba), _a.columnSpan = ba.columnSpan, qn.push(_a);
      }
      const pa = zn.getDefaultRowHeight(), ma = zn.getRowHeights();
      ma.splice(Un, 0, pa), zn.mutateRowHeights(ma), await this.applyChanges(zn, qn);
    });
    Ca(this, "addPostMutationListener", (zn) => {
      this.postMutationListeners.push(zn);
    });
    Ca(this, "applyChanges", async (zn, Un) => {
      await zn.mutateCellTextures(Un), zn.applyMutations(), zn.getCellContexts().forEach((qn) => qn.enableMutationMode()), this.callPostMutationListeners(zn);
    });
    Ca(this, "callPostMutationListeners", (zn) => {
      this.postMutationListeners.forEach((Un) => Un(zn));
    });
    /**
     * Возвращает массив индексов колонок, которые пересекают ячейки, отсортированный по возрастанию.
     * @param contexts ячейки.
     */
    Ca(this, "getColumnIndexes", (zn) => {
      const Un = /* @__PURE__ */ new Set();
      return zn.forEach((Kn) => {
        const { column: qn, columnSpan: Jo } = Kn.getTexture();
        for (let pa = qn; pa < qn + Jo; pa++)
          Un.add(pa);
      }), [...Un].sort();
    });
    /**
     * Возвращает массив индексов строк, которые пересекают ячейки, отсортированный по возрастанию.
     * @param contexts ячейки.
     */
    Ca(this, "getRowIndexes", (zn) => {
      const Un = /* @__PURE__ */ new Set();
      return zn.forEach((Kn) => {
        const { row: qn, rowSpan: Jo } = Kn.getTexture();
        for (let pa = qn; pa < qn + Jo; pa++)
          Un.add(pa);
      }), [...Un].sort((Kn, qn) => Kn - qn);
    });
    /**
     * Удаляет колонку по индексу.
     * @param component компонент таблицы.
     * @param targetIndex индекс колонки для удаления.
     */
    Ca(this, "deleteColumn", async (zn, Un) => {
      const Kn = zn.getTexture().cells, qn = _$2.cloneDeep(Kn);
      for (let pa = 0; pa < qn.length; pa++) {
        const ma = qn[pa];
        ma.columnSpan > 1 && (Un >= ma.column && Un <= ma.column + ma.columnSpan - 1 && (ma.columnSpan -= 1), ma.column === Un && (ma.column += 1)), ma.column === Un && (qn.splice(pa, 1), pa--), ma.column > Un && (ma.column -= 1);
      }
      const Jo = zn.getColumnWidths();
      Jo.splice(Un, 1), zn.mutateColumnWidths(Jo), await this.applyChanges(zn, qn);
    });
    /**
     * Удаляет строку по индексу.
     * @param component компонент таблицы.
     * @param targetIndex индекс строки для удаления.
     */
    Ca(this, "deleteRow", async (zn, Un) => {
      const Kn = zn.getTexture().cells, qn = _$2.cloneDeep(Kn);
      for (let pa = 0; pa < qn.length; pa++) {
        const ma = qn[pa];
        ma.rowSpan > 1 && (Un >= ma.row && Un <= ma.row + ma.rowSpan - 1 && (ma.rowSpan -= 1), ma.row === Un && (ma.row += 1)), ma.row === Un && (qn.splice(pa, 1), pa--), ma.row > Un && (ma.row -= 1);
      }
      const Jo = zn.getRowHeights();
      Jo.splice(Un, 1), zn.mutateRowHeights(Jo), await this.applyChanges(zn, qn);
    });
    /**
     * Выполняет проверку, образуют ли ячейки правильный прямоугольник. Вычисляет площадь ожидаемого
     * прямоугольника и сравнивает её с площадью ячеек.
     * @param contexts Контексты ячеек таблицы.
     */
    Ca(this, "validateMerge", (zn) => {
      let Un = Number.MAX_SAFE_INTEGER, Kn = Number.MAX_SAFE_INTEGER, qn = Number.MIN_SAFE_INTEGER, Jo = Number.MIN_SAFE_INTEGER;
      zn.forEach((_a) => {
        const { column: ya, row: xa, columnSpan: wa, rowSpan: Ta } = _a.getTexture();
        Un = Math.min(Un, ya), Kn = Math.min(Kn, xa), qn = Math.max(qn, ya + wa), Jo = Math.max(Jo, xa + Ta);
      });
      const pa = qn - Un, ma = Jo - Kn, va = pa * ma;
      let ba = 0;
      return zn.forEach((_a) => {
        const { columnSpan: ya, rowSpan: xa } = _a.getTexture();
        ba += ya * xa;
      }), va === ba;
    });
    Ca(this, "validateSplit", (zn) => {
      let Un = !1;
      return zn.forEach((Kn) => {
        const { rowSpan: qn, columnSpan: Jo } = Kn.getTexture();
        (qn > 1 || Jo > 1) && (Un = !0);
      }), Un;
    });
    Ca(this, "getSingleCellTexture", (zn, Un, Kn) => ({
      id: Utils.generate.uuid4(),
      column: Un,
      row: zn,
      background: Kn,
      rowSpan: 1,
      content: {
        tokens: [],
        textAlign: TextAlign.LEFT,
        splitGraphemePositions: [],
        id: Utils.generate.uuid4(),
        lineHeight: LineHeight.MEDIUM
      },
      columnSpan: 1
    }));
    Ca(this, "getStylesFromPattern", (zn, Un) => {
      const Kn = zn.content.tokens.find((pa) => pa.type === TokenType.TEXT), qn = Un.content.tokens.find((pa) => pa.type === TokenType.TEXT), Jo = [...zn.content.tokens];
      for (let pa = 0; pa < Jo.length; pa++)
        Jo[pa].type === TokenType.TEXT && (Jo[pa] = { ...qn, value: Kn.value });
      return Jo;
    });
    Ca(this, "validateControlPosition", (zn, Un, Kn) => zn.row === Kn && zn.column === Un);
    this.postMutationListeners = [];
  }
}
class ComponentSelectorArea extends SelectionArea {
  constructor() {
    super();
    Ca(this, "DELAY_HIGHLIGHT_PX", 4);
    Ca(this, "registerComponentCross", () => {
      const Un = this.dependencies.componentTree.getComponents(), Kn = this.getArea(), qn = this.getCrossComponentsFromArea(Kn);
      if (qn === null) {
        Un.forEach((Jo) => {
          Jo.disableFocus();
        });
        return;
      }
      Un.forEach((Jo) => {
        qn.includes(Jo) ? Jo.enableFocus() : Jo.disableFocus();
      });
    });
    Ca(this, "getCrossComponentsFromArea", (Un) => {
      const qn = this.dependencies.areaController.getAreas().filter((pa) => pa.type === SpatialCanvasAreaType.GRAPHIC);
      if (qn.length === 0)
        return null;
      const Jo = [];
      return qn.forEach((pa) => {
        const ma = pa.getGlobalFrameArea();
        if (Utils.geometry.isCrossedAreas(Un, ma)) {
          const { graphic: ba } = pa.getData(), _a = ba.getParentComponent();
          if (_a === null)
            return;
          Jo.push(_a);
        }
      }), Jo;
    });
    this.setDelayCreateAreaPx(this.DELAY_HIGHLIGHT_PX), this.addPostUpdateAreaListener(this.registerComponentCross);
  }
}
class CopyController extends Dependent {
  constructor() {
    super(...arguments);
    /**
     * MIME-тип для хранения отформатированной строки в буфере
     */
    Ca(this, "fragmentMIME", "web wakadoo/fragment");
    /**
     * Копирует компоненты, находящиеся в фокусе или текстовый диапазон в зависимости от того, есть ли в фокусе текстовый редактор в режиме редактирования.
     * @param focusComponents
     */
    Ca(this, "copy", async (Un) => {
      const Kn = Un[0];
      Kn.isEnableEditMode() ? await this.copyTextFromComponent(Kn) : await this.dependencies.componentCloner.copy(Un);
    });
    /**
     * Копирует в буфер обмена текст из переданного компонента.
     * @param component Источник текста.
     */
    Ca(this, "copyTextFromComponent", async (Un) => {
      if (Un.type === EditorComponentType.TEXT) {
        this.dependencies.textEngine.isModelInEditMode(Un);
        const Kn = Un.getTextModel();
        await this.copyText(Kn);
        return;
      }
      if (Un.type === EditorComponentType.TABLE) {
        const Kn = Un.getFocusCellContexts();
        if (Kn === null)
          return;
        const qn = Kn.find((pa) => this.dependencies.textEngine.isModelInEditMode(pa));
        if (qn === void 0)
          throw new EditorError("not have editable cell");
        const Jo = qn.getTextModel();
        await this.copyText(Jo);
        return;
      }
    });
    Ca(this, "copyText", async (Un) => {
      const Kn = Un.getFocusTextTokens(), qn = Kn === null ? Un.getTokens() : Kn, Jo = this.getText(qn), pa = new Blob([JSON.stringify(qn)], { type: this.fragmentMIME }), ma = new Blob([Jo], { type: "text/plain" }), va = [new ClipboardItem({
        [this.fragmentMIME]: pa,
        "text/plain": ma
        // 'text/html': html,
      })];
      return await navigator.clipboard.write(va), !0;
    });
    Ca(this, "getText", (Un) => Un.map((Kn) => Kn.value).join(""));
  }
}
class EditModeContext {
  constructor() {
    Ca(this, "currentEditContext");
    Ca(this, "getCurrentEditContext", () => this.currentEditContext);
    Ca(this, "setCurrentEditContext", (zn) => {
      this.currentEditContext = zn;
    });
    this.currentEditContext = null;
  }
}
class PasteController extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "PNG", "image/png");
    Ca(this, "JPEG", "image/jpeg");
    Ca(this, "HTML", "text/html");
    Ca(this, "plainText", "text/plain");
    Ca(this, "wakadooText", "web wakadoo/fragment");
    Ca(this, "pasteAtPosition", async (Un, Kn) => {
      await this.onPaste(Un, Kn);
    });
    Ca(this, "pasteInComponents", async (Un) => {
      await this.onPaste(Un);
    });
    Ca(this, "pasteFromBuffer", async () => {
      await this.onPaste();
    });
    /**
     * Читает данные из буфера обмена.
     */
    Ca(this, "readInBuffer", async () => {
      const Un = await navigator.clipboard.read(), Kn = [], qn = ["image/png", "image/jpeg", "text/html", "web wakadoo/fragment", "text/plain"];
      for (const Jo of Un)
        for (const pa of qn)
          if (Jo.types.includes(pa)) {
            const ma = await Jo.getType(pa), va = await ma.text();
            Kn.push({ type: pa, blob: ma, text: va });
          }
      return Kn;
    });
    /**
     * Координирует данные для последующей вставки.
     * @param focusComponents - компоненты, в которые будет производиться вставка текста.
     * @param position - позиция для вставки компонента.
     */
    Ca(this, "onPaste", async (Un, Kn) => {
      const qn = await this.readInBuffer();
      if (!qn.length) return;
      const Jo = this.getBlobByTypes(qn, [this.plainText]), pa = this.getBlobByTypes(qn, [this.HTML]), ma = this.getBlobByTypes(qn, [this.PNG, this.JPEG]), va = this.getBlobByTypes(qn, [this.wakadooText]);
      try {
        if (pa && this.isTable(pa.text)) {
          await this.pasteTableComponent(pa.text);
          return;
        }
        if (ma) {
          await this.pastePictureComponent(ma.blob);
          return;
        }
        if (va && Un && Un.length === 1 && Un[0].type === EditorComponentType.TEXT && Un[0].isEnableEditMode()) {
          const ba = JSON.parse(va.text);
          this.pasteTokensToComponent(Un[0], ba);
          return;
        }
        if (pa) {
          const ba = this.extractPlainText(pa.text), _a = this.convertBlobTextToTokens(ba);
          Un && this.isEditableFocusedComponent(Un) ? this.pasteTokensToComponent(Un[0], _a) : await this.dependencies.textImporter.importText(_a);
          return;
        }
        if (Jo) {
          const ba = this.convertBlobTextToTokens(Jo.text);
          Un && this.isEditableFocusedComponent(Un) ? this.pasteTokensToComponent(Un[0], ba) : await this.dependencies.textImporter.importText(ba);
        }
        va && await this.pasteJSONComponent(va.text, Kn);
      } catch (ba) {
        console.error("Error while pasting:", ba);
      }
    });
    Ca(this, "getBlobByTypes", (Un, Kn) => Un.filter((qn) => Kn.includes(qn.type))[0]);
    Ca(this, "isTable", (Un) => {
      const Kn = /<table[\S\s]*?>/i.test(Un), qn = /<tr[\S\s]*?>/i.test(Un), Jo = /<td[\S\s]*?>/i.test(Un);
      return Kn && qn && Jo;
    });
    Ca(this, "pastePictureComponent", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      Kn !== null ? await this.dependencies.pictureReplacer.replacePicture(Kn, Un) : await this.dependencies.pictureImporter.importPicture(Un);
    });
    Ca(this, "pasteTableComponent", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(EditorComponentType.TABLE);
      Kn !== null ? await this.dependencies.htmlTableReplacer.replaceTable(Kn, Un) : await this.dependencies.htmlTableImporter.importTable(Un);
    });
    Ca(this, "extractPlainText", (Un) => new DOMParser().parseFromString(Un, "text/html").body.textContent || "");
    /**
     * Достает из буфера обмена скопированные структуры компонентов и указатель на ID скетча,
     * где последний раз происходила вставка.
     * @param bufferData - данные из буфера обмена
     */
    Ca(this, "pullClipBoard", (Un) => {
      const Kn = Un.substring(5);
      let qn;
      try {
        qn = JSON.parse(Kn);
      } catch (Jo) {
        throw new EditorError(Jo);
      }
      return qn;
    });
    /**
     * Извлекает из буфера обмена скопированный токен текста
     * @return возвращает токен текста в виде строки или массива токенов.
     */
    Ca(this, "convertBlobTextToTokens", (Un) => {
      let Kn = [];
      try {
        if (Un.startsWith("TEXT:")) {
          const qn = Un.substring(5);
          Kn = JSON.parse(qn);
        } else {
          const qn = [];
          qn.push(Utils.text.getDefaultTextToken(Un));
          const Jo = JSON.stringify(qn);
          Kn = JSON.parse(Jo);
        }
      } catch (qn) {
        console.log(qn.message);
      }
      return Kn;
    });
    /**
     * Достает из буфера обмена первую графику первого скопированного компонента для расчета позиции при вставке.
     * @param bufferData - данные из буфера обмена
     */
    Ca(this, "getBufferFirstGraphic", async (Un) => {
      const Kn = Un.substring(5);
      let qn;
      try {
        qn = JSON.parse(Kn);
      } catch (ma) {
        throw new EditorError(ma);
      }
      if (qn === null)
        throw new EditorError("clonerClipboard is null");
      if (qn.structures.length === 0)
        throw new EditorError("buffer is empty");
      const Jo = new ComponentBuilder();
      return Jo.connectDependencies({
        graphicFactory: this.dependencies.graphicFactory,
        componentFactory: this.dependencies.componentFactory
      }), Jo.injectDependencies(), await Jo.scanStructure(qn.structures[0]), Jo.getComponent().getGraphics()[0];
    });
    /**
     * Запускает событие вставки текста в компонент.
     * @param component Компонент, в который вставляется текст.
     */
    Ca(this, "pasteTokensToComponent", (Un, Kn) => {
      if (Un.type === EditorComponentType.TEXT) {
        if (!this.dependencies.textEngine.isModelInEditMode(Un))
          return;
        Un.getTextModel().action({ type: TextEventType.INSERT_TOKENS, data: { tokens: Kn } });
      }
      if (Un.type === EditorComponentType.TABLE && Un.getFocusCellContexts()) {
        const qn = Un.getFocusCellContexts();
        if (qn === null) return;
        const Jo = qn.find((ma) => this.dependencies.textEngine.isModelInEditMode(ma));
        if (Jo === void 0)
          throw new EditorError("not have editable cell");
        Jo.getTextModel().action({ type: TextEventType.INSERT_TOKENS, data: { tokens: Kn } });
      }
    });
  }
  async pasteJSONComponent(Un, Kn) {
    const qn = this.pullClipBoard(Un), Jo = await this.getBufferFirstGraphic(Un), pa = Kn || this.dependencies.mouseObserver.getCurrentPosition();
    await this.dependencies.componentCloner.pasteAtPosition(pa, Jo, qn);
  }
  isEditableFocusedComponent(Un) {
    if (Un === null)
      throw new EditorError("focus components is null");
    return Un[0].isEnableEditMode();
  }
}
class ComponentCloner extends Dependent {
  constructor() {
    super();
    Ca(this, "FRAGMENT_MIME", "web wakadoo/fragment");
    Ca(this, "postPasteListeners");
    Ca(this, "componentBuilders");
    Ca(this, "syncLayers", (Un, Kn, qn) => {
      if (Un.graphicIdentities.length === 0)
        throw new EditorError("graphics not found", { postPasteLayers: Un });
      const Jo = qn.get(Un.graphicIdentities[0]);
      if (Jo === void 0)
        throw new EditorError("first graphic not found");
      Kn.mutateByChangeLayer(Un.baseGraphic, Jo);
      for (let pa = 0; pa < Un.graphicIdentities.length - 1; ++pa) {
        const ma = qn.get(Un.graphicIdentities[pa]), va = qn.get(Un.graphicIdentities[pa + 1]);
        if (ma === void 0 || va === void 0)
          throw new EditorError("graphic not found", {
            prevGraphic: { value: ma },
            graphic: { value: va }
          });
        Kn.mutateByChangeLayer(ma, va);
      }
    });
    /**
     * Вставляет компоненты из буфера на страницу в переданную позицию.
     */
    Ca(this, "pasteAtPosition", async (Un, Kn, qn) => {
      const ma = this.dependencies.componentTree.getRootComponent().getNearestGraphic(Un).getGlobalPosition(), va = Kn.getFrameConfiguration(), ba = Un.x - ma.x - va.x, _a = Un.y - ma.y - va.y, ya = {
        x: ba,
        y: _a
      };
      await this.pullComponentBuilders(qn), await this.injectComponents((xa) => this.correctStructuresToPosition(xa, ya));
    });
    /**
     * Получает компоненты в фокусе и записывает в буфер их структуры.
     */
    Ca(this, "copy", async (Un) => {
      const Kn = [], qn = this.dependencies.componentTree.getLayerSequences(), Jo = /* @__PURE__ */ new Map();
      for (let pa = 0; pa < Un.length; pa++) {
        const ma = Un[pa], { graphicFactory: va, componentFactory: ba } = this.dependencies, _a = new ComponentBuilder();
        _a.connectDependencies({
          graphicFactory: va,
          componentFactory: ba
        }), _a.injectDependencies(), await _a.scanComponent(ma, qn);
        const xa = _a.getComponentAll().filter(
          (wa) => wa.type === EditorComponentType.TABLE
        );
        this.fillCopyToOriginalComponents(ma, _a.getComponent(), Jo), this.correctComponentPositionInCopy(_a.getComponent(), Jo), xa.length !== 0 && await this.compressTableComponents(...xa), await this.compressUniterComponents(Jo, _a.getComponent(), ma), Kn.push(_a);
      }
      await this.saveToBuffer(Kn);
    });
    Ca(this, "pasteWithAlt", async (Un) => {
      if (Un[0].getFirstGraphic() !== null && !this.dependencies.componentTree.hasEditableComponent()) {
        for (let qn = 0; qn < Un.length; qn++) {
          const Jo = Un[qn], { graphicFactory: pa, componentFactory: ma } = this.dependencies, va = new ComponentBuilder();
          va.connectDependencies({
            graphicFactory: pa,
            componentFactory: ma
          }), va.injectDependencies(), await va.scanStructure(Jo.getUniqueStructure()), this.componentBuilders.push(va);
        }
        await this.injectComponents((qn) => qn);
      }
    });
    Ca(this, "addPostPasteListener", (...Un) => {
      this.postPasteListeners.push(...Un);
    });
    /**
     * Корректирует позицию компонента на основе глобальной позиции оригинального компонента.
     * @param component Скопированный компонент с оригинального без привязки к дереву
     * @param copyToOriginalComponents Отражение копии компонента к его оригиналу
     */
    Ca(this, "correctComponentPositionInCopy", (Un, Kn) => {
      const qn = Kn.get(Un);
      if (qn === void 0)
        throw new EditorError("original component not found");
      const Jo = Un.getGraphics(), pa = qn.getGraphics();
      if (Jo.length !== pa.length)
        throw new EditorError("incorrect graphs");
      for (let ma = 0; ma < Jo.length; ++ma) {
        const va = pa[ma].getGlobalPosition();
        Jo[ma].setFrameConfiguration((ba) => ({
          ...ba,
          x: va.x,
          y: va.y
        }));
      }
    });
    /**
     * Заполняет отражение копии компонента к его оригиналу включая все его вложенные компоненты.
     * @param component Оригинальный компонент, привязанный к дереву компонентов.
     * @param copyComponent Скопированный компонент с оригинального без привязки к дереву.
     * @param copyToOriginalComponents Отражение копии компонента к его оригиналу.
     */
    Ca(this, "fillCopyToOriginalComponents", (Un, Kn, qn) => {
      const Jo = [Un, ...Un.getComponentAll()], pa = [Kn, ...Kn.getComponentAll()];
      if (Jo.length !== pa.length)
        throw new EditorError("count components mismatched");
      Jo.forEach((ma, va) => {
        qn.set(pa[va], ma);
      });
    });
    /**
     * Записывает компоненты в ComponentBuilders для последующей вставки.
     * @param clonerClipboard - интерфейс для хранения коомпонентов
     */
    Ca(this, "pullComponentBuilders", async (Un) => {
      if (Un !== null)
        for (let Kn = 0; Kn < Un.structures.length; Kn++) {
          const qn = Un.structures[Kn], { graphicFactory: Jo, componentFactory: pa } = this.dependencies, ma = new ComponentBuilder();
          ma.connectDependencies({
            graphicFactory: Jo,
            componentFactory: pa
          }), ma.injectDependencies(), await ma.scanStructure(qn), this.componentBuilders.push(ma);
        }
      return Un;
    });
    Ca(this, "callPostPasteListeners", () => {
      this.postPasteListeners.forEach((Un) => Un());
    });
    /**
     * Перемещает структуру в позицию `position` на странице в фокусе.
     * @param component Обрабатываемый компонент.
     * @param positionOffset - Сдвиг, насколько должна измениться позиция графики.
     */
    Ca(this, "correctStructuresToPosition", (Un, Kn) => (Un.getGraphics().forEach((Jo) => {
      Jo.setFrameConfiguration((pa) => ({
        ...pa,
        x: pa.x + Kn.x,
        y: pa.y + Kn.y
      }));
    }), Un));
    /**
     * Вставляет компоненты в корневой компонент, предварительно обработав их пришедшим обработчиком.
     * @param process Обработчик компонента.
     */
    Ca(this, "injectComponents", async (Un) => {
      this.componentBuilders.map((qn) => qn.getComponent()).forEach((qn) => {
        Un(qn);
      }), await this.pasteComponents();
    });
    /**
     * Сжимает компоненты таблиц до одной графики.
     * @param tables Компоненты таблиц для сжатия.
     */
    Ca(this, "compressTableComponents", async (...Un) => {
      for (let Kn = 0; Kn < Un.length; Kn++) {
        const qn = Un[Kn], Jo = qn.getStructure();
        if (Jo.graphics === null)
          continue;
        const pa = Jo.graphics.reduce(
          (ba, _a) => _a.texture.rowCount + ba,
          0
        ), ma = qn.getFirstGraphic();
        if (ma === null)
          throw new EditorError("first graphic not found");
        const va = qn.getGraphics();
        for (let ba = 1; ba < va.length; ba++)
          qn.removeGraphic(va[ba]);
        await qn.setTexture((ba) => ({
          ...ba,
          startRows: [0]
        })), await ma.setTexture((ba) => ({
          ...ba,
          rowCount: pa
        }));
      }
      return Un;
    });
    /**
     * Сжимает компонент-объединитель до одной графики.
     * @param copyToOriginalComponents Отражение копии компонента к его оригиналу.
     * @param toCompressCopyComponent Копия компонента.
     * @param toCompressOriginalComponent Оригинальный компонент.
     */
    Ca(this, "compressUniterComponents", async (Un, Kn, qn) => {
      if (!Kn.isUniter || !qn.isUniter)
        return;
      if (!(Kn.isUniter && qn.isUniter))
        throw new EditorError("component types mismatched");
      const Jo = Kn.getGraphics(), pa = qn.getGraphics();
      if (Jo.length <= 1)
        return;
      for (let ba = 1; ba < Jo.length; ba++)
        Kn.removeGraphic(Jo[ba]);
      const ma = [];
      for (let ba = 0; ba < pa.length - 1; ba++) {
        const _a = pa[ba], ya = pa[ba + 1], xa = _a.getFrameConfiguration(), wa = _a.getGlobalPosition(), Sa = ya.getGlobalPosition().y - (wa.y + xa.height);
        ma.push(Sa);
      }
      const va = Kn.getComponentAll();
      for (let ba = 0; ba < va.length; ba++) {
        const _a = va[ba], ya = _a.getOffset();
        if (ya === null)
          throw new EditorError("component offset is null");
        if (ya === 0)
          return;
        await _a.setStructure((Na) => ({
          ...Na,
          offset: 0
        }));
        const xa = Un.get(_a);
        if (xa === void 0)
          throw new EditorError("original component not found");
        const wa = xa.getFirstGraphic();
        if (wa === null)
          throw new EditorError("first original graphic not found");
        const Ta = wa.getGlobalPosition(), Sa = qn.getFirstGraphic();
        if (Sa === null)
          throw new EditorError("to compress first original graphic not found");
        const Ma = Sa.getGlobalPosition(), ka = {
          x: Ta.x - Ma.x,
          y: Ta.y - Ma.y
        };
        _a.getGraphics().forEach((Na, Ka) => {
          const Ja = ya - 1, el = ya + Ka - 1;
          let qa = 0;
          for (let tl = Ja; tl <= el; tl++) {
            const Qa = ma[tl];
            if (Qa === void 0)
              throw new EditorError("distance not found");
            qa += Qa;
          }
          Na.setFrameConfiguration((tl) => ({
            ...tl,
            x: ka.x,
            y: ka.y - qa
          }));
        });
      }
    });
    Ca(this, "saveToBuffer", async (Un) => {
      const Kn = {
        structures: [],
        prevSketch: this.dependencies.toPasteSketchID
      };
      Un.forEach((ma) => {
        Kn.structures.push(ma.getUniqueStructure());
      });
      const qn = `JSON:${JSON.stringify(Kn)}`, Jo = new Blob([qn], { type: this.FRAGMENT_MIME }), pa = [
        new ClipboardItem({
          [this.FRAGMENT_MIME]: Jo
        })
      ];
      await navigator.clipboard.write(pa);
    });
    /**
     * Вставляет коллекцию компонентов на самый высокий слой страниц.
     */
    Ca(this, "pasteComponents", async () => {
      const Un = this.dependencies.componentTree.getRootComponent(), Kn = this.dependencies.mouseObserver.getCurrentPosition(), qn = Un.getNearestGraphic(Kn), Jo = Un.getNumberFromGraphic(qn);
      if (Jo === null)
        throw new EditorError("page index not found", { pageIndex: { value: Jo } });
      for (let pa = 0; pa < this.componentBuilders.length; pa++)
        await this.componentBuilders[pa].regenerate();
      this.componentBuilders.forEach((pa) => {
        pa.getLayerSequences();
      }), await this.dependencies.componentTree.executeMutations(async (pa) => {
        for (let ma = 0; ma < this.componentBuilders.length; ma++) {
          const va = this.componentBuilders[ma].getStructure();
          va.offset = Jo;
          const ba = await pa.mutator.mutateByAppendMultiComponent(Un, va);
          this.dependencies.componentTree.syncUniterComponentsSizeFromComponent(ba);
        }
      }), this.callPostPasteListeners(), this.componentBuilders.length = 0;
    });
    this.componentBuilders = [], this.postPasteListeners = [];
  }
}
class BaseComponentGrouper extends Dependent {
  constructor() {
    super(...arguments);
    /**
     * Возвращает результаты проверки компонентов на отсутствие среди них групповых компонентов.
     * @param components - проверяемые компоненты
     */
    Ca(this, "isAllSingleComponent", (Un) => Un.every((Kn) => !Kn.isUniter));
    /**
     * Разбивает компонент группы на самостоятельные компоненты.
     * @param componentUniter Групповой компонент.
     */
    Ca(this, "ungroupGroup", async (Un) => {
      const Kn = Un.getComponents();
      if (Kn === null)
        throw new EditorError("components not found");
      const qn = Un.getParentComponent();
      if (qn === null)
        throw new EditorError("group parent component not found");
      const Jo = Kn.flatMap((ma) => ma.getGraphics()), pa = this.getPostUngroupCorrectPositions(Jo);
      return await this.dependencies.componentTree.executeMutations(async (ma) => {
        const va = ma.layerRegistry.getSequences(), ba = this.getLayerSequenceMap(Jo, va);
        Kn.forEach((xa) => ma.mutator.mutateByRemoveComponent(xa)), ma.mutator.mutateByRemoveComponent(Un), Kn.forEach((xa) => ma.mutator.mutateByAppendComponent(qn, xa));
        const _a = Un.getOffset();
        if (_a === null)
          throw new EditorError("offset is null");
        for (let xa = 0; xa < Kn.length; xa++) {
          const wa = Kn[xa], Ta = wa.getOffset();
          if (Ta === null)
            throw new Error("offset is Null");
          await ma.mutator.mutateByChangeOffset(wa, Ta + _a);
        }
        const ya = this.getPostUngroupingLayers(Jo, va, ba);
        this.syncPostUngroupingLayers(ya, ma.mutator), pa.forEach((xa, wa) => {
          wa.setFrameConfiguration((Ta) => ({
            ...Ta,
            x: Ta.x + xa.x,
            y: Ta.y + xa.y
          }));
        });
      }), Kn;
    });
    /**
     * Возвращает последовательность графики в контексте слоев на каждой странице, игнорируя графику,
     * не переданную графику в `graphics`, учитывая все страницы.
     * @param graphics Графика компонентов.
     * @param globalLayerSequences Глобальная последовательность слоев.
     * @return IGraphic[] Позиция - номер страницы, значение - правильная последовательность графики.
     */
    Ca(this, "getLayerSequenceMap", (Un, Kn) => {
      const qn = Un.map((pa) => pa.getID()), Jo = [];
      for (let pa = 0; pa < Kn.length; pa++) {
        let ma = 0;
        for (let va = 0; va < Kn[pa].length; va++) {
          const ba = qn.indexOf(Kn[pa][va]);
          ba !== -1 && (Jo[pa] === void 0 && (Jo[pa] = []), Jo[pa][ma] = Un[ba], ma++);
        }
      }
      for (let pa = 0; pa < Jo.length; pa++)
        Jo[pa] !== void 0 && (Jo[pa] = Jo[pa].filter((ma) => ma !== void 0));
      return Jo;
    });
    Ca(this, "groupVariousComponents", (Un) => {
      throw new EditorError("not implemented");
    });
    /**
     * Синхронизирует последовательность слоев после объединения компонентов в группу.
     * @param postGroupingLayers Последовательность слоев.
     * @param mutator Мутатор дерева компонентов.
     */
    Ca(this, "syncPostGroupingLayers", (Un, Kn) => {
      Un.layersFromPages.forEach((qn) => {
        if (qn.groupingGraphics.length === 0)
          throw new EditorError("grouping graphics not found", { postGroupingLayers: Un });
        Kn.mutateByChangeLayer(qn.baseGraphic, qn.groupGraphic), Kn.mutateByChangeLayer(qn.groupGraphic, qn.groupingGraphics[0]);
        for (let Jo = 0; Jo < qn.groupingGraphics.length - 1; Jo++)
          Kn.mutateByChangeLayer(qn.groupingGraphics[Jo], qn.groupingGraphics[Jo + 1]);
      });
    });
    /**
     * Устанавливает новые офсеты компонентам, которые были объединены в группу.
     * @param components Компоненты в группе.
     */
    Ca(this, "correctPostGroupingComponentOffsets", async (Un) => {
      const Kn = /* @__PURE__ */ new Map();
      let qn = Number.MAX_SAFE_INTEGER;
      Un.forEach((Jo) => {
        const { offset: pa } = Jo.getStructure();
        if (pa === null)
          throw new EditorError("offset is null");
        pa < qn && (qn = pa), Kn.set(Jo, pa);
      });
      for (let Jo = 0; Jo < Un.length; Jo++)
        await Un[Jo].setStructure((ma) => ({
          ...ma,
          offset: ma.offset === null ? null : ma.offset - qn
        }));
    });
    /**
     * Возвращает стандартные структуры графики группы.
     * @param groupGraphicCount Количество график группы.
     */
    Ca(this, "getDefaultGroupGraphicStructures", (Un) => {
      const Kn = [];
      for (let qn = 0; qn < Un; qn++) {
        const Jo = {
          id: Utils.generate.uuid4(),
          type: GraphicType.GROUP,
          texture: null,
          offset: qn,
          frame: {
            y: 0,
            x: 0,
            height: 0,
            width: 0,
            rotate: 0,
            layer: Number.MAX_SAFE_INTEGER
          }
        };
        Kn.push(Jo);
      }
      return Kn;
    });
    /**
     * Возвращает стандартную структуру группового компонента.
     * @param offset Сдвиг компонента группы.
     */
    Ca(this, "getDefaultGroupStructure", (Un) => ({
      offset: Un,
      graphics: [],
      texture: null,
      components: [],
      id: Utils.generate.uuid4(),
      type: EditorComponentType.GROUP
    }));
    /**
     * Возвращает графику группы.
     * @param groupComponent Компонент группы.
     * @param structures Структуры графики, на основе которой они будут собраны.
     * @param tools Инструменты мутации дерева компонентов.
     */
    Ca(this, "getGroupGraphics", async (Un, Kn, qn) => {
      const Jo = [];
      for (let pa = 0; pa < Kn.length; pa++) {
        const ma = Kn[pa], va = qn.graphicFactory.createGraphic(GraphicType.GROUP, Un);
        await va.setStructure(() => ma), Jo.push(va);
      }
      return Jo;
    });
    /**
     * Возвращает сдвиги позиции компонентов внутри группы после их разделения.
     * @param graphics Графики группы.
     */
    Ca(this, "getPostUngroupCorrectPositions", (Un) => {
      const Kn = /* @__PURE__ */ new Map();
      return Un.forEach((qn) => {
        const Jo = qn.getParentGraphic();
        if (Jo === null)
          throw new EditorError("parent graphic not found");
        const { x: pa, y: ma } = Jo.getFrameConfiguration();
        Kn.set(qn, {
          x: pa,
          y: ma
        });
      }), Kn;
    });
    /**
     * Устанавливает правильную последовательность слоев после разделения группы.
     * @param postUngroupingLayers Правильная последовательность слоев.
     * @param mutator Мутатор для изменения дерева компонентов.
     */
    Ca(this, "syncPostUngroupingLayers", (Un, Kn) => {
      Un.layersFromPages.forEach((qn) => {
        if (qn.groupingGraphics.length === 0)
          throw new EditorError("grouping graphics not found", { postUngroupingLayers: Un });
        Kn.mutateByChangeLayer(qn.baseGraphic, qn.groupingGraphics[0]);
        for (let Jo = 0; Jo < qn.groupingGraphics.length - 1; Jo++)
          Kn.mutateByChangeLayer(qn.groupingGraphics[Jo], qn.groupingGraphics[Jo + 1]);
      });
    });
  }
}
class ComponentGrouper extends BaseComponentGrouper {
  constructor() {
    super(...arguments);
    Ca(this, "groupComponents", (Un) => {
      if (Un.length === 1)
        throw new EditorError("not found components for grouping");
      if (this.isAllSingleComponent(Un))
        return this.groupSingleComponents(Un);
    });
    Ca(this, "ungroupComponents", async (Un) => {
      await Promise.all(
        Un.filter((qn) => qn.isUniter).map(async (qn) => this.ungroupGroup(qn))
      ), this.dependencies.componentTree.getRootComponent().recursiveSyncGraphicsOffset();
    });
    Ca(this, "groupSingleComponents", async (Un) => {
      let Kn = null;
      if (await this.dependencies.componentTree.executeMutations(async (qn) => {
        const Jo = this.dependencies.componentTree.getRootComponent(), pa = Un.flatMap((ka) => ka.getGraphics()), ma = this.dependencies.componentTree.getLayerSequences(), va = this.getLayerSequenceMap(pa, ma), ba = va.flatMap((ka) => ka.map((Za) => Za.getID())), _a = /* @__PURE__ */ new Set();
        pa.forEach((ka) => {
          const Za = ka.getRootGraphicNumber();
          if (Za === null)
            throw new EditorError("graphic not connected");
          _a.add(Za);
        });
        const ya = _a.size, xa = Math.min(...Array.from(_a)), wa = this.getDefaultGroupStructure(xa);
        Kn = qn.componentFactory.createComponent(wa), await Kn.setStructure(() => wa), Kn.setParentComponent(Jo);
        const Ta = this.getDefaultGroupGraphicStructures(ya), Sa = await this.getGroupGraphics(Kn, Ta, qn);
        await this.correctPostGroupingComponentOffsets(Un);
        const Ma = this.getPostGroupingLayers(
          Sa,
          pa,
          ma,
          va
        );
        Un.forEach((ka) => qn.mutator.mutateByRemoveComponent(ka)), Sa.forEach((ka) => {
          if (Kn === null)
            throw new EditorError("group component not found");
          Kn.appendGraphic(ka);
        }), qn.mutator.mutateByAppendComponent(Jo, Kn), Un.forEach((ka) => {
          if (Kn === null)
            throw new EditorError("group component not found");
          qn.mutator.mutateByAppendComponent(Kn, ka);
        }), this.syncPostGroupingLayers(Ma, qn.mutator), await Kn.setTexture((ka) => ({
          ...ka,
          layerSequence: [...ba]
        })), this.dependencies.componentTree.syncUniterComponentsSizeFromComponent(Kn);
      }), Kn === null)
        throw new EditorError("group component not initiailzed");
      return Kn;
    });
    Ca(this, "getPostGroupingLayers", (Un, Kn, qn, Jo) => {
      const pa = this.dependencies.componentTree.getRootComponent(), ma = {
        layersFromPages: []
      };
      let va = 0;
      return qn.forEach((ba, _a) => {
        if (Jo[_a] === void 0)
          return;
        const ya = Jo[_a].map((Ma) => Ma.getID()), xa = qn[_a], wa = xa.find((Ma) => ya.includes(Ma));
        if (wa === void 0)
          throw new EditorError("first graphic not found", { globalLayers: qn, globalPageLayers: xa });
        const Ta = Kn.find((Ma) => Ma.getID() === wa);
        if (Ta === void 0)
          throw new EditorError("first graphic not found");
        let Sa = this.dependencies.componentTree.getPrevLayerGraphic(Ta);
        if (Sa === null) {
          const Ma = Ta.getRootGraphicNumber();
          if (Ma === null)
            throw new EditorError("graphic not connected to component tree");
          const ka = pa.getGraphicFromNumber(Ma);
          if (ka === null)
            throw new EditorError("page not found");
          Sa = ka;
        }
        if (Un[va] === void 0)
          throw new EditorError("group graphics not found");
        if (Jo[_a] === void 0)
          throw new EditorError("grouping graphics not found");
        ma.layersFromPages[va] = {
          baseGraphic: Sa,
          groupGraphic: Un[va],
          groupingGraphics: Jo[_a]
        }, va++;
      }), ma;
    });
    Ca(this, "getPostUngroupingLayers", (Un, Kn, qn) => {
      const Jo = this.dependencies.componentTree.getRootComponent(), pa = {
        layersFromPages: []
      };
      let ma = 0;
      return Kn.forEach((va, ba) => {
        if (qn[ba] === void 0)
          return;
        const _a = qn[ba].map((Ma) => Ma.getID()), ya = Kn[ba], xa = ya.find((Ma) => _a.includes(Ma));
        if (xa === void 0)
          throw new EditorError("first graphic not found", { globalLayers: Kn, globalPageLayers: ya });
        const wa = Un.find((Ma) => Ma.getID() === xa);
        if (wa === void 0)
          throw new EditorError("first graphic not found");
        let Ta = this.dependencies.componentTree.getPrevLayerGraphic(wa);
        if (Ta === null) {
          const Ma = wa.getRootGraphicNumber();
          if (Ma === null)
            throw new EditorError("graphic not connected to component tree");
          const ka = Jo.getGraphicFromNumber(Ma);
          if (ka === null)
            throw new EditorError("page not found");
          Ta = ka;
        }
        const Sa = Ta.getParentGraphic();
        if (Sa !== null && Sa.isUniter && (Ta = Sa.getParentGraphic(), Ta === null)) {
          const Ma = wa.getRootGraphicNumber();
          if (Ma === null)
            throw new EditorError("graphic not connected to component tree");
          const ka = Jo.getGraphicFromNumber(Ma);
          if (ka === null)
            throw new EditorError("page not found");
          Ta = ka;
        }
        if (qn[ba] === void 0)
          throw new EditorError("grouping graphics not found");
        pa.layersFromPages[ma] = {
          baseGraphic: Ta,
          groupingGraphics: qn[ba]
        }, ma++;
      }), pa;
    });
  }
}
class OrganizerMutation {
  constructor(zn, Un, Kn, qn) {
    this.graphic = zn, this.moveOffset = Un, this.component = Kn, this.componentTree = qn;
  }
}
class OrganizerExtendComponentMutation extends OrganizerMutation {
  constructor(Un, Kn, qn, Jo) {
    super(Un, Kn, qn, Jo);
    Ca(this, "run", async () => {
      const Un = this.component.getParentComponent();
      if (Un === null)
        throw new EditorError("parent component is null");
      const Kn = this.component.getOffset();
      if (Kn === null)
        throw new EditorError("component offset is null");
      const qn = this.component.getGraphics(), Jo = Un.getGraphics();
      let pa = 0;
      if (this.moveOffset !== 0 && (pa = Math.abs(Kn + this.moveOffset) + qn.length - Jo.length), this.moveOffset > 0)
        for (let ma = 0; ma < pa; ma++)
          await this.componentTree.mutateByExtendComponentToEnd(Un);
      else
        for (let ma = 0; ma < pa; ma++)
          await this.componentTree.mutateByExtendComponentToStart(Un);
    });
  }
}
class OrganizerOffsetMutation extends OrganizerMutation {
  constructor() {
    super(...arguments);
    Ca(this, "run", async () => {
      const Un = this.component.getOffset();
      if (Un === null)
        throw new EditorError("offset is null");
      const Kn = Un + this.moveOffset;
      await this.componentTree.mutateByChangeOffset(this.component, Kn);
    });
  }
}
class OrganizerPositionMutation extends OrganizerMutation {
  constructor(Un, Kn, qn, Jo) {
    super(Un, Kn, qn, Jo);
    Ca(this, "run", async () => {
      const Kn = this.componentTree.getIndexByParentGraphic(this.graphic) + this.moveOffset, qn = this.getPostMovePosition(this.graphic, Kn);
      this.graphic.setFrameConfiguration((Jo) => ({
        ...Jo,
        ...qn
      }));
    });
    /**
     * Возвращает новую позицию графика после смены офсета.
     * @param graphic Перемещаемая графика.
     * @param postMoveParentGraphicIndex Индекс родительской графики после перемещения графики.
     */
    Ca(this, "getPostMovePosition", (Un, Kn) => {
      const qn = Un.getParentGraphic();
      if (qn === null)
        throw new EditorError("parent graphic not found");
      const Jo = qn.getParentComponent();
      if (Jo === null)
        throw new EditorError("parent component not found");
      const ma = Jo.getGraphics()[Kn];
      if (ma === void 0)
        throw new EditorError("post move parent graphic");
      const va = ma.getGlobalPosition(), ba = Un.getGlobalPosition(), _a = {
        x: 0,
        y: 0
      };
      return ba.x < va.x ? _a.x = -Math.abs(ba.x - va.x) : _a.x = Math.abs(ba.x - va.x), ba.y < va.y ? _a.y = -Math.abs(ba.y - va.y) : _a.y = Math.abs(ba.y - va.y), _a;
    });
  }
}
class OrganizerTableMutation extends OrganizerMutation {
  constructor(Un, Kn, qn, Jo) {
    super(Un, Kn, qn, Jo);
    Ca(this, "requiredStartRows");
    Ca(this, "run", async () => {
      const Un = this.component.getRowProperties();
      this.requiredStartRows = await this.calculateRequiredStartRows(Un), await this.correctGraphicCount(this.requiredStartRows.length), await this.reorganizeRows(), this.requiredStartRows.length > 1 && this.requiredStartRows[0] === 0 && this.requiredStartRows[1] === 0 && await this.componentTree.executeMutations(async (qn) => {
        if (this.requiredStartRows === null)
          throw new EditorError("required start row not found");
        const Jo = this.component.getFirstGraphic();
        if (Jo === null)
          throw new EditorError("first graphic not found");
        const pa = this.component.getOffset();
        if (pa === null)
          throw new EditorError("offset not found");
        qn.mutator.mutateByRemoveGraphic(Jo), this.requiredStartRows.splice(0, 1), await qn.mutator.mutateByChangeOffset(this.component, pa + 1);
      }), this.component.syncGraphicsHeight();
      const Kn = this.component.getParentComponent();
      if (Kn != null && Kn.isUniter) {
        const qn = Kn, Jo = this.component.getGraphics().map((va) => va.getID()), pa = qn.getTexture(), ma = pa.layerSequence.findIndex((va) => Jo.includes(va));
        if (ma !== -1) {
          const va = Jo.filter((ba) => !pa.layerSequence.includes(ba));
          pa.layerSequence.splice(ma + 1, 0, ...va);
        }
        await qn.setTexture((va) => ({
          ...va,
          layerSequence: pa.layerSequence
        }));
      }
    });
    /**
     * Возвращает коллекцию номеров начальных строк таблицы для каждой графики на основании их физического
     * расположения относительно страниц.
     * @param rowsProperties Информация о высоте каждой строки таблицы.
     */
    Ca(this, "calculateRequiredStartRows", async (Un) => {
      const Kn = [0], qn = this.component.getGraphics();
      if (qn.length === 0)
        throw new EditorError("table graphics nor found");
      const pa = qn[0], ma = this.componentTree.getRootComponent();
      let va = pa.getRootGraphicNumber();
      if (va === null)
        throw new EditorError("graphic index not found");
      let ba = ma.getGraphicFromNumber(va);
      if (ba === null)
        throw new EditorError("first page graphic not found");
      let _a = ba.getTexture();
      const ya = ba.getAvailableSpaceY(), xa = ma.getRelativePagePosition(pa);
      let wa = ya - (xa.y - _a.paddingTop), Ta = 1;
      for (let Sa = 0; Sa < Un.length; Sa++) {
        const Ma = Un[Sa];
        Sa === 0 && (Ta = Ma.rowSpan), Ta === 1 ? (wa -= Ma.height, wa < 0 && (va++, ba = ma.getGraphicFromNumber(va), ba === null && (ba = await this.componentTree.mutateByExtendComponentToEnd(ma)), _a = ba.getTexture(), wa = ba.getAvailableSpaceY(), wa -= Ma.height + _a.paddingBottom, Kn.push(Sa)), Sa + 1 < Un.length && (Ta = Un[Sa + 1].rowSpan)) : Ta > 1 && Ta--;
      }
      return Kn;
    });
    /**
     * Корректирует необходимое количество графики таблицы.
     * Удаляет и добавляет графику до необходимого числа `graphicCount`.
     * @param graphicCount Необходимое количество графики.
     */
    Ca(this, "correctGraphicCount", async (Un) => {
      const Kn = this.component.getGraphics();
      await this.componentTree.executeMutations(async (qn) => {
        if (this.requiredStartRows === null)
          throw new EditorError("required start rows not initialized");
        if (Kn.length > Un && Kn.slice(Un).forEach((pa) => qn.mutator.mutateByRemoveGraphic(pa)), Kn.length < Un) {
          if (this.component.getParentComponent() === null)
            throw new EditorError("parent component not found");
          if (this.component.getOffset() === null)
            throw new EditorError("table component is null");
          for (let ma = Kn.length; ma < Un; ma++) {
            if (this.requiredStartRows[ma] === void 0)
              throw new EditorError("start row not found");
            const ba = this.component.getGraphics(), _a = ba[ba.length - 1], ya = _a.getFrameConfiguration(), xa = this.componentTree.getRootComponent(), wa = _a.getRootGraphicNumber();
            if (wa === null)
              throw new EditorError("number not found");
            const Ta = xa.getGraphicFromNumber(wa + 1);
            if (Ta === null)
              throw new EditorError("page not found");
            const Sa = Ta.getTexture(), Ma = await this.getParentGraphicToExtendTable(this.component, ma);
            if (Ma === void 0)
              throw new EditorError("parent graphic not found");
            const ka = this.getExtendGraphicPosition(
              Sa.paddingTop,
              Ma,
              _a
            ), Za = this.getExtendGraphic(
              this.component,
              ka,
              ya,
              qn
            );
            qn.mutator.mutateByAppendGraphic(this.component, Za);
          }
        }
      }), this.component.isEnableFocus() && this.component.enableFocus();
    });
    /**
     * Применяет `requiredStartRows` на таблицу `this.component`.
     */
    Ca(this, "reorganizeRows", async () => {
      if (this.requiredStartRows === null)
        throw new EditorError("not calculated required start rows");
      this.component.getStartRows(), await this.setTableStartRows(this.requiredStartRows), this.correctExtendTableGraphicPosition(this.component);
    });
    /**
     * Сообщает всей графике начальные номера строк для отрисовки.
     * @param startRowNumbers - номера начальных строк отрисовки для каждой графики.
     */
    Ca(this, "setTableStartRows", async (Un) => {
      await this.component.mutateStartRows(Un), this.component.applyMutations(), this.component.syncGraphicsHeight();
    });
    /**
     * Возвращает созданную добавочную графику таблицы.
     * @param tableComponent Компонент таблицы.
     * @param extendGraphicPosition Позиция для создаваемой графики.
     * @param prevGraphicConfiguration Конфигурация фрейма предыдущей графики перед создаваемой.
     * @param tools Инструменты для мутации структуры дерева компонентов.
     */
    Ca(this, "getExtendGraphic", (Un, Kn, qn, Jo) => {
      const pa = Jo.graphicFactory.createGraphic(GraphicType.TABLE, Un), { x: ma, y: va } = Kn, { width: ba } = qn;
      return pa.setFrameConfiguration((_a) => ({
        ..._a,
        x: ma,
        y: va,
        width: ba
      })), pa;
    });
    /**
     * Возвращает необходимую позицию для новой графики таблицы с учетом того, что любая графика таблицы,
     * за исключением первой, должна располагаться на верхнем отступе страницы и иметь такую же
     * координату по горизонтали, как у предыдущей графики.
     * @param pagePaddingTop Внутренний верхний отступ страницы.
     * @param parentGraphic Графика, в которую будет вставлена новая графика таблицы.
     * @param prevGraphic Предыдущая графика таблицы перед вставляемой.
     */
    Ca(this, "getExtendGraphicPosition", (Un, Kn, qn) => {
      const Jo = qn.getFrameConfiguration();
      if (Kn.type === GraphicType.PAGE)
        return {
          y: Un,
          x: Jo.x
        };
      let pa = Kn, ma = pa.getFrameConfiguration(), va = 0;
      for (; pa !== null; )
        va += ma.y, pa = pa.getParentGraphic(), pa !== null && (ma = pa.getFrameConfiguration());
      return {
        y: va - Un,
        x: Jo.x
      };
    });
    /**
     * Корректирует позицию дополнительных график таблицы, чтобы они были всегда привязаны
     * к верхнему отступу листа, учитывая их вложенность в другие компоненты.
     * @param tableComponent Компонент таблицы, содержащий обрабатываемую графику.
     */
    Ca(this, "correctExtendTableGraphicPosition", (Un) => {
      const Kn = Un.getGraphics(), qn = Un.getFirstGraphic();
      if (qn === null)
        throw new EditorError("first graphic not found");
      const Jo = this.componentTree.getRootComponent(), pa = Jo.getRelativePagePosition(qn), ma = Kn.slice(1);
      ma.length !== 0 && ma.forEach((va) => {
        const ba = Jo.getRelativePagePosition(va), _a = va.getRootGraphicNumber();
        if (_a === null)
          throw new EditorError("page index not found");
        const ya = Jo.getGraphicFromNumber(_a);
        if (ya === null)
          throw new EditorError("page not found");
        const xa = ya.getTexture();
        ba.y !== xa.paddingTop && this.correctVerticalExtendGraphic(va, xa), ba.x !== pa.x && this.correctHorizontalExtendGraphic(va, pa.x);
      });
    });
    /**
     * Корректирует вертикальную позицию графики таблицы по внутреннему отступу страницы.
     * @param graphic Корректируемая графика таблицы.
     * @param pageTexture Текстура страницы, от которой идет корректировка позиции.
     */
    Ca(this, "correctVerticalExtendGraphic", (Un, Kn) => {
      const qn = Un.getParentGraphic();
      if (qn === null)
        throw new EditorError("parent graphic not found");
      const pa = this.componentTree.getRootComponent().getRelativePagePosition(qn);
      let ma = 0;
      pa.y > Kn.paddingTop ? ma = -(pa.y - Kn.paddingTop) : ma = Math.abs(pa.y) + Kn.paddingTop, Un.setFrameConfiguration((va) => ({
        ...va,
        y: ma
      }));
    });
    /**
     * Корректирует горизонтальною позицию графики таблицы по требуемой относительной страницы позиции.
     * @param graphic Корректируемая графика таблицы.
     * @param requiredPosition Требуемая глобальная горизонтальная позиция.
     */
    Ca(this, "correctHorizontalExtendGraphic", (Un, Kn) => {
      const qn = Un.getParentGraphic();
      if (qn === null)
        throw new EditorError("parent graphic not found");
      const pa = this.componentTree.getRootComponent().getRelativePagePosition(qn);
      let ma = 0;
      pa.y > Kn ? ma = -(pa.y - Kn) : ma = Math.abs(pa.y) + Kn, Un.setFrameConfiguration((va) => ({
        ...va,
        x: ma
      }));
    });
    /**
     * Возвращает родительскую графику для графики таблицы.
     * @param tableComponent Компонент таблицы.
     * @param graphicIndex Индекс графики таблицы, для которой необходимо вернуть родительскую графику.
     */
    Ca(this, "getParentGraphicToExtendTable", async (Un, Kn) => {
      const qn = Un.getOffset();
      if (qn === null)
        throw new EditorError("table component not include offset");
      const Jo = Un.getLastGraphic();
      if (Jo === null)
        throw new EditorError("last graphic not found");
      const pa = Un.getParentComponent();
      if (pa === null)
        throw new EditorError("parent component not found");
      let ma = pa.getGraphics(), va = ma[qn + Kn];
      return va === void 0 && await this.generateParentsGraphics(Un, Jo), ma = pa.getGraphics(), va = ma[qn + Kn], va;
    });
    /**
     * Генерирует необходимую графику родительских компонентов таблицы для размещения всей графики таблицы.
     * @param tableComponent Компонент таблицы, от которой будут генерироваться родительские графики.
     * @param lastGraphic Последняя графика таблицы.
     */
    Ca(this, "generateParentsGraphics", async (Un, Kn) => {
      if (Un.getOffset() === null)
        throw new EditorError("table component offset not found");
      const Jo = new Stack();
      let pa = Un.getParentComponent();
      for (; pa !== null; )
        Jo.push(pa), pa = pa.getParentComponent();
      const ma = Kn.getRootGraphicNumber();
      if (ma === null)
        throw new EditorError("number not found");
      const va = ma + 1;
      let ba = Jo.pop();
      for (; ba !== void 0; ) {
        const _a = ba.getLastGraphic();
        if (_a === null)
          throw new EditorError("last graphic not found");
        const ya = _a.getRootGraphicNumber();
        if (ya === null)
          throw new EditorError("graphic page index not found");
        const xa = va - ya;
        for (let wa = 0; wa < xa; wa++)
          await this.componentTree.mutateByExtendComponentToEnd(ba);
        ba = Jo.pop();
      }
    });
    this.requiredStartRows = null;
  }
}
class BookComponentOrganizer extends Dependent {
  constructor() {
    super();
    Ca(this, "postSyncListeners");
    /**
     * Производит проверку выхода графики за границу страницы.
     * Если первая графика таблицы вышла за пределы страницы - переносится весь компонент на ту страницу,
     * на которую попала первая графика. Также происходит распределение строк таблицы согласно их
     * физическому расположению.
     * Запускает процесс проверки только для компонентов, расположенных на листьях дерева.
     */
    Ca(this, "sync", async () => {
      const Un = this.dependencies.componentTree.getRootComponent();
      if (Un.getComponents() === null)
        return;
      const qn = await this.getGraphicOutliers(Un), Jo = [];
      if (qn !== null) {
        const pa = this.generateMutationsFromOutliers(qn), ma = this.generateSyncTableMutations(qn);
        ma !== null && Jo.push(...ma), Jo.push(...pa);
      } else {
        const pa = this.generateSyncAllTableMutations();
        pa !== null && Jo.push(...pa);
      }
      await this.runMutations(Jo), this.callPostSyncListeners();
    });
    /**
     * Добавляет слушателя синхронизации компонентов.
     * @param listener Слушатель.
     */
    Ca(this, "addPostSyncListener", (Un) => {
      this.postSyncListeners.push(Un);
    });
    /**
     * Возвращает мутации на основе зафиксированных выходов за пределы страницы графики.
     * @param outliers Зафиксированные случаи выхода за пределы страницы.
     */
    Ca(this, "generateMutationsFromOutliers", (Un) => {
      const Kn = [];
      return Un.forEach((qn) => {
        Kn.push(
          new OrganizerExtendComponentMutation(
            qn.graphic,
            qn.moveOffset,
            qn.component,
            this.dependencies.componentTree
          ),
          new OrganizerPositionMutation(
            qn.graphic,
            qn.moveOffset,
            qn.component,
            this.dependencies.componentTree
          ),
          new OrganizerOffsetMutation(
            qn.graphic,
            qn.moveOffset,
            qn.component,
            this.dependencies.componentTree
          )
        ), qn.component.type === EditorComponentType.TABLE && Kn.push(
          new OrganizerTableMutation(
            qn.graphic,
            qn.moveOffset,
            qn.component,
            this.dependencies.componentTree
          )
        );
      }), Kn;
    });
    /**
     * Возвращает мутации синхронизации строк всех таблиц, которые не вышли за пределы страницы.
     * @param graphicOutliers Зафиксированные случаи выхода за пределы страницы.
     */
    Ca(this, "generateSyncTableMutations", (Un) => {
      const Kn = Un.filter((pa) => pa.component.type === EditorComponentType.TABLE).map((pa) => pa.component), qn = this.dependencies.componentTree.getUniformComponents(EditorComponentType.TABLE);
      return qn === null ? null : qn.filter((pa) => !Kn.includes(pa)).length !== 0 ? qn.map((pa) => {
        const ma = pa.getFirstGraphic();
        if (ma === null)
          throw new EditorError("table first graphic not found");
        return new OrganizerTableMutation(ma, 0, pa, this.dependencies.componentTree);
      }) : null;
    });
    /**
     * Возвращает коллекцию мутаций реорганизации строк для всех таблиц.
     */
    Ca(this, "generateSyncAllTableMutations", () => {
      const Un = this.dependencies.componentTree.getUniformComponents(EditorComponentType.TABLE);
      return Un === null ? null : Un.map((Kn) => {
        const qn = Kn.getFirstGraphic();
        if (qn === null)
          throw new EditorError("table first graphic not found");
        return new OrganizerTableMutation(qn, 0, Kn, this.dependencies.componentTree);
      });
    });
    /**
     * Возвращает коллекцию объектов с информацией о выходе графики за пределы допустимой области.
     * Для обычных компонентов это страница, а для таблиц внутренняя область страницы с учетом отступа.
     */
    Ca(this, "getGraphicOutliers", async (Un) => {
      const Kn = [];
      return await this.recursiveInspectPageOutside(Un, Kn), Kn.length === 0 ? null : Kn;
    });
    Ca(this, "recursiveInspectPageOutside", async (Un, Kn) => {
      const qn = Un.getComponents();
      if (qn === null) {
        await this.inspectPageOutsideComponent(Un, Kn);
        return;
      }
      this.sortComponentByLayers(qn);
      for (let Jo = 0; Jo < qn.length; Jo++)
        await this.recursiveInspectPageOutside(qn[Jo], Kn);
    });
    /**
     * Проверяет компонент на выход за пределы страницы, к которой он привязан структурно.
     * @param component Проверяемый компонент.
     * @param outliers Аккумулирующая коллекция зафиксированных выходов за границу.
     */
    Ca(this, "inspectPageOutsideComponent", async (Un, Kn) => {
      const qn = Un.getGraphics();
      if (Un.type === EditorComponentType.TABLE) {
        const Jo = Un.getFirstGraphic();
        if (Jo === null)
          throw new EditorError("first graphic not found");
        await this.inspectGraphicPageOutside(Jo);
        const pa = this.inspectTableGraphicOutline(Un, Jo);
        if (pa === null)
          return;
        Kn.push(pa);
        return;
      }
      for (let Jo = 0; Jo < qn.length; Jo++) {
        await this.inspectGraphicPageOutside(qn[Jo]);
        const pa = this.inspectGraphicOutline(Un, qn[Jo]);
        if (pa === null)
          return;
        Kn.push(pa);
      }
    });
    /**
     * Проверяет, находится ли графика за пределами текущей страницы,
     * и добавляет новую страницу в конец, если это необходимо.
     * @param graphic Проверяемая графика.
     */
    Ca(this, "inspectGraphicPageOutside", async (Un) => {
      const Kn = this.dependencies.componentTree.getRootComponent(), qn = Kn.getGraphics(), Jo = qn[qn.length - 1], pa = Jo.getFrameConfiguration(), ma = Jo.getGlobalPosition();
      Un.getGlobalPosition().y > ma.y + pa.height && (await this.dependencies.componentTree.mutateByExtendComponentToEnd(Kn), this.dependencies.bookOrganizer.sync());
    });
    /**
     * Проверка компонента с одной графикой на выход за пределы страницы.
     * @param component Проверяемый компонент.
     * @param graphic Проверяемая графика.
     */
    Ca(this, "inspectGraphicOutline", (Un, Kn) => {
      const qn = this.getDependGraphicToPage(Kn);
      if (qn === null)
        return null;
      const pa = this.dependencies.componentTree.getRootComponent().getGraphics(), ma = this.dependencies.componentTree.getGraphicSequences();
      let va = null;
      for (let _a = 0; _a < ma.length; _a++)
        ma[_a].includes(Kn) && (va = pa[_a]);
      if (va === null)
        throw new EditorError("current page");
      if (qn === va)
        return null;
      const ba = this.getMoveGraphicOffset(va, qn);
      return { component: Un, graphic: Kn, moveOffset: ba };
    });
    /**
     * Возвращает фиксацию выхода графики компонента за пределы страницы.
     * Пределами страницы считается внутренняя область страницы с учетом внутреннего отступа.
     * @param component Компонент таблицы.
     * @param graphic Графика таблицы.
     */
    Ca(this, "inspectTableGraphicOutline", (Un, Kn) => {
      const Jo = this.dependencies.componentTree.getRootComponent().getPageFromGraphic(Kn), pa = Jo.getTexture(), ma = Jo.getFrameConfiguration(), va = Jo.getGlobalPosition(), ba = Kn.getGlobalPosition(), _a = Kn.getFrameConfiguration(), ya = va.y + ma.height - pa.paddingBottom, xa = va.y + pa.paddingTop;
      if (ba.y + _a.height > ya || ba.y < xa) {
        const wa = this.dependencies.componentTree.getRootGraphics(), Ta = this.getDependGraphicToPage(Kn);
        if (Ta === null)
          throw new EditorError("depend page not found");
        const Sa = wa.indexOf(Jo), Ma = wa.indexOf(Ta);
        if (Sa === void 0 || Ma === void 0)
          throw new EditorError("page index not found");
        return {
          graphic: Kn,
          component: Un,
          moveOffset: Ma - Sa
        };
      }
      return null;
    });
    /**
     * Возвращает страницу, к которой в настоящий момент визуально относится графика.
     * @param graphic Проверяемая графика.
     */
    Ca(this, "getDependGraphicToPage", (Un) => {
      const qn = this.dependencies.componentTree.getRootComponent().getGraphics(), Jo = /* @__PURE__ */ new Map();
      if (qn.forEach((ba) => {
        const _a = ba.getGlobalPosition(), { width: ya, height: xa } = ba.getFrameConfiguration(), wa = Un.getGlobalPosition(), Ta = Un.getFrameConfiguration(), Sa = {
          x: _a.x,
          y: _a.y,
          width: ya,
          height: xa,
          rotate: 0
        }, Ma = {
          x: wa.x,
          y: wa.y,
          width: Ta.width,
          height: Ta.height,
          rotate: 0
        }, ka = Utils.geometry.intersectArea(Sa, Ma);
        Jo.set(ba, ka);
      }), Array.from(Jo.values()).every((ba) => ba === 0))
        return null;
      let ma = qn[0], va = 0;
      return Jo.forEach((ba, _a) => {
        ba > va && (ma = _a, va = ba);
      }), ma;
    });
    /**
     * Возвращает сдвиг офсета для графики от текущего значения для перемещения на страницу `graphicDependPage`.
     * @param currentPage Текущая страница, на которой расположена графика.
     * @param graphicDependPage Страница, на которую должна попасть графика после изменения офсета.
     */
    Ca(this, "getMoveGraphicOffset", (Un, Kn) => {
      if (Un === Kn)
        throw new EditorError("page not change");
      const Jo = this.dependencies.componentTree.getRootComponent().getGraphics(), pa = Jo.indexOf(Un);
      if (pa === -1)
        throw new EditorError("current page not found");
      const ma = Jo.indexOf(Kn);
      if (ma === -1)
        throw new EditorError("graphic depend not found");
      return ma - pa;
    });
    Ca(this, "callPostSyncListeners", () => {
      this.postSyncListeners.forEach((Un) => Un());
    });
    Ca(this, "sortComponentByLayers", (Un) => {
      Un.sort((Kn, qn) => {
        const Jo = Math.min(
          ...Kn.getGraphics().map((ma) => ma.getFrameConfiguration().layer)
        ), pa = Math.min(
          ...qn.getGraphics().map((ma) => ma.getFrameConfiguration().layer)
        );
        return Jo - pa;
      });
    });
    /**
     * Запускает все переданные мутации и побочные эффекты для них.
     * @param mutations Мутации для запуска.
     */
    Ca(this, "runMutations", async (Un) => {
      await this.dependencies.componentTree.executeMutations(async () => {
        for (let Kn = 0; Kn < Un.length; Kn++)
          await Un[Kn].run();
        await this.dependencies.componentTree.mutateByRemoveEmptyUniterGraphics();
      }), this.callPostSyncListeners();
    });
    this.postSyncListeners = [];
  }
}
class HTMLTableImporter extends Dependent {
  constructor() {
    super();
    Ca(this, "EMPTY_VALUE", "");
    Ca(this, "prevInjectListeners");
    Ca(this, "postInjectListeners");
    /**
     * Вставляет таблицы в приложение на основе переданной HTML-строки.
     * Метод парсит входящую строку, извлекает таблицы и преобразует их в
     * структуру, которую можно использовать в приложении. Если таблицы не найдены,
     * выводится уведомление об ошибке.
     * @param htmlString HTML строка таблицы.
     */
    Ca(this, "importTable", async (Un) => {
      const Kn = this.getStructures(Un);
      Kn.length, this.callPrevInjectListeners(), await this.injectTable(Kn[0]);
    });
    /**
     * Возвращает структуры таблиц, найденных в переданном HTML.
     * @param htmlString Строка HTML, содержащая таблицы.
     */
    Ca(this, "getStructures", (Un) => {
      const Jo = new DOMParser().parseFromString(Un, "text/html").querySelectorAll("table");
      if (Jo.length === 0)
        return [];
      const pa = [];
      return Jo.forEach((ma) => {
        const va = this.convertHTMLTableToStructure(ma);
        pa.push(va);
      }), pa;
    });
    /**
     * Конвертирует HTML таблицу в структуру таблицы.
     * @param table HTML элемент таблицы.
     */
    Ca(this, "convertHTMLTableToStructure", (Un) => {
      var ya;
      const Kn = this.getTemporaryContainer();
      Kn.appendChild(Un);
      const { rows: qn } = Un, Jo = Math.max(...Array.from(qn).map((xa) => xa.cells.length)), pa = qn.length, ma = {
        cells: [],
        columnCount: Jo,
        rowCount: pa
      }, va = [], ba = [];
      let _a = 0;
      for (let xa = 0; xa < pa; xa++) {
        const wa = qn[_a];
        va[xa] === void 0 && (va[xa] = []);
        let Ta = 0;
        for (let Sa = 0; Sa < Jo; Sa++) {
          const Ma = wa.cells[Ta];
          if (Ma) {
            for (; (ya = ba[xa]) != null && ya[Sa]; )
              Sa++;
            const ka = Utils.component.getDefaultCellTexture(this.EMPTY_VALUE, xa, Sa);
            ka.rowSpan = Ma.rowSpan, ka.columnSpan = Ma.colSpan;
            const { background: Za, tokens: Na } = this.getStyledContentFromHTML(ka, Ma);
            ka.background = Za, ka.content.tokens = [...Na], va[xa][Sa] = ka;
            for (let Ka = xa; Ka < xa + Ma.rowSpan; Ka++) {
              ba[Ka] || (ba[Ka] = []);
              for (let Ja = Sa; Ja < Sa + Ma.colSpan; Ja++)
                ba[Ka][Ja] || (ba[Ka][Ja] = ka.id);
            }
          }
          Ta++;
        }
        _a++;
      }
      return this.convertEmptyToEmptyCells(va, Jo, ba), ma.cells = this.flatCells(va), this.removeTemporaryContainer(Kn), ma;
    });
    /**
     * Возвращает вычисленные стили из HTML-элемента ячейки таблицы.
     * @param cell Текстура ячейки таблицы содержащяя информацию о стилях ячейки.
     * @param cellElement HTML-элемент ячейки таблицы, из которого будут извлечены стили.
     */
    Ca(this, "getStyledContentFromHTML", (Un, Kn) => {
      const qn = { ...Un };
      Kn.style.backgroundColor && (qn.background = Kn.style.backgroundColor);
      const Jo = this.getTokensFromElement(Kn);
      return { background: qn.background, tokens: Jo };
    });
    Ca(this, "injectTable", async (Un) => {
      const Kn = Utils.generate.uuid4(), qn = Utils.generate.uuid4(), { rowCount: Jo, columnCount: pa, cells: ma } = Un;
      if (ma.length < 1) {
        console.log("Вставляемая таблица не имеет ячеек с текстом");
        return;
      }
      const va = this.dependencies.componentTree.getRootComponent(), ba = this.dependencies.canvasMouseObserver.getCurrentPosition(), _a = this.calculateComponentInjectionParams(ba), ya = va.getGraphics()[_a.componentOffset], xa = ya.getGlobalPosition(), { paddingLeft: wa, paddingRight: Ta } = ya.getTexture(), { width: Sa } = ya.getFrameConfiguration(), Ma = {
        id: qn,
        type: GraphicType.TABLE,
        frame: {
          width: Sa - Ta - wa,
          height: 0,
          layer: 0,
          x: wa,
          y: ba.y - xa.y,
          rotate: 0
        },
        offset: 0,
        texture: {
          rowCount: Jo
        }
      };
      let ka;
      await this.dependencies.componentTree.executeMutations(async (Za) => {
        ka = Za.componentFactory.getClearComponent(EditorComponentType.TABLE);
        const Na = /* @__PURE__ */ new Map(), Ka = {
          id: Kn,
          type: EditorComponentType.TABLE,
          offset: _a.componentOffset,
          graphics: [Ma],
          texture: {
            startRows: [0],
            cells: ma,
            borderColor: "black",
            columnWidths: new Array(pa).fill(ka.getDefaultColumnWidth()),
            rowHeights: new Array(Jo).fill(ka.getDefaultRowHeight())
          },
          components: null
        };
        if (Ka.graphics === null)
          throw new EditorError("graphic structures not found");
        for (let Ja = 0; Ja < Ka.graphics.length; Ja++) {
          const el = Ka.graphics[Ja], qa = Za.graphicFactory.createGraphic(GraphicType.TABLE, ka);
          if (await qa.setStructure(() => el), ka.appendGraphic(qa), Ka.offset === null)
            throw new EditorError("the table structure does not have an offset");
          const tl = Ka.offset + el.offset, nl = Za.layerRegistry.getLastLayerFromRootGraphic(tl).getData();
          if (nl === null)
            throw new EditorError("last page layer graphic not found");
          Na.set(nl, qa);
        }
        await ka.setStructure(() => Ka), Za.mutator.mutateByAppendComponent(va, ka), Na.forEach((Ja, el) => {
          Za.mutator.mutateByChangeLayer(el, Ja);
        }), ka.mutateSyncRealRowHeight(), ka.syncGraphicsHeight(), ka.applyMutations(), this.callPostInjectListeners();
      });
    });
    Ca(this, "callPostInjectListeners", () => {
      this.postInjectListeners.forEach((Un) => Un());
    });
    Ca(this, "callPrevInjectListeners", () => {
      this.prevInjectListeners.forEach((Un) => Un());
    });
    /**
     * Возвращает стилизованный токен текста из HTML элемента.
     * @param element HTML-элемент, из которого будут извлечены токены.
     */
    Ca(this, "getTokensFromElement", (Un) => {
      const Kn = [];
      return Un.childNodes.forEach((qn) => this.recursiveTokenCollecting(qn, Kn)), Kn.length === 0 && Kn.push(Utils.text.getDefaultTextToken(this.EMPTY_VALUE)), Kn;
    });
    Ca(this, "recursiveTokenCollecting", (Un, Kn) => {
      if (Un.nodeType === Node.ELEMENT_NODE) {
        const qn = Un.tagName === "P" && Un.textContent && Un.textContent.trim().length > 1 && Kn.length > 0 && Kn[Kn.length - 1].value !== `
` || Un.tagName === "BR", Jo = Un.tagName === "SPAN" && Un.textContent === " ";
        if (qn) {
          const pa = window.getComputedStyle(Un), ma = Utils.text.getDefaultTextToken(`
`);
          this.applyTextStyles(ma, pa), Kn.push(ma);
        }
        if (Jo) {
          const pa = window.getComputedStyle(Un), ma = Utils.text.getDefaultTextToken(" ");
          this.applyTextStyles(ma, pa), Kn.push(ma);
        }
      }
      if (Un.nodeType === Node.TEXT_NODE) {
        const { textContent: qn } = Un;
        if (qn && qn.trim().length > 0) {
          const Jo = Un.parentElement, pa = window.getComputedStyle(Jo), ma = qn.replace(/[\n\r\u2028\u2029]/g, "").replace(/\s{2,}/g, " "), va = Utils.text.getDefaultTextToken(ma);
          this.applyTextStyles(va, pa), Kn.push(va);
        }
      } else
        Un.childNodes.forEach((qn) => this.recursiveTokenCollecting(qn, Kn));
    });
    /**
     * Применяет форматирование к токену в соответствии с вычисленными стилями текста.
     * @param token - Токен, к которому будут применены стили.
     * @param styles - Вычисленные CSS-стили, которые будут применены к токену.
     */
    Ca(this, "applyTextStyles", (Un, Kn) => {
      const { color: qn, fontWeight: Jo, fontStyle: pa, fontSize: ma, fontFamily: va } = Kn;
      if (qn && (Un.color = qn), Jo >= "700" && (Un.format = TokenFormat.Bold), pa === "italic" && (Un.format = TokenFormat.Italic), Jo >= "700" && pa === "italic" && (Un.format = TokenFormat.BoldItalic), ma) {
        const ba = this.convertPxToPt(ma);
        Object.entries(FontSize).find(([ya, xa]) => xa === ba) && (Un.fontSize = ba);
      }
      if (va) {
        const ba = va.replace(/,\s*sans-serif$/, "");
        Object.entries(FontFamily).find(([ya, xa]) => xa === ba) && (Un.fontFamily = ba);
      }
    });
    /**
     * Конвертирует px(пиксели) в pt(пункты).
     * @param px Писксели, которые необходимо конвертировать.
     */
    Ca(this, "convertPxToPt", (Un) => `${Math.ceil(Number.parseFloat(Un) * (3 / 4))}pt`);
    /**
     * Возвращает из двумерного массива текстур ячеек линейный массив.
     * @param cells Двумерный массив ячеек, отражающий структуру таблицы.
     */
    Ca(this, "flatCells", (Un) => Un.flatMap((Kn) => Kn.filter((qn) => qn !== null)));
    /**
     * Заполняет пустующие (не те, которые занимают ячейки в объединении, а с полным отсутствием в ней ячейки)
     * координаты таблицы.
     * @param cells Матрица текстур ячеек таблицы с пустующими координатами.
     * @param columnCount Количество колонок.
     * @param cellsGrid Карта ячеек (см. описание типа).
     */
    Ca(this, "convertEmptyToEmptyCells", (Un, Kn, qn) => {
      for (let Jo = 0; Jo < qn.length; Jo++)
        for (let pa = 0; pa < Kn; pa++)
          qn[Jo] === void 0 && (qn[Jo] = []), qn[Jo][pa] === void 0 && (Un[Jo][pa] = Utils.component.getDefaultCellTexture(this.EMPTY_VALUE, Jo, pa));
    });
    /**
     * Возвращает временный контейнер.
     */
    Ca(this, "getTemporaryContainer", () => {
      const Un = document.createElement("div");
      return Un.style.display = "none", document.body.appendChild(Un), Un;
    });
    /**
     * Удаляет временный контейнер.
     * @param container Удаляемый контейнер.
     */
    Ca(this, "removeTemporaryContainer", (Un) => {
      document.body.removeChild(Un);
    });
    /**
     * Вычисляет параметры инжекции для компонента по позиции мыши.
     * @param mousePosition Текущая позиция мыши.
     */
    Ca(this, "calculateComponentInjectionParams", (Un) => {
      let Kn = null, qn = Number.MAX_SAFE_INTEGER;
      const Jo = this.dependencies.componentTree.getRootGraphics();
      for (let va = 0; va < Jo.length; va++) {
        const ba = Jo[va], { y: _a, height: ya } = ba.getFrameConfiguration(), xa = _a + ya / 2, wa = Math.abs(Un.y - xa);
        wa < qn && (qn = wa, Kn = ba);
      }
      if (Kn === null)
        throw new EditorError("nearest page not found");
      const pa = Kn.getGlobalPosition(), ma = Kn.getOffset();
      return {
        x: pa.x,
        y: pa.y,
        componentOffset: ma
      };
    });
    this.prevInjectListeners = [], this.postInjectListeners = [];
  }
  addPostInjectListener(Un) {
    this.postInjectListeners.push(Un);
  }
  addPrevInjectListener(Un) {
    this.prevInjectListeners.push(Un);
  }
}
class HTMLTableReplacer extends Dependent {
  constructor() {
    super();
    Ca(this, "prevReplaceListeners");
    Ca(this, "postReplaceListeners");
    Ca(this, "replaceTable", async (Un, Kn) => {
      if (Un.length > 1)
        return;
      const qn = Un[0];
      if (qn === void 0)
        throw new EditorError("table is undefined");
      const Jo = qn.getFocusCellContexts(), pa = Jo === null ? qn.getCellContexts() : Jo, ma = this.generatePatternStyles(pa);
      this.isPatternStylesRectangle(pa, ma);
      const va = this.dependencies.htmlTableImporter.getStructures(Kn);
      if (va.length === 0)
        return;
      const { rowCount: ba, columnCount: _a, cells: ya } = va[0];
      if (ya.length < 1)
        return;
      const xa = this.resizePatternStyles(ma, ba, _a);
      for (let Sa = 0; Sa < ya.length; Sa++) {
        const Ma = ya[Sa], { row: ka, column: Za } = Ma;
        Ma.content.tokens = this.getStylesFromPattern(Ma, xa[ka][Za]), Ma.background = xa[ka][Za].background;
      }
      const wa = new Array(ba).fill(qn.getDefaultRowHeight()), Ta = new Array(_a).fill(qn.getDefaultColumnWidth());
      this.callPrevReplaceListeners(), qn.mutateRowHeights(wa), qn.mutateColumnWidths(Ta), await qn.mutateCellTextures(ya), qn.mutateSyncRealRowHeight(), qn.applyMutations(), this.callPostReplaceListeners();
    });
    Ca(this, "callPostReplaceListeners", () => {
      this.postReplaceListeners.forEach((Un) => Un());
    });
    Ca(this, "callPrevReplaceListeners", () => {
      this.prevReplaceListeners.forEach((Un) => Un());
    });
    Ca(this, "getStylesFromPattern", (Un, Kn) => {
      const qn = Kn.content.tokens.find((pa) => pa.type === TokenType.TEXT), Jo = [...Un.content.tokens];
      for (let pa = 0; pa < Jo.length; pa++)
        Jo[pa].type === TokenType.TEXT && (Jo[pa] = { ...qn, value: Jo[pa].value });
      return Jo;
    });
    /**
     * Возвращает масштабированный шаблон стилей, до размеров импортируемой таблицы.
     * @param patternStyles Шаблон стилей
     * @param rowCount Количество строк, в импортируемой таблице
     * @param columnCount Количество колонок, в импортируемой таблице
     */
    Ca(this, "resizePatternStyles", (Un, Kn, qn) => {
      const Jo = [], pa = Un.length, ma = Un[0].length;
      for (let va = 0; va < Kn; va++) {
        Jo[va] === void 0 && (Jo[va] = []);
        for (let ba = 0; ba < qn; ba++) {
          const _a = va % pa, ya = ba % ma;
          Jo[va][ba] = Un[_a][ya];
        }
      }
      return Jo;
    });
    /**
     * Возвращает результат проверки полученной фигуры из ячеек на соответствие прямоугольнику.
     * @param cells Ячейки для вычисления итогового количества строк и колонок
     * @param patternStyles Шаблон стилей, для проверки
     */
    Ca(this, "isPatternStylesRectangle", (Un, Kn) => {
      const qn = /* @__PURE__ */ new Set(), Jo = /* @__PURE__ */ new Set();
      for (let va = 0; va < Un.length; va++) {
        const { row: ba, column: _a } = Un[va].getTexture();
        Jo.add(ba), qn.add(_a);
      }
      const pa = Jo.size, ma = qn.size;
      for (let va = 0; va < pa; va++)
        for (let ba = 0; ba < ma; ba++)
          if (Kn[va][ba] === void 0)
            return !1;
      return !0;
    });
    /**
     * Возвращает сгенерированный шаблон стилей, на основе ячеек.
     * @param cells Ячейки для копирования стилей
     */
    Ca(this, "generatePatternStyles", (Un) => {
      let Kn = 0, qn = 0;
      for (let ma = 0; ma < Un.length; ma++) {
        const { row: va, column: ba } = Un[ma].getTexture();
        va > Kn && (Kn = va), ba > qn && (qn = ba);
      }
      Kn++, qn++;
      const Jo = [];
      for (let ma = 0; ma < Kn; ma++)
        Jo[ma] = new Array(qn).fill(null);
      for (let ma = 0; ma < Un.length; ma++) {
        const va = Un[ma].getTexture(), { row: ba, rowSpan: _a, column: ya, columnSpan: xa } = va;
        if (Jo[ba][ya] = va, _a > 1 || xa > 1)
          for (let wa = ba; wa < ba + _a; wa++)
            for (let Ta = ya; Ta < ya + xa; Ta++)
              Jo[wa][Ta] || (Jo[wa][Ta] = va);
      }
      return Jo.flatMap((ma) => {
        const va = ma.filter((ba) => ba !== null);
        return va.length > 0 ? [va] : [];
      });
    });
    this.prevReplaceListeners = [], this.postReplaceListeners = [];
  }
  addPostReplaceListener(Un) {
    this.postReplaceListeners.push(Un);
  }
  addPrevReplaceListener(Un) {
    this.prevReplaceListeners.push(Un);
  }
}
class PictureImporter extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 500);
    Ca(this, "DEFAULT_HEIGHT", 500);
    Ca(this, "prevInjectListeners");
    Ca(this, "postInjectListeners");
    /**
     * Вставляет картинку в приложение на основание переданного Blob-элемента.
     * Метод конвертирует Blob в base64 и отправляет на сервер, после чего добавляет картинку
     * с полученным id.
     * @param blob Блоб, который содержит изображение.
     */
    Ca(this, "importPicture", async (Un) => {
      const Kn = await this.getId(Un);
      if (Kn === null) {
        console.log("Прокиньте в меня пропсы пожалуйста");
        return;
      }
      this.callPrevInjectListeners(), await this.injectPicture(Kn);
    });
    /**
     * Возвращает структуры картинок, найденных в переданном HTML.
     * @param blob
     */
    Ca(this, "getId", async (Un) => {
      const { type: Kn } = Un;
      return Kn === "text/html" || (Kn === "image/png" || Kn === "image/jpeg") && await this.blobToBase64(Un), null;
    });
    Ca(this, "injectPicture", async (Un) => {
      const Kn = this.dependencies.componentTree.getRootComponent(), qn = this.dependencies.canvasMouseObserver.getCurrentPosition(), Jo = this.calculateComponentInjectionParams(qn), pa = Utils.generate.uuid4(), ma = Utils.generate.uuid4(), va = {
        id: pa,
        type: EditorComponentType.PICTURE,
        offset: Jo.componentOffset,
        graphics: [
          {
            id: ma,
            type: GraphicType.PICTURE,
            frame: {
              x: Jo.x,
              y: Jo.y,
              width: this.DEFAULT_WIDTH,
              height: this.DEFAULT_HEIGHT,
              rotate: 0,
              layer: 100
            },
            offset: 0,
            texture: {
              x: 0,
              y: 0,
              width: this.DEFAULT_WIDTH,
              height: this.DEFAULT_HEIGHT,
              source: Un
            }
          }
        ],
        texture: null,
        components: null
      };
      let ba;
      await this.dependencies.componentTree.executeMutations(async (_a) => {
        if (ba = _a.componentFactory.createComponent(va), await ba.setStructure(() => va), await Promise.all(
          va.graphics.map(async (xa) => {
            const wa = _a.graphicFactory.createGraphic(GraphicType.PICTURE, ba);
            await wa.setStructure(() => xa), await wa.adaptPictureToFrame(), ba.appendGraphic(wa);
          })
        ), _a.mutator.mutateByAppendComponent(Kn, ba), ba.getFirstGraphic() === null)
          throw new EditorError("picture graphic not found");
        this.callPostInjectListeners();
      });
    });
    Ca(this, "blobToBase64", (Un) => new Promise((Kn, qn) => {
      const Jo = new FileReader();
      Jo.onloadend = () => {
        Jo.result ? Kn(Jo.result) : qn(new Error("Failed to read blob"));
      }, Jo.onerror = () => qn(new Error("Error reading the blob")), Jo.readAsDataURL(Un);
    }));
    Ca(this, "callPostInjectListeners", () => {
      this.postInjectListeners.forEach((Un) => Un());
    });
    Ca(this, "callPrevInjectListeners", () => {
      this.prevInjectListeners.forEach((Un) => Un());
    });
    Ca(this, "calculateComponentInjectionParams", (Un) => {
      const qn = this.dependencies.componentTree.getRootComponent().getNearestGraphic(Un), { width: Jo, height: pa } = qn.getFrameConfiguration(), { x: ma, y: va } = qn.getGlobalPosition(), { paddingLeft: ba, paddingRight: _a, paddingTop: ya, paddingBottom: xa } = qn.getTexture();
      let wa, Ta;
      return Un.x >= ma && Un.x <= ma + Jo && Un.y >= va && Un.y <= va + pa ? (wa = Un.x - ma, Ta = Un.y - va) : Un.x >= ma && Un.x <= ma + Jo && (Un.y < va || Un.y > va + pa) ? (wa = Un.x - ma, Ta = Un.y < va ? ya : pa - xa - this.DEFAULT_HEIGHT) : Un.y >= va && Un.y <= va + pa && (Un.x < ma || Un.x > ma + Jo) ? (wa = Un.x < ma ? ba : Math.max(ba, Jo - _a - this.DEFAULT_WIDTH), Ta = Un.y - va) : (wa = Math.max(ba, Jo / 2 - this.DEFAULT_WIDTH / 2), Ta = pa / 2), {
        x: wa,
        y: Ta,
        componentOffset: qn.getOffset()
      };
    });
    this.prevInjectListeners = [], this.postInjectListeners = [];
  }
  addPostInjectListener(Un) {
    this.postInjectListeners.push(Un);
  }
  addPrevInjectListener(Un) {
    this.prevInjectListeners.push(Un);
  }
}
class TextImporter extends Dependent {
  constructor() {
    super();
    Ca(this, "MIN_TEXT_WIDTH", 80);
    Ca(this, "DEFAULT_HEIGHT", 28);
    Ca(this, "prevInjectListeners");
    Ca(this, "postInjectListeners");
    Ca(this, "importText", async (Un) => {
      this.callPrevInjectListeners();
      const Kn = this.dependencies.componentTree.getRootComponent(), qn = this.dependencies.canvasMouseObserver.getCurrentPosition(), Jo = this.calculateTextComponentInjectionParams(qn, Un), pa = Utils.generate.uuid4(), ma = Utils.generate.uuid4(), va = {
        id: pa,
        type: EditorComponentType.TEXT,
        offset: Jo.componentOffset,
        graphics: [
          {
            id: ma,
            type: GraphicType.TEXT,
            offset: 0,
            frame: {
              x: Jo.x,
              y: Jo.y,
              width: Jo.textWidth,
              height: this.DEFAULT_HEIGHT,
              rotate: 0,
              layer: 100
            },
            texture: null
          }
        ],
        texture: {
          model: {
            id: Utils.generate.uuid4(),
            tokens: Un,
            splitGraphemePositions: [],
            textAlign: TextAlign.LEFT,
            lineHeight: LineHeight.MEDIUM
          }
        },
        components: null
      };
      let ba;
      await this.dependencies.componentTree.executeMutations(async (_a) => {
        if (ba = _a.componentFactory.createComponent(va), va.graphics === null)
          throw new EditorError("graphic structures not found");
        for (let ya = 0; ya < va.graphics.length; ya++) {
          const xa = va.graphics[ya], wa = _a.graphicFactory.createGraphic(xa.type, ba);
          await wa.setStructure(() => xa), ba.appendGraphic(wa);
        }
        await ba.setStructure(() => va), _a.mutator.mutateByAppendComponent(Kn, ba), ba.enableFocus(), ba.enableEditMode();
      }), this.callPostInjectListeners();
    });
    /**
     * Возвращает ширину текста в пикселях, используя Canvas.
     * @param token Токен, содержащий текст, шрифт и размер шрифта.
     */
    Ca(this, "getTokenWidth", (Un) => {
      const qn = document.createElement("canvas").getContext("2d"), { fontSize: Jo, fontFamily: pa, value: ma } = Un;
      return qn ? (qn.font = `${Jo}px ${pa}`, qn.measureText(ma).width) : 0;
    });
    /**
     * Вычисляет параметры инжекции для текста компонента по позиции мыши.
     * @param mousePosition Текущая позиция мыши.
     * @param tokens Токены импортируемого текста.
     */
    Ca(this, "calculateTextComponentInjectionParams", (Un, Kn) => {
      const Jo = this.dependencies.componentTree.getRootComponent().getNearestGraphic(Un), { width: pa, height: ma } = Jo.getFrameConfiguration(), { x: va, y: ba } = Jo.getGlobalPosition(), { paddingLeft: _a, paddingRight: ya, paddingTop: xa, paddingBottom: wa } = Jo.getTexture(), Ta = Kn.reduce((Na, Ka) => Na + this.getTokenWidth(Ka), 0);
      let Sa, Ma;
      Un.x >= va && Un.x <= va + pa && Un.y >= ba && Un.y <= ba + ma ? (Sa = Un.x - va, Ma = Un.y - ba) : Un.x >= va && Un.x <= va + pa && (Un.y < ba || Un.y > ba + ma) ? (Sa = Un.x - va, Ma = Un.y < ba ? xa : ma - wa) : Un.y >= ba && Un.y <= ba + ma && (Un.x < va || Un.x > va + pa) ? (Sa = Un.x < va ? _a : Math.max(_a, pa - ya - Ta), Ma = Un.y - ba) : (Sa = Math.max(_a, pa / 2 - Ta / 2), Ma = ma / 2);
      const ka = Math.min(pa - ya - Sa, Ta), Za = Math.max(this.MIN_TEXT_WIDTH, ka);
      return {
        x: Sa,
        y: Ma,
        componentOffset: Jo.getOffset(),
        textWidth: Za
      };
    });
    Ca(this, "callPostInjectListeners", () => {
      this.postInjectListeners.forEach((Un) => Un());
    });
    Ca(this, "callPrevInjectListeners", () => {
      this.prevInjectListeners.forEach((Un) => Un());
    });
    this.prevInjectListeners = [], this.postInjectListeners = [];
  }
  addPostInjectListener(Un) {
    this.postInjectListeners.push(Un);
  }
  addPrevInjectListener(Un) {
    this.prevInjectListeners.push(Un);
  }
}
var Direction = /* @__PURE__ */ ((Xn) => (Xn.LEFT = "left", Xn.RIGHT = "right", Xn))(Direction || {});
class KeyCombinationTree {
  constructor() {
    Ca(this, "combinationRoot");
    Ca(this, "functionalListeners");
    Ca(this, "appendListener", (zn, ...Un) => {
      if (Un.length === 0)
        throw new EditorError("At least one key is required for a listener");
      if (Un.length === 1) {
        const Kn = Un[0], qn = this.functionalListeners.get(Kn);
        qn === void 0 ? this.functionalListeners.set(Kn, [zn]) : qn.push(zn);
      } else {
        let Kn = this.combinationRoot;
        for (let qn = 0; qn < Un.length; qn++) {
          const Jo = Un[qn];
          let pa = Kn.get(Jo);
          pa || (pa = {
            key: Jo,
            listeners: [],
            children: null
          }, Kn.set(Jo, pa)), qn === Un.length - 1 ? pa.listeners.push(zn) : (pa.children || (pa.children = /* @__PURE__ */ new Map()), Kn = pa.children);
        }
      }
    });
    Ca(this, "trigger", (zn, ...Un) => {
      Un.length === 1 ? this.triggerFunctional(zn, Un[0]) : this.triggerCombination(zn, ...Un);
    });
    Ca(this, "triggerCombination", (zn, ...Un) => {
      let Kn = this.combinationRoot;
      for (let qn = 0; qn < Un.length; qn++) {
        const Jo = Un[qn], pa = Kn.get(Jo);
        if (!pa)
          return;
        if (pa.listeners.length > 0)
          for (let ma = 0; ma < pa.listeners.length; ma++)
            pa.listeners[ma](zn);
        if (pa.children)
          Kn = pa.children;
        else
          return;
      }
    });
    Ca(this, "triggerFunctional", (zn, Un) => {
      const Kn = this.functionalListeners.get(Un);
      if (Kn)
        for (let qn = 0; qn < Kn.length; qn++)
          Kn[qn](zn);
    });
    this.combinationRoot = /* @__PURE__ */ new Map(), this.functionalListeners = /* @__PURE__ */ new Map();
  }
}
class KeyboardObserver extends Dependent {
  constructor() {
    super();
    Ca(this, "postChangeActiveKeysListeners");
    Ca(this, "SHIFT_KEYS", [KeyCode.SHIFT_LEFT, KeyCode.SHIFT_RIGHT]);
    Ca(this, "CONTROL_KEYS", [KeyCode.CONTROL_LEFT, KeyCode.CONTROL_RIGHT]);
    Ca(this, "ALT_KEYS", [KeyCode.ALT_LEFT, KeyCode.ALT_RIGHT]);
    Ca(this, "META_KEYS", [KeyCode.META_LEFT, KeyCode.META_RIGHT]);
    Ca(this, "MODIFIER_KEYS", [...this.CONTROL_KEYS, ...this.ALT_KEYS, ...this.META_KEYS]);
    Ca(this, "activeKeys");
    Ca(this, "inputListeners");
    Ca(this, "keyUpCombinationTree");
    Ca(this, "keyDownCombinationTree");
    Ca(this, "getActiveKeys", () => [...this.activeKeys]);
    Ca(this, "isPressed", (Un) => this.activeKeys.includes(Un));
    Ca(this, "addPostInputListener", (Un) => {
      this.inputListeners.push(Un);
    });
    Ca(this, "addPostKeyUpListener", (Un, ...Kn) => {
      this.keyUpCombinationTree.appendListener(Un, ...Kn);
    });
    Ca(this, "addPostKeyDownListener", (Un, ...Kn) => {
      this.keyDownCombinationTree.appendListener(Un, ...Kn);
    });
    Ca(this, "addPostChangeActiveKeysListener", (Un) => {
      this.postChangeActiveKeysListeners.push(Un);
    });
    Ca(this, "construct", () => {
      window.addEventListener("keyup", this.onKeyUp), window.addEventListener("keydown", this.onKeyDown), window.addEventListener("blur", this.onBlur);
    });
    Ca(this, "destruct", () => {
      window.removeEventListener("keyup", this.onKeyUp), window.removeEventListener("keydown", this.onKeyDown), window.removeEventListener("blur", this.onBlur);
    });
    Ca(this, "onInput", (Un) => {
      const Kn = Un.key;
      if (!(Kn.length > 1 && Kn !== KeyCode.SPACE && Kn !== KeyCode.ENTER) && !(this.activeKeys.length >= 2 && this.activeKeys.some((qn) => this.isKeyModifier(qn))) && !(this.activeKeys.length > 0 && !this.isLetter(Kn) && this.activeKeys[0] !== KeyCode.SHIFT_LEFT))
        for (let qn = 0; qn < this.inputListeners.length; qn++)
          this.inputListeners[qn](Kn);
    });
    Ca(this, "isKeyModifier", (Un) => this.MODIFIER_KEYS.includes(Un));
    Ca(this, "onKeyDown", (Un) => {
      const Kn = Un.code;
      this.activeKeys.includes(Kn) || this.activeKeys.push(Kn), this.onInput(Un), this.keyDownCombinationTree.trigger(Un, ...this.activeKeys), this.callChangeActiveKeysListeners();
    });
    Ca(this, "onKeyUp", (Un) => {
      const Kn = Un.code, qn = this.activeKeys.indexOf(Kn);
      if (!this.CONTROL_KEYS.includes(Kn) && !this.SHIFT_KEYS.includes(Kn) && !this.ALT_KEYS.includes(Kn) && !this.META_KEYS.includes(Kn) && qn !== -1 && this.activeKeys.splice(qn, 1), this.activeKeys.length !== 0) {
        if (Un.ctrlKey || this.removeControlKeys(), Un.shiftKey || this.removeShiftKeys(), Un.altKey || this.removeAltKeys(), !Un.metaKey) {
          const Jo = this.removeMetaKeys();
          Utils.platform.isMacOs() && this.activeKeys.splice(Math.min(...Jo));
        }
        this.keyUpCombinationTree.trigger(Un, ...this.activeKeys);
      }
      this.callChangeActiveKeysListeners();
    });
    Ca(this, "isLetter", (Un) => !0);
    Ca(this, "removeControlKeys", () => {
      this.removeKeys(this.CONTROL_KEYS);
    });
    Ca(this, "removeShiftKeys", () => {
      this.removeKeys(this.SHIFT_KEYS);
    });
    Ca(this, "removeAltKeys", () => {
      this.removeKeys(this.ALT_KEYS);
    });
    Ca(this, "removeMetaKeys", () => this.removeKeys(this.META_KEYS));
    Ca(this, "removeKeys", (Un) => {
      const Kn = [];
      for (let qn = 0; qn < Un.length; qn++) {
        const Jo = this.activeKeys.indexOf(Un[qn]);
        Jo !== -1 && (this.activeKeys.splice(Jo, 1), Kn.push(Jo));
      }
      return Kn;
    });
    Ca(this, "callChangeActiveKeysListeners", () => {
      this.postChangeActiveKeysListeners.forEach((Un) => Un());
    });
    Ca(this, "onBlur", () => {
      this.activeKeys.length = 0, this.callChangeActiveKeysListeners();
    });
    this.activeKeys = [], this.inputListeners = [], this.postChangeActiveKeysListeners = [], this.keyUpCombinationTree = new KeyCombinationTree(), this.keyDownCombinationTree = new KeyCombinationTree(), this.construct(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostKeyDownListener(
        Un.textEventGenerator.onRemove.bind(this, Direction.LEFT, !1, !1),
        KeyCode.BACKSPACE
      );
    });
  }
}
class PrivateTemplateKeyboardObserver extends KeyboardObserver {
  constructor() {
    super();
    Ca(this, "onCtrlG", (Un) => {
      Un.preventDefault(), this.dependencies.useCases.groupFocusComponents();
    });
    Ca(this, "onDelete", (Un) => {
      Un.preventDefault(), this.dependencies.useCases.removeFocusComponentsWithAnimate();
    });
    Ca(this, "onEscape", () => {
      this.dependencies.useCases.disableInjectingProcess(), this.dependencies.useCases.disableComponentsFocus();
    });
    Ca(this, "onCopy", async (Un) => {
      Un.preventDefault(), await this.dependencies.useCases.copy();
    });
    Ca(this, "onPaste", async (Un) => {
      Un.preventDefault(), await this.dependencies.useCases.pasteFromKeyboardHotkey();
    });
    Ca(this, "onCut", (Un) => {
      Un.preventDefault();
    });
    Ca(this, "enableMaintainAspectRatioFocusComponents", () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          qn.enableMaintainAspectRatio();
        });
      });
    });
    Ca(this, "disableMaintainAspectRatioFocusComponents", () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          qn.disableMaintainAspectRatio();
        });
      });
    });
    Ca(this, "onOpenAiModal", () => {
    });
    this.addPostInjectDependenciesListener((Un) => {
      const { useCases: Kn } = Un;
      this.addPostKeyDownListener(Kn.moveCarriageLeft, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageTop, KeyCode.ARROW_UP), this.addPostKeyDownListener(Kn.moveCarriageRight, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(Kn.moveCarriageSelectionRight, KeyCode.SHIFT_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(
        Kn.moveCarriageSelectionWordRight,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.ARROW_RIGHT
      ), this.addPostKeyDownListener(Kn.moveCarriageSelectionLeft, KeyCode.SHIFT_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.selectAllText, KeyCode.CONTROL_LEFT, KeyCode.KEY_A), this.addPostKeyDownListener(
        Kn.moveCarriageSelectionWordLeft,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.ARROW_LEFT
      ), this.addPostKeyDownListener(Kn.removeWordLeft, KeyCode.CONTROL_LEFT, KeyCode.BACKSPACE), this.addPostKeyDownListener(Kn.moveCarriageBottom, KeyCode.ARROW_DOWN), this.addPostKeyDownListener(Kn.moveCarriageWordLeft, KeyCode.CONTROL_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageWordLeft, KeyCode.META_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageWordRight, KeyCode.CONTROL_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(Kn.moveCarriageWordRight, KeyCode.META_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(this.onCtrlG, KeyCode.CONTROL_LEFT, KeyCode.KEY_G), this.addPostKeyDownListener(Kn.runInjectText, KeyCode.SHIFT_LEFT, KeyCode.KEY_T), this.addPostKeyDownListener(Kn.runInjectPicture, KeyCode.SHIFT_LEFT, KeyCode.KEY_K), this.addPostKeyDownListener(Kn.runInjectFigure, KeyCode.SHIFT_LEFT, KeyCode.KEY_F), this.addPostKeyDownListener(Kn.runInjectLine, KeyCode.SHIFT_LEFT, KeyCode.KEY_L), this.addPostKeyDownListener(
        Kn.ungroupFocusComponents,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.KEY_G
      ), this.addPostKeyDownListener(this.onDelete, KeyCode.DELETE), this.addPostKeyDownListener(this.onEscape, KeyCode.ESCAPE), this.addPostKeyDownListener(Kn.undo, KeyCode.CONTROL_LEFT, KeyCode.KEY_Z), this.addPostKeyDownListener(Kn.redo, KeyCode.CONTROL_LEFT, KeyCode.SHIFT_LEFT, KeyCode.KEY_Z), this.addPostKeyDownListener(this.onCopy, KeyCode.CONTROL_LEFT, KeyCode.KEY_C), this.addPostKeyDownListener(this.onPaste, KeyCode.CONTROL_LEFT, KeyCode.KEY_V), this.addPostKeyDownListener(this.onCopy, KeyCode.META_LEFT, KeyCode.KEY_C), this.addPostKeyDownListener(this.onPaste, KeyCode.META_LEFT, KeyCode.KEY_V);
    });
  }
}
class MagneticLineEntity {
  constructor(zn) {
    // Отступ, при котором появляется магнитная линия
    Ca(this, "VISUALIZE_LINE_OFFSET", 5);
    // Отступ, при котором графика притягивается к линии
    Ca(this, "MAGNETIZATION_OFFSET", 5);
    Ca(this, "line");
    Ca(this, "linePosition");
    /**
     * Находится ли полученная область в зоне появления линии.
     * @param frameArea - область для сканирования.
     */
    Ca(this, "isVisualizeZone", (zn) => this.isCollision(zn, this.VISUALIZE_LINE_OFFSET));
    /**
     * Находится ли полученная область в зоне притягивания графики к линии.
     * @param frameArea - проверяемая область.
     */
    Ca(this, "isMagnetizationZone", (zn) => this.isCollision(zn, this.MAGNETIZATION_OFFSET));
    Ca(this, "getObjects", () => [...this.line.getObjects()]);
    /**
     * Проверяет, пересекает ли область переданный отступ от линии.
     * @param frameConfiguration - проверяемая область.
     * @param offset - отступ от магнитной линии.
     * @returns DirectionVector в случае пересечения, в противном - `null`;
     */
    Ca(this, "isCollision", (zn, Un) => {
      switch (this.line.getDirection()) {
        case DirectionVector.LEFT:
          return this.isCollisionX(zn, Un);
        case DirectionVector.RIGHT:
          return this.isCollisionX(zn, Un);
        case DirectionVector.TOP:
          return this.isCollisionY(zn, Un);
        case DirectionVector.BOTTOM:
          return this.isCollisionY(zn, Un);
        case DirectionVector.MIDDLE_X:
          return this.isCollisionY(zn, Un);
        case DirectionVector.MIDDLE_Y:
          return this.isCollisionX(zn, Un);
        default:
          throw new EditorError("direction not found");
      }
    });
    /**
     * Проверяет, пересекает ли область границу горизонтальным ребром, а также горизонтальной серединой.
     * @param frameConfiguration - проверяемая область.
     * @param offset - отступ от магнитной линии.
     */
    Ca(this, "isCollisionX", (zn, Un) => this.isPositionInRange(zn.x, this.linePosition.x, Un) ? DirectionVector.LEFT : this.isPositionInRange(
      zn.x + zn.width / 2,
      this.linePosition.x,
      Un
    ) ? DirectionVector.MIDDLE_X : this.isPositionInRange(zn.x + zn.width, this.linePosition.x, Un) ? DirectionVector.RIGHT : null);
    /**
     * Проверяет, пересекает ли область границу вертикальным ребром, а также вертикальной серединой.
     * @param frameConfiguration - проверяемая область.
     * @param offset - отступ от магнитной линии.
     */
    Ca(this, "isCollisionY", (zn, Un) => this.isPositionInRange(zn.y, this.linePosition.y, Un) ? DirectionVector.TOP : this.isPositionInRange(
      zn.y + zn.height / 2,
      this.linePosition.y,
      Un
    ) ? DirectionVector.MIDDLE_Y : this.isPositionInRange(zn.y + zn.height, this.linePosition.y, Un) ? DirectionVector.BOTTOM : null);
    /**
     * Входит ли позиция в диапазон.
     * @param position - координата позиции.
     * @param prop - значение, от которого будет отсчитываться тригерная зона.
     * @param offset - отступ зоны от основного значения в одну сторону.
     */
    Ca(this, "isPositionInRange", (zn, Un, Kn) => zn > Un - Kn && zn < Un + Kn);
    this.line = zn, this.linePosition = zn.getPosition();
  }
}
class BaseMagneticLines extends Dependent {
  constructor() {
    super();
    Ca(this, "magneticLines");
    // Привязана ли к линии в текущий момент область
    Ca(this, "isMagnet");
    Ca(this, "mutator");
    Ca(this, "initiatorGraphic");
    Ca(this, "startConfiguration");
    /**
     * Инициирует начало процесса притяжения к магнитным линиям при перемещении объектов графики.
     * @param props Необходимые сущности для запуска процесса.
     */
    Ca(this, "start", (Un) => {
      this.mutator = Un.mutator, this.initiatorGraphic = this.calculateInitiatorGraphic(Un), this.startConfiguration = this.calculateStartConfiguration();
      const Kn = this.createMagneticLines();
      this.magneticLines.push(...Kn.map((qn) => new MagneticLineEntity(qn)));
    });
    /**
     * Завершает процесс притяжения к магнитным линиям при перемещении объектов графики.
     */
    Ca(this, "stop", async () => {
      this.mutator !== null && (this.isMagnet = !1, this.mutator.clearCorrectValues(), this.destroyMagneticLines(), this.mutator = null, this.startConfiguration = null);
    });
    Ca(this, "getObjects", () => this.magneticLines.flatMap((Un) => Un.getObjects()));
    Ca(this, "getStartConfiguration", () => this.startConfiguration);
    Ca(this, "getInitiatorGraphic", () => this.initiatorGraphic);
    Ca(this, "getMagneticLines", () => [...this.magneticLines]);
    Ca(this, "getIsMagnet", () => this.isMagnet);
    Ca(this, "setIsMagnet", (Un) => {
      this.isMagnet = Un;
    });
    /**
     * Уничтожает все запущенные магнитные линии.
     */
    Ca(this, "destroyMagneticLines", () => {
      this.magneticLines.length = 0;
    });
    this.mutator = null, this.isMagnet = !1, this.magneticLines = [], this.initiatorGraphic = null, this.startConfiguration = null;
  }
}
class MagneticLine {
  /**
   * Создает новый экземпляр MagneticLine.
   * @param direction - вектор направления линии.
   * @param rootGraphicConfiguration
   */
  constructor(zn, Un) {
    Ca(this, "object");
    Ca(this, "position");
    /**
     * Показывает магнитную линию.
     */
    Ca(this, "show", () => {
      this.object.object.visible = !0;
    });
    /**
     * Скрывает магнитную линию.
     */
    Ca(this, "hide", () => {
      this.object.object.visible = !1;
    });
    Ca(this, "getObjects", () => [this.object]);
    Ca(this, "getDirection", () => this.direction);
    Ca(this, "getPosition", () => ({ ...this.position }));
    /**
     * Устанавливает местоположение магнитной линии.
     * @param x Относительная координата X.
     * @param y Относительная координата Y
     * @param length Длина магнитной линии.
     * @param globalPosition Глобальные координаты X и Y, для размещения fabric объекта.
     */
    Ca(this, "setLocation", (zn, Un, Kn, qn) => {
      this.setConfiguration({
        x: zn,
        y: Un,
        width: this.direction === DirectionVector.BOTTOM || this.direction === DirectionVector.MIDDLE_X || this.direction === DirectionVector.TOP ? Kn : 1,
        height: this.direction === DirectionVector.LEFT || this.direction === DirectionVector.MIDDLE_Y || this.direction === DirectionVector.RIGHT ? Kn : 1,
        rotate: 0
      }, qn);
    });
    /**
     * Устанавливает конфигурацию магнитной линии.
     * @param configuration Применяемая конфигурация к линии.
     * @param globalPosition Глобальные координаты X и Y, для размещения fabric объекта.
     */
    Ca(this, "setConfiguration", (zn, Un) => {
      const { x: Kn, width: qn, y: Jo, height: pa } = zn;
      this.position.x = Kn, this.position.y = Jo, this.object.object.set({
        left: Kn + Un.x,
        top: Jo + Un.y,
        width: qn,
        height: pa
      }), this.object.relativePosition.x = Kn, this.object.relativePosition.y = Jo;
    });
    this.direction = zn, this.rootGraphicConfiguration = Un, this.position = {
      x: 0,
      y: 0
    }, this.object = {
      object: new pr({
        fill: "red",
        visible: !1,
        absolutePositioned: !0
      }),
      relativePosition: { x: 0, y: 0 }
    };
  }
}
class MagneticGraphicSideLine extends MagneticLine {
  constructor(zn) {
    super(zn.direction, zn.graphicConfiguration);
    const { x: Un, y: Kn, width: qn, height: Jo } = zn.graphicConfiguration, { x: pa, y: ma, width: va, height: ba } = zn.pageConfiguration;
    switch (zn.direction) {
      case DirectionVector.LEFT:
        this.setLocation(
          Un,
          0,
          ba,
          { x: pa, y: ma }
        );
        break;
      case DirectionVector.RIGHT:
        this.setLocation(
          Un + qn,
          0,
          ba,
          { x: pa, y: ma }
        );
        break;
      case DirectionVector.TOP:
        this.setLocation(
          0,
          Kn,
          va,
          { x: pa, y: ma }
        );
        break;
      case DirectionVector.BOTTOM:
        this.setLocation(
          0,
          Kn + Jo,
          va,
          { x: pa, y: ma }
        );
        break;
      case DirectionVector.MIDDLE_X:
        this.setLocation(
          0,
          Kn + Jo / 2,
          va,
          { x: pa, y: ma }
        );
        break;
      case DirectionVector.MIDDLE_Y:
        this.setLocation(
          Un + qn / 2,
          0,
          ba,
          { x: pa, y: ma }
        );
        break;
    }
  }
}
class MagneticPagePaddingLine extends MagneticLine {
  constructor(zn) {
    super(zn.direction, zn.pageConfiguration);
    const { x: Un, y: Kn, width: qn, height: Jo } = zn.pageConfiguration, {
      paddingLeft: pa,
      paddingRight: ma,
      paddingTop: va,
      paddingBottom: ba
    } = zn.pageTexture;
    switch (zn.direction) {
      case DirectionVector.LEFT:
        this.setLocation(
          pa,
          0,
          Jo,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.RIGHT:
        this.setLocation(
          qn - ma,
          0,
          Jo,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.TOP:
        this.setLocation(
          0,
          va,
          qn,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.BOTTOM:
        this.setLocation(
          0,
          Jo - ba,
          qn,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.MIDDLE_X:
        this.setLocation(
          0,
          Jo / 2,
          qn,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.MIDDLE_Y:
        this.setLocation(
          qn / 2,
          0,
          Jo,
          { x: Un, y: Kn }
        );
        break;
    }
  }
}
class MagneticPageSideLine extends MagneticLine {
  constructor(zn) {
    super(zn.direction, zn.pageConfiguration);
    const { x: Un, y: Kn, width: qn, height: Jo } = zn.pageConfiguration;
    switch (zn.direction) {
      case DirectionVector.LEFT:
        this.setLocation(
          0,
          0,
          Jo,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.RIGHT:
        this.setLocation(
          qn,
          0,
          Jo,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.TOP:
        this.setLocation(
          0,
          0,
          qn,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.BOTTOM:
        this.setLocation(
          0,
          Jo,
          qn,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.MIDDLE_X:
        this.setLocation(
          0,
          Jo / 2,
          qn,
          { x: Un, y: Kn }
        );
        break;
      case DirectionVector.MIDDLE_Y:
        this.setLocation(
          qn / 2,
          0,
          Jo,
          { x: Un, y: Kn }
        );
        break;
    }
  }
}
class MagneticLines extends BaseMagneticLines {
  constructor() {
    super();
    Ca(this, "createMagneticLines", () => {
      if (this.initiatorGraphic === null)
        throw new EditorError("initiator graphic not found");
      const Kn = this.dependencies.componentTree.getRootComponent().getPageFromGraphic(this.initiatorGraphic);
      if (Kn === null)
        throw new EditorError("number from initiator graphic not found");
      const qn = Kn.getFrameConfiguration(), Jo = Kn.getTexture(), pa = this.dependencies.componentTree.getGraphicSequences().map((ma) => ma.filter((va) => va.type !== GraphicType.PAGE));
      for (let ma = 0; ma < pa.length; ma++)
        if (pa[ma].includes(this.initiatorGraphic))
          return pa[ma] = pa[ma].filter((va) => va !== this.initiatorGraphic), this.initiatorGraphic.isUniter && (pa[ma] = pa[ma].filter(
            (va) => va.getParentGraphic() !== this.initiatorGraphic
          )), this.generateMagneticLines(qn, Jo, pa.flat());
      throw new EditorError("graphic not connected to component tree");
    });
    Ca(this, "calculateStartConfiguration", () => {
      if (this.initiatorGraphic === null)
        throw new EditorError("the initiator graphic not found");
      return this.dependencies.componentTree.getRootComponent().getConfigurationFromPage(this.initiatorGraphic);
    });
    Ca(this, "calculateInitiatorGraphic", (Un) => {
      var qn;
      const Kn = (qn = Un.initiator.getData()) == null ? void 0 : qn.graphic;
      if (Kn === void 0)
        throw new EditorError("graphic not found");
      return Kn;
    });
    /**
     * Создает магнитные линии на основе текущей страницы и графики.
     * @param pageConfiguration - конфигурация страницы.
     * @param pageTexture - текстура страницы.
     * @param graphics - графика на текущей странице.
     * @param pageElement - HTML элемент страницы, на которую будет добавлена линия.
     */
    Ca(this, "generateMagneticLines", (Un, Kn, qn) => [
      ...this.generatePagePaddingLines(Un, Kn),
      ...this.generatePageSideLines(Un),
      ...qn === null ? [] : this.generateGraphicsLines(Un, qn)
    ]);
    /**
     * Создает магнитные линии для внутренних отступов страницы.
     * @param pageConfiguration - конфигурация страницы, для которой создаются магнитные линии.
     * @param pageTexture - текстура страницы.
     * @param pageObject
     */
    Ca(this, "generatePagePaddingLines", (Un, Kn) => [
      new MagneticPagePaddingLine({
        pageTexture: Kn,
        pageConfiguration: Un,
        direction: DirectionVector.LEFT
      }),
      new MagneticPagePaddingLine({
        pageTexture: Kn,
        pageConfiguration: Un,
        direction: DirectionVector.TOP
      }),
      new MagneticPagePaddingLine({
        pageTexture: Kn,
        pageConfiguration: Un,
        direction: DirectionVector.RIGHT
      }),
      new MagneticPagePaddingLine({
        pageTexture: Kn,
        pageConfiguration: Un,
        direction: DirectionVector.BOTTOM
      })
    ]);
    /**
     * Создает магнитные линии для внешних границ страницы.
     * @param pageConfiguration - конфигурация страницы, для которой создаются магнитные линии.
     * @param pageObject
     */
    Ca(this, "generatePageSideLines", (Un) => [
      new MagneticPageSideLine({
        pageConfiguration: Un,
        direction: DirectionVector.LEFT
      }),
      new MagneticPageSideLine({
        pageConfiguration: Un,
        direction: DirectionVector.TOP
      }),
      new MagneticPageSideLine({
        pageConfiguration: Un,
        direction: DirectionVector.RIGHT
      }),
      new MagneticPageSideLine({
        pageConfiguration: Un,
        direction: DirectionVector.BOTTOM
      }),
      new MagneticPageSideLine({
        pageConfiguration: Un,
        direction: DirectionVector.MIDDLE_X
      }),
      new MagneticPageSideLine({
        pageConfiguration: Un,
        direction: DirectionVector.MIDDLE_Y
      })
    ]);
    /**
     * Создает магнитные линии для каждой графики.
     * @param pageConfiguration - конфигурация страницы, на которой расположена графика.
     * @param graphics - графика, расположенная на странице.
     * @param pageObject
     */
    Ca(this, "generateGraphicsLines", (Un, Kn) => Kn.flatMap((qn) => this.createGraphicLines(Un, qn)));
    /**
     * Создает магнитные линии для графики.
     * @param pageConfiguration - конфигурация страницы, на которой расположена графика.
     * @param graphic - графика, расположенная на странице.
     */
    Ca(this, "createGraphicLines", (Un, Kn) => {
      const qn = Kn.getFrameConfiguration();
      if (qn === null)
        throw new EditorError("graphic configuration not found");
      return [
        new MagneticGraphicSideLine({
          graphicConfiguration: qn,
          pageConfiguration: Un,
          direction: DirectionVector.LEFT
        }),
        new MagneticGraphicSideLine({
          graphicConfiguration: qn,
          pageConfiguration: Un,
          direction: DirectionVector.TOP
        }),
        new MagneticGraphicSideLine({
          graphicConfiguration: qn,
          pageConfiguration: Un,
          direction: DirectionVector.RIGHT
        }),
        new MagneticGraphicSideLine({
          graphicConfiguration: qn,
          pageConfiguration: Un,
          direction: DirectionVector.BOTTOM
        }),
        new MagneticGraphicSideLine({
          graphicConfiguration: qn,
          pageConfiguration: Un,
          direction: DirectionVector.MIDDLE_X
        }),
        new MagneticGraphicSideLine({
          graphicConfiguration: qn,
          pageConfiguration: Un,
          direction: DirectionVector.MIDDLE_Y
        })
      ];
    });
  }
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(Xn) {
  return Xn && Xn.__esModule && Object.prototype.hasOwnProperty.call(Xn, "default") ? Xn.default : Xn;
}
function getAugmentedNamespace(Xn) {
  if (Xn.__esModule) return Xn;
  var zn = Xn.default;
  if (typeof zn == "function") {
    var Un = function Kn() {
      return this instanceof Kn ? Reflect.construct(zn, arguments, this.constructor) : zn.apply(this, arguments);
    };
    Un.prototype = zn.prototype;
  } else Un = {};
  return Object.defineProperty(Un, "__esModule", { value: !0 }), Object.keys(Xn).forEach(function(Kn) {
    var qn = Object.getOwnPropertyDescriptor(Xn, Kn);
    Object.defineProperty(Un, Kn, qn.get ? qn : { enumerable: !0, get: function() {
      return Xn[Kn];
    } });
  }), Un;
}
typeof self > "u" && typeof commonjsGlobal == "object" && (commonjsGlobal.self = commonjsGlobal);
var global$1 = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, lookup$2 = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, inited = !1;
function init() {
  inited = !0;
  for (var Xn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", zn = 0; zn < 64; ++zn) lookup$2[zn] = Xn[zn], revLookup[Xn.charCodeAt(zn)] = zn;
  revLookup[45] = 62, revLookup[95] = 63;
}
function toByteArray(Xn) {
  var zn, Un, Kn, qn, Jo, pa;
  inited || init();
  var ma = Xn.length;
  if (ma % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  Jo = Xn[ma - 2] === "=" ? 2 : Xn[ma - 1] === "=" ? 1 : 0, pa = new Arr(3 * ma / 4 - Jo), Kn = Jo > 0 ? ma - 4 : ma;
  var va = 0;
  for (zn = 0, Un = 0; zn < Kn; zn += 4, Un += 3) qn = revLookup[Xn.charCodeAt(zn)] << 18 | revLookup[Xn.charCodeAt(zn + 1)] << 12 | revLookup[Xn.charCodeAt(zn + 2)] << 6 | revLookup[Xn.charCodeAt(zn + 3)], pa[va++] = qn >> 16 & 255, pa[va++] = qn >> 8 & 255, pa[va++] = 255 & qn;
  return Jo === 2 ? (qn = revLookup[Xn.charCodeAt(zn)] << 2 | revLookup[Xn.charCodeAt(zn + 1)] >> 4, pa[va++] = 255 & qn) : Jo === 1 && (qn = revLookup[Xn.charCodeAt(zn)] << 10 | revLookup[Xn.charCodeAt(zn + 1)] << 4 | revLookup[Xn.charCodeAt(zn + 2)] >> 2, pa[va++] = qn >> 8 & 255, pa[va++] = 255 & qn), pa;
}
function tripletToBase64(Xn) {
  return lookup$2[Xn >> 18 & 63] + lookup$2[Xn >> 12 & 63] + lookup$2[Xn >> 6 & 63] + lookup$2[63 & Xn];
}
function encodeChunk(Xn, zn, Un) {
  for (var Kn, qn = [], Jo = zn; Jo < Un; Jo += 3) Kn = (Xn[Jo] << 16) + (Xn[Jo + 1] << 8) + Xn[Jo + 2], qn.push(tripletToBase64(Kn));
  return qn.join("");
}
function fromByteArray(Xn) {
  var zn;
  inited || init();
  for (var Un = Xn.length, Kn = Un % 3, qn = "", Jo = [], pa = 16383, ma = 0, va = Un - Kn; ma < va; ma += pa) Jo.push(encodeChunk(Xn, ma, ma + pa > va ? va : ma + pa));
  return Kn === 1 ? (zn = Xn[Un - 1], qn += lookup$2[zn >> 2], qn += lookup$2[zn << 4 & 63], qn += "==") : Kn === 2 && (zn = (Xn[Un - 2] << 8) + Xn[Un - 1], qn += lookup$2[zn >> 10], qn += lookup$2[zn >> 4 & 63], qn += lookup$2[zn << 2 & 63], qn += "="), Jo.push(qn), Jo.join("");
}
function read(Xn, zn, Un, Kn, qn) {
  var Jo, pa, ma = 8 * qn - Kn - 1, va = (1 << ma) - 1, ba = va >> 1, _a = -7, ya = Un ? qn - 1 : 0, xa = Un ? -1 : 1, wa = Xn[zn + ya];
  for (ya += xa, Jo = wa & (1 << -_a) - 1, wa >>= -_a, _a += ma; _a > 0; Jo = 256 * Jo + Xn[zn + ya], ya += xa, _a -= 8) ;
  for (pa = Jo & (1 << -_a) - 1, Jo >>= -_a, _a += Kn; _a > 0; pa = 256 * pa + Xn[zn + ya], ya += xa, _a -= 8) ;
  if (Jo === 0) Jo = 1 - ba;
  else {
    if (Jo === va) return pa ? NaN : 1 / 0 * (wa ? -1 : 1);
    pa += Math.pow(2, Kn), Jo -= ba;
  }
  return (wa ? -1 : 1) * pa * Math.pow(2, Jo - Kn);
}
function write(Xn, zn, Un, Kn, qn, Jo) {
  var pa, ma, va, ba = 8 * Jo - qn - 1, _a = (1 << ba) - 1, ya = _a >> 1, xa = qn === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, wa = Kn ? 0 : Jo - 1, Ta = Kn ? 1 : -1, Sa = zn < 0 || zn === 0 && 1 / zn < 0 ? 1 : 0;
  for (zn = Math.abs(zn), isNaN(zn) || zn === 1 / 0 ? (ma = isNaN(zn) ? 1 : 0, pa = _a) : (pa = Math.floor(Math.log(zn) / Math.LN2), zn * (va = Math.pow(2, -pa)) < 1 && (pa--, va *= 2), (zn += pa + ya >= 1 ? xa / va : xa * Math.pow(2, 1 - ya)) * va >= 2 && (pa++, va /= 2), pa + ya >= _a ? (ma = 0, pa = _a) : pa + ya >= 1 ? (ma = (zn * va - 1) * Math.pow(2, qn), pa += ya) : (ma = zn * Math.pow(2, ya - 1) * Math.pow(2, qn), pa = 0)); qn >= 8; Xn[Un + wa] = 255 & ma, wa += Ta, ma /= 256, qn -= 8) ;
  for (pa = pa << qn | ma, ba += qn; ba > 0; Xn[Un + wa] = 255 & pa, wa += Ta, pa /= 256, ba -= 8) ;
  Xn[Un + wa - Ta] |= 128 * Sa;
}
var toString = {}.toString, isArray = Array.isArray || function(Xn) {
  return toString.call(Xn) == "[object Array]";
}, INSPECT_MAX_BYTES = 50;
function kMaxLength() {
  return Buffer$1.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function createBuffer(Xn, zn) {
  if (kMaxLength() < zn) throw new RangeError("Invalid typed array length");
  return Buffer$1.TYPED_ARRAY_SUPPORT ? (Xn = new Uint8Array(zn)).__proto__ = Buffer$1.prototype : (Xn === null && (Xn = new Buffer$1(zn)), Xn.length = zn), Xn;
}
function Buffer$1(Xn, zn, Un) {
  if (!(Buffer$1.TYPED_ARRAY_SUPPORT || this instanceof Buffer$1)) return new Buffer$1(Xn, zn, Un);
  if (typeof Xn == "number") {
    if (typeof zn == "string") throw new Error("If encoding is specified then the first argument must be a string");
    return allocUnsafe(this, Xn);
  }
  return from(this, Xn, zn, Un);
}
function from(Xn, zn, Un, Kn) {
  if (typeof zn == "number") throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && zn instanceof ArrayBuffer ? fromArrayBuffer(Xn, zn, Un, Kn) : typeof zn == "string" ? fromString(Xn, zn, Un) : fromObject(Xn, zn);
}
function assertSize(Xn) {
  if (typeof Xn != "number") throw new TypeError('"size" argument must be a number');
  if (Xn < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(Xn, zn, Un, Kn) {
  return assertSize(zn), zn <= 0 ? createBuffer(Xn, zn) : Un !== void 0 ? typeof Kn == "string" ? createBuffer(Xn, zn).fill(Un, Kn) : createBuffer(Xn, zn).fill(Un) : createBuffer(Xn, zn);
}
function allocUnsafe(Xn, zn) {
  if (assertSize(zn), Xn = createBuffer(Xn, zn < 0 ? 0 : 0 | checked(zn)), !Buffer$1.TYPED_ARRAY_SUPPORT) for (var Un = 0; Un < zn; ++Un) Xn[Un] = 0;
  return Xn;
}
function fromString(Xn, zn, Un) {
  if (typeof Un == "string" && Un !== "" || (Un = "utf8"), !Buffer$1.isEncoding(Un)) throw new TypeError('"encoding" must be a valid string encoding');
  var Kn = 0 | byteLength(zn, Un), qn = (Xn = createBuffer(Xn, Kn)).write(zn, Un);
  return qn !== Kn && (Xn = Xn.slice(0, qn)), Xn;
}
function fromArrayLike(Xn, zn) {
  var Un = zn.length < 0 ? 0 : 0 | checked(zn.length);
  Xn = createBuffer(Xn, Un);
  for (var Kn = 0; Kn < Un; Kn += 1) Xn[Kn] = 255 & zn[Kn];
  return Xn;
}
function fromArrayBuffer(Xn, zn, Un, Kn) {
  if (zn.byteLength, Un < 0 || zn.byteLength < Un) throw new RangeError("'offset' is out of bounds");
  if (zn.byteLength < Un + (Kn || 0)) throw new RangeError("'length' is out of bounds");
  return zn = Un === void 0 && Kn === void 0 ? new Uint8Array(zn) : Kn === void 0 ? new Uint8Array(zn, Un) : new Uint8Array(zn, Un, Kn), Buffer$1.TYPED_ARRAY_SUPPORT ? (Xn = zn).__proto__ = Buffer$1.prototype : Xn = fromArrayLike(Xn, zn), Xn;
}
function fromObject(Xn, zn) {
  if (internalIsBuffer(zn)) {
    var Un = 0 | checked(zn.length);
    return (Xn = createBuffer(Xn, Un)).length === 0 || zn.copy(Xn, 0, 0, Un), Xn;
  }
  if (zn) {
    if (typeof ArrayBuffer < "u" && zn.buffer instanceof ArrayBuffer || "length" in zn) return typeof zn.length != "number" || isnan(zn.length) ? createBuffer(Xn, 0) : fromArrayLike(Xn, zn);
    if (zn.type === "Buffer" && isArray(zn.data)) return fromArrayLike(Xn, zn.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(Xn) {
  if (Xn >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
  return 0 | Xn;
}
function internalIsBuffer(Xn) {
  return !(Xn == null || !Xn._isBuffer);
}
function byteLength(Xn, zn) {
  if (internalIsBuffer(Xn)) return Xn.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(Xn) || Xn instanceof ArrayBuffer)) return Xn.byteLength;
  typeof Xn != "string" && (Xn = "" + Xn);
  var Un = Xn.length;
  if (Un === 0) return 0;
  for (var Kn = !1; ; ) switch (zn) {
    case "ascii":
    case "latin1":
    case "binary":
      return Un;
    case "utf8":
    case "utf-8":
    case void 0:
      return utf8ToBytes(Xn).length;
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return 2 * Un;
    case "hex":
      return Un >>> 1;
    case "base64":
      return base64ToBytes(Xn).length;
    default:
      if (Kn) return utf8ToBytes(Xn).length;
      zn = ("" + zn).toLowerCase(), Kn = !0;
  }
}
function slowToString(Xn, zn, Un) {
  var Kn = !1;
  if ((zn === void 0 || zn < 0) && (zn = 0), zn > this.length || ((Un === void 0 || Un > this.length) && (Un = this.length), Un <= 0) || (Un >>>= 0) <= (zn >>>= 0)) return "";
  for (Xn || (Xn = "utf8"); ; ) switch (Xn) {
    case "hex":
      return hexSlice(this, zn, Un);
    case "utf8":
    case "utf-8":
      return utf8Slice(this, zn, Un);
    case "ascii":
      return asciiSlice(this, zn, Un);
    case "latin1":
    case "binary":
      return latin1Slice(this, zn, Un);
    case "base64":
      return base64Slice(this, zn, Un);
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return utf16leSlice(this, zn, Un);
    default:
      if (Kn) throw new TypeError("Unknown encoding: " + Xn);
      Xn = (Xn + "").toLowerCase(), Kn = !0;
  }
}
function swap(Xn, zn, Un) {
  var Kn = Xn[zn];
  Xn[zn] = Xn[Un], Xn[Un] = Kn;
}
function bidirectionalIndexOf(Xn, zn, Un, Kn, qn) {
  if (Xn.length === 0) return -1;
  if (typeof Un == "string" ? (Kn = Un, Un = 0) : Un > 2147483647 ? Un = 2147483647 : Un < -2147483648 && (Un = -2147483648), Un = +Un, isNaN(Un) && (Un = qn ? 0 : Xn.length - 1), Un < 0 && (Un = Xn.length + Un), Un >= Xn.length) {
    if (qn) return -1;
    Un = Xn.length - 1;
  } else if (Un < 0) {
    if (!qn) return -1;
    Un = 0;
  }
  if (typeof zn == "string" && (zn = Buffer$1.from(zn, Kn)), internalIsBuffer(zn)) return zn.length === 0 ? -1 : arrayIndexOf(Xn, zn, Un, Kn, qn);
  if (typeof zn == "number") return zn &= 255, Buffer$1.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? qn ? Uint8Array.prototype.indexOf.call(Xn, zn, Un) : Uint8Array.prototype.lastIndexOf.call(Xn, zn, Un) : arrayIndexOf(Xn, [zn], Un, Kn, qn);
  throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(Xn, zn, Un, Kn, qn) {
  var Jo, pa = 1, ma = Xn.length, va = zn.length;
  if (Kn !== void 0 && ((Kn = String(Kn).toLowerCase()) === "ucs2" || Kn === "ucs-2" || Kn === "utf16le" || Kn === "utf-16le")) {
    if (Xn.length < 2 || zn.length < 2) return -1;
    pa = 2, ma /= 2, va /= 2, Un /= 2;
  }
  function ba(wa, Ta) {
    return pa === 1 ? wa[Ta] : wa.readUInt16BE(Ta * pa);
  }
  if (qn) {
    var _a = -1;
    for (Jo = Un; Jo < ma; Jo++) if (ba(Xn, Jo) === ba(zn, _a === -1 ? 0 : Jo - _a)) {
      if (_a === -1 && (_a = Jo), Jo - _a + 1 === va) return _a * pa;
    } else _a !== -1 && (Jo -= Jo - _a), _a = -1;
  } else for (Un + va > ma && (Un = ma - va), Jo = Un; Jo >= 0; Jo--) {
    for (var ya = !0, xa = 0; xa < va; xa++) if (ba(Xn, Jo + xa) !== ba(zn, xa)) {
      ya = !1;
      break;
    }
    if (ya) return Jo;
  }
  return -1;
}
function hexWrite(Xn, zn, Un, Kn) {
  Un = Number(Un) || 0;
  var qn = Xn.length - Un;
  Kn ? (Kn = Number(Kn)) > qn && (Kn = qn) : Kn = qn;
  var Jo = zn.length;
  if (Jo % 2 != 0) throw new TypeError("Invalid hex string");
  Kn > Jo / 2 && (Kn = Jo / 2);
  for (var pa = 0; pa < Kn; ++pa) {
    var ma = parseInt(zn.substr(2 * pa, 2), 16);
    if (isNaN(ma)) return pa;
    Xn[Un + pa] = ma;
  }
  return pa;
}
function utf8Write(Xn, zn, Un, Kn) {
  return blitBuffer(utf8ToBytes(zn, Xn.length - Un), Xn, Un, Kn);
}
function asciiWrite(Xn, zn, Un, Kn) {
  return blitBuffer(asciiToBytes(zn), Xn, Un, Kn);
}
function latin1Write(Xn, zn, Un, Kn) {
  return asciiWrite(Xn, zn, Un, Kn);
}
function base64Write(Xn, zn, Un, Kn) {
  return blitBuffer(base64ToBytes(zn), Xn, Un, Kn);
}
function ucs2Write(Xn, zn, Un, Kn) {
  return blitBuffer(utf16leToBytes(zn, Xn.length - Un), Xn, Un, Kn);
}
function base64Slice(Xn, zn, Un) {
  return zn === 0 && Un === Xn.length ? fromByteArray(Xn) : fromByteArray(Xn.slice(zn, Un));
}
function utf8Slice(Xn, zn, Un) {
  Un = Math.min(Xn.length, Un);
  for (var Kn = [], qn = zn; qn < Un; ) {
    var Jo, pa, ma, va, ba = Xn[qn], _a = null, ya = ba > 239 ? 4 : ba > 223 ? 3 : ba > 191 ? 2 : 1;
    if (qn + ya <= Un) switch (ya) {
      case 1:
        ba < 128 && (_a = ba);
        break;
      case 2:
        (192 & (Jo = Xn[qn + 1])) == 128 && (va = (31 & ba) << 6 | 63 & Jo) > 127 && (_a = va);
        break;
      case 3:
        Jo = Xn[qn + 1], pa = Xn[qn + 2], (192 & Jo) == 128 && (192 & pa) == 128 && (va = (15 & ba) << 12 | (63 & Jo) << 6 | 63 & pa) > 2047 && (va < 55296 || va > 57343) && (_a = va);
        break;
      case 4:
        Jo = Xn[qn + 1], pa = Xn[qn + 2], ma = Xn[qn + 3], (192 & Jo) == 128 && (192 & pa) == 128 && (192 & ma) == 128 && (va = (15 & ba) << 18 | (63 & Jo) << 12 | (63 & pa) << 6 | 63 & ma) > 65535 && va < 1114112 && (_a = va);
    }
    _a === null ? (_a = 65533, ya = 1) : _a > 65535 && (_a -= 65536, Kn.push(_a >>> 10 & 1023 | 55296), _a = 56320 | 1023 & _a), Kn.push(_a), qn += ya;
  }
  return decodeCodePointsArray(Kn);
}
Buffer$1.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT === void 0 || global$1.TYPED_ARRAY_SUPPORT, kMaxLength(), Buffer$1.poolSize = 8192, Buffer$1._augment = function(Xn) {
  return Xn.__proto__ = Buffer$1.prototype, Xn;
}, Buffer$1.from = function(Xn, zn, Un) {
  return from(null, Xn, zn, Un);
}, Buffer$1.TYPED_ARRAY_SUPPORT && (Buffer$1.prototype.__proto__ = Uint8Array.prototype, Buffer$1.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Buffer$1[Symbol.species]), Buffer$1.alloc = function(Xn, zn, Un) {
  return alloc(null, Xn, zn, Un);
}, Buffer$1.allocUnsafe = function(Xn) {
  return allocUnsafe(null, Xn);
}, Buffer$1.allocUnsafeSlow = function(Xn) {
  return allocUnsafe(null, Xn);
}, Buffer$1.isBuffer = isBuffer, Buffer$1.compare = function(Xn, zn) {
  if (!internalIsBuffer(Xn) || !internalIsBuffer(zn)) throw new TypeError("Arguments must be Buffers");
  if (Xn === zn) return 0;
  for (var Un = Xn.length, Kn = zn.length, qn = 0, Jo = Math.min(Un, Kn); qn < Jo; ++qn) if (Xn[qn] !== zn[qn]) {
    Un = Xn[qn], Kn = zn[qn];
    break;
  }
  return Un < Kn ? -1 : Kn < Un ? 1 : 0;
}, Buffer$1.isEncoding = function(Xn) {
  switch (String(Xn).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
}, Buffer$1.concat = function(Xn, zn) {
  if (!isArray(Xn)) throw new TypeError('"list" argument must be an Array of Buffers');
  if (Xn.length === 0) return Buffer$1.alloc(0);
  var Un;
  if (zn === void 0) for (zn = 0, Un = 0; Un < Xn.length; ++Un) zn += Xn[Un].length;
  var Kn = Buffer$1.allocUnsafe(zn), qn = 0;
  for (Un = 0; Un < Xn.length; ++Un) {
    var Jo = Xn[Un];
    if (!internalIsBuffer(Jo)) throw new TypeError('"list" argument must be an Array of Buffers');
    Jo.copy(Kn, qn), qn += Jo.length;
  }
  return Kn;
}, Buffer$1.byteLength = byteLength, Buffer$1.prototype._isBuffer = !0, Buffer$1.prototype.swap16 = function() {
  var Xn = this.length;
  if (Xn % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var zn = 0; zn < Xn; zn += 2) swap(this, zn, zn + 1);
  return this;
}, Buffer$1.prototype.swap32 = function() {
  var Xn = this.length;
  if (Xn % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var zn = 0; zn < Xn; zn += 4) swap(this, zn, zn + 3), swap(this, zn + 1, zn + 2);
  return this;
}, Buffer$1.prototype.swap64 = function() {
  var Xn = this.length;
  if (Xn % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var zn = 0; zn < Xn; zn += 8) swap(this, zn, zn + 7), swap(this, zn + 1, zn + 6), swap(this, zn + 2, zn + 5), swap(this, zn + 3, zn + 4);
  return this;
}, Buffer$1.prototype.toString = function() {
  var Xn = 0 | this.length;
  return Xn === 0 ? "" : arguments.length === 0 ? utf8Slice(this, 0, Xn) : slowToString.apply(this, arguments);
}, Buffer$1.prototype.equals = function(Xn) {
  if (!internalIsBuffer(Xn)) throw new TypeError("Argument must be a Buffer");
  return this === Xn || Buffer$1.compare(this, Xn) === 0;
}, Buffer$1.prototype.inspect = function() {
  var Xn = "", zn = INSPECT_MAX_BYTES;
  return this.length > 0 && (Xn = this.toString("hex", 0, zn).match(/.{2}/g).join(" "), this.length > zn && (Xn += " ... ")), "<Buffer " + Xn + ">";
}, Buffer$1.prototype.compare = function(Xn, zn, Un, Kn, qn) {
  if (!internalIsBuffer(Xn)) throw new TypeError("Argument must be a Buffer");
  if (zn === void 0 && (zn = 0), Un === void 0 && (Un = Xn ? Xn.length : 0), Kn === void 0 && (Kn = 0), qn === void 0 && (qn = this.length), zn < 0 || Un > Xn.length || Kn < 0 || qn > this.length) throw new RangeError("out of range index");
  if (Kn >= qn && zn >= Un) return 0;
  if (Kn >= qn) return -1;
  if (zn >= Un) return 1;
  if (this === Xn) return 0;
  for (var Jo = (qn >>>= 0) - (Kn >>>= 0), pa = (Un >>>= 0) - (zn >>>= 0), ma = Math.min(Jo, pa), va = this.slice(Kn, qn), ba = Xn.slice(zn, Un), _a = 0; _a < ma; ++_a) if (va[_a] !== ba[_a]) {
    Jo = va[_a], pa = ba[_a];
    break;
  }
  return Jo < pa ? -1 : pa < Jo ? 1 : 0;
}, Buffer$1.prototype.includes = function(Xn, zn, Un) {
  return this.indexOf(Xn, zn, Un) !== -1;
}, Buffer$1.prototype.indexOf = function(Xn, zn, Un) {
  return bidirectionalIndexOf(this, Xn, zn, Un, !0);
}, Buffer$1.prototype.lastIndexOf = function(Xn, zn, Un) {
  return bidirectionalIndexOf(this, Xn, zn, Un, !1);
}, Buffer$1.prototype.write = function(Xn, zn, Un, Kn) {
  if (zn === void 0) Kn = "utf8", Un = this.length, zn = 0;
  else if (Un === void 0 && typeof zn == "string") Kn = zn, Un = this.length, zn = 0;
  else {
    if (!isFinite(zn)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    zn |= 0, isFinite(Un) ? (Un |= 0, Kn === void 0 && (Kn = "utf8")) : (Kn = Un, Un = void 0);
  }
  var qn = this.length - zn;
  if ((Un === void 0 || Un > qn) && (Un = qn), Xn.length > 0 && (Un < 0 || zn < 0) || zn > this.length) throw new RangeError("Attempt to write outside buffer bounds");
  Kn || (Kn = "utf8");
  for (var Jo = !1; ; ) switch (Kn) {
    case "hex":
      return hexWrite(this, Xn, zn, Un);
    case "utf8":
    case "utf-8":
      return utf8Write(this, Xn, zn, Un);
    case "ascii":
      return asciiWrite(this, Xn, zn, Un);
    case "latin1":
    case "binary":
      return latin1Write(this, Xn, zn, Un);
    case "base64":
      return base64Write(this, Xn, zn, Un);
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return ucs2Write(this, Xn, zn, Un);
    default:
      if (Jo) throw new TypeError("Unknown encoding: " + Kn);
      Kn = ("" + Kn).toLowerCase(), Jo = !0;
  }
}, Buffer$1.prototype.toJSON = function() {
  return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
};
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(Xn) {
  var zn = Xn.length;
  if (zn <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, Xn);
  for (var Un = "", Kn = 0; Kn < zn; ) Un += String.fromCharCode.apply(String, Xn.slice(Kn, Kn += MAX_ARGUMENTS_LENGTH));
  return Un;
}
function asciiSlice(Xn, zn, Un) {
  var Kn = "";
  Un = Math.min(Xn.length, Un);
  for (var qn = zn; qn < Un; ++qn) Kn += String.fromCharCode(127 & Xn[qn]);
  return Kn;
}
function latin1Slice(Xn, zn, Un) {
  var Kn = "";
  Un = Math.min(Xn.length, Un);
  for (var qn = zn; qn < Un; ++qn) Kn += String.fromCharCode(Xn[qn]);
  return Kn;
}
function hexSlice(Xn, zn, Un) {
  var Kn = Xn.length;
  (!zn || zn < 0) && (zn = 0), (!Un || Un < 0 || Un > Kn) && (Un = Kn);
  for (var qn = "", Jo = zn; Jo < Un; ++Jo) qn += toHex(Xn[Jo]);
  return qn;
}
function utf16leSlice(Xn, zn, Un) {
  for (var Kn = Xn.slice(zn, Un), qn = "", Jo = 0; Jo < Kn.length; Jo += 2) qn += String.fromCharCode(Kn[Jo] + 256 * Kn[Jo + 1]);
  return qn;
}
function checkOffset(Xn, zn, Un) {
  if (Xn % 1 != 0 || Xn < 0) throw new RangeError("offset is not uint");
  if (Xn + zn > Un) throw new RangeError("Trying to access beyond buffer length");
}
function checkInt(Xn, zn, Un, Kn, qn, Jo) {
  if (!internalIsBuffer(Xn)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (zn > qn || zn < Jo) throw new RangeError('"value" argument is out of bounds');
  if (Un + Kn > Xn.length) throw new RangeError("Index out of range");
}
function objectWriteUInt16(Xn, zn, Un, Kn) {
  zn < 0 && (zn = 65535 + zn + 1);
  for (var qn = 0, Jo = Math.min(Xn.length - Un, 2); qn < Jo; ++qn) Xn[Un + qn] = (zn & 255 << 8 * (Kn ? qn : 1 - qn)) >>> 8 * (Kn ? qn : 1 - qn);
}
function objectWriteUInt32(Xn, zn, Un, Kn) {
  zn < 0 && (zn = 4294967295 + zn + 1);
  for (var qn = 0, Jo = Math.min(Xn.length - Un, 4); qn < Jo; ++qn) Xn[Un + qn] = zn >>> 8 * (Kn ? qn : 3 - qn) & 255;
}
function checkIEEE754(Xn, zn, Un, Kn, qn, Jo) {
  if (Un + Kn > Xn.length) throw new RangeError("Index out of range");
  if (Un < 0) throw new RangeError("Index out of range");
}
function writeFloat(Xn, zn, Un, Kn, qn) {
  return qn || checkIEEE754(Xn, zn, Un, 4), write(Xn, zn, Un, Kn, 23, 4), Un + 4;
}
function writeDouble(Xn, zn, Un, Kn, qn) {
  return qn || checkIEEE754(Xn, zn, Un, 8), write(Xn, zn, Un, Kn, 52, 8), Un + 8;
}
Buffer$1.prototype.slice = function(Xn, zn) {
  var Un, Kn = this.length;
  if ((Xn = ~~Xn) < 0 ? (Xn += Kn) < 0 && (Xn = 0) : Xn > Kn && (Xn = Kn), (zn = zn === void 0 ? Kn : ~~zn) < 0 ? (zn += Kn) < 0 && (zn = 0) : zn > Kn && (zn = Kn), zn < Xn && (zn = Xn), Buffer$1.TYPED_ARRAY_SUPPORT) (Un = this.subarray(Xn, zn)).__proto__ = Buffer$1.prototype;
  else {
    var qn = zn - Xn;
    Un = new Buffer$1(qn, void 0);
    for (var Jo = 0; Jo < qn; ++Jo) Un[Jo] = this[Jo + Xn];
  }
  return Un;
}, Buffer$1.prototype.readUIntLE = function(Xn, zn, Un) {
  Xn |= 0, zn |= 0, Un || checkOffset(Xn, zn, this.length);
  for (var Kn = this[Xn], qn = 1, Jo = 0; ++Jo < zn && (qn *= 256); ) Kn += this[Xn + Jo] * qn;
  return Kn;
}, Buffer$1.prototype.readUIntBE = function(Xn, zn, Un) {
  Xn |= 0, zn |= 0, Un || checkOffset(Xn, zn, this.length);
  for (var Kn = this[Xn + --zn], qn = 1; zn > 0 && (qn *= 256); ) Kn += this[Xn + --zn] * qn;
  return Kn;
}, Buffer$1.prototype.readUInt8 = function(Xn, zn) {
  return zn || checkOffset(Xn, 1, this.length), this[Xn];
}, Buffer$1.prototype.readUInt16LE = function(Xn, zn) {
  return zn || checkOffset(Xn, 2, this.length), this[Xn] | this[Xn + 1] << 8;
}, Buffer$1.prototype.readUInt16BE = function(Xn, zn) {
  return zn || checkOffset(Xn, 2, this.length), this[Xn] << 8 | this[Xn + 1];
}, Buffer$1.prototype.readUInt32LE = function(Xn, zn) {
  return zn || checkOffset(Xn, 4, this.length), (this[Xn] | this[Xn + 1] << 8 | this[Xn + 2] << 16) + 16777216 * this[Xn + 3];
}, Buffer$1.prototype.readUInt32BE = function(Xn, zn) {
  return zn || checkOffset(Xn, 4, this.length), 16777216 * this[Xn] + (this[Xn + 1] << 16 | this[Xn + 2] << 8 | this[Xn + 3]);
}, Buffer$1.prototype.readIntLE = function(Xn, zn, Un) {
  Xn |= 0, zn |= 0, Un || checkOffset(Xn, zn, this.length);
  for (var Kn = this[Xn], qn = 1, Jo = 0; ++Jo < zn && (qn *= 256); ) Kn += this[Xn + Jo] * qn;
  return Kn >= (qn *= 128) && (Kn -= Math.pow(2, 8 * zn)), Kn;
}, Buffer$1.prototype.readIntBE = function(Xn, zn, Un) {
  Xn |= 0, zn |= 0, Un || checkOffset(Xn, zn, this.length);
  for (var Kn = zn, qn = 1, Jo = this[Xn + --Kn]; Kn > 0 && (qn *= 256); ) Jo += this[Xn + --Kn] * qn;
  return Jo >= (qn *= 128) && (Jo -= Math.pow(2, 8 * zn)), Jo;
}, Buffer$1.prototype.readInt8 = function(Xn, zn) {
  return zn || checkOffset(Xn, 1, this.length), 128 & this[Xn] ? -1 * (255 - this[Xn] + 1) : this[Xn];
}, Buffer$1.prototype.readInt16LE = function(Xn, zn) {
  zn || checkOffset(Xn, 2, this.length);
  var Un = this[Xn] | this[Xn + 1] << 8;
  return 32768 & Un ? 4294901760 | Un : Un;
}, Buffer$1.prototype.readInt16BE = function(Xn, zn) {
  zn || checkOffset(Xn, 2, this.length);
  var Un = this[Xn + 1] | this[Xn] << 8;
  return 32768 & Un ? 4294901760 | Un : Un;
}, Buffer$1.prototype.readInt32LE = function(Xn, zn) {
  return zn || checkOffset(Xn, 4, this.length), this[Xn] | this[Xn + 1] << 8 | this[Xn + 2] << 16 | this[Xn + 3] << 24;
}, Buffer$1.prototype.readInt32BE = function(Xn, zn) {
  return zn || checkOffset(Xn, 4, this.length), this[Xn] << 24 | this[Xn + 1] << 16 | this[Xn + 2] << 8 | this[Xn + 3];
}, Buffer$1.prototype.readFloatLE = function(Xn, zn) {
  return zn || checkOffset(Xn, 4, this.length), read(this, Xn, !0, 23, 4);
}, Buffer$1.prototype.readFloatBE = function(Xn, zn) {
  return zn || checkOffset(Xn, 4, this.length), read(this, Xn, !1, 23, 4);
}, Buffer$1.prototype.readDoubleLE = function(Xn, zn) {
  return zn || checkOffset(Xn, 8, this.length), read(this, Xn, !0, 52, 8);
}, Buffer$1.prototype.readDoubleBE = function(Xn, zn) {
  return zn || checkOffset(Xn, 8, this.length), read(this, Xn, !1, 52, 8);
}, Buffer$1.prototype.writeUIntLE = function(Xn, zn, Un, Kn) {
  Xn = +Xn, zn |= 0, Un |= 0, Kn || checkInt(this, Xn, zn, Un, Math.pow(2, 8 * Un) - 1, 0);
  var qn = 1, Jo = 0;
  for (this[zn] = 255 & Xn; ++Jo < Un && (qn *= 256); ) this[zn + Jo] = Xn / qn & 255;
  return zn + Un;
}, Buffer$1.prototype.writeUIntBE = function(Xn, zn, Un, Kn) {
  Xn = +Xn, zn |= 0, Un |= 0, Kn || checkInt(this, Xn, zn, Un, Math.pow(2, 8 * Un) - 1, 0);
  var qn = Un - 1, Jo = 1;
  for (this[zn + qn] = 255 & Xn; --qn >= 0 && (Jo *= 256); ) this[zn + qn] = Xn / Jo & 255;
  return zn + Un;
}, Buffer$1.prototype.writeUInt8 = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 1, 255, 0), Buffer$1.TYPED_ARRAY_SUPPORT || (Xn = Math.floor(Xn)), this[zn] = 255 & Xn, zn + 1;
}, Buffer$1.prototype.writeUInt16LE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 2, 65535, 0), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn] = 255 & Xn, this[zn + 1] = Xn >>> 8) : objectWriteUInt16(this, Xn, zn, !0), zn + 2;
}, Buffer$1.prototype.writeUInt16BE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 2, 65535, 0), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn] = Xn >>> 8, this[zn + 1] = 255 & Xn) : objectWriteUInt16(this, Xn, zn, !1), zn + 2;
}, Buffer$1.prototype.writeUInt32LE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 4, 4294967295, 0), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn + 3] = Xn >>> 24, this[zn + 2] = Xn >>> 16, this[zn + 1] = Xn >>> 8, this[zn] = 255 & Xn) : objectWriteUInt32(this, Xn, zn, !0), zn + 4;
}, Buffer$1.prototype.writeUInt32BE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 4, 4294967295, 0), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn] = Xn >>> 24, this[zn + 1] = Xn >>> 16, this[zn + 2] = Xn >>> 8, this[zn + 3] = 255 & Xn) : objectWriteUInt32(this, Xn, zn, !1), zn + 4;
}, Buffer$1.prototype.writeIntLE = function(Xn, zn, Un, Kn) {
  if (Xn = +Xn, zn |= 0, !Kn) {
    var qn = Math.pow(2, 8 * Un - 1);
    checkInt(this, Xn, zn, Un, qn - 1, -qn);
  }
  var Jo = 0, pa = 1, ma = 0;
  for (this[zn] = 255 & Xn; ++Jo < Un && (pa *= 256); ) Xn < 0 && ma === 0 && this[zn + Jo - 1] !== 0 && (ma = 1), this[zn + Jo] = (Xn / pa | 0) - ma & 255;
  return zn + Un;
}, Buffer$1.prototype.writeIntBE = function(Xn, zn, Un, Kn) {
  if (Xn = +Xn, zn |= 0, !Kn) {
    var qn = Math.pow(2, 8 * Un - 1);
    checkInt(this, Xn, zn, Un, qn - 1, -qn);
  }
  var Jo = Un - 1, pa = 1, ma = 0;
  for (this[zn + Jo] = 255 & Xn; --Jo >= 0 && (pa *= 256); ) Xn < 0 && ma === 0 && this[zn + Jo + 1] !== 0 && (ma = 1), this[zn + Jo] = (Xn / pa | 0) - ma & 255;
  return zn + Un;
}, Buffer$1.prototype.writeInt8 = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 1, 127, -128), Buffer$1.TYPED_ARRAY_SUPPORT || (Xn = Math.floor(Xn)), Xn < 0 && (Xn = 255 + Xn + 1), this[zn] = 255 & Xn, zn + 1;
}, Buffer$1.prototype.writeInt16LE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 2, 32767, -32768), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn] = 255 & Xn, this[zn + 1] = Xn >>> 8) : objectWriteUInt16(this, Xn, zn, !0), zn + 2;
}, Buffer$1.prototype.writeInt16BE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 2, 32767, -32768), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn] = Xn >>> 8, this[zn + 1] = 255 & Xn) : objectWriteUInt16(this, Xn, zn, !1), zn + 2;
}, Buffer$1.prototype.writeInt32LE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 4, 2147483647, -2147483648), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn] = 255 & Xn, this[zn + 1] = Xn >>> 8, this[zn + 2] = Xn >>> 16, this[zn + 3] = Xn >>> 24) : objectWriteUInt32(this, Xn, zn, !0), zn + 4;
}, Buffer$1.prototype.writeInt32BE = function(Xn, zn, Un) {
  return Xn = +Xn, zn |= 0, Un || checkInt(this, Xn, zn, 4, 2147483647, -2147483648), Xn < 0 && (Xn = 4294967295 + Xn + 1), Buffer$1.TYPED_ARRAY_SUPPORT ? (this[zn] = Xn >>> 24, this[zn + 1] = Xn >>> 16, this[zn + 2] = Xn >>> 8, this[zn + 3] = 255 & Xn) : objectWriteUInt32(this, Xn, zn, !1), zn + 4;
}, Buffer$1.prototype.writeFloatLE = function(Xn, zn, Un) {
  return writeFloat(this, Xn, zn, !0, Un);
}, Buffer$1.prototype.writeFloatBE = function(Xn, zn, Un) {
  return writeFloat(this, Xn, zn, !1, Un);
}, Buffer$1.prototype.writeDoubleLE = function(Xn, zn, Un) {
  return writeDouble(this, Xn, zn, !0, Un);
}, Buffer$1.prototype.writeDoubleBE = function(Xn, zn, Un) {
  return writeDouble(this, Xn, zn, !1, Un);
}, Buffer$1.prototype.copy = function(Xn, zn, Un, Kn) {
  if (Un || (Un = 0), Kn || Kn === 0 || (Kn = this.length), zn >= Xn.length && (zn = Xn.length), zn || (zn = 0), Kn > 0 && Kn < Un && (Kn = Un), Kn === Un || Xn.length === 0 || this.length === 0) return 0;
  if (zn < 0) throw new RangeError("targetStart out of bounds");
  if (Un < 0 || Un >= this.length) throw new RangeError("sourceStart out of bounds");
  if (Kn < 0) throw new RangeError("sourceEnd out of bounds");
  Kn > this.length && (Kn = this.length), Xn.length - zn < Kn - Un && (Kn = Xn.length - zn + Un);
  var qn, Jo = Kn - Un;
  if (this === Xn && Un < zn && zn < Kn) for (qn = Jo - 1; qn >= 0; --qn) Xn[qn + zn] = this[qn + Un];
  else if (Jo < 1e3 || !Buffer$1.TYPED_ARRAY_SUPPORT) for (qn = 0; qn < Jo; ++qn) Xn[qn + zn] = this[qn + Un];
  else Uint8Array.prototype.set.call(Xn, this.subarray(Un, Un + Jo), zn);
  return Jo;
}, Buffer$1.prototype.fill = function(Xn, zn, Un, Kn) {
  if (typeof Xn == "string") {
    if (typeof zn == "string" ? (Kn = zn, zn = 0, Un = this.length) : typeof Un == "string" && (Kn = Un, Un = this.length), Xn.length === 1) {
      var qn = Xn.charCodeAt(0);
      qn < 256 && (Xn = qn);
    }
    if (Kn !== void 0 && typeof Kn != "string") throw new TypeError("encoding must be a string");
    if (typeof Kn == "string" && !Buffer$1.isEncoding(Kn)) throw new TypeError("Unknown encoding: " + Kn);
  } else typeof Xn == "number" && (Xn &= 255);
  if (zn < 0 || this.length < zn || this.length < Un) throw new RangeError("Out of range index");
  if (Un <= zn) return this;
  var Jo;
  if (zn >>>= 0, Un = Un === void 0 ? this.length : Un >>> 0, Xn || (Xn = 0), typeof Xn == "number") for (Jo = zn; Jo < Un; ++Jo) this[Jo] = Xn;
  else {
    var pa = internalIsBuffer(Xn) ? Xn : utf8ToBytes(new Buffer$1(Xn, Kn).toString()), ma = pa.length;
    for (Jo = 0; Jo < Un - zn; ++Jo) this[Jo + zn] = pa[Jo % ma];
  }
  return this;
};
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g, HeaderTypes;
function base64clean(Xn) {
  if ((Xn = stringtrim(Xn).replace(INVALID_BASE64_RE, "")).length < 2) return "";
  for (; Xn.length % 4 != 0; ) Xn += "=";
  return Xn;
}
function stringtrim(Xn) {
  return Xn.trim ? Xn.trim() : Xn.replace(/^\s+|\s+$/g, "");
}
function toHex(Xn) {
  return Xn < 16 ? "0" + Xn.toString(16) : Xn.toString(16);
}
function utf8ToBytes(Xn, zn) {
  var Un;
  zn = zn || 1 / 0;
  for (var Kn = Xn.length, qn = null, Jo = [], pa = 0; pa < Kn; ++pa) {
    if ((Un = Xn.charCodeAt(pa)) > 55295 && Un < 57344) {
      if (!qn) {
        if (Un > 56319) {
          (zn -= 3) > -1 && Jo.push(239, 191, 189);
          continue;
        }
        if (pa + 1 === Kn) {
          (zn -= 3) > -1 && Jo.push(239, 191, 189);
          continue;
        }
        qn = Un;
        continue;
      }
      if (Un < 56320) {
        (zn -= 3) > -1 && Jo.push(239, 191, 189), qn = Un;
        continue;
      }
      Un = 65536 + (qn - 55296 << 10 | Un - 56320);
    } else qn && (zn -= 3) > -1 && Jo.push(239, 191, 189);
    if (qn = null, Un < 128) {
      if ((zn -= 1) < 0) break;
      Jo.push(Un);
    } else if (Un < 2048) {
      if ((zn -= 2) < 0) break;
      Jo.push(Un >> 6 | 192, 63 & Un | 128);
    } else if (Un < 65536) {
      if ((zn -= 3) < 0) break;
      Jo.push(Un >> 12 | 224, Un >> 6 & 63 | 128, 63 & Un | 128);
    } else {
      if (!(Un < 1114112)) throw new Error("Invalid code point");
      if ((zn -= 4) < 0) break;
      Jo.push(Un >> 18 | 240, Un >> 12 & 63 | 128, Un >> 6 & 63 | 128, 63 & Un | 128);
    }
  }
  return Jo;
}
function asciiToBytes(Xn) {
  for (var zn = [], Un = 0; Un < Xn.length; ++Un) zn.push(255 & Xn.charCodeAt(Un));
  return zn;
}
function utf16leToBytes(Xn, zn) {
  for (var Un, Kn, qn, Jo = [], pa = 0; pa < Xn.length && !((zn -= 2) < 0); ++pa) Kn = (Un = Xn.charCodeAt(pa)) >> 8, qn = Un % 256, Jo.push(qn), Jo.push(Kn);
  return Jo;
}
function base64ToBytes(Xn) {
  return toByteArray(base64clean(Xn));
}
function blitBuffer(Xn, zn, Un, Kn) {
  for (var qn = 0; qn < Kn && !(qn + Un >= zn.length || qn >= Xn.length); ++qn) zn[qn + Un] = Xn[qn];
  return qn;
}
function isnan(Xn) {
  return Xn != Xn;
}
function isBuffer(Xn) {
  return Xn != null && (!!Xn._isBuffer || isFastBuffer(Xn) || isSlowBuffer(Xn));
}
function isFastBuffer(Xn) {
  return !!Xn.constructor && typeof Xn.constructor.isBuffer == "function" && Xn.constructor.isBuffer(Xn);
}
function isSlowBuffer(Xn) {
  return typeof Xn.readFloatLE == "function" && typeof Xn.slice == "function" && isFastBuffer(Xn.slice(0, 0));
}
(function(Xn) {
  Xn[Xn.BITMAP_INFO_HEADER = 40] = "BITMAP_INFO_HEADER", Xn[Xn.BITMAP_V2_INFO_HEADER = 52] = "BITMAP_V2_INFO_HEADER", Xn[Xn.BITMAP_V3_INFO_HEADER = 56] = "BITMAP_V3_INFO_HEADER", Xn[Xn.BITMAP_V4_HEADER = 108] = "BITMAP_V4_HEADER", Xn[Xn.BITMAP_V5_HEADER = 124] = "BITMAP_V5_HEADER";
})(HeaderTypes || (HeaderTypes = {}));
var HeaderTypes$1 = HeaderTypes, BmpCompression;
function maskColor(Xn, zn, Un, Kn) {
  const qn = 1 + ~Xn & Xn, Jo = 1 + ~zn & zn, pa = 1 + ~Un & Un, ma = 1 + ~Kn & Kn, va = Xn / qn + 1, ba = zn / Jo + 1, _a = Un / pa + 1, ya = Kn / ma + 1;
  return { shiftRed: (xa) => (xa & Xn) / qn * 256 / va, shiftGreen: (xa) => (xa & zn) / Jo * 256 / ba, shiftBlue: (xa) => (xa & Un) / pa * 256 / _a, shiftAlpha: Kn !== 0 ? (xa) => (xa & Kn) / ma * 256 / ya : () => 255 };
}
(function(Xn) {
  Xn[Xn.NONE = 0] = "NONE", Xn[Xn.BI_RLE8 = 1] = "BI_RLE8", Xn[Xn.BI_RLE4 = 2] = "BI_RLE4", Xn[Xn.BI_BIT_FIELDS = 3] = "BI_BIT_FIELDS", Xn[Xn.BI_ALPHA_BIT_FIELDS = 6] = "BI_ALPHA_BIT_FIELDS";
})(BmpCompression || (BmpCompression = {}));
class BmpDecoder {
  constructor(zn, { toRGBA: Un } = { toRGBA: !1 }) {
    Ca(this, "flag");
    Ca(this, "fileSize");
    Ca(this, "reserved1");
    Ca(this, "reserved2");
    Ca(this, "offset");
    Ca(this, "headerSize");
    Ca(this, "width");
    Ca(this, "height");
    Ca(this, "planes");
    Ca(this, "bitPP");
    Ca(this, "compression");
    Ca(this, "rawSize");
    Ca(this, "hr");
    Ca(this, "vr");
    Ca(this, "colors");
    Ca(this, "importantColors");
    Ca(this, "palette");
    Ca(this, "data");
    Ca(this, "maskRed");
    Ca(this, "maskGreen");
    Ca(this, "maskBlue");
    Ca(this, "maskAlpha");
    Ca(this, "toRGBA");
    Ca(this, "pos");
    Ca(this, "bottomUp");
    Ca(this, "buffer");
    Ca(this, "locRed");
    Ca(this, "locGreen");
    Ca(this, "locBlue");
    Ca(this, "locAlpha");
    Ca(this, "shiftRed");
    Ca(this, "shiftGreen");
    Ca(this, "shiftBlue");
    Ca(this, "shiftAlpha");
    if (this.buffer = zn, this.toRGBA = !!Un, this.pos = 0, this.bottomUp = !0, this.flag = this.buffer.toString("utf-8", 0, this.pos += 2), this.flag !== "BM") throw new Error("Invalid BMP File");
    this.locRed = this.toRGBA ? 0 : 3, this.locGreen = this.toRGBA ? 1 : 2, this.locBlue = this.toRGBA ? 2 : 1, this.locAlpha = this.toRGBA ? 3 : 0, this.parseHeader(), this.parseRGBA();
  }
  parseHeader() {
    if (this.fileSize = this.readUInt32LE(), this.reserved1 = this.buffer.readUInt16LE(this.pos), this.pos += 2, this.reserved2 = this.buffer.readUInt16LE(this.pos), this.pos += 2, this.offset = this.readUInt32LE(), this.headerSize = this.readUInt32LE(), !(this.headerSize in HeaderTypes$1)) throw new Error(`Unsupported BMP header size ${this.headerSize}`);
    if (this.width = this.readUInt32LE(), this.height = this.readUInt32LE(), this.height = this.height > 2147483647 ? this.height - 4294967296 : this.height, this.planes = this.buffer.readUInt16LE(this.pos), this.pos += 2, this.bitPP = this.buffer.readUInt16LE(this.pos), this.pos += 2, this.compression = this.readUInt32LE(), this.rawSize = this.readUInt32LE(), this.hr = this.readUInt32LE(), this.vr = this.readUInt32LE(), this.colors = this.readUInt32LE(), this.importantColors = this.readUInt32LE(), this.bitPP === 32 ? (this.maskAlpha = 0, this.maskRed = 16711680, this.maskGreen = 65280, this.maskBlue = 255) : this.bitPP === 16 && (this.maskAlpha = 0, this.maskRed = 31744, this.maskGreen = 992, this.maskBlue = 31), (this.headerSize > HeaderTypes$1.BITMAP_INFO_HEADER || this.compression === BmpCompression.BI_BIT_FIELDS || this.compression === BmpCompression.BI_ALPHA_BIT_FIELDS) && (this.maskRed = this.readUInt32LE(), this.maskGreen = this.readUInt32LE(), this.maskBlue = this.readUInt32LE()), (this.headerSize > HeaderTypes$1.BITMAP_V2_INFO_HEADER || this.compression === BmpCompression.BI_ALPHA_BIT_FIELDS) && (this.maskAlpha = this.readUInt32LE()), this.headerSize > HeaderTypes$1.BITMAP_V3_INFO_HEADER && (this.pos += HeaderTypes$1.BITMAP_V4_HEADER - HeaderTypes$1.BITMAP_V3_INFO_HEADER), this.headerSize > HeaderTypes$1.BITMAP_V4_HEADER && (this.pos += HeaderTypes$1.BITMAP_V5_HEADER - HeaderTypes$1.BITMAP_V4_HEADER), this.bitPP <= 8 || this.colors > 0) {
      const Un = this.colors === 0 ? 1 << this.bitPP : this.colors;
      this.palette = new Array(Un);
      for (let Kn = 0; Kn < Un; Kn++) {
        const qn = this.buffer.readUInt8(this.pos++), Jo = this.buffer.readUInt8(this.pos++), pa = this.buffer.readUInt8(this.pos++), ma = this.buffer.readUInt8(this.pos++);
        this.palette[Kn] = { red: pa, green: Jo, blue: qn, quad: ma };
      }
    }
    this.height < 0 && (this.height *= -1, this.bottomUp = !1);
    const zn = maskColor(this.maskRed, this.maskGreen, this.maskBlue, this.maskAlpha);
    this.shiftRed = zn.shiftRed, this.shiftGreen = zn.shiftGreen, this.shiftBlue = zn.shiftBlue, this.shiftAlpha = zn.shiftAlpha;
  }
  parseRGBA() {
    switch (this.data = Buffer$1.alloc(this.width * this.height * 4), this.bitPP) {
      case 1:
        this.bit1();
        break;
      case 4:
        this.bit4();
        break;
      case 8:
        this.bit8();
        break;
      case 16:
        this.bit16();
        break;
      case 24:
        this.bit24();
        break;
      default:
        this.bit32();
    }
  }
  bit1() {
    const zn = Math.ceil(this.width / 8), Un = zn % 4, Kn = Un !== 0 ? 4 - Un : 0;
    this.scanImage(Kn, zn, (qn, Jo) => {
      const pa = this.buffer.readUInt8(this.pos++), ma = Jo * this.width * 4 + 8 * qn * 4;
      for (let va = 0; va < 8 && 8 * qn + va < this.width; va++) {
        const ba = this.palette[pa >> 7 - va & 1];
        this.data[ma + va * this.locAlpha] = 0, this.data[ma + 4 * va + this.locBlue] = ba.blue, this.data[ma + 4 * va + this.locGreen] = ba.green, this.data[ma + 4 * va + this.locRed] = ba.red;
      }
    });
  }
  bit4() {
    if (this.compression === BmpCompression.BI_RLE4) {
      this.data.fill(0);
      let zn = !1, Un = this.bottomUp ? this.height - 1 : 0, Kn = 0;
      for (; Kn < this.data.length; ) {
        const qn = this.buffer.readUInt8(this.pos++), Jo = this.buffer.readUInt8(this.pos++);
        if (qn === 0) {
          if (Jo === 0) {
            Un += this.bottomUp ? -1 : 1, Kn = Un * this.width * 4, zn = !1;
            continue;
          }
          if (Jo === 1) break;
          if (Jo === 2) {
            const pa = this.buffer.readUInt8(this.pos++), ma = this.buffer.readUInt8(this.pos++);
            Un += this.bottomUp ? -ma : ma, Kn += ma * this.width * 4 + 4 * pa;
          } else {
            let pa = this.buffer.readUInt8(this.pos++);
            for (let ma = 0; ma < Jo; ma++) Kn = this.setPixelData(Kn, zn ? 15 & pa : (240 & pa) >> 4), 1 & ma && ma + 1 < Jo && (pa = this.buffer.readUInt8(this.pos++)), zn = !zn;
            (Jo + 1 >> 1 & 1) == 1 && this.pos++;
          }
        } else for (let pa = 0; pa < qn; pa++) Kn = this.setPixelData(Kn, zn ? 15 & Jo : (240 & Jo) >> 4), zn = !zn;
      }
    } else {
      const zn = Math.ceil(this.width / 2), Un = zn % 4, Kn = Un !== 0 ? 4 - Un : 0;
      this.scanImage(Kn, zn, (qn, Jo) => {
        const pa = this.buffer.readUInt8(this.pos++), ma = Jo * this.width * 4 + 2 * qn * 4, va = pa >> 4;
        let ba = this.palette[va];
        if (this.data[ma] = 0, this.data[ma + 1] = ba.blue, this.data[ma + 2] = ba.green, this.data[ma + 3] = ba.red, 2 * qn + 1 >= this.width) return !1;
        const _a = 15 & pa;
        ba = this.palette[_a], this.data[ma + 4] = 0, this.data[ma + 4 + 1] = ba.blue, this.data[ma + 4 + 2] = ba.green, this.data[ma + 4 + 3] = ba.red;
      });
    }
  }
  bit8() {
    if (this.compression === BmpCompression.BI_RLE8) {
      this.data.fill(0);
      let zn = this.bottomUp ? this.height - 1 : 0, Un = 0;
      for (; Un < this.data.length; ) {
        const Kn = this.buffer.readUInt8(this.pos++), qn = this.buffer.readUInt8(this.pos++);
        if (Kn === 0) {
          if (qn === 0) {
            zn += this.bottomUp ? -1 : 1, Un = zn * this.width * 4;
            continue;
          }
          if (qn === 1) break;
          if (qn === 2) {
            const Jo = this.buffer.readUInt8(this.pos++), pa = this.buffer.readUInt8(this.pos++);
            zn += this.bottomUp ? -pa : pa, Un += pa * this.width * 4 + 4 * Jo;
          } else {
            for (let Jo = 0; Jo < qn; Jo++) {
              const pa = this.buffer.readUInt8(this.pos++);
              Un = this.setPixelData(Un, pa);
            }
            !0 & qn && this.pos++;
          }
        } else for (let Jo = 0; Jo < Kn; Jo++) Un = this.setPixelData(Un, qn);
      }
    } else {
      const zn = this.width % 4, Un = zn !== 0 ? 4 - zn : 0;
      this.scanImage(Un, this.width, (Kn, qn) => {
        const Jo = this.buffer.readUInt8(this.pos++), pa = qn * this.width * 4 + 4 * Kn;
        if (Jo < this.palette.length) {
          const ma = this.palette[Jo];
          this.data[pa] = 0, this.data[pa + 1] = ma.blue, this.data[pa + 2] = ma.green, this.data[pa + 3] = ma.red;
        } else this.data[pa] = 0, this.data[pa + 1] = 255, this.data[pa + 2] = 255, this.data[pa + 3] = 255;
      });
    }
  }
  bit16() {
    const zn = this.width % 2 * 2;
    this.scanImage(zn, this.width, (Un, Kn) => {
      const qn = Kn * this.width * 4 + 4 * Un, Jo = this.buffer.readUInt16LE(this.pos);
      this.pos += 2, this.data[qn + this.locRed] = this.shiftRed(Jo), this.data[qn + this.locGreen] = this.shiftGreen(Jo), this.data[qn + this.locBlue] = this.shiftBlue(Jo), this.data[qn + this.locAlpha] = this.shiftAlpha(Jo);
    });
  }
  bit24() {
    const zn = this.width % 4;
    this.scanImage(zn, this.width, (Un, Kn) => {
      const qn = Kn * this.width * 4 + 4 * Un, Jo = this.buffer.readUInt8(this.pos++), pa = this.buffer.readUInt8(this.pos++), ma = this.buffer.readUInt8(this.pos++);
      this.data[qn + this.locRed] = ma, this.data[qn + this.locGreen] = pa, this.data[qn + this.locBlue] = Jo, this.data[qn + this.locAlpha] = 0;
    });
  }
  bit32() {
    this.scanImage(0, this.width, (zn, Un) => {
      const Kn = Un * this.width * 4 + 4 * zn, qn = this.readUInt32LE();
      this.data[Kn + this.locRed] = this.shiftRed(qn), this.data[Kn + this.locGreen] = this.shiftGreen(qn), this.data[Kn + this.locBlue] = this.shiftBlue(qn), this.data[Kn + this.locAlpha] = this.shiftAlpha(qn);
    });
  }
  scanImage(zn = 0, Un = this.width, Kn) {
    for (let qn = this.height - 1; qn >= 0; qn--) {
      const Jo = this.bottomUp ? qn : this.height - 1 - qn;
      for (let pa = 0; pa < Un; pa++)
        if (Kn.call(this, pa, Jo) === !1) return;
      this.pos += zn;
    }
  }
  readUInt32LE() {
    const zn = this.buffer.readUInt32LE(this.pos);
    return this.pos += 4, zn;
  }
  setPixelData(zn, Un) {
    const { blue: Kn, green: qn, red: Jo } = this.palette[Un];
    return this.data[zn + this.locAlpha] = 0, this.data[zn + 1 + this.locBlue] = Kn, this.data[zn + 2 + this.locGreen] = qn, this.data[zn + 3 + this.locRed] = Jo, zn + 4;
  }
}
function createInteger(Xn) {
  return Xn.reduce((zn, Un) => zn << 1 | Un, 0);
}
function createColor(Xn) {
  return Xn.quad << 24 | Xn.red << 16 | Xn.green << 8 | Xn.blue;
}
class BmpEncoder {
  constructor(zn) {
    Ca(this, "fileSize");
    Ca(this, "reserved1");
    Ca(this, "reserved2");
    Ca(this, "offset");
    Ca(this, "width");
    Ca(this, "flag");
    Ca(this, "height");
    Ca(this, "planes");
    Ca(this, "bitPP");
    Ca(this, "compress");
    Ca(this, "hr");
    Ca(this, "vr");
    Ca(this, "colors");
    Ca(this, "importantColors");
    Ca(this, "rawSize");
    Ca(this, "headerSize");
    Ca(this, "data");
    Ca(this, "palette");
    Ca(this, "extraBytes");
    Ca(this, "buffer");
    Ca(this, "bytesInColor");
    Ca(this, "pos");
    switch (this.buffer = zn.data, this.width = zn.width, this.height = zn.height, this.headerSize = HeaderTypes$1.BITMAP_INFO_HEADER, this.flag = "BM", this.bitPP = zn.bitPP || 24, this.offset = 54, this.reserved1 = zn.reserved1 || 0, this.reserved2 = zn.reserved2 || 0, this.planes = 1, this.compress = 0, this.hr = zn.hr || 0, this.vr = zn.vr || 0, this.importantColors = zn.importantColors || 0, this.colors = Math.min(2 ** (this.bitPP - 1 || 1), zn.colors || 1 / 0), this.palette = zn.palette || [], this.colors && this.bitPP < 16 ? this.offset += 4 * this.colors : this.colors = 0, this.bitPP) {
      case 32:
        this.bytesInColor = 4;
        break;
      case 16:
        this.bytesInColor = 2;
        break;
      case 8:
        this.bytesInColor = 1;
        break;
      case 4:
        this.bytesInColor = 0.5;
        break;
      case 1:
        this.bytesInColor = 1 / 8;
        break;
      default:
        this.bytesInColor = 3, this.bitPP = 24;
    }
    const Un = this.width * this.bitPP / 32, Kn = Math.ceil(Un);
    this.extraBytes = 4 * (Kn - Un), this.rawSize = this.height * Kn * 4 + 2, this.fileSize = this.rawSize + this.offset, this.data = Buffer$1.alloc(this.fileSize, 1), this.pos = 0, this.encode();
  }
  encode() {
    switch (this.pos = 0, this.writeHeader(), this.bitPP) {
      case 32:
        this.bit32();
        break;
      case 16:
        this.bit16();
        break;
      case 8:
        this.bit8();
        break;
      case 4:
        this.bit4();
        break;
      case 1:
        this.bit1();
        break;
      default:
        this.bit24();
    }
  }
  writeHeader() {
    this.data.write(this.flag, this.pos, 2), this.pos += 2, this.writeUInt32LE(this.fileSize), this.writeUInt32LE(this.reserved1 << 16 | this.reserved2), this.writeUInt32LE(this.offset), this.writeUInt32LE(this.headerSize), this.writeUInt32LE(this.width), this.writeUInt32LE(this.height), this.data.writeUInt16LE(this.planes, this.pos), this.pos += 2, this.data.writeUInt16LE(this.bitPP, this.pos), this.pos += 2, this.writeUInt32LE(this.compress), this.writeUInt32LE(this.rawSize), this.writeUInt32LE(this.hr), this.writeUInt32LE(this.vr), this.writeUInt32LE(this.colors), this.writeUInt32LE(this.importantColors);
  }
  bit1() {
    this.palette.length && this.colors === 2 ? this.initColors(1) : (this.writeUInt32LE(16777215), this.writeUInt32LE(0)), this.pos += 1;
    let zn = [];
    this.writeImage((Un, Kn, qn) => {
      let Jo = Kn;
      Jo++;
      const pa = this.buffer[Jo++], ma = this.buffer[Jo++], va = 0.2126 * this.buffer[Jo++] + 0.7152 * ma + 0.0722 * pa;
      return zn.push(va > 127 ? 0 : 1), (qn + 1) % 8 == 0 ? (this.data[Un - 1] = createInteger(zn), zn = []) : qn === this.width - 1 && zn.length > 0 && (this.data[Un - 1] = createInteger(zn) << 4, zn = []), Jo;
    });
  }
  bit4() {
    const zn = this.initColors(4);
    let Un = [];
    this.writeImage((Kn, qn, Jo) => {
      let pa = qn;
      const ma = createColor({ quad: this.buffer[pa++], blue: this.buffer[pa++], green: this.buffer[pa++], red: this.buffer[pa++] }), va = zn.findIndex((ba) => ba === ma);
      return va !== -1 ? Un.push(va) : Un.push(0), (Jo + 1) % 2 == 0 && (this.data[Kn] = Un[0] << 4 | Un[1], Un = []), pa;
    });
  }
  bit8() {
    const zn = this.initColors(8);
    this.writeImage((Un, Kn) => {
      let qn = Kn;
      const Jo = createColor({ quad: this.buffer[qn++], blue: this.buffer[qn++], green: this.buffer[qn++], red: this.buffer[qn++] }), pa = zn.findIndex((ma) => ma === Jo);
      return this.data[Un] = pa !== -1 ? pa : 0, qn;
    });
  }
  bit16() {
    this.writeImage((zn, Un) => {
      let Kn = Un + 1;
      const qn = this.buffer[Kn++] / 8, Jo = this.buffer[Kn++] / 8, pa = this.buffer[Kn++] / 8 << 10 | Jo << 5 | qn;
      return this.data[zn] = 255 & pa, this.data[zn + 1] = (65280 & pa) >> 8, Kn;
    });
  }
  bit24() {
    this.writeImage((zn, Un) => {
      let Kn = Un + 1;
      return this.data[zn] = this.buffer[Kn++], this.data[zn + 1] = this.buffer[Kn++], this.data[zn + 2] = this.buffer[Kn++], Kn;
    });
  }
  bit32() {
    this.writeImage((zn, Un) => {
      let Kn = Un;
      return this.data[zn + 3] = this.buffer[Kn++], this.data[zn] = this.buffer[Kn++], this.data[zn + 1] = this.buffer[Kn++], this.data[zn + 2] = this.buffer[Kn++], Kn;
    });
  }
  writeImage(zn) {
    const Un = this.extraBytes + this.width * this.bytesInColor;
    let Kn = 0;
    for (let qn = 0; qn < this.height; qn++) for (let Jo = 0; Jo < this.width; Jo++) {
      const pa = Math.floor(this.pos + (this.height - 1 - qn) * Un + Jo * this.bytesInColor);
      Kn = zn.call(this, pa, Kn, Jo, qn);
    }
  }
  initColors(zn) {
    const Un = [];
    if (!this.palette.length) throw new Error(`To encode ${zn}-bit BMPs a pallette is needed. Please choose up to ${this.colors} colors. Colors must be 32-bit integers.`);
    for (let Kn = 0; Kn < this.colors; Kn++) {
      const qn = createColor(this.palette[Kn]);
      this.writeUInt32LE(qn), Un.push(qn);
    }
    return Un;
  }
  writeUInt32LE(zn) {
    this.data.writeUInt32LE(zn, this.pos), this.pos += 4;
  }
}
function decode$2(Xn, zn) {
  return new BmpDecoder(Xn, zn);
}
function encode$2(Xn) {
  return new BmpEncoder(Xn);
}
function _typeof(Xn) {
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(zn) {
    return typeof zn;
  } : function(zn) {
    return zn && typeof Symbol == "function" && zn.constructor === Symbol && zn !== Symbol.prototype ? "symbol" : typeof zn;
  }, _typeof(Xn);
}
var trimLeft = /^\s+/, trimRight = /\s+$/;
function tinycolor(Xn, zn) {
  if (zn = zn || {}, (Xn = Xn || "") instanceof tinycolor) return Xn;
  if (!(this instanceof tinycolor)) return new tinycolor(Xn, zn);
  var Un = inputToRGB(Xn);
  this._originalInput = Xn, this._r = Un.r, this._g = Un.g, this._b = Un.b, this._a = Un.a, this._roundA = Math.round(100 * this._a) / 100, this._format = zn.format || Un.format, this._gradientType = zn.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = Un.ok;
}
function inputToRGB(Xn) {
  var zn = { r: 0, g: 0, b: 0 }, Un = 1, Kn = null, qn = null, Jo = null, pa = !1, ma = !1;
  return typeof Xn == "string" && (Xn = stringInputToObject(Xn)), _typeof(Xn) == "object" && (isValidCSSUnit(Xn.r) && isValidCSSUnit(Xn.g) && isValidCSSUnit(Xn.b) ? (zn = rgbToRgb(Xn.r, Xn.g, Xn.b), pa = !0, ma = String(Xn.r).substr(-1) === "%" ? "prgb" : "rgb") : isValidCSSUnit(Xn.h) && isValidCSSUnit(Xn.s) && isValidCSSUnit(Xn.v) ? (Kn = convertToPercentage(Xn.s), qn = convertToPercentage(Xn.v), zn = hsvToRgb(Xn.h, Kn, qn), pa = !0, ma = "hsv") : isValidCSSUnit(Xn.h) && isValidCSSUnit(Xn.s) && isValidCSSUnit(Xn.l) && (Kn = convertToPercentage(Xn.s), Jo = convertToPercentage(Xn.l), zn = hslToRgb(Xn.h, Kn, Jo), pa = !0, ma = "hsl"), Xn.hasOwnProperty("a") && (Un = Xn.a)), Un = boundAlpha(Un), { ok: pa, format: Xn.format || ma, r: Math.min(255, Math.max(zn.r, 0)), g: Math.min(255, Math.max(zn.g, 0)), b: Math.min(255, Math.max(zn.b, 0)), a: Un };
}
function rgbToRgb(Xn, zn, Un) {
  return { r: 255 * bound01(Xn, 255), g: 255 * bound01(zn, 255), b: 255 * bound01(Un, 255) };
}
function rgbToHsl(Xn, zn, Un) {
  Xn = bound01(Xn, 255), zn = bound01(zn, 255), Un = bound01(Un, 255);
  var Kn, qn, Jo = Math.max(Xn, zn, Un), pa = Math.min(Xn, zn, Un), ma = (Jo + pa) / 2;
  if (Jo == pa) Kn = qn = 0;
  else {
    var va = Jo - pa;
    switch (qn = ma > 0.5 ? va / (2 - Jo - pa) : va / (Jo + pa), Jo) {
      case Xn:
        Kn = (zn - Un) / va + (zn < Un ? 6 : 0);
        break;
      case zn:
        Kn = (Un - Xn) / va + 2;
        break;
      case Un:
        Kn = (Xn - zn) / va + 4;
    }
    Kn /= 6;
  }
  return { h: Kn, s: qn, l: ma };
}
function hslToRgb(Xn, zn, Un) {
  var Kn, qn, Jo;
  function pa(ba, _a, ya) {
    return ya < 0 && (ya += 1), ya > 1 && (ya -= 1), ya < 1 / 6 ? ba + 6 * (_a - ba) * ya : ya < 0.5 ? _a : ya < 2 / 3 ? ba + (_a - ba) * (2 / 3 - ya) * 6 : ba;
  }
  if (Xn = bound01(Xn, 360), zn = bound01(zn, 100), Un = bound01(Un, 100), zn === 0) Kn = qn = Jo = Un;
  else {
    var ma = Un < 0.5 ? Un * (1 + zn) : Un + zn - Un * zn, va = 2 * Un - ma;
    Kn = pa(va, ma, Xn + 1 / 3), qn = pa(va, ma, Xn), Jo = pa(va, ma, Xn - 1 / 3);
  }
  return { r: 255 * Kn, g: 255 * qn, b: 255 * Jo };
}
function rgbToHsv(Xn, zn, Un) {
  Xn = bound01(Xn, 255), zn = bound01(zn, 255), Un = bound01(Un, 255);
  var Kn, qn, Jo = Math.max(Xn, zn, Un), pa = Math.min(Xn, zn, Un), ma = Jo, va = Jo - pa;
  if (qn = Jo === 0 ? 0 : va / Jo, Jo == pa) Kn = 0;
  else {
    switch (Jo) {
      case Xn:
        Kn = (zn - Un) / va + (zn < Un ? 6 : 0);
        break;
      case zn:
        Kn = (Un - Xn) / va + 2;
        break;
      case Un:
        Kn = (Xn - zn) / va + 4;
    }
    Kn /= 6;
  }
  return { h: Kn, s: qn, v: ma };
}
function hsvToRgb(Xn, zn, Un) {
  Xn = 6 * bound01(Xn, 360), zn = bound01(zn, 100), Un = bound01(Un, 100);
  var Kn = Math.floor(Xn), qn = Xn - Kn, Jo = Un * (1 - zn), pa = Un * (1 - qn * zn), ma = Un * (1 - (1 - qn) * zn), va = Kn % 6;
  return { r: 255 * [Un, pa, Jo, Jo, ma, Un][va], g: 255 * [ma, Un, Un, pa, Jo, Jo][va], b: 255 * [Jo, Jo, ma, Un, Un, pa][va] };
}
function rgbToHex(Xn, zn, Un, Kn) {
  var qn = [pad2(Math.round(Xn).toString(16)), pad2(Math.round(zn).toString(16)), pad2(Math.round(Un).toString(16))];
  return Kn && qn[0].charAt(0) == qn[0].charAt(1) && qn[1].charAt(0) == qn[1].charAt(1) && qn[2].charAt(0) == qn[2].charAt(1) ? qn[0].charAt(0) + qn[1].charAt(0) + qn[2].charAt(0) : qn.join("");
}
function rgbaToHex(Xn, zn, Un, Kn, qn) {
  var Jo = [pad2(Math.round(Xn).toString(16)), pad2(Math.round(zn).toString(16)), pad2(Math.round(Un).toString(16)), pad2(convertDecimalToHex(Kn))];
  return qn && Jo[0].charAt(0) == Jo[0].charAt(1) && Jo[1].charAt(0) == Jo[1].charAt(1) && Jo[2].charAt(0) == Jo[2].charAt(1) && Jo[3].charAt(0) == Jo[3].charAt(1) ? Jo[0].charAt(0) + Jo[1].charAt(0) + Jo[2].charAt(0) + Jo[3].charAt(0) : Jo.join("");
}
function rgbaToArgbHex(Xn, zn, Un, Kn) {
  return [pad2(convertDecimalToHex(Kn)), pad2(Math.round(Xn).toString(16)), pad2(Math.round(zn).toString(16)), pad2(Math.round(Un).toString(16))].join("");
}
function _desaturate(Xn, zn) {
  zn = zn === 0 ? 0 : zn || 10;
  var Un = tinycolor(Xn).toHsl();
  return Un.s -= zn / 100, Un.s = clamp01(Un.s), tinycolor(Un);
}
function _saturate(Xn, zn) {
  zn = zn === 0 ? 0 : zn || 10;
  var Un = tinycolor(Xn).toHsl();
  return Un.s += zn / 100, Un.s = clamp01(Un.s), tinycolor(Un);
}
function _greyscale(Xn) {
  return tinycolor(Xn).desaturate(100);
}
function _lighten(Xn, zn) {
  zn = zn === 0 ? 0 : zn || 10;
  var Un = tinycolor(Xn).toHsl();
  return Un.l += zn / 100, Un.l = clamp01(Un.l), tinycolor(Un);
}
function _brighten(Xn, zn) {
  zn = zn === 0 ? 0 : zn || 10;
  var Un = tinycolor(Xn).toRgb();
  return Un.r = Math.max(0, Math.min(255, Un.r - Math.round(-zn / 100 * 255))), Un.g = Math.max(0, Math.min(255, Un.g - Math.round(-zn / 100 * 255))), Un.b = Math.max(0, Math.min(255, Un.b - Math.round(-zn / 100 * 255))), tinycolor(Un);
}
function _darken(Xn, zn) {
  zn = zn === 0 ? 0 : zn || 10;
  var Un = tinycolor(Xn).toHsl();
  return Un.l -= zn / 100, Un.l = clamp01(Un.l), tinycolor(Un);
}
function _spin(Xn, zn) {
  var Un = tinycolor(Xn).toHsl(), Kn = (Un.h + zn) % 360;
  return Un.h = Kn < 0 ? 360 + Kn : Kn, tinycolor(Un);
}
function _complement(Xn) {
  var zn = tinycolor(Xn).toHsl();
  return zn.h = (zn.h + 180) % 360, tinycolor(zn);
}
function polyad(Xn, zn) {
  if (isNaN(zn) || zn <= 0) throw new Error("Argument to polyad must be a positive number");
  for (var Un = tinycolor(Xn).toHsl(), Kn = [tinycolor(Xn)], qn = 360 / zn, Jo = 1; Jo < zn; Jo++) Kn.push(tinycolor({ h: (Un.h + Jo * qn) % 360, s: Un.s, l: Un.l }));
  return Kn;
}
function _splitcomplement(Xn) {
  var zn = tinycolor(Xn).toHsl(), Un = zn.h;
  return [tinycolor(Xn), tinycolor({ h: (Un + 72) % 360, s: zn.s, l: zn.l }), tinycolor({ h: (Un + 216) % 360, s: zn.s, l: zn.l })];
}
function _analogous(Xn, zn, Un) {
  zn = zn || 6, Un = Un || 30;
  var Kn = tinycolor(Xn).toHsl(), qn = 360 / Un, Jo = [tinycolor(Xn)];
  for (Kn.h = (Kn.h - (qn * zn >> 1) + 720) % 360; --zn; ) Kn.h = (Kn.h + qn) % 360, Jo.push(tinycolor(Kn));
  return Jo;
}
function _monochromatic(Xn, zn) {
  zn = zn || 6;
  for (var Un = tinycolor(Xn).toHsv(), Kn = Un.h, qn = Un.s, Jo = Un.v, pa = [], ma = 1 / zn; zn--; ) pa.push(tinycolor({ h: Kn, s: qn, v: Jo })), Jo = (Jo + ma) % 1;
  return pa;
}
tinycolor.prototype = { isDark: function() {
  return this.getBrightness() < 128;
}, isLight: function() {
  return !this.isDark();
}, isValid: function() {
  return this._ok;
}, getOriginalInput: function() {
  return this._originalInput;
}, getFormat: function() {
  return this._format;
}, getAlpha: function() {
  return this._a;
}, getBrightness: function() {
  var Xn = this.toRgb();
  return (299 * Xn.r + 587 * Xn.g + 114 * Xn.b) / 1e3;
}, getLuminance: function() {
  var Xn, zn, Un, Kn = this.toRgb();
  return Xn = Kn.r / 255, zn = Kn.g / 255, Un = Kn.b / 255, 0.2126 * (Xn <= 0.03928 ? Xn / 12.92 : Math.pow((Xn + 0.055) / 1.055, 2.4)) + 0.7152 * (zn <= 0.03928 ? zn / 12.92 : Math.pow((zn + 0.055) / 1.055, 2.4)) + 0.0722 * (Un <= 0.03928 ? Un / 12.92 : Math.pow((Un + 0.055) / 1.055, 2.4));
}, setAlpha: function(Xn) {
  return this._a = boundAlpha(Xn), this._roundA = Math.round(100 * this._a) / 100, this;
}, toHsv: function() {
  var Xn = rgbToHsv(this._r, this._g, this._b);
  return { h: 360 * Xn.h, s: Xn.s, v: Xn.v, a: this._a };
}, toHsvString: function() {
  var Xn = rgbToHsv(this._r, this._g, this._b), zn = Math.round(360 * Xn.h), Un = Math.round(100 * Xn.s), Kn = Math.round(100 * Xn.v);
  return this._a == 1 ? "hsv(" + zn + ", " + Un + "%, " + Kn + "%)" : "hsva(" + zn + ", " + Un + "%, " + Kn + "%, " + this._roundA + ")";
}, toHsl: function() {
  var Xn = rgbToHsl(this._r, this._g, this._b);
  return { h: 360 * Xn.h, s: Xn.s, l: Xn.l, a: this._a };
}, toHslString: function() {
  var Xn = rgbToHsl(this._r, this._g, this._b), zn = Math.round(360 * Xn.h), Un = Math.round(100 * Xn.s), Kn = Math.round(100 * Xn.l);
  return this._a == 1 ? "hsl(" + zn + ", " + Un + "%, " + Kn + "%)" : "hsla(" + zn + ", " + Un + "%, " + Kn + "%, " + this._roundA + ")";
}, toHex: function(Xn) {
  return rgbToHex(this._r, this._g, this._b, Xn);
}, toHexString: function(Xn) {
  return "#" + this.toHex(Xn);
}, toHex8: function(Xn) {
  return rgbaToHex(this._r, this._g, this._b, this._a, Xn);
}, toHex8String: function(Xn) {
  return "#" + this.toHex8(Xn);
}, toRgb: function() {
  return { r: Math.round(this._r), g: Math.round(this._g), b: Math.round(this._b), a: this._a };
}, toRgbString: function() {
  return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
}, toPercentageRgb: function() {
  return { r: Math.round(100 * bound01(this._r, 255)) + "%", g: Math.round(100 * bound01(this._g, 255)) + "%", b: Math.round(100 * bound01(this._b, 255)) + "%", a: this._a };
}, toPercentageRgbString: function() {
  return this._a == 1 ? "rgb(" + Math.round(100 * bound01(this._r, 255)) + "%, " + Math.round(100 * bound01(this._g, 255)) + "%, " + Math.round(100 * bound01(this._b, 255)) + "%)" : "rgba(" + Math.round(100 * bound01(this._r, 255)) + "%, " + Math.round(100 * bound01(this._g, 255)) + "%, " + Math.round(100 * bound01(this._b, 255)) + "%, " + this._roundA + ")";
}, toName: function() {
  return this._a === 0 ? "transparent" : !(this._a < 1) && (hexNames[rgbToHex(this._r, this._g, this._b, !0)] || !1);
}, toFilter: function(Xn) {
  var zn = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a), Un = zn, Kn = this._gradientType ? "GradientType = 1, " : "";
  if (Xn) {
    var qn = tinycolor(Xn);
    Un = "#" + rgbaToArgbHex(qn._r, qn._g, qn._b, qn._a);
  }
  return "progid:DXImageTransform.Microsoft.gradient(" + Kn + "startColorstr=" + zn + ",endColorstr=" + Un + ")";
}, toString: function(Xn) {
  var zn = !!Xn;
  Xn = Xn || this._format;
  var Un = !1, Kn = this._a < 1 && this._a >= 0;
  return zn || !Kn || Xn !== "hex" && Xn !== "hex6" && Xn !== "hex3" && Xn !== "hex4" && Xn !== "hex8" && Xn !== "name" ? (Xn === "rgb" && (Un = this.toRgbString()), Xn === "prgb" && (Un = this.toPercentageRgbString()), Xn !== "hex" && Xn !== "hex6" || (Un = this.toHexString()), Xn === "hex3" && (Un = this.toHexString(!0)), Xn === "hex4" && (Un = this.toHex8String(!0)), Xn === "hex8" && (Un = this.toHex8String()), Xn === "name" && (Un = this.toName()), Xn === "hsl" && (Un = this.toHslString()), Xn === "hsv" && (Un = this.toHsvString()), Un || this.toHexString()) : Xn === "name" && this._a === 0 ? this.toName() : this.toRgbString();
}, clone: function() {
  return tinycolor(this.toString());
}, _applyModification: function(Xn, zn) {
  var Un = Xn.apply(null, [this].concat([].slice.call(zn)));
  return this._r = Un._r, this._g = Un._g, this._b = Un._b, this.setAlpha(Un._a), this;
}, lighten: function() {
  return this._applyModification(_lighten, arguments);
}, brighten: function() {
  return this._applyModification(_brighten, arguments);
}, darken: function() {
  return this._applyModification(_darken, arguments);
}, desaturate: function() {
  return this._applyModification(_desaturate, arguments);
}, saturate: function() {
  return this._applyModification(_saturate, arguments);
}, greyscale: function() {
  return this._applyModification(_greyscale, arguments);
}, spin: function() {
  return this._applyModification(_spin, arguments);
}, _applyCombination: function(Xn, zn) {
  return Xn.apply(null, [this].concat([].slice.call(zn)));
}, analogous: function() {
  return this._applyCombination(_analogous, arguments);
}, complement: function() {
  return this._applyCombination(_complement, arguments);
}, monochromatic: function() {
  return this._applyCombination(_monochromatic, arguments);
}, splitcomplement: function() {
  return this._applyCombination(_splitcomplement, arguments);
}, triad: function() {
  return this._applyCombination(polyad, [3]);
}, tetrad: function() {
  return this._applyCombination(polyad, [4]);
} }, tinycolor.fromRatio = function(Xn, zn) {
  if (_typeof(Xn) == "object") {
    var Un = {};
    for (var Kn in Xn) Xn.hasOwnProperty(Kn) && (Un[Kn] = Kn === "a" ? Xn[Kn] : convertToPercentage(Xn[Kn]));
    Xn = Un;
  }
  return tinycolor(Xn, zn);
}, tinycolor.equals = function(Xn, zn) {
  return !(!Xn || !zn) && tinycolor(Xn).toRgbString() == tinycolor(zn).toRgbString();
}, tinycolor.random = function() {
  return tinycolor.fromRatio({ r: Math.random(), g: Math.random(), b: Math.random() });
}, tinycolor.mix = function(Xn, zn, Un) {
  Un = Un === 0 ? 0 : Un || 50;
  var Kn = tinycolor(Xn).toRgb(), qn = tinycolor(zn).toRgb(), Jo = Un / 100;
  return tinycolor({ r: (qn.r - Kn.r) * Jo + Kn.r, g: (qn.g - Kn.g) * Jo + Kn.g, b: (qn.b - Kn.b) * Jo + Kn.b, a: (qn.a - Kn.a) * Jo + Kn.a });
}, tinycolor.readability = function(Xn, zn) {
  var Un = tinycolor(Xn), Kn = tinycolor(zn);
  return (Math.max(Un.getLuminance(), Kn.getLuminance()) + 0.05) / (Math.min(Un.getLuminance(), Kn.getLuminance()) + 0.05);
}, tinycolor.isReadable = function(Xn, zn, Un) {
  var Kn, qn, Jo = tinycolor.readability(Xn, zn);
  switch (qn = !1, (Kn = validateWCAG2Parms(Un)).level + Kn.size) {
    case "AAsmall":
    case "AAAlarge":
      qn = Jo >= 4.5;
      break;
    case "AAlarge":
      qn = Jo >= 3;
      break;
    case "AAAsmall":
      qn = Jo >= 7;
  }
  return qn;
}, tinycolor.mostReadable = function(Xn, zn, Un) {
  var Kn, qn, Jo, pa, ma = null, va = 0;
  qn = (Un = Un || {}).includeFallbackColors, Jo = Un.level, pa = Un.size;
  for (var ba = 0; ba < zn.length; ba++) (Kn = tinycolor.readability(Xn, zn[ba])) > va && (va = Kn, ma = tinycolor(zn[ba]));
  return tinycolor.isReadable(Xn, ma, { level: Jo, size: pa }) || !qn ? ma : (Un.includeFallbackColors = !1, tinycolor.mostReadable(Xn, ["#fff", "#000"], Un));
};
var names$1 = tinycolor.names = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "0ff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "00f", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", burntsienna: "ea7e5d", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "0ff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "f0f", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "663399", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" }, hexNames = tinycolor.hexNames = flip(names$1);
function flip(Xn) {
  var zn = {};
  for (var Un in Xn) Xn.hasOwnProperty(Un) && (zn[Xn[Un]] = Un);
  return zn;
}
function boundAlpha(Xn) {
  return Xn = parseFloat(Xn), (isNaN(Xn) || Xn < 0 || Xn > 1) && (Xn = 1), Xn;
}
function bound01(Xn, zn) {
  isOnePointZero(Xn) && (Xn = "100%");
  var Un = isPercentage(Xn);
  return Xn = Math.min(zn, Math.max(0, parseFloat(Xn))), Un && (Xn = parseInt(Xn * zn, 10) / 100), Math.abs(Xn - zn) < 1e-6 ? 1 : Xn % zn / parseFloat(zn);
}
function clamp01(Xn) {
  return Math.min(1, Math.max(0, Xn));
}
function parseIntFromHex(Xn) {
  return parseInt(Xn, 16);
}
function isOnePointZero(Xn) {
  return typeof Xn == "string" && Xn.indexOf(".") != -1 && parseFloat(Xn) === 1;
}
function isPercentage(Xn) {
  return typeof Xn == "string" && Xn.indexOf("%") != -1;
}
function pad2(Xn) {
  return Xn.length == 1 ? "0" + Xn : "" + Xn;
}
function convertToPercentage(Xn) {
  return Xn <= 1 && (Xn = 100 * Xn + "%"), Xn;
}
function convertDecimalToHex(Xn) {
  return Math.round(255 * parseFloat(Xn)).toString(16);
}
function convertHexToDecimal(Xn) {
  return parseIntFromHex(Xn) / 255;
}
var matchers = (CSS_UNIT = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)", PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?", PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?", { CSS_UNIT: new RegExp(CSS_UNIT), rgb: new RegExp("rgb" + PERMISSIVE_MATCH3), rgba: new RegExp("rgba" + PERMISSIVE_MATCH4), hsl: new RegExp("hsl" + PERMISSIVE_MATCH3), hsla: new RegExp("hsla" + PERMISSIVE_MATCH4), hsv: new RegExp("hsv" + PERMISSIVE_MATCH3), hsva: new RegExp("hsva" + PERMISSIVE_MATCH4), hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ }), CSS_UNIT, PERMISSIVE_MATCH3, PERMISSIVE_MATCH4;
function isValidCSSUnit(Xn) {
  return !!matchers.CSS_UNIT.exec(Xn);
}
function stringInputToObject(Xn) {
  Xn = Xn.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var zn, Un = !1;
  if (names$1[Xn]) Xn = names$1[Xn], Un = !0;
  else if (Xn == "transparent") return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  return (zn = matchers.rgb.exec(Xn)) ? { r: zn[1], g: zn[2], b: zn[3] } : (zn = matchers.rgba.exec(Xn)) ? { r: zn[1], g: zn[2], b: zn[3], a: zn[4] } : (zn = matchers.hsl.exec(Xn)) ? { h: zn[1], s: zn[2], l: zn[3] } : (zn = matchers.hsla.exec(Xn)) ? { h: zn[1], s: zn[2], l: zn[3], a: zn[4] } : (zn = matchers.hsv.exec(Xn)) ? { h: zn[1], s: zn[2], v: zn[3] } : (zn = matchers.hsva.exec(Xn)) ? { h: zn[1], s: zn[2], v: zn[3], a: zn[4] } : (zn = matchers.hex8.exec(Xn)) ? { r: parseIntFromHex(zn[1]), g: parseIntFromHex(zn[2]), b: parseIntFromHex(zn[3]), a: convertHexToDecimal(zn[4]), format: Un ? "name" : "hex8" } : (zn = matchers.hex6.exec(Xn)) ? { r: parseIntFromHex(zn[1]), g: parseIntFromHex(zn[2]), b: parseIntFromHex(zn[3]), format: Un ? "name" : "hex" } : (zn = matchers.hex4.exec(Xn)) ? { r: parseIntFromHex(zn[1] + "" + zn[1]), g: parseIntFromHex(zn[2] + "" + zn[2]), b: parseIntFromHex(zn[3] + "" + zn[3]), a: convertHexToDecimal(zn[4] + "" + zn[4]), format: Un ? "name" : "hex8" } : !!(zn = matchers.hex3.exec(Xn)) && { r: parseIntFromHex(zn[1] + "" + zn[1]), g: parseIntFromHex(zn[2] + "" + zn[2]), b: parseIntFromHex(zn[3] + "" + zn[3]), format: Un ? "name" : "hex" };
}
function validateWCAG2Parms(Xn) {
  var zn, Un;
  return (zn = ((Xn = Xn || { level: "AA", size: "small" }).level || "AA").toUpperCase()) !== "AA" && zn !== "AAA" && (zn = "AA"), (Un = (Xn.size || "small").toLowerCase()) !== "small" && Un !== "large" && (Un = "small"), { level: zn, size: Un };
}
function clone(Xn) {
  const zn = { width: Xn.bitmap.width, height: Xn.bitmap.height, data: Buffer$1.from(Xn.bitmap.data) };
  return new Xn.constructor(zn);
}
function scan(Xn, zn, Un, Kn, qn, Jo) {
  let pa, ma, va, ba, _a;
  if (typeof zn == "function") _a = zn, pa = 0, ma = 0, va = Xn.bitmap.width, ba = Xn.bitmap.height;
  else {
    if (pa = zn, typeof Un != "number") throw new Error("y must be a number");
    if (ma = Un, typeof Kn != "number") throw new Error("w must be a number");
    if (va = Kn, typeof qn != "number") throw new Error("h must be a number");
    if (ba = qn, typeof Jo != "function") throw new Error("cb must be a function");
    _a = Jo;
  }
  pa = Math.round(pa), ma = Math.round(ma), va = Math.round(va), ba = Math.round(ba);
  const ya = _a.bind(Xn);
  for (let xa = ma; xa < ma + ba; xa++) for (let wa = pa; wa < pa + va; wa++)
    ya(wa, xa, Xn.bitmap.width * xa + wa << 2);
  return Xn;
}
function* scanIterator(Xn, zn, Un, Kn, qn) {
  zn = Math.round(zn), Un = Math.round(Un), Kn = Math.round(Kn), qn = Math.round(qn);
  for (let Jo = Un; Jo < Un + qn; Jo++) for (let pa = zn; pa < zn + Kn; pa++) {
    const ma = Xn.bitmap.width * Jo + pa << 2;
    yield { x: pa, y: Jo, idx: ma, image: Xn };
  }
}
function intToRGBA$1(Xn) {
  if (typeof Xn != "number") throw new Error("i must be a number");
  const zn = { r: 0, g: 0, b: 0, a: 0 };
  return zn.r = Math.floor(Xn / Math.pow(256, 3)), zn.g = Math.floor((Xn - zn.r * Math.pow(256, 3)) / Math.pow(256, 2)), zn.b = Math.floor((Xn - zn.r * Math.pow(256, 3) - zn.g * Math.pow(256, 2)) / Math.pow(256, 1)), zn.a = Math.floor((Xn - zn.r * Math.pow(256, 3) - zn.g * Math.pow(256, 2) - zn.b * Math.pow(256, 1)) / Math.pow(256, 0)), zn;
}
function colorDiff(Xn, zn) {
  const Un = (pa) => Math.pow(pa, 2), { max: Kn } = Math, qn = "a" in Xn ? Xn.a : 255, Jo = "a" in zn ? zn.a : 255;
  return (Kn(Un(Xn.r - zn.r), Un(Xn.r - zn.r - qn + Jo)) + Kn(Un(Xn.g - zn.g), Un(Xn.g - zn.g - qn + Jo)) + Kn(Un(Xn.b - zn.b), Un(Xn.b - zn.b - qn + Jo))) / 195075;
}
function limit255(Xn) {
  return Xn = Math.max(Xn, 0), Xn = Math.min(Xn, 255);
}
function cssColorToHex(Xn) {
  return typeof Xn == "number" ? Xn : parseInt(tinycolor(Xn).toHex8(), 16);
}
function encode$1(Xn, zn = {}) {
  return scan({ bitmap: Xn }, 0, 0, Xn.width, Xn.height, function(Un, Kn, qn) {
    const Jo = Xn.data[qn + 0], pa = Xn.data[qn + 1], ma = Xn.data[qn + 2], va = Xn.data[qn + 3];
    Xn.data[qn + 0] = va, Xn.data[qn + 1] = ma, Xn.data[qn + 2] = pa, Xn.data[qn + 3] = Jo;
  }), encode$2({ ...Xn, ...zn }).data;
}
function decode$1(Xn, zn) {
  const Un = decode$2(Xn, zn);
  return scan({ bitmap: Un }, 0, 0, Un.width, Un.height, function(Kn, qn, Jo) {
    const pa = Un.data[Jo + 1], ma = Un.data[Jo + 2], va = Un.data[Jo + 3];
    Un.data[Jo + 0] = va, Un.data[Jo + 1] = ma, Un.data[Jo + 2] = pa, Un.data[Jo + 3] = 255;
  }), Un;
}
function msBmp() {
  return { mime: "image/x-ms-bmp", encode: encode$1, decode: decode$1 };
}
function bmp() {
  return { mime: "image/bmp", encode: encode$1, decode: decode$1 };
}
var omggif = {}, GifReader_1, GifWriter_1;
function GifWriter(Xn, zn, Un, Kn) {
  var qn = 0, Jo = (Kn = Kn === void 0 ? {} : Kn).loop === void 0 ? null : Kn.loop, pa = Kn.palette === void 0 ? null : Kn.palette;
  if (zn <= 0 || Un <= 0 || zn > 65535 || Un > 65535) throw new Error("Width/Height invalid.");
  function ma(Sa) {
    var Ma = Sa.length;
    if (Ma < 2 || Ma > 256 || Ma & Ma - 1) throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");
    return Ma;
  }
  Xn[qn++] = 71, Xn[qn++] = 73, Xn[qn++] = 70, Xn[qn++] = 56, Xn[qn++] = 57, Xn[qn++] = 97;
  var va = 0, ba = 0;
  if (pa !== null) {
    for (var _a = ma(pa); _a >>= 1; ) ++va;
    if (_a = 1 << va, --va, Kn.background !== void 0) {
      if ((ba = Kn.background) >= _a) throw new Error("Background index out of range.");
      if (ba === 0) throw new Error("Background index explicitly passed as 0.");
    }
  }
  if (Xn[qn++] = 255 & zn, Xn[qn++] = zn >> 8 & 255, Xn[qn++] = 255 & Un, Xn[qn++] = Un >> 8 & 255, Xn[qn++] = (pa !== null ? 128 : 0) | va, Xn[qn++] = ba, Xn[qn++] = 0, pa !== null) for (var ya = 0, xa = pa.length; ya < xa; ++ya) {
    var wa = pa[ya];
    Xn[qn++] = wa >> 16 & 255, Xn[qn++] = wa >> 8 & 255, Xn[qn++] = 255 & wa;
  }
  if (Jo !== null) {
    if (Jo < 0 || Jo > 65535) throw new Error("Loop count invalid.");
    Xn[qn++] = 33, Xn[qn++] = 255, Xn[qn++] = 11, Xn[qn++] = 78, Xn[qn++] = 69, Xn[qn++] = 84, Xn[qn++] = 83, Xn[qn++] = 67, Xn[qn++] = 65, Xn[qn++] = 80, Xn[qn++] = 69, Xn[qn++] = 50, Xn[qn++] = 46, Xn[qn++] = 48, Xn[qn++] = 3, Xn[qn++] = 1, Xn[qn++] = 255 & Jo, Xn[qn++] = Jo >> 8 & 255, Xn[qn++] = 0;
  }
  var Ta = !1;
  this.addFrame = function(Sa, Ma, ka, Za, Na, Ka) {
    if (Ta === !0 && (--qn, Ta = !1), Ka = Ka === void 0 ? {} : Ka, Sa < 0 || Ma < 0 || Sa > 65535 || Ma > 65535) throw new Error("x/y invalid.");
    if (ka <= 0 || Za <= 0 || ka > 65535 || Za > 65535) throw new Error("Width/Height invalid.");
    if (Na.length < ka * Za) throw new Error("Not enough pixels for the frame size.");
    var Ja = !0, el = Ka.palette;
    if (el == null && (Ja = !1, el = pa), el == null) throw new Error("Must supply either a local or global palette.");
    for (var qa = ma(el), tl = 0; qa >>= 1; ) ++tl;
    qa = 1 << tl;
    var Qa = Ka.delay === void 0 ? 0 : Ka.delay, nl = Ka.disposal === void 0 ? 0 : Ka.disposal;
    if (nl < 0 || nl > 3) throw new Error("Disposal out of range.");
    var rl = !1, il = 0;
    if (Ka.transparent !== void 0 && Ka.transparent !== null && (rl = !0, (il = Ka.transparent) < 0 || il >= qa)) throw new Error("Transparent color index.");
    if ((nl !== 0 || rl || Qa !== 0) && (Xn[qn++] = 33, Xn[qn++] = 249, Xn[qn++] = 4, Xn[qn++] = nl << 2 | (rl === !0 ? 1 : 0), Xn[qn++] = 255 & Qa, Xn[qn++] = Qa >> 8 & 255, Xn[qn++] = il, Xn[qn++] = 0), Xn[qn++] = 44, Xn[qn++] = 255 & Sa, Xn[qn++] = Sa >> 8 & 255, Xn[qn++] = 255 & Ma, Xn[qn++] = Ma >> 8 & 255, Xn[qn++] = 255 & ka, Xn[qn++] = ka >> 8 & 255, Xn[qn++] = 255 & Za, Xn[qn++] = Za >> 8 & 255, Xn[qn++] = Ja === !0 ? 128 | tl - 1 : 0, Ja === !0) for (var cl = 0, ll = el.length; cl < ll; ++cl) {
      var al = el[cl];
      Xn[qn++] = al >> 16 & 255, Xn[qn++] = al >> 8 & 255, Xn[qn++] = 255 & al;
    }
    return qn = GifWriterOutputLZWCodeStream(Xn, qn, tl < 2 ? 2 : tl, Na);
  }, this.end = function() {
    return Ta === !1 && (Xn[qn++] = 59, Ta = !0), qn;
  }, this.getOutputBuffer = function() {
    return Xn;
  }, this.setOutputBuffer = function(Sa) {
    Xn = Sa;
  }, this.getOutputBufferPosition = function() {
    return qn;
  }, this.setOutputBufferPosition = function(Sa) {
    qn = Sa;
  };
}
function GifWriterOutputLZWCodeStream(Xn, zn, Un, Kn) {
  Xn[zn++] = Un;
  var qn = zn++, Jo = 1 << Un, pa = Jo - 1, ma = Jo + 1, va = ma + 1, ba = Un + 1, _a = 0, ya = 0;
  function xa(Ja) {
    for (; _a >= Ja; ) Xn[zn++] = 255 & ya, ya >>= 8, _a -= 8, zn === qn + 256 && (Xn[qn] = 255, qn = zn++);
  }
  function wa(Ja) {
    ya |= Ja << _a, _a += ba, xa(8);
  }
  var Ta = Kn[0] & pa, Sa = {};
  wa(Jo);
  for (var Ma = 1, ka = Kn.length; Ma < ka; ++Ma) {
    var Za = Kn[Ma] & pa, Na = Ta << 8 | Za, Ka = Sa[Na];
    if (Ka === void 0) {
      for (ya |= Ta << _a, _a += ba; _a >= 8; ) Xn[zn++] = 255 & ya, ya >>= 8, _a -= 8, zn === qn + 256 && (Xn[qn] = 255, qn = zn++);
      va === 4096 ? (wa(Jo), va = ma + 1, ba = Un + 1, Sa = {}) : (va >= 1 << ba && ++ba, Sa[Na] = va++), Ta = Za;
    } else Ta = Ka;
  }
  return wa(Ta), wa(ma), xa(1), qn + 1 === zn ? Xn[qn] = 0 : (Xn[qn] = zn - qn - 1, Xn[zn++] = 0), zn;
}
function GifReader(Xn) {
  var zn = 0;
  if (Xn[zn++] !== 71 || Xn[zn++] !== 73 || Xn[zn++] !== 70 || Xn[zn++] !== 56 || (Xn[zn++] + 1 & 253) != 56 || Xn[zn++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var Un = Xn[zn++] | Xn[zn++] << 8, Kn = Xn[zn++] | Xn[zn++] << 8, qn = Xn[zn++], Jo = qn >> 7, pa = 1 << (7 & qn) + 1;
  Xn[zn++], Xn[zn++];
  var ma = null, va = null;
  Jo && (ma = zn, va = pa, zn += 3 * pa);
  var ba = !0, _a = [], ya = 0, xa = null, wa = 0, Ta = null;
  for (this.width = Un, this.height = Kn; ba && zn < Xn.length; ) switch (Xn[zn++]) {
    case 33:
      switch (Xn[zn++]) {
        case 255:
          if (Xn[zn] !== 11 || Xn[zn + 1] == 78 && Xn[zn + 2] == 69 && Xn[zn + 3] == 84 && Xn[zn + 4] == 83 && Xn[zn + 5] == 67 && Xn[zn + 6] == 65 && Xn[zn + 7] == 80 && Xn[zn + 8] == 69 && Xn[zn + 9] == 50 && Xn[zn + 10] == 46 && Xn[zn + 11] == 48 && Xn[zn + 12] == 3 && Xn[zn + 13] == 1 && Xn[zn + 16] == 0) zn += 14, Ta = Xn[zn++] | Xn[zn++] << 8, zn++;
          else for (zn += 12; ; ) {
            if (!((rl = Xn[zn++]) >= 0)) throw Error("Invalid block size");
            if (rl === 0) break;
            zn += rl;
          }
          break;
        case 249:
          if (Xn[zn++] !== 4 || Xn[zn + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var Sa = Xn[zn++];
          ya = Xn[zn++] | Xn[zn++] << 8, xa = Xn[zn++], 1 & Sa || (xa = null), wa = Sa >> 2 & 7, zn++;
          break;
        case 254:
          for (; ; ) {
            if (!((rl = Xn[zn++]) >= 0)) throw Error("Invalid block size");
            if (rl === 0) break;
            zn += rl;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + Xn[zn - 1].toString(16));
      }
      break;
    case 44:
      var Ma = Xn[zn++] | Xn[zn++] << 8, ka = Xn[zn++] | Xn[zn++] << 8, Za = Xn[zn++] | Xn[zn++] << 8, Na = Xn[zn++] | Xn[zn++] << 8, Ka = Xn[zn++], Ja = Ka >> 6 & 1, el = 1 << (7 & Ka) + 1, qa = ma, tl = va, Qa = !1;
      Ka >> 7 && (Qa = !0, qa = zn, tl = el, zn += 3 * el);
      var nl = zn;
      for (zn++; ; ) {
        var rl;
        if (!((rl = Xn[zn++]) >= 0)) throw Error("Invalid block size");
        if (rl === 0) break;
        zn += rl;
      }
      _a.push({ x: Ma, y: ka, width: Za, height: Na, has_local_palette: Qa, palette_offset: qa, palette_size: tl, data_offset: nl, data_length: zn - nl, transparent_index: xa, interlaced: !!Ja, delay: ya, disposal: wa });
      break;
    case 59:
      ba = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + Xn[zn - 1].toString(16));
  }
  this.numFrames = function() {
    return _a.length;
  }, this.loopCount = function() {
    return Ta;
  }, this.frameInfo = function(il) {
    if (il < 0 || il >= _a.length) throw new Error("Frame index out of range.");
    return _a[il];
  }, this.decodeAndBlitFrameBGRA = function(il, cl) {
    var ll = this.frameInfo(il), al = ll.width * ll.height, sl = new Uint8Array(al);
    GifReaderLZWOutputIndexStream(Xn, ll.data_offset, sl, al);
    var dl = ll.palette_offset, El = ll.transparent_index;
    El === null && (El = 256);
    var fl = ll.width, Ml = Un - fl, Sl = fl, ml = 4 * (ll.y * Un + ll.x), Dl = 4 * ((ll.y + ll.height) * Un + ll.x), _l = ml, gl = 4 * Ml;
    ll.interlaced === !0 && (gl += 4 * Un * 7);
    for (var Fl = 8, Nl = 0, zl = sl.length; Nl < zl; ++Nl) {
      var Zl = sl[Nl];
      if (Sl === 0 && (Sl = fl, (_l += gl) >= Dl && (gl = 4 * Ml + 4 * Un * (Fl - 1), _l = ml + (fl + Ml) * (Fl << 1), Fl >>= 1)), Zl === El) _l += 4;
      else {
        var kl = Xn[dl + 3 * Zl], ul = Xn[dl + 3 * Zl + 1], vl = Xn[dl + 3 * Zl + 2];
        cl[_l++] = vl, cl[_l++] = ul, cl[_l++] = kl, cl[_l++] = 255;
      }
      --Sl;
    }
  }, this.decodeAndBlitFrameRGBA = function(il, cl) {
    var ll = this.frameInfo(il), al = ll.width * ll.height, sl = new Uint8Array(al);
    GifReaderLZWOutputIndexStream(Xn, ll.data_offset, sl, al);
    var dl = ll.palette_offset, El = ll.transparent_index;
    El === null && (El = 256);
    var fl = ll.width, Ml = Un - fl, Sl = fl, ml = 4 * (ll.y * Un + ll.x), Dl = 4 * ((ll.y + ll.height) * Un + ll.x), _l = ml, gl = 4 * Ml;
    ll.interlaced === !0 && (gl += 4 * Un * 7);
    for (var Fl = 8, Nl = 0, zl = sl.length; Nl < zl; ++Nl) {
      var Zl = sl[Nl];
      if (Sl === 0 && (Sl = fl, (_l += gl) >= Dl && (gl = 4 * Ml + 4 * Un * (Fl - 1), _l = ml + (fl + Ml) * (Fl << 1), Fl >>= 1)), Zl === El) _l += 4;
      else {
        var kl = Xn[dl + 3 * Zl], ul = Xn[dl + 3 * Zl + 1], vl = Xn[dl + 3 * Zl + 2];
        cl[_l++] = kl, cl[_l++] = ul, cl[_l++] = vl, cl[_l++] = 255;
      }
      --Sl;
    }
  };
}
function GifReaderLZWOutputIndexStream(Xn, zn, Un, Kn) {
  for (var qn = Xn[zn++], Jo = 1 << qn, pa = Jo + 1, ma = pa + 1, va = qn + 1, ba = (1 << va) - 1, _a = 0, ya = 0, xa = 0, wa = Xn[zn++], Ta = new Int32Array(4096), Sa = null; ; ) {
    for (; _a < 16 && wa !== 0; ) ya |= Xn[zn++] << _a, _a += 8, wa === 1 ? wa = Xn[zn++] : --wa;
    if (_a < va) break;
    var Ma = ya & ba;
    if (ya >>= va, _a -= va, Ma !== Jo) {
      if (Ma === pa) break;
      for (var ka = Ma < ma ? Ma : Sa, Za = 0, Na = ka; Na > Jo; ) Na = Ta[Na] >> 8, ++Za;
      var Ka = Na;
      if (xa + Za + (ka !== Ma ? 1 : 0) > Kn) return void console.log("Warning, gif stream longer than expected.");
      Un[xa++] = Ka;
      var Ja = xa += Za;
      for (ka !== Ma && (Un[xa++] = Ka), Na = ka; Za--; ) Na = Ta[Na], Un[--Ja] = 255 & Na, Na >>= 8;
      Sa !== null && ma < 4096 && (Ta[ma++] = Sa << 8 | Ka, ma >= ba + 1 && va < 12 && (++va, ba = ba << 1 | 1)), Sa = Ma;
    } else ma = pa + 1, ba = (1 << (va = qn + 1)) - 1, Sa = null;
  }
  return xa !== Kn && console.log("Warning, gif stream shorter than expected."), Un;
}
try {
  GifWriter_1 = omggif.GifWriter = GifWriter, GifReader_1 = omggif.GifReader = GifReader;
} catch {
}
let BitmapImage$2 = class pd {
  constructor(...zn) {
    if (zn.length === 0) throw new Error("constructor requires parameters");
    const Un = zn[0];
    if (Un !== null && typeof Un == "object") if (Un instanceof pd) {
      const Kn = Un.bitmap;
      this.bitmap = { width: Kn.width, height: Kn.height, data: new Buffer$1(Kn.width * Kn.height * 4) }, Kn.data.copy(this.bitmap.data);
    } else {
      if (!(Un.width && Un.height && Un.data)) throw new Error("unrecognized constructor parameters");
      this.bitmap = Un;
    }
    else {
      if (typeof Un != "number" || typeof zn[1] != "number") throw new Error("unrecognized constructor parameters");
      {
        const Kn = Un, qn = zn[1], Jo = zn[2];
        this.bitmap = { width: Kn, height: qn }, Buffer$1.isBuffer(Jo) ? this.bitmap.data = Jo : (this.bitmap.data = new Buffer$1(Kn * qn * 4), typeof Jo == "number" && this.fillRGBA(Jo));
      }
    }
  }
  blit(zn, Un, Kn, qn, Jo, pa, ma) {
    if (qn + pa > this.bitmap.width) throw new Error("copy exceeds width of source bitmap");
    if (Un + pa > zn.bitmap.width) throw new Error("copy exceeds width of target bitmap");
    if (Jo + ma > this.bitmap.height) throw new Error("copy exceeds height of source bitmap");
    if (Kn + ma > zn.bitmap.height) throw new Erro("copy exceeds height of target bitmap");
    const va = this.bitmap.data, ba = zn.bitmap.data, _a = 4 * this.bitmap.width, ya = 4 * zn.bitmap.width, xa = 4 * pa;
    let wa = Jo * _a + 4 * qn, Ta = Kn * ya + 4 * Un;
    for (; --ma >= 0; ) va.copy(ba, Ta, wa, wa + xa), wa += _a, Ta += ya;
    return this;
  }
  fillRGBA(zn) {
    const Un = this.bitmap.data, Kn = 4 * this.bitmap.height;
    let qn = 0;
    for (; qn < Kn; ) Un.writeUInt32BE(zn, qn), qn += 4;
    for (; qn < Un.length; ) Un.copy(Un, qn, 0, Kn), qn += Kn;
    return this;
  }
  getRGBA(zn, Un) {
    const Kn = 4 * (Un * this.bitmap.width + zn);
    return this.bitmap.data.readUInt32BE(Kn);
  }
  getRGBASet() {
    const zn = /* @__PURE__ */ new Set(), Un = this.bitmap.data;
    for (let Kn = 0; Kn < Un.length; Kn += 4) zn.add(Un.readUInt32BE(Kn, !0));
    return zn;
  }
  greyscale() {
    const zn = this.bitmap.data;
    return this.scan(0, 0, this.bitmap.width, this.bitmap.height, (Un, Kn, qn) => {
      const Jo = Math.round(0.299 * zn[qn] + 0.587 * zn[qn + 1] + 0.114 * zn[qn + 2]);
      zn[qn] = Jo, zn[qn + 1] = Jo, zn[qn + 2] = Jo;
    }), this;
  }
  reframe(zn, Un, Kn, qn, Jo) {
    const pa = zn < 0 ? 0 : zn, ma = Un < 0 ? 0 : Un, va = Kn + pa > this.bitmap.width ? this.bitmap.width - pa : Kn, ba = qn + ma > this.bitmap.height ? this.bitmap.height - ma : qn, _a = zn < 0 ? -zn : 0, ya = Un < 0 ? -Un : 0;
    let xa;
    if (Jo === void 0) {
      if (pa !== zn || ma != Un || va !== Kn || ba !== qn) throw new GifError("fillRGBA required for this reframing");
      xa = new pd(Kn, qn);
    } else xa = new pd(Kn, qn, Jo);
    return this.blit(xa, _a, ya, pa, ma, va, ba), this.bitmap = xa.bitmap, this;
  }
  scale(zn) {
    if (zn === 1) return;
    if (!Number.isInteger(zn) || zn < 1) throw new Error("the scale must be an integer >= 1");
    const Un = this.bitmap.width, Kn = this.bitmap.height, qn = Un * zn * 4, Jo = this.bitmap.data, pa = new Buffer$1(Kn * qn * zn);
    let ma, va = 0, ba = 0;
    for (let _a = 0; _a < Kn; ++_a) {
      ma = ba;
      for (let ya = 0; ya < Un; ++ya) {
        const xa = Jo.readUInt32BE(va, !0);
        for (let wa = 0; wa < zn; ++wa) pa.writeUInt32BE(xa, ba), ba += 4;
        va += 4;
      }
      for (let ya = 1; ya < zn; ++ya) pa.copy(pa, ba, ma, ba), ba += qn, ma += qn;
    }
    return this.bitmap = { width: Un * zn, height: Kn * zn, data: pa }, this;
  }
  scanAllCoords(zn) {
    const Un = this.bitmap.width, Kn = this.bitmap.data.length;
    let qn = 0, Jo = 0;
    for (let pa = 0; pa < Kn; pa += 4) zn(qn, Jo, pa), ++qn === Un && (qn = 0, ++Jo);
  }
  scanAllIndexes(zn) {
    const Un = this.bitmap.data.length;
    for (let Kn = 0; Kn < Un; Kn += 4) zn(Kn);
  }
};
var bitmapimage = BitmapImage$2, gif$1 = {};
let Gif$1 = class {
  constructor(Xn, zn, Un) {
    this.width = Un.width, this.height = Un.height, this.loops = Un.loops, this.usesTransparency = Un.usesTransparency, this.colorScope = Un.colorScope, this.frames = zn, this.buffer = Xn;
  }
};
Gif$1.GlobalColorsPreferred = 0, Gif$1.GlobalColorsOnly = 1, Gif$1.LocalColorsOnly = 2;
let GifError$2 = class extends Error {
  constructor(Xn) {
    super(Xn), Xn instanceof Error && (this.stack = "Gif" + Xn.stack);
  }
};
gif$1.Gif = Gif$1, gif$1.GifError = GifError$2;
var gifcodec = {}, gifutil = {}, _polyfillNode_fs = {}, _polyfillNode_fs$1 = Object.freeze({ __proto__: null, default: _polyfillNode_fs }), require$$0 = getAugmentedNamespace(_polyfillNode_fs$1), __defProp$3 = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __hasOwnProp = Object.prototype.hasOwnProperty, __defNormalProp$3 = (Xn, zn, Un) => zn in Xn ? __defProp$3(Xn, zn, { enumerable: !0, configurable: !0, writable: !0, value: Un }) : Xn[zn] = Un, __markAsModule = (Xn) => __defProp$3(Xn, "__esModule", { value: !0 }), __export$1 = (Xn, zn) => {
  for (var Un in zn) __defProp$3(Xn, Un, { get: zn[Un], enumerable: !0 });
}, __reExport = (Xn, zn, Un, Kn) => {
  if (zn && typeof zn == "object" || typeof zn == "function") for (let qn of __getOwnPropNames(zn)) !__hasOwnProp.call(Xn, qn) && Un && __defProp$3(Xn, qn, { get: () => zn[qn], enumerable: !(Kn = __getOwnPropDesc(zn, qn)) || Kn.enumerable });
  return Xn;
}, __toCommonJS = /* @__PURE__ */ ((Xn) => (zn, Un) => Xn && Xn.get(zn) || (Un = __reExport(__markAsModule({}), zn, 1), Xn && Xn.set(zn, Un), Un))(typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : 0), __publicField$3 = (Xn, zn, Un) => (__defNormalProp$3(Xn, typeof zn != "symbol" ? zn + "" : zn, Un), Un), src_exports = {};
__export$1(src_exports, { applyPalette: () => applyPalette, applyPaletteSync: () => applyPaletteSync$1, buildPalette: () => buildPalette, buildPaletteSync: () => buildPaletteSync$1, constants: () => constants_exports$1, conversion: () => conversion_exports$1, distance: () => distance_exports$1, image: () => image_exports$1, palette: () => palette_exports$1, quality: () => quality_exports$1, utils: () => utils_exports$1 });
var constants_exports$1 = {};
__export$1(constants_exports$1, { bt709: () => bt709_exports$1 });
var bt709_exports$1 = {};
__export$1(bt709_exports$1, { Y: () => Y$1, x: () => x$2, y: () => y$2 });
var Y$1 = ((Xn) => (Xn[Xn.RED = 0.2126] = "RED", Xn[Xn.GREEN = 0.7152] = "GREEN", Xn[Xn.BLUE = 0.0722] = "BLUE", Xn[Xn.WHITE = 1] = "WHITE", Xn))(Y$1 || {}), x$2 = ((Xn) => (Xn[Xn.RED = 0.64] = "RED", Xn[Xn.GREEN = 0.3] = "GREEN", Xn[Xn.BLUE = 0.15] = "BLUE", Xn[Xn.WHITE = 0.3127] = "WHITE", Xn))(x$2 || {}), y$2 = ((Xn) => (Xn[Xn.RED = 0.33] = "RED", Xn[Xn.GREEN = 0.6] = "GREEN", Xn[Xn.BLUE = 0.06] = "BLUE", Xn[Xn.WHITE = 0.329] = "WHITE", Xn))(y$2 || {}), conversion_exports$1 = {};
function correctGamma$1(Xn) {
  return Xn > 0.04045 ? ((Xn + 0.055) / 1.055) ** 2.4 : Xn / 12.92;
}
function rgb2xyz$1(Xn, zn, Un) {
  return { x: 0.4124 * (Xn = correctGamma$1(Xn / 255)) + 0.3576 * (zn = correctGamma$1(zn / 255)) + 0.1805 * (Un = correctGamma$1(Un / 255)), y: 0.2126 * Xn + 0.7152 * zn + 0.0722 * Un, z: 0.0193 * Xn + 0.1192 * zn + 0.9505 * Un };
}
__export$1(conversion_exports$1, { lab2rgb: () => lab2rgb$1, lab2xyz: () => lab2xyz$1, rgb2hsl: () => rgb2hsl$1, rgb2lab: () => rgb2lab$1, rgb2xyz: () => rgb2xyz$1, xyz2lab: () => xyz2lab$1, xyz2rgb: () => xyz2rgb$1 });
var arithmetic_exports$1 = {};
function degrees2radians$1(Xn) {
  return Xn * (Math.PI / 180);
}
function max3$1(Xn, zn, Un) {
  let Kn = Xn;
  return Kn < zn && (Kn = zn), Kn < Un && (Kn = Un), Kn;
}
function min3$1(Xn, zn, Un) {
  let Kn = Xn;
  return Kn > zn && (Kn = zn), Kn > Un && (Kn = Un), Kn;
}
function intInRange$1(Xn, zn, Un) {
  return Xn > Un && (Xn = Un), Xn < zn && (Xn = zn), 0 | Xn;
}
function inRange0to255Rounded$1(Xn) {
  return (Xn = Math.round(Xn)) > 255 ? Xn = 255 : Xn < 0 && (Xn = 0), Xn;
}
function inRange0to255$1(Xn) {
  return Xn > 255 ? Xn = 255 : Xn < 0 && (Xn = 0), Xn;
}
function stableSort$1(Xn, zn) {
  const Un = typeof Xn[0];
  let Kn;
  if (Un === "number" || Un === "string") {
    const qn = /* @__PURE__ */ Object.create(null);
    for (let Jo = 0, pa = Xn.length; Jo < pa; Jo++) {
      const ma = Xn[Jo];
      qn[ma] || qn[ma] === 0 || (qn[ma] = Jo);
    }
    Kn = Xn.sort((Jo, pa) => zn(Jo, pa) || qn[Jo] - qn[pa]);
  } else {
    const qn = Xn.slice(0);
    Kn = Xn.sort((Jo, pa) => zn(Jo, pa) || qn.indexOf(Jo) - qn.indexOf(pa));
  }
  return Kn;
}
function rgb2hsl$1(Xn, zn, Un) {
  const Kn = min3$1(Xn, zn, Un), qn = max3$1(Xn, zn, Un), Jo = qn - Kn, pa = (Kn + qn) / 510;
  let ma = 0;
  pa > 0 && pa < 1 && (ma = Jo / (pa < 0.5 ? qn + Kn : 510 - qn - Kn));
  let va = 0;
  return Jo > 0 && (va = qn === Xn ? (zn - Un) / Jo : qn === zn ? 2 + (Un - Xn) / Jo : 4 + (Xn - zn) / Jo, va *= 60, va < 0 && (va += 360)), { h: va, s: ma, l: pa };
}
__export$1(arithmetic_exports$1, { degrees2radians: () => degrees2radians$1, inRange0to255: () => inRange0to255$1, inRange0to255Rounded: () => inRange0to255Rounded$1, intInRange: () => intInRange$1, max3: () => max3$1, min3: () => min3$1, stableSort: () => stableSort$1 });
var refX$1 = 0.95047, refY$1 = 1, refZ$1 = 1.08883;
function pivot$1(Xn) {
  return Xn > 8856e-6 ? Xn ** (1 / 3) : 7.787 * Xn + 16 / 116;
}
function xyz2lab$1(Xn, zn, Un) {
  if (Xn = pivot$1(Xn / refX$1), zn = pivot$1(zn / refY$1), Un = pivot$1(Un / refZ$1), 116 * zn - 16 < 0) throw new Error("xxx");
  return { L: Math.max(0, 116 * zn - 16), a: 500 * (Xn - zn), b: 200 * (zn - Un) };
}
function rgb2lab$1(Xn, zn, Un) {
  const Kn = rgb2xyz$1(Xn, zn, Un);
  return xyz2lab$1(Kn.x, Kn.y, Kn.z);
}
var refX2$1 = 0.95047, refY2$1 = 1, refZ2$1 = 1.08883;
function pivot2$1(Xn) {
  return Xn > 0.206893034 ? Xn ** 3 : (Xn - 16 / 116) / 7.787;
}
function lab2xyz$1(Xn, zn, Un) {
  const Kn = (Xn + 16) / 116, qn = Kn - Un / 200;
  return { x: refX2$1 * pivot2$1(zn / 500 + Kn), y: refY2$1 * pivot2$1(Kn), z: refZ2$1 * pivot2$1(qn) };
}
function correctGamma2$1(Xn) {
  return Xn > 31308e-7 ? 1.055 * Xn ** (1 / 2.4) - 0.055 : 12.92 * Xn;
}
function xyz2rgb$1(Xn, zn, Un) {
  const Kn = correctGamma2$1(3.2406 * Xn + -1.5372 * zn + -0.4986 * Un), qn = correctGamma2$1(-0.9689 * Xn + 1.8758 * zn + 0.0415 * Un), Jo = correctGamma2$1(0.0557 * Xn + -0.204 * zn + 1.057 * Un);
  return { r: inRange0to255Rounded$1(255 * Kn), g: inRange0to255Rounded$1(255 * qn), b: inRange0to255Rounded$1(255 * Jo) };
}
function lab2rgb$1(Xn, zn, Un) {
  const Kn = lab2xyz$1(Xn, zn, Un);
  return xyz2rgb$1(Kn.x, Kn.y, Kn.z);
}
var distance_exports$1 = {};
__export$1(distance_exports$1, { AbstractDistanceCalculator: () => AbstractDistanceCalculator$1, AbstractEuclidean: () => AbstractEuclidean$1, AbstractManhattan: () => AbstractManhattan$1, CIE94GraphicArts: () => CIE94GraphicArts$1, CIE94Textiles: () => CIE94Textiles$1, CIEDE2000: () => CIEDE2000$1, CMetric: () => CMetric$1, Euclidean: () => Euclidean$1, EuclideanBT709: () => EuclideanBT709$1, EuclideanBT709NoAlpha: () => EuclideanBT709NoAlpha$1, Manhattan: () => Manhattan$1, ManhattanBT709: () => ManhattanBT709$1, ManhattanNommyde: () => ManhattanNommyde$1, PNGQuant: () => PNGQuant$1 });
var AbstractDistanceCalculator$1 = class {
  constructor() {
    __publicField$3(this, "_maxDistance"), __publicField$3(this, "_whitePoint"), this._setDefaults(), this.setWhitePoint(255, 255, 255, 255);
  }
  setWhitePoint(Xn, zn, Un, Kn) {
    this._whitePoint = { r: Xn > 0 ? 255 / Xn : 0, g: zn > 0 ? 255 / zn : 0, b: Un > 0 ? 255 / Un : 0, a: Kn > 0 ? 255 / Kn : 0 }, this._maxDistance = this.calculateRaw(Xn, zn, Un, Kn, 0, 0, 0, 0);
  }
  calculateNormalized(Xn, zn) {
    return this.calculateRaw(Xn.r, Xn.g, Xn.b, Xn.a, zn.r, zn.g, zn.b, zn.a) / this._maxDistance;
  }
}, AbstractCIE94$1 = class extends AbstractDistanceCalculator$1 {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = rgb2lab$1(inRange0to255$1(Xn * this._whitePoint.r), inRange0to255$1(zn * this._whitePoint.g), inRange0to255$1(Un * this._whitePoint.b)), ba = rgb2lab$1(inRange0to255$1(qn * this._whitePoint.r), inRange0to255$1(Jo * this._whitePoint.g), inRange0to255$1(pa * this._whitePoint.b)), _a = va.L - ba.L, ya = va.a - ba.a, xa = va.b - ba.b, wa = Math.sqrt(va.a * va.a + va.b * va.b), Ta = wa - Math.sqrt(ba.a * ba.a + ba.b * ba.b);
    let Sa = ya * ya + xa * xa - Ta * Ta;
    Sa = Sa < 0 ? 0 : Math.sqrt(Sa);
    const Ma = (ma - Kn) * this._whitePoint.a * this._kA;
    return Math.sqrt((_a / this._Kl) ** 2 + (Ta / (1 + this._K1 * wa)) ** 2 + (Sa / (1 + this._K2 * wa)) ** 2 + Ma ** 2);
  }
}, CIE94Textiles$1 = class extends AbstractCIE94$1 {
  _setDefaults() {
    this._Kl = 2, this._K1 = 0.048, this._K2 = 0.014, this._kA = 12.5 / 255;
  }
}, CIE94GraphicArts$1 = class extends AbstractCIE94$1 {
  _setDefaults() {
    this._Kl = 1, this._K1 = 0.045, this._K2 = 0.015, this._kA = 25 / 255;
  }
}, _CIEDE2000$1 = class extends AbstractDistanceCalculator$1 {
  _setDefaults() {
  }
  static _calculatehp(Xn, zn) {
    const Un = Math.atan2(Xn, zn);
    return Un >= 0 ? Un : Un + _CIEDE2000$1._deg360InRad;
  }
  static _calculateRT(Xn, zn) {
    const Un = zn ** 7, Kn = 2 * Math.sqrt(Un / (Un + _CIEDE2000$1._pow25to7)), qn = _CIEDE2000$1._deg30InRad * Math.exp(-(((Xn - _CIEDE2000$1._deg275InRad) / _CIEDE2000$1._deg25InRad) ** 2));
    return -Math.sin(2 * qn) * Kn;
  }
  static _calculateT(Xn) {
    return 1 - 0.17 * Math.cos(Xn - _CIEDE2000$1._deg30InRad) + 0.24 * Math.cos(2 * Xn) + 0.32 * Math.cos(3 * Xn + _CIEDE2000$1._deg6InRad) - 0.2 * Math.cos(4 * Xn - _CIEDE2000$1._deg63InRad);
  }
  static _calculate_ahp(Xn, zn, Un, Kn) {
    const qn = Un + Kn;
    return Xn === 0 ? qn : zn <= _CIEDE2000$1._deg180InRad ? qn / 2 : qn < _CIEDE2000$1._deg360InRad ? (qn + _CIEDE2000$1._deg360InRad) / 2 : (qn - _CIEDE2000$1._deg360InRad) / 2;
  }
  static _calculate_dHp(Xn, zn, Un, Kn) {
    let qn;
    return qn = Xn === 0 ? 0 : zn <= _CIEDE2000$1._deg180InRad ? Un - Kn : Un <= Kn ? Un - Kn + _CIEDE2000$1._deg360InRad : Un - Kn - _CIEDE2000$1._deg360InRad, 2 * Math.sqrt(Xn) * Math.sin(qn / 2);
  }
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = rgb2lab$1(inRange0to255$1(Xn * this._whitePoint.r), inRange0to255$1(zn * this._whitePoint.g), inRange0to255$1(Un * this._whitePoint.b)), ba = rgb2lab$1(inRange0to255$1(qn * this._whitePoint.r), inRange0to255$1(Jo * this._whitePoint.g), inRange0to255$1(pa * this._whitePoint.b)), _a = (ma - Kn) * this._whitePoint.a * _CIEDE2000$1._kA, ya = this.calculateRawInLab(va, ba);
    return Math.sqrt(ya + _a * _a);
  }
  calculateRawInLab(Xn, zn) {
    const Un = Xn.L, Kn = Xn.a, qn = Xn.b, Jo = zn.L, pa = zn.a, ma = zn.b, va = ((Math.sqrt(Kn * Kn + qn * qn) + Math.sqrt(pa * pa + ma * ma)) / 2) ** 7, ba = 0.5 * (1 - Math.sqrt(va / (va + _CIEDE2000$1._pow25to7))), _a = (1 + ba) * Kn, ya = (1 + ba) * pa, xa = Math.sqrt(_a * _a + qn * qn), wa = Math.sqrt(ya * ya + ma * ma), Ta = xa * wa, Sa = _CIEDE2000$1._calculatehp(qn, _a), Ma = _CIEDE2000$1._calculatehp(ma, ya), ka = Math.abs(Sa - Ma), Za = Jo - Un, Na = wa - xa, Ka = _CIEDE2000$1._calculate_dHp(Ta, ka, Ma, Sa), Ja = _CIEDE2000$1._calculate_ahp(Ta, ka, Sa, Ma), el = (xa + wa) / 2, qa = ((Un + Jo) / 2 - 50) ** 2, tl = Na / (1 + 0.045 * el), Qa = Ka / (1 + 0.015 * _CIEDE2000$1._calculateT(Ja) * el);
    return (Za / (1 + 0.015 * qa / Math.sqrt(20 + qa))) ** 2 + tl ** 2 + Qa ** 2 + _CIEDE2000$1._calculateRT(Ja, el) * tl * Qa;
  }
}, CIEDE2000$1 = _CIEDE2000$1;
__publicField$3(CIEDE2000$1, "_kA", 25 / 255), __publicField$3(CIEDE2000$1, "_pow25to7", 25 ** 7), __publicField$3(CIEDE2000$1, "_deg360InRad", degrees2radians$1(360)), __publicField$3(CIEDE2000$1, "_deg180InRad", degrees2radians$1(180)), __publicField$3(CIEDE2000$1, "_deg30InRad", degrees2radians$1(30)), __publicField$3(CIEDE2000$1, "_deg6InRad", degrees2radians$1(6)), __publicField$3(CIEDE2000$1, "_deg63InRad", degrees2radians$1(63)), __publicField$3(CIEDE2000$1, "_deg275InRad", degrees2radians$1(275)), __publicField$3(CIEDE2000$1, "_deg25InRad", degrees2radians$1(25));
var CMetric$1 = class extends AbstractDistanceCalculator$1 {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = (Xn + qn) / 2 * this._whitePoint.r, ba = (Xn - qn) * this._whitePoint.r, _a = (zn - Jo) * this._whitePoint.g, ya = (Un - pa) * this._whitePoint.b, xa = ((512 + va) * ba * ba >> 8) + 4 * _a * _a + ((767 - va) * ya * ya >> 8), wa = (ma - Kn) * this._whitePoint.a;
    return Math.sqrt(xa + wa * wa);
  }
  _setDefaults() {
  }
}, AbstractEuclidean$1 = class extends AbstractDistanceCalculator$1 {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = qn - Xn, ba = Jo - zn, _a = pa - Un, ya = ma - Kn;
    return Math.sqrt(this._kR * va * va + this._kG * ba * ba + this._kB * _a * _a + this._kA * ya * ya);
  }
}, Euclidean$1 = class extends AbstractEuclidean$1 {
  _setDefaults() {
    this._kR = 1, this._kG = 1, this._kB = 1, this._kA = 1;
  }
}, EuclideanBT709$1 = class extends AbstractEuclidean$1 {
  _setDefaults() {
    this._kR = 0.2126, this._kG = 0.7152, this._kB = 0.0722, this._kA = 1;
  }
}, EuclideanBT709NoAlpha$1 = class extends AbstractEuclidean$1 {
  _setDefaults() {
    this._kR = 0.2126, this._kG = 0.7152, this._kB = 0.0722, this._kA = 0;
  }
}, AbstractManhattan$1 = class extends AbstractDistanceCalculator$1 {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    let va = qn - Xn, ba = Jo - zn, _a = pa - Un, ya = ma - Kn;
    return va < 0 && (va = 0 - va), ba < 0 && (ba = 0 - ba), _a < 0 && (_a = 0 - _a), ya < 0 && (ya = 0 - ya), this._kR * va + this._kG * ba + this._kB * _a + this._kA * ya;
  }
}, Manhattan$1 = class extends AbstractManhattan$1 {
  _setDefaults() {
    this._kR = 1, this._kG = 1, this._kB = 1, this._kA = 1;
  }
}, ManhattanNommyde$1 = class extends AbstractManhattan$1 {
  _setDefaults() {
    this._kR = 0.4984, this._kG = 0.8625, this._kB = 0.2979, this._kA = 1;
  }
}, ManhattanBT709$1 = class extends AbstractManhattan$1 {
  _setDefaults() {
    this._kR = 0.2126, this._kG = 0.7152, this._kB = 0.0722, this._kA = 1;
  }
}, PNGQuant$1 = class extends AbstractDistanceCalculator$1 {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = (ma - Kn) * this._whitePoint.a;
    return this._colordifferenceCh(Xn * this._whitePoint.r, qn * this._whitePoint.r, va) + this._colordifferenceCh(zn * this._whitePoint.g, Jo * this._whitePoint.g, va) + this._colordifferenceCh(Un * this._whitePoint.b, pa * this._whitePoint.b, va);
  }
  _colordifferenceCh(Xn, zn, Un) {
    const Kn = Xn - zn, qn = Kn + Un;
    return Kn * Kn + qn * qn;
  }
  _setDefaults() {
  }
}, palette_exports$1 = {};
__export$1(palette_exports$1, { AbstractPaletteQuantizer: () => AbstractPaletteQuantizer$1, ColorHistogram: () => ColorHistogram$1, NeuQuant: () => NeuQuant$1, NeuQuantFloat: () => NeuQuantFloat$1, RGBQuant: () => RGBQuant$1, WuColorCube: () => WuColorCube$1, WuQuant: () => WuQuant$1 });
var AbstractPaletteQuantizer$1 = class {
  quantizeSync() {
    for (const Xn of this.quantize()) if (Xn.palette) return Xn.palette;
    throw new Error("unreachable");
  }
}, Point$1 = class {
  constructor() {
    __publicField$3(this, "r"), __publicField$3(this, "g"), __publicField$3(this, "b"), __publicField$3(this, "a"), __publicField$3(this, "uint32"), __publicField$3(this, "rgba"), this.uint32 = -1 >>> 0, this.r = this.g = this.b = this.a = 0, this.rgba = new Array(4), this.rgba[0] = 0, this.rgba[1] = 0, this.rgba[2] = 0, this.rgba[3] = 0;
  }
  static createByQuadruplet(Xn) {
    const zn = new Point$1();
    return zn.r = 0 | Xn[0], zn.g = 0 | Xn[1], zn.b = 0 | Xn[2], zn.a = 0 | Xn[3], zn._loadUINT32(), zn._loadQuadruplet(), zn;
  }
  static createByRGBA(Xn, zn, Un, Kn) {
    const qn = new Point$1();
    return qn.r = 0 | Xn, qn.g = 0 | zn, qn.b = 0 | Un, qn.a = 0 | Kn, qn._loadUINT32(), qn._loadQuadruplet(), qn;
  }
  static createByUint32(Xn) {
    const zn = new Point$1();
    return zn.uint32 = Xn >>> 0, zn._loadRGBA(), zn._loadQuadruplet(), zn;
  }
  from(Xn) {
    this.r = Xn.r, this.g = Xn.g, this.b = Xn.b, this.a = Xn.a, this.uint32 = Xn.uint32, this.rgba[0] = Xn.r, this.rgba[1] = Xn.g, this.rgba[2] = Xn.b, this.rgba[3] = Xn.a;
  }
  getLuminosity(Xn) {
    let zn = this.r, Un = this.g, Kn = this.b;
    return Xn && (zn = Math.min(255, 255 - this.a + this.a * zn / 255), Un = Math.min(255, 255 - this.a + this.a * Un / 255), Kn = Math.min(255, 255 - this.a + this.a * Kn / 255)), 0.2126 * zn + 0.7152 * Un + 0.0722 * Kn;
  }
  _loadUINT32() {
    this.uint32 = (this.a << 24 | this.b << 16 | this.g << 8 | this.r) >>> 0;
  }
  _loadRGBA() {
    this.r = 255 & this.uint32, this.g = this.uint32 >>> 8 & 255, this.b = this.uint32 >>> 16 & 255, this.a = this.uint32 >>> 24 & 255;
  }
  _loadQuadruplet() {
    this.rgba[0] = this.r, this.rgba[1] = this.g, this.rgba[2] = this.b, this.rgba[3] = this.a;
  }
}, PointContainer$1 = class {
  constructor() {
    __publicField$3(this, "_pointArray"), __publicField$3(this, "_width"), __publicField$3(this, "_height"), this._width = 0, this._height = 0, this._pointArray = [];
  }
  getWidth() {
    return this._width;
  }
  getHeight() {
    return this._height;
  }
  setWidth(Xn) {
    this._width = Xn;
  }
  setHeight(Xn) {
    this._height = Xn;
  }
  getPointArray() {
    return this._pointArray;
  }
  clone() {
    const Xn = new PointContainer$1();
    Xn._width = this._width, Xn._height = this._height;
    for (let zn = 0, Un = this._pointArray.length; zn < Un; zn++) Xn._pointArray[zn] = Point$1.createByUint32(0 | this._pointArray[zn].uint32);
    return Xn;
  }
  toUint32Array() {
    const Xn = this._pointArray.length, zn = new Uint32Array(Xn);
    for (let Un = 0; Un < Xn; Un++) zn[Un] = this._pointArray[Un].uint32;
    return zn;
  }
  toUint8Array() {
    return new Uint8Array(this.toUint32Array().buffer);
  }
  static fromHTMLImageElement(Xn) {
    const zn = Xn.naturalWidth, Un = Xn.naturalHeight, Kn = document.createElement("canvas");
    return Kn.width = zn, Kn.height = Un, Kn.getContext("2d").drawImage(Xn, 0, 0, zn, Un, 0, 0, zn, Un), PointContainer$1.fromHTMLCanvasElement(Kn);
  }
  static fromHTMLCanvasElement(Xn) {
    const zn = Xn.width, Un = Xn.height, Kn = Xn.getContext("2d").getImageData(0, 0, zn, Un);
    return PointContainer$1.fromImageData(Kn);
  }
  static fromImageData(Xn) {
    const zn = Xn.width, Un = Xn.height;
    return PointContainer$1.fromUint8Array(Xn.data, zn, Un);
  }
  static fromUint8Array(Xn, zn, Un) {
    switch (Object.prototype.toString.call(Xn)) {
      case "[object Uint8ClampedArray]":
      case "[object Uint8Array]":
        break;
      default:
        Xn = new Uint8Array(Xn);
    }
    const Kn = new Uint32Array(Xn.buffer);
    return PointContainer$1.fromUint32Array(Kn, zn, Un);
  }
  static fromUint32Array(Xn, zn, Un) {
    const Kn = new PointContainer$1();
    Kn._width = zn, Kn._height = Un;
    for (let qn = 0, Jo = Xn.length; qn < Jo; qn++) Kn._pointArray[qn] = Point$1.createByUint32(0 | Xn[qn]);
    return Kn;
  }
  static fromBuffer(Xn, zn, Un) {
    const Kn = new Uint32Array(Xn.buffer, Xn.byteOffset, Xn.byteLength / Uint32Array.BYTES_PER_ELEMENT);
    return PointContainer$1.fromUint32Array(Kn, zn, Un);
  }
}, hueGroups$1 = 10;
function hueGroup$1(Xn, zn) {
  const Un = 360 / zn;
  for (let Kn = 1, qn = Un - Un / 2; Kn < zn; Kn++, qn += Un) if (Xn >= qn && Xn < qn + Un) return Kn;
  return 0;
}
var Palette$1 = class {
  constructor() {
    __publicField$3(this, "_pointContainer"), __publicField$3(this, "_pointArray", []), __publicField$3(this, "_i32idx", {}), this._pointContainer = new PointContainer$1(), this._pointContainer.setHeight(1), this._pointArray = this._pointContainer.getPointArray();
  }
  add(Xn) {
    this._pointArray.push(Xn), this._pointContainer.setWidth(this._pointArray.length);
  }
  has(Xn) {
    for (let zn = this._pointArray.length - 1; zn >= 0; zn--) if (Xn.uint32 === this._pointArray[zn].uint32) return !0;
    return !1;
  }
  getNearestColor(Xn, zn) {
    return this._pointArray[0 | this._getNearestIndex(Xn, zn)];
  }
  getPointContainer() {
    return this._pointContainer;
  }
  _nearestPointFromCache(Xn) {
    return typeof this._i32idx[Xn] == "number" ? this._i32idx[Xn] : -1;
  }
  _getNearestIndex(Xn, zn) {
    let Un = this._nearestPointFromCache("" + zn.uint32);
    if (Un >= 0) return Un;
    let Kn = Number.MAX_VALUE;
    Un = 0;
    for (let qn = 0, Jo = this._pointArray.length; qn < Jo; qn++) {
      const pa = this._pointArray[qn], ma = Xn.calculateRaw(zn.r, zn.g, zn.b, zn.a, pa.r, pa.g, pa.b, pa.a);
      ma < Kn && (Kn = ma, Un = qn);
    }
    return this._i32idx[zn.uint32] = Un, Un;
  }
  sort() {
    this._i32idx = {}, this._pointArray.sort((Xn, zn) => {
      const Un = rgb2hsl$1(Xn.r, Xn.g, Xn.b), Kn = rgb2hsl$1(zn.r, zn.g, zn.b), qn = Xn.r === Xn.g && Xn.g === Xn.b ? 0 : 1 + hueGroup$1(Un.h, hueGroups$1), Jo = (zn.r === zn.g && zn.g === zn.b ? 0 : 1 + hueGroup$1(Kn.h, hueGroups$1)) - qn;
      if (Jo) return -Jo;
      const pa = Xn.getLuminosity(!0), ma = zn.getLuminosity(!0);
      if (ma - pa != 0) return ma - pa;
      const va = (100 * Kn.s | 0) - (100 * Un.s | 0);
      return va ? -va : 0;
    });
  }
}, utils_exports$1 = {};
__export$1(utils_exports$1, { HueStatistics: () => HueStatistics$1, Palette: () => Palette$1, Point: () => Point$1, PointContainer: () => PointContainer$1, ProgressTracker: () => ProgressTracker$1, arithmetic: () => arithmetic_exports$1 });
var HueGroup$1 = class {
  constructor() {
    __publicField$3(this, "num", 0), __publicField$3(this, "cols", []);
  }
}, HueStatistics$1 = class {
  constructor(Xn, zn) {
    __publicField$3(this, "_numGroups"), __publicField$3(this, "_minCols"), __publicField$3(this, "_stats"), __publicField$3(this, "_groupsFull"), this._numGroups = Xn, this._minCols = zn, this._stats = [];
    for (let Un = 0; Un <= Xn; Un++) this._stats[Un] = new HueGroup$1();
    this._groupsFull = 0;
  }
  check(Xn) {
    this._groupsFull === this._numGroups + 1 && (this.check = () => {
    });
    const zn = 255 & Xn, Un = Xn >>> 8 & 255, Kn = Xn >>> 16 & 255, qn = zn === Un && Un === Kn ? 0 : 1 + hueGroup$1(rgb2hsl$1(zn, Un, Kn).h, this._numGroups), Jo = this._stats[qn], pa = this._minCols;
    Jo.num++, Jo.num > pa || (Jo.num === pa && this._groupsFull++, Jo.num <= pa && this._stats[qn].cols.push(Xn));
  }
  injectIntoDictionary(Xn) {
    for (let zn = 0; zn <= this._numGroups; zn++) this._stats[zn].num <= this._minCols && this._stats[zn].cols.forEach((Un) => {
      Xn[Un] ? Xn[Un]++ : Xn[Un] = 1;
    });
  }
  injectIntoArray(Xn) {
    for (let zn = 0; zn <= this._numGroups; zn++) this._stats[zn].num <= this._minCols && this._stats[zn].cols.forEach((Un) => {
      Xn.indexOf(Un) === -1 && Xn.push(Un);
    });
  }
}, _ProgressTracker$1 = class {
  constructor(Xn, zn) {
    __publicField$3(this, "progress"), __publicField$3(this, "_step"), __publicField$3(this, "_range"), __publicField$3(this, "_last"), __publicField$3(this, "_progressRange"), this._range = Xn, this._progressRange = zn, this._step = Math.max(1, this._range / (_ProgressTracker$1.steps + 1) | 0), this._last = -this._step, this.progress = 0;
  }
  shouldNotify(Xn) {
    return Xn - this._last >= this._step && (this._last = Xn, this.progress = Math.min(this._progressRange * this._last / this._range, this._progressRange), !0);
  }
}, ProgressTracker$1 = _ProgressTracker$1;
__publicField$3(ProgressTracker$1, "steps", 100);
var networkBiasShift$1 = 3, Neuron$1 = class {
  constructor(Xn) {
    __publicField$3(this, "r"), __publicField$3(this, "g"), __publicField$3(this, "b"), __publicField$3(this, "a"), this.r = this.g = this.b = this.a = Xn;
  }
  toPoint() {
    return Point$1.createByRGBA(this.r >> networkBiasShift$1, this.g >> networkBiasShift$1, this.b >> networkBiasShift$1, this.a >> networkBiasShift$1);
  }
  subtract(Xn, zn, Un, Kn) {
    this.r -= 0 | Xn, this.g -= 0 | zn, this.b -= 0 | Un, this.a -= 0 | Kn;
  }
}, _NeuQuant$1 = class extends AbstractPaletteQuantizer$1 {
  constructor(Xn, zn = 256) {
    super(), __publicField$3(this, "_pointArray"), __publicField$3(this, "_networkSize"), __publicField$3(this, "_network"), __publicField$3(this, "_sampleFactor"), __publicField$3(this, "_radPower"), __publicField$3(this, "_freq"), __publicField$3(this, "_bias"), __publicField$3(this, "_distance"), this._distance = Xn, this._pointArray = [], this._sampleFactor = 1, this._networkSize = zn, this._distance.setWhitePoint(255 << networkBiasShift$1, 255 << networkBiasShift$1, 255 << networkBiasShift$1, 255 << networkBiasShift$1);
  }
  sample(Xn) {
    this._pointArray = this._pointArray.concat(Xn.getPointArray());
  }
  *quantize() {
    this._init(), yield* this._learn(), yield { palette: this._buildPalette(), progress: 100 };
  }
  _init() {
    this._freq = [], this._bias = [], this._radPower = [], this._network = [];
    for (let Xn = 0; Xn < this._networkSize; Xn++) this._network[Xn] = new Neuron$1((Xn << networkBiasShift$1 + 8) / this._networkSize | 0), this._freq[Xn] = _NeuQuant$1._initialBias / this._networkSize | 0, this._bias[Xn] = 0;
  }
  *_learn() {
    let Xn = this._sampleFactor;
    const zn = this._pointArray.length;
    zn < _NeuQuant$1._minpicturebytes && (Xn = 1);
    const Un = 30 + (Xn - 1) / 3 | 0, Kn = zn / Xn | 0;
    let qn, Jo = Kn / _NeuQuant$1._nCycles | 0, pa = _NeuQuant$1._initAlpha, ma = (this._networkSize >> 3) * _NeuQuant$1._radiusBias, va = ma >> _NeuQuant$1._radiusBiasShift;
    va <= 1 && (va = 0);
    for (let _a = 0; _a < va; _a++) this._radPower[_a] = pa * ((va * va - _a * _a) * _NeuQuant$1._radBias / (va * va)) >>> 0;
    qn = zn < _NeuQuant$1._minpicturebytes ? 1 : zn % _NeuQuant$1._prime1 != 0 ? _NeuQuant$1._prime1 : zn % _NeuQuant$1._prime2 != 0 ? _NeuQuant$1._prime2 : zn % _NeuQuant$1._prime3 != 0 ? _NeuQuant$1._prime3 : _NeuQuant$1._prime4;
    const ba = new ProgressTracker$1(Kn, 99);
    for (let _a = 0, ya = 0; _a < Kn; ) {
      ba.shouldNotify(_a) && (yield { progress: ba.progress });
      const xa = this._pointArray[ya], wa = xa.b << networkBiasShift$1, Ta = xa.g << networkBiasShift$1, Sa = xa.r << networkBiasShift$1, Ma = xa.a << networkBiasShift$1, ka = this._contest(wa, Ta, Sa, Ma);
      if (this._alterSingle(pa, ka, wa, Ta, Sa, Ma), va !== 0 && this._alterNeighbour(va, ka, wa, Ta, Sa, Ma), ya += qn, ya >= zn && (ya -= zn), _a++, Jo === 0 && (Jo = 1), _a % Jo == 0) {
        pa -= pa / Un | 0, ma -= ma / _NeuQuant$1._radiusDecrease | 0, va = ma >> _NeuQuant$1._radiusBiasShift, va <= 1 && (va = 0);
        for (let Za = 0; Za < va; Za++) this._radPower[Za] = pa * ((va * va - Za * Za) * _NeuQuant$1._radBias / (va * va)) >>> 0;
      }
    }
  }
  _buildPalette() {
    const Xn = new Palette$1();
    return this._network.forEach((zn) => {
      Xn.add(zn.toPoint());
    }), Xn.sort(), Xn;
  }
  _alterNeighbour(Xn, zn, Un, Kn, qn, Jo) {
    let pa = zn - Xn;
    pa < -1 && (pa = -1);
    let ma = zn + Xn;
    ma > this._networkSize && (ma = this._networkSize);
    let va = zn + 1, ba = zn - 1, _a = 1;
    for (; va < ma || ba > pa; ) {
      const ya = this._radPower[_a++] / _NeuQuant$1._alphaRadBias;
      if (va < ma) {
        const xa = this._network[va++];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
      if (ba > pa) {
        const xa = this._network[ba--];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
    }
  }
  _alterSingle(Xn, zn, Un, Kn, qn, Jo) {
    Xn /= _NeuQuant$1._initAlpha;
    const pa = this._network[zn];
    pa.subtract(Xn * (pa.r - qn), Xn * (pa.g - Kn), Xn * (pa.b - Un), Xn * (pa.a - Jo));
  }
  _contest(Xn, zn, Un, Kn) {
    const qn = 1020 << networkBiasShift$1;
    let Jo = 2147483647, pa = Jo, ma = -1, va = ma;
    for (let ba = 0; ba < this._networkSize; ba++) {
      const _a = this._network[ba], ya = this._distance.calculateNormalized(_a, { r: Un, g: zn, b: Xn, a: Kn }) * qn | 0;
      ya < Jo && (Jo = ya, ma = ba);
      const xa = ya - (this._bias[ba] >> _NeuQuant$1._initialBiasShift - networkBiasShift$1);
      xa < pa && (pa = xa, va = ba);
      const wa = this._freq[ba] >> _NeuQuant$1._betaShift;
      this._freq[ba] -= wa, this._bias[ba] += wa << _NeuQuant$1._gammaShift;
    }
    return this._freq[ma] += _NeuQuant$1._beta, this._bias[ma] -= _NeuQuant$1._betaGamma, va;
  }
}, NeuQuant$1 = _NeuQuant$1;
__publicField$3(NeuQuant$1, "_prime1", 499), __publicField$3(NeuQuant$1, "_prime2", 491), __publicField$3(NeuQuant$1, "_prime3", 487), __publicField$3(NeuQuant$1, "_prime4", 503), __publicField$3(NeuQuant$1, "_minpicturebytes", _NeuQuant$1._prime4), __publicField$3(NeuQuant$1, "_nCycles", 100), __publicField$3(NeuQuant$1, "_initialBiasShift", 16), __publicField$3(NeuQuant$1, "_initialBias", 1 << _NeuQuant$1._initialBiasShift), __publicField$3(NeuQuant$1, "_gammaShift", 10), __publicField$3(NeuQuant$1, "_betaShift", 10), __publicField$3(NeuQuant$1, "_beta", _NeuQuant$1._initialBias >> _NeuQuant$1._betaShift), __publicField$3(NeuQuant$1, "_betaGamma", _NeuQuant$1._initialBias << _NeuQuant$1._gammaShift - _NeuQuant$1._betaShift), __publicField$3(NeuQuant$1, "_radiusBiasShift", 6), __publicField$3(NeuQuant$1, "_radiusBias", 1 << _NeuQuant$1._radiusBiasShift), __publicField$3(NeuQuant$1, "_radiusDecrease", 30), __publicField$3(NeuQuant$1, "_alphaBiasShift", 10), __publicField$3(NeuQuant$1, "_initAlpha", 1 << _NeuQuant$1._alphaBiasShift), __publicField$3(NeuQuant$1, "_radBiasShift", 8), __publicField$3(NeuQuant$1, "_radBias", 1 << _NeuQuant$1._radBiasShift), __publicField$3(NeuQuant$1, "_alphaRadBiasShift", _NeuQuant$1._alphaBiasShift + _NeuQuant$1._radBiasShift), __publicField$3(NeuQuant$1, "_alphaRadBias", 1 << _NeuQuant$1._alphaRadBiasShift);
var networkBiasShift2$1 = 3, NeuronFloat$1 = class {
  constructor(Xn) {
    __publicField$3(this, "r"), __publicField$3(this, "g"), __publicField$3(this, "b"), __publicField$3(this, "a"), this.r = this.g = this.b = this.a = Xn;
  }
  toPoint() {
    return Point$1.createByRGBA(this.r >> networkBiasShift2$1, this.g >> networkBiasShift2$1, this.b >> networkBiasShift2$1, this.a >> networkBiasShift2$1);
  }
  subtract(Xn, zn, Un, Kn) {
    this.r -= Xn, this.g -= zn, this.b -= Un, this.a -= Kn;
  }
}, _NeuQuantFloat$1 = class extends AbstractPaletteQuantizer$1 {
  constructor(Xn, zn = 256) {
    super(), __publicField$3(this, "_pointArray"), __publicField$3(this, "_networkSize"), __publicField$3(this, "_network"), __publicField$3(this, "_sampleFactor"), __publicField$3(this, "_radPower"), __publicField$3(this, "_freq"), __publicField$3(this, "_bias"), __publicField$3(this, "_distance"), this._distance = Xn, this._pointArray = [], this._sampleFactor = 1, this._networkSize = zn, this._distance.setWhitePoint(255 << networkBiasShift2$1, 255 << networkBiasShift2$1, 255 << networkBiasShift2$1, 255 << networkBiasShift2$1);
  }
  sample(Xn) {
    this._pointArray = this._pointArray.concat(Xn.getPointArray());
  }
  *quantize() {
    this._init(), yield* this._learn(), yield { palette: this._buildPalette(), progress: 100 };
  }
  _init() {
    this._freq = [], this._bias = [], this._radPower = [], this._network = [];
    for (let Xn = 0; Xn < this._networkSize; Xn++) this._network[Xn] = new NeuronFloat$1((Xn << networkBiasShift2$1 + 8) / this._networkSize), this._freq[Xn] = _NeuQuantFloat$1._initialBias / this._networkSize, this._bias[Xn] = 0;
  }
  *_learn() {
    let Xn = this._sampleFactor;
    const zn = this._pointArray.length;
    zn < _NeuQuantFloat$1._minpicturebytes && (Xn = 1);
    const Un = 30 + (Xn - 1) / 3, Kn = zn / Xn;
    let qn, Jo = Kn / _NeuQuantFloat$1._nCycles | 0, pa = _NeuQuantFloat$1._initAlpha, ma = (this._networkSize >> 3) * _NeuQuantFloat$1._radiusBias, va = ma >> _NeuQuantFloat$1._radiusBiasShift;
    va <= 1 && (va = 0);
    for (let _a = 0; _a < va; _a++) this._radPower[_a] = pa * ((va * va - _a * _a) * _NeuQuantFloat$1._radBias / (va * va));
    qn = zn < _NeuQuantFloat$1._minpicturebytes ? 1 : zn % _NeuQuantFloat$1._prime1 != 0 ? _NeuQuantFloat$1._prime1 : zn % _NeuQuantFloat$1._prime2 != 0 ? _NeuQuantFloat$1._prime2 : zn % _NeuQuantFloat$1._prime3 != 0 ? _NeuQuantFloat$1._prime3 : _NeuQuantFloat$1._prime4;
    const ba = new ProgressTracker$1(Kn, 99);
    for (let _a = 0, ya = 0; _a < Kn; ) {
      ba.shouldNotify(_a) && (yield { progress: ba.progress });
      const xa = this._pointArray[ya], wa = xa.b << networkBiasShift2$1, Ta = xa.g << networkBiasShift2$1, Sa = xa.r << networkBiasShift2$1, Ma = xa.a << networkBiasShift2$1, ka = this._contest(wa, Ta, Sa, Ma);
      if (this._alterSingle(pa, ka, wa, Ta, Sa, Ma), va !== 0 && this._alterNeighbour(va, ka, wa, Ta, Sa, Ma), ya += qn, ya >= zn && (ya -= zn), _a++, Jo === 0 && (Jo = 1), _a % Jo == 0) {
        pa -= pa / Un, ma -= ma / _NeuQuantFloat$1._radiusDecrease, va = ma >> _NeuQuantFloat$1._radiusBiasShift, va <= 1 && (va = 0);
        for (let Za = 0; Za < va; Za++) this._radPower[Za] = pa * ((va * va - Za * Za) * _NeuQuantFloat$1._radBias / (va * va));
      }
    }
  }
  _buildPalette() {
    const Xn = new Palette$1();
    return this._network.forEach((zn) => {
      Xn.add(zn.toPoint());
    }), Xn.sort(), Xn;
  }
  _alterNeighbour(Xn, zn, Un, Kn, qn, Jo) {
    let pa = zn - Xn;
    pa < -1 && (pa = -1);
    let ma = zn + Xn;
    ma > this._networkSize && (ma = this._networkSize);
    let va = zn + 1, ba = zn - 1, _a = 1;
    for (; va < ma || ba > pa; ) {
      const ya = this._radPower[_a++] / _NeuQuantFloat$1._alphaRadBias;
      if (va < ma) {
        const xa = this._network[va++];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
      if (ba > pa) {
        const xa = this._network[ba--];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
    }
  }
  _alterSingle(Xn, zn, Un, Kn, qn, Jo) {
    Xn /= _NeuQuantFloat$1._initAlpha;
    const pa = this._network[zn];
    pa.subtract(Xn * (pa.r - qn), Xn * (pa.g - Kn), Xn * (pa.b - Un), Xn * (pa.a - Jo));
  }
  _contest(Xn, zn, Un, Kn) {
    const qn = 1020 << networkBiasShift2$1;
    let Jo = 2147483647, pa = Jo, ma = -1, va = ma;
    for (let ba = 0; ba < this._networkSize; ba++) {
      const _a = this._network[ba], ya = this._distance.calculateNormalized(_a, { r: Un, g: zn, b: Xn, a: Kn }) * qn;
      ya < Jo && (Jo = ya, ma = ba);
      const xa = ya - (this._bias[ba] >> _NeuQuantFloat$1._initialBiasShift - networkBiasShift2$1);
      xa < pa && (pa = xa, va = ba);
      const wa = this._freq[ba] >> _NeuQuantFloat$1._betaShift;
      this._freq[ba] -= wa, this._bias[ba] += wa << _NeuQuantFloat$1._gammaShift;
    }
    return this._freq[ma] += _NeuQuantFloat$1._beta, this._bias[ma] -= _NeuQuantFloat$1._betaGamma, va;
  }
}, NeuQuantFloat$1 = _NeuQuantFloat$1;
__publicField$3(NeuQuantFloat$1, "_prime1", 499), __publicField$3(NeuQuantFloat$1, "_prime2", 491), __publicField$3(NeuQuantFloat$1, "_prime3", 487), __publicField$3(NeuQuantFloat$1, "_prime4", 503), __publicField$3(NeuQuantFloat$1, "_minpicturebytes", _NeuQuantFloat$1._prime4), __publicField$3(NeuQuantFloat$1, "_nCycles", 100), __publicField$3(NeuQuantFloat$1, "_initialBiasShift", 16), __publicField$3(NeuQuantFloat$1, "_initialBias", 1 << _NeuQuantFloat$1._initialBiasShift), __publicField$3(NeuQuantFloat$1, "_gammaShift", 10), __publicField$3(NeuQuantFloat$1, "_betaShift", 10), __publicField$3(NeuQuantFloat$1, "_beta", _NeuQuantFloat$1._initialBias >> _NeuQuantFloat$1._betaShift), __publicField$3(NeuQuantFloat$1, "_betaGamma", _NeuQuantFloat$1._initialBias << _NeuQuantFloat$1._gammaShift - _NeuQuantFloat$1._betaShift), __publicField$3(NeuQuantFloat$1, "_radiusBiasShift", 6), __publicField$3(NeuQuantFloat$1, "_radiusBias", 1 << _NeuQuantFloat$1._radiusBiasShift), __publicField$3(NeuQuantFloat$1, "_radiusDecrease", 30), __publicField$3(NeuQuantFloat$1, "_alphaBiasShift", 10), __publicField$3(NeuQuantFloat$1, "_initAlpha", 1 << _NeuQuantFloat$1._alphaBiasShift), __publicField$3(NeuQuantFloat$1, "_radBiasShift", 8), __publicField$3(NeuQuantFloat$1, "_radBias", 1 << _NeuQuantFloat$1._radBiasShift), __publicField$3(NeuQuantFloat$1, "_alphaRadBiasShift", _NeuQuantFloat$1._alphaBiasShift + _NeuQuantFloat$1._radBiasShift), __publicField$3(NeuQuantFloat$1, "_alphaRadBias", 1 << _NeuQuantFloat$1._alphaRadBiasShift);
var _ColorHistogram$1 = class {
  constructor(Xn, zn) {
    __publicField$3(this, "_method"), __publicField$3(this, "_hueStats"), __publicField$3(this, "_histogram"), __publicField$3(this, "_initColors"), __publicField$3(this, "_minHueCols"), this._method = Xn, this._minHueCols = zn << 2, this._initColors = zn << 2, this._hueStats = new HueStatistics$1(_ColorHistogram$1._hueGroups, this._minHueCols), this._histogram = /* @__PURE__ */ Object.create(null);
  }
  sample(Xn) {
    switch (this._method) {
      case 1:
        this._colorStats1D(Xn);
        break;
      case 2:
        this._colorStats2D(Xn);
    }
  }
  getImportanceSortedColorsIDXI32() {
    const Xn = stableSort$1(Object.keys(this._histogram), (Un, Kn) => this._histogram[Kn] - this._histogram[Un]);
    if (Xn.length === 0) return [];
    let zn;
    switch (this._method) {
      case 1:
        const Un = Math.min(Xn.length, this._initColors), Kn = Xn[Un - 1], qn = this._histogram[Kn];
        zn = Xn.slice(0, Un);
        let Jo = Un;
        const pa = Xn.length;
        for (; Jo < pa && this._histogram[Xn[Jo]] === qn; ) zn.push(Xn[Jo++]);
        this._hueStats.injectIntoArray(zn);
        break;
      case 2:
        zn = Xn;
        break;
      default:
        throw new Error("Incorrect method");
    }
    return zn.map((Un) => +Un);
  }
  _colorStats1D(Xn) {
    const zn = this._histogram, Un = Xn.getPointArray(), Kn = Un.length;
    for (let qn = 0; qn < Kn; qn++) {
      const Jo = Un[qn].uint32;
      this._hueStats.check(Jo), Jo in zn ? zn[Jo]++ : zn[Jo] = 1;
    }
  }
  _colorStats2D(Xn) {
    const zn = Xn.getWidth(), Un = Xn.getHeight(), Kn = Xn.getPointArray(), qn = _ColorHistogram$1._boxSize[0], Jo = _ColorHistogram$1._boxSize[1], pa = qn * Jo, ma = this._makeBoxes(zn, Un, qn, Jo), va = this._histogram;
    ma.forEach((ba) => {
      let _a = Math.round(ba.w * ba.h / pa) * _ColorHistogram$1._boxPixels;
      _a < 2 && (_a = 2);
      const ya = {};
      this._iterateBox(ba, zn, (xa) => {
        const wa = Kn[xa].uint32;
        this._hueStats.check(wa), wa in va ? va[wa]++ : wa in ya ? ++ya[wa] >= _a && (va[wa] = ya[wa]) : ya[wa] = 1;
      });
    }), this._hueStats.injectIntoDictionary(va);
  }
  _iterateBox(Xn, zn, Un) {
    const Kn = Xn, qn = Kn.y * zn + Kn.x, Jo = (Kn.y + Kn.h - 1) * zn + (Kn.x + Kn.w - 1), pa = zn - Kn.w + 1;
    let ma = 0, va = qn;
    do
      Un.call(this, va), va += ++ma % Kn.w == 0 ? pa : 1;
    while (va <= Jo);
  }
  _makeBoxes(Xn, zn, Un, Kn) {
    const qn = Xn % Un, Jo = zn % Kn, pa = Xn - qn, ma = zn - Jo, va = [];
    for (let ba = 0; ba < zn; ba += Kn) for (let _a = 0; _a < Xn; _a += Un) va.push({ x: _a, y: ba, w: _a === pa ? qn : Un, h: ba === ma ? Jo : Kn });
    return va;
  }
}, ColorHistogram$1 = _ColorHistogram$1;
__publicField$3(ColorHistogram$1, "_boxSize", [64, 64]), __publicField$3(ColorHistogram$1, "_boxPixels", 2), __publicField$3(ColorHistogram$1, "_hueGroups", 10);
var RemovedColor$1 = class {
  constructor(Xn, zn, Un) {
    __publicField$3(this, "index"), __publicField$3(this, "color"), __publicField$3(this, "distance"), this.index = Xn, this.color = zn, this.distance = Un;
  }
}, RGBQuant$1 = class extends AbstractPaletteQuantizer$1 {
  constructor(Xn, zn = 256, Un = 2) {
    super(), __publicField$3(this, "_colors"), __publicField$3(this, "_initialDistance"), __publicField$3(this, "_distanceIncrement"), __publicField$3(this, "_histogram"), __publicField$3(this, "_distance"), this._distance = Xn, this._colors = zn, this._histogram = new ColorHistogram$1(Un, zn), this._initialDistance = 0.01, this._distanceIncrement = 5e-3;
  }
  sample(Xn) {
    this._histogram.sample(Xn);
  }
  *quantize() {
    const Xn = this._histogram.getImportanceSortedColorsIDXI32();
    if (Xn.length === 0) throw new Error("No colors in image");
    yield* this._buildPalette(Xn);
  }
  *_buildPalette(Xn) {
    const zn = new Palette$1(), Un = zn.getPointContainer().getPointArray(), Kn = new Array(Xn.length);
    for (let _a = 0; _a < Xn.length; _a++) Un.push(Point$1.createByUint32(Xn[_a])), Kn[_a] = 1;
    const qn = Un.length, Jo = [];
    let pa = qn, ma = this._initialDistance;
    const va = new ProgressTracker$1(pa - this._colors, 99);
    for (; pa > this._colors; ) {
      Jo.length = 0;
      for (let _a = 0; _a < qn; _a++) {
        if (va.shouldNotify(qn - pa) && (yield { progress: va.progress }), Kn[_a] === 0) continue;
        const ya = Un[_a];
        for (let xa = _a + 1; xa < qn; xa++) {
          if (Kn[xa] === 0) continue;
          const wa = Un[xa], Ta = this._distance.calculateNormalized(ya, wa);
          Ta < ma && (Jo.push(new RemovedColor$1(xa, wa, Ta)), Kn[xa] = 0, pa--);
        }
      }
      ma += pa > 3 * this._colors ? this._initialDistance : this._distanceIncrement;
    }
    if (pa < this._colors) {
      stableSort$1(Jo, (ya, xa) => xa.distance - ya.distance);
      let _a = 0;
      for (; pa < this._colors && _a < Jo.length; )
        Kn[Jo[_a].index] = 1, pa++, _a++;
    }
    let ba = Un.length;
    for (let _a = ba - 1; _a >= 0; _a--) Kn[_a] === 0 && (_a !== ba - 1 && (Un[_a] = Un[ba - 1]), --ba);
    Un.length = ba, zn.sort(), yield { palette: zn, progress: 100 };
  }
};
function createArray1D$1(Xn) {
  const zn = [];
  for (let Un = 0; Un < Xn; Un++) zn[Un] = 0;
  return zn;
}
function createArray4D$1(Xn, zn, Un, Kn) {
  const qn = new Array(Xn);
  for (let Jo = 0; Jo < Xn; Jo++) {
    qn[Jo] = new Array(zn);
    for (let pa = 0; pa < zn; pa++) {
      qn[Jo][pa] = new Array(Un);
      for (let ma = 0; ma < Un; ma++) {
        qn[Jo][pa][ma] = new Array(Kn);
        for (let va = 0; va < Kn; va++) qn[Jo][pa][ma][va] = 0;
      }
    }
  }
  return qn;
}
function createArray3D$1(Xn, zn, Un) {
  const Kn = new Array(Xn);
  for (let qn = 0; qn < Xn; qn++) {
    Kn[qn] = new Array(zn);
    for (let Jo = 0; Jo < zn; Jo++) {
      Kn[qn][Jo] = new Array(Un);
      for (let pa = 0; pa < Un; pa++) Kn[qn][Jo][pa] = 0;
    }
  }
  return Kn;
}
function fillArray3D$1(Xn, zn, Un, Kn, qn) {
  for (let Jo = 0; Jo < zn; Jo++) {
    Xn[Jo] = [];
    for (let pa = 0; pa < Un; pa++) {
      Xn[Jo][pa] = [];
      for (let ma = 0; ma < Kn; ma++) Xn[Jo][pa][ma] = qn;
    }
  }
}
function fillArray1D$1(Xn, zn, Un) {
  for (let Kn = 0; Kn < zn; Kn++) Xn[Kn] = Un;
}
var WuColorCube$1 = class {
  constructor() {
    __publicField$3(this, "redMinimum"), __publicField$3(this, "redMaximum"), __publicField$3(this, "greenMinimum"), __publicField$3(this, "greenMaximum"), __publicField$3(this, "blueMinimum"), __publicField$3(this, "blueMaximum"), __publicField$3(this, "volume"), __publicField$3(this, "alphaMinimum"), __publicField$3(this, "alphaMaximum");
  }
}, _WuQuant$1 = class extends AbstractPaletteQuantizer$1 {
  constructor(Xn, zn = 256, Un = 5) {
    super(), __publicField$3(this, "_reds"), __publicField$3(this, "_greens"), __publicField$3(this, "_blues"), __publicField$3(this, "_alphas"), __publicField$3(this, "_sums"), __publicField$3(this, "_weights"), __publicField$3(this, "_momentsRed"), __publicField$3(this, "_momentsGreen"), __publicField$3(this, "_momentsBlue"), __publicField$3(this, "_momentsAlpha"), __publicField$3(this, "_moments"), __publicField$3(this, "_table"), __publicField$3(this, "_pixels"), __publicField$3(this, "_cubes"), __publicField$3(this, "_colors"), __publicField$3(this, "_significantBitsPerChannel"), __publicField$3(this, "_maxSideIndex"), __publicField$3(this, "_alphaMaxSideIndex"), __publicField$3(this, "_sideSize"), __publicField$3(this, "_alphaSideSize"), __publicField$3(this, "_distance"), this._distance = Xn, this._setQuality(Un), this._initialize(zn);
  }
  sample(Xn) {
    const zn = Xn.getPointArray();
    for (let Un = 0, Kn = zn.length; Un < Kn; Un++) this._addColor(zn[Un]);
    this._pixels = this._pixels.concat(zn);
  }
  *quantize() {
    yield* this._preparePalette();
    const Xn = new Palette$1();
    for (let zn = 0; zn < this._colors; zn++) if (this._sums[zn] > 0) {
      const Un = this._sums[zn], Kn = this._reds[zn] / Un, qn = this._greens[zn] / Un, Jo = this._blues[zn] / Un, pa = this._alphas[zn] / Un, ma = Point$1.createByRGBA(0 | Kn, 0 | qn, 0 | Jo, 0 | pa);
      Xn.add(ma);
    }
    Xn.sort(), yield { palette: Xn, progress: 100 };
  }
  *_preparePalette() {
    yield* this._calculateMoments();
    let Xn = 0;
    const zn = createArray1D$1(this._colors);
    for (let pa = 1; pa < this._colors; ++pa) {
      this._cut(this._cubes[Xn], this._cubes[pa]) ? (zn[Xn] = this._cubes[Xn].volume > 1 ? this._calculateVariance(this._cubes[Xn]) : 0, zn[pa] = this._cubes[pa].volume > 1 ? this._calculateVariance(this._cubes[pa]) : 0) : (zn[Xn] = 0, pa--), Xn = 0;
      let ma = zn[0];
      for (let va = 1; va <= pa; ++va) zn[va] > ma && (ma = zn[va], Xn = va);
      if (ma <= 0) {
        this._colors = pa + 1;
        break;
      }
    }
    const Un = [], Kn = [], qn = [], Jo = [];
    for (let pa = 0; pa < this._colors; ++pa) {
      const ma = _WuQuant$1._volume(this._cubes[pa], this._weights);
      ma > 0 ? (Un[pa] = _WuQuant$1._volume(this._cubes[pa], this._momentsRed) / ma | 0, Kn[pa] = _WuQuant$1._volume(this._cubes[pa], this._momentsGreen) / ma | 0, qn[pa] = _WuQuant$1._volume(this._cubes[pa], this._momentsBlue) / ma | 0, Jo[pa] = _WuQuant$1._volume(this._cubes[pa], this._momentsAlpha) / ma | 0) : (Un[pa] = 0, Kn[pa] = 0, qn[pa] = 0, Jo[pa] = 0);
    }
    this._reds = createArray1D$1(this._colors + 1), this._greens = createArray1D$1(this._colors + 1), this._blues = createArray1D$1(this._colors + 1), this._alphas = createArray1D$1(this._colors + 1), this._sums = createArray1D$1(this._colors + 1);
    for (let pa = 0, ma = this._pixels.length; pa < ma; pa++) {
      const va = this._pixels[pa];
      let ba = -1, _a = Number.MAX_VALUE;
      for (let ya = 0; ya < this._colors; ya++) {
        const xa = Un[ya], wa = Kn[ya], Ta = qn[ya], Sa = Jo[ya], Ma = this._distance.calculateRaw(xa, wa, Ta, Sa, va.r, va.g, va.b, va.a);
        Ma < _a && (_a = Ma, ba = ya);
      }
      this._reds[ba] += va.r, this._greens[ba] += va.g, this._blues[ba] += va.b, this._alphas[ba] += va.a, this._sums[ba]++;
    }
  }
  _addColor(Xn) {
    const zn = 8 - this._significantBitsPerChannel, Un = 1 + (Xn.r >> zn), Kn = 1 + (Xn.g >> zn), qn = 1 + (Xn.b >> zn), Jo = 1 + (Xn.a >> zn);
    this._weights[Jo][Un][Kn][qn]++, this._momentsRed[Jo][Un][Kn][qn] += Xn.r, this._momentsGreen[Jo][Un][Kn][qn] += Xn.g, this._momentsBlue[Jo][Un][Kn][qn] += Xn.b, this._momentsAlpha[Jo][Un][Kn][qn] += Xn.a, this._moments[Jo][Un][Kn][qn] += this._table[Xn.r] + this._table[Xn.g] + this._table[Xn.b] + this._table[Xn.a];
  }
  *_calculateMoments() {
    const Xn = [], zn = [], Un = [], Kn = [], qn = [], Jo = [], pa = createArray3D$1(this._sideSize, this._sideSize, this._sideSize), ma = createArray3D$1(this._sideSize, this._sideSize, this._sideSize), va = createArray3D$1(this._sideSize, this._sideSize, this._sideSize), ba = createArray3D$1(this._sideSize, this._sideSize, this._sideSize), _a = createArray3D$1(this._sideSize, this._sideSize, this._sideSize), ya = createArray3D$1(this._sideSize, this._sideSize, this._sideSize);
    let xa = 0;
    const wa = new ProgressTracker$1(this._alphaMaxSideIndex * this._maxSideIndex, 99);
    for (let Ta = 1; Ta <= this._alphaMaxSideIndex; ++Ta) {
      fillArray3D$1(pa, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D$1(ma, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D$1(va, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D$1(ba, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D$1(_a, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D$1(ya, this._sideSize, this._sideSize, this._sideSize, 0);
      for (let Sa = 1; Sa <= this._maxSideIndex; ++Sa, ++xa) {
        wa.shouldNotify(xa) && (yield { progress: wa.progress }), fillArray1D$1(Xn, this._sideSize, 0), fillArray1D$1(zn, this._sideSize, 0), fillArray1D$1(Un, this._sideSize, 0), fillArray1D$1(Kn, this._sideSize, 0), fillArray1D$1(qn, this._sideSize, 0), fillArray1D$1(Jo, this._sideSize, 0);
        for (let Ma = 1; Ma <= this._maxSideIndex; ++Ma) {
          let ka = 0, Za = 0, Na = 0, Ka = 0, Ja = 0, el = 0;
          for (let qa = 1; qa <= this._maxSideIndex; ++qa) ka += this._weights[Ta][Sa][Ma][qa], Za += this._momentsRed[Ta][Sa][Ma][qa], Na += this._momentsGreen[Ta][Sa][Ma][qa], Ka += this._momentsBlue[Ta][Sa][Ma][qa], Ja += this._momentsAlpha[Ta][Sa][Ma][qa], el += this._moments[Ta][Sa][Ma][qa], Xn[qa] += ka, zn[qa] += Za, Un[qa] += Na, Kn[qa] += Ka, qn[qa] += Ja, Jo[qa] += el, pa[Sa][Ma][qa] = pa[Sa - 1][Ma][qa] + Xn[qa], ma[Sa][Ma][qa] = ma[Sa - 1][Ma][qa] + zn[qa], va[Sa][Ma][qa] = va[Sa - 1][Ma][qa] + Un[qa], ba[Sa][Ma][qa] = ba[Sa - 1][Ma][qa] + Kn[qa], _a[Sa][Ma][qa] = _a[Sa - 1][Ma][qa] + qn[qa], ya[Sa][Ma][qa] = ya[Sa - 1][Ma][qa] + Jo[qa], this._weights[Ta][Sa][Ma][qa] = this._weights[Ta - 1][Sa][Ma][qa] + pa[Sa][Ma][qa], this._momentsRed[Ta][Sa][Ma][qa] = this._momentsRed[Ta - 1][Sa][Ma][qa] + ma[Sa][Ma][qa], this._momentsGreen[Ta][Sa][Ma][qa] = this._momentsGreen[Ta - 1][Sa][Ma][qa] + va[Sa][Ma][qa], this._momentsBlue[Ta][Sa][Ma][qa] = this._momentsBlue[Ta - 1][Sa][Ma][qa] + ba[Sa][Ma][qa], this._momentsAlpha[Ta][Sa][Ma][qa] = this._momentsAlpha[Ta - 1][Sa][Ma][qa] + _a[Sa][Ma][qa], this._moments[Ta][Sa][Ma][qa] = this._moments[Ta - 1][Sa][Ma][qa] + ya[Sa][Ma][qa];
        }
      }
    }
  }
  static _volumeFloat(Xn, zn) {
    return zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] - zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] - zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] + zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] + zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] + zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] - zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] - zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] - zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] - zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] - zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
  }
  static _volume(Xn, zn) {
    return 0 | _WuQuant$1._volumeFloat(Xn, zn);
  }
  static _top(Xn, zn, Un, Kn) {
    let qn;
    switch (zn) {
      case _WuQuant$1._alpha:
        qn = Kn[Un][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] - Kn[Un][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] - Kn[Un][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] + Kn[Un][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (Kn[Un][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] - Kn[Un][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] - Kn[Un][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + Kn[Un][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
        break;
      case _WuQuant$1._red:
        qn = Kn[Xn.alphaMaximum][Un][Xn.greenMaximum][Xn.blueMaximum] - Kn[Xn.alphaMaximum][Un][Xn.greenMinimum][Xn.blueMaximum] - Kn[Xn.alphaMinimum][Un][Xn.greenMaximum][Xn.blueMaximum] + Kn[Xn.alphaMinimum][Un][Xn.greenMinimum][Xn.blueMaximum] - (Kn[Xn.alphaMaximum][Un][Xn.greenMaximum][Xn.blueMinimum] - Kn[Xn.alphaMaximum][Un][Xn.greenMinimum][Xn.blueMinimum] - Kn[Xn.alphaMinimum][Un][Xn.greenMaximum][Xn.blueMinimum] + Kn[Xn.alphaMinimum][Un][Xn.greenMinimum][Xn.blueMinimum]);
        break;
      case _WuQuant$1._green:
        qn = Kn[Xn.alphaMaximum][Xn.redMaximum][Un][Xn.blueMaximum] - Kn[Xn.alphaMaximum][Xn.redMinimum][Un][Xn.blueMaximum] - Kn[Xn.alphaMinimum][Xn.redMaximum][Un][Xn.blueMaximum] + Kn[Xn.alphaMinimum][Xn.redMinimum][Un][Xn.blueMaximum] - (Kn[Xn.alphaMaximum][Xn.redMaximum][Un][Xn.blueMinimum] - Kn[Xn.alphaMaximum][Xn.redMinimum][Un][Xn.blueMinimum] - Kn[Xn.alphaMinimum][Xn.redMaximum][Un][Xn.blueMinimum] + Kn[Xn.alphaMinimum][Xn.redMinimum][Un][Xn.blueMinimum]);
        break;
      case _WuQuant$1._blue:
        qn = Kn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Un] - Kn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Un] - Kn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Un] + Kn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Un] - (Kn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Un] - Kn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Un] - Kn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Un] + Kn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Un]);
        break;
      default:
        throw new Error("impossible");
    }
    return 0 | qn;
  }
  static _bottom(Xn, zn, Un) {
    switch (zn) {
      case _WuQuant$1._alpha:
        return -Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (-Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      case _WuQuant$1._red:
        return -Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (-Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      case _WuQuant$1._green:
        return -Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (-Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      case _WuQuant$1._blue:
        return -Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] - (-Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      default:
        return 0;
    }
  }
  _calculateVariance(Xn) {
    const zn = _WuQuant$1._volume(Xn, this._momentsRed), Un = _WuQuant$1._volume(Xn, this._momentsGreen), Kn = _WuQuant$1._volume(Xn, this._momentsBlue), qn = _WuQuant$1._volume(Xn, this._momentsAlpha);
    return _WuQuant$1._volumeFloat(Xn, this._moments) - (zn * zn + Un * Un + Kn * Kn + qn * qn) / _WuQuant$1._volume(Xn, this._weights);
  }
  _maximize(Xn, zn, Un, Kn, qn, Jo, pa, ma, va) {
    const ba = 0 | _WuQuant$1._bottom(Xn, zn, this._momentsRed), _a = 0 | _WuQuant$1._bottom(Xn, zn, this._momentsGreen), ya = 0 | _WuQuant$1._bottom(Xn, zn, this._momentsBlue), xa = 0 | _WuQuant$1._bottom(Xn, zn, this._momentsAlpha), wa = 0 | _WuQuant$1._bottom(Xn, zn, this._weights);
    let Ta = 0, Sa = -1;
    for (let Ma = Un; Ma < Kn; ++Ma) {
      let ka = ba + _WuQuant$1._top(Xn, zn, Ma, this._momentsRed), Za = _a + _WuQuant$1._top(Xn, zn, Ma, this._momentsGreen), Na = ya + _WuQuant$1._top(Xn, zn, Ma, this._momentsBlue), Ka = xa + _WuQuant$1._top(Xn, zn, Ma, this._momentsAlpha), Ja = wa + _WuQuant$1._top(Xn, zn, Ma, this._weights);
      if (Ja !== 0) {
        let el = ka * ka + Za * Za + Na * Na + Ka * Ka, qa = el / Ja;
        ka = qn - ka, Za = Jo - Za, Na = pa - Na, Ka = ma - Ka, Ja = va - Ja, Ja !== 0 && (el = ka * ka + Za * Za + Na * Na + Ka * Ka, qa += el / Ja, qa > Ta && (Ta = qa, Sa = Ma));
      }
    }
    return { max: Ta, position: Sa };
  }
  _cut(Xn, zn) {
    let Un;
    const Kn = _WuQuant$1._volume(Xn, this._momentsRed), qn = _WuQuant$1._volume(Xn, this._momentsGreen), Jo = _WuQuant$1._volume(Xn, this._momentsBlue), pa = _WuQuant$1._volume(Xn, this._momentsAlpha), ma = _WuQuant$1._volume(Xn, this._weights), va = this._maximize(Xn, _WuQuant$1._red, Xn.redMinimum + 1, Xn.redMaximum, Kn, qn, Jo, pa, ma), ba = this._maximize(Xn, _WuQuant$1._green, Xn.greenMinimum + 1, Xn.greenMaximum, Kn, qn, Jo, pa, ma), _a = this._maximize(Xn, _WuQuant$1._blue, Xn.blueMinimum + 1, Xn.blueMaximum, Kn, qn, Jo, pa, ma), ya = this._maximize(Xn, _WuQuant$1._alpha, Xn.alphaMinimum + 1, Xn.alphaMaximum, Kn, qn, Jo, pa, ma);
    if (ya.max >= va.max && ya.max >= ba.max && ya.max >= _a.max) {
      if (Un = _WuQuant$1._alpha, ya.position < 0) return !1;
    } else Un = va.max >= ya.max && va.max >= ba.max && va.max >= _a.max ? _WuQuant$1._red : ba.max >= ya.max && ba.max >= va.max && ba.max >= _a.max ? _WuQuant$1._green : _WuQuant$1._blue;
    switch (zn.redMaximum = Xn.redMaximum, zn.greenMaximum = Xn.greenMaximum, zn.blueMaximum = Xn.blueMaximum, zn.alphaMaximum = Xn.alphaMaximum, Un) {
      case _WuQuant$1._red:
        zn.redMinimum = Xn.redMaximum = va.position, zn.greenMinimum = Xn.greenMinimum, zn.blueMinimum = Xn.blueMinimum, zn.alphaMinimum = Xn.alphaMinimum;
        break;
      case _WuQuant$1._green:
        zn.greenMinimum = Xn.greenMaximum = ba.position, zn.redMinimum = Xn.redMinimum, zn.blueMinimum = Xn.blueMinimum, zn.alphaMinimum = Xn.alphaMinimum;
        break;
      case _WuQuant$1._blue:
        zn.blueMinimum = Xn.blueMaximum = _a.position, zn.redMinimum = Xn.redMinimum, zn.greenMinimum = Xn.greenMinimum, zn.alphaMinimum = Xn.alphaMinimum;
        break;
      case _WuQuant$1._alpha:
        zn.alphaMinimum = Xn.alphaMaximum = ya.position, zn.blueMinimum = Xn.blueMinimum, zn.redMinimum = Xn.redMinimum, zn.greenMinimum = Xn.greenMinimum;
    }
    return Xn.volume = (Xn.redMaximum - Xn.redMinimum) * (Xn.greenMaximum - Xn.greenMinimum) * (Xn.blueMaximum - Xn.blueMinimum) * (Xn.alphaMaximum - Xn.alphaMinimum), zn.volume = (zn.redMaximum - zn.redMinimum) * (zn.greenMaximum - zn.greenMinimum) * (zn.blueMaximum - zn.blueMinimum) * (zn.alphaMaximum - zn.alphaMinimum), !0;
  }
  _initialize(Xn) {
    this._colors = Xn, this._cubes = [];
    for (let zn = 0; zn < Xn; zn++) this._cubes[zn] = new WuColorCube$1();
    this._cubes[0].redMinimum = 0, this._cubes[0].greenMinimum = 0, this._cubes[0].blueMinimum = 0, this._cubes[0].alphaMinimum = 0, this._cubes[0].redMaximum = this._maxSideIndex, this._cubes[0].greenMaximum = this._maxSideIndex, this._cubes[0].blueMaximum = this._maxSideIndex, this._cubes[0].alphaMaximum = this._alphaMaxSideIndex, this._weights = createArray4D$1(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsRed = createArray4D$1(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsGreen = createArray4D$1(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsBlue = createArray4D$1(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsAlpha = createArray4D$1(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._moments = createArray4D$1(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._table = [];
    for (let zn = 0; zn < 256; ++zn) this._table[zn] = zn * zn;
    this._pixels = [];
  }
  _setQuality(Xn = 5) {
    this._significantBitsPerChannel = Xn, this._maxSideIndex = 1 << this._significantBitsPerChannel, this._alphaMaxSideIndex = this._maxSideIndex, this._sideSize = this._maxSideIndex + 1, this._alphaSideSize = this._alphaMaxSideIndex + 1;
  }
}, WuQuant$1 = _WuQuant$1;
__publicField$3(WuQuant$1, "_alpha", 3), __publicField$3(WuQuant$1, "_red", 2), __publicField$3(WuQuant$1, "_green", 1), __publicField$3(WuQuant$1, "_blue", 0);
var image_exports$1 = {};
__export$1(image_exports$1, { AbstractImageQuantizer: () => AbstractImageQuantizer$1, ErrorDiffusionArray: () => ErrorDiffusionArray$1, ErrorDiffusionArrayKernel: () => ErrorDiffusionArrayKernel$1, ErrorDiffusionRiemersma: () => ErrorDiffusionRiemersma$1, NearestColor: () => NearestColor$1 });
var AbstractImageQuantizer$1 = class {
  quantizeSync(Xn, zn) {
    for (const Un of this.quantize(Xn, zn)) if (Un.pointContainer) return Un.pointContainer;
    throw new Error("unreachable");
  }
}, NearestColor$1 = class extends AbstractImageQuantizer$1 {
  constructor(Xn) {
    super(), __publicField$3(this, "_distance"), this._distance = Xn;
  }
  *quantize(Xn, zn) {
    const Un = Xn.getPointArray(), Kn = Xn.getWidth(), qn = Xn.getHeight(), Jo = new ProgressTracker$1(qn, 99);
    for (let pa = 0; pa < qn; pa++) {
      Jo.shouldNotify(pa) && (yield { progress: Jo.progress });
      for (let ma = 0, va = pa * Kn; ma < Kn; ma++, va++) {
        const ba = Un[va];
        ba.from(zn.getNearestColor(this._distance, ba));
      }
    }
    yield { pointContainer: Xn, progress: 100 };
  }
}, ErrorDiffusionArrayKernel$1 = ((Xn) => (Xn[Xn.FloydSteinberg = 0] = "FloydSteinberg", Xn[Xn.FalseFloydSteinberg = 1] = "FalseFloydSteinberg", Xn[Xn.Stucki = 2] = "Stucki", Xn[Xn.Atkinson = 3] = "Atkinson", Xn[Xn.Jarvis = 4] = "Jarvis", Xn[Xn.Burkes = 5] = "Burkes", Xn[Xn.Sierra = 6] = "Sierra", Xn[Xn.TwoSierra = 7] = "TwoSierra", Xn[Xn.SierraLite = 8] = "SierraLite", Xn))(ErrorDiffusionArrayKernel$1 || {}), ErrorDiffusionArray$1 = class extends AbstractImageQuantizer$1 {
  constructor(Xn, zn, Un = !0, Kn = 0, qn = !1) {
    super(), __publicField$3(this, "_minColorDistance"), __publicField$3(this, "_serpentine"), __publicField$3(this, "_kernel"), __publicField$3(this, "_calculateErrorLikeGIMP"), __publicField$3(this, "_distance"), this._setKernel(zn), this._distance = Xn, this._minColorDistance = Kn, this._serpentine = Un, this._calculateErrorLikeGIMP = qn;
  }
  *quantize(Xn, zn) {
    const Un = Xn.getPointArray(), Kn = new Point$1(), qn = Xn.getWidth(), Jo = Xn.getHeight(), pa = [];
    let ma = 1, va = 1;
    for (const _a of this._kernel) {
      const ya = _a[2] + 1;
      va < ya && (va = ya);
    }
    for (let _a = 0; _a < va; _a++) this._fillErrorLine(pa[_a] = [], qn);
    const ba = new ProgressTracker$1(Jo, 99);
    for (let _a = 0; _a < Jo; _a++) {
      ba.shouldNotify(_a) && (yield { progress: ba.progress }), this._serpentine && (ma *= -1);
      const ya = _a * qn, xa = ma === 1 ? 0 : qn - 1, wa = ma === 1 ? qn : -1;
      this._fillErrorLine(pa[0], qn), pa.push(pa.shift());
      const Ta = pa[0];
      for (let Sa = xa, Ma = ya + xa; Sa !== wa; Sa += ma, Ma += ma) {
        const ka = Un[Ma], Za = Ta[Sa];
        Kn.from(ka);
        const Na = Point$1.createByRGBA(inRange0to255Rounded$1(ka.r + Za[0]), inRange0to255Rounded$1(ka.g + Za[1]), inRange0to255Rounded$1(ka.b + Za[2]), inRange0to255Rounded$1(ka.a + Za[3])), Ka = zn.getNearestColor(this._distance, Na);
        if (ka.from(Ka), this._minColorDistance && this._distance.calculateNormalized(Kn, Ka) < this._minColorDistance)
          continue;
        let Ja, el, qa, tl;
        this._calculateErrorLikeGIMP ? (Ja = Na.r - Ka.r, el = Na.g - Ka.g, qa = Na.b - Ka.b, tl = Na.a - Ka.a) : (Ja = Kn.r - Ka.r, el = Kn.g - Ka.g, qa = Kn.b - Ka.b, tl = Kn.a - Ka.a);
        const Qa = ma === 1 ? 0 : this._kernel.length - 1, nl = ma === 1 ? this._kernel.length : -1;
        for (let rl = Qa; rl !== nl; rl += ma) {
          const il = this._kernel[rl][1] * ma, cl = this._kernel[rl][2];
          if (il + Sa >= 0 && il + Sa < qn && cl + _a >= 0 && cl + _a < Jo) {
            const ll = this._kernel[rl][0], al = pa[cl][il + Sa];
            al[0] += Ja * ll, al[1] += el * ll, al[2] += qa * ll, al[3] += tl * ll;
          }
        }
      }
    }
    yield { pointContainer: Xn, progress: 100 };
  }
  _fillErrorLine(Xn, zn) {
    Xn.length > zn && (Xn.length = zn);
    const Un = Xn.length;
    for (let Kn = 0; Kn < Un; Kn++) {
      const qn = Xn[Kn];
      qn[0] = qn[1] = qn[2] = qn[3] = 0;
    }
    for (let Kn = Un; Kn < zn; Kn++) Xn[Kn] = [0, 0, 0, 0];
  }
  _setKernel(Xn) {
    switch (Xn) {
      case 0:
        this._kernel = [[7 / 16, 1, 0], [3 / 16, -1, 1], [5 / 16, 0, 1], [1 / 16, 1, 1]];
        break;
      case 1:
        this._kernel = [[3 / 8, 1, 0], [3 / 8, 0, 1], [2 / 8, 1, 1]];
        break;
      case 2:
        this._kernel = [[8 / 42, 1, 0], [4 / 42, 2, 0], [2 / 42, -2, 1], [4 / 42, -1, 1], [8 / 42, 0, 1], [4 / 42, 1, 1], [2 / 42, 2, 1], [1 / 42, -2, 2], [2 / 42, -1, 2], [4 / 42, 0, 2], [2 / 42, 1, 2], [1 / 42, 2, 2]];
        break;
      case 3:
        this._kernel = [[1 / 8, 1, 0], [1 / 8, 2, 0], [1 / 8, -1, 1], [1 / 8, 0, 1], [1 / 8, 1, 1], [1 / 8, 0, 2]];
        break;
      case 4:
        this._kernel = [[7 / 48, 1, 0], [5 / 48, 2, 0], [3 / 48, -2, 1], [5 / 48, -1, 1], [7 / 48, 0, 1], [5 / 48, 1, 1], [3 / 48, 2, 1], [1 / 48, -2, 2], [3 / 48, -1, 2], [5 / 48, 0, 2], [3 / 48, 1, 2], [1 / 48, 2, 2]];
        break;
      case 5:
        this._kernel = [[0.25, 1, 0], [4 / 32, 2, 0], [2 / 32, -2, 1], [4 / 32, -1, 1], [0.25, 0, 1], [4 / 32, 1, 1], [2 / 32, 2, 1]];
        break;
      case 6:
        this._kernel = [[5 / 32, 1, 0], [3 / 32, 2, 0], [2 / 32, -2, 1], [4 / 32, -1, 1], [5 / 32, 0, 1], [4 / 32, 1, 1], [2 / 32, 2, 1], [2 / 32, -1, 2], [3 / 32, 0, 2], [2 / 32, 1, 2]];
        break;
      case 7:
        this._kernel = [[0.25, 1, 0], [3 / 16, 2, 0], [1 / 16, -2, 1], [2 / 16, -1, 1], [3 / 16, 0, 1], [2 / 16, 1, 1], [1 / 16, 2, 1]];
        break;
      case 8:
        this._kernel = [[0.5, 1, 0], [1 / 4, -1, 1], [1 / 4, 0, 1]];
        break;
      default:
        throw new Error(`ErrorDiffusionArray: unknown kernel = ${Xn}`);
    }
  }
};
function* hilbertCurve$1(Xn, zn, Un) {
  const Kn = Math.max(Xn, zn), qn = { width: Xn, height: zn, level: Math.floor(Math.log(Kn) / Math.log(2) + 1), callback: Un, tracker: new ProgressTracker$1(Xn * zn, 99), index: 0, x: 0, y: 0 };
  yield* walkHilbert$1(qn, 1), visit$1(qn, 0);
}
function* walkHilbert$1(Xn, zn) {
  if (!(Xn.level < 1)) {
    switch (Xn.tracker.shouldNotify(Xn.index) && (yield { progress: Xn.tracker.progress }), Xn.level--, zn) {
      case 2:
        yield* walkHilbert$1(Xn, 1), visit$1(Xn, 3), yield* walkHilbert$1(Xn, 2), visit$1(Xn, 4), yield* walkHilbert$1(Xn, 2), visit$1(Xn, 2), yield* walkHilbert$1(Xn, 4);
        break;
      case 3:
        yield* walkHilbert$1(Xn, 4), visit$1(Xn, 2), yield* walkHilbert$1(Xn, 3), visit$1(Xn, 1), yield* walkHilbert$1(Xn, 3), visit$1(Xn, 3), yield* walkHilbert$1(Xn, 1);
        break;
      case 1:
        yield* walkHilbert$1(Xn, 2), visit$1(Xn, 4), yield* walkHilbert$1(Xn, 1), visit$1(Xn, 3), yield* walkHilbert$1(Xn, 1), visit$1(Xn, 1), yield* walkHilbert$1(Xn, 3);
        break;
      case 4:
        yield* walkHilbert$1(Xn, 3), visit$1(Xn, 1), yield* walkHilbert$1(Xn, 4), visit$1(Xn, 2), yield* walkHilbert$1(Xn, 4), visit$1(Xn, 4), yield* walkHilbert$1(Xn, 2);
    }
    Xn.level++;
  }
}
function visit$1(Xn, zn) {
  switch (Xn.x >= 0 && Xn.x < Xn.width && Xn.y >= 0 && Xn.y < Xn.height && (Xn.callback(Xn.x, Xn.y), Xn.index++), zn) {
    case 2:
      Xn.x--;
      break;
    case 3:
      Xn.x++;
      break;
    case 1:
      Xn.y--;
      break;
    case 4:
      Xn.y++;
  }
}
var ErrorDiffusionRiemersma$1 = class extends AbstractImageQuantizer$1 {
  constructor(Xn, zn = 16, Un = 1) {
    super(), __publicField$3(this, "_distance"), __publicField$3(this, "_weights"), __publicField$3(this, "_errorQueueSize"), this._distance = Xn, this._errorQueueSize = zn, this._weights = ErrorDiffusionRiemersma$1._createWeights(Un, zn);
  }
  *quantize(Xn, zn) {
    const Un = Xn.getPointArray(), Kn = Xn.getWidth(), qn = Xn.getHeight(), Jo = [];
    let pa = 0;
    for (let ma = 0; ma < this._errorQueueSize; ma++) Jo[ma] = { r: 0, g: 0, b: 0, a: 0 };
    yield* hilbertCurve$1(Kn, qn, (ma, va) => {
      const ba = Un[ma + va * Kn];
      let { r: _a, g: ya, b: xa, a: wa } = ba;
      for (let ka = 0; ka < this._errorQueueSize; ka++) {
        const Za = this._weights[ka], Na = Jo[(ka + pa) % this._errorQueueSize];
        _a += Na.r * Za, ya += Na.g * Za, xa += Na.b * Za, wa += Na.a * Za;
      }
      const Ta = Point$1.createByRGBA(inRange0to255Rounded$1(_a), inRange0to255Rounded$1(ya), inRange0to255Rounded$1(xa), inRange0to255Rounded$1(wa)), Sa = zn.getNearestColor(this._distance, Ta);
      pa = (pa + 1) % this._errorQueueSize;
      const Ma = (pa + this._errorQueueSize - 1) % this._errorQueueSize;
      Jo[Ma].r = ba.r - Sa.r, Jo[Ma].g = ba.g - Sa.g, Jo[Ma].b = ba.b - Sa.b, Jo[Ma].a = ba.a - Sa.a, ba.from(Sa);
    }), yield { pointContainer: Xn, progress: 100 };
  }
  static _createWeights(Xn, zn) {
    const Un = [], Kn = Math.exp(Math.log(zn) / (zn - 1));
    for (let qn = 0, Jo = 1; qn < zn; qn++) Un[qn] = (Jo + 0.5 | 0) / zn * Xn, Jo *= Kn;
    return Un;
  }
}, quality_exports$1 = {};
__export$1(quality_exports$1, { ssim: () => ssim$1 });
var K1$1 = 0.01, K2$1 = 0.03;
function ssim$1(Xn, zn) {
  if (Xn.getHeight() !== zn.getHeight() || Xn.getWidth() !== zn.getWidth()) throw new Error("Images have different sizes!");
  const Un = (255 * K1$1) ** 2, Kn = (255 * K2$1) ** 2;
  let qn = 0, Jo = 0;
  return iterate$1(Xn, zn, (pa, ma, va, ba) => {
    let _a = 0, ya = 0, xa = 0;
    for (let Ta = 0; Ta < pa.length; Ta++) ya += (pa[Ta] - va) ** 2, xa += (ma[Ta] - ba) ** 2, _a += (pa[Ta] - va) * (ma[Ta] - ba);
    const wa = pa.length - 1;
    ya /= wa, xa /= wa, _a /= wa, Jo += (2 * va * ba + Un) * (2 * _a + Kn) / ((va ** 2 + ba ** 2 + Un) * (ya + xa + Kn)), qn++;
  }), Jo / qn;
}
function iterate$1(Xn, zn, Un) {
  const Kn = Xn.getWidth(), qn = Xn.getHeight();
  for (let Jo = 0; Jo < qn; Jo += 8) for (let pa = 0; pa < Kn; pa += 8) {
    const ma = Math.min(8, Kn - pa), va = Math.min(8, qn - Jo), ba = calculateLumaValuesForWindow$1(Xn, pa, Jo, ma, va), _a = calculateLumaValuesForWindow$1(zn, pa, Jo, ma, va);
    Un(ba, _a, calculateAverageLuma$1(ba), calculateAverageLuma$1(_a));
  }
}
function calculateLumaValuesForWindow$1(Xn, zn, Un, Kn, qn) {
  const Jo = Xn.getPointArray(), pa = [];
  let ma = 0;
  for (let va = Un; va < Un + qn; va++) {
    const ba = va * Xn.getWidth();
    for (let _a = zn; _a < zn + Kn; _a++) {
      const ya = Jo[ba + _a];
      pa[ma] = 0.2126 * ya.r + 0.7152 * ya.g + 0.0722 * ya.b, ma++;
    }
  }
  return pa;
}
function calculateAverageLuma$1(Xn) {
  let zn = 0;
  for (const Un of Xn) zn += Un;
  return zn / Xn.length;
}
var setImmediateImpl = typeof setImmediate == "function" ? setImmediate : typeof process < "u" && typeof (process == null ? void 0 : process.nextTick) == "function" ? (Xn) => process.nextTick(Xn) : (Xn) => setTimeout(Xn, 0);
function buildPaletteSync$1(Xn, { colorDistanceFormula: zn, paletteQuantization: Un, colors: Kn } = {}) {
  const qn = paletteQuantizationToPaletteQuantizer$1(colorDistanceFormulaToColorDistance$1(zn), Un, Kn);
  return Xn.forEach((Jo) => qn.sample(Jo)), qn.quantizeSync();
}
async function buildPalette(Xn, { colorDistanceFormula: zn, paletteQuantization: Un, colors: Kn, onProgress: qn } = {}) {
  return new Promise((Jo, pa) => {
    const ma = paletteQuantizationToPaletteQuantizer$1(colorDistanceFormulaToColorDistance$1(zn), Un, Kn);
    let va;
    Xn.forEach((ya) => ma.sample(ya));
    const ba = ma.quantize(), _a = () => {
      try {
        const ya = ba.next();
        ya.done ? Jo(va) : (ya.value.palette && (va = ya.value.palette), qn && qn(ya.value.progress), setImmediateImpl(_a));
      } catch (ya) {
        pa(ya);
      }
    };
    setImmediateImpl(_a);
  });
}
function applyPaletteSync$1(Xn, zn, { colorDistanceFormula: Un, imageQuantization: Kn } = {}) {
  return imageQuantizationToImageQuantizer$1(colorDistanceFormulaToColorDistance$1(Un), Kn).quantizeSync(Xn, zn);
}
async function applyPalette(Xn, zn, { colorDistanceFormula: Un, imageQuantization: Kn, onProgress: qn } = {}) {
  return new Promise((Jo, pa) => {
    let ma;
    const va = imageQuantizationToImageQuantizer$1(colorDistanceFormulaToColorDistance$1(Un), Kn).quantize(Xn, zn), ba = () => {
      try {
        const _a = va.next();
        _a.done ? Jo(ma) : (_a.value.pointContainer && (ma = _a.value.pointContainer), qn && qn(_a.value.progress), setImmediateImpl(ba));
      } catch (_a) {
        pa(_a);
      }
    };
    setImmediateImpl(ba);
  });
}
function colorDistanceFormulaToColorDistance$1(Xn = "euclidean-bt709") {
  switch (Xn) {
    case "cie94-graphic-arts":
      return new CIE94GraphicArts$1();
    case "cie94-textiles":
      return new CIE94Textiles$1();
    case "ciede2000":
      return new CIEDE2000$1();
    case "color-metric":
      return new CMetric$1();
    case "euclidean":
      return new Euclidean$1();
    case "euclidean-bt709":
      return new EuclideanBT709$1();
    case "euclidean-bt709-noalpha":
      return new EuclideanBT709NoAlpha$1();
    case "manhattan":
      return new Manhattan$1();
    case "manhattan-bt709":
      return new ManhattanBT709$1();
    case "manhattan-nommyde":
      return new ManhattanNommyde$1();
    case "pngquant":
      return new PNGQuant$1();
    default:
      throw new Error(`Unknown colorDistanceFormula ${Xn}`);
  }
}
function imageQuantizationToImageQuantizer$1(Xn, zn = "floyd-steinberg") {
  switch (zn) {
    case "nearest":
      return new NearestColor$1(Xn);
    case "riemersma":
      return new ErrorDiffusionRiemersma$1(Xn);
    case "floyd-steinberg":
      return new ErrorDiffusionArray$1(Xn, 0);
    case "false-floyd-steinberg":
      return new ErrorDiffusionArray$1(Xn, 1);
    case "stucki":
      return new ErrorDiffusionArray$1(Xn, 2);
    case "atkinson":
      return new ErrorDiffusionArray$1(Xn, 3);
    case "jarvis":
      return new ErrorDiffusionArray$1(Xn, 4);
    case "burkes":
      return new ErrorDiffusionArray$1(Xn, 5);
    case "sierra":
      return new ErrorDiffusionArray$1(Xn, 6);
    case "two-sierra":
      return new ErrorDiffusionArray$1(Xn, 7);
    case "sierra-lite":
      return new ErrorDiffusionArray$1(Xn, 8);
    default:
      throw new Error(`Unknown imageQuantization ${zn}`);
  }
}
function paletteQuantizationToPaletteQuantizer$1(Xn, zn = "wuquant", Un = 256) {
  switch (zn) {
    case "neuquant":
      return new NeuQuant$1(Xn, Un);
    case "rgbquant":
      return new RGBQuant$1(Xn, Un);
    case "wuquant":
      return new WuQuant$1(Xn, Un);
    case "neuquant-float":
      return new NeuQuantFloat$1(Xn, Un);
    default:
      throw new Error(`Unknown paletteQuantization ${zn}`);
  }
}
var imageQ = __toCommonJS(src_exports), gifframe = {};
const BitmapImage$1 = bitmapimage;
let GifFrame$1 = class S1 extends BitmapImage$1 {
  constructor(...zn) {
    if (super(...zn), zn[0] instanceof S1) {
      const Un = zn[0];
      this.xOffset = Un.xOffset, this.yOffset = Un.yOffset, this.disposalMethod = Un.disposalMethod, this.delayCentisecs = Un.delayCentisecs, this.interlaced = Un.interlaced;
    } else {
      const Un = zn[zn.length - 1];
      let Kn = {};
      typeof Un != "object" || Un instanceof BitmapImage$1 || (Kn = Un), this.xOffset = Kn.xOffset || 0, this.yOffset = Kn.yOffset || 0, this.disposalMethod = Kn.disposalMethod !== void 0 ? Kn.disposalMethod : S1.DisposeToBackgroundColor, this.delayCentisecs = Kn.delayCentisecs || 8, this.interlaced = Kn.interlaced || !1;
    }
  }
  getPalette() {
    const zn = /* @__PURE__ */ new Set(), Un = this.bitmap.data;
    let Kn = 0, qn = !1;
    for (; Kn < Un.length; ) {
      if (Un[Kn + 3] === 0) qn = !0;
      else {
        const va = Un.readUInt32BE(Kn, !0) >> 8 & 16777215;
        zn.add(va);
      }
      Kn += 4;
    }
    const Jo = new Array(zn.size), pa = zn.values();
    for (Kn = 0; Kn < Jo.length; ++Kn) Jo[Kn] = pa.next().value;
    Jo.sort((va, ba) => va - ba);
    let ma = Jo.length;
    return qn && ++ma, { colors: Jo, usesTransparency: qn, indexCount: ma };
  }
};
var hasRequiredGifutil, hasRequiredGifcodec;
function requireGifutil() {
  return hasRequiredGifutil || (hasRequiredGifutil = 1, function(Xn) {
    const zn = require$$0, Un = imageQ, Kn = bitmapimage, { GifFrame: qn } = gifframe, { GifError: Jo } = gif$1, { GifCodec: pa } = requireGifcodec(), ma = [".jpg", ".jpeg", ".png", ".bmp"], va = new pa();
    function ba(_a, ya, xa, wa, Ta) {
      const Sa = Array.isArray(_a) ? _a : [_a];
      if (Ta) {
        if (["FloydSteinberg", "FalseFloydSteinberg", "Stucki", "Atkinson", "Jarvis", "Burkes", "Sierra", "TwoSierra", "SierraLite"].indexOf(Ta.ditherAlgorithm) < 0) throw new Error(`Invalid ditherAlgorithm '${Ta.ditherAlgorithm}'`);
        Ta.serpentine === void 0 && (Ta.serpentine = !0), Ta.minimumColorDistanceToDither === void 0 && (Ta.minimumColorDistanceToDither = 0), Ta.calculateErrorLikeGIMP === void 0 && (Ta.calculateErrorLikeGIMP = !1);
      }
      const Ma = new Un.distance.Euclidean(), ka = new Un.palette[ya](Ma, xa, wa);
      let Za;
      Za = Ta ? new Un.image.ErrorDiffusionArray(Ma, Un.image.ErrorDiffusionArrayKernel[Ta.ditherAlgorithm], Ta.serpentine, Ta.minimumColorDistanceToDither, Ta.calculateErrorLikeGIMP) : new Un.image.NearestColor(Ma);
      const Na = [];
      Sa.forEach((Ja) => {
        const el = Ja.bitmap.data, qa = new ArrayBuffer(el.length), tl = new Uint32Array(qa);
        for (let nl = 0, rl = 0; nl < el.length; nl += 4, ++rl) tl[rl] = el.readUInt32LE(nl, !0);
        const Qa = Un.utils.PointContainer.fromUint32Array(tl, Ja.bitmap.width, Ja.bitmap.height);
        ka.sample(Qa), Na.push(Qa);
      });
      const Ka = ka.quantizeSync();
      for (let Ja = 0; Ja < Sa.length; ++Ja) {
        const el = Sa[Ja].bitmap.data, qa = Za.quantizeSync(Na[Ja], Ka).toUint32Array();
        for (let tl = 0, Qa = 0; tl < el.length; tl += 4, ++Qa) el.writeUInt32LE(qa[Qa], tl);
      }
    }
    Xn.cloneFrames = function(_a) {
      let ya = [];
      return _a.forEach((xa) => {
        ya.push(new qn(xa));
      }), ya;
    }, Xn.getColorInfo = function(_a, ya) {
      let xa = !1;
      const wa = [];
      for (let Za = 0; Za < _a.length; ++Za) {
        let Na = _a[Za].getPalette();
        if (Na.usesTransparency && (xa = !0), Na.indexCount > 256) throw new Jo(`Frame ${Za} uses more than 256 color indexes`);
        wa.push(Na);
      }
      if (ya === 0) return { usesTransparency: xa, palettes: wa };
      const Ta = /* @__PURE__ */ new Set();
      wa.forEach((Za) => {
        Za.colors.forEach((Na) => {
          Ta.add(Na);
        });
      });
      let Sa = Ta.size;
      if (xa && ++Sa, ya && Sa > ya) return { usesTransparency: xa, palettes: wa };
      const Ma = new Array(Ta.size), ka = Ta.values();
      for (let Za = 0; Za < Ma.length; ++Za) Ma[Za] = ka.next().value;
      return Ma.sort((Za, Na) => Za - Na), { colors: Ma, indexCount: Sa, usesTransparency: xa, palettes: wa };
    }, Xn.copyAsJimp = function(_a, ya) {
      return Xn.shareAsJimp(_a, new Kn(ya));
    }, Xn.getMaxDimensions = function(_a) {
      let ya = 0, xa = 0;
      return _a.forEach((wa) => {
        const Ta = wa.xOffset + wa.bitmap.width;
        Ta > ya && (ya = Ta);
        const Sa = wa.yOffset + wa.bitmap.height;
        Sa > xa && (xa = Sa);
      }), { maxWidth: ya, maxHeight: xa };
    }, Xn.quantizeDekker = function(_a, ya, xa) {
      ba(_a, "NeuQuantFloat", ya = ya || 256, 0, xa);
    }, Xn.quantizeSorokin = function(_a, ya, xa, wa) {
      let Ta;
      switch (ya = ya || 256, xa = xa || "min-pop") {
        case "min-pop":
          Ta = 2;
          break;
        case "top-pop":
          Ta = 1;
          break;
        default:
          throw new Error(`Invalid quantizeSorokin histogram '${xa}'`);
      }
      ba(_a, "RGBQuant", ya, Ta, wa);
    }, Xn.quantizeWu = function(_a, ya, xa, wa) {
      if (ya = ya || 256, (xa = xa || 5) < 1 || xa > 8) throw new Error("Invalid quantization quality");
      ba(_a, "WuQuant", ya, xa, wa);
    }, Xn.read = function(_a, ya) {
      return ya = ya || va, Buffer$1.isBuffer(_a) ? ya.decodeGif(_a) : function(xa) {
        return new Promise((wa, Ta) => {
          zn.readFile(xa, (Sa, Ma) => Sa ? Ta(Sa) : wa(Ma));
        });
      }(_a).then((xa) => ya.decodeGif(xa));
    }, Xn.shareAsJimp = function(_a, ya) {
      const xa = new _a(ya.bitmap.width, ya.bitmap.height, 0);
      return xa.bitmap.data = ya.bitmap.data, xa;
    }, Xn.write = function(_a, ya, xa, wa) {
      wa = wa || va;
      const Ta = _a.match(/\.[a-zA-Z]+$/);
      if (Ta !== null && ma.includes(Ta[0].toLowerCase())) throw new Error(`GIF '${_a}' has an unexpected suffix`);
      return wa.encodeGif(ya, xa).then((Sa) => function(Ma, ka) {
        return new Promise((Za, Na) => {
          zn.writeFile(Ma, ka, (Ka) => Ka ? Na(Ka) : Za());
        });
      }(_a, Sa.buffer).then(() => Sa));
    };
  }(gifutil)), gifutil;
}
function requireGifcodec() {
  if (hasRequiredGifcodec) return gifcodec;
  hasRequiredGifcodec = 1;
  const Xn = omggif, { Gif: zn, GifError: Un } = gif$1;
  function Kn() {
    const ya = requireGifutil();
    return Kn = function() {
      return ya;
    }, ya;
  }
  const { GifFrame: qn } = gifframe;
  function Jo(ya, xa) {
    const wa = ya.indexOf(xa);
    return wa === -1 ? null : wa;
  }
  function pa(ya, xa) {
    for (var wa, Ta = 0, Sa = ya.length - 1; Ta <= Sa; ) if (ya[wa = Math.floor((Ta + Sa) / 2)] > xa) Sa = wa - 1;
    else {
      if (!(ya[wa] < xa)) return wa;
      Ta = wa + 1;
    }
    return null;
  }
  function ma(ya) {
    const xa = ya.colors;
    ya.usesTransparency && xa.push(0);
    const wa = xa.length;
    let Ta = 2;
    for (; wa > Ta; ) Ta <<= 1;
    xa.length = Ta, xa.fill(0, wa);
  }
  function va(ya, xa) {
    let wa = ya.bitmap.width * ya.bitmap.height;
    return wa = Math.ceil(wa * xa / 8), wa += Math.ceil(wa / 255), 100 + wa + 768;
  }
  function ba(ya) {
    let xa = ya.indexCount, wa = 0;
    for (--xa; xa; ) ++wa, xa >>= 1;
    return wa > 0 ? wa : 1;
  }
  function _a(ya, xa, wa, Ta, Sa) {
    if (wa.interlaced) throw new Un("writing interlaced GIFs is not supported");
    const Ma = function(Za, Na, Ka) {
      const Ja = Ka.colors, el = Ja.length <= 8 ? Jo : pa, qa = Na.bitmap.data, tl = new Buffer$1(qa.length / 4);
      let Qa = Ja.length, nl = 0, rl = 0;
      for (; nl < qa.length; ) {
        if (qa[nl + 3] !== 0) {
          const il = qa.readUInt32BE(nl, !0) >> 8 & 16777215;
          tl[rl] = el(Ja, il);
        } else tl[rl] = Qa;
        nl += 4, ++rl;
      }
      if (Ka.usesTransparency) {
        if (Qa === 256) throw new Un(`Frame ${Za} already has 256 colorsand so can't use transparency`);
      } else Qa = null;
      return { buffer: tl, transparentIndex: Qa };
    }(xa, wa, Ta), ka = { delay: wa.delayCentisecs, disposal: wa.disposalMethod, transparent: Ma.transparentIndex };
    Sa && (ma(Ta), ka.palette = Ta.colors);
    try {
      let Za, Na = ya.getOutputBuffer(), Ka = ya.getOutputBufferPosition(), Ja = !0;
      for (; Ja; ) if (Za = ya.addFrame(wa.xOffset, wa.yOffset, wa.bitmap.width, wa.bitmap.height, Ma.buffer, ka), Ja = !1, Za >= Na.length - 1) {
        const el = new Buffer$1(1.5 * Na.length);
        Na.copy(el), ya.setOutputBuffer(el), ya.setOutputBufferPosition(Ka), Na = el, Ja = !0;
      }
      return Na;
    } catch (Za) {
      throw new Un(Za);
    }
  }
  return gifcodec.GifCodec = class {
    constructor(ya = {}) {
      this._transparentRGB = null, typeof ya.transparentRGB == "number" && ya.transparentRGB !== 0 && (this._transparentRGBA = 256 * ya.transparentRGB), this._testInitialBufferSize = 0;
    }
    decodeGif(ya) {
      try {
        let xa;
        try {
          xa = new Xn.GifReader(ya);
        } catch (Ma) {
          throw new Un(Ma);
        }
        const wa = xa.numFrames(), Ta = [], Sa = { width: xa.width, height: xa.height, loops: xa.loopCount(), usesTransparency: !1 };
        for (let Ma = 0; Ma < wa; ++Ma) {
          const ka = this._decodeFrame(xa, Ma, Sa.usesTransparency);
          Ta.push(ka.frame), ka.usesTransparency && (Sa.usesTransparency = !0);
        }
        return Promise.resolve(new zn(ya, Ta, Sa));
      } catch (xa) {
        return Promise.reject(xa);
      }
    }
    encodeGif(ya, xa = {}) {
      try {
        if (ya === null || ya.length === 0) throw new Un("there are no frames");
        const wa = Kn().getMaxDimensions(ya);
        return (xa = Object.assign({}, xa)).width = wa.maxWidth, xa.height = wa.maxHeight, xa.loops === void 0 && (xa.loops = 0), xa.colorScope = xa.colorScope || zn.GlobalColorsPreferred, Promise.resolve(this._encodeGif(ya, xa));
      } catch (wa) {
        return Promise.reject(wa);
      }
    }
    _decodeFrame(ya, xa, wa) {
      let Ta, Sa;
      try {
        if (Ta = ya.frameInfo(xa), Sa = new Buffer$1(ya.width * ya.height * 4), ya.decodeAndBlitFrameRGBA(xa, Sa), Ta.width !== ya.width || Ta.height !== ya.height) {
          if (Ta.y && (Sa = Sa.slice(Ta.y * ya.width * 4)), ya.width > Ta.width) for (let ka = 0; ka < Ta.height; ++ka) Sa.copy(Sa, ka * Ta.width * 4, 4 * (Ta.x + ka * ya.width), 4 * (Ta.x + ka * ya.width) + 4 * Ta.width);
          Sa = Sa.slice(0, Ta.width * Ta.height * 4);
        }
      } catch (ka) {
        throw new Un(ka);
      }
      let Ma = !1;
      if (this._transparentRGBA === null) {
        if (!wa) for (let ka = 3; ka < Sa.length; ka += 4) Sa[ka] === 0 && (Ma = !0, ka = Sa.length);
      } else for (let ka = 3; ka < Sa.length; ka += 4) Sa[ka] === 0 && (Sa.writeUInt32BE(this._transparentRGBA, ka - 3), Ma = !0);
      return { frame: new qn(Ta.width, Ta.height, Sa, { xOffset: Ta.x, yOffset: Ta.y, disposalMethod: Ta.disposal, interlaced: Ta.interlaced, delayCentisecs: Ta.delay }), usesTransparency: Ma };
    }
    _encodeGif(ya, xa) {
      let wa;
      if (xa.colorScope === zn.LocalColorsOnly) wa = Kn().getColorInfo(ya, 0);
      else if (wa = Kn().getColorInfo(ya, 256), !wa.colors) {
        if (xa.colorScope === zn.GlobalColorsOnly) throw new Un("Too many color indexes for global color table");
        xa.colorScope = zn.LocalColorsOnly;
      }
      xa.usesTransparency = wa.usesTransparency;
      const Ta = wa.palettes;
      return xa.colorScope === zn.LocalColorsOnly ? function(Sa, Ma, ka, Za) {
        const Na = { loop: Ma.loops };
        let Ka, Ja = new Buffer$1(ka);
        try {
          Ka = new Xn.GifWriter(Ja, Ma.width, Ma.height, Na);
        } catch (el) {
          throw new Un(el);
        }
        for (let el = 0; el < Sa.length; ++el) Ja = _a(Ka, el, Sa[el], Za[el], !0);
        return new zn(Ja.slice(0, Ka.end()), Sa, Ma);
      }(ya, xa, 2e3, Ta) : function(Sa, Ma, ka, Za) {
        const Na = { colors: Za.colors.slice(), usesTransparency: Za.usesTransparency };
        ma(Na);
        const Ka = { palette: Na.colors, loop: Ma.loops };
        let Ja, el = new Buffer$1(ka);
        try {
          Ja = new Xn.GifWriter(el, Ma.width, Ma.height, Ka);
        } catch (qa) {
          throw new Un(qa);
        }
        for (let qa = 0; qa < Sa.length; ++qa) el = _a(Ja, qa, Sa[qa], Za, !1);
        return new zn(el.slice(0, Ja.end()), Sa, Ma);
      }(ya, xa, 2e3, wa);
    }
    _getSizeEstimateGlobal(ya, xa) {
      if (this._testInitialBufferSize > 0) return this._testInitialBufferSize;
      let wa = 968;
      const Ta = ba(ya);
      return xa.forEach((Sa) => {
        wa += va(Sa, Ta);
      }), wa;
    }
    _getSizeEstimateLocal(ya, xa) {
      if (this._testInitialBufferSize > 0) return this._testInitialBufferSize;
      let wa = 200;
      for (let Ta = 0; Ta < xa.length; ++Ta) {
        const Sa = ba(ya[Ta]);
        wa += va(xa[Ta], Sa);
      }
      return wa;
    }
  }, gifcodec;
}
GifFrame$1.DisposeToAnything = 0, GifFrame$1.DisposeNothing = 1, GifFrame$1.DisposeToBackgroundColor = 2, GifFrame$1.DisposeToPrevious = 3, gifframe.GifFrame = GifFrame$1;
const BitmapImage = bitmapimage, { GifCodec } = requireGifcodec(), { GifFrame } = gifframe, GifUtil = requireGifutil();
var src = { BitmapImage, GifCodec, GifFrame, GifUtil };
function gif() {
  return { mime: "image/gif", encode: async (Xn) => {
    const zn = new src.BitmapImage(Xn);
    src.GifUtil.quantizeDekker(zn, 256);
    const Un = new src.GifFrame(Xn);
    return (await new src.GifCodec().encodeGif([Un], {})).buffer;
  }, decode: (Xn) => {
    const zn = new omggif.GifReader(Xn), Un = Buffer$1.alloc(zn.width * zn.height * 4);
    return zn.decodeAndBlitFrameRGBA(0, Un), { data: Un, width: zn.width, height: zn.height };
  } };
}
var encoder = { exports: {} };
(function(Xn) {
  function zn(Un) {
    var Kn, qn, Jo, pa, ma, va = Math.floor, ba = new Array(64), _a = new Array(64), ya = new Array(64), xa = new Array(64), wa = new Array(65535), Ta = new Array(65535), Sa = new Array(64), Ma = new Array(64), ka = [], Za = 0, Na = 7, Ka = new Array(64), Ja = new Array(64), el = new Array(64), qa = new Array(256), tl = new Array(2048), Qa = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], nl = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], rl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], il = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], cl = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], ll = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], al = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], sl = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], dl = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
    function El(_l, gl) {
      for (var Fl = 0, Nl = 0, zl = new Array(), Zl = 1; Zl <= 16; Zl++) {
        for (var kl = 1; kl <= _l[Zl]; kl++) zl[gl[Nl]] = [], zl[gl[Nl]][0] = Fl, zl[gl[Nl]][1] = Zl, Nl++, Fl++;
        Fl *= 2;
      }
      return zl;
    }
    function fl(_l) {
      for (var gl = _l[0], Fl = _l[1] - 1; Fl >= 0; ) gl & 1 << Fl && (Za |= 1 << Na), Fl--, --Na < 0 && (Za == 255 ? (Ml(255), Ml(0)) : Ml(Za), Na = 7, Za = 0);
    }
    function Ml(_l) {
      ka.push(_l);
    }
    function Sl(_l) {
      Ml(_l >> 8 & 255), Ml(255 & _l);
    }
    function ml(_l, gl, Fl, Nl, zl) {
      for (var Zl, kl = zl[0], ul = zl[240], vl = function(Ll, tc) {
        var nc, uc, _c, mc, Sc, hc, Lc, Ec, Hl, fc, lc = 0;
        for (Hl = 0; Hl < 8; ++Hl) {
          nc = Ll[lc], uc = Ll[lc + 1], _c = Ll[lc + 2], mc = Ll[lc + 3], Sc = Ll[lc + 4], hc = Ll[lc + 5], Lc = Ll[lc + 6];
          var Gl = nc + (Ec = Ll[lc + 7]), ql = nc - Ec, Vl = uc + Lc, Pl = uc - Lc, Ol = _c + hc, cc = _c - hc, bl = mc + Sc, pl = mc - Sc, Jl = Gl + bl, Al = Gl - bl, Bl = Vl + Ol, Kl = Vl - Ol;
          Ll[lc] = Jl + Bl, Ll[lc + 4] = Jl - Bl;
          var oc = 0.707106781 * (Kl + Al);
          Ll[lc + 2] = Al + oc, Ll[lc + 6] = Al - oc;
          var xc = 0.382683433 * ((Jl = pl + cc) - (Kl = Pl + ql)), vc = 0.5411961 * Jl + xc, Pc = 1.306562965 * Kl + xc, Hc = 0.707106781 * (Bl = cc + Pl), $c = ql + Hc, Nc = ql - Hc;
          Ll[lc + 5] = Nc + vc, Ll[lc + 3] = Nc - vc, Ll[lc + 1] = $c + Pc, Ll[lc + 7] = $c - Pc, lc += 8;
        }
        for (lc = 0, Hl = 0; Hl < 8; ++Hl) {
          nc = Ll[lc], uc = Ll[lc + 8], _c = Ll[lc + 16], mc = Ll[lc + 24], Sc = Ll[lc + 32], hc = Ll[lc + 40], Lc = Ll[lc + 48];
          var Zc = nc + (Ec = Ll[lc + 56]), Yc = nc - Ec, mh = uc + Lc, Wl = uc - Lc, ic = _c + hc, Xl = _c - hc, Ql = mc + Sc, ec = mc - Sc, rc = Zc + Ql, dc = Zc - Ql, wc = mh + ic, bc = mh - ic;
          Ll[lc] = rc + wc, Ll[lc + 32] = rc - wc;
          var Cc = 0.707106781 * (bc + dc);
          Ll[lc + 16] = dc + Cc, Ll[lc + 48] = dc - Cc;
          var yc = 0.382683433 * ((rc = ec + Xl) - (bc = Wl + Yc)), Oc = 0.5411961 * rc + yc, Mc = 1.306562965 * bc + yc, Bc = 0.707106781 * (wc = Xl + Wl), Rc = Yc + Bc, kc = Yc - Bc;
          Ll[lc + 40] = kc + Oc, Ll[lc + 24] = kc - Oc, Ll[lc + 8] = Rc + Mc, Ll[lc + 56] = Rc - Mc, lc++;
        }
        for (Hl = 0; Hl < 64; ++Hl) fc = Ll[Hl] * tc[Hl], Sa[Hl] = fc > 0 ? fc + 0.5 | 0 : fc - 0.5 | 0;
        return Sa;
      }(_l, gl), Tl = 0; Tl < 64; ++Tl) Ma[Qa[Tl]] = vl[Tl];
      var wl = Ma[0] - Fl;
      Fl = Ma[0], wl == 0 ? fl(Nl[0]) : (fl(Nl[Ta[Zl = 32767 + wl]]), fl(wa[Zl]));
      for (var yl = 63; yl > 0 && Ma[yl] == 0; yl--) ;
      if (yl == 0) return fl(kl), Fl;
      for (var Rl, Ul = 1; Ul <= yl; ) {
        for (var hl = Ul; Ma[Ul] == 0 && Ul <= yl; ++Ul) ;
        var Cl = Ul - hl;
        if (Cl >= 16) {
          Rl = Cl >> 4;
          for (var Il = 1; Il <= Rl; ++Il) fl(ul);
          Cl &= 15;
        }
        Zl = 32767 + Ma[Ul], fl(zl[(Cl << 4) + Ta[Zl]]), fl(wa[Zl]), Ul++;
      }
      return yl != 63 && fl(kl), Fl;
    }
    function Dl(_l) {
      _l <= 0 && (_l = 1), _l > 100 && (_l = 100), ma != _l && (function(gl) {
        for (var Fl = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], Nl = 0; Nl < 64; Nl++) {
          var zl = va((Fl[Nl] * gl + 50) / 100);
          zl < 1 ? zl = 1 : zl > 255 && (zl = 255), ba[Qa[Nl]] = zl;
        }
        for (var Zl = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], kl = 0; kl < 64; kl++) {
          var ul = va((Zl[kl] * gl + 50) / 100);
          ul < 1 ? ul = 1 : ul > 255 && (ul = 255), _a[Qa[kl]] = ul;
        }
        for (var vl = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], Tl = 0, wl = 0; wl < 8; wl++) for (var yl = 0; yl < 8; yl++) ya[Tl] = 1 / (ba[Qa[Tl]] * vl[wl] * vl[yl] * 8), xa[Tl] = 1 / (_a[Qa[Tl]] * vl[wl] * vl[yl] * 8), Tl++;
      }(_l < 50 ? Math.floor(5e3 / _l) : Math.floor(200 - 2 * _l)), ma = _l);
    }
    this.encode = function(_l, gl) {
      var Fl;
      (/* @__PURE__ */ new Date()).getTime(), gl && Dl(gl), ka = new Array(), Za = 0, Na = 7, Sl(65496), Sl(65504), Sl(16), Ml(74), Ml(70), Ml(73), Ml(70), Ml(0), Ml(1), Ml(1), Ml(0), Sl(1), Sl(1), Ml(0), Ml(0), (Fl = _l.comments) !== void 0 && Fl.constructor === Array && Fl.forEach((_c) => {
        if (typeof _c == "string") {
          Sl(65534);
          var mc, Sc = _c.length;
          for (Sl(Sc + 2), mc = 0; mc < Sc; mc++) Ml(_c.charCodeAt(mc));
        }
      }), function(_c) {
        if (_c) {
          Sl(65505), _c[0] === 69 && _c[1] === 120 && _c[2] === 105 && _c[3] === 102 ? Sl(_c.length + 2) : (Sl(_c.length + 5 + 2), Ml(69), Ml(120), Ml(105), Ml(102), Ml(0));
          for (var mc = 0; mc < _c.length; mc++) Ml(_c[mc]);
        }
      }(_l.exifBuffer), function() {
        Sl(65499), Sl(132), Ml(0);
        for (var _c = 0; _c < 64; _c++) Ml(ba[_c]);
        Ml(1);
        for (var mc = 0; mc < 64; mc++) Ml(_a[mc]);
      }(), function(_c, mc) {
        Sl(65472), Sl(17), Ml(8), Sl(mc), Sl(_c), Ml(3), Ml(1), Ml(17), Ml(0), Ml(2), Ml(17), Ml(1), Ml(3), Ml(17), Ml(1);
      }(_l.width, _l.height), function() {
        Sl(65476), Sl(418), Ml(0);
        for (var _c = 0; _c < 16; _c++) Ml(nl[_c + 1]);
        for (var mc = 0; mc <= 11; mc++) Ml(rl[mc]);
        Ml(16);
        for (var Sc = 0; Sc < 16; Sc++) Ml(il[Sc + 1]);
        for (var hc = 0; hc <= 161; hc++) Ml(cl[hc]);
        Ml(1);
        for (var Lc = 0; Lc < 16; Lc++) Ml(ll[Lc + 1]);
        for (var Ec = 0; Ec <= 11; Ec++) Ml(al[Ec]);
        Ml(17);
        for (var Hl = 0; Hl < 16; Hl++) Ml(sl[Hl + 1]);
        for (var fc = 0; fc <= 161; fc++) Ml(dl[fc]);
      }(), Sl(65498), Sl(12), Ml(3), Ml(1), Ml(0), Ml(2), Ml(17), Ml(3), Ml(17), Ml(0), Ml(63), Ml(0);
      var Nl = 0, zl = 0, Zl = 0;
      Za = 0, Na = 7, this.encode.displayName = "_encode_";
      for (var kl, ul, vl, Tl, wl, yl, Rl, Ul, hl, Cl = _l.data, Il = _l.width, Ll = _l.height, tc = 4 * Il, nc = 0; nc < Ll; ) {
        for (kl = 0; kl < tc; ) {
          for (yl = wl = tc * nc + kl, Rl = -1, Ul = 0, hl = 0; hl < 64; hl++) yl = wl + (Ul = hl >> 3) * tc + (Rl = 4 * (7 & hl)), nc + Ul >= Ll && (yl -= tc * (nc + 1 + Ul - Ll)), kl + Rl >= tc && (yl -= kl + Rl - tc + 4), ul = Cl[yl++], vl = Cl[yl++], Tl = Cl[yl++], Ka[hl] = (tl[ul] + tl[vl + 256 | 0] + tl[Tl + 512 | 0] >> 16) - 128, Ja[hl] = (tl[ul + 768 | 0] + tl[vl + 1024 | 0] + tl[Tl + 1280 | 0] >> 16) - 128, el[hl] = (tl[ul + 1280 | 0] + tl[vl + 1536 | 0] + tl[Tl + 1792 | 0] >> 16) - 128;
          Nl = ml(Ka, ya, Nl, Kn, Jo), zl = ml(Ja, xa, zl, qn, pa), Zl = ml(el, xa, Zl, qn, pa), kl += 32;
        }
        nc += 8;
      }
      if (Na >= 0) {
        var uc = [];
        uc[1] = Na + 1, uc[0] = (1 << Na + 1) - 1, fl(uc);
      }
      return Sl(65497), Buffer$1.from(ka);
    }, (/* @__PURE__ */ new Date()).getTime(), Un || (Un = 50), function() {
      for (var _l = String.fromCharCode, gl = 0; gl < 256; gl++) qa[gl] = _l(gl);
    }(), Kn = El(nl, rl), qn = El(ll, al), Jo = El(il, cl), pa = El(sl, dl), function() {
      for (var _l = 1, gl = 2, Fl = 1; Fl <= 15; Fl++) {
        for (var Nl = _l; Nl < gl; Nl++) Ta[32767 + Nl] = Fl, wa[32767 + Nl] = [], wa[32767 + Nl][1] = Fl, wa[32767 + Nl][0] = Nl;
        for (var zl = -(gl - 1); zl <= -_l; zl++) Ta[32767 + zl] = Fl, wa[32767 + zl] = [], wa[32767 + zl][1] = Fl, wa[32767 + zl][0] = gl - 1 + zl;
        _l <<= 1, gl <<= 1;
      }
    }(), function() {
      for (var _l = 0; _l < 256; _l++) tl[_l] = 19595 * _l, tl[_l + 256 | 0] = 38470 * _l, tl[_l + 512 | 0] = 7471 * _l + 32768, tl[_l + 768 | 0] = -11059 * _l, tl[_l + 1024 | 0] = -21709 * _l, tl[_l + 1280 | 0] = 32768 * _l + 8421375, tl[_l + 1536 | 0] = -27439 * _l, tl[_l + 1792 | 0] = -5329 * _l;
    }(), Dl(Un), (/* @__PURE__ */ new Date()).getTime();
  }
  encoder.exports = function(Un, Kn) {
    Kn === void 0 && (Kn = 50);
    var qn = new zn(Kn), Jo = qn.encode(Un, Kn);
    return { data: Jo, width: Un.width, height: Un.height };
  };
})();
var encoderExports = encoder.exports, decoder = { exports: {} }, module, JpegImage;
module = decoder, JpegImage = function() {
  var Xn = new Int32Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]), zn = 4017, Un = 799, Kn = 3406, qn = 2276, Jo = 1567, pa = 3784, ma = 5793, va = 2896;
  function ba() {
  }
  function _a(ka, Za) {
    for (var Na, Ka, Ja = 0, el = [], qa = 16; qa > 0 && !ka[qa - 1]; ) qa--;
    el.push({ children: [], index: 0 });
    var tl, Qa = el[0];
    for (Na = 0; Na < qa; Na++) {
      for (Ka = 0; Ka < ka[Na]; Ka++) {
        for ((Qa = el.pop()).children[Qa.index] = Za[Ja]; Qa.index > 0; ) {
          if (el.length === 0) throw new Error("Could not recreate Huffman Table");
          Qa = el.pop();
        }
        for (Qa.index++, el.push(Qa); el.length <= Na; ) el.push(tl = { children: [], index: 0 }), Qa.children[Qa.index] = tl.children, Qa = tl;
        Ja++;
      }
      Na + 1 < qa && (el.push(tl = { children: [], index: 0 }), Qa.children[Qa.index] = tl.children, Qa = tl);
    }
    return el[0].children;
  }
  function ya(ka, Za, Na, Ka, Ja, el, qa, tl, Qa, nl) {
    Na.precision, Na.samplesPerLine, Na.scanLines;
    var rl = Na.mcusPerLine, il = Na.progressive;
    Na.maxH, Na.maxV;
    var cl = Za, ll = 0, al = 0;
    function sl() {
      if (al > 0) return al--, ll >> al & 1;
      if ((ll = ka[Za++]) == 255) {
        var Ul = ka[Za++];
        if (Ul) throw new Error("unexpected marker: " + (ll << 8 | Ul).toString(16));
      }
      return al = 7, ll >>> 7;
    }
    function dl(Ul) {
      for (var hl, Cl = Ul; (hl = sl()) !== null; ) {
        if (typeof (Cl = Cl[hl]) == "number") return Cl;
        if (typeof Cl != "object") throw new Error("invalid huffman sequence");
      }
      return null;
    }
    function El(Ul) {
      for (var hl = 0; Ul > 0; ) {
        var Cl = sl();
        if (Cl === null) return;
        hl = hl << 1 | Cl, Ul--;
      }
      return hl;
    }
    function fl(Ul) {
      var hl = El(Ul);
      return hl >= 1 << Ul - 1 ? hl : hl + (-1 << Ul) + 1;
    }
    var Ml, Sl = 0, ml = 0;
    function Dl(Ul, hl, Cl, Il, Ll) {
      var tc = Cl % rl, nc = (Cl / rl | 0) * Ul.v + Il, uc = tc * Ul.h + Ll;
      Ul.blocks[nc] === void 0 && nl.tolerantDecoding || hl(Ul, Ul.blocks[nc][uc]);
    }
    function _l(Ul, hl, Cl) {
      var Il = Cl / Ul.blocksPerLine | 0, Ll = Cl % Ul.blocksPerLine;
      Ul.blocks[Il] === void 0 && nl.tolerantDecoding || hl(Ul, Ul.blocks[Il][Ll]);
    }
    var gl, Fl, Nl, zl, Zl, kl, ul = Ka.length;
    kl = il ? el === 0 ? tl === 0 ? function(Ul, hl) {
      var Cl = dl(Ul.huffmanTableDC), Il = Cl === 0 ? 0 : fl(Cl) << Qa;
      hl[0] = Ul.pred += Il;
    } : function(Ul, hl) {
      hl[0] |= sl() << Qa;
    } : tl === 0 ? function(Ul, hl) {
      if (Sl > 0) Sl--;
      else for (var Cl = el, Il = qa; Cl <= Il; ) {
        var Ll = dl(Ul.huffmanTableAC), tc = 15 & Ll, nc = Ll >> 4;
        if (tc !== 0) hl[Xn[Cl += nc]] = fl(tc) * (1 << Qa), Cl++;
        else {
          if (nc < 15) {
            Sl = El(nc) + (1 << nc) - 1;
            break;
          }
          Cl += 16;
        }
      }
    } : function(Ul, hl) {
      for (var Cl = el, Il = qa, Ll = 0; Cl <= Il; ) {
        var tc = Xn[Cl], nc = hl[tc] < 0 ? -1 : 1;
        switch (ml) {
          case 0:
            var uc = dl(Ul.huffmanTableAC), _c = 15 & uc;
            if (Ll = uc >> 4, _c === 0) Ll < 15 ? (Sl = El(Ll) + (1 << Ll), ml = 4) : (Ll = 16, ml = 1);
            else {
              if (_c !== 1) throw new Error("invalid ACn encoding");
              Ml = fl(_c), ml = Ll ? 2 : 3;
            }
            continue;
          case 1:
          case 2:
            hl[tc] ? hl[tc] += (sl() << Qa) * nc : --Ll == 0 && (ml = ml == 2 ? 3 : 0);
            break;
          case 3:
            hl[tc] ? hl[tc] += (sl() << Qa) * nc : (hl[tc] = Ml << Qa, ml = 0);
            break;
          case 4:
            hl[tc] && (hl[tc] += (sl() << Qa) * nc);
        }
        Cl++;
      }
      ml === 4 && --Sl == 0 && (ml = 0);
    } : function(Ul, hl) {
      var Cl = dl(Ul.huffmanTableDC), Il = Cl === 0 ? 0 : fl(Cl);
      hl[0] = Ul.pred += Il;
      for (var Ll = 1; Ll < 64; ) {
        var tc = dl(Ul.huffmanTableAC), nc = 15 & tc, uc = tc >> 4;
        if (nc !== 0) hl[Xn[Ll += uc]] = fl(nc), Ll++;
        else {
          if (uc < 15) break;
          Ll += 16;
        }
      }
    };
    var vl, Tl, wl, yl, Rl = 0;
    for (Tl = ul == 1 ? Ka[0].blocksPerLine * Ka[0].blocksPerColumn : rl * Na.mcusPerColumn, Ja || (Ja = Tl); Rl < Tl; ) {
      for (Fl = 0; Fl < ul; Fl++) Ka[Fl].pred = 0;
      if (Sl = 0, ul == 1) for (gl = Ka[0], Zl = 0; Zl < Ja; Zl++) _l(gl, kl, Rl), Rl++;
      else for (Zl = 0; Zl < Ja; Zl++) {
        for (Fl = 0; Fl < ul; Fl++) for (wl = (gl = Ka[Fl]).h, yl = gl.v, Nl = 0; Nl < yl; Nl++) for (zl = 0; zl < wl; zl++) Dl(gl, kl, Rl, Nl, zl);
        if (++Rl === Tl) break;
      }
      if (Rl === Tl) do {
        if (ka[Za] === 255 && ka[Za + 1] !== 0) break;
        Za += 1;
      } while (Za < ka.length - 2);
      if (al = 0, (vl = ka[Za] << 8 | ka[Za + 1]) < 65280) throw new Error("marker was not found");
      if (!(vl >= 65488 && vl <= 65495)) break;
      Za += 2;
    }
    return Za - cl;
  }
  function xa(ka, Za) {
    var Na, Ka, Ja = [], el = Za.blocksPerLine, qa = Za.blocksPerColumn, tl = el << 3, Qa = new Int32Array(64), nl = new Uint8Array(64);
    function rl(El, fl, Ml) {
      var Sl, ml, Dl, _l, gl, Fl, Nl, zl, Zl, kl, ul = Za.quantizationTable, vl = Ml;
      for (kl = 0; kl < 64; kl++) vl[kl] = El[kl] * ul[kl];
      for (kl = 0; kl < 8; ++kl) {
        var Tl = 8 * kl;
        vl[1 + Tl] != 0 || vl[2 + Tl] != 0 || vl[3 + Tl] != 0 || vl[4 + Tl] != 0 || vl[5 + Tl] != 0 || vl[6 + Tl] != 0 || vl[7 + Tl] != 0 ? (Sl = ma * vl[0 + Tl] + 128 >> 8, ml = ma * vl[4 + Tl] + 128 >> 8, Dl = vl[2 + Tl], _l = vl[6 + Tl], gl = va * (vl[1 + Tl] - vl[7 + Tl]) + 128 >> 8, zl = va * (vl[1 + Tl] + vl[7 + Tl]) + 128 >> 8, Fl = vl[3 + Tl] << 4, Nl = vl[5 + Tl] << 4, Zl = Sl - ml + 1 >> 1, Sl = Sl + ml + 1 >> 1, ml = Zl, Zl = Dl * pa + _l * Jo + 128 >> 8, Dl = Dl * Jo - _l * pa + 128 >> 8, _l = Zl, Zl = gl - Nl + 1 >> 1, gl = gl + Nl + 1 >> 1, Nl = Zl, Zl = zl + Fl + 1 >> 1, Fl = zl - Fl + 1 >> 1, zl = Zl, Zl = Sl - _l + 1 >> 1, Sl = Sl + _l + 1 >> 1, _l = Zl, Zl = ml - Dl + 1 >> 1, ml = ml + Dl + 1 >> 1, Dl = Zl, Zl = gl * qn + zl * Kn + 2048 >> 12, gl = gl * Kn - zl * qn + 2048 >> 12, zl = Zl, Zl = Fl * Un + Nl * zn + 2048 >> 12, Fl = Fl * zn - Nl * Un + 2048 >> 12, Nl = Zl, vl[0 + Tl] = Sl + zl, vl[7 + Tl] = Sl - zl, vl[1 + Tl] = ml + Nl, vl[6 + Tl] = ml - Nl, vl[2 + Tl] = Dl + Fl, vl[5 + Tl] = Dl - Fl, vl[3 + Tl] = _l + gl, vl[4 + Tl] = _l - gl) : (Zl = ma * vl[0 + Tl] + 512 >> 10, vl[0 + Tl] = Zl, vl[1 + Tl] = Zl, vl[2 + Tl] = Zl, vl[3 + Tl] = Zl, vl[4 + Tl] = Zl, vl[5 + Tl] = Zl, vl[6 + Tl] = Zl, vl[7 + Tl] = Zl);
      }
      for (kl = 0; kl < 8; ++kl) {
        var wl = kl;
        vl[8 + wl] != 0 || vl[16 + wl] != 0 || vl[24 + wl] != 0 || vl[32 + wl] != 0 || vl[40 + wl] != 0 || vl[48 + wl] != 0 || vl[56 + wl] != 0 ? (Sl = ma * vl[0 + wl] + 2048 >> 12, ml = ma * vl[32 + wl] + 2048 >> 12, Dl = vl[16 + wl], _l = vl[48 + wl], gl = va * (vl[8 + wl] - vl[56 + wl]) + 2048 >> 12, zl = va * (vl[8 + wl] + vl[56 + wl]) + 2048 >> 12, Fl = vl[24 + wl], Nl = vl[40 + wl], Zl = Sl - ml + 1 >> 1, Sl = Sl + ml + 1 >> 1, ml = Zl, Zl = Dl * pa + _l * Jo + 2048 >> 12, Dl = Dl * Jo - _l * pa + 2048 >> 12, _l = Zl, Zl = gl - Nl + 1 >> 1, gl = gl + Nl + 1 >> 1, Nl = Zl, Zl = zl + Fl + 1 >> 1, Fl = zl - Fl + 1 >> 1, zl = Zl, Zl = Sl - _l + 1 >> 1, Sl = Sl + _l + 1 >> 1, _l = Zl, Zl = ml - Dl + 1 >> 1, ml = ml + Dl + 1 >> 1, Dl = Zl, Zl = gl * qn + zl * Kn + 2048 >> 12, gl = gl * Kn - zl * qn + 2048 >> 12, zl = Zl, Zl = Fl * Un + Nl * zn + 2048 >> 12, Fl = Fl * zn - Nl * Un + 2048 >> 12, Nl = Zl, vl[0 + wl] = Sl + zl, vl[56 + wl] = Sl - zl, vl[8 + wl] = ml + Nl, vl[48 + wl] = ml - Nl, vl[16 + wl] = Dl + Fl, vl[40 + wl] = Dl - Fl, vl[24 + wl] = _l + gl, vl[32 + wl] = _l - gl) : (Zl = ma * Ml[kl + 0] + 8192 >> 14, vl[0 + wl] = Zl, vl[8 + wl] = Zl, vl[16 + wl] = Zl, vl[24 + wl] = Zl, vl[32 + wl] = Zl, vl[40 + wl] = Zl, vl[48 + wl] = Zl, vl[56 + wl] = Zl);
      }
      for (kl = 0; kl < 64; ++kl) {
        var yl = 128 + (vl[kl] + 8 >> 4);
        fl[kl] = yl < 0 ? 0 : yl > 255 ? 255 : yl;
      }
    }
    Ma(tl * qa * 8);
    for (var il = 0; il < qa; il++) {
      var cl = il << 3;
      for (Na = 0; Na < 8; Na++) Ja.push(new Uint8Array(tl));
      for (var ll = 0; ll < el; ll++) {
        rl(Za.blocks[il][ll], nl, Qa);
        var al = 0, sl = ll << 3;
        for (Ka = 0; Ka < 8; Ka++) {
          var dl = Ja[cl + Ka];
          for (Na = 0; Na < 8; Na++) dl[sl + Na] = nl[al++];
        }
      }
    }
    return Ja;
  }
  function wa(ka) {
    return ka < 0 ? 0 : ka > 255 ? 255 : ka;
  }
  ba.prototype = { load: function(ka) {
    var Za = new XMLHttpRequest();
    Za.open("GET", ka, !0), Za.responseType = "arraybuffer", Za.onload = (function() {
      var Na = new Uint8Array(Za.response || Za.mozResponseArrayBuffer);
      this.parse(Na), this.onload && this.onload();
    }).bind(this), Za.send(null);
  }, parse: function(ka) {
    var Za = 1e3 * this.opts.maxResolutionInMP * 1e3, Na = 0;
    function Ka() {
      var mc = ka[Na] << 8 | ka[Na + 1];
      return Na += 2, mc;
    }
    function Ja(mc) {
      var Sc, hc, Lc = 1, Ec = 1;
      for (hc in mc.components) mc.components.hasOwnProperty(hc) && (Lc < (Sc = mc.components[hc]).h && (Lc = Sc.h), Ec < Sc.v && (Ec = Sc.v));
      var Hl = Math.ceil(mc.samplesPerLine / 8 / Lc), fc = Math.ceil(mc.scanLines / 8 / Ec);
      for (hc in mc.components) if (mc.components.hasOwnProperty(hc)) {
        Sc = mc.components[hc];
        var lc = Math.ceil(Math.ceil(mc.samplesPerLine / 8) * Sc.h / Lc), Gl = Math.ceil(Math.ceil(mc.scanLines / 8) * Sc.v / Ec), ql = Hl * Sc.h, Vl = fc * Sc.v, Pl = [];
        Ma(Vl * ql * 256);
        for (var Ol = 0; Ol < Vl; Ol++) {
          for (var cc = [], bl = 0; bl < ql; bl++) cc.push(new Int32Array(64));
          Pl.push(cc);
        }
        Sc.blocksPerLine = lc, Sc.blocksPerColumn = Gl, Sc.blocks = Pl;
      }
      mc.maxH = Lc, mc.maxV = Ec, mc.mcusPerLine = Hl, mc.mcusPerColumn = fc;
    }
    ka.length;
    var el, qa, tl, Qa, nl = null, rl = null, il = [], cl = [], ll = [], al = [], sl = Ka(), dl = -1;
    if (this.comments = [], sl != 65496) throw new Error("SOI not found");
    for (sl = Ka(); sl != 65497; ) {
      switch (sl) {
        case 65280:
          break;
        case 65504:
        case 65505:
        case 65506:
        case 65507:
        case 65508:
        case 65509:
        case 65510:
        case 65511:
        case 65512:
        case 65513:
        case 65514:
        case 65515:
        case 65516:
        case 65517:
        case 65518:
        case 65519:
        case 65534:
          var El = (tl = void 0, Qa = void 0, tl = Ka(), Qa = ka.subarray(Na, Na + tl - 2), Na += Qa.length, Qa);
          if (sl === 65534) {
            var fl = String.fromCharCode.apply(null, El);
            this.comments.push(fl);
          }
          sl === 65504 && El[0] === 74 && El[1] === 70 && El[2] === 73 && El[3] === 70 && El[4] === 0 && (nl = { version: { major: El[5], minor: El[6] }, densityUnits: El[7], xDensity: El[8] << 8 | El[9], yDensity: El[10] << 8 | El[11], thumbWidth: El[12], thumbHeight: El[13], thumbData: El.subarray(14, 14 + 3 * El[12] * El[13]) }), sl === 65505 && El[0] === 69 && El[1] === 120 && El[2] === 105 && El[3] === 102 && El[4] === 0 && (this.exifBuffer = El.subarray(5, El.length)), sl === 65518 && El[0] === 65 && El[1] === 100 && El[2] === 111 && El[3] === 98 && El[4] === 101 && El[5] === 0 && (rl = { version: El[6], flags0: El[7] << 8 | El[8], flags1: El[9] << 8 | El[10], transformCode: El[11] });
          break;
        case 65499:
          for (var Ml = Ka() + Na - 2; Na < Ml; ) {
            var Sl = ka[Na++];
            Ma(256);
            var ml = new Int32Array(64);
            if (Sl >> 4) {
              if (Sl >> 4 != 1) throw new Error("DQT: invalid table spec");
              for (uc = 0; uc < 64; uc++) ml[Xn[uc]] = Ka();
            } else for (uc = 0; uc < 64; uc++) ml[Xn[uc]] = ka[Na++];
            il[15 & Sl] = ml;
          }
          break;
        case 65472:
        case 65473:
        case 65474:
          Ka(), (el = {}).extended = sl === 65473, el.progressive = sl === 65474, el.precision = ka[Na++], el.scanLines = Ka(), el.samplesPerLine = Ka(), el.components = {}, el.componentsOrder = [];
          var Dl = el.scanLines * el.samplesPerLine;
          if (Dl > Za) {
            var _l = Math.ceil((Dl - Za) / 1e6);
            throw new Error(`maxResolutionInMP limit exceeded by ${_l}MP`);
          }
          var gl, Fl = ka[Na++];
          for (tc = 0; tc < Fl; tc++) {
            gl = ka[Na];
            var Nl = ka[Na + 1] >> 4, zl = 15 & ka[Na + 1], Zl = ka[Na + 2];
            if (Nl <= 0 || zl <= 0) throw new Error("Invalid sampling factor, expected values above 0");
            el.componentsOrder.push(gl), el.components[gl] = { h: Nl, v: zl, quantizationIdx: Zl }, Na += 3;
          }
          Ja(el), cl.push(el);
          break;
        case 65476:
          var kl = Ka();
          for (tc = 2; tc < kl; ) {
            var ul = ka[Na++], vl = new Uint8Array(16), Tl = 0;
            for (uc = 0; uc < 16; uc++, Na++) Tl += vl[uc] = ka[Na];
            Ma(16 + Tl);
            var wl = new Uint8Array(Tl);
            for (uc = 0; uc < Tl; uc++, Na++) wl[uc] = ka[Na];
            tc += 17 + Tl, (ul >> 4 ? ll : al)[15 & ul] = _a(vl, wl);
          }
          break;
        case 65501:
          Ka(), qa = Ka();
          break;
        case 65500:
          Ka(), Ka();
          break;
        case 65498:
          Ka();
          var yl = ka[Na++], Rl = [];
          for (tc = 0; tc < yl; tc++) {
            _c = el.components[ka[Na++]];
            var Ul = ka[Na++];
            _c.huffmanTableDC = al[Ul >> 4], _c.huffmanTableAC = ll[15 & Ul], Rl.push(_c);
          }
          var hl = ka[Na++], Cl = ka[Na++], Il = ka[Na++], Ll = ya(ka, Na, el, Rl, qa, hl, Cl, Il >> 4, 15 & Il, this.opts);
          Na += Ll;
          break;
        case 65535:
          ka[Na] !== 255 && Na--;
          break;
        default:
          if (ka[Na - 3] == 255 && ka[Na - 2] >= 192 && ka[Na - 2] <= 254) {
            Na -= 3;
            break;
          }
          if (sl === 224 || sl == 225) {
            if (dl !== -1) throw new Error(`first unknown JPEG marker at offset ${dl.toString(16)}, second unknown JPEG marker ${sl.toString(16)} at offset ${(Na - 1).toString(16)}`);
            dl = Na - 1;
            const mc = Ka();
            if (ka[Na + mc - 2] === 255) {
              Na += mc - 2;
              break;
            }
          }
          throw new Error("unknown JPEG marker " + sl.toString(16));
      }
      sl = Ka();
    }
    if (cl.length != 1) throw new Error("only single frame JPEGs supported");
    for (var tc = 0; tc < cl.length; tc++) {
      var nc = cl[tc].components;
      for (var uc in nc) nc[uc].quantizationTable = il[nc[uc].quantizationIdx], delete nc[uc].quantizationIdx;
    }
    for (this.width = el.samplesPerLine, this.height = el.scanLines, this.jfif = nl, this.adobe = rl, this.components = [], tc = 0; tc < el.componentsOrder.length; tc++) {
      var _c = el.components[el.componentsOrder[tc]];
      this.components.push({ lines: xa(0, _c), scaleX: _c.h / el.maxH, scaleY: _c.v / el.maxV });
    }
  }, getData: function(ka, Za) {
    var Na, Ka, Ja, el, qa, tl, Qa, nl, rl, il, cl, ll, al, sl, dl, El, fl, Ml, Sl, ml, Dl, _l = this.width / ka, gl = this.height / Za, Fl = 0, Nl = ka * Za * this.components.length;
    Ma(Nl);
    var zl = new Uint8Array(Nl);
    switch (this.components.length) {
      case 1:
        for (Na = this.components[0], il = 0; il < Za; il++) for (qa = Na.lines[0 | il * Na.scaleY * gl], rl = 0; rl < ka; rl++) cl = qa[0 | rl * Na.scaleX * _l], zl[Fl++] = cl;
        break;
      case 2:
        for (Na = this.components[0], Ka = this.components[1], il = 0; il < Za; il++) for (qa = Na.lines[0 | il * Na.scaleY * gl], tl = Ka.lines[0 | il * Ka.scaleY * gl], rl = 0; rl < ka; rl++) cl = qa[0 | rl * Na.scaleX * _l], zl[Fl++] = cl, cl = tl[0 | rl * Ka.scaleX * _l], zl[Fl++] = cl;
        break;
      case 3:
        for (Dl = !0, this.adobe && this.adobe.transformCode ? Dl = !0 : this.opts.colorTransform !== void 0 && (Dl = !!this.opts.colorTransform), Na = this.components[0], Ka = this.components[1], Ja = this.components[2], il = 0; il < Za; il++) for (qa = Na.lines[0 | il * Na.scaleY * gl], tl = Ka.lines[0 | il * Ka.scaleY * gl], Qa = Ja.lines[0 | il * Ja.scaleY * gl], rl = 0; rl < ka; rl++) Dl ? (cl = qa[0 | rl * Na.scaleX * _l], ll = tl[0 | rl * Ka.scaleX * _l], Ml = wa(cl + 1.402 * ((al = Qa[0 | rl * Ja.scaleX * _l]) - 128)), Sl = wa(cl - 0.3441363 * (ll - 128) - 0.71413636 * (al - 128)), ml = wa(cl + 1.772 * (ll - 128))) : (Ml = qa[0 | rl * Na.scaleX * _l], Sl = tl[0 | rl * Ka.scaleX * _l], ml = Qa[0 | rl * Ja.scaleX * _l]), zl[Fl++] = Ml, zl[Fl++] = Sl, zl[Fl++] = ml;
        break;
      case 4:
        if (!this.adobe) throw new Error("Unsupported color mode (4 components)");
        for (Dl = !1, this.adobe && this.adobe.transformCode ? Dl = !0 : this.opts.colorTransform !== void 0 && (Dl = !!this.opts.colorTransform), Na = this.components[0], Ka = this.components[1], Ja = this.components[2], el = this.components[3], il = 0; il < Za; il++) for (qa = Na.lines[0 | il * Na.scaleY * gl], tl = Ka.lines[0 | il * Ka.scaleY * gl], Qa = Ja.lines[0 | il * Ja.scaleY * gl], nl = el.lines[0 | il * el.scaleY * gl], rl = 0; rl < ka; rl++) Dl ? (cl = qa[0 | rl * Na.scaleX * _l], ll = tl[0 | rl * Ka.scaleX * _l], al = Qa[0 | rl * Ja.scaleX * _l], sl = nl[0 | rl * el.scaleX * _l], dl = 255 - wa(cl + 1.402 * (al - 128)), El = 255 - wa(cl - 0.3441363 * (ll - 128) - 0.71413636 * (al - 128)), fl = 255 - wa(cl + 1.772 * (ll - 128))) : (dl = qa[0 | rl * Na.scaleX * _l], El = tl[0 | rl * Ka.scaleX * _l], fl = Qa[0 | rl * Ja.scaleX * _l], sl = nl[0 | rl * el.scaleX * _l]), zl[Fl++] = 255 - dl, zl[Fl++] = 255 - El, zl[Fl++] = 255 - fl, zl[Fl++] = 255 - sl;
        break;
      default:
        throw new Error("Unsupported color mode");
    }
    return zl;
  }, copyToImageData: function(ka, Za) {
    var Na, Ka, Ja, el, qa, tl, Qa, nl, rl, il = ka.width, cl = ka.height, ll = ka.data, al = this.getData(il, cl), sl = 0, dl = 0;
    switch (this.components.length) {
      case 1:
        for (Ka = 0; Ka < cl; Ka++) for (Na = 0; Na < il; Na++) Ja = al[sl++], ll[dl++] = Ja, ll[dl++] = Ja, ll[dl++] = Ja, Za && (ll[dl++] = 255);
        break;
      case 3:
        for (Ka = 0; Ka < cl; Ka++) for (Na = 0; Na < il; Na++) Qa = al[sl++], nl = al[sl++], rl = al[sl++], ll[dl++] = Qa, ll[dl++] = nl, ll[dl++] = rl, Za && (ll[dl++] = 255);
        break;
      case 4:
        for (Ka = 0; Ka < cl; Ka++) for (Na = 0; Na < il; Na++) qa = al[sl++], tl = al[sl++], Ja = al[sl++], Qa = 255 - wa(qa * (1 - (el = al[sl++]) / 255) + el), nl = 255 - wa(tl * (1 - el / 255) + el), rl = 255 - wa(Ja * (1 - el / 255) + el), ll[dl++] = Qa, ll[dl++] = nl, ll[dl++] = rl, Za && (ll[dl++] = 255);
        break;
      default:
        throw new Error("Unsupported color mode");
    }
  } };
  var Ta = 0, Sa = 0;
  function Ma(ka = 0) {
    var Za = Ta + ka;
    if (Za > Sa) {
      var Na = Math.ceil((Za - Sa) / 1024 / 1024);
      throw new Error(`maxMemoryUsageInMB limit exceeded by at least ${Na}MB`);
    }
    Ta = Za;
  }
  return ba.resetMaxMemoryUsage = function(ka) {
    Ta = 0, Sa = ka;
  }, ba.getBytesAllocated = function() {
    return Ta;
  }, ba.requestMemoryAllocation = Ma, ba;
}(), module.exports = function(Xn, zn = {}) {
  var Un = { colorTransform: void 0, useTArray: !1, formatAsRGBA: !0, tolerantDecoding: !0, maxResolutionInMP: 100, maxMemoryUsageInMB: 512, ...zn }, Kn = new Uint8Array(Xn), qn = new JpegImage();
  qn.opts = Un, JpegImage.resetMaxMemoryUsage(1024 * Un.maxMemoryUsageInMB * 1024), qn.parse(Kn);
  var Jo = Un.formatAsRGBA ? 4 : 3, pa = qn.width * qn.height * Jo;
  try {
    JpegImage.requestMemoryAllocation(pa);
    var ma = { width: qn.width, height: qn.height, exifBuffer: qn.exifBuffer, data: Un.useTArray ? new Uint8Array(pa) : Buffer$1.alloc(pa) };
    qn.comments.length > 0 && (ma.comments = qn.comments);
  } catch (va) {
    throw va instanceof RangeError ? new Error("Could not allocate enough memory for the image. Required: " + pa) : va instanceof ReferenceError && va.message === "Buffer is not defined" ? new Error("Buffer is not globally defined in this environment. Consider setting useTArray to true") : va;
  }
  return qn.copyToImageData(ma, Un.formatAsRGBA), ma;
};
var decoderExports = decoder.exports, encode = encoderExports, decode = decoderExports, jpegJs = { encode, decode }, JPEG = getDefaultExportFromCjs(jpegJs);
function jpeg$2() {
  return { mime: "image/jpeg", encode: (Xn, { quality: zn = 100 } = {}) => JPEG.encode(Xn, zn).data, decode: (Xn, zn) => JPEG.decode(Xn, zn) };
}
function commonjsRequire(Xn) {
  throw new Error('Could not dynamically require "' + Xn + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var browser$1 = { exports: {} };
browser$1.exports = (/* @__PURE__ */ function() {
  function Xn(zn, Un, Kn) {
    function qn(ma, va) {
      if (!Un[ma]) {
        if (!zn[ma]) {
          var ba = typeof commonjsRequire == "function" && commonjsRequire;
          if (!va && ba) return ba(ma, !0);
          if (Jo) return Jo(ma, !0);
          var _a = new Error("Cannot find module '" + ma + "'");
          throw _a.code = "MODULE_NOT_FOUND", _a;
        }
        var ya = Un[ma] = { exports: {} };
        zn[ma][0].call(ya.exports, function(xa) {
          return qn(zn[ma][1][xa] || xa);
        }, ya, ya.exports, Xn, zn, Un, Kn);
      }
      return Un[ma].exports;
    }
    for (var Jo = typeof commonjsRequire == "function" && commonjsRequire, pa = 0; pa < Kn.length; pa++) qn(Kn[pa]);
    return qn;
  }
  return Xn;
}())({ 1: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("./interlace"), Jo = [function() {
      }, function(_a, ya, xa, wa) {
        if (wa === ya.length) throw new Error("Ran out of data");
        let Ta = ya[wa];
        _a[xa] = Ta, _a[xa + 1] = Ta, _a[xa + 2] = Ta, _a[xa + 3] = 255;
      }, function(_a, ya, xa, wa) {
        if (wa + 1 >= ya.length) throw new Error("Ran out of data");
        let Ta = ya[wa];
        _a[xa] = Ta, _a[xa + 1] = Ta, _a[xa + 2] = Ta, _a[xa + 3] = ya[wa + 1];
      }, function(_a, ya, xa, wa) {
        if (wa + 2 >= ya.length) throw new Error("Ran out of data");
        _a[xa] = ya[wa], _a[xa + 1] = ya[wa + 1], _a[xa + 2] = ya[wa + 2], _a[xa + 3] = 255;
      }, function(_a, ya, xa, wa) {
        if (wa + 3 >= ya.length) throw new Error("Ran out of data");
        _a[xa] = ya[wa], _a[xa + 1] = ya[wa + 1], _a[xa + 2] = ya[wa + 2], _a[xa + 3] = ya[wa + 3];
      }], pa = [function() {
      }, function(_a, ya, xa, wa) {
        let Ta = ya[0];
        _a[xa] = Ta, _a[xa + 1] = Ta, _a[xa + 2] = Ta, _a[xa + 3] = wa;
      }, function(_a, ya, xa) {
        let wa = ya[0];
        _a[xa] = wa, _a[xa + 1] = wa, _a[xa + 2] = wa, _a[xa + 3] = ya[1];
      }, function(_a, ya, xa, wa) {
        _a[xa] = ya[0], _a[xa + 1] = ya[1], _a[xa + 2] = ya[2], _a[xa + 3] = wa;
      }, function(_a, ya, xa) {
        _a[xa] = ya[0], _a[xa + 1] = ya[1], _a[xa + 2] = ya[2], _a[xa + 3] = ya[3];
      }];
      function ma(_a, ya) {
        let xa = [], wa = 0;
        function Ta() {
          if (wa === _a.length) throw new Error("Ran out of data");
          let Sa, Ma, ka, Za, Na, Ka, Ja, el, qa = _a[wa];
          switch (wa++, ya) {
            default:
              throw new Error("unrecognised depth");
            case 16:
              Ja = _a[wa], wa++, xa.push((qa << 8) + Ja);
              break;
            case 4:
              Ja = 15 & qa, el = qa >> 4, xa.push(el, Ja);
              break;
            case 2:
              Na = 3 & qa, Ka = qa >> 2 & 3, Ja = qa >> 4 & 3, el = qa >> 6 & 3, xa.push(el, Ja, Ka, Na);
              break;
            case 1:
              Sa = 1 & qa, Ma = qa >> 1 & 1, ka = qa >> 2 & 1, Za = qa >> 3 & 1, Na = qa >> 4 & 1, Ka = qa >> 5 & 1, Ja = qa >> 6 & 1, el = qa >> 7 & 1, xa.push(el, Ja, Ka, Na, Za, ka, Ma, Sa);
          }
        }
        return { get: function(Sa) {
          for (; xa.length < Sa; ) Ta();
          let Ma = xa.slice(0, Sa);
          return xa = xa.slice(Sa), Ma;
        }, resetAfterLine: function() {
          xa.length = 0;
        }, end: function() {
          if (wa !== _a.length) throw new Error("extra data found");
        } };
      }
      function va(_a, ya, xa, wa, Ta, Sa) {
        let Ma = _a.width, ka = _a.height, Za = _a.index;
        for (let Na = 0; Na < ka; Na++) for (let Ka = 0; Ka < Ma; Ka++) {
          let Ja = xa(Ka, Na, Za);
          Jo[wa](ya, Ta, Ja, Sa), Sa += wa;
        }
        return Sa;
      }
      function ba(_a, ya, xa, wa, Ta, Sa) {
        let Ma = _a.width, ka = _a.height, Za = _a.index;
        for (let Na = 0; Na < ka; Na++) {
          for (let Ka = 0; Ka < Ma; Ka++) {
            let Ja = Ta.get(wa), el = xa(Ka, Na, Za);
            pa[wa](ya, Ja, el, Sa);
          }
          Ta.resetAfterLine();
        }
      }
      Un.dataToBitMap = function(_a, ya) {
        let xa, wa, Ta = ya.width, Sa = ya.height, Ma = ya.depth, ka = ya.bpp, Za = ya.interlace;
        Ma !== 8 && (xa = ma(_a, Ma)), wa = Ma <= 8 ? Kn.alloc(Ta * Sa * 4) : new Uint16Array(Ta * Sa * 4);
        let Na, Ka, Ja = Math.pow(2, Ma) - 1, el = 0;
        if (Za) Na = qn.getImagePasses(Ta, Sa), Ka = qn.getInterlaceIterator(Ta, Sa);
        else {
          let qa = 0;
          Ka = function() {
            let tl = qa;
            return qa += 4, tl;
          }, Na = [{ width: Ta, height: Sa }];
        }
        for (let qa = 0; qa < Na.length; qa++) Ma === 8 ? el = va(Na[qa], wa, Ka, ka, _a, el) : ba(Na[qa], wa, Ka, ka, xa, Ja);
        if (Ma === 8) {
          if (el !== _a.length) throw new Error("extra data found");
        } else xa.end();
        return wa;
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./interlace": 11, buffer: 32 }], 2: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("./constants");
      zn.exports = function(Jo, pa, ma, va) {
        let ba = [qn.COLORTYPE_COLOR_ALPHA, qn.COLORTYPE_ALPHA].indexOf(va.colorType) !== -1;
        if (va.colorType === va.inputColorType) {
          let Na = function() {
            let Ka = new ArrayBuffer(2);
            return new DataView(Ka).setInt16(0, 256, !0), new Int16Array(Ka)[0] !== 256;
          }();
          if (va.bitDepth === 8 || va.bitDepth === 16 && Na) return Jo;
        }
        let _a = va.bitDepth !== 16 ? Jo : new Uint16Array(Jo.buffer), ya = 255, xa = qn.COLORTYPE_TO_BPP_MAP[va.inputColorType];
        xa !== 4 || va.inputHasAlpha || (xa = 3);
        let wa = qn.COLORTYPE_TO_BPP_MAP[va.colorType];
        va.bitDepth === 16 && (ya = 65535, wa *= 2);
        let Ta = Kn.alloc(pa * ma * wa), Sa = 0, Ma = 0, ka = va.bgColor || {};
        function Za() {
          let Na, Ka, Ja, el = ya;
          switch (va.inputColorType) {
            case qn.COLORTYPE_COLOR_ALPHA:
              el = _a[Sa + 3], Na = _a[Sa], Ka = _a[Sa + 1], Ja = _a[Sa + 2];
              break;
            case qn.COLORTYPE_COLOR:
              Na = _a[Sa], Ka = _a[Sa + 1], Ja = _a[Sa + 2];
              break;
            case qn.COLORTYPE_ALPHA:
              el = _a[Sa + 1], Na = _a[Sa], Ka = Na, Ja = Na;
              break;
            case qn.COLORTYPE_GRAYSCALE:
              Na = _a[Sa], Ka = Na, Ja = Na;
              break;
            default:
              throw new Error("input color type:" + va.inputColorType + " is not supported at present");
          }
          return va.inputHasAlpha && (ba || (el /= ya, Na = Math.min(Math.max(Math.round((1 - el) * ka.red + el * Na), 0), ya), Ka = Math.min(Math.max(Math.round((1 - el) * ka.green + el * Ka), 0), ya), Ja = Math.min(Math.max(Math.round((1 - el) * ka.blue + el * Ja), 0), ya))), { red: Na, green: Ka, blue: Ja, alpha: el };
        }
        ka.red === void 0 && (ka.red = ya), ka.green === void 0 && (ka.green = ya), ka.blue === void 0 && (ka.blue = ya);
        for (let Na = 0; Na < ma; Na++) for (let Ka = 0; Ka < pa; Ka++) {
          let Ja = Za();
          switch (va.colorType) {
            case qn.COLORTYPE_COLOR_ALPHA:
            case qn.COLORTYPE_COLOR:
              va.bitDepth === 8 ? (Ta[Ma] = Ja.red, Ta[Ma + 1] = Ja.green, Ta[Ma + 2] = Ja.blue, ba && (Ta[Ma + 3] = Ja.alpha)) : (Ta.writeUInt16BE(Ja.red, Ma), Ta.writeUInt16BE(Ja.green, Ma + 2), Ta.writeUInt16BE(Ja.blue, Ma + 4), ba && Ta.writeUInt16BE(Ja.alpha, Ma + 6));
              break;
            case qn.COLORTYPE_ALPHA:
            case qn.COLORTYPE_GRAYSCALE: {
              let el = (Ja.red + Ja.green + Ja.blue) / 3;
              va.bitDepth === 8 ? (Ta[Ma] = el, ba && (Ta[Ma + 1] = Ja.alpha)) : (Ta.writeUInt16BE(el, Ma), ba && Ta.writeUInt16BE(Ja.alpha, Ma + 2));
              break;
            }
            default:
              throw new Error("unrecognised color Type " + va.colorType);
          }
          Sa += xa, Ma += wa;
        }
        return Ta;
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./constants": 4, buffer: 32 }], 3: [function(Xn, zn, Un) {
  (function(Kn, qn) {
    (function() {
      let Jo = Xn("util"), pa = Xn("stream"), ma = zn.exports = function() {
        pa.call(this), this._buffers = [], this._buffered = 0, this._reads = [], this._paused = !1, this._encoding = "utf8", this.writable = !0;
      };
      Jo.inherits(ma, pa), ma.prototype.read = function(va, ba) {
        this._reads.push({ length: Math.abs(va), allowLess: va < 0, func: ba }), Kn.nextTick((function() {
          this._process(), this._paused && this._reads && this._reads.length > 0 && (this._paused = !1, this.emit("drain"));
        }).bind(this));
      }, ma.prototype.write = function(va, ba) {
        if (!this.writable) return this.emit("error", new Error("Stream not writable")), !1;
        let _a;
        return _a = qn.isBuffer(va) ? va : qn.from(va, ba || this._encoding), this._buffers.push(_a), this._buffered += _a.length, this._process(), this._reads && this._reads.length === 0 && (this._paused = !0), this.writable && !this._paused;
      }, ma.prototype.end = function(va, ba) {
        va && this.write(va, ba), this.writable = !1, this._buffers && (this._buffers.length === 0 ? this._end() : (this._buffers.push(null), this._process()));
      }, ma.prototype.destroySoon = ma.prototype.end, ma.prototype._end = function() {
        this._reads.length > 0 && this.emit("error", new Error("Unexpected end of input")), this.destroy();
      }, ma.prototype.destroy = function() {
        this._buffers && (this.writable = !1, this._reads = null, this._buffers = null, this.emit("close"));
      }, ma.prototype._processReadAllowingLess = function(va) {
        this._reads.shift();
        let ba = this._buffers[0];
        ba.length > va.length ? (this._buffered -= va.length, this._buffers[0] = ba.slice(va.length), va.func.call(this, ba.slice(0, va.length))) : (this._buffered -= ba.length, this._buffers.shift(), va.func.call(this, ba));
      }, ma.prototype._processRead = function(va) {
        this._reads.shift();
        let ba = 0, _a = 0, ya = qn.alloc(va.length);
        for (; ba < va.length; ) {
          let xa = this._buffers[_a++], wa = Math.min(xa.length, va.length - ba);
          xa.copy(ya, ba, 0, wa), ba += wa, wa !== xa.length && (this._buffers[--_a] = xa.slice(wa));
        }
        _a > 0 && this._buffers.splice(0, _a), this._buffered -= va.length, va.func.call(this, ya);
      }, ma.prototype._process = function() {
        try {
          for (; this._buffered > 0 && this._reads && this._reads.length > 0; ) {
            let va = this._reads[0];
            if (va.allowLess) this._processReadAllowingLess(va);
            else {
              if (!(this._buffered >= va.length)) break;
              this._processRead(va);
            }
          }
          this._buffers && !this.writable && this._end();
        } catch (va) {
          this.emit("error", va);
        }
      };
    }).call(this);
  }).call(this, Xn("_process"), Xn("buffer").Buffer);
}, { _process: 63, buffer: 32, stream: 65, util: 84 }], 4: [function(Xn, zn, Un) {
  zn.exports = { PNG_SIGNATURE: [137, 80, 78, 71, 13, 10, 26, 10], TYPE_IHDR: 1229472850, TYPE_IEND: 1229278788, TYPE_IDAT: 1229209940, TYPE_PLTE: 1347179589, TYPE_tRNS: 1951551059, TYPE_gAMA: 1732332865, COLORTYPE_GRAYSCALE: 0, COLORTYPE_PALETTE: 1, COLORTYPE_COLOR: 2, COLORTYPE_ALPHA: 4, COLORTYPE_PALETTE_COLOR: 3, COLORTYPE_COLOR_ALPHA: 6, COLORTYPE_TO_BPP_MAP: { 0: 1, 2: 3, 3: 1, 4: 2, 6: 4 }, GAMMA_DIVISION: 1e5 };
}, {}], 5: [function(Xn, zn, Un) {
  let Kn = [];
  (function() {
    for (let Jo = 0; Jo < 256; Jo++) {
      let pa = Jo;
      for (let ma = 0; ma < 8; ma++) 1 & pa ? pa = 3988292384 ^ pa >>> 1 : pa >>>= 1;
      Kn[Jo] = pa;
    }
  })();
  let qn = zn.exports = function() {
    this._crc = -1;
  };
  qn.prototype.write = function(Jo) {
    for (let pa = 0; pa < Jo.length; pa++) this._crc = Kn[255 & (this._crc ^ Jo[pa])] ^ this._crc >>> 8;
    return !0;
  }, qn.prototype.crc32 = function() {
    return ~this._crc;
  }, qn.crc32 = function(Jo) {
    let pa = -1;
    for (let ma = 0; ma < Jo.length; ma++) pa = Kn[255 & (pa ^ Jo[ma])] ^ pa >>> 8;
    return ~pa;
  };
}, {}], 6: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("./paeth-predictor");
      function Jo(ka, Za, Na, Ka, Ja) {
        for (let el = 0; el < Na; el++) Ka[Ja + el] = ka[Za + el];
      }
      function pa(ka, Za, Na) {
        let Ka = 0, Ja = Za + Na;
        for (let el = Za; el < Ja; el++) Ka += Math.abs(ka[el]);
        return Ka;
      }
      function ma(ka, Za, Na, Ka, Ja, el) {
        for (let qa = 0; qa < Na; qa++) {
          let tl = qa >= el ? ka[Za + qa - el] : 0, Qa = ka[Za + qa] - tl;
          Ka[Ja + qa] = Qa;
        }
      }
      function va(ka, Za, Na, Ka) {
        let Ja = 0;
        for (let el = 0; el < Na; el++) {
          let qa = el >= Ka ? ka[Za + el - Ka] : 0, tl = ka[Za + el] - qa;
          Ja += Math.abs(tl);
        }
        return Ja;
      }
      function ba(ka, Za, Na, Ka, Ja) {
        for (let el = 0; el < Na; el++) {
          let qa = Za > 0 ? ka[Za + el - Na] : 0, tl = ka[Za + el] - qa;
          Ka[Ja + el] = tl;
        }
      }
      function _a(ka, Za, Na) {
        let Ka = 0, Ja = Za + Na;
        for (let el = Za; el < Ja; el++) {
          let qa = Za > 0 ? ka[el - Na] : 0, tl = ka[el] - qa;
          Ka += Math.abs(tl);
        }
        return Ka;
      }
      function ya(ka, Za, Na, Ka, Ja, el) {
        for (let qa = 0; qa < Na; qa++) {
          let tl = qa >= el ? ka[Za + qa - el] : 0, Qa = Za > 0 ? ka[Za + qa - Na] : 0, nl = ka[Za + qa] - (tl + Qa >> 1);
          Ka[Ja + qa] = nl;
        }
      }
      function xa(ka, Za, Na, Ka) {
        let Ja = 0;
        for (let el = 0; el < Na; el++) {
          let qa = el >= Ka ? ka[Za + el - Ka] : 0, tl = Za > 0 ? ka[Za + el - Na] : 0, Qa = ka[Za + el] - (qa + tl >> 1);
          Ja += Math.abs(Qa);
        }
        return Ja;
      }
      function wa(ka, Za, Na, Ka, Ja, el) {
        for (let qa = 0; qa < Na; qa++) {
          let tl = qa >= el ? ka[Za + qa - el] : 0, Qa = Za > 0 ? ka[Za + qa - Na] : 0, nl = Za > 0 && qa >= el ? ka[Za + qa - (Na + el)] : 0, rl = ka[Za + qa] - qn(tl, Qa, nl);
          Ka[Ja + qa] = rl;
        }
      }
      function Ta(ka, Za, Na, Ka) {
        let Ja = 0;
        for (let el = 0; el < Na; el++) {
          let qa = el >= Ka ? ka[Za + el - Ka] : 0, tl = Za > 0 ? ka[Za + el - Na] : 0, Qa = Za > 0 && el >= Ka ? ka[Za + el - (Na + Ka)] : 0, nl = ka[Za + el] - qn(qa, tl, Qa);
          Ja += Math.abs(nl);
        }
        return Ja;
      }
      let Sa = { 0: Jo, 1: ma, 2: ba, 3: ya, 4: wa }, Ma = { 0: pa, 1: va, 2: _a, 3: xa, 4: Ta };
      zn.exports = function(ka, Za, Na, Ka, Ja) {
        let el;
        if ("filterType" in Ka && Ka.filterType !== -1) {
          if (typeof Ka.filterType != "number") throw new Error("unrecognised filter types");
          el = [Ka.filterType];
        } else el = [0, 1, 2, 3, 4];
        Ka.bitDepth === 16 && (Ja *= 2);
        let qa = Za * Ja, tl = 0, Qa = 0, nl = Kn.alloc((qa + 1) * Na), rl = el[0];
        for (let il = 0; il < Na; il++) {
          if (el.length > 1) {
            let cl = 1 / 0;
            for (let ll = 0; ll < el.length; ll++) {
              let al = Ma[el[ll]](ka, Qa, qa, Ja);
              al < cl && (rl = el[ll], cl = al);
            }
          }
          nl[tl] = rl, tl++, Sa[rl](ka, Qa, qa, nl, tl, Ja), tl += qa, Qa += qa;
        }
        return nl;
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./paeth-predictor": 15, buffer: 32 }], 7: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("util"), Jo = Xn("./chunkstream"), pa = Xn("./filter-parse"), ma = zn.exports = function(va) {
        Jo.call(this);
        let ba = [], _a = this;
        this._filter = new pa(va, { read: this.read.bind(this), write: function(ya) {
          ba.push(ya);
        }, complete: function() {
          _a.emit("complete", Kn.concat(ba));
        } }), this._filter.start();
      };
      qn.inherits(ma, Jo);
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./chunkstream": 3, "./filter-parse": 9, buffer: 32, util: 84 }], 8: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("./sync-reader"), Jo = Xn("./filter-parse");
      Un.process = function(pa, ma) {
        let va = [], ba = new qn(pa);
        return new Jo(ma, { read: ba.read.bind(ba), write: function(_a) {
          va.push(_a);
        }, complete: function() {
        } }).start(), ba.process(), Kn.concat(va);
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./filter-parse": 9, "./sync-reader": 22, buffer: 32 }], 9: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("./interlace"), Jo = Xn("./paeth-predictor");
      function pa(va, ba, _a) {
        let ya = va * ba;
        return _a !== 8 && (ya = Math.ceil(ya / (8 / _a))), ya;
      }
      let ma = zn.exports = function(va, ba) {
        let _a = va.width, ya = va.height, xa = va.interlace, wa = va.bpp, Ta = va.depth;
        if (this.read = ba.read, this.write = ba.write, this.complete = ba.complete, this._imageIndex = 0, this._images = [], xa) {
          let Sa = qn.getImagePasses(_a, ya);
          for (let Ma = 0; Ma < Sa.length; Ma++) this._images.push({ byteWidth: pa(Sa[Ma].width, wa, Ta), height: Sa[Ma].height, lineIndex: 0 });
        } else this._images.push({ byteWidth: pa(_a, wa, Ta), height: ya, lineIndex: 0 });
        this._xComparison = Ta === 8 ? wa : Ta === 16 ? 2 * wa : 1;
      };
      ma.prototype.start = function() {
        this.read(this._images[this._imageIndex].byteWidth + 1, this._reverseFilterLine.bind(this));
      }, ma.prototype._unFilterType1 = function(va, ba, _a) {
        let ya = this._xComparison, xa = ya - 1;
        for (let wa = 0; wa < _a; wa++) {
          let Ta = va[1 + wa], Sa = wa > xa ? ba[wa - ya] : 0;
          ba[wa] = Ta + Sa;
        }
      }, ma.prototype._unFilterType2 = function(va, ba, _a) {
        let ya = this._lastLine;
        for (let xa = 0; xa < _a; xa++) {
          let wa = va[1 + xa], Ta = ya ? ya[xa] : 0;
          ba[xa] = wa + Ta;
        }
      }, ma.prototype._unFilterType3 = function(va, ba, _a) {
        let ya = this._xComparison, xa = ya - 1, wa = this._lastLine;
        for (let Ta = 0; Ta < _a; Ta++) {
          let Sa = va[1 + Ta], Ma = wa ? wa[Ta] : 0, ka = Ta > xa ? ba[Ta - ya] : 0, Za = Math.floor((ka + Ma) / 2);
          ba[Ta] = Sa + Za;
        }
      }, ma.prototype._unFilterType4 = function(va, ba, _a) {
        let ya = this._xComparison, xa = ya - 1, wa = this._lastLine;
        for (let Ta = 0; Ta < _a; Ta++) {
          let Sa = va[1 + Ta], Ma = wa ? wa[Ta] : 0, ka = Ta > xa ? ba[Ta - ya] : 0, Za = Ta > xa && wa ? wa[Ta - ya] : 0, Na = Jo(ka, Ma, Za);
          ba[Ta] = Sa + Na;
        }
      }, ma.prototype._reverseFilterLine = function(va) {
        let ba, _a = va[0], ya = this._images[this._imageIndex], xa = ya.byteWidth;
        if (_a === 0) ba = va.slice(1, xa + 1);
        else switch (ba = Kn.alloc(xa), _a) {
          case 1:
            this._unFilterType1(va, ba, xa);
            break;
          case 2:
            this._unFilterType2(va, ba, xa);
            break;
          case 3:
            this._unFilterType3(va, ba, xa);
            break;
          case 4:
            this._unFilterType4(va, ba, xa);
            break;
          default:
            throw new Error("Unrecognised filter type - " + _a);
        }
        this.write(ba), ya.lineIndex++, ya.lineIndex >= ya.height ? (this._lastLine = null, this._imageIndex++, ya = this._images[this._imageIndex]) : this._lastLine = ba, ya ? this.read(ya.byteWidth + 1, this._reverseFilterLine.bind(this)) : (this._lastLine = null, this.complete());
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./interlace": 11, "./paeth-predictor": 15, buffer: 32 }], 10: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      function qn(ma, va, ba, _a, ya) {
        let xa = 0;
        for (let wa = 0; wa < _a; wa++) for (let Ta = 0; Ta < ba; Ta++) {
          let Sa = ya[ma[xa]];
          if (!Sa) throw new Error("index " + ma[xa] + " not in palette");
          for (let Ma = 0; Ma < 4; Ma++) va[xa + Ma] = Sa[Ma];
          xa += 4;
        }
      }
      function Jo(ma, va, ba, _a, ya) {
        let xa = 0;
        for (let wa = 0; wa < _a; wa++) for (let Ta = 0; Ta < ba; Ta++) {
          let Sa = !1;
          if (ya.length === 1 ? ya[0] === ma[xa] && (Sa = !0) : ya[0] === ma[xa] && ya[1] === ma[xa + 1] && ya[2] === ma[xa + 2] && (Sa = !0), Sa) for (let Ma = 0; Ma < 4; Ma++) va[xa + Ma] = 0;
          xa += 4;
        }
      }
      function pa(ma, va, ba, _a, ya) {
        let xa = 255, wa = Math.pow(2, ya) - 1, Ta = 0;
        for (let Sa = 0; Sa < _a; Sa++) for (let Ma = 0; Ma < ba; Ma++) {
          for (let ka = 0; ka < 4; ka++) va[Ta + ka] = Math.floor(ma[Ta + ka] * xa / wa + 0.5);
          Ta += 4;
        }
      }
      zn.exports = function(ma, va, ba = !1) {
        let _a = va.depth, ya = va.width, xa = va.height, wa = va.colorType, Ta = va.transColor, Sa = va.palette, Ma = ma;
        return wa === 3 ? qn(ma, Ma, ya, xa, Sa) : (Ta && Jo(ma, Ma, ya, xa, Ta), _a === 8 || ba || (_a === 16 && (Ma = Kn.alloc(ya * xa * 4)), pa(ma, Ma, ya, xa, _a))), Ma;
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { buffer: 32 }], 11: [function(Xn, zn, Un) {
  let Kn = [{ x: [0], y: [0] }, { x: [4], y: [0] }, { x: [0, 4], y: [4] }, { x: [2, 6], y: [0, 4] }, { x: [0, 2, 4, 6], y: [2, 6] }, { x: [1, 3, 5, 7], y: [0, 2, 4, 6] }, { x: [0, 1, 2, 3, 4, 5, 6, 7], y: [1, 3, 5, 7] }];
  Un.getImagePasses = function(qn, Jo) {
    let pa = [], ma = qn % 8, va = Jo % 8, ba = (qn - ma) / 8, _a = (Jo - va) / 8;
    for (let ya = 0; ya < Kn.length; ya++) {
      let xa = Kn[ya], wa = ba * xa.x.length, Ta = _a * xa.y.length;
      for (let Sa = 0; Sa < xa.x.length && xa.x[Sa] < ma; Sa++) wa++;
      for (let Sa = 0; Sa < xa.y.length && xa.y[Sa] < va; Sa++) Ta++;
      wa > 0 && Ta > 0 && pa.push({ width: wa, height: Ta, index: ya });
    }
    return pa;
  }, Un.getInterlaceIterator = function(qn) {
    return function(Jo, pa, ma) {
      let va = Jo % Kn[ma].x.length, ba = (Jo - va) / Kn[ma].x.length * 8 + Kn[ma].x[va], _a = pa % Kn[ma].y.length;
      return 4 * ba + ((pa - _a) / Kn[ma].y.length * 8 + Kn[ma].y[_a]) * qn * 4;
    };
  };
}, {}], 12: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("util"), Jo = Xn("stream"), pa = Xn("./constants"), ma = Xn("./packer"), va = zn.exports = function(ba) {
        Jo.call(this);
        let _a = ba || {};
        this._packer = new ma(_a), this._deflate = this._packer.createDeflate(), this.readable = !0;
      };
      qn.inherits(va, Jo), va.prototype.pack = function(ba, _a, ya, xa) {
        this.emit("data", Kn.from(pa.PNG_SIGNATURE)), this.emit("data", this._packer.packIHDR(_a, ya)), xa && this.emit("data", this._packer.packGAMA(xa));
        let wa = this._packer.filterData(ba, _a, ya);
        this._deflate.on("error", this.emit.bind(this, "error")), this._deflate.on("data", (function(Ta) {
          this.emit("data", this._packer.packIDAT(Ta));
        }).bind(this)), this._deflate.on("end", (function() {
          this.emit("data", this._packer.packIEND()), this.emit("end");
        }).bind(this)), this._deflate.end(wa);
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./constants": 4, "./packer": 14, buffer: 32, stream: 65, util: 84 }], 13: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = !0, Jo = Xn("zlib");
      Jo.deflateSync || (qn = !1);
      let pa = Xn("./constants"), ma = Xn("./packer");
      zn.exports = function(va, ba) {
        if (!qn) throw new Error("To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0");
        let _a = new ma(ba || {}), ya = [];
        ya.push(Kn.from(pa.PNG_SIGNATURE)), ya.push(_a.packIHDR(va.width, va.height)), va.gamma && ya.push(_a.packGAMA(va.gamma));
        let xa = _a.filterData(va.data, va.width, va.height), wa = Jo.deflateSync(xa, _a.getDeflateOptions());
        if (xa = null, !wa || !wa.length) throw new Error("bad png - invalid compressed data response");
        return ya.push(_a.packIDAT(wa)), ya.push(_a.packIEND()), Kn.concat(ya);
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./constants": 4, "./packer": 14, buffer: 32, zlib: 31 }], 14: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("./constants"), Jo = Xn("./crc"), pa = Xn("./bitpacker"), ma = Xn("./filter-pack"), va = Xn("zlib"), ba = zn.exports = function(_a) {
        if (this._options = _a, _a.deflateChunkSize = _a.deflateChunkSize || 32768, _a.deflateLevel = _a.deflateLevel != null ? _a.deflateLevel : 9, _a.deflateStrategy = _a.deflateStrategy != null ? _a.deflateStrategy : 3, _a.inputHasAlpha = _a.inputHasAlpha == null || _a.inputHasAlpha, _a.deflateFactory = _a.deflateFactory || va.createDeflate, _a.bitDepth = _a.bitDepth || 8, _a.colorType = typeof _a.colorType == "number" ? _a.colorType : qn.COLORTYPE_COLOR_ALPHA, _a.inputColorType = typeof _a.inputColorType == "number" ? _a.inputColorType : qn.COLORTYPE_COLOR_ALPHA, [qn.COLORTYPE_GRAYSCALE, qn.COLORTYPE_COLOR, qn.COLORTYPE_COLOR_ALPHA, qn.COLORTYPE_ALPHA].indexOf(_a.colorType) === -1) throw new Error("option color type:" + _a.colorType + " is not supported at present");
        if ([qn.COLORTYPE_GRAYSCALE, qn.COLORTYPE_COLOR, qn.COLORTYPE_COLOR_ALPHA, qn.COLORTYPE_ALPHA].indexOf(_a.inputColorType) === -1) throw new Error("option input color type:" + _a.inputColorType + " is not supported at present");
        if (_a.bitDepth !== 8 && _a.bitDepth !== 16) throw new Error("option bit depth:" + _a.bitDepth + " is not supported at present");
      };
      ba.prototype.getDeflateOptions = function() {
        return { chunkSize: this._options.deflateChunkSize, level: this._options.deflateLevel, strategy: this._options.deflateStrategy };
      }, ba.prototype.createDeflate = function() {
        return this._options.deflateFactory(this.getDeflateOptions());
      }, ba.prototype.filterData = function(_a, ya, xa) {
        let wa = pa(_a, ya, xa, this._options), Ta = qn.COLORTYPE_TO_BPP_MAP[this._options.colorType];
        return ma(wa, ya, xa, this._options, Ta);
      }, ba.prototype._packChunk = function(_a, ya) {
        let xa = ya ? ya.length : 0, wa = Kn.alloc(xa + 12);
        return wa.writeUInt32BE(xa, 0), wa.writeUInt32BE(_a, 4), ya && ya.copy(wa, 8), wa.writeInt32BE(Jo.crc32(wa.slice(4, wa.length - 4)), wa.length - 4), wa;
      }, ba.prototype.packGAMA = function(_a) {
        let ya = Kn.alloc(4);
        return ya.writeUInt32BE(Math.floor(_a * qn.GAMMA_DIVISION), 0), this._packChunk(qn.TYPE_gAMA, ya);
      }, ba.prototype.packIHDR = function(_a, ya) {
        let xa = Kn.alloc(13);
        return xa.writeUInt32BE(_a, 0), xa.writeUInt32BE(ya, 4), xa[8] = this._options.bitDepth, xa[9] = this._options.colorType, xa[10] = 0, xa[11] = 0, xa[12] = 0, this._packChunk(qn.TYPE_IHDR, xa);
      }, ba.prototype.packIDAT = function(_a) {
        return this._packChunk(qn.TYPE_IDAT, _a);
      }, ba.prototype.packIEND = function() {
        return this._packChunk(qn.TYPE_IEND, null);
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./bitpacker": 2, "./constants": 4, "./crc": 5, "./filter-pack": 6, buffer: 32, zlib: 31 }], 15: [function(Xn, zn, Un) {
  zn.exports = function(Kn, qn, Jo) {
    let pa = Kn + qn - Jo, ma = Math.abs(pa - Kn), va = Math.abs(pa - qn), ba = Math.abs(pa - Jo);
    return ma <= va && ma <= ba ? Kn : va <= ba ? qn : Jo;
  };
}, {}], 16: [function(Xn, zn, Un) {
  let Kn = Xn("util"), qn = Xn("zlib"), Jo = Xn("./chunkstream"), pa = Xn("./filter-parse-async"), ma = Xn("./parser"), va = Xn("./bitmapper"), ba = Xn("./format-normaliser"), _a = zn.exports = function(ya) {
    Jo.call(this), this._parser = new ma(ya, { read: this.read.bind(this), error: this._handleError.bind(this), metadata: this._handleMetaData.bind(this), gamma: this.emit.bind(this, "gamma"), palette: this._handlePalette.bind(this), transColor: this._handleTransColor.bind(this), finished: this._finished.bind(this), inflateData: this._inflateData.bind(this), simpleTransparency: this._simpleTransparency.bind(this), headersFinished: this._headersFinished.bind(this) }), this._options = ya, this.writable = !0, this._parser.start();
  };
  Kn.inherits(_a, Jo), _a.prototype._handleError = function(ya) {
    this.emit("error", ya), this.writable = !1, this.destroy(), this._inflate && this._inflate.destroy && this._inflate.destroy(), this._filter && (this._filter.destroy(), this._filter.on("error", function() {
    })), this.errord = !0;
  }, _a.prototype._inflateData = function(ya) {
    if (!this._inflate) if (this._bitmapInfo.interlace) this._inflate = qn.createInflate(), this._inflate.on("error", this.emit.bind(this, "error")), this._filter.on("complete", this._complete.bind(this)), this._inflate.pipe(this._filter);
    else {
      let xa = (1 + (this._bitmapInfo.width * this._bitmapInfo.bpp * this._bitmapInfo.depth + 7 >> 3)) * this._bitmapInfo.height, wa = Math.max(xa, qn.Z_MIN_CHUNK);
      this._inflate = qn.createInflate({ chunkSize: wa });
      let Ta = xa, Sa = this.emit.bind(this, "error");
      this._inflate.on("error", function(ka) {
        Ta && Sa(ka);
      }), this._filter.on("complete", this._complete.bind(this));
      let Ma = this._filter.write.bind(this._filter);
      this._inflate.on("data", function(ka) {
        Ta && (ka.length > Ta && (ka = ka.slice(0, Ta)), Ta -= ka.length, Ma(ka));
      }), this._inflate.on("end", this._filter.end.bind(this._filter));
    }
    this._inflate.write(ya);
  }, _a.prototype._handleMetaData = function(ya) {
    this._metaData = ya, this._bitmapInfo = Object.create(ya), this._filter = new pa(this._bitmapInfo);
  }, _a.prototype._handleTransColor = function(ya) {
    this._bitmapInfo.transColor = ya;
  }, _a.prototype._handlePalette = function(ya) {
    this._bitmapInfo.palette = ya;
  }, _a.prototype._simpleTransparency = function() {
    this._metaData.alpha = !0;
  }, _a.prototype._headersFinished = function() {
    this.emit("metadata", this._metaData);
  }, _a.prototype._finished = function() {
    this.errord || (this._inflate ? this._inflate.end() : this.emit("error", "No Inflate block"));
  }, _a.prototype._complete = function(ya) {
    if (this.errord) return;
    let xa;
    try {
      let wa = va.dataToBitMap(ya, this._bitmapInfo);
      xa = ba(wa, this._bitmapInfo, this._options.skipRescale), wa = null;
    } catch (wa) {
      return void this._handleError(wa);
    }
    this.emit("parsed", xa);
  };
}, { "./bitmapper": 1, "./chunkstream": 3, "./filter-parse-async": 7, "./format-normaliser": 10, "./parser": 18, util: 84, zlib: 31 }], 17: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = !0, Jo = Xn("zlib"), pa = Xn("./sync-inflate");
      Jo.deflateSync || (qn = !1);
      let ma = Xn("./sync-reader"), va = Xn("./filter-parse-sync"), ba = Xn("./parser"), _a = Xn("./bitmapper"), ya = Xn("./format-normaliser");
      zn.exports = function(xa, wa) {
        if (!qn) throw new Error("To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0");
        let Ta, Sa, Ma;
        function ka(al) {
          Ta = al;
        }
        function Za(al) {
          Sa = al;
        }
        function Na(al) {
          Sa.transColor = al;
        }
        function Ka(al) {
          Sa.palette = al;
        }
        function Ja() {
          Sa.alpha = !0;
        }
        function el(al) {
          Ma = al;
        }
        let qa = [];
        function tl(al) {
          qa.push(al);
        }
        let Qa = new ma(xa);
        if (new ba(wa, { read: Qa.read.bind(Qa), error: ka, metadata: Za, gamma: el, palette: Ka, transColor: Na, inflateData: tl, simpleTransparency: Ja }).start(), Qa.process(), Ta) throw Ta;
        let nl, rl = Kn.concat(qa);
        if (qa.length = 0, Sa.interlace) nl = Jo.inflateSync(rl);
        else {
          let al = (1 + (Sa.width * Sa.bpp * Sa.depth + 7 >> 3)) * Sa.height;
          nl = pa(rl, { chunkSize: al, maxLength: al });
        }
        if (rl = null, !nl || !nl.length) throw new Error("bad png - invalid inflate data response");
        let il = va.process(nl, Sa);
        rl = null;
        let cl = _a.dataToBitMap(il, Sa);
        il = null;
        let ll = ya(cl, Sa, wa.skipRescale);
        return Sa.data = ll, Sa.gamma = Ma || 0, Sa;
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./bitmapper": 1, "./filter-parse-sync": 8, "./format-normaliser": 10, "./parser": 18, "./sync-inflate": 21, "./sync-reader": 22, buffer: 32, zlib: 31 }], 18: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      let qn = Xn("./constants"), Jo = Xn("./crc"), pa = zn.exports = function(ma, va) {
        this._options = ma, ma.checkCRC = ma.checkCRC !== !1, this._hasIHDR = !1, this._hasIEND = !1, this._emittedHeadersFinished = !1, this._palette = [], this._colorType = 0, this._chunks = {}, this._chunks[qn.TYPE_IHDR] = this._handleIHDR.bind(this), this._chunks[qn.TYPE_IEND] = this._handleIEND.bind(this), this._chunks[qn.TYPE_IDAT] = this._handleIDAT.bind(this), this._chunks[qn.TYPE_PLTE] = this._handlePLTE.bind(this), this._chunks[qn.TYPE_tRNS] = this._handleTRNS.bind(this), this._chunks[qn.TYPE_gAMA] = this._handleGAMA.bind(this), this.read = va.read, this.error = va.error, this.metadata = va.metadata, this.gamma = va.gamma, this.transColor = va.transColor, this.palette = va.palette, this.parsed = va.parsed, this.inflateData = va.inflateData, this.finished = va.finished, this.simpleTransparency = va.simpleTransparency, this.headersFinished = va.headersFinished || function() {
        };
      };
      pa.prototype.start = function() {
        this.read(qn.PNG_SIGNATURE.length, this._parseSignature.bind(this));
      }, pa.prototype._parseSignature = function(ma) {
        let va = qn.PNG_SIGNATURE;
        for (let ba = 0; ba < va.length; ba++) if (ma[ba] !== va[ba]) return void this.error(new Error("Invalid file signature"));
        this.read(8, this._parseChunkBegin.bind(this));
      }, pa.prototype._parseChunkBegin = function(ma) {
        let va = ma.readUInt32BE(0), ba = ma.readUInt32BE(4), _a = "";
        for (let xa = 4; xa < 8; xa++) _a += String.fromCharCode(ma[xa]);
        let ya = !!(32 & ma[4]);
        if (this._hasIHDR || ba === qn.TYPE_IHDR) {
          if (this._crc = new Jo(), this._crc.write(Kn.from(_a)), this._chunks[ba]) return this._chunks[ba](va);
          ya ? this.read(va + 4, this._skipChunk.bind(this)) : this.error(new Error("Unsupported critical chunk type " + _a));
        } else this.error(new Error("Expected IHDR on beggining"));
      }, pa.prototype._skipChunk = function() {
        this.read(8, this._parseChunkBegin.bind(this));
      }, pa.prototype._handleChunkEnd = function() {
        this.read(4, this._parseChunkEnd.bind(this));
      }, pa.prototype._parseChunkEnd = function(ma) {
        let va = ma.readInt32BE(0), ba = this._crc.crc32();
        this._options.checkCRC && ba !== va ? this.error(new Error("Crc error - " + va + " - " + ba)) : this._hasIEND || this.read(8, this._parseChunkBegin.bind(this));
      }, pa.prototype._handleIHDR = function(ma) {
        this.read(ma, this._parseIHDR.bind(this));
      }, pa.prototype._parseIHDR = function(ma) {
        this._crc.write(ma);
        let va = ma.readUInt32BE(0), ba = ma.readUInt32BE(4), _a = ma[8], ya = ma[9], xa = ma[10], wa = ma[11], Ta = ma[12];
        if (_a !== 8 && _a !== 4 && _a !== 2 && _a !== 1 && _a !== 16) return void this.error(new Error("Unsupported bit depth " + _a));
        if (!(ya in qn.COLORTYPE_TO_BPP_MAP)) return void this.error(new Error("Unsupported color type"));
        if (xa !== 0) return void this.error(new Error("Unsupported compression method"));
        if (wa !== 0) return void this.error(new Error("Unsupported filter method"));
        if (Ta !== 0 && Ta !== 1) return void this.error(new Error("Unsupported interlace method"));
        this._colorType = ya;
        let Sa = qn.COLORTYPE_TO_BPP_MAP[this._colorType];
        this._hasIHDR = !0, this.metadata({ width: va, height: ba, depth: _a, interlace: !!Ta, palette: !!(ya & qn.COLORTYPE_PALETTE), color: !!(ya & qn.COLORTYPE_COLOR), alpha: !!(ya & qn.COLORTYPE_ALPHA), bpp: Sa, colorType: ya }), this._handleChunkEnd();
      }, pa.prototype._handlePLTE = function(ma) {
        this.read(ma, this._parsePLTE.bind(this));
      }, pa.prototype._parsePLTE = function(ma) {
        this._crc.write(ma);
        let va = Math.floor(ma.length / 3);
        for (let ba = 0; ba < va; ba++) this._palette.push([ma[3 * ba], ma[3 * ba + 1], ma[3 * ba + 2], 255]);
        this.palette(this._palette), this._handleChunkEnd();
      }, pa.prototype._handleTRNS = function(ma) {
        this.simpleTransparency(), this.read(ma, this._parseTRNS.bind(this));
      }, pa.prototype._parseTRNS = function(ma) {
        if (this._crc.write(ma), this._colorType === qn.COLORTYPE_PALETTE_COLOR) {
          if (this._palette.length === 0) return void this.error(new Error("Transparency chunk must be after palette"));
          if (ma.length > this._palette.length) return void this.error(new Error("More transparent colors than palette size"));
          for (let va = 0; va < ma.length; va++) this._palette[va][3] = ma[va];
          this.palette(this._palette);
        }
        this._colorType === qn.COLORTYPE_GRAYSCALE && this.transColor([ma.readUInt16BE(0)]), this._colorType === qn.COLORTYPE_COLOR && this.transColor([ma.readUInt16BE(0), ma.readUInt16BE(2), ma.readUInt16BE(4)]), this._handleChunkEnd();
      }, pa.prototype._handleGAMA = function(ma) {
        this.read(ma, this._parseGAMA.bind(this));
      }, pa.prototype._parseGAMA = function(ma) {
        this._crc.write(ma), this.gamma(ma.readUInt32BE(0) / qn.GAMMA_DIVISION), this._handleChunkEnd();
      }, pa.prototype._handleIDAT = function(ma) {
        this._emittedHeadersFinished || (this._emittedHeadersFinished = !0, this.headersFinished()), this.read(-ma, this._parseIDAT.bind(this, ma));
      }, pa.prototype._parseIDAT = function(ma, va) {
        if (this._crc.write(va), this._colorType === qn.COLORTYPE_PALETTE_COLOR && this._palette.length === 0) throw new Error("Expected palette not found");
        this.inflateData(va);
        let ba = ma - va.length;
        ba > 0 ? this._handleIDAT(ba) : this._handleChunkEnd();
      }, pa.prototype._handleIEND = function(ma) {
        this.read(ma, this._parseIEND.bind(this));
      }, pa.prototype._parseIEND = function(ma) {
        this._crc.write(ma), this._hasIEND = !0, this._handleChunkEnd(), this.finished && this.finished();
      };
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "./constants": 4, "./crc": 5, buffer: 32 }], 19: [function(Xn, zn, Un) {
  let Kn = Xn("./parser-sync"), qn = Xn("./packer-sync");
  Un.read = function(Jo, pa) {
    return Kn(Jo, pa || {});
  }, Un.write = function(Jo, pa) {
    return qn(Jo, pa);
  };
}, { "./packer-sync": 13, "./parser-sync": 17 }], 20: [function(Xn, zn, Un) {
  (function(Kn, qn) {
    (function() {
      let Jo = Xn("util"), pa = Xn("stream"), ma = Xn("./parser-async"), va = Xn("./packer-async"), ba = Xn("./png-sync"), _a = Un.PNG = function(ya) {
        pa.call(this), ya = ya || {}, this.width = 0 | ya.width, this.height = 0 | ya.height, this.data = this.width > 0 && this.height > 0 ? qn.alloc(4 * this.width * this.height) : null, ya.fill && this.data && this.data.fill(0), this.gamma = 0, this.readable = this.writable = !0, this._parser = new ma(ya), this._parser.on("error", this.emit.bind(this, "error")), this._parser.on("close", this._handleClose.bind(this)), this._parser.on("metadata", this._metadata.bind(this)), this._parser.on("gamma", this._gamma.bind(this)), this._parser.on("parsed", (function(xa) {
          this.data = xa, this.emit("parsed", xa);
        }).bind(this)), this._packer = new va(ya), this._packer.on("data", this.emit.bind(this, "data")), this._packer.on("end", this.emit.bind(this, "end")), this._parser.on("close", this._handleClose.bind(this)), this._packer.on("error", this.emit.bind(this, "error"));
      };
      Jo.inherits(_a, pa), _a.sync = ba, _a.prototype.pack = function() {
        return this.data && this.data.length ? (Kn.nextTick((function() {
          this._packer.pack(this.data, this.width, this.height, this.gamma);
        }).bind(this)), this) : (this.emit("error", "No data provided"), this);
      }, _a.prototype.parse = function(ya, xa) {
        if (xa) {
          let wa, Ta;
          wa = (function(Sa) {
            this.removeListener("error", Ta), this.data = Sa, xa(null, this);
          }).bind(this), Ta = (function(Sa) {
            this.removeListener("parsed", wa), xa(Sa, null);
          }).bind(this), this.once("parsed", wa), this.once("error", Ta);
        }
        return this.end(ya), this;
      }, _a.prototype.write = function(ya) {
        return this._parser.write(ya), !0;
      }, _a.prototype.end = function(ya) {
        this._parser.end(ya);
      }, _a.prototype._metadata = function(ya) {
        this.width = ya.width, this.height = ya.height, this.emit("metadata", ya);
      }, _a.prototype._gamma = function(ya) {
        this.gamma = ya;
      }, _a.prototype._handleClose = function() {
        this._parser.writable || this._packer.readable || this.emit("close");
      }, _a.bitblt = function(ya, xa, wa, Ta, Sa, Ma, ka, Za) {
        if (Ta |= 0, Sa |= 0, Ma |= 0, ka |= 0, Za |= 0, (wa |= 0) > ya.width || Ta > ya.height || wa + Sa > ya.width || Ta + Ma > ya.height) throw new Error("bitblt reading outside image");
        if (ka > xa.width || Za > xa.height || ka + Sa > xa.width || Za + Ma > xa.height) throw new Error("bitblt writing outside image");
        for (let Na = 0; Na < Ma; Na++) ya.data.copy(xa.data, (Za + Na) * xa.width + ka << 2, (Ta + Na) * ya.width + wa << 2, (Ta + Na) * ya.width + wa + Sa << 2);
      }, _a.prototype.bitblt = function(ya, xa, wa, Ta, Sa, Ma, ka) {
        return _a.bitblt(this, ya, xa, wa, Ta, Sa, Ma, ka), this;
      }, _a.adjustGamma = function(ya) {
        if (ya.gamma) {
          for (let xa = 0; xa < ya.height; xa++) for (let wa = 0; wa < ya.width; wa++) {
            let Ta = ya.width * xa + wa << 2;
            for (let Sa = 0; Sa < 3; Sa++) {
              let Ma = ya.data[Ta + Sa] / 255;
              Ma = Math.pow(Ma, 1 / 2.2 / ya.gamma), ya.data[Ta + Sa] = Math.round(255 * Ma);
            }
          }
          ya.gamma = 0;
        }
      }, _a.prototype.adjustGamma = function() {
        _a.adjustGamma(this);
      };
    }).call(this);
  }).call(this, Xn("_process"), Xn("buffer").Buffer);
}, { "./packer-async": 12, "./parser-async": 16, "./png-sync": 19, _process: 63, buffer: 32, stream: 65, util: 84 }], 21: [function(Xn, zn, Un) {
  (function(Kn, qn) {
    (function() {
      let Jo = Xn("assert").ok, pa = Xn("zlib"), ma = Xn("util"), va = Xn("buffer").kMaxLength;
      function ba(Ta) {
        if (!(this instanceof ba)) return new ba(Ta);
        Ta && Ta.chunkSize < pa.Z_MIN_CHUNK && (Ta.chunkSize = pa.Z_MIN_CHUNK), pa.Inflate.call(this, Ta), this._offset = this._offset === void 0 ? this._outOffset : this._offset, this._buffer = this._buffer || this._outBuffer, Ta && Ta.maxLength != null && (this._maxLength = Ta.maxLength);
      }
      function _a(Ta) {
        return new ba(Ta);
      }
      function ya(Ta, Sa) {
        Ta._handle && (Ta._handle.close(), Ta._handle = null);
      }
      function xa(Ta, Sa) {
        if (typeof Sa == "string" && (Sa = qn.from(Sa)), !(Sa instanceof qn)) throw new TypeError("Not a string or buffer");
        let Ma = Ta._finishFlushFlag;
        return Ma == null && (Ma = pa.Z_FINISH), Ta._processChunk(Sa, Ma);
      }
      function wa(Ta, Sa) {
        return xa(new ba(Sa), Ta);
      }
      ba.prototype._processChunk = function(Ta, Sa, Ma) {
        if (typeof Ma == "function") return pa.Inflate._processChunk.call(this, Ta, Sa, Ma);
        let ka, Za, Na = this, Ka = Ta && Ta.length, Ja = this._chunkSize - this._offset, el = this._maxLength, qa = 0, tl = [], Qa = 0;
        function nl(il, cl) {
          if (Na._hadError) return;
          let ll = Ja - cl;
          if (Jo(ll >= 0, "have should not go down"), ll > 0) {
            let al = Na._buffer.slice(Na._offset, Na._offset + ll);
            if (Na._offset += ll, al.length > el && (al = al.slice(0, el)), tl.push(al), Qa += al.length, el -= al.length, el === 0) return !1;
          }
          return (cl === 0 || Na._offset >= Na._chunkSize) && (Ja = Na._chunkSize, Na._offset = 0, Na._buffer = qn.allocUnsafe(Na._chunkSize)), cl === 0 && (qa += Ka - il, Ka = il, !0);
        }
        this.on("error", function(il) {
          ka = il;
        }), Jo(this._handle, "zlib binding closed");
        do
          Za = this._handle.writeSync(Sa, Ta, qa, Ka, this._buffer, this._offset, Ja), Za = Za || this._writeState;
        while (!this._hadError && nl(Za[0], Za[1]));
        if (this._hadError) throw ka;
        if (Qa >= va) throw ya(this), new RangeError("Cannot create final Buffer. It would be larger than 0x" + va.toString(16) + " bytes");
        let rl = qn.concat(tl, Qa);
        return ya(this), rl;
      }, ma.inherits(ba, pa.Inflate), zn.exports = Un = wa, Un.Inflate = ba, Un.createInflate = _a, Un.inflateSync = wa;
    }).call(this);
  }).call(this, Xn("_process"), Xn("buffer").Buffer);
}, { _process: 63, assert: 23, buffer: 32, util: 84, zlib: 31 }], 22: [function(Xn, zn, Un) {
  let Kn = zn.exports = function(qn) {
    this._buffer = qn, this._reads = [];
  };
  Kn.prototype.read = function(qn, Jo) {
    this._reads.push({ length: Math.abs(qn), allowLess: qn < 0, func: Jo });
  }, Kn.prototype.process = function() {
    for (; this._reads.length > 0 && this._buffer.length; ) {
      let qn = this._reads[0];
      if (!this._buffer.length || !(this._buffer.length >= qn.length || qn.allowLess)) break;
      {
        this._reads.shift();
        let Jo = this._buffer;
        this._buffer = Jo.slice(qn.length), qn.func.call(this, Jo.slice(0, qn.length));
      }
    }
    if (this._reads.length > 0) throw new Error("There are some read requests waitng on finished stream");
    if (this._buffer.length > 0) throw new Error("unrecognised content at end of stream");
  };
}, {}], 23: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = Xn("object-assign");
      /*!
      	 * The buffer module from node.js, for the browser.
      	 *
      	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
      	 * @license  MIT
      	 */
      function Jo(ll, al) {
        if (ll === al) return 0;
        for (var sl = ll.length, dl = al.length, El = 0, fl = Math.min(sl, dl); El < fl; ++El) if (ll[El] !== al[El]) {
          sl = ll[El], dl = al[El];
          break;
        }
        return sl < dl ? -1 : dl < sl ? 1 : 0;
      }
      function pa(ll) {
        return Kn.Buffer && typeof Kn.Buffer.isBuffer == "function" ? Kn.Buffer.isBuffer(ll) : !(ll == null || !ll._isBuffer);
      }
      var ma = Xn("util/"), va = Object.prototype.hasOwnProperty, ba = Array.prototype.slice, _a = (function() {
      }).name === "foo";
      function ya(ll) {
        return Object.prototype.toString.call(ll);
      }
      function xa(ll) {
        return !pa(ll) && typeof Kn.ArrayBuffer == "function" && (typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(ll) : !!ll && (ll instanceof DataView || !!(ll.buffer && ll.buffer instanceof ArrayBuffer)));
      }
      var wa = zn.exports = Ka, Ta = /\s*function\s+([^\(\s]*)\s*/;
      function Sa(ll) {
        if (ma.isFunction(ll)) {
          if (_a) return ll.name;
          var al = ll.toString().match(Ta);
          return al && al[1];
        }
      }
      function Ma(ll, al) {
        return typeof ll == "string" ? ll.length < al ? ll : ll.slice(0, al) : ll;
      }
      function ka(ll) {
        if (_a || !ma.isFunction(ll)) return ma.inspect(ll);
        var al = Sa(ll);
        return "[Function" + (al ? ": " + al : "") + "]";
      }
      function Za(ll) {
        return Ma(ka(ll.actual), 128) + " " + ll.operator + " " + Ma(ka(ll.expected), 128);
      }
      function Na(ll, al, sl, dl, El) {
        throw new wa.AssertionError({ message: sl, actual: ll, expected: al, operator: dl, stackStartFunction: El });
      }
      function Ka(ll, al) {
        ll || Na(ll, !0, al, "==", wa.ok);
      }
      function Ja(ll, al, sl, dl) {
        if (ll === al) return !0;
        if (pa(ll) && pa(al)) return Jo(ll, al) === 0;
        if (ma.isDate(ll) && ma.isDate(al)) return ll.getTime() === al.getTime();
        if (ma.isRegExp(ll) && ma.isRegExp(al)) return ll.source === al.source && ll.global === al.global && ll.multiline === al.multiline && ll.lastIndex === al.lastIndex && ll.ignoreCase === al.ignoreCase;
        if (ll !== null && typeof ll == "object" || al !== null && typeof al == "object") {
          if (xa(ll) && xa(al) && ya(ll) === ya(al) && !(ll instanceof Float32Array || ll instanceof Float64Array)) return Jo(new Uint8Array(ll.buffer), new Uint8Array(al.buffer)) === 0;
          if (pa(ll) !== pa(al)) return !1;
          var El = (dl = dl || { actual: [], expected: [] }).actual.indexOf(ll);
          return El !== -1 && El === dl.expected.indexOf(al) || (dl.actual.push(ll), dl.expected.push(al), qa(ll, al, sl, dl));
        }
        return sl ? ll === al : ll == al;
      }
      function el(ll) {
        return Object.prototype.toString.call(ll) == "[object Arguments]";
      }
      function qa(ll, al, sl, dl) {
        if (ll == null || al == null) return !1;
        if (ma.isPrimitive(ll) || ma.isPrimitive(al)) return ll === al;
        if (sl && Object.getPrototypeOf(ll) !== Object.getPrototypeOf(al)) return !1;
        var El = el(ll), fl = el(al);
        if (El && !fl || !El && fl) return !1;
        if (El) return Ja(ll = ba.call(ll), al = ba.call(al), sl);
        var Ml, Sl, ml = cl(ll), Dl = cl(al);
        if (ml.length !== Dl.length) return !1;
        for (ml.sort(), Dl.sort(), Sl = ml.length - 1; Sl >= 0; Sl--) if (ml[Sl] !== Dl[Sl]) return !1;
        for (Sl = ml.length - 1; Sl >= 0; Sl--) if (!Ja(ll[Ml = ml[Sl]], al[Ml], sl, dl)) return !1;
        return !0;
      }
      function tl(ll, al, sl) {
        Ja(ll, al, !0) && Na(ll, al, sl, "notDeepStrictEqual", tl);
      }
      function Qa(ll, al) {
        if (!ll || !al) return !1;
        if (Object.prototype.toString.call(al) == "[object RegExp]") return al.test(ll);
        try {
          if (ll instanceof al) return !0;
        } catch {
        }
        return !Error.isPrototypeOf(al) && al.call({}, ll) === !0;
      }
      function nl(ll) {
        var al;
        try {
          ll();
        } catch (sl) {
          al = sl;
        }
        return al;
      }
      function rl(ll, al, sl, dl) {
        var El;
        if (typeof al != "function") throw new TypeError('"block" argument must be a function');
        typeof sl == "string" && (dl = sl, sl = null), El = nl(al), dl = (sl && sl.name ? " (" + sl.name + ")." : ".") + (dl ? " " + dl : "."), ll && !El && Na(El, sl, "Missing expected exception" + dl);
        var fl = typeof dl == "string", Ml = !ll && El && !sl;
        if ((!ll && ma.isError(El) && fl && Qa(El, sl) || Ml) && Na(El, sl, "Got unwanted exception" + dl), ll && El && sl && !Qa(El, sl) || !ll && El) throw El;
      }
      function il(ll, al) {
        ll || Na(ll, !0, al, "==", il);
      }
      wa.AssertionError = function(ll) {
        this.name = "AssertionError", this.actual = ll.actual, this.expected = ll.expected, this.operator = ll.operator, ll.message ? (this.message = ll.message, this.generatedMessage = !1) : (this.message = Za(this), this.generatedMessage = !0);
        var al = ll.stackStartFunction || Na;
        if (Error.captureStackTrace) Error.captureStackTrace(this, al);
        else {
          var sl = new Error();
          if (sl.stack) {
            var dl = sl.stack, El = Sa(al), fl = dl.indexOf(`
` + El);
            if (fl >= 0) {
              var Ml = dl.indexOf(`
`, fl + 1);
              dl = dl.substring(Ml + 1);
            }
            this.stack = dl;
          }
        }
      }, ma.inherits(wa.AssertionError, Error), wa.fail = Na, wa.ok = Ka, wa.equal = function(ll, al, sl) {
        ll != al && Na(ll, al, sl, "==", wa.equal);
      }, wa.notEqual = function(ll, al, sl) {
        ll == al && Na(ll, al, sl, "!=", wa.notEqual);
      }, wa.deepEqual = function(ll, al, sl) {
        Ja(ll, al, !1) || Na(ll, al, sl, "deepEqual", wa.deepEqual);
      }, wa.deepStrictEqual = function(ll, al, sl) {
        Ja(ll, al, !0) || Na(ll, al, sl, "deepStrictEqual", wa.deepStrictEqual);
      }, wa.notDeepEqual = function(ll, al, sl) {
        Ja(ll, al, !1) && Na(ll, al, sl, "notDeepEqual", wa.notDeepEqual);
      }, wa.notDeepStrictEqual = tl, wa.strictEqual = function(ll, al, sl) {
        ll !== al && Na(ll, al, sl, "===", wa.strictEqual);
      }, wa.notStrictEqual = function(ll, al, sl) {
        ll === al && Na(ll, al, sl, "!==", wa.notStrictEqual);
      }, wa.throws = function(ll, al, sl) {
        rl(!0, ll, al, sl);
      }, wa.doesNotThrow = function(ll, al, sl) {
        rl(!1, ll, al, sl);
      }, wa.ifError = function(ll) {
        if (ll) throw ll;
      }, wa.strict = qn(il, wa, { equal: wa.strictEqual, deepEqual: wa.deepStrictEqual, notEqual: wa.notStrictEqual, notDeepEqual: wa.notDeepStrictEqual }), wa.strict.strict = wa.strict;
      var cl = Object.keys || function(ll) {
        var al = [];
        for (var sl in ll) va.call(ll, sl) && al.push(sl);
        return al;
      };
    }).call(this);
  }).call(this, commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, { "object-assign": 51, "util/": 26 }], 24: [function(Xn, zn, Un) {
  typeof Object.create == "function" ? zn.exports = function(Kn, qn) {
    Kn.super_ = qn, Kn.prototype = Object.create(qn.prototype, { constructor: { value: Kn, enumerable: !1, writable: !0, configurable: !0 } });
  } : zn.exports = function(Kn, qn) {
    Kn.super_ = qn;
    var Jo = function() {
    };
    Jo.prototype = qn.prototype, Kn.prototype = new Jo(), Kn.prototype.constructor = Kn;
  };
}, {}], 25: [function(Xn, zn, Un) {
  zn.exports = function(Kn) {
    return Kn && typeof Kn == "object" && typeof Kn.copy == "function" && typeof Kn.fill == "function" && typeof Kn.readUInt8 == "function";
  };
}, {}], 26: [function(Xn, zn, Un) {
  (function(Kn, qn) {
    (function() {
      var Jo = /%[sdj%]/g;
      Un.format = function(Sl) {
        if (!qa(Sl)) {
          for (var ml = [], Dl = 0; Dl < arguments.length; Dl++) ml.push(va(arguments[Dl]));
          return ml.join(" ");
        }
        Dl = 1;
        for (var _l = arguments, gl = _l.length, Fl = String(Sl).replace(Jo, function(zl) {
          if (zl === "%%") return "%";
          if (Dl >= gl) return zl;
          switch (zl) {
            case "%s":
              return String(_l[Dl++]);
            case "%d":
              return Number(_l[Dl++]);
            case "%j":
              try {
                return JSON.stringify(_l[Dl++]);
              } catch {
                return "[Circular]";
              }
            default:
              return zl;
          }
        }), Nl = _l[Dl]; Dl < gl; Nl = _l[++Dl]) Ka(Nl) || !rl(Nl) ? Fl += " " + Nl : Fl += " " + va(Nl);
        return Fl;
      }, Un.deprecate = function(Sl, ml) {
        if (Qa(qn.process)) return function() {
          return Un.deprecate(Sl, ml).apply(this, arguments);
        };
        if (Kn.noDeprecation === !0) return Sl;
        var Dl = !1;
        function _l() {
          if (!Dl) {
            if (Kn.throwDeprecation) throw new Error(ml);
            Kn.traceDeprecation ? console.trace(ml) : console.error(ml), Dl = !0;
          }
          return Sl.apply(this, arguments);
        }
        return _l;
      };
      var pa, ma = {};
      function va(Sl, ml) {
        var Dl = { seen: [], stylize: _a };
        return arguments.length >= 3 && (Dl.depth = arguments[2]), arguments.length >= 4 && (Dl.colors = arguments[3]), Na(ml) ? Dl.showHidden = ml : ml && Un._extend(Dl, ml), Qa(Dl.showHidden) && (Dl.showHidden = !1), Qa(Dl.depth) && (Dl.depth = 2), Qa(Dl.colors) && (Dl.colors = !1), Qa(Dl.customInspect) && (Dl.customInspect = !0), Dl.colors && (Dl.stylize = ba), xa(Dl, Sl, Dl.depth);
      }
      function ba(Sl, ml) {
        var Dl = va.styles[ml];
        return Dl ? "\x1B[" + va.colors[Dl][0] + "m" + Sl + "\x1B[" + va.colors[Dl][1] + "m" : Sl;
      }
      function _a(Sl, ml) {
        return Sl;
      }
      function ya(Sl) {
        var ml = {};
        return Sl.forEach(function(Dl, _l) {
          ml[Dl] = !0;
        }), ml;
      }
      function xa(Sl, ml, Dl) {
        if (Sl.customInspect && ml && ll(ml.inspect) && ml.inspect !== Un.inspect && (!ml.constructor || ml.constructor.prototype !== ml)) {
          var _l = ml.inspect(Dl, Sl);
          return qa(_l) || (_l = xa(Sl, _l, Dl)), _l;
        }
        var gl = wa(Sl, ml);
        if (gl) return gl;
        var Fl = Object.keys(ml), Nl = ya(Fl);
        if (Sl.showHidden && (Fl = Object.getOwnPropertyNames(ml)), cl(ml) && (Fl.indexOf("message") >= 0 || Fl.indexOf("description") >= 0)) return Ta(ml);
        if (Fl.length === 0) {
          if (ll(ml)) {
            var zl = ml.name ? ": " + ml.name : "";
            return Sl.stylize("[Function" + zl + "]", "special");
          }
          if (nl(ml)) return Sl.stylize(RegExp.prototype.toString.call(ml), "regexp");
          if (il(ml)) return Sl.stylize(Date.prototype.toString.call(ml), "date");
          if (cl(ml)) return Ta(ml);
        }
        var Zl, kl = "", ul = !1, vl = ["{", "}"];
        return Za(ml) && (ul = !0, vl = ["[", "]"]), ll(ml) && (kl = " [Function" + (ml.name ? ": " + ml.name : "") + "]"), nl(ml) && (kl = " " + RegExp.prototype.toString.call(ml)), il(ml) && (kl = " " + Date.prototype.toUTCString.call(ml)), cl(ml) && (kl = " " + Ta(ml)), Fl.length !== 0 || ul && ml.length != 0 ? Dl < 0 ? nl(ml) ? Sl.stylize(RegExp.prototype.toString.call(ml), "regexp") : Sl.stylize("[Object]", "special") : (Sl.seen.push(ml), Zl = ul ? Sa(Sl, ml, Dl, Nl, Fl) : Fl.map(function(Tl) {
          return Ma(Sl, ml, Dl, Nl, Tl, ul);
        }), Sl.seen.pop(), ka(Zl, kl, vl)) : vl[0] + kl + vl[1];
      }
      function wa(Sl, ml) {
        if (Qa(ml)) return Sl.stylize("undefined", "undefined");
        if (qa(ml)) {
          var Dl = "'" + JSON.stringify(ml).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return Sl.stylize(Dl, "string");
        }
        return el(ml) ? Sl.stylize("" + ml, "number") : Na(ml) ? Sl.stylize("" + ml, "boolean") : Ka(ml) ? Sl.stylize("null", "null") : void 0;
      }
      function Ta(Sl) {
        return "[" + Error.prototype.toString.call(Sl) + "]";
      }
      function Sa(Sl, ml, Dl, _l, gl) {
        for (var Fl = [], Nl = 0, zl = ml.length; Nl < zl; ++Nl) Ml(ml, String(Nl)) ? Fl.push(Ma(Sl, ml, Dl, _l, String(Nl), !0)) : Fl.push("");
        return gl.forEach(function(Zl) {
          Zl.match(/^\d+$/) || Fl.push(Ma(Sl, ml, Dl, _l, Zl, !0));
        }), Fl;
      }
      function Ma(Sl, ml, Dl, _l, gl, Fl) {
        var Nl, zl, Zl;
        if ((Zl = Object.getOwnPropertyDescriptor(ml, gl) || { value: ml[gl] }).get ? zl = Zl.set ? Sl.stylize("[Getter/Setter]", "special") : Sl.stylize("[Getter]", "special") : Zl.set && (zl = Sl.stylize("[Setter]", "special")), Ml(_l, gl) || (Nl = "[" + gl + "]"), zl || (Sl.seen.indexOf(Zl.value) < 0 ? (zl = Ka(Dl) ? xa(Sl, Zl.value, null) : xa(Sl, Zl.value, Dl - 1)).indexOf(`
`) > -1 && (zl = Fl ? zl.split(`
`).map(function(kl) {
          return "  " + kl;
        }).join(`
`).substr(2) : `
` + zl.split(`
`).map(function(kl) {
          return "   " + kl;
        }).join(`
`)) : zl = Sl.stylize("[Circular]", "special")), Qa(Nl)) {
          if (Fl && gl.match(/^\d+$/)) return zl;
          (Nl = JSON.stringify("" + gl)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Nl = Nl.substr(1, Nl.length - 2), Nl = Sl.stylize(Nl, "name")) : (Nl = Nl.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Nl = Sl.stylize(Nl, "string"));
        }
        return Nl + ": " + zl;
      }
      function ka(Sl, ml, Dl) {
        return Sl.reduce(function(_l, gl) {
          return gl.indexOf(`
`), _l + gl.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60 ? Dl[0] + (ml === "" ? "" : ml + `
 `) + " " + Sl.join(`,
  `) + " " + Dl[1] : Dl[0] + ml + " " + Sl.join(", ") + " " + Dl[1];
      }
      function Za(Sl) {
        return Array.isArray(Sl);
      }
      function Na(Sl) {
        return typeof Sl == "boolean";
      }
      function Ka(Sl) {
        return Sl === null;
      }
      function Ja(Sl) {
        return Sl == null;
      }
      function el(Sl) {
        return typeof Sl == "number";
      }
      function qa(Sl) {
        return typeof Sl == "string";
      }
      function tl(Sl) {
        return typeof Sl == "symbol";
      }
      function Qa(Sl) {
        return Sl === void 0;
      }
      function nl(Sl) {
        return rl(Sl) && sl(Sl) === "[object RegExp]";
      }
      function rl(Sl) {
        return typeof Sl == "object" && Sl !== null;
      }
      function il(Sl) {
        return rl(Sl) && sl(Sl) === "[object Date]";
      }
      function cl(Sl) {
        return rl(Sl) && (sl(Sl) === "[object Error]" || Sl instanceof Error);
      }
      function ll(Sl) {
        return typeof Sl == "function";
      }
      function al(Sl) {
        return Sl === null || typeof Sl == "boolean" || typeof Sl == "number" || typeof Sl == "string" || typeof Sl == "symbol" || Sl === void 0;
      }
      function sl(Sl) {
        return Object.prototype.toString.call(Sl);
      }
      function dl(Sl) {
        return Sl < 10 ? "0" + Sl.toString(10) : Sl.toString(10);
      }
      Un.debuglog = function(Sl) {
        if (Qa(pa) && (pa = Kn.env.NODE_DEBUG || ""), Sl = Sl.toUpperCase(), !ma[Sl]) if (new RegExp("\\b" + Sl + "\\b", "i").test(pa)) {
          var ml = Kn.pid;
          ma[Sl] = function() {
            var Dl = Un.format.apply(Un, arguments);
            console.error("%s %d: %s", Sl, ml, Dl);
          };
        } else ma[Sl] = function() {
        };
        return ma[Sl];
      }, Un.inspect = va, va.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, va.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, Un.isArray = Za, Un.isBoolean = Na, Un.isNull = Ka, Un.isNullOrUndefined = Ja, Un.isNumber = el, Un.isString = qa, Un.isSymbol = tl, Un.isUndefined = Qa, Un.isRegExp = nl, Un.isObject = rl, Un.isDate = il, Un.isError = cl, Un.isFunction = ll, Un.isPrimitive = al, Un.isBuffer = Xn("./support/isBuffer");
      var El = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      function fl() {
        var Sl = /* @__PURE__ */ new Date(), ml = [dl(Sl.getHours()), dl(Sl.getMinutes()), dl(Sl.getSeconds())].join(":");
        return [Sl.getDate(), El[Sl.getMonth()], ml].join(" ");
      }
      function Ml(Sl, ml) {
        return Object.prototype.hasOwnProperty.call(Sl, ml);
      }
      Un.log = function() {
        console.log("%s - %s", fl(), Un.format.apply(Un, arguments));
      }, Un.inherits = Xn("inherits"), Un._extend = function(Sl, ml) {
        if (!ml || !rl(ml)) return Sl;
        for (var Dl = Object.keys(ml), _l = Dl.length; _l--; ) Sl[Dl[_l]] = ml[Dl[_l]];
        return Sl;
      };
    }).call(this);
  }).call(this, Xn("_process"), commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, { "./support/isBuffer": 25, _process: 63, inherits: 24 }], 27: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = ["BigInt64Array", "BigUint64Array", "Float32Array", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray"], Jo = typeof globalThis > "u" ? Kn : globalThis;
      zn.exports = function() {
        for (var pa = [], ma = 0; ma < qn.length; ma++) typeof Jo[qn[ma]] == "function" && (pa[pa.length] = qn[ma]);
        return pa;
      };
    }).call(this);
  }).call(this, commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, {}], 28: [function(Xn, zn, Un) {
  Un.byteLength = _a, Un.toByteArray = xa, Un.fromByteArray = Sa;
  for (var Kn = [], qn = [], Jo = typeof Uint8Array < "u" ? Uint8Array : Array, pa = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ma = 0, va = pa.length; ma < va; ++ma) Kn[ma] = pa[ma], qn[pa.charCodeAt(ma)] = ma;
  function ba(Ma) {
    var ka = Ma.length;
    if (ka % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var Za = Ma.indexOf("=");
    return Za === -1 && (Za = ka), [Za, Za === ka ? 0 : 4 - Za % 4];
  }
  function _a(Ma) {
    var ka = ba(Ma), Za = ka[0], Na = ka[1];
    return 3 * (Za + Na) / 4 - Na;
  }
  function ya(Ma, ka, Za) {
    return 3 * (ka + Za) / 4 - Za;
  }
  function xa(Ma) {
    var ka, Za, Na = ba(Ma), Ka = Na[0], Ja = Na[1], el = new Jo(ya(Ma, Ka, Ja)), qa = 0, tl = Ja > 0 ? Ka - 4 : Ka;
    for (Za = 0; Za < tl; Za += 4) ka = qn[Ma.charCodeAt(Za)] << 18 | qn[Ma.charCodeAt(Za + 1)] << 12 | qn[Ma.charCodeAt(Za + 2)] << 6 | qn[Ma.charCodeAt(Za + 3)], el[qa++] = ka >> 16 & 255, el[qa++] = ka >> 8 & 255, el[qa++] = 255 & ka;
    return Ja === 2 && (ka = qn[Ma.charCodeAt(Za)] << 2 | qn[Ma.charCodeAt(Za + 1)] >> 4, el[qa++] = 255 & ka), Ja === 1 && (ka = qn[Ma.charCodeAt(Za)] << 10 | qn[Ma.charCodeAt(Za + 1)] << 4 | qn[Ma.charCodeAt(Za + 2)] >> 2, el[qa++] = ka >> 8 & 255, el[qa++] = 255 & ka), el;
  }
  function wa(Ma) {
    return Kn[Ma >> 18 & 63] + Kn[Ma >> 12 & 63] + Kn[Ma >> 6 & 63] + Kn[63 & Ma];
  }
  function Ta(Ma, ka, Za) {
    for (var Na, Ka = [], Ja = ka; Ja < Za; Ja += 3) Na = (Ma[Ja] << 16 & 16711680) + (Ma[Ja + 1] << 8 & 65280) + (255 & Ma[Ja + 2]), Ka.push(wa(Na));
    return Ka.join("");
  }
  function Sa(Ma) {
    for (var ka, Za = Ma.length, Na = Za % 3, Ka = [], Ja = 16383, el = 0, qa = Za - Na; el < qa; el += Ja) Ka.push(Ta(Ma, el, el + Ja > qa ? qa : el + Ja));
    return Na === 1 ? (ka = Ma[Za - 1], Ka.push(Kn[ka >> 2] + Kn[ka << 4 & 63] + "==")) : Na === 2 && (ka = (Ma[Za - 2] << 8) + Ma[Za - 1], Ka.push(Kn[ka >> 10] + Kn[ka >> 4 & 63] + Kn[ka << 2 & 63] + "=")), Ka.join("");
  }
  qn[45] = 62, qn[95] = 63;
}, {}], 29: [function(Xn, zn, Un) {
}, {}], 30: [function(Xn, zn, Un) {
  (function(Kn, qn) {
    (function() {
      var Jo = Xn("assert"), pa = Xn("pako/lib/zlib/zstream"), ma = Xn("pako/lib/zlib/deflate.js"), va = Xn("pako/lib/zlib/inflate.js"), ba = Xn("pako/lib/zlib/constants");
      for (var _a in ba) Un[_a] = ba[_a];
      Un.NONE = 0, Un.DEFLATE = 1, Un.INFLATE = 2, Un.GZIP = 3, Un.GUNZIP = 4, Un.DEFLATERAW = 5, Un.INFLATERAW = 6, Un.UNZIP = 7;
      var ya = 31, xa = 139;
      function wa(Ta) {
        if (typeof Ta != "number" || Ta < Un.DEFLATE || Ta > Un.UNZIP) throw new TypeError("Bad argument");
        this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = Ta, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
      }
      wa.prototype.close = function() {
        this.write_in_progress ? this.pending_close = !0 : (this.pending_close = !1, Jo(this.init_done, "close before init"), Jo(this.mode <= Un.UNZIP), this.mode === Un.DEFLATE || this.mode === Un.GZIP || this.mode === Un.DEFLATERAW ? ma.deflateEnd(this.strm) : this.mode !== Un.INFLATE && this.mode !== Un.GUNZIP && this.mode !== Un.INFLATERAW && this.mode !== Un.UNZIP || va.inflateEnd(this.strm), this.mode = Un.NONE, this.dictionary = null);
      }, wa.prototype.write = function(Ta, Sa, Ma, ka, Za, Na, Ka) {
        return this._write(!0, Ta, Sa, Ma, ka, Za, Na, Ka);
      }, wa.prototype.writeSync = function(Ta, Sa, Ma, ka, Za, Na, Ka) {
        return this._write(!1, Ta, Sa, Ma, ka, Za, Na, Ka);
      }, wa.prototype._write = function(Ta, Sa, Ma, ka, Za, Na, Ka, Ja) {
        if (Jo.equal(arguments.length, 8), Jo(this.init_done, "write before init"), Jo(this.mode !== Un.NONE, "already finalized"), Jo.equal(!1, this.write_in_progress, "write already in progress"), Jo.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, Jo.equal(!1, Sa === void 0, "must provide flush value"), this.write_in_progress = !0, Sa !== Un.Z_NO_FLUSH && Sa !== Un.Z_PARTIAL_FLUSH && Sa !== Un.Z_SYNC_FLUSH && Sa !== Un.Z_FULL_FLUSH && Sa !== Un.Z_FINISH && Sa !== Un.Z_BLOCK) throw new Error("Invalid flush value");
        if (Ma == null && (Ma = qn.alloc(0), Za = 0, ka = 0), this.strm.avail_in = Za, this.strm.input = Ma, this.strm.next_in = ka, this.strm.avail_out = Ja, this.strm.output = Na, this.strm.next_out = Ka, this.flush = Sa, !Ta) return this._process(), this._checkError() ? this._afterSync() : void 0;
        var el = this;
        return Kn.nextTick(function() {
          el._process(), el._after();
        }), this;
      }, wa.prototype._afterSync = function() {
        var Ta = this.strm.avail_out, Sa = this.strm.avail_in;
        return this.write_in_progress = !1, [Sa, Ta];
      }, wa.prototype._process = function() {
        var Ta = null;
        switch (this.mode) {
          case Un.DEFLATE:
          case Un.GZIP:
          case Un.DEFLATERAW:
            this.err = ma.deflate(this.strm, this.flush);
            break;
          case Un.UNZIP:
            switch (this.strm.avail_in > 0 && (Ta = this.strm.next_in), this.gzip_id_bytes_read) {
              case 0:
                if (Ta === null) break;
                if (this.strm.input[Ta] !== ya) {
                  this.mode = Un.INFLATE;
                  break;
                }
                if (this.gzip_id_bytes_read = 1, Ta++, this.strm.avail_in === 1) break;
              case 1:
                if (Ta === null) break;
                this.strm.input[Ta] === xa ? (this.gzip_id_bytes_read = 2, this.mode = Un.GUNZIP) : this.mode = Un.INFLATE;
                break;
              default:
                throw new Error("invalid number of gzip magic number bytes read");
            }
          case Un.INFLATE:
          case Un.GUNZIP:
          case Un.INFLATERAW:
            for (this.err = va.inflate(this.strm, this.flush), this.err === Un.Z_NEED_DICT && this.dictionary && (this.err = va.inflateSetDictionary(this.strm, this.dictionary), this.err === Un.Z_OK ? this.err = va.inflate(this.strm, this.flush) : this.err === Un.Z_DATA_ERROR && (this.err = Un.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === Un.GUNZIP && this.err === Un.Z_STREAM_END && this.strm.next_in[0] !== 0; ) this.reset(), this.err = va.inflate(this.strm, this.flush);
            break;
          default:
            throw new Error("Unknown mode " + this.mode);
        }
      }, wa.prototype._checkError = function() {
        switch (this.err) {
          case Un.Z_OK:
          case Un.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === Un.Z_FINISH) return this._error("unexpected end of file"), !1;
            break;
          case Un.Z_STREAM_END:
            break;
          case Un.Z_NEED_DICT:
            return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
          default:
            return this._error("Zlib error"), !1;
        }
        return !0;
      }, wa.prototype._after = function() {
        if (this._checkError()) {
          var Ta = this.strm.avail_out, Sa = this.strm.avail_in;
          this.write_in_progress = !1, this.callback(Sa, Ta), this.pending_close && this.close();
        }
      }, wa.prototype._error = function(Ta) {
        this.strm.msg && (Ta = this.strm.msg), this.onerror(Ta, this.err), this.write_in_progress = !1, this.pending_close && this.close();
      }, wa.prototype.init = function(Ta, Sa, Ma, ka, Za) {
        Jo(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), Jo(Ta >= 8 && Ta <= 15, "invalid windowBits"), Jo(Sa >= -1 && Sa <= 9, "invalid compression level"), Jo(Ma >= 1 && Ma <= 9, "invalid memlevel"), Jo(ka === Un.Z_FILTERED || ka === Un.Z_HUFFMAN_ONLY || ka === Un.Z_RLE || ka === Un.Z_FIXED || ka === Un.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(Sa, Ta, Ma, ka, Za), this._setDictionary();
      }, wa.prototype.params = function() {
        throw new Error("deflateParams Not supported");
      }, wa.prototype.reset = function() {
        this._reset(), this._setDictionary();
      }, wa.prototype._init = function(Ta, Sa, Ma, ka, Za) {
        switch (this.level = Ta, this.windowBits = Sa, this.memLevel = Ma, this.strategy = ka, this.flush = Un.Z_NO_FLUSH, this.err = Un.Z_OK, this.mode !== Un.GZIP && this.mode !== Un.GUNZIP || (this.windowBits += 16), this.mode === Un.UNZIP && (this.windowBits += 32), this.mode !== Un.DEFLATERAW && this.mode !== Un.INFLATERAW || (this.windowBits = -1 * this.windowBits), this.strm = new pa(), this.mode) {
          case Un.DEFLATE:
          case Un.GZIP:
          case Un.DEFLATERAW:
            this.err = ma.deflateInit2(this.strm, this.level, Un.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
          case Un.INFLATE:
          case Un.GUNZIP:
          case Un.INFLATERAW:
          case Un.UNZIP:
            this.err = va.inflateInit2(this.strm, this.windowBits);
            break;
          default:
            throw new Error("Unknown mode " + this.mode);
        }
        this.err !== Un.Z_OK && this._error("Init error"), this.dictionary = Za, this.write_in_progress = !1, this.init_done = !0;
      }, wa.prototype._setDictionary = function() {
        if (this.dictionary != null) {
          switch (this.err = Un.Z_OK, this.mode) {
            case Un.DEFLATE:
            case Un.DEFLATERAW:
              this.err = ma.deflateSetDictionary(this.strm, this.dictionary);
          }
          this.err !== Un.Z_OK && this._error("Failed to set dictionary");
        }
      }, wa.prototype._reset = function() {
        switch (this.err = Un.Z_OK, this.mode) {
          case Un.DEFLATE:
          case Un.DEFLATERAW:
          case Un.GZIP:
            this.err = ma.deflateReset(this.strm);
            break;
          case Un.INFLATE:
          case Un.INFLATERAW:
          case Un.GUNZIP:
            this.err = va.inflateReset(this.strm);
        }
        this.err !== Un.Z_OK && this._error("Failed to reset stream");
      }, Un.Zlib = wa;
    }).call(this);
  }).call(this, Xn("_process"), Xn("buffer").Buffer);
}, { _process: 63, assert: 23, buffer: 32, "pako/lib/zlib/constants": 54, "pako/lib/zlib/deflate.js": 56, "pako/lib/zlib/inflate.js": 58, "pako/lib/zlib/zstream": 62 }], 31: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = Xn("buffer").Buffer, Jo = Xn("stream").Transform, pa = Xn("./binding"), ma = Xn("util"), va = Xn("assert").ok, ba = Xn("buffer").kMaxLength, _a = "Cannot create final Buffer. It would be larger than 0x" + ba.toString(16) + " bytes";
      pa.Z_MIN_WINDOWBITS = 8, pa.Z_MAX_WINDOWBITS = 15, pa.Z_DEFAULT_WINDOWBITS = 15, pa.Z_MIN_CHUNK = 64, pa.Z_MAX_CHUNK = 1 / 0, pa.Z_DEFAULT_CHUNK = 16384, pa.Z_MIN_MEMLEVEL = 1, pa.Z_MAX_MEMLEVEL = 9, pa.Z_DEFAULT_MEMLEVEL = 8, pa.Z_MIN_LEVEL = -1, pa.Z_MAX_LEVEL = 9, pa.Z_DEFAULT_LEVEL = pa.Z_DEFAULT_COMPRESSION;
      for (var ya = Object.keys(pa), xa = 0; xa < ya.length; xa++) {
        var wa = ya[xa];
        wa.match(/^Z/) && Object.defineProperty(Un, wa, { enumerable: !0, value: pa[wa], writable: !1 });
      }
      for (var Ta = { Z_OK: pa.Z_OK, Z_STREAM_END: pa.Z_STREAM_END, Z_NEED_DICT: pa.Z_NEED_DICT, Z_ERRNO: pa.Z_ERRNO, Z_STREAM_ERROR: pa.Z_STREAM_ERROR, Z_DATA_ERROR: pa.Z_DATA_ERROR, Z_MEM_ERROR: pa.Z_MEM_ERROR, Z_BUF_ERROR: pa.Z_BUF_ERROR, Z_VERSION_ERROR: pa.Z_VERSION_ERROR }, Sa = Object.keys(Ta), Ma = 0; Ma < Sa.length; Ma++) {
        var ka = Sa[Ma];
        Ta[Ta[ka]] = ka;
      }
      function Za(al, sl, dl) {
        var El = [], fl = 0;
        function Ml() {
          for (var Dl; (Dl = al.read()) !== null; ) El.push(Dl), fl += Dl.length;
          al.once("readable", Ml);
        }
        function Sl(Dl) {
          al.removeListener("end", ml), al.removeListener("readable", Ml), dl(Dl);
        }
        function ml() {
          var Dl, _l = null;
          fl >= ba ? _l = new RangeError(_a) : Dl = qn.concat(El, fl), El = [], al.close(), dl(_l, Dl);
        }
        al.on("error", Sl), al.on("end", ml), al.end(sl), Ml();
      }
      function Na(al, sl) {
        if (typeof sl == "string" && (sl = qn.from(sl)), !qn.isBuffer(sl)) throw new TypeError("Not a string or buffer");
        var dl = al._finishFlushFlag;
        return al._processChunk(sl, dl);
      }
      function Ka(al) {
        if (!(this instanceof Ka)) return new Ka(al);
        il.call(this, al, pa.DEFLATE);
      }
      function Ja(al) {
        if (!(this instanceof Ja)) return new Ja(al);
        il.call(this, al, pa.INFLATE);
      }
      function el(al) {
        if (!(this instanceof el)) return new el(al);
        il.call(this, al, pa.GZIP);
      }
      function qa(al) {
        if (!(this instanceof qa)) return new qa(al);
        il.call(this, al, pa.GUNZIP);
      }
      function tl(al) {
        if (!(this instanceof tl)) return new tl(al);
        il.call(this, al, pa.DEFLATERAW);
      }
      function Qa(al) {
        if (!(this instanceof Qa)) return new Qa(al);
        il.call(this, al, pa.INFLATERAW);
      }
      function nl(al) {
        if (!(this instanceof nl)) return new nl(al);
        il.call(this, al, pa.UNZIP);
      }
      function rl(al) {
        return al === pa.Z_NO_FLUSH || al === pa.Z_PARTIAL_FLUSH || al === pa.Z_SYNC_FLUSH || al === pa.Z_FULL_FLUSH || al === pa.Z_FINISH || al === pa.Z_BLOCK;
      }
      function il(al, sl) {
        var dl = this;
        if (this._opts = al = al || {}, this._chunkSize = al.chunkSize || Un.Z_DEFAULT_CHUNK, Jo.call(this, al), al.flush && !rl(al.flush)) throw new Error("Invalid flush flag: " + al.flush);
        if (al.finishFlush && !rl(al.finishFlush)) throw new Error("Invalid flush flag: " + al.finishFlush);
        if (this._flushFlag = al.flush || pa.Z_NO_FLUSH, this._finishFlushFlag = al.finishFlush !== void 0 ? al.finishFlush : pa.Z_FINISH, al.chunkSize && (al.chunkSize < Un.Z_MIN_CHUNK || al.chunkSize > Un.Z_MAX_CHUNK)) throw new Error("Invalid chunk size: " + al.chunkSize);
        if (al.windowBits && (al.windowBits < Un.Z_MIN_WINDOWBITS || al.windowBits > Un.Z_MAX_WINDOWBITS)) throw new Error("Invalid windowBits: " + al.windowBits);
        if (al.level && (al.level < Un.Z_MIN_LEVEL || al.level > Un.Z_MAX_LEVEL)) throw new Error("Invalid compression level: " + al.level);
        if (al.memLevel && (al.memLevel < Un.Z_MIN_MEMLEVEL || al.memLevel > Un.Z_MAX_MEMLEVEL)) throw new Error("Invalid memLevel: " + al.memLevel);
        if (al.strategy && al.strategy != Un.Z_FILTERED && al.strategy != Un.Z_HUFFMAN_ONLY && al.strategy != Un.Z_RLE && al.strategy != Un.Z_FIXED && al.strategy != Un.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + al.strategy);
        if (al.dictionary && !qn.isBuffer(al.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
        this._handle = new pa.Zlib(sl);
        var El = this;
        this._hadError = !1, this._handle.onerror = function(Sl, ml) {
          cl(El), El._hadError = !0;
          var Dl = new Error(Sl);
          Dl.errno = ml, Dl.code = Un.codes[ml], El.emit("error", Dl);
        };
        var fl = Un.Z_DEFAULT_COMPRESSION;
        typeof al.level == "number" && (fl = al.level);
        var Ml = Un.Z_DEFAULT_STRATEGY;
        typeof al.strategy == "number" && (Ml = al.strategy), this._handle.init(al.windowBits || Un.Z_DEFAULT_WINDOWBITS, fl, al.memLevel || Un.Z_DEFAULT_MEMLEVEL, Ml, al.dictionary), this._buffer = qn.allocUnsafe(this._chunkSize), this._offset = 0, this._level = fl, this._strategy = Ml, this.once("end", this.close), Object.defineProperty(this, "_closed", { get: function() {
          return !dl._handle;
        }, configurable: !0, enumerable: !0 });
      }
      function cl(al, sl) {
        sl && Kn.nextTick(sl), al._handle && (al._handle.close(), al._handle = null);
      }
      function ll(al) {
        al.emit("close");
      }
      Object.defineProperty(Un, "codes", { enumerable: !0, value: Object.freeze(Ta), writable: !1 }), Un.Deflate = Ka, Un.Inflate = Ja, Un.Gzip = el, Un.Gunzip = qa, Un.DeflateRaw = tl, Un.InflateRaw = Qa, Un.Unzip = nl, Un.createDeflate = function(al) {
        return new Ka(al);
      }, Un.createInflate = function(al) {
        return new Ja(al);
      }, Un.createDeflateRaw = function(al) {
        return new tl(al);
      }, Un.createInflateRaw = function(al) {
        return new Qa(al);
      }, Un.createGzip = function(al) {
        return new el(al);
      }, Un.createGunzip = function(al) {
        return new qa(al);
      }, Un.createUnzip = function(al) {
        return new nl(al);
      }, Un.deflate = function(al, sl, dl) {
        return typeof sl == "function" && (dl = sl, sl = {}), Za(new Ka(sl), al, dl);
      }, Un.deflateSync = function(al, sl) {
        return Na(new Ka(sl), al);
      }, Un.gzip = function(al, sl, dl) {
        return typeof sl == "function" && (dl = sl, sl = {}), Za(new el(sl), al, dl);
      }, Un.gzipSync = function(al, sl) {
        return Na(new el(sl), al);
      }, Un.deflateRaw = function(al, sl, dl) {
        return typeof sl == "function" && (dl = sl, sl = {}), Za(new tl(sl), al, dl);
      }, Un.deflateRawSync = function(al, sl) {
        return Na(new tl(sl), al);
      }, Un.unzip = function(al, sl, dl) {
        return typeof sl == "function" && (dl = sl, sl = {}), Za(new nl(sl), al, dl);
      }, Un.unzipSync = function(al, sl) {
        return Na(new nl(sl), al);
      }, Un.inflate = function(al, sl, dl) {
        return typeof sl == "function" && (dl = sl, sl = {}), Za(new Ja(sl), al, dl);
      }, Un.inflateSync = function(al, sl) {
        return Na(new Ja(sl), al);
      }, Un.gunzip = function(al, sl, dl) {
        return typeof sl == "function" && (dl = sl, sl = {}), Za(new qa(sl), al, dl);
      }, Un.gunzipSync = function(al, sl) {
        return Na(new qa(sl), al);
      }, Un.inflateRaw = function(al, sl, dl) {
        return typeof sl == "function" && (dl = sl, sl = {}), Za(new Qa(sl), al, dl);
      }, Un.inflateRawSync = function(al, sl) {
        return Na(new Qa(sl), al);
      }, ma.inherits(il, Jo), il.prototype.params = function(al, sl, dl) {
        if (al < Un.Z_MIN_LEVEL || al > Un.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + al);
        if (sl != Un.Z_FILTERED && sl != Un.Z_HUFFMAN_ONLY && sl != Un.Z_RLE && sl != Un.Z_FIXED && sl != Un.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + sl);
        if (this._level !== al || this._strategy !== sl) {
          var El = this;
          this.flush(pa.Z_SYNC_FLUSH, function() {
            va(El._handle, "zlib binding closed"), El._handle.params(al, sl), El._hadError || (El._level = al, El._strategy = sl, dl && dl());
          });
        } else Kn.nextTick(dl);
      }, il.prototype.reset = function() {
        return va(this._handle, "zlib binding closed"), this._handle.reset();
      }, il.prototype._flush = function(al) {
        this._transform(qn.alloc(0), "", al);
      }, il.prototype.flush = function(al, sl) {
        var dl = this, El = this._writableState;
        (typeof al == "function" || al === void 0 && !sl) && (sl = al, al = pa.Z_FULL_FLUSH), El.ended ? sl && Kn.nextTick(sl) : El.ending ? sl && this.once("end", sl) : El.needDrain ? sl && this.once("drain", function() {
          return dl.flush(al, sl);
        }) : (this._flushFlag = al, this.write(qn.alloc(0), "", sl));
      }, il.prototype.close = function(al) {
        cl(this, al), Kn.nextTick(ll, this);
      }, il.prototype._transform = function(al, sl, dl) {
        var El, fl = this._writableState, Ml = (fl.ending || fl.ended) && (!al || fl.length === al.length);
        return al === null || qn.isBuffer(al) ? this._handle ? (Ml ? El = this._finishFlushFlag : (El = this._flushFlag, al.length >= fl.length && (this._flushFlag = this._opts.flush || pa.Z_NO_FLUSH)), void this._processChunk(al, El, dl)) : dl(new Error("zlib binding closed")) : dl(new Error("invalid input"));
      }, il.prototype._processChunk = function(al, sl, dl) {
        var El = al && al.length, fl = this._chunkSize - this._offset, Ml = 0, Sl = this, ml = typeof dl == "function";
        if (!ml) {
          var Dl, _l = [], gl = 0;
          this.on("error", function(kl) {
            Dl = kl;
          }), va(this._handle, "zlib binding closed");
          do
            var Fl = this._handle.writeSync(sl, al, Ml, El, this._buffer, this._offset, fl);
          while (!this._hadError && Zl(Fl[0], Fl[1]));
          if (this._hadError) throw Dl;
          if (gl >= ba) throw cl(this), new RangeError(_a);
          var Nl = qn.concat(_l, gl);
          return cl(this), Nl;
        }
        va(this._handle, "zlib binding closed");
        var zl = this._handle.write(sl, al, Ml, El, this._buffer, this._offset, fl);
        function Zl(kl, ul) {
          if (this && (this.buffer = null, this.callback = null), !Sl._hadError) {
            var vl = fl - ul;
            if (va(vl >= 0, "have should not go down"), vl > 0) {
              var Tl = Sl._buffer.slice(Sl._offset, Sl._offset + vl);
              Sl._offset += vl, ml ? Sl.push(Tl) : (_l.push(Tl), gl += Tl.length);
            }
            if ((ul === 0 || Sl._offset >= Sl._chunkSize) && (fl = Sl._chunkSize, Sl._offset = 0, Sl._buffer = qn.allocUnsafe(Sl._chunkSize)), ul === 0) {
              if (Ml += El - kl, El = kl, !ml) return !0;
              var wl = Sl._handle.write(sl, al, Ml, El, Sl._buffer, Sl._offset, Sl._chunkSize);
              return wl.callback = Zl, void (wl.buffer = al);
            }
            if (!ml) return !1;
            dl();
          }
        }
        zl.buffer = al, zl.callback = Zl;
      }, ma.inherits(Ka, il), ma.inherits(Ja, il), ma.inherits(el, il), ma.inherits(qa, il), ma.inherits(tl, il), ma.inherits(Qa, il), ma.inherits(nl, il);
    }).call(this);
  }).call(this, Xn("_process"));
}, { "./binding": 30, _process: 63, assert: 23, buffer: 32, stream: 65, util: 84 }], 32: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = Xn("base64-js"), Jo = Xn("ieee754");
      Un.Buffer = ba, Un.SlowBuffer = Na, Un.INSPECT_MAX_BYTES = 50;
      var pa = 2147483647;
      function ma() {
        try {
          var hl = new Uint8Array(1);
          return hl.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
            return 42;
          } }, hl.foo() === 42;
        } catch {
          return !1;
        }
      }
      function va(hl) {
        if (hl > pa) throw new RangeError('The value "' + hl + '" is invalid for option "size"');
        var Cl = new Uint8Array(hl);
        return Cl.__proto__ = ba.prototype, Cl;
      }
      function ba(hl, Cl, Il) {
        if (typeof hl == "number") {
          if (typeof Cl == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
          return wa(hl);
        }
        return _a(hl, Cl, Il);
      }
      function _a(hl, Cl, Il) {
        if (typeof hl == "string") return Ta(hl, Cl);
        if (ArrayBuffer.isView(hl)) return Sa(hl);
        if (hl == null) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof hl);
        if (Rl(hl, ArrayBuffer) || hl && Rl(hl.buffer, ArrayBuffer)) return Ma(hl, Cl, Il);
        if (typeof hl == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
        var Ll = hl.valueOf && hl.valueOf();
        if (Ll != null && Ll !== hl) return ba.from(Ll, Cl, Il);
        var tc = ka(hl);
        if (tc) return tc;
        if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof hl[Symbol.toPrimitive] == "function") return ba.from(hl[Symbol.toPrimitive]("string"), Cl, Il);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof hl);
      }
      function ya(hl) {
        if (typeof hl != "number") throw new TypeError('"size" argument must be of type number');
        if (hl < 0) throw new RangeError('The value "' + hl + '" is invalid for option "size"');
      }
      function xa(hl, Cl, Il) {
        return ya(hl), hl <= 0 ? va(hl) : Cl !== void 0 ? typeof Il == "string" ? va(hl).fill(Cl, Il) : va(hl).fill(Cl) : va(hl);
      }
      function wa(hl) {
        return ya(hl), va(hl < 0 ? 0 : 0 | Za(hl));
      }
      function Ta(hl, Cl) {
        if (typeof Cl == "string" && Cl !== "" || (Cl = "utf8"), !ba.isEncoding(Cl)) throw new TypeError("Unknown encoding: " + Cl);
        var Il = 0 | Ka(hl, Cl), Ll = va(Il), tc = Ll.write(hl, Cl);
        return tc !== Il && (Ll = Ll.slice(0, tc)), Ll;
      }
      function Sa(hl) {
        for (var Cl = hl.length < 0 ? 0 : 0 | Za(hl.length), Il = va(Cl), Ll = 0; Ll < Cl; Ll += 1) Il[Ll] = 255 & hl[Ll];
        return Il;
      }
      function Ma(hl, Cl, Il) {
        if (Cl < 0 || hl.byteLength < Cl) throw new RangeError('"offset" is outside of buffer bounds');
        if (hl.byteLength < Cl + (Il || 0)) throw new RangeError('"length" is outside of buffer bounds');
        var Ll;
        return (Ll = Cl === void 0 && Il === void 0 ? new Uint8Array(hl) : Il === void 0 ? new Uint8Array(hl, Cl) : new Uint8Array(hl, Cl, Il)).__proto__ = ba.prototype, Ll;
      }
      function ka(hl) {
        if (ba.isBuffer(hl)) {
          var Cl = 0 | Za(hl.length), Il = va(Cl);
          return Il.length === 0 || hl.copy(Il, 0, 0, Cl), Il;
        }
        return hl.length !== void 0 ? typeof hl.length != "number" || Ul(hl.length) ? va(0) : Sa(hl) : hl.type === "Buffer" && Array.isArray(hl.data) ? Sa(hl.data) : void 0;
      }
      function Za(hl) {
        if (hl >= pa) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + pa.toString(16) + " bytes");
        return 0 | hl;
      }
      function Na(hl) {
        return +hl != hl && (hl = 0), ba.alloc(+hl);
      }
      function Ka(hl, Cl) {
        if (ba.isBuffer(hl)) return hl.length;
        if (ArrayBuffer.isView(hl) || Rl(hl, ArrayBuffer)) return hl.byteLength;
        if (typeof hl != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof hl);
        var Il = hl.length, Ll = arguments.length > 2 && arguments[2] === !0;
        if (!Ll && Il === 0) return 0;
        for (var tc = !1; ; ) switch (Cl) {
          case "ascii":
          case "latin1":
          case "binary":
            return Il;
          case "utf8":
          case "utf-8":
            return ul(hl).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * Il;
          case "hex":
            return Il >>> 1;
          case "base64":
            return wl(hl).length;
          default:
            if (tc) return Ll ? -1 : ul(hl).length;
            Cl = ("" + Cl).toLowerCase(), tc = !0;
        }
      }
      function Ja(hl, Cl, Il) {
        var Ll = !1;
        if ((Cl === void 0 || Cl < 0) && (Cl = 0), Cl > this.length || ((Il === void 0 || Il > this.length) && (Il = this.length), Il <= 0) || (Il >>>= 0) <= (Cl >>>= 0)) return "";
        for (hl || (hl = "utf8"); ; ) switch (hl) {
          case "hex":
            return Sl(this, Cl, Il);
          case "utf8":
          case "utf-8":
            return sl(this, Cl, Il);
          case "ascii":
            return fl(this, Cl, Il);
          case "latin1":
          case "binary":
            return Ml(this, Cl, Il);
          case "base64":
            return al(this, Cl, Il);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ml(this, Cl, Il);
          default:
            if (Ll) throw new TypeError("Unknown encoding: " + hl);
            hl = (hl + "").toLowerCase(), Ll = !0;
        }
      }
      function el(hl, Cl, Il) {
        var Ll = hl[Cl];
        hl[Cl] = hl[Il], hl[Il] = Ll;
      }
      function qa(hl, Cl, Il, Ll, tc) {
        if (hl.length === 0) return -1;
        if (typeof Il == "string" ? (Ll = Il, Il = 0) : Il > 2147483647 ? Il = 2147483647 : Il < -2147483648 && (Il = -2147483648), Ul(Il = +Il) && (Il = tc ? 0 : hl.length - 1), Il < 0 && (Il = hl.length + Il), Il >= hl.length) {
          if (tc) return -1;
          Il = hl.length - 1;
        } else if (Il < 0) {
          if (!tc) return -1;
          Il = 0;
        }
        if (typeof Cl == "string" && (Cl = ba.from(Cl, Ll)), ba.isBuffer(Cl)) return Cl.length === 0 ? -1 : tl(hl, Cl, Il, Ll, tc);
        if (typeof Cl == "number") return Cl &= 255, typeof Uint8Array.prototype.indexOf == "function" ? tc ? Uint8Array.prototype.indexOf.call(hl, Cl, Il) : Uint8Array.prototype.lastIndexOf.call(hl, Cl, Il) : tl(hl, [Cl], Il, Ll, tc);
        throw new TypeError("val must be string, number or Buffer");
      }
      function tl(hl, Cl, Il, Ll, tc) {
        var nc, uc = 1, _c = hl.length, mc = Cl.length;
        if (Ll !== void 0 && ((Ll = String(Ll).toLowerCase()) === "ucs2" || Ll === "ucs-2" || Ll === "utf16le" || Ll === "utf-16le")) {
          if (hl.length < 2 || Cl.length < 2) return -1;
          uc = 2, _c /= 2, mc /= 2, Il /= 2;
        }
        function Sc(Hl, fc) {
          return uc === 1 ? Hl[fc] : Hl.readUInt16BE(fc * uc);
        }
        if (tc) {
          var hc = -1;
          for (nc = Il; nc < _c; nc++) if (Sc(hl, nc) === Sc(Cl, hc === -1 ? 0 : nc - hc)) {
            if (hc === -1 && (hc = nc), nc - hc + 1 === mc) return hc * uc;
          } else hc !== -1 && (nc -= nc - hc), hc = -1;
        } else for (Il + mc > _c && (Il = _c - mc), nc = Il; nc >= 0; nc--) {
          for (var Lc = !0, Ec = 0; Ec < mc; Ec++) if (Sc(hl, nc + Ec) !== Sc(Cl, Ec)) {
            Lc = !1;
            break;
          }
          if (Lc) return nc;
        }
        return -1;
      }
      function Qa(hl, Cl, Il, Ll) {
        Il = Number(Il) || 0;
        var tc = hl.length - Il;
        Ll ? (Ll = Number(Ll)) > tc && (Ll = tc) : Ll = tc;
        var nc = Cl.length;
        Ll > nc / 2 && (Ll = nc / 2);
        for (var uc = 0; uc < Ll; ++uc) {
          var _c = parseInt(Cl.substr(2 * uc, 2), 16);
          if (Ul(_c)) return uc;
          hl[Il + uc] = _c;
        }
        return uc;
      }
      function nl(hl, Cl, Il, Ll) {
        return yl(ul(Cl, hl.length - Il), hl, Il, Ll);
      }
      function rl(hl, Cl, Il, Ll) {
        return yl(vl(Cl), hl, Il, Ll);
      }
      function il(hl, Cl, Il, Ll) {
        return rl(hl, Cl, Il, Ll);
      }
      function cl(hl, Cl, Il, Ll) {
        return yl(wl(Cl), hl, Il, Ll);
      }
      function ll(hl, Cl, Il, Ll) {
        return yl(Tl(Cl, hl.length - Il), hl, Il, Ll);
      }
      function al(hl, Cl, Il) {
        return Cl === 0 && Il === hl.length ? qn.fromByteArray(hl) : qn.fromByteArray(hl.slice(Cl, Il));
      }
      function sl(hl, Cl, Il) {
        Il = Math.min(hl.length, Il);
        for (var Ll = [], tc = Cl; tc < Il; ) {
          var nc, uc, _c, mc, Sc = hl[tc], hc = null, Lc = Sc > 239 ? 4 : Sc > 223 ? 3 : Sc > 191 ? 2 : 1;
          if (tc + Lc <= Il) switch (Lc) {
            case 1:
              Sc < 128 && (hc = Sc);
              break;
            case 2:
              (192 & (nc = hl[tc + 1])) == 128 && (mc = (31 & Sc) << 6 | 63 & nc) > 127 && (hc = mc);
              break;
            case 3:
              nc = hl[tc + 1], uc = hl[tc + 2], (192 & nc) == 128 && (192 & uc) == 128 && (mc = (15 & Sc) << 12 | (63 & nc) << 6 | 63 & uc) > 2047 && (mc < 55296 || mc > 57343) && (hc = mc);
              break;
            case 4:
              nc = hl[tc + 1], uc = hl[tc + 2], _c = hl[tc + 3], (192 & nc) == 128 && (192 & uc) == 128 && (192 & _c) == 128 && (mc = (15 & Sc) << 18 | (63 & nc) << 12 | (63 & uc) << 6 | 63 & _c) > 65535 && mc < 1114112 && (hc = mc);
          }
          hc === null ? (hc = 65533, Lc = 1) : hc > 65535 && (hc -= 65536, Ll.push(hc >>> 10 & 1023 | 55296), hc = 56320 | 1023 & hc), Ll.push(hc), tc += Lc;
        }
        return El(Ll);
      }
      Un.kMaxLength = pa, ba.TYPED_ARRAY_SUPPORT = ma(), ba.TYPED_ARRAY_SUPPORT || typeof console > "u" || typeof console.error != "function" || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(ba.prototype, "parent", { enumerable: !0, get: function() {
        if (ba.isBuffer(this)) return this.buffer;
      } }), Object.defineProperty(ba.prototype, "offset", { enumerable: !0, get: function() {
        if (ba.isBuffer(this)) return this.byteOffset;
      } }), typeof Symbol < "u" && Symbol.species != null && ba[Symbol.species] === ba && Object.defineProperty(ba, Symbol.species, { value: null, configurable: !0, enumerable: !1, writable: !1 }), ba.poolSize = 8192, ba.from = function(hl, Cl, Il) {
        return _a(hl, Cl, Il);
      }, ba.prototype.__proto__ = Uint8Array.prototype, ba.__proto__ = Uint8Array, ba.alloc = function(hl, Cl, Il) {
        return xa(hl, Cl, Il);
      }, ba.allocUnsafe = function(hl) {
        return wa(hl);
      }, ba.allocUnsafeSlow = function(hl) {
        return wa(hl);
      }, ba.isBuffer = function(hl) {
        return hl != null && hl._isBuffer === !0 && hl !== ba.prototype;
      }, ba.compare = function(hl, Cl) {
        if (Rl(hl, Uint8Array) && (hl = ba.from(hl, hl.offset, hl.byteLength)), Rl(Cl, Uint8Array) && (Cl = ba.from(Cl, Cl.offset, Cl.byteLength)), !ba.isBuffer(hl) || !ba.isBuffer(Cl)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (hl === Cl) return 0;
        for (var Il = hl.length, Ll = Cl.length, tc = 0, nc = Math.min(Il, Ll); tc < nc; ++tc) if (hl[tc] !== Cl[tc]) {
          Il = hl[tc], Ll = Cl[tc];
          break;
        }
        return Il < Ll ? -1 : Ll < Il ? 1 : 0;
      }, ba.isEncoding = function(hl) {
        switch (String(hl).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;
          default:
            return !1;
        }
      }, ba.concat = function(hl, Cl) {
        if (!Array.isArray(hl)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (hl.length === 0) return ba.alloc(0);
        var Il;
        if (Cl === void 0) for (Cl = 0, Il = 0; Il < hl.length; ++Il) Cl += hl[Il].length;
        var Ll = ba.allocUnsafe(Cl), tc = 0;
        for (Il = 0; Il < hl.length; ++Il) {
          var nc = hl[Il];
          if (Rl(nc, Uint8Array) && (nc = ba.from(nc)), !ba.isBuffer(nc)) throw new TypeError('"list" argument must be an Array of Buffers');
          nc.copy(Ll, tc), tc += nc.length;
        }
        return Ll;
      }, ba.byteLength = Ka, ba.prototype._isBuffer = !0, ba.prototype.swap16 = function() {
        var hl = this.length;
        if (hl % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (var Cl = 0; Cl < hl; Cl += 2) el(this, Cl, Cl + 1);
        return this;
      }, ba.prototype.swap32 = function() {
        var hl = this.length;
        if (hl % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (var Cl = 0; Cl < hl; Cl += 4) el(this, Cl, Cl + 3), el(this, Cl + 1, Cl + 2);
        return this;
      }, ba.prototype.swap64 = function() {
        var hl = this.length;
        if (hl % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (var Cl = 0; Cl < hl; Cl += 8) el(this, Cl, Cl + 7), el(this, Cl + 1, Cl + 6), el(this, Cl + 2, Cl + 5), el(this, Cl + 3, Cl + 4);
        return this;
      }, ba.prototype.toString = function() {
        var hl = this.length;
        return hl === 0 ? "" : arguments.length === 0 ? sl(this, 0, hl) : Ja.apply(this, arguments);
      }, ba.prototype.toLocaleString = ba.prototype.toString, ba.prototype.equals = function(hl) {
        if (!ba.isBuffer(hl)) throw new TypeError("Argument must be a Buffer");
        return this === hl || ba.compare(this, hl) === 0;
      }, ba.prototype.inspect = function() {
        var hl = "", Cl = Un.INSPECT_MAX_BYTES;
        return hl = this.toString("hex", 0, Cl).replace(/(.{2})/g, "$1 ").trim(), this.length > Cl && (hl += " ... "), "<Buffer " + hl + ">";
      }, ba.prototype.compare = function(hl, Cl, Il, Ll, tc) {
        if (Rl(hl, Uint8Array) && (hl = ba.from(hl, hl.offset, hl.byteLength)), !ba.isBuffer(hl)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof hl);
        if (Cl === void 0 && (Cl = 0), Il === void 0 && (Il = hl ? hl.length : 0), Ll === void 0 && (Ll = 0), tc === void 0 && (tc = this.length), Cl < 0 || Il > hl.length || Ll < 0 || tc > this.length) throw new RangeError("out of range index");
        if (Ll >= tc && Cl >= Il) return 0;
        if (Ll >= tc) return -1;
        if (Cl >= Il) return 1;
        if (this === hl) return 0;
        for (var nc = (tc >>>= 0) - (Ll >>>= 0), uc = (Il >>>= 0) - (Cl >>>= 0), _c = Math.min(nc, uc), mc = this.slice(Ll, tc), Sc = hl.slice(Cl, Il), hc = 0; hc < _c; ++hc) if (mc[hc] !== Sc[hc]) {
          nc = mc[hc], uc = Sc[hc];
          break;
        }
        return nc < uc ? -1 : uc < nc ? 1 : 0;
      }, ba.prototype.includes = function(hl, Cl, Il) {
        return this.indexOf(hl, Cl, Il) !== -1;
      }, ba.prototype.indexOf = function(hl, Cl, Il) {
        return qa(this, hl, Cl, Il, !0);
      }, ba.prototype.lastIndexOf = function(hl, Cl, Il) {
        return qa(this, hl, Cl, Il, !1);
      }, ba.prototype.write = function(hl, Cl, Il, Ll) {
        if (Cl === void 0) Ll = "utf8", Il = this.length, Cl = 0;
        else if (Il === void 0 && typeof Cl == "string") Ll = Cl, Il = this.length, Cl = 0;
        else {
          if (!isFinite(Cl)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          Cl >>>= 0, isFinite(Il) ? (Il >>>= 0, Ll === void 0 && (Ll = "utf8")) : (Ll = Il, Il = void 0);
        }
        var tc = this.length - Cl;
        if ((Il === void 0 || Il > tc) && (Il = tc), hl.length > 0 && (Il < 0 || Cl < 0) || Cl > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        Ll || (Ll = "utf8");
        for (var nc = !1; ; ) switch (Ll) {
          case "hex":
            return Qa(this, hl, Cl, Il);
          case "utf8":
          case "utf-8":
            return nl(this, hl, Cl, Il);
          case "ascii":
            return rl(this, hl, Cl, Il);
          case "latin1":
          case "binary":
            return il(this, hl, Cl, Il);
          case "base64":
            return cl(this, hl, Cl, Il);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ll(this, hl, Cl, Il);
          default:
            if (nc) throw new TypeError("Unknown encoding: " + Ll);
            Ll = ("" + Ll).toLowerCase(), nc = !0;
        }
      }, ba.prototype.toJSON = function() {
        return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
      };
      var dl = 4096;
      function El(hl) {
        var Cl = hl.length;
        if (Cl <= dl) return String.fromCharCode.apply(String, hl);
        for (var Il = "", Ll = 0; Ll < Cl; ) Il += String.fromCharCode.apply(String, hl.slice(Ll, Ll += dl));
        return Il;
      }
      function fl(hl, Cl, Il) {
        var Ll = "";
        Il = Math.min(hl.length, Il);
        for (var tc = Cl; tc < Il; ++tc) Ll += String.fromCharCode(127 & hl[tc]);
        return Ll;
      }
      function Ml(hl, Cl, Il) {
        var Ll = "";
        Il = Math.min(hl.length, Il);
        for (var tc = Cl; tc < Il; ++tc) Ll += String.fromCharCode(hl[tc]);
        return Ll;
      }
      function Sl(hl, Cl, Il) {
        var Ll = hl.length;
        (!Cl || Cl < 0) && (Cl = 0), (!Il || Il < 0 || Il > Ll) && (Il = Ll);
        for (var tc = "", nc = Cl; nc < Il; ++nc) tc += kl(hl[nc]);
        return tc;
      }
      function ml(hl, Cl, Il) {
        for (var Ll = hl.slice(Cl, Il), tc = "", nc = 0; nc < Ll.length; nc += 2) tc += String.fromCharCode(Ll[nc] + 256 * Ll[nc + 1]);
        return tc;
      }
      function Dl(hl, Cl, Il) {
        if (hl % 1 != 0 || hl < 0) throw new RangeError("offset is not uint");
        if (hl + Cl > Il) throw new RangeError("Trying to access beyond buffer length");
      }
      function _l(hl, Cl, Il, Ll, tc, nc) {
        if (!ba.isBuffer(hl)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (Cl > tc || Cl < nc) throw new RangeError('"value" argument is out of bounds');
        if (Il + Ll > hl.length) throw new RangeError("Index out of range");
      }
      function gl(hl, Cl, Il, Ll, tc, nc) {
        if (Il + Ll > hl.length) throw new RangeError("Index out of range");
        if (Il < 0) throw new RangeError("Index out of range");
      }
      function Fl(hl, Cl, Il, Ll, tc) {
        return Cl = +Cl, Il >>>= 0, tc || gl(hl, Cl, Il, 4), Jo.write(hl, Cl, Il, Ll, 23, 4), Il + 4;
      }
      function Nl(hl, Cl, Il, Ll, tc) {
        return Cl = +Cl, Il >>>= 0, tc || gl(hl, Cl, Il, 8), Jo.write(hl, Cl, Il, Ll, 52, 8), Il + 8;
      }
      ba.prototype.slice = function(hl, Cl) {
        var Il = this.length;
        (hl = ~~hl) < 0 ? (hl += Il) < 0 && (hl = 0) : hl > Il && (hl = Il), (Cl = Cl === void 0 ? Il : ~~Cl) < 0 ? (Cl += Il) < 0 && (Cl = 0) : Cl > Il && (Cl = Il), Cl < hl && (Cl = hl);
        var Ll = this.subarray(hl, Cl);
        return Ll.__proto__ = ba.prototype, Ll;
      }, ba.prototype.readUIntLE = function(hl, Cl, Il) {
        hl >>>= 0, Cl >>>= 0, Il || Dl(hl, Cl, this.length);
        for (var Ll = this[hl], tc = 1, nc = 0; ++nc < Cl && (tc *= 256); ) Ll += this[hl + nc] * tc;
        return Ll;
      }, ba.prototype.readUIntBE = function(hl, Cl, Il) {
        hl >>>= 0, Cl >>>= 0, Il || Dl(hl, Cl, this.length);
        for (var Ll = this[hl + --Cl], tc = 1; Cl > 0 && (tc *= 256); ) Ll += this[hl + --Cl] * tc;
        return Ll;
      }, ba.prototype.readUInt8 = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 1, this.length), this[hl];
      }, ba.prototype.readUInt16LE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 2, this.length), this[hl] | this[hl + 1] << 8;
      }, ba.prototype.readUInt16BE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 2, this.length), this[hl] << 8 | this[hl + 1];
      }, ba.prototype.readUInt32LE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 4, this.length), (this[hl] | this[hl + 1] << 8 | this[hl + 2] << 16) + 16777216 * this[hl + 3];
      }, ba.prototype.readUInt32BE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 4, this.length), 16777216 * this[hl] + (this[hl + 1] << 16 | this[hl + 2] << 8 | this[hl + 3]);
      }, ba.prototype.readIntLE = function(hl, Cl, Il) {
        hl >>>= 0, Cl >>>= 0, Il || Dl(hl, Cl, this.length);
        for (var Ll = this[hl], tc = 1, nc = 0; ++nc < Cl && (tc *= 256); ) Ll += this[hl + nc] * tc;
        return Ll >= (tc *= 128) && (Ll -= Math.pow(2, 8 * Cl)), Ll;
      }, ba.prototype.readIntBE = function(hl, Cl, Il) {
        hl >>>= 0, Cl >>>= 0, Il || Dl(hl, Cl, this.length);
        for (var Ll = Cl, tc = 1, nc = this[hl + --Ll]; Ll > 0 && (tc *= 256); ) nc += this[hl + --Ll] * tc;
        return nc >= (tc *= 128) && (nc -= Math.pow(2, 8 * Cl)), nc;
      }, ba.prototype.readInt8 = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 1, this.length), 128 & this[hl] ? -1 * (255 - this[hl] + 1) : this[hl];
      }, ba.prototype.readInt16LE = function(hl, Cl) {
        hl >>>= 0, Cl || Dl(hl, 2, this.length);
        var Il = this[hl] | this[hl + 1] << 8;
        return 32768 & Il ? 4294901760 | Il : Il;
      }, ba.prototype.readInt16BE = function(hl, Cl) {
        hl >>>= 0, Cl || Dl(hl, 2, this.length);
        var Il = this[hl + 1] | this[hl] << 8;
        return 32768 & Il ? 4294901760 | Il : Il;
      }, ba.prototype.readInt32LE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 4, this.length), this[hl] | this[hl + 1] << 8 | this[hl + 2] << 16 | this[hl + 3] << 24;
      }, ba.prototype.readInt32BE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 4, this.length), this[hl] << 24 | this[hl + 1] << 16 | this[hl + 2] << 8 | this[hl + 3];
      }, ba.prototype.readFloatLE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 4, this.length), Jo.read(this, hl, !0, 23, 4);
      }, ba.prototype.readFloatBE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 4, this.length), Jo.read(this, hl, !1, 23, 4);
      }, ba.prototype.readDoubleLE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 8, this.length), Jo.read(this, hl, !0, 52, 8);
      }, ba.prototype.readDoubleBE = function(hl, Cl) {
        return hl >>>= 0, Cl || Dl(hl, 8, this.length), Jo.read(this, hl, !1, 52, 8);
      }, ba.prototype.writeUIntLE = function(hl, Cl, Il, Ll) {
        hl = +hl, Cl >>>= 0, Il >>>= 0, Ll || _l(this, hl, Cl, Il, Math.pow(2, 8 * Il) - 1, 0);
        var tc = 1, nc = 0;
        for (this[Cl] = 255 & hl; ++nc < Il && (tc *= 256); ) this[Cl + nc] = hl / tc & 255;
        return Cl + Il;
      }, ba.prototype.writeUIntBE = function(hl, Cl, Il, Ll) {
        hl = +hl, Cl >>>= 0, Il >>>= 0, Ll || _l(this, hl, Cl, Il, Math.pow(2, 8 * Il) - 1, 0);
        var tc = Il - 1, nc = 1;
        for (this[Cl + tc] = 255 & hl; --tc >= 0 && (nc *= 256); ) this[Cl + tc] = hl / nc & 255;
        return Cl + Il;
      }, ba.prototype.writeUInt8 = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 1, 255, 0), this[Cl] = 255 & hl, Cl + 1;
      }, ba.prototype.writeUInt16LE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 2, 65535, 0), this[Cl] = 255 & hl, this[Cl + 1] = hl >>> 8, Cl + 2;
      }, ba.prototype.writeUInt16BE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 2, 65535, 0), this[Cl] = hl >>> 8, this[Cl + 1] = 255 & hl, Cl + 2;
      }, ba.prototype.writeUInt32LE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 4, 4294967295, 0), this[Cl + 3] = hl >>> 24, this[Cl + 2] = hl >>> 16, this[Cl + 1] = hl >>> 8, this[Cl] = 255 & hl, Cl + 4;
      }, ba.prototype.writeUInt32BE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 4, 4294967295, 0), this[Cl] = hl >>> 24, this[Cl + 1] = hl >>> 16, this[Cl + 2] = hl >>> 8, this[Cl + 3] = 255 & hl, Cl + 4;
      }, ba.prototype.writeIntLE = function(hl, Cl, Il, Ll) {
        if (hl = +hl, Cl >>>= 0, !Ll) {
          var tc = Math.pow(2, 8 * Il - 1);
          _l(this, hl, Cl, Il, tc - 1, -tc);
        }
        var nc = 0, uc = 1, _c = 0;
        for (this[Cl] = 255 & hl; ++nc < Il && (uc *= 256); ) hl < 0 && _c === 0 && this[Cl + nc - 1] !== 0 && (_c = 1), this[Cl + nc] = (hl / uc | 0) - _c & 255;
        return Cl + Il;
      }, ba.prototype.writeIntBE = function(hl, Cl, Il, Ll) {
        if (hl = +hl, Cl >>>= 0, !Ll) {
          var tc = Math.pow(2, 8 * Il - 1);
          _l(this, hl, Cl, Il, tc - 1, -tc);
        }
        var nc = Il - 1, uc = 1, _c = 0;
        for (this[Cl + nc] = 255 & hl; --nc >= 0 && (uc *= 256); ) hl < 0 && _c === 0 && this[Cl + nc + 1] !== 0 && (_c = 1), this[Cl + nc] = (hl / uc | 0) - _c & 255;
        return Cl + Il;
      }, ba.prototype.writeInt8 = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 1, 127, -128), hl < 0 && (hl = 255 + hl + 1), this[Cl] = 255 & hl, Cl + 1;
      }, ba.prototype.writeInt16LE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 2, 32767, -32768), this[Cl] = 255 & hl, this[Cl + 1] = hl >>> 8, Cl + 2;
      }, ba.prototype.writeInt16BE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 2, 32767, -32768), this[Cl] = hl >>> 8, this[Cl + 1] = 255 & hl, Cl + 2;
      }, ba.prototype.writeInt32LE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 4, 2147483647, -2147483648), this[Cl] = 255 & hl, this[Cl + 1] = hl >>> 8, this[Cl + 2] = hl >>> 16, this[Cl + 3] = hl >>> 24, Cl + 4;
      }, ba.prototype.writeInt32BE = function(hl, Cl, Il) {
        return hl = +hl, Cl >>>= 0, Il || _l(this, hl, Cl, 4, 2147483647, -2147483648), hl < 0 && (hl = 4294967295 + hl + 1), this[Cl] = hl >>> 24, this[Cl + 1] = hl >>> 16, this[Cl + 2] = hl >>> 8, this[Cl + 3] = 255 & hl, Cl + 4;
      }, ba.prototype.writeFloatLE = function(hl, Cl, Il) {
        return Fl(this, hl, Cl, !0, Il);
      }, ba.prototype.writeFloatBE = function(hl, Cl, Il) {
        return Fl(this, hl, Cl, !1, Il);
      }, ba.prototype.writeDoubleLE = function(hl, Cl, Il) {
        return Nl(this, hl, Cl, !0, Il);
      }, ba.prototype.writeDoubleBE = function(hl, Cl, Il) {
        return Nl(this, hl, Cl, !1, Il);
      }, ba.prototype.copy = function(hl, Cl, Il, Ll) {
        if (!ba.isBuffer(hl)) throw new TypeError("argument should be a Buffer");
        if (Il || (Il = 0), Ll || Ll === 0 || (Ll = this.length), Cl >= hl.length && (Cl = hl.length), Cl || (Cl = 0), Ll > 0 && Ll < Il && (Ll = Il), Ll === Il || hl.length === 0 || this.length === 0) return 0;
        if (Cl < 0) throw new RangeError("targetStart out of bounds");
        if (Il < 0 || Il >= this.length) throw new RangeError("Index out of range");
        if (Ll < 0) throw new RangeError("sourceEnd out of bounds");
        Ll > this.length && (Ll = this.length), hl.length - Cl < Ll - Il && (Ll = hl.length - Cl + Il);
        var tc = Ll - Il;
        if (this === hl && typeof Uint8Array.prototype.copyWithin == "function") this.copyWithin(Cl, Il, Ll);
        else if (this === hl && Il < Cl && Cl < Ll) for (var nc = tc - 1; nc >= 0; --nc) hl[nc + Cl] = this[nc + Il];
        else Uint8Array.prototype.set.call(hl, this.subarray(Il, Ll), Cl);
        return tc;
      }, ba.prototype.fill = function(hl, Cl, Il, Ll) {
        if (typeof hl == "string") {
          if (typeof Cl == "string" ? (Ll = Cl, Cl = 0, Il = this.length) : typeof Il == "string" && (Ll = Il, Il = this.length), Ll !== void 0 && typeof Ll != "string") throw new TypeError("encoding must be a string");
          if (typeof Ll == "string" && !ba.isEncoding(Ll)) throw new TypeError("Unknown encoding: " + Ll);
          if (hl.length === 1) {
            var tc = hl.charCodeAt(0);
            (Ll === "utf8" && tc < 128 || Ll === "latin1") && (hl = tc);
          }
        } else typeof hl == "number" && (hl &= 255);
        if (Cl < 0 || this.length < Cl || this.length < Il) throw new RangeError("Out of range index");
        if (Il <= Cl) return this;
        var nc;
        if (Cl >>>= 0, Il = Il === void 0 ? this.length : Il >>> 0, hl || (hl = 0), typeof hl == "number") for (nc = Cl; nc < Il; ++nc) this[nc] = hl;
        else {
          var uc = ba.isBuffer(hl) ? hl : ba.from(hl, Ll), _c = uc.length;
          if (_c === 0) throw new TypeError('The value "' + hl + '" is invalid for argument "value"');
          for (nc = 0; nc < Il - Cl; ++nc) this[nc + Cl] = uc[nc % _c];
        }
        return this;
      };
      var zl = /[^+/0-9A-Za-z-_]/g;
      function Zl(hl) {
        if ((hl = (hl = hl.split("=")[0]).trim().replace(zl, "")).length < 2) return "";
        for (; hl.length % 4 != 0; ) hl += "=";
        return hl;
      }
      function kl(hl) {
        return hl < 16 ? "0" + hl.toString(16) : hl.toString(16);
      }
      function ul(hl, Cl) {
        var Il;
        Cl = Cl || 1 / 0;
        for (var Ll = hl.length, tc = null, nc = [], uc = 0; uc < Ll; ++uc) {
          if ((Il = hl.charCodeAt(uc)) > 55295 && Il < 57344) {
            if (!tc) {
              if (Il > 56319) {
                (Cl -= 3) > -1 && nc.push(239, 191, 189);
                continue;
              }
              if (uc + 1 === Ll) {
                (Cl -= 3) > -1 && nc.push(239, 191, 189);
                continue;
              }
              tc = Il;
              continue;
            }
            if (Il < 56320) {
              (Cl -= 3) > -1 && nc.push(239, 191, 189), tc = Il;
              continue;
            }
            Il = 65536 + (tc - 55296 << 10 | Il - 56320);
          } else tc && (Cl -= 3) > -1 && nc.push(239, 191, 189);
          if (tc = null, Il < 128) {
            if ((Cl -= 1) < 0) break;
            nc.push(Il);
          } else if (Il < 2048) {
            if ((Cl -= 2) < 0) break;
            nc.push(Il >> 6 | 192, 63 & Il | 128);
          } else if (Il < 65536) {
            if ((Cl -= 3) < 0) break;
            nc.push(Il >> 12 | 224, Il >> 6 & 63 | 128, 63 & Il | 128);
          } else {
            if (!(Il < 1114112)) throw new Error("Invalid code point");
            if ((Cl -= 4) < 0) break;
            nc.push(Il >> 18 | 240, Il >> 12 & 63 | 128, Il >> 6 & 63 | 128, 63 & Il | 128);
          }
        }
        return nc;
      }
      function vl(hl) {
        for (var Cl = [], Il = 0; Il < hl.length; ++Il) Cl.push(255 & hl.charCodeAt(Il));
        return Cl;
      }
      function Tl(hl, Cl) {
        for (var Il, Ll, tc, nc = [], uc = 0; uc < hl.length && !((Cl -= 2) < 0); ++uc) Ll = (Il = hl.charCodeAt(uc)) >> 8, tc = Il % 256, nc.push(tc), nc.push(Ll);
        return nc;
      }
      function wl(hl) {
        return qn.toByteArray(Zl(hl));
      }
      function yl(hl, Cl, Il, Ll) {
        for (var tc = 0; tc < Ll && !(tc + Il >= Cl.length || tc >= hl.length); ++tc) Cl[tc + Il] = hl[tc];
        return tc;
      }
      function Rl(hl, Cl) {
        return hl instanceof Cl || hl != null && hl.constructor != null && hl.constructor.name != null && hl.constructor.name === Cl.name;
      }
      function Ul(hl) {
        return hl != hl;
      }
    }).call(this);
  }).call(this, Xn("buffer").Buffer);
}, { "base64-js": 28, buffer: 32, ieee754: 45 }], 33: [function(Xn, zn, Un) {
  var Kn = Xn("get-intrinsic"), qn = Xn("./"), Jo = qn(Kn("String.prototype.indexOf"));
  zn.exports = function(pa, ma) {
    var va = Kn(pa, !!ma);
    return typeof va == "function" && Jo(pa, ".prototype.") > -1 ? qn(va) : va;
  };
}, { "./": 34, "get-intrinsic": 39 }], 34: [function(Xn, zn, Un) {
  var Kn = Xn("function-bind"), qn = Xn("get-intrinsic"), Jo = qn("%Function.prototype.apply%"), pa = qn("%Function.prototype.call%"), ma = qn("%Reflect.apply%", !0) || Kn.call(pa, Jo), va = qn("%Object.getOwnPropertyDescriptor%", !0), ba = qn("%Object.defineProperty%", !0), _a = qn("%Math.max%");
  if (ba) try {
    ba({}, "a", { value: 1 });
  } catch {
    ba = null;
  }
  zn.exports = function(xa) {
    var wa = ma(Kn, pa, arguments);
    return va && ba && va(wa, "length").configurable && ba(wa, "length", { value: 1 + _a(0, xa.length - (arguments.length - 1)) }), wa;
  };
  var ya = function() {
    return ma(Kn, Jo, arguments);
  };
  ba ? ba(zn.exports, "apply", { value: ya }) : zn.exports.apply = ya;
}, { "function-bind": 38, "get-intrinsic": 39 }], 35: [function(Xn, zn, Un) {
  var Kn, qn = typeof Reflect == "object" ? Reflect : null, Jo = qn && typeof qn.apply == "function" ? qn.apply : function(qa, tl, Qa) {
    return Function.prototype.apply.call(qa, tl, Qa);
  };
  function pa(qa) {
    console && console.warn && console.warn(qa);
  }
  Kn = qn && typeof qn.ownKeys == "function" ? qn.ownKeys : Object.getOwnPropertySymbols ? function(qa) {
    return Object.getOwnPropertyNames(qa).concat(Object.getOwnPropertySymbols(qa));
  } : function(qa) {
    return Object.getOwnPropertyNames(qa);
  };
  var ma = Number.isNaN || function(qa) {
    return qa != qa;
  };
  function va() {
    va.init.call(this);
  }
  zn.exports = va, zn.exports.once = Ka, va.EventEmitter = va, va.prototype._events = void 0, va.prototype._eventsCount = 0, va.prototype._maxListeners = void 0;
  var ba = 10;
  function _a(qa) {
    if (typeof qa != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof qa);
  }
  function ya(qa) {
    return qa._maxListeners === void 0 ? va.defaultMaxListeners : qa._maxListeners;
  }
  function xa(qa, tl, Qa, nl) {
    var rl, il, cl;
    if (_a(Qa), (il = qa._events) === void 0 ? (il = qa._events = /* @__PURE__ */ Object.create(null), qa._eventsCount = 0) : (il.newListener !== void 0 && (qa.emit("newListener", tl, Qa.listener ? Qa.listener : Qa), il = qa._events), cl = il[tl]), cl === void 0) cl = il[tl] = Qa, ++qa._eventsCount;
    else if (typeof cl == "function" ? cl = il[tl] = nl ? [Qa, cl] : [cl, Qa] : nl ? cl.unshift(Qa) : cl.push(Qa), (rl = ya(qa)) > 0 && cl.length > rl && !cl.warned) {
      cl.warned = !0;
      var ll = new Error("Possible EventEmitter memory leak detected. " + cl.length + " " + String(tl) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      ll.name = "MaxListenersExceededWarning", ll.emitter = qa, ll.type = tl, ll.count = cl.length, pa(ll);
    }
    return qa;
  }
  function wa() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function Ta(qa, tl, Qa) {
    var nl = { fired: !1, wrapFn: void 0, target: qa, type: tl, listener: Qa }, rl = wa.bind(nl);
    return rl.listener = Qa, nl.wrapFn = rl, rl;
  }
  function Sa(qa, tl, Qa) {
    var nl = qa._events;
    if (nl === void 0) return [];
    var rl = nl[tl];
    return rl === void 0 ? [] : typeof rl == "function" ? Qa ? [rl.listener || rl] : [rl] : Qa ? Na(rl) : ka(rl, rl.length);
  }
  function Ma(qa) {
    var tl = this._events;
    if (tl !== void 0) {
      var Qa = tl[qa];
      if (typeof Qa == "function") return 1;
      if (Qa !== void 0) return Qa.length;
    }
    return 0;
  }
  function ka(qa, tl) {
    for (var Qa = new Array(tl), nl = 0; nl < tl; ++nl) Qa[nl] = qa[nl];
    return Qa;
  }
  function Za(qa, tl) {
    for (; tl + 1 < qa.length; tl++) qa[tl] = qa[tl + 1];
    qa.pop();
  }
  function Na(qa) {
    for (var tl = new Array(qa.length), Qa = 0; Qa < tl.length; ++Qa) tl[Qa] = qa[Qa].listener || qa[Qa];
    return tl;
  }
  function Ka(qa, tl) {
    return new Promise(function(Qa, nl) {
      function rl(cl) {
        qa.removeListener(tl, il), nl(cl);
      }
      function il() {
        typeof qa.removeListener == "function" && qa.removeListener("error", rl), Qa([].slice.call(arguments));
      }
      el(qa, tl, il, { once: !0 }), tl !== "error" && Ja(qa, rl, { once: !0 });
    });
  }
  function Ja(qa, tl, Qa) {
    typeof qa.on == "function" && el(qa, "error", tl, Qa);
  }
  function el(qa, tl, Qa, nl) {
    if (typeof qa.on == "function") nl.once ? qa.once(tl, Qa) : qa.on(tl, Qa);
    else {
      if (typeof qa.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof qa);
      qa.addEventListener(tl, function rl(il) {
        nl.once && qa.removeEventListener(tl, rl), Qa(il);
      });
    }
  }
  Object.defineProperty(va, "defaultMaxListeners", { enumerable: !0, get: function() {
    return ba;
  }, set: function(qa) {
    if (typeof qa != "number" || qa < 0 || ma(qa)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + qa + ".");
    ba = qa;
  } }), va.init = function() {
    this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, va.prototype.setMaxListeners = function(qa) {
    if (typeof qa != "number" || qa < 0 || ma(qa)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + qa + ".");
    return this._maxListeners = qa, this;
  }, va.prototype.getMaxListeners = function() {
    return ya(this);
  }, va.prototype.emit = function(qa) {
    for (var tl = [], Qa = 1; Qa < arguments.length; Qa++) tl.push(arguments[Qa]);
    var nl = qa === "error", rl = this._events;
    if (rl !== void 0) nl = nl && rl.error === void 0;
    else if (!nl) return !1;
    if (nl) {
      var il;
      if (tl.length > 0 && (il = tl[0]), il instanceof Error) throw il;
      var cl = new Error("Unhandled error." + (il ? " (" + il.message + ")" : ""));
      throw cl.context = il, cl;
    }
    var ll = rl[qa];
    if (ll === void 0) return !1;
    if (typeof ll == "function") Jo(ll, this, tl);
    else {
      var al = ll.length, sl = ka(ll, al);
      for (Qa = 0; Qa < al; ++Qa) Jo(sl[Qa], this, tl);
    }
    return !0;
  }, va.prototype.addListener = function(qa, tl) {
    return xa(this, qa, tl, !1);
  }, va.prototype.on = va.prototype.addListener, va.prototype.prependListener = function(qa, tl) {
    return xa(this, qa, tl, !0);
  }, va.prototype.once = function(qa, tl) {
    return _a(tl), this.on(qa, Ta(this, qa, tl)), this;
  }, va.prototype.prependOnceListener = function(qa, tl) {
    return _a(tl), this.prependListener(qa, Ta(this, qa, tl)), this;
  }, va.prototype.removeListener = function(qa, tl) {
    var Qa, nl, rl, il, cl;
    if (_a(tl), (nl = this._events) === void 0) return this;
    if ((Qa = nl[qa]) === void 0) return this;
    if (Qa === tl || Qa.listener === tl) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete nl[qa], nl.removeListener && this.emit("removeListener", qa, Qa.listener || tl));
    else if (typeof Qa != "function") {
      for (rl = -1, il = Qa.length - 1; il >= 0; il--) if (Qa[il] === tl || Qa[il].listener === tl) {
        cl = Qa[il].listener, rl = il;
        break;
      }
      if (rl < 0) return this;
      rl === 0 ? Qa.shift() : Za(Qa, rl), Qa.length === 1 && (nl[qa] = Qa[0]), nl.removeListener !== void 0 && this.emit("removeListener", qa, cl || tl);
    }
    return this;
  }, va.prototype.off = va.prototype.removeListener, va.prototype.removeAllListeners = function(qa) {
    var tl, Qa, nl;
    if ((Qa = this._events) === void 0) return this;
    if (Qa.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Qa[qa] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Qa[qa]), this;
    if (arguments.length === 0) {
      var rl, il = Object.keys(Qa);
      for (nl = 0; nl < il.length; ++nl) (rl = il[nl]) !== "removeListener" && this.removeAllListeners(rl);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (typeof (tl = Qa[qa]) == "function") this.removeListener(qa, tl);
    else if (tl !== void 0) for (nl = tl.length - 1; nl >= 0; nl--) this.removeListener(qa, tl[nl]);
    return this;
  }, va.prototype.listeners = function(qa) {
    return Sa(this, qa, !0);
  }, va.prototype.rawListeners = function(qa) {
    return Sa(this, qa, !1);
  }, va.listenerCount = function(qa, tl) {
    return typeof qa.listenerCount == "function" ? qa.listenerCount(tl) : Ma.call(qa, tl);
  }, va.prototype.listenerCount = Ma, va.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Kn(this._events) : [];
  };
}, {}], 36: [function(Xn, zn, Un) {
  var Kn = Xn("is-callable"), qn = Object.prototype.toString, Jo = Object.prototype.hasOwnProperty, pa = function(_a, ya, xa) {
    for (var wa = 0, Ta = _a.length; wa < Ta; wa++) Jo.call(_a, wa) && (xa == null ? ya(_a[wa], wa, _a) : ya.call(xa, _a[wa], wa, _a));
  }, ma = function(_a, ya, xa) {
    for (var wa = 0, Ta = _a.length; wa < Ta; wa++) xa == null ? ya(_a.charAt(wa), wa, _a) : ya.call(xa, _a.charAt(wa), wa, _a);
  }, va = function(_a, ya, xa) {
    for (var wa in _a) Jo.call(_a, wa) && (xa == null ? ya(_a[wa], wa, _a) : ya.call(xa, _a[wa], wa, _a));
  }, ba = function(_a, ya, xa) {
    if (!Kn(ya)) throw new TypeError("iterator must be a function");
    var wa;
    arguments.length >= 3 && (wa = xa), qn.call(_a) === "[object Array]" ? pa(_a, ya, wa) : typeof _a == "string" ? ma(_a, ya, wa) : va(_a, ya, wa);
  };
  zn.exports = ba;
}, { "is-callable": 48 }], 37: [function(Xn, zn, Un) {
  var Kn = "Function.prototype.bind called on incompatible ", qn = Array.prototype.slice, Jo = Object.prototype.toString, pa = "[object Function]";
  zn.exports = function(ma) {
    var va = this;
    if (typeof va != "function" || Jo.call(va) !== pa) throw new TypeError(Kn + va);
    for (var ba, _a = qn.call(arguments, 1), ya = function() {
      if (this instanceof ba) {
        var Ma = va.apply(this, _a.concat(qn.call(arguments)));
        return Object(Ma) === Ma ? Ma : this;
      }
      return va.apply(ma, _a.concat(qn.call(arguments)));
    }, xa = Math.max(0, va.length - _a.length), wa = [], Ta = 0; Ta < xa; Ta++) wa.push("$" + Ta);
    if (ba = Function("binder", "return function (" + wa.join(",") + "){ return binder.apply(this,arguments); }")(ya), va.prototype) {
      var Sa = function() {
      };
      Sa.prototype = va.prototype, ba.prototype = new Sa(), Sa.prototype = null;
    }
    return ba;
  };
}, {}], 38: [function(Xn, zn, Un) {
  var Kn = Xn("./implementation");
  zn.exports = Function.prototype.bind || Kn;
}, { "./implementation": 37 }], 39: [function(Xn, zn, Un) {
  var Kn, qn = SyntaxError, Jo = Function, pa = TypeError, ma = function(ll) {
    try {
      return Jo('"use strict"; return (' + ll + ").constructor;")();
    } catch {
    }
  }, va = Object.getOwnPropertyDescriptor;
  if (va) try {
    va({}, "");
  } catch {
    va = null;
  }
  var ba = function() {
    throw new pa();
  }, _a = va ? function() {
    try {
      return ba;
    } catch {
      try {
        return va(arguments, "callee").get;
      } catch {
        return ba;
      }
    }
  }() : ba, ya = Xn("has-symbols")(), xa = Object.getPrototypeOf || function(ll) {
    return ll.__proto__;
  }, wa = {}, Ta = typeof Uint8Array > "u" ? Kn : xa(Uint8Array), Sa = { "%AggregateError%": typeof AggregateError > "u" ? Kn : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Kn : ArrayBuffer, "%ArrayIteratorPrototype%": ya ? xa([][Symbol.iterator]()) : Kn, "%AsyncFromSyncIteratorPrototype%": Kn, "%AsyncFunction%": wa, "%AsyncGenerator%": wa, "%AsyncGeneratorFunction%": wa, "%AsyncIteratorPrototype%": wa, "%Atomics%": typeof Atomics > "u" ? Kn : Atomics, "%BigInt%": typeof BigInt > "u" ? Kn : BigInt, "%BigInt64Array%": typeof BigInt64Array > "u" ? Kn : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array > "u" ? Kn : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView > "u" ? Kn : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array > "u" ? Kn : Float32Array, "%Float64Array%": typeof Float64Array > "u" ? Kn : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Kn : FinalizationRegistry, "%Function%": Jo, "%GeneratorFunction%": wa, "%Int8Array%": typeof Int8Array > "u" ? Kn : Int8Array, "%Int16Array%": typeof Int16Array > "u" ? Kn : Int16Array, "%Int32Array%": typeof Int32Array > "u" ? Kn : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": ya ? xa(xa([][Symbol.iterator]())) : Kn, "%JSON%": typeof JSON == "object" ? JSON : Kn, "%Map%": typeof Map > "u" ? Kn : Map, "%MapIteratorPrototype%": typeof Map < "u" && ya ? xa((/* @__PURE__ */ new Map())[Symbol.iterator]()) : Kn, "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise > "u" ? Kn : Promise, "%Proxy%": typeof Proxy > "u" ? Kn : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect > "u" ? Kn : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set > "u" ? Kn : Set, "%SetIteratorPrototype%": typeof Set < "u" && ya ? xa((/* @__PURE__ */ new Set())[Symbol.iterator]()) : Kn, "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Kn : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": ya ? xa(""[Symbol.iterator]()) : Kn, "%Symbol%": ya ? Symbol : Kn, "%SyntaxError%": qn, "%ThrowTypeError%": _a, "%TypedArray%": Ta, "%TypeError%": pa, "%Uint8Array%": typeof Uint8Array > "u" ? Kn : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Kn : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array > "u" ? Kn : Uint16Array, "%Uint32Array%": typeof Uint32Array > "u" ? Kn : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap > "u" ? Kn : WeakMap, "%WeakRef%": typeof WeakRef > "u" ? Kn : WeakRef, "%WeakSet%": typeof WeakSet > "u" ? Kn : WeakSet };
  try {
    null.error;
  } catch (ll) {
    var Ma = xa(xa(ll));
    Sa["%Error.prototype%"] = Ma;
  }
  var ka = function ll(al) {
    var sl;
    if (al === "%AsyncFunction%") sl = ma("async function () {}");
    else if (al === "%GeneratorFunction%") sl = ma("function* () {}");
    else if (al === "%AsyncGeneratorFunction%") sl = ma("async function* () {}");
    else if (al === "%AsyncGenerator%") {
      var dl = ll("%AsyncGeneratorFunction%");
      dl && (sl = dl.prototype);
    } else if (al === "%AsyncIteratorPrototype%") {
      var El = ll("%AsyncGenerator%");
      El && (sl = xa(El.prototype));
    }
    return Sa[al] = sl, sl;
  }, Za = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, Na = Xn("function-bind"), Ka = Xn("has"), Ja = Na.call(Function.call, Array.prototype.concat), el = Na.call(Function.apply, Array.prototype.splice), qa = Na.call(Function.call, String.prototype.replace), tl = Na.call(Function.call, String.prototype.slice), Qa = Na.call(Function.call, RegExp.prototype.exec), nl = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, rl = /\\(\\)?/g, il = function(ll) {
    var al = tl(ll, 0, 1), sl = tl(ll, -1);
    if (al === "%" && sl !== "%") throw new qn("invalid intrinsic syntax, expected closing `%`");
    if (sl === "%" && al !== "%") throw new qn("invalid intrinsic syntax, expected opening `%`");
    var dl = [];
    return qa(ll, nl, function(El, fl, Ml, Sl) {
      dl[dl.length] = Ml ? qa(Sl, rl, "$1") : fl || El;
    }), dl;
  }, cl = function(ll, al) {
    var sl, dl = ll;
    if (Ka(Za, dl) && (dl = "%" + (sl = Za[dl])[0] + "%"), Ka(Sa, dl)) {
      var El = Sa[dl];
      if (El === wa && (El = ka(dl)), El === void 0 && !al) throw new pa("intrinsic " + ll + " exists, but is not available. Please file an issue!");
      return { alias: sl, name: dl, value: El };
    }
    throw new qn("intrinsic " + ll + " does not exist!");
  };
  zn.exports = function(ll, al) {
    if (typeof ll != "string" || ll.length === 0) throw new pa("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof al != "boolean") throw new pa('"allowMissing" argument must be a boolean');
    if (Qa(/^%?[^%]*%?$/, ll) === null) throw new qn("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var sl = il(ll), dl = sl.length > 0 ? sl[0] : "", El = cl("%" + dl + "%", al), fl = El.name, Ml = El.value, Sl = !1, ml = El.alias;
    ml && (dl = ml[0], el(sl, Ja([0, 1], ml)));
    for (var Dl = 1, _l = !0; Dl < sl.length; Dl += 1) {
      var gl = sl[Dl], Fl = tl(gl, 0, 1), Nl = tl(gl, -1);
      if ((Fl === '"' || Fl === "'" || Fl === "`" || Nl === '"' || Nl === "'" || Nl === "`") && Fl !== Nl) throw new qn("property names with quotes must have matching quotes");
      if (gl !== "constructor" && _l || (Sl = !0), Ka(Sa, fl = "%" + (dl += "." + gl) + "%")) Ml = Sa[fl];
      else if (Ml != null) {
        if (!(gl in Ml)) {
          if (!al) throw new pa("base intrinsic for " + ll + " exists, but the property is not available.");
          return;
        }
        if (va && Dl + 1 >= sl.length) {
          var zl = va(Ml, gl);
          Ml = (_l = !!zl) && "get" in zl && !("originalValue" in zl.get) ? zl.get : Ml[gl];
        } else _l = Ka(Ml, gl), Ml = Ml[gl];
        _l && !Sl && (Sa[fl] = Ml);
      }
    }
    return Ml;
  };
}, { "function-bind": 38, has: 44, "has-symbols": 41 }], 40: [function(Xn, zn, Un) {
  var Kn = Xn("get-intrinsic")("%Object.getOwnPropertyDescriptor%", !0);
  if (Kn) try {
    Kn([], "length");
  } catch {
    Kn = null;
  }
  zn.exports = Kn;
}, { "get-intrinsic": 39 }], 41: [function(Xn, zn, Un) {
  var Kn = typeof Symbol < "u" && Symbol, qn = Xn("./shams");
  zn.exports = function() {
    return typeof Kn == "function" && typeof Symbol == "function" && typeof Kn("foo") == "symbol" && typeof Symbol("bar") == "symbol" && qn();
  };
}, { "./shams": 42 }], 42: [function(Xn, zn, Un) {
  zn.exports = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
    if (typeof Symbol.iterator == "symbol") return !0;
    var Kn = {}, qn = Symbol("test"), Jo = Object(qn);
    if (typeof qn == "string" || Object.prototype.toString.call(qn) !== "[object Symbol]" || Object.prototype.toString.call(Jo) !== "[object Symbol]") return !1;
    var pa = 42;
    for (qn in Kn[qn] = pa, Kn) return !1;
    if (typeof Object.keys == "function" && Object.keys(Kn).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(Kn).length !== 0) return !1;
    var ma = Object.getOwnPropertySymbols(Kn);
    if (ma.length !== 1 || ma[0] !== qn || !Object.prototype.propertyIsEnumerable.call(Kn, qn)) return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var va = Object.getOwnPropertyDescriptor(Kn, qn);
      if (va.value !== pa || va.enumerable !== !0) return !1;
    }
    return !0;
  };
}, {}], 43: [function(Xn, zn, Un) {
  var Kn = Xn("has-symbols/shams");
  zn.exports = function() {
    return Kn() && !!Symbol.toStringTag;
  };
}, { "has-symbols/shams": 42 }], 44: [function(Xn, zn, Un) {
  var Kn = Xn("function-bind");
  zn.exports = Kn.call(Function.call, Object.prototype.hasOwnProperty);
}, { "function-bind": 38 }], 45: [function(Xn, zn, Un) {
  /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
  Un.read = function(Kn, qn, Jo, pa, ma) {
    var va, ba, _a = 8 * ma - pa - 1, ya = (1 << _a) - 1, xa = ya >> 1, wa = -7, Ta = Jo ? ma - 1 : 0, Sa = Jo ? -1 : 1, Ma = Kn[qn + Ta];
    for (Ta += Sa, va = Ma & (1 << -wa) - 1, Ma >>= -wa, wa += _a; wa > 0; va = 256 * va + Kn[qn + Ta], Ta += Sa, wa -= 8) ;
    for (ba = va & (1 << -wa) - 1, va >>= -wa, wa += pa; wa > 0; ba = 256 * ba + Kn[qn + Ta], Ta += Sa, wa -= 8) ;
    if (va === 0) va = 1 - xa;
    else {
      if (va === ya) return ba ? NaN : 1 / 0 * (Ma ? -1 : 1);
      ba += Math.pow(2, pa), va -= xa;
    }
    return (Ma ? -1 : 1) * ba * Math.pow(2, va - pa);
  }, Un.write = function(Kn, qn, Jo, pa, ma, va) {
    var ba, _a, ya, xa = 8 * va - ma - 1, wa = (1 << xa) - 1, Ta = wa >> 1, Sa = ma === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Ma = pa ? 0 : va - 1, ka = pa ? 1 : -1, Za = qn < 0 || qn === 0 && 1 / qn < 0 ? 1 : 0;
    for (qn = Math.abs(qn), isNaN(qn) || qn === 1 / 0 ? (_a = isNaN(qn) ? 1 : 0, ba = wa) : (ba = Math.floor(Math.log(qn) / Math.LN2), qn * (ya = Math.pow(2, -ba)) < 1 && (ba--, ya *= 2), (qn += ba + Ta >= 1 ? Sa / ya : Sa * Math.pow(2, 1 - Ta)) * ya >= 2 && (ba++, ya /= 2), ba + Ta >= wa ? (_a = 0, ba = wa) : ba + Ta >= 1 ? (_a = (qn * ya - 1) * Math.pow(2, ma), ba += Ta) : (_a = qn * Math.pow(2, Ta - 1) * Math.pow(2, ma), ba = 0)); ma >= 8; Kn[Jo + Ma] = 255 & _a, Ma += ka, _a /= 256, ma -= 8) ;
    for (ba = ba << ma | _a, xa += ma; xa > 0; Kn[Jo + Ma] = 255 & ba, Ma += ka, ba /= 256, xa -= 8) ;
    Kn[Jo + Ma - ka] |= 128 * Za;
  };
}, {}], 46: [function(Xn, zn, Un) {
  typeof Object.create == "function" ? zn.exports = function(Kn, qn) {
    qn && (Kn.super_ = qn, Kn.prototype = Object.create(qn.prototype, { constructor: { value: Kn, enumerable: !1, writable: !0, configurable: !0 } }));
  } : zn.exports = function(Kn, qn) {
    if (qn) {
      Kn.super_ = qn;
      var Jo = function() {
      };
      Jo.prototype = qn.prototype, Kn.prototype = new Jo(), Kn.prototype.constructor = Kn;
    }
  };
}, {}], 47: [function(Xn, zn, Un) {
  var Kn = Xn("has-tostringtag/shams")(), qn = Xn("call-bind/callBound")("Object.prototype.toString"), Jo = function(va) {
    return !(Kn && va && typeof va == "object" && Symbol.toStringTag in va) && qn(va) === "[object Arguments]";
  }, pa = function(va) {
    return !!Jo(va) || va !== null && typeof va == "object" && typeof va.length == "number" && va.length >= 0 && qn(va) !== "[object Array]" && qn(va.callee) === "[object Function]";
  }, ma = function() {
    return Jo(arguments);
  }();
  Jo.isLegacyArguments = pa, zn.exports = ma ? Jo : pa;
}, { "call-bind/callBound": 33, "has-tostringtag/shams": 43 }], 48: [function(Xn, zn, Un) {
  var Kn, qn, Jo = Function.prototype.toString, pa = typeof Reflect == "object" && Reflect !== null && Reflect.apply;
  if (typeof pa == "function" && typeof Object.defineProperty == "function") try {
    Kn = Object.defineProperty({}, "length", { get: function() {
      throw qn;
    } }), qn = {}, pa(function() {
      throw 42;
    }, null, Kn);
  } catch (Ja) {
    Ja !== qn && (pa = null);
  }
  else pa = null;
  var ma = /^\s*class\b/, va = function(Ja) {
    try {
      var el = Jo.call(Ja);
      return ma.test(el);
    } catch {
      return !1;
    }
  }, ba = function(Ja) {
    try {
      return !va(Ja) && (Jo.call(Ja), !0);
    } catch {
      return !1;
    }
  }, _a = Object.prototype.toString, ya = "[object Object]", xa = "[object Function]", wa = "[object GeneratorFunction]", Ta = "[object HTMLAllCollection]", Sa = "[object HTML document.all class]", Ma = "[object HTMLCollection]", ka = typeof Symbol == "function" && !!Symbol.toStringTag, Za = !(0 in [,]), Na = function() {
    return !1;
  };
  if (typeof document == "object") {
    var Ka = document.all;
    _a.call(Ka) === _a.call(document.all) && (Na = function(Ja) {
      if ((Za || !Ja) && (Ja === void 0 || typeof Ja == "object")) try {
        var el = _a.call(Ja);
        return (el === Ta || el === Sa || el === Ma || el === ya) && Ja("") == null;
      } catch {
      }
      return !1;
    });
  }
  zn.exports = pa ? function(Ja) {
    if (Na(Ja)) return !0;
    if (!Ja || typeof Ja != "function" && typeof Ja != "object") return !1;
    try {
      pa(Ja, null, Kn);
    } catch (el) {
      if (el !== qn) return !1;
    }
    return !va(Ja) && ba(Ja);
  } : function(Ja) {
    if (Na(Ja)) return !0;
    if (!Ja || typeof Ja != "function" && typeof Ja != "object") return !1;
    if (ka) return ba(Ja);
    if (va(Ja)) return !1;
    var el = _a.call(Ja);
    return !(el !== xa && el !== wa && !/^\[object HTML/.test(el)) && ba(Ja);
  };
}, {}], 49: [function(Xn, zn, Un) {
  var Kn, qn = Object.prototype.toString, Jo = Function.prototype.toString, pa = /^\s*(?:function)?\*/, ma = Xn("has-tostringtag/shams")(), va = Object.getPrototypeOf, ba = function() {
    if (!ma) return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  };
  zn.exports = function(_a) {
    if (typeof _a != "function") return !1;
    if (pa.test(Jo.call(_a))) return !0;
    if (!ma) return qn.call(_a) === "[object GeneratorFunction]";
    if (!va) return !1;
    if (Kn === void 0) {
      var ya = ba();
      Kn = !!ya && va(ya);
    }
    return va(_a) === Kn;
  };
}, { "has-tostringtag/shams": 43 }], 50: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = Xn("for-each"), Jo = Xn("available-typed-arrays"), pa = Xn("call-bind/callBound"), ma = pa("Object.prototype.toString"), va = Xn("has-tostringtag/shams")(), ba = Xn("gopd"), _a = typeof globalThis > "u" ? Kn : globalThis, ya = Jo(), xa = pa("Array.prototype.indexOf", !0) || function(ka, Za) {
        for (var Na = 0; Na < ka.length; Na += 1) if (ka[Na] === Za) return Na;
        return -1;
      }, wa = pa("String.prototype.slice"), Ta = {}, Sa = Object.getPrototypeOf;
      va && ba && Sa && qn(ya, function(ka) {
        var Za = new _a[ka]();
        if (Symbol.toStringTag in Za) {
          var Na = Sa(Za), Ka = ba(Na, Symbol.toStringTag);
          if (!Ka) {
            var Ja = Sa(Na);
            Ka = ba(Ja, Symbol.toStringTag);
          }
          Ta[ka] = Ka.get;
        }
      });
      var Ma = function(ka) {
        var Za = !1;
        return qn(Ta, function(Na, Ka) {
          if (!Za) try {
            Za = Na.call(ka) === Ka;
          } catch {
          }
        }), Za;
      };
      zn.exports = function(ka) {
        if (!ka || typeof ka != "object") return !1;
        if (!va || !(Symbol.toStringTag in ka)) {
          var Za = wa(ma(ka), 8, -1);
          return xa(ya, Za) > -1;
        }
        return !!ba && Ma(ka);
      };
    }).call(this);
  }).call(this, commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, { "available-typed-arrays": 27, "call-bind/callBound": 33, "for-each": 36, gopd: 40, "has-tostringtag/shams": 43 }], 51: [function(Xn, zn, Un) {
  var Kn = Object.getOwnPropertySymbols, qn = Object.prototype.hasOwnProperty, Jo = Object.prototype.propertyIsEnumerable;
  function pa(va) {
    if (va == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(va);
  }
  function ma() {
    try {
      if (!Object.assign) return !1;
      var va = new String("abc");
      if (va[5] = "de", Object.getOwnPropertyNames(va)[0] === "5") return !1;
      for (var ba = {}, _a = 0; _a < 10; _a++) ba["_" + String.fromCharCode(_a)] = _a;
      var ya = Object.getOwnPropertyNames(ba).map(function(wa) {
        return ba[wa];
      });
      if (ya.join("") !== "0123456789") return !1;
      var xa = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(wa) {
        xa[wa] = wa;
      }), Object.keys(Object.assign({}, xa)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  zn.exports = ma() ? Object.assign : function(va, ba) {
    for (var _a, ya, xa = pa(va), wa = 1; wa < arguments.length; wa++) {
      for (var Ta in _a = Object(arguments[wa])) qn.call(_a, Ta) && (xa[Ta] = _a[Ta]);
      if (Kn) {
        ya = Kn(_a);
        for (var Sa = 0; Sa < ya.length; Sa++) Jo.call(_a, ya[Sa]) && (xa[ya[Sa]] = _a[ya[Sa]]);
      }
    }
    return xa;
  };
}, {}], 52: [function(Xn, zn, Un) {
  var Kn = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  function qn(ma, va) {
    return Object.prototype.hasOwnProperty.call(ma, va);
  }
  Un.assign = function(ma) {
    for (var va = Array.prototype.slice.call(arguments, 1); va.length; ) {
      var ba = va.shift();
      if (ba) {
        if (typeof ba != "object") throw new TypeError(ba + "must be non-object");
        for (var _a in ba) qn(ba, _a) && (ma[_a] = ba[_a]);
      }
    }
    return ma;
  }, Un.shrinkBuf = function(ma, va) {
    return ma.length === va ? ma : ma.subarray ? ma.subarray(0, va) : (ma.length = va, ma);
  };
  var Jo = { arraySet: function(ma, va, ba, _a, ya) {
    if (va.subarray && ma.subarray) ma.set(va.subarray(ba, ba + _a), ya);
    else for (var xa = 0; xa < _a; xa++) ma[ya + xa] = va[ba + xa];
  }, flattenChunks: function(ma) {
    var va, ba, _a, ya, xa, wa;
    for (_a = 0, va = 0, ba = ma.length; va < ba; va++) _a += ma[va].length;
    for (wa = new Uint8Array(_a), ya = 0, va = 0, ba = ma.length; va < ba; va++) xa = ma[va], wa.set(xa, ya), ya += xa.length;
    return wa;
  } }, pa = { arraySet: function(ma, va, ba, _a, ya) {
    for (var xa = 0; xa < _a; xa++) ma[ya + xa] = va[ba + xa];
  }, flattenChunks: function(ma) {
    return [].concat.apply([], ma);
  } };
  Un.setTyped = function(ma) {
    ma ? (Un.Buf8 = Uint8Array, Un.Buf16 = Uint16Array, Un.Buf32 = Int32Array, Un.assign(Un, Jo)) : (Un.Buf8 = Array, Un.Buf16 = Array, Un.Buf32 = Array, Un.assign(Un, pa));
  }, Un.setTyped(Kn);
}, {}], 53: [function(Xn, zn, Un) {
  function Kn(qn, Jo, pa, ma) {
    for (var va = 65535 & qn, ba = qn >>> 16 & 65535, _a = 0; pa !== 0; ) {
      pa -= _a = pa > 2e3 ? 2e3 : pa;
      do
        ba = ba + (va = va + Jo[ma++] | 0) | 0;
      while (--_a);
      va %= 65521, ba %= 65521;
    }
    return va | ba << 16;
  }
  zn.exports = Kn;
}, {}], 54: [function(Xn, zn, Un) {
  zn.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
}, {}], 55: [function(Xn, zn, Un) {
  function Kn() {
    for (var pa, ma = [], va = 0; va < 256; va++) {
      pa = va;
      for (var ba = 0; ba < 8; ba++) pa = 1 & pa ? 3988292384 ^ pa >>> 1 : pa >>> 1;
      ma[va] = pa;
    }
    return ma;
  }
  var qn = Kn();
  function Jo(pa, ma, va, ba) {
    var _a = qn, ya = ba + va;
    pa ^= -1;
    for (var xa = ba; xa < ya; xa++) pa = pa >>> 8 ^ _a[255 & (pa ^ ma[xa])];
    return ~pa;
  }
  zn.exports = Jo;
}, {}], 56: [function(Xn, zn, Un) {
  var Kn, qn = Xn("../utils/common"), Jo = Xn("./trees"), pa = Xn("./adler32"), ma = Xn("./crc32"), va = Xn("./messages"), ba = 0, _a = 1, ya = 3, xa = 4, wa = 5, Ta = 0, Sa = 1, Ma = -2, ka = -3, Za = -5, Na = -1, Ka = 1, Ja = 2, el = 3, qa = 4, tl = 0, Qa = 2, nl = 8, rl = 9, il = 15, cl = 8, ll = 286, al = 30, sl = 19, dl = 2 * ll + 1, El = 15, fl = 3, Ml = 258, Sl = Ml + fl + 1, ml = 32, Dl = 42, _l = 69, gl = 73, Fl = 91, Nl = 103, zl = 113, Zl = 666, kl = 1, ul = 2, vl = 3, Tl = 4, wl = 3;
  function yl(pl, Jl) {
    return pl.msg = va[Jl], Jl;
  }
  function Rl(pl) {
    return (pl << 1) - (pl > 4 ? 9 : 0);
  }
  function Ul(pl) {
    for (var Jl = pl.length; --Jl >= 0; ) pl[Jl] = 0;
  }
  function hl(pl) {
    var Jl = pl.state, Al = Jl.pending;
    Al > pl.avail_out && (Al = pl.avail_out), Al !== 0 && (qn.arraySet(pl.output, Jl.pending_buf, Jl.pending_out, Al, pl.next_out), pl.next_out += Al, Jl.pending_out += Al, pl.total_out += Al, pl.avail_out -= Al, Jl.pending -= Al, Jl.pending === 0 && (Jl.pending_out = 0));
  }
  function Cl(pl, Jl) {
    Jo._tr_flush_block(pl, pl.block_start >= 0 ? pl.block_start : -1, pl.strstart - pl.block_start, Jl), pl.block_start = pl.strstart, hl(pl.strm);
  }
  function Il(pl, Jl) {
    pl.pending_buf[pl.pending++] = Jl;
  }
  function Ll(pl, Jl) {
    pl.pending_buf[pl.pending++] = Jl >>> 8 & 255, pl.pending_buf[pl.pending++] = 255 & Jl;
  }
  function tc(pl, Jl, Al, Bl) {
    var Kl = pl.avail_in;
    return Kl > Bl && (Kl = Bl), Kl === 0 ? 0 : (pl.avail_in -= Kl, qn.arraySet(Jl, pl.input, pl.next_in, Kl, Al), pl.state.wrap === 1 ? pl.adler = pa(pl.adler, Jl, Kl, Al) : pl.state.wrap === 2 && (pl.adler = ma(pl.adler, Jl, Kl, Al)), pl.next_in += Kl, pl.total_in += Kl, Kl);
  }
  function nc(pl, Jl) {
    var Al, Bl, Kl = pl.max_chain_length, oc = pl.strstart, xc = pl.prev_length, vc = pl.nice_match, Pc = pl.strstart > pl.w_size - Sl ? pl.strstart - (pl.w_size - Sl) : 0, Hc = pl.window, $c = pl.w_mask, Nc = pl.prev, Zc = pl.strstart + Ml, Yc = Hc[oc + xc - 1], mh = Hc[oc + xc];
    pl.prev_length >= pl.good_match && (Kl >>= 2), vc > pl.lookahead && (vc = pl.lookahead);
    do
      if (Hc[(Al = Jl) + xc] === mh && Hc[Al + xc - 1] === Yc && Hc[Al] === Hc[oc] && Hc[++Al] === Hc[oc + 1]) {
        oc += 2, Al++;
        do
          ;
        while (Hc[++oc] === Hc[++Al] && Hc[++oc] === Hc[++Al] && Hc[++oc] === Hc[++Al] && Hc[++oc] === Hc[++Al] && Hc[++oc] === Hc[++Al] && Hc[++oc] === Hc[++Al] && Hc[++oc] === Hc[++Al] && Hc[++oc] === Hc[++Al] && oc < Zc);
        if (Bl = Ml - (Zc - oc), oc = Zc - Ml, Bl > xc) {
          if (pl.match_start = Jl, xc = Bl, Bl >= vc) break;
          Yc = Hc[oc + xc - 1], mh = Hc[oc + xc];
        }
      }
    while ((Jl = Nc[Jl & $c]) > Pc && --Kl != 0);
    return xc <= pl.lookahead ? xc : pl.lookahead;
  }
  function uc(pl) {
    var Jl, Al, Bl, Kl, oc, xc = pl.w_size;
    do {
      if (Kl = pl.window_size - pl.lookahead - pl.strstart, pl.strstart >= xc + (xc - Sl)) {
        qn.arraySet(pl.window, pl.window, xc, xc, 0), pl.match_start -= xc, pl.strstart -= xc, pl.block_start -= xc, Jl = Al = pl.hash_size;
        do
          Bl = pl.head[--Jl], pl.head[Jl] = Bl >= xc ? Bl - xc : 0;
        while (--Al);
        Jl = Al = xc;
        do
          Bl = pl.prev[--Jl], pl.prev[Jl] = Bl >= xc ? Bl - xc : 0;
        while (--Al);
        Kl += xc;
      }
      if (pl.strm.avail_in === 0) break;
      if (Al = tc(pl.strm, pl.window, pl.strstart + pl.lookahead, Kl), pl.lookahead += Al, pl.lookahead + pl.insert >= fl) for (oc = pl.strstart - pl.insert, pl.ins_h = pl.window[oc], pl.ins_h = (pl.ins_h << pl.hash_shift ^ pl.window[oc + 1]) & pl.hash_mask; pl.insert && (pl.ins_h = (pl.ins_h << pl.hash_shift ^ pl.window[oc + fl - 1]) & pl.hash_mask, pl.prev[oc & pl.w_mask] = pl.head[pl.ins_h], pl.head[pl.ins_h] = oc, oc++, pl.insert--, !(pl.lookahead + pl.insert < fl)); ) ;
    } while (pl.lookahead < Sl && pl.strm.avail_in !== 0);
  }
  function _c(pl, Jl) {
    var Al = 65535;
    for (Al > pl.pending_buf_size - 5 && (Al = pl.pending_buf_size - 5); ; ) {
      if (pl.lookahead <= 1) {
        if (uc(pl), pl.lookahead === 0 && Jl === ba) return kl;
        if (pl.lookahead === 0) break;
      }
      pl.strstart += pl.lookahead, pl.lookahead = 0;
      var Bl = pl.block_start + Al;
      if ((pl.strstart === 0 || pl.strstart >= Bl) && (pl.lookahead = pl.strstart - Bl, pl.strstart = Bl, Cl(pl, !1), pl.strm.avail_out === 0) || pl.strstart - pl.block_start >= pl.w_size - Sl && (Cl(pl, !1), pl.strm.avail_out === 0)) return kl;
    }
    return pl.insert = 0, Jl === xa ? (Cl(pl, !0), pl.strm.avail_out === 0 ? vl : Tl) : (pl.strstart > pl.block_start && (Cl(pl, !1), pl.strm.avail_out), kl);
  }
  function mc(pl, Jl) {
    for (var Al, Bl; ; ) {
      if (pl.lookahead < Sl) {
        if (uc(pl), pl.lookahead < Sl && Jl === ba) return kl;
        if (pl.lookahead === 0) break;
      }
      if (Al = 0, pl.lookahead >= fl && (pl.ins_h = (pl.ins_h << pl.hash_shift ^ pl.window[pl.strstart + fl - 1]) & pl.hash_mask, Al = pl.prev[pl.strstart & pl.w_mask] = pl.head[pl.ins_h], pl.head[pl.ins_h] = pl.strstart), Al !== 0 && pl.strstart - Al <= pl.w_size - Sl && (pl.match_length = nc(pl, Al)), pl.match_length >= fl) if (Bl = Jo._tr_tally(pl, pl.strstart - pl.match_start, pl.match_length - fl), pl.lookahead -= pl.match_length, pl.match_length <= pl.max_lazy_match && pl.lookahead >= fl) {
        pl.match_length--;
        do
          pl.strstart++, pl.ins_h = (pl.ins_h << pl.hash_shift ^ pl.window[pl.strstart + fl - 1]) & pl.hash_mask, Al = pl.prev[pl.strstart & pl.w_mask] = pl.head[pl.ins_h], pl.head[pl.ins_h] = pl.strstart;
        while (--pl.match_length != 0);
        pl.strstart++;
      } else pl.strstart += pl.match_length, pl.match_length = 0, pl.ins_h = pl.window[pl.strstart], pl.ins_h = (pl.ins_h << pl.hash_shift ^ pl.window[pl.strstart + 1]) & pl.hash_mask;
      else Bl = Jo._tr_tally(pl, 0, pl.window[pl.strstart]), pl.lookahead--, pl.strstart++;
      if (Bl && (Cl(pl, !1), pl.strm.avail_out === 0)) return kl;
    }
    return pl.insert = pl.strstart < fl - 1 ? pl.strstart : fl - 1, Jl === xa ? (Cl(pl, !0), pl.strm.avail_out === 0 ? vl : Tl) : pl.last_lit && (Cl(pl, !1), pl.strm.avail_out === 0) ? kl : ul;
  }
  function Sc(pl, Jl) {
    for (var Al, Bl, Kl; ; ) {
      if (pl.lookahead < Sl) {
        if (uc(pl), pl.lookahead < Sl && Jl === ba) return kl;
        if (pl.lookahead === 0) break;
      }
      if (Al = 0, pl.lookahead >= fl && (pl.ins_h = (pl.ins_h << pl.hash_shift ^ pl.window[pl.strstart + fl - 1]) & pl.hash_mask, Al = pl.prev[pl.strstart & pl.w_mask] = pl.head[pl.ins_h], pl.head[pl.ins_h] = pl.strstart), pl.prev_length = pl.match_length, pl.prev_match = pl.match_start, pl.match_length = fl - 1, Al !== 0 && pl.prev_length < pl.max_lazy_match && pl.strstart - Al <= pl.w_size - Sl && (pl.match_length = nc(pl, Al), pl.match_length <= 5 && (pl.strategy === Ka || pl.match_length === fl && pl.strstart - pl.match_start > 4096) && (pl.match_length = fl - 1)), pl.prev_length >= fl && pl.match_length <= pl.prev_length) {
        Kl = pl.strstart + pl.lookahead - fl, Bl = Jo._tr_tally(pl, pl.strstart - 1 - pl.prev_match, pl.prev_length - fl), pl.lookahead -= pl.prev_length - 1, pl.prev_length -= 2;
        do
          ++pl.strstart <= Kl && (pl.ins_h = (pl.ins_h << pl.hash_shift ^ pl.window[pl.strstart + fl - 1]) & pl.hash_mask, Al = pl.prev[pl.strstart & pl.w_mask] = pl.head[pl.ins_h], pl.head[pl.ins_h] = pl.strstart);
        while (--pl.prev_length != 0);
        if (pl.match_available = 0, pl.match_length = fl - 1, pl.strstart++, Bl && (Cl(pl, !1), pl.strm.avail_out === 0)) return kl;
      } else if (pl.match_available) {
        if ((Bl = Jo._tr_tally(pl, 0, pl.window[pl.strstart - 1])) && Cl(pl, !1), pl.strstart++, pl.lookahead--, pl.strm.avail_out === 0) return kl;
      } else pl.match_available = 1, pl.strstart++, pl.lookahead--;
    }
    return pl.match_available && (Bl = Jo._tr_tally(pl, 0, pl.window[pl.strstart - 1]), pl.match_available = 0), pl.insert = pl.strstart < fl - 1 ? pl.strstart : fl - 1, Jl === xa ? (Cl(pl, !0), pl.strm.avail_out === 0 ? vl : Tl) : pl.last_lit && (Cl(pl, !1), pl.strm.avail_out === 0) ? kl : ul;
  }
  function hc(pl, Jl) {
    for (var Al, Bl, Kl, oc, xc = pl.window; ; ) {
      if (pl.lookahead <= Ml) {
        if (uc(pl), pl.lookahead <= Ml && Jl === ba) return kl;
        if (pl.lookahead === 0) break;
      }
      if (pl.match_length = 0, pl.lookahead >= fl && pl.strstart > 0 && (Bl = xc[Kl = pl.strstart - 1]) === xc[++Kl] && Bl === xc[++Kl] && Bl === xc[++Kl]) {
        oc = pl.strstart + Ml;
        do
          ;
        while (Bl === xc[++Kl] && Bl === xc[++Kl] && Bl === xc[++Kl] && Bl === xc[++Kl] && Bl === xc[++Kl] && Bl === xc[++Kl] && Bl === xc[++Kl] && Bl === xc[++Kl] && Kl < oc);
        pl.match_length = Ml - (oc - Kl), pl.match_length > pl.lookahead && (pl.match_length = pl.lookahead);
      }
      if (pl.match_length >= fl ? (Al = Jo._tr_tally(pl, 1, pl.match_length - fl), pl.lookahead -= pl.match_length, pl.strstart += pl.match_length, pl.match_length = 0) : (Al = Jo._tr_tally(pl, 0, pl.window[pl.strstart]), pl.lookahead--, pl.strstart++), Al && (Cl(pl, !1), pl.strm.avail_out === 0)) return kl;
    }
    return pl.insert = 0, Jl === xa ? (Cl(pl, !0), pl.strm.avail_out === 0 ? vl : Tl) : pl.last_lit && (Cl(pl, !1), pl.strm.avail_out === 0) ? kl : ul;
  }
  function Lc(pl, Jl) {
    for (var Al; ; ) {
      if (pl.lookahead === 0 && (uc(pl), pl.lookahead === 0)) {
        if (Jl === ba) return kl;
        break;
      }
      if (pl.match_length = 0, Al = Jo._tr_tally(pl, 0, pl.window[pl.strstart]), pl.lookahead--, pl.strstart++, Al && (Cl(pl, !1), pl.strm.avail_out === 0)) return kl;
    }
    return pl.insert = 0, Jl === xa ? (Cl(pl, !0), pl.strm.avail_out === 0 ? vl : Tl) : pl.last_lit && (Cl(pl, !1), pl.strm.avail_out === 0) ? kl : ul;
  }
  function Ec(pl, Jl, Al, Bl, Kl) {
    this.good_length = pl, this.max_lazy = Jl, this.nice_length = Al, this.max_chain = Bl, this.func = Kl;
  }
  function Hl(pl) {
    pl.window_size = 2 * pl.w_size, Ul(pl.head), pl.max_lazy_match = Kn[pl.level].max_lazy, pl.good_match = Kn[pl.level].good_length, pl.nice_match = Kn[pl.level].nice_length, pl.max_chain_length = Kn[pl.level].max_chain, pl.strstart = 0, pl.block_start = 0, pl.lookahead = 0, pl.insert = 0, pl.match_length = pl.prev_length = fl - 1, pl.match_available = 0, pl.ins_h = 0;
  }
  function fc() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = nl, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new qn.Buf16(2 * dl), this.dyn_dtree = new qn.Buf16(2 * (2 * al + 1)), this.bl_tree = new qn.Buf16(2 * (2 * sl + 1)), Ul(this.dyn_ltree), Ul(this.dyn_dtree), Ul(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new qn.Buf16(El + 1), this.heap = new qn.Buf16(2 * ll + 1), Ul(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new qn.Buf16(2 * ll + 1), Ul(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function lc(pl) {
    var Jl;
    return pl && pl.state ? (pl.total_in = pl.total_out = 0, pl.data_type = Qa, (Jl = pl.state).pending = 0, Jl.pending_out = 0, Jl.wrap < 0 && (Jl.wrap = -Jl.wrap), Jl.status = Jl.wrap ? Dl : zl, pl.adler = Jl.wrap === 2 ? 0 : 1, Jl.last_flush = ba, Jo._tr_init(Jl), Ta) : yl(pl, Ma);
  }
  function Gl(pl) {
    var Jl = lc(pl);
    return Jl === Ta && Hl(pl.state), Jl;
  }
  function ql(pl, Jl) {
    return pl && pl.state ? pl.state.wrap !== 2 ? Ma : (pl.state.gzhead = Jl, Ta) : Ma;
  }
  function Vl(pl, Jl, Al, Bl, Kl, oc) {
    if (!pl) return Ma;
    var xc = 1;
    if (Jl === Na && (Jl = 6), Bl < 0 ? (xc = 0, Bl = -Bl) : Bl > 15 && (xc = 2, Bl -= 16), Kl < 1 || Kl > rl || Al !== nl || Bl < 8 || Bl > 15 || Jl < 0 || Jl > 9 || oc < 0 || oc > qa) return yl(pl, Ma);
    Bl === 8 && (Bl = 9);
    var vc = new fc();
    return pl.state = vc, vc.strm = pl, vc.wrap = xc, vc.gzhead = null, vc.w_bits = Bl, vc.w_size = 1 << vc.w_bits, vc.w_mask = vc.w_size - 1, vc.hash_bits = Kl + 7, vc.hash_size = 1 << vc.hash_bits, vc.hash_mask = vc.hash_size - 1, vc.hash_shift = ~~((vc.hash_bits + fl - 1) / fl), vc.window = new qn.Buf8(2 * vc.w_size), vc.head = new qn.Buf16(vc.hash_size), vc.prev = new qn.Buf16(vc.w_size), vc.lit_bufsize = 1 << Kl + 6, vc.pending_buf_size = 4 * vc.lit_bufsize, vc.pending_buf = new qn.Buf8(vc.pending_buf_size), vc.d_buf = 1 * vc.lit_bufsize, vc.l_buf = 3 * vc.lit_bufsize, vc.level = Jl, vc.strategy = oc, vc.method = Al, Gl(pl);
  }
  function Pl(pl, Jl) {
    return Vl(pl, Jl, nl, il, cl, tl);
  }
  function Ol(pl, Jl) {
    var Al, Bl, Kl, oc;
    if (!pl || !pl.state || Jl > wa || Jl < 0) return pl ? yl(pl, Ma) : Ma;
    if (Bl = pl.state, !pl.output || !pl.input && pl.avail_in !== 0 || Bl.status === Zl && Jl !== xa) return yl(pl, pl.avail_out === 0 ? Za : Ma);
    if (Bl.strm = pl, Al = Bl.last_flush, Bl.last_flush = Jl, Bl.status === Dl) if (Bl.wrap === 2) pl.adler = 0, Il(Bl, 31), Il(Bl, 139), Il(Bl, 8), Bl.gzhead ? (Il(Bl, (Bl.gzhead.text ? 1 : 0) + (Bl.gzhead.hcrc ? 2 : 0) + (Bl.gzhead.extra ? 4 : 0) + (Bl.gzhead.name ? 8 : 0) + (Bl.gzhead.comment ? 16 : 0)), Il(Bl, 255 & Bl.gzhead.time), Il(Bl, Bl.gzhead.time >> 8 & 255), Il(Bl, Bl.gzhead.time >> 16 & 255), Il(Bl, Bl.gzhead.time >> 24 & 255), Il(Bl, Bl.level === 9 ? 2 : Bl.strategy >= Ja || Bl.level < 2 ? 4 : 0), Il(Bl, 255 & Bl.gzhead.os), Bl.gzhead.extra && Bl.gzhead.extra.length && (Il(Bl, 255 & Bl.gzhead.extra.length), Il(Bl, Bl.gzhead.extra.length >> 8 & 255)), Bl.gzhead.hcrc && (pl.adler = ma(pl.adler, Bl.pending_buf, Bl.pending, 0)), Bl.gzindex = 0, Bl.status = _l) : (Il(Bl, 0), Il(Bl, 0), Il(Bl, 0), Il(Bl, 0), Il(Bl, 0), Il(Bl, Bl.level === 9 ? 2 : Bl.strategy >= Ja || Bl.level < 2 ? 4 : 0), Il(Bl, wl), Bl.status = zl);
    else {
      var xc = nl + (Bl.w_bits - 8 << 4) << 8;
      xc |= (Bl.strategy >= Ja || Bl.level < 2 ? 0 : Bl.level < 6 ? 1 : Bl.level === 6 ? 2 : 3) << 6, Bl.strstart !== 0 && (xc |= ml), xc += 31 - xc % 31, Bl.status = zl, Ll(Bl, xc), Bl.strstart !== 0 && (Ll(Bl, pl.adler >>> 16), Ll(Bl, 65535 & pl.adler)), pl.adler = 1;
    }
    if (Bl.status === _l) if (Bl.gzhead.extra) {
      for (Kl = Bl.pending; Bl.gzindex < (65535 & Bl.gzhead.extra.length) && (Bl.pending !== Bl.pending_buf_size || (Bl.gzhead.hcrc && Bl.pending > Kl && (pl.adler = ma(pl.adler, Bl.pending_buf, Bl.pending - Kl, Kl)), hl(pl), Kl = Bl.pending, Bl.pending !== Bl.pending_buf_size)); ) Il(Bl, 255 & Bl.gzhead.extra[Bl.gzindex]), Bl.gzindex++;
      Bl.gzhead.hcrc && Bl.pending > Kl && (pl.adler = ma(pl.adler, Bl.pending_buf, Bl.pending - Kl, Kl)), Bl.gzindex === Bl.gzhead.extra.length && (Bl.gzindex = 0, Bl.status = gl);
    } else Bl.status = gl;
    if (Bl.status === gl) if (Bl.gzhead.name) {
      Kl = Bl.pending;
      do {
        if (Bl.pending === Bl.pending_buf_size && (Bl.gzhead.hcrc && Bl.pending > Kl && (pl.adler = ma(pl.adler, Bl.pending_buf, Bl.pending - Kl, Kl)), hl(pl), Kl = Bl.pending, Bl.pending === Bl.pending_buf_size)) {
          oc = 1;
          break;
        }
        oc = Bl.gzindex < Bl.gzhead.name.length ? 255 & Bl.gzhead.name.charCodeAt(Bl.gzindex++) : 0, Il(Bl, oc);
      } while (oc !== 0);
      Bl.gzhead.hcrc && Bl.pending > Kl && (pl.adler = ma(pl.adler, Bl.pending_buf, Bl.pending - Kl, Kl)), oc === 0 && (Bl.gzindex = 0, Bl.status = Fl);
    } else Bl.status = Fl;
    if (Bl.status === Fl) if (Bl.gzhead.comment) {
      Kl = Bl.pending;
      do {
        if (Bl.pending === Bl.pending_buf_size && (Bl.gzhead.hcrc && Bl.pending > Kl && (pl.adler = ma(pl.adler, Bl.pending_buf, Bl.pending - Kl, Kl)), hl(pl), Kl = Bl.pending, Bl.pending === Bl.pending_buf_size)) {
          oc = 1;
          break;
        }
        oc = Bl.gzindex < Bl.gzhead.comment.length ? 255 & Bl.gzhead.comment.charCodeAt(Bl.gzindex++) : 0, Il(Bl, oc);
      } while (oc !== 0);
      Bl.gzhead.hcrc && Bl.pending > Kl && (pl.adler = ma(pl.adler, Bl.pending_buf, Bl.pending - Kl, Kl)), oc === 0 && (Bl.status = Nl);
    } else Bl.status = Nl;
    if (Bl.status === Nl && (Bl.gzhead.hcrc ? (Bl.pending + 2 > Bl.pending_buf_size && hl(pl), Bl.pending + 2 <= Bl.pending_buf_size && (Il(Bl, 255 & pl.adler), Il(Bl, pl.adler >> 8 & 255), pl.adler = 0, Bl.status = zl)) : Bl.status = zl), Bl.pending !== 0) {
      if (hl(pl), pl.avail_out === 0) return Bl.last_flush = -1, Ta;
    } else if (pl.avail_in === 0 && Rl(Jl) <= Rl(Al) && Jl !== xa) return yl(pl, Za);
    if (Bl.status === Zl && pl.avail_in !== 0) return yl(pl, Za);
    if (pl.avail_in !== 0 || Bl.lookahead !== 0 || Jl !== ba && Bl.status !== Zl) {
      var vc = Bl.strategy === Ja ? Lc(Bl, Jl) : Bl.strategy === el ? hc(Bl, Jl) : Kn[Bl.level].func(Bl, Jl);
      if (vc !== vl && vc !== Tl || (Bl.status = Zl), vc === kl || vc === vl) return pl.avail_out === 0 && (Bl.last_flush = -1), Ta;
      if (vc === ul && (Jl === _a ? Jo._tr_align(Bl) : Jl !== wa && (Jo._tr_stored_block(Bl, 0, 0, !1), Jl === ya && (Ul(Bl.head), Bl.lookahead === 0 && (Bl.strstart = 0, Bl.block_start = 0, Bl.insert = 0))), hl(pl), pl.avail_out === 0)) return Bl.last_flush = -1, Ta;
    }
    return Jl !== xa ? Ta : Bl.wrap <= 0 ? Sa : (Bl.wrap === 2 ? (Il(Bl, 255 & pl.adler), Il(Bl, pl.adler >> 8 & 255), Il(Bl, pl.adler >> 16 & 255), Il(Bl, pl.adler >> 24 & 255), Il(Bl, 255 & pl.total_in), Il(Bl, pl.total_in >> 8 & 255), Il(Bl, pl.total_in >> 16 & 255), Il(Bl, pl.total_in >> 24 & 255)) : (Ll(Bl, pl.adler >>> 16), Ll(Bl, 65535 & pl.adler)), hl(pl), Bl.wrap > 0 && (Bl.wrap = -Bl.wrap), Bl.pending !== 0 ? Ta : Sa);
  }
  function cc(pl) {
    var Jl;
    return pl && pl.state ? (Jl = pl.state.status) !== Dl && Jl !== _l && Jl !== gl && Jl !== Fl && Jl !== Nl && Jl !== zl && Jl !== Zl ? yl(pl, Ma) : (pl.state = null, Jl === zl ? yl(pl, ka) : Ta) : Ma;
  }
  function bl(pl, Jl) {
    var Al, Bl, Kl, oc, xc, vc, Pc, Hc, $c = Jl.length;
    if (!pl || !pl.state || (oc = (Al = pl.state).wrap) === 2 || oc === 1 && Al.status !== Dl || Al.lookahead) return Ma;
    for (oc === 1 && (pl.adler = pa(pl.adler, Jl, $c, 0)), Al.wrap = 0, $c >= Al.w_size && (oc === 0 && (Ul(Al.head), Al.strstart = 0, Al.block_start = 0, Al.insert = 0), Hc = new qn.Buf8(Al.w_size), qn.arraySet(Hc, Jl, $c - Al.w_size, Al.w_size, 0), Jl = Hc, $c = Al.w_size), xc = pl.avail_in, vc = pl.next_in, Pc = pl.input, pl.avail_in = $c, pl.next_in = 0, pl.input = Jl, uc(Al); Al.lookahead >= fl; ) {
      Bl = Al.strstart, Kl = Al.lookahead - (fl - 1);
      do
        Al.ins_h = (Al.ins_h << Al.hash_shift ^ Al.window[Bl + fl - 1]) & Al.hash_mask, Al.prev[Bl & Al.w_mask] = Al.head[Al.ins_h], Al.head[Al.ins_h] = Bl, Bl++;
      while (--Kl);
      Al.strstart = Bl, Al.lookahead = fl - 1, uc(Al);
    }
    return Al.strstart += Al.lookahead, Al.block_start = Al.strstart, Al.insert = Al.lookahead, Al.lookahead = 0, Al.match_length = Al.prev_length = fl - 1, Al.match_available = 0, pl.next_in = vc, pl.input = Pc, pl.avail_in = xc, Al.wrap = oc, Ta;
  }
  Kn = [new Ec(0, 0, 0, 0, _c), new Ec(4, 4, 8, 4, mc), new Ec(4, 5, 16, 8, mc), new Ec(4, 6, 32, 32, mc), new Ec(4, 4, 16, 16, Sc), new Ec(8, 16, 32, 32, Sc), new Ec(8, 16, 128, 128, Sc), new Ec(8, 32, 128, 256, Sc), new Ec(32, 128, 258, 1024, Sc), new Ec(32, 258, 258, 4096, Sc)], Un.deflateInit = Pl, Un.deflateInit2 = Vl, Un.deflateReset = Gl, Un.deflateResetKeep = lc, Un.deflateSetHeader = ql, Un.deflate = Ol, Un.deflateEnd = cc, Un.deflateSetDictionary = bl, Un.deflateInfo = "pako deflate (from Nodeca project)";
}, { "../utils/common": 52, "./adler32": 53, "./crc32": 55, "./messages": 60, "./trees": 61 }], 57: [function(Xn, zn, Un) {
  var Kn = 30, qn = 12;
  zn.exports = function(Jo, pa) {
    var ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el, qa, tl, Qa, nl, rl, il, cl, ll, al;
    ma = Jo.state, va = Jo.next_in, ll = Jo.input, ba = va + (Jo.avail_in - 5), _a = Jo.next_out, al = Jo.output, ya = _a - (pa - Jo.avail_out), xa = _a + (Jo.avail_out - 257), wa = ma.dmax, Ta = ma.wsize, Sa = ma.whave, Ma = ma.wnext, ka = ma.window, Za = ma.hold, Na = ma.bits, Ka = ma.lencode, Ja = ma.distcode, el = (1 << ma.lenbits) - 1, qa = (1 << ma.distbits) - 1;
    e: do {
      Na < 15 && (Za += ll[va++] << Na, Na += 8, Za += ll[va++] << Na, Na += 8), tl = Ka[Za & el];
      t: for (; ; ) {
        if (Za >>>= Qa = tl >>> 24, Na -= Qa, (Qa = tl >>> 16 & 255) == 0) al[_a++] = 65535 & tl;
        else {
          if (!(16 & Qa)) {
            if (64 & Qa) {
              if (32 & Qa) {
                ma.mode = qn;
                break e;
              }
              Jo.msg = "invalid literal/length code", ma.mode = Kn;
              break e;
            }
            tl = Ka[(65535 & tl) + (Za & (1 << Qa) - 1)];
            continue t;
          }
          for (nl = 65535 & tl, (Qa &= 15) && (Na < Qa && (Za += ll[va++] << Na, Na += 8), nl += Za & (1 << Qa) - 1, Za >>>= Qa, Na -= Qa), Na < 15 && (Za += ll[va++] << Na, Na += 8, Za += ll[va++] << Na, Na += 8), tl = Ja[Za & qa]; ; ) {
            if (Za >>>= Qa = tl >>> 24, Na -= Qa, 16 & (Qa = tl >>> 16 & 255)) {
              if (rl = 65535 & tl, Na < (Qa &= 15) && (Za += ll[va++] << Na, (Na += 8) < Qa && (Za += ll[va++] << Na, Na += 8)), (rl += Za & (1 << Qa) - 1) > wa) {
                Jo.msg = "invalid distance too far back", ma.mode = Kn;
                break e;
              }
              if (Za >>>= Qa, Na -= Qa, rl > (Qa = _a - ya)) {
                if ((Qa = rl - Qa) > Sa && ma.sane) {
                  Jo.msg = "invalid distance too far back", ma.mode = Kn;
                  break e;
                }
                if (il = 0, cl = ka, Ma === 0) {
                  if (il += Ta - Qa, Qa < nl) {
                    nl -= Qa;
                    do
                      al[_a++] = ka[il++];
                    while (--Qa);
                    il = _a - rl, cl = al;
                  }
                } else if (Ma < Qa) {
                  if (il += Ta + Ma - Qa, (Qa -= Ma) < nl) {
                    nl -= Qa;
                    do
                      al[_a++] = ka[il++];
                    while (--Qa);
                    if (il = 0, Ma < nl) {
                      nl -= Qa = Ma;
                      do
                        al[_a++] = ka[il++];
                      while (--Qa);
                      il = _a - rl, cl = al;
                    }
                  }
                } else if (il += Ma - Qa, Qa < nl) {
                  nl -= Qa;
                  do
                    al[_a++] = ka[il++];
                  while (--Qa);
                  il = _a - rl, cl = al;
                }
                for (; nl > 2; ) al[_a++] = cl[il++], al[_a++] = cl[il++], al[_a++] = cl[il++], nl -= 3;
                nl && (al[_a++] = cl[il++], nl > 1 && (al[_a++] = cl[il++]));
              } else {
                il = _a - rl;
                do
                  al[_a++] = al[il++], al[_a++] = al[il++], al[_a++] = al[il++], nl -= 3;
                while (nl > 2);
                nl && (al[_a++] = al[il++], nl > 1 && (al[_a++] = al[il++]));
              }
              break;
            }
            if (64 & Qa) {
              Jo.msg = "invalid distance code", ma.mode = Kn;
              break e;
            }
            tl = Ja[(65535 & tl) + (Za & (1 << Qa) - 1)];
          }
        }
        break;
      }
    } while (va < ba && _a < xa);
    va -= nl = Na >> 3, Za &= (1 << (Na -= nl << 3)) - 1, Jo.next_in = va, Jo.next_out = _a, Jo.avail_in = va < ba ? ba - va + 5 : 5 - (va - ba), Jo.avail_out = _a < xa ? xa - _a + 257 : 257 - (_a - xa), ma.hold = Za, ma.bits = Na;
  };
}, {}], 58: [function(Xn, zn, Un) {
  var Kn = Xn("../utils/common"), qn = Xn("./adler32"), Jo = Xn("./crc32"), pa = Xn("./inffast"), ma = Xn("./inftrees"), va = 0, ba = 1, _a = 2, ya = 4, xa = 5, wa = 6, Ta = 0, Sa = 1, Ma = 2, ka = -2, Za = -3, Na = -4, Ka = -5, Ja = 8, el = 1, qa = 2, tl = 3, Qa = 4, nl = 5, rl = 6, il = 7, cl = 8, ll = 9, al = 10, sl = 11, dl = 12, El = 13, fl = 14, Ml = 15, Sl = 16, ml = 17, Dl = 18, _l = 19, gl = 20, Fl = 21, Nl = 22, zl = 23, Zl = 24, kl = 25, ul = 26, vl = 27, Tl = 28, wl = 29, yl = 30, Rl = 31, Ul = 852, hl = 592, Cl = 15;
  function Il(Vl) {
    return (Vl >>> 24 & 255) + (Vl >>> 8 & 65280) + ((65280 & Vl) << 8) + ((255 & Vl) << 24);
  }
  function Ll() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Kn.Buf16(320), this.work = new Kn.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function tc(Vl) {
    var Pl;
    return Vl && Vl.state ? (Pl = Vl.state, Vl.total_in = Vl.total_out = Pl.total = 0, Vl.msg = "", Pl.wrap && (Vl.adler = 1 & Pl.wrap), Pl.mode = el, Pl.last = 0, Pl.havedict = 0, Pl.dmax = 32768, Pl.head = null, Pl.hold = 0, Pl.bits = 0, Pl.lencode = Pl.lendyn = new Kn.Buf32(Ul), Pl.distcode = Pl.distdyn = new Kn.Buf32(hl), Pl.sane = 1, Pl.back = -1, Ta) : ka;
  }
  function nc(Vl) {
    var Pl;
    return Vl && Vl.state ? ((Pl = Vl.state).wsize = 0, Pl.whave = 0, Pl.wnext = 0, tc(Vl)) : ka;
  }
  function uc(Vl, Pl) {
    var Ol, cc;
    return Vl && Vl.state ? (cc = Vl.state, Pl < 0 ? (Ol = 0, Pl = -Pl) : (Ol = 1 + (Pl >> 4), Pl < 48 && (Pl &= 15)), Pl && (Pl < 8 || Pl > 15) ? ka : (cc.window !== null && cc.wbits !== Pl && (cc.window = null), cc.wrap = Ol, cc.wbits = Pl, nc(Vl))) : ka;
  }
  function _c(Vl, Pl) {
    var Ol, cc;
    return Vl ? (cc = new Ll(), Vl.state = cc, cc.window = null, (Ol = uc(Vl, Pl)) !== Ta && (Vl.state = null), Ol) : ka;
  }
  function mc(Vl) {
    return _c(Vl, Cl);
  }
  var Sc, hc, Lc = !0;
  function Ec(Vl) {
    if (Lc) {
      var Pl;
      for (Sc = new Kn.Buf32(512), hc = new Kn.Buf32(32), Pl = 0; Pl < 144; ) Vl.lens[Pl++] = 8;
      for (; Pl < 256; ) Vl.lens[Pl++] = 9;
      for (; Pl < 280; ) Vl.lens[Pl++] = 7;
      for (; Pl < 288; ) Vl.lens[Pl++] = 8;
      for (ma(ba, Vl.lens, 0, 288, Sc, 0, Vl.work, { bits: 9 }), Pl = 0; Pl < 32; ) Vl.lens[Pl++] = 5;
      ma(_a, Vl.lens, 0, 32, hc, 0, Vl.work, { bits: 5 }), Lc = !1;
    }
    Vl.lencode = Sc, Vl.lenbits = 9, Vl.distcode = hc, Vl.distbits = 5;
  }
  function Hl(Vl, Pl, Ol, cc) {
    var bl, pl = Vl.state;
    return pl.window === null && (pl.wsize = 1 << pl.wbits, pl.wnext = 0, pl.whave = 0, pl.window = new Kn.Buf8(pl.wsize)), cc >= pl.wsize ? (Kn.arraySet(pl.window, Pl, Ol - pl.wsize, pl.wsize, 0), pl.wnext = 0, pl.whave = pl.wsize) : ((bl = pl.wsize - pl.wnext) > cc && (bl = cc), Kn.arraySet(pl.window, Pl, Ol - cc, bl, pl.wnext), (cc -= bl) ? (Kn.arraySet(pl.window, Pl, Ol - cc, cc, 0), pl.wnext = cc, pl.whave = pl.wsize) : (pl.wnext += bl, pl.wnext === pl.wsize && (pl.wnext = 0), pl.whave < pl.wsize && (pl.whave += bl))), 0;
  }
  function fc(Vl, Pl) {
    var Ol, cc, bl, pl, Jl, Al, Bl, Kl, oc, xc, vc, Pc, Hc, $c, Nc, Zc, Yc, mh, Wl, ic, Xl, Ql, ec, rc, dc = 0, wc = new Kn.Buf8(4), bc = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
    if (!Vl || !Vl.state || !Vl.output || !Vl.input && Vl.avail_in !== 0) return ka;
    (Ol = Vl.state).mode === dl && (Ol.mode = El), Jl = Vl.next_out, bl = Vl.output, Bl = Vl.avail_out, pl = Vl.next_in, cc = Vl.input, Al = Vl.avail_in, Kl = Ol.hold, oc = Ol.bits, xc = Al, vc = Bl, Ql = Ta;
    e: for (; ; ) switch (Ol.mode) {
      case el:
        if (Ol.wrap === 0) {
          Ol.mode = El;
          break;
        }
        for (; oc < 16; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        if (2 & Ol.wrap && Kl === 35615) {
          Ol.check = 0, wc[0] = 255 & Kl, wc[1] = Kl >>> 8 & 255, Ol.check = Jo(Ol.check, wc, 2, 0), Kl = 0, oc = 0, Ol.mode = qa;
          break;
        }
        if (Ol.flags = 0, Ol.head && (Ol.head.done = !1), !(1 & Ol.wrap) || (((255 & Kl) << 8) + (Kl >> 8)) % 31) {
          Vl.msg = "incorrect header check", Ol.mode = yl;
          break;
        }
        if ((15 & Kl) !== Ja) {
          Vl.msg = "unknown compression method", Ol.mode = yl;
          break;
        }
        if (oc -= 4, Xl = 8 + (15 & (Kl >>>= 4)), Ol.wbits === 0) Ol.wbits = Xl;
        else if (Xl > Ol.wbits) {
          Vl.msg = "invalid window size", Ol.mode = yl;
          break;
        }
        Ol.dmax = 1 << Xl, Vl.adler = Ol.check = 1, Ol.mode = 512 & Kl ? al : dl, Kl = 0, oc = 0;
        break;
      case qa:
        for (; oc < 16; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        if (Ol.flags = Kl, (255 & Ol.flags) !== Ja) {
          Vl.msg = "unknown compression method", Ol.mode = yl;
          break;
        }
        if (57344 & Ol.flags) {
          Vl.msg = "unknown header flags set", Ol.mode = yl;
          break;
        }
        Ol.head && (Ol.head.text = Kl >> 8 & 1), 512 & Ol.flags && (wc[0] = 255 & Kl, wc[1] = Kl >>> 8 & 255, Ol.check = Jo(Ol.check, wc, 2, 0)), Kl = 0, oc = 0, Ol.mode = tl;
      case tl:
        for (; oc < 32; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        Ol.head && (Ol.head.time = Kl), 512 & Ol.flags && (wc[0] = 255 & Kl, wc[1] = Kl >>> 8 & 255, wc[2] = Kl >>> 16 & 255, wc[3] = Kl >>> 24 & 255, Ol.check = Jo(Ol.check, wc, 4, 0)), Kl = 0, oc = 0, Ol.mode = Qa;
      case Qa:
        for (; oc < 16; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        Ol.head && (Ol.head.xflags = 255 & Kl, Ol.head.os = Kl >> 8), 512 & Ol.flags && (wc[0] = 255 & Kl, wc[1] = Kl >>> 8 & 255, Ol.check = Jo(Ol.check, wc, 2, 0)), Kl = 0, oc = 0, Ol.mode = nl;
      case nl:
        if (1024 & Ol.flags) {
          for (; oc < 16; ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          Ol.length = Kl, Ol.head && (Ol.head.extra_len = Kl), 512 & Ol.flags && (wc[0] = 255 & Kl, wc[1] = Kl >>> 8 & 255, Ol.check = Jo(Ol.check, wc, 2, 0)), Kl = 0, oc = 0;
        } else Ol.head && (Ol.head.extra = null);
        Ol.mode = rl;
      case rl:
        if (1024 & Ol.flags && ((Pc = Ol.length) > Al && (Pc = Al), Pc && (Ol.head && (Xl = Ol.head.extra_len - Ol.length, Ol.head.extra || (Ol.head.extra = new Array(Ol.head.extra_len)), Kn.arraySet(Ol.head.extra, cc, pl, Pc, Xl)), 512 & Ol.flags && (Ol.check = Jo(Ol.check, cc, Pc, pl)), Al -= Pc, pl += Pc, Ol.length -= Pc), Ol.length)) break e;
        Ol.length = 0, Ol.mode = il;
      case il:
        if (2048 & Ol.flags) {
          if (Al === 0) break e;
          Pc = 0;
          do
            Xl = cc[pl + Pc++], Ol.head && Xl && Ol.length < 65536 && (Ol.head.name += String.fromCharCode(Xl));
          while (Xl && Pc < Al);
          if (512 & Ol.flags && (Ol.check = Jo(Ol.check, cc, Pc, pl)), Al -= Pc, pl += Pc, Xl) break e;
        } else Ol.head && (Ol.head.name = null);
        Ol.length = 0, Ol.mode = cl;
      case cl:
        if (4096 & Ol.flags) {
          if (Al === 0) break e;
          Pc = 0;
          do
            Xl = cc[pl + Pc++], Ol.head && Xl && Ol.length < 65536 && (Ol.head.comment += String.fromCharCode(Xl));
          while (Xl && Pc < Al);
          if (512 & Ol.flags && (Ol.check = Jo(Ol.check, cc, Pc, pl)), Al -= Pc, pl += Pc, Xl) break e;
        } else Ol.head && (Ol.head.comment = null);
        Ol.mode = ll;
      case ll:
        if (512 & Ol.flags) {
          for (; oc < 16; ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          if (Kl !== (65535 & Ol.check)) {
            Vl.msg = "header crc mismatch", Ol.mode = yl;
            break;
          }
          Kl = 0, oc = 0;
        }
        Ol.head && (Ol.head.hcrc = Ol.flags >> 9 & 1, Ol.head.done = !0), Vl.adler = Ol.check = 0, Ol.mode = dl;
        break;
      case al:
        for (; oc < 32; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        Vl.adler = Ol.check = Il(Kl), Kl = 0, oc = 0, Ol.mode = sl;
      case sl:
        if (Ol.havedict === 0) return Vl.next_out = Jl, Vl.avail_out = Bl, Vl.next_in = pl, Vl.avail_in = Al, Ol.hold = Kl, Ol.bits = oc, Ma;
        Vl.adler = Ol.check = 1, Ol.mode = dl;
      case dl:
        if (Pl === xa || Pl === wa) break e;
      case El:
        if (Ol.last) {
          Kl >>>= 7 & oc, oc -= 7 & oc, Ol.mode = vl;
          break;
        }
        for (; oc < 3; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        switch (Ol.last = 1 & Kl, oc -= 1, 3 & (Kl >>>= 1)) {
          case 0:
            Ol.mode = fl;
            break;
          case 1:
            if (Ec(Ol), Ol.mode = gl, Pl === wa) {
              Kl >>>= 2, oc -= 2;
              break e;
            }
            break;
          case 2:
            Ol.mode = ml;
            break;
          case 3:
            Vl.msg = "invalid block type", Ol.mode = yl;
        }
        Kl >>>= 2, oc -= 2;
        break;
      case fl:
        for (Kl >>>= 7 & oc, oc -= 7 & oc; oc < 32; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        if ((65535 & Kl) != (Kl >>> 16 ^ 65535)) {
          Vl.msg = "invalid stored block lengths", Ol.mode = yl;
          break;
        }
        if (Ol.length = 65535 & Kl, Kl = 0, oc = 0, Ol.mode = Ml, Pl === wa) break e;
      case Ml:
        Ol.mode = Sl;
      case Sl:
        if (Pc = Ol.length) {
          if (Pc > Al && (Pc = Al), Pc > Bl && (Pc = Bl), Pc === 0) break e;
          Kn.arraySet(bl, cc, pl, Pc, Jl), Al -= Pc, pl += Pc, Bl -= Pc, Jl += Pc, Ol.length -= Pc;
          break;
        }
        Ol.mode = dl;
        break;
      case ml:
        for (; oc < 14; ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        if (Ol.nlen = 257 + (31 & Kl), Kl >>>= 5, oc -= 5, Ol.ndist = 1 + (31 & Kl), Kl >>>= 5, oc -= 5, Ol.ncode = 4 + (15 & Kl), Kl >>>= 4, oc -= 4, Ol.nlen > 286 || Ol.ndist > 30) {
          Vl.msg = "too many length or distance symbols", Ol.mode = yl;
          break;
        }
        Ol.have = 0, Ol.mode = Dl;
      case Dl:
        for (; Ol.have < Ol.ncode; ) {
          for (; oc < 3; ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          Ol.lens[bc[Ol.have++]] = 7 & Kl, Kl >>>= 3, oc -= 3;
        }
        for (; Ol.have < 19; ) Ol.lens[bc[Ol.have++]] = 0;
        if (Ol.lencode = Ol.lendyn, Ol.lenbits = 7, ec = { bits: Ol.lenbits }, Ql = ma(va, Ol.lens, 0, 19, Ol.lencode, 0, Ol.work, ec), Ol.lenbits = ec.bits, Ql) {
          Vl.msg = "invalid code lengths set", Ol.mode = yl;
          break;
        }
        Ol.have = 0, Ol.mode = _l;
      case _l:
        for (; Ol.have < Ol.nlen + Ol.ndist; ) {
          for (; Zc = (dc = Ol.lencode[Kl & (1 << Ol.lenbits) - 1]) >>> 16 & 255, Yc = 65535 & dc, !((Nc = dc >>> 24) <= oc); ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          if (Yc < 16) Kl >>>= Nc, oc -= Nc, Ol.lens[Ol.have++] = Yc;
          else {
            if (Yc === 16) {
              for (rc = Nc + 2; oc < rc; ) {
                if (Al === 0) break e;
                Al--, Kl += cc[pl++] << oc, oc += 8;
              }
              if (Kl >>>= Nc, oc -= Nc, Ol.have === 0) {
                Vl.msg = "invalid bit length repeat", Ol.mode = yl;
                break;
              }
              Xl = Ol.lens[Ol.have - 1], Pc = 3 + (3 & Kl), Kl >>>= 2, oc -= 2;
            } else if (Yc === 17) {
              for (rc = Nc + 3; oc < rc; ) {
                if (Al === 0) break e;
                Al--, Kl += cc[pl++] << oc, oc += 8;
              }
              oc -= Nc, Xl = 0, Pc = 3 + (7 & (Kl >>>= Nc)), Kl >>>= 3, oc -= 3;
            } else {
              for (rc = Nc + 7; oc < rc; ) {
                if (Al === 0) break e;
                Al--, Kl += cc[pl++] << oc, oc += 8;
              }
              oc -= Nc, Xl = 0, Pc = 11 + (127 & (Kl >>>= Nc)), Kl >>>= 7, oc -= 7;
            }
            if (Ol.have + Pc > Ol.nlen + Ol.ndist) {
              Vl.msg = "invalid bit length repeat", Ol.mode = yl;
              break;
            }
            for (; Pc--; ) Ol.lens[Ol.have++] = Xl;
          }
        }
        if (Ol.mode === yl) break;
        if (Ol.lens[256] === 0) {
          Vl.msg = "invalid code -- missing end-of-block", Ol.mode = yl;
          break;
        }
        if (Ol.lenbits = 9, ec = { bits: Ol.lenbits }, Ql = ma(ba, Ol.lens, 0, Ol.nlen, Ol.lencode, 0, Ol.work, ec), Ol.lenbits = ec.bits, Ql) {
          Vl.msg = "invalid literal/lengths set", Ol.mode = yl;
          break;
        }
        if (Ol.distbits = 6, Ol.distcode = Ol.distdyn, ec = { bits: Ol.distbits }, Ql = ma(_a, Ol.lens, Ol.nlen, Ol.ndist, Ol.distcode, 0, Ol.work, ec), Ol.distbits = ec.bits, Ql) {
          Vl.msg = "invalid distances set", Ol.mode = yl;
          break;
        }
        if (Ol.mode = gl, Pl === wa) break e;
      case gl:
        Ol.mode = Fl;
      case Fl:
        if (Al >= 6 && Bl >= 258) {
          Vl.next_out = Jl, Vl.avail_out = Bl, Vl.next_in = pl, Vl.avail_in = Al, Ol.hold = Kl, Ol.bits = oc, pa(Vl, vc), Jl = Vl.next_out, bl = Vl.output, Bl = Vl.avail_out, pl = Vl.next_in, cc = Vl.input, Al = Vl.avail_in, Kl = Ol.hold, oc = Ol.bits, Ol.mode === dl && (Ol.back = -1);
          break;
        }
        for (Ol.back = 0; Zc = (dc = Ol.lencode[Kl & (1 << Ol.lenbits) - 1]) >>> 16 & 255, Yc = 65535 & dc, !((Nc = dc >>> 24) <= oc); ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        if (Zc && !(240 & Zc)) {
          for (mh = Nc, Wl = Zc, ic = Yc; Zc = (dc = Ol.lencode[ic + ((Kl & (1 << mh + Wl) - 1) >> mh)]) >>> 16 & 255, Yc = 65535 & dc, !(mh + (Nc = dc >>> 24) <= oc); ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          Kl >>>= mh, oc -= mh, Ol.back += mh;
        }
        if (Kl >>>= Nc, oc -= Nc, Ol.back += Nc, Ol.length = Yc, Zc === 0) {
          Ol.mode = ul;
          break;
        }
        if (32 & Zc) {
          Ol.back = -1, Ol.mode = dl;
          break;
        }
        if (64 & Zc) {
          Vl.msg = "invalid literal/length code", Ol.mode = yl;
          break;
        }
        Ol.extra = 15 & Zc, Ol.mode = Nl;
      case Nl:
        if (Ol.extra) {
          for (rc = Ol.extra; oc < rc; ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          Ol.length += Kl & (1 << Ol.extra) - 1, Kl >>>= Ol.extra, oc -= Ol.extra, Ol.back += Ol.extra;
        }
        Ol.was = Ol.length, Ol.mode = zl;
      case zl:
        for (; Zc = (dc = Ol.distcode[Kl & (1 << Ol.distbits) - 1]) >>> 16 & 255, Yc = 65535 & dc, !((Nc = dc >>> 24) <= oc); ) {
          if (Al === 0) break e;
          Al--, Kl += cc[pl++] << oc, oc += 8;
        }
        if (!(240 & Zc)) {
          for (mh = Nc, Wl = Zc, ic = Yc; Zc = (dc = Ol.distcode[ic + ((Kl & (1 << mh + Wl) - 1) >> mh)]) >>> 16 & 255, Yc = 65535 & dc, !(mh + (Nc = dc >>> 24) <= oc); ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          Kl >>>= mh, oc -= mh, Ol.back += mh;
        }
        if (Kl >>>= Nc, oc -= Nc, Ol.back += Nc, 64 & Zc) {
          Vl.msg = "invalid distance code", Ol.mode = yl;
          break;
        }
        Ol.offset = Yc, Ol.extra = 15 & Zc, Ol.mode = Zl;
      case Zl:
        if (Ol.extra) {
          for (rc = Ol.extra; oc < rc; ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          Ol.offset += Kl & (1 << Ol.extra) - 1, Kl >>>= Ol.extra, oc -= Ol.extra, Ol.back += Ol.extra;
        }
        if (Ol.offset > Ol.dmax) {
          Vl.msg = "invalid distance too far back", Ol.mode = yl;
          break;
        }
        Ol.mode = kl;
      case kl:
        if (Bl === 0) break e;
        if (Pc = vc - Bl, Ol.offset > Pc) {
          if ((Pc = Ol.offset - Pc) > Ol.whave && Ol.sane) {
            Vl.msg = "invalid distance too far back", Ol.mode = yl;
            break;
          }
          Pc > Ol.wnext ? (Pc -= Ol.wnext, Hc = Ol.wsize - Pc) : Hc = Ol.wnext - Pc, Pc > Ol.length && (Pc = Ol.length), $c = Ol.window;
        } else $c = bl, Hc = Jl - Ol.offset, Pc = Ol.length;
        Pc > Bl && (Pc = Bl), Bl -= Pc, Ol.length -= Pc;
        do
          bl[Jl++] = $c[Hc++];
        while (--Pc);
        Ol.length === 0 && (Ol.mode = Fl);
        break;
      case ul:
        if (Bl === 0) break e;
        bl[Jl++] = Ol.length, Bl--, Ol.mode = Fl;
        break;
      case vl:
        if (Ol.wrap) {
          for (; oc < 32; ) {
            if (Al === 0) break e;
            Al--, Kl |= cc[pl++] << oc, oc += 8;
          }
          if (vc -= Bl, Vl.total_out += vc, Ol.total += vc, vc && (Vl.adler = Ol.check = Ol.flags ? Jo(Ol.check, bl, vc, Jl - vc) : qn(Ol.check, bl, vc, Jl - vc)), vc = Bl, (Ol.flags ? Kl : Il(Kl)) !== Ol.check) {
            Vl.msg = "incorrect data check", Ol.mode = yl;
            break;
          }
          Kl = 0, oc = 0;
        }
        Ol.mode = Tl;
      case Tl:
        if (Ol.wrap && Ol.flags) {
          for (; oc < 32; ) {
            if (Al === 0) break e;
            Al--, Kl += cc[pl++] << oc, oc += 8;
          }
          if (Kl !== (4294967295 & Ol.total)) {
            Vl.msg = "incorrect length check", Ol.mode = yl;
            break;
          }
          Kl = 0, oc = 0;
        }
        Ol.mode = wl;
      case wl:
        Ql = Sa;
        break e;
      case yl:
        Ql = Za;
        break e;
      case Rl:
        return Na;
      default:
        return ka;
    }
    return Vl.next_out = Jl, Vl.avail_out = Bl, Vl.next_in = pl, Vl.avail_in = Al, Ol.hold = Kl, Ol.bits = oc, (Ol.wsize || vc !== Vl.avail_out && Ol.mode < yl && (Ol.mode < vl || Pl !== ya)) && Hl(Vl, Vl.output, Vl.next_out, vc - Vl.avail_out), xc -= Vl.avail_in, vc -= Vl.avail_out, Vl.total_in += xc, Vl.total_out += vc, Ol.total += vc, Ol.wrap && vc && (Vl.adler = Ol.check = Ol.flags ? Jo(Ol.check, bl, vc, Vl.next_out - vc) : qn(Ol.check, bl, vc, Vl.next_out - vc)), Vl.data_type = Ol.bits + (Ol.last ? 64 : 0) + (Ol.mode === dl ? 128 : 0) + (Ol.mode === gl || Ol.mode === Ml ? 256 : 0), (xc === 0 && vc === 0 || Pl === ya) && Ql === Ta && (Ql = Ka), Ql;
  }
  function lc(Vl) {
    if (!Vl || !Vl.state) return ka;
    var Pl = Vl.state;
    return Pl.window && (Pl.window = null), Vl.state = null, Ta;
  }
  function Gl(Vl, Pl) {
    var Ol;
    return Vl && Vl.state && 2 & (Ol = Vl.state).wrap ? (Ol.head = Pl, Pl.done = !1, Ta) : ka;
  }
  function ql(Vl, Pl) {
    var Ol, cc = Pl.length;
    return Vl && Vl.state ? (Ol = Vl.state).wrap !== 0 && Ol.mode !== sl ? ka : Ol.mode === sl && qn(1, Pl, cc, 0) !== Ol.check ? Za : Hl(Vl, Pl, cc, cc) ? (Ol.mode = Rl, Na) : (Ol.havedict = 1, Ta) : ka;
  }
  Un.inflateReset = nc, Un.inflateReset2 = uc, Un.inflateResetKeep = tc, Un.inflateInit = mc, Un.inflateInit2 = _c, Un.inflate = fc, Un.inflateEnd = lc, Un.inflateGetHeader = Gl, Un.inflateSetDictionary = ql, Un.inflateInfo = "pako inflate (from Nodeca project)";
}, { "../utils/common": 52, "./adler32": 53, "./crc32": 55, "./inffast": 57, "./inftrees": 59 }], 59: [function(Xn, zn, Un) {
  var Kn = Xn("../utils/common"), qn = 15, Jo = 852, pa = 592, ma = 0, va = 1, ba = 2, _a = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], ya = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], xa = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], wa = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
  zn.exports = function(Ta, Sa, Ma, ka, Za, Na, Ka, Ja) {
    var el, qa, tl, Qa, nl, rl, il, cl, ll, al = Ja.bits, sl = 0, dl = 0, El = 0, fl = 0, Ml = 0, Sl = 0, ml = 0, Dl = 0, _l = 0, gl = 0, Fl = null, Nl = 0, zl = new Kn.Buf16(qn + 1), Zl = new Kn.Buf16(qn + 1), kl = null, ul = 0;
    for (sl = 0; sl <= qn; sl++) zl[sl] = 0;
    for (dl = 0; dl < ka; dl++) zl[Sa[Ma + dl]]++;
    for (Ml = al, fl = qn; fl >= 1 && zl[fl] === 0; fl--) ;
    if (Ml > fl && (Ml = fl), fl === 0) return Za[Na++] = 20971520, Za[Na++] = 20971520, Ja.bits = 1, 0;
    for (El = 1; El < fl && zl[El] === 0; El++) ;
    for (Ml < El && (Ml = El), Dl = 1, sl = 1; sl <= qn; sl++) if (Dl <<= 1, (Dl -= zl[sl]) < 0) return -1;
    if (Dl > 0 && (Ta === ma || fl !== 1)) return -1;
    for (Zl[1] = 0, sl = 1; sl < qn; sl++) Zl[sl + 1] = Zl[sl] + zl[sl];
    for (dl = 0; dl < ka; dl++) Sa[Ma + dl] !== 0 && (Ka[Zl[Sa[Ma + dl]]++] = dl);
    if (Ta === ma ? (Fl = kl = Ka, rl = 19) : Ta === va ? (Fl = _a, Nl -= 257, kl = ya, ul -= 257, rl = 256) : (Fl = xa, kl = wa, rl = -1), gl = 0, dl = 0, sl = El, nl = Na, Sl = Ml, ml = 0, tl = -1, Qa = (_l = 1 << Ml) - 1, Ta === va && _l > Jo || Ta === ba && _l > pa) return 1;
    for (; ; ) {
      il = sl - ml, Ka[dl] < rl ? (cl = 0, ll = Ka[dl]) : Ka[dl] > rl ? (cl = kl[ul + Ka[dl]], ll = Fl[Nl + Ka[dl]]) : (cl = 96, ll = 0), el = 1 << sl - ml, El = qa = 1 << Sl;
      do
        Za[nl + (gl >> ml) + (qa -= el)] = il << 24 | cl << 16 | ll;
      while (qa !== 0);
      for (el = 1 << sl - 1; gl & el; ) el >>= 1;
      if (el !== 0 ? (gl &= el - 1, gl += el) : gl = 0, dl++, --zl[sl] == 0) {
        if (sl === fl) break;
        sl = Sa[Ma + Ka[dl]];
      }
      if (sl > Ml && (gl & Qa) !== tl) {
        for (ml === 0 && (ml = Ml), nl += El, Dl = 1 << (Sl = sl - ml); Sl + ml < fl && !((Dl -= zl[Sl + ml]) <= 0); ) Sl++, Dl <<= 1;
        if (_l += 1 << Sl, Ta === va && _l > Jo || Ta === ba && _l > pa) return 1;
        Za[tl = gl & Qa] = Ml << 24 | Sl << 16 | nl - Na;
      }
    }
    return gl !== 0 && (Za[nl + gl] = sl - ml << 24 | 64 << 16), Ja.bits = Ml, 0;
  };
}, { "../utils/common": 52 }], 60: [function(Xn, zn, Un) {
  zn.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
}, {}], 61: [function(Xn, zn, Un) {
  var Kn = Xn("../utils/common"), qn = 4, Jo = 0, pa = 1, ma = 2;
  function va(Gl) {
    for (var ql = Gl.length; --ql >= 0; ) Gl[ql] = 0;
  }
  var ba = 0, _a = 1, ya = 2, xa = 3, wa = 258, Ta = 29, Sa = 256, Ma = Sa + 1 + Ta, ka = 30, Za = 19, Na = 2 * Ma + 1, Ka = 15, Ja = 16, el = 7, qa = 256, tl = 16, Qa = 17, nl = 18, rl = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], il = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], cl = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], ll = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], al = 512, sl = new Array(2 * (Ma + 2));
  va(sl);
  var dl = new Array(2 * ka);
  va(dl);
  var El = new Array(al);
  va(El);
  var fl = new Array(wa - xa + 1);
  va(fl);
  var Ml = new Array(Ta);
  va(Ml);
  var Sl, ml, Dl, _l = new Array(ka);
  function gl(Gl, ql, Vl, Pl, Ol) {
    this.static_tree = Gl, this.extra_bits = ql, this.extra_base = Vl, this.elems = Pl, this.max_length = Ol, this.has_stree = Gl && Gl.length;
  }
  function Fl(Gl, ql) {
    this.dyn_tree = Gl, this.max_code = 0, this.stat_desc = ql;
  }
  function Nl(Gl) {
    return Gl < 256 ? El[Gl] : El[256 + (Gl >>> 7)];
  }
  function zl(Gl, ql) {
    Gl.pending_buf[Gl.pending++] = 255 & ql, Gl.pending_buf[Gl.pending++] = ql >>> 8 & 255;
  }
  function Zl(Gl, ql, Vl) {
    Gl.bi_valid > Ja - Vl ? (Gl.bi_buf |= ql << Gl.bi_valid & 65535, zl(Gl, Gl.bi_buf), Gl.bi_buf = ql >> Ja - Gl.bi_valid, Gl.bi_valid += Vl - Ja) : (Gl.bi_buf |= ql << Gl.bi_valid & 65535, Gl.bi_valid += Vl);
  }
  function kl(Gl, ql, Vl) {
    Zl(Gl, Vl[2 * ql], Vl[2 * ql + 1]);
  }
  function ul(Gl, ql) {
    var Vl = 0;
    do
      Vl |= 1 & Gl, Gl >>>= 1, Vl <<= 1;
    while (--ql > 0);
    return Vl >>> 1;
  }
  function vl(Gl) {
    Gl.bi_valid === 16 ? (zl(Gl, Gl.bi_buf), Gl.bi_buf = 0, Gl.bi_valid = 0) : Gl.bi_valid >= 8 && (Gl.pending_buf[Gl.pending++] = 255 & Gl.bi_buf, Gl.bi_buf >>= 8, Gl.bi_valid -= 8);
  }
  function Tl(Gl, ql) {
    var Vl, Pl, Ol, cc, bl, pl, Jl = ql.dyn_tree, Al = ql.max_code, Bl = ql.stat_desc.static_tree, Kl = ql.stat_desc.has_stree, oc = ql.stat_desc.extra_bits, xc = ql.stat_desc.extra_base, vc = ql.stat_desc.max_length, Pc = 0;
    for (cc = 0; cc <= Ka; cc++) Gl.bl_count[cc] = 0;
    for (Jl[2 * Gl.heap[Gl.heap_max] + 1] = 0, Vl = Gl.heap_max + 1; Vl < Na; Vl++) (cc = Jl[2 * Jl[2 * (Pl = Gl.heap[Vl]) + 1] + 1] + 1) > vc && (cc = vc, Pc++), Jl[2 * Pl + 1] = cc, Pl > Al || (Gl.bl_count[cc]++, bl = 0, Pl >= xc && (bl = oc[Pl - xc]), pl = Jl[2 * Pl], Gl.opt_len += pl * (cc + bl), Kl && (Gl.static_len += pl * (Bl[2 * Pl + 1] + bl)));
    if (Pc !== 0) {
      do {
        for (cc = vc - 1; Gl.bl_count[cc] === 0; ) cc--;
        Gl.bl_count[cc]--, Gl.bl_count[cc + 1] += 2, Gl.bl_count[vc]--, Pc -= 2;
      } while (Pc > 0);
      for (cc = vc; cc !== 0; cc--) for (Pl = Gl.bl_count[cc]; Pl !== 0; ) (Ol = Gl.heap[--Vl]) > Al || (Jl[2 * Ol + 1] !== cc && (Gl.opt_len += (cc - Jl[2 * Ol + 1]) * Jl[2 * Ol], Jl[2 * Ol + 1] = cc), Pl--);
    }
  }
  function wl(Gl, ql, Vl) {
    var Pl, Ol, cc = new Array(Ka + 1), bl = 0;
    for (Pl = 1; Pl <= Ka; Pl++) cc[Pl] = bl = bl + Vl[Pl - 1] << 1;
    for (Ol = 0; Ol <= ql; Ol++) {
      var pl = Gl[2 * Ol + 1];
      pl !== 0 && (Gl[2 * Ol] = ul(cc[pl]++, pl));
    }
  }
  function yl() {
    var Gl, ql, Vl, Pl, Ol, cc = new Array(Ka + 1);
    for (Vl = 0, Pl = 0; Pl < Ta - 1; Pl++) for (Ml[Pl] = Vl, Gl = 0; Gl < 1 << rl[Pl]; Gl++) fl[Vl++] = Pl;
    for (fl[Vl - 1] = Pl, Ol = 0, Pl = 0; Pl < 16; Pl++) for (_l[Pl] = Ol, Gl = 0; Gl < 1 << il[Pl]; Gl++) El[Ol++] = Pl;
    for (Ol >>= 7; Pl < ka; Pl++) for (_l[Pl] = Ol << 7, Gl = 0; Gl < 1 << il[Pl] - 7; Gl++) El[256 + Ol++] = Pl;
    for (ql = 0; ql <= Ka; ql++) cc[ql] = 0;
    for (Gl = 0; Gl <= 143; ) sl[2 * Gl + 1] = 8, Gl++, cc[8]++;
    for (; Gl <= 255; ) sl[2 * Gl + 1] = 9, Gl++, cc[9]++;
    for (; Gl <= 279; ) sl[2 * Gl + 1] = 7, Gl++, cc[7]++;
    for (; Gl <= 287; ) sl[2 * Gl + 1] = 8, Gl++, cc[8]++;
    for (wl(sl, Ma + 1, cc), Gl = 0; Gl < ka; Gl++) dl[2 * Gl + 1] = 5, dl[2 * Gl] = ul(Gl, 5);
    Sl = new gl(sl, rl, Sa + 1, Ma, Ka), ml = new gl(dl, il, 0, ka, Ka), Dl = new gl(new Array(0), cl, 0, Za, el);
  }
  function Rl(Gl) {
    var ql;
    for (ql = 0; ql < Ma; ql++) Gl.dyn_ltree[2 * ql] = 0;
    for (ql = 0; ql < ka; ql++) Gl.dyn_dtree[2 * ql] = 0;
    for (ql = 0; ql < Za; ql++) Gl.bl_tree[2 * ql] = 0;
    Gl.dyn_ltree[2 * qa] = 1, Gl.opt_len = Gl.static_len = 0, Gl.last_lit = Gl.matches = 0;
  }
  function Ul(Gl) {
    Gl.bi_valid > 8 ? zl(Gl, Gl.bi_buf) : Gl.bi_valid > 0 && (Gl.pending_buf[Gl.pending++] = Gl.bi_buf), Gl.bi_buf = 0, Gl.bi_valid = 0;
  }
  function hl(Gl, ql, Vl, Pl) {
    Ul(Gl), zl(Gl, Vl), zl(Gl, ~Vl), Kn.arraySet(Gl.pending_buf, Gl.window, ql, Vl, Gl.pending), Gl.pending += Vl;
  }
  function Cl(Gl, ql, Vl, Pl) {
    var Ol = 2 * ql, cc = 2 * Vl;
    return Gl[Ol] < Gl[cc] || Gl[Ol] === Gl[cc] && Pl[ql] <= Pl[Vl];
  }
  function Il(Gl, ql, Vl) {
    for (var Pl = Gl.heap[Vl], Ol = Vl << 1; Ol <= Gl.heap_len && (Ol < Gl.heap_len && Cl(ql, Gl.heap[Ol + 1], Gl.heap[Ol], Gl.depth) && Ol++, !Cl(ql, Pl, Gl.heap[Ol], Gl.depth)); ) Gl.heap[Vl] = Gl.heap[Ol], Vl = Ol, Ol <<= 1;
    Gl.heap[Vl] = Pl;
  }
  function Ll(Gl, ql, Vl) {
    var Pl, Ol, cc, bl, pl = 0;
    if (Gl.last_lit !== 0) do
      Pl = Gl.pending_buf[Gl.d_buf + 2 * pl] << 8 | Gl.pending_buf[Gl.d_buf + 2 * pl + 1], Ol = Gl.pending_buf[Gl.l_buf + pl], pl++, Pl === 0 ? kl(Gl, Ol, ql) : (kl(Gl, (cc = fl[Ol]) + Sa + 1, ql), (bl = rl[cc]) !== 0 && Zl(Gl, Ol -= Ml[cc], bl), kl(Gl, cc = Nl(--Pl), Vl), (bl = il[cc]) !== 0 && Zl(Gl, Pl -= _l[cc], bl));
    while (pl < Gl.last_lit);
    kl(Gl, qa, ql);
  }
  function tc(Gl, ql) {
    var Vl, Pl, Ol, cc = ql.dyn_tree, bl = ql.stat_desc.static_tree, pl = ql.stat_desc.has_stree, Jl = ql.stat_desc.elems, Al = -1;
    for (Gl.heap_len = 0, Gl.heap_max = Na, Vl = 0; Vl < Jl; Vl++) cc[2 * Vl] !== 0 ? (Gl.heap[++Gl.heap_len] = Al = Vl, Gl.depth[Vl] = 0) : cc[2 * Vl + 1] = 0;
    for (; Gl.heap_len < 2; ) cc[2 * (Ol = Gl.heap[++Gl.heap_len] = Al < 2 ? ++Al : 0)] = 1, Gl.depth[Ol] = 0, Gl.opt_len--, pl && (Gl.static_len -= bl[2 * Ol + 1]);
    for (ql.max_code = Al, Vl = Gl.heap_len >> 1; Vl >= 1; Vl--) Il(Gl, cc, Vl);
    Ol = Jl;
    do
      Vl = Gl.heap[1], Gl.heap[1] = Gl.heap[Gl.heap_len--], Il(Gl, cc, 1), Pl = Gl.heap[1], Gl.heap[--Gl.heap_max] = Vl, Gl.heap[--Gl.heap_max] = Pl, cc[2 * Ol] = cc[2 * Vl] + cc[2 * Pl], Gl.depth[Ol] = (Gl.depth[Vl] >= Gl.depth[Pl] ? Gl.depth[Vl] : Gl.depth[Pl]) + 1, cc[2 * Vl + 1] = cc[2 * Pl + 1] = Ol, Gl.heap[1] = Ol++, Il(Gl, cc, 1);
    while (Gl.heap_len >= 2);
    Gl.heap[--Gl.heap_max] = Gl.heap[1], Tl(Gl, ql), wl(cc, Al, Gl.bl_count);
  }
  function nc(Gl, ql, Vl) {
    var Pl, Ol, cc = -1, bl = ql[1], pl = 0, Jl = 7, Al = 4;
    for (bl === 0 && (Jl = 138, Al = 3), ql[2 * (Vl + 1) + 1] = 65535, Pl = 0; Pl <= Vl; Pl++) Ol = bl, bl = ql[2 * (Pl + 1) + 1], ++pl < Jl && Ol === bl || (pl < Al ? Gl.bl_tree[2 * Ol] += pl : Ol !== 0 ? (Ol !== cc && Gl.bl_tree[2 * Ol]++, Gl.bl_tree[2 * tl]++) : pl <= 10 ? Gl.bl_tree[2 * Qa]++ : Gl.bl_tree[2 * nl]++, pl = 0, cc = Ol, bl === 0 ? (Jl = 138, Al = 3) : Ol === bl ? (Jl = 6, Al = 3) : (Jl = 7, Al = 4));
  }
  function uc(Gl, ql, Vl) {
    var Pl, Ol, cc = -1, bl = ql[1], pl = 0, Jl = 7, Al = 4;
    for (bl === 0 && (Jl = 138, Al = 3), Pl = 0; Pl <= Vl; Pl++) if (Ol = bl, bl = ql[2 * (Pl + 1) + 1], !(++pl < Jl && Ol === bl)) {
      if (pl < Al) do
        kl(Gl, Ol, Gl.bl_tree);
      while (--pl != 0);
      else Ol !== 0 ? (Ol !== cc && (kl(Gl, Ol, Gl.bl_tree), pl--), kl(Gl, tl, Gl.bl_tree), Zl(Gl, pl - 3, 2)) : pl <= 10 ? (kl(Gl, Qa, Gl.bl_tree), Zl(Gl, pl - 3, 3)) : (kl(Gl, nl, Gl.bl_tree), Zl(Gl, pl - 11, 7));
      pl = 0, cc = Ol, bl === 0 ? (Jl = 138, Al = 3) : Ol === bl ? (Jl = 6, Al = 3) : (Jl = 7, Al = 4);
    }
  }
  function _c(Gl) {
    var ql;
    for (nc(Gl, Gl.dyn_ltree, Gl.l_desc.max_code), nc(Gl, Gl.dyn_dtree, Gl.d_desc.max_code), tc(Gl, Gl.bl_desc), ql = Za - 1; ql >= 3 && Gl.bl_tree[2 * ll[ql] + 1] === 0; ql--) ;
    return Gl.opt_len += 3 * (ql + 1) + 5 + 5 + 4, ql;
  }
  function mc(Gl, ql, Vl, Pl) {
    var Ol;
    for (Zl(Gl, ql - 257, 5), Zl(Gl, Vl - 1, 5), Zl(Gl, Pl - 4, 4), Ol = 0; Ol < Pl; Ol++) Zl(Gl, Gl.bl_tree[2 * ll[Ol] + 1], 3);
    uc(Gl, Gl.dyn_ltree, ql - 1), uc(Gl, Gl.dyn_dtree, Vl - 1);
  }
  function Sc(Gl) {
    var ql, Vl = 4093624447;
    for (ql = 0; ql <= 31; ql++, Vl >>>= 1) if (1 & Vl && Gl.dyn_ltree[2 * ql] !== 0) return Jo;
    if (Gl.dyn_ltree[18] !== 0 || Gl.dyn_ltree[20] !== 0 || Gl.dyn_ltree[26] !== 0) return pa;
    for (ql = 32; ql < Sa; ql++) if (Gl.dyn_ltree[2 * ql] !== 0) return pa;
    return Jo;
  }
  va(_l);
  var hc = !1;
  function Lc(Gl) {
    hc || (yl(), hc = !0), Gl.l_desc = new Fl(Gl.dyn_ltree, Sl), Gl.d_desc = new Fl(Gl.dyn_dtree, ml), Gl.bl_desc = new Fl(Gl.bl_tree, Dl), Gl.bi_buf = 0, Gl.bi_valid = 0, Rl(Gl);
  }
  function Ec(Gl, ql, Vl, Pl) {
    Zl(Gl, (ba << 1) + (Pl ? 1 : 0), 3), hl(Gl, ql, Vl);
  }
  function Hl(Gl) {
    Zl(Gl, _a << 1, 3), kl(Gl, qa, sl), vl(Gl);
  }
  function fc(Gl, ql, Vl, Pl) {
    var Ol, cc, bl = 0;
    Gl.level > 0 ? (Gl.strm.data_type === ma && (Gl.strm.data_type = Sc(Gl)), tc(Gl, Gl.l_desc), tc(Gl, Gl.d_desc), bl = _c(Gl), Ol = Gl.opt_len + 3 + 7 >>> 3, (cc = Gl.static_len + 3 + 7 >>> 3) <= Ol && (Ol = cc)) : Ol = cc = Vl + 5, Vl + 4 <= Ol && ql !== -1 ? Ec(Gl, ql, Vl, Pl) : Gl.strategy === qn || cc === Ol ? (Zl(Gl, (_a << 1) + (Pl ? 1 : 0), 3), Ll(Gl, sl, dl)) : (Zl(Gl, (ya << 1) + (Pl ? 1 : 0), 3), mc(Gl, Gl.l_desc.max_code + 1, Gl.d_desc.max_code + 1, bl + 1), Ll(Gl, Gl.dyn_ltree, Gl.dyn_dtree)), Rl(Gl), Pl && Ul(Gl);
  }
  function lc(Gl, ql, Vl) {
    return Gl.pending_buf[Gl.d_buf + 2 * Gl.last_lit] = ql >>> 8 & 255, Gl.pending_buf[Gl.d_buf + 2 * Gl.last_lit + 1] = 255 & ql, Gl.pending_buf[Gl.l_buf + Gl.last_lit] = 255 & Vl, Gl.last_lit++, ql === 0 ? Gl.dyn_ltree[2 * Vl]++ : (Gl.matches++, ql--, Gl.dyn_ltree[2 * (fl[Vl] + Sa + 1)]++, Gl.dyn_dtree[2 * Nl(ql)]++), Gl.last_lit === Gl.lit_bufsize - 1;
  }
  Un._tr_init = Lc, Un._tr_stored_block = Ec, Un._tr_flush_block = fc, Un._tr_tally = lc, Un._tr_align = Hl;
}, { "../utils/common": 52 }], 62: [function(Xn, zn, Un) {
  function Kn() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  zn.exports = Kn;
}, {}], 63: [function(Xn, zn, Un) {
  var Kn, qn, Jo = zn.exports = {};
  function pa() {
    throw new Error("setTimeout has not been defined");
  }
  function ma() {
    throw new Error("clearTimeout has not been defined");
  }
  function va(Za) {
    if (Kn === setTimeout) return setTimeout(Za, 0);
    if ((Kn === pa || !Kn) && setTimeout) return Kn = setTimeout, setTimeout(Za, 0);
    try {
      return Kn(Za, 0);
    } catch {
      try {
        return Kn.call(null, Za, 0);
      } catch {
        return Kn.call(this, Za, 0);
      }
    }
  }
  function ba(Za) {
    if (qn === clearTimeout) return clearTimeout(Za);
    if ((qn === ma || !qn) && clearTimeout) return qn = clearTimeout, clearTimeout(Za);
    try {
      return qn(Za);
    } catch {
      try {
        return qn.call(null, Za);
      } catch {
        return qn.call(this, Za);
      }
    }
  }
  (function() {
    try {
      Kn = typeof setTimeout == "function" ? setTimeout : pa;
    } catch {
      Kn = pa;
    }
    try {
      qn = typeof clearTimeout == "function" ? clearTimeout : ma;
    } catch {
      qn = ma;
    }
  })();
  var _a, ya = [], xa = !1, wa = -1;
  function Ta() {
    xa && _a && (xa = !1, _a.length ? ya = _a.concat(ya) : wa = -1, ya.length && Sa());
  }
  function Sa() {
    if (!xa) {
      var Za = va(Ta);
      xa = !0;
      for (var Na = ya.length; Na; ) {
        for (_a = ya, ya = []; ++wa < Na; ) _a && _a[wa].run();
        wa = -1, Na = ya.length;
      }
      _a = null, xa = !1, ba(Za);
    }
  }
  function Ma(Za, Na) {
    this.fun = Za, this.array = Na;
  }
  function ka() {
  }
  Jo.nextTick = function(Za) {
    var Na = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var Ka = 1; Ka < arguments.length; Ka++) Na[Ka - 1] = arguments[Ka];
    ya.push(new Ma(Za, Na)), ya.length !== 1 || xa || va(Sa);
  }, Ma.prototype.run = function() {
    this.fun.apply(null, this.array);
  }, Jo.title = "browser", Jo.browser = !0, Jo.env = {}, Jo.argv = [], Jo.version = "", Jo.versions = {}, Jo.on = ka, Jo.addListener = ka, Jo.once = ka, Jo.off = ka, Jo.removeListener = ka, Jo.removeAllListeners = ka, Jo.emit = ka, Jo.prependListener = ka, Jo.prependOnceListener = ka, Jo.listeners = function(Za) {
    return [];
  }, Jo.binding = function(Za) {
    throw new Error("process.binding is not supported");
  }, Jo.cwd = function() {
    return "/";
  }, Jo.chdir = function(Za) {
    throw new Error("process.chdir is not supported");
  }, Jo.umask = function() {
    return 0;
  };
}, {}], 64: [function(Xn, zn, Un) {
  /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
  var Kn = Xn("buffer"), qn = Kn.Buffer;
  function Jo(ma, va) {
    for (var ba in ma) va[ba] = ma[ba];
  }
  function pa(ma, va, ba) {
    return qn(ma, va, ba);
  }
  qn.from && qn.alloc && qn.allocUnsafe && qn.allocUnsafeSlow ? zn.exports = Kn : (Jo(Kn, Un), Un.Buffer = pa), pa.prototype = Object.create(qn.prototype), Jo(qn, pa), pa.from = function(ma, va, ba) {
    if (typeof ma == "number") throw new TypeError("Argument must not be a number");
    return qn(ma, va, ba);
  }, pa.alloc = function(ma, va, ba) {
    if (typeof ma != "number") throw new TypeError("Argument must be a number");
    var _a = qn(ma);
    return va !== void 0 ? typeof ba == "string" ? _a.fill(va, ba) : _a.fill(va) : _a.fill(0), _a;
  }, pa.allocUnsafe = function(ma) {
    if (typeof ma != "number") throw new TypeError("Argument must be a number");
    return qn(ma);
  }, pa.allocUnsafeSlow = function(ma) {
    if (typeof ma != "number") throw new TypeError("Argument must be a number");
    return Kn.SlowBuffer(ma);
  };
}, { buffer: 32 }], 65: [function(Xn, zn, Un) {
  zn.exports = qn;
  var Kn = Xn("events").EventEmitter;
  function qn() {
    Kn.call(this);
  }
  Xn("inherits")(qn, Kn), qn.Readable = Xn("readable-stream/lib/_stream_readable.js"), qn.Writable = Xn("readable-stream/lib/_stream_writable.js"), qn.Duplex = Xn("readable-stream/lib/_stream_duplex.js"), qn.Transform = Xn("readable-stream/lib/_stream_transform.js"), qn.PassThrough = Xn("readable-stream/lib/_stream_passthrough.js"), qn.finished = Xn("readable-stream/lib/internal/streams/end-of-stream.js"), qn.pipeline = Xn("readable-stream/lib/internal/streams/pipeline.js"), qn.Stream = qn, qn.prototype.pipe = function(Jo, pa) {
    var ma = this;
    function va(Sa) {
      Jo.writable && Jo.write(Sa) === !1 && ma.pause && ma.pause();
    }
    function ba() {
      ma.readable && ma.resume && ma.resume();
    }
    ma.on("data", va), Jo.on("drain", ba), Jo._isStdio || pa && pa.end === !1 || (ma.on("end", ya), ma.on("close", xa));
    var _a = !1;
    function ya() {
      _a || (_a = !0, Jo.end());
    }
    function xa() {
      _a || (_a = !0, typeof Jo.destroy == "function" && Jo.destroy());
    }
    function wa(Sa) {
      if (Ta(), Kn.listenerCount(this, "error") === 0) throw Sa;
    }
    function Ta() {
      ma.removeListener("data", va), Jo.removeListener("drain", ba), ma.removeListener("end", ya), ma.removeListener("close", xa), ma.removeListener("error", wa), Jo.removeListener("error", wa), ma.removeListener("end", Ta), ma.removeListener("close", Ta), Jo.removeListener("close", Ta);
    }
    return ma.on("error", wa), Jo.on("error", wa), ma.on("end", Ta), ma.on("close", Ta), Jo.on("close", Ta), Jo.emit("pipe", ma), Jo;
  };
}, { events: 35, inherits: 46, "readable-stream/lib/_stream_duplex.js": 67, "readable-stream/lib/_stream_passthrough.js": 68, "readable-stream/lib/_stream_readable.js": 69, "readable-stream/lib/_stream_transform.js": 70, "readable-stream/lib/_stream_writable.js": 71, "readable-stream/lib/internal/streams/end-of-stream.js": 75, "readable-stream/lib/internal/streams/pipeline.js": 77 }], 66: [function(Xn, zn, Un) {
  function Kn(_a, ya) {
    _a.prototype = Object.create(ya.prototype), _a.prototype.constructor = _a, _a.__proto__ = ya;
  }
  var qn = {};
  function Jo(_a, ya, xa) {
    function wa(Sa, Ma, ka) {
      return typeof ya == "string" ? ya : ya(Sa, Ma, ka);
    }
    xa || (xa = Error);
    var Ta = function(Sa) {
      function Ma(ka, Za, Na) {
        return Sa.call(this, wa(ka, Za, Na)) || this;
      }
      return Kn(Ma, Sa), Ma;
    }(xa);
    Ta.prototype.name = xa.name, Ta.prototype.code = _a, qn[_a] = Ta;
  }
  function pa(_a, ya) {
    if (Array.isArray(_a)) {
      var xa = _a.length;
      return _a = _a.map(function(wa) {
        return String(wa);
      }), xa > 2 ? "one of ".concat(ya, " ").concat(_a.slice(0, xa - 1).join(", "), ", or ") + _a[xa - 1] : xa === 2 ? "one of ".concat(ya, " ").concat(_a[0], " or ").concat(_a[1]) : "of ".concat(ya, " ").concat(_a[0]);
    }
    return "of ".concat(ya, " ").concat(String(_a));
  }
  function ma(_a, ya, xa) {
    return _a.substr(0, ya.length) === ya;
  }
  function va(_a, ya, xa) {
    return (xa === void 0 || xa > _a.length) && (xa = _a.length), _a.substring(xa - ya.length, xa) === ya;
  }
  function ba(_a, ya, xa) {
    return typeof xa != "number" && (xa = 0), !(xa + ya.length > _a.length) && _a.indexOf(ya, xa) !== -1;
  }
  Jo("ERR_INVALID_OPT_VALUE", function(_a, ya) {
    return 'The value "' + ya + '" is invalid for option "' + _a + '"';
  }, TypeError), Jo("ERR_INVALID_ARG_TYPE", function(_a, ya, xa) {
    var wa, Ta;
    if (typeof ya == "string" && ma(ya, "not ") ? (wa = "must not be", ya = ya.replace(/^not /, "")) : wa = "must be", va(_a, " argument")) Ta = "The ".concat(_a, " ").concat(wa, " ").concat(pa(ya, "type"));
    else {
      var Sa = ba(_a, ".") ? "property" : "argument";
      Ta = 'The "'.concat(_a, '" ').concat(Sa, " ").concat(wa, " ").concat(pa(ya, "type"));
    }
    return Ta += ". Received type ".concat(typeof xa);
  }, TypeError), Jo("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), Jo("ERR_METHOD_NOT_IMPLEMENTED", function(_a) {
    return "The " + _a + " method is not implemented";
  }), Jo("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), Jo("ERR_STREAM_DESTROYED", function(_a) {
    return "Cannot call " + _a + " after a stream was destroyed";
  }), Jo("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), Jo("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), Jo("ERR_STREAM_WRITE_AFTER_END", "write after end"), Jo("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), Jo("ERR_UNKNOWN_ENCODING", function(_a) {
    return "Unknown encoding: " + _a;
  }, TypeError), Jo("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), zn.exports.codes = qn;
}, {}], 67: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = Object.keys || function(wa) {
        var Ta = [];
        for (var Sa in wa) Ta.push(Sa);
        return Ta;
      };
      zn.exports = _a;
      var Jo = Xn("./_stream_readable"), pa = Xn("./_stream_writable");
      Xn("inherits")(_a, Jo);
      for (var ma = qn(pa.prototype), va = 0; va < ma.length; va++) {
        var ba = ma[va];
        _a.prototype[ba] || (_a.prototype[ba] = pa.prototype[ba]);
      }
      function _a(wa) {
        if (!(this instanceof _a)) return new _a(wa);
        Jo.call(this, wa), pa.call(this, wa), this.allowHalfOpen = !0, wa && (wa.readable === !1 && (this.readable = !1), wa.writable === !1 && (this.writable = !1), wa.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", ya)));
      }
      function ya() {
        this._writableState.ended || Kn.nextTick(xa, this);
      }
      function xa(wa) {
        wa.end();
      }
      Object.defineProperty(_a.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
        return this._writableState.highWaterMark;
      } }), Object.defineProperty(_a.prototype, "writableBuffer", { enumerable: !1, get: function() {
        return this._writableState && this._writableState.getBuffer();
      } }), Object.defineProperty(_a.prototype, "writableLength", { enumerable: !1, get: function() {
        return this._writableState.length;
      } }), Object.defineProperty(_a.prototype, "destroyed", { enumerable: !1, get: function() {
        return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
      }, set: function(wa) {
        this._readableState !== void 0 && this._writableState !== void 0 && (this._readableState.destroyed = wa, this._writableState.destroyed = wa);
      } });
    }).call(this);
  }).call(this, Xn("_process"));
}, { "./_stream_readable": 69, "./_stream_writable": 71, _process: 63, inherits: 46 }], 68: [function(Xn, zn, Un) {
  zn.exports = qn;
  var Kn = Xn("./_stream_transform");
  function qn(Jo) {
    if (!(this instanceof qn)) return new qn(Jo);
    Kn.call(this, Jo);
  }
  Xn("inherits")(qn, Kn), qn.prototype._transform = function(Jo, pa, ma) {
    ma(null, Jo);
  };
}, { "./_stream_transform": 70, inherits: 46 }], 69: [function(Xn, zn, Un) {
  (function(Kn, qn) {
    (function() {
      var Jo;
      zn.exports = cl, cl.ReadableState = il, Xn("events").EventEmitter;
      var pa = function(yl, Rl) {
        return yl.listeners(Rl).length;
      }, ma = Xn("./internal/streams/stream"), va = Xn("buffer").Buffer, ba = qn.Uint8Array || function() {
      };
      function _a(yl) {
        return va.from(yl);
      }
      function ya(yl) {
        return va.isBuffer(yl) || yl instanceof ba;
      }
      var xa, wa = Xn("util");
      xa = wa && wa.debuglog ? wa.debuglog("stream") : function() {
      };
      var Ta, Sa, Ma, ka = Xn("./internal/streams/buffer_list"), Za = Xn("./internal/streams/destroy"), Na = Xn("./internal/streams/state").getHighWaterMark, Ka = Xn("../errors").codes, Ja = Ka.ERR_INVALID_ARG_TYPE, el = Ka.ERR_STREAM_PUSH_AFTER_EOF, qa = Ka.ERR_METHOD_NOT_IMPLEMENTED, tl = Ka.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
      Xn("inherits")(cl, ma);
      var Qa = Za.errorOrDestroy, nl = ["error", "close", "destroy", "pause", "resume"];
      function rl(yl, Rl, Ul) {
        if (typeof yl.prependListener == "function") return yl.prependListener(Rl, Ul);
        yl._events && yl._events[Rl] ? Array.isArray(yl._events[Rl]) ? yl._events[Rl].unshift(Ul) : yl._events[Rl] = [Ul, yl._events[Rl]] : yl.on(Rl, Ul);
      }
      function il(yl, Rl, Ul) {
        Jo = Jo || Xn("./_stream_duplex"), yl = yl || {}, typeof Ul != "boolean" && (Ul = Rl instanceof Jo), this.objectMode = !!yl.objectMode, Ul && (this.objectMode = this.objectMode || !!yl.readableObjectMode), this.highWaterMark = Na(this, yl, "readableHighWaterMark", Ul), this.buffer = new ka(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = yl.emitClose !== !1, this.autoDestroy = !!yl.autoDestroy, this.destroyed = !1, this.defaultEncoding = yl.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, yl.encoding && (Ta || (Ta = Xn("string_decoder/").StringDecoder), this.decoder = new Ta(yl.encoding), this.encoding = yl.encoding);
      }
      function cl(yl) {
        if (Jo = Jo || Xn("./_stream_duplex"), !(this instanceof cl)) return new cl(yl);
        var Rl = this instanceof Jo;
        this._readableState = new il(yl, this, Rl), this.readable = !0, yl && (typeof yl.read == "function" && (this._read = yl.read), typeof yl.destroy == "function" && (this._destroy = yl.destroy)), ma.call(this);
      }
      function ll(yl, Rl, Ul, hl, Cl) {
        xa("readableAddChunk", Rl);
        var Il, Ll = yl._readableState;
        if (Rl === null) Ll.reading = !1, Ml(yl, Ll);
        else if (Cl || (Il = sl(Ll, Rl)), Il) Qa(yl, Il);
        else if (Ll.objectMode || Rl && Rl.length > 0) if (typeof Rl == "string" || Ll.objectMode || Object.getPrototypeOf(Rl) === va.prototype || (Rl = _a(Rl)), hl) Ll.endEmitted ? Qa(yl, new tl()) : al(yl, Ll, Rl, !0);
        else if (Ll.ended) Qa(yl, new el());
        else {
          if (Ll.destroyed) return !1;
          Ll.reading = !1, Ll.decoder && !Ul ? (Rl = Ll.decoder.write(Rl), Ll.objectMode || Rl.length !== 0 ? al(yl, Ll, Rl, !1) : Dl(yl, Ll)) : al(yl, Ll, Rl, !1);
        }
        else hl || (Ll.reading = !1, Dl(yl, Ll));
        return !Ll.ended && (Ll.length < Ll.highWaterMark || Ll.length === 0);
      }
      function al(yl, Rl, Ul, hl) {
        Rl.flowing && Rl.length === 0 && !Rl.sync ? (Rl.awaitDrain = 0, yl.emit("data", Ul)) : (Rl.length += Rl.objectMode ? 1 : Ul.length, hl ? Rl.buffer.unshift(Ul) : Rl.buffer.push(Ul), Rl.needReadable && Sl(yl)), Dl(yl, Rl);
      }
      function sl(yl, Rl) {
        var Ul;
        return ya(Rl) || typeof Rl == "string" || Rl === void 0 || yl.objectMode || (Ul = new Ja("chunk", ["string", "Buffer", "Uint8Array"], Rl)), Ul;
      }
      Object.defineProperty(cl.prototype, "destroyed", { enumerable: !1, get: function() {
        return this._readableState !== void 0 && this._readableState.destroyed;
      }, set: function(yl) {
        this._readableState && (this._readableState.destroyed = yl);
      } }), cl.prototype.destroy = Za.destroy, cl.prototype._undestroy = Za.undestroy, cl.prototype._destroy = function(yl, Rl) {
        Rl(yl);
      }, cl.prototype.push = function(yl, Rl) {
        var Ul, hl = this._readableState;
        return hl.objectMode ? Ul = !0 : typeof yl == "string" && ((Rl = Rl || hl.defaultEncoding) !== hl.encoding && (yl = va.from(yl, Rl), Rl = ""), Ul = !0), ll(this, yl, Rl, !1, Ul);
      }, cl.prototype.unshift = function(yl) {
        return ll(this, yl, null, !0, !1);
      }, cl.prototype.isPaused = function() {
        return this._readableState.flowing === !1;
      }, cl.prototype.setEncoding = function(yl) {
        Ta || (Ta = Xn("string_decoder/").StringDecoder);
        var Rl = new Ta(yl);
        this._readableState.decoder = Rl, this._readableState.encoding = this._readableState.decoder.encoding;
        for (var Ul = this._readableState.buffer.head, hl = ""; Ul !== null; ) hl += Rl.write(Ul.data), Ul = Ul.next;
        return this._readableState.buffer.clear(), hl !== "" && this._readableState.buffer.push(hl), this._readableState.length = hl.length, this;
      };
      var dl = 1073741824;
      function El(yl) {
        return yl >= dl ? yl = dl : (yl--, yl |= yl >>> 1, yl |= yl >>> 2, yl |= yl >>> 4, yl |= yl >>> 8, yl |= yl >>> 16, yl++), yl;
      }
      function fl(yl, Rl) {
        return yl <= 0 || Rl.length === 0 && Rl.ended ? 0 : Rl.objectMode ? 1 : yl != yl ? Rl.flowing && Rl.length ? Rl.buffer.head.data.length : Rl.length : (yl > Rl.highWaterMark && (Rl.highWaterMark = El(yl)), yl <= Rl.length ? yl : Rl.ended ? Rl.length : (Rl.needReadable = !0, 0));
      }
      function Ml(yl, Rl) {
        if (xa("onEofChunk"), !Rl.ended) {
          if (Rl.decoder) {
            var Ul = Rl.decoder.end();
            Ul && Ul.length && (Rl.buffer.push(Ul), Rl.length += Rl.objectMode ? 1 : Ul.length);
          }
          Rl.ended = !0, Rl.sync ? Sl(yl) : (Rl.needReadable = !1, Rl.emittedReadable || (Rl.emittedReadable = !0, ml(yl)));
        }
      }
      function Sl(yl) {
        var Rl = yl._readableState;
        xa("emitReadable", Rl.needReadable, Rl.emittedReadable), Rl.needReadable = !1, Rl.emittedReadable || (xa("emitReadable", Rl.flowing), Rl.emittedReadable = !0, Kn.nextTick(ml, yl));
      }
      function ml(yl) {
        var Rl = yl._readableState;
        xa("emitReadable_", Rl.destroyed, Rl.length, Rl.ended), Rl.destroyed || !Rl.length && !Rl.ended || (yl.emit("readable"), Rl.emittedReadable = !1), Rl.needReadable = !Rl.flowing && !Rl.ended && Rl.length <= Rl.highWaterMark, kl(yl);
      }
      function Dl(yl, Rl) {
        Rl.readingMore || (Rl.readingMore = !0, Kn.nextTick(_l, yl, Rl));
      }
      function _l(yl, Rl) {
        for (; !Rl.reading && !Rl.ended && (Rl.length < Rl.highWaterMark || Rl.flowing && Rl.length === 0); ) {
          var Ul = Rl.length;
          if (xa("maybeReadMore read 0"), yl.read(0), Ul === Rl.length) break;
        }
        Rl.readingMore = !1;
      }
      function gl(yl) {
        return function() {
          var Rl = yl._readableState;
          xa("pipeOnDrain", Rl.awaitDrain), Rl.awaitDrain && Rl.awaitDrain--, Rl.awaitDrain === 0 && pa(yl, "data") && (Rl.flowing = !0, kl(yl));
        };
      }
      function Fl(yl) {
        var Rl = yl._readableState;
        Rl.readableListening = yl.listenerCount("readable") > 0, Rl.resumeScheduled && !Rl.paused ? Rl.flowing = !0 : yl.listenerCount("data") > 0 && yl.resume();
      }
      function Nl(yl) {
        xa("readable nexttick read 0"), yl.read(0);
      }
      function zl(yl, Rl) {
        Rl.resumeScheduled || (Rl.resumeScheduled = !0, Kn.nextTick(Zl, yl, Rl));
      }
      function Zl(yl, Rl) {
        xa("resume", Rl.reading), Rl.reading || yl.read(0), Rl.resumeScheduled = !1, yl.emit("resume"), kl(yl), Rl.flowing && !Rl.reading && yl.read(0);
      }
      function kl(yl) {
        var Rl = yl._readableState;
        for (xa("flow", Rl.flowing); Rl.flowing && yl.read() !== null; ) ;
      }
      function ul(yl, Rl) {
        return Rl.length === 0 ? null : (Rl.objectMode ? Ul = Rl.buffer.shift() : !yl || yl >= Rl.length ? (Ul = Rl.decoder ? Rl.buffer.join("") : Rl.buffer.length === 1 ? Rl.buffer.first() : Rl.buffer.concat(Rl.length), Rl.buffer.clear()) : Ul = Rl.buffer.consume(yl, Rl.decoder), Ul);
        var Ul;
      }
      function vl(yl) {
        var Rl = yl._readableState;
        xa("endReadable", Rl.endEmitted), Rl.endEmitted || (Rl.ended = !0, Kn.nextTick(Tl, Rl, yl));
      }
      function Tl(yl, Rl) {
        if (xa("endReadableNT", yl.endEmitted, yl.length), !yl.endEmitted && yl.length === 0 && (yl.endEmitted = !0, Rl.readable = !1, Rl.emit("end"), yl.autoDestroy)) {
          var Ul = Rl._writableState;
          (!Ul || Ul.autoDestroy && Ul.finished) && Rl.destroy();
        }
      }
      function wl(yl, Rl) {
        for (var Ul = 0, hl = yl.length; Ul < hl; Ul++) if (yl[Ul] === Rl) return Ul;
        return -1;
      }
      cl.prototype.read = function(yl) {
        xa("read", yl), yl = parseInt(yl, 10);
        var Rl = this._readableState, Ul = yl;
        if (yl !== 0 && (Rl.emittedReadable = !1), yl === 0 && Rl.needReadable && ((Rl.highWaterMark !== 0 ? Rl.length >= Rl.highWaterMark : Rl.length > 0) || Rl.ended)) return xa("read: emitReadable", Rl.length, Rl.ended), Rl.length === 0 && Rl.ended ? vl(this) : Sl(this), null;
        if ((yl = fl(yl, Rl)) === 0 && Rl.ended) return Rl.length === 0 && vl(this), null;
        var hl, Cl = Rl.needReadable;
        return xa("need readable", Cl), (Rl.length === 0 || Rl.length - yl < Rl.highWaterMark) && xa("length less than watermark", Cl = !0), Rl.ended || Rl.reading ? xa("reading or ended", Cl = !1) : Cl && (xa("do read"), Rl.reading = !0, Rl.sync = !0, Rl.length === 0 && (Rl.needReadable = !0), this._read(Rl.highWaterMark), Rl.sync = !1, Rl.reading || (yl = fl(Ul, Rl))), (hl = yl > 0 ? ul(yl, Rl) : null) === null ? (Rl.needReadable = Rl.length <= Rl.highWaterMark, yl = 0) : (Rl.length -= yl, Rl.awaitDrain = 0), Rl.length === 0 && (Rl.ended || (Rl.needReadable = !0), Ul !== yl && Rl.ended && vl(this)), hl !== null && this.emit("data", hl), hl;
      }, cl.prototype._read = function(yl) {
        Qa(this, new qa("_read()"));
      }, cl.prototype.pipe = function(yl, Rl) {
        var Ul = this, hl = this._readableState;
        switch (hl.pipesCount) {
          case 0:
            hl.pipes = yl;
            break;
          case 1:
            hl.pipes = [hl.pipes, yl];
            break;
          default:
            hl.pipes.push(yl);
        }
        hl.pipesCount += 1, xa("pipe count=%d opts=%j", hl.pipesCount, Rl);
        var Cl = Rl && Rl.end === !1 || yl === Kn.stdout || yl === Kn.stderr ? Lc : Ll;
        function Il(Ec, Hl) {
          xa("onunpipe"), Ec === Ul && Hl && Hl.hasUnpiped === !1 && (Hl.hasUnpiped = !0, uc());
        }
        function Ll() {
          xa("onend"), yl.end();
        }
        hl.endEmitted ? Kn.nextTick(Cl) : Ul.once("end", Cl), yl.on("unpipe", Il);
        var tc = gl(Ul);
        yl.on("drain", tc);
        var nc = !1;
        function uc() {
          xa("cleanup"), yl.removeListener("close", Sc), yl.removeListener("finish", hc), yl.removeListener("drain", tc), yl.removeListener("error", mc), yl.removeListener("unpipe", Il), Ul.removeListener("end", Ll), Ul.removeListener("end", Lc), Ul.removeListener("data", _c), nc = !0, !hl.awaitDrain || yl._writableState && !yl._writableState.needDrain || tc();
        }
        function _c(Ec) {
          xa("ondata");
          var Hl = yl.write(Ec);
          xa("dest.write", Hl), Hl === !1 && ((hl.pipesCount === 1 && hl.pipes === yl || hl.pipesCount > 1 && wl(hl.pipes, yl) !== -1) && !nc && (xa("false write response, pause", hl.awaitDrain), hl.awaitDrain++), Ul.pause());
        }
        function mc(Ec) {
          xa("onerror", Ec), Lc(), yl.removeListener("error", mc), pa(yl, "error") === 0 && Qa(yl, Ec);
        }
        function Sc() {
          yl.removeListener("finish", hc), Lc();
        }
        function hc() {
          xa("onfinish"), yl.removeListener("close", Sc), Lc();
        }
        function Lc() {
          xa("unpipe"), Ul.unpipe(yl);
        }
        return Ul.on("data", _c), rl(yl, "error", mc), yl.once("close", Sc), yl.once("finish", hc), yl.emit("pipe", Ul), hl.flowing || (xa("pipe resume"), Ul.resume()), yl;
      }, cl.prototype.unpipe = function(yl) {
        var Rl = this._readableState, Ul = { hasUnpiped: !1 };
        if (Rl.pipesCount === 0) return this;
        if (Rl.pipesCount === 1) return yl && yl !== Rl.pipes || (yl || (yl = Rl.pipes), Rl.pipes = null, Rl.pipesCount = 0, Rl.flowing = !1, yl && yl.emit("unpipe", this, Ul)), this;
        if (!yl) {
          var hl = Rl.pipes, Cl = Rl.pipesCount;
          Rl.pipes = null, Rl.pipesCount = 0, Rl.flowing = !1;
          for (var Il = 0; Il < Cl; Il++) hl[Il].emit("unpipe", this, { hasUnpiped: !1 });
          return this;
        }
        var Ll = wl(Rl.pipes, yl);
        return Ll === -1 || (Rl.pipes.splice(Ll, 1), Rl.pipesCount -= 1, Rl.pipesCount === 1 && (Rl.pipes = Rl.pipes[0]), yl.emit("unpipe", this, Ul)), this;
      }, cl.prototype.on = function(yl, Rl) {
        var Ul = ma.prototype.on.call(this, yl, Rl), hl = this._readableState;
        return yl === "data" ? (hl.readableListening = this.listenerCount("readable") > 0, hl.flowing !== !1 && this.resume()) : yl === "readable" && (hl.endEmitted || hl.readableListening || (hl.readableListening = hl.needReadable = !0, hl.flowing = !1, hl.emittedReadable = !1, xa("on readable", hl.length, hl.reading), hl.length ? Sl(this) : hl.reading || Kn.nextTick(Nl, this))), Ul;
      }, cl.prototype.addListener = cl.prototype.on, cl.prototype.removeListener = function(yl, Rl) {
        var Ul = ma.prototype.removeListener.call(this, yl, Rl);
        return yl === "readable" && Kn.nextTick(Fl, this), Ul;
      }, cl.prototype.removeAllListeners = function(yl) {
        var Rl = ma.prototype.removeAllListeners.apply(this, arguments);
        return yl !== "readable" && yl !== void 0 || Kn.nextTick(Fl, this), Rl;
      }, cl.prototype.resume = function() {
        var yl = this._readableState;
        return yl.flowing || (xa("resume"), yl.flowing = !yl.readableListening, zl(this, yl)), yl.paused = !1, this;
      }, cl.prototype.pause = function() {
        return xa("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (xa("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
      }, cl.prototype.wrap = function(yl) {
        var Rl = this, Ul = this._readableState, hl = !1;
        for (var Cl in yl.on("end", function() {
          if (xa("wrapped end"), Ul.decoder && !Ul.ended) {
            var Ll = Ul.decoder.end();
            Ll && Ll.length && Rl.push(Ll);
          }
          Rl.push(null);
        }), yl.on("data", function(Ll) {
          xa("wrapped data"), Ul.decoder && (Ll = Ul.decoder.write(Ll)), Ul.objectMode && Ll == null || (Ul.objectMode || Ll && Ll.length) && (Rl.push(Ll) || (hl = !0, yl.pause()));
        }), yl) this[Cl] === void 0 && typeof yl[Cl] == "function" && (this[Cl] = /* @__PURE__ */ function(Ll) {
          return function() {
            return yl[Ll].apply(yl, arguments);
          };
        }(Cl));
        for (var Il = 0; Il < nl.length; Il++) yl.on(nl[Il], this.emit.bind(this, nl[Il]));
        return this._read = function(Ll) {
          xa("wrapped _read", Ll), hl && (hl = !1, yl.resume());
        }, this;
      }, typeof Symbol == "function" && (cl.prototype[Symbol.asyncIterator] = function() {
        return Sa === void 0 && (Sa = Xn("./internal/streams/async_iterator")), Sa(this);
      }), Object.defineProperty(cl.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
        return this._readableState.highWaterMark;
      } }), Object.defineProperty(cl.prototype, "readableBuffer", { enumerable: !1, get: function() {
        return this._readableState && this._readableState.buffer;
      } }), Object.defineProperty(cl.prototype, "readableFlowing", { enumerable: !1, get: function() {
        return this._readableState.flowing;
      }, set: function(yl) {
        this._readableState && (this._readableState.flowing = yl);
      } }), cl._fromList = ul, Object.defineProperty(cl.prototype, "readableLength", { enumerable: !1, get: function() {
        return this._readableState.length;
      } }), typeof Symbol == "function" && (cl.from = function(yl, Rl) {
        return Ma === void 0 && (Ma = Xn("./internal/streams/from")), Ma(cl, yl, Rl);
      });
    }).call(this);
  }).call(this, Xn("_process"), commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, { "../errors": 66, "./_stream_duplex": 67, "./internal/streams/async_iterator": 72, "./internal/streams/buffer_list": 73, "./internal/streams/destroy": 74, "./internal/streams/from": 76, "./internal/streams/state": 78, "./internal/streams/stream": 79, _process: 63, buffer: 32, events: 35, inherits: 46, "string_decoder/": 80, util: 29 }], 70: [function(Xn, zn, Un) {
  zn.exports = _a;
  var Kn = Xn("../errors").codes, qn = Kn.ERR_METHOD_NOT_IMPLEMENTED, Jo = Kn.ERR_MULTIPLE_CALLBACK, pa = Kn.ERR_TRANSFORM_ALREADY_TRANSFORMING, ma = Kn.ERR_TRANSFORM_WITH_LENGTH_0, va = Xn("./_stream_duplex");
  function ba(wa, Ta) {
    var Sa = this._transformState;
    Sa.transforming = !1;
    var Ma = Sa.writecb;
    if (Ma === null) return this.emit("error", new Jo());
    Sa.writechunk = null, Sa.writecb = null, Ta != null && this.push(Ta), Ma(wa);
    var ka = this._readableState;
    ka.reading = !1, (ka.needReadable || ka.length < ka.highWaterMark) && this._read(ka.highWaterMark);
  }
  function _a(wa) {
    if (!(this instanceof _a)) return new _a(wa);
    va.call(this, wa), this._transformState = { afterTransform: ba.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, wa && (typeof wa.transform == "function" && (this._transform = wa.transform), typeof wa.flush == "function" && (this._flush = wa.flush)), this.on("prefinish", ya);
  }
  function ya() {
    var wa = this;
    typeof this._flush != "function" || this._readableState.destroyed ? xa(this, null, null) : this._flush(function(Ta, Sa) {
      xa(wa, Ta, Sa);
    });
  }
  function xa(wa, Ta, Sa) {
    if (Ta) return wa.emit("error", Ta);
    if (Sa != null && wa.push(Sa), wa._writableState.length) throw new ma();
    if (wa._transformState.transforming) throw new pa();
    return wa.push(null);
  }
  Xn("inherits")(_a, va), _a.prototype.push = function(wa, Ta) {
    return this._transformState.needTransform = !1, va.prototype.push.call(this, wa, Ta);
  }, _a.prototype._transform = function(wa, Ta, Sa) {
    Sa(new qn("_transform()"));
  }, _a.prototype._write = function(wa, Ta, Sa) {
    var Ma = this._transformState;
    if (Ma.writecb = Sa, Ma.writechunk = wa, Ma.writeencoding = Ta, !Ma.transforming) {
      var ka = this._readableState;
      (Ma.needTransform || ka.needReadable || ka.length < ka.highWaterMark) && this._read(ka.highWaterMark);
    }
  }, _a.prototype._read = function(wa) {
    var Ta = this._transformState;
    Ta.writechunk === null || Ta.transforming ? Ta.needTransform = !0 : (Ta.transforming = !0, this._transform(Ta.writechunk, Ta.writeencoding, Ta.afterTransform));
  }, _a.prototype._destroy = function(wa, Ta) {
    va.prototype._destroy.call(this, wa, function(Sa) {
      Ta(Sa);
    });
  };
}, { "../errors": 66, "./_stream_duplex": 67, inherits: 46 }], 71: [function(Xn, zn, Un) {
  (function(Kn, qn) {
    (function() {
      function Jo(kl) {
        var ul = this;
        this.next = null, this.entry = null, this.finish = function() {
          Zl(ul, kl);
        };
      }
      var pa;
      zn.exports = il, il.WritableState = rl;
      var ma = { deprecate: Xn("util-deprecate") }, va = Xn("./internal/streams/stream"), ba = Xn("buffer").Buffer, _a = qn.Uint8Array || function() {
      };
      function ya(kl) {
        return ba.from(kl);
      }
      function xa(kl) {
        return ba.isBuffer(kl) || kl instanceof _a;
      }
      var wa, Ta = Xn("./internal/streams/destroy"), Sa = Xn("./internal/streams/state").getHighWaterMark, Ma = Xn("../errors").codes, ka = Ma.ERR_INVALID_ARG_TYPE, Za = Ma.ERR_METHOD_NOT_IMPLEMENTED, Na = Ma.ERR_MULTIPLE_CALLBACK, Ka = Ma.ERR_STREAM_CANNOT_PIPE, Ja = Ma.ERR_STREAM_DESTROYED, el = Ma.ERR_STREAM_NULL_VALUES, qa = Ma.ERR_STREAM_WRITE_AFTER_END, tl = Ma.ERR_UNKNOWN_ENCODING, Qa = Ta.errorOrDestroy;
      function nl() {
      }
      function rl(kl, ul, vl) {
        pa = pa || Xn("./_stream_duplex"), kl = kl || {}, typeof vl != "boolean" && (vl = ul instanceof pa), this.objectMode = !!kl.objectMode, vl && (this.objectMode = this.objectMode || !!kl.writableObjectMode), this.highWaterMark = Sa(this, kl, "writableHighWaterMark", vl), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var Tl = kl.decodeStrings === !1;
        this.decodeStrings = !Tl, this.defaultEncoding = kl.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(wl) {
          Ml(ul, wl);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = kl.emitClose !== !1, this.autoDestroy = !!kl.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new Jo(this);
      }
      function il(kl) {
        var ul = this instanceof (pa = pa || Xn("./_stream_duplex"));
        if (!ul && !wa.call(il, this)) return new il(kl);
        this._writableState = new rl(kl, this, ul), this.writable = !0, kl && (typeof kl.write == "function" && (this._write = kl.write), typeof kl.writev == "function" && (this._writev = kl.writev), typeof kl.destroy == "function" && (this._destroy = kl.destroy), typeof kl.final == "function" && (this._final = kl.final)), va.call(this);
      }
      function cl(kl, ul) {
        var vl = new qa();
        Qa(kl, vl), Kn.nextTick(ul, vl);
      }
      function ll(kl, ul, vl, Tl) {
        var wl;
        return vl === null ? wl = new el() : typeof vl == "string" || ul.objectMode || (wl = new ka("chunk", ["string", "Buffer"], vl)), !wl || (Qa(kl, wl), Kn.nextTick(Tl, wl), !1);
      }
      function al(kl, ul, vl) {
        return kl.objectMode || kl.decodeStrings === !1 || typeof ul != "string" || (ul = ba.from(ul, vl)), ul;
      }
      function sl(kl, ul, vl, Tl, wl, yl) {
        if (!vl) {
          var Rl = al(ul, Tl, wl);
          Tl !== Rl && (vl = !0, wl = "buffer", Tl = Rl);
        }
        var Ul = ul.objectMode ? 1 : Tl.length;
        ul.length += Ul;
        var hl = ul.length < ul.highWaterMark;
        if (hl || (ul.needDrain = !0), ul.writing || ul.corked) {
          var Cl = ul.lastBufferedRequest;
          ul.lastBufferedRequest = { chunk: Tl, encoding: wl, isBuf: vl, callback: yl, next: null }, Cl ? Cl.next = ul.lastBufferedRequest : ul.bufferedRequest = ul.lastBufferedRequest, ul.bufferedRequestCount += 1;
        } else dl(kl, ul, !1, Ul, Tl, wl, yl);
        return hl;
      }
      function dl(kl, ul, vl, Tl, wl, yl, Rl) {
        ul.writelen = Tl, ul.writecb = Rl, ul.writing = !0, ul.sync = !0, ul.destroyed ? ul.onwrite(new Ja("write")) : vl ? kl._writev(wl, ul.onwrite) : kl._write(wl, yl, ul.onwrite), ul.sync = !1;
      }
      function El(kl, ul, vl, Tl, wl) {
        --ul.pendingcb, vl ? (Kn.nextTick(wl, Tl), Kn.nextTick(Nl, kl, ul), kl._writableState.errorEmitted = !0, Qa(kl, Tl)) : (wl(Tl), kl._writableState.errorEmitted = !0, Qa(kl, Tl), Nl(kl, ul));
      }
      function fl(kl) {
        kl.writing = !1, kl.writecb = null, kl.length -= kl.writelen, kl.writelen = 0;
      }
      function Ml(kl, ul) {
        var vl = kl._writableState, Tl = vl.sync, wl = vl.writecb;
        if (typeof wl != "function") throw new Na();
        if (fl(vl), ul) El(kl, vl, Tl, ul, wl);
        else {
          var yl = _l(vl) || kl.destroyed;
          yl || vl.corked || vl.bufferProcessing || !vl.bufferedRequest || Dl(kl, vl), Tl ? Kn.nextTick(Sl, kl, vl, yl, wl) : Sl(kl, vl, yl, wl);
        }
      }
      function Sl(kl, ul, vl, Tl) {
        vl || ml(kl, ul), ul.pendingcb--, Tl(), Nl(kl, ul);
      }
      function ml(kl, ul) {
        ul.length === 0 && ul.needDrain && (ul.needDrain = !1, kl.emit("drain"));
      }
      function Dl(kl, ul) {
        ul.bufferProcessing = !0;
        var vl = ul.bufferedRequest;
        if (kl._writev && vl && vl.next) {
          var Tl = ul.bufferedRequestCount, wl = new Array(Tl), yl = ul.corkedRequestsFree;
          yl.entry = vl;
          for (var Rl = 0, Ul = !0; vl; ) wl[Rl] = vl, vl.isBuf || (Ul = !1), vl = vl.next, Rl += 1;
          wl.allBuffers = Ul, dl(kl, ul, !0, ul.length, wl, "", yl.finish), ul.pendingcb++, ul.lastBufferedRequest = null, yl.next ? (ul.corkedRequestsFree = yl.next, yl.next = null) : ul.corkedRequestsFree = new Jo(ul), ul.bufferedRequestCount = 0;
        } else {
          for (; vl; ) {
            var hl = vl.chunk, Cl = vl.encoding, Il = vl.callback;
            if (dl(kl, ul, !1, ul.objectMode ? 1 : hl.length, hl, Cl, Il), vl = vl.next, ul.bufferedRequestCount--, ul.writing) break;
          }
          vl === null && (ul.lastBufferedRequest = null);
        }
        ul.bufferedRequest = vl, ul.bufferProcessing = !1;
      }
      function _l(kl) {
        return kl.ending && kl.length === 0 && kl.bufferedRequest === null && !kl.finished && !kl.writing;
      }
      function gl(kl, ul) {
        kl._final(function(vl) {
          ul.pendingcb--, vl && Qa(kl, vl), ul.prefinished = !0, kl.emit("prefinish"), Nl(kl, ul);
        });
      }
      function Fl(kl, ul) {
        ul.prefinished || ul.finalCalled || (typeof kl._final != "function" || ul.destroyed ? (ul.prefinished = !0, kl.emit("prefinish")) : (ul.pendingcb++, ul.finalCalled = !0, Kn.nextTick(gl, kl, ul)));
      }
      function Nl(kl, ul) {
        var vl = _l(ul);
        if (vl && (Fl(kl, ul), ul.pendingcb === 0 && (ul.finished = !0, kl.emit("finish"), ul.autoDestroy))) {
          var Tl = kl._readableState;
          (!Tl || Tl.autoDestroy && Tl.endEmitted) && kl.destroy();
        }
        return vl;
      }
      function zl(kl, ul, vl) {
        ul.ending = !0, Nl(kl, ul), vl && (ul.finished ? Kn.nextTick(vl) : kl.once("finish", vl)), ul.ended = !0, kl.writable = !1;
      }
      function Zl(kl, ul, vl) {
        var Tl = kl.entry;
        for (kl.entry = null; Tl; ) {
          var wl = Tl.callback;
          ul.pendingcb--, wl(vl), Tl = Tl.next;
        }
        ul.corkedRequestsFree.next = kl;
      }
      Xn("inherits")(il, va), rl.prototype.getBuffer = function() {
        for (var kl = this.bufferedRequest, ul = []; kl; ) ul.push(kl), kl = kl.next;
        return ul;
      }, function() {
        try {
          Object.defineProperty(rl.prototype, "buffer", { get: ma.deprecate(function() {
            return this.getBuffer();
          }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
        } catch {
        }
      }(), typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (wa = Function.prototype[Symbol.hasInstance], Object.defineProperty(il, Symbol.hasInstance, { value: function(kl) {
        return !!wa.call(this, kl) || this === il && kl && kl._writableState instanceof rl;
      } })) : wa = function(kl) {
        return kl instanceof this;
      }, il.prototype.pipe = function() {
        Qa(this, new Ka());
      }, il.prototype.write = function(kl, ul, vl) {
        var Tl = this._writableState, wl = !1, yl = !Tl.objectMode && xa(kl);
        return yl && !ba.isBuffer(kl) && (kl = ya(kl)), typeof ul == "function" && (vl = ul, ul = null), yl ? ul = "buffer" : ul || (ul = Tl.defaultEncoding), typeof vl != "function" && (vl = nl), Tl.ending ? cl(this, vl) : (yl || ll(this, Tl, kl, vl)) && (Tl.pendingcb++, wl = sl(this, Tl, yl, kl, ul, vl)), wl;
      }, il.prototype.cork = function() {
        this._writableState.corked++;
      }, il.prototype.uncork = function() {
        var kl = this._writableState;
        kl.corked && (kl.corked--, kl.writing || kl.corked || kl.bufferProcessing || !kl.bufferedRequest || Dl(this, kl));
      }, il.prototype.setDefaultEncoding = function(kl) {
        if (typeof kl == "string" && (kl = kl.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((kl + "").toLowerCase()) > -1)) throw new tl(kl);
        return this._writableState.defaultEncoding = kl, this;
      }, Object.defineProperty(il.prototype, "writableBuffer", { enumerable: !1, get: function() {
        return this._writableState && this._writableState.getBuffer();
      } }), Object.defineProperty(il.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
        return this._writableState.highWaterMark;
      } }), il.prototype._write = function(kl, ul, vl) {
        vl(new Za("_write()"));
      }, il.prototype._writev = null, il.prototype.end = function(kl, ul, vl) {
        var Tl = this._writableState;
        return typeof kl == "function" ? (vl = kl, kl = null, ul = null) : typeof ul == "function" && (vl = ul, ul = null), kl != null && this.write(kl, ul), Tl.corked && (Tl.corked = 1, this.uncork()), Tl.ending || zl(this, Tl, vl), this;
      }, Object.defineProperty(il.prototype, "writableLength", { enumerable: !1, get: function() {
        return this._writableState.length;
      } }), Object.defineProperty(il.prototype, "destroyed", { enumerable: !1, get: function() {
        return this._writableState !== void 0 && this._writableState.destroyed;
      }, set: function(kl) {
        this._writableState && (this._writableState.destroyed = kl);
      } }), il.prototype.destroy = Ta.destroy, il.prototype._undestroy = Ta.undestroy, il.prototype._destroy = function(kl, ul) {
        ul(kl);
      };
    }).call(this);
  }).call(this, Xn("_process"), commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, { "../errors": 66, "./_stream_duplex": 67, "./internal/streams/destroy": 74, "./internal/streams/state": 78, "./internal/streams/stream": 79, _process: 63, buffer: 32, inherits: 46, "util-deprecate": 81 }], 72: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn;
      function Jo(Ja, el, qa) {
        return el in Ja ? Object.defineProperty(Ja, el, { value: qa, enumerable: !0, configurable: !0, writable: !0 }) : Ja[el] = qa, Ja;
      }
      var pa = Xn("./end-of-stream"), ma = Symbol("lastResolve"), va = Symbol("lastReject"), ba = Symbol("error"), _a = Symbol("ended"), ya = Symbol("lastPromise"), xa = Symbol("handlePromise"), wa = Symbol("stream");
      function Ta(Ja, el) {
        return { value: Ja, done: el };
      }
      function Sa(Ja) {
        var el = Ja[ma];
        if (el !== null) {
          var qa = Ja[wa].read();
          qa !== null && (Ja[ya] = null, Ja[ma] = null, Ja[va] = null, el(Ta(qa, !1)));
        }
      }
      function Ma(Ja) {
        Kn.nextTick(Sa, Ja);
      }
      function ka(Ja, el) {
        return function(qa, tl) {
          Ja.then(function() {
            el[_a] ? qa(Ta(void 0, !0)) : el[xa](qa, tl);
          }, tl);
        };
      }
      var Za = Object.getPrototypeOf(function() {
      }), Na = Object.setPrototypeOf((qn = { get stream() {
        return this[wa];
      }, next: function() {
        var Ja = this, el = this[ba];
        if (el !== null) return Promise.reject(el);
        if (this[_a]) return Promise.resolve(Ta(void 0, !0));
        if (this[wa].destroyed) return new Promise(function(nl, rl) {
          Kn.nextTick(function() {
            Ja[ba] ? rl(Ja[ba]) : nl(Ta(void 0, !0));
          });
        });
        var qa, tl = this[ya];
        if (tl) qa = new Promise(ka(tl, this));
        else {
          var Qa = this[wa].read();
          if (Qa !== null) return Promise.resolve(Ta(Qa, !1));
          qa = new Promise(this[xa]);
        }
        return this[ya] = qa, qa;
      } }, Jo(qn, Symbol.asyncIterator, function() {
        return this;
      }), Jo(qn, "return", function() {
        var Ja = this;
        return new Promise(function(el, qa) {
          Ja[wa].destroy(null, function(tl) {
            tl ? qa(tl) : el(Ta(void 0, !0));
          });
        });
      }), qn), Za), Ka = function(Ja) {
        var el, qa = Object.create(Na, (Jo(el = {}, wa, { value: Ja, writable: !0 }), Jo(el, ma, { value: null, writable: !0 }), Jo(el, va, { value: null, writable: !0 }), Jo(el, ba, { value: null, writable: !0 }), Jo(el, _a, { value: Ja._readableState.endEmitted, writable: !0 }), Jo(el, xa, { value: function(tl, Qa) {
          var nl = qa[wa].read();
          nl ? (qa[ya] = null, qa[ma] = null, qa[va] = null, tl(Ta(nl, !1))) : (qa[ma] = tl, qa[va] = Qa);
        }, writable: !0 }), el));
        return qa[ya] = null, pa(Ja, function(tl) {
          if (tl && tl.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var Qa = qa[va];
            return Qa !== null && (qa[ya] = null, qa[ma] = null, qa[va] = null, Qa(tl)), void (qa[ba] = tl);
          }
          var nl = qa[ma];
          nl !== null && (qa[ya] = null, qa[ma] = null, qa[va] = null, nl(Ta(void 0, !0))), qa[_a] = !0;
        }), Ja.on("readable", Ma.bind(null, qa)), qa;
      };
      zn.exports = Ka;
    }).call(this);
  }).call(this, Xn("_process"));
}, { "./end-of-stream": 75, _process: 63 }], 73: [function(Xn, zn, Un) {
  function Kn(wa, Ta) {
    var Sa = Object.keys(wa);
    if (Object.getOwnPropertySymbols) {
      var Ma = Object.getOwnPropertySymbols(wa);
      Ta && (Ma = Ma.filter(function(ka) {
        return Object.getOwnPropertyDescriptor(wa, ka).enumerable;
      })), Sa.push.apply(Sa, Ma);
    }
    return Sa;
  }
  function qn(wa) {
    for (var Ta = 1; Ta < arguments.length; Ta++) {
      var Sa = arguments[Ta] != null ? arguments[Ta] : {};
      Ta % 2 ? Kn(Object(Sa), !0).forEach(function(Ma) {
        Jo(wa, Ma, Sa[Ma]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(wa, Object.getOwnPropertyDescriptors(Sa)) : Kn(Object(Sa)).forEach(function(Ma) {
        Object.defineProperty(wa, Ma, Object.getOwnPropertyDescriptor(Sa, Ma));
      });
    }
    return wa;
  }
  function Jo(wa, Ta, Sa) {
    return Ta in wa ? Object.defineProperty(wa, Ta, { value: Sa, enumerable: !0, configurable: !0, writable: !0 }) : wa[Ta] = Sa, wa;
  }
  function pa(wa, Ta) {
    if (!(wa instanceof Ta)) throw new TypeError("Cannot call a class as a function");
  }
  function ma(wa, Ta) {
    for (var Sa = 0; Sa < Ta.length; Sa++) {
      var Ma = Ta[Sa];
      Ma.enumerable = Ma.enumerable || !1, Ma.configurable = !0, "value" in Ma && (Ma.writable = !0), Object.defineProperty(wa, Ma.key, Ma);
    }
  }
  function va(wa, Ta, Sa) {
    return Ta && ma(wa.prototype, Ta), wa;
  }
  var ba = Xn("buffer").Buffer, _a = Xn("util").inspect, ya = _a && _a.custom || "inspect";
  function xa(wa, Ta, Sa) {
    ba.prototype.copy.call(wa, Ta, Sa);
  }
  zn.exports = function() {
    function wa() {
      pa(this, wa), this.head = null, this.tail = null, this.length = 0;
    }
    return va(wa, [{ key: "push", value: function(Ta) {
      var Sa = { data: Ta, next: null };
      this.length > 0 ? this.tail.next = Sa : this.head = Sa, this.tail = Sa, ++this.length;
    } }, { key: "unshift", value: function(Ta) {
      var Sa = { data: Ta, next: this.head };
      this.length === 0 && (this.tail = Sa), this.head = Sa, ++this.length;
    } }, { key: "shift", value: function() {
      if (this.length !== 0) {
        var Ta = this.head.data;
        return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, Ta;
      }
    } }, { key: "clear", value: function() {
      this.head = this.tail = null, this.length = 0;
    } }, { key: "join", value: function(Ta) {
      if (this.length === 0) return "";
      for (var Sa = this.head, Ma = "" + Sa.data; Sa = Sa.next; ) Ma += Ta + Sa.data;
      return Ma;
    } }, { key: "concat", value: function(Ta) {
      if (this.length === 0) return ba.alloc(0);
      for (var Sa = ba.allocUnsafe(Ta >>> 0), Ma = this.head, ka = 0; Ma; ) xa(Ma.data, Sa, ka), ka += Ma.data.length, Ma = Ma.next;
      return Sa;
    } }, { key: "consume", value: function(Ta, Sa) {
      var Ma;
      return Ta < this.head.data.length ? (Ma = this.head.data.slice(0, Ta), this.head.data = this.head.data.slice(Ta)) : Ma = Ta === this.head.data.length ? this.shift() : Sa ? this._getString(Ta) : this._getBuffer(Ta), Ma;
    } }, { key: "first", value: function() {
      return this.head.data;
    } }, { key: "_getString", value: function(Ta) {
      var Sa = this.head, Ma = 1, ka = Sa.data;
      for (Ta -= ka.length; Sa = Sa.next; ) {
        var Za = Sa.data, Na = Ta > Za.length ? Za.length : Ta;
        if (Na === Za.length ? ka += Za : ka += Za.slice(0, Ta), (Ta -= Na) == 0) {
          Na === Za.length ? (++Ma, Sa.next ? this.head = Sa.next : this.head = this.tail = null) : (this.head = Sa, Sa.data = Za.slice(Na));
          break;
        }
        ++Ma;
      }
      return this.length -= Ma, ka;
    } }, { key: "_getBuffer", value: function(Ta) {
      var Sa = ba.allocUnsafe(Ta), Ma = this.head, ka = 1;
      for (Ma.data.copy(Sa), Ta -= Ma.data.length; Ma = Ma.next; ) {
        var Za = Ma.data, Na = Ta > Za.length ? Za.length : Ta;
        if (Za.copy(Sa, Sa.length - Ta, 0, Na), (Ta -= Na) == 0) {
          Na === Za.length ? (++ka, Ma.next ? this.head = Ma.next : this.head = this.tail = null) : (this.head = Ma, Ma.data = Za.slice(Na));
          break;
        }
        ++ka;
      }
      return this.length -= ka, Sa;
    } }, { key: ya, value: function(Ta, Sa) {
      return _a(this, qn({}, Sa, { depth: 0, customInspect: !1 }));
    } }]), wa;
  }();
}, { buffer: 32, util: 29 }], 74: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      function qn(_a, ya) {
        var xa = this, wa = this._readableState && this._readableState.destroyed, Ta = this._writableState && this._writableState.destroyed;
        return wa || Ta ? (ya ? ya(_a) : _a && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, Kn.nextTick(va, this, _a)) : Kn.nextTick(va, this, _a)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(_a || null, function(Sa) {
          !ya && Sa ? xa._writableState ? xa._writableState.errorEmitted ? Kn.nextTick(pa, xa) : (xa._writableState.errorEmitted = !0, Kn.nextTick(Jo, xa, Sa)) : Kn.nextTick(Jo, xa, Sa) : ya ? (Kn.nextTick(pa, xa), ya(Sa)) : Kn.nextTick(pa, xa);
        }), this);
      }
      function Jo(_a, ya) {
        va(_a, ya), pa(_a);
      }
      function pa(_a) {
        _a._writableState && !_a._writableState.emitClose || _a._readableState && !_a._readableState.emitClose || _a.emit("close");
      }
      function ma() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
      function va(_a, ya) {
        _a.emit("error", ya);
      }
      function ba(_a, ya) {
        var xa = _a._readableState, wa = _a._writableState;
        xa && xa.autoDestroy || wa && wa.autoDestroy ? _a.destroy(ya) : _a.emit("error", ya);
      }
      zn.exports = { destroy: qn, undestroy: ma, errorOrDestroy: ba };
    }).call(this);
  }).call(this, Xn("_process"));
}, { _process: 63 }], 75: [function(Xn, zn, Un) {
  var Kn = Xn("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
  function qn(va) {
    var ba = !1;
    return function() {
      if (!ba) {
        ba = !0;
        for (var _a = arguments.length, ya = new Array(_a), xa = 0; xa < _a; xa++) ya[xa] = arguments[xa];
        va.apply(this, ya);
      }
    };
  }
  function Jo() {
  }
  function pa(va) {
    return va.setHeader && typeof va.abort == "function";
  }
  function ma(va, ba, _a) {
    if (typeof ba == "function") return ma(va, null, ba);
    ba || (ba = {}), _a = qn(_a || Jo);
    var ya = ba.readable || ba.readable !== !1 && va.readable, xa = ba.writable || ba.writable !== !1 && va.writable, wa = function() {
      va.writable || Sa();
    }, Ta = va._writableState && va._writableState.finished, Sa = function() {
      xa = !1, Ta = !0, ya || _a.call(va);
    }, Ma = va._readableState && va._readableState.endEmitted, ka = function() {
      ya = !1, Ma = !0, xa || _a.call(va);
    }, Za = function(Ja) {
      _a.call(va, Ja);
    }, Na = function() {
      var Ja;
      return ya && !Ma ? (va._readableState && va._readableState.ended || (Ja = new Kn()), _a.call(va, Ja)) : xa && !Ta ? (va._writableState && va._writableState.ended || (Ja = new Kn()), _a.call(va, Ja)) : void 0;
    }, Ka = function() {
      va.req.on("finish", Sa);
    };
    return pa(va) ? (va.on("complete", Sa), va.on("abort", Na), va.req ? Ka() : va.on("request", Ka)) : xa && !va._writableState && (va.on("end", wa), va.on("close", wa)), va.on("end", ka), va.on("finish", Sa), ba.error !== !1 && va.on("error", Za), va.on("close", Na), function() {
      va.removeListener("complete", Sa), va.removeListener("abort", Na), va.removeListener("request", Ka), va.req && va.req.removeListener("finish", Sa), va.removeListener("end", wa), va.removeListener("close", wa), va.removeListener("finish", Sa), va.removeListener("end", ka), va.removeListener("error", Za), va.removeListener("close", Na);
    };
  }
  zn.exports = ma;
}, { "../../../errors": 66 }], 76: [function(Xn, zn, Un) {
  zn.exports = function() {
    throw new Error("Readable.from is not available in the browser");
  };
}, {}], 77: [function(Xn, zn, Un) {
  var Kn;
  function qn(Sa) {
    var Ma = !1;
    return function() {
      Ma || (Ma = !0, Sa.apply(void 0, arguments));
    };
  }
  var Jo = Xn("../../../errors").codes, pa = Jo.ERR_MISSING_ARGS, ma = Jo.ERR_STREAM_DESTROYED;
  function va(Sa) {
    if (Sa) throw Sa;
  }
  function ba(Sa) {
    return Sa.setHeader && typeof Sa.abort == "function";
  }
  function _a(Sa, Ma, ka, Za) {
    Za = qn(Za);
    var Na = !1;
    Sa.on("close", function() {
      Na = !0;
    }), Kn === void 0 && (Kn = Xn("./end-of-stream")), Kn(Sa, { readable: Ma, writable: ka }, function(Ja) {
      if (Ja) return Za(Ja);
      Na = !0, Za();
    });
    var Ka = !1;
    return function(Ja) {
      if (!Na && !Ka) return Ka = !0, ba(Sa) ? Sa.abort() : typeof Sa.destroy == "function" ? Sa.destroy() : void Za(Ja || new ma("pipe"));
    };
  }
  function ya(Sa) {
    Sa();
  }
  function xa(Sa, Ma) {
    return Sa.pipe(Ma);
  }
  function wa(Sa) {
    return Sa.length ? typeof Sa[Sa.length - 1] != "function" ? va : Sa.pop() : va;
  }
  function Ta() {
    for (var Sa = arguments.length, Ma = new Array(Sa), ka = 0; ka < Sa; ka++) Ma[ka] = arguments[ka];
    var Za, Na = wa(Ma);
    if (Array.isArray(Ma[0]) && (Ma = Ma[0]), Ma.length < 2) throw new pa("streams");
    var Ka = Ma.map(function(Ja, el) {
      var qa = el < Ma.length - 1;
      return _a(Ja, qa, el > 0, function(tl) {
        Za || (Za = tl), tl && Ka.forEach(ya), qa || (Ka.forEach(ya), Na(Za));
      });
    });
    return Ma.reduce(xa);
  }
  zn.exports = Ta;
}, { "../../../errors": 66, "./end-of-stream": 75 }], 78: [function(Xn, zn, Un) {
  var Kn = Xn("../../../errors").codes.ERR_INVALID_OPT_VALUE;
  function qn(pa, ma, va) {
    return pa.highWaterMark != null ? pa.highWaterMark : ma ? pa[va] : null;
  }
  function Jo(pa, ma, va, ba) {
    var _a = qn(ma, ba, va);
    if (_a != null) {
      if (!isFinite(_a) || Math.floor(_a) !== _a || _a < 0) throw new Kn(ba ? va : "highWaterMark", _a);
      return Math.floor(_a);
    }
    return pa.objectMode ? 16 : 16384;
  }
  zn.exports = { getHighWaterMark: Jo };
}, { "../../../errors": 66 }], 79: [function(Xn, zn, Un) {
  zn.exports = Xn("events").EventEmitter;
}, { events: 35 }], 80: [function(Xn, zn, Un) {
  var Kn = Xn("safe-buffer").Buffer, qn = Kn.isEncoding || function(Ka) {
    switch ((Ka = "" + Ka) && Ka.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function Jo(Ka) {
    if (!Ka) return "utf8";
    for (var Ja; ; ) switch (Ka) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return Ka;
      default:
        if (Ja) return;
        Ka = ("" + Ka).toLowerCase(), Ja = !0;
    }
  }
  function pa(Ka) {
    var Ja = Jo(Ka);
    if (typeof Ja != "string" && (Kn.isEncoding === qn || !qn(Ka))) throw new Error("Unknown encoding: " + Ka);
    return Ja || Ka;
  }
  function ma(Ka) {
    var Ja;
    switch (this.encoding = pa(Ka), this.encoding) {
      case "utf16le":
        this.text = Ta, this.end = Sa, Ja = 4;
        break;
      case "utf8":
        this.fillLast = ya, Ja = 4;
        break;
      case "base64":
        this.text = Ma, this.end = ka, Ja = 3;
        break;
      default:
        return this.write = Za, void (this.end = Na);
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Kn.allocUnsafe(Ja);
  }
  function va(Ka) {
    return Ka <= 127 ? 0 : Ka >> 5 == 6 ? 2 : Ka >> 4 == 14 ? 3 : Ka >> 3 == 30 ? 4 : Ka >> 6 == 2 ? -1 : -2;
  }
  function ba(Ka, Ja, el) {
    var qa = Ja.length - 1;
    if (qa < el) return 0;
    var tl = va(Ja[qa]);
    return tl >= 0 ? (tl > 0 && (Ka.lastNeed = tl - 1), tl) : --qa < el || tl === -2 ? 0 : (tl = va(Ja[qa])) >= 0 ? (tl > 0 && (Ka.lastNeed = tl - 2), tl) : --qa < el || tl === -2 ? 0 : (tl = va(Ja[qa])) >= 0 ? (tl > 0 && (tl === 2 ? tl = 0 : Ka.lastNeed = tl - 3), tl) : 0;
  }
  function _a(Ka, Ja, el) {
    if ((192 & Ja[0]) != 128) return Ka.lastNeed = 0, "�";
    if (Ka.lastNeed > 1 && Ja.length > 1) {
      if ((192 & Ja[1]) != 128) return Ka.lastNeed = 1, "�";
      if (Ka.lastNeed > 2 && Ja.length > 2 && (192 & Ja[2]) != 128) return Ka.lastNeed = 2, "�";
    }
  }
  function ya(Ka) {
    var Ja = this.lastTotal - this.lastNeed, el = _a(this, Ka);
    return el !== void 0 ? el : this.lastNeed <= Ka.length ? (Ka.copy(this.lastChar, Ja, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (Ka.copy(this.lastChar, Ja, 0, Ka.length), void (this.lastNeed -= Ka.length));
  }
  function xa(Ka, Ja) {
    var el = ba(this, Ka, Ja);
    if (!this.lastNeed) return Ka.toString("utf8", Ja);
    this.lastTotal = el;
    var qa = Ka.length - (el - this.lastNeed);
    return Ka.copy(this.lastChar, 0, qa), Ka.toString("utf8", Ja, qa);
  }
  function wa(Ka) {
    var Ja = Ka && Ka.length ? this.write(Ka) : "";
    return this.lastNeed ? Ja + "�" : Ja;
  }
  function Ta(Ka, Ja) {
    if ((Ka.length - Ja) % 2 == 0) {
      var el = Ka.toString("utf16le", Ja);
      if (el) {
        var qa = el.charCodeAt(el.length - 1);
        if (qa >= 55296 && qa <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = Ka[Ka.length - 2], this.lastChar[1] = Ka[Ka.length - 1], el.slice(0, -1);
      }
      return el;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = Ka[Ka.length - 1], Ka.toString("utf16le", Ja, Ka.length - 1);
  }
  function Sa(Ka) {
    var Ja = Ka && Ka.length ? this.write(Ka) : "";
    if (this.lastNeed) {
      var el = this.lastTotal - this.lastNeed;
      return Ja + this.lastChar.toString("utf16le", 0, el);
    }
    return Ja;
  }
  function Ma(Ka, Ja) {
    var el = (Ka.length - Ja) % 3;
    return el === 0 ? Ka.toString("base64", Ja) : (this.lastNeed = 3 - el, this.lastTotal = 3, el === 1 ? this.lastChar[0] = Ka[Ka.length - 1] : (this.lastChar[0] = Ka[Ka.length - 2], this.lastChar[1] = Ka[Ka.length - 1]), Ka.toString("base64", Ja, Ka.length - el));
  }
  function ka(Ka) {
    var Ja = Ka && Ka.length ? this.write(Ka) : "";
    return this.lastNeed ? Ja + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Ja;
  }
  function Za(Ka) {
    return Ka.toString(this.encoding);
  }
  function Na(Ka) {
    return Ka && Ka.length ? this.write(Ka) : "";
  }
  Un.StringDecoder = ma, ma.prototype.write = function(Ka) {
    if (Ka.length === 0) return "";
    var Ja, el;
    if (this.lastNeed) {
      if ((Ja = this.fillLast(Ka)) === void 0) return "";
      el = this.lastNeed, this.lastNeed = 0;
    } else el = 0;
    return el < Ka.length ? Ja ? Ja + this.text(Ka, el) : this.text(Ka, el) : Ja || "";
  }, ma.prototype.end = wa, ma.prototype.text = xa, ma.prototype.fillLast = function(Ka) {
    if (this.lastNeed <= Ka.length) return Ka.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Ka.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, Ka.length), this.lastNeed -= Ka.length;
  };
}, { "safe-buffer": 64 }], 81: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      function qn(pa, ma) {
        if (Jo("noDeprecation")) return pa;
        var va = !1;
        function ba() {
          if (!va) {
            if (Jo("throwDeprecation")) throw new Error(ma);
            Jo("traceDeprecation") ? console.trace(ma) : console.warn(ma), va = !0;
          }
          return pa.apply(this, arguments);
        }
        return ba;
      }
      function Jo(pa) {
        try {
          if (!Kn.localStorage) return !1;
        } catch {
          return !1;
        }
        var ma = Kn.localStorage[pa];
        return ma != null && String(ma).toLowerCase() === "true";
      }
      zn.exports = qn;
    }).call(this);
  }).call(this, commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, {}], 82: [function(Xn, zn, Un) {
  arguments[4][25][0].apply(Un, arguments);
}, { dup: 25 }], 83: [function(Xn, zn, Un) {
  var Kn = Xn("is-arguments"), qn = Xn("is-generator-function"), Jo = Xn("which-typed-array"), pa = Xn("is-typed-array");
  function ma(Ll) {
    return Ll.call.bind(Ll);
  }
  var va = typeof BigInt < "u", ba = typeof Symbol < "u", _a = ma(Object.prototype.toString), ya = ma(Number.prototype.valueOf), xa = ma(String.prototype.valueOf), wa = ma(Boolean.prototype.valueOf);
  if (va) var Ta = ma(BigInt.prototype.valueOf);
  if (ba) var Sa = ma(Symbol.prototype.valueOf);
  function Ma(Ll, tc) {
    if (typeof Ll != "object") return !1;
    try {
      return tc(Ll), !0;
    } catch {
      return !1;
    }
  }
  function ka(Ll) {
    return typeof Promise < "u" && Ll instanceof Promise || Ll !== null && typeof Ll == "object" && typeof Ll.then == "function" && typeof Ll.catch == "function";
  }
  function Za(Ll) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Ll) : pa(Ll) || gl(Ll);
  }
  function Na(Ll) {
    return Jo(Ll) === "Uint8Array";
  }
  function Ka(Ll) {
    return Jo(Ll) === "Uint8ClampedArray";
  }
  function Ja(Ll) {
    return Jo(Ll) === "Uint16Array";
  }
  function el(Ll) {
    return Jo(Ll) === "Uint32Array";
  }
  function qa(Ll) {
    return Jo(Ll) === "Int8Array";
  }
  function tl(Ll) {
    return Jo(Ll) === "Int16Array";
  }
  function Qa(Ll) {
    return Jo(Ll) === "Int32Array";
  }
  function nl(Ll) {
    return Jo(Ll) === "Float32Array";
  }
  function rl(Ll) {
    return Jo(Ll) === "Float64Array";
  }
  function il(Ll) {
    return Jo(Ll) === "BigInt64Array";
  }
  function cl(Ll) {
    return Jo(Ll) === "BigUint64Array";
  }
  function ll(Ll) {
    return _a(Ll) === "[object Map]";
  }
  function al(Ll) {
    return typeof Map < "u" && (ll.working ? ll(Ll) : Ll instanceof Map);
  }
  function sl(Ll) {
    return _a(Ll) === "[object Set]";
  }
  function dl(Ll) {
    return typeof Set < "u" && (sl.working ? sl(Ll) : Ll instanceof Set);
  }
  function El(Ll) {
    return _a(Ll) === "[object WeakMap]";
  }
  function fl(Ll) {
    return typeof WeakMap < "u" && (El.working ? El(Ll) : Ll instanceof WeakMap);
  }
  function Ml(Ll) {
    return _a(Ll) === "[object WeakSet]";
  }
  function Sl(Ll) {
    return Ml(Ll);
  }
  function ml(Ll) {
    return _a(Ll) === "[object ArrayBuffer]";
  }
  function Dl(Ll) {
    return typeof ArrayBuffer < "u" && (ml.working ? ml(Ll) : Ll instanceof ArrayBuffer);
  }
  function _l(Ll) {
    return _a(Ll) === "[object DataView]";
  }
  function gl(Ll) {
    return typeof DataView < "u" && (_l.working ? _l(Ll) : Ll instanceof DataView);
  }
  Un.isArgumentsObject = Kn, Un.isGeneratorFunction = qn, Un.isTypedArray = pa, Un.isPromise = ka, Un.isArrayBufferView = Za, Un.isUint8Array = Na, Un.isUint8ClampedArray = Ka, Un.isUint16Array = Ja, Un.isUint32Array = el, Un.isInt8Array = qa, Un.isInt16Array = tl, Un.isInt32Array = Qa, Un.isFloat32Array = nl, Un.isFloat64Array = rl, Un.isBigInt64Array = il, Un.isBigUint64Array = cl, ll.working = typeof Map < "u" && ll(/* @__PURE__ */ new Map()), Un.isMap = al, sl.working = typeof Set < "u" && sl(/* @__PURE__ */ new Set()), Un.isSet = dl, El.working = typeof WeakMap < "u" && El(/* @__PURE__ */ new WeakMap()), Un.isWeakMap = fl, Ml.working = typeof WeakSet < "u" && Ml(/* @__PURE__ */ new WeakSet()), Un.isWeakSet = Sl, ml.working = typeof ArrayBuffer < "u" && ml(new ArrayBuffer()), Un.isArrayBuffer = Dl, _l.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && _l(new DataView(new ArrayBuffer(1), 0, 1)), Un.isDataView = gl;
  var Fl = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function Nl(Ll) {
    return _a(Ll) === "[object SharedArrayBuffer]";
  }
  function zl(Ll) {
    return Fl !== void 0 && (Nl.working === void 0 && (Nl.working = Nl(new Fl())), Nl.working ? Nl(Ll) : Ll instanceof Fl);
  }
  function Zl(Ll) {
    return _a(Ll) === "[object AsyncFunction]";
  }
  function kl(Ll) {
    return _a(Ll) === "[object Map Iterator]";
  }
  function ul(Ll) {
    return _a(Ll) === "[object Set Iterator]";
  }
  function vl(Ll) {
    return _a(Ll) === "[object Generator]";
  }
  function Tl(Ll) {
    return _a(Ll) === "[object WebAssembly.Module]";
  }
  function wl(Ll) {
    return Ma(Ll, ya);
  }
  function yl(Ll) {
    return Ma(Ll, xa);
  }
  function Rl(Ll) {
    return Ma(Ll, wa);
  }
  function Ul(Ll) {
    return va && Ma(Ll, Ta);
  }
  function hl(Ll) {
    return ba && Ma(Ll, Sa);
  }
  function Cl(Ll) {
    return wl(Ll) || yl(Ll) || Rl(Ll) || Ul(Ll) || hl(Ll);
  }
  function Il(Ll) {
    return typeof Uint8Array < "u" && (Dl(Ll) || zl(Ll));
  }
  Un.isSharedArrayBuffer = zl, Un.isAsyncFunction = Zl, Un.isMapIterator = kl, Un.isSetIterator = ul, Un.isGeneratorObject = vl, Un.isWebAssemblyCompiledModule = Tl, Un.isNumberObject = wl, Un.isStringObject = yl, Un.isBooleanObject = Rl, Un.isBigIntObject = Ul, Un.isSymbolObject = hl, Un.isBoxedPrimitive = Cl, Un.isAnyArrayBuffer = Il, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Ll) {
    Object.defineProperty(Un, Ll, { enumerable: !1, value: function() {
      throw new Error(Ll + " is not supported in userland");
    } });
  });
}, { "is-arguments": 47, "is-generator-function": 49, "is-typed-array": 50, "which-typed-array": 85 }], 84: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = Object.getOwnPropertyDescriptors || function(gl) {
        for (var Fl = Object.keys(gl), Nl = {}, zl = 0; zl < Fl.length; zl++) Nl[Fl[zl]] = Object.getOwnPropertyDescriptor(gl, Fl[zl]);
        return Nl;
      }, Jo = /%[sdj%]/g;
      Un.format = function(gl) {
        if (!tl(gl)) {
          for (var Fl = [], Nl = 0; Nl < arguments.length; Nl++) Fl.push(ba(arguments[Nl]));
          return Fl.join(" ");
        }
        Nl = 1;
        for (var zl = arguments, Zl = zl.length, kl = String(gl).replace(Jo, function(vl) {
          if (vl === "%%") return "%";
          if (Nl >= Zl) return vl;
          switch (vl) {
            case "%s":
              return String(zl[Nl++]);
            case "%d":
              return Number(zl[Nl++]);
            case "%j":
              try {
                return JSON.stringify(zl[Nl++]);
              } catch {
                return "[Circular]";
              }
            default:
              return vl;
          }
        }), ul = zl[Nl]; Nl < Zl; ul = zl[++Nl]) Ja(ul) || !il(ul) ? kl += " " + ul : kl += " " + ba(ul);
        return kl;
      }, Un.deprecate = function(gl, Fl) {
        if (Kn !== void 0 && Kn.noDeprecation === !0) return gl;
        if (Kn === void 0) return function() {
          return Un.deprecate(gl, Fl).apply(this, arguments);
        };
        var Nl = !1;
        function zl() {
          if (!Nl) {
            if (Kn.throwDeprecation) throw new Error(Fl);
            Kn.traceDeprecation ? console.trace(Fl) : console.error(Fl), Nl = !0;
          }
          return gl.apply(this, arguments);
        }
        return zl;
      };
      var pa = {}, ma = /^$/;
      if (Kn.env.NODE_DEBUG) {
        var va = Kn.env.NODE_DEBUG;
        va = va.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), ma = new RegExp("^" + va + "$", "i");
      }
      function ba(gl, Fl) {
        var Nl = { seen: [], stylize: ya };
        return arguments.length >= 3 && (Nl.depth = arguments[2]), arguments.length >= 4 && (Nl.colors = arguments[3]), Ka(Fl) ? Nl.showHidden = Fl : Fl && Un._extend(Nl, Fl), nl(Nl.showHidden) && (Nl.showHidden = !1), nl(Nl.depth) && (Nl.depth = 2), nl(Nl.colors) && (Nl.colors = !1), nl(Nl.customInspect) && (Nl.customInspect = !0), Nl.colors && (Nl.stylize = _a), wa(Nl, gl, Nl.depth);
      }
      function _a(gl, Fl) {
        var Nl = ba.styles[Fl];
        return Nl ? "\x1B[" + ba.colors[Nl][0] + "m" + gl + "\x1B[" + ba.colors[Nl][1] + "m" : gl;
      }
      function ya(gl, Fl) {
        return gl;
      }
      function xa(gl) {
        var Fl = {};
        return gl.forEach(function(Nl, zl) {
          Fl[Nl] = !0;
        }), Fl;
      }
      function wa(gl, Fl, Nl) {
        if (gl.customInspect && Fl && al(Fl.inspect) && Fl.inspect !== Un.inspect && (!Fl.constructor || Fl.constructor.prototype !== Fl)) {
          var zl = Fl.inspect(Nl, gl);
          return tl(zl) || (zl = wa(gl, zl, Nl)), zl;
        }
        var Zl = Ta(gl, Fl);
        if (Zl) return Zl;
        var kl = Object.keys(Fl), ul = xa(kl);
        if (gl.showHidden && (kl = Object.getOwnPropertyNames(Fl)), ll(Fl) && (kl.indexOf("message") >= 0 || kl.indexOf("description") >= 0)) return Sa(Fl);
        if (kl.length === 0) {
          if (al(Fl)) {
            var vl = Fl.name ? ": " + Fl.name : "";
            return gl.stylize("[Function" + vl + "]", "special");
          }
          if (rl(Fl)) return gl.stylize(RegExp.prototype.toString.call(Fl), "regexp");
          if (cl(Fl)) return gl.stylize(Date.prototype.toString.call(Fl), "date");
          if (ll(Fl)) return Sa(Fl);
        }
        var Tl, wl = "", yl = !1, Rl = ["{", "}"];
        return Na(Fl) && (yl = !0, Rl = ["[", "]"]), al(Fl) && (wl = " [Function" + (Fl.name ? ": " + Fl.name : "") + "]"), rl(Fl) && (wl = " " + RegExp.prototype.toString.call(Fl)), cl(Fl) && (wl = " " + Date.prototype.toUTCString.call(Fl)), ll(Fl) && (wl = " " + Sa(Fl)), kl.length !== 0 || yl && Fl.length != 0 ? Nl < 0 ? rl(Fl) ? gl.stylize(RegExp.prototype.toString.call(Fl), "regexp") : gl.stylize("[Object]", "special") : (gl.seen.push(Fl), Tl = yl ? Ma(gl, Fl, Nl, ul, kl) : kl.map(function(Ul) {
          return ka(gl, Fl, Nl, ul, Ul, yl);
        }), gl.seen.pop(), Za(Tl, wl, Rl)) : Rl[0] + wl + Rl[1];
      }
      function Ta(gl, Fl) {
        if (nl(Fl)) return gl.stylize("undefined", "undefined");
        if (tl(Fl)) {
          var Nl = "'" + JSON.stringify(Fl).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return gl.stylize(Nl, "string");
        }
        return qa(Fl) ? gl.stylize("" + Fl, "number") : Ka(Fl) ? gl.stylize("" + Fl, "boolean") : Ja(Fl) ? gl.stylize("null", "null") : void 0;
      }
      function Sa(gl) {
        return "[" + Error.prototype.toString.call(gl) + "]";
      }
      function Ma(gl, Fl, Nl, zl, Zl) {
        for (var kl = [], ul = 0, vl = Fl.length; ul < vl; ++ul) Sl(Fl, String(ul)) ? kl.push(ka(gl, Fl, Nl, zl, String(ul), !0)) : kl.push("");
        return Zl.forEach(function(Tl) {
          Tl.match(/^\d+$/) || kl.push(ka(gl, Fl, Nl, zl, Tl, !0));
        }), kl;
      }
      function ka(gl, Fl, Nl, zl, Zl, kl) {
        var ul, vl, Tl;
        if ((Tl = Object.getOwnPropertyDescriptor(Fl, Zl) || { value: Fl[Zl] }).get ? vl = Tl.set ? gl.stylize("[Getter/Setter]", "special") : gl.stylize("[Getter]", "special") : Tl.set && (vl = gl.stylize("[Setter]", "special")), Sl(zl, Zl) || (ul = "[" + Zl + "]"), vl || (gl.seen.indexOf(Tl.value) < 0 ? (vl = Ja(Nl) ? wa(gl, Tl.value, null) : wa(gl, Tl.value, Nl - 1)).indexOf(`
`) > -1 && (vl = kl ? vl.split(`
`).map(function(wl) {
          return "  " + wl;
        }).join(`
`).slice(2) : `
` + vl.split(`
`).map(function(wl) {
          return "   " + wl;
        }).join(`
`)) : vl = gl.stylize("[Circular]", "special")), nl(ul)) {
          if (kl && Zl.match(/^\d+$/)) return vl;
          (ul = JSON.stringify("" + Zl)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (ul = ul.slice(1, -1), ul = gl.stylize(ul, "name")) : (ul = ul.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), ul = gl.stylize(ul, "string"));
        }
        return ul + ": " + vl;
      }
      function Za(gl, Fl, Nl) {
        return gl.reduce(function(zl, Zl) {
          return Zl.indexOf(`
`), zl + Zl.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60 ? Nl[0] + (Fl === "" ? "" : Fl + `
 `) + " " + gl.join(`,
  `) + " " + Nl[1] : Nl[0] + Fl + " " + gl.join(", ") + " " + Nl[1];
      }
      function Na(gl) {
        return Array.isArray(gl);
      }
      function Ka(gl) {
        return typeof gl == "boolean";
      }
      function Ja(gl) {
        return gl === null;
      }
      function el(gl) {
        return gl == null;
      }
      function qa(gl) {
        return typeof gl == "number";
      }
      function tl(gl) {
        return typeof gl == "string";
      }
      function Qa(gl) {
        return typeof gl == "symbol";
      }
      function nl(gl) {
        return gl === void 0;
      }
      function rl(gl) {
        return il(gl) && dl(gl) === "[object RegExp]";
      }
      function il(gl) {
        return typeof gl == "object" && gl !== null;
      }
      function cl(gl) {
        return il(gl) && dl(gl) === "[object Date]";
      }
      function ll(gl) {
        return il(gl) && (dl(gl) === "[object Error]" || gl instanceof Error);
      }
      function al(gl) {
        return typeof gl == "function";
      }
      function sl(gl) {
        return gl === null || typeof gl == "boolean" || typeof gl == "number" || typeof gl == "string" || typeof gl == "symbol" || gl === void 0;
      }
      function dl(gl) {
        return Object.prototype.toString.call(gl);
      }
      function El(gl) {
        return gl < 10 ? "0" + gl.toString(10) : gl.toString(10);
      }
      Un.debuglog = function(gl) {
        if (gl = gl.toUpperCase(), !pa[gl]) if (ma.test(gl)) {
          var Fl = Kn.pid;
          pa[gl] = function() {
            var Nl = Un.format.apply(Un, arguments);
            console.error("%s %d: %s", gl, Fl, Nl);
          };
        } else pa[gl] = function() {
        };
        return pa[gl];
      }, Un.inspect = ba, ba.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, ba.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, Un.types = Xn("./support/types"), Un.isArray = Na, Un.isBoolean = Ka, Un.isNull = Ja, Un.isNullOrUndefined = el, Un.isNumber = qa, Un.isString = tl, Un.isSymbol = Qa, Un.isUndefined = nl, Un.isRegExp = rl, Un.types.isRegExp = rl, Un.isObject = il, Un.isDate = cl, Un.types.isDate = cl, Un.isError = ll, Un.types.isNativeError = ll, Un.isFunction = al, Un.isPrimitive = sl, Un.isBuffer = Xn("./support/isBuffer");
      var fl = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      function Ml() {
        var gl = /* @__PURE__ */ new Date(), Fl = [El(gl.getHours()), El(gl.getMinutes()), El(gl.getSeconds())].join(":");
        return [gl.getDate(), fl[gl.getMonth()], Fl].join(" ");
      }
      function Sl(gl, Fl) {
        return Object.prototype.hasOwnProperty.call(gl, Fl);
      }
      Un.log = function() {
        console.log("%s - %s", Ml(), Un.format.apply(Un, arguments));
      }, Un.inherits = Xn("inherits"), Un._extend = function(gl, Fl) {
        if (!Fl || !il(Fl)) return gl;
        for (var Nl = Object.keys(Fl), zl = Nl.length; zl--; ) gl[Nl[zl]] = Fl[Nl[zl]];
        return gl;
      };
      var ml = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
      function Dl(gl, Fl) {
        if (!gl) {
          var Nl = new Error("Promise was rejected with a falsy value");
          Nl.reason = gl, gl = Nl;
        }
        return Fl(gl);
      }
      function _l(gl) {
        if (typeof gl != "function") throw new TypeError('The "original" argument must be of type Function');
        function Fl() {
          for (var Nl = [], zl = 0; zl < arguments.length; zl++) Nl.push(arguments[zl]);
          var Zl = Nl.pop();
          if (typeof Zl != "function") throw new TypeError("The last argument must be of type Function");
          var kl = this, ul = function() {
            return Zl.apply(kl, arguments);
          };
          gl.apply(this, Nl).then(function(vl) {
            Kn.nextTick(ul.bind(null, null, vl));
          }, function(vl) {
            Kn.nextTick(Dl.bind(null, vl, ul));
          });
        }
        return Object.setPrototypeOf(Fl, Object.getPrototypeOf(gl)), Object.defineProperties(Fl, qn(gl)), Fl;
      }
      Un.promisify = function(gl) {
        if (typeof gl != "function") throw new TypeError('The "original" argument must be of type Function');
        if (ml && gl[ml]) {
          var Fl;
          if (typeof (Fl = gl[ml]) != "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
          return Object.defineProperty(Fl, ml, { value: Fl, enumerable: !1, writable: !1, configurable: !0 }), Fl;
        }
        function Fl() {
          for (var Nl, zl, Zl = new Promise(function(vl, Tl) {
            Nl = vl, zl = Tl;
          }), kl = [], ul = 0; ul < arguments.length; ul++) kl.push(arguments[ul]);
          kl.push(function(vl, Tl) {
            vl ? zl(vl) : Nl(Tl);
          });
          try {
            gl.apply(this, kl);
          } catch (vl) {
            zl(vl);
          }
          return Zl;
        }
        return Object.setPrototypeOf(Fl, Object.getPrototypeOf(gl)), ml && Object.defineProperty(Fl, ml, { value: Fl, enumerable: !1, writable: !1, configurable: !0 }), Object.defineProperties(Fl, qn(gl));
      }, Un.promisify.custom = ml, Un.callbackify = _l;
    }).call(this);
  }).call(this, Xn("_process"));
}, { "./support/isBuffer": 82, "./support/types": 83, _process: 63, inherits: 46 }], 85: [function(Xn, zn, Un) {
  (function(Kn) {
    (function() {
      var qn = Xn("for-each"), Jo = Xn("available-typed-arrays"), pa = Xn("call-bind/callBound"), ma = Xn("gopd"), va = pa("Object.prototype.toString"), ba = Xn("has-tostringtag/shams")(), _a = typeof globalThis > "u" ? Kn : globalThis, ya = Jo(), xa = pa("String.prototype.slice"), wa = {}, Ta = Object.getPrototypeOf;
      ba && ma && Ta && qn(ya, function(ka) {
        if (typeof _a[ka] == "function") {
          var Za = new _a[ka]();
          if (Symbol.toStringTag in Za) {
            var Na = Ta(Za), Ka = ma(Na, Symbol.toStringTag);
            if (!Ka) {
              var Ja = Ta(Na);
              Ka = ma(Ja, Symbol.toStringTag);
            }
            wa[ka] = Ka.get;
          }
        }
      });
      var Sa = function(ka) {
        var Za = !1;
        return qn(wa, function(Na, Ka) {
          if (!Za) try {
            var Ja = Na.call(ka);
            Ja === Ka && (Za = Ja);
          } catch {
          }
        }), Za;
      }, Ma = Xn("is-typed-array");
      zn.exports = function(ka) {
        return !!Ma(ka) && (ba && Symbol.toStringTag in ka ? Sa(ka) : xa(va(ka), 8, -1));
      };
    }).call(this);
  }).call(this, commonjsGlobal !== void 0 ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
}, { "available-typed-arrays": 27, "call-bind/callBound": 33, "for-each": 36, gopd: 40, "has-tostringtag/shams": 43, "is-typed-array": 50 }] }, {}, [20])(20);
var browserExports = browser$1.exports, PNGFilterType, PNGFilterType2, PNGColorType, PNGColorType2;
function png() {
  return { mime: "image/png", hasAlpha: !0, encode: (Xn, { deflateLevel: zn = 9, deflateStrategy: Un = 3, filterType: Kn = PNGFilterType.AUTO, colorType: qn, inputHasAlpha: Jo = !0, ...pa } = {}) => {
    const ma = new browserExports.PNG({ width: Xn.width, height: Xn.height });
    return ma.data = Xn.data, browserExports.PNG.sync.write(ma, { ...pa, deflateLevel: zn, deflateStrategy: Un, filterType: Kn, colorType: qn !== void 0 ? qn : Jo ? PNGColorType.COLOR_ALPHA : PNGColorType.COLOR, inputHasAlpha: Jo });
  }, decode: (Xn, zn) => {
    const Un = browserExports.PNG.sync.read(Xn, zn);
    return { data: Un.data, width: Un.width, height: Un.height };
  } };
}
PNGFilterType2 = PNGFilterType || (PNGFilterType = {}), PNGFilterType2[PNGFilterType2.AUTO = -1] = "AUTO", PNGFilterType2[PNGFilterType2.NONE = 0] = "NONE", PNGFilterType2[PNGFilterType2.SUB = 1] = "SUB", PNGFilterType2[PNGFilterType2.UP = 2] = "UP", PNGFilterType2[PNGFilterType2.AVERAGE = 3] = "AVERAGE", PNGFilterType2[PNGFilterType2.PATH = 4] = "PATH", PNGColorType2 = PNGColorType || (PNGColorType = {}), PNGColorType2[PNGColorType2.GRAYSCALE = 0] = "GRAYSCALE", PNGColorType2[PNGColorType2.COLOR = 2] = "COLOR", PNGColorType2[PNGColorType2.GRAYSCALE_ALPHA = 4] = "GRAYSCALE_ALPHA", PNGColorType2[PNGColorType2.COLOR_ALPHA = 6] = "COLOR_ALPHA";
var UTIF = { exports: {} }, common$1 = {}, hasRequiredCommon$1;
function requireCommon$1() {
  return hasRequiredCommon$1 || (hasRequiredCommon$1 = 1, function(Xn) {
    var zn = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function Un(Jo, pa) {
      return Object.prototype.hasOwnProperty.call(Jo, pa);
    }
    Xn.assign = function(Jo) {
      for (var pa = Array.prototype.slice.call(arguments, 1); pa.length; ) {
        var ma = pa.shift();
        if (ma) {
          if (typeof ma != "object") throw new TypeError(ma + "must be non-object");
          for (var va in ma) Un(ma, va) && (Jo[va] = ma[va]);
        }
      }
      return Jo;
    }, Xn.shrinkBuf = function(Jo, pa) {
      return Jo.length === pa ? Jo : Jo.subarray ? Jo.subarray(0, pa) : (Jo.length = pa, Jo);
    };
    var Kn = { arraySet: function(Jo, pa, ma, va, ba) {
      if (pa.subarray && Jo.subarray) Jo.set(pa.subarray(ma, ma + va), ba);
      else for (var _a = 0; _a < va; _a++) Jo[ba + _a] = pa[ma + _a];
    }, flattenChunks: function(Jo) {
      var pa, ma, va, ba, _a, ya;
      for (va = 0, pa = 0, ma = Jo.length; pa < ma; pa++) va += Jo[pa].length;
      for (ya = new Uint8Array(va), ba = 0, pa = 0, ma = Jo.length; pa < ma; pa++) _a = Jo[pa], ya.set(_a, ba), ba += _a.length;
      return ya;
    } }, qn = { arraySet: function(Jo, pa, ma, va, ba) {
      for (var _a = 0; _a < va; _a++) Jo[ba + _a] = pa[ma + _a];
    }, flattenChunks: function(Jo) {
      return [].concat.apply([], Jo);
    } };
    Xn.setTyped = function(Jo) {
      Jo ? (Xn.Buf8 = Uint8Array, Xn.Buf16 = Uint16Array, Xn.Buf32 = Int32Array, Xn.assign(Xn, Kn)) : (Xn.Buf8 = Array, Xn.Buf16 = Array, Xn.Buf32 = Array, Xn.assign(Xn, qn));
    }, Xn.setTyped(zn);
  }(common$1)), common$1;
}
var deflate$1$1 = {}, deflate$2 = {}, trees$1 = {}, hasRequiredTrees$1, adler32_1$1, hasRequiredAdler32$1, crc32_1$1, hasRequiredCrc32$1, messages$1, hasRequiredMessages$1, hasRequiredDeflate$1$1;
function requireTrees$1() {
  if (hasRequiredTrees$1) return trees$1;
  hasRequiredTrees$1 = 1;
  var Xn = requireCommon$1(), zn = 0, Un = 1;
  function Kn(Tl) {
    for (var wl = Tl.length; --wl >= 0; ) Tl[wl] = 0;
  }
  var qn = 0, Jo = 29, pa = 256, ma = pa + 1 + Jo, va = 30, ba = 19, _a = 2 * ma + 1, ya = 15, xa = 16, wa = 7, Ta = 256, Sa = 16, Ma = 17, ka = 18, Za = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], Na = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], Ka = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], Ja = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], el = new Array(2 * (ma + 2));
  Kn(el);
  var qa = new Array(2 * va);
  Kn(qa);
  var tl = new Array(512);
  Kn(tl);
  var Qa = new Array(256);
  Kn(Qa);
  var nl = new Array(Jo);
  Kn(nl);
  var rl, il, cl, ll = new Array(va);
  function al(Tl, wl, yl, Rl, Ul) {
    this.static_tree = Tl, this.extra_bits = wl, this.extra_base = yl, this.elems = Rl, this.max_length = Ul, this.has_stree = Tl && Tl.length;
  }
  function sl(Tl, wl) {
    this.dyn_tree = Tl, this.max_code = 0, this.stat_desc = wl;
  }
  function dl(Tl) {
    return Tl < 256 ? tl[Tl] : tl[256 + (Tl >>> 7)];
  }
  function El(Tl, wl) {
    Tl.pending_buf[Tl.pending++] = 255 & wl, Tl.pending_buf[Tl.pending++] = wl >>> 8 & 255;
  }
  function fl(Tl, wl, yl) {
    Tl.bi_valid > xa - yl ? (Tl.bi_buf |= wl << Tl.bi_valid & 65535, El(Tl, Tl.bi_buf), Tl.bi_buf = wl >> xa - Tl.bi_valid, Tl.bi_valid += yl - xa) : (Tl.bi_buf |= wl << Tl.bi_valid & 65535, Tl.bi_valid += yl);
  }
  function Ml(Tl, wl, yl) {
    fl(Tl, yl[2 * wl], yl[2 * wl + 1]);
  }
  function Sl(Tl, wl) {
    var yl = 0;
    do
      yl |= 1 & Tl, Tl >>>= 1, yl <<= 1;
    while (--wl > 0);
    return yl >>> 1;
  }
  function ml(Tl, wl, yl) {
    var Rl, Ul, hl = new Array(ya + 1), Cl = 0;
    for (Rl = 1; Rl <= ya; Rl++) hl[Rl] = Cl = Cl + yl[Rl - 1] << 1;
    for (Ul = 0; Ul <= wl; Ul++) {
      var Il = Tl[2 * Ul + 1];
      Il !== 0 && (Tl[2 * Ul] = Sl(hl[Il]++, Il));
    }
  }
  function Dl(Tl) {
    var wl;
    for (wl = 0; wl < ma; wl++) Tl.dyn_ltree[2 * wl] = 0;
    for (wl = 0; wl < va; wl++) Tl.dyn_dtree[2 * wl] = 0;
    for (wl = 0; wl < ba; wl++) Tl.bl_tree[2 * wl] = 0;
    Tl.dyn_ltree[2 * Ta] = 1, Tl.opt_len = Tl.static_len = 0, Tl.last_lit = Tl.matches = 0;
  }
  function _l(Tl) {
    Tl.bi_valid > 8 ? El(Tl, Tl.bi_buf) : Tl.bi_valid > 0 && (Tl.pending_buf[Tl.pending++] = Tl.bi_buf), Tl.bi_buf = 0, Tl.bi_valid = 0;
  }
  function gl(Tl, wl, yl, Rl) {
    var Ul = 2 * wl, hl = 2 * yl;
    return Tl[Ul] < Tl[hl] || Tl[Ul] === Tl[hl] && Rl[wl] <= Rl[yl];
  }
  function Fl(Tl, wl, yl) {
    for (var Rl = Tl.heap[yl], Ul = yl << 1; Ul <= Tl.heap_len && (Ul < Tl.heap_len && gl(wl, Tl.heap[Ul + 1], Tl.heap[Ul], Tl.depth) && Ul++, !gl(wl, Rl, Tl.heap[Ul], Tl.depth)); ) Tl.heap[yl] = Tl.heap[Ul], yl = Ul, Ul <<= 1;
    Tl.heap[yl] = Rl;
  }
  function Nl(Tl, wl, yl) {
    var Rl, Ul, hl, Cl, Il = 0;
    if (Tl.last_lit !== 0) do
      Rl = Tl.pending_buf[Tl.d_buf + 2 * Il] << 8 | Tl.pending_buf[Tl.d_buf + 2 * Il + 1], Ul = Tl.pending_buf[Tl.l_buf + Il], Il++, Rl === 0 ? Ml(Tl, Ul, wl) : (Ml(Tl, (hl = Qa[Ul]) + pa + 1, wl), (Cl = Za[hl]) !== 0 && fl(Tl, Ul -= nl[hl], Cl), Ml(Tl, hl = dl(--Rl), yl), (Cl = Na[hl]) !== 0 && fl(Tl, Rl -= ll[hl], Cl));
    while (Il < Tl.last_lit);
    Ml(Tl, Ta, wl);
  }
  function zl(Tl, wl) {
    var yl, Rl, Ul, hl = wl.dyn_tree, Cl = wl.stat_desc.static_tree, Il = wl.stat_desc.has_stree, Ll = wl.stat_desc.elems, tc = -1;
    for (Tl.heap_len = 0, Tl.heap_max = _a, yl = 0; yl < Ll; yl++) hl[2 * yl] !== 0 ? (Tl.heap[++Tl.heap_len] = tc = yl, Tl.depth[yl] = 0) : hl[2 * yl + 1] = 0;
    for (; Tl.heap_len < 2; ) hl[2 * (Ul = Tl.heap[++Tl.heap_len] = tc < 2 ? ++tc : 0)] = 1, Tl.depth[Ul] = 0, Tl.opt_len--, Il && (Tl.static_len -= Cl[2 * Ul + 1]);
    for (wl.max_code = tc, yl = Tl.heap_len >> 1; yl >= 1; yl--) Fl(Tl, hl, yl);
    Ul = Ll;
    do
      yl = Tl.heap[1], Tl.heap[1] = Tl.heap[Tl.heap_len--], Fl(Tl, hl, 1), Rl = Tl.heap[1], Tl.heap[--Tl.heap_max] = yl, Tl.heap[--Tl.heap_max] = Rl, hl[2 * Ul] = hl[2 * yl] + hl[2 * Rl], Tl.depth[Ul] = (Tl.depth[yl] >= Tl.depth[Rl] ? Tl.depth[yl] : Tl.depth[Rl]) + 1, hl[2 * yl + 1] = hl[2 * Rl + 1] = Ul, Tl.heap[1] = Ul++, Fl(Tl, hl, 1);
    while (Tl.heap_len >= 2);
    Tl.heap[--Tl.heap_max] = Tl.heap[1], function(nc, uc) {
      var _c, mc, Sc, hc, Lc, Ec, Hl = uc.dyn_tree, fc = uc.max_code, lc = uc.stat_desc.static_tree, Gl = uc.stat_desc.has_stree, ql = uc.stat_desc.extra_bits, Vl = uc.stat_desc.extra_base, Pl = uc.stat_desc.max_length, Ol = 0;
      for (hc = 0; hc <= ya; hc++) nc.bl_count[hc] = 0;
      for (Hl[2 * nc.heap[nc.heap_max] + 1] = 0, _c = nc.heap_max + 1; _c < _a; _c++) (hc = Hl[2 * Hl[2 * (mc = nc.heap[_c]) + 1] + 1] + 1) > Pl && (hc = Pl, Ol++), Hl[2 * mc + 1] = hc, mc > fc || (nc.bl_count[hc]++, Lc = 0, mc >= Vl && (Lc = ql[mc - Vl]), Ec = Hl[2 * mc], nc.opt_len += Ec * (hc + Lc), Gl && (nc.static_len += Ec * (lc[2 * mc + 1] + Lc)));
      if (Ol !== 0) {
        do {
          for (hc = Pl - 1; nc.bl_count[hc] === 0; ) hc--;
          nc.bl_count[hc]--, nc.bl_count[hc + 1] += 2, nc.bl_count[Pl]--, Ol -= 2;
        } while (Ol > 0);
        for (hc = Pl; hc !== 0; hc--) for (mc = nc.bl_count[hc]; mc !== 0; ) (Sc = nc.heap[--_c]) > fc || (Hl[2 * Sc + 1] !== hc && (nc.opt_len += (hc - Hl[2 * Sc + 1]) * Hl[2 * Sc], Hl[2 * Sc + 1] = hc), mc--);
      }
    }(Tl, wl), ml(hl, tc, Tl.bl_count);
  }
  function Zl(Tl, wl, yl) {
    var Rl, Ul, hl = -1, Cl = wl[1], Il = 0, Ll = 7, tc = 4;
    for (Cl === 0 && (Ll = 138, tc = 3), wl[2 * (yl + 1) + 1] = 65535, Rl = 0; Rl <= yl; Rl++) Ul = Cl, Cl = wl[2 * (Rl + 1) + 1], ++Il < Ll && Ul === Cl || (Il < tc ? Tl.bl_tree[2 * Ul] += Il : Ul !== 0 ? (Ul !== hl && Tl.bl_tree[2 * Ul]++, Tl.bl_tree[2 * Sa]++) : Il <= 10 ? Tl.bl_tree[2 * Ma]++ : Tl.bl_tree[2 * ka]++, Il = 0, hl = Ul, Cl === 0 ? (Ll = 138, tc = 3) : Ul === Cl ? (Ll = 6, tc = 3) : (Ll = 7, tc = 4));
  }
  function kl(Tl, wl, yl) {
    var Rl, Ul, hl = -1, Cl = wl[1], Il = 0, Ll = 7, tc = 4;
    for (Cl === 0 && (Ll = 138, tc = 3), Rl = 0; Rl <= yl; Rl++) if (Ul = Cl, Cl = wl[2 * (Rl + 1) + 1], !(++Il < Ll && Ul === Cl)) {
      if (Il < tc) do
        Ml(Tl, Ul, Tl.bl_tree);
      while (--Il != 0);
      else Ul !== 0 ? (Ul !== hl && (Ml(Tl, Ul, Tl.bl_tree), Il--), Ml(Tl, Sa, Tl.bl_tree), fl(Tl, Il - 3, 2)) : Il <= 10 ? (Ml(Tl, Ma, Tl.bl_tree), fl(Tl, Il - 3, 3)) : (Ml(Tl, ka, Tl.bl_tree), fl(Tl, Il - 11, 7));
      Il = 0, hl = Ul, Cl === 0 ? (Ll = 138, tc = 3) : Ul === Cl ? (Ll = 6, tc = 3) : (Ll = 7, tc = 4);
    }
  }
  Kn(ll);
  var ul = !1;
  function vl(Tl, wl, yl, Rl) {
    fl(Tl, (qn << 1) + (Rl ? 1 : 0), 3), function(Ul, hl, Cl, Il) {
      _l(Ul), El(Ul, Cl), El(Ul, ~Cl), Xn.arraySet(Ul.pending_buf, Ul.window, hl, Cl, Ul.pending), Ul.pending += Cl;
    }(Tl, wl, yl);
  }
  return trees$1._tr_init = function(Tl) {
    ul || (function() {
      var wl, yl, Rl, Ul, hl, Cl = new Array(ya + 1);
      for (Rl = 0, Ul = 0; Ul < Jo - 1; Ul++) for (nl[Ul] = Rl, wl = 0; wl < 1 << Za[Ul]; wl++) Qa[Rl++] = Ul;
      for (Qa[Rl - 1] = Ul, hl = 0, Ul = 0; Ul < 16; Ul++) for (ll[Ul] = hl, wl = 0; wl < 1 << Na[Ul]; wl++) tl[hl++] = Ul;
      for (hl >>= 7; Ul < va; Ul++) for (ll[Ul] = hl << 7, wl = 0; wl < 1 << Na[Ul] - 7; wl++) tl[256 + hl++] = Ul;
      for (yl = 0; yl <= ya; yl++) Cl[yl] = 0;
      for (wl = 0; wl <= 143; ) el[2 * wl + 1] = 8, wl++, Cl[8]++;
      for (; wl <= 255; ) el[2 * wl + 1] = 9, wl++, Cl[9]++;
      for (; wl <= 279; ) el[2 * wl + 1] = 7, wl++, Cl[7]++;
      for (; wl <= 287; ) el[2 * wl + 1] = 8, wl++, Cl[8]++;
      for (ml(el, ma + 1, Cl), wl = 0; wl < va; wl++) qa[2 * wl + 1] = 5, qa[2 * wl] = Sl(wl, 5);
      rl = new al(el, Za, pa + 1, ma, ya), il = new al(qa, Na, 0, va, ya), cl = new al(new Array(0), Ka, 0, ba, wa);
    }(), ul = !0), Tl.l_desc = new sl(Tl.dyn_ltree, rl), Tl.d_desc = new sl(Tl.dyn_dtree, il), Tl.bl_desc = new sl(Tl.bl_tree, cl), Tl.bi_buf = 0, Tl.bi_valid = 0, Dl(Tl);
  }, trees$1._tr_stored_block = vl, trees$1._tr_flush_block = function(Tl, wl, yl, Rl) {
    var Ul, hl, Cl = 0;
    Tl.level > 0 ? (Tl.strm.data_type === 2 && (Tl.strm.data_type = function(Il) {
      var Ll, tc = 4093624447;
      for (Ll = 0; Ll <= 31; Ll++, tc >>>= 1) if (1 & tc && Il.dyn_ltree[2 * Ll] !== 0) return zn;
      if (Il.dyn_ltree[18] !== 0 || Il.dyn_ltree[20] !== 0 || Il.dyn_ltree[26] !== 0) return Un;
      for (Ll = 32; Ll < pa; Ll++) if (Il.dyn_ltree[2 * Ll] !== 0) return Un;
      return zn;
    }(Tl)), zl(Tl, Tl.l_desc), zl(Tl, Tl.d_desc), Cl = function(Il) {
      var Ll;
      for (Zl(Il, Il.dyn_ltree, Il.l_desc.max_code), Zl(Il, Il.dyn_dtree, Il.d_desc.max_code), zl(Il, Il.bl_desc), Ll = ba - 1; Ll >= 3 && Il.bl_tree[2 * Ja[Ll] + 1] === 0; Ll--) ;
      return Il.opt_len += 3 * (Ll + 1) + 5 + 5 + 4, Ll;
    }(Tl), Ul = Tl.opt_len + 3 + 7 >>> 3, (hl = Tl.static_len + 3 + 7 >>> 3) <= Ul && (Ul = hl)) : Ul = hl = yl + 5, yl + 4 <= Ul && wl !== -1 ? vl(Tl, wl, yl, Rl) : Tl.strategy === 4 || hl === Ul ? (fl(Tl, 2 + (Rl ? 1 : 0), 3), Nl(Tl, el, qa)) : (fl(Tl, 4 + (Rl ? 1 : 0), 3), function(Il, Ll, tc, nc) {
      var uc;
      for (fl(Il, Ll - 257, 5), fl(Il, tc - 1, 5), fl(Il, nc - 4, 4), uc = 0; uc < nc; uc++) fl(Il, Il.bl_tree[2 * Ja[uc] + 1], 3);
      kl(Il, Il.dyn_ltree, Ll - 1), kl(Il, Il.dyn_dtree, tc - 1);
    }(Tl, Tl.l_desc.max_code + 1, Tl.d_desc.max_code + 1, Cl + 1), Nl(Tl, Tl.dyn_ltree, Tl.dyn_dtree)), Dl(Tl), Rl && _l(Tl);
  }, trees$1._tr_tally = function(Tl, wl, yl) {
    return Tl.pending_buf[Tl.d_buf + 2 * Tl.last_lit] = wl >>> 8 & 255, Tl.pending_buf[Tl.d_buf + 2 * Tl.last_lit + 1] = 255 & wl, Tl.pending_buf[Tl.l_buf + Tl.last_lit] = 255 & yl, Tl.last_lit++, wl === 0 ? Tl.dyn_ltree[2 * yl]++ : (Tl.matches++, wl--, Tl.dyn_ltree[2 * (Qa[yl] + pa + 1)]++, Tl.dyn_dtree[2 * dl(wl)]++), Tl.last_lit === Tl.lit_bufsize - 1;
  }, trees$1._tr_align = function(Tl) {
    fl(Tl, 2, 3), Ml(Tl, Ta, el), function(wl) {
      wl.bi_valid === 16 ? (El(wl, wl.bi_buf), wl.bi_buf = 0, wl.bi_valid = 0) : wl.bi_valid >= 8 && (wl.pending_buf[wl.pending++] = 255 & wl.bi_buf, wl.bi_buf >>= 8, wl.bi_valid -= 8);
    }(Tl);
  }, trees$1;
}
function requireAdler32$1() {
  return hasRequiredAdler32$1 || (hasRequiredAdler32$1 = 1, adler32_1$1 = function(Xn, zn, Un, Kn) {
    for (var qn = 65535 & Xn, Jo = Xn >>> 16 & 65535, pa = 0; Un !== 0; ) {
      Un -= pa = Un > 2e3 ? 2e3 : Un;
      do
        Jo = Jo + (qn = qn + zn[Kn++] | 0) | 0;
      while (--pa);
      qn %= 65521, Jo %= 65521;
    }
    return qn | Jo << 16;
  }), adler32_1$1;
}
function requireCrc32$1() {
  if (hasRequiredCrc32$1) return crc32_1$1;
  hasRequiredCrc32$1 = 1;
  var Xn = function() {
    for (var zn, Un = [], Kn = 0; Kn < 256; Kn++) {
      zn = Kn;
      for (var qn = 0; qn < 8; qn++) zn = 1 & zn ? 3988292384 ^ zn >>> 1 : zn >>> 1;
      Un[Kn] = zn;
    }
    return Un;
  }();
  return crc32_1$1 = function(zn, Un, Kn, qn) {
    var Jo = Xn, pa = qn + Kn;
    zn ^= -1;
    for (var ma = qn; ma < pa; ma++) zn = zn >>> 8 ^ Jo[255 & (zn ^ Un[ma])];
    return ~zn;
  }, crc32_1$1;
}
function requireMessages$1() {
  return hasRequiredMessages$1 ? messages$1 : (hasRequiredMessages$1 = 1, messages$1 = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" });
}
function requireDeflate$1$1() {
  if (hasRequiredDeflate$1$1) return deflate$2;
  hasRequiredDeflate$1$1 = 1;
  var Xn, zn = requireCommon$1(), Un = requireTrees$1(), Kn = requireAdler32$1(), qn = requireCrc32$1(), Jo = requireMessages$1(), pa = 0, ma = 4, va = 0, ba = -2, _a = -1, ya = 4, xa = 2, wa = 8, Ta = 9, Sa = 286, Ma = 30, ka = 19, Za = 2 * Sa + 1, Na = 15, Ka = 3, Ja = 258, el = Ja + Ka + 1, qa = 42, tl = 103, Qa = 113, nl = 666, rl = 1, il = 2, cl = 3, ll = 4;
  function al(ul, vl) {
    return ul.msg = Jo[vl], vl;
  }
  function sl(ul) {
    return (ul << 1) - (ul > 4 ? 9 : 0);
  }
  function dl(ul) {
    for (var vl = ul.length; --vl >= 0; ) ul[vl] = 0;
  }
  function El(ul) {
    var vl = ul.state, Tl = vl.pending;
    Tl > ul.avail_out && (Tl = ul.avail_out), Tl !== 0 && (zn.arraySet(ul.output, vl.pending_buf, vl.pending_out, Tl, ul.next_out), ul.next_out += Tl, vl.pending_out += Tl, ul.total_out += Tl, ul.avail_out -= Tl, vl.pending -= Tl, vl.pending === 0 && (vl.pending_out = 0));
  }
  function fl(ul, vl) {
    Un._tr_flush_block(ul, ul.block_start >= 0 ? ul.block_start : -1, ul.strstart - ul.block_start, vl), ul.block_start = ul.strstart, El(ul.strm);
  }
  function Ml(ul, vl) {
    ul.pending_buf[ul.pending++] = vl;
  }
  function Sl(ul, vl) {
    ul.pending_buf[ul.pending++] = vl >>> 8 & 255, ul.pending_buf[ul.pending++] = 255 & vl;
  }
  function ml(ul, vl) {
    var Tl, wl, yl = ul.max_chain_length, Rl = ul.strstart, Ul = ul.prev_length, hl = ul.nice_match, Cl = ul.strstart > ul.w_size - el ? ul.strstart - (ul.w_size - el) : 0, Il = ul.window, Ll = ul.w_mask, tc = ul.prev, nc = ul.strstart + Ja, uc = Il[Rl + Ul - 1], _c = Il[Rl + Ul];
    ul.prev_length >= ul.good_match && (yl >>= 2), hl > ul.lookahead && (hl = ul.lookahead);
    do
      if (Il[(Tl = vl) + Ul] === _c && Il[Tl + Ul - 1] === uc && Il[Tl] === Il[Rl] && Il[++Tl] === Il[Rl + 1]) {
        Rl += 2, Tl++;
        do
          ;
        while (Il[++Rl] === Il[++Tl] && Il[++Rl] === Il[++Tl] && Il[++Rl] === Il[++Tl] && Il[++Rl] === Il[++Tl] && Il[++Rl] === Il[++Tl] && Il[++Rl] === Il[++Tl] && Il[++Rl] === Il[++Tl] && Il[++Rl] === Il[++Tl] && Rl < nc);
        if (wl = Ja - (nc - Rl), Rl = nc - Ja, wl > Ul) {
          if (ul.match_start = vl, Ul = wl, wl >= hl) break;
          uc = Il[Rl + Ul - 1], _c = Il[Rl + Ul];
        }
      }
    while ((vl = tc[vl & Ll]) > Cl && --yl != 0);
    return Ul <= ul.lookahead ? Ul : ul.lookahead;
  }
  function Dl(ul) {
    var vl, Tl, wl, yl, Rl, Ul, hl, Cl, Il, Ll, tc = ul.w_size;
    do {
      if (yl = ul.window_size - ul.lookahead - ul.strstart, ul.strstart >= tc + (tc - el)) {
        zn.arraySet(ul.window, ul.window, tc, tc, 0), ul.match_start -= tc, ul.strstart -= tc, ul.block_start -= tc, vl = Tl = ul.hash_size;
        do
          wl = ul.head[--vl], ul.head[vl] = wl >= tc ? wl - tc : 0;
        while (--Tl);
        vl = Tl = tc;
        do
          wl = ul.prev[--vl], ul.prev[vl] = wl >= tc ? wl - tc : 0;
        while (--Tl);
        yl += tc;
      }
      if (ul.strm.avail_in === 0) break;
      if (Ul = ul.strm, hl = ul.window, Cl = ul.strstart + ul.lookahead, Il = yl, Ll = void 0, (Ll = Ul.avail_in) > Il && (Ll = Il), Tl = Ll === 0 ? 0 : (Ul.avail_in -= Ll, zn.arraySet(hl, Ul.input, Ul.next_in, Ll, Cl), Ul.state.wrap === 1 ? Ul.adler = Kn(Ul.adler, hl, Ll, Cl) : Ul.state.wrap === 2 && (Ul.adler = qn(Ul.adler, hl, Ll, Cl)), Ul.next_in += Ll, Ul.total_in += Ll, Ll), ul.lookahead += Tl, ul.lookahead + ul.insert >= Ka) for (Rl = ul.strstart - ul.insert, ul.ins_h = ul.window[Rl], ul.ins_h = (ul.ins_h << ul.hash_shift ^ ul.window[Rl + 1]) & ul.hash_mask; ul.insert && (ul.ins_h = (ul.ins_h << ul.hash_shift ^ ul.window[Rl + Ka - 1]) & ul.hash_mask, ul.prev[Rl & ul.w_mask] = ul.head[ul.ins_h], ul.head[ul.ins_h] = Rl, Rl++, ul.insert--, !(ul.lookahead + ul.insert < Ka)); ) ;
    } while (ul.lookahead < el && ul.strm.avail_in !== 0);
  }
  function _l(ul, vl) {
    for (var Tl, wl; ; ) {
      if (ul.lookahead < el) {
        if (Dl(ul), ul.lookahead < el && vl === pa) return rl;
        if (ul.lookahead === 0) break;
      }
      if (Tl = 0, ul.lookahead >= Ka && (ul.ins_h = (ul.ins_h << ul.hash_shift ^ ul.window[ul.strstart + Ka - 1]) & ul.hash_mask, Tl = ul.prev[ul.strstart & ul.w_mask] = ul.head[ul.ins_h], ul.head[ul.ins_h] = ul.strstart), Tl !== 0 && ul.strstart - Tl <= ul.w_size - el && (ul.match_length = ml(ul, Tl)), ul.match_length >= Ka) if (wl = Un._tr_tally(ul, ul.strstart - ul.match_start, ul.match_length - Ka), ul.lookahead -= ul.match_length, ul.match_length <= ul.max_lazy_match && ul.lookahead >= Ka) {
        ul.match_length--;
        do
          ul.strstart++, ul.ins_h = (ul.ins_h << ul.hash_shift ^ ul.window[ul.strstart + Ka - 1]) & ul.hash_mask, Tl = ul.prev[ul.strstart & ul.w_mask] = ul.head[ul.ins_h], ul.head[ul.ins_h] = ul.strstart;
        while (--ul.match_length != 0);
        ul.strstart++;
      } else ul.strstart += ul.match_length, ul.match_length = 0, ul.ins_h = ul.window[ul.strstart], ul.ins_h = (ul.ins_h << ul.hash_shift ^ ul.window[ul.strstart + 1]) & ul.hash_mask;
      else wl = Un._tr_tally(ul, 0, ul.window[ul.strstart]), ul.lookahead--, ul.strstart++;
      if (wl && (fl(ul, !1), ul.strm.avail_out === 0)) return rl;
    }
    return ul.insert = ul.strstart < Ka - 1 ? ul.strstart : Ka - 1, vl === ma ? (fl(ul, !0), ul.strm.avail_out === 0 ? cl : ll) : ul.last_lit && (fl(ul, !1), ul.strm.avail_out === 0) ? rl : il;
  }
  function gl(ul, vl) {
    for (var Tl, wl, yl; ; ) {
      if (ul.lookahead < el) {
        if (Dl(ul), ul.lookahead < el && vl === pa) return rl;
        if (ul.lookahead === 0) break;
      }
      if (Tl = 0, ul.lookahead >= Ka && (ul.ins_h = (ul.ins_h << ul.hash_shift ^ ul.window[ul.strstart + Ka - 1]) & ul.hash_mask, Tl = ul.prev[ul.strstart & ul.w_mask] = ul.head[ul.ins_h], ul.head[ul.ins_h] = ul.strstart), ul.prev_length = ul.match_length, ul.prev_match = ul.match_start, ul.match_length = Ka - 1, Tl !== 0 && ul.prev_length < ul.max_lazy_match && ul.strstart - Tl <= ul.w_size - el && (ul.match_length = ml(ul, Tl), ul.match_length <= 5 && (ul.strategy === 1 || ul.match_length === Ka && ul.strstart - ul.match_start > 4096) && (ul.match_length = Ka - 1)), ul.prev_length >= Ka && ul.match_length <= ul.prev_length) {
        yl = ul.strstart + ul.lookahead - Ka, wl = Un._tr_tally(ul, ul.strstart - 1 - ul.prev_match, ul.prev_length - Ka), ul.lookahead -= ul.prev_length - 1, ul.prev_length -= 2;
        do
          ++ul.strstart <= yl && (ul.ins_h = (ul.ins_h << ul.hash_shift ^ ul.window[ul.strstart + Ka - 1]) & ul.hash_mask, Tl = ul.prev[ul.strstart & ul.w_mask] = ul.head[ul.ins_h], ul.head[ul.ins_h] = ul.strstart);
        while (--ul.prev_length != 0);
        if (ul.match_available = 0, ul.match_length = Ka - 1, ul.strstart++, wl && (fl(ul, !1), ul.strm.avail_out === 0)) return rl;
      } else if (ul.match_available) {
        if ((wl = Un._tr_tally(ul, 0, ul.window[ul.strstart - 1])) && fl(ul, !1), ul.strstart++, ul.lookahead--, ul.strm.avail_out === 0) return rl;
      } else ul.match_available = 1, ul.strstart++, ul.lookahead--;
    }
    return ul.match_available && (wl = Un._tr_tally(ul, 0, ul.window[ul.strstart - 1]), ul.match_available = 0), ul.insert = ul.strstart < Ka - 1 ? ul.strstart : Ka - 1, vl === ma ? (fl(ul, !0), ul.strm.avail_out === 0 ? cl : ll) : ul.last_lit && (fl(ul, !1), ul.strm.avail_out === 0) ? rl : il;
  }
  function Fl(ul, vl, Tl, wl, yl) {
    this.good_length = ul, this.max_lazy = vl, this.nice_length = Tl, this.max_chain = wl, this.func = yl;
  }
  function Nl() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = wa, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new zn.Buf16(2 * Za), this.dyn_dtree = new zn.Buf16(2 * (2 * Ma + 1)), this.bl_tree = new zn.Buf16(2 * (2 * ka + 1)), dl(this.dyn_ltree), dl(this.dyn_dtree), dl(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new zn.Buf16(Na + 1), this.heap = new zn.Buf16(2 * Sa + 1), dl(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new zn.Buf16(2 * Sa + 1), dl(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function zl(ul) {
    var vl;
    return ul && ul.state ? (ul.total_in = ul.total_out = 0, ul.data_type = xa, (vl = ul.state).pending = 0, vl.pending_out = 0, vl.wrap < 0 && (vl.wrap = -vl.wrap), vl.status = vl.wrap ? qa : Qa, ul.adler = vl.wrap === 2 ? 0 : 1, vl.last_flush = pa, Un._tr_init(vl), va) : al(ul, ba);
  }
  function Zl(ul) {
    var vl = zl(ul);
    return vl === va && function(Tl) {
      Tl.window_size = 2 * Tl.w_size, dl(Tl.head), Tl.max_lazy_match = Xn[Tl.level].max_lazy, Tl.good_match = Xn[Tl.level].good_length, Tl.nice_match = Xn[Tl.level].nice_length, Tl.max_chain_length = Xn[Tl.level].max_chain, Tl.strstart = 0, Tl.block_start = 0, Tl.lookahead = 0, Tl.insert = 0, Tl.match_length = Tl.prev_length = Ka - 1, Tl.match_available = 0, Tl.ins_h = 0;
    }(ul.state), vl;
  }
  function kl(ul, vl, Tl, wl, yl, Rl) {
    if (!ul) return ba;
    var Ul = 1;
    if (vl === _a && (vl = 6), wl < 0 ? (Ul = 0, wl = -wl) : wl > 15 && (Ul = 2, wl -= 16), yl < 1 || yl > Ta || Tl !== wa || wl < 8 || wl > 15 || vl < 0 || vl > 9 || Rl < 0 || Rl > ya) return al(ul, ba);
    wl === 8 && (wl = 9);
    var hl = new Nl();
    return ul.state = hl, hl.strm = ul, hl.wrap = Ul, hl.gzhead = null, hl.w_bits = wl, hl.w_size = 1 << hl.w_bits, hl.w_mask = hl.w_size - 1, hl.hash_bits = yl + 7, hl.hash_size = 1 << hl.hash_bits, hl.hash_mask = hl.hash_size - 1, hl.hash_shift = ~~((hl.hash_bits + Ka - 1) / Ka), hl.window = new zn.Buf8(2 * hl.w_size), hl.head = new zn.Buf16(hl.hash_size), hl.prev = new zn.Buf16(hl.w_size), hl.lit_bufsize = 1 << yl + 6, hl.pending_buf_size = 4 * hl.lit_bufsize, hl.pending_buf = new zn.Buf8(hl.pending_buf_size), hl.d_buf = 1 * hl.lit_bufsize, hl.l_buf = 3 * hl.lit_bufsize, hl.level = vl, hl.strategy = Rl, hl.method = Tl, Zl(ul);
  }
  return Xn = [new Fl(0, 0, 0, 0, function(ul, vl) {
    var Tl = 65535;
    for (Tl > ul.pending_buf_size - 5 && (Tl = ul.pending_buf_size - 5); ; ) {
      if (ul.lookahead <= 1) {
        if (Dl(ul), ul.lookahead === 0 && vl === pa) return rl;
        if (ul.lookahead === 0) break;
      }
      ul.strstart += ul.lookahead, ul.lookahead = 0;
      var wl = ul.block_start + Tl;
      if ((ul.strstart === 0 || ul.strstart >= wl) && (ul.lookahead = ul.strstart - wl, ul.strstart = wl, fl(ul, !1), ul.strm.avail_out === 0) || ul.strstart - ul.block_start >= ul.w_size - el && (fl(ul, !1), ul.strm.avail_out === 0)) return rl;
    }
    return ul.insert = 0, vl === ma ? (fl(ul, !0), ul.strm.avail_out === 0 ? cl : ll) : (ul.strstart > ul.block_start && (fl(ul, !1), ul.strm.avail_out), rl);
  }), new Fl(4, 4, 8, 4, _l), new Fl(4, 5, 16, 8, _l), new Fl(4, 6, 32, 32, _l), new Fl(4, 4, 16, 16, gl), new Fl(8, 16, 32, 32, gl), new Fl(8, 16, 128, 128, gl), new Fl(8, 32, 128, 256, gl), new Fl(32, 128, 258, 1024, gl), new Fl(32, 258, 258, 4096, gl)], deflate$2.deflateInit = function(ul, vl) {
    return kl(ul, vl, wa, 15, 8, 0);
  }, deflate$2.deflateInit2 = kl, deflate$2.deflateReset = Zl, deflate$2.deflateResetKeep = zl, deflate$2.deflateSetHeader = function(ul, vl) {
    return ul && ul.state ? ul.state.wrap !== 2 ? ba : (ul.state.gzhead = vl, va) : ba;
  }, deflate$2.deflate = function(ul, vl) {
    var Tl, wl, yl, Rl;
    if (!ul || !ul.state || vl > 5 || vl < 0) return ul ? al(ul, ba) : ba;
    if (wl = ul.state, !ul.output || !ul.input && ul.avail_in !== 0 || wl.status === nl && vl !== ma) return al(ul, ul.avail_out === 0 ? -5 : ba);
    if (wl.strm = ul, Tl = wl.last_flush, wl.last_flush = vl, wl.status === qa) if (wl.wrap === 2) ul.adler = 0, Ml(wl, 31), Ml(wl, 139), Ml(wl, 8), wl.gzhead ? (Ml(wl, (wl.gzhead.text ? 1 : 0) + (wl.gzhead.hcrc ? 2 : 0) + (wl.gzhead.extra ? 4 : 0) + (wl.gzhead.name ? 8 : 0) + (wl.gzhead.comment ? 16 : 0)), Ml(wl, 255 & wl.gzhead.time), Ml(wl, wl.gzhead.time >> 8 & 255), Ml(wl, wl.gzhead.time >> 16 & 255), Ml(wl, wl.gzhead.time >> 24 & 255), Ml(wl, wl.level === 9 ? 2 : wl.strategy >= 2 || wl.level < 2 ? 4 : 0), Ml(wl, 255 & wl.gzhead.os), wl.gzhead.extra && wl.gzhead.extra.length && (Ml(wl, 255 & wl.gzhead.extra.length), Ml(wl, wl.gzhead.extra.length >> 8 & 255)), wl.gzhead.hcrc && (ul.adler = qn(ul.adler, wl.pending_buf, wl.pending, 0)), wl.gzindex = 0, wl.status = 69) : (Ml(wl, 0), Ml(wl, 0), Ml(wl, 0), Ml(wl, 0), Ml(wl, 0), Ml(wl, wl.level === 9 ? 2 : wl.strategy >= 2 || wl.level < 2 ? 4 : 0), Ml(wl, 3), wl.status = Qa);
    else {
      var Ul = wa + (wl.w_bits - 8 << 4) << 8;
      Ul |= (wl.strategy >= 2 || wl.level < 2 ? 0 : wl.level < 6 ? 1 : wl.level === 6 ? 2 : 3) << 6, wl.strstart !== 0 && (Ul |= 32), Ul += 31 - Ul % 31, wl.status = Qa, Sl(wl, Ul), wl.strstart !== 0 && (Sl(wl, ul.adler >>> 16), Sl(wl, 65535 & ul.adler)), ul.adler = 1;
    }
    if (wl.status === 69) if (wl.gzhead.extra) {
      for (yl = wl.pending; wl.gzindex < (65535 & wl.gzhead.extra.length) && (wl.pending !== wl.pending_buf_size || (wl.gzhead.hcrc && wl.pending > yl && (ul.adler = qn(ul.adler, wl.pending_buf, wl.pending - yl, yl)), El(ul), yl = wl.pending, wl.pending !== wl.pending_buf_size)); ) Ml(wl, 255 & wl.gzhead.extra[wl.gzindex]), wl.gzindex++;
      wl.gzhead.hcrc && wl.pending > yl && (ul.adler = qn(ul.adler, wl.pending_buf, wl.pending - yl, yl)), wl.gzindex === wl.gzhead.extra.length && (wl.gzindex = 0, wl.status = 73);
    } else wl.status = 73;
    if (wl.status === 73) if (wl.gzhead.name) {
      yl = wl.pending;
      do {
        if (wl.pending === wl.pending_buf_size && (wl.gzhead.hcrc && wl.pending > yl && (ul.adler = qn(ul.adler, wl.pending_buf, wl.pending - yl, yl)), El(ul), yl = wl.pending, wl.pending === wl.pending_buf_size)) {
          Rl = 1;
          break;
        }
        Rl = wl.gzindex < wl.gzhead.name.length ? 255 & wl.gzhead.name.charCodeAt(wl.gzindex++) : 0, Ml(wl, Rl);
      } while (Rl !== 0);
      wl.gzhead.hcrc && wl.pending > yl && (ul.adler = qn(ul.adler, wl.pending_buf, wl.pending - yl, yl)), Rl === 0 && (wl.gzindex = 0, wl.status = 91);
    } else wl.status = 91;
    if (wl.status === 91) if (wl.gzhead.comment) {
      yl = wl.pending;
      do {
        if (wl.pending === wl.pending_buf_size && (wl.gzhead.hcrc && wl.pending > yl && (ul.adler = qn(ul.adler, wl.pending_buf, wl.pending - yl, yl)), El(ul), yl = wl.pending, wl.pending === wl.pending_buf_size)) {
          Rl = 1;
          break;
        }
        Rl = wl.gzindex < wl.gzhead.comment.length ? 255 & wl.gzhead.comment.charCodeAt(wl.gzindex++) : 0, Ml(wl, Rl);
      } while (Rl !== 0);
      wl.gzhead.hcrc && wl.pending > yl && (ul.adler = qn(ul.adler, wl.pending_buf, wl.pending - yl, yl)), Rl === 0 && (wl.status = tl);
    } else wl.status = tl;
    if (wl.status === tl && (wl.gzhead.hcrc ? (wl.pending + 2 > wl.pending_buf_size && El(ul), wl.pending + 2 <= wl.pending_buf_size && (Ml(wl, 255 & ul.adler), Ml(wl, ul.adler >> 8 & 255), ul.adler = 0, wl.status = Qa)) : wl.status = Qa), wl.pending !== 0) {
      if (El(ul), ul.avail_out === 0) return wl.last_flush = -1, va;
    } else if (ul.avail_in === 0 && sl(vl) <= sl(Tl) && vl !== ma) return al(ul, -5);
    if (wl.status === nl && ul.avail_in !== 0) return al(ul, -5);
    if (ul.avail_in !== 0 || wl.lookahead !== 0 || vl !== pa && wl.status !== nl) {
      var hl = wl.strategy === 2 ? function(Cl, Il) {
        for (var Ll; ; ) {
          if (Cl.lookahead === 0 && (Dl(Cl), Cl.lookahead === 0)) {
            if (Il === pa) return rl;
            break;
          }
          if (Cl.match_length = 0, Ll = Un._tr_tally(Cl, 0, Cl.window[Cl.strstart]), Cl.lookahead--, Cl.strstart++, Ll && (fl(Cl, !1), Cl.strm.avail_out === 0)) return rl;
        }
        return Cl.insert = 0, Il === ma ? (fl(Cl, !0), Cl.strm.avail_out === 0 ? cl : ll) : Cl.last_lit && (fl(Cl, !1), Cl.strm.avail_out === 0) ? rl : il;
      }(wl, vl) : wl.strategy === 3 ? function(Cl, Il) {
        for (var Ll, tc, nc, uc, _c = Cl.window; ; ) {
          if (Cl.lookahead <= Ja) {
            if (Dl(Cl), Cl.lookahead <= Ja && Il === pa) return rl;
            if (Cl.lookahead === 0) break;
          }
          if (Cl.match_length = 0, Cl.lookahead >= Ka && Cl.strstart > 0 && (tc = _c[nc = Cl.strstart - 1]) === _c[++nc] && tc === _c[++nc] && tc === _c[++nc]) {
            uc = Cl.strstart + Ja;
            do
              ;
            while (tc === _c[++nc] && tc === _c[++nc] && tc === _c[++nc] && tc === _c[++nc] && tc === _c[++nc] && tc === _c[++nc] && tc === _c[++nc] && tc === _c[++nc] && nc < uc);
            Cl.match_length = Ja - (uc - nc), Cl.match_length > Cl.lookahead && (Cl.match_length = Cl.lookahead);
          }
          if (Cl.match_length >= Ka ? (Ll = Un._tr_tally(Cl, 1, Cl.match_length - Ka), Cl.lookahead -= Cl.match_length, Cl.strstart += Cl.match_length, Cl.match_length = 0) : (Ll = Un._tr_tally(Cl, 0, Cl.window[Cl.strstart]), Cl.lookahead--, Cl.strstart++), Ll && (fl(Cl, !1), Cl.strm.avail_out === 0)) return rl;
        }
        return Cl.insert = 0, Il === ma ? (fl(Cl, !0), Cl.strm.avail_out === 0 ? cl : ll) : Cl.last_lit && (fl(Cl, !1), Cl.strm.avail_out === 0) ? rl : il;
      }(wl, vl) : Xn[wl.level].func(wl, vl);
      if (hl !== cl && hl !== ll || (wl.status = nl), hl === rl || hl === cl) return ul.avail_out === 0 && (wl.last_flush = -1), va;
      if (hl === il && (vl === 1 ? Un._tr_align(wl) : vl !== 5 && (Un._tr_stored_block(wl, 0, 0, !1), vl === 3 && (dl(wl.head), wl.lookahead === 0 && (wl.strstart = 0, wl.block_start = 0, wl.insert = 0))), El(ul), ul.avail_out === 0)) return wl.last_flush = -1, va;
    }
    return vl !== ma ? va : wl.wrap <= 0 ? 1 : (wl.wrap === 2 ? (Ml(wl, 255 & ul.adler), Ml(wl, ul.adler >> 8 & 255), Ml(wl, ul.adler >> 16 & 255), Ml(wl, ul.adler >> 24 & 255), Ml(wl, 255 & ul.total_in), Ml(wl, ul.total_in >> 8 & 255), Ml(wl, ul.total_in >> 16 & 255), Ml(wl, ul.total_in >> 24 & 255)) : (Sl(wl, ul.adler >>> 16), Sl(wl, 65535 & ul.adler)), El(ul), wl.wrap > 0 && (wl.wrap = -wl.wrap), wl.pending !== 0 ? va : 1);
  }, deflate$2.deflateEnd = function(ul) {
    var vl;
    return ul && ul.state ? (vl = ul.state.status) !== qa && vl !== 69 && vl !== 73 && vl !== 91 && vl !== tl && vl !== Qa && vl !== nl ? al(ul, ba) : (ul.state = null, vl === Qa ? al(ul, -3) : va) : ba;
  }, deflate$2.deflateSetDictionary = function(ul, vl) {
    var Tl, wl, yl, Rl, Ul, hl, Cl, Il, Ll = vl.length;
    if (!ul || !ul.state || (Rl = (Tl = ul.state).wrap) === 2 || Rl === 1 && Tl.status !== qa || Tl.lookahead) return ba;
    for (Rl === 1 && (ul.adler = Kn(ul.adler, vl, Ll, 0)), Tl.wrap = 0, Ll >= Tl.w_size && (Rl === 0 && (dl(Tl.head), Tl.strstart = 0, Tl.block_start = 0, Tl.insert = 0), Il = new zn.Buf8(Tl.w_size), zn.arraySet(Il, vl, Ll - Tl.w_size, Tl.w_size, 0), vl = Il, Ll = Tl.w_size), Ul = ul.avail_in, hl = ul.next_in, Cl = ul.input, ul.avail_in = Ll, ul.next_in = 0, ul.input = vl, Dl(Tl); Tl.lookahead >= Ka; ) {
      wl = Tl.strstart, yl = Tl.lookahead - (Ka - 1);
      do
        Tl.ins_h = (Tl.ins_h << Tl.hash_shift ^ Tl.window[wl + Ka - 1]) & Tl.hash_mask, Tl.prev[wl & Tl.w_mask] = Tl.head[Tl.ins_h], Tl.head[Tl.ins_h] = wl, wl++;
      while (--yl);
      Tl.strstart = wl, Tl.lookahead = Ka - 1, Dl(Tl);
    }
    return Tl.strstart += Tl.lookahead, Tl.block_start = Tl.strstart, Tl.insert = Tl.lookahead, Tl.lookahead = 0, Tl.match_length = Tl.prev_length = Ka - 1, Tl.match_available = 0, ul.next_in = hl, ul.input = Cl, ul.avail_in = Ul, Tl.wrap = Rl, va;
  }, deflate$2.deflateInfo = "pako deflate (from Nodeca project)", deflate$2;
}
var strings$1 = {}, hasRequiredStrings$1, zstream$1, hasRequiredZstream$1, hasRequiredDeflate$2;
function requireStrings$1() {
  if (hasRequiredStrings$1) return strings$1;
  hasRequiredStrings$1 = 1;
  var Xn = requireCommon$1(), zn = !0, Un = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    zn = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    Un = !1;
  }
  for (var Kn = new Xn.Buf8(256), qn = 0; qn < 256; qn++) Kn[qn] = qn >= 252 ? 6 : qn >= 248 ? 5 : qn >= 240 ? 4 : qn >= 224 ? 3 : qn >= 192 ? 2 : 1;
  function Jo(pa, ma) {
    if (ma < 65534 && (pa.subarray && Un || !pa.subarray && zn)) return String.fromCharCode.apply(null, Xn.shrinkBuf(pa, ma));
    for (var va = "", ba = 0; ba < ma; ba++) va += String.fromCharCode(pa[ba]);
    return va;
  }
  return Kn[254] = Kn[254] = 1, strings$1.string2buf = function(pa) {
    var ma, va, ba, _a, ya, xa = pa.length, wa = 0;
    for (_a = 0; _a < xa; _a++) (64512 & (va = pa.charCodeAt(_a))) == 55296 && _a + 1 < xa && (64512 & (ba = pa.charCodeAt(_a + 1))) == 56320 && (va = 65536 + (va - 55296 << 10) + (ba - 56320), _a++), wa += va < 128 ? 1 : va < 2048 ? 2 : va < 65536 ? 3 : 4;
    for (ma = new Xn.Buf8(wa), ya = 0, _a = 0; ya < wa; _a++) (64512 & (va = pa.charCodeAt(_a))) == 55296 && _a + 1 < xa && (64512 & (ba = pa.charCodeAt(_a + 1))) == 56320 && (va = 65536 + (va - 55296 << 10) + (ba - 56320), _a++), va < 128 ? ma[ya++] = va : va < 2048 ? (ma[ya++] = 192 | va >>> 6, ma[ya++] = 128 | 63 & va) : va < 65536 ? (ma[ya++] = 224 | va >>> 12, ma[ya++] = 128 | va >>> 6 & 63, ma[ya++] = 128 | 63 & va) : (ma[ya++] = 240 | va >>> 18, ma[ya++] = 128 | va >>> 12 & 63, ma[ya++] = 128 | va >>> 6 & 63, ma[ya++] = 128 | 63 & va);
    return ma;
  }, strings$1.buf2binstring = function(pa) {
    return Jo(pa, pa.length);
  }, strings$1.binstring2buf = function(pa) {
    for (var ma = new Xn.Buf8(pa.length), va = 0, ba = ma.length; va < ba; va++) ma[va] = pa.charCodeAt(va);
    return ma;
  }, strings$1.buf2string = function(pa, ma) {
    var va, ba, _a, ya, xa = ma || pa.length, wa = new Array(2 * xa);
    for (ba = 0, va = 0; va < xa; ) if ((_a = pa[va++]) < 128) wa[ba++] = _a;
    else if ((ya = Kn[_a]) > 4) wa[ba++] = 65533, va += ya - 1;
    else {
      for (_a &= ya === 2 ? 31 : ya === 3 ? 15 : 7; ya > 1 && va < xa; ) _a = _a << 6 | 63 & pa[va++], ya--;
      ya > 1 ? wa[ba++] = 65533 : _a < 65536 ? wa[ba++] = _a : (_a -= 65536, wa[ba++] = 55296 | _a >> 10 & 1023, wa[ba++] = 56320 | 1023 & _a);
    }
    return Jo(wa, ba);
  }, strings$1.utf8border = function(pa, ma) {
    var va;
    for ((ma = ma || pa.length) > pa.length && (ma = pa.length), va = ma - 1; va >= 0 && (192 & pa[va]) == 128; ) va--;
    return va < 0 || va === 0 ? ma : va + Kn[pa[va]] > ma ? va : ma;
  }, strings$1;
}
function requireZstream$1() {
  return hasRequiredZstream$1 ? zstream$1 : (hasRequiredZstream$1 = 1, zstream$1 = function() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  });
}
function requireDeflate$2() {
  if (hasRequiredDeflate$2) return deflate$1$1;
  hasRequiredDeflate$2 = 1;
  var Xn = requireDeflate$1$1(), zn = requireCommon$1(), Un = requireStrings$1(), Kn = requireMessages$1(), qn = requireZstream$1(), Jo = Object.prototype.toString, pa = 0, ma = -1, va = 0, ba = 8;
  function _a(xa) {
    if (!(this instanceof _a)) return new _a(xa);
    this.options = zn.assign({ level: ma, method: ba, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: va, to: "" }, xa || {});
    var wa = this.options;
    wa.raw && wa.windowBits > 0 ? wa.windowBits = -wa.windowBits : wa.gzip && wa.windowBits > 0 && wa.windowBits < 16 && (wa.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new qn(), this.strm.avail_out = 0;
    var Ta = Xn.deflateInit2(this.strm, wa.level, wa.method, wa.windowBits, wa.memLevel, wa.strategy);
    if (Ta !== pa) throw new Error(Kn[Ta]);
    if (wa.header && Xn.deflateSetHeader(this.strm, wa.header), wa.dictionary) {
      var Sa;
      if (Sa = typeof wa.dictionary == "string" ? Un.string2buf(wa.dictionary) : Jo.call(wa.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(wa.dictionary) : wa.dictionary, (Ta = Xn.deflateSetDictionary(this.strm, Sa)) !== pa) throw new Error(Kn[Ta]);
      this._dict_set = !0;
    }
  }
  function ya(xa, wa) {
    var Ta = new _a(wa);
    if (Ta.push(xa, !0), Ta.err) throw Ta.msg || Kn[Ta.err];
    return Ta.result;
  }
  return _a.prototype.push = function(xa, wa) {
    var Ta, Sa, Ma = this.strm, ka = this.options.chunkSize;
    if (this.ended) return !1;
    Sa = wa === ~~wa ? wa : wa === !0 ? 4 : 0, typeof xa == "string" ? Ma.input = Un.string2buf(xa) : Jo.call(xa) === "[object ArrayBuffer]" ? Ma.input = new Uint8Array(xa) : Ma.input = xa, Ma.next_in = 0, Ma.avail_in = Ma.input.length;
    do {
      if (Ma.avail_out === 0 && (Ma.output = new zn.Buf8(ka), Ma.next_out = 0, Ma.avail_out = ka), (Ta = Xn.deflate(Ma, Sa)) !== 1 && Ta !== pa) return this.onEnd(Ta), this.ended = !0, !1;
      Ma.avail_out !== 0 && (Ma.avail_in !== 0 || Sa !== 4 && Sa !== 2) || (this.options.to === "string" ? this.onData(Un.buf2binstring(zn.shrinkBuf(Ma.output, Ma.next_out))) : this.onData(zn.shrinkBuf(Ma.output, Ma.next_out)));
    } while ((Ma.avail_in > 0 || Ma.avail_out === 0) && Ta !== 1);
    return Sa === 4 ? (Ta = Xn.deflateEnd(this.strm), this.onEnd(Ta), this.ended = !0, Ta === pa) : Sa !== 2 || (this.onEnd(pa), Ma.avail_out = 0, !0);
  }, _a.prototype.onData = function(xa) {
    this.chunks.push(xa);
  }, _a.prototype.onEnd = function(xa) {
    xa === pa && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = zn.flattenChunks(this.chunks)), this.chunks = [], this.err = xa, this.msg = this.strm.msg;
  }, deflate$1$1.Deflate = _a, deflate$1$1.deflate = ya, deflate$1$1.deflateRaw = function(xa, wa) {
    return (wa = wa || {}).raw = !0, ya(xa, wa);
  }, deflate$1$1.gzip = function(xa, wa) {
    return (wa = wa || {}).gzip = !0, ya(xa, wa);
  }, deflate$1$1;
}
var inflate$1$1 = {}, inflate$2 = {}, inffast$1, hasRequiredInffast$1, inftrees$1, hasRequiredInftrees$1, hasRequiredInflate$1$1, constants$1, hasRequiredConstants$1, gzheader$1, hasRequiredGzheader$1, hasRequiredInflate$2, pako_1$1, hasRequiredPako$1;
function requireInffast$1() {
  return hasRequiredInffast$1 ? inffast$1 : (hasRequiredInffast$1 = 1, inffast$1 = function(Xn, zn) {
    var Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el, qa, tl, Qa, nl;
    Un = Xn.state, Kn = Xn.next_in, Qa = Xn.input, qn = Kn + (Xn.avail_in - 5), Jo = Xn.next_out, nl = Xn.output, pa = Jo - (zn - Xn.avail_out), ma = Jo + (Xn.avail_out - 257), va = Un.dmax, ba = Un.wsize, _a = Un.whave, ya = Un.wnext, xa = Un.window, wa = Un.hold, Ta = Un.bits, Sa = Un.lencode, Ma = Un.distcode, ka = (1 << Un.lenbits) - 1, Za = (1 << Un.distbits) - 1;
    e: do {
      Ta < 15 && (wa += Qa[Kn++] << Ta, Ta += 8, wa += Qa[Kn++] << Ta, Ta += 8), Na = Sa[wa & ka];
      t: for (; ; ) {
        if (wa >>>= Ka = Na >>> 24, Ta -= Ka, (Ka = Na >>> 16 & 255) === 0) nl[Jo++] = 65535 & Na;
        else {
          if (!(16 & Ka)) {
            if (64 & Ka) {
              if (32 & Ka) {
                Un.mode = 12;
                break e;
              }
              Xn.msg = "invalid literal/length code", Un.mode = 30;
              break e;
            }
            Na = Sa[(65535 & Na) + (wa & (1 << Ka) - 1)];
            continue t;
          }
          for (Ja = 65535 & Na, (Ka &= 15) && (Ta < Ka && (wa += Qa[Kn++] << Ta, Ta += 8), Ja += wa & (1 << Ka) - 1, wa >>>= Ka, Ta -= Ka), Ta < 15 && (wa += Qa[Kn++] << Ta, Ta += 8, wa += Qa[Kn++] << Ta, Ta += 8), Na = Ma[wa & Za]; ; ) {
            if (wa >>>= Ka = Na >>> 24, Ta -= Ka, 16 & (Ka = Na >>> 16 & 255)) {
              if (el = 65535 & Na, Ta < (Ka &= 15) && (wa += Qa[Kn++] << Ta, (Ta += 8) < Ka && (wa += Qa[Kn++] << Ta, Ta += 8)), (el += wa & (1 << Ka) - 1) > va) {
                Xn.msg = "invalid distance too far back", Un.mode = 30;
                break e;
              }
              if (wa >>>= Ka, Ta -= Ka, el > (Ka = Jo - pa)) {
                if ((Ka = el - Ka) > _a && Un.sane) {
                  Xn.msg = "invalid distance too far back", Un.mode = 30;
                  break e;
                }
                if (qa = 0, tl = xa, ya === 0) {
                  if (qa += ba - Ka, Ka < Ja) {
                    Ja -= Ka;
                    do
                      nl[Jo++] = xa[qa++];
                    while (--Ka);
                    qa = Jo - el, tl = nl;
                  }
                } else if (ya < Ka) {
                  if (qa += ba + ya - Ka, (Ka -= ya) < Ja) {
                    Ja -= Ka;
                    do
                      nl[Jo++] = xa[qa++];
                    while (--Ka);
                    if (qa = 0, ya < Ja) {
                      Ja -= Ka = ya;
                      do
                        nl[Jo++] = xa[qa++];
                      while (--Ka);
                      qa = Jo - el, tl = nl;
                    }
                  }
                } else if (qa += ya - Ka, Ka < Ja) {
                  Ja -= Ka;
                  do
                    nl[Jo++] = xa[qa++];
                  while (--Ka);
                  qa = Jo - el, tl = nl;
                }
                for (; Ja > 2; ) nl[Jo++] = tl[qa++], nl[Jo++] = tl[qa++], nl[Jo++] = tl[qa++], Ja -= 3;
                Ja && (nl[Jo++] = tl[qa++], Ja > 1 && (nl[Jo++] = tl[qa++]));
              } else {
                qa = Jo - el;
                do
                  nl[Jo++] = nl[qa++], nl[Jo++] = nl[qa++], nl[Jo++] = nl[qa++], Ja -= 3;
                while (Ja > 2);
                Ja && (nl[Jo++] = nl[qa++], Ja > 1 && (nl[Jo++] = nl[qa++]));
              }
              break;
            }
            if (64 & Ka) {
              Xn.msg = "invalid distance code", Un.mode = 30;
              break e;
            }
            Na = Ma[(65535 & Na) + (wa & (1 << Ka) - 1)];
          }
        }
        break;
      }
    } while (Kn < qn && Jo < ma);
    Kn -= Ja = Ta >> 3, wa &= (1 << (Ta -= Ja << 3)) - 1, Xn.next_in = Kn, Xn.next_out = Jo, Xn.avail_in = Kn < qn ? qn - Kn + 5 : 5 - (Kn - qn), Xn.avail_out = Jo < ma ? ma - Jo + 257 : 257 - (Jo - ma), Un.hold = wa, Un.bits = Ta;
  }, inffast$1);
}
function requireInftrees$1() {
  if (hasRequiredInftrees$1) return inftrees$1;
  hasRequiredInftrees$1 = 1;
  var Xn = requireCommon$1(), zn = 15, Un = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], Kn = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], qn = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], Jo = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
  return inftrees$1 = function(pa, ma, va, ba, _a, ya, xa, wa) {
    var Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el, qa = wa.bits, tl = 0, Qa = 0, nl = 0, rl = 0, il = 0, cl = 0, ll = 0, al = 0, sl = 0, dl = 0, El = null, fl = 0, Ml = new Xn.Buf16(16), Sl = new Xn.Buf16(16), ml = null, Dl = 0;
    for (tl = 0; tl <= zn; tl++) Ml[tl] = 0;
    for (Qa = 0; Qa < ba; Qa++) Ml[ma[va + Qa]]++;
    for (il = qa, rl = zn; rl >= 1 && Ml[rl] === 0; rl--) ;
    if (il > rl && (il = rl), rl === 0) return _a[ya++] = 20971520, _a[ya++] = 20971520, wa.bits = 1, 0;
    for (nl = 1; nl < rl && Ml[nl] === 0; nl++) ;
    for (il < nl && (il = nl), al = 1, tl = 1; tl <= zn; tl++) if (al <<= 1, (al -= Ml[tl]) < 0) return -1;
    if (al > 0 && (pa === 0 || rl !== 1)) return -1;
    for (Sl[1] = 0, tl = 1; tl < zn; tl++) Sl[tl + 1] = Sl[tl] + Ml[tl];
    for (Qa = 0; Qa < ba; Qa++) ma[va + Qa] !== 0 && (xa[Sl[ma[va + Qa]]++] = Qa);
    if (pa === 0 ? (El = ml = xa, Na = 19) : pa === 1 ? (El = Un, fl -= 257, ml = Kn, Dl -= 257, Na = 256) : (El = qn, ml = Jo, Na = -1), dl = 0, Qa = 0, tl = nl, Za = ya, cl = il, ll = 0, Ma = -1, ka = (sl = 1 << il) - 1, pa === 1 && sl > 852 || pa === 2 && sl > 592) return 1;
    for (; ; ) {
      Ka = tl - ll, xa[Qa] < Na ? (Ja = 0, el = xa[Qa]) : xa[Qa] > Na ? (Ja = ml[Dl + xa[Qa]], el = El[fl + xa[Qa]]) : (Ja = 96, el = 0), Ta = 1 << tl - ll, nl = Sa = 1 << cl;
      do
        _a[Za + (dl >> ll) + (Sa -= Ta)] = Ka << 24 | Ja << 16 | el;
      while (Sa !== 0);
      for (Ta = 1 << tl - 1; dl & Ta; ) Ta >>= 1;
      if (Ta !== 0 ? (dl &= Ta - 1, dl += Ta) : dl = 0, Qa++, --Ml[tl] == 0) {
        if (tl === rl) break;
        tl = ma[va + xa[Qa]];
      }
      if (tl > il && (dl & ka) !== Ma) {
        for (ll === 0 && (ll = il), Za += nl, al = 1 << (cl = tl - ll); cl + ll < rl && !((al -= Ml[cl + ll]) <= 0); ) cl++, al <<= 1;
        if (sl += 1 << cl, pa === 1 && sl > 852 || pa === 2 && sl > 592) return 1;
        _a[Ma = dl & ka] = il << 24 | cl << 16 | Za - ya;
      }
    }
    return dl !== 0 && (_a[Za + dl] = tl - ll << 24 | 64 << 16), wa.bits = il, 0;
  };
}
function requireInflate$1$1() {
  if (hasRequiredInflate$1$1) return inflate$2;
  hasRequiredInflate$1$1 = 1;
  var Xn = requireCommon$1(), zn = requireAdler32$1(), Un = requireCrc32$1(), Kn = requireInffast$1(), qn = requireInftrees$1(), Jo = 1, pa = 2, ma = 0, va = -2, ba = 1, _a = 12, ya = 30, xa = 852, wa = 592;
  function Ta(Qa) {
    return (Qa >>> 24 & 255) + (Qa >>> 8 & 65280) + ((65280 & Qa) << 8) + ((255 & Qa) << 24);
  }
  function Sa() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Xn.Buf16(320), this.work = new Xn.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function Ma(Qa) {
    var nl;
    return Qa && Qa.state ? (nl = Qa.state, Qa.total_in = Qa.total_out = nl.total = 0, Qa.msg = "", nl.wrap && (Qa.adler = 1 & nl.wrap), nl.mode = ba, nl.last = 0, nl.havedict = 0, nl.dmax = 32768, nl.head = null, nl.hold = 0, nl.bits = 0, nl.lencode = nl.lendyn = new Xn.Buf32(xa), nl.distcode = nl.distdyn = new Xn.Buf32(wa), nl.sane = 1, nl.back = -1, ma) : va;
  }
  function ka(Qa) {
    var nl;
    return Qa && Qa.state ? ((nl = Qa.state).wsize = 0, nl.whave = 0, nl.wnext = 0, Ma(Qa)) : va;
  }
  function Za(Qa, nl) {
    var rl, il;
    return Qa && Qa.state ? (il = Qa.state, nl < 0 ? (rl = 0, nl = -nl) : (rl = 1 + (nl >> 4), nl < 48 && (nl &= 15)), nl && (nl < 8 || nl > 15) ? va : (il.window !== null && il.wbits !== nl && (il.window = null), il.wrap = rl, il.wbits = nl, ka(Qa))) : va;
  }
  function Na(Qa, nl) {
    var rl, il;
    return Qa ? (il = new Sa(), Qa.state = il, il.window = null, (rl = Za(Qa, nl)) !== ma && (Qa.state = null), rl) : va;
  }
  var Ka, Ja, el = !0;
  function qa(Qa) {
    if (el) {
      var nl;
      for (Ka = new Xn.Buf32(512), Ja = new Xn.Buf32(32), nl = 0; nl < 144; ) Qa.lens[nl++] = 8;
      for (; nl < 256; ) Qa.lens[nl++] = 9;
      for (; nl < 280; ) Qa.lens[nl++] = 7;
      for (; nl < 288; ) Qa.lens[nl++] = 8;
      for (qn(Jo, Qa.lens, 0, 288, Ka, 0, Qa.work, { bits: 9 }), nl = 0; nl < 32; ) Qa.lens[nl++] = 5;
      qn(pa, Qa.lens, 0, 32, Ja, 0, Qa.work, { bits: 5 }), el = !1;
    }
    Qa.lencode = Ka, Qa.lenbits = 9, Qa.distcode = Ja, Qa.distbits = 5;
  }
  function tl(Qa, nl, rl, il) {
    var cl, ll = Qa.state;
    return ll.window === null && (ll.wsize = 1 << ll.wbits, ll.wnext = 0, ll.whave = 0, ll.window = new Xn.Buf8(ll.wsize)), il >= ll.wsize ? (Xn.arraySet(ll.window, nl, rl - ll.wsize, ll.wsize, 0), ll.wnext = 0, ll.whave = ll.wsize) : ((cl = ll.wsize - ll.wnext) > il && (cl = il), Xn.arraySet(ll.window, nl, rl - il, cl, ll.wnext), (il -= cl) ? (Xn.arraySet(ll.window, nl, rl - il, il, 0), ll.wnext = il, ll.whave = ll.wsize) : (ll.wnext += cl, ll.wnext === ll.wsize && (ll.wnext = 0), ll.whave < ll.wsize && (ll.whave += cl))), 0;
  }
  return inflate$2.inflateReset = ka, inflate$2.inflateReset2 = Za, inflate$2.inflateResetKeep = Ma, inflate$2.inflateInit = function(Qa) {
    return Na(Qa, 15);
  }, inflate$2.inflateInit2 = Na, inflate$2.inflate = function(Qa, nl) {
    var rl, il, cl, ll, al, sl, dl, El, fl, Ml, Sl, ml, Dl, _l, gl, Fl, Nl, zl, Zl, kl, ul, vl, Tl, wl, yl = 0, Rl = new Xn.Buf8(4), Ul = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
    if (!Qa || !Qa.state || !Qa.output || !Qa.input && Qa.avail_in !== 0) return va;
    (rl = Qa.state).mode === _a && (rl.mode = 13), al = Qa.next_out, cl = Qa.output, dl = Qa.avail_out, ll = Qa.next_in, il = Qa.input, sl = Qa.avail_in, El = rl.hold, fl = rl.bits, Ml = sl, Sl = dl, vl = ma;
    e: for (; ; ) switch (rl.mode) {
      case ba:
        if (rl.wrap === 0) {
          rl.mode = 13;
          break;
        }
        for (; fl < 16; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        if (2 & rl.wrap && El === 35615) {
          rl.check = 0, Rl[0] = 255 & El, Rl[1] = El >>> 8 & 255, rl.check = Un(rl.check, Rl, 2, 0), El = 0, fl = 0, rl.mode = 2;
          break;
        }
        if (rl.flags = 0, rl.head && (rl.head.done = !1), !(1 & rl.wrap) || (((255 & El) << 8) + (El >> 8)) % 31) {
          Qa.msg = "incorrect header check", rl.mode = ya;
          break;
        }
        if ((15 & El) != 8) {
          Qa.msg = "unknown compression method", rl.mode = ya;
          break;
        }
        if (fl -= 4, ul = 8 + (15 & (El >>>= 4)), rl.wbits === 0) rl.wbits = ul;
        else if (ul > rl.wbits) {
          Qa.msg = "invalid window size", rl.mode = ya;
          break;
        }
        rl.dmax = 1 << ul, Qa.adler = rl.check = 1, rl.mode = 512 & El ? 10 : _a, El = 0, fl = 0;
        break;
      case 2:
        for (; fl < 16; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        if (rl.flags = El, (255 & rl.flags) != 8) {
          Qa.msg = "unknown compression method", rl.mode = ya;
          break;
        }
        if (57344 & rl.flags) {
          Qa.msg = "unknown header flags set", rl.mode = ya;
          break;
        }
        rl.head && (rl.head.text = El >> 8 & 1), 512 & rl.flags && (Rl[0] = 255 & El, Rl[1] = El >>> 8 & 255, rl.check = Un(rl.check, Rl, 2, 0)), El = 0, fl = 0, rl.mode = 3;
      case 3:
        for (; fl < 32; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        rl.head && (rl.head.time = El), 512 & rl.flags && (Rl[0] = 255 & El, Rl[1] = El >>> 8 & 255, Rl[2] = El >>> 16 & 255, Rl[3] = El >>> 24 & 255, rl.check = Un(rl.check, Rl, 4, 0)), El = 0, fl = 0, rl.mode = 4;
      case 4:
        for (; fl < 16; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        rl.head && (rl.head.xflags = 255 & El, rl.head.os = El >> 8), 512 & rl.flags && (Rl[0] = 255 & El, Rl[1] = El >>> 8 & 255, rl.check = Un(rl.check, Rl, 2, 0)), El = 0, fl = 0, rl.mode = 5;
      case 5:
        if (1024 & rl.flags) {
          for (; fl < 16; ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          rl.length = El, rl.head && (rl.head.extra_len = El), 512 & rl.flags && (Rl[0] = 255 & El, Rl[1] = El >>> 8 & 255, rl.check = Un(rl.check, Rl, 2, 0)), El = 0, fl = 0;
        } else rl.head && (rl.head.extra = null);
        rl.mode = 6;
      case 6:
        if (1024 & rl.flags && ((ml = rl.length) > sl && (ml = sl), ml && (rl.head && (ul = rl.head.extra_len - rl.length, rl.head.extra || (rl.head.extra = new Array(rl.head.extra_len)), Xn.arraySet(rl.head.extra, il, ll, ml, ul)), 512 & rl.flags && (rl.check = Un(rl.check, il, ml, ll)), sl -= ml, ll += ml, rl.length -= ml), rl.length)) break e;
        rl.length = 0, rl.mode = 7;
      case 7:
        if (2048 & rl.flags) {
          if (sl === 0) break e;
          ml = 0;
          do
            ul = il[ll + ml++], rl.head && ul && rl.length < 65536 && (rl.head.name += String.fromCharCode(ul));
          while (ul && ml < sl);
          if (512 & rl.flags && (rl.check = Un(rl.check, il, ml, ll)), sl -= ml, ll += ml, ul) break e;
        } else rl.head && (rl.head.name = null);
        rl.length = 0, rl.mode = 8;
      case 8:
        if (4096 & rl.flags) {
          if (sl === 0) break e;
          ml = 0;
          do
            ul = il[ll + ml++], rl.head && ul && rl.length < 65536 && (rl.head.comment += String.fromCharCode(ul));
          while (ul && ml < sl);
          if (512 & rl.flags && (rl.check = Un(rl.check, il, ml, ll)), sl -= ml, ll += ml, ul) break e;
        } else rl.head && (rl.head.comment = null);
        rl.mode = 9;
      case 9:
        if (512 & rl.flags) {
          for (; fl < 16; ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          if (El !== (65535 & rl.check)) {
            Qa.msg = "header crc mismatch", rl.mode = ya;
            break;
          }
          El = 0, fl = 0;
        }
        rl.head && (rl.head.hcrc = rl.flags >> 9 & 1, rl.head.done = !0), Qa.adler = rl.check = 0, rl.mode = _a;
        break;
      case 10:
        for (; fl < 32; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        Qa.adler = rl.check = Ta(El), El = 0, fl = 0, rl.mode = 11;
      case 11:
        if (rl.havedict === 0) return Qa.next_out = al, Qa.avail_out = dl, Qa.next_in = ll, Qa.avail_in = sl, rl.hold = El, rl.bits = fl, 2;
        Qa.adler = rl.check = 1, rl.mode = _a;
      case _a:
        if (nl === 5 || nl === 6) break e;
      case 13:
        if (rl.last) {
          El >>>= 7 & fl, fl -= 7 & fl, rl.mode = 27;
          break;
        }
        for (; fl < 3; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        switch (rl.last = 1 & El, fl -= 1, 3 & (El >>>= 1)) {
          case 0:
            rl.mode = 14;
            break;
          case 1:
            if (qa(rl), rl.mode = 20, nl === 6) {
              El >>>= 2, fl -= 2;
              break e;
            }
            break;
          case 2:
            rl.mode = 17;
            break;
          case 3:
            Qa.msg = "invalid block type", rl.mode = ya;
        }
        El >>>= 2, fl -= 2;
        break;
      case 14:
        for (El >>>= 7 & fl, fl -= 7 & fl; fl < 32; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        if ((65535 & El) != (El >>> 16 ^ 65535)) {
          Qa.msg = "invalid stored block lengths", rl.mode = ya;
          break;
        }
        if (rl.length = 65535 & El, El = 0, fl = 0, rl.mode = 15, nl === 6) break e;
      case 15:
        rl.mode = 16;
      case 16:
        if (ml = rl.length) {
          if (ml > sl && (ml = sl), ml > dl && (ml = dl), ml === 0) break e;
          Xn.arraySet(cl, il, ll, ml, al), sl -= ml, ll += ml, dl -= ml, al += ml, rl.length -= ml;
          break;
        }
        rl.mode = _a;
        break;
      case 17:
        for (; fl < 14; ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        if (rl.nlen = 257 + (31 & El), El >>>= 5, fl -= 5, rl.ndist = 1 + (31 & El), El >>>= 5, fl -= 5, rl.ncode = 4 + (15 & El), El >>>= 4, fl -= 4, rl.nlen > 286 || rl.ndist > 30) {
          Qa.msg = "too many length or distance symbols", rl.mode = ya;
          break;
        }
        rl.have = 0, rl.mode = 18;
      case 18:
        for (; rl.have < rl.ncode; ) {
          for (; fl < 3; ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          rl.lens[Ul[rl.have++]] = 7 & El, El >>>= 3, fl -= 3;
        }
        for (; rl.have < 19; ) rl.lens[Ul[rl.have++]] = 0;
        if (rl.lencode = rl.lendyn, rl.lenbits = 7, Tl = { bits: rl.lenbits }, vl = qn(0, rl.lens, 0, 19, rl.lencode, 0, rl.work, Tl), rl.lenbits = Tl.bits, vl) {
          Qa.msg = "invalid code lengths set", rl.mode = ya;
          break;
        }
        rl.have = 0, rl.mode = 19;
      case 19:
        for (; rl.have < rl.nlen + rl.ndist; ) {
          for (; Fl = (yl = rl.lencode[El & (1 << rl.lenbits) - 1]) >>> 16 & 255, Nl = 65535 & yl, !((gl = yl >>> 24) <= fl); ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          if (Nl < 16) El >>>= gl, fl -= gl, rl.lens[rl.have++] = Nl;
          else {
            if (Nl === 16) {
              for (wl = gl + 2; fl < wl; ) {
                if (sl === 0) break e;
                sl--, El += il[ll++] << fl, fl += 8;
              }
              if (El >>>= gl, fl -= gl, rl.have === 0) {
                Qa.msg = "invalid bit length repeat", rl.mode = ya;
                break;
              }
              ul = rl.lens[rl.have - 1], ml = 3 + (3 & El), El >>>= 2, fl -= 2;
            } else if (Nl === 17) {
              for (wl = gl + 3; fl < wl; ) {
                if (sl === 0) break e;
                sl--, El += il[ll++] << fl, fl += 8;
              }
              fl -= gl, ul = 0, ml = 3 + (7 & (El >>>= gl)), El >>>= 3, fl -= 3;
            } else {
              for (wl = gl + 7; fl < wl; ) {
                if (sl === 0) break e;
                sl--, El += il[ll++] << fl, fl += 8;
              }
              fl -= gl, ul = 0, ml = 11 + (127 & (El >>>= gl)), El >>>= 7, fl -= 7;
            }
            if (rl.have + ml > rl.nlen + rl.ndist) {
              Qa.msg = "invalid bit length repeat", rl.mode = ya;
              break;
            }
            for (; ml--; ) rl.lens[rl.have++] = ul;
          }
        }
        if (rl.mode === ya) break;
        if (rl.lens[256] === 0) {
          Qa.msg = "invalid code -- missing end-of-block", rl.mode = ya;
          break;
        }
        if (rl.lenbits = 9, Tl = { bits: rl.lenbits }, vl = qn(Jo, rl.lens, 0, rl.nlen, rl.lencode, 0, rl.work, Tl), rl.lenbits = Tl.bits, vl) {
          Qa.msg = "invalid literal/lengths set", rl.mode = ya;
          break;
        }
        if (rl.distbits = 6, rl.distcode = rl.distdyn, Tl = { bits: rl.distbits }, vl = qn(pa, rl.lens, rl.nlen, rl.ndist, rl.distcode, 0, rl.work, Tl), rl.distbits = Tl.bits, vl) {
          Qa.msg = "invalid distances set", rl.mode = ya;
          break;
        }
        if (rl.mode = 20, nl === 6) break e;
      case 20:
        rl.mode = 21;
      case 21:
        if (sl >= 6 && dl >= 258) {
          Qa.next_out = al, Qa.avail_out = dl, Qa.next_in = ll, Qa.avail_in = sl, rl.hold = El, rl.bits = fl, Kn(Qa, Sl), al = Qa.next_out, cl = Qa.output, dl = Qa.avail_out, ll = Qa.next_in, il = Qa.input, sl = Qa.avail_in, El = rl.hold, fl = rl.bits, rl.mode === _a && (rl.back = -1);
          break;
        }
        for (rl.back = 0; Fl = (yl = rl.lencode[El & (1 << rl.lenbits) - 1]) >>> 16 & 255, Nl = 65535 & yl, !((gl = yl >>> 24) <= fl); ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        if (Fl && !(240 & Fl)) {
          for (zl = gl, Zl = Fl, kl = Nl; Fl = (yl = rl.lencode[kl + ((El & (1 << zl + Zl) - 1) >> zl)]) >>> 16 & 255, Nl = 65535 & yl, !(zl + (gl = yl >>> 24) <= fl); ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          El >>>= zl, fl -= zl, rl.back += zl;
        }
        if (El >>>= gl, fl -= gl, rl.back += gl, rl.length = Nl, Fl === 0) {
          rl.mode = 26;
          break;
        }
        if (32 & Fl) {
          rl.back = -1, rl.mode = _a;
          break;
        }
        if (64 & Fl) {
          Qa.msg = "invalid literal/length code", rl.mode = ya;
          break;
        }
        rl.extra = 15 & Fl, rl.mode = 22;
      case 22:
        if (rl.extra) {
          for (wl = rl.extra; fl < wl; ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          rl.length += El & (1 << rl.extra) - 1, El >>>= rl.extra, fl -= rl.extra, rl.back += rl.extra;
        }
        rl.was = rl.length, rl.mode = 23;
      case 23:
        for (; Fl = (yl = rl.distcode[El & (1 << rl.distbits) - 1]) >>> 16 & 255, Nl = 65535 & yl, !((gl = yl >>> 24) <= fl); ) {
          if (sl === 0) break e;
          sl--, El += il[ll++] << fl, fl += 8;
        }
        if (!(240 & Fl)) {
          for (zl = gl, Zl = Fl, kl = Nl; Fl = (yl = rl.distcode[kl + ((El & (1 << zl + Zl) - 1) >> zl)]) >>> 16 & 255, Nl = 65535 & yl, !(zl + (gl = yl >>> 24) <= fl); ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          El >>>= zl, fl -= zl, rl.back += zl;
        }
        if (El >>>= gl, fl -= gl, rl.back += gl, 64 & Fl) {
          Qa.msg = "invalid distance code", rl.mode = ya;
          break;
        }
        rl.offset = Nl, rl.extra = 15 & Fl, rl.mode = 24;
      case 24:
        if (rl.extra) {
          for (wl = rl.extra; fl < wl; ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          rl.offset += El & (1 << rl.extra) - 1, El >>>= rl.extra, fl -= rl.extra, rl.back += rl.extra;
        }
        if (rl.offset > rl.dmax) {
          Qa.msg = "invalid distance too far back", rl.mode = ya;
          break;
        }
        rl.mode = 25;
      case 25:
        if (dl === 0) break e;
        if (ml = Sl - dl, rl.offset > ml) {
          if ((ml = rl.offset - ml) > rl.whave && rl.sane) {
            Qa.msg = "invalid distance too far back", rl.mode = ya;
            break;
          }
          ml > rl.wnext ? (ml -= rl.wnext, Dl = rl.wsize - ml) : Dl = rl.wnext - ml, ml > rl.length && (ml = rl.length), _l = rl.window;
        } else _l = cl, Dl = al - rl.offset, ml = rl.length;
        ml > dl && (ml = dl), dl -= ml, rl.length -= ml;
        do
          cl[al++] = _l[Dl++];
        while (--ml);
        rl.length === 0 && (rl.mode = 21);
        break;
      case 26:
        if (dl === 0) break e;
        cl[al++] = rl.length, dl--, rl.mode = 21;
        break;
      case 27:
        if (rl.wrap) {
          for (; fl < 32; ) {
            if (sl === 0) break e;
            sl--, El |= il[ll++] << fl, fl += 8;
          }
          if (Sl -= dl, Qa.total_out += Sl, rl.total += Sl, Sl && (Qa.adler = rl.check = rl.flags ? Un(rl.check, cl, Sl, al - Sl) : zn(rl.check, cl, Sl, al - Sl)), Sl = dl, (rl.flags ? El : Ta(El)) !== rl.check) {
            Qa.msg = "incorrect data check", rl.mode = ya;
            break;
          }
          El = 0, fl = 0;
        }
        rl.mode = 28;
      case 28:
        if (rl.wrap && rl.flags) {
          for (; fl < 32; ) {
            if (sl === 0) break e;
            sl--, El += il[ll++] << fl, fl += 8;
          }
          if (El !== (4294967295 & rl.total)) {
            Qa.msg = "incorrect length check", rl.mode = ya;
            break;
          }
          El = 0, fl = 0;
        }
        rl.mode = 29;
      case 29:
        vl = 1;
        break e;
      case ya:
        vl = -3;
        break e;
      case 31:
        return -4;
      default:
        return va;
    }
    return Qa.next_out = al, Qa.avail_out = dl, Qa.next_in = ll, Qa.avail_in = sl, rl.hold = El, rl.bits = fl, (rl.wsize || Sl !== Qa.avail_out && rl.mode < ya && (rl.mode < 27 || nl !== 4)) && tl(Qa, Qa.output, Qa.next_out, Sl - Qa.avail_out), Ml -= Qa.avail_in, Sl -= Qa.avail_out, Qa.total_in += Ml, Qa.total_out += Sl, rl.total += Sl, rl.wrap && Sl && (Qa.adler = rl.check = rl.flags ? Un(rl.check, cl, Sl, Qa.next_out - Sl) : zn(rl.check, cl, Sl, Qa.next_out - Sl)), Qa.data_type = rl.bits + (rl.last ? 64 : 0) + (rl.mode === _a ? 128 : 0) + (rl.mode === 20 || rl.mode === 15 ? 256 : 0), (Ml === 0 && Sl === 0 || nl === 4) && vl === ma && (vl = -5), vl;
  }, inflate$2.inflateEnd = function(Qa) {
    if (!Qa || !Qa.state) return va;
    var nl = Qa.state;
    return nl.window && (nl.window = null), Qa.state = null, ma;
  }, inflate$2.inflateGetHeader = function(Qa, nl) {
    var rl;
    return Qa && Qa.state && 2 & (rl = Qa.state).wrap ? (rl.head = nl, nl.done = !1, ma) : va;
  }, inflate$2.inflateSetDictionary = function(Qa, nl) {
    var rl, il = nl.length;
    return Qa && Qa.state ? (rl = Qa.state).wrap !== 0 && rl.mode !== 11 ? va : rl.mode === 11 && zn(1, nl, il, 0) !== rl.check ? -3 : tl(Qa, nl, il, il) ? (rl.mode = 31, -4) : (rl.havedict = 1, ma) : va;
  }, inflate$2.inflateInfo = "pako inflate (from Nodeca project)", inflate$2;
}
function requireConstants$1() {
  return hasRequiredConstants$1 ? constants$1 : (hasRequiredConstants$1 = 1, constants$1 = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 });
}
function requireGzheader$1() {
  return hasRequiredGzheader$1 ? gzheader$1 : (hasRequiredGzheader$1 = 1, gzheader$1 = function() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  });
}
function requireInflate$2() {
  if (hasRequiredInflate$2) return inflate$1$1;
  hasRequiredInflate$2 = 1;
  var Xn = requireInflate$1$1(), zn = requireCommon$1(), Un = requireStrings$1(), Kn = requireConstants$1(), qn = requireMessages$1(), Jo = requireZstream$1(), pa = requireGzheader$1(), ma = Object.prototype.toString;
  function va(_a) {
    if (!(this instanceof va)) return new va(_a);
    this.options = zn.assign({ chunkSize: 16384, windowBits: 0, to: "" }, _a || {});
    var ya = this.options;
    ya.raw && ya.windowBits >= 0 && ya.windowBits < 16 && (ya.windowBits = -ya.windowBits, ya.windowBits === 0 && (ya.windowBits = -15)), !(ya.windowBits >= 0 && ya.windowBits < 16) || _a && _a.windowBits || (ya.windowBits += 32), ya.windowBits > 15 && ya.windowBits < 48 && (15 & ya.windowBits || (ya.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Jo(), this.strm.avail_out = 0;
    var xa = Xn.inflateInit2(this.strm, ya.windowBits);
    if (xa !== Kn.Z_OK) throw new Error(qn[xa]);
    if (this.header = new pa(), Xn.inflateGetHeader(this.strm, this.header), ya.dictionary && (typeof ya.dictionary == "string" ? ya.dictionary = Un.string2buf(ya.dictionary) : ma.call(ya.dictionary) === "[object ArrayBuffer]" && (ya.dictionary = new Uint8Array(ya.dictionary)), ya.raw && (xa = Xn.inflateSetDictionary(this.strm, ya.dictionary)) !== Kn.Z_OK)) throw new Error(qn[xa]);
  }
  function ba(_a, ya) {
    var xa = new va(ya);
    if (xa.push(_a, !0), xa.err) throw xa.msg || qn[xa.err];
    return xa.result;
  }
  return va.prototype.push = function(_a, ya) {
    var xa, wa, Ta, Sa, Ma, ka = this.strm, Za = this.options.chunkSize, Na = this.options.dictionary, Ka = !1;
    if (this.ended) return !1;
    wa = ya === ~~ya ? ya : ya === !0 ? Kn.Z_FINISH : Kn.Z_NO_FLUSH, typeof _a == "string" ? ka.input = Un.binstring2buf(_a) : ma.call(_a) === "[object ArrayBuffer]" ? ka.input = new Uint8Array(_a) : ka.input = _a, ka.next_in = 0, ka.avail_in = ka.input.length;
    do {
      if (ka.avail_out === 0 && (ka.output = new zn.Buf8(Za), ka.next_out = 0, ka.avail_out = Za), (xa = Xn.inflate(ka, Kn.Z_NO_FLUSH)) === Kn.Z_NEED_DICT && Na && (xa = Xn.inflateSetDictionary(this.strm, Na)), xa === Kn.Z_BUF_ERROR && Ka === !0 && (xa = Kn.Z_OK, Ka = !1), xa !== Kn.Z_STREAM_END && xa !== Kn.Z_OK) return this.onEnd(xa), this.ended = !0, !1;
      ka.next_out && (ka.avail_out !== 0 && xa !== Kn.Z_STREAM_END && (ka.avail_in !== 0 || wa !== Kn.Z_FINISH && wa !== Kn.Z_SYNC_FLUSH) || (this.options.to === "string" ? (Ta = Un.utf8border(ka.output, ka.next_out), Sa = ka.next_out - Ta, Ma = Un.buf2string(ka.output, Ta), ka.next_out = Sa, ka.avail_out = Za - Sa, Sa && zn.arraySet(ka.output, ka.output, Ta, Sa, 0), this.onData(Ma)) : this.onData(zn.shrinkBuf(ka.output, ka.next_out)))), ka.avail_in === 0 && ka.avail_out === 0 && (Ka = !0);
    } while ((ka.avail_in > 0 || ka.avail_out === 0) && xa !== Kn.Z_STREAM_END);
    return xa === Kn.Z_STREAM_END && (wa = Kn.Z_FINISH), wa === Kn.Z_FINISH ? (xa = Xn.inflateEnd(this.strm), this.onEnd(xa), this.ended = !0, xa === Kn.Z_OK) : wa !== Kn.Z_SYNC_FLUSH || (this.onEnd(Kn.Z_OK), ka.avail_out = 0, !0);
  }, va.prototype.onData = function(_a) {
    this.chunks.push(_a);
  }, va.prototype.onEnd = function(_a) {
    _a === Kn.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = zn.flattenChunks(this.chunks)), this.chunks = [], this.err = _a, this.msg = this.strm.msg;
  }, inflate$1$1.Inflate = va, inflate$1$1.inflate = ba, inflate$1$1.inflateRaw = function(_a, ya) {
    return (ya = ya || {}).raw = !0, ba(_a, ya);
  }, inflate$1$1.ungzip = ba, inflate$1$1;
}
function requirePako$1() {
  if (hasRequiredPako$1) return pako_1$1;
  hasRequiredPako$1 = 1;
  var Xn = {};
  return (0, requireCommon$1().assign)(Xn, requireDeflate$2(), requireInflate$2(), requireConstants$1()), pako_1$1 = Xn;
}
(function(Xn) {
  (function() {
    var zn = {};
    function Un() {
      typeof process < "u" && process.env.NODE_ENV != "development" || console.log.apply(console, arguments);
    }
    Xn.exports = zn, function(Kn, qn) {
      (function() {
        var Jo = function() {
          function va(ba) {
            this.message = "JPEG error: " + ba;
          }
          return va.prototype = new Error(), va.prototype.name = "JpegError", va.constructor = va, va;
        }(), pa = function() {
          var va = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]), ba = 4017, _a = 799, ya = 3406, xa = 2276, wa = 1567, Ta = 3784, Sa = 5793, Ma = 2896;
          function ka(tl) {
            tl == null && (tl = {}), tl.w == null && (tl.w = -1), this.V = tl.n, this.N = tl.w;
          }
          function Za(tl, Qa) {
            for (var nl, rl, il, cl = 0, ll = [], al = 16; al > 0 && !tl[al - 1]; ) al--;
            ll.push({ children: [], index: 0 });
            var sl = ll[0];
            for (nl = 0; nl < al; nl++) {
              for (rl = 0; rl < tl[nl]; rl++) {
                for ((sl = ll.pop()).children[sl.index] = Qa[cl]; sl.index > 0; ) sl = ll.pop();
                for (sl.index++, ll.push(sl); ll.length <= nl; ) ll.push(il = { children: [], index: 0 }), sl.children[sl.index] = il.children, sl = il;
                cl++;
              }
              nl + 1 < al && (ll.push(il = { children: [], index: 0 }), sl.children[sl.index] = il.children, sl = il);
            }
            return ll[0].children;
          }
          function Na(tl, Qa, nl) {
            return 64 * ((tl.P + 1) * Qa + nl);
          }
          function Ka(tl, Qa, nl, rl, il, cl, ll, al, sl, dl) {
            dl == null && (dl = !1);
            var El, fl, Ml, Sl, ml, Dl, _l, gl, Fl, Nl, zl, Zl = nl.m, kl = nl.Z, ul = Qa, vl = 0, Tl = 0, wl = 0, yl = 0, Rl = 0, Ul = 0;
            function hl() {
              if (Tl > 0) return Tl--, vl >> Tl & 1;
              if ((vl = tl[Qa++]) === 255) {
                var mc = tl[Qa++];
                if (mc) {
                  if (mc === 220 && dl) {
                    var Sc = ma(tl, Qa += 2);
                    if (Qa += 2, Sc > 0 && Sc !== nl.s) throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", Sc);
                  } else if (mc === 217) {
                    if (dl) {
                      var hc = 8 * Rl;
                      if (hc > 0 && hc < nl.s / 10) throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", hc);
                    }
                    throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
                  }
                  throw new Jo("unexpected marker");
                }
              }
              return Tl = 7, vl >>> 7;
            }
            function Cl(mc) {
              for (var Sc = mc; ; ) {
                switch (typeof (Sc = Sc[hl()])) {
                  case "number":
                    return Sc;
                  case "object":
                    continue;
                }
                throw new Jo("invalid huffman sequence");
              }
            }
            function Il(mc) {
              for (var Sc = 0; mc > 0; ) Sc = Sc << 1 | hl(), mc--;
              return Sc;
            }
            function Ll(mc) {
              if (mc === 1) return hl() === 1 ? 1 : -1;
              var Sc = Il(mc);
              return Sc >= 1 << mc - 1 ? Sc : Sc + (-1 << mc) + 1;
            }
            function tc(mc, Sc, hc, Lc, Ec) {
              var Hl = hc % Zl;
              Rl = (hc / Zl | 0) * mc.A + Lc;
              var fc = Hl * mc.h + Ec;
              Sc(mc, Na(mc, Rl, fc));
            }
            function nc(mc, Sc, hc) {
              Rl = hc / mc.P | 0;
              var Lc = hc % mc.P;
              Sc(mc, Na(mc, Rl, Lc));
            }
            var uc = rl.length;
            for (_l = kl ? cl === 0 ? al === 0 ? function(mc, Sc) {
              var hc = Cl(mc.J), Lc = hc === 0 ? 0 : Ll(hc) << sl;
              mc.D[Sc] = mc.Q += Lc;
            } : function(mc, Sc) {
              mc.D[Sc] |= hl() << sl;
            } : al === 0 ? function(mc, Sc) {
              if (wl > 0) wl--;
              else for (var hc = cl, Lc = ll; hc <= Lc; ) {
                var Ec = Cl(mc.i), Hl = 15 & Ec, fc = Ec >> 4;
                if (Hl !== 0) {
                  var lc = va[hc += fc];
                  mc.D[Sc + lc] = Ll(Hl) * (1 << sl), hc++;
                } else {
                  if (fc < 15) {
                    wl = Il(fc) + (1 << fc) - 1;
                    break;
                  }
                  hc += 16;
                }
              }
            } : function(mc, Sc) {
              for (var hc, Lc, Ec = cl, Hl = ll, fc = 0; Ec <= Hl; ) {
                var lc = Sc + va[Ec], Gl = mc.D[lc] < 0 ? -1 : 1;
                switch (yl) {
                  case 0:
                    if (fc = (Lc = Cl(mc.i)) >> 4, (hc = 15 & Lc) == 0) fc < 15 ? (wl = Il(fc) + (1 << fc), yl = 4) : (fc = 16, yl = 1);
                    else {
                      if (hc !== 1) throw new Jo("invalid ACn encoding");
                      El = Ll(hc), yl = fc ? 2 : 3;
                    }
                    continue;
                  case 1:
                  case 2:
                    mc.D[lc] ? mc.D[lc] += Gl * (hl() << sl) : --fc == 0 && (yl = yl === 2 ? 3 : 0);
                    break;
                  case 3:
                    mc.D[lc] ? mc.D[lc] += Gl * (hl() << sl) : (mc.D[lc] = El << sl, yl = 0);
                    break;
                  case 4:
                    mc.D[lc] && (mc.D[lc] += Gl * (hl() << sl));
                }
                Ec++;
              }
              yl === 4 && --wl == 0 && (yl = 0);
            } : function(mc, Sc) {
              var hc = Cl(mc.J), Lc = hc === 0 ? 0 : Ll(hc), Ec = 1;
              for (mc.D[Sc] = mc.Q += Lc; Ec < 64; ) {
                var Hl = Cl(mc.i), fc = 15 & Hl, lc = Hl >> 4;
                if (fc !== 0) {
                  var Gl = va[Ec += lc];
                  mc.D[Sc + Gl] = Ll(fc), Ec++;
                } else {
                  if (lc < 15) break;
                  Ec += 16;
                }
              }
            }, Fl = uc === 1 ? rl[0].P * rl[0].c : Zl * nl.R; Ul <= Fl; ) {
              var _c = il ? Math.min(Fl - Ul, il) : Fl;
              if (_c > 0) {
                for (Ml = 0; Ml < uc; Ml++) rl[Ml].Q = 0;
                if (wl = 0, uc === 1) for (fl = rl[0], Dl = 0; Dl < _c; Dl++) nc(fl, _l, Ul), Ul++;
                else for (Dl = 0; Dl < _c; Dl++) {
                  for (Ml = 0; Ml < uc; Ml++) for (Nl = (fl = rl[Ml]).h, zl = fl.A, Sl = 0; Sl < zl; Sl++) for (ml = 0; ml < Nl; ml++) tc(fl, _l, Ul, Sl, ml);
                  Ul++;
                }
              }
              if (Tl = 0, !(gl = qa(tl, Qa)) || (gl.u && (Qa = gl.offset), !(gl.M >= 65488 && gl.M <= 65495))) break;
              Qa += 2;
            }
            return Qa - ul;
          }
          function Ja(tl, Qa, nl) {
            var rl, il, cl, ll, al, sl, dl, El, fl, Ml, Sl, ml, Dl, _l, gl, Fl, Nl, zl = tl.$, Zl = tl.D;
            if (!zl) throw new Jo("missing required Quantization Table.");
            for (var kl = 0; kl < 64; kl += 8) fl = Zl[Qa + kl], Ml = Zl[Qa + kl + 1], Sl = Zl[Qa + kl + 2], ml = Zl[Qa + kl + 3], Dl = Zl[Qa + kl + 4], _l = Zl[Qa + kl + 5], gl = Zl[Qa + kl + 6], Fl = Zl[Qa + kl + 7], fl *= zl[kl], Ml | Sl | ml | Dl | _l | gl | Fl ? (Ml *= zl[kl + 1], Sl *= zl[kl + 2], ml *= zl[kl + 3], Dl *= zl[kl + 4], _l *= zl[kl + 5], gl *= zl[kl + 6], Fl *= zl[kl + 7], il = (rl = (rl = Sa * fl + 128 >> 8) + (il = Sa * Dl + 128 >> 8) + 1 >> 1) - il, Nl = (cl = Sl) * Ta + (ll = gl) * wa + 128 >> 8, cl = cl * wa - ll * Ta + 128 >> 8, dl = (al = (al = Ma * (Ml - Fl) + 128 >> 8) + (dl = _l << 4) + 1 >> 1) - dl, sl = (El = (El = Ma * (Ml + Fl) + 128 >> 8) + (sl = ml << 4) + 1 >> 1) - sl, ll = (rl = rl + (ll = Nl) + 1 >> 1) - ll, cl = (il = il + cl + 1 >> 1) - cl, Nl = al * xa + El * ya + 2048 >> 12, al = al * ya - El * xa + 2048 >> 12, El = Nl, Nl = sl * _a + dl * ba + 2048 >> 12, sl = sl * ba - dl * _a + 2048 >> 12, dl = Nl, nl[kl] = rl + El, nl[kl + 7] = rl - El, nl[kl + 1] = il + dl, nl[kl + 6] = il - dl, nl[kl + 2] = cl + sl, nl[kl + 5] = cl - sl, nl[kl + 3] = ll + al, nl[kl + 4] = ll - al) : (Nl = Sa * fl + 512 >> 10, nl[kl] = Nl, nl[kl + 1] = Nl, nl[kl + 2] = Nl, nl[kl + 3] = Nl, nl[kl + 4] = Nl, nl[kl + 5] = Nl, nl[kl + 6] = Nl, nl[kl + 7] = Nl);
            for (var ul = 0; ul < 8; ++ul) fl = nl[ul], (Ml = nl[ul + 8]) | (Sl = nl[ul + 16]) | (ml = nl[ul + 24]) | (Dl = nl[ul + 32]) | (_l = nl[ul + 40]) | (gl = nl[ul + 48]) | (Fl = nl[ul + 56]) ? (il = (rl = 4112 + ((rl = Sa * fl + 2048 >> 12) + (il = Sa * Dl + 2048 >> 12) + 1 >> 1)) - il, Nl = (cl = Sl) * Ta + (ll = gl) * wa + 2048 >> 12, cl = cl * wa - ll * Ta + 2048 >> 12, ll = Nl, dl = (al = (al = Ma * (Ml - Fl) + 2048 >> 12) + (dl = _l) + 1 >> 1) - dl, sl = (El = (El = Ma * (Ml + Fl) + 2048 >> 12) + (sl = ml) + 1 >> 1) - sl, Nl = al * xa + El * ya + 2048 >> 12, al = al * ya - El * xa + 2048 >> 12, El = Nl, Nl = sl * _a + dl * ba + 2048 >> 12, sl = sl * ba - dl * _a + 2048 >> 12, (fl = (rl = rl + ll + 1 >> 1) + El) < 16 ? fl = 0 : fl >= 4080 ? fl = 255 : fl >>= 4, (Ml = (il = il + cl + 1 >> 1) + (dl = Nl)) < 16 ? Ml = 0 : Ml >= 4080 ? Ml = 255 : Ml >>= 4, (Sl = (cl = il - cl) + sl) < 16 ? Sl = 0 : Sl >= 4080 ? Sl = 255 : Sl >>= 4, (ml = (ll = rl - ll) + al) < 16 ? ml = 0 : ml >= 4080 ? ml = 255 : ml >>= 4, (Dl = ll - al) < 16 ? Dl = 0 : Dl >= 4080 ? Dl = 255 : Dl >>= 4, (_l = cl - sl) < 16 ? _l = 0 : _l >= 4080 ? _l = 255 : _l >>= 4, (gl = il - dl) < 16 ? gl = 0 : gl >= 4080 ? gl = 255 : gl >>= 4, (Fl = rl - El) < 16 ? Fl = 0 : Fl >= 4080 ? Fl = 255 : Fl >>= 4, Zl[Qa + ul] = fl, Zl[Qa + ul + 8] = Ml, Zl[Qa + ul + 16] = Sl, Zl[Qa + ul + 24] = ml, Zl[Qa + ul + 32] = Dl, Zl[Qa + ul + 40] = _l, Zl[Qa + ul + 48] = gl, Zl[Qa + ul + 56] = Fl) : (Nl = (Nl = Sa * fl + 8192 >> 14) < -2040 ? 0 : Nl >= 2024 ? 255 : Nl + 2056 >> 4, Zl[Qa + ul] = Nl, Zl[Qa + ul + 8] = Nl, Zl[Qa + ul + 16] = Nl, Zl[Qa + ul + 24] = Nl, Zl[Qa + ul + 32] = Nl, Zl[Qa + ul + 40] = Nl, Zl[Qa + ul + 48] = Nl, Zl[Qa + ul + 56] = Nl);
          }
          function el(tl, Qa) {
            for (var nl = Qa.P, rl = Qa.c, il = new Int16Array(64), cl = 0; cl < rl; cl++) for (var ll = 0; ll < nl; ll++)
              Ja(Qa, Na(Qa, cl, ll), il);
            return Qa.D;
          }
          function qa(tl, Qa, nl) {
            nl == null && (nl = Qa);
            var rl = tl.length - 1, il = nl < Qa ? nl : Qa;
            if (Qa >= rl) return null;
            var cl = ma(tl, Qa);
            if (cl >= 65472 && cl <= 65534) return { u: null, M: cl, offset: Qa };
            for (var ll = ma(tl, il); !(ll >= 65472 && ll <= 65534); ) {
              if (++il >= rl) return null;
              ll = ma(tl, il);
            }
            return { u: cl.toString(16), M: ll, offset: il };
          }
          return ka.prototype = { parse(tl, Qa) {
            Qa == null && (Qa = {});
            var nl, rl, il = Qa.F, cl = 0, ll = null, al = null, sl = 0;
            function dl() {
              var Vl = ma(tl, cl), Pl = (cl += 2) + Vl - 2, Ol = qa(tl, Pl, cl);
              Ol && Ol.u && (Pl = Ol.offset);
              var cc = tl.subarray(cl, Pl);
              return cl += cc.length, cc;
            }
            function El(Vl) {
              for (var Pl = Math.ceil(Vl.o / 8 / Vl.X), Ol = Math.ceil(Vl.s / 8 / Vl.B), cc = 0; cc < Vl.W.length; cc++) {
                nc = Vl.W[cc];
                var bl = Math.ceil(Math.ceil(Vl.o / 8) * nc.h / Vl.X), pl = Math.ceil(Math.ceil(Vl.s / 8) * nc.A / Vl.B), Jl = Pl * nc.h, Al = 64 * (Ol * nc.A) * (Jl + 1);
                nc.D = new Int16Array(Al), nc.P = bl, nc.c = pl;
              }
              Vl.m = Pl, Vl.R = Ol;
            }
            var fl = [], Ml = [], Sl = [], ml = ma(tl, cl);
            if (cl += 2, ml !== 65496) throw new Jo("SOI not found");
            ml = ma(tl, cl), cl += 2;
            e: for (; ml !== 65497; ) {
              var Dl, _l, gl;
              switch (ml) {
                case 65504:
                case 65505:
                case 65506:
                case 65507:
                case 65508:
                case 65509:
                case 65510:
                case 65511:
                case 65512:
                case 65513:
                case 65514:
                case 65515:
                case 65516:
                case 65517:
                case 65518:
                case 65519:
                case 65534:
                  var Fl = dl();
                  ml === 65504 && Fl[0] === 74 && Fl[1] === 70 && Fl[2] === 73 && Fl[3] === 70 && Fl[4] === 0 && (ll = { version: { d: Fl[5], T: Fl[6] }, K: Fl[7], j: Fl[8] << 8 | Fl[9], H: Fl[10] << 8 | Fl[11], S: Fl[12], I: Fl[13], C: Fl.subarray(14, 14 + 3 * Fl[12] * Fl[13]) }), ml === 65518 && Fl[0] === 65 && Fl[1] === 100 && Fl[2] === 111 && Fl[3] === 98 && Fl[4] === 101 && (al = { version: Fl[5] << 8 | Fl[6], k: Fl[7] << 8 | Fl[8], q: Fl[9] << 8 | Fl[10], a: Fl[11] });
                  break;
                case 65499:
                  for (var Nl = ma(tl, cl) + (cl += 2) - 2; cl < Nl; ) {
                    var zl = tl[cl++], Zl = new Uint16Array(64);
                    if (zl >> 4) {
                      if (zl >> 4 != 1) throw new Jo("DQT - invalid table spec");
                      for (_l = 0; _l < 64; _l++) Zl[va[_l]] = ma(tl, cl), cl += 2;
                    } else for (_l = 0; _l < 64; _l++) Zl[va[_l]] = tl[cl++];
                    fl[15 & zl] = Zl;
                  }
                  break;
                case 65472:
                case 65473:
                case 65474:
                  if (nl) throw new Jo("Only single frame JPEGs supported");
                  cl += 2, (nl = {}).G = ml === 65473, nl.Z = ml === 65474, nl.precision = tl[cl++];
                  var kl, ul = ma(tl, cl), vl = 0, Tl = 0;
                  cl += 2, nl.s = il || ul, nl.o = ma(tl, cl), cl += 2, nl.W = [], nl._ = {};
                  var wl = tl[cl++];
                  for (Dl = 0; Dl < wl; Dl++) {
                    kl = tl[cl];
                    var yl = tl[cl + 1] >> 4, Rl = 15 & tl[cl + 1];
                    vl < yl && (vl = yl), Tl < Rl && (Tl = Rl);
                    var Ul = tl[cl + 2];
                    gl = nl.W.push({ h: yl, A: Rl, L: Ul, $: null }), nl._[kl] = gl - 1, cl += 3;
                  }
                  nl.X = vl, nl.B = Tl, El(nl);
                  break;
                case 65476:
                  var hl = ma(tl, cl);
                  for (cl += 2, Dl = 2; Dl < hl; ) {
                    var Cl = tl[cl++], Il = new Uint8Array(16), Ll = 0;
                    for (_l = 0; _l < 16; _l++, cl++) Ll += Il[_l] = tl[cl];
                    var tc = new Uint8Array(Ll);
                    for (_l = 0; _l < Ll; _l++, cl++) tc[_l] = tl[cl];
                    Dl += 17 + Ll, (Cl >> 4 ? Ml : Sl)[15 & Cl] = Za(Il, tc);
                  }
                  break;
                case 65501:
                  rl = ma(tl, cl += 2), cl += 2;
                  break;
                case 65498:
                  var nc, uc = ++sl == 1 && !il;
                  cl += 2;
                  var _c = tl[cl++], mc = [];
                  for (Dl = 0; Dl < _c; Dl++) {
                    var Sc = tl[cl++], hc = nl._[Sc];
                    (nc = nl.W[hc]).index = Sc;
                    var Lc = tl[cl++];
                    nc.J = Sl[Lc >> 4], nc.i = Ml[15 & Lc], mc.push(nc);
                  }
                  var Ec = tl[cl++], Hl = tl[cl++], fc = tl[cl++];
                  try {
                    var lc = Ka(tl, cl, nl, mc, rl, Ec, Hl, fc >> 4, 15 & fc, uc);
                    cl += lc;
                  } catch (Vl) {
                    if (Vl instanceof DNLMarkerError) return this.parse(tl, { F: Vl.s });
                    if (Vl instanceof EOIMarkerError) break e;
                    throw Vl;
                  }
                  break;
                case 65500:
                  cl += 4;
                  break;
                case 65535:
                  tl[cl] !== 255 && cl--;
                  break;
                default:
                  var Gl = qa(tl, cl - 2, cl - 3);
                  if (Gl && Gl.u) {
                    cl = Gl.offset;
                    break;
                  }
                  if (cl >= tl.length - 1) break e;
                  throw new Jo("JpegImage.parse - unknown marker: " + ml.toString(16));
              }
              ml = ma(tl, cl), cl += 2;
            }
            for (this.width = nl.o, this.height = nl.s, this.g = ll, this.b = al, this.W = [], Dl = 0; Dl < nl.W.length; Dl++) {
              var ql = fl[(nc = nl.W[Dl]).L];
              ql && (nc.$ = ql), this.W.push({ index: nc.index, e: el(0, nc), l: nc.h / nl.X, t: nc.A / nl.B, P: nc.P, c: nc.c });
            }
            this.p = this.W.length;
          }, Y(tl, Qa, nl) {
            nl == null && (nl = !1);
            var rl, il, cl, ll, al, sl, dl, El, fl, Ml, Sl, ml, Dl = this.width / tl, _l = this.height / Qa, gl = 0, Fl = this.W.length, Nl = tl * Qa * Fl, zl = new Uint8ClampedArray(Nl), Zl = new Uint32Array(tl), kl = 4294967288;
            for (dl = 0; dl < Fl; dl++) {
              if (il = (rl = this.W[dl]).l * Dl, cl = rl.t * _l, gl = dl, Sl = rl.e, ll = rl.P + 1 << 3, il !== ml) {
                for (al = 0; al < tl; al++) El = 0 | al * il, Zl[al] = (El & kl) << 3 | 7 & El;
                ml = il;
              }
              for (sl = 0; sl < Qa; sl++) for (Ml = ll * ((El = 0 | sl * cl) & kl) | (7 & El) << 3, al = 0; al < tl; al++) zl[gl] = Sl[Ml + Zl[al]], gl += Fl;
            }
            var ul = this.V;
            if (nl || Fl !== 4 || ul || (ul = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255])), ul) for (dl = 0; dl < Nl; ) for (El = 0, fl = 0; El < Fl; El++, dl++, fl += 2) zl[dl] = (zl[dl] * ul[fl] >> 8) + ul[fl + 1];
            return zl;
          }, get f() {
            return this.b ? !!this.b.a : this.p === 3 ? this.N !== 0 && (this.W[0].index !== 82 || this.W[1].index !== 71 || this.W[2].index !== 66) : this.N === 1;
          }, z: function(tl) {
            for (var Qa, nl, rl, il = 0, cl = tl.length; il < cl; il += 3) Qa = tl[il], nl = tl[il + 1], rl = tl[il + 2], tl[il] = Qa - 179.456 + 1.402 * rl, tl[il + 1] = Qa + 135.459 - 0.344 * nl - 0.714 * rl, tl[il + 2] = Qa - 226.816 + 1.772 * nl;
            return tl;
          }, O: function(tl) {
            for (var Qa, nl, rl, il, cl = 0, ll = 0, al = tl.length; ll < al; ll += 4) Qa = tl[ll], nl = tl[ll + 1], rl = tl[ll + 2], il = tl[ll + 3], tl[cl++] = nl * (-660635669420364e-19 * nl + 437130475926232e-18 * rl - 54080610064599e-18 * Qa + 48449797120281e-17 * il - 0.154362151871126) - 122.67195406894 + rl * (-957964378445773e-18 * rl + 817076911346625e-18 * Qa - 0.00477271405408747 * il + 1.53380253221734) + Qa * (961250184130688e-18 * Qa - 0.00266257332283933 * il + 0.48357088451265) + il * (-336197177618394e-18 * il + 0.484791561490776), tl[cl++] = 107.268039397724 + nl * (219927104525741e-19 * nl - 640992018297945e-18 * rl + 659397001245577e-18 * Qa + 426105652938837e-18 * il - 0.176491792462875) + rl * (-778269941513683e-18 * rl + 0.00130872261408275 * Qa + 770482631801132e-18 * il - 0.151051492775562) + Qa * (0.00126935368114843 * Qa - 0.00265090189010898 * il + 0.25802910206845) + il * (-318913117588328e-18 * il - 0.213742400323665), tl[cl++] = nl * (-570115196973677e-18 * nl - 263409051004589e-19 * rl + 0.0020741088115012 * Qa - 0.00288260236853442 * il + 0.814272968359295) - 20.810012546947 + rl * (-153496057440975e-19 * rl - 132689043961446e-18 * Qa + 560833691242812e-18 * il - 0.195152027534049) + Qa * (0.00174418132927582 * Qa - 0.00255243321439347 * il + 0.116935020465145) + il * (-343531996510555e-18 * il + 0.24165260232407);
            return tl.subarray(0, cl);
          }, r: function(tl) {
            for (var Qa, nl, rl, il = 0, cl = tl.length; il < cl; il += 4) Qa = tl[il], nl = tl[il + 1], rl = tl[il + 2], tl[il] = 434.456 - Qa - 1.402 * rl, tl[il + 1] = 119.541 - Qa + 0.344 * nl + 0.714 * rl, tl[il + 2] = 481.816 - Qa - 1.772 * nl;
            return tl;
          }, U: function(tl) {
            for (var Qa, nl, rl, il, cl = 0, ll = 0, al = tl.length; ll < al; ll += 4) Qa = tl[ll], nl = tl[ll + 1], rl = tl[ll + 2], il = tl[ll + 3], tl[cl++] = 255 + Qa * (-6747147073602441e-20 * Qa + 8379262121013727e-19 * nl + 2894718188643294e-19 * rl + 0.003264231057537806 * il - 1.1185611867203937) + nl * (26374107616089405e-21 * nl - 8626949158638572e-20 * rl - 2748769067499491e-19 * il - 0.02155688794978967) + rl * (-3878099212869363e-20 * rl - 3267808279485286e-19 * il + 0.0686742238595345) - il * (3361971776183937e-19 * il + 0.7430659151342254), tl[cl++] = 255 + Qa * (13596372813588848e-20 * Qa + 924537132573585e-18 * nl + 10567359618683593e-20 * rl + 4791864687436512e-19 * il - 0.3109689587515875) + nl * (-23545346108370344e-20 * nl + 2702845253534714e-19 * rl + 0.0020200308977307156 * il - 0.7488052167015494) + rl * (6834815998235662e-20 * rl + 15168452363460973e-20 * il - 0.09751927774728933) - il * (3189131175883281e-19 * il + 0.7364883807733168), tl[cl++] = 255 + Qa * (13598650411385307e-21 * Qa + 12423956175490851e-20 * nl + 4751985097583589e-19 * rl - 36729317476630422e-22 * il - 0.05562186980264034) + nl * (16141380598724676e-20 * nl + 9692239130725186e-19 * rl + 7782692450036253e-19 * il - 0.44015232367526463) + rl * (5068882914068769e-22 * rl + 0.0017778369011375071 * il - 0.7591454649749609) - il * (3435319965105553e-19 * il + 0.7063770186160144);
            return tl.subarray(0, cl);
          }, getData: function(tl) {
            var Qa = tl.width, nl = tl.height, rl = tl.forceRGB, il = tl.isSourcePDF;
            if (this.p > 4) throw new Jo("Unsupported color mode");
            var cl = this.Y(Qa, nl, il);
            if (this.p === 1 && rl) {
              for (var ll = cl.length, al = new Uint8ClampedArray(3 * ll), sl = 0, dl = 0; dl < ll; dl++) {
                var El = cl[dl];
                al[sl++] = El, al[sl++] = El, al[sl++] = El;
              }
              return al;
            }
            if (this.p === 3 && this.f) return this.z(cl);
            if (this.p === 4) {
              if (this.f) return rl ? this.O(cl) : this.r(cl);
              if (rl) return this.U(cl);
            }
            return cl;
          } }, ka;
        }();
        function ma(va, ba) {
          return va[ba] << 8 | va[ba + 1];
        }
        Kn.JpegDecoder = pa;
      })(), Kn.encodeImage = function(Jo, pa, ma, va) {
        var ba = { t256: [pa], t257: [ma], t258: [8, 8, 8, 8], t259: [1], t262: [2], t273: [1e3], t277: [4], t278: [ma], t279: [pa * ma * 4], t282: [[72, 1]], t283: [[72, 1]], t284: [1], t286: [[0, 1]], t287: [[0, 1]], t296: [1], t305: ["Photopea (UTIF.js)"], t338: [1] };
        if (va) for (var _a in va) ba[_a] = va[_a];
        var ya = new Uint8Array(Kn.encode([ba])), xa = new Uint8Array(Jo), wa = new Uint8Array(1e3 + pa * ma * 4);
        for (_a = 0; _a < ya.length; _a++) wa[_a] = ya[_a];
        for (_a = 0; _a < xa.length; _a++) wa[1e3 + _a] = xa[_a];
        return wa.buffer;
      }, Kn.encode = function(Jo) {
        var pa = new Uint8Array(2e4), ma = 4, va = Kn._binBE;
        pa[0] = pa[1] = 77, va.writeUshort(pa, 2, 42);
        var ba = 8;
        va.writeUint(pa, ma, ba), ma += 4;
        for (var _a = 0; _a < Jo.length; _a++) {
          var ya = Kn._writeIFD(va, Kn._types.basic, pa, ba, Jo[_a]);
          ba = ya[1], _a < Jo.length - 1 && (3 & ba && (ba += 4 - (3 & ba)), va.writeUint(pa, ya[0], ba));
        }
        return pa.slice(0, ba).buffer;
      }, Kn.decode = function(Jo, pa) {
        pa == null && (pa = { parseMN: !0, debug: !1 });
        var ma = new Uint8Array(Jo), va = 0, ba = Kn._binBE.readASCII(ma, va, 2);
        va += 2;
        var _a = ba == "II" ? Kn._binLE : Kn._binBE;
        _a.readUshort(ma, va), va += 2;
        var ya = _a.readUint(ma, va);
        va += 4;
        for (var xa = []; ; ) {
          var wa = _a.readUshort(ma, ya), Ta = _a.readUshort(ma, ya + 4);
          if (wa != 0 && (Ta < 1 || 13 < Ta)) {
            Un("error in TIFF");
            break;
          }
          if (Kn._readIFD(_a, ma, ya, xa, 0, pa), (ya = _a.readUint(ma, ya + 2 + 12 * wa)) == 0) break;
        }
        return xa;
      }, Kn.decodeImage = function(Jo, pa, ma) {
        if (!pa.data) {
          var va = new Uint8Array(Jo), ba = Kn._binBE.readASCII(va, 0, 2);
          if (pa.t256 != null) {
            pa.isLE = ba == "II", pa.width = pa.t256[0], pa.height = pa.t257[0];
            var _a = pa.t259 ? pa.t259[0] : 1, ya = pa.t266 ? pa.t266[0] : 1;
            pa.t284 && pa.t284[0] == 2 && Un("PlanarConfiguration 2 should not be used!"), _a == 7 && pa.t258 && pa.t258.length > 3 && (pa.t258 = pa.t258.slice(0, 3));
            var xa = pa.t277 ? pa.t277[0] : 1, wa = (pa.t258 ? pa.t258[0] : 1) * xa;
            _a == 1 && pa.t279 != null && pa.t278 && pa.t262[0] == 32803 && (wa = Math.round(8 * pa.t279[0] / (pa.width * pa.t278[0]))), pa.t50885 && pa.t50885[0] == 4 && (wa = 3 * pa.t258[0]);
            var Ta = 8 * Math.ceil(pa.width * wa / 8), Sa = pa.t273;
            (Sa == null || pa.t322) && (Sa = pa.t324);
            var Ma = pa.t279;
            _a == 1 && Sa.length == 1 && (Ma = [pa.height * (Ta >>> 3)]), (Ma == null || pa.t322) && (Ma = pa.t325);
            var ka = new Uint8Array(pa.height * (Ta >>> 3)), Za = 0;
            if (pa.t322 != null) {
              var Na = pa.t322[0], Ka = pa.t323[0], Ja = Math.floor((pa.width + Na - 1) / Na), el = Math.floor((pa.height + Ka - 1) / Ka), qa = new Uint8Array(0 | Math.ceil(Na * Ka * wa / 8));
              console.log("====", Ja, el);
              for (var tl = 0; tl < el; tl++) for (var Qa = 0; Qa < Ja; Qa++) {
                var nl = tl * Ja + Qa;
                qa.fill(0), Kn.decode._decompress(pa, ma, va, Sa[nl], Ma[nl], _a, qa, 0, ya, Na, Ka), _a == 6 ? ka = qa : Kn._copyTile(qa, 0 | Math.ceil(Na * wa / 8), Ka, ka, 0 | Math.ceil(pa.width * wa / 8), pa.height, 0 | Math.ceil(Qa * Na * wa / 8), tl * Ka);
              }
              Za = 8 * ka.length;
            } else {
              if (Sa == null) return;
              var rl = pa.t278 ? pa.t278[0] : pa.height;
              for (rl = Math.min(rl, pa.height), nl = 0; nl < Sa.length; nl++) Kn.decode._decompress(pa, ma, va, Sa[nl], Ma[nl], _a, ka, 0 | Math.ceil(Za / 8), ya, pa.width, rl), Za += Ta * rl;
              Za = Math.min(Za, 8 * ka.length);
            }
            pa.data = new Uint8Array(ka.buffer, 0, 0 | Math.ceil(Za / 8));
          }
        }
      }, Kn.decode._decompress = function(Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa) {
        if (Jo.t271 && Jo.t271[0] == "Panasonic" && Jo.t45 && Jo.t45[0] == 6 && (_a = 34316), _a == 1) for (var Ma = 0; Ma < ba; Ma++) ya[xa + Ma] = ma[va + Ma];
        else if (_a == 2) Kn.decode._decodeG2(ma, va, ba, ya, xa, Ta, wa);
        else if (_a == 3) Kn.decode._decodeG3(ma, va, ba, ya, xa, Ta, wa, !!Jo.t292 && !(1 & ~Jo.t292[0]));
        else if (_a == 4) Kn.decode._decodeG4(ma, va, ba, ya, xa, Ta, wa);
        else if (_a == 5) Kn.decode._decodeLZW(ma, va, ba, ya, xa, 8);
        else if (_a == 6) Kn.decode._decodeOldJPEG(Jo, ma, va, ba, ya, xa);
        else if (_a == 7 || _a == 34892) Kn.decode._decodeNewJPEG(Jo, ma, va, ba, ya, xa);
        else if (_a == 8 || _a == 32946) {
          var ka = new Uint8Array(ma.buffer, va + 2, ba - 6), Za = qn.inflateRaw(ka);
          xa + Za.length <= ya.length && ya.set(Za, xa);
        } else _a == 9 ? Kn.decode._decodeVC5(ma, va, ba, ya, xa, Jo.t33422) : _a == 32767 ? Kn.decode._decodeARW(Jo, ma, va, ba, ya, xa) : _a == 32773 ? Kn.decode._decodePackBits(ma, va, ba, ya, xa) : _a == 32809 ? Kn.decode._decodeThunder(ma, va, ba, ya, xa) : _a == 34316 ? Kn.decode._decodePanasonic(Jo, ma, va, ba, ya, xa) : _a == 34713 ? Kn.decode._decodeNikon(Jo, pa, ma, va, ba, ya, xa) : _a == 34676 ? Kn.decode._decodeLogLuv32(Jo, ma, va, ba, ya, xa) : Un("Unknown compression", _a);
        var Na = Jo.t258 ? Math.min(32, Jo.t258[0]) : 1, Ka = Jo.t277 ? Jo.t277[0] : 1, Ja = Na * Ka >>> 3, el = Math.ceil(Na * Ka * Ta / 8);
        if (Na == 16 && !Jo.isLE && Jo.t33422 == null) for (var qa = 0; qa < Sa; qa++) for (var tl = xa + qa * el, Qa = 1; Qa < el; Qa += 2) {
          var nl = ya[tl + Qa];
          ya[tl + Qa] = ya[tl + Qa - 1], ya[tl + Qa - 1] = nl;
        }
        if (Jo.t317 && Jo.t317[0] == 2) for (qa = 0; qa < Sa; qa++) {
          var rl = xa + qa * el;
          if (Na == 16) for (Ma = Ja; Ma < el; Ma += 2) {
            var il = (ya[rl + Ma + 1] << 8 | ya[rl + Ma]) + (ya[rl + Ma - Ja + 1] << 8 | ya[rl + Ma - Ja]);
            ya[rl + Ma] = 255 & il, ya[rl + Ma + 1] = il >>> 8 & 255;
          }
          else if (Ka == 3) for (Ma = 3; Ma < el; Ma += 3) ya[rl + Ma] = ya[rl + Ma] + ya[rl + Ma - 3] & 255, ya[rl + Ma + 1] = ya[rl + Ma + 1] + ya[rl + Ma - 2] & 255, ya[rl + Ma + 2] = ya[rl + Ma + 2] + ya[rl + Ma - 1] & 255;
          else for (Ma = Ja; Ma < el; Ma++) ya[rl + Ma] = ya[rl + Ma] + ya[rl + Ma - Ja] & 255;
        }
      }, Kn.decode._decodePanasonic = function(Jo, pa, ma, va, ba, _a) {
        var ya, xa, wa, Ta, Sa, Ma, ka, Za, Na = pa.buffer, Ka = Jo.t2[0], Ja = Jo.t3[0], el = Jo.t10[0], qa = Jo.t45[0], tl = 0, Qa = 0, nl = 0, rl = 0, il = qa == 6 ? new Uint32Array(18) : new Uint8Array(16), cl = [0, 0], ll = [0, 0], al = 0, sl = new Uint8Array(16384), dl = new Uint16Array(ba.buffer);
        function El(Ul) {
          if (nl == 0) {
            var hl = new Uint8Array(Na, ma + Qa + 8184, 8200), Cl = new Uint8Array(Na, ma + Qa, 8184);
            sl.set(hl), sl.set(Cl, hl.length), Qa += 16384;
          }
          if (qa != 5) return (sl[rl = (nl = nl - Ul & 131071) >> 3 ^ 16368] | sl[rl + 1] << 8) >> (7 & nl) & ~(-1 << Ul);
          for (ya = 0; ya < 16; ya++) il[ya] = sl[nl++], nl &= 16383;
        }
        function fl(Ul) {
          return sl[nl + 15 - Ul];
        }
        function Ml() {
          cl[0] = 0, cl[1] = 0, ll[0] = 0, ll[1] = 0;
        }
        if (qa == 7) throw qa;
        if (qa == 6) {
          var Sl = el == 12, ml = Sl ? function() {
            il[0] = fl(0) << 4 | fl(1) >> 4, il[1] = 4095 & ((15 & fl(1)) << 8 | fl(2)), il[2] = fl(3) >> 6 & 3, il[3] = (63 & fl(3)) << 2 | fl(4) >> 6, il[4] = (63 & fl(4)) << 2 | fl(5) >> 6, il[5] = (63 & fl(5)) << 2 | fl(6) >> 6, il[6] = fl(6) >> 4 & 3, il[7] = (15 & fl(6)) << 4 | fl(7) >> 4, il[8] = (15 & fl(7)) << 4 | fl(8) >> 4, il[9] = (15 & fl(8)) << 4 | fl(9) >> 4, il[10] = fl(9) >> 2 & 3, il[11] = (3 & fl(9)) << 6 | fl(10) >> 2, il[12] = (3 & fl(10)) << 6 | fl(11) >> 2, il[13] = (3 & fl(11)) << 6 | fl(12) >> 2, il[14] = 3 & fl(12), il[15] = fl(13), il[16] = fl(14), il[17] = fl(15), nl += 16, rl = 0;
          } : function() {
            il[0] = fl(0) << 6 | fl(1) >> 2, il[1] = 16383 & ((3 & fl(1)) << 12 | fl(2) << 4 | fl(3) >> 4), il[2] = fl(3) >> 2 & 3, il[3] = (3 & fl(3)) << 8 | fl(4), il[4] = fl(5) << 2 | fl(6) >> 6, il[5] = (63 & fl(6)) << 4 | fl(7) >> 4, il[6] = fl(7) >> 2 & 3, il[7] = (3 & fl(7)) << 8 | fl(8), il[8] = fl(9) << 2 & 1020 | fl(10) >> 6, il[9] = 1023 & (fl(10) << 4 | fl(11) >> 4), il[10] = fl(11) >> 2 & 3, il[11] = (3 & fl(11)) << 8 | fl(12), il[12] = 1023 & (fl(13) << 2 & 1020 | fl(14) >> 6), il[13] = 1023 & (fl(14) << 4 | fl(15) >> 4), nl += 16, rl = 0;
          }, Dl = Sl ? 14 : 11, _l = Sl ? 128 : 512, gl = Sl ? 2048 : 8192, Fl = Sl ? 16383 : 65535, Nl = Sl ? 4095 : 16383, zl = Ka / Dl, Zl = 16 * zl, kl = Sl ? 18 : 14;
          for (Ma = 0; Ma < Ja - 15; Ma += 16) {
            var ul = Math.min(16, Ja - Ma), vl = Zl * ul;
            for (sl = new Uint8Array(Na, ma + tl, vl), nl = 0, tl += vl, Za = 0, ka = 0; Za < ul; Za++, ka = 0) {
              al = (Ma + Za) * Ka;
              for (var Tl = 0; Tl < zl; Tl++) for (ml(), Ml(), wa = 0, Sa = 0, ya = 0; ya < Dl; ya++) {
                if (Ta = 1 & ya, ya % 3 == 2) {
                  var wl = rl < kl ? il[rl++] : 0;
                  wl == 3 && (wl = 4), Sa = _l << wl, wa = 1 << wl;
                }
                var yl = rl < kl ? il[rl++] : 0;
                cl[Ta] ? (yl *= wa, Sa < gl && ll[Ta] > Sa && (yl += ll[Ta] - Sa), ll[Ta] = yl) : (cl[Ta] = yl, yl ? ll[Ta] = yl : yl = ll[Ta]), dl[al + ka++] = yl - 15 <= Fl ? yl - 15 & Fl : yl + 2147483633 >> 31 & Nl;
              }
            }
          }
        } else if (qa == 5) {
          var Rl = el == 12 ? 10 : 9;
          for (Ma = 0; Ma < Ja; Ma++) for (ka = 0; ka < Ka; ka += Rl) El(0), el == 12 ? (dl[al++] = ((15 & il[1]) << 8) + il[0], dl[al++] = 16 * il[2] + (il[1] >> 4), dl[al++] = ((15 & il[4]) << 8) + il[3], dl[al++] = 16 * il[5] + (il[4] >> 4), dl[al++] = ((15 & il[7]) << 8) + il[6], dl[al++] = 16 * il[8] + (il[7] >> 4), dl[al++] = ((15 & il[10]) << 8) + il[9], dl[al++] = 16 * il[11] + (il[10] >> 4), dl[al++] = ((15 & il[13]) << 8) + il[12], dl[al++] = 16 * il[14] + (il[13] >> 4)) : el == 14 && (dl[al++] = il[0] + ((63 & il[1]) << 8), dl[al++] = (il[1] >> 6) + 4 * il[2] + ((15 & il[3]) << 10), dl[al++] = (il[3] >> 4) + 16 * il[4] + ((3 & il[5]) << 12), dl[al++] = ((252 & il[5]) >> 2) + (il[6] << 6), dl[al++] = il[7] + ((63 & il[8]) << 8), dl[al++] = (il[8] >> 6) + 4 * il[9] + ((15 & il[10]) << 10), dl[al++] = (il[10] >> 4) + 16 * il[11] + ((3 & il[12]) << 12), dl[al++] = ((252 & il[12]) >> 2) + (il[13] << 6), dl[al++] = il[14] + ((63 & il[15]) << 8));
        } else {
          if (qa != 4) throw qa;
          for (Ma = 0; Ma < Ja; Ma++) for (ka = 0; ka < Ka; ka++) Ta = 1 & (ya = ka % 14), ya == 0 && Ml(), ya % 3 == 2 && (wa = 4 >> 3 - El(2)), ll[Ta] ? (xa = El(8)) != 0 && (cl[Ta] -= 128 << wa, (cl[Ta] < 0 || wa == 4) && (cl[Ta] &= ~(-1 << wa)), cl[Ta] += xa << wa) : (ll[Ta] = El(8), (ll[Ta] || ya > 11) && (cl[Ta] = ll[Ta] << 4 | El(4))), dl[al++] = cl[1 & ka];
        }
      }, Kn.decode._decodeVC5 = /* @__PURE__ */ function() {
        var Jo, pa, ma, va = [1, 0, 1, 0, 2, 2, 1, 1, 3, 7, 1, 2, 5, 25, 1, 3, 6, 48, 1, 4, 6, 54, 1, 5, 7, 111, 1, 8, 7, 99, 1, 6, 7, 105, 12, 0, 7, 107, 1, 7, 8, 209, 20, 0, 8, 212, 1, 9, 8, 220, 1, 10, 9, 393, 1, 11, 9, 394, 32, 0, 9, 416, 1, 12, 9, 427, 1, 13, 10, 887, 1, 18, 10, 784, 1, 14, 10, 790, 1, 15, 10, 835, 60, 0, 10, 852, 1, 16, 10, 885, 1, 17, 11, 1571, 1, 19, 11, 1668, 1, 20, 11, 1669, 100, 0, 11, 1707, 1, 21, 11, 1772, 1, 22, 12, 3547, 1, 29, 12, 3164, 1, 24, 12, 3166, 1, 25, 12, 3140, 1, 23, 12, 3413, 1, 26, 12, 3537, 1, 27, 12, 3539, 1, 28, 13, 7093, 1, 35, 13, 6283, 1, 30, 13, 6331, 1, 31, 13, 6335, 180, 0, 13, 6824, 1, 32, 13, 7072, 1, 33, 13, 7077, 320, 0, 13, 7076, 1, 34, 14, 12565, 1, 36, 14, 12661, 1, 37, 14, 12669, 1, 38, 14, 13651, 1, 39, 14, 14184, 1, 40, 15, 28295, 1, 46, 15, 28371, 1, 47, 15, 25320, 1, 42, 15, 25336, 1, 43, 15, 25128, 1, 41, 15, 27300, 1, 44, 15, 28293, 1, 45, 16, 50259, 1, 48, 16, 50643, 1, 49, 16, 50675, 1, 50, 16, 56740, 1, 53, 16, 56584, 1, 51, 16, 56588, 1, 52, 17, 113483, 1, 61, 17, 113482, 1, 60, 17, 101285, 1, 55, 17, 101349, 1, 56, 17, 109205, 1, 57, 17, 109207, 1, 58, 17, 100516, 1, 54, 17, 113171, 1, 59, 18, 202568, 1, 62, 18, 202696, 1, 63, 18, 218408, 1, 64, 18, 218412, 1, 65, 18, 226340, 1, 66, 18, 226356, 1, 67, 18, 226358, 1, 68, 19, 402068, 1, 69, 19, 405138, 1, 70, 19, 405394, 1, 71, 19, 436818, 1, 72, 19, 436826, 1, 73, 19, 452714, 1, 75, 19, 452718, 1, 76, 19, 452682, 1, 74, 20, 804138, 1, 77, 20, 810279, 1, 78, 20, 810790, 1, 79, 20, 873638, 1, 80, 20, 873654, 1, 81, 20, 905366, 1, 82, 20, 905430, 1, 83, 20, 905438, 1, 84, 21, 1608278, 1, 85, 21, 1620557, 1, 86, 21, 1621582, 1, 87, 21, 1621583, 1, 88, 21, 1747310, 1, 89, 21, 1810734, 1, 90, 21, 1810735, 1, 91, 21, 1810863, 1, 92, 21, 1810879, 1, 93, 22, 3621725, 1, 99, 22, 3621757, 1, 100, 22, 3241112, 1, 94, 22, 3494556, 1, 95, 22, 3494557, 1, 96, 22, 3494622, 1, 97, 22, 3494623, 1, 98, 23, 6482227, 1, 102, 23, 6433117, 1, 101, 23, 6989117, 1, 103, 23, 6989119, 1, 105, 23, 6989118, 1, 104, 23, 7243449, 1, 106, 23, 7243512, 1, 107, 24, 13978233, 1, 111, 24, 12964453, 1, 109, 24, 12866232, 1, 108, 24, 14486897, 1, 113, 24, 13978232, 1, 110, 24, 14486896, 1, 112, 24, 14487026, 1, 114, 24, 14487027, 1, 115, 25, 25732598, 1, 225, 25, 25732597, 1, 189, 25, 25732596, 1, 188, 25, 25732595, 1, 203, 25, 25732594, 1, 202, 25, 25732593, 1, 197, 25, 25732592, 1, 207, 25, 25732591, 1, 169, 25, 25732590, 1, 223, 25, 25732589, 1, 159, 25, 25732522, 1, 235, 25, 25732579, 1, 152, 25, 25732575, 1, 192, 25, 25732489, 1, 179, 25, 25732573, 1, 201, 25, 25732472, 1, 172, 25, 25732576, 1, 149, 25, 25732488, 1, 178, 25, 25732566, 1, 120, 25, 25732571, 1, 219, 25, 25732577, 1, 150, 25, 25732487, 1, 127, 25, 25732506, 1, 211, 25, 25732548, 1, 125, 25, 25732588, 1, 158, 25, 25732486, 1, 247, 25, 25732467, 1, 238, 25, 25732508, 1, 163, 25, 25732552, 1, 228, 25, 25732603, 1, 183, 25, 25732513, 1, 217, 25, 25732587, 1, 168, 25, 25732520, 1, 122, 25, 25732484, 1, 128, 25, 25732562, 1, 249, 25, 25732505, 1, 187, 25, 25732504, 1, 186, 25, 25732483, 1, 136, 25, 25928905, 1, 181, 25, 25732560, 1, 255, 25, 25732500, 1, 230, 25, 25732482, 1, 135, 25, 25732555, 1, 233, 25, 25732568, 1, 222, 25, 25732583, 1, 145, 25, 25732481, 1, 134, 25, 25732586, 1, 167, 25, 25732521, 1, 248, 25, 25732518, 1, 209, 25, 25732480, 1, 243, 25, 25732512, 1, 216, 25, 25732509, 1, 164, 25, 25732547, 1, 140, 25, 25732479, 1, 157, 25, 25732544, 1, 239, 25, 25732574, 1, 191, 25, 25732564, 1, 251, 25, 25732478, 1, 156, 25, 25732546, 1, 139, 25, 25732498, 1, 242, 25, 25732557, 1, 133, 25, 25732477, 1, 162, 25, 25732515, 1, 213, 25, 25732584, 1, 165, 25, 25732514, 1, 212, 25, 25732476, 1, 227, 25, 25732494, 1, 198, 25, 25732531, 1, 236, 25, 25732530, 1, 234, 25, 25732529, 1, 117, 25, 25732528, 1, 215, 25, 25732527, 1, 124, 25, 25732526, 1, 123, 25, 25732525, 1, 254, 25, 25732524, 1, 253, 25, 25732523, 1, 148, 25, 25732570, 1, 218, 25, 25732580, 1, 146, 25, 25732581, 1, 147, 25, 25732569, 1, 224, 25, 25732533, 1, 143, 25, 25732540, 1, 184, 25, 25732541, 1, 185, 25, 25732585, 1, 166, 25, 25732556, 1, 132, 25, 25732485, 1, 129, 25, 25732563, 1, 250, 25, 25732578, 1, 151, 25, 25732501, 1, 119, 25, 25732502, 1, 193, 25, 25732536, 1, 176, 25, 25732496, 1, 245, 25, 25732553, 1, 229, 25, 25732516, 1, 206, 25, 25732582, 1, 144, 25, 25732517, 1, 208, 25, 25732558, 1, 137, 25, 25732543, 1, 241, 25, 25732466, 1, 237, 25, 25732507, 1, 190, 25, 25732542, 1, 240, 25, 25732551, 1, 131, 25, 25732554, 1, 232, 25, 25732565, 1, 252, 25, 25732475, 1, 171, 25, 25732493, 1, 205, 25, 25732492, 1, 204, 25, 25732491, 1, 118, 25, 25732490, 1, 214, 25, 25928904, 1, 180, 25, 25732549, 1, 126, 25, 25732602, 1, 182, 25, 25732539, 1, 175, 25, 25732545, 1, 141, 25, 25732559, 1, 138, 25, 25732537, 1, 177, 25, 25732534, 1, 153, 25, 25732503, 1, 194, 25, 25732606, 1, 160, 25, 25732567, 1, 121, 25, 25732538, 1, 174, 25, 25732497, 1, 246, 25, 25732550, 1, 130, 25, 25732572, 1, 200, 25, 25732474, 1, 170, 25, 25732511, 1, 221, 25, 25732601, 1, 196, 25, 25732532, 1, 142, 25, 25732519, 1, 210, 25, 25732495, 1, 199, 25, 25732605, 1, 155, 25, 25732535, 1, 154, 25, 25732499, 1, 244, 25, 25732510, 1, 220, 25, 25732600, 1, 195, 25, 25732607, 1, 161, 25, 25732604, 1, 231, 25, 25732473, 1, 173, 25, 25732599, 1, 226, 26, 51465122, 1, 116, 26, 51465123, 0, 1], ba = [3, 3, 3, 3, 2, 2, 2, 1, 1, 1];
        function _a(Za) {
          var Na = Za[1], Ka = Za[0][Na >>> 3] >>> 7 - (7 & Na) & 1;
          return Za[1]++, Ka;
        }
        function ya(Za, Na) {
          if (Jo == null) {
            Jo = {};
            for (var Ka = 0; Ka < va.length; Ka += 4) Jo[va[Ka + 1]] = va.slice(Ka, Ka + 4);
          }
          for (var Ja = _a(Za), el = Jo[Ja]; el == null; ) Ja = Ja << 1 | _a(Za), el = Jo[Ja];
          var qa = el[3];
          qa != 0 && (qa = _a(Za) == 0 ? qa : -qa), Na[0] = el[2], Na[1] = qa;
        }
        function xa(Za, Na) {
          for (var Ka = 0; Ka < Na; Ka++) 1 & ~Za || Za++, Za >>>= 1;
          return Za;
        }
        function wa(Za, Na) {
          return Za >> Na;
        }
        function Ta(Za, Na, Ka, Ja, el, qa) {
          Na[Ka] = wa(wa(11 * Za[el] - 4 * Za[el + qa] + Za[el + qa + qa] + 4, 3) + Za[Ja], 1), Na[Ka + qa] = wa(wa(5 * Za[el] + 4 * Za[el + qa] - Za[el + qa + qa] + 4, 3) - Za[Ja], 1);
        }
        function Sa(Za, Na, Ka, Ja, el, qa) {
          var tl = Za[el - qa] - Za[el + qa], Qa = Za[el], nl = Za[Ja];
          Na[Ka] = wa(wa(tl + 4, 3) + Qa + nl, 1), Na[Ka + qa] = wa(wa(4 - tl, 3) + Qa - nl, 1);
        }
        function Ma(Za, Na, Ka, Ja, el, qa) {
          Na[Ka] = wa(wa(5 * Za[el] + 4 * Za[el - qa] - Za[el - qa - qa] + 4, 3) + Za[Ja], 1), Na[Ka + qa] = wa(wa(11 * Za[el] - 4 * Za[el - qa] + Za[el - qa - qa] + 4, 3) - Za[Ja], 1);
        }
        function ka(Za) {
          return Za = ma[Za = Za < 0 ? 0 : Za > 4095 ? 4095 : Za] >>> 2;
        }
        return function(Za, Na, Ka, Ja, el, qa) {
          Ja = new Uint16Array(Ja.buffer);
          var tl, Qa, nl, rl, il, cl, ll, al, sl = Date.now(), dl = Kn._binBE, El = Na + Ka;
          Na += 4;
          for (var fl = qa[0] == 1; Na < El; ) {
            var Ml = dl.readShort(Za, Na), Sl = dl.readUshort(Za, Na + 2);
            if (Na += 4, Ml == 12) zl = Sl;
            else if (Ml == 20) tl = Sl;
            else if (Ml == 21) Qa = Sl;
            else if (Ml == 48) nl = Sl;
            else if (Ml == 53) rl = Sl;
            else if (Ml != 35) {
              if (Ml == 62) il = Sl;
              else if (Ml != 101) {
                if (Ml == 109) cl = Sl;
                else if (Ml != 84) {
                  if (Ml != 106) {
                    if (Ml != 107) {
                      if (Ml != 108) {
                        if (Ml != 102) {
                          if (Ml == 104) hc = Sl;
                          else if (Ml != 105) {
                            var ml = Ml < 0 ? -Ml : Ml, Dl = 65280 & ml, _l = 0;
                            if (24576 & ml && (8192 & ml ? (_l = 65535 & Sl, _l += (255 & ml) << 16) : _l = 65535 & Sl), 24576 & ~ml) {
                              if (ml == 16388) Na += 4 * _l;
                              else if (Dl != 8192 && Dl != 8448 && Dl != 9216) throw ml.toString(16);
                            } else {
                              if (ll == null) {
                                ll = [];
                                for (var gl = 0; gl < 4; gl++) ll[gl] = new Int16Array((tl >>> 1) * (Qa >>> 1));
                                for (al = new Int16Array((tl >>> 1) * (Qa >>> 1)), pa = new Int16Array(1024), gl = 0; gl < 1024; gl++) {
                                  var Fl = gl - 512, Nl = Math.abs(Fl), zl = Math.floor(768 * Nl * Nl * Nl / 16581375) + Nl;
                                  pa[gl] = Math.sign(Fl) * zl;
                                }
                                for (ma = new Uint16Array(4096), gl = 0; gl < 4096; gl++) {
                                  var Zl = gl, kl = 65535 * (Math.pow(113, Zl / 4095) - 1) / 112;
                                  ma[gl] = Math.min(kl, 65535);
                                }
                              }
                              var ul = ll[il], vl = xa(tl, 1 + ba[nl]), Tl = xa(Qa, 1 + ba[nl]);
                              if (nl == 0) for (var wl = 0; wl < Tl; wl++) for (var yl = 0; yl < vl; yl++) {
                                var Rl = Na + 2 * (wl * vl + yl);
                                ul[wl * (tl >>> 1) + yl] = Za[Rl] << 8 | Za[Rl + 1];
                              }
                              else {
                                var Ul = [Za, 8 * Na], hl = [], Cl = 0, Il = vl * Tl, Ll = [0, 0], tc = 0;
                                for (Sl = 0; Cl < Il; ) for (ya(Ul, Ll), tc = Ll[0], Sl = Ll[1]; tc > 0; ) hl[Cl++] = Sl, tc--;
                                var nc = (nl - 1) % 3, uc = nc != 1 ? vl : 0, _c = nc != 0 ? Tl : 0;
                                for (wl = 0; wl < Tl; wl++) {
                                  var mc = (wl + _c) * (tl >>> 1) + uc, Sc = wl * vl;
                                  for (yl = 0; yl < vl; yl++) ul[mc + yl] = pa[hl[Sc + yl] + 512] * rl;
                                }
                                if (nc == 2) {
                                  var hc = tl >>> 1, Lc = 2 * vl, Ec = 2 * Tl;
                                  for (wl = 0; wl < Tl; wl++) for (yl = 0; yl < Lc; yl++) {
                                    gl = 2 * wl * hc + yl;
                                    var Hl = Tl * hc + (lc = wl * hc + yl);
                                    wl == 0 ? Ta(ul, al, gl, Hl, lc, hc) : wl == Tl - 1 ? Ma(ul, al, gl, Hl, lc, hc) : Sa(ul, al, gl, Hl, lc, hc);
                                  }
                                  var fc = ul;
                                  for (ul = al, al = fc, wl = 0; wl < Ec; wl++) for (yl = 0; yl < vl; yl++) {
                                    var lc;
                                    gl = wl * hc + 2 * yl, Hl = vl + (lc = wl * hc + yl), yl == 0 ? Ta(ul, al, gl, Hl, lc, 1) : yl == vl - 1 ? Ma(ul, al, gl, Hl, lc, 1) : Sa(ul, al, gl, Hl, lc, 1);
                                  }
                                  fc = ul, ul = al, al = fc;
                                  for (var Gl = [], ql = 2 - ~~((nl - 1) / 3), Vl = 0; Vl < 3; Vl++) Gl[Vl] = cl >> 14 - 2 * Vl & 3;
                                  var Pl = Gl[ql];
                                  if (Pl != 0) for (wl = 0; wl < Ec; wl++) for (yl = 0; yl < Lc; yl++)
                                    ul[gl = wl * hc + yl] = ul[gl] << Pl;
                                }
                              }
                              if (nl == 9 && il == 3) {
                                var Ol = ll[0], cc = ll[1], bl = ll[2], pl = ll[3];
                                for (wl = 0; wl < Qa; wl += 2) for (yl = 0; yl < tl; yl += 2) {
                                  var Jl = wl * tl + yl, Al = Ol[Rl = (wl >>> 1) * (tl >>> 1) + (yl >>> 1)], Bl = cc[Rl] - 2048, Kl = bl[Rl] - 2048, oc = pl[Rl] - 2048, xc = (Bl << 1) + Al, vc = (Kl << 1) + Al, Pc = Al + oc, Hc = Al - oc;
                                  fl ? (Ja[Jl] = ka(Pc), Ja[Jl + 1] = ka(vc), Ja[Jl + tl] = ka(xc), Ja[Jl + tl + 1] = ka(Hc)) : (Ja[Jl] = ka(xc), Ja[Jl + 1] = ka(Pc), Ja[Jl + tl] = ka(Hc), Ja[Jl + tl + 1] = ka(vc));
                                }
                              }
                              Na += 4 * _l;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          console.log(Date.now() - sl);
        };
      }(), Kn.decode._decodeLogLuv32 = function(Jo, pa, ma, va, ba, _a) {
        for (var ya = Jo.width, xa = 4 * ya, wa = 0, Ta = new Uint8Array(xa); wa < va; ) {
          for (var Sa = 0; Sa < xa; ) {
            var Ma = pa[ma + wa];
            if (wa++, Ma < 128) {
              for (var ka = 0; ka < Ma; ka++) Ta[Sa + ka] = pa[ma + wa + ka];
              Sa += Ma, wa += Ma;
            } else {
              for (Ma -= 126, ka = 0; ka < Ma; ka++) Ta[Sa + ka] = pa[ma + wa];
              Sa += Ma, wa++;
            }
          }
          for (var Za = 0; Za < ya; Za++) ba[_a + 0] = Ta[Za], ba[_a + 1] = Ta[Za + ya], ba[_a + 2] = Ta[Za + 2 * ya], ba[_a + 4] = Ta[Za + 3 * ya], _a += 6;
        }
      }, Kn.decode._ljpeg_diff = function(Jo, pa, ma) {
        var va, ba, _a = Kn.decode._getbithuff;
        return va = _a(Jo, pa, ma[0], ma), (ba = _a(Jo, pa, va, 0)) & 1 << va - 1 || (ba -= (1 << va) - 1), ba;
      }, Kn.decode._decodeARW = function(Jo, pa, ma, va, ba, _a) {
        var ya = Jo.t256[0], xa = Jo.t257[0], wa = Jo.t258[0], Ta = Jo.isLE ? Kn._binLE : Kn._binBE;
        if (ya * xa == va || ya * xa * 1.5 == va) if (ya * xa * 1.5 != va) {
          var Sa, Ma, ka, Za, Na, Ka, Ja, el, qa = new Uint16Array(16), tl = new Uint8Array(ya + 1);
          for (sl = 0; sl < xa; sl++) {
            for (var Qa = 0; Qa < ya; Qa++) tl[Qa] = pa[ma++];
            for (el = 0, al = 0; al < ya - 30; el += 16) {
              for (Ma = 2047 & (Sa = Ta.readUint(tl, el)), ka = 2047 & Sa >>> 11, Za = 15 & Sa >>> 22, Na = 15 & Sa >>> 26, Ka = 0; Ka < 4 && 128 << Ka <= Ma - ka; Ka++) ;
              for (Ja = 30, nl = 0; nl < 16; nl++) nl == Za ? qa[nl] = Ma : nl == Na ? qa[nl] = ka : (qa[nl] = ((Ta.readUshort(tl, el + (Ja >> 3)) >>> (7 & Ja) & 127) << Ka) + ka, qa[nl] > 2047 && (qa[nl] = 2047), Ja += 7);
              for (nl = 0; nl < 16; nl++, al += 2)
                _l = qa[nl] << 1, Kn.decode._putsF(ba, (sl * ya + al) * wa, _l << 16 - wa);
              al -= 1 & al ? 1 : 31;
            }
          }
        } else for (var nl = 0; nl < va; nl += 3) {
          var rl = pa[ma + nl + 0], il = pa[ma + nl + 1], cl = pa[ma + nl + 2];
          ba[_a + nl] = il << 4 | rl >>> 4, ba[_a + nl + 1] = rl << 4 | cl >>> 4, ba[_a + nl + 2] = cl << 4 | il >>> 4;
        }
        else {
          xa += 8;
          var ll, al, sl, dl = [ma, 0, 0, 0], El = new Uint16Array(32770), fl = [3857, 3856, 3599, 3342, 3085, 2828, 2571, 2314, 2057, 1800, 1543, 1286, 1029, 772, 771, 768, 514, 513], Ml = 0, Sl = Kn.decode._ljpeg_diff;
          for (El[0] = 15, ll = nl = 0; nl < 18; nl++) for (var ml = 32768 >>> (fl[nl] >>> 8), Dl = 0; Dl < ml; Dl++) El[++ll] = fl[nl];
          for (al = ya; al--; ) for (sl = 0; sl < xa + 1; sl += 2) if (sl == xa && (sl = 1), Ml += Sl(pa, dl, El), sl < xa) {
            var _l = 4095 & Ml;
            Kn.decode._putsF(ba, (sl * ya + al) * wa, _l << 16 - wa);
          }
        }
      }, Kn.decode._decodeNikon = function(Jo, pa, ma, va, ba, _a, ya) {
        var xa = [[0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 2, 0, 0, 0, 0, 0, 0, 5, 4, 3, 6, 2, 7, 1, 0, 8, 9, 11, 10, 12], [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 2, 0, 0, 0, 0, 0, 0, 57, 90, 56, 39, 22, 5, 4, 3, 2, 1, 0, 11, 12, 12], [0, 0, 1, 4, 2, 3, 1, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 4, 6, 3, 7, 2, 8, 1, 9, 0, 10, 11, 12], [0, 0, 1, 4, 3, 1, 1, 1, 1, 1, 2, 0, 0, 0, 0, 0, 0, 5, 6, 4, 7, 8, 3, 9, 2, 1, 0, 10, 11, 12, 13, 14], [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 1, 2, 0, 0, 0, 0, 0, 8, 92, 75, 58, 41, 7, 6, 5, 4, 3, 2, 1, 0, 13, 14], [0, 0, 1, 4, 2, 2, 3, 1, 2, 0, 0, 0, 0, 0, 0, 0, 0, 7, 6, 8, 5, 9, 4, 10, 3, 11, 12, 2, 0, 1, 13, 14]], wa = Jo.t256[0], Ta = Jo.t257[0], Sa = Jo.t258[0], Ma = 0, ka = 0, Za = Kn.decode._make_decoder, Na = Kn.decode._getbithuff, Ka = pa[0].exifIFD.makerNote, Ja = Ka.t150 ? Ka.t150 : Ka.t140, el = 0, qa = Ja[el++], tl = Ja[el++];
        qa != 73 && tl != 88 || (el += 2110), qa == 70 && (Ma = 2), Sa == 14 && (Ma += 3);
        for (var Qa = [[0, 0], [0, 0]], nl = Jo.isLE ? Kn._binLE : Kn._binBE, rl = 0; rl < 2; rl++) for (var il = 0; il < 2; il++) Qa[rl][il] = nl.readShort(Ja, el), el += 2;
        var cl, ll, al, sl, dl, El = 1 << Sa & 32767, fl = 0, Ml = nl.readShort(Ja, el);
        el += 2, Ml > 1 && (fl = Math.floor(El / (Ml - 1))), qa == 68 && tl == 32 && fl > 0 && (ka = nl.readShort(Ja, 562));
        var Sl = [0, 0], ml = Za(xa[Ma]), Dl = [va, 0, 0, 0];
        for (cl = 0; cl < Ta; cl++) for (ka && cl == ka && (ml = Za(xa[Ma + 1])), ll = 0; ll < wa; ll++) {
          rl = Na(ma, Dl, ml[0], ml), (dl = 1 + (Na(ma, Dl, (al = 15 & rl) - (sl = rl >>> 4), 0) << 1) << sl >>> 1) & 1 << al - 1 || (dl -= (1 << al) - (sl == 0 ? 1 : 0)), ll < 2 ? Sl[ll] = Qa[1 & cl][ll] += dl : Sl[1 & ll] += dl;
          var _l = Math.min(Math.max(Sl[1 & ll], 0), (1 << Sa) - 1), gl = (cl * wa + ll) * Sa;
          Kn.decode._putsF(_a, gl, _l << 16 - Sa);
        }
      }, Kn.decode._putsF = function(Jo, pa, ma) {
        ma <<= 8 - (7 & pa);
        var va = pa >>> 3;
        Jo[va] |= ma >>> 16, Jo[va + 1] |= ma >>> 8, Jo[va + 2] |= ma;
      }, Kn.decode._getbithuff = function(Jo, pa, ma, va) {
        var ba;
        Kn.decode._get_byte;
        var _a = pa[0], ya = pa[1], xa = pa[2], wa = pa[3];
        if (ma == 0 || xa < 0) return 0;
        for (; !wa && xa < ma && (ba = Jo[_a++]) != -1 && !(wa = 0); ) ya = (ya << 8) + ba, xa += 8;
        if (ba = ya << 32 - xa >>> 32 - ma, va ? (xa -= va[ba + 1] >>> 8, ba = 255 & va[ba + 1]) : xa -= ma, xa < 0) throw "e";
        return pa[0] = _a, pa[1] = ya, pa[2] = xa, pa[3] = wa, ba;
      }, Kn.decode._make_decoder = function(Jo) {
        var pa, ma, va, ba, _a, ya = [];
        for (pa = 16; pa != 0 && !Jo[pa]; pa--) ;
        var xa = 17;
        for (ya[0] = pa, va = ma = 1; ma <= pa; ma++) for (ba = 0; ba < Jo[ma]; ba++, ++xa) for (_a = 0; _a < 1 << pa - ma; _a++) va <= 1 << pa && (ya[va++] = ma << 8 | Jo[xa]);
        return ya;
      }, Kn.decode._decodeNewJPEG = function(Jo, pa, ma, va, ba, _a) {
        va = Math.min(va, pa.length - ma);
        var ya = Jo.t347, xa = ya ? ya.length : 0, wa = new Uint8Array(xa + va);
        if (ya) {
          for (var Ta = 0, Sa = 0; Sa < xa - 1 && (ya[Sa] != 255 || ya[Sa + 1] != 217); Sa++) wa[Ta++] = ya[Sa];
          var Ma = pa[ma], ka = pa[ma + 1];
          for (Ma == 255 && ka == 216 || (wa[Ta++] = Ma, wa[Ta++] = ka), Sa = 2; Sa < va; Sa++) wa[Ta++] = pa[ma + Sa];
        } else for (Sa = 0; Sa < va; Sa++) wa[Sa] = pa[ma + Sa];
        if (Jo.t262[0] == 32803 || Jo.t259[0] == 7 && Jo.t262[0] == 34892) {
          var Za = Jo.t258[0], Na = Kn.LosslessJpegDecode(wa), Ka = Na.length;
          if (Za == 16) if (Jo.isLE) for (Sa = 0; Sa < Ka; Sa++) ba[_a + (Sa << 1)] = 255 & Na[Sa], ba[_a + (Sa << 1) + 1] = Na[Sa] >>> 8;
          else for (Sa = 0; Sa < Ka; Sa++) ba[_a + (Sa << 1)] = Na[Sa] >>> 8, ba[_a + (Sa << 1) + 1] = 255 & Na[Sa];
          else if (Za == 14 || Za == 12 || Za == 10) {
            var Ja = 16 - Za;
            for (Sa = 0; Sa < Ka; Sa++) Kn.decode._putsF(ba, Sa * Za, Na[Sa] << Ja);
          } else {
            if (Za != 8) throw new Error("unsupported bit depth " + Za);
            for (Sa = 0; Sa < Ka; Sa++) ba[_a + Sa] = Na[Sa];
          }
        } else {
          var el = new Kn.JpegDecoder();
          el.parse(wa);
          var qa = el.getData({ width: el.width, height: el.height, forceRGB: !0, isSourcePDF: !1 });
          for (Sa = 0; Sa < qa.length; Sa++) ba[_a + Sa] = qa[Sa];
        }
        Jo.t262[0] == 6 && (Jo.t262[0] = 2);
      }, Kn.decode._decodeOldJPEGInit = function(Jo, pa, ma, va) {
        var ba, _a, ya, xa, wa, Ta = 216, Sa = 0, Ma = 0, ka = !1, Za = Jo.t513, Na = Za ? Za[0] : 0, Ka = Jo.t514, Ja = Ka ? Ka[0] : 0, el = Jo.t324 || Jo.t273 || Za, qa = Jo.t530, tl = 0, Qa = 0, nl = Jo.t277 ? Jo.t277[0] : 1, rl = Jo.t515;
        if (el && (Ma = el[0], ka = el.length > 1), !ka) {
          if (pa[ma] == 255 && pa[ma + 1] == Ta) return { jpegOffset: ma };
          if (Za != null && (pa[ma + Na] == 255 && pa[ma + Na + 1] == Ta ? Sa = ma + Na : Un("JPEGInterchangeFormat does not point to SOI"), Ka == null ? Un("JPEGInterchangeFormatLength field is missing") : (Na >= Ma || Na + Ja <= Ma) && Un("JPEGInterchangeFormatLength field value is invalid"), Sa != null)) return { jpegOffset: Sa };
        }
        if (qa != null && (tl = qa[0], Qa = qa[1]), Za != null && Ka != null) if (Ja >= 2 && Na + Ja <= Ma) {
          for (ba = pa[ma + Na + Ja - 2] == 255 && pa[ma + Na + Ja - 1] == Ta ? new Uint8Array(Ja - 2) : new Uint8Array(Ja), ya = 0; ya < ba.length; ya++) ba[ya] = pa[ma + Na + ya];
          Un("Incorrect JPEG interchange format: using JPEGInterchangeFormat offset to derive tables");
        } else Un("JPEGInterchangeFormat+JPEGInterchangeFormatLength > offset to first strip or tile");
        if (ba == null) {
          var il = 0, cl = [];
          cl[il++] = 255, cl[il++] = Ta;
          var ll = Jo.t519;
          if (ll == null) throw new Error("JPEGQTables tag is missing");
          for (ya = 0; ya < ll.length; ya++) for (cl[il++] = 255, cl[il++] = 219, cl[il++] = 0, cl[il++] = 67, cl[il++] = ya, xa = 0; xa < 64; xa++) cl[il++] = pa[ma + ll[ya] + xa];
          for (wa = 0; wa < 2; wa++) {
            var al = Jo[wa == 0 ? "t520" : "t521"];
            if (al == null) throw new Error((wa == 0 ? "JPEGDCTables" : "JPEGACTables") + " tag is missing");
            for (ya = 0; ya < al.length; ya++) {
              cl[il++] = 255, cl[il++] = 196;
              var sl = 19;
              for (xa = 0; xa < 16; xa++) sl += pa[ma + al[ya] + xa];
              for (cl[il++] = sl >>> 8, cl[il++] = 255 & sl, cl[il++] = ya | wa << 4, xa = 0; xa < 16; xa++) cl[il++] = pa[ma + al[ya] + xa];
              for (xa = 0; xa < sl; xa++) cl[il++] = pa[ma + al[ya] + 16 + xa];
            }
          }
          if (cl[il++] = 255, cl[il++] = 192, cl[il++] = 0, cl[il++] = 8 + 3 * nl, cl[il++] = 8, cl[il++] = Jo.height >>> 8 & 255, cl[il++] = 255 & Jo.height, cl[il++] = Jo.width >>> 8 & 255, cl[il++] = 255 & Jo.width, cl[il++] = nl, nl == 1) cl[il++] = 1, cl[il++] = 17, cl[il++] = 0;
          else for (ya = 0; ya < 3; ya++) cl[il++] = ya + 1, cl[il++] = ya != 0 ? 17 : (15 & tl) << 4 | 15 & Qa, cl[il++] = ya;
          rl != null && rl[0] != 0 && (cl[il++] = 255, cl[il++] = 221, cl[il++] = 0, cl[il++] = 4, cl[il++] = rl[0] >>> 8 & 255, cl[il++] = 255 & rl[0]), ba = new Uint8Array(cl);
        }
        var dl = -1;
        for (ya = 0; ya < ba.length - 1; ) {
          if (ba[ya] == 255 && ba[ya + 1] == 192) {
            dl = ya;
            break;
          }
          ya++;
        }
        if (dl == -1) {
          var El = new Uint8Array(ba.length + 10 + 3 * nl);
          El.set(ba);
          var fl = ba.length;
          if (dl = ba.length, (ba = El)[fl++] = 255, ba[fl++] = 192, ba[fl++] = 0, ba[fl++] = 8 + 3 * nl, ba[fl++] = 8, ba[fl++] = Jo.height >>> 8 & 255, ba[fl++] = 255 & Jo.height, ba[fl++] = Jo.width >>> 8 & 255, ba[fl++] = 255 & Jo.width, ba[fl++] = nl, nl == 1) ba[fl++] = 1, ba[fl++] = 17, ba[fl++] = 0;
          else for (ya = 0; ya < 3; ya++) ba[fl++] = ya + 1, ba[fl++] = ya != 0 ? 17 : (15 & tl) << 4 | 15 & Qa, ba[fl++] = ya;
        }
        if (pa[Ma] == 255 && pa[Ma + 1] == 218) {
          var Ml = pa[Ma + 2] << 8 | pa[Ma + 3];
          for ((_a = new Uint8Array(Ml + 2))[0] = pa[Ma], _a[1] = pa[Ma + 1], _a[2] = pa[Ma + 2], _a[3] = pa[Ma + 3], ya = 0; ya < Ml - 2; ya++) _a[ya + 4] = pa[Ma + ya + 4];
        } else {
          var Sl = 0;
          if ((_a = new Uint8Array(8 + 2 * nl))[Sl++] = 255, _a[Sl++] = 218, _a[Sl++] = 0, _a[Sl++] = 6 + 2 * nl, _a[Sl++] = nl, nl == 1) _a[Sl++] = 1, _a[Sl++] = 0;
          else for (ya = 0; ya < 3; ya++) _a[Sl++] = ya + 1, _a[Sl++] = ya << 4 | ya;
          _a[Sl++] = 0, _a[Sl++] = 63, _a[Sl++] = 0;
        }
        return { jpegOffset: ma, tables: ba, sosMarker: _a, sofPosition: dl };
      }, Kn.decode._decodeOldJPEG = function(Jo, pa, ma, va, ba, _a) {
        var ya, xa, wa, Ta, Sa = Kn.decode._decodeOldJPEGInit(Jo, pa, ma, va);
        if (Sa.jpegOffset != null) for (ya = ma + va - Sa.jpegOffset, wa = new Uint8Array(ya), Za = 0; Za < ya; Za++) wa[Za] = pa[Sa.jpegOffset + Za];
        else {
          for (xa = Sa.tables.length, (wa = new Uint8Array(xa + Sa.sosMarker.length + va + 2)).set(Sa.tables), Ta = xa, wa[Sa.sofPosition + 5] = Jo.height >>> 8 & 255, wa[Sa.sofPosition + 6] = 255 & Jo.height, wa[Sa.sofPosition + 7] = Jo.width >>> 8 & 255, wa[Sa.sofPosition + 8] = 255 & Jo.width, pa[ma] == 255 && pa[ma + 1] == SOS || (wa.set(Sa.sosMarker, Ta), Ta += sosMarker.length), Za = 0; Za < va; Za++) wa[Ta++] = pa[ma + Za];
          wa[Ta++] = 255, wa[Ta++] = EOI;
        }
        var Ma = new Kn.JpegDecoder();
        Ma.parse(wa);
        for (var ka = Ma.getData({ width: Ma.width, height: Ma.height, forceRGB: !0, isSourcePDF: !1 }), Za = 0; Za < ka.length; Za++) ba[_a + Za] = ka[Za];
        Jo.t262 && Jo.t262[0] == 6 && (Jo.t262[0] = 2);
      }, Kn.decode._decodePackBits = function(Jo, pa, ma, va, ba) {
        for (var _a = new Int8Array(Jo.buffer), ya = new Int8Array(va.buffer), xa = pa + ma; pa < xa; ) {
          var wa = _a[pa];
          if (pa++, wa >= 0 && wa < 128) for (var Ta = 0; Ta < wa + 1; Ta++) ya[ba] = _a[pa], ba++, pa++;
          if (wa >= -127 && wa < 0) {
            for (Ta = 0; Ta < 1 - wa; Ta++) ya[ba] = _a[pa], ba++;
            pa++;
          }
        }
        return ba;
      }, Kn.decode._decodeThunder = function(Jo, pa, ma, va, ba) {
        for (var _a = [0, 1, 0, -1], ya = [0, 1, 2, 3, 0, -3, -2, -1], xa = pa + ma, wa = 2 * ba, Ta = 0; pa < xa; ) {
          var Sa = Jo[pa], Ma = Sa >>> 6, ka = 63 & Sa;
          if (pa++, Ma == 3 && (Ta = 15 & ka, va[wa >>> 1] |= Ta << 4 * (1 - wa & 1), wa++), Ma == 0) for (var Za = 0; Za < ka; Za++) va[wa >>> 1] |= Ta << 4 * (1 - wa & 1), wa++;
          if (Ma == 2) for (Za = 0; Za < 2; Za++)
            (Na = ka >>> 3 * (1 - Za) & 7) != 4 && (Ta += ya[Na], va[wa >>> 1] |= Ta << 4 * (1 - wa & 1), wa++);
          if (Ma == 1) for (Za = 0; Za < 3; Za++) {
            var Na;
            (Na = ka >>> 2 * (2 - Za) & 3) != 2 && (Ta += _a[Na], va[wa >>> 1] |= Ta << 4 * (1 - wa & 1), wa++);
          }
        }
      }, Kn.decode._dmap = { 1: 0, "011": 1, "000011": 2, "0000011": 3, "010": -1, "000010": -2, "0000010": -3 }, Kn.decode._lens = function() {
        var Jo = function(wa, Ta, Sa, Ma) {
          for (var ka = 0; ka < Ta.length; ka++) wa[Ta[ka]] = Sa + ka * Ma;
        }, pa = "00110101,000111,0111,1000,1011,1100,1110,1111,10011,10100,00111,01000,001000,000011,110100,110101,101010,101011,0100111,0001100,0001000,0010111,0000011,0000100,0101000,0101011,0010011,0100100,0011000,00000010,00000011,00011010,00011011,00010010,00010011,00010100,00010101,00010110,00010111,00101000,00101001,00101010,00101011,00101100,00101101,00000100,00000101,00001010,00001011,01010010,01010011,01010100,01010101,00100100,00100101,01011000,01011001,01011010,01011011,01001010,01001011,00110010,00110011,00110100", ma = "0000110111,010,11,10,011,0011,0010,00011,000101,000100,0000100,0000101,0000111,00000100,00000111,000011000,0000010111,0000011000,0000001000,00001100111,00001101000,00001101100,00000110111,00000101000,00000010111,00000011000,000011001010,000011001011,000011001100,000011001101,000001101000,000001101001,000001101010,000001101011,000011010010,000011010011,000011010100,000011010101,000011010110,000011010111,000001101100,000001101101,000011011010,000011011011,000001010100,000001010101,000001010110,000001010111,000001100100,000001100101,000001010010,000001010011,000000100100,000000110111,000000111000,000000100111,000000101000,000001011000,000001011001,000000101011,000000101100,000001011010,000001100110,000001100111", va = "11011,10010,010111,0110111,00110110,00110111,01100100,01100101,01101000,01100111,011001100,011001101,011010010,011010011,011010100,011010101,011010110,011010111,011011000,011011001,011011010,011011011,010011000,010011001,010011010,011000,010011011", ba = "0000001111,000011001000,000011001001,000001011011,000000110011,000000110100,000000110101,0000001101100,0000001101101,0000001001010,0000001001011,0000001001100,0000001001101,0000001110010,0000001110011,0000001110100,0000001110101,0000001110110,0000001110111,0000001010010,0000001010011,0000001010100,0000001010101,0000001011010,0000001011011,0000001100100,0000001100101", _a = "00000001000,00000001100,00000001101,000000010010,000000010011,000000010100,000000010101,000000010110,000000010111,000000011100,000000011101,000000011110,000000011111";
        pa = pa.split(","), ma = ma.split(","), va = va.split(","), ba = ba.split(","), _a = _a.split(",");
        var ya = {}, xa = {};
        return Jo(ya, pa, 0, 1), Jo(ya, va, 64, 64), Jo(ya, _a, 1792, 64), Jo(xa, ma, 0, 1), Jo(xa, ba, 64, 64), Jo(xa, _a, 1792, 64), [ya, xa];
      }(), Kn.decode._decodeG4 = function(Jo, pa, ma, va, ba, _a, ya) {
        for (var xa = Kn.decode, wa = pa << 3, Ta = 0, Sa = "", Ma = [], ka = [], Za = 0; Za < _a; Za++) ka.push(0);
        ka = xa._makeDiff(ka);
        for (var Na = 0, Ka = 0, Ja = 0, el = 0, qa = 0, tl = 0, Qa = "", nl = 0, rl = 8 * Math.ceil(_a / 8); wa >>> 3 < pa + ma; ) {
          Ja = xa._findDiff(ka, Na + (Na == 0 ? 0 : 1), 1 - qa), el = xa._findDiff(ka, Ja, qa);
          var il = 0;
          if (ya == 1 && (il = Jo[wa >>> 3] >>> 7 - (7 & wa) & 1), ya == 2 && (il = Jo[wa >>> 3] >>> (7 & wa) & 1), wa++, Sa += il, Qa == "H") {
            if (xa._lens[qa][Sa] != null) {
              var cl = xa._lens[qa][Sa];
              Sa = "", Ta += cl, cl < 64 && (xa._addNtimes(Ma, Ta, qa), Na += Ta, qa = 1 - qa, Ta = 0, --nl == 0 && (Qa = ""));
            }
          } else Sa == "0001" && (Sa = "", xa._addNtimes(Ma, el - Na, qa), Na = el), Sa == "001" && (Sa = "", Qa = "H", nl = 2), xa._dmap[Sa] != null && (Ka = Ja + xa._dmap[Sa], xa._addNtimes(Ma, Ka - Na, qa), Na = Ka, Sa = "", qa = 1 - qa);
          Ma.length == _a && Qa == "" && (xa._writeBits(Ma, va, 8 * ba + tl * rl), qa = 0, tl++, Na = 0, ka = xa._makeDiff(Ma), Ma = []);
        }
      }, Kn.decode._findDiff = function(Jo, pa, ma) {
        for (var va = 0; va < Jo.length; va += 2) if (Jo[va] >= pa && Jo[va + 1] == ma) return Jo[va];
      }, Kn.decode._makeDiff = function(Jo) {
        var pa = [];
        Jo[0] == 1 && pa.push(0, 1);
        for (var ma = 1; ma < Jo.length; ma++) Jo[ma - 1] != Jo[ma] && pa.push(ma, Jo[ma]);
        return pa.push(Jo.length, 0, Jo.length, 1), pa;
      }, Kn.decode._decodeG2 = function(Jo, pa, ma, va, ba, _a, ya) {
        for (var xa = Kn.decode, wa = pa << 3, Ta = 0, Sa = "", Ma = [], ka = 0, Za = 0, Na = 8 * Math.ceil(_a / 8); wa >>> 3 < pa + ma; ) {
          var Ka = 0;
          ya == 1 && (Ka = Jo[wa >>> 3] >>> 7 - (7 & wa) & 1), ya == 2 && (Ka = Jo[wa >>> 3] >>> (7 & wa) & 1), wa++, Sa += Ka, (Ta = xa._lens[ka][Sa]) != null && (xa._addNtimes(Ma, Ta, ka), Sa = "", Ta < 64 && (ka = 1 - ka), Ma.length == _a && (xa._writeBits(Ma, va, 8 * ba + Za * Na), Ma = [], Za++, ka = 0, 7 & wa && (wa += 8 - (7 & wa)), Ta >= 64 && (wa += 8)));
        }
      }, Kn.decode._decodeG3 = function(Jo, pa, ma, va, ba, _a, ya, xa) {
        for (var wa = Kn.decode, Ta = pa << 3, Sa = 0, Ma = "", ka = [], Za = [], Na = 0; Na < _a; Na++) ka.push(0);
        for (var Ka = 0, Ja = 0, el = 0, qa = 0, tl = 0, Qa = -1, nl = "", rl = 0, il = !0, cl = 8 * Math.ceil(_a / 8); Ta >>> 3 < pa + ma; ) {
          el = wa._findDiff(Za, Ka + (Ka == 0 ? 0 : 1), 1 - tl), qa = wa._findDiff(Za, el, tl);
          var ll = 0;
          if (ya == 1 && (ll = Jo[Ta >>> 3] >>> 7 - (7 & Ta) & 1), ya == 2 && (ll = Jo[Ta >>> 3] >>> (7 & Ta) & 1), Ta++, Ma += ll, il) {
            if (wa._lens[tl][Ma] != null) {
              var al = wa._lens[tl][Ma];
              Ma = "", Sa += al, al < 64 && (wa._addNtimes(ka, Sa, tl), tl = 1 - tl, Sa = 0);
            }
          } else nl == "H" ? wa._lens[tl][Ma] != null && (al = wa._lens[tl][Ma], Ma = "", Sa += al, al < 64 && (wa._addNtimes(ka, Sa, tl), Ka += Sa, tl = 1 - tl, Sa = 0, --rl == 0 && (nl = ""))) : (Ma == "0001" && (Ma = "", wa._addNtimes(ka, qa - Ka, tl), Ka = qa), Ma == "001" && (Ma = "", nl = "H", rl = 2), wa._dmap[Ma] != null && (Ja = el + wa._dmap[Ma], wa._addNtimes(ka, Ja - Ka, tl), Ka = Ja, Ma = "", tl = 1 - tl));
          Ma.endsWith("000000000001") && (Qa >= 0 && wa._writeBits(ka, va, 8 * ba + Qa * cl), xa && (ya == 1 && (il = (Jo[Ta >>> 3] >>> 7 - (7 & Ta) & 1) == 1), ya == 2 && (il = (Jo[Ta >>> 3] >>> (7 & Ta) & 1) == 1), Ta++), Ma = "", tl = 0, Qa++, Ka = 0, Za = wa._makeDiff(ka), ka = []);
        }
        ka.length == _a && wa._writeBits(ka, va, 8 * ba + Qa * cl);
      }, Kn.decode._addNtimes = function(Jo, pa, ma) {
        for (var va = 0; va < pa; va++) Jo.push(ma);
      }, Kn.decode._writeBits = function(Jo, pa, ma) {
        for (var va = 0; va < Jo.length; va++) pa[ma + va >>> 3] |= Jo[va] << 7 - (ma + va & 7);
      }, Kn.decode._decodeLZW = Kn.decode._decodeLZW = function() {
        var Jo, pa, ma, va, ba = 0, _a = 0, ya = 0, xa = 0, wa = function() {
          var Na = Jo >>> 3, Ka = (pa[Na] << 16 | pa[Na + 1] << 8 | pa[Na + 2]) >>> 24 - (7 & Jo) - _a & (1 << _a) - 1;
          return Jo += _a, Ka;
        }, Ta = new Uint32Array(16384), Sa = 0, Ma = function(Na) {
          _a = Na + 1, ba = xa + 1;
        }, ka = function(Na) {
          for (var Ka = Na << 2, Ja = Ta[Ka + 2], el = va + Ja - 1; Ka != 65535; ) ma[el--] = Ta[Ka], Ka = Ta[Ka + 1];
          va += Ja;
        }, Za = function(Na, Ka) {
          var Ja = ba << 2, el = Na << 2;
          Ta[Ja] = Ta[3 + (Ka << 2)], Ta[Ja + 1] = el, Ta[Ja + 2] = Ta[el + 2] + 1, Ta[Ja + 3] = Ta[el + 3], ++ba + 1 == 1 << _a && _a != 12 && _a++;
        };
        return function(Na, Ka, Ja, el, qa, tl) {
          Jo = Ka << 3, pa = Na, ma = el, va = qa;
          var Qa = Ka + Ja << 3, nl = 0, rl = 0;
          for (function(il) {
            if (il != Sa) {
              Sa = il, xa = 1 + (ya = 1 << il);
              for (var cl = 0; cl < xa + 1; cl++) Ta[4 * cl] = Ta[4 * cl + 3] = cl, Ta[4 * cl + 1] = 65535, Ta[4 * cl + 2] = 1;
            }
          }(tl), Ma(tl); Jo < Qa && (nl = wa()) != xa; ) {
            if (nl == ya) {
              if (Ma(tl), (nl = wa()) == xa) break;
              ka(nl);
            } else nl < ba ? (ka(nl), Za(rl, nl)) : (Za(rl, rl), ka(ba - 1));
            rl = nl;
          }
          return va;
        };
      }(), Kn.tags = {}, Kn._types = function() {
        var Jo = new Array(250);
        return Jo.fill(0), { basic: { main: Jo = Jo.concat([0, 0, 0, 0, 4, 3, 3, 3, 3, 3, 0, 0, 3, 0, 0, 0, 3, 0, 0, 2, 2, 2, 2, 4, 3, 0, 0, 3, 4, 4, 3, 3, 5, 5, 3, 2, 5, 5, 0, 0, 0, 0, 4, 4, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 3, 5, 5, 3, 0, 3, 3, 4, 4, 4, 3, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), rest: { 33432: 2, 33434: 5, 33437: 5, 34665: 4, 34850: 3, 34853: 4, 34855: 3, 34864: 3, 34866: 4, 36864: 7, 36867: 2, 36868: 2, 37121: 7, 37377: 10, 37378: 5, 37380: 10, 37381: 5, 37383: 3, 37384: 3, 37385: 3, 37386: 5, 37510: 7, 37520: 2, 37521: 2, 37522: 2, 40960: 7, 40961: 3, 40962: 4, 40963: 4, 40965: 4, 41486: 5, 41487: 5, 41488: 3, 41985: 3, 41986: 3, 41987: 3, 41988: 5, 41989: 3, 41990: 3, 41993: 3, 41994: 3, 41995: 7, 41996: 3, 42032: 2, 42033: 2, 42034: 5, 42036: 2, 42037: 2, 59932: 7 } }, gps: { main: [1, 2, 5, 2, 5, 1, 5, 5, 0, 9], rest: { 18: 2, 29: 2 } } };
      }(), Kn._readIFD = function(Jo, pa, ma, va, ba, _a) {
        var ya = Jo.readUshort(pa, ma);
        ma += 2;
        var xa = {};
        _a.debug && Un("   ".repeat(ba), va.length - 1, ">>>----------------");
        for (var wa = 0; wa < ya; wa++) {
          var Ta = Jo.readUshort(pa, ma);
          ma += 2;
          var Sa = Jo.readUshort(pa, ma);
          ma += 2;
          var Ma = Jo.readUint(pa, ma);
          ma += 4;
          var ka = Jo.readUint(pa, ma);
          ma += 4;
          var Za = [];
          if (Sa == 1 || Sa == 7) {
            var Na = Ma < 5 ? ma - 4 : ka;
            Na + Ma > pa.buffer.byteLength && (Ma = pa.buffer.byteLength - Na), Za = new Uint8Array(pa.buffer, Na, Ma);
          }
          if (Sa == 2) {
            var Ka = Ma < 5 ? ma - 4 : ka, Ja = pa[Ka], el = Math.max(0, Math.min(Ma - 1, pa.length - Ka));
            Ja < 128 || el == 0 ? Za.push(Jo.readASCII(pa, Ka, el)) : Za = new Uint8Array(pa.buffer, Ka, el);
          }
          if (Sa == 3) for (var qa = 0; qa < Ma; qa++) Za.push(Jo.readUshort(pa, (Ma < 3 ? ma - 4 : ka) + 2 * qa));
          if (Sa == 4 || Sa == 13) for (qa = 0; qa < Ma; qa++) Za.push(Jo.readUint(pa, (Ma < 2 ? ma - 4 : ka) + 4 * qa));
          if (Sa == 5 || Sa == 10) {
            var tl = Sa == 5 ? Jo.readUint : Jo.readInt;
            for (qa = 0; qa < Ma; qa++) Za.push([tl(pa, ka + 8 * qa), tl(pa, ka + 8 * qa + 4)]);
          }
          if (Sa == 8) for (qa = 0; qa < Ma; qa++) Za.push(Jo.readShort(pa, (Ma < 3 ? ma - 4 : ka) + 2 * qa));
          if (Sa == 9) for (qa = 0; qa < Ma; qa++) Za.push(Jo.readInt(pa, (Ma < 2 ? ma - 4 : ka) + 4 * qa));
          if (Sa == 11) for (qa = 0; qa < Ma; qa++) Za.push(Jo.readFloat(pa, ka + 4 * qa));
          if (Sa == 12) for (qa = 0; qa < Ma; qa++) Za.push(Jo.readDouble(pa, ka + 8 * qa));
          if (Ma == 0 || Za.length != 0) {
            if (_a.debug && Un("   ".repeat(ba), Ta, Sa, Kn.tags[Ta], Za), xa["t" + Ta] = Za, !(Ta == 330 && xa.t272 && xa.t272[0] == "DSLR-A100")) {
              if (Ta == 330 || Ta == 34665 || Ta == 34853 || Ta == 50740 && Jo.readUshort(pa, Jo.readUint(Za, 0)) < 300 || Ta == 61440) {
                var Qa = Ta == 50740 ? [Jo.readUint(Za, 0)] : Za, nl = [];
                for (qa = 0; qa < Qa.length; qa++) Kn._readIFD(Jo, pa, Qa[qa], nl, ba + 1, _a);
                Ta == 330 && (xa.subIFD = nl), Ta == 34665 && (xa.exifIFD = nl[0]), Ta == 34853 && (xa.gpsiIFD = nl[0]), Ta == 50740 && (xa.dngPrvt = nl[0]), Ta == 61440 && (xa.fujiIFD = nl[0]);
              }
            }
            if (Ta == 37500 && _a.parseMN) {
              var rl = Za;
              if (Jo.readASCII(rl, 0, 5) == "Nikon") xa.makerNote = Kn.decode(rl.slice(10).buffer)[0];
              else if (Jo.readASCII(rl, 0, 5) == "OLYMP" || Jo.readASCII(rl, 0, 9) == "OM SYSTEM") {
                var il = [8208, 8224, 8240, 8256, 8272], cl = [];
                Kn._readIFD(Jo, rl, rl[1] == 77 ? 16 : rl[5] == 85 ? 12 : 8, cl, ba + 1, _a);
                var ll = xa.makerNote = cl.pop();
                for (qa = 0; qa < il.length; qa++) {
                  var al = "t" + il[qa];
                  ll[al] != null && (Kn._readIFD(Jo, rl, ll[al][0], cl, ba + 1, _a), ll[al] = cl.pop());
                }
                ll.t12288 && (Kn._readIFD(Jo, ll.t12288, 0, cl, ba + 1, _a), ll.t12288 = cl.pop());
              } else Jo.readUshort(pa, ka) < 300 && Jo.readUshort(pa, ka + 4) <= 12 && (cl = [], Kn._readIFD(Jo, pa, ka, cl, ba + 1, _a), xa.makerNote = cl[0]);
            }
          } else if (Un(Ta, "unknown TIFF tag type: ", Sa, "num:", Ma), wa == 0) return;
        }
        return va.push(xa), _a.debug && Un("   ".repeat(ba), "<<<---------------"), ma;
      }, Kn._writeIFD = function(Jo, pa, ma, va, ba) {
        var _a = Object.keys(ba), ya = _a.length;
        ba.exifIFD && ya--, ba.gpsiIFD && ya--, Jo.writeUshort(ma, va, ya);
        for (var xa = (va += 2) + 12 * ya + 4, wa = 0; wa < _a.length; wa++) {
          var Ta = _a[wa];
          if (Ta != "t34665" && Ta != "t34853") {
            Ta == "exifIFD" && (Ta = "t34665"), Ta == "gpsiIFD" && (Ta = "t34853");
            var Sa = parseInt(Ta.slice(1)), Ma = pa.main[Sa];
            if (Ma == null && (Ma = pa.rest[Sa]), Ma == null || Ma == 0) throw new Error("unknown type of tag: " + Sa);
            var ka = ba[Ta];
            Sa == 34665 && (ka = [xa], xa = Kn._writeIFD(Jo, pa, ma, xa, ba.exifIFD)[1]), Sa == 34853 && (ka = [xa], xa = Kn._writeIFD(Jo, Kn._types.gps, ma, xa, ba.gpsiIFD)[1]), Ma == 2 && (ka = ka[0] + "\0");
            var Za = ka.length;
            Jo.writeUshort(ma, va, Sa), va += 2, Jo.writeUshort(ma, va, Ma), va += 2, Jo.writeUint(ma, va, Za);
            var Na = [-1, 1, 1, 2, 4, 8, 0, 1, 0, 4, 8, 0, 8][Ma] * Za, Ka = va += 4;
            if (Na > 4 && (Jo.writeUint(ma, va, xa), Ka = xa), Ma == 1 || Ma == 7) for (var Ja = 0; Ja < Za; Ja++) ma[Ka + Ja] = ka[Ja];
            else if (Ma == 2) Jo.writeASCII(ma, Ka, ka);
            else if (Ma == 3) for (Ja = 0; Ja < Za; Ja++) Jo.writeUshort(ma, Ka + 2 * Ja, ka[Ja]);
            else if (Ma == 4) for (Ja = 0; Ja < Za; Ja++) Jo.writeUint(ma, Ka + 4 * Ja, ka[Ja]);
            else if (Ma == 5 || Ma == 10) {
              var el = Ma == 5 ? Jo.writeUint : Jo.writeInt;
              for (Ja = 0; Ja < Za; Ja++) {
                var qa = ka[Ja], tl = qa[0], Qa = qa[1];
                if (tl == null) throw "e";
                el(ma, Ka + 8 * Ja, tl), el(ma, Ka + 8 * Ja + 4, Qa);
              }
            } else if (Ma == 9) for (Ja = 0; Ja < Za; Ja++) Jo.writeInt(ma, Ka + 4 * Ja, ka[Ja]);
            else {
              if (Ma != 12) throw Ma;
              for (Ja = 0; Ja < Za; Ja++) Jo.writeDouble(ma, Ka + 8 * Ja, ka[Ja]);
            }
            Na > 4 && (xa += Na += 1 & Na), va += 4;
          }
        }
        return [va, xa];
      }, Kn.toRGBA8 = function(Jo, pa) {
        function ma(uc) {
          return uc < 31308e-7 ? 12.92 * uc : 1.055 * Math.pow(uc, 1 / 2.4) - 0.055;
        }
        var va = Jo.width, ba = Jo.height, _a = va * ba, ya = Jo.data, xa = new Uint8Array(4 * _a), wa = Jo.t262 ? Jo.t262[0] : 2, Ta = Jo.t258 ? Math.min(32, Jo.t258[0]) : 1;
        Jo.t262 == null && Ta == 1 && (wa = 0);
        var Sa = Jo.t277 ? Jo.t277[0] : Jo.t258 ? Jo.t258.length : [1, 1, 3, 1, 1, 4, 3][wa], Ma = Jo.t339 ? Jo.t339[0] : null;
        if (wa == 1 && Ta == 32 && Ma != 3) throw "e";
        var ka = Math.ceil(Sa * Ta * va / 8);
        if (wa == 0) {
          pa = 1 / 256;
          for (var Za = 0; Za < ba; Za++) {
            var Na = Za * ka, Ka = Za * va;
            if (Ta == 1) for (var Ja = 0; Ja < va; Ja++) {
              var el = Ka + Ja << 2, qa = ya[Na + (Ja >> 3)] >> 7 - (7 & Ja) & 1;
              xa[el] = xa[el + 1] = xa[el + 2] = 255 * (1 - qa), xa[el + 3] = 255;
            }
            if (Ta == 4) for (Ja = 0; Ja < va; Ja++)
              el = Ka + Ja << 2, qa = ya[Na + (Ja >> 1)] >> 4 - 4 * (1 & Ja) & 15, xa[el] = xa[el + 1] = xa[el + 2] = 17 * (15 - qa), xa[el + 3] = 255;
            if (Ta == 8) for (Ja = 0; Ja < va; Ja++)
              el = Ka + Ja << 2, qa = ya[Na + Ja], xa[el] = xa[el + 1] = xa[el + 2] = 255 - qa, xa[el + 3] = 255;
            if (Ta == 16) for (Ja = 0; Ja < va; Ja++)
              el = Ka + Ja << 2, qa = ya[(Qa = Na + 2 * Ja) + 1] << 8 | ya[Qa], xa[el] = xa[el + 1] = xa[el + 2] = Math.min(255, 255 - ~~(qa * pa)), xa[el + 3] = 255;
          }
        } else if (wa == 1) {
          pa == null && (pa = 1 / 256);
          var tl = 3 & ya.length ? null : new Float32Array(ya.buffer);
          for (Za = 0; Za < ba; Za++) {
            if (Na = Za * ka, Ka = Za * va, Ta == 1) for (Ja = 0; Ja < va; Ja++)
              el = Ka + Ja << 2, qa = ya[Na + (Ja >> 3)] >> 7 - (7 & Ja) & 1, xa[el] = xa[el + 1] = xa[el + 2] = 255 * qa, xa[el + 3] = 255;
            if (Ta == 2) for (Ja = 0; Ja < va; Ja++)
              el = Ka + Ja << 2, qa = ya[Na + (Ja >> 2)] >> 6 - 2 * (3 & Ja) & 3, xa[el] = xa[el + 1] = xa[el + 2] = 85 * qa, xa[el + 3] = 255;
            if (Ta == 8) for (Ja = 0; Ja < va; Ja++)
              el = Ka + Ja << 2, qa = ya[Na + Ja * Sa], xa[el] = xa[el + 1] = xa[el + 2] = qa, xa[el + 3] = 255;
            if (Ta == 16) for (Ja = 0; Ja < va; Ja++)
              el = Ka + Ja << 2, qa = ya[(Qa = Na + 2 * Ja) + 1] << 8 | ya[Qa], xa[el] = xa[el + 1] = xa[el + 2] = Math.min(255, ~~(qa * pa)), xa[el + 3] = 255;
            if (Ta == 32) for (Ja = 0; Ja < va; Ja++) {
              var Qa;
              el = Ka + Ja << 2, qa = tl[Qa = (Na >>> 2) + Ja], xa[el] = xa[el + 1] = xa[el + 2] = ~~(0.5 + 255 * qa), xa[el + 3] = 255;
            }
          }
        } else if (wa == 2) if (Ta == 8) {
          if (Sa == 1) for (Ja = 0; Ja < _a; Ja++) xa[4 * Ja] = xa[4 * Ja + 1] = xa[4 * Ja + 2] = ya[Ja], xa[4 * Ja + 3] = 255;
          if (Sa == 3) for (Ja = 0; Ja < _a; Ja++) {
            var nl = 3 * Ja;
            xa[el = Ja << 2] = ya[nl], xa[el + 1] = ya[nl + 1], xa[el + 2] = ya[nl + 2], xa[el + 3] = 255;
          }
          if (Sa >= 4) for (Ja = 0; Ja < _a; Ja++)
            nl = Ja * Sa, xa[el = Ja << 2] = ya[nl], xa[el + 1] = ya[nl + 1], xa[el + 2] = ya[nl + 2], xa[el + 3] = ya[nl + 3];
        } else if (Ta == 16) {
          if (Sa == 4) for (Ja = 0; Ja < _a; Ja++)
            nl = 8 * Ja + 1, xa[el = Ja << 2] = ya[nl], xa[el + 1] = ya[nl + 2], xa[el + 2] = ya[nl + 4], xa[el + 3] = ya[nl + 6];
          if (Sa == 3) for (Ja = 0; Ja < _a; Ja++)
            nl = 6 * Ja + 1, xa[el = Ja << 2] = ya[nl], xa[el + 1] = ya[nl + 2], xa[el + 2] = ya[nl + 4], xa[el + 3] = 255;
        } else {
          if (Ta != 32) throw Ta;
          var rl = new Float32Array(ya.buffer), il = 0;
          for (Ja = 0; Ja < rl.length; Ja++) il = Math.min(il, rl[Ja]);
          if (il < 0) for (Ja = 0; Ja < ya.length; Ja += 4) {
            var cl = ya[Ja];
            ya[Ja] = ya[Ja + 3], ya[Ja + 3] = cl, cl = ya[Ja + 1], ya[Ja + 1] = ya[Ja + 2], ya[Ja + 2] = cl;
          }
          var ll = [];
          for (Ja = 0; Ja < 65536; Ja++) ll.push(ma(Ja / 65535));
          for (Ja = 0; Ja < rl.length; Ja++) {
            var al = Math.max(0, Math.min(1, rl[Ja]));
            rl[Ja] = ll[~~(0.5 + 65535 * al)];
          }
          if (Sa == 3) for (Ja = 0; Ja < _a; Ja++)
            nl = 3 * Ja, xa[el = Ja << 2] = ~~(0.5 + 255 * rl[nl]), xa[el + 1] = ~~(0.5 + 255 * rl[nl + 1]), xa[el + 2] = ~~(0.5 + 255 * rl[nl + 2]), xa[el + 3] = 255;
          else {
            if (Sa != 4) throw Sa;
            for (Ja = 0; Ja < _a; Ja++)
              nl = 4 * Ja, xa[el = Ja << 2] = ~~(0.5 + 255 * rl[nl]), xa[el + 1] = ~~(0.5 + 255 * rl[nl + 1]), xa[el + 2] = ~~(0.5 + 255 * rl[nl + 2]), xa[el + 3] = ~~(0.5 + 255 * rl[nl + 3]);
          }
        }
        else if (wa == 3) {
          var sl = Jo.t320, dl = 1 << Ta, El = Ta == 8 && Sa > 1 && Jo.t338 && Jo.t338[0] != 0;
          for (Za = 0; Za < ba; Za++) for (var fl = 0; fl < va; fl++) {
            el = (Ja = Za * va + fl) << 2;
            var Ml = 0, Sl = Za * ka;
            if (Ta == 1) Ml = ya[Sl + (fl >>> 3)] >>> 7 - (7 & fl) & 1;
            else if (Ta == 2) Ml = ya[Sl + (fl >>> 2)] >>> 6 - 2 * (3 & fl) & 3;
            else if (Ta == 4) Ml = ya[Sl + (fl >>> 1)] >>> 4 - 4 * (1 & fl) & 15;
            else {
              if (Ta != 8) throw Ta;
              Ml = ya[Sl + fl * Sa];
            }
            xa[el] = sl[Ml] >> 8, xa[el + 1] = sl[dl + Ml] >> 8, xa[el + 2] = sl[dl + dl + Ml] >> 8, xa[el + 3] = El ? ya[Sl + fl * Sa + 1] : 255;
          }
        } else if (wa == 5) {
          var ml = Sa > 4 ? 1 : 0;
          for (Ja = 0; Ja < _a; Ja++) {
            el = Ja << 2;
            var Dl = Ja * Sa;
            if (window.UDOC) {
              var _l = ya[Dl], gl = ya[Dl + 1], Fl = ya[Dl + 2], Nl = ya[Dl + 3], zl = UDOC.C.cmykToRgb([_l * (1 / 255), gl * (1 / 255), Fl * (1 / 255), Nl * (1 / 255)]);
              xa[el] = ~~(0.5 + 255 * zl[0]), xa[el + 1] = ~~(0.5 + 255 * zl[1]), xa[el + 2] = ~~(0.5 + 255 * zl[2]);
            } else
              _l = 255 - ya[Dl], gl = 255 - ya[Dl + 1], Fl = 255 - ya[Dl + 2], Nl = (255 - ya[Dl + 3]) * (1 / 255), xa[el] = ~~(_l * Nl + 0.5), xa[el + 1] = ~~(gl * Nl + 0.5), xa[el + 2] = ~~(Fl * Nl + 0.5);
            xa[el + 3] = 255 * (1 - ml) + ya[Dl + 4] * ml;
          }
        } else if (wa == 6 && Jo.t278) {
          var Zl = Jo.t278[0];
          for (Za = 0; Za < ba; Za += Zl) {
            Ja = Za * va;
            for (var kl = Zl * va, ul = 0; ul < kl; ul++) {
              el = 4 * (Ja + ul), Fl = ya[(Dl = 3 * Ja + 4 * (ul >>> 1)) + (1 & ul)];
              var vl = ya[Dl + 2] - 128, Tl = ya[Dl + 3] - 128, wl = Fl + ((Tl >> 2) + (Tl >> 3) + (Tl >> 5)), yl = Fl - ((vl >> 2) + (vl >> 4) + (vl >> 5)) - ((Tl >> 1) + (Tl >> 3) + (Tl >> 4) + (Tl >> 5)), Rl = Fl + (vl + (vl >> 1) + (vl >> 2) + (vl >> 6));
              xa[el] = Math.max(0, Math.min(255, wl)), xa[el + 1] = Math.max(0, Math.min(255, yl)), xa[el + 2] = Math.max(0, Math.min(255, Rl)), xa[el + 3] = 255;
            }
          }
        } else if (wa == 32845) for (Za = 0; Za < ba; Za++) for (fl = 0; fl < va; fl++) {
          el = 4 * (Za * va + fl);
          var Ul = ya[(Dl = 6 * (Za * va + fl)) + 1] << 8 | ya[Dl], hl = (Ul = Math.pow(2, (Ul + 0.5) / 256 - 64), (ya[Dl + 3] + 0.5) / 410), Cl = (ya[Dl + 5] + 0.5) / 410, Il = 9 * hl / (6 * hl - 16 * Cl + 12), Ll = 4 * Cl / (6 * hl - 16 * Cl + 12), tc = Il * Ul / Ll, nc = (1 - Il - Ll) * Ul / Ll;
          wl = 2.69 * tc - 1.276 * (Fl = Ul) - 0.414 * nc, yl = -1.022 * tc + 1.978 * Fl + 0.044 * nc, Rl = 0.061 * tc - 0.224 * Fl + 1.163 * nc, xa[el] = 255 * ma(Math.min(wl, 1)), xa[el + 1] = 255 * ma(Math.min(yl, 1)), xa[el + 2] = 255 * ma(Math.min(Rl, 1)), xa[el + 3] = 255;
        }
        else Un("Unknown Photometric interpretation: " + wa);
        return xa;
      }, Kn.replaceIMG = function(Jo) {
        Jo == null && (Jo = document.getElementsByTagName("img"));
        for (var pa = ["tif", "tiff", "dng", "cr2", "nef"], ma = 0; ma < Jo.length; ma++) {
          var va = Jo[ma], ba = va.getAttribute("src");
          if (ba != null) {
            var _a = ba.split(".").pop().toLowerCase();
            if (pa.indexOf(_a) != -1) {
              var ya = new XMLHttpRequest();
              Kn._xhrs.push(ya), Kn._imgs.push(va), ya.open("GET", ba), ya.responseType = "arraybuffer", ya.onload = Kn._imgLoaded, ya.send();
            }
          }
        }
      }, Kn._xhrs = [], Kn._imgs = [], Kn._imgLoaded = function(Jo) {
        var pa = Kn._xhrs.indexOf(Jo.target), ma = Kn._imgs[pa];
        Kn._xhrs.splice(pa, 1), Kn._imgs.splice(pa, 1), ma.setAttribute("src", Kn.bufferToURI(Jo.target.response));
      }, Kn.bufferToURI = function(Jo) {
        var pa = Kn.decode(Jo), ma = pa, va = 0, ba = ma[0];
        pa[0].subIFD && (ma = ma.concat(pa[0].subIFD));
        for (var _a = 0; _a < ma.length; _a++) {
          var ya = ma[_a];
          if (!(ya.t258 == null || ya.t258.length < 3)) {
            var xa = ya.t256 * ya.t257;
            xa > va && (va = xa, ba = ya);
          }
        }
        Kn.decodeImage(Jo, ba, pa);
        var wa = Kn.toRGBA8(ba), Ta = ba.width, Sa = ba.height, Ma = document.createElement("canvas");
        Ma.width = Ta, Ma.height = Sa;
        var ka = Ma.getContext("2d"), Za = new ImageData(new Uint8ClampedArray(wa.buffer), Ta, Sa);
        return ka.putImageData(Za, 0, 0), Ma.toDataURL();
      }, Kn._binBE = { nextZero: function(Jo, pa) {
        for (; Jo[pa] != 0; ) pa++;
        return pa;
      }, readUshort: function(Jo, pa) {
        return Jo[pa] << 8 | Jo[pa + 1];
      }, readShort: function(Jo, pa) {
        var ma = Kn._binBE.ui8;
        return ma[0] = Jo[pa + 1], ma[1] = Jo[pa + 0], Kn._binBE.i16[0];
      }, readInt: function(Jo, pa) {
        var ma = Kn._binBE.ui8;
        return ma[0] = Jo[pa + 3], ma[1] = Jo[pa + 2], ma[2] = Jo[pa + 1], ma[3] = Jo[pa + 0], Kn._binBE.i32[0];
      }, readUint: function(Jo, pa) {
        var ma = Kn._binBE.ui8;
        return ma[0] = Jo[pa + 3], ma[1] = Jo[pa + 2], ma[2] = Jo[pa + 1], ma[3] = Jo[pa + 0], Kn._binBE.ui32[0];
      }, readASCII: function(Jo, pa, ma) {
        for (var va = "", ba = 0; ba < ma; ba++) va += String.fromCharCode(Jo[pa + ba]);
        return va;
      }, readFloat: function(Jo, pa) {
        for (var ma = Kn._binBE.ui8, va = 0; va < 4; va++) ma[va] = Jo[pa + 3 - va];
        return Kn._binBE.fl32[0];
      }, readDouble: function(Jo, pa) {
        for (var ma = Kn._binBE.ui8, va = 0; va < 8; va++) ma[va] = Jo[pa + 7 - va];
        return Kn._binBE.fl64[0];
      }, writeUshort: function(Jo, pa, ma) {
        Jo[pa] = ma >> 8 & 255, Jo[pa + 1] = 255 & ma;
      }, writeInt: function(Jo, pa, ma) {
        var va = Kn._binBE.ui8;
        Kn._binBE.i32[0] = ma, Jo[pa + 3] = va[0], Jo[pa + 2] = va[1], Jo[pa + 1] = va[2], Jo[pa + 0] = va[3];
      }, writeUint: function(Jo, pa, ma) {
        Jo[pa] = ma >> 24 & 255, Jo[pa + 1] = ma >> 16 & 255, Jo[pa + 2] = ma >> 8 & 255, Jo[pa + 3] = 255 & ma;
      }, writeASCII: function(Jo, pa, ma) {
        for (var va = 0; va < ma.length; va++) Jo[pa + va] = ma.charCodeAt(va);
      }, writeDouble: function(Jo, pa, ma) {
        Kn._binBE.fl64[0] = ma;
        for (var va = 0; va < 8; va++) Jo[pa + va] = Kn._binBE.ui8[7 - va];
      } }, Kn._binBE.ui8 = new Uint8Array(8), Kn._binBE.i16 = new Int16Array(Kn._binBE.ui8.buffer), Kn._binBE.i32 = new Int32Array(Kn._binBE.ui8.buffer), Kn._binBE.ui32 = new Uint32Array(Kn._binBE.ui8.buffer), Kn._binBE.fl32 = new Float32Array(Kn._binBE.ui8.buffer), Kn._binBE.fl64 = new Float64Array(Kn._binBE.ui8.buffer), Kn._binLE = { nextZero: Kn._binBE.nextZero, readUshort: function(Jo, pa) {
        return Jo[pa + 1] << 8 | Jo[pa];
      }, readShort: function(Jo, pa) {
        var ma = Kn._binBE.ui8;
        return ma[0] = Jo[pa + 0], ma[1] = Jo[pa + 1], Kn._binBE.i16[0];
      }, readInt: function(Jo, pa) {
        var ma = Kn._binBE.ui8;
        return ma[0] = Jo[pa + 0], ma[1] = Jo[pa + 1], ma[2] = Jo[pa + 2], ma[3] = Jo[pa + 3], Kn._binBE.i32[0];
      }, readUint: function(Jo, pa) {
        var ma = Kn._binBE.ui8;
        return ma[0] = Jo[pa + 0], ma[1] = Jo[pa + 1], ma[2] = Jo[pa + 2], ma[3] = Jo[pa + 3], Kn._binBE.ui32[0];
      }, readASCII: Kn._binBE.readASCII, readFloat: function(Jo, pa) {
        for (var ma = Kn._binBE.ui8, va = 0; va < 4; va++) ma[va] = Jo[pa + va];
        return Kn._binBE.fl32[0];
      }, readDouble: function(Jo, pa) {
        for (var ma = Kn._binBE.ui8, va = 0; va < 8; va++) ma[va] = Jo[pa + va];
        return Kn._binBE.fl64[0];
      }, writeUshort: function(Jo, pa, ma) {
        Jo[pa] = 255 & ma, Jo[pa + 1] = ma >> 8 & 255;
      }, writeInt: function(Jo, pa, ma) {
        var va = Kn._binBE.ui8;
        Kn._binBE.i32[0] = ma, Jo[pa + 0] = va[0], Jo[pa + 1] = va[1], Jo[pa + 2] = va[2], Jo[pa + 3] = va[3];
      }, writeUint: function(Jo, pa, ma) {
        Jo[pa] = ma >>> 0 & 255, Jo[pa + 1] = ma >>> 8 & 255, Jo[pa + 2] = ma >>> 16 & 255, Jo[pa + 3] = ma >>> 24 & 255;
      }, writeASCII: Kn._binBE.writeASCII }, Kn._copyTile = function(Jo, pa, ma, va, ba, _a, ya, xa) {
        for (var wa = Math.min(pa, ba - ya), Ta = Math.min(ma, _a - xa), Sa = 0; Sa < Ta; Sa++) for (var Ma = (xa + Sa) * ba + ya, ka = Sa * pa, Za = 0; Za < wa; Za++) va[Ma + Za] = Jo[ka + Za];
      }, Kn.LosslessJpegDecode = /* @__PURE__ */ function() {
        var Jo, pa;
        function ma() {
          return Jo[pa++];
        }
        function va() {
          return Jo[pa++] << 8 | Jo[pa++];
        }
        function ba(Na) {
          for (var Ka = ma(), Ja = [0, 0, 0, 255], el = [], qa = 0; qa < 16; qa++) el[qa] = ma();
          for (qa = 0; qa < 16; qa++) for (var tl = 0; tl < el[qa]; tl++)
            Ja[_a(Ja, 0, qa + 1, 1) + 3] = ma();
          var Qa = new Uint8Array(256);
          for (Na[Ka] = [new Uint8Array(Ja), Qa], qa = 0; qa < 256; qa++) {
            for (var nl = 8, rl = qa, il = 0; Ja[il + 3] == 255 && nl != 0; ) il = Ja[il + (rl >> --nl & 1)];
            Qa[qa] = il;
          }
        }
        function _a(Na, Ka, Ja, el) {
          if (Na[Ka + 3] != 255) return 0;
          if (Ja == 0) return Ka;
          for (var qa = 0; qa < 2; qa++) {
            Na[Ka + qa] == 0 && (Na[Ka + qa] = Na.length, Na.push(0, 0, el, 255));
            var tl = _a(Na, Na[Ka + qa], Ja - 1, el + 1);
            if (tl != 0) return tl;
          }
          return 0;
        }
        function ya(Na) {
          for (var Ka = Na.b, Ja = Na.f; Ka < 25 && Na.a < Na.d; ) {
            var el = Na.data[Na.a++];
            el != 255 || Na.c || Na.a++, Ja = Ja << 8 | el, Ka += 8;
          }
          if (Ka < 0) throw "e";
          Na.b = Ka, Na.f = Ja;
        }
        function xa(Na, Ka) {
          return Ka.b < Na && ya(Ka), Ka.f >> (Ka.b -= Na) & 65535 >> 16 - Na;
        }
        function wa(Na, Ka) {
          var Ja = Na[0], el = 0, qa = 255;
          Ka.b < 16 && ya(Ka);
          var tl = Ka.f >> Ka.b - 8 & 255;
          for (qa = Ja[(el = Na[1][tl]) + 3], Ka.b -= Ja[el + 2]; qa == 255; ) qa = Ja[(el = Ja[el + (Ka.f >> --Ka.b & 1)]) + 3];
          return qa;
        }
        function Ta(Na, Ka) {
          return Na < 32768 >> 16 - Ka && (Na += 1 - (1 << Ka)), Na;
        }
        function Sa(Na, Ka) {
          var Ja = wa(Na, Ka);
          return Ja == 0 ? 0 : Ja == 16 ? -32768 : Ta(xa(Ja, Ka), Ja);
        }
        function Ma(Na, Ka, Ja, el, qa, tl) {
          for (var Qa = 0, nl = 0; nl < tl; nl++) {
            for (var rl = nl * Ka, il = 0; il < Ka; il += qa) {
              Qa++;
              for (var cl = 0; cl < qa; cl++) Na[rl + il + cl] = Sa(el[cl], Ja);
            }
            if (Ja.e != 0 && Qa % Ja.e == 0 && nl != 0) {
              for (var ll = Ja.a, al = Ja.data; al[ll] != 255 || !(208 <= al[ll + 1] && al[ll + 1] <= 215); ) ll--;
              Ja.a = ll + 2, Ja.f = 0, Ja.b = 0;
            }
          }
        }
        function ka(Na, Ka) {
          return Ta(xa(Na, Ka), Na);
        }
        function Za(Na, Ka, Ja, el, qa, tl, Qa, nl) {
          for (var rl = Ja * Qa, il = qa; il < tl; il++) Na[il] += 1 << nl - 1;
          for (var cl = Qa; cl < rl; cl += Qa) for (il = qa; il < tl; il++) Na[cl + il] += Na[cl + il - Qa];
          for (var ll = 1; ll < el; ll++) {
            var al = ll * rl;
            for (il = qa; il < tl; il++) Na[al + il] += Na[al + il - rl];
            for (cl = Qa; cl < rl; cl += Qa) for (il = qa; il < tl; il++) {
              var sl = al + cl + il, dl = sl - rl, El = Na[sl - Qa], fl = 0;
              if (Ka == 0) fl = 0;
              else if (Ka == 1) fl = El;
              else if (Ka == 2) fl = Na[dl];
              else if (Ka == 3) fl = Na[dl - Qa];
              else if (Ka == 4) fl = El + (Na[dl] - Na[dl - Qa]);
              else if (Ka == 5) fl = El + (Na[dl] - Na[dl - Qa] >>> 1);
              else if (Ka == 6) fl = Na[dl] + (El - Na[dl - Qa] >>> 1);
              else {
                if (Ka != 7) throw Ka;
                fl = El + Na[dl] >>> 1;
              }
              Na[sl] += fl;
            }
          }
        }
        return function(Na) {
          if (Jo = Na, pa = 0, va() != 65496) throw "e";
          for (var Ka = [], Ja = 0, el = 0, qa = 0, tl = [], Qa = [], nl = [], rl = 0, il = 0, cl = 0; ; ) {
            var ll = va();
            if (ll != 65535) {
              var al = va();
              if (ll == 65475) {
                el = ma(), il = va(), cl = va(), rl = ma();
                for (var sl = 0; sl < rl; sl++) {
                  var dl = ma(), El = ma();
                  if (ma() != 0) throw "e";
                  Ka[dl] = [sl, El >> 4, 15 & El];
                }
              } else if (ll == 65476) for (var fl = pa + al - 2; pa < fl; ) ba(Qa);
              else {
                if (ll == 65498) {
                  for (pa++, sl = 0; sl < rl; sl++) {
                    var Ml = Ka[ma()];
                    nl[Ml[0]] = Qa[ma() >>> 4], tl[Ml[0]] = Ml.slice(1);
                  }
                  Ja = ma(), pa += 2;
                  break;
                }
                ll == 65501 ? qa = va() : pa += al - 2;
              }
            } else pa--;
          }
          var Sl = new (el > 8 ? Uint16Array : Uint8Array)(il * cl * rl), ml = { b: 0, f: 0, c: Ja == 8, a: pa, data: Jo, d: Jo.length, e: qa };
          if (ml.c) (function(tc, nc, uc, _c, mc) {
            for (var Sc = Jo.length - pa, hc = 0; hc < Sc; hc += 4) {
              var Lc = Jo[pa + hc];
              Jo[pa + hc] = Jo[pa + hc + 3], Jo[pa + hc + 3] = Lc, Lc = Jo[pa + hc + 1], Jo[pa + hc + 1] = Jo[pa + hc + 2], Jo[pa + hc + 2] = Lc;
            }
            for (var Ec = 0; Ec < mc; Ec++) for (var Hl = 32768, fc = 32768, lc = 0; lc < nc; lc += 2) {
              var Gl = wa(_c, uc), ql = wa(_c, uc);
              Gl != 0 && (Hl += ka(Gl, uc)), ql != 0 && (fc += ka(ql, uc)), tc[Ec * nc + lc] = 65535 & Hl, tc[Ec * nc + lc + 1] = 65535 & fc;
            }
          })(Sl, cl * rl, ml, nl[0], il);
          else {
            var Dl = [], _l = 0, gl = 0;
            for (sl = 0; sl < rl; sl++) {
              var Fl = tl[sl];
              (Rl = Fl[0]) > _l && (_l = Rl), (yl = Fl[1]) > gl && (gl = yl), Dl.push(Rl * yl);
            }
            if (_l != 1 || gl != 1) {
              if (rl != 3 || Dl[1] != 1 || Dl[2] != 1 || _l != 2 || gl != 1 && gl != 2) throw "e";
              var Nl = [], zl = 0;
              for (sl = 0; sl < rl; sl++) {
                for (var Zl = 0; Zl < Dl[sl]; Zl++) Nl.push(nl[sl]);
                zl += Dl[sl];
              }
              var kl = cl / _l, ul = il / gl, vl = kl * ul;
              Ma(Sl, kl * zl, ml, Nl, zl, ul), Za(Sl, Ja, kl, ul, zl - 2, zl, zl, el);
              var Tl = new Uint16Array(vl * Dl[0]);
              if (_l == 2 && gl == 2) {
                for (sl = 0; sl < vl; sl++) Tl[4 * sl] = Sl[6 * sl], Tl[4 * sl + 1] = Sl[6 * sl + 1], Tl[4 * sl + 2] = Sl[6 * sl + 2], Tl[4 * sl + 3] = Sl[6 * sl + 3];
                for (Za(Tl, Ja, 4 * kl, ul, 0, 1, 1, el), sl = 0; sl < vl; sl++) Sl[6 * sl] = Tl[4 * sl], Sl[6 * sl + 1] = Tl[4 * sl + 1], Sl[6 * sl + 2] = Tl[4 * sl + 2], Sl[6 * sl + 3] = Tl[4 * sl + 3];
              }
              if (_l == 2 && gl == 1) {
                for (sl = 0; sl < vl; sl++) Tl[2 * sl] = Sl[4 * sl], Tl[2 * sl + 1] = Sl[4 * sl + 1];
                for (Za(Tl, Ja, 2 * kl, ul, 0, 1, 1, el), sl = 0; sl < vl; sl++) Sl[4 * sl] = Tl[2 * sl], Sl[4 * sl + 1] = Tl[2 * sl + 1];
              }
              for (var wl = Sl.slice(0), yl = 0; yl < il; yl++) if (gl == 2) for (var Rl = 0; Rl < cl; Rl++) {
                var Ul = ((yl >>> 1) * kl + (Rl >>> 1)) * zl, hl = 2 * (1 & yl) + (1 & Rl);
                Sl[Cl = (yl * cl + Rl) * rl] = wl[Ul + hl], Sl[Cl + 1] = wl[Ul + 4], Sl[Cl + 2] = wl[Ul + 5];
              }
              else for (Rl = 0; Rl < cl; Rl++) {
                var Cl;
                Ul = (yl * kl + (Rl >>> 1)) * zl, hl = 1 & Rl, Sl[Cl = (yl * cl + Rl) * rl] = wl[Ul + hl], Sl[Cl + 1] = wl[Ul + 2], Sl[Cl + 2] = wl[Ul + 3];
              }
            } else if (Ma(Sl, cl * rl, ml, nl, rl, il), qa == 0) Za(Sl, Ja, cl, il, 0, rl, rl, el);
            else {
              var Il = Math.floor(qa / cl);
              for (yl = 0; yl < il; yl += Il) {
                var Ll = Sl.slice(yl * cl * rl, (yl + Il) * cl * rl);
                Za(Ll, Ja, cl, Il, 0, rl, rl, el), Sl.set(Ll, yl * cl * rl);
              }
            }
          }
          return Sl;
        };
      }(), function() {
        var Jo = 2, pa = 4, ma = 5, va = 6, ba = 7, _a = 12, ya = 13, xa = 14, wa = 15, Ta = 17;
        function Sa(tl) {
          var Qa = { c: new Int8Array(2 << tl.u) };
          return function(nl, rl, il) {
            var cl = [rl, 3 * rl + 18, 5 * rl + 67, 7 * rl + 276, il];
            nl.o = rl, nl.w = (cl[4] + 2 * rl) / (2 * rl + 1) + 1 | 0, nl.v = Math.ceil(Math.log2(nl.w)), nl.t = 9, function(ll, al) {
              for (var sl = -al[4], dl = 0; sl <= al[4]; dl++, sl++) ll[dl] = sl <= -276 ? -4 : sl <= -67 ? -3 : sl <= -18 ? -2 : sl < -0 ? -1 : sl <= al[0] ? 0 : sl < al[1] ? 1 : sl < al[2] ? 2 : sl < al[3] ? 3 : 4;
            }(nl.c, cl);
          }(Qa, 0, tl.g), Qa;
        }
        function Ma(tl) {
          for (var Qa = [[], [], []], nl = Math.max(2, tl.w + 32 >>> 6), rl = 0; rl < 3; rl++) for (var il = 0; il < 41; il++) Qa[rl][il] = [nl, 1];
          return Qa;
        }
        function ka(tl, Qa) {
          var nl = 0, rl = 8 - tl.a;
          if (tl.j, tl.a, Qa) {
            if (Qa >= rl) do
              nl <<= rl, Qa -= rl, nl |= tl[tl.j] & (1 << rl) - 1, tl.j++, rl = 8;
            while (Qa >= 8);
            Qa && (nl <<= Qa, rl -= Qa, nl |= tl[tl.j] >>> rl & (1 << Qa) - 1), tl.a = 8 - rl;
          }
          return nl;
        }
        function Za(tl, Qa, nl, rl, il, cl, ll, al) {
          al == null && (al = 0);
          var sl, dl, El, fl, Ml, Sl, ml = cl + 1, Dl = ml % 2, _l = 0, gl = rl[il], Fl = rl[il - 1], Nl = rl[il - 2][ml], zl = Fl[ml - 1], Zl = Fl[ml], kl = Fl[ml + 1], ul = gl[ml - 1], vl = gl[ml + 1], Tl = Math.abs;
          if (Dl && (El = Tl(kl - Zl), fl = Tl(Nl - Zl), Ml = Tl(zl - Zl)), Dl) {
            if (Sl = (Sl = El > Ml && fl < El ? Nl + zl : El < Ml && fl < Ml ? Nl + kl : kl + zl) + 2 * Zl >>> 2, al) return void (gl[ml] = Sl);
            sl = Qa.t * Qa.c[tl.g + Zl - Nl] + Qa.c[tl.g + zl - Zl];
          } else Sl = Zl > zl && Zl > kl || Zl < zl && Zl < kl ? vl + ul + 2 * Zl >>> 2 : ul + vl >>> 1, sl = Qa.t * Qa.c[tl.g + Zl - zl] + Qa.c[tl.g + zl - ul];
          dl = Tl(sl);
          var wl = function(Rl) {
            for (var Ul = -1, hl = 0; !hl; Ul++) hl = Rl[Rl.j] >>> 7 - Rl.a & 1, Rl.a++, Rl.a &= 7, Rl.a || Rl.j++;
            return Ul;
          }(nl);
          if (wl < tl.n - Qa.v - 1) {
            var yl = function(Rl, Ul) {
              var hl = 0;
              if (Ul < Rl) for (; hl <= 14 && Ul << ++hl < Rl; ) ;
              return hl;
            }(ll[dl][0], ll[dl][1]);
            _l = ka(nl, yl) + (wl << yl);
          } else _l = ka(nl, Qa.v) + 1;
          _l = 1 & _l ? -1 - (_l >>> 1) : _l >>> 1, ll[dl][0] += Tl(_l), ll[dl][1] == tl.f && (ll[dl][0] >>>= 1, ll[dl][1] >>>= 1), ll[dl][1]++, Sl = sl < 0 ? Sl - _l : Sl + _l, tl.i && (Sl < 0 ? Sl += Qa.w : Sl > tl.g && (Sl -= Qa.w)), gl[ml] = Sl >= 0 ? Math.min(Sl, tl.g) : 0;
        }
        function Na(tl, Qa, nl) {
          for (var rl = tl[0].length, il = Qa; il <= nl; il++) tl[il][0] = tl[il - 1][1], tl[il][rl - 1] = tl[il - 1][rl - 2];
        }
        function Ka(tl) {
          Na(tl, ba, _a), Na(tl, Jo, pa), Na(tl, wa, Ta);
        }
        function Ja(tl, Qa, nl, rl, il, cl, ll, al, sl, dl, El, fl, Ml) {
          for (var Sl = 0, ml = 1, Dl = il < ya && il > pa; ml < tl.m; ) Sl < tl.m && (Za(tl, Qa, nl, rl, il, Sl, ll[sl], tl.h && (Dl && dl || !Dl && (El || (Sl & fl) == Ml))), Za(tl, Qa, nl, rl, cl, Sl, ll[sl], tl.h && (!Dl && dl || Dl && (El || (Sl & fl) == Ml))), Sl += 2), Sl > 8 && (Za(tl, Qa, nl, rl, il, ml, al[sl]), Za(tl, Qa, nl, rl, cl, ml, al[sl]), ml += 2);
          Ka(rl);
        }
        function el(tl, Qa, nl, rl, il, cl) {
          Ja(tl, Qa, nl, rl, Jo, ba, il, cl, 0, 0, 1, 0, 8), Ja(tl, Qa, nl, rl, 8, wa, il, cl, 1, 0, 1, 0, 8), Ja(tl, Qa, nl, rl, 3, 9, il, cl, 2, 1, 0, 3, 0), Ja(tl, Qa, nl, rl, 10, 16, il, cl, 0, 0, 0, 3, 2), Ja(tl, Qa, nl, rl, pa, 11, il, cl, 1, 0, 0, 3, 2), Ja(tl, Qa, nl, rl, _a, Ta, il, cl, 2, 1, 0, 3, 0);
        }
        function qa(tl, Qa, nl, rl, il, cl) {
          var ll = cl.length, al = tl.l;
          il + 1 == tl.s && (al = tl.e - il * tl.l);
          for (var sl = 6 * tl.e * rl + il * tl.l, dl = 0; dl < 6; dl++) {
            for (var El = 0; El < al; El++) {
              var fl, Ml = cl[dl % ll][El % ll];
              fl = Ml == 0 ? Jo + (dl >>> 1) : Ml == 2 ? wa + (dl >>> 1) : ba + dl;
              var Sl = tl.h ? (2 * El / 3 & 2147483646 | El % 3 & 1) + (El % 3 >>> 1) : El >>> 1;
              Qa[sl + El] = nl[fl][Sl + 1];
            }
            sl += tl.e;
          }
        }
        Kn._decompressRAF = function(tl, Qa) {
          var nl = function(ml) {
            var Dl = Kn._binBE.readUshort, _l = { b: Dl(ml, 0), i: ml[2], C: ml[3], u: ml[4], q: Dl(ml, 5), k: Dl(ml, 7), e: Dl(ml, 9), l: Dl(ml, 11), s: ml[13], d: Dl(ml, 14) };
            if (_l.b != 18771 || _l.i > 1 || _l.q < 6 || _l.q % 6 || _l.e < 768 || _l.e % 24 || _l.l != 768 || _l.k < _l.l || _l.k % _l.l || _l.k - _l.e >= _l.l || _l.s > 16 || _l.s != _l.k / _l.l || _l.s != Math.ceil(_l.e / _l.l) || _l.d != _l.q / 6 || _l.u != 12 && _l.u != 14 && _l.u != 16 || _l.C != 16 && _l.C != 0) throw "Invalid data";
            if (_l.i == 0) throw "Not implemented. We need this file!";
            return _l.h = _l.C == 16, _l.m = 0 | (_l.h ? 2 * _l.l / 3 : _l.l >>> 1), _l.A = _l.m + 2, _l.f = 64, _l.g = (1 << _l.u) - 1, _l.n = 4 * _l.u, _l;
          }(tl), rl = function(ml, Dl) {
            var _l = new Array(Dl.s), gl = 4 * Dl.s, Fl = 16 + gl;
            12 & gl && (Fl += 16 - (12 & gl));
            for (var Nl = 0, zl = 16; Nl < Dl.s; zl += 4) {
              var Zl = Kn._binBE.readUint(ml, zl);
              _l[Nl] = ml.slice(Fl, Fl + Zl), _l[Nl].j = 0, _l[Nl].a = 0, Fl += Zl, Nl++;
            }
            if (Fl != ml.length) throw "Invalid data";
            return _l;
          }(tl, nl), il = Sa(nl), cl = new Int16Array(nl.e * nl.q);
          Qa == null && (Qa = nl.h ? [[1, 1, 0, 1, 1, 2], [1, 1, 2, 1, 1, 0], [2, 0, 1, 0, 2, 1], [1, 1, 2, 1, 1, 0], [1, 1, 0, 1, 1, 2], [0, 2, 1, 2, 0, 1]] : [[0, 1], [3, 2]]);
          for (var ll = [[0, 3], [1, pa], [ma, 11], [va, _a], [ya, 16], [xa, Ta]], al = [], sl = 0; sl < 18; sl++) al[sl] = new Uint16Array(nl.A);
          for (var dl = 0; dl < nl.s; dl++) {
            var El = Ma(il), fl = Ma(il);
            for (sl = 0; sl < 18; sl++) for (var Ml = 0; Ml < nl.A; Ml++) al[sl][Ml] = 0;
            for (var Sl = 0; Sl < nl.d; Sl++) {
              for (el(nl, il, rl[dl], al, El, fl), sl = 0; sl < 6; sl++) for (Ml = 0; Ml < nl.A; Ml++) al[ll[sl][0]][Ml] = al[ll[sl][1]][Ml];
              for (qa(nl, cl, al, Sl, dl, Qa), sl = Jo; sl < 18; sl++) if ([ma, va, ya, xa].indexOf(sl) == -1) for (Ml = 0; Ml < nl.A; Ml++) al[sl][Ml] = 0;
              Ka(al);
            }
          }
          return cl;
        };
      }();
    }(zn, typeof commonjsRequire == "function" ? requirePako$1() : self.pako);
  })();
})(UTIF);
var UTIFExports = UTIF.exports, utif = getDefaultExportFromCjs(UTIFExports), util$1, objectUtil;
function getDimensionValue(Xn) {
  return typeof Xn == "number" ? Xn : Xn instanceof Uint8Array ? Xn[0] : typeof Xn[0] == "string" ? parseInt(Xn[0]) : Xn[0];
}
function tiff() {
  return { mime: "image/tiff", encode: (Xn) => {
    const zn = utif.encodeImage(Xn.data, Xn.width, Xn.height);
    return Buffer$1.from(zn);
  }, decode: (Xn) => {
    const zn = utif.decode(Xn), Un = zn[0];
    if (!Un) throw new Error("No page found in TIFF");
    if (!Un.t256) throw new Error("No image width found in TIFF");
    if (!Un.t257) throw new Error("No image height found in TIFF");
    zn.forEach((qn) => {
      utif.decodeImage(Xn, qn);
    });
    const Kn = utif.toRGBA8(Un);
    return { data: Buffer$1.from(Kn), width: getDimensionValue(Un.t256), height: getDimensionValue(Un.t257) };
  } };
}
(function(Xn) {
  Xn.assertEqual = (zn) => zn, Xn.assertIs = function(zn) {
  }, Xn.assertNever = function(zn) {
    throw new Error();
  }, Xn.arrayToEnum = (zn) => {
    const Un = {};
    for (const Kn of zn) Un[Kn] = Kn;
    return Un;
  }, Xn.getValidEnumValues = (zn) => {
    const Un = Xn.objectKeys(zn).filter((qn) => typeof zn[zn[qn]] != "number"), Kn = {};
    for (const qn of Un) Kn[qn] = zn[qn];
    return Xn.objectValues(Kn);
  }, Xn.objectValues = (zn) => Xn.objectKeys(zn).map(function(Un) {
    return zn[Un];
  }), Xn.objectKeys = typeof Object.keys == "function" ? (zn) => Object.keys(zn) : (zn) => {
    const Un = [];
    for (const Kn in zn) Object.prototype.hasOwnProperty.call(zn, Kn) && Un.push(Kn);
    return Un;
  }, Xn.find = (zn, Un) => {
    for (const Kn of zn) if (Un(Kn)) return Kn;
  }, Xn.isInteger = typeof Number.isInteger == "function" ? (zn) => Number.isInteger(zn) : (zn) => typeof zn == "number" && isFinite(zn) && Math.floor(zn) === zn, Xn.joinValues = function(zn, Un = " | ") {
    return zn.map((Kn) => typeof Kn == "string" ? `'${Kn}'` : Kn).join(Un);
  }, Xn.jsonStringifyReplacer = (zn, Un) => typeof Un == "bigint" ? Un.toString() : Un;
})(util$1 || (util$1 = {})), function(Xn) {
  Xn.mergeShapes = (zn, Un) => ({ ...zn, ...Un });
}(objectUtil || (objectUtil = {}));
const ZodParsedType = util$1.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), getParsedType = (Xn) => {
  switch (typeof Xn) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(Xn) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      return Array.isArray(Xn) ? ZodParsedType.array : Xn === null ? ZodParsedType.null : Xn.then && typeof Xn.then == "function" && Xn.catch && typeof Xn.catch == "function" ? ZodParsedType.promise : typeof Map < "u" && Xn instanceof Map ? ZodParsedType.map : typeof Set < "u" && Xn instanceof Set ? ZodParsedType.set : typeof Date < "u" && Xn instanceof Date ? ZodParsedType.date : ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
}, ZodIssueCode = util$1.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]), quotelessJson = (Xn) => JSON.stringify(Xn, null, 2).replace(/"([^"]+)":/g, "$1:");
class ZodError extends Error {
  constructor(zn) {
    super(), this.issues = [], this.addIssue = (Kn) => {
      this.issues = [...this.issues, Kn];
    }, this.addIssues = (Kn = []) => {
      this.issues = [...this.issues, ...Kn];
    };
    const Un = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, Un) : this.__proto__ = Un, this.name = "ZodError", this.issues = zn;
  }
  get errors() {
    return this.issues;
  }
  format(zn) {
    const Un = zn || function(Jo) {
      return Jo.message;
    }, Kn = { _errors: [] }, qn = (Jo) => {
      for (const pa of Jo.issues) if (pa.code === "invalid_union") pa.unionErrors.map(qn);
      else if (pa.code === "invalid_return_type") qn(pa.returnTypeError);
      else if (pa.code === "invalid_arguments") qn(pa.argumentsError);
      else if (pa.path.length === 0) Kn._errors.push(Un(pa));
      else {
        let ma = Kn, va = 0;
        for (; va < pa.path.length; ) {
          const ba = pa.path[va];
          va === pa.path.length - 1 ? (ma[ba] = ma[ba] || { _errors: [] }, ma[ba]._errors.push(Un(pa))) : ma[ba] = ma[ba] || { _errors: [] }, ma = ma[ba], va++;
        }
      }
    };
    return qn(this), Kn;
  }
  static assert(zn) {
    if (!(zn instanceof ZodError)) throw new Error(`Not a ZodError: ${zn}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util$1.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(zn = (Un) => Un.message) {
    const Un = {}, Kn = [];
    for (const qn of this.issues) qn.path.length > 0 ? (Un[qn.path[0]] = Un[qn.path[0]] || [], Un[qn.path[0]].push(zn(qn))) : Kn.push(zn(qn));
    return { formErrors: Kn, fieldErrors: Un };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (Xn) => new ZodError(Xn);
const errorMap = (Xn, zn) => {
  let Un;
  switch (Xn.code) {
    case ZodIssueCode.invalid_type:
      Un = Xn.received === ZodParsedType.undefined ? "Required" : `Expected ${Xn.expected}, received ${Xn.received}`;
      break;
    case ZodIssueCode.invalid_literal:
      Un = `Invalid literal value, expected ${JSON.stringify(Xn.expected, util$1.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      Un = `Unrecognized key(s) in object: ${util$1.joinValues(Xn.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      Un = "Invalid input";
      break;
    case ZodIssueCode.invalid_union_discriminator:
      Un = `Invalid discriminator value. Expected ${util$1.joinValues(Xn.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      Un = `Invalid enum value. Expected ${util$1.joinValues(Xn.options)}, received '${Xn.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      Un = "Invalid function arguments";
      break;
    case ZodIssueCode.invalid_return_type:
      Un = "Invalid function return type";
      break;
    case ZodIssueCode.invalid_date:
      Un = "Invalid date";
      break;
    case ZodIssueCode.invalid_string:
      typeof Xn.validation == "object" ? "includes" in Xn.validation ? (Un = `Invalid input: must include "${Xn.validation.includes}"`, typeof Xn.validation.position == "number" && (Un = `${Un} at one or more positions greater than or equal to ${Xn.validation.position}`)) : "startsWith" in Xn.validation ? Un = `Invalid input: must start with "${Xn.validation.startsWith}"` : "endsWith" in Xn.validation ? Un = `Invalid input: must end with "${Xn.validation.endsWith}"` : util$1.assertNever(Xn.validation) : Un = Xn.validation !== "regex" ? `Invalid ${Xn.validation}` : "Invalid";
      break;
    case ZodIssueCode.too_small:
      Un = Xn.type === "array" ? `Array must contain ${Xn.exact ? "exactly" : Xn.inclusive ? "at least" : "more than"} ${Xn.minimum} element(s)` : Xn.type === "string" ? `String must contain ${Xn.exact ? "exactly" : Xn.inclusive ? "at least" : "over"} ${Xn.minimum} character(s)` : Xn.type === "number" ? `Number must be ${Xn.exact ? "exactly equal to " : Xn.inclusive ? "greater than or equal to " : "greater than "}${Xn.minimum}` : Xn.type === "date" ? `Date must be ${Xn.exact ? "exactly equal to " : Xn.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(Xn.minimum))}` : "Invalid input";
      break;
    case ZodIssueCode.too_big:
      Un = Xn.type === "array" ? `Array must contain ${Xn.exact ? "exactly" : Xn.inclusive ? "at most" : "less than"} ${Xn.maximum} element(s)` : Xn.type === "string" ? `String must contain ${Xn.exact ? "exactly" : Xn.inclusive ? "at most" : "under"} ${Xn.maximum} character(s)` : Xn.type === "number" ? `Number must be ${Xn.exact ? "exactly" : Xn.inclusive ? "less than or equal to" : "less than"} ${Xn.maximum}` : Xn.type === "bigint" ? `BigInt must be ${Xn.exact ? "exactly" : Xn.inclusive ? "less than or equal to" : "less than"} ${Xn.maximum}` : Xn.type === "date" ? `Date must be ${Xn.exact ? "exactly" : Xn.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(Xn.maximum))}` : "Invalid input";
      break;
    case ZodIssueCode.custom:
      Un = "Invalid input";
      break;
    case ZodIssueCode.invalid_intersection_types:
      Un = "Intersection results could not be merged";
      break;
    case ZodIssueCode.not_multiple_of:
      Un = `Number must be a multiple of ${Xn.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      Un = "Number must be finite";
      break;
    default:
      Un = zn.defaultError, util$1.assertNever(Xn);
  }
  return { message: Un };
};
let overrideErrorMap = errorMap;
function setErrorMap(Xn) {
  overrideErrorMap = Xn;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (Xn) => {
  const { data: zn, path: Un, errorMaps: Kn, issueData: qn } = Xn, Jo = [...Un, ...qn.path || []], pa = { ...qn, path: Jo };
  if (qn.message !== void 0) return { ...qn, path: Jo, message: qn.message };
  let ma = "";
  const va = Kn.filter((ba) => !!ba).slice().reverse();
  for (const ba of va) ma = ba(pa, { data: zn, defaultError: ma }).message;
  return { ...qn, path: Jo, message: ma };
}, EMPTY_PATH = [];
function addIssueToContext(Xn, zn) {
  const Un = getErrorMap(), Kn = makeIssue({ issueData: zn, data: Xn.data, path: Xn.path, errorMaps: [Xn.common.contextualErrorMap, Xn.schemaErrorMap, Un, Un === errorMap ? void 0 : errorMap].filter((qn) => !!qn) });
  Xn.common.issues.push(Kn);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(zn, Un) {
    const Kn = [];
    for (const qn of Un) {
      if (qn.status === "aborted") return INVALID;
      qn.status === "dirty" && zn.dirty(), Kn.push(qn.value);
    }
    return { status: zn.value, value: Kn };
  }
  static async mergeObjectAsync(zn, Un) {
    const Kn = [];
    for (const qn of Un) {
      const Jo = await qn.key, pa = await qn.value;
      Kn.push({ key: Jo, value: pa });
    }
    return ParseStatus.mergeObjectSync(zn, Kn);
  }
  static mergeObjectSync(zn, Un) {
    const Kn = {};
    for (const qn of Un) {
      const { key: Jo, value: pa } = qn;
      if (Jo.status === "aborted" || pa.status === "aborted") return INVALID;
      Jo.status === "dirty" && zn.dirty(), pa.status === "dirty" && zn.dirty(), Jo.value === "__proto__" || pa.value === void 0 && !qn.alwaysSet || (Kn[Jo.value] = pa.value);
    }
    return { status: zn.value, value: Kn };
  }
}
const INVALID = Object.freeze({ status: "aborted" }), DIRTY = (Xn) => ({ status: "dirty", value: Xn }), OK = (Xn) => ({ status: "valid", value: Xn }), isAborted = (Xn) => Xn.status === "aborted", isDirty = (Xn) => Xn.status === "dirty", isValid = (Xn) => Xn.status === "valid", isAsync = (Xn) => typeof Promise < "u" && Xn instanceof Promise;
function __classPrivateFieldGet(Xn, zn, Un, Kn) {
  if (typeof zn == "function" ? Xn !== zn || !0 : !zn.has(Xn)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return zn.get(Xn);
}
function __classPrivateFieldSet(Xn, zn, Un, Kn, qn) {
  if (typeof zn == "function" ? Xn !== zn || !0 : !zn.has(Xn)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return zn.set(Xn, Un), Un;
}
var errorUtil, _ZodEnum_cache, _ZodNativeEnum_cache;
typeof SuppressedError == "function" && SuppressedError, function(Xn) {
  Xn.errToObj = (zn) => typeof zn == "string" ? { message: zn } : zn || {}, Xn.toString = (zn) => typeof zn == "string" ? zn : zn == null ? void 0 : zn.message;
}(errorUtil || (errorUtil = {}));
class ParseInputLazyPath {
  constructor(zn, Un, Kn, qn) {
    this._cachedPath = [], this.parent = zn, this.data = Un, this._path = Kn, this._key = qn;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const handleResult = (Xn, zn) => {
  if (isValid(zn)) return { success: !0, data: zn.value };
  if (!Xn.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const Un = new ZodError(Xn.common.issues);
    return this._error = Un, this._error;
  } };
};
function processCreateParams(Xn) {
  if (!Xn) return {};
  const { errorMap: zn, invalid_type_error: Un, required_error: Kn, description: qn } = Xn;
  if (zn && (Un || Kn)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return zn ? { errorMap: zn, description: qn } : { errorMap: (Jo, pa) => {
    var ma, va;
    const { message: ba } = Xn;
    return Jo.code === "invalid_enum_value" ? { message: ba ?? pa.defaultError } : pa.data === void 0 ? { message: (ma = ba ?? Kn) !== null && ma !== void 0 ? ma : pa.defaultError } : Jo.code !== "invalid_type" ? { message: pa.defaultError } : { message: (va = ba ?? Un) !== null && va !== void 0 ? va : pa.defaultError };
  }, description: qn };
}
class ZodType {
  constructor(zn) {
    this.spa = this.safeParseAsync, this._def = zn, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(zn) {
    return getParsedType(zn.data);
  }
  _getOrReturnCtx(zn, Un) {
    return Un || { common: zn.parent.common, data: zn.data, parsedType: getParsedType(zn.data), schemaErrorMap: this._def.errorMap, path: zn.path, parent: zn.parent };
  }
  _processInputParams(zn) {
    return { status: new ParseStatus(), ctx: { common: zn.parent.common, data: zn.data, parsedType: getParsedType(zn.data), schemaErrorMap: this._def.errorMap, path: zn.path, parent: zn.parent } };
  }
  _parseSync(zn) {
    const Un = this._parse(zn);
    if (isAsync(Un)) throw new Error("Synchronous parse encountered promise.");
    return Un;
  }
  _parseAsync(zn) {
    const Un = this._parse(zn);
    return Promise.resolve(Un);
  }
  parse(zn, Un) {
    const Kn = this.safeParse(zn, Un);
    if (Kn.success) return Kn.data;
    throw Kn.error;
  }
  safeParse(zn, Un) {
    var Kn;
    const qn = { common: { issues: [], async: (Kn = Un == null ? void 0 : Un.async) !== null && Kn !== void 0 && Kn, contextualErrorMap: Un == null ? void 0 : Un.errorMap }, path: (Un == null ? void 0 : Un.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: zn, parsedType: getParsedType(zn) }, Jo = this._parseSync({ data: zn, path: qn.path, parent: qn });
    return handleResult(qn, Jo);
  }
  async parseAsync(zn, Un) {
    const Kn = await this.safeParseAsync(zn, Un);
    if (Kn.success) return Kn.data;
    throw Kn.error;
  }
  async safeParseAsync(zn, Un) {
    const Kn = { common: { issues: [], contextualErrorMap: Un == null ? void 0 : Un.errorMap, async: !0 }, path: (Un == null ? void 0 : Un.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: zn, parsedType: getParsedType(zn) }, qn = this._parse({ data: zn, path: Kn.path, parent: Kn }), Jo = await (isAsync(qn) ? qn : Promise.resolve(qn));
    return handleResult(Kn, Jo);
  }
  refine(zn, Un) {
    const Kn = (qn) => typeof Un == "string" || Un === void 0 ? { message: Un } : typeof Un == "function" ? Un(qn) : Un;
    return this._refinement((qn, Jo) => {
      const pa = zn(qn), ma = () => Jo.addIssue({ code: ZodIssueCode.custom, ...Kn(qn) });
      return typeof Promise < "u" && pa instanceof Promise ? pa.then((va) => !!va || (ma(), !1)) : !!pa || (ma(), !1);
    });
  }
  refinement(zn, Un) {
    return this._refinement((Kn, qn) => !!zn(Kn) || (qn.addIssue(typeof Un == "function" ? Un(Kn, qn) : Un), !1));
  }
  _refinement(zn) {
    return new ZodEffects({ schema: this, typeName: ZodFirstPartyTypeKind.ZodEffects, effect: { type: "refinement", refinement: zn } });
  }
  superRefine(zn) {
    return this._refinement(zn);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(zn) {
    return ZodUnion.create([this, zn], this._def);
  }
  and(zn) {
    return ZodIntersection.create(this, zn, this._def);
  }
  transform(zn) {
    return new ZodEffects({ ...processCreateParams(this._def), schema: this, typeName: ZodFirstPartyTypeKind.ZodEffects, effect: { type: "transform", transform: zn } });
  }
  default(zn) {
    const Un = typeof zn == "function" ? zn : () => zn;
    return new ZodDefault({ ...processCreateParams(this._def), innerType: this, defaultValue: Un, typeName: ZodFirstPartyTypeKind.ZodDefault });
  }
  brand() {
    return new ZodBranded({ typeName: ZodFirstPartyTypeKind.ZodBranded, type: this, ...processCreateParams(this._def) });
  }
  catch(zn) {
    const Un = typeof zn == "function" ? zn : () => zn;
    return new ZodCatch({ ...processCreateParams(this._def), innerType: this, catchValue: Un, typeName: ZodFirstPartyTypeKind.ZodCatch });
  }
  describe(zn) {
    return new this.constructor({ ...this._def, description: zn });
  }
  pipe(zn) {
    return ZodPipeline.create(this, zn);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i, cuid2Regex = /^[0-9a-z]+$/, ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/, uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, nanoidRegex = /^[a-z0-9_-]{21}$/i, durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let emojiRegex;
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, dateRegexSource = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", dateRegex$1 = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(Xn) {
  let zn = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return Xn.precision ? zn = `${zn}\\.\\d{${Xn.precision}}` : Xn.precision == null && (zn = `${zn}(\\.\\d+)?`), zn;
}
function timeRegex(Xn) {
  return new RegExp(`^${timeRegexSource(Xn)}$`);
}
function datetimeRegex(Xn) {
  let zn = `${dateRegexSource}T${timeRegexSource(Xn)}`;
  const Un = [];
  return Un.push(Xn.local ? "Z?" : "Z"), Xn.offset && Un.push("([+-]\\d{2}:?\\d{2})"), zn = `${zn}(${Un.join("|")})`, new RegExp(`^${zn}$`);
}
function isValidIP(Xn, zn) {
  return !(zn !== "v4" && zn || !ipv4Regex.test(Xn)) || !(zn !== "v6" && zn || !ipv6Regex.test(Xn));
}
class ZodString extends ZodType {
  _parse(zn) {
    if (this._def.coerce && (zn.data = String(zn.data)), this._getType(zn) !== ZodParsedType.string) {
      const qn = this._getOrReturnCtx(zn);
      return addIssueToContext(qn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.string, received: qn.parsedType }), INVALID;
    }
    const Un = new ParseStatus();
    let Kn;
    for (const qn of this._def.checks) if (qn.kind === "min") zn.data.length < qn.value && (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.too_small, minimum: qn.value, type: "string", inclusive: !0, exact: !1, message: qn.message }), Un.dirty());
    else if (qn.kind === "max") zn.data.length > qn.value && (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.too_big, maximum: qn.value, type: "string", inclusive: !0, exact: !1, message: qn.message }), Un.dirty());
    else if (qn.kind === "length") {
      const Jo = zn.data.length > qn.value, pa = zn.data.length < qn.value;
      (Jo || pa) && (Kn = this._getOrReturnCtx(zn, Kn), Jo ? addIssueToContext(Kn, { code: ZodIssueCode.too_big, maximum: qn.value, type: "string", inclusive: !0, exact: !0, message: qn.message }) : pa && addIssueToContext(Kn, { code: ZodIssueCode.too_small, minimum: qn.value, type: "string", inclusive: !0, exact: !0, message: qn.message }), Un.dirty());
    } else if (qn.kind === "email") emailRegex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "email", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty());
    else if (qn.kind === "emoji") emojiRegex || (emojiRegex = new RegExp(_emojiRegex, "u")), emojiRegex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "emoji", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty());
    else if (qn.kind === "uuid") uuidRegex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "uuid", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty());
    else if (qn.kind === "nanoid") nanoidRegex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "nanoid", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty());
    else if (qn.kind === "cuid") cuidRegex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "cuid", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty());
    else if (qn.kind === "cuid2") cuid2Regex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "cuid2", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty());
    else if (qn.kind === "ulid") ulidRegex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "ulid", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty());
    else if (qn.kind === "url") try {
      new URL(zn.data);
    } catch {
      Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "url", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty();
    }
    else qn.kind === "regex" ? (qn.regex.lastIndex = 0, qn.regex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "regex", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty())) : qn.kind === "trim" ? zn.data = zn.data.trim() : qn.kind === "includes" ? zn.data.includes(qn.value, qn.position) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.invalid_string, validation: { includes: qn.value, position: qn.position }, message: qn.message }), Un.dirty()) : qn.kind === "toLowerCase" ? zn.data = zn.data.toLowerCase() : qn.kind === "toUpperCase" ? zn.data = zn.data.toUpperCase() : qn.kind === "startsWith" ? zn.data.startsWith(qn.value) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.invalid_string, validation: { startsWith: qn.value }, message: qn.message }), Un.dirty()) : qn.kind === "endsWith" ? zn.data.endsWith(qn.value) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.invalid_string, validation: { endsWith: qn.value }, message: qn.message }), Un.dirty()) : qn.kind === "datetime" ? datetimeRegex(qn).test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.invalid_string, validation: "datetime", message: qn.message }), Un.dirty()) : qn.kind === "date" ? dateRegex$1.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.invalid_string, validation: "date", message: qn.message }), Un.dirty()) : qn.kind === "time" ? timeRegex(qn).test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.invalid_string, validation: "time", message: qn.message }), Un.dirty()) : qn.kind === "duration" ? durationRegex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "duration", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty()) : qn.kind === "ip" ? isValidIP(zn.data, qn.version) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "ip", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty()) : qn.kind === "base64" ? base64Regex.test(zn.data) || (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { validation: "base64", code: ZodIssueCode.invalid_string, message: qn.message }), Un.dirty()) : util$1.assertNever(qn);
    return { status: Un.value, value: zn.data };
  }
  _regex(zn, Un, Kn) {
    return this.refinement((qn) => zn.test(qn), { validation: Un, code: ZodIssueCode.invalid_string, ...errorUtil.errToObj(Kn) });
  }
  _addCheck(zn) {
    return new ZodString({ ...this._def, checks: [...this._def.checks, zn] });
  }
  email(zn) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(zn) });
  }
  url(zn) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(zn) });
  }
  emoji(zn) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(zn) });
  }
  uuid(zn) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(zn) });
  }
  nanoid(zn) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(zn) });
  }
  cuid(zn) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(zn) });
  }
  cuid2(zn) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(zn) });
  }
  ulid(zn) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(zn) });
  }
  base64(zn) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(zn) });
  }
  ip(zn) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(zn) });
  }
  datetime(zn) {
    var Un, Kn;
    return typeof zn == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: zn }) : this._addCheck({ kind: "datetime", precision: (zn == null ? void 0 : zn.precision) === void 0 ? null : zn == null ? void 0 : zn.precision, offset: (Un = zn == null ? void 0 : zn.offset) !== null && Un !== void 0 && Un, local: (Kn = zn == null ? void 0 : zn.local) !== null && Kn !== void 0 && Kn, ...errorUtil.errToObj(zn == null ? void 0 : zn.message) });
  }
  date(zn) {
    return this._addCheck({ kind: "date", message: zn });
  }
  time(zn) {
    return typeof zn == "string" ? this._addCheck({ kind: "time", precision: null, message: zn }) : this._addCheck({ kind: "time", precision: (zn == null ? void 0 : zn.precision) === void 0 ? null : zn == null ? void 0 : zn.precision, ...errorUtil.errToObj(zn == null ? void 0 : zn.message) });
  }
  duration(zn) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(zn) });
  }
  regex(zn, Un) {
    return this._addCheck({ kind: "regex", regex: zn, ...errorUtil.errToObj(Un) });
  }
  includes(zn, Un) {
    return this._addCheck({ kind: "includes", value: zn, position: Un == null ? void 0 : Un.position, ...errorUtil.errToObj(Un == null ? void 0 : Un.message) });
  }
  startsWith(zn, Un) {
    return this._addCheck({ kind: "startsWith", value: zn, ...errorUtil.errToObj(Un) });
  }
  endsWith(zn, Un) {
    return this._addCheck({ kind: "endsWith", value: zn, ...errorUtil.errToObj(Un) });
  }
  min(zn, Un) {
    return this._addCheck({ kind: "min", value: zn, ...errorUtil.errToObj(Un) });
  }
  max(zn, Un) {
    return this._addCheck({ kind: "max", value: zn, ...errorUtil.errToObj(Un) });
  }
  length(zn, Un) {
    return this._addCheck({ kind: "length", value: zn, ...errorUtil.errToObj(Un) });
  }
  nonempty(zn) {
    return this.min(1, errorUtil.errToObj(zn));
  }
  trim() {
    return new ZodString({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new ZodString({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new ZodString({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((zn) => zn.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((zn) => zn.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((zn) => zn.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((zn) => zn.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((zn) => zn.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((zn) => zn.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((zn) => zn.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((zn) => zn.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((zn) => zn.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((zn) => zn.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((zn) => zn.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((zn) => zn.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((zn) => zn.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((zn) => zn.kind === "base64");
  }
  get minLength() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "min" && (zn === null || Un.value > zn) && (zn = Un.value);
    return zn;
  }
  get maxLength() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "max" && (zn === null || Un.value < zn) && (zn = Un.value);
    return zn;
  }
}
function floatSafeRemainder(Xn, zn) {
  const Un = (Xn.toString().split(".")[1] || "").length, Kn = (zn.toString().split(".")[1] || "").length, qn = Un > Kn ? Un : Kn;
  return parseInt(Xn.toFixed(qn).replace(".", "")) % parseInt(zn.toFixed(qn).replace(".", "")) / Math.pow(10, qn);
}
ZodString.create = (Xn) => {
  var zn;
  return new ZodString({ checks: [], typeName: ZodFirstPartyTypeKind.ZodString, coerce: (zn = Xn == null ? void 0 : Xn.coerce) !== null && zn !== void 0 && zn, ...processCreateParams(Xn) });
};
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(zn) {
    if (this._def.coerce && (zn.data = Number(zn.data)), this._getType(zn) !== ZodParsedType.number) {
      const qn = this._getOrReturnCtx(zn);
      return addIssueToContext(qn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.number, received: qn.parsedType }), INVALID;
    }
    let Un;
    const Kn = new ParseStatus();
    for (const qn of this._def.checks) qn.kind === "int" ? util$1.isInteger(zn.data) || (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: "integer", received: "float", message: qn.message }), Kn.dirty()) : qn.kind === "min" ? (qn.inclusive ? zn.data < qn.value : zn.data <= qn.value) && (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.too_small, minimum: qn.value, type: "number", inclusive: qn.inclusive, exact: !1, message: qn.message }), Kn.dirty()) : qn.kind === "max" ? (qn.inclusive ? zn.data > qn.value : zn.data >= qn.value) && (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.too_big, maximum: qn.value, type: "number", inclusive: qn.inclusive, exact: !1, message: qn.message }), Kn.dirty()) : qn.kind === "multipleOf" ? floatSafeRemainder(zn.data, qn.value) !== 0 && (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.not_multiple_of, multipleOf: qn.value, message: qn.message }), Kn.dirty()) : qn.kind === "finite" ? Number.isFinite(zn.data) || (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.not_finite, message: qn.message }), Kn.dirty()) : util$1.assertNever(qn);
    return { status: Kn.value, value: zn.data };
  }
  gte(zn, Un) {
    return this.setLimit("min", zn, !0, errorUtil.toString(Un));
  }
  gt(zn, Un) {
    return this.setLimit("min", zn, !1, errorUtil.toString(Un));
  }
  lte(zn, Un) {
    return this.setLimit("max", zn, !0, errorUtil.toString(Un));
  }
  lt(zn, Un) {
    return this.setLimit("max", zn, !1, errorUtil.toString(Un));
  }
  setLimit(zn, Un, Kn, qn) {
    return new ZodNumber({ ...this._def, checks: [...this._def.checks, { kind: zn, value: Un, inclusive: Kn, message: errorUtil.toString(qn) }] });
  }
  _addCheck(zn) {
    return new ZodNumber({ ...this._def, checks: [...this._def.checks, zn] });
  }
  int(zn) {
    return this._addCheck({ kind: "int", message: errorUtil.toString(zn) });
  }
  positive(zn) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: errorUtil.toString(zn) });
  }
  negative(zn) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: errorUtil.toString(zn) });
  }
  nonpositive(zn) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: errorUtil.toString(zn) });
  }
  nonnegative(zn) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: errorUtil.toString(zn) });
  }
  multipleOf(zn, Un) {
    return this._addCheck({ kind: "multipleOf", value: zn, message: errorUtil.toString(Un) });
  }
  finite(zn) {
    return this._addCheck({ kind: "finite", message: errorUtil.toString(zn) });
  }
  safe(zn) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: errorUtil.toString(zn) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: errorUtil.toString(zn) });
  }
  get minValue() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "min" && (zn === null || Un.value > zn) && (zn = Un.value);
    return zn;
  }
  get maxValue() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "max" && (zn === null || Un.value < zn) && (zn = Un.value);
    return zn;
  }
  get isInt() {
    return !!this._def.checks.find((zn) => zn.kind === "int" || zn.kind === "multipleOf" && util$1.isInteger(zn.value));
  }
  get isFinite() {
    let zn = null, Un = null;
    for (const Kn of this._def.checks) {
      if (Kn.kind === "finite" || Kn.kind === "int" || Kn.kind === "multipleOf") return !0;
      Kn.kind === "min" ? (Un === null || Kn.value > Un) && (Un = Kn.value) : Kn.kind === "max" && (zn === null || Kn.value < zn) && (zn = Kn.value);
    }
    return Number.isFinite(Un) && Number.isFinite(zn);
  }
}
ZodNumber.create = (Xn) => new ZodNumber({ checks: [], typeName: ZodFirstPartyTypeKind.ZodNumber, coerce: (Xn == null ? void 0 : Xn.coerce) || !1, ...processCreateParams(Xn) });
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(zn) {
    if (this._def.coerce && (zn.data = BigInt(zn.data)), this._getType(zn) !== ZodParsedType.bigint) {
      const qn = this._getOrReturnCtx(zn);
      return addIssueToContext(qn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.bigint, received: qn.parsedType }), INVALID;
    }
    let Un;
    const Kn = new ParseStatus();
    for (const qn of this._def.checks) qn.kind === "min" ? (qn.inclusive ? zn.data < qn.value : zn.data <= qn.value) && (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.too_small, type: "bigint", minimum: qn.value, inclusive: qn.inclusive, message: qn.message }), Kn.dirty()) : qn.kind === "max" ? (qn.inclusive ? zn.data > qn.value : zn.data >= qn.value) && (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.too_big, type: "bigint", maximum: qn.value, inclusive: qn.inclusive, message: qn.message }), Kn.dirty()) : qn.kind === "multipleOf" ? zn.data % qn.value !== BigInt(0) && (Un = this._getOrReturnCtx(zn, Un), addIssueToContext(Un, { code: ZodIssueCode.not_multiple_of, multipleOf: qn.value, message: qn.message }), Kn.dirty()) : util$1.assertNever(qn);
    return { status: Kn.value, value: zn.data };
  }
  gte(zn, Un) {
    return this.setLimit("min", zn, !0, errorUtil.toString(Un));
  }
  gt(zn, Un) {
    return this.setLimit("min", zn, !1, errorUtil.toString(Un));
  }
  lte(zn, Un) {
    return this.setLimit("max", zn, !0, errorUtil.toString(Un));
  }
  lt(zn, Un) {
    return this.setLimit("max", zn, !1, errorUtil.toString(Un));
  }
  setLimit(zn, Un, Kn, qn) {
    return new ZodBigInt({ ...this._def, checks: [...this._def.checks, { kind: zn, value: Un, inclusive: Kn, message: errorUtil.toString(qn) }] });
  }
  _addCheck(zn) {
    return new ZodBigInt({ ...this._def, checks: [...this._def.checks, zn] });
  }
  positive(zn) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: errorUtil.toString(zn) });
  }
  negative(zn) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: errorUtil.toString(zn) });
  }
  nonpositive(zn) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: errorUtil.toString(zn) });
  }
  nonnegative(zn) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: errorUtil.toString(zn) });
  }
  multipleOf(zn, Un) {
    return this._addCheck({ kind: "multipleOf", value: zn, message: errorUtil.toString(Un) });
  }
  get minValue() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "min" && (zn === null || Un.value > zn) && (zn = Un.value);
    return zn;
  }
  get maxValue() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "max" && (zn === null || Un.value < zn) && (zn = Un.value);
    return zn;
  }
}
ZodBigInt.create = (Xn) => {
  var zn;
  return new ZodBigInt({ checks: [], typeName: ZodFirstPartyTypeKind.ZodBigInt, coerce: (zn = Xn == null ? void 0 : Xn.coerce) !== null && zn !== void 0 && zn, ...processCreateParams(Xn) });
};
class ZodBoolean extends ZodType {
  _parse(zn) {
    if (this._def.coerce && (zn.data = !!zn.data), this._getType(zn) !== ZodParsedType.boolean) {
      const Un = this._getOrReturnCtx(zn);
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.boolean, received: Un.parsedType }), INVALID;
    }
    return OK(zn.data);
  }
}
ZodBoolean.create = (Xn) => new ZodBoolean({ typeName: ZodFirstPartyTypeKind.ZodBoolean, coerce: (Xn == null ? void 0 : Xn.coerce) || !1, ...processCreateParams(Xn) });
class ZodDate extends ZodType {
  _parse(zn) {
    if (this._def.coerce && (zn.data = new Date(zn.data)), this._getType(zn) !== ZodParsedType.date) {
      const qn = this._getOrReturnCtx(zn);
      return addIssueToContext(qn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.date, received: qn.parsedType }), INVALID;
    }
    if (isNaN(zn.data.getTime()))
      return addIssueToContext(this._getOrReturnCtx(zn), { code: ZodIssueCode.invalid_date }), INVALID;
    const Un = new ParseStatus();
    let Kn;
    for (const qn of this._def.checks) qn.kind === "min" ? zn.data.getTime() < qn.value && (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.too_small, message: qn.message, inclusive: !0, exact: !1, minimum: qn.value, type: "date" }), Un.dirty()) : qn.kind === "max" ? zn.data.getTime() > qn.value && (Kn = this._getOrReturnCtx(zn, Kn), addIssueToContext(Kn, { code: ZodIssueCode.too_big, message: qn.message, inclusive: !0, exact: !1, maximum: qn.value, type: "date" }), Un.dirty()) : util$1.assertNever(qn);
    return { status: Un.value, value: new Date(zn.data.getTime()) };
  }
  _addCheck(zn) {
    return new ZodDate({ ...this._def, checks: [...this._def.checks, zn] });
  }
  min(zn, Un) {
    return this._addCheck({ kind: "min", value: zn.getTime(), message: errorUtil.toString(Un) });
  }
  max(zn, Un) {
    return this._addCheck({ kind: "max", value: zn.getTime(), message: errorUtil.toString(Un) });
  }
  get minDate() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "min" && (zn === null || Un.value > zn) && (zn = Un.value);
    return zn != null ? new Date(zn) : null;
  }
  get maxDate() {
    let zn = null;
    for (const Un of this._def.checks) Un.kind === "max" && (zn === null || Un.value < zn) && (zn = Un.value);
    return zn != null ? new Date(zn) : null;
  }
}
ZodDate.create = (Xn) => new ZodDate({ checks: [], coerce: (Xn == null ? void 0 : Xn.coerce) || !1, typeName: ZodFirstPartyTypeKind.ZodDate, ...processCreateParams(Xn) });
class ZodSymbol extends ZodType {
  _parse(zn) {
    if (this._getType(zn) !== ZodParsedType.symbol) {
      const Un = this._getOrReturnCtx(zn);
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.symbol, received: Un.parsedType }), INVALID;
    }
    return OK(zn.data);
  }
}
ZodSymbol.create = (Xn) => new ZodSymbol({ typeName: ZodFirstPartyTypeKind.ZodSymbol, ...processCreateParams(Xn) });
class ZodUndefined extends ZodType {
  _parse(zn) {
    if (this._getType(zn) !== ZodParsedType.undefined) {
      const Un = this._getOrReturnCtx(zn);
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.undefined, received: Un.parsedType }), INVALID;
    }
    return OK(zn.data);
  }
}
ZodUndefined.create = (Xn) => new ZodUndefined({ typeName: ZodFirstPartyTypeKind.ZodUndefined, ...processCreateParams(Xn) });
class ZodNull extends ZodType {
  _parse(zn) {
    if (this._getType(zn) !== ZodParsedType.null) {
      const Un = this._getOrReturnCtx(zn);
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.null, received: Un.parsedType }), INVALID;
    }
    return OK(zn.data);
  }
}
ZodNull.create = (Xn) => new ZodNull({ typeName: ZodFirstPartyTypeKind.ZodNull, ...processCreateParams(Xn) });
class ZodAny extends ZodType {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(zn) {
    return OK(zn.data);
  }
}
ZodAny.create = (Xn) => new ZodAny({ typeName: ZodFirstPartyTypeKind.ZodAny, ...processCreateParams(Xn) });
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(zn) {
    return OK(zn.data);
  }
}
ZodUnknown.create = (Xn) => new ZodUnknown({ typeName: ZodFirstPartyTypeKind.ZodUnknown, ...processCreateParams(Xn) });
class ZodNever extends ZodType {
  _parse(zn) {
    const Un = this._getOrReturnCtx(zn);
    return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.never, received: Un.parsedType }), INVALID;
  }
}
ZodNever.create = (Xn) => new ZodNever({ typeName: ZodFirstPartyTypeKind.ZodNever, ...processCreateParams(Xn) });
class ZodVoid extends ZodType {
  _parse(zn) {
    if (this._getType(zn) !== ZodParsedType.undefined) {
      const Un = this._getOrReturnCtx(zn);
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.void, received: Un.parsedType }), INVALID;
    }
    return OK(zn.data);
  }
}
ZodVoid.create = (Xn) => new ZodVoid({ typeName: ZodFirstPartyTypeKind.ZodVoid, ...processCreateParams(Xn) });
class ZodArray extends ZodType {
  _parse(zn) {
    const { ctx: Un, status: Kn } = this._processInputParams(zn), qn = this._def;
    if (Un.parsedType !== ZodParsedType.array) return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.array, received: Un.parsedType }), INVALID;
    if (qn.exactLength !== null) {
      const pa = Un.data.length > qn.exactLength.value, ma = Un.data.length < qn.exactLength.value;
      (pa || ma) && (addIssueToContext(Un, { code: pa ? ZodIssueCode.too_big : ZodIssueCode.too_small, minimum: ma ? qn.exactLength.value : void 0, maximum: pa ? qn.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: qn.exactLength.message }), Kn.dirty());
    }
    if (qn.minLength !== null && Un.data.length < qn.minLength.value && (addIssueToContext(Un, { code: ZodIssueCode.too_small, minimum: qn.minLength.value, type: "array", inclusive: !0, exact: !1, message: qn.minLength.message }), Kn.dirty()), qn.maxLength !== null && Un.data.length > qn.maxLength.value && (addIssueToContext(Un, { code: ZodIssueCode.too_big, maximum: qn.maxLength.value, type: "array", inclusive: !0, exact: !1, message: qn.maxLength.message }), Kn.dirty()), Un.common.async) return Promise.all([...Un.data].map((pa, ma) => qn.type._parseAsync(new ParseInputLazyPath(Un, pa, Un.path, ma)))).then((pa) => ParseStatus.mergeArray(Kn, pa));
    const Jo = [...Un.data].map((pa, ma) => qn.type._parseSync(new ParseInputLazyPath(Un, pa, Un.path, ma)));
    return ParseStatus.mergeArray(Kn, Jo);
  }
  get element() {
    return this._def.type;
  }
  min(zn, Un) {
    return new ZodArray({ ...this._def, minLength: { value: zn, message: errorUtil.toString(Un) } });
  }
  max(zn, Un) {
    return new ZodArray({ ...this._def, maxLength: { value: zn, message: errorUtil.toString(Un) } });
  }
  length(zn, Un) {
    return new ZodArray({ ...this._def, exactLength: { value: zn, message: errorUtil.toString(Un) } });
  }
  nonempty(zn) {
    return this.min(1, zn);
  }
}
function deepPartialify(Xn) {
  if (Xn instanceof ZodObject) {
    const zn = {};
    for (const Un in Xn.shape) {
      const Kn = Xn.shape[Un];
      zn[Un] = ZodOptional.create(deepPartialify(Kn));
    }
    return new ZodObject({ ...Xn._def, shape: () => zn });
  }
  return Xn instanceof ZodArray ? new ZodArray({ ...Xn._def, type: deepPartialify(Xn.element) }) : Xn instanceof ZodOptional ? ZodOptional.create(deepPartialify(Xn.unwrap())) : Xn instanceof ZodNullable ? ZodNullable.create(deepPartialify(Xn.unwrap())) : Xn instanceof ZodTuple ? ZodTuple.create(Xn.items.map((zn) => deepPartialify(zn))) : Xn;
}
ZodArray.create = (Xn, zn) => new ZodArray({ type: Xn, minLength: null, maxLength: null, exactLength: null, typeName: ZodFirstPartyTypeKind.ZodArray, ...processCreateParams(zn) });
class ZodObject extends ZodType {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const zn = this._def.shape(), Un = util$1.objectKeys(zn);
    return this._cached = { shape: zn, keys: Un };
  }
  _parse(zn) {
    if (this._getType(zn) !== ZodParsedType.object) {
      const va = this._getOrReturnCtx(zn);
      return addIssueToContext(va, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.object, received: va.parsedType }), INVALID;
    }
    const { status: Un, ctx: Kn } = this._processInputParams(zn), { shape: qn, keys: Jo } = this._getCached(), pa = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) for (const va in Kn.data) Jo.includes(va) || pa.push(va);
    const ma = [];
    for (const va of Jo) {
      const ba = qn[va], _a = Kn.data[va];
      ma.push({ key: { status: "valid", value: va }, value: ba._parse(new ParseInputLazyPath(Kn, _a, Kn.path, va)), alwaysSet: va in Kn.data });
    }
    if (this._def.catchall instanceof ZodNever) {
      const va = this._def.unknownKeys;
      if (va === "passthrough") for (const ba of pa) ma.push({ key: { status: "valid", value: ba }, value: { status: "valid", value: Kn.data[ba] } });
      else if (va === "strict") pa.length > 0 && (addIssueToContext(Kn, { code: ZodIssueCode.unrecognized_keys, keys: pa }), Un.dirty());
      else if (va !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const va = this._def.catchall;
      for (const ba of pa) {
        const _a = Kn.data[ba];
        ma.push({ key: { status: "valid", value: ba }, value: va._parse(new ParseInputLazyPath(Kn, _a, Kn.path, ba)), alwaysSet: ba in Kn.data });
      }
    }
    return Kn.common.async ? Promise.resolve().then(async () => {
      const va = [];
      for (const ba of ma) {
        const _a = await ba.key, ya = await ba.value;
        va.push({ key: _a, value: ya, alwaysSet: ba.alwaysSet });
      }
      return va;
    }).then((va) => ParseStatus.mergeObjectSync(Un, va)) : ParseStatus.mergeObjectSync(Un, ma);
  }
  get shape() {
    return this._def.shape();
  }
  strict(zn) {
    return errorUtil.errToObj, new ZodObject({ ...this._def, unknownKeys: "strict", ...zn !== void 0 ? { errorMap: (Un, Kn) => {
      var qn, Jo, pa, ma;
      const va = (pa = (Jo = (qn = this._def).errorMap) === null || Jo === void 0 ? void 0 : Jo.call(qn, Un, Kn).message) !== null && pa !== void 0 ? pa : Kn.defaultError;
      return Un.code === "unrecognized_keys" ? { message: (ma = errorUtil.errToObj(zn).message) !== null && ma !== void 0 ? ma : va } : { message: va };
    } } : {} });
  }
  strip() {
    return new ZodObject({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new ZodObject({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(zn) {
    return new ZodObject({ ...this._def, shape: () => ({ ...this._def.shape(), ...zn }) });
  }
  merge(zn) {
    return new ZodObject({ unknownKeys: zn._def.unknownKeys, catchall: zn._def.catchall, shape: () => ({ ...this._def.shape(), ...zn._def.shape() }), typeName: ZodFirstPartyTypeKind.ZodObject });
  }
  setKey(zn, Un) {
    return this.augment({ [zn]: Un });
  }
  catchall(zn) {
    return new ZodObject({ ...this._def, catchall: zn });
  }
  pick(zn) {
    const Un = {};
    return util$1.objectKeys(zn).forEach((Kn) => {
      zn[Kn] && this.shape[Kn] && (Un[Kn] = this.shape[Kn]);
    }), new ZodObject({ ...this._def, shape: () => Un });
  }
  omit(zn) {
    const Un = {};
    return util$1.objectKeys(this.shape).forEach((Kn) => {
      zn[Kn] || (Un[Kn] = this.shape[Kn]);
    }), new ZodObject({ ...this._def, shape: () => Un });
  }
  deepPartial() {
    return deepPartialify(this);
  }
  partial(zn) {
    const Un = {};
    return util$1.objectKeys(this.shape).forEach((Kn) => {
      const qn = this.shape[Kn];
      zn && !zn[Kn] ? Un[Kn] = qn : Un[Kn] = qn.optional();
    }), new ZodObject({ ...this._def, shape: () => Un });
  }
  required(zn) {
    const Un = {};
    return util$1.objectKeys(this.shape).forEach((Kn) => {
      if (zn && !zn[Kn]) Un[Kn] = this.shape[Kn];
      else {
        let qn = this.shape[Kn];
        for (; qn instanceof ZodOptional; ) qn = qn._def.innerType;
        Un[Kn] = qn;
      }
    }), new ZodObject({ ...this._def, shape: () => Un });
  }
  keyof() {
    return createZodEnum(util$1.objectKeys(this.shape));
  }
}
ZodObject.create = (Xn, zn) => new ZodObject({ shape: () => Xn, unknownKeys: "strip", catchall: ZodNever.create(), typeName: ZodFirstPartyTypeKind.ZodObject, ...processCreateParams(zn) }), ZodObject.strictCreate = (Xn, zn) => new ZodObject({ shape: () => Xn, unknownKeys: "strict", catchall: ZodNever.create(), typeName: ZodFirstPartyTypeKind.ZodObject, ...processCreateParams(zn) }), ZodObject.lazycreate = (Xn, zn) => new ZodObject({ shape: Xn, unknownKeys: "strip", catchall: ZodNever.create(), typeName: ZodFirstPartyTypeKind.ZodObject, ...processCreateParams(zn) });
class ZodUnion extends ZodType {
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn), Kn = this._def.options;
    if (Un.common.async) return Promise.all(Kn.map(async (qn) => {
      const Jo = { ...Un, common: { ...Un.common, issues: [] }, parent: null };
      return { result: await qn._parseAsync({ data: Un.data, path: Un.path, parent: Jo }), ctx: Jo };
    })).then(function(qn) {
      for (const pa of qn) if (pa.result.status === "valid") return pa.result;
      for (const pa of qn) if (pa.result.status === "dirty") return Un.common.issues.push(...pa.ctx.common.issues), pa.result;
      const Jo = qn.map((pa) => new ZodError(pa.ctx.common.issues));
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_union, unionErrors: Jo }), INVALID;
    });
    {
      let qn;
      const Jo = [];
      for (const ma of Kn) {
        const va = { ...Un, common: { ...Un.common, issues: [] }, parent: null }, ba = ma._parseSync({ data: Un.data, path: Un.path, parent: va });
        if (ba.status === "valid") return ba;
        ba.status !== "dirty" || qn || (qn = { result: ba, ctx: va }), va.common.issues.length && Jo.push(va.common.issues);
      }
      if (qn) return Un.common.issues.push(...qn.ctx.common.issues), qn.result;
      const pa = Jo.map((ma) => new ZodError(ma));
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_union, unionErrors: pa }), INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (Xn, zn) => new ZodUnion({ options: Xn, typeName: ZodFirstPartyTypeKind.ZodUnion, ...processCreateParams(zn) });
const getDiscriminator = (Xn) => Xn instanceof ZodLazy ? getDiscriminator(Xn.schema) : Xn instanceof ZodEffects ? getDiscriminator(Xn.innerType()) : Xn instanceof ZodLiteral ? [Xn.value] : Xn instanceof ZodEnum ? Xn.options : Xn instanceof ZodNativeEnum ? util$1.objectValues(Xn.enum) : Xn instanceof ZodDefault ? getDiscriminator(Xn._def.innerType) : Xn instanceof ZodUndefined ? [void 0] : Xn instanceof ZodNull ? [null] : Xn instanceof ZodOptional ? [void 0, ...getDiscriminator(Xn.unwrap())] : Xn instanceof ZodNullable ? [null, ...getDiscriminator(Xn.unwrap())] : Xn instanceof ZodBranded || Xn instanceof ZodReadonly ? getDiscriminator(Xn.unwrap()) : Xn instanceof ZodCatch ? getDiscriminator(Xn._def.innerType) : [];
class ZodDiscriminatedUnion extends ZodType {
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn);
    if (Un.parsedType !== ZodParsedType.object) return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.object, received: Un.parsedType }), INVALID;
    const Kn = this.discriminator, qn = Un.data[Kn], Jo = this.optionsMap.get(qn);
    return Jo ? Un.common.async ? Jo._parseAsync({ data: Un.data, path: Un.path, parent: Un }) : Jo._parseSync({ data: Un.data, path: Un.path, parent: Un }) : (addIssueToContext(Un, { code: ZodIssueCode.invalid_union_discriminator, options: Array.from(this.optionsMap.keys()), path: [Kn] }), INVALID);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  static create(zn, Un, Kn) {
    const qn = /* @__PURE__ */ new Map();
    for (const Jo of Un) {
      const pa = getDiscriminator(Jo.shape[zn]);
      if (!pa.length) throw new Error(`A discriminator value for key \`${zn}\` could not be extracted from all schema options`);
      for (const ma of pa) {
        if (qn.has(ma)) throw new Error(`Discriminator property ${String(zn)} has duplicate value ${String(ma)}`);
        qn.set(ma, Jo);
      }
    }
    return new ZodDiscriminatedUnion({ typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion, discriminator: zn, options: Un, optionsMap: qn, ...processCreateParams(Kn) });
  }
}
function mergeValues(Xn, zn) {
  const Un = getParsedType(Xn), Kn = getParsedType(zn);
  if (Xn === zn) return { valid: !0, data: Xn };
  if (Un === ZodParsedType.object && Kn === ZodParsedType.object) {
    const qn = util$1.objectKeys(zn), Jo = util$1.objectKeys(Xn).filter((ma) => qn.indexOf(ma) !== -1), pa = { ...Xn, ...zn };
    for (const ma of Jo) {
      const va = mergeValues(Xn[ma], zn[ma]);
      if (!va.valid) return { valid: !1 };
      pa[ma] = va.data;
    }
    return { valid: !0, data: pa };
  }
  if (Un === ZodParsedType.array && Kn === ZodParsedType.array) {
    if (Xn.length !== zn.length) return { valid: !1 };
    const qn = [];
    for (let Jo = 0; Jo < Xn.length; Jo++) {
      const pa = mergeValues(Xn[Jo], zn[Jo]);
      if (!pa.valid) return { valid: !1 };
      qn.push(pa.data);
    }
    return { valid: !0, data: qn };
  }
  return Un === ZodParsedType.date && Kn === ZodParsedType.date && +Xn == +zn ? { valid: !0, data: Xn } : { valid: !1 };
}
class ZodIntersection extends ZodType {
  _parse(zn) {
    const { status: Un, ctx: Kn } = this._processInputParams(zn), qn = (Jo, pa) => {
      if (isAborted(Jo) || isAborted(pa)) return INVALID;
      const ma = mergeValues(Jo.value, pa.value);
      return ma.valid ? ((isDirty(Jo) || isDirty(pa)) && Un.dirty(), { status: Un.value, value: ma.data }) : (addIssueToContext(Kn, { code: ZodIssueCode.invalid_intersection_types }), INVALID);
    };
    return Kn.common.async ? Promise.all([this._def.left._parseAsync({ data: Kn.data, path: Kn.path, parent: Kn }), this._def.right._parseAsync({ data: Kn.data, path: Kn.path, parent: Kn })]).then(([Jo, pa]) => qn(Jo, pa)) : qn(this._def.left._parseSync({ data: Kn.data, path: Kn.path, parent: Kn }), this._def.right._parseSync({ data: Kn.data, path: Kn.path, parent: Kn }));
  }
}
ZodIntersection.create = (Xn, zn, Un) => new ZodIntersection({ left: Xn, right: zn, typeName: ZodFirstPartyTypeKind.ZodIntersection, ...processCreateParams(Un) });
class ZodTuple extends ZodType {
  _parse(zn) {
    const { status: Un, ctx: Kn } = this._processInputParams(zn);
    if (Kn.parsedType !== ZodParsedType.array) return addIssueToContext(Kn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.array, received: Kn.parsedType }), INVALID;
    if (Kn.data.length < this._def.items.length) return addIssueToContext(Kn, { code: ZodIssueCode.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), INVALID;
    !this._def.rest && Kn.data.length > this._def.items.length && (addIssueToContext(Kn, { code: ZodIssueCode.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), Un.dirty());
    const qn = [...Kn.data].map((Jo, pa) => {
      const ma = this._def.items[pa] || this._def.rest;
      return ma ? ma._parse(new ParseInputLazyPath(Kn, Jo, Kn.path, pa)) : null;
    }).filter((Jo) => !!Jo);
    return Kn.common.async ? Promise.all(qn).then((Jo) => ParseStatus.mergeArray(Un, Jo)) : ParseStatus.mergeArray(Un, qn);
  }
  get items() {
    return this._def.items;
  }
  rest(zn) {
    return new ZodTuple({ ...this._def, rest: zn });
  }
}
ZodTuple.create = (Xn, zn) => {
  if (!Array.isArray(Xn)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ZodTuple({ items: Xn, typeName: ZodFirstPartyTypeKind.ZodTuple, rest: null, ...processCreateParams(zn) });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(zn) {
    const { status: Un, ctx: Kn } = this._processInputParams(zn);
    if (Kn.parsedType !== ZodParsedType.object) return addIssueToContext(Kn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.object, received: Kn.parsedType }), INVALID;
    const qn = [], Jo = this._def.keyType, pa = this._def.valueType;
    for (const ma in Kn.data) qn.push({ key: Jo._parse(new ParseInputLazyPath(Kn, ma, Kn.path, ma)), value: pa._parse(new ParseInputLazyPath(Kn, Kn.data[ma], Kn.path, ma)), alwaysSet: ma in Kn.data });
    return Kn.common.async ? ParseStatus.mergeObjectAsync(Un, qn) : ParseStatus.mergeObjectSync(Un, qn);
  }
  get element() {
    return this._def.valueType;
  }
  static create(zn, Un, Kn) {
    return new ZodRecord(Un instanceof ZodType ? { keyType: zn, valueType: Un, typeName: ZodFirstPartyTypeKind.ZodRecord, ...processCreateParams(Kn) } : { keyType: ZodString.create(), valueType: zn, typeName: ZodFirstPartyTypeKind.ZodRecord, ...processCreateParams(Un) });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(zn) {
    const { status: Un, ctx: Kn } = this._processInputParams(zn);
    if (Kn.parsedType !== ZodParsedType.map) return addIssueToContext(Kn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.map, received: Kn.parsedType }), INVALID;
    const qn = this._def.keyType, Jo = this._def.valueType, pa = [...Kn.data.entries()].map(([ma, va], ba) => ({ key: qn._parse(new ParseInputLazyPath(Kn, ma, Kn.path, [ba, "key"])), value: Jo._parse(new ParseInputLazyPath(Kn, va, Kn.path, [ba, "value"])) }));
    if (Kn.common.async) {
      const ma = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const va of pa) {
          const ba = await va.key, _a = await va.value;
          if (ba.status === "aborted" || _a.status === "aborted") return INVALID;
          ba.status !== "dirty" && _a.status !== "dirty" || Un.dirty(), ma.set(ba.value, _a.value);
        }
        return { status: Un.value, value: ma };
      });
    }
    {
      const ma = /* @__PURE__ */ new Map();
      for (const va of pa) {
        const ba = va.key, _a = va.value;
        if (ba.status === "aborted" || _a.status === "aborted") return INVALID;
        ba.status !== "dirty" && _a.status !== "dirty" || Un.dirty(), ma.set(ba.value, _a.value);
      }
      return { status: Un.value, value: ma };
    }
  }
}
ZodMap.create = (Xn, zn, Un) => new ZodMap({ valueType: zn, keyType: Xn, typeName: ZodFirstPartyTypeKind.ZodMap, ...processCreateParams(Un) });
class ZodSet extends ZodType {
  _parse(zn) {
    const { status: Un, ctx: Kn } = this._processInputParams(zn);
    if (Kn.parsedType !== ZodParsedType.set) return addIssueToContext(Kn, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.set, received: Kn.parsedType }), INVALID;
    const qn = this._def;
    qn.minSize !== null && Kn.data.size < qn.minSize.value && (addIssueToContext(Kn, { code: ZodIssueCode.too_small, minimum: qn.minSize.value, type: "set", inclusive: !0, exact: !1, message: qn.minSize.message }), Un.dirty()), qn.maxSize !== null && Kn.data.size > qn.maxSize.value && (addIssueToContext(Kn, { code: ZodIssueCode.too_big, maximum: qn.maxSize.value, type: "set", inclusive: !0, exact: !1, message: qn.maxSize.message }), Un.dirty());
    const Jo = this._def.valueType;
    function pa(va) {
      const ba = /* @__PURE__ */ new Set();
      for (const _a of va) {
        if (_a.status === "aborted") return INVALID;
        _a.status === "dirty" && Un.dirty(), ba.add(_a.value);
      }
      return { status: Un.value, value: ba };
    }
    const ma = [...Kn.data.values()].map((va, ba) => Jo._parse(new ParseInputLazyPath(Kn, va, Kn.path, ba)));
    return Kn.common.async ? Promise.all(ma).then((va) => pa(va)) : pa(ma);
  }
  min(zn, Un) {
    return new ZodSet({ ...this._def, minSize: { value: zn, message: errorUtil.toString(Un) } });
  }
  max(zn, Un) {
    return new ZodSet({ ...this._def, maxSize: { value: zn, message: errorUtil.toString(Un) } });
  }
  size(zn, Un) {
    return this.min(zn, Un).max(zn, Un);
  }
  nonempty(zn) {
    return this.min(1, zn);
  }
}
ZodSet.create = (Xn, zn) => new ZodSet({ valueType: Xn, minSize: null, maxSize: null, typeName: ZodFirstPartyTypeKind.ZodSet, ...processCreateParams(zn) });
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn);
    if (Un.parsedType !== ZodParsedType.function) return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.function, received: Un.parsedType }), INVALID;
    function Kn(ma, va) {
      return makeIssue({ data: ma, path: Un.path, errorMaps: [Un.common.contextualErrorMap, Un.schemaErrorMap, getErrorMap(), errorMap].filter((ba) => !!ba), issueData: { code: ZodIssueCode.invalid_arguments, argumentsError: va } });
    }
    function qn(ma, va) {
      return makeIssue({ data: ma, path: Un.path, errorMaps: [Un.common.contextualErrorMap, Un.schemaErrorMap, getErrorMap(), errorMap].filter((ba) => !!ba), issueData: { code: ZodIssueCode.invalid_return_type, returnTypeError: va } });
    }
    const Jo = { errorMap: Un.common.contextualErrorMap }, pa = Un.data;
    if (this._def.returns instanceof ZodPromise) {
      const ma = this;
      return OK(async function(...va) {
        const ba = new ZodError([]), _a = await ma._def.args.parseAsync(va, Jo).catch((wa) => {
          throw ba.addIssue(Kn(va, wa)), ba;
        }), ya = await Reflect.apply(pa, this, _a);
        return await ma._def.returns._def.type.parseAsync(ya, Jo).catch((wa) => {
          throw ba.addIssue(qn(ya, wa)), ba;
        });
      });
    }
    {
      const ma = this;
      return OK(function(...va) {
        const ba = ma._def.args.safeParse(va, Jo);
        if (!ba.success) throw new ZodError([Kn(va, ba.error)]);
        const _a = Reflect.apply(pa, this, ba.data), ya = ma._def.returns.safeParse(_a, Jo);
        if (!ya.success) throw new ZodError([qn(_a, ya.error)]);
        return ya.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...zn) {
    return new ZodFunction({ ...this._def, args: ZodTuple.create(zn).rest(ZodUnknown.create()) });
  }
  returns(zn) {
    return new ZodFunction({ ...this._def, returns: zn });
  }
  implement(zn) {
    return this.parse(zn);
  }
  strictImplement(zn) {
    return this.parse(zn);
  }
  static create(zn, Un, Kn) {
    return new ZodFunction({ args: zn || ZodTuple.create([]).rest(ZodUnknown.create()), returns: Un || ZodUnknown.create(), typeName: ZodFirstPartyTypeKind.ZodFunction, ...processCreateParams(Kn) });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn);
    return this._def.getter()._parse({ data: Un.data, path: Un.path, parent: Un });
  }
}
ZodLazy.create = (Xn, zn) => new ZodLazy({ getter: Xn, typeName: ZodFirstPartyTypeKind.ZodLazy, ...processCreateParams(zn) });
class ZodLiteral extends ZodType {
  _parse(zn) {
    if (zn.data !== this._def.value) {
      const Un = this._getOrReturnCtx(zn);
      return addIssueToContext(Un, { received: Un.data, code: ZodIssueCode.invalid_literal, expected: this._def.value }), INVALID;
    }
    return { status: "valid", value: zn.data };
  }
  get value() {
    return this._def.value;
  }
}
function createZodEnum(Xn, zn) {
  return new ZodEnum({ values: Xn, typeName: ZodFirstPartyTypeKind.ZodEnum, ...processCreateParams(zn) });
}
ZodLiteral.create = (Xn, zn) => new ZodLiteral({ value: Xn, typeName: ZodFirstPartyTypeKind.ZodLiteral, ...processCreateParams(zn) });
class ZodEnum extends ZodType {
  constructor() {
    super(...arguments), _ZodEnum_cache.set(this, void 0);
  }
  _parse(zn) {
    if (typeof zn.data != "string") {
      const Un = this._getOrReturnCtx(zn), Kn = this._def.values;
      return addIssueToContext(Un, { expected: util$1.joinValues(Kn), received: Un.parsedType, code: ZodIssueCode.invalid_type }), INVALID;
    }
    if (__classPrivateFieldGet(this, _ZodEnum_cache) || __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values)), !__classPrivateFieldGet(this, _ZodEnum_cache).has(zn.data)) {
      const Un = this._getOrReturnCtx(zn), Kn = this._def.values;
      return addIssueToContext(Un, { received: Un.data, code: ZodIssueCode.invalid_enum_value, options: Kn }), INVALID;
    }
    return OK(zn.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const zn = {};
    for (const Un of this._def.values) zn[Un] = Un;
    return zn;
  }
  get Values() {
    const zn = {};
    for (const Un of this._def.values) zn[Un] = Un;
    return zn;
  }
  get Enum() {
    const zn = {};
    for (const Un of this._def.values) zn[Un] = Un;
    return zn;
  }
  extract(zn, Un = this._def) {
    return ZodEnum.create(zn, { ...this._def, ...Un });
  }
  exclude(zn, Un = this._def) {
    return ZodEnum.create(this.options.filter((Kn) => !zn.includes(Kn)), { ...this._def, ...Un });
  }
}
_ZodEnum_cache = /* @__PURE__ */ new WeakMap(), ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  constructor() {
    super(...arguments), _ZodNativeEnum_cache.set(this, void 0);
  }
  _parse(zn) {
    const Un = util$1.getValidEnumValues(this._def.values), Kn = this._getOrReturnCtx(zn);
    if (Kn.parsedType !== ZodParsedType.string && Kn.parsedType !== ZodParsedType.number) {
      const qn = util$1.objectValues(Un);
      return addIssueToContext(Kn, { expected: util$1.joinValues(qn), received: Kn.parsedType, code: ZodIssueCode.invalid_type }), INVALID;
    }
    if (__classPrivateFieldGet(this, _ZodNativeEnum_cache) || __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util$1.getValidEnumValues(this._def.values))), !__classPrivateFieldGet(this, _ZodNativeEnum_cache).has(zn.data)) {
      const qn = util$1.objectValues(Un);
      return addIssueToContext(Kn, { received: Kn.data, code: ZodIssueCode.invalid_enum_value, options: qn }), INVALID;
    }
    return OK(zn.data);
  }
  get enum() {
    return this._def.values;
  }
}
_ZodNativeEnum_cache = /* @__PURE__ */ new WeakMap(), ZodNativeEnum.create = (Xn, zn) => new ZodNativeEnum({ values: Xn, typeName: ZodFirstPartyTypeKind.ZodNativeEnum, ...processCreateParams(zn) });
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn);
    if (Un.parsedType !== ZodParsedType.promise && Un.common.async === !1) return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.promise, received: Un.parsedType }), INVALID;
    const Kn = Un.parsedType === ZodParsedType.promise ? Un.data : Promise.resolve(Un.data);
    return OK(Kn.then((qn) => this._def.type.parseAsync(qn, { path: Un.path, errorMap: Un.common.contextualErrorMap })));
  }
}
ZodPromise.create = (Xn, zn) => new ZodPromise({ type: Xn, typeName: ZodFirstPartyTypeKind.ZodPromise, ...processCreateParams(zn) });
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(zn) {
    const { status: Un, ctx: Kn } = this._processInputParams(zn), qn = this._def.effect || null, Jo = { addIssue: (pa) => {
      addIssueToContext(Kn, pa), pa.fatal ? Un.abort() : Un.dirty();
    }, get path() {
      return Kn.path;
    } };
    if (Jo.addIssue = Jo.addIssue.bind(Jo), qn.type === "preprocess") {
      const pa = qn.transform(Kn.data, Jo);
      if (Kn.common.async) return Promise.resolve(pa).then(async (ma) => {
        if (Un.value === "aborted") return INVALID;
        const va = await this._def.schema._parseAsync({ data: ma, path: Kn.path, parent: Kn });
        return va.status === "aborted" ? INVALID : va.status === "dirty" || Un.value === "dirty" ? DIRTY(va.value) : va;
      });
      {
        if (Un.value === "aborted") return INVALID;
        const ma = this._def.schema._parseSync({ data: pa, path: Kn.path, parent: Kn });
        return ma.status === "aborted" ? INVALID : ma.status === "dirty" || Un.value === "dirty" ? DIRTY(ma.value) : ma;
      }
    }
    if (qn.type === "refinement") {
      const pa = (ma) => {
        const va = qn.refinement(ma, Jo);
        if (Kn.common.async) return Promise.resolve(va);
        if (va instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return ma;
      };
      if (Kn.common.async === !1) {
        const ma = this._def.schema._parseSync({ data: Kn.data, path: Kn.path, parent: Kn });
        return ma.status === "aborted" ? INVALID : (ma.status === "dirty" && Un.dirty(), pa(ma.value), { status: Un.value, value: ma.value });
      }
      return this._def.schema._parseAsync({ data: Kn.data, path: Kn.path, parent: Kn }).then((ma) => ma.status === "aborted" ? INVALID : (ma.status === "dirty" && Un.dirty(), pa(ma.value).then(() => ({ status: Un.value, value: ma.value }))));
    }
    if (qn.type === "transform") {
      if (Kn.common.async === !1) {
        const pa = this._def.schema._parseSync({ data: Kn.data, path: Kn.path, parent: Kn });
        if (!isValid(pa)) return pa;
        const ma = qn.transform(pa.value, Jo);
        if (ma instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: Un.value, value: ma };
      }
      return this._def.schema._parseAsync({ data: Kn.data, path: Kn.path, parent: Kn }).then((pa) => isValid(pa) ? Promise.resolve(qn.transform(pa.value, Jo)).then((ma) => ({ status: Un.value, value: ma })) : pa);
    }
    util$1.assertNever(qn);
  }
}
ZodEffects.create = (Xn, zn, Un) => new ZodEffects({ schema: Xn, typeName: ZodFirstPartyTypeKind.ZodEffects, effect: zn, ...processCreateParams(Un) }), ZodEffects.createWithPreprocess = (Xn, zn, Un) => new ZodEffects({ schema: zn, effect: { type: "preprocess", transform: Xn }, typeName: ZodFirstPartyTypeKind.ZodEffects, ...processCreateParams(Un) });
class ZodOptional extends ZodType {
  _parse(zn) {
    return this._getType(zn) === ZodParsedType.undefined ? OK(void 0) : this._def.innerType._parse(zn);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (Xn, zn) => new ZodOptional({ innerType: Xn, typeName: ZodFirstPartyTypeKind.ZodOptional, ...processCreateParams(zn) });
class ZodNullable extends ZodType {
  _parse(zn) {
    return this._getType(zn) === ZodParsedType.null ? OK(null) : this._def.innerType._parse(zn);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (Xn, zn) => new ZodNullable({ innerType: Xn, typeName: ZodFirstPartyTypeKind.ZodNullable, ...processCreateParams(zn) });
class ZodDefault extends ZodType {
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn);
    let Kn = Un.data;
    return Un.parsedType === ZodParsedType.undefined && (Kn = this._def.defaultValue()), this._def.innerType._parse({ data: Kn, path: Un.path, parent: Un });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (Xn, zn) => new ZodDefault({ innerType: Xn, typeName: ZodFirstPartyTypeKind.ZodDefault, defaultValue: typeof zn.default == "function" ? zn.default : () => zn.default, ...processCreateParams(zn) });
class ZodCatch extends ZodType {
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn), Kn = { ...Un, common: { ...Un.common, issues: [] } }, qn = this._def.innerType._parse({ data: Kn.data, path: Kn.path, parent: { ...Kn } });
    return isAsync(qn) ? qn.then((Jo) => ({ status: "valid", value: Jo.status === "valid" ? Jo.value : this._def.catchValue({ get error() {
      return new ZodError(Kn.common.issues);
    }, input: Kn.data }) })) : { status: "valid", value: qn.status === "valid" ? qn.value : this._def.catchValue({ get error() {
      return new ZodError(Kn.common.issues);
    }, input: Kn.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (Xn, zn) => new ZodCatch({ innerType: Xn, typeName: ZodFirstPartyTypeKind.ZodCatch, catchValue: typeof zn.catch == "function" ? zn.catch : () => zn.catch, ...processCreateParams(zn) });
class ZodNaN extends ZodType {
  _parse(zn) {
    if (this._getType(zn) !== ZodParsedType.nan) {
      const Un = this._getOrReturnCtx(zn);
      return addIssueToContext(Un, { code: ZodIssueCode.invalid_type, expected: ZodParsedType.nan, received: Un.parsedType }), INVALID;
    }
    return { status: "valid", value: zn.data };
  }
}
ZodNaN.create = (Xn) => new ZodNaN({ typeName: ZodFirstPartyTypeKind.ZodNaN, ...processCreateParams(Xn) });
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(zn) {
    const { ctx: Un } = this._processInputParams(zn), Kn = Un.data;
    return this._def.type._parse({ data: Kn, path: Un.path, parent: Un });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(zn) {
    const { status: Un, ctx: Kn } = this._processInputParams(zn);
    if (Kn.common.async)
      return (async () => {
        const qn = await this._def.in._parseAsync({ data: Kn.data, path: Kn.path, parent: Kn });
        return qn.status === "aborted" ? INVALID : qn.status === "dirty" ? (Un.dirty(), DIRTY(qn.value)) : this._def.out._parseAsync({ data: qn.value, path: Kn.path, parent: Kn });
      })();
    {
      const qn = this._def.in._parseSync({ data: Kn.data, path: Kn.path, parent: Kn });
      return qn.status === "aborted" ? INVALID : qn.status === "dirty" ? (Un.dirty(), { status: "dirty", value: qn.value }) : this._def.out._parseSync({ data: qn.value, path: Kn.path, parent: Kn });
    }
  }
  static create(zn, Un) {
    return new ZodPipeline({ in: zn, out: Un, typeName: ZodFirstPartyTypeKind.ZodPipeline });
  }
}
class ZodReadonly extends ZodType {
  _parse(zn) {
    const Un = this._def.innerType._parse(zn), Kn = (qn) => (isValid(qn) && (qn.value = Object.freeze(qn.value)), qn);
    return isAsync(Un) ? Un.then((qn) => Kn(qn)) : Kn(Un);
  }
  unwrap() {
    return this._def.innerType;
  }
}
function custom(Xn, zn = {}, Un) {
  return Xn ? ZodAny.create().superRefine((Kn, qn) => {
    var Jo, pa;
    if (!Xn(Kn)) {
      const ma = typeof zn == "function" ? zn(Kn) : typeof zn == "string" ? { message: zn } : zn, va = (pa = (Jo = ma.fatal) !== null && Jo !== void 0 ? Jo : Un) === null || pa === void 0 || pa, ba = typeof ma == "string" ? { message: ma } : ma;
      qn.addIssue({ code: "custom", ...ba, fatal: va });
    }
  }) : ZodAny.create();
}
ZodReadonly.create = (Xn, zn) => new ZodReadonly({ innerType: Xn, typeName: ZodFirstPartyTypeKind.ZodReadonly, ...processCreateParams(zn) });
const late = { object: ZodObject.lazycreate };
var ZodFirstPartyTypeKind;
(function(Xn) {
  Xn.ZodString = "ZodString", Xn.ZodNumber = "ZodNumber", Xn.ZodNaN = "ZodNaN", Xn.ZodBigInt = "ZodBigInt", Xn.ZodBoolean = "ZodBoolean", Xn.ZodDate = "ZodDate", Xn.ZodSymbol = "ZodSymbol", Xn.ZodUndefined = "ZodUndefined", Xn.ZodNull = "ZodNull", Xn.ZodAny = "ZodAny", Xn.ZodUnknown = "ZodUnknown", Xn.ZodNever = "ZodNever", Xn.ZodVoid = "ZodVoid", Xn.ZodArray = "ZodArray", Xn.ZodObject = "ZodObject", Xn.ZodUnion = "ZodUnion", Xn.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", Xn.ZodIntersection = "ZodIntersection", Xn.ZodTuple = "ZodTuple", Xn.ZodRecord = "ZodRecord", Xn.ZodMap = "ZodMap", Xn.ZodSet = "ZodSet", Xn.ZodFunction = "ZodFunction", Xn.ZodLazy = "ZodLazy", Xn.ZodLiteral = "ZodLiteral", Xn.ZodEnum = "ZodEnum", Xn.ZodEffects = "ZodEffects", Xn.ZodNativeEnum = "ZodNativeEnum", Xn.ZodOptional = "ZodOptional", Xn.ZodNullable = "ZodNullable", Xn.ZodDefault = "ZodDefault", Xn.ZodCatch = "ZodCatch", Xn.ZodPromise = "ZodPromise", Xn.ZodBranded = "ZodBranded", Xn.ZodPipeline = "ZodPipeline", Xn.ZodReadonly = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (Xn, zn = { message: `Input not instance of ${Xn.name}` }) => custom((Un) => Un instanceof Xn, zn), stringType = ZodString.create, numberType = ZodNumber.create, nanType = ZodNaN.create, bigIntType = ZodBigInt.create, booleanType = ZodBoolean.create, dateType = ZodDate.create, symbolType = ZodSymbol.create, undefinedType = ZodUndefined.create, nullType = ZodNull.create, anyType = ZodAny.create, unknownType = ZodUnknown.create, neverType = ZodNever.create, voidType = ZodVoid.create, arrayType = ZodArray.create, objectType = ZodObject.create, strictObjectType = ZodObject.strictCreate, unionType = ZodUnion.create, discriminatedUnionType = ZodDiscriminatedUnion.create, intersectionType = ZodIntersection.create, tupleType = ZodTuple.create, recordType = ZodRecord.create, mapType = ZodMap.create, setType = ZodSet.create, functionType = ZodFunction.create, lazyType = ZodLazy.create, literalType = ZodLiteral.create, enumType = ZodEnum.create, nativeEnumType = ZodNativeEnum.create, promiseType = ZodPromise.create, effectsType = ZodEffects.create, optionalType = ZodOptional.create, nullableType = ZodNullable.create, preprocessType = ZodEffects.createWithPreprocess, pipelineType = ZodPipeline.create, ostring = () => stringType().optional(), onumber = () => numberType().optional(), oboolean = () => booleanType().optional(), coerce = { string: (Xn) => ZodString.create({ ...Xn, coerce: !0 }), number: (Xn) => ZodNumber.create({ ...Xn, coerce: !0 }), boolean: (Xn) => ZodBoolean.create({ ...Xn, coerce: !0 }), bigint: (Xn) => ZodBigInt.create({ ...Xn, coerce: !0 }), date: (Xn) => ZodDate.create({ ...Xn, coerce: !0 }) }, NEVER = INVALID;
var z = Object.freeze({ __proto__: null, defaultErrorMap: errorMap, setErrorMap, getErrorMap, makeIssue, EMPTY_PATH, addIssueToContext, ParseStatus, INVALID, DIRTY, OK, isAborted, isDirty, isValid, isAsync, get util() {
  return util$1;
}, get objectUtil() {
  return objectUtil;
}, ZodParsedType, getParsedType, ZodType, datetimeRegex, ZodString, ZodNumber, ZodBigInt, ZodBoolean, ZodDate, ZodSymbol, ZodUndefined, ZodNull, ZodAny, ZodUnknown, ZodNever, ZodVoid, ZodArray, ZodObject, ZodUnion, ZodDiscriminatedUnion, ZodIntersection, ZodTuple, ZodRecord, ZodMap, ZodSet, ZodFunction, ZodLazy, ZodLiteral, ZodEnum, ZodNativeEnum, ZodPromise, ZodEffects, ZodTransformer: ZodEffects, ZodOptional, ZodNullable, ZodDefault, ZodCatch, ZodNaN, BRAND, ZodBranded, ZodPipeline, ZodReadonly, custom, Schema: ZodType, ZodSchema: ZodType, late, get ZodFirstPartyTypeKind() {
  return ZodFirstPartyTypeKind;
}, coerce, any: anyType, array: arrayType, bigint: bigIntType, boolean: booleanType, date: dateType, discriminatedUnion: discriminatedUnionType, effect: effectsType, enum: enumType, function: functionType, instanceof: instanceOfType, intersection: intersectionType, lazy: lazyType, literal: literalType, map: mapType, nan: nanType, nativeEnum: nativeEnumType, never: neverType, null: nullType, nullable: nullableType, number: numberType, object: objectType, oboolean, onumber, optional: optionalType, ostring, pipeline: pipelineType, preprocess: preprocessType, promise: promiseType, record: recordType, set: setType, strictObject: strictObjectType, string: stringType, symbol: symbolType, transformer: effectsType, tuple: tupleType, undefined: undefinedType, union: unionType, unknown: unknownType, void: voidType, NEVER, ZodIssueCode, quotelessJson, ZodError }), Edge, Edge2;
Edge2 = Edge || (Edge = {}), Edge2[Edge2.EXTEND = 1] = "EXTEND", Edge2[Edge2.WRAP = 2] = "WRAP", Edge2[Edge2.CROP = 3] = "CROP";
const JimpClassSchema = z.object({ bitmap: z.object({ data: z.union([z.instanceof(Buffer$1), z.instanceof(Uint8Array)]), width: z.number(), height: z.number() }) }), BlitOptionsSchemaComplex = z.object({ src: JimpClassSchema, x: z.number().optional(), y: z.number().optional(), srcX: z.number().optional(), srcY: z.number().optional(), srcW: z.number().optional(), srcH: z.number().optional() }), BlitOptionsSchema = z.union([JimpClassSchema, BlitOptionsSchemaComplex]), methods$h = { blit(Xn, zn) {
  const Un = BlitOptionsSchema.parse(zn);
  let { src: Kn, x: qn = 0, y: Jo = 0, srcX: pa = 0, srcY: ma = 0, srcW: va = Kn.bitmap.width, srcH: ba = Kn.bitmap.height } = "bitmap" in Un ? { src: Un } : Un;
  if (!("bitmap" in Kn)) throw new Error("The source must be a Jimp image");
  if (typeof qn != "number" || typeof Jo != "number") throw new Error("x and y must be numbers");
  qn = Math.round(qn), Jo = Math.round(Jo), pa = Math.round(pa), ma = Math.round(ma), va = Math.round(va), ba = Math.round(ba);
  const _a = Xn.bitmap.width, ya = Xn.bitmap.height;
  return scan(Kn, pa, ma, va, ba, function(xa, wa, Ta) {
    const Sa = qn + xa - pa, Ma = Jo + wa - ma;
    if (Sa >= 0 && Ma >= 0 && _a - Sa > 0 && ya - Ma > 0) {
      const ka = Xn.getPixelIndex(Sa, Ma), Za = { r: Kn.bitmap.data[Ta] || 0, g: Kn.bitmap.data[Ta + 1] || 0, b: Kn.bitmap.data[Ta + 2] || 0, a: Kn.bitmap.data[Ta + 3] || 0 }, Na = { r: Xn.bitmap.data[ka] || 0, g: Xn.bitmap.data[ka + 1] || 0, b: Xn.bitmap.data[ka + 2] || 0, a: Xn.bitmap.data[ka + 3] || 0 };
      Xn.bitmap.data[ka] = (Za.a * (Za.r - Na.r) - Na.r + 255 >> 8) + Na.r, Xn.bitmap.data[ka + 1] = (Za.a * (Za.g - Na.g) - Na.g + 255 >> 8) + Na.g, Xn.bitmap.data[ka + 2] = (Za.a * (Za.b - Na.b) - Na.b + 255 >> 8) + Na.b, Xn.bitmap.data[ka + 3] = limit255(Na.a + Za.a);
    }
  }), Xn;
} }, mulTable = [1, 57, 41, 21, 203, 34, 97, 73, 227, 91, 149, 62, 105, 45, 39, 137, 241, 107, 3, 173, 39, 71, 65, 238, 219, 101, 187, 87, 81, 151, 141, 133, 249, 117, 221, 209, 197, 187, 177, 169, 5, 153, 73, 139, 133, 127, 243, 233, 223, 107, 103, 99, 191, 23, 177, 171, 165, 159, 77, 149, 9, 139, 135, 131, 253, 245, 119, 231, 224, 109, 211, 103, 25, 195, 189, 23, 45, 175, 171, 83, 81, 79, 155, 151, 147, 9, 141, 137, 67, 131, 129, 251, 123, 30, 235, 115, 113, 221, 217, 53, 13, 51, 50, 49, 193, 189, 185, 91, 179, 175, 43, 169, 83, 163, 5, 79, 155, 19, 75, 147, 145, 143, 35, 69, 17, 67, 33, 65, 255, 251, 247, 243, 239, 59, 29, 229, 113, 111, 219, 27, 213, 105, 207, 51, 201, 199, 49, 193, 191, 47, 93, 183, 181, 179, 11, 87, 43, 85, 167, 165, 163, 161, 159, 157, 155, 77, 19, 75, 37, 73, 145, 143, 141, 35, 138, 137, 135, 67, 33, 131, 129, 255, 63, 250, 247, 61, 121, 239, 237, 117, 29, 229, 227, 225, 111, 55, 109, 216, 213, 211, 209, 207, 205, 203, 201, 199, 197, 195, 193, 48, 190, 47, 93, 185, 183, 181, 179, 178, 176, 175, 173, 171, 85, 21, 167, 165, 41, 163, 161, 5, 79, 157, 78, 154, 153, 19, 75, 149, 74, 147, 73, 144, 143, 71, 141, 140, 139, 137, 17, 135, 134, 133, 66, 131, 65, 129, 1], shgTable = [0, 9, 10, 10, 14, 12, 14, 14, 16, 15, 16, 15, 16, 15, 15, 17, 18, 17, 12, 18, 16, 17, 17, 19, 19, 18, 19, 18, 18, 19, 19, 19, 20, 19, 20, 20, 20, 20, 20, 20, 15, 20, 19, 20, 20, 20, 21, 21, 21, 20, 20, 20, 21, 18, 21, 21, 21, 21, 20, 21, 17, 21, 21, 21, 22, 22, 21, 22, 22, 21, 22, 21, 19, 22, 22, 19, 20, 22, 22, 21, 21, 21, 22, 22, 22, 18, 22, 22, 21, 22, 22, 23, 22, 20, 23, 22, 22, 23, 23, 21, 19, 21, 21, 21, 23, 23, 23, 22, 23, 23, 21, 23, 22, 23, 18, 22, 23, 20, 22, 23, 23, 23, 21, 22, 20, 22, 21, 22, 24, 24, 24, 24, 24, 22, 21, 24, 23, 23, 24, 21, 24, 23, 24, 22, 24, 24, 22, 24, 24, 22, 23, 24, 24, 24, 20, 23, 22, 23, 24, 24, 24, 24, 24, 24, 24, 23, 21, 23, 22, 23, 24, 24, 24, 22, 24, 24, 24, 23, 22, 24, 24, 25, 23, 25, 25, 23, 24, 25, 25, 24, 22, 25, 25, 25, 24, 23, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 23, 25, 23, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 24, 22, 25, 25, 23, 25, 25, 20, 24, 25, 24, 25, 25, 22, 24, 25, 24, 25, 24, 25, 25, 24, 25, 25, 25, 25, 22, 25, 25, 25, 24, 25, 24, 25, 18], methods$g = { blur(Xn, zn) {
  if (typeof zn != "number") throw new Error("r must be a number");
  if (zn < 1) throw new Error("r must be greater than 0");
  let Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta;
  const Sa = Xn.bitmap.width - 1, Ma = Xn.bitmap.height - 1, ka = zn + 1, Za = mulTable[zn], Na = shgTable[zn], Ka = [], Ja = [], el = [], qa = [], tl = [], Qa = [];
  let nl = 2;
  for (; nl-- > 0; ) {
    for (wa = 0, Ta = 0, ma = 0; ma < Xn.bitmap.height; ma++) {
      for (Un = Xn.bitmap.data[Ta] * ka, Kn = Xn.bitmap.data[Ta + 1] * ka, qn = Xn.bitmap.data[Ta + 2] * ka, Jo = Xn.bitmap.data[Ta + 3] * ka, va = 1; va <= zn; va++) ba = Ta + ((va > Sa ? Sa : va) << 2), Un += Xn.bitmap.data[ba++], Kn += Xn.bitmap.data[ba++], qn += Xn.bitmap.data[ba++], Jo += Xn.bitmap.data[ba];
      for (pa = 0; pa < Xn.bitmap.width; pa++) Ka[wa] = Un, Ja[wa] = Kn, el[wa] = qn, qa[wa] = Jo, ma === 0 && (tl[pa] = ((ba = pa + ka) < Sa ? ba : Sa) << 2, Qa[pa] = (ba = pa - zn) > 0 ? ba << 2 : 0), _a = Ta + tl[pa], ya = Ta + Qa[pa], Un += Xn.bitmap.data[_a++] - Xn.bitmap.data[ya++], Kn += Xn.bitmap.data[_a++] - Xn.bitmap.data[ya++], qn += Xn.bitmap.data[_a++] - Xn.bitmap.data[ya++], Jo += Xn.bitmap.data[_a] - Xn.bitmap.data[ya++], wa++;
      Ta += Xn.bitmap.width << 2;
    }
    for (pa = 0; pa < Xn.bitmap.width; pa++) {
      for (xa = pa, Un = Ka[xa] * ka, Kn = Ja[xa] * ka, qn = el[xa] * ka, Jo = qa[xa] * ka, va = 1; va <= zn; va++) xa += va > Ma ? 0 : Xn.bitmap.width, Un += Ka[xa], Kn += Ja[xa], qn += el[xa], Jo += qa[xa];
      for (wa = pa << 2, ma = 0; ma < Xn.bitmap.height; ma++) Xn.bitmap.data[wa] = limit255(Un * Za >>> Na), Xn.bitmap.data[wa + 1] = limit255(Kn * Za >>> Na), Xn.bitmap.data[wa + 2] = limit255(qn * Za >>> Na), Xn.bitmap.data[wa + 3] = limit255(Jo * Za >>> Na), pa === 0 && (tl[ma] = ((ba = ma + ka) < Ma ? ba : Ma) * Xn.bitmap.width, Qa[ma] = (ba = ma - zn) > 0 ? ba * Xn.bitmap.width : 0), _a = pa + tl[ma], ya = pa + Qa[ma], Un += Ka[_a] - Ka[ya], Kn += Ja[_a] - Ja[ya], qn += el[_a] - el[ya], Jo += qa[_a] - qa[ya], wa += Xn.bitmap.width << 2;
    }
  }
  return Xn;
}, gaussian(Xn, zn) {
  if (typeof zn != "number") throw new Error("r must be a number");
  if (zn < 1) throw new Error("r must be greater than 0");
  const Un = Math.ceil(2.57 * zn), Kn = 2 * Un + 1, qn = zn * zn * 2, Jo = qn * Math.PI, pa = [];
  for (let ma = 0; ma < Kn; ma++) {
    const va = [];
    for (let ba = 0; ba < Kn; ba++) {
      const _a = (ba - Un) ** 2 + (ma - Un) ** 2;
      va[ba] = Math.exp(-_a / qn) / Jo;
    }
    pa.push(va);
  }
  for (let ma = 0; ma < Xn.bitmap.height; ma++) for (let va = 0; va < Xn.bitmap.width; va++) {
    let ba = 0, _a = 0, ya = 0, xa = 0, wa = 0;
    for (let Ta = 0; Ta < Kn; Ta++) {
      for (let Ma = 0; Ma < Kn; Ma++) {
        const ka = Math.min(Xn.bitmap.width - 1, Math.max(0, Ma + va - Un)), Za = Math.min(Xn.bitmap.height - 1, Math.max(0, Ta + ma - Un)), Na = pa[Ta][Ma], Ka = Za * Xn.bitmap.width + ka << 2;
        ba += Xn.bitmap.data[Ka] * Na, _a += Xn.bitmap.data[Ka + 1] * Na, ya += Xn.bitmap.data[Ka + 2] * Na, xa += Xn.bitmap.data[Ka + 3] * Na, wa += Na;
      }
      const Sa = ma * Xn.bitmap.width + va << 2;
      Xn.bitmap.data[Sa] = Math.round(ba / wa), Xn.bitmap.data[Sa + 1] = Math.round(_a / wa), Xn.bitmap.data[Sa + 2] = Math.round(ya / wa), Xn.bitmap.data[Sa + 3] = Math.round(xa / wa);
    }
  }
  return Xn;
} }, CircleOptionsSchema = z.object({ x: z.number().optional(), y: z.number().optional(), radius: z.number().min(0).optional() }), methods$f = { circle(Xn, zn = {}) {
  const Un = CircleOptionsSchema.parse(zn), Kn = Un.radius || (Xn.bitmap.width > Xn.bitmap.height ? Xn.bitmap.height : Xn.bitmap.width) / 2, qn = typeof Un.x == "number" ? Un.x : Xn.bitmap.width / 2, Jo = typeof Un.y == "number" ? Un.y : Xn.bitmap.height / 2;
  return Xn.scan((pa, ma, va) => {
    const ba = Math.sqrt(Math.pow(pa - qn, 2) + Math.pow(ma - Jo, 2));
    Kn - ba <= 0 ? Xn.bitmap.data[va + 3] = 0 : Kn - ba < 1 && (Xn.bitmap.data[va + 3] = 255 * (Kn - ba));
  }), Xn;
} }, ConvolutionMatrixSchema = z.array(z.number()).min(1).array(), ConvolutionComplexOptionsSchema = z.object({ kernel: ConvolutionMatrixSchema, edgeHandling: z.nativeEnum(Edge).optional() }), ConvolutionOptionsSchema = z.union([ConvolutionMatrixSchema, ConvolutionComplexOptionsSchema]), ConvoluteComplexOptionsSchema = z.object({ kernel: ConvolutionMatrixSchema, x: z.number().optional(), y: z.number().optional(), w: z.number().optional(), h: z.number().optional() }), ConvoluteOptionsSchema = z.union([ConvolutionMatrixSchema, ConvoluteComplexOptionsSchema]), PixelateSize = z.number().min(1).max(1 / 0), PixelateComplexOptionsSchema = z.object({ size: PixelateSize, x: z.number().optional(), y: z.number().optional(), w: z.number().optional(), h: z.number().optional() }), PixelateOptionsSchema = z.union([PixelateSize, PixelateComplexOptionsSchema]);
function applyKernel(Xn, zn, Un, Kn) {
  const qn = [0, 0, 0, 0], Jo = (zn.length - 1) / 2;
  for (let pa = 0; pa < zn.length; pa += 1) for (let ma = 0; ma < zn[pa].length; ma += 1) {
    const va = Xn.getPixelIndex(Un + pa - Jo, Kn + ma - Jo);
    qn[0] += Xn.bitmap.data[va] * zn[pa][ma], qn[1] += Xn.bitmap.data[va + 1] * zn[pa][ma], qn[2] += Xn.bitmap.data[va + 2] * zn[pa][ma], qn[3] += Xn.bitmap.data[va + 3] * zn[pa][ma];
  }
  return qn;
}
function mix(Xn, zn, Un = 50) {
  return { r: (zn.r - Xn.r) * (Un / 100) + Xn.r, g: (zn.g - Xn.g) * (Un / 100) + Xn.g, b: (zn.b - Xn.b) * (Un / 100) + Xn.b };
}
const HueActionSchema = z.object({ apply: z.literal("hue"), params: z.tuple([z.number().min(-360).max(360)]) }), SpinActionSchema = z.object({ apply: z.literal("spin"), params: z.tuple([z.number().min(-360).max(360)]) }), LightenActionSchema = z.object({ apply: z.literal("lighten"), params: z.tuple([z.number().min(0).max(100)]).optional() }), RGBColorSchema = z.object({ r: z.number().min(0).max(255), g: z.number().min(0).max(255), b: z.number().min(0).max(255) }), MixActionSchema = z.object({ apply: z.literal("mix"), params: z.union([z.tuple([RGBColorSchema]), z.tuple([RGBColorSchema, z.number().min(0).max(100)])]) }), TintActionSchema = z.object({ apply: z.literal("tint"), params: z.tuple([z.number().min(0).max(100)]).optional() }), ShadeActionSchema = z.object({ apply: z.literal("shade"), params: z.tuple([z.number().min(0).max(100)]).optional() }), XorActionSchema = z.object({ apply: z.literal("xor"), params: z.tuple([RGBColorSchema]) }), RedActionSchema = z.object({ apply: z.literal("red"), params: z.tuple([z.number().min(-255).max(255)]) }), GreenActionSchema = z.object({ apply: z.literal("green"), params: z.tuple([z.number().min(-255).max(255)]) }), BlueActionSchema = z.object({ apply: z.literal("blue"), params: z.tuple([z.number().min(-255).max(255)]) }), BrightenActionSchema = z.object({ apply: z.literal("brighten"), params: z.tuple([z.number().min(0).max(100)]).optional() }), DarkenActionSchema = z.object({ apply: z.literal("darken"), params: z.tuple([z.number().min(0).max(100)]).optional() }), DesaturateActionSchema = z.object({ apply: z.literal("desaturate"), params: z.tuple([z.number().min(0).max(100)]).optional() }), SaturateActionSchema = z.object({ apply: z.literal("saturate"), params: z.tuple([z.number().min(0).max(100)]).optional() }), GrayscaleActionSchema = z.object({ apply: z.literal("greyscale"), params: z.tuple([]).optional() }), ColorActionNameSchema = z.union([HueActionSchema, SpinActionSchema, LightenActionSchema, MixActionSchema, TintActionSchema, ShadeActionSchema, XorActionSchema, RedActionSchema, GreenActionSchema, BlueActionSchema, BrightenActionSchema, DarkenActionSchema, DesaturateActionSchema, SaturateActionSchema, GrayscaleActionSchema]);
function histogram(Xn) {
  const zn = { r: new Array(256).fill(0), g: new Array(256).fill(0), b: new Array(256).fill(0) };
  return Xn.scan((Un, Kn, qn) => {
    zn.r[Xn.bitmap.data[qn + 0]]++, zn.g[Xn.bitmap.data[qn + 1]]++, zn.b[Xn.bitmap.data[qn + 2]]++;
  }), zn;
}
const normalizeValue = function(Xn, zn, Un) {
  return 255 * (Xn - zn) / (Un - zn);
}, getBounds = function(Xn) {
  return [Xn.findIndex((zn) => zn > 0), 255 - Xn.slice().reverse().findIndex((zn) => zn > 0)];
}, methods$e = { normalize(Xn) {
  const zn = histogram(Xn), Un = { r: getBounds(zn.r), g: getBounds(zn.g), b: getBounds(zn.b) };
  return Xn.scan((Kn, qn, Jo) => {
    const pa = Xn.bitmap.data[Jo + 0], ma = Xn.bitmap.data[Jo + 1], va = Xn.bitmap.data[Jo + 2];
    Xn.bitmap.data[Jo + 0] = normalizeValue(pa, Un.r[0], Un.r[1]), Xn.bitmap.data[Jo + 1] = normalizeValue(ma, Un.g[0], Un.g[1]), Xn.bitmap.data[Jo + 2] = normalizeValue(va, Un.b[0], Un.b[1]);
  }), Xn;
}, invert: (Xn) => (Xn.scan((zn, Un, Kn) => {
  Xn.bitmap.data[Kn] = 255 - Xn.bitmap.data[Kn], Xn.bitmap.data[Kn + 1] = 255 - Xn.bitmap.data[Kn + 1], Xn.bitmap.data[Kn + 2] = 255 - Xn.bitmap.data[Kn + 2];
}), Xn), brightness(Xn, zn) {
  if (typeof zn != "number") throw new Error("val must be numbers");
  return Xn.scan((Un, Kn, qn) => {
    Xn.bitmap.data[qn] = limit255(Xn.bitmap.data[qn] * zn), Xn.bitmap.data[qn + 1] = limit255(Xn.bitmap.data[qn + 1] * zn), Xn.bitmap.data[qn + 2] = limit255(Xn.bitmap.data[qn + 2] * zn);
  }), Xn;
}, contrast(Xn, zn) {
  if (typeof zn != "number") throw new Error("val must be numbers");
  if (zn < -1 || zn > 1) throw new Error("val must be a number between -1 and +1");
  const Un = (zn + 1) / (1 - zn);
  function Kn(qn) {
    return (qn = Math.floor(Un * (qn - 127) + 127)) < 0 ? 0 : qn > 255 ? 255 : qn;
  }
  return Xn.scan((qn, Jo, pa) => {
    Xn.bitmap.data[pa] = Kn(Xn.bitmap.data[pa]), Xn.bitmap.data[pa + 1] = Kn(Xn.bitmap.data[pa + 1]), Xn.bitmap.data[pa + 2] = Kn(Xn.bitmap.data[pa + 2]);
  }), Xn;
}, posterize(Xn, zn) {
  if (typeof zn != "number") throw new Error("n must be numbers");
  return zn < 2 && (zn = 2), Xn.scan((Un, Kn, qn) => {
    const Jo = Xn.bitmap.data[qn], pa = Xn.bitmap.data[qn + 1], ma = Xn.bitmap.data[qn + 2];
    Xn.bitmap.data[qn] = Math.floor(Jo / 255 * (zn - 1)) / (zn - 1) * 255, Xn.bitmap.data[qn + 1] = Math.floor(pa / 255 * (zn - 1)) / (zn - 1) * 255, Xn.bitmap.data[qn + 2] = Math.floor(ma / 255 * (zn - 1)) / (zn - 1) * 255;
  }), Xn;
}, greyscale: (Xn) => (Xn.scan((zn, Un, Kn) => {
  const qn = 0.2126 * Xn.bitmap.data[Kn] + 0.7152 * Xn.bitmap.data[Kn + 1] + 0.0722 * Xn.bitmap.data[Kn + 2];
  Xn.bitmap.data[Kn] = qn, Xn.bitmap.data[Kn + 1] = qn, Xn.bitmap.data[Kn + 2] = qn;
}), Xn), opacity(Xn, zn) {
  if (typeof zn != "number") throw new Error("f must be a number");
  if (zn < 0 || zn > 1) throw new Error("f must be a number from 0 to 1");
  return Xn.scan((Un, Kn, qn) => {
    const Jo = Xn.bitmap.data[qn + 3] * zn;
    Xn.bitmap.data[qn + 3] = Jo;
  }), Xn;
}, sepia: (Xn) => (Xn.scan((zn, Un, Kn) => {
  let qn = Xn.bitmap.data[Kn], Jo = Xn.bitmap.data[Kn + 1], pa = Xn.bitmap.data[Kn + 2];
  qn = 0.393 * qn + 0.769 * Jo + 0.189 * pa, Jo = 0.349 * qn + 0.686 * Jo + 0.168 * pa, pa = 0.272 * qn + 0.534 * Jo + 0.131 * pa, Xn.bitmap.data[Kn] = qn < 255 ? qn : 255, Xn.bitmap.data[Kn + 1] = Jo < 255 ? Jo : 255, Xn.bitmap.data[Kn + 2] = pa < 255 ? pa : 255;
}), Xn), fade(Xn, zn) {
  if (typeof zn != "number") throw new Error("f must be a number");
  if (zn < 0 || zn > 1) throw new Error("f must be a number from 0 to 1");
  return this.opacity(Xn, 1 - zn);
}, convolution(Xn, zn) {
  const Un = ConvolutionOptionsSchema.parse(zn), { kernel: Kn, edgeHandling: qn = Edge.EXTEND } = "kernel" in Un ? Un : { kernel: Un, edgeHandling: void 0 };
  if (!Kn[0]) throw new Error("kernel must be a matrix");
  const Jo = Buffer$1.from(Xn.bitmap.data), pa = Kn.length, ma = Kn[0].length, va = Math.floor(pa / 2), ba = Math.floor(ma / 2), _a = -va, ya = -ba;
  let xa, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja;
  return Xn.scan((el, qa, tl) => {
    Sa = 0, Ta = 0, wa = 0;
    for (let Qa = _a; Qa <= va; Qa++) for (let nl = ya; nl <= ba; nl++) Na = el + nl, Ka = qa + Qa, xa = Kn[Qa + va][nl + ba], Ja = Xn.getPixelIndex(Na, Ka, qn), Ja === -1 ? (Za = 0, ka = 0, Ma = 0) : (Ma = Xn.bitmap.data[Ja + 0], ka = Xn.bitmap.data[Ja + 1], Za = Xn.bitmap.data[Ja + 2]), wa += xa * Ma, Ta += xa * ka, Sa += xa * Za;
    wa < 0 && (wa = 0), Ta < 0 && (Ta = 0), Sa < 0 && (Sa = 0), wa > 255 && (wa = 255), Ta > 255 && (Ta = 255), Sa > 255 && (Sa = 255), Jo[tl + 0] = wa, Jo[tl + 1] = Ta, Jo[tl + 2] = Sa;
  }), Xn.bitmap.data = Jo, Xn;
}, opaque: (Xn) => (Xn.scan((zn, Un, Kn) => {
  Xn.bitmap.data[Kn + 3] = 255;
}), Xn), pixelate(Xn, zn) {
  const Un = PixelateOptionsSchema.parse(zn), { size: Kn, x: qn = 0, y: Jo = 0, w: pa = Xn.bitmap.width - qn, h: ma = Xn.bitmap.height - Jo } = typeof Un == "number" ? { size: Un } : Un, va = [[1 / 16, 2 / 16, 1 / 16], [2 / 16, 0.25, 2 / 16], [1 / 16, 2 / 16, 1 / 16]], ba = clone(Xn);
  return scan(ba, qn, Jo, pa, ma, (_a, ya, xa) => {
    _a = Kn * Math.floor(_a / Kn), ya = Kn * Math.floor(ya / Kn);
    const wa = applyKernel(ba, va, _a, ya);
    Xn.bitmap.data[xa] = wa[0], Xn.bitmap.data[xa + 1] = wa[1], Xn.bitmap.data[xa + 2] = wa[2], Xn.bitmap.data[xa + 3] = wa[3];
  }), Xn;
}, convolute(Xn, zn) {
  const Un = ConvoluteOptionsSchema.parse(zn), { kernel: Kn, x: qn = 0, y: Jo = 0, w: pa = Xn.bitmap.width - qn, h: ma = Xn.bitmap.height - Jo } = "kernel" in Un ? Un : { kernel: Un }, va = clone(Xn);
  return scan(va, qn, Jo, pa, ma, (ba, _a, ya) => {
    const xa = applyKernel(va, Kn, ba, _a);
    Xn.bitmap.data[ya] = limit255(xa[0]), Xn.bitmap.data[ya + 1] = limit255(xa[1]), Xn.bitmap.data[ya + 2] = limit255(xa[2]), Xn.bitmap.data[ya + 3] = limit255(xa[3]);
  }), Xn;
}, color(Xn, zn) {
  if (!zn || !Array.isArray(zn)) throw new Error("actions must be an array");
  return zn.forEach((Un) => ColorActionNameSchema.parse(Un)), zn = zn.map((Un) => (Un.apply !== "xor" && Un.apply !== "mix" || (Un.params[0] = tinycolor(Un.params[0]).toRgb()), Un)), Xn.scan((Un, Kn, qn) => {
    let Jo = { r: Xn.bitmap.data[qn], g: Xn.bitmap.data[qn + 1], b: Xn.bitmap.data[qn + 2] };
    const pa = (ma, va) => limit255(Jo[ma] + va);
    zn.forEach((ma) => {
      var va, ba;
      if (ma.apply === "mix") Jo = mix(Jo, ma.params[0], ma.params[1]);
      else if (ma.apply === "tint") Jo = mix(Jo, { r: 255, g: 255, b: 255 }, (va = ma.params) == null ? void 0 : va[0]);
      else if (ma.apply === "shade") Jo = mix(Jo, { r: 0, g: 0, b: 0 }, (ba = ma.params) == null ? void 0 : ba[0]);
      else if (ma.apply === "xor") Jo = { r: Jo.r ^ ma.params[0].r, g: Jo.g ^ ma.params[0].g, b: Jo.b ^ ma.params[0].b };
      else if (ma.apply === "red") Jo.r = pa("r", ma.params[0]);
      else if (ma.apply === "green") Jo.g = pa("g", ma.params[0]);
      else if (ma.apply === "blue") Jo.b = pa("b", ma.params[0]);
      else {
        ma.apply === "hue" && (ma.apply = "spin");
        const _a = tinycolor(Jo), ya = _a[ma.apply].bind(_a);
        if (!ya) throw new Error("action " + ma.apply + " not supported");
        Jo = ya(...ma.params || []).toRgb();
      }
    }), Xn.bitmap.data[qn] = Jo.r, Xn.bitmap.data[qn + 1] = Jo.g, Xn.bitmap.data[qn + 2] = Jo.b;
  }), Xn;
} };
var lib$1 = {}, ieee754 = {
  /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
  read: function(Xn, zn, Un, Kn, qn) {
    var Jo, pa, ma = 8 * qn - Kn - 1, va = (1 << ma) - 1, ba = va >> 1, _a = -7, ya = Un ? qn - 1 : 0, xa = Un ? -1 : 1, wa = Xn[zn + ya];
    for (ya += xa, Jo = wa & (1 << -_a) - 1, wa >>= -_a, _a += ma; _a > 0; Jo = 256 * Jo + Xn[zn + ya], ya += xa, _a -= 8) ;
    for (pa = Jo & (1 << -_a) - 1, Jo >>= -_a, _a += Kn; _a > 0; pa = 256 * pa + Xn[zn + ya], ya += xa, _a -= 8) ;
    if (Jo === 0) Jo = 1 - ba;
    else {
      if (Jo === va) return pa ? NaN : 1 / 0 * (wa ? -1 : 1);
      pa += Math.pow(2, Kn), Jo -= ba;
    }
    return (wa ? -1 : 1) * pa * Math.pow(2, Jo - Kn);
  },
  write: function(Xn, zn, Un, Kn, qn, Jo) {
    var pa, ma, va, ba = 8 * Jo - qn - 1, _a = (1 << ba) - 1, ya = _a >> 1, xa = qn === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, wa = Kn ? 0 : Jo - 1, Ta = Kn ? 1 : -1, Sa = zn < 0 || zn === 0 && 1 / zn < 0 ? 1 : 0;
    for (zn = Math.abs(zn), isNaN(zn) || zn === 1 / 0 ? (ma = isNaN(zn) ? 1 : 0, pa = _a) : (pa = Math.floor(Math.log(zn) / Math.LN2), zn * (va = Math.pow(2, -pa)) < 1 && (pa--, va *= 2), (zn += pa + ya >= 1 ? xa / va : xa * Math.pow(2, 1 - ya)) * va >= 2 && (pa++, va /= 2), pa + ya >= _a ? (ma = 0, pa = _a) : pa + ya >= 1 ? (ma = (zn * va - 1) * Math.pow(2, qn), pa += ya) : (ma = zn * Math.pow(2, ya - 1) * Math.pow(2, qn), pa = 0)); qn >= 8; Xn[Un + wa] = 255 & ma, wa += Ta, ma /= 256, qn -= 8) ;
    for (pa = pa << qn | ma, ba += qn; ba > 0; Xn[Un + wa] = 255 & pa, wa += Ta, pa /= 256, ba -= 8) ;
    Xn[Un + wa - Ta] |= 128 * Sa;
  }
};
(function(Xn) {
  Object.defineProperty(Xn, "__esModule", { value: !0 }), Xn.AnsiStringType = Xn.StringType = Xn.BufferType = Xn.Uint8ArrayType = Xn.IgnoreType = Xn.Float80_LE = Xn.Float80_BE = Xn.Float64_LE = Xn.Float64_BE = Xn.Float32_LE = Xn.Float32_BE = Xn.Float16_LE = Xn.Float16_BE = Xn.INT64_BE = Xn.UINT64_BE = Xn.INT64_LE = Xn.UINT64_LE = Xn.INT32_LE = Xn.INT32_BE = Xn.INT24_BE = Xn.INT24_LE = Xn.INT16_LE = Xn.INT16_BE = Xn.INT8 = Xn.UINT32_BE = Xn.UINT32_LE = Xn.UINT24_BE = Xn.UINT24_LE = Xn.UINT16_BE = Xn.UINT16_LE = Xn.UINT8 = void 0;
  const zn = ieee754;
  function Un(qn) {
    return new DataView(qn.buffer, qn.byteOffset);
  }
  Xn.UINT8 = { len: 1, get: (qn, Jo) => Un(qn).getUint8(Jo), put: (qn, Jo, pa) => (Un(qn).setUint8(Jo, pa), Jo + 1) }, Xn.UINT16_LE = { len: 2, get: (qn, Jo) => Un(qn).getUint16(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setUint16(Jo, pa, !0), Jo + 2) }, Xn.UINT16_BE = { len: 2, get: (qn, Jo) => Un(qn).getUint16(Jo), put: (qn, Jo, pa) => (Un(qn).setUint16(Jo, pa), Jo + 2) }, Xn.UINT24_LE = { len: 3, get(qn, Jo) {
    const pa = Un(qn);
    return pa.getUint8(Jo) + (pa.getUint16(Jo + 1, !0) << 8);
  }, put(qn, Jo, pa) {
    const ma = Un(qn);
    return ma.setUint8(Jo, 255 & pa), ma.setUint16(Jo + 1, pa >> 8, !0), Jo + 3;
  } }, Xn.UINT24_BE = { len: 3, get(qn, Jo) {
    const pa = Un(qn);
    return (pa.getUint16(Jo) << 8) + pa.getUint8(Jo + 2);
  }, put(qn, Jo, pa) {
    const ma = Un(qn);
    return ma.setUint16(Jo, pa >> 8), ma.setUint8(Jo + 2, 255 & pa), Jo + 3;
  } }, Xn.UINT32_LE = { len: 4, get: (qn, Jo) => Un(qn).getUint32(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setUint32(Jo, pa, !0), Jo + 4) }, Xn.UINT32_BE = { len: 4, get: (qn, Jo) => Un(qn).getUint32(Jo), put: (qn, Jo, pa) => (Un(qn).setUint32(Jo, pa), Jo + 4) }, Xn.INT8 = { len: 1, get: (qn, Jo) => Un(qn).getInt8(Jo), put: (qn, Jo, pa) => (Un(qn).setInt8(Jo, pa), Jo + 1) }, Xn.INT16_BE = { len: 2, get: (qn, Jo) => Un(qn).getInt16(Jo), put: (qn, Jo, pa) => (Un(qn).setInt16(Jo, pa), Jo + 2) }, Xn.INT16_LE = { len: 2, get: (qn, Jo) => Un(qn).getInt16(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setInt16(Jo, pa, !0), Jo + 2) }, Xn.INT24_LE = { len: 3, get(qn, Jo) {
    const pa = Xn.UINT24_LE.get(qn, Jo);
    return pa > 8388607 ? pa - 16777216 : pa;
  }, put(qn, Jo, pa) {
    const ma = Un(qn);
    return ma.setUint8(Jo, 255 & pa), ma.setUint16(Jo + 1, pa >> 8, !0), Jo + 3;
  } }, Xn.INT24_BE = { len: 3, get(qn, Jo) {
    const pa = Xn.UINT24_BE.get(qn, Jo);
    return pa > 8388607 ? pa - 16777216 : pa;
  }, put(qn, Jo, pa) {
    const ma = Un(qn);
    return ma.setUint16(Jo, pa >> 8), ma.setUint8(Jo + 2, 255 & pa), Jo + 3;
  } }, Xn.INT32_BE = { len: 4, get: (qn, Jo) => Un(qn).getInt32(Jo), put: (qn, Jo, pa) => (Un(qn).setInt32(Jo, pa), Jo + 4) }, Xn.INT32_LE = { len: 4, get: (qn, Jo) => Un(qn).getInt32(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setInt32(Jo, pa, !0), Jo + 4) }, Xn.UINT64_LE = { len: 8, get: (qn, Jo) => Un(qn).getBigUint64(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setBigUint64(Jo, pa, !0), Jo + 8) }, Xn.INT64_LE = { len: 8, get: (qn, Jo) => Un(qn).getBigInt64(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setBigInt64(Jo, pa, !0), Jo + 8) }, Xn.UINT64_BE = { len: 8, get: (qn, Jo) => Un(qn).getBigUint64(Jo), put: (qn, Jo, pa) => (Un(qn).setBigUint64(Jo, pa), Jo + 8) }, Xn.INT64_BE = { len: 8, get: (qn, Jo) => Un(qn).getBigInt64(Jo), put: (qn, Jo, pa) => (Un(qn).setBigInt64(Jo, pa), Jo + 8) }, Xn.Float16_BE = { len: 2, get(qn, Jo) {
    return zn.read(qn, Jo, !1, 10, this.len);
  }, put(qn, Jo, pa) {
    return zn.write(qn, pa, Jo, !1, 10, this.len), Jo + this.len;
  } }, Xn.Float16_LE = { len: 2, get(qn, Jo) {
    return zn.read(qn, Jo, !0, 10, this.len);
  }, put(qn, Jo, pa) {
    return zn.write(qn, pa, Jo, !0, 10, this.len), Jo + this.len;
  } }, Xn.Float32_BE = { len: 4, get: (qn, Jo) => Un(qn).getFloat32(Jo), put: (qn, Jo, pa) => (Un(qn).setFloat32(Jo, pa), Jo + 4) }, Xn.Float32_LE = { len: 4, get: (qn, Jo) => Un(qn).getFloat32(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setFloat32(Jo, pa, !0), Jo + 4) }, Xn.Float64_BE = { len: 8, get: (qn, Jo) => Un(qn).getFloat64(Jo), put: (qn, Jo, pa) => (Un(qn).setFloat64(Jo, pa), Jo + 8) }, Xn.Float64_LE = { len: 8, get: (qn, Jo) => Un(qn).getFloat64(Jo, !0), put: (qn, Jo, pa) => (Un(qn).setFloat64(Jo, pa, !0), Jo + 8) }, Xn.Float80_BE = { len: 10, get(qn, Jo) {
    return zn.read(qn, Jo, !1, 63, this.len);
  }, put(qn, Jo, pa) {
    return zn.write(qn, pa, Jo, !1, 63, this.len), Jo + this.len;
  } }, Xn.Float80_LE = { len: 10, get(qn, Jo) {
    return zn.read(qn, Jo, !0, 63, this.len);
  }, put(qn, Jo, pa) {
    return zn.write(qn, pa, Jo, !0, 63, this.len), Jo + this.len;
  } }, Xn.IgnoreType = class {
    constructor(qn) {
      this.len = qn;
    }
    get(qn, Jo) {
    }
  }, Xn.Uint8ArrayType = class {
    constructor(qn) {
      this.len = qn;
    }
    get(qn, Jo) {
      return qn.subarray(Jo, Jo + this.len);
    }
  }, Xn.BufferType = class {
    constructor(qn) {
      this.len = qn;
    }
    get(qn, Jo) {
      return Buffer$1.from(qn.subarray(Jo, Jo + this.len));
    }
  }, Xn.StringType = class {
    constructor(qn, Jo) {
      this.len = qn, this.encoding = Jo;
    }
    get(qn, Jo) {
      return Buffer$1.from(qn).toString(this.encoding, Jo, Jo + this.len);
    }
  };
  class Kn {
    constructor(Jo) {
      this.len = Jo;
    }
    static decode(Jo, pa, ma) {
      let va = "";
      for (let ba = pa; ba < ma; ++ba) va += Kn.codePointToString(Kn.singleByteDecoder(Jo[ba]));
      return va;
    }
    static inRange(Jo, pa, ma) {
      return pa <= Jo && Jo <= ma;
    }
    static codePointToString(Jo) {
      return Jo <= 65535 ? String.fromCharCode(Jo) : (Jo -= 65536, String.fromCharCode(55296 + (Jo >> 10), 56320 + (1023 & Jo)));
    }
    static singleByteDecoder(Jo) {
      if (Kn.inRange(Jo, 0, 127)) return Jo;
      const pa = Kn.windows1252[Jo - 128];
      if (pa === null) throw Error("invaliding encoding");
      return pa;
    }
    get(Jo, pa = 0) {
      return Kn.decode(Jo, pa, pa + this.len);
    }
  }
  Xn.AnsiStringType = Kn, Kn.windows1252 = [8364, 129, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, 141, 381, 143, 144, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, 157, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255];
})(lib$1);
var core$1 = {}, ReadStreamTokenizer$1 = {}, AbstractTokenizer$1 = {}, lib = {}, EndOfFileStream = {};
(function(Xn) {
  Object.defineProperty(Xn, "__esModule", { value: !0 }), Xn.EndOfStreamError = Xn.defaultMessages = void 0, Xn.defaultMessages = "End-Of-Stream";
  class zn extends Error {
    constructor() {
      super(Xn.defaultMessages);
    }
  }
  Xn.EndOfStreamError = zn;
})(EndOfFileStream);
var StreamReader = {}, Deferred$1 = {};
Object.defineProperty(Deferred$1, "__esModule", { value: !0 }), Deferred$1.Deferred = void 0;
class Deferred {
  constructor() {
    this.resolve = () => null, this.reject = () => null, this.promise = new Promise((zn, Un) => {
      this.reject = Un, this.resolve = zn;
    });
  }
}
Deferred$1.Deferred = Deferred, function(Xn) {
  Object.defineProperty(Xn, "__esModule", { value: !0 }), Xn.StreamReader = Xn.EndOfStreamError = void 0;
  const zn = EndOfFileStream, Un = Deferred$1;
  var Kn = EndOfFileStream;
  Object.defineProperty(Xn, "EndOfStreamError", { enumerable: !0, get: function() {
    return Kn.EndOfStreamError;
  } }), Xn.StreamReader = class {
    constructor(qn) {
      if (this.s = qn, this.deferred = null, this.endOfStream = !1, this.peekQueue = [], !qn.read || !qn.once) throw new Error("Expected an instance of stream.Readable");
      this.s.once("end", () => this.reject(new zn.EndOfStreamError())), this.s.once("error", (Jo) => this.reject(Jo)), this.s.once("close", () => this.reject(new Error("Stream closed")));
    }
    async peek(qn, Jo, pa) {
      const ma = await this.read(qn, Jo, pa);
      return this.peekQueue.push(qn.subarray(Jo, Jo + ma)), ma;
    }
    async read(qn, Jo, pa) {
      if (pa === 0) return 0;
      if (this.peekQueue.length === 0 && this.endOfStream) throw new zn.EndOfStreamError();
      let ma = pa, va = 0;
      for (; this.peekQueue.length > 0 && ma > 0; ) {
        const ba = this.peekQueue.pop();
        if (!ba) throw new Error("peekData should be defined");
        const _a = Math.min(ba.length, ma);
        qn.set(ba.subarray(0, _a), Jo + va), va += _a, ma -= _a, _a < ba.length && this.peekQueue.push(ba.subarray(_a));
      }
      for (; ma > 0 && !this.endOfStream; ) {
        const ba = Math.min(ma, 1048576), _a = await this.readFromStream(qn, Jo + va, ba);
        if (va += _a, _a < ba) break;
        ma -= _a;
      }
      return va;
    }
    async readFromStream(qn, Jo, pa) {
      const ma = this.s.read(pa);
      if (ma) return qn.set(ma, Jo), ma.length;
      {
        const va = { buffer: qn, offset: Jo, length: pa, deferred: new Un.Deferred() };
        return this.deferred = va.deferred, this.s.once("readable", () => {
          this.readDeferred(va);
        }), va.deferred.promise;
      }
    }
    readDeferred(qn) {
      const Jo = this.s.read(qn.length);
      Jo ? (qn.buffer.set(Jo, qn.offset), qn.deferred.resolve(Jo.length), this.deferred = null) : this.s.once("readable", () => {
        this.readDeferred(qn);
      });
    }
    reject(qn) {
      this.endOfStream = !0, this.deferred && (this.deferred.reject(qn), this.deferred = null);
    }
  };
}(StreamReader), function(Xn) {
  Object.defineProperty(Xn, "__esModule", { value: !0 }), Xn.StreamReader = Xn.EndOfStreamError = void 0;
  var zn = EndOfFileStream;
  Object.defineProperty(Xn, "EndOfStreamError", { enumerable: !0, get: function() {
    return zn.EndOfStreamError;
  } });
  var Un = StreamReader;
  Object.defineProperty(Xn, "StreamReader", { enumerable: !0, get: function() {
    return Un.StreamReader;
  } });
}(lib), Object.defineProperty(AbstractTokenizer$1, "__esModule", { value: !0 }), AbstractTokenizer$1.AbstractTokenizer = void 0;
const peek_readable_1$2 = lib;
class AbstractTokenizer {
  constructor(zn) {
    this.position = 0, this.numBuffer = new Uint8Array(8), this.fileInfo = zn || {};
  }
  async readToken(zn, Un = this.position) {
    const Kn = Buffer$1.alloc(zn.len);
    if (await this.readBuffer(Kn, { position: Un }) < zn.len) throw new peek_readable_1$2.EndOfStreamError();
    return zn.get(Kn, 0);
  }
  async peekToken(zn, Un = this.position) {
    const Kn = Buffer$1.alloc(zn.len);
    if (await this.peekBuffer(Kn, { position: Un }) < zn.len) throw new peek_readable_1$2.EndOfStreamError();
    return zn.get(Kn, 0);
  }
  async readNumber(zn) {
    if (await this.readBuffer(this.numBuffer, { length: zn.len }) < zn.len) throw new peek_readable_1$2.EndOfStreamError();
    return zn.get(this.numBuffer, 0);
  }
  async peekNumber(zn) {
    if (await this.peekBuffer(this.numBuffer, { length: zn.len }) < zn.len) throw new peek_readable_1$2.EndOfStreamError();
    return zn.get(this.numBuffer, 0);
  }
  async ignore(zn) {
    if (this.fileInfo.size !== void 0) {
      const Un = this.fileInfo.size - this.position;
      if (zn > Un) return this.position += Un, Un;
    }
    return this.position += zn, zn;
  }
  async close() {
  }
  normalizeOptions(zn, Un) {
    if (Un && Un.position !== void 0 && Un.position < this.position) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
    return Un ? { mayBeLess: Un.mayBeLess === !0, offset: Un.offset ? Un.offset : 0, length: Un.length ? Un.length : zn.length - (Un.offset ? Un.offset : 0), position: Un.position ? Un.position : this.position } : { mayBeLess: !1, offset: 0, length: zn.length, position: this.position };
  }
}
AbstractTokenizer$1.AbstractTokenizer = AbstractTokenizer, Object.defineProperty(ReadStreamTokenizer$1, "__esModule", { value: !0 }), ReadStreamTokenizer$1.ReadStreamTokenizer = void 0;
const AbstractTokenizer_1$1 = AbstractTokenizer$1, peek_readable_1$1 = lib, maxBufferSize = 256e3;
class ReadStreamTokenizer extends AbstractTokenizer_1$1.AbstractTokenizer {
  constructor(zn, Un) {
    super(Un), this.streamReader = new peek_readable_1$1.StreamReader(zn);
  }
  async getFileInfo() {
    return this.fileInfo;
  }
  async readBuffer(zn, Un) {
    const Kn = this.normalizeOptions(zn, Un), qn = Kn.position - this.position;
    if (qn > 0) return await this.ignore(qn), this.readBuffer(zn, Un);
    if (qn < 0) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
    if (Kn.length === 0) return 0;
    const Jo = await this.streamReader.read(zn, Kn.offset, Kn.length);
    if (this.position += Jo, (!Un || !Un.mayBeLess) && Jo < Kn.length) throw new peek_readable_1$1.EndOfStreamError();
    return Jo;
  }
  async peekBuffer(zn, Un) {
    const Kn = this.normalizeOptions(zn, Un);
    let qn = 0;
    if (Kn.position) {
      const Jo = Kn.position - this.position;
      if (Jo > 0) {
        const pa = new Uint8Array(Kn.length + Jo);
        return qn = await this.peekBuffer(pa, { mayBeLess: Kn.mayBeLess }), zn.set(pa.subarray(Jo), Kn.offset), qn - Jo;
      }
      if (Jo < 0) throw new Error("Cannot peek from a negative offset in a stream");
    }
    if (Kn.length > 0) {
      try {
        qn = await this.streamReader.peek(zn, Kn.offset, Kn.length);
      } catch (Jo) {
        if (Un && Un.mayBeLess && Jo instanceof peek_readable_1$1.EndOfStreamError) return 0;
        throw Jo;
      }
      if (!Kn.mayBeLess && qn < Kn.length) throw new peek_readable_1$1.EndOfStreamError();
    }
    return qn;
  }
  async ignore(zn) {
    const Un = Math.min(maxBufferSize, zn), Kn = new Uint8Array(Un);
    let qn = 0;
    for (; qn < zn; ) {
      const Jo = zn - qn, pa = await this.readBuffer(Kn, { length: Math.min(Un, Jo) });
      if (pa < 0) return pa;
      qn += pa;
    }
    return qn;
  }
}
ReadStreamTokenizer$1.ReadStreamTokenizer = ReadStreamTokenizer;
var BufferTokenizer$1 = {};
Object.defineProperty(BufferTokenizer$1, "__esModule", { value: !0 }), BufferTokenizer$1.BufferTokenizer = void 0;
const peek_readable_1 = lib, AbstractTokenizer_1 = AbstractTokenizer$1;
class BufferTokenizer extends AbstractTokenizer_1.AbstractTokenizer {
  constructor(zn, Un) {
    super(Un), this.uint8Array = zn, this.fileInfo.size = this.fileInfo.size ? this.fileInfo.size : zn.length;
  }
  async readBuffer(zn, Un) {
    if (Un && Un.position) {
      if (Un.position < this.position) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
      this.position = Un.position;
    }
    const Kn = await this.peekBuffer(zn, Un);
    return this.position += Kn, Kn;
  }
  async peekBuffer(zn, Un) {
    const Kn = this.normalizeOptions(zn, Un), qn = Math.min(this.uint8Array.length - Kn.position, Kn.length);
    if (!Kn.mayBeLess && qn < Kn.length) throw new peek_readable_1.EndOfStreamError();
    return zn.set(this.uint8Array.subarray(Kn.position, Kn.position + qn), Kn.offset), qn;
  }
  async close() {
  }
}
BufferTokenizer$1.BufferTokenizer = BufferTokenizer, function(Xn) {
  Object.defineProperty(Xn, "__esModule", { value: !0 }), Xn.fromBuffer = Xn.fromStream = Xn.EndOfStreamError = void 0;
  const zn = ReadStreamTokenizer$1, Un = BufferTokenizer$1;
  var Kn = lib;
  Object.defineProperty(Xn, "EndOfStreamError", { enumerable: !0, get: function() {
    return Kn.EndOfStreamError;
  } }), Xn.fromStream = function(qn, Jo) {
    return Jo = Jo || {}, new zn.ReadStreamTokenizer(qn, Jo);
  }, Xn.fromBuffer = function(qn, Jo) {
    return new Un.BufferTokenizer(qn, Jo);
  };
}(core$1);
var util = { stringToBytes: (Xn) => [...Xn].map((zn) => zn.charCodeAt(0)), tarHeaderChecksumMatches: (Xn, zn = 0) => {
  const Un = parseInt(Xn.toString("utf8", 148, 154).replace(/\0.*$/, "").trim(), 8);
  if (isNaN(Un)) return !1;
  let Kn = 256;
  for (let qn = zn; qn < zn + 148; qn++) Kn += Xn[qn];
  for (let qn = zn + 156; qn < zn + 512; qn++) Kn += Xn[qn];
  return Un === Kn;
}, uint32SyncSafeToken: { get: (Xn, zn) => 127 & Xn[zn + 3] | Xn[zn + 2] << 7 | Xn[zn + 1] << 14 | Xn[zn] << 21, len: 4 } }, supported$1 = { extensions: ["jpg", "png", "apng", "gif", "webp", "flif", "xcf", "cr2", "cr3", "orf", "arw", "dng", "nef", "rw2", "raf", "tif", "bmp", "icns", "jxr", "psd", "indd", "zip", "tar", "rar", "gz", "bz2", "7z", "dmg", "mp4", "mid", "mkv", "webm", "mov", "avi", "mpg", "mp2", "mp3", "m4a", "oga", "ogg", "ogv", "opus", "flac", "wav", "spx", "amr", "pdf", "epub", "exe", "swf", "rtf", "wasm", "woff", "woff2", "eot", "ttf", "otf", "ico", "flv", "ps", "xz", "sqlite", "nes", "crx", "xpi", "cab", "deb", "ar", "rpm", "Z", "lz", "cfb", "mxf", "mts", "blend", "bpg", "docx", "pptx", "xlsx", "3gp", "3g2", "jp2", "jpm", "jpx", "mj2", "aif", "qcp", "odt", "ods", "odp", "xml", "mobi", "heic", "cur", "ktx", "ape", "wv", "dcm", "ics", "glb", "pcap", "dsf", "lnk", "alias", "voc", "ac3", "m4v", "m4p", "m4b", "f4v", "f4p", "f4b", "f4a", "mie", "asf", "ogm", "ogx", "mpc", "arrow", "shp", "aac", "mp1", "it", "s3m", "xm", "ai", "skp", "avif", "eps", "lzh", "pgp", "asar", "stl", "chm", "3mf", "zst", "jxl", "vcf"], mimeTypes: ["image/jpeg", "image/png", "image/gif", "image/webp", "image/flif", "image/x-xcf", "image/x-canon-cr2", "image/x-canon-cr3", "image/tiff", "image/bmp", "image/vnd.ms-photo", "image/vnd.adobe.photoshop", "application/x-indesign", "application/epub+zip", "application/x-xpinstall", "application/vnd.oasis.opendocument.text", "application/vnd.oasis.opendocument.spreadsheet", "application/vnd.oasis.opendocument.presentation", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/zip", "application/x-tar", "application/x-rar-compressed", "application/gzip", "application/x-bzip2", "application/x-7z-compressed", "application/x-apple-diskimage", "application/x-apache-arrow", "video/mp4", "audio/midi", "video/x-matroska", "video/webm", "video/quicktime", "video/vnd.avi", "audio/vnd.wave", "audio/qcelp", "audio/x-ms-asf", "video/x-ms-asf", "application/vnd.ms-asf", "video/mpeg", "video/3gpp", "audio/mpeg", "audio/mp4", "audio/opus", "video/ogg", "audio/ogg", "application/ogg", "audio/x-flac", "audio/ape", "audio/wavpack", "audio/amr", "application/pdf", "application/x-msdownload", "application/x-shockwave-flash", "application/rtf", "application/wasm", "font/woff", "font/woff2", "application/vnd.ms-fontobject", "font/ttf", "font/otf", "image/x-icon", "video/x-flv", "application/postscript", "application/eps", "application/x-xz", "application/x-sqlite3", "application/x-nintendo-nes-rom", "application/x-google-chrome-extension", "application/vnd.ms-cab-compressed", "application/x-deb", "application/x-unix-archive", "application/x-rpm", "application/x-compress", "application/x-lzip", "application/x-cfb", "application/x-mie", "application/mxf", "video/mp2t", "application/x-blender", "image/bpg", "image/jp2", "image/jpx", "image/jpm", "image/mj2", "audio/aiff", "application/xml", "application/x-mobipocket-ebook", "image/heif", "image/heif-sequence", "image/heic", "image/heic-sequence", "image/icns", "image/ktx", "application/dicom", "audio/x-musepack", "text/calendar", "text/vcard", "model/gltf-binary", "application/vnd.tcpdump.pcap", "audio/x-dsf", "application/x.ms.shortcut", "application/x.apple.alias", "audio/x-voc", "audio/vnd.dolby.dd-raw", "audio/x-m4a", "image/apng", "image/x-olympus-orf", "image/x-sony-arw", "image/x-adobe-dng", "image/x-nikon-nef", "image/x-panasonic-rw2", "image/x-fujifilm-raf", "video/x-m4v", "video/3gpp2", "application/x-esri-shape", "audio/aac", "audio/x-it", "audio/x-s3m", "audio/x-xm", "video/MP1S", "video/MP2P", "application/vnd.sketchup.skp", "image/avif", "application/x-lzh-compressed", "application/pgp-encrypted", "application/x-asar", "model/stl", "application/vnd.ms-htmlhelp", "model/3mf", "image/jxl", "application/zstd"] };
const Token = lib$1, strtok3 = core$1, { stringToBytes, tarHeaderChecksumMatches, uint32SyncSafeToken } = util, supported = supported$1, minimumBytes = 4100;
async function fromStream(Xn) {
  const zn = await strtok3.fromStream(Xn);
  try {
    return await fromTokenizer(zn);
  } finally {
    await zn.close();
  }
}
async function fromBuffer(Xn) {
  if (!(Xn instanceof Uint8Array || Xn instanceof ArrayBuffer || Buffer$1.isBuffer(Xn))) throw new TypeError(`Expected the \`input\` argument to be of type \`Uint8Array\` or \`Buffer\` or \`ArrayBuffer\`, got \`${typeof Xn}\``);
  const zn = Xn instanceof Buffer$1 ? Xn : Buffer$1.from(Xn);
  if (zn && zn.length > 1)
    return fromTokenizer(strtok3.fromBuffer(zn));
}
function _check(Xn, zn, Un) {
  Un = { offset: 0, ...Un };
  for (const [Kn, qn] of zn.entries()) if (Un.mask) {
    if (qn !== (Un.mask[Kn] & Xn[Kn + Un.offset])) return !1;
  } else if (qn !== Xn[Kn + Un.offset]) return !1;
  return !0;
}
async function fromTokenizer(Xn) {
  try {
    return _fromTokenizer(Xn);
  } catch (zn) {
    if (!(zn instanceof strtok3.EndOfStreamError)) throw zn;
  }
}
async function _fromTokenizer(Xn) {
  let zn = Buffer$1.alloc(minimumBytes);
  const Un = (qn, Jo) => _check(zn, qn, Jo), Kn = (qn, Jo) => Un(stringToBytes(qn), Jo);
  if (Xn.fileInfo.size || (Xn.fileInfo.size = Number.MAX_SAFE_INTEGER), await Xn.peekBuffer(zn, { length: 12, mayBeLess: !0 }), Un([66, 77])) return { ext: "bmp", mime: "image/bmp" };
  if (Un([11, 119])) return { ext: "ac3", mime: "audio/vnd.dolby.dd-raw" };
  if (Un([120, 1])) return { ext: "dmg", mime: "application/x-apple-diskimage" };
  if (Un([77, 90])) return { ext: "exe", mime: "application/x-msdownload" };
  if (Un([37, 33])) return await Xn.peekBuffer(zn, { length: 24, mayBeLess: !0 }), Kn("PS-Adobe-", { offset: 2 }) && Kn(" EPSF-", { offset: 14 }) ? { ext: "eps", mime: "application/eps" } : { ext: "ps", mime: "application/postscript" };
  if (Un([31, 160]) || Un([31, 157])) return { ext: "Z", mime: "application/x-compress" };
  if (Un([255, 216, 255])) return { ext: "jpg", mime: "image/jpeg" };
  if (Un([73, 73, 188])) return { ext: "jxr", mime: "image/vnd.ms-photo" };
  if (Un([31, 139, 8])) return { ext: "gz", mime: "application/gzip" };
  if (Un([66, 90, 104])) return { ext: "bz2", mime: "application/x-bzip2" };
  if (Kn("ID3")) {
    await Xn.ignore(6);
    const qn = await Xn.readToken(uint32SyncSafeToken);
    return Xn.position + qn > Xn.fileInfo.size ? { ext: "mp3", mime: "audio/mpeg" } : (await Xn.ignore(qn), fromTokenizer(Xn));
  }
  if (Kn("MP+")) return { ext: "mpc", mime: "audio/x-musepack" };
  if ((zn[0] === 67 || zn[0] === 70) && Un([87, 83], { offset: 1 })) return { ext: "swf", mime: "application/x-shockwave-flash" };
  if (Un([71, 73, 70])) return { ext: "gif", mime: "image/gif" };
  if (Kn("FLIF")) return { ext: "flif", mime: "image/flif" };
  if (Kn("8BPS")) return { ext: "psd", mime: "image/vnd.adobe.photoshop" };
  if (Kn("WEBP", { offset: 8 })) return { ext: "webp", mime: "image/webp" };
  if (Kn("MPCK")) return { ext: "mpc", mime: "audio/x-musepack" };
  if (Kn("FORM")) return { ext: "aif", mime: "audio/aiff" };
  if (Kn("icns", { offset: 0 })) return { ext: "icns", mime: "image/icns" };
  if (Un([80, 75, 3, 4])) {
    try {
      for (; Xn.position + 30 < Xn.fileInfo.size; ) {
        await Xn.readBuffer(zn, { length: 30 });
        const qn = { compressedSize: zn.readUInt32LE(18), uncompressedSize: zn.readUInt32LE(22), filenameLength: zn.readUInt16LE(26), extraFieldLength: zn.readUInt16LE(28) };
        if (qn.filename = await Xn.readToken(new Token.StringType(qn.filenameLength, "utf-8")), await Xn.ignore(qn.extraFieldLength), qn.filename === "META-INF/mozilla.rsa") return { ext: "xpi", mime: "application/x-xpinstall" };
        if (qn.filename.endsWith(".rels") || qn.filename.endsWith(".xml"))
          switch (qn.filename.split("/")[0]) {
            case "_rels":
            default:
              break;
            case "word":
              return { ext: "docx", mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" };
            case "ppt":
              return { ext: "pptx", mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation" };
            case "xl":
              return { ext: "xlsx", mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" };
          }
        if (qn.filename.startsWith("xl/")) return { ext: "xlsx", mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" };
        if (qn.filename.startsWith("3D/") && qn.filename.endsWith(".model")) return { ext: "3mf", mime: "model/3mf" };
        if (qn.filename === "mimetype" && qn.compressedSize === qn.uncompressedSize)
          switch (await Xn.readToken(new Token.StringType(qn.compressedSize, "utf-8"))) {
            case "application/epub+zip":
              return { ext: "epub", mime: "application/epub+zip" };
            case "application/vnd.oasis.opendocument.text":
              return { ext: "odt", mime: "application/vnd.oasis.opendocument.text" };
            case "application/vnd.oasis.opendocument.spreadsheet":
              return { ext: "ods", mime: "application/vnd.oasis.opendocument.spreadsheet" };
            case "application/vnd.oasis.opendocument.presentation":
              return { ext: "odp", mime: "application/vnd.oasis.opendocument.presentation" };
          }
        if (qn.compressedSize === 0) {
          let Jo = -1;
          for (; Jo < 0 && Xn.position < Xn.fileInfo.size; ) await Xn.peekBuffer(zn, { mayBeLess: !0 }), Jo = zn.indexOf("504B0304", 0, "hex"), await Xn.ignore(Jo >= 0 ? Jo : zn.length);
        } else await Xn.ignore(qn.compressedSize);
      }
    } catch (qn) {
      if (!(qn instanceof strtok3.EndOfStreamError)) throw qn;
    }
    return { ext: "zip", mime: "application/zip" };
  }
  if (Kn("OggS")) {
    await Xn.ignore(28);
    const qn = Buffer$1.alloc(8);
    return await Xn.readBuffer(qn), _check(qn, [79, 112, 117, 115, 72, 101, 97, 100]) ? { ext: "opus", mime: "audio/opus" } : _check(qn, [128, 116, 104, 101, 111, 114, 97]) ? { ext: "ogv", mime: "video/ogg" } : _check(qn, [1, 118, 105, 100, 101, 111, 0]) ? { ext: "ogm", mime: "video/ogg" } : _check(qn, [127, 70, 76, 65, 67]) ? { ext: "oga", mime: "audio/ogg" } : _check(qn, [83, 112, 101, 101, 120, 32, 32]) ? { ext: "spx", mime: "audio/ogg" } : _check(qn, [1, 118, 111, 114, 98, 105, 115]) ? { ext: "ogg", mime: "audio/ogg" } : { ext: "ogx", mime: "application/ogg" };
  }
  if (Un([80, 75]) && (zn[2] === 3 || zn[2] === 5 || zn[2] === 7) && (zn[3] === 4 || zn[3] === 6 || zn[3] === 8)) return { ext: "zip", mime: "application/zip" };
  if (Kn("ftyp", { offset: 4 }) && 96 & zn[8]) {
    const qn = zn.toString("binary", 8, 12).replace("\0", " ").trim();
    switch (qn) {
      case "avif":
        return { ext: "avif", mime: "image/avif" };
      case "mif1":
        return { ext: "heic", mime: "image/heif" };
      case "msf1":
        return { ext: "heic", mime: "image/heif-sequence" };
      case "heic":
      case "heix":
        return { ext: "heic", mime: "image/heic" };
      case "hevc":
      case "hevx":
        return { ext: "heic", mime: "image/heic-sequence" };
      case "qt":
        return { ext: "mov", mime: "video/quicktime" };
      case "M4V":
      case "M4VH":
      case "M4VP":
        return { ext: "m4v", mime: "video/x-m4v" };
      case "M4P":
        return { ext: "m4p", mime: "video/mp4" };
      case "M4B":
        return { ext: "m4b", mime: "audio/mp4" };
      case "M4A":
        return { ext: "m4a", mime: "audio/x-m4a" };
      case "F4V":
        return { ext: "f4v", mime: "video/mp4" };
      case "F4P":
        return { ext: "f4p", mime: "video/mp4" };
      case "F4A":
        return { ext: "f4a", mime: "audio/mp4" };
      case "F4B":
        return { ext: "f4b", mime: "audio/mp4" };
      case "crx":
        return { ext: "cr3", mime: "image/x-canon-cr3" };
      default:
        return qn.startsWith("3g") ? qn.startsWith("3g2") ? { ext: "3g2", mime: "video/3gpp2" } : { ext: "3gp", mime: "video/3gpp" } : { ext: "mp4", mime: "video/mp4" };
    }
  }
  if (Kn("MThd")) return { ext: "mid", mime: "audio/midi" };
  if (Kn("wOFF") && (Un([0, 1, 0, 0], { offset: 4 }) || Kn("OTTO", { offset: 4 }))) return { ext: "woff", mime: "font/woff" };
  if (Kn("wOF2") && (Un([0, 1, 0, 0], { offset: 4 }) || Kn("OTTO", { offset: 4 }))) return { ext: "woff2", mime: "font/woff2" };
  if (Un([212, 195, 178, 161]) || Un([161, 178, 195, 212])) return { ext: "pcap", mime: "application/vnd.tcpdump.pcap" };
  if (Kn("DSD ")) return { ext: "dsf", mime: "audio/x-dsf" };
  if (Kn("LZIP")) return { ext: "lz", mime: "application/x-lzip" };
  if (Kn("fLaC")) return { ext: "flac", mime: "audio/x-flac" };
  if (Un([66, 80, 71, 251])) return { ext: "bpg", mime: "image/bpg" };
  if (Kn("wvpk")) return { ext: "wv", mime: "audio/wavpack" };
  if (Kn("%PDF")) {
    await Xn.ignore(1350);
    const qn = 10485760, Jo = Buffer$1.alloc(Math.min(qn, Xn.fileInfo.size));
    return await Xn.readBuffer(Jo, { mayBeLess: !0 }), Jo.includes(Buffer$1.from("AIPrivateData")) ? { ext: "ai", mime: "application/postscript" } : { ext: "pdf", mime: "application/pdf" };
  }
  if (Un([0, 97, 115, 109])) return { ext: "wasm", mime: "application/wasm" };
  if (Un([73, 73, 42, 0])) return Kn("CR", { offset: 8 }) ? { ext: "cr2", mime: "image/x-canon-cr2" } : Un([28, 0, 254, 0], { offset: 8 }) || Un([31, 0, 11, 0], { offset: 8 }) ? { ext: "nef", mime: "image/x-nikon-nef" } : Un([8, 0, 0, 0], { offset: 4 }) && (Un([45, 0, 254, 0], { offset: 8 }) || Un([39, 0, 254, 0], { offset: 8 })) ? { ext: "dng", mime: "image/x-adobe-dng" } : (zn = Buffer$1.alloc(24), await Xn.peekBuffer(zn), (Un([16, 251, 134, 1], { offset: 4 }) || Un([8, 0, 0, 0], { offset: 4 })) && Un([0, 254, 0, 4, 0, 1, 0, 0, 0, 1, 0, 0, 0, 3, 1], { offset: 9 }) ? { ext: "arw", mime: "image/x-sony-arw" } : { ext: "tif", mime: "image/tiff" });
  if (Un([77, 77, 0, 42])) return { ext: "tif", mime: "image/tiff" };
  if (Kn("MAC ")) return { ext: "ape", mime: "audio/ape" };
  if (Un([26, 69, 223, 163])) {
    async function qn() {
      const va = await Xn.peekNumber(Token.UINT8);
      let ba = 128, _a = 0;
      for (; !(va & ba) && ba !== 0; ) ++_a, ba >>= 1;
      const ya = Buffer$1.alloc(_a + 1);
      return await Xn.readBuffer(ya), ya;
    }
    async function Jo() {
      const va = await qn(), ba = await qn();
      ba[0] ^= 128 >> ba.length - 1;
      const _a = Math.min(6, ba.length);
      return { id: va.readUIntBE(0, va.length), len: ba.readUIntBE(ba.length - _a, _a) };
    }
    async function pa(va, ba) {
      for (; ba > 0; ) {
        const _a = await Jo();
        if (_a.id === 17026) return Xn.readToken(new Token.StringType(_a.len, "utf-8"));
        await Xn.ignore(_a.len), --ba;
      }
    }
    const ma = await Jo();
    switch (await pa(0, ma.len)) {
      case "webm":
        return { ext: "webm", mime: "video/webm" };
      case "matroska":
        return { ext: "mkv", mime: "video/x-matroska" };
      default:
        return;
    }
  }
  if (Un([82, 73, 70, 70])) {
    if (Un([65, 86, 73], { offset: 8 })) return { ext: "avi", mime: "video/vnd.avi" };
    if (Un([87, 65, 86, 69], { offset: 8 })) return { ext: "wav", mime: "audio/vnd.wave" };
    if (Un([81, 76, 67, 77], { offset: 8 })) return { ext: "qcp", mime: "audio/qcelp" };
  }
  if (Kn("SQLi")) return { ext: "sqlite", mime: "application/x-sqlite3" };
  if (Un([78, 69, 83, 26])) return { ext: "nes", mime: "application/x-nintendo-nes-rom" };
  if (Kn("Cr24")) return { ext: "crx", mime: "application/x-google-chrome-extension" };
  if (Kn("MSCF") || Kn("ISc(")) return { ext: "cab", mime: "application/vnd.ms-cab-compressed" };
  if (Un([237, 171, 238, 219])) return { ext: "rpm", mime: "application/x-rpm" };
  if (Un([197, 208, 211, 198])) return { ext: "eps", mime: "application/eps" };
  if (Un([40, 181, 47, 253])) return { ext: "zst", mime: "application/zstd" };
  if (Un([79, 84, 84, 79, 0])) return { ext: "otf", mime: "font/otf" };
  if (Kn("#!AMR")) return { ext: "amr", mime: "audio/amr" };
  if (Kn("{\\rtf")) return { ext: "rtf", mime: "application/rtf" };
  if (Un([70, 76, 86, 1])) return { ext: "flv", mime: "video/x-flv" };
  if (Kn("IMPM")) return { ext: "it", mime: "audio/x-it" };
  if (Kn("-lh0-", { offset: 2 }) || Kn("-lh1-", { offset: 2 }) || Kn("-lh2-", { offset: 2 }) || Kn("-lh3-", { offset: 2 }) || Kn("-lh4-", { offset: 2 }) || Kn("-lh5-", { offset: 2 }) || Kn("-lh6-", { offset: 2 }) || Kn("-lh7-", { offset: 2 }) || Kn("-lzs-", { offset: 2 }) || Kn("-lz4-", { offset: 2 }) || Kn("-lz5-", { offset: 2 }) || Kn("-lhd-", { offset: 2 })) return { ext: "lzh", mime: "application/x-lzh-compressed" };
  if (Un([0, 0, 1, 186])) {
    if (Un([33], { offset: 4, mask: [241] })) return { ext: "mpg", mime: "video/MP1S" };
    if (Un([68], { offset: 4, mask: [196] })) return { ext: "mpg", mime: "video/MP2P" };
  }
  if (Kn("ITSF")) return { ext: "chm", mime: "application/vnd.ms-htmlhelp" };
  if (Un([253, 55, 122, 88, 90, 0])) return { ext: "xz", mime: "application/x-xz" };
  if (Kn("<?xml ")) return { ext: "xml", mime: "application/xml" };
  if (Un([55, 122, 188, 175, 39, 28])) return { ext: "7z", mime: "application/x-7z-compressed" };
  if (Un([82, 97, 114, 33, 26, 7]) && (zn[6] === 0 || zn[6] === 1)) return { ext: "rar", mime: "application/x-rar-compressed" };
  if (Kn("solid ")) return { ext: "stl", mime: "model/stl" };
  if (Kn("BLENDER")) return { ext: "blend", mime: "application/x-blender" };
  if (Kn("!<arch>"))
    return await Xn.ignore(8), await Xn.readToken(new Token.StringType(13, "ascii")) === "debian-binary" ? { ext: "deb", mime: "application/x-deb" } : { ext: "ar", mime: "application/x-unix-archive" };
  if (Un([137, 80, 78, 71, 13, 10, 26, 10])) {
    async function qn() {
      return { length: await Xn.readToken(Token.INT32_BE), type: await Xn.readToken(new Token.StringType(4, "binary")) };
    }
    await Xn.ignore(8);
    do {
      const Jo = await qn();
      if (Jo.length < 0) return;
      switch (Jo.type) {
        case "IDAT":
          return { ext: "png", mime: "image/png" };
        case "acTL":
          return { ext: "apng", mime: "image/apng" };
        default:
          await Xn.ignore(Jo.length + 4);
      }
    } while (Xn.position + 8 < Xn.fileInfo.size);
    return { ext: "png", mime: "image/png" };
  }
  if (Un([65, 82, 82, 79, 87, 49, 0, 0])) return { ext: "arrow", mime: "application/x-apache-arrow" };
  if (Un([103, 108, 84, 70, 2, 0, 0, 0])) return { ext: "glb", mime: "model/gltf-binary" };
  if (Un([102, 114, 101, 101], { offset: 4 }) || Un([109, 100, 97, 116], { offset: 4 }) || Un([109, 111, 111, 118], { offset: 4 }) || Un([119, 105, 100, 101], { offset: 4 })) return { ext: "mov", mime: "video/quicktime" };
  if (Un([73, 73, 82, 79, 8, 0, 0, 0, 24])) return { ext: "orf", mime: "image/x-olympus-orf" };
  if (Kn("gimp xcf ")) return { ext: "xcf", mime: "image/x-xcf" };
  if (Un([73, 73, 85, 0, 24, 0, 0, 0, 136, 231, 116, 216])) return { ext: "rw2", mime: "image/x-panasonic-rw2" };
  if (Un([48, 38, 178, 117, 142, 102, 207, 17, 166, 217])) {
    async function qn() {
      const Jo = Buffer$1.alloc(16);
      return await Xn.readBuffer(Jo), { id: Jo, size: Number(await Xn.readToken(Token.UINT64_LE)) };
    }
    for (await Xn.ignore(30); Xn.position + 24 < Xn.fileInfo.size; ) {
      const Jo = await qn();
      let pa = Jo.size - 24;
      if (_check(Jo.id, [145, 7, 220, 183, 183, 169, 207, 17, 142, 230, 0, 192, 12, 32, 83, 101])) {
        const ma = Buffer$1.alloc(16);
        if (pa -= await Xn.readBuffer(ma), _check(ma, [64, 158, 105, 248, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) return { ext: "asf", mime: "audio/x-ms-asf" };
        if (_check(ma, [192, 239, 25, 188, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) return { ext: "asf", mime: "video/x-ms-asf" };
        break;
      }
      await Xn.ignore(pa);
    }
    return { ext: "asf", mime: "application/vnd.ms-asf" };
  }
  if (Un([171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10])) return { ext: "ktx", mime: "image/ktx" };
  if ((Un([126, 16, 4]) || Un([126, 24, 4])) && Un([48, 77, 73, 69], { offset: 4 })) return { ext: "mie", mime: "application/x-mie" };
  if (Un([39, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], { offset: 2 })) return { ext: "shp", mime: "application/x-esri-shape" };
  if (Un([0, 0, 0, 12, 106, 80, 32, 32, 13, 10, 135, 10]))
    switch (await Xn.ignore(20), await Xn.readToken(new Token.StringType(4, "ascii"))) {
      case "jp2 ":
        return { ext: "jp2", mime: "image/jp2" };
      case "jpx ":
        return { ext: "jpx", mime: "image/jpx" };
      case "jpm ":
        return { ext: "jpm", mime: "image/jpm" };
      case "mjp2":
        return { ext: "mj2", mime: "image/mj2" };
      default:
        return;
    }
  if (Un([255, 10]) || Un([0, 0, 0, 12, 74, 88, 76, 32, 13, 10, 135, 10])) return { ext: "jxl", mime: "image/jxl" };
  if (Un([0, 0, 1, 186]) || Un([0, 0, 1, 179])) return { ext: "mpg", mime: "video/mpeg" };
  if (Un([0, 1, 0, 0, 0])) return { ext: "ttf", mime: "font/ttf" };
  if (Un([0, 0, 1, 0])) return { ext: "ico", mime: "image/x-icon" };
  if (Un([0, 0, 2, 0])) return { ext: "cur", mime: "image/x-icon" };
  if (Un([208, 207, 17, 224, 161, 177, 26, 225])) return { ext: "cfb", mime: "application/x-cfb" };
  if (await Xn.peekBuffer(zn, { length: Math.min(256, Xn.fileInfo.size), mayBeLess: !0 }), Kn("BEGIN:")) {
    if (Kn("VCARD", { offset: 6 })) return { ext: "vcf", mime: "text/vcard" };
    if (Kn("VCALENDAR", { offset: 6 })) return { ext: "ics", mime: "text/calendar" };
  }
  if (Kn("FUJIFILMCCD-RAW")) return { ext: "raf", mime: "image/x-fujifilm-raf" };
  if (Kn("Extended Module:")) return { ext: "xm", mime: "audio/x-xm" };
  if (Kn("Creative Voice File")) return { ext: "voc", mime: "audio/x-voc" };
  if (Un([4, 0, 0, 0]) && zn.length >= 16) {
    const qn = zn.readUInt32LE(12);
    if (qn > 12 && zn.length >= qn + 16) try {
      const Jo = zn.slice(16, qn + 16).toString();
      if (JSON.parse(Jo).files) return { ext: "asar", mime: "application/x-asar" };
    } catch {
    }
  }
  if (Un([6, 14, 43, 52, 2, 5, 1, 1, 13, 1, 2, 1, 1, 2])) return { ext: "mxf", mime: "application/mxf" };
  if (Kn("SCRM", { offset: 44 })) return { ext: "s3m", mime: "audio/x-s3m" };
  if (Un([71], { offset: 4 }) && (Un([71], { offset: 192 }) || Un([71], { offset: 196 }))) return { ext: "mts", mime: "video/mp2t" };
  if (Un([66, 79, 79, 75, 77, 79, 66, 73], { offset: 60 })) return { ext: "mobi", mime: "application/x-mobipocket-ebook" };
  if (Un([68, 73, 67, 77], { offset: 128 })) return { ext: "dcm", mime: "application/dicom" };
  if (Un([76, 0, 0, 0, 1, 20, 2, 0, 0, 0, 0, 0, 192, 0, 0, 0, 0, 0, 0, 70])) return { ext: "lnk", mime: "application/x.ms.shortcut" };
  if (Un([98, 111, 111, 107, 0, 0, 0, 0, 109, 97, 114, 107, 0, 0, 0, 0])) return { ext: "alias", mime: "application/x.apple.alias" };
  if (Un([76, 80], { offset: 34 }) && (Un([0, 0, 1], { offset: 8 }) || Un([1, 0, 2], { offset: 8 }) || Un([2, 0, 2], { offset: 8 }))) return { ext: "eot", mime: "application/vnd.ms-fontobject" };
  if (Un([6, 6, 237, 245, 216, 29, 70, 229, 189, 49, 239, 231, 254, 116, 183, 29])) return { ext: "indd", mime: "application/x-indesign" };
  if (await Xn.peekBuffer(zn, { length: Math.min(512, Xn.fileInfo.size), mayBeLess: !0 }), tarHeaderChecksumMatches(zn)) return { ext: "tar", mime: "application/x-tar" };
  if (Un([255, 254, 255, 14, 83, 0, 107, 0, 101, 0, 116, 0, 99, 0, 104, 0, 85, 0, 112, 0, 32, 0, 77, 0, 111, 0, 100, 0, 101, 0, 108, 0])) return { ext: "skp", mime: "application/vnd.sketchup.skp" };
  if (Kn("-----BEGIN PGP MESSAGE-----")) return { ext: "pgp", mime: "application/pgp-encrypted" };
  if (zn.length >= 2 && Un([255, 224], { offset: 0, mask: [255, 224] })) {
    if (Un([16], { offset: 1, mask: [22] })) return Un([8], { offset: 1, mask: [8] }), { ext: "aac", mime: "audio/aac" };
    if (Un([2], { offset: 1, mask: [6] })) return { ext: "mp3", mime: "audio/mpeg" };
    if (Un([4], { offset: 1, mask: [6] })) return { ext: "mp2", mime: "audio/mpeg" };
    if (Un([6], { offset: 1, mask: [6] })) return { ext: "mp1", mime: "audio/mpeg" };
  }
}
const stream$1 = (readableStream) => new Promise((resolve, reject) => {
  const stream = eval("require")("stream");
  readableStream.on("error", reject), readableStream.once("readable", async () => {
    const Xn = new stream.PassThrough();
    let zn;
    zn = stream.pipeline ? stream.pipeline(readableStream, Xn, () => {
    }) : readableStream.pipe(Xn);
    const Un = readableStream.read(minimumBytes) || readableStream.read() || Buffer$1.alloc(0);
    try {
      const Kn = await fromBuffer(Un);
      Xn.fileType = Kn;
    } catch (Kn) {
      reject(Kn);
    }
    resolve(zn);
  });
}), fileType = { fromStream, fromTokenizer, fromBuffer, stream: stream$1 };
Object.defineProperty(fileType, "extensions", { get: () => new Set(supported.extensions) }), Object.defineProperty(fileType, "mimeTypes", { get: () => new Set(supported.mimeTypes) });
var core = fileType, fileType$1 = getDefaultExportFromCjs(core);
function to(Xn, zn) {
  return Xn.then(function(Un) {
    return [null, Un];
  }).catch(function(Un) {
    return [Un, void 0];
  });
}
const writeFile = async () => {
  throw new Error("Not supported");
};
function Mime$1() {
  this._types = /* @__PURE__ */ Object.create(null), this._extensions = /* @__PURE__ */ Object.create(null);
  for (let Xn = 0; Xn < arguments.length; Xn++) this.define(arguments[Xn]);
  this.define = this.define.bind(this), this.getType = this.getType.bind(this), this.getExtension = this.getExtension.bind(this);
}
Mime$1.prototype.define = function(Xn, zn) {
  for (let Un in Xn) {
    let Kn = Xn[Un].map(function(qn) {
      return qn.toLowerCase();
    });
    Un = Un.toLowerCase();
    for (let qn = 0; qn < Kn.length; qn++) {
      const Jo = Kn[qn];
      if (Jo[0] !== "*") {
        if (!zn && Jo in this._types) throw new Error('Attempt to change mapping for "' + Jo + '" extension from "' + this._types[Jo] + '" to "' + Un + '". Pass `force=true` to allow this, otherwise remove "' + Jo + '" from the list of extensions for "' + Un + '".');
        this._types[Jo] = Un;
      }
    }
    if (zn || !this._extensions[Un]) {
      const qn = Kn[0];
      this._extensions[Un] = qn[0] !== "*" ? qn : qn.substr(1);
    }
  }
}, Mime$1.prototype.getType = function(Xn) {
  let zn = (Xn = String(Xn)).replace(/^.*[/\\]/, "").toLowerCase(), Un = zn.replace(/^.*\./, "").toLowerCase(), Kn = zn.length < Xn.length;
  return (Un.length < zn.length - 1 || !Kn) && this._types[Un] || null;
}, Mime$1.prototype.getExtension = function(Xn) {
  return (Xn = /^\s*([^;\s]*)/.test(Xn) && RegExp.$1) && this._extensions[Xn.toLowerCase()] || null;
};
var Mime_1 = Mime$1, standard = { "application/andrew-inset": ["ez"], "application/applixware": ["aw"], "application/atom+xml": ["atom"], "application/atomcat+xml": ["atomcat"], "application/atomdeleted+xml": ["atomdeleted"], "application/atomsvc+xml": ["atomsvc"], "application/atsc-dwd+xml": ["dwd"], "application/atsc-held+xml": ["held"], "application/atsc-rsat+xml": ["rsat"], "application/bdoc": ["bdoc"], "application/calendar+xml": ["xcs"], "application/ccxml+xml": ["ccxml"], "application/cdfx+xml": ["cdfx"], "application/cdmi-capability": ["cdmia"], "application/cdmi-container": ["cdmic"], "application/cdmi-domain": ["cdmid"], "application/cdmi-object": ["cdmio"], "application/cdmi-queue": ["cdmiq"], "application/cu-seeme": ["cu"], "application/dash+xml": ["mpd"], "application/davmount+xml": ["davmount"], "application/docbook+xml": ["dbk"], "application/dssc+der": ["dssc"], "application/dssc+xml": ["xdssc"], "application/ecmascript": ["es", "ecma"], "application/emma+xml": ["emma"], "application/emotionml+xml": ["emotionml"], "application/epub+zip": ["epub"], "application/exi": ["exi"], "application/express": ["exp"], "application/fdt+xml": ["fdt"], "application/font-tdpfr": ["pfr"], "application/geo+json": ["geojson"], "application/gml+xml": ["gml"], "application/gpx+xml": ["gpx"], "application/gxf": ["gxf"], "application/gzip": ["gz"], "application/hjson": ["hjson"], "application/hyperstudio": ["stk"], "application/inkml+xml": ["ink", "inkml"], "application/ipfix": ["ipfix"], "application/its+xml": ["its"], "application/java-archive": ["jar", "war", "ear"], "application/java-serialized-object": ["ser"], "application/java-vm": ["class"], "application/javascript": ["js", "mjs"], "application/json": ["json", "map"], "application/json5": ["json5"], "application/jsonml+json": ["jsonml"], "application/ld+json": ["jsonld"], "application/lgr+xml": ["lgr"], "application/lost+xml": ["lostxml"], "application/mac-binhex40": ["hqx"], "application/mac-compactpro": ["cpt"], "application/mads+xml": ["mads"], "application/manifest+json": ["webmanifest"], "application/marc": ["mrc"], "application/marcxml+xml": ["mrcx"], "application/mathematica": ["ma", "nb", "mb"], "application/mathml+xml": ["mathml"], "application/mbox": ["mbox"], "application/mediaservercontrol+xml": ["mscml"], "application/metalink+xml": ["metalink"], "application/metalink4+xml": ["meta4"], "application/mets+xml": ["mets"], "application/mmt-aei+xml": ["maei"], "application/mmt-usd+xml": ["musd"], "application/mods+xml": ["mods"], "application/mp21": ["m21", "mp21"], "application/mp4": ["mp4s", "m4p"], "application/msword": ["doc", "dot"], "application/mxf": ["mxf"], "application/n-quads": ["nq"], "application/n-triples": ["nt"], "application/node": ["cjs"], "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"], "application/oda": ["oda"], "application/oebps-package+xml": ["opf"], "application/ogg": ["ogx"], "application/omdoc+xml": ["omdoc"], "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"], "application/oxps": ["oxps"], "application/p2p-overlay+xml": ["relo"], "application/patch-ops-error+xml": ["xer"], "application/pdf": ["pdf"], "application/pgp-encrypted": ["pgp"], "application/pgp-signature": ["asc", "sig"], "application/pics-rules": ["prf"], "application/pkcs10": ["p10"], "application/pkcs7-mime": ["p7m", "p7c"], "application/pkcs7-signature": ["p7s"], "application/pkcs8": ["p8"], "application/pkix-attr-cert": ["ac"], "application/pkix-cert": ["cer"], "application/pkix-crl": ["crl"], "application/pkix-pkipath": ["pkipath"], "application/pkixcmp": ["pki"], "application/pls+xml": ["pls"], "application/postscript": ["ai", "eps", "ps"], "application/provenance+xml": ["provx"], "application/pskc+xml": ["pskcxml"], "application/raml+yaml": ["raml"], "application/rdf+xml": ["rdf", "owl"], "application/reginfo+xml": ["rif"], "application/relax-ng-compact-syntax": ["rnc"], "application/resource-lists+xml": ["rl"], "application/resource-lists-diff+xml": ["rld"], "application/rls-services+xml": ["rs"], "application/route-apd+xml": ["rapd"], "application/route-s-tsid+xml": ["sls"], "application/route-usd+xml": ["rusd"], "application/rpki-ghostbusters": ["gbr"], "application/rpki-manifest": ["mft"], "application/rpki-roa": ["roa"], "application/rsd+xml": ["rsd"], "application/rss+xml": ["rss"], "application/rtf": ["rtf"], "application/sbml+xml": ["sbml"], "application/scvp-cv-request": ["scq"], "application/scvp-cv-response": ["scs"], "application/scvp-vp-request": ["spq"], "application/scvp-vp-response": ["spp"], "application/sdp": ["sdp"], "application/senml+xml": ["senmlx"], "application/sensml+xml": ["sensmlx"], "application/set-payment-initiation": ["setpay"], "application/set-registration-initiation": ["setreg"], "application/shf+xml": ["shf"], "application/sieve": ["siv", "sieve"], "application/smil+xml": ["smi", "smil"], "application/sparql-query": ["rq"], "application/sparql-results+xml": ["srx"], "application/srgs": ["gram"], "application/srgs+xml": ["grxml"], "application/sru+xml": ["sru"], "application/ssdl+xml": ["ssdl"], "application/ssml+xml": ["ssml"], "application/swid+xml": ["swidtag"], "application/tei+xml": ["tei", "teicorpus"], "application/thraud+xml": ["tfi"], "application/timestamped-data": ["tsd"], "application/toml": ["toml"], "application/trig": ["trig"], "application/ttml+xml": ["ttml"], "application/ubjson": ["ubj"], "application/urc-ressheet+xml": ["rsheet"], "application/urc-targetdesc+xml": ["td"], "application/voicexml+xml": ["vxml"], "application/wasm": ["wasm"], "application/widget": ["wgt"], "application/winhlp": ["hlp"], "application/wsdl+xml": ["wsdl"], "application/wspolicy+xml": ["wspolicy"], "application/xaml+xml": ["xaml"], "application/xcap-att+xml": ["xav"], "application/xcap-caps+xml": ["xca"], "application/xcap-diff+xml": ["xdf"], "application/xcap-el+xml": ["xel"], "application/xcap-ns+xml": ["xns"], "application/xenc+xml": ["xenc"], "application/xhtml+xml": ["xhtml", "xht"], "application/xliff+xml": ["xlf"], "application/xml": ["xml", "xsl", "xsd", "rng"], "application/xml-dtd": ["dtd"], "application/xop+xml": ["xop"], "application/xproc+xml": ["xpl"], "application/xslt+xml": ["*xsl", "xslt"], "application/xspf+xml": ["xspf"], "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"], "application/yang": ["yang"], "application/yin+xml": ["yin"], "application/zip": ["zip"], "audio/3gpp": ["*3gpp"], "audio/adpcm": ["adp"], "audio/amr": ["amr"], "audio/basic": ["au", "snd"], "audio/midi": ["mid", "midi", "kar", "rmi"], "audio/mobile-xmf": ["mxmf"], "audio/mp3": ["*mp3"], "audio/mp4": ["m4a", "mp4a"], "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"], "audio/ogg": ["oga", "ogg", "spx", "opus"], "audio/s3m": ["s3m"], "audio/silk": ["sil"], "audio/wav": ["wav"], "audio/wave": ["*wav"], "audio/webm": ["weba"], "audio/xm": ["xm"], "font/collection": ["ttc"], "font/otf": ["otf"], "font/ttf": ["ttf"], "font/woff": ["woff"], "font/woff2": ["woff2"], "image/aces": ["exr"], "image/apng": ["apng"], "image/avif": ["avif"], "image/bmp": ["bmp"], "image/cgm": ["cgm"], "image/dicom-rle": ["drle"], "image/emf": ["emf"], "image/fits": ["fits"], "image/g3fax": ["g3"], "image/gif": ["gif"], "image/heic": ["heic"], "image/heic-sequence": ["heics"], "image/heif": ["heif"], "image/heif-sequence": ["heifs"], "image/hej2k": ["hej2"], "image/hsj2": ["hsj2"], "image/ief": ["ief"], "image/jls": ["jls"], "image/jp2": ["jp2", "jpg2"], "image/jpeg": ["jpeg", "jpg", "jpe"], "image/jph": ["jph"], "image/jphc": ["jhc"], "image/jpm": ["jpm"], "image/jpx": ["jpx", "jpf"], "image/jxr": ["jxr"], "image/jxra": ["jxra"], "image/jxrs": ["jxrs"], "image/jxs": ["jxs"], "image/jxsc": ["jxsc"], "image/jxsi": ["jxsi"], "image/jxss": ["jxss"], "image/ktx": ["ktx"], "image/ktx2": ["ktx2"], "image/png": ["png"], "image/sgi": ["sgi"], "image/svg+xml": ["svg", "svgz"], "image/t38": ["t38"], "image/tiff": ["tif", "tiff"], "image/tiff-fx": ["tfx"], "image/webp": ["webp"], "image/wmf": ["wmf"], "message/disposition-notification": ["disposition-notification"], "message/global": ["u8msg"], "message/global-delivery-status": ["u8dsn"], "message/global-disposition-notification": ["u8mdn"], "message/global-headers": ["u8hdr"], "message/rfc822": ["eml", "mime"], "model/3mf": ["3mf"], "model/gltf+json": ["gltf"], "model/gltf-binary": ["glb"], "model/iges": ["igs", "iges"], "model/mesh": ["msh", "mesh", "silo"], "model/mtl": ["mtl"], "model/obj": ["obj"], "model/step+xml": ["stpx"], "model/step+zip": ["stpz"], "model/step-xml+zip": ["stpxz"], "model/stl": ["stl"], "model/vrml": ["wrl", "vrml"], "model/x3d+binary": ["*x3db", "x3dbz"], "model/x3d+fastinfoset": ["x3db"], "model/x3d+vrml": ["*x3dv", "x3dvz"], "model/x3d+xml": ["x3d", "x3dz"], "model/x3d-vrml": ["x3dv"], "text/cache-manifest": ["appcache", "manifest"], "text/calendar": ["ics", "ifb"], "text/coffeescript": ["coffee", "litcoffee"], "text/css": ["css"], "text/csv": ["csv"], "text/html": ["html", "htm", "shtml"], "text/jade": ["jade"], "text/jsx": ["jsx"], "text/less": ["less"], "text/markdown": ["markdown", "md"], "text/mathml": ["mml"], "text/mdx": ["mdx"], "text/n3": ["n3"], "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"], "text/richtext": ["rtx"], "text/rtf": ["*rtf"], "text/sgml": ["sgml", "sgm"], "text/shex": ["shex"], "text/slim": ["slim", "slm"], "text/spdx": ["spdx"], "text/stylus": ["stylus", "styl"], "text/tab-separated-values": ["tsv"], "text/troff": ["t", "tr", "roff", "man", "me", "ms"], "text/turtle": ["ttl"], "text/uri-list": ["uri", "uris", "urls"], "text/vcard": ["vcard"], "text/vtt": ["vtt"], "text/xml": ["*xml"], "text/yaml": ["yaml", "yml"], "video/3gpp": ["3gp", "3gpp"], "video/3gpp2": ["3g2"], "video/h261": ["h261"], "video/h263": ["h263"], "video/h264": ["h264"], "video/iso.segment": ["m4s"], "video/jpeg": ["jpgv"], "video/jpm": ["*jpm", "jpgm"], "video/mj2": ["mj2", "mjp2"], "video/mp2t": ["ts"], "video/mp4": ["mp4", "mp4v", "mpg4"], "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"], "video/ogg": ["ogv"], "video/quicktime": ["qt", "mov"], "video/webm": ["webm"] };
let Mime = Mime_1;
var lite = new Mime(standard), mime = getDefaultExportFromCjs(lite), HorizontalAlign, HorizontalAlign2, VerticalAlign, VerticalAlign2, BlendMode$1, BlendMode2;
function srcOver(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a;
  return { r: (Xn.r * Xn.a + zn.r * zn.a * (1 - Xn.a)) / Kn, g: (Xn.g * Xn.a + zn.g * zn.a * (1 - Xn.a)) / Kn, b: (Xn.b * Xn.a + zn.b * zn.a * (1 - Xn.a)) / Kn, a: Kn };
}
function dstOver(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a;
  return { r: (zn.r * zn.a + Xn.r * Xn.a * (1 - zn.a)) / Kn, g: (zn.g * zn.a + Xn.g * Xn.a * (1 - zn.a)) / Kn, b: (zn.b * zn.a + Xn.b * Xn.a * (1 - zn.a)) / Kn, a: Kn };
}
function multiply(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (qn * ma + qn * (1 - zn.a) + ma * (1 - Xn.a)) / Kn, g: (Jo * va + Jo * (1 - zn.a) + va * (1 - Xn.a)) / Kn, b: (pa * ba + pa * (1 - zn.a) + ba * (1 - Xn.a)) / Kn, a: Kn };
}
function add(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a;
  return { r: (qn + zn.r * zn.a) / Kn, g: (Jo + zn.g * zn.a) / Kn, b: (pa + zn.b * zn.a) / Kn, a: Kn };
}
function screen(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (qn * zn.a + ma * Xn.a - qn * ma + qn * (1 - zn.a) + ma * (1 - Xn.a)) / Kn, g: (Jo * zn.a + va * Xn.a - Jo * va + Jo * (1 - zn.a) + va * (1 - Xn.a)) / Kn, b: (pa * zn.a + ba * Xn.a - pa * ba + pa * (1 - zn.a) + ba * (1 - Xn.a)) / Kn, a: Kn };
}
function overlay(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (2 * ma <= zn.a ? 2 * qn * ma + qn * (1 - zn.a) + ma * (1 - Xn.a) : qn * (1 + zn.a) + ma * (1 + Xn.a) - 2 * ma * qn - zn.a * Xn.a) / Kn, g: (2 * va <= zn.a ? 2 * Jo * va + Jo * (1 - zn.a) + va * (1 - Xn.a) : Jo * (1 + zn.a) + va * (1 + Xn.a) - 2 * va * Jo - zn.a * Xn.a) / Kn, b: (2 * ba <= zn.a ? 2 * pa * ba + pa * (1 - zn.a) + ba * (1 - Xn.a) : pa * (1 + zn.a) + ba * (1 + Xn.a) - 2 * ba * pa - zn.a * Xn.a) / Kn, a: Kn };
}
function darken(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (Math.min(qn * zn.a, ma * Xn.a) + qn * (1 - zn.a) + ma * (1 - Xn.a)) / Kn, g: (Math.min(Jo * zn.a, va * Xn.a) + Jo * (1 - zn.a) + va * (1 - Xn.a)) / Kn, b: (Math.min(pa * zn.a, ba * Xn.a) + pa * (1 - zn.a) + ba * (1 - Xn.a)) / Kn, a: Kn };
}
function lighten(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (Math.max(qn * zn.a, ma * Xn.a) + qn * (1 - zn.a) + ma * (1 - Xn.a)) / Kn, g: (Math.max(Jo * zn.a, va * Xn.a) + Jo * (1 - zn.a) + va * (1 - Xn.a)) / Kn, b: (Math.max(pa * zn.a, ba * Xn.a) + pa * (1 - zn.a) + ba * (1 - Xn.a)) / Kn, a: Kn };
}
function hardLight(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (2 * qn <= Xn.a ? 2 * qn * ma + qn * (1 - zn.a) + ma * (1 - Xn.a) : qn * (1 + zn.a) + ma * (1 + Xn.a) - 2 * ma * qn - zn.a * Xn.a) / Kn, g: (2 * Jo <= Xn.a ? 2 * Jo * va + Jo * (1 - zn.a) + va * (1 - Xn.a) : Jo * (1 + zn.a) + va * (1 + Xn.a) - 2 * va * Jo - zn.a * Xn.a) / Kn, b: (2 * pa <= Xn.a ? 2 * pa * ba + pa * (1 - zn.a) + ba * (1 - Xn.a) : pa * (1 + zn.a) + ba * (1 + Xn.a) - 2 * ba * pa - zn.a * Xn.a) / Kn, a: Kn };
}
function difference(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (qn + ma - 2 * Math.min(qn * zn.a, ma * Xn.a)) / Kn, g: (Jo + va - 2 * Math.min(Jo * zn.a, va * Xn.a)) / Kn, b: (pa + ba - 2 * Math.min(pa * zn.a, ba * Xn.a)) / Kn, a: Kn };
}
function exclusion(Xn, zn, Un = 1) {
  Xn.a *= Un;
  const Kn = zn.a + Xn.a - zn.a * Xn.a, qn = Xn.r * Xn.a, Jo = Xn.g * Xn.a, pa = Xn.b * Xn.a, ma = zn.r * zn.a, va = zn.g * zn.a, ba = zn.b * zn.a;
  return { r: (qn * zn.a + ma * Xn.a - 2 * qn * ma + qn * (1 - zn.a) + ma * (1 - Xn.a)) / Kn, g: (Jo * zn.a + va * Xn.a - 2 * Jo * va + Jo * (1 - zn.a) + va * (1 - Xn.a)) / Kn, b: (pa * zn.a + ba * Xn.a - 2 * pa * ba + pa * (1 - zn.a) + ba * (1 - Xn.a)) / Kn, a: Kn };
}
HorizontalAlign2 = HorizontalAlign || (HorizontalAlign = {}), HorizontalAlign2[HorizontalAlign2.LEFT = 1] = "LEFT", HorizontalAlign2[HorizontalAlign2.CENTER = 2] = "CENTER", HorizontalAlign2[HorizontalAlign2.RIGHT = 4] = "RIGHT", VerticalAlign2 = VerticalAlign || (VerticalAlign = {}), VerticalAlign2[VerticalAlign2.TOP = 8] = "TOP", VerticalAlign2[VerticalAlign2.MIDDLE = 16] = "MIDDLE", VerticalAlign2[VerticalAlign2.BOTTOM = 32] = "BOTTOM", BlendMode2 = BlendMode$1 || (BlendMode$1 = {}), BlendMode2.SRC_OVER = "srcOver", BlendMode2.DST_OVER = "dstOver", BlendMode2.MULTIPLY = "multiply", BlendMode2.ADD = "add", BlendMode2.SCREEN = "screen", BlendMode2.OVERLAY = "overlay", BlendMode2.DARKEN = "darken", BlendMode2.LIGHTEN = "lighten", BlendMode2.HARD_LIGHT = "hardLight", BlendMode2.DIFFERENCE = "difference", BlendMode2.EXCLUSION = "exclusion";
const names = [srcOver, dstOver, multiply, add, screen, overlay, darken, lighten, hardLight, difference, exclusion];
var compositeModes = Object.freeze({ __proto__: null, add, darken, difference, dstOver, exclusion, hardLight, lighten, multiply, names, overlay, screen, srcOver });
function composite(Xn, zn, Un = 0, Kn = 0, qn = {}) {
  if (!(zn instanceof Xn.constructor)) throw new Error("The source must be a Jimp image");
  if (typeof Un != "number" || typeof Kn != "number") throw new Error("x and y must be numbers");
  const { mode: Jo = BlendMode$1.SRC_OVER } = qn;
  let { opacitySource: pa = 1, opacityDest: ma = 1 } = qn;
  (typeof pa != "number" || pa < 0 || pa > 1) && (pa = 1), (typeof ma != "number" || ma < 0 || ma > 1) && (ma = 1);
  const va = compositeModes[Jo];
  return Un = Math.round(Un), Kn = Math.round(Kn), ma !== 1 && Xn.scan((ba, _a, ya) => {
    const xa = Xn.bitmap.data[ya + 3] * ma;
    Xn.bitmap.data[ya + 3] = xa;
  }), zn.scan((ba, _a, ya) => {
    const xa = Xn.getPixelIndex(Un + ba, Kn + _a, Edge.CROP);
    if (xa === -1) return;
    const wa = va({ r: zn.bitmap.data[ya + 0] / 255, g: zn.bitmap.data[ya + 1] / 255, b: zn.bitmap.data[ya + 2] / 255, a: zn.bitmap.data[ya + 3] / 255 }, { r: Xn.bitmap.data[xa + 0] / 255, g: Xn.bitmap.data[xa + 1] / 255, b: Xn.bitmap.data[xa + 2] / 255, a: Xn.bitmap.data[xa + 3] / 255 }, pa);
    Xn.bitmap.data[xa + 0] = limit255(255 * wa.r), Xn.bitmap.data[xa + 1] = limit255(255 * wa.g), Xn.bitmap.data[xa + 2] = limit255(255 * wa.b), Xn.bitmap.data[xa + 3] = limit255(255 * wa.a);
  }), Xn;
}
var jpeg$1 = { parseSections: function(Xn, zn) {
  var Un, Kn;
  for (Xn.setBigEndian(!0); Xn.remainingLength() > 0 && Kn !== 218; ) {
    if (Xn.nextUInt8() !== 255) throw new Error("Invalid JPEG section offset");
    Un = (Kn = Xn.nextUInt8()) >= 208 && Kn <= 217 || Kn === 218 ? 0 : Xn.nextUInt16() - 2, zn(Kn, Xn.branch(0, Un)), Xn.skip(Un);
  }
}, getSizeFromSOFSection: function(Xn) {
  return Xn.skip(1), { height: Xn.nextUInt16(), width: Xn.nextUInt16() };
}, getSectionName: function(Xn) {
  var zn, Un;
  switch (Xn) {
    case 216:
      zn = "SOI";
      break;
    case 196:
      zn = "DHT";
      break;
    case 219:
      zn = "DQT";
      break;
    case 221:
      zn = "DRI";
      break;
    case 218:
      zn = "SOS";
      break;
    case 254:
      zn = "COM";
      break;
    case 217:
      zn = "EOI";
      break;
    default:
      Xn >= 224 && Xn <= 239 ? (zn = "APP", Un = Xn - 224) : Xn >= 192 && Xn <= 207 && Xn !== 196 && Xn !== 200 && Xn !== 204 ? (zn = "SOF", Un = Xn - 192) : Xn >= 208 && Xn <= 215 && (zn = "RST", Un = Xn - 208);
  }
  var Kn = { name: zn };
  return typeof Un == "number" && (Kn.index = Un), Kn;
} };
function readExifValue(Xn, zn) {
  switch (Xn) {
    case 1:
      return zn.nextUInt8();
    case 3:
    case 8:
      return zn.nextUInt16();
    case 4:
    case 9:
      return zn.nextUInt32();
    case 5:
      return [zn.nextUInt32(), zn.nextUInt32()];
    case 6:
      return zn.nextInt8();
    case 10:
      return [zn.nextInt32(), zn.nextInt32()];
    case 11:
      return zn.nextFloat();
    case 12:
      return zn.nextDouble();
    default:
      throw new Error("Invalid format while decoding: " + Xn);
  }
}
function getBytesPerComponent(Xn) {
  switch (Xn) {
    case 1:
    case 2:
    case 6:
    case 7:
      return 1;
    case 3:
    case 8:
      return 2;
    case 4:
    case 9:
    case 11:
      return 4;
    case 5:
    case 10:
    case 12:
      return 8;
    default:
      return 0;
  }
}
function readExifTag(Xn, zn) {
  var Un, Kn, qn = zn.nextUInt16(), Jo = zn.nextUInt16(), pa = getBytesPerComponent(Jo), ma = zn.nextUInt32(), va = pa * ma;
  if (va > 4 && (zn = Xn.openWithOffset(zn.nextUInt32())), Jo === 2) {
    var ba = (Un = zn.nextString(ma)).indexOf("\0");
    ba !== -1 && (Un = Un.substr(0, ba));
  } else if (Jo === 7) Un = zn.nextBuffer(ma);
  else if (Jo !== 0) for (Un = [], Kn = 0; Kn < ma; ++Kn) Un.push(readExifValue(Jo, zn));
  return va < 4 && zn.skip(4 - va), [qn, Un, Jo];
}
function readIFDSection(Xn, zn, Un) {
  var Kn, qn, Jo = zn.nextUInt16();
  for (qn = 0; qn < Jo; ++qn) Un((Kn = readExifTag(Xn, zn))[0], Kn[1], Kn[2]);
}
function readHeader(Xn) {
  if (Xn.nextString(6) !== "Exif\0\0") throw new Error("Invalid EXIF header");
  var zn = Xn.mark(), Un = Xn.nextUInt16();
  if (Un === 18761) Xn.setBigEndian(!1);
  else {
    if (Un !== 19789) throw new Error("Invalid TIFF header");
    Xn.setBigEndian(!0);
  }
  if (Xn.nextUInt16() !== 42) throw new Error("Invalid TIFF data");
  return zn;
}
var exif$2 = { IFD0: 1, IFD1: 2, GPSIFD: 3, SubIFD: 4, InteropIFD: 5, parseTags: function(Xn, zn) {
  var Un, Kn, qn, Jo;
  try {
    Un = readHeader(Xn);
  } catch {
    return !1;
  }
  var pa = Un.openWithOffset(Xn.nextUInt32()), ma = this.IFD0;
  readIFDSection(Un, pa, function(Ta, Sa, Ma) {
    switch (Ta) {
      case 34853:
        qn = Sa[0];
        break;
      case 34665:
        Kn = Sa[0];
        break;
      default:
        zn(ma, Ta, Sa, Ma);
    }
  });
  var va = pa.nextUInt32();
  if (va !== 0) {
    var ba = Un.openWithOffset(va);
    readIFDSection(Un, ba, zn.bind(null, this.IFD1));
  }
  if (qn) {
    var _a = Un.openWithOffset(qn);
    readIFDSection(Un, _a, zn.bind(null, this.GPSIFD));
  }
  if (Kn) {
    var ya = Un.openWithOffset(Kn), xa = this.InteropIFD;
    readIFDSection(Un, ya, function(Ta, Sa, Ma) {
      Ta === 40965 ? Jo = Sa[0] : zn(xa, Ta, Sa, Ma);
    });
  }
  if (Jo) {
    var wa = Un.openWithOffset(Jo);
    readIFDSection(Un, wa, zn.bind(null, this.InteropIFD));
  }
  return !0;
} };
function parseNumber(Xn) {
  return parseInt(Xn, 10);
}
var hours = 3600, minutes = 60;
function parseDateTimeParts(Xn, zn) {
  Xn = Xn.map(parseNumber), zn = zn.map(parseNumber);
  var Un = Xn[0], Kn = Xn[1] - 1, qn = Xn[2], Jo = zn[0], pa = zn[1], ma = zn[2];
  return Date.UTC(Un, Kn, qn, Jo, pa, ma, 0) / 1e3;
}
function parseDateWithTimezoneFormat(Xn) {
  var zn = Xn.substr(0, 10).split("-"), Un = Xn.substr(11, 8).split(":"), Kn = Xn.substr(19, 6).split(":").map(parseNumber), qn = Kn[0] * hours + Kn[1] * minutes, Jo = parseDateTimeParts(zn, Un);
  if (typeof (Jo -= qn) == "number" && !isNaN(Jo)) return Jo;
}
function parseDateWithSpecFormat(Xn) {
  var zn = Xn.split(" "), Un = parseDateTimeParts(zn[0].split(":"), zn[1].split(":"));
  if (typeof Un == "number" && !isNaN(Un)) return Un;
}
function parseExifDate(Xn) {
  var zn = Xn.length === 19 && Xn.charAt(4) === ":";
  return Xn.length === 25 && Xn.charAt(10) === "T" ? parseDateWithTimezoneFormat(Xn) : zn ? parseDateWithSpecFormat(Xn) : void 0;
}
var date$1 = { parseDateWithSpecFormat, parseDateWithTimezoneFormat, parseExifDate }, exif$1 = exif$2, date = date$1, degreeTags = [{ section: exif$1.GPSIFD, type: 2, name: "GPSLatitude", refType: 1, refName: "GPSLatitudeRef", posVal: "N" }, { section: exif$1.GPSIFD, type: 4, name: "GPSLongitude", refType: 3, refName: "GPSLongitudeRef", posVal: "E" }], dateTags = [{ section: exif$1.SubIFD, type: 306, name: "ModifyDate" }, { section: exif$1.SubIFD, type: 36867, name: "DateTimeOriginal" }, { section: exif$1.SubIFD, type: 36868, name: "CreateDate" }, { section: exif$1.SubIFD, type: 306, name: "ModifyDate" }], simplify$1 = { castDegreeValues: function(Xn, zn) {
  degreeTags.forEach(function(Un) {
    var Kn = Xn(Un);
    if (Kn) {
      var qn = Xn({ section: Un.section, type: Un.refType, name: Un.refName }) === Un.posVal ? 1 : -1, Jo = (Kn[0] + Kn[1] / 60 + Kn[2] / 3600) * qn;
      zn(Un, Jo);
    }
  });
}, castDateValues: function(Xn, zn) {
  dateTags.forEach(function(Un) {
    var Kn = Xn(Un);
    if (Kn) {
      var qn = date.parseExifDate(Kn);
      qn !== void 0 && zn(Un, qn);
    }
  });
}, simplifyValue: function(Xn, zn) {
  return Array.isArray(Xn) && (Xn = Xn.map(function(Un) {
    return zn === 10 || zn === 5 ? Un[0] / Un[1] : Un;
  })).length === 1 && (Xn = Xn[0]), Xn;
} }, exifTags, hasRequiredExifTags;
function requireExifTags() {
  return hasRequiredExifTags ? exifTags : (hasRequiredExifTags = 1, exifTags = { exif: { 1: "InteropIndex", 2: "InteropVersion", 11: "ProcessingSoftware", 254: "SubfileType", 255: "OldSubfileType", 256: "ImageWidth", 257: "ImageHeight", 258: "BitsPerSample", 259: "Compression", 262: "PhotometricInterpretation", 263: "Thresholding", 264: "CellWidth", 265: "CellLength", 266: "FillOrder", 269: "DocumentName", 270: "ImageDescription", 271: "Make", 272: "Model", 273: "StripOffsets", 274: "Orientation", 277: "SamplesPerPixel", 278: "RowsPerStrip", 279: "StripByteCounts", 280: "MinSampleValue", 281: "MaxSampleValue", 282: "XResolution", 283: "YResolution", 284: "PlanarConfiguration", 285: "PageName", 286: "XPosition", 287: "YPosition", 288: "FreeOffsets", 289: "FreeByteCounts", 290: "GrayResponseUnit", 291: "GrayResponseCurve", 292: "T4Options", 293: "T6Options", 296: "ResolutionUnit", 297: "PageNumber", 300: "ColorResponseUnit", 301: "TransferFunction", 305: "Software", 306: "ModifyDate", 315: "Artist", 316: "HostComputer", 317: "Predictor", 318: "WhitePoint", 319: "PrimaryChromaticities", 320: "ColorMap", 321: "HalftoneHints", 322: "TileWidth", 323: "TileLength", 324: "TileOffsets", 325: "TileByteCounts", 326: "BadFaxLines", 327: "CleanFaxData", 328: "ConsecutiveBadFaxLines", 330: "SubIFD", 332: "InkSet", 333: "InkNames", 334: "NumberofInks", 336: "DotRange", 337: "TargetPrinter", 338: "ExtraSamples", 339: "SampleFormat", 340: "SMinSampleValue", 341: "SMaxSampleValue", 342: "TransferRange", 343: "ClipPath", 344: "XClipPathUnits", 345: "YClipPathUnits", 346: "Indexed", 347: "JPEGTables", 351: "OPIProxy", 400: "GlobalParametersIFD", 401: "ProfileType", 402: "FaxProfile", 403: "CodingMethods", 404: "VersionYear", 405: "ModeNumber", 433: "Decode", 434: "DefaultImageColor", 435: "T82Options", 437: "JPEGTables", 512: "JPEGProc", 513: "ThumbnailOffset", 514: "ThumbnailLength", 515: "JPEGRestartInterval", 517: "JPEGLosslessPredictors", 518: "JPEGPointTransforms", 519: "JPEGQTables", 520: "JPEGDCTables", 521: "JPEGACTables", 529: "YCbCrCoefficients", 530: "YCbCrSubSampling", 531: "YCbCrPositioning", 532: "ReferenceBlackWhite", 559: "StripRowCounts", 700: "ApplicationNotes", 999: "USPTOMiscellaneous", 4096: "RelatedImageFileFormat", 4097: "RelatedImageWidth", 4098: "RelatedImageHeight", 18246: "Rating", 18247: "XP_DIP_XML", 18248: "StitchInfo", 18249: "RatingPercent", 32781: "ImageID", 32931: "WangTag1", 32932: "WangAnnotation", 32933: "WangTag3", 32934: "WangTag4", 32995: "Matteing", 32996: "DataType", 32997: "ImageDepth", 32998: "TileDepth", 33405: "Model2", 33421: "CFARepeatPatternDim", 33422: "CFAPattern2", 33423: "BatteryLevel", 33424: "KodakIFD", 33432: "Copyright", 33434: "ExposureTime", 33437: "FNumber", 33445: "MDFileTag", 33446: "MDScalePixel", 33447: "MDColorTable", 33448: "MDLabName", 33449: "MDSampleInfo", 33450: "MDPrepDate", 33451: "MDPrepTime", 33452: "MDFileUnits", 33550: "PixelScale", 33589: "AdventScale", 33590: "AdventRevision", 33628: "UIC1Tag", 33629: "UIC2Tag", 33630: "UIC3Tag", 33631: "UIC4Tag", 33723: "IPTC-NAA", 33918: "IntergraphPacketData", 33919: "IntergraphFlagRegisters", 33920: "IntergraphMatrix", 33921: "INGRReserved", 33922: "ModelTiePoint", 34016: "Site", 34017: "ColorSequence", 34018: "IT8Header", 34019: "RasterPadding", 34020: "BitsPerRunLength", 34021: "BitsPerExtendedRunLength", 34022: "ColorTable", 34023: "ImageColorIndicator", 34024: "BackgroundColorIndicator", 34025: "ImageColorValue", 34026: "BackgroundColorValue", 34027: "PixelIntensityRange", 34028: "TransparencyIndicator", 34029: "ColorCharacterization", 34030: "HCUsage", 34031: "TrapIndicator", 34032: "CMYKEquivalent", 34118: "SEMInfo", 34152: "AFCP_IPTC", 34232: "PixelMagicJBIGOptions", 34264: "ModelTransform", 34306: "WB_GRGBLevels", 34310: "LeafData", 34377: "PhotoshopSettings", 34665: "ExifOffset", 34675: "ICC_Profile", 34687: "TIFF_FXExtensions", 34688: "MultiProfiles", 34689: "SharedData", 34690: "T88Options", 34732: "ImageLayer", 34735: "GeoTiffDirectory", 34736: "GeoTiffDoubleParams", 34737: "GeoTiffAsciiParams", 34850: "ExposureProgram", 34852: "SpectralSensitivity", 34853: "GPSInfo", 34855: "ISO", 34856: "Opto-ElectricConvFactor", 34857: "Interlace", 34858: "TimeZoneOffset", 34859: "SelfTimerMode", 34864: "SensitivityType", 34865: "StandardOutputSensitivity", 34866: "RecommendedExposureIndex", 34867: "ISOSpeed", 34868: "ISOSpeedLatitudeyyy", 34869: "ISOSpeedLatitudezzz", 34908: "FaxRecvParams", 34909: "FaxSubAddress", 34910: "FaxRecvTime", 34954: "LeafSubIFD", 36864: "ExifVersion", 36867: "DateTimeOriginal", 36868: "CreateDate", 37121: "ComponentsConfiguration", 37122: "CompressedBitsPerPixel", 37377: "ShutterSpeedValue", 37378: "ApertureValue", 37379: "BrightnessValue", 37380: "ExposureCompensation", 37381: "MaxApertureValue", 37382: "SubjectDistance", 37383: "MeteringMode", 37384: "LightSource", 37385: "Flash", 37386: "FocalLength", 37387: "FlashEnergy", 37388: "SpatialFrequencyResponse", 37389: "Noise", 37390: "FocalPlaneXResolution", 37391: "FocalPlaneYResolution", 37392: "FocalPlaneResolutionUnit", 37393: "ImageNumber", 37394: "SecurityClassification", 37395: "ImageHistory", 37396: "SubjectArea", 37397: "ExposureIndex", 37398: "TIFF-EPStandardID", 37399: "SensingMethod", 37434: "CIP3DataFile", 37435: "CIP3Sheet", 37436: "CIP3Side", 37439: "StoNits", 37500: "MakerNote", 37510: "UserComment", 37520: "SubSecTime", 37521: "SubSecTimeOriginal", 37522: "SubSecTimeDigitized", 37679: "MSDocumentText", 37680: "MSPropertySetStorage", 37681: "MSDocumentTextPosition", 37724: "ImageSourceData", 40091: "XPTitle", 40092: "XPComment", 40093: "XPAuthor", 40094: "XPKeywords", 40095: "XPSubject", 40960: "FlashpixVersion", 40961: "ColorSpace", 40962: "ExifImageWidth", 40963: "ExifImageHeight", 40964: "RelatedSoundFile", 40965: "InteropOffset", 41483: "FlashEnergy", 41484: "SpatialFrequencyResponse", 41485: "Noise", 41486: "FocalPlaneXResolution", 41487: "FocalPlaneYResolution", 41488: "FocalPlaneResolutionUnit", 41489: "ImageNumber", 41490: "SecurityClassification", 41491: "ImageHistory", 41492: "SubjectLocation", 41493: "ExposureIndex", 41494: "TIFF-EPStandardID", 41495: "SensingMethod", 41728: "FileSource", 41729: "SceneType", 41730: "CFAPattern", 41985: "CustomRendered", 41986: "ExposureMode", 41987: "WhiteBalance", 41988: "DigitalZoomRatio", 41989: "FocalLengthIn35mmFormat", 41990: "SceneCaptureType", 41991: "GainControl", 41992: "Contrast", 41993: "Saturation", 41994: "Sharpness", 41995: "DeviceSettingDescription", 41996: "SubjectDistanceRange", 42016: "ImageUniqueID", 42032: "OwnerName", 42033: "SerialNumber", 42034: "LensInfo", 42035: "LensMake", 42036: "LensModel", 42037: "LensSerialNumber", 42112: "GDALMetadata", 42113: "GDALNoData", 42240: "Gamma", 44992: "ExpandSoftware", 44993: "ExpandLens", 44994: "ExpandFilm", 44995: "ExpandFilterLens", 44996: "ExpandScanner", 44997: "ExpandFlashLamp", 48129: "PixelFormat", 48130: "Transformation", 48131: "Uncompressed", 48132: "ImageType", 48256: "ImageWidth", 48257: "ImageHeight", 48258: "WidthResolution", 48259: "HeightResolution", 48320: "ImageOffset", 48321: "ImageByteCount", 48322: "AlphaOffset", 48323: "AlphaByteCount", 48324: "ImageDataDiscard", 48325: "AlphaDataDiscard", 50215: "OceScanjobDesc", 50216: "OceApplicationSelector", 50217: "OceIDNumber", 50218: "OceImageLogic", 50255: "Annotations", 50341: "PrintIM", 50560: "USPTOOriginalContentType", 50706: "DNGVersion", 50707: "DNGBackwardVersion", 50708: "UniqueCameraModel", 50709: "LocalizedCameraModel", 50710: "CFAPlaneColor", 50711: "CFALayout", 50712: "LinearizationTable", 50713: "BlackLevelRepeatDim", 50714: "BlackLevel", 50715: "BlackLevelDeltaH", 50716: "BlackLevelDeltaV", 50717: "WhiteLevel", 50718: "DefaultScale", 50719: "DefaultCropOrigin", 50720: "DefaultCropSize", 50721: "ColorMatrix1", 50722: "ColorMatrix2", 50723: "CameraCalibration1", 50724: "CameraCalibration2", 50725: "ReductionMatrix1", 50726: "ReductionMatrix2", 50727: "AnalogBalance", 50728: "AsShotNeutral", 50729: "AsShotWhiteXY", 50730: "BaselineExposure", 50731: "BaselineNoise", 50732: "BaselineSharpness", 50733: "BayerGreenSplit", 50734: "LinearResponseLimit", 50735: "CameraSerialNumber", 50736: "DNGLensInfo", 50737: "ChromaBlurRadius", 50738: "AntiAliasStrength", 50739: "ShadowScale", 50740: "DNGPrivateData", 50741: "MakerNoteSafety", 50752: "RawImageSegmentation", 50778: "CalibrationIlluminant1", 50779: "CalibrationIlluminant2", 50780: "BestQualityScale", 50781: "RawDataUniqueID", 50784: "AliasLayerMetadata", 50827: "OriginalRawFileName", 50828: "OriginalRawFileData", 50829: "ActiveArea", 50830: "MaskedAreas", 50831: "AsShotICCProfile", 50832: "AsShotPreProfileMatrix", 50833: "CurrentICCProfile", 50834: "CurrentPreProfileMatrix", 50879: "ColorimetricReference", 50898: "PanasonicTitle", 50899: "PanasonicTitle2", 50931: "CameraCalibrationSig", 50932: "ProfileCalibrationSig", 50933: "ProfileIFD", 50934: "AsShotProfileName", 50935: "NoiseReductionApplied", 50936: "ProfileName", 50937: "ProfileHueSatMapDims", 50938: "ProfileHueSatMapData1", 50939: "ProfileHueSatMapData2", 50940: "ProfileToneCurve", 50941: "ProfileEmbedPolicy", 50942: "ProfileCopyright", 50964: "ForwardMatrix1", 50965: "ForwardMatrix2", 50966: "PreviewApplicationName", 50967: "PreviewApplicationVersion", 50968: "PreviewSettingsName", 50969: "PreviewSettingsDigest", 50970: "PreviewColorSpace", 50971: "PreviewDateTime", 50972: "RawImageDigest", 50973: "OriginalRawFileDigest", 50974: "SubTileBlockSize", 50975: "RowInterleaveFactor", 50981: "ProfileLookTableDims", 50982: "ProfileLookTableData", 51008: "OpcodeList1", 51009: "OpcodeList2", 51022: "OpcodeList3", 51041: "NoiseProfile", 51043: "TimeCodes", 51044: "FrameRate", 51058: "TStop", 51081: "ReelName", 51089: "OriginalDefaultFinalSize", 51090: "OriginalBestQualitySize", 51091: "OriginalDefaultCropSize", 51105: "CameraLabel", 51107: "ProfileHueSatMapEncoding", 51108: "ProfileLookTableEncoding", 51109: "BaselineExposureOffset", 51110: "DefaultBlackRender", 51111: "NewRawImageDigest", 51112: "RawToPreviewGain", 51125: "DefaultUserCrop", 59932: "Padding", 59933: "OffsetSchema", 65e3: "OwnerName", 65001: "SerialNumber", 65002: "Lens", 65024: "KDC_IFD", 65100: "RawFile", 65101: "Converter", 65102: "WhiteBalance", 65105: "Exposure", 65106: "Shadows", 65107: "Brightness", 65108: "Contrast", 65109: "Saturation", 65110: "Sharpness", 65111: "Smoothness", 65112: "MoireFilter" }, gps: { 0: "GPSVersionID", 1: "GPSLatitudeRef", 2: "GPSLatitude", 3: "GPSLongitudeRef", 4: "GPSLongitude", 5: "GPSAltitudeRef", 6: "GPSAltitude", 7: "GPSTimeStamp", 8: "GPSSatellites", 9: "GPSStatus", 10: "GPSMeasureMode", 11: "GPSDOP", 12: "GPSSpeedRef", 13: "GPSSpeed", 14: "GPSTrackRef", 15: "GPSTrack", 16: "GPSImgDirectionRef", 17: "GPSImgDirection", 18: "GPSMapDatum", 19: "GPSDestLatitudeRef", 20: "GPSDestLatitude", 21: "GPSDestLongitudeRef", 22: "GPSDestLongitude", 23: "GPSDestBearingRef", 24: "GPSDestBearing", 25: "GPSDestDistanceRef", 26: "GPSDestDistance", 27: "GPSProcessingMethod", 28: "GPSAreaInformation", 29: "GPSDateStamp", 30: "GPSDifferential", 31: "GPSHPositioningError" } });
}
var jpeg = jpeg$1, exif = exif$2, simplify = simplify$1;
function ExifResult(Xn, zn, Un, Kn, qn, Jo, pa) {
  this.startMarker = Xn, this.tags = zn, this.imageSize = Un, this.thumbnailOffset = Kn, this.thumbnailLength = qn, this.thumbnailType = Jo, this.app1Offset = pa;
}
function Parser$1(Xn) {
  this.stream = Xn, this.flags = { readBinaryTags: !1, resolveTagNames: !0, simplifyValues: !0, imageSize: !0, hidePointers: !0, returnTags: !0 };
}
ExifResult.prototype = { hasThumbnail: function(Xn) {
  return !(!this.thumbnailOffset || !this.thumbnailLength) && (typeof Xn != "string" || (Xn.toLowerCase().trim() === "image/jpeg" ? this.thumbnailType === 6 : Xn.toLowerCase().trim() === "image/tiff" && this.thumbnailType === 1));
}, getThumbnailOffset: function() {
  return this.app1Offset + 6 + this.thumbnailOffset;
}, getThumbnailLength: function() {
  return this.thumbnailLength;
}, getThumbnailBuffer: function() {
  return this._getThumbnailStream().nextBuffer(this.thumbnailLength);
}, _getThumbnailStream: function() {
  return this.startMarker.openWithOffset(this.getThumbnailOffset());
}, getImageSize: function() {
  return this.imageSize;
}, getThumbnailSize: function() {
  var Xn, zn = this._getThumbnailStream();
  return jpeg.parseSections(zn, function(Un, Kn) {
    jpeg.getSectionName(Un).name === "SOF" && (Xn = jpeg.getSizeFromSOFSection(Kn));
  }), Xn;
} }, Parser$1.prototype = { enableBinaryFields: function(Xn) {
  return this.flags.readBinaryTags = !!Xn, this;
}, enablePointers: function(Xn) {
  return this.flags.hidePointers = !Xn, this;
}, enableTagNames: function(Xn) {
  return this.flags.resolveTagNames = !!Xn, this;
}, enableImageSize: function(Xn) {
  return this.flags.imageSize = !!Xn, this;
}, enableReturnTags: function(Xn) {
  return this.flags.returnTags = !!Xn, this;
}, enableSimpleValues: function(Xn) {
  return this.flags.simplifyValues = !!Xn, this;
}, parse: function() {
  var Xn, zn, Un, Kn, qn, Jo, pa, ma, va, ba = this.stream.mark(), _a = ba.openWithOffset(0), ya = this.flags;
  return ya.resolveTagNames && (pa = requireExifTags()), ya.resolveTagNames ? (Xn = {}, ma = function(xa) {
    return Xn[xa.name];
  }, va = function(xa, wa) {
    Xn[xa.name] = wa;
  }) : (Xn = [], ma = function(xa) {
    var wa;
    for (wa = 0; wa < Xn.length; ++wa) if (Xn[wa].type === xa.type && Xn[wa].section === xa.section) return Xn.value;
  }, va = function(xa, wa) {
    var Ta;
    for (Ta = 0; Ta < Xn.length; ++Ta) if (Xn[Ta].type === xa.type && Xn[Ta].section === xa.section) return void (Xn.value = wa);
  }), jpeg.parseSections(_a, function(xa, wa) {
    var Ta = wa.offsetFrom(ba);
    xa === 225 ? exif.parseTags(wa, function(Sa, Ma, ka, Za) {
      if (ya.readBinaryTags || Za !== 7) {
        if (Ma === 513) {
          if (Un = ka[0], ya.hidePointers) return;
        } else if (Ma === 514) {
          if (Kn = ka[0], ya.hidePointers) return;
        } else if (Ma === 259 && (qn = ka[0], ya.hidePointers)) return;
        if (ya.returnTags) if (ya.simplifyValues && (ka = simplify.simplifyValue(ka, Za)), ya.resolveTagNames) {
          var Na = (Sa === exif.GPSIFD ? pa.gps : pa.exif)[Ma];
          Na || (Na = pa.exif[Ma]), Xn.hasOwnProperty(Na) || (Xn[Na] = ka);
        } else Xn.push({ section: Sa, type: Ma, value: ka });
      }
    }) && (Jo = Ta) : ya.imageSize && jpeg.getSectionName(xa).name === "SOF" && (zn = jpeg.getSizeFromSOFSection(wa));
  }), ya.simplifyValues && (simplify.castDegreeValues(ma, va), simplify.castDateValues(ma, va)), new ExifResult(ba, Xn, zn, Un, Kn, qn, Jo);
} };
var parser = Parser$1, domBufferstream, hasRequiredDomBufferstream, bufferstream, hasRequiredBufferstream;
function requireDomBufferstream() {
  if (hasRequiredDomBufferstream) return domBufferstream;
  function Xn(zn, Un, Kn, qn, Jo, pa) {
    this.global = Jo, Un = Un || 0, Kn = Kn || zn.byteLength - Un, this.arrayBuffer = zn.slice(Un, Un + Kn), this.view = new Jo.DataView(this.arrayBuffer, 0, this.arrayBuffer.byteLength), this.setBigEndian(qn), this.offset = 0, this.parentOffset = (pa || 0) + Un;
  }
  return hasRequiredDomBufferstream = 1, Xn.prototype = { setBigEndian: function(zn) {
    this.littleEndian = !zn;
  }, nextUInt8: function() {
    var zn = this.view.getUint8(this.offset);
    return this.offset += 1, zn;
  }, nextInt8: function() {
    var zn = this.view.getInt8(this.offset);
    return this.offset += 1, zn;
  }, nextUInt16: function() {
    var zn = this.view.getUint16(this.offset, this.littleEndian);
    return this.offset += 2, zn;
  }, nextUInt32: function() {
    var zn = this.view.getUint32(this.offset, this.littleEndian);
    return this.offset += 4, zn;
  }, nextInt16: function() {
    var zn = this.view.getInt16(this.offset, this.littleEndian);
    return this.offset += 2, zn;
  }, nextInt32: function() {
    var zn = this.view.getInt32(this.offset, this.littleEndian);
    return this.offset += 4, zn;
  }, nextFloat: function() {
    var zn = this.view.getFloat32(this.offset, this.littleEndian);
    return this.offset += 4, zn;
  }, nextDouble: function() {
    var zn = this.view.getFloat64(this.offset, this.littleEndian);
    return this.offset += 8, zn;
  }, nextBuffer: function(zn) {
    var Un = this.arrayBuffer.slice(this.offset, this.offset + zn);
    return this.offset += zn, Un;
  }, remainingLength: function() {
    return this.arrayBuffer.byteLength - this.offset;
  }, nextString: function(zn) {
    var Un = this.arrayBuffer.slice(this.offset, this.offset + zn);
    return Un = String.fromCharCode.apply(null, new this.global.Uint8Array(Un)), this.offset += zn, Un;
  }, mark: function() {
    var zn = this;
    return { openWithOffset: function(Un) {
      return Un = (Un || 0) + this.offset, new Xn(zn.arrayBuffer, Un, zn.arrayBuffer.byteLength - Un, !zn.littleEndian, zn.global, zn.parentOffset);
    }, offset: this.offset, getParentOffset: function() {
      return zn.parentOffset;
    } };
  }, offsetFrom: function(zn) {
    return this.parentOffset + this.offset - (zn.offset + zn.getParentOffset());
  }, skip: function(zn) {
    this.offset += zn;
  }, branch: function(zn, Un) {
    return Un = typeof Un == "number" ? Un : this.arrayBuffer.byteLength - (this.offset + zn), new Xn(this.arrayBuffer, this.offset + zn, Un, !this.littleEndian, this.global, this.parentOffset);
  } }, domBufferstream = Xn;
}
function requireBufferstream() {
  if (hasRequiredBufferstream) return bufferstream;
  function Xn(zn, Un, Kn, qn) {
    this.buffer = zn, this.offset = Un || 0, Kn = typeof Kn == "number" ? Kn : zn.length, this.endPosition = this.offset + Kn, this.setBigEndian(qn);
  }
  return hasRequiredBufferstream = 1, Xn.prototype = { setBigEndian: function(zn) {
    this.bigEndian = !!zn;
  }, nextUInt8: function() {
    var zn = this.buffer.readUInt8(this.offset);
    return this.offset += 1, zn;
  }, nextInt8: function() {
    var zn = this.buffer.readInt8(this.offset);
    return this.offset += 1, zn;
  }, nextUInt16: function() {
    var zn = this.bigEndian ? this.buffer.readUInt16BE(this.offset) : this.buffer.readUInt16LE(this.offset);
    return this.offset += 2, zn;
  }, nextUInt32: function() {
    var zn = this.bigEndian ? this.buffer.readUInt32BE(this.offset) : this.buffer.readUInt32LE(this.offset);
    return this.offset += 4, zn;
  }, nextInt16: function() {
    var zn = this.bigEndian ? this.buffer.readInt16BE(this.offset) : this.buffer.readInt16LE(this.offset);
    return this.offset += 2, zn;
  }, nextInt32: function() {
    var zn = this.bigEndian ? this.buffer.readInt32BE(this.offset) : this.buffer.readInt32LE(this.offset);
    return this.offset += 4, zn;
  }, nextFloat: function() {
    var zn = this.bigEndian ? this.buffer.readFloatBE(this.offset) : this.buffer.readFloatLE(this.offset);
    return this.offset += 4, zn;
  }, nextDouble: function() {
    var zn = this.bigEndian ? this.buffer.readDoubleBE(this.offset) : this.buffer.readDoubleLE(this.offset);
    return this.offset += 8, zn;
  }, nextBuffer: function(zn) {
    var Un = this.buffer.slice(this.offset, this.offset + zn);
    return this.offset += zn, Un;
  }, remainingLength: function() {
    return this.endPosition - this.offset;
  }, nextString: function(zn) {
    var Un = this.buffer.toString("utf8", this.offset, this.offset + zn);
    return this.offset += zn, Un;
  }, mark: function() {
    var zn = this;
    return { openWithOffset: function(Un) {
      return Un = (Un || 0) + this.offset, new Xn(zn.buffer, Un, zn.endPosition - Un, zn.bigEndian);
    }, offset: this.offset };
  }, offsetFrom: function(zn) {
    return this.offset - zn.offset;
  }, skip: function(zn) {
    this.offset += zn;
  }, branch: function(zn, Un) {
    return Un = typeof Un == "number" ? Un : this.endPosition - (this.offset + zn), new Xn(this.buffer, this.offset + zn, Un, this.bigEndian);
  } }, bufferstream = Xn;
}
var Parser = parser;
function getGlobal() {
  return (0, eval)("this");
}
var exifParser = { create: function(Xn, zn) {
  if (Xn instanceof (zn = zn || getGlobal()).ArrayBuffer) {
    var Un = requireDomBufferstream();
    return new Parser(new Un(Xn, 0, Xn.byteLength, !0, zn));
  }
  var Kn = requireBufferstream();
  return new Parser(new Kn(Xn, 0, Xn.length, !0));
} }, EXIFParser = getDefaultExportFromCjs(exifParser);
function getExifOrientation(Xn) {
  const zn = Xn._exif;
  return zn && zn.tags && zn.tags.Orientation || 1;
}
function getExifOrientationTransformation(Xn) {
  const zn = Xn.bitmap.width, Un = Xn.bitmap.height;
  switch (getExifOrientation(Xn)) {
    case 1:
    default:
      return null;
    case 2:
      return function(Kn, qn) {
        return [zn - Kn - 1, qn];
      };
    case 3:
      return function(Kn, qn) {
        return [zn - Kn - 1, Un - qn - 1];
      };
    case 4:
      return function(Kn, qn) {
        return [Kn, Un - qn - 1];
      };
    case 5:
      return function(Kn, qn) {
        return [qn, Kn];
      };
    case 6:
      return function(Kn, qn) {
        return [qn, Un - Kn - 1];
      };
    case 7:
      return function(Kn, qn) {
        return [zn - qn - 1, Un - Kn - 1];
      };
    case 8:
      return function(Kn, qn) {
        return [zn - qn - 1, Kn];
      };
  }
}
function transformBitmap(Xn, zn, Un, Kn) {
  const qn = Xn.bitmap.data, Jo = Xn.bitmap.width, pa = Buffer$1.alloc(qn.length);
  for (let ma = 0; ma < zn; ma++) for (let va = 0; va < Un; va++) {
    const [ba, _a] = Kn(ma, va), ya = zn * va + ma << 2, xa = Jo * _a + ba << 2, wa = qn.readUInt32BE(xa);
    pa.writeUInt32BE(wa, ya);
  }
  Xn.bitmap.data = pa, Xn.bitmap.width = zn, Xn.bitmap.height = Un, Xn._exif.tags.Orientation = 1;
}
function exifRotate(Xn) {
  if (getExifOrientation(Xn) < 2) return;
  const zn = getExifOrientationTransformation(Xn), Un = getExifOrientation(Xn) > 4, Kn = Un ? Xn.bitmap.height : Xn.bitmap.width, qn = Un ? Xn.bitmap.width : Xn.bitmap.height;
  zn && transformBitmap(Xn, Kn, qn, zn);
}
async function attemptExifRotate(Xn, zn) {
  try {
    Xn._exif = EXIFParser.create(zn).parse(), exifRotate(Xn);
  } catch {
  }
}
var __defProp$2 = Object.defineProperty, __defNormalProp$2 = (Xn, zn, Un) => zn in Xn ? __defProp$2(Xn, zn, { enumerable: !0, configurable: !0, writable: !0, value: Un }) : Xn[zn] = Un, __publicField$2 = (Xn, zn, Un) => __defNormalProp$2(Xn, typeof zn != "symbol" ? zn + "" : zn, Un);
const emptyBitmap = { data: Buffer$1.alloc(0), width: 0, height: 0 };
function bufferFromArrayBuffer(Xn) {
  const zn = Buffer$1.alloc(Xn.byteLength), Un = new Uint8Array(Xn);
  for (let Kn = 0; Kn < zn.length; ++Kn) zn[Kn] = Un[Kn];
  return zn;
}
function createJimp({ plugins: Xn, formats: zn } = {}) {
  const Un = Xn || [], Kn = (zn || []).map((Jo) => Jo()), qn = class {
    constructor(Jo = emptyBitmap) {
      if (__publicField$2(this, "bitmap", emptyBitmap), __publicField$2(this, "background", 0), __publicField$2(this, "formats", []), __publicField$2(this, "mime"), this.formats = Kn, "data" in Jo) this.bitmap = Jo;
      else if (this.bitmap = { data: Buffer$1.alloc(Jo.width * Jo.height * 4), width: Jo.width, height: Jo.height }, Jo.color) {
        this.background = typeof Jo.color == "string" ? cssColorToHex(Jo.color) : Jo.color;
        for (let pa = 0; pa < this.bitmap.data.length; pa += 4) this.bitmap.data.writeUInt32BE(this.background, pa);
      }
      for (const pa of Un) for (const ma in pa) this[ma] = (...va) => {
        var _a;
        const ba = (_a = pa[ma]) == null ? void 0 : _a.call(pa, this, ...va);
        return typeof ba == "object" && "bitmap" in ba ? (this.bitmap = ba.bitmap, this) : ba;
      };
    }
    static async read(Jo, pa) {
      if (Buffer$1.isBuffer(Jo) || Jo instanceof ArrayBuffer) return this.fromBuffer(Jo);
      const [ma, va] = await to(fetch(Jo));
      if (ma) throw new Error(`Could not load Buffer from URL: ${Jo}`);
      if (!va.ok) throw new Error(`HTTP Status ${va.status} for url ${Jo}`);
      const [ba, _a] = await to(va.arrayBuffer());
      if (ba) throw new Error(`Could not load Buffer from ${Jo}`);
      const ya = bufferFromArrayBuffer(_a);
      return this.fromBuffer(ya, pa);
    }
    static fromBitmap(Jo) {
      let pa;
      if (Jo.data instanceof Buffer$1 && (pa = Buffer$1.from(Jo.data)), (Jo.data instanceof Uint8Array || Jo.data instanceof Uint8ClampedArray) && (pa = Buffer$1.from(Jo.data.buffer)), Array.isArray(Jo.data) && (pa = Buffer$1.concat(Jo.data.map((ma) => Buffer$1.from(ma.toString(16).padStart(8, "0"), "hex")))), !pa) throw new Error("data must be a Buffer");
      if (typeof Jo.height != "number" || typeof Jo.width != "number") throw new Error("bitmap must have width and height");
      return new qn({ height: Jo.height, width: Jo.width, data: pa });
    }
    static async fromBuffer(Jo, pa) {
      const ma = Jo instanceof ArrayBuffer ? bufferFromArrayBuffer(Jo) : Jo, va = await fileType$1.fromBuffer(ma);
      if (!va || !va.mime) throw new Error("Could not find MIME for Buffer");
      const ba = Kn.find((ya) => ya.mime === va.mime);
      if (!ba || !ba.decode) throw new Error(`Mime type ${va.mime} does not support decoding`);
      const _a = new qn(await ba.decode(ma, pa == null ? void 0 : pa[ba.mime]));
      return _a.mime = va.mime, attemptExifRotate(_a, ma), _a;
    }
    inspect() {
      return "<Jimp " + (this.bitmap === emptyBitmap ? "pending..." : this.bitmap.width + "x" + this.bitmap.height) + ">";
    }
    toString() {
      return "[object Jimp]";
    }
    get width() {
      return this.bitmap.width;
    }
    get height() {
      return this.bitmap.height;
    }
    async getBuffer(Jo, pa) {
      const ma = this.formats.find((ba) => ba.mime === Jo);
      if (!ma || !ma.encode) throw new Error(`Unsupported MIME type: ${Jo}`);
      let va;
      return ma.hasAlpha ? va = this : (va = new qn({ width: this.bitmap.width, height: this.bitmap.height, color: this.background }), composite(va, this)), ma.encode(va.bitmap, pa);
    }
    async getBase64(Jo, pa) {
      return "data:" + Jo + ";base64," + (await this.getBuffer(Jo, pa)).toString("base64");
    }
    async write(Jo, pa) {
      const ma = mime.getType(Jo);
      await writeFile(Jo, await this.getBuffer(ma, pa));
    }
    clone() {
      return new qn({ ...this.bitmap, data: Buffer$1.from(this.bitmap.data) });
    }
    getPixelIndex(Jo, pa, ma) {
      let va, ba;
      if (ma || (ma = Edge.EXTEND), typeof Jo != "number" || typeof pa != "number") throw new Error("x and y must be numbers");
      va = Jo = Math.round(Jo), ba = pa = Math.round(pa), ma === Edge.EXTEND && (Jo < 0 && (va = 0), Jo >= this.bitmap.width && (va = this.bitmap.width - 1), pa < 0 && (ba = 0), pa >= this.bitmap.height && (ba = this.bitmap.height - 1)), ma === Edge.WRAP && (Jo < 0 && (va = this.bitmap.width + Jo), Jo >= this.bitmap.width && (va = Jo % this.bitmap.width), pa < 0 && (ba = this.bitmap.height + pa), pa >= this.bitmap.height && (ba = pa % this.bitmap.height));
      let _a = this.bitmap.width * ba + va << 2;
      return (va < 0 || va >= this.bitmap.width) && (_a = -1), (ba < 0 || ba >= this.bitmap.height) && (_a = -1), _a;
    }
    getPixelColor(Jo, pa) {
      if (typeof Jo != "number" || typeof pa != "number") throw new Error("x and y must be numbers");
      const ma = this.getPixelIndex(Jo, pa);
      return this.bitmap.data.readUInt32BE(ma);
    }
    setPixelColor(Jo, pa, ma) {
      if (typeof Jo != "number" || typeof pa != "number" || typeof ma != "number") throw new Error("hex, x and y must be numbers");
      const va = this.getPixelIndex(pa, ma);
      return this.bitmap.data.writeUInt32BE(Jo, va), this;
    }
    hasAlpha() {
      const { width: Jo, height: pa, data: ma } = this.bitmap, va = Jo * pa << 2;
      for (let ba = 3; ba < va; ba += 4) if (ma[ba] !== 255) return !0;
      return !1;
    }
    composite(Jo, pa = 0, ma = 0, va = {}) {
      return composite(this, Jo, pa, ma, va);
    }
    scan(Jo, pa, ma, va, ba) {
      return scan(this, Jo, pa, ma, va, ba);
    }
    scanIterator(Jo = 0, pa = 0, ma = this.bitmap.width, va = this.bitmap.height) {
      if (typeof Jo != "number" || typeof pa != "number") throw new Error("x and y must be numbers");
      if (typeof ma != "number" || typeof va != "number") throw new Error("w and h must be numbers");
      return scanIterator(this, Jo, pa, ma, va);
    }
  };
  return qn;
}
var ResizeStrategy, ResizeStrategy2;
function Resize(Xn, zn, Un, Kn, qn, Jo, pa) {
  this.widthOriginal = Math.abs(Math.floor(Xn) || 0), this.heightOriginal = Math.abs(Math.floor(zn) || 0), this.targetWidth = Math.abs(Math.floor(Un) || 0), this.targetHeight = Math.abs(Math.floor(Kn) || 0), this.colorChannels = qn ? 4 : 3, this.interpolationPass = !!Jo, this.resizeCallback = typeof pa == "function" ? pa : function() {
  }, this.targetWidthMultipliedByChannels = this.targetWidth * this.colorChannels, this.originalWidthMultipliedByChannels = this.widthOriginal * this.colorChannels, this.originalHeightMultipliedByChannels = this.heightOriginal * this.colorChannels, this.widthPassResultSize = this.targetWidthMultipliedByChannels * this.heightOriginal, this.finalResultSize = this.targetWidthMultipliedByChannels * this.targetHeight, this.initialize();
}
ResizeStrategy2 = ResizeStrategy || (ResizeStrategy = {}), ResizeStrategy2.NEAREST_NEIGHBOR = "nearestNeighbor", ResizeStrategy2.BILINEAR = "bilinearInterpolation", ResizeStrategy2.BICUBIC = "bicubicInterpolation", ResizeStrategy2.HERMITE = "hermiteInterpolation", ResizeStrategy2.BEZIER = "bezierInterpolation", Resize.prototype.initialize = function() {
  if (!(this.widthOriginal > 0 && this.heightOriginal > 0 && this.targetWidth > 0 && this.targetHeight > 0)) throw console.log(this), new Error("Invalid settings specified for the resizer.");
  this.configurePasses();
}, Resize.prototype.configurePasses = function() {
  this.widthOriginal === this.targetWidth ? this.resizeWidth = this.bypassResizer : (this.ratioWeightWidthPass = this.widthOriginal / this.targetWidth, this.ratioWeightWidthPass < 1 && this.interpolationPass ? (this.initializeFirstPassBuffers(!0), this.resizeWidth = this.colorChannels === 4 ? this.resizeWidthInterpolatedRGBA : this.resizeWidthInterpolatedRGB) : (this.initializeFirstPassBuffers(!1), this.resizeWidth = this.colorChannels === 4 ? this.resizeWidthRGBA : this.resizeWidthRGB)), this.heightOriginal === this.targetHeight ? this.resizeHeight = this.bypassResizer : (this.ratioWeightHeightPass = this.heightOriginal / this.targetHeight, this.ratioWeightHeightPass < 1 && this.interpolationPass ? (this.initializeSecondPassBuffers(!0), this.resizeHeight = this.resizeHeightInterpolated) : (this.initializeSecondPassBuffers(!1), this.resizeHeight = this.colorChannels === 4 ? this.resizeHeightRGBA : this.resizeHeightRGB));
}, Resize.prototype._resizeWidthInterpolatedRGBChannels = function(Xn, zn) {
  const Un = zn ? 4 : 3, Kn = this.ratioWeightWidthPass, qn = this.widthBuffer;
  let Jo, pa, ma = 0, va = 0, ba = 0, _a = 0, ya = 0;
  for (Jo = 0; ma < 1 / 3; Jo += Un, ma += Kn) for (va = Jo, ba = 0; va < this.widthPassResultSize; ba += this.originalWidthMultipliedByChannels, va += this.targetWidthMultipliedByChannels) qn[va] = Xn[ba], qn[va + 1] = Xn[ba + 1], qn[va + 2] = Xn[ba + 2], zn && (qn[va + 3] = Xn[ba + 3]);
  for (ma -= 1 / 3, pa = this.widthOriginal - 1; ma < pa; Jo += Un, ma += Kn) for (ya = ma % 1, _a = 1 - ya, va = Jo, ba = Math.floor(ma) * Un; va < this.widthPassResultSize; ba += this.originalWidthMultipliedByChannels, va += this.targetWidthMultipliedByChannels) qn[va + 0] = Xn[ba + 0] * _a + Xn[ba + Un + 0] * ya, qn[va + 1] = Xn[ba + 1] * _a + Xn[ba + Un + 1] * ya, qn[va + 2] = Xn[ba + 2] * _a + Xn[ba + Un + 2] * ya, zn && (qn[va + 3] = Xn[ba + 3] * _a + Xn[ba + Un + 3] * ya);
  for (pa = this.originalWidthMultipliedByChannels - Un; Jo < this.targetWidthMultipliedByChannels; Jo += Un) for (va = Jo, ba = pa; va < this.widthPassResultSize; ba += this.originalWidthMultipliedByChannels, va += this.targetWidthMultipliedByChannels) qn[va] = Xn[ba], qn[va + 1] = Xn[ba + 1], qn[va + 2] = Xn[ba + 2], zn && (qn[va + 3] = Xn[ba + 3]);
  return qn;
}, Resize.prototype._resizeWidthRGBChannels = function(Xn, zn) {
  const Un = zn ? 4 : 3, Kn = this.ratioWeightWidthPass, qn = 1 / Kn, Jo = this.originalWidthMultipliedByChannels - Un + 1, pa = this.targetWidthMultipliedByChannels - Un + 1, ma = this.outputWidthWorkBench, va = this.widthBuffer, ba = this.outputWidthWorkBenchOpaquePixelsCount;
  let _a = 0, ya = 0, xa = 0, wa = 0, Ta = 0, Sa = 0, Ma = 0, ka = 1, Za = 0, Na = 0, Ka = 0, Ja = 0;
  do {
    for (Ta = 0; Ta < this.originalHeightMultipliedByChannels; ) ma[Ta++] = 0, ma[Ta++] = 0, ma[Ta++] = 0, zn && (ma[Ta++] = 0, ba[Ta / Un - 1] = 0);
    _a = Kn;
    do {
      for (ya = 1 + xa - wa, ka = Math.min(_a, ya), Ta = 0, Sa = xa; Ta < this.originalHeightMultipliedByChannels; Sa += Jo) Za = Xn[Sa], Na = Xn[++Sa], Ka = Xn[++Sa], Ja = zn ? Xn[++Sa] : 255, ma[Ta++] += (Ja ? Za : 0) * ka, ma[Ta++] += (Ja ? Na : 0) * ka, ma[Ta++] += (Ja ? Ka : 0) * ka, zn && (ma[Ta++] += Ja * ka, ba[Ta / Un - 1] += Ja ? ka : 0);
      if (!(_a >= ya)) {
        wa += _a;
        break;
      }
      xa += Un, wa = xa, _a -= ya;
    } while (_a > 0 && xa < this.originalWidthMultipliedByChannels);
    for (Ta = 0, Sa = Ma; Ta < this.originalHeightMultipliedByChannels; Sa += pa) _a = zn ? ba[Ta / Un] : 1, ka = zn ? _a ? 1 / _a : 0 : qn, va[Sa] = ma[Ta++] * ka, va[++Sa] = ma[Ta++] * ka, va[++Sa] = ma[Ta++] * ka, zn && (va[++Sa] = ma[Ta++] * qn);
    Ma += Un;
  } while (Ma < this.targetWidthMultipliedByChannels);
  return va;
}, Resize.prototype._resizeHeightRGBChannels = function(Xn, zn) {
  const Un = this.ratioWeightHeightPass, Kn = 1 / Un, qn = this.outputHeightWorkBench, Jo = this.heightBuffer, pa = this.outputHeightWorkBenchOpaquePixelsCount;
  let ma = 0, va = 0, ba = 0, _a = 0, ya = 0, xa = 0, wa = 0, Ta = 1, Sa = 0, Ma = 0, ka = 0, Za = 0;
  do {
    for (ya = 0; ya < this.targetWidthMultipliedByChannels; ) qn[ya++] = 0, qn[ya++] = 0, qn[ya++] = 0, zn && (qn[ya++] = 0, pa[ya / 4 - 1] = 0);
    ma = Un;
    do {
      for (va = 1 + ba - _a, Ta = Math.min(ma, va), wa = ba, ya = 0; ya < this.targetWidthMultipliedByChannels; ) Sa = Xn[wa++], Ma = Xn[wa++], ka = Xn[wa++], Za = zn ? Xn[wa++] : 255, qn[ya++] += (Za ? Sa : 0) * Ta, qn[ya++] += (Za ? Ma : 0) * Ta, qn[ya++] += (Za ? ka : 0) * Ta, zn && (qn[ya++] += Za * Ta, pa[ya / 4 - 1] += Za ? Ta : 0);
      if (!(ma >= va)) {
        _a += ma;
        break;
      }
      ba = wa, _a = ba, ma -= va;
    } while (ma > 0 && ba < this.widthPassResultSize);
    for (ya = 0; ya < this.targetWidthMultipliedByChannels; ) ma = zn ? pa[ya / 4] : 1, Ta = zn ? ma ? 1 / ma : 0 : Kn, Jo[xa++] = Math.round(qn[ya++] * Ta), Jo[xa++] = Math.round(qn[ya++] * Ta), Jo[xa++] = Math.round(qn[ya++] * Ta), zn && (Jo[xa++] = Math.round(qn[ya++] * Kn));
  } while (xa < this.finalResultSize);
  return Jo;
}, Resize.prototype.resizeWidthInterpolatedRGB = function(Xn) {
  return this._resizeWidthInterpolatedRGBChannels(Xn, !1);
}, Resize.prototype.resizeWidthInterpolatedRGBA = function(Xn) {
  return this._resizeWidthInterpolatedRGBChannels(Xn, !0);
}, Resize.prototype.resizeWidthRGB = function(Xn) {
  return this._resizeWidthRGBChannels(Xn, !1);
}, Resize.prototype.resizeWidthRGBA = function(Xn) {
  return this._resizeWidthRGBChannels(Xn, !0);
}, Resize.prototype.resizeHeightInterpolated = function(Xn) {
  const zn = this.ratioWeightHeightPass, Un = this.heightBuffer;
  let Kn, qn = 0, Jo = 0, pa = 0, ma = 0, va = 0, ba = 0, _a = 0;
  for (; qn < 1 / 3; qn += zn) for (pa = 0; pa < this.targetWidthMultipliedByChannels; ) Un[Jo++] = Math.round(Xn[pa++]);
  for (qn -= 1 / 3, Kn = this.heightOriginal - 1; qn < Kn; qn += zn) for (_a = qn % 1, ba = 1 - _a, ma = Math.floor(qn) * this.targetWidthMultipliedByChannels, va = ma + this.targetWidthMultipliedByChannels, pa = 0; pa < this.targetWidthMultipliedByChannels; ++pa) Un[Jo++] = Math.round(Xn[ma++] * ba + Xn[va++] * _a);
  for (; Jo < this.finalResultSize; ) for (pa = 0, ma = Kn * this.targetWidthMultipliedByChannels; pa < this.targetWidthMultipliedByChannels; ++pa) Un[Jo++] = Math.round(Xn[ma++]);
  return Un;
}, Resize.prototype.resizeHeightRGB = function(Xn) {
  return this._resizeHeightRGBChannels(Xn, !1);
}, Resize.prototype.resizeHeightRGBA = function(Xn) {
  return this._resizeHeightRGBChannels(Xn, !0);
}, Resize.prototype.resize = function(Xn) {
  this.resizeCallback(this.resizeHeight(this.resizeWidth(Xn)));
}, Resize.prototype.bypassResizer = function(Xn) {
  return Xn;
}, Resize.prototype.initializeFirstPassBuffers = function(Xn) {
  this.widthBuffer = this.generateFloatBuffer(this.widthPassResultSize), Xn || (this.outputWidthWorkBench = this.generateFloatBuffer(this.originalHeightMultipliedByChannels), this.colorChannels > 3 && (this.outputWidthWorkBenchOpaquePixelsCount = this.generateFloat64Buffer(this.heightOriginal)));
}, Resize.prototype.initializeSecondPassBuffers = function(Xn) {
  this.heightBuffer = this.generateUint8Buffer(this.finalResultSize), Xn || (this.outputHeightWorkBench = this.generateFloatBuffer(this.targetWidthMultipliedByChannels), this.colorChannels > 3 && (this.outputHeightWorkBenchOpaquePixelsCount = this.generateFloat64Buffer(this.targetWidth)));
}, Resize.prototype.generateFloatBuffer = function(Xn) {
  try {
    return new Float32Array(Xn);
  } catch (zn) {
    return console.error(zn), [];
  }
}, Resize.prototype.generateFloat64Buffer = function(Xn) {
  try {
    return new Float64Array(Xn);
  } catch (zn) {
    return console.error(zn), [];
  }
}, Resize.prototype.generateUint8Buffer = function(Xn) {
  try {
    return new Uint8Array(Xn);
  } catch (zn) {
    return console.error(zn), [];
  }
};
const operations = { nearestNeighbor(Xn, zn) {
  const Un = Xn.width, Kn = Xn.height, qn = zn.width, Jo = zn.height, pa = Xn.data, ma = zn.data;
  for (let va = 0; va < Jo; va++) for (let ba = 0; ba < qn; ba++) {
    let _a = 4 * (va * qn + ba), ya = 4 * (Math.floor(va * Kn / Jo) * Un + Math.floor(ba * Un / qn));
    ma[_a++] = pa[ya++], ma[_a++] = pa[ya++], ma[_a++] = pa[ya++], ma[_a++] = pa[ya++];
  }
}, bilinearInterpolation(Xn, zn) {
  const Un = Xn.width, Kn = Xn.height, qn = zn.width, Jo = zn.height, pa = Xn.data, ma = zn.data, va = function(_a, ya, xa, wa, Ta) {
    return ya === wa ? xa : Math.round((_a - ya) * Ta + (wa - _a) * xa);
  }, ba = function(_a, ya, xa, wa, Ta, Sa, Ma, ka) {
    let Za = 4 * (Ma * Un + wa) + ya, Na = 4 * (Ma * Un + Ta) + ya;
    const Ka = va(xa, wa, pa[Za], Ta, pa[Na]);
    if (ka === Ma) ma[_a + ya] = Ka;
    else {
      Za = 4 * (ka * Un + wa) + ya, Na = 4 * (ka * Un + Ta) + ya;
      const Ja = va(xa, wa, pa[Za], Ta, pa[Na]);
      ma[_a + ya] = va(Sa, Ma, Ka, ka, Ja);
    }
  };
  for (let _a = 0; _a < Jo; _a++) for (let ya = 0; ya < qn; ya++) {
    const xa = 4 * (_a * qn + ya), wa = ya * Un / qn, Ta = Math.floor(wa), Sa = Math.min(Math.ceil(wa), Un - 1), Ma = _a * Kn / Jo, ka = Math.floor(Ma), Za = Math.min(Math.ceil(Ma), Kn - 1);
    ba(xa, 0, wa, Ta, Sa, Ma, ka, Za), ba(xa, 1, wa, Ta, Sa, Ma, ka, Za), ba(xa, 2, wa, Ta, Sa, Ma, ka, Za), ba(xa, 3, wa, Ta, Sa, Ma, ka, Za);
  }
}, _interpolate2D(Xn, zn, Un, Kn) {
  const qn = Xn.data, Jo = zn.data, pa = Xn.width, ma = Xn.height, va = zn.width, ba = zn.height, _a = Math.max(1, Math.floor(pa / va)), ya = va * _a, xa = Math.max(1, Math.floor(ma / ba)), wa = ba * xa, Ta = Buffer$1.alloc(ya * ma * 4);
  for (let ka = 0; ka < ma; ka++) for (let Za = 0; Za < ya; Za++) {
    const Na = Za * (pa - 1) / ya, Ka = Math.floor(Na), Ja = Na - Ka, el = 4 * (ka * pa + Ka), qa = 4 * (ka * ya + Za);
    for (let tl = 0; tl < 4; tl++) {
      const Qa = el + tl, nl = Ka > 0 ? qn[Qa - 4] : 2 * qn[Qa] - qn[Qa + 4], rl = qn[Qa], il = qn[Qa + 4], cl = Ka < pa - 2 ? qn[Qa + 8] : 2 * qn[Qa + 4] - qn[Qa];
      Ta[qa + tl] = Kn(nl, rl, il, cl, Ja);
    }
  }
  const Sa = Buffer$1.alloc(ya * wa * 4);
  for (let ka = 0; ka < wa; ka++) for (let Za = 0; Za < ya; Za++) {
    const Na = ka * (ma - 1) / wa, Ka = Math.floor(Na), Ja = Na - Ka, el = 4 * (Ka * ya + Za), qa = 4 * (ka * ya + Za);
    for (let tl = 0; tl < 4; tl++) {
      const Qa = el + tl, nl = Ka > 0 ? Ta[Qa - 4 * ya] : 2 * Ta[Qa] - Ta[Qa + 4 * ya], rl = Ta[Qa], il = Ta[Qa + 4 * ya], cl = Ka < ma - 2 ? Ta[Qa + 8 * ya] : 2 * Ta[Qa + 4 * ya] - Ta[Qa];
      Sa[qa + tl] = Kn(nl, rl, il, cl, Ja);
    }
  }
  const Ma = _a * xa;
  if (Ma > 1) for (let ka = 0; ka < ba; ka++) for (let Za = 0; Za < va; Za++) {
    let Na = 0, Ka = 0, Ja = 0, el = 0, qa = 0;
    for (let Qa = 0; Qa < xa; Qa++) {
      const nl = ka * xa + Qa;
      for (let rl = 0; rl < _a; rl++) {
        const il = 4 * (nl * ya + (Za * _a + rl)), cl = Sa[il + 3];
        cl && (Na += Sa[il], Ka += Sa[il + 1], Ja += Sa[il + 2], qa++), el += cl;
      }
    }
    const tl = 4 * (ka * va + Za);
    Jo[tl] = qa ? Math.round(Na / qa) : 0, Jo[tl + 1] = qa ? Math.round(Ka / qa) : 0, Jo[tl + 2] = qa ? Math.round(Ja / qa) : 0, Jo[tl + 3] = Math.round(el / Ma);
  }
  else zn.data = Sa;
}, bicubicInterpolation(Xn, zn, Un) {
  return this._interpolate2D(Xn, zn, Un, function(Kn, qn, Jo, pa, ma) {
    const va = pa - Jo - Kn + qn, ba = Kn - qn - va, _a = Jo - Kn, ya = qn;
    return Math.max(0, Math.min(255, va * (ma * ma * ma) + ba * (ma * ma) + _a * ma + ya));
  });
}, hermiteInterpolation(Xn, zn, Un) {
  return this._interpolate2D(Xn, zn, Un, function(Kn, qn, Jo, pa, ma) {
    const va = qn, ba = 0.5 * (Jo - Kn), _a = Kn - 2.5 * qn + 2 * Jo - 0.5 * pa, ya = 0.5 * (pa - Kn) + 1.5 * (qn - Jo);
    return Math.max(0, Math.min(255, Math.round(((ya * ma + _a) * ma + ba) * ma + va)));
  });
}, bezierInterpolation(Xn, zn, Un) {
  return this._interpolate2D(Xn, zn, Un, function(Kn, qn, Jo, pa, ma) {
    const va = 1 - ma, ba = qn * va * va * va, _a = 3 * (qn + (Jo - Kn) / 4) * va * va * ma, ya = 3 * (Jo - (pa - qn) / 4) * va * ma * ma, xa = Jo * ma * ma * ma;
    return Math.max(0, Math.min(255, Math.round(ba + _a + ya + xa)));
  });
} }, ResizeOptionsSchema = z.union([z.object({ w: z.number().min(0), h: z.number().min(0).optional(), mode: z.nativeEnum(ResizeStrategy).optional() }), z.object({ w: z.number().min(0).optional(), h: z.number().min(0), mode: z.nativeEnum(ResizeStrategy).optional() })]), ScaleToFitOptionsSchema = z.object({ w: z.number().min(0), h: z.number().min(0), mode: z.nativeEnum(ResizeStrategy).optional() }), ScaleComplexOptionsSchema = z.object({ f: z.number().min(0), mode: z.nativeEnum(ResizeStrategy).optional() }), methods$d = { resize(Xn, zn) {
  const { mode: Un } = ResizeOptionsSchema.parse(zn);
  let Kn, qn;
  if (typeof zn.w == "number") Kn = zn.w, qn = zn.h ?? Xn.bitmap.height * (Kn / Xn.bitmap.width);
  else {
    if (typeof zn.h != "number") throw new Error("w must be a number");
    qn = zn.h, Kn = zn.w ?? Xn.bitmap.width * (qn / Xn.bitmap.height);
  }
  if (Kn = Math.round(Kn) || 1, qn = Math.round(qn) || 1, Un && typeof operations[Un] == "function") {
    const Jo = { data: Buffer$1.alloc(Kn * qn * 4), width: Kn, height: qn };
    operations[Un](Xn.bitmap, Jo), Xn.bitmap = Jo;
  } else
    new Resize(Xn.bitmap.width, Xn.bitmap.height, Kn, qn, !0, !0, (Jo) => {
      Xn.bitmap.data = Buffer$1.from(Jo), Xn.bitmap.width = Kn, Xn.bitmap.height = qn;
    }).resize(Xn.bitmap.data);
  return Xn;
}, scale(Xn, zn) {
  const { f: Un, mode: Kn } = typeof zn == "number" ? { f: zn } : ScaleComplexOptionsSchema.parse(zn), qn = Xn.bitmap.width * Un, Jo = Xn.bitmap.height * Un;
  return this.resize(Xn, { w: qn, h: Jo, mode: Kn });
}, scaleToFit(Xn, zn) {
  const { h: Un, w: Kn, mode: qn } = ScaleToFitOptionsSchema.parse(zn), Jo = Kn / Un > Xn.bitmap.width / Xn.bitmap.height ? Un / Xn.bitmap.height : Kn / Xn.bitmap.width;
  return this.scale(Xn, { f: Jo, mode: qn });
} }, ContainOptionsSchema = z.object({ w: z.number(), h: z.number(), align: z.number().optional(), mode: z.nativeEnum(ResizeStrategy).optional() }), methods$c = { contain(Xn, zn) {
  const { w: Un, h: Kn, align: qn = HorizontalAlign.CENTER | VerticalAlign.MIDDLE, mode: Jo } = ContainOptionsSchema.parse(zn), pa = 7 & qn, ma = qn >> 3;
  if ((pa === 0 || pa & pa - 1) && (ma === 0 || ma & ma - 1)) throw new Error("only use one flag per alignment direction");
  const va = pa >> 1, ba = ma >> 1, _a = Un / Kn > Xn.bitmap.width / Xn.bitmap.height ? Kn / Xn.bitmap.height : Un / Xn.bitmap.width, ya = methods$d.scale(clone(Xn), { f: _a, mode: Jo });
  return (Xn = methods$d.resize(Xn, { w: Un, h: Kn, mode: Jo })).scan((xa, wa, Ta) => {
    Xn.bitmap.data.writeUInt32BE(Xn.background, Ta);
  }), Xn = methods$h.blit(Xn, { src: ya, x: (Xn.bitmap.width - ya.bitmap.width) / 2 * va, y: (Xn.bitmap.height - ya.bitmap.height) / 2 * ba });
} }, CropOptionsSchema = z.object({ x: z.number(), y: z.number(), w: z.number(), h: z.number() }), AutocropComplexOptionsSchema = z.object({ tolerance: z.number().min(0).max(1).optional(), cropOnlyFrames: z.boolean().optional(), cropSymmetric: z.boolean().optional(), leaveBorder: z.number().optional(), ignoreSides: z.object({ north: z.boolean().optional(), south: z.boolean().optional(), east: z.boolean().optional(), west: z.boolean().optional() }).optional() }), methods$b = { crop(Xn, zn) {
  let { x: Un, y: Kn, w: qn, h: Jo } = CropOptionsSchema.parse(zn);
  if (Un = Math.round(Un), Kn = Math.round(Kn), qn = Math.round(qn), Jo = Math.round(Jo), Un === 0 && qn === Xn.bitmap.width) {
    const pa = qn * Kn + Un << 2, ma = pa + (Jo * qn << 2);
    Xn.bitmap.data = Xn.bitmap.data.slice(pa, ma);
  } else {
    const pa = Buffer$1.allocUnsafe(qn * Jo * 4);
    let ma = 0;
    scan(Xn, Un, Kn, qn, Jo, function(va, ba, _a) {
      const ya = Xn.bitmap.data.readUInt32BE(_a);
      pa.writeUInt32BE(ya, ma), ma += 4;
    }), Xn.bitmap.data = pa;
  }
  return Xn.bitmap.width = qn, Xn.bitmap.height = Jo, Xn;
}, autocrop(Xn, zn = {}) {
  const { tolerance: Un = 2e-4, cropOnlyFrames: Kn = !0, cropSymmetric: qn = !1, leaveBorder: Jo = 0, ignoreSides: pa } = typeof zn == "number" ? { tolerance: zn } : AutocropComplexOptionsSchema.parse(zn), ma = Xn.bitmap.width, va = Xn.bitmap.height, ba = { north: !1, south: !1, east: !1, west: !1, ...pa };
  let _a = Xn.getPixelColor(0, 0);
  const ya = intToRGBA$1(_a);
  let xa = 0, wa = 0, Ta = 0, Sa = 0;
  if (_a = Xn.getPixelColor(0, 0), !ba.north) e: for (let Na = 0; Na < va - 1; Na++) {
    for (let Ka = 0; Ka < ma; Ka++)
      if (colorDiff(ya, intToRGBA$1(Xn.getPixelColor(Ka, Na))) > Un) break e;
    xa++;
  }
  if (_a = Xn.getPixelColor(ma, 0), !ba.west) e: for (let Na = 0; Na < ma - 1; Na++) {
    for (let Ka = 0 + xa; Ka < va; Ka++)
      if (colorDiff(ya, intToRGBA$1(Xn.getPixelColor(Na, Ka))) > Un) break e;
    Sa++;
  }
  if (_a = Xn.getPixelColor(0, va), !ba.south) e: for (let Na = va - 1; Na >= xa + 1; Na--) {
    for (let Ka = ma - wa - 1; Ka >= 0; Ka--)
      if (colorDiff(ya, intToRGBA$1(Xn.getPixelColor(Ka, Na))) > Un) break e;
    Ta++;
  }
  if (_a = Xn.getPixelColor(ma, va), !ba.east) e: for (let Na = ma - 1; Na >= 0 + Sa + 1; Na--) {
    for (let Ka = va - 1; Ka >= 0 + xa; Ka--)
      if (colorDiff(ya, intToRGBA$1(Xn.getPixelColor(Na, Ka))) > Un) break e;
    wa++;
  }
  let Ma = !1;
  if (Sa -= Jo, wa -= Jo, xa -= Jo, Ta -= Jo, qn) {
    const Na = Math.min(wa, Sa), Ka = Math.min(xa, Ta);
    Sa = Na, wa = Na, xa = Ka, Ta = Ka;
  }
  Sa = Sa >= 0 ? Sa : 0, wa = wa >= 0 ? wa : 0, xa = xa >= 0 ? xa : 0, Ta = Ta >= 0 ? Ta : 0;
  const ka = ma - (Sa + wa), Za = va - (Ta + xa);
  return Ma = Kn ? wa !== 0 && xa !== 0 && Sa !== 0 && Ta !== 0 : wa !== 0 || xa !== 0 || Sa !== 0 || Ta !== 0, Ma && this.crop(Xn, { x: Sa, y: xa, w: ka, h: Za }), Xn;
} }, CoverOptionsSchema = z.object({ w: z.number(), h: z.number(), align: z.number().optional(), mode: z.nativeEnum(ResizeStrategy).optional() }), methods$a = { cover(Xn, zn) {
  const { w: Un, h: Kn, align: qn = HorizontalAlign.CENTER | VerticalAlign.MIDDLE, mode: Jo } = CoverOptionsSchema.parse(zn), pa = 7 & qn, ma = qn >> 3;
  if ((pa === 0 || pa & pa - 1) && (ma === 0 || ma & ma - 1)) throw new Error("only use one flag per alignment direction");
  const va = pa >> 1, ba = ma >> 1, _a = Un / Kn > Xn.bitmap.width / Xn.bitmap.height ? Un / Xn.bitmap.width : Kn / Xn.bitmap.height;
  return Xn = methods$d.scale(Xn, { f: _a, mode: Jo }), Xn = methods$b.crop(Xn, { x: (Xn.bitmap.width - Un) / 2 * va, y: (Xn.bitmap.height - Kn) / 2 * ba, w: Un, h: Kn });
} }, DisplaceOptionsSchema = z.object({ map: JimpClassSchema, offset: z.number() }), methods$9 = { displace(Xn, zn) {
  const { map: Un, offset: Kn } = DisplaceOptionsSchema.parse(zn), qn = clone(Xn);
  return Xn.scan((Jo, pa, ma) => {
    let va = Un.bitmap.data[ma] / 256 * Kn;
    va = Math.round(va);
    const ba = Xn.getPixelIndex(Jo + va, pa);
    Xn.bitmap.data[ba] = qn.bitmap.data[ma], Xn.bitmap.data[ba + 1] = qn.bitmap.data[ma + 1], Xn.bitmap.data[ba + 2] = qn.bitmap.data[ma + 2];
  }), Xn;
} }, methods$8 = { dither(Xn) {
  const zn = [1, 9, 3, 11, 13, 5, 15, 7, 4, 12, 2, 10, 16, 8, 14, 6];
  return Xn.scan((Un, Kn, qn) => {
    const Jo = zn[((3 & Kn) << 2) + Un % 4];
    Xn.bitmap.data[qn] = Math.min(Xn.bitmap.data[qn] + Jo, 255), Xn.bitmap.data[qn + 1] = Math.min(Xn.bitmap.data[qn + 1] + Jo, 255), Xn.bitmap.data[qn + 2] = Math.min(Xn.bitmap.data[qn + 2] + Jo, 255);
  }), Xn;
} }, FisheyeOptionsSchema = z.object({ radius: z.number().min(0).optional() }), methods$7 = { fisheye(Xn, zn = {}) {
  const { radius: Un = 2.5 } = FisheyeOptionsSchema.parse(zn), Kn = clone(Xn), { width: qn, height: Jo } = Kn.bitmap;
  return Kn.scan((pa, ma) => {
    const va = pa / qn, ba = ma / Jo, _a = Math.sqrt(Math.pow(va - 0.5, 2) + Math.pow(ba - 0.5, 2)), ya = 2 * Math.pow(_a, Un), xa = (va - 0.5) / _a, wa = (ba - 0.5) / _a, Ta = Math.round((ya * xa + 0.5) * qn), Sa = Math.round((ya * wa + 0.5) * Jo), Ma = Kn.getPixelColor(Ta, Sa);
    Xn.setPixelColor(Ma, pa, ma);
  }), Xn.setPixelColor(Kn.getPixelColor(qn / 2, Jo / 2), qn / 2, Jo / 2), Xn;
} }, FlipOptionsSchema = z.object({ horizontal: z.boolean().optional(), vertical: z.boolean().optional() }), methods$6 = { flip(Xn, zn) {
  const { horizontal: Un, vertical: Kn } = FlipOptionsSchema.parse(zn), qn = Buffer$1.alloc(Xn.bitmap.data.length);
  return Xn.scan((Jo, pa, ma) => {
    const va = Un ? Xn.bitmap.width - 1 - Jo : Jo, ba = Kn ? Xn.bitmap.height - 1 - pa : pa, _a = Xn.bitmap.width * ba + va << 2, ya = Xn.bitmap.data.readUInt32BE(ma);
    qn.writeUInt32BE(ya, _a);
  }), Xn.bitmap.data = Buffer$1.from(qn), Xn;
} };
function Converter$1(Xn, zn) {
  if (!(Xn && zn && Xn.length && zn.length)) throw new Error("Bad alphabet");
  this.srcAlphabet = Xn, this.dstAlphabet = zn;
}
Converter$1.prototype.convert = function(Xn) {
  var zn, Un, Kn, qn = {}, Jo = this.srcAlphabet.length, pa = this.dstAlphabet.length, ma = Xn.length, va = typeof Xn == "string" ? "" : [];
  if (!this.isValid(Xn)) throw new Error('Number "' + Xn + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
  if (this.srcAlphabet === this.dstAlphabet) return Xn;
  for (zn = 0; zn < ma; zn++) qn[zn] = this.srcAlphabet.indexOf(Xn[zn]);
  do {
    for (Un = 0, Kn = 0, zn = 0; zn < ma; zn++) (Un = Un * Jo + qn[zn]) >= pa ? (qn[Kn++] = parseInt(Un / pa, 10), Un %= pa) : Kn > 0 && (qn[Kn++] = 0);
    ma = Kn, va = this.dstAlphabet.slice(Un, Un + 1).concat(va);
  } while (Kn !== 0);
  return va;
}, Converter$1.prototype.isValid = function(Xn) {
  for (var zn = 0; zn < Xn.length; ++zn) if (this.srcAlphabet.indexOf(Xn[zn]) === -1) return !1;
  return !0;
};
var converter = Converter$1, Converter = converter;
function anyBase(Xn, zn) {
  var Un = new Converter(Xn, zn);
  return function(Kn) {
    return Un.convert(Kn);
  };
}
anyBase.BIN = "01", anyBase.OCT = "01234567", anyBase.DEC = "0123456789", anyBase.HEX = "0123456789abcdef";
var anyBase_1 = anyBase, anyBase$1 = getDefaultExportFromCjs(anyBase_1), __defProp$1 = Object.defineProperty, __defNormalProp$1 = (Xn, zn, Un) => zn in Xn ? __defProp$1(Xn, zn, { enumerable: !0, configurable: !0, writable: !0, value: Un }) : Xn[zn] = Un, __publicField$1 = (Xn, zn, Un) => __defNormalProp$1(Xn, typeof zn != "symbol" ? zn + "" : zn, Un);
class ImagePHash {
  constructor(zn, Un) {
    __publicField$1(this, "size"), __publicField$1(this, "smallerSize"), this.size = zn || 32, this.smallerSize = Un || 8, initCoefficients(this.size);
  }
  distance(zn, Un) {
    let Kn = 0;
    for (let qn = 0; qn < zn.length; qn++) zn[qn] !== Un[qn] && Kn++;
    return Kn / zn.length;
  }
  getHash(zn) {
    zn = methods$d.resize(clone(zn), { w: this.size, h: this.size }), zn = methods$e.greyscale(zn);
    const Un = [];
    for (let ma = 0; ma < zn.bitmap.width; ma++) {
      const va = [];
      for (let ba = 0; ba < zn.bitmap.height; ba++) va[ba] = intToRGBA(zn.getPixelColor(ma, ba)).b;
      Un[ma] = va;
    }
    const Kn = applyDCT(Un, this.size);
    let qn = 0;
    for (let ma = 0; ma < this.smallerSize; ma++) for (let va = 0; va < this.smallerSize; va++) qn += Kn[ma][va];
    const Jo = qn / (this.smallerSize * this.smallerSize);
    let pa = "";
    for (let ma = 0; ma < this.smallerSize; ma++) for (let va = 0; va < this.smallerSize; va++) pa += Kn[ma][va] > Jo ? "1" : "0";
    return pa;
  }
}
function intToRGBA(Xn) {
  const zn = 255 & Xn, Un = 255 & (Xn >>>= 8), Kn = 255 & (Xn >>>= 8);
  return { r: 255 & (Xn >>>= 8), g: Kn, b: Un, a: zn };
}
const c$1 = [];
function initCoefficients(Xn) {
  for (let zn = 1; zn < Xn; zn++) c$1[zn] = 1;
  c$1[0] = 1 / Math.sqrt(2);
}
function applyDCT(Xn, zn) {
  const Un = zn, Kn = [];
  for (let qn = 0; qn < Un; qn++) {
    const Jo = [];
    for (let pa = 0; pa < Un; pa++) {
      let ma = 0;
      for (let va = 0; va < Un; va++) for (let ba = 0; ba < Un; ba++) ma += Math.cos((2 * va + 1) / (2 * Un) * qn * Math.PI) * Math.cos((2 * ba + 1) / (2 * Un) * pa * Math.PI) * Xn[va][ba];
      ma *= c$1[qn] * c$1[pa] / 4, Jo[pa] = ma, Kn[qn] = Jo;
    }
  }
  return Kn;
}
const alphabet = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_", maxHashLength = [NaN, NaN];
for (let Xn = 2; Xn < 65; Xn++) {
  const zn = anyBase$1(anyBase$1.BIN, alphabet.slice(0, Xn))(new Array(65).join("1"));
  maxHashLength.push(zn.length);
}
const methods$5 = { pHash: (Xn) => new ImagePHash().getHash(Xn), hash(Xn, zn = 64) {
  if (zn < 2 || zn > 64) throw new Error("base must be a number between 2 and 64");
  const Un = alphabet.slice(0, zn), Kn = this.pHash(Xn), qn = maxHashLength[zn];
  return anyBase$1(anyBase$1.BIN, Un)(Kn).padStart(qn, "0");
}, distanceFromHash(Xn, zn) {
  const Un = new ImagePHash(), Kn = Un.getHash(Xn);
  return Un.distance(Kn, zn);
} }, MaskOptionsObjectSchema = z.object({ src: JimpClassSchema, x: z.number().optional(), y: z.number().optional() }), MaskOptionsSchema = z.union([JimpClassSchema, MaskOptionsObjectSchema]), methods$4 = { mask(Xn, zn) {
  let Un, Kn, qn;
  MaskOptionsSchema.parse(zn), "bitmap" in zn ? (Un = zn, Kn = 0, qn = 0) : (Un = zn.src, Kn = zn.x ?? 0, qn = zn.y ?? 0), Kn = Math.round(Kn), qn = Math.round(qn);
  const Jo = Xn.bitmap.width, pa = Xn.bitmap.height;
  return Un.scan(function(ma, va, ba) {
    const _a = Kn + ma, ya = qn + va;
    if (_a >= 0 && ya >= 0 && _a < Jo && ya < pa) {
      const xa = Xn.getPixelIndex(_a, ya), { data: wa } = Un.bitmap, Ta = (wa[ba + 0] + wa[ba + 1] + wa[ba + 2]) / 3;
      Xn.bitmap.data[xa + 3] *= Ta / 255;
    }
  }), Xn;
} };
function measureText(Xn, zn) {
  let Un = 0;
  for (let Kn = 0; Kn < zn.length; Kn++) {
    const qn = zn[Kn], Jo = Xn.chars[qn];
    if (Jo) {
      const pa = Xn.kernings[qn], ma = zn[Kn + 1], va = pa && ma && pa[ma] && pa[ma] || 0;
      Un += (Jo.xadvance || 0) + va;
    }
  }
  return Un;
}
function splitLines(Xn, zn, Un) {
  const Kn = zn.replace(/[\r\n]+/g, ` 
`).split(" "), qn = [];
  let Jo = [], pa = 0;
  return Kn.forEach((ma) => {
    if (measureText(Xn, ma + (Kn.length > 1 ? " " : "")) > Un) {
      const _a = ma[Symbol.iterator]();
      let ya = "";
      for (const xa of _a) {
        const wa = [...Jo, ya + xa].join(" "), Ta = measureText(Xn, wa);
        Ta < Un ? ya += xa : Ta > Un ? (qn.push([...Jo, ya]), Jo = [], ya = xa) : (qn.push([...Jo, ya + xa]), Jo = [], ya = "");
      }
      return;
    }
    const va = [...Jo, ma].join(" "), ba = measureText(Xn, va);
    ba <= Un && !ma.includes(`
`) ? (ba > pa && (pa = ba), Jo.push(ma)) : (qn.push(Jo), Jo = [ma.replace(`
`, "")]);
  }), qn.push(Jo), { lines: qn, longestLine: pa };
}
function measureTextHeight(Xn, zn, Un) {
  const { lines: Kn } = splitLines(Xn, zn, Un);
  return Kn.length * Xn.common.lineHeight;
}
const PrintOptionsSchema = z.object({ x: z.number(), y: z.number(), text: z.union([z.union([z.string(), z.number()]), z.object({ text: z.union([z.string(), z.number()]), alignmentX: z.nativeEnum(HorizontalAlign).optional(), alignmentY: z.nativeEnum(VerticalAlign).optional() })]), maxWidth: z.number().optional(), maxHeight: z.number().optional(), cb: z.function(z.tuple([z.object({ x: z.number(), y: z.number() })])).optional() });
function xOffsetBasedOnAlignment(Xn, zn, Un, Kn) {
  return Kn === HorizontalAlign.LEFT ? 0 : Kn === HorizontalAlign.CENTER ? (Un - measureText(Xn, zn)) / 2 : Un - measureText(Xn, zn);
}
function drawCharacter(Xn, zn, Un, Kn, qn) {
  if (qn.width > 0 && qn.height > 0) {
    const Jo = zn.pages[qn.page];
    Jo && (Xn = methods$h.blit(Xn, { src: Jo, x: Un + qn.xoffset, y: Kn + qn.yoffset, srcX: qn.x, srcY: qn.y, srcW: qn.width, srcH: qn.height }));
  }
  return Xn;
}
function printText(Xn, zn, Un, Kn, qn, Jo) {
  for (let pa = 0; pa < qn.length; pa++) {
    const ma = qn[pa];
    let va;
    va = zn.chars[ma] ? ma : /\s/.test(ma) ? "" : "?";
    const ba = zn.chars[va] || { xadvance: void 0 }, _a = zn.kernings[va];
    ba && drawCharacter(Xn, zn, Un, Kn, ba);
    const ya = qn[pa + 1];
    Un += (_a && ya && _a[ya] && _a[ya] || 0) + (ba.xadvance || Jo);
  }
}
const methods$3 = { print(Xn, { font: zn, ...Un }) {
  var Ta;
  let Kn, qn, { x: Jo, y: pa, text: ma, maxWidth: va = 1 / 0, maxHeight: ba = 1 / 0, cb: _a = () => {
  } } = PrintOptionsSchema.parse(Un);
  typeof ma == "object" && ma.text !== null && ma.text !== void 0 ? (Kn = ma.alignmentX || HorizontalAlign.LEFT, qn = ma.alignmentY || VerticalAlign.TOP, { text: ma } = ma) : (Kn = HorizontalAlign.LEFT, qn = VerticalAlign.TOP, ma = ma.toString()), typeof ma == "number" && (ma = ma.toString()), ba !== 1 / 0 && qn === VerticalAlign.BOTTOM ? pa += ba - measureTextHeight(zn, ma, va) : ba !== 1 / 0 && qn === VerticalAlign.MIDDLE && (pa += ba / 2 - measureTextHeight(zn, ma, va) / 2);
  const ya = (Ta = Object.entries(zn.chars).find((Sa) => Sa[1].xadvance)) == null ? void 0 : Ta[1].xadvance;
  if (typeof ya != "number") throw new Error("Could not find default character width");
  const { lines: xa, longestLine: wa } = splitLines(zn, ma, va);
  return xa.forEach((Sa) => {
    const Ma = Sa.join(" "), ka = xOffsetBasedOnAlignment(zn, Ma, va, Kn);
    printText(Xn, zn, Jo + ka, pa, Ma, ya), pa += zn.common.lineHeight;
  }), _a.bind(Xn)({ x: Jo + wa, y: pa }), Xn;
} }, RotateOptionsSchema = z.union([z.number(), z.object({ deg: z.number(), mode: z.union([z.boolean(), z.nativeEnum(ResizeStrategy)]).optional() })]);
function createIdxTranslationFunction(Xn) {
  return function(zn, Un) {
    return Un * Xn + zn << 2;
  };
}
function matrixRotate(Xn, zn) {
  if (Math.abs(zn) % 90 != 0) throw new Error("Unsupported matrix rotation degree");
  const Un = Xn.bitmap.width, Kn = Xn.bitmap.height;
  let qn;
  switch (zn) {
    case 90:
    case -270:
      qn = 90;
      break;
    case 180:
    case -180:
      qn = 180;
      break;
    case 270:
    case -90:
      qn = -90;
      break;
    default:
      throw new Error("Unsupported matrix rotation degree");
  }
  const Jo = qn === 180 ? Un : Kn, pa = qn === 180 ? Kn : Un, ma = Buffer$1.alloc(Xn.bitmap.data.length), va = createIdxTranslationFunction(Un), ba = createIdxTranslationFunction(Jo);
  for (let _a = 0; _a < Un; _a++) for (let ya = 0; ya < Kn; ya++) {
    const xa = va(_a, ya), wa = Xn.bitmap.data.readUInt32BE(xa);
    let Ta;
    switch (qn) {
      case 90:
        Ta = ba(ya, Un - _a - 1);
        break;
      case -90:
        Ta = ba(Kn - ya - 1, _a);
        break;
      case 180:
        Ta = ba(Un - _a - 1, Kn - ya - 1);
        break;
      default:
        throw new Error("Unsupported matrix rotation angle");
    }
    ma.writeUInt32BE(wa, Ta);
  }
  Xn.bitmap.data = ma, Xn.bitmap.width = Jo, Xn.bitmap.height = pa;
}
function createTranslationFunction(Xn, zn) {
  return function(Un, Kn) {
    return { x: Un + Xn, y: Kn + zn };
  };
}
function advancedRotate(Xn, zn, Un) {
  const Kn = zn * Math.PI / 180, qn = Math.cos(Kn), Jo = Math.sin(Kn);
  let pa = Xn.bitmap.width, ma = Xn.bitmap.height;
  if (Un === !0 || typeof Un == "string") {
    pa = Math.ceil(Math.abs(Xn.bitmap.width * qn) + Math.abs(Xn.bitmap.height * Jo)) + 1, ma = Math.ceil(Math.abs(Xn.bitmap.width * Jo) + Math.abs(Xn.bitmap.height * qn)) + 1, pa % 2 != 0 && pa++, ma % 2 != 0 && ma++;
    const wa = clone(Xn);
    Xn.scan((Sa, Ma, ka) => {
      Xn.bitmap.data.writeUInt32BE(Xn.background, ka);
    });
    const Ta = Math.max(pa, ma, Xn.bitmap.width, Xn.bitmap.height);
    Xn = composite(Xn = methods$d.resize(Xn, { h: Ta, w: Ta, mode: Un === !0 ? void 0 : Un }), wa, Xn.bitmap.width / 2 - wa.bitmap.width / 2, Xn.bitmap.height / 2 - wa.bitmap.height / 2);
  }
  const va = Xn.bitmap.width, ba = Xn.bitmap.height, _a = Buffer$1.alloc(Xn.bitmap.data.length), ya = createTranslationFunction(-va / 2, -ba / 2), xa = createTranslationFunction(va / 2 + 0.5, ba / 2 + 0.5);
  for (let wa = 1; wa <= ba; wa++) for (let Ta = 1; Ta <= va; Ta++) {
    const Sa = ya(Ta, wa), Ma = xa(qn * Sa.x - Jo * Sa.y, qn * Sa.y + Jo * Sa.x), ka = va * (wa - 1) + Ta - 1 << 2;
    if (Ma.x >= 0 && Ma.x < va && Ma.y >= 0 && Ma.y < ba) {
      const Za = va * (0 | Ma.y) + Ma.x << 2, Na = Xn.bitmap.data.readUInt32BE(Za);
      _a.writeUInt32BE(Na, ka);
    } else _a.writeUInt32BE(Xn.background, ka);
  }
  if (Xn.bitmap.data = _a, Un === !0 || typeof Un == "string") {
    const wa = Math.max(va / 2 - pa / 2, 0), Ta = Math.max(ba / 2 - ma / 2, 0);
    Xn = methods$b.crop(Xn, { x: wa, y: Ta, w: pa, h: ma });
  }
}
const methods$2 = { rotate(Xn, zn) {
  const Un = RotateOptionsSchema.parse(zn), Kn = typeof Un == "number" ? { deg: Un } : Un, { mode: qn = !0 } = Kn;
  let { deg: Jo } = Kn;
  return Jo %= 360, Jo % 360 == 0 || (Jo % 90 == 0 && (qn || Xn.bitmap.width === Xn.bitmap.height || Jo % 180 == 0) ? matrixRotate(Xn, Jo) : advancedRotate(Xn, Jo, qn)), Xn;
} }, ThresholdOptionsSchema = z.object({ max: z.number().min(0).max(255), replace: z.number().min(0).max(255).optional(), autoGreyscale: z.boolean().optional() }), methods$1 = { threshold(Xn, zn) {
  let { max: Un, replace: Kn = 255, autoGreyscale: qn = !0 } = ThresholdOptionsSchema.parse(zn);
  return Un = limit255(Un), Kn = limit255(Kn), qn && methods$e.greyscale(Xn), Xn.scan((Jo, pa, ma) => {
    const va = Xn.bitmap.data[ma] < Un ? Xn.bitmap.data[ma] : Kn;
    Xn.bitmap.data[ma] = va, Xn.bitmap.data[ma + 1] = va, Xn.bitmap.data[ma + 2] = va;
  }), Xn;
} };
var __defProp = Object.defineProperty, __defNormalProp = (Xn, zn, Un) => zn in Xn ? __defProp(Xn, zn, { enumerable: !0, configurable: !0, writable: !0, value: Un }) : Xn[zn] = Un, __export = (Xn, zn) => {
  for (var Un in zn) __defProp(Xn, Un, { get: zn[Un], enumerable: !0 });
}, __publicField = (Xn, zn, Un) => (__defNormalProp(Xn, typeof zn != "symbol" ? zn + "" : zn, Un), Un), constants_exports = {};
__export(constants_exports, { bt709: () => bt709_exports });
var bt709_exports = {};
__export(bt709_exports, { Y: () => Y, x: () => x$1, y: () => y$1 });
var Y = ((Xn) => (Xn[Xn.RED = 0.2126] = "RED", Xn[Xn.GREEN = 0.7152] = "GREEN", Xn[Xn.BLUE = 0.0722] = "BLUE", Xn[Xn.WHITE = 1] = "WHITE", Xn))(Y || {}), x$1 = ((Xn) => (Xn[Xn.RED = 0.64] = "RED", Xn[Xn.GREEN = 0.3] = "GREEN", Xn[Xn.BLUE = 0.15] = "BLUE", Xn[Xn.WHITE = 0.3127] = "WHITE", Xn))(x$1 || {}), y$1 = ((Xn) => (Xn[Xn.RED = 0.33] = "RED", Xn[Xn.GREEN = 0.6] = "GREEN", Xn[Xn.BLUE = 0.06] = "BLUE", Xn[Xn.WHITE = 0.329] = "WHITE", Xn))(y$1 || {}), conversion_exports = {};
function correctGamma(Xn) {
  return Xn > 0.04045 ? ((Xn + 0.055) / 1.055) ** 2.4 : Xn / 12.92;
}
function rgb2xyz(Xn, zn, Un) {
  return { x: 0.4124 * (Xn = correctGamma(Xn / 255)) + 0.3576 * (zn = correctGamma(zn / 255)) + 0.1805 * (Un = correctGamma(Un / 255)), y: 0.2126 * Xn + 0.7152 * zn + 0.0722 * Un, z: 0.0193 * Xn + 0.1192 * zn + 0.9505 * Un };
}
__export(conversion_exports, { lab2rgb: () => lab2rgb, lab2xyz: () => lab2xyz, rgb2hsl: () => rgb2hsl, rgb2lab: () => rgb2lab, rgb2xyz: () => rgb2xyz, xyz2lab: () => xyz2lab, xyz2rgb: () => xyz2rgb });
var arithmetic_exports = {};
function degrees2radians(Xn) {
  return Xn * (Math.PI / 180);
}
function max3(Xn, zn, Un) {
  let Kn = Xn;
  return Kn < zn && (Kn = zn), Kn < Un && (Kn = Un), Kn;
}
function min3(Xn, zn, Un) {
  let Kn = Xn;
  return Kn > zn && (Kn = zn), Kn > Un && (Kn = Un), Kn;
}
function intInRange(Xn, zn, Un) {
  return Xn > Un && (Xn = Un), Xn < zn && (Xn = zn), 0 | Xn;
}
function inRange0to255Rounded(Xn) {
  return (Xn = Math.round(Xn)) > 255 ? Xn = 255 : Xn < 0 && (Xn = 0), Xn;
}
function inRange0to255(Xn) {
  return Xn > 255 ? Xn = 255 : Xn < 0 && (Xn = 0), Xn;
}
function stableSort(Xn, zn) {
  const Un = typeof Xn[0];
  let Kn;
  if (Un === "number" || Un === "string") {
    const qn = /* @__PURE__ */ Object.create(null);
    for (let Jo = 0, pa = Xn.length; Jo < pa; Jo++) {
      const ma = Xn[Jo];
      qn[ma] || qn[ma] === 0 || (qn[ma] = Jo);
    }
    Kn = Xn.sort((Jo, pa) => zn(Jo, pa) || qn[Jo] - qn[pa]);
  } else {
    const qn = Xn.slice(0);
    Kn = Xn.sort((Jo, pa) => zn(Jo, pa) || qn.indexOf(Jo) - qn.indexOf(pa));
  }
  return Kn;
}
function rgb2hsl(Xn, zn, Un) {
  const Kn = min3(Xn, zn, Un), qn = max3(Xn, zn, Un), Jo = qn - Kn, pa = (Kn + qn) / 510;
  let ma = 0;
  pa > 0 && pa < 1 && (ma = Jo / (pa < 0.5 ? qn + Kn : 510 - qn - Kn));
  let va = 0;
  return Jo > 0 && (va = qn === Xn ? (zn - Un) / Jo : qn === zn ? 2 + (Un - Xn) / Jo : 4 + (Xn - zn) / Jo, va *= 60, va < 0 && (va += 360)), { h: va, s: ma, l: pa };
}
__export(arithmetic_exports, { degrees2radians: () => degrees2radians, inRange0to255: () => inRange0to255, inRange0to255Rounded: () => inRange0to255Rounded, intInRange: () => intInRange, max3: () => max3, min3: () => min3, stableSort: () => stableSort });
var refX = 0.95047, refY = 1, refZ = 1.08883;
function pivot(Xn) {
  return Xn > 8856e-6 ? Xn ** (1 / 3) : 7.787 * Xn + 16 / 116;
}
function xyz2lab(Xn, zn, Un) {
  if (Xn = pivot(Xn / refX), zn = pivot(zn / refY), Un = pivot(Un / refZ), 116 * zn - 16 < 0) throw new Error("xxx");
  return { L: Math.max(0, 116 * zn - 16), a: 500 * (Xn - zn), b: 200 * (zn - Un) };
}
function rgb2lab(Xn, zn, Un) {
  const Kn = rgb2xyz(Xn, zn, Un);
  return xyz2lab(Kn.x, Kn.y, Kn.z);
}
var refX2 = 0.95047, refY2 = 1, refZ2 = 1.08883;
function pivot2(Xn) {
  return Xn > 0.206893034 ? Xn ** 3 : (Xn - 16 / 116) / 7.787;
}
function lab2xyz(Xn, zn, Un) {
  const Kn = (Xn + 16) / 116, qn = Kn - Un / 200;
  return { x: refX2 * pivot2(zn / 500 + Kn), y: refY2 * pivot2(Kn), z: refZ2 * pivot2(qn) };
}
function correctGamma2(Xn) {
  return Xn > 31308e-7 ? 1.055 * Xn ** (1 / 2.4) - 0.055 : 12.92 * Xn;
}
function xyz2rgb(Xn, zn, Un) {
  const Kn = correctGamma2(3.2406 * Xn + -1.5372 * zn + -0.4986 * Un), qn = correctGamma2(-0.9689 * Xn + 1.8758 * zn + 0.0415 * Un), Jo = correctGamma2(0.0557 * Xn + -0.204 * zn + 1.057 * Un);
  return { r: inRange0to255Rounded(255 * Kn), g: inRange0to255Rounded(255 * qn), b: inRange0to255Rounded(255 * Jo) };
}
function lab2rgb(Xn, zn, Un) {
  const Kn = lab2xyz(Xn, zn, Un);
  return xyz2rgb(Kn.x, Kn.y, Kn.z);
}
var distance_exports = {};
__export(distance_exports, { AbstractDistanceCalculator: () => AbstractDistanceCalculator, AbstractEuclidean: () => AbstractEuclidean, AbstractManhattan: () => AbstractManhattan, CIE94GraphicArts: () => CIE94GraphicArts, CIE94Textiles: () => CIE94Textiles, CIEDE2000: () => CIEDE2000, CMetric: () => CMetric, Euclidean: () => Euclidean, EuclideanBT709: () => EuclideanBT709, EuclideanBT709NoAlpha: () => EuclideanBT709NoAlpha, Manhattan: () => Manhattan, ManhattanBT709: () => ManhattanBT709, ManhattanNommyde: () => ManhattanNommyde, PNGQuant: () => PNGQuant });
var AbstractDistanceCalculator = class {
  constructor() {
    __publicField(this, "_maxDistance"), __publicField(this, "_whitePoint"), this._setDefaults(), this.setWhitePoint(255, 255, 255, 255);
  }
  setWhitePoint(Xn, zn, Un, Kn) {
    this._whitePoint = { r: Xn > 0 ? 255 / Xn : 0, g: zn > 0 ? 255 / zn : 0, b: Un > 0 ? 255 / Un : 0, a: Kn > 0 ? 255 / Kn : 0 }, this._maxDistance = this.calculateRaw(Xn, zn, Un, Kn, 0, 0, 0, 0);
  }
  calculateNormalized(Xn, zn) {
    return this.calculateRaw(Xn.r, Xn.g, Xn.b, Xn.a, zn.r, zn.g, zn.b, zn.a) / this._maxDistance;
  }
}, AbstractCIE94 = class extends AbstractDistanceCalculator {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = rgb2lab(inRange0to255(Xn * this._whitePoint.r), inRange0to255(zn * this._whitePoint.g), inRange0to255(Un * this._whitePoint.b)), ba = rgb2lab(inRange0to255(qn * this._whitePoint.r), inRange0to255(Jo * this._whitePoint.g), inRange0to255(pa * this._whitePoint.b)), _a = va.L - ba.L, ya = va.a - ba.a, xa = va.b - ba.b, wa = Math.sqrt(va.a * va.a + va.b * va.b), Ta = wa - Math.sqrt(ba.a * ba.a + ba.b * ba.b);
    let Sa = ya * ya + xa * xa - Ta * Ta;
    Sa = Sa < 0 ? 0 : Math.sqrt(Sa);
    const Ma = (ma - Kn) * this._whitePoint.a * this._kA;
    return Math.sqrt((_a / this._Kl) ** 2 + (Ta / (1 + this._K1 * wa)) ** 2 + (Sa / (1 + this._K2 * wa)) ** 2 + Ma ** 2);
  }
}, CIE94Textiles = class extends AbstractCIE94 {
  _setDefaults() {
    this._Kl = 2, this._K1 = 0.048, this._K2 = 0.014, this._kA = 12.5 / 255;
  }
}, CIE94GraphicArts = class extends AbstractCIE94 {
  _setDefaults() {
    this._Kl = 1, this._K1 = 0.045, this._K2 = 0.015, this._kA = 25 / 255;
  }
}, _CIEDE2000 = class extends AbstractDistanceCalculator {
  _setDefaults() {
  }
  static _calculatehp(Xn, zn) {
    const Un = Math.atan2(Xn, zn);
    return Un >= 0 ? Un : Un + _CIEDE2000._deg360InRad;
  }
  static _calculateRT(Xn, zn) {
    const Un = zn ** 7, Kn = 2 * Math.sqrt(Un / (Un + _CIEDE2000._pow25to7)), qn = _CIEDE2000._deg30InRad * Math.exp(-(((Xn - _CIEDE2000._deg275InRad) / _CIEDE2000._deg25InRad) ** 2));
    return -Math.sin(2 * qn) * Kn;
  }
  static _calculateT(Xn) {
    return 1 - 0.17 * Math.cos(Xn - _CIEDE2000._deg30InRad) + 0.24 * Math.cos(2 * Xn) + 0.32 * Math.cos(3 * Xn + _CIEDE2000._deg6InRad) - 0.2 * Math.cos(4 * Xn - _CIEDE2000._deg63InRad);
  }
  static _calculate_ahp(Xn, zn, Un, Kn) {
    const qn = Un + Kn;
    return Xn === 0 ? qn : zn <= _CIEDE2000._deg180InRad ? qn / 2 : qn < _CIEDE2000._deg360InRad ? (qn + _CIEDE2000._deg360InRad) / 2 : (qn - _CIEDE2000._deg360InRad) / 2;
  }
  static _calculate_dHp(Xn, zn, Un, Kn) {
    let qn;
    return qn = Xn === 0 ? 0 : zn <= _CIEDE2000._deg180InRad ? Un - Kn : Un <= Kn ? Un - Kn + _CIEDE2000._deg360InRad : Un - Kn - _CIEDE2000._deg360InRad, 2 * Math.sqrt(Xn) * Math.sin(qn / 2);
  }
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = rgb2lab(inRange0to255(Xn * this._whitePoint.r), inRange0to255(zn * this._whitePoint.g), inRange0to255(Un * this._whitePoint.b)), ba = rgb2lab(inRange0to255(qn * this._whitePoint.r), inRange0to255(Jo * this._whitePoint.g), inRange0to255(pa * this._whitePoint.b)), _a = (ma - Kn) * this._whitePoint.a * _CIEDE2000._kA, ya = this.calculateRawInLab(va, ba);
    return Math.sqrt(ya + _a * _a);
  }
  calculateRawInLab(Xn, zn) {
    const Un = Xn.L, Kn = Xn.a, qn = Xn.b, Jo = zn.L, pa = zn.a, ma = zn.b, va = ((Math.sqrt(Kn * Kn + qn * qn) + Math.sqrt(pa * pa + ma * ma)) / 2) ** 7, ba = 0.5 * (1 - Math.sqrt(va / (va + _CIEDE2000._pow25to7))), _a = (1 + ba) * Kn, ya = (1 + ba) * pa, xa = Math.sqrt(_a * _a + qn * qn), wa = Math.sqrt(ya * ya + ma * ma), Ta = xa * wa, Sa = _CIEDE2000._calculatehp(qn, _a), Ma = _CIEDE2000._calculatehp(ma, ya), ka = Math.abs(Sa - Ma), Za = Jo - Un, Na = wa - xa, Ka = _CIEDE2000._calculate_dHp(Ta, ka, Ma, Sa), Ja = _CIEDE2000._calculate_ahp(Ta, ka, Sa, Ma), el = (xa + wa) / 2, qa = ((Un + Jo) / 2 - 50) ** 2, tl = Na / (1 + 0.045 * el), Qa = Ka / (1 + 0.015 * _CIEDE2000._calculateT(Ja) * el);
    return (Za / (1 + 0.015 * qa / Math.sqrt(20 + qa))) ** 2 + tl ** 2 + Qa ** 2 + _CIEDE2000._calculateRT(Ja, el) * tl * Qa;
  }
}, CIEDE2000 = _CIEDE2000;
__publicField(CIEDE2000, "_kA", 25 / 255), __publicField(CIEDE2000, "_pow25to7", 25 ** 7), __publicField(CIEDE2000, "_deg360InRad", degrees2radians(360)), __publicField(CIEDE2000, "_deg180InRad", degrees2radians(180)), __publicField(CIEDE2000, "_deg30InRad", degrees2radians(30)), __publicField(CIEDE2000, "_deg6InRad", degrees2radians(6)), __publicField(CIEDE2000, "_deg63InRad", degrees2radians(63)), __publicField(CIEDE2000, "_deg275InRad", degrees2radians(275)), __publicField(CIEDE2000, "_deg25InRad", degrees2radians(25));
var CMetric = class extends AbstractDistanceCalculator {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = (Xn + qn) / 2 * this._whitePoint.r, ba = (Xn - qn) * this._whitePoint.r, _a = (zn - Jo) * this._whitePoint.g, ya = (Un - pa) * this._whitePoint.b, xa = ((512 + va) * ba * ba >> 8) + 4 * _a * _a + ((767 - va) * ya * ya >> 8), wa = (ma - Kn) * this._whitePoint.a;
    return Math.sqrt(xa + wa * wa);
  }
  _setDefaults() {
  }
}, AbstractEuclidean = class extends AbstractDistanceCalculator {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = qn - Xn, ba = Jo - zn, _a = pa - Un, ya = ma - Kn;
    return Math.sqrt(this._kR * va * va + this._kG * ba * ba + this._kB * _a * _a + this._kA * ya * ya);
  }
}, Euclidean = class extends AbstractEuclidean {
  _setDefaults() {
    this._kR = 1, this._kG = 1, this._kB = 1, this._kA = 1;
  }
}, EuclideanBT709 = class extends AbstractEuclidean {
  _setDefaults() {
    this._kR = 0.2126, this._kG = 0.7152, this._kB = 0.0722, this._kA = 1;
  }
}, EuclideanBT709NoAlpha = class extends AbstractEuclidean {
  _setDefaults() {
    this._kR = 0.2126, this._kG = 0.7152, this._kB = 0.0722, this._kA = 0;
  }
}, AbstractManhattan = class extends AbstractDistanceCalculator {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    let va = qn - Xn, ba = Jo - zn, _a = pa - Un, ya = ma - Kn;
    return va < 0 && (va = 0 - va), ba < 0 && (ba = 0 - ba), _a < 0 && (_a = 0 - _a), ya < 0 && (ya = 0 - ya), this._kR * va + this._kG * ba + this._kB * _a + this._kA * ya;
  }
}, Manhattan = class extends AbstractManhattan {
  _setDefaults() {
    this._kR = 1, this._kG = 1, this._kB = 1, this._kA = 1;
  }
}, ManhattanNommyde = class extends AbstractManhattan {
  _setDefaults() {
    this._kR = 0.4984, this._kG = 0.8625, this._kB = 0.2979, this._kA = 1;
  }
}, ManhattanBT709 = class extends AbstractManhattan {
  _setDefaults() {
    this._kR = 0.2126, this._kG = 0.7152, this._kB = 0.0722, this._kA = 1;
  }
}, PNGQuant = class extends AbstractDistanceCalculator {
  calculateRaw(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
    const va = (ma - Kn) * this._whitePoint.a;
    return this._colordifferenceCh(Xn * this._whitePoint.r, qn * this._whitePoint.r, va) + this._colordifferenceCh(zn * this._whitePoint.g, Jo * this._whitePoint.g, va) + this._colordifferenceCh(Un * this._whitePoint.b, pa * this._whitePoint.b, va);
  }
  _colordifferenceCh(Xn, zn, Un) {
    const Kn = Xn - zn, qn = Kn + Un;
    return Kn * Kn + qn * qn;
  }
  _setDefaults() {
  }
}, palette_exports = {};
__export(palette_exports, { AbstractPaletteQuantizer: () => AbstractPaletteQuantizer, ColorHistogram: () => ColorHistogram, NeuQuant: () => NeuQuant, NeuQuantFloat: () => NeuQuantFloat, RGBQuant: () => RGBQuant, WuColorCube: () => WuColorCube, WuQuant: () => WuQuant });
var AbstractPaletteQuantizer = class {
  quantizeSync() {
    for (const Xn of this.quantize()) if (Xn.palette) return Xn.palette;
    throw new Error("unreachable");
  }
}, Point = class {
  constructor() {
    __publicField(this, "r"), __publicField(this, "g"), __publicField(this, "b"), __publicField(this, "a"), __publicField(this, "uint32"), __publicField(this, "rgba"), this.uint32 = -1 >>> 0, this.r = this.g = this.b = this.a = 0, this.rgba = new Array(4), this.rgba[0] = 0, this.rgba[1] = 0, this.rgba[2] = 0, this.rgba[3] = 0;
  }
  static createByQuadruplet(Xn) {
    const zn = new Point();
    return zn.r = 0 | Xn[0], zn.g = 0 | Xn[1], zn.b = 0 | Xn[2], zn.a = 0 | Xn[3], zn._loadUINT32(), zn._loadQuadruplet(), zn;
  }
  static createByRGBA(Xn, zn, Un, Kn) {
    const qn = new Point();
    return qn.r = 0 | Xn, qn.g = 0 | zn, qn.b = 0 | Un, qn.a = 0 | Kn, qn._loadUINT32(), qn._loadQuadruplet(), qn;
  }
  static createByUint32(Xn) {
    const zn = new Point();
    return zn.uint32 = Xn >>> 0, zn._loadRGBA(), zn._loadQuadruplet(), zn;
  }
  from(Xn) {
    this.r = Xn.r, this.g = Xn.g, this.b = Xn.b, this.a = Xn.a, this.uint32 = Xn.uint32, this.rgba[0] = Xn.r, this.rgba[1] = Xn.g, this.rgba[2] = Xn.b, this.rgba[3] = Xn.a;
  }
  getLuminosity(Xn) {
    let zn = this.r, Un = this.g, Kn = this.b;
    return Xn && (zn = Math.min(255, 255 - this.a + this.a * zn / 255), Un = Math.min(255, 255 - this.a + this.a * Un / 255), Kn = Math.min(255, 255 - this.a + this.a * Kn / 255)), 0.2126 * zn + 0.7152 * Un + 0.0722 * Kn;
  }
  _loadUINT32() {
    this.uint32 = (this.a << 24 | this.b << 16 | this.g << 8 | this.r) >>> 0;
  }
  _loadRGBA() {
    this.r = 255 & this.uint32, this.g = this.uint32 >>> 8 & 255, this.b = this.uint32 >>> 16 & 255, this.a = this.uint32 >>> 24 & 255;
  }
  _loadQuadruplet() {
    this.rgba[0] = this.r, this.rgba[1] = this.g, this.rgba[2] = this.b, this.rgba[3] = this.a;
  }
}, PointContainer = class {
  constructor() {
    __publicField(this, "_pointArray"), __publicField(this, "_width"), __publicField(this, "_height"), this._width = 0, this._height = 0, this._pointArray = [];
  }
  getWidth() {
    return this._width;
  }
  getHeight() {
    return this._height;
  }
  setWidth(Xn) {
    this._width = Xn;
  }
  setHeight(Xn) {
    this._height = Xn;
  }
  getPointArray() {
    return this._pointArray;
  }
  clone() {
    const Xn = new PointContainer();
    Xn._width = this._width, Xn._height = this._height;
    for (let zn = 0, Un = this._pointArray.length; zn < Un; zn++) Xn._pointArray[zn] = Point.createByUint32(0 | this._pointArray[zn].uint32);
    return Xn;
  }
  toUint32Array() {
    const Xn = this._pointArray.length, zn = new Uint32Array(Xn);
    for (let Un = 0; Un < Xn; Un++) zn[Un] = this._pointArray[Un].uint32;
    return zn;
  }
  toUint8Array() {
    return new Uint8Array(this.toUint32Array().buffer);
  }
  static fromHTMLImageElement(Xn) {
    const zn = Xn.naturalWidth, Un = Xn.naturalHeight, Kn = document.createElement("canvas");
    return Kn.width = zn, Kn.height = Un, Kn.getContext("2d").drawImage(Xn, 0, 0, zn, Un, 0, 0, zn, Un), PointContainer.fromHTMLCanvasElement(Kn);
  }
  static fromHTMLCanvasElement(Xn) {
    const zn = Xn.width, Un = Xn.height, Kn = Xn.getContext("2d").getImageData(0, 0, zn, Un);
    return PointContainer.fromImageData(Kn);
  }
  static fromImageData(Xn) {
    const zn = Xn.width, Un = Xn.height;
    return PointContainer.fromUint8Array(Xn.data, zn, Un);
  }
  static fromUint8Array(Xn, zn, Un) {
    switch (Object.prototype.toString.call(Xn)) {
      case "[object Uint8ClampedArray]":
      case "[object Uint8Array]":
        break;
      default:
        Xn = new Uint8Array(Xn);
    }
    const Kn = new Uint32Array(Xn.buffer);
    return PointContainer.fromUint32Array(Kn, zn, Un);
  }
  static fromUint32Array(Xn, zn, Un) {
    const Kn = new PointContainer();
    Kn._width = zn, Kn._height = Un;
    for (let qn = 0, Jo = Xn.length; qn < Jo; qn++) Kn._pointArray[qn] = Point.createByUint32(0 | Xn[qn]);
    return Kn;
  }
  static fromBuffer(Xn, zn, Un) {
    const Kn = new Uint32Array(Xn.buffer, Xn.byteOffset, Xn.byteLength / Uint32Array.BYTES_PER_ELEMENT);
    return PointContainer.fromUint32Array(Kn, zn, Un);
  }
}, hueGroups = 10;
function hueGroup(Xn, zn) {
  const Un = 360 / zn;
  for (let Kn = 1, qn = Un - Un / 2; Kn < zn; Kn++, qn += Un) if (Xn >= qn && Xn < qn + Un) return Kn;
  return 0;
}
var Palette = class {
  constructor() {
    __publicField(this, "_pointContainer"), __publicField(this, "_pointArray", []), __publicField(this, "_i32idx", {}), this._pointContainer = new PointContainer(), this._pointContainer.setHeight(1), this._pointArray = this._pointContainer.getPointArray();
  }
  add(Xn) {
    this._pointArray.push(Xn), this._pointContainer.setWidth(this._pointArray.length);
  }
  has(Xn) {
    for (let zn = this._pointArray.length - 1; zn >= 0; zn--) if (Xn.uint32 === this._pointArray[zn].uint32) return !0;
    return !1;
  }
  getNearestColor(Xn, zn) {
    return this._pointArray[0 | this._getNearestIndex(Xn, zn)];
  }
  getPointContainer() {
    return this._pointContainer;
  }
  _nearestPointFromCache(Xn) {
    return typeof this._i32idx[Xn] == "number" ? this._i32idx[Xn] : -1;
  }
  _getNearestIndex(Xn, zn) {
    let Un = this._nearestPointFromCache("" + zn.uint32);
    if (Un >= 0) return Un;
    let Kn = Number.MAX_VALUE;
    Un = 0;
    for (let qn = 0, Jo = this._pointArray.length; qn < Jo; qn++) {
      const pa = this._pointArray[qn], ma = Xn.calculateRaw(zn.r, zn.g, zn.b, zn.a, pa.r, pa.g, pa.b, pa.a);
      ma < Kn && (Kn = ma, Un = qn);
    }
    return this._i32idx[zn.uint32] = Un, Un;
  }
  sort() {
    this._i32idx = {}, this._pointArray.sort((Xn, zn) => {
      const Un = rgb2hsl(Xn.r, Xn.g, Xn.b), Kn = rgb2hsl(zn.r, zn.g, zn.b), qn = Xn.r === Xn.g && Xn.g === Xn.b ? 0 : 1 + hueGroup(Un.h, hueGroups), Jo = (zn.r === zn.g && zn.g === zn.b ? 0 : 1 + hueGroup(Kn.h, hueGroups)) - qn;
      if (Jo) return -Jo;
      const pa = Xn.getLuminosity(!0), ma = zn.getLuminosity(!0);
      if (ma - pa != 0) return ma - pa;
      const va = (100 * Kn.s | 0) - (100 * Un.s | 0);
      return va ? -va : 0;
    });
  }
}, utils_exports = {};
__export(utils_exports, { HueStatistics: () => HueStatistics, Palette: () => Palette, Point: () => Point, PointContainer: () => PointContainer, ProgressTracker: () => ProgressTracker, arithmetic: () => arithmetic_exports });
var HueGroup = class {
  constructor() {
    __publicField(this, "num", 0), __publicField(this, "cols", []);
  }
}, HueStatistics = class {
  constructor(Xn, zn) {
    __publicField(this, "_numGroups"), __publicField(this, "_minCols"), __publicField(this, "_stats"), __publicField(this, "_groupsFull"), this._numGroups = Xn, this._minCols = zn, this._stats = [];
    for (let Un = 0; Un <= Xn; Un++) this._stats[Un] = new HueGroup();
    this._groupsFull = 0;
  }
  check(Xn) {
    this._groupsFull === this._numGroups + 1 && (this.check = () => {
    });
    const zn = 255 & Xn, Un = Xn >>> 8 & 255, Kn = Xn >>> 16 & 255, qn = zn === Un && Un === Kn ? 0 : 1 + hueGroup(rgb2hsl(zn, Un, Kn).h, this._numGroups), Jo = this._stats[qn], pa = this._minCols;
    Jo.num++, Jo.num > pa || (Jo.num === pa && this._groupsFull++, Jo.num <= pa && this._stats[qn].cols.push(Xn));
  }
  injectIntoDictionary(Xn) {
    for (let zn = 0; zn <= this._numGroups; zn++) this._stats[zn].num <= this._minCols && this._stats[zn].cols.forEach((Un) => {
      Xn[Un] ? Xn[Un]++ : Xn[Un] = 1;
    });
  }
  injectIntoArray(Xn) {
    for (let zn = 0; zn <= this._numGroups; zn++) this._stats[zn].num <= this._minCols && this._stats[zn].cols.forEach((Un) => {
      Xn.indexOf(Un) === -1 && Xn.push(Un);
    });
  }
}, _ProgressTracker = class {
  constructor(Xn, zn) {
    __publicField(this, "progress"), __publicField(this, "_step"), __publicField(this, "_range"), __publicField(this, "_last"), __publicField(this, "_progressRange"), this._range = Xn, this._progressRange = zn, this._step = Math.max(1, this._range / (_ProgressTracker.steps + 1) | 0), this._last = -this._step, this.progress = 0;
  }
  shouldNotify(Xn) {
    return Xn - this._last >= this._step && (this._last = Xn, this.progress = Math.min(this._progressRange * this._last / this._range, this._progressRange), !0);
  }
}, ProgressTracker = _ProgressTracker;
__publicField(ProgressTracker, "steps", 100);
var networkBiasShift = 3, Neuron = class {
  constructor(Xn) {
    __publicField(this, "r"), __publicField(this, "g"), __publicField(this, "b"), __publicField(this, "a"), this.r = this.g = this.b = this.a = Xn;
  }
  toPoint() {
    return Point.createByRGBA(this.r >> networkBiasShift, this.g >> networkBiasShift, this.b >> networkBiasShift, this.a >> networkBiasShift);
  }
  subtract(Xn, zn, Un, Kn) {
    this.r -= 0 | Xn, this.g -= 0 | zn, this.b -= 0 | Un, this.a -= 0 | Kn;
  }
}, _NeuQuant = class extends AbstractPaletteQuantizer {
  constructor(Xn, zn = 256) {
    super(), __publicField(this, "_pointArray"), __publicField(this, "_networkSize"), __publicField(this, "_network"), __publicField(this, "_sampleFactor"), __publicField(this, "_radPower"), __publicField(this, "_freq"), __publicField(this, "_bias"), __publicField(this, "_distance"), this._distance = Xn, this._pointArray = [], this._sampleFactor = 1, this._networkSize = zn, this._distance.setWhitePoint(255 << networkBiasShift, 255 << networkBiasShift, 255 << networkBiasShift, 255 << networkBiasShift);
  }
  sample(Xn) {
    this._pointArray = this._pointArray.concat(Xn.getPointArray());
  }
  *quantize() {
    this._init(), yield* this._learn(), yield { palette: this._buildPalette(), progress: 100 };
  }
  _init() {
    this._freq = [], this._bias = [], this._radPower = [], this._network = [];
    for (let Xn = 0; Xn < this._networkSize; Xn++) this._network[Xn] = new Neuron((Xn << networkBiasShift + 8) / this._networkSize | 0), this._freq[Xn] = _NeuQuant._initialBias / this._networkSize | 0, this._bias[Xn] = 0;
  }
  *_learn() {
    let Xn = this._sampleFactor;
    const zn = this._pointArray.length;
    zn < _NeuQuant._minpicturebytes && (Xn = 1);
    const Un = 30 + (Xn - 1) / 3 | 0, Kn = zn / Xn | 0;
    let qn, Jo = Kn / _NeuQuant._nCycles | 0, pa = _NeuQuant._initAlpha, ma = (this._networkSize >> 3) * _NeuQuant._radiusBias, va = ma >> _NeuQuant._radiusBiasShift;
    va <= 1 && (va = 0);
    for (let _a = 0; _a < va; _a++) this._radPower[_a] = pa * ((va * va - _a * _a) * _NeuQuant._radBias / (va * va)) >>> 0;
    qn = zn < _NeuQuant._minpicturebytes ? 1 : zn % _NeuQuant._prime1 != 0 ? _NeuQuant._prime1 : zn % _NeuQuant._prime2 != 0 ? _NeuQuant._prime2 : zn % _NeuQuant._prime3 != 0 ? _NeuQuant._prime3 : _NeuQuant._prime4;
    const ba = new ProgressTracker(Kn, 99);
    for (let _a = 0, ya = 0; _a < Kn; ) {
      ba.shouldNotify(_a) && (yield { progress: ba.progress });
      const xa = this._pointArray[ya], wa = xa.b << networkBiasShift, Ta = xa.g << networkBiasShift, Sa = xa.r << networkBiasShift, Ma = xa.a << networkBiasShift, ka = this._contest(wa, Ta, Sa, Ma);
      if (this._alterSingle(pa, ka, wa, Ta, Sa, Ma), va !== 0 && this._alterNeighbour(va, ka, wa, Ta, Sa, Ma), ya += qn, ya >= zn && (ya -= zn), _a++, Jo === 0 && (Jo = 1), _a % Jo == 0) {
        pa -= pa / Un | 0, ma -= ma / _NeuQuant._radiusDecrease | 0, va = ma >> _NeuQuant._radiusBiasShift, va <= 1 && (va = 0);
        for (let Za = 0; Za < va; Za++) this._radPower[Za] = pa * ((va * va - Za * Za) * _NeuQuant._radBias / (va * va)) >>> 0;
      }
    }
  }
  _buildPalette() {
    const Xn = new Palette();
    return this._network.forEach((zn) => {
      Xn.add(zn.toPoint());
    }), Xn.sort(), Xn;
  }
  _alterNeighbour(Xn, zn, Un, Kn, qn, Jo) {
    let pa = zn - Xn;
    pa < -1 && (pa = -1);
    let ma = zn + Xn;
    ma > this._networkSize && (ma = this._networkSize);
    let va = zn + 1, ba = zn - 1, _a = 1;
    for (; va < ma || ba > pa; ) {
      const ya = this._radPower[_a++] / _NeuQuant._alphaRadBias;
      if (va < ma) {
        const xa = this._network[va++];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
      if (ba > pa) {
        const xa = this._network[ba--];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
    }
  }
  _alterSingle(Xn, zn, Un, Kn, qn, Jo) {
    Xn /= _NeuQuant._initAlpha;
    const pa = this._network[zn];
    pa.subtract(Xn * (pa.r - qn), Xn * (pa.g - Kn), Xn * (pa.b - Un), Xn * (pa.a - Jo));
  }
  _contest(Xn, zn, Un, Kn) {
    const qn = 1020 << networkBiasShift;
    let Jo = 2147483647, pa = Jo, ma = -1, va = ma;
    for (let ba = 0; ba < this._networkSize; ba++) {
      const _a = this._network[ba], ya = this._distance.calculateNormalized(_a, { r: Un, g: zn, b: Xn, a: Kn }) * qn | 0;
      ya < Jo && (Jo = ya, ma = ba);
      const xa = ya - (this._bias[ba] >> _NeuQuant._initialBiasShift - networkBiasShift);
      xa < pa && (pa = xa, va = ba);
      const wa = this._freq[ba] >> _NeuQuant._betaShift;
      this._freq[ba] -= wa, this._bias[ba] += wa << _NeuQuant._gammaShift;
    }
    return this._freq[ma] += _NeuQuant._beta, this._bias[ma] -= _NeuQuant._betaGamma, va;
  }
}, NeuQuant = _NeuQuant;
__publicField(NeuQuant, "_prime1", 499), __publicField(NeuQuant, "_prime2", 491), __publicField(NeuQuant, "_prime3", 487), __publicField(NeuQuant, "_prime4", 503), __publicField(NeuQuant, "_minpicturebytes", _NeuQuant._prime4), __publicField(NeuQuant, "_nCycles", 100), __publicField(NeuQuant, "_initialBiasShift", 16), __publicField(NeuQuant, "_initialBias", 1 << _NeuQuant._initialBiasShift), __publicField(NeuQuant, "_gammaShift", 10), __publicField(NeuQuant, "_betaShift", 10), __publicField(NeuQuant, "_beta", _NeuQuant._initialBias >> _NeuQuant._betaShift), __publicField(NeuQuant, "_betaGamma", _NeuQuant._initialBias << _NeuQuant._gammaShift - _NeuQuant._betaShift), __publicField(NeuQuant, "_radiusBiasShift", 6), __publicField(NeuQuant, "_radiusBias", 1 << _NeuQuant._radiusBiasShift), __publicField(NeuQuant, "_radiusDecrease", 30), __publicField(NeuQuant, "_alphaBiasShift", 10), __publicField(NeuQuant, "_initAlpha", 1 << _NeuQuant._alphaBiasShift), __publicField(NeuQuant, "_radBiasShift", 8), __publicField(NeuQuant, "_radBias", 1 << _NeuQuant._radBiasShift), __publicField(NeuQuant, "_alphaRadBiasShift", _NeuQuant._alphaBiasShift + _NeuQuant._radBiasShift), __publicField(NeuQuant, "_alphaRadBias", 1 << _NeuQuant._alphaRadBiasShift);
var networkBiasShift2 = 3, NeuronFloat = class {
  constructor(Xn) {
    __publicField(this, "r"), __publicField(this, "g"), __publicField(this, "b"), __publicField(this, "a"), this.r = this.g = this.b = this.a = Xn;
  }
  toPoint() {
    return Point.createByRGBA(this.r >> networkBiasShift2, this.g >> networkBiasShift2, this.b >> networkBiasShift2, this.a >> networkBiasShift2);
  }
  subtract(Xn, zn, Un, Kn) {
    this.r -= Xn, this.g -= zn, this.b -= Un, this.a -= Kn;
  }
}, _NeuQuantFloat = class extends AbstractPaletteQuantizer {
  constructor(Xn, zn = 256) {
    super(), __publicField(this, "_pointArray"), __publicField(this, "_networkSize"), __publicField(this, "_network"), __publicField(this, "_sampleFactor"), __publicField(this, "_radPower"), __publicField(this, "_freq"), __publicField(this, "_bias"), __publicField(this, "_distance"), this._distance = Xn, this._pointArray = [], this._sampleFactor = 1, this._networkSize = zn, this._distance.setWhitePoint(255 << networkBiasShift2, 255 << networkBiasShift2, 255 << networkBiasShift2, 255 << networkBiasShift2);
  }
  sample(Xn) {
    this._pointArray = this._pointArray.concat(Xn.getPointArray());
  }
  *quantize() {
    this._init(), yield* this._learn(), yield { palette: this._buildPalette(), progress: 100 };
  }
  _init() {
    this._freq = [], this._bias = [], this._radPower = [], this._network = [];
    for (let Xn = 0; Xn < this._networkSize; Xn++) this._network[Xn] = new NeuronFloat((Xn << networkBiasShift2 + 8) / this._networkSize), this._freq[Xn] = _NeuQuantFloat._initialBias / this._networkSize, this._bias[Xn] = 0;
  }
  *_learn() {
    let Xn = this._sampleFactor;
    const zn = this._pointArray.length;
    zn < _NeuQuantFloat._minpicturebytes && (Xn = 1);
    const Un = 30 + (Xn - 1) / 3, Kn = zn / Xn;
    let qn, Jo = Kn / _NeuQuantFloat._nCycles | 0, pa = _NeuQuantFloat._initAlpha, ma = (this._networkSize >> 3) * _NeuQuantFloat._radiusBias, va = ma >> _NeuQuantFloat._radiusBiasShift;
    va <= 1 && (va = 0);
    for (let _a = 0; _a < va; _a++) this._radPower[_a] = pa * ((va * va - _a * _a) * _NeuQuantFloat._radBias / (va * va));
    qn = zn < _NeuQuantFloat._minpicturebytes ? 1 : zn % _NeuQuantFloat._prime1 != 0 ? _NeuQuantFloat._prime1 : zn % _NeuQuantFloat._prime2 != 0 ? _NeuQuantFloat._prime2 : zn % _NeuQuantFloat._prime3 != 0 ? _NeuQuantFloat._prime3 : _NeuQuantFloat._prime4;
    const ba = new ProgressTracker(Kn, 99);
    for (let _a = 0, ya = 0; _a < Kn; ) {
      ba.shouldNotify(_a) && (yield { progress: ba.progress });
      const xa = this._pointArray[ya], wa = xa.b << networkBiasShift2, Ta = xa.g << networkBiasShift2, Sa = xa.r << networkBiasShift2, Ma = xa.a << networkBiasShift2, ka = this._contest(wa, Ta, Sa, Ma);
      if (this._alterSingle(pa, ka, wa, Ta, Sa, Ma), va !== 0 && this._alterNeighbour(va, ka, wa, Ta, Sa, Ma), ya += qn, ya >= zn && (ya -= zn), _a++, Jo === 0 && (Jo = 1), _a % Jo == 0) {
        pa -= pa / Un, ma -= ma / _NeuQuantFloat._radiusDecrease, va = ma >> _NeuQuantFloat._radiusBiasShift, va <= 1 && (va = 0);
        for (let Za = 0; Za < va; Za++) this._radPower[Za] = pa * ((va * va - Za * Za) * _NeuQuantFloat._radBias / (va * va));
      }
    }
  }
  _buildPalette() {
    const Xn = new Palette();
    return this._network.forEach((zn) => {
      Xn.add(zn.toPoint());
    }), Xn.sort(), Xn;
  }
  _alterNeighbour(Xn, zn, Un, Kn, qn, Jo) {
    let pa = zn - Xn;
    pa < -1 && (pa = -1);
    let ma = zn + Xn;
    ma > this._networkSize && (ma = this._networkSize);
    let va = zn + 1, ba = zn - 1, _a = 1;
    for (; va < ma || ba > pa; ) {
      const ya = this._radPower[_a++] / _NeuQuantFloat._alphaRadBias;
      if (va < ma) {
        const xa = this._network[va++];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
      if (ba > pa) {
        const xa = this._network[ba--];
        xa.subtract(ya * (xa.r - qn), ya * (xa.g - Kn), ya * (xa.b - Un), ya * (xa.a - Jo));
      }
    }
  }
  _alterSingle(Xn, zn, Un, Kn, qn, Jo) {
    Xn /= _NeuQuantFloat._initAlpha;
    const pa = this._network[zn];
    pa.subtract(Xn * (pa.r - qn), Xn * (pa.g - Kn), Xn * (pa.b - Un), Xn * (pa.a - Jo));
  }
  _contest(Xn, zn, Un, Kn) {
    const qn = 1020 << networkBiasShift2;
    let Jo = 2147483647, pa = Jo, ma = -1, va = ma;
    for (let ba = 0; ba < this._networkSize; ba++) {
      const _a = this._network[ba], ya = this._distance.calculateNormalized(_a, { r: Un, g: zn, b: Xn, a: Kn }) * qn;
      ya < Jo && (Jo = ya, ma = ba);
      const xa = ya - (this._bias[ba] >> _NeuQuantFloat._initialBiasShift - networkBiasShift2);
      xa < pa && (pa = xa, va = ba);
      const wa = this._freq[ba] >> _NeuQuantFloat._betaShift;
      this._freq[ba] -= wa, this._bias[ba] += wa << _NeuQuantFloat._gammaShift;
    }
    return this._freq[ma] += _NeuQuantFloat._beta, this._bias[ma] -= _NeuQuantFloat._betaGamma, va;
  }
}, NeuQuantFloat = _NeuQuantFloat;
__publicField(NeuQuantFloat, "_prime1", 499), __publicField(NeuQuantFloat, "_prime2", 491), __publicField(NeuQuantFloat, "_prime3", 487), __publicField(NeuQuantFloat, "_prime4", 503), __publicField(NeuQuantFloat, "_minpicturebytes", _NeuQuantFloat._prime4), __publicField(NeuQuantFloat, "_nCycles", 100), __publicField(NeuQuantFloat, "_initialBiasShift", 16), __publicField(NeuQuantFloat, "_initialBias", 1 << _NeuQuantFloat._initialBiasShift), __publicField(NeuQuantFloat, "_gammaShift", 10), __publicField(NeuQuantFloat, "_betaShift", 10), __publicField(NeuQuantFloat, "_beta", _NeuQuantFloat._initialBias >> _NeuQuantFloat._betaShift), __publicField(NeuQuantFloat, "_betaGamma", _NeuQuantFloat._initialBias << _NeuQuantFloat._gammaShift - _NeuQuantFloat._betaShift), __publicField(NeuQuantFloat, "_radiusBiasShift", 6), __publicField(NeuQuantFloat, "_radiusBias", 1 << _NeuQuantFloat._radiusBiasShift), __publicField(NeuQuantFloat, "_radiusDecrease", 30), __publicField(NeuQuantFloat, "_alphaBiasShift", 10), __publicField(NeuQuantFloat, "_initAlpha", 1 << _NeuQuantFloat._alphaBiasShift), __publicField(NeuQuantFloat, "_radBiasShift", 8), __publicField(NeuQuantFloat, "_radBias", 1 << _NeuQuantFloat._radBiasShift), __publicField(NeuQuantFloat, "_alphaRadBiasShift", _NeuQuantFloat._alphaBiasShift + _NeuQuantFloat._radBiasShift), __publicField(NeuQuantFloat, "_alphaRadBias", 1 << _NeuQuantFloat._alphaRadBiasShift);
var _ColorHistogram = class {
  constructor(Xn, zn) {
    __publicField(this, "_method"), __publicField(this, "_hueStats"), __publicField(this, "_histogram"), __publicField(this, "_initColors"), __publicField(this, "_minHueCols"), this._method = Xn, this._minHueCols = zn << 2, this._initColors = zn << 2, this._hueStats = new HueStatistics(_ColorHistogram._hueGroups, this._minHueCols), this._histogram = /* @__PURE__ */ Object.create(null);
  }
  sample(Xn) {
    switch (this._method) {
      case 1:
        this._colorStats1D(Xn);
        break;
      case 2:
        this._colorStats2D(Xn);
    }
  }
  getImportanceSortedColorsIDXI32() {
    const Xn = stableSort(Object.keys(this._histogram), (Un, Kn) => this._histogram[Kn] - this._histogram[Un]);
    if (Xn.length === 0) return [];
    let zn;
    switch (this._method) {
      case 1:
        const Un = Math.min(Xn.length, this._initColors), Kn = Xn[Un - 1], qn = this._histogram[Kn];
        zn = Xn.slice(0, Un);
        let Jo = Un;
        const pa = Xn.length;
        for (; Jo < pa && this._histogram[Xn[Jo]] === qn; ) zn.push(Xn[Jo++]);
        this._hueStats.injectIntoArray(zn);
        break;
      case 2:
        zn = Xn;
        break;
      default:
        throw new Error("Incorrect method");
    }
    return zn.map((Un) => +Un);
  }
  _colorStats1D(Xn) {
    const zn = this._histogram, Un = Xn.getPointArray(), Kn = Un.length;
    for (let qn = 0; qn < Kn; qn++) {
      const Jo = Un[qn].uint32;
      this._hueStats.check(Jo), Jo in zn ? zn[Jo]++ : zn[Jo] = 1;
    }
  }
  _colorStats2D(Xn) {
    const zn = Xn.getWidth(), Un = Xn.getHeight(), Kn = Xn.getPointArray(), qn = _ColorHistogram._boxSize[0], Jo = _ColorHistogram._boxSize[1], pa = qn * Jo, ma = this._makeBoxes(zn, Un, qn, Jo), va = this._histogram;
    ma.forEach((ba) => {
      let _a = Math.round(ba.w * ba.h / pa) * _ColorHistogram._boxPixels;
      _a < 2 && (_a = 2);
      const ya = {};
      this._iterateBox(ba, zn, (xa) => {
        const wa = Kn[xa].uint32;
        this._hueStats.check(wa), wa in va ? va[wa]++ : wa in ya ? ++ya[wa] >= _a && (va[wa] = ya[wa]) : ya[wa] = 1;
      });
    }), this._hueStats.injectIntoDictionary(va);
  }
  _iterateBox(Xn, zn, Un) {
    const Kn = Xn, qn = Kn.y * zn + Kn.x, Jo = (Kn.y + Kn.h - 1) * zn + (Kn.x + Kn.w - 1), pa = zn - Kn.w + 1;
    let ma = 0, va = qn;
    do
      Un.call(this, va), va += ++ma % Kn.w == 0 ? pa : 1;
    while (va <= Jo);
  }
  _makeBoxes(Xn, zn, Un, Kn) {
    const qn = Xn % Un, Jo = zn % Kn, pa = Xn - qn, ma = zn - Jo, va = [];
    for (let ba = 0; ba < zn; ba += Kn) for (let _a = 0; _a < Xn; _a += Un) va.push({ x: _a, y: ba, w: _a === pa ? qn : Un, h: ba === ma ? Jo : Kn });
    return va;
  }
}, ColorHistogram = _ColorHistogram;
__publicField(ColorHistogram, "_boxSize", [64, 64]), __publicField(ColorHistogram, "_boxPixels", 2), __publicField(ColorHistogram, "_hueGroups", 10);
var RemovedColor = class {
  constructor(Xn, zn, Un) {
    __publicField(this, "index"), __publicField(this, "color"), __publicField(this, "distance"), this.index = Xn, this.color = zn, this.distance = Un;
  }
}, RGBQuant = class extends AbstractPaletteQuantizer {
  constructor(Xn, zn = 256, Un = 2) {
    super(), __publicField(this, "_colors"), __publicField(this, "_initialDistance"), __publicField(this, "_distanceIncrement"), __publicField(this, "_histogram"), __publicField(this, "_distance"), this._distance = Xn, this._colors = zn, this._histogram = new ColorHistogram(Un, zn), this._initialDistance = 0.01, this._distanceIncrement = 5e-3;
  }
  sample(Xn) {
    this._histogram.sample(Xn);
  }
  *quantize() {
    const Xn = this._histogram.getImportanceSortedColorsIDXI32();
    if (Xn.length === 0) throw new Error("No colors in image");
    yield* this._buildPalette(Xn);
  }
  *_buildPalette(Xn) {
    const zn = new Palette(), Un = zn.getPointContainer().getPointArray(), Kn = new Array(Xn.length);
    for (let _a = 0; _a < Xn.length; _a++) Un.push(Point.createByUint32(Xn[_a])), Kn[_a] = 1;
    const qn = Un.length, Jo = [];
    let pa = qn, ma = this._initialDistance;
    const va = new ProgressTracker(pa - this._colors, 99);
    for (; pa > this._colors; ) {
      Jo.length = 0;
      for (let _a = 0; _a < qn; _a++) {
        if (va.shouldNotify(qn - pa) && (yield { progress: va.progress }), Kn[_a] === 0) continue;
        const ya = Un[_a];
        for (let xa = _a + 1; xa < qn; xa++) {
          if (Kn[xa] === 0) continue;
          const wa = Un[xa], Ta = this._distance.calculateNormalized(ya, wa);
          Ta < ma && (Jo.push(new RemovedColor(xa, wa, Ta)), Kn[xa] = 0, pa--);
        }
      }
      ma += pa > 3 * this._colors ? this._initialDistance : this._distanceIncrement;
    }
    if (pa < this._colors) {
      stableSort(Jo, (ya, xa) => xa.distance - ya.distance);
      let _a = 0;
      for (; pa < this._colors && _a < Jo.length; )
        Kn[Jo[_a].index] = 1, pa++, _a++;
    }
    let ba = Un.length;
    for (let _a = ba - 1; _a >= 0; _a--) Kn[_a] === 0 && (_a !== ba - 1 && (Un[_a] = Un[ba - 1]), --ba);
    Un.length = ba, zn.sort(), yield { palette: zn, progress: 100 };
  }
};
function createArray1D(Xn) {
  const zn = [];
  for (let Un = 0; Un < Xn; Un++) zn[Un] = 0;
  return zn;
}
function createArray4D(Xn, zn, Un, Kn) {
  const qn = new Array(Xn);
  for (let Jo = 0; Jo < Xn; Jo++) {
    qn[Jo] = new Array(zn);
    for (let pa = 0; pa < zn; pa++) {
      qn[Jo][pa] = new Array(Un);
      for (let ma = 0; ma < Un; ma++) {
        qn[Jo][pa][ma] = new Array(Kn);
        for (let va = 0; va < Kn; va++) qn[Jo][pa][ma][va] = 0;
      }
    }
  }
  return qn;
}
function createArray3D(Xn, zn, Un) {
  const Kn = new Array(Xn);
  for (let qn = 0; qn < Xn; qn++) {
    Kn[qn] = new Array(zn);
    for (let Jo = 0; Jo < zn; Jo++) {
      Kn[qn][Jo] = new Array(Un);
      for (let pa = 0; pa < Un; pa++) Kn[qn][Jo][pa] = 0;
    }
  }
  return Kn;
}
function fillArray3D(Xn, zn, Un, Kn, qn) {
  for (let Jo = 0; Jo < zn; Jo++) {
    Xn[Jo] = [];
    for (let pa = 0; pa < Un; pa++) {
      Xn[Jo][pa] = [];
      for (let ma = 0; ma < Kn; ma++) Xn[Jo][pa][ma] = qn;
    }
  }
}
function fillArray1D(Xn, zn, Un) {
  for (let Kn = 0; Kn < zn; Kn++) Xn[Kn] = Un;
}
var WuColorCube = class {
  constructor() {
    __publicField(this, "redMinimum"), __publicField(this, "redMaximum"), __publicField(this, "greenMinimum"), __publicField(this, "greenMaximum"), __publicField(this, "blueMinimum"), __publicField(this, "blueMaximum"), __publicField(this, "volume"), __publicField(this, "alphaMinimum"), __publicField(this, "alphaMaximum");
  }
}, _WuQuant = class extends AbstractPaletteQuantizer {
  constructor(Xn, zn = 256, Un = 5) {
    super(), __publicField(this, "_reds"), __publicField(this, "_greens"), __publicField(this, "_blues"), __publicField(this, "_alphas"), __publicField(this, "_sums"), __publicField(this, "_weights"), __publicField(this, "_momentsRed"), __publicField(this, "_momentsGreen"), __publicField(this, "_momentsBlue"), __publicField(this, "_momentsAlpha"), __publicField(this, "_moments"), __publicField(this, "_table"), __publicField(this, "_pixels"), __publicField(this, "_cubes"), __publicField(this, "_colors"), __publicField(this, "_significantBitsPerChannel"), __publicField(this, "_maxSideIndex"), __publicField(this, "_alphaMaxSideIndex"), __publicField(this, "_sideSize"), __publicField(this, "_alphaSideSize"), __publicField(this, "_distance"), this._distance = Xn, this._setQuality(Un), this._initialize(zn);
  }
  sample(Xn) {
    const zn = Xn.getPointArray();
    for (let Un = 0, Kn = zn.length; Un < Kn; Un++) this._addColor(zn[Un]);
    this._pixels = this._pixels.concat(zn);
  }
  *quantize() {
    yield* this._preparePalette();
    const Xn = new Palette();
    for (let zn = 0; zn < this._colors; zn++) if (this._sums[zn] > 0) {
      const Un = this._sums[zn], Kn = this._reds[zn] / Un, qn = this._greens[zn] / Un, Jo = this._blues[zn] / Un, pa = this._alphas[zn] / Un, ma = Point.createByRGBA(0 | Kn, 0 | qn, 0 | Jo, 0 | pa);
      Xn.add(ma);
    }
    Xn.sort(), yield { palette: Xn, progress: 100 };
  }
  *_preparePalette() {
    yield* this._calculateMoments();
    let Xn = 0;
    const zn = createArray1D(this._colors);
    for (let pa = 1; pa < this._colors; ++pa) {
      this._cut(this._cubes[Xn], this._cubes[pa]) ? (zn[Xn] = this._cubes[Xn].volume > 1 ? this._calculateVariance(this._cubes[Xn]) : 0, zn[pa] = this._cubes[pa].volume > 1 ? this._calculateVariance(this._cubes[pa]) : 0) : (zn[Xn] = 0, pa--), Xn = 0;
      let ma = zn[0];
      for (let va = 1; va <= pa; ++va) zn[va] > ma && (ma = zn[va], Xn = va);
      if (ma <= 0) {
        this._colors = pa + 1;
        break;
      }
    }
    const Un = [], Kn = [], qn = [], Jo = [];
    for (let pa = 0; pa < this._colors; ++pa) {
      const ma = _WuQuant._volume(this._cubes[pa], this._weights);
      ma > 0 ? (Un[pa] = _WuQuant._volume(this._cubes[pa], this._momentsRed) / ma | 0, Kn[pa] = _WuQuant._volume(this._cubes[pa], this._momentsGreen) / ma | 0, qn[pa] = _WuQuant._volume(this._cubes[pa], this._momentsBlue) / ma | 0, Jo[pa] = _WuQuant._volume(this._cubes[pa], this._momentsAlpha) / ma | 0) : (Un[pa] = 0, Kn[pa] = 0, qn[pa] = 0, Jo[pa] = 0);
    }
    this._reds = createArray1D(this._colors + 1), this._greens = createArray1D(this._colors + 1), this._blues = createArray1D(this._colors + 1), this._alphas = createArray1D(this._colors + 1), this._sums = createArray1D(this._colors + 1);
    for (let pa = 0, ma = this._pixels.length; pa < ma; pa++) {
      const va = this._pixels[pa];
      let ba = -1, _a = Number.MAX_VALUE;
      for (let ya = 0; ya < this._colors; ya++) {
        const xa = Un[ya], wa = Kn[ya], Ta = qn[ya], Sa = Jo[ya], Ma = this._distance.calculateRaw(xa, wa, Ta, Sa, va.r, va.g, va.b, va.a);
        Ma < _a && (_a = Ma, ba = ya);
      }
      this._reds[ba] += va.r, this._greens[ba] += va.g, this._blues[ba] += va.b, this._alphas[ba] += va.a, this._sums[ba]++;
    }
  }
  _addColor(Xn) {
    const zn = 8 - this._significantBitsPerChannel, Un = 1 + (Xn.r >> zn), Kn = 1 + (Xn.g >> zn), qn = 1 + (Xn.b >> zn), Jo = 1 + (Xn.a >> zn);
    this._weights[Jo][Un][Kn][qn]++, this._momentsRed[Jo][Un][Kn][qn] += Xn.r, this._momentsGreen[Jo][Un][Kn][qn] += Xn.g, this._momentsBlue[Jo][Un][Kn][qn] += Xn.b, this._momentsAlpha[Jo][Un][Kn][qn] += Xn.a, this._moments[Jo][Un][Kn][qn] += this._table[Xn.r] + this._table[Xn.g] + this._table[Xn.b] + this._table[Xn.a];
  }
  *_calculateMoments() {
    const Xn = [], zn = [], Un = [], Kn = [], qn = [], Jo = [], pa = createArray3D(this._sideSize, this._sideSize, this._sideSize), ma = createArray3D(this._sideSize, this._sideSize, this._sideSize), va = createArray3D(this._sideSize, this._sideSize, this._sideSize), ba = createArray3D(this._sideSize, this._sideSize, this._sideSize), _a = createArray3D(this._sideSize, this._sideSize, this._sideSize), ya = createArray3D(this._sideSize, this._sideSize, this._sideSize);
    let xa = 0;
    const wa = new ProgressTracker(this._alphaMaxSideIndex * this._maxSideIndex, 99);
    for (let Ta = 1; Ta <= this._alphaMaxSideIndex; ++Ta) {
      fillArray3D(pa, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D(ma, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D(va, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D(ba, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D(_a, this._sideSize, this._sideSize, this._sideSize, 0), fillArray3D(ya, this._sideSize, this._sideSize, this._sideSize, 0);
      for (let Sa = 1; Sa <= this._maxSideIndex; ++Sa, ++xa) {
        wa.shouldNotify(xa) && (yield { progress: wa.progress }), fillArray1D(Xn, this._sideSize, 0), fillArray1D(zn, this._sideSize, 0), fillArray1D(Un, this._sideSize, 0), fillArray1D(Kn, this._sideSize, 0), fillArray1D(qn, this._sideSize, 0), fillArray1D(Jo, this._sideSize, 0);
        for (let Ma = 1; Ma <= this._maxSideIndex; ++Ma) {
          let ka = 0, Za = 0, Na = 0, Ka = 0, Ja = 0, el = 0;
          for (let qa = 1; qa <= this._maxSideIndex; ++qa) ka += this._weights[Ta][Sa][Ma][qa], Za += this._momentsRed[Ta][Sa][Ma][qa], Na += this._momentsGreen[Ta][Sa][Ma][qa], Ka += this._momentsBlue[Ta][Sa][Ma][qa], Ja += this._momentsAlpha[Ta][Sa][Ma][qa], el += this._moments[Ta][Sa][Ma][qa], Xn[qa] += ka, zn[qa] += Za, Un[qa] += Na, Kn[qa] += Ka, qn[qa] += Ja, Jo[qa] += el, pa[Sa][Ma][qa] = pa[Sa - 1][Ma][qa] + Xn[qa], ma[Sa][Ma][qa] = ma[Sa - 1][Ma][qa] + zn[qa], va[Sa][Ma][qa] = va[Sa - 1][Ma][qa] + Un[qa], ba[Sa][Ma][qa] = ba[Sa - 1][Ma][qa] + Kn[qa], _a[Sa][Ma][qa] = _a[Sa - 1][Ma][qa] + qn[qa], ya[Sa][Ma][qa] = ya[Sa - 1][Ma][qa] + Jo[qa], this._weights[Ta][Sa][Ma][qa] = this._weights[Ta - 1][Sa][Ma][qa] + pa[Sa][Ma][qa], this._momentsRed[Ta][Sa][Ma][qa] = this._momentsRed[Ta - 1][Sa][Ma][qa] + ma[Sa][Ma][qa], this._momentsGreen[Ta][Sa][Ma][qa] = this._momentsGreen[Ta - 1][Sa][Ma][qa] + va[Sa][Ma][qa], this._momentsBlue[Ta][Sa][Ma][qa] = this._momentsBlue[Ta - 1][Sa][Ma][qa] + ba[Sa][Ma][qa], this._momentsAlpha[Ta][Sa][Ma][qa] = this._momentsAlpha[Ta - 1][Sa][Ma][qa] + _a[Sa][Ma][qa], this._moments[Ta][Sa][Ma][qa] = this._moments[Ta - 1][Sa][Ma][qa] + ya[Sa][Ma][qa];
        }
      }
    }
  }
  static _volumeFloat(Xn, zn) {
    return zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] - zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] - zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] + zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] + zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] + zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] - zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] - zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] - zn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + zn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] - zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + zn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] - zn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
  }
  static _volume(Xn, zn) {
    return 0 | _WuQuant._volumeFloat(Xn, zn);
  }
  static _top(Xn, zn, Un, Kn) {
    let qn;
    switch (zn) {
      case _WuQuant._alpha:
        qn = Kn[Un][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] - Kn[Un][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] - Kn[Un][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] + Kn[Un][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (Kn[Un][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] - Kn[Un][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] - Kn[Un][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + Kn[Un][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
        break;
      case _WuQuant._red:
        qn = Kn[Xn.alphaMaximum][Un][Xn.greenMaximum][Xn.blueMaximum] - Kn[Xn.alphaMaximum][Un][Xn.greenMinimum][Xn.blueMaximum] - Kn[Xn.alphaMinimum][Un][Xn.greenMaximum][Xn.blueMaximum] + Kn[Xn.alphaMinimum][Un][Xn.greenMinimum][Xn.blueMaximum] - (Kn[Xn.alphaMaximum][Un][Xn.greenMaximum][Xn.blueMinimum] - Kn[Xn.alphaMaximum][Un][Xn.greenMinimum][Xn.blueMinimum] - Kn[Xn.alphaMinimum][Un][Xn.greenMaximum][Xn.blueMinimum] + Kn[Xn.alphaMinimum][Un][Xn.greenMinimum][Xn.blueMinimum]);
        break;
      case _WuQuant._green:
        qn = Kn[Xn.alphaMaximum][Xn.redMaximum][Un][Xn.blueMaximum] - Kn[Xn.alphaMaximum][Xn.redMinimum][Un][Xn.blueMaximum] - Kn[Xn.alphaMinimum][Xn.redMaximum][Un][Xn.blueMaximum] + Kn[Xn.alphaMinimum][Xn.redMinimum][Un][Xn.blueMaximum] - (Kn[Xn.alphaMaximum][Xn.redMaximum][Un][Xn.blueMinimum] - Kn[Xn.alphaMaximum][Xn.redMinimum][Un][Xn.blueMinimum] - Kn[Xn.alphaMinimum][Xn.redMaximum][Un][Xn.blueMinimum] + Kn[Xn.alphaMinimum][Xn.redMinimum][Un][Xn.blueMinimum]);
        break;
      case _WuQuant._blue:
        qn = Kn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Un] - Kn[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Un] - Kn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Un] + Kn[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Un] - (Kn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Un] - Kn[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Un] - Kn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Un] + Kn[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Un]);
        break;
      default:
        throw new Error("impossible");
    }
    return 0 | qn;
  }
  static _bottom(Xn, zn, Un) {
    switch (zn) {
      case _WuQuant._alpha:
        return -Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (-Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      case _WuQuant._red:
        return -Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMaximum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (-Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      case _WuQuant._green:
        return -Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMaximum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMaximum] - (-Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      case _WuQuant._blue:
        return -Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMaximum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum] - (-Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMaximum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMaximum][Xn.greenMinimum][Xn.blueMinimum] + Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMaximum][Xn.blueMinimum] - Un[Xn.alphaMinimum][Xn.redMinimum][Xn.greenMinimum][Xn.blueMinimum]);
      default:
        return 0;
    }
  }
  _calculateVariance(Xn) {
    const zn = _WuQuant._volume(Xn, this._momentsRed), Un = _WuQuant._volume(Xn, this._momentsGreen), Kn = _WuQuant._volume(Xn, this._momentsBlue), qn = _WuQuant._volume(Xn, this._momentsAlpha);
    return _WuQuant._volumeFloat(Xn, this._moments) - (zn * zn + Un * Un + Kn * Kn + qn * qn) / _WuQuant._volume(Xn, this._weights);
  }
  _maximize(Xn, zn, Un, Kn, qn, Jo, pa, ma, va) {
    const ba = 0 | _WuQuant._bottom(Xn, zn, this._momentsRed), _a = 0 | _WuQuant._bottom(Xn, zn, this._momentsGreen), ya = 0 | _WuQuant._bottom(Xn, zn, this._momentsBlue), xa = 0 | _WuQuant._bottom(Xn, zn, this._momentsAlpha), wa = 0 | _WuQuant._bottom(Xn, zn, this._weights);
    let Ta = 0, Sa = -1;
    for (let Ma = Un; Ma < Kn; ++Ma) {
      let ka = ba + _WuQuant._top(Xn, zn, Ma, this._momentsRed), Za = _a + _WuQuant._top(Xn, zn, Ma, this._momentsGreen), Na = ya + _WuQuant._top(Xn, zn, Ma, this._momentsBlue), Ka = xa + _WuQuant._top(Xn, zn, Ma, this._momentsAlpha), Ja = wa + _WuQuant._top(Xn, zn, Ma, this._weights);
      if (Ja !== 0) {
        let el = ka * ka + Za * Za + Na * Na + Ka * Ka, qa = el / Ja;
        ka = qn - ka, Za = Jo - Za, Na = pa - Na, Ka = ma - Ka, Ja = va - Ja, Ja !== 0 && (el = ka * ka + Za * Za + Na * Na + Ka * Ka, qa += el / Ja, qa > Ta && (Ta = qa, Sa = Ma));
      }
    }
    return { max: Ta, position: Sa };
  }
  _cut(Xn, zn) {
    let Un;
    const Kn = _WuQuant._volume(Xn, this._momentsRed), qn = _WuQuant._volume(Xn, this._momentsGreen), Jo = _WuQuant._volume(Xn, this._momentsBlue), pa = _WuQuant._volume(Xn, this._momentsAlpha), ma = _WuQuant._volume(Xn, this._weights), va = this._maximize(Xn, _WuQuant._red, Xn.redMinimum + 1, Xn.redMaximum, Kn, qn, Jo, pa, ma), ba = this._maximize(Xn, _WuQuant._green, Xn.greenMinimum + 1, Xn.greenMaximum, Kn, qn, Jo, pa, ma), _a = this._maximize(Xn, _WuQuant._blue, Xn.blueMinimum + 1, Xn.blueMaximum, Kn, qn, Jo, pa, ma), ya = this._maximize(Xn, _WuQuant._alpha, Xn.alphaMinimum + 1, Xn.alphaMaximum, Kn, qn, Jo, pa, ma);
    if (ya.max >= va.max && ya.max >= ba.max && ya.max >= _a.max) {
      if (Un = _WuQuant._alpha, ya.position < 0) return !1;
    } else Un = va.max >= ya.max && va.max >= ba.max && va.max >= _a.max ? _WuQuant._red : ba.max >= ya.max && ba.max >= va.max && ba.max >= _a.max ? _WuQuant._green : _WuQuant._blue;
    switch (zn.redMaximum = Xn.redMaximum, zn.greenMaximum = Xn.greenMaximum, zn.blueMaximum = Xn.blueMaximum, zn.alphaMaximum = Xn.alphaMaximum, Un) {
      case _WuQuant._red:
        zn.redMinimum = Xn.redMaximum = va.position, zn.greenMinimum = Xn.greenMinimum, zn.blueMinimum = Xn.blueMinimum, zn.alphaMinimum = Xn.alphaMinimum;
        break;
      case _WuQuant._green:
        zn.greenMinimum = Xn.greenMaximum = ba.position, zn.redMinimum = Xn.redMinimum, zn.blueMinimum = Xn.blueMinimum, zn.alphaMinimum = Xn.alphaMinimum;
        break;
      case _WuQuant._blue:
        zn.blueMinimum = Xn.blueMaximum = _a.position, zn.redMinimum = Xn.redMinimum, zn.greenMinimum = Xn.greenMinimum, zn.alphaMinimum = Xn.alphaMinimum;
        break;
      case _WuQuant._alpha:
        zn.alphaMinimum = Xn.alphaMaximum = ya.position, zn.blueMinimum = Xn.blueMinimum, zn.redMinimum = Xn.redMinimum, zn.greenMinimum = Xn.greenMinimum;
    }
    return Xn.volume = (Xn.redMaximum - Xn.redMinimum) * (Xn.greenMaximum - Xn.greenMinimum) * (Xn.blueMaximum - Xn.blueMinimum) * (Xn.alphaMaximum - Xn.alphaMinimum), zn.volume = (zn.redMaximum - zn.redMinimum) * (zn.greenMaximum - zn.greenMinimum) * (zn.blueMaximum - zn.blueMinimum) * (zn.alphaMaximum - zn.alphaMinimum), !0;
  }
  _initialize(Xn) {
    this._colors = Xn, this._cubes = [];
    for (let zn = 0; zn < Xn; zn++) this._cubes[zn] = new WuColorCube();
    this._cubes[0].redMinimum = 0, this._cubes[0].greenMinimum = 0, this._cubes[0].blueMinimum = 0, this._cubes[0].alphaMinimum = 0, this._cubes[0].redMaximum = this._maxSideIndex, this._cubes[0].greenMaximum = this._maxSideIndex, this._cubes[0].blueMaximum = this._maxSideIndex, this._cubes[0].alphaMaximum = this._alphaMaxSideIndex, this._weights = createArray4D(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsRed = createArray4D(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsGreen = createArray4D(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsBlue = createArray4D(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsAlpha = createArray4D(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._moments = createArray4D(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._table = [];
    for (let zn = 0; zn < 256; ++zn) this._table[zn] = zn * zn;
    this._pixels = [];
  }
  _setQuality(Xn = 5) {
    this._significantBitsPerChannel = Xn, this._maxSideIndex = 1 << this._significantBitsPerChannel, this._alphaMaxSideIndex = this._maxSideIndex, this._sideSize = this._maxSideIndex + 1, this._alphaSideSize = this._alphaMaxSideIndex + 1;
  }
}, WuQuant = _WuQuant;
__publicField(WuQuant, "_alpha", 3), __publicField(WuQuant, "_red", 2), __publicField(WuQuant, "_green", 1), __publicField(WuQuant, "_blue", 0);
var image_exports = {};
__export(image_exports, { AbstractImageQuantizer: () => AbstractImageQuantizer, ErrorDiffusionArray: () => ErrorDiffusionArray, ErrorDiffusionArrayKernel: () => ErrorDiffusionArrayKernel, ErrorDiffusionRiemersma: () => ErrorDiffusionRiemersma, NearestColor: () => NearestColor });
var AbstractImageQuantizer = class {
  quantizeSync(Xn, zn) {
    for (const Un of this.quantize(Xn, zn)) if (Un.pointContainer) return Un.pointContainer;
    throw new Error("unreachable");
  }
}, NearestColor = class extends AbstractImageQuantizer {
  constructor(Xn) {
    super(), __publicField(this, "_distance"), this._distance = Xn;
  }
  *quantize(Xn, zn) {
    const Un = Xn.getPointArray(), Kn = Xn.getWidth(), qn = Xn.getHeight(), Jo = new ProgressTracker(qn, 99);
    for (let pa = 0; pa < qn; pa++) {
      Jo.shouldNotify(pa) && (yield { progress: Jo.progress });
      for (let ma = 0, va = pa * Kn; ma < Kn; ma++, va++) {
        const ba = Un[va];
        ba.from(zn.getNearestColor(this._distance, ba));
      }
    }
    yield { pointContainer: Xn, progress: 100 };
  }
}, ErrorDiffusionArrayKernel = ((Xn) => (Xn[Xn.FloydSteinberg = 0] = "FloydSteinberg", Xn[Xn.FalseFloydSteinberg = 1] = "FalseFloydSteinberg", Xn[Xn.Stucki = 2] = "Stucki", Xn[Xn.Atkinson = 3] = "Atkinson", Xn[Xn.Jarvis = 4] = "Jarvis", Xn[Xn.Burkes = 5] = "Burkes", Xn[Xn.Sierra = 6] = "Sierra", Xn[Xn.TwoSierra = 7] = "TwoSierra", Xn[Xn.SierraLite = 8] = "SierraLite", Xn))(ErrorDiffusionArrayKernel || {}), ErrorDiffusionArray = class extends AbstractImageQuantizer {
  constructor(Xn, zn, Un = !0, Kn = 0, qn = !1) {
    super(), __publicField(this, "_minColorDistance"), __publicField(this, "_serpentine"), __publicField(this, "_kernel"), __publicField(this, "_calculateErrorLikeGIMP"), __publicField(this, "_distance"), this._setKernel(zn), this._distance = Xn, this._minColorDistance = Kn, this._serpentine = Un, this._calculateErrorLikeGIMP = qn;
  }
  *quantize(Xn, zn) {
    const Un = Xn.getPointArray(), Kn = new Point(), qn = Xn.getWidth(), Jo = Xn.getHeight(), pa = [];
    let ma = 1, va = 1;
    for (const _a of this._kernel) {
      const ya = _a[2] + 1;
      va < ya && (va = ya);
    }
    for (let _a = 0; _a < va; _a++) this._fillErrorLine(pa[_a] = [], qn);
    const ba = new ProgressTracker(Jo, 99);
    for (let _a = 0; _a < Jo; _a++) {
      ba.shouldNotify(_a) && (yield { progress: ba.progress }), this._serpentine && (ma *= -1);
      const ya = _a * qn, xa = ma === 1 ? 0 : qn - 1, wa = ma === 1 ? qn : -1;
      this._fillErrorLine(pa[0], qn), pa.push(pa.shift());
      const Ta = pa[0];
      for (let Sa = xa, Ma = ya + xa; Sa !== wa; Sa += ma, Ma += ma) {
        const ka = Un[Ma], Za = Ta[Sa];
        Kn.from(ka);
        const Na = Point.createByRGBA(inRange0to255Rounded(ka.r + Za[0]), inRange0to255Rounded(ka.g + Za[1]), inRange0to255Rounded(ka.b + Za[2]), inRange0to255Rounded(ka.a + Za[3])), Ka = zn.getNearestColor(this._distance, Na);
        if (ka.from(Ka), this._minColorDistance && this._distance.calculateNormalized(Kn, Ka) < this._minColorDistance)
          continue;
        let Ja, el, qa, tl;
        this._calculateErrorLikeGIMP ? (Ja = Na.r - Ka.r, el = Na.g - Ka.g, qa = Na.b - Ka.b, tl = Na.a - Ka.a) : (Ja = Kn.r - Ka.r, el = Kn.g - Ka.g, qa = Kn.b - Ka.b, tl = Kn.a - Ka.a);
        const Qa = ma === 1 ? 0 : this._kernel.length - 1, nl = ma === 1 ? this._kernel.length : -1;
        for (let rl = Qa; rl !== nl; rl += ma) {
          const il = this._kernel[rl][1] * ma, cl = this._kernel[rl][2];
          if (il + Sa >= 0 && il + Sa < qn && cl + _a >= 0 && cl + _a < Jo) {
            const ll = this._kernel[rl][0], al = pa[cl][il + Sa];
            al[0] += Ja * ll, al[1] += el * ll, al[2] += qa * ll, al[3] += tl * ll;
          }
        }
      }
    }
    yield { pointContainer: Xn, progress: 100 };
  }
  _fillErrorLine(Xn, zn) {
    Xn.length > zn && (Xn.length = zn);
    const Un = Xn.length;
    for (let Kn = 0; Kn < Un; Kn++) {
      const qn = Xn[Kn];
      qn[0] = qn[1] = qn[2] = qn[3] = 0;
    }
    for (let Kn = Un; Kn < zn; Kn++) Xn[Kn] = [0, 0, 0, 0];
  }
  _setKernel(Xn) {
    switch (Xn) {
      case 0:
        this._kernel = [[7 / 16, 1, 0], [3 / 16, -1, 1], [5 / 16, 0, 1], [1 / 16, 1, 1]];
        break;
      case 1:
        this._kernel = [[3 / 8, 1, 0], [3 / 8, 0, 1], [2 / 8, 1, 1]];
        break;
      case 2:
        this._kernel = [[8 / 42, 1, 0], [4 / 42, 2, 0], [2 / 42, -2, 1], [4 / 42, -1, 1], [8 / 42, 0, 1], [4 / 42, 1, 1], [2 / 42, 2, 1], [1 / 42, -2, 2], [2 / 42, -1, 2], [4 / 42, 0, 2], [2 / 42, 1, 2], [1 / 42, 2, 2]];
        break;
      case 3:
        this._kernel = [[1 / 8, 1, 0], [1 / 8, 2, 0], [1 / 8, -1, 1], [1 / 8, 0, 1], [1 / 8, 1, 1], [1 / 8, 0, 2]];
        break;
      case 4:
        this._kernel = [[7 / 48, 1, 0], [5 / 48, 2, 0], [3 / 48, -2, 1], [5 / 48, -1, 1], [7 / 48, 0, 1], [5 / 48, 1, 1], [3 / 48, 2, 1], [1 / 48, -2, 2], [3 / 48, -1, 2], [5 / 48, 0, 2], [3 / 48, 1, 2], [1 / 48, 2, 2]];
        break;
      case 5:
        this._kernel = [[0.25, 1, 0], [4 / 32, 2, 0], [2 / 32, -2, 1], [4 / 32, -1, 1], [0.25, 0, 1], [4 / 32, 1, 1], [2 / 32, 2, 1]];
        break;
      case 6:
        this._kernel = [[5 / 32, 1, 0], [3 / 32, 2, 0], [2 / 32, -2, 1], [4 / 32, -1, 1], [5 / 32, 0, 1], [4 / 32, 1, 1], [2 / 32, 2, 1], [2 / 32, -1, 2], [3 / 32, 0, 2], [2 / 32, 1, 2]];
        break;
      case 7:
        this._kernel = [[0.25, 1, 0], [3 / 16, 2, 0], [1 / 16, -2, 1], [2 / 16, -1, 1], [3 / 16, 0, 1], [2 / 16, 1, 1], [1 / 16, 2, 1]];
        break;
      case 8:
        this._kernel = [[0.5, 1, 0], [1 / 4, -1, 1], [1 / 4, 0, 1]];
        break;
      default:
        throw new Error(`ErrorDiffusionArray: unknown kernel = ${Xn}`);
    }
  }
};
function* hilbertCurve(Xn, zn, Un) {
  const Kn = Math.max(Xn, zn), qn = { width: Xn, height: zn, level: Math.floor(Math.log(Kn) / Math.log(2) + 1), callback: Un, tracker: new ProgressTracker(Xn * zn, 99), index: 0, x: 0, y: 0 };
  yield* walkHilbert(qn, 1), visit(qn, 0);
}
function* walkHilbert(Xn, zn) {
  if (!(Xn.level < 1)) {
    switch (Xn.tracker.shouldNotify(Xn.index) && (yield { progress: Xn.tracker.progress }), Xn.level--, zn) {
      case 2:
        yield* walkHilbert(Xn, 1), visit(Xn, 3), yield* walkHilbert(Xn, 2), visit(Xn, 4), yield* walkHilbert(Xn, 2), visit(Xn, 2), yield* walkHilbert(Xn, 4);
        break;
      case 3:
        yield* walkHilbert(Xn, 4), visit(Xn, 2), yield* walkHilbert(Xn, 3), visit(Xn, 1), yield* walkHilbert(Xn, 3), visit(Xn, 3), yield* walkHilbert(Xn, 1);
        break;
      case 1:
        yield* walkHilbert(Xn, 2), visit(Xn, 4), yield* walkHilbert(Xn, 1), visit(Xn, 3), yield* walkHilbert(Xn, 1), visit(Xn, 1), yield* walkHilbert(Xn, 3);
        break;
      case 4:
        yield* walkHilbert(Xn, 3), visit(Xn, 1), yield* walkHilbert(Xn, 4), visit(Xn, 2), yield* walkHilbert(Xn, 4), visit(Xn, 4), yield* walkHilbert(Xn, 2);
    }
    Xn.level++;
  }
}
function visit(Xn, zn) {
  switch (Xn.x >= 0 && Xn.x < Xn.width && Xn.y >= 0 && Xn.y < Xn.height && (Xn.callback(Xn.x, Xn.y), Xn.index++), zn) {
    case 2:
      Xn.x--;
      break;
    case 3:
      Xn.x++;
      break;
    case 1:
      Xn.y--;
      break;
    case 4:
      Xn.y++;
  }
}
var ErrorDiffusionRiemersma = class extends AbstractImageQuantizer {
  constructor(Xn, zn = 16, Un = 1) {
    super(), __publicField(this, "_distance"), __publicField(this, "_weights"), __publicField(this, "_errorQueueSize"), this._distance = Xn, this._errorQueueSize = zn, this._weights = ErrorDiffusionRiemersma._createWeights(Un, zn);
  }
  *quantize(Xn, zn) {
    const Un = Xn.getPointArray(), Kn = Xn.getWidth(), qn = Xn.getHeight(), Jo = [];
    let pa = 0;
    for (let ma = 0; ma < this._errorQueueSize; ma++) Jo[ma] = { r: 0, g: 0, b: 0, a: 0 };
    yield* hilbertCurve(Kn, qn, (ma, va) => {
      const ba = Un[ma + va * Kn];
      let { r: _a, g: ya, b: xa, a: wa } = ba;
      for (let ka = 0; ka < this._errorQueueSize; ka++) {
        const Za = this._weights[ka], Na = Jo[(ka + pa) % this._errorQueueSize];
        _a += Na.r * Za, ya += Na.g * Za, xa += Na.b * Za, wa += Na.a * Za;
      }
      const Ta = Point.createByRGBA(inRange0to255Rounded(_a), inRange0to255Rounded(ya), inRange0to255Rounded(xa), inRange0to255Rounded(wa)), Sa = zn.getNearestColor(this._distance, Ta);
      pa = (pa + 1) % this._errorQueueSize;
      const Ma = (pa + this._errorQueueSize - 1) % this._errorQueueSize;
      Jo[Ma].r = ba.r - Sa.r, Jo[Ma].g = ba.g - Sa.g, Jo[Ma].b = ba.b - Sa.b, Jo[Ma].a = ba.a - Sa.a, ba.from(Sa);
    }), yield { pointContainer: Xn, progress: 100 };
  }
  static _createWeights(Xn, zn) {
    const Un = [], Kn = Math.exp(Math.log(zn) / (zn - 1));
    for (let qn = 0, Jo = 1; qn < zn; qn++) Un[qn] = (Jo + 0.5 | 0) / zn * Xn, Jo *= Kn;
    return Un;
  }
}, quality_exports = {};
__export(quality_exports, { ssim: () => ssim });
var K1 = 0.01, K2 = 0.03;
function ssim(Xn, zn) {
  if (Xn.getHeight() !== zn.getHeight() || Xn.getWidth() !== zn.getWidth()) throw new Error("Images have different sizes!");
  const Un = (255 * K1) ** 2, Kn = (255 * K2) ** 2;
  let qn = 0, Jo = 0;
  return iterate(Xn, zn, (pa, ma, va, ba) => {
    let _a = 0, ya = 0, xa = 0;
    for (let Ta = 0; Ta < pa.length; Ta++) ya += (pa[Ta] - va) ** 2, xa += (ma[Ta] - ba) ** 2, _a += (pa[Ta] - va) * (ma[Ta] - ba);
    const wa = pa.length - 1;
    ya /= wa, xa /= wa, _a /= wa, Jo += (2 * va * ba + Un) * (2 * _a + Kn) / ((va ** 2 + ba ** 2 + Un) * (ya + xa + Kn)), qn++;
  }), Jo / qn;
}
function iterate(Xn, zn, Un) {
  const Kn = Xn.getWidth(), qn = Xn.getHeight();
  for (let Jo = 0; Jo < qn; Jo += 8) for (let pa = 0; pa < Kn; pa += 8) {
    const ma = Math.min(8, Kn - pa), va = Math.min(8, qn - Jo), ba = calculateLumaValuesForWindow(Xn, pa, Jo, ma, va), _a = calculateLumaValuesForWindow(zn, pa, Jo, ma, va);
    Un(ba, _a, calculateAverageLuma(ba), calculateAverageLuma(_a));
  }
}
function calculateLumaValuesForWindow(Xn, zn, Un, Kn, qn) {
  const Jo = Xn.getPointArray(), pa = [];
  let ma = 0;
  for (let va = Un; va < Un + qn; va++) {
    const ba = va * Xn.getWidth();
    for (let _a = zn; _a < zn + Kn; _a++) {
      const ya = Jo[ba + _a];
      pa[ma] = 0.2126 * ya.r + 0.7152 * ya.g + 0.0722 * ya.b, ma++;
    }
  }
  return pa;
}
function calculateAverageLuma(Xn) {
  let zn = 0;
  for (const Un of Xn) zn += Un;
  return zn / Xn.length;
}
function buildPaletteSync(Xn, { colorDistanceFormula: zn, paletteQuantization: Un, colors: Kn } = {}) {
  const qn = paletteQuantizationToPaletteQuantizer(colorDistanceFormulaToColorDistance(zn), Un, Kn);
  return Xn.forEach((Jo) => qn.sample(Jo)), qn.quantizeSync();
}
function applyPaletteSync(Xn, zn, { colorDistanceFormula: Un, imageQuantization: Kn } = {}) {
  return imageQuantizationToImageQuantizer(colorDistanceFormulaToColorDistance(Un), Kn).quantizeSync(Xn, zn);
}
function colorDistanceFormulaToColorDistance(Xn = "euclidean-bt709") {
  switch (Xn) {
    case "cie94-graphic-arts":
      return new CIE94GraphicArts();
    case "cie94-textiles":
      return new CIE94Textiles();
    case "ciede2000":
      return new CIEDE2000();
    case "color-metric":
      return new CMetric();
    case "euclidean":
      return new Euclidean();
    case "euclidean-bt709":
      return new EuclideanBT709();
    case "euclidean-bt709-noalpha":
      return new EuclideanBT709NoAlpha();
    case "manhattan":
      return new Manhattan();
    case "manhattan-bt709":
      return new ManhattanBT709();
    case "manhattan-nommyde":
      return new ManhattanNommyde();
    case "pngquant":
      return new PNGQuant();
    default:
      throw new Error(`Unknown colorDistanceFormula ${Xn}`);
  }
}
function imageQuantizationToImageQuantizer(Xn, zn = "floyd-steinberg") {
  switch (zn) {
    case "nearest":
      return new NearestColor(Xn);
    case "riemersma":
      return new ErrorDiffusionRiemersma(Xn);
    case "floyd-steinberg":
      return new ErrorDiffusionArray(Xn, 0);
    case "false-floyd-steinberg":
      return new ErrorDiffusionArray(Xn, 1);
    case "stucki":
      return new ErrorDiffusionArray(Xn, 2);
    case "atkinson":
      return new ErrorDiffusionArray(Xn, 3);
    case "jarvis":
      return new ErrorDiffusionArray(Xn, 4);
    case "burkes":
      return new ErrorDiffusionArray(Xn, 5);
    case "sierra":
      return new ErrorDiffusionArray(Xn, 6);
    case "two-sierra":
      return new ErrorDiffusionArray(Xn, 7);
    case "sierra-lite":
      return new ErrorDiffusionArray(Xn, 8);
    default:
      throw new Error(`Unknown imageQuantization ${zn}`);
  }
}
function paletteQuantizationToPaletteQuantizer(Xn, zn = "wuquant", Un = 256) {
  switch (zn) {
    case "neuquant":
      return new NeuQuant(Xn, Un);
    case "rgbquant":
      return new RGBQuant(Xn, Un);
    case "wuquant":
      return new WuQuant(Xn, Un);
    case "neuquant-float":
      return new NeuQuantFloat(Xn, Un);
    default:
      throw new Error(`Unknown paletteQuantization ${zn}`);
  }
}
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * cie94.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * ciede2000.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * cmetric.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * common.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * constants.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * ditherErrorDiffusionArray.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * euclidean.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * helper.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * hueStatistics.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * lab2rgb.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * lab2xyz.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * manhattanNeuQuant.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * nearestColor.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * palette.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * pngQuant.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * point.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * pointContainer.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * rgb2hsl.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * rgb2lab.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * rgb2xyz.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * ssim.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * wuQuant.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * xyz2lab.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * xyz2rgb.ts - part of Image Quantization Library
 */
/**
 * @preserve
 * MIT License
 *
 * Copyright 2015-2018 Igor Bezkrovnyi
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * riemersma.ts - part of Image Quantization Library
 */
/**
 * @preserve TypeScript port:
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * colorHistogram.ts - part of Image Quantization Library
 */
/**
 * @preserve TypeScript port:
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * neuquant.ts - part of Image Quantization Library
 */
/**
 * @preserve TypeScript port:
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * rgbquant.ts - part of Image Quantization Library
 */
typeof setImmediate == "function" ? setImmediate : typeof process < "u" && (process == null || process.nextTick);
const QuantizeOptionsSchema = z.object({ colors: z.number().optional(), colorDistanceFormula: z.union([z.literal("cie94-textiles"), z.literal("cie94-graphic-arts"), z.literal("ciede2000"), z.literal("color-metric"), z.literal("euclidean"), z.literal("euclidean-bt709-noalpha"), z.literal("euclidean-bt709"), z.literal("manhattan"), z.literal("manhattan-bt709"), z.literal("manhattan-nommyde"), z.literal("pngquant")]).optional(), paletteQuantization: z.union([z.literal("neuquant"), z.literal("neuquant-float"), z.literal("rgbquant"), z.literal("wuquant")]).optional(), imageQuantization: z.union([z.literal("nearest"), z.literal("riemersma"), z.literal("floyd-steinberg"), z.literal("false-floyd-steinberg"), z.literal("stucki"), z.literal("atkinson"), z.literal("jarvis"), z.literal("burkes"), z.literal("sierra"), z.literal("two-sierra"), z.literal("sierra-lite")]).optional() }), methods = { quantize(Xn, zn) {
  const { colors: Un, colorDistanceFormula: Kn, paletteQuantization: qn, imageQuantization: Jo } = QuantizeOptionsSchema.parse(zn), pa = utils_exports.PointContainer.fromUint8Array(Xn.bitmap.data, Xn.bitmap.width, Xn.bitmap.height), ma = applyPaletteSync(pa, buildPaletteSync([pa], { colors: Un, colorDistanceFormula: Kn, paletteQuantization: qn }), { colorDistanceFormula: Kn, imageQuantization: Jo });
  return Xn.bitmap.data = Buffer$1.from(ma.toUint8Array()), Xn;
} };
var parseBmfontAscii = function(Xn) {
  if (!Xn) throw new Error("no data provided");
  var zn = { pages: [], chars: [], kernings: [] }, Un = (Xn = Xn.toString().trim()).split(/\r\n?|\n/g);
  if (Un.length === 0) throw new Error("no data in BMFont file");
  for (var Kn = 0; Kn < Un.length; Kn++) {
    var qn = splitLine(Un[Kn], Kn);
    if (qn) if (qn.key === "page") {
      if (typeof qn.data.id != "number") throw new Error("malformed file at line " + Kn + " -- needs page id=N");
      if (typeof qn.data.file != "string") throw new Error("malformed file at line " + Kn + ' -- needs page file="path"');
      zn.pages[qn.data.id] = qn.data.file;
    } else qn.key === "chars" || qn.key === "kernings" || (qn.key === "char" ? zn.chars.push(qn.data) : qn.key === "kerning" ? zn.kernings.push(qn.data) : zn[qn.key] = qn.data);
  }
  return zn;
};
function splitLine(Xn, zn) {
  if (!(Xn = Xn.replace(/\t+/g, " ").trim())) return null;
  var Un = Xn.indexOf(" ");
  if (Un === -1) throw new Error("no named row at line " + zn);
  var Kn = Xn.substring(0, Un);
  Xn = (Xn = (Xn = (Xn = Xn.substring(Un + 1)).replace(/letter=[\'\"]\S+[\'\"]/gi, "")).split("=")).map(function(va) {
    return va.trim().match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);
  });
  for (var qn = [], Jo = 0; Jo < Xn.length; Jo++) {
    var pa = Xn[Jo];
    Jo === 0 ? qn.push({ key: pa[0], data: "" }) : Jo === Xn.length - 1 ? qn[qn.length - 1].data = parseData(pa[0]) : (qn[qn.length - 1].data = parseData(pa[0]), qn.push({ key: pa[1], data: "" }));
  }
  var ma = { key: Kn, data: {} };
  return qn.forEach(function(va) {
    ma.data[va.key] = va.data;
  }), ma;
}
function parseData(Xn) {
  return Xn && Xn.length !== 0 ? Xn.indexOf('"') === 0 || Xn.indexOf("'") === 0 ? Xn.substring(1, Xn.length - 1) : Xn.indexOf(",") !== -1 ? parseIntList$1(Xn) : parseInt(Xn, 10) : "";
}
function parseIntList$1(Xn) {
  return Xn.split(",").map(function(zn) {
    return parseInt(zn, 10);
  });
}
getDefaultExportFromCjs(parseBmfontAscii);
var GLYPH_DESIGNER_ERROR = "chasrset", parseAttribs = function(Xn) {
  for (var zn in Xn = Object.assign({}, Xn), GLYPH_DESIGNER_ERROR in Xn && (Xn.charset = Xn[GLYPH_DESIGNER_ERROR], delete Xn[GLYPH_DESIGNER_ERROR]), Xn) zn !== "face" && zn !== "charset" && (Xn[zn] = zn === "padding" || zn === "spacing" ? parseIntList(Xn[zn]) : parseInt(Xn[zn], 10));
  return Xn;
};
function parseIntList(Xn) {
  return Xn.split(",").map(function(zn) {
    return parseInt(zn, 10);
  });
}
var xmlParseFromString = self.DOMParser !== void 0 ? function(Xn) {
  return new self.DOMParser().parseFromString(Xn, "application/xml");
} : self.ActiveXObject !== void 0 && new self.ActiveXObject("Microsoft.XMLDOM") ? function(Xn) {
  var zn = new self.ActiveXObject("Microsoft.XMLDOM");
  return zn.async = "false", zn.loadXML(Xn), zn;
} : function(Xn) {
  var zn = document.createElement("div");
  return zn.innerHTML = Xn, zn;
}, parseAttributes = parseAttribs, parseFromString = xmlParseFromString, NAME_MAP = { scaleh: "scaleH", scalew: "scaleW", stretchh: "stretchH", lineheight: "lineHeight", alphachnl: "alphaChnl", redchnl: "redChnl", greenchnl: "greenChnl", bluechnl: "blueChnl" }, browser = function(Xn) {
  Xn = Xn.toString();
  var zn = parseFromString(Xn), Un = { pages: [], chars: [], kernings: [] };
  ["info", "common"].forEach(function(ba) {
    var _a = zn.getElementsByTagName(ba)[0];
    _a && (Un[ba] = parseAttributes(getAttribs(_a)));
  });
  var Kn = zn.getElementsByTagName("pages")[0];
  if (!Kn) throw new Error("malformed file -- no <pages> element");
  for (var qn = Kn.getElementsByTagName("page"), Jo = 0; Jo < qn.length; Jo++) {
    var pa = qn[Jo], ma = parseInt(pa.getAttribute("id"), 10), va = pa.getAttribute("file");
    if (isNaN(ma)) throw new Error('malformed file -- page "id" attribute is NaN');
    if (!va) throw new Error('malformed file -- needs page "file" attribute');
    Un.pages[parseInt(ma, 10)] = va;
  }
  return ["chars", "kernings"].forEach(function(ba) {
    var _a = zn.getElementsByTagName(ba)[0];
    if (_a) for (var ya = ba.substring(0, ba.length - 1), xa = _a.getElementsByTagName(ya), wa = 0; wa < xa.length; wa++) {
      var Ta = xa[wa];
      Un[ba].push(parseAttributes(getAttribs(Ta)));
    }
  }), Un;
};
function getAttribs(Xn) {
  return getAttribList(Xn).reduce(function(zn, Un) {
    return zn[mapName(Un.nodeName)] = Un.nodeValue, zn;
  }, {});
}
function getAttribList(Xn) {
  for (var zn = [], Un = 0; Un < Xn.attributes.length; Un++) zn.push(Xn.attributes[Un]);
  return zn;
}
function mapName(Xn) {
  return NAME_MAP[Xn.toLowerCase()] || Xn;
}
getDefaultExportFromCjs(browser);
var HEADER$1 = [66, 77, 70], parseBmfontBinary = function(Xn) {
  if (Xn.length < 6) throw new Error("invalid buffer length for BMFont");
  var zn = HEADER$1.every(function(Jo, pa) {
    return Xn.readUInt8(pa) === Jo;
  });
  if (!zn) throw new Error("BMFont missing BMF byte header");
  var Un = 3;
  if (Xn.readUInt8(Un++) > 3) throw new Error("Only supports BMFont Binary v3 (BMFont App v1.10)");
  for (var Kn = { kernings: [], chars: [] }, qn = 0; qn < 5; qn++) Un += readBlock(Kn, Xn, Un);
  return Kn;
};
function readBlock(Xn, zn, Un) {
  if (Un > zn.length - 1) return 0;
  var Kn = zn.readUInt8(Un++), qn = zn.readInt32LE(Un);
  switch (Un += 4, Kn) {
    case 1:
      Xn.info = readInfo(zn, Un);
      break;
    case 2:
      Xn.common = readCommon(zn, Un);
      break;
    case 3:
      Xn.pages = readPages(zn, Un, qn);
      break;
    case 4:
      Xn.chars = readChars(zn, Un, qn);
      break;
    case 5:
      Xn.kernings = readKernings(zn, Un, qn);
  }
  return 5 + qn;
}
function readInfo(Xn, zn) {
  var Un = {};
  Un.size = Xn.readInt16LE(zn);
  var Kn = Xn.readUInt8(zn + 2);
  return Un.smooth = Kn >> 7 & 1, Un.unicode = Kn >> 6 & 1, Un.italic = Kn >> 5 & 1, Un.bold = Kn >> 4 & 1, Kn >> 3 & 1 && (Un.fixedHeight = 1), Un.charset = Xn.readUInt8(zn + 3) || "", Un.stretchH = Xn.readUInt16LE(zn + 4), Un.aa = Xn.readUInt8(zn + 6), Un.padding = [Xn.readInt8(zn + 7), Xn.readInt8(zn + 8), Xn.readInt8(zn + 9), Xn.readInt8(zn + 10)], Un.spacing = [Xn.readInt8(zn + 11), Xn.readInt8(zn + 12)], Un.outline = Xn.readUInt8(zn + 13), Un.face = readStringNT(Xn, zn + 14), Un;
}
function readCommon(Xn, zn) {
  var Un = {};
  return Un.lineHeight = Xn.readUInt16LE(zn), Un.base = Xn.readUInt16LE(zn + 2), Un.scaleW = Xn.readUInt16LE(zn + 4), Un.scaleH = Xn.readUInt16LE(zn + 6), Un.pages = Xn.readUInt16LE(zn + 8), Xn.readUInt8(zn + 10), Un.packed = 0, Un.alphaChnl = Xn.readUInt8(zn + 11), Un.redChnl = Xn.readUInt8(zn + 12), Un.greenChnl = Xn.readUInt8(zn + 13), Un.blueChnl = Xn.readUInt8(zn + 14), Un;
}
function readPages(Xn, zn, Un) {
  for (var Kn = [], qn = readNameNT(Xn, zn), Jo = qn.length + 1, pa = Un / Jo, ma = 0; ma < pa; ma++) Kn[ma] = Xn.slice(zn, zn + qn.length).toString("utf8"), zn += Jo;
  return Kn;
}
function readChars(Xn, zn, Un) {
  for (var Kn = [], qn = Un / 20, Jo = 0; Jo < qn; Jo++) {
    var pa = {}, ma = 20 * Jo;
    pa.id = Xn.readUInt32LE(zn + 0 + ma), pa.x = Xn.readUInt16LE(zn + 4 + ma), pa.y = Xn.readUInt16LE(zn + 6 + ma), pa.width = Xn.readUInt16LE(zn + 8 + ma), pa.height = Xn.readUInt16LE(zn + 10 + ma), pa.xoffset = Xn.readInt16LE(zn + 12 + ma), pa.yoffset = Xn.readInt16LE(zn + 14 + ma), pa.xadvance = Xn.readInt16LE(zn + 16 + ma), pa.page = Xn.readUInt8(zn + 18 + ma), pa.chnl = Xn.readUInt8(zn + 19 + ma), Kn[Jo] = pa;
  }
  return Kn;
}
function readKernings(Xn, zn, Un) {
  for (var Kn = [], qn = Un / 10, Jo = 0; Jo < qn; Jo++) {
    var pa = {}, ma = 10 * Jo;
    pa.first = Xn.readUInt32LE(zn + 0 + ma), pa.second = Xn.readUInt32LE(zn + 4 + ma), pa.amount = Xn.readInt16LE(zn + 8 + ma), Kn[Jo] = pa;
  }
  return Kn;
}
function readNameNT(Xn, zn) {
  for (var Un = zn; Un < Xn.length && Xn[Un] !== 0; Un++) ;
  return Xn.slice(zn, Un);
}
function readStringNT(Xn, zn) {
  return readNameNT(Xn, zn).toString("utf8");
}
getDefaultExportFromCjs(parseBmfontBinary);
function e(Xn) {
  return Xn && Xn.__esModule && Object.prototype.hasOwnProperty.call(Xn, "default") ? Xn.default : Xn;
}
const t = (Xn) => {
  if (!Xn) return null;
  const zn = {};
  switch (Xn.type) {
    case "ELEMENT": {
      let Un = {};
      const Kn = E(Xn.value.attributes), qn = t(Xn.value.children);
      if (Kn && (Un = Object.assign(Un, Kn)), qn) {
        const Jo = r(Xn.value.children);
        Un = Object.assign(Un, Jo);
      }
      zn[Xn.value.type] = Un;
      break;
    }
    case "ATTRIBUTE": {
      const Un = Xn.value;
      zn[Un.name] = Un.value;
      break;
    }
    case "CONTENT":
      return { content: Xn.value };
  }
  return zn;
}, r = (Xn) => Xn && Array.isArray(Xn) && Xn.length !== 0 ? n(Xn) ? { content: Xn[0].value } : { children: Xn.map(t) } : null, n = (Xn) => Xn && Array.isArray(Xn) && Xn.length === 1 && Xn[0].type === "CONTENT", E = (Xn) => Xn && Array.isArray(Xn) ? Xn.map(t).reduce((zn, Un) => Object.assign(zn, Un), {}) : null;
var s = { convert: (Xn) => t(Xn.value.children[0]) }, a = { Token: (Xn, zn) => ({ type: Xn, value: zn }), TOKEN_TYPE: { OPEN_BRACKET: "OPEN_BRACKET", ELEMENT_TYPE: "ELEMENT_TYPE", CLOSE_ELEMENT: "CLOSE_ELEMENT", ATTRIB_NAME: "ATTRIB_NAME", ATTRIB_VALUE: "ATTRIB_VALUE", ASSIGN: "ASSIGN", CLOSE_BRACKET: "CLOSE_BRACKET", CONTENT: "CONTENT", EOF: "EOF" } };
const { Token: T, TOKEN_TYPE: u } = a, c = T("EOF"), l = (Xn) => Xn === " " || Xn === `
` || Xn === "\r" || Xn === "	", o = (Xn) => Xn.replace(/'/g, '"');
var N = { createLexer: function(Xn) {
  let zn = null, Un = ((ya) => {
    let xa = 0;
    for (; xa < ya.length && l(ya[xa]); ) xa++;
    return ((wa, Ta) => {
      if (wa.startsWith("<?xml", Ta)) {
        const Sa = wa.length;
        for (; Ta < Sa; ) if (wa[Ta] !== "?") Ta++;
        else {
          if (wa[Ta + 1] === ">") return Ta + 2;
          Ta++;
        }
      }
      return Ta;
    })(ya, xa);
  })(Xn), Kn = [];
  const qn = () => Xn[Un], Jo = () => zn !== c && Un < Xn.length, pa = (ya) => ya === '"' || ya === "'", ma = () => {
    for (; Jo() && l(Xn[Un]); ) Un++;
  }, va = (ya) => {
    if (Jo()) {
      if (Xn[Un] === "<") {
        let xa = "<";
        return Un++, Jo() && Xn[Un] === "/" ? (Un++, xa = "</") : Jo() && Xn[Un] === "!" && Xn[Un + 1] === "-" && Xn[Un + 2] === "-" && (Un++, Un++, Un++, xa = "<!--"), xa;
      }
      if (qn() === "/") {
        let xa = "/";
        return Un++, Jo() && qn() === ">" && (Un++, xa = "/>"), xa;
      }
      if (Xn[Un] === "=" || Xn[Un] === ">") {
        const xa = Xn[Un];
        return Un++, xa;
      }
    }
    return ba(!!ya);
  }, ba = (ya) => {
    const xa = ya ? /[^>=<]/u : /[a-zA-Z0-9_:-]/;
    let wa = Un;
    for (; Jo() && Xn[Un].match(xa); ) Un++;
    return o(Xn.substring(wa, Un));
  }, _a = () => {
    const ya = Un;
    ma();
    const xa = Un - ya;
    if (Jo()) if (zn && zn.type === u.OPEN_BRACKET) {
      ma();
      const wa = va(!1);
      zn = T(u.ELEMENT_TYPE, wa), Kn.push(wa);
    } else if (zn && zn.type === u.ASSIGN) {
      Jo() && pa(qn()) && Un++;
      let wa = Un;
      for (; Jo() && !pa(qn()); ) Un++;
      const Ta = o(Xn.substring(wa, Un));
      Un++, zn = T(u.ATTRIB_VALUE, Ta);
    } else {
      ma();
      let wa = va(!0);
      switch (wa) {
        case "=":
          zn = zn.type === u.ATTRIB_NAME ? T(u.ASSIGN) : T(u.CONTENT, wa);
          break;
        case "</": {
          const Ta = Un;
          for (; Xn[Un] !== ">"; ) Un++;
          zn = T(u.CLOSE_ELEMENT, Xn.substring(Ta, Un)), Un++, Kn.pop();
          break;
        }
        case "/>": {
          const Ta = Kn.pop();
          zn = T(u.CLOSE_ELEMENT, Ta);
          break;
        }
        case "<!--": {
          const Ta = ["!", "-", "-"];
          for (; Jo() && (Ta[2] !== ">" || Ta[1] !== "-" || Ta[0] !== "-"); ) Ta.shift(), Ta.push(Xn[Un]), Un++;
          return _a();
        }
        case ">":
          zn = T(u.CLOSE_BRACKET);
          break;
        case "<":
          zn = T(u.OPEN_BRACKET);
          break;
        default:
          if (wa && wa.length > 0) {
            if (zn.type === u.CLOSE_BRACKET) {
              let Ta = "";
              qn() !== "<" && (Ta = ba(!0)), zn = T(u.CONTENT, wa + Ta);
            } else if (zn.type !== u.ATTRIB_NAME && zn.type !== u.CONTENT) zn.type === u.CLOSE_ELEMENT ? (wa = " ".repeat(xa) + wa, zn = T(u.CONTENT, wa)) : zn = T(u.ATTRIB_NAME, wa);
            else {
              const Ta = " ".repeat(xa) + wa;
              zn = T(u.CONTENT, Ta);
            }
            break;
          }
          {
            const Ta = 'Unknown Syntax : "' + Xn[Un] + '"';
            throw new Error(Ta);
          }
      }
    }
    else zn = c;
    return zn;
  };
  return { peek: qn, next: _a, hasNext: Jo };
} };
const { createLexer: i$2 } = N, { Token: p, TOKEN_TYPE: O } = a, [A, f, C, h] = ["ROOT", "ELEMENT", "ATTRIBUTE", "CONTENT"], _ = (Xn, zn) => ({ type: Xn, value: zn }), L = (Xn) => _(h, Xn), y = (Xn, zn, Un) => _(f, { type: Xn, attributes: zn, children: Un }), v = (Xn, zn) => _(C, { name: Xn, value: zn }), S = (Xn, zn) => {
  const Un = [];
  for (; Xn.hasNext(); ) {
    const Kn = Xn.next();
    switch (Kn.type) {
      case O.OPEN_BRACKET: {
        const qn = Xn.next(), [Jo, pa] = R(Xn);
        let ma = [];
        pa.type !== O.CLOSE_ELEMENT && (ma = S(Xn, qn)), ma && ma.length > 0 && ma[0].type === O.CONTENT && (ma = b(ma)), Un.push(y(qn.value, Jo, ma));
        break;
      }
      case O.CLOSE_ELEMENT:
        if (Kn.value === zn.value) return Un;
        break;
      case O.CONTENT:
        Un.push(L(Kn.value));
        break;
      case O.EOF:
        return Un;
      default:
        throw new Error(`Unknown Lexem type: ${Kn.type} "${Kn.value}, scoping element: ${zn.value}"`);
    }
  }
  return Un;
}, R = (Xn) => {
  const zn = [];
  let Un = Xn.peek();
  if (!Xn.hasNext() || Un && Un.type === O.CLOSE_BRACKET || Un && Un.type === O.CLOSE_ELEMENT) return [zn, Un];
  for (Un = Xn.next(); Xn.hasNext() && Un && Un.type !== O.CLOSE_BRACKET && Un.type !== O.CLOSE_ELEMENT; ) {
    const Kn = Un;
    Xn.next();
    const qn = Xn.next(), Jo = v(Kn.value, qn.value);
    zn.push(Jo), Un = Xn.next();
  }
  return [zn, Un];
};
function b(Xn) {
  let zn = [], Un = "";
  return Xn.forEach((Kn) => {
    Kn.type === O.CONTENT ? Un += Kn.value : (Un.length && (zn.push(L(Un)), Un = ""), zn.push(Kn));
  }), Un.length && zn.push(L(Un)), zn;
}
var B = { transpile: function(Xn, zn) {
  const Un = ((Kn) => _(A, { children: S(Kn, p(A, "ROOT")) }))(i$2(Xn));
  return zn ? zn.convert(Un) : Un;
} };
const M = s, { transpile: x } = B;
var k = e({ convertXML: function(Xn, zn) {
  return x(Xn, zn || M);
}, createAST: function(Xn) {
  return x(Xn);
} }), simpleXmlToJson_min = k, xmlPackage = getDefaultExportFromCjs(simpleXmlToJson_min);
const { convertXML } = xmlPackage;
createJimp({ formats: [png] });
Buffer$1.from([66, 77, 70, 3]);
var pixelmatch_1 = pixelmatch;
const defaultOptions = { threshold: 0.1, includeAA: !1, alpha: 0.1, aaColor: [255, 255, 0], diffColor: [255, 0, 0], diffColorAlt: null, diffMask: !1 };
function pixelmatch(Xn, zn, Un, Kn, qn, Jo) {
  if (!isPixelData(Xn) || !isPixelData(zn) || Un && !isPixelData(Un)) throw new Error("Image data: Uint8Array, Uint8ClampedArray or Buffer expected.");
  if (Xn.length !== zn.length || Un && Un.length !== Xn.length) throw new Error("Image sizes do not match.");
  if (Xn.length !== Kn * qn * 4) throw new Error("Image data size does not match width/height.");
  Jo = Object.assign({}, defaultOptions, Jo);
  const pa = Kn * qn, ma = new Uint32Array(Xn.buffer, Xn.byteOffset, pa), va = new Uint32Array(zn.buffer, zn.byteOffset, pa);
  let ba = !0;
  for (let xa = 0; xa < pa; xa++) if (ma[xa] !== va[xa]) {
    ba = !1;
    break;
  }
  if (ba) {
    if (Un && !Jo.diffMask) for (let xa = 0; xa < pa; xa++) drawGrayPixel(Xn, 4 * xa, Jo.alpha, Un);
    return 0;
  }
  const _a = 35215 * Jo.threshold * Jo.threshold;
  let ya = 0;
  for (let xa = 0; xa < qn; xa++) for (let wa = 0; wa < Kn; wa++) {
    const Ta = 4 * (xa * Kn + wa), Sa = colorDelta(Xn, zn, Ta, Ta);
    Math.abs(Sa) > _a ? Jo.includeAA || !antialiased(Xn, wa, xa, Kn, qn, zn) && !antialiased(zn, wa, xa, Kn, qn, Xn) ? (Un && drawPixel(Un, Ta, ...Sa < 0 && Jo.diffColorAlt || Jo.diffColor), ya++) : Un && !Jo.diffMask && drawPixel(Un, Ta, ...Jo.aaColor) : Un && (Jo.diffMask || drawGrayPixel(Xn, Ta, Jo.alpha, Un));
  }
  return ya;
}
function isPixelData(Xn) {
  return ArrayBuffer.isView(Xn) && Xn.constructor.BYTES_PER_ELEMENT === 1;
}
function antialiased(Xn, zn, Un, Kn, qn, Jo) {
  const pa = Math.max(zn - 1, 0), ma = Math.max(Un - 1, 0), va = Math.min(zn + 1, Kn - 1), ba = Math.min(Un + 1, qn - 1), _a = 4 * (Un * Kn + zn);
  let ya, xa, wa, Ta, Sa = zn === pa || zn === va || Un === ma || Un === ba ? 1 : 0, Ma = 0, ka = 0;
  for (let Za = pa; Za <= va; Za++) for (let Na = ma; Na <= ba; Na++) {
    if (Za === zn && Na === Un) continue;
    const Ka = colorDelta(Xn, Xn, _a, 4 * (Na * Kn + Za), !0);
    if (Ka === 0) {
      if (Sa++, Sa > 2) return !1;
    } else Ka < Ma ? (Ma = Ka, ya = Za, xa = Na) : Ka > ka && (ka = Ka, wa = Za, Ta = Na);
  }
  return Ma !== 0 && ka !== 0 && (hasManySiblings(Xn, ya, xa, Kn, qn) && hasManySiblings(Jo, ya, xa, Kn, qn) || hasManySiblings(Xn, wa, Ta, Kn, qn) && hasManySiblings(Jo, wa, Ta, Kn, qn));
}
function hasManySiblings(Xn, zn, Un, Kn, qn) {
  const Jo = Math.max(zn - 1, 0), pa = Math.max(Un - 1, 0), ma = Math.min(zn + 1, Kn - 1), va = Math.min(Un + 1, qn - 1), ba = 4 * (Un * Kn + zn);
  let _a = zn === Jo || zn === ma || Un === pa || Un === va ? 1 : 0;
  for (let ya = Jo; ya <= ma; ya++) for (let xa = pa; xa <= va; xa++) {
    if (ya === zn && xa === Un) continue;
    const wa = 4 * (xa * Kn + ya);
    if (Xn[ba] === Xn[wa] && Xn[ba + 1] === Xn[wa + 1] && Xn[ba + 2] === Xn[wa + 2] && Xn[ba + 3] === Xn[wa + 3] && _a++, _a > 2) return !0;
  }
  return !1;
}
function colorDelta(Xn, zn, Un, Kn, qn) {
  let Jo = Xn[Un + 0], pa = Xn[Un + 1], ma = Xn[Un + 2], va = Xn[Un + 3], ba = zn[Kn + 0], _a = zn[Kn + 1], ya = zn[Kn + 2], xa = zn[Kn + 3];
  if (va === xa && Jo === ba && pa === _a && ma === ya) return 0;
  va < 255 && (va /= 255, Jo = blend(Jo, va), pa = blend(pa, va), ma = blend(ma, va)), xa < 255 && (xa /= 255, ba = blend(ba, xa), _a = blend(_a, xa), ya = blend(ya, xa));
  const wa = rgb2y(Jo, pa, ma), Ta = rgb2y(ba, _a, ya), Sa = wa - Ta;
  if (qn) return Sa;
  const Ma = rgb2i(Jo, pa, ma) - rgb2i(ba, _a, ya), ka = rgb2q(Jo, pa, ma) - rgb2q(ba, _a, ya), Za = 0.5053 * Sa * Sa + 0.299 * Ma * Ma + 0.1957 * ka * ka;
  return wa > Ta ? -Za : Za;
}
function rgb2y(Xn, zn, Un) {
  return 0.29889531 * Xn + 0.58662247 * zn + 0.11448223 * Un;
}
function rgb2i(Xn, zn, Un) {
  return 0.59597799 * Xn - 0.2741761 * zn - 0.32180189 * Un;
}
function rgb2q(Xn, zn, Un) {
  return 0.21147017 * Xn - 0.52261711 * zn + 0.31114694 * Un;
}
function blend(Xn, zn) {
  return 255 + (Xn - 255) * zn;
}
function drawPixel(Xn, zn, Un, Kn, qn) {
  Xn[zn + 0] = Un, Xn[zn + 1] = Kn, Xn[zn + 2] = qn, Xn[zn + 3] = 255;
}
function drawGrayPixel(Xn, zn, Un, Kn) {
  const qn = blend(rgb2y(Xn[zn + 0], Xn[zn + 1], Xn[zn + 2]), Un * Xn[zn + 3] / 255);
  drawPixel(Kn, zn, qn, qn, qn);
}
getDefaultExportFromCjs(pixelmatch_1);
const defaultPlugins = [methods$h, methods$g, methods$f, methods$e, methods$c, methods$a, methods$b, methods$9, methods$8, methods$7, methods$6, methods$5, methods$4, methods$3, methods$d, methods$2, methods$1, methods], defaultFormats = [bmp, msBmp, gif, jpeg$2, png, tiff];
bmp().mime, gif().mime, jpeg$2().mime, png().mime, tiff().mime;
const Jimp = createJimp({ formats: defaultFormats, plugins: defaultPlugins });
class ModulePlaceholder extends Dependent {
  constructor() {
    super();
    Ca(this, "CSS_PROPERTY_TOP", "--top");
    Ca(this, "CSS_PROPERTY_LEFT", "--left");
    Ca(this, "initializePosition");
    Ca(this, "isStarted");
    // Коэффициент для красного канала
    Ca(this, "RED_WEIGHT", 0.299);
    // Коэффициент для зелёного канала
    Ca(this, "GREEN_WEIGHT", 0.587);
    // Коэффициент для синего канала
    Ca(this, "BLUE_WEIGHT", 0.114);
    // Максимальное значение цвета
    Ca(this, "MAX_COLOR_VALUE", 255);
    // Порог для яркости изображения
    Ca(this, "BRIGHTNESS_THRESHOLD", 0.765);
    Ca(this, "start", (Un) => {
      this.isStarted = !0, this.initializePosition = Un;
    });
    Ca(this, "stop", () => {
      this.isStarted = !1, this.initializePosition = null, this.removePreview();
    });
    Ca(this, "appendPreview", (Un) => {
      if (this.initializePosition === null)
        throw new EditorError("initialize position was null");
      this.updatePreviewPosition(this.initializePosition);
      const Kn = Utils.backend.getSystemImageURI(Un);
      Jimp.read(Kn).then((qn) => {
        this.isImageBright(qn.bitmap) && this.enablePlaceholderDarkMode();
      });
    });
    Ca(this, "removePreview", () => {
      this.disablePlaceholderDarkMode();
    });
    Ca(this, "updatePreviewPosition", (Un) => {
      this.isStarted && this.getModuleAlignmentSection(Un);
    });
    /**
     * Рассчитывает позицию модуля в одной из трёх горизонтальных секций страницы
     * (лево, центр или право) на основе текущей позиции мыши.
     * @param position Позиция мыши.
     */
    Ca(this, "getModuleAlignmentSection", (Un) => {
      const Kn = this.dependencies.componentTree.getRootGraphics(), { x: qn, width: Jo } = Kn[0].getFrameConfiguration();
      return 0;
    });
    Ca(this, "enablePlaceholderDarkMode", () => {
    });
    Ca(this, "disablePlaceholderDarkMode", () => {
    });
    /**
     * Возвращает результат проверки изображения превью, светлое ли оно.
     * @param image Изображение, которое мы проверяем.
     */
    Ca(this, "isImageBright", (Un) => {
      let Kn = 0, qn = 0;
      const { data: Jo } = Un;
      return Jo.forEach((ma, va) => {
        if (va % 4 === 0) {
          const ba = Jo[va], _a = Jo[va + 1], ya = Jo[va + 2], xa = Jo[va + 3];
          if (xa !== 0) {
            const wa = xa / this.MAX_COLOR_VALUE, Ta = (this.RED_WEIGHT * ba + this.GREEN_WEIGHT * _a + this.BLUE_WEIGHT * ya) / this.MAX_COLOR_VALUE;
            Kn += Ta * wa, qn++;
          }
        }
      }), qn === 0 ? !1 : Kn / qn > this.BRIGHTNESS_THRESHOLD;
    });
    this.initializePosition = null, this.isStarted = !1, this.addPostInjectDependenciesListener((Un) => {
      Un.canvasMouseObserver.subscribeToPosition(this.updatePreviewPosition);
    });
  }
}
class PictureReplacer extends Dependent {
  constructor() {
    super();
    Ca(this, "prevReplaceListeners");
    Ca(this, "postReplaceListeners");
    /**
     * Заменяет переданные картинки в приложение на основание переданного Blob-элемента.
     * Метод конвертирует Blob в base64 и отправляет на сервер, после чего добавляет картинку
     * с полученным id.
     * @param pictureComponents Изображения, которые необходимо заменить.
     * @param blob Блоб, который содержит изображение.
     */
    Ca(this, "replacePicture", async (Un, Kn) => {
      const qn = await this.dependencies.pictureImporter.getId(Kn);
      if (qn !== null) {
        this.callPrevReplaceListeners();
        for (let Jo = 0; Jo < Un.length; Jo++) {
          const pa = Un[Jo];
          if (pa === void 0)
            throw new EditorError("picture is undefined");
          const ma = pa.getFirstGraphic();
          if (ma === null)
            throw new EditorError("first graphic not found");
          await ma.setTexture((va) => ({
            ...va,
            source: qn
          })), await ma.adaptPictureToFrame();
        }
        this.callPostReplaceListeners();
      }
    });
    Ca(this, "callPostReplaceListeners", () => {
      this.postReplaceListeners.forEach((Un) => Un());
    });
    Ca(this, "callPrevReplaceListeners", () => {
      this.prevReplaceListeners.forEach((Un) => Un());
    });
    this.prevReplaceListeners = [], this.postReplaceListeners = [];
  }
  addPostReplaceListener(Un) {
    this.postReplaceListeners.push(Un);
  }
  addPrevReplaceListener(Un) {
    this.prevReplaceListeners.push(Un);
  }
}
class TextActionInitiator extends Dependent {
  constructor() {
    super();
    Ca(this, "IDLE_TIMEOUT", 1e3);
    Ca(this, "isActive");
    Ca(this, "idleTimer");
    /**
     * Начинает отслеживание пользовательских действий.
     * Если уже активно — выбрасывает ошибку.
     * Запускает новый таймер бездействия.
     */
    Ca(this, "start", () => {
      if (this.isActive)
        throw new EditorError("text action initiator is active");
      this.isActive = !0, this.dependencies.actionController.startUserAction(), this.resetTimer();
    });
    /**
     * Обновляет таймер бездействия при пользовательском изменении.
     * Если отслеживание неактивно — выбрасывает ошибку.
     */
    Ca(this, "notifyUserChange", () => {
      if (!this.isActive)
        throw new EditorError("text action initiator is inactive");
      this.dependencies.actionController.isRunningAction() || this.dependencies.actionController.startUserAction(), this.resetTimer();
    });
    /**
     * Завершает пользовательское действие и очищает таймер бездействия.
     * Безопасен при повторном вызове.
     */
    Ca(this, "stop", async () => {
      if (this.clearTimer(), !this.isActive)
        throw new EditorError("text action initiator is inactive");
      this.isActive = !1, this.dependencies.actionController.isRunningAction() && await this.dependencies.actionController.stopUserAction();
    });
    /**
     * Принудительно сохраняет изменения и завершает пользовательское действие.
     * Используется в случае аварийного завершения или сброса состояния.
     */
    Ca(this, "forceSave", async () => {
      this.idleTimer !== null && (this.clearTimer(), await this.saveAction());
    });
    /**
     * Возвращает true, если отслеживание пользовательских действий активно.
     * Используется для проверки состояния таймера бездействия.
     */
    Ca(this, "isTimerRunning", () => this.isActive);
    /**
     * Автоматически завершает пользовательское действие после периода бездействия.
     * Вызывается по истечении таймера.
     */
    Ca(this, "saveAction", async () => {
      if (!this.isActive)
        throw new EditorError("text action initiator is inactive");
      await this.dependencies.actionController.stopUserAction();
    });
    /**
     * Перезапускает таймер бездействия.
     * Используется для продления периода активности.
     */
    Ca(this, "resetTimer", () => {
      this.clearTimer(), this.idleTimer = setTimeout(async () => {
        this.clearTimer(), await this.saveAction();
      }, this.IDLE_TIMEOUT);
    });
    /**
     * Останавливает и очищает таймер бездействия, если он был установлен.
     * Выбрасывает ошибку, если таймер не найден.
     */
    Ca(this, "clearTimer", () => {
      this.idleTimer !== null && (clearTimeout(this.idleTimer), this.idleTimer = null);
    });
    this.isActive = !1, this.idleTimer = null;
  }
}
var CommandType = /* @__PURE__ */ ((Xn) => (Xn.SKETCH_NAME_CHANGE = "SKETCH_NAME_CHANGE", Xn.APPEND_COMPONENT = "APPEND_COMPONENT", Xn.REMOVE_COMPONENT = "REMOVE_COMPONENT", Xn.CHANGE_COMPONENT = "CHANGE_COMPONENT", Xn.LAYER_SEQUENCES = "LAYER_SEQUENCES", Xn))(CommandType || {});
class ActionController extends Dependent {
  /** Создает экземпляр `ActionController`. */
  constructor() {
    super();
    Ca(this, "startActionListeners");
    Ca(this, "stopActionListeners");
    /** Флаг, указывающий на выполнение действия пользователя. */
    Ca(this, "actionProcess");
    /**
     * Выполняет пользовательское действие с контролем состояния.
     * @param userAction Функция, выполняющая действие пользователя.
     * @throws {EditorError} Если уже выполняется другое действие.
     */
    Ca(this, "executeUserAction", async (Un) => {
      this.startUserAction(), await Un(), await this.stopUserAction();
    });
    /**
     * Начинает выполнение пользовательского действия.
     * @throws {EditorError} Если уже выполняется другое действие.
     */
    Ca(this, "startUserAction", () => {
      if (this.actionProcess)
        throw console.trace(), new EditorError("action is active");
      this.actionProcess = !0, this.callPostStartActionListeners();
    });
    /**
     * Завершает выполнение пользовательского действия.
     * @throws {EditorError} Если действие не выполняется.
     */
    Ca(this, "stopUserAction", async () => {
      if (!this.actionProcess)
        throw console.trace(), new EditorError("action is inactive");
      this.performAction(), this.actionProcess = !1, this.callPostStopActionListeners();
    });
    /**
     * Принудительно завершает выполнение пользовательского действия.
     */
    Ca(this, "forceStopUserAction", () => {
      this.performAction(), this.actionProcess = !1;
    });
    /**
     * Отправляет команды в удаленное хранилище.
     * Исключает команды изменения последовательности слоев, так как они используются только внутри манипулятора.
     * @param commands Команды на изменение структуры скетча.
     */
    Ca(this, "sendCommands", (Un) => {
      const { getConstructorConnectionStatus: Kn, sendCommands: qn } = this.dependencies, Jo = Un.filter((ma) => ma.type !== CommandType.LAYER_SEQUENCES);
      if (Kn()) {
        qn(Jo);
        return;
      }
    });
    Ca(this, "addPostStartActionListener", (Un) => {
      this.startActionListeners.push(Un);
    });
    Ca(this, "addPostStopActionListener", (Un) => {
      this.stopActionListeners.push(Un);
    });
    Ca(this, "isRunningAction", () => this.actionProcess);
    /**
     * Выполняет действие пользователя, добавляет его в хранилище и отправляет команды.
     */
    Ca(this, "performAction", () => {
      const Un = this.dependencies.state.buildAction();
      if (Un === null)
        return;
      const Kn = Un.getRedoCommands();
      this.dependencies.actionStore.push(Un), this.sendCommands(Kn);
    });
    Ca(this, "callPostStartActionListeners", () => {
      this.startActionListeners.forEach((Un) => Un());
    });
    Ca(this, "callPostStopActionListeners", () => {
      this.stopActionListeners.forEach((Un) => Un());
    });
    this.actionProcess = !1, this.stopActionListeners = [], this.startActionListeners = [];
  }
}
class ActionRepository {
  constructor() {
    Ca(this, "CURSOR_STEP", 1);
    Ca(this, "CURSOR_DEVIATION", 0.5);
    Ca(this, "CURSOR_INITIAL_VALUE", -0.5);
    Ca(this, "actions");
    Ca(this, "postMoveTimeLineCursorEvents");
    Ca(this, "cursor");
    /**
     * Возвращает количество action доступных для восстановления.
     */
    Ca(this, "getRedoActionCount", () => {
      if (this.actions.length === 0)
        return 0;
      const zn = this.cursor + this.CURSOR_DEVIATION;
      return this.actions.length - 1 < zn ? 0 : this.actions.length - zn;
    });
    /**
     * Возвращает количество action доступных для отмены.
     */
    Ca(this, "getUndoActionCount", () => this.actions.length === 0 ? 0 : this.cursor - this.CURSOR_INITIAL_VALUE);
    Ca(this, "push", (zn) => {
      this.deleteFutureActions(), this.actions.push(zn), this.moveCursorForward();
    });
    Ca(this, "getActions", () => [...this.actions]);
    /**
     * Отменяет последнее действие.
     */
    Ca(this, "undoAction", (zn) => {
      const Un = this.cursor - this.CURSOR_DEVIATION, Kn = this.actions[Un];
      Kn === void 0 || !zn(Kn) || this.cursor !== this.CURSOR_INITIAL_VALUE && this.moveCursorBack();
    });
    /**
     * Выполняет следующее действие, стоящее впереди временной линии.
     */
    Ca(this, "redoAction", (zn) => {
      const Un = this.cursor + this.CURSOR_DEVIATION, Kn = this.actions[Un];
      Kn === void 0 || !zn(Kn) || this.moveCursorForward();
    });
    /**
     * Удаляет все действия, следующие после текущей позиции курсора.
     */
    Ca(this, "deleteFutureActions", () => {
      const zn = this.cursor + this.CURSOR_DEVIATION;
      this.actions.splice(zn);
    });
    Ca(this, "getCursorPosition", () => this.cursor);
    Ca(this, "getActionCount", () => this.actions.length);
    Ca(this, "addPostMoveTimeLineCursorListener", (zn) => {
      this.postMoveTimeLineCursorEvents.push(zn);
    });
    Ca(this, "callPostMoveTimeLineCursorEvents", () => {
      this.postMoveTimeLineCursorEvents.forEach((zn) => zn());
    });
    Ca(this, "moveCursorForward", () => {
      this.cursor += this.CURSOR_STEP, this.callPostMoveTimeLineCursorEvents();
    });
    Ca(this, "moveCursorBack", () => {
      this.cursor -= this.CURSOR_STEP, this.callPostMoveTimeLineCursorEvents();
    });
    this.cursor = this.CURSOR_INITIAL_VALUE, this.actions = [], this.postMoveTimeLineCursorEvents = [];
  }
}
class ActionStore extends Dependent {
  constructor() {
    super();
    Ca(this, "postUndoRedoListeners");
    Ca(this, "push", (Un) => {
      this.dependencies.repository.push(Un);
    });
    /**
     * Отменяет последнее действие, возвращает состояние успеха отмены.
     */
    Ca(this, "undo", () => {
      this.dependencies.repository.undoAction((Un) => {
        Un.undo(), this.callPostUndoRedoListeners();
        const Kn = Un.getUndoCommands();
        return this.dependencies.actionController.sendCommands(Kn), !0;
      });
    });
    /**
     * Выполняет последнее действие, возвращает состояние успеха отмены.
     */
    Ca(this, "redo", () => {
      this.dependencies.repository.redoAction((Un) => (Un.redo(), this.callPostUndoRedoListeners(), !0));
    });
    Ca(this, "addPostUndoRedoListener", (Un) => {
      this.postUndoRedoListeners.push(Un);
    });
    Ca(this, "getUndoCommandCount", () => this.dependencies.repository.getUndoActionCount());
    Ca(this, "getRedoCommandCount", () => this.dependencies.repository.getRedoActionCount());
    Ca(this, "callPostUndoRedoListeners", () => {
      this.postUndoRedoListeners.forEach((Un) => Un());
    });
    this.postUndoRedoListeners = [];
  }
}
class ConstructorAction {
  constructor() {
    Ca(this, "redoCommands");
    Ca(this, "undoCommands");
    /**
     * Возвращает команды для восстановления действия.
     */
    Ca(this, "getRedoCommands", () => [...this.redoCommands]);
    /**
     * Возвращает команды для отмены действия.
     */
    Ca(this, "getUndoCommands", () => [...this.undoCommands]);
    /**
     * Добавляет команды для восстановления действия.
     * @param commands Добавляемые команды.
     */
    Ca(this, "pushRedoCommands", (...zn) => {
      this.redoCommands.push(...zn);
    });
    /**
     * Добавляет команды для отмены действия.
     * @param commands Добавляемые команды.
     */
    Ca(this, "pushUndoCommands", (...zn) => {
      this.undoCommands.push(...zn);
    });
    /**
     * Восстановить действие.
     */
    Ca(this, "redo", () => {
      this.redoCommands.forEach((zn) => {
        zn.exec();
      });
    });
    /**
     * Отменить действие.
     */
    Ca(this, "undo", () => {
      this.undoCommands.forEach((zn) => {
        zn.exec();
      });
    });
    /**
     * Имеет ли действие наличие команд.
     */
    Ca(this, "isEmpty", () => this.redoCommands.length === 0 || this.undoCommands.length === 0);
    this.redoCommands = [], this.undoCommands = [];
  }
}
class EditorCommand {
  constructor() {
    Ca(this, "serialize", () => ({
      type: this.type,
      body: this.buildBody()
    }));
  }
}
class ComponentAppendCommand extends EditorCommand {
  constructor(Un, Kn, qn, Jo) {
    super();
    Ca(this, "type", CommandType.APPEND_COMPONENT);
    Ca(this, "sketchID");
    Ca(this, "parent");
    Ca(this, "component");
    Ca(this, "componentTreeMutator");
    Ca(this, "exec", async () => {
      await this.componentTreeMutator.executeMutations(async (Un) => {
        Un.mutator.mutateByAppendComponent(this.parent, this.component);
      });
    });
    Ca(this, "buildBody", () => {
      const { id: Un } = this.parent.getStructure(), Kn = this.component.getStructure();
      return {
        sketch: this.sketchID,
        parent: Un,
        structure: Kn
      };
    });
    this.parent = qn, this.sketchID = Jo, this.component = Kn, this.componentTreeMutator = Un;
  }
}
class ComponentChangeCommand extends EditorCommand {
  constructor(Un) {
    super();
    Ca(this, "type", CommandType.CHANGE_COMPONENT);
    Ca(this, "sketchID");
    Ca(this, "component");
    Ca(this, "structure");
    Ca(this, "componentTree");
    Ca(this, "exec", async () => {
      await this.component.setStructure((pa) => this.structure);
      let Un = this.component.getGraphics();
      const Kn = this.structure.graphics;
      if (Kn === null)
        throw new EditorError("graphics not found");
      const qn = Un.length, Jo = Kn.length;
      if (qn !== Jo) {
        const pa = Math.abs(qn - Jo);
        if (qn > Jo) {
          const ma = Un.slice(Un.length - pa);
          await this.componentTree.executeMutations(async (va) => {
            ma.forEach((ba) => {
              va.mutator.mutateByRemoveGraphic(ba);
            });
          });
        } else {
          const ma = Kn[0];
          if (ma === void 0)
            throw new EditorError("base structure not found");
          for (let va = 0; va < pa; va++)
            await this.componentTree.executeMutations(async (ba) => {
              const _a = ba.graphicFactory.createGraphic(ma.type, this.component);
              await _a.setStructure(() => ma), ba.mutator.mutateByAppendGraphic(this.component, _a);
            });
        }
      }
      Un = this.component.getGraphics(), Un.forEach((pa, ma) => {
        if (this.structure.graphics === null)
          throw new EditorError("graphics in structure not found");
        const va = this.structure.graphics[ma];
        pa.setStructure(() => va);
      });
      for (const pa of Un)
        if (pa.type === GraphicType.TEXT) {
          const ma = pa;
          ma.setFrameConfiguration((va) => ({
            ...va,
            height: ma.getFrameConfiguration().height
          }));
        }
    });
    Ca(this, "buildBody", () => ({
      sketch: this.sketchID,
      structure: { ...this.structure }
    }));
    this.sketchID = Un.sketchID, this.component = Un.component, this.structure = { ...Un.structure }, this.componentTree = Un.componentTree;
  }
}
class ComponentRemoveCommand extends EditorCommand {
  constructor(Un, Kn, qn, Jo) {
    super();
    Ca(this, "type", CommandType.REMOVE_COMPONENT);
    Ca(this, "sketch");
    Ca(this, "parent");
    Ca(this, "component");
    Ca(this, "componentTreeMutator");
    Ca(this, "exec", async () => {
      await this.componentTreeMutator.executeMutations(async (Un) => {
        Un.mutator.mutateByRemoveComponent(this.component);
      });
    });
    Ca(this, "buildBody", () => {
      const Un = this.parent.getStructure().id, Kn = this.component.getStructure().id;
      return {
        sketch: this.sketch,
        parent: Un,
        component: Kn
      };
    });
    this.parent = qn, this.sketch = Jo, this.component = Kn, this.componentTreeMutator = Un;
  }
}
class LayerSequencesCommand extends EditorCommand {
  constructor(Un, Kn) {
    super();
    Ca(this, "type", CommandType.LAYER_SEQUENCES);
    Ca(this, "layerSequences");
    Ca(this, "componentTree");
    Ca(this, "exec", async () => {
      this.componentTree.setLayerSequences(this.layerSequences);
    });
    this.layerSequences = Kn, this.componentTree = Un;
  }
  buildBody() {
    return {};
  }
}
class SketchNameChangeCommand extends EditorCommand {
  constructor(Un, Kn) {
    super();
    Ca(this, "type", CommandType.SKETCH_NAME_CHANGE);
    Ca(this, "editor");
    Ca(this, "name");
    Ca(this, "exec", async () => {
      this.editor.setName(this.name);
    });
    /**
     * Конвертирует данные команды в формат, требуемый API.
     */
    Ca(this, "buildBody", () => ({
      sketch: this.editor.getID(),
      name: this.name
    }));
    this.name = Kn, this.editor = Un;
  }
}
class SketchState extends Dependent {
  constructor() {
    super();
    Ca(this, "sketchID");
    Ca(this, "snapshot");
    /**
     * Синхронизирует внутренние структуры данными из текущего состояния скетча.
     */
    Ca(this, "syncState", () => {
      const Un = this.dependencies.editor.getName(), Kn = this.dependencies.componentTree.getComponents();
      this.snapshot.mapComponentStructure.clear(), this.snapshot.mapComponentChildParent.clear(), this.snapshot.name = Un, Kn.forEach((qn) => {
        const Jo = {
          ...qn.getStructure(),
          components: null
        }, pa = qn.getParentComponent();
        this.snapshot.mapComponentStructure.set(qn, Jo), this.snapshot.mapComponentChildParent.set(qn, pa);
      }), this.snapshot.layerSequences = this.dependencies.componentTree.getLayerSequences();
    });
    /**
     * Сравнивает последнее сохраненное состояние с текущим и генерирует действие на основе изменений.
     * @returns {IEditorAction} - Сгенерированное действие.
     */
    Ca(this, "buildAction", () => {
      const Un = new ConstructorAction(), Kn = this.dependencies.editor.getStructure(), qn = this.dependencies.componentTree.getComponents(), Jo = Array.from(this.snapshot.mapComponentStructure.keys());
      this.scanSketch(Un, Kn);
      const pa = this.scanRemoveComponents(Un, Jo, qn), ma = this.scanAppendComponents(Un, Jo, qn);
      return pa.filter((ba) => !ma.includes(ba)).forEach((ba) => {
        this.scanStructureComponent(Un, ba), this.scanChangeParentComponent(Un, ba);
      }), Un.isEmpty() || this.scanChangeLayers(Un), this.syncState(), Un;
    });
    Ca(this, "setSketchID", (Un) => {
      this.sketchID = Un;
    });
    /**
     * Записывает общие изменения характеристик скетча в действие.
     * @param {ConstructorAction} action - Действие для записи изменений.
     * @param {IEditorStructure} sketchStructure - Структура скетча.
     */
    Ca(this, "scanSketch", (Un, Kn) => {
      const { name: qn } = Kn;
      if (qn === this.snapshot.name)
        return;
      const Jo = new SketchNameChangeCommand(this.dependencies.editor, this.snapshot.name), pa = new SketchNameChangeCommand(this.dependencies.editor, qn);
      Un.pushUndoCommands(Jo), Un.pushRedoCommands(pa);
    });
    /**
     * Записывает удаление компонентов в действие и возвращает актуальные компоненты, для которых
     * целесообразна проверка на изменение характеристик (коллекция включает также только что добавленные компоненты).
     * @param {ConstructorAction} action - Действие для записи изменений.
     * @param {IComponent[]} snapshotComponents - Компоненты из предыдущего состояния.
     * @param {IComponent[]} currentComponents - Текущие компоненты.
     * @returns {IComponent[]} - Актуальные компоненты после удаления.
     */
    Ca(this, "scanRemoveComponents", (Un, Kn, qn) => {
      const Jo = this.getRemoveComponents(Kn, qn), pa = qn.filter((ma) => !Jo.includes(ma));
      return Jo.forEach((ma) => {
        const va = this.snapshot.mapComponentChildParent.get(ma);
        if (va === void 0)
          throw new EditorError("component parent not found");
        if (va === null)
          return;
        const ba = new ComponentAppendCommand(this.dependencies.componentTree, ma, va, this.sketchID), _a = new ComponentRemoveCommand(this.dependencies.componentTree, ma, va, this.sketchID);
        Un.pushUndoCommands(ba), Un.pushRedoCommands(_a);
      }), pa;
    });
    /**
     * Записывает появление компонентов в действие.
     * @param {ConstructorAction} action - Действие для записи изменений.
     * @param {IComponent[]} snapshotComponents - Компоненты из предыдущего состояния.
     * @param {IComponent[]} currentComponents - Текущие компоненты.
     * @returns {IComponent[]} - Компоненты, которые были добавлены.
     */
    Ca(this, "scanAppendComponents", (Un, Kn, qn) => {
      const Jo = this.getAppendComponents(Kn, qn);
      return Jo.forEach((pa) => {
        const ma = pa.getParentComponent();
        if (ma === null)
          throw new EditorError("component parent not found");
        const va = new ComponentRemoveCommand(this.dependencies.componentTree, pa, ma, this.sketchID), ba = new ComponentAppendCommand(this.dependencies.componentTree, pa, ma, this.sketchID);
        Un.pushUndoCommands(va), Un.pushRedoCommands(ba);
      }), Jo;
    });
    /**
     * Возвращает компоненты, которые были удалены.
     * @param {IComponent[]} snapshotComponents - Компоненты из предыдущего состояния.
     * @param {IComponent[]} currentComponents - Текущие компоненты.
     * @returns {IComponent[]} - Компоненты, которые были удалены.
     */
    Ca(this, "getRemoveComponents", (Un, Kn) => Un.filter((qn) => !Kn.includes(qn)));
    /**
     * Возвращает компоненты, которые были добавлены.
     * @param {IComponent[]} snapshotComponents - Компоненты из предыдущего состояния.
     * @param {IComponent[]} currentComponents - Текущие компоненты.
     * @returns {IComponent[]} - Компоненты, которые были добавлены.
     */
    Ca(this, "getAppendComponents", (Un, Kn) => Kn.filter((qn) => !Un.includes(qn)));
    /**
     * Записывает изменения характеристик компонента в действие.
     * @param {ConstructorAction} action - Действие для записи изменений.
     * @param {IComponent} component - Компонент, для которого записываются изменения.
     */
    Ca(this, "scanStructureComponent", (Un, Kn) => {
      const qn = {
        ...Kn.getStructure(),
        components: null
      }, Jo = this.snapshot.mapComponentStructure.get(Kn);
      if (Jo === void 0)
        throw new EditorError("structure snapshot not found");
      if (Utils.objectUtils.deepEqual(Jo, qn))
        return;
      const ma = new ComponentChangeCommand({
        component: Kn,
        sketchID: this.sketchID,
        structure: Jo,
        componentTree: this.dependencies.componentTree
      }), va = new ComponentChangeCommand({
        component: Kn,
        sketchID: this.sketchID,
        structure: qn,
        componentTree: this.dependencies.componentTree
      });
      Un.pushUndoCommands(ma), Un.pushRedoCommands(va);
    });
    /**
     * Записывает смену родителя компонента в действие.
     * @param {ConstructorAction} action - Действие для записи изменений.
     * @param {IComponent} component - Компонент, для которого записывается смена родителя.
     */
    Ca(this, "scanChangeParentComponent", (Un, Kn) => {
      const qn = this.snapshot.mapComponentChildParent.get(Kn), Jo = Kn.getParentComponent();
      if (qn === void 0)
        throw new EditorError("snapshot parent not found");
      if (qn === null || Jo === null || qn === Jo)
        return;
      const pa = new ComponentRemoveCommand(
        this.dependencies.componentTree,
        Kn,
        Jo,
        this.sketchID
      ), ma = new ComponentAppendCommand(
        this.dependencies.componentTree,
        Kn,
        qn,
        this.sketchID
      ), va = new ComponentRemoveCommand(
        this.dependencies.componentTree,
        Kn,
        qn,
        this.sketchID
      ), ba = new ComponentAppendCommand(
        this.dependencies.componentTree,
        Kn,
        Jo,
        this.sketchID
      );
      Jo.isUniter || Un.pushUndoCommands(pa, ma), qn.isUniter || Un.pushRedoCommands(va, ba);
    });
    /**
     * Ищет изменения в последовательности слоев. В случае обнаружения записывает соответствующие команды в action.
     * @param action Сущность действия пользователя, в которую будут записаны команды изменения скетча.
     */
    Ca(this, "scanChangeLayers", (Un) => {
      const Kn = this.dependencies.componentTree.getLayerSequences();
      if (Utils.objectUtils.deepEqual(this.snapshot.layerSequences, Kn))
        return;
      const Jo = new LayerSequencesCommand(this.dependencies.componentTree, this.snapshot.layerSequences), pa = new LayerSequencesCommand(this.dependencies.componentTree, Kn);
      Un.pushRedoCommands(pa), Un.pushUndoCommands(Jo);
    });
    this.snapshot = {
      name: "",
      layerSequences: [],
      mapComponentChildParent: /* @__PURE__ */ new Map(),
      mapComponentStructure: /* @__PURE__ */ new Map()
    }, this.sketchID = "not initialized", this.addPostInjectDependenciesListener((Un) => {
      this.sketchID = Un.editor.getID();
    });
  }
}
class SpatialContextMenuArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.CONTEXT_MENU);
    Ca(this, "getGlobalFrameArea", () => this.contextMenu.getFrameArea());
    Ca(this, "getData", () => this.contextMenu);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.contextMenu = Un;
  }
}
var ContextMode = /* @__PURE__ */ ((Xn) => (Xn.DEFAULT = "DEFAULT", Xn.GRAPHIC_GROUP = "GRAPHIC_GROUP", Xn.GRAPHIC_UNGROUP = "GRAPHIC_UNGROUP", Xn.TABLE = "TABLE", Xn))(ContextMode || {});
class ContextAddColumnLeftButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 24);
    Ca(this, "DEFAULT_TEXT", "Добавить столбец слева");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.COLUMN_LEFT),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextAddColumnRightButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 24);
    Ca(this, "DEFAULT_TEXT", "Добавить столбец справа");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.COLUMN_RIGHT),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextAddRowAboveButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 24);
    Ca(this, "DEFAULT_TEXT", "Добавить строку выше");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.ROW_OVER),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      svgScale: ScaleSvg.HEIGHT,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextAddRowBelowButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 24);
    Ca(this, "DEFAULT_TEXT", "Добавить строку ниже");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.ROW_UNDER),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      svgScale: ScaleSvg.HEIGHT,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextCopyButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Скопировать",
      textColor: "black",
      placeholder: "Ctrl+C",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextCreateModuleButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Создать модуль",
      textColor: "black",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextDelButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Удалить",
      textColor: "black",
      placeholder: "Del",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextDelColumnButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 20);
    Ca(this, "DEFAULT_TEXT", "Удалить столбец");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.DELETE_COLUMN),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgScale: ScaleSvg.HEIGHT,
      svgColor: UIDefaultColor.BLACK,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextDelRowButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 20);
    Ca(this, "DEFAULT_TEXT", "Удалить строку");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.DELETE_ROW),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextGroupButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Добавить в группу",
      textColor: "black",
      placeholder: "Ctrl+G",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextHideInterfaceButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "onToggleInterfaceVisible", () => {
      if (this.dependencies.ui.isShowed()) {
        this.dependencies.ui.hide(), this.setConfiguration((Un) => ({
          ...Un,
          text: "Показать интерфейс"
        }));
        return;
      }
      this.dependencies.ui.show(), this.setConfiguration((Un) => ({
        ...Un,
        text: "Скрыть интерфейс"
      }));
    });
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Скрыть интерфейс",
      textColor: "black",
      placeholder: "Ctrl+\\",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    })), this.addPostInjectDependenciesListener(() => {
      this.addPostMouseDownListeners(this.onToggleInterfaceVisible);
    });
  }
}
class ContextMergeCellsButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 20);
    Ca(this, "DEFAULT_TEXT", "Объединить ячейки");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.MERGE_CELLS),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextMoveBackButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Переместить назад",
      textColor: "black",
      placeholder: "]",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextMoveForwardButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Переместить вперед",
      textColor: "black",
      placeholder: "[",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextPasteButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Вставить",
      textColor: "black",
      placeholder: "Ctrl+V",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextPlanToBackButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "На задний план",
      textColor: "black",
      placeholder: "ctrl+]",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextPlanToForwardButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "На передний план",
      textColor: "black",
      placeholder: "Ctrl+]",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextSplitCellsButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 20);
    Ca(this, "DEFAULT_TEXT", "Разделить ячейки");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.SPLIT_CELLS),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextSplitTableButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_SVG_SIZE", 20);
    Ca(this, "DEFAULT_TEXT", "Разделить таблицу");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE_BUTTON", 14);
    Ca(this, "DEFAULT_PADDING_BUTTON", {
      topBottom: 0,
      leftRight: 16
    });
    const Un = new Xo(this.DEFAULT_TEXT, {
      fontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }), Kn = Math.round(
      (this.DEFAULT_WIDTH - this.DEFAULT_PADDING_BUTTON.leftRight - this.DEFAULT_SVG_SIZE) / 2 - Un.width / 2
    );
    this.setConfiguration((qn) => ({
      ...qn,
      text: this.DEFAULT_TEXT,
      textColor: UIDefaultColor.BLACK,
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      svg: {
        object: SVGCanvasStore.getSvgGroup(SVGCollection.SPLIT_TABLE),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: this.DEFAULT_SVG_SIZE,
      svgColor: UIDefaultColor.BLACK,
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: this.DEFAULT_PADDING_BUTTON,
      insideTextToSvg: Kn,
      textFontSize: this.DEFAULT_TEXT_FONT_SIZE_BUTTON
    }));
  }
}
class ContextUnGroupButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      text: "Разгруппировать",
      textColor: "black",
      placeholder: "Ctrl+Shift+G",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      fillHover: null,
      textColorHover: UIDefaultColor.BLUE_900,
      borderColor: UIDefaultColor.WHITE,
      borderColorHover: null,
      durationHover: 50,
      textFontSize: 14
    }));
  }
}
class ContextMenuView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    Ca(this, "DEFAULT_PADDING_VERTICAL", 8);
    Ca(this, "copy");
    Ca(this, "paste");
    Ca(this, "delete");
    Ca(this, "hideInterface");
    Ca(this, "group");
    Ca(this, "ungroup");
    Ca(this, "moveForward");
    Ca(this, "moveBack");
    Ca(this, "planToForward");
    Ca(this, "planToBack");
    Ca(this, "createModule");
    Ca(this, "mergeCells");
    Ca(this, "splitCells");
    Ca(this, "splitTable");
    Ca(this, "addColumnLeft");
    Ca(this, "addColumnRight");
    Ca(this, "addRowBelow");
    Ca(this, "addRowAbove");
    Ca(this, "deleteRow");
    Ca(this, "deleteColumn");
    Ca(this, "buttons");
    Ca(this, "container");
    Ca(this, "firstSeparator");
    Ca(this, "secondSeparator");
    Ca(this, "thirdSeparator");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "contextMode");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "showDefaultMenu", (Un) => {
      this.contextMode = ContextMode.DEFAULT, this.setAndFixPosition(Un), this.container.object.visible = !0, this.copy.show(), this.paste.show(), this.delete.show(), this.hideInterface.show(), this.firstSeparator.object.visible = !0;
    });
    Ca(this, "showTableMenu", (Un, Kn) => {
      if (!Kn.isEnableEditMode()) {
        this.showComponentMenu(Un, Kn);
        return;
      }
      this.contextMode = ContextMode.TABLE, this.setAndFixPosition(Un), this.container.object.visible = !0, this.mergeCells.show(), this.splitCells.show(), this.splitTable.show(), this.addColumnLeft.show(), this.addColumnRight.show(), this.addRowBelow.show(), this.addRowAbove.show(), this.deleteRow.show(), this.deleteColumn.show(), this.copy.show(), this.paste.show(), this.dependencies.render.renderUnstructured(), this.dependencies.render.renderRelativePositions();
    });
    Ca(this, "showComponentMenu", (Un, Kn) => {
      Kn.isUniter ? this.contextMode = ContextMode.GRAPHIC_UNGROUP : this.contextMode = ContextMode.GRAPHIC_GROUP, this.setAndFixPosition(Un), this.container.object.visible = !0, this.copy.show(), this.paste.show(), this.delete.show(), Kn.isUniter ? this.ungroup.show() : this.group.show(), this.moveForward.show(), this.moveBack.show(), this.planToForward.show(), this.planToBack.show(), this.createModule.show(), this.firstSeparator.object.visible = !0, this.secondSeparator.object.visible = !0, this.thirdSeparator.object.visible = !0, this.dependencies.render.renderUnstructured(), this.dependencies.render.renderRelativePositions();
    });
    Ca(this, "hide", () => {
      this.isShow = !1, this.container.object.visible = !1, this.firstSeparator.object.visible = !1, this.secondSeparator.object.visible = !1, this.thirdSeparator.object.visible = !1, this.buttons.forEach((Un) => {
        Un.hide();
      });
    });
    Ca(this, "getWidth", () => this.DEFAULT_WIDTH);
    Ca(this, "getHeight", () => {
      switch (this.contextMode) {
        case ContextMode.DEFAULT:
          return this.DEFAULT_PADDING_VERTICAL * 2 + this.DEFAULT_HEIGHT_BUTTON * 4 + this.DEFAULT_PADDING_VERTICAL * 2 + this.firstSeparator.object.height;
        case ContextMode.TABLE:
          return this.DEFAULT_PADDING_VERTICAL * 2 + this.DEFAULT_HEIGHT_BUTTON * 11;
        case ContextMode.GRAPHIC_GROUP:
          return this.DEFAULT_PADDING_VERTICAL * 2 + this.DEFAULT_HEIGHT_BUTTON * 9 + this.DEFAULT_PADDING_VERTICAL * 6 + this.firstSeparator.object.height + this.secondSeparator.object.height + this.thirdSeparator.object.height;
        case ContextMode.GRAPHIC_UNGROUP:
          return this.DEFAULT_PADDING_VERTICAL * 2 + this.DEFAULT_HEIGHT_BUTTON * 9 + this.DEFAULT_PADDING_VERTICAL * 6 + this.firstSeparator.object.height + this.secondSeparator.object.height + this.thirdSeparator.object.height;
      }
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      this.container.object.fill = qn.fill, this.configuration = qn;
    });
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.firstSeparator.object,
      this.secondSeparator.object,
      this.thirdSeparator.object,
      ...this.buttons.flatMap((Un) => Un.getFabricObjects())
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.firstSeparator,
      this.secondSeparator,
      this.thirdSeparator,
      ...this.buttons.flatMap((Un) => Un.getObjects())
    ]);
    Ca(this, "getUIElements", () => [
      this.copy,
      this.paste,
      this.delete,
      this.hideInterface,
      this.group,
      this.moveForward,
      this.moveBack,
      this.planToForward,
      this.planToBack,
      this.createModule,
      this.ungroup,
      this.mergeCells,
      this.splitCells,
      this.splitTable,
      this.addColumnLeft,
      this.addColumnRight,
      this.addRowBelow,
      this.addRowAbove,
      this.deleteRow,
      this.deleteColumn
    ]);
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "disableFocus", () => {
    });
    Ca(this, "enableFocus", () => {
    });
    Ca(this, "disableHover", () => {
    });
    Ca(this, "enableHover", () => {
    });
    Ca(this, "isEnableFocus", () => !1);
    Ca(this, "isEnableHover", () => !1);
    Ca(this, "setAndFixPosition", (Un) => {
      const Kn = this.dependencies.render.getHeight(), Jo = this.dependencies.render.getWidth() - this.getWidth(), pa = Kn - this.getHeight();
      Un.x > Jo && (Un.x = Jo), Un.y > pa && (Un.y = pa), this.setPosition(Un);
    });
    Ca(this, "setPosition", (Un) => {
      switch (this.contextMode) {
        case ContextMode.DEFAULT: {
          const { x: Kn, y: qn } = Un;
          let Jo = this.DEFAULT_PADDING_VERTICAL;
          this.copy.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: this.DEFAULT_PADDING_VERTICAL
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.paste.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.delete.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON + this.DEFAULT_PADDING_VERTICAL, this.firstSeparator.relativePosition = {
            x: Kn,
            y: qn + Jo
          }, Jo += this.DEFAULT_PADDING_VERTICAL + this.firstSeparator.object.height, this.hideInterface.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), this.container.relativePosition = {
            x: Kn,
            y: qn
          }, this.container.object.set({
            height: this.getHeight()
          }), this.dependencies.render.render();
          break;
        }
        case ContextMode.TABLE: {
          const { x: Kn, y: qn } = Un;
          let Jo = this.DEFAULT_PADDING_VERTICAL;
          this.mergeCells.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.splitCells.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.splitTable.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.addColumnRight.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.addColumnLeft.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.addRowBelow.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.addRowAbove.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.deleteRow.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.deleteColumn.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.copy.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.paste.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.container.relativePosition = {
            x: Kn,
            y: qn
          }, this.container.object.set({
            height: this.getHeight()
          });
          break;
        }
        case ContextMode.GRAPHIC_GROUP: {
          const { x: Kn, y: qn } = Un;
          this.container.relativePosition = {
            x: Kn,
            y: qn
          }, this.container.object.set({
            width: this.DEFAULT_WIDTH,
            height: this.getHeight()
          });
          let Jo = this.DEFAULT_PADDING_VERTICAL;
          this.copy.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.paste.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.delete.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON + this.DEFAULT_PADDING_VERTICAL, this.firstSeparator.relativePosition = {
            x: Kn,
            y: qn + Jo
          }, Jo += this.firstSeparator.object.height + this.DEFAULT_PADDING_VERTICAL, this.group.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON + this.DEFAULT_PADDING_VERTICAL, this.secondSeparator.relativePosition = {
            x: Kn,
            y: qn + Jo
          }, Jo += this.firstSeparator.object.height + this.DEFAULT_PADDING_VERTICAL, this.moveForward.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.moveBack.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.planToForward.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.planToBack.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON + this.DEFAULT_PADDING_VERTICAL, this.thirdSeparator.relativePosition = {
            x: Kn,
            y: qn + Jo
          }, Jo += this.firstSeparator.object.height + this.DEFAULT_PADDING_VERTICAL, this.createModule.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          }));
          break;
        }
        case ContextMode.GRAPHIC_UNGROUP: {
          const { x: Kn, y: qn } = Un;
          this.container.relativePosition = {
            x: Kn,
            y: qn
          }, this.container.object.set({
            width: this.DEFAULT_WIDTH,
            height: this.getHeight()
          });
          let Jo = this.DEFAULT_PADDING_VERTICAL;
          this.copy.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.paste.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.delete.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON + this.DEFAULT_PADDING_VERTICAL, this.firstSeparator.relativePosition = {
            x: Kn,
            y: qn + Jo
          }, Jo += this.firstSeparator.object.height + this.DEFAULT_PADDING_VERTICAL, this.ungroup.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON + this.DEFAULT_PADDING_VERTICAL, this.secondSeparator.relativePosition = {
            x: Kn,
            y: qn + Jo
          }, Jo += this.firstSeparator.object.height + this.DEFAULT_PADDING_VERTICAL, this.moveForward.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.moveBack.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.planToForward.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON, this.planToBack.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          })), Jo += this.DEFAULT_HEIGHT_BUTTON + this.DEFAULT_PADDING_VERTICAL, this.thirdSeparator.relativePosition = {
            x: Kn,
            y: qn + Jo
          }, Jo += this.firstSeparator.object.height + this.DEFAULT_PADDING_VERTICAL, this.createModule.setConfiguration((pa) => ({
            ...pa,
            x: 0,
            y: Jo
          }));
          break;
        }
      }
      this.configuration.x = Un.x, this.configuration.y = Un.y;
    });
    this.copy = new ContextCopyButton(), this.paste = new ContextPasteButton(), this.delete = new ContextDelButton(), this.hideInterface = new ContextHideInterfaceButton(), this.group = new ContextGroupButton(), this.ungroup = new ContextUnGroupButton(), this.moveForward = new ContextMoveForwardButton(), this.moveBack = new ContextMoveBackButton(), this.planToForward = new ContextPlanToForwardButton(), this.planToBack = new ContextPlanToBackButton(), this.createModule = new ContextCreateModuleButton(), this.mergeCells = new ContextMergeCellsButton(), this.splitCells = new ContextSplitCellsButton(), this.splitTable = new ContextSplitTableButton(), this.addColumnLeft = new ContextAddColumnLeftButton(), this.addColumnRight = new ContextAddColumnRightButton(), this.addRowBelow = new ContextAddRowBelowButton(), this.addRowAbove = new ContextAddRowAboveButton(), this.deleteRow = new ContextDelRowButton(), this.deleteColumn = new ContextDelColumnButton(), this.buttons = [
      this.copy,
      this.paste,
      this.delete,
      this.hideInterface,
      this.group,
      this.ungroup,
      this.moveForward,
      this.moveBack,
      this.planToForward,
      this.planToBack,
      this.createModule,
      this.mergeCells,
      this.splitCells,
      this.splitTable,
      this.addColumnLeft,
      this.addColumnRight,
      this.addRowBelow,
      this.addRowAbove,
      this.deleteRow,
      this.deleteColumn
    ], this.addPostInjectDependenciesListener((Un) => {
      const { useCases: Kn, render: qn, ui: Jo } = Un;
      this.copy.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.paste.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.delete.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.hideInterface.forceInjectDependencies({
        render: qn,
        useCases: Kn,
        ui: Jo
      }), this.group.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.ungroup.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.moveForward.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.moveBack.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.planToForward.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.planToBack.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.createModule.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.mergeCells.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.deleteRow.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.mergeCells.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.splitCells.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.splitTable.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.addColumnLeft.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.addColumnRight.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.addRowBelow.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.addRowAbove.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.deleteRow.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.deleteColumn.forceInjectDependencies({
        render: qn,
        useCases: Kn
      }), this.buttons.forEach((pa) => {
        pa.hide();
      });
    }), this.configuration = {
      fill: UIDefaultColor.WHITE,
      x: 0,
      y: 0
    }, this.container = {
      object: new pr({
        fill: UIDefaultColor.WHITE,
        rx: 8,
        ry: 8,
        strokeWidth: 0,
        visible: !1,
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        width: this.DEFAULT_WIDTH
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.firstSeparator = {
      object: new pr({
        width: this.DEFAULT_WIDTH,
        height: 1,
        fill: UIDefaultColor.GRAY_100,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.secondSeparator = {
      object: new pr({
        width: this.DEFAULT_WIDTH,
        height: 1,
        fill: UIDefaultColor.GRAY_100,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.thirdSeparator = {
      object: new pr({
        width: this.DEFAULT_WIDTH,
        height: 1,
        fill: UIDefaultColor.GRAY_100,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.isShow = !1, this.isResetFocus = !0, this.contextMode = ContextMode.DEFAULT;
  }
}
class PrivateTemplateContextMenu extends ContextMenuView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "currentMousePosition");
    Ca(this, "currentActiveArea");
    Ca(this, "currentCrossGraphic");
    Ca(this, "currentCrossComponent");
    Ca(this, "getSpatialArea", () => (this.area === null && (this.area = new SpatialContextMenuArea(this), this.area.markDirty()), this.area));
    Ca(this, "show", () => {
      if (this.hide(), this.isShow = !0, this.currentMousePosition = this.dependencies.uiMouseObserver.getCurrentPosition(), this.currentActiveArea = this.dependencies.areaController.getActiveArea(), this.currentCrossGraphic = null, this.currentCrossComponent = null, this.currentActiveArea !== null && Object.values(SpatialCanvasAreaType).includes(this.currentActiveArea.type)) {
        const Un = this.currentActiveArea.getData(), Kn = Un.graphic.getParentComponent();
        this.currentCrossGraphic = Un.graphic, this.currentCrossComponent = Kn;
      }
      this.coordinateMenuForShow(), this.updateSpatialAreasPosition();
    });
    Ca(this, "updateSpatialAreasPosition", () => {
      if (this.area !== null) {
        this.area.markDirty();
        for (let Un = 0; Un < this.buttons.length; Un++)
          this.buttons[Un].getSpatialArea().markDirty();
      }
    });
    Ca(this, "coordinateMenuForShow", () => {
      if (this.currentCrossComponent === null || this.currentCrossGraphic === null || this.currentCrossGraphic.type === GraphicType.PAGE) {
        this.showDefaultMenu(this.currentMousePosition), this.dependencies.render.renderRelativePositions();
        return;
      }
      if (this.currentCrossComponent.type === EditorComponentType.TABLE && this.currentActiveArea && this.currentCrossComponent.getFocusCellContexts() !== null) {
        this.showTableMenu(this.currentMousePosition, this.currentCrossComponent), this.dependencies.render.renderRelativePositions();
        return;
      }
      this.showComponentMenu(this.currentMousePosition, this.currentCrossComponent), this.dependencies.render.renderRelativePositions();
    });
    Ca(this, "onMergeCells", async () => {
      await this.dependencies.useCases.mergeFocusCell(this.currentCrossComponent);
    });
    Ca(this, "onSplitCells", async () => {
      await this.dependencies.useCases.splitFocusCells(this.currentCrossComponent);
    });
    Ca(this, "onSplitTable", async () => {
      await this.dependencies.useCases.splitTable(
        this.currentCrossComponent,
        this.currentActiveArea
      );
    });
    Ca(this, "onDeleteRow", async () => {
      await this.dependencies.useCases.deleteFocusRows(this.currentCrossComponent);
    });
    Ca(this, "onAddColumnRight", async () => {
      await this.dependencies.useCases.addColumnAfter(this.currentCrossComponent);
    });
    Ca(this, "onAddColumnLeft", async () => {
      await this.dependencies.useCases.addColumnBefore(this.currentCrossComponent);
    });
    Ca(this, "onAddRowBelow", async () => {
      await this.dependencies.useCases.addRowUnder(this.currentCrossComponent);
    });
    Ca(this, "onAddRowAbove", async () => {
      await this.dependencies.useCases.addRowOver(this.currentCrossComponent);
    });
    Ca(this, "onDeleteColumn", async () => {
      await this.dependencies.useCases.deleteFocusColumns(this.currentCrossComponent);
    });
    Ca(this, "onCopy", async () => {
      await this.dependencies.useCases.copy();
    });
    Ca(this, "onPaste", async () => {
      const Un = this.currentMousePosition;
      await this.dependencies.useCases.pasteAtPosition(Un);
    });
    Ca(this, "onDelete", () => {
      this.dependencies.useCases.removeFocusComponentsWithAnimate();
    });
    Ca(this, "onGroup", async () => {
      await this.dependencies.useCases.groupFocusComponents();
    });
    Ca(this, "onUngroup", async () => {
      await this.dependencies.useCases.ungroupFocusComponents();
    });
    Ca(this, "onGraphicForward", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveForwardGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicBack", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveBackGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicForeground", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveToForegroundGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicBackground", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveToBackgroundGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onModule", async () => {
      if (this.currentCrossComponent === null)
        throw new EditorError("component is null");
      await this.dependencies.useCases.createModule();
    });
    this.area = null, this.addPostInjectDependenciesListener(() => {
      this.copy.addPostMouseDownListeners(this.onCopy), this.paste.addPostMouseDownListeners(this.onPaste), this.delete.addPostMouseDownListeners(this.onDelete), this.group.addPostMouseDownListeners(this.onGroup), this.ungroup.addPostMouseDownListeners(this.onUngroup), this.moveForward.addPostMouseDownListeners(this.onGraphicForward), this.moveBack.addPostMouseDownListeners(this.onGraphicBack), this.planToBack.addPostMouseDownListeners(this.onGraphicBackground), this.planToForward.addPostMouseDownListeners(this.onGraphicForeground), this.createModule.addPostMouseDownListeners(this.onModule), this.mergeCells.addPostMouseDownListeners(this.onMergeCells), this.splitCells.addPostMouseDownListeners(this.onSplitCells), this.splitTable.addPostMouseDownListeners(this.onSplitTable), this.addColumnRight.addPostMouseDownListeners(this.onAddColumnRight), this.addColumnLeft.addPostMouseDownListeners(this.onAddColumnLeft), this.addRowBelow.addPostMouseDownListeners(this.onAddRowBelow), this.addRowAbove.addPostMouseDownListeners(this.onAddRowAbove), this.deleteRow.addPostMouseDownListeners(this.onDeleteRow), this.deleteColumn.addPostMouseDownListeners(this.onDeleteColumn);
    }), this.currentMousePosition = { x: 0, y: 0 }, this.currentActiveArea = null, this.currentCrossGraphic = null, this.currentCrossComponent = null;
  }
  callClick() {
  }
}
class ColorexPalette extends Dependent {
  constructor() {
    super();
    Ca(this, "onSelectColorexColor");
    Ca(this, "colorsUsed");
    Ca(this, "isShow");
    Ca(this, "setUsedColors", (Un) => {
      this.colorsUsed = Un;
    });
    Ca(this, "getUsedColors", () => this.colorsUsed);
    Ca(this, "syncPosition", (Un, Kn) => {
      this.dependencies.core.syncPalettePosition(Un, Kn);
    });
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.dependencies.core.show());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.dependencies.core.hide());
    });
    Ca(this, "isEnableShow", () => this.isShow);
    Ca(this, "setSelectedColorListener", (Un) => {
      this.onSelectColorexColor = Un;
    });
    Ca(this, "getSpatialAreas", () => {
      const Un = this.dependencies.core.getSpatialAreas();
      if (this.onSelectColorexColor !== null)
        for (const Kn of Un)
          Kn.getOnClick() !== this.onSelectColorexColor && Kn.setClick(this.onSelectColorexColor);
      return Un;
    });
    this.onSelectColorexColor = null, this.isShow = !1, this.colorsUsed = [];
  }
}
class ColorInputView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_PALETTE", 20);
    Ca(this, "DEFAULT_COLOREX", "#000000");
    Ca(this, "DEFAULT_FILL", "#ffffff");
    Ca(this, "DEFAULT_FILL_HOVER", "#ffffff");
    Ca(this, "DEFAULT_FILL_FOCUS", "#ffffff");
    Ca(this, "DEFAULT_BORDER_COLOR", "#ffffff");
    Ca(this, "DEFAULT_BORDER_COLOR_HOVER", UIDefaultColor.GRAY_500);
    Ca(this, "DEFAULT_BORDER_COLOR_FOCUS", "#ffffff");
    Ca(this, "DEFAULT_BORDER_COLOREX_COLOR", "#a6a6a6");
    Ca(this, "DEFAULT_BORDER_WIDTH", 1);
    Ca(this, "DEFAULT_SIZE", 28);
    Ca(this, "DEFAULT_PADDING", 8);
    Ca(this, "DEFAULT_CORNER_RADIUS_CONTAINER", 4);
    Ca(this, "DEFAULT_CORNER_RADIUS_COLOREX", 2);
    Ca(this, "DEFAULT_DURATION_HOVER", 100);
    Ca(this, "tooltip");
    Ca(this, "object");
    Ca(this, "palette");
    Ca(this, "configuration");
    Ca(this, "isVisible");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.object.container.object.left,
      y: this.object.container.object.top
    }));
    Ca(this, "getWidth", () => this.object.container.object.width);
    Ca(this, "getHeight", () => this.object.container.object.height);
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "syncActiveColors", (...Un) => {
      this.palette.setUsedColors(Un);
    });
    Ca(this, "enableHover", () => {
      if (this.isHover)
        return;
      this.isHover = !0;
      const { fill: Un, fillHover: Kn, borderColor: qn, borderColorHover: Jo, isEnableTooltip: pa } = this.configuration, ma = [
        {
          object: this.object.container.object,
          startColor: Un,
          endColor: Kn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        },
        {
          object: this.object.container.object,
          startColor: qn,
          endColor: Jo,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }
      ];
      this.dependencies.render.animateColor(...ma), pa && this.tooltip.show();
    });
    Ca(this, "isEnableShowPalette", () => this.palette.isEnableShow());
    Ca(this, "disableHover", () => {
      if (!this.isHover)
        return;
      this.isHover = !1;
      const { fill: Un, fillHover: Kn, borderColor: qn, borderColorHover: Jo, isEnableTooltip: pa } = this.configuration, ma = [
        {
          object: this.object.container.object,
          startColor: Kn,
          endColor: Un,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.FILL
        },
        {
          object: this.object.container.object,
          startColor: Jo,
          endColor: qn,
          duration: this.DEFAULT_DURATION_HOVER,
          type: TypeColorAnimated.STROKE
        }
      ];
      this.dependencies.render.animateColor(...ma), pa && this.tooltip.hide();
    });
    Ca(this, "enableFocus", () => {
      if (this.isFocus)
        return;
      this.isFocus = !0;
      const { x: Un, y: Kn } = this.getFrameArea();
      this.palette.syncPosition(
        {
          x: Un - this.DEFAULT_MARGIN_PALETTE,
          y: Kn
        },
        !0
      ), this.dependencies.render.renderRelativePositions(), this.palette.show();
    });
    Ca(this, "disableFocus", () => {
      this.isFocus && (this.isFocus = !1, this.palette.hide());
    });
    Ca(this, "isEnableHover", () => this.isHover);
    Ca(this, "isEnableFocus", () => this.isFocus);
    Ca(this, "isShowed", () => this.isVisible);
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.object.container.object.visible = !0, this.object.colorex.object.visible = !0);
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.object.container.object.visible = !1, this.object.colorex.object.visible = !1);
    });
    Ca(this, "getFrameArea", () => ({
      x: this.object.container.object.left,
      y: this.object.container.object.top,
      width: this.object.container.object.width,
      height: this.object.container.object.height,
      rotate: 0
    }));
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      this.object.container.object.width = qn.size, this.object.container.object.height = qn.size, this.object.container.relativePosition = {
        x: qn.x,
        y: qn.y
      }, this.object.colorex.relativePosition = {
        x: qn.x + qn.padding / 2,
        y: qn.y + qn.padding / 2
      }, this.object.colorex.object.set({
        width: qn.size - qn.padding,
        height: qn.size - qn.padding,
        fill: qn.color
      }), this.object.container.object.fill = qn.fill, this.object.container.object.stroke = qn.borderColor, this.object.container.object.strokeWidth = qn.borderThickness, this.tooltip.setPosition(
        {
          x: Math.round(qn.x + qn.size),
          y: Math.round(qn.y + qn.size)
        },
        qn.size
      ), this.tooltip.setText(qn.tooltipText), this.configuration = qn;
    });
    Ca(this, "getCurrentColor", () => this.configuration.color);
    Ca(this, "setCurrentColor", (Un) => {
      this.setConfiguration((Kn) => ({
        ...Kn,
        color: Un
      }));
    });
    Ca(this, "getFabricObjects", () => [
      this.object.container.object,
      this.object.colorex.object,
      ...this.tooltip.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.object.container,
      this.object.colorex,
      ...this.tooltip.getObjects()
    ]);
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    this.palette = new ColorexPalette(), this.configuration = {
      color: this.DEFAULT_COLOREX,
      fill: this.DEFAULT_FILL,
      fillHover: this.DEFAULT_FILL_HOVER,
      fillFocus: this.DEFAULT_FILL_FOCUS,
      borderColor: this.DEFAULT_BORDER_COLOR,
      borderColorHover: this.DEFAULT_BORDER_COLOR_HOVER,
      borderColorFocus: this.DEFAULT_BORDER_COLOR_FOCUS,
      borderThickness: this.DEFAULT_BORDER_WIDTH,
      size: this.DEFAULT_SIZE,
      x: 0,
      y: 0,
      padding: this.DEFAULT_PADDING,
      cornerRadiusContainer: this.DEFAULT_CORNER_RADIUS_CONTAINER,
      cornerRadiusColorex: this.DEFAULT_CORNER_RADIUS_COLOREX,
      borderColorexColor: this.DEFAULT_BORDER_COLOREX_COLOR,
      isEnableTooltip: !1,
      tooltipText: ""
    }, this.object = {
      container: {
        object: new pr({
          fill: this.configuration.fill,
          borderColor: this.configuration.borderColor,
          strokeWidth: this.configuration.borderThickness,
          stroke: this.configuration.borderColor,
          width: this.configuration.size,
          height: this.configuration.size,
          left: this.configuration.x,
          top: this.configuration.y,
          rx: this.configuration.cornerRadiusContainer,
          ry: this.configuration.cornerRadiusContainer
        }),
        relativePosition: { x: 0, y: 0 }
      },
      colorex: {
        object: new pr({
          fill: this.configuration.color,
          stroke: this.configuration.borderColorexColor,
          strokeWidth: 1,
          width: this.configuration.size - this.configuration.padding,
          height: this.configuration.size - this.configuration.padding,
          left: this.configuration.x + this.configuration.padding,
          top: this.configuration.y + this.configuration.padding,
          rx: this.configuration.cornerRadiusColorex,
          ry: this.configuration.cornerRadiusColorex
        }),
        relativePosition: { x: 0, y: 0 }
      }
    }, this.tooltip = new ToolTipBottom(), this.isVisible = !0, this.isHover = !1, this.isFocus = !1, this.isResetFocus = !0, this.addPostInjectDependenciesListener((Un) => {
      this.palette.forceInjectDependencies({
        core: Un.core
      });
    });
  }
}
class SpatialColorInputArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.COLOR_INPUT);
    Ca(this, "getGlobalFrameArea", () => this.input.getFrameArea());
    Ca(this, "getData", () => this.input);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.input = Un;
  }
}
class ColorInput extends ColorInputView {
  constructor() {
    super();
    Ca(this, "DEFAULT_SELECTED_COLOR", "#000000");
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "getSpatialAreasPalette", () => this.palette.getSpatialAreas());
    Ca(this, "setSelectColorListener", (Un) => {
      const Kn = (qn) => {
        Un(qn), this.dependencies.core.sendSelectColor(qn), this.dependencies.core.syncActiveColors([qn]);
      };
      this.palette.setSelectedColorListener(Kn);
    });
    Ca(this, "callClick", () => {
      if (this.dependencies.core.syncActiveColors(this.palette.getUsedColors()), this.isEnableFocus()) {
        this.disableFocus();
        return;
      }
      this.enableFocus();
    });
    this.setCurrentColor(this.DEFAULT_SELECTED_COLOR), this.area = new SpatialColorInputArea(this);
  }
  getUIElements() {
    return [];
  }
  // public syncActiveColors = (colors: string[]): void => {
  // 	this.colorex.syncActiveColors(colors);
  // };
  /** Добавить обработчик на события выбора цвета. */
  // public addSelectColorListener = (ev: (color: string) => void) => {
  // 	this.colorex.addSelectColorEvent(color => {
  // 		this.setColor(color);
  // 		ev(color);
  // 	});
  // };
  /**
   * Установить подсказку для пользователя при наведении.
   * @param text Содержание подсказки.
   */
  // public setHint = (text: string) => {
  // 	this.hintElement.textContent = text;
  // 	this.containerElement.addEventListener('mouseenter', this.showHint);
  // 	this.containerElement.addEventListener('mouseleave', this.hideHint);
  // };
  // protected showHint = () => {
  // 	this.containerElement.append(this.hintElement);
  // };
  // protected hideHint = () => {
  // 	this.hintElement.remove();
  // };
}
class SpatialUIGenerationHintArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.PANEL);
    Ca(this, "getGlobalFrameArea", () => this.generationHint.getFrameArea());
    Ca(this, "getData", () => this.generationHint);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.generationHint = Un;
  }
}
class GenerationRateButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_WIDTH", 250);
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 40);
    this.setConfiguration((Un) => ({
      ...Un,
      fill: UIDefaultColor.BLUE_900,
      fillHover: null,
      textColor: UIDefaultColor.WHITE,
      textColorHover: null,
      borderRadius: 4,
      borderColor: "transparent",
      borderColorHover: null,
      textFontSize: 14,
      text: "Тарифы"
    })), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.onGoToTariff);
    });
  }
}
class GenerationHint extends Dependent {
  constructor() {
    super();
    Ca(this, "container");
    Ca(this, "triangle");
    Ca(this, "textGeneratedValue");
    Ca(this, "textGenerated");
    Ca(this, "textTime");
    Ca(this, "textTimeValue");
    Ca(this, "rateButton");
    Ca(this, "area");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.triangle.object.visible = !0, this.textGenerated.object.visible = !0, this.textGeneratedValue.object.visible = !0, this.textTime.object.visible = !0, this.textTimeValue.object.visible = !0, this.rateButton.show());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.triangle.object.visible = !1, this.textGenerated.object.visible = !1, this.textGeneratedValue.object.visible = !1, this.textTime.object.visible = !1, this.textTimeValue.object.visible = !1, this.rateButton.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      if (this.container.object.fill = qn.fill, this.configuration.marginIsStart !== qn.marginIsStart || this.configuration.padding !== qn.padding || this.configuration.x !== qn.x || this.configuration.y !== qn.y) {
        this.configuration = qn, this.sync();
        return;
      }
      this.configuration = qn;
    });
    Ca(this, "getWidth", () => this.configuration.padding * 2 + this.configuration.width);
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.triangle.object,
      this.textGenerated.object,
      this.textGeneratedValue.object,
      this.textTime.object,
      this.textTimeValue.object,
      ...this.rateButton.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.triangle,
      this.textGenerated,
      this.textGeneratedValue,
      this.textTime,
      this.textTimeValue,
      ...this.rateButton.getObjects()
    ]);
    Ca(this, "getUIElements", () => [this.rateButton]);
    Ca(this, "sync", () => {
      const { padding: Un, x: Kn, y: qn, width: Jo } = this.configuration, pa = this.dependencies.onGetGenerationHintStructure(), ma = Un * 2 + Jo;
      this.triangle.relativePosition = {
        x: Math.round(Kn - this.triangle.object.width / 2 + ma / 2),
        y: qn
      }, this.container.object.set({
        height: Un * 2 + this.textGeneratedValue.object.height + this.textGenerated.object.height + this.textTime.object.height,
        width: ma
      }), this.container.relativePosition = {
        x: Kn,
        y: qn + this.triangle.object.getScaledHeight()
      };
      const va = Math.round(qn + this.triangle.object.height + Un), ba = Kn + Un, _a = 5;
      this.textGeneratedValue.object.set({
        text: `${pa.availableGeneration}/${pa.totalGeneration}`
      }), this.textGeneratedValue.relativePosition = {
        x: ba,
        y: va
      }, this.textGenerated.relativePosition = {
        x: ba,
        y: va + this.textGeneratedValue.object.height
      }, this.textTime.relativePosition = {
        x: ba,
        y: va + this.textGeneratedValue.object.height + this.textGenerated.object.height + _a
      }, this.rateButton.setConfiguration((ya) => ({
        ...ya,
        x: ma - Un - this.rateButton.getWidth(),
        y: this.triangle.object.getScaledHeight() + Un
      })), this.textTimeValue.object.set({
        text: `${pa.recoveryTimeHours}ч`
      }), this.textTimeValue.relativePosition = {
        x: ba - Un * 2 + ma - this.textTimeValue.object.width,
        y: va + this.textGeneratedValue.object.height + this.textGenerated.object.height + _a
      }, this.dependencies.render.renderRelativePositions();
    });
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.configuration.width,
      height: this.configuration.padding * 2 + this.textGeneratedValue.object.height + this.textGenerated.object.height + this.textTime.object.height,
      rotate: 0
    }));
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getSpatialArea", () => this.area);
    this.area = new SpatialUIGenerationHintArea(this), this.configuration = {
      padding: 16,
      marginIsStart: 5,
      x: 0,
      y: 0,
      fill: UIDefaultColor.GRAY_900,
      width: 190
    }, this.container = {
      object: new pr({
        fill: this.configuration.fill,
        rx: 4,
        ry: 4,
        strokeWidth: 0,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.triangle = {
      object: SVGCanvasStore.getSvg(SVGCollection.TRIANGLE_GENERATED),
      relativePosition: { x: 0, y: 0 }
    }, this.triangle.object.set({
      fill: this.configuration.fill,
      visible: !1
    }), this.triangle.object.scaleToHeight(14), this.textGeneratedValue = {
      object: new Xo("600/600", {
        fill: UIDefaultColor.WHITE,
        fontSize: 24,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.textGenerated = {
      object: new Xo("Генераций", {
        fill: UIDefaultColor.WHITE,
        fontSize: 14,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.textTime = {
      object: new Xo("Восстановится через", {
        fill: UIDefaultColor.BLUE_900,
        fontSize: 14,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.textTimeValue = {
      object: new Xo("19x", {
        fill: UIDefaultColor.BLUE_900,
        fontSize: 14,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.rateButton = new GenerationRateButton(), this.rateButton.hide(), this.isShow = !1, this.isResetFocus = !0, this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, onGoToTariff: qn } = Un;
      this.rateButton.forceInjectDependencies({ render: Kn, onGoToTariff: qn });
    });
  }
  disableFocus() {
  }
  disableHover() {
  }
  enableFocus() {
  }
  enableHover() {
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  callClick() {
  }
}
class SpatialUIPanelArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.PANEL);
    Ca(this, "getGlobalFrameArea", () => this.propertyPanel.getFrameArea());
    Ca(this, "getData", () => this.propertyPanel);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.propertyPanel = Un;
  }
}
class FigureBorderColorInput extends ColorInput {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Цвет обводки");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.setSelectColorListener(Un.useCases.setFocusFigureBorderColor);
    });
  }
}
class FigureFillColorInput extends ColorInput {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Цвет фона");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.setSelectColorListener(Un.useCases.setFocusFigureBackground);
    });
  }
}
class FigureThicknessInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 2,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.BORDER_WIDTH),
        relativePosition: { x: 0, y: 0 }
      },
      svgColor: UIDefaultColor.GRAY_500,
      paddingHorizontal: 10,
      textFontSize: FontSize.Pt12
    })), this.setMaxLength(3), this.hide(), this.addPostInjectDependenciesListener((zn) => {
      this.addPostChangeTextListener(() => {
        zn.useCases.setFocusFigureBorderWidth(this.getValue());
      });
    });
  }
}
class PropertyFigureBarView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_TOP", 620);
    Ca(this, "DEFAULT_MARGIN_RIGHT", 20);
    Ca(this, "DEFAULT_PADDING", 24);
    Ca(this, "DEFAULT_MARGIN_BOTTOM_OBJECTS", 10);
    Ca(this, "DEFAULT_TITLE", "Фигура");
    Ca(this, "DEFAULT_WIDTH_BAR", 320);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_HEIGHT_BLOCK", 30);
    Ca(this, "DEFAULT_BUTTON_PADDING", 8);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "DEFAULT_MARGIN_SIDE_BUTTON", 6);
    Ca(this, "container");
    Ca(this, "fillColorInput");
    Ca(this, "borderColorInput");
    Ca(this, "inputThickness");
    // private readonly borderSelect: BorderSelectView;
    Ca(this, "title");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.title.object.visible = !0, this.fillColorInput.show(), this.borderColorInput.show(), this.inputThickness.show());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.title.object.visible = !1, this.fillColorInput.hide(), this.borderColorInput.hide(), this.inputThickness.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getUIElements", () => [this.fillColorInput, this.borderColorInput, this.inputThickness]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.fillColorInput.isEnableFocus() && Un.push(this.fillColorInput), this.borderColorInput.isEnableFocus() && Un.push(this.borderColorInput), this.inputThickness.isEnableFocus() && Un.push(this.inputThickness), Un;
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration;
      this.configuration = Un(Kn), this.sync();
    });
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.title.object,
      ...this.inputThickness.getFabricObjects(),
      // ...this.borderSelect.getObjects(),
      ...this.fillColorInput.getFabricObjects(),
      ...this.borderColorInput.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.title,
      ...this.inputThickness.getObjects(),
      // ...this.borderSelect.getObjects(),
      ...this.fillColorInput.getObjects(),
      ...this.borderColorInput.getObjects()
    ]);
    Ca(this, "getContainer", () => this.container.object);
    Ca(this, "getContentElements", () => [
      this.title.object,
      ...this.inputThickness.getFabricObjects(),
      // ...this.borderSelect.getObjects(),
      ...this.fillColorInput.getFabricObjects(),
      ...this.borderColorInput.getFabricObjects()
    ]);
    Ca(this, "getHeight", () => {
      const { padding: Un, marginBottomObjects: Kn, heightBlock: qn } = this.configuration;
      return Un * 2 + Kn * 2 + this.title.object.height + qn;
    });
    Ca(this, "getRelativePosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "syncPosition", () => {
      this.sync();
    });
    Ca(this, "sync", () => {
      const {
        marginTop: Un,
        marginRight: Kn,
        width: qn,
        padding: Jo,
        marginBottomObjects: pa,
        fill: ma,
        cornerRadius: va,
        heightBlock: ba,
        titleFontSize: _a,
        marginSideButton: ya
      } = this.configuration, xa = this.dependencies.render.getWidth() - Kn - qn;
      this.container.object.set({
        width: qn,
        height: this.getHeight(),
        fill: ma,
        rx: va,
        ry: va,
        originX: "left",
        originY: "top",
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        }
      }), this.container.relativePosition = {
        x: xa,
        y: Un
      }, this.title.object.set({
        fill: UIDefaultColor.GRAY_900,
        fontSize: _a,
        fontFamily: FontFamily.DEFAULT
      }), this.title.relativePosition = {
        x: xa + Jo,
        y: Un + Jo
      };
      const wa = Jo + this.title.object.height + pa;
      this.fillColorInput.setConfiguration((Ta) => ({
        ...Ta,
        size: ba,
        x: Jo,
        y: wa
      })), this.borderColorInput.setConfiguration((Ta) => ({
        ...Ta,
        size: ba,
        x: Jo + ba + ya,
        y: wa
      })), this.inputThickness.setConfiguration((Ta) => ({
        ...Ta,
        width: 64,
        height: ba,
        x: Jo + ba * 2 + ya * 3,
        y: wa
      })), this.dependencies.render.renderRelativePositions();
    });
    this.isShow = !1, this.isResetFocus = !0, this.configuration = {
      marginTop: this.DEFAULT_MARGIN_TOP,
      marginRight: this.DEFAULT_MARGIN_RIGHT,
      width: this.DEFAULT_WIDTH_BAR,
      padding: this.DEFAULT_PADDING,
      marginBottomObjects: this.DEFAULT_MARGIN_BOTTOM_OBJECTS,
      fill: UIDefaultColor.WHITE,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      heightBlock: this.DEFAULT_HEIGHT_BLOCK,
      buttonPadding: this.DEFAULT_BUTTON_PADDING,
      marginSideButton: this.DEFAULT_MARGIN_SIDE_BUTTON
    }, this.container = {
      object: new pr({ visible: !1 }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo(this.DEFAULT_TITLE, { visible: !1 }),
      relativePosition: { x: 0, y: 0 }
    }, this.fillColorInput = new FigureFillColorInput(), this.borderColorInput = new FigureBorderColorInput(), this.inputThickness = new FigureThicknessInput();
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class PropertyFigureBar extends PropertyFigureBarView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "syncComponent", (Un) => {
      const Kn = Un.flatMap(
        (Jo) => Jo.getGraphics().flatMap((pa) => pa.getTexture())
      ), qn = Utils.objectUtils.checkFieldsEquality(...Kn);
      qn.borderColor !== null ? this.borderColorInput.setCurrentColor(qn.borderColor) : this.borderColorInput.setCurrentColor(UIDefaultColor.BLACK), qn.background !== null ? this.fillColorInput.setCurrentColor(qn.background) : this.fillColorInput.setCurrentColor(UIDefaultColor.BLACK), qn.borderWidth !== null && this.inputThickness.setValue(qn.borderWidth.toString()), this.borderColorInput.syncActiveColors(...this.dependencies.useCases.getColorsBorderFigureFocusComponents()), this.fillColorInput.syncActiveColors(...this.dependencies.useCases.getColorsBackgroundFigureFocusComponents());
    });
    this.area = new SpatialUIPanelArea(this), this.addPostInjectDependenciesListener((Un) => {
      this.fillColorInput.forceInjectDependencies({
        render: Un.render,
        useCases: Un.useCases,
        core: Un.core
      }), this.borderColorInput.forceInjectDependencies({
        render: Un.render,
        useCases: Un.useCases,
        core: Un.core
      }), this.inputThickness.forceInjectDependencies({
        render: Un.render,
        textEngine: Un.textEngine,
        useCases: Un.useCases
      });
    });
  }
  callClick() {
  }
}
class LineFillColorInput extends ColorInput {
  constructor() {
    super(), this.hide(), this.addPostInjectDependenciesListener((zn) => {
      this.setSelectColorListener(zn.useCases.setFocusLineBackground);
    });
  }
}
class LineThicknessInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 2,
      width: 64,
      textFontSize: FontSize.Pt12
    })), this.hide(), this.addPostInjectDependenciesListener((zn) => {
      this.addPostChangeTextListener(() => {
        zn.useCases.setFocusLineWidth(this.getValue());
      });
    });
  }
}
class PropertyLineBarView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_TOP", 740);
    Ca(this, "DEFAULT_MARGIN_RIGHT", 20);
    Ca(this, "DEFAULT_PADDING", 24);
    Ca(this, "DEFAULT_MARGIN_BOTTOM_OBJECTS", 12);
    Ca(this, "DEFAULT_TITLE", "Линия");
    Ca(this, "DEFAULT_WIDTH_BAR", 320);
    Ca(this, "DEFAULT_FILL_BAR", UIDefaultColor.WHITE);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_BUTTON_PADDING", 14);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "DEFAULT_MARGIN_SIDE_BUTTON", 8);
    Ca(this, "DEFAULT_HEIGHT_CORNER_BLOCK", 32);
    Ca(this, "container");
    Ca(this, "fillColorInput");
    Ca(this, "title");
    Ca(this, "inputThickness");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "configuration");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.isShow = !0, this.container.object.visible = !0, this.title.object.visible = !0, this.fillColorInput.show(), this.inputThickness.show());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.title.object.visible = !1, this.fillColorInput.hide(), this.inputThickness.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getHeight", () => {
      const { padding: Un, marginBottomObjects: Kn, heightBlocks: qn } = this.configuration;
      return Un * 2 + Kn * 2 + qn;
    });
    Ca(this, "getRelativePosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    /**
     * Возвращает конфигурацию панели.
     */
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration;
      this.configuration = Un(Kn), this.sync();
    });
    Ca(this, "getUIElements", () => [this.fillColorInput, this.inputThickness]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.inputThickness.isEnableFocus() && Un.push(this.inputThickness), this.fillColorInput.isEnableFocus() && Un.push(this.fillColorInput), Un;
    });
    /**
     * Возвращает все объекты `FabricObject` в панели.
     */
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.title.object,
      ...this.fillColorInput.getFabricObjects(),
      ...this.inputThickness.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [this.container, this.title, ...this.fillColorInput.getObjects(), ...this.inputThickness.getObjects()]);
    Ca(this, "getContainer", () => this.container.object);
    Ca(this, "getContentElements", () => [this.title.object, ...this.fillColorInput.getFabricObjects(), ...this.inputThickness.getFabricObjects()]);
    /**
     * Обновляет панель в зависимости от новых размеров `canvas`.
     * @param width
     */
    Ca(this, "syncPosition", () => {
      this.sync();
    });
    Ca(this, "syncComponent", (Un) => {
      const Kn = Un.flatMap(
        (Jo) => Jo.getGraphics().flatMap((pa) => pa.getTexture())
      ), qn = Utils.objectUtils.checkFieldsEquality(...Kn);
      qn.thickness !== null && this.inputThickness.setValue(qn.thickness.toString()), qn.background !== null && this.fillColorInput.setCurrentColor(qn.background), this.fillColorInput.syncActiveColors(...this.dependencies.useCases.getColorsLineFocusComponents());
    });
    /**
     * Синхронизирует все параметры панели.
     */
    Ca(this, "sync", () => {
      const { marginTop: Un, marginRight: Kn, width: qn, padding: Jo, marginBottomObjects: pa, fill: ma, cornerRadius: va, titleFontSize: ba } = this.configuration, _a = this.dependencies.render.getWidth() - Kn - qn;
      this.container.object.set({
        width: qn,
        height: this.getHeight(),
        fill: ma,
        rx: va,
        ry: va
      }), this.container.relativePosition = {
        x: _a,
        y: Un
      }, this.title.relativePosition = {
        x: _a + Jo,
        y: Un + Jo
      }, this.fillColorInput.setConfiguration((ya) => ({
        ...ya,
        x: Jo,
        y: Jo + ba + pa
      })), this.inputThickness.setConfiguration((ya) => ({
        ...ya,
        x: this.fillColorInput.getRelativePosition().x + this.fillColorInput.getWidth() + pa,
        y: Jo + ba + pa
      })), this.dependencies.render.renderRelativePositions();
    });
    this.isShow = !1, this.isResetFocus = !0, this.configuration = {
      marginTop: this.DEFAULT_MARGIN_TOP,
      marginRight: this.DEFAULT_MARGIN_RIGHT,
      width: this.DEFAULT_WIDTH_BAR,
      padding: this.DEFAULT_PADDING,
      marginBottomObjects: this.DEFAULT_MARGIN_BOTTOM_OBJECTS,
      fill: this.DEFAULT_FILL_BAR,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      buttonPadding: this.DEFAULT_BUTTON_PADDING,
      marginSideButton: this.DEFAULT_MARGIN_SIDE_BUTTON,
      heightBlocks: this.DEFAULT_HEIGHT_CORNER_BLOCK
    }, this.container = {
      object: new pr({
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo(this.DEFAULT_TITLE, {
        fill: UIDefaultColor.GRAY_900,
        fontSize: this.configuration.titleFontSize,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.inputThickness = new LineThicknessInput(), this.fillColorInput = new LineFillColorInput();
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class PropertyLineBar extends PropertyLineBarView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    this.area = new SpatialUIPanelArea(this), this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, useCases: qn, core: Jo, textEngine: pa } = Un;
      this.fillColorInput.forceInjectDependencies({
        render: Kn,
        useCases: qn,
        core: Jo
      }), this.inputThickness.forceInjectDependencies({
        render: Kn,
        textEngine: pa,
        useCases: qn
      });
    });
  }
  callClick() {
  }
}
class CornerRadiusInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.CORNER_RADIUS),
        relativePosition: { x: 0, y: 0 }
      },
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 2,
      paddingHorizontal: 8,
      textFontSize: FontSize.Pt12
    })), this.hide();
  }
}
class ObjectExpandWidthButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Расширить компонент по ширине");
    this.setConfiguration((Un) => ({
      ...Un,
      tooltipType: TooltipType.BOTTOM,
      tooltipText: this.TOOLTIP_TEXT,
      isEnableTooltip: !0,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.BOOM),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 18,
      text: null,
      borderColor: UIDefaultColor.WHITE,
      svgColor: UIDefaultColor.GRAY_600,
      fillHover: null,
      borderColorHover: UIDefaultColor.GRAY_600,
      svgColorHover: UIDefaultColor.GRAY_600,
      size: {
        width: 32,
        height: 32
      },
      padding: "center",
      borderRadius: 2,
      insideTextToSvg: 0
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.stretchFocusComponentToWidth);
    });
  }
}
class PropertyObjectBarView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_TOP", 120);
    Ca(this, "DEFAULT_MARGIN_RIGHT", 20);
    Ca(this, "DEFAULT_PADDING", 24);
    Ca(this, "DEFAULT_MARGIN_BOTTOM_OBJECTS", 10);
    Ca(this, "DEFAULT_TITLE", "Объекты");
    Ca(this, "DEFAULT_TITLE_CORNER_INPUT", "Радиус углов");
    Ca(this, "DEFAULT_WIDTH_BAR", 320);
    Ca(this, "DEFAULT_FILL_BAR", "#FFFFFF");
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_BUTTON_PADDING", 14);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "DEFAULT_MARGIN_SIDE_BUTTON", 8);
    Ca(this, "DEFAULT_HEIGHT_CORNER_BLOCK", 32);
    Ca(this, "container");
    Ca(this, "cornerRadiusButton");
    Ca(this, "expandWidthButton");
    Ca(this, "title");
    Ca(this, "titleCornerInput");
    Ca(this, "inputCornerText");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "configuration");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.title.object.visible = !0, this.expandWidthButton.show(), this.configuration.isRadiusBlock && (this.inputCornerText.show(), this.titleCornerInput.object.visible = !0, this.cornerRadiusButton.show()));
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.title.object.visible = !1, this.inputCornerText.hide(), this.titleCornerInput.object.visible = !1, this.cornerRadiusButton.hide(), this.expandWidthButton.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getHeight", () => {
      const { padding: Un, marginBottomObjects: Kn, heightBlocks: qn, isRadiusBlock: Jo } = this.configuration;
      return Jo ? Un * 2 + Kn * 3 + qn * 2 : Un * 2 + Kn * 2 + qn;
    });
    Ca(this, "getRelativePosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    Ca(this, "getGlobalPosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    /**
     * Возвращает конфигурацию панели.
     */
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration;
      this.configuration = Un(Kn), this.sync();
    });
    Ca(this, "getUIElements", () => [this.cornerRadiusButton, this.expandWidthButton, this.inputCornerText]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.cornerRadiusButton.isEnableFocus() && Un.push(this.cornerRadiusButton), this.inputCornerText.isEnableFocus() && Un.push(this.inputCornerText), Un;
    });
    /**
     * Возвращает все объекты `FabricObject` в панели.
     */
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.title.object,
      this.titleCornerInput.object,
      ...this.cornerRadiusButton.getFabricObjects(),
      ...this.expandWidthButton.getFabricObjects(),
      ...this.inputCornerText.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.title,
      this.titleCornerInput,
      ...this.cornerRadiusButton.getObjects(),
      ...this.expandWidthButton.getObjects(),
      ...this.inputCornerText.getObjects()
    ]);
    Ca(this, "getContainer", () => this.container.object);
    Ca(this, "getContentElements", () => [
      this.title.object,
      this.titleCornerInput.object,
      ...this.cornerRadiusButton.getFabricObjects(),
      ...this.expandWidthButton.getFabricObjects(),
      ...this.inputCornerText.getFabricObjects()
    ]);
    Ca(this, "syncComponent", (Un) => {
      if (Un.length === 0)
        return;
      const Kn = Utils.component.getSomeComponentType(Un);
      if (Kn === null)
        throw new EditorError("some component type was null");
      Kn === EditorComponentType.TEXT && (this.configuration.isRadiusBlock = !1, this.sync());
      const Jo = Un.flatMap((va) => [
        va,
        ...va.getComponentAll()
      ]).flatMap(
        (va) => va.getGraphics().flatMap((ba) => ba.getTexture())
      );
      if (Jo.every((va) => va === null))
        return;
      const pa = Jo.filter((va) => va !== null), ma = Utils.objectUtils.checkFieldsEquality(...pa);
      switch (Kn) {
        case EditorComponentType.PICTURE:
          if (ma.radius !== null) {
            const va = ma.radius;
            va.bottomLeft === va.bottomRight && va.bottomLeft === va.topLeft && va.bottomLeft === va.topRight ? this.inputCornerText.setValue(va.bottomLeft.toString()) : this.inputCornerText.setValue("");
          }
          this.configuration.isRadiusBlock = !0, this.sync();
          break;
        case EditorComponentType.FIGURE:
          if (ma.radius !== null) {
            const va = ma.radius;
            this.dependencies.editCornerObject.setCornerRadius(va), va.bottomLeft === va.bottomRight && va.bottomLeft === va.topLeft && va.bottomLeft === va.topRight ? this.inputCornerText.setValue(va.bottomLeft.toString()) : this.inputCornerText.setValue("");
          }
          this.configuration.isRadiusBlock = !0, this.sync();
          break;
        default:
          this.configuration.isRadiusBlock = !1, this.sync();
          break;
      }
    });
    /**
     * Обновляет панель в зависимости от новых размеров `canvas`.
     * @param width
     */
    Ca(this, "syncPosition", () => {
      this.sync();
    });
    /**
     * Синхронизирует все параметры панели.
     */
    Ca(this, "sync", () => {
      const {
        marginTop: Un,
        marginRight: Kn,
        width: qn,
        padding: Jo,
        marginBottomObjects: pa,
        fill: ma,
        cornerRadius: va,
        titleFontSize: ba,
        marginSideButton: _a,
        heightBlocks: ya,
        isRadiusBlock: xa
      } = this.configuration, wa = Jo + ba + pa + ya / 2, Ta = this.dependencies.render.getWidth() - Kn - qn;
      if (this.container.object.set({
        width: qn,
        height: this.getHeight(),
        fill: ma,
        rx: va,
        ry: va
      }), this.container.relativePosition = {
        x: Ta,
        y: Un
      }, this.title.object.set({
        fill: UIDefaultColor.GRAY_900,
        fontSize: ba,
        fontFamily: FontFamily.DEFAULT
      }), this.title.relativePosition = {
        x: Ta + Jo,
        y: Un + Jo
      }, xa) {
        this.isShow && (this.inputCornerText.show(), this.titleCornerInput.object.visible = !0, this.cornerRadiusButton.show()), this.titleCornerInput.object.set({
          fill: UIDefaultColor.GRAY_700,
          fontSize: ba,
          fontFamily: FontFamily.DEFAULT
        }), this.titleCornerInput.relativePosition = {
          x: Ta + Jo,
          y: Un + wa - ba / 2
        }, this.cornerRadiusButton.setConfiguration((Ma) => ({
          ...Ma,
          x: Jo + this.titleCornerInput.object.width + _a + this.inputCornerText.getConfiguration().width + _a,
          y: wa - ya / 2,
          fill: ma
        })), this.expandWidthButton.setConfiguration((Ma) => ({
          ...Ma,
          x: Jo,
          y: Jo + ba + pa + ya + pa,
          fill: ma
        })), this.inputCornerText.setConfiguration((Ma) => ({
          ...Ma,
          x: Jo + this.titleCornerInput.object.width + _a,
          y: Jo + this.title.object.height + _a,
          width: 80,
          height: ya
        })), this.dependencies.render.renderRelativePositions();
        return;
      }
      this.titleCornerInput.object.set({
        visible: !1
      }), this.inputCornerText.hide(), this.cornerRadiusButton.hide(), this.expandWidthButton.setConfiguration((Ma) => ({
        ...Ma,
        x: Jo,
        y: Jo + ba + pa,
        fill: ma
      })), this.inputCornerText.getObjects().map((Ma) => Ma.object).forEach((Ma) => {
        Ma.set({
          visible: !1
        });
      }), this.dependencies.render.renderRelativePositions();
    });
    this.isShow = !1, this.isResetFocus = !0, this.configuration = {
      marginTop: this.DEFAULT_MARGIN_TOP,
      marginRight: this.DEFAULT_MARGIN_RIGHT,
      width: this.DEFAULT_WIDTH_BAR,
      padding: this.DEFAULT_PADDING,
      marginBottomObjects: this.DEFAULT_MARGIN_BOTTOM_OBJECTS,
      fill: this.DEFAULT_FILL_BAR,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      buttonPadding: this.DEFAULT_BUTTON_PADDING,
      marginSideButton: this.DEFAULT_MARGIN_SIDE_BUTTON,
      heightBlocks: this.DEFAULT_HEIGHT_CORNER_BLOCK,
      isRadiusBlock: !0
    }, this.container = {
      object: new pr({
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo(this.DEFAULT_TITLE, {
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.titleCornerInput = {
      object: new Xo(this.DEFAULT_TITLE_CORNER_INPUT, {
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.cornerRadiusButton = new ObjectCornerRadiusButton(), this.expandWidthButton = new ObjectExpandWidthButton(), this.inputCornerText = new CornerRadiusInput();
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class PropertyObjectBar extends PropertyObjectBarView {
  constructor() {
    super();
    Ca(this, "area");
    // public enableInputCornerText = () => {
    // 	this.dependencies.textEngine.enableModelEditMode(this.inputCornerText);
    // };
    //
    // public disableInputCornerText = () => {
    // 	this.dependencies.textEngine.disableModeEditMode(this.inputCornerText);
    // };
    Ca(this, "getSpatialArea", () => this.area);
    this.area = new SpatialUIPanelArea(this), this.addPostInjectDependenciesListener((Un) => {
      this.cornerRadiusButton.forceInjectDependencies({
        render: Un.render,
        useCases: Un.useCases,
        editCornerObject: Un.editCornerObject
      }), this.expandWidthButton.forceInjectDependencies({
        render: Un.render,
        useCases: Un.useCases
      }), this.inputCornerText.forceInjectDependencies({
        render: Un.render,
        textEngine: Un.textEngine
      }), this.inputCornerText.addPostChangeTextListener(() => {
        Un.useCases.setFocusObjectCornerRadius(this.inputCornerText.getValue());
      });
    });
  }
  callClick() {
  }
}
class PageBackgroundColorInput extends ColorInput {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Установить цвет страницы");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      size: 32,
      padding: 10,
      borderColorHover: UIDefaultColor.GRAY_600
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.setSelectColorListener(Un.useCases.setPageBackgroundColor);
    });
  }
}
class PageBackgroundPictureButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Установить фоновое изображение");
    this.setConfiguration((Un) => ({
      ...Un,
      tooltipType: TooltipType.BOTTOM,
      tooltipText: this.TOOLTIP_TEXT,
      isEnableTooltip: !0,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.ADD_IMAGE),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 22,
      text: null,
      borderColor: UIDefaultColor.WHITE,
      svgColor: UIDefaultColor.GRAY_600,
      fillHover: null,
      borderColorHover: UIDefaultColor.GRAY_600,
      svgColorHover: UIDefaultColor.GRAY_600,
      size: {
        width: 32,
        height: 32
      },
      padding: "center",
      borderRadius: 2,
      insideTextToSvg: 0
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.setPageBackgroundImage);
    });
  }
}
class PageEditModeButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Включить режим редактирования страницы");
    this.setConfiguration((Un) => ({
      ...Un,
      tooltipType: TooltipType.BOTTOM,
      tooltipText: this.TOOLTIP_TEXT,
      isEnableTooltip: !0,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.EDIT),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 22,
      text: null,
      borderColor: UIDefaultColor.WHITE,
      svgColor: UIDefaultColor.GRAY_600,
      fillHover: null,
      borderColorHover: UIDefaultColor.GRAY_600,
      svgColorHover: UIDefaultColor.GRAY_600,
      size: {
        width: 32,
        height: 32
      },
      padding: "center",
      borderRadius: 2,
      insideTextToSvg: 0
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.toggleBookEditMode);
    });
  }
}
class PagePictureCollageButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Установить изображение для коллажа");
    this.setConfiguration((Un) => ({
      ...Un,
      tooltipType: TooltipType.BOTTOM,
      tooltipText: this.TOOLTIP_TEXT,
      isEnableTooltip: !0,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.PAGE_COLLAGE),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 22,
      text: null,
      borderColor: UIDefaultColor.WHITE,
      svgColor: UIDefaultColor.GRAY_600,
      fillHover: null,
      borderColorHover: UIDefaultColor.GRAY_600,
      svgColorHover: UIDefaultColor.GRAY_600,
      size: {
        width: 32,
        height: 32
      },
      padding: "center",
      borderRadius: 2,
      insideTextToSvg: 0
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.setPageRepeatingImage);
    });
  }
}
class RepeatingImageInput extends NumberInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      fill: UIDefaultColor.WHITE,
      borderColor: UIDefaultColor.GRAY_300,
      borderRadius: 2,
      paddingHorizontal: 10
    })), this.setMaxLength(3), this.hide();
  }
}
class PropertyPageBarView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_TOP", 120);
    Ca(this, "DEFAULT_MARGIN_RIGHT", 20);
    Ca(this, "DEFAULT_PADDING", 24);
    Ca(this, "DEFAULT_MARGIN_BOTTOM_OBJECTS", 10);
    Ca(this, "DEFAULT_TITLE", "Параметры страницы");
    Ca(this, "DEFAULT_TITLE_REPEATING_IMAGE", "Масштаб коллажа");
    Ca(this, "DEFAULT_WIDTH_BAR", 320);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_BUTTON_SIZE", 30);
    Ca(this, "DEFAULT_BUTTON_PADDING", 8);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "DEFAULT_MARGIN_SIDE_BUTTON", 8);
    Ca(this, "container");
    Ca(this, "uiButtons");
    Ca(this, "title");
    Ca(this, "titleRepeatingImage");
    Ca(this, "repeatingImageInput");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "picturePageButton");
    Ca(this, "pageCollageButton");
    Ca(this, "pageEditModeButton");
    Ca(this, "pageBackgroundInput");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.title.object.visible = !0, this.pageBackgroundInput.show(), this.configuration.isEnableRepeatingImage && (this.titleRepeatingImage.object.visible = !0, this.repeatingImageInput.show()), this.uiButtons.forEach((Un) => {
        Un.show();
      }));
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.title.object.visible = !1, this.titleRepeatingImage.object.visible = !1, this.repeatingImageInput.hide(), this.pageBackgroundInput.hide(), this.uiButtons.forEach((Un) => {
        Un.hide();
      }));
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getUIElements", () => [this.pageBackgroundInput, ...this.uiButtons, this.repeatingImageInput]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.pageBackgroundInput.isEnableFocus() && Un.push(this.pageBackgroundInput), this.repeatingImageInput.isEnableFocus() && Un.push(this.repeatingImageInput), this.uiButtons.forEach((Kn) => {
        Kn.isEnableFocus() && Un.push(Kn);
      }), Un;
    });
    Ca(this, "getConfiguration", () => this.configuration);
    /**
     * Возвращает все объекты `FabricObject` из которых он состоит.
     */
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.title.object,
      this.titleRepeatingImage.object,
      ...this.repeatingImageInput.getFabricObjects(),
      ...this.pageBackgroundInput.getFabricObjects(),
      ...this.uiButtons.flatMap((Un) => Un.getFabricObjects())
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.title,
      this.titleRepeatingImage,
      ...this.repeatingImageInput.getObjects(),
      ...this.pageBackgroundInput.getObjects(),
      ...this.uiButtons.flatMap((Un) => Un.getObjects())
    ]);
    Ca(this, "getContainer", () => this.container.object);
    Ca(this, "getContentElements", () => [
      this.title.object,
      this.titleRepeatingImage.object,
      ...this.repeatingImageInput.getFabricObjects(),
      ...this.pageBackgroundInput.getFabricObjects(),
      ...this.uiButtons.flatMap((Un) => Un.getFabricObjects())
    ]);
    Ca(this, "getHeight", () => {
      const { padding: Un, marginBottomObjects: Kn, heightBlock: qn, titleFontSize: Jo } = this.configuration;
      return this.configuration.isEnableRepeatingImage ? Un * 2 + Kn * 2 + Jo + qn * 2 : Un * 2 + Kn + Jo + qn;
    });
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "getRelativePosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    Ca(this, "syncComponent", (Un) => {
      const { orientation: Kn, backgroundColor: qn, repeatingImage: Jo } = Un.getTexture();
      qn !== null && (this.pageBackgroundInput.setCurrentColor(qn), this.pageBackgroundInput.syncActiveColors(qn.toLowerCase())), Jo !== null ? (this.configuration.isEnableRepeatingImage = !0, this.repeatingImageInput.setValue(Jo.size.toString())) : this.configuration.isEnableRepeatingImage = !1;
    });
    Ca(this, "syncPosition", () => {
      const Un = this.dependencies.render.getWidth(), {
        marginTop: Kn,
        marginRight: qn,
        width: Jo,
        padding: pa,
        marginBottomObjects: ma,
        fill: va,
        cornerRadius: ba,
        heightBlock: _a,
        titleFontSize: ya,
        marginSideButton: xa
      } = this.configuration, wa = Un - qn - Jo;
      this.container.object.set({
        width: Jo,
        height: this.getHeight(),
        fill: va,
        rx: ba,
        ry: ba
      }), this.container.relativePosition = {
        x: wa,
        y: Kn
      }, this.title.object.set({
        fontSize: ya
      }), this.titleRepeatingImage.object.set({
        fontSize: ya
      }), this.title.relativePosition = {
        x: wa + pa,
        y: Kn + pa
      }, this.pageBackgroundInput.setConfiguration((Sa) => ({
        ...Sa,
        width: _a,
        height: _a,
        x: pa,
        y: pa + this.title.object.height + ma
      }));
      let Ta = pa + _a + xa;
      for (let Sa = 0; Sa < this.uiButtons.length; Sa++)
        this.uiButtons[Sa].setConfiguration((ka) => ({
          ...ka,
          x: Ta,
          y: pa + this.title.object.height + ma
        })), Ta += _a + xa;
      this.configuration.isEnableRepeatingImage ? (this.isShow && (this.titleRepeatingImage.object.visible = !0, this.repeatingImageInput.show()), this.titleRepeatingImage.relativePosition = {
        x: wa + pa,
        y: Kn + pa + this.title.object.height + ma + _a + xa + (_a / 2 - this.titleRepeatingImage.object.height / 2)
      }, this.repeatingImageInput.setConfiguration((Sa) => ({
        ...Sa,
        x: pa + xa + this.titleRepeatingImage.object.width,
        y: pa + this.title.object.height + ma + _a + xa + (_a / 2 - this.repeatingImageInput.getHeight() / 2),
        width: 64,
        height: _a
      }))) : (this.titleRepeatingImage.object.visible = !1, this.repeatingImageInput.hide()), this.dependencies.render.renderRelativePositions();
    });
    this.uiButtons = [], this.isShow = !1, this.isResetFocus = !0, this.configuration = {
      marginTop: this.DEFAULT_MARGIN_TOP,
      marginRight: this.DEFAULT_MARGIN_RIGHT,
      width: this.DEFAULT_WIDTH_BAR,
      padding: this.DEFAULT_PADDING,
      marginBottomObjects: this.DEFAULT_MARGIN_BOTTOM_OBJECTS,
      fill: UIDefaultColor.WHITE,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      heightBlock: this.DEFAULT_BUTTON_SIZE,
      buttonPadding: this.DEFAULT_BUTTON_PADDING,
      marginSideButton: this.DEFAULT_MARGIN_SIDE_BUTTON,
      isEnableRepeatingImage: !0
    }, this.container = {
      object: new pr({
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo(this.DEFAULT_TITLE, {
        fill: UIDefaultColor.BLACK,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.titleRepeatingImage = {
      object: new Xo(this.DEFAULT_TITLE_REPEATING_IMAGE, {
        fill: UIDefaultColor.GRAY_700,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.repeatingImageInput = new RepeatingImageInput(), this.pageEditModeButton = new PageEditModeButton(), this.pageCollageButton = new PagePictureCollageButton(), this.picturePageButton = new PageBackgroundPictureButton(), this.pageBackgroundInput = new PageBackgroundColorInput(), this.uiButtons.push(this.pageEditModeButton, this.picturePageButton, this.pageCollageButton);
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class PropertyPageBar extends PropertyPageBarView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    this.area = new SpatialUIPanelArea(this), this.addPostInjectDependenciesListener((Un) => {
      const { useCases: Kn, render: qn, core: Jo, textEngine: pa } = Un;
      this.pageBackgroundInput.forceInjectDependencies({ render: qn, useCases: Kn, core: Jo }), this.pageEditModeButton.forceInjectDependencies({ render: qn, useCases: Kn }), this.picturePageButton.forceInjectDependencies({ render: qn, useCases: Kn }), this.pageCollageButton.forceInjectDependencies({ render: qn, useCases: Kn }), this.repeatingImageInput.forceInjectDependencies({
        render: qn,
        textEngine: pa
      }), this.repeatingImageInput.addPostChangeTextListener(() => {
        Un.useCases.setRepeatingImageSize(this.repeatingImageInput.getValue());
      });
    });
  }
  callClick() {
  }
}
class TableBorderColorInput extends ColorInput {
  constructor() {
    super(), this.hide(), this.addPostInjectDependenciesListener((zn) => {
      this.setSelectColorListener(zn.useCases.setFocusTableBorderColor);
    });
  }
}
class TableFillColorInput extends ColorInput {
  constructor() {
    super(), this.hide(), this.addPostInjectDependenciesListener((zn) => {
      this.setSelectColorListener(zn.useCases.setFocusTableCellFill);
    });
  }
}
class TableLoadExcelButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      tooltipType: TooltipType.BOTTOM,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.EXCEL_REPLACE),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 24,
      text: null,
      borderColor: UIDefaultColor.WHITE,
      svgColor: UIDefaultColor.GRAY_600,
      fillHover: null,
      borderColorHover: UIDefaultColor.GRAY_600,
      svgColorHover: UIDefaultColor.GRAY_600,
      size: {
        width: 32,
        height: 32
      },
      padding: "center",
      borderRadius: 2,
      insideTextToSvg: 0
    })), this.hide(), this.addPostInjectDependenciesListener((zn) => {
      this.addPostMouseDownListeners(zn.useCases.replaceTablesFromXLSX);
    });
  }
}
class PropertyTableBarView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_TOP", 120);
    Ca(this, "DEFAULT_MARGIN_RIGHT", 20);
    Ca(this, "DEFAULT_PADDING", 24);
    Ca(this, "DEFAULT_MARGIN_BOTTOM_OBJECTS", 10);
    Ca(this, "DEFAULT_TITLE", "Таблица");
    Ca(this, "DEFAULT_TITLE_FILL_COLOR", "Заливка");
    Ca(this, "DEFAULT_TITLE_BORDER_COLOR", "Граница");
    Ca(this, "DEFAULT_WIDTH_BAR", 320);
    Ca(this, "DEFAULT_FILL_BAR", UIDefaultColor.WHITE);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_BUTTON_PADDING", 14);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "DEFAULT_TITLE_SECOND_FONT_SIZE", 14);
    Ca(this, "DEFAULT_MARGIN_SIDE_BUTTON", 8);
    Ca(this, "DEFAULT_HEIGHT_CORNER_BLOCK", 32);
    Ca(this, "container");
    Ca(this, "loadExcelButton");
    Ca(this, "fillColorInput");
    Ca(this, "borderColorInput");
    Ca(this, "title");
    Ca(this, "titleFill");
    Ca(this, "titleBorder");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "configuration");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.isShow = !0, this.container.object.visible = !0, this.title.object.visible = !0, this.titleFill.object.visible = !0, this.titleBorder.object.visible = !0, this.loadExcelButton.show(), this.fillColorInput.show(), this.borderColorInput.show());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.title.object.visible = !1, this.titleFill.object.visible = !1, this.titleBorder.object.visible = !1, this.loadExcelButton.hide(), this.fillColorInput.hide(), this.borderColorInput.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getHeight", () => {
      const { padding: Un, marginBottomObjects: Kn, heightBlocks: qn } = this.configuration;
      return Un * 2 + Kn * 3 + qn * 3;
    });
    Ca(this, "getRelativePosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    /**
     * Возвращает конфигурацию панели.
     */
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration;
      this.configuration = Un(Kn), this.sync();
    });
    Ca(this, "getUIElements", () => [this.loadExcelButton, this.fillColorInput, this.borderColorInput]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.loadExcelButton.isEnableFocus() && Un.push(this.loadExcelButton), this.fillColorInput.isEnableFocus() && Un.push(this.fillColorInput), this.borderColorInput.isEnableFocus() && Un.push(this.borderColorInput), Un;
    });
    /**
     * Возвращает все объекты `FabricObject` в панели.
     */
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.title.object,
      this.titleFill.object,
      this.titleBorder.object,
      ...this.loadExcelButton.getFabricObjects(),
      ...this.fillColorInput.getFabricObjects(),
      ...this.borderColorInput.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.title,
      this.titleFill,
      this.titleBorder,
      ...this.loadExcelButton.getObjects(),
      ...this.fillColorInput.getObjects(),
      ...this.borderColorInput.getObjects()
    ]);
    Ca(this, "getContainer", () => this.container.object);
    Ca(this, "getContentElements", () => [
      this.title.object,
      this.titleFill.object,
      this.titleBorder.object,
      ...this.loadExcelButton.getFabricObjects(),
      ...this.fillColorInput.getFabricObjects(),
      ...this.borderColorInput.getFabricObjects()
    ]);
    /**
     * Обновляет панель в зависимости от новых размеров `canvas`.
     * @param width
     */
    Ca(this, "syncPosition", () => {
      this.sync();
    });
    Ca(this, "syncComponent", (Un) => {
      const Kn = [], qn = [];
      Un.forEach((ma) => {
        const va = ma.getTexture(), ba = ma.getFocusCellContexts();
        ba ? qn.push(...ba.map((_a) => _a.getTexture())) : qn.push(...va.cells), Kn.push(va);
      });
      const Jo = Utils.objectUtils.checkFieldsEquality(...Kn), pa = Utils.objectUtils.checkFieldsEquality(...qn);
      Jo.borderColor !== null ? this.borderColorInput.setCurrentColor(Jo.borderColor) : this.borderColorInput.setCurrentColor(UIDefaultColor.BLACK), pa.background !== null ? this.fillColorInput.setCurrentColor(pa.background) : this.fillColorInput.setCurrentColor(UIDefaultColor.WHITE);
    });
    /**
     * Синхронизирует все параметры панели.
     */
    Ca(this, "sync", () => {
      const {
        marginTop: Un,
        marginRight: Kn,
        width: qn,
        padding: Jo,
        marginBottomObjects: pa,
        fill: ma,
        cornerRadius: va,
        titleFontSize: ba,
        marginSideButton: _a,
        heightBlocks: ya
      } = this.configuration, xa = this.dependencies.render.getWidth() - Kn - qn;
      this.container.object.set({
        width: qn,
        height: this.getHeight(),
        fill: ma,
        rx: va,
        ry: va
      }), this.container.relativePosition = {
        x: xa,
        y: Un
      }, this.title.relativePosition = {
        x: xa + Jo,
        y: Un + Jo
      }, this.fillColorInput.setConfiguration((wa) => ({
        ...wa,
        x: Jo,
        y: Jo + ba + pa
      })), this.titleFill.relativePosition = {
        x: xa + Jo + this.fillColorInput.getFrameArea().width + pa,
        y: Un + Jo + ba + pa + (ya / 2 - this.titleFill.object.height / 2)
      }, this.borderColorInput.setConfiguration((wa) => ({
        ...wa,
        x: Jo,
        y: Jo + ba + pa + this.fillColorInput.getFrameArea().height + pa
      })), this.titleBorder.relativePosition = {
        x: xa + Jo + this.borderColorInput.getFrameArea().width + pa,
        y: Un + Jo + ba + pa * 2 + this.fillColorInput.getFrameArea().height + (ya / 2 - this.titleBorder.object.height / 2)
      }, this.loadExcelButton.setConfiguration((wa) => ({
        ...wa,
        x: Jo,
        y: Jo + ba + pa * 3 + this.fillColorInput.getFrameArea().height + this.borderColorInput.getFrameArea().height
      })), this.dependencies.render.renderRelativePositions();
    });
    this.isShow = !1, this.isResetFocus = !0, this.configuration = {
      marginTop: this.DEFAULT_MARGIN_TOP,
      marginRight: this.DEFAULT_MARGIN_RIGHT,
      width: this.DEFAULT_WIDTH_BAR,
      padding: this.DEFAULT_PADDING,
      marginBottomObjects: this.DEFAULT_MARGIN_BOTTOM_OBJECTS,
      fill: this.DEFAULT_FILL_BAR,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      buttonPadding: this.DEFAULT_BUTTON_PADDING,
      marginSideButton: this.DEFAULT_MARGIN_SIDE_BUTTON,
      heightBlocks: this.DEFAULT_HEIGHT_CORNER_BLOCK
    }, this.container = {
      object: new pr({
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo(this.DEFAULT_TITLE, {
        fill: UIDefaultColor.GRAY_900,
        fontSize: this.configuration.titleFontSize,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.titleFill = {
      object: new Xo(this.DEFAULT_TITLE_FILL_COLOR, {
        fill: UIDefaultColor.GRAY_900,
        fontSize: this.DEFAULT_TITLE_SECOND_FONT_SIZE,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.titleBorder = {
      object: new Xo(this.DEFAULT_TITLE_BORDER_COLOR, {
        fill: UIDefaultColor.GRAY_900,
        fontSize: this.DEFAULT_TITLE_SECOND_FONT_SIZE,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.fillColorInput = new TableFillColorInput(), this.borderColorInput = new TableBorderColorInput(), this.loadExcelButton = new TableLoadExcelButton();
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class PropertyTableBar extends PropertyTableBarView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    this.area = new SpatialUIPanelArea(this), this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, useCases: qn, core: Jo } = Un;
      this.loadExcelButton.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.fillColorInput.forceInjectDependencies({
        render: Kn,
        useCases: qn,
        core: Jo
      }), this.borderColorInput.forceInjectDependencies({
        render: Kn,
        useCases: qn,
        core: Jo
      });
    });
  }
  callClick() {
  }
}
class SpatialComboBoxItemArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.COMBO_BOX_ITEM);
    Ca(this, "getGlobalFrameArea", () => this.comboBoxItem.getFrameArea());
    Ca(this, "getData", () => this.comboBoxItem);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.comboBoxItem = Un;
  }
}
var ITextPosition = /* @__PURE__ */ ((Xn) => (Xn.LEFT = "left", Xn.CENTER = "center", Xn))(ITextPosition || {});
class ComboBoxItemView extends Dependent {
  constructor(Un, Kn) {
    super();
    Ca(this, "DEFAULT_DURATION_HOVER", 10);
    Ca(this, "container");
    Ca(this, "text");
    Ca(this, "value");
    Ca(this, "clipPath");
    Ca(this, "parentComboBox");
    Ca(this, "configuration");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isVisible");
    Ca(this, "isResetFocus");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "getValue", () => this.value);
    Ca(this, "setParentComboBox", (Un) => {
      this.parentComboBox = Un;
    });
    Ca(this, "enableHover", () => {
      if (!this.isHover) {
        this.isHover = !0;
        const { fill: Un, fillHover: Kn, textColorHover: qn, textColor: Jo } = this.configuration;
        if (!this.isFocus) {
          const pa = [
            {
              object: this.container.object,
              startColor: Un,
              endColor: Kn,
              duration: this.DEFAULT_DURATION_HOVER,
              type: TypeColorAnimated.FILL
            },
            {
              object: this.text.object,
              startColor: Jo,
              endColor: qn,
              duration: this.DEFAULT_DURATION_HOVER,
              type: TypeColorAnimated.FILL
            }
          ];
          this.dependencies.render.animateColor(...pa);
        }
      }
    });
    Ca(this, "disableHover", () => {
      if (this.isHover) {
        this.isHover = !1;
        const { fill: Un, fillHover: Kn, textColorHover: qn, textColor: Jo } = this.configuration;
        if (!this.isFocus) {
          const pa = [
            {
              object: this.container.object,
              startColor: Kn,
              endColor: Un,
              duration: this.DEFAULT_DURATION_HOVER,
              type: TypeColorAnimated.FILL
            },
            {
              object: this.text.object,
              startColor: qn,
              endColor: Jo,
              duration: this.DEFAULT_DURATION_HOVER,
              type: TypeColorAnimated.FILL
            }
          ];
          this.dependencies.render.animateColor(...pa);
        }
      }
    });
    Ca(this, "enableFocus", () => {
      this.isFocus || (this.isFocus = !0, this.container.object.set({
        fill: this.configuration.fillFocus
      }), this.text.object.set({
        fill: this.configuration.textColorFocus
      }), this.dependencies.render.renderUnstructured());
    });
    Ca(this, "disableFocus", () => {
      this.isFocus && (this.isFocus = !1, this.container.object.set({
        fill: this.configuration.fill
      }), this.text.object.set({
        fill: this.configuration.textColor
      }), this.dependencies.render.renderUnstructured());
    });
    Ca(this, "getParentComboBox", () => this.parentComboBox);
    Ca(this, "setClipPath", (Un) => {
      this.clipPath = Un, this.container.object.set({
        clipPath: this.clipPath.object
      }), this.text.object.set({
        clipPath: this.clipPath.object
      });
    });
    Ca(this, "getCloneText", () => new Xo(this.text.object.text, {
      fill: this.text.object.fill,
      fontSize: this.text.object.fontSize,
      fontFamily: this.text.object.fontFamily
    }));
    Ca(this, "getText", () => this.text.object.text);
    Ca(this, "isEnableHover", () => this.isHover);
    Ca(this, "isEnableFocus", () => this.isFocus);
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.container.object.visible = !0, this.text.object.visible = !0);
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.container.object.visible = !1, this.text.object.visible = !1);
    });
    Ca(this, "getFrameArea", () => {
      if (this.parentComboBox === null)
        throw new Error("ParentComboBox null");
      if (this.configuration.y < 0) {
        let Un = this.container.object.height + this.configuration.y;
        return Un < 0 && (Un = 1), {
          width: this.container.object.width,
          height: Un,
          x: this.container.object.left,
          y: this.container.object.top - this.configuration.y,
          rotate: 0
        };
      }
      return this.configuration.y > this.parentComboBox.getHeightMenu() - this.configuration.height ? {
        width: this.container.object.width,
        height: this.configuration.y + this.configuration.height - this.parentComboBox.getHeightMenu(),
        x: this.container.object.left,
        y: this.container.object.top,
        rotate: 0
      } : {
        width: this.container.object.width,
        height: this.container.object.height,
        x: this.container.object.left,
        y: this.container.object.top,
        rotate: 0
      };
    });
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "getWidth", () => this.configuration.width);
    Ca(this, "getHeight", () => this.configuration.height);
    Ca(this, "isShowed", () => this.isVisible);
    Ca(this, "getFabricObjects", () => [this.container.object, this.text.object]);
    Ca(this, "getObjects", () => [this.container, this.text]);
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      switch (qn.textPositionHorizontal) {
        case ITextPosition.LEFT: {
          this.text.object.set({
            text: qn.text,
            fontSize: qn.textFontSize,
            fontFamily: qn.textFontFamily,
            fill: qn.textColor
          }), this.text.relativePosition = {
            x: qn.x + qn.padding.leftRight,
            y: qn.y + Math.round(this.configuration.height / 2 - this.text.object.height / 2)
          };
          break;
        }
        case ITextPosition.CENTER: {
          this.text.object.set({
            text: qn.text,
            fontSize: qn.textFontSize,
            fontFamily: qn.textFontFamily,
            fill: qn.textColor
          }), this.text.relativePosition = {
            x: qn.x + Math.round(qn.width / 2 - this.text.object.width / 2),
            y: qn.y + Math.round(this.configuration.height / 2 - this.text.object.height / 2)
          };
          break;
        }
      }
      this.container.object.set({
        fill: this.isFocus ? qn.fillFocus : qn.fill,
        width: qn.width,
        height: qn.height
      }), this.container.relativePosition = {
        x: qn.x,
        y: qn.y
      }, this.configuration = qn;
    });
    Ca(this, "scroll", (Un, Kn, qn) => {
      const Jo = this.container.relativePosition.y + Un;
      this.container.relativePosition = {
        x: this.container.relativePosition.x,
        y: Jo
      }, this.text.relativePosition = {
        x: this.text.relativePosition.x,
        y: this.text.relativePosition.y + Un
      }, this.configuration.y = Jo, this.dependencies.render.renderRelativePositions(), qn();
    });
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getUIElements", () => []);
    this.value = Kn, this.parentComboBox = null, this.isHover = !1, this.isFocus = !1, this.isVisible = !1, this.isResetFocus = !0, this.configuration = {
      text: Un,
      textFontSize: 16,
      textFontFamily: FontFamily.DEFAULT,
      textColor: UIDefaultColor.BLACK,
      textColorHover: UIDefaultColor.BLACK,
      textColorFocus: UIDefaultColor.BLACK,
      fill: UIDefaultColor.WHITE,
      fillHover: UIDefaultColor.GRAY_50,
      fillFocus: UIDefaultColor.GRAY_350,
      width: 100,
      height: 34,
      x: 0,
      y: 0,
      padding: {
        leftRight: 10,
        topBottom: 5
      },
      textPositionHorizontal: ITextPosition.CENTER
    }, this.container = {
      object: new pr({
        width: this.configuration.width,
        height: this.configuration.height,
        fill: this.configuration.fill,
        opacity: 0.3,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.text = {
      object: new Xo(this.configuration.text, {
        fontSize: this.configuration.textFontSize,
        fontFamily: this.configuration.textFontFamily,
        fill: this.configuration.textColor,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.clipPath = {
      object: new pr({
        absolutePositioned: !0
      }),
      relativePosition: { x: 0, y: 0 }
    };
  }
}
class ComboBoxItem extends ComboBoxItemView {
  constructor(Un, Kn) {
    super(Un, Kn);
    Ca(this, "area");
    Ca(this, "postMouseDownListeners");
    Ca(this, "prevMouseDownListeners");
    Ca(this, "addPostMouseDownListeners", (...Un) => {
      this.postMouseDownListeners.push(...Un);
    });
    Ca(this, "addPrevMouseDownListeners", (...Un) => {
      this.prevMouseDownListeners.push(...Un);
    });
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "callClick", () => {
      this.prevMouseDownListeners.forEach((Un) => Un(this.value)), this.onClick(), this.postMouseDownListeners.forEach((Un) => Un(this.value));
    });
    Ca(this, "onClick", () => {
      var Un, Kn;
      this.isFocus || ((Un = this.parentComboBox) == null || Un.disableFocusAllItems(), this.enableFocus(), (Kn = this.parentComboBox) == null || Kn.setCurrentItem(this));
    });
    this.area = new SpatialComboBoxItemArea(this), this.postMouseDownListeners = [], this.prevMouseDownListeners = [];
  }
}
class SpatialComboBoxArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.COMBO_BOX);
    Ca(this, "getGlobalFrameArea", () => this.comboBox.getFrameArea());
    Ca(this, "getData", () => this.comboBox);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.comboBox = Un;
  }
}
class ComboBoxView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_BORDER_RADIUS", 4);
    Ca(this, "DEFAULT_WIDTH", 150);
    Ca(this, "DEFAULT_HEIGHT", 30);
    Ca(this, "DEFAULT_WIDTH_SCROLL_BAR", 4);
    Ca(this, "DEFAULT_MAX_HEIGHT_MENU_ITEMS", 150);
    Ca(this, "DEFAULT_FILL", "#FFFFFF");
    Ca(this, "DEFAULT_BORDER_COLOR", "#000000");
    Ca(this, "DEFAULT_SVG_COLOR", UIDefaultColor.GRAY_600);
    Ca(this, "DEFAULT_SVG_COLOR_HOVER", UIDefaultColor.GRAY_600);
    Ca(this, "DEFAULT_SVG_COLOR_FOCUS", UIDefaultColor.GRAY_600);
    Ca(this, "DEFAULT_BORDER_THICKNESS", 1);
    Ca(this, "DEFAULT_FILL_HOVER", "#d6e9ff");
    Ca(this, "DEFAULT_FILL_FOCUS", "#d6e9ff");
    Ca(this, "DEFAULT_BORDER_COLOR_HOVER", "#000000");
    Ca(this, "DEFAULT_BORDER_COLOR_FOCUS", "#000000");
    Ca(this, "DEFAULT_TEXT_FONT_SIZE", 16);
    Ca(this, "DEFAULT_TEXT_FONT", FontFamily.DEFAULT);
    Ca(this, "DEFAULT_DURATION_FOCUS", 50);
    Ca(this, "DEFAULT_DURATION_HOVER", 50);
    Ca(this, "DEFAULT_PADDING", {
      leftRight: 10,
      topBottom: 5
    });
    Ca(this, "configuration");
    Ca(this, "container");
    Ca(this, "containerItems");
    Ca(this, "currentItem");
    Ca(this, "clipPathMenu");
    Ca(this, "currentText");
    Ca(this, "currentSvg");
    Ca(this, "items");
    Ca(this, "scrollBar");
    Ca(this, "commonScroll");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isVisible");
    Ca(this, "isResetFocus");
    Ca(this, "accumulatedOffset");
    Ca(this, "isAnimating");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "enableHover", () => {
      if (!this.isHover) {
        this.isHover = !0;
        const { fill: Un, fillHover: Kn, borderColor: qn, borderColorHover: Jo, svgColor: pa, svgColorHover: ma } = this.configuration, va = [
          {
            object: this.container.object,
            startColor: Un,
            endColor: Kn,
            duration: this.DEFAULT_DURATION_HOVER,
            type: TypeColorAnimated.FILL
          },
          {
            object: this.container.object,
            startColor: qn,
            endColor: Jo,
            duration: this.DEFAULT_DURATION_HOVER,
            type: TypeColorAnimated.STROKE
          },
          {
            object: this.currentSvg.object,
            startColor: pa,
            endColor: ma,
            duration: this.DEFAULT_DURATION_HOVER,
            type: TypeColorAnimated.FILL
          }
        ];
        this.dependencies.render.animateColor(...va);
      }
    });
    Ca(this, "disableHover", () => {
      if (this.isHover) {
        this.isHover = !1;
        const { fill: Un, fillHover: Kn, borderColor: qn, borderColorHover: Jo, svgColorHover: pa, svgColor: ma } = this.configuration, va = [
          {
            object: this.container.object,
            startColor: Kn,
            endColor: Un,
            duration: this.DEFAULT_DURATION_HOVER,
            type: TypeColorAnimated.FILL
          },
          {
            object: this.container.object,
            startColor: Jo,
            endColor: qn,
            duration: this.DEFAULT_DURATION_HOVER,
            type: TypeColorAnimated.STROKE
          },
          {
            object: this.currentSvg.object,
            startColor: pa,
            endColor: ma,
            duration: this.DEFAULT_DURATION_HOVER,
            type: TypeColorAnimated.FILL
          }
        ];
        this.dependencies.render.animateColor(...va);
      }
    });
    Ca(this, "enableFocus", () => {
      this.isFocus || (this.isFocus = !0, this.containerItems.object.visible = !0, this.scrollBar.object.visible = !0, this.commonScroll = 0, this.getVisibleItems().forEach((Un) => {
        Un.show();
      }));
    });
    Ca(this, "disableFocus", () => {
      this.isFocus && (this.isFocus = !1, this.containerItems.object.visible = !1, this.scrollBar.object.visible = !1, this.items.forEach((Un) => {
        Un.hide();
      }));
    });
    Ca(this, "setCurrentItem", (Un) => {
      this.currentItem = Un, this.items.forEach((Kn) => Kn.disableFocus()), this.currentItem.enableFocus(), this.currentText.object.set({
        text: Un.getText()
      }), this.configuration.isEnableText && (this.currentText.relativePosition = {
        x: this.configuration.x + Math.round(this.configuration.width / 2 - this.currentText.object.width / 2),
        y: this.configuration.y + Math.round(this.configuration.height / 2 - this.currentText.object.height / 2)
      }), this.disableFocus();
    });
    Ca(this, "setCurrentItemNoFocus", (Un) => {
      this.currentItem = Un, this.items.forEach((Kn) => Kn.disableFocus()), this.currentItem.enableFocus(), this.currentText.object.set({
        text: Un.getText()
      }), this.configuration.isEnableText && (this.currentText.relativePosition = {
        x: this.configuration.x + Math.round(this.configuration.width / 2 - this.currentText.object.width / 2),
        y: this.configuration.y + Math.round(this.configuration.height / 2 - this.currentText.object.height / 2)
      });
    });
    Ca(this, "disableCurrentItem", () => {
      this.currentItem = null, this.items.forEach((Un) => Un.disableFocus()), this.currentText.object.set({
        text: ""
      });
    });
    Ca(this, "disableFocusAllItems", () => {
      this.items.forEach((Un) => {
        Un.disableFocus();
      });
    });
    Ca(this, "addItems", (...Un) => {
      this.items.length === 0 && this.setCurrentItem(Un[0]), this.items.push(...Un), this.items.forEach((Kn) => {
        Kn.setClipPath(this.clipPathMenu), Kn.setParentComboBox(this);
      });
    });
    Ca(this, "getItems", () => this.items);
    Ca(this, "setCurrentItemToValue", (Un) => {
      this.items.forEach((Kn) => {
        Kn.getValue() === Un && this.setCurrentItemNoFocus(Kn);
      });
    });
    Ca(this, "isEnableHover", () => this.isHover);
    Ca(this, "isEnableFocus", () => this.isFocus);
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.container.object.visible = !0, this.currentText.object.visible = !0, this.currentSvg.object.visible = !0);
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.container.object.visible = !1, this.currentText.object.visible = !1, this.currentSvg.object.visible = !1, this.scrollBar.object.visible = !1, this.disableFocus());
    });
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "getWidth", () => this.configuration.width);
    Ca(this, "getHeight", () => this.configuration.height);
    Ca(this, "isShowed", () => this.isVisible);
    Ca(this, "getFabricObjects", () => {
      const Un = [this.container.object];
      return this.configuration.isEnableText && Un.push(this.currentText.object), this.configuration.isEnableSvg && Un.push(this.currentSvg.object), Un.push(this.containerItems.object, ...this.items.flatMap((Kn) => Kn.getFabricObjects())), this.configuration.isEnableScrollBar && Un.push(this.scrollBar.object), Un;
    });
    Ca(this, "getObjects", () => {
      const Un = [this.container];
      return this.configuration.isEnableText && Un.push(this.currentText), this.configuration.isEnableSvg && Un.push(this.currentSvg), Un.push(this.containerItems, this.clipPathMenu, ...this.items.flatMap((Kn) => Kn.getObjects())), this.configuration.isEnableScrollBar && Un.push(this.scrollBar), Un;
    });
    Ca(this, "setSvg", (Un) => {
      this.currentSvg = {
        object: Un,
        relativePosition: { x: 0, y: 0 }
      }, this.currentSvg.relativePosition = {
        x: Math.round(this.configuration.x + this.configuration.width / 2 - this.currentSvg.object.width / 2),
        y: Math.round(this.configuration.y + this.configuration.height / 2 - this.currentSvg.object.height / 2)
      }, this.currentSvg.object.set({
        fill: this.configuration.svgColor
      });
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      if (this.container.object.set({
        fill: qn.fill,
        stroke: qn.borderColor,
        strokeWidth: qn.borderThickness,
        width: qn.width,
        height: qn.height
      }), this.container.relativePosition = {
        x: qn.x,
        y: qn.y
      }, this.containerItems.object.set({
        fill: qn.fill,
        stroke: qn.borderColor,
        strokeWidth: qn.borderThickness,
        width: qn.widthMenuItems,
        height: qn.maxHeightMenuItems
      }), this.containerItems.relativePosition = {
        x: qn.x,
        y: qn.y
      }, this.clipPathMenu.object.set({
        width: qn.widthMenuItems,
        height: qn.maxHeightMenuItems
      }), this.clipPathMenu.relativePosition = {
        x: qn.x,
        y: qn.y
      }, this.scrollBar.object.set({
        height: this.calculateScrollBarHeight(qn.maxHeightMenuItems)
      }), this.scrollBar.relativePosition = {
        x: qn.x + qn.widthMenuItems - this.DEFAULT_WIDTH_SCROLL_BAR,
        y: qn.y
      }, this.configuration.isEnableText && this.configuration.isEnableSvg) {
        const ma = this.currentText.object.width + this.currentSvg.object.width + 5;
        this.currentSvg.relativePosition = {
          x: qn.x + Math.round(qn.width / 2 - ma / 2),
          y: qn.y + Math.round(qn.height / 2 - this.currentSvg.object.height / 2)
        }, this.currentText.relativePosition = {
          x: this.currentSvg.object.left + this.currentSvg.object.width + 5,
          y: qn.y + Math.round(qn.height / 2 - this.currentText.object.height / 2)
        };
      } else
        qn.isEnableText && (this.currentText.relativePosition = {
          x: qn.x + Math.round(qn.width / 2 - this.currentText.object.width / 2),
          y: qn.y + Math.round(qn.height / 2 - this.currentText.object.height / 2)
        }), qn.isEnableSvg && (this.currentSvg.relativePosition = {
          x: Math.round(this.configuration.x + this.configuration.width / 2 - this.currentSvg.object.width / 2),
          y: Math.round(this.configuration.y + this.configuration.height / 2 - this.currentSvg.object.height / 2)
        });
      this.currentSvg.object.set({
        fill: qn.svgColor
      }), this.configuration = qn;
      let Jo = 0;
      this.items.forEach((pa) => {
        pa.setConfiguration((ma) => ({
          ...ma,
          width: qn.widthMenuItems,
          x: 0,
          y: Jo
        })), Jo += qn.height;
      });
    });
    /**
     * Синхронизирует при скролле.
     */
    Ca(this, "syncScroll", (Un) => {
      if (this.isAnimating) {
        this.accumulatedOffset += Un;
        return;
      }
      this.isAnimating = !0, this.commonScroll += Un;
      let Kn = Un;
      if (this.commonScroll > this.getMaxScroll() && (Kn -= this.commonScroll - this.getMaxScroll(), this.commonScroll = this.getMaxScroll()), this.commonScroll < 0 && (Kn += -this.commonScroll, this.commonScroll = 0), Kn === 0) {
        this.isAnimating = !1;
        return;
      }
      const qn = this.items[this.items.length - 1];
      this.items.forEach((Jo) => {
        Jo.hide();
      }), this.getVisibleItems().forEach((Jo) => {
        Jo.show();
      }), this.items.forEach((Jo) => {
        Jo.scroll(-Kn, Math.abs(Kn), () => {
          if (Jo === qn) {
            this.isAnimating = !1;
            const pa = this.accumulatedOffset;
            this.accumulatedOffset = 0, pa !== 0 && this.syncScroll(pa);
          }
        });
      }), this.updateScrollBarPosition(), this.items.length === 0 && (this.isAnimating = !1), this.items.forEach((Jo) => {
        Jo.hide();
      }), this.getVisibleItems().forEach((Jo) => {
        Jo.show();
      });
    });
    Ca(this, "getMaxScroll", () => {
      const Un = this.configuration.height * this.items.length;
      return Un <= this.configuration.maxHeightMenuItems ? 0 : Un - this.configuration.maxHeightMenuItems;
    });
    Ca(this, "getHeightMenu", () => this.configuration.maxHeightMenuItems);
    /**
     * Возвращает только элементы которые должны быть видны при определенном скролле.
     */
    Ca(this, "getVisibleItems", () => {
      if (this.isEnableFocus()) {
        let Un = Math.ceil(this.commonScroll / this.configuration.height) - 1, Kn = Math.ceil(this.configuration.maxHeightMenuItems / this.configuration.height) + 1;
        return this.commonScroll % this.configuration.height === 0 && (Un = Math.ceil(this.commonScroll / this.configuration.height), Kn = Math.ceil(this.configuration.maxHeightMenuItems / this.configuration.height)), this.items.length <= Kn ? this.items : this.items.slice(Un, Un + Kn);
      }
      return [];
    });
    Ca(this, "updateScrollBarPosition", () => {
      const Un = this.getMaxScroll();
      if (Un === 0) {
        this.scrollBar.object.set({ visible: !1 });
        return;
      }
      const Kn = this.commonScroll / Un, qn = this.configuration.maxHeightMenuItems - this.scrollBar.object.height;
      this.scrollBar.object.set({
        top: this.scrollBar.object.top + Kn * qn
      });
    });
    this.commonScroll = 0, this.configuration = {
      borderRadius: this.DEFAULT_BORDER_RADIUS,
      fill: this.DEFAULT_FILL,
      fillHover: this.DEFAULT_FILL_HOVER,
      fillFocus: this.DEFAULT_FILL_FOCUS,
      borderColor: this.DEFAULT_BORDER_COLOR,
      borderColorHover: this.DEFAULT_BORDER_COLOR_HOVER,
      borderFocusColor: this.DEFAULT_BORDER_COLOR_FOCUS,
      borderThickness: this.DEFAULT_BORDER_THICKNESS,
      x: 0,
      y: 0,
      padding: this.DEFAULT_PADDING,
      fontSize: this.DEFAULT_TEXT_FONT_SIZE,
      fontFamily: this.DEFAULT_TEXT_FONT,
      durationHover: this.DEFAULT_DURATION_HOVER,
      durationFocus: this.DEFAULT_DURATION_FOCUS,
      width: this.DEFAULT_WIDTH,
      height: this.DEFAULT_HEIGHT,
      maxHeightMenuItems: this.DEFAULT_MAX_HEIGHT_MENU_ITEMS,
      widthMenuItems: this.DEFAULT_WIDTH,
      isEnableText: !0,
      isEnableSvg: !1,
      isEnableScrollBar: !0,
      svgColor: this.DEFAULT_SVG_COLOR,
      svgColorHover: this.DEFAULT_SVG_COLOR_HOVER,
      svgColorFocus: this.DEFAULT_SVG_COLOR_FOCUS
    }, this.container = {
      object: new pr({
        fill: this.configuration.fill,
        rx: this.configuration.borderRadius,
        ry: this.configuration.borderRadius,
        width: this.configuration.width,
        height: this.configuration.height
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.containerItems = {
      object: new pr({
        fill: this.configuration.fill,
        rx: this.configuration.borderRadius,
        ry: this.configuration.borderRadius,
        width: this.configuration.width,
        height: this.configuration.maxHeightMenuItems,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.clipPathMenu = {
      object: new pr({
        absolutePositioned: !0,
        rx: this.configuration.borderRadius,
        ry: this.configuration.borderRadius
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.scrollBar = {
      object: new pr({
        width: this.DEFAULT_WIDTH_SCROLL_BAR,
        fill: UIDefaultColor.GRAY_400,
        clipPath: this.clipPathMenu.object,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.currentItem = null, this.currentText = {
      object: new Xo("ComboBox", {
        fontSize: this.configuration.fontSize,
        fontFamily: this.configuration.fontFamily
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.currentSvg = {
      object: SVGCanvasStore.getSvg(SVGCollection.CLOSE),
      relativePosition: { x: 0, y: 0 }
    }, this.currentSvg.object.visible = !1, this.items = [], this.isVisible = !0, this.isHover = !1, this.isFocus = !1, this.isAnimating = !1, this.isResetFocus = !0, this.accumulatedOffset = 0;
  }
  calculateScrollBarHeight(Un) {
    const Kn = this.configuration.height * this.items.length;
    return Kn <= Un ? Un : Un / Kn * Un;
  }
}
class UIBaseComboBox extends ComboBoxView {
  constructor() {
    super();
    Ca(this, "postMouseDownListeners");
    Ca(this, "postMouseUpListeners");
    Ca(this, "prevMouseDownListeners");
    Ca(this, "prevMouseUpListeners");
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "addPostMouseDownListeners", (...Un) => {
      this.postMouseDownListeners.push(...Un);
    });
    Ca(this, "addPrevMouseDownListeners", (...Un) => {
      this.prevMouseDownListeners.push(...Un);
    });
    Ca(this, "callClick", () => {
      this.prevMouseDownListeners.forEach((Un) => {
        Un();
      }), this.onClick(), this.postMouseDownListeners.forEach((Un) => {
        Un();
      });
    });
    Ca(this, "getUIElements", () => [...this.items]);
    Ca(this, "onClick", () => {
      if (!this.isEnableFocus()) {
        this.enableFocus();
        return;
      }
      this.disableFocus();
    });
    this.postMouseDownListeners = [], this.postMouseUpListeners = [], this.prevMouseDownListeners = [], this.prevMouseUpListeners = [], this.area = new SpatialComboBoxArea(this);
  }
}
class ComboBoxFontFamily extends UIBaseComboBox {
  constructor() {
    super(), this.setConfiguration((Un) => ({
      ...Un,
      maxHeightMenuItems: 340,
      height: 34,
      borderColor: UIDefaultColor.GRAY_100,
      borderColorHover: UIDefaultColor.GRAY_600,
      fillHover: "white",
      width: 145,
      widthMenuItems: 145
    }));
    const zn = [];
    Object.values(FontFamily).forEach((Un) => {
      zn.push(new ComboBoxItem(Un, Un));
    }), this.addPostInjectDependenciesListener((Un) => {
      zn.forEach((Kn) => {
        Kn.forceInjectDependencies({
          render: Un.render
        }), Kn.addPostMouseDownListeners(Un.useCases.setFocusTextFontFamily);
      }), this.addItems(...zn);
    });
  }
}
class ComboBoxFontLineHeight extends UIBaseComboBox {
  constructor() {
    super(), this.setConfiguration((Un) => ({
      ...Un,
      maxHeightMenuItems: 306,
      height: 34,
      borderColor: "transparent",
      borderColorHover: UIDefaultColor.GRAY_600,
      fillHover: "white",
      width: 60,
      widthMenuItems: 60,
      isEnableSvg: !0,
      isEnableText: !1,
      svgColor: UIDefaultColor.GRAY_600,
      isEnableScrollBar: !1
    }));
    const zn = [];
    this.addPostInjectDependenciesListener((Un) => {
      Object.values(LineHeight).filter((Kn) => typeof Kn == "number").forEach((Kn) => {
        const qn = new ComboBoxItem(Kn.toString(), Kn);
        qn.addPostMouseDownListeners(Un.useCases.setFocusTextLineHeight), zn.push(qn);
      }), zn.forEach((Kn) => {
        Kn.forceInjectDependencies({
          render: Un.render
        });
      }), this.addItems(...zn);
    });
  }
}
class ComboBoxFontSize extends UIBaseComboBox {
  constructor() {
    super(), this.setConfiguration((Un) => ({
      ...Un,
      maxHeightMenuItems: 340,
      height: 34,
      borderColor: UIDefaultColor.GRAY_100,
      borderColorHover: UIDefaultColor.GRAY_600,
      fillHover: "white",
      width: 60,
      widthMenuItems: 60
    }));
    const zn = [];
    Object.values(FontSize).forEach((Un) => {
      const Kn = Number.parseInt(Un.slice(0, -2), 10).toString();
      zn.push(new ComboBoxItem(Kn, Un));
    }), this.addPostInjectDependenciesListener((Un) => {
      const { useCases: Kn, render: qn } = Un;
      zn.forEach((Jo) => {
        Jo.forceInjectDependencies({ render: qn }), Jo.addPostMouseDownListeners(Kn.setFocusTextFontSize);
      }), this.addItems(...zn);
    });
  }
}
class TextBoldButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: UIDefaultColor.GRAY_600,
      borderRadius: 4,
      fillHover: UIDefaultColor.WHITE,
      fillFocus: UIDefaultColor.BLUE_300,
      svgColorHover: UIDefaultColor.GRAY_600,
      svgColorFocus: UIDefaultColor.BLUE_900,
      svgScale: ScaleSvg.WIDTH,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.FONT_BOLD),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 18,
      size: {
        width: 32,
        height: 32
      },
      text: null,
      insideTextToSvg: 0,
      padding: "center"
    })), this.enableClickFocus(), this.disableResetFocus();
  }
}
class TextCenterTextButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: UIDefaultColor.GRAY_600,
      borderRadius: 4,
      fillHover: UIDefaultColor.WHITE,
      fillFocus: UIDefaultColor.BLUE_300,
      svgColorHover: UIDefaultColor.GRAY_600,
      svgColorFocus: UIDefaultColor.BLUE_900,
      svgScale: ScaleSvg.HEIGHT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TEXT_ALIGN_CENTER),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 14,
      size: {
        width: 32,
        height: 32
      },
      text: null,
      insideTextToSvg: 0,
      padding: "center",
      isDisableFocusClick: !1
    })), this.enableClickFocus(), this.addPostInjectDependenciesListener((zn) => {
      this.addPostMouseDownListeners(zn.useCases.setFocusTextAlign.bind(this, TextAlign.CENTER));
    });
  }
}
class TextColorInput extends ColorInput {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      padding: 10
    })), this.addPostInjectDependenciesListener((zn) => {
      this.setSelectColorListener(zn.useCases.setFocusTextColor);
    });
  }
}
class TextItalicButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: UIDefaultColor.GRAY_600,
      borderRadius: 4,
      fillHover: UIDefaultColor.WHITE,
      fillFocus: UIDefaultColor.BLUE_300,
      svgColorHover: UIDefaultColor.GRAY_600,
      svgColorFocus: UIDefaultColor.BLUE_900,
      svgScale: ScaleSvg.WIDTH,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.FONT_ITALIC),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 14,
      size: {
        width: 32,
        height: 32
      },
      text: null,
      insideTextToSvg: 0,
      padding: "center"
    })), this.enableClickFocus(), this.disableResetFocus();
  }
}
class TextJustifyButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: UIDefaultColor.GRAY_600,
      borderRadius: 4,
      fillHover: UIDefaultColor.WHITE,
      fillFocus: UIDefaultColor.BLUE_300,
      svgColorHover: UIDefaultColor.GRAY_600,
      svgColorFocus: UIDefaultColor.BLUE_900,
      svgScale: ScaleSvg.HEIGHT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TEXT_ALIGN_JUSTIFY),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 14,
      size: {
        width: 32,
        height: 32
      },
      text: null,
      insideTextToSvg: 0,
      padding: "center",
      isDisableFocusClick: !1
    })), this.enableClickFocus(), this.addPostInjectDependenciesListener((zn) => {
      this.addPostMouseDownListeners(zn.useCases.setFocusTextAlign.bind(this, TextAlign.JUSTIFY));
    });
  }
}
class TextLeftTextButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: UIDefaultColor.GRAY_600,
      borderRadius: 4,
      fillHover: UIDefaultColor.WHITE,
      fillFocus: UIDefaultColor.BLUE_300,
      svgColorHover: null,
      svgColorFocus: UIDefaultColor.BLUE_900,
      svgScale: ScaleSvg.HEIGHT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TEXT_ALIGN_LEFT),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 14,
      size: {
        width: 32,
        height: 32
      },
      text: null,
      insideTextToSvg: 0,
      padding: "center",
      isDisableFocusClick: !1
    })), this.enableClickFocus(), this.addPostInjectDependenciesListener((zn) => {
      this.addPostMouseDownListeners(zn.useCases.setFocusTextAlign.bind(this, TextAlign.LEFT));
    });
  }
}
class TextRightTextButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: UIDefaultColor.GRAY_600,
      borderRadius: 4,
      fillHover: UIDefaultColor.WHITE,
      fillFocus: UIDefaultColor.BLUE_300,
      svgColorHover: UIDefaultColor.GRAY_600,
      svgColorFocus: UIDefaultColor.BLUE_900,
      svgScale: ScaleSvg.HEIGHT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TEXT_ALIGN_RIGHT),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 14,
      size: {
        width: 32,
        height: 32
      },
      text: null,
      insideTextToSvg: 0,
      padding: "center",
      isDisableFocusClick: !1
    })), this.enableClickFocus(), this.addPostInjectDependenciesListener((zn) => {
      this.addPostMouseDownListeners(zn.useCases.setFocusTextAlign.bind(this, TextAlign.RIGHT));
    });
  }
}
class PropertyTextBarView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_TOP", 220);
    Ca(this, "DEFAULT_MARGIN_RIGHT", 20);
    Ca(this, "DEFAULT_PADDING", 24);
    Ca(this, "DEFAULT_MARGIN_BOTTOM_OBJECTS", 20);
    Ca(this, "DEFAULT_TITLE", "Текст");
    Ca(this, "DEFAULT_WIDTH_BAR", 320);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_HEIGHT_BLOCK", 32);
    Ca(this, "DEFAULT_BUTTON_PADDING", 20);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "DEFAULT_MARGIN_SIDE_BUTTON", 8);
    Ca(this, "container");
    Ca(this, "title");
    Ca(this, "uiButton");
    Ca(this, "buttons");
    Ca(this, "comboBoxFontFamily");
    Ca(this, "comboBoxFontSize");
    Ca(this, "comboBoxLineHeight");
    Ca(this, "colorInput");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.title.object.visible = !0, this.colorInput.show(), this.comboBoxFontSize.show(), this.comboBoxLineHeight.show(), this.comboBoxFontFamily.show(), this.buttons.forEach((Un) => {
        Un.show();
      }));
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.title.object.visible = !1, this.colorInput.hide(), this.comboBoxFontSize.hide(), this.comboBoxFontFamily.hide(), this.comboBoxLineHeight.hide(), this.buttons.forEach((Un) => {
        Un.hide();
      }));
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getUIElements", () => [
      this.colorInput,
      this.comboBoxFontSize,
      this.comboBoxFontFamily,
      this.comboBoxLineHeight,
      this.uiButton.leftText,
      this.uiButton.centerText,
      this.uiButton.rightText,
      this.uiButton.justifyText,
      this.uiButton.boldText,
      this.uiButton.italicText
    ]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.colorInput.isEnableFocus() && Un.push(this.colorInput), this.comboBoxFontSize.isEnableFocus() && Un.push(this.comboBoxFontSize), this.comboBoxFontFamily.isEnableFocus() && Un.push(this.comboBoxFontFamily), this.comboBoxLineHeight.isEnableFocus() && Un.push(this.comboBoxLineHeight), this.uiButton.boldText.isEnableFocus() && Un.push(this.uiButton.boldText), this.uiButton.italicText.isEnableFocus() && Un.push(this.uiButton.italicText), Un;
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration;
      this.configuration = Un(Kn), this.sync();
    });
    /**
     * Возвращает все объекты `FabricObject` из которых он состоит.
     */
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.title.object,
      ...this.colorInput.getFabricObjects(),
      ...this.uiButton.leftText.getFabricObjects(),
      ...this.uiButton.centerText.getFabricObjects(),
      ...this.uiButton.rightText.getFabricObjects(),
      ...this.uiButton.justifyText.getFabricObjects(),
      ...this.uiButton.boldText.getFabricObjects(),
      ...this.uiButton.italicText.getFabricObjects(),
      ...this.comboBoxFontSize.getFabricObjects(),
      ...this.comboBoxFontFamily.getFabricObjects(),
      ...this.comboBoxLineHeight.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.title,
      ...this.colorInput.getObjects(),
      ...this.uiButton.leftText.getObjects(),
      ...this.uiButton.centerText.getObjects(),
      ...this.uiButton.rightText.getObjects(),
      ...this.uiButton.justifyText.getObjects(),
      ...this.uiButton.boldText.getObjects(),
      ...this.uiButton.italicText.getObjects()
    ]);
    Ca(this, "getContainer", () => this.container.object);
    Ca(this, "getContentElements", () => [
      this.title.object,
      ...this.colorInput.getFabricObjects(),
      ...this.uiButton.leftText.getFabricObjects(),
      ...this.uiButton.centerText.getFabricObjects(),
      ...this.uiButton.rightText.getFabricObjects(),
      ...this.uiButton.justifyText.getFabricObjects(),
      ...this.uiButton.boldText.getFabricObjects(),
      ...this.uiButton.italicText.getFabricObjects(),
      ...this.comboBoxLineHeight.getFabricObjects(),
      ...this.comboBoxFontSize.getFabricObjects(),
      ...this.comboBoxFontFamily.getFabricObjects()
    ]);
    Ca(this, "getHeight", () => {
      const { padding: Un, marginBottomObjects: Kn, heightBlock: qn } = this.configuration;
      return Un * 2 + Kn * 2 + this.title.object.height + qn * 2;
    });
    Ca(this, "getRelativePosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    Ca(this, "getGlobalPosition", () => {
      const { marginTop: Un, marginRight: Kn, width: qn } = this.configuration;
      return {
        x: this.dependencies.render.getWidth() - Kn - qn,
        y: Un
      };
    });
    Ca(this, "syncComponent", (Un) => {
      const Kn = Un.map((xa) => xa.getTextModel()), Jo = this.dependencies.textEngine.getModelParents().map((xa) => xa.getTextModel()).filter((xa) => Kn.includes(xa));
      if (Jo.length > 0) {
        const xa = Jo[0], wa = xa.getColorToCarriagePosition(), Ta = xa.getFontSizeToCarriagePosition(), Sa = xa.getFontFamilyToCarriagePosition();
        switch (this.colorInput.setCurrentColor(wa), this.colorInput.syncActiveColors(wa), this.comboBoxFontSize.setCurrentItemToValue(Ta), this.comboBoxFontFamily.setCurrentItemToValue(Sa), xa.getTexture().textAlign) {
          case TextAlign.LEFT: {
            this.uiButton.leftText.enableFocus(), this.uiButton.rightText.disableFocus(), this.uiButton.centerText.disableFocus(), this.uiButton.justifyText.disableFocus();
            break;
          }
          case TextAlign.RIGHT: {
            this.uiButton.rightText.enableFocus(), this.uiButton.leftText.disableFocus(), this.uiButton.centerText.disableFocus(), this.uiButton.justifyText.disableFocus();
            break;
          }
          case TextAlign.CENTER: {
            this.uiButton.centerText.enableFocus(), this.uiButton.rightText.disableFocus(), this.uiButton.leftText.disableFocus(), this.uiButton.justifyText.disableFocus();
            break;
          }
          case TextAlign.JUSTIFY: {
            this.uiButton.justifyText.enableFocus(), this.uiButton.rightText.disableFocus(), this.uiButton.centerText.disableFocus(), this.uiButton.leftText.disableFocus();
            break;
          }
        }
        switch (xa.getFontFormatToCarriagePosition()) {
          case TokenFormat.Bold: {
            this.uiButton.boldText.enableFocus();
            break;
          }
          case TokenFormat.Italic: {
            this.uiButton.italicText.enableFocus();
            break;
          }
          case TokenFormat.BoldItalic: {
            this.uiButton.boldText.enableFocus(), this.uiButton.italicText.enableFocus();
            break;
          }
          case TokenFormat.None: {
            this.uiButton.boldText.disableFocus(), this.uiButton.italicText.disableFocus();
            break;
          }
        }
        return;
      }
      const pa = [...new Set(Kn.flatMap((xa) => xa.getColorsTokens()))];
      pa.length === 1 ? (this.colorInput.setCurrentColor(pa[0]), this.colorInput.syncActiveColors(pa[0])) : (this.colorInput.setCurrentColor(UIDefaultColor.BLACK), this.colorInput.syncActiveColors(UIDefaultColor.BLACK));
      const ma = [...new Set(Kn.flatMap((xa) => xa.getFontSizeTokens()))];
      ma.length === 1 ? this.comboBoxFontSize.setCurrentItemToValue(ma[0]) : this.comboBoxFontSize.disableCurrentItem();
      const va = [...new Set(Kn.flatMap((xa) => xa.getFontFamilyTokens()))];
      va.length === 1 ? this.comboBoxFontFamily.setCurrentItemToValue(va[0]) : this.comboBoxFontFamily.disableCurrentItem();
      const ba = [...new Set(Kn.flatMap((xa) => xa.getTexture().lineHeight))];
      ba.length === 1 ? this.comboBoxLineHeight.setCurrentItemToValue(ba[0]) : this.comboBoxLineHeight.disableCurrentItem();
      const _a = [...new Set(Kn.flatMap((xa) => xa.getFontFormatTokens()))];
      if (ba.length === 1)
        switch (_a[0]) {
          case TokenFormat.Bold: {
            this.uiButton.boldText.enableFocus();
            break;
          }
          case TokenFormat.Italic: {
            this.uiButton.italicText.enableFocus();
            break;
          }
          case TokenFormat.BoldItalic: {
            this.uiButton.boldText.enableFocus(), this.uiButton.italicText.enableFocus();
            break;
          }
          case TokenFormat.None: {
            this.uiButton.boldText.disableFocus(), this.uiButton.italicText.disableFocus();
            break;
          }
        }
      else
        this.uiButton.boldText.disableFocus(), this.uiButton.italicText.disableFocus();
      const ya = [...new Set(Kn.flatMap((xa) => xa.getTexture().textAlign))];
      if (ya.length === 1)
        switch (ya[0]) {
          case TextAlign.LEFT: {
            this.uiButton.leftText.enableFocus(), this.uiButton.rightText.disableFocus(), this.uiButton.centerText.disableFocus(), this.uiButton.justifyText.disableFocus();
            break;
          }
          case TextAlign.RIGHT: {
            this.uiButton.rightText.enableFocus(), this.uiButton.leftText.disableFocus(), this.uiButton.centerText.disableFocus(), this.uiButton.justifyText.disableFocus();
            break;
          }
          case TextAlign.CENTER: {
            this.uiButton.centerText.enableFocus(), this.uiButton.rightText.disableFocus(), this.uiButton.leftText.disableFocus(), this.uiButton.justifyText.disableFocus();
            break;
          }
          case TextAlign.JUSTIFY: {
            this.uiButton.justifyText.enableFocus(), this.uiButton.rightText.disableFocus(), this.uiButton.centerText.disableFocus(), this.uiButton.leftText.disableFocus();
            break;
          }
        }
      else
        this.uiButton.centerText.disableFocus(), this.uiButton.rightText.disableFocus(), this.uiButton.leftText.disableFocus(), this.uiButton.justifyText.disableFocus();
    });
    Ca(this, "syncPosition", () => {
      this.sync();
    });
    Ca(this, "sync", () => {
      const {
        marginTop: Un,
        marginRight: Kn,
        width: qn,
        padding: Jo,
        marginBottomObjects: pa,
        fill: ma,
        cornerRadius: va,
        heightBlock: ba,
        titleFontSize: _a,
        marginSideButton: ya
      } = this.configuration, xa = this.dependencies.render.getWidth() - Kn - qn;
      this.container.object.set({
        width: qn,
        height: this.getHeight(),
        fill: ma,
        rx: va,
        ry: va
      }), this.container.relativePosition = {
        x: xa,
        y: Un
      }, this.title.object.set({
        fontSize: _a,
        fontFamily: FontFamily.DEFAULT
      }), this.title.relativePosition = {
        x: xa + Jo,
        y: Un + Jo
      };
      const wa = Jo + this.title.object.height + pa;
      this.comboBoxFontFamily.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo,
        y: wa
      })), this.comboBoxFontSize.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + this.comboBoxFontFamily.getWidth() + ya * 2,
        y: wa
      })), this.colorInput.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + this.comboBoxFontFamily.getWidth() + ya * 2 + this.comboBoxFontSize.getWidth() + ya * 2,
        y: wa,
        size: ba
      }));
      const Ta = Jo + this.title.object.height + pa + ba + pa;
      this.uiButton.leftText.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo,
        y: Ta
      })), this.uiButton.centerText.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + (ba + ya),
        y: Ta,
        size: {
          width: ba,
          height: ba
        },
        svgSize: 14
      })), this.uiButton.rightText.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + (ba + ya) * 2,
        y: Ta,
        size: {
          width: ba,
          height: ba
        },
        svgSize: 14
      })), this.uiButton.justifyText.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + (ba + ya) * 3,
        y: Ta,
        size: {
          width: ba,
          height: ba
        },
        svgSize: 14
      })), this.comboBoxLineHeight.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + (ba + ya) * 4,
        y: Ta,
        width: ba,
        height: ba,
        widthMenuItems: 60
      })), this.uiButton.boldText.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + (ba + ya) * 5,
        y: Ta,
        size: {
          width: ba,
          height: ba
        }
      })), this.uiButton.italicText.setConfiguration((Sa) => ({
        ...Sa,
        x: Jo + (ba + ya) * 6,
        y: Ta,
        size: {
          width: ba,
          height: ba
        },
        svgSize: 14
      })), this.dependencies.render.renderUnstructured(), this.dependencies.render.renderRelativePositions();
    });
    this.isShow = !1, this.isResetFocus = !0, this.configuration = {
      marginTop: this.DEFAULT_MARGIN_TOP,
      marginRight: this.DEFAULT_MARGIN_RIGHT,
      width: this.DEFAULT_WIDTH_BAR,
      padding: this.DEFAULT_PADDING,
      marginBottomObjects: this.DEFAULT_MARGIN_BOTTOM_OBJECTS,
      fill: UIDefaultColor.WHITE,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      heightBlock: this.DEFAULT_HEIGHT_BLOCK,
      buttonPadding: this.DEFAULT_BUTTON_PADDING,
      marginSideButton: this.DEFAULT_MARGIN_SIDE_BUTTON
    }, this.container = {
      object: new pr({
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo(this.DEFAULT_TITLE, {
        fill: UIDefaultColor.GRAY_900,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.uiButton = {
      leftText: new TextLeftTextButton(),
      centerText: new TextCenterTextButton(),
      rightText: new TextRightTextButton(),
      justifyText: new TextJustifyButton(),
      boldText: new TextBoldButton(),
      italicText: new TextItalicButton()
    }, this.buttons = [
      this.uiButton.leftText,
      this.uiButton.centerText,
      this.uiButton.rightText,
      this.uiButton.justifyText,
      this.uiButton.boldText,
      this.uiButton.italicText
    ], this.colorInput = new TextColorInput(), this.comboBoxFontFamily = new ComboBoxFontFamily(), this.comboBoxFontSize = new ComboBoxFontSize(), this.comboBoxLineHeight = new ComboBoxFontLineHeight(), this.comboBoxLineHeight.setSvg(SVGCanvasStore.getSvg(SVGCollection.TEXT_ALIGN_HEIGHT));
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class PropertyTextBar extends PropertyTextBarView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "onFormatTextBold", () => {
      this.uiButton.boldText.isEnableFocus() ? this.uiButton.italicText.isEnableFocus() ? this.dependencies.useCases.setFocusTextFormatItalicAndBold() : this.dependencies.useCases.setFocusTextFormatBold() : this.uiButton.italicText.isEnableFocus() ? this.dependencies.useCases.setFocusTextFormatItalic() : this.dependencies.useCases.setFocusTextFormatNone();
    });
    Ca(this, "onFormatTextItalic", () => {
      this.uiButton.italicText.isEnableFocus() ? this.uiButton.boldText.isEnableFocus() ? this.dependencies.useCases.setFocusTextFormatItalicAndBold() : this.dependencies.useCases.setFocusTextFormatItalic() : this.uiButton.boldText.isEnableFocus() ? this.dependencies.useCases.setFocusTextFormatBold() : this.dependencies.useCases.setFocusTextFormatNone();
    });
    this.area = new SpatialUIPanelArea(this), this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, useCases: qn, core: Jo } = Un;
      this.uiButton.leftText.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.uiButton.centerText.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.uiButton.rightText.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.uiButton.justifyText.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.uiButton.boldText.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.uiButton.italicText.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.buttons.forEach((pa) => pa.hide()), this.colorInput.forceInjectDependencies({
        render: Kn,
        useCases: qn,
        core: Jo
      }), this.colorInput.hide(), this.comboBoxFontFamily.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.comboBoxFontFamily.hide(), this.comboBoxFontSize.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.comboBoxFontSize.hide(), this.comboBoxLineHeight.forceInjectDependencies({
        render: Kn,
        useCases: qn
      }), this.comboBoxLineHeight.hide(), this.uiButton.boldText.addPostMouseDownListeners(this.onFormatTextBold), this.uiButton.italicText.addPostMouseDownListeners(this.onFormatTextItalic);
    });
  }
  callClick() {
  }
}
class SpatialUISocketIndicatorArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.SOCKET_INDICATOR);
    Ca(this, "getGlobalFrameArea", () => this.socketIndicator.getFrameArea());
    Ca(this, "getData", () => this.socketIndicator);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.socketIndicator = Un;
  }
}
const UIShadowDefault = {
  color: UIDefaultColor.SHADOW,
  blur: 5,
  offsetX: 0,
  offsetY: 0,
  affectStroke: !1,
  includeDefaultValues: !0,
  nonScaling: !1
};
var SocketIndicatorState = /* @__PURE__ */ ((Xn) => (Xn.SUCCESS = "success", Xn.LOADING = "loading", Xn.ERROR = "error", Xn))(SocketIndicatorState || {});
class UISocketIndicator extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN", 20);
    Ca(this, "DEFAULT_HEIGHT", 35);
    Ca(this, "DEFAULT_WIDTH", 130);
    Ca(this, "DEFAULT_SVG_SIZE", 20);
    Ca(this, "DEFAULT_PADDING_HORIZONTAL", 8);
    Ca(this, "DEFAULT_TITLE_SUCCESS", "Сохранено");
    Ca(this, "DEFAULT_TITLE_LOADING", "Сохраняется");
    Ca(this, "DEFAULT_TITLE_ERROR", "Ошибка");
    Ca(this, "container");
    Ca(this, "title");
    Ca(this, "loader");
    Ca(this, "success");
    Ca(this, "error");
    Ca(this, "area");
    Ca(this, "state");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.set({
        visible: !0
      }), this.success.object.set({
        visible: !0
      }), this.error.object.set({
        visible: !0
      }), this.loader.object.set({
        visible: !0
      }), this.title.object.set({
        visible: !0
      }));
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.set({
        visible: !1
      }), this.success.object.set({
        visible: !1
      }), this.error.object.set({
        visible: !1
      }), this.loader.object.set({
        visible: !1
      }), this.title.object.set({
        visible: !1
      }));
    });
    Ca(this, "setState", (Un) => {
      this.state = Un, this.sync();
    });
    Ca(this, "getFabricObject", () => [
      this.container.object,
      this.title.object,
      this.loader.object,
      this.success.object,
      this.error.object
    ]);
    Ca(this, "getObjects", () => [this.container, this.title, this.loader, this.success, this.error]);
    Ca(this, "sync", () => {
      const Un = this.dependencies.render.getHeight();
      switch (this.container.relativePosition = {
        x: this.DEFAULT_MARGIN,
        y: Un - this.DEFAULT_MARGIN - this.DEFAULT_HEIGHT
      }, this.state) {
        case "success": {
          this.title.object.set({
            text: this.DEFAULT_TITLE_SUCCESS
          }), this.loader.object.set({
            visible: !1
          }), this.error.object.set({
            visible: !1
          }), this.success.object.set({
            visible: !0
          });
          break;
        }
        case "loading": {
          this.title.object.set({
            text: this.DEFAULT_TITLE_LOADING
          }), this.success.object.set({
            visible: !1
          }), this.error.object.set({
            visible: !1
          }), this.loader.object.set({
            visible: !0
          }), this.animateRotateObject(this.loader.object);
          break;
        }
        case "error": {
          this.title.object.set({
            text: this.DEFAULT_TITLE_ERROR
          }), this.success.object.set({
            visible: !1
          }), this.error.object.set({
            visible: !0
          }), this.loader.object.set({
            visible: !1
          });
          break;
        }
      }
      this.success.relativePosition = {
        x: this.DEFAULT_MARGIN + this.DEFAULT_PADDING_HORIZONTAL,
        y: Math.round(
          Un - this.DEFAULT_MARGIN - this.DEFAULT_HEIGHT + (this.DEFAULT_HEIGHT / 2 - this.DEFAULT_SVG_SIZE / 2)
        )
      }, this.error.relativePosition = {
        x: this.DEFAULT_MARGIN + this.DEFAULT_PADDING_HORIZONTAL,
        y: Math.round(
          Un - this.DEFAULT_MARGIN - this.DEFAULT_HEIGHT + (this.DEFAULT_HEIGHT / 2 - this.DEFAULT_SVG_SIZE / 2)
        )
      }, this.loader.relativePosition = {
        x: this.DEFAULT_MARGIN + this.DEFAULT_PADDING_HORIZONTAL + this.DEFAULT_SVG_SIZE / 2,
        y: Math.round(
          Un - this.DEFAULT_MARGIN - this.DEFAULT_HEIGHT + (this.DEFAULT_HEIGHT / 2 - this.DEFAULT_SVG_SIZE / 2) + this.DEFAULT_SVG_SIZE / 2
        )
      }, this.title.relativePosition = {
        x: this.DEFAULT_MARGIN + this.DEFAULT_PADDING_HORIZONTAL * 2 + this.DEFAULT_SVG_SIZE,
        y: Math.round(
          Un - this.DEFAULT_MARGIN - this.DEFAULT_HEIGHT + (this.DEFAULT_HEIGHT / 2 - this.title.object.height / 2)
        )
      }, this.dependencies.render.renderUnstructured();
    });
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getRelativePosition", () => ({
      x: this.container.relativePosition.x,
      y: this.container.relativePosition.y
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "animateRotateObject", (Un) => {
      const Kn = () => {
        if (this.state === "success")
          return;
        const qn = Un.angle ?? 0, Jo = qn + 360;
        un.animate({
          startValue: qn,
          endValue: Jo,
          duration: 2500,
          onChange: (pa) => {
            Un.set("angle", pa), this.dependencies.render.renderUnstructured();
          },
          onComplete: () => {
            Kn();
          }
        });
      };
      Kn();
    });
    this.area = new SpatialUISocketIndicatorArea(this), this.isShow = !1, this.isResetFocus = !0, this.container = {
      object: new pr({
        shadow: UIShadowDefault,
        fill: UIDefaultColor.WHITE,
        height: this.DEFAULT_HEIGHT,
        width: this.DEFAULT_WIDTH,
        rx: 8,
        ry: 8,
        opacity: 0.6,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo("Сохранено", { fontFamily: FontFamily.DEFAULT, visible: !1, fontSize: 14, opacity: 0.6 }),
      relativePosition: { x: 0, y: 0 }
    }, this.loader = {
      object: SVGCanvasStore.getSvgGroup(SVGCollection.LOADER),
      relativePosition: { x: 0, y: 0 }
    };
    const Un = this.DEFAULT_SVG_SIZE / this.loader.object.height;
    this.loader.object.set({
      scaleX: Un,
      scaleY: Un,
      opacity: 0.6,
      originX: "center",
      originY: "center",
      visible: !1
    }), this.success = {
      object: SVGCanvasStore.getSvg(SVGCollection.GREEN_SAVED_CIRCLE),
      relativePosition: { x: 0, y: 0 }
    }, this.success.object.scaleToHeight(this.DEFAULT_SVG_SIZE), this.success.object.set({
      visible: !1,
      fill: UIDefaultColor.GREEN_500,
      opacity: 0.6
    }), this.error = {
      object: SVGCanvasStore.getSvg(SVGCollection.CANCELED),
      relativePosition: { x: 0, y: 0 }
    }, this.error.object.scaleToHeight(this.DEFAULT_SVG_SIZE), this.error.object.set({
      visible: !1,
      fill: "#FF0000",
      opacity: 0.6
    }), this.state = "success";
  }
  getUIElements() {
    return [];
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  callClick() {
  }
  disableFocus() {
  }
  disableHover() {
  }
  enableFocus() {
  }
  enableHover() {
  }
  getFabricObjects() {
    return [];
  }
}
class SpatialGridTableCellArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.GRID_TABLE_CELL);
    Ca(this, "getGlobalFrameArea", () => this.cell.getFrameArea());
    Ca(this, "getData", () => this.cell);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.cell = Un;
  }
}
class GridTableSizeCell extends Dependent {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "object");
    Ca(this, "configuration");
    Ca(this, "onClick");
    Ca(this, "onMove");
    Ca(this, "isVisible");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.object.object.left,
      y: this.object.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "getSize", () => this.configuration.size);
    Ca(this, "setOnMove", (Un) => {
      this.onMove = Un;
    });
    Ca(this, "setOnClick", (Un) => {
      this.onClick = Un;
    });
    Ca(this, "callClick", () => {
      this.onClick && this.onClick(this.dependencies.coords.y + 1, this.dependencies.coords.x + 1);
    });
    Ca(this, "enableHover", () => {
      if (this.isHover)
        return;
      this.isHover = !0;
      const { fillHover: Un, borderColorHover: Kn } = this.configuration;
      this.object.object.set({
        fill: Un,
        stroke: Kn
      }), this.dependencies.render.renderUnstructured(), this.onMove && this.onMove(this.dependencies.coords.y, this.dependencies.coords.x);
    });
    Ca(this, "disableHover", () => {
      if (!this.isHover)
        return;
      this.isHover = !1;
      const { fill: Un, fillFocus: Kn, borderColor: qn, borderColorFocus: Jo } = this.configuration;
      this.isFocus ? this.object.object.set({
        fill: Kn,
        stroke: Jo
      }) : this.object.object.set({
        fill: Un,
        stroke: qn
      }), this.dependencies.render.renderUnstructured();
    });
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.object.object.visible = !0);
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.object.object.visible = !1);
    });
    Ca(this, "getFrameArea", () => ({
      x: this.object.object.left,
      y: this.object.object.top,
      width: this.object.object.width + 2,
      height: this.object.object.height + 2,
      rotate: 0
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "getUIElements", () => []);
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      this.object.object.set({
        width: qn.size,
        height: qn.size
      }), this.object.relativePosition = {
        x: qn.x,
        y: qn.y
      }, !this.isFocus && !this.isHover && this.object.object.set({
        fill: qn.fill,
        stroke: qn.borderColor
      }), this.configuration = qn;
    });
    Ca(this, "getFabricObjects", () => [this.object.object]);
    Ca(this, "getObjects", () => [this.object]);
    Ca(this, "isEnableFocus", () => this.isFocus);
    Ca(this, "isEnableHover", () => this.isHover);
    Ca(this, "isShowed", () => this.isVisible);
    Ca(this, "enableFocus", () => {
      if (this.isFocus)
        return;
      this.isFocus = !0;
      const { fillFocus: Un, borderColorFocus: Kn } = this.configuration;
      this.object.object.set({
        fill: Un,
        stroke: Kn
      }), this.dependencies.render.renderUnstructured();
    });
    Ca(this, "disableFocus", () => {
      if (!this.isFocus)
        return;
      this.isFocus = !1;
      const { fill: Un, borderColor: Kn } = this.configuration;
      this.object.object.set({
        fill: Un,
        stroke: Kn
      }), this.dependencies.render.renderUnstructured();
    });
    this.area = new SpatialGridTableCellArea(this), this.isVisible = !1, this.isHover = !1, this.isFocus = !1, this.onClick = null, this.onMove = null, this.isResetFocus = !1, this.configuration = {
      fill: UIDefaultColor.WHITE,
      fillHover: "#d6e9ff",
      fillFocus: "#d6e9ff",
      borderColor: "#a6a6a6",
      borderColorHover: "#0075ff",
      borderColorFocus: "#0075ff",
      size: 20,
      x: 0,
      y: 0
    }, this.object = {
      object: new pr({
        width: this.configuration.size,
        height: this.configuration.size,
        fill: this.configuration.fill,
        stroke: this.configuration.borderColor,
        strokeWidth: 1,
        rx: 2,
        ry: 2,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    };
  }
}
class GridTableSize extends Dependent {
  constructor() {
    super();
    Ca(this, "sizeBoxes");
    Ca(this, "configuration");
    Ca(this, "setPosition", (Un) => {
      this.configuration.x = Un.x, this.configuration.y = Un.y;
      for (let Kn = 0; Kn < this.configuration.rows; Kn++)
        for (let qn = 0; qn < this.configuration.columns; qn++)
          this.sizeBoxes[Kn][qn].setConfiguration((pa) => ({
            ...pa,
            x: this.configuration.x + qn * (this.configuration.sizeCell + this.configuration.marginCells),
            y: this.configuration.y + Kn * (this.configuration.sizeCell + this.configuration.marginCells)
          }));
    });
    Ca(this, "getWidth", () => {
      let Un = 0;
      for (let Kn = 0; Kn < this.configuration.columns; Kn++)
        Un += this.configuration.sizeCell + this.configuration.marginCells;
      return Un - this.configuration.marginCells;
    });
    Ca(this, "getHeight", () => {
      let Un = 0;
      for (let Kn = 0; Kn < this.configuration.rows; Kn++)
        Un += this.configuration.sizeCell + this.configuration.marginCells;
      return Un - this.configuration.marginCells;
    });
    Ca(this, "getUIElements", () => [...this.sizeBoxes.flat()]);
    Ca(this, "tableGridConstruct", (Un, Kn) => {
      this.sizeBoxes[0][0].enableFocus();
      for (let qn = 0; qn < this.sizeBoxes.length; qn++)
        for (let Jo = 0; Jo < this.sizeBoxes[qn].length; Jo++)
          (qn > Un || Jo > Kn) && this.sizeBoxes[qn][Jo].disableFocus();
      for (let qn = 0; qn < this.sizeBoxes.length; qn++)
        for (let Jo = 0; Jo < this.sizeBoxes[qn].length; Jo++)
          qn <= Un && Jo <= Kn && this.sizeBoxes[qn][Jo].enableFocus();
      this.dependencies.currentTableSizeText.set({
        text: `${Un + 1} × ${Kn + 1}`
      });
    });
    Ca(this, "getFabricObjects", () => [
      ...this.sizeBoxes.flat().flatMap((Un) => Un.getFabricObjects())
    ]);
    Ca(this, "getObjects", () => [
      ...this.sizeBoxes.flat().flatMap((Un) => Un.getObjects())
    ]);
    Ca(this, "enableVisible", () => {
      this.sizeBoxes.flat().map((Un) => Un.show());
    });
    Ca(this, "disableVisible", () => {
      this.sizeBoxes.flat().map((Un) => Un.hide());
    });
    Ca(this, "onCellMouseClick", (Un, Kn) => {
      this.dependencies.tableConstructor.hide(), this.dependencies.useCases.createEmptyTable(Un, Kn);
    });
    Ca(this, "onCellMouseMove", (Un, Kn) => {
      this.tableGridConstruct(Un, Kn);
    });
    this.sizeBoxes = [], this.configuration = {
      x: 0,
      y: 0,
      rows: 10,
      columns: 10,
      sizeCell: 20,
      marginCells: 4
    }, this.addPostInjectDependenciesListener((Un) => {
      this.configuration.x = Un.position.x, this.configuration.y = Un.position.y;
      for (let Kn = 0; Kn < this.configuration.rows; Kn++) {
        const qn = [];
        for (let Jo = 0; Jo < this.configuration.columns; Jo++) {
          const pa = new GridTableSizeCell();
          pa.connectDependencies({
            render: this.dependencies.render,
            coords: { x: Jo, y: Kn }
          }), pa.injectDependencies(), pa.setConfiguration((ma) => ({
            ...ma,
            size: this.configuration.sizeCell,
            x: this.configuration.x + Jo * (this.configuration.sizeCell + this.configuration.marginCells),
            y: this.configuration.y + Kn * (this.configuration.sizeCell + this.configuration.marginCells)
          })), pa.setOnMove(this.onCellMouseMove), pa.setOnClick(this.onCellMouseClick), qn.push(pa);
        }
        this.sizeBoxes.push(qn);
      }
    });
  }
}
class ExcelButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TEXT", "Загрузить Excel-таблицу");
    this.setConfiguration((Un) => ({
      ...Un,
      text: this.TEXT,
      textColor: UIDefaultColor.GREEN_900,
      textColorHover: UIDefaultColor.GREEN_700,
      borderColor: "transparent",
      fill: "transparent",
      fillHover: null,
      borderColorHover: null,
      padding: {
        leftRight: 5,
        topBottom: 5
      },
      isEnableSvg: !0,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.EXCEL_LOADER),
        relativePosition: { x: 0, y: 0 }
      },
      svgColor: UIDefaultColor.GREEN_900,
      svgColorHover: UIDefaultColor.GREEN_700,
      isEnableFocusClick: !1
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.createTableFromXLSX);
    });
  }
}
class TableCustomButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TEXT", "Задать свои значения");
    this.setConfiguration((Un) => ({
      ...Un,
      text: this.TEXT,
      textColor: UIDefaultColor.BLUE_900,
      textColorHover: UIDefaultColor.BLUE_700,
      borderColor: "transparent",
      fill: "transparent",
      fillHover: "transparent",
      borderColorHover: "transparent",
      padding: {
        leftRight: 5,
        topBottom: 5
      },
      isEnableSvg: !0,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TABLE_CUSTOM_VALUES),
        relativePosition: { x: 0, y: 0 }
      },
      svgColor: UIDefaultColor.BLUE_900,
      svgColorHover: UIDefaultColor.BLUE_700
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(() => {
        Un.onOpenCreateCustomTableWindow();
      });
    });
  }
}
class TableConstructorView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_PADDING", 24);
    Ca(this, "DEFAULT_MARGIN_BOTTOM_OBJECTS", 10);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_BUTTON_GRID_SIZE", 20);
    Ca(this, "DEFAULT_BUTTON_GRID_PADDING", 4);
    Ca(this, "DEFAULT_FONT_SIZE", 16);
    Ca(this, "DEFAULT_CURRENT_TABLE_SIZE_TEXT", "1 × 1");
    Ca(this, "area");
    Ca(this, "container");
    Ca(this, "grid");
    Ca(this, "currentTableSizeText");
    Ca(this, "customTableButton");
    Ca(this, "downloadExcelTableButton");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.grid.enableVisible(), this.currentTableSizeText.object.visible = !0, this.customTableButton.show(), this.downloadExcelTableButton.show());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.grid.disableVisible(), this.currentTableSizeText.object.visible = !1, this.customTableButton.hide(), this.downloadExcelTableButton.hide(), this.dependencies.render.renderUnstructured());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getWidth", () => this.grid.getWidth() + this.configuration.padding * 2);
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getUIElements", () => [
      ...this.grid.getUIElements(),
      this.customTableButton,
      this.downloadExcelTableButton
    ]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.customTableButton.isEnableFocus() && Un.push(this.customTableButton), this.downloadExcelTableButton.isEnableFocus() && Un.push(this.downloadExcelTableButton), this.grid.getUIElements().forEach((Kn) => {
        Kn.isEnableFocus() && Un.push(Kn);
      }), Un;
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      this.configuration = qn, this.syncPosition();
    });
    /**
     * Возвращает все объекты `FabricObject` из которых он состоит.
     */
    Ca(this, "getObjects", () => [
      this.container,
      this.currentTableSizeText,
      ...this.customTableButton.getObjects(),
      ...this.downloadExcelTableButton.getObjects(),
      ...this.grid.getObjects()
    ]);
    /**
     * Возвращает все объекты `FabricObject` из которых он состоит.
     */
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.currentTableSizeText.object,
      ...this.customTableButton.getFabricObjects(),
      ...this.downloadExcelTableButton.getFabricObjects(),
      ...this.grid.getFabricObjects()
    ]);
    Ca(this, "getHeight", () => {
      const { padding: Un, marginBottomObjects: Kn } = this.configuration;
      return Un * 2 + Kn * 3 + this.currentTableSizeText.object.height + this.grid.getHeight() + this.customTableButton.getHeight() + this.downloadExcelTableButton.getHeight();
    });
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "syncPosition", () => {
      const { x: Un, y: Kn, padding: qn, fill: Jo, cornerRadius: pa, marginBottomObjects: ma, fontSize: va } = this.configuration;
      this.currentTableSizeText.object.set({
        fill: UIDefaultColor.GRAY_900,
        fontFamily: FontFamily.DEFAULT,
        fontSize: va
      }), this.currentTableSizeText.relativePosition = {
        x: Un + (this.getWidth() / 2 - this.currentTableSizeText.object.width / 2),
        y: Kn + qn
      }, this.container.object.set({
        width: this.getWidth(),
        height: this.getHeight(),
        fill: Jo,
        rx: pa,
        ry: pa
      }), this.container.relativePosition = {
        x: Un,
        y: Kn
      }, this.grid.setPosition({
        x: qn,
        y: qn + this.currentTableSizeText.object.height + ma
      }), this.customTableButton.setConfiguration((ba) => ({
        ...ba,
        x: qn,
        y: qn + this.currentTableSizeText.object.height + ma * 3 + this.grid.getHeight()
      })), this.downloadExcelTableButton.setConfiguration((ba) => ({
        ...ba,
        x: qn,
        y: qn + this.currentTableSizeText.object.height + ma * 4 + this.grid.getHeight() + this.customTableButton.getHeight()
      })), this.dependencies.render.forceRenderUnstructured();
    });
    Ca(this, "getSpatialArea", () => this.area);
    this.area = new SpatialUIPanelArea(this), this.grid = new GridTableSize(), this.customTableButton = new TableCustomButton(), this.downloadExcelTableButton = new ExcelButton(), this.isShow = !1, this.isResetFocus = !0, this.configuration = {
      padding: this.DEFAULT_PADDING,
      marginBottomObjects: this.DEFAULT_MARGIN_BOTTOM_OBJECTS,
      fill: UIDefaultColor.WHITE,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      fontSize: this.DEFAULT_FONT_SIZE,
      buttonGridSize: this.DEFAULT_BUTTON_GRID_SIZE,
      buttonGridPadding: this.DEFAULT_BUTTON_GRID_PADDING,
      x: 0,
      y: 0
    }, this.container = {
      object: new pr({
        fill: UIDefaultColor.WHITE,
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.currentTableSizeText = {
      object: new Xo(this.DEFAULT_CURRENT_TABLE_SIZE_TEXT, { visible: !1 }),
      relativePosition: { x: 0, y: 0 }
    }, this.addPostInjectDependenciesListener((Un) => {
      this.grid.forceInjectDependencies({
        render: Un.render,
        useCases: Un.useCases,
        tableConstructor: this,
        position: {
          x: 0,
          y: 0
        },
        currentTableSizeText: this.currentTableSizeText.object
      }), this.customTableButton.forceInjectDependencies({
        render: Un.render,
        onOpenCreateCustomTableWindow: Un.onOpenCreateCustomTableWindow
      }), this.downloadExcelTableButton.forceInjectDependencies({
        render: Un.render,
        useCases: Un.useCases
      });
    });
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
  callClick() {
  }
}
class SpatialTemplateMenuArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.TEMPLATE_MENU);
    Ca(this, "getGlobalFrameArea", () => this.templateMenu.getFrameArea());
    Ca(this, "getData", () => this.templateMenu);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.templateMenu = Un;
  }
}
class TemplateMenuOfferButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 38);
    Ca(this, "DEFAULT_WIDTH", 160);
    Ca(this, "TEXT", "Отправить КП");
    this.setConfiguration((Un) => ({
      ...Un,
      text: this.TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.OUTLINE_KP),
        relativePosition: { x: 0, y: 0 }
      },
      insideTextToSvg: 12,
      svgScale: ScaleSvg.HEIGHT,
      svgSize: 10,
      svgColor: UIDefaultColor.GREEN_500,
      svgColorHover: null,
      svgColorFocus: null,
      textColor: "#000000",
      textColorHover: null,
      textColorFocus: null,
      borderColor: "#ffffff",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: {
        topBottom: 12,
        leftRight: 16
      },
      borderColorHover: UIDefaultColor.GRAY_300,
      borderColorFocus: null,
      fillHover: UIDefaultColor.GRAY_300,
      fillFocus: null
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.onSendOffer);
    });
  }
}
class TemplateMenuPDFButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "DEFAULT_HEIGHT_BUTTON", 38);
    Ca(this, "DEFAULT_WIDTH", 160);
    Ca(this, "TEXT", "Скачать PDF");
    this.setConfiguration((Un) => ({
      ...Un,
      text: this.TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.PDF),
        relativePosition: { x: 0, y: 0 }
      },
      insideTextToSvg: 12,
      svgColor: UIDefaultColor.GRAY_900,
      textColor: "#000000",
      borderColor: "#ffffff",
      size: {
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT_BUTTON
      },
      padding: {
        topBottom: 12,
        leftRight: 16
      },
      svgScale: ScaleSvg.HEIGHT,
      svgColorHover: null,
      svgColorFocus: null,
      textColorHover: null,
      textColorFocus: null,
      borderColorHover: UIDefaultColor.GRAY_300,
      borderColorFocus: null,
      fillHover: UIDefaultColor.GRAY_300,
      fillFocus: null
    })), this.hide(), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.onDownloadPDF);
    });
  }
}
class PrivateTemplateTemplateMenu extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_FILL", UIDefaultColor.WHITE);
    Ca(this, "DEFAULT_PADDING_VERTICAL", 10);
    Ca(this, "DEFAULT_WIDTH", 160);
    Ca(this, "DEFAULT_HEIGHT", 50);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "container");
    Ca(this, "offerButton");
    Ca(this, "pdfButton");
    Ca(this, "area");
    Ca(this, "position");
    Ca(this, "isVisible");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "setPosition", (Un) => {
      this.container.object.set({
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_PADDING_VERTICAL * 2 + this.offerButton.getHeight() + this.pdfButton.getHeight()
      }), this.container.relativePosition = {
        x: Un.x - this.container.object.width,
        y: Un.y
      };
      let Kn = this.DEFAULT_PADDING_VERTICAL;
      this.offerButton.setConfiguration((qn) => ({
        ...qn,
        x: -this.container.object.width,
        y: this.DEFAULT_PADDING_VERTICAL
      })), Kn += this.offerButton.getHeight(), this.pdfButton.setConfiguration((qn) => ({
        ...qn,
        x: -this.container.object.width,
        y: Kn
      })), this.position = Un;
    });
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      ...this.offerButton.getFabricObjects(),
      ...this.pdfButton.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      ...this.offerButton.getObjects(),
      ...this.pdfButton.getObjects()
    ]);
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.container.object.visible = !0, this.pdfButton.show(), this.offerButton.show());
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.container.object.visible = !1, this.offerButton.hide(), this.pdfButton.hide());
    });
    Ca(this, "getRelativePosition", () => this.position);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "getUIElements", () => [this.offerButton, this.pdfButton]);
    Ca(this, "isShowed", () => this.isVisible);
    this.isVisible = !1, this.isHover = !1, this.isFocus = !1, this.isResetFocus = !0, this.position = { x: 0, y: 0 }, this.pdfButton = new TemplateMenuPDFButton(), this.offerButton = new TemplateMenuOfferButton(), this.area = new SpatialTemplateMenuArea(this), this.container = {
      object: new pr({
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT,
        fill: this.DEFAULT_FILL,
        shadow: UIShadowDefault,
        rx: this.DEFAULT_CORNER_RADIUS,
        ry: this.DEFAULT_CORNER_RADIUS,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, onDownloadPDF: qn, onSendOffer: Jo } = Un;
      this.pdfButton.forceInjectDependencies({ render: Kn, onDownloadPDF: qn }), this.offerButton.forceInjectDependencies({ render: Kn, onSendOffer: Jo });
    });
  }
  enableFocus() {
  }
  disableFocus() {
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  callClick() {
  }
}
class ToolAIButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Искусственный интеллект");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.AI_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900,
      svgColorFocus: UIDefaultColor.BLUE_900,
      fillFocus: UIDefaultColor.BLUE_300
    })), this.enableClickFocus(), this.disableResetFocus(), this.addPostInjectDependenciesListener((Un) => {
      this.addEnableFocusListeners(Un.onOpenAIActionsModal), this.addDisableFocusListeners(Un.onCloseAIActionsModal);
    });
  }
}
class ToolLineButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Линия / Shift + L");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.LINE_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.runInjectLine);
    });
  }
}
class ToolModuleButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Модули");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.MODAL_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.onOpenModulesModal);
    });
  }
}
class ToolPictureButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Изображение / Shift + K");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.PICTURE_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.runInjectPicture);
    });
  }
}
class ToolRectangleButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Прямоугольник / Shift + F");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.RECTANGLE_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.runInjectFigure);
    });
  }
}
class ToolRedoButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Следующее действие");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.REDO_ARROW_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPostMouseDownListeners(() => {
      this.dependencies.useCases.redo();
    });
  }
}
class ToolTableButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Таблица");
    Ca(this, "TABLE_CONSTRUCTOR_PADDING", 30);
    Ca(this, "onMouseDown", () => {
      if (this.isEnableFocus()) {
        this.dependencies.tableConstructor.hide();
        return;
      }
      const { x: Un, y: Kn } = this.getGlobalPosition(), qn = this.getWidth();
      this.dependencies.tableConstructor.setConfiguration((Jo) => ({
        ...Jo,
        x: Un + qn + this.TABLE_CONSTRUCTOR_PADDING,
        y: Kn
      })), this.dependencies.tableConstructor.show();
    });
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TABLE_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPrevMouseDownListeners(this.onMouseDown), this.addDisableFocusListeners(() => {
      this.dependencies.tableConstructor.hide();
    });
  }
}
class ToolTextButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Текст / Shift + T");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TEXT_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPostInjectDependenciesListener((Un) => {
      this.addPostMouseDownListeners(Un.useCases.runInjectText);
    });
  }
}
class ToolUndoButton extends BaseUIButton {
  constructor() {
    super();
    Ca(this, "TOOLTIP_TEXT", "Предыдущее действие");
    this.setConfiguration((Un) => ({
      ...Un,
      isEnableTooltip: !0,
      tooltipText: this.TOOLTIP_TEXT,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.UNDO_ARROW_TOOL),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 28,
      text: null,
      svgColorHover: UIDefaultColor.BLUE_900
    })), this.addPostMouseDownListeners(() => {
      this.dependencies.useCases.undo();
    });
  }
}
class ToolBar {
  constructor() {
    Ca(this, "DEFAULT_MARGIN_PANEL", 8);
    Ca(this, "DEFAULT_WIDTH_TOOL", 66);
    Ca(this, "DEFAULT_PADDING", 4);
    Ca(this, "DEFAULT_MARGIN_TOP", 120);
    Ca(this, "DEFAULT_LEFT_POSITION", 20);
    Ca(this, "DEFAULT_FILL", "#FFFFFF");
    Ca(this, "configuration");
    Ca(this, "toolPanels");
    Ca(this, "setMarginTop", (zn) => {
      this.configuration.marginTop = zn;
    });
    Ca(this, "sync", () => {
      for (let zn = 0; zn < this.toolPanels.length; zn++)
        this.toolPanels[zn].sync();
    });
    /**
     * Добавляет панель инструментов
     * @param panel
     */
    Ca(this, "addPanel", (zn) => {
      this.toolPanels.push(zn);
      let Un = this.configuration.marginTop;
      const { marginLeft: Kn, marginPanel: qn } = this.configuration;
      for (let Jo = 0; Jo < this.toolPanels.length; Jo++) {
        const pa = this.toolPanels[Jo];
        pa.setConfiguration((ma) => ({
          ...ma,
          x: Kn,
          y: Un
        })), Un += pa.getHeight() + qn;
      }
    });
    Ca(this, "getObjects", () => this.toolPanels.length <= 0 ? [] : this.toolPanels.flatMap((zn) => zn.getObjects()));
    /**
     * Возвращает все компоненты ToolBar
     */
    Ca(this, "getFabricObjects", () => this.toolPanels.length <= 0 ? [] : this.toolPanels.flatMap((zn) => zn.getFabricObjects()));
    Ca(this, "getUIElements", () => [
      ...this.toolPanels,
      ...this.toolPanels.flatMap((zn) => zn.getUIElements())
    ]);
    Ca(this, "getPanels", () => [...this.toolPanels]);
    Ca(this, "show", () => {
      this.toolPanels.forEach((zn) => zn.show());
    });
    Ca(this, "hide", () => {
      this.toolPanels.forEach((zn) => zn.hide());
    });
    this.toolPanels = [], this.configuration = {
      marginLeft: this.DEFAULT_LEFT_POSITION,
      marginTop: this.DEFAULT_MARGIN_TOP,
      marginPanel: this.DEFAULT_MARGIN_PANEL,
      padding: this.DEFAULT_PADDING,
      width: this.DEFAULT_WIDTH_TOOL,
      fill: this.DEFAULT_FILL
    };
  }
}
class SpatialToolPanelArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.TEMPLATE_MENU);
    Ca(this, "getGlobalFrameArea", () => this.toolPanel.getFrameArea());
    Ca(this, "getData", () => this.toolPanel);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.toolPanel = Un;
  }
}
class ToolPanel extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_PADDING", 4);
    Ca(this, "DEFAULT_WIDTH_TOOL", 66);
    Ca(this, "DEFAULT_FILL_TOOL", "#FFFFFF");
    Ca(this, "configuration");
    Ca(this, "uiButtons");
    Ca(this, "container");
    Ca(this, "area");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    /**
     * добавляет кнопки в панель.
     * @param buttons Массив кнопок.
     */
    Ca(this, "addButtons", (...Un) => {
      const { padding: Kn, width: qn } = this.configuration, Jo = qn - Kn * 2;
      Un.forEach((pa) => {
        pa.setConfiguration((ma) => ({
          ...ma,
          size: {
            width: Jo,
            height: Jo
          },
          padding: "center",
          x: 0,
          y: 0,
          insideTextToSvg: 0,
          borderThickness: 0,
          borderRadius: 4,
          svgColor: UIDefaultColor.GRAY_600
        })), this.uiButtons.push(pa);
      });
    });
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      this.configuration.x = qn.x, this.configuration.y = qn.y, qn.padding !== Kn.padding && (this.configuration.padding = qn.padding, this.syncSizeButtons()), qn.width !== Kn.width && (this.configuration.width = qn.width, this.syncSizeButtons()), qn.fill !== Kn.fill && (this.configuration.fill = qn.fill, this.container.object.fill = qn.fill), this.sync();
    });
    /**
     * Возвращает высоту панели.
     */
    Ca(this, "getHeight", () => {
      const { padding: Un, width: Kn } = this.configuration, qn = Kn - Un * 2;
      return this.uiButtons.length * (qn + Un) + Un;
    });
    Ca(this, "getUIElements", () => [...this.uiButtons]);
    Ca(this, "getFabricContainer", () => this.container.object);
    Ca(this, "getFabricButtons", () => [...this.uiButtons.flatMap((Un) => Un.getFabricObjects())]);
    /**
     * Синхронизирует свойства панели.
     */
    Ca(this, "sync", () => {
      const { padding: Un, width: Kn, y: qn, x: Jo, fill: pa } = this.configuration, ma = qn, va = Jo + Un, ba = Kn - Un * 2;
      let _a = ma + Un;
      for (let ya = 0; ya < this.uiButtons.length; ya++)
        this.uiButtons[ya].setConfiguration((xa) => ({
          ...xa,
          x: va,
          y: _a
        })), _a += ba + Un;
      this.container.object.set({
        width: Kn,
        height: this.uiButtons.length * (ba + Un) + Un,
        fill: pa
      }), this.container.relativePosition = {
        x: Jo,
        y: ma
      };
    });
    /**
     * Синхронизирует свойства кнопок.
     */
    Ca(this, "syncSizeButtons", () => {
      const Un = this.uiButtons, { padding: Kn, width: qn } = this.configuration, Jo = qn - Kn * 2;
      Un.forEach((pa) => {
        pa.setConfiguration((ma) => ({
          ...ma,
          size: {
            width: Jo,
            height: Jo
          }
        }));
      });
    });
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.uiButtons.forEach((Un) => Un.show()));
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.uiButtons.forEach((Un) => Un.hide()));
    });
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      ...this.uiButtons.flatMap((Un) => Un.getFabricObjects())
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      ...this.uiButtons.flatMap((Un) => Un.getObjects())
    ]);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "isShowed", () => this.isShow);
    this.area = new SpatialToolPanelArea(this), this.uiButtons = [], this.isShow = !0, this.isResetFocus = !0, this.configuration = {
      padding: this.DEFAULT_PADDING,
      width: this.DEFAULT_WIDTH_TOOL,
      x: 0,
      y: 0,
      fill: this.DEFAULT_FILL_TOOL
    }, this.container = {
      object: new pr({
        fill: this.DEFAULT_FILL_TOOL,
        rx: 7,
        ry: 7
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.container.object.set({
      shadow: {
        color: UIDefaultColor.SHADOW,
        blur: 5,
        offsetX: 0,
        offsetY: 0
      }
    }), this.sync();
  }
  disableFocus() {
  }
  disableHover() {
  }
  enableFocus() {
  }
  enableHover() {
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  callClick() {
  }
}
class TopBackButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      svgScale: ScaleSvg.HEIGHT,
      borderColor: "transparent",
      borderColorHover: null,
      borderColorFocus: null,
      fillHover: null,
      fillFocus: null,
      svgColor: UIDefaultColor.GRAY_600,
      svgColorHover: null,
      svgColorFocus: null,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.BACK_BUTTON),
        relativePosition: { x: 0, y: 0 }
      },
      svgSize: 20,
      padding: {
        topBottom: 10,
        leftRight: 10
      },
      text: null
    })), this.addPostInjectDependenciesListener((zn) => {
      this.addPostMouseDownListeners(zn.onBackPage);
    });
  }
}
class TopGenerateCounterButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.GENERATION_COUNTER),
        relativePosition: { x: 0, y: 0 }
      },
      svgColor: UIDefaultColor.BLACK,
      textColor: UIDefaultColor.BLACK,
      textColorHover: null,
      textColorFocus: null,
      borderColor: "transparent",
      borderColorHover: null,
      borderColorFocus: null,
      fillHover: null,
      fillFocus: null,
      svgColorHover: null,
      svgColorFocus: null,
      text: "600"
    })), this.enableClickFocus(), this.addPrevMouseDownListeners(() => {
      if (this.isEnableFocus()) {
        this.dependencies.generationHint.hide();
        return;
      }
      const zn = this.dependencies.generationHint.getWidth();
      this.dependencies.generationHint.setConfiguration((Un) => ({
        ...Un,
        x: this.getGlobalPosition().x + Math.round(this.getWidth() / 2) - 40 - Math.round(zn / 2),
        y: this.getGlobalPosition().y + 10
      })), this.dependencies.generationHint.show();
    }), this.addDisableFocusListeners(() => {
      this.dependencies.generationHint.hide();
    });
  }
}
class TopGetTariffButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: null,
      borderColorFocus: null,
      fillHover: null,
      fillFocus: null,
      svgColor: UIDefaultColor.GRAY_600,
      svgColorHover: null,
      svgColorFocus: UIDefaultColor.BLUE_900,
      text: "Перейти к тарифам",
      textColor: UIDefaultColor.BLUE_900,
      textColorHover: null,
      textColorFocus: null,
      padding: {
        topBottom: 5,
        leftRight: 10
      }
    }));
  }
}
class TopModulesButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      svg: {
        object: SVGCanvasStore.getSvg(SVGCollection.TOP_PANEL_MODULES),
        relativePosition: { x: 0, y: 0 }
      },
      svgColor: UIDefaultColor.GRAY_600,
      textColorHover: null,
      textColorFocus: null,
      borderColor: "transparent",
      borderColorHover: null,
      borderColorFocus: null,
      fillHover: null,
      fillFocus: null,
      svgColorHover: null,
      svgColorFocus: null,
      text: null
    })), this.enableClickFocus(), this.addPrevMouseDownListeners(() => {
      if (this.isEnableFocus()) {
        this.dependencies.templateMenu.hide();
        return;
      }
      this.dependencies.templateMenu.setPosition({
        x: this.getGlobalPosition().x + this.getWidth(),
        y: this.getGlobalPosition().y + this.getHeight()
      }), this.dependencies.templateMenu.show(), this.dependencies.render.render();
    }), this.addDisableFocusListeners(() => {
      this.dependencies.templateMenu.hide();
    });
  }
}
class TopPDFUnavailableButton extends BaseUIButton {
  constructor() {
    super(), this.setConfiguration((zn) => ({
      ...zn,
      borderColor: "transparent",
      borderColorHover: null,
      borderColorFocus: null,
      fillHover: null,
      fillFocus: null,
      svgColor: UIDefaultColor.GRAY_600,
      svgColorHover: null,
      svgColorFocus: UIDefaultColor.BLUE_900,
      text: "Скачивание PDF недоступно в пробной версии",
      textColor: UIDefaultColor.GRAY_600,
      textColorHover: null,
      textColorFocus: null,
      padding: {
        topBottom: 5,
        leftRight: 10
      }
    }));
  }
}
var TopBarState = /* @__PURE__ */ ((Xn) => (Xn.AI_PDF_KP = "AI_PDF_KP_FULL", Xn.AI_PDF = "AI_AND_KP", Xn.AI_KP = "AI_KP", Xn))(TopBarState || {});
class TopBarView extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_TOP", 20);
    Ca(this, "DEFAULT_MARGIN_HORIZONTAL", 20);
    Ca(this, "DEFAULT_PADDING", 12);
    Ca(this, "DEFAULT_HEIGHT_BLOCK", 50);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_BUTTON_INDENT", 10);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "container");
    Ca(this, "backButton");
    Ca(this, "renameButton");
    Ca(this, "modulesButton");
    Ca(this, "pdfUnavailable");
    Ca(this, "getTariff");
    Ca(this, "genCounter");
    Ca(this, "titleInput");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "setTitle", (Un) => {
      this.titleInput.setValue(Un);
    });
    Ca(this, "setState", (Un) => {
      this.configuration.state = Un;
    });
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.titleInput.show(), this.backButton.show(), this.renameButton.show(), this.modulesButton.show(), this.genCounter.show(), this.pdfUnavailable.show(), this.getTariff.show());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.titleInput.hide(), this.backButton.hide(), this.renameButton.hide(), this.modulesButton.hide(), this.pdfUnavailable.hide(), this.getTariff.hide(), this.genCounter.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getRelativePosition", () => ({
      x: this.getGlobalPosition().x,
      y: this.getGlobalPosition().y
    }));
    Ca(this, "getFrameArea", () => ({
      width: this.configuration.canvasWidth - this.configuration.marginHorizontal * 2,
      height: this.configuration.heightBlock + this.configuration.padding * 2,
      x: this.getGlobalPosition().x,
      y: this.getGlobalPosition().y,
      rotate: 0
    }));
    Ca(this, "getUIElements", () => [
      this.backButton,
      this.renameButton,
      this.modulesButton,
      this.pdfUnavailable,
      this.getTariff,
      this.genCounter,
      this.dependencies.generationHint,
      this.titleInput
    ]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.backButton.isEnableFocus() && Un.push(this.backButton), this.renameButton.isEnableFocus() && Un.push(this.renameButton), this.modulesButton.isEnableFocus() && Un.push(this.modulesButton), this.genCounter.isEnableFocus() && Un.push(this.genCounter), this.pdfUnavailable.isEnableFocus() && Un.push(this.pdfUnavailable), this.getTariff.isEnableFocus() && Un.push(this.getTariff), this.titleInput.isEnableFocus() && Un.push(this.titleInput), Un;
    });
    Ca(this, "getConfiguration", () => this.configuration);
    /**
     * Возвращает все объекты `FabricObject` из которых он состоит.
     */
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      ...this.titleInput.getFabricObjects(),
      ...this.backButton.getFabricObjects(),
      ...this.renameButton.getFabricObjects(),
      ...this.modulesButton.getFabricObjects(),
      ...this.pdfUnavailable.getFabricObjects(),
      ...this.getTariff.getFabricObjects(),
      ...this.genCounter.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      ...this.titleInput.getObjects(),
      ...this.backButton.getObjects(),
      ...this.renameButton.getObjects(),
      ...this.modulesButton.getObjects(),
      ...this.pdfUnavailable.getObjects(),
      ...this.getTariff.getObjects(),
      ...this.genCounter.getObjects()
    ]);
    Ca(this, "getFabricContainer", () => this.container.object);
    Ca(this, "getFabricContentElements", () => [
      ...this.titleInput.getFabricObjects(),
      ...this.backButton.getFabricObjects(),
      ...this.renameButton.getFabricObjects(),
      ...this.modulesButton.getFabricObjects(),
      ...this.pdfUnavailable.getFabricObjects(),
      ...this.getTariff.getFabricObjects(),
      ...this.genCounter.getFabricObjects()
    ]);
    Ca(this, "getHeight", () => {
      const { padding: Un, heightBlock: Kn } = this.configuration;
      return Un * 2 + Kn;
    });
    Ca(this, "getGlobalPosition", () => {
      const { marginTop: Un, marginHorizontal: Kn } = this.configuration;
      return {
        x: Kn,
        y: Un
      };
    });
    Ca(this, "syncPosition", () => {
      const Un = this.dependencies.render.getWidth(), { marginTop: Kn, marginHorizontal: qn, padding: Jo, fill: pa, cornerRadius: ma, titleFontSize: va, heightBlock: ba, indentButton: _a } = this.configuration, ya = Un - qn * 2;
      this.container.object.set({
        width: ya,
        height: this.getHeight(),
        fill: pa,
        rx: ma,
        ry: ma
      }), this.container.relativePosition = {
        x: qn,
        y: Kn
      }, this.backButton.setConfiguration((Ta) => ({
        ...Ta,
        x: Jo,
        y: Math.round(this.getHeight() / 2 - this.backButton.getHeight() / 2)
      }));
      const xa = ba - _a * 2, wa = ya / 2 - (this.titleInput.getWidth() + xa + _a) / 2;
      switch (this.titleInput.setConfiguration((Ta) => ({
        ...Ta,
        x: wa - _a,
        y: this.getHeight() / 2 - this.titleInput.getHeight() / 2
      })), this.renameButton.setConfiguration((Ta) => ({
        ...Ta,
        x: wa + this.titleInput.getWidth(),
        y: Math.round(this.getHeight() / 2 - xa / 2)
      })), this.configuration.state) {
        case TopBarState.AI_PDF_KP: {
          this.pdfUnavailable.hide(), this.getTariff.hide(), this.modulesButton.setConfiguration((Ta) => ({
            ...Ta,
            x: ya - Jo * 2 - this.modulesButton.getWidth(),
            y: Math.round(this.getHeight() / 2 - this.genCounter.getHeight() / 2),
            size: {
              width: xa,
              height: xa
            }
          })), this.genCounter.setConfiguration((Ta) => ({
            ...Ta,
            x: ya - Jo * 2 - this.modulesButton.getWidth() - _a - this.genCounter.getWidth(),
            y: Math.round(this.getHeight() / 2 - this.genCounter.getHeight() / 2),
            text: this.dependencies.onGetGenerationHintStructure().availableGeneration.toString()
          }));
          break;
        }
        case TopBarState.AI_KP: {
          this.modulesButton.hide(), this.getTariff.setConfiguration((Ta) => ({
            ...Ta,
            x: ya - Jo * 2 - this.getTariff.getWidth(),
            y: Math.round(this.getHeight() / 2 - this.genCounter.getHeight() / 2)
          })), this.pdfUnavailable.setConfiguration((Ta) => ({
            ...Ta,
            x: ya - Jo * 2 - this.pdfUnavailable.getWidth() - this.getTariff.getWidth(),
            y: Math.round(this.getHeight() / 2 - this.genCounter.getHeight() / 2)
          })), this.genCounter.setConfiguration((Ta) => ({
            ...Ta,
            x: ya - Jo * 2 - this.pdfUnavailable.getWidth() - _a - this.genCounter.getWidth() - this.getTariff.getWidth(),
            y: Math.round(this.getHeight() / 2 - this.genCounter.getHeight() / 2),
            text: this.dependencies.onGetGenerationHintStructure().availableGeneration.toString()
          }));
          break;
        }
        case TopBarState.AI_PDF: {
          this.pdfUnavailable.hide(), this.getTariff.hide(), this.modulesButton.setConfiguration((Ta) => ({
            ...Ta,
            x: ya - Jo * 2 - this.modulesButton.getWidth(),
            y: Math.round(this.getHeight() / 2 - this.genCounter.getHeight() / 2),
            size: {
              width: xa,
              height: xa
            }
          })), this.genCounter.setConfiguration((Ta) => ({
            ...Ta,
            x: ya - Jo * 2 - this.modulesButton.getWidth() - _a - this.genCounter.getWidth(),
            y: Math.round(this.getHeight() / 2 - this.genCounter.getHeight() / 2),
            text: this.dependencies.onGetGenerationHintStructure().availableGeneration.toString()
          }));
          break;
        }
      }
      this.dependencies.render.forceRenderUnstructured(), this.dependencies.render.renderRelativePositions();
    });
    this.isShow = !1, this.isResetFocus = !1, this.configuration = {
      marginTop: this.DEFAULT_MARGIN_TOP,
      canvasWidth: 1920,
      padding: this.DEFAULT_PADDING,
      fill: UIDefaultColor.WHITE,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      marginHorizontal: this.DEFAULT_MARGIN_HORIZONTAL,
      heightBlock: this.DEFAULT_HEIGHT_BLOCK,
      indentButton: this.DEFAULT_BUTTON_INDENT,
      state: TopBarState.AI_PDF_KP
    }, this.container = {
      object: new pr({
        shadow: UIShadowDefault,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.titleInput = new TopTitleInput(), this.backButton = new TopBackButton(), this.renameButton = new TopRenameButton(), this.modulesButton = new TopModulesButton(), this.genCounter = new TopGenerateCounterButton(), this.pdfUnavailable = new TopPDFUnavailableButton(), this.getTariff = new TopGetTariffButton();
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableHover() {
    return !1;
  }
  enableFocus() {
  }
  disableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class TopBar extends TopBarView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "getSpatialArea", () => this.area);
    this.area = new SpatialUIPanelArea(this), this.addPostInjectDependenciesListener((Un) => {
      const {
        render: Kn,
        templateMenu: qn,
        generationHint: Jo,
        onBackPage: pa,
        textEngine: ma,
        useCases: va,
        onSetNameTemplate: ba,
        actionController: _a
      } = Un;
      this.backButton.forceInjectDependencies({ render: Kn, onBackPage: pa }), this.renameButton.forceInjectDependencies({ render: Kn, textInput: this.titleInput }), this.pdfUnavailable.forceInjectDependencies({ render: Kn }), this.getTariff.forceInjectDependencies({ render: Kn }), this.modulesButton.forceInjectDependencies({
        render: Kn,
        templateMenu: qn
      }), this.genCounter.forceInjectDependencies({
        render: Kn,
        generationHint: Jo
      }), this.titleInput.forceInjectDependencies({
        render: Kn,
        textEngine: ma,
        useCases: va,
        topRenameButton: this.renameButton,
        onSetNameTemplate: ba,
        actionController: _a
      }), this.titleInput.addPostChangeTextListener(() => {
        this.syncPosition();
      });
    });
  }
  callClick() {
  }
}
class SpatialUIColorexPaletteArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.PALETTE);
    Ca(this, "getGlobalFrameArea", () => this.colorexPalette.getFrameArea());
    Ca(this, "getData", () => this.colorexPalette);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.colorexPalette = Un;
  }
}
const globalColorexColors = [
  {
    head: ColorexColor.Red600,
    colors: [
      ColorexColor.Red50,
      ColorexColor.Red100,
      ColorexColor.Red200,
      ColorexColor.Red300,
      ColorexColor.Red400,
      ColorexColor.Red500,
      ColorexColor.Red600,
      ColorexColor.Red700,
      ColorexColor.Red800,
      ColorexColor.Red900
      // ColorexColor.RedA100,
      // ColorexColor.RedA200,
      // ColorexColor.RedA400,
      // ColorexColor.RedA700,
    ]
  },
  {
    head: ColorexColor.Pink600,
    colors: [
      ColorexColor.Pink50,
      ColorexColor.Pink100,
      ColorexColor.Pink200,
      ColorexColor.Pink300,
      ColorexColor.Pink400,
      ColorexColor.Pink500,
      ColorexColor.Pink600,
      ColorexColor.Pink700,
      ColorexColor.Pink800,
      ColorexColor.Pink900
      // ColorexColor.PinkA100,
      // ColorexColor.PinkA200,
      // ColorexColor.PinkA400,
      // ColorexColor.PinkA700,
    ]
  },
  {
    head: ColorexColor.Purple600,
    colors: [
      ColorexColor.Purple50,
      ColorexColor.Purple100,
      ColorexColor.Purple200,
      ColorexColor.Purple300,
      ColorexColor.Purple400,
      ColorexColor.Purple500,
      ColorexColor.Purple600,
      ColorexColor.Purple700,
      ColorexColor.Purple800,
      ColorexColor.Purple900
      // ColorexColor.PurpleA100,
      // ColorexColor.PurpleA200,
      // ColorexColor.PurpleA400,
      // ColorexColor.PurpleA700,
    ]
  },
  {
    head: ColorexColor.DeepPurple600,
    colors: [
      ColorexColor.DeepPurple50,
      ColorexColor.DeepPurple100,
      ColorexColor.DeepPurple200,
      ColorexColor.DeepPurple300,
      ColorexColor.DeepPurple400,
      ColorexColor.DeepPurple500,
      ColorexColor.DeepPurple600,
      ColorexColor.DeepPurple700,
      ColorexColor.DeepPurple800,
      ColorexColor.DeepPurple900
      // ColorexColor.DeepPurpleA100,
      // ColorexColor.DeepPurpleA200,
      // ColorexColor.DeepPurpleA400,
      // ColorexColor.DeepPurpleA700,
    ]
  },
  {
    head: ColorexColor.Indigo600,
    colors: [
      ColorexColor.Indigo50,
      ColorexColor.Indigo100,
      ColorexColor.Indigo200,
      ColorexColor.Indigo300,
      ColorexColor.Indigo400,
      ColorexColor.Indigo500,
      ColorexColor.Indigo600,
      ColorexColor.Indigo700,
      ColorexColor.Indigo800,
      ColorexColor.Indigo900
      // ColorexColor.IndigoA100,
      // ColorexColor.IndigoA200,
      // ColorexColor.IndigoA400,
      // ColorexColor.IndigoA700,
    ]
  },
  {
    head: ColorexColor.Blue600,
    colors: [
      ColorexColor.Blue50,
      ColorexColor.Blue100,
      ColorexColor.Blue200,
      ColorexColor.Blue300,
      ColorexColor.Blue400,
      ColorexColor.Blue500,
      ColorexColor.Blue600,
      ColorexColor.Blue700,
      ColorexColor.Blue800,
      ColorexColor.Blue900
      // ColorexColor.BlueA100,
      // ColorexColor.BlueA200,
      // ColorexColor.BlueA400,
      // ColorexColor.BlueA700,
    ]
  },
  {
    head: ColorexColor.LightBlue600,
    colors: [
      ColorexColor.LightBlue50,
      ColorexColor.LightBlue100,
      ColorexColor.LightBlue200,
      ColorexColor.LightBlue300,
      ColorexColor.LightBlue400,
      ColorexColor.LightBlue500,
      ColorexColor.LightBlue600,
      ColorexColor.LightBlue700,
      ColorexColor.LightBlue800,
      ColorexColor.LightBlue900
      // ColorexColor.LightBlueA100,
      // ColorexColor.LightBlueA200,
      // ColorexColor.LightBlueA400,
      // ColorexColor.LightBlueA700,
    ]
  },
  {
    head: ColorexColor.Cyan600,
    colors: [
      ColorexColor.Cyan50,
      ColorexColor.Cyan100,
      ColorexColor.Cyan200,
      ColorexColor.Cyan300,
      ColorexColor.Cyan400,
      ColorexColor.Cyan500,
      ColorexColor.Cyan600,
      ColorexColor.Cyan700,
      ColorexColor.Cyan800,
      ColorexColor.Cyan900
      // ColorexColor.CyanA100,
      // ColorexColor.CyanA200,
      // ColorexColor.CyanA400,
      // ColorexColor.CyanA700,
    ]
  },
  {
    head: ColorexColor.Teal600,
    colors: [
      ColorexColor.Teal50,
      ColorexColor.Teal100,
      ColorexColor.Teal200,
      ColorexColor.Teal300,
      ColorexColor.Teal400,
      ColorexColor.Teal500,
      ColorexColor.Teal600,
      ColorexColor.Teal700,
      ColorexColor.Teal800,
      ColorexColor.Teal900
      // ColorexColor.TealA100,
      // ColorexColor.TealA200,
      // ColorexColor.TealA400,
      // ColorexColor.TealA700,
    ]
  },
  {
    head: ColorexColor.Green600,
    colors: [
      ColorexColor.Green50,
      ColorexColor.Green100,
      ColorexColor.Green200,
      ColorexColor.Green300,
      ColorexColor.Green400,
      ColorexColor.Green500,
      ColorexColor.Green600,
      ColorexColor.Green700,
      ColorexColor.Green800,
      ColorexColor.Green900
      // ColorexColor.GreenA100,
      // ColorexColor.GreenA200,
      // ColorexColor.GreenA400,
      // ColorexColor.GreenA700,
    ]
  },
  {
    head: ColorexColor.LightGreen600,
    colors: [
      ColorexColor.LightGreen50,
      ColorexColor.LightGreen100,
      ColorexColor.LightGreen200,
      ColorexColor.LightGreen300,
      ColorexColor.LightGreen400,
      ColorexColor.LightGreen500,
      ColorexColor.LightGreen600,
      ColorexColor.LightGreen700,
      ColorexColor.LightGreen800,
      ColorexColor.LightGreen900
      // ColorexColor.LightGreenA100,
      // ColorexColor.LightGreenA200,
      // ColorexColor.LightGreenA400,
      // ColorexColor.LightGreenA700,
    ]
  },
  {
    head: ColorexColor.Lime600,
    colors: [
      ColorexColor.Lime50,
      ColorexColor.Lime100,
      ColorexColor.Lime200,
      ColorexColor.Lime300,
      ColorexColor.Lime400,
      ColorexColor.Lime500,
      ColorexColor.Lime600,
      ColorexColor.Lime700,
      ColorexColor.Lime800,
      ColorexColor.Lime900
      // ColorexColor.LimeA100,
      // ColorexColor.LimeA200,
      // ColorexColor.LimeA400,
      // ColorexColor.LimeA700,
    ]
  },
  {
    head: ColorexColor.Red600,
    colors: [
      ColorexColor.Yellow50,
      ColorexColor.Yellow100,
      ColorexColor.Yellow200,
      ColorexColor.Yellow300,
      ColorexColor.Yellow400,
      ColorexColor.Yellow500,
      ColorexColor.Yellow600,
      ColorexColor.Yellow700,
      ColorexColor.Yellow800,
      ColorexColor.Yellow900
      // ColorexColor.YellowA100,
      // ColorexColor.YellowA200,
      // ColorexColor.YellowA400,
      // ColorexColor.YellowA700,
    ]
  },
  {
    head: ColorexColor.Amber600,
    colors: [
      ColorexColor.Amber50,
      ColorexColor.Amber100,
      ColorexColor.Amber200,
      ColorexColor.Amber300,
      ColorexColor.Amber400,
      ColorexColor.Amber500,
      ColorexColor.Amber600,
      ColorexColor.Amber700,
      ColorexColor.Amber800,
      ColorexColor.Amber900
      // ColorexColor.AmberA100,
      // ColorexColor.AmberA200,
      // ColorexColor.AmberA400,
      // ColorexColor.AmberA700,
    ]
  },
  {
    head: ColorexColor.Orange600,
    colors: [
      ColorexColor.Orange50,
      ColorexColor.Orange100,
      ColorexColor.Orange200,
      ColorexColor.Orange300,
      ColorexColor.Orange400,
      ColorexColor.Orange500,
      ColorexColor.Orange600,
      ColorexColor.Orange700,
      ColorexColor.Orange800,
      ColorexColor.Orange900
      // ColorexColor.OrangeA100,
      // ColorexColor.OrangeA200,
      // ColorexColor.OrangeA400,
      // ColorexColor.OrangeA700,
    ]
  },
  {
    head: ColorexColor.DeepOrange600,
    colors: [
      ColorexColor.DeepOrange50,
      ColorexColor.DeepOrange100,
      ColorexColor.DeepOrange200,
      ColorexColor.DeepOrange300,
      ColorexColor.DeepOrange400,
      ColorexColor.DeepOrange500,
      ColorexColor.DeepOrange600,
      ColorexColor.DeepOrange700,
      ColorexColor.DeepOrange800,
      ColorexColor.DeepOrange900
      // ColorexColor.DeepOrangeA100,
      // ColorexColor.DeepOrangeA200,
      // ColorexColor.DeepOrangeA400,
      // ColorexColor.DeepOrangeA700,
    ]
  },
  {
    head: ColorexColor.Brown600,
    colors: [
      ColorexColor.Brown50,
      ColorexColor.Brown100,
      ColorexColor.Brown200,
      ColorexColor.Brown300,
      ColorexColor.Brown400,
      ColorexColor.Brown500,
      ColorexColor.Brown600,
      ColorexColor.Brown700,
      ColorexColor.Brown800,
      ColorexColor.Brown900
    ]
  },
  {
    head: ColorexColor.Grey600,
    colors: [
      ColorexColor.Grey50,
      ColorexColor.Grey100,
      ColorexColor.Grey200,
      ColorexColor.Grey300,
      ColorexColor.Grey400,
      ColorexColor.Grey500,
      ColorexColor.Grey600,
      ColorexColor.Grey700,
      ColorexColor.Grey800,
      ColorexColor.Grey900
    ]
  },
  {
    head: ColorexColor.BlueGrey600,
    colors: [
      ColorexColor.BlueGrey50,
      ColorexColor.BlueGrey100,
      ColorexColor.BlueGrey200,
      ColorexColor.BlueGrey300,
      ColorexColor.BlueGrey400,
      ColorexColor.BlueGrey500,
      ColorexColor.BlueGrey600,
      ColorexColor.BlueGrey700,
      ColorexColor.BlueGrey800,
      ColorexColor.BlueGrey900
    ]
  }
];
var TypeObjectAnimated = /* @__PURE__ */ ((Xn) => (Xn.WIDTH = "width", Xn.HEIGHT = "height", Xn.OPACITY = "opacity", Xn.LEFT = "left", Xn.TOP = "top", Xn.SCALE_X = "scaleX", Xn.SCALE_Y = "scaleY", Xn))(TypeObjectAnimated || {});
class SpatialColorexCircleArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.COLOREX_COLOR);
    Ca(this, "onClick");
    Ca(this, "getGlobalFrameArea", () => this.circle.getFrameArea());
    Ca(this, "getData", () => this.circle);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    Ca(this, "setClick", (Un) => {
      this.onClick = Un;
    });
    Ca(this, "getOnClick", () => this.onClick);
    Ca(this, "callClick", () => {
      this.onClick !== null && this.onClick(this.circle.getColor());
    });
    this.circle = Un, this.onClick = null;
  }
}
class ColorexColorCircle {
  constructor(zn) {
    Ca(this, "DEFAULT_PADDING", 2);
    Ca(this, "DEFAULT_DURATION_ANIMATION", 100);
    Ca(this, "circle");
    Ca(this, "lineTransparent");
    Ca(this, "lineClipPath");
    Ca(this, "render");
    Ca(this, "postClickListeners");
    Ca(this, "prevClickListeners");
    Ca(this, "color");
    Ca(this, "isUsed");
    Ca(this, "isVisible");
    Ca(this, "isHover");
    Ca(this, "configuration");
    Ca(this, "isTransparent");
    Ca(this, "isResetFocus");
    Ca(this, "area");
    Ca(this, "getGlobalPosition", () => ({
      x: this.circle.object.left,
      y: this.circle.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "isEnableHover", () => this.isHover);
    Ca(this, "enableHover", () => {
      if (this.isHover)
        return;
      this.isHover = !0;
      const zn = [
        {
          object: this.circle.object,
          start: this.configuration.size,
          end: this.configuration.size + this.configuration.padding,
          duration: this.DEFAULT_DURATION_ANIMATION,
          type: TypeObjectAnimated.WIDTH,
          ease: un.ease.easeInSine
        },
        {
          object: this.circle.object,
          start: this.configuration.size,
          end: this.configuration.size + this.configuration.padding,
          duration: this.DEFAULT_DURATION_ANIMATION,
          type: TypeObjectAnimated.HEIGHT,
          ease: un.ease.easeInSine
        }
      ];
      this.isTransparent && zn.push({
        object: this.lineClipPath.object,
        start: this.configuration.size,
        end: this.configuration.size + this.configuration.padding * 2,
        duration: this.DEFAULT_DURATION_ANIMATION,
        type: TypeObjectAnimated.WIDTH,
        ease: un.ease.easeInSine
      }), this.render.animateObjects(...zn), this.circle.object.rx = this.circle.object.width, this.circle.object.ry = this.circle.object.height;
    });
    Ca(this, "disableHover", () => {
      if (!this.isHover)
        return;
      this.isHover = !1;
      const zn = [
        {
          object: this.circle.object,
          start: this.configuration.size + this.configuration.padding,
          end: this.configuration.size,
          duration: this.DEFAULT_DURATION_ANIMATION,
          type: TypeObjectAnimated.WIDTH,
          ease: un.ease.easeInSine
        },
        {
          object: this.circle.object,
          start: this.configuration.size + this.configuration.padding,
          end: this.configuration.size,
          duration: this.DEFAULT_DURATION_ANIMATION,
          type: TypeObjectAnimated.HEIGHT,
          ease: un.ease.easeInSine
        }
      ];
      this.isTransparent && zn.push({
        object: this.lineClipPath.object,
        start: this.configuration.size + this.configuration.padding * 2,
        end: this.configuration.size,
        duration: this.DEFAULT_DURATION_ANIMATION,
        type: TypeObjectAnimated.WIDTH,
        ease: un.ease.easeInSine
      }), this.render.animateObjects(...zn), this.circle.object.rx = this.circle.object.width, this.circle.object.ry = this.circle.object.height;
    });
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.circle.object.visible = !0, this.isTransparent && (this.lineTransparent.object.visible = !0));
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.circle.object.set({
        visible: !1
      }), this.lineTransparent.object.visible = !1);
    });
    Ca(this, "enableUsed", () => {
      this.isUsed || (this.isUsed = !0, this.circle.object.set({
        strokeWidth: 3,
        stroke: UIDefaultColor.BLUE_900
      }));
    });
    Ca(this, "disableUsed", () => {
      this.isUsed && (this.isUsed = !1, this.circle.object.set({
        strokeWidth: 1,
        stroke: UIDefaultColor.GRAY_580
      }));
    });
    Ca(this, "setSize", (zn, Un) => {
      this.configuration.padding = Un, this.configuration.size = zn, this.circle.object.width = zn, this.circle.object.height = zn, this.circle.object.rx = zn, this.circle.object.ry = zn, this.lineClipPath.object.width = zn, this.lineClipPath.object.height = zn, this.lineClipPath.object.rx = zn, this.lineClipPath.object.ry = zn;
    });
    Ca(this, "setPosition", (zn) => {
      this.circle.relativePosition = {
        x: Math.round(zn.x),
        y: Math.round(zn.y)
      }, this.lineClipPath.relativePosition = {
        x: Math.round(zn.x),
        y: Math.round(zn.y)
      }, this.configuration.x = Math.round(zn.x), this.configuration.y = Math.round(zn.y), this.isTransparent && (this.lineTransparent.relativePosition = {
        x: zn.x - this.configuration.size / 2 - this.configuration.padding,
        y: zn.y - this.configuration.size / 2 - this.configuration.padding
      });
    });
    Ca(this, "getFabricObjects", () => [this.circle.object, this.lineTransparent.object]);
    Ca(this, "setColor", (zn) => {
      this.color = zn, this.circle.object.fill = zn, zn === ColorexColor.Transparent && (this.isTransparent = !0);
    });
    Ca(this, "addPostClickListeners", (...zn) => {
      this.postClickListeners.push(...zn);
    });
    Ca(this, "addPrevClickListeners", (...zn) => {
      this.prevClickListeners.push(...zn);
    });
    Ca(this, "callClick", () => {
      this.prevClickListeners.forEach((zn) => zn(this.color)), this.enableUsed(), this.postClickListeners.forEach((zn) => zn(this.color));
    });
    Ca(this, "getColor", () => this.color);
    Ca(this, "getFrameArea", () => ({
      x: Math.round(this.circle.object.left - this.circle.object.width / 2 - this.configuration.padding / 2),
      y: Math.round(this.circle.object.top - this.circle.object.height / 2 - this.configuration.padding / 2),
      width: this.configuration.size + this.configuration.padding,
      height: this.configuration.size + this.configuration.padding,
      rotate: 0
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "isShowed", () => this.isVisible);
    Ca(this, "getUIElements", () => []);
    Ca(this, "getObjects", () => this.isTransparent ? [this.circle, this.lineTransparent, this.lineClipPath] : [this.circle, this.lineTransparent]);
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x - this.configuration.size / 2 - this.configuration.padding / 2,
      y: this.configuration.y - this.configuration.size / 2 - this.configuration.padding / 2
    }));
    this.render = zn, this.color = ColorexColor.Transparent, this.isTransparent = !1, this.area = new SpatialColorexCircleArea(this), this.circle = {
      object: new pr({
        fill: this.color,
        strokeWidth: 1,
        stroke: UIDefaultColor.GRAY_580,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.lineClipPath = {
      object: new pr({
        width: 30,
        height: 30,
        fill: UIDefaultColor.BLACK,
        strokeWidth: 1,
        stroke: "#868686",
        absolutePositioned: !0,
        visible: !0
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.circle.object.set({
      originX: "center",
      originY: "center"
    }), this.lineClipPath.object.set({
      originX: "center",
      originY: "center"
    }), this.lineTransparent = {
      object: new $n(
        [
          this.lineClipPath.object.left ?? 0,
          this.lineClipPath.object.top ?? 0,
          (this.lineClipPath.object.left ?? 0) + (this.lineClipPath.object.width ?? 0),
          (this.lineClipPath.object.top ?? 0) + (this.lineClipPath.object.height ?? 0)
        ],
        {
          stroke: "red",
          strokeWidth: 3,
          selectable: !1,
          clipPath: this.lineClipPath.object,
          visible: !1
        }
      ),
      relativePosition: { x: 0, y: 0 }
    }, this.configuration = {
      size: 0,
      x: 0,
      y: 0,
      animateEnable: {
        x: 0,
        y: 0
      },
      animateDisable: {
        x: 0,
        y: 0
      },
      padding: this.DEFAULT_PADDING
    }, this.isUsed = !1, this.isVisible = !1, this.isHover = !1, this.isResetFocus = !0, this.postClickListeners = [], this.prevClickListeners = [];
  }
  disableFocus() {
  }
  enableFocus() {
  }
  isEnableFocus() {
    return !1;
  }
}
class ColorexColorsBlock extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_SIZE_COLOREX_CIRCLE", 17);
    Ca(this, "DEFAULT_PADDING_COLOREX_CIRCLE", 6);
    Ca(this, "DEFAULT_COUNT_CIRCLES_ROW", 10);
    Ca(this, "circles", []);
    Ca(this, "postSelectColorListeners");
    Ca(this, "prevSelectColorListeners");
    Ca(this, "configuration");
    Ca(this, "isVisible");
    Ca(this, "enableVisible", () => {
      if (!this.isVisible) {
        this.isVisible = !0;
        for (let Un = 0; Un < this.circles.length; Un++)
          this.circles[Un].show();
      }
    });
    Ca(this, "disableVisible", () => {
      if (this.isVisible) {
        this.isVisible = !1;
        for (let Un = 0; Un < this.circles.length; Un++)
          this.circles[Un].hide();
      }
    });
    Ca(this, "setPosition", (Un) => {
      this.configuration.x = Un.x, this.configuration.y = Un.y, this.syncCircles();
    });
    Ca(this, "getWidth", () => this.configuration.countCirclesRow * (this.configuration.sizeColorexCircle + this.configuration.paddingColorexCircle));
    Ca(this, "getHeight", () => globalColorexColors.length * (this.configuration.sizeColorexCircle + this.configuration.paddingColorexCircle));
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration;
      this.configuration = Un(Kn), this.syncCircles();
    });
    Ca(this, "getCircles", () => this.circles);
    /**
     * Устанавливает используемые цвета палитры
     * @param colors Используемые цвета
     */
    Ca(this, "setColorsUsed", (Un) => {
      Un !== null && this.circles.forEach((Kn) => {
        Un.includes(Kn.getColor()) ? Kn.enableUsed() : Kn.disableUsed();
      });
    });
    Ca(this, "addPrevSelectColorListeners", (...Un) => {
      this.prevSelectColorListeners.push(...Un);
    });
    Ca(this, "addPostSelectColorListeners", (...Un) => {
      this.postSelectColorListeners.push(...Un);
    });
    Ca(this, "getUIElements", () => [...this.circles]);
    Ca(this, "getObjects", () => this.circles.flatMap((Un) => Un.getObjects()));
    Ca(this, "getFabricObjects", () => this.circles.flatMap((Un) => Un.getFabricObjects()));
    Ca(this, "onSelectColorClick", (Un) => {
      console.log("onSelectColorClick"), this.prevSelectColorListeners.forEach((Kn) => Kn(Un)), this.circles.forEach((Kn) => {
        Un === Kn.getColor() ? Kn.enableUsed() : Kn.disableUsed();
      }), this.dependencies.frequentlyUsedBlock.getCircles().forEach((Kn) => {
        Un === Kn.getColor() ? Kn.enableUsed() : Kn.disableUsed();
      }), this.postSelectColorListeners.forEach((Kn) => Kn(Un));
    });
    /**
     * Синхронизирует позицию цветов
     */
    Ca(this, "syncCircles", () => {
      const { x: Un, y: Kn, sizeColorexCircle: qn, paddingColorexCircle: Jo, countCirclesRow: pa } = this.configuration, ma = qn + Jo, va = globalColorexColors.length;
      for (let ba = 0; ba < va; ba++)
        for (let _a = 0; _a < pa; _a++) {
          const ya = this.circles[ba * pa + _a], xa = Un + _a * ma + ma / 2, wa = Kn + ba * ma + ma / 2;
          ya.setPosition({
            x: xa,
            y: wa
          });
        }
    });
    this.configuration = {
      x: 0,
      y: 0,
      sizeColorexCircle: this.DEFAULT_SIZE_COLOREX_CIRCLE,
      paddingColorexCircle: this.DEFAULT_PADDING_COLOREX_CIRCLE,
      countCirclesRow: this.DEFAULT_COUNT_CIRCLES_ROW
    }, this.postSelectColorListeners = [], this.prevSelectColorListeners = [], this.isVisible = !1, this.disableVisible(), this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn } = Un;
      globalColorexColors.forEach((qn) => {
        qn.colors.forEach((Jo) => {
          const pa = new ColorexColorCircle(Kn);
          pa.setColor(Jo);
          const { sizeColorexCircle: ma, paddingColorexCircle: va } = this.configuration;
          pa.setSize(ma, va), pa.addPostClickListeners(this.onSelectColorClick), this.circles.push(pa);
        });
      }), this.syncCircles();
    });
  }
}
class ColorexFrequentlyUsed extends Dependent {
  constructor(Un) {
    super();
    Ca(this, "DEFAULT_SIZE_COLOREX_CIRCLE", 17);
    Ca(this, "DEFAULT_PADDING_COLOREX_CIRCLE", 6);
    Ca(this, "DEFAULT_MAX_COLOREX_CIRCLE", 7);
    Ca(this, "DEFAULT_MAX_FREQUENTLY_COLORS_COUNT", 7);
    Ca(this, "BASE_COLORS", [ColorexColor.Black, ColorexColor.White, ColorexColor.Transparent]);
    Ca(this, "colorCirclesBase");
    Ca(this, "configuration");
    Ca(this, "prevSelectColorListeners");
    Ca(this, "postSelectColorListeners");
    Ca(this, "colorCircles");
    Ca(this, "postSelectColorListener");
    Ca(this, "selectColorEventBlock");
    Ca(this, "prevSelectColorEvent");
    Ca(this, "activeColors");
    Ca(this, "isVisible");
    Ca(this, "maxFrequentlyColorCount");
    Ca(this, "frequentlyColors");
    Ca(this, "enableVisible", () => {
      if (this.setColors(this.getFrequentlyColors()), !this.isVisible) {
        this.isVisible = !0;
        for (let Un = 0; Un < this.colorCirclesBase.length; Un++)
          this.colorCirclesBase[Un].show();
        for (let Un = 0; Un < this.colorCircles.length; Un++)
          this.colorCircles[Un].show();
      }
    });
    Ca(this, "disableVisible", () => {
      if (this.isVisible) {
        this.isVisible = !1;
        for (let Un = 0; Un < this.colorCirclesBase.length; Un++)
          this.colorCirclesBase[Un].hide();
        for (let Un = 0; Un < this.colorCircles.length; Un++)
          this.colorCircles[Un].hide();
      }
    });
    /**
     * Синхронизирует палитру с новыми координатами
     * @param position Новые координаты
     */
    Ca(this, "setPosition", (Un) => {
      this.configuration.x = Un.x, this.configuration.y = Un.y, this.syncCirclePosition();
    });
    Ca(this, "getCircles", () => [...this.colorCircles, ...this.colorCirclesBase]);
    /**
     * Устанавливает используемые цветы
     * @param colors
     */
    Ca(this, "setColorsUsed", (Un) => {
      this.activeColors = Un, this.colorCircles.forEach((Kn) => {
        Un.includes(Kn.getColor()) ? Kn.enableUsed() : Kn.disableUsed();
      }), this.colorCirclesBase.forEach((Kn) => {
        Un.includes(Kn.getColor()) ? Kn.enableUsed() : Kn.disableUsed(), Kn.getColor() === "#000000" && Un.includes("#000") && Kn.enableUsed();
      });
    });
    Ca(this, "setColors", (Un) => {
      this.render(Un);
    });
    Ca(this, "addPrevSelectColorListeners", (...Un) => {
      this.prevSelectColorListeners.push(...Un);
    });
    Ca(this, "addPostSelectColorListeners", (...Un) => {
      this.postSelectColorListeners.push(...Un);
    });
    Ca(this, "getObjects", () => {
      const Un = this.colorCirclesBase.flatMap((qn) => qn.getObjects()), Kn = this.colorCircles.flatMap((qn) => qn.getObjects());
      return [...Un, ...Kn];
    });
    Ca(this, "getFabricObjects", () => {
      const Un = this.colorCirclesBase.flatMap((qn) => qn.getFabricObjects()), Kn = this.colorCircles.flatMap((qn) => qn.getFabricObjects());
      return [...Un, ...Kn];
    });
    Ca(this, "getUIElements", () => [...this.colorCirclesBase, ...this.colorCircles]);
    Ca(this, "setUsedColors", (Un) => {
      if (this.colorCirclesBase.map((Jo) => Jo.getColor()).includes(Un))
        return;
      this.pushFrequentlyColor(Un);
      const qn = this.getFrequentlyColors();
      this.setColors(qn);
    });
    Ca(this, "setMaxFrequentlyColorCount", (Un) => {
      this.maxFrequentlyColorCount = Un;
    });
    Ca(this, "getFrequentlyColors", () => [...this.frequentlyColors]);
    Ca(this, "pushFrequentlyColor", (Un) => {
      if (this.frequentlyColors.find((qn) => qn === Un)) {
        const qn = this.frequentlyColors.indexOf(Un);
        this.frequentlyColors = [
          ...this.frequentlyColors.slice(0, qn),
          ...this.frequentlyColors.slice(qn + 1),
          Un
        ];
      } else {
        if (this.frequentlyColors.length === this.maxFrequentlyColorCount) {
          this.frequentlyColors = [...this.frequentlyColors.slice(1), Un];
          return;
        }
        this.frequentlyColors.push(Un);
      }
    });
    Ca(this, "render", (Un) => {
      const Kn = this.colorCircles.map((qn) => qn.getColor());
      Un.forEach((qn) => {
        if (!Kn.includes(qn)) {
          const Jo = this.appendCircle(qn);
          Jo.show(), this.colorCircles.push(Jo);
        }
      }), this.setColorsUsed(this.activeColors), this.syncCirclePosition(), this.dependencies.render.render();
    });
    /**
     * Обрабатывает клик на цвет
     * @param color
     */
    Ca(this, "onSelectColorClick", (Un) => {
      this.prevSelectColorEvent !== null && this.prevSelectColorEvent(Un), this.postSelectColorListener !== null && this.postSelectColorListener(Un), this.selectColorEventBlock !== null && this.selectColorEventBlock([Un.toString()]), this.setColorsUsed([Un.toString()]);
    });
    /**
     * Создает новый цвет и возвращает его
     * @param color
     */
    Ca(this, "appendCircle", (Un) => {
      const Kn = new ColorexColorCircle(this.dependencies.render), { sizeColorexCircle: qn, paddingColorexCircle: Jo } = this.configuration;
      return Kn.setSize(qn, Jo), Kn.setColor(Un), Kn.addPostClickListeners(this.onSelectColorClick), Kn;
    });
    /**
     * Синхронизирует позицию цветов
     */
    Ca(this, "syncCirclePosition", () => {
      const { x: Un, y: Kn, sizeColorexCircle: qn, paddingColorexCircle: Jo } = this.configuration, pa = qn + Jo;
      for (let va = 0; va < this.colorCirclesBase.length; va++) {
        const ba = Un + (va * pa + pa / 2), _a = Kn + (pa - Jo) / 2;
        this.colorCirclesBase[va].setPosition({
          x: ba,
          y: _a
        });
      }
      for (; this.colorCircles.length > this.configuration.maxColorexCircle; )
        this.colorCircles.shift();
      const ma = this.colorCirclesBase.length * pa;
      for (let va = 0; va < this.colorCircles.length; va++) {
        const ba = Un + (va * pa + pa / 2) + ma, _a = Kn + (pa - Jo) / 2;
        this.colorCircles[va].setPosition({
          x: ba,
          y: _a
        });
      }
    });
    /**
     * Рендерит базовые цвета
     * @param isDisableTransparent Добавлять ли прозрачный цвет
     */
    Ca(this, "renderBaseColors", (Un) => {
      this.BASE_COLORS.forEach((Kn) => {
        if (Un && Kn === "transparent")
          return;
        const qn = this.appendCircle(Kn);
        this.colorCirclesBase.push(qn);
      }), this.activeColors && this.setColorsUsed(this.activeColors), this.syncCirclePosition();
    });
    this.maxFrequentlyColorCount = this.DEFAULT_MAX_FREQUENTLY_COLORS_COUNT, this.frequentlyColors = [], this.colorCircles = [], this.colorCirclesBase = [], this.prevSelectColorListeners = [], this.postSelectColorListeners = [], this.postSelectColorListener = null, this.selectColorEventBlock = null, this.prevSelectColorEvent = null, this.activeColors = [], this.isVisible = !1, this.configuration = {
      x: 0,
      y: 0,
      sizeColorexCircle: this.DEFAULT_SIZE_COLOREX_CIRCLE,
      paddingColorexCircle: this.DEFAULT_PADDING_COLOREX_CIRCLE,
      maxColorexCircle: this.DEFAULT_MAX_COLOREX_CIRCLE
    }, this.addPostInjectDependenciesListener(() => {
      this.renderBaseColors(Un);
    });
  }
}
class ColorexCore extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_PADDING", 6);
    Ca(this, "DEFAULT_SEPARATOR_COLOR", "#bebebe");
    Ca(this, "DEFAULT_SEPARATOR_THICKNESS", 1);
    Ca(this, "DEFAULT_SEPARATOR_PADDING", 2);
    Ca(this, "container");
    Ca(this, "separator");
    Ca(this, "configuration");
    Ca(this, "area");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "frequentlyUsedBlock");
    Ca(this, "colorsBlock");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "getWidth", () => this.colorsBlock.getWidth() + this.configuration.padding * 2);
    Ca(this, "getHeight", () => this.colorsBlock.getHeight() + (this.colorsBlock.getConfiguration().sizeColorexCircle + this.colorsBlock.getConfiguration().paddingColorexCircle) + this.configuration.padding * 2 + this.configuration.separatorPadding * 2 + this.configuration.separatorThickness);
    Ca(this, "syncActiveColors", (Un) => {
      this.colorsBlock.setColorsUsed(Un), this.frequentlyUsedBlock.setColorsUsed(Un);
    });
    Ca(this, "syncPalettePosition", (Un, Kn) => {
      Kn ? this.setPalettePosition({
        x: Un.x - this.getWidth(),
        y: Un.y
      }) : this.setPalettePosition(Un);
    });
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.separator.object,
      ...this.frequentlyUsedBlock.getFabricObjects(),
      ...this.colorsBlock.getFabricObjects()
    ]);
    Ca(this, "getSpatialAreas", () => [...[...this.colorsBlock.getCircles(), ...this.frequentlyUsedBlock.getCircles()].map((Kn) => Kn.getSpatialArea())]);
    Ca(this, "getObjects", () => [this.container, ...this.frequentlyUsedBlock.getObjects(), ...this.colorsBlock.getObjects(), this.separator]);
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.frequentlyUsedBlock.enableVisible(), this.colorsBlock.enableVisible(), this.separator.object.visible = !0);
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.separator.object.visible = !1, this.frequentlyUsedBlock.disableVisible(), this.colorsBlock.disableVisible());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.getWidth(),
      height: this.getHeight(),
      rotate: 0
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "getUIElements", () => [...this.colorsBlock.getUIElements(), ...this.frequentlyUsedBlock.getUIElements()]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.colorsBlock.getUIElements().forEach((Kn) => {
        Kn.isEnableFocus() && Un.push(Kn);
      }), this.frequentlyUsedBlock.getUIElements().forEach((Kn) => {
        Kn.isEnableFocus() && Un.push(Kn);
      }), Un;
    });
    Ca(this, "sendSelectColor", (Un) => {
      this.frequentlyUsedBlock.setUsedColors(Un);
    });
    Ca(this, "setPalettePosition", (Un) => {
      this.configuration.x = Un.x, this.configuration.y = Un.y;
      const { x: Kn, y: qn, padding: Jo, separatorThickness: pa, separatorPadding: ma } = this.configuration;
      this.container.relativePosition = {
        x: Kn,
        y: qn
      };
      const { sizeColorexCircle: va, paddingColorexCircle: ba } = this.colorsBlock.getConfiguration(), _a = va + ba;
      this.separator.relativePosition = {
        x: Kn + Jo,
        y: qn + Jo + va + ba
      }, this.frequentlyUsedBlock.setPosition({
        x: Jo,
        y: Jo
      }), this.colorsBlock.setPosition({
        x: Jo,
        y: Jo + _a + ma * 2 + pa
      });
    });
    /**
     * Проверяет, не выходит ли элемент за границы экрана. Если это происходит, то метод исправляет положение элемента.
     */
    Ca(this, "checkAndFixPalettePosition", () => {
      const { x: Un, y: Kn } = this.configuration, qn = this.dependencies.render.getWidth(), Jo = this.dependencies.render.getHeight() * 2, pa = qn - this.getWidth(), ma = Jo - this.getHeight();
      let va = Un, ba = Kn;
      Kn < 0 ? ba = 0 : Kn > ma && (ba = ma), Un < 0 ? va = 0 : Un > pa && (va = pa), this.setPalettePosition({
        x: va,
        y: ba
      });
    });
    Ca(this, "addPostSelectColorListeners", (...Un) => {
      this.frequentlyUsedBlock.addPostSelectColorListeners(...Un), this.colorsBlock.addPostSelectColorListeners(...Un);
    });
    Ca(this, "addPrevSelectColorListeners", (...Un) => {
      this.frequentlyUsedBlock.addPrevSelectColorListeners(...Un), this.colorsBlock.addPrevSelectColorListeners(...Un);
    });
    this.isShow = !1, this.isResetFocus = !1, this.frequentlyUsedBlock = new ColorexFrequentlyUsed(!1), this.colorsBlock = new ColorexColorsBlock(), this.area = new SpatialUIColorexPaletteArea(this), this.configuration = {
      x: 0,
      y: 0,
      padding: this.DEFAULT_PADDING,
      separatorColor: this.DEFAULT_SEPARATOR_COLOR,
      separatorThickness: this.DEFAULT_SEPARATOR_THICKNESS,
      separatorPadding: this.DEFAULT_SEPARATOR_PADDING
    }, this.separator = {
      object: new pr({
        left: 0,
        top: 0,
        width: this.colorsBlock.getWidth(),
        height: this.configuration.separatorThickness,
        fill: this.configuration.separatorColor,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.separator.object.visible = !1, this.container = {
      object: new pr({
        left: 0,
        top: 0,
        visible: !1,
        fill: UIDefaultColor.WHITE,
        width: this.getWidth(),
        height: this.getHeight(),
        rx: 8,
        ry: 8,
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        }
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn } = Un;
      this.frequentlyUsedBlock.forceInjectDependencies({ render: Kn }), this.colorsBlock.forceInjectDependencies({
        render: Kn,
        frequentlyUsedBlock: this.frequentlyUsedBlock
      });
    });
  }
  callClick() {
  }
  disableFocus() {
  }
  disableHover() {
  }
  enableFocus() {
  }
  enableHover() {
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  // public connectPalette = (palette: ColorexPalette) => {
  // 	this.palettes.push(palette);
  // };
  // public getContainer = () => this.paletteContainerElement;
  // private onDocumentClick = (ev: MouseEvent) => {
  // 	if (ev.target instanceof HTMLElement) {
  // 		for (let i = 0; i < this.palettes.length; i++) {
  // 			const palette = this.palettes[i];
  // 			const paletteClassName = palette.getClassName();
  // 			const isPaletteClick = ev.target.closest(`.${paletteClassName}`);
  // 			const targetElement = palette.getTargetElement();
  // 			if (targetElement instanceof HTMLElement) {
  // 				const isTargetClick = targetElement.contains(ev.target);
  // 				if (!isTargetClick && isPaletteClick === null) {
  // 					const isShow = palette.isShow();
  // 					if (isShow) {
  // 						palette.hidden();
  // 					}
  // 				}
  // 			}
  // 		}
  // 	}
  // };
}
class SpatialUIEditCornerObjectArea extends SpatialArea {
  constructor(Un) {
    super();
    Ca(this, "type", SpatialUIAreaType.EDIT_CORNER);
    Ca(this, "getGlobalFrameArea", () => this.editCornerObject.getFrameArea());
    Ca(this, "getData", () => this.editCornerObject);
    Ca(this, "isResizeType", () => !1);
    Ca(this, "isAllowMutatePosition", () => !1);
    Ca(this, "getRelatedFrames", () => []);
    this.editCornerObject = Un;
  }
}
class EditCornerObject extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_PADDING", 18);
    Ca(this, "DEFAULT_TITLE", "Радиус углов");
    Ca(this, "DEFAULT_FILL_BAR", "#FFFFFF");
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "DEFAULT_TITLE_FONT_SIZE", 16);
    Ca(this, "DEFAULT_MARGIN_INPUT", 6);
    Ca(this, "DEFAULT_HEIGHT_CORNER_BLOCK", 32);
    Ca(this, "DEFAULT_WIDTH_INPUT", 80);
    Ca(this, "DEFAULT_TITLE_MARGIN_BOTTOM", 10);
    Ca(this, "container");
    Ca(this, "title");
    Ca(this, "inputLeftTop");
    Ca(this, "inputRightTop");
    Ca(this, "inputRightBottom");
    Ca(this, "inputLeftBottom");
    Ca(this, "area");
    Ca(this, "configuration");
    Ca(this, "isShow");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    /**
     * Включает видимость панели.
     */
    Ca(this, "show", () => {
      this.isShow || (this.isShow = !0, this.container.object.visible = !0, this.title.object.visible = !0, this.inputLeftTop.show(), this.inputRightTop.show(), this.inputRightBottom.show(), this.inputLeftBottom.show());
    });
    /**
     * Отключает видимость панели.
     */
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.container.object.visible = !1, this.title.object.visible = !1, this.inputLeftTop.hide(), this.inputRightTop.hide(), this.inputRightBottom.hide(), this.inputLeftBottom.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    Ca(this, "setCornerRadius", (Un) => {
      this.inputLeftTop.setValue(Un.topLeft.toString()), this.inputLeftBottom.setValue(Un.bottomLeft.toString()), this.inputRightTop.setValue(Un.topRight.toString()), this.inputRightBottom.setValue(Un.bottomRight.toString());
    });
    /**
     * Возвращает конфигурацию панели.
     */
    Ca(this, "getConfiguration", () => this.configuration);
    Ca(this, "setConfiguration", (Un) => {
      const Kn = this.configuration, qn = Un(Kn);
      qn.x -= this.getWidth() / 2, this.configuration = qn, this.sync();
    });
    Ca(this, "getWidth", () => {
      const { padding: Un, widthInput: Kn, marginInput: qn } = this.configuration;
      return Un * 2 + Kn * 2 + qn;
    });
    Ca(this, "getHeight", () => {
      const { padding: Un, marginInput: Kn, heightBlocks: qn, titleMarginBottom: Jo, titleFontSize: pa } = this.configuration;
      return Un * 2 + pa + Jo + qn * 2 + Kn;
    });
    /**
     * Синхронизирует все параметры панели.
     */
    Ca(this, "sync", () => {
      const { marginInput: Un, padding: Kn, fill: qn, titleFontSize: Jo, heightBlocks: pa, widthInput: ma, x: va, y: ba, titleMarginBottom: _a } = this.configuration;
      this.container.object.set({
        width: this.getWidth(),
        height: this.getHeight(),
        fill: qn
      }), this.container.relativePosition = {
        x: va,
        y: ba
      }, this.title.relativePosition = {
        x: va + Kn,
        y: ba + Kn
      }, this.inputLeftTop.setConfiguration((ya) => ({
        ...ya,
        x: Kn,
        y: Kn + Jo + _a,
        width: ma,
        height: pa
      })), this.inputRightTop.setConfiguration((ya) => ({
        ...ya,
        x: Kn + ma + Un,
        y: Kn + Jo + _a,
        width: ma,
        height: pa
      })), this.inputRightBottom.setConfiguration((ya) => ({
        ...ya,
        x: Kn + ma + Un,
        y: Kn + Jo + _a + pa + Un,
        width: ma,
        height: pa
      })), this.inputLeftBottom.setConfiguration((ya) => ({
        ...ya,
        x: Kn,
        y: Kn + Jo + _a + pa + Un,
        width: ma,
        height: pa
      }));
    });
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      this.title.object,
      ...this.inputLeftTop.getFabricObjects(),
      ...this.inputRightTop.getFabricObjects(),
      ...this.inputLeftBottom.getFabricObjects(),
      ...this.inputRightBottom.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      this.title,
      ...this.inputLeftTop.getObjects(),
      ...this.inputRightTop.getObjects(),
      ...this.inputLeftBottom.getObjects(),
      ...this.inputRightBottom.getObjects()
    ]);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getRelativePosition", () => ({
      x: this.configuration.x,
      y: this.configuration.y
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "getUIElements", () => [
      this.inputLeftTop,
      this.inputRightTop,
      this.inputRightBottom,
      this.inputLeftBottom
    ]);
    Ca(this, "getFocusUIElements", () => {
      const Un = [];
      return this.inputLeftTop.isEnableFocus() && Un.push(this.inputLeftTop), this.inputRightTop.isEnableFocus() && Un.push(this.inputRightTop), this.inputRightBottom.isEnableFocus() && Un.push(this.inputRightBottom), this.inputLeftBottom.isEnableFocus() && Un.push(this.inputLeftBottom), Un;
    });
    this.isShow = !1, this.isResetFocus = !0, this.area = new SpatialUIEditCornerObjectArea(this), this.configuration = {
      marginInput: this.DEFAULT_MARGIN_INPUT,
      padding: this.DEFAULT_PADDING,
      fill: this.DEFAULT_FILL_BAR,
      cornerRadius: this.DEFAULT_CORNER_RADIUS,
      titleFontSize: this.DEFAULT_TITLE_FONT_SIZE,
      heightBlocks: this.DEFAULT_HEIGHT_CORNER_BLOCK,
      widthInput: this.DEFAULT_WIDTH_INPUT,
      titleMarginBottom: this.DEFAULT_TITLE_MARGIN_BOTTOM,
      x: 0,
      y: 0
    }, this.container = {
      object: new pr({
        rx: this.configuration.cornerRadius,
        ry: this.configuration.cornerRadius,
        shadow: {
          color: UIDefaultColor.SHADOW,
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1
        },
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.title = {
      object: new Xo(this.DEFAULT_TITLE, {
        fontSize: this.configuration.titleFontSize,
        fill: UIDefaultColor.GRAY_900,
        fontFamily: FontFamily.DEFAULT,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.inputLeftTop = new LeftTopInput(), this.inputRightTop = new RightTopInput(), this.inputRightBottom = new RightBottomInput(), this.inputLeftBottom = new LeftBottomInput(), this.addPostInjectDependenciesListener((Un) => {
      this.inputLeftTop.forceInjectDependencies({
        render: Un.render,
        textEngine: Un.textEngine
      }), this.inputRightTop.forceInjectDependencies({
        render: Un.render,
        textEngine: Un.textEngine
      }), this.inputRightBottom.forceInjectDependencies({
        render: Un.render,
        textEngine: Un.textEngine
      }), this.inputLeftBottom.forceInjectDependencies({
        render: Un.render,
        textEngine: Un.textEngine
      }), this.inputLeftTop.addPostChangeTextListener(() => {
        Un.useCases.setFocusComponentsBorderRadius({
          topLeft: this.inputLeftTop.getValue(),
          topRight: this.inputRightTop.getValue(),
          bottomRight: this.inputRightBottom.getValue(),
          bottomLeft: this.inputLeftBottom.getValue()
        });
      }), this.inputLeftBottom.addPostChangeTextListener(() => {
        Un.useCases.setFocusComponentsBorderRadius({
          topLeft: this.inputLeftTop.getValue(),
          topRight: this.inputRightTop.getValue(),
          bottomRight: this.inputRightBottom.getValue(),
          bottomLeft: this.inputLeftBottom.getValue()
        });
      }), this.inputRightTop.addPostChangeTextListener(() => {
        Un.useCases.setFocusComponentsBorderRadius({
          topLeft: this.inputLeftTop.getValue(),
          topRight: this.inputRightTop.getValue(),
          bottomRight: this.inputRightBottom.getValue(),
          bottomLeft: this.inputLeftBottom.getValue()
        });
      }), this.inputRightBottom.addPostChangeTextListener(() => {
        Un.useCases.setFocusComponentsBorderRadius({
          topLeft: this.inputLeftTop.getValue(),
          topRight: this.inputRightTop.getValue(),
          bottomRight: this.inputRightBottom.getValue(),
          bottomLeft: this.inputLeftBottom.getValue()
        });
      });
    });
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  callClick() {
  }
  disableFocus() {
  }
  disableHover() {
  }
  enableFocus() {
  }
  enableHover() {
  }
}
class BaseUI extends Dependent {
  constructor() {
    super();
  }
}
class DesktopUI extends BaseUI {
  constructor() {
    super();
    Ca(this, "socketIndicator");
    Ca(this, "colorexCore");
    Ca(this, "propertyPanels");
    Ca(this, "bars");
    Ca(this, "editCornerObject");
    Ca(this, "isShow");
    Ca(this, "show", async () => {
      this.isShow || (this.isShow = !0, this.bars.forEach((Un) => Un.show()), await this.sync());
    });
    Ca(this, "hide", () => {
      this.isShow && (this.isShow = !1, this.bars.forEach((Un) => Un.hide()), this.hideAllPanels(), this.colorexCore.hide());
    });
    Ca(this, "isShowed", () => this.isShow);
    /**
     * Скрывает панели.
     */
    Ca(this, "hideAllPanels", () => {
      this.propertyPanels.forEach((Un) => Un.hide());
    });
    /**
     * Скрывает все панели кроме полученных
     * @param panels - Панели.
     */
    Ca(this, "hidePanelsExcept", (...Un) => {
      this.propertyPanels.forEach((Kn) => {
        Un.includes(Kn) || Kn.hide();
      });
    });
    this.isShow = !0, this.bars = [], this.propertyPanels = [], this.colorexCore = new ColorexCore(), this.editCornerObject = new EditCornerObject(), this.socketIndicator = new UISocketIndicator();
  }
  haveActiveElement() {
    return !0;
  }
  disableInjectingElements() {
  }
}
class PrivateTemplateDesktopUI extends DesktopUI {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_PANEL", 8);
    Ca(this, "topBar");
    Ca(this, "toolBar");
    Ca(this, "propertyPageBar");
    Ca(this, "propertyObjectBar");
    Ca(this, "propertyFigureBar");
    Ca(this, "propertyTextBar");
    Ca(this, "propertyTableBar");
    Ca(this, "propertyLineBar");
    Ca(this, "generationHint");
    Ca(this, "templateMenu");
    Ca(this, "tableConstructor");
    Ca(this, "undoButton");
    Ca(this, "redoButton");
    Ca(this, "disableFocusAIModal", () => {
      this.toolBar.getUIElements().forEach((Un) => Un.disableFocus());
    });
    Ca(this, "getSpatialAreas", () => {
      const Un = this.getUIElementsAll(), Kn = [];
      for (let qn = 0; qn < Un.length; qn++)
        Un[qn].isShowed() && (Kn.push(Un[qn].getSpatialArea()), Un[qn] instanceof ColorInput && Un[qn].isEnableShowPalette() && Kn.push(...Un[qn].getSpatialAreasPalette()));
      return Kn;
    });
    Ca(this, "getObjects", () => [
      // 1 слой контейнеры панелей
      ...this.toolBar.getFabricObjects(),
      this.propertyPageBar.getContainer(),
      this.propertyObjectBar.getContainer(),
      this.propertyFigureBar.getContainer(),
      this.propertyTextBar.getContainer(),
      this.propertyTableBar.getContainer(),
      this.propertyLineBar.getContainer(),
      this.topBar.getFabricContainer(),
      // 2 слой кнопки и заголовки
      // ...this.toolBar.getPanels().map(panel => panel.getButtons()).flat(),
      ...this.propertyPageBar.getContentElements(),
      ...this.propertyObjectBar.getContentElements(),
      ...this.propertyFigureBar.getContentElements(),
      ...this.propertyTableBar.getContentElements(),
      ...this.propertyLineBar.getContentElements(),
      ...this.propertyTextBar.getContentElements(),
      ...this.topBar.getFabricContentElements(),
      // 3 слой модалки, палитра и т.д.
      ...this.tableConstructor.getFabricObjects(),
      ...this.colorexCore.getFabricObjects(),
      ...this.generationHint.getFabricObjects(),
      ...this.templateMenu.getFabricObjects(),
      ...this.colorexCore.getFabricObjects(),
      ...this.editCornerObject.getFabricObjects(),
      ...this.socketIndicator.getFabricObject(),
      ...this.dependencies.contextMenu.getFabricObjects()
    ]);
    Ca(this, "sync", async () => {
      if (this.toolBar.sync(), this.topBar.syncPosition(), this.propertyPageBar.syncPosition(), this.propertyObjectBar.syncPosition(), this.propertyFigureBar.syncPosition(), this.propertyTextBar.syncPosition(), this.propertyTableBar.syncPosition(), this.propertyLineBar.syncPosition(), !this.isShowed())
        return;
      const Un = this.dependencies.componentTree.getFocusComponents(), Kn = this.dependencies.actionStore.getUndoCommandCount(), qn = this.dependencies.actionStore.getRedoCommandCount(), Jo = this.dependencies.componentTree.getRootComponent().getFirstGraphic();
      if (Kn < 1 ? this.undoButton.setIsEnableClick(!1) : this.undoButton.setIsEnableClick(!0), qn < 1 ? this.redoButton.setIsEnableClick(!1) : this.redoButton.setIsEnableClick(!0), Un === null) {
        Jo && (this.propertyPageBar.syncComponent(Jo), this.propertyPageBar.show()), this.propertyObjectBar.hide(), this.hidePanelsExcept(this.propertyPageBar);
        return;
      }
      this.propertyPageBar.hide(), this.propertyObjectBar.show(), this.propertyObjectBar.syncComponent(Un);
      const pa = Un[0];
      Un.every((va) => va.type === pa.type) && this.syncForSameComponentType(Un, pa.type), this.toolBar.show(), this.topBar.show();
    });
    Ca(this, "setActiveTariff", (Un) => {
      Un || this.topBar.setState(TopBarState.AI_PDF);
    });
    Ca(this, "setStateLoadingSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.LOADING);
    });
    Ca(this, "setStateSuccessSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.SUCCESS);
    });
    Ca(this, "setStateErrorSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.ERROR);
    });
    Ca(this, "setNameTemplate", (Un) => {
      this.topBar.setTitle(Un);
    });
    Ca(this, "getUIElements", () => [
      ...this.toolBar.getUIElements(),
      this.colorexCore,
      this.tableConstructor,
      this.propertyTextBar,
      this.propertyFigureBar,
      this.propertyObjectBar,
      this.propertyPageBar,
      this.propertyTableBar,
      this.propertyLineBar,
      this.topBar,
      this.templateMenu,
      this.editCornerObject,
      this.dependencies.contextMenu,
      this.socketIndicator
    ]);
    // Метод возвращает общий массив со всеми элементами интерфейса (включает все дочерние элементы внутри панелей)
    Ca(this, "getUIElementsAll", () => {
      const Un = [], Kn = this.getUIElements();
      for (let qn = 0; qn < Kn.length; qn++)
        Un.push(Kn[qn]), Un.push(...this.getChildrenAllUIElements(Kn[qn]));
      return [...Un];
    });
    Ca(this, "getChildrenAllUIElements", (Un) => {
      const Kn = [], qn = Un.getUIElements();
      for (const Jo of qn)
        Kn.push(Jo), Kn.push(...this.getChildrenAllUIElements(Jo));
      return Kn;
    });
    Ca(this, "getFocusUIElements", () => [
      ...this.toolBar.getUIElements(),
      this.tableConstructor,
      ...this.tableConstructor.getUIElements(),
      this.propertyTextBar,
      ...this.propertyTextBar.getFocusUIElements(),
      this.propertyPageBar,
      ...this.propertyPageBar.getFocusUIElements(),
      this.propertyFigureBar,
      ...this.propertyFigureBar.getFocusUIElements(),
      this.propertyObjectBar,
      ...this.propertyObjectBar.getFocusUIElements(),
      // this.colorexPalette,
      // ...this.colorexPalette.getFocusUIElements(),
      this.topBar,
      ...this.topBar.getFocusUIElements(),
      this.propertyTableBar,
      ...this.propertyTableBar.getFocusUIElements(),
      this.propertyLineBar,
      ...this.propertyLineBar.getFocusUIElements(),
      ...this.editCornerObject.getFocusUIElements()
    ]);
    /**
     * Синхронизировать интерфейс для компонентов одного типа.
     * @param components - компоненты для сканирования.
     * @param type - тип компонентов.
     * @private
     */
    Ca(this, "syncForSameComponentType", (Un, Kn) => {
      switch (Kn) {
        case EditorComponentType.TABLE: {
          const qn = [];
          Un.forEach((Jo) => {
            const pa = Jo.getFocusCellContexts();
            pa !== null && qn.push(...pa);
          }), this.propertyTextBar.syncComponent(qn), this.propertyTextBar.setConfiguration((Jo) => ({
            ...Jo,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTextBar.show(), this.propertyTableBar.syncComponent(Un), this.propertyTableBar.setConfiguration((Jo) => ({
            ...Jo,
            marginTop: this.propertyTextBar.getGlobalPosition().y + this.propertyTextBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTableBar.show(), this.hidePanelsExcept(this.propertyTextBar, this.propertyTableBar);
          break;
        }
        case EditorComponentType.TEXT:
          this.propertyTextBar.syncComponent(Un), this.propertyTextBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTextBar.show(), this.hidePanelsExcept(this.propertyTextBar);
          break;
        case EditorComponentType.FIGURE:
          this.propertyFigureBar.syncComponent(Un), this.propertyFigureBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyFigureBar.show(), this.hidePanelsExcept(this.propertyFigureBar);
          break;
        case EditorComponentType.LINE:
          this.propertyLineBar.syncComponent(Un), this.propertyLineBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyLineBar.show();
          break;
        case EditorComponentType.GROUP:
          this.propertyObjectBar.hide(), this.hideAllPanels();
          break;
        case EditorComponentType.BOOK:
          this.hideAllPanels();
          break;
        case EditorComponentType.MODULE:
          this.hideAllPanels();
          break;
        case EditorComponentType.PICTURE:
          this.hideAllPanels();
          break;
      }
    });
    this.toolBar = new ToolBar(), this.topBar = new TopBar(), this.generationHint = new GenerationHint(), this.templateMenu = new PrivateTemplateTemplateMenu(), this.propertyPageBar = new PropertyPageBar(), this.propertyObjectBar = new PropertyObjectBar(), this.propertyFigureBar = new PropertyFigureBar(), this.propertyTextBar = new PropertyTextBar(), this.propertyTableBar = new PropertyTableBar(), this.propertyLineBar = new PropertyLineBar(), this.tableConstructor = new TableConstructorView();
    const Un = new ToolUndoButton(), Kn = new ToolRedoButton();
    this.undoButton = Un, this.redoButton = Kn, this.propertyPanels.push(
      this.propertyPageBar,
      this.propertyFigureBar,
      this.propertyTextBar,
      this.propertyTableBar,
      this.propertyLineBar
    ), this.bars.push(
      ...this.toolBar.getPanels(),
      this.topBar,
      this.generationHint,
      this.templateMenu,
      this.propertyObjectBar
    ), this.addPostInjectDependenciesListener((qn) => {
      const {
        render: Jo,
        useCases: pa,
        textEngine: ma,
        onOpenModulesModal: va,
        onBackPage: ba,
        onDownloadPDF: _a,
        onSendOffer: ya,
        onOpenCreateCustomTableWindow: xa,
        onGoToTariff: wa,
        onGetGenerationHintStructure: Ta,
        onSetNameTemplate: Sa,
        actionController: Ma,
        onOpenAIActionsModal: ka,
        onCloseAIActionsModal: Za
      } = qn;
      this.tableConstructor.forceInjectDependencies({
        useCases: pa,
        render: qn.render,
        onOpenCreateCustomTableWindow: xa
      });
      const Na = new ToolPanel().forceInjectDependencies({ render: Jo }), Ka = new ToolAIButton().forceInjectDependencies({
        render: Jo,
        onOpenAIActionsModal: ka,
        onCloseAIActionsModal: Za
      }), Ja = new ToolPanel().forceInjectDependencies({ render: Jo }), el = new ToolTextButton().forceInjectDependencies({
        render: Jo,
        useCases: pa
      }), qa = new ToolTableButton().forceInjectDependencies({
        render: Jo,
        useCases: pa,
        tableConstructor: this.tableConstructor
      });
      qa.enableClickFocus();
      const tl = new ToolPictureButton().forceInjectDependencies({ render: Jo, useCases: pa }), Qa = new ToolRectangleButton().forceInjectDependencies({ render: Jo, useCases: pa }), nl = new ToolLineButton().forceInjectDependencies({ render: Jo, useCases: pa }), rl = new ToolPanel();
      Un.forceInjectDependencies({ render: Jo, useCases: pa }), Un.disableClickFocus(), Kn.forceInjectDependencies({ render: Jo, useCases: pa }), Kn.disableClickFocus();
      const il = new ToolPanel(), cl = new ToolModuleButton().forceInjectDependencies({ render: Jo, onOpenModulesModal: va });
      Ja.addButtons(el, qa, tl, Qa, nl), Na.addButtons(Ka), rl.addButtons(Un, Kn), il.addButtons(cl), this.toolBar.addPanel(Na), this.toolBar.addPanel(Ja), this.toolBar.addPanel(rl), this.toolBar.addPanel(il), this.bars.push(...this.toolBar.getPanels(), this.topBar, this.propertyObjectBar), this.propertyPageBar.forceInjectDependencies({
        useCases: pa,
        render: Jo,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyObjectBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        textEngine: ma,
        editCornerObject: this.editCornerObject
      }), this.propertyFigureBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyTextBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyTableBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore
      }), this.propertyLineBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.topBar.forceInjectDependencies({
        render: Jo,
        templateMenu: this.templateMenu,
        generationHint: this.generationHint,
        useCases: pa,
        onBackPage: ba,
        textEngine: ma,
        onSetNameTemplate: Sa,
        actionController: Ma,
        onGetGenerationHintStructure: Ta
      }), this.topBar.show(), this.templateMenu.forceInjectDependencies({ render: Jo, onDownloadPDF: _a, onSendOffer: ya }), this.colorexCore.forceInjectDependencies({
        render: Jo
      }), this.generationHint.forceInjectDependencies({ render: Jo, onGoToTariff: wa, onGetGenerationHintStructure: Ta }), this.editCornerObject.forceInjectDependencies({
        render: Jo,
        textEngine: ma,
        useCases: pa
      }), this.socketIndicator.forceInjectDependencies({
        render: Jo
      }), this.socketIndicator.show(), this.socketIndicator.sync();
    });
  }
}
class StaticComponentTree extends ComponentTree {
  constructor(zn) {
    super(zn);
  }
}
class LayerRegistry extends BaseLayerRegistry {
  constructor() {
    super();
    /**
     * Загружает структуру графики и строит дерево слоев.
     *
     * Распределение графики по дереву основано на значении `layer` в `FrameConfiguration` у каждого элемента.
     * Алгоритм использует стек для отслеживания вложенности, чтобы правильно определять родительские и дочерние узлы.
     * - Если уровень `layer` текущего элемента больше, чем у вершины стека, он становится дочерним.
     * - Если уровень `layer` меньше или равен, элементы стека удаляются, пока не будет найден подходящий родитель.
     * - Каждый новый элемент добавляется в дерево в зависимости от найденного родительского узла.
     *
     * @param structure Структура компонентов для загрузки.
     */
    Ca(this, "load", (Un) => {
      const Kn = this.dependencies.componentTree.getComponents();
      if (Kn.length === 0)
        throw new EditorError("component tree not initialized");
      const qn = /* @__PURE__ */ new Map(), Jo = /* @__PURE__ */ new Map();
      Kn.flatMap((va) => va.getGraphics()).forEach((va) => {
        qn.set(va.getID(), va), Jo.set(va, va.getParentGraphic());
      });
      const ma = this.getFlatStructure(Un, qn);
      if (ma.length === 0)
        throw new EditorError("graphics structure is empty");
      this.rootNode.setData(ma[0]), this.rootNode.setName(ma[0].getShortID()), this.buildTree(ma, Jo);
    });
    Ca(this, "sync", () => {
      this.recursiveSync(this.rootNode, 0);
    });
    Ca(this, "getPrevGraphic", (Un) => {
      const Kn = this.tree.getLayerFromData(Un);
      if (Kn === null)
        throw new EditorError("graphic not connected to tree");
      const qn = Kn.getAbsolutePosition();
      if (qn === 0)
        return null;
      const Jo = this.tree.getLayerFromAbsolutePosition(qn - 1);
      if (Jo === null)
        throw new EditorError("node not found");
      const pa = Jo.getData();
      if (Un === null)
        throw new EditorError("graphic not found");
      return pa;
    });
    Ca(this, "appendGraphic", (Un, Kn) => {
      const qn = this.tree.getLayers();
      if (qn === null)
        throw new EditorError("layers not found");
      const Jo = qn[qn.length - 1];
      if (this.tree.getLayerFromData(Un) !== null)
        throw new EditorError("the graphics are already in the tree");
      const ma = new LayerItem(Un, Un.getShortID());
      return this.tree.addLayers(Jo, ma), this.sync(), ma;
    });
    // TODO убрать из базового класса
    Ca(this, "setSequences", (Un, Kn) => {
      throw new EditorError("not implemented");
    });
    Ca(this, "getFlatStructure", (Un, Kn) => {
      const qn = [], Jo = [];
      if (this.recursiveAccumGraphics(Un, Jo), Jo.sort((pa, ma) => {
        if (pa.frame === null || ma.frame === null)
          throw new EditorError("frame configuration is missing in graphic structure");
        return pa.frame.layer - ma.frame.layer;
      }), Jo.forEach((pa) => {
        const ma = Kn.get(pa.id);
        if (ma === void 0)
          throw new EditorError("graphic not found");
        qn.push(ma);
      }), Jo.length !== qn.length)
        throw new EditorError("graphics structure does not match the expected count");
      return qn;
    });
    Ca(this, "recursiveAccumGraphics", (Un, Kn) => {
      Un.graphics !== null && Kn.push(...Un.graphics), Un.components !== null && Un.components.forEach((qn) => this.recursiveAccumGraphics(qn, Kn));
    });
    /**
     * Строит дерево слоев на основе отсортированной структуры графики.
     *
     * Использует отображение `graphicToParent` для корректного связывания узлов.
     * - Если у графического элемента есть родитель, он привязывается к нему.
     * - Если родителя нет (`null` в `graphicToParent`), он привязывается к `rootNode`.
     *
     * @param flatStructure Отсортированный массив графических элементов.
     * @param graphicToParent Словарь, связывающий каждый графический элемент с его родителем.
     *                        Если значение `null`, графика привязывается к `rootNode`.
     * @throws {EditorError} Если отсутствует необходимая информация о графике или её родителе.
     */
    Ca(this, "buildTree", (Un, Kn) => {
      const qn = /* @__PURE__ */ new Map();
      Un.forEach((Jo) => {
        const pa = Jo.getFrameConfiguration();
        if (!pa)
          throw new EditorError("Frame configuration not found");
        const ma = pa.layer;
        if (ma < 0)
          throw new EditorError(`Invalid layer ${ma} for graphic ${Jo.getID()}`);
        const va = new LayerItem(Jo, Jo.getShortID());
        qn.set(Jo, va);
        const ba = Kn.get(Jo), _a = ba ? qn.get(ba) : this.rootNode;
        if (!_a)
          throw new EditorError(`Parent node not found for graphic ${Jo.getID()}`);
        _a.addLayers(va);
      });
    });
    this.tree.setRootLayer(this.rootNode);
  }
}
class ComponentPreviewEditor extends StaticEditor {
  constructor(Un) {
    const Kn = document.createElement("div");
    Kn.style.position = "absolute", Kn.style.top = "0px", document.body.append(Kn);
    super(Kn);
    Ca(this, "useCases");
    Ca(this, "componentTree");
    Ca(this, "layerRegistry");
    Ca(this, "canvasOrganizer");
    Ca(this, "getPreview", async () => new Promise((Un, Kn) => {
      requestAnimationFrame(() => {
        this.canvas.lowerCanvasEl.toBlob((qn) => {
          qn ? Un(qn) : Kn(new Error("Ошибка при создании Blob изображения")), this.editorContainer.remove();
        }, "image/png");
      });
    }));
    Ca(this, "setStructure", async (Un) => {
      var Kn;
      if (((Kn = Un.root.graphics) == null ? void 0 : Kn.length) !== 1)
        throw new EditorError("invalid structure: expected exactly one graphic element");
      this.correctCanvas(Un.root), await this.componentTree.load(Un.root), this.canvasRender.render();
    });
    Ca(this, "correctCanvas", (Un) => {
      if (Un.graphics === null)
        throw new EditorError("structure graphics not found");
      const Kn = Un.graphics[0];
      if (Kn === void 0)
        throw new EditorError("graphic structure not found");
      if (Kn.frame === null)
        throw new EditorError("frame configuration not found");
      const { width: qn, height: Jo } = Kn.frame;
      this.canvas.setDimensions({
        width: qn + 1,
        height: Jo + 1
      }), this.canvas.backgroundColor = "";
    });
    this.useCases = null, this.layerRegistry = new LayerRegistry(), this.canvasOrganizer = new StaticCanvasObjectOrganizer(), this.componentTree = new StaticComponentTree(this.canvas), this.layerRegistry.connectDependencies({ componentTree: this.componentTree }), this.componentTree.connectDependencies({
      componentFactory: this.componentFactory,
      layerRegistry: this.layerRegistry,
      graphicFactory: this.graphicFactory
    }), this.canvasOrganizer.connectDependencies({
      layerRegistry: this.layerRegistry
    }), this.canvasRender.connectDependencies({
      canvas: this.canvas,
      layerRegistry: this.layerRegistry,
      canvasObjectOrganizer: this.canvasOrganizer
    }), this.graphicFactory.connectDependencies({
      componentTree: this.componentTree,
      imageFileSourcePrefix: Un.imageFileSourcePrefix
    }), this.layerRegistry.injectDependencies(), this.componentTree.injectDependencies(), this.canvasOrganizer.injectDependencies(), this.canvasRender.injectDependencies(), this.graphicFactory.injectDependencies();
  }
}
class XLSXTableImporter extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "EMPTY_CELL_VALUE", "");
    /**
     * Формирует структуру таблицы через запуск загрузки XLSX файла и возвращает её в callback.
     * @param loadStructure Callback для отправки структуры таблицы.
     */
    Ca(this, "getStructure", (Un) => {
      this.dependencies.onUploadXlsxFile(() => {
      }).then((Kn) => {
        const qn = readSync(Kn, {
          type: "buffer",
          cellStyles: !0
          // raw: true,
          // bookDeps: true,
          // dense: true,
          // bookVBA: true,
          // bookProps: true,
          // cellFormula: true,
          // cellHTML: true,
          // cellNF: true,
          // cellText: true,
          // cellDates: true,
          // sheetStubs: true,
          // bookFiles: true,
          // bookVBA: true,
          // WTF: true,
        });
        if (this.isEmptyWorkbook(qn))
          return;
        const pa = [];
        qn.SheetNames.forEach((ma) => {
          const va = this.convertSheetToStructure(qn, ma);
          pa.push(va);
        }), Un(pa);
      });
    });
    /**
     * Проверяет, пустой ли лист в файле XLSX.
     * @param workbook Полное описание страницы в файле.
     */
    Ca(this, "isEmptyWorkbook", (Un) => Un.SheetNames.length < 1 ? !0 : !Un.SheetNames.every((Kn) => {
      if (Un.Sheets[Kn] === void 0)
        throw new EditorError("the sheet not found");
      return !0;
    }));
    /**
     * Конвертирует страницу XLSX в структуру таблицы.
     * @param workbook Структура страницы XLSX.
     * @param sheetName Имя страницы.
     */
    Ca(this, "convertSheetToStructure", (Un, Kn) => {
      const qn = {
        cells: [],
        columnCount: 0,
        rowCount: 0
      }, Jo = Un.Sheets[Kn], pa = Un.Sheets[Kn]["!merges"], ma = utils.sheet_to_json(Jo, {
        header: 1,
        defval: ""
      });
      ma.length > 1e3 && ma.splice(1e3);
      const va = Math.max(...ma.map((xa) => xa.length)), ba = Un.Sheets[Kn]["!cols"];
      if (ba !== void 0 && ba.length < 1)
        throw new EditorError("invalid sheet cols");
      const _a = ma.map(
        (xa, wa) => xa.map((Ta, Sa) => {
          const Ma = Ta.toString().trim();
          if (Ma === this.EMPTY_CELL_VALUE)
            return null;
          const ka = Utils.component.getDefaultCellTexture(Ma, wa, Sa);
          return pa !== void 0 && this.setCellTextureSpan(pa, ka, Sa, wa), ka;
        })
      ), ya = [];
      return _a.forEach((xa, wa) => {
        xa.forEach((Ta, Sa) => {
          if (Ta !== null)
            for (let Ma = wa; Ma < wa + Ta.rowSpan; Ma++) {
              ya[Ma] === void 0 && (ya[Ma] = []);
              for (let ka = Sa; ka < Sa + Ta.columnSpan; ka++)
                ya[Ma][ka] = Ta.id;
            }
        });
      }), this.convertEmptyToEmptyCells(_a, va, ya), qn.cells = this.flatCells(_a), qn.rowCount = ya.length, qn.columnCount = va, qn;
    });
    /**
     * Возвращает из двумерного массива текстур ячеек линейный массив.
     * @param cells Двумерный массив ячеек, отражающий структуру таблицы.
     */
    Ca(this, "flatCells", (Un) => Un.flatMap((Kn) => Kn.filter((qn) => qn !== null)));
    /**
     * Записывает в ячейки информации об их объединении на основании объекта `merges`.
     * @param merges Объект с информацией об объединении ячеек.
     * @param cellTexture Текстура ячейки для обновления.
     * @param columnIndex Индекс столбца ячейки.
     * @param rowIndex Индекс строки ячейки.
     */
    Ca(this, "setCellTextureSpan", (Un, Kn, qn, Jo) => {
      const pa = Un.find((ma) => ma.s.c === qn && ma.s.r === Jo);
      pa !== void 0 && (Kn.rowSpan = pa.e.r - pa.s.r + 1, Kn.columnSpan = pa.e.c - pa.s.c + 1);
    });
    /**
     * Заполняет пустующие (не те, которые занимают ячейки в объединении, а с полным отсутствием в ней ячейки)
     * координаты таблицы.
     * @param cells Матрица текстур ячеек таблицы с пустующими координатами.
     * @param columnCount Количество колонок.
     * @param cellsGrid Карта ячеек (см. описание типа).
     */
    Ca(this, "convertEmptyToEmptyCells", (Un, Kn, qn) => {
      for (let Jo = 0; Jo < qn.length; Jo++)
        for (let pa = 0; pa < Kn; pa++)
          qn[Jo] === void 0 && (qn[Jo] = []), qn[Jo][pa] === void 0 && (Un[Jo][pa] = Utils.component.getDefaultCellTexture(
            this.EMPTY_CELL_VALUE,
            Jo,
            pa
          ));
    });
    /**
     * Записывает в структуры ячеек информацию о стилях текста.
     * @deprecated Не во всех случаях библиотека возвращает полную информацию о стилях. Проверить работоспособность
     * @deprecated с новыми версиями библиотеки.
     * @param workbook
     * @param tableStructure
     */
    Ca(this, "setStyleCells", (Un, Kn) => {
      var qn, Jo, pa, ma;
      if (Un.Styles === void 0 || Kn.cells.length > Un.Styles.Fonts.length) return Kn;
      for (let va = 0; va < Kn.cells.length; va++) {
        if (Un.Styles.Fonts[va + 4].color !== void 0) {
          const ba = (qn = Un.Styles.Fonts[va + 4].color) == null ? void 0 : qn.rgb;
          Kn.cells[va].content.tokens[0].color = `#${ba}`;
        }
        if (Un.Styles.Fonts[va + 4].bold && !Un.Styles.Fonts[va + 4].italic && (Kn.cells[va].content.tokens[0].format = TokenFormat.Bold), Un.Styles.Fonts[va + 4].italic && !Un.Styles.Fonts[va + 4].bold && (Kn.cells[va].content.tokens[0].format = TokenFormat.Italic), Un.Styles.Fonts[va + 4].italic && Un.Styles.Fonts[va + 4].bold && (Kn.cells[va].content.tokens[0].format = 3), Un.Styles.Fonts[va + 4].sz) {
          const ba = Un.Styles.Fonts[va + 4].sz, ya = (Jo = Object.entries(FontSize).map(([xa, wa]) => ({
            key: xa,
            number: Number.parseInt(wa, 10)
          })).find((xa) => xa.number === ba)) == null ? void 0 : Jo.key;
          Kn.cells[va].content.tokens[0].fontSize = FontSize[ya];
        }
        if (Un.Styles.Fonts[va + 4].name) {
          const ba = Un.Styles.Fonts[va + 4].name, ya = (pa = Object.entries(FontFamily).map(([xa, wa]) => ({ key: xa, fontFamily: wa.toString() })).find((xa) => xa.fontFamily === ba)) == null ? void 0 : pa.key;
          Kn.cells[va].content.tokens[0].fontFamily = FontFamily[ya];
        }
        if (va + 4 > Kn.cells.length) break;
      }
      if (Un.Styles.CellXf === void 0) return Kn;
      for (let va = 1; va < Un.Styles.CellXf.length; va++)
        Un.Styles.CellXf[va].alignment && ((ma = Un.Styles.CellXf[va].alignment) == null || ma.horizontal);
      return Kn;
    });
  }
}
class XLSXTableReplacer extends Dependent {
  constructor() {
    super();
    Ca(this, "prevReplaceListeners");
    Ca(this, "postReplaceListeners");
    /**
     * Запускает процесс выбора XLSX файла пользователем и замены содержимого таблиц его структурой с передачей
     * форматирования ячеек.
     * Логика переноса стилей с заменяемой таблицы на новую:
     * Форматирование считывается с ячеек в фокусе либо в случае их отсутствия со всей таблицы. За основу берем
     * последовательность стилей форматирования в строке/строках и количество этих строк. В том случае, когда у новой
     * таблицы больше строк или столбцов, чем выделено в заменяемой таблице, то эти последовательности просто
     * повторяются.
     * При не совпадении числа страниц в файле и количества таблиц - последние будут добавлены/проигнорированы.
     */
    Ca(this, "replaceTable", async (Un) => {
      if (Un.length > 1)
        return;
      const Kn = Un[0];
      if (Kn === void 0)
        throw new EditorError("table is undefined");
      const qn = Kn.getFocusCellContexts(), Jo = qn === null ? Kn.getCellContexts() : qn, pa = this.generatePatternStyles(Jo);
      this.isPatternStylesRectangle(Jo, pa) && this.dependencies.xlsxTableImporter.getStructure(async (ma) => {
        const { rowCount: va, columnCount: ba, cells: _a } = ma[0];
        if (_a.length < 1)
          return;
        const ya = this.resizePatternStyles(pa, va, ba);
        for (let Ta = 0; Ta < _a.length; Ta++) {
          const Sa = _a[Ta], { row: Ma, column: ka } = Sa;
          Sa.content.tokens = this.getStylesFromPattern(Sa, ya[Ma][ka]), Sa.background = ya[Ma][ka].background;
        }
        const xa = Array(va).fill(1), wa = Array(ba).fill(1);
        this.callPrevReplaceListeners(Kn), Kn.mutateRowHeights(xa), Kn.mutateColumnWidths(wa), await Kn.mutateCellTextures(_a), Kn.mutateSyncRealRowHeight(), Kn.syncGraphicsHeight(), Kn.applyMutations(), this.callPostReplaceListeners(Kn);
      });
    });
    Ca(this, "callPrevReplaceListeners", (Un) => {
      this.prevReplaceListeners.forEach((Kn) => Kn(Un));
    });
    Ca(this, "callPostReplaceListeners", (Un) => {
      this.postReplaceListeners.forEach((Kn) => Kn(Un));
    });
    Ca(this, "getStylesFromPattern", (Un, Kn) => {
      const qn = Un.content.tokens.find((ma) => ma.type === TokenType.TEXT), Jo = Kn.content.tokens.find((ma) => ma.type === TokenType.TEXT), pa = [...Un.content.tokens];
      for (let ma = 0; ma < pa.length; ma++)
        pa[ma].type === TokenType.TEXT && (pa[ma] = { ...Jo, value: qn.value });
      return pa;
    });
    /**
     * Возвращает масштабированный шаблон стилей, до размеров импортируемой таблицы.
     * @param patternStyles Шаблон стилей
     * @param rowCount Количество строк, в импортируемой таблице
     * @param columnCount Количество колонок, в импортируемой таблице
     */
    Ca(this, "resizePatternStyles", (Un, Kn, qn) => {
      const Jo = [], pa = Un.length, ma = Un[0].length;
      for (let va = 0; va < Kn; va++) {
        Jo[va] === void 0 && (Jo[va] = []);
        for (let ba = 0; ba < qn; ba++) {
          const _a = va % pa, ya = ba % ma;
          Jo[va][ba] = Un[_a][ya];
        }
      }
      return Jo;
    });
    /**
     * Возвращает результат проверки полученной фигуры из ячеек на соответствие прямоугольнику.
     * @param cells Ячейки для вычисления итогового количества строк и колонок
     * @param patternStyles Шаблон стилей, для проверки
     */
    Ca(this, "isPatternStylesRectangle", (Un, Kn) => {
      const qn = /* @__PURE__ */ new Set(), Jo = /* @__PURE__ */ new Set();
      for (let va = 0; va < Un.length; va++) {
        const { row: ba, column: _a } = Un[va].getTexture();
        Jo.add(ba), qn.add(_a);
      }
      const pa = Jo.size, ma = qn.size;
      for (let va = 0; va < pa; va++)
        for (let ba = 0; ba < ma; ba++)
          if (Kn[va][ba] === void 0)
            return !1;
      return !0;
    });
    /**
     * Возвращает сгенерированный шаблон стилей, на основе ячеек.
     * @param cells Ячейки для копирования стилей
     */
    Ca(this, "generatePatternStyles", (Un) => {
      let Kn = 0, qn = 0;
      for (let ma = 0; ma < Un.length; ma++) {
        const { row: va, column: ba } = Un[ma].getTexture();
        va > Kn && (Kn = va), ba > qn && (qn = ba);
      }
      Kn++, qn++;
      const Jo = [];
      for (let ma = 0; ma < Kn; ma++)
        Jo[ma] = new Array(qn).fill(null);
      for (let ma = 0; ma < Un.length; ma++) {
        const va = Un[ma].getTexture(), { row: ba, rowSpan: _a, column: ya, columnSpan: xa } = va;
        if (Jo[ba][ya] = va, _a > 1 || xa > 1)
          for (let wa = ba; wa < ba + _a; wa++)
            for (let Ta = ya; Ta < ya + xa; Ta++)
              Jo[wa][Ta] || (Jo[wa][Ta] = va);
      }
      return Jo.flatMap((ma) => {
        const va = ma.filter((ba) => ba !== null);
        return va.length > 0 ? [va] : [];
      });
    });
    this.prevReplaceListeners = [], this.postReplaceListeners = [];
  }
  addPrevReplaceListener(Un) {
    this.prevReplaceListeners.push(Un);
  }
  addPostReplaceListener(Un) {
    this.postReplaceListeners.push(Un);
  }
}
class BookTableReplacer extends XLSXTableReplacer {
  constructor() {
    super(), this.addPrevReplaceListener(() => {
      this.dependencies.sketchStabilizer.startUserAction();
    }), this.addPostReplaceListener(() => {
      this.dependencies.componentOrganizer.sync(), this.dependencies.sketchStabilizer.stopUserAction();
    });
  }
}
class TableSplitter extends Dependent {
  constructor() {
    super();
    // Отступ от первой таблицы при вставке
    Ca(this, "PADDING_BOTTOM", 20);
    Ca(this, "prevSplitListeners");
    Ca(this, "postSplitListeners");
    /**
     * Разделяет таблицу на две по активной ячейке.
     * Если ячейка выходит за пределы строки, по которой нужно разделить таблицу, она делится на две части.
     * Первая таблица заменяет исходную, вторая вставляется ниже первой.
     *
     * @param table Таблица, которую необходимо разделить
     * @param activeCellArea Область, содержащая активную ячейку, по которой будет происходить разделение
     */
    Ca(this, "splitTable", async (Un, Kn) => {
      if (Un === void 0)
        throw new EditorError("table is undefined");
      const qn = Kn.getData().areaCell;
      if (qn === void 0)
        return;
      const Jo = qn.row + qn.rowSpan - 1;
      if (Jo === Un.getRowCount() - 1)
        return;
      const pa = Un.getTexture().cells, ma = _$2.cloneDeep(pa), va = [], ba = [];
      for (let _a = 0; _a < pa.length; _a++) {
        const ya = ma[_a], { row: xa, rowSpan: wa, column: Ta, columnSpan: Sa, background: Ma } = ya, ka = xa <= Jo;
        if (xa <= Jo && Jo < xa + wa - 1) {
          const Za = wa - 1 + xa - Jo;
          ya.rowSpan -= Za;
          const Na = this.getSingleCellTexture(xa + wa - 1 - Jo - Za, Ta, Ma);
          Na.rowSpan = Za, Na.columnSpan = Sa, ba.push(Na);
        }
        ka ? va.push(ya) : (ya.row -= Jo + 1, ba.push(ya));
      }
      await this.injectTableUnder(Un, ba, Kn), await this.replaceTable(Un, va), this.callPostSplitListeners();
    });
    /**
     * Вставляет вторую таблицу под первой с отступом.
     * Метод рассчитывает координаты вставки новой таблицы и добавляет ее в дерево компонентов.
     *
     * @param table Первая таблица, под которой нужно вставить вторую
     * @param cells Набор ячеек для второй таблицы
     * @param activeCellArea Область, содержащая активную ячейку, по которой происходит разделение
     */
    Ca(this, "injectTableUnder", async (Un, Kn, qn) => {
      const { graphic: Jo, areaCell: pa } = qn.getData(), ma = qn.getGlobalFrameArea(), va = Jo.getFrameArea(), ba = pa.getHeight(), _a = ma.y - Jo.getGlobalPosition().y, ya = va.y + _a + ba + this.PADDING_BOTTOM, xa = Un.getParentComponent();
      if (xa === null)
        throw new EditorError("parent component not found");
      const wa = this.calculateOffsetAtPosition(ma.y + ma.height + this.PADDING_BOTTOM), Ta = Utils.generate.uuid4(), Sa = Utils.generate.uuid4(), { borderColor: Ma, columnWidths: ka, rowHeights: Za } = Un.getTexture(), Na = this.calculateRowCount(Kn), Ka = {
        id: Sa,
        type: GraphicType.TABLE,
        frame: {
          width: va.width,
          height: 0,
          layer: 0,
          x: va.x,
          y: ya,
          rotate: 0
        },
        offset: 0,
        texture: {
          rowCount: Na
        }
      }, Ja = Za.slice(Za.length - Na), el = {
        id: Ta,
        type: EditorComponentType.TABLE,
        offset: wa,
        graphics: [Ka],
        texture: {
          startRows: [0],
          cells: Kn,
          borderColor: Ma,
          columnWidths: ka,
          rowHeights: Ja
        },
        components: null
      };
      let qa;
      await this.dependencies.componentTree.executeMutations(async (tl) => {
        qa = tl.componentFactory.createComponent(el);
        const Qa = /* @__PURE__ */ new Map();
        if (el.graphics === null)
          throw new EditorError("graphic structures not found");
        for (let nl = 0; nl < el.graphics.length; nl++) {
          const rl = el.graphics[nl], il = tl.graphicFactory.createGraphic(GraphicType.TABLE, qa);
          if (await il.setStructure(() => rl), qa.appendGraphic(il), el.offset === null)
            throw new EditorError("the table structure does not have an offset");
          const cl = el.offset + rl.offset, al = tl.layerRegistry.getLastLayerFromRootGraphic(cl).getData();
          if (al === null)
            throw new EditorError("data not found");
          Qa.set(al, il);
        }
        await qa.setStructure(() => el), tl.mutator.mutateByAppendComponent(xa, qa), Qa.forEach((nl, rl) => {
          tl.mutator.mutateByChangeLayer(rl, nl);
        }), this.callPrevSplitListeners(qa);
      });
    });
    /**
     * Заменяет текущие текстуры ячеек таблицы на новые.
     *
     * @param table Таблица, в которой нужно заменить текстуру ячеек
     * @param cells Набор новых текстур ячеек для таблицы
     */
    Ca(this, "replaceTable", async (Un, Kn) => {
      const qn = Un.getRowHeights(), Jo = this.calculateRowCount(Kn), pa = qn.slice(0, Jo);
      Un.mutateRowHeights(pa), await Un.mutateCellTextures(Kn), Un.applyMutations(), this.callPrevSplitListeners(Un);
    });
    Ca(this, "calculateRowCount", (Un) => {
      let Kn = 0;
      for (let qn = 0; qn < Un.length; qn++) {
        const Jo = Un[qn], { row: pa, rowSpan: ma } = Jo;
        Kn = Math.max(Kn, pa + ma);
      }
      return Kn;
    });
    Ca(this, "calculateOffsetAtPosition", (Un) => {
      let Kn = null, qn = Number.MAX_SAFE_INTEGER;
      const Jo = this.dependencies.componentTree.getRootGraphics();
      for (let pa = 0; pa < Jo.length; pa++) {
        const ma = Jo[pa], { y: va, height: ba } = ma.getFrameConfiguration(), _a = va + ba / 2, ya = Math.abs(Un - _a);
        ya < qn && (qn = ya, Kn = ma);
      }
      if (Kn === null)
        throw new EditorError("nearest page not found");
      return Kn.getOffset();
    });
    Ca(this, "getSingleCellTexture", (Un, Kn, qn) => ({
      id: Utils.generate.uuid4(),
      column: Kn,
      row: Un,
      background: qn,
      rowSpan: 1,
      content: Utils.component.getDefaultTextModel(),
      columnSpan: 1
    }));
    Ca(this, "callPostSplitListeners", () => {
      this.postSplitListeners.forEach((Un) => Un());
    });
    Ca(this, "callPrevSplitListeners", (Un) => {
      this.prevSplitListeners.forEach((Kn) => Kn(Un));
    });
    this.prevSplitListeners = [], this.postSplitListeners = [];
  }
  addPostSplitListeners(Un) {
    this.postSplitListeners.push(Un);
  }
  addPrevSplitListeners(Un) {
    this.prevSplitListeners.push(Un);
  }
}
class BookTableSplitter extends TableSplitter {
  constructor() {
    super(), this.addPostSplitListeners(() => {
      this.dependencies.componentOrganizer.sync(), this.dependencies.actionController.stopUserAction();
    });
  }
}
class TextUseCases extends Dependent {
  constructor() {
    super(...arguments);
    Ca(this, "moveCarriageLeft", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveLeft();
    });
    Ca(this, "moveCarriageRight", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveRight();
    });
    Ca(this, "moveCarriageWordLeft", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveCarriageWordLeft();
    });
    Ca(this, "moveCarriageWordRight", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveCarriageWordRight();
    });
    Ca(this, "moveCarriageSelectionRight", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveSelectionRight();
    });
    Ca(this, "moveCarriageSelectionWordRight", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveSelectionWordRight();
    });
    Ca(this, "moveCarriageSelectionWordLeft", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveSelectionWordLeft();
    });
    Ca(this, "removeWordLeft", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.removeWordLeft();
    });
    Ca(this, "moveCarriageSelectionLeft", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveSelectionLeft();
    });
    Ca(this, "selectAllText", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.selectAllText();
    });
    Ca(this, "moveCarriageTop", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveTop();
    });
    Ca(this, "moveCarriageBottom", () => {
      this.dependencies.carriageCoordinator.isEnableTextEdit() && this.dependencies.carriageCoordinator.moveBottom();
    });
  }
}
class BaseUseCases extends TextUseCases {
  constructor() {
    super();
    Ca(this, "postApplyToGraphicListeners");
    /** @inheritDoc */
    Ca(this, "copy", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      if (Un === null) {
        console.log("Копирование компонентов", "Отсутствуют компоненты в фокусе.");
        return;
      }
      await this.dependencies.copyController.copy(Un);
    });
    /** @inheritDoc */
    Ca(this, "pasteFromKeyboardHotkey", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      await this.dependencies.actionController.executeUserAction(async () => {
        Un != null && Un[0].isEnableEditMode() ? await this.dependencies.pasteController.pasteInComponents(Un) : await this.dependencies.pasteController.pasteFromBuffer();
      }), await this.dependencies.areaController.sync();
    });
    Ca(this, "hideInterface", () => {
      this.dependencies.ui.hide();
    });
    Ca(this, "showInterface", () => {
      this.dependencies.ui.show();
    });
    Ca(this, "removeFocusComponentsWithAnimate", () => {
      if (this.dependencies.carriageCoordinator.isEnableTextEdit())
        return;
      const Un = this.dependencies.componentTree.getFocusComponents();
      if (Un === null)
        return;
      const Jo = Un.flatMap((pa) => pa.getGraphics()).flatMap((pa) => pa.getObjects().map((va) => va.object)).map(
        (pa) => ({
          object: pa,
          type: TypeObjectAnimated.OPACITY,
          duration: 200,
          start: 1,
          end: 0,
          ease: un.ease.easeInSine
        })
      );
      this.dependencies.canvasRender.animateObjects(...Jo).then(async () => {
        await this.removeFocusComponents();
      });
    });
    Ca(this, "disableInjectingProcess", () => {
      this.dependencies.componentInjector.isInjecting() && this.dependencies.componentInjector.stopInjecting(), this.dependencies.ui.disableInjectingElements();
    });
    Ca(this, "disableComponentsFocus", () => {
      const Un = this.dependencies.componentTree.getComponents();
      if (Un !== null)
        for (const Kn of Un)
          Kn.disableEditMode(), Kn.disableFocus();
    });
    Ca(this, "stretchFocusComponentToWidth", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentAlignment.alignToWidth(...Un), await Promise.all(
          Un.map(async (Kn) => {
            Kn.type === EditorComponentType.TEXT && await this.syncTextComponentsFrameSize(), Kn.type === EditorComponentType.PICTURE && await this.syncPictureComponentsFrameSize(), Kn.type === EditorComponentType.TABLE && await Kn.syncWidths();
          })
        );
      }), await this.dependencies.ui.sync(), await this.dependencies.areaController.sync());
    });
    /** @inheritDoc */
    Ca(this, "cloneWithAlt", async () => {
      if (this.dependencies.textEngine.isAnyModelInEditMode())
        return;
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.componentCloner.pasteWithAlt(Un);
      }), await this.dependencies.areaController.sync());
    });
    /** @inheritDoc */
    Ca(this, "pasteAtPosition", async (Un) => {
      const Kn = this.dependencies.componentTree.getFocusComponents();
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.pasteController.pasteAtPosition(Kn, Un);
      }), await this.dependencies.areaController.sync();
    });
    /** @inheritDoc */
    Ca(this, "removeFocusComponents", async () => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.componentTree.mutateByRemoveFocusComponents();
      }), await this.dependencies.ui.sync(), await this.dependencies.areaController.sync();
    });
    /** @inheritDoc */
    Ca(this, "undo", async () => {
      this.dependencies.actionStore.undo(), await this.dependencies.areaController.sync(), await this.dependencies.ui.sync();
    });
    /** @inheritDoc */
    Ca(this, "redo", async () => {
      this.dependencies.actionStore.redo(), await this.dependencies.areaController.sync(), await this.dependencies.ui.sync();
    });
    /**
     * Перемещает все компоненты в фокусе на слой ниже.
     */
    Ca(this, "moveBackFocusComponents", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveBackComponents(...Un);
      }), await this.dependencies.areaController.sync());
    });
    Ca(this, "moveForwardFocusComponents", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveForwardComponents(...Un);
      }), await this.dependencies.areaController.sync());
    });
    Ca(this, "moveToForegroundFocusComponents", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveComponentToForeground(...Un);
      }), await this.dependencies.areaController.sync());
    });
    Ca(this, "moveToBackgroundFocusComponents", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveComponentToBackground(...Un);
      }), await this.dependencies.areaController.sync());
    });
    Ca(this, "moveBackGraphics", async (...Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveBackGraphics(...Un);
      }), await this.dependencies.areaController.sync();
    });
    Ca(this, "moveForwardGraphics", async (...Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveForwardGraphics(...Un);
      }), await this.dependencies.areaController.sync();
    });
    Ca(this, "moveToForegroundGraphics", async (...Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveGraphicToForeground(...Un);
      }), await this.dependencies.areaController.sync();
    });
    Ca(this, "moveToBackgroundGraphics", async (...Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        this.dependencies.componentTree.moveGraphicToBackground(...Un);
      }), await this.dependencies.areaController.sync();
    });
    Ca(this, "groupFocusComponents", async () => {
      let Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (Un = Un.filter((Kn) => Kn.type !== EditorComponentType.BOOK), Un.length !== 0 && (await this.dependencies.actionController.executeUserAction(async () => {
        const Kn = await this.dependencies.componentGrouper.groupComponents(Un);
        this.dependencies.componentTree.getRootComponent().recursiveSyncGraphicsOffset(), this.dependencies.componentTree.enableFocusOnly(Kn);
      }), await this.dependencies.areaController.sync()));
    });
    Ca(this, "ungroupFocusComponents", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && (await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.componentGrouper.ungroupComponents(Un);
      }), await this.dependencies.areaController.sync());
    });
    Ca(this, "createEmptyTable", (Un, Kn) => {
      this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.injectEmptyTable(Un, Kn), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction);
    });
    Ca(this, "setFocusFigureBackground", async (Un) => {
      await this.applyForFocusFigureGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          background: Un
        }))
      );
    });
    Ca(this, "setFocusFigureBorderColor", async (Un) => {
      await this.applyForFocusFigureGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          borderColor: Un
        }))
      );
    });
    Ca(this, "setFocusFigureBorderWidth", async (Un) => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.applyForFocusFigureGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          borderWidth: Un
        }))
      );
    });
    Ca(this, "setFocusObjectCornerRadius", async (Un) => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.applyForFocusFigureGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          radius: {
            topLeft: Un,
            topRight: Un,
            bottomLeft: Un,
            bottomRight: Un
          }
        }))
      ), await this.applyForFocusPictureGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          radius: {
            topLeft: Un,
            topRight: Un,
            bottomLeft: Un,
            bottomRight: Un
          }
        }))
      );
    });
    Ca(this, "setFocusFigureBorderStyle", async (Un) => {
      await this.applyForFocusFigureGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          borderStyle: Un
        }))
      );
    });
    Ca(this, "setFocusFigureBorderRadius", async (Un) => {
      await this.applyForFocusFigureGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          radius: Un
        }))
      );
    });
    Ca(this, "setFocusLineStyle", async (Un) => {
      await this.applyForFocusLineGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          style: Un
        }))
      );
    });
    Ca(this, "setFocusLineBackground", async (Un) => {
      await this.applyForFocusLineGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          background: Un
        }))
      );
    });
    Ca(this, "setFocusLineWidth", async (Un) => {
      await this.applyForFocusLineGraphic(
        (Kn) => Kn.setTexture((qn) => ({
          ...qn,
          thickness: Un
        }))
      ), await this.applyForFocusLineGraphic(
        (Kn) => Kn.setFrameConfiguration((qn) => ({
          ...qn,
          height: Un
        }))
      );
    });
    Ca(this, "setFocusPictureBorderRadius", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      if (Kn === null)
        return;
      const qn = Kn.flatMap((Jo) => Jo.getGraphics());
      await this.dependencies.actionController.executeUserAction(async () => {
        for (let Jo = 0; Jo < qn.length; Jo++)
          await qn[Jo].setTexture((pa) => ({
            ...pa,
            radius: Un
          }));
      });
    });
    Ca(this, "resetFocusPictureSize", async () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      Un !== null && await this.dependencies.actionController.executeUserAction(async () => {
        await Promise.all(Un.map((Kn) => Kn.resetPictureSize));
      });
    });
    Ca(this, "applyEditablePictureChange", async () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      if (Un !== null) {
        for (const Kn of Un)
          Kn.disableEditMode(), Kn.disableFocus();
        await this.dependencies.ui.sync();
      }
    });
    Ca(this, "cancelEditablePictureChange", async () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      if (Un !== null) {
        for (let Kn = 0; Kn < Un.length; Kn++) {
          const qn = Un[Kn];
          await qn.cancelChanges(), qn.disableEditMode(), qn.disableFocus();
        }
        await this.dependencies.areaController.sync(), await this.dependencies.ui.sync();
      }
    });
    Ca(this, "loadPictureToFocusComponentsWithAdaptFrame", async () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      if (Un === null)
        return;
      const Kn = await this.dependencies.uploadImageFile(() => {
        for (let qn = 0; qn < Un.length; qn++)
          Un[qn].enableLoadingMode();
      });
      await Promise.all(Un.map((qn) => qn.setPicture(Kn)));
    });
    Ca(this, "loadPictureComponentWithAdaptFrame", async (Un) => {
      if (Un.getGraphics().some((Jo) => Jo.isEnableHover() && !Jo.isEnableFocus())) {
        const Jo = await this.dependencies.uploadImageFile(() => {
          Un.enableLoadingMode();
        });
        await Un.setPicture(Jo);
        return;
      }
      await this.loadPictureToFocusComponentsWithAdaptFrame();
    });
    Ca(this, "setFocusTextColor", async (Un) => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Kn, qn) => {
          qn.setColor(Un);
        }), this.applyToFocusTableGraphics((Kn, qn) => {
          qn.setColor(Un);
        });
      }), await this.syncTextComponentsFrameSize();
    });
    Ca(this, "setFocusTextLineHeight", async (Un) => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Kn, qn) => {
          qn.setFormat(TokenFormat.None);
        }), this.applyToFocusTableGraphics((Kn, qn) => {
          qn.setFormat(TokenFormat.None);
        });
      }), await this.syncTextComponentsFrameSize();
    });
    Ca(this, "runInjectText", () => this.dependencies.componentTree.hasEditableComponent() ? !1 : (this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.runInjectText(), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction), !0));
    Ca(this, "runInjectPicture", () => {
      this.dependencies.componentTree.hasEditableComponent() || (this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.runInjectPicture(), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction));
    });
    Ca(this, "runInjectFigure", () => {
      this.dependencies.componentTree.hasEditableComponent() || (this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.runInjectFigure(), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction));
    });
    Ca(this, "runInjectLine", () => {
      this.dependencies.componentTree.hasEditableComponent() || (this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.runInjectLine(), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction));
    });
    Ca(this, "setFocusComponentsBorderRadius", async (Un) => {
      await this.setFocusFigureBorderRadius(Un), await this.setFocusPictureBorderRadius(Un);
    });
    Ca(this, "moveFocusTableCellUp", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TABLE
      );
      if (Un !== null)
        for (const Kn of Un)
          Kn.getFocusCellContexts() !== null && Kn.moveFocusTableCell(SearchPositionTableCell.CELL_ABOVE);
    });
    Ca(this, "moveFocusTableCellDown", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TABLE
      );
      if (Un !== null)
        for (const Kn of Un)
          Kn.getFocusCellContexts() !== null && Kn.moveFocusTableCell(SearchPositionTableCell.CELL_BELOW);
    });
    Ca(this, "moveFocusTableCellLeft", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TABLE
      );
      if (Un !== null)
        for (const Kn of Un)
          Kn.getFocusCellContexts() !== null && Kn.moveFocusTableCell(SearchPositionTableCell.CELL_LEFT);
    });
    Ca(this, "moveFocusTableCellRight", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TABLE
      );
      if (Un !== null)
        for (const Kn of Un)
          Kn.getFocusCellContexts() !== null && Kn.moveFocusTableCell(SearchPositionTableCell.CELL_RIGHT);
    });
    Ca(this, "setFocusTextAlign", async (Un) => {
      if (this.dependencies.actionStore === null || this.dependencies.ui === null)
        throw new EditorError("alignment cannot be set");
      this.dependencies.componentTree.getFocusComponents() !== null && (this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((qn, Jo) => {
          qn.setTexture((pa) => ({
            ...pa,
            model: {
              ...pa.model,
              textAlign: Un
            }
          }));
        }), this.applyToFocusTableGraphics((qn, Jo) => {
          qn.setFocusCellTextAlign(Un);
        });
      }), await this.dependencies.ui.sync());
    });
    Ca(this, "setFocusTextFontFamily", async (Un) => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Kn, qn) => {
          qn.setFontFamily(Un);
        }), this.applyToFocusTableGraphics((Kn, qn) => {
          qn.setFontFamily(Un);
        });
      }), await this.syncTextComponentsFrameSize(), await this.dependencies.ui.sync();
    });
    Ca(this, "setFocusTextFormatNone", async () => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.None);
        }), this.applyToFocusTableGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.None);
        });
      }), await this.syncTextComponentsFrameSize(), await this.dependencies.ui.sync();
    });
    Ca(this, "setFocusTextFormatBold", async () => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.Bold);
        }), this.applyToFocusTableGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.Bold);
        });
      }), await this.syncTextComponentsFrameSize(), await this.dependencies.ui.sync();
    });
    Ca(this, "setFocusTextFormatItalic", async () => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.Italic);
        }), this.applyToFocusTableGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.Italic);
        });
      }), await this.syncTextComponentsFrameSize(), await this.dependencies.ui.sync();
    });
    Ca(this, "setFocusTextFormatItalicAndBold", async () => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.BoldItalic);
        }), this.applyToFocusTableGraphics((Un, Kn) => {
          Kn.setFormat(TokenFormat.BoldItalic);
        });
      }), await this.syncTextComponentsFrameSize(), await this.dependencies.ui.sync();
    });
    Ca(this, "setFocusTextFontSize", async (Un) => {
      this.dependencies.textActionInitiator.isTimerRunning() && await this.dependencies.textActionInitiator.forceSave(), await this.dependencies.actionController.executeUserAction(async () => {
        this.applyToFocusTextGraphics((Kn, qn) => {
          qn.setFontSize(Un);
        }), this.applyToFocusTableGraphics((Kn, qn) => {
          qn.setFontSize(Un);
        });
      }), await this.syncTextComponentsFrameSize();
    });
    Ca(this, "setFocusTableCellFill", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(EditorComponentType.TABLE);
      Kn !== null && await this.dependencies.actionController.executeUserAction(async () => {
        for (const qn of Kn) {
          const Jo = qn.getFocusCellContexts();
          if (Jo === null) {
            const pa = qn.getCellContexts();
            for (const ma of pa)
              ma.setBackground(Un);
            return;
          }
          for (const pa of Jo)
            pa.setBackground(Un);
        }
      });
    });
    Ca(this, "setFocusTableCellTextAlign", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(EditorComponentType.TABLE);
      Kn !== null && await this.dependencies.actionController.executeUserAction(async () => {
        for (const qn of Kn) {
          const Jo = qn.getFocusCellContexts();
          if (Jo === null) {
            const pa = qn.getCellContexts();
            for (const ma of pa)
              ma.setTextAlign(Un);
            return;
          }
          for (const pa of Jo)
            pa.setTextAlign(Un);
        }
      });
    });
    Ca(this, "setFocusTableBorderColor", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(EditorComponentType.TABLE);
      Kn !== null && await this.dependencies.actionController.executeUserAction(async () => {
        for (const qn of Kn)
          qn.mutateBorderColor(Un), qn.applyMutations();
      });
    });
    Ca(this, "addColumnAfter", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.addColumnAfter(Un);
      });
    });
    Ca(this, "addColumnBefore", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.addColumnBefore(Un);
      });
    });
    Ca(this, "addRowUnder", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.addRowUnder(Un);
      });
    });
    Ca(this, "addRowOver", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.addRowOver(Un);
      });
    });
    Ca(this, "deleteFocusRows", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.deleteFocusRows(Un);
      });
    });
    Ca(this, "deleteFocusColumns", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.deleteFocusColumns(Un);
      });
    });
    Ca(this, "splitFocusCells", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.splitFocusCells(Un);
      });
    });
    Ca(this, "mergeFocusCell", async (Un) => {
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.tableGridMutator.mergeFocusCell(Un);
      });
    });
    Ca(this, "getColorsBorderFigureFocusComponents", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.FIGURE
      ), Kn = [];
      if (Un !== null)
        for (const qn of Un) {
          const Jo = qn.getFirstGraphic();
          if (Jo !== null) {
            const pa = Jo.getTexture();
            Kn.push(pa.borderColor);
          }
        }
      return Kn;
    });
    Ca(this, "getColorsBackgroundFigureFocusComponents", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.FIGURE
      ), Kn = [];
      if (Un !== null)
        for (const qn of Un) {
          const Jo = qn.getFirstGraphic();
          if (Jo !== null) {
            const pa = Jo.getTexture();
            Kn.push(pa.background);
          }
        }
      return Kn;
    });
    Ca(this, "getColorsLineFocusComponents", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.LINE
      ), Kn = [];
      if (Un !== null)
        for (const qn of Un) {
          const Jo = qn.getFirstGraphic();
          if (Jo !== null) {
            const pa = Jo.getTexture();
            Kn.push(pa.background);
          }
        }
      return Kn;
    });
    Ca(this, "getColorsFillTableFocusComponents", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TABLE
      ), Kn = [];
      if (Un !== null)
        for (const qn of Un)
          Kn.push(...qn.getColorsContextTable());
      return Kn;
    });
    Ca(this, "getColorsBorderTableFocusComponents", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TABLE
      ), Kn = [];
      if (Un !== null)
        for (const qn of Un)
          Kn.push(qn.getTexture().borderColor);
      return Kn;
    });
    Ca(this, "addPostApplyToGraphicListener", (Un) => {
      this.postApplyToGraphicListeners.push(Un);
    });
    Ca(this, "stretchToWidthForTables", () => {
      const Un = this.dependencies.componentTree.getUniformComponents(
        EditorComponentType.TABLE
      );
      if (Un !== null)
        for (const Kn of Un)
          this.dependencies.componentAlignment.alignToWidth(Kn);
    });
    /** Применить `callback` к каждому текстовому редактору графики в фокусе. */
    Ca(this, "applyToFocusTextGraphics", (Un) => {
      const Kn = this.dependencies.componentTree.getFocusComponents();
      if (Kn !== null)
        for (const qn of Kn) {
          if (qn.type === EditorComponentType.TEXT) {
            const Jo = qn, pa = Jo.getTextModel();
            Un(Jo, pa);
          }
          this.callPostApplyToGraphicExternalListeners(qn);
        }
    });
    /** Применить `callback` к каждому текстовому редактору графики в фокусе. */
    Ca(this, "applyToFocusTableGraphics", (Un) => {
      const Kn = this.dependencies.componentTree.getFocusComponents();
      if (Kn !== null)
        for (const qn of Kn) {
          if (qn.type === EditorComponentType.TABLE) {
            const Jo = qn, pa = Jo.getFocusCellContexts();
            if (pa !== null)
              for (const ma of pa) {
                const va = ma.getTextModel();
                Un(Jo, va);
              }
          }
          this.callPostApplyToGraphicExternalListeners(qn);
        }
    });
    /**
     * Синхронизирует размеры текстовых фреймов в фокусе с реальными размерами текста.
     */
    Ca(this, "syncTextComponentsFrameSize", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      if (Un !== null)
        for (const Kn of Un) {
          if (Kn.type !== EditorComponentType.TEXT)
            return;
          await this.syncTextComponentFrameSize(Kn);
        }
    });
    /**
     * Обновляет положение картинки относительно фрейма.
     */
    Ca(this, "syncPictureComponentsFrameSize", async () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      Un !== null && await Promise.all(Un.map((Kn) => Kn.resetPictureSize));
    });
    Ca(this, "syncTextComponentFrameSize", async (Un) => {
      Un.disableAutoWidth(), await Un.syncFrameSize();
    });
    Ca(this, "applyForFocusPictureGraphic", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.PICTURE
      );
      if (Kn === null)
        return;
      const qn = Kn.flatMap((Jo) => Jo.getGraphics());
      await this.dependencies.actionController.executeUserAction(async () => {
        for (const Jo of qn)
          Un(Jo);
      });
    });
    Ca(this, "applyForFocusTextGraphic", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TEXT
      );
      if (Kn === null)
        return;
      const qn = Kn.flatMap((Jo) => Jo.getGraphics());
      await this.dependencies.actionController.executeUserAction(async () => {
        for (const Jo of qn)
          Un(Jo);
      });
    });
    Ca(this, "applyForFocusTableGraphic", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.TABLE
      );
      if (Kn === null)
        return;
      const qn = Kn.flatMap((Jo) => Jo.getGraphics());
      await this.dependencies.actionController.executeUserAction(async () => {
        for (const Jo of qn)
          Un(Jo);
      });
    });
    Ca(this, "applyForFocusFigureGraphic", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.FIGURE
      );
      if (Kn === null)
        return;
      const qn = Kn.flatMap((Jo) => Jo.getGraphics());
      await this.dependencies.actionController.executeUserAction(async () => {
        for (const Jo of qn)
          Un(Jo);
      });
    });
    Ca(this, "applyForFocusLineGraphic", async (Un) => {
      const Kn = this.dependencies.componentTree.getUniformFocusComponents(
        EditorComponentType.LINE
      );
      if (Kn === null)
        return;
      const qn = Kn.flatMap((Jo) => Jo.getGraphics());
      await this.dependencies.actionController.executeUserAction(async () => {
        for (const Jo of qn)
          Un(Jo);
      });
    });
    Ca(this, "callPostApplyToGraphicExternalListeners", (Un) => {
      for (const Kn of this.postApplyToGraphicListeners)
        Kn(Un);
    });
    this.postApplyToGraphicListeners = [];
  }
}
class BookUseCases extends BaseUseCases {
  constructor() {
    super(...arguments);
    Ca(this, "setPageBackgroundImage", async () => {
      const Un = this.dependencies.componentTree.getRootComponent(), Kn = Un.getGraphics(), qn = await this.dependencies.uploadImageFile(() => {
        Kn.forEach((Jo) => Jo.enableBackgroundPictureLoadingMode());
      });
      await this.dependencies.actionController.executeUserAction(async () => {
        await Promise.all(
          Kn.map((Jo) => Jo.setBackgroundImage(qn))
        ), Un.enableEditMode(), await this.dependencies.areaController.sync(), await this.dependencies.ui.sync();
      });
    });
    /** Устанавливает цвет фона всем страницам. */
    Ca(this, "setPageBackgroundColor", async (Un) => {
      const qn = this.dependencies.componentTree.getRootComponent().getGraphics();
      await this.dependencies.actionController.executeUserAction(async () => {
        await Promise.all(
          qn.map(async (Jo) => {
            Jo.removeBackgroundImage(), await Jo.setBackgroundColor(Un);
          })
        );
      }), await this.dependencies.areaController.sync(), this.dependencies.canvasRender.renderUnstructured();
    });
    /**
     * Запускает процесс установки повторяющееся изображение в качестве фона страниц.
     */
    Ca(this, "setPageRepeatingImage", async () => {
      const Kn = this.dependencies.componentTree.getRootComponent().getGraphics(), qn = await this.dependencies.uploadImageFile(() => {
        Kn.forEach((Jo) => Jo.enableBackgroundPictureLoadingMode());
      });
      this.dependencies.actionController.startUserAction(), await Promise.all(Kn.map((Jo) => Jo.setRepeatingImage({ source: qn, size: 100 }))), await this.dependencies.areaController.sync(), await this.dependencies.actionController.stopUserAction(), await this.dependencies.ui.sync();
    });
    /** Устанавливает ориентацию всех страниц. */
    Ca(this, "setPageOrientation", (Un) => {
    });
    /**
     * Удаляет текущую страницу в фокусе.
     * @param pageGraphic Графика удаляемой страницы.
     */
    Ca(this, "deletePage", async (Un) => {
      const Kn = this.dependencies.componentTree.getRootComponent();
      if (Kn.getGraphics().length === 1)
        return;
      const Jo = Kn.getNumberFromGraphic(Un);
      if (Jo === null)
        throw new EditorError("page number not found");
      const pa = Kn.getPageEmbeddedGraphics(Jo);
      await this.dependencies.actionController.executeUserAction(async () => {
        if (pa !== null) {
          const va = new Set(pa.map((ba) => ba.getParentComponent()));
          pa.forEach((ba) => {
            this.dependencies.componentTree.mutateByRemoveGraphic(ba);
          }), va.forEach((ba) => {
            ba !== null && ba.getGraphics().length === 0 && this.dependencies.componentTree.mutateByRemoveComponent(ba);
          });
        }
        this.dependencies.componentTree.mutateByRemoveGraphic(Un);
        const ma = Kn.getComponents();
        if (ma !== null)
          for (let va = 0; va < ma.length; va++) {
            const ba = ma[va], _a = ba.getOffset();
            if (_a === null)
              throw new EditorError("offset is null");
            _a > Jo && await this.dependencies.componentTree.mutateByChangeOffset(ba, _a - 1);
          }
      }), Kn.syncPagePanels(), this.dependencies.bookOrganizer.sync(), await this.dependencies.areaController.sync();
    });
    Ca(this, "appendPageAfter", async (Un) => {
      const Kn = Un.getUniqueStructure(), qn = this.dependencies.componentTree.getRootComponent(), pa = qn.getGraphics().indexOf(Un);
      if (pa === void 0)
        throw new EditorError("graphic not found");
      await this.dependencies.actionController.executeUserAction(async () => {
        await this.dependencies.componentTree.executeMutations(async (ma) => {
          const va = ma.graphicFactory.createGraphic(GraphicType.PAGE, qn);
          await va.setStructure(() => Kn), ma.mutator.mutateByAppendGraphicAfter(qn, Un, va);
          const ba = qn.getComponents();
          if (ba !== null)
            for (let _a = 0; _a < ba.length; _a++) {
              const ya = ba[_a].getOffset();
              if (ya === null)
                throw new EditorError("offset is null");
              ya > pa && await ma.mutator.mutateByChangeOffset(ba[_a], ya + 1);
            }
        });
      }), qn.syncPagePanels(), this.dependencies.bookOrganizer.sync(), await this.dependencies.areaController.sync(), this.dependencies.canvasRender.render();
    });
    Ca(this, "setRepeatingImageSize", (Un) => {
    });
    /**
     * @inheritDoc
     */
    Ca(this, "toggleBookEditMode", () => {
      const Un = this.dependencies.componentTree.getRootComponent();
      return Un.isEnableEditMode() ? (Un.disableEditMode(), !1) : (Un.enableEditMode(), !0);
    });
  }
}
class PrivateTemplateUseCases extends BookUseCases {
  constructor() {
    super();
    Ca(this, "tableSplitter");
    Ca(this, "xlsxTableImporter");
    Ca(this, "xlsxTableReplacer");
    /**
     * Создаёт модуль из компонентов в фокусе. При создании модуля из одного uniter компонента (например это компонент
     * группы) этот компонент конвертируется в компонент модуля, т.к. никакого смысла в группе нет в данном случае.
     */
    Ca(this, "createModule", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      if (Un === null)
        return;
      const qn = (await this.dependencies.moduleBuilder.build(...Un)).getUniqueStructure();
      this.dependencies.onOpenCreateModuleWindow(async (Jo) => {
        const pa = new ComponentPreviewEditor({
          imageFileSourcePrefix: this.dependencies.imageFileSourcePrefix
        });
        await pa.setStructure({
          id: "preview",
          name: "preview",
          root: qn
        });
        const ma = await pa.getPreview();
        Jo(ma);
      }, qn);
    });
    Ca(this, "injectModule", async (Un) => {
      this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.injectModule(Un), this.dependencies.componentInjector.addSingleUseInjectListener(async () => {
        await this.dependencies.componentOrganizer.sync(), await this.dependencies.actionController.stopUserAction();
      });
    });
    Ca(this, "splitTable", async (Un, Kn) => {
      this.dependencies.actionController.startUserAction(), await this.tableSplitter.splitTable(Un, Kn);
    });
    Ca(this, "replaceTablesFromXLSX", async () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(EditorComponentType.TABLE);
      Un !== null && await this.xlsxTableReplacer.replaceTable(Un);
    });
    /**
     * Запускает процесс выбора XLSX файла пользователем и создания таблиц из его структуры.
     * В случае, если в файле несколько листов, то будет создано несколько таблиц.
     */
    Ca(this, "createTableFromXLSX", () => {
      this.xlsxTableImporter.getStructure((Un) => {
        const { rowCount: Kn, columnCount: qn, cells: Jo } = Un[0];
        Jo.length < 1 || (this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.injectTable(Kn, qn, Jo), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction));
      });
    });
    this.tableSplitter = new BookTableSplitter(), this.xlsxTableImporter = new XLSXTableImporter(), this.xlsxTableReplacer = new BookTableReplacer(), this.addPostInjectDependenciesListener((Un) => {
      const { onUploadXlsxFile: Kn, componentOrganizer: qn, areaController: Jo, actionController: pa, componentTree: ma } = Un;
      this.xlsxTableReplacer.forceInjectDependencies({
        xlsxTableImporter: this.xlsxTableImporter,
        areaController: Jo,
        sketchStabilizer: pa,
        componentOrganizer: qn
      }), this.tableSplitter.forceInjectDependencies({
        componentTree: ma,
        areaController: Jo,
        actionController: pa,
        componentOrganizer: qn
      }), this.xlsxTableImporter.forceInjectDependencies({
        onUploadXlsxFile: Kn
      }), this.addPostApplyToGraphicListener((va) => {
        va.type === EditorComponentType.TABLE && this.dependencies.componentOrganizer.sync();
      });
    });
  }
}
class KeyboardVisualizer {
  constructor(zn) {
    Ca(this, "GUI_FOLDER_NAME", "Keyboard");
    Ca(this, "postSyncListeners");
    Ca(this, "parameters");
    Ca(this, "addGUIBlock", (zn) => {
      zn.addFolder(this.GUI_FOLDER_NAME).add(this.parameters, "isActiveKeysShow").name("Show active keys").onChange(this.sync);
    });
    Ca(this, "addPostSyncListener", (zn) => {
      this.postSyncListeners.push(zn);
    });
    Ca(this, "getObjects", () => {
      if (!this.parameters.isActiveKeysShow)
        return [];
      const zn = this.keyboardObserver.getActiveKeys(), Un = [];
      return zn.forEach((Kn, qn) => {
        const pa = Math.max(60, Kn.length * 10 + 30), ma = 40, va = 10, ba = qn * (ma + 15) + 10, _a = new pr({
          left: va,
          top: ba,
          width: pa,
          height: ma,
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 2,
          rx: 5,
          ry: 5
        }), ya = new Xo(Kn, {
          left: va + pa / 2,
          top: ba + ma / 2,
          fontSize: 16,
          fill: "black",
          originX: "center",
          originY: "center"
        }), xa = new Mr([_a, ya]);
        Un.push(xa);
      }), Un;
    });
    Ca(this, "sync", () => {
      this.callPostSyncListeners();
    });
    Ca(this, "callPostSyncListeners", () => {
      this.postSyncListeners.forEach((zn) => zn());
    });
    this.keyboardObserver = zn, this.postSyncListeners = [], this.parameters = {
      isActiveKeysShow: !1
    };
  }
}
class DynamicComponentFactory extends ComponentFactory {
  constructor() {
    super(...arguments);
    Ca(this, "createComponent", (Un) => {
      const Kn = this.getClearComponent(Un.type);
      if (Un.type === EditorComponentType.PICTURE) {
        const qn = Kn;
        qn.addPostEnableEditModeListener(qn.fixGraphicState), qn.addPostEnableEditModeListener(
          this.loadPictureEmptyPictureComponent.bind(this, qn)
        ), qn.addPostEnableEditModeListener(this.dependencies.areaController.sync);
      }
      if (Un.type === EditorComponentType.TABLE) {
        const qn = Kn;
        qn.addPostDisableEditModeListener(qn.disableAllContextFocus), qn.addPostDisableEditModeListener(this.disableActiveCellContext.bind(this, qn)), qn.addPostCellInputListener(this.dependencies.areaController.sync);
      }
      if (Un.type === EditorComponentType.TEXT && Kn.addPostDisableEditModeListener(this.removeEmptyTextComponent.bind(this, Kn)), Un.type === EditorComponentType.TEXT) {
        const qn = Kn;
        qn.addPostEnableEditModeListener(this.connectTextModel.bind(this, qn)), qn.addPostDisableEditModeListener(this.disconnectTextModel.bind(this, qn));
      }
      if (Kn.isUniter) {
        const qn = Kn;
        qn.addPostDisableEditModeListener(qn.syncSingleComponentsEditMode), qn.addPostEnableEditModeListener(qn.syncSingleComponentsEditMode), qn.addPostEnableEditModeListener(this.dependencies.areaController.sync);
      }
      return Kn.addPostDisableEditModeListener(this.dependencies.pageStructureObserver.sync), Kn;
    });
    /**
     * Проверяет текстовый компонент на наличие пустых токенов.
     * Если пустой токен найден, компонент помечается к удалению.
     * Процесс удаления осуществляется через метод removeComponent.
     * @param component - текстовый компонент, который нужно проверить и, возможно, удалить.
     */
    Ca(this, "removeEmptyTextComponent", async (Un) => {
      Un.getTextModel().getText().length === 0 && await this.removeComponent(Un);
    });
    /**
     * Удаляет текстовый компонент из дерева компонентов
     * выполняя мутации на дереве компонентов, используя инструмент мутатора
     * для удаления указанного компонента.
     * @param component - текстовый компонент, который нужно удалить из дерева компонентов.
     */
    Ca(this, "removeComponent", async (Un) => {
      await this.dependencies.componentTree.executeMutations(async (Kn) => {
        Kn.mutator.mutateByRemoveComponent(Un);
      });
    });
    /**
     * Запускает загрузку изображения при пустом компоненте изображения.
     * @param component Компонент изображения, по которому будет принято решение об обновлении изображения.
     */
    Ca(this, "loadPictureEmptyPictureComponent", (Un) => {
      Un.getGraphics().map((pa) => pa.getTexture()).some((pa) => pa.source === null) && this.dependencies.useCases.loadPictureComponentWithAdaptFrame(Un);
    });
    Ca(this, "updateUniterLayerSequence", async () => {
      const Un = this.dependencies.componentTree.getUniterComponents();
      if (Un !== null)
        for (let Kn = 0; Kn < Un.length; Kn++) {
          const qn = Un[Kn], pa = qn.getComponentAll().flatMap((ya) => ya.getGraphics()), ma = this.dependencies.componentTree.getLayerSequences(), va = pa.map((ya) => ya.getID()), ba = [];
          for (let ya = 0; ya < ma.length; ya++) {
            let xa = 0;
            for (let wa = 0; wa < ma[ya].length; wa++) {
              const Ta = va.indexOf(ma[ya][wa]);
              Ta !== -1 && (ba[ya] === void 0 && (ba[ya] = []), ba[ya][xa] = pa[Ta], xa++);
            }
          }
          for (let ya = 0; ya < ba.length; ya++)
            ba[ya] !== void 0 && (ba[ya] = ba[ya].filter((xa) => xa !== void 0));
          const _a = ba.flatMap((ya) => ya.map((xa) => xa.getID()));
          await qn.setTexture((ya) => ({
            ...ya,
            layerSequence: _a
          }));
        }
    });
    Ca(this, "disableActiveCellContext", async (Un) => {
      const Kn = Un.getActiveEditCellContext();
      Kn !== null && await this.dependencies.textEngine.disableModeEditMode(Kn);
    });
    Ca(this, "connectTextModel", (Un) => {
      this.dependencies.textEngine.enableModelEditMode(Un);
    });
    Ca(this, "disconnectTextModel", async (Un) => {
      await this.dependencies.textEngine.disableModeEditMode(Un);
    });
  }
}
class DynamicCanvasObjectOrganizer extends BaseObjectOrganizer {
  constructor() {
    super(...arguments);
    Ca(this, "getSortedObjects", () => [
      ...this.getComponentTreeObjects(),
      ...this.getHoverHighlighterObjects(),
      ...this.getSizePanelObjects(),
      ...this.getEditModeHighlighterObjects(),
      ...this.getMagneticLinesObjects(),
      ...this.getSelectionAreaObjects(),
      ...this.getInjectorsObjects(),
      ...this.quadTreeVisualizeObjects(),
      ...this.textSelectionVisualizeObjects()
    ]);
    Ca(this, "getSelectionAreaObjects", () => [this.dependencies.componentSelectionArea.getObject().object]);
    Ca(this, "getSizePanelObjects", () => {
      const Un = this.dependencies.layerRegistry.getSortedGraphics();
      return Un === null ? [] : Un.flatMap((qn) => qn.getSizePanel().getObjects()).map((qn) => qn.object);
    });
    Ca(this, "getHoverHighlighterObjects", () => {
      const Un = this.dependencies.layerRegistry.getSortedGraphics();
      return Un === null ? [] : Un.flatMap((qn) => qn.getHoverHighlighter().getObjects()).map((qn) => qn.object);
    });
    Ca(this, "getEditModeHighlighterObjects", () => {
      const Un = this.dependencies.layerRegistry.getSortedGraphics();
      return Un === null ? [] : Un.flatMap((qn) => qn.getEditModeHighlighter().getObjects()).map((qn) => qn.object);
    });
    Ca(this, "getInjectorsObjects", () => {
      const Un = [], Kn = this.dependencies.componentInjector.getObjects();
      for (let qn = 0; qn < Kn.length; qn++)
        Un.push(Kn[qn].object);
      return Un;
    });
    Ca(this, "getMagneticLinesObjects", () => {
      const Un = [], Kn = this.dependencies.magneticLines.getObjects();
      for (let qn = 0; qn < Kn.length; qn++)
        Un.push(Kn[qn].object);
      return Un;
    });
    Ca(this, "quadTreeVisualizeObjects", () => this.dependencies.quadTreeVisualizer.getObjects());
    Ca(this, "textSelectionVisualizeObjects", () => this.dependencies.textSelectionVisualizer.getObjects());
  }
}
class UIObjectOrganizer extends Dependent {
  constructor() {
    super();
    Ca(this, "getSortedObjects", () => [
      ...this.getUIObjects(),
      ...this.getQuadTreeVisualizeObjects(),
      ...this.getLayerVisualizeObjects(),
      ...this.getKeyboardVisualizeObjects(),
      ...this.getActionVisualizeObjects()
    ]);
    Ca(this, "getUIObjects", () => this.dependencies.ui.getObjects());
    Ca(this, "getLayerVisualizeObjects", () => this.dependencies.layerVisualizer.getObjects());
    Ca(this, "getQuadTreeVisualizeObjects", () => this.dependencies.quadTreeVisualizer.getObjects());
    Ca(this, "getKeyboardVisualizeObjects", () => this.dependencies.keyboardVisualizer.getObjects());
    Ca(this, "getActionVisualizeObjects", () => this.dependencies.actionVisualizer.getObjects());
  }
}
class UIObjectPositionCorrector extends Dependent {
  sync() {
    const zn = this.dependencies.ui.getUIElements();
    for (let Un = 0; Un < zn.length; Un++)
      this.recursiveCorrectElements(zn[Un], 0, 0);
  }
  recursiveCorrectElements(zn, Un, Kn) {
    const qn = zn.getObjects();
    for (let va = 0; va < qn.length; va++)
      qn[va].object.set({
        left: Un + qn[va].relativePosition.x,
        top: Kn + qn[va].relativePosition.y
      });
    const { x: Jo, y: pa } = zn.getRelativePosition(), ma = zn.getUIElements();
    for (let va = 0; va < ma.length; va++)
      this.recursiveCorrectElements(ma[va], Un + Jo, Kn + pa);
  }
}
class UIRender extends BaseRender {
  constructor() {
    super();
    Ca(this, "positionCorrector");
    /**
     * Выполняет синхронизацию объектов и их порядка на холсте.
     */
    Ca(this, "render", () => {
      const Un = this.dependencies.uiObjectOrganizer.getSortedObjects();
      this.positionCorrector.sync(), this.syncObjects(Un), this.dependencies.canvas.requestRenderAll();
    });
    /**
     * Выполняет обновление основного холста без учета структуры объектов.
     */
    Ca(this, "renderUnstructured", () => {
      this.dependencies.canvas.requestRenderAll();
    });
    /**
     * Принудительно обновляет основной холст, игнорируя структуру объектов.
     */
    Ca(this, "forceRenderUnstructured", () => {
      this.dependencies.canvas.renderAll();
    });
    Ca(this, "renderRelativePositions", async () => {
      this.positionCorrector.sync(), this.renderUnstructured();
    });
    this.positionCorrector = new UIObjectPositionCorrector(), this.addPostInjectDependenciesListener((Un) => {
      this.positionCorrector.forceInjectDependencies({
        ui: Un.ui
      });
    });
  }
}
class CarriageCoordinator extends Dependent {
  constructor() {
    super();
    Ca(this, "models");
    Ca(this, "postChangeCarriageRangeListeners");
    Ca(this, "connectModel", (Un) => {
      Un.addPostChangeTextListener(this.onChangeText), Un.addPostMoveCarriageListener(this.onMoveCarriage), this.models.push(Un), this.initPosition(), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "disconnectModel", (Un) => {
      const Kn = this.models.indexOf(Un);
      if (Kn === -1)
        throw new EditorError("Cannot disconnect model: The specified model is not connected.");
      Un.removePostChangeTextListener(this.onChangeText), Un.removePostMoveCarriageListener(this.onMoveCarriage), this.disableViews(Un), this.models.splice(Kn, 1), this.dependencies.render.renderUnstructured(), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "addPostChangeCarriageRangeListener", (Un) => {
      this.postChangeCarriageRangeListeners.push(Un);
    });
    Ca(this, "initPosition", () => {
      this.dependencies.render.render(), this.models.forEach((Un) => {
        this.correctCarriagePosition(Un);
      });
    });
    /**
     * Перемещает каретку к ближайшему символу в позиции клика мыши.
     *
     * @param parent - Родительский объект текстовой модели.
     * @param textView - Представление текстовой модели.
     * @param textArea - Область iframe, содержащая текст.
     * @param clickPosition - Позиция клика мыши.
     * @throws EditorError - Если не найдено покрытие каретки для данного представления.
     */
    Ca(this, "pounceToMouse", (Un, Kn, qn, Jo) => {
      const pa = Un.getTextModel(), va = Un.getCarriageCoverages().find((Na) => Na.view === Kn);
      if (va === void 0)
        throw new EditorError("carriage coverage not found");
      const ba = va.view.getTextPadding(), _a = {
        x: Jo.x - qn.x - ba.x,
        y: Jo.y - qn.y - ba.y
      };
      let ya = 0, xa = 0, wa = Number.POSITIVE_INFINITY;
      for (let Na = 0; Na < va.lineHeights.length; Na++) {
        const Ka = ya + va.lineHeights[Na] / 2, Ja = Math.abs(_a.y - Ka);
        Ja < wa && (wa = Ja, xa = Na), ya += va.lineHeights[Na];
      }
      const Ta = va.graphemePositions[xa];
      let Sa = 0, Ma = Number.POSITIVE_INFINITY, ka = !0;
      for (let Na = 0; Na < Ta.length; Na++) {
        const Ka = Ta[Na], Ja = Ka.left + Ka.width / 2, el = Math.abs(_a.x - Ja);
        el < Ma && (Ma = el, Sa = Na, ka = _a.x < Ja);
      }
      let Za = 0;
      for (let Na = 0; Na < va.graphemePositions.length; Na++)
        for (let Ka = 0; Ka < va.graphemePositions[Na].length; Ka++) {
          if (Na === xa && Ka === Sa) {
            const el = Sa === Ta.length - 1 || ka ? Za : Za + 1;
            pa.setCarriagePosition(el);
            return;
          }
          Za++;
        }
      this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveLeft", () => {
      this.models.forEach((Un) => {
        Un.moveCarriageLeft();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveRight", () => {
      this.models.forEach((Un) => {
        Un.moveCarriageRight();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveSelectionRight", () => {
      this.models.forEach((Un) => {
        Un.moveCarriageSelectionRight();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveSelectionWordRight", () => {
      this.models.forEach((Un) => {
        Un.moveCarriageSelectionWordRight();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveSelectionWordLeft", () => {
      this.models.forEach((Un) => {
        Un.moveCarriageSelectionWordLeft();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "removeWordLeft", () => {
      this.models.forEach((Un) => {
        Un.removeWordLeft();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveSelectionLeft", () => {
      this.models.forEach((Un) => {
        Un.moveCarriageSelectionLeft();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "selectAllText", () => {
      this.models.forEach((Un) => {
        Un.selectAllText();
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveTop", () => {
      this.models.forEach((Un) => {
        const Kn = Un.getParent(), qn = Un.getCarriagePosition();
        Kn.getCarriageCoverages().forEach((Jo) => {
          if (qn < Jo.coverage.start || qn > Jo.coverage.end)
            return;
          const pa = Jo.carriage.getPosition(), ma = this.findLineNumber(Jo.lineHeights, pa.y), va = Jo.graphemePositions[ma], ba = Jo.graphemePositions[ma - 1];
          if (ba === void 0)
            return;
          const _a = va.findIndex((wa) => wa.left === pa.x);
          if (_a === void 0)
            throw new EditorError("start letter not found");
          let ya = _a + 1;
          for (let wa = ba.length - 1; wa >= 0; wa--) {
            const Ta = ba[wa].left - pa.x, Sa = ba[wa - 1].left - pa.x;
            if (Sa < 0) {
              Ta > Math.abs(Sa) && ya++;
              break;
            }
            ya++;
          }
          const xa = qn - ya;
          Un.setCarriagePosition(xa);
        });
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "moveBottom", () => {
      this.models.forEach((Un) => {
        const Kn = Un.getParent(), qn = Un.getCarriagePosition();
        Kn.getCarriageCoverages().forEach((Jo) => {
          if (qn < Jo.coverage.start || qn > Jo.coverage.end)
            return;
          const pa = Jo.carriage.getPosition(), ma = this.findLineNumber(Jo.lineHeights, pa.y), va = Jo.graphemePositions[ma], ba = Jo.graphemePositions[ma + 1];
          if (ba === void 0)
            return;
          const _a = va.findIndex((Ta) => Ta.left === pa.x);
          if (_a === void 0)
            throw new EditorError("start letter not found");
          let ya = !1, xa = va.length - _a;
          for (let Ta = 0; Ta < ba.length - 1; Ta++) {
            const Sa = pa.x - ba[Ta].left, Ma = pa.x - ba[Ta + 1].left;
            if (Ma < 0) {
              Sa > Math.abs(Ma) && xa++, ya = !0;
              break;
            }
            xa++;
          }
          ya || (xa = va.length - _a + ba.length - 1);
          const wa = qn + xa;
          Un.setCarriagePosition(wa);
        });
      }), this.callPostChangeCarriageRangeListeners();
    });
    Ca(this, "isEnableTextEdit", () => this.models.length !== 0);
    Ca(this, "getModels", () => this.models.length === 0 ? null : this.models);
    Ca(this, "onChangeText", (Un) => {
      this.correctCarriagePosition(Un);
    });
    Ca(this, "onMoveCarriage", (Un) => {
      this.correctCarriagePosition(Un);
    });
    /**
     * Корректирует позицию каретки в зависимости от её положения в модели текста.
     * Если каретка представляет собой одиночный курсор, позиция обновляется на основе границ грэфем.
     * Если выделен фрагмент текста, корректируется область выделения.
     *
     * @param model - Модель текста, содержащая информацию о положении каретки.
     */
    Ca(this, "correctCarriagePosition", (Un) => {
      this.dependencies.render.forceRenderUnstructured();
      const Kn = Un.getParent(), qn = Un.getCarriagePosition(), Jo = Kn.getCarriageCoverages();
      if (Un.isEnableSelection()) {
        const ma = Un.getSelectionRange();
        if (ma === null)
          throw new EditorError("carriage range not found");
        this.correctSelection(Jo, ma);
      } else
        this.clearSelections(Jo);
      this.correctSingleCarriage(Jo, qn), this.dependencies.render.render();
    });
    Ca(this, "getLineEndPositions", (Un) => {
      const Kn = [];
      for (let qn = 0; qn < Un.length; qn++)
        Kn[qn] = (qn === 0 ? 0 : Kn[qn - 1]) + Un[qn];
      return Kn;
    });
    Ca(this, "findLineNumber", (Un, Kn) => {
      let qn = 0;
      for (let Jo = 0; Jo < Un.length; Jo++)
        if (qn += Un[Jo], Kn < qn)
          return Jo;
      return Un.length - 1;
    });
    Ca(this, "enableCarriages", (Un) => {
      Un.getParent().getTextViews().forEach((Jo) => {
        Jo.getTextCarriage().enable();
      });
    });
    Ca(this, "disableViews", (Un) => {
      Un.getParent().getTextViews().forEach((Jo) => {
        const pa = Jo.getTextCarriage();
        Jo.getTextSelection().disable(), pa.disable();
      });
    });
    Ca(this, "correctSingleCarriage", (Un, Kn) => {
      let qn = !1;
      for (let Jo = 0; Jo < Un.length; Jo++) {
        const { carriage: pa, coverage: ma, graphemePositions: va, lineHeights: ba } = Un[Jo];
        if (Kn >= ma.start && Kn <= ma.end) {
          const _a = Kn - ma.start;
          let ya = 0;
          for (let xa = 0; xa < va.length; xa++) {
            for (let wa = 0; wa < va[xa].length; wa++) {
              if (ya === _a) {
                const Ta = va[xa][wa], Ma = this.getLineEndPositions(ba)[xa] - ba[xa] / 2 - Ta.height / 2;
                qn = !0, pa.setPosition({
                  x: Ta.left,
                  y: Ma
                }), pa.setHeight(Ta.height), this.dependencies.render.renderRelativePositions();
                break;
              }
              if (qn)
                break;
              ya++;
            }
            if (qn)
              break;
          }
        } else
          pa.disable();
      }
    });
    Ca(this, "correctSelection", (Un, Kn) => {
      let qn = 0;
      for (let Jo = 0; Jo < Un.length; Jo++) {
        const { coverage: pa, graphemePositions: ma, view: va } = Un[Jo], ba = va.getTextSelection(), _a = { lines: [] }, ya = Math.max(Kn.start, pa.start), xa = Math.min(Kn.end, pa.end);
        for (let wa = 0; wa < ma.length; wa++) {
          const Ta = {
            start: qn,
            end: qn + ma[wa].length - 1
          };
          if (ya <= Ta.end && xa >= Ta.start) {
            const Sa = Math.max(Ta.start, ya), Ma = Math.min(Ta.end, xa), ka = Sa - qn, Za = Ma - qn;
            _a.lines.push({
              number: wa,
              range: {
                start: ka,
                end: Za
              }
            });
          }
          qn = Ta.end;
        }
        ba.setLinesSelection(Un[Jo], _a);
      }
    });
    Ca(this, "clearSelections", (Un) => {
      Un.forEach((Kn) => {
        Kn.view.getTextSelection().disable();
      });
    });
    Ca(this, "callPostChangeCarriageRangeListeners", () => {
      this.postChangeCarriageRangeListeners.forEach((Un) => Un());
    });
    this.models = [], this.postChangeCarriageRangeListeners = [];
  }
  moveCarriageWordLeft() {
    this.models.forEach((Un) => {
      Un.moveCarriageWordLeft();
    }), this.callPostChangeCarriageRangeListeners();
  }
  moveCarriageWordRight() {
    this.models.forEach((Un) => {
      Un.moveCarriageWordRight();
    }), this.callPostChangeCarriageRangeListeners();
  }
}
class TextEngine extends Dependent {
  constructor() {
    super();
    Ca(this, "modelParents");
    Ca(this, "getModelParents", () => this.modelParents);
    /**
     * Включает режим редактирования для указанной текстовой модели.
     *
     * @param {ITextModelParent} parent - Родительский объект текстовой модели.
     */
    Ca(this, "enableModelEditMode", (Un) => {
      if (this.isModelInEditMode(Un))
        throw new Error("enable model edit mode");
      const Kn = Un.getTextModel();
      Kn.addPostChangeTextListener(this.renderAllCanvas), Kn.addPostChangeTextActionListener(this.dependencies.textActionInitiator.notifyUserChange), this.dependencies.textEventGenerator.connectModel(Kn), this.dependencies.carriageCoordinator.connectModel(Kn), this.dependencies.textActionInitiator.start(), this.modelParents.push(Un), Kn.syncModelWithViews(), this.renderAllCanvas();
    });
    /**
     * Отключает режим редактирования для указанной текстовой модели.
     *
     * @param {ITextModelParent} parent - Родительский объект текстовой модели.
     * @throws {EditorError} Если указанная модель не найдена.
     */
    Ca(this, "disableModeEditMode", async (Un) => {
      const Kn = Un.getTextModel();
      Kn.removePostChangeTextListener(this.renderAllCanvas), this.dependencies.textEventGenerator.disconnectModel(Kn), this.dependencies.carriageCoordinator.disconnectModel(Kn);
      const qn = this.modelParents.indexOf(Un);
      if (qn === -1)
        throw new EditorError("parent not found");
      this.modelParents.splice(qn, 1), await this.dependencies.textActionInitiator.stop(), Kn.disableSelection(), this.renderAllCanvas();
    });
    /**
     * Отключает режим редактирования для всех текстовых моделей.
     */
    Ca(this, "disableAllModels", async () => {
      for (let Un = 0; Un < this.modelParents.length; Un++)
        await this.disableModeEditMode(this.modelParents[Un]);
    });
    Ca(this, "disableModelsExcept", (...Un) => {
      this.modelParents.forEach((Kn) => {
        Un.includes(Kn) || this.disableModeEditMode(Kn);
      });
    });
    /**
     * Проверяет, находится ли текстовая модель в режиме редактирования.
     *
     * @param {ITextModelParent} model - Текстовая модель для проверки.
     * @returns {boolean} Возвращает `true`, если модель в режиме редактирования, иначе `false`.
     */
    Ca(this, "isModelInEditMode", (Un) => this.modelParents.includes(Un));
    /**
     * Проверяет, находится ли хотя бы одна модель в режиме редактирования.
     *
     * @returns {boolean} Возвращает `true`, если хотя бы одна модель активна, иначе `false`.
     */
    Ca(this, "isAnyModelInEditMode", () => this.modelParents.length !== 0);
    /**
     * Перерисовывает все холсты.
     * Вызывает рендеринг без перерасчета актуальной последовательности объектов.
     */
    Ca(this, "renderAllCanvas", () => {
      this.dependencies.renders.forEach((Un) => Un.renderUnstructured());
    });
    this.modelParents = [], this.addPostInjectDependenciesListener((Un) => {
      Un.keyboardObserver.addPostInputListener(Un.textEventGenerator.onInputLetter);
    });
  }
}
class TextEventGenerator {
  constructor() {
    Ca(this, "models");
    Ca(this, "connectModel", (zn) => {
      this.models.push(zn);
    });
    Ca(this, "disconnectModel", (zn) => {
      const Un = this.models.indexOf(zn);
      if (Un === -1)
        throw new EditorError("model not connected");
      this.models.splice(Un, 1);
    });
    Ca(this, "onInputLetter", (zn) => {
      if (zn === "Enter") {
        const Kn = {
          type: TextEventType.LINE_BREAK,
          data: null
        };
        this.callModels(Kn);
        return;
      }
      const Un = {
        type: TextEventType.INSERT,
        data: {
          letter: zn
        }
      };
      this.callModels(Un);
    });
    Ca(this, "onRemove", (zn, Un, Kn) => {
      const qn = {
        type: TextEventType.REMOVE_LEFT,
        data: {
          mode: Un ? RemoveMode.WORD : Kn ? RemoveMode.LINE : RemoveMode.LETTER,
          direction: zn
        }
      };
      this.callModels(qn);
    });
    Ca(this, "callModels", (zn) => {
      for (let Un = 0; Un < this.models.length; Un++)
        this.models[Un].action(zn);
    });
    this.models = [];
  }
}
class ActionVisualizer extends Dependent {
  constructor() {
    super();
    Ca(this, "GUI_FOLDER_NAME", "User actions");
    Ca(this, "guiParameters");
    Ca(this, "addGUIBlock", (Un) => {
      Un.addFolder(this.GUI_FOLDER_NAME).add(this.guiParameters, "isEnable").name("Show").onChange((qn) => {
        qn ? this.enable() : this.disable(), this.sync();
      });
    });
    Ca(this, "sync", () => {
      this.dependencies.render.render();
    });
    Ca(this, "getObjects", () => {
      if (!this.guiParameters.isEnable)
        return [];
      const { actionRepository: Un } = this.dependencies, Kn = Un.getActions(), qn = Un.getCursorPosition(), Jo = [], pa = new Xo(this.dependencies.actionController.isRunningAction() ? "Running" : "Idle", {
        left: 20,
        top: 5,
        fontSize: 10,
        fill: "green",
        fontFamily: FontFamily.DEFAULT
      });
      Jo.push(pa);
      let ma = 20;
      Kn.forEach((_a, ya) => {
        const xa = _a.getRedoCommands(), wa = [];
        let Ta = 0;
        xa.forEach((ka, Za) => {
          const Na = new Xo(ka.type, {
            left: ma,
            top: 55 + Za * 12,
            fontSize: 10,
            fill: "blue",
            fontFamily: FontFamily.DEFAULT
          });
          wa.push(Na), Ta = Math.max(Ta, Na.width ?? 0);
        });
        const Sa = new pr({
          left: ma,
          top: 20,
          width: 30,
          height: 30,
          fill: "lightgray",
          stroke: "black",
          strokeWidth: 1
        }), Ma = new Xo(`${ya + 1}`, {
          left: ma + 10,
          top: 25,
          fontSize: 14,
          fill: "black",
          fontFamily: FontFamily.DEFAULT
        });
        Jo.push(Sa, Ma, ...wa), ma += Math.max(Ta, 40) + 10;
      });
      const va = (() => {
        let _a = 0;
        for (let ya = 0; ya < qn && ya < Kn.length; ya++) {
          const xa = Kn[ya].getRedoCommands();
          let wa = 0;
          xa.forEach((Ta) => {
            const Sa = new Xo(Ta.type, {
              fontSize: 10,
              fontFamily: FontFamily.DEFAULT
            });
            wa = Math.max(wa, Sa.width ?? 0);
          }), _a += Math.max(wa, 40) + 10;
        }
        return _a;
      })(), ba = new to$1({
        left: va - 5,
        top: 15,
        width: 10,
        height: 10,
        fill: "red",
        angle: 180,
        originX: "left",
        originY: "top"
      });
      return Jo.push(ba), Jo;
    });
    Ca(this, "enable", () => {
      this.guiParameters.isEnable = !0;
    });
    Ca(this, "disable", () => {
      this.guiParameters.isEnable = !1;
    });
    this.guiParameters = {
      isEnable: !1
    };
  }
}
class SpatialGrid {
  constructor() {
    Ca(this, "CELL_SIZE", 128);
    Ca(this, "allAreas");
    Ca(this, "postSyncListeners");
    Ca(this, "grid");
    Ca(this, "areaToCells");
    /**
     * Возвращает все области, которые пересекаются с указанной точкой в глобальных координатах.
     *
     * Сначала определяется ячейка сетки, в которую попадает точка, затем извлекаются все области из этой ячейки.
     * После этого проводится точная проверка: действительно ли фрейм области пересекается с точкой.
     *
     * Это позволяет эффективно выполнять поиск по точке без проверки всех объектов в сцене.
     *
     * @param position Глобальные координаты тоски.
     */
    Ca(this, "getAreasAtPosition", (zn) => {
      const { x: Un, y: Kn } = zn, qn = `${Math.floor(Un / this.CELL_SIZE)},${Math.floor(Kn / this.CELL_SIZE)}`, Jo = this.grid.get(qn);
      return Jo ? [...Jo].filter((pa) => {
        const ma = pa.getGlobalFrameArea();
        return Un >= ma.x && Un <= ma.x + ma.width && Kn >= ma.y && Kn <= ma.y + ma.height;
      }) : [];
    });
    /**
     * Возвращает все области, которые есть в сетке.
     */
    Ca(this, "getAreas", () => [...this.allAreas]);
    /**
     * Возвращает ключи всех занятых ячеек.
     */
    Ca(this, "getCells", () => [...this.grid.keys()]);
    /**
     * Возвращает размер ячейки
     */
    Ca(this, "getCellSize", () => this.CELL_SIZE);
    Ca(this, "addPostSyncListener", (zn) => {
      this.postSyncListeners.push(zn);
    });
    Ca(this, "callPostSyncListeners", () => {
      this.postSyncListeners.forEach((zn) => zn());
    });
    /**
     * Добавляет новую область в сетку.
     * @param area Добавляемая область.
     */
    Ca(this, "add", (zn) => {
      const Un = zn.getGlobalFrameArea(), Kn = this.getCellKeys(Un);
      for (const qn of Kn)
        this.grid.has(qn) || this.grid.set(qn, /* @__PURE__ */ new Set()), this.grid.get(qn).add(zn);
      this.allAreas.add(zn), this.areaToCells.set(zn, Kn);
    });
    /**
     * Обновляет местоположение области (удаляет и добавляет заново).
     * @param area Обновляемая область.
     */
    Ca(this, "update", (zn) => {
      this.remove(zn), this.add(zn);
    });
    /**
     * Удаляет область из сетки.
     * @param area Удаляемая область.
     */
    Ca(this, "remove", (zn) => {
      const Un = this.areaToCells.get(zn);
      if (Un) {
        for (const Kn of Un) {
          const qn = this.grid.get(Kn);
          qn && (qn.delete(zn), qn.size === 0 && this.grid.delete(Kn));
        }
        this.allAreas.delete(zn), this.areaToCells.delete(zn);
      }
    });
    this.allAreas = /* @__PURE__ */ new Set(), this.postSyncListeners = [], this.grid = /* @__PURE__ */ new Map(), this.areaToCells = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Синхронизирует текущее состояние областей:
   * - добавляет новые,
   * - обновляет грязные (dirty),
   * - удаляет отсутствующие.
   *
   * Вызывает `postSyncListeners` после завершения.
   *
   * @param areas Список всех актуальных областей.
   */
  syncAreas(zn) {
    const Un = new Set(this.allAreas), Kn = new Set(zn);
    for (const qn of zn)
      Un.has(qn) || this.add(qn);
    for (const qn of Un)
      qn.isDirtyArea() && (this.update(qn), qn.clearDirty());
    for (const qn of Un)
      Kn.has(qn) || this.remove(qn);
    this.callPostSyncListeners();
  }
  /**
   * Получает ключи ячеек, которые пересекаются с фреймом области.
   * @param frame Фрейм области.
   */
  getCellKeys(zn) {
    const Un = [], Kn = Math.floor(zn.x / this.CELL_SIZE), qn = Math.floor(zn.y / this.CELL_SIZE), Jo = Math.floor((zn.x + zn.width) / this.CELL_SIZE), pa = Math.floor((zn.y + zn.height) / this.CELL_SIZE);
    for (let ma = qn; ma <= pa; ma++)
      for (let va = Kn; va <= Jo; va++)
        Un.push(`${va},${ma}`);
    return Un;
  }
}
class TextSelectionObserver {
  constructor() {
    Ca(this, "globalGraphemes");
    Ca(this, "postChangeListeners");
    Ca(this, "blindZoneDetector");
    Ca(this, "model");
    Ca(this, "offsets");
    Ca(this, "selectionArea");
    Ca(this, "initPosition");
    Ca(this, "start", (zn, Un, Kn) => {
      const Jo = Un.getParent().getTextViews();
      if (zn.length !== Jo.length)
        throw new EditorError("The number of provided areas does not match the number of text views");
      for (let pa = 0; pa < zn.length; pa++) {
        const ma = zn[pa];
        if (ma.type === SpatialCanvasAreaType.TABLE_CELL) {
          const va = ma.getData(), ba = Jo[pa], _a = ba.getGraphemePositions(), ya = ba.getRealLineHeights(), xa = ma.getGlobalFrameArea(), wa = ba.getTextPadding(), Ta = va.areaCell.getLocalFrameArea(), Sa = {
            x: wa.x - Ta.x,
            y: wa.y - Ta.y
          };
          let Ma = Sa.y;
          for (let ka = 0; ka < _a.length; ka++) {
            const Za = _a[ka], Na = [], Ka = Un.getTexture().textAlign;
            let Ja = 0;
            const el = Za.reduce((tl, Qa) => tl + Qa.width, 0);
            let qa = Sa.x;
            switch (Ka) {
              case TextAlign.CENTER: {
                Ja = xa.width / 2 - el / 2, qa = 0;
                break;
              }
              case TextAlign.RIGHT: {
                Ja = xa.width - el, qa = -qa;
                break;
              }
            }
            for (let tl = 0; tl < Za.length - 1; tl++)
              Na.push({
                x: xa.x + Za[tl].left + qa + Ja,
                y: xa.y + Ma,
                width: Za[tl].width,
                height: ya[ka],
                rotate: 0
              });
            this.globalGraphemes.push(Na), Ma += ya[ka];
          }
        } else {
          const va = Jo[pa], ba = va.getGraphemePositions(), _a = va.getRealLineHeights(), ya = ma.getGlobalFrameArea(), xa = va.getTextPadding();
          let wa = -xa.y;
          for (let Ta = 0; Ta < ba.length; Ta++) {
            const Sa = ba[Ta], Ma = [], ka = Un.getTexture().textAlign;
            let Za = 0;
            const Na = Sa.reduce((Ja, el) => Ja + el.width, 0);
            let Ka = xa.x;
            switch (ka) {
              case TextAlign.CENTER: {
                Za = ya.width / 2 - Na / 2, Ka = 0;
                break;
              }
              case TextAlign.RIGHT: {
                Za = ya.width - Na, Ka = -Ka;
                break;
              }
            }
            for (let Ja = 0; Ja < Sa.length - 1; Ja++)
              Ma.push({
                x: ya.x + Sa[Ja].left + Ka + Za,
                y: ya.y - wa,
                width: Sa[Ja].width,
                height: _a[Ta],
                rotate: 0
              });
            this.globalGraphemes.push(Ma), wa -= _a[Ta];
          }
        }
      }
      this.initPosition = Kn, this.selectionArea = {
        x: Kn.x,
        y: Kn.y,
        width: 0,
        rotate: 0,
        height: 0
      }, this.model = Un, this.blindZoneDetector.start(), this.callPostChangeListeners();
    });
    Ca(this, "move", (zn, Un) => {
      if (this.initPosition === null)
        return;
      if (this.model === null)
        throw new EditorError("model is null");
      if (this.selectionArea === null)
        throw new EditorError("selection area is null");
      if (this.offsets.x += zn, this.offsets.y += Un, this.blindZoneDetector.appendOffsets({
        x: zn,
        y: Un
      }), !this.blindZoneDetector.isBlindZoneOverstepping())
        return;
      this.model.enableSelection(), this.offsets.x > 0 ? (this.selectionArea.x = this.initPosition.x, this.selectionArea.width = this.offsets.x) : (this.selectionArea.x = this.initPosition.x + this.offsets.x, this.selectionArea.width = Math.abs(this.offsets.x)), this.offsets.y > 0 ? (this.selectionArea.y = this.initPosition.y, this.selectionArea.height = this.offsets.y) : (this.selectionArea.y = this.initPosition.y + this.offsets.y, this.selectionArea.height = Math.abs(this.offsets.y));
      let Kn = null, qn = null, Jo = 0, pa = !1;
      for (let ma = 0; ma < this.globalGraphemes.length; ma++)
        for (let va = 0; va < this.globalGraphemes[ma].length; va++) {
          const ba = this.globalGraphemes[ma][va], _a = ba.x + ba.width / 2;
          _a >= this.selectionArea.x && _a <= this.selectionArea.x + this.selectionArea.width && Utils.geometry.isCrossedAreas(this.selectionArea, ba) && (pa ? qn = Jo : (pa = !0, Kn = Jo)), Jo++;
        }
      if (this.callPostChangeListeners(), Kn === null || qn === null) {
        this.model.disableSelection();
        return;
      }
      this.model.setSelection(Kn, qn);
    });
    Ca(this, "stop", () => {
      this.model = null, this.offsets.x = 0, this.offsets.y = 0, this.initPosition = null, this.selectionArea = null, this.globalGraphemes.length = 0, this.callPostChangeListeners();
    });
    Ca(this, "selectWordToCarriagePosition", (zn) => {
      zn.selectWord();
    });
    Ca(this, "addPostChangeListener", (zn) => {
      this.postChangeListeners.push(zn);
    });
    Ca(this, "getGraphemeLines", () => this.globalGraphemes.map((zn) => [...zn]));
    Ca(this, "getActiveModel", () => this.model);
    Ca(this, "getSelectionAreaFrame", () => this.selectionArea);
    Ca(this, "callPostChangeListeners", () => {
      for (const zn of this.postChangeListeners)
        zn();
    });
    this.model = null, this.initPosition = null, this.globalGraphemes = [], this.selectionArea = null, this.offsets = { x: 0, y: 0 }, this.postChangeListeners = [], this.blindZoneDetector = new BlindZoneDetector();
  }
}
class TextSelectionVisualizer {
  constructor(zn, Un) {
    Ca(this, "GUI_FOLDER_NAME", "Text Selection");
    Ca(this, "GRAPHEME_FILL_COLOR", "rgba(255,156,156,0.6)");
    Ca(this, "GRAPHEME_STROKE_COLOR", "rgba(255,156,156,1)");
    Ca(this, "SELECTION_AREA_FILL_COLOR", "rgba(156,158,255,0.6)");
    Ca(this, "SELECTION_AREA_STROKE_COLOR", "rgba(156,158,255,1)");
    Ca(this, "postSyncListeners");
    Ca(this, "parameters");
    Ca(this, "addGUIBlock", (zn) => {
      const Un = zn.addFolder(this.GUI_FOLDER_NAME);
      Un.add(this.parameters, "isGraphemeFramesShow").name("Show grapheme frames").onChange(this.sync), Un.add(this.parameters, "isSelectionAreaShow").name("Show selection area").onChange(this.sync), Un.add(this.parameters, "graphemeCount").name("Grapheme count enabled").listen().disable(), Un.add(this.parameters, "carriageRange").name("Current carriage range").listen().disable(), this.updateCounts();
    });
    Ca(this, "addPostSyncListener", (zn) => {
      this.postSyncListeners.push(zn);
    });
    Ca(this, "getObjects", () => {
      const zn = [], Un = this.selectionObserver.getGraphemeLines();
      Un !== null && this.parameters.isGraphemeFramesShow && zn.push(
        ...Un.flat().map(
          (qn) => new pr({
            left: qn.x,
            top: qn.y,
            width: qn.width,
            height: qn.height,
            fill: this.GRAPHEME_FILL_COLOR,
            strokeWidth: 1,
            stroke: this.GRAPHEME_STROKE_COLOR
          })
        )
      );
      const Kn = this.selectionObserver.getSelectionAreaFrame();
      return Kn !== null && this.parameters.isSelectionAreaShow && zn.push(
        new pr({
          left: Kn.x,
          top: Kn.y,
          width: Kn.width,
          height: Kn.height,
          fill: this.SELECTION_AREA_FILL_COLOR,
          strokeWidth: 1,
          stroke: this.SELECTION_AREA_STROKE_COLOR
        })
      ), zn;
    });
    Ca(this, "sync", () => {
      this.updateCounts(), this.callPostSyncListeners();
    });
    Ca(this, "updateCounts", () => {
      const zn = this.carriageCoordinator.getModels(), Un = this.selectionObserver.getGraphemeLines();
      this.parameters.graphemeCount = Un === null ? 0 : Un.flat().length, zn === null ? this.parameters.carriageRange = "-1" : this.parameters.carriageRange = zn.map((Kn) => {
        const qn = Kn.getSelectionRange();
        return qn === null ? "null" : `${qn.start}:${qn.end}`;
      }).join("|");
    });
    Ca(this, "callPostSyncListeners", () => {
      this.postSyncListeners.forEach((zn) => zn());
    });
    this.selectionObserver = zn, this.carriageCoordinator = Un, this.parameters = {
      isGraphemeFramesShow: !1,
      isSelectionAreaShow: !1,
      graphemeCount: 0,
      selectedGraphemeCount: 0,
      carriageRange: ""
    }, this.postSyncListeners = [];
  }
}
class DynamicEditor extends BaseEditor {
  constructor(Un) {
    super(Un);
    Ca(this, "uiRender");
    Ca(this, "textEngine");
    Ca(this, "uiCanvas");
    Ca(this, "uiSpatialGrid");
    Ca(this, "uiMouseObserver");
    Ca(this, "canvasSpatialGrid");
    Ca(this, "actionVisualizer");
    Ca(this, "uiObjectOrganizer");
    Ca(this, "componentAlignment");
    Ca(this, "textEventGenerator");
    Ca(this, "carriageCoordinator");
    Ca(this, "componentFactory");
    Ca(this, "textSelectionObserver");
    Ca(this, "objectOrganizer");
    Ca(this, "textSelectionVisualizer");
    Ca(this, "adaptUICanvas", () => {
      this.canvas.setDimensions({
        width: this.editorContainer.offsetWidth,
        height: this.editorContainer.offsetHeight
      }), this.uiCanvas.setDimensions({
        width: this.editorContainer.offsetWidth,
        height: this.editorContainer.offsetHeight
      }), this.canvas.requestRenderAll(), this.uiCanvas.requestRenderAll();
    });
    this.uiRender = new UIRender(), this.uiSpatialGrid = new SpatialGrid(), this.canvasSpatialGrid = new SpatialGrid(), this.carriageCoordinator = new CarriageCoordinator(), this.textSelectionObserver = new TextSelectionObserver(), this.objectOrganizer = new DynamicCanvasObjectOrganizer(), this.textSelectionVisualizer = new TextSelectionVisualizer(this.textSelectionObserver, this.carriageCoordinator), this.uiObjectOrganizer = new UIObjectOrganizer(), this.textEngine = new TextEngine(), this.textEventGenerator = new TextEventGenerator(), this.componentAlignment = new ComponentAlignment(), this.componentFactory = new DynamicComponentFactory(), this.uiCanvas = this.getStaticCanvas(Un.offsetWidth, Un.offsetHeight, void 0), this.uiMouseObserver = new MouseObserver(this.editorContainer, this.uiCanvas), this.actionVisualizer = new ActionVisualizer(), this.textSelectionVisualizer.addPostSyncListener(this.canvasRender.render), this.textSelectionVisualizer.addPostSyncListener(this.uiRender.render), this.textSelectionObserver.addPostChangeListener(this.textSelectionVisualizer.sync), this.debugEntities.push(this.textSelectionVisualizer), Un.append(this.uiCanvas.getElement());
  }
  // public enableAIModalMode = () => {
  // 	const pagesContainer = this.componentTree.getPagesContainer();
  // 	pagesContainer.enableRightMagneticMode();
  // 	// this.interface.hidePropertiesBar();
  // };
  //
  // public disableAIModalMode = () => {
  // 	const pagesContainer = this.componentTree.getPagesContainer();
  // 	pagesContainer.disableRightMagneticMode();
  // 	// this.interface.showPropertiesBar();
  // };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(Xn, zn) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Un, Kn) {
    Un.__proto__ = Kn;
  } || function(Un, Kn) {
    for (var qn in Kn) Kn.hasOwnProperty(qn) && (Un[qn] = Kn[qn]);
  }, extendStatics(Xn, zn);
};
function __extends(Xn, zn) {
  extendStatics(Xn, zn);
  function Un() {
    this.constructor = Xn;
  }
  Xn.prototype = zn === null ? Object.create(zn) : (Un.prototype = zn.prototype, new Un());
}
var __assign = function() {
  return __assign = Object.assign || function(zn) {
    for (var Un, Kn = 1, qn = arguments.length; Kn < qn; Kn++) {
      Un = arguments[Kn];
      for (var Jo in Un) Object.prototype.hasOwnProperty.call(Un, Jo) && (zn[Jo] = Un[Jo]);
    }
    return zn;
  }, __assign.apply(this, arguments);
};
function __rest(Xn, zn) {
  var Un = {};
  for (var Kn in Xn) Object.prototype.hasOwnProperty.call(Xn, Kn) && zn.indexOf(Kn) < 0 && (Un[Kn] = Xn[Kn]);
  if (Xn != null && typeof Object.getOwnPropertySymbols == "function")
    for (var qn = 0, Kn = Object.getOwnPropertySymbols(Xn); qn < Kn.length; qn++)
      zn.indexOf(Kn[qn]) < 0 && Object.prototype.propertyIsEnumerable.call(Xn, Kn[qn]) && (Un[Kn[qn]] = Xn[Kn[qn]]);
  return Un;
}
function __awaiter(Xn, zn, Un, Kn) {
  function qn(Jo) {
    return Jo instanceof Un ? Jo : new Un(function(pa) {
      pa(Jo);
    });
  }
  return new (Un || (Un = Promise))(function(Jo, pa) {
    function ma(_a) {
      try {
        ba(Kn.next(_a));
      } catch (ya) {
        pa(ya);
      }
    }
    function va(_a) {
      try {
        ba(Kn.throw(_a));
      } catch (ya) {
        pa(ya);
      }
    }
    function ba(_a) {
      _a.done ? Jo(_a.value) : qn(_a.value).then(ma, va);
    }
    ba((Kn = Kn.apply(Xn, [])).next());
  });
}
function __generator(Xn, zn) {
  var Un = { label: 0, sent: function() {
    if (Jo[0] & 1) throw Jo[1];
    return Jo[1];
  }, trys: [], ops: [] }, Kn, qn, Jo, pa;
  return pa = { next: ma(0), throw: ma(1), return: ma(2) }, typeof Symbol == "function" && (pa[Symbol.iterator] = function() {
    return this;
  }), pa;
  function ma(ba) {
    return function(_a) {
      return va([ba, _a]);
    };
  }
  function va(ba) {
    if (Kn) throw new TypeError("Generator is already executing.");
    for (; Un; ) try {
      if (Kn = 1, qn && (Jo = ba[0] & 2 ? qn.return : ba[0] ? qn.throw || ((Jo = qn.return) && Jo.call(qn), 0) : qn.next) && !(Jo = Jo.call(qn, ba[1])).done) return Jo;
      switch (qn = 0, Jo && (ba = [ba[0] & 2, Jo.value]), ba[0]) {
        case 0:
        case 1:
          Jo = ba;
          break;
        case 4:
          return Un.label++, { value: ba[1], done: !1 };
        case 5:
          Un.label++, qn = ba[1], ba = [0];
          continue;
        case 7:
          ba = Un.ops.pop(), Un.trys.pop();
          continue;
        default:
          if (Jo = Un.trys, !(Jo = Jo.length > 0 && Jo[Jo.length - 1]) && (ba[0] === 6 || ba[0] === 2)) {
            Un = 0;
            continue;
          }
          if (ba[0] === 3 && (!Jo || ba[1] > Jo[0] && ba[1] < Jo[3])) {
            Un.label = ba[1];
            break;
          }
          if (ba[0] === 6 && Un.label < Jo[1]) {
            Un.label = Jo[1], Jo = ba;
            break;
          }
          if (Jo && Un.label < Jo[2]) {
            Un.label = Jo[2], Un.ops.push(ba);
            break;
          }
          Jo[2] && Un.ops.pop(), Un.trys.pop();
          continue;
      }
      ba = zn.call(Xn, Un);
    } catch (_a) {
      ba = [6, _a], qn = 0;
    } finally {
      Kn = Jo = 0;
    }
    if (ba[0] & 5) throw ba[1];
    return { value: ba[0] ? ba[1] : void 0, done: !0 };
  }
}
function __spreadArrays() {
  for (var Xn = 0, zn = 0, Un = arguments.length; zn < Un; zn++) Xn += arguments[zn].length;
  for (var Kn = Array(Xn), qn = 0, zn = 0; zn < Un; zn++)
    for (var Jo = arguments[zn], pa = 0, ma = Jo.length; pa < ma; pa++, qn++)
      Kn[qn] = Jo[pa];
  return Kn;
}
var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", lookup$1 = new Uint8Array(256);
for (var i$1 = 0; i$1 < chars$1.length; i$1++)
  lookup$1[chars$1.charCodeAt(i$1)] = i$1;
var encodeToBase64 = function(Xn) {
  for (var zn = "", Un = Xn.length, Kn = 0; Kn < Un; Kn += 3)
    zn += chars$1[Xn[Kn] >> 2], zn += chars$1[(Xn[Kn] & 3) << 4 | Xn[Kn + 1] >> 4], zn += chars$1[(Xn[Kn + 1] & 15) << 2 | Xn[Kn + 2] >> 6], zn += chars$1[Xn[Kn + 2] & 63];
  return Un % 3 === 2 ? zn = zn.substring(0, zn.length - 1) + "=" : Un % 3 === 1 && (zn = zn.substring(0, zn.length - 2) + "=="), zn;
}, decodeFromBase64$1 = function(Xn) {
  var zn = Xn.length * 0.75, Un = Xn.length, Kn, qn = 0, Jo, pa, ma, va;
  Xn[Xn.length - 1] === "=" && (zn--, Xn[Xn.length - 2] === "=" && zn--);
  var ba = new Uint8Array(zn);
  for (Kn = 0; Kn < Un; Kn += 4)
    Jo = lookup$1[Xn.charCodeAt(Kn)], pa = lookup$1[Xn.charCodeAt(Kn + 1)], ma = lookup$1[Xn.charCodeAt(Kn + 2)], va = lookup$1[Xn.charCodeAt(Kn + 3)], ba[qn++] = Jo << 2 | pa >> 4, ba[qn++] = (pa & 15) << 4 | ma >> 2, ba[qn++] = (ma & 3) << 6 | va & 63;
  return ba;
}, DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i, decodeFromBase64DataUri = function(Xn) {
  var zn = Xn.trim(), Un = zn.substring(0, 100), Kn = Un.match(DATA_URI_PREFIX_REGEX);
  if (!Kn)
    return decodeFromBase64$1(zn);
  var qn = Kn[0], Jo = zn.substring(qn.length);
  return decodeFromBase64$1(Jo);
}, toCharCode = function(Xn) {
  return Xn.charCodeAt(0);
}, toCodePoint = function(Xn) {
  return Xn.codePointAt(0);
}, toHexStringOfMinLength = function(Xn, zn) {
  return padStart$1(Xn.toString(16), zn, "0").toUpperCase();
}, toHexString = function(Xn) {
  return toHexStringOfMinLength(Xn, 2);
}, charFromCode = function(Xn) {
  return String.fromCharCode(Xn);
}, charFromHexCode = function(Xn) {
  return charFromCode(parseInt(Xn, 16));
}, padStart$1 = function(Xn, zn, Un) {
  for (var Kn = "", qn = 0, Jo = zn - Xn.length; qn < Jo; qn++)
    Kn += Un;
  return Kn + Xn;
}, copyStringIntoBuffer = function(Xn, zn, Un) {
  for (var Kn = Xn.length, qn = 0; qn < Kn; qn++)
    zn[Un++] = Xn.charCodeAt(qn);
  return Kn;
}, escapeRegExp = function(Xn) {
  return Xn.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}, cleanText = function(Xn) {
  return Xn.replace(/\t|\u0085|\u2028|\u2029/g, "    ").replace(/[\b\v]/g, "");
}, escapedNewlineChars = ["\\n", "\\f", "\\r", "\\u000B"], isNewlineChar = function(Xn) {
  return /^[\n\f\r\u000B]$/.test(Xn);
}, lineSplit = function(Xn) {
  return Xn.split(/[\n\f\r\u000B]/);
}, mergeLines = function(Xn) {
  return Xn.replace(/[\n\f\r\u000B]/g, " ");
}, charAtIndex = function(Xn, zn) {
  var Un = Xn.charCodeAt(zn), Kn, qn = zn + 1, Jo = 1;
  return (
    // Check if it's the start of a surrogate pair.
    Un >= 55296 && Un <= 56319 && // high surrogate
    Xn.length > qn && (Kn = Xn.charCodeAt(qn), Kn >= 56320 && Kn <= 57343 && (Jo = 2)), [Xn.slice(zn, zn + Jo), Jo]
  );
}, charSplit = function(Xn) {
  for (var zn = [], Un = 0, Kn = Xn.length; Un < Kn; ) {
    var qn = charAtIndex(Xn, Un), Jo = qn[0], pa = qn[1];
    zn.push(Jo), Un += pa;
  }
  return zn;
}, buildWordBreakRegex = function(Xn) {
  for (var zn = escapedNewlineChars.join("|"), Un = ["$"], Kn = 0, qn = Xn.length; Kn < qn; Kn++) {
    var Jo = Xn[Kn];
    if (isNewlineChar(Jo))
      throw new TypeError("`wordBreak` must not include " + zn);
    Un.push(Jo === "" ? "." : escapeRegExp(Jo));
  }
  var pa = Un.join("|");
  return new RegExp("(" + zn + ")|((.*?)(" + pa + "))", "gm");
}, breakTextIntoLines = function(Xn, zn, Un, Kn) {
  for (var qn = buildWordBreakRegex(zn), Jo = cleanText(Xn).match(qn), pa = "", ma = 0, va = [], ba = function() {
    pa !== "" && va.push(pa), pa = "", ma = 0;
  }, _a = 0, ya = Jo.length; _a < ya; _a++) {
    var xa = Jo[_a];
    if (isNewlineChar(xa))
      ba();
    else {
      var wa = Kn(xa);
      ma + wa > Un && ba(), pa += xa, ma += wa;
    }
  }
  return ba(), va;
}, dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/, parseDate = function(Xn) {
  var zn = Xn.match(dateRegex);
  if (zn) {
    var Un = zn[1], Kn = zn[2], qn = Kn === void 0 ? "01" : Kn, Jo = zn[3], pa = Jo === void 0 ? "01" : Jo, ma = zn[4], va = ma === void 0 ? "00" : ma, ba = zn[5], _a = ba === void 0 ? "00" : ba, ya = zn[6], xa = ya === void 0 ? "00" : ya, wa = zn[7], Ta = wa === void 0 ? "Z" : wa, Sa = zn[8], Ma = Sa === void 0 ? "00" : Sa, ka = zn[9], Za = ka === void 0 ? "00" : ka, Na = Ta === "Z" ? "Z" : "" + Ta + Ma + ":" + Za, Ka = /* @__PURE__ */ new Date(Un + "-" + qn + "-" + pa + "T" + va + ":" + _a + ":" + xa + Na);
    return Ka;
  }
}, findLastMatch = function(Xn, zn) {
  for (var Un, Kn = 0, qn; Kn < Xn.length; ) {
    var Jo = Xn.substring(Kn).match(zn);
    if (!Jo)
      return { match: qn, pos: Kn };
    qn = Jo, Kn += ((Un = Jo.index) !== null && Un !== void 0 ? Un : 0) + Jo[0].length;
  }
  return { match: qn, pos: Kn };
}, last = function(Xn) {
  return Xn[Xn.length - 1];
}, typedArrayFor = function(Xn) {
  if (Xn instanceof Uint8Array)
    return Xn;
  for (var zn = Xn.length, Un = new Uint8Array(zn), Kn = 0; Kn < zn; Kn++)
    Un[Kn] = Xn.charCodeAt(Kn);
  return Un;
}, mergeIntoTypedArray = function() {
  for (var Xn = [], zn = 0; zn < arguments.length; zn++)
    Xn[zn] = arguments[zn];
  for (var Un = Xn.length, Kn = [], qn = 0; qn < Un; qn++) {
    var Jo = Xn[qn];
    Kn[qn] = Jo instanceof Uint8Array ? Jo : typedArrayFor(Jo);
  }
  for (var pa = 0, qn = 0; qn < Un; qn++)
    pa += Xn[qn].length;
  for (var ma = new Uint8Array(pa), va = 0, ba = 0; ba < Un; ba++)
    for (var _a = Kn[ba], ya = 0, xa = _a.length; ya < xa; ya++)
      ma[va++] = _a[ya];
  return ma;
}, mergeUint8Arrays = function(Xn) {
  for (var zn = 0, Un = 0, Kn = Xn.length; Un < Kn; Un++)
    zn += Xn[Un].length;
  for (var qn = new Uint8Array(zn), Jo = 0, Un = 0, Kn = Xn.length; Un < Kn; Un++) {
    var pa = Xn[Un];
    qn.set(pa, Jo), Jo += pa.length;
  }
  return qn;
}, arrayAsString = function(Xn) {
  for (var zn = "", Un = 0, Kn = Xn.length; Un < Kn; Un++)
    zn += charFromCode(Xn[Un]);
  return zn;
}, byAscendingId = function(Xn, zn) {
  return Xn.id - zn.id;
}, sortedUniq = function(Xn, zn) {
  for (var Un = [], Kn = 0, qn = Xn.length; Kn < qn; Kn++) {
    var Jo = Xn[Kn], pa = Xn[Kn - 1];
    (Kn === 0 || zn(Jo) !== zn(pa)) && Un.push(Jo);
  }
  return Un;
}, reverseArray = function(Xn) {
  for (var zn = Xn.length, Un = 0, Kn = Math.floor(zn / 2); Un < Kn; Un++) {
    var qn = Un, Jo = zn - Un - 1, pa = Xn[Un];
    Xn[qn] = Xn[Jo], Xn[Jo] = pa;
  }
  return Xn;
}, sum = function(Xn) {
  for (var zn = 0, Un = 0, Kn = Xn.length; Un < Kn; Un++)
    zn += Xn[Un];
  return zn;
}, range = function(Xn, zn) {
  for (var Un = new Array(zn - Xn), Kn = 0, qn = Un.length; Kn < qn; Kn++)
    Un[Kn] = Xn + Kn;
  return Un;
}, pluckIndices = function(Xn, zn) {
  for (var Un = new Array(zn.length), Kn = 0, qn = zn.length; Kn < qn; Kn++)
    Un[Kn] = Xn[zn[Kn]];
  return Un;
}, canBeConvertedToUint8Array = function(Xn) {
  return Xn instanceof Uint8Array || Xn instanceof ArrayBuffer || typeof Xn == "string";
}, toUint8Array = function(Xn) {
  if (typeof Xn == "string")
    return decodeFromBase64DataUri(Xn);
  if (Xn instanceof ArrayBuffer)
    return new Uint8Array(Xn);
  if (Xn instanceof Uint8Array)
    return Xn;
  throw new TypeError("`input` must be one of `string | ArrayBuffer | Uint8Array`");
}, waitForTick = function() {
  return new Promise(function(Xn) {
    setTimeout(function() {
      return Xn();
    }, 0);
  });
}, utf16Encode = function(Xn, zn) {
  zn === void 0 && (zn = !0);
  var Un = [];
  zn && Un.push(65279);
  for (var Kn = 0, qn = Xn.length; Kn < qn; ) {
    var Jo = Xn.codePointAt(Kn);
    if (Jo < 65536)
      Un.push(Jo), Kn += 1;
    else if (Jo < 1114112)
      Un.push(highSurrogate(Jo), lowSurrogate(Jo)), Kn += 2;
    else
      throw new Error("Invalid code point: 0x" + toHexString(Jo));
  }
  return new Uint16Array(Un);
}, isWithinBMP = function(Xn) {
  return Xn >= 0 && Xn <= 65535;
}, hasSurrogates = function(Xn) {
  return Xn >= 65536 && Xn <= 1114111;
}, highSurrogate = function(Xn) {
  return Math.floor((Xn - 65536) / 1024) + 55296;
}, lowSurrogate = function(Xn) {
  return (Xn - 65536) % 1024 + 56320;
}, ByteOrder;
(function(Xn) {
  Xn.BigEndian = "BigEndian", Xn.LittleEndian = "LittleEndian";
})(ByteOrder || (ByteOrder = {}));
var REPLACEMENT = "�".codePointAt(0), utf16Decode = function(Xn, zn) {
  if (zn === void 0 && (zn = !0), Xn.length <= 1)
    return String.fromCodePoint(REPLACEMENT);
  for (var Un = zn ? readBOM(Xn) : ByteOrder.BigEndian, Kn = zn ? 2 : 0, qn = []; Xn.length - Kn >= 2; ) {
    var Jo = decodeValues(Xn[Kn++], Xn[Kn++], Un);
    if (isHighSurrogate(Jo))
      if (Xn.length - Kn < 2)
        qn.push(REPLACEMENT);
      else {
        var pa = decodeValues(Xn[Kn++], Xn[Kn++], Un);
        isLowSurrogate(pa) ? qn.push(Jo, pa) : qn.push(REPLACEMENT);
      }
    else isLowSurrogate(Jo) ? (Kn += 2, qn.push(REPLACEMENT)) : qn.push(Jo);
  }
  return Kn < Xn.length && qn.push(REPLACEMENT), String.fromCodePoint.apply(String, qn);
}, isHighSurrogate = function(Xn) {
  return Xn >= 55296 && Xn <= 56319;
}, isLowSurrogate = function(Xn) {
  return Xn >= 56320 && Xn <= 57343;
}, decodeValues = function(Xn, zn, Un) {
  if (Un === ByteOrder.LittleEndian)
    return zn << 8 | Xn;
  if (Un === ByteOrder.BigEndian)
    return Xn << 8 | zn;
  throw new Error("Invalid byteOrder: " + Un);
}, readBOM = function(Xn) {
  return hasUtf16BigEndianBOM(Xn) ? ByteOrder.BigEndian : hasUtf16LittleEndianBOM(Xn) ? ByteOrder.LittleEndian : ByteOrder.BigEndian;
}, hasUtf16BigEndianBOM = function(Xn) {
  return Xn[0] === 254 && Xn[1] === 255;
}, hasUtf16LittleEndianBOM = function(Xn) {
  return Xn[0] === 255 && Xn[1] === 254;
}, hasUtf16BOM = function(Xn) {
  return hasUtf16BigEndianBOM(Xn) || hasUtf16LittleEndianBOM(Xn);
}, numberToString = function(Xn) {
  var zn = String(Xn);
  if (Math.abs(Xn) < 1) {
    var Un = parseInt(Xn.toString().split("e-")[1]);
    if (Un) {
      var Kn = Xn < 0;
      Kn && (Xn *= -1), Xn *= Math.pow(10, Un - 1), zn = "0." + new Array(Un).join("0") + Xn.toString().substring(2), Kn && (zn = "-" + zn);
    }
  } else {
    var Un = parseInt(Xn.toString().split("+")[1]);
    Un > 20 && (Un -= 20, Xn /= Math.pow(10, Un), zn = Xn.toString() + new Array(Un + 1).join("0"));
  }
  return zn;
}, sizeInBytes = function(Xn) {
  return Math.ceil(Xn.toString(2).length / 8);
}, bytesFor = function(Xn) {
  for (var zn = new Uint8Array(sizeInBytes(Xn)), Un = 1; Un <= zn.length; Un++)
    zn[Un - 1] = Xn >> (zn.length - Un) * 8;
  return zn;
}, error = function(Xn) {
  throw new Error(Xn);
}, common = {}, hasRequiredCommon;
function requireCommon() {
  return hasRequiredCommon || (hasRequiredCommon = 1, function(Xn) {
    var zn = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function Un(Jo, pa) {
      return Object.prototype.hasOwnProperty.call(Jo, pa);
    }
    Xn.assign = function(Jo) {
      for (var pa = Array.prototype.slice.call(arguments, 1); pa.length; ) {
        var ma = pa.shift();
        if (ma) {
          if (typeof ma != "object")
            throw new TypeError(ma + "must be non-object");
          for (var va in ma)
            Un(ma, va) && (Jo[va] = ma[va]);
        }
      }
      return Jo;
    }, Xn.shrinkBuf = function(Jo, pa) {
      return Jo.length === pa ? Jo : Jo.subarray ? Jo.subarray(0, pa) : (Jo.length = pa, Jo);
    };
    var Kn = {
      arraySet: function(Jo, pa, ma, va, ba) {
        if (pa.subarray && Jo.subarray) {
          Jo.set(pa.subarray(ma, ma + va), ba);
          return;
        }
        for (var _a = 0; _a < va; _a++)
          Jo[ba + _a] = pa[ma + _a];
      },
      // Join array of chunks to single array.
      flattenChunks: function(Jo) {
        var pa, ma, va, ba, _a, ya;
        for (va = 0, pa = 0, ma = Jo.length; pa < ma; pa++)
          va += Jo[pa].length;
        for (ya = new Uint8Array(va), ba = 0, pa = 0, ma = Jo.length; pa < ma; pa++)
          _a = Jo[pa], ya.set(_a, ba), ba += _a.length;
        return ya;
      }
    }, qn = {
      arraySet: function(Jo, pa, ma, va, ba) {
        for (var _a = 0; _a < va; _a++)
          Jo[ba + _a] = pa[ma + _a];
      },
      // Join array of chunks to single array.
      flattenChunks: function(Jo) {
        return [].concat.apply([], Jo);
      }
    };
    Xn.setTyped = function(Jo) {
      Jo ? (Xn.Buf8 = Uint8Array, Xn.Buf16 = Uint16Array, Xn.Buf32 = Int32Array, Xn.assign(Xn, Kn)) : (Xn.Buf8 = Array, Xn.Buf16 = Array, Xn.Buf32 = Array, Xn.assign(Xn, qn));
    }, Xn.setTyped(zn);
  }(common)), common;
}
var deflate$1 = {}, deflate = {}, trees = {}, hasRequiredTrees;
function requireTrees() {
  if (hasRequiredTrees) return trees;
  hasRequiredTrees = 1;
  var Xn = requireCommon(), zn = 4, Un = 0, Kn = 1, qn = 2;
  function Jo(Hl) {
    for (var fc = Hl.length; --fc >= 0; )
      Hl[fc] = 0;
  }
  var pa = 0, ma = 1, va = 2, ba = 3, _a = 258, ya = 29, xa = 256, wa = xa + 1 + ya, Ta = 30, Sa = 19, Ma = 2 * wa + 1, ka = 15, Za = 16, Na = 7, Ka = 256, Ja = 16, el = 17, qa = 18, tl = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), Qa = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), nl = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), rl = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], il = 512, cl = new Array((wa + 2) * 2);
  Jo(cl);
  var ll = new Array(Ta * 2);
  Jo(ll);
  var al = new Array(il);
  Jo(al);
  var sl = new Array(_a - ba + 1);
  Jo(sl);
  var dl = new Array(ya);
  Jo(dl);
  var El = new Array(Ta);
  Jo(El);
  function fl(Hl, fc, lc, Gl, ql) {
    this.static_tree = Hl, this.extra_bits = fc, this.extra_base = lc, this.elems = Gl, this.max_length = ql, this.has_stree = Hl && Hl.length;
  }
  var Ml, Sl, ml;
  function Dl(Hl, fc) {
    this.dyn_tree = Hl, this.max_code = 0, this.stat_desc = fc;
  }
  function _l(Hl) {
    return Hl < 256 ? al[Hl] : al[256 + (Hl >>> 7)];
  }
  function gl(Hl, fc) {
    Hl.pending_buf[Hl.pending++] = fc & 255, Hl.pending_buf[Hl.pending++] = fc >>> 8 & 255;
  }
  function Fl(Hl, fc, lc) {
    Hl.bi_valid > Za - lc ? (Hl.bi_buf |= fc << Hl.bi_valid & 65535, gl(Hl, Hl.bi_buf), Hl.bi_buf = fc >> Za - Hl.bi_valid, Hl.bi_valid += lc - Za) : (Hl.bi_buf |= fc << Hl.bi_valid & 65535, Hl.bi_valid += lc);
  }
  function Nl(Hl, fc, lc) {
    Fl(
      Hl,
      lc[fc * 2],
      lc[fc * 2 + 1]
      /*.Len*/
    );
  }
  function zl(Hl, fc) {
    var lc = 0;
    do
      lc |= Hl & 1, Hl >>>= 1, lc <<= 1;
    while (--fc > 0);
    return lc >>> 1;
  }
  function Zl(Hl) {
    Hl.bi_valid === 16 ? (gl(Hl, Hl.bi_buf), Hl.bi_buf = 0, Hl.bi_valid = 0) : Hl.bi_valid >= 8 && (Hl.pending_buf[Hl.pending++] = Hl.bi_buf & 255, Hl.bi_buf >>= 8, Hl.bi_valid -= 8);
  }
  function kl(Hl, fc) {
    var lc = fc.dyn_tree, Gl = fc.max_code, ql = fc.stat_desc.static_tree, Vl = fc.stat_desc.has_stree, Pl = fc.stat_desc.extra_bits, Ol = fc.stat_desc.extra_base, cc = fc.stat_desc.max_length, bl, pl, Jl, Al, Bl, Kl, oc = 0;
    for (Al = 0; Al <= ka; Al++)
      Hl.bl_count[Al] = 0;
    for (lc[Hl.heap[Hl.heap_max] * 2 + 1] = 0, bl = Hl.heap_max + 1; bl < Ma; bl++)
      pl = Hl.heap[bl], Al = lc[lc[pl * 2 + 1] * 2 + 1] + 1, Al > cc && (Al = cc, oc++), lc[pl * 2 + 1] = Al, !(pl > Gl) && (Hl.bl_count[Al]++, Bl = 0, pl >= Ol && (Bl = Pl[pl - Ol]), Kl = lc[pl * 2], Hl.opt_len += Kl * (Al + Bl), Vl && (Hl.static_len += Kl * (ql[pl * 2 + 1] + Bl)));
    if (oc !== 0) {
      do {
        for (Al = cc - 1; Hl.bl_count[Al] === 0; )
          Al--;
        Hl.bl_count[Al]--, Hl.bl_count[Al + 1] += 2, Hl.bl_count[cc]--, oc -= 2;
      } while (oc > 0);
      for (Al = cc; Al !== 0; Al--)
        for (pl = Hl.bl_count[Al]; pl !== 0; )
          Jl = Hl.heap[--bl], !(Jl > Gl) && (lc[Jl * 2 + 1] !== Al && (Hl.opt_len += (Al - lc[Jl * 2 + 1]) * lc[Jl * 2], lc[Jl * 2 + 1] = Al), pl--);
    }
  }
  function ul(Hl, fc, lc) {
    var Gl = new Array(ka + 1), ql = 0, Vl, Pl;
    for (Vl = 1; Vl <= ka; Vl++)
      Gl[Vl] = ql = ql + lc[Vl - 1] << 1;
    for (Pl = 0; Pl <= fc; Pl++) {
      var Ol = Hl[Pl * 2 + 1];
      Ol !== 0 && (Hl[Pl * 2] = zl(Gl[Ol]++, Ol));
    }
  }
  function vl() {
    var Hl, fc, lc, Gl, ql, Vl = new Array(ka + 1);
    for (lc = 0, Gl = 0; Gl < ya - 1; Gl++)
      for (dl[Gl] = lc, Hl = 0; Hl < 1 << tl[Gl]; Hl++)
        sl[lc++] = Gl;
    for (sl[lc - 1] = Gl, ql = 0, Gl = 0; Gl < 16; Gl++)
      for (El[Gl] = ql, Hl = 0; Hl < 1 << Qa[Gl]; Hl++)
        al[ql++] = Gl;
    for (ql >>= 7; Gl < Ta; Gl++)
      for (El[Gl] = ql << 7, Hl = 0; Hl < 1 << Qa[Gl] - 7; Hl++)
        al[256 + ql++] = Gl;
    for (fc = 0; fc <= ka; fc++)
      Vl[fc] = 0;
    for (Hl = 0; Hl <= 143; )
      cl[Hl * 2 + 1] = 8, Hl++, Vl[8]++;
    for (; Hl <= 255; )
      cl[Hl * 2 + 1] = 9, Hl++, Vl[9]++;
    for (; Hl <= 279; )
      cl[Hl * 2 + 1] = 7, Hl++, Vl[7]++;
    for (; Hl <= 287; )
      cl[Hl * 2 + 1] = 8, Hl++, Vl[8]++;
    for (ul(cl, wa + 1, Vl), Hl = 0; Hl < Ta; Hl++)
      ll[Hl * 2 + 1] = 5, ll[Hl * 2] = zl(Hl, 5);
    Ml = new fl(cl, tl, xa + 1, wa, ka), Sl = new fl(ll, Qa, 0, Ta, ka), ml = new fl(new Array(0), nl, 0, Sa, Na);
  }
  function Tl(Hl) {
    var fc;
    for (fc = 0; fc < wa; fc++)
      Hl.dyn_ltree[fc * 2] = 0;
    for (fc = 0; fc < Ta; fc++)
      Hl.dyn_dtree[fc * 2] = 0;
    for (fc = 0; fc < Sa; fc++)
      Hl.bl_tree[fc * 2] = 0;
    Hl.dyn_ltree[Ka * 2] = 1, Hl.opt_len = Hl.static_len = 0, Hl.last_lit = Hl.matches = 0;
  }
  function wl(Hl) {
    Hl.bi_valid > 8 ? gl(Hl, Hl.bi_buf) : Hl.bi_valid > 0 && (Hl.pending_buf[Hl.pending++] = Hl.bi_buf), Hl.bi_buf = 0, Hl.bi_valid = 0;
  }
  function yl(Hl, fc, lc, Gl) {
    wl(Hl), gl(Hl, lc), gl(Hl, ~lc), Xn.arraySet(Hl.pending_buf, Hl.window, fc, lc, Hl.pending), Hl.pending += lc;
  }
  function Rl(Hl, fc, lc, Gl) {
    var ql = fc * 2, Vl = lc * 2;
    return Hl[ql] < Hl[Vl] || Hl[ql] === Hl[Vl] && Gl[fc] <= Gl[lc];
  }
  function Ul(Hl, fc, lc) {
    for (var Gl = Hl.heap[lc], ql = lc << 1; ql <= Hl.heap_len && (ql < Hl.heap_len && Rl(fc, Hl.heap[ql + 1], Hl.heap[ql], Hl.depth) && ql++, !Rl(fc, Gl, Hl.heap[ql], Hl.depth)); )
      Hl.heap[lc] = Hl.heap[ql], lc = ql, ql <<= 1;
    Hl.heap[lc] = Gl;
  }
  function hl(Hl, fc, lc) {
    var Gl, ql, Vl = 0, Pl, Ol;
    if (Hl.last_lit !== 0)
      do
        Gl = Hl.pending_buf[Hl.d_buf + Vl * 2] << 8 | Hl.pending_buf[Hl.d_buf + Vl * 2 + 1], ql = Hl.pending_buf[Hl.l_buf + Vl], Vl++, Gl === 0 ? Nl(Hl, ql, fc) : (Pl = sl[ql], Nl(Hl, Pl + xa + 1, fc), Ol = tl[Pl], Ol !== 0 && (ql -= dl[Pl], Fl(Hl, ql, Ol)), Gl--, Pl = _l(Gl), Nl(Hl, Pl, lc), Ol = Qa[Pl], Ol !== 0 && (Gl -= El[Pl], Fl(Hl, Gl, Ol)));
      while (Vl < Hl.last_lit);
    Nl(Hl, Ka, fc);
  }
  function Cl(Hl, fc) {
    var lc = fc.dyn_tree, Gl = fc.stat_desc.static_tree, ql = fc.stat_desc.has_stree, Vl = fc.stat_desc.elems, Pl, Ol, cc = -1, bl;
    for (Hl.heap_len = 0, Hl.heap_max = Ma, Pl = 0; Pl < Vl; Pl++)
      lc[Pl * 2] !== 0 ? (Hl.heap[++Hl.heap_len] = cc = Pl, Hl.depth[Pl] = 0) : lc[Pl * 2 + 1] = 0;
    for (; Hl.heap_len < 2; )
      bl = Hl.heap[++Hl.heap_len] = cc < 2 ? ++cc : 0, lc[bl * 2] = 1, Hl.depth[bl] = 0, Hl.opt_len--, ql && (Hl.static_len -= Gl[bl * 2 + 1]);
    for (fc.max_code = cc, Pl = Hl.heap_len >> 1; Pl >= 1; Pl--)
      Ul(Hl, lc, Pl);
    bl = Vl;
    do
      Pl = Hl.heap[
        1
        /*SMALLEST*/
      ], Hl.heap[
        1
        /*SMALLEST*/
      ] = Hl.heap[Hl.heap_len--], Ul(
        Hl,
        lc,
        1
        /*SMALLEST*/
      ), Ol = Hl.heap[
        1
        /*SMALLEST*/
      ], Hl.heap[--Hl.heap_max] = Pl, Hl.heap[--Hl.heap_max] = Ol, lc[bl * 2] = lc[Pl * 2] + lc[Ol * 2], Hl.depth[bl] = (Hl.depth[Pl] >= Hl.depth[Ol] ? Hl.depth[Pl] : Hl.depth[Ol]) + 1, lc[Pl * 2 + 1] = lc[Ol * 2 + 1] = bl, Hl.heap[
        1
        /*SMALLEST*/
      ] = bl++, Ul(
        Hl,
        lc,
        1
        /*SMALLEST*/
      );
    while (Hl.heap_len >= 2);
    Hl.heap[--Hl.heap_max] = Hl.heap[
      1
      /*SMALLEST*/
    ], kl(Hl, fc), ul(lc, cc, Hl.bl_count);
  }
  function Il(Hl, fc, lc) {
    var Gl, ql = -1, Vl, Pl = fc[0 * 2 + 1], Ol = 0, cc = 7, bl = 4;
    for (Pl === 0 && (cc = 138, bl = 3), fc[(lc + 1) * 2 + 1] = 65535, Gl = 0; Gl <= lc; Gl++)
      Vl = Pl, Pl = fc[(Gl + 1) * 2 + 1], !(++Ol < cc && Vl === Pl) && (Ol < bl ? Hl.bl_tree[Vl * 2] += Ol : Vl !== 0 ? (Vl !== ql && Hl.bl_tree[Vl * 2]++, Hl.bl_tree[Ja * 2]++) : Ol <= 10 ? Hl.bl_tree[el * 2]++ : Hl.bl_tree[qa * 2]++, Ol = 0, ql = Vl, Pl === 0 ? (cc = 138, bl = 3) : Vl === Pl ? (cc = 6, bl = 3) : (cc = 7, bl = 4));
  }
  function Ll(Hl, fc, lc) {
    var Gl, ql = -1, Vl, Pl = fc[0 * 2 + 1], Ol = 0, cc = 7, bl = 4;
    for (Pl === 0 && (cc = 138, bl = 3), Gl = 0; Gl <= lc; Gl++)
      if (Vl = Pl, Pl = fc[(Gl + 1) * 2 + 1], !(++Ol < cc && Vl === Pl)) {
        if (Ol < bl)
          do
            Nl(Hl, Vl, Hl.bl_tree);
          while (--Ol !== 0);
        else Vl !== 0 ? (Vl !== ql && (Nl(Hl, Vl, Hl.bl_tree), Ol--), Nl(Hl, Ja, Hl.bl_tree), Fl(Hl, Ol - 3, 2)) : Ol <= 10 ? (Nl(Hl, el, Hl.bl_tree), Fl(Hl, Ol - 3, 3)) : (Nl(Hl, qa, Hl.bl_tree), Fl(Hl, Ol - 11, 7));
        Ol = 0, ql = Vl, Pl === 0 ? (cc = 138, bl = 3) : Vl === Pl ? (cc = 6, bl = 3) : (cc = 7, bl = 4);
      }
  }
  function tc(Hl) {
    var fc;
    for (Il(Hl, Hl.dyn_ltree, Hl.l_desc.max_code), Il(Hl, Hl.dyn_dtree, Hl.d_desc.max_code), Cl(Hl, Hl.bl_desc), fc = Sa - 1; fc >= 3 && Hl.bl_tree[rl[fc] * 2 + 1] === 0; fc--)
      ;
    return Hl.opt_len += 3 * (fc + 1) + 5 + 5 + 4, fc;
  }
  function nc(Hl, fc, lc, Gl) {
    var ql;
    for (Fl(Hl, fc - 257, 5), Fl(Hl, lc - 1, 5), Fl(Hl, Gl - 4, 4), ql = 0; ql < Gl; ql++)
      Fl(Hl, Hl.bl_tree[rl[ql] * 2 + 1], 3);
    Ll(Hl, Hl.dyn_ltree, fc - 1), Ll(Hl, Hl.dyn_dtree, lc - 1);
  }
  function uc(Hl) {
    var fc = 4093624447, lc;
    for (lc = 0; lc <= 31; lc++, fc >>>= 1)
      if (fc & 1 && Hl.dyn_ltree[lc * 2] !== 0)
        return Un;
    if (Hl.dyn_ltree[9 * 2] !== 0 || Hl.dyn_ltree[10 * 2] !== 0 || Hl.dyn_ltree[13 * 2] !== 0)
      return Kn;
    for (lc = 32; lc < xa; lc++)
      if (Hl.dyn_ltree[lc * 2] !== 0)
        return Kn;
    return Un;
  }
  var _c = !1;
  function mc(Hl) {
    _c || (vl(), _c = !0), Hl.l_desc = new Dl(Hl.dyn_ltree, Ml), Hl.d_desc = new Dl(Hl.dyn_dtree, Sl), Hl.bl_desc = new Dl(Hl.bl_tree, ml), Hl.bi_buf = 0, Hl.bi_valid = 0, Tl(Hl);
  }
  function Sc(Hl, fc, lc, Gl) {
    Fl(Hl, (pa << 1) + (Gl ? 1 : 0), 3), yl(Hl, fc, lc);
  }
  function hc(Hl) {
    Fl(Hl, ma << 1, 3), Nl(Hl, Ka, cl), Zl(Hl);
  }
  function Lc(Hl, fc, lc, Gl) {
    var ql, Vl, Pl = 0;
    Hl.level > 0 ? (Hl.strm.data_type === qn && (Hl.strm.data_type = uc(Hl)), Cl(Hl, Hl.l_desc), Cl(Hl, Hl.d_desc), Pl = tc(Hl), ql = Hl.opt_len + 3 + 7 >>> 3, Vl = Hl.static_len + 3 + 7 >>> 3, Vl <= ql && (ql = Vl)) : ql = Vl = lc + 5, lc + 4 <= ql && fc !== -1 ? Sc(Hl, fc, lc, Gl) : Hl.strategy === zn || Vl === ql ? (Fl(Hl, (ma << 1) + (Gl ? 1 : 0), 3), hl(Hl, cl, ll)) : (Fl(Hl, (va << 1) + (Gl ? 1 : 0), 3), nc(Hl, Hl.l_desc.max_code + 1, Hl.d_desc.max_code + 1, Pl + 1), hl(Hl, Hl.dyn_ltree, Hl.dyn_dtree)), Tl(Hl), Gl && wl(Hl);
  }
  function Ec(Hl, fc, lc) {
    return Hl.pending_buf[Hl.d_buf + Hl.last_lit * 2] = fc >>> 8 & 255, Hl.pending_buf[Hl.d_buf + Hl.last_lit * 2 + 1] = fc & 255, Hl.pending_buf[Hl.l_buf + Hl.last_lit] = lc & 255, Hl.last_lit++, fc === 0 ? Hl.dyn_ltree[lc * 2]++ : (Hl.matches++, fc--, Hl.dyn_ltree[(sl[lc] + xa + 1) * 2]++, Hl.dyn_dtree[_l(fc) * 2]++), Hl.last_lit === Hl.lit_bufsize - 1;
  }
  return trees._tr_init = mc, trees._tr_stored_block = Sc, trees._tr_flush_block = Lc, trees._tr_tally = Ec, trees._tr_align = hc, trees;
}
var adler32_1, hasRequiredAdler32;
function requireAdler32() {
  if (hasRequiredAdler32) return adler32_1;
  hasRequiredAdler32 = 1;
  function Xn(zn, Un, Kn, qn) {
    for (var Jo = zn & 65535 | 0, pa = zn >>> 16 & 65535 | 0, ma = 0; Kn !== 0; ) {
      ma = Kn > 2e3 ? 2e3 : Kn, Kn -= ma;
      do
        Jo = Jo + Un[qn++] | 0, pa = pa + Jo | 0;
      while (--ma);
      Jo %= 65521, pa %= 65521;
    }
    return Jo | pa << 16 | 0;
  }
  return adler32_1 = Xn, adler32_1;
}
var crc32_1, hasRequiredCrc32;
function requireCrc32() {
  if (hasRequiredCrc32) return crc32_1;
  hasRequiredCrc32 = 1;
  function Xn() {
    for (var Kn, qn = [], Jo = 0; Jo < 256; Jo++) {
      Kn = Jo;
      for (var pa = 0; pa < 8; pa++)
        Kn = Kn & 1 ? 3988292384 ^ Kn >>> 1 : Kn >>> 1;
      qn[Jo] = Kn;
    }
    return qn;
  }
  var zn = Xn();
  function Un(Kn, qn, Jo, pa) {
    var ma = zn, va = pa + Jo;
    Kn ^= -1;
    for (var ba = pa; ba < va; ba++)
      Kn = Kn >>> 8 ^ ma[(Kn ^ qn[ba]) & 255];
    return Kn ^ -1;
  }
  return crc32_1 = Un, crc32_1;
}
var messages, hasRequiredMessages;
function requireMessages() {
  return hasRequiredMessages || (hasRequiredMessages = 1, messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), messages;
}
var hasRequiredDeflate$1;
function requireDeflate$1() {
  if (hasRequiredDeflate$1) return deflate;
  hasRequiredDeflate$1 = 1;
  var Xn = requireCommon(), zn = requireTrees(), Un = requireAdler32(), Kn = requireCrc32(), qn = requireMessages(), Jo = 0, pa = 1, ma = 3, va = 4, ba = 5, _a = 0, ya = 1, xa = -2, wa = -3, Ta = -5, Sa = -1, Ma = 1, ka = 2, Za = 3, Na = 4, Ka = 0, Ja = 2, el = 8, qa = 9, tl = 15, Qa = 8, nl = 29, rl = 256, il = rl + 1 + nl, cl = 30, ll = 19, al = 2 * il + 1, sl = 15, dl = 3, El = 258, fl = El + dl + 1, Ml = 32, Sl = 42, ml = 69, Dl = 73, _l = 91, gl = 103, Fl = 113, Nl = 666, zl = 1, Zl = 2, kl = 3, ul = 4, vl = 3;
  function Tl(bl, pl) {
    return bl.msg = qn[pl], pl;
  }
  function wl(bl) {
    return (bl << 1) - (bl > 4 ? 9 : 0);
  }
  function yl(bl) {
    for (var pl = bl.length; --pl >= 0; )
      bl[pl] = 0;
  }
  function Rl(bl) {
    var pl = bl.state, Jl = pl.pending;
    Jl > bl.avail_out && (Jl = bl.avail_out), Jl !== 0 && (Xn.arraySet(bl.output, pl.pending_buf, pl.pending_out, Jl, bl.next_out), bl.next_out += Jl, pl.pending_out += Jl, bl.total_out += Jl, bl.avail_out -= Jl, pl.pending -= Jl, pl.pending === 0 && (pl.pending_out = 0));
  }
  function Ul(bl, pl) {
    zn._tr_flush_block(bl, bl.block_start >= 0 ? bl.block_start : -1, bl.strstart - bl.block_start, pl), bl.block_start = bl.strstart, Rl(bl.strm);
  }
  function hl(bl, pl) {
    bl.pending_buf[bl.pending++] = pl;
  }
  function Cl(bl, pl) {
    bl.pending_buf[bl.pending++] = pl >>> 8 & 255, bl.pending_buf[bl.pending++] = pl & 255;
  }
  function Il(bl, pl, Jl, Al) {
    var Bl = bl.avail_in;
    return Bl > Al && (Bl = Al), Bl === 0 ? 0 : (bl.avail_in -= Bl, Xn.arraySet(pl, bl.input, bl.next_in, Bl, Jl), bl.state.wrap === 1 ? bl.adler = Un(bl.adler, pl, Bl, Jl) : bl.state.wrap === 2 && (bl.adler = Kn(bl.adler, pl, Bl, Jl)), bl.next_in += Bl, bl.total_in += Bl, Bl);
  }
  function Ll(bl, pl) {
    var Jl = bl.max_chain_length, Al = bl.strstart, Bl, Kl, oc = bl.prev_length, xc = bl.nice_match, vc = bl.strstart > bl.w_size - fl ? bl.strstart - (bl.w_size - fl) : 0, Pc = bl.window, Hc = bl.w_mask, $c = bl.prev, Nc = bl.strstart + El, Zc = Pc[Al + oc - 1], Yc = Pc[Al + oc];
    bl.prev_length >= bl.good_match && (Jl >>= 2), xc > bl.lookahead && (xc = bl.lookahead);
    do
      if (Bl = pl, !(Pc[Bl + oc] !== Yc || Pc[Bl + oc - 1] !== Zc || Pc[Bl] !== Pc[Al] || Pc[++Bl] !== Pc[Al + 1])) {
        Al += 2, Bl++;
        do
          ;
        while (Pc[++Al] === Pc[++Bl] && Pc[++Al] === Pc[++Bl] && Pc[++Al] === Pc[++Bl] && Pc[++Al] === Pc[++Bl] && Pc[++Al] === Pc[++Bl] && Pc[++Al] === Pc[++Bl] && Pc[++Al] === Pc[++Bl] && Pc[++Al] === Pc[++Bl] && Al < Nc);
        if (Kl = El - (Nc - Al), Al = Nc - El, Kl > oc) {
          if (bl.match_start = pl, oc = Kl, Kl >= xc)
            break;
          Zc = Pc[Al + oc - 1], Yc = Pc[Al + oc];
        }
      }
    while ((pl = $c[pl & Hc]) > vc && --Jl !== 0);
    return oc <= bl.lookahead ? oc : bl.lookahead;
  }
  function tc(bl) {
    var pl = bl.w_size, Jl, Al, Bl, Kl, oc;
    do {
      if (Kl = bl.window_size - bl.lookahead - bl.strstart, bl.strstart >= pl + (pl - fl)) {
        Xn.arraySet(bl.window, bl.window, pl, pl, 0), bl.match_start -= pl, bl.strstart -= pl, bl.block_start -= pl, Al = bl.hash_size, Jl = Al;
        do
          Bl = bl.head[--Jl], bl.head[Jl] = Bl >= pl ? Bl - pl : 0;
        while (--Al);
        Al = pl, Jl = Al;
        do
          Bl = bl.prev[--Jl], bl.prev[Jl] = Bl >= pl ? Bl - pl : 0;
        while (--Al);
        Kl += pl;
      }
      if (bl.strm.avail_in === 0)
        break;
      if (Al = Il(bl.strm, bl.window, bl.strstart + bl.lookahead, Kl), bl.lookahead += Al, bl.lookahead + bl.insert >= dl)
        for (oc = bl.strstart - bl.insert, bl.ins_h = bl.window[oc], bl.ins_h = (bl.ins_h << bl.hash_shift ^ bl.window[oc + 1]) & bl.hash_mask; bl.insert && (bl.ins_h = (bl.ins_h << bl.hash_shift ^ bl.window[oc + dl - 1]) & bl.hash_mask, bl.prev[oc & bl.w_mask] = bl.head[bl.ins_h], bl.head[bl.ins_h] = oc, oc++, bl.insert--, !(bl.lookahead + bl.insert < dl)); )
          ;
    } while (bl.lookahead < fl && bl.strm.avail_in !== 0);
  }
  function nc(bl, pl) {
    var Jl = 65535;
    for (Jl > bl.pending_buf_size - 5 && (Jl = bl.pending_buf_size - 5); ; ) {
      if (bl.lookahead <= 1) {
        if (tc(bl), bl.lookahead === 0 && pl === Jo)
          return zl;
        if (bl.lookahead === 0)
          break;
      }
      bl.strstart += bl.lookahead, bl.lookahead = 0;
      var Al = bl.block_start + Jl;
      if ((bl.strstart === 0 || bl.strstart >= Al) && (bl.lookahead = bl.strstart - Al, bl.strstart = Al, Ul(bl, !1), bl.strm.avail_out === 0) || bl.strstart - bl.block_start >= bl.w_size - fl && (Ul(bl, !1), bl.strm.avail_out === 0))
        return zl;
    }
    return bl.insert = 0, pl === va ? (Ul(bl, !0), bl.strm.avail_out === 0 ? kl : ul) : (bl.strstart > bl.block_start && (Ul(bl, !1), bl.strm.avail_out === 0), zl);
  }
  function uc(bl, pl) {
    for (var Jl, Al; ; ) {
      if (bl.lookahead < fl) {
        if (tc(bl), bl.lookahead < fl && pl === Jo)
          return zl;
        if (bl.lookahead === 0)
          break;
      }
      if (Jl = 0, bl.lookahead >= dl && (bl.ins_h = (bl.ins_h << bl.hash_shift ^ bl.window[bl.strstart + dl - 1]) & bl.hash_mask, Jl = bl.prev[bl.strstart & bl.w_mask] = bl.head[bl.ins_h], bl.head[bl.ins_h] = bl.strstart), Jl !== 0 && bl.strstart - Jl <= bl.w_size - fl && (bl.match_length = Ll(bl, Jl)), bl.match_length >= dl)
        if (Al = zn._tr_tally(bl, bl.strstart - bl.match_start, bl.match_length - dl), bl.lookahead -= bl.match_length, bl.match_length <= bl.max_lazy_match && bl.lookahead >= dl) {
          bl.match_length--;
          do
            bl.strstart++, bl.ins_h = (bl.ins_h << bl.hash_shift ^ bl.window[bl.strstart + dl - 1]) & bl.hash_mask, Jl = bl.prev[bl.strstart & bl.w_mask] = bl.head[bl.ins_h], bl.head[bl.ins_h] = bl.strstart;
          while (--bl.match_length !== 0);
          bl.strstart++;
        } else
          bl.strstart += bl.match_length, bl.match_length = 0, bl.ins_h = bl.window[bl.strstart], bl.ins_h = (bl.ins_h << bl.hash_shift ^ bl.window[bl.strstart + 1]) & bl.hash_mask;
      else
        Al = zn._tr_tally(bl, 0, bl.window[bl.strstart]), bl.lookahead--, bl.strstart++;
      if (Al && (Ul(bl, !1), bl.strm.avail_out === 0))
        return zl;
    }
    return bl.insert = bl.strstart < dl - 1 ? bl.strstart : dl - 1, pl === va ? (Ul(bl, !0), bl.strm.avail_out === 0 ? kl : ul) : bl.last_lit && (Ul(bl, !1), bl.strm.avail_out === 0) ? zl : Zl;
  }
  function _c(bl, pl) {
    for (var Jl, Al, Bl; ; ) {
      if (bl.lookahead < fl) {
        if (tc(bl), bl.lookahead < fl && pl === Jo)
          return zl;
        if (bl.lookahead === 0)
          break;
      }
      if (Jl = 0, bl.lookahead >= dl && (bl.ins_h = (bl.ins_h << bl.hash_shift ^ bl.window[bl.strstart + dl - 1]) & bl.hash_mask, Jl = bl.prev[bl.strstart & bl.w_mask] = bl.head[bl.ins_h], bl.head[bl.ins_h] = bl.strstart), bl.prev_length = bl.match_length, bl.prev_match = bl.match_start, bl.match_length = dl - 1, Jl !== 0 && bl.prev_length < bl.max_lazy_match && bl.strstart - Jl <= bl.w_size - fl && (bl.match_length = Ll(bl, Jl), bl.match_length <= 5 && (bl.strategy === Ma || bl.match_length === dl && bl.strstart - bl.match_start > 4096) && (bl.match_length = dl - 1)), bl.prev_length >= dl && bl.match_length <= bl.prev_length) {
        Bl = bl.strstart + bl.lookahead - dl, Al = zn._tr_tally(bl, bl.strstart - 1 - bl.prev_match, bl.prev_length - dl), bl.lookahead -= bl.prev_length - 1, bl.prev_length -= 2;
        do
          ++bl.strstart <= Bl && (bl.ins_h = (bl.ins_h << bl.hash_shift ^ bl.window[bl.strstart + dl - 1]) & bl.hash_mask, Jl = bl.prev[bl.strstart & bl.w_mask] = bl.head[bl.ins_h], bl.head[bl.ins_h] = bl.strstart);
        while (--bl.prev_length !== 0);
        if (bl.match_available = 0, bl.match_length = dl - 1, bl.strstart++, Al && (Ul(bl, !1), bl.strm.avail_out === 0))
          return zl;
      } else if (bl.match_available) {
        if (Al = zn._tr_tally(bl, 0, bl.window[bl.strstart - 1]), Al && Ul(bl, !1), bl.strstart++, bl.lookahead--, bl.strm.avail_out === 0)
          return zl;
      } else
        bl.match_available = 1, bl.strstart++, bl.lookahead--;
    }
    return bl.match_available && (Al = zn._tr_tally(bl, 0, bl.window[bl.strstart - 1]), bl.match_available = 0), bl.insert = bl.strstart < dl - 1 ? bl.strstart : dl - 1, pl === va ? (Ul(bl, !0), bl.strm.avail_out === 0 ? kl : ul) : bl.last_lit && (Ul(bl, !1), bl.strm.avail_out === 0) ? zl : Zl;
  }
  function mc(bl, pl) {
    for (var Jl, Al, Bl, Kl, oc = bl.window; ; ) {
      if (bl.lookahead <= El) {
        if (tc(bl), bl.lookahead <= El && pl === Jo)
          return zl;
        if (bl.lookahead === 0)
          break;
      }
      if (bl.match_length = 0, bl.lookahead >= dl && bl.strstart > 0 && (Bl = bl.strstart - 1, Al = oc[Bl], Al === oc[++Bl] && Al === oc[++Bl] && Al === oc[++Bl])) {
        Kl = bl.strstart + El;
        do
          ;
        while (Al === oc[++Bl] && Al === oc[++Bl] && Al === oc[++Bl] && Al === oc[++Bl] && Al === oc[++Bl] && Al === oc[++Bl] && Al === oc[++Bl] && Al === oc[++Bl] && Bl < Kl);
        bl.match_length = El - (Kl - Bl), bl.match_length > bl.lookahead && (bl.match_length = bl.lookahead);
      }
      if (bl.match_length >= dl ? (Jl = zn._tr_tally(bl, 1, bl.match_length - dl), bl.lookahead -= bl.match_length, bl.strstart += bl.match_length, bl.match_length = 0) : (Jl = zn._tr_tally(bl, 0, bl.window[bl.strstart]), bl.lookahead--, bl.strstart++), Jl && (Ul(bl, !1), bl.strm.avail_out === 0))
        return zl;
    }
    return bl.insert = 0, pl === va ? (Ul(bl, !0), bl.strm.avail_out === 0 ? kl : ul) : bl.last_lit && (Ul(bl, !1), bl.strm.avail_out === 0) ? zl : Zl;
  }
  function Sc(bl, pl) {
    for (var Jl; ; ) {
      if (bl.lookahead === 0 && (tc(bl), bl.lookahead === 0)) {
        if (pl === Jo)
          return zl;
        break;
      }
      if (bl.match_length = 0, Jl = zn._tr_tally(bl, 0, bl.window[bl.strstart]), bl.lookahead--, bl.strstart++, Jl && (Ul(bl, !1), bl.strm.avail_out === 0))
        return zl;
    }
    return bl.insert = 0, pl === va ? (Ul(bl, !0), bl.strm.avail_out === 0 ? kl : ul) : bl.last_lit && (Ul(bl, !1), bl.strm.avail_out === 0) ? zl : Zl;
  }
  function hc(bl, pl, Jl, Al, Bl) {
    this.good_length = bl, this.max_lazy = pl, this.nice_length = Jl, this.max_chain = Al, this.func = Bl;
  }
  var Lc;
  Lc = [
    /*      good lazy nice chain */
    new hc(0, 0, 0, 0, nc),
    /* 0 store only */
    new hc(4, 4, 8, 4, uc),
    /* 1 max speed, no lazy matches */
    new hc(4, 5, 16, 8, uc),
    /* 2 */
    new hc(4, 6, 32, 32, uc),
    /* 3 */
    new hc(4, 4, 16, 16, _c),
    /* 4 lazy matches */
    new hc(8, 16, 32, 32, _c),
    /* 5 */
    new hc(8, 16, 128, 128, _c),
    /* 6 */
    new hc(8, 32, 128, 256, _c),
    /* 7 */
    new hc(32, 128, 258, 1024, _c),
    /* 8 */
    new hc(32, 258, 258, 4096, _c)
    /* 9 max compression */
  ];
  function Ec(bl) {
    bl.window_size = 2 * bl.w_size, yl(bl.head), bl.max_lazy_match = Lc[bl.level].max_lazy, bl.good_match = Lc[bl.level].good_length, bl.nice_match = Lc[bl.level].nice_length, bl.max_chain_length = Lc[bl.level].max_chain, bl.strstart = 0, bl.block_start = 0, bl.lookahead = 0, bl.insert = 0, bl.match_length = bl.prev_length = dl - 1, bl.match_available = 0, bl.ins_h = 0;
  }
  function Hl() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = el, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Xn.Buf16(al * 2), this.dyn_dtree = new Xn.Buf16((2 * cl + 1) * 2), this.bl_tree = new Xn.Buf16((2 * ll + 1) * 2), yl(this.dyn_ltree), yl(this.dyn_dtree), yl(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Xn.Buf16(sl + 1), this.heap = new Xn.Buf16(2 * il + 1), yl(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Xn.Buf16(2 * il + 1), yl(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function fc(bl) {
    var pl;
    return !bl || !bl.state ? Tl(bl, xa) : (bl.total_in = bl.total_out = 0, bl.data_type = Ja, pl = bl.state, pl.pending = 0, pl.pending_out = 0, pl.wrap < 0 && (pl.wrap = -pl.wrap), pl.status = pl.wrap ? Sl : Fl, bl.adler = pl.wrap === 2 ? 0 : 1, pl.last_flush = Jo, zn._tr_init(pl), _a);
  }
  function lc(bl) {
    var pl = fc(bl);
    return pl === _a && Ec(bl.state), pl;
  }
  function Gl(bl, pl) {
    return !bl || !bl.state || bl.state.wrap !== 2 ? xa : (bl.state.gzhead = pl, _a);
  }
  function ql(bl, pl, Jl, Al, Bl, Kl) {
    if (!bl)
      return xa;
    var oc = 1;
    if (pl === Sa && (pl = 6), Al < 0 ? (oc = 0, Al = -Al) : Al > 15 && (oc = 2, Al -= 16), Bl < 1 || Bl > qa || Jl !== el || Al < 8 || Al > 15 || pl < 0 || pl > 9 || Kl < 0 || Kl > Na)
      return Tl(bl, xa);
    Al === 8 && (Al = 9);
    var xc = new Hl();
    return bl.state = xc, xc.strm = bl, xc.wrap = oc, xc.gzhead = null, xc.w_bits = Al, xc.w_size = 1 << xc.w_bits, xc.w_mask = xc.w_size - 1, xc.hash_bits = Bl + 7, xc.hash_size = 1 << xc.hash_bits, xc.hash_mask = xc.hash_size - 1, xc.hash_shift = ~~((xc.hash_bits + dl - 1) / dl), xc.window = new Xn.Buf8(xc.w_size * 2), xc.head = new Xn.Buf16(xc.hash_size), xc.prev = new Xn.Buf16(xc.w_size), xc.lit_bufsize = 1 << Bl + 6, xc.pending_buf_size = xc.lit_bufsize * 4, xc.pending_buf = new Xn.Buf8(xc.pending_buf_size), xc.d_buf = 1 * xc.lit_bufsize, xc.l_buf = 3 * xc.lit_bufsize, xc.level = pl, xc.strategy = Kl, xc.method = Jl, lc(bl);
  }
  function Vl(bl, pl) {
    return ql(bl, pl, el, tl, Qa, Ka);
  }
  function Pl(bl, pl) {
    var Jl, Al, Bl, Kl;
    if (!bl || !bl.state || pl > ba || pl < 0)
      return bl ? Tl(bl, xa) : xa;
    if (Al = bl.state, !bl.output || !bl.input && bl.avail_in !== 0 || Al.status === Nl && pl !== va)
      return Tl(bl, bl.avail_out === 0 ? Ta : xa);
    if (Al.strm = bl, Jl = Al.last_flush, Al.last_flush = pl, Al.status === Sl)
      if (Al.wrap === 2)
        bl.adler = 0, hl(Al, 31), hl(Al, 139), hl(Al, 8), Al.gzhead ? (hl(
          Al,
          (Al.gzhead.text ? 1 : 0) + (Al.gzhead.hcrc ? 2 : 0) + (Al.gzhead.extra ? 4 : 0) + (Al.gzhead.name ? 8 : 0) + (Al.gzhead.comment ? 16 : 0)
        ), hl(Al, Al.gzhead.time & 255), hl(Al, Al.gzhead.time >> 8 & 255), hl(Al, Al.gzhead.time >> 16 & 255), hl(Al, Al.gzhead.time >> 24 & 255), hl(Al, Al.level === 9 ? 2 : Al.strategy >= ka || Al.level < 2 ? 4 : 0), hl(Al, Al.gzhead.os & 255), Al.gzhead.extra && Al.gzhead.extra.length && (hl(Al, Al.gzhead.extra.length & 255), hl(Al, Al.gzhead.extra.length >> 8 & 255)), Al.gzhead.hcrc && (bl.adler = Kn(bl.adler, Al.pending_buf, Al.pending, 0)), Al.gzindex = 0, Al.status = ml) : (hl(Al, 0), hl(Al, 0), hl(Al, 0), hl(Al, 0), hl(Al, 0), hl(Al, Al.level === 9 ? 2 : Al.strategy >= ka || Al.level < 2 ? 4 : 0), hl(Al, vl), Al.status = Fl);
      else {
        var oc = el + (Al.w_bits - 8 << 4) << 8, xc = -1;
        Al.strategy >= ka || Al.level < 2 ? xc = 0 : Al.level < 6 ? xc = 1 : Al.level === 6 ? xc = 2 : xc = 3, oc |= xc << 6, Al.strstart !== 0 && (oc |= Ml), oc += 31 - oc % 31, Al.status = Fl, Cl(Al, oc), Al.strstart !== 0 && (Cl(Al, bl.adler >>> 16), Cl(Al, bl.adler & 65535)), bl.adler = 1;
      }
    if (Al.status === ml)
      if (Al.gzhead.extra) {
        for (Bl = Al.pending; Al.gzindex < (Al.gzhead.extra.length & 65535) && !(Al.pending === Al.pending_buf_size && (Al.gzhead.hcrc && Al.pending > Bl && (bl.adler = Kn(bl.adler, Al.pending_buf, Al.pending - Bl, Bl)), Rl(bl), Bl = Al.pending, Al.pending === Al.pending_buf_size)); )
          hl(Al, Al.gzhead.extra[Al.gzindex] & 255), Al.gzindex++;
        Al.gzhead.hcrc && Al.pending > Bl && (bl.adler = Kn(bl.adler, Al.pending_buf, Al.pending - Bl, Bl)), Al.gzindex === Al.gzhead.extra.length && (Al.gzindex = 0, Al.status = Dl);
      } else
        Al.status = Dl;
    if (Al.status === Dl)
      if (Al.gzhead.name) {
        Bl = Al.pending;
        do {
          if (Al.pending === Al.pending_buf_size && (Al.gzhead.hcrc && Al.pending > Bl && (bl.adler = Kn(bl.adler, Al.pending_buf, Al.pending - Bl, Bl)), Rl(bl), Bl = Al.pending, Al.pending === Al.pending_buf_size)) {
            Kl = 1;
            break;
          }
          Al.gzindex < Al.gzhead.name.length ? Kl = Al.gzhead.name.charCodeAt(Al.gzindex++) & 255 : Kl = 0, hl(Al, Kl);
        } while (Kl !== 0);
        Al.gzhead.hcrc && Al.pending > Bl && (bl.adler = Kn(bl.adler, Al.pending_buf, Al.pending - Bl, Bl)), Kl === 0 && (Al.gzindex = 0, Al.status = _l);
      } else
        Al.status = _l;
    if (Al.status === _l)
      if (Al.gzhead.comment) {
        Bl = Al.pending;
        do {
          if (Al.pending === Al.pending_buf_size && (Al.gzhead.hcrc && Al.pending > Bl && (bl.adler = Kn(bl.adler, Al.pending_buf, Al.pending - Bl, Bl)), Rl(bl), Bl = Al.pending, Al.pending === Al.pending_buf_size)) {
            Kl = 1;
            break;
          }
          Al.gzindex < Al.gzhead.comment.length ? Kl = Al.gzhead.comment.charCodeAt(Al.gzindex++) & 255 : Kl = 0, hl(Al, Kl);
        } while (Kl !== 0);
        Al.gzhead.hcrc && Al.pending > Bl && (bl.adler = Kn(bl.adler, Al.pending_buf, Al.pending - Bl, Bl)), Kl === 0 && (Al.status = gl);
      } else
        Al.status = gl;
    if (Al.status === gl && (Al.gzhead.hcrc ? (Al.pending + 2 > Al.pending_buf_size && Rl(bl), Al.pending + 2 <= Al.pending_buf_size && (hl(Al, bl.adler & 255), hl(Al, bl.adler >> 8 & 255), bl.adler = 0, Al.status = Fl)) : Al.status = Fl), Al.pending !== 0) {
      if (Rl(bl), bl.avail_out === 0)
        return Al.last_flush = -1, _a;
    } else if (bl.avail_in === 0 && wl(pl) <= wl(Jl) && pl !== va)
      return Tl(bl, Ta);
    if (Al.status === Nl && bl.avail_in !== 0)
      return Tl(bl, Ta);
    if (bl.avail_in !== 0 || Al.lookahead !== 0 || pl !== Jo && Al.status !== Nl) {
      var vc = Al.strategy === ka ? Sc(Al, pl) : Al.strategy === Za ? mc(Al, pl) : Lc[Al.level].func(Al, pl);
      if ((vc === kl || vc === ul) && (Al.status = Nl), vc === zl || vc === kl)
        return bl.avail_out === 0 && (Al.last_flush = -1), _a;
      if (vc === Zl && (pl === pa ? zn._tr_align(Al) : pl !== ba && (zn._tr_stored_block(Al, 0, 0, !1), pl === ma && (yl(Al.head), Al.lookahead === 0 && (Al.strstart = 0, Al.block_start = 0, Al.insert = 0))), Rl(bl), bl.avail_out === 0))
        return Al.last_flush = -1, _a;
    }
    return pl !== va ? _a : Al.wrap <= 0 ? ya : (Al.wrap === 2 ? (hl(Al, bl.adler & 255), hl(Al, bl.adler >> 8 & 255), hl(Al, bl.adler >> 16 & 255), hl(Al, bl.adler >> 24 & 255), hl(Al, bl.total_in & 255), hl(Al, bl.total_in >> 8 & 255), hl(Al, bl.total_in >> 16 & 255), hl(Al, bl.total_in >> 24 & 255)) : (Cl(Al, bl.adler >>> 16), Cl(Al, bl.adler & 65535)), Rl(bl), Al.wrap > 0 && (Al.wrap = -Al.wrap), Al.pending !== 0 ? _a : ya);
  }
  function Ol(bl) {
    var pl;
    return !bl || !bl.state ? xa : (pl = bl.state.status, pl !== Sl && pl !== ml && pl !== Dl && pl !== _l && pl !== gl && pl !== Fl && pl !== Nl ? Tl(bl, xa) : (bl.state = null, pl === Fl ? Tl(bl, wa) : _a));
  }
  function cc(bl, pl) {
    var Jl = pl.length, Al, Bl, Kl, oc, xc, vc, Pc, Hc;
    if (!bl || !bl.state || (Al = bl.state, oc = Al.wrap, oc === 2 || oc === 1 && Al.status !== Sl || Al.lookahead))
      return xa;
    for (oc === 1 && (bl.adler = Un(bl.adler, pl, Jl, 0)), Al.wrap = 0, Jl >= Al.w_size && (oc === 0 && (yl(Al.head), Al.strstart = 0, Al.block_start = 0, Al.insert = 0), Hc = new Xn.Buf8(Al.w_size), Xn.arraySet(Hc, pl, Jl - Al.w_size, Al.w_size, 0), pl = Hc, Jl = Al.w_size), xc = bl.avail_in, vc = bl.next_in, Pc = bl.input, bl.avail_in = Jl, bl.next_in = 0, bl.input = pl, tc(Al); Al.lookahead >= dl; ) {
      Bl = Al.strstart, Kl = Al.lookahead - (dl - 1);
      do
        Al.ins_h = (Al.ins_h << Al.hash_shift ^ Al.window[Bl + dl - 1]) & Al.hash_mask, Al.prev[Bl & Al.w_mask] = Al.head[Al.ins_h], Al.head[Al.ins_h] = Bl, Bl++;
      while (--Kl);
      Al.strstart = Bl, Al.lookahead = dl - 1, tc(Al);
    }
    return Al.strstart += Al.lookahead, Al.block_start = Al.strstart, Al.insert = Al.lookahead, Al.lookahead = 0, Al.match_length = Al.prev_length = dl - 1, Al.match_available = 0, bl.next_in = vc, bl.input = Pc, bl.avail_in = xc, Al.wrap = oc, _a;
  }
  return deflate.deflateInit = Vl, deflate.deflateInit2 = ql, deflate.deflateReset = lc, deflate.deflateResetKeep = fc, deflate.deflateSetHeader = Gl, deflate.deflate = Pl, deflate.deflateEnd = Ol, deflate.deflateSetDictionary = cc, deflate.deflateInfo = "pako deflate (from Nodeca project)", deflate;
}
var strings = {}, hasRequiredStrings;
function requireStrings() {
  if (hasRequiredStrings) return strings;
  hasRequiredStrings = 1;
  var Xn = requireCommon(), zn = !0, Un = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    zn = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    Un = !1;
  }
  for (var Kn = new Xn.Buf8(256), qn = 0; qn < 256; qn++)
    Kn[qn] = qn >= 252 ? 6 : qn >= 248 ? 5 : qn >= 240 ? 4 : qn >= 224 ? 3 : qn >= 192 ? 2 : 1;
  Kn[254] = Kn[254] = 1, strings.string2buf = function(pa) {
    var ma, va, ba, _a, ya, xa = pa.length, wa = 0;
    for (_a = 0; _a < xa; _a++)
      va = pa.charCodeAt(_a), (va & 64512) === 55296 && _a + 1 < xa && (ba = pa.charCodeAt(_a + 1), (ba & 64512) === 56320 && (va = 65536 + (va - 55296 << 10) + (ba - 56320), _a++)), wa += va < 128 ? 1 : va < 2048 ? 2 : va < 65536 ? 3 : 4;
    for (ma = new Xn.Buf8(wa), ya = 0, _a = 0; ya < wa; _a++)
      va = pa.charCodeAt(_a), (va & 64512) === 55296 && _a + 1 < xa && (ba = pa.charCodeAt(_a + 1), (ba & 64512) === 56320 && (va = 65536 + (va - 55296 << 10) + (ba - 56320), _a++)), va < 128 ? ma[ya++] = va : va < 2048 ? (ma[ya++] = 192 | va >>> 6, ma[ya++] = 128 | va & 63) : va < 65536 ? (ma[ya++] = 224 | va >>> 12, ma[ya++] = 128 | va >>> 6 & 63, ma[ya++] = 128 | va & 63) : (ma[ya++] = 240 | va >>> 18, ma[ya++] = 128 | va >>> 12 & 63, ma[ya++] = 128 | va >>> 6 & 63, ma[ya++] = 128 | va & 63);
    return ma;
  };
  function Jo(pa, ma) {
    if (ma < 65534 && (pa.subarray && Un || !pa.subarray && zn))
      return String.fromCharCode.apply(null, Xn.shrinkBuf(pa, ma));
    for (var va = "", ba = 0; ba < ma; ba++)
      va += String.fromCharCode(pa[ba]);
    return va;
  }
  return strings.buf2binstring = function(pa) {
    return Jo(pa, pa.length);
  }, strings.binstring2buf = function(pa) {
    for (var ma = new Xn.Buf8(pa.length), va = 0, ba = ma.length; va < ba; va++)
      ma[va] = pa.charCodeAt(va);
    return ma;
  }, strings.buf2string = function(pa, ma) {
    var va, ba, _a, ya, xa = ma || pa.length, wa = new Array(xa * 2);
    for (ba = 0, va = 0; va < xa; ) {
      if (_a = pa[va++], _a < 128) {
        wa[ba++] = _a;
        continue;
      }
      if (ya = Kn[_a], ya > 4) {
        wa[ba++] = 65533, va += ya - 1;
        continue;
      }
      for (_a &= ya === 2 ? 31 : ya === 3 ? 15 : 7; ya > 1 && va < xa; )
        _a = _a << 6 | pa[va++] & 63, ya--;
      if (ya > 1) {
        wa[ba++] = 65533;
        continue;
      }
      _a < 65536 ? wa[ba++] = _a : (_a -= 65536, wa[ba++] = 55296 | _a >> 10 & 1023, wa[ba++] = 56320 | _a & 1023);
    }
    return Jo(wa, ba);
  }, strings.utf8border = function(pa, ma) {
    var va;
    for (ma = ma || pa.length, ma > pa.length && (ma = pa.length), va = ma - 1; va >= 0 && (pa[va] & 192) === 128; )
      va--;
    return va < 0 || va === 0 ? ma : va + Kn[pa[va]] > ma ? va : ma;
  }, strings;
}
var zstream, hasRequiredZstream;
function requireZstream() {
  if (hasRequiredZstream) return zstream;
  hasRequiredZstream = 1;
  function Xn() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return zstream = Xn, zstream;
}
var hasRequiredDeflate;
function requireDeflate() {
  if (hasRequiredDeflate) return deflate$1;
  hasRequiredDeflate = 1;
  var Xn = requireDeflate$1(), zn = requireCommon(), Un = requireStrings(), Kn = requireMessages(), qn = requireZstream(), Jo = Object.prototype.toString, pa = 0, ma = 4, va = 0, ba = 1, _a = 2, ya = -1, xa = 0, wa = 8;
  function Ta(Za) {
    if (!(this instanceof Ta)) return new Ta(Za);
    this.options = zn.assign({
      level: ya,
      method: wa,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: xa,
      to: ""
    }, Za || {});
    var Na = this.options;
    Na.raw && Na.windowBits > 0 ? Na.windowBits = -Na.windowBits : Na.gzip && Na.windowBits > 0 && Na.windowBits < 16 && (Na.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new qn(), this.strm.avail_out = 0;
    var Ka = Xn.deflateInit2(
      this.strm,
      Na.level,
      Na.method,
      Na.windowBits,
      Na.memLevel,
      Na.strategy
    );
    if (Ka !== va)
      throw new Error(Kn[Ka]);
    if (Na.header && Xn.deflateSetHeader(this.strm, Na.header), Na.dictionary) {
      var Ja;
      if (typeof Na.dictionary == "string" ? Ja = Un.string2buf(Na.dictionary) : Jo.call(Na.dictionary) === "[object ArrayBuffer]" ? Ja = new Uint8Array(Na.dictionary) : Ja = Na.dictionary, Ka = Xn.deflateSetDictionary(this.strm, Ja), Ka !== va)
        throw new Error(Kn[Ka]);
      this._dict_set = !0;
    }
  }
  Ta.prototype.push = function(Za, Na) {
    var Ka = this.strm, Ja = this.options.chunkSize, el, qa;
    if (this.ended)
      return !1;
    qa = Na === ~~Na ? Na : Na === !0 ? ma : pa, typeof Za == "string" ? Ka.input = Un.string2buf(Za) : Jo.call(Za) === "[object ArrayBuffer]" ? Ka.input = new Uint8Array(Za) : Ka.input = Za, Ka.next_in = 0, Ka.avail_in = Ka.input.length;
    do {
      if (Ka.avail_out === 0 && (Ka.output = new zn.Buf8(Ja), Ka.next_out = 0, Ka.avail_out = Ja), el = Xn.deflate(Ka, qa), el !== ba && el !== va)
        return this.onEnd(el), this.ended = !0, !1;
      (Ka.avail_out === 0 || Ka.avail_in === 0 && (qa === ma || qa === _a)) && (this.options.to === "string" ? this.onData(Un.buf2binstring(zn.shrinkBuf(Ka.output, Ka.next_out))) : this.onData(zn.shrinkBuf(Ka.output, Ka.next_out)));
    } while ((Ka.avail_in > 0 || Ka.avail_out === 0) && el !== ba);
    return qa === ma ? (el = Xn.deflateEnd(this.strm), this.onEnd(el), this.ended = !0, el === va) : (qa === _a && (this.onEnd(va), Ka.avail_out = 0), !0);
  }, Ta.prototype.onData = function(Za) {
    this.chunks.push(Za);
  }, Ta.prototype.onEnd = function(Za) {
    Za === va && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = zn.flattenChunks(this.chunks)), this.chunks = [], this.err = Za, this.msg = this.strm.msg;
  };
  function Sa(Za, Na) {
    var Ka = new Ta(Na);
    if (Ka.push(Za, !0), Ka.err)
      throw Ka.msg || Kn[Ka.err];
    return Ka.result;
  }
  function Ma(Za, Na) {
    return Na = Na || {}, Na.raw = !0, Sa(Za, Na);
  }
  function ka(Za, Na) {
    return Na = Na || {}, Na.gzip = !0, Sa(Za, Na);
  }
  return deflate$1.Deflate = Ta, deflate$1.deflate = Sa, deflate$1.deflateRaw = Ma, deflate$1.gzip = ka, deflate$1;
}
var inflate$1 = {}, inflate = {}, inffast, hasRequiredInffast;
function requireInffast() {
  if (hasRequiredInffast) return inffast;
  hasRequiredInffast = 1;
  var Xn = 30, zn = 12;
  return inffast = function(Kn, qn) {
    var Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja, el, qa, tl, Qa, nl, rl, il, cl;
    Jo = Kn.state, pa = Kn.next_in, il = Kn.input, ma = pa + (Kn.avail_in - 5), va = Kn.next_out, cl = Kn.output, ba = va - (qn - Kn.avail_out), _a = va + (Kn.avail_out - 257), ya = Jo.dmax, xa = Jo.wsize, wa = Jo.whave, Ta = Jo.wnext, Sa = Jo.window, Ma = Jo.hold, ka = Jo.bits, Za = Jo.lencode, Na = Jo.distcode, Ka = (1 << Jo.lenbits) - 1, Ja = (1 << Jo.distbits) - 1;
    e:
      do {
        ka < 15 && (Ma += il[pa++] << ka, ka += 8, Ma += il[pa++] << ka, ka += 8), el = Za[Ma & Ka];
        t:
          for (; ; ) {
            if (qa = el >>> 24, Ma >>>= qa, ka -= qa, qa = el >>> 16 & 255, qa === 0)
              cl[va++] = el & 65535;
            else if (qa & 16) {
              tl = el & 65535, qa &= 15, qa && (ka < qa && (Ma += il[pa++] << ka, ka += 8), tl += Ma & (1 << qa) - 1, Ma >>>= qa, ka -= qa), ka < 15 && (Ma += il[pa++] << ka, ka += 8, Ma += il[pa++] << ka, ka += 8), el = Na[Ma & Ja];
              r:
                for (; ; ) {
                  if (qa = el >>> 24, Ma >>>= qa, ka -= qa, qa = el >>> 16 & 255, qa & 16) {
                    if (Qa = el & 65535, qa &= 15, ka < qa && (Ma += il[pa++] << ka, ka += 8, ka < qa && (Ma += il[pa++] << ka, ka += 8)), Qa += Ma & (1 << qa) - 1, Qa > ya) {
                      Kn.msg = "invalid distance too far back", Jo.mode = Xn;
                      break e;
                    }
                    if (Ma >>>= qa, ka -= qa, qa = va - ba, Qa > qa) {
                      if (qa = Qa - qa, qa > wa && Jo.sane) {
                        Kn.msg = "invalid distance too far back", Jo.mode = Xn;
                        break e;
                      }
                      if (nl = 0, rl = Sa, Ta === 0) {
                        if (nl += xa - qa, qa < tl) {
                          tl -= qa;
                          do
                            cl[va++] = Sa[nl++];
                          while (--qa);
                          nl = va - Qa, rl = cl;
                        }
                      } else if (Ta < qa) {
                        if (nl += xa + Ta - qa, qa -= Ta, qa < tl) {
                          tl -= qa;
                          do
                            cl[va++] = Sa[nl++];
                          while (--qa);
                          if (nl = 0, Ta < tl) {
                            qa = Ta, tl -= qa;
                            do
                              cl[va++] = Sa[nl++];
                            while (--qa);
                            nl = va - Qa, rl = cl;
                          }
                        }
                      } else if (nl += Ta - qa, qa < tl) {
                        tl -= qa;
                        do
                          cl[va++] = Sa[nl++];
                        while (--qa);
                        nl = va - Qa, rl = cl;
                      }
                      for (; tl > 2; )
                        cl[va++] = rl[nl++], cl[va++] = rl[nl++], cl[va++] = rl[nl++], tl -= 3;
                      tl && (cl[va++] = rl[nl++], tl > 1 && (cl[va++] = rl[nl++]));
                    } else {
                      nl = va - Qa;
                      do
                        cl[va++] = cl[nl++], cl[va++] = cl[nl++], cl[va++] = cl[nl++], tl -= 3;
                      while (tl > 2);
                      tl && (cl[va++] = cl[nl++], tl > 1 && (cl[va++] = cl[nl++]));
                    }
                  } else if ((qa & 64) === 0) {
                    el = Na[(el & 65535) + (Ma & (1 << qa) - 1)];
                    continue r;
                  } else {
                    Kn.msg = "invalid distance code", Jo.mode = Xn;
                    break e;
                  }
                  break;
                }
            } else if ((qa & 64) === 0) {
              el = Za[(el & 65535) + (Ma & (1 << qa) - 1)];
              continue t;
            } else if (qa & 32) {
              Jo.mode = zn;
              break e;
            } else {
              Kn.msg = "invalid literal/length code", Jo.mode = Xn;
              break e;
            }
            break;
          }
      } while (pa < ma && va < _a);
    tl = ka >> 3, pa -= tl, ka -= tl << 3, Ma &= (1 << ka) - 1, Kn.next_in = pa, Kn.next_out = va, Kn.avail_in = pa < ma ? 5 + (ma - pa) : 5 - (pa - ma), Kn.avail_out = va < _a ? 257 + (_a - va) : 257 - (va - _a), Jo.hold = Ma, Jo.bits = ka;
  }, inffast;
}
var inftrees, hasRequiredInftrees;
function requireInftrees() {
  if (hasRequiredInftrees) return inftrees;
  hasRequiredInftrees = 1;
  var Xn = requireCommon(), zn = 15, Un = 852, Kn = 592, qn = 0, Jo = 1, pa = 2, ma = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], va = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], ba = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], _a = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return inftrees = function(xa, wa, Ta, Sa, Ma, ka, Za, Na) {
    var Ka = Na.bits, Ja = 0, el = 0, qa = 0, tl = 0, Qa = 0, nl = 0, rl = 0, il = 0, cl = 0, ll = 0, al, sl, dl, El, fl, Ml = null, Sl = 0, ml, Dl = new Xn.Buf16(zn + 1), _l = new Xn.Buf16(zn + 1), gl = null, Fl = 0, Nl, zl, Zl;
    for (Ja = 0; Ja <= zn; Ja++)
      Dl[Ja] = 0;
    for (el = 0; el < Sa; el++)
      Dl[wa[Ta + el]]++;
    for (Qa = Ka, tl = zn; tl >= 1 && Dl[tl] === 0; tl--)
      ;
    if (Qa > tl && (Qa = tl), tl === 0)
      return Ma[ka++] = 1 << 24 | 64 << 16 | 0, Ma[ka++] = 1 << 24 | 64 << 16 | 0, Na.bits = 1, 0;
    for (qa = 1; qa < tl && Dl[qa] === 0; qa++)
      ;
    for (Qa < qa && (Qa = qa), il = 1, Ja = 1; Ja <= zn; Ja++)
      if (il <<= 1, il -= Dl[Ja], il < 0)
        return -1;
    if (il > 0 && (xa === qn || tl !== 1))
      return -1;
    for (_l[1] = 0, Ja = 1; Ja < zn; Ja++)
      _l[Ja + 1] = _l[Ja] + Dl[Ja];
    for (el = 0; el < Sa; el++)
      wa[Ta + el] !== 0 && (Za[_l[wa[Ta + el]]++] = el);
    if (xa === qn ? (Ml = gl = Za, ml = 19) : xa === Jo ? (Ml = ma, Sl -= 257, gl = va, Fl -= 257, ml = 256) : (Ml = ba, gl = _a, ml = -1), ll = 0, el = 0, Ja = qa, fl = ka, nl = Qa, rl = 0, dl = -1, cl = 1 << Qa, El = cl - 1, xa === Jo && cl > Un || xa === pa && cl > Kn)
      return 1;
    for (; ; ) {
      Nl = Ja - rl, Za[el] < ml ? (zl = 0, Zl = Za[el]) : Za[el] > ml ? (zl = gl[Fl + Za[el]], Zl = Ml[Sl + Za[el]]) : (zl = 96, Zl = 0), al = 1 << Ja - rl, sl = 1 << nl, qa = sl;
      do
        sl -= al, Ma[fl + (ll >> rl) + sl] = Nl << 24 | zl << 16 | Zl | 0;
      while (sl !== 0);
      for (al = 1 << Ja - 1; ll & al; )
        al >>= 1;
      if (al !== 0 ? (ll &= al - 1, ll += al) : ll = 0, el++, --Dl[Ja] === 0) {
        if (Ja === tl)
          break;
        Ja = wa[Ta + Za[el]];
      }
      if (Ja > Qa && (ll & El) !== dl) {
        for (rl === 0 && (rl = Qa), fl += qa, nl = Ja - rl, il = 1 << nl; nl + rl < tl && (il -= Dl[nl + rl], !(il <= 0)); )
          nl++, il <<= 1;
        if (cl += 1 << nl, xa === Jo && cl > Un || xa === pa && cl > Kn)
          return 1;
        dl = ll & El, Ma[dl] = Qa << 24 | nl << 16 | fl - ka | 0;
      }
    }
    return ll !== 0 && (Ma[fl + ll] = Ja - rl << 24 | 64 << 16 | 0), Na.bits = Qa, 0;
  }, inftrees;
}
var hasRequiredInflate$1;
function requireInflate$1() {
  if (hasRequiredInflate$1) return inflate;
  hasRequiredInflate$1 = 1;
  var Xn = requireCommon(), zn = requireAdler32(), Un = requireCrc32(), Kn = requireInffast(), qn = requireInftrees(), Jo = 0, pa = 1, ma = 2, va = 4, ba = 5, _a = 6, ya = 0, xa = 1, wa = 2, Ta = -2, Sa = -3, Ma = -4, ka = -5, Za = 8, Na = 1, Ka = 2, Ja = 3, el = 4, qa = 5, tl = 6, Qa = 7, nl = 8, rl = 9, il = 10, cl = 11, ll = 12, al = 13, sl = 14, dl = 15, El = 16, fl = 17, Ml = 18, Sl = 19, ml = 20, Dl = 21, _l = 22, gl = 23, Fl = 24, Nl = 25, zl = 26, Zl = 27, kl = 28, ul = 29, vl = 30, Tl = 31, wl = 32, yl = 852, Rl = 592, Ul = 15, hl = Ul;
  function Cl(ql) {
    return (ql >>> 24 & 255) + (ql >>> 8 & 65280) + ((ql & 65280) << 8) + ((ql & 255) << 24);
  }
  function Il() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Xn.Buf16(320), this.work = new Xn.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function Ll(ql) {
    var Vl;
    return !ql || !ql.state ? Ta : (Vl = ql.state, ql.total_in = ql.total_out = Vl.total = 0, ql.msg = "", Vl.wrap && (ql.adler = Vl.wrap & 1), Vl.mode = Na, Vl.last = 0, Vl.havedict = 0, Vl.dmax = 32768, Vl.head = null, Vl.hold = 0, Vl.bits = 0, Vl.lencode = Vl.lendyn = new Xn.Buf32(yl), Vl.distcode = Vl.distdyn = new Xn.Buf32(Rl), Vl.sane = 1, Vl.back = -1, ya);
  }
  function tc(ql) {
    var Vl;
    return !ql || !ql.state ? Ta : (Vl = ql.state, Vl.wsize = 0, Vl.whave = 0, Vl.wnext = 0, Ll(ql));
  }
  function nc(ql, Vl) {
    var Pl, Ol;
    return !ql || !ql.state || (Ol = ql.state, Vl < 0 ? (Pl = 0, Vl = -Vl) : (Pl = (Vl >> 4) + 1, Vl < 48 && (Vl &= 15)), Vl && (Vl < 8 || Vl > 15)) ? Ta : (Ol.window !== null && Ol.wbits !== Vl && (Ol.window = null), Ol.wrap = Pl, Ol.wbits = Vl, tc(ql));
  }
  function uc(ql, Vl) {
    var Pl, Ol;
    return ql ? (Ol = new Il(), ql.state = Ol, Ol.window = null, Pl = nc(ql, Vl), Pl !== ya && (ql.state = null), Pl) : Ta;
  }
  function _c(ql) {
    return uc(ql, hl);
  }
  var mc = !0, Sc, hc;
  function Lc(ql) {
    if (mc) {
      var Vl;
      for (Sc = new Xn.Buf32(512), hc = new Xn.Buf32(32), Vl = 0; Vl < 144; )
        ql.lens[Vl++] = 8;
      for (; Vl < 256; )
        ql.lens[Vl++] = 9;
      for (; Vl < 280; )
        ql.lens[Vl++] = 7;
      for (; Vl < 288; )
        ql.lens[Vl++] = 8;
      for (qn(pa, ql.lens, 0, 288, Sc, 0, ql.work, { bits: 9 }), Vl = 0; Vl < 32; )
        ql.lens[Vl++] = 5;
      qn(ma, ql.lens, 0, 32, hc, 0, ql.work, { bits: 5 }), mc = !1;
    }
    ql.lencode = Sc, ql.lenbits = 9, ql.distcode = hc, ql.distbits = 5;
  }
  function Ec(ql, Vl, Pl, Ol) {
    var cc, bl = ql.state;
    return bl.window === null && (bl.wsize = 1 << bl.wbits, bl.wnext = 0, bl.whave = 0, bl.window = new Xn.Buf8(bl.wsize)), Ol >= bl.wsize ? (Xn.arraySet(bl.window, Vl, Pl - bl.wsize, bl.wsize, 0), bl.wnext = 0, bl.whave = bl.wsize) : (cc = bl.wsize - bl.wnext, cc > Ol && (cc = Ol), Xn.arraySet(bl.window, Vl, Pl - Ol, cc, bl.wnext), Ol -= cc, Ol ? (Xn.arraySet(bl.window, Vl, Pl - Ol, Ol, 0), bl.wnext = Ol, bl.whave = bl.wsize) : (bl.wnext += cc, bl.wnext === bl.wsize && (bl.wnext = 0), bl.whave < bl.wsize && (bl.whave += cc))), 0;
  }
  function Hl(ql, Vl) {
    var Pl, Ol, cc, bl, pl, Jl, Al, Bl, Kl, oc, xc, vc, Pc, Hc, $c = 0, Nc, Zc, Yc, mh, Wl, ic, Xl, Ql, ec = new Xn.Buf8(4), rc, dc, wc = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!ql || !ql.state || !ql.output || !ql.input && ql.avail_in !== 0)
      return Ta;
    Pl = ql.state, Pl.mode === ll && (Pl.mode = al), pl = ql.next_out, cc = ql.output, Al = ql.avail_out, bl = ql.next_in, Ol = ql.input, Jl = ql.avail_in, Bl = Pl.hold, Kl = Pl.bits, oc = Jl, xc = Al, Ql = ya;
    e:
      for (; ; )
        switch (Pl.mode) {
          case Na:
            if (Pl.wrap === 0) {
              Pl.mode = al;
              break;
            }
            for (; Kl < 16; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            if (Pl.wrap & 2 && Bl === 35615) {
              Pl.check = 0, ec[0] = Bl & 255, ec[1] = Bl >>> 8 & 255, Pl.check = Un(Pl.check, ec, 2, 0), Bl = 0, Kl = 0, Pl.mode = Ka;
              break;
            }
            if (Pl.flags = 0, Pl.head && (Pl.head.done = !1), !(Pl.wrap & 1) || /* check if zlib header allowed */
            (((Bl & 255) << 8) + (Bl >> 8)) % 31) {
              ql.msg = "incorrect header check", Pl.mode = vl;
              break;
            }
            if ((Bl & 15) !== Za) {
              ql.msg = "unknown compression method", Pl.mode = vl;
              break;
            }
            if (Bl >>>= 4, Kl -= 4, Xl = (Bl & 15) + 8, Pl.wbits === 0)
              Pl.wbits = Xl;
            else if (Xl > Pl.wbits) {
              ql.msg = "invalid window size", Pl.mode = vl;
              break;
            }
            Pl.dmax = 1 << Xl, ql.adler = Pl.check = 1, Pl.mode = Bl & 512 ? il : ll, Bl = 0, Kl = 0;
            break;
          case Ka:
            for (; Kl < 16; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            if (Pl.flags = Bl, (Pl.flags & 255) !== Za) {
              ql.msg = "unknown compression method", Pl.mode = vl;
              break;
            }
            if (Pl.flags & 57344) {
              ql.msg = "unknown header flags set", Pl.mode = vl;
              break;
            }
            Pl.head && (Pl.head.text = Bl >> 8 & 1), Pl.flags & 512 && (ec[0] = Bl & 255, ec[1] = Bl >>> 8 & 255, Pl.check = Un(Pl.check, ec, 2, 0)), Bl = 0, Kl = 0, Pl.mode = Ja;
          /* falls through */
          case Ja:
            for (; Kl < 32; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            Pl.head && (Pl.head.time = Bl), Pl.flags & 512 && (ec[0] = Bl & 255, ec[1] = Bl >>> 8 & 255, ec[2] = Bl >>> 16 & 255, ec[3] = Bl >>> 24 & 255, Pl.check = Un(Pl.check, ec, 4, 0)), Bl = 0, Kl = 0, Pl.mode = el;
          /* falls through */
          case el:
            for (; Kl < 16; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            Pl.head && (Pl.head.xflags = Bl & 255, Pl.head.os = Bl >> 8), Pl.flags & 512 && (ec[0] = Bl & 255, ec[1] = Bl >>> 8 & 255, Pl.check = Un(Pl.check, ec, 2, 0)), Bl = 0, Kl = 0, Pl.mode = qa;
          /* falls through */
          case qa:
            if (Pl.flags & 1024) {
              for (; Kl < 16; ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              Pl.length = Bl, Pl.head && (Pl.head.extra_len = Bl), Pl.flags & 512 && (ec[0] = Bl & 255, ec[1] = Bl >>> 8 & 255, Pl.check = Un(Pl.check, ec, 2, 0)), Bl = 0, Kl = 0;
            } else Pl.head && (Pl.head.extra = null);
            Pl.mode = tl;
          /* falls through */
          case tl:
            if (Pl.flags & 1024 && (vc = Pl.length, vc > Jl && (vc = Jl), vc && (Pl.head && (Xl = Pl.head.extra_len - Pl.length, Pl.head.extra || (Pl.head.extra = new Array(Pl.head.extra_len)), Xn.arraySet(
              Pl.head.extra,
              Ol,
              bl,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              vc,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              Xl
            )), Pl.flags & 512 && (Pl.check = Un(Pl.check, Ol, vc, bl)), Jl -= vc, bl += vc, Pl.length -= vc), Pl.length))
              break e;
            Pl.length = 0, Pl.mode = Qa;
          /* falls through */
          case Qa:
            if (Pl.flags & 2048) {
              if (Jl === 0)
                break e;
              vc = 0;
              do
                Xl = Ol[bl + vc++], Pl.head && Xl && Pl.length < 65536 && (Pl.head.name += String.fromCharCode(Xl));
              while (Xl && vc < Jl);
              if (Pl.flags & 512 && (Pl.check = Un(Pl.check, Ol, vc, bl)), Jl -= vc, bl += vc, Xl)
                break e;
            } else Pl.head && (Pl.head.name = null);
            Pl.length = 0, Pl.mode = nl;
          /* falls through */
          case nl:
            if (Pl.flags & 4096) {
              if (Jl === 0)
                break e;
              vc = 0;
              do
                Xl = Ol[bl + vc++], Pl.head && Xl && Pl.length < 65536 && (Pl.head.comment += String.fromCharCode(Xl));
              while (Xl && vc < Jl);
              if (Pl.flags & 512 && (Pl.check = Un(Pl.check, Ol, vc, bl)), Jl -= vc, bl += vc, Xl)
                break e;
            } else Pl.head && (Pl.head.comment = null);
            Pl.mode = rl;
          /* falls through */
          case rl:
            if (Pl.flags & 512) {
              for (; Kl < 16; ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              if (Bl !== (Pl.check & 65535)) {
                ql.msg = "header crc mismatch", Pl.mode = vl;
                break;
              }
              Bl = 0, Kl = 0;
            }
            Pl.head && (Pl.head.hcrc = Pl.flags >> 9 & 1, Pl.head.done = !0), ql.adler = Pl.check = 0, Pl.mode = ll;
            break;
          case il:
            for (; Kl < 32; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            ql.adler = Pl.check = Cl(Bl), Bl = 0, Kl = 0, Pl.mode = cl;
          /* falls through */
          case cl:
            if (Pl.havedict === 0)
              return ql.next_out = pl, ql.avail_out = Al, ql.next_in = bl, ql.avail_in = Jl, Pl.hold = Bl, Pl.bits = Kl, wa;
            ql.adler = Pl.check = 1, Pl.mode = ll;
          /* falls through */
          case ll:
            if (Vl === ba || Vl === _a)
              break e;
          /* falls through */
          case al:
            if (Pl.last) {
              Bl >>>= Kl & 7, Kl -= Kl & 7, Pl.mode = Zl;
              break;
            }
            for (; Kl < 3; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            switch (Pl.last = Bl & 1, Bl >>>= 1, Kl -= 1, Bl & 3) {
              case 0:
                Pl.mode = sl;
                break;
              case 1:
                if (Lc(Pl), Pl.mode = ml, Vl === _a) {
                  Bl >>>= 2, Kl -= 2;
                  break e;
                }
                break;
              case 2:
                Pl.mode = fl;
                break;
              case 3:
                ql.msg = "invalid block type", Pl.mode = vl;
            }
            Bl >>>= 2, Kl -= 2;
            break;
          case sl:
            for (Bl >>>= Kl & 7, Kl -= Kl & 7; Kl < 32; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            if ((Bl & 65535) !== (Bl >>> 16 ^ 65535)) {
              ql.msg = "invalid stored block lengths", Pl.mode = vl;
              break;
            }
            if (Pl.length = Bl & 65535, Bl = 0, Kl = 0, Pl.mode = dl, Vl === _a)
              break e;
          /* falls through */
          case dl:
            Pl.mode = El;
          /* falls through */
          case El:
            if (vc = Pl.length, vc) {
              if (vc > Jl && (vc = Jl), vc > Al && (vc = Al), vc === 0)
                break e;
              Xn.arraySet(cc, Ol, bl, vc, pl), Jl -= vc, bl += vc, Al -= vc, pl += vc, Pl.length -= vc;
              break;
            }
            Pl.mode = ll;
            break;
          case fl:
            for (; Kl < 14; ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            if (Pl.nlen = (Bl & 31) + 257, Bl >>>= 5, Kl -= 5, Pl.ndist = (Bl & 31) + 1, Bl >>>= 5, Kl -= 5, Pl.ncode = (Bl & 15) + 4, Bl >>>= 4, Kl -= 4, Pl.nlen > 286 || Pl.ndist > 30) {
              ql.msg = "too many length or distance symbols", Pl.mode = vl;
              break;
            }
            Pl.have = 0, Pl.mode = Ml;
          /* falls through */
          case Ml:
            for (; Pl.have < Pl.ncode; ) {
              for (; Kl < 3; ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              Pl.lens[wc[Pl.have++]] = Bl & 7, Bl >>>= 3, Kl -= 3;
            }
            for (; Pl.have < 19; )
              Pl.lens[wc[Pl.have++]] = 0;
            if (Pl.lencode = Pl.lendyn, Pl.lenbits = 7, rc = { bits: Pl.lenbits }, Ql = qn(Jo, Pl.lens, 0, 19, Pl.lencode, 0, Pl.work, rc), Pl.lenbits = rc.bits, Ql) {
              ql.msg = "invalid code lengths set", Pl.mode = vl;
              break;
            }
            Pl.have = 0, Pl.mode = Sl;
          /* falls through */
          case Sl:
            for (; Pl.have < Pl.nlen + Pl.ndist; ) {
              for (; $c = Pl.lencode[Bl & (1 << Pl.lenbits) - 1], Nc = $c >>> 24, Zc = $c >>> 16 & 255, Yc = $c & 65535, !(Nc <= Kl); ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              if (Yc < 16)
                Bl >>>= Nc, Kl -= Nc, Pl.lens[Pl.have++] = Yc;
              else {
                if (Yc === 16) {
                  for (dc = Nc + 2; Kl < dc; ) {
                    if (Jl === 0)
                      break e;
                    Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
                  }
                  if (Bl >>>= Nc, Kl -= Nc, Pl.have === 0) {
                    ql.msg = "invalid bit length repeat", Pl.mode = vl;
                    break;
                  }
                  Xl = Pl.lens[Pl.have - 1], vc = 3 + (Bl & 3), Bl >>>= 2, Kl -= 2;
                } else if (Yc === 17) {
                  for (dc = Nc + 3; Kl < dc; ) {
                    if (Jl === 0)
                      break e;
                    Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
                  }
                  Bl >>>= Nc, Kl -= Nc, Xl = 0, vc = 3 + (Bl & 7), Bl >>>= 3, Kl -= 3;
                } else {
                  for (dc = Nc + 7; Kl < dc; ) {
                    if (Jl === 0)
                      break e;
                    Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
                  }
                  Bl >>>= Nc, Kl -= Nc, Xl = 0, vc = 11 + (Bl & 127), Bl >>>= 7, Kl -= 7;
                }
                if (Pl.have + vc > Pl.nlen + Pl.ndist) {
                  ql.msg = "invalid bit length repeat", Pl.mode = vl;
                  break;
                }
                for (; vc--; )
                  Pl.lens[Pl.have++] = Xl;
              }
            }
            if (Pl.mode === vl)
              break;
            if (Pl.lens[256] === 0) {
              ql.msg = "invalid code -- missing end-of-block", Pl.mode = vl;
              break;
            }
            if (Pl.lenbits = 9, rc = { bits: Pl.lenbits }, Ql = qn(pa, Pl.lens, 0, Pl.nlen, Pl.lencode, 0, Pl.work, rc), Pl.lenbits = rc.bits, Ql) {
              ql.msg = "invalid literal/lengths set", Pl.mode = vl;
              break;
            }
            if (Pl.distbits = 6, Pl.distcode = Pl.distdyn, rc = { bits: Pl.distbits }, Ql = qn(ma, Pl.lens, Pl.nlen, Pl.ndist, Pl.distcode, 0, Pl.work, rc), Pl.distbits = rc.bits, Ql) {
              ql.msg = "invalid distances set", Pl.mode = vl;
              break;
            }
            if (Pl.mode = ml, Vl === _a)
              break e;
          /* falls through */
          case ml:
            Pl.mode = Dl;
          /* falls through */
          case Dl:
            if (Jl >= 6 && Al >= 258) {
              ql.next_out = pl, ql.avail_out = Al, ql.next_in = bl, ql.avail_in = Jl, Pl.hold = Bl, Pl.bits = Kl, Kn(ql, xc), pl = ql.next_out, cc = ql.output, Al = ql.avail_out, bl = ql.next_in, Ol = ql.input, Jl = ql.avail_in, Bl = Pl.hold, Kl = Pl.bits, Pl.mode === ll && (Pl.back = -1);
              break;
            }
            for (Pl.back = 0; $c = Pl.lencode[Bl & (1 << Pl.lenbits) - 1], Nc = $c >>> 24, Zc = $c >>> 16 & 255, Yc = $c & 65535, !(Nc <= Kl); ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            if (Zc && (Zc & 240) === 0) {
              for (mh = Nc, Wl = Zc, ic = Yc; $c = Pl.lencode[ic + ((Bl & (1 << mh + Wl) - 1) >> mh)], Nc = $c >>> 24, Zc = $c >>> 16 & 255, Yc = $c & 65535, !(mh + Nc <= Kl); ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              Bl >>>= mh, Kl -= mh, Pl.back += mh;
            }
            if (Bl >>>= Nc, Kl -= Nc, Pl.back += Nc, Pl.length = Yc, Zc === 0) {
              Pl.mode = zl;
              break;
            }
            if (Zc & 32) {
              Pl.back = -1, Pl.mode = ll;
              break;
            }
            if (Zc & 64) {
              ql.msg = "invalid literal/length code", Pl.mode = vl;
              break;
            }
            Pl.extra = Zc & 15, Pl.mode = _l;
          /* falls through */
          case _l:
            if (Pl.extra) {
              for (dc = Pl.extra; Kl < dc; ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              Pl.length += Bl & (1 << Pl.extra) - 1, Bl >>>= Pl.extra, Kl -= Pl.extra, Pl.back += Pl.extra;
            }
            Pl.was = Pl.length, Pl.mode = gl;
          /* falls through */
          case gl:
            for (; $c = Pl.distcode[Bl & (1 << Pl.distbits) - 1], Nc = $c >>> 24, Zc = $c >>> 16 & 255, Yc = $c & 65535, !(Nc <= Kl); ) {
              if (Jl === 0)
                break e;
              Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
            }
            if ((Zc & 240) === 0) {
              for (mh = Nc, Wl = Zc, ic = Yc; $c = Pl.distcode[ic + ((Bl & (1 << mh + Wl) - 1) >> mh)], Nc = $c >>> 24, Zc = $c >>> 16 & 255, Yc = $c & 65535, !(mh + Nc <= Kl); ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              Bl >>>= mh, Kl -= mh, Pl.back += mh;
            }
            if (Bl >>>= Nc, Kl -= Nc, Pl.back += Nc, Zc & 64) {
              ql.msg = "invalid distance code", Pl.mode = vl;
              break;
            }
            Pl.offset = Yc, Pl.extra = Zc & 15, Pl.mode = Fl;
          /* falls through */
          case Fl:
            if (Pl.extra) {
              for (dc = Pl.extra; Kl < dc; ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              Pl.offset += Bl & (1 << Pl.extra) - 1, Bl >>>= Pl.extra, Kl -= Pl.extra, Pl.back += Pl.extra;
            }
            if (Pl.offset > Pl.dmax) {
              ql.msg = "invalid distance too far back", Pl.mode = vl;
              break;
            }
            Pl.mode = Nl;
          /* falls through */
          case Nl:
            if (Al === 0)
              break e;
            if (vc = xc - Al, Pl.offset > vc) {
              if (vc = Pl.offset - vc, vc > Pl.whave && Pl.sane) {
                ql.msg = "invalid distance too far back", Pl.mode = vl;
                break;
              }
              vc > Pl.wnext ? (vc -= Pl.wnext, Pc = Pl.wsize - vc) : Pc = Pl.wnext - vc, vc > Pl.length && (vc = Pl.length), Hc = Pl.window;
            } else
              Hc = cc, Pc = pl - Pl.offset, vc = Pl.length;
            vc > Al && (vc = Al), Al -= vc, Pl.length -= vc;
            do
              cc[pl++] = Hc[Pc++];
            while (--vc);
            Pl.length === 0 && (Pl.mode = Dl);
            break;
          case zl:
            if (Al === 0)
              break e;
            cc[pl++] = Pl.length, Al--, Pl.mode = Dl;
            break;
          case Zl:
            if (Pl.wrap) {
              for (; Kl < 32; ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl |= Ol[bl++] << Kl, Kl += 8;
              }
              if (xc -= Al, ql.total_out += xc, Pl.total += xc, xc && (ql.adler = Pl.check = /*UPDATE(state.check, put - _out, _out);*/
              Pl.flags ? Un(Pl.check, cc, xc, pl - xc) : zn(Pl.check, cc, xc, pl - xc)), xc = Al, (Pl.flags ? Bl : Cl(Bl)) !== Pl.check) {
                ql.msg = "incorrect data check", Pl.mode = vl;
                break;
              }
              Bl = 0, Kl = 0;
            }
            Pl.mode = kl;
          /* falls through */
          case kl:
            if (Pl.wrap && Pl.flags) {
              for (; Kl < 32; ) {
                if (Jl === 0)
                  break e;
                Jl--, Bl += Ol[bl++] << Kl, Kl += 8;
              }
              if (Bl !== (Pl.total & 4294967295)) {
                ql.msg = "incorrect length check", Pl.mode = vl;
                break;
              }
              Bl = 0, Kl = 0;
            }
            Pl.mode = ul;
          /* falls through */
          case ul:
            Ql = xa;
            break e;
          case vl:
            Ql = Sa;
            break e;
          case Tl:
            return Ma;
          case wl:
          /* falls through */
          default:
            return Ta;
        }
    return ql.next_out = pl, ql.avail_out = Al, ql.next_in = bl, ql.avail_in = Jl, Pl.hold = Bl, Pl.bits = Kl, (Pl.wsize || xc !== ql.avail_out && Pl.mode < vl && (Pl.mode < Zl || Vl !== va)) && Ec(ql, ql.output, ql.next_out, xc - ql.avail_out), oc -= ql.avail_in, xc -= ql.avail_out, ql.total_in += oc, ql.total_out += xc, Pl.total += xc, Pl.wrap && xc && (ql.adler = Pl.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    Pl.flags ? Un(Pl.check, cc, xc, ql.next_out - xc) : zn(Pl.check, cc, xc, ql.next_out - xc)), ql.data_type = Pl.bits + (Pl.last ? 64 : 0) + (Pl.mode === ll ? 128 : 0) + (Pl.mode === ml || Pl.mode === dl ? 256 : 0), (oc === 0 && xc === 0 || Vl === va) && Ql === ya && (Ql = ka), Ql;
  }
  function fc(ql) {
    if (!ql || !ql.state)
      return Ta;
    var Vl = ql.state;
    return Vl.window && (Vl.window = null), ql.state = null, ya;
  }
  function lc(ql, Vl) {
    var Pl;
    return !ql || !ql.state || (Pl = ql.state, (Pl.wrap & 2) === 0) ? Ta : (Pl.head = Vl, Vl.done = !1, ya);
  }
  function Gl(ql, Vl) {
    var Pl = Vl.length, Ol, cc, bl;
    return !ql || !ql.state || (Ol = ql.state, Ol.wrap !== 0 && Ol.mode !== cl) ? Ta : Ol.mode === cl && (cc = 1, cc = zn(cc, Vl, Pl, 0), cc !== Ol.check) ? Sa : (bl = Ec(ql, Vl, Pl, Pl), bl ? (Ol.mode = Tl, Ma) : (Ol.havedict = 1, ya));
  }
  return inflate.inflateReset = tc, inflate.inflateReset2 = nc, inflate.inflateResetKeep = Ll, inflate.inflateInit = _c, inflate.inflateInit2 = uc, inflate.inflate = Hl, inflate.inflateEnd = fc, inflate.inflateGetHeader = lc, inflate.inflateSetDictionary = Gl, inflate.inflateInfo = "pako inflate (from Nodeca project)", inflate;
}
var constants, hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, constants = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), constants;
}
var gzheader, hasRequiredGzheader;
function requireGzheader() {
  if (hasRequiredGzheader) return gzheader;
  hasRequiredGzheader = 1;
  function Xn() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return gzheader = Xn, gzheader;
}
var hasRequiredInflate;
function requireInflate() {
  if (hasRequiredInflate) return inflate$1;
  hasRequiredInflate = 1;
  var Xn = requireInflate$1(), zn = requireCommon(), Un = requireStrings(), Kn = requireConstants(), qn = requireMessages(), Jo = requireZstream(), pa = requireGzheader(), ma = Object.prototype.toString;
  function va(ya) {
    if (!(this instanceof va)) return new va(ya);
    this.options = zn.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, ya || {});
    var xa = this.options;
    xa.raw && xa.windowBits >= 0 && xa.windowBits < 16 && (xa.windowBits = -xa.windowBits, xa.windowBits === 0 && (xa.windowBits = -15)), xa.windowBits >= 0 && xa.windowBits < 16 && !(ya && ya.windowBits) && (xa.windowBits += 32), xa.windowBits > 15 && xa.windowBits < 48 && (xa.windowBits & 15) === 0 && (xa.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Jo(), this.strm.avail_out = 0;
    var wa = Xn.inflateInit2(
      this.strm,
      xa.windowBits
    );
    if (wa !== Kn.Z_OK)
      throw new Error(qn[wa]);
    if (this.header = new pa(), Xn.inflateGetHeader(this.strm, this.header), xa.dictionary && (typeof xa.dictionary == "string" ? xa.dictionary = Un.string2buf(xa.dictionary) : ma.call(xa.dictionary) === "[object ArrayBuffer]" && (xa.dictionary = new Uint8Array(xa.dictionary)), xa.raw && (wa = Xn.inflateSetDictionary(this.strm, xa.dictionary), wa !== Kn.Z_OK)))
      throw new Error(qn[wa]);
  }
  va.prototype.push = function(ya, xa) {
    var wa = this.strm, Ta = this.options.chunkSize, Sa = this.options.dictionary, Ma, ka, Za, Na, Ka, Ja = !1;
    if (this.ended)
      return !1;
    ka = xa === ~~xa ? xa : xa === !0 ? Kn.Z_FINISH : Kn.Z_NO_FLUSH, typeof ya == "string" ? wa.input = Un.binstring2buf(ya) : ma.call(ya) === "[object ArrayBuffer]" ? wa.input = new Uint8Array(ya) : wa.input = ya, wa.next_in = 0, wa.avail_in = wa.input.length;
    do {
      if (wa.avail_out === 0 && (wa.output = new zn.Buf8(Ta), wa.next_out = 0, wa.avail_out = Ta), Ma = Xn.inflate(wa, Kn.Z_NO_FLUSH), Ma === Kn.Z_NEED_DICT && Sa && (Ma = Xn.inflateSetDictionary(this.strm, Sa)), Ma === Kn.Z_BUF_ERROR && Ja === !0 && (Ma = Kn.Z_OK, Ja = !1), Ma !== Kn.Z_STREAM_END && Ma !== Kn.Z_OK)
        return this.onEnd(Ma), this.ended = !0, !1;
      wa.next_out && (wa.avail_out === 0 || Ma === Kn.Z_STREAM_END || wa.avail_in === 0 && (ka === Kn.Z_FINISH || ka === Kn.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (Za = Un.utf8border(wa.output, wa.next_out), Na = wa.next_out - Za, Ka = Un.buf2string(wa.output, Za), wa.next_out = Na, wa.avail_out = Ta - Na, Na && zn.arraySet(wa.output, wa.output, Za, Na, 0), this.onData(Ka)) : this.onData(zn.shrinkBuf(wa.output, wa.next_out))), wa.avail_in === 0 && wa.avail_out === 0 && (Ja = !0);
    } while ((wa.avail_in > 0 || wa.avail_out === 0) && Ma !== Kn.Z_STREAM_END);
    return Ma === Kn.Z_STREAM_END && (ka = Kn.Z_FINISH), ka === Kn.Z_FINISH ? (Ma = Xn.inflateEnd(this.strm), this.onEnd(Ma), this.ended = !0, Ma === Kn.Z_OK) : (ka === Kn.Z_SYNC_FLUSH && (this.onEnd(Kn.Z_OK), wa.avail_out = 0), !0);
  }, va.prototype.onData = function(ya) {
    this.chunks.push(ya);
  }, va.prototype.onEnd = function(ya) {
    ya === Kn.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = zn.flattenChunks(this.chunks)), this.chunks = [], this.err = ya, this.msg = this.strm.msg;
  };
  function ba(ya, xa) {
    var wa = new va(xa);
    if (wa.push(ya, !0), wa.err)
      throw wa.msg || qn[wa.err];
    return wa.result;
  }
  function _a(ya, xa) {
    return xa = xa || {}, xa.raw = !0, ba(ya, xa);
  }
  return inflate$1.Inflate = va, inflate$1.inflate = ba, inflate$1.inflateRaw = _a, inflate$1.ungzip = ba, inflate$1;
}
var pako_1, hasRequiredPako;
function requirePako() {
  if (hasRequiredPako) return pako_1;
  hasRequiredPako = 1;
  var Xn = requireCommon().assign, zn = requireDeflate(), Un = requireInflate(), Kn = requireConstants(), qn = {};
  return Xn(qn, zn, Un, Kn), pako_1 = qn, pako_1;
}
var pakoExports = requirePako();
const pako$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(pakoExports);
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", lookup = new Uint8Array(256);
for (var i = 0; i < chars.length; i++)
  lookup[chars.charCodeAt(i)] = i;
var decodeFromBase64 = function(Xn) {
  var zn = Xn.length * 0.75, Un = Xn.length, Kn, qn = 0, Jo, pa, ma, va;
  Xn[Xn.length - 1] === "=" && (zn--, Xn[Xn.length - 2] === "=" && zn--);
  var ba = new Uint8Array(zn);
  for (Kn = 0; Kn < Un; Kn += 4)
    Jo = lookup[Xn.charCodeAt(Kn)], pa = lookup[Xn.charCodeAt(Kn + 1)], ma = lookup[Xn.charCodeAt(Kn + 2)], va = lookup[Xn.charCodeAt(Kn + 3)], ba[qn++] = Jo << 2 | pa >> 4, ba[qn++] = (pa & 15) << 4 | ma >> 2, ba[qn++] = (ma & 3) << 6 | va & 63;
  return ba;
}, arrayToString = function(Xn) {
  for (var zn = "", Un = 0; Un < Xn.length; Un++)
    zn += String.fromCharCode(Xn[Un]);
  return zn;
}, decompressJson = function(Xn) {
  return arrayToString(pako$1.inflate(decodeFromBase64(Xn)));
}, padStart = function(Xn, zn, Un) {
  for (var Kn = "", qn = 0, Jo = zn - Xn.length; qn < Jo; qn++)
    Kn += Un;
  return Kn + Xn;
};
const CourierBoldCompressed = "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", CourierBoldObliqueCompressed = "eJyFWdtyGjkQ/RVqnnarcAo7vuE3jEnCxgEvGDtxKg9iRgxaa0ZEF9s4lX/fnrGdTVZ9lBcKTmvU96PW8C0bmqqStc9OsqsPwYlSdnaPDvb6naP+3v5+1s3emNpPRCVpwdAEq6TdOTW6mC61+hpksyBo/euCTrOg89MKUSm9/XUNwddSletGcbOcfo+90Cof1KWmdTu7e4S4N+pBFhfK5+vsxNsgu9lwLazIvbRz2Tw7evCyLmQxM5Won809PTUP2cnnnYOj7s7eQa97fNjvHvd2v3SzBS21WtXywjjllakbRb3eT4LLtcpva+lcdkJPZlfSunZZ1uu9ftXr9UjFxHiVP7my2drGh84f+Z+d3f5xv0uf/V77udt+vm4/jzqDwixlZ751XlauM65zYzfGCi+LV53OQOvOrNnHdWbSSXtHKOkZ0apC1eU8X8s2dO0mcy/qQtjiRUoLh2Lz7jmWB4cUto8vv/Zf97vZwOVNhGx2crhHP8/kj987uxShbO6Ld9fZyfF++/WKvu72Dp/i/EF6q3IKxedv2fVH2qAJ1YQscRtBEfje/R8sH3Itqhj/Ggx5utSxpA7VsglxWceywmgtbIxvpM2bio0EoiKRo/AAC9pcMfsJK2stV0gEHhOu2dHdMk/p4GI0p0YTMbzebtaS8Z5cUYbxxGnh1jH8KK2JUVMzWfL3zEq/tpJZu6JuZVB1x6x16oEB5R3nneRjWivO4Nxow+zhZKWASDcNHCv9GgRTg6WV1IiMm8ReriWJOPeM7YMYOo2hYQydxdAoht7E0NsYehdD4xj6K4bex9B5DH2IoUkMTWPoIob+jqFZDM1j6DKGFjF0FUPXMfQxhj7F0E0MLekQupWep40lyUCfPj8HOSVXKlc2DwyLhoa1HZ0cTIu0/MYbw3DOkukxhn+ZDmK4gGkohuViSMXQPzHE0CvTwky0mK5laG/DhDKGGG5g6IWJfYihuxi6jyGGSbcM6fP1BQphyR2m7fpUNXqlC3jUF+aeiTN/OjfHpW4GlriEmoGO5dktd3astLGKPQ/ALnmwdIznTADbtnGqHTnh1MJHswyKJJUBFNCI241/IwahXzHdsWIKnyY5lmYKUZbckfaEs6PY08DR5E5ayfQ+zUKitGLDkRpdASTjxX/hXQqXiHBaCkL0IwFALrVWG6eYRiVP/doENCk+Hfp8aVMAuNFH5MFzg0vL5CstmXYGfVWJ3HI1vLSSU1wYL3K+3wq6ZUnWf8t2YS4LCig3oYa6FDZUWgRGjSlpyGRYOhesH7LiC3bAjDzGFiua8fih8BwcsFOE8woqIrmgWQ2Cj3czWzLdqYFeg3Bmd2pNusVSyTNJG+N8SlB+AhRNSGdUgtR9whYU6k5x1fwJWDZIdYYADy1SD23BQ669dqEekaktF3yfLHAYBGqGBbAuoAdGWMkZEQR3/0g6mr+8qmBUIcrJQR0IPi6TpAEa1Shg1MvkbkO0G2DVUYInHXDTQUJUQLs2j7IuGcEMqHibdDIkmyQlHKCUWmBIDn29SUTucm0ss9kUaZ+BuM0BXgBrF0hB4CuzfbfhQjvgMDPRFJTgAOGAVqugvdpoZswMwMFL4CCNWl4JXagVc7vaYmqYAD0qVSyjZJklTh0syoEdNaJBlNAJCNAYbNS8eaOBgXv9trTmVtbsHcjKUjkw9b4FyR6nGCVQV/NXkRGoKQscMigyN+CBGxCx55dc4BXYyDMTyhCSgk7ylkejHzwdkWCAxodEVYIAP6LWQLqnKCPo6EGZckgzdmKaHEuAh2dSeyZXnidpf28SjIhNq5hXGgpYZNJz5giFvgATTsvjVMCWCpkxbZ6oV74i3yfr+BwkzltRyEpYxnKZYIUxiNIYFc45sJqCthaaORmamwlocJOqqBpMTYvf5A/ERyKHSsCl5NBzVrmk8kGYJ1M3TVteEEtw/3YYkKIhMCJANi9UzqXhDGxkk95MQH4MwGfpsk5KB2DPAeRofuaagn0eEx0yQqc90n2bdAUMAuNkKwATfPpyY8om37Xh3o9gLg1YRFuhf6vSF1ruIH8ETtXJrSjk+IRQqMdHofkf8ks3ey9tfSGUbf49/vL9XxrnGMA=", CourierObliqueCompressed = "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", CourierCompressed = "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", HelveticaBoldCompressed = /* @__PURE__ */ JSON.parse('"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"'), HelveticaBoldObliqueCompressed = /* @__PURE__ */ JSON.parse('"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"'), HelveticaObliqueCompressed = /* @__PURE__ */ JSON.parse('"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"'), HelveticaCompressed = /* @__PURE__ */ JSON.parse('"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"'), TimesBoldCompressed = /* @__PURE__ */ JSON.parse('"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"'), TimesBoldItalicCompressed = /* @__PURE__ */ JSON.parse('"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"'), TimesItalicCompressed = /* @__PURE__ */ JSON.parse('"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"'), TimesRomanCompressed = /* @__PURE__ */ JSON.parse('"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"'), SymbolCompressed = "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", ZapfDingbatsCompressed = "eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==";
var compressedJsonForFontName = {
  Courier: CourierCompressed,
  "Courier-Bold": CourierBoldCompressed,
  "Courier-Oblique": CourierObliqueCompressed,
  "Courier-BoldOblique": CourierBoldObliqueCompressed,
  Helvetica: HelveticaCompressed,
  "Helvetica-Bold": HelveticaBoldCompressed,
  "Helvetica-Oblique": HelveticaObliqueCompressed,
  "Helvetica-BoldOblique": HelveticaBoldObliqueCompressed,
  "Times-Roman": TimesRomanCompressed,
  "Times-Bold": TimesBoldCompressed,
  "Times-Italic": TimesItalicCompressed,
  "Times-BoldItalic": TimesBoldItalicCompressed,
  Symbol: SymbolCompressed,
  ZapfDingbats: ZapfDingbatsCompressed
}, FontNames;
(function(Xn) {
  Xn.Courier = "Courier", Xn.CourierBold = "Courier-Bold", Xn.CourierOblique = "Courier-Oblique", Xn.CourierBoldOblique = "Courier-BoldOblique", Xn.Helvetica = "Helvetica", Xn.HelveticaBold = "Helvetica-Bold", Xn.HelveticaOblique = "Helvetica-Oblique", Xn.HelveticaBoldOblique = "Helvetica-BoldOblique", Xn.TimesRoman = "Times-Roman", Xn.TimesRomanBold = "Times-Bold", Xn.TimesRomanItalic = "Times-Italic", Xn.TimesRomanBoldItalic = "Times-BoldItalic", Xn.Symbol = "Symbol", Xn.ZapfDingbats = "ZapfDingbats";
})(FontNames || (FontNames = {}));
var fontCache = {}, Font = (
  /** @class */
  function() {
    function Xn() {
      var zn = this;
      this.getWidthOfGlyph = function(Un) {
        return zn.CharWidths[Un];
      }, this.getXAxisKerningForPair = function(Un, Kn) {
        return (zn.KernPairXAmounts[Un] || {})[Kn];
      };
    }
    return Xn.load = function(zn) {
      var Un = fontCache[zn];
      if (Un)
        return Un;
      var Kn = decompressJson(compressedJsonForFontName[zn]), qn = Object.assign(new Xn(), JSON.parse(Kn));
      return qn.CharWidths = qn.CharMetrics.reduce(function(Jo, pa) {
        return Jo[pa.N] = pa.WX, Jo;
      }, {}), qn.KernPairXAmounts = qn.KernPairs.reduce(function(Jo, pa) {
        var ma = pa[0], va = pa[1], ba = pa[2];
        return Jo[ma] || (Jo[ma] = {}), Jo[ma][va] = ba, Jo;
      }, {}), fontCache[zn] = qn, qn;
    }, Xn;
  }()
);
const AllEncodingsCompressed = "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";
var decompressedEncodings = decompressJson(AllEncodingsCompressed), allUnicodeMappings = JSON.parse(decompressedEncodings), Encoding = (
  /** @class */
  /* @__PURE__ */ function() {
    function Xn(zn, Un) {
      var Kn = this;
      this.canEncodeUnicodeCodePoint = function(qn) {
        return qn in Kn.unicodeMappings;
      }, this.encodeUnicodeCodePoint = function(qn) {
        var Jo = Kn.unicodeMappings[qn];
        if (!Jo) {
          var pa = String.fromCharCode(qn), ma = "0x" + padStart(qn.toString(16), 4, "0"), va = Kn.name + ' cannot encode "' + pa + '" (' + ma + ")";
          throw new Error(va);
        }
        return { code: Jo[0], name: Jo[1] };
      }, this.name = zn, this.supportedCodePoints = Object.keys(Un).map(Number).sort(function(qn, Jo) {
        return qn - Jo;
      }), this.unicodeMappings = Un;
    }
    return Xn;
  }()
), Encodings = {
  Symbol: new Encoding("Symbol", allUnicodeMappings.symbol),
  ZapfDingbats: new Encoding("ZapfDingbats", allUnicodeMappings.zapfdingbats),
  WinAnsi: new Encoding("WinAnsi", allUnicodeMappings.win1252)
}, values = function(Xn) {
  return Object.keys(Xn).map(function(zn) {
    return Xn[zn];
  });
}, StandardFontValues = values(FontNames), isStandardFont = function(Xn) {
  return StandardFontValues.includes(Xn);
}, rectanglesAreEqual = function(Xn, zn) {
  return Xn.x === zn.x && Xn.y === zn.y && Xn.width === zn.width && Xn.height === zn.height;
}, backtick = function(Xn) {
  return "`" + Xn + "`";
}, singleQuote = function(Xn) {
  return "'" + Xn + "'";
}, formatValue = function(Xn) {
  var zn = typeof Xn;
  return zn === "string" ? singleQuote(Xn) : zn === "undefined" ? backtick(Xn) : Xn;
}, createValueErrorMsg = function(Xn, zn, Un) {
  for (var Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++) {
    var pa = Un[qn];
    Kn[qn] = formatValue(pa);
  }
  var ma = Kn.join(" or ");
  return backtick(zn) + " must be one of " + ma + ", but was actually " + formatValue(Xn);
}, assertIsOneOf = function(Xn, zn, Un) {
  Array.isArray(Un) || (Un = values(Un));
  for (var Kn = 0, qn = Un.length; Kn < qn; Kn++)
    if (Xn === Un[Kn])
      return;
  throw new TypeError(createValueErrorMsg(Xn, zn, Un));
}, assertIsOneOfOrUndefined = function(Xn, zn, Un) {
  Array.isArray(Un) || (Un = values(Un)), assertIsOneOf(Xn, zn, Un.concat(void 0));
}, assertIsSubset = function(Xn, zn, Un) {
  Array.isArray(Un) || (Un = values(Un));
  for (var Kn = 0, qn = Xn.length; Kn < qn; Kn++)
    assertIsOneOf(Xn[Kn], zn, Un);
}, getType = function(Xn) {
  return Xn === null ? "null" : Xn === void 0 ? "undefined" : typeof Xn == "string" ? "string" : isNaN(Xn) ? "NaN" : typeof Xn == "number" ? "number" : typeof Xn == "boolean" ? "boolean" : typeof Xn == "symbol" ? "symbol" : typeof Xn == "bigint" ? "bigint" : Xn.constructor && Xn.constructor.name ? Xn.constructor.name : Xn.name ? Xn.name : Xn.constructor ? String(Xn.constructor) : String(Xn);
}, isType = function(Xn, zn) {
  return zn === "null" ? Xn === null : zn === "undefined" ? Xn === void 0 : zn === "string" ? typeof Xn == "string" : zn === "number" ? typeof Xn == "number" && !isNaN(Xn) : zn === "boolean" ? typeof Xn == "boolean" : zn === "symbol" ? typeof Xn == "symbol" : zn === "bigint" ? typeof Xn == "bigint" : zn === Date ? Xn instanceof Date : zn === Array ? Xn instanceof Array : zn === Uint8Array ? Xn instanceof Uint8Array : zn === ArrayBuffer ? Xn instanceof ArrayBuffer : zn === Function ? Xn instanceof Function : Xn instanceof zn[0];
}, createTypeErrorMsg = function(Xn, zn, Un) {
  for (var Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++) {
    var pa = Un[qn];
    pa === "null" && (Kn[qn] = backtick("null")), pa === "undefined" && (Kn[qn] = backtick("undefined")), pa === "string" ? Kn[qn] = backtick("string") : pa === "number" ? Kn[qn] = backtick("number") : pa === "boolean" ? Kn[qn] = backtick("boolean") : pa === "symbol" ? Kn[qn] = backtick("symbol") : pa === "bigint" ? Kn[qn] = backtick("bigint") : pa === Array ? Kn[qn] = backtick("Array") : pa === Uint8Array ? Kn[qn] = backtick("Uint8Array") : pa === ArrayBuffer ? Kn[qn] = backtick("ArrayBuffer") : Kn[qn] = backtick(pa[1]);
  }
  var ma = Kn.join(" or ");
  return backtick(zn) + " must be of type " + ma + ", but was actually of type " + backtick(getType(Xn));
}, assertIs = function(Xn, zn, Un) {
  for (var Kn = 0, qn = Un.length; Kn < qn; Kn++)
    if (isType(Xn, Un[Kn]))
      return;
  throw new TypeError(createTypeErrorMsg(Xn, zn, Un));
}, assertOrUndefined = function(Xn, zn, Un) {
  assertIs(Xn, zn, Un.concat("undefined"));
}, assertEachIs = function(Xn, zn, Un) {
  for (var Kn = 0, qn = Xn.length; Kn < qn; Kn++)
    assertIs(Xn[Kn], zn, Un);
}, assertRange = function(Xn, zn, Un, Kn) {
  if (assertIs(Xn, zn, ["number"]), assertIs(Un, "min", ["number"]), assertIs(Kn, "max", ["number"]), Kn = Math.max(Un, Kn), Xn < Un || Xn > Kn)
    throw new Error(backtick(zn) + " must be at least " + Un + " and at most " + Kn + ", but was actually " + Xn);
}, assertRangeOrUndefined = function(Xn, zn, Un, Kn) {
  assertIs(Xn, zn, ["number", "undefined"]), typeof Xn == "number" && assertRange(Xn, zn, Un, Kn);
}, assertMultiple = function(Xn, zn, Un) {
  if (assertIs(Xn, zn, ["number"]), Xn % Un !== 0)
    throw new Error(backtick(zn) + " must be a multiple of " + Un + ", but was actually " + Xn);
}, assertInteger = function(Xn, zn) {
  if (!Number.isInteger(Xn))
    throw new Error(backtick(zn) + " must be an integer, but was actually " + Xn);
}, assertPositive = function(Xn, zn) {
  if (![1, 0].includes(Math.sign(Xn)))
    throw new Error(backtick(zn) + " must be a positive number or 0, but was actually " + Xn);
}, pdfDocEncodingToUnicode = new Uint16Array(256);
for (var idx$2 = 0; idx$2 < 256; idx$2++)
  pdfDocEncodingToUnicode[idx$2] = idx$2;
pdfDocEncodingToUnicode[22] = toCharCode("");
pdfDocEncodingToUnicode[24] = toCharCode("˘");
pdfDocEncodingToUnicode[25] = toCharCode("ˇ");
pdfDocEncodingToUnicode[26] = toCharCode("ˆ");
pdfDocEncodingToUnicode[27] = toCharCode("˙");
pdfDocEncodingToUnicode[28] = toCharCode("˝");
pdfDocEncodingToUnicode[29] = toCharCode("˛");
pdfDocEncodingToUnicode[30] = toCharCode("˚");
pdfDocEncodingToUnicode[31] = toCharCode("˜");
pdfDocEncodingToUnicode[127] = toCharCode("�");
pdfDocEncodingToUnicode[128] = toCharCode("•");
pdfDocEncodingToUnicode[129] = toCharCode("†");
pdfDocEncodingToUnicode[130] = toCharCode("‡");
pdfDocEncodingToUnicode[131] = toCharCode("…");
pdfDocEncodingToUnicode[132] = toCharCode("—");
pdfDocEncodingToUnicode[133] = toCharCode("–");
pdfDocEncodingToUnicode[134] = toCharCode("ƒ");
pdfDocEncodingToUnicode[135] = toCharCode("⁄");
pdfDocEncodingToUnicode[136] = toCharCode("‹");
pdfDocEncodingToUnicode[137] = toCharCode("›");
pdfDocEncodingToUnicode[138] = toCharCode("−");
pdfDocEncodingToUnicode[139] = toCharCode("‰");
pdfDocEncodingToUnicode[140] = toCharCode("„");
pdfDocEncodingToUnicode[141] = toCharCode("“");
pdfDocEncodingToUnicode[142] = toCharCode("”");
pdfDocEncodingToUnicode[143] = toCharCode("‘");
pdfDocEncodingToUnicode[144] = toCharCode("’");
pdfDocEncodingToUnicode[145] = toCharCode("‚");
pdfDocEncodingToUnicode[146] = toCharCode("™");
pdfDocEncodingToUnicode[147] = toCharCode("ﬁ");
pdfDocEncodingToUnicode[148] = toCharCode("ﬂ");
pdfDocEncodingToUnicode[149] = toCharCode("Ł");
pdfDocEncodingToUnicode[150] = toCharCode("Œ");
pdfDocEncodingToUnicode[151] = toCharCode("Š");
pdfDocEncodingToUnicode[152] = toCharCode("Ÿ");
pdfDocEncodingToUnicode[153] = toCharCode("Ž");
pdfDocEncodingToUnicode[154] = toCharCode("ı");
pdfDocEncodingToUnicode[155] = toCharCode("ł");
pdfDocEncodingToUnicode[156] = toCharCode("œ");
pdfDocEncodingToUnicode[157] = toCharCode("š");
pdfDocEncodingToUnicode[158] = toCharCode("ž");
pdfDocEncodingToUnicode[159] = toCharCode("�");
pdfDocEncodingToUnicode[160] = toCharCode("€");
pdfDocEncodingToUnicode[173] = toCharCode("�");
var pdfDocEncodingDecode = function(Xn) {
  for (var zn = new Array(Xn.length), Un = 0, Kn = Xn.length; Un < Kn; Un++)
    zn[Un] = pdfDocEncodingToUnicode[Xn[Un]];
  return String.fromCodePoint.apply(String, zn);
}, Cache = (
  /** @class */
  function() {
    function Xn(zn) {
      this.populate = zn, this.value = void 0;
    }
    return Xn.prototype.getValue = function() {
      return this.value;
    }, Xn.prototype.access = function() {
      return this.value || (this.value = this.populate()), this.value;
    }, Xn.prototype.invalidate = function() {
      this.value = void 0;
    }, Xn.populatedBy = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), MethodNotImplementedError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Method " + Un + "." + Kn + "() not implemented";
      return qn = Xn.call(this, Jo) || this, qn;
    }
    return zn;
  }(Error)
), PrivateConstructorError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "Cannot construct " + Un + " - it has a private constructor";
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), UnexpectedObjectTypeError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = function(va) {
        var ba, _a;
        return (ba = va == null ? void 0 : va.name) !== null && ba !== void 0 ? ba : (_a = va == null ? void 0 : va.constructor) === null || _a === void 0 ? void 0 : _a.name;
      }, pa = Array.isArray(Un) ? Un.map(Jo) : [Jo(Un)], ma = "Expected instance of " + pa.join(" or ") + ", " + ("but got instance of " + (Kn && Jo(Kn)));
      return qn = Xn.call(this, ma) || this, qn;
    }
    return zn;
  }(Error)
), UnsupportedEncodingError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = Un + " stream encoding not supported";
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), ReparseError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Cannot call " + Un + "." + Kn + "() more than once";
      return qn = Xn.call(this, Jo) || this, qn;
    }
    return zn;
  }(Error)
);
(function(Xn) {
  __extends(zn, Xn);
  function zn(Un) {
    var Kn = this, qn = "Missing catalog (ref=" + Un + ")";
    return Kn = Xn.call(this, qn) || this, Kn;
  }
  return zn;
})(Error);
var MissingPageContentsEmbeddingError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "Can't embed page with missing Contents";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), UnrecognizedStreamTypeError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn, qn, Jo, pa = this, ma = (Jo = (qn = (Kn = Un == null ? void 0 : Un.contructor) === null || Kn === void 0 ? void 0 : Kn.name) !== null && qn !== void 0 ? qn : Un == null ? void 0 : Un.name) !== null && Jo !== void 0 ? Jo : Un, va = "Unrecognized stream type: " + ma;
      return pa = Xn.call(this, va) || this, pa;
    }
    return zn;
  }(Error)
), PageEmbeddingMismatchedContextError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), PDFArrayIsNotRectangleError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "Attempted to convert PDFArray with " + Un + " elements to rectangle, but must have exactly 4 elements.";
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), InvalidPDFDateStringError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = 'Attempted to convert "' + Un + '" to a date, but it does not match the PDF date string format.';
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), InvalidTargetIndexError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Invalid targetIndex specified: targetIndex=" + Un + " must be less than Count=" + Kn;
      return qn = Xn.call(this, Jo) || this, qn;
    }
    return zn;
  }(Error)
), CorruptPageTreeError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Failed to " + Kn + " at targetIndex=" + Un + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
      return qn = Xn.call(this, Jo) || this, qn;
    }
    return zn;
  }(Error)
), IndexOutOfBoundsError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = this, pa = "index should be at least " + Kn + " and at most " + qn + ", but was actually " + Un;
      return Jo = Xn.call(this, pa) || this, Jo;
    }
    return zn;
  }(Error)
), InvalidAcroFieldValueError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "Attempted to set invalid field value";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), MultiSelectValueError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "Attempted to select multiple values for single-select field";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), MissingDAEntryError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "No /DA (default appearance) entry found for field: " + Un;
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), MissingTfOperatorError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "No Tf operator found for DA of field: " + Un;
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), NumberParsingError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Failed to parse number " + ("(line:" + Un.line + " col:" + Un.column + " offset=" + Un.offset + '): "' + Kn + '"');
      return qn = Xn.call(this, Jo) || this, qn;
    }
    return zn;
  }(Error)
), PDFParsingError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Failed to parse PDF document " + ("(line:" + Un.line + " col:" + Un.column + " offset=" + Un.offset + "): " + Kn);
      return qn = Xn.call(this, Jo) || this, qn;
    }
    return zn;
  }(Error)
), NextByteAssertionError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = this, pa = "Expected next byte to be " + Kn + " but it was actually " + qn;
      return Jo = Xn.call(this, Un, pa) || this, Jo;
    }
    return zn;
  }(PDFParsingError)
), PDFObjectParsingError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Failed to parse PDF object starting with the following byte: " + Kn;
      return qn = Xn.call(this, Un, Jo) || this, qn;
    }
    return zn;
  }(PDFParsingError)
), PDFInvalidObjectParsingError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "Failed to parse invalid PDF object";
      return Kn = Xn.call(this, Un, qn) || this, Kn;
    }
    return zn;
  }(PDFParsingError)
), PDFStreamParsingError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "Failed to parse PDF stream";
      return Kn = Xn.call(this, Un, qn) || this, Kn;
    }
    return zn;
  }(PDFParsingError)
), UnbalancedParenthesisError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "Failed to parse PDF literal string due to unbalanced parenthesis";
      return Kn = Xn.call(this, Un, qn) || this, Kn;
    }
    return zn;
  }(PDFParsingError)
), StalledParserError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "Parser stalled";
      return Kn = Xn.call(this, Un, qn) || this, Kn;
    }
    return zn;
  }(PDFParsingError)
), MissingPDFHeaderError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "No PDF header found";
      return Kn = Xn.call(this, Un, qn) || this, Kn;
    }
    return zn;
  }(PDFParsingError)
), MissingKeywordError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Did not find expected keyword '" + arrayAsString(Kn) + "'";
      return qn = Xn.call(this, Un, Jo) || this, qn;
    }
    return zn;
  }(PDFParsingError)
), CharCodes;
(function(Xn) {
  Xn[Xn.Null = 0] = "Null", Xn[Xn.Backspace = 8] = "Backspace", Xn[Xn.Tab = 9] = "Tab", Xn[Xn.Newline = 10] = "Newline", Xn[Xn.FormFeed = 12] = "FormFeed", Xn[Xn.CarriageReturn = 13] = "CarriageReturn", Xn[Xn.Space = 32] = "Space", Xn[Xn.ExclamationPoint = 33] = "ExclamationPoint", Xn[Xn.Hash = 35] = "Hash", Xn[Xn.Percent = 37] = "Percent", Xn[Xn.LeftParen = 40] = "LeftParen", Xn[Xn.RightParen = 41] = "RightParen", Xn[Xn.Plus = 43] = "Plus", Xn[Xn.Minus = 45] = "Minus", Xn[Xn.Dash = 45] = "Dash", Xn[Xn.Period = 46] = "Period", Xn[Xn.ForwardSlash = 47] = "ForwardSlash", Xn[Xn.Zero = 48] = "Zero", Xn[Xn.One = 49] = "One", Xn[Xn.Two = 50] = "Two", Xn[Xn.Three = 51] = "Three", Xn[Xn.Four = 52] = "Four", Xn[Xn.Five = 53] = "Five", Xn[Xn.Six = 54] = "Six", Xn[Xn.Seven = 55] = "Seven", Xn[Xn.Eight = 56] = "Eight", Xn[Xn.Nine = 57] = "Nine", Xn[Xn.LessThan = 60] = "LessThan", Xn[Xn.GreaterThan = 62] = "GreaterThan", Xn[Xn.A = 65] = "A", Xn[Xn.D = 68] = "D", Xn[Xn.E = 69] = "E", Xn[Xn.F = 70] = "F", Xn[Xn.O = 79] = "O", Xn[Xn.P = 80] = "P", Xn[Xn.R = 82] = "R", Xn[Xn.LeftSquareBracket = 91] = "LeftSquareBracket", Xn[Xn.BackSlash = 92] = "BackSlash", Xn[Xn.RightSquareBracket = 93] = "RightSquareBracket", Xn[Xn.a = 97] = "a", Xn[Xn.b = 98] = "b", Xn[Xn.d = 100] = "d", Xn[Xn.e = 101] = "e", Xn[Xn.f = 102] = "f", Xn[Xn.i = 105] = "i", Xn[Xn.j = 106] = "j", Xn[Xn.l = 108] = "l", Xn[Xn.m = 109] = "m", Xn[Xn.n = 110] = "n", Xn[Xn.o = 111] = "o", Xn[Xn.r = 114] = "r", Xn[Xn.s = 115] = "s", Xn[Xn.t = 116] = "t", Xn[Xn.u = 117] = "u", Xn[Xn.x = 120] = "x", Xn[Xn.LeftCurly = 123] = "LeftCurly", Xn[Xn.RightCurly = 125] = "RightCurly", Xn[Xn.Tilde = 126] = "Tilde";
})(CharCodes || (CharCodes = {}));
const CharCodes$1 = CharCodes;
var PDFHeader = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      this.major = String(zn), this.minor = String(Un);
    }
    return Xn.prototype.toString = function() {
      var zn = charFromCode(129);
      return "%PDF-" + this.major + "." + this.minor + `
%` + zn + zn + zn + zn;
    }, Xn.prototype.sizeInBytes = function() {
      return 12 + this.major.length + this.minor.length;
    }, Xn.prototype.copyBytesInto = function(zn, Un) {
      var Kn = Un;
      return zn[Un++] = CharCodes$1.Percent, zn[Un++] = CharCodes$1.P, zn[Un++] = CharCodes$1.D, zn[Un++] = CharCodes$1.F, zn[Un++] = CharCodes$1.Dash, Un += copyStringIntoBuffer(this.major, zn, Un), zn[Un++] = CharCodes$1.Period, Un += copyStringIntoBuffer(this.minor, zn, Un), zn[Un++] = CharCodes$1.Newline, zn[Un++] = CharCodes$1.Percent, zn[Un++] = 129, zn[Un++] = 129, zn[Un++] = 129, zn[Un++] = 129, Un - Kn;
    }, Xn.forVersion = function(zn, Un) {
      return new Xn(zn, Un);
    }, Xn;
  }()
), PDFObject = (
  /** @class */
  function() {
    function Xn() {
    }
    return Xn.prototype.clone = function(zn) {
      throw new MethodNotImplementedError(this.constructor.name, "clone");
    }, Xn.prototype.toString = function() {
      throw new MethodNotImplementedError(this.constructor.name, "toString");
    }, Xn.prototype.sizeInBytes = function() {
      throw new MethodNotImplementedError(this.constructor.name, "sizeInBytes");
    }, Xn.prototype.copyBytesInto = function(zn, Un) {
      throw new MethodNotImplementedError(this.constructor.name, "copyBytesInto");
    }, Xn;
  }()
), PDFNumber = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = Xn.call(this) || this;
      return Kn.numberValue = Un, Kn.stringValue = numberToString(Un), Kn;
    }
    return zn.prototype.asNumber = function() {
      return this.numberValue;
    }, zn.prototype.value = function() {
      return this.numberValue;
    }, zn.prototype.clone = function() {
      return zn.of(this.numberValue);
    }, zn.prototype.toString = function() {
      return this.stringValue;
    }, zn.prototype.sizeInBytes = function() {
      return this.stringValue.length;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      return Kn += copyStringIntoBuffer(this.stringValue, Un, Kn), this.stringValue.length;
    }, zn.of = function(Un) {
      return new zn(Un);
    }, zn;
  }(PDFObject)
), PDFArray = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = Xn.call(this) || this;
      return Kn.array = [], Kn.context = Un, Kn;
    }
    return zn.prototype.size = function() {
      return this.array.length;
    }, zn.prototype.push = function(Un) {
      this.array.push(Un);
    }, zn.prototype.insert = function(Un, Kn) {
      this.array.splice(Un, 0, Kn);
    }, zn.prototype.indexOf = function(Un) {
      var Kn = this.array.indexOf(Un);
      return Kn === -1 ? void 0 : Kn;
    }, zn.prototype.remove = function(Un) {
      this.array.splice(Un, 1);
    }, zn.prototype.set = function(Un, Kn) {
      this.array[Un] = Kn;
    }, zn.prototype.get = function(Un) {
      return this.array[Un];
    }, zn.prototype.lookupMaybe = function(Un) {
      for (var Kn, qn = [], Jo = 1; Jo < arguments.length; Jo++)
        qn[Jo - 1] = arguments[Jo];
      return (Kn = this.context).lookupMaybe.apply(Kn, __spreadArrays([this.get(Un)], qn));
    }, zn.prototype.lookup = function(Un) {
      for (var Kn, qn = [], Jo = 1; Jo < arguments.length; Jo++)
        qn[Jo - 1] = arguments[Jo];
      return (Kn = this.context).lookup.apply(Kn, __spreadArrays([this.get(Un)], qn));
    }, zn.prototype.asRectangle = function() {
      if (this.size() !== 4)
        throw new PDFArrayIsNotRectangleError(this.size());
      var Un = this.lookup(0, PDFNumber).asNumber(), Kn = this.lookup(1, PDFNumber).asNumber(), qn = this.lookup(2, PDFNumber).asNumber(), Jo = this.lookup(3, PDFNumber).asNumber(), pa = Un, ma = Kn, va = qn - Un, ba = Jo - Kn;
      return { x: pa, y: ma, width: va, height: ba };
    }, zn.prototype.asArray = function() {
      return this.array.slice();
    }, zn.prototype.clone = function(Un) {
      for (var Kn = zn.withContext(Un || this.context), qn = 0, Jo = this.size(); qn < Jo; qn++)
        Kn.push(this.array[qn]);
      return Kn;
    }, zn.prototype.toString = function() {
      for (var Un = "[ ", Kn = 0, qn = this.size(); Kn < qn; Kn++)
        Un += this.get(Kn).toString(), Un += " ";
      return Un += "]", Un;
    }, zn.prototype.sizeInBytes = function() {
      for (var Un = 3, Kn = 0, qn = this.size(); Kn < qn; Kn++)
        Un += this.get(Kn).sizeInBytes() + 1;
      return Un;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      var qn = Kn;
      Un[Kn++] = CharCodes$1.LeftSquareBracket, Un[Kn++] = CharCodes$1.Space;
      for (var Jo = 0, pa = this.size(); Jo < pa; Jo++)
        Kn += this.get(Jo).copyBytesInto(Un, Kn), Un[Kn++] = CharCodes$1.Space;
      return Un[Kn++] = CharCodes$1.RightSquareBracket, Kn - qn;
    }, zn.prototype.scalePDFNumbers = function(Un, Kn) {
      for (var qn = 0, Jo = this.size(); qn < Jo; qn++) {
        var pa = this.lookup(qn);
        if (pa instanceof PDFNumber) {
          var ma = qn % 2 === 0 ? Un : Kn;
          this.set(qn, PDFNumber.of(pa.asNumber() * ma));
        }
      }
    }, zn.withContext = function(Un) {
      return new zn(Un);
    }, zn;
  }(PDFObject)
), ENFORCER$2 = {}, PDFBool = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this;
      if (Un !== ENFORCER$2)
        throw new PrivateConstructorError("PDFBool");
      return qn = Xn.call(this) || this, qn.value = Kn, qn;
    }
    return zn.prototype.asBoolean = function() {
      return this.value;
    }, zn.prototype.clone = function() {
      return this;
    }, zn.prototype.toString = function() {
      return String(this.value);
    }, zn.prototype.sizeInBytes = function() {
      return this.value ? 4 : 5;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      return this.value ? (Un[Kn++] = CharCodes$1.t, Un[Kn++] = CharCodes$1.r, Un[Kn++] = CharCodes$1.u, Un[Kn++] = CharCodes$1.e, 4) : (Un[Kn++] = CharCodes$1.f, Un[Kn++] = CharCodes$1.a, Un[Kn++] = CharCodes$1.l, Un[Kn++] = CharCodes$1.s, Un[Kn++] = CharCodes$1.e, 5);
    }, zn.True = new zn(ENFORCER$2, !0), zn.False = new zn(ENFORCER$2, !1), zn;
  }(PDFObject)
), IsDelimiter = new Uint8Array(256);
IsDelimiter[CharCodes$1.LeftParen] = 1;
IsDelimiter[CharCodes$1.RightParen] = 1;
IsDelimiter[CharCodes$1.LessThan] = 1;
IsDelimiter[CharCodes$1.GreaterThan] = 1;
IsDelimiter[CharCodes$1.LeftSquareBracket] = 1;
IsDelimiter[CharCodes$1.RightSquareBracket] = 1;
IsDelimiter[CharCodes$1.LeftCurly] = 1;
IsDelimiter[CharCodes$1.RightCurly] = 1;
IsDelimiter[CharCodes$1.ForwardSlash] = 1;
IsDelimiter[CharCodes$1.Percent] = 1;
var IsWhitespace = new Uint8Array(256);
IsWhitespace[CharCodes$1.Null] = 1;
IsWhitespace[CharCodes$1.Tab] = 1;
IsWhitespace[CharCodes$1.Newline] = 1;
IsWhitespace[CharCodes$1.FormFeed] = 1;
IsWhitespace[CharCodes$1.CarriageReturn] = 1;
IsWhitespace[CharCodes$1.Space] = 1;
var IsIrregular = new Uint8Array(256);
for (var idx$1 = 0, len$1 = 256; idx$1 < len$1; idx$1++)
  IsIrregular[idx$1] = IsWhitespace[idx$1] || IsDelimiter[idx$1] ? 1 : 0;
IsIrregular[CharCodes$1.Hash] = 1;
var decodeName = function(Xn) {
  return Xn.replace(/#([\dABCDEF]{2})/g, function(zn, Un) {
    return charFromHexCode(Un);
  });
}, isRegularChar = function(Xn) {
  return Xn >= CharCodes$1.ExclamationPoint && Xn <= CharCodes$1.Tilde && !IsIrregular[Xn];
}, ENFORCER$1 = {}, pool$1 = /* @__PURE__ */ new Map(), PDFName = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this;
      if (Un !== ENFORCER$1)
        throw new PrivateConstructorError("PDFName");
      qn = Xn.call(this) || this;
      for (var Jo = "/", pa = 0, ma = Kn.length; pa < ma; pa++) {
        var va = Kn[pa], ba = toCharCode(va);
        Jo += isRegularChar(ba) ? va : "#" + toHexString(ba);
      }
      return qn.encodedName = Jo, qn;
    }
    return zn.prototype.asBytes = function() {
      for (var Un = [], Kn = "", qn = !1, Jo = function(ya) {
        ya !== void 0 && Un.push(ya), qn = !1;
      }, pa = 1, ma = this.encodedName.length; pa < ma; pa++) {
        var va = this.encodedName[pa], ba = toCharCode(va), _a = this.encodedName[pa + 1];
        qn ? ba >= CharCodes$1.Zero && ba <= CharCodes$1.Nine || ba >= CharCodes$1.a && ba <= CharCodes$1.f || ba >= CharCodes$1.A && ba <= CharCodes$1.F ? (Kn += va, (Kn.length === 2 || !(_a >= "0" && _a <= "9" || _a >= "a" && _a <= "f" || _a >= "A" && _a <= "F")) && (Jo(parseInt(Kn, 16)), Kn = "")) : Jo(ba) : ba === CharCodes$1.Hash ? qn = !0 : Jo(ba);
      }
      return new Uint8Array(Un);
    }, zn.prototype.decodeText = function() {
      var Un = this.asBytes();
      return String.fromCharCode.apply(String, Array.from(Un));
    }, zn.prototype.asString = function() {
      return this.encodedName;
    }, zn.prototype.value = function() {
      return this.encodedName;
    }, zn.prototype.clone = function() {
      return this;
    }, zn.prototype.toString = function() {
      return this.encodedName;
    }, zn.prototype.sizeInBytes = function() {
      return this.encodedName.length;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      return Kn += copyStringIntoBuffer(this.encodedName, Un, Kn), this.encodedName.length;
    }, zn.of = function(Un) {
      var Kn = decodeName(Un), qn = pool$1.get(Kn);
      return qn || (qn = new zn(ENFORCER$1, Kn), pool$1.set(Kn, qn)), qn;
    }, zn.Length = zn.of("Length"), zn.FlateDecode = zn.of("FlateDecode"), zn.Resources = zn.of("Resources"), zn.Font = zn.of("Font"), zn.XObject = zn.of("XObject"), zn.ExtGState = zn.of("ExtGState"), zn.Contents = zn.of("Contents"), zn.Type = zn.of("Type"), zn.Parent = zn.of("Parent"), zn.MediaBox = zn.of("MediaBox"), zn.Page = zn.of("Page"), zn.Annots = zn.of("Annots"), zn.TrimBox = zn.of("TrimBox"), zn.ArtBox = zn.of("ArtBox"), zn.BleedBox = zn.of("BleedBox"), zn.CropBox = zn.of("CropBox"), zn.Rotate = zn.of("Rotate"), zn.Title = zn.of("Title"), zn.Author = zn.of("Author"), zn.Subject = zn.of("Subject"), zn.Creator = zn.of("Creator"), zn.Keywords = zn.of("Keywords"), zn.Producer = zn.of("Producer"), zn.CreationDate = zn.of("CreationDate"), zn.ModDate = zn.of("ModDate"), zn;
  }(PDFObject)
), PDFNull = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.asNull = function() {
      return null;
    }, zn.prototype.clone = function() {
      return this;
    }, zn.prototype.toString = function() {
      return "null";
    }, zn.prototype.sizeInBytes = function() {
      return 4;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      return Un[Kn++] = CharCodes$1.n, Un[Kn++] = CharCodes$1.u, Un[Kn++] = CharCodes$1.l, Un[Kn++] = CharCodes$1.l, 4;
    }, zn;
  }(PDFObject)
);
const PDFNull$1 = new PDFNull();
var PDFDict = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this) || this;
      return qn.dict = Un, qn.context = Kn, qn;
    }
    return zn.prototype.keys = function() {
      return Array.from(this.dict.keys());
    }, zn.prototype.values = function() {
      return Array.from(this.dict.values());
    }, zn.prototype.entries = function() {
      return Array.from(this.dict.entries());
    }, zn.prototype.set = function(Un, Kn) {
      this.dict.set(Un, Kn);
    }, zn.prototype.get = function(Un, Kn) {
      Kn === void 0 && (Kn = !1);
      var qn = this.dict.get(Un);
      if (!(qn === PDFNull$1 && !Kn))
        return qn;
    }, zn.prototype.has = function(Un) {
      var Kn = this.dict.get(Un);
      return Kn !== void 0 && Kn !== PDFNull$1;
    }, zn.prototype.lookupMaybe = function(Un) {
      for (var Kn, qn = [], Jo = 1; Jo < arguments.length; Jo++)
        qn[Jo - 1] = arguments[Jo];
      var pa = qn.includes(PDFNull$1), ma = (Kn = this.context).lookupMaybe.apply(Kn, __spreadArrays([this.get(Un, pa)], qn));
      if (!(ma === PDFNull$1 && !pa))
        return ma;
    }, zn.prototype.lookup = function(Un) {
      for (var Kn, qn = [], Jo = 1; Jo < arguments.length; Jo++)
        qn[Jo - 1] = arguments[Jo];
      var pa = qn.includes(PDFNull$1), ma = (Kn = this.context).lookup.apply(Kn, __spreadArrays([this.get(Un, pa)], qn));
      if (!(ma === PDFNull$1 && !pa))
        return ma;
    }, zn.prototype.delete = function(Un) {
      return this.dict.delete(Un);
    }, zn.prototype.asMap = function() {
      return new Map(this.dict);
    }, zn.prototype.uniqueKey = function(Un) {
      Un === void 0 && (Un = "");
      for (var Kn = this.keys(), qn = PDFName.of(this.context.addRandomSuffix(Un, 10)); Kn.includes(qn); )
        qn = PDFName.of(this.context.addRandomSuffix(Un, 10));
      return qn;
    }, zn.prototype.clone = function(Un) {
      for (var Kn = zn.withContext(Un || this.context), qn = this.entries(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo], va = ma[0], ba = ma[1];
        Kn.set(va, ba);
      }
      return Kn;
    }, zn.prototype.toString = function() {
      for (var Un = `<<
`, Kn = this.entries(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = pa[0], va = pa[1];
        Un += ma.toString() + " " + va.toString() + `
`;
      }
      return Un += ">>", Un;
    }, zn.prototype.sizeInBytes = function() {
      for (var Un = 5, Kn = this.entries(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = pa[0], va = pa[1];
        Un += ma.sizeInBytes() + va.sizeInBytes() + 2;
      }
      return Un;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      var qn = Kn;
      Un[Kn++] = CharCodes$1.LessThan, Un[Kn++] = CharCodes$1.LessThan, Un[Kn++] = CharCodes$1.Newline;
      for (var Jo = this.entries(), pa = 0, ma = Jo.length; pa < ma; pa++) {
        var va = Jo[pa], ba = va[0], _a = va[1];
        Kn += ba.copyBytesInto(Un, Kn), Un[Kn++] = CharCodes$1.Space, Kn += _a.copyBytesInto(Un, Kn), Un[Kn++] = CharCodes$1.Newline;
      }
      return Un[Kn++] = CharCodes$1.GreaterThan, Un[Kn++] = CharCodes$1.GreaterThan, Kn - qn;
    }, zn.withContext = function(Un) {
      return new zn(/* @__PURE__ */ new Map(), Un);
    }, zn.fromMapWithContext = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn;
  }(PDFObject)
), PDFStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = Xn.call(this) || this;
      return Kn.dict = Un, Kn;
    }
    return zn.prototype.clone = function(Un) {
      throw new MethodNotImplementedError(this.constructor.name, "clone");
    }, zn.prototype.getContentsString = function() {
      throw new MethodNotImplementedError(this.constructor.name, "getContentsString");
    }, zn.prototype.getContents = function() {
      throw new MethodNotImplementedError(this.constructor.name, "getContents");
    }, zn.prototype.getContentsSize = function() {
      throw new MethodNotImplementedError(this.constructor.name, "getContentsSize");
    }, zn.prototype.updateDict = function() {
      var Un = this.getContentsSize();
      this.dict.set(PDFName.Length, PDFNumber.of(Un));
    }, zn.prototype.sizeInBytes = function() {
      return this.updateDict(), this.dict.sizeInBytes() + this.getContentsSize() + 18;
    }, zn.prototype.toString = function() {
      this.updateDict();
      var Un = this.dict.toString();
      return Un += `
stream
`, Un += this.getContentsString(), Un += `
endstream`, Un;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      this.updateDict();
      var qn = Kn;
      Kn += this.dict.copyBytesInto(Un, Kn), Un[Kn++] = CharCodes$1.Newline, Un[Kn++] = CharCodes$1.s, Un[Kn++] = CharCodes$1.t, Un[Kn++] = CharCodes$1.r, Un[Kn++] = CharCodes$1.e, Un[Kn++] = CharCodes$1.a, Un[Kn++] = CharCodes$1.m, Un[Kn++] = CharCodes$1.Newline;
      for (var Jo = this.getContents(), pa = 0, ma = Jo.length; pa < ma; pa++)
        Un[Kn++] = Jo[pa];
      return Un[Kn++] = CharCodes$1.Newline, Un[Kn++] = CharCodes$1.e, Un[Kn++] = CharCodes$1.n, Un[Kn++] = CharCodes$1.d, Un[Kn++] = CharCodes$1.s, Un[Kn++] = CharCodes$1.t, Un[Kn++] = CharCodes$1.r, Un[Kn++] = CharCodes$1.e, Un[Kn++] = CharCodes$1.a, Un[Kn++] = CharCodes$1.m, Kn - qn;
    }, zn;
  }(PDFObject)
), PDFRawStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this, Un) || this;
      return qn.contents = Kn, qn;
    }
    return zn.prototype.asUint8Array = function() {
      return this.contents.slice();
    }, zn.prototype.clone = function(Un) {
      return zn.of(this.dict.clone(Un), this.contents.slice());
    }, zn.prototype.getContentsString = function() {
      return arrayAsString(this.contents);
    }, zn.prototype.getContents = function() {
      return this.contents;
    }, zn.prototype.getContentsSize = function() {
      return this.contents.length;
    }, zn.of = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn;
  }(PDFStream)
), ENFORCER = {}, pool = /* @__PURE__ */ new Map(), PDFRef = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = this;
      if (Un !== ENFORCER)
        throw new PrivateConstructorError("PDFRef");
      return Jo = Xn.call(this) || this, Jo.objectNumber = Kn, Jo.generationNumber = qn, Jo.tag = Kn + " " + qn + " R", Jo;
    }
    return zn.prototype.clone = function() {
      return this;
    }, zn.prototype.toString = function() {
      return this.tag;
    }, zn.prototype.sizeInBytes = function() {
      return this.tag.length;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      return Kn += copyStringIntoBuffer(this.tag, Un, Kn), this.tag.length;
    }, zn.of = function(Un, Kn) {
      Kn === void 0 && (Kn = 0);
      var qn = Un + " " + Kn + " R", Jo = pool.get(qn);
      return Jo || (Jo = new zn(ENFORCER, Un, Kn), pool.set(qn, Jo)), Jo;
    }, zn;
  }(PDFObject)
), PDFOperator = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      this.name = zn, this.args = Un || [];
    }
    return Xn.prototype.clone = function(zn) {
      for (var Un = new Array(this.args.length), Kn = 0, qn = Un.length; Kn < qn; Kn++) {
        var Jo = this.args[Kn];
        Un[Kn] = Jo instanceof PDFObject ? Jo.clone(zn) : Jo;
      }
      return Xn.of(this.name, Un);
    }, Xn.prototype.toString = function() {
      for (var zn = "", Un = 0, Kn = this.args.length; Un < Kn; Un++)
        zn += String(this.args[Un]) + " ";
      return zn += this.name, zn;
    }, Xn.prototype.sizeInBytes = function() {
      for (var zn = 0, Un = 0, Kn = this.args.length; Un < Kn; Un++) {
        var qn = this.args[Un];
        zn += (qn instanceof PDFObject ? qn.sizeInBytes() : qn.length) + 1;
      }
      return zn += this.name.length, zn;
    }, Xn.prototype.copyBytesInto = function(zn, Un) {
      for (var Kn = Un, qn = 0, Jo = this.args.length; qn < Jo; qn++) {
        var pa = this.args[qn];
        pa instanceof PDFObject ? Un += pa.copyBytesInto(zn, Un) : Un += copyStringIntoBuffer(pa, zn, Un), zn[Un++] = CharCodes$1.Space;
      }
      return Un += copyStringIntoBuffer(this.name, zn, Un), Un - Kn;
    }, Xn.of = function(zn, Un) {
      return new Xn(zn, Un);
    }, Xn;
  }()
), PDFOperatorNames;
(function(Xn) {
  Xn.NonStrokingColor = "sc", Xn.NonStrokingColorN = "scn", Xn.NonStrokingColorRgb = "rg", Xn.NonStrokingColorGray = "g", Xn.NonStrokingColorCmyk = "k", Xn.NonStrokingColorspace = "cs", Xn.StrokingColor = "SC", Xn.StrokingColorN = "SCN", Xn.StrokingColorRgb = "RG", Xn.StrokingColorGray = "G", Xn.StrokingColorCmyk = "K", Xn.StrokingColorspace = "CS", Xn.BeginMarkedContentSequence = "BDC", Xn.BeginMarkedContent = "BMC", Xn.EndMarkedContent = "EMC", Xn.MarkedContentPointWithProps = "DP", Xn.MarkedContentPoint = "MP", Xn.DrawObject = "Do", Xn.ConcatTransformationMatrix = "cm", Xn.PopGraphicsState = "Q", Xn.PushGraphicsState = "q", Xn.SetFlatness = "i", Xn.SetGraphicsStateParams = "gs", Xn.SetLineCapStyle = "J", Xn.SetLineDashPattern = "d", Xn.SetLineJoinStyle = "j", Xn.SetLineMiterLimit = "M", Xn.SetLineWidth = "w", Xn.SetTextMatrix = "Tm", Xn.SetRenderingIntent = "ri", Xn.AppendRectangle = "re", Xn.BeginInlineImage = "BI", Xn.BeginInlineImageData = "ID", Xn.EndInlineImage = "EI", Xn.ClipEvenOdd = "W*", Xn.ClipNonZero = "W", Xn.CloseAndStroke = "s", Xn.CloseFillEvenOddAndStroke = "b*", Xn.CloseFillNonZeroAndStroke = "b", Xn.ClosePath = "h", Xn.AppendBezierCurve = "c", Xn.CurveToReplicateFinalPoint = "y", Xn.CurveToReplicateInitialPoint = "v", Xn.EndPath = "n", Xn.FillEvenOddAndStroke = "B*", Xn.FillEvenOdd = "f*", Xn.FillNonZeroAndStroke = "B", Xn.FillNonZero = "f", Xn.LegacyFillNonZero = "F", Xn.LineTo = "l", Xn.MoveTo = "m", Xn.ShadingFill = "sh", Xn.StrokePath = "S", Xn.BeginText = "BT", Xn.EndText = "ET", Xn.MoveText = "Td", Xn.MoveTextSetLeading = "TD", Xn.NextLine = "T*", Xn.SetCharacterSpacing = "Tc", Xn.SetFontAndSize = "Tf", Xn.SetTextHorizontalScaling = "Tz", Xn.SetTextLineHeight = "TL", Xn.SetTextRenderingMode = "Tr", Xn.SetTextRise = "Ts", Xn.SetWordSpacing = "Tw", Xn.ShowText = "Tj", Xn.ShowTextAdjusted = "TJ", Xn.ShowTextLine = "'", Xn.ShowTextLineAndSpace = '"', Xn.Type3D0 = "d0", Xn.Type3D1 = "d1", Xn.BeginCompatibilitySection = "BX", Xn.EndCompatibilitySection = "EX";
})(PDFOperatorNames || (PDFOperatorNames = {}));
const Ops = PDFOperatorNames;
var PDFFlateStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this, Un) || this;
      return qn.computeContents = function() {
        var Jo = qn.getUnencodedContents();
        return qn.encode ? pako$1.deflate(Jo) : Jo;
      }, qn.encode = Kn, Kn && Un.set(PDFName.of("Filter"), PDFName.of("FlateDecode")), qn.contentsCache = Cache.populatedBy(qn.computeContents), qn;
    }
    return zn.prototype.getContents = function() {
      return this.contentsCache.access();
    }, zn.prototype.getContentsSize = function() {
      return this.contentsCache.access().length;
    }, zn.prototype.getUnencodedContents = function() {
      throw new MethodNotImplementedError(this.constructor.name, "getUnencodedContents");
    }, zn;
  }(PDFStream)
), PDFContentStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      qn === void 0 && (qn = !0);
      var Jo = Xn.call(this, Un, qn) || this;
      return Jo.operators = Kn, Jo;
    }
    return zn.prototype.push = function() {
      for (var Un, Kn = [], qn = 0; qn < arguments.length; qn++)
        Kn[qn] = arguments[qn];
      (Un = this.operators).push.apply(Un, Kn);
    }, zn.prototype.clone = function(Un) {
      for (var Kn = new Array(this.operators.length), qn = 0, Jo = this.operators.length; qn < Jo; qn++)
        Kn[qn] = this.operators[qn].clone(Un);
      var pa = this, ma = pa.dict, va = pa.encode;
      return zn.of(ma.clone(Un), Kn, va);
    }, zn.prototype.getContentsString = function() {
      for (var Un = "", Kn = 0, qn = this.operators.length; Kn < qn; Kn++)
        Un += this.operators[Kn] + `
`;
      return Un;
    }, zn.prototype.getUnencodedContents = function() {
      for (var Un = new Uint8Array(this.getUnencodedContentsSize()), Kn = 0, qn = 0, Jo = this.operators.length; qn < Jo; qn++)
        Kn += this.operators[qn].copyBytesInto(Un, Kn), Un[Kn++] = CharCodes$1.Newline;
      return Un;
    }, zn.prototype.getUnencodedContentsSize = function() {
      for (var Un = 0, Kn = 0, qn = this.operators.length; Kn < qn; Kn++)
        Un += this.operators[Kn].sizeInBytes() + 1;
      return Un;
    }, zn.of = function(Un, Kn, qn) {
      return qn === void 0 && (qn = !0), new zn(Un, Kn, qn);
    }, zn;
  }(PDFFlateStream)
), SimpleRNG = (
  /** @class */
  function() {
    function Xn(zn) {
      this.seed = zn;
    }
    return Xn.prototype.nextInt = function() {
      var zn = Math.sin(this.seed++) * 1e4;
      return zn - Math.floor(zn);
    }, Xn.withSeed = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), byAscendingObjectNumber = function(Xn, zn) {
  var Un = Xn[0], Kn = zn[0];
  return Un.objectNumber - Kn.objectNumber;
}, PDFContext = (
  /** @class */
  function() {
    function Xn() {
      this.largestObjectNumber = 0, this.header = PDFHeader.forVersion(1, 7), this.trailerInfo = {}, this.indirectObjects = /* @__PURE__ */ new Map(), this.rng = SimpleRNG.withSeed(1);
    }
    return Xn.prototype.assign = function(zn, Un) {
      this.indirectObjects.set(zn, Un), zn.objectNumber > this.largestObjectNumber && (this.largestObjectNumber = zn.objectNumber);
    }, Xn.prototype.nextRef = function() {
      return this.largestObjectNumber += 1, PDFRef.of(this.largestObjectNumber);
    }, Xn.prototype.register = function(zn) {
      var Un = this.nextRef();
      return this.assign(Un, zn), Un;
    }, Xn.prototype.delete = function(zn) {
      return this.indirectObjects.delete(zn);
    }, Xn.prototype.lookupMaybe = function(zn) {
      for (var Un = [], Kn = 1; Kn < arguments.length; Kn++)
        Un[Kn - 1] = arguments[Kn];
      var qn = Un.includes(PDFNull$1), Jo = zn instanceof PDFRef ? this.indirectObjects.get(zn) : zn;
      if (!(!Jo || Jo === PDFNull$1 && !qn)) {
        for (var pa = 0, ma = Un.length; pa < ma; pa++) {
          var va = Un[pa];
          if (va === PDFNull$1) {
            if (Jo === PDFNull$1)
              return Jo;
          } else if (Jo instanceof va)
            return Jo;
        }
        throw new UnexpectedObjectTypeError(Un, Jo);
      }
    }, Xn.prototype.lookup = function(zn) {
      for (var Un = [], Kn = 1; Kn < arguments.length; Kn++)
        Un[Kn - 1] = arguments[Kn];
      var qn = zn instanceof PDFRef ? this.indirectObjects.get(zn) : zn;
      if (Un.length === 0)
        return qn;
      for (var Jo = 0, pa = Un.length; Jo < pa; Jo++) {
        var ma = Un[Jo];
        if (ma === PDFNull$1) {
          if (qn === PDFNull$1)
            return qn;
        } else if (qn instanceof ma)
          return qn;
      }
      throw new UnexpectedObjectTypeError(Un, qn);
    }, Xn.prototype.getObjectRef = function(zn) {
      for (var Un = Array.from(this.indirectObjects.entries()), Kn = 0, qn = Un.length; Kn < qn; Kn++) {
        var Jo = Un[Kn], pa = Jo[0], ma = Jo[1];
        if (ma === zn)
          return pa;
      }
    }, Xn.prototype.enumerateIndirectObjects = function() {
      return Array.from(this.indirectObjects.entries()).sort(byAscendingObjectNumber);
    }, Xn.prototype.obj = function(zn) {
      if (zn instanceof PDFObject)
        return zn;
      if (zn == null)
        return PDFNull$1;
      if (typeof zn == "string")
        return PDFName.of(zn);
      if (typeof zn == "number")
        return PDFNumber.of(zn);
      if (typeof zn == "boolean")
        return zn ? PDFBool.True : PDFBool.False;
      if (Array.isArray(zn)) {
        for (var Un = PDFArray.withContext(this), Kn = 0, qn = zn.length; Kn < qn; Kn++)
          Un.push(this.obj(zn[Kn]));
        return Un;
      } else {
        for (var Jo = PDFDict.withContext(this), pa = Object.keys(zn), Kn = 0, qn = pa.length; Kn < qn; Kn++) {
          var ma = pa[Kn], va = zn[ma];
          va !== void 0 && Jo.set(PDFName.of(ma), this.obj(va));
        }
        return Jo;
      }
    }, Xn.prototype.stream = function(zn, Un) {
      return Un === void 0 && (Un = {}), PDFRawStream.of(this.obj(Un), typedArrayFor(zn));
    }, Xn.prototype.flateStream = function(zn, Un) {
      return Un === void 0 && (Un = {}), this.stream(pako$1.deflate(typedArrayFor(zn)), __assign(__assign({}, Un), { Filter: "FlateDecode" }));
    }, Xn.prototype.contentStream = function(zn, Un) {
      return Un === void 0 && (Un = {}), PDFContentStream.of(this.obj(Un), zn);
    }, Xn.prototype.formXObject = function(zn, Un) {
      return Un === void 0 && (Un = {}), this.contentStream(zn, __assign(__assign({ BBox: this.obj([0, 0, 0, 0]), Matrix: this.obj([1, 0, 0, 1, 0, 0]) }, Un), { Type: "XObject", Subtype: "Form" }));
    }, Xn.prototype.getPushGraphicsStateContentStream = function() {
      if (this.pushGraphicsStateContentStreamRef)
        return this.pushGraphicsStateContentStreamRef;
      var zn = this.obj({}), Un = PDFOperator.of(Ops.PushGraphicsState), Kn = PDFContentStream.of(zn, [Un]);
      return this.pushGraphicsStateContentStreamRef = this.register(Kn), this.pushGraphicsStateContentStreamRef;
    }, Xn.prototype.getPopGraphicsStateContentStream = function() {
      if (this.popGraphicsStateContentStreamRef)
        return this.popGraphicsStateContentStreamRef;
      var zn = this.obj({}), Un = PDFOperator.of(Ops.PopGraphicsState), Kn = PDFContentStream.of(zn, [Un]);
      return this.popGraphicsStateContentStreamRef = this.register(Kn), this.popGraphicsStateContentStreamRef;
    }, Xn.prototype.addRandomSuffix = function(zn, Un) {
      return Un === void 0 && (Un = 4), zn + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, Un));
    }, Xn.create = function() {
      return new Xn();
    }, Xn;
  }()
), PDFPageLeaf = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      qn === void 0 && (qn = !0);
      var Jo = Xn.call(this, Un, Kn) || this;
      return Jo.normalized = !1, Jo.autoNormalizeCTM = qn, Jo;
    }
    return zn.prototype.clone = function(Un) {
      for (var Kn = zn.fromMapWithContext(/* @__PURE__ */ new Map(), Un || this.context, this.autoNormalizeCTM), qn = this.entries(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo], va = ma[0], ba = ma[1];
        Kn.set(va, ba);
      }
      return Kn;
    }, zn.prototype.Parent = function() {
      return this.lookupMaybe(PDFName.Parent, PDFDict);
    }, zn.prototype.Contents = function() {
      return this.lookup(PDFName.of("Contents"));
    }, zn.prototype.Annots = function() {
      return this.lookupMaybe(PDFName.Annots, PDFArray);
    }, zn.prototype.BleedBox = function() {
      return this.lookupMaybe(PDFName.BleedBox, PDFArray);
    }, zn.prototype.TrimBox = function() {
      return this.lookupMaybe(PDFName.TrimBox, PDFArray);
    }, zn.prototype.ArtBox = function() {
      return this.lookupMaybe(PDFName.ArtBox, PDFArray);
    }, zn.prototype.Resources = function() {
      var Un = this.getInheritableAttribute(PDFName.Resources);
      return this.context.lookupMaybe(Un, PDFDict);
    }, zn.prototype.MediaBox = function() {
      var Un = this.getInheritableAttribute(PDFName.MediaBox);
      return this.context.lookup(Un, PDFArray);
    }, zn.prototype.CropBox = function() {
      var Un = this.getInheritableAttribute(PDFName.CropBox);
      return this.context.lookupMaybe(Un, PDFArray);
    }, zn.prototype.Rotate = function() {
      var Un = this.getInheritableAttribute(PDFName.Rotate);
      return this.context.lookupMaybe(Un, PDFNumber);
    }, zn.prototype.getInheritableAttribute = function(Un) {
      var Kn;
      return this.ascend(function(qn) {
        Kn || (Kn = qn.get(Un));
      }), Kn;
    }, zn.prototype.setParent = function(Un) {
      this.set(PDFName.Parent, Un);
    }, zn.prototype.addContentStream = function(Un) {
      var Kn = this.normalizedEntries().Contents || this.context.obj([]);
      this.set(PDFName.Contents, Kn), Kn.push(Un);
    }, zn.prototype.wrapContentStreams = function(Un, Kn) {
      var qn = this.Contents();
      return qn instanceof PDFArray ? (qn.insert(0, Un), qn.push(Kn), !0) : !1;
    }, zn.prototype.addAnnot = function(Un) {
      var Kn = this.normalizedEntries().Annots;
      Kn.push(Un);
    }, zn.prototype.removeAnnot = function(Un) {
      var Kn = this.normalizedEntries().Annots, qn = Kn.indexOf(Un);
      qn !== void 0 && Kn.remove(qn);
    }, zn.prototype.setFontDictionary = function(Un, Kn) {
      var qn = this.normalizedEntries().Font;
      qn.set(Un, Kn);
    }, zn.prototype.newFontDictionaryKey = function(Un) {
      var Kn = this.normalizedEntries().Font;
      return Kn.uniqueKey(Un);
    }, zn.prototype.newFontDictionary = function(Un, Kn) {
      var qn = this.newFontDictionaryKey(Un);
      return this.setFontDictionary(qn, Kn), qn;
    }, zn.prototype.setXObject = function(Un, Kn) {
      var qn = this.normalizedEntries().XObject;
      qn.set(Un, Kn);
    }, zn.prototype.newXObjectKey = function(Un) {
      var Kn = this.normalizedEntries().XObject;
      return Kn.uniqueKey(Un);
    }, zn.prototype.newXObject = function(Un, Kn) {
      var qn = this.newXObjectKey(Un);
      return this.setXObject(qn, Kn), qn;
    }, zn.prototype.setExtGState = function(Un, Kn) {
      var qn = this.normalizedEntries().ExtGState;
      qn.set(Un, Kn);
    }, zn.prototype.newExtGStateKey = function(Un) {
      var Kn = this.normalizedEntries().ExtGState;
      return Kn.uniqueKey(Un);
    }, zn.prototype.newExtGState = function(Un, Kn) {
      var qn = this.newExtGStateKey(Un);
      return this.setExtGState(qn, Kn), qn;
    }, zn.prototype.ascend = function(Un) {
      Un(this);
      var Kn = this.Parent();
      Kn && Kn.ascend(Un);
    }, zn.prototype.normalize = function() {
      if (!this.normalized) {
        var Un = this.context, Kn = this.get(PDFName.Contents), qn = this.context.lookup(Kn);
        qn instanceof PDFStream && this.set(PDFName.Contents, Un.obj([Kn])), this.autoNormalizeCTM && this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        var Jo = this.getInheritableAttribute(PDFName.Resources), pa = Un.lookupMaybe(Jo, PDFDict) || Un.obj({});
        this.set(PDFName.Resources, pa);
        var ma = pa.lookupMaybe(PDFName.Font, PDFDict) || Un.obj({});
        pa.set(PDFName.Font, ma);
        var va = pa.lookupMaybe(PDFName.XObject, PDFDict) || Un.obj({});
        pa.set(PDFName.XObject, va);
        var ba = pa.lookupMaybe(PDFName.ExtGState, PDFDict) || Un.obj({});
        pa.set(PDFName.ExtGState, ba);
        var _a = this.Annots() || Un.obj([]);
        this.set(PDFName.Annots, _a), this.normalized = !0;
      }
    }, zn.prototype.normalizedEntries = function() {
      this.normalize();
      var Un = this.Annots(), Kn = this.Resources(), qn = this.Contents();
      return {
        Annots: Un,
        Resources: Kn,
        Contents: qn,
        Font: Kn.lookup(PDFName.Font, PDFDict),
        XObject: Kn.lookup(PDFName.XObject, PDFDict),
        ExtGState: Kn.lookup(PDFName.ExtGState, PDFDict)
      };
    }, zn.InheritableEntries = [
      "Resources",
      "MediaBox",
      "CropBox",
      "Rotate"
    ], zn.withContextAndParent = function(Un, Kn) {
      var qn = /* @__PURE__ */ new Map();
      return qn.set(PDFName.Type, PDFName.Page), qn.set(PDFName.Parent, Kn), qn.set(PDFName.Resources, Un.obj({})), qn.set(PDFName.MediaBox, Un.obj([0, 0, 612, 792])), new zn(qn, Un, !1);
    }, zn.fromMapWithContext = function(Un, Kn, qn) {
      return qn === void 0 && (qn = !0), new zn(Un, Kn, qn);
    }, zn;
  }(PDFDict)
), PDFObjectCopier = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      var Kn = this;
      this.traversedObjects = /* @__PURE__ */ new Map(), this.copy = function(qn) {
        return qn instanceof PDFPageLeaf ? Kn.copyPDFPage(qn) : qn instanceof PDFDict ? Kn.copyPDFDict(qn) : qn instanceof PDFArray ? Kn.copyPDFArray(qn) : qn instanceof PDFStream ? Kn.copyPDFStream(qn) : qn instanceof PDFRef ? Kn.copyPDFIndirectObject(qn) : qn.clone();
      }, this.copyPDFPage = function(qn) {
        for (var Jo = qn.clone(), pa = PDFPageLeaf.InheritableEntries, ma = 0, va = pa.length; ma < va; ma++) {
          var ba = PDFName.of(pa[ma]), _a = Jo.getInheritableAttribute(ba);
          !Jo.get(ba) && _a && Jo.set(ba, _a);
        }
        return Jo.delete(PDFName.of("Parent")), Kn.copyPDFDict(Jo);
      }, this.copyPDFDict = function(qn) {
        if (Kn.traversedObjects.has(qn))
          return Kn.traversedObjects.get(qn);
        var Jo = qn.clone(Kn.dest);
        Kn.traversedObjects.set(qn, Jo);
        for (var pa = qn.entries(), ma = 0, va = pa.length; ma < va; ma++) {
          var ba = pa[ma], _a = ba[0], ya = ba[1];
          Jo.set(_a, Kn.copy(ya));
        }
        return Jo;
      }, this.copyPDFArray = function(qn) {
        if (Kn.traversedObjects.has(qn))
          return Kn.traversedObjects.get(qn);
        var Jo = qn.clone(Kn.dest);
        Kn.traversedObjects.set(qn, Jo);
        for (var pa = 0, ma = qn.size(); pa < ma; pa++) {
          var va = qn.get(pa);
          Jo.set(pa, Kn.copy(va));
        }
        return Jo;
      }, this.copyPDFStream = function(qn) {
        if (Kn.traversedObjects.has(qn))
          return Kn.traversedObjects.get(qn);
        var Jo = qn.clone(Kn.dest);
        Kn.traversedObjects.set(qn, Jo);
        for (var pa = qn.dict.entries(), ma = 0, va = pa.length; ma < va; ma++) {
          var ba = pa[ma], _a = ba[0], ya = ba[1];
          Jo.dict.set(_a, Kn.copy(ya));
        }
        return Jo;
      }, this.copyPDFIndirectObject = function(qn) {
        var Jo = Kn.traversedObjects.has(qn);
        if (!Jo) {
          var pa = Kn.dest.nextRef();
          Kn.traversedObjects.set(qn, pa);
          var ma = Kn.src.lookup(qn);
          if (ma) {
            var va = Kn.copy(ma);
            Kn.dest.assign(pa, va);
          }
        }
        return Kn.traversedObjects.get(qn);
      }, this.src = zn, this.dest = Un;
    }
    return Xn.for = function(zn, Un) {
      return new Xn(zn, Un);
    }, Xn;
  }()
), PDFCrossRefSection = (
  /** @class */
  function() {
    function Xn(zn) {
      this.subsections = zn ? [[zn]] : [], this.chunkIdx = 0, this.chunkLength = zn ? 1 : 0;
    }
    return Xn.prototype.addEntry = function(zn, Un) {
      this.append({ ref: zn, offset: Un, deleted: !1 });
    }, Xn.prototype.addDeletedEntry = function(zn, Un) {
      this.append({ ref: zn, offset: Un, deleted: !0 });
    }, Xn.prototype.toString = function() {
      for (var zn = `xref
`, Un = 0, Kn = this.subsections.length; Un < Kn; Un++) {
        var qn = this.subsections[Un];
        zn += qn[0].ref.objectNumber + " " + qn.length + `
`;
        for (var Jo = 0, pa = qn.length; Jo < pa; Jo++) {
          var ma = qn[Jo];
          zn += padStart$1(String(ma.offset), 10, "0"), zn += " ", zn += padStart$1(String(ma.ref.generationNumber), 5, "0"), zn += " ", zn += ma.deleted ? "f" : "n", zn += ` 
`;
        }
      }
      return zn;
    }, Xn.prototype.sizeInBytes = function() {
      for (var zn = 5, Un = 0, Kn = this.subsections.length; Un < Kn; Un++) {
        var qn = this.subsections[Un], Jo = qn.length, pa = qn[0];
        zn += 2, zn += String(pa.ref.objectNumber).length, zn += String(Jo).length, zn += 20 * Jo;
      }
      return zn;
    }, Xn.prototype.copyBytesInto = function(zn, Un) {
      var Kn = Un;
      return zn[Un++] = CharCodes$1.x, zn[Un++] = CharCodes$1.r, zn[Un++] = CharCodes$1.e, zn[Un++] = CharCodes$1.f, zn[Un++] = CharCodes$1.Newline, Un += this.copySubsectionsIntoBuffer(this.subsections, zn, Un), Un - Kn;
    }, Xn.prototype.copySubsectionsIntoBuffer = function(zn, Un, Kn) {
      for (var qn = Kn, Jo = zn.length, pa = 0; pa < Jo; pa++) {
        var ma = this.subsections[pa], va = String(ma[0].ref.objectNumber);
        Kn += copyStringIntoBuffer(va, Un, Kn), Un[Kn++] = CharCodes$1.Space;
        var ba = String(ma.length);
        Kn += copyStringIntoBuffer(ba, Un, Kn), Un[Kn++] = CharCodes$1.Newline, Kn += this.copyEntriesIntoBuffer(ma, Un, Kn);
      }
      return Kn - qn;
    }, Xn.prototype.copyEntriesIntoBuffer = function(zn, Un, Kn) {
      for (var qn = zn.length, Jo = 0; Jo < qn; Jo++) {
        var pa = zn[Jo], ma = padStart$1(String(pa.offset), 10, "0");
        Kn += copyStringIntoBuffer(ma, Un, Kn), Un[Kn++] = CharCodes$1.Space;
        var va = padStart$1(String(pa.ref.generationNumber), 5, "0");
        Kn += copyStringIntoBuffer(va, Un, Kn), Un[Kn++] = CharCodes$1.Space, Un[Kn++] = pa.deleted ? CharCodes$1.f : CharCodes$1.n, Un[Kn++] = CharCodes$1.Space, Un[Kn++] = CharCodes$1.Newline;
      }
      return 20 * qn;
    }, Xn.prototype.append = function(zn) {
      if (this.chunkLength === 0) {
        this.subsections.push([zn]), this.chunkIdx = 0, this.chunkLength = 1;
        return;
      }
      var Un = this.subsections[this.chunkIdx], Kn = Un[this.chunkLength - 1];
      zn.ref.objectNumber - Kn.ref.objectNumber > 1 ? (this.subsections.push([zn]), this.chunkIdx += 1, this.chunkLength = 1) : (Un.push(zn), this.chunkLength += 1);
    }, Xn.create = function() {
      return new Xn({
        ref: PDFRef.of(0, 65535),
        offset: 0,
        deleted: !0
      });
    }, Xn.createEmpty = function() {
      return new Xn();
    }, Xn;
  }()
), PDFTrailer = (
  /** @class */
  function() {
    function Xn(zn) {
      this.lastXRefOffset = String(zn);
    }
    return Xn.prototype.toString = function() {
      return `startxref
` + this.lastXRefOffset + `
%%EOF`;
    }, Xn.prototype.sizeInBytes = function() {
      return 16 + this.lastXRefOffset.length;
    }, Xn.prototype.copyBytesInto = function(zn, Un) {
      var Kn = Un;
      return zn[Un++] = CharCodes$1.s, zn[Un++] = CharCodes$1.t, zn[Un++] = CharCodes$1.a, zn[Un++] = CharCodes$1.r, zn[Un++] = CharCodes$1.t, zn[Un++] = CharCodes$1.x, zn[Un++] = CharCodes$1.r, zn[Un++] = CharCodes$1.e, zn[Un++] = CharCodes$1.f, zn[Un++] = CharCodes$1.Newline, Un += copyStringIntoBuffer(this.lastXRefOffset, zn, Un), zn[Un++] = CharCodes$1.Newline, zn[Un++] = CharCodes$1.Percent, zn[Un++] = CharCodes$1.Percent, zn[Un++] = CharCodes$1.E, zn[Un++] = CharCodes$1.O, zn[Un++] = CharCodes$1.F, Un - Kn;
    }, Xn.forLastCrossRefSectionOffset = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), PDFTrailerDict = (
  /** @class */
  function() {
    function Xn(zn) {
      this.dict = zn;
    }
    return Xn.prototype.toString = function() {
      return `trailer
` + this.dict.toString();
    }, Xn.prototype.sizeInBytes = function() {
      return 8 + this.dict.sizeInBytes();
    }, Xn.prototype.copyBytesInto = function(zn, Un) {
      var Kn = Un;
      return zn[Un++] = CharCodes$1.t, zn[Un++] = CharCodes$1.r, zn[Un++] = CharCodes$1.a, zn[Un++] = CharCodes$1.i, zn[Un++] = CharCodes$1.l, zn[Un++] = CharCodes$1.e, zn[Un++] = CharCodes$1.r, zn[Un++] = CharCodes$1.Newline, Un += this.dict.copyBytesInto(zn, Un), Un - Kn;
    }, Xn.of = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), PDFObjectStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      qn === void 0 && (qn = !0);
      var Jo = Xn.call(this, Un.obj({}), qn) || this;
      return Jo.objects = Kn, Jo.offsets = Jo.computeObjectOffsets(), Jo.offsetsString = Jo.computeOffsetsString(), Jo.dict.set(PDFName.of("Type"), PDFName.of("ObjStm")), Jo.dict.set(PDFName.of("N"), PDFNumber.of(Jo.objects.length)), Jo.dict.set(PDFName.of("First"), PDFNumber.of(Jo.offsetsString.length)), Jo;
    }
    return zn.prototype.getObjectsCount = function() {
      return this.objects.length;
    }, zn.prototype.clone = function(Un) {
      return zn.withContextAndObjects(Un || this.dict.context, this.objects.slice(), this.encode);
    }, zn.prototype.getContentsString = function() {
      for (var Un = this.offsetsString, Kn = 0, qn = this.objects.length; Kn < qn; Kn++) {
        var Jo = this.objects[Kn], pa = Jo[1];
        Un += pa + `
`;
      }
      return Un;
    }, zn.prototype.getUnencodedContents = function() {
      for (var Un = new Uint8Array(this.getUnencodedContentsSize()), Kn = copyStringIntoBuffer(this.offsetsString, Un, 0), qn = 0, Jo = this.objects.length; qn < Jo; qn++) {
        var pa = this.objects[qn], ma = pa[1];
        Kn += ma.copyBytesInto(Un, Kn), Un[Kn++] = CharCodes$1.Newline;
      }
      return Un;
    }, zn.prototype.getUnencodedContentsSize = function() {
      return this.offsetsString.length + last(this.offsets)[1] + last(this.objects)[1].sizeInBytes() + 1;
    }, zn.prototype.computeOffsetsString = function() {
      for (var Un = "", Kn = 0, qn = this.offsets.length; Kn < qn; Kn++) {
        var Jo = this.offsets[Kn], pa = Jo[0], ma = Jo[1];
        Un += pa + " " + ma + " ";
      }
      return Un;
    }, zn.prototype.computeObjectOffsets = function() {
      for (var Un = 0, Kn = new Array(this.objects.length), qn = 0, Jo = this.objects.length; qn < Jo; qn++) {
        var pa = this.objects[qn], ma = pa[0], va = pa[1];
        Kn[qn] = [ma.objectNumber, Un], Un += va.sizeInBytes() + 1;
      }
      return Kn;
    }, zn.withContextAndObjects = function(Un, Kn, qn) {
      return qn === void 0 && (qn = !0), new zn(Un, Kn, qn);
    }, zn;
  }(PDFFlateStream)
), PDFWriter = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      var Kn = this;
      this.parsedObjects = 0, this.shouldWaitForTick = function(qn) {
        return Kn.parsedObjects += qn, Kn.parsedObjects % Kn.objectsPerTick === 0;
      }, this.context = zn, this.objectsPerTick = Un;
    }
    return Xn.prototype.serializeToBuffer = function() {
      return __awaiter(this, void 0, void 0, function() {
        var zn, Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma, ka;
        return __generator(this, function(Za) {
          switch (Za.label) {
            case 0:
              return [4, this.computeBufferSize()];
            case 1:
              zn = Za.sent(), Un = zn.size, Kn = zn.header, qn = zn.indirectObjects, Jo = zn.xref, pa = zn.trailerDict, ma = zn.trailer, va = 0, ba = new Uint8Array(Un), va += Kn.copyBytesInto(ba, va), ba[va++] = CharCodes$1.Newline, ba[va++] = CharCodes$1.Newline, _a = 0, ya = qn.length, Za.label = 2;
            case 2:
              return _a < ya ? (xa = qn[_a], wa = xa[0], Ta = xa[1], Sa = String(wa.objectNumber), va += copyStringIntoBuffer(Sa, ba, va), ba[va++] = CharCodes$1.Space, Ma = String(wa.generationNumber), va += copyStringIntoBuffer(Ma, ba, va), ba[va++] = CharCodes$1.Space, ba[va++] = CharCodes$1.o, ba[va++] = CharCodes$1.b, ba[va++] = CharCodes$1.j, ba[va++] = CharCodes$1.Newline, va += Ta.copyBytesInto(ba, va), ba[va++] = CharCodes$1.Newline, ba[va++] = CharCodes$1.e, ba[va++] = CharCodes$1.n, ba[va++] = CharCodes$1.d, ba[va++] = CharCodes$1.o, ba[va++] = CharCodes$1.b, ba[va++] = CharCodes$1.j, ba[va++] = CharCodes$1.Newline, ba[va++] = CharCodes$1.Newline, ka = Ta instanceof PDFObjectStream ? Ta.getObjectsCount() : 1, this.shouldWaitForTick(ka) ? [4, waitForTick()] : [3, 4]) : [3, 5];
            case 3:
              Za.sent(), Za.label = 4;
            case 4:
              return _a++, [3, 2];
            case 5:
              return Jo && (va += Jo.copyBytesInto(ba, va), ba[va++] = CharCodes$1.Newline), pa && (va += pa.copyBytesInto(ba, va), ba[va++] = CharCodes$1.Newline, ba[va++] = CharCodes$1.Newline), va += ma.copyBytesInto(ba, va), [2, ba];
          }
        });
      });
    }, Xn.prototype.computeIndirectObjectSize = function(zn) {
      var Un = zn[0], Kn = zn[1], qn = Un.sizeInBytes() + 3, Jo = Kn.sizeInBytes() + 9;
      return qn + Jo;
    }, Xn.prototype.createTrailerDict = function() {
      return this.context.obj({
        Size: this.context.largestObjectNumber + 1,
        Root: this.context.trailerInfo.Root,
        Encrypt: this.context.trailerInfo.Encrypt,
        Info: this.context.trailerInfo.Info,
        ID: this.context.trailerInfo.ID
      });
    }, Xn.prototype.computeBufferSize = function() {
      return __awaiter(this, void 0, void 0, function() {
        var zn, Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya;
        return __generator(this, function(xa) {
          switch (xa.label) {
            case 0:
              zn = PDFHeader.forVersion(1, 7), Un = zn.sizeInBytes() + 2, Kn = PDFCrossRefSection.create(), qn = this.context.enumerateIndirectObjects(), Jo = 0, pa = qn.length, xa.label = 1;
            case 1:
              return Jo < pa ? (ma = qn[Jo], va = ma[0], Kn.addEntry(va, Un), Un += this.computeIndirectObjectSize(ma), this.shouldWaitForTick(1) ? [4, waitForTick()] : [3, 3]) : [3, 4];
            case 2:
              xa.sent(), xa.label = 3;
            case 3:
              return Jo++, [3, 1];
            case 4:
              return ba = Un, Un += Kn.sizeInBytes() + 1, _a = PDFTrailerDict.of(this.createTrailerDict()), Un += _a.sizeInBytes() + 2, ya = PDFTrailer.forLastCrossRefSectionOffset(ba), Un += ya.sizeInBytes(), [2, { size: Un, header: zn, indirectObjects: qn, xref: Kn, trailerDict: _a, trailer: ya }];
          }
        });
      });
    }, Xn.forContext = function(zn, Un) {
      return new Xn(zn, Un);
    }, Xn;
  }()
), PDFInvalidObject = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = Xn.call(this) || this;
      return Kn.data = Un, Kn;
    }
    return zn.prototype.clone = function() {
      return zn.of(this.data.slice());
    }, zn.prototype.toString = function() {
      return "PDFInvalidObject(" + this.data.length + " bytes)";
    }, zn.prototype.sizeInBytes = function() {
      return this.data.length;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      for (var qn = this.data.length, Jo = 0; Jo < qn; Jo++)
        Un[Kn++] = this.data[Jo];
      return qn;
    }, zn.of = function(Un) {
      return new zn(Un);
    }, zn;
  }(PDFObject)
), EntryType;
(function(Xn) {
  Xn[Xn.Deleted = 0] = "Deleted", Xn[Xn.Uncompressed = 1] = "Uncompressed", Xn[Xn.Compressed = 2] = "Compressed";
})(EntryType || (EntryType = {}));
var PDFCrossRefStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      qn === void 0 && (qn = !0);
      var Jo = Xn.call(this, Un, qn) || this;
      return Jo.computeIndex = function() {
        for (var pa = [], ma = 0, va = 0, ba = Jo.entries.length; va < ba; va++) {
          var _a = Jo.entries[va], ya = Jo.entries[va - 1];
          va === 0 ? pa.push(_a.ref.objectNumber) : _a.ref.objectNumber - ya.ref.objectNumber > 1 && (pa.push(ma), pa.push(_a.ref.objectNumber), ma = 0), ma += 1;
        }
        return pa.push(ma), pa;
      }, Jo.computeEntryTuples = function() {
        for (var pa = new Array(Jo.entries.length), ma = 0, va = Jo.entries.length; ma < va; ma++) {
          var ba = Jo.entries[ma];
          if (ba.type === EntryType.Deleted) {
            var _a = ba.type, ya = ba.nextFreeObjectNumber, xa = ba.ref;
            pa[ma] = [_a, ya, xa.generationNumber];
          }
          if (ba.type === EntryType.Uncompressed) {
            var _a = ba.type, wa = ba.offset, xa = ba.ref;
            pa[ma] = [_a, wa, xa.generationNumber];
          }
          if (ba.type === EntryType.Compressed) {
            var _a = ba.type, Ta = ba.objectStreamRef, Sa = ba.index;
            pa[ma] = [_a, Ta.objectNumber, Sa];
          }
        }
        return pa;
      }, Jo.computeMaxEntryByteWidths = function() {
        for (var pa = Jo.entryTuplesCache.access(), ma = [0, 0, 0], va = 0, ba = pa.length; va < ba; va++) {
          var _a = pa[va], ya = _a[0], xa = _a[1], wa = _a[2], Ta = sizeInBytes(ya), Sa = sizeInBytes(xa), Ma = sizeInBytes(wa);
          Ta > ma[0] && (ma[0] = Ta), Sa > ma[1] && (ma[1] = Sa), Ma > ma[2] && (ma[2] = Ma);
        }
        return ma;
      }, Jo.entries = Kn || [], Jo.entryTuplesCache = Cache.populatedBy(Jo.computeEntryTuples), Jo.maxByteWidthsCache = Cache.populatedBy(Jo.computeMaxEntryByteWidths), Jo.indexCache = Cache.populatedBy(Jo.computeIndex), Un.set(PDFName.of("Type"), PDFName.of("XRef")), Jo;
    }
    return zn.prototype.addDeletedEntry = function(Un, Kn) {
      var qn = EntryType.Deleted;
      this.entries.push({ type: qn, ref: Un, nextFreeObjectNumber: Kn }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
    }, zn.prototype.addUncompressedEntry = function(Un, Kn) {
      var qn = EntryType.Uncompressed;
      this.entries.push({ type: qn, ref: Un, offset: Kn }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
    }, zn.prototype.addCompressedEntry = function(Un, Kn, qn) {
      var Jo = EntryType.Compressed;
      this.entries.push({ type: Jo, ref: Un, objectStreamRef: Kn, index: qn }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
    }, zn.prototype.clone = function(Un) {
      var Kn = this, qn = Kn.dict, Jo = Kn.entries, pa = Kn.encode;
      return zn.of(qn.clone(Un), Jo.slice(), pa);
    }, zn.prototype.getContentsString = function() {
      for (var Un = this.entryTuplesCache.access(), Kn = this.maxByteWidthsCache.access(), qn = "", Jo = 0, pa = Un.length; Jo < pa; Jo++) {
        for (var ma = Un[Jo], va = ma[0], ba = ma[1], _a = ma[2], ya = reverseArray(bytesFor(va)), xa = reverseArray(bytesFor(ba)), wa = reverseArray(bytesFor(_a)), Ta = Kn[0] - 1; Ta >= 0; Ta--)
          qn += (ya[Ta] || 0).toString(2);
        for (var Ta = Kn[1] - 1; Ta >= 0; Ta--)
          qn += (xa[Ta] || 0).toString(2);
        for (var Ta = Kn[2] - 1; Ta >= 0; Ta--)
          qn += (wa[Ta] || 0).toString(2);
      }
      return qn;
    }, zn.prototype.getUnencodedContents = function() {
      for (var Un = this.entryTuplesCache.access(), Kn = this.maxByteWidthsCache.access(), qn = new Uint8Array(this.getUnencodedContentsSize()), Jo = 0, pa = 0, ma = Un.length; pa < ma; pa++) {
        for (var va = Un[pa], ba = va[0], _a = va[1], ya = va[2], xa = reverseArray(bytesFor(ba)), wa = reverseArray(bytesFor(_a)), Ta = reverseArray(bytesFor(ya)), Sa = Kn[0] - 1; Sa >= 0; Sa--)
          qn[Jo++] = xa[Sa] || 0;
        for (var Sa = Kn[1] - 1; Sa >= 0; Sa--)
          qn[Jo++] = wa[Sa] || 0;
        for (var Sa = Kn[2] - 1; Sa >= 0; Sa--)
          qn[Jo++] = Ta[Sa] || 0;
      }
      return qn;
    }, zn.prototype.getUnencodedContentsSize = function() {
      var Un = this.maxByteWidthsCache.access(), Kn = sum(Un);
      return Kn * this.entries.length;
    }, zn.prototype.updateDict = function() {
      Xn.prototype.updateDict.call(this);
      var Un = this.maxByteWidthsCache.access(), Kn = this.indexCache.access(), qn = this.dict.context;
      this.dict.set(PDFName.of("W"), qn.obj(Un)), this.dict.set(PDFName.of("Index"), qn.obj(Kn));
    }, zn.create = function(Un, Kn) {
      Kn === void 0 && (Kn = !0);
      var qn = new zn(Un, [], Kn);
      return qn.addDeletedEntry(PDFRef.of(0, 65535), 0), qn;
    }, zn.of = function(Un, Kn, qn) {
      return qn === void 0 && (qn = !0), new zn(Un, Kn, qn);
    }, zn;
  }(PDFFlateStream)
), PDFStreamWriter = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn, Jo) {
      var pa = Xn.call(this, Un, Kn) || this;
      return pa.encodeStreams = qn, pa.objectsPerStream = Jo, pa;
    }
    return zn.prototype.computeBufferSize = function() {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo, pa, ma, va, ba, Ta, Sa, _a, ka, ya, xa, Ma, wa, Ta, Sa, Ma, ka, Za, Na, Ka, Ja;
        return __generator(this, function(el) {
          switch (el.label) {
            case 0:
              Un = this.context.largestObjectNumber + 1, Kn = PDFHeader.forVersion(1, 7), qn = Kn.sizeInBytes() + 2, Jo = PDFCrossRefStream.create(this.createTrailerDict(), this.encodeStreams), pa = [], ma = [], va = [], ba = this.context.enumerateIndirectObjects(), Ta = 0, Sa = ba.length, el.label = 1;
            case 1:
              return Ta < Sa ? (_a = ba[Ta], ka = _a[0], ya = _a[1], xa = ka === this.context.trailerInfo.Encrypt || ya instanceof PDFStream || ya instanceof PDFInvalidObject || ka.generationNumber !== 0, xa ? (pa.push(_a), Jo.addUncompressedEntry(ka, qn), qn += this.computeIndirectObjectSize(_a), this.shouldWaitForTick(1) ? [4, waitForTick()] : [3, 3]) : [3, 4]) : [3, 6];
            case 2:
              el.sent(), el.label = 3;
            case 3:
              return [3, 5];
            case 4:
              Ma = last(ma), wa = last(va), (!Ma || Ma.length % this.objectsPerStream === 0) && (Ma = [], ma.push(Ma), wa = PDFRef.of(Un++), va.push(wa)), Jo.addCompressedEntry(ka, wa, Ma.length), Ma.push(_a), el.label = 5;
            case 5:
              return Ta++, [3, 1];
            case 6:
              Ta = 0, Sa = ma.length, el.label = 7;
            case 7:
              return Ta < Sa ? (Ma = ma[Ta], ka = va[Ta], Za = PDFObjectStream.withContextAndObjects(this.context, Ma, this.encodeStreams), Jo.addUncompressedEntry(ka, qn), qn += this.computeIndirectObjectSize([ka, Za]), pa.push([ka, Za]), this.shouldWaitForTick(Ma.length) ? [4, waitForTick()] : [3, 9]) : [3, 10];
            case 8:
              el.sent(), el.label = 9;
            case 9:
              return Ta++, [3, 7];
            case 10:
              return Na = PDFRef.of(Un++), Jo.dict.set(PDFName.of("Size"), PDFNumber.of(Un)), Jo.addUncompressedEntry(Na, qn), Ka = qn, qn += this.computeIndirectObjectSize([Na, Jo]), pa.push([Na, Jo]), Ja = PDFTrailer.forLastCrossRefSectionOffset(Ka), qn += Ja.sizeInBytes(), [2, { size: qn, header: Kn, indirectObjects: pa, trailer: Ja }];
          }
        });
      });
    }, zn.forContext = function(Un, Kn, qn, Jo) {
      return qn === void 0 && (qn = !0), Jo === void 0 && (Jo = 50), new zn(Un, Kn, qn, Jo);
    }, zn;
  }(PDFWriter)
), PDFHexString = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = Xn.call(this) || this;
      return Kn.value = Un, Kn;
    }
    return zn.prototype.asBytes = function() {
      for (var Un = this.value + (this.value.length % 2 === 1 ? "0" : ""), Kn = Un.length, qn = new Uint8Array(Un.length / 2), Jo = 0, pa = 0; Jo < Kn; ) {
        var ma = parseInt(Un.substring(Jo, Jo + 2), 16);
        qn[pa] = ma, Jo += 2, pa += 1;
      }
      return qn;
    }, zn.prototype.decodeText = function() {
      var Un = this.asBytes();
      return hasUtf16BOM(Un) ? utf16Decode(Un) : pdfDocEncodingDecode(Un);
    }, zn.prototype.decodeDate = function() {
      var Un = this.decodeText(), Kn = parseDate(Un);
      if (!Kn)
        throw new InvalidPDFDateStringError(Un);
      return Kn;
    }, zn.prototype.asString = function() {
      return this.value;
    }, zn.prototype.clone = function() {
      return zn.of(this.value);
    }, zn.prototype.toString = function() {
      return "<" + this.value + ">";
    }, zn.prototype.sizeInBytes = function() {
      return this.value.length + 2;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      return Un[Kn++] = CharCodes$1.LessThan, Kn += copyStringIntoBuffer(this.value, Un, Kn), Un[Kn++] = CharCodes$1.GreaterThan, this.value.length + 2;
    }, zn.of = function(Un) {
      return new zn(Un);
    }, zn.fromText = function(Un) {
      for (var Kn = utf16Encode(Un), qn = "", Jo = 0, pa = Kn.length; Jo < pa; Jo++)
        qn += toHexStringOfMinLength(Kn[Jo], 4);
      return new zn(qn);
    }, zn;
  }(PDFObject)
), StandardFontEmbedder = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      this.encoding = zn === FontNames.ZapfDingbats ? Encodings.ZapfDingbats : zn === FontNames.Symbol ? Encodings.Symbol : Encodings.WinAnsi, this.font = Font.load(zn), this.fontName = this.font.FontName, this.customName = Un;
    }
    return Xn.prototype.encodeText = function(zn) {
      for (var Un = this.encodeTextAsGlyphs(zn), Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++)
        Kn[qn] = toHexString(Un[qn].code);
      return PDFHexString.of(Kn.join(""));
    }, Xn.prototype.widthOfTextAtSize = function(zn, Un) {
      for (var Kn = this.encodeTextAsGlyphs(zn), qn = 0, Jo = 0, pa = Kn.length; Jo < pa; Jo++) {
        var ma = Kn[Jo].name, va = (Kn[Jo + 1] || {}).name, ba = this.font.getXAxisKerningForPair(ma, va) || 0;
        qn += this.widthOfGlyph(ma) + ba;
      }
      var _a = Un / 1e3;
      return qn * _a;
    }, Xn.prototype.heightOfFontAtSize = function(zn, Un) {
      Un === void 0 && (Un = {});
      var Kn = Un.descender, qn = Kn === void 0 ? !0 : Kn, Jo = this.font, pa = Jo.Ascender, ma = Jo.Descender, va = Jo.FontBBox, ba = pa || va[3], _a = ma || va[1], ya = ba - _a;
      return qn || (ya += ma || 0), ya / 1e3 * zn;
    }, Xn.prototype.sizeOfFontAtHeight = function(zn) {
      var Un = this.font, Kn = Un.Ascender, qn = Un.Descender, Jo = Un.FontBBox, pa = Kn || Jo[3], ma = qn || Jo[1];
      return 1e3 * zn / (pa - ma);
    }, Xn.prototype.embedIntoContext = function(zn, Un) {
      var Kn = zn.obj({
        Type: "Font",
        Subtype: "Type1",
        BaseFont: this.customName || this.fontName,
        Encoding: this.encoding === Encodings.WinAnsi ? "WinAnsiEncoding" : void 0
      });
      return Un ? (zn.assign(Un, Kn), Un) : zn.register(Kn);
    }, Xn.prototype.widthOfGlyph = function(zn) {
      return this.font.getWidthOfGlyph(zn) || 250;
    }, Xn.prototype.encodeTextAsGlyphs = function(zn) {
      for (var Un = Array.from(zn), Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++) {
        var pa = toCodePoint(Un[qn]);
        Kn[qn] = this.encoding.encodeUnicodeCodePoint(pa);
      }
      return Kn;
    }, Xn.for = function(zn, Un) {
      return new Xn(zn, Un);
    }, Xn;
  }()
), createCmap = function(Xn, zn) {
  for (var Un = new Array(Xn.length), Kn = 0, qn = Xn.length; Kn < qn; Kn++) {
    var Jo = Xn[Kn], pa = cmapHexFormat(cmapHexString(zn(Jo))), ma = cmapHexFormat.apply(void 0, Jo.codePoints.map(cmapCodePointFormat));
    Un[Kn] = [pa, ma];
  }
  return fillCmapTemplate(Un);
}, fillCmapTemplate = function(Xn) {
  return `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange
` + Xn.length + ` beginbfchar
` + Xn.map(function(zn) {
    var Un = zn[0], Kn = zn[1];
    return Un + " " + Kn;
  }).join(`
`) + `
endbfchar
endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
}, cmapHexFormat = function() {
  for (var Xn = [], zn = 0; zn < arguments.length; zn++)
    Xn[zn] = arguments[zn];
  return "<" + Xn.join("") + ">";
}, cmapHexString = function(Xn) {
  return toHexStringOfMinLength(Xn, 4);
}, cmapCodePointFormat = function(Xn) {
  if (isWithinBMP(Xn))
    return cmapHexString(Xn);
  if (hasSurrogates(Xn)) {
    var zn = highSurrogate(Xn), Un = lowSurrogate(Xn);
    return "" + cmapHexString(zn) + cmapHexString(Un);
  }
  var Kn = toHexString(Xn), qn = "0x" + Kn + " is not a valid UTF-8 or UTF-16 codepoint.";
  throw new Error(qn);
}, makeFontFlags = function(Xn) {
  var zn = 0, Un = function(Kn) {
    zn |= 1 << Kn - 1;
  };
  return Xn.fixedPitch && Un(1), Xn.serif && Un(2), Un(3), Xn.script && Un(4), Xn.nonsymbolic && Un(6), Xn.italic && Un(7), Xn.allCap && Un(17), Xn.smallCap && Un(18), Xn.forceBold && Un(19), zn;
}, deriveFontFlags = function(Xn) {
  var zn = Xn["OS/2"] ? Xn["OS/2"].sFamilyClass : 0, Un = makeFontFlags({
    fixedPitch: Xn.post.isFixedPitch,
    serif: 1 <= zn && zn <= 7,
    script: zn === 10,
    italic: Xn.head.macStyle.italic
  });
  return Un;
}, PDFString = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = Xn.call(this) || this;
      return Kn.value = Un, Kn;
    }
    return zn.prototype.asBytes = function() {
      for (var Un = [], Kn = "", qn = !1, Jo = function(ya) {
        ya !== void 0 && Un.push(ya), qn = !1;
      }, pa = 0, ma = this.value.length; pa < ma; pa++) {
        var va = this.value[pa], ba = toCharCode(va), _a = this.value[pa + 1];
        qn ? ba === CharCodes$1.Newline || ba === CharCodes$1.CarriageReturn ? Jo() : ba === CharCodes$1.n ? Jo(CharCodes$1.Newline) : ba === CharCodes$1.r ? Jo(CharCodes$1.CarriageReturn) : ba === CharCodes$1.t ? Jo(CharCodes$1.Tab) : ba === CharCodes$1.b ? Jo(CharCodes$1.Backspace) : ba === CharCodes$1.f ? Jo(CharCodes$1.FormFeed) : ba === CharCodes$1.LeftParen ? Jo(CharCodes$1.LeftParen) : ba === CharCodes$1.RightParen ? Jo(CharCodes$1.RightParen) : ba === CharCodes$1.Backspace ? Jo(CharCodes$1.BackSlash) : ba >= CharCodes$1.Zero && ba <= CharCodes$1.Seven ? (Kn += va, (Kn.length === 3 || !(_a >= "0" && _a <= "7")) && (Jo(parseInt(Kn, 8)), Kn = "")) : Jo(ba) : ba === CharCodes$1.BackSlash ? qn = !0 : Jo(ba);
      }
      return new Uint8Array(Un);
    }, zn.prototype.decodeText = function() {
      var Un = this.asBytes();
      return hasUtf16BOM(Un) ? utf16Decode(Un) : pdfDocEncodingDecode(Un);
    }, zn.prototype.decodeDate = function() {
      var Un = this.decodeText(), Kn = parseDate(Un);
      if (!Kn)
        throw new InvalidPDFDateStringError(Un);
      return Kn;
    }, zn.prototype.asString = function() {
      return this.value;
    }, zn.prototype.clone = function() {
      return zn.of(this.value);
    }, zn.prototype.toString = function() {
      return "(" + this.value + ")";
    }, zn.prototype.sizeInBytes = function() {
      return this.value.length + 2;
    }, zn.prototype.copyBytesInto = function(Un, Kn) {
      return Un[Kn++] = CharCodes$1.LeftParen, Kn += copyStringIntoBuffer(this.value, Un, Kn), Un[Kn++] = CharCodes$1.RightParen, this.value.length + 2;
    }, zn.of = function(Un) {
      return new zn(Un);
    }, zn.fromDate = function(Un) {
      var Kn = padStart$1(String(Un.getUTCFullYear()), 4, "0"), qn = padStart$1(String(Un.getUTCMonth() + 1), 2, "0"), Jo = padStart$1(String(Un.getUTCDate()), 2, "0"), pa = padStart$1(String(Un.getUTCHours()), 2, "0"), ma = padStart$1(String(Un.getUTCMinutes()), 2, "0"), va = padStart$1(String(Un.getUTCSeconds()), 2, "0");
      return new zn("D:" + Kn + qn + Jo + pa + ma + va + "Z");
    }, zn;
  }(PDFObject)
), CustomFontEmbedder = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn, qn) {
      var Jo = this;
      this.allGlyphsInFontSortedById = function() {
        for (var pa = new Array(Jo.font.characterSet.length), ma = 0, va = pa.length; ma < va; ma++) {
          var ba = Jo.font.characterSet[ma];
          pa[ma] = Jo.font.glyphForCodePoint(ba);
        }
        return sortedUniq(pa.sort(byAscendingId), function(_a) {
          return _a.id;
        });
      }, this.font = zn, this.scale = 1e3 / this.font.unitsPerEm, this.fontData = Un, this.fontName = this.font.postscriptName || "Font", this.customName = Kn, this.fontFeatures = qn, this.baseFontName = "", this.glyphCache = Cache.populatedBy(this.allGlyphsInFontSortedById);
    }
    return Xn.for = function(zn, Un, Kn, qn) {
      return __awaiter(this, void 0, void 0, function() {
        var Jo;
        return __generator(this, function(pa) {
          switch (pa.label) {
            case 0:
              return [4, zn.create(Un)];
            case 1:
              return Jo = pa.sent(), [2, new Xn(Jo, Un, Kn, qn)];
          }
        });
      });
    }, Xn.prototype.encodeText = function(zn) {
      for (var Un = this.font.layout(zn, this.fontFeatures).glyphs, Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++)
        Kn[qn] = toHexStringOfMinLength(Un[qn].id, 4);
      return PDFHexString.of(Kn.join(""));
    }, Xn.prototype.widthOfTextAtSize = function(zn, Un) {
      for (var Kn = this.font.layout(zn, this.fontFeatures).glyphs, qn = 0, Jo = 0, pa = Kn.length; Jo < pa; Jo++)
        qn += Kn[Jo].advanceWidth * this.scale;
      var ma = Un / 1e3;
      return qn * ma;
    }, Xn.prototype.heightOfFontAtSize = function(zn, Un) {
      Un === void 0 && (Un = {});
      var Kn = Un.descender, qn = Kn === void 0 ? !0 : Kn, Jo = this.font, pa = Jo.ascent, ma = Jo.descent, va = Jo.bbox, ba = (pa || va.maxY) * this.scale, _a = (ma || va.minY) * this.scale, ya = ba - _a;
      return qn || (ya -= Math.abs(ma) || 0), ya / 1e3 * zn;
    }, Xn.prototype.sizeOfFontAtHeight = function(zn) {
      var Un = this.font, Kn = Un.ascent, qn = Un.descent, Jo = Un.bbox, pa = (Kn || Jo.maxY) * this.scale, ma = (qn || Jo.minY) * this.scale;
      return 1e3 * zn / (pa - ma);
    }, Xn.prototype.embedIntoContext = function(zn, Un) {
      return this.baseFontName = this.customName || zn.addRandomSuffix(this.fontName), this.embedFontDict(zn, Un);
    }, Xn.prototype.embedFontDict = function(zn, Un) {
      return __awaiter(this, void 0, void 0, function() {
        var Kn, qn, Jo;
        return __generator(this, function(pa) {
          switch (pa.label) {
            case 0:
              return [4, this.embedCIDFontDict(zn)];
            case 1:
              return Kn = pa.sent(), qn = this.embedUnicodeCmap(zn), Jo = zn.obj({
                Type: "Font",
                Subtype: "Type0",
                BaseFont: this.baseFontName,
                Encoding: "Identity-H",
                DescendantFonts: [Kn],
                ToUnicode: qn
              }), Un ? (zn.assign(Un, Jo), [2, Un]) : [2, zn.register(Jo)];
          }
        });
      });
    }, Xn.prototype.isCFF = function() {
      return this.font.cff;
    }, Xn.prototype.embedCIDFontDict = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn;
        return __generator(this, function(qn) {
          switch (qn.label) {
            case 0:
              return [4, this.embedFontDescriptor(zn)];
            case 1:
              return Un = qn.sent(), Kn = zn.obj({
                Type: "Font",
                Subtype: this.isCFF() ? "CIDFontType0" : "CIDFontType2",
                CIDToGIDMap: "Identity",
                BaseFont: this.baseFontName,
                CIDSystemInfo: {
                  Registry: PDFString.of("Adobe"),
                  Ordering: PDFString.of("Identity"),
                  Supplement: 0
                },
                FontDescriptor: Un,
                W: this.computeWidths()
              }), [2, zn.register(Kn)];
          }
        });
      });
    }, Xn.prototype.embedFontDescriptor = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma;
        return __generator(this, function(ka) {
          switch (ka.label) {
            case 0:
              return [4, this.embedFontStream(zn)];
            case 1:
              return Un = ka.sent(), Kn = this.scale, qn = this.font, Jo = qn.italicAngle, pa = qn.ascent, ma = qn.descent, va = qn.capHeight, ba = qn.xHeight, _a = this.font.bbox, ya = _a.minX, xa = _a.minY, wa = _a.maxX, Ta = _a.maxY, Sa = zn.obj((Ma = {
                Type: "FontDescriptor",
                FontName: this.baseFontName,
                Flags: deriveFontFlags(this.font),
                FontBBox: [ya * Kn, xa * Kn, wa * Kn, Ta * Kn],
                ItalicAngle: Jo,
                Ascent: pa * Kn,
                Descent: ma * Kn,
                CapHeight: (va || pa) * Kn,
                XHeight: (ba || 0) * Kn,
                // Not sure how to compute/find this, nor is anybody else really:
                // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                StemV: 0
              }, Ma[this.isCFF() ? "FontFile3" : "FontFile2"] = Un, Ma)), [2, zn.register(Sa)];
          }
        });
      });
    }, Xn.prototype.serializeFont = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(zn) {
          return [2, this.fontData];
        });
      });
    }, Xn.prototype.embedFontStream = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn;
        return __generator(this, function(Jo) {
          switch (Jo.label) {
            case 0:
              return qn = (Kn = zn).flateStream, [4, this.serializeFont()];
            case 1:
              return Un = qn.apply(Kn, [Jo.sent(), {
                Subtype: this.isCFF() ? "CIDFontType0C" : void 0
              }]), [2, zn.register(Un)];
          }
        });
      });
    }, Xn.prototype.embedUnicodeCmap = function(zn) {
      var Un = createCmap(this.glyphCache.access(), this.glyphId.bind(this)), Kn = zn.flateStream(Un);
      return zn.register(Kn);
    }, Xn.prototype.glyphId = function(zn) {
      return zn ? zn.id : -1;
    }, Xn.prototype.computeWidths = function() {
      for (var zn = this.glyphCache.access(), Un = [], Kn = [], qn = 0, Jo = zn.length; qn < Jo; qn++) {
        var pa = zn[qn], ma = zn[qn - 1], va = this.glyphId(pa), ba = this.glyphId(ma);
        qn === 0 ? Un.push(va) : va - ba !== 1 && (Un.push(Kn), Un.push(va), Kn = []), Kn.push(pa.advanceWidth * this.scale);
      }
      return Un.push(Kn), Un;
    }, Xn;
  }()
), CustomFontSubsetEmbedder = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn, Jo) {
      var pa = Xn.call(this, Un, Kn, qn, Jo) || this;
      return pa.subset = pa.font.createSubset(), pa.glyphs = [], pa.glyphCache = Cache.populatedBy(function() {
        return pa.glyphs;
      }), pa.glyphIdMap = /* @__PURE__ */ new Map(), pa;
    }
    return zn.for = function(Un, Kn, qn, Jo) {
      return __awaiter(this, void 0, void 0, function() {
        var pa;
        return __generator(this, function(ma) {
          switch (ma.label) {
            case 0:
              return [4, Un.create(Kn)];
            case 1:
              return pa = ma.sent(), [2, new zn(pa, Kn, qn, Jo)];
          }
        });
      });
    }, zn.prototype.encodeText = function(Un) {
      for (var Kn = this.font.layout(Un, this.fontFeatures).glyphs, qn = new Array(Kn.length), Jo = 0, pa = Kn.length; Jo < pa; Jo++) {
        var ma = Kn[Jo], va = this.subset.includeGlyph(ma);
        this.glyphs[va - 1] = ma, this.glyphIdMap.set(ma.id, va), qn[Jo] = toHexStringOfMinLength(va, 4);
      }
      return this.glyphCache.invalidate(), PDFHexString.of(qn.join(""));
    }, zn.prototype.isCFF = function() {
      return this.subset.cff;
    }, zn.prototype.glyphId = function(Un) {
      return Un ? this.glyphIdMap.get(Un.id) : -1;
    }, zn.prototype.serializeFont = function() {
      var Un = this;
      return new Promise(function(Kn, qn) {
        var Jo = [];
        Un.subset.encodeStream().on("data", function(pa) {
          return Jo.push(pa);
        }).on("end", function() {
          return Kn(mergeUint8Arrays(Jo));
        }).on("error", function(pa) {
          return qn(pa);
        });
      });
    }, zn;
  }(CustomFontEmbedder)
), AFRelationship;
(function(Xn) {
  Xn.Source = "Source", Xn.Data = "Data", Xn.Alternative = "Alternative", Xn.Supplement = "Supplement", Xn.EncryptedPayload = "EncryptedPayload", Xn.FormData = "EncryptedPayload", Xn.Schema = "Schema", Xn.Unspecified = "Unspecified";
})(AFRelationship || (AFRelationship = {}));
var FileEmbedder = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      Kn === void 0 && (Kn = {}), this.fileData = zn, this.fileName = Un, this.options = Kn;
    }
    return Xn.for = function(zn, Un, Kn) {
      return Kn === void 0 && (Kn = {}), new Xn(zn, Un, Kn);
    }, Xn.prototype.embedIntoContext = function(zn, Un) {
      return __awaiter(this, void 0, void 0, function() {
        var Kn, qn, Jo, pa, ma, va, ba, _a, ya;
        return __generator(this, function(xa) {
          return Kn = this.options, qn = Kn.mimeType, Jo = Kn.description, pa = Kn.creationDate, ma = Kn.modificationDate, va = Kn.afRelationship, ba = zn.flateStream(this.fileData, {
            Type: "EmbeddedFile",
            Subtype: qn ?? void 0,
            Params: {
              Size: this.fileData.length,
              CreationDate: pa ? PDFString.fromDate(pa) : void 0,
              ModDate: ma ? PDFString.fromDate(ma) : void 0
            }
          }), _a = zn.register(ba), ya = zn.obj({
            Type: "Filespec",
            F: PDFString.of(this.fileName),
            UF: PDFHexString.fromText(this.fileName),
            EF: { F: _a },
            Desc: Jo ? PDFHexString.fromText(Jo) : void 0,
            AFRelationship: va ?? void 0
          }), Un ? (zn.assign(Un, ya), [2, Un]) : [2, zn.register(ya)];
        });
      });
    }, Xn;
  }()
), MARKERS = [
  65472,
  65473,
  65474,
  65475,
  65477,
  65478,
  65479,
  65480,
  65481,
  65482,
  65483,
  65484,
  65485,
  65486,
  65487
], ColorSpace;
(function(Xn) {
  Xn.DeviceGray = "DeviceGray", Xn.DeviceRGB = "DeviceRGB", Xn.DeviceCMYK = "DeviceCMYK";
})(ColorSpace || (ColorSpace = {}));
var ChannelToColorSpace = {
  1: ColorSpace.DeviceGray,
  3: ColorSpace.DeviceRGB,
  4: ColorSpace.DeviceCMYK
}, JpegEmbedder = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn, qn, Jo) {
      this.imageData = zn, this.bitsPerComponent = Un, this.width = Kn, this.height = qn, this.colorSpace = Jo;
    }
    return Xn.for = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya;
        return __generator(this, function(xa) {
          if (Un = new DataView(zn.buffer), Kn = Un.getUint16(0), Kn !== 65496)
            throw new Error("SOI not found in JPEG");
          for (qn = 2; qn < Un.byteLength && (Jo = Un.getUint16(qn), qn += 2, !MARKERS.includes(Jo)); )
            qn += Un.getUint16(qn);
          if (!MARKERS.includes(Jo))
            throw new Error("Invalid JPEG");
          if (qn += 2, pa = Un.getUint8(qn++), ma = Un.getUint16(qn), qn += 2, va = Un.getUint16(qn), qn += 2, ba = Un.getUint8(qn++), _a = ChannelToColorSpace[ba], !_a)
            throw new Error("Unknown JPEG channel.");
          return ya = _a, [2, new Xn(zn, pa, va, ma, ya)];
        });
      });
    }, Xn.prototype.embedIntoContext = function(zn, Un) {
      return __awaiter(this, void 0, void 0, function() {
        var Kn;
        return __generator(this, function(qn) {
          return Kn = zn.stream(this.imageData, {
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: this.bitsPerComponent,
            Width: this.width,
            Height: this.height,
            ColorSpace: this.colorSpace,
            Filter: "DCTDecode",
            // CMYK JPEG streams in PDF are typically stored complemented,
            // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
            //
            // Standalone CMYK JPEG (usually exported by Photoshop) are
            // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
            //
            // Applying a swap here as a hedge that most bytes passing
            // through this method will benefit from it.
            Decode: this.colorSpace === ColorSpace.DeviceCMYK ? [1, 0, 1, 0, 1, 0, 1, 0] : void 0
          }), Un ? (zn.assign(Un, Kn), [2, Un]) : [2, zn.register(Kn)];
        });
      });
    }, Xn;
  }()
), UPNG = {};
UPNG.toRGBA8 = function(Xn) {
  var zn = Xn.width, Un = Xn.height;
  if (Xn.tabs.acTL == null) return [UPNG.toRGBA8.decodeImage(Xn.data, zn, Un, Xn).buffer];
  var Kn = [];
  Xn.frames[0].data == null && (Xn.frames[0].data = Xn.data);
  for (var qn = zn * Un * 4, Jo = new Uint8Array(qn), pa = new Uint8Array(qn), ma = new Uint8Array(qn), va = 0; va < Xn.frames.length; va++) {
    var ba = Xn.frames[va], _a = ba.rect.x, ya = ba.rect.y, xa = ba.rect.width, wa = ba.rect.height, Ta = UPNG.toRGBA8.decodeImage(ba.data, xa, wa, Xn);
    if (va != 0) for (var Sa = 0; Sa < qn; Sa++) ma[Sa] = Jo[Sa];
    if (ba.blend == 0 ? UPNG._copyTile(Ta, xa, wa, Jo, zn, Un, _a, ya, 0) : ba.blend == 1 && UPNG._copyTile(Ta, xa, wa, Jo, zn, Un, _a, ya, 1), Kn.push(Jo.buffer.slice(0)), ba.dispose != 0) {
      if (ba.dispose == 1) UPNG._copyTile(pa, xa, wa, Jo, zn, Un, _a, ya, 0);
      else if (ba.dispose == 2) for (var Sa = 0; Sa < qn; Sa++) Jo[Sa] = ma[Sa];
    }
  }
  return Kn;
};
UPNG.toRGBA8.decodeImage = function(Xn, zn, Un, Kn) {
  var qn = zn * Un, Jo = UPNG.decode._getBPP(Kn), pa = Math.ceil(zn * Jo / 8), ma = new Uint8Array(qn * 4), va = new Uint32Array(ma.buffer), ba = Kn.ctype, _a = Kn.depth, ya = UPNG._bin.readUshort;
  if (ba == 6) {
    var xa = qn << 2;
    if (_a == 8) for (var wa = 0; wa < xa; wa += 4)
      ma[wa] = Xn[wa], ma[wa + 1] = Xn[wa + 1], ma[wa + 2] = Xn[wa + 2], ma[wa + 3] = Xn[wa + 3];
    if (_a == 16) for (var wa = 0; wa < xa; wa++)
      ma[wa] = Xn[wa << 1];
  } else if (ba == 2) {
    var Ta = Kn.tabs.tRNS;
    if (Ta == null) {
      if (_a == 8) for (var wa = 0; wa < qn; wa++) {
        var Sa = wa * 3;
        va[wa] = 255 << 24 | Xn[Sa + 2] << 16 | Xn[Sa + 1] << 8 | Xn[Sa];
      }
      if (_a == 16) for (var wa = 0; wa < qn; wa++) {
        var Sa = wa * 6;
        va[wa] = 255 << 24 | Xn[Sa + 4] << 16 | Xn[Sa + 2] << 8 | Xn[Sa];
      }
    } else {
      var Ma = Ta[0], ka = Ta[1], Za = Ta[2];
      if (_a == 8) for (var wa = 0; wa < qn; wa++) {
        var Na = wa << 2, Sa = wa * 3;
        va[wa] = 255 << 24 | Xn[Sa + 2] << 16 | Xn[Sa + 1] << 8 | Xn[Sa], Xn[Sa] == Ma && Xn[Sa + 1] == ka && Xn[Sa + 2] == Za && (ma[Na + 3] = 0);
      }
      if (_a == 16) for (var wa = 0; wa < qn; wa++) {
        var Na = wa << 2, Sa = wa * 6;
        va[wa] = 255 << 24 | Xn[Sa + 4] << 16 | Xn[Sa + 2] << 8 | Xn[Sa], ya(Xn, Sa) == Ma && ya(Xn, Sa + 2) == ka && ya(Xn, Sa + 4) == Za && (ma[Na + 3] = 0);
      }
    }
  } else if (ba == 3) {
    var Ka = Kn.tabs.PLTE, Ja = Kn.tabs.tRNS, el = Ja ? Ja.length : 0;
    if (_a == 1) for (var qa = 0; qa < Un; qa++)
      for (var tl = qa * pa, Qa = qa * zn, wa = 0; wa < zn; wa++) {
        var Na = Qa + wa << 2, nl = Xn[tl + (wa >> 3)] >> 7 - ((wa & 7) << 0) & 1, rl = 3 * nl;
        ma[Na] = Ka[rl], ma[Na + 1] = Ka[rl + 1], ma[Na + 2] = Ka[rl + 2], ma[Na + 3] = nl < el ? Ja[nl] : 255;
      }
    if (_a == 2) for (var qa = 0; qa < Un; qa++)
      for (var tl = qa * pa, Qa = qa * zn, wa = 0; wa < zn; wa++) {
        var Na = Qa + wa << 2, nl = Xn[tl + (wa >> 2)] >> 6 - ((wa & 3) << 1) & 3, rl = 3 * nl;
        ma[Na] = Ka[rl], ma[Na + 1] = Ka[rl + 1], ma[Na + 2] = Ka[rl + 2], ma[Na + 3] = nl < el ? Ja[nl] : 255;
      }
    if (_a == 4) for (var qa = 0; qa < Un; qa++)
      for (var tl = qa * pa, Qa = qa * zn, wa = 0; wa < zn; wa++) {
        var Na = Qa + wa << 2, nl = Xn[tl + (wa >> 1)] >> 4 - ((wa & 1) << 2) & 15, rl = 3 * nl;
        ma[Na] = Ka[rl], ma[Na + 1] = Ka[rl + 1], ma[Na + 2] = Ka[rl + 2], ma[Na + 3] = nl < el ? Ja[nl] : 255;
      }
    if (_a == 8) for (var wa = 0; wa < qn; wa++) {
      var Na = wa << 2, nl = Xn[wa], rl = 3 * nl;
      ma[Na] = Ka[rl], ma[Na + 1] = Ka[rl + 1], ma[Na + 2] = Ka[rl + 2], ma[Na + 3] = nl < el ? Ja[nl] : 255;
    }
  } else if (ba == 4) {
    if (_a == 8) for (var wa = 0; wa < qn; wa++) {
      var Na = wa << 2, il = wa << 1, cl = Xn[il];
      ma[Na] = cl, ma[Na + 1] = cl, ma[Na + 2] = cl, ma[Na + 3] = Xn[il + 1];
    }
    if (_a == 16) for (var wa = 0; wa < qn; wa++) {
      var Na = wa << 2, il = wa << 2, cl = Xn[il];
      ma[Na] = cl, ma[Na + 1] = cl, ma[Na + 2] = cl, ma[Na + 3] = Xn[il + 2];
    }
  } else if (ba == 0)
    for (var Ma = Kn.tabs.tRNS ? Kn.tabs.tRNS : -1, qa = 0; qa < Un; qa++) {
      var ll = qa * pa, al = qa * zn;
      if (_a == 1) for (var sl = 0; sl < zn; sl++) {
        var cl = 255 * (Xn[ll + (sl >>> 3)] >>> 7 - (sl & 7) & 1), dl = cl == Ma * 255 ? 0 : 255;
        va[al + sl] = dl << 24 | cl << 16 | cl << 8 | cl;
      }
      else if (_a == 2) for (var sl = 0; sl < zn; sl++) {
        var cl = 85 * (Xn[ll + (sl >>> 2)] >>> 6 - ((sl & 3) << 1) & 3), dl = cl == Ma * 85 ? 0 : 255;
        va[al + sl] = dl << 24 | cl << 16 | cl << 8 | cl;
      }
      else if (_a == 4) for (var sl = 0; sl < zn; sl++) {
        var cl = 17 * (Xn[ll + (sl >>> 1)] >>> 4 - ((sl & 1) << 2) & 15), dl = cl == Ma * 17 ? 0 : 255;
        va[al + sl] = dl << 24 | cl << 16 | cl << 8 | cl;
      }
      else if (_a == 8) for (var sl = 0; sl < zn; sl++) {
        var cl = Xn[ll + sl], dl = cl == Ma ? 0 : 255;
        va[al + sl] = dl << 24 | cl << 16 | cl << 8 | cl;
      }
      else if (_a == 16) for (var sl = 0; sl < zn; sl++) {
        var cl = Xn[ll + (sl << 1)], dl = ya(Xn, ll + (sl << wa)) == Ma ? 0 : 255;
        va[al + sl] = dl << 24 | cl << 16 | cl << 8 | cl;
      }
    }
  return ma;
};
UPNG.decode = function(Xn) {
  for (var zn = new Uint8Array(Xn), Un = 8, Kn = UPNG._bin, qn = Kn.readUshort, Jo = Kn.readUint, pa = { tabs: {}, frames: [] }, ma = new Uint8Array(zn.length), va = 0, ba, _a = 0, ya = [137, 80, 78, 71, 13, 10, 26, 10], xa = 0; xa < 8; xa++) if (zn[xa] != ya[xa]) throw "The input is not a PNG file!";
  for (; Un < zn.length; ) {
    var wa = Kn.readUint(zn, Un);
    Un += 4;
    var Ta = Kn.readASCII(zn, Un, 4);
    if (Un += 4, Ta == "IHDR")
      UPNG.decode._IHDR(zn, Un, pa);
    else if (Ta == "IDAT") {
      for (var xa = 0; xa < wa; xa++) ma[va + xa] = zn[Un + xa];
      va += wa;
    } else if (Ta == "acTL")
      pa.tabs[Ta] = { num_frames: Jo(zn, Un), num_plays: Jo(zn, Un + 4) }, ba = new Uint8Array(zn.length);
    else if (Ta == "fcTL") {
      if (_a != 0) {
        var Sa = pa.frames[pa.frames.length - 1];
        Sa.data = UPNG.decode._decompress(pa, ba.slice(0, _a), Sa.rect.width, Sa.rect.height), _a = 0;
      }
      var Ma = { x: Jo(zn, Un + 12), y: Jo(zn, Un + 16), width: Jo(zn, Un + 4), height: Jo(zn, Un + 8) }, ka = qn(zn, Un + 22);
      ka = qn(zn, Un + 20) / (ka == 0 ? 100 : ka);
      var Za = { rect: Ma, delay: Math.round(ka * 1e3), dispose: zn[Un + 24], blend: zn[Un + 25] };
      pa.frames.push(Za);
    } else if (Ta == "fdAT") {
      for (var xa = 0; xa < wa - 4; xa++) ba[_a + xa] = zn[Un + xa + 4];
      _a += wa - 4;
    } else if (Ta == "pHYs")
      pa.tabs[Ta] = [Kn.readUint(zn, Un), Kn.readUint(zn, Un + 4), zn[Un + 8]];
    else if (Ta == "cHRM") {
      pa.tabs[Ta] = [];
      for (var xa = 0; xa < 8; xa++) pa.tabs[Ta].push(Kn.readUint(zn, Un + xa * 4));
    } else if (Ta == "tEXt") {
      pa.tabs[Ta] == null && (pa.tabs[Ta] = {});
      var Na = Kn.nextZero(zn, Un), Ka = Kn.readASCII(zn, Un, Na - Un), Ja = Kn.readASCII(zn, Na + 1, Un + wa - Na - 1);
      pa.tabs[Ta][Ka] = Ja;
    } else if (Ta == "iTXt") {
      pa.tabs[Ta] == null && (pa.tabs[Ta] = {});
      var Na = 0, el = Un;
      Na = Kn.nextZero(zn, el);
      var Ka = Kn.readASCII(zn, el, Na - el);
      el = Na + 1, zn[el], zn[el + 1], el += 2, Na = Kn.nextZero(zn, el), Kn.readASCII(zn, el, Na - el), el = Na + 1, Na = Kn.nextZero(zn, el), Kn.readUTF8(zn, el, Na - el), el = Na + 1;
      var Ja = Kn.readUTF8(zn, el, wa - (el - Un));
      pa.tabs[Ta][Ka] = Ja;
    } else if (Ta == "PLTE")
      pa.tabs[Ta] = Kn.readBytes(zn, Un, wa);
    else if (Ta == "hIST") {
      var qa = pa.tabs.PLTE.length / 3;
      pa.tabs[Ta] = [];
      for (var xa = 0; xa < qa; xa++) pa.tabs[Ta].push(qn(zn, Un + xa * 2));
    } else if (Ta == "tRNS")
      pa.ctype == 3 ? pa.tabs[Ta] = Kn.readBytes(zn, Un, wa) : pa.ctype == 0 ? pa.tabs[Ta] = qn(zn, Un) : pa.ctype == 2 && (pa.tabs[Ta] = [qn(zn, Un), qn(zn, Un + 2), qn(zn, Un + 4)]);
    else if (Ta == "gAMA") pa.tabs[Ta] = Kn.readUint(zn, Un) / 1e5;
    else if (Ta == "sRGB") pa.tabs[Ta] = zn[Un];
    else if (Ta == "bKGD")
      pa.ctype == 0 || pa.ctype == 4 ? pa.tabs[Ta] = [qn(zn, Un)] : pa.ctype == 2 || pa.ctype == 6 ? pa.tabs[Ta] = [qn(zn, Un), qn(zn, Un + 2), qn(zn, Un + 4)] : pa.ctype == 3 && (pa.tabs[Ta] = zn[Un]);
    else if (Ta == "IEND")
      break;
    Un += wa, Kn.readUint(zn, Un), Un += 4;
  }
  if (_a != 0) {
    var Sa = pa.frames[pa.frames.length - 1];
    Sa.data = UPNG.decode._decompress(pa, ba.slice(0, _a), Sa.rect.width, Sa.rect.height), _a = 0;
  }
  return pa.data = UPNG.decode._decompress(pa, ma, pa.width, pa.height), delete pa.compress, delete pa.interlace, delete pa.filter, pa;
};
UPNG.decode._decompress = function(Xn, zn, Un, Kn) {
  var qn = UPNG.decode._getBPP(Xn), Jo = Math.ceil(Un * qn / 8), pa = new Uint8Array((Jo + 1 + Xn.interlace) * Kn);
  return zn = UPNG.decode._inflate(zn, pa), Xn.interlace == 0 ? zn = UPNG.decode._filterZero(zn, Xn, 0, Un, Kn) : Xn.interlace == 1 && (zn = UPNG.decode._readInterlace(zn, Xn)), zn;
};
UPNG.decode._inflate = function(Xn, zn) {
  var Un = UPNG.inflateRaw(new Uint8Array(Xn.buffer, 2, Xn.length - 6), zn);
  return Un;
};
UPNG.inflateRaw = function() {
  var Xn = {};
  return Xn.H = {}, Xn.H.N = function(zn, Un) {
    var Kn = Uint8Array, qn = 0, Jo = 0, pa = 0, ma = 0, va = 0, ba = 0, _a = 0, ya = 0, xa = 0, wa, Ta;
    if (zn[0] == 3 && zn[1] == 0) return Un || new Kn(0);
    var Sa = Xn.H, Ma = Sa.b, ka = Sa.e, Za = Sa.R, Na = Sa.n, Ka = Sa.A, Ja = Sa.Z, el = Sa.m, qa = Un == null;
    for (qa && (Un = new Kn(zn.length >>> 2 << 3)); qn == 0; ) {
      if (qn = Ma(zn, xa, 1), Jo = Ma(zn, xa + 1, 2), xa += 3, Jo == 0) {
        (xa & 7) != 0 && (xa += 8 - (xa & 7));
        var tl = (xa >>> 3) + 4, Qa = zn[tl - 4] | zn[tl - 3] << 8;
        qa && (Un = Xn.H.W(Un, ya + Qa)), Un.set(new Kn(zn.buffer, zn.byteOffset + tl, Qa), ya), xa = tl + Qa << 3, ya += Qa;
        continue;
      }
      if (qa && (Un = Xn.H.W(Un, ya + (1 << 17))), Jo == 1 && (wa = el.J, Ta = el.h, ba = 511, _a = 31), Jo == 2) {
        pa = ka(zn, xa, 5) + 257, ma = ka(zn, xa + 5, 5) + 1, va = ka(zn, xa + 10, 4) + 4, xa += 14;
        for (var nl = 1, rl = 0; rl < 38; rl += 2)
          el.Q[rl] = 0, el.Q[rl + 1] = 0;
        for (var rl = 0; rl < va; rl++) {
          var il = ka(zn, xa + rl * 3, 3);
          el.Q[(el.X[rl] << 1) + 1] = il, il > nl && (nl = il);
        }
        xa += 3 * va, Na(el.Q, nl), Ka(el.Q, nl, el.u), wa = el.w, Ta = el.d, xa = Za(el.u, (1 << nl) - 1, pa + ma, zn, xa, el.v);
        var cl = Sa.V(el.v, 0, pa, el.C);
        ba = (1 << cl) - 1;
        var ll = Sa.V(el.v, pa, ma, el.D);
        _a = (1 << ll) - 1, Na(el.C, cl), Ka(el.C, cl, wa), Na(el.D, ll), Ka(el.D, ll, Ta);
      }
      for (; ; ) {
        var al = wa[Ja(zn, xa) & ba];
        xa += al & 15;
        var sl = al >>> 4;
        if (!(sl >>> 8))
          Un[ya++] = sl;
        else {
          if (sl == 256)
            break;
          var dl = ya + sl - 254;
          if (sl > 264) {
            var El = el.q[sl - 257];
            dl = ya + (El >>> 3) + ka(zn, xa, El & 7), xa += El & 7;
          }
          var fl = Ta[Ja(zn, xa) & _a];
          xa += fl & 15;
          var Ml = fl >>> 4, Sl = el.c[Ml], ml = (Sl >>> 4) + Ma(zn, xa, Sl & 15);
          for (xa += Sl & 15; ya < dl; )
            Un[ya] = Un[ya++ - ml], Un[ya] = Un[ya++ - ml], Un[ya] = Un[ya++ - ml], Un[ya] = Un[ya++ - ml];
          ya = dl;
        }
      }
    }
    return Un.length == ya ? Un : Un.slice(0, ya);
  }, Xn.H.W = function(zn, Un) {
    var Kn = zn.length;
    if (Un <= Kn) return zn;
    var qn = new Uint8Array(Kn << 1);
    return qn.set(zn, 0), qn;
  }, Xn.H.R = function(zn, Un, Kn, qn, Jo, pa) {
    for (var ma = Xn.H.e, va = Xn.H.Z, ba = 0; ba < Kn; ) {
      var _a = zn[va(qn, Jo) & Un];
      Jo += _a & 15;
      var ya = _a >>> 4;
      if (ya <= 15)
        pa[ba] = ya, ba++;
      else {
        var xa = 0, wa = 0;
        ya == 16 ? (wa = 3 + ma(qn, Jo, 2), Jo += 2, xa = pa[ba - 1]) : ya == 17 ? (wa = 3 + ma(qn, Jo, 3), Jo += 3) : ya == 18 && (wa = 11 + ma(qn, Jo, 7), Jo += 7);
        for (var Ta = ba + wa; ba < Ta; )
          pa[ba] = xa, ba++;
      }
    }
    return Jo;
  }, Xn.H.V = function(zn, Un, Kn, qn) {
    for (var Jo = 0, pa = 0, ma = qn.length >>> 1; pa < Kn; ) {
      var va = zn[pa + Un];
      qn[pa << 1] = 0, qn[(pa << 1) + 1] = va, va > Jo && (Jo = va), pa++;
    }
    for (; pa < ma; )
      qn[pa << 1] = 0, qn[(pa << 1) + 1] = 0, pa++;
    return Jo;
  }, Xn.H.n = function(zn, Un) {
    for (var Kn = Xn.H.m, qn = zn.length, Jo, pa, ma, va, ba, _a = Kn.j, va = 0; va <= Un; va++) _a[va] = 0;
    for (va = 1; va < qn; va += 2) _a[zn[va]]++;
    var ya = Kn.K;
    for (Jo = 0, _a[0] = 0, pa = 1; pa <= Un; pa++)
      Jo = Jo + _a[pa - 1] << 1, ya[pa] = Jo;
    for (ma = 0; ma < qn; ma += 2)
      ba = zn[ma + 1], ba != 0 && (zn[ma] = ya[ba], ya[ba]++);
  }, Xn.H.A = function(zn, Un, Kn) {
    for (var qn = zn.length, Jo = Xn.H.m, pa = Jo.r, ma = 0; ma < qn; ma += 2) if (zn[ma + 1] != 0)
      for (var va = ma >> 1, ba = zn[ma + 1], _a = va << 4 | ba, ya = Un - ba, xa = zn[ma] << ya, wa = xa + (1 << ya); xa != wa; ) {
        var Ta = pa[xa] >>> 15 - Un;
        Kn[Ta] = _a, xa++;
      }
  }, Xn.H.l = function(zn, Un) {
    for (var Kn = Xn.H.m.r, qn = 15 - Un, Jo = 0; Jo < zn.length; Jo += 2) {
      var pa = zn[Jo] << Un - zn[Jo + 1];
      zn[Jo] = Kn[pa] >>> qn;
    }
  }, Xn.H.M = function(zn, Un, Kn) {
    Kn = Kn << (Un & 7);
    var qn = Un >>> 3;
    zn[qn] |= Kn, zn[qn + 1] |= Kn >>> 8;
  }, Xn.H.I = function(zn, Un, Kn) {
    Kn = Kn << (Un & 7);
    var qn = Un >>> 3;
    zn[qn] |= Kn, zn[qn + 1] |= Kn >>> 8, zn[qn + 2] |= Kn >>> 16;
  }, Xn.H.e = function(zn, Un, Kn) {
    return (zn[Un >>> 3] | zn[(Un >>> 3) + 1] << 8) >>> (Un & 7) & (1 << Kn) - 1;
  }, Xn.H.b = function(zn, Un, Kn) {
    return (zn[Un >>> 3] | zn[(Un >>> 3) + 1] << 8 | zn[(Un >>> 3) + 2] << 16) >>> (Un & 7) & (1 << Kn) - 1;
  }, Xn.H.Z = function(zn, Un) {
    return (zn[Un >>> 3] | zn[(Un >>> 3) + 1] << 8 | zn[(Un >>> 3) + 2] << 16) >>> (Un & 7);
  }, Xn.H.i = function(zn, Un) {
    return (zn[Un >>> 3] | zn[(Un >>> 3) + 1] << 8 | zn[(Un >>> 3) + 2] << 16 | zn[(Un >>> 3) + 3] << 24) >>> (Un & 7);
  }, Xn.H.m = function() {
    var zn = Uint16Array, Un = Uint32Array;
    return { K: new zn(16), j: new zn(16), X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], S: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], T: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], q: new zn(32), p: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], z: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], c: new Un(32), J: new zn(512), _: [], h: new zn(32), $: [], w: new zn(32768), C: [], v: [], d: new zn(32768), D: [], u: new zn(512), Q: [], r: new zn(32768), s: new Un(286), Y: new Un(30), a: new Un(19), t: new Un(15e3), k: new zn(65536), g: new zn(32768) };
  }(), function() {
    for (var zn = Xn.H.m, Un = 32768, Kn = 0; Kn < Un; Kn++) {
      var qn = Kn;
      qn = (qn & 2863311530) >>> 1 | (qn & 1431655765) << 1, qn = (qn & 3435973836) >>> 2 | (qn & 858993459) << 2, qn = (qn & 4042322160) >>> 4 | (qn & 252645135) << 4, qn = (qn & 4278255360) >>> 8 | (qn & 16711935) << 8, zn.r[Kn] = (qn >>> 16 | qn << 16) >>> 17;
    }
    function Jo(pa, ma, va) {
      for (; ma-- != 0; ) pa.push(0, va);
    }
    for (var Kn = 0; Kn < 32; Kn++)
      zn.q[Kn] = zn.S[Kn] << 3 | zn.T[Kn], zn.c[Kn] = zn.p[Kn] << 4 | zn.z[Kn];
    Jo(zn._, 144, 8), Jo(zn._, 112, 9), Jo(zn._, 24, 7), Jo(zn._, 8, 8), Xn.H.n(zn._, 9), Xn.H.A(zn._, 9, zn.J), Xn.H.l(zn._, 9), Jo(zn.$, 32, 5), Xn.H.n(zn.$, 5), Xn.H.A(zn.$, 5, zn.h), Xn.H.l(zn.$, 5), Jo(zn.Q, 19, 0), Jo(zn.C, 286, 0), Jo(zn.D, 30, 0), Jo(zn.v, 320, 0);
  }(), Xn.H.N;
}();
UPNG.decode._readInterlace = function(Xn, zn) {
  for (var Un = zn.width, Kn = zn.height, qn = UPNG.decode._getBPP(zn), Jo = qn >> 3, pa = Math.ceil(Un * qn / 8), ma = new Uint8Array(Kn * pa), va = 0, ba = [0, 0, 4, 0, 2, 0, 1], _a = [0, 4, 0, 2, 0, 1, 0], ya = [8, 8, 8, 4, 4, 2, 2], xa = [8, 8, 4, 4, 2, 2, 1], wa = 0; wa < 7; ) {
    for (var Ta = ya[wa], Sa = xa[wa], Ma = 0, ka = 0, Za = ba[wa]; Za < Kn; )
      Za += Ta, ka++;
    for (var Na = _a[wa]; Na < Un; )
      Na += Sa, Ma++;
    var Ka = Math.ceil(Ma * qn / 8);
    UPNG.decode._filterZero(Xn, zn, va, Ma, ka);
    for (var Ja = 0, el = ba[wa]; el < Kn; ) {
      for (var qa = _a[wa], tl = va + Ja * Ka << 3; qa < Un; ) {
        if (qn == 1) {
          var Qa = Xn[tl >> 3];
          Qa = Qa >> 7 - (tl & 7) & 1, ma[el * pa + (qa >> 3)] |= Qa << 7 - ((qa & 7) << 0);
        }
        if (qn == 2) {
          var Qa = Xn[tl >> 3];
          Qa = Qa >> 6 - (tl & 7) & 3, ma[el * pa + (qa >> 2)] |= Qa << 6 - ((qa & 3) << 1);
        }
        if (qn == 4) {
          var Qa = Xn[tl >> 3];
          Qa = Qa >> 4 - (tl & 7) & 15, ma[el * pa + (qa >> 1)] |= Qa << 4 - ((qa & 1) << 2);
        }
        if (qn >= 8)
          for (var nl = el * pa + qa * Jo, rl = 0; rl < Jo; rl++) ma[nl + rl] = Xn[(tl >> 3) + rl];
        tl += qn, qa += Sa;
      }
      Ja++, el += Ta;
    }
    Ma * ka != 0 && (va += ka * (1 + Ka)), wa = wa + 1;
  }
  return ma;
};
UPNG.decode._getBPP = function(Xn) {
  var zn = [1, null, 3, 1, 2, null, 4][Xn.ctype];
  return zn * Xn.depth;
};
UPNG.decode._filterZero = function(Xn, zn, Un, Kn, qn) {
  var Jo = UPNG.decode._getBPP(zn), pa = Math.ceil(Kn * Jo / 8), ma = UPNG.decode._paeth;
  Jo = Math.ceil(Jo / 8);
  var va = 0, ba = 1, _a = Xn[Un], ya = 0;
  if (_a > 1 && (Xn[Un] = [0, 0, 1][_a - 2]), _a == 3) for (ya = Jo; ya < pa; ya++) Xn[ya + 1] = Xn[ya + 1] + (Xn[ya + 1 - Jo] >>> 1) & 255;
  for (var xa = 0; xa < qn; xa++)
    if (va = Un + xa * pa, ba = va + xa + 1, _a = Xn[ba - 1], ya = 0, _a == 0) for (; ya < pa; ya++) Xn[va + ya] = Xn[ba + ya];
    else if (_a == 1) {
      for (; ya < Jo; ya++) Xn[va + ya] = Xn[ba + ya];
      for (; ya < pa; ya++) Xn[va + ya] = Xn[ba + ya] + Xn[va + ya - Jo];
    } else if (_a == 2)
      for (; ya < pa; ya++) Xn[va + ya] = Xn[ba + ya] + Xn[va + ya - pa];
    else if (_a == 3) {
      for (; ya < Jo; ya++) Xn[va + ya] = Xn[ba + ya] + (Xn[va + ya - pa] >>> 1);
      for (; ya < pa; ya++) Xn[va + ya] = Xn[ba + ya] + (Xn[va + ya - pa] + Xn[va + ya - Jo] >>> 1);
    } else {
      for (; ya < Jo; ya++) Xn[va + ya] = Xn[ba + ya] + ma(0, Xn[va + ya - pa], 0);
      for (; ya < pa; ya++) Xn[va + ya] = Xn[ba + ya] + ma(Xn[va + ya - Jo], Xn[va + ya - pa], Xn[va + ya - Jo - pa]);
    }
  return Xn;
};
UPNG.decode._paeth = function(Xn, zn, Un) {
  var Kn = Xn + zn - Un, qn = Kn - Xn, Jo = Kn - zn, pa = Kn - Un;
  return qn * qn <= Jo * Jo && qn * qn <= pa * pa ? Xn : Jo * Jo <= pa * pa ? zn : Un;
};
UPNG.decode._IHDR = function(Xn, zn, Un) {
  var Kn = UPNG._bin;
  Un.width = Kn.readUint(Xn, zn), zn += 4, Un.height = Kn.readUint(Xn, zn), zn += 4, Un.depth = Xn[zn], zn++, Un.ctype = Xn[zn], zn++, Un.compress = Xn[zn], zn++, Un.filter = Xn[zn], zn++, Un.interlace = Xn[zn], zn++;
};
UPNG._bin = {
  nextZero: function(Xn, zn) {
    for (; Xn[zn] != 0; ) zn++;
    return zn;
  },
  readUshort: function(Xn, zn) {
    return Xn[zn] << 8 | Xn[zn + 1];
  },
  writeUshort: function(Xn, zn, Un) {
    Xn[zn] = Un >> 8 & 255, Xn[zn + 1] = Un & 255;
  },
  readUint: function(Xn, zn) {
    return Xn[zn] * (256 * 256 * 256) + (Xn[zn + 1] << 16 | Xn[zn + 2] << 8 | Xn[zn + 3]);
  },
  writeUint: function(Xn, zn, Un) {
    Xn[zn] = Un >> 24 & 255, Xn[zn + 1] = Un >> 16 & 255, Xn[zn + 2] = Un >> 8 & 255, Xn[zn + 3] = Un & 255;
  },
  readASCII: function(Xn, zn, Un) {
    for (var Kn = "", qn = 0; qn < Un; qn++) Kn += String.fromCharCode(Xn[zn + qn]);
    return Kn;
  },
  writeASCII: function(Xn, zn, Un) {
    for (var Kn = 0; Kn < Un.length; Kn++) Xn[zn + Kn] = Un.charCodeAt(Kn);
  },
  readBytes: function(Xn, zn, Un) {
    for (var Kn = [], qn = 0; qn < Un; qn++) Kn.push(Xn[zn + qn]);
    return Kn;
  },
  pad: function(Xn) {
    return Xn.length < 2 ? "0" + Xn : Xn;
  },
  readUTF8: function(Xn, zn, Un) {
    for (var Kn = "", qn, Jo = 0; Jo < Un; Jo++) Kn += "%" + UPNG._bin.pad(Xn[zn + Jo].toString(16));
    try {
      qn = decodeURIComponent(Kn);
    } catch {
      return UPNG._bin.readASCII(Xn, zn, Un);
    }
    return qn;
  }
};
UPNG._copyTile = function(Xn, zn, Un, Kn, qn, Jo, pa, ma, va) {
  for (var ba = Math.min(zn, qn), _a = Math.min(Un, Jo), ya = 0, xa = 0, wa = 0; wa < _a; wa++)
    for (var Ta = 0; Ta < ba; Ta++)
      if (pa >= 0 && ma >= 0 ? (ya = wa * zn + Ta << 2, xa = (ma + wa) * qn + pa + Ta << 2) : (ya = (-ma + wa) * zn - pa + Ta << 2, xa = wa * qn + Ta << 2), va == 0)
        Kn[xa] = Xn[ya], Kn[xa + 1] = Xn[ya + 1], Kn[xa + 2] = Xn[ya + 2], Kn[xa + 3] = Xn[ya + 3];
      else if (va == 1) {
        var Sa = Xn[ya + 3] * 0.00392156862745098, Ma = Xn[ya] * Sa, ka = Xn[ya + 1] * Sa, Za = Xn[ya + 2] * Sa, Na = Kn[xa + 3] * (1 / 255), Ka = Kn[xa] * Na, Ja = Kn[xa + 1] * Na, el = Kn[xa + 2] * Na, qa = 1 - Sa, tl = Sa + Na * qa, Qa = tl == 0 ? 0 : 1 / tl;
        Kn[xa + 3] = 255 * tl, Kn[xa + 0] = (Ma + Ka * qa) * Qa, Kn[xa + 1] = (ka + Ja * qa) * Qa, Kn[xa + 2] = (Za + el * qa) * Qa;
      } else if (va == 2) {
        var Sa = Xn[ya + 3], Ma = Xn[ya], ka = Xn[ya + 1], Za = Xn[ya + 2], Na = Kn[xa + 3], Ka = Kn[xa], Ja = Kn[xa + 1], el = Kn[xa + 2];
        Sa == Na && Ma == Ka && ka == Ja && Za == el ? (Kn[xa] = 0, Kn[xa + 1] = 0, Kn[xa + 2] = 0, Kn[xa + 3] = 0) : (Kn[xa] = Ma, Kn[xa + 1] = ka, Kn[xa + 2] = Za, Kn[xa + 3] = Sa);
      } else if (va == 3) {
        var Sa = Xn[ya + 3], Ma = Xn[ya], ka = Xn[ya + 1], Za = Xn[ya + 2], Na = Kn[xa + 3], Ka = Kn[xa], Ja = Kn[xa + 1], el = Kn[xa + 2];
        if (Sa == Na && Ma == Ka && ka == Ja && Za == el) continue;
        if (Sa < 220 && Na > 20) return !1;
      }
  return !0;
};
UPNG.encode = function(Xn, zn, Un, Kn, qn, Jo, pa) {
  Kn == null && (Kn = 0), pa == null && (pa = !1);
  var ma = UPNG.encode.compress(Xn, zn, Un, Kn, [!1, !1, !1, 0, pa]);
  return UPNG.encode.compressPNG(ma, -1), UPNG.encode._main(ma, zn, Un, qn, Jo);
};
UPNG.encodeLL = function(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  for (var va = { ctype: 0 + (Kn == 1 ? 0 : 2) + (qn == 0 ? 0 : 4), depth: Jo, frames: [] }, ba = (Kn + qn) * Jo, _a = ba * zn, ya = 0; ya < Xn.length; ya++)
    va.frames.push({ rect: { x: 0, y: 0, width: zn, height: Un }, img: new Uint8Array(Xn[ya]), blend: 0, dispose: 1, bpp: Math.ceil(ba / 8), bpl: Math.ceil(_a / 8) });
  UPNG.encode.compressPNG(va, 0, !0);
  var xa = UPNG.encode._main(va, zn, Un, pa, ma);
  return xa;
};
UPNG.encode._main = function(Xn, zn, Un, Kn, qn) {
  qn == null && (qn = {});
  var Jo = UPNG.crc.crc, pa = UPNG._bin.writeUint, ma = UPNG._bin.writeUshort, va = UPNG._bin.writeASCII, ba = 8, _a = Xn.frames.length > 1, ya = !1, xa = 33 + (_a ? 20 : 0);
  if (qn.sRGB != null && (xa += 13), qn.pHYs != null && (xa += 21), Xn.ctype == 3) {
    for (var wa = Xn.plte.length, Ta = 0; Ta < wa; Ta++) Xn.plte[Ta] >>> 24 != 255 && (ya = !0);
    xa += 8 + wa * 3 + 4 + (ya ? 8 + wa * 1 + 4 : 0);
  }
  for (var Sa = 0; Sa < Xn.frames.length; Sa++) {
    var Ma = Xn.frames[Sa];
    _a && (xa += 38), xa += Ma.cimg.length + 12, Sa != 0 && (xa += 4);
  }
  xa += 12;
  for (var ka = new Uint8Array(xa), Za = [137, 80, 78, 71, 13, 10, 26, 10], Ta = 0; Ta < 8; Ta++) ka[Ta] = Za[Ta];
  if (pa(ka, ba, 13), ba += 4, va(ka, ba, "IHDR"), ba += 4, pa(ka, ba, zn), ba += 4, pa(ka, ba, Un), ba += 4, ka[ba] = Xn.depth, ba++, ka[ba] = Xn.ctype, ba++, ka[ba] = 0, ba++, ka[ba] = 0, ba++, ka[ba] = 0, ba++, pa(ka, ba, Jo(ka, ba - 17, 17)), ba += 4, qn.sRGB != null && (pa(ka, ba, 1), ba += 4, va(ka, ba, "sRGB"), ba += 4, ka[ba] = qn.sRGB, ba++, pa(ka, ba, Jo(ka, ba - 5, 5)), ba += 4), qn.pHYs != null && (pa(ka, ba, 9), ba += 4, va(ka, ba, "pHYs"), ba += 4, pa(ka, ba, qn.pHYs[0]), ba += 4, pa(ka, ba, qn.pHYs[1]), ba += 4, ka[ba] = qn.pHYs[2], ba++, pa(ka, ba, Jo(ka, ba - 13, 13)), ba += 4), _a && (pa(ka, ba, 8), ba += 4, va(ka, ba, "acTL"), ba += 4, pa(ka, ba, Xn.frames.length), ba += 4, pa(ka, ba, qn.loop != null ? qn.loop : 0), ba += 4, pa(ka, ba, Jo(ka, ba - 12, 12)), ba += 4), Xn.ctype == 3) {
    var wa = Xn.plte.length;
    pa(ka, ba, wa * 3), ba += 4, va(ka, ba, "PLTE"), ba += 4;
    for (var Ta = 0; Ta < wa; Ta++) {
      var Na = Ta * 3, Ka = Xn.plte[Ta], Ja = Ka & 255, el = Ka >>> 8 & 255, qa = Ka >>> 16 & 255;
      ka[ba + Na + 0] = Ja, ka[ba + Na + 1] = el, ka[ba + Na + 2] = qa;
    }
    if (ba += wa * 3, pa(ka, ba, Jo(ka, ba - wa * 3 - 4, wa * 3 + 4)), ba += 4, ya) {
      pa(ka, ba, wa), ba += 4, va(ka, ba, "tRNS"), ba += 4;
      for (var Ta = 0; Ta < wa; Ta++) ka[ba + Ta] = Xn.plte[Ta] >>> 24 & 255;
      ba += wa, pa(ka, ba, Jo(ka, ba - wa - 4, wa + 4)), ba += 4;
    }
  }
  for (var tl = 0, Sa = 0; Sa < Xn.frames.length; Sa++) {
    var Ma = Xn.frames[Sa];
    _a && (pa(ka, ba, 26), ba += 4, va(ka, ba, "fcTL"), ba += 4, pa(ka, ba, tl++), ba += 4, pa(ka, ba, Ma.rect.width), ba += 4, pa(ka, ba, Ma.rect.height), ba += 4, pa(ka, ba, Ma.rect.x), ba += 4, pa(ka, ba, Ma.rect.y), ba += 4, ma(ka, ba, Kn[Sa]), ba += 2, ma(ka, ba, 1e3), ba += 2, ka[ba] = Ma.dispose, ba++, ka[ba] = Ma.blend, ba++, pa(ka, ba, Jo(ka, ba - 30, 30)), ba += 4);
    var Qa = Ma.cimg, wa = Qa.length;
    pa(ka, ba, wa + (Sa == 0 ? 0 : 4)), ba += 4;
    var nl = ba;
    va(ka, ba, Sa == 0 ? "IDAT" : "fdAT"), ba += 4, Sa != 0 && (pa(ka, ba, tl++), ba += 4), ka.set(Qa, ba), ba += wa, pa(ka, ba, Jo(ka, nl, ba - nl)), ba += 4;
  }
  return pa(ka, ba, 0), ba += 4, va(ka, ba, "IEND"), ba += 4, pa(ka, ba, Jo(ka, ba - 4, 4)), ba += 4, ka.buffer;
};
UPNG.encode.compressPNG = function(Xn, zn, Un) {
  for (var Kn = 0; Kn < Xn.frames.length; Kn++) {
    var qn = Xn.frames[Kn];
    qn.rect.width;
    var Jo = qn.rect.height, pa = new Uint8Array(Jo * qn.bpl + Jo);
    qn.cimg = UPNG.encode._filterZero(qn.img, Jo, qn.bpp, qn.bpl, pa, zn, Un);
  }
};
UPNG.encode.compress = function(Xn, zn, Un, Kn, qn) {
  for (var Jo = qn[0], pa = qn[1], ma = qn[2], va = qn[3], ba = qn[4], _a = 6, ya = 8, xa = 255, wa = 0; wa < Xn.length; wa++)
    for (var Ta = new Uint8Array(Xn[wa]), Sa = Ta.length, Ma = 0; Ma < Sa; Ma += 4) xa &= Ta[Ma + 3];
  var ka = xa != 255, Za = UPNG.encode.framize(Xn, zn, Un, Jo, pa, ma), Na = {}, Ka = [], Ja = [];
  if (Kn != 0) {
    for (var el = [], Ma = 0; Ma < Za.length; Ma++) el.push(Za[Ma].img.buffer);
    for (var qa = UPNG.encode.concatRGBA(el), tl = UPNG.quantize(qa, Kn), Qa = 0, nl = new Uint8Array(tl.abuf), Ma = 0; Ma < Za.length; Ma++) {
      var rl = Za[Ma].img, il = rl.length;
      Ja.push(new Uint8Array(tl.inds.buffer, Qa >> 2, il >> 2));
      for (var wa = 0; wa < il; wa += 4)
        rl[wa] = nl[Qa + wa], rl[wa + 1] = nl[Qa + wa + 1], rl[wa + 2] = nl[Qa + wa + 2], rl[wa + 3] = nl[Qa + wa + 3];
      Qa += il;
    }
    for (var Ma = 0; Ma < tl.plte.length; Ma++) Ka.push(tl.plte[Ma].est.rgba);
  } else
    for (var wa = 0; wa < Za.length; wa++) {
      var cl = Za[wa], ll = new Uint32Array(cl.img.buffer), al = cl.rect.width, Sa = ll.length, sl = new Uint8Array(Sa);
      Ja.push(sl);
      for (var Ma = 0; Ma < Sa; Ma++) {
        var dl = ll[Ma];
        if (Ma != 0 && dl == ll[Ma - 1]) sl[Ma] = sl[Ma - 1];
        else if (Ma > al && dl == ll[Ma - al]) sl[Ma] = sl[Ma - al];
        else {
          var El = Na[dl];
          if (El == null && (Na[dl] = El = Ka.length, Ka.push(dl), Ka.length >= 300))
            break;
          sl[Ma] = El;
        }
      }
    }
  var fl = Ka.length;
  fl <= 256 && ba == !1 && (fl <= 2 ? ya = 1 : fl <= 4 ? ya = 2 : fl <= 16 ? ya = 4 : ya = 8, ya = Math.max(ya, va));
  for (var wa = 0; wa < Za.length; wa++) {
    var cl = Za[wa];
    cl.rect.x, cl.rect.y;
    var al = cl.rect.width, Ml = cl.rect.height, Sl = cl.img;
    new Uint32Array(Sl.buffer);
    var ml = 4 * al, Dl = 4;
    if (fl <= 256 && ba == !1) {
      ml = Math.ceil(ya * al / 8);
      for (var _l = new Uint8Array(ml * Ml), gl = Ja[wa], Fl = 0; Fl < Ml; Fl++) {
        var Ma = Fl * ml, Nl = Fl * al;
        if (ya == 8) for (var zl = 0; zl < al; zl++) _l[Ma + zl] = gl[Nl + zl];
        else if (ya == 4) for (var zl = 0; zl < al; zl++) _l[Ma + (zl >> 1)] |= gl[Nl + zl] << 4 - (zl & 1) * 4;
        else if (ya == 2) for (var zl = 0; zl < al; zl++) _l[Ma + (zl >> 2)] |= gl[Nl + zl] << 6 - (zl & 3) * 2;
        else if (ya == 1) for (var zl = 0; zl < al; zl++) _l[Ma + (zl >> 3)] |= gl[Nl + zl] << 7 - (zl & 7) * 1;
      }
      Sl = _l, _a = 3, Dl = 1;
    } else if (ka == !1 && Za.length == 1) {
      for (var _l = new Uint8Array(al * Ml * 3), Zl = al * Ml, Ma = 0; Ma < Zl; Ma++) {
        var rl = Ma * 3, kl = Ma * 4;
        _l[rl] = Sl[kl], _l[rl + 1] = Sl[kl + 1], _l[rl + 2] = Sl[kl + 2];
      }
      Sl = _l, _a = 2, Dl = 3, ml = 3 * al;
    }
    cl.img = Sl, cl.bpl = ml, cl.bpp = Dl;
  }
  return { ctype: _a, depth: ya, plte: Ka, frames: Za };
};
UPNG.encode.framize = function(Xn, zn, Un, Kn, qn, Jo) {
  for (var pa = [], ma = 0; ma < Xn.length; ma++) {
    var va = new Uint8Array(Xn[ma]), ba = new Uint32Array(va.buffer), _a, ya = 0, xa = 0, wa = zn, Ta = Un, Sa = Kn ? 1 : 0;
    if (ma != 0) {
      for (var Ma = Jo || Kn || ma == 1 || pa[ma - 2].dispose != 0 ? 1 : 2, ka = 0, Za = 1e9, Na = 0; Na < Ma; Na++) {
        for (var cl = new Uint8Array(Xn[ma - 1 - Na]), Ka = new Uint32Array(Xn[ma - 1 - Na]), Ja = zn, el = Un, qa = -1, tl = -1, Qa = 0; Qa < Un; Qa++) for (var nl = 0; nl < zn; nl++) {
          var rl = Qa * zn + nl;
          ba[rl] != Ka[rl] && (nl < Ja && (Ja = nl), nl > qa && (qa = nl), Qa < el && (el = Qa), Qa > tl && (tl = Qa));
        }
        qa == -1 && (Ja = el = qa = tl = 0), qn && ((Ja & 1) == 1 && Ja--, (el & 1) == 1 && el--);
        var il = (qa - Ja + 1) * (tl - el + 1);
        il < Za && (Za = il, ka = Na, ya = Ja, xa = el, wa = qa - Ja + 1, Ta = tl - el + 1);
      }
      var cl = new Uint8Array(Xn[ma - 1 - ka]);
      ka == 1 && (pa[ma - 1].dispose = 2), _a = new Uint8Array(wa * Ta * 4), UPNG._copyTile(cl, zn, Un, _a, wa, Ta, -ya, -xa, 0), Sa = UPNG._copyTile(va, zn, Un, _a, wa, Ta, -ya, -xa, 3) ? 1 : 0, Sa == 1 ? UPNG.encode._prepareDiff(va, zn, Un, _a, { x: ya, y: xa, width: wa, height: Ta }) : UPNG._copyTile(va, zn, Un, _a, wa, Ta, -ya, -xa, 0);
    } else _a = va.slice(0);
    pa.push({ rect: { x: ya, y: xa, width: wa, height: Ta }, img: _a, blend: Sa, dispose: 0 });
  }
  if (Kn) for (var ma = 0; ma < pa.length; ma++) {
    var ll = pa[ma];
    if (ll.blend != 1) {
      var al = ll.rect, sl = pa[ma - 1].rect, dl = Math.min(al.x, sl.x), El = Math.min(al.y, sl.y), fl = Math.max(al.x + al.width, sl.x + sl.width), Ml = Math.max(al.y + al.height, sl.y + sl.height), Sl = { x: dl, y: El, width: fl - dl, height: Ml - El };
      pa[ma - 1].dispose = 1, ma - 1 != 0 && UPNG.encode._updateFrame(Xn, zn, Un, pa, ma - 1, Sl, qn), UPNG.encode._updateFrame(Xn, zn, Un, pa, ma, Sl, qn);
    }
  }
  var ml = 0;
  if (Xn.length != 1) for (var rl = 0; rl < pa.length; rl++) {
    var ll = pa[rl];
    ml += ll.rect.width * ll.rect.height;
  }
  return pa;
};
UPNG.encode._updateFrame = function(Xn, zn, Un, Kn, qn, Jo, pa) {
  for (var ma = Uint8Array, va = Uint32Array, ba = new ma(Xn[qn - 1]), _a = new va(Xn[qn - 1]), ya = qn + 1 < Xn.length ? new ma(Xn[qn + 1]) : null, xa = new ma(Xn[qn]), wa = new va(xa.buffer), Ta = zn, Sa = Un, Ma = -1, ka = -1, Za = 0; Za < Jo.height; Za++) for (var Na = 0; Na < Jo.width; Na++) {
    var Ka = Jo.x + Na, Ja = Jo.y + Za, el = Ja * zn + Ka, qa = wa[el];
    qa == 0 || Kn[qn - 1].dispose == 0 && _a[el] == qa && (ya == null || ya[el * 4 + 3] != 0) || (Ka < Ta && (Ta = Ka), Ka > Ma && (Ma = Ka), Ja < Sa && (Sa = Ja), Ja > ka && (ka = Ja));
  }
  Ma == -1 && (Ta = Sa = Ma = ka = 0), pa && ((Ta & 1) == 1 && Ta--, (Sa & 1) == 1 && Sa--), Jo = { x: Ta, y: Sa, width: Ma - Ta + 1, height: ka - Sa + 1 };
  var tl = Kn[qn];
  tl.rect = Jo, tl.blend = 1, tl.img = new Uint8Array(Jo.width * Jo.height * 4), Kn[qn - 1].dispose == 0 ? (UPNG._copyTile(ba, zn, Un, tl.img, Jo.width, Jo.height, -Jo.x, -Jo.y, 0), UPNG.encode._prepareDiff(xa, zn, Un, tl.img, Jo)) : UPNG._copyTile(xa, zn, Un, tl.img, Jo.width, Jo.height, -Jo.x, -Jo.y, 0);
};
UPNG.encode._prepareDiff = function(Xn, zn, Un, Kn, qn) {
  UPNG._copyTile(Xn, zn, Un, Kn, qn.width, qn.height, -qn.x, -qn.y, 2);
};
UPNG.encode._filterZero = function(Xn, zn, Un, Kn, qn, Jo, pa) {
  var ma = [], va = [0, 1, 2, 3, 4];
  Jo != -1 ? va = [Jo] : (zn * Kn > 5e5 || Un == 1) && (va = [0]);
  var ba;
  pa && (ba = { level: 0 });
  for (var _a = pa && UZIP != null ? UZIP : pako$1, ya = 0; ya < va.length; ya++) {
    for (var xa = 0; xa < zn; xa++) UPNG.encode._filterLine(qn, Xn, xa, Kn, Un, va[ya]);
    ma.push(_a.deflate(qn, ba));
  }
  for (var wa, Ta = 1e9, ya = 0; ya < ma.length; ya++) ma[ya].length < Ta && (wa = ya, Ta = ma[ya].length);
  return ma[wa];
};
UPNG.encode._filterLine = function(Xn, zn, Un, Kn, qn, Jo) {
  var pa = Un * Kn, ma = pa + Un, va = UPNG.decode._paeth;
  if (Xn[ma] = Jo, ma++, Jo == 0)
    if (Kn < 500) for (var ba = 0; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba];
    else Xn.set(new Uint8Array(zn.buffer, pa, Kn), ma);
  else if (Jo == 1) {
    for (var ba = 0; ba < qn; ba++) Xn[ma + ba] = zn[pa + ba];
    for (var ba = qn; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba] - zn[pa + ba - qn] + 256 & 255;
  } else if (Un == 0) {
    for (var ba = 0; ba < qn; ba++) Xn[ma + ba] = zn[pa + ba];
    if (Jo == 2) for (var ba = qn; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba];
    if (Jo == 3) for (var ba = qn; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba] - (zn[pa + ba - qn] >> 1) + 256 & 255;
    if (Jo == 4) for (var ba = qn; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba] - va(zn[pa + ba - qn], 0, 0) + 256 & 255;
  } else {
    if (Jo == 2)
      for (var ba = 0; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba] + 256 - zn[pa + ba - Kn] & 255;
    if (Jo == 3) {
      for (var ba = 0; ba < qn; ba++) Xn[ma + ba] = zn[pa + ba] + 256 - (zn[pa + ba - Kn] >> 1) & 255;
      for (var ba = qn; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba] + 256 - (zn[pa + ba - Kn] + zn[pa + ba - qn] >> 1) & 255;
    }
    if (Jo == 4) {
      for (var ba = 0; ba < qn; ba++) Xn[ma + ba] = zn[pa + ba] + 256 - va(0, zn[pa + ba - Kn], 0) & 255;
      for (var ba = qn; ba < Kn; ba++) Xn[ma + ba] = zn[pa + ba] + 256 - va(zn[pa + ba - qn], zn[pa + ba - Kn], zn[pa + ba - qn - Kn]) & 255;
    }
  }
};
UPNG.crc = {
  table: function() {
    for (var Xn = new Uint32Array(256), zn = 0; zn < 256; zn++) {
      for (var Un = zn, Kn = 0; Kn < 8; Kn++)
        Un & 1 ? Un = 3988292384 ^ Un >>> 1 : Un = Un >>> 1;
      Xn[zn] = Un;
    }
    return Xn;
  }(),
  update: function(Xn, zn, Un, Kn) {
    for (var qn = 0; qn < Kn; qn++) Xn = UPNG.crc.table[(Xn ^ zn[Un + qn]) & 255] ^ Xn >>> 8;
    return Xn;
  },
  crc: function(Xn, zn, Un) {
    return UPNG.crc.update(4294967295, Xn, zn, Un) ^ 4294967295;
  }
};
UPNG.quantize = function(Xn, zn) {
  var Un = new Uint8Array(Xn), Kn = Un.slice(0), qn = new Uint32Array(Kn.buffer), Jo = UPNG.quantize.getKDtree(Kn, zn), pa = Jo[0], ma = Jo[1];
  UPNG.quantize.planeDst;
  for (var va = Un, ba = qn, _a = va.length, ya = new Uint8Array(Un.length >> 2), xa = 0; xa < _a; xa += 4) {
    var wa = va[xa] * 0.00392156862745098, Ta = va[xa + 1] * (1 / 255), Sa = va[xa + 2] * (1 / 255), Ma = va[xa + 3] * (1 / 255), ka = UPNG.quantize.getNearest(pa, wa, Ta, Sa, Ma);
    ya[xa >> 2] = ka.ind, ba[xa >> 2] = ka.est.rgba;
  }
  return { abuf: Kn.buffer, inds: ya, plte: ma };
};
UPNG.quantize.getKDtree = function(Xn, zn, Un) {
  Un == null && (Un = 1e-4);
  var Kn = new Uint32Array(Xn.buffer), qn = { i0: 0, i1: Xn.length, bst: null, est: null, tdst: 0, left: null, right: null };
  qn.bst = UPNG.quantize.stats(Xn, qn.i0, qn.i1), qn.est = UPNG.quantize.estats(qn.bst);
  for (var Jo = [qn]; Jo.length < zn; ) {
    for (var pa = 0, ma = 0, va = 0; va < Jo.length; va++) Jo[va].est.L > pa && (pa = Jo[va].est.L, ma = va);
    if (pa < Un) break;
    var ba = Jo[ma], _a = UPNG.quantize.splitPixels(Xn, Kn, ba.i0, ba.i1, ba.est.e, ba.est.eMq255), ya = ba.i0 >= _a || ba.i1 <= _a;
    if (ya) {
      ba.est.L = 0;
      continue;
    }
    var xa = { i0: ba.i0, i1: _a, bst: null, est: null, tdst: 0, left: null, right: null };
    xa.bst = UPNG.quantize.stats(Xn, xa.i0, xa.i1), xa.est = UPNG.quantize.estats(xa.bst);
    var wa = { i0: _a, i1: ba.i1, bst: null, est: null, tdst: 0, left: null, right: null };
    wa.bst = { R: [], m: [], N: ba.bst.N - xa.bst.N };
    for (var va = 0; va < 16; va++) wa.bst.R[va] = ba.bst.R[va] - xa.bst.R[va];
    for (var va = 0; va < 4; va++) wa.bst.m[va] = ba.bst.m[va] - xa.bst.m[va];
    wa.est = UPNG.quantize.estats(wa.bst), ba.left = xa, ba.right = wa, Jo[ma] = xa, Jo.push(wa);
  }
  Jo.sort(function(Ta, Sa) {
    return Sa.bst.N - Ta.bst.N;
  });
  for (var va = 0; va < Jo.length; va++) Jo[va].ind = va;
  return [qn, Jo];
};
UPNG.quantize.getNearest = function(Xn, zn, Un, Kn, qn) {
  if (Xn.left == null)
    return Xn.tdst = UPNG.quantize.dist(Xn.est.q, zn, Un, Kn, qn), Xn;
  var Jo = UPNG.quantize.planeDst(Xn.est, zn, Un, Kn, qn), pa = Xn.left, ma = Xn.right;
  Jo > 0 && (pa = Xn.right, ma = Xn.left);
  var va = UPNG.quantize.getNearest(pa, zn, Un, Kn, qn);
  if (va.tdst <= Jo * Jo) return va;
  var ba = UPNG.quantize.getNearest(ma, zn, Un, Kn, qn);
  return ba.tdst < va.tdst ? ba : va;
};
UPNG.quantize.planeDst = function(Xn, zn, Un, Kn, qn) {
  var Jo = Xn.e;
  return Jo[0] * zn + Jo[1] * Un + Jo[2] * Kn + Jo[3] * qn - Xn.eMq;
};
UPNG.quantize.dist = function(Xn, zn, Un, Kn, qn) {
  var Jo = zn - Xn[0], pa = Un - Xn[1], ma = Kn - Xn[2], va = qn - Xn[3];
  return Jo * Jo + pa * pa + ma * ma + va * va;
};
UPNG.quantize.splitPixels = function(Xn, zn, Un, Kn, qn, Jo) {
  var pa = UPNG.quantize.vecDot;
  for (Kn -= 4; Un < Kn; ) {
    for (; pa(Xn, Un, qn) <= Jo; ) Un += 4;
    for (; pa(Xn, Kn, qn) > Jo; ) Kn -= 4;
    if (Un >= Kn) break;
    var ma = zn[Un >> 2];
    zn[Un >> 2] = zn[Kn >> 2], zn[Kn >> 2] = ma, Un += 4, Kn -= 4;
  }
  for (; pa(Xn, Un, qn) > Jo; ) Un -= 4;
  return Un + 4;
};
UPNG.quantize.vecDot = function(Xn, zn, Un) {
  return Xn[zn] * Un[0] + Xn[zn + 1] * Un[1] + Xn[zn + 2] * Un[2] + Xn[zn + 3] * Un[3];
};
UPNG.quantize.stats = function(Xn, zn, Un) {
  for (var Kn = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], qn = [0, 0, 0, 0], Jo = Un - zn >> 2, pa = zn; pa < Un; pa += 4) {
    var ma = Xn[pa] * 0.00392156862745098, va = Xn[pa + 1] * (1 / 255), ba = Xn[pa + 2] * (1 / 255), _a = Xn[pa + 3] * (1 / 255);
    qn[0] += ma, qn[1] += va, qn[2] += ba, qn[3] += _a, Kn[0] += ma * ma, Kn[1] += ma * va, Kn[2] += ma * ba, Kn[3] += ma * _a, Kn[5] += va * va, Kn[6] += va * ba, Kn[7] += va * _a, Kn[10] += ba * ba, Kn[11] += ba * _a, Kn[15] += _a * _a;
  }
  return Kn[4] = Kn[1], Kn[8] = Kn[2], Kn[9] = Kn[6], Kn[12] = Kn[3], Kn[13] = Kn[7], Kn[14] = Kn[11], { R: Kn, m: qn, N: Jo };
};
UPNG.quantize.estats = function(Xn) {
  var zn = Xn.R, Un = Xn.m, Kn = Xn.N, qn = Un[0], Jo = Un[1], pa = Un[2], ma = Un[3], va = Kn == 0 ? 0 : 1 / Kn, ba = [
    zn[0] - qn * qn * va,
    zn[1] - qn * Jo * va,
    zn[2] - qn * pa * va,
    zn[3] - qn * ma * va,
    zn[4] - Jo * qn * va,
    zn[5] - Jo * Jo * va,
    zn[6] - Jo * pa * va,
    zn[7] - Jo * ma * va,
    zn[8] - pa * qn * va,
    zn[9] - pa * Jo * va,
    zn[10] - pa * pa * va,
    zn[11] - pa * ma * va,
    zn[12] - ma * qn * va,
    zn[13] - ma * Jo * va,
    zn[14] - ma * pa * va,
    zn[15] - ma * ma * va
  ], _a = ba, ya = UPNG.M4, xa = [0.5, 0.5, 0.5, 0.5], wa = 0, Ta = 0;
  if (Kn != 0)
    for (var Sa = 0; Sa < 10 && (xa = ya.multVec(_a, xa), Ta = Math.sqrt(ya.dot(xa, xa)), xa = ya.sml(1 / Ta, xa), !(Math.abs(Ta - wa) < 1e-9)); Sa++)
      wa = Ta;
  var Ma = [qn * va, Jo * va, pa * va, ma * va], ka = ya.dot(ya.sml(255, Ma), xa);
  return {
    Cov: ba,
    q: Ma,
    e: xa,
    L: wa,
    eMq255: ka,
    eMq: ya.dot(xa, Ma),
    rgba: (Math.round(255 * Ma[3]) << 24 | Math.round(255 * Ma[2]) << 16 | Math.round(255 * Ma[1]) << 8 | Math.round(255 * Ma[0]) << 0) >>> 0
  };
};
UPNG.M4 = {
  multVec: function(Xn, zn) {
    return [
      Xn[0] * zn[0] + Xn[1] * zn[1] + Xn[2] * zn[2] + Xn[3] * zn[3],
      Xn[4] * zn[0] + Xn[5] * zn[1] + Xn[6] * zn[2] + Xn[7] * zn[3],
      Xn[8] * zn[0] + Xn[9] * zn[1] + Xn[10] * zn[2] + Xn[11] * zn[3],
      Xn[12] * zn[0] + Xn[13] * zn[1] + Xn[14] * zn[2] + Xn[15] * zn[3]
    ];
  },
  dot: function(Xn, zn) {
    return Xn[0] * zn[0] + Xn[1] * zn[1] + Xn[2] * zn[2] + Xn[3] * zn[3];
  },
  sml: function(Xn, zn) {
    return [Xn * zn[0], Xn * zn[1], Xn * zn[2], Xn * zn[3]];
  }
};
UPNG.encode.concatRGBA = function(Xn) {
  for (var zn = 0, Un = 0; Un < Xn.length; Un++) zn += Xn[Un].byteLength;
  for (var Kn = new Uint8Array(zn), qn = 0, Un = 0; Un < Xn.length; Un++) {
    for (var Jo = new Uint8Array(Xn[Un]), pa = Jo.length, ma = 0; ma < pa; ma += 4) {
      var va = Jo[ma], ba = Jo[ma + 1], _a = Jo[ma + 2], ya = Jo[ma + 3];
      ya == 0 && (va = ba = _a = 0), Kn[qn + ma] = va, Kn[qn + ma + 1] = ba, Kn[qn + ma + 2] = _a, Kn[qn + ma + 3] = ya;
    }
    qn += pa;
  }
  return Kn.buffer;
};
var getImageType = function(Xn) {
  if (Xn === 0)
    return PngType.Greyscale;
  if (Xn === 2)
    return PngType.Truecolour;
  if (Xn === 3)
    return PngType.IndexedColour;
  if (Xn === 4)
    return PngType.GreyscaleWithAlpha;
  if (Xn === 6)
    return PngType.TruecolourWithAlpha;
  throw new Error("Unknown color type: " + Xn);
}, splitAlphaChannel = function(Xn) {
  for (var zn = Math.floor(Xn.length / 4), Un = new Uint8Array(zn * 3), Kn = new Uint8Array(zn * 1), qn = 0, Jo = 0, pa = 0; qn < Xn.length; )
    Un[Jo++] = Xn[qn++], Un[Jo++] = Xn[qn++], Un[Jo++] = Xn[qn++], Kn[pa++] = Xn[qn++];
  return { rgbChannel: Un, alphaChannel: Kn };
}, PngType;
(function(Xn) {
  Xn.Greyscale = "Greyscale", Xn.Truecolour = "Truecolour", Xn.IndexedColour = "IndexedColour", Xn.GreyscaleWithAlpha = "GreyscaleWithAlpha", Xn.TruecolourWithAlpha = "TruecolourWithAlpha";
})(PngType || (PngType = {}));
var PNG = (
  /** @class */
  function() {
    function Xn(zn) {
      var Un = UPNG.decode(zn), Kn = UPNG.toRGBA8(Un);
      if (Kn.length > 1)
        throw new Error("Animated PNGs are not supported");
      var qn = new Uint8Array(Kn[0]), Jo = splitAlphaChannel(qn), pa = Jo.rgbChannel, ma = Jo.alphaChannel;
      this.rgbChannel = pa;
      var va = ma.some(function(ba) {
        return ba < 255;
      });
      va && (this.alphaChannel = ma), this.type = getImageType(Un.ctype), this.width = Un.width, this.height = Un.height, this.bitsPerComponent = 8;
    }
    return Xn.load = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), PngEmbedder = (
  /** @class */
  function() {
    function Xn(zn) {
      this.image = zn, this.bitsPerComponent = zn.bitsPerComponent, this.width = zn.width, this.height = zn.height, this.colorSpace = "DeviceRGB";
    }
    return Xn.for = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un;
        return __generator(this, function(Kn) {
          return Un = PNG.load(zn), [2, new Xn(Un)];
        });
      });
    }, Xn.prototype.embedIntoContext = function(zn, Un) {
      return __awaiter(this, void 0, void 0, function() {
        var Kn, qn;
        return __generator(this, function(Jo) {
          return Kn = this.embedAlphaChannel(zn), qn = zn.flateStream(this.image.rgbChannel, {
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: this.image.bitsPerComponent,
            Width: this.image.width,
            Height: this.image.height,
            ColorSpace: this.colorSpace,
            SMask: Kn
          }), Un ? (zn.assign(Un, qn), [2, Un]) : [2, zn.register(qn)];
        });
      });
    }, Xn.prototype.embedAlphaChannel = function(zn) {
      if (this.image.alphaChannel) {
        var Un = zn.flateStream(this.image.alphaChannel, {
          Type: "XObject",
          Subtype: "Image",
          Height: this.image.height,
          Width: this.image.width,
          BitsPerComponent: this.image.bitsPerComponent,
          ColorSpace: "DeviceGray",
          Decode: [0, 1]
        });
        return zn.register(Un);
      }
    }, Xn;
  }()
), Stream = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      this.bytes = zn, this.start = Un || 0, this.pos = this.start, this.end = Un && Kn ? Un + Kn : this.bytes.length;
    }
    return Object.defineProperty(Xn.prototype, "length", {
      get: function() {
        return this.end - this.start;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Xn.prototype, "isEmpty", {
      get: function() {
        return this.length === 0;
      },
      enumerable: !1,
      configurable: !0
    }), Xn.prototype.getByte = function() {
      return this.pos >= this.end ? -1 : this.bytes[this.pos++];
    }, Xn.prototype.getUint16 = function() {
      var zn = this.getByte(), Un = this.getByte();
      return zn === -1 || Un === -1 ? -1 : (zn << 8) + Un;
    }, Xn.prototype.getInt32 = function() {
      var zn = this.getByte(), Un = this.getByte(), Kn = this.getByte(), qn = this.getByte();
      return (zn << 24) + (Un << 16) + (Kn << 8) + qn;
    }, Xn.prototype.getBytes = function(zn, Un) {
      Un === void 0 && (Un = !1);
      var Kn = this.bytes, qn = this.pos, Jo = this.end;
      if (zn) {
        var ma = qn + zn;
        ma > Jo && (ma = Jo), this.pos = ma;
        var pa = Kn.subarray(qn, ma);
        return Un ? new Uint8ClampedArray(pa) : pa;
      } else {
        var pa = Kn.subarray(qn, Jo);
        return Un ? new Uint8ClampedArray(pa) : pa;
      }
    }, Xn.prototype.peekByte = function() {
      var zn = this.getByte();
      return this.pos--, zn;
    }, Xn.prototype.peekBytes = function(zn, Un) {
      Un === void 0 && (Un = !1);
      var Kn = this.getBytes(zn, Un);
      return this.pos -= Kn.length, Kn;
    }, Xn.prototype.skip = function(zn) {
      zn || (zn = 1), this.pos += zn;
    }, Xn.prototype.reset = function() {
      this.pos = this.start;
    }, Xn.prototype.moveStart = function() {
      this.start = this.pos;
    }, Xn.prototype.makeSubStream = function(zn, Un) {
      return new Xn(this.bytes, zn, Un);
    }, Xn.prototype.decode = function() {
      return this.bytes;
    }, Xn;
  }()
), emptyBuffer = new Uint8Array(0), DecodeStream = (
  /** @class */
  function() {
    function Xn(zn) {
      if (this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = emptyBuffer, this.minBufferLength = 512, zn)
        for (; this.minBufferLength < zn; )
          this.minBufferLength *= 2;
    }
    return Object.defineProperty(Xn.prototype, "isEmpty", {
      get: function() {
        for (; !this.eof && this.bufferLength === 0; )
          this.readBlock();
        return this.bufferLength === 0;
      },
      enumerable: !1,
      configurable: !0
    }), Xn.prototype.getByte = function() {
      for (var zn = this.pos; this.bufferLength <= zn; ) {
        if (this.eof)
          return -1;
        this.readBlock();
      }
      return this.buffer[this.pos++];
    }, Xn.prototype.getUint16 = function() {
      var zn = this.getByte(), Un = this.getByte();
      return zn === -1 || Un === -1 ? -1 : (zn << 8) + Un;
    }, Xn.prototype.getInt32 = function() {
      var zn = this.getByte(), Un = this.getByte(), Kn = this.getByte(), qn = this.getByte();
      return (zn << 24) + (Un << 16) + (Kn << 8) + qn;
    }, Xn.prototype.getBytes = function(zn, Un) {
      Un === void 0 && (Un = !1);
      var Kn, qn = this.pos;
      if (zn) {
        for (this.ensureBuffer(qn + zn), Kn = qn + zn; !this.eof && this.bufferLength < Kn; )
          this.readBlock();
        var Jo = this.bufferLength;
        Kn > Jo && (Kn = Jo);
      } else {
        for (; !this.eof; )
          this.readBlock();
        Kn = this.bufferLength;
      }
      this.pos = Kn;
      var pa = this.buffer.subarray(qn, Kn);
      return Un && !(pa instanceof Uint8ClampedArray) ? new Uint8ClampedArray(pa) : pa;
    }, Xn.prototype.peekByte = function() {
      var zn = this.getByte();
      return this.pos--, zn;
    }, Xn.prototype.peekBytes = function(zn, Un) {
      Un === void 0 && (Un = !1);
      var Kn = this.getBytes(zn, Un);
      return this.pos -= Kn.length, Kn;
    }, Xn.prototype.skip = function(zn) {
      zn || (zn = 1), this.pos += zn;
    }, Xn.prototype.reset = function() {
      this.pos = 0;
    }, Xn.prototype.makeSubStream = function(zn, Un) {
      for (var Kn = zn + Un; this.bufferLength <= Kn && !this.eof; )
        this.readBlock();
      return new Stream(
        this.buffer,
        zn,
        Un
        /* dict */
      );
    }, Xn.prototype.decode = function() {
      for (; !this.eof; )
        this.readBlock();
      return this.buffer.subarray(0, this.bufferLength);
    }, Xn.prototype.readBlock = function() {
      throw new MethodNotImplementedError(this.constructor.name, "readBlock");
    }, Xn.prototype.ensureBuffer = function(zn) {
      var Un = this.buffer;
      if (zn <= Un.byteLength)
        return Un;
      for (var Kn = this.minBufferLength; Kn < zn; )
        Kn *= 2;
      var qn = new Uint8Array(Kn);
      return qn.set(Un), this.buffer = qn;
    }, Xn;
  }()
), isSpace = function(Xn) {
  return Xn === 32 || Xn === 9 || Xn === 13 || Xn === 10;
}, Ascii85Stream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this, Kn) || this;
      return qn.stream = Un, qn.input = new Uint8Array(5), Kn && (Kn = 0.8 * Kn), qn;
    }
    return zn.prototype.readBlock = function() {
      for (var Un = 126, Kn = 122, qn = -1, Jo = this.stream, pa = Jo.getByte(); isSpace(pa); )
        pa = Jo.getByte();
      if (pa === qn || pa === Un) {
        this.eof = !0;
        return;
      }
      var ma = this.bufferLength, va, ba;
      if (pa === Kn) {
        for (va = this.ensureBuffer(ma + 4), ba = 0; ba < 4; ++ba)
          va[ma + ba] = 0;
        this.bufferLength += 4;
      } else {
        var _a = this.input;
        for (_a[0] = pa, ba = 1; ba < 5; ++ba) {
          for (pa = Jo.getByte(); isSpace(pa); )
            pa = Jo.getByte();
          if (_a[ba] = pa, pa === qn || pa === Un)
            break;
        }
        if (va = this.ensureBuffer(ma + ba - 1), this.bufferLength += ba - 1, ba < 5) {
          for (; ba < 5; ++ba)
            _a[ba] = 117;
          this.eof = !0;
        }
        var ya = 0;
        for (ba = 0; ba < 5; ++ba)
          ya = ya * 85 + (_a[ba] - 33);
        for (ba = 3; ba >= 0; --ba)
          va[ma + ba] = ya & 255, ya >>= 8;
      }
    }, zn;
  }(DecodeStream)
), AsciiHexStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this, Kn) || this;
      return qn.stream = Un, qn.firstDigit = -1, Kn && (Kn = 0.5 * Kn), qn;
    }
    return zn.prototype.readBlock = function() {
      var Un = 8e3, Kn = this.stream.getBytes(Un);
      if (!Kn.length) {
        this.eof = !0;
        return;
      }
      for (var qn = Kn.length + 1 >> 1, Jo = this.ensureBuffer(this.bufferLength + qn), pa = this.bufferLength, ma = this.firstDigit, va = 0, ba = Kn.length; va < ba; va++) {
        var _a = Kn[va], ya = void 0;
        if (_a >= 48 && _a <= 57)
          ya = _a & 15;
        else if (_a >= 65 && _a <= 70 || _a >= 97 && _a <= 102)
          ya = (_a & 15) + 9;
        else if (_a === 62) {
          this.eof = !0;
          break;
        } else
          continue;
        ma < 0 ? ma = ya : (Jo[pa++] = ma << 4 | ya, ma = -1);
      }
      ma >= 0 && this.eof && (Jo[pa++] = ma << 4, ma = -1), this.firstDigit = ma, this.bufferLength = pa;
    }, zn;
  }(DecodeStream)
), codeLenCodeMap = new Int32Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), lengthDecode = new Int32Array([
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  65547,
  65549,
  65551,
  65553,
  131091,
  131095,
  131099,
  131103,
  196643,
  196651,
  196659,
  196667,
  262211,
  262227,
  262243,
  262259,
  327811,
  327843,
  327875,
  327907,
  258,
  258,
  258
]), distDecode = new Int32Array([
  1,
  2,
  3,
  4,
  65541,
  65543,
  131081,
  131085,
  196625,
  196633,
  262177,
  262193,
  327745,
  327777,
  393345,
  393409,
  459009,
  459137,
  524801,
  525057,
  590849,
  591361,
  657409,
  658433,
  724993,
  727041,
  794625,
  798721,
  868353,
  876545
]), fixedLitCodeTab = [new Int32Array([
  459008,
  524368,
  524304,
  524568,
  459024,
  524400,
  524336,
  590016,
  459016,
  524384,
  524320,
  589984,
  524288,
  524416,
  524352,
  590048,
  459012,
  524376,
  524312,
  589968,
  459028,
  524408,
  524344,
  590032,
  459020,
  524392,
  524328,
  59e4,
  524296,
  524424,
  524360,
  590064,
  459010,
  524372,
  524308,
  524572,
  459026,
  524404,
  524340,
  590024,
  459018,
  524388,
  524324,
  589992,
  524292,
  524420,
  524356,
  590056,
  459014,
  524380,
  524316,
  589976,
  459030,
  524412,
  524348,
  590040,
  459022,
  524396,
  524332,
  590008,
  524300,
  524428,
  524364,
  590072,
  459009,
  524370,
  524306,
  524570,
  459025,
  524402,
  524338,
  590020,
  459017,
  524386,
  524322,
  589988,
  524290,
  524418,
  524354,
  590052,
  459013,
  524378,
  524314,
  589972,
  459029,
  524410,
  524346,
  590036,
  459021,
  524394,
  524330,
  590004,
  524298,
  524426,
  524362,
  590068,
  459011,
  524374,
  524310,
  524574,
  459027,
  524406,
  524342,
  590028,
  459019,
  524390,
  524326,
  589996,
  524294,
  524422,
  524358,
  590060,
  459015,
  524382,
  524318,
  589980,
  459031,
  524414,
  524350,
  590044,
  459023,
  524398,
  524334,
  590012,
  524302,
  524430,
  524366,
  590076,
  459008,
  524369,
  524305,
  524569,
  459024,
  524401,
  524337,
  590018,
  459016,
  524385,
  524321,
  589986,
  524289,
  524417,
  524353,
  590050,
  459012,
  524377,
  524313,
  589970,
  459028,
  524409,
  524345,
  590034,
  459020,
  524393,
  524329,
  590002,
  524297,
  524425,
  524361,
  590066,
  459010,
  524373,
  524309,
  524573,
  459026,
  524405,
  524341,
  590026,
  459018,
  524389,
  524325,
  589994,
  524293,
  524421,
  524357,
  590058,
  459014,
  524381,
  524317,
  589978,
  459030,
  524413,
  524349,
  590042,
  459022,
  524397,
  524333,
  590010,
  524301,
  524429,
  524365,
  590074,
  459009,
  524371,
  524307,
  524571,
  459025,
  524403,
  524339,
  590022,
  459017,
  524387,
  524323,
  589990,
  524291,
  524419,
  524355,
  590054,
  459013,
  524379,
  524315,
  589974,
  459029,
  524411,
  524347,
  590038,
  459021,
  524395,
  524331,
  590006,
  524299,
  524427,
  524363,
  590070,
  459011,
  524375,
  524311,
  524575,
  459027,
  524407,
  524343,
  590030,
  459019,
  524391,
  524327,
  589998,
  524295,
  524423,
  524359,
  590062,
  459015,
  524383,
  524319,
  589982,
  459031,
  524415,
  524351,
  590046,
  459023,
  524399,
  524335,
  590014,
  524303,
  524431,
  524367,
  590078,
  459008,
  524368,
  524304,
  524568,
  459024,
  524400,
  524336,
  590017,
  459016,
  524384,
  524320,
  589985,
  524288,
  524416,
  524352,
  590049,
  459012,
  524376,
  524312,
  589969,
  459028,
  524408,
  524344,
  590033,
  459020,
  524392,
  524328,
  590001,
  524296,
  524424,
  524360,
  590065,
  459010,
  524372,
  524308,
  524572,
  459026,
  524404,
  524340,
  590025,
  459018,
  524388,
  524324,
  589993,
  524292,
  524420,
  524356,
  590057,
  459014,
  524380,
  524316,
  589977,
  459030,
  524412,
  524348,
  590041,
  459022,
  524396,
  524332,
  590009,
  524300,
  524428,
  524364,
  590073,
  459009,
  524370,
  524306,
  524570,
  459025,
  524402,
  524338,
  590021,
  459017,
  524386,
  524322,
  589989,
  524290,
  524418,
  524354,
  590053,
  459013,
  524378,
  524314,
  589973,
  459029,
  524410,
  524346,
  590037,
  459021,
  524394,
  524330,
  590005,
  524298,
  524426,
  524362,
  590069,
  459011,
  524374,
  524310,
  524574,
  459027,
  524406,
  524342,
  590029,
  459019,
  524390,
  524326,
  589997,
  524294,
  524422,
  524358,
  590061,
  459015,
  524382,
  524318,
  589981,
  459031,
  524414,
  524350,
  590045,
  459023,
  524398,
  524334,
  590013,
  524302,
  524430,
  524366,
  590077,
  459008,
  524369,
  524305,
  524569,
  459024,
  524401,
  524337,
  590019,
  459016,
  524385,
  524321,
  589987,
  524289,
  524417,
  524353,
  590051,
  459012,
  524377,
  524313,
  589971,
  459028,
  524409,
  524345,
  590035,
  459020,
  524393,
  524329,
  590003,
  524297,
  524425,
  524361,
  590067,
  459010,
  524373,
  524309,
  524573,
  459026,
  524405,
  524341,
  590027,
  459018,
  524389,
  524325,
  589995,
  524293,
  524421,
  524357,
  590059,
  459014,
  524381,
  524317,
  589979,
  459030,
  524413,
  524349,
  590043,
  459022,
  524397,
  524333,
  590011,
  524301,
  524429,
  524365,
  590075,
  459009,
  524371,
  524307,
  524571,
  459025,
  524403,
  524339,
  590023,
  459017,
  524387,
  524323,
  589991,
  524291,
  524419,
  524355,
  590055,
  459013,
  524379,
  524315,
  589975,
  459029,
  524411,
  524347,
  590039,
  459021,
  524395,
  524331,
  590007,
  524299,
  524427,
  524363,
  590071,
  459011,
  524375,
  524311,
  524575,
  459027,
  524407,
  524343,
  590031,
  459019,
  524391,
  524327,
  589999,
  524295,
  524423,
  524359,
  590063,
  459015,
  524383,
  524319,
  589983,
  459031,
  524415,
  524351,
  590047,
  459023,
  524399,
  524335,
  590015,
  524303,
  524431,
  524367,
  590079
]), 9], fixedDistCodeTab = [new Int32Array([
  327680,
  327696,
  327688,
  327704,
  327684,
  327700,
  327692,
  327708,
  327682,
  327698,
  327690,
  327706,
  327686,
  327702,
  327694,
  0,
  327681,
  327697,
  327689,
  327705,
  327685,
  327701,
  327693,
  327709,
  327683,
  327699,
  327691,
  327707,
  327687,
  327703,
  327695,
  0
]), 5], FlateStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this, Kn) || this;
      qn.stream = Un;
      var Jo = Un.getByte(), pa = Un.getByte();
      if (Jo === -1 || pa === -1)
        throw new Error("Invalid header in flate stream: " + Jo + ", " + pa);
      if ((Jo & 15) !== 8)
        throw new Error("Unknown compression method in flate stream: " + Jo + ", " + pa);
      if (((Jo << 8) + pa) % 31 !== 0)
        throw new Error("Bad FCHECK in flate stream: " + Jo + ", " + pa);
      if (pa & 32)
        throw new Error("FDICT bit set in flate stream: " + Jo + ", " + pa);
      return qn.codeSize = 0, qn.codeBuf = 0, qn;
    }
    return zn.prototype.readBlock = function() {
      var Un, Kn, qn = this.stream, Jo = this.getBits(3);
      if (Jo & 1 && (this.eof = !0), Jo >>= 1, Jo === 0) {
        var pa = void 0;
        if ((pa = qn.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        var ma = pa;
        if ((pa = qn.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        if (ma |= pa << 8, (pa = qn.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        var va = pa;
        if ((pa = qn.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        if (va |= pa << 8, va !== (~ma & 65535) && (ma !== 0 || va !== 0))
          throw new Error("Bad uncompressed block length in flate stream");
        this.codeBuf = 0, this.codeSize = 0;
        var ba = this.bufferLength;
        Un = this.ensureBuffer(ba + ma);
        var _a = ba + ma;
        if (this.bufferLength = _a, ma === 0)
          qn.peekByte() === -1 && (this.eof = !0);
        else
          for (var ya = ba; ya < _a; ++ya) {
            if ((pa = qn.getByte()) === -1) {
              this.eof = !0;
              break;
            }
            Un[ya] = pa;
          }
        return;
      }
      var xa, wa;
      if (Jo === 1)
        xa = fixedLitCodeTab, wa = fixedDistCodeTab;
      else if (Jo === 2) {
        var Ta = this.getBits(5) + 257, Sa = this.getBits(5) + 1, Ma = this.getBits(4) + 4, ka = new Uint8Array(codeLenCodeMap.length), Za = void 0;
        for (Za = 0; Za < Ma; ++Za)
          ka[codeLenCodeMap[Za]] = this.getBits(3);
        var Na = this.generateHuffmanTable(ka);
        Kn = 0, Za = 0;
        for (var Ka = Ta + Sa, Ja = new Uint8Array(Ka), el = void 0, qa = void 0, tl = void 0; Za < Ka; ) {
          var Qa = this.getCode(Na);
          if (Qa === 16)
            el = 2, qa = 3, tl = Kn;
          else if (Qa === 17)
            el = 3, qa = 3, tl = Kn = 0;
          else if (Qa === 18)
            el = 7, qa = 11, tl = Kn = 0;
          else {
            Ja[Za++] = Kn = Qa;
            continue;
          }
          for (var nl = this.getBits(el) + qa; nl-- > 0; )
            Ja[Za++] = tl;
        }
        xa = this.generateHuffmanTable(Ja.subarray(0, Ta)), wa = this.generateHuffmanTable(Ja.subarray(Ta, Ka));
      } else
        throw new Error("Unknown block type in flate stream");
      Un = this.buffer;
      for (var rl = Un ? Un.length : 0, il = this.bufferLength; ; ) {
        var cl = this.getCode(xa);
        if (cl < 256) {
          il + 1 >= rl && (Un = this.ensureBuffer(il + 1), rl = Un.length), Un[il++] = cl;
          continue;
        }
        if (cl === 256) {
          this.bufferLength = il;
          return;
        }
        cl -= 257, cl = lengthDecode[cl];
        var ll = cl >> 16;
        ll > 0 && (ll = this.getBits(ll)), Kn = (cl & 65535) + ll, cl = this.getCode(wa), cl = distDecode[cl], ll = cl >> 16, ll > 0 && (ll = this.getBits(ll));
        var al = (cl & 65535) + ll;
        il + Kn >= rl && (Un = this.ensureBuffer(il + Kn), rl = Un.length);
        for (var sl = 0; sl < Kn; ++sl, ++il)
          Un[il] = Un[il - al];
      }
    }, zn.prototype.getBits = function(Un) {
      for (var Kn = this.stream, qn = this.codeSize, Jo = this.codeBuf, pa; qn < Un; ) {
        if ((pa = Kn.getByte()) === -1)
          throw new Error("Bad encoding in flate stream");
        Jo |= pa << qn, qn += 8;
      }
      return pa = Jo & (1 << Un) - 1, this.codeBuf = Jo >> Un, this.codeSize = qn -= Un, pa;
    }, zn.prototype.getCode = function(Un) {
      for (var Kn = this.stream, qn = Un[0], Jo = Un[1], pa = this.codeSize, ma = this.codeBuf, va; pa < Jo && (va = Kn.getByte()) !== -1; )
        ma |= va << pa, pa += 8;
      var ba = qn[ma & (1 << Jo) - 1];
      typeof qn == "number" && console.log("FLATE:", ba);
      var _a = ba >> 16, ya = ba & 65535;
      if (_a < 1 || pa < _a)
        throw new Error("Bad encoding in flate stream");
      return this.codeBuf = ma >> _a, this.codeSize = pa - _a, ya;
    }, zn.prototype.generateHuffmanTable = function(Un) {
      var Kn = Un.length, qn = 0, Jo;
      for (Jo = 0; Jo < Kn; ++Jo)
        Un[Jo] > qn && (qn = Un[Jo]);
      for (var pa = 1 << qn, ma = new Int32Array(pa), va = 1, ba = 0, _a = 2; va <= qn; ++va, ba <<= 1, _a <<= 1)
        for (var ya = 0; ya < Kn; ++ya)
          if (Un[ya] === va) {
            var xa = 0, wa = ba;
            for (Jo = 0; Jo < va; ++Jo)
              xa = xa << 1 | wa & 1, wa >>= 1;
            for (Jo = xa; Jo < pa; Jo += _a)
              ma[Jo] = va << 16 | ya;
            ++ba;
          }
      return [ma, qn];
    }, zn;
  }(DecodeStream)
), LZWStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Kn) || this;
      Jo.stream = Un, Jo.cachedData = 0, Jo.bitsCached = 0;
      for (var pa = 4096, ma = {
        earlyChange: qn,
        codeLength: 9,
        nextCode: 258,
        dictionaryValues: new Uint8Array(pa),
        dictionaryLengths: new Uint16Array(pa),
        dictionaryPrevCodes: new Uint16Array(pa),
        currentSequence: new Uint8Array(pa),
        currentSequenceLength: 0
      }, va = 0; va < 256; ++va)
        ma.dictionaryValues[va] = va, ma.dictionaryLengths[va] = 1;
      return Jo.lzwState = ma, Jo;
    }
    return zn.prototype.readBlock = function() {
      var Un = 512, Kn = Un * 2, qn = Un, Jo, pa, ma, va = this.lzwState;
      if (va) {
        var ba = va.earlyChange, _a = va.nextCode, ya = va.dictionaryValues, xa = va.dictionaryLengths, wa = va.dictionaryPrevCodes, Ta = va.codeLength, Sa = va.prevCode, Ma = va.currentSequence, ka = va.currentSequenceLength, Za = 0, Na = this.bufferLength, Ka = this.ensureBuffer(this.bufferLength + Kn);
        for (Jo = 0; Jo < Un; Jo++) {
          var Ja = this.readBits(Ta), el = ka > 0;
          if (!Ja || Ja < 256)
            Ma[0] = Ja, ka = 1;
          else if (Ja >= 258)
            if (Ja < _a)
              for (ka = xa[Ja], pa = ka - 1, ma = Ja; pa >= 0; pa--)
                Ma[pa] = ya[ma], ma = wa[ma];
            else
              Ma[ka++] = Ma[0];
          else if (Ja === 256) {
            Ta = 9, _a = 258, ka = 0;
            continue;
          } else {
            this.eof = !0, delete this.lzwState;
            break;
          }
          if (el && (wa[_a] = Sa, xa[_a] = xa[Sa] + 1, ya[_a] = Ma[0], _a++, Ta = _a + ba & _a + ba - 1 ? Ta : Math.min(Math.log(_a + ba) / 0.6931471805599453 + 1, 12) | 0), Sa = Ja, Za += ka, Kn < Za) {
            do
              Kn += qn;
            while (Kn < Za);
            Ka = this.ensureBuffer(this.bufferLength + Kn);
          }
          for (pa = 0; pa < ka; pa++)
            Ka[Na++] = Ma[pa];
        }
        va.nextCode = _a, va.codeLength = Ta, va.prevCode = Sa, va.currentSequenceLength = ka, this.bufferLength = Na;
      }
    }, zn.prototype.readBits = function(Un) {
      for (var Kn = this.bitsCached, qn = this.cachedData; Kn < Un; ) {
        var Jo = this.stream.getByte();
        if (Jo === -1)
          return this.eof = !0, null;
        qn = qn << 8 | Jo, Kn += 8;
      }
      return this.bitsCached = Kn -= Un, this.cachedData = qn, qn >>> Kn & (1 << Un) - 1;
    }, zn;
  }(DecodeStream)
), RunLengthStream = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this, Kn) || this;
      return qn.stream = Un, qn;
    }
    return zn.prototype.readBlock = function() {
      var Un = this.stream.getBytes(2);
      if (!Un || Un.length < 2 || Un[0] === 128) {
        this.eof = !0;
        return;
      }
      var Kn, qn = this.bufferLength, Jo = Un[0];
      if (Jo < 128) {
        if (Kn = this.ensureBuffer(qn + Jo + 1), Kn[qn++] = Un[1], Jo > 0) {
          var pa = this.stream.getBytes(Jo);
          Kn.set(pa, qn), qn += Jo;
        }
      } else {
        Jo = 257 - Jo;
        var ma = Un[1];
        Kn = this.ensureBuffer(qn + Jo + 1);
        for (var va = 0; va < Jo; va++)
          Kn[qn++] = ma;
      }
      this.bufferLength = qn;
    }, zn;
  }(DecodeStream)
), decodeStream = function(Xn, zn, Un) {
  if (zn === PDFName.of("FlateDecode"))
    return new FlateStream(Xn);
  if (zn === PDFName.of("LZWDecode")) {
    var Kn = 1;
    if (Un instanceof PDFDict) {
      var qn = Un.lookup(PDFName.of("EarlyChange"));
      qn instanceof PDFNumber && (Kn = qn.asNumber());
    }
    return new LZWStream(Xn, void 0, Kn);
  }
  if (zn === PDFName.of("ASCII85Decode"))
    return new Ascii85Stream(Xn);
  if (zn === PDFName.of("ASCIIHexDecode"))
    return new AsciiHexStream(Xn);
  if (zn === PDFName.of("RunLengthDecode"))
    return new RunLengthStream(Xn);
  throw new UnsupportedEncodingError(zn.asString());
}, decodePDFRawStream = function(Xn) {
  var zn = Xn.dict, Un = Xn.contents, Kn = new Stream(Un), qn = zn.lookup(PDFName.of("Filter")), Jo = zn.lookup(PDFName.of("DecodeParms"));
  if (qn instanceof PDFName)
    Kn = decodeStream(Kn, qn, Jo);
  else if (qn instanceof PDFArray)
    for (var pa = 0, ma = qn.size(); pa < ma; pa++)
      Kn = decodeStream(Kn, qn.lookup(pa, PDFName), Jo && Jo.lookupMaybe(pa, PDFDict));
  else if (qn)
    throw new UnexpectedObjectTypeError([PDFName, PDFArray], qn);
  return Kn;
}, fullPageBoundingBox = function(Xn) {
  var zn = Xn.MediaBox(), Un = zn.lookup(2, PDFNumber).asNumber() - zn.lookup(0, PDFNumber).asNumber(), Kn = zn.lookup(3, PDFNumber).asNumber() - zn.lookup(1, PDFNumber).asNumber();
  return { left: 0, bottom: 0, right: Un, top: Kn };
}, boundingBoxAdjustedMatrix = function(Xn) {
  return [1, 0, 0, 1, -Xn.left, -Xn.bottom];
}, PDFPageEmbedder = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      this.page = zn;
      var qn = Un ?? fullPageBoundingBox(zn);
      this.width = qn.right - qn.left, this.height = qn.top - qn.bottom, this.boundingBox = qn, this.transformationMatrix = Kn ?? boundingBoxAdjustedMatrix(qn);
    }
    return Xn.for = function(zn, Un, Kn) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(qn) {
          return [2, new Xn(zn, Un, Kn)];
        });
      });
    }, Xn.prototype.embedIntoContext = function(zn, Un) {
      return __awaiter(this, void 0, void 0, function() {
        var Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa;
        return __generator(this, function(wa) {
          if (Kn = this.page.normalizedEntries(), qn = Kn.Contents, Jo = Kn.Resources, !qn)
            throw new MissingPageContentsEmbeddingError();
          return pa = this.decodeContents(qn), ma = this.boundingBox, va = ma.left, ba = ma.bottom, _a = ma.right, ya = ma.top, xa = zn.flateStream(pa, {
            Type: "XObject",
            Subtype: "Form",
            FormType: 1,
            BBox: [va, ba, _a, ya],
            Matrix: this.transformationMatrix,
            Resources: Jo
          }), Un ? (zn.assign(Un, xa), [2, Un]) : [2, zn.register(xa)];
        });
      });
    }, Xn.prototype.decodeContents = function(zn) {
      for (var Un = Uint8Array.of(CharCodes$1.Newline), Kn = [], qn = 0, Jo = zn.size(); qn < Jo; qn++) {
        var pa = zn.lookup(qn, PDFStream), ma = void 0;
        if (pa instanceof PDFRawStream)
          ma = decodePDFRawStream(pa).decode();
        else if (pa instanceof PDFContentStream)
          ma = pa.getUnencodedContents();
        else
          throw new UnrecognizedStreamTypeError(pa);
        Kn.push(ma, Un);
      }
      return mergeIntoTypedArray.apply(void 0, Kn);
    }, Xn;
  }()
), asEnum = function(Xn, zn) {
  if (Xn !== void 0)
    return zn[Xn];
}, NonFullScreenPageMode;
(function(Xn) {
  Xn.UseNone = "UseNone", Xn.UseOutlines = "UseOutlines", Xn.UseThumbs = "UseThumbs", Xn.UseOC = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(Xn) {
  Xn.L2R = "L2R", Xn.R2L = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(Xn) {
  Xn.None = "None", Xn.AppDefault = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Xn) {
  Xn.Simplex = "Simplex", Xn.DuplexFlipShortEdge = "DuplexFlipShortEdge", Xn.DuplexFlipLongEdge = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = (
  /** @class */
  function() {
    function Xn(zn) {
      this.dict = zn;
    }
    return Xn.prototype.lookupBool = function(zn) {
      var Un = this.dict.lookup(PDFName.of(zn));
      if (Un instanceof PDFBool)
        return Un;
    }, Xn.prototype.lookupName = function(zn) {
      var Un = this.dict.lookup(PDFName.of(zn));
      if (Un instanceof PDFName)
        return Un;
    }, Xn.prototype.HideToolbar = function() {
      return this.lookupBool("HideToolbar");
    }, Xn.prototype.HideMenubar = function() {
      return this.lookupBool("HideMenubar");
    }, Xn.prototype.HideWindowUI = function() {
      return this.lookupBool("HideWindowUI");
    }, Xn.prototype.FitWindow = function() {
      return this.lookupBool("FitWindow");
    }, Xn.prototype.CenterWindow = function() {
      return this.lookupBool("CenterWindow");
    }, Xn.prototype.DisplayDocTitle = function() {
      return this.lookupBool("DisplayDocTitle");
    }, Xn.prototype.NonFullScreenPageMode = function() {
      return this.lookupName("NonFullScreenPageMode");
    }, Xn.prototype.Direction = function() {
      return this.lookupName("Direction");
    }, Xn.prototype.PrintScaling = function() {
      return this.lookupName("PrintScaling");
    }, Xn.prototype.Duplex = function() {
      return this.lookupName("Duplex");
    }, Xn.prototype.PickTrayByPDFSize = function() {
      return this.lookupBool("PickTrayByPDFSize");
    }, Xn.prototype.PrintPageRange = function() {
      var zn = this.dict.lookup(PDFName.of("PrintPageRange"));
      if (zn instanceof PDFArray)
        return zn;
    }, Xn.prototype.NumCopies = function() {
      var zn = this.dict.lookup(PDFName.of("NumCopies"));
      if (zn instanceof PDFNumber)
        return zn;
    }, Xn.prototype.getHideToolbar = function() {
      var zn, Un;
      return (Un = (zn = this.HideToolbar()) === null || zn === void 0 ? void 0 : zn.asBoolean()) !== null && Un !== void 0 ? Un : !1;
    }, Xn.prototype.getHideMenubar = function() {
      var zn, Un;
      return (Un = (zn = this.HideMenubar()) === null || zn === void 0 ? void 0 : zn.asBoolean()) !== null && Un !== void 0 ? Un : !1;
    }, Xn.prototype.getHideWindowUI = function() {
      var zn, Un;
      return (Un = (zn = this.HideWindowUI()) === null || zn === void 0 ? void 0 : zn.asBoolean()) !== null && Un !== void 0 ? Un : !1;
    }, Xn.prototype.getFitWindow = function() {
      var zn, Un;
      return (Un = (zn = this.FitWindow()) === null || zn === void 0 ? void 0 : zn.asBoolean()) !== null && Un !== void 0 ? Un : !1;
    }, Xn.prototype.getCenterWindow = function() {
      var zn, Un;
      return (Un = (zn = this.CenterWindow()) === null || zn === void 0 ? void 0 : zn.asBoolean()) !== null && Un !== void 0 ? Un : !1;
    }, Xn.prototype.getDisplayDocTitle = function() {
      var zn, Un;
      return (Un = (zn = this.DisplayDocTitle()) === null || zn === void 0 ? void 0 : zn.asBoolean()) !== null && Un !== void 0 ? Un : !1;
    }, Xn.prototype.getNonFullScreenPageMode = function() {
      var zn, Un, Kn = (zn = this.NonFullScreenPageMode()) === null || zn === void 0 ? void 0 : zn.decodeText();
      return (Un = asEnum(Kn, NonFullScreenPageMode)) !== null && Un !== void 0 ? Un : NonFullScreenPageMode.UseNone;
    }, Xn.prototype.getReadingDirection = function() {
      var zn, Un, Kn = (zn = this.Direction()) === null || zn === void 0 ? void 0 : zn.decodeText();
      return (Un = asEnum(Kn, ReadingDirection)) !== null && Un !== void 0 ? Un : ReadingDirection.L2R;
    }, Xn.prototype.getPrintScaling = function() {
      var zn, Un, Kn = (zn = this.PrintScaling()) === null || zn === void 0 ? void 0 : zn.decodeText();
      return (Un = asEnum(Kn, PrintScaling)) !== null && Un !== void 0 ? Un : PrintScaling.AppDefault;
    }, Xn.prototype.getDuplex = function() {
      var zn, Un = (zn = this.Duplex()) === null || zn === void 0 ? void 0 : zn.decodeText();
      return asEnum(Un, Duplex);
    }, Xn.prototype.getPickTrayByPDFSize = function() {
      var zn;
      return (zn = this.PickTrayByPDFSize()) === null || zn === void 0 ? void 0 : zn.asBoolean();
    }, Xn.prototype.getPrintPageRange = function() {
      var zn = this.PrintPageRange();
      if (!zn)
        return [];
      for (var Un = [], Kn = 0; Kn < zn.size(); Kn += 2) {
        var qn = zn.lookup(Kn, PDFNumber).asNumber(), Jo = zn.lookup(Kn + 1, PDFNumber).asNumber();
        Un.push({ start: qn, end: Jo });
      }
      return Un;
    }, Xn.prototype.getNumCopies = function() {
      var zn, Un;
      return (Un = (zn = this.NumCopies()) === null || zn === void 0 ? void 0 : zn.asNumber()) !== null && Un !== void 0 ? Un : 1;
    }, Xn.prototype.setHideToolbar = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("HideToolbar"), Un);
    }, Xn.prototype.setHideMenubar = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("HideMenubar"), Un);
    }, Xn.prototype.setHideWindowUI = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("HideWindowUI"), Un);
    }, Xn.prototype.setFitWindow = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("FitWindow"), Un);
    }, Xn.prototype.setCenterWindow = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("CenterWindow"), Un);
    }, Xn.prototype.setDisplayDocTitle = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("DisplayDocTitle"), Un);
    }, Xn.prototype.setNonFullScreenPageMode = function(zn) {
      assertIsOneOf(zn, "nonFullScreenPageMode", NonFullScreenPageMode);
      var Un = PDFName.of(zn);
      this.dict.set(PDFName.of("NonFullScreenPageMode"), Un);
    }, Xn.prototype.setReadingDirection = function(zn) {
      assertIsOneOf(zn, "readingDirection", ReadingDirection);
      var Un = PDFName.of(zn);
      this.dict.set(PDFName.of("Direction"), Un);
    }, Xn.prototype.setPrintScaling = function(zn) {
      assertIsOneOf(zn, "printScaling", PrintScaling);
      var Un = PDFName.of(zn);
      this.dict.set(PDFName.of("PrintScaling"), Un);
    }, Xn.prototype.setDuplex = function(zn) {
      assertIsOneOf(zn, "duplex", Duplex);
      var Un = PDFName.of(zn);
      this.dict.set(PDFName.of("Duplex"), Un);
    }, Xn.prototype.setPickTrayByPDFSize = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("PickTrayByPDFSize"), Un);
    }, Xn.prototype.setPrintPageRange = function(zn) {
      Array.isArray(zn) || (zn = [zn]);
      for (var Un = [], Kn = 0, qn = zn.length; Kn < qn; Kn++)
        Un.push(zn[Kn].start), Un.push(zn[Kn].end);
      assertEachIs(Un, "printPageRange", ["number"]);
      var Jo = this.dict.context.obj(Un);
      this.dict.set(PDFName.of("PrintPageRange"), Jo);
    }, Xn.prototype.setNumCopies = function(zn) {
      assertRange(zn, "numCopies", 1, Number.MAX_VALUE), assertInteger(zn, "numCopies");
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("NumCopies"), Un);
    }, Xn.fromDict = function(zn) {
      return new Xn(zn);
    }, Xn.create = function(zn) {
      var Un = zn.obj({});
      return new Xn(Un);
    }, Xn;
  }()
), tfRegex$1 = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/, PDFAcroField = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      this.dict = zn, this.ref = Un;
    }
    return Xn.prototype.T = function() {
      return this.dict.lookupMaybe(PDFName.of("T"), PDFString, PDFHexString);
    }, Xn.prototype.Ff = function() {
      var zn = this.getInheritableAttribute(PDFName.of("Ff"));
      return this.dict.context.lookupMaybe(zn, PDFNumber);
    }, Xn.prototype.V = function() {
      var zn = this.getInheritableAttribute(PDFName.of("V"));
      return this.dict.context.lookup(zn);
    }, Xn.prototype.Kids = function() {
      return this.dict.lookupMaybe(PDFName.of("Kids"), PDFArray);
    }, Xn.prototype.DA = function() {
      var zn = this.dict.lookup(PDFName.of("DA"));
      if (zn instanceof PDFString || zn instanceof PDFHexString)
        return zn;
    }, Xn.prototype.setKids = function(zn) {
      this.dict.set(PDFName.of("Kids"), this.dict.context.obj(zn));
    }, Xn.prototype.getParent = function() {
      var zn = this.dict.get(PDFName.of("Parent"));
      if (zn instanceof PDFRef) {
        var Un = this.dict.lookup(PDFName.of("Parent"), PDFDict);
        return new Xn(Un, zn);
      }
    }, Xn.prototype.setParent = function(zn) {
      zn ? this.dict.set(PDFName.of("Parent"), zn) : this.dict.delete(PDFName.of("Parent"));
    }, Xn.prototype.getFullyQualifiedName = function() {
      var zn = this.getParent();
      return zn ? zn.getFullyQualifiedName() + "." + this.getPartialName() : this.getPartialName();
    }, Xn.prototype.getPartialName = function() {
      var zn;
      return (zn = this.T()) === null || zn === void 0 ? void 0 : zn.decodeText();
    }, Xn.prototype.setPartialName = function(zn) {
      zn ? this.dict.set(PDFName.of("T"), PDFHexString.fromText(zn)) : this.dict.delete(PDFName.of("T"));
    }, Xn.prototype.setDefaultAppearance = function(zn) {
      this.dict.set(PDFName.of("DA"), PDFString.of(zn));
    }, Xn.prototype.getDefaultAppearance = function() {
      var zn = this.DA();
      return zn instanceof PDFHexString ? zn.decodeText() : zn == null ? void 0 : zn.asString();
    }, Xn.prototype.setFontSize = function(zn) {
      var Un, Kn = (Un = this.getFullyQualifiedName()) !== null && Un !== void 0 ? Un : "", qn = this.getDefaultAppearance();
      if (!qn)
        throw new MissingDAEntryError(Kn);
      var Jo = findLastMatch(qn, tfRegex$1);
      if (!Jo.match)
        throw new MissingTfOperatorError(Kn);
      var pa = qn.slice(0, Jo.pos - Jo.match[0].length), ma = Jo.pos <= qn.length ? qn.slice(Jo.pos) : "", va = Jo.match[1], ba = pa + " /" + va + " " + zn + " Tf " + ma;
      this.setDefaultAppearance(ba);
    }, Xn.prototype.getFlags = function() {
      var zn, Un;
      return (Un = (zn = this.Ff()) === null || zn === void 0 ? void 0 : zn.asNumber()) !== null && Un !== void 0 ? Un : 0;
    }, Xn.prototype.setFlags = function(zn) {
      this.dict.set(PDFName.of("Ff"), PDFNumber.of(zn));
    }, Xn.prototype.hasFlag = function(zn) {
      var Un = this.getFlags();
      return (Un & zn) !== 0;
    }, Xn.prototype.setFlag = function(zn) {
      var Un = this.getFlags();
      this.setFlags(Un | zn);
    }, Xn.prototype.clearFlag = function(zn) {
      var Un = this.getFlags();
      this.setFlags(Un & ~zn);
    }, Xn.prototype.setFlagTo = function(zn, Un) {
      Un ? this.setFlag(zn) : this.clearFlag(zn);
    }, Xn.prototype.getInheritableAttribute = function(zn) {
      var Un;
      return this.ascend(function(Kn) {
        Un || (Un = Kn.dict.get(zn));
      }), Un;
    }, Xn.prototype.ascend = function(zn) {
      zn(this);
      var Un = this.getParent();
      Un && Un.ascend(zn);
    }, Xn;
  }()
), BorderStyle = (
  /** @class */
  function() {
    function Xn(zn) {
      this.dict = zn;
    }
    return Xn.prototype.W = function() {
      var zn = this.dict.lookup(PDFName.of("W"));
      if (zn instanceof PDFNumber)
        return zn;
    }, Xn.prototype.getWidth = function() {
      var zn, Un;
      return (Un = (zn = this.W()) === null || zn === void 0 ? void 0 : zn.asNumber()) !== null && Un !== void 0 ? Un : 1;
    }, Xn.prototype.setWidth = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("W"), Un);
    }, Xn.fromDict = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), PDFAnnotation = (
  /** @class */
  function() {
    function Xn(zn) {
      this.dict = zn;
    }
    return Xn.prototype.Rect = function() {
      return this.dict.lookup(PDFName.of("Rect"), PDFArray);
    }, Xn.prototype.AP = function() {
      return this.dict.lookupMaybe(PDFName.of("AP"), PDFDict);
    }, Xn.prototype.F = function() {
      var zn = this.dict.lookup(PDFName.of("F"));
      return this.dict.context.lookupMaybe(zn, PDFNumber);
    }, Xn.prototype.getRectangle = function() {
      var zn, Un = this.Rect();
      return (zn = Un == null ? void 0 : Un.asRectangle()) !== null && zn !== void 0 ? zn : { x: 0, y: 0, width: 0, height: 0 };
    }, Xn.prototype.setRectangle = function(zn) {
      var Un = zn.x, Kn = zn.y, qn = zn.width, Jo = zn.height, pa = this.dict.context.obj([Un, Kn, Un + qn, Kn + Jo]);
      this.dict.set(PDFName.of("Rect"), pa);
    }, Xn.prototype.getAppearanceState = function() {
      var zn = this.dict.lookup(PDFName.of("AS"));
      if (zn instanceof PDFName)
        return zn;
    }, Xn.prototype.setAppearanceState = function(zn) {
      this.dict.set(PDFName.of("AS"), zn);
    }, Xn.prototype.setAppearances = function(zn) {
      this.dict.set(PDFName.of("AP"), zn);
    }, Xn.prototype.ensureAP = function() {
      var zn = this.AP();
      return zn || (zn = this.dict.context.obj({}), this.dict.set(PDFName.of("AP"), zn)), zn;
    }, Xn.prototype.getNormalAppearance = function() {
      var zn = this.ensureAP(), Un = zn.get(PDFName.of("N"));
      if (Un instanceof PDFRef || Un instanceof PDFDict)
        return Un;
      throw new Error("Unexpected N type: " + (Un == null ? void 0 : Un.constructor.name));
    }, Xn.prototype.setNormalAppearance = function(zn) {
      var Un = this.ensureAP();
      Un.set(PDFName.of("N"), zn);
    }, Xn.prototype.setRolloverAppearance = function(zn) {
      var Un = this.ensureAP();
      Un.set(PDFName.of("R"), zn);
    }, Xn.prototype.setDownAppearance = function(zn) {
      var Un = this.ensureAP();
      Un.set(PDFName.of("D"), zn);
    }, Xn.prototype.removeRolloverAppearance = function() {
      var zn = this.AP();
      zn == null || zn.delete(PDFName.of("R"));
    }, Xn.prototype.removeDownAppearance = function() {
      var zn = this.AP();
      zn == null || zn.delete(PDFName.of("D"));
    }, Xn.prototype.getAppearances = function() {
      var zn = this.AP();
      if (zn) {
        var Un = zn.lookup(PDFName.of("N"), PDFDict, PDFStream), Kn = zn.lookupMaybe(PDFName.of("R"), PDFDict, PDFStream), qn = zn.lookupMaybe(PDFName.of("D"), PDFDict, PDFStream);
        return { normal: Un, rollover: Kn, down: qn };
      }
    }, Xn.prototype.getFlags = function() {
      var zn, Un;
      return (Un = (zn = this.F()) === null || zn === void 0 ? void 0 : zn.asNumber()) !== null && Un !== void 0 ? Un : 0;
    }, Xn.prototype.setFlags = function(zn) {
      this.dict.set(PDFName.of("F"), PDFNumber.of(zn));
    }, Xn.prototype.hasFlag = function(zn) {
      var Un = this.getFlags();
      return (Un & zn) !== 0;
    }, Xn.prototype.setFlag = function(zn) {
      var Un = this.getFlags();
      this.setFlags(Un | zn);
    }, Xn.prototype.clearFlag = function(zn) {
      var Un = this.getFlags();
      this.setFlags(Un & ~zn);
    }, Xn.prototype.setFlagTo = function(zn, Un) {
      Un ? this.setFlag(zn) : this.clearFlag(zn);
    }, Xn.fromDict = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), AppearanceCharacteristics = (
  /** @class */
  function() {
    function Xn(zn) {
      this.dict = zn;
    }
    return Xn.prototype.R = function() {
      var zn = this.dict.lookup(PDFName.of("R"));
      if (zn instanceof PDFNumber)
        return zn;
    }, Xn.prototype.BC = function() {
      var zn = this.dict.lookup(PDFName.of("BC"));
      if (zn instanceof PDFArray)
        return zn;
    }, Xn.prototype.BG = function() {
      var zn = this.dict.lookup(PDFName.of("BG"));
      if (zn instanceof PDFArray)
        return zn;
    }, Xn.prototype.CA = function() {
      var zn = this.dict.lookup(PDFName.of("CA"));
      if (zn instanceof PDFHexString || zn instanceof PDFString)
        return zn;
    }, Xn.prototype.RC = function() {
      var zn = this.dict.lookup(PDFName.of("RC"));
      if (zn instanceof PDFHexString || zn instanceof PDFString)
        return zn;
    }, Xn.prototype.AC = function() {
      var zn = this.dict.lookup(PDFName.of("AC"));
      if (zn instanceof PDFHexString || zn instanceof PDFString)
        return zn;
    }, Xn.prototype.getRotation = function() {
      var zn;
      return (zn = this.R()) === null || zn === void 0 ? void 0 : zn.asNumber();
    }, Xn.prototype.getBorderColor = function() {
      var zn = this.BC();
      if (zn) {
        for (var Un = [], Kn = 0, qn = zn == null ? void 0 : zn.size(); Kn < qn; Kn++) {
          var Jo = zn.get(Kn);
          Jo instanceof PDFNumber && Un.push(Jo.asNumber());
        }
        return Un;
      }
    }, Xn.prototype.getBackgroundColor = function() {
      var zn = this.BG();
      if (zn) {
        for (var Un = [], Kn = 0, qn = zn == null ? void 0 : zn.size(); Kn < qn; Kn++) {
          var Jo = zn.get(Kn);
          Jo instanceof PDFNumber && Un.push(Jo.asNumber());
        }
        return Un;
      }
    }, Xn.prototype.getCaptions = function() {
      var zn = this.CA(), Un = this.RC(), Kn = this.AC();
      return {
        normal: zn == null ? void 0 : zn.decodeText(),
        rollover: Un == null ? void 0 : Un.decodeText(),
        down: Kn == null ? void 0 : Kn.decodeText()
      };
    }, Xn.prototype.setRotation = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("R"), Un);
    }, Xn.prototype.setBorderColor = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("BC"), Un);
    }, Xn.prototype.setBackgroundColor = function(zn) {
      var Un = this.dict.context.obj(zn);
      this.dict.set(PDFName.of("BG"), Un);
    }, Xn.prototype.setCaptions = function(zn) {
      var Un = PDFHexString.fromText(zn.normal);
      if (this.dict.set(PDFName.of("CA"), Un), zn.rollover) {
        var Kn = PDFHexString.fromText(zn.rollover);
        this.dict.set(PDFName.of("RC"), Kn);
      } else
        this.dict.delete(PDFName.of("RC"));
      if (zn.down) {
        var qn = PDFHexString.fromText(zn.down);
        this.dict.set(PDFName.of("AC"), qn);
      } else
        this.dict.delete(PDFName.of("AC"));
    }, Xn.fromDict = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), PDFWidgetAnnotation = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.MK = function() {
      var Un = this.dict.lookup(PDFName.of("MK"));
      if (Un instanceof PDFDict)
        return Un;
    }, zn.prototype.BS = function() {
      var Un = this.dict.lookup(PDFName.of("BS"));
      if (Un instanceof PDFDict)
        return Un;
    }, zn.prototype.DA = function() {
      var Un = this.dict.lookup(PDFName.of("DA"));
      if (Un instanceof PDFString || Un instanceof PDFHexString)
        return Un;
    }, zn.prototype.P = function() {
      var Un = this.dict.get(PDFName.of("P"));
      if (Un instanceof PDFRef)
        return Un;
    }, zn.prototype.setP = function(Un) {
      this.dict.set(PDFName.of("P"), Un);
    }, zn.prototype.setDefaultAppearance = function(Un) {
      this.dict.set(PDFName.of("DA"), PDFString.of(Un));
    }, zn.prototype.getDefaultAppearance = function() {
      var Un = this.DA();
      return Un instanceof PDFHexString ? Un.decodeText() : Un == null ? void 0 : Un.asString();
    }, zn.prototype.getAppearanceCharacteristics = function() {
      var Un = this.MK();
      if (Un)
        return AppearanceCharacteristics.fromDict(Un);
    }, zn.prototype.getOrCreateAppearanceCharacteristics = function() {
      var Un = this.MK();
      if (Un)
        return AppearanceCharacteristics.fromDict(Un);
      var Kn = AppearanceCharacteristics.fromDict(this.dict.context.obj({}));
      return this.dict.set(PDFName.of("MK"), Kn.dict), Kn;
    }, zn.prototype.getBorderStyle = function() {
      var Un = this.BS();
      if (Un)
        return BorderStyle.fromDict(Un);
    }, zn.prototype.getOrCreateBorderStyle = function() {
      var Un = this.BS();
      if (Un)
        return BorderStyle.fromDict(Un);
      var Kn = BorderStyle.fromDict(this.dict.context.obj({}));
      return this.dict.set(PDFName.of("BS"), Kn.dict), Kn;
    }, zn.prototype.getOnValue = function() {
      var Un, Kn = (Un = this.getAppearances()) === null || Un === void 0 ? void 0 : Un.normal;
      if (Kn instanceof PDFDict)
        for (var qn = Kn.keys(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
          var ma = qn[Jo];
          if (ma !== PDFName.of("Off"))
            return ma;
        }
    }, zn.fromDict = function(Un) {
      return new zn(Un);
    }, zn.create = function(Un, Kn) {
      var qn = Un.obj({
        Type: "Annot",
        Subtype: "Widget",
        Rect: [0, 0, 0, 0],
        Parent: Kn
      });
      return new zn(qn);
    }, zn;
  }(PDFAnnotation)
), PDFAcroTerminal = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.FT = function() {
      var Un = this.getInheritableAttribute(PDFName.of("FT"));
      return this.dict.context.lookup(Un, PDFName);
    }, zn.prototype.getWidgets = function() {
      var Un = this.Kids();
      if (!Un)
        return [PDFWidgetAnnotation.fromDict(this.dict)];
      for (var Kn = new Array(Un.size()), qn = 0, Jo = Un.size(); qn < Jo; qn++) {
        var pa = Un.lookup(qn, PDFDict);
        Kn[qn] = PDFWidgetAnnotation.fromDict(pa);
      }
      return Kn;
    }, zn.prototype.addWidget = function(Un) {
      var Kn = this.normalizedEntries().Kids;
      Kn.push(Un);
    }, zn.prototype.removeWidget = function(Un) {
      var Kn = this.Kids();
      if (Kn) {
        if (Un < 0 || Un > Kn.size())
          throw new IndexOutOfBoundsError(Un, 0, Kn.size());
        Kn.remove(Un);
      } else {
        if (Un !== 0)
          throw new IndexOutOfBoundsError(Un, 0, 0);
        this.setKids([]);
      }
    }, zn.prototype.normalizedEntries = function() {
      var Un = this.Kids();
      return Un || (Un = this.dict.context.obj([this.ref]), this.dict.set(PDFName.of("Kids"), Un)), { Kids: Un };
    }, zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn;
  }(PDFAcroField)
), PDFAcroButton = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.Opt = function() {
      return this.dict.lookupMaybe(PDFName.of("Opt"), PDFString, PDFHexString, PDFArray);
    }, zn.prototype.setOpt = function(Un) {
      this.dict.set(PDFName.of("Opt"), this.dict.context.obj(Un));
    }, zn.prototype.getExportValues = function() {
      var Un = this.Opt();
      if (Un) {
        if (Un instanceof PDFString || Un instanceof PDFHexString)
          return [Un];
        for (var Kn = [], qn = 0, Jo = Un.size(); qn < Jo; qn++) {
          var pa = Un.lookup(qn);
          (pa instanceof PDFString || pa instanceof PDFHexString) && Kn.push(pa);
        }
        return Kn;
      }
    }, zn.prototype.removeExportValue = function(Un) {
      var Kn = this.Opt();
      if (Kn)
        if (Kn instanceof PDFString || Kn instanceof PDFHexString) {
          if (Un !== 0)
            throw new IndexOutOfBoundsError(Un, 0, 0);
          this.setOpt([]);
        } else {
          if (Un < 0 || Un > Kn.size())
            throw new IndexOutOfBoundsError(Un, 0, Kn.size());
          Kn.remove(Un);
        }
    }, zn.prototype.normalizeExportValues = function() {
      for (var Un, Kn, qn, Jo, pa = (Un = this.getExportValues()) !== null && Un !== void 0 ? Un : [], ma = [], va = this.getWidgets(), ba = 0, _a = va.length; ba < _a; ba++) {
        var ya = va[ba], xa = (Kn = pa[ba]) !== null && Kn !== void 0 ? Kn : PDFHexString.fromText((Jo = (qn = ya.getOnValue()) === null || qn === void 0 ? void 0 : qn.decodeText()) !== null && Jo !== void 0 ? Jo : "");
        ma.push(xa);
      }
      this.setOpt(ma);
    }, zn.prototype.addOpt = function(Un, Kn) {
      var qn;
      this.normalizeExportValues();
      var Jo = Un.decodeText(), pa;
      if (Kn)
        for (var ma = (qn = this.getExportValues()) !== null && qn !== void 0 ? qn : [], va = 0, ba = ma.length; va < ba; va++) {
          var _a = ma[va];
          _a.decodeText() === Jo && (pa = va);
        }
      var ya = this.Opt();
      return ya.push(Un), pa ?? ya.size() - 1;
    }, zn.prototype.addWidgetWithOpt = function(Un, Kn, qn) {
      var Jo = this.addOpt(Kn, qn), pa = PDFName.of(String(Jo));
      return this.addWidget(Un), pa;
    }, zn;
  }(PDFAcroTerminal)
), PDFAcroCheckBox = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.setValue = function(Un) {
      var Kn, qn = (Kn = this.getOnValue()) !== null && Kn !== void 0 ? Kn : PDFName.of("Yes");
      if (Un !== qn && Un !== PDFName.of("Off"))
        throw new InvalidAcroFieldValueError();
      this.dict.set(PDFName.of("V"), Un);
      for (var Jo = this.getWidgets(), pa = 0, ma = Jo.length; pa < ma; pa++) {
        var va = Jo[pa], ba = va.getOnValue() === Un ? Un : PDFName.of("Off");
        va.setAppearanceState(ba);
      }
    }, zn.prototype.getValue = function() {
      var Un = this.V();
      return Un instanceof PDFName ? Un : PDFName.of("Off");
    }, zn.prototype.getOnValue = function() {
      var Un = this.getWidgets()[0];
      return Un == null ? void 0 : Un.getOnValue();
    }, zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn.create = function(Un) {
      var Kn = Un.obj({
        FT: "Btn",
        Kids: []
      }), qn = Un.register(Kn);
      return new zn(Kn, qn);
    }, zn;
  }(PDFAcroButton)
), flag$1 = function(Xn) {
  return 1 << Xn;
}, AcroFieldFlags;
(function(Xn) {
  Xn[Xn.ReadOnly = flag$1(0)] = "ReadOnly", Xn[Xn.Required = flag$1(1)] = "Required", Xn[Xn.NoExport = flag$1(2)] = "NoExport";
})(AcroFieldFlags || (AcroFieldFlags = {}));
var AcroButtonFlags;
(function(Xn) {
  Xn[Xn.NoToggleToOff = flag$1(14)] = "NoToggleToOff", Xn[Xn.Radio = flag$1(15)] = "Radio", Xn[Xn.PushButton = flag$1(16)] = "PushButton", Xn[Xn.RadiosInUnison = flag$1(25)] = "RadiosInUnison";
})(AcroButtonFlags || (AcroButtonFlags = {}));
var AcroTextFlags;
(function(Xn) {
  Xn[Xn.Multiline = flag$1(12)] = "Multiline", Xn[Xn.Password = flag$1(13)] = "Password", Xn[Xn.FileSelect = flag$1(20)] = "FileSelect", Xn[Xn.DoNotSpellCheck = flag$1(22)] = "DoNotSpellCheck", Xn[Xn.DoNotScroll = flag$1(23)] = "DoNotScroll", Xn[Xn.Comb = flag$1(24)] = "Comb", Xn[Xn.RichText = flag$1(25)] = "RichText";
})(AcroTextFlags || (AcroTextFlags = {}));
var AcroChoiceFlags;
(function(Xn) {
  Xn[Xn.Combo = flag$1(17)] = "Combo", Xn[Xn.Edit = flag$1(18)] = "Edit", Xn[Xn.Sort = flag$1(19)] = "Sort", Xn[Xn.MultiSelect = flag$1(21)] = "MultiSelect", Xn[Xn.DoNotSpellCheck = flag$1(22)] = "DoNotSpellCheck", Xn[Xn.CommitOnSelChange = flag$1(26)] = "CommitOnSelChange";
})(AcroChoiceFlags || (AcroChoiceFlags = {}));
var PDFAcroChoice = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.setValues = function(Un) {
      if (this.hasFlag(AcroChoiceFlags.Combo) && !this.hasFlag(AcroChoiceFlags.Edit) && !this.valuesAreValid(Un))
        throw new InvalidAcroFieldValueError();
      if (Un.length === 0 && this.dict.delete(PDFName.of("V")), Un.length === 1 && this.dict.set(PDFName.of("V"), Un[0]), Un.length > 1) {
        if (!this.hasFlag(AcroChoiceFlags.MultiSelect))
          throw new MultiSelectValueError();
        this.dict.set(PDFName.of("V"), this.dict.context.obj(Un));
      }
      this.updateSelectedIndices(Un);
    }, zn.prototype.valuesAreValid = function(Un) {
      for (var Kn = this.getOptions(), qn = function(va, ba) {
        var _a = Un[va].decodeText();
        if (!Kn.find(function(ya) {
          return _a === (ya.display || ya.value).decodeText();
        }))
          return { value: !1 };
      }, Jo = 0, pa = Un.length; Jo < pa; Jo++) {
        var ma = qn(Jo);
        if (typeof ma == "object")
          return ma.value;
      }
      return !0;
    }, zn.prototype.updateSelectedIndices = function(Un) {
      if (Un.length > 1) {
        for (var Kn = new Array(Un.length), qn = this.getOptions(), Jo = function(va, ba) {
          var _a = Un[va].decodeText();
          Kn[va] = qn.findIndex(function(ya) {
            return _a === (ya.display || ya.value).decodeText();
          });
        }, pa = 0, ma = Un.length; pa < ma; pa++)
          Jo(pa, ma);
        this.dict.set(PDFName.of("I"), this.dict.context.obj(Kn.sort()));
      } else
        this.dict.delete(PDFName.of("I"));
    }, zn.prototype.getValues = function() {
      var Un = this.V();
      if (Un instanceof PDFString || Un instanceof PDFHexString)
        return [Un];
      if (Un instanceof PDFArray) {
        for (var Kn = [], qn = 0, Jo = Un.size(); qn < Jo; qn++) {
          var pa = Un.lookup(qn);
          (pa instanceof PDFString || pa instanceof PDFHexString) && Kn.push(pa);
        }
        return Kn;
      }
      return [];
    }, zn.prototype.Opt = function() {
      return this.dict.lookupMaybe(PDFName.of("Opt"), PDFString, PDFHexString, PDFArray);
    }, zn.prototype.setOptions = function(Un) {
      for (var Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++) {
        var pa = Un[qn], ma = pa.value, va = pa.display;
        Kn[qn] = this.dict.context.obj([ma, va || ma]);
      }
      this.dict.set(PDFName.of("Opt"), this.dict.context.obj(Kn));
    }, zn.prototype.getOptions = function() {
      var Un = this.Opt();
      if (Un instanceof PDFString || Un instanceof PDFHexString)
        return [{ value: Un, display: Un }];
      if (Un instanceof PDFArray) {
        for (var Kn = [], qn = 0, Jo = Un.size(); qn < Jo; qn++) {
          var pa = Un.lookup(qn);
          if ((pa instanceof PDFString || pa instanceof PDFHexString) && Kn.push({ value: pa, display: pa }), pa instanceof PDFArray && pa.size() > 0) {
            var ma = pa.lookup(0, PDFString, PDFHexString), va = pa.lookupMaybe(1, PDFString, PDFHexString);
            Kn.push({ value: ma, display: va || ma });
          }
        }
        return Kn;
      }
      return [];
    }, zn;
  }(PDFAcroTerminal)
), PDFAcroComboBox = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn.create = function(Un) {
      var Kn = Un.obj({
        FT: "Ch",
        Ff: AcroChoiceFlags.Combo,
        Kids: []
      }), qn = Un.register(Kn);
      return new zn(Kn, qn);
    }, zn;
  }(PDFAcroChoice)
), PDFAcroNonTerminal = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.addField = function(Un) {
      var Kn = this.normalizedEntries().Kids;
      Kn == null || Kn.push(Un);
    }, zn.prototype.normalizedEntries = function() {
      var Un = this.Kids();
      return Un || (Un = this.dict.context.obj([]), this.dict.set(PDFName.of("Kids"), Un)), { Kids: Un };
    }, zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn.create = function(Un) {
      var Kn = Un.obj({}), qn = Un.register(Kn);
      return new zn(Kn, qn);
    }, zn;
  }(PDFAcroField)
), PDFAcroSignature = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn;
  }(PDFAcroTerminal)
), PDFAcroText = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.MaxLen = function() {
      var Un = this.dict.lookup(PDFName.of("MaxLen"));
      if (Un instanceof PDFNumber)
        return Un;
    }, zn.prototype.Q = function() {
      var Un = this.dict.lookup(PDFName.of("Q"));
      if (Un instanceof PDFNumber)
        return Un;
    }, zn.prototype.setMaxLength = function(Un) {
      this.dict.set(PDFName.of("MaxLen"), PDFNumber.of(Un));
    }, zn.prototype.removeMaxLength = function() {
      this.dict.delete(PDFName.of("MaxLen"));
    }, zn.prototype.getMaxLength = function() {
      var Un;
      return (Un = this.MaxLen()) === null || Un === void 0 ? void 0 : Un.asNumber();
    }, zn.prototype.setQuadding = function(Un) {
      this.dict.set(PDFName.of("Q"), PDFNumber.of(Un));
    }, zn.prototype.getQuadding = function() {
      var Un;
      return (Un = this.Q()) === null || Un === void 0 ? void 0 : Un.asNumber();
    }, zn.prototype.setValue = function(Un) {
      this.dict.set(PDFName.of("V"), Un);
    }, zn.prototype.removeValue = function() {
      this.dict.delete(PDFName.of("V"));
    }, zn.prototype.getValue = function() {
      var Un = this.V();
      if (Un instanceof PDFString || Un instanceof PDFHexString)
        return Un;
    }, zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn.create = function(Un) {
      var Kn = Un.obj({
        FT: "Tx",
        Kids: []
      }), qn = Un.register(Kn);
      return new zn(Kn, qn);
    }, zn;
  }(PDFAcroTerminal)
), PDFAcroPushButton = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn.create = function(Un) {
      var Kn = Un.obj({
        FT: "Btn",
        Ff: AcroButtonFlags.PushButton,
        Kids: []
      }), qn = Un.register(Kn);
      return new zn(Kn, qn);
    }, zn;
  }(PDFAcroButton)
), PDFAcroRadioButton = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.setValue = function(Un) {
      var Kn = this.getOnValues();
      if (!Kn.includes(Un) && Un !== PDFName.of("Off"))
        throw new InvalidAcroFieldValueError();
      this.dict.set(PDFName.of("V"), Un);
      for (var qn = this.getWidgets(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo], va = ma.getOnValue() === Un ? Un : PDFName.of("Off");
        ma.setAppearanceState(va);
      }
    }, zn.prototype.getValue = function() {
      var Un = this.V();
      return Un instanceof PDFName ? Un : PDFName.of("Off");
    }, zn.prototype.getOnValues = function() {
      for (var Un = this.getWidgets(), Kn = [], qn = 0, Jo = Un.length; qn < Jo; qn++) {
        var pa = Un[qn].getOnValue();
        pa && Kn.push(pa);
      }
      return Kn;
    }, zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn.create = function(Un) {
      var Kn = Un.obj({
        FT: "Btn",
        Ff: AcroButtonFlags.Radio,
        Kids: []
      }), qn = Un.register(Kn);
      return new zn(Kn, qn);
    }, zn;
  }(PDFAcroButton)
), PDFAcroListBox = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.fromDict = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn.create = function(Un) {
      var Kn = Un.obj({
        FT: "Ch",
        Kids: []
      }), qn = Un.register(Kn);
      return new zn(Kn, qn);
    }, zn;
  }(PDFAcroChoice)
), createPDFAcroFields = function(Xn) {
  if (!Xn)
    return [];
  for (var zn = [], Un = 0, Kn = Xn.size(); Un < Kn; Un++) {
    var qn = Xn.get(Un), Jo = Xn.lookup(Un);
    qn instanceof PDFRef && Jo instanceof PDFDict && zn.push([createPDFAcroField(Jo, qn), qn]);
  }
  return zn;
}, createPDFAcroField = function(Xn, zn) {
  var Un = isNonTerminalAcroField(Xn);
  return Un ? PDFAcroNonTerminal.fromDict(Xn, zn) : createPDFAcroTerminal(Xn, zn);
}, isNonTerminalAcroField = function(Xn) {
  var zn = Xn.lookup(PDFName.of("Kids"));
  if (zn instanceof PDFArray)
    for (var Un = 0, Kn = zn.size(); Un < Kn; Un++) {
      var qn = zn.lookup(Un), Jo = qn instanceof PDFDict && qn.has(PDFName.of("T"));
      if (Jo)
        return !0;
    }
  return !1;
}, createPDFAcroTerminal = function(Xn, zn) {
  var Un = getInheritableAttribute(Xn, PDFName.of("FT")), Kn = Xn.context.lookup(Un, PDFName);
  return Kn === PDFName.of("Btn") ? createPDFAcroButton(Xn, zn) : Kn === PDFName.of("Ch") ? createPDFAcroChoice(Xn, zn) : Kn === PDFName.of("Tx") ? PDFAcroText.fromDict(Xn, zn) : Kn === PDFName.of("Sig") ? PDFAcroSignature.fromDict(Xn, zn) : PDFAcroTerminal.fromDict(Xn, zn);
}, createPDFAcroButton = function(Xn, zn) {
  var Un, Kn = getInheritableAttribute(Xn, PDFName.of("Ff")), qn = Xn.context.lookupMaybe(Kn, PDFNumber), Jo = (Un = qn == null ? void 0 : qn.asNumber()) !== null && Un !== void 0 ? Un : 0;
  return flagIsSet(Jo, AcroButtonFlags.PushButton) ? PDFAcroPushButton.fromDict(Xn, zn) : flagIsSet(Jo, AcroButtonFlags.Radio) ? PDFAcroRadioButton.fromDict(Xn, zn) : PDFAcroCheckBox.fromDict(Xn, zn);
}, createPDFAcroChoice = function(Xn, zn) {
  var Un, Kn = getInheritableAttribute(Xn, PDFName.of("Ff")), qn = Xn.context.lookupMaybe(Kn, PDFNumber), Jo = (Un = qn == null ? void 0 : qn.asNumber()) !== null && Un !== void 0 ? Un : 0;
  return flagIsSet(Jo, AcroChoiceFlags.Combo) ? PDFAcroComboBox.fromDict(Xn, zn) : PDFAcroListBox.fromDict(Xn, zn);
}, flagIsSet = function(Xn, zn) {
  return (Xn & zn) !== 0;
}, getInheritableAttribute = function(Xn, zn) {
  var Un;
  return ascend(Xn, function(Kn) {
    Un || (Un = Kn.get(zn));
  }), Un;
}, ascend = function(Xn, zn) {
  zn(Xn);
  var Un = Xn.lookupMaybe(PDFName.of("Parent"), PDFDict);
  Un && ascend(Un, zn);
}, PDFAcroForm = (
  /** @class */
  function() {
    function Xn(zn) {
      this.dict = zn;
    }
    return Xn.prototype.Fields = function() {
      var zn = this.dict.lookup(PDFName.of("Fields"));
      if (zn instanceof PDFArray)
        return zn;
    }, Xn.prototype.getFields = function() {
      for (var zn = this.normalizedEntries().Fields, Un = new Array(zn.size()), Kn = 0, qn = zn.size(); Kn < qn; Kn++) {
        var Jo = zn.get(Kn), pa = zn.lookup(Kn, PDFDict);
        Un[Kn] = [createPDFAcroField(pa, Jo), Jo];
      }
      return Un;
    }, Xn.prototype.getAllFields = function() {
      var zn = [], Un = function(Kn) {
        if (Kn)
          for (var qn = 0, Jo = Kn.length; qn < Jo; qn++) {
            var pa = Kn[qn];
            zn.push(pa);
            var ma = pa[0];
            ma instanceof PDFAcroNonTerminal && Un(createPDFAcroFields(ma.Kids()));
          }
      };
      return Un(this.getFields()), zn;
    }, Xn.prototype.addField = function(zn) {
      var Un = this.normalizedEntries().Fields;
      Un == null || Un.push(zn);
    }, Xn.prototype.removeField = function(zn) {
      var Un = zn.getParent(), Kn = Un === void 0 ? this.normalizedEntries().Fields : Un.Kids(), qn = Kn == null ? void 0 : Kn.indexOf(zn.ref);
      if (Kn === void 0 || qn === void 0)
        throw new Error("Tried to remove inexistent field " + zn.getFullyQualifiedName());
      Kn.remove(qn), Un !== void 0 && Kn.size() === 0 && this.removeField(Un);
    }, Xn.prototype.normalizedEntries = function() {
      var zn = this.Fields();
      return zn || (zn = this.dict.context.obj([]), this.dict.set(PDFName.of("Fields"), zn)), { Fields: zn };
    }, Xn.fromDict = function(zn) {
      return new Xn(zn);
    }, Xn.create = function(zn) {
      var Un = zn.obj({ Fields: [] });
      return new Xn(Un);
    }, Xn;
  }()
), PDFCatalog = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.Pages = function() {
      return this.lookup(PDFName.of("Pages"), PDFDict);
    }, zn.prototype.AcroForm = function() {
      return this.lookupMaybe(PDFName.of("AcroForm"), PDFDict);
    }, zn.prototype.getAcroForm = function() {
      var Un = this.AcroForm();
      if (Un)
        return PDFAcroForm.fromDict(Un);
    }, zn.prototype.getOrCreateAcroForm = function() {
      var Un = this.getAcroForm();
      if (!Un) {
        Un = PDFAcroForm.create(this.context);
        var Kn = this.context.register(Un.dict);
        this.set(PDFName.of("AcroForm"), Kn);
      }
      return Un;
    }, zn.prototype.ViewerPreferences = function() {
      return this.lookupMaybe(PDFName.of("ViewerPreferences"), PDFDict);
    }, zn.prototype.getViewerPreferences = function() {
      var Un = this.ViewerPreferences();
      if (Un)
        return ViewerPreferences.fromDict(Un);
    }, zn.prototype.getOrCreateViewerPreferences = function() {
      var Un = this.getViewerPreferences();
      if (!Un) {
        Un = ViewerPreferences.create(this.context);
        var Kn = this.context.register(Un.dict);
        this.set(PDFName.of("ViewerPreferences"), Kn);
      }
      return Un;
    }, zn.prototype.insertLeafNode = function(Un, Kn) {
      var qn = this.get(PDFName.of("Pages")), Jo = this.Pages().insertLeafNode(Un, Kn);
      return Jo || qn;
    }, zn.prototype.removeLeafNode = function(Un) {
      this.Pages().removeLeafNode(Un);
    }, zn.withContextAndPages = function(Un, Kn) {
      var qn = /* @__PURE__ */ new Map();
      return qn.set(PDFName.of("Type"), PDFName.of("Catalog")), qn.set(PDFName.of("Pages"), Kn), new zn(qn, Un);
    }, zn.fromMapWithContext = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn;
  }(PDFDict)
), PDFPageTree = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      return Xn !== null && Xn.apply(this, arguments) || this;
    }
    return zn.prototype.Parent = function() {
      return this.lookup(PDFName.of("Parent"));
    }, zn.prototype.Kids = function() {
      return this.lookup(PDFName.of("Kids"), PDFArray);
    }, zn.prototype.Count = function() {
      return this.lookup(PDFName.of("Count"), PDFNumber);
    }, zn.prototype.pushTreeNode = function(Un) {
      var Kn = this.Kids();
      Kn.push(Un);
    }, zn.prototype.pushLeafNode = function(Un) {
      var Kn = this.Kids();
      this.insertLeafKid(Kn.size(), Un);
    }, zn.prototype.insertLeafNode = function(Un, Kn) {
      var qn = this.Kids(), Jo = this.Count().asNumber();
      if (Kn > Jo)
        throw new InvalidTargetIndexError(Kn, Jo);
      for (var pa = Kn, ma = 0, va = qn.size(); ma < va; ma++) {
        if (pa === 0) {
          this.insertLeafKid(ma, Un);
          return;
        }
        var ba = qn.get(ma), _a = this.context.lookup(ba);
        if (_a instanceof zn) {
          if (_a.Count().asNumber() > pa)
            return _a.insertLeafNode(Un, pa) || ba;
          pa -= _a.Count().asNumber();
        }
        _a instanceof PDFPageLeaf && (pa -= 1);
      }
      if (pa === 0) {
        this.insertLeafKid(qn.size(), Un);
        return;
      }
      throw new CorruptPageTreeError(Kn, "insertLeafNode");
    }, zn.prototype.removeLeafNode = function(Un, Kn) {
      Kn === void 0 && (Kn = !0);
      var qn = this.Kids(), Jo = this.Count().asNumber();
      if (Un >= Jo)
        throw new InvalidTargetIndexError(Un, Jo);
      for (var pa = Un, ma = 0, va = qn.size(); ma < va; ma++) {
        var ba = qn.get(ma), _a = this.context.lookup(ba);
        if (_a instanceof zn)
          if (_a.Count().asNumber() > pa) {
            _a.removeLeafNode(pa, Kn), Kn && _a.Kids().size() === 0 && qn.remove(ma);
            return;
          } else
            pa -= _a.Count().asNumber();
        if (_a instanceof PDFPageLeaf)
          if (pa === 0) {
            this.removeKid(ma);
            return;
          } else
            pa -= 1;
      }
      throw new CorruptPageTreeError(Un, "removeLeafNode");
    }, zn.prototype.ascend = function(Un) {
      Un(this);
      var Kn = this.Parent();
      Kn && Kn.ascend(Un);
    }, zn.prototype.traverse = function(Un) {
      for (var Kn = this.Kids(), qn = 0, Jo = Kn.size(); qn < Jo; qn++) {
        var pa = Kn.get(qn), ma = this.context.lookup(pa);
        ma instanceof zn && ma.traverse(Un), Un(ma, pa);
      }
    }, zn.prototype.insertLeafKid = function(Un, Kn) {
      var qn = this.Kids();
      this.ascend(function(Jo) {
        var pa = Jo.Count().asNumber() + 1;
        Jo.set(PDFName.of("Count"), PDFNumber.of(pa));
      }), qn.insert(Un, Kn);
    }, zn.prototype.removeKid = function(Un) {
      var Kn = this.Kids(), qn = Kn.lookup(Un);
      qn instanceof PDFPageLeaf && this.ascend(function(Jo) {
        var pa = Jo.Count().asNumber() - 1;
        Jo.set(PDFName.of("Count"), PDFNumber.of(pa));
      }), Kn.remove(Un);
    }, zn.withContext = function(Un, Kn) {
      var qn = /* @__PURE__ */ new Map();
      return qn.set(PDFName.of("Type"), PDFName.of("Pages")), qn.set(PDFName.of("Kids"), Un.obj([])), qn.set(PDFName.of("Count"), Un.obj(0)), Kn && qn.set(PDFName.of("Parent"), Kn), new zn(qn, Un);
    }, zn.fromMapWithContext = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn;
  }(PDFDict)
), IsDigit = new Uint8Array(256);
IsDigit[CharCodes$1.Zero] = 1;
IsDigit[CharCodes$1.One] = 1;
IsDigit[CharCodes$1.Two] = 1;
IsDigit[CharCodes$1.Three] = 1;
IsDigit[CharCodes$1.Four] = 1;
IsDigit[CharCodes$1.Five] = 1;
IsDigit[CharCodes$1.Six] = 1;
IsDigit[CharCodes$1.Seven] = 1;
IsDigit[CharCodes$1.Eight] = 1;
IsDigit[CharCodes$1.Nine] = 1;
var IsNumericPrefix = new Uint8Array(256);
IsNumericPrefix[CharCodes$1.Period] = 1;
IsNumericPrefix[CharCodes$1.Plus] = 1;
IsNumericPrefix[CharCodes$1.Minus] = 1;
var IsNumeric = new Uint8Array(256);
for (var idx = 0, len = 256; idx < len; idx++)
  IsNumeric[idx] = IsDigit[idx] || IsNumericPrefix[idx] ? 1 : 0;
var Newline$1 = CharCodes$1.Newline, CarriageReturn$1 = CharCodes$1.CarriageReturn, BaseParser = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      Un === void 0 && (Un = !1), this.bytes = zn, this.capNumbers = Un;
    }
    return Xn.prototype.parseRawInt = function() {
      for (var zn = ""; !this.bytes.done(); ) {
        var Un = this.bytes.peek();
        if (!IsDigit[Un])
          break;
        zn += charFromCode(this.bytes.next());
      }
      var Kn = Number(zn);
      if (!zn || !isFinite(Kn))
        throw new NumberParsingError(this.bytes.position(), zn);
      return Kn;
    }, Xn.prototype.parseRawNumber = function() {
      for (var zn = ""; !this.bytes.done(); ) {
        var Un = this.bytes.peek();
        if (!IsNumeric[Un] || (zn += charFromCode(this.bytes.next()), Un === CharCodes$1.Period))
          break;
      }
      for (; !this.bytes.done(); ) {
        var Un = this.bytes.peek();
        if (!IsDigit[Un])
          break;
        zn += charFromCode(this.bytes.next());
      }
      var Kn = Number(zn);
      if (!zn || !isFinite(Kn))
        throw new NumberParsingError(this.bytes.position(), zn);
      if (Kn > Number.MAX_SAFE_INTEGER)
        if (this.capNumbers) {
          var qn = "Parsed number that is too large for some PDF readers: " + zn + ", using Number.MAX_SAFE_INTEGER instead.";
          return console.warn(qn), Number.MAX_SAFE_INTEGER;
        } else {
          var qn = "Parsed number that is too large for some PDF readers: " + zn + ", not capping.";
          console.warn(qn);
        }
      return Kn;
    }, Xn.prototype.skipWhitespace = function() {
      for (; !this.bytes.done() && IsWhitespace[this.bytes.peek()]; )
        this.bytes.next();
    }, Xn.prototype.skipLine = function() {
      for (; !this.bytes.done(); ) {
        var zn = this.bytes.peek();
        if (zn === Newline$1 || zn === CarriageReturn$1)
          return;
        this.bytes.next();
      }
    }, Xn.prototype.skipComment = function() {
      if (this.bytes.peek() !== CharCodes$1.Percent)
        return !1;
      for (; !this.bytes.done(); ) {
        var zn = this.bytes.peek();
        if (zn === Newline$1 || zn === CarriageReturn$1)
          return !0;
        this.bytes.next();
      }
      return !0;
    }, Xn.prototype.skipWhitespaceAndComments = function() {
      for (this.skipWhitespace(); this.skipComment(); )
        this.skipWhitespace();
    }, Xn.prototype.matchKeyword = function(zn) {
      for (var Un = this.bytes.offset(), Kn = 0, qn = zn.length; Kn < qn; Kn++)
        if (this.bytes.done() || this.bytes.next() !== zn[Kn])
          return this.bytes.moveTo(Un), !1;
      return !0;
    }, Xn;
  }()
), ByteStream = (
  /** @class */
  function() {
    function Xn(zn) {
      this.idx = 0, this.line = 0, this.column = 0, this.bytes = zn, this.length = this.bytes.length;
    }
    return Xn.prototype.moveTo = function(zn) {
      this.idx = zn;
    }, Xn.prototype.next = function() {
      var zn = this.bytes[this.idx++];
      return zn === CharCodes$1.Newline ? (this.line += 1, this.column = 0) : this.column += 1, zn;
    }, Xn.prototype.assertNext = function(zn) {
      if (this.peek() !== zn)
        throw new NextByteAssertionError(this.position(), zn, this.peek());
      return this.next();
    }, Xn.prototype.peek = function() {
      return this.bytes[this.idx];
    }, Xn.prototype.peekAhead = function(zn) {
      return this.bytes[this.idx + zn];
    }, Xn.prototype.peekAt = function(zn) {
      return this.bytes[zn];
    }, Xn.prototype.done = function() {
      return this.idx >= this.length;
    }, Xn.prototype.offset = function() {
      return this.idx;
    }, Xn.prototype.slice = function(zn, Un) {
      return this.bytes.slice(zn, Un);
    }, Xn.prototype.position = function() {
      return { line: this.line, column: this.column, offset: this.idx };
    }, Xn.of = function(zn) {
      return new Xn(zn);
    }, Xn.fromPDFRawStream = function(zn) {
      return Xn.of(decodePDFRawStream(zn).decode());
    }, Xn;
  }()
), Space = CharCodes$1.Space, CarriageReturn = CharCodes$1.CarriageReturn, Newline = CharCodes$1.Newline, stream = [
  CharCodes$1.s,
  CharCodes$1.t,
  CharCodes$1.r,
  CharCodes$1.e,
  CharCodes$1.a,
  CharCodes$1.m
], endstream = [
  CharCodes$1.e,
  CharCodes$1.n,
  CharCodes$1.d,
  CharCodes$1.s,
  CharCodes$1.t,
  CharCodes$1.r,
  CharCodes$1.e,
  CharCodes$1.a,
  CharCodes$1.m
], Keywords = {
  header: [
    CharCodes$1.Percent,
    CharCodes$1.P,
    CharCodes$1.D,
    CharCodes$1.F,
    CharCodes$1.Dash
  ],
  eof: [
    CharCodes$1.Percent,
    CharCodes$1.Percent,
    CharCodes$1.E,
    CharCodes$1.O,
    CharCodes$1.F
  ],
  obj: [CharCodes$1.o, CharCodes$1.b, CharCodes$1.j],
  endobj: [
    CharCodes$1.e,
    CharCodes$1.n,
    CharCodes$1.d,
    CharCodes$1.o,
    CharCodes$1.b,
    CharCodes$1.j
  ],
  xref: [CharCodes$1.x, CharCodes$1.r, CharCodes$1.e, CharCodes$1.f],
  trailer: [
    CharCodes$1.t,
    CharCodes$1.r,
    CharCodes$1.a,
    CharCodes$1.i,
    CharCodes$1.l,
    CharCodes$1.e,
    CharCodes$1.r
  ],
  startxref: [
    CharCodes$1.s,
    CharCodes$1.t,
    CharCodes$1.a,
    CharCodes$1.r,
    CharCodes$1.t,
    CharCodes$1.x,
    CharCodes$1.r,
    CharCodes$1.e,
    CharCodes$1.f
  ],
  true: [CharCodes$1.t, CharCodes$1.r, CharCodes$1.u, CharCodes$1.e],
  false: [CharCodes$1.f, CharCodes$1.a, CharCodes$1.l, CharCodes$1.s, CharCodes$1.e],
  null: [CharCodes$1.n, CharCodes$1.u, CharCodes$1.l, CharCodes$1.l],
  stream,
  streamEOF1: __spreadArrays(stream, [Space, CarriageReturn, Newline]),
  streamEOF2: __spreadArrays(stream, [CarriageReturn, Newline]),
  streamEOF3: __spreadArrays(stream, [CarriageReturn]),
  streamEOF4: __spreadArrays(stream, [Newline]),
  endstream,
  EOF1endstream: __spreadArrays([CarriageReturn, Newline], endstream),
  EOF2endstream: __spreadArrays([CarriageReturn], endstream),
  EOF3endstream: __spreadArrays([Newline], endstream)
}, PDFObjectParser = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      qn === void 0 && (qn = !1);
      var Jo = Xn.call(this, Un, qn) || this;
      return Jo.context = Kn, Jo;
    }
    return zn.prototype.parseObject = function() {
      if (this.skipWhitespaceAndComments(), this.matchKeyword(Keywords.true))
        return PDFBool.True;
      if (this.matchKeyword(Keywords.false))
        return PDFBool.False;
      if (this.matchKeyword(Keywords.null))
        return PDFNull$1;
      var Un = this.bytes.peek();
      if (Un === CharCodes$1.LessThan && this.bytes.peekAhead(1) === CharCodes$1.LessThan)
        return this.parseDictOrStream();
      if (Un === CharCodes$1.LessThan)
        return this.parseHexString();
      if (Un === CharCodes$1.LeftParen)
        return this.parseString();
      if (Un === CharCodes$1.ForwardSlash)
        return this.parseName();
      if (Un === CharCodes$1.LeftSquareBracket)
        return this.parseArray();
      if (IsNumeric[Un])
        return this.parseNumberOrRef();
      throw new PDFObjectParsingError(this.bytes.position(), Un);
    }, zn.prototype.parseNumberOrRef = function() {
      var Un = this.parseRawNumber();
      this.skipWhitespaceAndComments();
      var Kn = this.bytes.offset();
      if (IsDigit[this.bytes.peek()]) {
        var qn = this.parseRawNumber();
        if (this.skipWhitespaceAndComments(), this.bytes.peek() === CharCodes$1.R)
          return this.bytes.assertNext(CharCodes$1.R), PDFRef.of(Un, qn);
      }
      return this.bytes.moveTo(Kn), PDFNumber.of(Un);
    }, zn.prototype.parseHexString = function() {
      var Un = "";
      for (this.bytes.assertNext(CharCodes$1.LessThan); !this.bytes.done() && this.bytes.peek() !== CharCodes$1.GreaterThan; )
        Un += charFromCode(this.bytes.next());
      return this.bytes.assertNext(CharCodes$1.GreaterThan), PDFHexString.of(Un);
    }, zn.prototype.parseString = function() {
      for (var Un = 0, Kn = !1, qn = ""; !this.bytes.done(); ) {
        var Jo = this.bytes.next();
        if (qn += charFromCode(Jo), Kn || (Jo === CharCodes$1.LeftParen && (Un += 1), Jo === CharCodes$1.RightParen && (Un -= 1)), Jo === CharCodes$1.BackSlash ? Kn = !Kn : Kn && (Kn = !1), Un === 0)
          return PDFString.of(qn.substring(1, qn.length - 1));
      }
      throw new UnbalancedParenthesisError(this.bytes.position());
    }, zn.prototype.parseName = function() {
      this.bytes.assertNext(CharCodes$1.ForwardSlash);
      for (var Un = ""; !this.bytes.done(); ) {
        var Kn = this.bytes.peek();
        if (IsWhitespace[Kn] || IsDelimiter[Kn])
          break;
        Un += charFromCode(Kn), this.bytes.next();
      }
      return PDFName.of(Un);
    }, zn.prototype.parseArray = function() {
      this.bytes.assertNext(CharCodes$1.LeftSquareBracket), this.skipWhitespaceAndComments();
      for (var Un = PDFArray.withContext(this.context); this.bytes.peek() !== CharCodes$1.RightSquareBracket; ) {
        var Kn = this.parseObject();
        Un.push(Kn), this.skipWhitespaceAndComments();
      }
      return this.bytes.assertNext(CharCodes$1.RightSquareBracket), Un;
    }, zn.prototype.parseDict = function() {
      this.bytes.assertNext(CharCodes$1.LessThan), this.bytes.assertNext(CharCodes$1.LessThan), this.skipWhitespaceAndComments();
      for (var Un = /* @__PURE__ */ new Map(); !this.bytes.done() && this.bytes.peek() !== CharCodes$1.GreaterThan && this.bytes.peekAhead(1) !== CharCodes$1.GreaterThan; ) {
        var Kn = this.parseName(), qn = this.parseObject();
        Un.set(Kn, qn), this.skipWhitespaceAndComments();
      }
      this.skipWhitespaceAndComments(), this.bytes.assertNext(CharCodes$1.GreaterThan), this.bytes.assertNext(CharCodes$1.GreaterThan);
      var Jo = Un.get(PDFName.of("Type"));
      return Jo === PDFName.of("Catalog") ? PDFCatalog.fromMapWithContext(Un, this.context) : Jo === PDFName.of("Pages") ? PDFPageTree.fromMapWithContext(Un, this.context) : Jo === PDFName.of("Page") ? PDFPageLeaf.fromMapWithContext(Un, this.context) : PDFDict.fromMapWithContext(Un, this.context);
    }, zn.prototype.parseDictOrStream = function() {
      var Un = this.bytes.position(), Kn = this.parseDict();
      if (this.skipWhitespaceAndComments(), !this.matchKeyword(Keywords.streamEOF1) && !this.matchKeyword(Keywords.streamEOF2) && !this.matchKeyword(Keywords.streamEOF3) && !this.matchKeyword(Keywords.streamEOF4) && !this.matchKeyword(Keywords.stream))
        return Kn;
      var qn = this.bytes.offset(), Jo, pa = Kn.get(PDFName.of("Length"));
      pa instanceof PDFNumber ? (Jo = qn + pa.asNumber(), this.bytes.moveTo(Jo), this.skipWhitespaceAndComments(), this.matchKeyword(Keywords.endstream) || (this.bytes.moveTo(qn), Jo = this.findEndOfStreamFallback(Un))) : Jo = this.findEndOfStreamFallback(Un);
      var ma = this.bytes.slice(qn, Jo);
      return PDFRawStream.of(Kn, ma);
    }, zn.prototype.findEndOfStreamFallback = function(Un) {
      for (var Kn = 1, qn = this.bytes.offset(); !this.bytes.done() && (qn = this.bytes.offset(), this.matchKeyword(Keywords.stream) ? Kn += 1 : this.matchKeyword(Keywords.EOF1endstream) || this.matchKeyword(Keywords.EOF2endstream) || this.matchKeyword(Keywords.EOF3endstream) || this.matchKeyword(Keywords.endstream) ? Kn -= 1 : this.bytes.next(), Kn !== 0); )
        ;
      if (Kn !== 0)
        throw new PDFStreamParsingError(Un);
      return qn;
    }, zn.forBytes = function(Un, Kn, qn) {
      return new zn(ByteStream.of(Un), Kn, qn);
    }, zn.forByteStream = function(Un, Kn, qn) {
      return qn === void 0 && (qn = !1), new zn(Un, Kn, qn);
    }, zn;
  }(BaseParser)
), PDFObjectStreamParser = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = Xn.call(this, ByteStream.fromPDFRawStream(Un), Un.dict.context) || this, Jo = Un.dict;
      return qn.alreadyParsed = !1, qn.shouldWaitForTick = Kn || function() {
        return !1;
      }, qn.firstOffset = Jo.lookup(PDFName.of("First"), PDFNumber).asNumber(), qn.objectCount = Jo.lookup(PDFName.of("N"), PDFNumber).asNumber(), qn;
    }
    return zn.prototype.parseIntoContext = function() {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo, pa, ma, va, ba;
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              if (this.alreadyParsed)
                throw new ReparseError("PDFObjectStreamParser", "parseIntoContext");
              this.alreadyParsed = !0, Un = this.parseOffsetsAndObjectNumbers(), Kn = 0, qn = Un.length, _a.label = 1;
            case 1:
              return Kn < qn ? (Jo = Un[Kn], pa = Jo.objectNumber, ma = Jo.offset, this.bytes.moveTo(this.firstOffset + ma), va = this.parseObject(), ba = PDFRef.of(pa, 0), this.context.assign(ba, va), this.shouldWaitForTick() ? [4, waitForTick()] : [3, 3]) : [3, 4];
            case 2:
              _a.sent(), _a.label = 3;
            case 3:
              return Kn++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, zn.prototype.parseOffsetsAndObjectNumbers = function() {
      for (var Un = [], Kn = 0, qn = this.objectCount; Kn < qn; Kn++) {
        this.skipWhitespaceAndComments();
        var Jo = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var pa = this.parseRawInt();
        Un.push({ objectNumber: Jo, offset: pa });
      }
      return Un;
    }, zn.forStream = function(Un, Kn) {
      return new zn(Un, Kn);
    }, zn;
  }(PDFObjectParser)
), PDFXRefStreamParser = (
  /** @class */
  function() {
    function Xn(zn) {
      this.alreadyParsed = !1, this.dict = zn.dict, this.bytes = ByteStream.fromPDFRawStream(zn), this.context = this.dict.context;
      var Un = this.dict.lookup(PDFName.of("Size"), PDFNumber), Kn = this.dict.lookup(PDFName.of("Index"));
      if (Kn instanceof PDFArray) {
        this.subsections = [];
        for (var qn = 0, Jo = Kn.size(); qn < Jo; qn += 2) {
          var pa = Kn.lookup(qn + 0, PDFNumber).asNumber(), ma = Kn.lookup(qn + 1, PDFNumber).asNumber();
          this.subsections.push({ firstObjectNumber: pa, length: ma });
        }
      } else
        this.subsections = [{ firstObjectNumber: 0, length: Un.asNumber() }];
      var va = this.dict.lookup(PDFName.of("W"), PDFArray);
      this.byteWidths = [-1, -1, -1];
      for (var qn = 0, Jo = va.size(); qn < Jo; qn++)
        this.byteWidths[qn] = va.lookup(qn, PDFNumber).asNumber();
    }
    return Xn.prototype.parseIntoContext = function() {
      if (this.alreadyParsed)
        throw new ReparseError("PDFXRefStreamParser", "parseIntoContext");
      this.alreadyParsed = !0, this.context.trailerInfo = {
        Root: this.dict.get(PDFName.of("Root")),
        Encrypt: this.dict.get(PDFName.of("Encrypt")),
        Info: this.dict.get(PDFName.of("Info")),
        ID: this.dict.get(PDFName.of("ID"))
      };
      var zn = this.parseEntries();
      return zn;
    }, Xn.prototype.parseEntries = function() {
      for (var zn = [], Un = this.byteWidths, Kn = Un[0], qn = Un[1], Jo = Un[2], pa = 0, ma = this.subsections.length; pa < ma; pa++)
        for (var va = this.subsections[pa], ba = va.firstObjectNumber, _a = va.length, ya = 0; ya < _a; ya++) {
          for (var xa = 0, wa = 0, Ta = Kn; wa < Ta; wa++)
            xa = xa << 8 | this.bytes.next();
          for (var Sa = 0, wa = 0, Ta = qn; wa < Ta; wa++)
            Sa = Sa << 8 | this.bytes.next();
          for (var Ma = 0, wa = 0, Ta = Jo; wa < Ta; wa++)
            Ma = Ma << 8 | this.bytes.next();
          Kn === 0 && (xa = 1);
          var ka = ba + ya, Za = {
            ref: PDFRef.of(ka, Ma),
            offset: Sa,
            deleted: xa === 0,
            inObjectStream: xa === 2
          };
          zn.push(Za);
        }
      return zn;
    }, Xn.forStream = function(zn) {
      return new Xn(zn);
    }, Xn;
  }()
), PDFParser = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn, Jo) {
      Kn === void 0 && (Kn = 1 / 0), qn === void 0 && (qn = !1), Jo === void 0 && (Jo = !1);
      var pa = Xn.call(this, ByteStream.of(Un), PDFContext.create(), Jo) || this;
      return pa.alreadyParsed = !1, pa.parsedObjects = 0, pa.shouldWaitForTick = function() {
        return pa.parsedObjects += 1, pa.parsedObjects % pa.objectsPerTick === 0;
      }, pa.objectsPerTick = Kn, pa.throwOnInvalidObject = qn, pa;
    }
    return zn.prototype.parseDocument = function() {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn;
        return __generator(this, function(qn) {
          switch (qn.label) {
            case 0:
              if (this.alreadyParsed)
                throw new ReparseError("PDFParser", "parseDocument");
              this.alreadyParsed = !0, this.context.header = this.parseHeader(), qn.label = 1;
            case 1:
              return this.bytes.done() ? [3, 3] : [4, this.parseDocumentSection()];
            case 2:
              if (qn.sent(), Kn = this.bytes.offset(), Kn === Un)
                throw new StalledParserError(this.bytes.position());
              return Un = Kn, [3, 1];
            case 3:
              return this.maybeRecoverRoot(), this.context.lookup(PDFRef.of(0)) && (console.warn("Removing parsed object: 0 0 R"), this.context.delete(PDFRef.of(0))), [2, this.context];
          }
        });
      });
    }, zn.prototype.maybeRecoverRoot = function() {
      var Un = function(_a) {
        return _a instanceof PDFDict && _a.lookup(PDFName.of("Type")) === PDFName.of("Catalog");
      }, Kn = this.context.lookup(this.context.trailerInfo.Root);
      if (!Un(Kn))
        for (var qn = this.context.enumerateIndirectObjects(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
          var ma = qn[Jo], va = ma[0], ba = ma[1];
          Un(ba) && (this.context.trailerInfo.Root = va);
        }
    }, zn.prototype.parseHeader = function() {
      for (; !this.bytes.done(); ) {
        if (this.matchKeyword(Keywords.header)) {
          var Un = this.parseRawInt();
          this.bytes.assertNext(CharCodes$1.Period);
          var Kn = this.parseRawInt(), qn = PDFHeader.forVersion(Un, Kn);
          return this.skipBinaryHeaderComment(), qn;
        }
        this.bytes.next();
      }
      throw new MissingPDFHeaderError(this.bytes.position());
    }, zn.prototype.parseIndirectObjectHeader = function() {
      this.skipWhitespaceAndComments();
      var Un = this.parseRawInt();
      this.skipWhitespaceAndComments();
      var Kn = this.parseRawInt();
      if (this.skipWhitespaceAndComments(), !this.matchKeyword(Keywords.obj))
        throw new MissingKeywordError(this.bytes.position(), Keywords.obj);
      return PDFRef.of(Un, Kn);
    }, zn.prototype.matchIndirectObjectHeader = function() {
      var Un = this.bytes.offset();
      try {
        return this.parseIndirectObjectHeader(), !0;
      } catch {
        return this.bytes.moveTo(Un), !1;
      }
    }, zn.prototype.parseIndirectObject = function() {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn;
        return __generator(this, function(qn) {
          switch (qn.label) {
            case 0:
              return Un = this.parseIndirectObjectHeader(), this.skipWhitespaceAndComments(), Kn = this.parseObject(), this.skipWhitespaceAndComments(), this.matchKeyword(Keywords.endobj), Kn instanceof PDFRawStream && Kn.dict.lookup(PDFName.of("Type")) === PDFName.of("ObjStm") ? [4, PDFObjectStreamParser.forStream(Kn, this.shouldWaitForTick).parseIntoContext()] : [3, 2];
            case 1:
              return qn.sent(), [3, 3];
            case 2:
              Kn instanceof PDFRawStream && Kn.dict.lookup(PDFName.of("Type")) === PDFName.of("XRef") ? PDFXRefStreamParser.forStream(Kn).parseIntoContext() : this.context.assign(Un, Kn), qn.label = 3;
            case 3:
              return [2, Un];
          }
        });
      });
    }, zn.prototype.tryToParseInvalidIndirectObject = function() {
      var Un = this.bytes.position(), Kn = "Trying to parse invalid object: " + JSON.stringify(Un) + ")";
      if (this.throwOnInvalidObject)
        throw new Error(Kn);
      console.warn(Kn);
      var qn = this.parseIndirectObjectHeader();
      console.warn("Invalid object ref: " + qn), this.skipWhitespaceAndComments();
      for (var Jo = this.bytes.offset(), pa = !0; !this.bytes.done() && (this.matchKeyword(Keywords.endobj) && (pa = !1), !!pa); )
        this.bytes.next();
      if (pa)
        throw new PDFInvalidObjectParsingError(Un);
      var ma = this.bytes.offset() - Keywords.endobj.length, va = PDFInvalidObject.of(this.bytes.slice(Jo, ma));
      return this.context.assign(qn, va), qn;
    }, zn.prototype.parseIndirectObjects = function() {
      return __awaiter(this, void 0, void 0, function() {
        var Un;
        return __generator(this, function(Kn) {
          switch (Kn.label) {
            case 0:
              this.skipWhitespaceAndComments(), Kn.label = 1;
            case 1:
              if (!(!this.bytes.done() && IsDigit[this.bytes.peek()])) return [3, 8];
              Un = this.bytes.offset(), Kn.label = 2;
            case 2:
              return Kn.trys.push([2, 4, , 5]), [4, this.parseIndirectObject()];
            case 3:
              return Kn.sent(), [3, 5];
            case 4:
              return Kn.sent(), this.bytes.moveTo(Un), this.tryToParseInvalidIndirectObject(), [3, 5];
            case 5:
              return this.skipWhitespaceAndComments(), this.skipJibberish(), this.shouldWaitForTick() ? [4, waitForTick()] : [3, 7];
            case 6:
              Kn.sent(), Kn.label = 7;
            case 7:
              return [3, 1];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, zn.prototype.maybeParseCrossRefSection = function() {
      if (this.skipWhitespaceAndComments(), !!this.matchKeyword(Keywords.xref)) {
        this.skipWhitespaceAndComments();
        for (var Un = -1, Kn = PDFCrossRefSection.createEmpty(); !this.bytes.done() && IsDigit[this.bytes.peek()]; ) {
          var qn = this.parseRawInt();
          this.skipWhitespaceAndComments();
          var Jo = this.parseRawInt();
          this.skipWhitespaceAndComments();
          var pa = this.bytes.peek();
          if (pa === CharCodes$1.n || pa === CharCodes$1.f) {
            var ma = PDFRef.of(Un, Jo);
            this.bytes.next() === CharCodes$1.n ? Kn.addEntry(ma, qn) : Kn.addDeletedEntry(ma, qn), Un += 1;
          } else
            Un = qn;
          this.skipWhitespaceAndComments();
        }
        return Kn;
      }
    }, zn.prototype.maybeParseTrailerDict = function() {
      if (this.skipWhitespaceAndComments(), !!this.matchKeyword(Keywords.trailer)) {
        this.skipWhitespaceAndComments();
        var Un = this.parseDict(), Kn = this.context;
        Kn.trailerInfo = {
          Root: Un.get(PDFName.of("Root")) || Kn.trailerInfo.Root,
          Encrypt: Un.get(PDFName.of("Encrypt")) || Kn.trailerInfo.Encrypt,
          Info: Un.get(PDFName.of("Info")) || Kn.trailerInfo.Info,
          ID: Un.get(PDFName.of("ID")) || Kn.trailerInfo.ID
        };
      }
    }, zn.prototype.maybeParseTrailer = function() {
      if (this.skipWhitespaceAndComments(), !!this.matchKeyword(Keywords.startxref)) {
        this.skipWhitespaceAndComments();
        var Un = this.parseRawInt();
        return this.skipWhitespace(), this.matchKeyword(Keywords.eof), this.skipWhitespaceAndComments(), this.matchKeyword(Keywords.eof), this.skipWhitespaceAndComments(), PDFTrailer.forLastCrossRefSectionOffset(Un);
      }
    }, zn.prototype.parseDocumentSection = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(Un) {
          switch (Un.label) {
            case 0:
              return [4, this.parseIndirectObjects()];
            case 1:
              return Un.sent(), this.maybeParseCrossRefSection(), this.maybeParseTrailerDict(), this.maybeParseTrailer(), this.skipJibberish(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, zn.prototype.skipJibberish = function() {
      for (this.skipWhitespaceAndComments(); !this.bytes.done(); ) {
        var Un = this.bytes.offset(), Kn = this.bytes.peek(), qn = Kn >= CharCodes$1.Space && Kn <= CharCodes$1.Tilde;
        if (qn && (this.matchKeyword(Keywords.xref) || this.matchKeyword(Keywords.trailer) || this.matchKeyword(Keywords.startxref) || this.matchIndirectObjectHeader())) {
          this.bytes.moveTo(Un);
          break;
        }
        this.bytes.next();
      }
    }, zn.prototype.skipBinaryHeaderComment = function() {
      this.skipWhitespaceAndComments();
      try {
        var Un = this.bytes.offset();
        this.parseIndirectObjectHeader(), this.bytes.moveTo(Un);
      } catch {
        this.bytes.next(), this.skipWhitespaceAndComments();
      }
    }, zn.forBytesWithOptions = function(Un, Kn, qn, Jo) {
      return new zn(Un, Kn, qn, Jo);
    }, zn;
  }(PDFObjectParser)
), flag = function(Xn) {
  return 1 << Xn;
}, AnnotationFlags;
(function(Xn) {
  Xn[Xn.Invisible = flag(0)] = "Invisible", Xn[Xn.Hidden = flag(1)] = "Hidden", Xn[Xn.Print = flag(2)] = "Print", Xn[Xn.NoZoom = flag(3)] = "NoZoom", Xn[Xn.NoRotate = flag(4)] = "NoRotate", Xn[Xn.NoView = flag(5)] = "NoView", Xn[Xn.ReadOnly = flag(6)] = "ReadOnly", Xn[Xn.Locked = flag(7)] = "Locked", Xn[Xn.ToggleNoView = flag(8)] = "ToggleNoView", Xn[Xn.LockedContents = flag(9)] = "LockedContents";
})(AnnotationFlags || (AnnotationFlags = {}));
var asPDFName = function(Xn) {
  return Xn instanceof PDFName ? Xn : PDFName.of(Xn);
}, asPDFNumber = function(Xn) {
  return Xn instanceof PDFNumber ? Xn : PDFNumber.of(Xn);
}, asNumber = function(Xn) {
  return Xn instanceof PDFNumber ? Xn.asNumber() : Xn;
}, RotationTypes;
(function(Xn) {
  Xn.Degrees = "degrees", Xn.Radians = "radians";
})(RotationTypes || (RotationTypes = {}));
var degrees = function(Xn) {
  return assertIs(Xn, "degreeAngle", ["number"]), { type: RotationTypes.Degrees, angle: Xn };
}, Radians = RotationTypes.Radians, Degrees = RotationTypes.Degrees, degreesToRadians = function(Xn) {
  return Xn * Math.PI / 180;
}, radiansToDegrees = function(Xn) {
  return Xn * 180 / Math.PI;
}, toRadians = function(Xn) {
  return Xn.type === Radians ? Xn.angle : Xn.type === Degrees ? degreesToRadians(Xn.angle) : error("Invalid rotation: " + JSON.stringify(Xn));
}, toDegrees = function(Xn) {
  return Xn.type === Radians ? radiansToDegrees(Xn.angle) : Xn.type === Degrees ? Xn.angle : error("Invalid rotation: " + JSON.stringify(Xn));
}, reduceRotation = function(Xn) {
  Xn === void 0 && (Xn = 0);
  var zn = Xn / 90 % 4;
  return zn === 0 ? 0 : zn === 1 ? 90 : zn === 2 ? 180 : zn === 3 ? 270 : 0;
}, adjustDimsForRotation = function(Xn, zn) {
  zn === void 0 && (zn = 0);
  var Un = reduceRotation(zn);
  return Un === 90 || Un === 270 ? { width: Xn.height, height: Xn.width } : { width: Xn.width, height: Xn.height };
}, rotateRectangle = function(Xn, zn, Un) {
  zn === void 0 && (zn = 0), Un === void 0 && (Un = 0);
  var Kn = Xn.x, qn = Xn.y, Jo = Xn.width, pa = Xn.height, ma = reduceRotation(Un), va = zn / 2;
  return ma === 0 ? { x: Kn - va, y: qn - va, width: Jo, height: pa } : ma === 90 ? { x: Kn - pa + va, y: qn - va, width: pa, height: Jo } : ma === 180 ? { x: Kn - Jo + va, y: qn - pa + va, width: Jo, height: pa } : ma === 270 ? { x: Kn - va, y: qn - Jo + va, width: pa, height: Jo } : { x: Kn - va, y: qn - va, width: Jo, height: pa };
}, clip = function() {
  return PDFOperator.of(Ops.ClipNonZero);
}, cos = Math.cos, sin = Math.sin, tan = Math.tan, concatTransformationMatrix = function(Xn, zn, Un, Kn, qn, Jo) {
  return PDFOperator.of(Ops.ConcatTransformationMatrix, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un),
    asPDFNumber(Kn),
    asPDFNumber(qn),
    asPDFNumber(Jo)
  ]);
}, translate = function(Xn, zn) {
  return concatTransformationMatrix(1, 0, 0, 1, Xn, zn);
}, scale = function(Xn, zn) {
  return concatTransformationMatrix(Xn, 0, 0, zn, 0, 0);
}, rotateRadians = function(Xn) {
  return concatTransformationMatrix(cos(asNumber(Xn)), sin(asNumber(Xn)), -sin(asNumber(Xn)), cos(asNumber(Xn)), 0, 0);
}, rotateDegrees = function(Xn) {
  return rotateRadians(degreesToRadians(asNumber(Xn)));
}, skewRadians = function(Xn, zn) {
  return concatTransformationMatrix(1, tan(asNumber(Xn)), tan(asNumber(zn)), 1, 0, 0);
}, setDashPattern = function(Xn, zn) {
  return PDFOperator.of(Ops.SetLineDashPattern, [
    "[" + Xn.map(asPDFNumber).join(" ") + "]",
    asPDFNumber(zn)
  ]);
}, LineCapStyle;
(function(Xn) {
  Xn[Xn.Butt = 0] = "Butt", Xn[Xn.Round = 1] = "Round", Xn[Xn.Projecting = 2] = "Projecting";
})(LineCapStyle || (LineCapStyle = {}));
var setLineCap = function(Xn) {
  return PDFOperator.of(Ops.SetLineCapStyle, [asPDFNumber(Xn)]);
}, LineJoinStyle;
(function(Xn) {
  Xn[Xn.Miter = 0] = "Miter", Xn[Xn.Round = 1] = "Round", Xn[Xn.Bevel = 2] = "Bevel";
})(LineJoinStyle || (LineJoinStyle = {}));
var setGraphicsState = function(Xn) {
  return PDFOperator.of(Ops.SetGraphicsStateParams, [asPDFName(Xn)]);
}, pushGraphicsState = function() {
  return PDFOperator.of(Ops.PushGraphicsState);
}, popGraphicsState = function() {
  return PDFOperator.of(Ops.PopGraphicsState);
}, setLineWidth = function(Xn) {
  return PDFOperator.of(Ops.SetLineWidth, [asPDFNumber(Xn)]);
}, appendBezierCurve = function(Xn, zn, Un, Kn, qn, Jo) {
  return PDFOperator.of(Ops.AppendBezierCurve, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un),
    asPDFNumber(Kn),
    asPDFNumber(qn),
    asPDFNumber(Jo)
  ]);
}, appendQuadraticCurve = function(Xn, zn, Un, Kn) {
  return PDFOperator.of(Ops.CurveToReplicateInitialPoint, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un),
    asPDFNumber(Kn)
  ]);
}, closePath = function() {
  return PDFOperator.of(Ops.ClosePath);
}, moveTo = function(Xn, zn) {
  return PDFOperator.of(Ops.MoveTo, [asPDFNumber(Xn), asPDFNumber(zn)]);
}, lineTo = function(Xn, zn) {
  return PDFOperator.of(Ops.LineTo, [asPDFNumber(Xn), asPDFNumber(zn)]);
}, stroke = function() {
  return PDFOperator.of(Ops.StrokePath);
}, fill = function() {
  return PDFOperator.of(Ops.FillNonZero);
}, fillAndStroke = function() {
  return PDFOperator.of(Ops.FillNonZeroAndStroke);
}, endPath = function() {
  return PDFOperator.of(Ops.EndPath);
}, nextLine = function() {
  return PDFOperator.of(Ops.NextLine);
}, showText = function(Xn) {
  return PDFOperator.of(Ops.ShowText, [Xn]);
}, beginText = function() {
  return PDFOperator.of(Ops.BeginText);
}, endText = function() {
  return PDFOperator.of(Ops.EndText);
}, setFontAndSize = function(Xn, zn) {
  return PDFOperator.of(Ops.SetFontAndSize, [asPDFName(Xn), asPDFNumber(zn)]);
}, setLineHeight = function(Xn) {
  return PDFOperator.of(Ops.SetTextLineHeight, [asPDFNumber(Xn)]);
}, TextRenderingMode;
(function(Xn) {
  Xn[Xn.Fill = 0] = "Fill", Xn[Xn.Outline = 1] = "Outline", Xn[Xn.FillAndOutline = 2] = "FillAndOutline", Xn[Xn.Invisible = 3] = "Invisible", Xn[Xn.FillAndClip = 4] = "FillAndClip", Xn[Xn.OutlineAndClip = 5] = "OutlineAndClip", Xn[Xn.FillAndOutlineAndClip = 6] = "FillAndOutlineAndClip", Xn[Xn.Clip = 7] = "Clip";
})(TextRenderingMode || (TextRenderingMode = {}));
var setTextMatrix = function(Xn, zn, Un, Kn, qn, Jo) {
  return PDFOperator.of(Ops.SetTextMatrix, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un),
    asPDFNumber(Kn),
    asPDFNumber(qn),
    asPDFNumber(Jo)
  ]);
}, rotateAndSkewTextRadiansAndTranslate = function(Xn, zn, Un, Kn, qn) {
  return setTextMatrix(cos(asNumber(Xn)), sin(asNumber(Xn)) + tan(asNumber(zn)), -sin(asNumber(Xn)) + tan(asNumber(Un)), cos(asNumber(Xn)), Kn, qn);
}, drawObject = function(Xn) {
  return PDFOperator.of(Ops.DrawObject, [asPDFName(Xn)]);
}, setFillingGrayscaleColor = function(Xn) {
  return PDFOperator.of(Ops.NonStrokingColorGray, [asPDFNumber(Xn)]);
}, setStrokingGrayscaleColor = function(Xn) {
  return PDFOperator.of(Ops.StrokingColorGray, [asPDFNumber(Xn)]);
}, setFillingRgbColor = function(Xn, zn, Un) {
  return PDFOperator.of(Ops.NonStrokingColorRgb, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un)
  ]);
}, setStrokingRgbColor = function(Xn, zn, Un) {
  return PDFOperator.of(Ops.StrokingColorRgb, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un)
  ]);
}, setFillingCmykColor = function(Xn, zn, Un, Kn) {
  return PDFOperator.of(Ops.NonStrokingColorCmyk, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un),
    asPDFNumber(Kn)
  ]);
}, setStrokingCmykColor = function(Xn, zn, Un, Kn) {
  return PDFOperator.of(Ops.StrokingColorCmyk, [
    asPDFNumber(Xn),
    asPDFNumber(zn),
    asPDFNumber(Un),
    asPDFNumber(Kn)
  ]);
}, beginMarkedContent = function(Xn) {
  return PDFOperator.of(Ops.BeginMarkedContent, [asPDFName(Xn)]);
}, endMarkedContent = function() {
  return PDFOperator.of(Ops.EndMarkedContent);
}, ColorTypes;
(function(Xn) {
  Xn.Grayscale = "Grayscale", Xn.RGB = "RGB", Xn.CMYK = "CMYK";
})(ColorTypes || (ColorTypes = {}));
var grayscale = function(Xn) {
  return assertRange(Xn, "gray", 0, 1), { type: ColorTypes.Grayscale, gray: Xn };
}, rgb = function(Xn, zn, Un) {
  return assertRange(Xn, "red", 0, 1), assertRange(zn, "green", 0, 1), assertRange(Un, "blue", 0, 1), { type: ColorTypes.RGB, red: Xn, green: zn, blue: Un };
}, cmyk = function(Xn, zn, Un, Kn) {
  return assertRange(Xn, "cyan", 0, 1), assertRange(zn, "magenta", 0, 1), assertRange(Un, "yellow", 0, 1), assertRange(Kn, "key", 0, 1), { type: ColorTypes.CMYK, cyan: Xn, magenta: zn, yellow: Un, key: Kn };
}, Grayscale = ColorTypes.Grayscale, RGB = ColorTypes.RGB, CMYK = ColorTypes.CMYK, setFillingColor = function(Xn) {
  return Xn.type === Grayscale ? setFillingGrayscaleColor(Xn.gray) : Xn.type === RGB ? setFillingRgbColor(Xn.red, Xn.green, Xn.blue) : Xn.type === CMYK ? setFillingCmykColor(Xn.cyan, Xn.magenta, Xn.yellow, Xn.key) : error("Invalid color: " + JSON.stringify(Xn));
}, setStrokingColor = function(Xn) {
  return Xn.type === Grayscale ? setStrokingGrayscaleColor(Xn.gray) : Xn.type === RGB ? setStrokingRgbColor(Xn.red, Xn.green, Xn.blue) : Xn.type === CMYK ? setStrokingCmykColor(Xn.cyan, Xn.magenta, Xn.yellow, Xn.key) : error("Invalid color: " + JSON.stringify(Xn));
}, componentsToColor = function(Xn, zn) {
  return zn === void 0 && (zn = 1), (Xn == null ? void 0 : Xn.length) === 1 ? grayscale(Xn[0] * zn) : (Xn == null ? void 0 : Xn.length) === 3 ? rgb(Xn[0] * zn, Xn[1] * zn, Xn[2] * zn) : (Xn == null ? void 0 : Xn.length) === 4 ? cmyk(Xn[0] * zn, Xn[1] * zn, Xn[2] * zn, Xn[3] * zn) : void 0;
}, colorToComponents = function(Xn) {
  return Xn.type === Grayscale ? [Xn.gray] : Xn.type === RGB ? [Xn.red, Xn.green, Xn.blue] : Xn.type === CMYK ? [Xn.cyan, Xn.magenta, Xn.yellow, Xn.key] : error("Invalid color: " + JSON.stringify(Xn));
}, cx = 0, cy = 0, px = 0, py = 0, sx = 0, sy = 0, parameters = /* @__PURE__ */ new Map([
  ["A", 7],
  ["a", 7],
  ["C", 6],
  ["c", 6],
  ["H", 1],
  ["h", 1],
  ["L", 2],
  ["l", 2],
  ["M", 2],
  ["m", 2],
  ["Q", 4],
  ["q", 4],
  ["S", 4],
  ["s", 4],
  ["T", 2],
  ["t", 2],
  ["V", 1],
  ["v", 1],
  ["Z", 0],
  ["z", 0]
]), parse = function(Xn) {
  for (var zn, Un = [], Kn = [], qn = "", Jo = !1, pa = 0, ma = 0, va = Xn; ma < va.length; ma++) {
    var ba = va[ma];
    if (parameters.has(ba))
      pa = parameters.get(ba), zn && (qn.length > 0 && (Kn[Kn.length] = +qn), Un[Un.length] = { cmd: zn, args: Kn }, Kn = [], qn = "", Jo = !1), zn = ba;
    else if ([" ", ","].includes(ba) || ba === "-" && qn.length > 0 && qn[qn.length - 1] !== "e" || ba === "." && Jo) {
      if (qn.length === 0)
        continue;
      Kn.length === pa ? (Un[Un.length] = { cmd: zn, args: Kn }, Kn = [+qn], zn === "M" && (zn = "L"), zn === "m" && (zn = "l")) : Kn[Kn.length] = +qn, Jo = ba === ".", qn = ["-", "."].includes(ba) ? ba : "";
    } else
      qn += ba, ba === "." && (Jo = !0);
  }
  return qn.length > 0 && (Kn.length === pa ? (Un[Un.length] = { cmd: zn, args: Kn }, Kn = [+qn], zn === "M" && (zn = "L"), zn === "m" && (zn = "l")) : Kn[Kn.length] = +qn), Un[Un.length] = { cmd: zn, args: Kn }, Un;
}, apply = function(Xn) {
  cx = cy = px = py = sx = sy = 0;
  for (var zn = [], Un = 0; Un < Xn.length; Un++) {
    var Kn = Xn[Un];
    if (Kn.cmd && typeof runners[Kn.cmd] == "function") {
      var qn = runners[Kn.cmd](Kn.args);
      Array.isArray(qn) ? zn = zn.concat(qn) : zn.push(qn);
    }
  }
  return zn;
}, runners = {
  M: function(Xn) {
    return cx = Xn[0], cy = Xn[1], px = py = null, sx = cx, sy = cy, moveTo(cx, cy);
  },
  m: function(Xn) {
    return cx += Xn[0], cy += Xn[1], px = py = null, sx = cx, sy = cy, moveTo(cx, cy);
  },
  C: function(Xn) {
    return cx = Xn[4], cy = Xn[5], px = Xn[2], py = Xn[3], appendBezierCurve(Xn[0], Xn[1], Xn[2], Xn[3], Xn[4], Xn[5]);
  },
  c: function(Xn) {
    var zn = appendBezierCurve(Xn[0] + cx, Xn[1] + cy, Xn[2] + cx, Xn[3] + cy, Xn[4] + cx, Xn[5] + cy);
    return px = cx + Xn[2], py = cy + Xn[3], cx += Xn[4], cy += Xn[5], zn;
  },
  S: function(Xn) {
    (px === null || py === null) && (px = cx, py = cy);
    var zn = appendBezierCurve(cx - (px - cx), cy - (py - cy), Xn[0], Xn[1], Xn[2], Xn[3]);
    return px = Xn[0], py = Xn[1], cx = Xn[2], cy = Xn[3], zn;
  },
  s: function(Xn) {
    (px === null || py === null) && (px = cx, py = cy);
    var zn = appendBezierCurve(cx - (px - cx), cy - (py - cy), cx + Xn[0], cy + Xn[1], cx + Xn[2], cy + Xn[3]);
    return px = cx + Xn[0], py = cy + Xn[1], cx += Xn[2], cy += Xn[3], zn;
  },
  Q: function(Xn) {
    return px = Xn[0], py = Xn[1], cx = Xn[2], cy = Xn[3], appendQuadraticCurve(Xn[0], Xn[1], cx, cy);
  },
  q: function(Xn) {
    var zn = appendQuadraticCurve(Xn[0] + cx, Xn[1] + cy, Xn[2] + cx, Xn[3] + cy);
    return px = cx + Xn[0], py = cy + Xn[1], cx += Xn[2], cy += Xn[3], zn;
  },
  T: function(Xn) {
    px === null || py === null ? (px = cx, py = cy) : (px = cx - (px - cx), py = cy - (py - cy));
    var zn = appendQuadraticCurve(px, py, Xn[0], Xn[1]);
    return px = cx - (px - cx), py = cy - (py - cy), cx = Xn[0], cy = Xn[1], zn;
  },
  t: function(Xn) {
    px === null || py === null ? (px = cx, py = cy) : (px = cx - (px - cx), py = cy - (py - cy));
    var zn = appendQuadraticCurve(px, py, cx + Xn[0], cy + Xn[1]);
    return cx += Xn[0], cy += Xn[1], zn;
  },
  A: function(Xn) {
    var zn = solveArc(cx, cy, Xn);
    return cx = Xn[5], cy = Xn[6], zn;
  },
  a: function(Xn) {
    Xn[5] += cx, Xn[6] += cy;
    var zn = solveArc(cx, cy, Xn);
    return cx = Xn[5], cy = Xn[6], zn;
  },
  L: function(Xn) {
    return cx = Xn[0], cy = Xn[1], px = py = null, lineTo(cx, cy);
  },
  l: function(Xn) {
    return cx += Xn[0], cy += Xn[1], px = py = null, lineTo(cx, cy);
  },
  H: function(Xn) {
    return cx = Xn[0], px = py = null, lineTo(cx, cy);
  },
  h: function(Xn) {
    return cx += Xn[0], px = py = null, lineTo(cx, cy);
  },
  V: function(Xn) {
    return cy = Xn[0], px = py = null, lineTo(cx, cy);
  },
  v: function(Xn) {
    return cy += Xn[0], px = py = null, lineTo(cx, cy);
  },
  Z: function() {
    var Xn = closePath();
    return cx = sx, cy = sy, Xn;
  },
  z: function() {
    var Xn = closePath();
    return cx = sx, cy = sy, Xn;
  }
}, solveArc = function(Xn, zn, Un) {
  for (var Kn = Un[0], qn = Un[1], Jo = Un[2], pa = Un[3], ma = Un[4], va = Un[5], ba = Un[6], _a = arcToSegments(va, ba, Kn, qn, pa, ma, Jo, Xn, zn), ya = [], xa = 0, wa = _a; xa < wa.length; xa++) {
    var Ta = wa[xa], Sa = segmentToBezier.apply(void 0, Ta);
    ya.push(appendBezierCurve.apply(void 0, Sa));
  }
  return ya;
}, arcToSegments = function(Xn, zn, Un, Kn, qn, Jo, pa, ma, va) {
  var ba = pa * (Math.PI / 180), _a = Math.sin(ba), ya = Math.cos(ba);
  Un = Math.abs(Un), Kn = Math.abs(Kn), px = ya * (ma - Xn) * 0.5 + _a * (va - zn) * 0.5, py = ya * (va - zn) * 0.5 - _a * (ma - Xn) * 0.5;
  var xa = px * px / (Un * Un) + py * py / (Kn * Kn);
  xa > 1 && (xa = Math.sqrt(xa), Un *= xa, Kn *= xa);
  var wa = ya / Un, Ta = _a / Un, Sa = -_a / Kn, Ma = ya / Kn, ka = wa * ma + Ta * va, Za = Sa * ma + Ma * va, Na = wa * Xn + Ta * zn, Ka = Sa * Xn + Ma * zn, Ja = (Na - ka) * (Na - ka) + (Ka - Za) * (Ka - Za), el = 1 / Ja - 0.25;
  el < 0 && (el = 0);
  var qa = Math.sqrt(el);
  Jo === qn && (qa = -qa);
  var tl = 0.5 * (ka + Na) - qa * (Ka - Za), Qa = 0.5 * (Za + Ka) + qa * (Na - ka), nl = Math.atan2(Za - Qa, ka - tl), rl = Math.atan2(Ka - Qa, Na - tl), il = rl - nl;
  il < 0 && Jo === 1 ? il += 2 * Math.PI : il > 0 && Jo === 0 && (il -= 2 * Math.PI);
  for (var cl = Math.ceil(Math.abs(il / (Math.PI * 0.5 + 1e-3))), ll = [], al = 0; al < cl; al++) {
    var sl = nl + al * il / cl, dl = nl + (al + 1) * il / cl;
    ll[al] = [tl, Qa, sl, dl, Un, Kn, _a, ya];
  }
  return ll;
}, segmentToBezier = function(Xn, zn, Un, Kn, qn, Jo, pa, ma) {
  var va = ma * qn, ba = -pa * Jo, _a = pa * qn, ya = ma * Jo, xa = 0.5 * (Kn - Un), wa = 8 / 3 * Math.sin(xa * 0.5) * Math.sin(xa * 0.5) / Math.sin(xa), Ta = Xn + Math.cos(Un) - wa * Math.sin(Un), Sa = zn + Math.sin(Un) + wa * Math.cos(Un), Ma = Xn + Math.cos(Kn), ka = zn + Math.sin(Kn), Za = Ma + wa * Math.sin(Kn), Na = ka - wa * Math.cos(Kn), Ka = [
    va * Ta + ba * Sa,
    _a * Ta + ya * Sa,
    va * Za + ba * Na,
    _a * Za + ya * Na,
    va * Ma + ba * ka,
    _a * Ma + ya * ka
  ];
  return Ka;
}, svgPathToOperators = function(Xn) {
  return apply(parse(Xn));
}, drawLinesOfText = function(Xn, zn) {
  for (var Un = [
    pushGraphicsState(),
    zn.graphicsState && setGraphicsState(zn.graphicsState),
    beginText(),
    setFillingColor(zn.color),
    setFontAndSize(zn.font, zn.size),
    setLineHeight(zn.lineHeight),
    rotateAndSkewTextRadiansAndTranslate(toRadians(zn.rotate), toRadians(zn.xSkew), toRadians(zn.ySkew), zn.x, zn.y)
  ].filter(Boolean), Kn = 0, qn = Xn.length; Kn < qn; Kn++)
    Un.push(showText(Xn[Kn]), nextLine());
  return Un.push(endText(), popGraphicsState()), Un;
}, drawImage = function(Xn, zn) {
  return [
    pushGraphicsState(),
    zn.graphicsState && setGraphicsState(zn.graphicsState),
    translate(zn.x, zn.y),
    rotateRadians(toRadians(zn.rotate)),
    scale(zn.width, zn.height),
    skewRadians(toRadians(zn.xSkew), toRadians(zn.ySkew)),
    drawObject(Xn),
    popGraphicsState()
  ].filter(Boolean);
}, drawPage = function(Xn, zn) {
  return [
    pushGraphicsState(),
    zn.graphicsState && setGraphicsState(zn.graphicsState),
    translate(zn.x, zn.y),
    rotateRadians(toRadians(zn.rotate)),
    scale(zn.xScale, zn.yScale),
    skewRadians(toRadians(zn.xSkew), toRadians(zn.ySkew)),
    drawObject(Xn),
    popGraphicsState()
  ].filter(Boolean);
}, drawLine = function(Xn) {
  var zn, Un;
  return [
    pushGraphicsState(),
    Xn.graphicsState && setGraphicsState(Xn.graphicsState),
    Xn.color && setStrokingColor(Xn.color),
    setLineWidth(Xn.thickness),
    setDashPattern((zn = Xn.dashArray) !== null && zn !== void 0 ? zn : [], (Un = Xn.dashPhase) !== null && Un !== void 0 ? Un : 0),
    moveTo(Xn.start.x, Xn.start.y),
    Xn.lineCap && setLineCap(Xn.lineCap),
    moveTo(Xn.start.x, Xn.start.y),
    lineTo(Xn.end.x, Xn.end.y),
    stroke(),
    popGraphicsState()
  ].filter(Boolean);
}, drawRectangle = function(Xn) {
  var zn, Un;
  return [
    pushGraphicsState(),
    Xn.graphicsState && setGraphicsState(Xn.graphicsState),
    Xn.color && setFillingColor(Xn.color),
    Xn.borderColor && setStrokingColor(Xn.borderColor),
    setLineWidth(Xn.borderWidth),
    Xn.borderLineCap && setLineCap(Xn.borderLineCap),
    setDashPattern((zn = Xn.borderDashArray) !== null && zn !== void 0 ? zn : [], (Un = Xn.borderDashPhase) !== null && Un !== void 0 ? Un : 0),
    translate(Xn.x, Xn.y),
    rotateRadians(toRadians(Xn.rotate)),
    skewRadians(toRadians(Xn.xSkew), toRadians(Xn.ySkew)),
    moveTo(0, 0),
    lineTo(0, Xn.height),
    lineTo(Xn.width, Xn.height),
    lineTo(Xn.width, 0),
    closePath(),
    // prettier-ignore
    Xn.color && Xn.borderWidth ? fillAndStroke() : Xn.color ? fill() : Xn.borderColor ? stroke() : closePath(),
    popGraphicsState()
  ].filter(Boolean);
}, KAPPA = 4 * ((Math.sqrt(2) - 1) / 3), drawEllipsePath = function(Xn) {
  var zn = asNumber(Xn.x), Un = asNumber(Xn.y), Kn = asNumber(Xn.xScale), qn = asNumber(Xn.yScale);
  zn -= Kn, Un -= qn;
  var Jo = Kn * KAPPA, pa = qn * KAPPA, ma = zn + Kn * 2, va = Un + qn * 2, ba = zn + Kn, _a = Un + qn;
  return [
    pushGraphicsState(),
    moveTo(zn, _a),
    appendBezierCurve(zn, _a - pa, ba - Jo, Un, ba, Un),
    appendBezierCurve(ba + Jo, Un, ma, _a - pa, ma, _a),
    appendBezierCurve(ma, _a + pa, ba + Jo, va, ba, va),
    appendBezierCurve(ba - Jo, va, zn, _a + pa, zn, _a),
    popGraphicsState()
  ];
}, drawEllipseCurves = function(Xn) {
  var zn = asNumber(Xn.x), Un = asNumber(Xn.y), Kn = asNumber(Xn.xScale), qn = asNumber(Xn.yScale), Jo = -Kn, pa = -qn, ma = Kn * KAPPA, va = qn * KAPPA, ba = Jo + Kn * 2, _a = pa + qn * 2, ya = Jo + Kn, xa = pa + qn;
  return [
    translate(zn, Un),
    rotateRadians(toRadians(Xn.rotate)),
    moveTo(Jo, xa),
    appendBezierCurve(Jo, xa - va, ya - ma, pa, ya, pa),
    appendBezierCurve(ya + ma, pa, ba, xa - va, ba, xa),
    appendBezierCurve(ba, xa + va, ya + ma, _a, ya, _a),
    appendBezierCurve(ya - ma, _a, Jo, xa + va, Jo, xa)
  ];
}, drawEllipse = function(Xn) {
  var zn, Un, Kn;
  return __spreadArrays([
    pushGraphicsState(),
    Xn.graphicsState && setGraphicsState(Xn.graphicsState),
    Xn.color && setFillingColor(Xn.color),
    Xn.borderColor && setStrokingColor(Xn.borderColor),
    setLineWidth(Xn.borderWidth),
    Xn.borderLineCap && setLineCap(Xn.borderLineCap),
    setDashPattern((zn = Xn.borderDashArray) !== null && zn !== void 0 ? zn : [], (Un = Xn.borderDashPhase) !== null && Un !== void 0 ? Un : 0)
  ], Xn.rotate === void 0 ? drawEllipsePath({
    x: Xn.x,
    y: Xn.y,
    xScale: Xn.xScale,
    yScale: Xn.yScale
  }) : drawEllipseCurves({
    x: Xn.x,
    y: Xn.y,
    xScale: Xn.xScale,
    yScale: Xn.yScale,
    rotate: (Kn = Xn.rotate) !== null && Kn !== void 0 ? Kn : degrees(0)
  }), [
    // prettier-ignore
    Xn.color && Xn.borderWidth ? fillAndStroke() : Xn.color ? fill() : Xn.borderColor ? stroke() : closePath(),
    popGraphicsState()
  ]).filter(Boolean);
}, drawSvgPath = function(Xn, zn) {
  var Un, Kn, qn;
  return __spreadArrays([
    pushGraphicsState(),
    zn.graphicsState && setGraphicsState(zn.graphicsState),
    translate(zn.x, zn.y),
    rotateRadians(toRadians((Un = zn.rotate) !== null && Un !== void 0 ? Un : degrees(0))),
    // SVG path Y axis is opposite pdf-lib's
    zn.scale ? scale(zn.scale, -zn.scale) : scale(1, -1),
    zn.color && setFillingColor(zn.color),
    zn.borderColor && setStrokingColor(zn.borderColor),
    zn.borderWidth && setLineWidth(zn.borderWidth),
    zn.borderLineCap && setLineCap(zn.borderLineCap),
    setDashPattern((Kn = zn.borderDashArray) !== null && Kn !== void 0 ? Kn : [], (qn = zn.borderDashPhase) !== null && qn !== void 0 ? qn : 0)
  ], svgPathToOperators(Xn), [
    // prettier-ignore
    zn.color && zn.borderWidth ? fillAndStroke() : zn.color ? fill() : zn.borderColor ? stroke() : closePath(),
    popGraphicsState()
  ]).filter(Boolean);
}, drawCheckMark = function(Xn) {
  var zn = asNumber(Xn.size), Un = -1 + 0.75, Kn = -1 + 0.51, qn = 1 - 0.525, Jo = 1 - 0.31, pa = -1 + 0.325, ma = 0.3995 / (qn - Kn) + Kn;
  return [
    pushGraphicsState(),
    Xn.color && setStrokingColor(Xn.color),
    setLineWidth(Xn.thickness),
    translate(Xn.x, Xn.y),
    moveTo(pa * zn, ma * zn),
    lineTo(Un * zn, Kn * zn),
    lineTo(Jo * zn, qn * zn),
    stroke(),
    popGraphicsState()
  ].filter(Boolean);
}, rotateInPlace = function(Xn) {
  return Xn.rotation === 0 ? [
    translate(0, 0),
    rotateDegrees(0)
  ] : Xn.rotation === 90 ? [
    translate(Xn.width, 0),
    rotateDegrees(90)
  ] : Xn.rotation === 180 ? [
    translate(Xn.width, Xn.height),
    rotateDegrees(180)
  ] : Xn.rotation === 270 ? [
    translate(0, Xn.height),
    rotateDegrees(270)
  ] : [];
}, drawCheckBox = function(Xn) {
  var zn = drawRectangle({
    x: Xn.x,
    y: Xn.y,
    width: Xn.width,
    height: Xn.height,
    borderWidth: Xn.borderWidth,
    color: Xn.color,
    borderColor: Xn.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  if (!Xn.filled)
    return zn;
  var Un = asNumber(Xn.width), Kn = asNumber(Xn.height), qn = Math.min(Un, Kn) / 2, Jo = drawCheckMark({
    x: Un / 2,
    y: Kn / 2,
    size: qn,
    thickness: Xn.thickness,
    color: Xn.markColor
  });
  return __spreadArrays([pushGraphicsState()], zn, Jo, [popGraphicsState()]);
}, drawRadioButton = function(Xn) {
  var zn = asNumber(Xn.width), Un = asNumber(Xn.height), Kn = Math.min(zn, Un) / 2, qn = drawEllipse({
    x: Xn.x,
    y: Xn.y,
    xScale: Kn,
    yScale: Kn,
    color: Xn.color,
    borderColor: Xn.borderColor,
    borderWidth: Xn.borderWidth
  });
  if (!Xn.filled)
    return qn;
  var Jo = drawEllipse({
    x: Xn.x,
    y: Xn.y,
    xScale: Kn * 0.45,
    yScale: Kn * 0.45,
    color: Xn.dotColor,
    borderColor: void 0,
    borderWidth: 0
  });
  return __spreadArrays([pushGraphicsState()], qn, Jo, [popGraphicsState()]);
}, drawButton = function(Xn) {
  var zn = asNumber(Xn.x), Un = asNumber(Xn.y), Kn = asNumber(Xn.width), qn = asNumber(Xn.height), Jo = drawRectangle({
    x: zn,
    y: Un,
    width: Kn,
    height: qn,
    borderWidth: Xn.borderWidth,
    color: Xn.color,
    borderColor: Xn.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  }), pa = drawTextLines(Xn.textLines, {
    color: Xn.textColor,
    font: Xn.font,
    size: Xn.fontSize,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  return __spreadArrays([pushGraphicsState()], Jo, pa, [popGraphicsState()]);
}, drawTextLines = function(Xn, zn) {
  for (var Un = [
    beginText(),
    setFillingColor(zn.color),
    setFontAndSize(zn.font, zn.size)
  ], Kn = 0, qn = Xn.length; Kn < qn; Kn++) {
    var Jo = Xn[Kn], pa = Jo.encoded, ma = Jo.x, va = Jo.y;
    Un.push(rotateAndSkewTextRadiansAndTranslate(toRadians(zn.rotate), toRadians(zn.xSkew), toRadians(zn.ySkew), ma, va), showText(pa));
  }
  return Un.push(endText()), Un;
}, drawTextField = function(Xn) {
  var zn = asNumber(Xn.x), Un = asNumber(Xn.y), Kn = asNumber(Xn.width), qn = asNumber(Xn.height), Jo = asNumber(Xn.borderWidth), pa = asNumber(Xn.padding), ma = zn + Jo / 2 + pa, va = Un + Jo / 2 + pa, ba = Kn - (Jo / 2 + pa) * 2, _a = qn - (Jo / 2 + pa) * 2, ya = [
    moveTo(ma, va),
    lineTo(ma, va + _a),
    lineTo(ma + ba, va + _a),
    lineTo(ma + ba, va),
    closePath(),
    clip(),
    endPath()
  ], xa = drawRectangle({
    x: zn,
    y: Un,
    width: Kn,
    height: qn,
    borderWidth: Xn.borderWidth,
    color: Xn.color,
    borderColor: Xn.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  }), wa = drawTextLines(Xn.textLines, {
    color: Xn.textColor,
    font: Xn.font,
    size: Xn.fontSize,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  }), Ta = __spreadArrays([
    beginMarkedContent("Tx"),
    pushGraphicsState()
  ], wa, [
    popGraphicsState(),
    endMarkedContent()
  ]);
  return __spreadArrays([
    pushGraphicsState()
  ], xa, ya, Ta, [
    popGraphicsState()
  ]);
}, drawOptionList = function(Xn) {
  for (var zn = asNumber(Xn.x), Un = asNumber(Xn.y), Kn = asNumber(Xn.width), qn = asNumber(Xn.height), Jo = asNumber(Xn.lineHeight), pa = asNumber(Xn.borderWidth), ma = asNumber(Xn.padding), va = zn + pa / 2 + ma, ba = Un + pa / 2 + ma, _a = Kn - (pa / 2 + ma) * 2, ya = qn - (pa / 2 + ma) * 2, xa = [
    moveTo(va, ba),
    lineTo(va, ba + ya),
    lineTo(va + _a, ba + ya),
    lineTo(va + _a, ba),
    closePath(),
    clip(),
    endPath()
  ], wa = drawRectangle({
    x: zn,
    y: Un,
    width: Kn,
    height: qn,
    borderWidth: Xn.borderWidth,
    color: Xn.color,
    borderColor: Xn.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  }), Ta = [], Sa = 0, Ma = Xn.selectedLines.length; Sa < Ma; Sa++) {
    var ka = Xn.textLines[Xn.selectedLines[Sa]];
    Ta.push.apply(Ta, drawRectangle({
      x: ka.x - ma,
      y: ka.y - (Jo - ka.height) / 2,
      width: Kn - pa,
      height: ka.height + (Jo - ka.height) / 2,
      borderWidth: 0,
      color: Xn.selectedColor,
      borderColor: void 0,
      rotate: degrees(0),
      xSkew: degrees(0),
      ySkew: degrees(0)
    }));
  }
  var Za = drawTextLines(Xn.textLines, {
    color: Xn.textColor,
    font: Xn.font,
    size: Xn.fontSize,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  }), Na = __spreadArrays([
    beginMarkedContent("Tx"),
    pushGraphicsState()
  ], Za, [
    popGraphicsState(),
    endMarkedContent()
  ]);
  return __spreadArrays([
    pushGraphicsState()
  ], wa, Ta, xa, Na, [
    popGraphicsState()
  ]);
}, EncryptedPDFError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), FontkitNotRegisteredError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), ForeignPageError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), RemovePageFromEmptyDocumentError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn() {
      var Un = this, Kn = "PDFDocument has no pages so `PDFDocument.removePage` cannot be called";
      return Un = Xn.call(this, Kn) || this, Un;
    }
    return zn;
  }(Error)
), NoSuchFieldError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = 'PDFDocument has no form field with the name "' + Un + '"';
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), UnexpectedFieldTypeError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo, pa, ma = this, va = Kn == null ? void 0 : Kn.name, ba = (pa = (Jo = qn == null ? void 0 : qn.constructor) === null || Jo === void 0 ? void 0 : Jo.name) !== null && pa !== void 0 ? pa : qn, _a = 'Expected field "' + Un + '" to be of type ' + va + ", " + ("but it is actually of type " + ba);
      return ma = Xn.call(this, _a) || this, ma;
    }
    return zn;
  }(Error)
);
(function(Xn) {
  __extends(zn, Xn);
  function zn(Un) {
    var Kn = this, qn = 'Failed to select check box due to missing onValue: "' + Un + '"';
    return Kn = Xn.call(this, qn) || this, Kn;
  }
  return zn;
})(Error);
var FieldAlreadyExistsError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = 'A field already exists with the specified name: "' + Un + '"';
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), InvalidFieldNamePartError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = 'Field name contains invalid component: "' + Un + '"';
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
);
(function(Xn) {
  __extends(zn, Xn);
  function zn(Un) {
    var Kn = this, qn = 'A non-terminal field already exists with the specified name: "' + Un + '"';
    return Kn = Xn.call(this, qn) || this, Kn;
  }
  return zn;
})(Error);
var RichTextFieldReadError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un) {
      var Kn = this, qn = "Reading rich text fields is not supported: Attempted to read rich text field: " + Un;
      return Kn = Xn.call(this, qn) || this, Kn;
    }
    return zn;
  }(Error)
), CombedTextLayoutError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn) {
      var qn = this, Jo = "Failed to layout combed text as lineLength=" + Un + " is greater than cellCount=" + Kn;
      return qn = Xn.call(this, Jo) || this, qn;
    }
    return zn;
  }(Error)
), ExceededMaxLengthError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = this, pa = "Attempted to set text with length=" + Un + " for TextField with maxLength=" + Kn + " and name=" + qn;
      return Jo = Xn.call(this, pa) || this, Jo;
    }
    return zn;
  }(Error)
), InvalidMaxLengthError = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = this, pa = "Attempted to set maxLength=" + Kn + ", which is less than " + Un + ", the length of this field's current value (name=" + qn + ")";
      return Jo = Xn.call(this, pa) || this, Jo;
    }
    return zn;
  }(Error)
), TextAlignment;
(function(Xn) {
  Xn[Xn.Left = 0] = "Left", Xn[Xn.Center = 1] = "Center", Xn[Xn.Right = 2] = "Right";
})(TextAlignment || (TextAlignment = {}));
var MIN_FONT_SIZE = 4, MAX_FONT_SIZE = 500, computeFontSize = function(Xn, zn, Un, Kn) {
  Kn === void 0 && (Kn = !1);
  for (var qn = MIN_FONT_SIZE; qn < MAX_FONT_SIZE; ) {
    for (var Jo = 0, pa = 0, ma = Xn.length; pa < ma; pa++) {
      Jo += 1;
      for (var va = Xn[pa], ba = va.split(" "), _a = Un.width, ya = 0, xa = ba.length; ya < xa; ya++) {
        var wa = ya === xa - 1, Ta = wa ? ba[ya] : ba[ya] + " ", Sa = zn.widthOfTextAtSize(Ta, qn);
        _a -= Sa, _a <= 0 && (Jo += 1, _a = Un.width - Sa);
      }
    }
    if (!Kn && Jo > Xn.length)
      return qn - 1;
    var Ma = zn.heightAtSize(qn), ka = Ma + Ma * 0.2, Za = ka * Jo;
    if (Za > Math.abs(Un.height))
      return qn - 1;
    qn += 1;
  }
  return qn;
}, computeCombedFontSize = function(Xn, zn, Un, Kn) {
  for (var qn = Un.width / Kn, Jo = Un.height, pa = MIN_FONT_SIZE, ma = charSplit(Xn); pa < MAX_FONT_SIZE; ) {
    for (var va = 0, ba = ma.length; va < ba; va++) {
      var _a = ma[va], ya = zn.widthOfTextAtSize(_a, pa) > qn * 0.75;
      if (ya)
        return pa - 1;
    }
    var xa = zn.heightAtSize(pa, { descender: !1 });
    if (xa > Jo)
      return pa - 1;
    pa += 1;
  }
  return pa;
}, lastIndexOfWhitespace = function(Xn) {
  for (var zn = Xn.length; zn > 0; zn--)
    if (/\s/.test(Xn[zn]))
      return zn;
}, splitOutLines = function(Xn, zn, Un, Kn) {
  for (var qn, Jo = Xn.length; Jo > 0; ) {
    var pa = Xn.substring(0, Jo), ma = Un.encodeText(pa), va = Un.widthOfTextAtSize(pa, Kn);
    if (va < zn) {
      var ba = Xn.substring(Jo) || void 0;
      return { line: pa, encoded: ma, width: va, remainder: ba };
    }
    Jo = (qn = lastIndexOfWhitespace(pa)) !== null && qn !== void 0 ? qn : 0;
  }
  return {
    line: Xn,
    encoded: Un.encodeText(Xn),
    width: Un.widthOfTextAtSize(Xn, Kn),
    remainder: void 0
  };
}, layoutMultilineText = function(Xn, zn) {
  var Un = zn.alignment, Kn = zn.fontSize, qn = zn.font, Jo = zn.bounds, pa = lineSplit(cleanText(Xn));
  (Kn === void 0 || Kn === 0) && (Kn = computeFontSize(pa, qn, Jo, !0));
  for (var ma = qn.heightAtSize(Kn), va = ma + ma * 0.2, ba = [], _a = Jo.x, ya = Jo.y, xa = Jo.x + Jo.width, wa = Jo.y + Jo.height, Ta = Jo.y + Jo.height, Sa = 0, Ma = pa.length; Sa < Ma; Sa++)
    for (var ka = pa[Sa]; ka !== void 0; ) {
      var Za = splitOutLines(ka, Jo.width, qn, Kn), Na = Za.line, Ka = Za.encoded, Ja = Za.width, el = Za.remainder, qa = Un === TextAlignment.Left ? Jo.x : Un === TextAlignment.Center ? Jo.x + Jo.width / 2 - Ja / 2 : Un === TextAlignment.Right ? Jo.x + Jo.width - Ja : Jo.x;
      Ta -= va, qa < _a && (_a = qa), Ta < ya && (ya = Ta), qa + Ja > xa && (xa = qa + Ja), Ta + ma > wa && (wa = Ta + ma), ba.push({ text: Na, encoded: Ka, width: Ja, height: ma, x: qa, y: Ta }), ka = el == null ? void 0 : el.trim();
    }
  return {
    fontSize: Kn,
    lineHeight: va,
    lines: ba,
    bounds: {
      x: _a,
      y: ya,
      width: xa - _a,
      height: wa - ya
    }
  };
}, layoutCombedText = function(Xn, zn) {
  var Un = zn.fontSize, Kn = zn.font, qn = zn.bounds, Jo = zn.cellCount, pa = mergeLines(cleanText(Xn));
  if (pa.length > Jo)
    throw new CombedTextLayoutError(pa.length, Jo);
  (Un === void 0 || Un === 0) && (Un = computeCombedFontSize(pa, Kn, qn, Jo));
  for (var ma = qn.width / Jo, va = Kn.heightAtSize(Un, { descender: !1 }), ba = qn.y + (qn.height / 2 - va / 2), _a = [], ya = qn.x, xa = qn.y, wa = qn.x + qn.width, Ta = qn.y + qn.height, Sa = 0, Ma = 0; Sa < Jo; ) {
    var ka = charAtIndex(pa, Ma), Za = ka[0], Na = ka[1], Ka = Kn.encodeText(Za), Ja = Kn.widthOfTextAtSize(Za, Un), el = qn.x + (ma * Sa + ma / 2), qa = el - Ja / 2;
    qa < ya && (ya = qa), ba < xa && (xa = ba), qa + Ja > wa && (wa = qa + Ja), ba + va > Ta && (Ta = ba + va), _a.push({ text: pa, encoded: Ka, width: Ja, height: va, x: qa, y: ba }), Sa += 1, Ma += Na;
  }
  return {
    fontSize: Un,
    cells: _a,
    bounds: {
      x: ya,
      y: xa,
      width: wa - ya,
      height: Ta - xa
    }
  };
}, layoutSinglelineText = function(Xn, zn) {
  var Un = zn.alignment, Kn = zn.fontSize, qn = zn.font, Jo = zn.bounds, pa = mergeLines(cleanText(Xn));
  (Kn === void 0 || Kn === 0) && (Kn = computeFontSize([pa], qn, Jo));
  var ma = qn.encodeText(pa), va = qn.widthOfTextAtSize(pa, Kn), ba = qn.heightAtSize(Kn, { descender: !1 }), _a = Un === TextAlignment.Left ? Jo.x : Un === TextAlignment.Center ? Jo.x + Jo.width / 2 - va / 2 : Un === TextAlignment.Right ? Jo.x + Jo.width - va : Jo.x, ya = Jo.y + (Jo.height / 2 - ba / 2);
  return {
    fontSize: Kn,
    line: { text: pa, encoded: ma, width: va, height: ba, x: _a, y: ya },
    bounds: { x: _a, y: ya, width: va, height: ba }
  };
}, normalizeAppearance = function(Xn) {
  return "normal" in Xn ? Xn : { normal: Xn };
}, tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/, getDefaultFontSize = function(Xn) {
  var zn, Un, Kn = (zn = Xn.getDefaultAppearance()) !== null && zn !== void 0 ? zn : "", qn = (Un = findLastMatch(Kn, tfRegex).match) !== null && Un !== void 0 ? Un : [], Jo = Number(qn[2]);
  return isFinite(Jo) ? Jo : void 0;
}, colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/, getDefaultColor = function(Xn) {
  var zn, Un = (zn = Xn.getDefaultAppearance()) !== null && zn !== void 0 ? zn : "", Kn = findLastMatch(Un, colorRegex).match, qn = Kn ?? [], Jo = qn[1], pa = qn[2], ma = qn[3], va = qn[4], ba = qn[5];
  if (ba === "g" && Jo)
    return grayscale(Number(Jo));
  if (ba === "rg" && Jo && pa && ma)
    return rgb(Number(Jo), Number(pa), Number(ma));
  if (ba === "k" && Jo && pa && ma && va)
    return cmyk(Number(Jo), Number(pa), Number(ma), Number(va));
}, updateDefaultAppearance = function(Xn, zn, Un, Kn) {
  var qn;
  Kn === void 0 && (Kn = 0);
  var Jo = [
    setFillingColor(zn).toString(),
    setFontAndSize((qn = Un == null ? void 0 : Un.name) !== null && qn !== void 0 ? qn : "dummy__noop", Kn).toString()
  ].join(`
`);
  Xn.setDefaultAppearance(Jo);
}, defaultCheckBoxAppearanceProvider = function(Xn, zn) {
  var Un, Kn, qn, Jo = getDefaultColor(zn), pa = getDefaultColor(Xn.acroField), ma = zn.getRectangle(), va = zn.getAppearanceCharacteristics(), ba = zn.getBorderStyle(), _a = (Un = ba == null ? void 0 : ba.getWidth()) !== null && Un !== void 0 ? Un : 0, ya = reduceRotation(va == null ? void 0 : va.getRotation()), xa = adjustDimsForRotation(ma, ya), wa = xa.width, Ta = xa.height, Sa = rotateInPlace(__assign(__assign({}, ma), { rotation: ya })), Ma = rgb(0, 0, 0), ka = (Kn = componentsToColor(va == null ? void 0 : va.getBorderColor())) !== null && Kn !== void 0 ? Kn : Ma, Za = componentsToColor(va == null ? void 0 : va.getBackgroundColor()), Na = componentsToColor(va == null ? void 0 : va.getBackgroundColor(), 0.8), Ka = (qn = Jo ?? pa) !== null && qn !== void 0 ? qn : Ma;
  updateDefaultAppearance(Jo ? zn : Xn.acroField, Ka);
  var Ja = {
    x: 0 + _a / 2,
    y: 0 + _a / 2,
    width: wa - _a,
    height: Ta - _a,
    thickness: 1.5,
    borderWidth: _a,
    borderColor: ka,
    markColor: Ka
  };
  return {
    normal: {
      on: __spreadArrays(Sa, drawCheckBox(__assign(__assign({}, Ja), { color: Za, filled: !0 }))),
      off: __spreadArrays(Sa, drawCheckBox(__assign(__assign({}, Ja), { color: Za, filled: !1 })))
    },
    down: {
      on: __spreadArrays(Sa, drawCheckBox(__assign(__assign({}, Ja), { color: Na, filled: !0 }))),
      off: __spreadArrays(Sa, drawCheckBox(__assign(__assign({}, Ja), { color: Na, filled: !1 })))
    }
  };
}, defaultRadioGroupAppearanceProvider = function(Xn, zn) {
  var Un, Kn, qn, Jo = getDefaultColor(zn), pa = getDefaultColor(Xn.acroField), ma = zn.getRectangle(), va = zn.getAppearanceCharacteristics(), ba = zn.getBorderStyle(), _a = (Un = ba == null ? void 0 : ba.getWidth()) !== null && Un !== void 0 ? Un : 0, ya = reduceRotation(va == null ? void 0 : va.getRotation()), xa = adjustDimsForRotation(ma, ya), wa = xa.width, Ta = xa.height, Sa = rotateInPlace(__assign(__assign({}, ma), { rotation: ya })), Ma = rgb(0, 0, 0), ka = (Kn = componentsToColor(va == null ? void 0 : va.getBorderColor())) !== null && Kn !== void 0 ? Kn : Ma, Za = componentsToColor(va == null ? void 0 : va.getBackgroundColor()), Na = componentsToColor(va == null ? void 0 : va.getBackgroundColor(), 0.8), Ka = (qn = Jo ?? pa) !== null && qn !== void 0 ? qn : Ma;
  updateDefaultAppearance(Jo ? zn : Xn.acroField, Ka);
  var Ja = {
    x: wa / 2,
    y: Ta / 2,
    width: wa - _a,
    height: Ta - _a,
    borderWidth: _a,
    borderColor: ka,
    dotColor: Ka
  };
  return {
    normal: {
      on: __spreadArrays(Sa, drawRadioButton(__assign(__assign({}, Ja), { color: Za, filled: !0 }))),
      off: __spreadArrays(Sa, drawRadioButton(__assign(__assign({}, Ja), { color: Za, filled: !1 })))
    },
    down: {
      on: __spreadArrays(Sa, drawRadioButton(__assign(__assign({}, Ja), { color: Na, filled: !0 }))),
      off: __spreadArrays(Sa, drawRadioButton(__assign(__assign({}, Ja), { color: Na, filled: !1 })))
    }
  };
}, defaultButtonAppearanceProvider = function(Xn, zn, Un) {
  var Kn, qn, Jo, pa, ma, va = getDefaultColor(zn), ba = getDefaultColor(Xn.acroField), _a = getDefaultFontSize(zn), ya = getDefaultFontSize(Xn.acroField), xa = zn.getRectangle(), wa = zn.getAppearanceCharacteristics(), Ta = zn.getBorderStyle(), Sa = wa == null ? void 0 : wa.getCaptions(), Ma = (Kn = Sa == null ? void 0 : Sa.normal) !== null && Kn !== void 0 ? Kn : "", ka = (Jo = (qn = Sa == null ? void 0 : Sa.down) !== null && qn !== void 0 ? qn : Ma) !== null && Jo !== void 0 ? Jo : "", Za = (pa = Ta == null ? void 0 : Ta.getWidth()) !== null && pa !== void 0 ? pa : 0, Na = reduceRotation(wa == null ? void 0 : wa.getRotation()), Ka = adjustDimsForRotation(xa, Na), Ja = Ka.width, el = Ka.height, qa = rotateInPlace(__assign(__assign({}, xa), { rotation: Na })), tl = rgb(0, 0, 0), Qa = componentsToColor(wa == null ? void 0 : wa.getBorderColor()), nl = componentsToColor(wa == null ? void 0 : wa.getBackgroundColor()), rl = componentsToColor(wa == null ? void 0 : wa.getBackgroundColor(), 0.8), il = {
    x: Za,
    y: Za,
    width: Ja - Za * 2,
    height: el - Za * 2
  }, cl = layoutSinglelineText(Ma, {
    alignment: TextAlignment.Center,
    fontSize: _a ?? ya,
    font: Un,
    bounds: il
  }), ll = layoutSinglelineText(ka, {
    alignment: TextAlignment.Center,
    fontSize: _a ?? ya,
    font: Un,
    bounds: il
  }), al = Math.min(cl.fontSize, ll.fontSize), sl = (ma = va ?? ba) !== null && ma !== void 0 ? ma : tl;
  updateDefaultAppearance(va || _a !== void 0 ? zn : Xn.acroField, sl, Un, al);
  var dl = {
    x: 0 + Za / 2,
    y: 0 + Za / 2,
    width: Ja - Za,
    height: el - Za,
    borderWidth: Za,
    borderColor: Qa,
    textColor: sl,
    font: Un.name,
    fontSize: al
  };
  return {
    normal: __spreadArrays(qa, drawButton(__assign(__assign({}, dl), { color: nl, textLines: [cl.line] }))),
    down: __spreadArrays(qa, drawButton(__assign(__assign({}, dl), { color: rl, textLines: [ll.line] })))
  };
}, defaultTextFieldAppearanceProvider = function(Xn, zn, Un) {
  var Kn, qn, Jo, pa, ma = getDefaultColor(zn), va = getDefaultColor(Xn.acroField), ba = getDefaultFontSize(zn), _a = getDefaultFontSize(Xn.acroField), ya = zn.getRectangle(), xa = zn.getAppearanceCharacteristics(), wa = zn.getBorderStyle(), Ta = (Kn = Xn.getText()) !== null && Kn !== void 0 ? Kn : "", Sa = (qn = wa == null ? void 0 : wa.getWidth()) !== null && qn !== void 0 ? qn : 0, Ma = reduceRotation(xa == null ? void 0 : xa.getRotation()), ka = adjustDimsForRotation(ya, Ma), Za = ka.width, Na = ka.height, Ka = rotateInPlace(__assign(__assign({}, ya), { rotation: Ma })), Ja = rgb(0, 0, 0), el = componentsToColor(xa == null ? void 0 : xa.getBorderColor()), qa = componentsToColor(xa == null ? void 0 : xa.getBackgroundColor()), tl, Qa, nl = Xn.isCombed() ? 0 : 1, rl = {
    x: Sa + nl,
    y: Sa + nl,
    width: Za - (Sa + nl) * 2,
    height: Na - (Sa + nl) * 2
  };
  if (Xn.isMultiline()) {
    var il = layoutMultilineText(Ta, {
      alignment: Xn.getAlignment(),
      fontSize: ba ?? _a,
      font: Un,
      bounds: rl
    });
    tl = il.lines, Qa = il.fontSize;
  } else if (Xn.isCombed()) {
    var il = layoutCombedText(Ta, {
      fontSize: ba ?? _a,
      font: Un,
      bounds: rl,
      cellCount: (Jo = Xn.getMaxLength()) !== null && Jo !== void 0 ? Jo : 0
    });
    tl = il.cells, Qa = il.fontSize;
  } else {
    var il = layoutSinglelineText(Ta, {
      alignment: Xn.getAlignment(),
      fontSize: ba ?? _a,
      font: Un,
      bounds: rl
    });
    tl = [il.line], Qa = il.fontSize;
  }
  var cl = (pa = ma ?? va) !== null && pa !== void 0 ? pa : Ja;
  updateDefaultAppearance(ma || ba !== void 0 ? zn : Xn.acroField, cl, Un, Qa);
  var ll = {
    x: 0 + Sa / 2,
    y: 0 + Sa / 2,
    width: Za - Sa,
    height: Na - Sa,
    borderWidth: Sa ?? 0,
    borderColor: el,
    textColor: cl,
    font: Un.name,
    fontSize: Qa,
    color: qa,
    textLines: tl,
    padding: nl
  };
  return __spreadArrays(Ka, drawTextField(ll));
}, defaultDropdownAppearanceProvider = function(Xn, zn, Un) {
  var Kn, qn, Jo, pa = getDefaultColor(zn), ma = getDefaultColor(Xn.acroField), va = getDefaultFontSize(zn), ba = getDefaultFontSize(Xn.acroField), _a = zn.getRectangle(), ya = zn.getAppearanceCharacteristics(), xa = zn.getBorderStyle(), wa = (Kn = Xn.getSelected()[0]) !== null && Kn !== void 0 ? Kn : "", Ta = (qn = xa == null ? void 0 : xa.getWidth()) !== null && qn !== void 0 ? qn : 0, Sa = reduceRotation(ya == null ? void 0 : ya.getRotation()), Ma = adjustDimsForRotation(_a, Sa), ka = Ma.width, Za = Ma.height, Na = rotateInPlace(__assign(__assign({}, _a), { rotation: Sa })), Ka = rgb(0, 0, 0), Ja = componentsToColor(ya == null ? void 0 : ya.getBorderColor()), el = componentsToColor(ya == null ? void 0 : ya.getBackgroundColor()), qa = 1, tl = {
    x: Ta + qa,
    y: Ta + qa,
    width: ka - (Ta + qa) * 2,
    height: Za - (Ta + qa) * 2
  }, Qa = layoutSinglelineText(wa, {
    alignment: TextAlignment.Left,
    fontSize: va ?? ba,
    font: Un,
    bounds: tl
  }), nl = Qa.line, rl = Qa.fontSize, il = (Jo = pa ?? ma) !== null && Jo !== void 0 ? Jo : Ka;
  updateDefaultAppearance(pa || va !== void 0 ? zn : Xn.acroField, il, Un, rl);
  var cl = {
    x: 0 + Ta / 2,
    y: 0 + Ta / 2,
    width: ka - Ta,
    height: Za - Ta,
    borderWidth: Ta ?? 0,
    borderColor: Ja,
    textColor: il,
    font: Un.name,
    fontSize: rl,
    color: el,
    textLines: [nl],
    padding: qa
  };
  return __spreadArrays(Na, drawTextField(cl));
}, defaultOptionListAppearanceProvider = function(Xn, zn, Un) {
  var Kn, qn, Jo = getDefaultColor(zn), pa = getDefaultColor(Xn.acroField), ma = getDefaultFontSize(zn), va = getDefaultFontSize(Xn.acroField), ba = zn.getRectangle(), _a = zn.getAppearanceCharacteristics(), ya = zn.getBorderStyle(), xa = (Kn = ya == null ? void 0 : ya.getWidth()) !== null && Kn !== void 0 ? Kn : 0, wa = reduceRotation(_a == null ? void 0 : _a.getRotation()), Ta = adjustDimsForRotation(ba, wa), Sa = Ta.width, Ma = Ta.height, ka = rotateInPlace(__assign(__assign({}, ba), { rotation: wa })), Za = rgb(0, 0, 0), Na = componentsToColor(_a == null ? void 0 : _a.getBorderColor()), Ka = componentsToColor(_a == null ? void 0 : _a.getBackgroundColor()), Ja = Xn.getOptions(), el = Xn.getSelected();
  Xn.isSorted() && Ja.sort();
  for (var qa = "", tl = 0, Qa = Ja.length; tl < Qa; tl++)
    qa += Ja[tl], tl < Qa - 1 && (qa += `
`);
  for (var nl = 1, rl = {
    x: xa + nl,
    y: xa + nl,
    width: Sa - (xa + nl) * 2,
    height: Ma - (xa + nl) * 2
  }, il = layoutMultilineText(qa, {
    alignment: TextAlignment.Left,
    fontSize: ma ?? va,
    font: Un,
    bounds: rl
  }), cl = il.lines, ll = il.fontSize, al = il.lineHeight, sl = [], tl = 0, Qa = cl.length; tl < Qa; tl++) {
    var dl = cl[tl];
    el.includes(dl.text) && sl.push(tl);
  }
  var El = rgb(153 / 255, 193 / 255, 218 / 255), fl = (qn = Jo ?? pa) !== null && qn !== void 0 ? qn : Za;
  return updateDefaultAppearance(Jo || ma !== void 0 ? zn : Xn.acroField, fl, Un, ll), __spreadArrays(ka, drawOptionList({
    x: 0 + xa / 2,
    y: 0 + xa / 2,
    width: Sa - xa,
    height: Ma - xa,
    borderWidth: xa ?? 0,
    borderColor: Na,
    textColor: fl,
    font: Un.name,
    fontSize: ll,
    color: Ka,
    textLines: cl,
    lineHeight: al,
    selectedColor: El,
    selectedLines: sl,
    padding: nl
  }));
}, PDFEmbeddedPage = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      this.alreadyEmbedded = !1, assertIs(zn, "ref", [[PDFRef, "PDFRef"]]), assertIs(Un, "doc", [[PDFDocument, "PDFDocument"]]), assertIs(Kn, "embedder", [[PDFPageEmbedder, "PDFPageEmbedder"]]), this.ref = zn, this.doc = Un, this.width = Kn.width, this.height = Kn.height, this.embedder = Kn;
    }
    return Xn.prototype.scale = function(zn) {
      return assertIs(zn, "factor", ["number"]), { width: this.width * zn, height: this.height * zn };
    }, Xn.prototype.size = function() {
      return this.scale(1);
    }, Xn.prototype.embed = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(zn) {
          switch (zn.label) {
            case 0:
              return this.alreadyEmbedded ? [3, 2] : [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
            case 1:
              zn.sent(), this.alreadyEmbedded = !0, zn.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, Xn.of = function(zn, Un, Kn) {
      return new Xn(zn, Un, Kn);
    }, Xn;
  }()
), PDFFont = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      this.modified = !0, assertIs(zn, "ref", [[PDFRef, "PDFRef"]]), assertIs(Un, "doc", [[PDFDocument, "PDFDocument"]]), assertIs(Kn, "embedder", [
        [CustomFontEmbedder, "CustomFontEmbedder"],
        [StandardFontEmbedder, "StandardFontEmbedder"]
      ]), this.ref = zn, this.doc = Un, this.name = Kn.fontName, this.embedder = Kn;
    }
    return Xn.prototype.encodeText = function(zn) {
      return assertIs(zn, "text", ["string"]), this.modified = !0, this.embedder.encodeText(zn);
    }, Xn.prototype.widthOfTextAtSize = function(zn, Un) {
      return assertIs(zn, "text", ["string"]), assertIs(Un, "size", ["number"]), this.embedder.widthOfTextAtSize(zn, Un);
    }, Xn.prototype.heightAtSize = function(zn, Un) {
      var Kn;
      return assertIs(zn, "size", ["number"]), assertOrUndefined(Un == null ? void 0 : Un.descender, "options.descender", ["boolean"]), this.embedder.heightOfFontAtSize(zn, {
        descender: (Kn = Un == null ? void 0 : Un.descender) !== null && Kn !== void 0 ? Kn : !0
      });
    }, Xn.prototype.sizeAtHeight = function(zn) {
      return assertIs(zn, "height", ["number"]), this.embedder.sizeOfFontAtHeight(zn);
    }, Xn.prototype.getCharacterSet = function() {
      return this.embedder instanceof StandardFontEmbedder ? this.embedder.encoding.supportedCodePoints : this.embedder.font.characterSet;
    }, Xn.prototype.embed = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(zn) {
          switch (zn.label) {
            case 0:
              return this.modified ? [4, this.embedder.embedIntoContext(this.doc.context, this.ref)] : [3, 2];
            case 1:
              zn.sent(), this.modified = !1, zn.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, Xn.of = function(zn, Un, Kn) {
      return new Xn(zn, Un, Kn);
    }, Xn;
  }()
), PDFImage = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      assertIs(zn, "ref", [[PDFRef, "PDFRef"]]), assertIs(Un, "doc", [[PDFDocument, "PDFDocument"]]), assertIs(Kn, "embedder", [
        [JpegEmbedder, "JpegEmbedder"],
        [PngEmbedder, "PngEmbedder"]
      ]), this.ref = zn, this.doc = Un, this.width = Kn.width, this.height = Kn.height, this.embedder = Kn;
    }
    return Xn.prototype.scale = function(zn) {
      return assertIs(zn, "factor", ["number"]), { width: this.width * zn, height: this.height * zn };
    }, Xn.prototype.scaleToFit = function(zn, Un) {
      assertIs(zn, "width", ["number"]), assertIs(Un, "height", ["number"]);
      var Kn = zn / this.width, qn = Un / this.height, Jo = Math.min(Kn, qn);
      return this.scale(Jo);
    }, Xn.prototype.size = function() {
      return this.scale(1);
    }, Xn.prototype.embed = function() {
      return __awaiter(this, void 0, void 0, function() {
        var zn, Un, Kn;
        return __generator(this, function(qn) {
          switch (qn.label) {
            case 0:
              return this.embedder ? (this.embedTask || (zn = this, Un = zn.doc, Kn = zn.ref, this.embedTask = this.embedder.embedIntoContext(Un.context, Kn)), [4, this.embedTask]) : [
                2
                /*return*/
              ];
            case 1:
              return qn.sent(), this.embedder = void 0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, Xn.of = function(zn, Un, Kn) {
      return new Xn(zn, Un, Kn);
    }, Xn;
  }()
), ImageAlignment;
(function(Xn) {
  Xn[Xn.Left = 0] = "Left", Xn[Xn.Center = 1] = "Center", Xn[Xn.Right = 2] = "Right";
})(ImageAlignment || (ImageAlignment = {}));
var assertFieldAppearanceOptions = function(Xn) {
  assertOrUndefined(Xn == null ? void 0 : Xn.x, "options.x", ["number"]), assertOrUndefined(Xn == null ? void 0 : Xn.y, "options.y", ["number"]), assertOrUndefined(Xn == null ? void 0 : Xn.width, "options.width", ["number"]), assertOrUndefined(Xn == null ? void 0 : Xn.height, "options.height", ["number"]), assertOrUndefined(Xn == null ? void 0 : Xn.textColor, "options.textColor", [
    [Object, "Color"]
  ]), assertOrUndefined(Xn == null ? void 0 : Xn.backgroundColor, "options.backgroundColor", [
    [Object, "Color"]
  ]), assertOrUndefined(Xn == null ? void 0 : Xn.borderColor, "options.borderColor", [
    [Object, "Color"]
  ]), assertOrUndefined(Xn == null ? void 0 : Xn.borderWidth, "options.borderWidth", ["number"]), assertOrUndefined(Xn == null ? void 0 : Xn.rotate, "options.rotate", [[Object, "Rotation"]]);
}, PDFField = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      assertIs(zn, "acroField", [[PDFAcroTerminal, "PDFAcroTerminal"]]), assertIs(Un, "ref", [[PDFRef, "PDFRef"]]), assertIs(Kn, "doc", [[PDFDocument, "PDFDocument"]]), this.acroField = zn, this.ref = Un, this.doc = Kn;
    }
    return Xn.prototype.getName = function() {
      var zn;
      return (zn = this.acroField.getFullyQualifiedName()) !== null && zn !== void 0 ? zn : "";
    }, Xn.prototype.isReadOnly = function() {
      return this.acroField.hasFlag(AcroFieldFlags.ReadOnly);
    }, Xn.prototype.enableReadOnly = function() {
      this.acroField.setFlagTo(AcroFieldFlags.ReadOnly, !0);
    }, Xn.prototype.disableReadOnly = function() {
      this.acroField.setFlagTo(AcroFieldFlags.ReadOnly, !1);
    }, Xn.prototype.isRequired = function() {
      return this.acroField.hasFlag(AcroFieldFlags.Required);
    }, Xn.prototype.enableRequired = function() {
      this.acroField.setFlagTo(AcroFieldFlags.Required, !0);
    }, Xn.prototype.disableRequired = function() {
      this.acroField.setFlagTo(AcroFieldFlags.Required, !1);
    }, Xn.prototype.isExported = function() {
      return !this.acroField.hasFlag(AcroFieldFlags.NoExport);
    }, Xn.prototype.enableExporting = function() {
      this.acroField.setFlagTo(AcroFieldFlags.NoExport, !1);
    }, Xn.prototype.disableExporting = function() {
      this.acroField.setFlagTo(AcroFieldFlags.NoExport, !0);
    }, Xn.prototype.needsAppearancesUpdate = function() {
      throw new MethodNotImplementedError(this.constructor.name, "needsAppearancesUpdate");
    }, Xn.prototype.defaultUpdateAppearances = function(zn) {
      throw new MethodNotImplementedError(this.constructor.name, "defaultUpdateAppearances");
    }, Xn.prototype.markAsDirty = function() {
      this.doc.getForm().markFieldAsDirty(this.ref);
    }, Xn.prototype.markAsClean = function() {
      this.doc.getForm().markFieldAsClean(this.ref);
    }, Xn.prototype.isDirty = function() {
      return this.doc.getForm().fieldIsDirty(this.ref);
    }, Xn.prototype.createWidget = function(zn) {
      var Un, Kn = zn.textColor, qn = zn.backgroundColor, Jo = zn.borderColor, pa = zn.borderWidth, ma = toDegrees(zn.rotate), va = zn.caption, ba = zn.x, _a = zn.y, ya = zn.width + pa, xa = zn.height + pa, wa = !!zn.hidden, Ta = zn.page;
      assertMultiple(ma, "degreesAngle", 90);
      var Sa = PDFWidgetAnnotation.create(this.doc.context, this.ref), Ma = rotateRectangle({ x: ba, y: _a, width: ya, height: xa }, pa, ma);
      Sa.setRectangle(Ma), Ta && Sa.setP(Ta);
      var ka = Sa.getOrCreateAppearanceCharacteristics();
      qn && ka.setBackgroundColor(colorToComponents(qn)), ka.setRotation(ma), va && ka.setCaptions({ normal: va }), Jo && ka.setBorderColor(colorToComponents(Jo));
      var Za = Sa.getOrCreateBorderStyle();
      if (pa !== void 0 && Za.setWidth(pa), Sa.setFlagTo(AnnotationFlags.Print, !0), Sa.setFlagTo(AnnotationFlags.Hidden, wa), Sa.setFlagTo(AnnotationFlags.Invisible, !1), Kn) {
        var Na = (Un = this.acroField.getDefaultAppearance()) !== null && Un !== void 0 ? Un : "", Ka = Na + `
` + setFillingColor(Kn).toString();
        this.acroField.setDefaultAppearance(Ka);
      }
      return Sa;
    }, Xn.prototype.updateWidgetAppearanceWithFont = function(zn, Un, Kn) {
      var qn = Kn.normal, Jo = Kn.rollover, pa = Kn.down;
      this.updateWidgetAppearances(zn, {
        normal: this.createAppearanceStream(zn, qn, Un),
        rollover: Jo && this.createAppearanceStream(zn, Jo, Un),
        down: pa && this.createAppearanceStream(zn, pa, Un)
      });
    }, Xn.prototype.updateOnOffWidgetAppearance = function(zn, Un, Kn) {
      var qn = Kn.normal, Jo = Kn.rollover, pa = Kn.down;
      this.updateWidgetAppearances(zn, {
        normal: this.createAppearanceDict(zn, qn, Un),
        rollover: Jo && this.createAppearanceDict(zn, Jo, Un),
        down: pa && this.createAppearanceDict(zn, pa, Un)
      });
    }, Xn.prototype.updateWidgetAppearances = function(zn, Un) {
      var Kn = Un.normal, qn = Un.rollover, Jo = Un.down;
      zn.setNormalAppearance(Kn), qn ? zn.setRolloverAppearance(qn) : zn.removeRolloverAppearance(), Jo ? zn.setDownAppearance(Jo) : zn.removeDownAppearance();
    }, Xn.prototype.createAppearanceStream = function(zn, Un, Kn) {
      var qn, Jo = this.acroField.dict.context, pa = zn.getRectangle(), ma = pa.width, va = pa.height, ba = Kn && { Font: (qn = {}, qn[Kn.name] = Kn.ref, qn) }, _a = Jo.formXObject(Un, {
        Resources: ba,
        BBox: Jo.obj([0, 0, ma, va]),
        Matrix: Jo.obj([1, 0, 0, 1, 0, 0])
      }), ya = Jo.register(_a);
      return ya;
    }, Xn.prototype.createImageAppearanceStream = function(zn, Un, Kn) {
      var qn, Jo, pa = this.acroField.dict.context, ma = zn.getRectangle(), va = zn.getAppearanceCharacteristics(), ba = zn.getBorderStyle(), _a = (Jo = ba == null ? void 0 : ba.getWidth()) !== null && Jo !== void 0 ? Jo : 0, ya = reduceRotation(va == null ? void 0 : va.getRotation()), xa = rotateInPlace(__assign(__assign({}, ma), { rotation: ya })), wa = adjustDimsForRotation(ma, ya), Ta = Un.scaleToFit(wa.width - _a * 2, wa.height - _a * 2), Sa = {
        x: _a,
        y: _a,
        width: Ta.width,
        height: Ta.height,
        //
        rotate: degrees(0),
        xSkew: degrees(0),
        ySkew: degrees(0)
      };
      Kn === ImageAlignment.Center ? (Sa.x += (wa.width - _a * 2) / 2 - Ta.width / 2, Sa.y += (wa.height - _a * 2) / 2 - Ta.height / 2) : Kn === ImageAlignment.Right && (Sa.x = wa.width - _a - Ta.width, Sa.y = wa.height - _a - Ta.height);
      var Ma = this.doc.context.addRandomSuffix("Image", 10), ka = __spreadArrays(xa, drawImage(Ma, Sa)), Za = { XObject: (qn = {}, qn[Ma] = Un.ref, qn) }, Na = pa.formXObject(ka, {
        Resources: Za,
        BBox: pa.obj([0, 0, ma.width, ma.height]),
        Matrix: pa.obj([1, 0, 0, 1, 0, 0])
      });
      return pa.register(Na);
    }, Xn.prototype.createAppearanceDict = function(zn, Un, Kn) {
      var qn = this.acroField.dict.context, Jo = this.createAppearanceStream(zn, Un.on), pa = this.createAppearanceStream(zn, Un.off), ma = qn.obj({});
      return ma.set(Kn, Jo), ma.set(PDFName.of("Off"), pa), ma;
    }, Xn;
  }()
), PDFCheckBox = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Un, Kn, qn) || this;
      return assertIs(Un, "acroCheckBox", [
        [PDFAcroCheckBox, "PDFAcroCheckBox"]
      ]), Jo.acroField = Un, Jo;
    }
    return zn.prototype.check = function() {
      var Un, Kn = (Un = this.acroField.getOnValue()) !== null && Un !== void 0 ? Un : PDFName.of("Yes");
      this.markAsDirty(), this.acroField.setValue(Kn);
    }, zn.prototype.uncheck = function() {
      this.markAsDirty(), this.acroField.setValue(PDFName.of("Off"));
    }, zn.prototype.isChecked = function() {
      var Un = this.acroField.getOnValue();
      return !!Un && Un === this.acroField.getValue();
    }, zn.prototype.addToPage = function(Un, Kn) {
      var qn, Jo, pa, ma, va, ba;
      assertIs(Un, "page", [[PDFPage, "PDFPage"]]), assertFieldAppearanceOptions(Kn), Kn || (Kn = {}), "textColor" in Kn || (Kn.textColor = rgb(0, 0, 0)), "backgroundColor" in Kn || (Kn.backgroundColor = rgb(1, 1, 1)), "borderColor" in Kn || (Kn.borderColor = rgb(0, 0, 0)), "borderWidth" in Kn || (Kn.borderWidth = 1);
      var _a = this.createWidget({
        x: (qn = Kn.x) !== null && qn !== void 0 ? qn : 0,
        y: (Jo = Kn.y) !== null && Jo !== void 0 ? Jo : 0,
        width: (pa = Kn.width) !== null && pa !== void 0 ? pa : 50,
        height: (ma = Kn.height) !== null && ma !== void 0 ? ma : 50,
        textColor: Kn.textColor,
        backgroundColor: Kn.backgroundColor,
        borderColor: Kn.borderColor,
        borderWidth: (va = Kn.borderWidth) !== null && va !== void 0 ? va : 0,
        rotate: (ba = Kn.rotate) !== null && ba !== void 0 ? ba : degrees(0),
        hidden: Kn.hidden,
        page: Un.ref
      }), ya = this.doc.context.register(_a.dict);
      this.acroField.addWidget(ya), _a.setAppearanceState(PDFName.of("Off")), this.updateWidgetAppearance(_a, PDFName.of("Yes")), Un.node.addAnnot(ya);
    }, zn.prototype.needsAppearancesUpdate = function() {
      for (var Un, Kn = this.acroField.getWidgets(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = pa.getAppearanceState(), va = (Un = pa.getAppearances()) === null || Un === void 0 ? void 0 : Un.normal;
        if (!(va instanceof PDFDict) || ma && !va.has(ma))
          return !0;
      }
      return !1;
    }, zn.prototype.defaultUpdateAppearances = function() {
      this.updateAppearances();
    }, zn.prototype.updateAppearances = function(Un) {
      var Kn;
      assertOrUndefined(Un, "provider", [Function]);
      for (var qn = this.acroField.getWidgets(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo], va = (Kn = ma.getOnValue()) !== null && Kn !== void 0 ? Kn : PDFName.of("Yes");
        va && this.updateWidgetAppearance(ma, va, Un);
      }
      this.markAsClean();
    }, zn.prototype.updateWidgetAppearance = function(Un, Kn, qn) {
      var Jo = qn ?? defaultCheckBoxAppearanceProvider, pa = normalizeAppearance(Jo(this, Un));
      this.updateOnOffWidgetAppearance(Un, Kn, pa);
    }, zn.of = function(Un, Kn, qn) {
      return new zn(Un, Kn, qn);
    }, zn;
  }(PDFField)
), PDFDropdown = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Un, Kn, qn) || this;
      return assertIs(Un, "acroComboBox", [
        [PDFAcroComboBox, "PDFAcroComboBox"]
      ]), Jo.acroField = Un, Jo;
    }
    return zn.prototype.getOptions = function() {
      for (var Un = this.acroField.getOptions(), Kn = new Array(Un.length), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Un[qn], ma = pa.display, va = pa.value;
        Kn[qn] = (ma ?? va).decodeText();
      }
      return Kn;
    }, zn.prototype.getSelected = function() {
      for (var Un = this.acroField.getValues(), Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++)
        Kn[qn] = Un[qn].decodeText();
      return Kn;
    }, zn.prototype.setOptions = function(Un) {
      assertIs(Un, "options", [Array]);
      for (var Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++)
        Kn[qn] = { value: PDFHexString.fromText(Un[qn]) };
      this.acroField.setOptions(Kn);
    }, zn.prototype.addOptions = function(Un) {
      assertIs(Un, "options", ["string", Array]);
      for (var Kn = Array.isArray(Un) ? Un : [Un], qn = this.acroField.getOptions(), Jo = new Array(Kn.length), pa = 0, ma = Kn.length; pa < ma; pa++)
        Jo[pa] = { value: PDFHexString.fromText(Kn[pa]) };
      this.acroField.setOptions(qn.concat(Jo));
    }, zn.prototype.select = function(Un, Kn) {
      Kn === void 0 && (Kn = !1), assertIs(Un, "options", ["string", Array]), assertIs(Kn, "merge", ["boolean"]);
      var qn = Array.isArray(Un) ? Un : [Un], Jo = this.getOptions(), pa = qn.find(function(ya) {
        return !Jo.includes(ya);
      });
      pa && this.enableEditing(), this.markAsDirty(), (qn.length > 1 || qn.length === 1 && Kn) && this.enableMultiselect();
      for (var ma = new Array(qn.length), va = 0, ba = qn.length; va < ba; va++)
        ma[va] = PDFHexString.fromText(qn[va]);
      if (Kn) {
        var _a = this.acroField.getValues();
        this.acroField.setValues(_a.concat(ma));
      } else
        this.acroField.setValues(ma);
    }, zn.prototype.clear = function() {
      this.markAsDirty(), this.acroField.setValues([]);
    }, zn.prototype.setFontSize = function(Un) {
      assertPositive(Un, "fontSize"), this.acroField.setFontSize(Un), this.markAsDirty();
    }, zn.prototype.isEditable = function() {
      return this.acroField.hasFlag(AcroChoiceFlags.Edit);
    }, zn.prototype.enableEditing = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.Edit, !0);
    }, zn.prototype.disableEditing = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.Edit, !1);
    }, zn.prototype.isSorted = function() {
      return this.acroField.hasFlag(AcroChoiceFlags.Sort);
    }, zn.prototype.enableSorting = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.Sort, !0);
    }, zn.prototype.disableSorting = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.Sort, !1);
    }, zn.prototype.isMultiselect = function() {
      return this.acroField.hasFlag(AcroChoiceFlags.MultiSelect);
    }, zn.prototype.enableMultiselect = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, !0);
    }, zn.prototype.disableMultiselect = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, !1);
    }, zn.prototype.isSpellChecked = function() {
      return !this.acroField.hasFlag(AcroChoiceFlags.DoNotSpellCheck);
    }, zn.prototype.enableSpellChecking = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.DoNotSpellCheck, !1);
    }, zn.prototype.disableSpellChecking = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.DoNotSpellCheck, !0);
    }, zn.prototype.isSelectOnClick = function() {
      return this.acroField.hasFlag(AcroChoiceFlags.CommitOnSelChange);
    }, zn.prototype.enableSelectOnClick = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, !0);
    }, zn.prototype.disableSelectOnClick = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, !1);
    }, zn.prototype.addToPage = function(Un, Kn) {
      var qn, Jo, pa, ma, va, ba, _a;
      assertIs(Un, "page", [[PDFPage, "PDFPage"]]), assertFieldAppearanceOptions(Kn), Kn || (Kn = {}), "textColor" in Kn || (Kn.textColor = rgb(0, 0, 0)), "backgroundColor" in Kn || (Kn.backgroundColor = rgb(1, 1, 1)), "borderColor" in Kn || (Kn.borderColor = rgb(0, 0, 0)), "borderWidth" in Kn || (Kn.borderWidth = 1);
      var ya = this.createWidget({
        x: (qn = Kn.x) !== null && qn !== void 0 ? qn : 0,
        y: (Jo = Kn.y) !== null && Jo !== void 0 ? Jo : 0,
        width: (pa = Kn.width) !== null && pa !== void 0 ? pa : 200,
        height: (ma = Kn.height) !== null && ma !== void 0 ? ma : 50,
        textColor: Kn.textColor,
        backgroundColor: Kn.backgroundColor,
        borderColor: Kn.borderColor,
        borderWidth: (va = Kn.borderWidth) !== null && va !== void 0 ? va : 0,
        rotate: (ba = Kn.rotate) !== null && ba !== void 0 ? ba : degrees(0),
        hidden: Kn.hidden,
        page: Un.ref
      }), xa = this.doc.context.register(ya.dict);
      this.acroField.addWidget(xa);
      var wa = (_a = Kn.font) !== null && _a !== void 0 ? _a : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(ya, wa), Un.node.addAnnot(xa);
    }, zn.prototype.needsAppearancesUpdate = function() {
      var Un;
      if (this.isDirty())
        return !0;
      for (var Kn = this.acroField.getWidgets(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = ((Un = pa.getAppearances()) === null || Un === void 0 ? void 0 : Un.normal) instanceof PDFStream;
        if (!ma)
          return !0;
      }
      return !1;
    }, zn.prototype.defaultUpdateAppearances = function(Un) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), this.updateAppearances(Un);
    }, zn.prototype.updateAppearances = function(Un, Kn) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), assertOrUndefined(Kn, "provider", [Function]);
      for (var qn = this.acroField.getWidgets(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo];
        this.updateWidgetAppearance(ma, Un, Kn);
      }
      this.markAsClean();
    }, zn.prototype.updateWidgetAppearance = function(Un, Kn, qn) {
      var Jo = qn ?? defaultDropdownAppearanceProvider, pa = normalizeAppearance(Jo(this, Un, Kn));
      this.updateWidgetAppearanceWithFont(Un, Kn, pa);
    }, zn.of = function(Un, Kn, qn) {
      return new zn(Un, Kn, qn);
    }, zn;
  }(PDFField)
), PDFOptionList = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Un, Kn, qn) || this;
      return assertIs(Un, "acroListBox", [[PDFAcroListBox, "PDFAcroListBox"]]), Jo.acroField = Un, Jo;
    }
    return zn.prototype.getOptions = function() {
      for (var Un = this.acroField.getOptions(), Kn = new Array(Un.length), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Un[qn], ma = pa.display, va = pa.value;
        Kn[qn] = (ma ?? va).decodeText();
      }
      return Kn;
    }, zn.prototype.getSelected = function() {
      for (var Un = this.acroField.getValues(), Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++)
        Kn[qn] = Un[qn].decodeText();
      return Kn;
    }, zn.prototype.setOptions = function(Un) {
      assertIs(Un, "options", [Array]), this.markAsDirty();
      for (var Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++)
        Kn[qn] = { value: PDFHexString.fromText(Un[qn]) };
      this.acroField.setOptions(Kn);
    }, zn.prototype.addOptions = function(Un) {
      assertIs(Un, "options", ["string", Array]), this.markAsDirty();
      for (var Kn = Array.isArray(Un) ? Un : [Un], qn = this.acroField.getOptions(), Jo = new Array(Kn.length), pa = 0, ma = Kn.length; pa < ma; pa++)
        Jo[pa] = { value: PDFHexString.fromText(Kn[pa]) };
      this.acroField.setOptions(qn.concat(Jo));
    }, zn.prototype.select = function(Un, Kn) {
      Kn === void 0 && (Kn = !1), assertIs(Un, "options", ["string", Array]), assertIs(Kn, "merge", ["boolean"]);
      var qn = Array.isArray(Un) ? Un : [Un], Jo = this.getOptions();
      assertIsSubset(qn, "option", Jo), this.markAsDirty(), (qn.length > 1 || qn.length === 1 && Kn) && this.enableMultiselect();
      for (var pa = new Array(qn.length), ma = 0, va = qn.length; ma < va; ma++)
        pa[ma] = PDFHexString.fromText(qn[ma]);
      if (Kn) {
        var ba = this.acroField.getValues();
        this.acroField.setValues(ba.concat(pa));
      } else
        this.acroField.setValues(pa);
    }, zn.prototype.clear = function() {
      this.markAsDirty(), this.acroField.setValues([]);
    }, zn.prototype.setFontSize = function(Un) {
      assertPositive(Un, "fontSize"), this.acroField.setFontSize(Un), this.markAsDirty();
    }, zn.prototype.isSorted = function() {
      return this.acroField.hasFlag(AcroChoiceFlags.Sort);
    }, zn.prototype.enableSorting = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.Sort, !0);
    }, zn.prototype.disableSorting = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.Sort, !1);
    }, zn.prototype.isMultiselect = function() {
      return this.acroField.hasFlag(AcroChoiceFlags.MultiSelect);
    }, zn.prototype.enableMultiselect = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, !0);
    }, zn.prototype.disableMultiselect = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, !1);
    }, zn.prototype.isSelectOnClick = function() {
      return this.acroField.hasFlag(AcroChoiceFlags.CommitOnSelChange);
    }, zn.prototype.enableSelectOnClick = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, !0);
    }, zn.prototype.disableSelectOnClick = function() {
      this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, !1);
    }, zn.prototype.addToPage = function(Un, Kn) {
      var qn, Jo, pa, ma, va, ba, _a;
      assertIs(Un, "page", [[PDFPage, "PDFPage"]]), assertFieldAppearanceOptions(Kn), Kn || (Kn = {}), "textColor" in Kn || (Kn.textColor = rgb(0, 0, 0)), "backgroundColor" in Kn || (Kn.backgroundColor = rgb(1, 1, 1)), "borderColor" in Kn || (Kn.borderColor = rgb(0, 0, 0)), "borderWidth" in Kn || (Kn.borderWidth = 1);
      var ya = this.createWidget({
        x: (qn = Kn.x) !== null && qn !== void 0 ? qn : 0,
        y: (Jo = Kn.y) !== null && Jo !== void 0 ? Jo : 0,
        width: (pa = Kn.width) !== null && pa !== void 0 ? pa : 200,
        height: (ma = Kn.height) !== null && ma !== void 0 ? ma : 100,
        textColor: Kn.textColor,
        backgroundColor: Kn.backgroundColor,
        borderColor: Kn.borderColor,
        borderWidth: (va = Kn.borderWidth) !== null && va !== void 0 ? va : 0,
        rotate: (ba = Kn.rotate) !== null && ba !== void 0 ? ba : degrees(0),
        hidden: Kn.hidden,
        page: Un.ref
      }), xa = this.doc.context.register(ya.dict);
      this.acroField.addWidget(xa);
      var wa = (_a = Kn.font) !== null && _a !== void 0 ? _a : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(ya, wa), Un.node.addAnnot(xa);
    }, zn.prototype.needsAppearancesUpdate = function() {
      var Un;
      if (this.isDirty())
        return !0;
      for (var Kn = this.acroField.getWidgets(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = ((Un = pa.getAppearances()) === null || Un === void 0 ? void 0 : Un.normal) instanceof PDFStream;
        if (!ma)
          return !0;
      }
      return !1;
    }, zn.prototype.defaultUpdateAppearances = function(Un) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), this.updateAppearances(Un);
    }, zn.prototype.updateAppearances = function(Un, Kn) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), assertOrUndefined(Kn, "provider", [Function]);
      for (var qn = this.acroField.getWidgets(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo];
        this.updateWidgetAppearance(ma, Un, Kn);
      }
      this.markAsClean();
    }, zn.prototype.updateWidgetAppearance = function(Un, Kn, qn) {
      var Jo = qn ?? defaultOptionListAppearanceProvider, pa = normalizeAppearance(Jo(this, Un, Kn));
      this.updateWidgetAppearanceWithFont(Un, Kn, pa);
    }, zn.of = function(Un, Kn, qn) {
      return new zn(Un, Kn, qn);
    }, zn;
  }(PDFField)
), PDFRadioGroup = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Un, Kn, qn) || this;
      return assertIs(Un, "acroRadioButton", [
        [PDFAcroRadioButton, "PDFAcroRadioButton"]
      ]), Jo.acroField = Un, Jo;
    }
    return zn.prototype.getOptions = function() {
      var Un = this.acroField.getExportValues();
      if (Un) {
        for (var Kn = new Array(Un.length), qn = 0, Jo = Un.length; qn < Jo; qn++)
          Kn[qn] = Un[qn].decodeText();
        return Kn;
      }
      for (var pa = this.acroField.getOnValues(), ma = new Array(pa.length), qn = 0, Jo = ma.length; qn < Jo; qn++)
        ma[qn] = pa[qn].decodeText();
      return ma;
    }, zn.prototype.getSelected = function() {
      var Un = this.acroField.getValue();
      if (Un !== PDFName.of("Off")) {
        var Kn = this.acroField.getExportValues();
        if (Kn) {
          for (var qn = this.acroField.getOnValues(), Jo = 0, pa = qn.length; Jo < pa; Jo++)
            if (qn[Jo] === Un)
              return Kn[Jo].decodeText();
        }
        return Un.decodeText();
      }
    }, zn.prototype.select = function(Un) {
      assertIs(Un, "option", ["string"]);
      var Kn = this.getOptions();
      assertIsOneOf(Un, "option", Kn), this.markAsDirty();
      var qn = this.acroField.getOnValues(), Jo = this.acroField.getExportValues();
      if (Jo)
        for (var pa = 0, ma = Jo.length; pa < ma; pa++)
          Jo[pa].decodeText() === Un && this.acroField.setValue(qn[pa]);
      else
        for (var pa = 0, ma = qn.length; pa < ma; pa++) {
          var va = qn[pa];
          va.decodeText() === Un && this.acroField.setValue(va);
        }
    }, zn.prototype.clear = function() {
      this.markAsDirty(), this.acroField.setValue(PDFName.of("Off"));
    }, zn.prototype.isOffToggleable = function() {
      return !this.acroField.hasFlag(AcroButtonFlags.NoToggleToOff);
    }, zn.prototype.enableOffToggling = function() {
      this.acroField.setFlagTo(AcroButtonFlags.NoToggleToOff, !1);
    }, zn.prototype.disableOffToggling = function() {
      this.acroField.setFlagTo(AcroButtonFlags.NoToggleToOff, !0);
    }, zn.prototype.isMutuallyExclusive = function() {
      return !this.acroField.hasFlag(AcroButtonFlags.RadiosInUnison);
    }, zn.prototype.enableMutualExclusion = function() {
      this.acroField.setFlagTo(AcroButtonFlags.RadiosInUnison, !1);
    }, zn.prototype.disableMutualExclusion = function() {
      this.acroField.setFlagTo(AcroButtonFlags.RadiosInUnison, !0);
    }, zn.prototype.addOptionToPage = function(Un, Kn, qn) {
      var Jo, pa, ma, va, ba, _a, ya, xa, wa;
      assertIs(Un, "option", ["string"]), assertIs(Kn, "page", [[PDFPage, "PDFPage"]]), assertFieldAppearanceOptions(qn);
      var Ta = this.createWidget({
        x: (Jo = qn == null ? void 0 : qn.x) !== null && Jo !== void 0 ? Jo : 0,
        y: (pa = qn == null ? void 0 : qn.y) !== null && pa !== void 0 ? pa : 0,
        width: (ma = qn == null ? void 0 : qn.width) !== null && ma !== void 0 ? ma : 50,
        height: (va = qn == null ? void 0 : qn.height) !== null && va !== void 0 ? va : 50,
        textColor: (ba = qn == null ? void 0 : qn.textColor) !== null && ba !== void 0 ? ba : rgb(0, 0, 0),
        backgroundColor: (_a = qn == null ? void 0 : qn.backgroundColor) !== null && _a !== void 0 ? _a : rgb(1, 1, 1),
        borderColor: (ya = qn == null ? void 0 : qn.borderColor) !== null && ya !== void 0 ? ya : rgb(0, 0, 0),
        borderWidth: (xa = qn == null ? void 0 : qn.borderWidth) !== null && xa !== void 0 ? xa : 1,
        rotate: (wa = qn == null ? void 0 : qn.rotate) !== null && wa !== void 0 ? wa : degrees(0),
        hidden: qn == null ? void 0 : qn.hidden,
        page: Kn.ref
      }), Sa = this.doc.context.register(Ta.dict), Ma = this.acroField.addWidgetWithOpt(Sa, PDFHexString.fromText(Un), !this.isMutuallyExclusive());
      Ta.setAppearanceState(PDFName.of("Off")), this.updateWidgetAppearance(Ta, Ma), Kn.node.addAnnot(Sa);
    }, zn.prototype.needsAppearancesUpdate = function() {
      for (var Un, Kn = this.acroField.getWidgets(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = pa.getAppearanceState(), va = (Un = pa.getAppearances()) === null || Un === void 0 ? void 0 : Un.normal;
        if (!(va instanceof PDFDict) || ma && !va.has(ma))
          return !0;
      }
      return !1;
    }, zn.prototype.defaultUpdateAppearances = function() {
      this.updateAppearances();
    }, zn.prototype.updateAppearances = function(Un) {
      assertOrUndefined(Un, "provider", [Function]);
      for (var Kn = this.acroField.getWidgets(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = pa.getOnValue();
        ma && this.updateWidgetAppearance(pa, ma, Un);
      }
    }, zn.prototype.updateWidgetAppearance = function(Un, Kn, qn) {
      var Jo = qn ?? defaultRadioGroupAppearanceProvider, pa = normalizeAppearance(Jo(this, Un));
      this.updateOnOffWidgetAppearance(Un, Kn, pa);
    }, zn.of = function(Un, Kn, qn) {
      return new zn(Un, Kn, qn);
    }, zn;
  }(PDFField)
), PDFSignature = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Un, Kn, qn) || this;
      return assertIs(Un, "acroSignature", [
        [PDFAcroSignature, "PDFAcroSignature"]
      ]), Jo.acroField = Un, Jo;
    }
    return zn.prototype.needsAppearancesUpdate = function() {
      return !1;
    }, zn.of = function(Un, Kn, qn) {
      return new zn(Un, Kn, qn);
    }, zn;
  }(PDFField)
), PDFTextField = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Un, Kn, qn) || this;
      return assertIs(Un, "acroText", [[PDFAcroText, "PDFAcroText"]]), Jo.acroField = Un, Jo;
    }
    return zn.prototype.getText = function() {
      var Un = this.acroField.getValue();
      if (!Un && this.isRichFormatted())
        throw new RichTextFieldReadError(this.getName());
      return Un == null ? void 0 : Un.decodeText();
    }, zn.prototype.setText = function(Un) {
      assertOrUndefined(Un, "text", ["string"]);
      var Kn = this.getMaxLength();
      if (Kn !== void 0 && Un && Un.length > Kn)
        throw new ExceededMaxLengthError(Un.length, Kn, this.getName());
      this.markAsDirty(), this.disableRichFormatting(), Un ? this.acroField.setValue(PDFHexString.fromText(Un)) : this.acroField.removeValue();
    }, zn.prototype.getAlignment = function() {
      var Un = this.acroField.getQuadding();
      return Un === 0 ? TextAlignment.Left : Un === 1 ? TextAlignment.Center : Un === 2 ? TextAlignment.Right : TextAlignment.Left;
    }, zn.prototype.setAlignment = function(Un) {
      assertIsOneOf(Un, "alignment", TextAlignment), this.markAsDirty(), this.acroField.setQuadding(Un);
    }, zn.prototype.getMaxLength = function() {
      return this.acroField.getMaxLength();
    }, zn.prototype.setMaxLength = function(Un) {
      if (assertRangeOrUndefined(Un, "maxLength", 0, Number.MAX_SAFE_INTEGER), this.markAsDirty(), Un === void 0)
        this.acroField.removeMaxLength();
      else {
        var Kn = this.getText();
        if (Kn && Kn.length > Un)
          throw new InvalidMaxLengthError(Kn.length, Un, this.getName());
        this.acroField.setMaxLength(Un);
      }
    }, zn.prototype.removeMaxLength = function() {
      this.markAsDirty(), this.acroField.removeMaxLength();
    }, zn.prototype.setImage = function(Un) {
      for (var Kn = this.getAlignment(), qn = Kn === TextAlignment.Center ? ImageAlignment.Center : Kn === TextAlignment.Right ? ImageAlignment.Right : ImageAlignment.Left, Jo = this.acroField.getWidgets(), pa = 0, ma = Jo.length; pa < ma; pa++) {
        var va = Jo[pa], ba = this.createImageAppearanceStream(va, Un, qn);
        this.updateWidgetAppearances(va, { normal: ba });
      }
      this.markAsClean();
    }, zn.prototype.setFontSize = function(Un) {
      assertPositive(Un, "fontSize"), this.acroField.setFontSize(Un), this.markAsDirty();
    }, zn.prototype.isMultiline = function() {
      return this.acroField.hasFlag(AcroTextFlags.Multiline);
    }, zn.prototype.enableMultiline = function() {
      this.markAsDirty(), this.acroField.setFlagTo(AcroTextFlags.Multiline, !0);
    }, zn.prototype.disableMultiline = function() {
      this.markAsDirty(), this.acroField.setFlagTo(AcroTextFlags.Multiline, !1);
    }, zn.prototype.isPassword = function() {
      return this.acroField.hasFlag(AcroTextFlags.Password);
    }, zn.prototype.enablePassword = function() {
      this.acroField.setFlagTo(AcroTextFlags.Password, !0);
    }, zn.prototype.disablePassword = function() {
      this.acroField.setFlagTo(AcroTextFlags.Password, !1);
    }, zn.prototype.isFileSelector = function() {
      return this.acroField.hasFlag(AcroTextFlags.FileSelect);
    }, zn.prototype.enableFileSelection = function() {
      this.acroField.setFlagTo(AcroTextFlags.FileSelect, !0);
    }, zn.prototype.disableFileSelection = function() {
      this.acroField.setFlagTo(AcroTextFlags.FileSelect, !1);
    }, zn.prototype.isSpellChecked = function() {
      return !this.acroField.hasFlag(AcroTextFlags.DoNotSpellCheck);
    }, zn.prototype.enableSpellChecking = function() {
      this.acroField.setFlagTo(AcroTextFlags.DoNotSpellCheck, !1);
    }, zn.prototype.disableSpellChecking = function() {
      this.acroField.setFlagTo(AcroTextFlags.DoNotSpellCheck, !0);
    }, zn.prototype.isScrollable = function() {
      return !this.acroField.hasFlag(AcroTextFlags.DoNotScroll);
    }, zn.prototype.enableScrolling = function() {
      this.acroField.setFlagTo(AcroTextFlags.DoNotScroll, !1);
    }, zn.prototype.disableScrolling = function() {
      this.acroField.setFlagTo(AcroTextFlags.DoNotScroll, !0);
    }, zn.prototype.isCombed = function() {
      return this.acroField.hasFlag(AcroTextFlags.Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== void 0;
    }, zn.prototype.enableCombing = function() {
      if (this.getMaxLength() === void 0) {
        var Un = "PDFTextFields must have a max length in order to be combed";
        console.warn(Un);
      }
      this.markAsDirty(), this.disableMultiline(), this.disablePassword(), this.disableFileSelection(), this.acroField.setFlagTo(AcroTextFlags.Comb, !0);
    }, zn.prototype.disableCombing = function() {
      this.markAsDirty(), this.acroField.setFlagTo(AcroTextFlags.Comb, !1);
    }, zn.prototype.isRichFormatted = function() {
      return this.acroField.hasFlag(AcroTextFlags.RichText);
    }, zn.prototype.enableRichFormatting = function() {
      this.acroField.setFlagTo(AcroTextFlags.RichText, !0);
    }, zn.prototype.disableRichFormatting = function() {
      this.acroField.setFlagTo(AcroTextFlags.RichText, !1);
    }, zn.prototype.addToPage = function(Un, Kn) {
      var qn, Jo, pa, ma, va, ba, _a;
      assertIs(Un, "page", [[PDFPage, "PDFPage"]]), assertFieldAppearanceOptions(Kn), Kn || (Kn = {}), "textColor" in Kn || (Kn.textColor = rgb(0, 0, 0)), "backgroundColor" in Kn || (Kn.backgroundColor = rgb(1, 1, 1)), "borderColor" in Kn || (Kn.borderColor = rgb(0, 0, 0)), "borderWidth" in Kn || (Kn.borderWidth = 1);
      var ya = this.createWidget({
        x: (qn = Kn.x) !== null && qn !== void 0 ? qn : 0,
        y: (Jo = Kn.y) !== null && Jo !== void 0 ? Jo : 0,
        width: (pa = Kn.width) !== null && pa !== void 0 ? pa : 200,
        height: (ma = Kn.height) !== null && ma !== void 0 ? ma : 50,
        textColor: Kn.textColor,
        backgroundColor: Kn.backgroundColor,
        borderColor: Kn.borderColor,
        borderWidth: (va = Kn.borderWidth) !== null && va !== void 0 ? va : 0,
        rotate: (ba = Kn.rotate) !== null && ba !== void 0 ? ba : degrees(0),
        hidden: Kn.hidden,
        page: Un.ref
      }), xa = this.doc.context.register(ya.dict);
      this.acroField.addWidget(xa);
      var wa = (_a = Kn.font) !== null && _a !== void 0 ? _a : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(ya, wa), Un.node.addAnnot(xa);
    }, zn.prototype.needsAppearancesUpdate = function() {
      var Un;
      if (this.isDirty())
        return !0;
      for (var Kn = this.acroField.getWidgets(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = ((Un = pa.getAppearances()) === null || Un === void 0 ? void 0 : Un.normal) instanceof PDFStream;
        if (!ma)
          return !0;
      }
      return !1;
    }, zn.prototype.defaultUpdateAppearances = function(Un) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), this.updateAppearances(Un);
    }, zn.prototype.updateAppearances = function(Un, Kn) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), assertOrUndefined(Kn, "provider", [Function]);
      for (var qn = this.acroField.getWidgets(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo];
        this.updateWidgetAppearance(ma, Un, Kn);
      }
      this.markAsClean();
    }, zn.prototype.updateWidgetAppearance = function(Un, Kn, qn) {
      var Jo = qn ?? defaultTextFieldAppearanceProvider, pa = normalizeAppearance(Jo(this, Un, Kn));
      this.updateWidgetAppearanceWithFont(Un, Kn, pa);
    }, zn.of = function(Un, Kn, qn) {
      return new zn(Un, Kn, qn);
    }, zn;
  }(PDFField)
), StandardFonts;
(function(Xn) {
  Xn.Courier = "Courier", Xn.CourierBold = "Courier-Bold", Xn.CourierOblique = "Courier-Oblique", Xn.CourierBoldOblique = "Courier-BoldOblique", Xn.Helvetica = "Helvetica", Xn.HelveticaBold = "Helvetica-Bold", Xn.HelveticaOblique = "Helvetica-Oblique", Xn.HelveticaBoldOblique = "Helvetica-BoldOblique", Xn.TimesRoman = "Times-Roman", Xn.TimesRomanBold = "Times-Bold", Xn.TimesRomanItalic = "Times-Italic", Xn.TimesRomanBoldItalic = "Times-BoldItalic", Xn.Symbol = "Symbol", Xn.ZapfDingbats = "ZapfDingbats";
})(StandardFonts || (StandardFonts = {}));
var PDFForm = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      var Kn = this;
      this.embedDefaultFont = function() {
        return Kn.doc.embedStandardFont(StandardFonts.Helvetica);
      }, assertIs(zn, "acroForm", [[PDFAcroForm, "PDFAcroForm"]]), assertIs(Un, "doc", [[PDFDocument, "PDFDocument"]]), this.acroForm = zn, this.doc = Un, this.dirtyFields = /* @__PURE__ */ new Set(), this.defaultFontCache = Cache.populatedBy(this.embedDefaultFont);
    }
    return Xn.prototype.hasXFA = function() {
      return this.acroForm.dict.has(PDFName.of("XFA"));
    }, Xn.prototype.deleteXFA = function() {
      this.acroForm.dict.delete(PDFName.of("XFA"));
    }, Xn.prototype.getFields = function() {
      for (var zn = this.acroForm.getAllFields(), Un = [], Kn = 0, qn = zn.length; Kn < qn; Kn++) {
        var Jo = zn[Kn], pa = Jo[0], ma = Jo[1], va = convertToPDFField(pa, ma, this.doc);
        va && Un.push(va);
      }
      return Un;
    }, Xn.prototype.getFieldMaybe = function(zn) {
      assertIs(zn, "name", ["string"]);
      for (var Un = this.getFields(), Kn = 0, qn = Un.length; Kn < qn; Kn++) {
        var Jo = Un[Kn];
        if (Jo.getName() === zn)
          return Jo;
      }
    }, Xn.prototype.getField = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getFieldMaybe(zn);
      if (Un)
        return Un;
      throw new NoSuchFieldError(zn);
    }, Xn.prototype.getButton = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getField(zn);
      if (Un instanceof PDFButton)
        return Un;
      throw new UnexpectedFieldTypeError(zn, PDFButton, Un);
    }, Xn.prototype.getCheckBox = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getField(zn);
      if (Un instanceof PDFCheckBox)
        return Un;
      throw new UnexpectedFieldTypeError(zn, PDFCheckBox, Un);
    }, Xn.prototype.getDropdown = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getField(zn);
      if (Un instanceof PDFDropdown)
        return Un;
      throw new UnexpectedFieldTypeError(zn, PDFDropdown, Un);
    }, Xn.prototype.getOptionList = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getField(zn);
      if (Un instanceof PDFOptionList)
        return Un;
      throw new UnexpectedFieldTypeError(zn, PDFOptionList, Un);
    }, Xn.prototype.getRadioGroup = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getField(zn);
      if (Un instanceof PDFRadioGroup)
        return Un;
      throw new UnexpectedFieldTypeError(zn, PDFRadioGroup, Un);
    }, Xn.prototype.getSignature = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getField(zn);
      if (Un instanceof PDFSignature)
        return Un;
      throw new UnexpectedFieldTypeError(zn, PDFSignature, Un);
    }, Xn.prototype.getTextField = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = this.getField(zn);
      if (Un instanceof PDFTextField)
        return Un;
      throw new UnexpectedFieldTypeError(zn, PDFTextField, Un);
    }, Xn.prototype.createButton = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = splitFieldName(zn), Kn = this.findOrCreateNonTerminals(Un.nonTerminal), qn = PDFAcroPushButton.create(this.doc.context);
      return qn.setPartialName(Un.terminal), addFieldToParent(Kn, [qn, qn.ref], Un.terminal), PDFButton.of(qn, qn.ref, this.doc);
    }, Xn.prototype.createCheckBox = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = splitFieldName(zn), Kn = this.findOrCreateNonTerminals(Un.nonTerminal), qn = PDFAcroCheckBox.create(this.doc.context);
      return qn.setPartialName(Un.terminal), addFieldToParent(Kn, [qn, qn.ref], Un.terminal), PDFCheckBox.of(qn, qn.ref, this.doc);
    }, Xn.prototype.createDropdown = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = splitFieldName(zn), Kn = this.findOrCreateNonTerminals(Un.nonTerminal), qn = PDFAcroComboBox.create(this.doc.context);
      return qn.setPartialName(Un.terminal), addFieldToParent(Kn, [qn, qn.ref], Un.terminal), PDFDropdown.of(qn, qn.ref, this.doc);
    }, Xn.prototype.createOptionList = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = splitFieldName(zn), Kn = this.findOrCreateNonTerminals(Un.nonTerminal), qn = PDFAcroListBox.create(this.doc.context);
      return qn.setPartialName(Un.terminal), addFieldToParent(Kn, [qn, qn.ref], Un.terminal), PDFOptionList.of(qn, qn.ref, this.doc);
    }, Xn.prototype.createRadioGroup = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = splitFieldName(zn), Kn = this.findOrCreateNonTerminals(Un.nonTerminal), qn = PDFAcroRadioButton.create(this.doc.context);
      return qn.setPartialName(Un.terminal), addFieldToParent(Kn, [qn, qn.ref], Un.terminal), PDFRadioGroup.of(qn, qn.ref, this.doc);
    }, Xn.prototype.createTextField = function(zn) {
      assertIs(zn, "name", ["string"]);
      var Un = splitFieldName(zn), Kn = this.findOrCreateNonTerminals(Un.nonTerminal), qn = PDFAcroText.create(this.doc.context);
      return qn.setPartialName(Un.terminal), addFieldToParent(Kn, [qn, qn.ref], Un.terminal), PDFTextField.of(qn, qn.ref, this.doc);
    }, Xn.prototype.flatten = function(zn) {
      zn === void 0 && (zn = { updateFieldAppearances: !0 }), zn.updateFieldAppearances && this.updateFieldAppearances();
      for (var Un = this.getFields(), Kn = 0, qn = Un.length; Kn < qn; Kn++) {
        for (var Jo = Un[Kn], pa = Jo.acroField.getWidgets(), ma = 0, va = pa.length; ma < va; ma++) {
          var ba = pa[ma], _a = this.findWidgetPage(ba), ya = this.findWidgetAppearanceRef(Jo, ba), xa = _a.node.newXObject("FlatWidget", ya), wa = ba.getRectangle(), Ta = __spreadArrays([
            pushGraphicsState(),
            translate(wa.x, wa.y)
          ], rotateInPlace(__assign(__assign({}, wa), { rotation: 0 })), [
            drawObject(xa),
            popGraphicsState()
          ]).filter(Boolean);
          _a.pushOperators.apply(_a, Ta);
        }
        this.removeField(Jo);
      }
    }, Xn.prototype.removeField = function(zn) {
      for (var Un = zn.acroField.getWidgets(), Kn = /* @__PURE__ */ new Set(), qn = 0, Jo = Un.length; qn < Jo; qn++) {
        var pa = Un[qn], ma = this.findWidgetAppearanceRef(zn, pa), va = this.findWidgetPage(pa);
        Kn.add(va), va.node.removeAnnot(ma);
      }
      Kn.forEach(function(wa) {
        return wa.node.removeAnnot(zn.ref);
      }), this.acroForm.removeField(zn.acroField);
      for (var ba = zn.acroField.normalizedEntries().Kids, _a = ba.size(), ya = 0; ya < _a; ya++) {
        var xa = ba.get(ya);
        xa instanceof PDFRef && this.doc.context.delete(xa);
      }
      this.doc.context.delete(zn.ref);
    }, Xn.prototype.updateFieldAppearances = function(zn) {
      assertOrUndefined(zn, "font", [[PDFFont, "PDFFont"]]), zn = zn ?? this.getDefaultFont();
      for (var Un = this.getFields(), Kn = 0, qn = Un.length; Kn < qn; Kn++) {
        var Jo = Un[Kn];
        Jo.needsAppearancesUpdate() && Jo.defaultUpdateAppearances(zn);
      }
    }, Xn.prototype.markFieldAsDirty = function(zn) {
      assertOrUndefined(zn, "fieldRef", [[PDFRef, "PDFRef"]]), this.dirtyFields.add(zn);
    }, Xn.prototype.markFieldAsClean = function(zn) {
      assertOrUndefined(zn, "fieldRef", [[PDFRef, "PDFRef"]]), this.dirtyFields.delete(zn);
    }, Xn.prototype.fieldIsDirty = function(zn) {
      return assertOrUndefined(zn, "fieldRef", [[PDFRef, "PDFRef"]]), this.dirtyFields.has(zn);
    }, Xn.prototype.getDefaultFont = function() {
      return this.defaultFontCache.access();
    }, Xn.prototype.findWidgetPage = function(zn) {
      var Un = zn.P(), Kn = this.doc.getPages().find(function(Jo) {
        return Jo.ref === Un;
      });
      if (Kn === void 0) {
        var qn = this.doc.context.getObjectRef(zn.dict);
        if (qn === void 0)
          throw new Error("Could not find PDFRef for PDFObject");
        if (Kn = this.doc.findPageForAnnotationRef(qn), Kn === void 0)
          throw new Error("Could not find page for PDFRef " + qn);
      }
      return Kn;
    }, Xn.prototype.findWidgetAppearanceRef = function(zn, Un) {
      var Kn, qn = Un.getNormalAppearance();
      if (qn instanceof PDFDict && (zn instanceof PDFCheckBox || zn instanceof PDFRadioGroup)) {
        var Jo = zn.acroField.getValue(), pa = (Kn = qn.get(Jo)) !== null && Kn !== void 0 ? Kn : qn.get(PDFName.of("Off"));
        pa instanceof PDFRef && (qn = pa);
      }
      if (!(qn instanceof PDFRef)) {
        var ma = zn.getName();
        throw new Error("Failed to extract appearance ref for: " + ma);
      }
      return qn;
    }, Xn.prototype.findOrCreateNonTerminals = function(zn) {
      for (var Un = [
        this.acroForm
      ], Kn = 0, qn = zn.length; Kn < qn; Kn++) {
        var Jo = zn[Kn];
        if (!Jo)
          throw new InvalidFieldNamePartError(Jo);
        var pa = Un[0], ma = Un[1], va = this.findNonTerminal(Jo, pa);
        if (va)
          Un = va;
        else {
          var ba = PDFAcroNonTerminal.create(this.doc.context);
          ba.setPartialName(Jo), ba.setParent(ma);
          var _a = this.doc.context.register(ba.dict);
          pa.addField(_a), Un = [ba, _a];
        }
      }
      return Un;
    }, Xn.prototype.findNonTerminal = function(zn, Un) {
      for (var Kn = Un instanceof PDFAcroForm ? this.acroForm.getFields() : createPDFAcroFields(Un.Kids()), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = pa[0], va = pa[1];
        if (ma.getPartialName() === zn) {
          if (ma instanceof PDFAcroNonTerminal)
            return [ma, va];
          throw new FieldAlreadyExistsError(zn);
        }
      }
    }, Xn.of = function(zn, Un) {
      return new Xn(zn, Un);
    }, Xn;
  }()
), convertToPDFField = function(Xn, zn, Un) {
  if (Xn instanceof PDFAcroPushButton)
    return PDFButton.of(Xn, zn, Un);
  if (Xn instanceof PDFAcroCheckBox)
    return PDFCheckBox.of(Xn, zn, Un);
  if (Xn instanceof PDFAcroComboBox)
    return PDFDropdown.of(Xn, zn, Un);
  if (Xn instanceof PDFAcroListBox)
    return PDFOptionList.of(Xn, zn, Un);
  if (Xn instanceof PDFAcroText)
    return PDFTextField.of(Xn, zn, Un);
  if (Xn instanceof PDFAcroRadioButton)
    return PDFRadioGroup.of(Xn, zn, Un);
  if (Xn instanceof PDFAcroSignature)
    return PDFSignature.of(Xn, zn, Un);
}, splitFieldName = function(Xn) {
  if (Xn.length === 0)
    throw new Error("PDF field names must not be empty strings");
  for (var zn = Xn.split("."), Un = 0, Kn = zn.length; Un < Kn; Un++)
    if (zn[Un] === "")
      throw new Error('Periods in PDF field names must be separated by at least one character: "' + Xn + '"');
  return zn.length === 1 ? { nonTerminal: [], terminal: zn[0] } : {
    nonTerminal: zn.slice(0, zn.length - 1),
    terminal: zn[zn.length - 1]
  };
}, addFieldToParent = function(Xn, zn, Un) {
  for (var Kn = Xn[0], qn = Xn[1], Jo = zn[0], pa = zn[1], ma = Kn.normalizedEntries(), va = createPDFAcroFields("Kids" in ma ? ma.Kids : ma.Fields), ba = 0, _a = va.length; ba < _a; ba++)
    if (va[ba][0].getPartialName() === Un)
      throw new FieldAlreadyExistsError(Un);
  Kn.addField(pa), Jo.setParent(qn);
}, PageSizes = {
  A4: [595.28, 841.89]
}, ParseSpeeds;
(function(Xn) {
  Xn[Xn.Fastest = 1 / 0] = "Fastest", Xn[Xn.Fast = 1500] = "Fast", Xn[Xn.Medium = 500] = "Medium", Xn[Xn.Slow = 100] = "Slow";
})(ParseSpeeds || (ParseSpeeds = {}));
var PDFEmbeddedFile = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      this.alreadyEmbedded = !1, this.ref = zn, this.doc = Un, this.embedder = Kn;
    }
    return Xn.prototype.embed = function() {
      return __awaiter(this, void 0, void 0, function() {
        var zn, Un, Kn, qn, Jo;
        return __generator(this, function(pa) {
          switch (pa.label) {
            case 0:
              return this.alreadyEmbedded ? [3, 2] : [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
            case 1:
              zn = pa.sent(), this.doc.catalog.has(PDFName.of("Names")) || this.doc.catalog.set(PDFName.of("Names"), this.doc.context.obj({})), Un = this.doc.catalog.lookup(PDFName.of("Names"), PDFDict), Un.has(PDFName.of("EmbeddedFiles")) || Un.set(PDFName.of("EmbeddedFiles"), this.doc.context.obj({})), Kn = Un.lookup(PDFName.of("EmbeddedFiles"), PDFDict), Kn.has(PDFName.of("Names")) || Kn.set(PDFName.of("Names"), this.doc.context.obj([])), qn = Kn.lookup(PDFName.of("Names"), PDFArray), qn.push(PDFHexString.fromText(this.embedder.fileName)), qn.push(zn), this.doc.catalog.has(PDFName.of("AF")) || this.doc.catalog.set(PDFName.of("AF"), this.doc.context.obj([])), Jo = this.doc.catalog.lookup(PDFName.of("AF"), PDFArray), Jo.push(zn), this.alreadyEmbedded = !0, pa.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, Xn.of = function(zn, Un, Kn) {
      return new Xn(zn, Un, Kn);
    }, Xn;
  }()
), PDFJavaScript = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      this.alreadyEmbedded = !1, this.ref = zn, this.doc = Un, this.embedder = Kn;
    }
    return Xn.prototype.embed = function() {
      return __awaiter(this, void 0, void 0, function() {
        var zn, Un, Kn, qn, Jo, pa, ma;
        return __generator(this, function(va) {
          switch (va.label) {
            case 0:
              return this.alreadyEmbedded ? [3, 2] : (zn = this.doc, Un = zn.catalog, Kn = zn.context, [4, this.embedder.embedIntoContext(this.doc.context, this.ref)]);
            case 1:
              qn = va.sent(), Un.has(PDFName.of("Names")) || Un.set(PDFName.of("Names"), Kn.obj({})), Jo = Un.lookup(PDFName.of("Names"), PDFDict), Jo.has(PDFName.of("JavaScript")) || Jo.set(PDFName.of("JavaScript"), Kn.obj({})), pa = Jo.lookup(PDFName.of("JavaScript"), PDFDict), pa.has(PDFName.of("Names")) || pa.set(PDFName.of("Names"), Kn.obj([])), ma = pa.lookup(PDFName.of("Names"), PDFArray), ma.push(PDFHexString.fromText(this.embedder.scriptName)), ma.push(qn), this.alreadyEmbedded = !0, va.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, Xn.of = function(zn, Un, Kn) {
      return new Xn(zn, Un, Kn);
    }, Xn;
  }()
), JavaScriptEmbedder = (
  /** @class */
  function() {
    function Xn(zn, Un) {
      this.script = zn, this.scriptName = Un;
    }
    return Xn.for = function(zn, Un) {
      return new Xn(zn, Un);
    }, Xn.prototype.embedIntoContext = function(zn, Un) {
      return __awaiter(this, void 0, void 0, function() {
        var Kn;
        return __generator(this, function(qn) {
          return Kn = zn.obj({
            Type: "Action",
            S: "JavaScript",
            JS: PDFHexString.fromText(this.script)
          }), Un ? (zn.assign(Un, Kn), [2, Un]) : [2, zn.register(Kn)];
        });
      });
    }, Xn;
  }()
), PDFDocument = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      var qn = this;
      if (this.defaultWordBreaks = [" "], this.computePages = function() {
        var Jo = [];
        return qn.catalog.Pages().traverse(function(pa, ma) {
          if (pa instanceof PDFPageLeaf) {
            var va = qn.pageMap.get(pa);
            va || (va = PDFPage.of(pa, ma, qn), qn.pageMap.set(pa, va)), Jo.push(va);
          }
        }), Jo;
      }, this.getOrCreateForm = function() {
        var Jo = qn.catalog.getOrCreateAcroForm();
        return PDFForm.of(Jo, qn);
      }, assertIs(zn, "context", [[PDFContext, "PDFContext"]]), assertIs(Un, "ignoreEncryption", ["boolean"]), this.context = zn, this.catalog = zn.lookup(zn.trailerInfo.Root), this.isEncrypted = !!zn.lookup(zn.trailerInfo.Encrypt), this.pageCache = Cache.populatedBy(this.computePages), this.pageMap = /* @__PURE__ */ new Map(), this.formCache = Cache.populatedBy(this.getOrCreateForm), this.fonts = [], this.images = [], this.embeddedPages = [], this.embeddedFiles = [], this.javaScripts = [], !Un && this.isEncrypted)
        throw new EncryptedPDFError();
      Kn && this.updateInfoDict();
    }
    return Xn.load = function(zn, Un) {
      return Un === void 0 && (Un = {}), __awaiter(this, void 0, void 0, function() {
        var Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta;
        return __generator(this, function(Sa) {
          switch (Sa.label) {
            case 0:
              return Kn = Un.ignoreEncryption, qn = Kn === void 0 ? !1 : Kn, Jo = Un.parseSpeed, pa = Jo === void 0 ? ParseSpeeds.Slow : Jo, ma = Un.throwOnInvalidObject, va = ma === void 0 ? !1 : ma, ba = Un.updateMetadata, _a = ba === void 0 ? !0 : ba, ya = Un.capNumbers, xa = ya === void 0 ? !1 : ya, assertIs(zn, "pdf", ["string", Uint8Array, ArrayBuffer]), assertIs(qn, "ignoreEncryption", ["boolean"]), assertIs(pa, "parseSpeed", ["number"]), assertIs(va, "throwOnInvalidObject", ["boolean"]), wa = toUint8Array(zn), [4, PDFParser.forBytesWithOptions(wa, pa, va, xa).parseDocument()];
            case 1:
              return Ta = Sa.sent(), [2, new Xn(Ta, qn, _a)];
          }
        });
      });
    }, Xn.create = function(zn) {
      return zn === void 0 && (zn = {}), __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo, pa, ma;
        return __generator(this, function(va) {
          return Un = zn.updateMetadata, Kn = Un === void 0 ? !0 : Un, qn = PDFContext.create(), Jo = PDFPageTree.withContext(qn), pa = qn.register(Jo), ma = PDFCatalog.withContextAndPages(qn, pa), qn.trailerInfo.Root = qn.register(ma), [2, new Xn(qn, !1, Kn)];
        });
      });
    }, Xn.prototype.registerFontkit = function(zn) {
      this.fontkit = zn;
    }, Xn.prototype.getForm = function() {
      var zn = this.formCache.access();
      return zn.hasXFA() && (console.warn("Removing XFA form data as pdf-lib does not support reading or writing XFA"), zn.deleteXFA()), zn;
    }, Xn.prototype.getTitle = function() {
      var zn = this.getInfoDict().lookup(PDFName.Title);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeText();
    }, Xn.prototype.getAuthor = function() {
      var zn = this.getInfoDict().lookup(PDFName.Author);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeText();
    }, Xn.prototype.getSubject = function() {
      var zn = this.getInfoDict().lookup(PDFName.Subject);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeText();
    }, Xn.prototype.getKeywords = function() {
      var zn = this.getInfoDict().lookup(PDFName.Keywords);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeText();
    }, Xn.prototype.getCreator = function() {
      var zn = this.getInfoDict().lookup(PDFName.Creator);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeText();
    }, Xn.prototype.getProducer = function() {
      var zn = this.getInfoDict().lookup(PDFName.Producer);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeText();
    }, Xn.prototype.getCreationDate = function() {
      var zn = this.getInfoDict().lookup(PDFName.CreationDate);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeDate();
    }, Xn.prototype.getModificationDate = function() {
      var zn = this.getInfoDict().lookup(PDFName.ModDate);
      if (zn)
        return assertIsLiteralOrHexString(zn), zn.decodeDate();
    }, Xn.prototype.setTitle = function(zn, Un) {
      assertIs(zn, "title", ["string"]);
      var Kn = PDFName.of("Title");
      if (this.getInfoDict().set(Kn, PDFHexString.fromText(zn)), Un != null && Un.showInWindowTitleBar) {
        var qn = this.catalog.getOrCreateViewerPreferences();
        qn.setDisplayDocTitle(!0);
      }
    }, Xn.prototype.setAuthor = function(zn) {
      assertIs(zn, "author", ["string"]);
      var Un = PDFName.of("Author");
      this.getInfoDict().set(Un, PDFHexString.fromText(zn));
    }, Xn.prototype.setSubject = function(zn) {
      assertIs(zn, "author", ["string"]);
      var Un = PDFName.of("Subject");
      this.getInfoDict().set(Un, PDFHexString.fromText(zn));
    }, Xn.prototype.setKeywords = function(zn) {
      assertIs(zn, "keywords", [Array]);
      var Un = PDFName.of("Keywords");
      this.getInfoDict().set(Un, PDFHexString.fromText(zn.join(" ")));
    }, Xn.prototype.setCreator = function(zn) {
      assertIs(zn, "creator", ["string"]);
      var Un = PDFName.of("Creator");
      this.getInfoDict().set(Un, PDFHexString.fromText(zn));
    }, Xn.prototype.setProducer = function(zn) {
      assertIs(zn, "creator", ["string"]);
      var Un = PDFName.of("Producer");
      this.getInfoDict().set(Un, PDFHexString.fromText(zn));
    }, Xn.prototype.setLanguage = function(zn) {
      assertIs(zn, "language", ["string"]);
      var Un = PDFName.of("Lang");
      this.catalog.set(Un, PDFString.of(zn));
    }, Xn.prototype.setCreationDate = function(zn) {
      assertIs(zn, "creationDate", [[Date, "Date"]]);
      var Un = PDFName.of("CreationDate");
      this.getInfoDict().set(Un, PDFString.fromDate(zn));
    }, Xn.prototype.setModificationDate = function(zn) {
      assertIs(zn, "modificationDate", [[Date, "Date"]]);
      var Un = PDFName.of("ModDate");
      this.getInfoDict().set(Un, PDFString.fromDate(zn));
    }, Xn.prototype.getPageCount = function() {
      return this.pageCount === void 0 && (this.pageCount = this.getPages().length), this.pageCount;
    }, Xn.prototype.getPages = function() {
      return this.pageCache.access();
    }, Xn.prototype.getPage = function(zn) {
      var Un = this.getPages();
      return assertRange(zn, "index", 0, Un.length - 1), Un[zn];
    }, Xn.prototype.getPageIndices = function() {
      return range(0, this.getPageCount());
    }, Xn.prototype.removePage = function(zn) {
      var Un = this.getPageCount();
      if (this.pageCount === 0)
        throw new RemovePageFromEmptyDocumentError();
      assertRange(zn, "index", 0, Un - 1), this.catalog.removeLeafNode(zn), this.pageCount = Un - 1;
    }, Xn.prototype.addPage = function(zn) {
      return assertIs(zn, "page", ["undefined", [PDFPage, "PDFPage"], Array]), this.insertPage(this.getPageCount(), zn);
    }, Xn.prototype.insertPage = function(zn, Un) {
      var Kn = this.getPageCount();
      if (assertRange(zn, "index", 0, Kn), assertIs(Un, "page", ["undefined", [PDFPage, "PDFPage"], Array]), !Un || Array.isArray(Un)) {
        var qn = Array.isArray(Un) ? Un : PageSizes.A4;
        Un = PDFPage.create(this), Un.setSize.apply(Un, qn);
      } else if (Un.doc !== this)
        throw new ForeignPageError();
      var Jo = this.catalog.insertLeafNode(Un.ref, zn);
      return Un.node.setParent(Jo), this.pageMap.set(Un.node, Un), this.pageCache.invalidate(), this.pageCount = Kn + 1, Un;
    }, Xn.prototype.copyPages = function(zn, Un) {
      return __awaiter(this, void 0, void 0, function() {
        var Kn, qn, Jo, pa, ma, va, ba, _a;
        return __generator(this, function(ya) {
          switch (ya.label) {
            case 0:
              return assertIs(zn, "srcDoc", [[Xn, "PDFDocument"]]), assertIs(Un, "indices", [Array]), [4, zn.flush()];
            case 1:
              for (ya.sent(), Kn = PDFObjectCopier.for(zn.context, this.context), qn = zn.getPages(), Jo = new Array(Un.length), pa = 0, ma = Un.length; pa < ma; pa++)
                va = qn[Un[pa]], ba = Kn.copy(va.node), _a = this.context.register(ba), Jo[pa] = PDFPage.of(ba, _a, this);
              return [2, Jo];
          }
        });
      });
    }, Xn.prototype.copy = function() {
      return __awaiter(this, void 0, void 0, function() {
        var zn, Un, Kn, qn;
        return __generator(this, function(Jo) {
          switch (Jo.label) {
            case 0:
              return [4, Xn.create()];
            case 1:
              return zn = Jo.sent(), [4, zn.copyPages(this, this.getPageIndices())];
            case 2:
              for (Un = Jo.sent(), Kn = 0, qn = Un.length; Kn < qn; Kn++)
                zn.addPage(Un[Kn]);
              return this.getAuthor() !== void 0 && zn.setAuthor(this.getAuthor()), this.getCreationDate() !== void 0 && zn.setCreationDate(this.getCreationDate()), this.getCreator() !== void 0 && zn.setCreator(this.getCreator()), this.getModificationDate() !== void 0 && zn.setModificationDate(this.getModificationDate()), this.getProducer() !== void 0 && zn.setProducer(this.getProducer()), this.getSubject() !== void 0 && zn.setSubject(this.getSubject()), this.getTitle() !== void 0 && zn.setTitle(this.getTitle()), zn.defaultWordBreaks = this.defaultWordBreaks, [2, zn];
          }
        });
      });
    }, Xn.prototype.addJavaScript = function(zn, Un) {
      assertIs(zn, "name", ["string"]), assertIs(Un, "script", ["string"]);
      var Kn = JavaScriptEmbedder.for(Un, zn), qn = this.context.nextRef(), Jo = PDFJavaScript.of(qn, this, Kn);
      this.javaScripts.push(Jo);
    }, Xn.prototype.attach = function(zn, Un, Kn) {
      return Kn === void 0 && (Kn = {}), __awaiter(this, void 0, void 0, function() {
        var qn, Jo, pa, ma;
        return __generator(this, function(va) {
          return assertIs(zn, "attachment", ["string", Uint8Array, ArrayBuffer]), assertIs(Un, "name", ["string"]), assertOrUndefined(Kn.mimeType, "mimeType", ["string"]), assertOrUndefined(Kn.description, "description", ["string"]), assertOrUndefined(Kn.creationDate, "options.creationDate", [Date]), assertOrUndefined(Kn.modificationDate, "options.modificationDate", [
            Date
          ]), assertIsOneOfOrUndefined(Kn.afRelationship, "options.afRelationship", AFRelationship), qn = toUint8Array(zn), Jo = FileEmbedder.for(qn, Un, Kn), pa = this.context.nextRef(), ma = PDFEmbeddedFile.of(pa, this, Jo), this.embeddedFiles.push(ma), [
            2
            /*return*/
          ];
        });
      });
    }, Xn.prototype.embedFont = function(zn, Un) {
      return Un === void 0 && (Un = {}), __awaiter(this, void 0, void 0, function() {
        var Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa;
        return __generator(this, function(wa) {
          switch (wa.label) {
            case 0:
              return Kn = Un.subset, qn = Kn === void 0 ? !1 : Kn, Jo = Un.customName, pa = Un.features, assertIs(zn, "font", ["string", Uint8Array, ArrayBuffer]), assertIs(qn, "subset", ["boolean"]), isStandardFont(zn) ? (ma = StandardFontEmbedder.for(zn, Jo), [3, 7]) : [3, 1];
            case 1:
              return canBeConvertedToUint8Array(zn) ? (va = toUint8Array(zn), ba = this.assertFontkit(), qn ? [4, CustomFontSubsetEmbedder.for(ba, va, Jo, pa)] : [3, 3]) : [3, 6];
            case 2:
              return _a = wa.sent(), [3, 5];
            case 3:
              return [4, CustomFontEmbedder.for(ba, va, Jo, pa)];
            case 4:
              _a = wa.sent(), wa.label = 5;
            case 5:
              return ma = _a, [3, 7];
            case 6:
              throw new TypeError("`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`");
            case 7:
              return ya = this.context.nextRef(), xa = PDFFont.of(ya, this, ma), this.fonts.push(xa), [2, xa];
          }
        });
      });
    }, Xn.prototype.embedStandardFont = function(zn, Un) {
      if (assertIs(zn, "font", ["string"]), !isStandardFont(zn))
        throw new TypeError("`font` must be one of type `StandardFonts`");
      var Kn = StandardFontEmbedder.for(zn, Un), qn = this.context.nextRef(), Jo = PDFFont.of(qn, this, Kn);
      return this.fonts.push(Jo), Jo;
    }, Xn.prototype.embedJpg = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo;
        return __generator(this, function(pa) {
          switch (pa.label) {
            case 0:
              return assertIs(zn, "jpg", ["string", Uint8Array, ArrayBuffer]), Un = toUint8Array(zn), [4, JpegEmbedder.for(Un)];
            case 1:
              return Kn = pa.sent(), qn = this.context.nextRef(), Jo = PDFImage.of(qn, this, Kn), this.images.push(Jo), [2, Jo];
          }
        });
      });
    }, Xn.prototype.embedPng = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo;
        return __generator(this, function(pa) {
          switch (pa.label) {
            case 0:
              return assertIs(zn, "png", ["string", Uint8Array, ArrayBuffer]), Un = toUint8Array(zn), [4, PngEmbedder.for(Un)];
            case 1:
              return Kn = pa.sent(), qn = this.context.nextRef(), Jo = PDFImage.of(qn, this, Kn), this.images.push(Jo), [2, Jo];
          }
        });
      });
    }, Xn.prototype.embedPdf = function(zn, Un) {
      return Un === void 0 && (Un = [0]), __awaiter(this, void 0, void 0, function() {
        var Kn, qn, Jo;
        return __generator(this, function(pa) {
          switch (pa.label) {
            case 0:
              return assertIs(zn, "pdf", [
                "string",
                Uint8Array,
                ArrayBuffer,
                [Xn, "PDFDocument"]
              ]), assertIs(Un, "indices", [Array]), zn instanceof Xn ? (qn = zn, [3, 3]) : [3, 1];
            case 1:
              return [4, Xn.load(zn)];
            case 2:
              qn = pa.sent(), pa.label = 3;
            case 3:
              return Kn = qn, Jo = pluckIndices(Kn.getPages(), Un), [2, this.embedPages(Jo)];
          }
        });
      });
    }, Xn.prototype.embedPage = function(zn, Un, Kn) {
      return __awaiter(this, void 0, void 0, function() {
        var qn;
        return __generator(this, function(Jo) {
          switch (Jo.label) {
            case 0:
              return assertIs(zn, "page", [[PDFPage, "PDFPage"]]), [4, this.embedPages([zn], [Un], [Kn])];
            case 1:
              return qn = Jo.sent()[0], [2, qn];
          }
        });
      });
    }, Xn.prototype.embedPages = function(zn, Un, Kn) {
      return Un === void 0 && (Un = []), Kn === void 0 && (Kn = []), __awaiter(this, void 0, void 0, function() {
        var ba, _a, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa, Ma;
        return __generator(this, function(ka) {
          switch (ka.label) {
            case 0:
              if (zn.length === 0)
                return [2, []];
              for (ba = 0, _a = zn.length - 1; ba < _a; ba++)
                if (qn = zn[ba], Jo = zn[ba + 1], qn.node.context !== Jo.node.context)
                  throw new PageEmbeddingMismatchedContextError();
              pa = zn[0].node.context, ma = pa === this.context ? function(Za) {
                return Za;
              } : PDFObjectCopier.for(pa, this.context).copy, va = new Array(zn.length), ba = 0, _a = zn.length, ka.label = 1;
            case 1:
              return ba < _a ? (ya = ma(zn[ba].node), xa = Un[ba], wa = Kn[ba], [4, PDFPageEmbedder.for(ya, xa, wa)]) : [3, 4];
            case 2:
              Ta = ka.sent(), Sa = this.context.nextRef(), va[ba] = PDFEmbeddedPage.of(Sa, this, Ta), ka.label = 3;
            case 3:
              return ba++, [3, 1];
            case 4:
              return (Ma = this.embeddedPages).push.apply(Ma, va), [2, va];
          }
        });
      });
    }, Xn.prototype.flush = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(zn) {
          switch (zn.label) {
            case 0:
              return [4, this.embedAll(this.fonts)];
            case 1:
              return zn.sent(), [4, this.embedAll(this.images)];
            case 2:
              return zn.sent(), [4, this.embedAll(this.embeddedPages)];
            case 3:
              return zn.sent(), [4, this.embedAll(this.embeddedFiles)];
            case 4:
              return zn.sent(), [4, this.embedAll(this.javaScripts)];
            case 5:
              return zn.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, Xn.prototype.save = function(zn) {
      return zn === void 0 && (zn = {}), __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya;
        return __generator(this, function(xa) {
          switch (xa.label) {
            case 0:
              return Un = zn.useObjectStreams, Kn = Un === void 0 ? !0 : Un, qn = zn.addDefaultPage, Jo = qn === void 0 ? !0 : qn, pa = zn.objectsPerTick, ma = pa === void 0 ? 50 : pa, va = zn.updateFieldAppearances, ba = va === void 0 ? !0 : va, assertIs(Kn, "useObjectStreams", ["boolean"]), assertIs(Jo, "addDefaultPage", ["boolean"]), assertIs(ma, "objectsPerTick", ["number"]), assertIs(ba, "updateFieldAppearances", ["boolean"]), Jo && this.getPageCount() === 0 && this.addPage(), ba && (_a = this.formCache.getValue(), _a && _a.updateFieldAppearances()), [4, this.flush()];
            case 1:
              return xa.sent(), ya = Kn ? PDFStreamWriter : PDFWriter, [2, ya.forContext(this.context, ma).serializeToBuffer()];
          }
        });
      });
    }, Xn.prototype.saveAsBase64 = function(zn) {
      return zn === void 0 && (zn = {}), __awaiter(this, void 0, void 0, function() {
        var Un, Kn, qn, Jo, pa;
        return __generator(this, function(ma) {
          switch (ma.label) {
            case 0:
              return Un = zn.dataUri, Kn = Un === void 0 ? !1 : Un, qn = __rest(zn, ["dataUri"]), assertIs(Kn, "dataUri", ["boolean"]), [4, this.save(qn)];
            case 1:
              return Jo = ma.sent(), pa = encodeToBase64(Jo), [2, Kn ? "data:application/pdf;base64," + pa : pa];
          }
        });
      });
    }, Xn.prototype.findPageForAnnotationRef = function(zn) {
      for (var Un = this.getPages(), Kn = 0, qn = Un.length; Kn < qn; Kn++) {
        var Jo = Un[Kn], pa = Jo.node.Annots();
        if ((pa == null ? void 0 : pa.indexOf(zn)) !== void 0)
          return Jo;
      }
    }, Xn.prototype.embedAll = function(zn) {
      return __awaiter(this, void 0, void 0, function() {
        var Un, Kn;
        return __generator(this, function(qn) {
          switch (qn.label) {
            case 0:
              Un = 0, Kn = zn.length, qn.label = 1;
            case 1:
              return Un < Kn ? [4, zn[Un].embed()] : [3, 4];
            case 2:
              qn.sent(), qn.label = 3;
            case 3:
              return Un++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, Xn.prototype.updateInfoDict = function() {
      var zn = "pdf-lib (https://github.com/Hopding/pdf-lib)", Un = /* @__PURE__ */ new Date(), Kn = this.getInfoDict();
      this.setProducer(zn), this.setModificationDate(Un), Kn.get(PDFName.of("Creator")) || this.setCreator(zn), Kn.get(PDFName.of("CreationDate")) || this.setCreationDate(Un);
    }, Xn.prototype.getInfoDict = function() {
      var zn = this.context.lookup(this.context.trailerInfo.Info);
      if (zn instanceof PDFDict)
        return zn;
      var Un = this.context.obj({});
      return this.context.trailerInfo.Info = this.context.register(Un), Un;
    }, Xn.prototype.assertFontkit = function() {
      if (!this.fontkit)
        throw new FontkitNotRegisteredError();
      return this.fontkit;
    }, Xn;
  }()
);
function assertIsLiteralOrHexString(Xn) {
  if (!(Xn instanceof PDFHexString) && !(Xn instanceof PDFString))
    throw new UnexpectedObjectTypeError([PDFHexString, PDFString], Xn);
}
var BlendMode;
(function(Xn) {
  Xn.Normal = "Normal", Xn.Multiply = "Multiply", Xn.Screen = "Screen", Xn.Overlay = "Overlay", Xn.Darken = "Darken", Xn.Lighten = "Lighten", Xn.ColorDodge = "ColorDodge", Xn.ColorBurn = "ColorBurn", Xn.HardLight = "HardLight", Xn.SoftLight = "SoftLight", Xn.Difference = "Difference", Xn.Exclusion = "Exclusion";
})(BlendMode || (BlendMode = {}));
var PDFPage = (
  /** @class */
  function() {
    function Xn(zn, Un, Kn) {
      this.fontSize = 24, this.fontColor = rgb(0, 0, 0), this.lineHeight = 24, this.x = 0, this.y = 0, assertIs(zn, "leafNode", [[PDFPageLeaf, "PDFPageLeaf"]]), assertIs(Un, "ref", [[PDFRef, "PDFRef"]]), assertIs(Kn, "doc", [[PDFDocument, "PDFDocument"]]), this.node = zn, this.ref = Un, this.doc = Kn;
    }
    return Xn.prototype.setRotation = function(zn) {
      var Un = toDegrees(zn);
      assertMultiple(Un, "degreesAngle", 90), this.node.set(PDFName.of("Rotate"), this.doc.context.obj(Un));
    }, Xn.prototype.getRotation = function() {
      var zn = this.node.Rotate();
      return degrees(zn ? zn.asNumber() : 0);
    }, Xn.prototype.setSize = function(zn, Un) {
      assertIs(zn, "width", ["number"]), assertIs(Un, "height", ["number"]);
      var Kn = this.getMediaBox();
      this.setMediaBox(Kn.x, Kn.y, zn, Un);
      var qn = this.getCropBox(), Jo = this.getBleedBox(), pa = this.getTrimBox(), ma = this.getArtBox(), va = this.node.CropBox(), ba = this.node.BleedBox(), _a = this.node.TrimBox(), ya = this.node.ArtBox();
      va && rectanglesAreEqual(qn, Kn) && this.setCropBox(Kn.x, Kn.y, zn, Un), ba && rectanglesAreEqual(Jo, Kn) && this.setBleedBox(Kn.x, Kn.y, zn, Un), _a && rectanglesAreEqual(pa, Kn) && this.setTrimBox(Kn.x, Kn.y, zn, Un), ya && rectanglesAreEqual(ma, Kn) && this.setArtBox(Kn.x, Kn.y, zn, Un);
    }, Xn.prototype.setWidth = function(zn) {
      assertIs(zn, "width", ["number"]), this.setSize(zn, this.getSize().height);
    }, Xn.prototype.setHeight = function(zn) {
      assertIs(zn, "height", ["number"]), this.setSize(this.getSize().width, zn);
    }, Xn.prototype.setMediaBox = function(zn, Un, Kn, qn) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), assertIs(Kn, "width", ["number"]), assertIs(qn, "height", ["number"]);
      var Jo = this.doc.context.obj([zn, Un, zn + Kn, Un + qn]);
      this.node.set(PDFName.MediaBox, Jo);
    }, Xn.prototype.setCropBox = function(zn, Un, Kn, qn) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), assertIs(Kn, "width", ["number"]), assertIs(qn, "height", ["number"]);
      var Jo = this.doc.context.obj([zn, Un, zn + Kn, Un + qn]);
      this.node.set(PDFName.CropBox, Jo);
    }, Xn.prototype.setBleedBox = function(zn, Un, Kn, qn) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), assertIs(Kn, "width", ["number"]), assertIs(qn, "height", ["number"]);
      var Jo = this.doc.context.obj([zn, Un, zn + Kn, Un + qn]);
      this.node.set(PDFName.BleedBox, Jo);
    }, Xn.prototype.setTrimBox = function(zn, Un, Kn, qn) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), assertIs(Kn, "width", ["number"]), assertIs(qn, "height", ["number"]);
      var Jo = this.doc.context.obj([zn, Un, zn + Kn, Un + qn]);
      this.node.set(PDFName.TrimBox, Jo);
    }, Xn.prototype.setArtBox = function(zn, Un, Kn, qn) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), assertIs(Kn, "width", ["number"]), assertIs(qn, "height", ["number"]);
      var Jo = this.doc.context.obj([zn, Un, zn + Kn, Un + qn]);
      this.node.set(PDFName.ArtBox, Jo);
    }, Xn.prototype.getSize = function() {
      var zn = this.getMediaBox(), Un = zn.width, Kn = zn.height;
      return { width: Un, height: Kn };
    }, Xn.prototype.getWidth = function() {
      return this.getSize().width;
    }, Xn.prototype.getHeight = function() {
      return this.getSize().height;
    }, Xn.prototype.getMediaBox = function() {
      var zn = this.node.MediaBox();
      return zn.asRectangle();
    }, Xn.prototype.getCropBox = function() {
      var zn, Un = this.node.CropBox();
      return (zn = Un == null ? void 0 : Un.asRectangle()) !== null && zn !== void 0 ? zn : this.getMediaBox();
    }, Xn.prototype.getBleedBox = function() {
      var zn, Un = this.node.BleedBox();
      return (zn = Un == null ? void 0 : Un.asRectangle()) !== null && zn !== void 0 ? zn : this.getCropBox();
    }, Xn.prototype.getTrimBox = function() {
      var zn, Un = this.node.TrimBox();
      return (zn = Un == null ? void 0 : Un.asRectangle()) !== null && zn !== void 0 ? zn : this.getCropBox();
    }, Xn.prototype.getArtBox = function() {
      var zn, Un = this.node.ArtBox();
      return (zn = Un == null ? void 0 : Un.asRectangle()) !== null && zn !== void 0 ? zn : this.getCropBox();
    }, Xn.prototype.translateContent = function(zn, Un) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), this.node.normalize(), this.getContentStream();
      var Kn = this.createContentStream(pushGraphicsState(), translate(zn, Un)), qn = this.doc.context.register(Kn), Jo = this.createContentStream(popGraphicsState()), pa = this.doc.context.register(Jo);
      this.node.wrapContentStreams(qn, pa);
    }, Xn.prototype.scale = function(zn, Un) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), this.setSize(this.getWidth() * zn, this.getHeight() * Un), this.scaleContent(zn, Un), this.scaleAnnotations(zn, Un);
    }, Xn.prototype.scaleContent = function(zn, Un) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), this.node.normalize(), this.getContentStream();
      var Kn = this.createContentStream(pushGraphicsState(), scale(zn, Un)), qn = this.doc.context.register(Kn), Jo = this.createContentStream(popGraphicsState()), pa = this.doc.context.register(Jo);
      this.node.wrapContentStreams(qn, pa);
    }, Xn.prototype.scaleAnnotations = function(zn, Un) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]);
      var Kn = this.node.Annots();
      if (Kn)
        for (var qn = 0; qn < Kn.size(); qn++) {
          var Jo = Kn.lookup(qn);
          Jo instanceof PDFDict && this.scaleAnnot(Jo, zn, Un);
        }
    }, Xn.prototype.resetPosition = function() {
      this.getContentStream(!1), this.x = 0, this.y = 0;
    }, Xn.prototype.setFont = function(zn) {
      assertIs(zn, "font", [[PDFFont, "PDFFont"]]), this.font = zn, this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    }, Xn.prototype.setFontSize = function(zn) {
      assertIs(zn, "fontSize", ["number"]), this.fontSize = zn;
    }, Xn.prototype.setFontColor = function(zn) {
      assertIs(zn, "fontColor", [[Object, "Color"]]), this.fontColor = zn;
    }, Xn.prototype.setLineHeight = function(zn) {
      assertIs(zn, "lineHeight", ["number"]), this.lineHeight = zn;
    }, Xn.prototype.getPosition = function() {
      return { x: this.x, y: this.y };
    }, Xn.prototype.getX = function() {
      return this.x;
    }, Xn.prototype.getY = function() {
      return this.y;
    }, Xn.prototype.moveTo = function(zn, Un) {
      assertIs(zn, "x", ["number"]), assertIs(Un, "y", ["number"]), this.x = zn, this.y = Un;
    }, Xn.prototype.moveDown = function(zn) {
      assertIs(zn, "yDecrease", ["number"]), this.y -= zn;
    }, Xn.prototype.moveUp = function(zn) {
      assertIs(zn, "yIncrease", ["number"]), this.y += zn;
    }, Xn.prototype.moveLeft = function(zn) {
      assertIs(zn, "xDecrease", ["number"]), this.x -= zn;
    }, Xn.prototype.moveRight = function(zn) {
      assertIs(zn, "xIncrease", ["number"]), this.x += zn;
    }, Xn.prototype.pushOperators = function() {
      for (var zn = [], Un = 0; Un < arguments.length; Un++)
        zn[Un] = arguments[Un];
      assertEachIs(zn, "operator", [[PDFOperator, "PDFOperator"]]);
      var Kn = this.getContentStream();
      Kn.push.apply(Kn, zn);
    }, Xn.prototype.drawText = function(zn, Un) {
      var Kn, qn, Jo, pa, ma, va, ba;
      Un === void 0 && (Un = {}), assertIs(zn, "text", ["string"]), assertOrUndefined(Un.color, "options.color", [[Object, "Color"]]), assertRangeOrUndefined(Un.opacity, "opacity.opacity", 0, 1), assertOrUndefined(Un.font, "options.font", [[PDFFont, "PDFFont"]]), assertOrUndefined(Un.size, "options.size", ["number"]), assertOrUndefined(Un.rotate, "options.rotate", [[Object, "Rotation"]]), assertOrUndefined(Un.xSkew, "options.xSkew", [[Object, "Rotation"]]), assertOrUndefined(Un.ySkew, "options.ySkew", [[Object, "Rotation"]]), assertOrUndefined(Un.x, "options.x", ["number"]), assertOrUndefined(Un.y, "options.y", ["number"]), assertOrUndefined(Un.lineHeight, "options.lineHeight", ["number"]), assertOrUndefined(Un.maxWidth, "options.maxWidth", ["number"]), assertOrUndefined(Un.wordBreaks, "options.wordBreaks", [Array]), assertIsOneOfOrUndefined(Un.blendMode, "options.blendMode", BlendMode);
      for (var _a = this.setOrEmbedFont(Un.font), ya = _a.oldFont, xa = _a.newFont, wa = _a.newFontKey, Ta = Un.size || this.fontSize, Sa = Un.wordBreaks || this.doc.defaultWordBreaks, Ma = function(qa) {
        return xa.widthOfTextAtSize(qa, Ta);
      }, ka = Un.maxWidth === void 0 ? lineSplit(cleanText(zn)) : breakTextIntoLines(zn, Sa, Un.maxWidth, Ma), Za = new Array(ka.length), Na = 0, Ka = ka.length; Na < Ka; Na++)
        Za[Na] = xa.encodeText(ka[Na]);
      var Ja = this.maybeEmbedGraphicsState({
        opacity: Un.opacity,
        blendMode: Un.blendMode
      }), el = this.getContentStream();
      el.push.apply(el, drawLinesOfText(Za, {
        color: (Kn = Un.color) !== null && Kn !== void 0 ? Kn : this.fontColor,
        font: wa,
        size: Ta,
        rotate: (qn = Un.rotate) !== null && qn !== void 0 ? qn : degrees(0),
        xSkew: (Jo = Un.xSkew) !== null && Jo !== void 0 ? Jo : degrees(0),
        ySkew: (pa = Un.ySkew) !== null && pa !== void 0 ? pa : degrees(0),
        x: (ma = Un.x) !== null && ma !== void 0 ? ma : this.x,
        y: (va = Un.y) !== null && va !== void 0 ? va : this.y,
        lineHeight: (ba = Un.lineHeight) !== null && ba !== void 0 ? ba : this.lineHeight,
        graphicsState: Ja
      })), Un.font && (ya ? this.setFont(ya) : this.resetFont());
    }, Xn.prototype.drawImage = function(zn, Un) {
      var Kn, qn, Jo, pa, ma, va, ba;
      Un === void 0 && (Un = {}), assertIs(zn, "image", [[PDFImage, "PDFImage"]]), assertOrUndefined(Un.x, "options.x", ["number"]), assertOrUndefined(Un.y, "options.y", ["number"]), assertOrUndefined(Un.width, "options.width", ["number"]), assertOrUndefined(Un.height, "options.height", ["number"]), assertOrUndefined(Un.rotate, "options.rotate", [[Object, "Rotation"]]), assertOrUndefined(Un.xSkew, "options.xSkew", [[Object, "Rotation"]]), assertOrUndefined(Un.ySkew, "options.ySkew", [[Object, "Rotation"]]), assertRangeOrUndefined(Un.opacity, "opacity.opacity", 0, 1), assertIsOneOfOrUndefined(Un.blendMode, "options.blendMode", BlendMode);
      var _a = this.node.newXObject("Image", zn.ref), ya = this.maybeEmbedGraphicsState({
        opacity: Un.opacity,
        blendMode: Un.blendMode
      }), xa = this.getContentStream();
      xa.push.apply(xa, drawImage(_a, {
        x: (Kn = Un.x) !== null && Kn !== void 0 ? Kn : this.x,
        y: (qn = Un.y) !== null && qn !== void 0 ? qn : this.y,
        width: (Jo = Un.width) !== null && Jo !== void 0 ? Jo : zn.size().width,
        height: (pa = Un.height) !== null && pa !== void 0 ? pa : zn.size().height,
        rotate: (ma = Un.rotate) !== null && ma !== void 0 ? ma : degrees(0),
        xSkew: (va = Un.xSkew) !== null && va !== void 0 ? va : degrees(0),
        ySkew: (ba = Un.ySkew) !== null && ba !== void 0 ? ba : degrees(0),
        graphicsState: ya
      }));
    }, Xn.prototype.drawPage = function(zn, Un) {
      var Kn, qn, Jo, pa, ma;
      Un === void 0 && (Un = {}), assertIs(zn, "embeddedPage", [
        [PDFEmbeddedPage, "PDFEmbeddedPage"]
      ]), assertOrUndefined(Un.x, "options.x", ["number"]), assertOrUndefined(Un.y, "options.y", ["number"]), assertOrUndefined(Un.xScale, "options.xScale", ["number"]), assertOrUndefined(Un.yScale, "options.yScale", ["number"]), assertOrUndefined(Un.width, "options.width", ["number"]), assertOrUndefined(Un.height, "options.height", ["number"]), assertOrUndefined(Un.rotate, "options.rotate", [[Object, "Rotation"]]), assertOrUndefined(Un.xSkew, "options.xSkew", [[Object, "Rotation"]]), assertOrUndefined(Un.ySkew, "options.ySkew", [[Object, "Rotation"]]), assertRangeOrUndefined(Un.opacity, "opacity.opacity", 0, 1), assertIsOneOfOrUndefined(Un.blendMode, "options.blendMode", BlendMode);
      var va = this.node.newXObject("EmbeddedPdfPage", zn.ref), ba = this.maybeEmbedGraphicsState({
        opacity: Un.opacity,
        blendMode: Un.blendMode
      }), _a = Un.width !== void 0 ? Un.width / zn.width : Un.xScale !== void 0 ? Un.xScale : 1, ya = Un.height !== void 0 ? Un.height / zn.height : Un.yScale !== void 0 ? Un.yScale : 1, xa = this.getContentStream();
      xa.push.apply(xa, drawPage(va, {
        x: (Kn = Un.x) !== null && Kn !== void 0 ? Kn : this.x,
        y: (qn = Un.y) !== null && qn !== void 0 ? qn : this.y,
        xScale: _a,
        yScale: ya,
        rotate: (Jo = Un.rotate) !== null && Jo !== void 0 ? Jo : degrees(0),
        xSkew: (pa = Un.xSkew) !== null && pa !== void 0 ? pa : degrees(0),
        ySkew: (ma = Un.ySkew) !== null && ma !== void 0 ? ma : degrees(0),
        graphicsState: ba
      }));
    }, Xn.prototype.drawSvgPath = function(zn, Un) {
      var Kn, qn, Jo, pa, ma, va, ba, _a, ya;
      Un === void 0 && (Un = {}), assertIs(zn, "path", ["string"]), assertOrUndefined(Un.x, "options.x", ["number"]), assertOrUndefined(Un.y, "options.y", ["number"]), assertOrUndefined(Un.scale, "options.scale", ["number"]), assertOrUndefined(Un.rotate, "options.rotate", [[Object, "Rotation"]]), assertOrUndefined(Un.borderWidth, "options.borderWidth", ["number"]), assertOrUndefined(Un.color, "options.color", [[Object, "Color"]]), assertRangeOrUndefined(Un.opacity, "opacity.opacity", 0, 1), assertOrUndefined(Un.borderColor, "options.borderColor", [
        [Object, "Color"]
      ]), assertOrUndefined(Un.borderDashArray, "options.borderDashArray", [
        Array
      ]), assertOrUndefined(Un.borderDashPhase, "options.borderDashPhase", [
        "number"
      ]), assertIsOneOfOrUndefined(Un.borderLineCap, "options.borderLineCap", LineCapStyle), assertRangeOrUndefined(Un.borderOpacity, "options.borderOpacity", 0, 1), assertIsOneOfOrUndefined(Un.blendMode, "options.blendMode", BlendMode);
      var xa = this.maybeEmbedGraphicsState({
        opacity: Un.opacity,
        borderOpacity: Un.borderOpacity,
        blendMode: Un.blendMode
      });
      !("color" in Un) && !("borderColor" in Un) && (Un.borderColor = rgb(0, 0, 0));
      var wa = this.getContentStream();
      wa.push.apply(wa, drawSvgPath(zn, {
        x: (Kn = Un.x) !== null && Kn !== void 0 ? Kn : this.x,
        y: (qn = Un.y) !== null && qn !== void 0 ? qn : this.y,
        scale: Un.scale,
        rotate: (Jo = Un.rotate) !== null && Jo !== void 0 ? Jo : degrees(0),
        color: (pa = Un.color) !== null && pa !== void 0 ? pa : void 0,
        borderColor: (ma = Un.borderColor) !== null && ma !== void 0 ? ma : void 0,
        borderWidth: (va = Un.borderWidth) !== null && va !== void 0 ? va : 0,
        borderDashArray: (ba = Un.borderDashArray) !== null && ba !== void 0 ? ba : void 0,
        borderDashPhase: (_a = Un.borderDashPhase) !== null && _a !== void 0 ? _a : void 0,
        borderLineCap: (ya = Un.borderLineCap) !== null && ya !== void 0 ? ya : void 0,
        graphicsState: xa
      }));
    }, Xn.prototype.drawLine = function(zn) {
      var Un, Kn, qn, Jo, pa;
      assertIs(zn.start, "options.start", [
        [Object, "{ x: number, y: number }"]
      ]), assertIs(zn.end, "options.end", [
        [Object, "{ x: number, y: number }"]
      ]), assertIs(zn.start.x, "options.start.x", ["number"]), assertIs(zn.start.y, "options.start.y", ["number"]), assertIs(zn.end.x, "options.end.x", ["number"]), assertIs(zn.end.y, "options.end.y", ["number"]), assertOrUndefined(zn.thickness, "options.thickness", ["number"]), assertOrUndefined(zn.color, "options.color", [[Object, "Color"]]), assertOrUndefined(zn.dashArray, "options.dashArray", [Array]), assertOrUndefined(zn.dashPhase, "options.dashPhase", ["number"]), assertIsOneOfOrUndefined(zn.lineCap, "options.lineCap", LineCapStyle), assertRangeOrUndefined(zn.opacity, "opacity.opacity", 0, 1), assertIsOneOfOrUndefined(zn.blendMode, "options.blendMode", BlendMode);
      var ma = this.maybeEmbedGraphicsState({
        borderOpacity: zn.opacity,
        blendMode: zn.blendMode
      });
      "color" in zn || (zn.color = rgb(0, 0, 0));
      var va = this.getContentStream();
      va.push.apply(va, drawLine({
        start: zn.start,
        end: zn.end,
        thickness: (Un = zn.thickness) !== null && Un !== void 0 ? Un : 1,
        color: (Kn = zn.color) !== null && Kn !== void 0 ? Kn : void 0,
        dashArray: (qn = zn.dashArray) !== null && qn !== void 0 ? qn : void 0,
        dashPhase: (Jo = zn.dashPhase) !== null && Jo !== void 0 ? Jo : void 0,
        lineCap: (pa = zn.lineCap) !== null && pa !== void 0 ? pa : void 0,
        graphicsState: ma
      }));
    }, Xn.prototype.drawRectangle = function(zn) {
      var Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta;
      zn === void 0 && (zn = {}), assertOrUndefined(zn.x, "options.x", ["number"]), assertOrUndefined(zn.y, "options.y", ["number"]), assertOrUndefined(zn.width, "options.width", ["number"]), assertOrUndefined(zn.height, "options.height", ["number"]), assertOrUndefined(zn.rotate, "options.rotate", [[Object, "Rotation"]]), assertOrUndefined(zn.xSkew, "options.xSkew", [[Object, "Rotation"]]), assertOrUndefined(zn.ySkew, "options.ySkew", [[Object, "Rotation"]]), assertOrUndefined(zn.borderWidth, "options.borderWidth", ["number"]), assertOrUndefined(zn.color, "options.color", [[Object, "Color"]]), assertRangeOrUndefined(zn.opacity, "opacity.opacity", 0, 1), assertOrUndefined(zn.borderColor, "options.borderColor", [
        [Object, "Color"]
      ]), assertOrUndefined(zn.borderDashArray, "options.borderDashArray", [
        Array
      ]), assertOrUndefined(zn.borderDashPhase, "options.borderDashPhase", [
        "number"
      ]), assertIsOneOfOrUndefined(zn.borderLineCap, "options.borderLineCap", LineCapStyle), assertRangeOrUndefined(zn.borderOpacity, "options.borderOpacity", 0, 1), assertIsOneOfOrUndefined(zn.blendMode, "options.blendMode", BlendMode);
      var Sa = this.maybeEmbedGraphicsState({
        opacity: zn.opacity,
        borderOpacity: zn.borderOpacity,
        blendMode: zn.blendMode
      });
      !("color" in zn) && !("borderColor" in zn) && (zn.color = rgb(0, 0, 0));
      var Ma = this.getContentStream();
      Ma.push.apply(Ma, drawRectangle({
        x: (Un = zn.x) !== null && Un !== void 0 ? Un : this.x,
        y: (Kn = zn.y) !== null && Kn !== void 0 ? Kn : this.y,
        width: (qn = zn.width) !== null && qn !== void 0 ? qn : 150,
        height: (Jo = zn.height) !== null && Jo !== void 0 ? Jo : 100,
        rotate: (pa = zn.rotate) !== null && pa !== void 0 ? pa : degrees(0),
        xSkew: (ma = zn.xSkew) !== null && ma !== void 0 ? ma : degrees(0),
        ySkew: (va = zn.ySkew) !== null && va !== void 0 ? va : degrees(0),
        borderWidth: (ba = zn.borderWidth) !== null && ba !== void 0 ? ba : 0,
        color: (_a = zn.color) !== null && _a !== void 0 ? _a : void 0,
        borderColor: (ya = zn.borderColor) !== null && ya !== void 0 ? ya : void 0,
        borderDashArray: (xa = zn.borderDashArray) !== null && xa !== void 0 ? xa : void 0,
        borderDashPhase: (wa = zn.borderDashPhase) !== null && wa !== void 0 ? wa : void 0,
        graphicsState: Sa,
        borderLineCap: (Ta = zn.borderLineCap) !== null && Ta !== void 0 ? Ta : void 0
      }));
    }, Xn.prototype.drawSquare = function(zn) {
      zn === void 0 && (zn = {});
      var Un = zn.size;
      assertOrUndefined(Un, "size", ["number"]), this.drawRectangle(__assign(__assign({}, zn), { width: Un, height: Un }));
    }, Xn.prototype.drawEllipse = function(zn) {
      var Un, Kn, qn, Jo, pa, ma, va, ba, _a, ya, xa;
      zn === void 0 && (zn = {}), assertOrUndefined(zn.x, "options.x", ["number"]), assertOrUndefined(zn.y, "options.y", ["number"]), assertOrUndefined(zn.xScale, "options.xScale", ["number"]), assertOrUndefined(zn.yScale, "options.yScale", ["number"]), assertOrUndefined(zn.rotate, "options.rotate", [[Object, "Rotation"]]), assertOrUndefined(zn.color, "options.color", [[Object, "Color"]]), assertRangeOrUndefined(zn.opacity, "opacity.opacity", 0, 1), assertOrUndefined(zn.borderColor, "options.borderColor", [
        [Object, "Color"]
      ]), assertRangeOrUndefined(zn.borderOpacity, "options.borderOpacity", 0, 1), assertOrUndefined(zn.borderWidth, "options.borderWidth", ["number"]), assertOrUndefined(zn.borderDashArray, "options.borderDashArray", [
        Array
      ]), assertOrUndefined(zn.borderDashPhase, "options.borderDashPhase", [
        "number"
      ]), assertIsOneOfOrUndefined(zn.borderLineCap, "options.borderLineCap", LineCapStyle), assertIsOneOfOrUndefined(zn.blendMode, "options.blendMode", BlendMode);
      var wa = this.maybeEmbedGraphicsState({
        opacity: zn.opacity,
        borderOpacity: zn.borderOpacity,
        blendMode: zn.blendMode
      });
      !("color" in zn) && !("borderColor" in zn) && (zn.color = rgb(0, 0, 0));
      var Ta = this.getContentStream();
      Ta.push.apply(Ta, drawEllipse({
        x: (Un = zn.x) !== null && Un !== void 0 ? Un : this.x,
        y: (Kn = zn.y) !== null && Kn !== void 0 ? Kn : this.y,
        xScale: (qn = zn.xScale) !== null && qn !== void 0 ? qn : 100,
        yScale: (Jo = zn.yScale) !== null && Jo !== void 0 ? Jo : 100,
        rotate: (pa = zn.rotate) !== null && pa !== void 0 ? pa : void 0,
        color: (ma = zn.color) !== null && ma !== void 0 ? ma : void 0,
        borderColor: (va = zn.borderColor) !== null && va !== void 0 ? va : void 0,
        borderWidth: (ba = zn.borderWidth) !== null && ba !== void 0 ? ba : 0,
        borderDashArray: (_a = zn.borderDashArray) !== null && _a !== void 0 ? _a : void 0,
        borderDashPhase: (ya = zn.borderDashPhase) !== null && ya !== void 0 ? ya : void 0,
        borderLineCap: (xa = zn.borderLineCap) !== null && xa !== void 0 ? xa : void 0,
        graphicsState: wa
      }));
    }, Xn.prototype.drawCircle = function(zn) {
      zn === void 0 && (zn = {});
      var Un = zn.size, Kn = Un === void 0 ? 100 : Un;
      assertOrUndefined(Kn, "size", ["number"]), this.drawEllipse(__assign(__assign({}, zn), { xScale: Kn, yScale: Kn }));
    }, Xn.prototype.setOrEmbedFont = function(zn) {
      var Un = this.font, Kn = this.fontKey;
      zn ? this.setFont(zn) : this.getFont();
      var qn = this.font, Jo = this.fontKey;
      return { oldFont: Un, oldFontKey: Kn, newFont: qn, newFontKey: Jo };
    }, Xn.prototype.getFont = function() {
      if (!this.font || !this.fontKey) {
        var zn = this.doc.embedStandardFont(StandardFonts.Helvetica);
        this.setFont(zn);
      }
      return [this.font, this.fontKey];
    }, Xn.prototype.resetFont = function() {
      this.font = void 0, this.fontKey = void 0;
    }, Xn.prototype.getContentStream = function(zn) {
      return zn === void 0 && (zn = !0), zn && this.contentStream ? this.contentStream : (this.contentStream = this.createContentStream(), this.contentStreamRef = this.doc.context.register(this.contentStream), this.node.addContentStream(this.contentStreamRef), this.contentStream);
    }, Xn.prototype.createContentStream = function() {
      for (var zn = [], Un = 0; Un < arguments.length; Un++)
        zn[Un] = arguments[Un];
      var Kn = this.doc.context.obj({}), qn = PDFContentStream.of(Kn, zn);
      return qn;
    }, Xn.prototype.maybeEmbedGraphicsState = function(zn) {
      var Un = zn.opacity, Kn = zn.borderOpacity, qn = zn.blendMode;
      if (!(Un === void 0 && Kn === void 0 && qn === void 0)) {
        var Jo = this.doc.context.obj({
          Type: "ExtGState",
          ca: Un,
          CA: Kn,
          BM: qn
        }), pa = this.node.newExtGState("GS", Jo);
        return pa;
      }
    }, Xn.prototype.scaleAnnot = function(zn, Un, Kn) {
      for (var qn = ["RD", "CL", "Vertices", "QuadPoints", "L", "Rect"], Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = zn.lookup(PDFName.of(qn[Jo]));
        ma instanceof PDFArray && ma.scalePDFNumbers(Un, Kn);
      }
      var va = zn.lookup(PDFName.of("InkList"));
      if (va instanceof PDFArray)
        for (var Jo = 0, pa = va.size(); Jo < pa; Jo++) {
          var ba = va.lookup(Jo);
          ba instanceof PDFArray && ba.scalePDFNumbers(Un, Kn);
        }
    }, Xn.of = function(zn, Un, Kn) {
      return new Xn(zn, Un, Kn);
    }, Xn.create = function(zn) {
      assertIs(zn, "doc", [[PDFDocument, "PDFDocument"]]);
      var Un = PDFRef.of(-1), Kn = PDFPageLeaf.withContextAndParent(zn.context, Un), qn = zn.context.register(Kn);
      return new Xn(Kn, qn, zn);
    }, Xn;
  }()
), PDFButton = (
  /** @class */
  function(Xn) {
    __extends(zn, Xn);
    function zn(Un, Kn, qn) {
      var Jo = Xn.call(this, Un, Kn, qn) || this;
      return assertIs(Un, "acroButton", [
        [PDFAcroPushButton, "PDFAcroPushButton"]
      ]), Jo.acroField = Un, Jo;
    }
    return zn.prototype.setImage = function(Un, Kn) {
      Kn === void 0 && (Kn = ImageAlignment.Center);
      for (var qn = this.acroField.getWidgets(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo], va = this.createImageAppearanceStream(ma, Un, Kn);
        this.updateWidgetAppearances(ma, { normal: va });
      }
      this.markAsClean();
    }, zn.prototype.setFontSize = function(Un) {
      assertPositive(Un, "fontSize"), this.acroField.setFontSize(Un), this.markAsDirty();
    }, zn.prototype.addToPage = function(Un, Kn, qn) {
      var Jo, pa, ma, va, ba, _a, ya, xa, wa, Ta, Sa;
      assertOrUndefined(Un, "text", ["string"]), assertOrUndefined(Kn, "page", [[PDFPage, "PDFPage"]]), assertFieldAppearanceOptions(qn);
      var Ma = this.createWidget({
        x: ((Jo = qn == null ? void 0 : qn.x) !== null && Jo !== void 0 ? Jo : 0) - ((pa = qn == null ? void 0 : qn.borderWidth) !== null && pa !== void 0 ? pa : 0) / 2,
        y: ((ma = qn == null ? void 0 : qn.y) !== null && ma !== void 0 ? ma : 0) - ((va = qn == null ? void 0 : qn.borderWidth) !== null && va !== void 0 ? va : 0) / 2,
        width: (ba = qn == null ? void 0 : qn.width) !== null && ba !== void 0 ? ba : 100,
        height: (_a = qn == null ? void 0 : qn.height) !== null && _a !== void 0 ? _a : 50,
        textColor: (ya = qn == null ? void 0 : qn.textColor) !== null && ya !== void 0 ? ya : rgb(0, 0, 0),
        backgroundColor: (xa = qn == null ? void 0 : qn.backgroundColor) !== null && xa !== void 0 ? xa : rgb(0.75, 0.75, 0.75),
        borderColor: qn == null ? void 0 : qn.borderColor,
        borderWidth: (wa = qn == null ? void 0 : qn.borderWidth) !== null && wa !== void 0 ? wa : 0,
        rotate: (Ta = qn == null ? void 0 : qn.rotate) !== null && Ta !== void 0 ? Ta : degrees(0),
        caption: Un,
        hidden: qn == null ? void 0 : qn.hidden,
        page: Kn.ref
      }), ka = this.doc.context.register(Ma.dict);
      this.acroField.addWidget(ka);
      var Za = (Sa = qn == null ? void 0 : qn.font) !== null && Sa !== void 0 ? Sa : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(Ma, Za), Kn.node.addAnnot(ka);
    }, zn.prototype.needsAppearancesUpdate = function() {
      var Un;
      if (this.isDirty())
        return !0;
      for (var Kn = this.acroField.getWidgets(), qn = 0, Jo = Kn.length; qn < Jo; qn++) {
        var pa = Kn[qn], ma = ((Un = pa.getAppearances()) === null || Un === void 0 ? void 0 : Un.normal) instanceof PDFStream;
        if (!ma)
          return !0;
      }
      return !1;
    }, zn.prototype.defaultUpdateAppearances = function(Un) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), this.updateAppearances(Un);
    }, zn.prototype.updateAppearances = function(Un, Kn) {
      assertIs(Un, "font", [[PDFFont, "PDFFont"]]), assertOrUndefined(Kn, "provider", [Function]);
      for (var qn = this.acroField.getWidgets(), Jo = 0, pa = qn.length; Jo < pa; Jo++) {
        var ma = qn[Jo];
        this.updateWidgetAppearance(ma, Un, Kn);
      }
    }, zn.prototype.updateWidgetAppearance = function(Un, Kn, qn) {
      var Jo = qn ?? defaultButtonAppearanceProvider, pa = normalizeAppearance(Jo(this, Un, Kn));
      this.updateWidgetAppearanceWithFont(Un, Kn, pa);
    }, zn.of = function(Un, Kn, qn) {
      return new zn(Un, Kn, qn);
    }, zn;
  }(PDFField)
);
class CanvasConverter extends Dependent {
  constructor() {
    super(...arguments);
    /**
     * Добавляем 1 пиксель к ширине и высоте, чтобы избежать артефактов обрезки
     * из-за погрешностей округления в `canvas` и `drawImage`.
     */
    Ca(this, "CANVAS_PADDING_PIXELS", 1);
    Ca(this, "getFirstPageImage", async (Un) => {
      const qn = this.dependencies.canvas.getElement(), Jo = await new Promise((Sa, Ma) => {
        qn.toBlob((ka) => {
          ka ? Sa(ka) : Ma(new Error("Ошибка при создании Blob для всего canvas"));
        }, "image/png");
      }), pa = await createImageBitmap(Jo), ma = Un.getFirstGraphic();
      if (!ma)
        throw new EditorError("Не удалось получить первую страницу");
      const va = ma.getFrameObject(), { left: ba, top: _a, width: ya, height: xa } = va.object, wa = new OffscreenCanvas(
        ya + this.CANVAS_PADDING_PIXELS,
        xa + this.CANVAS_PADDING_PIXELS
      ), Ta = wa.getContext("2d");
      if (!Ta)
        throw new EditorError("Не удалось получить контекст для offscreenCanvas");
      return Ta.drawImage(
        pa,
        ba,
        _a,
        ya + this.CANVAS_PADDING_PIXELS,
        xa + this.CANVAS_PADDING_PIXELS,
        0,
        0,
        ya + this.CANVAS_PADDING_PIXELS,
        xa + this.CANVAS_PADDING_PIXELS
      ), await wa.convertToBlob({ type: "image/png" });
    });
  }
  /**
   * Конвертирует содержимое `fabric.js`-холста в PDF.
   * @param component - Компонент книги, содержащий графику.
   * @returns `Blob` с PDF-документом.
   */
  async getBookPdfBlob(Un) {
    const Kn = await PDFDocument.create(), qn = Un.getGraphics();
    for (let Ma = 0; Ma < qn.length; Ma++)
      Kn.addPage();
    const Jo = Kn.getPages(), pa = this.dependencies.canvas.getElement(), ma = await new Promise((Ma, ka) => {
      pa.toBlob((Za) => {
        Za ? Ma(Za) : ka(new Error("Ошибка при создании Blob для всего canvas"));
      }, "image/png");
    }), va = qn.map(async (Ma) => {
      const ka = Ma.getGraphicObject(), { left: Za, top: Na, width: Ka, height: Ja } = ka.object, el = await createImageBitmap(ma), qa = new OffscreenCanvas(
        Ka + this.CANVAS_PADDING_PIXELS,
        Ja + this.CANVAS_PADDING_PIXELS
      ), tl = qa.getContext("2d");
      if (!tl)
        throw new Error("Не удалось получить контекст для offscreenCanvas");
      return tl.drawImage(
        el,
        Za,
        Na,
        Ka + this.CANVAS_PADDING_PIXELS,
        Ja + this.CANVAS_PADDING_PIXELS,
        0,
        0,
        Ka + this.CANVAS_PADDING_PIXELS,
        Ja + this.CANVAS_PADDING_PIXELS
      ), await qa.convertToBlob({ type: "image/png" });
    }), ba = await Promise.all(va), ya = (await Promise.all(ba)).map((Ma) => Ma.arrayBuffer()), wa = (await Promise.all(ya)).map((Ma) => Kn.embedPng(Ma));
    (await Promise.all(wa)).forEach((Ma, ka) => {
      const { width: Za, height: Na } = Jo[ka].getSize(), Ka = Za / Ma.width, Ja = Na / Ma.height, el = Math.min(Ka, Ja), qa = Ma.width * el, tl = Ma.height * el;
      Jo[ka].drawImage(Ma, {
        x: 0,
        y: Na - tl,
        // Корректируем y с учетом перевернутых координат
        width: qa,
        height: tl
      });
    });
    const Sa = await Kn.save();
    return new Blob([Sa], { type: "application/pdf" });
  }
}
class ContentConverterEditor extends VisualizerEditor {
  constructor(Un) {
    const Kn = document.createElement("div");
    Kn.style.position = "absolute", Kn.style.top = `-${Number.MAX_SAFE_INTEGER}px`, Kn.style.left = `-${Number.MAX_SAFE_INTEGER}px`, document.body.append(Kn);
    const qn = {
      editorContainer: Kn,
      imageFileSourcePrefix: Un.imageFileSourcePrefix,
      isEnableMouseWheel: Un.isEnableMouseWheel,
      isCanvasHeightAdaptive: Un.isCanvasHeightAdaptive
    };
    super(qn);
    Ca(this, "canvasConverter");
    Ca(this, "savePdf", async (Un) => new Promise((Kn) => {
      requestAnimationFrame(() => {
        const qn = this.componentTree.getRootComponent();
        this.canvasConverter.getBookPdfBlob(qn).then((Jo) => {
          const pa = document.createElement("a");
          pa.href = window.URL.createObjectURL(Jo), pa.download = Un, pa.click(), this.editorContainer.remove(), Kn();
        });
      });
    }));
    Ca(this, "getFirstPageImage", () => new Promise((Un) => {
      requestAnimationFrame(() => {
        const Kn = this.componentTree.getRootComponent();
        Un(this.canvasConverter.getFirstPageImage(Kn)), this.editorContainer.remove();
      });
    }));
    Ca(this, "postSetStructureListener", () => {
      this.canvasConverter.forceInjectDependencies({ canvas: this.canvas });
    });
    this.canvasConverter = new CanvasConverter(), this.addPostSetStructureListener(this.postSetStructureListener);
  }
}
class PrivateTemplateEditor extends DynamicEditor {
  constructor(Un) {
    super(Un.editorContainer);
    Ca(this, "state");
    Ca(this, "cursorView");
    Ca(this, "actionStore");
    Ca(this, "textImporter");
    Ca(this, "ui");
    Ca(this, "moduleBuilder");
    Ca(this, "magneticLines");
    Ca(this, "cursor");
    Ca(this, "copyController");
    Ca(this, "bookOrganizer");
    Ca(this, "editModeContext");
    Ca(this, "injectorFactory");
    Ca(this, "componentCloner");
    Ca(this, "pictureImporter");
    Ca(this, "pictureReplacer");
    Ca(this, "pasteController");
    Ca(this, "tableGridMutator");
    Ca(this, "componentBuilder");
    Ca(this, "componentGrouper");
    Ca(this, "actionController");
    Ca(this, "actionRepository");
    Ca(this, "selectionArea");
    Ca(this, "htmlTableImporter");
    Ca(this, "htmlTableReplacer");
    Ca(this, "componentInjector");
    Ca(this, "modulePlaceHolder");
    Ca(this, "keyboardVisualizer");
    Ca(this, "contextMenu");
    Ca(this, "textActionInitiator");
    Ca(this, "componentOrganizer");
    Ca(this, "keyboardObserver");
    Ca(this, "useCases");
    Ca(this, "componentTree");
    Ca(this, "layerRegistry");
    Ca(this, "graphicFactory");
    /**
     * Отключает фокус у кнопки открытия AI
     */
    Ca(this, "disableFocusAIModal", () => {
      this.ui.disableFocusAIModal();
    });
    /**
     * Вставляет модуль в редактор шаблона.
     *
     * @param {AnyComponentStructure} structure - Структура компонента, который необходимо вставить.
     */
    Ca(this, "injectModule", async (Un) => {
      await this.useCases.injectModule(Un);
    });
    /**
     * Создает таблицу с полученным кол-вом строк и столбцов.
     * @param columnCount - кол-во столбцов.
     * @param rowCount - кол-во строк.
     */
    Ca(this, "createTable", (Un, Kn) => {
      this.useCases.createEmptyTable(Kn, Un);
    });
    /**
     * Устанавливает состояние загрузки сохранения шаблона.
     */
    Ca(this, "setStateLoadingSaveTemplate", () => {
      this.ui.setStateLoadingSaveTemplate();
    });
    /**
     * Устанавливает состояние успешного сохранения шаблона.
     */
    Ca(this, "setStateSuccessSaveTemplate", () => {
      this.ui.setStateSuccessSaveTemplate();
    });
    /**
     * Устанавливает состояние ошибки сохранения шаблона.
     */
    Ca(this, "setStateErrorSaveTemplate", () => {
      this.ui.setStateErrorSaveTemplate();
    });
    /**
     * Устанавливает структуру шаблона редактора и обновляет отображение.
     *
     * Этот метод загружает переданную структуру, устанавливает её идентификатор и имя,
     * затем обновляет дерево компонентов и интерфейс редактора.
     *
     * @param editorStructure - Объект структуры редактора, содержащий конфигурацию и содержимое.
     */
    Ca(this, "setStructure", async (Un) => {
      const Kn = _$2.cloneDeep(Un), { id: qn, name: Jo } = Kn;
      this.setID(qn), this.setName(Jo), this.state.setSketchID(qn), this.componentCloner.forceInjectDependencies({
        toPasteSketchID: qn,
        componentTree: this.componentTree,
        graphicFactory: this.graphicFactory,
        componentFactory: this.componentFactory,
        mouseObserver: this.canvasMouseObserver
      }), await this.componentTree.load(Kn.root);
      const pa = this.componentTree.getRootComponent();
      this.bookOrganizer.connectDependencies({
        book: pa,
        render: this.canvasRender,
        canvas: this.canvas
      }), this.bookOrganizer.injectDependencies(), this.addPostResizeWindowListener(this.bookOrganizer.sync), this.canvasRender.render(), this.uiRender.render(), pa.syncPagePanels(), this.bookOrganizer.sync(), await this.areaController.sync(), this.state.syncState(), this.ui.setNameTemplate(Kn.name), await this.ui.sync(), this.uiRender.render(), await this.ui.sync(), this.layerVisualizer.sync(), this.callPostSetStructureListeners();
    });
    Ca(this, "savePreview", async (Un, Kn) => {
      const qn = new ContentConverterEditor({
        imageFileSourcePrefix: Un,
        isEnableMouseWheel: !1,
        isCanvasHeightAdaptive: !0
      }), Jo = this.getStructure();
      await qn.setStructure(Jo);
      const pa = await qn.getFirstPageImage();
      Kn(pa);
    });
    this.state = new SketchState(), this.actionStore = new ActionStore(), this.textImporter = new TextImporter(), this.ui = new PrivateTemplateDesktopUI(), this.moduleBuilder = new ModuleBuilder(), this.cursor = new PrivateTemplateCursor(), this.layerRegistry = new BookLayerRegistry(), this.editModeContext = new EditModeContext(), this.injectorFactory = new InjectorFactory(), this.pictureImporter = new PictureImporter(), this.pictureReplacer = new PictureReplacer(), this.actionRepository = new ActionRepository(), this.bookOrganizer = new BookModeOrganizer(), this.textActionInitiator = new TextActionInitiator(), this.useCases = new PrivateTemplateUseCases(), this.tableGridMutator = new TableGridMutator(), this.copyController = new CopyController(), this.pasteController = new PasteController(), this.selectionArea = new ComponentSelectorArea(), this.componentInjector = new ComponentInjector(), this.htmlTableImporter = new HTMLTableImporter(), this.htmlTableReplacer = new HTMLTableReplacer(), this.graphicFactory = new DynamicGraphicFactory(), this.componentBuilder = new ComponentBuilder(), this.magneticLines = new MagneticLines(), this.componentOrganizer = new BookComponentOrganizer(), this.componentGrouper = new ComponentGrouper(), this.actionController = new ActionController(), this.contextMenu = new PrivateTemplateContextMenu(), this.modulePlaceHolder = new ModulePlaceholder(), this.componentTree = new DynamicComponentTree(), this.cursorView = new CursorView(Un.editorContainer);
    const Kn = this.layerRegistry.getTree();
    this.componentOrganizer.addPostSyncListener(this.bookOrganizer.sync), this.componentOrganizer.addPostSyncListener(this.layerVisualizer.sync), this.componentOrganizer.addPostSyncListener(this.pageTextOverflowObserver.sync), this.componentOrganizer.addPostSyncListener(this.componentTree.syncUniterComponentsSize), this.canvasSpatialGridVisualizer.addPostUpdateVisibilityListener(this.canvasRender.render), this.uiSpatialGridVisualizer.addPostUpdateVisibilityListener(this.uiRender.render), this.wheelObserver.subscribe(this.areaWheelObserver.onMouseWheel), this.areaWheelObserver.subscribeGlobalWheel(this.camera.move), this.touchObserver.subscribe(this.camera.move), this.camera.addPostUpdateViewListeners(this.canvasRender.renderUnstructured), this.selectionArea.addPostUpdateAreaListener(this.canvasRender.renderUnstructured), this.componentCloner = new ComponentCloner(), this.actionStore.addPostUndoRedoListener(this.canvasAreaController.sync), this.actionStore.addPostUndoRedoListener(this.canvasRender.render), this.actionStore.addPostUndoRedoListener(this.actionVisualizer.sync), this.actionRepository.addPostMoveTimeLineCursorListener(this.actionVisualizer.sync), this.actionController.addPostStopActionListener(this.actionVisualizer.sync), this.actionController.addPostStartActionListener(this.actionVisualizer.sync), this.keyboardObserver = new PrivateTemplateKeyboardObserver(), this.keyboardVisualizer = new KeyboardVisualizer(this.keyboardObserver), this.addEnableInteractiveListener(this.keyboardObserver.construct), this.addDisableInteractiveListener(this.keyboardObserver.destruct), this.keyboardVisualizer.addPostSyncListener(this.uiRender.render), this.keyboardObserver.addPostChangeActiveKeysListener(this.keyboardVisualizer.sync), this.carriageCoordinator.addPostChangeCarriageRangeListener(this.textSelectionVisualizer.sync), this.pageStructureObserver.subscribe(
      () => this.savePreview(Un.imageFileSourcePrefix, Un.onUpdateTemplatePreview)
    ), this.ui.connectDependencies({
      render: this.uiRender,
      useCases: this.useCases,
      textEngine: this.textEngine,
      onBackPage: Un.onBackPage,
      actionStore: this.actionStore,
      actionController: this.actionController,
      contextMenu: this.contextMenu,
      componentTree: this.componentTree,
      onSendOffer: Un.onSendOffer,
      onDownloadPDF: Un.onDownloadPDF,
      onOpenModulesModal: Un.onOpenModulesWindow,
      onOpenCreateCustomTableWindow: Un.onOpenCreateCustomTableWindow,
      onGoToTariff: Un.onGoToTariff,
      onGetGenerationHintStructure: Un.onGetGenerationHintStructure,
      onSetNameTemplate: this.setName,
      onOpenAIActionsModal: Un.onOpenAIActionsModal,
      onCloseAIActionsModal: Un.onCloseAIActionsModal
    }), this.magneticLines.connectDependencies({
      componentTree: this.componentTree
    }), this.actionVisualizer.connectDependencies({
      render: this.uiRender,
      actionRepository: this.actionRepository,
      actionController: this.actionController
    }), this.cursor.connectDependencies({
      ui: this.ui,
      editor: this,
      useCases: this.useCases,
      render: this.canvasRender,
      cursorView: this.cursorView,
      textEngine: this.textEngine,
      contextMenu: this.contextMenu,
      componentTree: this.componentTree,
      selectionArea: this.selectionArea,
      magneticLines: this.magneticLines,
      areaController: this.areaController,
      editModeContext: this.editModeContext,
      editorContainer: this.editorContainer,
      uiMouseObserver: this.uiMouseObserver,
      actionController: this.actionController,
      keyboardObserver: this.keyboardObserver,
      componentInjector: this.componentInjector,
      componentOrganizer: this.componentOrganizer,
      carriageCoordinator: this.carriageCoordinator,
      canvasMouseObserver: this.canvasMouseObserver,
      textSelectionObserver: this.textSelectionObserver,
      pageStructureObserver: this.pageStructureObserver,
      pageTextOverflowObserver: this.pageTextOverflowObserver
    }), this.pageTextOverflowObserver.connectDependencies({
      componentTree: this.componentTree
    }), this.carriageCoordinator.connectDependencies({
      render: this.canvasRender
    }), this.textEngine.connectDependencies({
      keyboardObserver: this.keyboardObserver,
      actionController: this.actionController,
      renders: [this.canvasRender, this.uiRender],
      textActionInitiator: this.textActionInitiator,
      textEventGenerator: this.textEventGenerator,
      carriageCoordinator: this.carriageCoordinator
    }), this.pageStructureObserver.connectDependencies({
      componentTree: this.componentTree
    }), this.selectionArea.connectDependencies({
      areaController: this.canvasAreaController,
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.contextMenu.connectDependencies({
      render: this.uiRender,
      useCases: this.useCases,
      areaController: this.areaController,
      uiMouseObserver: this.uiMouseObserver,
      ui: this.ui
    }), this.layerVisualizer.connectDependencies({
      tree: Kn,
      render: this.uiRender,
      canvas: this.uiCanvas
    }), this.componentFactory.connectDependencies({
      useCases: this.useCases,
      textEngine: this.textEngine,
      componentTree: this.componentTree,
      actionController: this.actionController,
      areaController: this.canvasAreaController,
      pageStructureObserver: this.pageStructureObserver
    }), this.textImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.pictureImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.canvasAreaController.connectDependencies({
      tree: this.canvasSpatialGrid,
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.uiAreaController.connectDependencies({
      ui: this.ui,
      tree: this.uiSpatialGrid,
      uiMouseObserver: this.uiMouseObserver
    }), this.pictureReplacer.connectDependencies({
      pictureImporter: this.pictureImporter,
      sketchStabilizer: this.actionController
    }), this.htmlTableImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      componentOrganizer: this.componentOrganizer,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.htmlTableReplacer.connectDependencies({
      htmlTableImporter: this.htmlTableImporter,
      componentOrganizer: this.componentOrganizer,
      sketchStabilizer: this.actionController
    }), this.layerRegistry.connectDependencies({
      componentTree: this.componentTree
    }), this.copyController.connectDependencies({
      textEngine: this.textEngine,
      textImporter: this.textImporter,
      componentCloner: this.componentCloner
    }), this.pasteController.connectDependencies({
      textEngine: this.textEngine,
      textImporter: this.textImporter,
      componentTree: this.componentTree,
      graphicFactory: this.graphicFactory,
      pictureImporter: this.pictureImporter,
      pictureReplacer: this.pictureReplacer,
      componentCloner: this.componentCloner,
      componentFactory: this.componentFactory,
      componentInjector: this.componentInjector,
      mouseObserver: this.canvasMouseObserver,
      htmlTableImporter: this.htmlTableImporter,
      htmlTableReplacer: this.htmlTableReplacer
    }), this.actionController.connectDependencies({
      state: this.state,
      actionStore: this.actionStore,
      sendCommands: Un.sendCommands,
      componentTree: this.componentTree,
      areaController: this.canvasAreaController,
      getConstructorConnectionStatus: Un.getServerConnectionStatus
    }), this.injectorFactory.connectDependencies({
      render: this.canvasRender,
      cursorView: this.cursorView,
      componentTree: this.componentTree,
      componentAlignment: this.componentAlignment,
      canvasMouseObserver: this.canvasMouseObserver,
      modulePlaceHolder: this.modulePlaceHolder
    }), this.componentOrganizer.connectDependencies({
      componentTree: this.componentTree,
      bookOrganizer: this.bookOrganizer
    }), this.componentTree.connectDependencies({
      render: this.canvasRender,
      layerRegistry: this.layerRegistry,
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory
    }), this.keyboardObserver.connectDependencies({
      useCases: this.useCases,
      componentTree: this.componentTree,
      textEventGenerator: this.textEventGenerator
    }), this.moduleBuilder.connectDependencies({
      componentTree: this.componentTree,
      graphicFactory: this.graphicFactory,
      componentBuilder: this.componentBuilder,
      componentFactory: this.componentFactory
    }), this.useCases.connectDependencies({
      ui: this.ui,
      textEngine: this.textEngine,
      actionStore: this.actionStore,
      canvasRender: this.canvasRender,
      componentTree: this.componentTree,
      bookOrganizer: this.bookOrganizer,
      moduleBuilder: this.moduleBuilder,
      componentCloner: this.componentCloner,
      uploadImageFile: Un.uploadImageFile,
      componentGrouper: this.componentGrouper,
      tableGridMutator: this.tableGridMutator,
      copyController: this.copyController,
      pasteController: this.pasteController,
      actionController: this.actionController,
      onUploadXlsxFile: Un.uploadXlsxFile,
      componentInjector: this.componentInjector,
      areaController: this.canvasAreaController,
      componentOrganizer: this.componentOrganizer,
      componentAlignment: this.componentAlignment,
      canvasMouseObserver: this.canvasMouseObserver,
      carriageCoordinator: this.carriageCoordinator,
      textActionInitiator: this.textActionInitiator,
      imageFileSourcePrefix: Un.imageFileSourcePrefix,
      onOpenCreateModuleWindow: Un.openCreateModuleWindow
    }), this.canvasSpatialGridVisualizer.connectDependencies({
      spatialGrid: this.canvasSpatialGrid
    }), this.uiSpatialGridVisualizer.connectDependencies({
      spatialGrid: this.uiSpatialGrid
    }), this.objectOrganizer.connectDependencies({
      ui: this.ui,
      layerRegistry: this.layerRegistry,
      magneticLines: this.magneticLines,
      componentInjector: this.componentInjector,
      componentSelectionArea: this.selectionArea,
      quadTreeVisualizer: this.canvasSpatialGridVisualizer,
      textSelectionVisualizer: this.textSelectionVisualizer
    }), this.uiObjectOrganizer.connectDependencies({
      ui: this.ui,
      layerVisualizer: this.layerVisualizer,
      actionVisualizer: this.actionVisualizer,
      keyboardVisualizer: this.keyboardVisualizer,
      quadTreeVisualizer: this.uiSpatialGridVisualizer
    }), this.modulePlaceHolder.connectDependencies({
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.componentInjector.connectDependencies({
      injectorFactory: this.injectorFactory
    }), this.state.connectDependencies({
      editor: this,
      componentTree: this.componentTree
    }), this.actionStore.connectDependencies({
      repository: this.actionRepository,
      actionController: this.actionController
    }), this.componentGrouper.connectDependencies({
      componentTree: this.componentTree,
      componentBuilder: this.componentBuilder
    }), this.graphicFactory.connectDependencies({
      ui: this.ui,
      camera: this.camera,
      useCases: this.useCases,
      render: this.canvasRender,
      componentTree: this.componentTree,
      layerRegistry: this.layerRegistry,
      areaController: this.canvasAreaController,
      imageFileSourcePrefix: Un.imageFileSourcePrefix
    }), this.textActionInitiator.connectDependencies({
      actionController: this.actionController
    }), this.componentBuilder.connectDependencies({
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory
    }), this.canvasRender.connectDependencies({
      canvas: this.canvas,
      layerRegistry: this.layerRegistry,
      canvasObjectOrganizer: this.objectOrganizer
    }), this.uiRender.connectDependencies({
      ui: this.ui,
      canvas: this.uiCanvas,
      uiObjectOrganizer: this.uiObjectOrganizer
    }), this.camera.connectDependencies({
      componentTree: this.componentTree
    }), this.areaWheelObserver.connectDependencies({
      areaController: this.areaController
    }), this.ui.injectDependencies(), this.camera.injectDependencies(), this.componentTree.injectDependencies(), this.state.injectDependencies(), this.actionStore.injectDependencies(), this.canvasAreaController.injectDependencies(), this.uiAreaController.injectDependencies(), this.objectOrganizer.injectDependencies(), this.layerRegistry.injectDependencies(), this.textImporter.injectDependencies(), this.uiObjectOrganizer.injectDependencies(), this.cursor.injectDependencies(), this.pictureImporter.injectDependencies(), this.injectorFactory.injectDependencies(), this.keyboardObserver.injectDependencies(), this.componentGrouper.injectDependencies(), this.componentInjector.injectDependencies(), this.canvasSpatialGridVisualizer.injectDependencies(), this.uiSpatialGridVisualizer.injectDependencies(), this.graphicFactory.injectDependencies(), this.pageStructureObserver.injectDependencies(), this.pasteController.injectDependencies(), this.canvasRender.injectDependencies(), this.layerVisualizer.injectDependencies(), this.actionController.injectDependencies(), this.pageTextOverflowObserver.injectDependencies(), this.useCases.injectDependencies(), this.textActionInitiator.injectDependencies(), this.htmlTableImporter.injectDependencies(), this.carriageCoordinator.injectDependencies(), this.htmlTableReplacer.injectDependencies(), this.selectionArea.injectDependencies(), this.textEngine.injectDependencies(), this.contextMenu.injectDependencies(), this.uiRender.injectDependencies(), this.moduleBuilder.injectDependencies(), this.modulePlaceHolder.injectDependencies(), this.componentOrganizer.injectDependencies(), this.areaWheelObserver.injectDependencies(), this.ui.setActiveTariff(Un.isEnableTopBarTariffLabel), this.componentInjector.addPostUpdateAreaListener(this.canvasRender.render), this.addPostResizeWindowListener(this.layerVisualizer.sync), this.addPostResizeWindowListener(this.adaptCanvas), this.addPostResizeWindowListener(this.adaptUICanvas), this.addPostResizeWindowListener(this.ui.sync), this.addPostResizeWindowListener(this.ui.sync), this.addPostResizeWindowListener(this.canvasSpatialGridVisualizer.sync), this.addPostResizeWindowListener(this.areaController.updateAreaPosition), this.addPostResizeWindowListener(this.uiSpatialGridVisualizer.sync), this.addDestructListener(this.wheelObserver.destruct), this.addDestructListener(this.touchObserver.destruct), this.addDestructListener(this.cursor.destruct), this.addDestructListener(this.keyboardObserver.destruct), this.debugEntities.push(this.keyboardVisualizer, this.actionVisualizer), Un.enableDebugMenu && this.enableGUI();
  }
}
class OrganizerModuleEditor {
}
class WorkshopModuleEditor {
}
class OfferSettingsEditor {
}
class WorkshopTemplateCursor extends Cursor {
  constructor() {
    super();
    Ca(this, "magneticPositionCorrector");
    Ca(this, "areaPositionMutator");
    Ca(this, "magneticSizeCorrector");
    Ca(this, "onMouseMove", async (Un, Kn) => {
      const qn = this.dependencies.componentTree.getComponents();
      await this.dependencies.areaController.sync();
      const Jo = this.dependencies.areaController.getActiveArea();
      this.syncHover(Jo, qn), this.isRunningMutationComponent() ? this.dependencies.cursorView.setActiveArea(null) : this.dependencies.cursorView.setActiveArea(Jo), await this.areaSizeMutator.mutate(Un, Kn), await this.tableColumnMutator.mutate(Un, Kn), await this.areaPositionMutator.mutate(Un, Kn), this.cellSelectionObserver.move(Un, Kn, Jo), this.dependencies.textSelectionObserver.move(Un, Kn), this.dependencies.render.renderUnstructured();
    });
    Ca(this, "onMouseLeftDown", async (Un) => {
      if (this.dependencies.componentInjector.isInjecting()) {
        if (!this.dependencies.componentInjector.isReadyInject()) {
          this.dependencies.componentInjector.onMouseDown(), this.dependencies.contextMenu.hide();
          return;
        }
        await this.dependencies.componentInjector.inject(), this.dependencies.contextMenu.hide();
        return;
      }
      const qn = this.dependencies.componentTree.getComponents(), Jo = this.dependencies.canvasMouseObserver.getCurrentPosition();
      await this.dependencies.areaController.sync();
      const pa = this.dependencies.areaController.getActiveArea();
      if (this.syncFocusMouseDown(pa, Un), this.syncEditMode(pa, qn, Un), await this.dependencies.ui.sync(), pa === null) {
        this.dependencies.componentTree.hasEditableOrFocusComponent() || this.dependencies.selectionArea.start(Jo), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.isResizeType()) {
        this.areaSizeMutator.start(pa), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.type === SpatialCanvasAreaType.TABLE_COLUMN_RESIZE) {
        this.tableColumnMutator.start(pa), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.type === SpatialCanvasAreaType.TABLE_CELL && this.cellSelectionObserver.start(pa), this.areaTypeAnalyzer.isSpatialUIAreaType(pa.type)) {
        const ma = pa.getData();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
        if (pa.type === SpatialUIAreaType.COLOREX_COLOR)
          pa.callClick();
        else if (pa.type === SpatialUIAreaType.INPUT) {
          ma.callClick();
          const va = this.dependencies.uiMouseObserver.getCurrentPosition(), ba = ma.getGlobalPosition();
          this.dependencies.carriageCoordinator.pounceToMouse(ma, ma, ba, va), this.dependencies.textSelectionObserver.start([pa], ma.getTextModel(), va);
        } else
          ma.callClick();
        this.dependencies.contextMenu.hide();
      } else if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(pa.type)) {
        const ma = pa.getData();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
        const va = ma.graphic.type;
        if (pa.type === SpatialCanvasAreaType.BUTTON && pa.getButton().callClick(), va === GraphicType.PAGE && pa.type !== SpatialCanvasAreaType.BUTTON && this.areaPositionMutator.startMoveComponents(pa, [this.dependencies.componentTree.getRootComponent()]), va === GraphicType.TEXT && ma.graphic.isEnableEditMode()) {
          const _a = ma.graphic.getGlobalPosition();
          this.dependencies.carriageCoordinator.pounceToMouse(
            ma.graphic.getParentComponent(),
            ma.graphic,
            _a,
            Jo
          );
          const ya = ma.graphic.getParentComponent();
          if (ya === null)
            throw this.dependencies.contextMenu.hide(), new EditorError("component is null");
          const wa = ya.getGraphics().map((Ta) => new SpatialGraphicArea(Ta));
          this.dependencies.textSelectionObserver.start(wa, ya.getTextModel(), Jo);
        }
        if (pa.type === SpatialCanvasAreaType.TABLE_CELL && ma.graphic.isEnableEditMode()) {
          const _a = ma.graphic.getGlobalPosition(), xa = pa.getData();
          this.dependencies.carriageCoordinator.pounceToMouse(
            ma.areaCellContext,
            ma.areaCell,
            _a,
            Jo
          );
          const wa = xa.component.getSpatialAreas().filter(
            (Sa) => Sa.type === SpatialCanvasAreaType.TABLE_CELL && Sa.getData().areaCellContext === ma.areaCellContext
          ), Ta = xa.areaCellContext.getTextModel();
          wa.length !== 0 && this.dependencies.textSelectionObserver.start(wa, Ta, Jo);
        }
        const ba = this.dependencies.componentTree.getFocusComponents();
        if (ba === null) {
          this.dependencies.contextMenu.hide();
          return;
        }
        this.areaPositionMutator.startMoveComponents(pa, ba), this.dependencies.contextMenu.hide();
      }
    });
    Ca(this, "onMouseLeftUp", async (Un) => {
      const Kn = this.dependencies.areaController.getActiveArea();
      await this.dependencies.componentInjector.onMouseUp(), this.dependencies.textSelectionObserver.stop(), this.syncFocusMouseUp(Kn, Un), this.areaSizeMutator.stop(), this.tableColumnMutator.stop(), this.areaPositionMutator.stop(), await this.cellSelectionObserver.stop(), this.dependencies.selectionArea.stop(), await this.dependencies.componentOrganizer.sync(), await this.dependencies.areaController.sync(), await this.dependencies.ui.sync();
    });
    Ca(this, "onMouseRightDown", (Un) => {
      Un.preventDefault(), this.dependencies.contextMenu.show();
    });
    // TODO Доделать
    /**
     * Обновляет эффекты наведения на компоненты в зависимости от положения курсора.
     */
    Ca(this, "syncHover", (Un, Kn) => {
      if (Un === null) {
        this.dependencies.ui.getUIElementsAll().forEach((Jo) => {
          Jo.disableHover();
        }), Kn == null || Kn.forEach((Jo) => {
          Jo.disableHover(), Jo.type === EditorComponentType.BOOK && Jo.getGraphics().forEach((ma) => {
            ma.pageHeaderDisableHover();
          });
        });
        return;
      }
      if (this.isRunningMutationComponent()) {
        Kn == null || Kn.forEach((qn) => {
          qn.disableHover();
        });
        return;
      }
      if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
        const qn = Un;
        if (qn.type === SpatialCanvasAreaType.BUTTON) {
          Un.getButton().enableHover();
          return;
        }
        const pa = qn.getData().graphic.getParentComponent();
        if (pa === null)
          throw new EditorError("crossed component not found");
        if (Kn === null)
          throw new EditorError("components is null");
        if (pa.type !== EditorComponentType.BOOK) {
          const ma = pa.getParentComponent();
          if (ma === null)
            throw new EditorError("parent component not found");
          if (ma.isUniter && this.dependencies.keyboardObserver.isPressed(KeyCode.CONTROL_LEFT)) {
            Kn.forEach((va) => {
              if (va === ma) {
                va.enableHover();
                return;
              }
              va.disableHover();
            });
            return;
          }
        }
        Kn.forEach((ma) => {
          if (ma === pa) {
            ma.enableHover();
            return;
          }
          ma.disableHover();
        });
      } else if (this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) {
        Kn == null || Kn.forEach((ma) => {
          ma.disableHover(), ma.type === EditorComponentType.BOOK && ma.getGraphics().forEach((ba) => {
            ba.pageHeaderDisableHover();
          });
        });
        const Jo = Un.getData();
        this.dependencies.ui.getUIElementsAll().forEach((ma) => {
          if (ma === Jo) {
            ma.enableHover();
            return;
          }
          ma.disableHover();
        });
      } else
        throw new EditorError("spatial area type not identity");
    });
    /**
     * Отключает фокус у компонентов в фокусе.
     * @param ev Событие мыши.
     */
    Ca(this, "disableFocusComponents", (Un) => {
      const Kn = this.dependencies.componentTree.getFocusComponents();
      Kn == null || Kn.forEach((qn) => {
        Un.altKey || Un.metaKey || qn.disableFocus();
      });
    });
    /**
     * Отключает фокус у компонентов в фокусе.
     * @param activeArea
     */
    Ca(this, "disableFocusUIElements", (Un) => {
      this.dependencies.ui.getFocusUIElements().forEach((qn) => {
        this.shouldKeepFocus(qn, Un) || qn.disableFocus();
      });
    });
    /**
     * Проверяет должен ли отключится фокус у элемента.
     * @param element
     * @param activeArea
     */
    Ca(this, "shouldKeepFocus", (Un, Kn) => {
      if (!Un.isEnableResetFocus())
        return !0;
      if (Kn === null)
        return !Un.isEnableResetFocus();
      const qn = Kn.getData(), { type: Jo } = Kn;
      return qn instanceof TopTitleInput && (Un instanceof TopTitleInput || Un instanceof TopRenameButton) || qn instanceof TopRenameButton && (Un instanceof TopTitleInput || Un instanceof TopRenameButton) || (qn instanceof LeftBottomInput || qn instanceof LeftTopInput || qn instanceof RightBottomInput || qn instanceof RightTopInput) && Un instanceof ObjectCornerRadiusButton || qn === Un || Jo === SpatialUIAreaType.EDIT_CORNER ? !0 : Jo === SpatialUIAreaType.PALETTE || Jo === SpatialUIAreaType.COLOREX_COLOR;
    });
    /**
     * Синхронизирует фокус компонентов при отжатии кнопки мыши.
     * @param activeArea
     * @param ev
     */
    Ca(this, "syncFocusMouseUp", (Un, Kn) => {
      if (Un !== null) {
        if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
          const pa = Un.getData().graphic.getParentComponent();
          if (pa === null)
            return;
          if (this.areaPositionMutator.isRunningMutate() && !this.areaPositionMutator.isBlindZoneOverstepping()) {
            const ma = this.dependencies.componentTree.getFocusComponents();
            ma !== null && ma.forEach((va) => {
              Kn.altKey || Kn.metaKey || va !== pa && va.disableFocus();
            });
          }
        } else if (!this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) throw new EditorError("spatial area type not identity");
      }
    });
    /**
     * Обновляет состояния режима редактирования у компонентов.
     */
    Ca(this, "syncEditMode", (Un, Kn, qn) => {
      if (Un === null) {
        Kn.forEach((Jo) => Jo.disableEditMode());
        return;
      }
      if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
        const Jo = Un, ma = Jo.getData().graphic.getParentComponent();
        if (ma === null || Jo.type === SpatialCanvasAreaType.BUTTON)
          return;
        if (ma && qn.type === MouseEventType.DOUBLE_CLICK) {
          ma.enableEditMode(), ma.isUniter && this.dependencies.editModeContext.setCurrentEditContext(ma);
          return;
        }
        if (qn.type === MouseEventType.MOUSE_DOWN) {
          let va = this.dependencies.editModeContext.getCurrentEditContext();
          va && (!ma || !va.isIncludeComponent(ma)) && (this.dependencies.editModeContext.setCurrentEditContext(null), va = null), Kn.forEach((ba) => {
            ba !== va && ba !== ma && ba.disableEditMode();
          });
        }
      } else if (!this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) throw new EditorError("spatial area type not identity");
    });
    /**
     * Обработчик события двойного нажатия мыши.
     * @param ev Событие мыши.
     */
    Ca(this, "onDoubleClick", (Un) => {
      const Kn = this.dependencies.componentTree.getComponents(), qn = this.dependencies.areaController.getActiveArea();
      if (this.syncEditMode(qn, Kn, Un), qn === null)
        return;
      const Jo = qn.getData();
      if (Jo === null)
        throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
      if (Jo.graphic.type === GraphicType.TEXT && Jo.graphic.isEnableEditMode()) {
        const ma = Jo.graphic.getParentComponent();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("component is null");
        this.dependencies.textSelectionObserver.selectWordToCarriagePosition(ma.getTextModel());
      }
    });
    /**
     * Обработчик события начала отрисовки магнитных линий.
     * @param props
     */
    Ca(this, "onStartMagneticLines", (Un) => {
      this.dependencies.componentTree.hasEditableComponent() || (this.dependencies.magneticLines.start(Un), this.dependencies.render.render());
    });
    /**
     * Возвращает происходит ли в данные момент мутация какого либо компонента.
     */
    Ca(this, "isRunningMutationComponent", () => !!(this.areaPositionMutator.isRunningMutate() || this.areaSizeMutator.isRunningMutate() || this.tableColumnMutator.isRunningMutate()));
    this.magneticPositionCorrector = new MagneticPositionCorrector(), this.areaPositionMutator = new AreaPositionWithCloneMutator(), this.magneticSizeCorrector = new MagneticSizeCorrector(), this.addPostInjectDependenciesListener((Un) => {
      this.tableColumnMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.tableColumnMutator.addStopMutationListener(this.dependencies.componentOrganizer.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.areaController.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.tableColumnMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.areaPositionMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.areaPositionMutator.addStartMutationListener(this.onStartMagneticLines), this.areaPositionMutator.addPrevMutationListener(this.magneticPositionCorrector.move), this.areaPositionMutator.addPostMutationListener(Un.render.renderRelativePositions), this.areaPositionMutator.addStopMutationListener(Un.magneticLines.stop), this.areaPositionMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.areaPositionMutator.addStopMutationListener(this.dependencies.pageTextOverflowObserver.sync), this.areaPositionMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.areaSizeMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.areaSizeMutator.addStartMutationListener(this.onStartMagneticLines), this.areaSizeMutator.addPrevMutationListener(this.magneticSizeCorrector.move), this.areaSizeMutator.addStopMutationListener(Un.magneticLines.stop), this.areaSizeMutator.addPostMutationListener(Un.ui.sync), this.areaSizeMutator.addPostMutationListener(Un.render.renderRelativePositions), this.areaSizeMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.areaSizeMutator.addStopMutationListener(this.dependencies.pageTextOverflowObserver.sync), this.areaSizeMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.areaPositionMutator.forceInjectDependencies({
        fnClone: Un.useCases.cloneWithAlt,
        keyboardObserver: Un.keyboardObserver
      }), this.magneticPositionCorrector.forceInjectDependencies({
        mutator: this.areaPositionMutator,
        magneticLines: Un.magneticLines
      }), this.magneticSizeCorrector.forceInjectDependencies({
        mutator: this.areaSizeMutator,
        magneticLines: Un.magneticLines
      });
    });
  }
  onMouseCenterDown(Un) {
  }
  onMouseCenterUp(Un) {
  }
  onMouseRightUp(Un) {
  }
  /**
   * Обновляет эффекты фокуса на компонентах.
   */
  syncFocusMouseDown(Un, Kn) {
    if (Un === null) {
      this.disableFocusComponents(Kn), this.disableFocusUIElements(Un);
      return;
    }
    if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
      this.disableFocusUIElements(null);
      const pa = Un.getData().graphic.getParentComponent();
      if (pa === null || pa.type === EditorComponentType.BOOK) {
        this.disableFocusComponents(Kn);
        return;
      }
      !pa.isEnableFocus() && this.disableFocusComponents(Kn);
      const va = pa.getParentComponent();
      if (va != null && va.isUniter && va.isEnableEditMode()) {
        const ba = va.getComponents();
        if (!ba)
          return;
        ba.forEach((_a) => {
          var ya;
          _a.type === EditorComponentType.TABLE && ((ya = _a.getFocusCellContexts()) == null || ya.forEach((xa) => {
            xa.disableFocus();
          })), _a.disableFocus();
        }), pa.enableFocus();
        return;
      }
      if (pa.isUniter && pa.isEnableEditMode()) {
        const ba = pa.getComponents();
        if (!ba) return;
        ba.forEach((_a) => {
          var ya;
          _a.type === EditorComponentType.TABLE && ((ya = _a.getFocusCellContexts()) == null || ya.forEach((xa) => {
            xa.disableFocus();
          })), _a.disableFocus();
        }), pa.enableFocus();
        return;
      }
      pa.enableFocus();
    } else if (this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type))
      this.disableFocusUIElements(Un);
    else
      throw new EditorError("spatial area type not identity");
  }
}
class WorkshopTemplateKeyboardObserver extends KeyboardObserver {
  constructor() {
    super();
    Ca(this, "onCtrlG", (Un) => {
      Un.preventDefault(), this.dependencies.useCases.groupFocusComponents();
    });
    Ca(this, "onDelete", (Un) => {
      Un.preventDefault(), this.dependencies.useCases.removeFocusComponentsWithAnimate();
    });
    Ca(this, "onEscape", () => {
      this.dependencies.useCases.disableInjectingProcess(), this.dependencies.useCases.disableComponentsFocus();
    });
    Ca(this, "onCopy", async (Un) => {
      console.log("onCopy"), Un.preventDefault(), await this.dependencies.useCases.copy();
    });
    Ca(this, "onPaste", async (Un) => {
      console.log("onPaste"), Un.preventDefault(), await this.dependencies.useCases.pasteFromKeyboardHotkey();
    });
    Ca(this, "onCut", (Un) => {
      Un.preventDefault();
    });
    Ca(this, "enableMaintainAspectRatioFocusComponents", () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          qn.enableMaintainAspectRatio();
        });
      });
    });
    Ca(this, "disableMaintainAspectRatioFocusComponents", () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          qn.disableMaintainAspectRatio();
        });
      });
    });
    Ca(this, "onOpenAiModal", () => {
    });
    this.addPostInjectDependenciesListener((Un) => {
      const { useCases: Kn } = Un;
      this.addPostKeyDownListener(Kn.moveCarriageLeft, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageTop, KeyCode.ARROW_UP), this.addPostKeyDownListener(Kn.moveCarriageRight, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(Kn.moveCarriageSelectionRight, KeyCode.SHIFT_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(
        Kn.moveCarriageSelectionWordRight,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.ARROW_RIGHT
      ), this.addPostKeyDownListener(Kn.moveCarriageSelectionLeft, KeyCode.SHIFT_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.selectAllText, KeyCode.CONTROL_LEFT, KeyCode.KEY_A), this.addPostKeyDownListener(
        Kn.moveCarriageSelectionWordLeft,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.ARROW_LEFT
      ), this.addPostKeyDownListener(Kn.moveCarriageBottom, KeyCode.ARROW_DOWN), this.addPostKeyDownListener(Kn.moveCarriageWordLeft, KeyCode.CONTROL_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageWordLeft, KeyCode.META_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageWordRight, KeyCode.CONTROL_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(Kn.moveCarriageWordRight, KeyCode.META_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(this.onCtrlG, KeyCode.CONTROL_LEFT, KeyCode.KEY_G), this.addPostKeyDownListener(Kn.runInjectText, KeyCode.SHIFT_LEFT, KeyCode.KEY_T), this.addPostKeyDownListener(Kn.runInjectPicture, KeyCode.SHIFT_LEFT, KeyCode.KEY_K), this.addPostKeyDownListener(Kn.runInjectFigure, KeyCode.SHIFT_LEFT, KeyCode.KEY_F), this.addPostKeyDownListener(Kn.runInjectLine, KeyCode.SHIFT_LEFT, KeyCode.KEY_L), this.addPostKeyDownListener(
        Kn.ungroupFocusComponents,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.KEY_G
      ), this.addPostKeyDownListener(this.onDelete, KeyCode.DELETE), this.addPostKeyDownListener(this.onEscape, KeyCode.ESCAPE), this.addPostKeyDownListener(Kn.undo, KeyCode.CONTROL_LEFT, KeyCode.KEY_Z), this.addPostKeyDownListener(Kn.redo, KeyCode.CONTROL_LEFT, KeyCode.SHIFT_LEFT, KeyCode.KEY_Z), this.addPostKeyDownListener(this.onCopy, KeyCode.CONTROL_LEFT, KeyCode.KEY_C), this.addPostKeyDownListener(this.onPaste, KeyCode.CONTROL_LEFT, KeyCode.KEY_V), this.addPostKeyDownListener(this.onCopy, KeyCode.META_LEFT, KeyCode.KEY_C), this.addPostKeyDownListener(this.onPaste, KeyCode.META_LEFT, KeyCode.KEY_V);
    });
  }
}
class WorkshopTemplateContextMenu extends ContextMenuView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "currentMousePosition");
    Ca(this, "currentActiveArea");
    Ca(this, "currentCrossGraphic");
    Ca(this, "currentCrossComponent");
    Ca(this, "getSpatialArea", () => (this.area === null && (this.area = new SpatialContextMenuArea(this), this.area.markDirty()), this.area));
    Ca(this, "show", () => {
      if (this.hide(), this.isShow = !0, this.currentMousePosition = this.dependencies.uiMouseObserver.getCurrentPosition(), this.currentActiveArea = this.dependencies.areaController.getActiveArea(), this.currentCrossGraphic = null, this.currentCrossComponent = null, this.currentActiveArea !== null && Object.values(SpatialCanvasAreaType).includes(this.currentActiveArea.type)) {
        const Un = this.currentActiveArea.getData(), Kn = Un.graphic.getParentComponent();
        this.currentCrossGraphic = Un.graphic, this.currentCrossComponent = Kn;
      }
      this.coordinateMenuForShow(), this.updateSpatialAreasPosition();
    });
    Ca(this, "updateSpatialAreasPosition", () => {
      if (this.area !== null) {
        this.area.markDirty();
        for (let Un = 0; Un < this.buttons.length; Un++)
          this.buttons[Un].getSpatialArea().markDirty();
      }
    });
    Ca(this, "coordinateMenuForShow", () => {
      if (this.currentCrossComponent === null || this.currentCrossGraphic === null || this.currentCrossGraphic.type === GraphicType.PAGE) {
        this.showDefaultMenu(this.currentMousePosition), this.dependencies.render.renderRelativePositions();
        return;
      }
      if (this.currentCrossComponent.type === EditorComponentType.TABLE && this.currentActiveArea) {
        this.showTableMenu(this.currentMousePosition, this.currentCrossComponent), this.dependencies.render.renderRelativePositions();
        return;
      }
      this.showComponentMenu(this.currentMousePosition, this.currentCrossComponent), this.dependencies.render.renderRelativePositions();
    });
    Ca(this, "onMergeCells", () => {
      this.dependencies.useCases.mergeFocusCell(this.currentCrossComponent);
    });
    Ca(this, "onSplitCells", () => {
      this.dependencies.useCases.splitFocusCells(this.currentCrossComponent);
    });
    Ca(this, "onSplitTable", () => {
      this.dependencies.useCases.splitTable(
        this.currentCrossComponent,
        this.currentActiveArea
      );
    });
    Ca(this, "onDeleteRow", () => {
      this.dependencies.useCases.deleteFocusRows(this.currentCrossComponent);
    });
    Ca(this, "onAddColumnRight", () => {
      this.dependencies.useCases.addColumnAfter(this.currentCrossComponent);
    });
    Ca(this, "onAddColumnLeft", () => {
      this.dependencies.useCases.addColumnBefore(this.currentCrossComponent);
    });
    Ca(this, "onAddRowBelow", () => {
      this.dependencies.useCases.addRowUnder(this.currentCrossComponent);
    });
    Ca(this, "onAddRowAbove", () => {
      this.dependencies.useCases.addRowOver(this.currentCrossComponent);
    });
    Ca(this, "onDeleteColumn", () => {
      this.dependencies.useCases.deleteFocusColumns(this.currentCrossComponent);
    });
    Ca(this, "onCopy", () => {
      this.dependencies.useCases.copy();
    });
    Ca(this, "onPaste", async () => {
      const Un = this.currentMousePosition;
      await this.dependencies.useCases.pasteAtPosition(Un);
    });
    Ca(this, "onDelete", () => {
      this.dependencies.useCases.removeFocusComponentsWithAnimate();
    });
    Ca(this, "onGroup", () => {
      this.dependencies.useCases.groupFocusComponents();
    });
    Ca(this, "onUngroup", () => {
      this.dependencies.useCases.ungroupFocusComponents();
    });
    Ca(this, "onGraphicForward", () => {
      this.currentCrossGraphic && this.dependencies.useCases.moveForwardGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicBack", () => {
      this.currentCrossGraphic && this.dependencies.useCases.moveBackGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicForeground", () => {
      this.currentCrossGraphic && this.dependencies.useCases.moveToForegroundGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicBackground", () => {
      this.currentCrossGraphic && this.dependencies.useCases.moveToBackgroundGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onModule", async () => {
      if (this.currentCrossComponent === null)
        throw new EditorError("component is null");
      await this.dependencies.useCases.createModule();
    });
    this.area = null, this.addPostInjectDependenciesListener(() => {
      this.copy.addPostMouseDownListeners(this.onCopy), this.paste.addPostMouseDownListeners(this.onPaste), this.delete.addPostMouseDownListeners(this.onDelete), this.group.addPostMouseDownListeners(this.onGroup), this.ungroup.addPostMouseDownListeners(this.onUngroup), this.moveForward.addPostMouseDownListeners(this.onGraphicForward), this.moveBack.addPostMouseDownListeners(this.onGraphicBack), this.planToBack.addPostMouseDownListeners(this.onGraphicBackground), this.planToForward.addPostMouseDownListeners(this.onGraphicForeground), this.createModule.addPostMouseDownListeners(this.onModule), this.mergeCells.addPostMouseDownListeners(this.onMergeCells), this.splitCells.addPostMouseDownListeners(this.onSplitCells), this.splitTable.addPostMouseDownListeners(this.onSplitTable), this.addColumnRight.addPostMouseDownListeners(this.onAddColumnRight), this.addColumnLeft.addPostMouseDownListeners(this.onAddColumnLeft), this.addRowBelow.addPostMouseDownListeners(this.onAddRowBelow), this.addRowAbove.addPostMouseDownListeners(this.onAddRowAbove), this.deleteRow.addPostMouseDownListeners(this.onDeleteRow), this.deleteColumn.addPostMouseDownListeners(this.onDeleteColumn);
    }), this.currentMousePosition = { x: 0, y: 0 }, this.currentActiveArea = null, this.currentCrossGraphic = null, this.currentCrossComponent = null;
  }
  callClick() {
  }
}
class WorkshopTemplateTemplateMenu extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_FILL", UIDefaultColor.WHITE);
    Ca(this, "DEFAULT_PADDING_VERTICAL", 10);
    Ca(this, "DEFAULT_WIDTH", 160);
    Ca(this, "DEFAULT_HEIGHT", 50);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "container");
    Ca(this, "pdfButton");
    Ca(this, "area");
    Ca(this, "position");
    Ca(this, "isVisible");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "setPosition", (Un) => {
      this.container.relativePosition = {
        x: Un.x - this.container.object.width,
        y: Un.y
      };
      const Kn = this.DEFAULT_PADDING_VERTICAL;
      this.pdfButton.setConfiguration((qn) => ({
        ...qn,
        x: -this.container.object.width,
        y: Kn
      })), this.position = Un;
    });
    Ca(this, "getFabricObjects", () => [this.container.object, ...this.pdfButton.getFabricObjects()]);
    Ca(this, "getObjects", () => [this.container, ...this.pdfButton.getObjects()]);
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.container.object.visible = !0, this.pdfButton.show());
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.container.object.visible = !1, this.pdfButton.hide());
    });
    Ca(this, "getRelativePosition", () => this.position);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "getUIElements", () => [this.pdfButton]);
    Ca(this, "isShowed", () => this.isVisible);
    this.area = new SpatialTemplateMenuArea(this), this.isVisible = !1, this.isHover = !1, this.isFocus = !1, this.isResetFocus = !0, this.position = { x: 0, y: 0 }, this.pdfButton = new TemplateMenuPDFButton(), this.container = {
      object: new pr({
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT,
        fill: this.DEFAULT_FILL,
        shadow: UIShadowDefault,
        rx: this.DEFAULT_CORNER_RADIUS,
        ry: this.DEFAULT_CORNER_RADIUS,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, onDownloadPDF: qn } = Un;
      this.pdfButton.forceInjectDependencies({ render: Kn, onDownloadPDF: qn });
    });
  }
  enableFocus() {
  }
  disableFocus() {
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  callClick() {
  }
}
class WorkshopTemplateDesktopUI extends DesktopUI {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_PANEL", 8);
    Ca(this, "topBar");
    Ca(this, "toolBar");
    Ca(this, "propertyPageBar");
    Ca(this, "propertyObjectBar");
    Ca(this, "propertyFigureBar");
    Ca(this, "propertyTextBar");
    Ca(this, "propertyTableBar");
    Ca(this, "propertyLineBar");
    Ca(this, "generationHint");
    Ca(this, "templateMenu");
    Ca(this, "tableConstructor");
    Ca(this, "undoButton");
    Ca(this, "redoButton");
    Ca(this, "disableFocusAIModal", () => {
      this.toolBar.getUIElements().forEach((Un) => Un.disableFocus());
    });
    Ca(this, "getSpatialAreas", () => {
      const Un = this.getUIElementsAll(), Kn = [];
      for (let qn = 0; qn < Un.length; qn++)
        Un[qn].isShowed() && (Kn.push(Un[qn].getSpatialArea()), Un[qn] instanceof ColorInput && Un[qn].isEnableShowPalette() && Kn.push(...Un[qn].getSpatialAreasPalette()));
      return Kn;
    });
    Ca(this, "getObjects", () => [
      // 1 слой контейнеры панелей
      ...this.toolBar.getFabricObjects(),
      this.propertyPageBar.getContainer(),
      this.propertyObjectBar.getContainer(),
      this.propertyFigureBar.getContainer(),
      this.propertyTextBar.getContainer(),
      this.propertyTableBar.getContainer(),
      this.propertyLineBar.getContainer(),
      this.topBar.getFabricContainer(),
      // 2 слой кнопки и заголовки
      // ...this.toolBar.getPanels().map(panel => panel.getButtons()).flat(),
      ...this.propertyPageBar.getContentElements(),
      ...this.propertyObjectBar.getContentElements(),
      ...this.propertyFigureBar.getContentElements(),
      ...this.propertyTableBar.getContentElements(),
      ...this.propertyLineBar.getContentElements(),
      ...this.propertyTextBar.getContentElements(),
      ...this.topBar.getFabricContentElements(),
      // 3 слой модалки, палитра и т.д.
      ...this.tableConstructor.getFabricObjects(),
      ...this.colorexCore.getFabricObjects(),
      ...this.generationHint.getFabricObjects(),
      ...this.templateMenu.getFabricObjects(),
      ...this.colorexCore.getFabricObjects(),
      ...this.editCornerObject.getFabricObjects(),
      ...this.socketIndicator.getFabricObject(),
      ...this.dependencies.contextMenu.getFabricObjects()
    ]);
    Ca(this, "sync", async () => {
      if (this.toolBar.sync(), this.topBar.syncPosition(), this.propertyPageBar.syncPosition(), this.propertyObjectBar.syncPosition(), this.propertyFigureBar.syncPosition(), this.propertyTextBar.syncPosition(), this.propertyTableBar.syncPosition(), this.propertyLineBar.syncPosition(), !this.isShowed())
        return;
      const Un = this.dependencies.componentTree.getFocusComponents(), Kn = this.dependencies.actionStore.getUndoCommandCount(), qn = this.dependencies.actionStore.getRedoCommandCount(), Jo = this.dependencies.componentTree.getRootComponent().getFirstGraphic();
      if (Kn < 1 ? this.undoButton.setIsEnableClick(!1) : this.undoButton.setIsEnableClick(!0), qn < 1 ? this.redoButton.setIsEnableClick(!1) : this.redoButton.setIsEnableClick(!0), Un === null) {
        Jo && (this.propertyPageBar.syncComponent(Jo), this.propertyPageBar.show()), this.propertyObjectBar.hide(), this.hidePanelsExcept(this.propertyPageBar);
        return;
      }
      this.propertyPageBar.hide(), this.propertyObjectBar.show(), this.propertyObjectBar.syncComponent(Un);
      const pa = Un[0];
      Un.every((va) => va.type === pa.type) && this.syncForSameComponentType(Un, pa.type), this.toolBar.show(), this.topBar.show();
    });
    Ca(this, "getUIElements", () => [
      ...this.toolBar.getUIElements(),
      this.colorexCore,
      this.tableConstructor,
      this.propertyTextBar,
      this.propertyFigureBar,
      this.propertyObjectBar,
      this.propertyPageBar,
      this.propertyTableBar,
      this.propertyLineBar,
      this.topBar,
      this.templateMenu,
      this.editCornerObject,
      this.dependencies.contextMenu,
      this.socketIndicator
    ]);
    // Метод возвращает общий массив со всеми элементами интерфейса (включает все дочерние элементы внутри панелей)
    Ca(this, "getUIElementsAll", () => {
      const Un = [], Kn = this.getUIElements();
      for (let qn = 0; qn < Kn.length; qn++)
        Un.push(Kn[qn]), Un.push(...this.getChildrenAllUIElements(Kn[qn]));
      return [...Un];
    });
    Ca(this, "getChildrenAllUIElements", (Un) => {
      const Kn = [], qn = Un.getUIElements();
      for (const Jo of qn)
        Kn.push(Jo), Kn.push(...this.getChildrenAllUIElements(Jo));
      return Kn;
    });
    Ca(this, "getFocusUIElements", () => [
      ...this.toolBar.getUIElements(),
      this.tableConstructor,
      ...this.tableConstructor.getUIElements(),
      this.propertyTextBar,
      ...this.propertyTextBar.getFocusUIElements(),
      this.propertyPageBar,
      ...this.propertyPageBar.getFocusUIElements(),
      this.propertyFigureBar,
      ...this.propertyFigureBar.getFocusUIElements(),
      this.propertyObjectBar,
      ...this.propertyObjectBar.getFocusUIElements(),
      // this.colorexPalette,
      // ...this.colorexPalette.getFocusUIElements(),
      this.topBar,
      ...this.topBar.getFocusUIElements(),
      this.propertyTableBar,
      ...this.propertyTableBar.getFocusUIElements(),
      this.propertyLineBar,
      ...this.propertyLineBar.getFocusUIElements(),
      ...this.editCornerObject.getFocusUIElements()
    ]);
    Ca(this, "setNameTemplate", (Un) => {
      this.topBar.setTitle(Un);
    });
    Ca(this, "setStateLoadingSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.LOADING);
    });
    Ca(this, "setStateSuccessSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.SUCCESS);
    });
    Ca(this, "setStateErrorSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.ERROR);
    });
    /**
     * Синхронизировать интерфейс для компонентов одного типа.
     * @param components - компоненты для сканирования.
     * @param type - тип компонентов.
     * @private
     */
    Ca(this, "syncForSameComponentType", (Un, Kn) => {
      switch (Kn) {
        case EditorComponentType.TABLE: {
          const qn = [];
          Un.forEach((Jo) => {
            const pa = Jo.getFocusCellContexts();
            pa !== null && qn.push(...pa);
          }), this.propertyTextBar.syncComponent(qn), this.propertyTextBar.setConfiguration((Jo) => ({
            ...Jo,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTextBar.show(), this.propertyTableBar.syncComponent(Un), this.propertyTableBar.setConfiguration((Jo) => ({
            ...Jo,
            marginTop: this.propertyTextBar.getGlobalPosition().y + this.propertyTextBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTableBar.show(), this.hidePanelsExcept(this.propertyTextBar, this.propertyTableBar);
          break;
        }
        case EditorComponentType.TEXT:
          this.propertyTextBar.syncComponent(Un), this.propertyTextBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTextBar.show(), this.hidePanelsExcept(this.propertyTextBar);
          break;
        case EditorComponentType.FIGURE:
          this.propertyFigureBar.syncComponent(Un), this.propertyFigureBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyFigureBar.show(), this.hidePanelsExcept(this.propertyFigureBar);
          break;
        case EditorComponentType.LINE:
          this.propertyLineBar.syncComponent(Un), this.propertyLineBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyLineBar.show();
          break;
        case EditorComponentType.GROUP:
          this.propertyObjectBar.hide(), this.hideAllPanels();
          break;
        case EditorComponentType.BOOK:
          this.hideAllPanels();
          break;
        case EditorComponentType.MODULE:
          this.hideAllPanels();
          break;
        case EditorComponentType.PICTURE:
          this.hideAllPanels();
          break;
      }
    });
    this.toolBar = new ToolBar(), this.topBar = new TopBar(), this.generationHint = new GenerationHint(), this.templateMenu = new WorkshopTemplateTemplateMenu(), this.propertyPageBar = new PropertyPageBar(), this.propertyObjectBar = new PropertyObjectBar(), this.propertyFigureBar = new PropertyFigureBar(), this.propertyTextBar = new PropertyTextBar(), this.propertyTableBar = new PropertyTableBar(), this.propertyLineBar = new PropertyLineBar(), this.tableConstructor = new TableConstructorView();
    const Un = new ToolUndoButton(), Kn = new ToolRedoButton();
    this.undoButton = Un, this.redoButton = Kn, this.addPostInjectDependenciesListener((qn) => {
      const {
        render: Jo,
        useCases: pa,
        textEngine: ma,
        onOpenModulesModal: va,
        onBackPage: ba,
        onDownloadPDF: _a,
        onOpenCreateCustomTableWindow: ya,
        onGetGenerationHintStructure: xa,
        onGoToTariff: wa,
        onSetNameTemplate: Ta,
        actionController: Sa,
        onOpenAIActionsModal: Ma,
        onCloseAIActionsModal: ka
      } = qn;
      this.tableConstructor.forceInjectDependencies({
        useCases: pa,
        render: qn.render,
        onOpenCreateCustomTableWindow: ya
      });
      const Za = new ToolPanel().forceInjectDependencies({ render: Jo }), Na = new ToolAIButton().forceInjectDependencies({
        render: Jo,
        onOpenAIActionsModal: Ma,
        onCloseAIActionsModal: ka
      }), Ka = new ToolPanel().forceInjectDependencies({ render: Jo }), Ja = new ToolTextButton().forceInjectDependencies({
        render: Jo,
        useCases: pa
      }), el = new ToolTableButton().forceInjectDependencies({
        render: Jo,
        useCases: pa,
        tableConstructor: this.tableConstructor
      });
      el.enableClickFocus();
      const qa = new ToolPictureButton().forceInjectDependencies({ render: Jo, useCases: pa }), tl = new ToolRectangleButton().forceInjectDependencies({ render: Jo, useCases: pa }), Qa = new ToolLineButton().forceInjectDependencies({ render: Jo, useCases: pa }), nl = new ToolPanel();
      Un.forceInjectDependencies({ render: Jo, useCases: pa }), Un.disableClickFocus(), Kn.forceInjectDependencies({ render: Jo, useCases: pa }), Kn.disableClickFocus();
      const rl = new ToolPanel(), il = new ToolModuleButton().forceInjectDependencies({ render: Jo, onOpenModulesModal: va });
      Ka.addButtons(Ja, el, qa, tl, Qa), Za.addButtons(Na), nl.addButtons(Un, Kn), rl.addButtons(il), this.toolBar.addPanel(Za), this.toolBar.addPanel(Ka), this.toolBar.addPanel(nl), this.toolBar.addPanel(rl), this.bars.push(...this.toolBar.getPanels(), this.topBar, this.propertyObjectBar), this.propertyPageBar.forceInjectDependencies({
        useCases: pa,
        render: Jo,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyObjectBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        textEngine: ma,
        editCornerObject: this.editCornerObject
      }), this.propertyFigureBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyTextBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyTableBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore
      }), this.propertyLineBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.topBar.forceInjectDependencies({
        render: Jo,
        templateMenu: this.templateMenu,
        generationHint: this.generationHint,
        useCases: pa,
        onBackPage: ba,
        textEngine: ma,
        onSetNameTemplate: Ta,
        actionController: Sa,
        onGetGenerationHintStructure: xa
      }), this.topBar.show(), this.topBar.setState(TopBarState.AI_PDF), this.templateMenu.forceInjectDependencies({ render: Jo, onDownloadPDF: _a }), this.colorexCore.forceInjectDependencies({
        render: Jo
      }), this.generationHint.forceInjectDependencies({ render: Jo, onGoToTariff: wa, onGetGenerationHintStructure: xa }), this.editCornerObject.forceInjectDependencies({
        render: Jo,
        textEngine: ma,
        useCases: pa
      }), this.socketIndicator.forceInjectDependencies({
        render: Jo
      }), this.socketIndicator.show(), this.socketIndicator.sync();
    });
  }
}
class WorkshopTemplateUseCases extends BookUseCases {
  constructor() {
    super();
    Ca(this, "tableSplitter");
    Ca(this, "xlsxTableImporter");
    Ca(this, "xlsxTableReplacer");
    /**
     * Создаёт модуль из компонентов в фокусе. При создании модуля из одного uniter компонента (например это компонент
     * группы) этот компонент конвертируется в компонент модуля, т.к. никакого смысла в группе нет в данном случае.
     */
    Ca(this, "createModule", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      if (Un === null)
        return;
      const qn = (await this.dependencies.moduleBuilder.build(...Un)).getUniqueStructure();
      this.dependencies.onOpenCreateModuleWindow(async (Jo) => {
        const pa = new ComponentPreviewEditor({
          imageFileSourcePrefix: this.dependencies.imageFileSourcePrefix
        });
        await pa.setStructure({
          id: "preview",
          name: "preview",
          root: qn
        });
        const ma = await pa.getPreview();
        Jo(ma);
      }, qn);
    });
    Ca(this, "injectModule", async (Un) => {
      this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.injectModule(Un), this.dependencies.componentInjector.addSingleUseInjectListener(async () => {
        await this.dependencies.componentOrganizer.sync(), await this.dependencies.actionController.stopUserAction();
      });
    });
    Ca(this, "splitTable", async (Un, Kn) => {
      this.dependencies.actionController.startUserAction(), await this.tableSplitter.splitTable(Un, Kn);
    });
    Ca(this, "replaceTablesFromXLSX", () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(EditorComponentType.TABLE);
      Un !== null && this.xlsxTableReplacer.replaceTable(Un);
    });
    /**
     * Запускает процесс выбора XLSX файла пользователем и создания таблиц из его структуры.
     * В случае, если в файле несколько листов, то будет создано несколько таблиц.
     */
    Ca(this, "createTableFromXLSX", () => {
      this.xlsxTableImporter.getStructure((Un) => {
        const { rowCount: Kn, columnCount: qn, cells: Jo } = Un[0];
        this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.injectTable(Kn, qn, Jo), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction);
      });
    });
    this.tableSplitter = new BookTableSplitter(), this.xlsxTableImporter = new XLSXTableImporter(), this.xlsxTableReplacer = new BookTableReplacer(), this.addPostInjectDependenciesListener((Un) => {
      const { componentTree: Kn, areaController: qn, actionController: Jo, componentOrganizer: pa, onUploadXlsxFile: ma } = Un;
      this.tableSplitter.forceInjectDependencies({
        componentTree: Kn,
        areaController: qn,
        actionController: Jo,
        componentOrganizer: pa
      }), this.xlsxTableReplacer.forceInjectDependencies({
        xlsxTableImporter: this.xlsxTableImporter,
        areaController: qn,
        sketchStabilizer: Jo,
        componentOrganizer: pa
      }), this.xlsxTableImporter.forceInjectDependencies({
        onUploadXlsxFile: ma
      });
    });
  }
}
class WorkshopTemplateEditor extends DynamicEditor {
  constructor(Un) {
    super(Un.editorContainer);
    Ca(this, "ui");
    Ca(this, "state");
    Ca(this, "cursorView");
    Ca(this, "actionStore");
    Ca(this, "textImporter");
    Ca(this, "moduleBuilder");
    Ca(this, "magneticLines");
    Ca(this, "copyController");
    Ca(this, "cursor");
    Ca(this, "bookOrganizer");
    Ca(this, "editModeContext");
    Ca(this, "injectorFactory");
    Ca(this, "componentCloner");
    Ca(this, "pictureImporter");
    Ca(this, "pictureReplacer");
    Ca(this, "tableGridMutator");
    Ca(this, "componentBuilder");
    Ca(this, "pasteController");
    Ca(this, "actionRepository");
    Ca(this, "selectionArea");
    Ca(this, "htmlTableImporter");
    Ca(this, "textActionInitiator");
    Ca(this, "htmlTableReplacer");
    Ca(this, "componentInjector");
    Ca(this, "modulePlaceHolder");
    Ca(this, "keyboardVisualizer");
    Ca(this, "componentGrouper");
    Ca(this, "actionController");
    Ca(this, "contextMenu");
    Ca(this, "componentOrganizer");
    Ca(this, "useCases");
    Ca(this, "componentTree");
    Ca(this, "layerRegistry");
    Ca(this, "graphicFactory");
    Ca(this, "keyboardObserver");
    /**
     * Отключает фокус у кнопки открытия AI
     */
    Ca(this, "disableFocusAIModal", () => {
      this.ui.disableFocusAIModal();
    });
    /**
     * Вставляет модуль в редактор шаблона.
     *
     * @param {AnyComponentStructure} structure - Структура компонента, который необходимо вставить.
     */
    Ca(this, "injectModule", async (Un) => {
      await this.useCases.injectModule(Un);
    });
    /**
     * Создает таблицу с полученным кол-вом строк и столбцов.
     * @param columnCount - кол-во столбцов.
     * @param rowCount - кол-во строк.
     */
    Ca(this, "createTable", (Un, Kn) => {
      this.useCases.createEmptyTable(Kn, Un);
    });
    /**
     * Устанавливает состояние загрузки сохранения шаблона.
     */
    Ca(this, "setStateLoadingSaveTemplate", () => {
      this.ui.setStateLoadingSaveTemplate();
    });
    /**
     * Устанавливает состояние успешного сохранения шаблона.
     */
    Ca(this, "setStateSuccessSaveTemplate", () => {
      this.ui.setStateSuccessSaveTemplate();
    });
    /**
     * Устанавливает состояние ошибки сохранения шаблона.
     */
    Ca(this, "setStateErrorSaveTemplate", () => {
      this.ui.setStateErrorSaveTemplate();
    });
    /**
     * Устанавливает структуру шаблона редактора и обновляет отображение.
     *
     * Этот метод загружает переданную структуру, устанавливает её идентификатор и имя,
     * затем обновляет дерево компонентов и интерфейс редактора.
     *
     * @param editorStructure - Объект структуры редактора, содержащий конфигурацию и содержимое.
     */
    Ca(this, "setStructure", async (Un) => {
      const Kn = _$2.cloneDeep(Un), { id: qn, name: Jo } = Kn;
      this.setID(qn), this.setName(Jo), this.state.setSketchID(qn), await this.componentTree.load(Kn.root), this.componentCloner.forceInjectDependencies({
        toPasteSketchID: qn,
        componentTree: this.componentTree,
        graphicFactory: this.graphicFactory,
        componentFactory: this.componentFactory,
        mouseObserver: this.canvasMouseObserver
      }), await this.canvasAreaController.sync(), this.state.syncState(), this.ui.setNameTemplate(Jo), await this.ui.sync(), this.uiRender.render(), await this.ui.sync(), this.layerVisualizer.sync(), this.componentOrganizer.addPostSyncListener(this.layerVisualizer.sync), this.componentInjector.addPostUpdateAreaListener(this.canvasRender.render);
      const pa = this.componentTree.getRootComponent();
      this.bookOrganizer.connectDependencies({
        book: pa,
        render: this.canvasRender,
        canvas: this.canvas
      }), this.bookOrganizer.injectDependencies(), pa.syncPagePanels(), this.bookOrganizer.sync(), await this.areaController.sync(), this.canvasRender.render(), this.callPostSetStructureListeners();
    });
    Ca(this, "savePreview", async (Un, Kn) => {
      const qn = new ContentConverterEditor({
        imageFileSourcePrefix: Un,
        isEnableMouseWheel: !1,
        isCanvasHeightAdaptive: !0
      }), Jo = this.getStructure();
      await qn.setStructure(Jo);
      const pa = await qn.getFirstPageImage();
      Kn(pa);
    });
    this.ui = new WorkshopTemplateDesktopUI(), this.state = new SketchState(), this.actionStore = new ActionStore(), this.textImporter = new TextImporter(), this.moduleBuilder = new ModuleBuilder(), this.copyController = new CopyController(), this.cursor = new WorkshopTemplateCursor(), this.layerRegistry = new BookLayerRegistry(), this.editModeContext = new EditModeContext(), this.injectorFactory = new InjectorFactory(), this.pictureImporter = new PictureImporter(), this.pictureReplacer = new PictureReplacer(), this.bookOrganizer = new BookModeOrganizer(), this.textActionInitiator = new TextActionInitiator(), this.useCases = new WorkshopTemplateUseCases(), this.tableGridMutator = new TableGridMutator(), this.pasteController = new PasteController(), this.actionRepository = new ActionRepository(), this.selectionArea = new ComponentSelectorArea(), this.componentInjector = new ComponentInjector(), this.htmlTableImporter = new HTMLTableImporter(), this.htmlTableReplacer = new HTMLTableReplacer(), this.componentOrganizer = new BookComponentOrganizer(), this.componentGrouper = new ComponentGrouper(), this.actionController = new ActionController(), this.contextMenu = new WorkshopTemplateContextMenu(), this.modulePlaceHolder = new ModulePlaceholder(), this.componentTree = new DynamicComponentTree(), this.cursorView = new CursorView(Un.editorContainer);
    const Kn = this.layerRegistry.getTree();
    this.componentOrganizer.addPostSyncListener(this.bookOrganizer.sync), this.componentOrganizer.addPostSyncListener(this.pageTextOverflowObserver.sync), this.componentOrganizer.addPostSyncListener(this.componentTree.syncUniterComponentsSize), this.selectionArea.addPostUpdateAreaListener(this.canvasRender.renderUnstructured), this.addPostResizeWindowListener(this.adaptCanvas), this.addPostResizeWindowListener(this.adaptUICanvas), this.addPostResizeWindowListener(this.ui.sync), this.addPostResizeWindowListener(this.ui.sync), this.addPostResizeWindowListener(this.bookOrganizer.sync), this.addPostResizeWindowListener(this.layerVisualizer.sync), this.addPostResizeWindowListener(this.uiSpatialGridVisualizer.sync), this.addPostResizeWindowListener(this.canvasSpatialGridVisualizer.sync), this.addPostResizeWindowListener(this.areaController.updateAreaPosition), this.graphicFactory = new DynamicGraphicFactory(), this.componentBuilder = new ComponentBuilder(), this.componentCloner = new ComponentCloner(), this.actionStore.addPostUndoRedoListener(this.canvasAreaController.sync), this.actionStore.addPostUndoRedoListener(this.canvasRender.render), this.actionController.addPostStopActionListener(this.actionVisualizer.sync), this.actionController.addPostStartActionListener(this.actionVisualizer.sync), this.magneticLines = new MagneticLines(), this.keyboardObserver = new WorkshopTemplateKeyboardObserver(), this.keyboardVisualizer = new KeyboardVisualizer(this.keyboardObserver), this.addEnableInteractiveListener(this.keyboardObserver.construct), this.addDisableInteractiveListener(this.keyboardObserver.destruct), this.keyboardVisualizer.addPostSyncListener(this.uiRender.render), this.keyboardObserver.addPostChangeActiveKeysListener(this.keyboardVisualizer.sync), this.carriageCoordinator.addPostChangeCarriageRangeListener(this.textSelectionVisualizer.sync), this.pageStructureObserver.subscribe(
      () => this.savePreview(Un.imageFileSourcePrefix, Un.onUpdateTemplatePreview)
    ), this.ui.connectDependencies({
      render: this.uiRender,
      useCases: this.useCases,
      textEngine: this.textEngine,
      onBackPage: Un.onBackPage,
      actionStore: this.actionStore,
      actionController: this.actionController,
      contextMenu: this.contextMenu,
      componentTree: this.componentTree,
      onDownloadPDF: Un.onDownloadPDF,
      onOpenModulesModal: Un.onOpenModulesWindow,
      onOpenCreateCustomTableWindow: Un.onOpenCreateCustomTableWindow,
      onGoToTariff: Un.onGoToTariff,
      onGetGenerationHintStructure: Un.onGetGenerationHintStructure,
      onSetNameTemplate: this.setName,
      onOpenAIActionsModal: Un.onOpenAIActionsModal,
      onCloseAIActionsModal: Un.onCloseAIActionsModal
    }), this.magneticLines.connectDependencies({
      componentTree: this.componentTree
    }), this.cursor.connectDependencies({
      ui: this.ui,
      editor: this,
      useCases: this.useCases,
      render: this.canvasRender,
      cursorView: this.cursorView,
      textEngine: this.textEngine,
      contextMenu: this.contextMenu,
      componentTree: this.componentTree,
      selectionArea: this.selectionArea,
      magneticLines: this.magneticLines,
      areaController: this.areaController,
      editModeContext: this.editModeContext,
      editorContainer: this.editorContainer,
      uiMouseObserver: this.uiMouseObserver,
      actionController: this.actionController,
      keyboardObserver: this.keyboardObserver,
      componentInjector: this.componentInjector,
      componentOrganizer: this.componentOrganizer,
      carriageCoordinator: this.carriageCoordinator,
      canvasMouseObserver: this.canvasMouseObserver,
      textSelectionObserver: this.textSelectionObserver,
      pageStructureObserver: this.pageStructureObserver,
      pageTextOverflowObserver: this.pageTextOverflowObserver
    }), this.pageTextOverflowObserver.connectDependencies({
      componentTree: this.componentTree
    }), this.carriageCoordinator.connectDependencies({
      render: this.canvasRender
    }), this.textEngine.connectDependencies({
      keyboardObserver: this.keyboardObserver,
      actionController: this.actionController,
      renders: [this.canvasRender, this.uiRender],
      textActionInitiator: this.textActionInitiator,
      textEventGenerator: this.textEventGenerator,
      carriageCoordinator: this.carriageCoordinator
    }), this.pageStructureObserver.connectDependencies({
      componentTree: this.componentTree
    }), this.selectionArea.connectDependencies({
      areaController: this.canvasAreaController,
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.contextMenu.connectDependencies({
      ui: this.ui,
      render: this.uiRender,
      useCases: this.useCases,
      areaController: this.areaController,
      uiMouseObserver: this.uiMouseObserver
    }), this.layerVisualizer.connectDependencies({
      tree: Kn,
      render: this.uiRender,
      canvas: this.uiCanvas
    }), this.componentFactory.connectDependencies({
      useCases: this.useCases,
      textEngine: this.textEngine,
      componentTree: this.componentTree,
      actionController: this.actionController,
      areaController: this.canvasAreaController,
      pageStructureObserver: this.pageStructureObserver
    }), this.textImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.pictureImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.canvasAreaController.connectDependencies({
      tree: this.canvasSpatialGrid,
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.uiAreaController.connectDependencies({
      ui: this.ui,
      tree: this.uiSpatialGrid,
      uiMouseObserver: this.uiMouseObserver
    }), this.pictureReplacer.connectDependencies({
      pictureImporter: this.pictureImporter,
      sketchStabilizer: this.actionController
    }), this.htmlTableImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      componentOrganizer: this.componentOrganizer,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.htmlTableReplacer.connectDependencies({
      htmlTableImporter: this.htmlTableImporter,
      componentOrganizer: this.componentOrganizer,
      sketchStabilizer: this.actionController
    }), this.layerRegistry.connectDependencies({
      componentTree: this.componentTree
    }), this.copyController.connectDependencies({
      textEngine: this.textEngine,
      textImporter: this.textImporter,
      componentCloner: this.componentCloner
    }), this.pasteController.connectDependencies({
      textEngine: this.textEngine,
      textImporter: this.textImporter,
      componentTree: this.componentTree,
      graphicFactory: this.graphicFactory,
      pictureImporter: this.pictureImporter,
      pictureReplacer: this.pictureReplacer,
      componentCloner: this.componentCloner,
      componentFactory: this.componentFactory,
      componentInjector: this.componentInjector,
      mouseObserver: this.canvasMouseObserver,
      htmlTableImporter: this.htmlTableImporter,
      htmlTableReplacer: this.htmlTableReplacer
    }), this.actionController.connectDependencies({
      state: this.state,
      actionStore: this.actionStore,
      sendCommands: Un.sendCommands,
      componentTree: this.componentTree,
      areaController: this.canvasAreaController,
      getConstructorConnectionStatus: Un.getServerConnectionStatus
    }), this.injectorFactory.connectDependencies({
      render: this.canvasRender,
      cursorView: this.cursorView,
      componentTree: this.componentTree,
      componentAlignment: this.componentAlignment,
      canvasMouseObserver: this.canvasMouseObserver,
      modulePlaceHolder: this.modulePlaceHolder
    }), this.componentOrganizer.connectDependencies({
      componentTree: this.componentTree,
      bookOrganizer: this.bookOrganizer
    }), this.componentTree.connectDependencies({
      render: this.canvasRender,
      layerRegistry: this.layerRegistry,
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory
    }), this.keyboardObserver.connectDependencies({
      useCases: this.useCases,
      componentTree: this.componentTree,
      textEventGenerator: this.textEventGenerator
    }), this.textActionInitiator.connectDependencies({
      actionController: this.actionController
    }), this.actionVisualizer.connectDependencies({
      render: this.uiRender,
      actionRepository: this.actionRepository,
      actionController: this.actionController
    }), this.moduleBuilder.connectDependencies({
      componentTree: this.componentTree,
      graphicFactory: this.graphicFactory,
      componentBuilder: this.componentBuilder,
      componentFactory: this.componentFactory
    }), this.useCases.connectDependencies({
      ui: this.ui,
      textEngine: this.textEngine,
      actionStore: this.actionStore,
      canvasRender: this.canvasRender,
      componentTree: this.componentTree,
      bookOrganizer: this.bookOrganizer,
      moduleBuilder: this.moduleBuilder,
      componentCloner: this.componentCloner,
      uploadImageFile: Un.uploadImageFile,
      componentGrouper: this.componentGrouper,
      tableGridMutator: this.tableGridMutator,
      copyController: this.copyController,
      pasteController: this.pasteController,
      actionController: this.actionController,
      onUploadXlsxFile: Un.uploadXlsxFile,
      componentInjector: this.componentInjector,
      areaController: this.canvasAreaController,
      componentOrganizer: this.componentOrganizer,
      componentAlignment: this.componentAlignment,
      canvasMouseObserver: this.canvasMouseObserver,
      textActionInitiator: this.textActionInitiator,
      carriageCoordinator: this.carriageCoordinator,
      imageFileSourcePrefix: Un.imageFileSourcePrefix,
      onOpenCreateModuleWindow: Un.openCreateModuleWindow
    }), this.canvasSpatialGridVisualizer.connectDependencies({
      spatialGrid: this.canvasSpatialGrid
    }), this.uiSpatialGridVisualizer.connectDependencies({
      spatialGrid: this.uiSpatialGrid
    }), this.objectOrganizer.connectDependencies({
      ui: this.ui,
      layerRegistry: this.layerRegistry,
      magneticLines: this.magneticLines,
      componentInjector: this.componentInjector,
      componentSelectionArea: this.selectionArea,
      quadTreeVisualizer: this.canvasSpatialGridVisualizer,
      textSelectionVisualizer: this.textSelectionVisualizer
    }), this.uiObjectOrganizer.connectDependencies({
      ui: this.ui,
      layerVisualizer: this.layerVisualizer,
      actionVisualizer: this.actionVisualizer,
      keyboardVisualizer: this.keyboardVisualizer,
      quadTreeVisualizer: this.uiSpatialGridVisualizer
    }), this.modulePlaceHolder.connectDependencies({
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.componentInjector.connectDependencies({
      injectorFactory: this.injectorFactory
    }), this.state.connectDependencies({
      editor: this,
      componentTree: this.componentTree
    }), this.actionStore.connectDependencies({
      repository: this.actionRepository,
      actionController: this.actionController
    }), this.componentGrouper.connectDependencies({
      componentTree: this.componentTree,
      componentBuilder: this.componentBuilder
    }), this.graphicFactory.connectDependencies({
      ui: this.ui,
      camera: this.camera,
      useCases: this.useCases,
      render: this.canvasRender,
      componentTree: this.componentTree,
      layerRegistry: this.layerRegistry,
      areaController: this.canvasAreaController,
      imageFileSourcePrefix: Un.imageFileSourcePrefix
    }), this.componentBuilder.connectDependencies({
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory
    }), this.canvasRender.connectDependencies({
      canvas: this.canvas,
      layerRegistry: this.layerRegistry,
      canvasObjectOrganizer: this.objectOrganizer
    }), this.uiRender.connectDependencies({
      ui: this.ui,
      canvas: this.uiCanvas,
      uiObjectOrganizer: this.uiObjectOrganizer
    }), this.camera.connectDependencies({
      componentTree: this.componentTree
    }), this.areaWheelObserver.connectDependencies({
      areaController: this.areaController
    }), this.ui.injectDependencies(), this.camera.injectDependencies(), this.componentTree.injectDependencies(), this.state.injectDependencies(), this.actionStore.injectDependencies(), this.canvasAreaController.injectDependencies(), this.uiAreaController.injectDependencies(), this.objectOrganizer.injectDependencies(), this.layerRegistry.injectDependencies(), this.textImporter.injectDependencies(), this.uiObjectOrganizer.injectDependencies(), this.cursor.injectDependencies(), this.pictureImporter.injectDependencies(), this.injectorFactory.injectDependencies(), this.keyboardObserver.injectDependencies(), this.componentGrouper.injectDependencies(), this.componentInjector.injectDependencies(), this.canvasSpatialGridVisualizer.injectDependencies(), this.uiSpatialGridVisualizer.injectDependencies(), this.graphicFactory.injectDependencies(), this.pageStructureObserver.injectDependencies(), this.pasteController.injectDependencies(), this.canvasRender.injectDependencies(), this.layerVisualizer.injectDependencies(), this.actionController.injectDependencies(), this.pageTextOverflowObserver.injectDependencies(), this.useCases.injectDependencies(), this.htmlTableImporter.injectDependencies(), this.carriageCoordinator.injectDependencies(), this.htmlTableReplacer.injectDependencies(), this.selectionArea.injectDependencies(), this.textEngine.injectDependencies(), this.contextMenu.injectDependencies(), this.uiRender.injectDependencies(), this.moduleBuilder.injectDependencies(), this.actionVisualizer.injectDependencies(), this.modulePlaceHolder.injectDependencies(), this.componentOrganizer.injectDependencies(), this.areaWheelObserver.injectDependencies(), this.canvasSpatialGridVisualizer.addPostUpdateVisibilityListener(this.canvasRender.render), this.uiSpatialGridVisualizer.addPostUpdateVisibilityListener(this.uiRender.render), this.wheelObserver.subscribe(this.areaWheelObserver.onMouseWheel), this.areaWheelObserver.subscribeGlobalWheel(this.camera.move), this.touchObserver.subscribe(this.camera.move), this.camera.addPostUpdateViewListeners(this.canvasRender.renderUnstructured), this.addDestructListener(this.wheelObserver.destruct), this.addDestructListener(this.touchObserver.destruct), this.addDestructListener(this.cursor.destruct), this.addDestructListener(this.keyboardObserver.destruct), this.debugEntities.push(this.keyboardVisualizer), Un.enableDebugMenu && this.enableGUI();
  }
}
class TeamTemplateCursor extends Cursor {
  constructor() {
    super();
    Ca(this, "magneticPositionCorrector");
    Ca(this, "areaPositionMutator");
    Ca(this, "magneticSizeCorrector");
    Ca(this, "onMouseMove", async (Un, Kn) => {
      const qn = this.dependencies.componentTree.getComponents();
      await this.dependencies.areaController.sync();
      const Jo = this.dependencies.areaController.getActiveArea();
      this.syncHover(Jo, qn), this.isRunningMutationComponent() ? this.dependencies.cursorView.setActiveArea(null) : this.dependencies.cursorView.setActiveArea(Jo), await this.areaSizeMutator.mutate(Un, Kn), await this.tableColumnMutator.mutate(Un, Kn), await this.areaPositionMutator.mutate(Un, Kn), this.cellSelectionObserver.move(Un, Kn, Jo), this.dependencies.textSelectionObserver.move(Un, Kn), this.dependencies.render.renderUnstructured();
    });
    Ca(this, "onMouseLeftDown", async (Un) => {
      if (this.dependencies.componentInjector.isInjecting()) {
        if (!this.dependencies.componentInjector.isReadyInject()) {
          this.dependencies.componentInjector.onMouseDown(), this.dependencies.contextMenu.hide();
          return;
        }
        await this.dependencies.componentInjector.inject(), this.dependencies.contextMenu.hide();
        return;
      }
      const qn = this.dependencies.componentTree.getComponents(), Jo = this.dependencies.canvasMouseObserver.getCurrentPosition();
      await this.dependencies.areaController.sync();
      const pa = this.dependencies.areaController.getActiveArea();
      if (this.syncFocusMouseDown(pa, Un), this.syncEditMode(pa, qn, Un), await this.dependencies.ui.sync(), pa === null) {
        this.dependencies.componentTree.hasEditableOrFocusComponent() || this.dependencies.selectionArea.start(Jo), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.isResizeType()) {
        this.areaSizeMutator.start(pa), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.type === SpatialCanvasAreaType.TABLE_COLUMN_RESIZE) {
        this.tableColumnMutator.start(pa), this.dependencies.contextMenu.hide();
        return;
      }
      if (pa.type === SpatialCanvasAreaType.TABLE_CELL && this.cellSelectionObserver.start(pa), this.areaTypeAnalyzer.isSpatialUIAreaType(pa.type)) {
        const ma = pa.getData();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
        if (pa.type === SpatialUIAreaType.COLOREX_COLOR)
          pa.callClick();
        else if (pa.type === SpatialUIAreaType.INPUT) {
          ma.callClick();
          const va = this.dependencies.uiMouseObserver.getCurrentPosition(), ba = ma.getGlobalPosition();
          this.dependencies.carriageCoordinator.pounceToMouse(ma, ma, ba, va), this.dependencies.textSelectionObserver.start([pa], ma.getTextModel(), va);
        } else
          ma.callClick();
        this.dependencies.contextMenu.hide();
      } else if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(pa.type)) {
        const ma = pa.getData();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
        const va = ma.graphic.type;
        if (pa.type === SpatialCanvasAreaType.BUTTON && pa.getButton().callClick(), va === GraphicType.PAGE && pa.type !== SpatialCanvasAreaType.BUTTON && this.areaPositionMutator.startMoveComponents(pa, [this.dependencies.componentTree.getRootComponent()]), va === GraphicType.TEXT && ma.graphic.isEnableEditMode()) {
          const _a = ma.graphic.getGlobalPosition();
          this.dependencies.carriageCoordinator.pounceToMouse(
            ma.graphic.getParentComponent(),
            ma.graphic,
            _a,
            Jo
          );
          const ya = ma.graphic.getParentComponent();
          if (ya === null)
            throw this.dependencies.contextMenu.hide(), new EditorError("component is null");
          const wa = ya.getGraphics().map((Ta) => Ta.getSpatialGraphicArea());
          this.dependencies.textSelectionObserver.start(wa, ya.getTextModel(), Jo);
        }
        if (pa.type === SpatialCanvasAreaType.TABLE_CELL && ma.graphic.isEnableEditMode()) {
          const _a = ma.graphic.getGlobalPosition(), xa = pa.getData();
          this.dependencies.carriageCoordinator.pounceToMouse(
            ma.areaCellContext,
            ma.areaCell,
            _a,
            Jo
          );
          const wa = xa.component.getSpatialAreas().filter(
            (Sa) => Sa.type === SpatialCanvasAreaType.TABLE_CELL && Sa.getData().areaCellContext === ma.areaCellContext
          ), Ta = xa.areaCellContext.getTextModel();
          wa.length !== 0 && this.dependencies.textSelectionObserver.start(wa, Ta, Jo);
        }
        const ba = this.dependencies.componentTree.getFocusComponents();
        if (ba === null) {
          this.dependencies.contextMenu.hide();
          return;
        }
        pa.type !== SpatialCanvasAreaType.BUTTON && (!ma.graphic.isEnableEditMode() || pa.type === SpatialCanvasAreaType.PICTURE) && this.areaPositionMutator.startMoveComponents(pa, ba), this.dependencies.contextMenu.hide();
      }
    });
    Ca(this, "onMouseLeftUp", async (Un) => {
      const Kn = this.dependencies.areaController.getActiveArea();
      await this.dependencies.componentInjector.onMouseUp(), this.dependencies.textSelectionObserver.stop(), this.syncFocusMouseUp(Kn, Un), this.areaSizeMutator.stop(), this.tableColumnMutator.stop(), this.areaPositionMutator.stop(), await this.cellSelectionObserver.stop(), this.dependencies.selectionArea.stop(), await this.dependencies.componentOrganizer.sync(), await this.dependencies.areaController.sync(), await this.dependencies.ui.sync();
    });
    Ca(this, "onMouseRightDown", (Un) => {
      Un.preventDefault(), this.dependencies.contextMenu.show();
    });
    // TODO Доделать
    /**
     * Обновляет эффекты наведения на компоненты в зависимости от положения курсора.
     */
    Ca(this, "syncHover", (Un, Kn) => {
      if (Un === null) {
        this.dependencies.ui.getUIElementsAll().forEach((Jo) => {
          Jo.disableHover();
        }), Kn == null || Kn.forEach((Jo) => {
          Jo.disableHover(), Jo.type === EditorComponentType.BOOK && Jo.getGraphics().forEach((ma) => {
            ma.pageHeaderDisableHover();
          });
        });
        return;
      }
      if (this.isRunningMutationComponent()) {
        Kn == null || Kn.forEach((qn) => {
          qn.disableHover();
        });
        return;
      }
      if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
        const qn = Un;
        if (qn.type === SpatialCanvasAreaType.BUTTON) {
          Un.getButton().enableHover();
          return;
        }
        const pa = qn.getData().graphic.getParentComponent();
        if (pa === null)
          throw new EditorError("crossed component not found");
        if (Kn === null)
          throw new EditorError("components is null");
        if (pa.type !== EditorComponentType.BOOK) {
          const ma = pa.getParentComponent();
          if (ma === null)
            throw new EditorError("parent component not found");
          if (ma.isUniter && this.dependencies.keyboardObserver.isPressed(KeyCode.CONTROL_LEFT)) {
            Kn.forEach((va) => {
              if (va === ma) {
                va.enableHover();
                return;
              }
              va.disableHover();
            });
            return;
          }
        }
        Kn.forEach((ma) => {
          if (ma === pa) {
            ma.enableHover();
            return;
          }
          ma.disableHover();
        });
      } else if (this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) {
        Kn == null || Kn.forEach((ma) => {
          ma.disableHover(), ma.type === EditorComponentType.BOOK && ma.getGraphics().forEach((ba) => {
            ba.pageHeaderDisableHover();
          });
        });
        const Jo = Un.getData();
        this.dependencies.ui.getUIElementsAll().forEach((ma) => {
          if (ma === Jo) {
            ma.enableHover();
            return;
          }
          ma.disableHover();
        });
      } else
        throw new EditorError("spatial area type not identity");
    });
    /**
     * Отключает фокус у компонентов в фокусе.
     * @param ev Событие мыши.
     */
    Ca(this, "disableFocusComponents", (Un) => {
      const Kn = this.dependencies.componentTree.getFocusComponents();
      Kn == null || Kn.forEach((qn) => {
        Un.altKey || Un.metaKey || qn.disableFocus();
      });
    });
    /**
     * Отключает фокус у компонентов в фокусе и оставляет фокус у компонентов у которых должен остатьтся фокус.
     * @param activeArea
     */
    Ca(this, "disableFocusUIElements", (Un) => {
      this.dependencies.ui.getFocusUIElements().forEach((qn) => {
        this.shouldKeepFocus(qn, Un) || qn.disableFocus();
      });
    });
    /**
     * Проверяет должен ли отключится фокус у элемента.
     * @param element
     * @param activeArea
     */
    Ca(this, "shouldKeepFocus", (Un, Kn) => {
      if (!Un.isEnableResetFocus())
        return !0;
      if (Kn === null)
        return !Un.isEnableResetFocus();
      const qn = Kn.getData(), { type: Jo } = Kn;
      return qn instanceof TopTitleInput && (Un instanceof TopTitleInput || Un instanceof TopRenameButton) || qn instanceof TopRenameButton && (Un instanceof TopTitleInput || Un instanceof TopRenameButton) || (qn instanceof LeftBottomInput || qn instanceof LeftTopInput || qn instanceof RightBottomInput || qn instanceof RightTopInput) && Un instanceof ObjectCornerRadiusButton || qn === Un || Jo === SpatialUIAreaType.EDIT_CORNER ? !0 : Jo === SpatialUIAreaType.PALETTE || Jo === SpatialUIAreaType.COLOREX_COLOR;
    });
    /**
     * Синхронизирует фокус компонентов при отжатии кнопки мыши.
     * @param activeArea
     * @param ev
     */
    Ca(this, "syncFocusMouseUp", (Un, Kn) => {
      if (Un !== null) {
        if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
          const pa = Un.getData().graphic.getParentComponent();
          if (pa === null)
            return;
          if (this.areaPositionMutator.isRunningMutate() && !this.areaPositionMutator.isBlindZoneOverstepping()) {
            const ma = this.dependencies.componentTree.getFocusComponents();
            ma !== null && ma.forEach((va) => {
              Kn.altKey || Kn.metaKey || va !== pa && va.disableFocus();
            });
          }
        } else if (!this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) throw new EditorError("spatial area type not identity");
      }
    });
    /**
     * Обновляет состояния режима редактирования у компонентов.
     */
    Ca(this, "syncEditMode", (Un, Kn, qn) => {
      if (Un === null) {
        Kn.forEach((Jo) => Jo.disableEditMode());
        return;
      }
      if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
        const Jo = Un, ma = Jo.getData().graphic.getParentComponent();
        if (ma === null || Jo.type === SpatialCanvasAreaType.BUTTON)
          return;
        if (ma && qn.type === MouseEventType.DOUBLE_CLICK) {
          ma.enableEditMode(), ma.isUniter && this.dependencies.editModeContext.setCurrentEditContext(ma);
          return;
        }
        if (qn.type === MouseEventType.MOUSE_DOWN) {
          let va = this.dependencies.editModeContext.getCurrentEditContext();
          va && (!ma || !va.isIncludeComponent(ma)) && (this.dependencies.editModeContext.setCurrentEditContext(null), va = null), Kn.forEach((ba) => {
            ba !== va && ba !== ma && ba.disableEditMode();
          });
        }
      } else if (!this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type)) throw new EditorError("spatial area type not identity");
    });
    /**
     * Обработчик события двойного нажатия мыши.
     * @param ev Событие мыши.
     */
    Ca(this, "onDoubleClick", (Un) => {
      const Kn = this.dependencies.componentTree.getComponents(), qn = this.dependencies.areaController.getActiveArea();
      if (this.syncEditMode(qn, Kn, Un), qn === null)
        return;
      const Jo = qn.getData();
      if (Jo === null)
        throw this.dependencies.contextMenu.hide(), new EditorError("area data is null");
      if (Jo.graphic.type === GraphicType.TEXT && Jo.graphic.isEnableEditMode()) {
        const ma = Jo.graphic.getParentComponent();
        if (ma === null)
          throw this.dependencies.contextMenu.hide(), new EditorError("component is null");
        this.dependencies.textSelectionObserver.selectWordToCarriagePosition(ma.getTextModel());
      }
    });
    /**
     * Обработчик события начала отрисовки магнитных линий.
     * @param props
     */
    Ca(this, "onStartMagneticLines", (Un) => {
      this.dependencies.componentTree.hasEditableComponent() || (this.dependencies.magneticLines.start(Un), this.dependencies.render.render());
    });
    /**
     * Возвращает происходит ли в данные момент мутация какого либо компонента.
     */
    Ca(this, "isRunningMutationComponent", () => !!(this.areaPositionMutator.isRunningMutate() || this.areaSizeMutator.isRunningMutate() || this.tableColumnMutator.isRunningMutate()));
    this.magneticPositionCorrector = new MagneticPositionCorrector(), this.areaPositionMutator = new AreaPositionWithCloneMutator(), this.magneticSizeCorrector = new MagneticSizeCorrector(), this.addPostInjectDependenciesListener((Un) => {
      this.tableColumnMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.tableColumnMutator.addStopMutationListener(this.dependencies.componentOrganizer.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.areaController.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.tableColumnMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.tableColumnMutator.addPostMutationListener(this.dependencies.render.renderRelativePositions), this.areaPositionMutator.addStartMutationListener(this.onStartMagneticLines), this.areaPositionMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.areaPositionMutator.addPrevMutationListener(this.magneticPositionCorrector.move), this.areaPositionMutator.addPostMutationListener(Un.render.renderRelativePositions), this.areaPositionMutator.addStopMutationListener(Un.magneticLines.stop), this.areaPositionMutator.addStopMutationListener(this.dependencies.pageTextOverflowObserver.sync), this.areaPositionMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.areaPositionMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.areaSizeMutator.addStartMutationListener(this.dependencies.actionController.startUserAction), this.areaSizeMutator.addStartMutationListener(this.onStartMagneticLines), this.areaSizeMutator.addPrevMutationListener(this.magneticSizeCorrector.move), this.areaSizeMutator.addStopMutationListener(Un.magneticLines.stop), this.areaSizeMutator.addPostMutationListener(Un.ui.sync), this.areaSizeMutator.addPostMutationListener(Un.render.renderRelativePositions), this.areaSizeMutator.addStopMutationListener(this.dependencies.actionController.stopUserAction), this.areaSizeMutator.addStopMutationListener(this.dependencies.pageTextOverflowObserver.sync), this.areaSizeMutator.addStopMutationListener(this.dependencies.pageStructureObserver.sync), this.areaPositionMutator.forceInjectDependencies({
        fnClone: Un.useCases.cloneWithAlt,
        keyboardObserver: Un.keyboardObserver
      }), this.magneticPositionCorrector.forceInjectDependencies({
        mutator: this.areaPositionMutator,
        magneticLines: Un.magneticLines
      }), this.magneticSizeCorrector.forceInjectDependencies({
        mutator: this.areaSizeMutator,
        magneticLines: Un.magneticLines
      });
    });
  }
  onMouseCenterDown(Un) {
  }
  onMouseCenterUp(Un) {
  }
  onMouseRightUp(Un) {
  }
  /**
   * Обновляет эффекты фокуса на компонентах.
   */
  syncFocusMouseDown(Un, Kn) {
    if (Un === null) {
      this.disableFocusComponents(Kn), this.disableFocusUIElements(Un);
      return;
    }
    if (this.areaTypeAnalyzer.isSpatialCanvasAreaType(Un.type)) {
      this.disableFocusUIElements(null);
      const pa = Un.getData().graphic.getParentComponent();
      if (pa === null || pa.type === EditorComponentType.BOOK) {
        this.disableFocusComponents(Kn);
        return;
      }
      !pa.isEnableFocus() && this.disableFocusComponents(Kn);
      const va = pa.getParentComponent();
      if (va != null && va.isUniter && va.isEnableEditMode()) {
        const ba = va.getComponents();
        if (!ba)
          return;
        ba.forEach((_a) => {
          var ya;
          _a.type === EditorComponentType.TABLE && ((ya = _a.getFocusCellContexts()) == null || ya.forEach((xa) => {
            xa.disableFocus();
          })), _a.disableFocus();
        }), pa.enableFocus();
        return;
      }
      if (pa.isUniter && pa.isEnableEditMode()) {
        const ba = pa.getComponents();
        if (!ba) return;
        ba.forEach((_a) => {
          var ya;
          _a.type === EditorComponentType.TABLE && ((ya = _a.getFocusCellContexts()) == null || ya.forEach((xa) => {
            xa.disableFocus();
          })), _a.disableFocus();
        }), pa.enableFocus();
        return;
      }
      pa.enableFocus();
    } else if (this.areaTypeAnalyzer.isSpatialUIAreaType(Un.type))
      this.disableFocusUIElements(Un);
    else
      throw new EditorError("spatial area type not identity");
  }
}
class TeamTemplateKeyboardObserver extends KeyboardObserver {
  constructor() {
    super();
    Ca(this, "onCtrlG", (Un) => {
      Un.preventDefault(), this.dependencies.useCases.groupFocusComponents();
    });
    Ca(this, "onDelete", (Un) => {
      Un.preventDefault(), this.dependencies.useCases.removeFocusComponentsWithAnimate();
    });
    Ca(this, "onEscape", () => {
      this.dependencies.useCases.disableInjectingProcess(), this.dependencies.useCases.disableComponentsFocus();
    });
    Ca(this, "onCopy", async (Un) => {
      Un.preventDefault(), await this.dependencies.useCases.copy();
    });
    Ca(this, "onPaste", async (Un) => {
      Un.preventDefault(), await this.dependencies.useCases.pasteFromKeyboardHotkey();
    });
    Ca(this, "onCut", (Un) => {
      Un.preventDefault();
    });
    Ca(this, "enableMaintainAspectRatioFocusComponents", () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          qn.enableMaintainAspectRatio();
        });
      });
    });
    Ca(this, "disableMaintainAspectRatioFocusComponents", () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      Un !== null && Un.forEach((Kn) => {
        Kn.getGraphics().forEach((qn) => {
          qn.disableMaintainAspectRatio();
        });
      });
    });
    Ca(this, "onOpenAiModal", () => {
    });
    this.addPostInjectDependenciesListener((Un) => {
      const { useCases: Kn } = Un;
      this.addPostKeyDownListener(Kn.moveCarriageLeft, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageTop, KeyCode.ARROW_UP), this.addPostKeyDownListener(Kn.moveCarriageRight, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(Kn.moveCarriageSelectionRight, KeyCode.SHIFT_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(
        Kn.moveCarriageSelectionWordRight,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.ARROW_RIGHT
      ), this.addPostKeyDownListener(Kn.moveCarriageSelectionLeft, KeyCode.SHIFT_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.selectAllText, KeyCode.CONTROL_LEFT, KeyCode.KEY_A), this.addPostKeyDownListener(
        Kn.moveCarriageSelectionWordLeft,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.ARROW_LEFT
      ), this.addPostKeyDownListener(Kn.removeWordLeft, KeyCode.CONTROL_LEFT, KeyCode.BACKSPACE), this.addPostKeyDownListener(Kn.moveCarriageBottom, KeyCode.ARROW_DOWN), this.addPostKeyDownListener(Kn.moveCarriageWordLeft, KeyCode.CONTROL_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageWordLeft, KeyCode.META_LEFT, KeyCode.ARROW_LEFT), this.addPostKeyDownListener(Kn.moveCarriageWordRight, KeyCode.CONTROL_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(Kn.moveCarriageWordRight, KeyCode.META_LEFT, KeyCode.ARROW_RIGHT), this.addPostKeyDownListener(this.onCtrlG, KeyCode.CONTROL_LEFT, KeyCode.KEY_G), this.addPostKeyDownListener(Kn.runInjectText, KeyCode.SHIFT_LEFT, KeyCode.KEY_T), this.addPostKeyDownListener(Kn.runInjectPicture, KeyCode.SHIFT_LEFT, KeyCode.KEY_K), this.addPostKeyDownListener(Kn.runInjectFigure, KeyCode.SHIFT_LEFT, KeyCode.KEY_F), this.addPostKeyDownListener(Kn.runInjectLine, KeyCode.SHIFT_LEFT, KeyCode.KEY_L), this.addPostKeyDownListener(
        Kn.ungroupFocusComponents,
        KeyCode.CONTROL_LEFT,
        KeyCode.SHIFT_LEFT,
        KeyCode.KEY_G
      ), this.addPostKeyDownListener(this.onDelete, KeyCode.DELETE), this.addPostKeyDownListener(this.onEscape, KeyCode.ESCAPE), this.addPostKeyDownListener(Kn.undo, KeyCode.CONTROL_LEFT, KeyCode.KEY_Z), this.addPostKeyDownListener(Kn.redo, KeyCode.CONTROL_LEFT, KeyCode.SHIFT_LEFT, KeyCode.KEY_Z), this.addPostKeyDownListener(this.onCopy, KeyCode.CONTROL_LEFT, KeyCode.KEY_C), this.addPostKeyDownListener(this.onPaste, KeyCode.CONTROL_LEFT, KeyCode.KEY_V), this.addPostKeyDownListener(this.onCopy, KeyCode.META_LEFT, KeyCode.KEY_C), this.addPostKeyDownListener(this.onPaste, KeyCode.META_LEFT, KeyCode.KEY_V);
    });
  }
}
class TeamTemplateContextMenu extends ContextMenuView {
  constructor() {
    super();
    Ca(this, "area");
    Ca(this, "currentMousePosition");
    Ca(this, "currentActiveArea");
    Ca(this, "currentCrossGraphic");
    Ca(this, "currentCrossComponent");
    Ca(this, "getSpatialArea", () => (this.area === null && (this.area = new SpatialContextMenuArea(this), this.area.markDirty()), this.area));
    Ca(this, "show", () => {
      if (this.hide(), this.isShow = !0, this.currentMousePosition = this.dependencies.uiMouseObserver.getCurrentPosition(), this.currentActiveArea = this.dependencies.areaController.getActiveArea(), this.currentCrossGraphic = null, this.currentCrossComponent = null, this.currentActiveArea !== null && Object.values(SpatialCanvasAreaType).includes(this.currentActiveArea.type)) {
        const Un = this.currentActiveArea.getData(), Kn = Un.graphic.getParentComponent();
        this.currentCrossGraphic = Un.graphic, this.currentCrossComponent = Kn;
      }
      this.coordinateMenuForShow(), this.updateSpatialAreasPosition();
    });
    Ca(this, "updateSpatialAreasPosition", () => {
      if (this.area !== null) {
        this.area.markDirty();
        for (let Un = 0; Un < this.buttons.length; Un++)
          this.buttons[Un].getSpatialArea().markDirty();
      }
    });
    Ca(this, "coordinateMenuForShow", () => {
      if (this.currentCrossComponent === null || this.currentCrossGraphic === null || this.currentCrossGraphic.type === GraphicType.PAGE) {
        this.showDefaultMenu(this.currentMousePosition), this.dependencies.render.renderRelativePositions();
        return;
      }
      if (this.currentCrossComponent.type === EditorComponentType.TABLE && this.currentActiveArea && this.currentCrossComponent.getFocusCellContexts() !== null) {
        this.showTableMenu(this.currentMousePosition, this.currentCrossComponent), this.dependencies.render.renderRelativePositions();
        return;
      }
      this.showComponentMenu(this.currentMousePosition, this.currentCrossComponent), this.dependencies.render.renderRelativePositions();
    });
    Ca(this, "onMergeCells", async () => {
      await this.dependencies.useCases.mergeFocusCell(this.currentCrossComponent);
    });
    Ca(this, "onSplitCells", async () => {
      await this.dependencies.useCases.splitFocusCells(this.currentCrossComponent);
    });
    Ca(this, "onSplitTable", async () => {
      await this.dependencies.useCases.splitTable(
        this.currentCrossComponent,
        this.currentActiveArea
      );
    });
    Ca(this, "onDeleteRow", async () => {
      await this.dependencies.useCases.deleteFocusRows(this.currentCrossComponent);
    });
    Ca(this, "onAddColumnRight", async () => {
      await this.dependencies.useCases.addColumnAfter(this.currentCrossComponent);
    });
    Ca(this, "onAddColumnLeft", async () => {
      await this.dependencies.useCases.addColumnBefore(this.currentCrossComponent);
    });
    Ca(this, "onAddRowBelow", async () => {
      await this.dependencies.useCases.addRowUnder(this.currentCrossComponent);
    });
    Ca(this, "onAddRowAbove", async () => {
      await this.dependencies.useCases.addRowOver(this.currentCrossComponent);
    });
    Ca(this, "onDeleteColumn", async () => {
      await this.dependencies.useCases.deleteFocusColumns(this.currentCrossComponent);
    });
    Ca(this, "onCopy", async () => {
      await this.dependencies.useCases.copy();
    });
    Ca(this, "onPaste", async () => {
      const Un = this.currentMousePosition;
      await this.dependencies.useCases.pasteAtPosition(Un);
    });
    Ca(this, "onDelete", () => {
      this.dependencies.useCases.removeFocusComponentsWithAnimate();
    });
    Ca(this, "onGroup", async () => {
      await this.dependencies.useCases.groupFocusComponents();
    });
    Ca(this, "onUngroup", async () => {
      await this.dependencies.useCases.ungroupFocusComponents();
    });
    Ca(this, "onGraphicForward", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveForwardGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicBack", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveBackGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicForeground", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveToForegroundGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onGraphicBackground", async () => {
      this.currentCrossGraphic && await this.dependencies.useCases.moveToBackgroundGraphics(this.currentCrossGraphic);
    });
    Ca(this, "onModule", async () => {
      if (this.currentCrossComponent === null)
        throw new EditorError("component is null");
      await this.dependencies.useCases.createModule();
    });
    this.area = null, this.addPostInjectDependenciesListener(() => {
      this.copy.addPostMouseDownListeners(this.onCopy), this.paste.addPostMouseDownListeners(this.onPaste), this.delete.addPostMouseDownListeners(this.onDelete), this.group.addPostMouseDownListeners(this.onGroup), this.ungroup.addPostMouseDownListeners(this.onUngroup), this.moveForward.addPostMouseDownListeners(this.onGraphicForward), this.moveBack.addPostMouseDownListeners(this.onGraphicBack), this.planToBack.addPostMouseDownListeners(this.onGraphicBackground), this.planToForward.addPostMouseDownListeners(this.onGraphicForeground), this.createModule.addPostMouseDownListeners(this.onModule), this.mergeCells.addPostMouseDownListeners(this.onMergeCells), this.splitCells.addPostMouseDownListeners(this.onSplitCells), this.splitTable.addPostMouseDownListeners(this.onSplitTable), this.addColumnRight.addPostMouseDownListeners(this.onAddColumnRight), this.addColumnLeft.addPostMouseDownListeners(this.onAddColumnLeft), this.addRowBelow.addPostMouseDownListeners(this.onAddRowBelow), this.addRowAbove.addPostMouseDownListeners(this.onAddRowAbove), this.deleteRow.addPostMouseDownListeners(this.onDeleteRow), this.deleteColumn.addPostMouseDownListeners(this.onDeleteColumn);
    }), this.currentMousePosition = { x: 0, y: 0 }, this.currentActiveArea = null, this.currentCrossGraphic = null, this.currentCrossComponent = null;
  }
  callClick() {
  }
}
class TeamTemplateTemplateMenu extends Dependent {
  constructor() {
    super();
    Ca(this, "DEFAULT_FILL", UIDefaultColor.WHITE);
    Ca(this, "DEFAULT_PADDING_VERTICAL", 10);
    Ca(this, "DEFAULT_WIDTH", 160);
    Ca(this, "DEFAULT_HEIGHT", 50);
    Ca(this, "DEFAULT_CORNER_RADIUS", 8);
    Ca(this, "container");
    Ca(this, "offerButton");
    Ca(this, "pdfButton");
    Ca(this, "area");
    Ca(this, "position");
    Ca(this, "isVisible");
    Ca(this, "isHover");
    Ca(this, "isFocus");
    Ca(this, "isResetFocus");
    Ca(this, "getGlobalPosition", () => ({
      x: this.container.object.left,
      y: this.container.object.top
    }));
    Ca(this, "enableResetFocus", () => {
      this.isResetFocus || (this.isResetFocus = !0);
    });
    Ca(this, "disableResetFocus", () => {
      this.isResetFocus && (this.isResetFocus = !1);
    });
    Ca(this, "isEnableResetFocus", () => this.isResetFocus);
    Ca(this, "setPosition", (Un) => {
      this.container.object.set({
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_PADDING_VERTICAL * 2 + this.offerButton.getHeight() + this.pdfButton.getHeight()
      }), this.container.relativePosition = {
        x: Un.x - this.container.object.width,
        y: Un.y
      };
      let Kn = this.DEFAULT_PADDING_VERTICAL;
      this.offerButton.setConfiguration((qn) => ({
        ...qn,
        x: -this.container.object.width,
        y: this.DEFAULT_PADDING_VERTICAL
      })), Kn += this.offerButton.getHeight(), this.pdfButton.setConfiguration((qn) => ({
        ...qn,
        x: -this.container.object.width,
        y: Kn
      })), this.position = Un;
    });
    Ca(this, "getFabricObjects", () => [
      this.container.object,
      ...this.offerButton.getFabricObjects(),
      ...this.pdfButton.getFabricObjects()
    ]);
    Ca(this, "getObjects", () => [
      this.container,
      ...this.offerButton.getObjects(),
      ...this.pdfButton.getObjects()
    ]);
    Ca(this, "show", () => {
      this.isVisible || (this.isVisible = !0, this.container.object.visible = !0, this.pdfButton.show(), this.offerButton.show());
    });
    Ca(this, "hide", () => {
      this.isVisible && (this.isVisible = !1, this.container.object.visible = !1, this.offerButton.hide(), this.pdfButton.hide());
    });
    Ca(this, "getRelativePosition", () => this.position);
    Ca(this, "getFrameArea", () => ({
      x: this.container.object.left,
      y: this.container.object.top,
      width: this.container.object.width,
      height: this.container.object.height,
      rotate: 0
    }));
    Ca(this, "getSpatialArea", () => this.area);
    Ca(this, "getUIElements", () => [this.offerButton, this.pdfButton]);
    Ca(this, "isShowed", () => this.isVisible);
    this.area = new SpatialTemplateMenuArea(this), this.isVisible = !1, this.isHover = !1, this.isFocus = !1, this.isResetFocus = !0, this.position = { x: 0, y: 0 }, this.pdfButton = new TemplateMenuPDFButton(), this.offerButton = new TemplateMenuOfferButton(), this.container = {
      object: new pr({
        width: this.DEFAULT_WIDTH,
        height: this.DEFAULT_HEIGHT,
        fill: this.DEFAULT_FILL,
        shadow: UIShadowDefault,
        rx: this.DEFAULT_CORNER_RADIUS,
        ry: this.DEFAULT_CORNER_RADIUS,
        visible: !1
      }),
      relativePosition: { x: 0, y: 0 }
    }, this.addPostInjectDependenciesListener((Un) => {
      const { render: Kn, onDownloadPDF: qn, onSendOffer: Jo } = Un;
      this.pdfButton.forceInjectDependencies({ render: Kn, onDownloadPDF: qn }), this.offerButton.forceInjectDependencies({ render: Kn, onSendOffer: Jo });
    });
  }
  enableFocus() {
  }
  disableFocus() {
  }
  enableHover() {
  }
  disableHover() {
  }
  isEnableFocus() {
    return !1;
  }
  isEnableHover() {
    return !1;
  }
  callClick() {
  }
}
class TeamTemplateDesktopUI extends DesktopUI {
  constructor() {
    super();
    Ca(this, "DEFAULT_MARGIN_PANEL", 8);
    Ca(this, "topBar");
    Ca(this, "toolBar");
    Ca(this, "propertyPageBar");
    Ca(this, "propertyObjectBar");
    Ca(this, "propertyFigureBar");
    Ca(this, "propertyTextBar");
    Ca(this, "propertyTableBar");
    Ca(this, "propertyLineBar");
    Ca(this, "generationHint");
    Ca(this, "templateMenu");
    Ca(this, "tableConstructor");
    Ca(this, "undoButton");
    Ca(this, "redoButton");
    Ca(this, "disableFocusAIModal", () => {
      this.toolBar.getUIElements().forEach((Un) => Un.disableFocus());
    });
    Ca(this, "getSpatialAreas", () => {
      const Un = this.getUIElementsAll(), Kn = [];
      for (let qn = 0; qn < Un.length; qn++)
        Un[qn].isShowed() && (Kn.push(Un[qn].getSpatialArea()), Un[qn] instanceof ColorInput && Un[qn].isEnableShowPalette() && Kn.push(...Un[qn].getSpatialAreasPalette()));
      return Kn;
    });
    Ca(this, "getObjects", () => [
      // 1 слой контейнеры панелей
      ...this.toolBar.getFabricObjects(),
      this.propertyPageBar.getContainer(),
      this.propertyObjectBar.getContainer(),
      this.propertyFigureBar.getContainer(),
      this.propertyTextBar.getContainer(),
      this.propertyTableBar.getContainer(),
      this.propertyLineBar.getContainer(),
      this.topBar.getFabricContainer(),
      // 2 слой кнопки и заголовки
      // ...this.toolBar.getPanels().map(panel => panel.getButtons()).flat(),
      ...this.propertyPageBar.getContentElements(),
      ...this.propertyObjectBar.getContentElements(),
      ...this.propertyFigureBar.getContentElements(),
      ...this.propertyTableBar.getContentElements(),
      ...this.propertyLineBar.getContentElements(),
      ...this.propertyTextBar.getContentElements(),
      ...this.topBar.getFabricContentElements(),
      // 3 слой модалки, палитра и т.д.
      ...this.tableConstructor.getFabricObjects(),
      ...this.colorexCore.getFabricObjects(),
      ...this.generationHint.getFabricObjects(),
      ...this.templateMenu.getFabricObjects(),
      ...this.colorexCore.getFabricObjects(),
      ...this.editCornerObject.getFabricObjects(),
      ...this.socketIndicator.getFabricObject(),
      ...this.dependencies.contextMenu.getFabricObjects()
    ]);
    Ca(this, "sync", async () => {
      if (this.toolBar.sync(), this.topBar.syncPosition(), this.propertyPageBar.syncPosition(), this.propertyObjectBar.syncPosition(), this.propertyFigureBar.syncPosition(), this.propertyTextBar.syncPosition(), this.propertyTableBar.syncPosition(), this.propertyLineBar.syncPosition(), !this.isShowed())
        return;
      const Un = this.dependencies.componentTree.getFocusComponents(), Kn = this.dependencies.actionStore.getUndoCommandCount(), qn = this.dependencies.actionStore.getRedoCommandCount(), Jo = this.dependencies.componentTree.getRootComponent().getFirstGraphic();
      if (Kn < 1 ? this.undoButton.setIsEnableClick(!1) : this.undoButton.setIsEnableClick(!0), qn < 1 ? this.redoButton.setIsEnableClick(!1) : this.redoButton.setIsEnableClick(!0), Un === null) {
        Jo && (this.propertyPageBar.syncComponent(Jo), this.propertyPageBar.show()), this.propertyObjectBar.hide(), this.hidePanelsExcept(this.propertyPageBar);
        return;
      }
      this.propertyPageBar.hide(), this.propertyObjectBar.show(), this.propertyObjectBar.syncComponent(Un);
      const pa = Un[0];
      Un.every((va) => va.type === pa.type) && this.syncForSameComponentType(Un, pa.type), this.toolBar.show(), this.topBar.show();
    });
    Ca(this, "setActiveTariff", (Un) => {
      Un || this.topBar.setState(TopBarState.AI_PDF);
    });
    Ca(this, "setStateLoadingSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.LOADING);
    });
    Ca(this, "setStateSuccessSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.SUCCESS);
    });
    Ca(this, "setStateErrorSaveTemplate", () => {
      this.socketIndicator.setState(SocketIndicatorState.ERROR);
    });
    Ca(this, "setNameTemplate", (Un) => {
      this.topBar.setTitle(Un);
    });
    Ca(this, "getUIElements", () => [
      ...this.toolBar.getUIElements(),
      this.colorexCore,
      this.tableConstructor,
      this.propertyTextBar,
      this.propertyFigureBar,
      this.propertyObjectBar,
      this.propertyPageBar,
      this.propertyTableBar,
      this.propertyLineBar,
      this.topBar,
      this.templateMenu,
      this.editCornerObject,
      this.dependencies.contextMenu,
      this.socketIndicator
    ]);
    // Метод возвращает общий массив со всеми элементами интерфейса (включает все дочерние элементы внутри панелей)
    Ca(this, "getUIElementsAll", () => {
      const Un = [], Kn = this.getUIElements();
      for (let qn = 0; qn < Kn.length; qn++)
        Un.push(Kn[qn]), Un.push(...this.getChildrenAllUIElements(Kn[qn]));
      return [...Un];
    });
    Ca(this, "getChildrenAllUIElements", (Un) => {
      const Kn = [], qn = Un.getUIElements();
      for (const Jo of qn)
        Kn.push(Jo), Kn.push(...this.getChildrenAllUIElements(Jo));
      return Kn;
    });
    Ca(this, "getFocusUIElements", () => [
      ...this.toolBar.getUIElements(),
      this.tableConstructor,
      ...this.tableConstructor.getUIElements(),
      this.propertyTextBar,
      ...this.propertyTextBar.getFocusUIElements(),
      this.propertyPageBar,
      ...this.propertyPageBar.getFocusUIElements(),
      this.propertyFigureBar,
      ...this.propertyFigureBar.getFocusUIElements(),
      this.propertyObjectBar,
      ...this.propertyObjectBar.getFocusUIElements(),
      // this.colorexPalette,
      // ...this.colorexPalette.getFocusUIElements(),
      this.topBar,
      ...this.topBar.getFocusUIElements(),
      this.propertyTableBar,
      ...this.propertyTableBar.getFocusUIElements(),
      this.propertyLineBar,
      ...this.propertyLineBar.getFocusUIElements(),
      ...this.editCornerObject.getFocusUIElements()
    ]);
    /**
     * Синхронизировать интерфейс для компонентов одного типа.
     * @param components - компоненты для сканирования.
     * @param type - тип компонентов.
     * @private
     */
    Ca(this, "syncForSameComponentType", (Un, Kn) => {
      switch (Kn) {
        case EditorComponentType.TABLE: {
          const qn = [];
          Un.forEach((Jo) => {
            const pa = Jo.getFocusCellContexts();
            pa !== null && qn.push(...pa);
          }), this.propertyTextBar.syncComponent(qn), this.propertyTextBar.setConfiguration((Jo) => ({
            ...Jo,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTextBar.show(), this.propertyTableBar.syncComponent(Un), this.propertyTableBar.setConfiguration((Jo) => ({
            ...Jo,
            marginTop: this.propertyTextBar.getGlobalPosition().y + this.propertyTextBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTableBar.show(), this.hidePanelsExcept(this.propertyTextBar, this.propertyTableBar);
          break;
        }
        case EditorComponentType.TEXT:
          this.propertyTextBar.syncComponent(Un), this.propertyTextBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyTextBar.show(), this.hidePanelsExcept(this.propertyTextBar);
          break;
        case EditorComponentType.FIGURE:
          this.propertyFigureBar.syncComponent(Un), this.propertyFigureBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyFigureBar.show(), this.hidePanelsExcept(this.propertyFigureBar);
          break;
        case EditorComponentType.LINE:
          this.propertyLineBar.syncComponent(Un), this.propertyLineBar.setConfiguration((qn) => ({
            ...qn,
            marginTop: this.propertyObjectBar.getGlobalPosition().y + this.propertyObjectBar.getHeight() + this.DEFAULT_MARGIN_PANEL
          })), this.propertyLineBar.show();
          break;
        case EditorComponentType.GROUP:
          this.propertyObjectBar.hide(), this.hideAllPanels();
          break;
        case EditorComponentType.BOOK:
          this.hideAllPanels();
          break;
        case EditorComponentType.MODULE:
          this.hideAllPanels();
          break;
        case EditorComponentType.PICTURE:
          this.hideAllPanels();
          break;
      }
    });
    this.toolBar = new ToolBar(), this.topBar = new TopBar(), this.generationHint = new GenerationHint(), this.templateMenu = new TeamTemplateTemplateMenu(), this.propertyPageBar = new PropertyPageBar(), this.propertyObjectBar = new PropertyObjectBar(), this.propertyFigureBar = new PropertyFigureBar(), this.propertyTextBar = new PropertyTextBar(), this.propertyTableBar = new PropertyTableBar(), this.propertyLineBar = new PropertyLineBar(), this.tableConstructor = new TableConstructorView();
    const Un = new ToolUndoButton(), Kn = new ToolRedoButton();
    this.undoButton = Un, this.redoButton = Kn, this.propertyPanels.push(
      this.propertyPageBar,
      this.propertyFigureBar,
      this.propertyTextBar,
      this.propertyTableBar,
      this.propertyLineBar
    ), this.addPostInjectDependenciesListener((qn) => {
      const {
        render: Jo,
        useCases: pa,
        textEngine: ma,
        onOpenModulesModal: va,
        onBackPage: ba,
        onDownloadPDF: _a,
        onSendOffer: ya,
        onOpenCreateCustomTableWindow: xa,
        onGoToTariff: wa,
        onGetGenerationHintStructure: Ta,
        onSetNameTemplate: Sa,
        actionController: Ma,
        onOpenAIActionsModal: ka,
        onCloseAIActionsModal: Za
      } = qn;
      this.tableConstructor.forceInjectDependencies({
        useCases: pa,
        render: qn.render,
        onOpenCreateCustomTableWindow: xa
      });
      const Na = new ToolPanel().forceInjectDependencies({ render: Jo }), Ka = new ToolAIButton().forceInjectDependencies({
        render: Jo,
        onOpenAIActionsModal: ka,
        onCloseAIActionsModal: Za
      }), Ja = new ToolPanel().forceInjectDependencies({ render: Jo }), el = new ToolTextButton().forceInjectDependencies({
        render: Jo,
        useCases: pa
      }), qa = new ToolTableButton().forceInjectDependencies({
        render: Jo,
        useCases: pa,
        tableConstructor: this.tableConstructor
      });
      qa.enableClickFocus();
      const tl = new ToolPictureButton().forceInjectDependencies({ render: Jo, useCases: pa }), Qa = new ToolRectangleButton().forceInjectDependencies({ render: Jo, useCases: pa }), nl = new ToolLineButton().forceInjectDependencies({ render: Jo, useCases: pa }), rl = new ToolPanel();
      Un.forceInjectDependencies({ render: Jo, useCases: pa }), Un.disableClickFocus(), Kn.forceInjectDependencies({ render: Jo, useCases: pa }), Kn.disableClickFocus();
      const il = new ToolPanel(), cl = new ToolModuleButton().forceInjectDependencies({ render: Jo, onOpenModulesModal: va });
      Ja.addButtons(el, qa, tl, Qa, nl), Na.addButtons(Ka), rl.addButtons(Un, Kn), il.addButtons(cl), this.toolBar.addPanel(Na), this.toolBar.addPanel(Ja), this.toolBar.addPanel(rl), this.toolBar.addPanel(il), this.bars.push(...this.toolBar.getPanels(), this.topBar, this.propertyObjectBar), this.propertyPageBar.forceInjectDependencies({
        useCases: pa,
        render: Jo,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyObjectBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        textEngine: ma,
        editCornerObject: this.editCornerObject
      }), this.propertyFigureBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyTextBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.propertyTableBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore
      }), this.propertyLineBar.forceInjectDependencies({
        render: Jo,
        useCases: pa,
        core: this.colorexCore,
        textEngine: ma
      }), this.topBar.forceInjectDependencies({
        render: Jo,
        templateMenu: this.templateMenu,
        generationHint: this.generationHint,
        useCases: pa,
        onBackPage: ba,
        textEngine: ma,
        onSetNameTemplate: Sa,
        actionController: Ma,
        onGetGenerationHintStructure: Ta
      }), this.topBar.show(), this.templateMenu.forceInjectDependencies({ render: Jo, onDownloadPDF: _a, onSendOffer: ya }), this.colorexCore.forceInjectDependencies({
        render: Jo
      }), this.generationHint.forceInjectDependencies({ render: Jo, onGoToTariff: wa, onGetGenerationHintStructure: Ta }), this.editCornerObject.forceInjectDependencies({
        render: Jo,
        textEngine: ma,
        useCases: pa
      }), this.socketIndicator.forceInjectDependencies({
        render: Jo
      }), this.socketIndicator.show(), this.socketIndicator.sync();
    });
  }
}
class TeamTemplateUseCases extends BookUseCases {
  constructor() {
    super();
    Ca(this, "tableSplitter");
    Ca(this, "xlsxTableImporter");
    Ca(this, "xlsxTableReplacer");
    /**
     * Создаёт модуль из компонентов в фокусе. При создании модуля из одного uniter компонента (например это компонент
     * группы) этот компонент конвертируется в компонент модуля, т.к. никакого смысла в группе нет в данном случае.
     */
    Ca(this, "createModule", async () => {
      const Un = this.dependencies.componentTree.getFocusComponents();
      if (Un === null)
        return;
      const qn = (await this.dependencies.moduleBuilder.build(...Un)).getUniqueStructure();
      this.dependencies.onOpenCreateModuleWindow(async (Jo) => {
        const pa = new ComponentPreviewEditor({
          imageFileSourcePrefix: this.dependencies.imageFileSourcePrefix
        });
        await pa.setStructure({
          id: "preview",
          name: "preview",
          root: qn
        });
        const ma = await pa.getPreview();
        Jo(ma);
      }, qn);
    });
    Ca(this, "injectModule", async (Un) => {
      this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.injectModule(Un), this.dependencies.componentInjector.addSingleUseInjectListener(async () => {
        await this.dependencies.componentOrganizer.sync(), await this.dependencies.actionController.stopUserAction();
      });
    });
    Ca(this, "splitTable", async (Un, Kn) => {
      this.dependencies.actionController.startUserAction(), await this.tableSplitter.splitTable(Un, Kn);
    });
    Ca(this, "replaceTablesFromXLSX", async () => {
      const Un = this.dependencies.componentTree.getUniformFocusComponents(EditorComponentType.TABLE);
      Un !== null && await this.xlsxTableReplacer.replaceTable(Un);
    });
    /**
     * Запускает процесс выбора XLSX файла пользователем и создания таблиц из его структуры.
     * В случае, если в файле несколько листов, то будет создано несколько таблиц.
     */
    Ca(this, "createTableFromXLSX", () => {
      this.xlsxTableImporter.getStructure((Un) => {
        const { rowCount: Kn, columnCount: qn, cells: Jo } = Un[0];
        Jo.length < 1 || (this.dependencies.actionController.startUserAction(), this.dependencies.componentInjector.injectTable(Kn, qn, Jo), this.dependencies.componentInjector.addSingleUseInjectListener(this.dependencies.actionController.stopUserAction));
      });
    });
    this.tableSplitter = new BookTableSplitter(), this.xlsxTableImporter = new XLSXTableImporter(), this.xlsxTableReplacer = new BookTableReplacer(), this.addPostInjectDependenciesListener((Un) => {
      const { onUploadXlsxFile: Kn, componentOrganizer: qn, areaController: Jo, actionController: pa, componentTree: ma } = Un;
      this.xlsxTableReplacer.forceInjectDependencies({
        xlsxTableImporter: this.xlsxTableImporter,
        areaController: Jo,
        sketchStabilizer: pa,
        componentOrganizer: qn
      }), this.tableSplitter.forceInjectDependencies({
        componentTree: ma,
        areaController: Jo,
        actionController: pa,
        componentOrganizer: qn
      }), this.xlsxTableImporter.forceInjectDependencies({
        onUploadXlsxFile: Kn
      }), this.addPostApplyToGraphicListener((va) => {
        va.type === EditorComponentType.TABLE && this.dependencies.componentOrganizer.sync();
      });
    });
  }
}
class TeamTemplateEditor extends DynamicEditor {
  constructor(Un) {
    super(Un.editorContainer);
    Ca(this, "state");
    Ca(this, "cursorView");
    Ca(this, "actionStore");
    Ca(this, "textImporter");
    Ca(this, "ui");
    Ca(this, "moduleBuilder");
    Ca(this, "magneticLines");
    Ca(this, "cursor");
    Ca(this, "copyController");
    Ca(this, "bookOrganizer");
    Ca(this, "editModeContext");
    Ca(this, "injectorFactory");
    Ca(this, "componentCloner");
    Ca(this, "pictureImporter");
    Ca(this, "pictureReplacer");
    Ca(this, "pasteController");
    Ca(this, "tableGridMutator");
    Ca(this, "componentBuilder");
    Ca(this, "componentGrouper");
    Ca(this, "actionController");
    Ca(this, "actionRepository");
    Ca(this, "selectionArea");
    Ca(this, "htmlTableImporter");
    Ca(this, "htmlTableReplacer");
    Ca(this, "componentInjector");
    Ca(this, "modulePlaceHolder");
    Ca(this, "keyboardVisualizer");
    Ca(this, "contextMenu");
    Ca(this, "textActionInitiator");
    Ca(this, "componentOrganizer");
    Ca(this, "useCases");
    Ca(this, "componentTree");
    Ca(this, "layerRegistry");
    Ca(this, "graphicFactory");
    Ca(this, "keyboardObserver");
    /**
     * Отключает фокус у кнопки открытия AI
     */
    Ca(this, "disableFocusAIModal", () => {
      this.ui.disableFocusAIModal();
    });
    /**
     * Вставляет модуль в редактор шаблона.
     *
     * @param {AnyComponentStructure} structure - Структура компонента, который необходимо вставить.
     */
    Ca(this, "injectModule", async (Un) => {
      await this.useCases.injectModule(Un);
    });
    /**
     * Создает таблицу с полученным кол-вом строк и столбцов.
     * @param columnCount - кол-во столбцов.
     * @param rowCount - кол-во строк.
     */
    Ca(this, "createTable", (Un, Kn) => {
      this.useCases.createEmptyTable(Kn, Un);
    });
    /**
     * Устанавливает состояние загрузки сохранения шаблона.
     */
    Ca(this, "setStateLoadingSaveTemplate", () => {
      this.ui.setStateLoadingSaveTemplate();
    });
    /**
     * Устанавливает состояние успешного сохранения шаблона.
     */
    Ca(this, "setStateSuccessSaveTemplate", () => {
      this.ui.setStateSuccessSaveTemplate();
    });
    /**
     * Устанавливает состояние ошибки сохранения шаблона.
     */
    Ca(this, "setStateErrorSaveTemplate", () => {
      this.ui.setStateErrorSaveTemplate();
    });
    /**
     * Устанавливает структуру шаблона редактора и обновляет отображение.
     *
     * Этот метод загружает переданную структуру, устанавливает её идентификатор и имя,
     * затем обновляет дерево компонентов и интерфейс редактора.
     *
     * @param editorStructure - Объект структуры редактора, содержащий конфигурацию и содержимое.
     */
    Ca(this, "setStructure", async (Un) => {
      const Kn = _$2.cloneDeep(Un), { id: qn, name: Jo } = Kn;
      this.setID(qn), this.setName(Jo), this.state.setSketchID(qn), this.componentCloner.forceInjectDependencies({
        toPasteSketchID: qn,
        componentTree: this.componentTree,
        graphicFactory: this.graphicFactory,
        componentFactory: this.componentFactory,
        mouseObserver: this.canvasMouseObserver
      }), await this.componentTree.load(Kn.root);
      const pa = this.componentTree.getRootComponent();
      this.bookOrganizer.connectDependencies({
        book: pa,
        render: this.canvasRender,
        canvas: this.canvas
      }), this.bookOrganizer.injectDependencies(), this.addPostResizeWindowListener(this.bookOrganizer.sync), this.canvasRender.render(), this.uiRender.render(), pa.syncPagePanels(), this.bookOrganizer.sync(), await this.areaController.sync(), this.state.syncState(), this.ui.setNameTemplate(Kn.name), await this.ui.sync(), this.uiRender.render(), await this.ui.sync(), this.layerVisualizer.sync(), this.callPostSetStructureListeners();
    });
    Ca(this, "savePreview", async (Un, Kn) => {
      const qn = new ContentConverterEditor({
        imageFileSourcePrefix: Un,
        isEnableMouseWheel: !1,
        isCanvasHeightAdaptive: !0
      }), Jo = this.getStructure();
      await qn.setStructure(Jo);
      const pa = await qn.getFirstPageImage();
      Kn(pa);
    });
    this.state = new SketchState(), this.actionStore = new ActionStore(), this.textImporter = new TextImporter(), this.ui = new TeamTemplateDesktopUI(), this.moduleBuilder = new ModuleBuilder(), this.cursor = new TeamTemplateCursor(), this.layerRegistry = new BookLayerRegistry(), this.editModeContext = new EditModeContext(), this.injectorFactory = new InjectorFactory(), this.pictureImporter = new PictureImporter(), this.pictureReplacer = new PictureReplacer(), this.actionRepository = new ActionRepository(), this.bookOrganizer = new BookModeOrganizer(), this.textActionInitiator = new TextActionInitiator(), this.useCases = new TeamTemplateUseCases(), this.tableGridMutator = new TableGridMutator(), this.copyController = new CopyController(), this.pasteController = new PasteController(), this.selectionArea = new ComponentSelectorArea(), this.componentInjector = new ComponentInjector(), this.htmlTableImporter = new HTMLTableImporter(), this.htmlTableReplacer = new HTMLTableReplacer(), this.graphicFactory = new DynamicGraphicFactory(), this.componentBuilder = new ComponentBuilder(), this.magneticLines = new MagneticLines(), this.componentOrganizer = new BookComponentOrganizer(), this.componentGrouper = new ComponentGrouper(), this.actionController = new ActionController(), this.contextMenu = new TeamTemplateContextMenu(), this.modulePlaceHolder = new ModulePlaceholder(), this.componentTree = new DynamicComponentTree(), this.cursorView = new CursorView(Un.editorContainer);
    const Kn = this.layerRegistry.getTree();
    this.componentOrganizer.addPostSyncListener(this.bookOrganizer.sync), this.componentOrganizer.addPostSyncListener(this.layerVisualizer.sync), this.componentOrganizer.addPostSyncListener(this.pageTextOverflowObserver.sync), this.componentOrganizer.addPostSyncListener(this.componentTree.syncUniterComponentsSize), this.canvasSpatialGridVisualizer.addPostUpdateVisibilityListener(this.canvasRender.render), this.uiSpatialGridVisualizer.addPostUpdateVisibilityListener(this.uiRender.render), this.wheelObserver.subscribe(this.areaWheelObserver.onMouseWheel), this.areaWheelObserver.subscribeGlobalWheel(this.camera.move), this.touchObserver.subscribe(this.camera.move), this.camera.addPostUpdateViewListeners(this.canvasRender.renderUnstructured), this.selectionArea.addPostUpdateAreaListener(this.canvasRender.renderUnstructured), this.componentCloner = new ComponentCloner(), this.actionStore.addPostUndoRedoListener(this.canvasAreaController.sync), this.actionStore.addPostUndoRedoListener(this.canvasRender.render), this.actionStore.addPostUndoRedoListener(this.actionVisualizer.sync), this.actionRepository.addPostMoveTimeLineCursorListener(this.actionVisualizer.sync), this.actionController.addPostStopActionListener(this.actionVisualizer.sync), this.actionController.addPostStartActionListener(this.actionVisualizer.sync), this.keyboardObserver = new TeamTemplateKeyboardObserver(), this.keyboardVisualizer = new KeyboardVisualizer(this.keyboardObserver), this.addEnableInteractiveListener(this.keyboardObserver.construct), this.addDisableInteractiveListener(this.keyboardObserver.destruct), this.keyboardVisualizer.addPostSyncListener(this.uiRender.render), this.keyboardObserver.addPostChangeActiveKeysListener(this.keyboardVisualizer.sync), this.carriageCoordinator.addPostChangeCarriageRangeListener(this.textSelectionVisualizer.sync), this.pageStructureObserver.subscribe(
      () => this.savePreview(Un.imageFileSourcePrefix, Un.onUpdateTemplatePreview)
    ), this.ui.connectDependencies({
      render: this.uiRender,
      useCases: this.useCases,
      textEngine: this.textEngine,
      onBackPage: Un.onBackPage,
      actionStore: this.actionStore,
      actionController: this.actionController,
      contextMenu: this.contextMenu,
      componentTree: this.componentTree,
      onSendOffer: Un.onSendOffer,
      onDownloadPDF: Un.onDownloadPDF,
      onOpenModulesModal: Un.onOpenModulesWindow,
      onOpenCreateCustomTableWindow: Un.onOpenCreateCustomTableWindow,
      onGoToTariff: Un.onGoToTariff,
      onGetGenerationHintStructure: Un.onGetGenerationHintStructure,
      onSetNameTemplate: this.setName,
      onOpenAIActionsModal: Un.onOpenAIActionsModal,
      onCloseAIActionsModal: Un.onCloseAIActionsModal
    }), this.magneticLines.connectDependencies({
      componentTree: this.componentTree
    }), this.actionVisualizer.connectDependencies({
      render: this.uiRender,
      actionRepository: this.actionRepository,
      actionController: this.actionController
    }), this.cursor.connectDependencies({
      ui: this.ui,
      editor: this,
      useCases: this.useCases,
      render: this.canvasRender,
      cursorView: this.cursorView,
      textEngine: this.textEngine,
      contextMenu: this.contextMenu,
      componentTree: this.componentTree,
      selectionArea: this.selectionArea,
      magneticLines: this.magneticLines,
      areaController: this.areaController,
      editModeContext: this.editModeContext,
      editorContainer: this.editorContainer,
      uiMouseObserver: this.uiMouseObserver,
      actionController: this.actionController,
      keyboardObserver: this.keyboardObserver,
      componentInjector: this.componentInjector,
      componentOrganizer: this.componentOrganizer,
      carriageCoordinator: this.carriageCoordinator,
      canvasMouseObserver: this.canvasMouseObserver,
      textSelectionObserver: this.textSelectionObserver,
      pageStructureObserver: this.pageStructureObserver,
      pageTextOverflowObserver: this.pageTextOverflowObserver
    }), this.pageTextOverflowObserver.connectDependencies({
      componentTree: this.componentTree
    }), this.carriageCoordinator.connectDependencies({
      render: this.canvasRender
    }), this.textEngine.connectDependencies({
      keyboardObserver: this.keyboardObserver,
      actionController: this.actionController,
      renders: [this.canvasRender, this.uiRender],
      textActionInitiator: this.textActionInitiator,
      textEventGenerator: this.textEventGenerator,
      carriageCoordinator: this.carriageCoordinator
    }), this.pageStructureObserver.connectDependencies({
      componentTree: this.componentTree
    }), this.selectionArea.connectDependencies({
      areaController: this.canvasAreaController,
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.contextMenu.connectDependencies({
      render: this.uiRender,
      useCases: this.useCases,
      areaController: this.areaController,
      uiMouseObserver: this.uiMouseObserver,
      ui: this.ui
    }), this.layerVisualizer.connectDependencies({
      tree: Kn,
      render: this.uiRender,
      canvas: this.uiCanvas
    }), this.componentFactory.connectDependencies({
      useCases: this.useCases,
      textEngine: this.textEngine,
      componentTree: this.componentTree,
      actionController: this.actionController,
      areaController: this.canvasAreaController,
      pageStructureObserver: this.pageStructureObserver
    }), this.textImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.pictureImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.canvasAreaController.connectDependencies({
      tree: this.canvasSpatialGrid,
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.uiAreaController.connectDependencies({
      ui: this.ui,
      tree: this.uiSpatialGrid,
      uiMouseObserver: this.uiMouseObserver
    }), this.pictureReplacer.connectDependencies({
      pictureImporter: this.pictureImporter,
      sketchStabilizer: this.actionController
    }), this.htmlTableImporter.connectDependencies({
      componentTree: this.componentTree,
      sketchStabilizer: this.actionController,
      componentOrganizer: this.componentOrganizer,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.htmlTableReplacer.connectDependencies({
      htmlTableImporter: this.htmlTableImporter,
      componentOrganizer: this.componentOrganizer,
      sketchStabilizer: this.actionController
    }), this.layerRegistry.connectDependencies({
      componentTree: this.componentTree
    }), this.copyController.connectDependencies({
      textEngine: this.textEngine,
      textImporter: this.textImporter,
      componentCloner: this.componentCloner
    }), this.pasteController.connectDependencies({
      textEngine: this.textEngine,
      textImporter: this.textImporter,
      componentTree: this.componentTree,
      graphicFactory: this.graphicFactory,
      pictureImporter: this.pictureImporter,
      pictureReplacer: this.pictureReplacer,
      componentCloner: this.componentCloner,
      componentFactory: this.componentFactory,
      componentInjector: this.componentInjector,
      mouseObserver: this.canvasMouseObserver,
      htmlTableImporter: this.htmlTableImporter,
      htmlTableReplacer: this.htmlTableReplacer
    }), this.actionController.connectDependencies({
      state: this.state,
      actionStore: this.actionStore,
      sendCommands: Un.sendCommands,
      componentTree: this.componentTree,
      areaController: this.canvasAreaController,
      getConstructorConnectionStatus: Un.getServerConnectionStatus
    }), this.injectorFactory.connectDependencies({
      render: this.canvasRender,
      cursorView: this.cursorView,
      componentTree: this.componentTree,
      componentAlignment: this.componentAlignment,
      canvasMouseObserver: this.canvasMouseObserver,
      modulePlaceHolder: this.modulePlaceHolder
    }), this.componentOrganizer.connectDependencies({
      componentTree: this.componentTree,
      bookOrganizer: this.bookOrganizer
    }), this.componentTree.connectDependencies({
      render: this.canvasRender,
      layerRegistry: this.layerRegistry,
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory
    }), this.keyboardObserver.connectDependencies({
      useCases: this.useCases,
      componentTree: this.componentTree,
      textEventGenerator: this.textEventGenerator
    }), this.moduleBuilder.connectDependencies({
      componentTree: this.componentTree,
      graphicFactory: this.graphicFactory,
      componentBuilder: this.componentBuilder,
      componentFactory: this.componentFactory
    }), this.useCases.connectDependencies({
      ui: this.ui,
      textEngine: this.textEngine,
      actionStore: this.actionStore,
      canvasRender: this.canvasRender,
      componentTree: this.componentTree,
      bookOrganizer: this.bookOrganizer,
      moduleBuilder: this.moduleBuilder,
      componentCloner: this.componentCloner,
      uploadImageFile: Un.uploadImageFile,
      componentGrouper: this.componentGrouper,
      tableGridMutator: this.tableGridMutator,
      copyController: this.copyController,
      pasteController: this.pasteController,
      actionController: this.actionController,
      onUploadXlsxFile: Un.uploadXlsxFile,
      componentInjector: this.componentInjector,
      areaController: this.canvasAreaController,
      componentOrganizer: this.componentOrganizer,
      componentAlignment: this.componentAlignment,
      canvasMouseObserver: this.canvasMouseObserver,
      carriageCoordinator: this.carriageCoordinator,
      textActionInitiator: this.textActionInitiator,
      imageFileSourcePrefix: Un.imageFileSourcePrefix,
      onOpenCreateModuleWindow: Un.openCreateModuleWindow
    }), this.canvasSpatialGridVisualizer.connectDependencies({
      spatialGrid: this.canvasSpatialGrid
    }), this.uiSpatialGridVisualizer.connectDependencies({
      spatialGrid: this.uiSpatialGrid
    }), this.objectOrganizer.connectDependencies({
      ui: this.ui,
      layerRegistry: this.layerRegistry,
      magneticLines: this.magneticLines,
      componentInjector: this.componentInjector,
      componentSelectionArea: this.selectionArea,
      quadTreeVisualizer: this.canvasSpatialGridVisualizer,
      textSelectionVisualizer: this.textSelectionVisualizer
    }), this.uiObjectOrganizer.connectDependencies({
      ui: this.ui,
      layerVisualizer: this.layerVisualizer,
      actionVisualizer: this.actionVisualizer,
      keyboardVisualizer: this.keyboardVisualizer,
      quadTreeVisualizer: this.uiSpatialGridVisualizer
    }), this.modulePlaceHolder.connectDependencies({
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.componentInjector.connectDependencies({
      injectorFactory: this.injectorFactory
    }), this.state.connectDependencies({
      editor: this,
      componentTree: this.componentTree
    }), this.actionStore.connectDependencies({
      repository: this.actionRepository,
      actionController: this.actionController
    }), this.componentGrouper.connectDependencies({
      componentTree: this.componentTree,
      componentBuilder: this.componentBuilder
    }), this.graphicFactory.connectDependencies({
      ui: this.ui,
      camera: this.camera,
      useCases: this.useCases,
      render: this.canvasRender,
      componentTree: this.componentTree,
      layerRegistry: this.layerRegistry,
      areaController: this.canvasAreaController,
      imageFileSourcePrefix: Un.imageFileSourcePrefix
    }), this.textActionInitiator.connectDependencies({
      actionController: this.actionController
    }), this.componentBuilder.connectDependencies({
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory
    }), this.canvasRender.connectDependencies({
      canvas: this.canvas,
      layerRegistry: this.layerRegistry,
      canvasObjectOrganizer: this.objectOrganizer
    }), this.uiRender.connectDependencies({
      ui: this.ui,
      canvas: this.uiCanvas,
      uiObjectOrganizer: this.uiObjectOrganizer
    }), this.camera.connectDependencies({
      componentTree: this.componentTree
    }), this.areaWheelObserver.connectDependencies({
      areaController: this.areaController
    }), this.ui.injectDependencies(), this.camera.injectDependencies(), this.componentTree.injectDependencies(), this.state.injectDependencies(), this.actionStore.injectDependencies(), this.canvasAreaController.injectDependencies(), this.uiAreaController.injectDependencies(), this.objectOrganizer.injectDependencies(), this.layerRegistry.injectDependencies(), this.textImporter.injectDependencies(), this.uiObjectOrganizer.injectDependencies(), this.cursor.injectDependencies(), this.pictureImporter.injectDependencies(), this.injectorFactory.injectDependencies(), this.keyboardObserver.injectDependencies(), this.componentGrouper.injectDependencies(), this.componentInjector.injectDependencies(), this.canvasSpatialGridVisualizer.injectDependencies(), this.uiSpatialGridVisualizer.injectDependencies(), this.graphicFactory.injectDependencies(), this.pageStructureObserver.injectDependencies(), this.pasteController.injectDependencies(), this.canvasRender.injectDependencies(), this.layerVisualizer.injectDependencies(), this.actionController.injectDependencies(), this.pageTextOverflowObserver.injectDependencies(), this.useCases.injectDependencies(), this.textActionInitiator.injectDependencies(), this.htmlTableImporter.injectDependencies(), this.carriageCoordinator.injectDependencies(), this.htmlTableReplacer.injectDependencies(), this.selectionArea.injectDependencies(), this.textEngine.injectDependencies(), this.contextMenu.injectDependencies(), this.uiRender.injectDependencies(), this.moduleBuilder.injectDependencies(), this.modulePlaceHolder.injectDependencies(), this.componentOrganizer.injectDependencies(), this.areaWheelObserver.injectDependencies(), this.ui.setActiveTariff(Un.isEnableTopBarTariffLabel), this.componentInjector.addPostUpdateAreaListener(this.canvasRender.render), this.addPostResizeWindowListener(this.layerVisualizer.sync), this.addPostResizeWindowListener(this.adaptCanvas), this.addPostResizeWindowListener(this.adaptUICanvas), this.addPostResizeWindowListener(this.ui.sync), this.addPostResizeWindowListener(this.ui.sync), this.addPostResizeWindowListener(this.canvasSpatialGridVisualizer.sync), this.addPostResizeWindowListener(this.areaController.updateAreaPosition), this.addPostResizeWindowListener(this.uiSpatialGridVisualizer.sync), this.addDestructListener(this.wheelObserver.destruct), this.addDestructListener(this.touchObserver.destruct), this.addDestructListener(this.cursor.destruct), this.addDestructListener(this.keyboardObserver.destruct), this.debugEntities.push(this.keyboardVisualizer, this.actionVisualizer), Un.enableDebugMenu && this.enableGUI();
  }
}
class AIBasedTemplateBuilder extends VisualizerEditor {
  constructor(Un) {
    const Kn = document.createElement("div");
    Kn.style.position = "absolute", Kn.style.top = `-${Number.MAX_SAFE_INTEGER}px`, Kn.style.left = `-${Number.MAX_SAFE_INTEGER}px`, document.body.append(Kn);
    super({
      imageFileSourcePrefix: Un.imageFileSourcePrefix,
      editorContainer: Kn,
      isCanvasHeightAdaptive: !0,
      isEnableMouseWheel: !1
    });
    Ca(this, "useCases");
    Ca(this, "cursorView");
    Ca(this, "layerRegistry");
    Ca(this, "componentTree");
    Ca(this, "modulePlaceholder");
    Ca(this, "moduleInjector");
    Ca(this, "setModules", async (Un) => {
      const Kn = this.componentTree.getRootComponent(), qn = Kn.getFirstGraphic();
      if (qn === null)
        throw new EditorError("first page not found");
      const Jo = qn.getA4LongSide();
      let pa = 0, ma = 0, va = Jo;
      await this.componentTree.executeMutations(async (ba) => {
        for (let _a = 0; _a < Un.length; _a++) {
          const ya = Un[_a];
          if (ya.graphics === null || ya.graphics.length !== 1)
            throw new EditorError("invalid module graphic count");
          if (ya.graphics[0].frame === null)
            throw new EditorError("module frame not found");
          const { height: xa } = ya.graphics[0].frame;
          if (xa > va) {
            if (xa > Jo)
              throw new EditorError("module height highest page");
            await ba.mutator.mutateByExtendComponentToEnd(Kn), va = Jo, ma = 0, pa++;
          }
          await this.moduleInjector.injectToPoint(ba, ya, pa, ma), ma += xa;
        }
      });
    });
    this.useCases = null, this.moduleInjector = new ModuleInjector(), this.layerRegistry = new BookLayerRegistry(), this.componentTree = new DynamicComponentTree(), this.cursorView = new CursorView(Kn), this.modulePlaceholder = new ModulePlaceholder(), this.graphicFactory.connectDependencies({
      componentTree: this.componentTree,
      imageFileSourcePrefix: Un.imageFileSourcePrefix
    }), this.layerRegistry.connectDependencies({
      componentTree: this.componentTree
    }), this.moduleInjector.connectDependencies({
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver,
      cursorView: this.cursorView,
      modulePlaceHolder: this.modulePlaceholder
    }), this.modulePlaceholder.connectDependencies({
      componentTree: this.componentTree,
      canvasMouseObserver: this.canvasMouseObserver
    }), this.componentTree.connectDependencies({
      render: this.canvasRender,
      layerRegistry: this.layerRegistry,
      graphicFactory: this.graphicFactory,
      componentFactory: this.componentFactory
    }), this.graphicFactory.injectDependencies(), this.layerRegistry.injectDependencies(), this.moduleInjector.injectDependencies(), this.modulePlaceholder.injectDependencies(), this.componentTree.injectDependencies();
  }
}
const FONT_LOAD_TIMEOUT_MS = 1e4, hasFontLoaded = (Xn) => {
  const zn = "abcdefABCDEF123456", Kn = document.createElement("canvas").getContext("2d");
  if (Kn === null)
    throw new Error();
  Kn.font = '40px "non-existent-fallback-font"';
  const qn = Kn.measureText(zn).width;
  Kn.font = `40px "${Xn}", "non-existent-fallback-font"`;
  const Jo = Kn.measureText(zn).width;
  return qn !== Jo;
}, waitForFontsApplied = async () => {
  const Xn = Object.values(FontFamily).map((Un) => [Un, Un]), zn = Date.now();
  return new Promise((Un, Kn) => {
    const qn = () => {
      const Jo = Xn.filter(([va]) => hasFontLoaded(va)).map(([va]) => va), pa = Xn.filter(([va]) => !hasFontLoaded(va)).map(([va]) => va);
      if (console.log(`Font check: loaded = [${Jo.join(", ")}], pending = [${pa.join(", ")}]`), Xn.every(([va]) => hasFontLoaded(va)))
        Un();
      else if (Date.now() - zn > FONT_LOAD_TIMEOUT_MS) {
        const va = Xn.filter(([ba]) => !hasFontLoaded(ba)).map(([ba]) => ba);
        console.warn(`Timeout waiting for fonts: ${va.join(", ")}`), Kn(new Error(`Fonts "${va.join(", ")}" did not apply within timeout.`));
      } else
        requestAnimationFrame(qn);
    };
    qn();
  });
};
export {
  AIBasedTemplateBuilder,
  AdaptVisualizerEditor,
  CommandType,
  ContentConverterEditor,
  EditorComponentType,
  FontFamily,
  FontSize,
  GraphicType,
  OfferSettingsEditor,
  OrganizerModuleEditor,
  Orientation,
  PrivateTemplateEditor,
  SVGCanvasStore,
  TeamTemplateEditor,
  TextAlign,
  TokenType,
  VisualizerEditor,
  WorkshopModuleEditor,
  WorkshopTemplateEditor,
  waitForFontsApplied
};
